
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3fab"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3fab"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4x3bm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ifLAN"));

});
parcelRegister("ifLAN", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d49e8b922d581d6f$export$ffb0004e005737fa; }, function (v) { return $d49e8b922d581d6f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d49e8b922d581d6f$export$34b9dba7ce09269b; }, function (v) { return $d49e8b922d581d6f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d49e8b922d581d6f$export$25062201e9e25d76; }, function (v) { return $d49e8b922d581d6f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d49e8b922d581d6f$export$ffb0004e005737fa;
var $d49e8b922d581d6f$export$34b9dba7ce09269b;
var $d49e8b922d581d6f$export$25062201e9e25d76;
"use strict";

var $70fFQ = parcelRequire("70fFQ");
var $d49e8b922d581d6f$var$k = Symbol.for("react.element"), $d49e8b922d581d6f$var$l = Symbol.for("react.fragment"), $d49e8b922d581d6f$var$m = Object.prototype.hasOwnProperty, $d49e8b922d581d6f$var$n = $70fFQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d49e8b922d581d6f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d49e8b922d581d6f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d49e8b922d581d6f$var$m.call(a, b) && !$d49e8b922d581d6f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d49e8b922d581d6f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d49e8b922d581d6f$var$n.current
    };
}
$d49e8b922d581d6f$export$ffb0004e005737fa = $d49e8b922d581d6f$var$l;
$d49e8b922d581d6f$export$34b9dba7ce09269b = $d49e8b922d581d6f$var$q;
$d49e8b922d581d6f$export$25062201e9e25d76 = $d49e8b922d581d6f$var$q;

});
parcelRegister("70fFQ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hjxY2"));

});
parcelRegister("hjxY2", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c9ae8f3ccfa82d2b$export$dca3b0875bd9a954; }, function (v) { return $c9ae8f3ccfa82d2b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c9ae8f3ccfa82d2b$export$16fa2f45be04daa8; }, function (v) { return $c9ae8f3ccfa82d2b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c9ae8f3ccfa82d2b$export$ffb0004e005737fa; }, function (v) { return $c9ae8f3ccfa82d2b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c9ae8f3ccfa82d2b$export$e2c29f18771995cb; }, function (v) { return $c9ae8f3ccfa82d2b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd; }, function (v) { return $c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c9ae8f3ccfa82d2b$export$5f8d39834fd61797; }, function (v) { return $c9ae8f3ccfa82d2b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5; }, function (v) { return $c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c9ae8f3ccfa82d2b$export$ae55be85d98224ed; }, function (v) { return $c9ae8f3ccfa82d2b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c9ae8f3ccfa82d2b$export$e530037191fcd5d7; }, function (v) { return $c9ae8f3ccfa82d2b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109; }, function (v) { return $c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d; }, function (v) { return $c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9; }, function (v) { return $c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43; }, function (v) { return $c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c9ae8f3ccfa82d2b$export$257a8862b851cb5b; }, function (v) { return $c9ae8f3ccfa82d2b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c9ae8f3ccfa82d2b$export$a8257692ac88316c; }, function (v) { return $c9ae8f3ccfa82d2b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c9ae8f3ccfa82d2b$export$488013bae63b21da; }, function (v) { return $c9ae8f3ccfa82d2b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c9ae8f3ccfa82d2b$export$7c73462e0d25e514; }, function (v) { return $c9ae8f3ccfa82d2b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c9ae8f3ccfa82d2b$export$7568632d0d33d16d; }, function (v) { return $c9ae8f3ccfa82d2b$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c9ae8f3ccfa82d2b$export$88948ce120ea2619; }, function (v) { return $c9ae8f3ccfa82d2b$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c9ae8f3ccfa82d2b$export$35808ee640e87ca7; }, function (v) { return $c9ae8f3ccfa82d2b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c9ae8f3ccfa82d2b$export$fae74005e78b1a27; }, function (v) { return $c9ae8f3ccfa82d2b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e; }, function (v) { return $c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c9ae8f3ccfa82d2b$export$6a7bc4e911dc01cf; }, function (v) { return $c9ae8f3ccfa82d2b$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c9ae8f3ccfa82d2b$export$6d9c69b0de29b591; }, function (v) { return $c9ae8f3ccfa82d2b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c9ae8f3ccfa82d2b$export$f680877a34711e37; }, function (v) { return $c9ae8f3ccfa82d2b$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c9ae8f3ccfa82d2b$export$d5a552a76deda3c2; }, function (v) { return $c9ae8f3ccfa82d2b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c9ae8f3ccfa82d2b$export$aaabe4eda9ed9969; }, function (v) { return $c9ae8f3ccfa82d2b$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c; }, function (v) { return $c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c9ae8f3ccfa82d2b$export$1538c33de8887b59; }, function (v) { return $c9ae8f3ccfa82d2b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c9ae8f3ccfa82d2b$export$13e3392192263954; }, function (v) { return $c9ae8f3ccfa82d2b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca; }, function (v) { return $c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c9ae8f3ccfa82d2b$export$60241385465d0a34; }, function (v) { return $c9ae8f3ccfa82d2b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c9ae8f3ccfa82d2b$export$306c0aa65ff9ec16; }, function (v) { return $c9ae8f3ccfa82d2b$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c9ae8f3ccfa82d2b$export$7b286972b8d8ccbf; }, function (v) { return $c9ae8f3ccfa82d2b$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c9ae8f3ccfa82d2b$export$83d89fbfd8236492; }, function (v) { return $c9ae8f3ccfa82d2b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9ae8f3ccfa82d2b$export$dca3b0875bd9a954;
var $c9ae8f3ccfa82d2b$export$16fa2f45be04daa8;
var $c9ae8f3ccfa82d2b$export$ffb0004e005737fa;
var $c9ae8f3ccfa82d2b$export$e2c29f18771995cb;
var $c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd;
var $c9ae8f3ccfa82d2b$export$5f8d39834fd61797;
var $c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5;
var $c9ae8f3ccfa82d2b$export$ae55be85d98224ed;
var $c9ae8f3ccfa82d2b$export$e530037191fcd5d7;
var $c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109;
var $c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d;
var $c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9;
var $c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43;
var $c9ae8f3ccfa82d2b$export$257a8862b851cb5b;
var $c9ae8f3ccfa82d2b$export$a8257692ac88316c;
var $c9ae8f3ccfa82d2b$export$488013bae63b21da;
var $c9ae8f3ccfa82d2b$export$7c73462e0d25e514;
var $c9ae8f3ccfa82d2b$export$7568632d0d33d16d;
var $c9ae8f3ccfa82d2b$export$88948ce120ea2619;
var $c9ae8f3ccfa82d2b$export$35808ee640e87ca7;
var $c9ae8f3ccfa82d2b$export$fae74005e78b1a27;
var $c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e;
var $c9ae8f3ccfa82d2b$export$6a7bc4e911dc01cf;
var $c9ae8f3ccfa82d2b$export$6d9c69b0de29b591;
var $c9ae8f3ccfa82d2b$export$f680877a34711e37;
var $c9ae8f3ccfa82d2b$export$d5a552a76deda3c2;
var $c9ae8f3ccfa82d2b$export$aaabe4eda9ed9969;
var $c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c;
var $c9ae8f3ccfa82d2b$export$1538c33de8887b59;
var $c9ae8f3ccfa82d2b$export$13e3392192263954;
var $c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca;
var $c9ae8f3ccfa82d2b$export$60241385465d0a34;
var $c9ae8f3ccfa82d2b$export$306c0aa65ff9ec16;
var $c9ae8f3ccfa82d2b$export$7b286972b8d8ccbf;
var $c9ae8f3ccfa82d2b$export$83d89fbfd8236492;
"use strict";
var $c9ae8f3ccfa82d2b$var$l = Symbol.for("react.element"), $c9ae8f3ccfa82d2b$var$n = Symbol.for("react.portal"), $c9ae8f3ccfa82d2b$var$p = Symbol.for("react.fragment"), $c9ae8f3ccfa82d2b$var$q = Symbol.for("react.strict_mode"), $c9ae8f3ccfa82d2b$var$r = Symbol.for("react.profiler"), $c9ae8f3ccfa82d2b$var$t = Symbol.for("react.provider"), $c9ae8f3ccfa82d2b$var$u = Symbol.for("react.context"), $c9ae8f3ccfa82d2b$var$v = Symbol.for("react.forward_ref"), $c9ae8f3ccfa82d2b$var$w = Symbol.for("react.suspense"), $c9ae8f3ccfa82d2b$var$x = Symbol.for("react.memo"), $c9ae8f3ccfa82d2b$var$y = Symbol.for("react.lazy"), $c9ae8f3ccfa82d2b$var$z = Symbol.iterator;
function $c9ae8f3ccfa82d2b$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c9ae8f3ccfa82d2b$var$z && a[$c9ae8f3ccfa82d2b$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c9ae8f3ccfa82d2b$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c9ae8f3ccfa82d2b$var$C = Object.assign, $c9ae8f3ccfa82d2b$var$D = {};
function $c9ae8f3ccfa82d2b$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c9ae8f3ccfa82d2b$var$D;
    this.updater = e || $c9ae8f3ccfa82d2b$var$B;
}
$c9ae8f3ccfa82d2b$var$E.prototype.isReactComponent = {};
$c9ae8f3ccfa82d2b$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c9ae8f3ccfa82d2b$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c9ae8f3ccfa82d2b$var$F() {}
$c9ae8f3ccfa82d2b$var$F.prototype = $c9ae8f3ccfa82d2b$var$E.prototype;
function $c9ae8f3ccfa82d2b$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c9ae8f3ccfa82d2b$var$D;
    this.updater = e || $c9ae8f3ccfa82d2b$var$B;
}
var $c9ae8f3ccfa82d2b$var$H = $c9ae8f3ccfa82d2b$var$G.prototype = new $c9ae8f3ccfa82d2b$var$F;
$c9ae8f3ccfa82d2b$var$H.constructor = $c9ae8f3ccfa82d2b$var$G;
$c9ae8f3ccfa82d2b$var$C($c9ae8f3ccfa82d2b$var$H, $c9ae8f3ccfa82d2b$var$E.prototype);
$c9ae8f3ccfa82d2b$var$H.isPureReactComponent = !0;
var $c9ae8f3ccfa82d2b$var$I = Array.isArray, $c9ae8f3ccfa82d2b$var$J = Object.prototype.hasOwnProperty, $c9ae8f3ccfa82d2b$var$K = {
    current: null
}, $c9ae8f3ccfa82d2b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c9ae8f3ccfa82d2b$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c9ae8f3ccfa82d2b$var$J.call(b, d) && !$c9ae8f3ccfa82d2b$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c9ae8f3ccfa82d2b$var$K.current
    };
}
function $c9ae8f3ccfa82d2b$var$N(a, b) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c9ae8f3ccfa82d2b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c9ae8f3ccfa82d2b$var$l;
}
function $c9ae8f3ccfa82d2b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c9ae8f3ccfa82d2b$var$P = /\/+/g;
function $c9ae8f3ccfa82d2b$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c9ae8f3ccfa82d2b$var$escape("" + a.key) : b.toString(36);
}
function $c9ae8f3ccfa82d2b$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c9ae8f3ccfa82d2b$var$l:
                case $c9ae8f3ccfa82d2b$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c9ae8f3ccfa82d2b$var$Q(h, 0) : d, $c9ae8f3ccfa82d2b$var$I(c) ? (e = "", null != a && (e = a.replace($c9ae8f3ccfa82d2b$var$P, "$&/") + "/"), $c9ae8f3ccfa82d2b$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c9ae8f3ccfa82d2b$var$O(c) && (c = $c9ae8f3ccfa82d2b$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c9ae8f3ccfa82d2b$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c9ae8f3ccfa82d2b$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c9ae8f3ccfa82d2b$var$Q(k, g);
        h += $c9ae8f3ccfa82d2b$var$R(k, b, e, f, c);
    }
    else if (f = $c9ae8f3ccfa82d2b$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c9ae8f3ccfa82d2b$var$Q(k, g++), h += $c9ae8f3ccfa82d2b$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c9ae8f3ccfa82d2b$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c9ae8f3ccfa82d2b$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c9ae8f3ccfa82d2b$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c9ae8f3ccfa82d2b$var$U = {
    current: null
}, $c9ae8f3ccfa82d2b$var$V = {
    transition: null
}, $c9ae8f3ccfa82d2b$var$W = {
    ReactCurrentDispatcher: $c9ae8f3ccfa82d2b$var$U,
    ReactCurrentBatchConfig: $c9ae8f3ccfa82d2b$var$V,
    ReactCurrentOwner: $c9ae8f3ccfa82d2b$var$K
};
$c9ae8f3ccfa82d2b$export$dca3b0875bd9a954 = {
    map: $c9ae8f3ccfa82d2b$var$S,
    forEach: function(a, b, e) {
        $c9ae8f3ccfa82d2b$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c9ae8f3ccfa82d2b$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c9ae8f3ccfa82d2b$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c9ae8f3ccfa82d2b$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c9ae8f3ccfa82d2b$export$16fa2f45be04daa8 = $c9ae8f3ccfa82d2b$var$E;
$c9ae8f3ccfa82d2b$export$ffb0004e005737fa = $c9ae8f3ccfa82d2b$var$p;
$c9ae8f3ccfa82d2b$export$e2c29f18771995cb = $c9ae8f3ccfa82d2b$var$r;
$c9ae8f3ccfa82d2b$export$221d75b3f55bb0bd = $c9ae8f3ccfa82d2b$var$G;
$c9ae8f3ccfa82d2b$export$5f8d39834fd61797 = $c9ae8f3ccfa82d2b$var$q;
$c9ae8f3ccfa82d2b$export$74bf444e3cd11ea5 = $c9ae8f3ccfa82d2b$var$w;
$c9ae8f3ccfa82d2b$export$ae55be85d98224ed = $c9ae8f3ccfa82d2b$var$W;
$c9ae8f3ccfa82d2b$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c9ae8f3ccfa82d2b$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c9ae8f3ccfa82d2b$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c9ae8f3ccfa82d2b$var$J.call(b, f) && !$c9ae8f3ccfa82d2b$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c9ae8f3ccfa82d2b$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c9ae8f3ccfa82d2b$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c9ae8f3ccfa82d2b$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c9ae8f3ccfa82d2b$export$c8a8987d4410bf2d = $c9ae8f3ccfa82d2b$var$M;
$c9ae8f3ccfa82d2b$export$d38cd72104c1f0e9 = function(a) {
    var b = $c9ae8f3ccfa82d2b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c9ae8f3ccfa82d2b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c9ae8f3ccfa82d2b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$v,
        render: a
    };
};
$c9ae8f3ccfa82d2b$export$a8257692ac88316c = $c9ae8f3ccfa82d2b$var$O;
$c9ae8f3ccfa82d2b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c9ae8f3ccfa82d2b$var$T
    };
};
$c9ae8f3ccfa82d2b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c9ae8f3ccfa82d2b$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c9ae8f3ccfa82d2b$export$7568632d0d33d16d = function(a) {
    var b = $c9ae8f3ccfa82d2b$var$V.transition;
    $c9ae8f3ccfa82d2b$var$V.transition = {};
    try {
        a();
    } finally{
        $c9ae8f3ccfa82d2b$var$V.transition = b;
    }
};
$c9ae8f3ccfa82d2b$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c9ae8f3ccfa82d2b$export$35808ee640e87ca7 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$U.current.useCallback(a, b);
};
$c9ae8f3ccfa82d2b$export$fae74005e78b1a27 = function(a) {
    return $c9ae8f3ccfa82d2b$var$U.current.useContext(a);
};
$c9ae8f3ccfa82d2b$export$dc8fbce3eb94dc1e = function() {};
$c9ae8f3ccfa82d2b$export$6a7bc4e911dc01cf = function(a) {
    return $c9ae8f3ccfa82d2b$var$U.current.useDeferredValue(a);
};
$c9ae8f3ccfa82d2b$export$6d9c69b0de29b591 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$U.current.useEffect(a, b);
};
$c9ae8f3ccfa82d2b$export$f680877a34711e37 = function() {
    return $c9ae8f3ccfa82d2b$var$U.current.useId();
};
$c9ae8f3ccfa82d2b$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c9ae8f3ccfa82d2b$var$U.current.useImperativeHandle(a, b, e);
};
$c9ae8f3ccfa82d2b$export$aaabe4eda9ed9969 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$U.current.useInsertionEffect(a, b);
};
$c9ae8f3ccfa82d2b$export$e5c5a5f917a5871c = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$U.current.useLayoutEffect(a, b);
};
$c9ae8f3ccfa82d2b$export$1538c33de8887b59 = function(a, b) {
    return $c9ae8f3ccfa82d2b$var$U.current.useMemo(a, b);
};
$c9ae8f3ccfa82d2b$export$13e3392192263954 = function(a, b, e) {
    return $c9ae8f3ccfa82d2b$var$U.current.useReducer(a, b, e);
};
$c9ae8f3ccfa82d2b$export$b8f5890fc79d6aca = function(a) {
    return $c9ae8f3ccfa82d2b$var$U.current.useRef(a);
};
$c9ae8f3ccfa82d2b$export$60241385465d0a34 = function(a) {
    return $c9ae8f3ccfa82d2b$var$U.current.useState(a);
};
$c9ae8f3ccfa82d2b$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c9ae8f3ccfa82d2b$var$U.current.useSyncExternalStore(a, b, e);
};
$c9ae8f3ccfa82d2b$export$7b286972b8d8ccbf = function() {
    return $c9ae8f3ccfa82d2b$var$U.current.useTransition();
};
$c9ae8f3ccfa82d2b$export$83d89fbfd8236492 = "18.1.0";

});




parcelRegister("3glZ1", function(module, exports) {
"use strict";
function $2603eb25b0423f2c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2603eb25b0423f2c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2603eb25b0423f2c$var$checkDCE();

module.exports = (parcelRequire("ldfzr"));

});
parcelRegister("ldfzr", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f716e3e58d6e8629$export$ae55be85d98224ed; }, function (v) { return $f716e3e58d6e8629$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $f716e3e58d6e8629$export$d39a5bbd09211389; }, function (v) { return $f716e3e58d6e8629$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $f716e3e58d6e8629$export$882461b6382ed46c; }, function (v) { return $f716e3e58d6e8629$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $f716e3e58d6e8629$export$466bfc07425424d5; }, function (v) { return $f716e3e58d6e8629$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $f716e3e58d6e8629$export$cd75ccfd720a3cd4; }, function (v) { return $f716e3e58d6e8629$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $f716e3e58d6e8629$export$fa8d919ba61d84db; }, function (v) { return $f716e3e58d6e8629$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $f716e3e58d6e8629$export$757ceba2d55c277e; }, function (v) { return $f716e3e58d6e8629$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $f716e3e58d6e8629$export$b3890eb0ae9dca99; }, function (v) { return $f716e3e58d6e8629$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $f716e3e58d6e8629$export$502457920280e6be; }, function (v) { return $f716e3e58d6e8629$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $f716e3e58d6e8629$export$c78a37762a8d58e1; }, function (v) { return $f716e3e58d6e8629$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $f716e3e58d6e8629$export$dc54d992c10e8a18; }, function (v) { return $f716e3e58d6e8629$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $f716e3e58d6e8629$export$83d89fbfd8236492; }, function (v) { return $f716e3e58d6e8629$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f716e3e58d6e8629$export$ae55be85d98224ed;
var $f716e3e58d6e8629$export$d39a5bbd09211389;
var $f716e3e58d6e8629$export$882461b6382ed46c;
var $f716e3e58d6e8629$export$466bfc07425424d5;
var $f716e3e58d6e8629$export$cd75ccfd720a3cd4;
var $f716e3e58d6e8629$export$fa8d919ba61d84db;
var $f716e3e58d6e8629$export$757ceba2d55c277e;
var $f716e3e58d6e8629$export$b3890eb0ae9dca99;
var $f716e3e58d6e8629$export$502457920280e6be;
var $f716e3e58d6e8629$export$c78a37762a8d58e1;
var $f716e3e58d6e8629$export$dc54d992c10e8a18;
var $f716e3e58d6e8629$export$83d89fbfd8236492;
"use strict";

var $70fFQ = parcelRequire("70fFQ");

var $c2cCr = parcelRequire("c2cCr");
function $f716e3e58d6e8629$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f716e3e58d6e8629$var$da = new Set, $f716e3e58d6e8629$var$ea = {};
function $f716e3e58d6e8629$var$fa(a, b) {
    $f716e3e58d6e8629$var$ha(a, b);
    $f716e3e58d6e8629$var$ha(a + "Capture", b);
}
function $f716e3e58d6e8629$var$ha(a, b) {
    $f716e3e58d6e8629$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f716e3e58d6e8629$var$da.add(b[a]);
}
var $f716e3e58d6e8629$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f716e3e58d6e8629$var$ja = Object.prototype.hasOwnProperty, $f716e3e58d6e8629$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f716e3e58d6e8629$var$la = {}, $f716e3e58d6e8629$var$ma = {};
function $f716e3e58d6e8629$var$na(a) {
    if ($f716e3e58d6e8629$var$ja.call($f716e3e58d6e8629$var$ma, a)) return !0;
    if ($f716e3e58d6e8629$var$ja.call($f716e3e58d6e8629$var$la, a)) return !1;
    if ($f716e3e58d6e8629$var$ka.test(a)) return $f716e3e58d6e8629$var$ma[a] = !0;
    $f716e3e58d6e8629$var$la[a] = !0;
    return !1;
}
function $f716e3e58d6e8629$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f716e3e58d6e8629$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f716e3e58d6e8629$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f716e3e58d6e8629$var$t(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f716e3e58d6e8629$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f716e3e58d6e8629$var$z[b] = new $f716e3e58d6e8629$var$t(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f716e3e58d6e8629$var$qa = /[\-:]([a-z])/g;
function $f716e3e58d6e8629$var$ra(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f716e3e58d6e8629$var$qa, $f716e3e58d6e8629$var$ra);
    $f716e3e58d6e8629$var$z[b] = new $f716e3e58d6e8629$var$t(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f716e3e58d6e8629$var$qa, $f716e3e58d6e8629$var$ra);
    $f716e3e58d6e8629$var$z[b] = new $f716e3e58d6e8629$var$t(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f716e3e58d6e8629$var$qa, $f716e3e58d6e8629$var$ra);
    $f716e3e58d6e8629$var$z[b] = new $f716e3e58d6e8629$var$t(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f716e3e58d6e8629$var$z.xlinkHref = new $f716e3e58d6e8629$var$t("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f716e3e58d6e8629$var$z[a] = new $f716e3e58d6e8629$var$t(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f716e3e58d6e8629$var$sa(a, b, c, d) {
    var e = $f716e3e58d6e8629$var$z.hasOwnProperty(b) ? $f716e3e58d6e8629$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f716e3e58d6e8629$var$pa(b, c, e, d) && (c = null), d || null === e ? $f716e3e58d6e8629$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f716e3e58d6e8629$var$ta = $70fFQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f716e3e58d6e8629$var$ua = Symbol.for("react.element"), $f716e3e58d6e8629$var$va = Symbol.for("react.portal"), $f716e3e58d6e8629$var$wa = Symbol.for("react.fragment"), $f716e3e58d6e8629$var$xa = Symbol.for("react.strict_mode"), $f716e3e58d6e8629$var$za = Symbol.for("react.profiler"), $f716e3e58d6e8629$var$Aa = Symbol.for("react.provider"), $f716e3e58d6e8629$var$Ba = Symbol.for("react.context"), $f716e3e58d6e8629$var$Ca = Symbol.for("react.forward_ref"), $f716e3e58d6e8629$var$Da = Symbol.for("react.suspense"), $f716e3e58d6e8629$var$Ea = Symbol.for("react.suspense_list"), $f716e3e58d6e8629$var$Fa = Symbol.for("react.memo"), $f716e3e58d6e8629$var$Ga = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f716e3e58d6e8629$var$Ha = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f716e3e58d6e8629$var$Ia = Symbol.iterator;
function $f716e3e58d6e8629$var$Ja(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f716e3e58d6e8629$var$Ia && a[$f716e3e58d6e8629$var$Ia] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f716e3e58d6e8629$var$A = Object.assign, $f716e3e58d6e8629$var$Ka;
function $f716e3e58d6e8629$var$La(a) {
    if (void 0 === $f716e3e58d6e8629$var$Ka) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f716e3e58d6e8629$var$Ka = b && b[1] || "";
    }
    return "\n" + $f716e3e58d6e8629$var$Ka + a;
}
var $f716e3e58d6e8629$var$Ma = !1;
function $f716e3e58d6e8629$var$Na(a, b) {
    if (!a || $f716e3e58d6e8629$var$Ma) return "";
    $f716e3e58d6e8629$var$Ma = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f716e3e58d6e8629$var$Ma = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f716e3e58d6e8629$var$La(a) : "";
}
function $f716e3e58d6e8629$var$Oa(a) {
    switch(a.tag){
        case 5:
            return $f716e3e58d6e8629$var$La(a.type);
        case 16:
            return $f716e3e58d6e8629$var$La("Lazy");
        case 13:
            return $f716e3e58d6e8629$var$La("Suspense");
        case 19:
            return $f716e3e58d6e8629$var$La("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f716e3e58d6e8629$var$Na(a.type, !1), a;
        case 11:
            return a = $f716e3e58d6e8629$var$Na(a.type.render, !1), a;
        case 1:
            return a = $f716e3e58d6e8629$var$Na(a.type, !0), a;
        default:
            return "";
    }
}
function $f716e3e58d6e8629$var$Pa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f716e3e58d6e8629$var$wa:
            return "Fragment";
        case $f716e3e58d6e8629$var$va:
            return "Portal";
        case $f716e3e58d6e8629$var$za:
            return "Profiler";
        case $f716e3e58d6e8629$var$xa:
            return "StrictMode";
        case $f716e3e58d6e8629$var$Da:
            return "Suspense";
        case $f716e3e58d6e8629$var$Ea:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f716e3e58d6e8629$var$Ba:
            return (a.displayName || "Context") + ".Consumer";
        case $f716e3e58d6e8629$var$Aa:
            return (a._context.displayName || "Context") + ".Provider";
        case $f716e3e58d6e8629$var$Ca:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f716e3e58d6e8629$var$Fa:
            return b = a.displayName || null, null !== b ? b : $f716e3e58d6e8629$var$Pa(a.type) || "Memo";
        case $f716e3e58d6e8629$var$Ga:
            b = a._payload;
            a = a._init;
            try {
                return $f716e3e58d6e8629$var$Pa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f716e3e58d6e8629$var$Qa(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f716e3e58d6e8629$var$Pa(b);
        case 8:
            return b === $f716e3e58d6e8629$var$xa ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f716e3e58d6e8629$var$Ra(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f716e3e58d6e8629$var$Sa(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f716e3e58d6e8629$var$Ta(a) {
    var b = $f716e3e58d6e8629$var$Sa(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f716e3e58d6e8629$var$Ua(a) {
    a._valueTracker || (a._valueTracker = $f716e3e58d6e8629$var$Ta(a));
}
function $f716e3e58d6e8629$var$Va(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f716e3e58d6e8629$var$Sa(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f716e3e58d6e8629$var$Wa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f716e3e58d6e8629$var$Xa(a, b) {
    var c = b.checked;
    return $f716e3e58d6e8629$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f716e3e58d6e8629$var$Ya(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f716e3e58d6e8629$var$Ra(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f716e3e58d6e8629$var$Za(a, b) {
    b = b.checked;
    null != b && $f716e3e58d6e8629$var$sa(a, "checked", b, !1);
}
function $f716e3e58d6e8629$var$$a(a, b) {
    $f716e3e58d6e8629$var$Za(a, b);
    var c = $f716e3e58d6e8629$var$Ra(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f716e3e58d6e8629$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f716e3e58d6e8629$var$bb(a, b.type, $f716e3e58d6e8629$var$Ra(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f716e3e58d6e8629$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f716e3e58d6e8629$var$bb(a, b, c) {
    if ("number" !== b || $f716e3e58d6e8629$var$Wa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f716e3e58d6e8629$var$db = Array.isArray;
function $f716e3e58d6e8629$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f716e3e58d6e8629$var$Ra(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f716e3e58d6e8629$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f716e3e58d6e8629$var$p(91));
    return $f716e3e58d6e8629$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f716e3e58d6e8629$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f716e3e58d6e8629$var$p(92));
            if ($f716e3e58d6e8629$var$db(c)) {
                if (1 < c.length) throw Error($f716e3e58d6e8629$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f716e3e58d6e8629$var$Ra(c)
    };
}
function $f716e3e58d6e8629$var$hb(a, b) {
    var c = $f716e3e58d6e8629$var$Ra(b.value), d = $f716e3e58d6e8629$var$Ra(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f716e3e58d6e8629$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f716e3e58d6e8629$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f716e3e58d6e8629$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f716e3e58d6e8629$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f716e3e58d6e8629$var$lb, $f716e3e58d6e8629$var$mb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f716e3e58d6e8629$var$lb = $f716e3e58d6e8629$var$lb || document.createElement("div");
        $f716e3e58d6e8629$var$lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f716e3e58d6e8629$var$lb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f716e3e58d6e8629$var$nb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f716e3e58d6e8629$var$ob = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f716e3e58d6e8629$var$pb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f716e3e58d6e8629$var$ob).forEach(function(a) {
    $f716e3e58d6e8629$var$pb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f716e3e58d6e8629$var$ob[b] = $f716e3e58d6e8629$var$ob[a];
    });
});
function $f716e3e58d6e8629$var$qb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f716e3e58d6e8629$var$ob.hasOwnProperty(a) && $f716e3e58d6e8629$var$ob[a] ? ("" + b).trim() : b + "px";
}
function $f716e3e58d6e8629$var$rb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f716e3e58d6e8629$var$qb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f716e3e58d6e8629$var$sb = $f716e3e58d6e8629$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f716e3e58d6e8629$var$tb(a, b) {
    if (b) {
        if ($f716e3e58d6e8629$var$sb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f716e3e58d6e8629$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f716e3e58d6e8629$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f716e3e58d6e8629$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f716e3e58d6e8629$var$p(62));
    }
}
function $f716e3e58d6e8629$var$ub(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f716e3e58d6e8629$var$vb = null;
function $f716e3e58d6e8629$var$wb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f716e3e58d6e8629$var$xb = null, $f716e3e58d6e8629$var$yb = null, $f716e3e58d6e8629$var$zb = null;
function $f716e3e58d6e8629$var$Ab(a) {
    if (a = $f716e3e58d6e8629$var$Bb(a)) {
        if ("function" !== typeof $f716e3e58d6e8629$var$xb) throw Error($f716e3e58d6e8629$var$p(280));
        var b = a.stateNode;
        b && (b = $f716e3e58d6e8629$var$Cb(b), $f716e3e58d6e8629$var$xb(a.stateNode, a.type, b));
    }
}
function $f716e3e58d6e8629$var$Db(a) {
    $f716e3e58d6e8629$var$yb ? $f716e3e58d6e8629$var$zb ? $f716e3e58d6e8629$var$zb.push(a) : $f716e3e58d6e8629$var$zb = [
        a
    ] : $f716e3e58d6e8629$var$yb = a;
}
function $f716e3e58d6e8629$var$Eb() {
    if ($f716e3e58d6e8629$var$yb) {
        var a = $f716e3e58d6e8629$var$yb, b = $f716e3e58d6e8629$var$zb;
        $f716e3e58d6e8629$var$zb = $f716e3e58d6e8629$var$yb = null;
        $f716e3e58d6e8629$var$Ab(a);
        if (b) for(a = 0; a < b.length; a++)$f716e3e58d6e8629$var$Ab(b[a]);
    }
}
function $f716e3e58d6e8629$var$Fb(a, b) {
    return a(b);
}
function $f716e3e58d6e8629$var$Gb() {}
var $f716e3e58d6e8629$var$Hb = !1;
function $f716e3e58d6e8629$var$Ib(a, b, c) {
    if ($f716e3e58d6e8629$var$Hb) return a(b, c);
    $f716e3e58d6e8629$var$Hb = !0;
    try {
        return $f716e3e58d6e8629$var$Fb(a, b, c);
    } finally{
        if ($f716e3e58d6e8629$var$Hb = !1, null !== $f716e3e58d6e8629$var$yb || null !== $f716e3e58d6e8629$var$zb) $f716e3e58d6e8629$var$Gb(), $f716e3e58d6e8629$var$Eb();
    }
}
function $f716e3e58d6e8629$var$Jb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f716e3e58d6e8629$var$Cb(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f716e3e58d6e8629$var$p(231, b, typeof c));
    return c;
}
var $f716e3e58d6e8629$var$Kb = !1;
if ($f716e3e58d6e8629$var$ia) try {
    var $f716e3e58d6e8629$var$Lb = {};
    Object.defineProperty($f716e3e58d6e8629$var$Lb, "passive", {
        get: function() {
            $f716e3e58d6e8629$var$Kb = !0;
        }
    });
    window.addEventListener("test", $f716e3e58d6e8629$var$Lb, $f716e3e58d6e8629$var$Lb);
    window.removeEventListener("test", $f716e3e58d6e8629$var$Lb, $f716e3e58d6e8629$var$Lb);
} catch (a) {
    $f716e3e58d6e8629$var$Kb = !1;
}
function $f716e3e58d6e8629$var$Mb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $f716e3e58d6e8629$var$Nb = !1, $f716e3e58d6e8629$var$Ob = null, $f716e3e58d6e8629$var$Pb = !1, $f716e3e58d6e8629$var$Qb = null, $f716e3e58d6e8629$var$Rb = {
    onError: function(a) {
        $f716e3e58d6e8629$var$Nb = !0;
        $f716e3e58d6e8629$var$Ob = a;
    }
};
function $f716e3e58d6e8629$var$Sb(a, b, c, d, e, f, g, h, k) {
    $f716e3e58d6e8629$var$Nb = !1;
    $f716e3e58d6e8629$var$Ob = null;
    $f716e3e58d6e8629$var$Mb.apply($f716e3e58d6e8629$var$Rb, arguments);
}
function $f716e3e58d6e8629$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f716e3e58d6e8629$var$Sb.apply(this, arguments);
    if ($f716e3e58d6e8629$var$Nb) {
        if ($f716e3e58d6e8629$var$Nb) {
            var l = $f716e3e58d6e8629$var$Ob;
            $f716e3e58d6e8629$var$Nb = !1;
            $f716e3e58d6e8629$var$Ob = null;
        } else throw Error($f716e3e58d6e8629$var$p(198));
        $f716e3e58d6e8629$var$Pb || ($f716e3e58d6e8629$var$Pb = !0, $f716e3e58d6e8629$var$Qb = l);
    }
}
function $f716e3e58d6e8629$var$Ub(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f716e3e58d6e8629$var$Vb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f716e3e58d6e8629$var$Wb(a) {
    if ($f716e3e58d6e8629$var$Ub(a) !== a) throw Error($f716e3e58d6e8629$var$p(188));
}
function $f716e3e58d6e8629$var$Xb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f716e3e58d6e8629$var$Ub(a);
        if (null === b) throw Error($f716e3e58d6e8629$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f716e3e58d6e8629$var$Wb(e), a;
                if (f === d) return $f716e3e58d6e8629$var$Wb(e), b;
                f = f.sibling;
            }
            throw Error($f716e3e58d6e8629$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f716e3e58d6e8629$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f716e3e58d6e8629$var$p(190));
    }
    if (3 !== c.tag) throw Error($f716e3e58d6e8629$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f716e3e58d6e8629$var$Yb(a) {
    a = $f716e3e58d6e8629$var$Xb(a);
    return null !== a ? $f716e3e58d6e8629$var$Zb(a) : null;
}
function $f716e3e58d6e8629$var$Zb(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f716e3e58d6e8629$var$Zb(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f716e3e58d6e8629$var$$b = $c2cCr.unstable_scheduleCallback, $f716e3e58d6e8629$var$ac = $c2cCr.unstable_cancelCallback, $f716e3e58d6e8629$var$bc = $c2cCr.unstable_shouldYield, $f716e3e58d6e8629$var$cc = $c2cCr.unstable_requestPaint, $f716e3e58d6e8629$var$B = $c2cCr.unstable_now, $f716e3e58d6e8629$var$dc = $c2cCr.unstable_getCurrentPriorityLevel, $f716e3e58d6e8629$var$ec = $c2cCr.unstable_ImmediatePriority, $f716e3e58d6e8629$var$fc = $c2cCr.unstable_UserBlockingPriority, $f716e3e58d6e8629$var$gc = $c2cCr.unstable_NormalPriority, $f716e3e58d6e8629$var$hc = $c2cCr.unstable_LowPriority, $f716e3e58d6e8629$var$ic = $c2cCr.unstable_IdlePriority, $f716e3e58d6e8629$var$jc = null, $f716e3e58d6e8629$var$kc = null;
function $f716e3e58d6e8629$var$lc(a) {
    if ($f716e3e58d6e8629$var$kc && "function" === typeof $f716e3e58d6e8629$var$kc.onCommitFiberRoot) try {
        $f716e3e58d6e8629$var$kc.onCommitFiberRoot($f716e3e58d6e8629$var$jc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f716e3e58d6e8629$var$nc = Math.clz32 ? Math.clz32 : $f716e3e58d6e8629$var$mc, $f716e3e58d6e8629$var$oc = Math.log, $f716e3e58d6e8629$var$pc = Math.LN2;
function $f716e3e58d6e8629$var$mc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f716e3e58d6e8629$var$oc(a) / $f716e3e58d6e8629$var$pc | 0) | 0;
}
var $f716e3e58d6e8629$var$qc = 64, $f716e3e58d6e8629$var$rc = 4194304;
function $f716e3e58d6e8629$var$sc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f716e3e58d6e8629$var$tc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f716e3e58d6e8629$var$sc(h) : (f &= g, 0 !== f && (d = $f716e3e58d6e8629$var$sc(f)));
    } else g = c & ~e, 0 !== g ? d = $f716e3e58d6e8629$var$sc(g) : 0 !== f && (d = $f716e3e58d6e8629$var$sc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f716e3e58d6e8629$var$nc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f716e3e58d6e8629$var$uc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f716e3e58d6e8629$var$vc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f716e3e58d6e8629$var$nc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f716e3e58d6e8629$var$uc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f716e3e58d6e8629$var$wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f716e3e58d6e8629$var$xc() {
    var a = $f716e3e58d6e8629$var$qc;
    $f716e3e58d6e8629$var$qc <<= 1;
    0 === ($f716e3e58d6e8629$var$qc & 4194240) && ($f716e3e58d6e8629$var$qc = 64);
    return a;
}
function $f716e3e58d6e8629$var$yc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f716e3e58d6e8629$var$zc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f716e3e58d6e8629$var$nc(b);
    a[b] = c;
}
function $f716e3e58d6e8629$var$Ac(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f716e3e58d6e8629$var$nc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f716e3e58d6e8629$var$Bc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f716e3e58d6e8629$var$nc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f716e3e58d6e8629$var$C = 0;
function $f716e3e58d6e8629$var$Cc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f716e3e58d6e8629$var$Dc, $f716e3e58d6e8629$var$Ec, $f716e3e58d6e8629$var$Fc, $f716e3e58d6e8629$var$Gc, $f716e3e58d6e8629$var$Hc, $f716e3e58d6e8629$var$Ic = !1, $f716e3e58d6e8629$var$Jc = [], $f716e3e58d6e8629$var$Kc = null, $f716e3e58d6e8629$var$Lc = null, $f716e3e58d6e8629$var$Mc = null, $f716e3e58d6e8629$var$Nc = new Map, $f716e3e58d6e8629$var$Oc = new Map, $f716e3e58d6e8629$var$Pc = [], $f716e3e58d6e8629$var$Qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f716e3e58d6e8629$var$Rc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f716e3e58d6e8629$var$Kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f716e3e58d6e8629$var$Lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f716e3e58d6e8629$var$Mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f716e3e58d6e8629$var$Nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f716e3e58d6e8629$var$Oc.delete(b.pointerId);
    }
}
function $f716e3e58d6e8629$var$Sc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f716e3e58d6e8629$var$Bb(b), null !== b && $f716e3e58d6e8629$var$Ec(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f716e3e58d6e8629$var$Tc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f716e3e58d6e8629$var$Kc = $f716e3e58d6e8629$var$Sc($f716e3e58d6e8629$var$Kc, a, b, c, d, e), !0;
        case "dragenter":
            return $f716e3e58d6e8629$var$Lc = $f716e3e58d6e8629$var$Sc($f716e3e58d6e8629$var$Lc, a, b, c, d, e), !0;
        case "mouseover":
            return $f716e3e58d6e8629$var$Mc = $f716e3e58d6e8629$var$Sc($f716e3e58d6e8629$var$Mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f716e3e58d6e8629$var$Nc.set(f, $f716e3e58d6e8629$var$Sc($f716e3e58d6e8629$var$Nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f716e3e58d6e8629$var$Oc.set(f, $f716e3e58d6e8629$var$Sc($f716e3e58d6e8629$var$Oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f716e3e58d6e8629$var$Uc(a) {
    var b = $f716e3e58d6e8629$var$Vc(a.target);
    if (null !== b) {
        var c = $f716e3e58d6e8629$var$Ub(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f716e3e58d6e8629$var$Vb(c), null !== b) {
                    a.blockedOn = b;
                    $f716e3e58d6e8629$var$Hc(a.priority, function() {
                        $f716e3e58d6e8629$var$Fc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f716e3e58d6e8629$var$Wc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f716e3e58d6e8629$var$Xc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f716e3e58d6e8629$var$vb = d;
            c.target.dispatchEvent(d);
            $f716e3e58d6e8629$var$vb = null;
        } else return b = $f716e3e58d6e8629$var$Bb(c), null !== b && $f716e3e58d6e8629$var$Ec(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f716e3e58d6e8629$var$Yc(a, b, c) {
    $f716e3e58d6e8629$var$Wc(a) && c.delete(b);
}
function $f716e3e58d6e8629$var$Zc() {
    $f716e3e58d6e8629$var$Ic = !1;
    null !== $f716e3e58d6e8629$var$Kc && $f716e3e58d6e8629$var$Wc($f716e3e58d6e8629$var$Kc) && ($f716e3e58d6e8629$var$Kc = null);
    null !== $f716e3e58d6e8629$var$Lc && $f716e3e58d6e8629$var$Wc($f716e3e58d6e8629$var$Lc) && ($f716e3e58d6e8629$var$Lc = null);
    null !== $f716e3e58d6e8629$var$Mc && $f716e3e58d6e8629$var$Wc($f716e3e58d6e8629$var$Mc) && ($f716e3e58d6e8629$var$Mc = null);
    $f716e3e58d6e8629$var$Nc.forEach($f716e3e58d6e8629$var$Yc);
    $f716e3e58d6e8629$var$Oc.forEach($f716e3e58d6e8629$var$Yc);
}
function $f716e3e58d6e8629$var$$c(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f716e3e58d6e8629$var$Ic || ($f716e3e58d6e8629$var$Ic = !0, $c2cCr.unstable_scheduleCallback($c2cCr.unstable_NormalPriority, $f716e3e58d6e8629$var$Zc)));
}
function $f716e3e58d6e8629$var$ad(a) {
    function b(b) {
        return $f716e3e58d6e8629$var$$c(b, a);
    }
    if (0 < $f716e3e58d6e8629$var$Jc.length) {
        $f716e3e58d6e8629$var$$c($f716e3e58d6e8629$var$Jc[0], a);
        for(var c = 1; c < $f716e3e58d6e8629$var$Jc.length; c++){
            var d = $f716e3e58d6e8629$var$Jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f716e3e58d6e8629$var$Kc && $f716e3e58d6e8629$var$$c($f716e3e58d6e8629$var$Kc, a);
    null !== $f716e3e58d6e8629$var$Lc && $f716e3e58d6e8629$var$$c($f716e3e58d6e8629$var$Lc, a);
    null !== $f716e3e58d6e8629$var$Mc && $f716e3e58d6e8629$var$$c($f716e3e58d6e8629$var$Mc, a);
    $f716e3e58d6e8629$var$Nc.forEach(b);
    $f716e3e58d6e8629$var$Oc.forEach(b);
    for(c = 0; c < $f716e3e58d6e8629$var$Pc.length; c++)d = $f716e3e58d6e8629$var$Pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f716e3e58d6e8629$var$Pc.length && (c = $f716e3e58d6e8629$var$Pc[0], null === c.blockedOn);)$f716e3e58d6e8629$var$Uc(c), null === c.blockedOn && $f716e3e58d6e8629$var$Pc.shift();
}
var $f716e3e58d6e8629$var$bd = $f716e3e58d6e8629$var$ta.ReactCurrentBatchConfig, $f716e3e58d6e8629$var$cd = !0;
function $f716e3e58d6e8629$var$dd(a, b, c, d) {
    var e = $f716e3e58d6e8629$var$C, f = $f716e3e58d6e8629$var$bd.transition;
    $f716e3e58d6e8629$var$bd.transition = null;
    try {
        $f716e3e58d6e8629$var$C = 1, $f716e3e58d6e8629$var$ed(a, b, c, d);
    } finally{
        $f716e3e58d6e8629$var$C = e, $f716e3e58d6e8629$var$bd.transition = f;
    }
}
function $f716e3e58d6e8629$var$fd(a, b, c, d) {
    var e = $f716e3e58d6e8629$var$C, f = $f716e3e58d6e8629$var$bd.transition;
    $f716e3e58d6e8629$var$bd.transition = null;
    try {
        $f716e3e58d6e8629$var$C = 4, $f716e3e58d6e8629$var$ed(a, b, c, d);
    } finally{
        $f716e3e58d6e8629$var$C = e, $f716e3e58d6e8629$var$bd.transition = f;
    }
}
function $f716e3e58d6e8629$var$ed(a, b, c, d) {
    if ($f716e3e58d6e8629$var$cd) {
        var e = $f716e3e58d6e8629$var$Xc(a, b, c, d);
        if (null === e) $f716e3e58d6e8629$var$gd(a, b, d, $f716e3e58d6e8629$var$hd, c), $f716e3e58d6e8629$var$Rc(a, d);
        else if ($f716e3e58d6e8629$var$Tc(e, a, b, c, d)) d.stopPropagation();
        else if ($f716e3e58d6e8629$var$Rc(a, d), b & 4 && -1 < $f716e3e58d6e8629$var$Qc.indexOf(a)) {
            for(; null !== e;){
                var f = $f716e3e58d6e8629$var$Bb(e);
                null !== f && $f716e3e58d6e8629$var$Dc(f);
                f = $f716e3e58d6e8629$var$Xc(a, b, c, d);
                null === f && $f716e3e58d6e8629$var$gd(a, b, d, $f716e3e58d6e8629$var$hd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f716e3e58d6e8629$var$gd(a, b, d, null, c);
    }
}
var $f716e3e58d6e8629$var$hd = null;
function $f716e3e58d6e8629$var$Xc(a, b, c, d) {
    $f716e3e58d6e8629$var$hd = null;
    a = $f716e3e58d6e8629$var$wb(d);
    a = $f716e3e58d6e8629$var$Vc(a);
    if (null !== a) {
        if (b = $f716e3e58d6e8629$var$Ub(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f716e3e58d6e8629$var$Vb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f716e3e58d6e8629$var$hd = a;
    return null;
}
function $f716e3e58d6e8629$var$id(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f716e3e58d6e8629$var$dc()){
                case $f716e3e58d6e8629$var$ec:
                    return 1;
                case $f716e3e58d6e8629$var$fc:
                    return 4;
                case $f716e3e58d6e8629$var$gc:
                case $f716e3e58d6e8629$var$hc:
                    return 16;
                case $f716e3e58d6e8629$var$ic:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f716e3e58d6e8629$var$jd = null, $f716e3e58d6e8629$var$kd = null, $f716e3e58d6e8629$var$ld = null;
function $f716e3e58d6e8629$var$md() {
    if ($f716e3e58d6e8629$var$ld) return $f716e3e58d6e8629$var$ld;
    var a, b = $f716e3e58d6e8629$var$kd, c = b.length, d, e = "value" in $f716e3e58d6e8629$var$jd ? $f716e3e58d6e8629$var$jd.value : $f716e3e58d6e8629$var$jd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f716e3e58d6e8629$var$ld = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f716e3e58d6e8629$var$nd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f716e3e58d6e8629$var$od() {
    return !0;
}
function $f716e3e58d6e8629$var$pd() {
    return !1;
}
function $f716e3e58d6e8629$var$qd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f716e3e58d6e8629$var$od : $f716e3e58d6e8629$var$pd;
        this.isPropagationStopped = $f716e3e58d6e8629$var$pd;
        return this;
    }
    $f716e3e58d6e8629$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f716e3e58d6e8629$var$od);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f716e3e58d6e8629$var$od);
        },
        persist: function() {},
        isPersistent: $f716e3e58d6e8629$var$od
    });
    return b;
}
var $f716e3e58d6e8629$var$rd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f716e3e58d6e8629$var$sd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$rd), $f716e3e58d6e8629$var$td = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$rd, {
    view: 0,
    detail: 0
}), $f716e3e58d6e8629$var$ud = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$td), $f716e3e58d6e8629$var$vd, $f716e3e58d6e8629$var$wd, $f716e3e58d6e8629$var$xd, $f716e3e58d6e8629$var$zd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$td, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f716e3e58d6e8629$var$yd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f716e3e58d6e8629$var$xd && ($f716e3e58d6e8629$var$xd && "mousemove" === a.type ? ($f716e3e58d6e8629$var$vd = a.screenX - $f716e3e58d6e8629$var$xd.screenX, $f716e3e58d6e8629$var$wd = a.screenY - $f716e3e58d6e8629$var$xd.screenY) : $f716e3e58d6e8629$var$wd = $f716e3e58d6e8629$var$vd = 0, $f716e3e58d6e8629$var$xd = a);
        return $f716e3e58d6e8629$var$vd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f716e3e58d6e8629$var$wd;
    }
}), $f716e3e58d6e8629$var$Ad = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$zd), $f716e3e58d6e8629$var$Bd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$zd, {
    dataTransfer: 0
}), $f716e3e58d6e8629$var$Cd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Bd), $f716e3e58d6e8629$var$Dd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$td, {
    relatedTarget: 0
}), $f716e3e58d6e8629$var$Ed = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Dd), $f716e3e58d6e8629$var$Fd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$rd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f716e3e58d6e8629$var$Gd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Fd), $f716e3e58d6e8629$var$Hd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$rd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f716e3e58d6e8629$var$Id = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Hd), $f716e3e58d6e8629$var$Jd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$rd, {
    data: 0
}), $f716e3e58d6e8629$var$Kd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Jd), $f716e3e58d6e8629$var$Ld = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f716e3e58d6e8629$var$Md = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f716e3e58d6e8629$var$Nd = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f716e3e58d6e8629$var$Od(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f716e3e58d6e8629$var$Nd[a]) ? !!b[a] : !1;
}
function $f716e3e58d6e8629$var$yd() {
    return $f716e3e58d6e8629$var$Od;
}
var $f716e3e58d6e8629$var$Pd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$td, {
    key: function(a) {
        if (a.key) {
            var b = $f716e3e58d6e8629$var$Ld[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f716e3e58d6e8629$var$nd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f716e3e58d6e8629$var$Md[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f716e3e58d6e8629$var$yd,
    charCode: function(a) {
        return "keypress" === a.type ? $f716e3e58d6e8629$var$nd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f716e3e58d6e8629$var$nd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f716e3e58d6e8629$var$Qd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Pd), $f716e3e58d6e8629$var$Rd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$zd, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f716e3e58d6e8629$var$Sd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Rd), $f716e3e58d6e8629$var$Td = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$td, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f716e3e58d6e8629$var$yd
}), $f716e3e58d6e8629$var$Ud = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Td), $f716e3e58d6e8629$var$Vd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$rd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f716e3e58d6e8629$var$Wd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Vd), $f716e3e58d6e8629$var$Xd = $f716e3e58d6e8629$var$A({}, $f716e3e58d6e8629$var$zd, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f716e3e58d6e8629$var$Yd = $f716e3e58d6e8629$var$qd($f716e3e58d6e8629$var$Xd), $f716e3e58d6e8629$var$Zd = [
    9,
    13,
    27,
    32
], $f716e3e58d6e8629$var$$d = $f716e3e58d6e8629$var$ia && "CompositionEvent" in window, $f716e3e58d6e8629$var$ae = null;
$f716e3e58d6e8629$var$ia && "documentMode" in document && ($f716e3e58d6e8629$var$ae = document.documentMode);
var $f716e3e58d6e8629$var$be = $f716e3e58d6e8629$var$ia && "TextEvent" in window && !$f716e3e58d6e8629$var$ae, $f716e3e58d6e8629$var$ce = $f716e3e58d6e8629$var$ia && (!$f716e3e58d6e8629$var$$d || $f716e3e58d6e8629$var$ae && 8 < $f716e3e58d6e8629$var$ae && 11 >= $f716e3e58d6e8629$var$ae), $f716e3e58d6e8629$var$de = String.fromCharCode(32), $f716e3e58d6e8629$var$ee = !1;
function $f716e3e58d6e8629$var$fe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f716e3e58d6e8629$var$Zd.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f716e3e58d6e8629$var$ge(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f716e3e58d6e8629$var$he = !1;
function $f716e3e58d6e8629$var$ie(a, b) {
    switch(a){
        case "compositionend":
            return $f716e3e58d6e8629$var$ge(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f716e3e58d6e8629$var$ee = !0;
            return $f716e3e58d6e8629$var$de;
        case "textInput":
            return a = b.data, a === $f716e3e58d6e8629$var$de && $f716e3e58d6e8629$var$ee ? null : a;
        default:
            return null;
    }
}
function $f716e3e58d6e8629$var$je(a, b) {
    if ($f716e3e58d6e8629$var$he) return "compositionend" === a || !$f716e3e58d6e8629$var$$d && $f716e3e58d6e8629$var$fe(a, b) ? (a = $f716e3e58d6e8629$var$md(), $f716e3e58d6e8629$var$ld = $f716e3e58d6e8629$var$kd = $f716e3e58d6e8629$var$jd = null, $f716e3e58d6e8629$var$he = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f716e3e58d6e8629$var$ce && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f716e3e58d6e8629$var$ke = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f716e3e58d6e8629$var$le(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f716e3e58d6e8629$var$ke[a.type] : "textarea" === b ? !0 : !1;
}
function $f716e3e58d6e8629$var$me(a, b, c, d) {
    $f716e3e58d6e8629$var$Db(d);
    b = $f716e3e58d6e8629$var$ne(b, "onChange");
    0 < b.length && (c = new $f716e3e58d6e8629$var$sd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f716e3e58d6e8629$var$oe = null, $f716e3e58d6e8629$var$pe = null;
function $f716e3e58d6e8629$var$qe(a) {
    $f716e3e58d6e8629$var$re(a, 0);
}
function $f716e3e58d6e8629$var$se(a) {
    var b = $f716e3e58d6e8629$var$te(a);
    if ($f716e3e58d6e8629$var$Va(b)) return a;
}
function $f716e3e58d6e8629$var$ue(a, b) {
    if ("change" === a) return b;
}
var $f716e3e58d6e8629$var$ve = !1;
if ($f716e3e58d6e8629$var$ia) {
    var $f716e3e58d6e8629$var$we;
    if ($f716e3e58d6e8629$var$ia) {
        var $f716e3e58d6e8629$var$xe = "oninput" in document;
        if (!$f716e3e58d6e8629$var$xe) {
            var $f716e3e58d6e8629$var$ye = document.createElement("div");
            $f716e3e58d6e8629$var$ye.setAttribute("oninput", "return;");
            $f716e3e58d6e8629$var$xe = "function" === typeof $f716e3e58d6e8629$var$ye.oninput;
        }
        $f716e3e58d6e8629$var$we = $f716e3e58d6e8629$var$xe;
    } else $f716e3e58d6e8629$var$we = !1;
    $f716e3e58d6e8629$var$ve = $f716e3e58d6e8629$var$we && (!document.documentMode || 9 < document.documentMode);
}
function $f716e3e58d6e8629$var$ze() {
    $f716e3e58d6e8629$var$oe && ($f716e3e58d6e8629$var$oe.detachEvent("onpropertychange", $f716e3e58d6e8629$var$Ae), $f716e3e58d6e8629$var$pe = $f716e3e58d6e8629$var$oe = null);
}
function $f716e3e58d6e8629$var$Ae(a) {
    if ("value" === a.propertyName && $f716e3e58d6e8629$var$se($f716e3e58d6e8629$var$pe)) {
        var b = [];
        $f716e3e58d6e8629$var$me(b, $f716e3e58d6e8629$var$pe, a, $f716e3e58d6e8629$var$wb(a));
        $f716e3e58d6e8629$var$Ib($f716e3e58d6e8629$var$qe, b);
    }
}
function $f716e3e58d6e8629$var$Be(a, b, c) {
    "focusin" === a ? ($f716e3e58d6e8629$var$ze(), $f716e3e58d6e8629$var$oe = b, $f716e3e58d6e8629$var$pe = c, $f716e3e58d6e8629$var$oe.attachEvent("onpropertychange", $f716e3e58d6e8629$var$Ae)) : "focusout" === a && $f716e3e58d6e8629$var$ze();
}
function $f716e3e58d6e8629$var$Ce(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f716e3e58d6e8629$var$se($f716e3e58d6e8629$var$pe);
}
function $f716e3e58d6e8629$var$De(a, b) {
    if ("click" === a) return $f716e3e58d6e8629$var$se(b);
}
function $f716e3e58d6e8629$var$Ee(a, b) {
    if ("input" === a || "change" === a) return $f716e3e58d6e8629$var$se(b);
}
function $f716e3e58d6e8629$var$Fe(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f716e3e58d6e8629$var$Ge = "function" === typeof Object.is ? Object.is : $f716e3e58d6e8629$var$Fe;
function $f716e3e58d6e8629$var$He(a, b) {
    if ($f716e3e58d6e8629$var$Ge(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f716e3e58d6e8629$var$ja.call(b, e) || !$f716e3e58d6e8629$var$Ge(a[e], b[e])) return !1;
    }
    return !0;
}
function $f716e3e58d6e8629$var$Ie(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f716e3e58d6e8629$var$Je(a, b) {
    var c = $f716e3e58d6e8629$var$Ie(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f716e3e58d6e8629$var$Ie(c);
    }
}
function $f716e3e58d6e8629$var$Ke(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f716e3e58d6e8629$var$Ke(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f716e3e58d6e8629$var$Le() {
    for(var a = window, b = $f716e3e58d6e8629$var$Wa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f716e3e58d6e8629$var$Wa(a.document);
    }
    return b;
}
function $f716e3e58d6e8629$var$Me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f716e3e58d6e8629$var$Ne(a) {
    var b = $f716e3e58d6e8629$var$Le(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f716e3e58d6e8629$var$Ke(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f716e3e58d6e8629$var$Me(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f716e3e58d6e8629$var$Je(c, f);
                var g = $f716e3e58d6e8629$var$Je(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f716e3e58d6e8629$var$Oe = $f716e3e58d6e8629$var$ia && "documentMode" in document && 11 >= document.documentMode, $f716e3e58d6e8629$var$Pe = null, $f716e3e58d6e8629$var$Qe = null, $f716e3e58d6e8629$var$Re = null, $f716e3e58d6e8629$var$Se = !1;
function $f716e3e58d6e8629$var$Te(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f716e3e58d6e8629$var$Se || null == $f716e3e58d6e8629$var$Pe || $f716e3e58d6e8629$var$Pe !== $f716e3e58d6e8629$var$Wa(d) || (d = $f716e3e58d6e8629$var$Pe, "selectionStart" in d && $f716e3e58d6e8629$var$Me(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f716e3e58d6e8629$var$Re && $f716e3e58d6e8629$var$He($f716e3e58d6e8629$var$Re, d) || ($f716e3e58d6e8629$var$Re = d, d = $f716e3e58d6e8629$var$ne($f716e3e58d6e8629$var$Qe, "onSelect"), 0 < d.length && (b = new $f716e3e58d6e8629$var$sd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f716e3e58d6e8629$var$Pe)));
}
function $f716e3e58d6e8629$var$Ue(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f716e3e58d6e8629$var$Ve = {
    animationend: $f716e3e58d6e8629$var$Ue("Animation", "AnimationEnd"),
    animationiteration: $f716e3e58d6e8629$var$Ue("Animation", "AnimationIteration"),
    animationstart: $f716e3e58d6e8629$var$Ue("Animation", "AnimationStart"),
    transitionend: $f716e3e58d6e8629$var$Ue("Transition", "TransitionEnd")
}, $f716e3e58d6e8629$var$We = {}, $f716e3e58d6e8629$var$Xe = {};
$f716e3e58d6e8629$var$ia && ($f716e3e58d6e8629$var$Xe = document.createElement("div").style, "AnimationEvent" in window || (delete $f716e3e58d6e8629$var$Ve.animationend.animation, delete $f716e3e58d6e8629$var$Ve.animationiteration.animation, delete $f716e3e58d6e8629$var$Ve.animationstart.animation), "TransitionEvent" in window || delete $f716e3e58d6e8629$var$Ve.transitionend.transition);
function $f716e3e58d6e8629$var$Ye(a) {
    if ($f716e3e58d6e8629$var$We[a]) return $f716e3e58d6e8629$var$We[a];
    if (!$f716e3e58d6e8629$var$Ve[a]) return a;
    var b = $f716e3e58d6e8629$var$Ve[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f716e3e58d6e8629$var$Xe) return $f716e3e58d6e8629$var$We[a] = b[c];
    return a;
}
var $f716e3e58d6e8629$var$Ze = $f716e3e58d6e8629$var$Ye("animationend"), $f716e3e58d6e8629$var$$e = $f716e3e58d6e8629$var$Ye("animationiteration"), $f716e3e58d6e8629$var$af = $f716e3e58d6e8629$var$Ye("animationstart"), $f716e3e58d6e8629$var$bf = $f716e3e58d6e8629$var$Ye("transitionend"), $f716e3e58d6e8629$var$cf = new Map, $f716e3e58d6e8629$var$df = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f716e3e58d6e8629$var$ef(a, b) {
    $f716e3e58d6e8629$var$cf.set(a, b);
    $f716e3e58d6e8629$var$fa(b, [
        a
    ]);
}
for(var $f716e3e58d6e8629$var$ff = 0; $f716e3e58d6e8629$var$ff < $f716e3e58d6e8629$var$df.length; $f716e3e58d6e8629$var$ff++){
    var $f716e3e58d6e8629$var$gf = $f716e3e58d6e8629$var$df[$f716e3e58d6e8629$var$ff], $f716e3e58d6e8629$var$hf = $f716e3e58d6e8629$var$gf.toLowerCase(), $f716e3e58d6e8629$var$jf = $f716e3e58d6e8629$var$gf[0].toUpperCase() + $f716e3e58d6e8629$var$gf.slice(1);
    $f716e3e58d6e8629$var$ef($f716e3e58d6e8629$var$hf, "on" + $f716e3e58d6e8629$var$jf);
}
$f716e3e58d6e8629$var$ef($f716e3e58d6e8629$var$Ze, "onAnimationEnd");
$f716e3e58d6e8629$var$ef($f716e3e58d6e8629$var$$e, "onAnimationIteration");
$f716e3e58d6e8629$var$ef($f716e3e58d6e8629$var$af, "onAnimationStart");
$f716e3e58d6e8629$var$ef("dblclick", "onDoubleClick");
$f716e3e58d6e8629$var$ef("focusin", "onFocus");
$f716e3e58d6e8629$var$ef("focusout", "onBlur");
$f716e3e58d6e8629$var$ef($f716e3e58d6e8629$var$bf, "onTransitionEnd");
$f716e3e58d6e8629$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f716e3e58d6e8629$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f716e3e58d6e8629$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f716e3e58d6e8629$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f716e3e58d6e8629$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f716e3e58d6e8629$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f716e3e58d6e8629$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f716e3e58d6e8629$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f716e3e58d6e8629$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f716e3e58d6e8629$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f716e3e58d6e8629$var$kf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f716e3e58d6e8629$var$lf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f716e3e58d6e8629$var$kf));
function $f716e3e58d6e8629$var$mf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f716e3e58d6e8629$var$Tb(d, b, void 0, a);
    a.currentTarget = null;
}
function $f716e3e58d6e8629$var$re(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f716e3e58d6e8629$var$mf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f716e3e58d6e8629$var$mf(e, h, l);
                f = k;
            }
        }
    }
    if ($f716e3e58d6e8629$var$Pb) throw a = $f716e3e58d6e8629$var$Qb, $f716e3e58d6e8629$var$Pb = !1, $f716e3e58d6e8629$var$Qb = null, a;
}
function $f716e3e58d6e8629$var$D(a, b) {
    var c = b[$f716e3e58d6e8629$var$nf];
    void 0 === c && (c = b[$f716e3e58d6e8629$var$nf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f716e3e58d6e8629$var$of(b, a, 2, !1), c.add(d));
}
function $f716e3e58d6e8629$var$pf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f716e3e58d6e8629$var$of(c, a, d, b);
}
var $f716e3e58d6e8629$var$qf = "_reactListening" + Math.random().toString(36).slice(2);
function $f716e3e58d6e8629$var$rf(a) {
    if (!a[$f716e3e58d6e8629$var$qf]) {
        a[$f716e3e58d6e8629$var$qf] = !0;
        $f716e3e58d6e8629$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f716e3e58d6e8629$var$lf.has(b) || $f716e3e58d6e8629$var$pf(b, !1, a), $f716e3e58d6e8629$var$pf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f716e3e58d6e8629$var$qf] || (b[$f716e3e58d6e8629$var$qf] = !0, $f716e3e58d6e8629$var$pf("selectionchange", !1, b));
    }
}
function $f716e3e58d6e8629$var$of(a, b, c, d) {
    switch($f716e3e58d6e8629$var$id(b)){
        case 1:
            var e = $f716e3e58d6e8629$var$dd;
            break;
        case 4:
            e = $f716e3e58d6e8629$var$fd;
            break;
        default:
            e = $f716e3e58d6e8629$var$ed;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f716e3e58d6e8629$var$Kb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f716e3e58d6e8629$var$gd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f716e3e58d6e8629$var$Vc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f716e3e58d6e8629$var$Ib(function() {
        var d = f, e = $f716e3e58d6e8629$var$wb(c), g = [];
        a: {
            var h = $f716e3e58d6e8629$var$cf.get(a);
            if (void 0 !== h) {
                var k = $f716e3e58d6e8629$var$sd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $f716e3e58d6e8629$var$nd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f716e3e58d6e8629$var$Qd;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $f716e3e58d6e8629$var$Ed;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $f716e3e58d6e8629$var$Ed;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f716e3e58d6e8629$var$Ed;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f716e3e58d6e8629$var$Ad;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f716e3e58d6e8629$var$Cd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f716e3e58d6e8629$var$Ud;
                        break;
                    case $f716e3e58d6e8629$var$Ze:
                    case $f716e3e58d6e8629$var$$e:
                    case $f716e3e58d6e8629$var$af:
                        k = $f716e3e58d6e8629$var$Gd;
                        break;
                    case $f716e3e58d6e8629$var$bf:
                        k = $f716e3e58d6e8629$var$Wd;
                        break;
                    case "scroll":
                        k = $f716e3e58d6e8629$var$ud;
                        break;
                    case "wheel":
                        k = $f716e3e58d6e8629$var$Yd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f716e3e58d6e8629$var$Id;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f716e3e58d6e8629$var$Sd;
                }
                var w = 0 !== (b & 4), J = !w && "scroll" === a, v = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var x = d, r; null !== x;){
                    r = x;
                    var F = r.stateNode;
                    5 === r.tag && null !== F && (r = F, null !== v && (F = $f716e3e58d6e8629$var$Jb(x, v), null != F && w.push($f716e3e58d6e8629$var$sf(x, F, r))));
                    if (J) break;
                    x = x.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f716e3e58d6e8629$var$vb && (m = c.relatedTarget || c.fromElement) && ($f716e3e58d6e8629$var$Vc(m) || m[$f716e3e58d6e8629$var$tf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $f716e3e58d6e8629$var$Vc(m) : null, null !== m && (J = $f716e3e58d6e8629$var$Ub(m), m !== J || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $f716e3e58d6e8629$var$Ad;
                        F = "onMouseLeave";
                        v = "onMouseEnter";
                        x = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $f716e3e58d6e8629$var$Sd, F = "onPointerLeave", v = "onPointerEnter", x = "pointer";
                        J = null == k ? h : $f716e3e58d6e8629$var$te(k);
                        r = null == m ? h : $f716e3e58d6e8629$var$te(m);
                        h = new w(F, x + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = r;
                        F = null;
                        $f716e3e58d6e8629$var$Vc(e) === d && (w = new w(v, x + "enter", m, c, e), w.target = r, w.relatedTarget = J, F = w);
                        J = F;
                        if (k && m) b: {
                            w = k;
                            v = m;
                            x = 0;
                            for(r = w; r; r = $f716e3e58d6e8629$var$uf(r))x++;
                            r = 0;
                            for(F = v; F; F = $f716e3e58d6e8629$var$uf(F))r++;
                            for(; 0 < x - r;)w = $f716e3e58d6e8629$var$uf(w), x--;
                            for(; 0 < r - x;)v = $f716e3e58d6e8629$var$uf(v), r--;
                            for(; x--;){
                                if (w === v || null !== v && w === v.alternate) break b;
                                w = $f716e3e58d6e8629$var$uf(w);
                                v = $f716e3e58d6e8629$var$uf(v);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $f716e3e58d6e8629$var$vf(g, h, k, w, !1);
                        null !== m && null !== J && $f716e3e58d6e8629$var$vf(g, J, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $f716e3e58d6e8629$var$te(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var Z = $f716e3e58d6e8629$var$ue;
                else if ($f716e3e58d6e8629$var$le(h)) {
                    if ($f716e3e58d6e8629$var$ve) Z = $f716e3e58d6e8629$var$Ee;
                    else {
                        Z = $f716e3e58d6e8629$var$Ce;
                        var ya = $f716e3e58d6e8629$var$Be;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (Z = $f716e3e58d6e8629$var$De);
                if (Z && (Z = Z(a, d))) {
                    $f716e3e58d6e8629$var$me(g, Z, c, e);
                    break a;
                }
                ya && ya(a, h, d);
                "focusout" === a && (ya = h._wrapperState) && ya.controlled && "number" === h.type && $f716e3e58d6e8629$var$bb(h, "number", h.value);
            }
            ya = d ? $f716e3e58d6e8629$var$te(d) : window;
            switch(a){
                case "focusin":
                    if ($f716e3e58d6e8629$var$le(ya) || "true" === ya.contentEditable) $f716e3e58d6e8629$var$Pe = ya, $f716e3e58d6e8629$var$Qe = d, $f716e3e58d6e8629$var$Re = null;
                    break;
                case "focusout":
                    $f716e3e58d6e8629$var$Re = $f716e3e58d6e8629$var$Qe = $f716e3e58d6e8629$var$Pe = null;
                    break;
                case "mousedown":
                    $f716e3e58d6e8629$var$Se = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f716e3e58d6e8629$var$Se = !1;
                    $f716e3e58d6e8629$var$Te(g, c, e);
                    break;
                case "selectionchange":
                    if ($f716e3e58d6e8629$var$Oe) break;
                case "keydown":
                case "keyup":
                    $f716e3e58d6e8629$var$Te(g, c, e);
            }
            var ab;
            if ($f716e3e58d6e8629$var$$d) b: {
                switch(a){
                    case "compositionstart":
                        var ca = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ca = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ca = "onCompositionUpdate";
                        break b;
                }
                ca = void 0;
            }
            else $f716e3e58d6e8629$var$he ? $f716e3e58d6e8629$var$fe(a, c) && (ca = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ca = "onCompositionStart");
            ca && ($f716e3e58d6e8629$var$ce && "ko" !== c.locale && ($f716e3e58d6e8629$var$he || "onCompositionStart" !== ca ? "onCompositionEnd" === ca && $f716e3e58d6e8629$var$he && (ab = $f716e3e58d6e8629$var$md()) : ($f716e3e58d6e8629$var$jd = e, $f716e3e58d6e8629$var$kd = "value" in $f716e3e58d6e8629$var$jd ? $f716e3e58d6e8629$var$jd.value : $f716e3e58d6e8629$var$jd.textContent, $f716e3e58d6e8629$var$he = !0)), ya = $f716e3e58d6e8629$var$ne(d, ca), 0 < ya.length && (ca = new $f716e3e58d6e8629$var$Kd(ca, a, null, c, e), g.push({
                event: ca,
                listeners: ya
            }), ab ? ca.data = ab : (ab = $f716e3e58d6e8629$var$ge(c), null !== ab && (ca.data = ab))));
            if (ab = $f716e3e58d6e8629$var$be ? $f716e3e58d6e8629$var$ie(a, c) : $f716e3e58d6e8629$var$je(a, c)) d = $f716e3e58d6e8629$var$ne(d, "onBeforeInput"), 0 < d.length && (e = new $f716e3e58d6e8629$var$Kd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = ab);
        }
        $f716e3e58d6e8629$var$re(g, b);
    });
}
function $f716e3e58d6e8629$var$sf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f716e3e58d6e8629$var$ne(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f716e3e58d6e8629$var$Jb(a, c), null != f && d.unshift($f716e3e58d6e8629$var$sf(a, f, e)), f = $f716e3e58d6e8629$var$Jb(a, b), null != f && d.push($f716e3e58d6e8629$var$sf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f716e3e58d6e8629$var$uf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f716e3e58d6e8629$var$vf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f716e3e58d6e8629$var$Jb(c, f), null != k && g.unshift($f716e3e58d6e8629$var$sf(c, k, h))) : e || (k = $f716e3e58d6e8629$var$Jb(c, f), null != k && g.push($f716e3e58d6e8629$var$sf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f716e3e58d6e8629$var$wf = /\r\n?/g, $f716e3e58d6e8629$var$xf = /\u0000|\uFFFD/g;
function $f716e3e58d6e8629$var$yf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f716e3e58d6e8629$var$wf, "\n").replace($f716e3e58d6e8629$var$xf, "");
}
function $f716e3e58d6e8629$var$zf(a, b, c) {
    b = $f716e3e58d6e8629$var$yf(b);
    if ($f716e3e58d6e8629$var$yf(a) !== b && c) throw Error($f716e3e58d6e8629$var$p(425));
}
function $f716e3e58d6e8629$var$Af() {}
var $f716e3e58d6e8629$var$Bf = null, $f716e3e58d6e8629$var$Cf = null;
function $f716e3e58d6e8629$var$Df(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f716e3e58d6e8629$var$Ef = "function" === typeof setTimeout ? setTimeout : void 0, $f716e3e58d6e8629$var$Ff = "function" === typeof clearTimeout ? clearTimeout : void 0, $f716e3e58d6e8629$var$Gf = "function" === typeof Promise ? Promise : void 0, $f716e3e58d6e8629$var$If = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f716e3e58d6e8629$var$Gf ? function(a) {
    return $f716e3e58d6e8629$var$Gf.resolve(null).then(a).catch($f716e3e58d6e8629$var$Hf);
} : $f716e3e58d6e8629$var$Ef;
function $f716e3e58d6e8629$var$Hf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f716e3e58d6e8629$var$Jf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f716e3e58d6e8629$var$ad(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f716e3e58d6e8629$var$ad(b);
}
function $f716e3e58d6e8629$var$Kf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f716e3e58d6e8629$var$Lf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f716e3e58d6e8629$var$Mf = Math.random().toString(36).slice(2), $f716e3e58d6e8629$var$Nf = "__reactFiber$" + $f716e3e58d6e8629$var$Mf, $f716e3e58d6e8629$var$Of = "__reactProps$" + $f716e3e58d6e8629$var$Mf, $f716e3e58d6e8629$var$tf = "__reactContainer$" + $f716e3e58d6e8629$var$Mf, $f716e3e58d6e8629$var$nf = "__reactEvents$" + $f716e3e58d6e8629$var$Mf, $f716e3e58d6e8629$var$Pf = "__reactListeners$" + $f716e3e58d6e8629$var$Mf, $f716e3e58d6e8629$var$Qf = "__reactHandles$" + $f716e3e58d6e8629$var$Mf;
function $f716e3e58d6e8629$var$Vc(a) {
    var b = a[$f716e3e58d6e8629$var$Nf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f716e3e58d6e8629$var$tf] || c[$f716e3e58d6e8629$var$Nf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f716e3e58d6e8629$var$Lf(a); null !== a;){
                if (c = a[$f716e3e58d6e8629$var$Nf]) return c;
                a = $f716e3e58d6e8629$var$Lf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f716e3e58d6e8629$var$Bb(a) {
    a = a[$f716e3e58d6e8629$var$Nf] || a[$f716e3e58d6e8629$var$tf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f716e3e58d6e8629$var$te(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f716e3e58d6e8629$var$p(33));
}
function $f716e3e58d6e8629$var$Cb(a) {
    return a[$f716e3e58d6e8629$var$Of] || null;
}
var $f716e3e58d6e8629$var$Rf = [], $f716e3e58d6e8629$var$Sf = -1;
function $f716e3e58d6e8629$var$Tf(a) {
    return {
        current: a
    };
}
function $f716e3e58d6e8629$var$E(a) {
    0 > $f716e3e58d6e8629$var$Sf || (a.current = $f716e3e58d6e8629$var$Rf[$f716e3e58d6e8629$var$Sf], $f716e3e58d6e8629$var$Rf[$f716e3e58d6e8629$var$Sf] = null, $f716e3e58d6e8629$var$Sf--);
}
function $f716e3e58d6e8629$var$G(a, b) {
    $f716e3e58d6e8629$var$Sf++;
    $f716e3e58d6e8629$var$Rf[$f716e3e58d6e8629$var$Sf] = a.current;
    a.current = b;
}
var $f716e3e58d6e8629$var$Uf = {}, $f716e3e58d6e8629$var$H = $f716e3e58d6e8629$var$Tf($f716e3e58d6e8629$var$Uf), $f716e3e58d6e8629$var$Vf = $f716e3e58d6e8629$var$Tf(!1), $f716e3e58d6e8629$var$Wf = $f716e3e58d6e8629$var$Uf;
function $f716e3e58d6e8629$var$Xf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f716e3e58d6e8629$var$Uf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f716e3e58d6e8629$var$Yf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f716e3e58d6e8629$var$Zf() {
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Vf);
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$H);
}
function $f716e3e58d6e8629$var$$f(a, b, c) {
    if ($f716e3e58d6e8629$var$H.current !== $f716e3e58d6e8629$var$Uf) throw Error($f716e3e58d6e8629$var$p(168));
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$H, b);
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Vf, c);
}
function $f716e3e58d6e8629$var$ag(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f716e3e58d6e8629$var$p(108, $f716e3e58d6e8629$var$Qa(a) || "Unknown", e));
    return $f716e3e58d6e8629$var$A({}, c, d);
}
function $f716e3e58d6e8629$var$bg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f716e3e58d6e8629$var$Uf;
    $f716e3e58d6e8629$var$Wf = $f716e3e58d6e8629$var$H.current;
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$H, a);
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Vf, $f716e3e58d6e8629$var$Vf.current);
    return !0;
}
function $f716e3e58d6e8629$var$cg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f716e3e58d6e8629$var$p(169));
    c ? (a = $f716e3e58d6e8629$var$ag(a, b, $f716e3e58d6e8629$var$Wf), d.__reactInternalMemoizedMergedChildContext = a, $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Vf), $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$H), $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$H, a)) : $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Vf);
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Vf, c);
}
var $f716e3e58d6e8629$var$dg = null, $f716e3e58d6e8629$var$eg = !1, $f716e3e58d6e8629$var$fg = !1;
function $f716e3e58d6e8629$var$gg(a) {
    null === $f716e3e58d6e8629$var$dg ? $f716e3e58d6e8629$var$dg = [
        a
    ] : $f716e3e58d6e8629$var$dg.push(a);
}
function $f716e3e58d6e8629$var$hg(a) {
    $f716e3e58d6e8629$var$eg = !0;
    $f716e3e58d6e8629$var$gg(a);
}
function $f716e3e58d6e8629$var$ig() {
    if (!$f716e3e58d6e8629$var$fg && null !== $f716e3e58d6e8629$var$dg) {
        $f716e3e58d6e8629$var$fg = !0;
        var a = 0, b = $f716e3e58d6e8629$var$C;
        try {
            var c = $f716e3e58d6e8629$var$dg;
            for($f716e3e58d6e8629$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f716e3e58d6e8629$var$dg = null;
            $f716e3e58d6e8629$var$eg = !1;
        } catch (e) {
            throw null !== $f716e3e58d6e8629$var$dg && ($f716e3e58d6e8629$var$dg = $f716e3e58d6e8629$var$dg.slice(a + 1)), $f716e3e58d6e8629$var$$b($f716e3e58d6e8629$var$ec, $f716e3e58d6e8629$var$ig), e;
        } finally{
            $f716e3e58d6e8629$var$C = b, $f716e3e58d6e8629$var$fg = !1;
        }
    }
    return null;
}
var $f716e3e58d6e8629$var$jg = $f716e3e58d6e8629$var$ta.ReactCurrentBatchConfig;
function $f716e3e58d6e8629$var$kg(a, b) {
    if (a && a.defaultProps) {
        b = $f716e3e58d6e8629$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $f716e3e58d6e8629$var$lg = $f716e3e58d6e8629$var$Tf(null), $f716e3e58d6e8629$var$mg = null, $f716e3e58d6e8629$var$ng = null, $f716e3e58d6e8629$var$og = null;
function $f716e3e58d6e8629$var$pg() {
    $f716e3e58d6e8629$var$og = $f716e3e58d6e8629$var$ng = $f716e3e58d6e8629$var$mg = null;
}
function $f716e3e58d6e8629$var$qg(a) {
    var b = $f716e3e58d6e8629$var$lg.current;
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$lg);
    a._currentValue = b;
}
function $f716e3e58d6e8629$var$rg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f716e3e58d6e8629$var$sg(a, b) {
    $f716e3e58d6e8629$var$mg = a;
    $f716e3e58d6e8629$var$og = $f716e3e58d6e8629$var$ng = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f716e3e58d6e8629$var$tg = !0), a.firstContext = null);
}
function $f716e3e58d6e8629$var$ug(a) {
    var b = a._currentValue;
    if ($f716e3e58d6e8629$var$og !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f716e3e58d6e8629$var$ng) {
            if (null === $f716e3e58d6e8629$var$mg) throw Error($f716e3e58d6e8629$var$p(308));
            $f716e3e58d6e8629$var$ng = a;
            $f716e3e58d6e8629$var$mg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f716e3e58d6e8629$var$ng = $f716e3e58d6e8629$var$ng.next = a;
    }
    return b;
}
var $f716e3e58d6e8629$var$vg = null, $f716e3e58d6e8629$var$wg = !1;
function $f716e3e58d6e8629$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f716e3e58d6e8629$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f716e3e58d6e8629$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f716e3e58d6e8629$var$Ag(a, b) {
    var c = a.updateQueue;
    null !== c && (c = c.shared, $f716e3e58d6e8629$var$Bg(a) ? (a = c.interleaved, null === a ? (b.next = b, null === $f716e3e58d6e8629$var$vg ? $f716e3e58d6e8629$var$vg = [
        c
    ] : $f716e3e58d6e8629$var$vg.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
}
function $f716e3e58d6e8629$var$Cg(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f716e3e58d6e8629$var$Bc(a, c);
    }
}
function $f716e3e58d6e8629$var$Dg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f716e3e58d6e8629$var$Eg(a, b, c, d) {
    var e = a.updateQueue;
    $f716e3e58d6e8629$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var u = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var q = h.lane, y = h.eventTime;
            if ((d & q) === q) {
                null !== n && (n = n.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    q = b;
                    y = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                u = m.call(y, u, q);
                                break a;
                            }
                            u = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            q = "function" === typeof m ? m.call(y, u, q) : m;
                            if (null === q || void 0 === q) break a;
                            u = $f716e3e58d6e8629$var$A({}, u, q);
                            break a;
                        case 2:
                            $f716e3e58d6e8629$var$wg = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, q = e.effects, null === q ? e.effects = [
                    h
                ] : q.push(h));
            } else y = {
                eventTime: y,
                lane: q,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = y, k = u) : n = n.next = y, g |= q;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else q = h, h = q.next, q.next = null, e.lastBaseUpdate = q, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = u);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f716e3e58d6e8629$var$Fg |= g;
        a.lanes = g;
        a.memoizedState = u;
    }
}
function $f716e3e58d6e8629$var$Gg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f716e3e58d6e8629$var$p(191, e));
            e.call(d);
        }
    }
}
var $f716e3e58d6e8629$var$Hg = (new $70fFQ.Component).refs;
function $f716e3e58d6e8629$var$Ig(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f716e3e58d6e8629$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f716e3e58d6e8629$var$Mg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f716e3e58d6e8629$var$Ub(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f716e3e58d6e8629$var$Jg(), e = $f716e3e58d6e8629$var$Kg(a), f = $f716e3e58d6e8629$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $f716e3e58d6e8629$var$Ag(a, f);
        b = $f716e3e58d6e8629$var$Lg(a, e, d);
        null !== b && $f716e3e58d6e8629$var$Cg(b, a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f716e3e58d6e8629$var$Jg(), e = $f716e3e58d6e8629$var$Kg(a), f = $f716e3e58d6e8629$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $f716e3e58d6e8629$var$Ag(a, f);
        b = $f716e3e58d6e8629$var$Lg(a, e, d);
        null !== b && $f716e3e58d6e8629$var$Cg(b, a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f716e3e58d6e8629$var$Jg(), d = $f716e3e58d6e8629$var$Kg(a), e = $f716e3e58d6e8629$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $f716e3e58d6e8629$var$Ag(a, e);
        b = $f716e3e58d6e8629$var$Lg(a, d, c);
        null !== b && $f716e3e58d6e8629$var$Cg(b, a, d);
    }
};
function $f716e3e58d6e8629$var$Ng(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f716e3e58d6e8629$var$He(c, d) || !$f716e3e58d6e8629$var$He(e, f) : !0;
}
function $f716e3e58d6e8629$var$Og(a, b, c) {
    var d = !1, e = $f716e3e58d6e8629$var$Uf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f716e3e58d6e8629$var$ug(f) : (e = $f716e3e58d6e8629$var$Yf(b) ? $f716e3e58d6e8629$var$Wf : $f716e3e58d6e8629$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f716e3e58d6e8629$var$Xf(a, e) : $f716e3e58d6e8629$var$Uf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f716e3e58d6e8629$var$Mg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f716e3e58d6e8629$var$Pg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f716e3e58d6e8629$var$Mg.enqueueReplaceState(b, b.state, null);
}
function $f716e3e58d6e8629$var$Qg(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $f716e3e58d6e8629$var$Hg;
    $f716e3e58d6e8629$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f716e3e58d6e8629$var$ug(f) : (f = $f716e3e58d6e8629$var$Yf(b) ? $f716e3e58d6e8629$var$Wf : $f716e3e58d6e8629$var$H.current, e.context = $f716e3e58d6e8629$var$Xf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f716e3e58d6e8629$var$Ig(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f716e3e58d6e8629$var$Mg.enqueueReplaceState(e, e.state, null), $f716e3e58d6e8629$var$Eg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
var $f716e3e58d6e8629$var$Rg = [], $f716e3e58d6e8629$var$Sg = 0, $f716e3e58d6e8629$var$Tg = null, $f716e3e58d6e8629$var$Ug = 0, $f716e3e58d6e8629$var$Vg = [], $f716e3e58d6e8629$var$Wg = 0, $f716e3e58d6e8629$var$Xg = null, $f716e3e58d6e8629$var$Yg = 1, $f716e3e58d6e8629$var$Zg = "";
function $f716e3e58d6e8629$var$$g(a, b) {
    $f716e3e58d6e8629$var$Rg[$f716e3e58d6e8629$var$Sg++] = $f716e3e58d6e8629$var$Ug;
    $f716e3e58d6e8629$var$Rg[$f716e3e58d6e8629$var$Sg++] = $f716e3e58d6e8629$var$Tg;
    $f716e3e58d6e8629$var$Tg = a;
    $f716e3e58d6e8629$var$Ug = b;
}
function $f716e3e58d6e8629$var$ah(a, b, c) {
    $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg++] = $f716e3e58d6e8629$var$Yg;
    $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg++] = $f716e3e58d6e8629$var$Zg;
    $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg++] = $f716e3e58d6e8629$var$Xg;
    $f716e3e58d6e8629$var$Xg = a;
    var d = $f716e3e58d6e8629$var$Yg;
    a = $f716e3e58d6e8629$var$Zg;
    var e = 32 - $f716e3e58d6e8629$var$nc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f716e3e58d6e8629$var$nc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f716e3e58d6e8629$var$Yg = 1 << 32 - $f716e3e58d6e8629$var$nc(b) + e | c << e | d;
        $f716e3e58d6e8629$var$Zg = f + a;
    } else $f716e3e58d6e8629$var$Yg = 1 << f | c << e | d, $f716e3e58d6e8629$var$Zg = a;
}
function $f716e3e58d6e8629$var$bh(a) {
    null !== a.return && ($f716e3e58d6e8629$var$$g(a, 1), $f716e3e58d6e8629$var$ah(a, 1, 0));
}
function $f716e3e58d6e8629$var$ch(a) {
    for(; a === $f716e3e58d6e8629$var$Tg;)$f716e3e58d6e8629$var$Tg = $f716e3e58d6e8629$var$Rg[--$f716e3e58d6e8629$var$Sg], $f716e3e58d6e8629$var$Rg[$f716e3e58d6e8629$var$Sg] = null, $f716e3e58d6e8629$var$Ug = $f716e3e58d6e8629$var$Rg[--$f716e3e58d6e8629$var$Sg], $f716e3e58d6e8629$var$Rg[$f716e3e58d6e8629$var$Sg] = null;
    for(; a === $f716e3e58d6e8629$var$Xg;)$f716e3e58d6e8629$var$Xg = $f716e3e58d6e8629$var$Vg[--$f716e3e58d6e8629$var$Wg], $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg] = null, $f716e3e58d6e8629$var$Zg = $f716e3e58d6e8629$var$Vg[--$f716e3e58d6e8629$var$Wg], $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg] = null, $f716e3e58d6e8629$var$Yg = $f716e3e58d6e8629$var$Vg[--$f716e3e58d6e8629$var$Wg], $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg] = null;
}
var $f716e3e58d6e8629$var$dh = null, $f716e3e58d6e8629$var$eh = null, $f716e3e58d6e8629$var$I = !1, $f716e3e58d6e8629$var$fh = null;
function $f716e3e58d6e8629$var$gh(a, b) {
    var c = $f716e3e58d6e8629$var$hh(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f716e3e58d6e8629$var$ih(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f716e3e58d6e8629$var$dh = a, $f716e3e58d6e8629$var$eh = $f716e3e58d6e8629$var$Kf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f716e3e58d6e8629$var$dh = a, $f716e3e58d6e8629$var$eh = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f716e3e58d6e8629$var$Xg ? {
                id: $f716e3e58d6e8629$var$Yg,
                overflow: $f716e3e58d6e8629$var$Zg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f716e3e58d6e8629$var$hh(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f716e3e58d6e8629$var$dh = a, $f716e3e58d6e8629$var$eh = null, !0) : !1;
        default:
            return !1;
    }
}
function $f716e3e58d6e8629$var$jh(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f716e3e58d6e8629$var$kh(a) {
    if ($f716e3e58d6e8629$var$I) {
        var b = $f716e3e58d6e8629$var$eh;
        if (b) {
            var c = b;
            if (!$f716e3e58d6e8629$var$ih(a, b)) {
                if ($f716e3e58d6e8629$var$jh(a)) throw Error($f716e3e58d6e8629$var$p(418));
                b = $f716e3e58d6e8629$var$Kf(c.nextSibling);
                var d = $f716e3e58d6e8629$var$dh;
                b && $f716e3e58d6e8629$var$ih(a, b) ? $f716e3e58d6e8629$var$gh(d, c) : (a.flags = a.flags & -4097 | 2, $f716e3e58d6e8629$var$I = !1, $f716e3e58d6e8629$var$dh = a);
            }
        } else {
            if ($f716e3e58d6e8629$var$jh(a)) throw Error($f716e3e58d6e8629$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f716e3e58d6e8629$var$I = !1;
            $f716e3e58d6e8629$var$dh = a;
        }
    }
}
function $f716e3e58d6e8629$var$lh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f716e3e58d6e8629$var$dh = a;
}
function $f716e3e58d6e8629$var$mh(a) {
    if (a !== $f716e3e58d6e8629$var$dh) return !1;
    if (!$f716e3e58d6e8629$var$I) return $f716e3e58d6e8629$var$lh(a), $f716e3e58d6e8629$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f716e3e58d6e8629$var$Df(a.type, a.memoizedProps));
    if (b && (b = $f716e3e58d6e8629$var$eh)) {
        if ($f716e3e58d6e8629$var$jh(a)) {
            for(a = $f716e3e58d6e8629$var$eh; a;)a = $f716e3e58d6e8629$var$Kf(a.nextSibling);
            throw Error($f716e3e58d6e8629$var$p(418));
        }
        for(; b;)$f716e3e58d6e8629$var$gh(a, b), b = $f716e3e58d6e8629$var$Kf(b.nextSibling);
    }
    $f716e3e58d6e8629$var$lh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f716e3e58d6e8629$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f716e3e58d6e8629$var$eh = $f716e3e58d6e8629$var$Kf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f716e3e58d6e8629$var$eh = null;
        }
    } else $f716e3e58d6e8629$var$eh = $f716e3e58d6e8629$var$dh ? $f716e3e58d6e8629$var$Kf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f716e3e58d6e8629$var$nh() {
    $f716e3e58d6e8629$var$eh = $f716e3e58d6e8629$var$dh = null;
    $f716e3e58d6e8629$var$I = !1;
}
function $f716e3e58d6e8629$var$oh(a) {
    null === $f716e3e58d6e8629$var$fh ? $f716e3e58d6e8629$var$fh = [
        a
    ] : $f716e3e58d6e8629$var$fh.push(a);
}
function $f716e3e58d6e8629$var$ph(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f716e3e58d6e8629$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f716e3e58d6e8629$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $f716e3e58d6e8629$var$Hg && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f716e3e58d6e8629$var$p(284));
        if (!c._owner) throw Error($f716e3e58d6e8629$var$p(290, a));
    }
    return a;
}
function $f716e3e58d6e8629$var$qh(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f716e3e58d6e8629$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f716e3e58d6e8629$var$rh(a) {
    var b = a._init;
    return b(a._payload);
}
function $f716e3e58d6e8629$var$sh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f716e3e58d6e8629$var$th(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f716e3e58d6e8629$var$uh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f716e3e58d6e8629$var$wa) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f716e3e58d6e8629$var$Ga && $f716e3e58d6e8629$var$rh(f) === b.type)) return d = e(b, c.props), d.ref = $f716e3e58d6e8629$var$ph(a, b, c), d.return = a, d;
        d = $f716e3e58d6e8629$var$vh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f716e3e58d6e8629$var$ph(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f716e3e58d6e8629$var$wh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f716e3e58d6e8629$var$xh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function u(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f716e3e58d6e8629$var$uh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f716e3e58d6e8629$var$ua:
                    return c = $f716e3e58d6e8629$var$vh(b.type, b.key, b.props, null, a.mode, c), c.ref = $f716e3e58d6e8629$var$ph(a, null, b), c.return = a, c;
                case $f716e3e58d6e8629$var$va:
                    return b = $f716e3e58d6e8629$var$wh(b, a.mode, c), b.return = a, b;
                case $f716e3e58d6e8629$var$Ga:
                    var d = b._init;
                    return u(a, d(b._payload), c);
            }
            if ($f716e3e58d6e8629$var$db(b) || $f716e3e58d6e8629$var$Ja(b)) return b = $f716e3e58d6e8629$var$xh(b, a.mode, c, null), b.return = a, b;
            $f716e3e58d6e8629$var$qh(a, b);
        }
        return null;
    }
    function q(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f716e3e58d6e8629$var$ua:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f716e3e58d6e8629$var$va:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f716e3e58d6e8629$var$Ga:
                    return e = c._init, q(a, b, e(c._payload), d);
            }
            if ($f716e3e58d6e8629$var$db(c) || $f716e3e58d6e8629$var$Ja(c)) return null !== e ? null : n(a, b, c, d, null);
            $f716e3e58d6e8629$var$qh(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f716e3e58d6e8629$var$ua:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f716e3e58d6e8629$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f716e3e58d6e8629$var$Ga:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f716e3e58d6e8629$var$db(d) || $f716e3e58d6e8629$var$Ja(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $f716e3e58d6e8629$var$qh(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, n = null, r = g, m = g = 0, x = null; null !== r && m < h.length; m++){
            r.index > m ? (x = r, r = null) : x = r.sibling;
            var v = q(e, r, h[m], k);
            if (null === v) {
                null === r && (r = x);
                break;
            }
            a && r && null === v.alternate && b(e, r);
            g = f(v, g, m);
            null === n ? l = v : n.sibling = v;
            n = v;
            r = x;
        }
        if (m === h.length) return c(e, r), $f716e3e58d6e8629$var$I && $f716e3e58d6e8629$var$$g(e, m), l;
        if (null === r) {
            for(; m < h.length; m++)r = u(e, h[m], k), null !== r && (g = f(r, g, m), null === n ? l = r : n.sibling = r, n = r);
            $f716e3e58d6e8629$var$I && $f716e3e58d6e8629$var$$g(e, m);
            return l;
        }
        for(r = d(e, r); m < h.length; m++)x = y(r, e, m, h[m], k), null !== x && (a && null !== x.alternate && r.delete(null === x.key ? m : x.key), g = f(x, g, m), null === n ? l = x : n.sibling = x, n = x);
        a && r.forEach(function(a) {
            return b(e, a);
        });
        $f716e3e58d6e8629$var$I && $f716e3e58d6e8629$var$$g(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $f716e3e58d6e8629$var$Ja(h);
        if ("function" !== typeof l) throw Error($f716e3e58d6e8629$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f716e3e58d6e8629$var$p(151));
        for(var n = l = null, m = g, r = g = 0, x = null, v = h.next(); null !== m && !v.done; r++, v = h.next()){
            m.index > r ? (x = m, m = null) : x = m.sibling;
            var w = q(e, m, v.value, k);
            if (null === w) {
                null === m && (m = x);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, r);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = x;
        }
        if (v.done) return c(e, m), $f716e3e58d6e8629$var$I && $f716e3e58d6e8629$var$$g(e, r), l;
        if (null === m) {
            for(; !v.done; r++, v = h.next())v = u(e, v.value, k), null !== v && (g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
            $f716e3e58d6e8629$var$I && $f716e3e58d6e8629$var$$g(e, r);
            return l;
        }
        for(m = d(e, m); !v.done; r++, v = h.next())v = y(m, e, r, v.value, k), null !== v && (a && null !== v.alternate && m.delete(null === v.key ? r : v.key), g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f716e3e58d6e8629$var$I && $f716e3e58d6e8629$var$$g(e, r);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f716e3e58d6e8629$var$wa && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f716e3e58d6e8629$var$ua:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f716e3e58d6e8629$var$wa) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f716e3e58d6e8629$var$Ga && $f716e3e58d6e8629$var$rh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f716e3e58d6e8629$var$ph(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f716e3e58d6e8629$var$wa ? (d = $f716e3e58d6e8629$var$xh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f716e3e58d6e8629$var$vh(f.type, f.key, f.props, null, a.mode, h), h.ref = $f716e3e58d6e8629$var$ph(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f716e3e58d6e8629$var$va:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f716e3e58d6e8629$var$wh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f716e3e58d6e8629$var$Ga:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f716e3e58d6e8629$var$db(f)) return m(a, d, f, h);
            if ($f716e3e58d6e8629$var$Ja(f)) return w(a, d, f, h);
            $f716e3e58d6e8629$var$qh(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f716e3e58d6e8629$var$uh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f716e3e58d6e8629$var$yh = $f716e3e58d6e8629$var$sh(!0), $f716e3e58d6e8629$var$zh = $f716e3e58d6e8629$var$sh(!1), $f716e3e58d6e8629$var$Ah = {}, $f716e3e58d6e8629$var$Bh = $f716e3e58d6e8629$var$Tf($f716e3e58d6e8629$var$Ah), $f716e3e58d6e8629$var$Ch = $f716e3e58d6e8629$var$Tf($f716e3e58d6e8629$var$Ah), $f716e3e58d6e8629$var$Dh = $f716e3e58d6e8629$var$Tf($f716e3e58d6e8629$var$Ah);
function $f716e3e58d6e8629$var$Eh(a) {
    if (a === $f716e3e58d6e8629$var$Ah) throw Error($f716e3e58d6e8629$var$p(174));
    return a;
}
function $f716e3e58d6e8629$var$Fh(a, b) {
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Dh, b);
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Ch, a);
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Bh, $f716e3e58d6e8629$var$Ah);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f716e3e58d6e8629$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f716e3e58d6e8629$var$kb(b, a);
    }
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Bh);
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Bh, b);
}
function $f716e3e58d6e8629$var$Gh() {
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Bh);
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Ch);
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Dh);
}
function $f716e3e58d6e8629$var$Hh(a) {
    $f716e3e58d6e8629$var$Eh($f716e3e58d6e8629$var$Dh.current);
    var b = $f716e3e58d6e8629$var$Eh($f716e3e58d6e8629$var$Bh.current);
    var c = $f716e3e58d6e8629$var$kb(b, a.type);
    b !== c && ($f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Ch, a), $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$Bh, c));
}
function $f716e3e58d6e8629$var$Ih(a) {
    $f716e3e58d6e8629$var$Ch.current === a && ($f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Bh), $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Ch));
}
var $f716e3e58d6e8629$var$K = $f716e3e58d6e8629$var$Tf(0);
function $f716e3e58d6e8629$var$Jh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f716e3e58d6e8629$var$Kh = [];
function $f716e3e58d6e8629$var$Lh() {
    for(var a = 0; a < $f716e3e58d6e8629$var$Kh.length; a++)$f716e3e58d6e8629$var$Kh[a]._workInProgressVersionPrimary = null;
    $f716e3e58d6e8629$var$Kh.length = 0;
}
var $f716e3e58d6e8629$var$Mh = $f716e3e58d6e8629$var$ta.ReactCurrentDispatcher, $f716e3e58d6e8629$var$Nh = $f716e3e58d6e8629$var$ta.ReactCurrentBatchConfig, $f716e3e58d6e8629$var$Oh = 0, $f716e3e58d6e8629$var$L = null, $f716e3e58d6e8629$var$M = null, $f716e3e58d6e8629$var$N = null, $f716e3e58d6e8629$var$Ph = !1, $f716e3e58d6e8629$var$Qh = !1, $f716e3e58d6e8629$var$Rh = 0, $f716e3e58d6e8629$var$Sh = 0;
function $f716e3e58d6e8629$var$O() {
    throw Error($f716e3e58d6e8629$var$p(321));
}
function $f716e3e58d6e8629$var$Th(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f716e3e58d6e8629$var$Ge(a[c], b[c])) return !1;
    return !0;
}
function $f716e3e58d6e8629$var$Uh(a, b, c, d, e, f) {
    $f716e3e58d6e8629$var$Oh = f;
    $f716e3e58d6e8629$var$L = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f716e3e58d6e8629$var$Mh.current = null === a || null === a.memoizedState ? $f716e3e58d6e8629$var$Vh : $f716e3e58d6e8629$var$Wh;
    a = c(d, e);
    if ($f716e3e58d6e8629$var$Qh) {
        f = 0;
        do {
            $f716e3e58d6e8629$var$Qh = !1;
            $f716e3e58d6e8629$var$Rh = 0;
            if (25 <= f) throw Error($f716e3e58d6e8629$var$p(301));
            f += 1;
            $f716e3e58d6e8629$var$N = $f716e3e58d6e8629$var$M = null;
            b.updateQueue = null;
            $f716e3e58d6e8629$var$Mh.current = $f716e3e58d6e8629$var$Xh;
            a = c(d, e);
        }while ($f716e3e58d6e8629$var$Qh);
    }
    $f716e3e58d6e8629$var$Mh.current = $f716e3e58d6e8629$var$Yh;
    b = null !== $f716e3e58d6e8629$var$M && null !== $f716e3e58d6e8629$var$M.next;
    $f716e3e58d6e8629$var$Oh = 0;
    $f716e3e58d6e8629$var$N = $f716e3e58d6e8629$var$M = $f716e3e58d6e8629$var$L = null;
    $f716e3e58d6e8629$var$Ph = !1;
    if (b) throw Error($f716e3e58d6e8629$var$p(300));
    return a;
}
function $f716e3e58d6e8629$var$Zh() {
    var a = 0 !== $f716e3e58d6e8629$var$Rh;
    $f716e3e58d6e8629$var$Rh = 0;
    return a;
}
function $f716e3e58d6e8629$var$$h() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f716e3e58d6e8629$var$N ? $f716e3e58d6e8629$var$L.memoizedState = $f716e3e58d6e8629$var$N = a : $f716e3e58d6e8629$var$N = $f716e3e58d6e8629$var$N.next = a;
    return $f716e3e58d6e8629$var$N;
}
function $f716e3e58d6e8629$var$ai() {
    if (null === $f716e3e58d6e8629$var$M) {
        var a = $f716e3e58d6e8629$var$L.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f716e3e58d6e8629$var$M.next;
    var b = null === $f716e3e58d6e8629$var$N ? $f716e3e58d6e8629$var$L.memoizedState : $f716e3e58d6e8629$var$N.next;
    if (null !== b) $f716e3e58d6e8629$var$N = b, $f716e3e58d6e8629$var$M = a;
    else {
        if (null === a) throw Error($f716e3e58d6e8629$var$p(310));
        $f716e3e58d6e8629$var$M = a;
        a = {
            memoizedState: $f716e3e58d6e8629$var$M.memoizedState,
            baseState: $f716e3e58d6e8629$var$M.baseState,
            baseQueue: $f716e3e58d6e8629$var$M.baseQueue,
            queue: $f716e3e58d6e8629$var$M.queue,
            next: null
        };
        null === $f716e3e58d6e8629$var$N ? $f716e3e58d6e8629$var$L.memoizedState = $f716e3e58d6e8629$var$N = a : $f716e3e58d6e8629$var$N = $f716e3e58d6e8629$var$N.next = a;
    }
    return $f716e3e58d6e8629$var$N;
}
function $f716e3e58d6e8629$var$bi(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f716e3e58d6e8629$var$ci(a) {
    var b = $f716e3e58d6e8629$var$ai(), c = b.queue;
    if (null === c) throw Error($f716e3e58d6e8629$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f716e3e58d6e8629$var$M, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($f716e3e58d6e8629$var$Oh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var u = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = u, g = d) : k = k.next = u;
                $f716e3e58d6e8629$var$L.lanes |= n;
                $f716e3e58d6e8629$var$Fg |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f716e3e58d6e8629$var$Ge(d, b.memoizedState) || ($f716e3e58d6e8629$var$tg = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f716e3e58d6e8629$var$L.lanes |= f, $f716e3e58d6e8629$var$Fg |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f716e3e58d6e8629$var$di(a) {
    var b = $f716e3e58d6e8629$var$ai(), c = b.queue;
    if (null === c) throw Error($f716e3e58d6e8629$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f716e3e58d6e8629$var$Ge(f, b.memoizedState) || ($f716e3e58d6e8629$var$tg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f716e3e58d6e8629$var$ei() {}
function $f716e3e58d6e8629$var$fi(a, b) {
    var c = $f716e3e58d6e8629$var$L, d = $f716e3e58d6e8629$var$ai(), e = b(), f = !$f716e3e58d6e8629$var$Ge(d.memoizedState, e);
    f && (d.memoizedState = e, $f716e3e58d6e8629$var$tg = !0);
    d = d.queue;
    $f716e3e58d6e8629$var$gi($f716e3e58d6e8629$var$hi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f716e3e58d6e8629$var$N && $f716e3e58d6e8629$var$N.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f716e3e58d6e8629$var$ii(9, $f716e3e58d6e8629$var$ji.bind(null, c, d, e, b), void 0, null);
        if (null === $f716e3e58d6e8629$var$P) throw Error($f716e3e58d6e8629$var$p(349));
        0 !== ($f716e3e58d6e8629$var$Oh & 30) || $f716e3e58d6e8629$var$ki(c, b, e);
    }
    return e;
}
function $f716e3e58d6e8629$var$ki(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f716e3e58d6e8629$var$L.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f716e3e58d6e8629$var$L.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f716e3e58d6e8629$var$ji(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f716e3e58d6e8629$var$li(b) && $f716e3e58d6e8629$var$Lg(a, 1, -1);
}
function $f716e3e58d6e8629$var$hi(a, b, c) {
    return c(function() {
        $f716e3e58d6e8629$var$li(b) && $f716e3e58d6e8629$var$Lg(a, 1, -1);
    });
}
function $f716e3e58d6e8629$var$li(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f716e3e58d6e8629$var$Ge(a, c);
    } catch (d) {
        return !0;
    }
}
function $f716e3e58d6e8629$var$mi(a) {
    var b = $f716e3e58d6e8629$var$$h();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f716e3e58d6e8629$var$bi,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f716e3e58d6e8629$var$ni.bind(null, $f716e3e58d6e8629$var$L, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f716e3e58d6e8629$var$ii(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f716e3e58d6e8629$var$L.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f716e3e58d6e8629$var$L.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f716e3e58d6e8629$var$oi() {
    return $f716e3e58d6e8629$var$ai().memoizedState;
}
function $f716e3e58d6e8629$var$pi(a, b, c, d) {
    var e = $f716e3e58d6e8629$var$$h();
    $f716e3e58d6e8629$var$L.flags |= a;
    e.memoizedState = $f716e3e58d6e8629$var$ii(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f716e3e58d6e8629$var$qi(a, b, c, d) {
    var e = $f716e3e58d6e8629$var$ai();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f716e3e58d6e8629$var$M) {
        var g = $f716e3e58d6e8629$var$M.memoizedState;
        f = g.destroy;
        if (null !== d && $f716e3e58d6e8629$var$Th(d, g.deps)) {
            e.memoizedState = $f716e3e58d6e8629$var$ii(b, c, f, d);
            return;
        }
    }
    $f716e3e58d6e8629$var$L.flags |= a;
    e.memoizedState = $f716e3e58d6e8629$var$ii(1 | b, c, f, d);
}
function $f716e3e58d6e8629$var$ri(a, b) {
    return $f716e3e58d6e8629$var$pi(8390656, 8, a, b);
}
function $f716e3e58d6e8629$var$gi(a, b) {
    return $f716e3e58d6e8629$var$qi(2048, 8, a, b);
}
function $f716e3e58d6e8629$var$si(a, b) {
    return $f716e3e58d6e8629$var$qi(4, 2, a, b);
}
function $f716e3e58d6e8629$var$ti(a, b) {
    return $f716e3e58d6e8629$var$qi(4, 4, a, b);
}
function $f716e3e58d6e8629$var$ui(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f716e3e58d6e8629$var$vi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f716e3e58d6e8629$var$qi(4, 4, $f716e3e58d6e8629$var$ui.bind(null, b, a), c);
}
function $f716e3e58d6e8629$var$wi() {}
function $f716e3e58d6e8629$var$xi(a, b) {
    var c = $f716e3e58d6e8629$var$ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f716e3e58d6e8629$var$Th(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f716e3e58d6e8629$var$yi(a, b) {
    var c = $f716e3e58d6e8629$var$ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f716e3e58d6e8629$var$Th(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f716e3e58d6e8629$var$zi(a, b, c) {
    if (0 === ($f716e3e58d6e8629$var$Oh & 21)) return a.baseState && (a.baseState = !1, $f716e3e58d6e8629$var$tg = !0), a.memoizedState = c;
    $f716e3e58d6e8629$var$Ge(c, b) || (c = $f716e3e58d6e8629$var$xc(), $f716e3e58d6e8629$var$L.lanes |= c, $f716e3e58d6e8629$var$Fg |= c, a.baseState = !0);
    return b;
}
function $f716e3e58d6e8629$var$Ai(a, b) {
    var c = $f716e3e58d6e8629$var$C;
    $f716e3e58d6e8629$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f716e3e58d6e8629$var$Nh.transition;
    $f716e3e58d6e8629$var$Nh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f716e3e58d6e8629$var$C = c, $f716e3e58d6e8629$var$Nh.transition = d;
    }
}
function $f716e3e58d6e8629$var$Bi() {
    return $f716e3e58d6e8629$var$ai().memoizedState;
}
function $f716e3e58d6e8629$var$Ci(a, b, c) {
    var d = $f716e3e58d6e8629$var$Kg(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $f716e3e58d6e8629$var$Di(a) ? $f716e3e58d6e8629$var$Ei(b, c) : ($f716e3e58d6e8629$var$Fi(a, b, c), c = $f716e3e58d6e8629$var$Jg(), a = $f716e3e58d6e8629$var$Lg(a, d, c), null !== a && $f716e3e58d6e8629$var$Gi(a, b, d));
}
function $f716e3e58d6e8629$var$ni(a, b, c) {
    var d = $f716e3e58d6e8629$var$Kg(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f716e3e58d6e8629$var$Di(a)) $f716e3e58d6e8629$var$Ei(b, e);
    else {
        $f716e3e58d6e8629$var$Fi(a, b, e);
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f716e3e58d6e8629$var$Ge(h, g)) return;
        } catch (k) {} finally{}
        c = $f716e3e58d6e8629$var$Jg();
        a = $f716e3e58d6e8629$var$Lg(a, d, c);
        null !== a && $f716e3e58d6e8629$var$Gi(a, b, d);
    }
}
function $f716e3e58d6e8629$var$Di(a) {
    var b = a.alternate;
    return a === $f716e3e58d6e8629$var$L || null !== b && b === $f716e3e58d6e8629$var$L;
}
function $f716e3e58d6e8629$var$Ei(a, b) {
    $f716e3e58d6e8629$var$Qh = $f716e3e58d6e8629$var$Ph = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f716e3e58d6e8629$var$Fi(a, b, c) {
    $f716e3e58d6e8629$var$Bg(a) ? (a = b.interleaved, null === a ? (c.next = c, null === $f716e3e58d6e8629$var$vg ? $f716e3e58d6e8629$var$vg = [
        b
    ] : $f716e3e58d6e8629$var$vg.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
}
function $f716e3e58d6e8629$var$Gi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f716e3e58d6e8629$var$Bc(a, c);
    }
}
var $f716e3e58d6e8629$var$Yh = {
    readContext: $f716e3e58d6e8629$var$ug,
    useCallback: $f716e3e58d6e8629$var$O,
    useContext: $f716e3e58d6e8629$var$O,
    useEffect: $f716e3e58d6e8629$var$O,
    useImperativeHandle: $f716e3e58d6e8629$var$O,
    useInsertionEffect: $f716e3e58d6e8629$var$O,
    useLayoutEffect: $f716e3e58d6e8629$var$O,
    useMemo: $f716e3e58d6e8629$var$O,
    useReducer: $f716e3e58d6e8629$var$O,
    useRef: $f716e3e58d6e8629$var$O,
    useState: $f716e3e58d6e8629$var$O,
    useDebugValue: $f716e3e58d6e8629$var$O,
    useDeferredValue: $f716e3e58d6e8629$var$O,
    useTransition: $f716e3e58d6e8629$var$O,
    useMutableSource: $f716e3e58d6e8629$var$O,
    useSyncExternalStore: $f716e3e58d6e8629$var$O,
    useId: $f716e3e58d6e8629$var$O,
    unstable_isNewReconciler: !1
}, $f716e3e58d6e8629$var$Vh = {
    readContext: $f716e3e58d6e8629$var$ug,
    useCallback: function(a, b) {
        $f716e3e58d6e8629$var$$h().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f716e3e58d6e8629$var$ug,
    useEffect: $f716e3e58d6e8629$var$ri,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f716e3e58d6e8629$var$pi(4194308, 4, $f716e3e58d6e8629$var$ui.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f716e3e58d6e8629$var$pi(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f716e3e58d6e8629$var$pi(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f716e3e58d6e8629$var$$h();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f716e3e58d6e8629$var$$h();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f716e3e58d6e8629$var$Ci.bind(null, $f716e3e58d6e8629$var$L, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f716e3e58d6e8629$var$$h();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f716e3e58d6e8629$var$mi,
    useDebugValue: $f716e3e58d6e8629$var$wi,
    useDeferredValue: function(a) {
        return $f716e3e58d6e8629$var$$h().memoizedState = a;
    },
    useTransition: function() {
        var a = $f716e3e58d6e8629$var$mi(!1), b = a[0];
        a = $f716e3e58d6e8629$var$Ai.bind(null, a[1]);
        $f716e3e58d6e8629$var$$h().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f716e3e58d6e8629$var$L, e = $f716e3e58d6e8629$var$$h();
        if ($f716e3e58d6e8629$var$I) {
            if (void 0 === c) throw Error($f716e3e58d6e8629$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f716e3e58d6e8629$var$P) throw Error($f716e3e58d6e8629$var$p(349));
            0 !== ($f716e3e58d6e8629$var$Oh & 30) || $f716e3e58d6e8629$var$ki(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f716e3e58d6e8629$var$ri($f716e3e58d6e8629$var$hi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f716e3e58d6e8629$var$ii(9, $f716e3e58d6e8629$var$ji.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f716e3e58d6e8629$var$$h(), b = $f716e3e58d6e8629$var$P.identifierPrefix;
        if ($f716e3e58d6e8629$var$I) {
            var c = $f716e3e58d6e8629$var$Zg;
            var d = $f716e3e58d6e8629$var$Yg;
            c = (d & ~(1 << 32 - $f716e3e58d6e8629$var$nc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f716e3e58d6e8629$var$Rh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f716e3e58d6e8629$var$Sh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f716e3e58d6e8629$var$Wh = {
    readContext: $f716e3e58d6e8629$var$ug,
    useCallback: $f716e3e58d6e8629$var$xi,
    useContext: $f716e3e58d6e8629$var$ug,
    useEffect: $f716e3e58d6e8629$var$gi,
    useImperativeHandle: $f716e3e58d6e8629$var$vi,
    useInsertionEffect: $f716e3e58d6e8629$var$si,
    useLayoutEffect: $f716e3e58d6e8629$var$ti,
    useMemo: $f716e3e58d6e8629$var$yi,
    useReducer: $f716e3e58d6e8629$var$ci,
    useRef: $f716e3e58d6e8629$var$oi,
    useState: function() {
        return $f716e3e58d6e8629$var$ci($f716e3e58d6e8629$var$bi);
    },
    useDebugValue: $f716e3e58d6e8629$var$wi,
    useDeferredValue: function(a) {
        var b = $f716e3e58d6e8629$var$ai();
        return $f716e3e58d6e8629$var$zi(b, $f716e3e58d6e8629$var$M.memoizedState, a);
    },
    useTransition: function() {
        var a = $f716e3e58d6e8629$var$ci($f716e3e58d6e8629$var$bi)[0], b = $f716e3e58d6e8629$var$ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f716e3e58d6e8629$var$ei,
    useSyncExternalStore: $f716e3e58d6e8629$var$fi,
    useId: $f716e3e58d6e8629$var$Bi,
    unstable_isNewReconciler: !1
}, $f716e3e58d6e8629$var$Xh = {
    readContext: $f716e3e58d6e8629$var$ug,
    useCallback: $f716e3e58d6e8629$var$xi,
    useContext: $f716e3e58d6e8629$var$ug,
    useEffect: $f716e3e58d6e8629$var$gi,
    useImperativeHandle: $f716e3e58d6e8629$var$vi,
    useInsertionEffect: $f716e3e58d6e8629$var$si,
    useLayoutEffect: $f716e3e58d6e8629$var$ti,
    useMemo: $f716e3e58d6e8629$var$yi,
    useReducer: $f716e3e58d6e8629$var$di,
    useRef: $f716e3e58d6e8629$var$oi,
    useState: function() {
        return $f716e3e58d6e8629$var$di($f716e3e58d6e8629$var$bi);
    },
    useDebugValue: $f716e3e58d6e8629$var$wi,
    useDeferredValue: function(a) {
        var b = $f716e3e58d6e8629$var$ai();
        return null === $f716e3e58d6e8629$var$M ? b.memoizedState = a : $f716e3e58d6e8629$var$zi(b, $f716e3e58d6e8629$var$M.memoizedState, a);
    },
    useTransition: function() {
        var a = $f716e3e58d6e8629$var$di($f716e3e58d6e8629$var$bi)[0], b = $f716e3e58d6e8629$var$ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f716e3e58d6e8629$var$ei,
    useSyncExternalStore: $f716e3e58d6e8629$var$fi,
    useId: $f716e3e58d6e8629$var$Bi,
    unstable_isNewReconciler: !1
};
function $f716e3e58d6e8629$var$Hi(a, b) {
    try {
        var c = "", d = b;
        do c += $f716e3e58d6e8629$var$Oa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $f716e3e58d6e8629$var$Ii(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f716e3e58d6e8629$var$Ji = "function" === typeof WeakMap ? WeakMap : Map;
function $f716e3e58d6e8629$var$Ki(a, b, c) {
    c = $f716e3e58d6e8629$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f716e3e58d6e8629$var$Li || ($f716e3e58d6e8629$var$Li = !0, $f716e3e58d6e8629$var$Mi = d);
        $f716e3e58d6e8629$var$Ii(a, b);
    };
    return c;
}
function $f716e3e58d6e8629$var$Ni(a, b, c) {
    c = $f716e3e58d6e8629$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f716e3e58d6e8629$var$Ii(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f716e3e58d6e8629$var$Ii(a, b);
        "function" !== typeof d && (null === $f716e3e58d6e8629$var$Oi ? $f716e3e58d6e8629$var$Oi = new Set([
            this
        ]) : $f716e3e58d6e8629$var$Oi.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f716e3e58d6e8629$var$Pi(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f716e3e58d6e8629$var$Ji;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f716e3e58d6e8629$var$Qi.bind(null, a, b, c), b.then(a, a));
}
function $f716e3e58d6e8629$var$Ri(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f716e3e58d6e8629$var$Si(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f716e3e58d6e8629$var$zg(-1, 1), b.tag = 2, $f716e3e58d6e8629$var$Ag(c, b))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f716e3e58d6e8629$var$Ti, $f716e3e58d6e8629$var$Ui, $f716e3e58d6e8629$var$Vi, $f716e3e58d6e8629$var$Wi;
$f716e3e58d6e8629$var$Ti = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f716e3e58d6e8629$var$Ui = function() {};
$f716e3e58d6e8629$var$Vi = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f716e3e58d6e8629$var$Eh($f716e3e58d6e8629$var$Bh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f716e3e58d6e8629$var$Xa(a, e);
                d = $f716e3e58d6e8629$var$Xa(a, d);
                f = [];
                break;
            case "select":
                e = $f716e3e58d6e8629$var$A({}, e, {
                    value: void 0
                });
                d = $f716e3e58d6e8629$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f716e3e58d6e8629$var$fb(a, e);
                d = $f716e3e58d6e8629$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f716e3e58d6e8629$var$Af);
        }
        $f716e3e58d6e8629$var$tb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f716e3e58d6e8629$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f716e3e58d6e8629$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f716e3e58d6e8629$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f716e3e58d6e8629$var$Wi = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f716e3e58d6e8629$var$Xi(a, b) {
    if (!$f716e3e58d6e8629$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f716e3e58d6e8629$var$Q(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f716e3e58d6e8629$var$Yi(a, b, c) {
    var d = b.pendingProps;
    $f716e3e58d6e8629$var$ch(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f716e3e58d6e8629$var$Q(b), null;
        case 1:
            return $f716e3e58d6e8629$var$Yf(b.type) && $f716e3e58d6e8629$var$Zf(), $f716e3e58d6e8629$var$Q(b), null;
        case 3:
            d = b.stateNode;
            $f716e3e58d6e8629$var$Gh();
            $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Vf);
            $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$H);
            $f716e3e58d6e8629$var$Lh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f716e3e58d6e8629$var$mh(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f716e3e58d6e8629$var$fh && ($f716e3e58d6e8629$var$Zi($f716e3e58d6e8629$var$fh), $f716e3e58d6e8629$var$fh = null));
            $f716e3e58d6e8629$var$Ui(a, b);
            $f716e3e58d6e8629$var$Q(b);
            return null;
        case 5:
            $f716e3e58d6e8629$var$Ih(b);
            var e = $f716e3e58d6e8629$var$Eh($f716e3e58d6e8629$var$Dh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f716e3e58d6e8629$var$Vi(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f716e3e58d6e8629$var$p(166));
                    $f716e3e58d6e8629$var$Q(b);
                    return null;
                }
                a = $f716e3e58d6e8629$var$Eh($f716e3e58d6e8629$var$Bh.current);
                if ($f716e3e58d6e8629$var$mh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f716e3e58d6e8629$var$Nf] = b;
                    d[$f716e3e58d6e8629$var$Of] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f716e3e58d6e8629$var$D("cancel", d);
                            $f716e3e58d6e8629$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f716e3e58d6e8629$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f716e3e58d6e8629$var$kf.length; e++)$f716e3e58d6e8629$var$D($f716e3e58d6e8629$var$kf[e], d);
                            break;
                        case "source":
                            $f716e3e58d6e8629$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f716e3e58d6e8629$var$D("error", d);
                            $f716e3e58d6e8629$var$D("load", d);
                            break;
                        case "details":
                            $f716e3e58d6e8629$var$D("toggle", d);
                            break;
                        case "input":
                            $f716e3e58d6e8629$var$Ya(d, f);
                            $f716e3e58d6e8629$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f716e3e58d6e8629$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f716e3e58d6e8629$var$gb(d, f), $f716e3e58d6e8629$var$D("invalid", d);
                    }
                    $f716e3e58d6e8629$var$tb(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f716e3e58d6e8629$var$zf(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f716e3e58d6e8629$var$zf(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f716e3e58d6e8629$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f716e3e58d6e8629$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f716e3e58d6e8629$var$Ua(d);
                            $f716e3e58d6e8629$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $f716e3e58d6e8629$var$Ua(d);
                            $f716e3e58d6e8629$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f716e3e58d6e8629$var$Af);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f716e3e58d6e8629$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f716e3e58d6e8629$var$Nf] = b;
                    a[$f716e3e58d6e8629$var$Of] = d;
                    $f716e3e58d6e8629$var$Ti(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f716e3e58d6e8629$var$ub(c, d);
                        switch(c){
                            case "dialog":
                                $f716e3e58d6e8629$var$D("cancel", a);
                                $f716e3e58d6e8629$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f716e3e58d6e8629$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f716e3e58d6e8629$var$kf.length; e++)$f716e3e58d6e8629$var$D($f716e3e58d6e8629$var$kf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f716e3e58d6e8629$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f716e3e58d6e8629$var$D("error", a);
                                $f716e3e58d6e8629$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f716e3e58d6e8629$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f716e3e58d6e8629$var$Ya(a, d);
                                e = $f716e3e58d6e8629$var$Xa(a, d);
                                $f716e3e58d6e8629$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f716e3e58d6e8629$var$A({}, d, {
                                    value: void 0
                                });
                                $f716e3e58d6e8629$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f716e3e58d6e8629$var$gb(a, d);
                                e = $f716e3e58d6e8629$var$fb(a, d);
                                $f716e3e58d6e8629$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f716e3e58d6e8629$var$tb(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f716e3e58d6e8629$var$rb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f716e3e58d6e8629$var$mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f716e3e58d6e8629$var$nb(a, k) : "number" === typeof k && $f716e3e58d6e8629$var$nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f716e3e58d6e8629$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f716e3e58d6e8629$var$D("scroll", a) : null != k && $f716e3e58d6e8629$var$sa(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f716e3e58d6e8629$var$Ua(a);
                                $f716e3e58d6e8629$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $f716e3e58d6e8629$var$Ua(a);
                                $f716e3e58d6e8629$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f716e3e58d6e8629$var$Ra(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f716e3e58d6e8629$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f716e3e58d6e8629$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f716e3e58d6e8629$var$Af);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f716e3e58d6e8629$var$Q(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f716e3e58d6e8629$var$Wi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f716e3e58d6e8629$var$p(166));
                c = $f716e3e58d6e8629$var$Eh($f716e3e58d6e8629$var$Dh.current);
                $f716e3e58d6e8629$var$Eh($f716e3e58d6e8629$var$Bh.current);
                if ($f716e3e58d6e8629$var$mh(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f716e3e58d6e8629$var$Nf] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f716e3e58d6e8629$var$dh, null !== a) switch(a.tag){
                            case 3:
                                $f716e3e58d6e8629$var$zf(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f716e3e58d6e8629$var$zf(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f716e3e58d6e8629$var$Nf] = b, b.stateNode = d;
            }
            $f716e3e58d6e8629$var$Q(b);
            return null;
        case 13:
            $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$K);
            d = b.memoizedState;
            if ($f716e3e58d6e8629$var$I && null !== $f716e3e58d6e8629$var$eh && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                for(d = $f716e3e58d6e8629$var$eh; d;)d = $f716e3e58d6e8629$var$Kf(d.nextSibling);
                $f716e3e58d6e8629$var$nh();
                b.flags |= 98560;
                return b;
            }
            if (null !== d && null !== d.dehydrated) {
                d = $f716e3e58d6e8629$var$mh(b);
                if (null === a) {
                    if (!d) throw Error($f716e3e58d6e8629$var$p(318));
                    d = b.memoizedState;
                    d = null !== d ? d.dehydrated : null;
                    if (!d) throw Error($f716e3e58d6e8629$var$p(317));
                    d[$f716e3e58d6e8629$var$Nf] = b;
                } else $f716e3e58d6e8629$var$nh(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                $f716e3e58d6e8629$var$Q(b);
                return null;
            }
            null !== $f716e3e58d6e8629$var$fh && ($f716e3e58d6e8629$var$Zi($f716e3e58d6e8629$var$fh), $f716e3e58d6e8629$var$fh = null);
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? $f716e3e58d6e8629$var$mh(b) : c = null !== a.memoizedState;
            d !== c && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f716e3e58d6e8629$var$K.current & 1) ? 0 === $f716e3e58d6e8629$var$R && ($f716e3e58d6e8629$var$R = 3) : $f716e3e58d6e8629$var$$i()));
            null !== b.updateQueue && (b.flags |= 4);
            $f716e3e58d6e8629$var$Q(b);
            return null;
        case 4:
            return $f716e3e58d6e8629$var$Gh(), $f716e3e58d6e8629$var$Ui(a, b), null === a && $f716e3e58d6e8629$var$rf(b.stateNode.containerInfo), $f716e3e58d6e8629$var$Q(b), null;
        case 10:
            return $f716e3e58d6e8629$var$qg(b.type._context), $f716e3e58d6e8629$var$Q(b), null;
        case 17:
            return $f716e3e58d6e8629$var$Yf(b.type) && $f716e3e58d6e8629$var$Zf(), $f716e3e58d6e8629$var$Q(b), null;
        case 19:
            $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$K);
            f = b.memoizedState;
            if (null === f) return $f716e3e58d6e8629$var$Q(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f716e3e58d6e8629$var$Xi(f, !1);
                else {
                    if (0 !== $f716e3e58d6e8629$var$R || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f716e3e58d6e8629$var$Jh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f716e3e58d6e8629$var$Xi(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, $f716e3e58d6e8629$var$K.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f716e3e58d6e8629$var$B() > $f716e3e58d6e8629$var$aj && (b.flags |= 128, d = !0, $f716e3e58d6e8629$var$Xi(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f716e3e58d6e8629$var$Jh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f716e3e58d6e8629$var$Xi(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f716e3e58d6e8629$var$I) return $f716e3e58d6e8629$var$Q(b), null;
                    } else 2 * $f716e3e58d6e8629$var$B() - f.renderingStartTime > $f716e3e58d6e8629$var$aj && 1073741824 !== c && (b.flags |= 128, d = !0, $f716e3e58d6e8629$var$Xi(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f716e3e58d6e8629$var$B(), b.sibling = null, c = $f716e3e58d6e8629$var$K.current, $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, d ? c & 1 | 2 : c & 1), b;
            $f716e3e58d6e8629$var$Q(b);
            return null;
        case 22:
        case 23:
            return $f716e3e58d6e8629$var$bj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f716e3e58d6e8629$var$cj & 1073741824) && ($f716e3e58d6e8629$var$Q(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f716e3e58d6e8629$var$Q(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f716e3e58d6e8629$var$p(156, b.tag));
}
var $f716e3e58d6e8629$var$dj = $f716e3e58d6e8629$var$ta.ReactCurrentOwner, $f716e3e58d6e8629$var$tg = !1;
function $f716e3e58d6e8629$var$ej(a, b, c, d) {
    b.child = null === a ? $f716e3e58d6e8629$var$zh(b, null, c, d) : $f716e3e58d6e8629$var$yh(b, a.child, c, d);
}
function $f716e3e58d6e8629$var$fj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f716e3e58d6e8629$var$sg(b, e);
    d = $f716e3e58d6e8629$var$Uh(a, b, c, d, f, e);
    c = $f716e3e58d6e8629$var$Zh();
    if (null !== a && !$f716e3e58d6e8629$var$tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f716e3e58d6e8629$var$gj(a, b, e);
    $f716e3e58d6e8629$var$I && c && $f716e3e58d6e8629$var$bh(b);
    b.flags |= 1;
    $f716e3e58d6e8629$var$ej(a, b, d, e);
    return b.child;
}
function $f716e3e58d6e8629$var$hj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f716e3e58d6e8629$var$ij(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f716e3e58d6e8629$var$jj(a, b, f, d, e);
        a = $f716e3e58d6e8629$var$vh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f716e3e58d6e8629$var$He;
        if (c(g, d) && a.ref === b.ref) return $f716e3e58d6e8629$var$gj(a, b, e);
    }
    b.flags |= 1;
    a = $f716e3e58d6e8629$var$th(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f716e3e58d6e8629$var$jj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f716e3e58d6e8629$var$He(f, d) && a.ref === b.ref) {
            if ($f716e3e58d6e8629$var$tg = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f716e3e58d6e8629$var$tg = !0);
            else return b.lanes = a.lanes, $f716e3e58d6e8629$var$gj(a, b, e);
        }
    }
    return $f716e3e58d6e8629$var$kj(a, b, c, d, e);
}
function $f716e3e58d6e8629$var$lj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$mj, $f716e3e58d6e8629$var$cj), $f716e3e58d6e8629$var$cj |= c;
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, d = null !== f ? f.baseLanes : c, $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$mj, $f716e3e58d6e8629$var$cj), $f716e3e58d6e8629$var$cj |= d;
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a,
            cachePool: null,
            transitions: null
        }, b.updateQueue = null, $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$mj, $f716e3e58d6e8629$var$cj), $f716e3e58d6e8629$var$cj |= a, null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$mj, $f716e3e58d6e8629$var$cj), $f716e3e58d6e8629$var$cj |= d;
    $f716e3e58d6e8629$var$ej(a, b, e, c);
    return b.child;
}
function $f716e3e58d6e8629$var$nj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f716e3e58d6e8629$var$kj(a, b, c, d, e) {
    var f = $f716e3e58d6e8629$var$Yf(c) ? $f716e3e58d6e8629$var$Wf : $f716e3e58d6e8629$var$H.current;
    f = $f716e3e58d6e8629$var$Xf(b, f);
    $f716e3e58d6e8629$var$sg(b, e);
    c = $f716e3e58d6e8629$var$Uh(a, b, c, d, f, e);
    d = $f716e3e58d6e8629$var$Zh();
    if (null !== a && !$f716e3e58d6e8629$var$tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f716e3e58d6e8629$var$gj(a, b, e);
    $f716e3e58d6e8629$var$I && d && $f716e3e58d6e8629$var$bh(b);
    b.flags |= 1;
    $f716e3e58d6e8629$var$ej(a, b, c, e);
    return b.child;
}
function $f716e3e58d6e8629$var$oj(a, b, c, d, e) {
    if ($f716e3e58d6e8629$var$Yf(c)) {
        var f = !0;
        $f716e3e58d6e8629$var$bg(b);
    } else f = !1;
    $f716e3e58d6e8629$var$sg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $f716e3e58d6e8629$var$Og(b, c, d), $f716e3e58d6e8629$var$Qg(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f716e3e58d6e8629$var$ug(l) : (l = $f716e3e58d6e8629$var$Yf(c) ? $f716e3e58d6e8629$var$Wf : $f716e3e58d6e8629$var$H.current, l = $f716e3e58d6e8629$var$Xf(b, l));
        var n = c.getDerivedStateFromProps, u = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        u || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f716e3e58d6e8629$var$Pg(b, g, d, l);
        $f716e3e58d6e8629$var$wg = !1;
        var q = b.memoizedState;
        g.state = q;
        $f716e3e58d6e8629$var$Eg(b, d, g, e);
        k = b.memoizedState;
        h !== d || q !== k || $f716e3e58d6e8629$var$Vf.current || $f716e3e58d6e8629$var$wg ? ("function" === typeof n && ($f716e3e58d6e8629$var$Ig(b, c, n, d), k = b.memoizedState), (h = $f716e3e58d6e8629$var$wg || $f716e3e58d6e8629$var$Ng(b, c, h, d, q, k, l)) ? (u || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f716e3e58d6e8629$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f716e3e58d6e8629$var$kg(b.type, h);
        g.props = l;
        u = b.pendingProps;
        q = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f716e3e58d6e8629$var$ug(k) : (k = $f716e3e58d6e8629$var$Yf(c) ? $f716e3e58d6e8629$var$Wf : $f716e3e58d6e8629$var$H.current, k = $f716e3e58d6e8629$var$Xf(b, k));
        var y = c.getDerivedStateFromProps;
        (n = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== u || q !== k) && $f716e3e58d6e8629$var$Pg(b, g, d, k);
        $f716e3e58d6e8629$var$wg = !1;
        q = b.memoizedState;
        g.state = q;
        $f716e3e58d6e8629$var$Eg(b, d, g, e);
        var m = b.memoizedState;
        h !== u || q !== m || $f716e3e58d6e8629$var$Vf.current || $f716e3e58d6e8629$var$wg ? ("function" === typeof y && ($f716e3e58d6e8629$var$Ig(b, c, y, d), m = b.memoizedState), (l = $f716e3e58d6e8629$var$wg || $f716e3e58d6e8629$var$Ng(b, c, l, d, q, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f716e3e58d6e8629$var$pj(a, b, c, d, f, e);
}
function $f716e3e58d6e8629$var$pj(a, b, c, d, e, f) {
    $f716e3e58d6e8629$var$nj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f716e3e58d6e8629$var$cg(b, c, !1), $f716e3e58d6e8629$var$gj(a, b, f);
    d = b.stateNode;
    $f716e3e58d6e8629$var$dj.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f716e3e58d6e8629$var$yh(b, a.child, null, f), b.child = $f716e3e58d6e8629$var$yh(b, null, h, f)) : $f716e3e58d6e8629$var$ej(a, b, h, f);
    b.memoizedState = d.state;
    e && $f716e3e58d6e8629$var$cg(b, c, !0);
    return b.child;
}
function $f716e3e58d6e8629$var$qj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f716e3e58d6e8629$var$$f(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f716e3e58d6e8629$var$$f(a, b.context, !1);
    $f716e3e58d6e8629$var$Fh(a, b.containerInfo);
}
function $f716e3e58d6e8629$var$rj(a, b, c, d, e) {
    $f716e3e58d6e8629$var$nh();
    $f716e3e58d6e8629$var$oh(e);
    b.flags |= 256;
    $f716e3e58d6e8629$var$ej(a, b, c, d);
    return b.child;
}
var $f716e3e58d6e8629$var$sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f716e3e58d6e8629$var$tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f716e3e58d6e8629$var$uj(a, b) {
    return {
        baseLanes: a.baseLanes | b,
        cachePool: null,
        transitions: a.transitions
    };
}
function $f716e3e58d6e8629$var$vj(a, b, c) {
    var d = b.pendingProps, e = $f716e3e58d6e8629$var$K.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, e & 1);
    if (null === a) {
        $f716e3e58d6e8629$var$kh(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        e = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, e = {
            mode: "hidden",
            children: e
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = $f716e3e58d6e8629$var$wj(e, d, 0, null), a = $f716e3e58d6e8629$var$xh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f716e3e58d6e8629$var$tj(c), b.memoizedState = $f716e3e58d6e8629$var$sj, a) : $f716e3e58d6e8629$var$xj(b, e);
    }
    e = a.memoizedState;
    if (null !== e) {
        h = e.dehydrated;
        if (null !== h) {
            if (g) {
                if (b.flags & 256) return b.flags &= -257, $f716e3e58d6e8629$var$yj(a, b, c, Error($f716e3e58d6e8629$var$p(422)));
                if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                f = d.fallback;
                e = b.mode;
                d = $f716e3e58d6e8629$var$wj({
                    mode: "visible",
                    children: d.children
                }, e, 0, null);
                f = $f716e3e58d6e8629$var$xh(f, e, c, null);
                f.flags |= 2;
                d.return = b;
                f.return = b;
                d.sibling = f;
                b.child = d;
                0 !== (b.mode & 1) && $f716e3e58d6e8629$var$yh(b, a.child, null, c);
                b.child.memoizedState = $f716e3e58d6e8629$var$tj(c);
                b.memoizedState = $f716e3e58d6e8629$var$sj;
                return f;
            }
            if (0 === (b.mode & 1)) b = $f716e3e58d6e8629$var$yj(a, b, c, null);
            else if ("$!" === h.data) b = $f716e3e58d6e8629$var$yj(a, b, c, Error($f716e3e58d6e8629$var$p(419)));
            else if (d = 0 !== (c & a.childLanes), $f716e3e58d6e8629$var$tg || d) {
                d = $f716e3e58d6e8629$var$P;
                if (null !== d) {
                    switch(c & -c){
                        case 4:
                            f = 2;
                            break;
                        case 16:
                            f = 8;
                            break;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            f = 32;
                            break;
                        case 536870912:
                            f = 268435456;
                            break;
                        default:
                            f = 0;
                    }
                    d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                    0 !== d && d !== e.retryLane && (e.retryLane = d, $f716e3e58d6e8629$var$Lg(a, d, -1));
                }
                $f716e3e58d6e8629$var$$i();
                b = $f716e3e58d6e8629$var$yj(a, b, c, Error($f716e3e58d6e8629$var$p(421)));
            } else "$?" === h.data ? (b.flags |= 128, b.child = a.child, b = $f716e3e58d6e8629$var$zj.bind(null, a), h._reactRetry = b, b = null) : (c = e.treeContext, $f716e3e58d6e8629$var$eh = $f716e3e58d6e8629$var$Kf(h.nextSibling), $f716e3e58d6e8629$var$dh = b, $f716e3e58d6e8629$var$I = !0, $f716e3e58d6e8629$var$fh = null, null !== c && ($f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg++] = $f716e3e58d6e8629$var$Yg, $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg++] = $f716e3e58d6e8629$var$Zg, $f716e3e58d6e8629$var$Vg[$f716e3e58d6e8629$var$Wg++] = $f716e3e58d6e8629$var$Xg, $f716e3e58d6e8629$var$Yg = c.id, $f716e3e58d6e8629$var$Zg = c.overflow, $f716e3e58d6e8629$var$Xg = b), b = $f716e3e58d6e8629$var$xj(b, b.pendingProps.children), b.flags |= 4096);
            return b;
        }
        if (f) return d = $f716e3e58d6e8629$var$Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? $f716e3e58d6e8629$var$tj(c) : $f716e3e58d6e8629$var$uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = $f716e3e58d6e8629$var$sj, d;
        c = $f716e3e58d6e8629$var$Bj(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $f716e3e58d6e8629$var$Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? $f716e3e58d6e8629$var$tj(c) : $f716e3e58d6e8629$var$uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = $f716e3e58d6e8629$var$sj, d;
    c = $f716e3e58d6e8629$var$Bj(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $f716e3e58d6e8629$var$xj(a, b) {
    b = $f716e3e58d6e8629$var$wj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f716e3e58d6e8629$var$Bj(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $f716e3e58d6e8629$var$th(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 1) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (d = b.deletions, null === d ? (b.deletions = [
        a
    ], b.flags |= 16) : d.push(a));
    return b.child = c;
}
function $f716e3e58d6e8629$var$Aj(a, b, c, d, e) {
    var f = b.mode;
    a = a.child;
    var g = a.sibling, h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = $f716e3e58d6e8629$var$th(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
    null !== g ? d = $f716e3e58d6e8629$var$th(g, d) : (d = $f716e3e58d6e8629$var$xh(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $f716e3e58d6e8629$var$yj(a, b, c, d) {
    null !== d && $f716e3e58d6e8629$var$oh(d);
    $f716e3e58d6e8629$var$yh(b, a.child, null, c);
    a = $f716e3e58d6e8629$var$xj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f716e3e58d6e8629$var$Cj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f716e3e58d6e8629$var$rg(a.return, b, c);
}
function $f716e3e58d6e8629$var$Dj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f716e3e58d6e8629$var$Ej(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f716e3e58d6e8629$var$ej(a, b, d.children, c);
    d = $f716e3e58d6e8629$var$K.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f716e3e58d6e8629$var$Cj(a, c, b);
            else if (19 === a.tag) $f716e3e58d6e8629$var$Cj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f716e3e58d6e8629$var$Jh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f716e3e58d6e8629$var$Dj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f716e3e58d6e8629$var$Jh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f716e3e58d6e8629$var$Dj(b, !0, c, null, f);
            break;
        case "together":
            $f716e3e58d6e8629$var$Dj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f716e3e58d6e8629$var$gj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f716e3e58d6e8629$var$Fg |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f716e3e58d6e8629$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f716e3e58d6e8629$var$th(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f716e3e58d6e8629$var$th(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f716e3e58d6e8629$var$Fj(a, b, c) {
    switch(b.tag){
        case 3:
            $f716e3e58d6e8629$var$qj(b);
            $f716e3e58d6e8629$var$nh();
            break;
        case 5:
            $f716e3e58d6e8629$var$Hh(b);
            break;
        case 1:
            $f716e3e58d6e8629$var$Yf(b.type) && $f716e3e58d6e8629$var$bg(b);
            break;
        case 4:
            $f716e3e58d6e8629$var$Fh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$lg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, $f716e3e58d6e8629$var$K.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f716e3e58d6e8629$var$vj(a, b, c);
                $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, $f716e3e58d6e8629$var$K.current & 1);
                a = $f716e3e58d6e8629$var$gj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, $f716e3e58d6e8629$var$K.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f716e3e58d6e8629$var$Ej(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$K, $f716e3e58d6e8629$var$K.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f716e3e58d6e8629$var$lj(a, b, c);
    }
    return $f716e3e58d6e8629$var$gj(a, b, c);
}
function $f716e3e58d6e8629$var$Gj(a, b) {
    $f716e3e58d6e8629$var$ch(b);
    switch(b.tag){
        case 1:
            return $f716e3e58d6e8629$var$Yf(b.type) && $f716e3e58d6e8629$var$Zf(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f716e3e58d6e8629$var$Gh(), $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Vf), $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$H), $f716e3e58d6e8629$var$Lh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f716e3e58d6e8629$var$Ih(b), null;
        case 13:
            $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$K);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f716e3e58d6e8629$var$p(340));
                $f716e3e58d6e8629$var$nh();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$K), null;
        case 4:
            return $f716e3e58d6e8629$var$Gh(), null;
        case 10:
            return $f716e3e58d6e8629$var$qg(b.type._context), null;
        case 22:
        case 23:
            return $f716e3e58d6e8629$var$bj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f716e3e58d6e8629$var$Hj = !1, $f716e3e58d6e8629$var$S = !1, $f716e3e58d6e8629$var$Ij = "function" === typeof WeakSet ? WeakSet : Set, $f716e3e58d6e8629$var$T = null;
function $f716e3e58d6e8629$var$Jj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f716e3e58d6e8629$var$U(a, b, d);
        }
        else c.current = null;
    }
}
function $f716e3e58d6e8629$var$Kj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f716e3e58d6e8629$var$U(a, b, d);
    }
}
var $f716e3e58d6e8629$var$Lj = !1;
function $f716e3e58d6e8629$var$Mj(a, b) {
    $f716e3e58d6e8629$var$Bf = $f716e3e58d6e8629$var$cd;
    a = $f716e3e58d6e8629$var$Le();
    if ($f716e3e58d6e8629$var$Me(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (Z) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, u = a, q = null;
                b: for(;;){
                    for(var y;;){
                        u !== c || 0 !== e && 3 !== u.nodeType || (h = g + e);
                        u !== f || 0 !== d && 3 !== u.nodeType || (k = g + d);
                        3 === u.nodeType && (g += u.nodeValue.length);
                        if (null === (y = u.firstChild)) break;
                        q = u;
                        u = y;
                    }
                    for(;;){
                        if (u === a) break b;
                        q === c && ++l === e && (h = g);
                        q === f && ++n === d && (k = g);
                        if (null !== (y = u.nextSibling)) break;
                        u = q;
                        q = u.parentNode;
                    }
                    u = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f716e3e58d6e8629$var$Cf = {
        focusedElem: a,
        selectionRange: c
    };
    $f716e3e58d6e8629$var$cd = !1;
    for($f716e3e58d6e8629$var$T = b; null !== $f716e3e58d6e8629$var$T;)if (b = $f716e3e58d6e8629$var$T, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f716e3e58d6e8629$var$T = a;
    else for(; null !== $f716e3e58d6e8629$var$T;){
        b = $f716e3e58d6e8629$var$T;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, J = m.memoizedState, v = b.stateNode, x = v.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $f716e3e58d6e8629$var$kg(b.type, w), J);
                        v.__reactInternalSnapshotBeforeUpdate = x;
                    }
                    break;
                case 3:
                    var r = b.stateNode.containerInfo;
                    if (1 === r.nodeType) r.textContent = "";
                    else if (9 === r.nodeType) {
                        var F = r.body;
                        null != F && (F.textContent = "");
                    }
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f716e3e58d6e8629$var$p(163));
            }
        } catch (Z) {
            $f716e3e58d6e8629$var$U(b, b.return, Z);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f716e3e58d6e8629$var$T = a;
            break;
        }
        $f716e3e58d6e8629$var$T = b.return;
    }
    m = $f716e3e58d6e8629$var$Lj;
    $f716e3e58d6e8629$var$Lj = !1;
    return m;
}
function $f716e3e58d6e8629$var$Nj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f716e3e58d6e8629$var$Kj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f716e3e58d6e8629$var$Oj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f716e3e58d6e8629$var$Pj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f716e3e58d6e8629$var$Qj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f716e3e58d6e8629$var$Qj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f716e3e58d6e8629$var$Nf], delete b[$f716e3e58d6e8629$var$Of], delete b[$f716e3e58d6e8629$var$nf], delete b[$f716e3e58d6e8629$var$Pf], delete b[$f716e3e58d6e8629$var$Qf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f716e3e58d6e8629$var$Rj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f716e3e58d6e8629$var$Sj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f716e3e58d6e8629$var$Rj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f716e3e58d6e8629$var$Tj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f716e3e58d6e8629$var$Af));
    else if (4 !== d && (a = a.child, null !== a)) for($f716e3e58d6e8629$var$Tj(a, b, c), a = a.sibling; null !== a;)$f716e3e58d6e8629$var$Tj(a, b, c), a = a.sibling;
}
function $f716e3e58d6e8629$var$Uj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f716e3e58d6e8629$var$Uj(a, b, c), a = a.sibling; null !== a;)$f716e3e58d6e8629$var$Uj(a, b, c), a = a.sibling;
}
var $f716e3e58d6e8629$var$V = null, $f716e3e58d6e8629$var$Vj = !1;
function $f716e3e58d6e8629$var$Wj(a, b, c) {
    for(c = c.child; null !== c;)$f716e3e58d6e8629$var$Xj(a, b, c), c = c.sibling;
}
function $f716e3e58d6e8629$var$Xj(a, b, c) {
    if ($f716e3e58d6e8629$var$kc && "function" === typeof $f716e3e58d6e8629$var$kc.onCommitFiberUnmount) try {
        $f716e3e58d6e8629$var$kc.onCommitFiberUnmount($f716e3e58d6e8629$var$jc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f716e3e58d6e8629$var$S || $f716e3e58d6e8629$var$Jj(c, b);
        case 6:
            var d = $f716e3e58d6e8629$var$V, e = $f716e3e58d6e8629$var$Vj;
            $f716e3e58d6e8629$var$V = null;
            $f716e3e58d6e8629$var$Wj(a, b, c);
            $f716e3e58d6e8629$var$V = d;
            $f716e3e58d6e8629$var$Vj = e;
            null !== $f716e3e58d6e8629$var$V && ($f716e3e58d6e8629$var$Vj ? (a = $f716e3e58d6e8629$var$V, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f716e3e58d6e8629$var$V.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f716e3e58d6e8629$var$V && ($f716e3e58d6e8629$var$Vj ? (a = $f716e3e58d6e8629$var$V, c = c.stateNode, 8 === a.nodeType ? $f716e3e58d6e8629$var$Jf(a.parentNode, c) : 1 === a.nodeType && $f716e3e58d6e8629$var$Jf(a, c), $f716e3e58d6e8629$var$ad(a)) : $f716e3e58d6e8629$var$Jf($f716e3e58d6e8629$var$V, c.stateNode));
            break;
        case 4:
            d = $f716e3e58d6e8629$var$V;
            e = $f716e3e58d6e8629$var$Vj;
            $f716e3e58d6e8629$var$V = c.stateNode.containerInfo;
            $f716e3e58d6e8629$var$Vj = !0;
            $f716e3e58d6e8629$var$Wj(a, b, c);
            $f716e3e58d6e8629$var$V = d;
            $f716e3e58d6e8629$var$Vj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f716e3e58d6e8629$var$S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f716e3e58d6e8629$var$Kj(c, b, g) : 0 !== (f & 4) && $f716e3e58d6e8629$var$Kj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f716e3e58d6e8629$var$Wj(a, b, c);
            break;
        case 1:
            if (!$f716e3e58d6e8629$var$S && ($f716e3e58d6e8629$var$Jj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f716e3e58d6e8629$var$U(c, b, h);
            }
            $f716e3e58d6e8629$var$Wj(a, b, c);
            break;
        case 21:
            $f716e3e58d6e8629$var$Wj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f716e3e58d6e8629$var$S = (d = $f716e3e58d6e8629$var$S) || null !== c.memoizedState, $f716e3e58d6e8629$var$Wj(a, b, c), $f716e3e58d6e8629$var$S = d) : $f716e3e58d6e8629$var$Wj(a, b, c);
            break;
        default:
            $f716e3e58d6e8629$var$Wj(a, b, c);
    }
}
function $f716e3e58d6e8629$var$Yj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f716e3e58d6e8629$var$Ij);
        b.forEach(function(b) {
            var d = $f716e3e58d6e8629$var$Zj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f716e3e58d6e8629$var$ak(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f716e3e58d6e8629$var$V = h.stateNode;
                        $f716e3e58d6e8629$var$Vj = !1;
                        break a;
                    case 3:
                        $f716e3e58d6e8629$var$V = h.stateNode.containerInfo;
                        $f716e3e58d6e8629$var$Vj = !0;
                        break a;
                    case 4:
                        $f716e3e58d6e8629$var$V = h.stateNode.containerInfo;
                        $f716e3e58d6e8629$var$Vj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f716e3e58d6e8629$var$V) throw Error($f716e3e58d6e8629$var$p(160));
            $f716e3e58d6e8629$var$Xj(f, g, e);
            $f716e3e58d6e8629$var$V = null;
            $f716e3e58d6e8629$var$Vj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f716e3e58d6e8629$var$U(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f716e3e58d6e8629$var$bk(b, a), b = b.sibling;
}
function $f716e3e58d6e8629$var$bk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            if (d & 4) {
                try {
                    $f716e3e58d6e8629$var$Nj(3, a, a.return), $f716e3e58d6e8629$var$Oj(3, a);
                } catch (m) {
                    $f716e3e58d6e8629$var$U(a, a.return, m);
                }
                try {
                    $f716e3e58d6e8629$var$Nj(5, a, a.return);
                } catch (m) {
                    $f716e3e58d6e8629$var$U(a, a.return, m);
                }
            }
            break;
        case 1:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            d & 512 && null !== c && $f716e3e58d6e8629$var$Jj(c, c.return);
            break;
        case 5:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            d & 512 && null !== c && $f716e3e58d6e8629$var$Jj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f716e3e58d6e8629$var$nb(e, "");
                } catch (m) {
                    $f716e3e58d6e8629$var$U(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f716e3e58d6e8629$var$Za(e, f);
                    $f716e3e58d6e8629$var$ub(h, g);
                    var l = $f716e3e58d6e8629$var$ub(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], u = k[g + 1];
                        "style" === n ? $f716e3e58d6e8629$var$rb(e, u) : "dangerouslySetInnerHTML" === n ? $f716e3e58d6e8629$var$mb(e, u) : "children" === n ? $f716e3e58d6e8629$var$nb(e, u) : $f716e3e58d6e8629$var$sa(e, n, u, l);
                    }
                    switch(h){
                        case "input":
                            $f716e3e58d6e8629$var$$a(e, f);
                            break;
                        case "textarea":
                            $f716e3e58d6e8629$var$hb(e, f);
                            break;
                        case "select":
                            var q = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f716e3e58d6e8629$var$eb(e, !!f.multiple, y, !1) : q !== !!f.multiple && (null != f.defaultValue ? $f716e3e58d6e8629$var$eb(e, !!f.multiple, f.defaultValue, !0) : $f716e3e58d6e8629$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f716e3e58d6e8629$var$Of] = f;
                } catch (m) {
                    $f716e3e58d6e8629$var$U(a, a.return, m);
                }
            }
            break;
        case 6:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f716e3e58d6e8629$var$p(162));
                l = a.stateNode;
                n = a.memoizedProps;
                try {
                    l.nodeValue = n;
                } catch (m) {
                    $f716e3e58d6e8629$var$U(a, a.return, m);
                }
            }
            break;
        case 3:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f716e3e58d6e8629$var$ad(b.containerInfo);
            } catch (m) {
                $f716e3e58d6e8629$var$U(a, a.return, m);
            }
            break;
        case 4:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            break;
        case 13:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            l = a.child;
            l.flags & 8192 && null !== l.memoizedState && (null === l.alternate || null === l.alternate.memoizedState) && ($f716e3e58d6e8629$var$dk = $f716e3e58d6e8629$var$B());
            d & 4 && $f716e3e58d6e8629$var$Yj(a);
            break;
        case 22:
            l = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f716e3e58d6e8629$var$S = (n = $f716e3e58d6e8629$var$S) || l, $f716e3e58d6e8629$var$ak(b, a), $f716e3e58d6e8629$var$S = n) : $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            if (d & 8192) {
                n = null !== a.memoizedState;
                a: for(u = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === u) {
                            u = q;
                            try {
                                e = q.stateNode, n ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f716e3e58d6e8629$var$qb("display", g));
                            } catch (m) {
                                $f716e3e58d6e8629$var$U(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === u) try {
                            q.stateNode.nodeValue = n ? "" : q.memoizedProps;
                        } catch (m) {
                            $f716e3e58d6e8629$var$U(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        u === q && (u = null);
                        q = q.return;
                    }
                    u === q && (u = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
                if (n && !l && 0 !== (a.mode & 1)) for($f716e3e58d6e8629$var$T = a, a = a.child; null !== a;){
                    for(l = $f716e3e58d6e8629$var$T = a; null !== $f716e3e58d6e8629$var$T;){
                        n = $f716e3e58d6e8629$var$T;
                        u = n.child;
                        switch(n.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f716e3e58d6e8629$var$Nj(4, n, n.return);
                                break;
                            case 1:
                                $f716e3e58d6e8629$var$Jj(n, n.return);
                                f = n.stateNode;
                                if ("function" === typeof f.componentWillUnmount) {
                                    q = n;
                                    y = n.return;
                                    try {
                                        e = q, f.props = e.memoizedProps, f.state = e.memoizedState, f.componentWillUnmount();
                                    } catch (m) {
                                        $f716e3e58d6e8629$var$U(q, y, m);
                                    }
                                }
                                break;
                            case 5:
                                $f716e3e58d6e8629$var$Jj(n, n.return);
                                break;
                            case 22:
                                if (null !== n.memoizedState) {
                                    $f716e3e58d6e8629$var$ek(l);
                                    continue;
                                }
                        }
                        null !== u ? (u.return = n, $f716e3e58d6e8629$var$T = u) : $f716e3e58d6e8629$var$ek(l);
                    }
                    a = a.sibling;
                }
            }
            break;
        case 19:
            $f716e3e58d6e8629$var$ak(b, a);
            $f716e3e58d6e8629$var$ck(a);
            d & 4 && $f716e3e58d6e8629$var$Yj(a);
            break;
        case 21:
            break;
        default:
            $f716e3e58d6e8629$var$ak(b, a), $f716e3e58d6e8629$var$ck(a);
    }
}
function $f716e3e58d6e8629$var$ck(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f716e3e58d6e8629$var$Rj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f716e3e58d6e8629$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f716e3e58d6e8629$var$nb(e, ""), d.flags &= -33);
                    var f = $f716e3e58d6e8629$var$Sj(a);
                    $f716e3e58d6e8629$var$Uj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f716e3e58d6e8629$var$Sj(a);
                    $f716e3e58d6e8629$var$Tj(a, h, g);
                    break;
                default:
                    throw Error($f716e3e58d6e8629$var$p(161));
            }
        } catch (k) {
            $f716e3e58d6e8629$var$U(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f716e3e58d6e8629$var$fk(a, b, c) {
    $f716e3e58d6e8629$var$T = a;
    $f716e3e58d6e8629$var$gk(a, b, c);
}
function $f716e3e58d6e8629$var$gk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f716e3e58d6e8629$var$T;){
        var e = $f716e3e58d6e8629$var$T, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f716e3e58d6e8629$var$Hj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f716e3e58d6e8629$var$S;
                h = $f716e3e58d6e8629$var$Hj;
                var l = $f716e3e58d6e8629$var$S;
                $f716e3e58d6e8629$var$Hj = g;
                if (($f716e3e58d6e8629$var$S = k) && !l) for($f716e3e58d6e8629$var$T = e; null !== $f716e3e58d6e8629$var$T;)g = $f716e3e58d6e8629$var$T, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f716e3e58d6e8629$var$hk(e) : null !== k ? (k.return = g, $f716e3e58d6e8629$var$T = k) : $f716e3e58d6e8629$var$hk(e);
                for(; null !== f;)$f716e3e58d6e8629$var$T = f, $f716e3e58d6e8629$var$gk(f, b, c), f = f.sibling;
                $f716e3e58d6e8629$var$T = e;
                $f716e3e58d6e8629$var$Hj = h;
                $f716e3e58d6e8629$var$S = l;
            }
            $f716e3e58d6e8629$var$ik(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f716e3e58d6e8629$var$T = f) : $f716e3e58d6e8629$var$ik(a, b, c);
    }
}
function $f716e3e58d6e8629$var$ik(a) {
    for(; null !== $f716e3e58d6e8629$var$T;){
        var b = $f716e3e58d6e8629$var$T;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f716e3e58d6e8629$var$S || $f716e3e58d6e8629$var$Oj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f716e3e58d6e8629$var$S) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f716e3e58d6e8629$var$kg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f716e3e58d6e8629$var$Gg(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f716e3e58d6e8629$var$Gg(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var n = l.memoizedState;
                                if (null !== n) {
                                    var u = n.dehydrated;
                                    null !== u && $f716e3e58d6e8629$var$ad(u);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                        break;
                    default:
                        throw Error($f716e3e58d6e8629$var$p(163));
                }
                $f716e3e58d6e8629$var$S || b.flags & 512 && $f716e3e58d6e8629$var$Pj(b);
            } catch (q) {
                $f716e3e58d6e8629$var$U(b, b.return, q);
            }
        }
        if (b === a) {
            $f716e3e58d6e8629$var$T = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f716e3e58d6e8629$var$T = c;
            break;
        }
        $f716e3e58d6e8629$var$T = b.return;
    }
}
function $f716e3e58d6e8629$var$ek(a) {
    for(; null !== $f716e3e58d6e8629$var$T;){
        var b = $f716e3e58d6e8629$var$T;
        if (b === a) {
            $f716e3e58d6e8629$var$T = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f716e3e58d6e8629$var$T = c;
            break;
        }
        $f716e3e58d6e8629$var$T = b.return;
    }
}
function $f716e3e58d6e8629$var$hk(a) {
    for(; null !== $f716e3e58d6e8629$var$T;){
        var b = $f716e3e58d6e8629$var$T;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f716e3e58d6e8629$var$Oj(4, b);
                    } catch (k) {
                        $f716e3e58d6e8629$var$U(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f716e3e58d6e8629$var$U(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f716e3e58d6e8629$var$Pj(b);
                    } catch (k) {
                        $f716e3e58d6e8629$var$U(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f716e3e58d6e8629$var$Pj(b);
                    } catch (k) {
                        $f716e3e58d6e8629$var$U(b, g, k);
                    }
            }
        } catch (k) {
            $f716e3e58d6e8629$var$U(b, b.return, k);
        }
        if (b === a) {
            $f716e3e58d6e8629$var$T = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f716e3e58d6e8629$var$T = h;
            break;
        }
        $f716e3e58d6e8629$var$T = b.return;
    }
}
var $f716e3e58d6e8629$var$jk = Math.ceil, $f716e3e58d6e8629$var$kk = $f716e3e58d6e8629$var$ta.ReactCurrentDispatcher, $f716e3e58d6e8629$var$lk = $f716e3e58d6e8629$var$ta.ReactCurrentOwner, $f716e3e58d6e8629$var$mk = $f716e3e58d6e8629$var$ta.ReactCurrentBatchConfig, $f716e3e58d6e8629$var$W = 0, $f716e3e58d6e8629$var$P = null, $f716e3e58d6e8629$var$X = null, $f716e3e58d6e8629$var$Y = 0, $f716e3e58d6e8629$var$cj = 0, $f716e3e58d6e8629$var$mj = $f716e3e58d6e8629$var$Tf(0), $f716e3e58d6e8629$var$R = 0, $f716e3e58d6e8629$var$nk = null, $f716e3e58d6e8629$var$Fg = 0, $f716e3e58d6e8629$var$ok = 0, $f716e3e58d6e8629$var$pk = 0, $f716e3e58d6e8629$var$qk = null, $f716e3e58d6e8629$var$rk = null, $f716e3e58d6e8629$var$dk = 0, $f716e3e58d6e8629$var$aj = Infinity, $f716e3e58d6e8629$var$sk = null, $f716e3e58d6e8629$var$Li = !1, $f716e3e58d6e8629$var$Mi = null, $f716e3e58d6e8629$var$Oi = null, $f716e3e58d6e8629$var$tk = !1, $f716e3e58d6e8629$var$uk = null, $f716e3e58d6e8629$var$vk = 0, $f716e3e58d6e8629$var$wk = 0, $f716e3e58d6e8629$var$xk = null, $f716e3e58d6e8629$var$yk = -1, $f716e3e58d6e8629$var$zk = 0;
function $f716e3e58d6e8629$var$Jg() {
    return 0 !== ($f716e3e58d6e8629$var$W & 6) ? $f716e3e58d6e8629$var$B() : -1 !== $f716e3e58d6e8629$var$yk ? $f716e3e58d6e8629$var$yk : $f716e3e58d6e8629$var$yk = $f716e3e58d6e8629$var$B();
}
function $f716e3e58d6e8629$var$Kg(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f716e3e58d6e8629$var$W & 2) && 0 !== $f716e3e58d6e8629$var$Y) return $f716e3e58d6e8629$var$Y & -$f716e3e58d6e8629$var$Y;
    if (null !== $f716e3e58d6e8629$var$jg.transition) return 0 === $f716e3e58d6e8629$var$zk && ($f716e3e58d6e8629$var$zk = $f716e3e58d6e8629$var$xc()), $f716e3e58d6e8629$var$zk;
    a = $f716e3e58d6e8629$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f716e3e58d6e8629$var$id(a.type);
    return a;
}
function $f716e3e58d6e8629$var$Lg(a, b, c) {
    if (50 < $f716e3e58d6e8629$var$wk) throw $f716e3e58d6e8629$var$wk = 0, $f716e3e58d6e8629$var$xk = null, Error($f716e3e58d6e8629$var$p(185));
    var d = $f716e3e58d6e8629$var$Ak(a, b);
    if (null === d) return null;
    $f716e3e58d6e8629$var$zc(d, b, c);
    if (0 === ($f716e3e58d6e8629$var$W & 2) || d !== $f716e3e58d6e8629$var$P) d === $f716e3e58d6e8629$var$P && (0 === ($f716e3e58d6e8629$var$W & 2) && ($f716e3e58d6e8629$var$ok |= b), 4 === $f716e3e58d6e8629$var$R && $f716e3e58d6e8629$var$Bk(d, $f716e3e58d6e8629$var$Y)), $f716e3e58d6e8629$var$Ck(d, c), 1 === b && 0 === $f716e3e58d6e8629$var$W && 0 === (a.mode & 1) && ($f716e3e58d6e8629$var$aj = $f716e3e58d6e8629$var$B() + 500, $f716e3e58d6e8629$var$eg && $f716e3e58d6e8629$var$ig());
    return d;
}
function $f716e3e58d6e8629$var$Ak(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $f716e3e58d6e8629$var$Bg(a) {
    return (null !== $f716e3e58d6e8629$var$P || null !== $f716e3e58d6e8629$var$vg) && 0 !== (a.mode & 1) && 0 === ($f716e3e58d6e8629$var$W & 2);
}
function $f716e3e58d6e8629$var$Ck(a, b) {
    var c = a.callbackNode;
    $f716e3e58d6e8629$var$vc(a, b);
    var d = $f716e3e58d6e8629$var$tc(a, a === $f716e3e58d6e8629$var$P ? $f716e3e58d6e8629$var$Y : 0);
    if (0 === d) null !== c && $f716e3e58d6e8629$var$ac(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f716e3e58d6e8629$var$ac(c);
        if (1 === b) 0 === a.tag ? $f716e3e58d6e8629$var$hg($f716e3e58d6e8629$var$Dk.bind(null, a)) : $f716e3e58d6e8629$var$gg($f716e3e58d6e8629$var$Dk.bind(null, a)), $f716e3e58d6e8629$var$If(function() {
            0 === $f716e3e58d6e8629$var$W && $f716e3e58d6e8629$var$ig();
        }), c = null;
        else {
            switch($f716e3e58d6e8629$var$Cc(d)){
                case 1:
                    c = $f716e3e58d6e8629$var$ec;
                    break;
                case 4:
                    c = $f716e3e58d6e8629$var$fc;
                    break;
                case 16:
                    c = $f716e3e58d6e8629$var$gc;
                    break;
                case 536870912:
                    c = $f716e3e58d6e8629$var$ic;
                    break;
                default:
                    c = $f716e3e58d6e8629$var$gc;
            }
            c = $f716e3e58d6e8629$var$Ek(c, $f716e3e58d6e8629$var$Fk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f716e3e58d6e8629$var$Fk(a, b) {
    $f716e3e58d6e8629$var$yk = -1;
    $f716e3e58d6e8629$var$zk = 0;
    if (0 !== ($f716e3e58d6e8629$var$W & 6)) throw Error($f716e3e58d6e8629$var$p(327));
    var c = a.callbackNode;
    if ($f716e3e58d6e8629$var$Gk() && a.callbackNode !== c) return null;
    var d = $f716e3e58d6e8629$var$tc(a, a === $f716e3e58d6e8629$var$P ? $f716e3e58d6e8629$var$Y : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f716e3e58d6e8629$var$Hk(a, d);
    else {
        b = d;
        var e = $f716e3e58d6e8629$var$W;
        $f716e3e58d6e8629$var$W |= 2;
        var f = $f716e3e58d6e8629$var$Ik();
        if ($f716e3e58d6e8629$var$P !== a || $f716e3e58d6e8629$var$Y !== b) $f716e3e58d6e8629$var$sk = null, $f716e3e58d6e8629$var$aj = $f716e3e58d6e8629$var$B() + 500, $f716e3e58d6e8629$var$Jk(a, b);
        for(;;)try {
            $f716e3e58d6e8629$var$Kk();
            break;
        } catch (h) {
            $f716e3e58d6e8629$var$Lk(a, h);
        }
        $f716e3e58d6e8629$var$pg();
        $f716e3e58d6e8629$var$kk.current = f;
        $f716e3e58d6e8629$var$W = e;
        null !== $f716e3e58d6e8629$var$X ? b = 0 : ($f716e3e58d6e8629$var$P = null, $f716e3e58d6e8629$var$Y = 0, b = $f716e3e58d6e8629$var$R);
    }
    if (0 !== b) {
        2 === b && (e = $f716e3e58d6e8629$var$wc(a), 0 !== e && (d = e, b = $f716e3e58d6e8629$var$Mk(a, e)));
        if (1 === b) throw c = $f716e3e58d6e8629$var$nk, $f716e3e58d6e8629$var$Jk(a, 0), $f716e3e58d6e8629$var$Bk(a, d), $f716e3e58d6e8629$var$Ck(a, $f716e3e58d6e8629$var$B()), c;
        if (6 === b) $f716e3e58d6e8629$var$Bk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f716e3e58d6e8629$var$Nk(e) && (b = $f716e3e58d6e8629$var$Hk(a, d), 2 === b && (f = $f716e3e58d6e8629$var$wc(a), 0 !== f && (d = f, b = $f716e3e58d6e8629$var$Mk(a, f))), 1 === b)) throw c = $f716e3e58d6e8629$var$nk, $f716e3e58d6e8629$var$Jk(a, 0), $f716e3e58d6e8629$var$Bk(a, d), $f716e3e58d6e8629$var$Ck(a, $f716e3e58d6e8629$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f716e3e58d6e8629$var$p(345));
                case 2:
                    $f716e3e58d6e8629$var$Ok(a, $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$sk);
                    break;
                case 3:
                    $f716e3e58d6e8629$var$Bk(a, d);
                    if ((d & 130023424) === d && (b = $f716e3e58d6e8629$var$dk + 500 - $f716e3e58d6e8629$var$B(), 10 < b)) {
                        if (0 !== $f716e3e58d6e8629$var$tc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f716e3e58d6e8629$var$Jg();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f716e3e58d6e8629$var$Ef($f716e3e58d6e8629$var$Ok.bind(null, a, $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$sk), b);
                        break;
                    }
                    $f716e3e58d6e8629$var$Ok(a, $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$sk);
                    break;
                case 4:
                    $f716e3e58d6e8629$var$Bk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f716e3e58d6e8629$var$nc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f716e3e58d6e8629$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f716e3e58d6e8629$var$jk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f716e3e58d6e8629$var$Ef($f716e3e58d6e8629$var$Ok.bind(null, a, $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$sk), d);
                        break;
                    }
                    $f716e3e58d6e8629$var$Ok(a, $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$sk);
                    break;
                case 5:
                    $f716e3e58d6e8629$var$Ok(a, $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$sk);
                    break;
                default:
                    throw Error($f716e3e58d6e8629$var$p(329));
            }
        }
    }
    $f716e3e58d6e8629$var$Ck(a, $f716e3e58d6e8629$var$B());
    return a.callbackNode === c ? $f716e3e58d6e8629$var$Fk.bind(null, a) : null;
}
function $f716e3e58d6e8629$var$Mk(a, b) {
    var c = $f716e3e58d6e8629$var$qk;
    a.current.memoizedState.isDehydrated && ($f716e3e58d6e8629$var$Jk(a, b).flags |= 256);
    a = $f716e3e58d6e8629$var$Hk(a, b);
    2 !== a && (b = $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$rk = c, null !== b && $f716e3e58d6e8629$var$Zi(b));
    return a;
}
function $f716e3e58d6e8629$var$Zi(a) {
    null === $f716e3e58d6e8629$var$rk ? $f716e3e58d6e8629$var$rk = a : $f716e3e58d6e8629$var$rk.push.apply($f716e3e58d6e8629$var$rk, a);
}
function $f716e3e58d6e8629$var$Nk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f716e3e58d6e8629$var$Ge(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f716e3e58d6e8629$var$Bk(a, b) {
    b &= ~$f716e3e58d6e8629$var$pk;
    b &= ~$f716e3e58d6e8629$var$ok;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f716e3e58d6e8629$var$nc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f716e3e58d6e8629$var$Dk(a) {
    if (0 !== ($f716e3e58d6e8629$var$W & 6)) throw Error($f716e3e58d6e8629$var$p(327));
    $f716e3e58d6e8629$var$Gk();
    var b = $f716e3e58d6e8629$var$tc(a, 0);
    if (0 === (b & 1)) return $f716e3e58d6e8629$var$Ck(a, $f716e3e58d6e8629$var$B()), null;
    var c = $f716e3e58d6e8629$var$Hk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f716e3e58d6e8629$var$wc(a);
        0 !== d && (b = d, c = $f716e3e58d6e8629$var$Mk(a, d));
    }
    if (1 === c) throw c = $f716e3e58d6e8629$var$nk, $f716e3e58d6e8629$var$Jk(a, 0), $f716e3e58d6e8629$var$Bk(a, b), $f716e3e58d6e8629$var$Ck(a, $f716e3e58d6e8629$var$B()), c;
    if (6 === c) throw Error($f716e3e58d6e8629$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f716e3e58d6e8629$var$Ok(a, $f716e3e58d6e8629$var$rk, $f716e3e58d6e8629$var$sk);
    $f716e3e58d6e8629$var$Ck(a, $f716e3e58d6e8629$var$B());
    return null;
}
function $f716e3e58d6e8629$var$Pk(a, b) {
    var c = $f716e3e58d6e8629$var$W;
    $f716e3e58d6e8629$var$W |= 1;
    try {
        return a(b);
    } finally{
        $f716e3e58d6e8629$var$W = c, 0 === $f716e3e58d6e8629$var$W && ($f716e3e58d6e8629$var$aj = $f716e3e58d6e8629$var$B() + 500, $f716e3e58d6e8629$var$eg && $f716e3e58d6e8629$var$ig());
    }
}
function $f716e3e58d6e8629$var$Qk(a) {
    null !== $f716e3e58d6e8629$var$uk && 0 === $f716e3e58d6e8629$var$uk.tag && 0 === ($f716e3e58d6e8629$var$W & 6) && $f716e3e58d6e8629$var$Gk();
    var b = $f716e3e58d6e8629$var$W;
    $f716e3e58d6e8629$var$W |= 1;
    var c = $f716e3e58d6e8629$var$mk.transition, d = $f716e3e58d6e8629$var$C;
    try {
        if ($f716e3e58d6e8629$var$mk.transition = null, $f716e3e58d6e8629$var$C = 1, a) return a();
    } finally{
        $f716e3e58d6e8629$var$C = d, $f716e3e58d6e8629$var$mk.transition = c, $f716e3e58d6e8629$var$W = b, 0 === ($f716e3e58d6e8629$var$W & 6) && $f716e3e58d6e8629$var$ig();
    }
}
function $f716e3e58d6e8629$var$bj() {
    $f716e3e58d6e8629$var$cj = $f716e3e58d6e8629$var$mj.current;
    $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$mj);
}
function $f716e3e58d6e8629$var$Jk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f716e3e58d6e8629$var$Ff(c));
    if (null !== $f716e3e58d6e8629$var$X) for(c = $f716e3e58d6e8629$var$X.return; null !== c;){
        var d = c;
        $f716e3e58d6e8629$var$ch(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f716e3e58d6e8629$var$Zf();
                break;
            case 3:
                $f716e3e58d6e8629$var$Gh();
                $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$Vf);
                $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$H);
                $f716e3e58d6e8629$var$Lh();
                break;
            case 5:
                $f716e3e58d6e8629$var$Ih(d);
                break;
            case 4:
                $f716e3e58d6e8629$var$Gh();
                break;
            case 13:
                $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$K);
                break;
            case 19:
                $f716e3e58d6e8629$var$E($f716e3e58d6e8629$var$K);
                break;
            case 10:
                $f716e3e58d6e8629$var$qg(d.type._context);
                break;
            case 22:
            case 23:
                $f716e3e58d6e8629$var$bj();
        }
        c = c.return;
    }
    $f716e3e58d6e8629$var$P = a;
    $f716e3e58d6e8629$var$X = a = $f716e3e58d6e8629$var$th(a.current, null);
    $f716e3e58d6e8629$var$Y = $f716e3e58d6e8629$var$cj = b;
    $f716e3e58d6e8629$var$R = 0;
    $f716e3e58d6e8629$var$nk = null;
    $f716e3e58d6e8629$var$pk = $f716e3e58d6e8629$var$ok = $f716e3e58d6e8629$var$Fg = 0;
    $f716e3e58d6e8629$var$rk = $f716e3e58d6e8629$var$qk = null;
    if (null !== $f716e3e58d6e8629$var$vg) {
        for(b = 0; b < $f716e3e58d6e8629$var$vg.length; b++)if (c = $f716e3e58d6e8629$var$vg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f716e3e58d6e8629$var$vg = null;
    }
    return a;
}
function $f716e3e58d6e8629$var$Lk(a, b) {
    do {
        var c = $f716e3e58d6e8629$var$X;
        try {
            $f716e3e58d6e8629$var$pg();
            $f716e3e58d6e8629$var$Mh.current = $f716e3e58d6e8629$var$Yh;
            if ($f716e3e58d6e8629$var$Ph) {
                for(var d = $f716e3e58d6e8629$var$L.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f716e3e58d6e8629$var$Ph = !1;
            }
            $f716e3e58d6e8629$var$Oh = 0;
            $f716e3e58d6e8629$var$N = $f716e3e58d6e8629$var$M = $f716e3e58d6e8629$var$L = null;
            $f716e3e58d6e8629$var$Qh = !1;
            $f716e3e58d6e8629$var$Rh = 0;
            $f716e3e58d6e8629$var$lk.current = null;
            if (null === c || null === c.return) {
                $f716e3e58d6e8629$var$R = 1;
                $f716e3e58d6e8629$var$nk = b;
                $f716e3e58d6e8629$var$X = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f716e3e58d6e8629$var$Y;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, n = h, u = n.tag;
                    if (0 === (n.mode & 1) && (0 === u || 11 === u || 15 === u)) {
                        var q = n.alternate;
                        q ? (n.updateQueue = q.updateQueue, n.memoizedState = q.memoizedState, n.lanes = q.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var y = $f716e3e58d6e8629$var$Ri(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f716e3e58d6e8629$var$Si(y, g, h, f, b);
                        y.mode & 1 && $f716e3e58d6e8629$var$Pi(f, l, b);
                        b = y;
                        k = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(k);
                            b.updateQueue = w;
                        } else m.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f716e3e58d6e8629$var$Pi(f, l, b);
                            $f716e3e58d6e8629$var$$i();
                            break a;
                        }
                        k = Error($f716e3e58d6e8629$var$p(426));
                    }
                } else if ($f716e3e58d6e8629$var$I && h.mode & 1) {
                    var J = $f716e3e58d6e8629$var$Ri(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f716e3e58d6e8629$var$Si(J, g, h, f, b);
                        $f716e3e58d6e8629$var$oh(k);
                        break a;
                    }
                }
                f = k;
                4 !== $f716e3e58d6e8629$var$R && ($f716e3e58d6e8629$var$R = 2);
                null === $f716e3e58d6e8629$var$qk ? $f716e3e58d6e8629$var$qk = [
                    f
                ] : $f716e3e58d6e8629$var$qk.push(f);
                k = $f716e3e58d6e8629$var$Hi(k, h);
                h = g;
                do {
                    switch(h.tag){
                        case 3:
                            h.flags |= 65536;
                            b &= -b;
                            h.lanes |= b;
                            var v = $f716e3e58d6e8629$var$Ki(h, k, b);
                            $f716e3e58d6e8629$var$Dg(h, v);
                            break a;
                        case 1:
                            f = k;
                            var x = h.type, r = h.stateNode;
                            if (0 === (h.flags & 128) && ("function" === typeof x.getDerivedStateFromError || null !== r && "function" === typeof r.componentDidCatch && (null === $f716e3e58d6e8629$var$Oi || !$f716e3e58d6e8629$var$Oi.has(r)))) {
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var F = $f716e3e58d6e8629$var$Ni(h, f, b);
                                $f716e3e58d6e8629$var$Dg(h, F);
                                break a;
                            }
                    }
                    h = h.return;
                }while (null !== h);
            }
            $f716e3e58d6e8629$var$Rk(c);
        } catch (Z) {
            b = Z;
            $f716e3e58d6e8629$var$X === c && null !== c && ($f716e3e58d6e8629$var$X = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f716e3e58d6e8629$var$Ik() {
    var a = $f716e3e58d6e8629$var$kk.current;
    $f716e3e58d6e8629$var$kk.current = $f716e3e58d6e8629$var$Yh;
    return null === a ? $f716e3e58d6e8629$var$Yh : a;
}
function $f716e3e58d6e8629$var$$i() {
    if (0 === $f716e3e58d6e8629$var$R || 3 === $f716e3e58d6e8629$var$R || 2 === $f716e3e58d6e8629$var$R) $f716e3e58d6e8629$var$R = 4;
    null === $f716e3e58d6e8629$var$P || 0 === ($f716e3e58d6e8629$var$Fg & 268435455) && 0 === ($f716e3e58d6e8629$var$ok & 268435455) || $f716e3e58d6e8629$var$Bk($f716e3e58d6e8629$var$P, $f716e3e58d6e8629$var$Y);
}
function $f716e3e58d6e8629$var$Hk(a, b) {
    var c = $f716e3e58d6e8629$var$W;
    $f716e3e58d6e8629$var$W |= 2;
    var d = $f716e3e58d6e8629$var$Ik();
    if ($f716e3e58d6e8629$var$P !== a || $f716e3e58d6e8629$var$Y !== b) $f716e3e58d6e8629$var$sk = null, $f716e3e58d6e8629$var$Jk(a, b);
    for(;;)try {
        $f716e3e58d6e8629$var$Sk();
        break;
    } catch (e) {
        $f716e3e58d6e8629$var$Lk(a, e);
    }
    $f716e3e58d6e8629$var$pg();
    $f716e3e58d6e8629$var$W = c;
    $f716e3e58d6e8629$var$kk.current = d;
    if (null !== $f716e3e58d6e8629$var$X) throw Error($f716e3e58d6e8629$var$p(261));
    $f716e3e58d6e8629$var$P = null;
    $f716e3e58d6e8629$var$Y = 0;
    return $f716e3e58d6e8629$var$R;
}
function $f716e3e58d6e8629$var$Sk() {
    for(; null !== $f716e3e58d6e8629$var$X;)$f716e3e58d6e8629$var$Tk($f716e3e58d6e8629$var$X);
}
function $f716e3e58d6e8629$var$Kk() {
    for(; null !== $f716e3e58d6e8629$var$X && !$f716e3e58d6e8629$var$bc();)$f716e3e58d6e8629$var$Tk($f716e3e58d6e8629$var$X);
}
function $f716e3e58d6e8629$var$Tk(a) {
    var b = $f716e3e58d6e8629$var$Uk(a.alternate, a, $f716e3e58d6e8629$var$cj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f716e3e58d6e8629$var$Rk(a) : $f716e3e58d6e8629$var$X = b;
    $f716e3e58d6e8629$var$lk.current = null;
}
function $f716e3e58d6e8629$var$Rk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f716e3e58d6e8629$var$Yi(c, b, $f716e3e58d6e8629$var$cj), null !== c) {
                $f716e3e58d6e8629$var$X = c;
                return;
            }
        } else {
            c = $f716e3e58d6e8629$var$Gj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f716e3e58d6e8629$var$X = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f716e3e58d6e8629$var$R = 6;
                $f716e3e58d6e8629$var$X = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f716e3e58d6e8629$var$X = b;
            return;
        }
        $f716e3e58d6e8629$var$X = b = a;
    }while (null !== b);
    0 === $f716e3e58d6e8629$var$R && ($f716e3e58d6e8629$var$R = 5);
}
function $f716e3e58d6e8629$var$Ok(a, b, c) {
    var d = $f716e3e58d6e8629$var$C, e = $f716e3e58d6e8629$var$mk.transition;
    try {
        $f716e3e58d6e8629$var$mk.transition = null, $f716e3e58d6e8629$var$C = 1, $f716e3e58d6e8629$var$Vk(a, b, c, d);
    } finally{
        $f716e3e58d6e8629$var$mk.transition = e, $f716e3e58d6e8629$var$C = d;
    }
    return null;
}
function $f716e3e58d6e8629$var$Vk(a, b, c, d) {
    do $f716e3e58d6e8629$var$Gk();
    while (null !== $f716e3e58d6e8629$var$uk);
    if (0 !== ($f716e3e58d6e8629$var$W & 6)) throw Error($f716e3e58d6e8629$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f716e3e58d6e8629$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f716e3e58d6e8629$var$Ac(a, f);
    a === $f716e3e58d6e8629$var$P && ($f716e3e58d6e8629$var$X = $f716e3e58d6e8629$var$P = null, $f716e3e58d6e8629$var$Y = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f716e3e58d6e8629$var$tk || ($f716e3e58d6e8629$var$tk = !0, $f716e3e58d6e8629$var$Ek($f716e3e58d6e8629$var$gc, function() {
        $f716e3e58d6e8629$var$Gk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f716e3e58d6e8629$var$mk.transition;
        $f716e3e58d6e8629$var$mk.transition = null;
        var g = $f716e3e58d6e8629$var$C;
        $f716e3e58d6e8629$var$C = 1;
        var h = $f716e3e58d6e8629$var$W;
        $f716e3e58d6e8629$var$W |= 4;
        $f716e3e58d6e8629$var$lk.current = null;
        $f716e3e58d6e8629$var$Mj(a, c);
        $f716e3e58d6e8629$var$bk(c, a);
        $f716e3e58d6e8629$var$Ne($f716e3e58d6e8629$var$Cf);
        $f716e3e58d6e8629$var$cd = !!$f716e3e58d6e8629$var$Bf;
        $f716e3e58d6e8629$var$Cf = $f716e3e58d6e8629$var$Bf = null;
        a.current = c;
        $f716e3e58d6e8629$var$fk(c, a, e);
        $f716e3e58d6e8629$var$cc();
        $f716e3e58d6e8629$var$W = h;
        $f716e3e58d6e8629$var$C = g;
        $f716e3e58d6e8629$var$mk.transition = f;
    } else a.current = c;
    $f716e3e58d6e8629$var$tk && ($f716e3e58d6e8629$var$tk = !1, $f716e3e58d6e8629$var$uk = a, $f716e3e58d6e8629$var$vk = e);
    f = a.pendingLanes;
    0 === f && ($f716e3e58d6e8629$var$Oi = null);
    $f716e3e58d6e8629$var$lc(c.stateNode, d);
    $f716e3e58d6e8629$var$Ck(a, $f716e3e58d6e8629$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)d(b[c]);
    if ($f716e3e58d6e8629$var$Li) throw $f716e3e58d6e8629$var$Li = !1, a = $f716e3e58d6e8629$var$Mi, $f716e3e58d6e8629$var$Mi = null, a;
    0 !== ($f716e3e58d6e8629$var$vk & 1) && 0 !== a.tag && $f716e3e58d6e8629$var$Gk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f716e3e58d6e8629$var$xk ? $f716e3e58d6e8629$var$wk++ : ($f716e3e58d6e8629$var$wk = 0, $f716e3e58d6e8629$var$xk = a) : $f716e3e58d6e8629$var$wk = 0;
    $f716e3e58d6e8629$var$ig();
    return null;
}
function $f716e3e58d6e8629$var$Gk() {
    if (null !== $f716e3e58d6e8629$var$uk) {
        var a = $f716e3e58d6e8629$var$Cc($f716e3e58d6e8629$var$vk), b = $f716e3e58d6e8629$var$mk.transition, c = $f716e3e58d6e8629$var$C;
        try {
            $f716e3e58d6e8629$var$mk.transition = null;
            $f716e3e58d6e8629$var$C = 16 > a ? 16 : a;
            if (null === $f716e3e58d6e8629$var$uk) var d = !1;
            else {
                a = $f716e3e58d6e8629$var$uk;
                $f716e3e58d6e8629$var$uk = null;
                $f716e3e58d6e8629$var$vk = 0;
                if (0 !== ($f716e3e58d6e8629$var$W & 6)) throw Error($f716e3e58d6e8629$var$p(331));
                var e = $f716e3e58d6e8629$var$W;
                $f716e3e58d6e8629$var$W |= 4;
                for($f716e3e58d6e8629$var$T = a.current; null !== $f716e3e58d6e8629$var$T;){
                    var f = $f716e3e58d6e8629$var$T, g = f.child;
                    if (0 !== ($f716e3e58d6e8629$var$T.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f716e3e58d6e8629$var$T = l; null !== $f716e3e58d6e8629$var$T;){
                                    var n = $f716e3e58d6e8629$var$T;
                                    switch(n.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f716e3e58d6e8629$var$Nj(8, n, f);
                                    }
                                    var u = n.child;
                                    if (null !== u) u.return = n, $f716e3e58d6e8629$var$T = u;
                                    else for(; null !== $f716e3e58d6e8629$var$T;){
                                        n = $f716e3e58d6e8629$var$T;
                                        var q = n.sibling, y = n.return;
                                        $f716e3e58d6e8629$var$Qj(n);
                                        if (n === l) {
                                            $f716e3e58d6e8629$var$T = null;
                                            break;
                                        }
                                        if (null !== q) {
                                            q.return = y;
                                            $f716e3e58d6e8629$var$T = q;
                                            break;
                                        }
                                        $f716e3e58d6e8629$var$T = y;
                                    }
                                }
                            }
                            var m = f.alternate;
                            if (null !== m) {
                                var w = m.child;
                                if (null !== w) {
                                    m.child = null;
                                    do {
                                        var J = w.sibling;
                                        w.sibling = null;
                                        w = J;
                                    }while (null !== w);
                                }
                            }
                            $f716e3e58d6e8629$var$T = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f716e3e58d6e8629$var$T = g;
                    else b: for(; null !== $f716e3e58d6e8629$var$T;){
                        f = $f716e3e58d6e8629$var$T;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f716e3e58d6e8629$var$Nj(9, f, f.return);
                        }
                        var v = f.sibling;
                        if (null !== v) {
                            v.return = f.return;
                            $f716e3e58d6e8629$var$T = v;
                            break b;
                        }
                        $f716e3e58d6e8629$var$T = f.return;
                    }
                }
                var x = a.current;
                for($f716e3e58d6e8629$var$T = x; null !== $f716e3e58d6e8629$var$T;){
                    g = $f716e3e58d6e8629$var$T;
                    var r = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== r) r.return = g, $f716e3e58d6e8629$var$T = r;
                    else b: for(g = x; null !== $f716e3e58d6e8629$var$T;){
                        h = $f716e3e58d6e8629$var$T;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f716e3e58d6e8629$var$Oj(9, h);
                            }
                        } catch (Z) {
                            $f716e3e58d6e8629$var$U(h, h.return, Z);
                        }
                        if (h === g) {
                            $f716e3e58d6e8629$var$T = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f716e3e58d6e8629$var$T = F;
                            break b;
                        }
                        $f716e3e58d6e8629$var$T = h.return;
                    }
                }
                $f716e3e58d6e8629$var$W = e;
                $f716e3e58d6e8629$var$ig();
                if ($f716e3e58d6e8629$var$kc && "function" === typeof $f716e3e58d6e8629$var$kc.onPostCommitFiberRoot) try {
                    $f716e3e58d6e8629$var$kc.onPostCommitFiberRoot($f716e3e58d6e8629$var$jc, a);
                } catch (Z) {}
                d = !0;
            }
            return d;
        } finally{
            $f716e3e58d6e8629$var$C = c, $f716e3e58d6e8629$var$mk.transition = b;
        }
    }
    return !1;
}
function $f716e3e58d6e8629$var$Wk(a, b, c) {
    b = $f716e3e58d6e8629$var$Hi(c, b);
    b = $f716e3e58d6e8629$var$Ki(a, b, 1);
    $f716e3e58d6e8629$var$Ag(a, b);
    b = $f716e3e58d6e8629$var$Jg();
    a = $f716e3e58d6e8629$var$Ak(a, 1);
    null !== a && ($f716e3e58d6e8629$var$zc(a, 1, b), $f716e3e58d6e8629$var$Ck(a, b));
}
function $f716e3e58d6e8629$var$U(a, b, c) {
    if (3 === a.tag) $f716e3e58d6e8629$var$Wk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f716e3e58d6e8629$var$Wk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f716e3e58d6e8629$var$Oi || !$f716e3e58d6e8629$var$Oi.has(d))) {
                a = $f716e3e58d6e8629$var$Hi(c, a);
                a = $f716e3e58d6e8629$var$Ni(b, a, 1);
                $f716e3e58d6e8629$var$Ag(b, a);
                a = $f716e3e58d6e8629$var$Jg();
                b = $f716e3e58d6e8629$var$Ak(b, 1);
                null !== b && ($f716e3e58d6e8629$var$zc(b, 1, a), $f716e3e58d6e8629$var$Ck(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f716e3e58d6e8629$var$Qi(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f716e3e58d6e8629$var$Jg();
    a.pingedLanes |= a.suspendedLanes & c;
    $f716e3e58d6e8629$var$P === a && ($f716e3e58d6e8629$var$Y & c) === c && (4 === $f716e3e58d6e8629$var$R || 3 === $f716e3e58d6e8629$var$R && ($f716e3e58d6e8629$var$Y & 130023424) === $f716e3e58d6e8629$var$Y && 500 > $f716e3e58d6e8629$var$B() - $f716e3e58d6e8629$var$dk ? $f716e3e58d6e8629$var$Jk(a, 0) : $f716e3e58d6e8629$var$pk |= c);
    $f716e3e58d6e8629$var$Ck(a, b);
}
function $f716e3e58d6e8629$var$Xk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f716e3e58d6e8629$var$rc, $f716e3e58d6e8629$var$rc <<= 1, 0 === ($f716e3e58d6e8629$var$rc & 130023424) && ($f716e3e58d6e8629$var$rc = 4194304)));
    var c = $f716e3e58d6e8629$var$Jg();
    a = $f716e3e58d6e8629$var$Ak(a, b);
    null !== a && ($f716e3e58d6e8629$var$zc(a, b, c), $f716e3e58d6e8629$var$Ck(a, c));
}
function $f716e3e58d6e8629$var$zj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f716e3e58d6e8629$var$Xk(a, c);
}
function $f716e3e58d6e8629$var$Zj(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f716e3e58d6e8629$var$p(314));
    }
    null !== d && d.delete(b);
    $f716e3e58d6e8629$var$Xk(a, c);
}
var $f716e3e58d6e8629$var$Uk;
$f716e3e58d6e8629$var$Uk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f716e3e58d6e8629$var$Vf.current) $f716e3e58d6e8629$var$tg = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f716e3e58d6e8629$var$tg = !1, $f716e3e58d6e8629$var$Fj(a, b, c);
            $f716e3e58d6e8629$var$tg = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f716e3e58d6e8629$var$tg = !1, $f716e3e58d6e8629$var$I && 0 !== (b.flags & 1048576) && $f716e3e58d6e8629$var$ah(b, $f716e3e58d6e8629$var$Ug, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            var e = $f716e3e58d6e8629$var$Xf(b, $f716e3e58d6e8629$var$H.current);
            $f716e3e58d6e8629$var$sg(b, c);
            e = $f716e3e58d6e8629$var$Uh(null, b, d, a, e, c);
            var f = $f716e3e58d6e8629$var$Zh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f716e3e58d6e8629$var$Yf(d) ? (f = !0, $f716e3e58d6e8629$var$bg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f716e3e58d6e8629$var$xg(b), e.updater = $f716e3e58d6e8629$var$Mg, b.stateNode = e, e._reactInternals = b, $f716e3e58d6e8629$var$Qg(b, d, a, c), b = $f716e3e58d6e8629$var$pj(null, b, d, !0, f, c)) : (b.tag = 0, $f716e3e58d6e8629$var$I && f && $f716e3e58d6e8629$var$bh(b), $f716e3e58d6e8629$var$ej(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f716e3e58d6e8629$var$Yk(d);
                a = $f716e3e58d6e8629$var$kg(d, a);
                switch(e){
                    case 0:
                        b = $f716e3e58d6e8629$var$kj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f716e3e58d6e8629$var$oj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f716e3e58d6e8629$var$fj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f716e3e58d6e8629$var$hj(null, b, d, $f716e3e58d6e8629$var$kg(d.type, a), c);
                        break a;
                }
                throw Error($f716e3e58d6e8629$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f716e3e58d6e8629$var$kg(d, e), $f716e3e58d6e8629$var$kj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f716e3e58d6e8629$var$kg(d, e), $f716e3e58d6e8629$var$oj(a, b, d, e, c);
        case 3:
            a: {
                $f716e3e58d6e8629$var$qj(b);
                if (null === a) throw Error($f716e3e58d6e8629$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f716e3e58d6e8629$var$yg(a, b);
                $f716e3e58d6e8629$var$Eg(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Error($f716e3e58d6e8629$var$p(423));
                        b = $f716e3e58d6e8629$var$rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Error($f716e3e58d6e8629$var$p(424));
                        b = $f716e3e58d6e8629$var$rj(a, b, d, c, e);
                        break a;
                    } else for($f716e3e58d6e8629$var$eh = $f716e3e58d6e8629$var$Kf(b.stateNode.containerInfo.firstChild), $f716e3e58d6e8629$var$dh = b, $f716e3e58d6e8629$var$I = !0, $f716e3e58d6e8629$var$fh = null, c = $f716e3e58d6e8629$var$zh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f716e3e58d6e8629$var$nh();
                    if (d === e) {
                        b = $f716e3e58d6e8629$var$gj(a, b, c);
                        break a;
                    }
                    $f716e3e58d6e8629$var$ej(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f716e3e58d6e8629$var$Hh(b), null === a && $f716e3e58d6e8629$var$kh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f716e3e58d6e8629$var$Df(d, e) ? g = null : null !== f && $f716e3e58d6e8629$var$Df(d, f) && (b.flags |= 32), $f716e3e58d6e8629$var$nj(a, b), $f716e3e58d6e8629$var$ej(a, b, g, c), b.child;
        case 6:
            return null === a && $f716e3e58d6e8629$var$kh(b), null;
        case 13:
            return $f716e3e58d6e8629$var$vj(a, b, c);
        case 4:
            return $f716e3e58d6e8629$var$Fh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f716e3e58d6e8629$var$yh(b, null, d, c) : $f716e3e58d6e8629$var$ej(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f716e3e58d6e8629$var$kg(d, e), $f716e3e58d6e8629$var$fj(a, b, d, e, c);
        case 7:
            return $f716e3e58d6e8629$var$ej(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f716e3e58d6e8629$var$ej(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f716e3e58d6e8629$var$ej(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f716e3e58d6e8629$var$G($f716e3e58d6e8629$var$lg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f716e3e58d6e8629$var$Ge(f.value, g)) {
                        if (f.children === e.children && !$f716e3e58d6e8629$var$Vf.current) {
                            b = $f716e3e58d6e8629$var$gj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f716e3e58d6e8629$var$zg(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f716e3e58d6e8629$var$rg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f716e3e58d6e8629$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f716e3e58d6e8629$var$rg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f716e3e58d6e8629$var$ej(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f716e3e58d6e8629$var$sg(b, c), e = $f716e3e58d6e8629$var$ug(e), d = d(e), b.flags |= 1, $f716e3e58d6e8629$var$ej(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f716e3e58d6e8629$var$kg(d, b.pendingProps), e = $f716e3e58d6e8629$var$kg(d.type, e), $f716e3e58d6e8629$var$hj(a, b, d, e, c);
        case 15:
            return $f716e3e58d6e8629$var$jj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f716e3e58d6e8629$var$kg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $f716e3e58d6e8629$var$Yf(d) ? (a = !0, $f716e3e58d6e8629$var$bg(b)) : a = !1, $f716e3e58d6e8629$var$sg(b, c), $f716e3e58d6e8629$var$Og(b, d, e), $f716e3e58d6e8629$var$Qg(b, d, e, c), $f716e3e58d6e8629$var$pj(null, b, d, !0, a, c);
        case 19:
            return $f716e3e58d6e8629$var$Ej(a, b, c);
        case 22:
            return $f716e3e58d6e8629$var$lj(a, b, c);
    }
    throw Error($f716e3e58d6e8629$var$p(156, b.tag));
};
function $f716e3e58d6e8629$var$Ek(a, b) {
    return $f716e3e58d6e8629$var$$b(a, b);
}
function $f716e3e58d6e8629$var$Zk(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f716e3e58d6e8629$var$hh(a, b, c, d) {
    return new $f716e3e58d6e8629$var$Zk(a, b, c, d);
}
function $f716e3e58d6e8629$var$ij(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f716e3e58d6e8629$var$Yk(a) {
    if ("function" === typeof a) return $f716e3e58d6e8629$var$ij(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f716e3e58d6e8629$var$Ca) return 11;
        if (a === $f716e3e58d6e8629$var$Fa) return 14;
    }
    return 2;
}
function $f716e3e58d6e8629$var$th(a, b) {
    var c = a.alternate;
    null === c ? (c = $f716e3e58d6e8629$var$hh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f716e3e58d6e8629$var$vh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f716e3e58d6e8629$var$ij(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f716e3e58d6e8629$var$wa:
            return $f716e3e58d6e8629$var$xh(c.children, e, f, b);
        case $f716e3e58d6e8629$var$xa:
            g = 8;
            e |= 8;
            break;
        case $f716e3e58d6e8629$var$za:
            return a = $f716e3e58d6e8629$var$hh(12, c, b, e | 2), a.elementType = $f716e3e58d6e8629$var$za, a.lanes = f, a;
        case $f716e3e58d6e8629$var$Da:
            return a = $f716e3e58d6e8629$var$hh(13, c, b, e), a.elementType = $f716e3e58d6e8629$var$Da, a.lanes = f, a;
        case $f716e3e58d6e8629$var$Ea:
            return a = $f716e3e58d6e8629$var$hh(19, c, b, e), a.elementType = $f716e3e58d6e8629$var$Ea, a.lanes = f, a;
        case $f716e3e58d6e8629$var$Ha:
            return $f716e3e58d6e8629$var$wj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f716e3e58d6e8629$var$Aa:
                    g = 10;
                    break a;
                case $f716e3e58d6e8629$var$Ba:
                    g = 9;
                    break a;
                case $f716e3e58d6e8629$var$Ca:
                    g = 11;
                    break a;
                case $f716e3e58d6e8629$var$Fa:
                    g = 14;
                    break a;
                case $f716e3e58d6e8629$var$Ga:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f716e3e58d6e8629$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f716e3e58d6e8629$var$hh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f716e3e58d6e8629$var$xh(a, b, c, d) {
    a = $f716e3e58d6e8629$var$hh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f716e3e58d6e8629$var$wj(a, b, c, d) {
    a = $f716e3e58d6e8629$var$hh(22, a, d, b);
    a.elementType = $f716e3e58d6e8629$var$Ha;
    a.lanes = c;
    a.stateNode = {};
    return a;
}
function $f716e3e58d6e8629$var$uh(a, b, c) {
    a = $f716e3e58d6e8629$var$hh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f716e3e58d6e8629$var$wh(a, b, c) {
    b = $f716e3e58d6e8629$var$hh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f716e3e58d6e8629$var$$k(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f716e3e58d6e8629$var$yc(0);
    this.expirationTimes = $f716e3e58d6e8629$var$yc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f716e3e58d6e8629$var$yc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f716e3e58d6e8629$var$al(a, b, c, d, e, f, g, h, k) {
    a = new $f716e3e58d6e8629$var$$k(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f716e3e58d6e8629$var$hh(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f716e3e58d6e8629$var$xg(f);
    return a;
}
function $f716e3e58d6e8629$var$bl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f716e3e58d6e8629$var$va,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f716e3e58d6e8629$var$cl(a) {
    if (!a) return $f716e3e58d6e8629$var$Uf;
    a = a._reactInternals;
    a: {
        if ($f716e3e58d6e8629$var$Ub(a) !== a || 1 !== a.tag) throw Error($f716e3e58d6e8629$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f716e3e58d6e8629$var$Yf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f716e3e58d6e8629$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f716e3e58d6e8629$var$Yf(c)) return $f716e3e58d6e8629$var$ag(a, c, b);
    }
    return b;
}
function $f716e3e58d6e8629$var$dl(a, b, c, d, e, f, g, h, k) {
    a = $f716e3e58d6e8629$var$al(c, d, !0, a, e, f, g, h, k);
    a.context = $f716e3e58d6e8629$var$cl(null);
    c = a.current;
    d = $f716e3e58d6e8629$var$Jg();
    e = $f716e3e58d6e8629$var$Kg(c);
    f = $f716e3e58d6e8629$var$zg(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f716e3e58d6e8629$var$Ag(c, f);
    a.current.lanes = e;
    $f716e3e58d6e8629$var$zc(a, e, d);
    $f716e3e58d6e8629$var$Ck(a, d);
    return a;
}
function $f716e3e58d6e8629$var$el(a, b, c, d) {
    var e = b.current, f = $f716e3e58d6e8629$var$Jg(), g = $f716e3e58d6e8629$var$Kg(e);
    c = $f716e3e58d6e8629$var$cl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f716e3e58d6e8629$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $f716e3e58d6e8629$var$Ag(e, b);
    a = $f716e3e58d6e8629$var$Lg(e, g, f);
    null !== a && $f716e3e58d6e8629$var$Cg(a, e, g);
    return g;
}
function $f716e3e58d6e8629$var$fl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f716e3e58d6e8629$var$gl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f716e3e58d6e8629$var$hl(a, b) {
    $f716e3e58d6e8629$var$gl(a, b);
    (a = a.alternate) && $f716e3e58d6e8629$var$gl(a, b);
}
function $f716e3e58d6e8629$var$il() {
    return null;
}
var $f716e3e58d6e8629$var$jl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f716e3e58d6e8629$var$kl(a) {
    this._internalRoot = a;
}
$f716e3e58d6e8629$var$ll.prototype.render = $f716e3e58d6e8629$var$kl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f716e3e58d6e8629$var$p(409));
    $f716e3e58d6e8629$var$el(a, b, null, null);
};
$f716e3e58d6e8629$var$ll.prototype.unmount = $f716e3e58d6e8629$var$kl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f716e3e58d6e8629$var$Qk(function() {
            $f716e3e58d6e8629$var$el(null, a, null, null);
        });
        b[$f716e3e58d6e8629$var$tf] = null;
    }
};
function $f716e3e58d6e8629$var$ll(a) {
    this._internalRoot = a;
}
$f716e3e58d6e8629$var$ll.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f716e3e58d6e8629$var$Gc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f716e3e58d6e8629$var$Pc.length && 0 !== b && b < $f716e3e58d6e8629$var$Pc[c].priority; c++);
        $f716e3e58d6e8629$var$Pc.splice(c, 0, a);
        0 === c && $f716e3e58d6e8629$var$Uc(a);
    }
};
function $f716e3e58d6e8629$var$ml(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f716e3e58d6e8629$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f716e3e58d6e8629$var$ol() {}
function $f716e3e58d6e8629$var$pl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f716e3e58d6e8629$var$fl(g);
                f.call(a);
            };
        }
        var g = $f716e3e58d6e8629$var$dl(b, d, a, 0, null, !1, !1, "", $f716e3e58d6e8629$var$ol);
        a._reactRootContainer = g;
        a[$f716e3e58d6e8629$var$tf] = g.current;
        $f716e3e58d6e8629$var$rf(8 === a.nodeType ? a.parentNode : a);
        $f716e3e58d6e8629$var$Qk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f716e3e58d6e8629$var$fl(k);
            h.call(a);
        };
    }
    var k = $f716e3e58d6e8629$var$al(a, 0, !1, null, null, !1, !1, "", $f716e3e58d6e8629$var$ol);
    a._reactRootContainer = k;
    a[$f716e3e58d6e8629$var$tf] = k.current;
    $f716e3e58d6e8629$var$rf(8 === a.nodeType ? a.parentNode : a);
    $f716e3e58d6e8629$var$Qk(function() {
        $f716e3e58d6e8629$var$el(b, k, c, d);
    });
    return k;
}
function $f716e3e58d6e8629$var$ql(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f716e3e58d6e8629$var$fl(g);
                h.call(a);
            };
        }
        $f716e3e58d6e8629$var$el(b, g, a, e);
    } else g = $f716e3e58d6e8629$var$pl(c, b, a, e, d);
    return $f716e3e58d6e8629$var$fl(g);
}
$f716e3e58d6e8629$var$Dc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f716e3e58d6e8629$var$sc(b.pendingLanes);
                0 !== c && ($f716e3e58d6e8629$var$Bc(b, c | 1), $f716e3e58d6e8629$var$Ck(b, $f716e3e58d6e8629$var$B()), 0 === ($f716e3e58d6e8629$var$W & 6) && ($f716e3e58d6e8629$var$aj = $f716e3e58d6e8629$var$B() + 500, $f716e3e58d6e8629$var$ig()));
            }
            break;
        case 13:
            var d = $f716e3e58d6e8629$var$Jg();
            $f716e3e58d6e8629$var$Qk(function() {
                return $f716e3e58d6e8629$var$Lg(a, 1, d);
            });
            $f716e3e58d6e8629$var$hl(a, 1);
    }
};
$f716e3e58d6e8629$var$Ec = function(a) {
    if (13 === a.tag) {
        var b = $f716e3e58d6e8629$var$Jg();
        $f716e3e58d6e8629$var$Lg(a, 134217728, b);
        $f716e3e58d6e8629$var$hl(a, 134217728);
    }
};
$f716e3e58d6e8629$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f716e3e58d6e8629$var$Jg(), c = $f716e3e58d6e8629$var$Kg(a);
        $f716e3e58d6e8629$var$Lg(a, c, b);
        $f716e3e58d6e8629$var$hl(a, c);
    }
};
$f716e3e58d6e8629$var$Gc = function() {
    return $f716e3e58d6e8629$var$C;
};
$f716e3e58d6e8629$var$Hc = function(a, b) {
    var c = $f716e3e58d6e8629$var$C;
    try {
        return $f716e3e58d6e8629$var$C = a, b();
    } finally{
        $f716e3e58d6e8629$var$C = c;
    }
};
$f716e3e58d6e8629$var$xb = function(a, b, c) {
    switch(b){
        case "input":
            $f716e3e58d6e8629$var$$a(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f716e3e58d6e8629$var$Cb(d);
                        if (!e) throw Error($f716e3e58d6e8629$var$p(90));
                        $f716e3e58d6e8629$var$Va(d);
                        $f716e3e58d6e8629$var$$a(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f716e3e58d6e8629$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $f716e3e58d6e8629$var$eb(a, !!c.multiple, b, !1);
    }
};
$f716e3e58d6e8629$var$Fb = $f716e3e58d6e8629$var$Pk;
$f716e3e58d6e8629$var$Gb = $f716e3e58d6e8629$var$Qk;
var $f716e3e58d6e8629$var$rl = {
    usingClientEntryPoint: !1,
    Events: [
        $f716e3e58d6e8629$var$Bb,
        $f716e3e58d6e8629$var$te,
        $f716e3e58d6e8629$var$Cb,
        $f716e3e58d6e8629$var$Db,
        $f716e3e58d6e8629$var$Eb,
        $f716e3e58d6e8629$var$Pk
    ]
}, $f716e3e58d6e8629$var$sl = {
    findFiberByHostInstance: $f716e3e58d6e8629$var$Vc,
    bundleType: 0,
    version: "18.1.0",
    rendererPackageName: "react-dom"
};
var $f716e3e58d6e8629$var$tl = {
    bundleType: $f716e3e58d6e8629$var$sl.bundleType,
    version: $f716e3e58d6e8629$var$sl.version,
    rendererPackageName: $f716e3e58d6e8629$var$sl.rendererPackageName,
    rendererConfig: $f716e3e58d6e8629$var$sl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f716e3e58d6e8629$var$ta.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f716e3e58d6e8629$var$Yb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f716e3e58d6e8629$var$sl.findFiberByHostInstance || $f716e3e58d6e8629$var$il,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.1.0-next-22edb9f77-20220426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f716e3e58d6e8629$var$ul = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f716e3e58d6e8629$var$ul.isDisabled && $f716e3e58d6e8629$var$ul.supportsFiber) try {
        $f716e3e58d6e8629$var$jc = $f716e3e58d6e8629$var$ul.inject($f716e3e58d6e8629$var$tl), $f716e3e58d6e8629$var$kc = $f716e3e58d6e8629$var$ul;
    } catch (a) {}
}
$f716e3e58d6e8629$export$ae55be85d98224ed = $f716e3e58d6e8629$var$rl;
$f716e3e58d6e8629$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f716e3e58d6e8629$var$ml(b)) throw Error($f716e3e58d6e8629$var$p(200));
    return $f716e3e58d6e8629$var$bl(a, b, null, c);
};
$f716e3e58d6e8629$export$882461b6382ed46c = function(a, b) {
    if (!$f716e3e58d6e8629$var$ml(a)) throw Error($f716e3e58d6e8629$var$p(299));
    var c = !1, d = "", e = $f716e3e58d6e8629$var$jl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f716e3e58d6e8629$var$al(a, 1, !1, null, null, c, !1, d, e);
    a[$f716e3e58d6e8629$var$tf] = b.current;
    $f716e3e58d6e8629$var$rf(8 === a.nodeType ? a.parentNode : a);
    return new $f716e3e58d6e8629$var$kl(b);
};
$f716e3e58d6e8629$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f716e3e58d6e8629$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f716e3e58d6e8629$var$p(268, a));
    }
    a = $f716e3e58d6e8629$var$Yb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f716e3e58d6e8629$export$cd75ccfd720a3cd4 = function(a) {
    return $f716e3e58d6e8629$var$Qk(a);
};
$f716e3e58d6e8629$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f716e3e58d6e8629$var$nl(b)) throw Error($f716e3e58d6e8629$var$p(200));
    return $f716e3e58d6e8629$var$ql(null, a, b, !0, c);
};
$f716e3e58d6e8629$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f716e3e58d6e8629$var$ml(a)) throw Error($f716e3e58d6e8629$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f716e3e58d6e8629$var$jl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f716e3e58d6e8629$var$dl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f716e3e58d6e8629$var$tf] = b.current;
    $f716e3e58d6e8629$var$rf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f716e3e58d6e8629$var$ll(b);
};
$f716e3e58d6e8629$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f716e3e58d6e8629$var$nl(b)) throw Error($f716e3e58d6e8629$var$p(200));
    return $f716e3e58d6e8629$var$ql(null, a, b, !1, c);
};
$f716e3e58d6e8629$export$502457920280e6be = function(a) {
    if (!$f716e3e58d6e8629$var$nl(a)) throw Error($f716e3e58d6e8629$var$p(40));
    return a._reactRootContainer ? ($f716e3e58d6e8629$var$Qk(function() {
        $f716e3e58d6e8629$var$ql(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f716e3e58d6e8629$var$tf] = null;
        });
    }), !0) : !1;
};
$f716e3e58d6e8629$export$c78a37762a8d58e1 = $f716e3e58d6e8629$var$Pk;
$f716e3e58d6e8629$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f716e3e58d6e8629$var$nl(c)) throw Error($f716e3e58d6e8629$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f716e3e58d6e8629$var$p(38));
    return $f716e3e58d6e8629$var$ql(a, b, c, !1, d);
};
$f716e3e58d6e8629$export$83d89fbfd8236492 = "18.1.0-next-22edb9f77-20220426";

});
parcelRegister("c2cCr", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jA2H2"));

});
parcelRegister("jA2H2", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e41377ef566186ed$export$c4744153514ff05d; }, function (v) { return $e41377ef566186ed$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e41377ef566186ed$export$3e506c1ccc9cc1a7; }, function (v) { return $e41377ef566186ed$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e41377ef566186ed$export$e26fe2ed2fa76875; }, function (v) { return $e41377ef566186ed$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e41377ef566186ed$export$502329bbf4b505b1; }, function (v) { return $e41377ef566186ed$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e41377ef566186ed$export$6e3807111c4874c4; }, function (v) { return $e41377ef566186ed$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e41377ef566186ed$export$c27134553091fb3a; }, function (v) { return $e41377ef566186ed$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e41377ef566186ed$export$33ee1acdc04fd2a2; }, function (v) { return $e41377ef566186ed$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e41377ef566186ed$export$b00a404bbd5edef2; }, function (v) { return $e41377ef566186ed$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e41377ef566186ed$export$8352ce38b91d0c62; }, function (v) { return $e41377ef566186ed$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e41377ef566186ed$export$d66a1c1c77bd778b; }, function (v) { return $e41377ef566186ed$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e41377ef566186ed$export$d3dfb8e4810cb555; }, function (v) { return $e41377ef566186ed$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e41377ef566186ed$export$839f9183b0465a69; }, function (v) { return $e41377ef566186ed$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e41377ef566186ed$export$72fdf0e06517287b; }, function (v) { return $e41377ef566186ed$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e41377ef566186ed$export$4b844e58a3e414b4; }, function (v) { return $e41377ef566186ed$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e41377ef566186ed$export$816d2913ae6b83b1; }, function (v) { return $e41377ef566186ed$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e41377ef566186ed$export$61bcfe829111a1d0; }, function (v) { return $e41377ef566186ed$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e41377ef566186ed$export$7ee8c9beb337bc3f; }, function (v) { return $e41377ef566186ed$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e41377ef566186ed$export$b5836b71941fa3ed; }, function (v) { return $e41377ef566186ed$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e41377ef566186ed$export$cf845f2c119da08a; }, function (v) { return $e41377ef566186ed$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e41377ef566186ed$export$c4744153514ff05d;
var $e41377ef566186ed$export$3e506c1ccc9cc1a7;
var $e41377ef566186ed$export$e26fe2ed2fa76875;
var $e41377ef566186ed$export$502329bbf4b505b1;
var $e41377ef566186ed$export$6e3807111c4874c4;
var $e41377ef566186ed$export$c27134553091fb3a;
var $e41377ef566186ed$export$33ee1acdc04fd2a2;
var $e41377ef566186ed$export$b00a404bbd5edef2;
var $e41377ef566186ed$export$8352ce38b91d0c62;
var $e41377ef566186ed$export$d66a1c1c77bd778b;
var $e41377ef566186ed$export$d3dfb8e4810cb555;
var $e41377ef566186ed$export$839f9183b0465a69;
var $e41377ef566186ed$export$72fdf0e06517287b;
var $e41377ef566186ed$export$4b844e58a3e414b4;
var $e41377ef566186ed$export$816d2913ae6b83b1;
var $e41377ef566186ed$export$61bcfe829111a1d0;
var $e41377ef566186ed$export$7ee8c9beb337bc3f;
var $e41377ef566186ed$export$b5836b71941fa3ed;
var $e41377ef566186ed$export$cf845f2c119da08a;
"use strict";
function $e41377ef566186ed$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e41377ef566186ed$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e41377ef566186ed$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e41377ef566186ed$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e41377ef566186ed$var$g(C, c)) n < e && 0 > $e41377ef566186ed$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e41377ef566186ed$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e41377ef566186ed$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e41377ef566186ed$var$l = performance;
    $e41377ef566186ed$export$c4744153514ff05d = function() {
        return $e41377ef566186ed$var$l.now();
    };
} else {
    var $e41377ef566186ed$var$p = Date, $e41377ef566186ed$var$q = $e41377ef566186ed$var$p.now();
    $e41377ef566186ed$export$c4744153514ff05d = function() {
        return $e41377ef566186ed$var$p.now() - $e41377ef566186ed$var$q;
    };
}
var $e41377ef566186ed$var$r = [], $e41377ef566186ed$var$t = [], $e41377ef566186ed$var$u = 1, $e41377ef566186ed$var$v = null, $e41377ef566186ed$var$y = 3, $e41377ef566186ed$var$z = !1, $e41377ef566186ed$var$A = !1, $e41377ef566186ed$var$B = !1, $e41377ef566186ed$var$D = "function" === typeof setTimeout ? setTimeout : null, $e41377ef566186ed$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e41377ef566186ed$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e41377ef566186ed$var$G(a) {
    for(var b = $e41377ef566186ed$var$h($e41377ef566186ed$var$t); null !== b;){
        if (null === b.callback) $e41377ef566186ed$var$k($e41377ef566186ed$var$t);
        else if (b.startTime <= a) $e41377ef566186ed$var$k($e41377ef566186ed$var$t), b.sortIndex = b.expirationTime, $e41377ef566186ed$var$f($e41377ef566186ed$var$r, b);
        else break;
        b = $e41377ef566186ed$var$h($e41377ef566186ed$var$t);
    }
}
function $e41377ef566186ed$var$H(a) {
    $e41377ef566186ed$var$B = !1;
    $e41377ef566186ed$var$G(a);
    if (!$e41377ef566186ed$var$A) {
        if (null !== $e41377ef566186ed$var$h($e41377ef566186ed$var$r)) $e41377ef566186ed$var$A = !0, $e41377ef566186ed$var$I($e41377ef566186ed$var$J);
        else {
            var b = $e41377ef566186ed$var$h($e41377ef566186ed$var$t);
            null !== b && $e41377ef566186ed$var$K($e41377ef566186ed$var$H, b.startTime - a);
        }
    }
}
function $e41377ef566186ed$var$J(a, b) {
    $e41377ef566186ed$var$A = !1;
    $e41377ef566186ed$var$B && ($e41377ef566186ed$var$B = !1, $e41377ef566186ed$var$E($e41377ef566186ed$var$L), $e41377ef566186ed$var$L = -1);
    $e41377ef566186ed$var$z = !0;
    var c = $e41377ef566186ed$var$y;
    try {
        $e41377ef566186ed$var$G(b);
        for($e41377ef566186ed$var$v = $e41377ef566186ed$var$h($e41377ef566186ed$var$r); null !== $e41377ef566186ed$var$v && (!($e41377ef566186ed$var$v.expirationTime > b) || a && !$e41377ef566186ed$var$M());){
            var d = $e41377ef566186ed$var$v.callback;
            if ("function" === typeof d) {
                $e41377ef566186ed$var$v.callback = null;
                $e41377ef566186ed$var$y = $e41377ef566186ed$var$v.priorityLevel;
                var e = d($e41377ef566186ed$var$v.expirationTime <= b);
                b = $e41377ef566186ed$export$c4744153514ff05d();
                "function" === typeof e ? $e41377ef566186ed$var$v.callback = e : $e41377ef566186ed$var$v === $e41377ef566186ed$var$h($e41377ef566186ed$var$r) && $e41377ef566186ed$var$k($e41377ef566186ed$var$r);
                $e41377ef566186ed$var$G(b);
            } else $e41377ef566186ed$var$k($e41377ef566186ed$var$r);
            $e41377ef566186ed$var$v = $e41377ef566186ed$var$h($e41377ef566186ed$var$r);
        }
        if (null !== $e41377ef566186ed$var$v) var w = !0;
        else {
            var m = $e41377ef566186ed$var$h($e41377ef566186ed$var$t);
            null !== m && $e41377ef566186ed$var$K($e41377ef566186ed$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e41377ef566186ed$var$v = null, $e41377ef566186ed$var$y = c, $e41377ef566186ed$var$z = !1;
    }
}
var $e41377ef566186ed$var$N = !1, $e41377ef566186ed$var$O = null, $e41377ef566186ed$var$L = -1, $e41377ef566186ed$var$P = 5, $e41377ef566186ed$var$Q = -1;
function $e41377ef566186ed$var$M() {
    return $e41377ef566186ed$export$c4744153514ff05d() - $e41377ef566186ed$var$Q < $e41377ef566186ed$var$P ? !1 : !0;
}
function $e41377ef566186ed$var$R() {
    if (null !== $e41377ef566186ed$var$O) {
        var a = $e41377ef566186ed$export$c4744153514ff05d();
        $e41377ef566186ed$var$Q = a;
        var b = !0;
        try {
            b = $e41377ef566186ed$var$O(!0, a);
        } finally{
            b ? $e41377ef566186ed$var$S() : ($e41377ef566186ed$var$N = !1, $e41377ef566186ed$var$O = null);
        }
    } else $e41377ef566186ed$var$N = !1;
}
var $e41377ef566186ed$var$S;
if ("function" === typeof $e41377ef566186ed$var$F) $e41377ef566186ed$var$S = function() {
    $e41377ef566186ed$var$F($e41377ef566186ed$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e41377ef566186ed$var$T = new MessageChannel, $e41377ef566186ed$var$U = $e41377ef566186ed$var$T.port2;
    $e41377ef566186ed$var$T.port1.onmessage = $e41377ef566186ed$var$R;
    $e41377ef566186ed$var$S = function() {
        $e41377ef566186ed$var$U.postMessage(null);
    };
} else $e41377ef566186ed$var$S = function() {
    $e41377ef566186ed$var$D($e41377ef566186ed$var$R, 0);
};
function $e41377ef566186ed$var$I(a) {
    $e41377ef566186ed$var$O = a;
    $e41377ef566186ed$var$N || ($e41377ef566186ed$var$N = !0, $e41377ef566186ed$var$S());
}
function $e41377ef566186ed$var$K(a, b) {
    $e41377ef566186ed$var$L = $e41377ef566186ed$var$D(function() {
        a($e41377ef566186ed$export$c4744153514ff05d());
    }, b);
}
$e41377ef566186ed$export$3e506c1ccc9cc1a7 = 5;
$e41377ef566186ed$export$e26fe2ed2fa76875 = 1;
$e41377ef566186ed$export$502329bbf4b505b1 = 4;
$e41377ef566186ed$export$6e3807111c4874c4 = 3;
$e41377ef566186ed$export$c27134553091fb3a = null;
$e41377ef566186ed$export$33ee1acdc04fd2a2 = 2;
$e41377ef566186ed$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e41377ef566186ed$export$8352ce38b91d0c62 = function() {
    $e41377ef566186ed$var$A || $e41377ef566186ed$var$z || ($e41377ef566186ed$var$A = !0, $e41377ef566186ed$var$I($e41377ef566186ed$var$J));
};
$e41377ef566186ed$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e41377ef566186ed$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e41377ef566186ed$export$d3dfb8e4810cb555 = function() {
    return $e41377ef566186ed$var$y;
};
$e41377ef566186ed$export$839f9183b0465a69 = function() {
    return $e41377ef566186ed$var$h($e41377ef566186ed$var$r);
};
$e41377ef566186ed$export$72fdf0e06517287b = function(a) {
    switch($e41377ef566186ed$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e41377ef566186ed$var$y;
    }
    var c = $e41377ef566186ed$var$y;
    $e41377ef566186ed$var$y = b;
    try {
        return a();
    } finally{
        $e41377ef566186ed$var$y = c;
    }
};
$e41377ef566186ed$export$4b844e58a3e414b4 = function() {};
$e41377ef566186ed$export$816d2913ae6b83b1 = function() {};
$e41377ef566186ed$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e41377ef566186ed$var$y;
    $e41377ef566186ed$var$y = a;
    try {
        return b();
    } finally{
        $e41377ef566186ed$var$y = c;
    }
};
$e41377ef566186ed$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e41377ef566186ed$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e41377ef566186ed$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e41377ef566186ed$var$f($e41377ef566186ed$var$t, a), null === $e41377ef566186ed$var$h($e41377ef566186ed$var$r) && a === $e41377ef566186ed$var$h($e41377ef566186ed$var$t) && ($e41377ef566186ed$var$B ? ($e41377ef566186ed$var$E($e41377ef566186ed$var$L), $e41377ef566186ed$var$L = -1) : $e41377ef566186ed$var$B = !0, $e41377ef566186ed$var$K($e41377ef566186ed$var$H, c - d))) : (a.sortIndex = e, $e41377ef566186ed$var$f($e41377ef566186ed$var$r, a), $e41377ef566186ed$var$A || $e41377ef566186ed$var$z || ($e41377ef566186ed$var$A = !0, $e41377ef566186ed$var$I($e41377ef566186ed$var$J)));
    return a;
};
$e41377ef566186ed$export$b5836b71941fa3ed = $e41377ef566186ed$var$M;
$e41377ef566186ed$export$cf845f2c119da08a = function(a) {
    var b = $e41377ef566186ed$var$y;
    return function() {
        var c = $e41377ef566186ed$var$y;
        $e41377ef566186ed$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e41377ef566186ed$var$y = c;
        }
    };
};

});




parcelRegister("dsvUQ", function(module, exports) {
$parcel$export(module.exports, "__RouterContext", function () { return (parcelRequire("dih0O")).__RouterContext; });
$parcel$export(module.exports, "matchPath", function () { return (parcelRequire("dih0O")).matchPath; });
$parcel$export(module.exports, "Redirect", function () { return (parcelRequire("dih0O")).Redirect; });
$parcel$export(module.exports, "Route", function () { return (parcelRequire("dih0O")).Route; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("dih0O")).Router; });
$parcel$export(module.exports, "Switch", function () { return (parcelRequire("dih0O")).Switch; });
$parcel$export(module.exports, "useHistory", function () { return (parcelRequire("dih0O")).useHistory; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("dih0O")).useLocation; });
$parcel$export(module.exports, "useParams", function () { return (parcelRequire("dih0O")).useParams; });
$parcel$export(module.exports, "useRouteMatch", function () { return (parcelRequire("dih0O")).useRouteMatch; });

$parcel$export(module.exports, "BrowserRouter", function () { return $9cc6a5b0b922b332$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $9cc6a5b0b922b332$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $9cc6a5b0b922b332$export$b0d92dbee9b5b60d; });

var $dih0O = parcelRequire("dih0O");

var $1hm3X = parcelRequire("1hm3X");

var $70fFQ = parcelRequire("70fFQ");

var $lw2Im = parcelRequire("lw2Im");



var $iBVPT = parcelRequire("iBVPT");

var $fxhIv = parcelRequire("fxhIv");

var $1ayQT = parcelRequire("1ayQT");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $9cc6a5b0b922b332$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $1hm3X.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $lw2Im.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $dih0O.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $9cc6a5b0b922b332$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $1hm3X.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $lw2Im.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $dih0O.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
var $9cc6a5b0b922b332$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $9cc6a5b0b922b332$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $lw2Im.createLocation)(to, null, null, currentLocation) : to;
};
var $9cc6a5b0b922b332$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $9cc6a5b0b922b332$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef;
if (typeof $9cc6a5b0b922b332$var$forwardRef === "undefined") $9cc6a5b0b922b332$var$forwardRef = $9cc6a5b0b922b332$var$forwardRefShim;
function $9cc6a5b0b922b332$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $9cc6a5b0b922b332$var$LinkAnchor = $9cc6a5b0b922b332$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $fxhIv.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $iBVPT.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$9cc6a5b0b922b332$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($9cc6a5b0b922b332$var$forwardRefShim !== $9cc6a5b0b922b332$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $9cc6a5b0b922b332$export$a6c7ac8248d6e38a = $9cc6a5b0b922b332$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $9cc6a5b0b922b332$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $fxhIv.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $dih0O.__RouterContext).Consumer, null, function(context) {
        !context && (0, $1ayQT.default)(false);
        var history = context.history;
        var location = $9cc6a5b0b922b332$var$normalizeToLocation($9cc6a5b0b922b332$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $iBVPT.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $9cc6a5b0b922b332$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($9cc6a5b0b922b332$var$forwardRefShim !== $9cc6a5b0b922b332$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(component, props);
    });
});
var $9cc6a5b0b922b332$var$toType, $9cc6a5b0b922b332$var$refType;
var $9cc6a5b0b922b332$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $9cc6a5b0b922b332$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).forwardRef;
if (typeof $9cc6a5b0b922b332$var$forwardRef$1 === "undefined") $9cc6a5b0b922b332$var$forwardRef$1 = $9cc6a5b0b922b332$var$forwardRefShim$1;
function $9cc6a5b0b922b332$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $9cc6a5b0b922b332$export$b0d92dbee9b5b60d = $9cc6a5b0b922b332$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $fxhIv.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $dih0O.__RouterContext).Consumer, null, function(context) {
        !context && (0, $1ayQT.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $9cc6a5b0b922b332$var$normalizeToLocation($9cc6a5b0b922b332$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $dih0O.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $9cc6a5b0b922b332$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $iBVPT.default)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $iBVPT.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($9cc6a5b0b922b332$var$forwardRefShim$1 !== $9cc6a5b0b922b332$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9cc6a5b0b922b332$export$a6c7ac8248d6e38a, props);
    });
});
var $9cc6a5b0b922b332$var$ariaCurrentType;

});
parcelRegister("dih0O", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $9ada270afa9d29fb$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $9ada270afa9d29fb$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Redirect", function () { return $9ada270afa9d29fb$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "matchPath", function () { return $9ada270afa9d29fb$export$81336c211d5ff295; });
$parcel$export(module.exports, "Route", function () { return $9ada270afa9d29fb$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Switch", function () { return $9ada270afa9d29fb$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "useHistory", function () { return $9ada270afa9d29fb$export$3420e1dc2c4a518c; });
$parcel$export(module.exports, "useLocation", function () { return $9ada270afa9d29fb$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useParams", function () { return $9ada270afa9d29fb$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteMatch", function () { return $9ada270afa9d29fb$export$632be4bb944c1bc7; });

var $c6Dbg = parcelRequire("c6Dbg");

var $70fFQ = parcelRequire("70fFQ");


var $lw2Im = parcelRequire("lw2Im");


var $al2p2 = parcelRequire("al2p2");

var $1ayQT = parcelRequire("1ayQT");

var $iMVXs = parcelRequire("iMVXs");

var $39sv4 = parcelRequire("39sv4");
parcelRequire("3HbWh");

var $5uOBs = parcelRequire("5uOBs");

var $55VV8 = parcelRequire("55VV8");
// TODO: Replace with React.createContext once we can assume React 16+
var $9ada270afa9d29fb$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $al2p2.default)();
    context.displayName = name;
    return context;
};
var $9ada270afa9d29fb$export$63baa8ccbe60bb07 = /*#__PURE__*/ $9ada270afa9d29fb$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $9ada270afa9d29fb$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $c6Dbg.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$63baa8ccbe60bb07.Provider, {
            children: this.props.children || null,
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        });
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $9ada270afa9d29fb$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $c6Dbg.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $lw2Im.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
var $9ada270afa9d29fb$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $c6Dbg.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $9ada270afa9d29fb$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $1ayQT.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $9ada270afa9d29fb$var$messageType;
var $9ada270afa9d29fb$var$cache = {};
var $9ada270afa9d29fb$var$cacheLimit = 10000;
var $9ada270afa9d29fb$var$cacheCount = 0;
function $9ada270afa9d29fb$var$compilePath(path) {
    if ($9ada270afa9d29fb$var$cache[path]) return $9ada270afa9d29fb$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($39sv4))).compile(path);
    if ($9ada270afa9d29fb$var$cacheCount < $9ada270afa9d29fb$var$cacheLimit) {
        $9ada270afa9d29fb$var$cache[path] = generator;
        $9ada270afa9d29fb$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $9ada270afa9d29fb$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $9ada270afa9d29fb$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $9ada270afa9d29fb$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $1ayQT.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $lw2Im.createLocation)(computedMatch ? typeof to === "string" ? $9ada270afa9d29fb$export$82476f982757e71e(to, computedMatch.params) : (0, $iMVXs.default)({}, to, {
            pathname: $9ada270afa9d29fb$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $lw2Im.createLocation)(prevProps.to);
                if (!(0, $lw2Im.locationsAreEqual)(prevLocation, (0, $iMVXs.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $9ada270afa9d29fb$var$cache$1 = {};
var $9ada270afa9d29fb$var$cacheLimit$1 = 10000;
var $9ada270afa9d29fb$var$cacheCount$1 = 0;
function $9ada270afa9d29fb$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $9ada270afa9d29fb$var$cache$1[cacheKey] || ($9ada270afa9d29fb$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($39sv4)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($9ada270afa9d29fb$var$cacheCount$1 < $9ada270afa9d29fb$var$cacheLimit$1) {
        pathCache[path] = result;
        $9ada270afa9d29fb$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $9ada270afa9d29fb$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $9ada270afa9d29fb$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $9ada270afa9d29fb$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.count(children) === 0;
}
function $9ada270afa9d29fb$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $9ada270afa9d29fb$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $c6Dbg.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $1ayQT.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $9ada270afa9d29fb$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $iMVXs.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
function $9ada270afa9d29fb$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $9ada270afa9d29fb$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $iMVXs.default)({}, location, {
        pathname: $9ada270afa9d29fb$var$addLeadingSlash(basename) + location.pathname
    });
}
function $9ada270afa9d29fb$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $9ada270afa9d29fb$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $iMVXs.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $9ada270afa9d29fb$var$createURL(location) {
    return typeof location === "string" ? location : (0, $lw2Im.createPath)(location);
}
function $9ada270afa9d29fb$var$staticHandler(methodName) {
    return function() {
        (0, $1ayQT.default)(false);
    };
}
function $9ada270afa9d29fb$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $9ada270afa9d29fb$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $c6Dbg.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $9ada270afa9d29fb$var$noop;
        };
        _this.handleBlock = function() {
            return $9ada270afa9d29fb$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $9ada270afa9d29fb$var$addBasename(basename, (0, $lw2Im.createLocation)(location));
        context.url = $9ada270afa9d29fb$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $5uOBs.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $9ada270afa9d29fb$var$addLeadingSlash(basename + $9ada270afa9d29fb$var$createURL(path));
            },
            action: "POP",
            location: $9ada270afa9d29fb$var$stripBasename(basename, (0, $lw2Im.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $9ada270afa9d29fb$var$staticHandler("go"),
            goBack: $9ada270afa9d29fb$var$staticHandler("goBack"),
            goForward: $9ada270afa9d29fb$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$55185c17a0fcbe46, (0, $iMVXs.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $9ada270afa9d29fb$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $c6Dbg.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $1ayQT.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $9ada270afa9d29fb$export$81336c211d5ff295(location.pathname, (0, $iMVXs.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $9ada270afa9d29fb$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $5uOBs.default)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($9ada270afa9d29fb$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $1ayQT.default)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(Component, (0, $iMVXs.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($55VV8)))(C, Component);
}
var $9ada270afa9d29fb$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useContext;
function $9ada270afa9d29fb$export$3420e1dc2c4a518c() {
    return $9ada270afa9d29fb$var$useContext($9ada270afa9d29fb$export$63baa8ccbe60bb07).history;
}
function $9ada270afa9d29fb$export$45d76561a5302f2b() {
    return $9ada270afa9d29fb$var$useContext($9ada270afa9d29fb$export$63baa8ccbe60bb07).location;
}
function $9ada270afa9d29fb$export$99eaa27ddbbb95ef() {
    var match = $9ada270afa9d29fb$var$useContext($9ada270afa9d29fb$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $9ada270afa9d29fb$export$632be4bb944c1bc7(path) {
    return path ? $9ada270afa9d29fb$export$81336c211d5ff295($9ada270afa9d29fb$export$45d76561a5302f2b().pathname, path) : $9ada270afa9d29fb$var$useContext($9ada270afa9d29fb$export$63baa8ccbe60bb07).match;
}
var $9ada270afa9d29fb$var$global, $9ada270afa9d29fb$var$key, $9ada270afa9d29fb$var$buildNames, $9ada270afa9d29fb$var$initialBuildName, $9ada270afa9d29fb$var$secondaryBuildName;

});
parcelRegister("c6Dbg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d04700507130a65$export$2e2bcd8739ae039; });
function $8d04700507130a65$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

});

parcelRegister("lw2Im", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $fa9eb12b8acccbff$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $fa9eb12b8acccbff$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $fa9eb12b8acccbff$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $fa9eb12b8acccbff$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $fa9eb12b8acccbff$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $fa9eb12b8acccbff$export$2b76ad033c6e6d08; });

var $adToP = parcelRequire("adToP");

var $1hgYx = parcelRequire("1hgYx");

var $9yFSs = parcelRequire("9yFSs");


var $1ayQT = parcelRequire("1ayQT");
function $fa9eb12b8acccbff$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $fa9eb12b8acccbff$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $fa9eb12b8acccbff$var$hasBasename(path, prefix) {
    return new RegExp("^" + prefix + "(\\/|\\?|#|$)", "i").test(path);
}
function $fa9eb12b8acccbff$var$stripBasename(path, prefix) {
    return $fa9eb12b8acccbff$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $fa9eb12b8acccbff$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $fa9eb12b8acccbff$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $fa9eb12b8acccbff$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $fa9eb12b8acccbff$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $fa9eb12b8acccbff$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $adToP.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $1hgYx.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $fa9eb12b8acccbff$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9yFSs.default)(a.state, b.state);
}
function $fa9eb12b8acccbff$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $fa9eb12b8acccbff$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $fa9eb12b8acccbff$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $fa9eb12b8acccbff$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $fa9eb12b8acccbff$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $fa9eb12b8acccbff$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $fa9eb12b8acccbff$var$isExtraneousPopstateEvent(event) {
    event.state === undefined && navigator.userAgent.indexOf("CriOS");
}
var $fa9eb12b8acccbff$var$PopStateEvent = "popstate";
var $fa9eb12b8acccbff$var$HashChangeEvent = "hashchange";
function $fa9eb12b8acccbff$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $fa9eb12b8acccbff$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$fa9eb12b8acccbff$var$canUseDOM && (0, $1ayQT.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $fa9eb12b8acccbff$var$supportsHistory();
    var needsHashChangeListener = !$fa9eb12b8acccbff$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $fa9eb12b8acccbff$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $fa9eb12b8acccbff$var$stripTrailingSlash($fa9eb12b8acccbff$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $fa9eb12b8acccbff$var$stripBasename(path, basename);
        return $fa9eb12b8acccbff$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $fa9eb12b8acccbff$var$createTransitionManager();
    function setState(nextState) {
        (0, $adToP.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($fa9eb12b8acccbff$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($fa9eb12b8acccbff$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($fa9eb12b8acccbff$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $fa9eb12b8acccbff$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $fa9eb12b8acccbff$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $fa9eb12b8acccbff$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($fa9eb12b8acccbff$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($fa9eb12b8acccbff$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($fa9eb12b8acccbff$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($fa9eb12b8acccbff$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $fa9eb12b8acccbff$var$HashChangeEvent$1 = "hashchange";
var $fa9eb12b8acccbff$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $fa9eb12b8acccbff$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $fa9eb12b8acccbff$var$stripLeadingSlash,
        decodePath: $fa9eb12b8acccbff$var$addLeadingSlash
    },
    slash: {
        encodePath: $fa9eb12b8acccbff$var$addLeadingSlash,
        decodePath: $fa9eb12b8acccbff$var$addLeadingSlash
    }
};
function $fa9eb12b8acccbff$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $fa9eb12b8acccbff$var$pushHashPath(path) {
    window.location.hash = path;
}
function $fa9eb12b8acccbff$var$replaceHashPath(path) {
    var hashIndex = window.location.href.indexOf("#");
    window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + "#" + path);
}
function $fa9eb12b8acccbff$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$fa9eb12b8acccbff$var$canUseDOM && (0, $1ayQT.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $fa9eb12b8acccbff$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $fa9eb12b8acccbff$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $fa9eb12b8acccbff$var$stripTrailingSlash($fa9eb12b8acccbff$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $fa9eb12b8acccbff$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($fa9eb12b8acccbff$var$getHashPath());
        if (basename) path = $fa9eb12b8acccbff$var$stripBasename(path, basename);
        return $fa9eb12b8acccbff$export$90c043f1c57770b8(path);
    }
    var transitionManager = $fa9eb12b8acccbff$var$createTransitionManager();
    function setState(nextState) {
        (0, $adToP.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function handleHashChange() {
        var path = $fa9eb12b8acccbff$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $fa9eb12b8acccbff$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && $fa9eb12b8acccbff$export$c3e8bb440bd55b18(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $fa9eb12b8acccbff$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($fa9eb12b8acccbff$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($fa9eb12b8acccbff$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $fa9eb12b8acccbff$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $fa9eb12b8acccbff$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $fa9eb12b8acccbff$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        return "#" + encodePath(basename + $fa9eb12b8acccbff$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $fa9eb12b8acccbff$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $fa9eb12b8acccbff$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $fa9eb12b8acccbff$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $fa9eb12b8acccbff$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($fa9eb12b8acccbff$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $fa9eb12b8acccbff$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $fa9eb12b8acccbff$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $fa9eb12b8acccbff$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $fa9eb12b8acccbff$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($fa9eb12b8acccbff$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($fa9eb12b8acccbff$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($fa9eb12b8acccbff$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $fa9eb12b8acccbff$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $fa9eb12b8acccbff$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $fa9eb12b8acccbff$var$createTransitionManager();
    function setState(nextState) {
        (0, $adToP.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $fa9eb12b8acccbff$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $fa9eb12b8acccbff$export$90c043f1c57770b8(entry, undefined, createKey()) : $fa9eb12b8acccbff$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $fa9eb12b8acccbff$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $fa9eb12b8acccbff$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $fa9eb12b8acccbff$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $fa9eb12b8acccbff$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("adToP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7716176f5e0cfda4$export$2e2bcd8739ae039; });
function $7716176f5e0cfda4$export$2e2bcd8739ae039() {
    $7716176f5e0cfda4$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7716176f5e0cfda4$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("1hgYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee48bf4caf578e1$export$2e2bcd8739ae039; });
function $0ee48bf4caf578e1$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0ee48bf4caf578e1$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0ee48bf4caf578e1$var$resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0ee48bf4caf578e1$var$isAbsolute(to);
    var isFromAbs = from && $0ee48bf4caf578e1$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0ee48bf4caf578e1$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash = void 0;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0ee48bf4caf578e1$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0ee48bf4caf578e1$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0ee48bf4caf578e1$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0ee48bf4caf578e1$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0ee48bf4caf578e1$export$2e2bcd8739ae039 = $0ee48bf4caf578e1$var$resolvePathname;

});

parcelRegister("9yFSs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f57c5fa07461a12$export$2e2bcd8739ae039; });
var $6f57c5fa07461a12$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $6f57c5fa07461a12$var$valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6f57c5fa07461a12$var$valueEqual(item, b[index]);
    });
    var aType = typeof a === "undefined" ? "undefined" : $6f57c5fa07461a12$var$_typeof(a);
    var bType = typeof b === "undefined" ? "undefined" : $6f57c5fa07461a12$var$_typeof(b);
    if (aType !== bType) return false;
    if (aType === "object") {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return $6f57c5fa07461a12$var$valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
            return $6f57c5fa07461a12$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6f57c5fa07461a12$export$2e2bcd8739ae039 = $6f57c5fa07461a12$var$valueEqual;

});

parcelRegister("1ayQT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0da1c288545eac50$export$2e2bcd8739ae039; });
var $0da1c288545eac50$var$isProduction = true;
var $0da1c288545eac50$var$prefix = "Invariant failed";
function $0da1c288545eac50$var$invariant(condition, message) {
    if (condition) return;
    if ($0da1c288545eac50$var$isProduction) throw new Error($0da1c288545eac50$var$prefix);
    else throw new Error($0da1c288545eac50$var$prefix + ": " + (message || ""));
}
var $0da1c288545eac50$export$2e2bcd8739ae039 = $0da1c288545eac50$var$invariant;

});


parcelRegister("al2p2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $786dbab2251ef9b7$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $atxqw = parcelRequire("atxqw");

var $cd0Jr = parcelRequire("cd0Jr");

var $c2cf2 = parcelRequire("c2cf2");

var $786dbab2251ef9b7$var$MAX_SIGNED_31_BIT_INT = 1073741823;
function $786dbab2251ef9b7$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $786dbab2251ef9b7$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $786dbab2251ef9b7$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $786dbab2251ef9b7$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + (0, (/*@__PURE__*/$parcel$interopDefault($c2cf2)))() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($atxqw)))(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $786dbab2251ef9b7$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($786dbab2251ef9b7$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $786dbab2251ef9b7$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $70fFQ.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, (/*@__PURE__*/$parcel$interopDefault($atxqw)))(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $786dbab2251ef9b7$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $786dbab2251ef9b7$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $786dbab2251ef9b7$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $70fFQ.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $786dbab2251ef9b7$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext || $786dbab2251ef9b7$var$createReactContext;
var $786dbab2251ef9b7$export$2e2bcd8739ae039 = $786dbab2251ef9b7$var$index;

});
parcelRegister("atxqw", function(module, exports) {
function $7a068aae08366db9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
module.exports = $7a068aae08366db9$var$_inheritsLoose;

});

parcelRegister("cd0Jr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e37444847af19e8$var$ReactIs, $8e37444847af19e8$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("eSKCJ"))();

});
parcelRegister("eSKCJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kGFiO = parcelRequire("kGFiO");
function $ad5a4654dfeb0e94$var$emptyFunction() {}
function $ad5a4654dfeb0e94$var$emptyFunctionWithReset() {}
$ad5a4654dfeb0e94$var$emptyFunctionWithReset.resetWarningCache = $ad5a4654dfeb0e94$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kGFiO) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ad5a4654dfeb0e94$var$emptyFunctionWithReset,
        resetWarningCache: $ad5a4654dfeb0e94$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kGFiO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f0f7c4b0d0b6e510$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f0f7c4b0d0b6e510$var$ReactPropTypesSecret;

});



parcelRegister("c2cf2", function(module, exports) {
// @flow
"use strict";
var $8c2f2adeaf0764e0$var$key = "__global_unique_id__";
module.exports = function() {
    return $parcel$global[$8c2f2adeaf0764e0$var$key] = ($parcel$global[$8c2f2adeaf0764e0$var$key] || 0) + 1;
};

});


parcelRegister("iMVXs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dad9aaea2f3ec275$export$2e2bcd8739ae039; });
function $dad9aaea2f3ec275$export$2e2bcd8739ae039() {
    $dad9aaea2f3ec275$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dad9aaea2f3ec275$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("39sv4", function(module, exports) {

var $f8aTb = parcelRequire("f8aTb");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $24b851e3008b290b$var$pathToRegexp;
module.exports.parse = $24b851e3008b290b$var$parse;
module.exports.compile = $24b851e3008b290b$var$compile;
module.exports.tokensToFunction = $24b851e3008b290b$var$tokensToFunction;
module.exports.tokensToRegExp = $24b851e3008b290b$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $24b851e3008b290b$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $24b851e3008b290b$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $24b851e3008b290b$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $24b851e3008b290b$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $24b851e3008b290b$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $24b851e3008b290b$var$compile(str, options) {
    return $24b851e3008b290b$var$tokensToFunction($24b851e3008b290b$var$parse(str, options));
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $24b851e3008b290b$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $24b851e3008b290b$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $24b851e3008b290b$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$");
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $24b851e3008b290b$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($f8aTb(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $24b851e3008b290b$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $24b851e3008b290b$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $24b851e3008b290b$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $24b851e3008b290b$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $24b851e3008b290b$var$flags(options) {
    return options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $24b851e3008b290b$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $24b851e3008b290b$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $24b851e3008b290b$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($24b851e3008b290b$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $24b851e3008b290b$var$flags(options));
    return $24b851e3008b290b$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $24b851e3008b290b$var$stringToRegexp(path, keys, options) {
    return $24b851e3008b290b$var$tokensToRegExp($24b851e3008b290b$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $24b851e3008b290b$var$tokensToRegExp(tokens, keys, options) {
    if (!$f8aTb(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $24b851e3008b290b$var$escapeString(token);
        else {
            var prefix = $24b851e3008b290b$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $24b851e3008b290b$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $24b851e3008b290b$var$attachKeys(new RegExp("^" + route, $24b851e3008b290b$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $24b851e3008b290b$var$pathToRegexp(path, keys, options) {
    if (!$f8aTb(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $24b851e3008b290b$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($f8aTb(path)) return $24b851e3008b290b$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $24b851e3008b290b$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("f8aTb", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

});


parcelRegister("3HbWh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5U6Je"));

});
parcelRegister("5U6Je", function(module, exports) {
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $44c766e27e2c7c91$var$b = "function" === typeof Symbol && Symbol.for, $44c766e27e2c7c91$var$c = $44c766e27e2c7c91$var$b ? Symbol.for("react.element") : 60103, $44c766e27e2c7c91$var$d = $44c766e27e2c7c91$var$b ? Symbol.for("react.portal") : 60106, $44c766e27e2c7c91$var$e = $44c766e27e2c7c91$var$b ? Symbol.for("react.fragment") : 60107, $44c766e27e2c7c91$var$f = $44c766e27e2c7c91$var$b ? Symbol.for("react.strict_mode") : 60108, $44c766e27e2c7c91$var$g = $44c766e27e2c7c91$var$b ? Symbol.for("react.profiler") : 60114, $44c766e27e2c7c91$var$h = $44c766e27e2c7c91$var$b ? Symbol.for("react.provider") : 60109, $44c766e27e2c7c91$var$k = $44c766e27e2c7c91$var$b ? Symbol.for("react.context") : 60110, $44c766e27e2c7c91$var$l = $44c766e27e2c7c91$var$b ? Symbol.for("react.async_mode") : 60111, $44c766e27e2c7c91$var$m = $44c766e27e2c7c91$var$b ? Symbol.for("react.concurrent_mode") : 60111, $44c766e27e2c7c91$var$n = $44c766e27e2c7c91$var$b ? Symbol.for("react.forward_ref") : 60112, $44c766e27e2c7c91$var$p = $44c766e27e2c7c91$var$b ? Symbol.for("react.suspense") : 60113, $44c766e27e2c7c91$var$q = $44c766e27e2c7c91$var$b ? Symbol.for("react.memo") : 60115, $44c766e27e2c7c91$var$r = $44c766e27e2c7c91$var$b ? Symbol.for("react.lazy") : 60116;
function $44c766e27e2c7c91$var$t(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $44c766e27e2c7c91$var$c:
                switch(a = a.type, a){
                    case $44c766e27e2c7c91$var$l:
                    case $44c766e27e2c7c91$var$m:
                    case $44c766e27e2c7c91$var$e:
                    case $44c766e27e2c7c91$var$g:
                    case $44c766e27e2c7c91$var$f:
                    case $44c766e27e2c7c91$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $44c766e27e2c7c91$var$k:
                            case $44c766e27e2c7c91$var$n:
                            case $44c766e27e2c7c91$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $44c766e27e2c7c91$var$r:
            case $44c766e27e2c7c91$var$q:
            case $44c766e27e2c7c91$var$d:
                return u;
        }
    }
}
function $44c766e27e2c7c91$var$v(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$m;
}
module.exports.typeOf = $44c766e27e2c7c91$var$t;
module.exports.AsyncMode = $44c766e27e2c7c91$var$l;
module.exports.ConcurrentMode = $44c766e27e2c7c91$var$m;
module.exports.ContextConsumer = $44c766e27e2c7c91$var$k;
module.exports.ContextProvider = $44c766e27e2c7c91$var$h;
module.exports.Element = $44c766e27e2c7c91$var$c;
module.exports.ForwardRef = $44c766e27e2c7c91$var$n;
module.exports.Fragment = $44c766e27e2c7c91$var$e;
module.exports.Lazy = $44c766e27e2c7c91$var$r;
module.exports.Memo = $44c766e27e2c7c91$var$q;
module.exports.Portal = $44c766e27e2c7c91$var$d;
module.exports.Profiler = $44c766e27e2c7c91$var$g;
module.exports.StrictMode = $44c766e27e2c7c91$var$f;
module.exports.Suspense = $44c766e27e2c7c91$var$p;
module.exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $44c766e27e2c7c91$var$e || a === $44c766e27e2c7c91$var$m || a === $44c766e27e2c7c91$var$g || a === $44c766e27e2c7c91$var$f || a === $44c766e27e2c7c91$var$p || "object" === typeof a && null !== a && (a.$$typeof === $44c766e27e2c7c91$var$r || a.$$typeof === $44c766e27e2c7c91$var$q || a.$$typeof === $44c766e27e2c7c91$var$h || a.$$typeof === $44c766e27e2c7c91$var$k || a.$$typeof === $44c766e27e2c7c91$var$n);
};
module.exports.isAsyncMode = function(a) {
    return $44c766e27e2c7c91$var$v(a) || $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$l;
};
module.exports.isConcurrentMode = $44c766e27e2c7c91$var$v;
module.exports.isContextConsumer = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$k;
};
module.exports.isContextProvider = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$h;
};
module.exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $44c766e27e2c7c91$var$c;
};
module.exports.isForwardRef = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$n;
};
module.exports.isFragment = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$e;
};
module.exports.isLazy = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$r;
};
module.exports.isMemo = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$q;
};
module.exports.isPortal = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$d;
};
module.exports.isProfiler = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$g;
};
module.exports.isStrictMode = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$f;
};
module.exports.isSuspense = function(a) {
    return $44c766e27e2c7c91$var$t(a) === $44c766e27e2c7c91$var$p;
};

});


parcelRegister("5uOBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400701d145807711$export$2e2bcd8739ae039; });
function $400701d145807711$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("55VV8", function(module, exports) {
"use strict";

var $enjWa = parcelRequire("enjWa");
var $3b5a592ebbb19045$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3b5a592ebbb19045$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3b5a592ebbb19045$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3b5a592ebbb19045$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3b5a592ebbb19045$var$TYPE_STATICS = {};
$3b5a592ebbb19045$var$TYPE_STATICS[$enjWa.ForwardRef] = $3b5a592ebbb19045$var$FORWARD_REF_STATICS;
function $3b5a592ebbb19045$var$getStatics(component) {
    if ($enjWa.isMemo(component)) return $3b5a592ebbb19045$var$MEMO_STATICS;
    return $3b5a592ebbb19045$var$TYPE_STATICS[component["$$typeof"]] || $3b5a592ebbb19045$var$REACT_STATICS;
}
var $3b5a592ebbb19045$var$defineProperty = Object.defineProperty;
var $3b5a592ebbb19045$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3b5a592ebbb19045$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3b5a592ebbb19045$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3b5a592ebbb19045$var$getPrototypeOf = Object.getPrototypeOf;
var $3b5a592ebbb19045$var$objectPrototype = Object.prototype;
function $3b5a592ebbb19045$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3b5a592ebbb19045$var$objectPrototype) {
            var inheritedComponent = $3b5a592ebbb19045$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3b5a592ebbb19045$var$objectPrototype) $3b5a592ebbb19045$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3b5a592ebbb19045$var$getOwnPropertyNames(sourceComponent);
        if ($3b5a592ebbb19045$var$getOwnPropertySymbols) keys = keys.concat($3b5a592ebbb19045$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3b5a592ebbb19045$var$getStatics(targetComponent);
        var sourceStatics = $3b5a592ebbb19045$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3b5a592ebbb19045$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3b5a592ebbb19045$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3b5a592ebbb19045$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $3b5a592ebbb19045$var$hoistNonReactStatics;

});
parcelRegister("enjWa", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hAyFw"));

});
parcelRegister("hAyFw", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cce0b0f44a7ea63f$export$2b8d127b894957b9; }, function (v) { return $cce0b0f44a7ea63f$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cce0b0f44a7ea63f$export$cea3a54a6425200c; }, function (v) { return $cce0b0f44a7ea63f$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cce0b0f44a7ea63f$export$a7c73072b1a182ae; }, function (v) { return $cce0b0f44a7ea63f$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cce0b0f44a7ea63f$export$9f27bc3417b4524d; }, function (v) { return $cce0b0f44a7ea63f$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cce0b0f44a7ea63f$export$db77ccec0bb4ccac; }, function (v) { return $cce0b0f44a7ea63f$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cce0b0f44a7ea63f$export$8392c0c9d3dcbd35; }, function (v) { return $cce0b0f44a7ea63f$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cce0b0f44a7ea63f$export$ffb0004e005737fa; }, function (v) { return $cce0b0f44a7ea63f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cce0b0f44a7ea63f$export$b624eff549462981; }, function (v) { return $cce0b0f44a7ea63f$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cce0b0f44a7ea63f$export$7897aa7841a5380c; }, function (v) { return $cce0b0f44a7ea63f$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cce0b0f44a7ea63f$export$602eac185826482c; }, function (v) { return $cce0b0f44a7ea63f$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cce0b0f44a7ea63f$export$e2c29f18771995cb; }, function (v) { return $cce0b0f44a7ea63f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cce0b0f44a7ea63f$export$5f8d39834fd61797; }, function (v) { return $cce0b0f44a7ea63f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cce0b0f44a7ea63f$export$74bf444e3cd11ea5; }, function (v) { return $cce0b0f44a7ea63f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cce0b0f44a7ea63f$export$92387174baf9b227; }, function (v) { return $cce0b0f44a7ea63f$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cce0b0f44a7ea63f$export$ec112efeb987d9c6; }, function (v) { return $cce0b0f44a7ea63f$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cce0b0f44a7ea63f$export$b706b080d889d2c9; }, function (v) { return $cce0b0f44a7ea63f$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cce0b0f44a7ea63f$export$5be5a87408f70ddc; }, function (v) { return $cce0b0f44a7ea63f$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cce0b0f44a7ea63f$export$45a5e7f76e0caa8d; }, function (v) { return $cce0b0f44a7ea63f$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cce0b0f44a7ea63f$export$455c2e768291efa6; }, function (v) { return $cce0b0f44a7ea63f$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cce0b0f44a7ea63f$export$9522e17588c12572; }, function (v) { return $cce0b0f44a7ea63f$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cce0b0f44a7ea63f$export$2110ac352bb060b9; }, function (v) { return $cce0b0f44a7ea63f$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cce0b0f44a7ea63f$export$56885ab8b9c456ab; }, function (v) { return $cce0b0f44a7ea63f$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cce0b0f44a7ea63f$export$d927fcb6adf8f9de; }, function (v) { return $cce0b0f44a7ea63f$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cce0b0f44a7ea63f$export$b82d16f27459e05a; }, function (v) { return $cce0b0f44a7ea63f$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cce0b0f44a7ea63f$export$522c17b4f5e123e8; }, function (v) { return $cce0b0f44a7ea63f$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cce0b0f44a7ea63f$export$1aabd8a0274ecfd6; }, function (v) { return $cce0b0f44a7ea63f$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cce0b0f44a7ea63f$export$9b621391a187a31a; }, function (v) { return $cce0b0f44a7ea63f$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cce0b0f44a7ea63f$export$f5bbd400c2f4426f; }, function (v) { return $cce0b0f44a7ea63f$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cce0b0f44a7ea63f$export$2b8d127b894957b9;
var $cce0b0f44a7ea63f$export$cea3a54a6425200c;
var $cce0b0f44a7ea63f$export$a7c73072b1a182ae;
var $cce0b0f44a7ea63f$export$9f27bc3417b4524d;
var $cce0b0f44a7ea63f$export$db77ccec0bb4ccac;
var $cce0b0f44a7ea63f$export$8392c0c9d3dcbd35;
var $cce0b0f44a7ea63f$export$ffb0004e005737fa;
var $cce0b0f44a7ea63f$export$b624eff549462981;
var $cce0b0f44a7ea63f$export$7897aa7841a5380c;
var $cce0b0f44a7ea63f$export$602eac185826482c;
var $cce0b0f44a7ea63f$export$e2c29f18771995cb;
var $cce0b0f44a7ea63f$export$5f8d39834fd61797;
var $cce0b0f44a7ea63f$export$74bf444e3cd11ea5;
var $cce0b0f44a7ea63f$export$92387174baf9b227;
var $cce0b0f44a7ea63f$export$ec112efeb987d9c6;
var $cce0b0f44a7ea63f$export$b706b080d889d2c9;
var $cce0b0f44a7ea63f$export$5be5a87408f70ddc;
var $cce0b0f44a7ea63f$export$45a5e7f76e0caa8d;
var $cce0b0f44a7ea63f$export$455c2e768291efa6;
var $cce0b0f44a7ea63f$export$9522e17588c12572;
var $cce0b0f44a7ea63f$export$2110ac352bb060b9;
var $cce0b0f44a7ea63f$export$56885ab8b9c456ab;
var $cce0b0f44a7ea63f$export$d927fcb6adf8f9de;
var $cce0b0f44a7ea63f$export$b82d16f27459e05a;
var $cce0b0f44a7ea63f$export$522c17b4f5e123e8;
var $cce0b0f44a7ea63f$export$1aabd8a0274ecfd6;
var $cce0b0f44a7ea63f$export$9b621391a187a31a;
var $cce0b0f44a7ea63f$export$f5bbd400c2f4426f;
"use strict";
var $cce0b0f44a7ea63f$var$b = "function" === typeof Symbol && Symbol.for, $cce0b0f44a7ea63f$var$c = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.element") : 60103, $cce0b0f44a7ea63f$var$d = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.portal") : 60106, $cce0b0f44a7ea63f$var$e = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.fragment") : 60107, $cce0b0f44a7ea63f$var$f = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.strict_mode") : 60108, $cce0b0f44a7ea63f$var$g = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.profiler") : 60114, $cce0b0f44a7ea63f$var$h = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.provider") : 60109, $cce0b0f44a7ea63f$var$k = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.context") : 60110, $cce0b0f44a7ea63f$var$l = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.async_mode") : 60111, $cce0b0f44a7ea63f$var$m = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cce0b0f44a7ea63f$var$n = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.forward_ref") : 60112, $cce0b0f44a7ea63f$var$p = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.suspense") : 60113, $cce0b0f44a7ea63f$var$q = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.suspense_list") : 60120, $cce0b0f44a7ea63f$var$r = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.memo") : 60115, $cce0b0f44a7ea63f$var$t = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.lazy") : 60116, $cce0b0f44a7ea63f$var$v = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.block") : 60121, $cce0b0f44a7ea63f$var$w = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.fundamental") : 60117, $cce0b0f44a7ea63f$var$x = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.responder") : 60118, $cce0b0f44a7ea63f$var$y = $cce0b0f44a7ea63f$var$b ? Symbol.for("react.scope") : 60119;
function $cce0b0f44a7ea63f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cce0b0f44a7ea63f$var$c:
                switch(a = a.type, a){
                    case $cce0b0f44a7ea63f$var$l:
                    case $cce0b0f44a7ea63f$var$m:
                    case $cce0b0f44a7ea63f$var$e:
                    case $cce0b0f44a7ea63f$var$g:
                    case $cce0b0f44a7ea63f$var$f:
                    case $cce0b0f44a7ea63f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cce0b0f44a7ea63f$var$k:
                            case $cce0b0f44a7ea63f$var$n:
                            case $cce0b0f44a7ea63f$var$t:
                            case $cce0b0f44a7ea63f$var$r:
                            case $cce0b0f44a7ea63f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cce0b0f44a7ea63f$var$d:
                return u;
        }
    }
}
function $cce0b0f44a7ea63f$var$A(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$m;
}
$cce0b0f44a7ea63f$export$2b8d127b894957b9 = $cce0b0f44a7ea63f$var$l;
$cce0b0f44a7ea63f$export$cea3a54a6425200c = $cce0b0f44a7ea63f$var$m;
$cce0b0f44a7ea63f$export$a7c73072b1a182ae = $cce0b0f44a7ea63f$var$k;
$cce0b0f44a7ea63f$export$9f27bc3417b4524d = $cce0b0f44a7ea63f$var$h;
$cce0b0f44a7ea63f$export$db77ccec0bb4ccac = $cce0b0f44a7ea63f$var$c;
$cce0b0f44a7ea63f$export$8392c0c9d3dcbd35 = $cce0b0f44a7ea63f$var$n;
$cce0b0f44a7ea63f$export$ffb0004e005737fa = $cce0b0f44a7ea63f$var$e;
$cce0b0f44a7ea63f$export$b624eff549462981 = $cce0b0f44a7ea63f$var$t;
$cce0b0f44a7ea63f$export$7897aa7841a5380c = $cce0b0f44a7ea63f$var$r;
$cce0b0f44a7ea63f$export$602eac185826482c = $cce0b0f44a7ea63f$var$d;
$cce0b0f44a7ea63f$export$e2c29f18771995cb = $cce0b0f44a7ea63f$var$g;
$cce0b0f44a7ea63f$export$5f8d39834fd61797 = $cce0b0f44a7ea63f$var$f;
$cce0b0f44a7ea63f$export$74bf444e3cd11ea5 = $cce0b0f44a7ea63f$var$p;
$cce0b0f44a7ea63f$export$92387174baf9b227 = function(a) {
    return $cce0b0f44a7ea63f$var$A(a) || $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$l;
};
$cce0b0f44a7ea63f$export$ec112efeb987d9c6 = $cce0b0f44a7ea63f$var$A;
$cce0b0f44a7ea63f$export$b706b080d889d2c9 = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$k;
};
$cce0b0f44a7ea63f$export$5be5a87408f70ddc = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$h;
};
$cce0b0f44a7ea63f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cce0b0f44a7ea63f$var$c;
};
$cce0b0f44a7ea63f$export$455c2e768291efa6 = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$n;
};
$cce0b0f44a7ea63f$export$9522e17588c12572 = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$e;
};
$cce0b0f44a7ea63f$export$2110ac352bb060b9 = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$t;
};
$cce0b0f44a7ea63f$export$56885ab8b9c456ab = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$r;
};
$cce0b0f44a7ea63f$export$d927fcb6adf8f9de = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$d;
};
$cce0b0f44a7ea63f$export$b82d16f27459e05a = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$g;
};
$cce0b0f44a7ea63f$export$522c17b4f5e123e8 = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$f;
};
$cce0b0f44a7ea63f$export$1aabd8a0274ecfd6 = function(a) {
    return $cce0b0f44a7ea63f$var$z(a) === $cce0b0f44a7ea63f$var$p;
};
$cce0b0f44a7ea63f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cce0b0f44a7ea63f$var$e || a === $cce0b0f44a7ea63f$var$m || a === $cce0b0f44a7ea63f$var$g || a === $cce0b0f44a7ea63f$var$f || a === $cce0b0f44a7ea63f$var$p || a === $cce0b0f44a7ea63f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cce0b0f44a7ea63f$var$t || a.$$typeof === $cce0b0f44a7ea63f$var$r || a.$$typeof === $cce0b0f44a7ea63f$var$h || a.$$typeof === $cce0b0f44a7ea63f$var$k || a.$$typeof === $cce0b0f44a7ea63f$var$n || a.$$typeof === $cce0b0f44a7ea63f$var$w || a.$$typeof === $cce0b0f44a7ea63f$var$x || a.$$typeof === $cce0b0f44a7ea63f$var$y || a.$$typeof === $cce0b0f44a7ea63f$var$v);
};
$cce0b0f44a7ea63f$export$f5bbd400c2f4426f = $cce0b0f44a7ea63f$var$z;

});




parcelRegister("1hm3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee87e385b1557e4$export$2e2bcd8739ae039; });
function $0ee87e385b1557e4$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

});

parcelRegister("iBVPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8c88bba4ab346a6$export$2e2bcd8739ae039; });
function $d8c88bba4ab346a6$export$2e2bcd8739ae039() {
    $d8c88bba4ab346a6$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8c88bba4ab346a6$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("fxhIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4f7ae49db0ec40d$export$2e2bcd8739ae039; });
function $b4f7ae49db0ec40d$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("20MOv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1771723e14e11c61$export$2e2bcd8739ae039; });
function $1771723e14e11c61$export$2e2bcd8739ae039() {
    $1771723e14e11c61$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1771723e14e11c61$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("cNmNk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $950bbe29cfff7f63$export$2e2bcd8739ae039; });

var $5ICsL = parcelRequire("5ICsL");

var $7Rxn3 = parcelRequire("7Rxn3");
function $950bbe29cfff7f63$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $5ICsL.default)({
        props: props,
        name: name,
        defaultTheme: $7Rxn3.default
    });
}

});
parcelRegister("5ICsL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $429ee5b99ee93221$export$2e2bcd8739ae039; });

var $lfg53 = parcelRequire("lfg53");

var $3yh9K = parcelRequire("3yh9K");
function $429ee5b99ee93221$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme }) {
    const theme = (0, $3yh9K.default)(defaultTheme);
    const mergedProps = (0, $lfg53.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("lfg53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f77778f4f2eda6a7$export$2e2bcd8739ae039; });

var $b913t = parcelRequire("b913t");
function $f77778f4f2eda6a7$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $b913t.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("b913t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81d15a7790ca3f2f$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");
function $81d15a7790ca3f2f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $20MOv.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("3yh9K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2961daf3d9514be3$export$2e2bcd8739ae039; });

var $ketPc = parcelRequire("ketPc");

var $g7YYH = parcelRequire("g7YYH");
const $2961daf3d9514be3$export$35e57303dbd8a66 = (0, $ketPc.default)();
function $2961daf3d9514be3$var$useTheme(defaultTheme = $2961daf3d9514be3$export$35e57303dbd8a66) {
    return (0, $g7YYH.default)(defaultTheme);
}
var $2961daf3d9514be3$export$2e2bcd8739ae039 = $2961daf3d9514be3$var$useTheme;

});
parcelRegister("ketPc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebac400d95f45d3b$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $jWrHX = parcelRequire("jWrHX");

var $fxwWe = parcelRequire("fxwWe");

var $d7B4v = parcelRequire("d7B4v");

var $7VF1Q = parcelRequire("7VF1Q");
const $ebac400d95f45d3b$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $ebac400d95f45d3b$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $79yYo.default)(options, $ebac400d95f45d3b$var$_excluded);
    const breakpoints = (0, $fxwWe.default)(breakpointsInput);
    const spacing = (0, $7VF1Q.default)(spacingInput);
    let muiTheme = (0, $jWrHX.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $20MOv.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $20MOv.default)({}, (0, $d7B4v.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $jWrHX.default)(acc, argument), muiTheme);
    return muiTheme;
}
var $ebac400d95f45d3b$export$2e2bcd8739ae039 = $ebac400d95f45d3b$var$createTheme;

});
parcelRegister("79yYo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53548097e910e6ba$export$2e2bcd8739ae039; });
function $53548097e910e6ba$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("jWrHX", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $e848ed545ed37bf1$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $e848ed545ed37bf1$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");
function $e848ed545ed37bf1$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $e848ed545ed37bf1$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $20MOv.default)({}, target) : target;
    if ($e848ed545ed37bf1$export$53b83ca8eaab0383(target) && $e848ed545ed37bf1$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($e848ed545ed37bf1$export$53b83ca8eaab0383(source[key]) && key in target && $e848ed545ed37bf1$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $e848ed545ed37bf1$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("fxwWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5037cefb2e2664e$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");
const $b5037cefb2e2664e$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $b5037cefb2e2664e$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $b5037cefb2e2664e$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || []; // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $20MOv.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
}; // Keep in mind that @media is inclusive by the CSS specification.
function $b5037cefb2e2664e$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $79yYo.default)(breakpoints, $b5037cefb2e2664e$var$_excluded);
    const sortedValues = $b5037cefb2e2664e$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $20MOv.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("d7B4v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98d8af7b025217d8$export$2e2bcd8739ae039; });
const $98d8af7b025217d8$var$shape = {
    borderRadius: 4
};
var $98d8af7b025217d8$export$2e2bcd8739ae039 = $98d8af7b025217d8$var$shape;

});

parcelRegister("7VF1Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c5daebf4eabdffc$export$2e2bcd8739ae039; });

var $eHQ84 = parcelRequire("eHQ84");
function $5c5daebf4eabdffc$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    const transform = (0, $eHQ84.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("eHQ84", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $ab4d849f9b1a6a61$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $ab4d849f9b1a6a61$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $ab4d849f9b1a6a61$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "default", function () { return $ab4d849f9b1a6a61$export$2e2bcd8739ae039; });


var $bXmqm = parcelRequire("bXmqm");

var $1sJkf = parcelRequire("1sJkf");

var $bs0XL = parcelRequire("bs0XL");

var $4fgLQ = parcelRequire("4fgLQ");
const $ab4d849f9b1a6a61$var$properties = {
    m: "margin",
    p: "padding"
};
const $ab4d849f9b1a6a61$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $ab4d849f9b1a6a61$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $ab4d849f9b1a6a61$var$getCssProperties = (0, $4fgLQ.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($ab4d849f9b1a6a61$var$aliases[prop]) prop = $ab4d849f9b1a6a61$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $ab4d849f9b1a6a61$var$properties[a];
    const direction = $ab4d849f9b1a6a61$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $ab4d849f9b1a6a61$var$marginKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $ab4d849f9b1a6a61$var$paddingKeys = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $ab4d849f9b1a6a61$var$spacingKeys = [
    ...$ab4d849f9b1a6a61$var$marginKeys,
    ...$ab4d849f9b1a6a61$var$paddingKeys
];
function $ab4d849f9b1a6a61$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $1sJkf.getPath)(theme, themeKey) || defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $ab4d849f9b1a6a61$export$1def6f833384e3d1(theme) {
    return $ab4d849f9b1a6a61$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $ab4d849f9b1a6a61$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $ab4d849f9b1a6a61$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $ab4d849f9b1a6a61$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $ab4d849f9b1a6a61$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $ab4d849f9b1a6a61$var$getCssProperties(prop);
    const styleFromPropValue = $ab4d849f9b1a6a61$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $bXmqm.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $ab4d849f9b1a6a61$var$style(props, keys) {
    const transformer = $ab4d849f9b1a6a61$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$ab4d849f9b1a6a61$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $bs0XL.default), {});
}
function $ab4d849f9b1a6a61$export$7ede87f9b603dd3c(props) {
    return $ab4d849f9b1a6a61$var$style(props, $ab4d849f9b1a6a61$var$marginKeys);
}
$ab4d849f9b1a6a61$export$7ede87f9b603dd3c.propTypes = {};
$ab4d849f9b1a6a61$export$7ede87f9b603dd3c.filterProps = $ab4d849f9b1a6a61$var$marginKeys;
function $ab4d849f9b1a6a61$export$6f98e8eaf0be1996(props) {
    return $ab4d849f9b1a6a61$var$style(props, $ab4d849f9b1a6a61$var$paddingKeys);
}
$ab4d849f9b1a6a61$export$6f98e8eaf0be1996.propTypes = {};
$ab4d849f9b1a6a61$export$6f98e8eaf0be1996.filterProps = $ab4d849f9b1a6a61$var$paddingKeys;
function $ab4d849f9b1a6a61$var$spacing(props) {
    return $ab4d849f9b1a6a61$var$style(props, $ab4d849f9b1a6a61$var$spacingKeys);
}
$ab4d849f9b1a6a61$var$spacing.propTypes = {};
$ab4d849f9b1a6a61$var$spacing.filterProps = $ab4d849f9b1a6a61$var$spacingKeys;
var $ab4d849f9b1a6a61$export$2e2bcd8739ae039 = $ab4d849f9b1a6a61$var$spacing;

});
parcelRegister("bXmqm", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $8b46995bfecb1b07$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $8b46995bfecb1b07$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $8b46995bfecb1b07$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $8b46995bfecb1b07$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $8b46995bfecb1b07$export$980e6a259d807490; });

var $20MOv = parcelRequire("20MOv");


var $jWrHX = parcelRequire("jWrHX");

var $bs0XL = parcelRequire("bs0XL");
const $8b46995bfecb1b07$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $8b46995bfecb1b07$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$8b46995bfecb1b07$export$68c286be0e7e55b7[key]}px)`
};
function $8b46995bfecb1b07$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $8b46995bfecb1b07$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $8b46995bfecb1b07$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $8b46995bfecb1b07$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $8b46995bfecb1b07$var$breakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $8b46995bfecb1b07$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $20MOv.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $bs0XL.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $8b46995bfecb1b07$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $8b46995bfecb1b07$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $8b46995bfecb1b07$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $8b46995bfecb1b07$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $jWrHX.default)(prev, next), {});
    return $8b46995bfecb1b07$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
} // compute base for responsive values; e.g.,
function $8b46995bfecb1b07$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $8b46995bfecb1b07$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $8b46995bfecb1b07$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous] || breakpointValues;
            previous = breakpoint;
        }
        return acc;
    }, {});
}
var $8b46995bfecb1b07$export$2e2bcd8739ae039 = $8b46995bfecb1b07$var$breakpoints;

});
parcelRegister("bs0XL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85630e7367834496$export$2e2bcd8739ae039; });

var $jWrHX = parcelRequire("jWrHX");
function $85630e7367834496$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $jWrHX.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $85630e7367834496$export$2e2bcd8739ae039 = $85630e7367834496$var$merge;

});


parcelRegister("1sJkf", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $110b90a9a2989531$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "default", function () { return $110b90a9a2989531$export$2e2bcd8739ae039; });

var $9vGQi = parcelRequire("9vGQi");


var $bXmqm = parcelRequire("bXmqm");
function $110b90a9a2989531$export$2aa3fd96c49a84a8(obj, path) {
    if (!path || typeof path !== "string") return null;
    return path.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
}
function $110b90a9a2989531$var$getValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $110b90a9a2989531$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value);
    return value;
}
function $110b90a9a2989531$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $110b90a9a2989531$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $110b90a9a2989531$var$getValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $110b90a9a2989531$var$getValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $9vGQi.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bXmqm.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $110b90a9a2989531$export$2e2bcd8739ae039 = $110b90a9a2989531$var$style;

});
parcelRegister("9vGQi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ec83dedc83ed9a4$export$2e2bcd8739ae039; });

var $awKLE = parcelRequire("awKLE");
function $6ec83dedc83ed9a4$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $awKLE.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("awKLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aa12b98280af963$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $7aa12b98280af963$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("4fgLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31759272fbdf9765$export$2e2bcd8739ae039; });
function $31759272fbdf9765$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("g7YYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbdc99c3100a96c0$export$2e2bcd8739ae039; });

var $jxWMH = parcelRequire("jxWMH");
function $bbdc99c3100a96c0$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $bbdc99c3100a96c0$var$useTheme(defaultTheme = null) {
    const contextTheme = (0, $jxWMH.default)();
    return !contextTheme || $bbdc99c3100a96c0$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $bbdc99c3100a96c0$export$2e2bcd8739ae039 = $bbdc99c3100a96c0$var$useTheme;

});
parcelRegister("jxWMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3aeb2c7597694db$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $gCCs2 = parcelRequire("gCCs2");
function $e3aeb2c7597694db$export$2e2bcd8739ae039() {
    const theme = $70fFQ.useContext((0, $gCCs2.default));
    return theme;
}

});
parcelRegister("gCCs2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c19e058b1f20be97$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
const $c19e058b1f20be97$var$ThemeContext = /*#__PURE__*/ $70fFQ.createContext(null);
var $c19e058b1f20be97$export$2e2bcd8739ae039 = $c19e058b1f20be97$var$ThemeContext;

});





parcelRegister("7Rxn3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b975e69d38cecb6$export$2e2bcd8739ae039; });

var $bMr3l = parcelRequire("bMr3l");
const $5b975e69d38cecb6$var$defaultTheme = (0, $bMr3l.default)();
var $5b975e69d38cecb6$export$2e2bcd8739ae039 = $5b975e69d38cecb6$var$defaultTheme;

});
parcelRegister("bMr3l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $893929896aef4ab0$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $jWrHX = parcelRequire("jWrHX");


var $ketPc = parcelRequire("ketPc");

var $fola9 = parcelRequire("fola9");

var $bY67P = parcelRequire("bY67P");

var $1yqBb = parcelRequire("1yqBb");

var $aBxCC = parcelRequire("aBxCC");

var $a3nje = parcelRequire("a3nje");

var $ghwOB = parcelRequire("ghwOB");
const $893929896aef4ab0$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $893929896aef4ab0$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $79yYo.default)(options, $893929896aef4ab0$var$_excluded);
    const palette = (0, $bY67P.default)(paletteInput);
    const systemTheme = (0, $ketPc.default)(options);
    let muiTheme = (0, $jWrHX.default)(systemTheme, {
        mixins: (0, $fola9.default)(systemTheme.breakpoints, systemTheme.spacing, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $aBxCC.default).slice(),
        typography: (0, $1yqBb.default)(palette, typographyInput),
        transitions: (0, $a3nje.default)(transitionsInput),
        zIndex: (0, $20MOv.default)({}, (0, $ghwOB.default))
    });
    muiTheme = (0, $jWrHX.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $jWrHX.default)(acc, argument), muiTheme);
    var component;
    return muiTheme;
}
let $893929896aef4ab0$var$warnedOnce = false;
function $893929896aef4ab0$export$c469355549431d9b(...args) {
    return $893929896aef4ab0$var$createTheme(...args);
}
var $893929896aef4ab0$export$2e2bcd8739ae039 = $893929896aef4ab0$var$createTheme;

});
parcelRegister("fola9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b34983688cc945c0$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");
function $b34983688cc945c0$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    return (0, $20MOv.default)({
        toolbar: {
            minHeight: 56,
            [`${breakpoints.up("xs")} and (orientation: landscape)`]: {
                minHeight: 48
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("bY67P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b6a0ca5867b71d9$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $jWrHX = parcelRequire("jWrHX");
var $awKLE = parcelRequire("awKLE");

var $bFVgt = parcelRequire("bFVgt");

var $AC97U = parcelRequire("AC97U");

var $eYsCg = parcelRequire("eYsCg");

var $jibMW = parcelRequire("jibMW");

var $d39yA = parcelRequire("d39yA");

var $1QBMq = parcelRequire("1QBMq");

var $aXDgw = parcelRequire("aXDgw");

var $8mydd = parcelRequire("8mydd");

var $du1yB = parcelRequire("du1yB");
const $8b6a0ca5867b71d9$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $8b6a0ca5867b71d9$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $AC97U.default).white,
        default: (0, $AC97U.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $8b6a0ca5867b71d9$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $AC97U.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $AC97U.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $8b6a0ca5867b71d9$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $bFVgt.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $bFVgt.darken)(intent.main, tonalOffsetDark);
    }
}
function $8b6a0ca5867b71d9$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $aXDgw.default)[200],
        light: (0, $aXDgw.default)[50],
        dark: (0, $aXDgw.default)[400]
    };
    return {
        main: (0, $aXDgw.default)[700],
        light: (0, $aXDgw.default)[400],
        dark: (0, $aXDgw.default)[800]
    };
}
function $8b6a0ca5867b71d9$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $jibMW.default)[200],
        light: (0, $jibMW.default)[50],
        dark: (0, $jibMW.default)[400]
    };
    return {
        main: (0, $jibMW.default)[500],
        light: (0, $jibMW.default)[300],
        dark: (0, $jibMW.default)[700]
    };
}
function $8b6a0ca5867b71d9$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $d39yA.default)[500],
        light: (0, $d39yA.default)[300],
        dark: (0, $d39yA.default)[700]
    };
    return {
        main: (0, $d39yA.default)[700],
        light: (0, $d39yA.default)[400],
        dark: (0, $d39yA.default)[800]
    };
}
function $8b6a0ca5867b71d9$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $8mydd.default)[400],
        light: (0, $8mydd.default)[300],
        dark: (0, $8mydd.default)[700]
    };
    return {
        main: (0, $8mydd.default)[700],
        light: (0, $8mydd.default)[500],
        dark: (0, $8mydd.default)[900]
    };
}
function $8b6a0ca5867b71d9$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $du1yB.default)[400],
        light: (0, $du1yB.default)[300],
        dark: (0, $du1yB.default)[700]
    };
    return {
        main: (0, $du1yB.default)[800],
        light: (0, $du1yB.default)[500],
        dark: (0, $du1yB.default)[900]
    };
}
function $8b6a0ca5867b71d9$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1QBMq.default)[400],
        light: (0, $1QBMq.default)[300],
        dark: (0, $1QBMq.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $1QBMq.default)[500],
        dark: (0, $1QBMq.default)[900]
    };
}
function $8b6a0ca5867b71d9$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $79yYo.default)(palette, $8b6a0ca5867b71d9$var$_excluded);
    const primary = palette.primary || $8b6a0ca5867b71d9$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $8b6a0ca5867b71d9$var$getDefaultSecondary(mode);
    const error = palette.error || $8b6a0ca5867b71d9$var$getDefaultError(mode);
    const info = palette.info || $8b6a0ca5867b71d9$var$getDefaultInfo(mode);
    const success = palette.success || $8b6a0ca5867b71d9$var$getDefaultSuccess(mode);
    const warning = palette.warning || $8b6a0ca5867b71d9$var$getDefaultWarning(mode); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $bFVgt.getContrastRatio)(background, $8b6a0ca5867b71d9$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $8b6a0ca5867b71d9$export$55ce6f3a06c59543.text.primary : $8b6a0ca5867b71d9$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $20MOv.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $awKLE.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $awKLE.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $8b6a0ca5867b71d9$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $8b6a0ca5867b71d9$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $8b6a0ca5867b71d9$export$55ce6f3a06c59543,
        light: $8b6a0ca5867b71d9$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $jWrHX.default)((0, $20MOv.default)({
        common: // A collection of common colors.
        $AC97U.default,
        mode: // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $eYsCg.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("bFVgt", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $87fff1a2e98892b5$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $87fff1a2e98892b5$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $87fff1a2e98892b5$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $87fff1a2e98892b5$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $87fff1a2e98892b5$export$e665714f76e581fd; });

var $awKLE = parcelRequire("awKLE");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $87fff1a2e98892b5$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $87fff1a2e98892b5$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $87fff1a2e98892b5$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $87fff1a2e98892b5$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $87fff1a2e98892b5$export$677b39864803984e($87fff1a2e98892b5$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $awKLE.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].substr(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $awKLE.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
function $87fff1a2e98892b5$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $87fff1a2e98892b5$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $87fff1a2e98892b5$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$87fff1a2e98892b5$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $87fff1a2e98892b5$export$29fb7152bd3f781a(color) {
    color = $87fff1a2e98892b5$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $87fff1a2e98892b5$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $87fff1a2e98892b5$export$c852d90bf7403b62(color) {
    color = $87fff1a2e98892b5$export$677b39864803984e(color);
    let rgb = color.type === "hsl" ? $87fff1a2e98892b5$export$677b39864803984e($87fff1a2e98892b5$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $87fff1a2e98892b5$export$d061e26956a60b0a(foreground, background) {
    const lumA = $87fff1a2e98892b5$export$c852d90bf7403b62(foreground);
    const lumB = $87fff1a2e98892b5$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $87fff1a2e98892b5$export$58f0f39f63f3cf42(color, value) {
    color = $87fff1a2e98892b5$export$677b39864803984e(color);
    value = $87fff1a2e98892b5$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $87fff1a2e98892b5$export$211a73f2b8c10ce4(color);
}
function $87fff1a2e98892b5$export$4b073707ff63303(color, coefficient) {
    color = $87fff1a2e98892b5$export$677b39864803984e(color);
    coefficient = $87fff1a2e98892b5$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $87fff1a2e98892b5$export$211a73f2b8c10ce4(color);
}
function $87fff1a2e98892b5$export$c0816ed86df316af(color, coefficient) {
    color = $87fff1a2e98892b5$export$677b39864803984e(color);
    coefficient = $87fff1a2e98892b5$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $87fff1a2e98892b5$export$211a73f2b8c10ce4(color);
}
function $87fff1a2e98892b5$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $87fff1a2e98892b5$export$c852d90bf7403b62(color) > 0.5 ? $87fff1a2e98892b5$export$4b073707ff63303(color, coefficient) : $87fff1a2e98892b5$export$c0816ed86df316af(color, coefficient);
}

});

parcelRegister("AC97U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06e0f3f2d3f967e6$export$2e2bcd8739ae039; });
const $06e0f3f2d3f967e6$var$common = {
    black: "#000",
    white: "#fff"
};
var $06e0f3f2d3f967e6$export$2e2bcd8739ae039 = $06e0f3f2d3f967e6$var$common;

});

parcelRegister("eYsCg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae6cddd585bc4db0$export$2e2bcd8739ae039; });
const $ae6cddd585bc4db0$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $ae6cddd585bc4db0$export$2e2bcd8739ae039 = $ae6cddd585bc4db0$var$grey;

});

parcelRegister("jibMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0b8d7afde082243$export$2e2bcd8739ae039; });
const $e0b8d7afde082243$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $e0b8d7afde082243$export$2e2bcd8739ae039 = $e0b8d7afde082243$var$purple;

});

parcelRegister("d39yA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9802f7fa7d8fab2a$export$2e2bcd8739ae039; });
const $9802f7fa7d8fab2a$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $9802f7fa7d8fab2a$export$2e2bcd8739ae039 = $9802f7fa7d8fab2a$var$red;

});

parcelRegister("1QBMq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1587f41f904ad438$export$2e2bcd8739ae039; });
const $1587f41f904ad438$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $1587f41f904ad438$export$2e2bcd8739ae039 = $1587f41f904ad438$var$orange;

});

parcelRegister("aXDgw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7faddf63a46da71b$export$2e2bcd8739ae039; });
const $7faddf63a46da71b$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $7faddf63a46da71b$export$2e2bcd8739ae039 = $7faddf63a46da71b$var$blue;

});

parcelRegister("8mydd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $616aeaa36fc557ad$export$2e2bcd8739ae039; });
const $616aeaa36fc557ad$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $616aeaa36fc557ad$export$2e2bcd8739ae039 = $616aeaa36fc557ad$var$lightBlue;

});

parcelRegister("du1yB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0f48e6a9341174$export$2e2bcd8739ae039; });
const $9d0f48e6a9341174$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $9d0f48e6a9341174$export$2e2bcd8739ae039 = $9d0f48e6a9341174$var$green;

});


parcelRegister("1yqBb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $121d995c3c1a526c$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $jWrHX = parcelRequire("jWrHX");
const $121d995c3c1a526c$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $121d995c3c1a526c$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $121d995c3c1a526c$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $121d995c3c1a526c$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $121d995c3c1a526c$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $121d995c3c1a526c$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $79yYo.default)(_ref, $121d995c3c1a526c$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $20MOv.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $121d995c3c1a526c$var$defaultFontFamily ? {
            letterSpacing: `${$121d995c3c1a526c$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $121d995c3c1a526c$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $121d995c3c1a526c$var$caseAllCaps)
    };
    return (0, $jWrHX.default)((0, $20MOv.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("aBxCC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b8770b6488b69cf$export$2e2bcd8739ae039; });
const $7b8770b6488b69cf$var$shadowKeyUmbraOpacity = 0.2;
const $7b8770b6488b69cf$var$shadowKeyPenumbraOpacity = 0.14;
const $7b8770b6488b69cf$var$shadowAmbientShadowOpacity = 0.12;
function $7b8770b6488b69cf$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$7b8770b6488b69cf$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$7b8770b6488b69cf$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$7b8770b6488b69cf$var$shadowAmbientShadowOpacity})`
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $7b8770b6488b69cf$var$shadows = [
    "none",
    $7b8770b6488b69cf$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $7b8770b6488b69cf$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $7b8770b6488b69cf$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $7b8770b6488b69cf$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $7b8770b6488b69cf$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $7b8770b6488b69cf$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $7b8770b6488b69cf$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $7b8770b6488b69cf$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $7b8770b6488b69cf$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $7b8770b6488b69cf$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $7b8770b6488b69cf$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $7b8770b6488b69cf$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $7b8770b6488b69cf$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $7b8770b6488b69cf$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $7b8770b6488b69cf$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $7b8770b6488b69cf$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $7b8770b6488b69cf$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $7b8770b6488b69cf$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $7b8770b6488b69cf$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $7b8770b6488b69cf$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $7b8770b6488b69cf$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $7b8770b6488b69cf$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $7b8770b6488b69cf$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $7b8770b6488b69cf$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $7b8770b6488b69cf$export$2e2bcd8739ae039 = $7b8770b6488b69cf$var$shadows;

});

parcelRegister("a3nje", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $751c43e6fb576b43$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $751c43e6fb576b43$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");
const $751c43e6fb576b43$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $751c43e6fb576b43$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
const $751c43e6fb576b43$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $751c43e6fb576b43$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $751c43e6fb576b43$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $751c43e6fb576b43$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $20MOv.default)({}, $751c43e6fb576b43$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $20MOv.default)({}, $751c43e6fb576b43$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $79yYo.default)(options, $751c43e6fb576b43$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $751c43e6fb576b43$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $751c43e6fb576b43$var$formatMs(delay)}`).join(",");
    };
    return (0, $20MOv.default)({
        getAutoHeightDuration: $751c43e6fb576b43$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("ghwOB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bda7b04dadfecb4c$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $bda7b04dadfecb4c$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $bda7b04dadfecb4c$export$2e2bcd8739ae039 = $bda7b04dadfecb4c$var$zIndex;

});




parcelRegister("6mXVL", function(module, exports) {
"use strict";

var $koAO1 = parcelRequire("koAO1");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4a334922dedd850b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4a334922dedd850b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4a334922dedd850b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4a334922dedd850b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4a334922dedd850b$var$TYPE_STATICS = {};
$4a334922dedd850b$var$TYPE_STATICS[$koAO1.ForwardRef] = $4a334922dedd850b$var$FORWARD_REF_STATICS;
$4a334922dedd850b$var$TYPE_STATICS[$koAO1.Memo] = $4a334922dedd850b$var$MEMO_STATICS;
function $4a334922dedd850b$var$getStatics(component) {
    // React v16.11 and below
    if ($koAO1.isMemo(component)) return $4a334922dedd850b$var$MEMO_STATICS;
     // React v16.12 and above
    return $4a334922dedd850b$var$TYPE_STATICS[component["$$typeof"]] || $4a334922dedd850b$var$REACT_STATICS;
}
var $4a334922dedd850b$var$defineProperty = Object.defineProperty;
var $4a334922dedd850b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4a334922dedd850b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4a334922dedd850b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4a334922dedd850b$var$getPrototypeOf = Object.getPrototypeOf;
var $4a334922dedd850b$var$objectPrototype = Object.prototype;
function $4a334922dedd850b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($4a334922dedd850b$var$objectPrototype) {
            var inheritedComponent = $4a334922dedd850b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4a334922dedd850b$var$objectPrototype) $4a334922dedd850b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4a334922dedd850b$var$getOwnPropertyNames(sourceComponent);
        if ($4a334922dedd850b$var$getOwnPropertySymbols) keys = keys.concat($4a334922dedd850b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4a334922dedd850b$var$getStatics(targetComponent);
        var sourceStatics = $4a334922dedd850b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4a334922dedd850b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4a334922dedd850b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4a334922dedd850b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $4a334922dedd850b$var$hoistNonReactStatics;

});
parcelRegister("koAO1", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4GSL4"));

});
parcelRegister("4GSL4", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $36a58f7b27f0109b$export$2b8d127b894957b9; }, function (v) { return $36a58f7b27f0109b$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $36a58f7b27f0109b$export$cea3a54a6425200c; }, function (v) { return $36a58f7b27f0109b$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $36a58f7b27f0109b$export$a7c73072b1a182ae; }, function (v) { return $36a58f7b27f0109b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $36a58f7b27f0109b$export$9f27bc3417b4524d; }, function (v) { return $36a58f7b27f0109b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $36a58f7b27f0109b$export$db77ccec0bb4ccac; }, function (v) { return $36a58f7b27f0109b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $36a58f7b27f0109b$export$8392c0c9d3dcbd35; }, function (v) { return $36a58f7b27f0109b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $36a58f7b27f0109b$export$ffb0004e005737fa; }, function (v) { return $36a58f7b27f0109b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $36a58f7b27f0109b$export$b624eff549462981; }, function (v) { return $36a58f7b27f0109b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $36a58f7b27f0109b$export$7897aa7841a5380c; }, function (v) { return $36a58f7b27f0109b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $36a58f7b27f0109b$export$602eac185826482c; }, function (v) { return $36a58f7b27f0109b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $36a58f7b27f0109b$export$e2c29f18771995cb; }, function (v) { return $36a58f7b27f0109b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $36a58f7b27f0109b$export$5f8d39834fd61797; }, function (v) { return $36a58f7b27f0109b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $36a58f7b27f0109b$export$74bf444e3cd11ea5; }, function (v) { return $36a58f7b27f0109b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $36a58f7b27f0109b$export$92387174baf9b227; }, function (v) { return $36a58f7b27f0109b$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $36a58f7b27f0109b$export$ec112efeb987d9c6; }, function (v) { return $36a58f7b27f0109b$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $36a58f7b27f0109b$export$b706b080d889d2c9; }, function (v) { return $36a58f7b27f0109b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $36a58f7b27f0109b$export$5be5a87408f70ddc; }, function (v) { return $36a58f7b27f0109b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $36a58f7b27f0109b$export$45a5e7f76e0caa8d; }, function (v) { return $36a58f7b27f0109b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $36a58f7b27f0109b$export$455c2e768291efa6; }, function (v) { return $36a58f7b27f0109b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $36a58f7b27f0109b$export$9522e17588c12572; }, function (v) { return $36a58f7b27f0109b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $36a58f7b27f0109b$export$2110ac352bb060b9; }, function (v) { return $36a58f7b27f0109b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $36a58f7b27f0109b$export$56885ab8b9c456ab; }, function (v) { return $36a58f7b27f0109b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $36a58f7b27f0109b$export$d927fcb6adf8f9de; }, function (v) { return $36a58f7b27f0109b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $36a58f7b27f0109b$export$b82d16f27459e05a; }, function (v) { return $36a58f7b27f0109b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $36a58f7b27f0109b$export$522c17b4f5e123e8; }, function (v) { return $36a58f7b27f0109b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $36a58f7b27f0109b$export$1aabd8a0274ecfd6; }, function (v) { return $36a58f7b27f0109b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $36a58f7b27f0109b$export$9b621391a187a31a; }, function (v) { return $36a58f7b27f0109b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $36a58f7b27f0109b$export$f5bbd400c2f4426f; }, function (v) { return $36a58f7b27f0109b$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $36a58f7b27f0109b$export$2b8d127b894957b9;
var $36a58f7b27f0109b$export$cea3a54a6425200c;
var $36a58f7b27f0109b$export$a7c73072b1a182ae;
var $36a58f7b27f0109b$export$9f27bc3417b4524d;
var $36a58f7b27f0109b$export$db77ccec0bb4ccac;
var $36a58f7b27f0109b$export$8392c0c9d3dcbd35;
var $36a58f7b27f0109b$export$ffb0004e005737fa;
var $36a58f7b27f0109b$export$b624eff549462981;
var $36a58f7b27f0109b$export$7897aa7841a5380c;
var $36a58f7b27f0109b$export$602eac185826482c;
var $36a58f7b27f0109b$export$e2c29f18771995cb;
var $36a58f7b27f0109b$export$5f8d39834fd61797;
var $36a58f7b27f0109b$export$74bf444e3cd11ea5;
var $36a58f7b27f0109b$export$92387174baf9b227;
var $36a58f7b27f0109b$export$ec112efeb987d9c6;
var $36a58f7b27f0109b$export$b706b080d889d2c9;
var $36a58f7b27f0109b$export$5be5a87408f70ddc;
var $36a58f7b27f0109b$export$45a5e7f76e0caa8d;
var $36a58f7b27f0109b$export$455c2e768291efa6;
var $36a58f7b27f0109b$export$9522e17588c12572;
var $36a58f7b27f0109b$export$2110ac352bb060b9;
var $36a58f7b27f0109b$export$56885ab8b9c456ab;
var $36a58f7b27f0109b$export$d927fcb6adf8f9de;
var $36a58f7b27f0109b$export$b82d16f27459e05a;
var $36a58f7b27f0109b$export$522c17b4f5e123e8;
var $36a58f7b27f0109b$export$1aabd8a0274ecfd6;
var $36a58f7b27f0109b$export$9b621391a187a31a;
var $36a58f7b27f0109b$export$f5bbd400c2f4426f;
"use strict";
var $36a58f7b27f0109b$var$b = "function" === typeof Symbol && Symbol.for, $36a58f7b27f0109b$var$c = $36a58f7b27f0109b$var$b ? Symbol.for("react.element") : 60103, $36a58f7b27f0109b$var$d = $36a58f7b27f0109b$var$b ? Symbol.for("react.portal") : 60106, $36a58f7b27f0109b$var$e = $36a58f7b27f0109b$var$b ? Symbol.for("react.fragment") : 60107, $36a58f7b27f0109b$var$f = $36a58f7b27f0109b$var$b ? Symbol.for("react.strict_mode") : 60108, $36a58f7b27f0109b$var$g = $36a58f7b27f0109b$var$b ? Symbol.for("react.profiler") : 60114, $36a58f7b27f0109b$var$h = $36a58f7b27f0109b$var$b ? Symbol.for("react.provider") : 60109, $36a58f7b27f0109b$var$k = $36a58f7b27f0109b$var$b ? Symbol.for("react.context") : 60110, $36a58f7b27f0109b$var$l = $36a58f7b27f0109b$var$b ? Symbol.for("react.async_mode") : 60111, $36a58f7b27f0109b$var$m = $36a58f7b27f0109b$var$b ? Symbol.for("react.concurrent_mode") : 60111, $36a58f7b27f0109b$var$n = $36a58f7b27f0109b$var$b ? Symbol.for("react.forward_ref") : 60112, $36a58f7b27f0109b$var$p = $36a58f7b27f0109b$var$b ? Symbol.for("react.suspense") : 60113, $36a58f7b27f0109b$var$q = $36a58f7b27f0109b$var$b ? Symbol.for("react.suspense_list") : 60120, $36a58f7b27f0109b$var$r = $36a58f7b27f0109b$var$b ? Symbol.for("react.memo") : 60115, $36a58f7b27f0109b$var$t = $36a58f7b27f0109b$var$b ? Symbol.for("react.lazy") : 60116, $36a58f7b27f0109b$var$v = $36a58f7b27f0109b$var$b ? Symbol.for("react.block") : 60121, $36a58f7b27f0109b$var$w = $36a58f7b27f0109b$var$b ? Symbol.for("react.fundamental") : 60117, $36a58f7b27f0109b$var$x = $36a58f7b27f0109b$var$b ? Symbol.for("react.responder") : 60118, $36a58f7b27f0109b$var$y = $36a58f7b27f0109b$var$b ? Symbol.for("react.scope") : 60119;
function $36a58f7b27f0109b$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $36a58f7b27f0109b$var$c:
                switch(a = a.type, a){
                    case $36a58f7b27f0109b$var$l:
                    case $36a58f7b27f0109b$var$m:
                    case $36a58f7b27f0109b$var$e:
                    case $36a58f7b27f0109b$var$g:
                    case $36a58f7b27f0109b$var$f:
                    case $36a58f7b27f0109b$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $36a58f7b27f0109b$var$k:
                            case $36a58f7b27f0109b$var$n:
                            case $36a58f7b27f0109b$var$t:
                            case $36a58f7b27f0109b$var$r:
                            case $36a58f7b27f0109b$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $36a58f7b27f0109b$var$d:
                return u;
        }
    }
}
function $36a58f7b27f0109b$var$A(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$m;
}
$36a58f7b27f0109b$export$2b8d127b894957b9 = $36a58f7b27f0109b$var$l;
$36a58f7b27f0109b$export$cea3a54a6425200c = $36a58f7b27f0109b$var$m;
$36a58f7b27f0109b$export$a7c73072b1a182ae = $36a58f7b27f0109b$var$k;
$36a58f7b27f0109b$export$9f27bc3417b4524d = $36a58f7b27f0109b$var$h;
$36a58f7b27f0109b$export$db77ccec0bb4ccac = $36a58f7b27f0109b$var$c;
$36a58f7b27f0109b$export$8392c0c9d3dcbd35 = $36a58f7b27f0109b$var$n;
$36a58f7b27f0109b$export$ffb0004e005737fa = $36a58f7b27f0109b$var$e;
$36a58f7b27f0109b$export$b624eff549462981 = $36a58f7b27f0109b$var$t;
$36a58f7b27f0109b$export$7897aa7841a5380c = $36a58f7b27f0109b$var$r;
$36a58f7b27f0109b$export$602eac185826482c = $36a58f7b27f0109b$var$d;
$36a58f7b27f0109b$export$e2c29f18771995cb = $36a58f7b27f0109b$var$g;
$36a58f7b27f0109b$export$5f8d39834fd61797 = $36a58f7b27f0109b$var$f;
$36a58f7b27f0109b$export$74bf444e3cd11ea5 = $36a58f7b27f0109b$var$p;
$36a58f7b27f0109b$export$92387174baf9b227 = function(a) {
    return $36a58f7b27f0109b$var$A(a) || $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$l;
};
$36a58f7b27f0109b$export$ec112efeb987d9c6 = $36a58f7b27f0109b$var$A;
$36a58f7b27f0109b$export$b706b080d889d2c9 = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$k;
};
$36a58f7b27f0109b$export$5be5a87408f70ddc = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$h;
};
$36a58f7b27f0109b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $36a58f7b27f0109b$var$c;
};
$36a58f7b27f0109b$export$455c2e768291efa6 = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$n;
};
$36a58f7b27f0109b$export$9522e17588c12572 = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$e;
};
$36a58f7b27f0109b$export$2110ac352bb060b9 = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$t;
};
$36a58f7b27f0109b$export$56885ab8b9c456ab = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$r;
};
$36a58f7b27f0109b$export$d927fcb6adf8f9de = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$d;
};
$36a58f7b27f0109b$export$b82d16f27459e05a = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$g;
};
$36a58f7b27f0109b$export$522c17b4f5e123e8 = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$f;
};
$36a58f7b27f0109b$export$1aabd8a0274ecfd6 = function(a) {
    return $36a58f7b27f0109b$var$z(a) === $36a58f7b27f0109b$var$p;
};
$36a58f7b27f0109b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $36a58f7b27f0109b$var$e || a === $36a58f7b27f0109b$var$m || a === $36a58f7b27f0109b$var$g || a === $36a58f7b27f0109b$var$f || a === $36a58f7b27f0109b$var$p || a === $36a58f7b27f0109b$var$q || "object" === typeof a && null !== a && (a.$$typeof === $36a58f7b27f0109b$var$t || a.$$typeof === $36a58f7b27f0109b$var$r || a.$$typeof === $36a58f7b27f0109b$var$h || a.$$typeof === $36a58f7b27f0109b$var$k || a.$$typeof === $36a58f7b27f0109b$var$n || a.$$typeof === $36a58f7b27f0109b$var$w || a.$$typeof === $36a58f7b27f0109b$var$x || a.$$typeof === $36a58f7b27f0109b$var$y || a.$$typeof === $36a58f7b27f0109b$var$v);
};
$36a58f7b27f0109b$export$f5bbd400c2f4426f = $36a58f7b27f0109b$var$z;

});



parcelRegister("lM6lR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fda301fb3397341c$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");


var $e5Z97 = parcelRequire("e5Z97");

var $6eHKy = parcelRequire("6eHKy");

var $4x3bm = parcelRequire("4x3bm");
const $fda301fb3397341c$var$cache = (0, $6eHKy.default)({
    key: "css",
    prepend: true
});
function $fda301fb3397341c$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e5Z97.C), {
        value: $fda301fb3397341c$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("e5Z97", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $a430f6a570517541$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $a430f6a570517541$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $a430f6a570517541$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $a430f6a570517541$export$971d5caa766a69d7; });
$parcel$export(module.exports, "u", function () { return $a430f6a570517541$export$3b14a55fb2447963; });
$parcel$export(module.exports, "c", function () { return $a430f6a570517541$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $a430f6a570517541$export$a9c23c6ac3fc3eca; });

var $70fFQ = parcelRequire("70fFQ");

var $6eHKy = parcelRequire("6eHKy");

var $20MOv = parcelRequire("20MOv");

var $evHj4 = parcelRequire("evHj4");

var $7kcod = parcelRequire("7kcod");

var $jJpXM = parcelRequire("jJpXM");

var $asszK = parcelRequire("asszK");
var $a430f6a570517541$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $a430f6a570517541$var$EmotionCacheContext = /* #__PURE__ */ (0, $70fFQ.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $6eHKy.default)({
    key: "css"
}) : null);
var $a430f6a570517541$export$e7094788287c5e9b = $a430f6a570517541$var$EmotionCacheContext.Provider;
var $a430f6a570517541$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $70fFQ.useContext)($a430f6a570517541$var$EmotionCacheContext);
};
var $a430f6a570517541$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $70fFQ.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $70fFQ.useContext)($a430f6a570517541$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $a430f6a570517541$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $70fFQ.createContext)({});
var $a430f6a570517541$export$407448d2b89b1813 = function useTheme() {
    return (0, $70fFQ.useContext)($a430f6a570517541$export$971d5caa766a69d7);
};
var $a430f6a570517541$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $20MOv.default)({}, outerTheme, theme);
};
var $a430f6a570517541$var$createCacheWithTheme = /* #__PURE__ */ (0, $evHj4.default)(function(outerTheme) {
    return (0, $evHj4.default)(function(theme) {
        return $a430f6a570517541$var$getTheme(outerTheme, theme);
    });
});
var $a430f6a570517541$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = (0, $70fFQ.useContext)($a430f6a570517541$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $a430f6a570517541$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $70fFQ.createElement)($a430f6a570517541$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $a430f6a570517541$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = (0, $70fFQ.useContext)($a430f6a570517541$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $70fFQ.createElement)(Component, (0, $20MOv.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $70fFQ.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $7kcod.default)(WithTheme, Component);
}
var $a430f6a570517541$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $a430f6a570517541$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $a430f6a570517541$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $a430f6a570517541$var$getLastPart(match[1]);
    return undefined;
};
var $a430f6a570517541$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $a430f6a570517541$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $a430f6a570517541$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $a430f6a570517541$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($a430f6a570517541$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $a430f6a570517541$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $a430f6a570517541$var$useInsertionEffect = $70fFQ.useInsertionEffect ? $70fFQ.useInsertionEffect : function useInsertionEffect(create) {
    create();
};
function $a430f6a570517541$export$3b14a55fb2447963(create) {
    $a430f6a570517541$var$useInsertionEffect(create);
}
var $a430f6a570517541$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $a430f6a570517541$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $a430f6a570517541$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($a430f6a570517541$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$a430f6a570517541$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $a430f6a570517541$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $jJpXM.registerStyles)(cache, serialized, isStringTag);
    var rules = $a430f6a570517541$export$3b14a55fb2447963(function() {
        return (0, $jJpXM.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $a430f6a570517541$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $a430f6a570517541$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$a430f6a570517541$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $jJpXM.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $asszK.serializeStyles)(registeredStyles, undefined, (0, $70fFQ.useContext)($a430f6a570517541$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($a430f6a570517541$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $a430f6a570517541$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $70fFQ.createElement)((0, $70fFQ.Fragment), null, /*#__PURE__*/ (0, $70fFQ.createElement)($a430f6a570517541$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ (0, $70fFQ.createElement)(WrappedComponent, newProps));
});

});
parcelRegister("6eHKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48a5fcaf347b00c9$export$2e2bcd8739ae039; });

var $332e3 = parcelRequire("332e3");

var $jjzxz = parcelRequire("jjzxz");
parcelRequire("evHj4");
parcelRequire("fWAyu");
var $48a5fcaf347b00c9$var$last = function last(arr) {
    return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244
var $48a5fcaf347b00c9$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $jjzxz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $jjzxz.token)(character)) break;
        (0, $jjzxz.next)();
    }
    return (0, $jjzxz.slice)(begin, (0, $jjzxz.position));
};
var $48a5fcaf347b00c9$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $jjzxz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $jjzxz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $48a5fcaf347b00c9$var$identifierWithPointTracking((0, $jjzxz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $jjzxz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $jjzxz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jjzxz.from)(character);
    }
    while (character = (0, $jjzxz.next)());
    return parsed;
};
var $48a5fcaf347b00c9$var$getRules = function getRules(value, points) {
    return (0, $jjzxz.dealloc)($48a5fcaf347b00c9$var$toRules((0, $jjzxz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $48a5fcaf347b00c9$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $48a5fcaf347b00c9$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$48a5fcaf347b00c9$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $48a5fcaf347b00c9$var$fixedElements.set(element, true);
    var points = [];
    var rules = $48a5fcaf347b00c9$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $48a5fcaf347b00c9$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $48a5fcaf347b00c9$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $48a5fcaf347b00c9$var$isIgnoringComment = function isIgnoringComment(element) {
    return !!element && element.type === "comm" && element.children.indexOf($48a5fcaf347b00c9$var$ignoreFlag) > -1;
};
var $48a5fcaf347b00c9$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule") return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses && cache.compat !== true) {
            var prevElement = index > 0 ? children[index - 1] : null;
            if (prevElement && $48a5fcaf347b00c9$var$isIgnoringComment($48a5fcaf347b00c9$var$last(prevElement.children))) return;
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $48a5fcaf347b00c9$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $48a5fcaf347b00c9$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$48a5fcaf347b00c9$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $48a5fcaf347b00c9$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $48a5fcaf347b00c9$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$48a5fcaf347b00c9$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $48a5fcaf347b00c9$var$nullifyElement(element);
    } else if ($48a5fcaf347b00c9$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $48a5fcaf347b00c9$var$nullifyElement(element);
    }
};
var $48a5fcaf347b00c9$var$defaultStylisPlugins = [
    (0, $jjzxz.prefixer)
];
var $48a5fcaf347b00c9$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $48a5fcaf347b00c9$var$defaultStylisPlugins;
    var inserted = {}; // $FlowFixMe
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $48a5fcaf347b00c9$var$compat,
        $48a5fcaf347b00c9$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $jjzxz.stringify),
        (0, $jjzxz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $jjzxz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $jjzxz.serialize)((0, $jjzxz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $332e3.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $48a5fcaf347b00c9$export$2e2bcd8739ae039 = $48a5fcaf347b00c9$var$createCache;

});
parcelRegister("332e3", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $238360dfbd8efbc3$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $238360dfbd8efbc3$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $238360dfbd8efbc3$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $238360dfbd8efbc3$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($238360dfbd8efbc3$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $238360dfbd8efbc3$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("jjzxz", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $145bc69d9bd54ee6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "position", function () { return $145bc69d9bd54ee6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "next", function () { return $145bc69d9bd54ee6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $145bc69d9bd54ee6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $145bc69d9bd54ee6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $145bc69d9bd54ee6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $145bc69d9bd54ee6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $145bc69d9bd54ee6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $145bc69d9bd54ee6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $145bc69d9bd54ee6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $145bc69d9bd54ee6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $145bc69d9bd54ee6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $145bc69d9bd54ee6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $145bc69d9bd54ee6$export$38bcb760f1d4871c; });
$parcel$export(module.exports, "prefixer", function () { return $145bc69d9bd54ee6$export$e08c7d021b829b7a; });
var $145bc69d9bd54ee6$export$71ad59f2e432cfe8 = "-ms-";
var $145bc69d9bd54ee6$export$2c0f367103c8d01c = "-moz-";
var $145bc69d9bd54ee6$export$39dfd62a25e0fe93 = "-webkit-";
var $145bc69d9bd54ee6$export$a29989082612d0d9 = "comm";
var $145bc69d9bd54ee6$export$aa3a2e812ca8570d = "rule";
var $145bc69d9bd54ee6$export$527d108ccf083c2b = "decl";
var $145bc69d9bd54ee6$export$d3d35020fa5b54f0 = "@page";
var $145bc69d9bd54ee6$export$500415a86c544f73 = "@media";
var $145bc69d9bd54ee6$export$a763edbf796b780a = "@import";
var $145bc69d9bd54ee6$export$2790aeb8b4e5c826 = "@charset";
var $145bc69d9bd54ee6$export$1cc683e23b84b133 = "@viewport";
var $145bc69d9bd54ee6$export$9447a5efea57e862 = "@supports";
var $145bc69d9bd54ee6$export$ef011b4e114b1fba = "@document";
var $145bc69d9bd54ee6$export$6aad947bda0f3f46 = "@namespace";
var $145bc69d9bd54ee6$export$b44a8529a35fcb60 = "@keyframes";
var $145bc69d9bd54ee6$export$2c16de31893252e6 = "@font-face";
var $145bc69d9bd54ee6$export$3d846dd52e150c6f = "@counter-style";
var $145bc69d9bd54ee6$export$22314bfbb57653fe = "@font-feature-values";
var $145bc69d9bd54ee6$export$2335f513bbd82c6d = Math.abs;
var $145bc69d9bd54ee6$export$6788812c4e6611e6 = String.fromCharCode;
var $145bc69d9bd54ee6$export$e6e34fd1f2686227 = Object.assign;
function $145bc69d9bd54ee6$export$d6af199866bfb566(e, r) {
    return (((r << 2 ^ $145bc69d9bd54ee6$export$a9db5e087081082d(e, 0)) << 2 ^ $145bc69d9bd54ee6$export$a9db5e087081082d(e, 1)) << 2 ^ $145bc69d9bd54ee6$export$a9db5e087081082d(e, 2)) << 2 ^ $145bc69d9bd54ee6$export$a9db5e087081082d(e, 3);
}
function $145bc69d9bd54ee6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $145bc69d9bd54ee6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $145bc69d9bd54ee6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $145bc69d9bd54ee6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $145bc69d9bd54ee6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $145bc69d9bd54ee6$export$36776f635604f274(e) {
    return e.length;
}
function $145bc69d9bd54ee6$export$f9084667e487ed46(e) {
    return e.length;
}
function $145bc69d9bd54ee6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $145bc69d9bd54ee6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $145bc69d9bd54ee6$export$53f1d5ea8de3d7c = 1;
var $145bc69d9bd54ee6$export$4e0c71f277ca26b3 = 1;
var $145bc69d9bd54ee6$export$f24224f1c91d8156 = 0;
var $145bc69d9bd54ee6$export$5880b8b5730aff45 = 0;
var $145bc69d9bd54ee6$export$c0306caf338ac095 = 0;
var $145bc69d9bd54ee6$export$30a86d91af8ff6e6 = "";
function $145bc69d9bd54ee6$export$35059013cd4a06db(e, r, a, c, n, t, s) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: t,
        line: $145bc69d9bd54ee6$export$53f1d5ea8de3d7c,
        column: $145bc69d9bd54ee6$export$4e0c71f277ca26b3,
        length: s,
        return: ""
    };
}
function $145bc69d9bd54ee6$export$784d13d8ee351f07(e, r) {
    return $145bc69d9bd54ee6$export$e6e34fd1f2686227($145bc69d9bd54ee6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $145bc69d9bd54ee6$export$eba6f6f03b0a92e7() {
    return $145bc69d9bd54ee6$export$c0306caf338ac095;
}
function $145bc69d9bd54ee6$export$232faf9add678146() {
    $145bc69d9bd54ee6$export$c0306caf338ac095 = $145bc69d9bd54ee6$export$5880b8b5730aff45 > 0 ? $145bc69d9bd54ee6$export$a9db5e087081082d($145bc69d9bd54ee6$export$30a86d91af8ff6e6, --$145bc69d9bd54ee6$export$5880b8b5730aff45) : 0;
    if ($145bc69d9bd54ee6$export$4e0c71f277ca26b3--, $145bc69d9bd54ee6$export$c0306caf338ac095 === 10) $145bc69d9bd54ee6$export$4e0c71f277ca26b3 = 1, $145bc69d9bd54ee6$export$53f1d5ea8de3d7c--;
    return $145bc69d9bd54ee6$export$c0306caf338ac095;
}
function $145bc69d9bd54ee6$export$48cfd1e771a65c4f() {
    $145bc69d9bd54ee6$export$c0306caf338ac095 = $145bc69d9bd54ee6$export$5880b8b5730aff45 < $145bc69d9bd54ee6$export$f24224f1c91d8156 ? $145bc69d9bd54ee6$export$a9db5e087081082d($145bc69d9bd54ee6$export$30a86d91af8ff6e6, $145bc69d9bd54ee6$export$5880b8b5730aff45++) : 0;
    if ($145bc69d9bd54ee6$export$4e0c71f277ca26b3++, $145bc69d9bd54ee6$export$c0306caf338ac095 === 10) $145bc69d9bd54ee6$export$4e0c71f277ca26b3 = 1, $145bc69d9bd54ee6$export$53f1d5ea8de3d7c++;
    return $145bc69d9bd54ee6$export$c0306caf338ac095;
}
function $145bc69d9bd54ee6$export$4d3fb11e950abb9e() {
    return $145bc69d9bd54ee6$export$a9db5e087081082d($145bc69d9bd54ee6$export$30a86d91af8ff6e6, $145bc69d9bd54ee6$export$5880b8b5730aff45);
}
function $145bc69d9bd54ee6$export$e88cb2efb12ae807() {
    return $145bc69d9bd54ee6$export$5880b8b5730aff45;
}
function $145bc69d9bd54ee6$export$58adb3bec8346d0f(e, r) {
    return $145bc69d9bd54ee6$export$2f35ab04d2335697($145bc69d9bd54ee6$export$30a86d91af8ff6e6, e, r);
}
function $145bc69d9bd54ee6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $145bc69d9bd54ee6$export$2de70f21292aac9e(e) {
    return $145bc69d9bd54ee6$export$53f1d5ea8de3d7c = $145bc69d9bd54ee6$export$4e0c71f277ca26b3 = 1, $145bc69d9bd54ee6$export$f24224f1c91d8156 = $145bc69d9bd54ee6$export$36776f635604f274($145bc69d9bd54ee6$export$30a86d91af8ff6e6 = e), $145bc69d9bd54ee6$export$5880b8b5730aff45 = 0, [];
}
function $145bc69d9bd54ee6$export$45918ac1574455b1(e) {
    return $145bc69d9bd54ee6$export$30a86d91af8ff6e6 = "", e;
}
function $145bc69d9bd54ee6$export$410ac95b9ec204b8(e) {
    return $145bc69d9bd54ee6$export$87c2784dc9fc4ab($145bc69d9bd54ee6$export$58adb3bec8346d0f($145bc69d9bd54ee6$export$5880b8b5730aff45 - 1, $145bc69d9bd54ee6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $145bc69d9bd54ee6$export$660b2ee2d4fb4eff(e) {
    return $145bc69d9bd54ee6$export$45918ac1574455b1($145bc69d9bd54ee6$export$5f8c09e3ae6f64e1($145bc69d9bd54ee6$export$2de70f21292aac9e(e)));
}
function $145bc69d9bd54ee6$export$7af1228ff777d175(e) {
    while($145bc69d9bd54ee6$export$c0306caf338ac095 = $145bc69d9bd54ee6$export$4d3fb11e950abb9e())if ($145bc69d9bd54ee6$export$c0306caf338ac095 < 33) $145bc69d9bd54ee6$export$48cfd1e771a65c4f();
    else break;
    return $145bc69d9bd54ee6$export$9e1725a4cfeada27(e) > 2 || $145bc69d9bd54ee6$export$9e1725a4cfeada27($145bc69d9bd54ee6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $145bc69d9bd54ee6$export$5f8c09e3ae6f64e1(e) {
    while($145bc69d9bd54ee6$export$48cfd1e771a65c4f())switch($145bc69d9bd54ee6$export$9e1725a4cfeada27($145bc69d9bd54ee6$export$c0306caf338ac095)){
        case 0:
            $145bc69d9bd54ee6$export$10d8903dec122b9d($145bc69d9bd54ee6$export$c2ab62c7bf24634($145bc69d9bd54ee6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $145bc69d9bd54ee6$export$10d8903dec122b9d($145bc69d9bd54ee6$export$410ac95b9ec204b8($145bc69d9bd54ee6$export$c0306caf338ac095), e);
            break;
        default:
            $145bc69d9bd54ee6$export$10d8903dec122b9d($145bc69d9bd54ee6$export$6788812c4e6611e6($145bc69d9bd54ee6$export$c0306caf338ac095), e);
    }
    return e;
}
function $145bc69d9bd54ee6$export$955ba06d119e085e(e, r) {
    while(--r && $145bc69d9bd54ee6$export$48cfd1e771a65c4f())if ($145bc69d9bd54ee6$export$c0306caf338ac095 < 48 || $145bc69d9bd54ee6$export$c0306caf338ac095 > 102 || $145bc69d9bd54ee6$export$c0306caf338ac095 > 57 && $145bc69d9bd54ee6$export$c0306caf338ac095 < 65 || $145bc69d9bd54ee6$export$c0306caf338ac095 > 70 && $145bc69d9bd54ee6$export$c0306caf338ac095 < 97) break;
    return $145bc69d9bd54ee6$export$58adb3bec8346d0f(e, $145bc69d9bd54ee6$export$e88cb2efb12ae807() + (r < 6 && $145bc69d9bd54ee6$export$4d3fb11e950abb9e() == 32 && $145bc69d9bd54ee6$export$48cfd1e771a65c4f() == 32));
}
function $145bc69d9bd54ee6$export$c889f2fcc19dbf12(e) {
    while($145bc69d9bd54ee6$export$48cfd1e771a65c4f())switch($145bc69d9bd54ee6$export$c0306caf338ac095){
        case e:
            return $145bc69d9bd54ee6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $145bc69d9bd54ee6$export$c889f2fcc19dbf12($145bc69d9bd54ee6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $145bc69d9bd54ee6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $145bc69d9bd54ee6$export$48cfd1e771a65c4f();
            break;
    }
    return $145bc69d9bd54ee6$export$5880b8b5730aff45;
}
function $145bc69d9bd54ee6$export$4254d4e2b3745c4c(e, r) {
    while($145bc69d9bd54ee6$export$48cfd1e771a65c4f())if (e + $145bc69d9bd54ee6$export$c0306caf338ac095 === 57) break;
    else if (e + $145bc69d9bd54ee6$export$c0306caf338ac095 === 84 && $145bc69d9bd54ee6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $145bc69d9bd54ee6$export$58adb3bec8346d0f(r, $145bc69d9bd54ee6$export$5880b8b5730aff45 - 1) + "*" + $145bc69d9bd54ee6$export$6788812c4e6611e6(e === 47 ? e : $145bc69d9bd54ee6$export$48cfd1e771a65c4f());
}
function $145bc69d9bd54ee6$export$c2ab62c7bf24634(e) {
    while(!$145bc69d9bd54ee6$export$9e1725a4cfeada27($145bc69d9bd54ee6$export$4d3fb11e950abb9e()))$145bc69d9bd54ee6$export$48cfd1e771a65c4f();
    return $145bc69d9bd54ee6$export$58adb3bec8346d0f(e, $145bc69d9bd54ee6$export$5880b8b5730aff45);
}
function $145bc69d9bd54ee6$export$ef7acd7185315e22(e) {
    return $145bc69d9bd54ee6$export$45918ac1574455b1($145bc69d9bd54ee6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $145bc69d9bd54ee6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $145bc69d9bd54ee6$export$98e6a39c04603d36(e, r, a, c, n, t, s, u, i) {
    var f = 0;
    var o = 0;
    var l = s;
    var v = 0;
    var h = 0;
    var p = 0;
    var b = 1;
    var w = 1;
    var $ = 1;
    var k = 0;
    var g = "";
    var m = n;
    var x = t;
    var y = c;
    var z = g;
    while(w)switch(p = k, k = $145bc69d9bd54ee6$export$48cfd1e771a65c4f()){
        case 40:
            if (p != 108 && z.charCodeAt(l - 1) == 58) {
                if ($145bc69d9bd54ee6$export$f8e21b1e77979a08(z += $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed($145bc69d9bd54ee6$export$410ac95b9ec204b8(k), "&", "&\f"), "&\f") != -1) $ = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $145bc69d9bd54ee6$export$410ac95b9ec204b8(k);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $145bc69d9bd54ee6$export$7af1228ff777d175(p);
            break;
        case 92:
            z += $145bc69d9bd54ee6$export$955ba06d119e085e($145bc69d9bd54ee6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($145bc69d9bd54ee6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $145bc69d9bd54ee6$export$10d8903dec122b9d($145bc69d9bd54ee6$export$4a34f930e789283c($145bc69d9bd54ee6$export$4254d4e2b3745c4c($145bc69d9bd54ee6$export$48cfd1e771a65c4f(), $145bc69d9bd54ee6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $145bc69d9bd54ee6$export$36776f635604f274(z) * $;
        case 125 * b:
        case 59:
        case 0:
            switch(k){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (h > 0 && $145bc69d9bd54ee6$export$36776f635604f274(z) - l) $145bc69d9bd54ee6$export$10d8903dec122b9d(h > 32 ? $145bc69d9bd54ee6$export$f8483753829ec8f3(z + ";", c, a, l - 1) : $145bc69d9bd54ee6$export$f8483753829ec8f3($145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $145bc69d9bd54ee6$export$10d8903dec122b9d(y = $145bc69d9bd54ee6$export$3307ffa7023ede1e(z, r, a, f, o, n, u, g, m = [], x = [], l), t);
                    if (k === 123) {
                        if (o === 0) $145bc69d9bd54ee6$export$98e6a39c04603d36(z, r, y, y, m, t, l, u, x);
                        else switch(v){
                            case 100:
                            case 109:
                            case 115:
                                $145bc69d9bd54ee6$export$98e6a39c04603d36(e, y, y, c && $145bc69d9bd54ee6$export$10d8903dec122b9d($145bc69d9bd54ee6$export$3307ffa7023ede1e(e, y, y, 0, 0, n, u, g, n, m = [], l), x), n, x, l, u, c ? m : x);
                                break;
                            default:
                                $145bc69d9bd54ee6$export$98e6a39c04603d36(z, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = h = 0, b = $ = 1, g = z = "", l = s;
            break;
        case 58:
            l = 1 + $145bc69d9bd54ee6$export$36776f635604f274(z), h = p;
        default:
            if (b < 1) {
                if (k == 123) --b;
                else if (k == 125 && b++ == 0 && $145bc69d9bd54ee6$export$232faf9add678146() == 125) continue;
            }
            switch(z += $145bc69d9bd54ee6$export$6788812c4e6611e6(k), k * b){
                case 38:
                    $ = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($145bc69d9bd54ee6$export$36776f635604f274(z) - 1) * $, $ = 1;
                    break;
                case 64:
                    if ($145bc69d9bd54ee6$export$4d3fb11e950abb9e() === 45) z += $145bc69d9bd54ee6$export$410ac95b9ec204b8($145bc69d9bd54ee6$export$48cfd1e771a65c4f());
                    v = $145bc69d9bd54ee6$export$4d3fb11e950abb9e(), o = l = $145bc69d9bd54ee6$export$36776f635604f274(g = z += $145bc69d9bd54ee6$export$c2ab62c7bf24634($145bc69d9bd54ee6$export$e88cb2efb12ae807())), k++;
                    break;
                case 45:
                    if (p === 45 && $145bc69d9bd54ee6$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return t;
}
function $145bc69d9bd54ee6$export$3307ffa7023ede1e(e, r, a, c, t, s, u, i, f, o, l) {
    var v = t - 1;
    var h = t === 0 ? s : [
        ""
    ];
    var p = $145bc69d9bd54ee6$export$f9084667e487ed46(h);
    for(var b = 0, w = 0, $ = 0; b < c; ++b)for(var d = 0, g = $145bc69d9bd54ee6$export$2f35ab04d2335697(e, v + 1, v = $145bc69d9bd54ee6$export$2335f513bbd82c6d(w = u[b])), m = e; d < p; ++d)if (m = $145bc69d9bd54ee6$export$87c2784dc9fc4ab(w > 0 ? h[d] + " " + g : $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(g, /&\f/g, h[d]))) f[$++] = m;
    return $145bc69d9bd54ee6$export$35059013cd4a06db(e, r, a, t === 0 ? $145bc69d9bd54ee6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $145bc69d9bd54ee6$export$4a34f930e789283c(e, r, a) {
    return $145bc69d9bd54ee6$export$35059013cd4a06db(e, r, a, $145bc69d9bd54ee6$export$a29989082612d0d9, $145bc69d9bd54ee6$export$6788812c4e6611e6($145bc69d9bd54ee6$export$eba6f6f03b0a92e7()), $145bc69d9bd54ee6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $145bc69d9bd54ee6$export$f8483753829ec8f3(e, r, a, c) {
    return $145bc69d9bd54ee6$export$35059013cd4a06db(e, r, a, $145bc69d9bd54ee6$export$527d108ccf083c2b, $145bc69d9bd54ee6$export$2f35ab04d2335697(e, 0, c), $145bc69d9bd54ee6$export$2f35ab04d2335697(e, c + 1, -1), c);
}
function $145bc69d9bd54ee6$export$82e9f45cca5ba907(c, n) {
    switch($145bc69d9bd54ee6$export$d6af199866bfb566(c, n)){
        case 5103:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$2c0f367103c8d01c + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + c + c;
        case 6828:
        case 4268:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "box-$1$2" + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + "flex-item-" + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /flex-|-self/, "") + c;
        case 4675:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + "flex-line-pack" + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/, "") + c;
        case 5548:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "box-" + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, "-grow", "") + $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed($145bc69d9bd54ee6$export$77ad94ebf1c2b9ed($145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed($145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "box-pack:$3" + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($145bc69d9bd54ee6$export$36776f635604f274(c) - 1 - n > 6) switch($145bc69d9bd54ee6$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($145bc69d9bd54ee6$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $145bc69d9bd54ee6$export$2c0f367103c8d01c + ($145bc69d9bd54ee6$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$145bc69d9bd54ee6$export$f8e21b1e77979a08(c, "stretch") ? $145bc69d9bd54ee6$export$82e9f45cca5ba907($145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n) + c : c;
            }
            break;
        case 4949:
            if ($145bc69d9bd54ee6$export$a9db5e087081082d(c, n + 1) !== 115) break;
        case 6444:
            switch($145bc69d9bd54ee6$export$a9db5e087081082d(c, $145bc69d9bd54ee6$export$36776f635604f274(c) - 3 - (~$145bc69d9bd54ee6$export$f8e21b1e77979a08(c, "!important") && 10))){
                case 107:
                    return $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, ":", ":" + $145bc69d9bd54ee6$export$39dfd62a25e0fe93) + c;
                case 101:
                    return $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /(.+:)([^;!]+)(;|!.+)?/, "$1" + $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + ($145bc69d9bd54ee6$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + "$2box$3") + c;
            }
            break;
        case 5936:
            switch($145bc69d9bd54ee6$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
            return $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + c + $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + c + c;
    }
    return c;
}
function $145bc69d9bd54ee6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var c = $145bc69d9bd54ee6$export$f9084667e487ed46(e);
    for(var n = 0; n < c; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $145bc69d9bd54ee6$export$fac44ee5b035f737(e, r, a, s) {
    switch(e.type){
        case $145bc69d9bd54ee6$export$a763edbf796b780a:
        case $145bc69d9bd54ee6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $145bc69d9bd54ee6$export$a29989082612d0d9:
            return "";
        case $145bc69d9bd54ee6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $145bc69d9bd54ee6$export$dfdc1655ccc5b9cb(e.children, s) + "}";
        case $145bc69d9bd54ee6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $145bc69d9bd54ee6$export$36776f635604f274(a = $145bc69d9bd54ee6$export$dfdc1655ccc5b9cb(e.children, s)) ? e.return = e.value + "{" + a + "}" : "";
}
function $145bc69d9bd54ee6$export$5a7767152ae0305f(e) {
    var r = $145bc69d9bd54ee6$export$f9084667e487ed46(e);
    return function(a, c, n, t) {
        var s = "";
        for(var u = 0; u < r; u++)s += e[u](a, c, n, t) || "";
        return s;
    };
}
function $145bc69d9bd54ee6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $145bc69d9bd54ee6$export$e08c7d021b829b7a(c, s, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $145bc69d9bd54ee6$export$527d108ccf083c2b:
                c.return = $145bc69d9bd54ee6$export$82e9f45cca5ba907(c.value, c.length);
                break;
            case $145bc69d9bd54ee6$export$b44a8529a35fcb60:
                return $145bc69d9bd54ee6$export$dfdc1655ccc5b9cb([
                    $145bc69d9bd54ee6$export$784d13d8ee351f07(c, {
                        value: $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $145bc69d9bd54ee6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $145bc69d9bd54ee6$export$aa3a2e812ca8570d:
                if (c.length) return $145bc69d9bd54ee6$export$1be1fc439b849fdf(c.props, function(n) {
                    switch($145bc69d9bd54ee6$export$4659b591c19bdf3d(n, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $145bc69d9bd54ee6$export$dfdc1655ccc5b9cb([
                                $145bc69d9bd54ee6$export$784d13d8ee351f07(c, {
                                    props: [
                                        $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $145bc69d9bd54ee6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $145bc69d9bd54ee6$export$dfdc1655ccc5b9cb([
                                $145bc69d9bd54ee6$export$784d13d8ee351f07(c, {
                                    props: [
                                        $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $145bc69d9bd54ee6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $145bc69d9bd54ee6$export$784d13d8ee351f07(c, {
                                    props: [
                                        $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $145bc69d9bd54ee6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $145bc69d9bd54ee6$export$784d13d8ee351f07(c, {
                                    props: [
                                        $145bc69d9bd54ee6$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $145bc69d9bd54ee6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $145bc69d9bd54ee6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $145bc69d9bd54ee6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $145bc69d9bd54ee6$export$1be1fc439b849fdf($145bc69d9bd54ee6$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($145bc69d9bd54ee6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $145bc69d9bd54ee6$export$2f35ab04d2335697(r, 1, $145bc69d9bd54ee6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $145bc69d9bd54ee6$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $145bc69d9bd54ee6$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $145bc69d9bd54ee6$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("evHj4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9058db6290652bd$export$2e2bcd8739ae039; });
var $a9058db6290652bd$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $a9058db6290652bd$export$2e2bcd8739ae039 = $a9058db6290652bd$var$weakMemoize;

});

parcelRegister("fWAyu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b8a0ec2a434b13$export$2e2bcd8739ae039; });
function $b9b8a0ec2a434b13$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $b9b8a0ec2a434b13$export$2e2bcd8739ae039 = $b9b8a0ec2a434b13$var$memoize;

});


parcelRegister("7kcod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $555402fce37f522a$export$2e2bcd8739ae039; });

var $6mXVL = parcelRequire("6mXVL");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $555402fce37f522a$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6mXVL)))(targetComponent, sourceComponent);
};
var $555402fce37f522a$export$2e2bcd8739ae039 = $555402fce37f522a$var$hoistNonReactStatics;

});

parcelRegister("jJpXM", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $e5d65c10781c6d7a$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $e5d65c10781c6d7a$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $e5d65c10781c6d7a$export$6f077d94b33a01aa; });
var $e5d65c10781c6d7a$var$isBrowser = true;
function $e5d65c10781c6d7a$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $e5d65c10781c6d7a$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $e5d65c10781c6d7a$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $e5d65c10781c6d7a$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $e5d65c10781c6d7a$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("asszK", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $79d2af65d5c10c06$export$6321afa313b251b5; });

var $3ZKH4 = parcelRequire("3ZKH4");

var $kIYjZ = parcelRequire("kIYjZ");

var $fWAyu = parcelRequire("fWAyu");
var $79d2af65d5c10c06$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $79d2af65d5c10c06$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $79d2af65d5c10c06$var$hyphenateRegex = /[A-Z]|^ms/g;
var $79d2af65d5c10c06$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $79d2af65d5c10c06$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $79d2af65d5c10c06$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $79d2af65d5c10c06$var$processStyleName = /* #__PURE__ */ (0, $fWAyu.default)(function(styleName) {
    return $79d2af65d5c10c06$var$isCustomProperty(styleName) ? styleName : styleName.replace($79d2af65d5c10c06$var$hyphenateRegex, "-$&").toLowerCase();
});
var $79d2af65d5c10c06$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($79d2af65d5c10c06$var$animationRegex, function(match, p1, p2) {
                $79d2af65d5c10c06$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $79d2af65d5c10c06$var$cursor
                };
                return p1;
            });
    }
    if ((0, $kIYjZ.default)[key] !== 1 && !$79d2af65d5c10c06$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $79d2af65d5c10c06$var$contentValuePattern, $79d2af65d5c10c06$var$contentValues, $79d2af65d5c10c06$var$oldProcessStyleValue, $79d2af65d5c10c06$var$msPattern, $79d2af65d5c10c06$var$hyphenPattern, $79d2af65d5c10c06$var$hyphenatedCache;
function $79d2af65d5c10c06$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $79d2af65d5c10c06$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $79d2af65d5c10c06$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $79d2af65d5c10c06$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $79d2af65d5c10c06$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $79d2af65d5c10c06$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $79d2af65d5c10c06$var$cursor;
                var result = interpolation(mergedProps);
                $79d2af65d5c10c06$var$cursor = previousCursor;
                return $79d2af65d5c10c06$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $79d2af65d5c10c06$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $79d2af65d5c10c06$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($79d2af65d5c10c06$var$isProcessableValue(value)) string += $79d2af65d5c10c06$var$processStyleName(_key) + ":" + $79d2af65d5c10c06$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($79d2af65d5c10c06$var$isProcessableValue(value[_i])) string += $79d2af65d5c10c06$var$processStyleName(_key) + ":" + $79d2af65d5c10c06$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $79d2af65d5c10c06$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $79d2af65d5c10c06$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $79d2af65d5c10c06$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $79d2af65d5c10c06$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $79d2af65d5c10c06$var$cursor;
var $79d2af65d5c10c06$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $79d2af65d5c10c06$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $79d2af65d5c10c06$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $79d2af65d5c10c06$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $79d2af65d5c10c06$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $79d2af65d5c10c06$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3ZKH4.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $79d2af65d5c10c06$var$cursor
    };
};

});
parcelRegister("3ZKH4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e8b4a01f00a0e71$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $2e8b4a01f00a0e71$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $2e8b4a01f00a0e71$export$2e2bcd8739ae039 = $2e8b4a01f00a0e71$var$murmur2;

});

parcelRegister("kIYjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f166b543ff6f8d23$export$2e2bcd8739ae039; });
var $f166b543ff6f8d23$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $f166b543ff6f8d23$export$2e2bcd8739ae039 = $f166b543ff6f8d23$var$unitlessKeys;

});




parcelRegister("5vXJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $403e2f183c52395e$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");


var $5f0Qw = parcelRequire("5f0Qw");

parcelRequire("l1z3A");
var $e5Z97 = parcelRequire("e5Z97");

var $3yh9K = parcelRequire("3yh9K");

var $4x3bm = parcelRequire("4x3bm");
function $403e2f183c52395e$var$InnerThemeProvider(props) {
    const theme = (0, $3yh9K.default)();
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e5Z97.T).Provider, {
        value: typeof theme === "object" ? theme : {},
        children: props.children
    });
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 */ function $403e2f183c52395e$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5f0Qw.default), {
        theme: localTheme,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($403e2f183c52395e$var$InnerThemeProvider, {
            children: children
        })
    });
}
var $403e2f183c52395e$export$2e2bcd8739ae039 = $403e2f183c52395e$var$ThemeProvider;

});
parcelRegister("5f0Qw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d0f027c6cce8dd0$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");



var $gCCs2 = parcelRequire("gCCs2");

var $jxWMH = parcelRequire("jxWMH");

var $9aXnw = parcelRequire("9aXnw");

var $4x3bm = parcelRequire("4x3bm");
function $3d0f027c6cce8dd0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $20MOv.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $3d0f027c6cce8dd0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $jxWMH.default)();
    const theme = $70fFQ.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $3d0f027c6cce8dd0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $9aXnw.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $gCCs2.default).Provider, {
        value: theme,
        children: children
    });
}
var $3d0f027c6cce8dd0$export$2e2bcd8739ae039 = $3d0f027c6cce8dd0$var$ThemeProvider;

});
parcelRegister("9aXnw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ae31b8dba0fe836$export$2e2bcd8739ae039; });
const $6ae31b8dba0fe836$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $6ae31b8dba0fe836$export$2e2bcd8739ae039 = $6ae31b8dba0fe836$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("l1z3A", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $f4e4e289b4538e0e$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $f4e4e289b4538e0e$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $f4e4e289b4538e0e$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("e5Z97")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("e5Z97")).w; });

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("6eHKy");

var $e5Z97 = parcelRequire("e5Z97");
parcelRequire("2i5nE");
parcelRequire("evHj4");
parcelRequire("6mXVL");


var $jJpXM = parcelRequire("jJpXM");

var $asszK = parcelRequire("asszK");
var $f4e4e289b4538e0e$var$pkg = {
    name: "@emotion/react",
    version: "11.8.2",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/babel-plugin": "^11.7.1",
        "@emotion/cache": "^11.7.1",
        "@emotion/serialize": "^1.0.2",
        "@emotion/utils": "^1.1.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.7.1",
        "@emotion/css-prettifier": "1.0.1",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.8.1",
        "@types/react": "^16.9.11",
        dtslint: "^4.2.1",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact"
    }
};
var $f4e4e289b4538e0e$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $e5Z97.h).call(props, "css")) // $FlowFixMe
    return (0, $70fFQ.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $e5Z97.E);
    createElementArgArray[1] = (0, $e5Z97.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $70fFQ.createElement).apply(null, createElementArgArray);
};
var $f4e4e289b4538e0e$var$useInsertionEffect = $70fFQ.useInsertionEffect ? $70fFQ.useInsertionEffect : (0, $70fFQ.useLayoutEffect);
var $f4e4e289b4538e0e$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $f4e4e289b4538e0e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $e5Z97.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $asszK.serializeStyles)([
        styles
    ], undefined, (0, $70fFQ.useContext)((0, $e5Z97.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $70fFQ.useRef)();
    $f4e4e289b4538e0e$var$useInsertionEffect(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    $f4e4e289b4538e0e$var$useInsertionEffect(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $jJpXM.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $f4e4e289b4538e0e$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $asszK.serializeStyles)(args);
}
var $f4e4e289b4538e0e$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $f4e4e289b4538e0e$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $f4e4e289b4538e0e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $f4e4e289b4538e0e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $jJpXM.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f4e4e289b4538e0e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $e5Z97.u)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $jJpXM.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $f4e4e289b4538e0e$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $e5Z97.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $asszK.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $jJpXM.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $f4e4e289b4538e0e$var$merge(cache.registered, css, $f4e4e289b4538e0e$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $70fFQ.useContext)((0, $e5Z97.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $70fFQ.createElement)((0, $70fFQ.Fragment), null, /*#__PURE__*/ (0, $70fFQ.createElement)($f4e4e289b4538e0e$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $f4e4e289b4538e0e$var$isBrowser, $f4e4e289b4538e0e$var$isJest, $f4e4e289b4538e0e$var$globalContext, $f4e4e289b4538e0e$var$globalKey;

});
parcelRegister("2i5nE", function(module, exports) {
function $1ab16fa43c767403$var$_extends() {
    module.exports = $1ab16fa43c767403$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $1ab16fa43c767403$var$_extends.apply(this, arguments);
}
module.exports = $1ab16fa43c767403$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("gOgWf", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "autorun", function () { return autorun; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "keys", function () { return keys; });
$parcel$export(module.exports, "set", function () { return set; });
$parcel$export(module.exports, "remove", function () { return remove; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    var _proto$constructor;
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    return ((_proto$constructor = proto.constructor) == null ? void 0 : _proto$constructor.toString()) === plainObjectString;
} // https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object); // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
} // From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
} // From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {}; // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
     // @override must override something
    var fieldName;
    assertNotDecorated(prototype, annotation, key); // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    } // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name); // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v; // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) == null ? void 0 : _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 : 1 /* Break */ ;
     // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 : 2 /* Continue */ ;
     // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, ((_annotation$options_4 = annotation.options_) == null ? void 0 : _annotation$options_4.bound) ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 : 2 /* Continue */ ;
     // prototype
    // bound - must annotate protos to support super.flow()
    if (((_this$options_ = this.options_) == null ? void 0 : _this$options_.bound) && !isFlow(adm.target_[key])) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if (bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: flow(value),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 : 1 /* Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 : 1 /* Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
     // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set); // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 : 2 /* Continue */ ;
         // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* Continue */ ;
    } // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = ((_this$options_ = this.options_) == null ? void 0 : _this$options_.autoBind) ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = ((_this$options_2 = this.options_) == null ? void 0 : _this$options_2.autoBind) ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    } // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable; // if function respect autoBind option
    if (typeof descriptor.value === "function" && ((_this$options_4 = this.options_) == null ? void 0 : _this$options_4.autoBind)) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
     // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
     // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && ((_this$options_5 = this.options_) == null ? void 0 : _this$options_5.autoBind)) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct"; // Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    } // already observable - ignore
    if (isObservable(v)) return v; // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3); // Array
    if (Array.isArray(v)) return observable.array(v, arg2); // Map
    if (isES6Map(v)) return observable.map(v, arg2); // Set
    if (isES6Set(v)) return observable.set(v, arg2); // other object - ignore
    if (typeof v === "object" && v !== null) return v; // anything else
    return observable.box(v, arg2);
}
Object.assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
}; // eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
     // computed(expr, options?)
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || "");
    /* for generated name */ return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false; // we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        Object.defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        } // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = !!options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true; // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_"; // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_"; // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_"; // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause; // Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                     // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true); // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_; // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        } // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    } // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    } // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
} // function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_; // invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
     // invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions(); // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_; // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return true;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
} // function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_; // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    }); // invariantLOS(observable, "changed end");
} // Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    }); // invariantLOS(observable, "confirmed end");
} // Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    }); // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1); // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        if (requiresObservable_ === void 0) requiresObservable_ = false;
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return; // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_() {
        var r = this.dispose.bind(this);
        r[$mobx] = this;
        return r;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0; // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return; // dead code elimination can do the rest
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction); // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction); // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
         // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts); // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule_();
    return reaction.getDisposer_();
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    r.schedule_();
    return r.getDisposer_();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed"; // const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    var descriptors = getOwnPropertyDescriptors(properties);
    var adm = asObservableObject(target, options)[$mobx];
    startBatch();
    try {
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], !annotations ? true : key in annotations ? annotations[key] : true);
        });
    } finally{
        endBatch();
    }
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
     // flow(fn)
    var generator = arg1;
    var name = generator.name || "<unnamed flow>"; // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise); // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined); // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    } // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Basically, a deep clone, so that no reactive property will exist anymore.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    die("trace() is not available in production builds");
    var enterBreakPoint = false;
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    if (derivation.isTracing_ === TraceMode.NONE) console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
    derivation.isTracing_ = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect); // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var cancel;
    var res = new Promise(function(resolve, reject) {
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
} // Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false; // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    var adm = asObservableObject(target, options)[$mobx];
    startBatch();
    try {
        var _annotations;
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target); // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    } finally{
        endBatch();
    }
    return target;
} // proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    var adm = asObservableObject(target, options)[$mobx]; // Optimization: cache keys on proto
    // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
    if (!target[keysSymbol]) {
        var proto = Object.getPrototypeOf(target);
        var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
        keys["delete"]("constructor");
        keys["delete"]($mobx);
        addHiddenProp(proto, keysSymbol, keys);
    }
    startBatch();
    try {
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, !overrides ? true : key in overrides ? overrides[key] : true);
        });
    } finally{
        endBatch();
    }
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            var res = this.values_.slice(index, index + deleteCount);
            var oldItems = this.values_.slice(index + deleteCount);
            this.values_.length = index + newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null; // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged(); // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (index < this.values_.length) {
            this.atom_.reportObserved();
            return this.dehanceValue_(this.values_[index]);
        }
        console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else if (index === values.length) // add a new item
        this.spliceWithArray_(index, 0, [
            newValue
        ]);
        else // out of bounds
        die(17, index, values.length);
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
    addHiddenFinalProp(adm.values_, $mobx, adm);
    var proxy = new Proxy(adm.values_, arrayTraps);
    adm.proxy_ = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart(true);
        adm.spliceWithArray_(0, 0, initialValues);
        allowStateChangesEnd(prev);
    }
    return proxy;
} // eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc); // map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc); // reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
} // Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
} // Make sure callbacks recieve correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
} // Make sure callbacks recieve correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_); // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete"; // just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        this.keysAtom_ = createAtom("ObservableMap.keys()");
        this.data_ = new Map();
        this.hasMap_ = new Map();
        this.merge(initialData);
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this2 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this2$hasMap_$get;
                _this2.keysAtom_.reportChanged();
                (_this2$hasMap_$get = _this2.hasMap_.get(key)) == null || _this2$hasMap_$get.setNewValue_(false);
                var observable = _this2.data_.get(key);
                observable.setNewValue_(undefined);
                _this2.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this3$hasMap_$get;
            var observable = new ObservableValue(newValue, _this3.enhancer_, "ObservableMap.key", false);
            _this3.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(true);
            _this3.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this4 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this4.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this4.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this4.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this5 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this5.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this5["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this6 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map(); // Used for optimization
            var keysReportChangedCalled = false; // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this6.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this6["delete"](key); // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this6.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            } // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this6.data_.has(_key); // Add or update value
                _this6.set(_key, _value); // The addition could have been prevent by interceptor
                if (_this6.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this6.data_.get(_key);
                    orderedData.set(_key, _value2); // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            } // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this6.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this6.keysAtom_.reportChanged();
                else {
                    var iter1 = _this6.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this6.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            } // Use correctly ordered map
            _this6.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}(); // eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.atom_ = createAtom(this.name_);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        if (initialData) this.replace(initialData);
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this2 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this; // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this2.data_.add(_this2.enhancer_(value, undefined));
                _this2.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this3 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this3.atom_.reportChanged();
                _this3.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this4 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this4.clear();
                other.forEach(function(value) {
                    return _this4.add(value);
                });
            } else if (isES6Set(other)) {
                _this4.clear();
                other.forEach(function(value) {
                    return _this4.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}(); // eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys"); // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        } // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue); // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    } // Trap for "in"
    ;
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) == null ? void 0 : _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0) return;
                if (outcome === 1) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            } // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
             // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    } // If original descriptor becomes relevant, move this to annotation directly
    ;
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            }; // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable); // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    } // If original descriptor becomes relevant, move this to annotation directly
    ;
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            }; // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options)); // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // No such prop
        if (!hasProp(this.target_, key)) return true;
         // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            }); // Cancelled
            if (!change) return null;
        } // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key); // Value needed for spies/listeners
            var value = undefined; // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            } // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
             // Allow re-annotating this field
            if (observable) {
                this.values_["delete"](key); // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                 // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            } // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged(); // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_); // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true); // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0; // Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype); // Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
        adm.proxy_ = _assertThisInitialized(_this);
        addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
        if (initialValues && initialValues.length) {
            var prev = allowStateChangesStart(true); // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            allowStateChangesEnd(prev);
        }
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                // @ts-ignore
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing[$mobx];
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
} // Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b; // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false; // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b; // Exhaust primitive checks
    var type = typeof a;
    if (!isFunction(type) && type !== "object" && typeof b != "object") return false; // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b; // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    } // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false; // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
     // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    } // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b); // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false; // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length; // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    } // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_);
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("8hvMW", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return (parcelRequire("87gt0")).observer; });
$parcel$export(module.exports, "useLocalStore", function () { return (parcelRequire("jTDtN")).useLocalStore; });
parcelRequire("hYrwY");
parcelRequire("2icV0");
var $3glZ1 = parcelRequire("3glZ1");

var $d8Qvp = parcelRequire("d8Qvp");
parcelRequire("lk9T4");

var $lBJ1n = parcelRequire("lBJ1n");

var $a32AH = parcelRequire("a32AH");

var $87gt0 = parcelRequire("87gt0");

var $jKc8N = parcelRequire("jKc8N");

var $e7tbY = parcelRequire("e7tbY");

var $jTDtN = parcelRequire("jTDtN");

var $80RKL = parcelRequire("80RKL");

var $kJoID = parcelRequire("kJoID");
(0, $d8Qvp.observerBatching)((0, $3glZ1.unstable_batchedUpdates));
function $607891cac3cc5723$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $lBJ1n.useObserver)(fn, baseComponentName);
}
function $607891cac3cc5723$export$7613124ee4202834(enable) {
    (0, $a32AH.enableStaticRendering)(enable);
}

});
parcelRegister("hYrwY", function(module, exports) {

var $gOgWf = parcelRequire("gOgWf");

var $70fFQ = parcelRequire("70fFQ");
if (!(0, $70fFQ.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $gOgWf.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});

parcelRegister("2icV0", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("3glZ1")).unstable_batchedUpdates; });

var $3glZ1 = parcelRequire("3glZ1");

});

parcelRegister("d8Qvp", function(module, exports) {

$parcel$export(module.exports, "observerBatching", function () { return $9914c03b19cd6b2b$export$294943bbc3c74f4f; });

var $gOgWf = parcelRequire("gOgWf");
function $9914c03b19cd6b2b$export$fb2daceae6f5097a(callback) {
    callback();
}
function $9914c03b19cd6b2b$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $9914c03b19cd6b2b$export$fb2daceae6f5097a;
    (0, $gOgWf.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $9914c03b19cd6b2b$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("lk9T4", function(module, exports) {
var $f863229eac307d4a$var$deprecatedMessages = [];
function $f863229eac307d4a$export$be38475be17599d(msg) {
    if (!$f863229eac307d4a$var$deprecatedMessages.includes(msg)) {
        $f863229eac307d4a$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("lBJ1n", function(module, exports) {

$parcel$export(module.exports, "useObserver", function () { return $fbaff9f8c8e0861f$export$b9c7ecd090a87b14; });

var $gOgWf = parcelRequire("gOgWf");

var $70fFQ = parcelRequire("70fFQ");

var $ljNBX = parcelRequire("ljNBX");

var $kJoID = parcelRequire("kJoID");

var $a32AH = parcelRequire("a32AH");
var $fbaff9f8c8e0861f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $fbaff9f8c8e0861f$var$observerComponentNameFor(baseComponentName) {
    return "observer" + baseComponentName;
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $fbaff9f8c8e0861f$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $fbaff9f8c8e0861f$var$objectToBeRetainedByReactFactory() {
    return new $fbaff9f8c8e0861f$var$ObjectToBeRetainedByReact();
}
function $fbaff9f8c8e0861f$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $a32AH.isUsingStaticRendering)()) return fn();
    var _a = $fbaff9f8c8e0861f$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState($fbaff9f8c8e0861f$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $fbaff9f8c8e0861f$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var reactionTrackingRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    if (!reactionTrackingRef.current) {
        // First render for this component (or first time since a previous
        // reaction from an abandoned render was disposed).
        var newReaction = new (0, $gOgWf.Reaction)($fbaff9f8c8e0861f$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (trackingData_1.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            trackingData_1.changedBeforeMount = true;
        });
        var trackingData_1 = (0, $kJoID.addReactionToTrack)(reactionTrackingRef, newReaction, objectRetainedByReact);
    }
    var reaction = reactionTrackingRef.current.reaction;
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useDebugValue(reaction, (0, $ljNBX.printDebugValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useEffect(function() {
        // Called on first mount only
        (0, $kJoID.recordReactionAsCommitted)(reactionTrackingRef);
        if (reactionTrackingRef.current) {
            // Great. We've already got our reaction from our render;
            // all we need to do is to record that it's now mounted,
            // to allow future observable changes to trigger re-renders
            reactionTrackingRef.current.mounted = true;
            // Got a change before first mount, force an update
            if (reactionTrackingRef.current.changedBeforeMount) {
                reactionTrackingRef.current.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            reactionTrackingRef.current = {
                reaction: new (0, $gOgWf.Reaction)($fbaff9f8c8e0861f$var$observerComponentNameFor(baseComponentName), function() {
                    // We've definitely already been mounted at this point
                    forceUpdate();
                }),
                mounted: true,
                changedBeforeMount: false,
                cleanAt: Infinity
            };
            forceUpdate();
        }
        return function() {
            reactionTrackingRef.current.reaction.dispose();
            reactionTrackingRef.current = null;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}

});
parcelRegister("ljNBX", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", function () { return $f851db1985964faf$export$ef795f1f307682c7; });

var $gOgWf = parcelRequire("gOgWf");
function $f851db1985964faf$export$ef795f1f307682c7(v) {
    return (0, $gOgWf.getDependencyTree)(v);
}

});

parcelRegister("kJoID", function(module, exports) {

$parcel$export(module.exports, "addReactionToTrack", function () { return $f17b2f445cb5e7b8$export$afe524b4187b229f; });
$parcel$export(module.exports, "recordReactionAsCommitted", function () { return $f17b2f445cb5e7b8$export$ab63aa5c46b8d26f; });

var $bTohN = parcelRequire("bTohN");

var $3aEMe = parcelRequire("3aEMe");

var $kGWPs = parcelRequire("kGWPs");
var $f17b2f445cb5e7b8$var$_a = (0, $bTohN.FinalizationRegistry) ? (0, $3aEMe.createReactionCleanupTrackingUsingFinalizationRegister)((0, $bTohN.FinalizationRegistry)) : (0, $kGWPs.createTimerBasedReactionCleanupTracking)(), $f17b2f445cb5e7b8$export$afe524b4187b229f = $f17b2f445cb5e7b8$var$_a.addReactionToTrack, $f17b2f445cb5e7b8$export$ab63aa5c46b8d26f = $f17b2f445cb5e7b8$var$_a.recordReactionAsCommitted, $f17b2f445cb5e7b8$export$8ccb7f898b3f89a3 = $f17b2f445cb5e7b8$var$_a.resetCleanupScheduleForTests, $f17b2f445cb5e7b8$export$e4e43e0ec68bea7 = $f17b2f445cb5e7b8$var$_a.forceCleanupTimerToRunNowForTests;

});
parcelRegister("bTohN", function(module, exports) {

$parcel$export(module.exports, "FinalizationRegistry", function () { return $8a87ab7a9e0ba88e$export$76a7cbb61503421d; });
var $8a87ab7a9e0ba88e$export$76a7cbb61503421d = typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry;

});

parcelRegister("3aEMe", function(module, exports) {

$parcel$export(module.exports, "createReactionCleanupTrackingUsingFinalizationRegister", function () { return $24f1efb7e45e8bb7$export$50c9e8dc802ed29e; });

var $53Jpg = parcelRequire("53Jpg");
function $24f1efb7e45e8bb7$export$50c9e8dc802ed29e(FinalizationRegistry) {
    var cleanupTokenToReactionTrackingMap = new Map();
    var globalCleanupTokensCounter = 1;
    var registry = new FinalizationRegistry(function cleanupFunction(token) {
        var trackedReaction = cleanupTokenToReactionTrackingMap.get(token);
        if (trackedReaction) {
            trackedReaction.reaction.dispose();
            cleanupTokenToReactionTrackingMap.delete(token);
        }
    });
    return {
        addReactionToTrack: function(reactionTrackingRef, reaction, objectRetainedByReact) {
            var token = globalCleanupTokensCounter++;
            registry.register(objectRetainedByReact, token, reactionTrackingRef);
            reactionTrackingRef.current = (0, $53Jpg.createTrackingData)(reaction);
            reactionTrackingRef.current.finalizationRegistryCleanupToken = token;
            cleanupTokenToReactionTrackingMap.set(token, reactionTrackingRef.current);
            return reactionTrackingRef.current;
        },
        recordReactionAsCommitted: function(reactionRef) {
            registry.unregister(reactionRef);
            if (reactionRef.current && reactionRef.current.finalizationRegistryCleanupToken) cleanupTokenToReactionTrackingMap.delete(reactionRef.current.finalizationRegistryCleanupToken);
        },
        forceCleanupTimerToRunNowForTests: function() {
        // When FinalizationRegistry in use, this this is no-op
        },
        resetCleanupScheduleForTests: function() {
        // When FinalizationRegistry in use, this this is no-op
        }
    };
}

});
parcelRegister("53Jpg", function(module, exports) {

$parcel$export(module.exports, "createTrackingData", function () { return $3af07451efa3cf75$export$bbb1082a9abc1839; });
$parcel$export(module.exports, "CLEANUP_TIMER_LOOP_MILLIS", function () { return $3af07451efa3cf75$export$262a80afc9566214; });
function $3af07451efa3cf75$export$bbb1082a9abc1839(reaction) {
    var trackingData = {
        reaction: reaction,
        mounted: false,
        changedBeforeMount: false,
        cleanAt: Date.now() + $3af07451efa3cf75$export$6c9b1ff66852295c
    };
    return trackingData;
}
var $3af07451efa3cf75$export$6c9b1ff66852295c = 10000;
var $3af07451efa3cf75$export$262a80afc9566214 = 10000;

});


parcelRegister("kGWPs", function(module, exports) {

$parcel$export(module.exports, "createTimerBasedReactionCleanupTracking", function () { return $f1055d1a6838f3e6$export$6136b5ce3e719258; });

var $53Jpg = parcelRequire("53Jpg");
var $f1055d1a6838f3e6$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $f1055d1a6838f3e6$export$6136b5ce3e719258() {
    /**
     * Reactions created by components that have yet to be fully mounted.
     */ var uncommittedReactionRefs = new Set();
    /**
     * Latest 'uncommitted reactions' cleanup timer handle.
     */ var reactionCleanupHandle;
    /* istanbul ignore next */ /**
     * Only to be used by test functions; do not export outside of mobx-react-lite
     */ function forceCleanupTimerToRunNowForTests() {
        // This allows us to control the execution of the cleanup timer
        // to force it to run at awkward times in unit tests.
        if (reactionCleanupHandle) {
            clearTimeout(reactionCleanupHandle);
            cleanUncommittedReactions();
        }
    }
    /* istanbul ignore next */ function resetCleanupScheduleForTests() {
        var e_1, _a;
        if (uncommittedReactionRefs.size > 0) {
            try {
                for(var uncommittedReactionRefs_1 = $f1055d1a6838f3e6$var$__values(uncommittedReactionRefs), uncommittedReactionRefs_1_1 = uncommittedReactionRefs_1.next(); !uncommittedReactionRefs_1_1.done; uncommittedReactionRefs_1_1 = uncommittedReactionRefs_1.next()){
                    var ref = uncommittedReactionRefs_1_1.value;
                    var tracking = ref.current;
                    if (tracking) {
                        tracking.reaction.dispose();
                        ref.current = null;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (uncommittedReactionRefs_1_1 && !uncommittedReactionRefs_1_1.done && (_a = uncommittedReactionRefs_1.return)) _a.call(uncommittedReactionRefs_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            uncommittedReactionRefs.clear();
        }
        if (reactionCleanupHandle) {
            clearTimeout(reactionCleanupHandle);
            reactionCleanupHandle = undefined;
        }
    }
    function ensureCleanupTimerRunning() {
        if (reactionCleanupHandle === undefined) reactionCleanupHandle = setTimeout(cleanUncommittedReactions, (0, $53Jpg.CLEANUP_TIMER_LOOP_MILLIS));
    }
    function scheduleCleanupOfReactionIfLeaked(ref) {
        uncommittedReactionRefs.add(ref);
        ensureCleanupTimerRunning();
    }
    function recordReactionAsCommitted(reactionRef) {
        uncommittedReactionRefs.delete(reactionRef);
    }
    /**
     * Run by the cleanup timer to dispose any outstanding reactions
     */ function cleanUncommittedReactions() {
        reactionCleanupHandle = undefined;
        // Loop through all the candidate leaked reactions; those older
        // than CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS get tidied.
        var now = Date.now();
        uncommittedReactionRefs.forEach(function(ref) {
            var tracking = ref.current;
            if (tracking) {
                if (now >= tracking.cleanAt) {
                    // It's time to tidy up this leaked reaction.
                    tracking.reaction.dispose();
                    ref.current = null;
                    uncommittedReactionRefs.delete(ref);
                }
            }
        });
        if (uncommittedReactionRefs.size > 0) // We've just finished a round of cleanups but there are still
        // some leak candidates outstanding.
        ensureCleanupTimerRunning();
    }
    return {
        addReactionToTrack: function(reactionTrackingRef, reaction, /**
         * On timer based implementation we don't really need this object,
         * but we keep the same api
         */ objectRetainedByReact) {
            reactionTrackingRef.current = (0, $53Jpg.createTrackingData)(reaction);
            scheduleCleanupOfReactionIfLeaked(reactionTrackingRef);
            return reactionTrackingRef.current;
        },
        recordReactionAsCommitted: recordReactionAsCommitted,
        forceCleanupTimerToRunNowForTests: forceCleanupTimerToRunNowForTests,
        resetCleanupScheduleForTests: resetCleanupScheduleForTests
    };
}

});


parcelRegister("a32AH", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", function () { return $750c31b313a7c5e5$export$5d52eaa7c0f24c9e; });
$parcel$export(module.exports, "isUsingStaticRendering", function () { return $750c31b313a7c5e5$export$55979271896d643e; });
var $750c31b313a7c5e5$var$globalIsUsingStaticRendering = false;
function $750c31b313a7c5e5$export$5d52eaa7c0f24c9e(enable) {
    $750c31b313a7c5e5$var$globalIsUsingStaticRendering = enable;
}
function $750c31b313a7c5e5$export$55979271896d643e() {
    return $750c31b313a7c5e5$var$globalIsUsingStaticRendering;
}

});


parcelRegister("87gt0", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $5e8bc020242a39a2$export$b6ae1bc530f4c149; });

var $70fFQ = parcelRequire("70fFQ");

var $a32AH = parcelRequire("a32AH");

var $lBJ1n = parcelRequire("lBJ1n");
var $5e8bc020242a39a2$var$__assign = undefined && undefined.__assign || function() {
    $5e8bc020242a39a2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5e8bc020242a39a2$var$__assign.apply(this, arguments);
};
function $5e8bc020242a39a2$export$b6ae1bc530f4c149(baseComponent, options) {
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $a32AH.isUsingStaticRendering)()) return baseComponent;
    var realOptions = $5e8bc020242a39a2$var$__assign({
        forwardRef: false
    }, options);
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    var wrappedComponent = function(props, ref) {
        return (0, $lBJ1n.useObserver)(function() {
            return baseComponent(props, ref);
        }, baseComponentName);
    };
    wrappedComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`       
    if (baseComponent.contextTypes) wrappedComponent.contextTypes = baseComponent.contextTypes;
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    var memoComponent;
    if (realOptions.forwardRef) // we have to use forwardRef here because:
    // 1. it cannot go before memo, only after it
    // 2. forwardRef converts the function into an actual component, so we can't let the baseComponent do it
    //    since it wouldn't be a callable function anymore
    memoComponent = (0, $70fFQ.memo)((0, $70fFQ.forwardRef)(wrappedComponent));
    else memoComponent = (0, $70fFQ.memo)(wrappedComponent);
    $5e8bc020242a39a2$var$copyStaticProperties(baseComponent, memoComponent);
    memoComponent.displayName = baseComponentName;
    return memoComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $5e8bc020242a39a2$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true
};
function $5e8bc020242a39a2$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$5e8bc020242a39a2$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("jKc8N", function(module, exports) {

var $lBJ1n = parcelRequire("lBJ1n");
function $e5fbbb24f130934e$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $lBJ1n.useObserver)(component);
}
$e5fbbb24f130934e$export$c1cbdee04e18ea8b.displayName = "Observer";
function $e5fbbb24f130934e$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("e7tbY", function(module, exports) {

var $gOgWf = parcelRequire("gOgWf");

var $70fFQ = parcelRequire("70fFQ");
function $a4785d14001171d7$export$aa207039f277c5f(initializer, annotations) {
    return (0, $70fFQ.useState)(function() {
        return (0, $gOgWf.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("jTDtN", function(module, exports) {

$parcel$export(module.exports, "useLocalStore", function () { return $e7c1c72d61f13c66$export$f5b97ae82d1eeaf3; });

var $gOgWf = parcelRequire("gOgWf");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("lk9T4");

var $80RKL = parcelRequire("80RKL");
function $e7c1c72d61f13c66$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $80RKL.useAsObservableSource)(current);
    return (0, $70fFQ.useState)(function() {
        return (0, $gOgWf.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("80RKL", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", function () { return $5d58051dac3adcd1$export$e0ded3646391939c; });
parcelRequire("lk9T4");

var $gOgWf = parcelRequire("gOgWf");

var $70fFQ = parcelRequire("70fFQ");
var $5d58051dac3adcd1$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $5d58051dac3adcd1$export$e0ded3646391939c(current) {
    var _a = $5d58051dac3adcd1$var$__read((0, $70fFQ.useState)(function() {
        return (0, $gOgWf.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $gOgWf.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});



parcelRegister("iWaGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc95edeaac0bd010$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $3Bt14 = parcelRequire("3Bt14");
var $dc95edeaac0bd010$export$2e2bcd8739ae039 = ()=>(0, $70fFQ.useContext)((0, $3Bt14.default));

});
parcelRegister("3Bt14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29fb55cf4217ea0e$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $a2DeL = parcelRequire("a2DeL");

var $bccd0 = parcelRequire("bccd0");

var $8ERvd = parcelRequire("8ERvd");

var $PtNzY = parcelRequire("PtNzY");

var $4WgAH = parcelRequire("4WgAH");

var $a0rcO = parcelRequire("a0rcO");

var $6OIJW = parcelRequire("6OIJW");

var $brBQs = parcelRequire("brBQs");

var $kH9gy = parcelRequire("kH9gy");

var $7dntZ = parcelRequire("7dntZ");

var $5KKaN = parcelRequire("5KKaN");

var $4WMcN = parcelRequire("4WMcN");

var $iuVwc = parcelRequire("iuVwc");

var $gABF7 = parcelRequire("gABF7");

var $gcPmB = parcelRequire("gcPmB");
var $29fb55cf4217ea0e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $70fFQ.createContext)({
    buildingStore: (0, $a2DeL.default),
    buildingDetailStore: (0, $bccd0.default),
    modalStore: (0, $8ERvd.default),
    projectStore: (0, $4WgAH.default),
    taskStore: (0, $a0rcO.default),
    uiStore: (0, $6OIJW.default),
    userStore: (0, $brBQs.default),
    createProjectStore: (0, $PtNzY.default),
    projectDetailStore: (0, $kH9gy.default),
    taskEditorStore: (0, $5KKaN.default),
    mapStore: (0, $gcPmB.default),
    editorStore: (0, $iuVwc.default),
    featureSettingsStore: (0, $gABF7.default),
    surveyStore: (0, $4WMcN.default),
    chatStore: (0, $7dntZ.default)
});

});
parcelRegister("a2DeL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f886f614e1467d$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $fBBlk = parcelRequire("fBBlk");

var $lxEiN = parcelRequire("lxEiN");

var $4WgAH = parcelRequire("4WgAH");

var $gcPmB = parcelRequire("gcPmB");

var $ht0W2 = parcelRequire("ht0W2");
const $74f886f614e1467d$var$parseFilters = (filters)=>{
    const q = {
        filters: {}
    };
    Object.keys(filters).forEach((filterName)=>{
        const filterValue = filters[filterName];
        if (filterValue === null || filterValue === "") return;
        if (filterName === "geo_polygon") {
            q.filters[filterName] = filterValue;
            return;
        }
        if (typeof filterValue === "object") {
            if (filterName.match(/^estimates_int/i)) {
                if (filterValue.start) q.filters[`${filterName}.low`] = {
                    gte: filterValue.start
                };
                if (filterValue.end) q.filters[`${filterName}.high`] = {
                    lte: filterValue.end
                };
            } else if (filterName.match(/^incentives/i)) q.filters[filterName] = filterValue;
            else if (filterName === "radius") q.filters.radius = filterValue;
            else if (filterName === "sort") q.sort = filterValue;
            else q.filters[filterName] = {
                gte: filterValue.start,
                lte: filterValue.end
            };
        } else if (![
            "skip",
            "limit",
            "favourites"
        ].includes(filterName)) q.filters[filterName] = filterValue;
        else q[filterName] = filterValue;
    });
    return q;
};
class $74f886f614e1467d$var$Store {
    setResults(results) {
        this.resultMap = results;
    }
    updateBuildingName(buildingId, buildingName) {
        const building = this.resultMap.get(buildingId);
        const updatedBuilding = (0, $edHbI._)((0, $2QP2i._)({}, building), {
            building_name: buildingName
        });
        this.resultMap.set(buildingId, updatedBuilding);
        const newResults = new Map(this.resultMap);
        newResults.set(buildingId, updatedBuilding);
        this.resultMap = newResults;
    }
    clearPicked() {
        this.pickedResults = new Set();
    }
    pickResult(id) {
        console.log("pick: pickResult", id);
        this.pickedResults.add(id);
    }
    unPickResult(id) {
        this.pickedResults.delete(id);
    }
    getFilterValue(name) {
        return this.filters[name] || null;
    }
    get filtersCount() {
        return (0, $gOgWf.keys)(this.filters).length;
    }
    get params() {
        return $74f886f614e1467d$var$parseFilters(this.filters);
    }
    clearAllFilters() {
        this.filters = {};
    }
    constructor(){
        (0, $cr2GM._)(this, "buildings", new Map());
        (0, $cr2GM._)(this, "activeProject", null);
        (0, $cr2GM._)(this, "aggregations", null);
        (0, $cr2GM._)(this, "emissions", null);
        (0, $cr2GM._)(this, "financials", null);
        (0, $cr2GM._)(this, "filters", {});
        (0, $cr2GM._)(this, "projectId", null);
        (0, $cr2GM._)(this, "sort", "");
        (0, $cr2GM._)(this, "pickedResults", new Set());
        (0, $cr2GM._)(this, "savedSearches", []);
        (0, $cr2GM._)(this, "totalResults", {
            value: 0,
            relation: "gte"
        });
        (0, $cr2GM._)(this, "hexagons", []);
        (0, $cr2GM._)(this, "points", []);
        (0, $cr2GM._)(this, "bbox", null);
        (0, $cr2GM._)(this, "location", null);
        (0, $cr2GM._)(this, "resultMap", new Map());
        (0, $cr2GM._)(this, "loadResult", async (ids)=>{
            if (!ids.length) return;
            // Set state to loading
            ids.forEach((id)=>{
                this.resultMap.set(id, 1);
            });
            const { data: data } = await (0, $lxEiN.default).Building.getBuildingsById(ids);
            data.data.forEach((item)=>{
                this.resultMap.set(item.id, item);
            });
            return data;
        });
        (0, $cr2GM._)(this, "debounceLoadResult", (0, $fBBlk.debounce)(this.loadResult, 500));
        (0, $cr2GM._)(this, "get", (id)=>{
            return this.resultMap.get(id);
        });
        (0, $cr2GM._)(this, "pickAllResults", ()=>{
            this.pickedResults = new Set([
                ...this.resultMap.keys()
            ]);
        });
        (0, $cr2GM._)(this, "createProjectFromPicked", async (params)=>{
            const pickedResults = [
                ...this.pickedResults
            ];
            if (!pickedResults.size) return;
            this.clearPicked();
            const project = await (0, $4WgAH.default).createProject((0, $edHbI._)((0, $2QP2i._)({}, params), {
                pickedResults: pickedResults
            }));
            (0, $4WgAH.default).fetchAll();
            return project;
        });
        (0, $cr2GM._)(this, "setSort", (value)=>{
            const selected = this.sort && this.sort.includes(value);
            if (selected && this.sort.includes("desc")) this.sort = `${value}:asc`;
            else this.sort = `${value}:desc`;
            return this.sort;
        });
        (0, $cr2GM._)(this, "setFilter", (name, value)=>{
            const newFilters = (0, $2QP2i._)({}, this.filters);
            if (value === null) delete newFilters[name];
            else newFilters[name] = value;
            this.filters = newFilters;
        });
        (0, $cr2GM._)(this, "clearFilters", ()=>{
            this.filters = {};
            this.sort = "";
        });
        (0, $cr2GM._)(this, "fetchBuilding", async (id)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getBuildingsById([
                id
            ], 1);
            return data.data[0];
        });
        (0, $cr2GM._)(this, "setFilters", (newFilters)=>{
            this.filters = newFilters;
        });
        (0, $cr2GM._)(this, "restoreFilters", async (savedSearchId)=>{
            var _response_data_data, _response_data;
            const response = await (0, $lxEiN.default).SavedSearchFilters.get(savedSearchId);
            this.setFilters((_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_data = _response_data.data) === null || _response_data_data === void 0 ? void 0 : _response_data_data.query);
        });
        (0, $cr2GM._)(this, "saveFilters", async (name, projectId)=>{
            const response = await (0, $lxEiN.default).SavedSearchFilters.create(name, this.filters, projectId);
            const newSavedSearches = [
                ...this.savedSearches,
                response.data.data
            ];
            this.savedSearches = newSavedSearches;
        });
        (0, $cr2GM._)(this, "deleteSavedSearch", async (savedSearchId)=>{
            const newSavedSearches = [
                ...this.savedSearches
            ].filter((savedSearch)=>savedSearch.id !== savedSearchId);
            this.savedSearches = newSavedSearches;
            (0, $lxEiN.default).SavedSearchFilters.delete(savedSearchId);
        });
        (0, $cr2GM._)(this, "getSavedSearches", async (projectId)=>{
            const response = await (0, $lxEiN.default).SavedSearchFilters.getAll({
                projectId: projectId
            });
            this.savedSearches = response.data.data;
        });
        (0, $cr2GM._)(this, "fetch", async ()=>{
            var _data_hexagons;
            this.results = [];
            this.points = [];
            // Fill results with loading results for visual feedback
            const arr = [
                ...new Array(10)
            ].map((item, index)=>{
                return [
                    index,
                    0
                ];
            });
            this.resultMap = new Map(arr);
            const params = $74f886f614e1467d$var$parseFilters(this.filters);
            if (this.sort) params.sort = this.sort;
            params.version = "v2";
            const { data: data } = await (0, $lxEiN.default).Building.getBuildings(params);
            const map = data.data.reduce((acc, result)=>{
                acc[result.id] = result;
                return acc;
            }, {});
            if (data.ids) {
                const arr = data.ids.map((value)=>{
                    const [id] = value;
                    if (map[id]) return [
                        id,
                        map[id]
                    ];
                    return [
                        id,
                        0
                    ];
                });
                this.resultMap = new Map(arr);
            }
            this.location = data.location || null;
            if ((_data_hexagons = data.hexagons) === null || _data_hexagons === void 0 ? void 0 : _data_hexagons.length) this.hexagons = data.hexagons;
            else this.hexagons = [];
            // Don't change the order since observers depend on it
            this.bbox = data.bbox;
            if (!this.filters.geo_polygon) (0, $gcPmB.default).setBounds(data.bbox);
            if (this.filters.project_id) this.projectId = this.filters.project_id;
            this.points = data.ids;
            this.financials = data.financials;
            this.emissions = data.emissions;
            this.totalResults = data.total;
            this.aggregations = data.aggregations;
        });
        (0, $cr2GM._)(this, "loadBuilding", async (buildingId)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getBuilding(buildingId);
            if (data.data) {
                const formattedData = (0, $ht0W2.formatBuildingData)(data.data);
                const building = (0, $edHbI._)((0, $2QP2i._)({}, formattedData), {
                    formatted_details: data.data.formatted_details,
                    details: (0, $ht0W2.formatBuildingDetails)(data.data)
                });
                // console.log('BUILDING', formattedData, data.data);
                this.buildings.set(data.data.id, building);
                return building;
            }
            return null;
        });
        (0, $cr2GM._)(this, "getWeather", async (buildingId, lon, lat)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getWeather(lon, lat);
            if (data === null || data === void 0 ? void 0 : data.data) {
                const weather = data.data.wind_speed_temp.reduce((acc, item)=>{
                    acc.weather_timestamp.push(item[0] * 1000);
                    acc.wind_speed.push(item[1]);
                    acc.temperature.push(item[2]);
                    return acc;
                }, {
                    weather_timestamp: [],
                    wind_speed: [],
                    temperature: []
                });
                const building = this.buildings.get(buildingId);
                this.buildings.set(buildingId, (0, $2QP2i._)({}, building, weather));
            }
        });
        (0, $cr2GM._)(this, "getPowerOptions", async (buildingId, lon, lat)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getPowerOptions(lon, lat);
            if (data === null || data === void 0 ? void 0 : data.data) {
                const { power_line_closest_point: power_line_closest_point, power_line_geometry: power_line_geometry, power_line_id: power_line_id, power_plant_geometry: power_plant_geometry } = data.data;
                const building = this.buildings.get(buildingId);
                this.buildings.set(buildingId, (0, $edHbI._)((0, $2QP2i._)({}, building), {
                    details: (0, $2QP2i._)({}, building.details, (0, $ht0W2.formatBuildingPower)(data.data)),
                    closest_power_plant: true,
                    power_line: {
                        power_line_closest_point: power_line_closest_point,
                        power_line_geometry: power_line_geometry,
                        power_line_id: power_line_id,
                        power_plant_geometry: power_plant_geometry
                    }
                }));
            }
        });
        (0, $cr2GM._)(this, "getPlaces", async (buildingId, lon, lat)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getPlaces(lon, lat);
            if (data === null || data === void 0 ? void 0 : data.data) {
                const building = this.buildings.get(buildingId);
                this.buildings.set(buildingId, (0, $edHbI._)((0, $2QP2i._)({}, building), {
                    places: data.data
                }));
            }
        });
        (0, $gOgWf.makeObservable)(this, {
            projectId: (0, $gOgWf.observable),
            buildings: (0, $gOgWf.observable),
            activeProject: (0, $gOgWf.observable),
            aggregations: (0, $gOgWf.observable),
            filters: (0, $gOgWf.observable),
            financials: (0, $gOgWf.observable),
            emissions: (0, $gOgWf.observable),
            sort: (0, $gOgWf.observable),
            pickedResults: (0, $gOgWf.observable),
            savedSearches: (0, $gOgWf.observable),
            totalResults: (0, $gOgWf.observable),
            hexagons: (0, $gOgWf.observable),
            points: (0, $gOgWf.observable),
            bbox: (0, $gOgWf.observable),
            location: (0, $gOgWf.observable),
            resultMap: (0, $gOgWf.observable),
            loadResult: (0, $gOgWf.action),
            debounceLoadResult: (0, $gOgWf.action),
            get: (0, $gOgWf.action),
            pickAllResults: (0, $gOgWf.action),
            createProjectFromPicked: (0, $gOgWf.action),
            setSort: (0, $gOgWf.action),
            clearPicked: (0, $gOgWf.action),
            pickResult: (0, $gOgWf.action),
            unPickResult: (0, $gOgWf.action),
            setFilter: (0, $gOgWf.action),
            clearFilters: (0, $gOgWf.action),
            getFilterValue: (0, $gOgWf.action),
            filtersCount: (0, $gOgWf.computed),
            fetchBuilding: (0, $gOgWf.action),
            clearAllFilters: (0, $gOgWf.action),
            setFilters: (0, $gOgWf.action),
            restoreFilters: (0, $gOgWf.action),
            saveFilters: (0, $gOgWf.action),
            deleteSavedSearch: (0, $gOgWf.action),
            getSavedSearches: (0, $gOgWf.action),
            fetch: (0, $gOgWf.action),
            loadBuilding: (0, $gOgWf.action),
            getWeather: (0, $gOgWf.action),
            getPlaces: (0, $gOgWf.action),
            getPowerOptions: (0, $gOgWf.action),
            params: (0, $gOgWf.computed),
            updateBuildingName: (0, $gOgWf.action)
        });
    }
}
const $74f886f614e1467d$var$store = new $74f886f614e1467d$var$Store();
(0, $gOgWf.reaction)(()=>JSON.stringify([
        $74f886f614e1467d$var$store.filters
    ]), (0, $fBBlk.debounce)(()=>{
    if ((Object.keys($74f886f614e1467d$var$store.filters).includes("addresses") && $74f886f614e1467d$var$store.filters.addresses.length) === 0 && Object.keys($74f886f614e1467d$var$store.filters).length === 1) return;
    $74f886f614e1467d$var$store.fetch();
}, 350));
var $74f886f614e1467d$export$2e2bcd8739ae039 = $74f886f614e1467d$var$store;

});
parcelRegister("cr2GM", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $90da17a50fd8adb7$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $90da17a50fd8adb7$export$1e71eb4bef00f6b0; });
function $90da17a50fd8adb7$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("2QP2i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $213806c615f8d849$export$581ff339ea0ba762; });

var $cr2GM = parcelRequire("cr2GM");
function $213806c615f8d849$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cr2GM._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("edHbI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $02abee93fb4af183$export$4fa2f4023c9cbda5; });
function $02abee93fb4af183$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $02abee93fb4af183$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $02abee93fb4af183$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("fBBlk", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $b5c7473cf3da35ca$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$b5c7473cf3da35ca$var$debounce.debounce = $b5c7473cf3da35ca$var$debounce;
module.exports = $b5c7473cf3da35ca$var$debounce;

});

parcelRegister("lxEiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faebf13b597c0117$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $96kno = parcelRequire("96kno");

var $hqhdr = parcelRequire("hqhdr");

var $3U8SM = parcelRequire("3U8SM");

var $lUBOG = parcelRequire("lUBOG");
const $faebf13b597c0117$var$instance = (0, (/*@__PURE__*/$parcel$interopDefault($96kno))).create({
    baseURL: (0, $lUBOG.default).PROSPECTING_API_URL,
    timeout: 30000,
    withCredentials: true,
    paramsSerializer: (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($hqhdr))).stringify(params, {
            skipNulls: true
        })
});
const $faebf13b597c0117$var$upload = (url, filesLike, onProgress)=>{
    let formData = null;
    if (Array.isArray(filesLike)) {
        formData = new FormData();
        filesLike.forEach((file)=>formData.append("file[]", file));
    }
    if (filesLike instanceof FormData) formData = filesLike;
    if (!formData) throw new Error(`Files must be either FormData or array`);
    return (0, $3U8SM.default).post(url, formData, {
        timeout: Infinity,
        headers: {
            "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (event)=>{
            const percentage = event.loaded / event.total * 100;
            return onProgress(percentage, event);
        }
    });
};
const $faebf13b597c0117$var$Dataset = {
    getFeature: (datasetId, featureId)=>(0, $3U8SM.default).get(`/datasets/${datasetId}/feature/${featureId}`, {
            timeout: 100000
        }),
    getDataset: (datasetId)=>(0, $3U8SM.default).get(`/datasets/${datasetId}`),
    getFeatures: (datasetId, layerId)=>(0, $3U8SM.default).get(`/datasets/${datasetId}/features`, {
            params: {
                layer_id: layerId
            }
        }),
    getLayers: (datasetId)=>(0, $3U8SM.default).get(`/datasets/${datasetId}/layers`),
    createLayer: (datasetId, data)=>(0, $3U8SM.default).post(`/datasets/${datasetId}/layer`, data),
    updateLayer: (datasetId, layerId, params)=>(0, $3U8SM.default).patch(`/datasets/${datasetId}/layer/${layerId}`, params),
    updateFeature: (datasetId, feature)=>(0, $3U8SM.default).patch(`/datasets/${datasetId}/${feature.id}`, feature),
    get: (groupId)=>(0, $3U8SM.default).get(`/datasets`, {
            params: {
                group_id: groupId
            }
        }),
    getLayer: (datasetId, layerId)=>(0, $3U8SM.default).get(`/datasets/${datasetId}/layer/${layerId}`),
    createFeature: (datasetId, feature)=>(0, $3U8SM.default).post(`/datasets/${datasetId}/${feature.id}`, feature),
    updateFeatureProperties: (datasetId, featureId, properties)=>(0, $3U8SM.default).post(`/datasets/${datasetId}/${featureId}/properties`, properties),
    deleteFeature: (datasetId, featureId)=>(0, $3U8SM.default).delete(`/datasets/${datasetId}/${featureId}`),
    createDataset: (data)=>(0, $3U8SM.default).put("/datasets", data),
    updateDataset: (datasetId, params)=>(0, $3U8SM.default).patch(`/datasets/${datasetId}`, params),
    deleteDataset: (datasetId)=>(0, $3U8SM.default).delete(`/datasets/${datasetId}`),
    deleteLayer: (datasetId, layerId)=>(0, $3U8SM.default).delete(`/datasets/${datasetId}/layer/${layerId}`),
    upload: (formData, params)=>(0, $3U8SM.default).post("datasets/upload", formData, params),
    uploadDataset: (files, { name: name, description: description, projectId: projectId, onUploadProgress: onUploadProgress })=>{
        const formData = new FormData();
        formData.append("name", name);
        formData.append("description", description);
        formData.append("projectId", projectId);
        files.forEach((file)=>{
            formData.append("file", file);
        });
        return (0, $3U8SM.default).post("datasets/upload", formData, {
            timeout: Infinity,
            headers: {
                "Content-Type": "multipart/form-data",
                "Cache-Control": "no-cache, no-store"
            },
            onUploadProgress: onUploadProgress
        });
    },
    removeDatasetProject: (datasetId, projectId)=>(0, $3U8SM.default).delete(`/datasets/${datasetId}/project/${projectId}`),
    addDatasetProject: (datasetId, projectId)=>(0, $3U8SM.default).get(`/datasets/${datasetId}/project/${projectId}`),
    search: (term, groupId)=>(0, $3U8SM.default).get("datasets/search", {
            params: {
                term: term,
                group_id: groupId
            }
        })
};
const $faebf13b597c0117$var$Building = {
    runOptimization: (buildingId, params)=>(0, $3U8SM.default).post(`/api/building/${buildingId}/optimization`, params),
    addFiles: (buildingId, fileIds)=>(0, $3U8SM.default).patch(`/building/${buildingId}/files/${fileIds.join(";")}`),
    getBuildings: (params)=>$faebf13b597c0117$var$instance.post("/building", (0, $2QP2i._)({}, params)),
    getBuildingsById: (ids, limit = 30)=>$faebf13b597c0117$var$instance.get("/building", {
            params: {
                ids: ids,
                limit: limit
            }
        }),
    getBuilding: (buildingId, projectId)=>$faebf13b597c0117$var$instance.get(`/building/${buildingId}`, projectId ? {
            project_id: projectId
        } : {}),
    getPlaces: (lon, lat)=>$faebf13b597c0117$var$instance.get(`/places`, {
            params: {
                lon: lon,
                lat: lat
            }
        }),
    getPowerOptions: (lon, lat)=>$faebf13b597c0117$var$instance.get(`/powerline`, {
            params: {
                lon: lon,
                lat: lat
            }
        }),
    getWeather: (lon, lat)=>$faebf13b597c0117$var$instance.get(`/weather`, {
            params: {
                lon: lon,
                lat: lat
            }
        }),
    getPredictions: (buildingId)=>$faebf13b597c0117$var$instance.get(`/building/${buildingId}/predictions?period=7D`),
    getHoverInfo: (longitude, latitude)=>(0, $3U8SM.default).get(`/points/hoverinfo`, {
            params: {
                longitude: longitude,
                latitude: latitude
            }
        })
};
const $faebf13b597c0117$var$Project = {
    getProject: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}`),
    getProjectTerms: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/terms`),
    getStatus: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/status`),
    createProjectProposal: (projectId, files, questions, signature)=>(0, $3U8SM.default).post(`/project/${projectId}/proposals`, {
            files: files,
            questions: questions,
            signature: signature
        }),
    getProjectPredictions: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/predictions?period=7D`),
    getProjectBuildingPredictions: (projectId, buildingId)=>(0, $3U8SM.default).get(`/project/${projectId}/building/${buildingId}/predictions?period=7D`),
    getProjectFinancials: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/financials`),
    getProjectRFPQuestions: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/rfp_questions`),
    setProjectRFPQuestions: (projectId, questions)=>(0, $3U8SM.default).patch(`/project/${projectId}/rfp_questions`, questions),
    createProjectRFPQuestion: (projectId, data)=>(0, $3U8SM.default).post(`/project/${projectId}/rfp_question`, data),
    deleteProjectRFPQuestion: (projectId, questionId)=>(0, $3U8SM.default).delete(`/project/${projectId}/rfp_question/${questionId}`),
    updateProjectRFPQuestion: (projectId, questionId, data)=>(0, $3U8SM.default).patch(`/project/${projectId}/rfp_question/${questionId}`, data),
    updateProjectTerms: (projectId, termsId, data)=>(0, $3U8SM.default).patch(`/project/${projectId}/terms/${termsId}`, data),
    createProjectTerms: (projectId, terms)=>(0, $3U8SM.default).post(`/project/${projectId}/terms`, terms),
    deleteProjectTerms: (projectId, termsId)=>(0, $3U8SM.default).delete(`/project/${projectId}/terms/${termsId}`),
    getProjectTermsById: (projectId, termsId)=>(0, $3U8SM.default).get(`/project/${projectId}/terms/${termsId}`),
    hasAccess: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/has_access`),
    updateProject: (projectId, data)=>(0, $3U8SM.default).patch(`/project/${projectId}`, data),
    getProjects: ()=>(0, $3U8SM.default).get(`/project`),
    deleteProject: (projectId)=>(0, $3U8SM.default).delete(`/project/${projectId}`),
    getProjectBuilding: (projectId, buildingId)=>(0, $3U8SM.default).get(`/project/${projectId}/building/${buildingId}`),
    getProjectFeature: (projectId, featureId)=>(0, $3U8SM.default).get(`/project/${projectId}/feature/${featureId}`),
    refreshProjectFinancials: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/financials/refresh`),
    updateProjectBuilding: (projectId, buildingId, buildingData)=>(0, $3U8SM.default).post(`/project/${projectId}/building/${buildingId}`, buildingData),
    getBuildingAnalyticsSettings: (projectId, buildingId)=>(0, $3U8SM.default).get(`/project/${projectId}/building/${buildingId}/analytics_settings`),
    getProjectVendors: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/vendors`),
    getProjectBuildings: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/buildings`),
    getProjectLayers: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/layers`),
    getBuildingFinancials: (projectId, buildingId)=>(0, $3U8SM.default).get(`/project/${projectId}/building/${buildingId}/financials`),
    updateBuildingSettings: (projectId, buildingId, settings)=>(0, $3U8SM.default).patch(`/project/${projectId}/building/${buildingId}/settings`, settings),
    createBuilding: (projectId, buildingData)=>(0, $3U8SM.default).post(`/project/${projectId}/add`, buildingData),
    addBuilding: (projectId, buildingIds)=>(0, $3U8SM.default).post(`/project/${projectId}/add`, buildingIds),
    addBuildingByImportId: (projectId, importId)=>(0, $3U8SM.default).post(`/project/${projectId}/add`, {
            import_id: importId
        }),
    createProjectByImportId: (importId, projectName = "Imported Project")=>(0, $3U8SM.default).post("/project", {
            name: projectName,
            importId: importId
        }),
    removeBuilding: (projectId, buildingIds)=>(0, $3U8SM.default).post(`/project/${projectId}/remove`, buildingIds),
    createProject: (params)=>(0, $3U8SM.default).post("/project", params),
    updateProjectBuildingGeometry: (projectId, buildingId, geometry)=>(0, $3U8SM.default).post(`/project/${projectId}/building/${buildingId}/geometry`, geometry),
    acceptInfoMessage: (projectId)=>(0, $3U8SM.default).post(`/project/${projectId}/accept_infomessage`),
    setProjectSettings: (projectId, settingsData)=>(0, $3U8SM.default).patch(`/project/${projectId}/settings`, settingsData),
    getSystems: (projectId)=>(0, $3U8SM.default).get("/crawler/system", {
            params: {
                project_id: projectId
            }
        }),
    getSystemData: (systemId, timeWindow, time)=>(0, $3U8SM.default).get(`/crawler/system/${systemId}/data`, {
            params: {
                timeWindow: timeWindow,
                time: time
            }
        }),
    getFiles: (projectId, fileIds = [])=>(0, $3U8SM.default).get(`/project/${projectId}/files/${fileIds.join(";")}`),
    deleteFiles: (projectId, fileIds)=>(0, $3U8SM.default).delete(`/project/${projectId}/files/${fileIds.join(";")}`),
    addFiles: (projectId, fileIds)=>(0, $3U8SM.default).patch(`/project/${projectId}/files/${fileIds.join(";")}`),
    getProposal: (projectId, proposalId)=>(0, $3U8SM.default).get(`/project/${projectId}/proposals/${proposalId}`),
    deleteProposal: (projectId, proposalId)=>(0, $3U8SM.default).delete(`/project/${projectId}/proposals/${proposalId}`),
    getProposals: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/proposals`),
    addProposals: (projectId, fileIds)=>(0, $3U8SM.default).patch(`/project/${projectId}/proposals/${fileIds.join(";")}`),
    addVendors: (projectId, vendorIds)=>(0, $3U8SM.default).post(`/project/${projectId}/share`, vendorIds),
    addMembers: (projectId, memberIds)=>(0, $3U8SM.default).put(`/project/${projectId}/members`, memberIds),
    getChat: (projectId)=>(0, $3U8SM.default).get(`/project/${projectId}/chat`),
    updateChat: (projectId, chatData)=>(0, $3U8SM.default).post(`/project/${projectId}/chat`, {
            chat: chatData
        }),
    uploadBuildingLoadProfile: (projectId, buildingId, files, onProgressCallback)=>{
        const url = `/project/${projectId}/building/${buildingId}/load_profile`;
        return $faebf13b597c0117$var$upload(url, files, onProgressCallback);
    },
    uploadBuildingRate: (projectId, buildingId, files, onProgressCallback)=>{
        const url = `/project/${projectId}/building/${buildingId}/rate`;
        return $faebf13b597c0117$var$upload(url, files, onProgressCallback);
    },
    deleteBuildingLoadProfile: (projectId, buildingId)=>(0, $3U8SM.default).delete(`/project/${projectId}/building/${buildingId}/load_profile`),
    getVendorSuggestions: (projectId, q)=>(0, $3U8SM.default).get(`/project/${projectId}/vendor_suggestions`, {
            params: {
                q: q
            }
        }),
    addVendor: (projectId, groupIdLike)=>(0, $3U8SM.default).post(`/project/${projectId}/invite_vendor`, {
            id: groupIdLike
        }),
    removeVendor: (projectId, groupId)=>(0, $3U8SM.default).delete(`/project/${projectId}/remove_vendor`, {
            params: {
                group_id: groupId
            }
        }),
    uploadBuildingCSV: (projectId, files, onProgressCallback)=>{
        const url = `/importer-service/upload`;
        return $faebf13b597c0117$var$upload(url, files, onProgressCallback);
    },
    checkForImport: (importId, importItemIndex)=>{
        const url = `/importer-service/import/${importId}/check`;
        return (0, $3U8SM.default).get(url, {
            params: {
                index: importItemIndex
            }
        });
    },
    uncheckForImport: (importId, importItemIndex)=>{
        const url = `/importer-service/import/${importId}/uncheck`;
        // console.log();
        return (0, $3U8SM.default).get(url, {
            params: {
                index: importItemIndex
            }
        });
    },
    getImportStatus: (importId)=>{
        const url = `/importer-service/status/${importId}`;
        return (0, $3U8SM.default).get(url);
    }
};
const $faebf13b597c0117$var$Group = {
    getSettings: (groupId)=>(0, $3U8SM.default).get(`/group/${groupId}/settings`),
    update: (groupId, data)=>(0, $3U8SM.default).patch(`/group/${groupId}`, data),
    setSettings: (groupId, data)=>(0, $3U8SM.default).post(`/group/${groupId}/settings`, data),
    delete: (groupId)=>(0, $3U8SM.default).delete(`/group/${groupId}`),
    search: (query)=>(0, $3U8SM.default).get(`/group/search`, {
            params: {
                query: query
            }
        })
};
const $faebf13b597c0117$var$User = {
    validateResetToken: (token)=>(0, $3U8SM.default).get(`/reset/check/${token}`),
    validateUserActivationToken: (token)=>(0, $3U8SM.default).get(`/activate/${token}`),
    getGroups: ()=>(0, $3U8SM.default).get(`/user/groups`),
    sendPasswordResetEmail: (email)=>(0, $3U8SM.default).get(`/reset`, {
            params: {
                email: email
            }
        }),
    signup: (data)=>(0, $3U8SM.default).post(`/signup`, data),
    skipOnboarding: ()=>(0, $3U8SM.default).post(`/user/onboarding/skip`),
    logout: ()=>(0, $3U8SM.default).get(`/logout`),
    sendFeedback: (formData)=>(0, $3U8SM.default).post(`/user/feedback`, formData),
    onboardingComplete: ()=>(0, $3U8SM.default).post(`/user/onboarding/complete`),
    createSignupProject: (data)=>(0, $3U8SM.default).post(`/signup/project`, data),
    updateUserInfo: (id, data)=>(0, $3U8SM.default).put(`/user/${id}`, data),
    getUserAvatar: (id)=>(0, $3U8SM.default).get(`/user/${id}/avatar`),
    submitOnboardingAnswer: (question, answer, userId)=>(0, $3U8SM.default).post(`/user/onboarding/answer`, {
            user_id: userId,
            question: question,
            answer: answer
        }),
    resetPassword: (send_email, user_id)=>(0, $3U8SM.default).post(`/reset_password`, send_email, user_id)
};
const $faebf13b597c0117$var$Admin = {
    sendResetPassword: (send_email, user_id)=>(0, $3U8SM.default).post(`/admin/user/reset_password`, send_email, user_id),
    sendMagicLink: (userId)=>(0, $3U8SM.default).post(`/admin/user/magic_link`, {
            user_id: userId
        })
};
const $faebf13b597c0117$var$Task = {
    get: (id)=>(0, $3U8SM.default).get(`/task/${id}`),
    create: (params)=>(0, $3U8SM.default).post("/task", params),
    update: (id, params)=>(0, $3U8SM.default).patch(`/task/${id}`, params),
    delete: (id)=>(0, $3U8SM.default).delete(`/task/${id}`),
    getProjectTasks: (projectId, buildingId)=>buildingId ? (0, $3U8SM.default).get(`/project/${projectId}/building/${buildingId}/tasks`) : (0, $3U8SM.default).get(`/project/${projectId}/tasks`)
};
const $faebf13b597c0117$var$Data = {
    getDataset: (name)=>(0, $3U8SM.default).get(`/data/${name}`),
    getCountries: ()=>(0, $3U8SM.default).get(`/data/countries`),
    getISOTerritories: (term)=>(0, $3U8SM.default).get(`/data/iso_territories`, {
            params: {
                term: term
            }
        }),
    getUtilityTerritories: (term)=>(0, $3U8SM.default).get(`/data/utility_territories`, {
            params: {
                term: term
            }
        })
};
const $faebf13b597c0117$var$SavedSearchFilters = {
    get: (id)=>(0, $3U8SM.default).get(`/user/search/${id}`),
    getAll: ({ projectId: projectId })=>(0, $3U8SM.default).get(`/user/search`, {
            params: {
                project_id: projectId
            }
        }),
    create: (name, data, projectId)=>(0, $3U8SM.default).post(`/user/search`, {
            name: name,
            data: data,
            project_id: projectId
        }),
    delete: (id)=>(0, $3U8SM.default).delete(`/user/search/${id}`)
};
const $faebf13b597c0117$var$Log = {
    get: (groupId, projectId)=>(0, $3U8SM.default).get(`/log`, {
            params: {
                group_id: groupId,
                project_id: projectId
            }
        }),
    getCSV: (groupId)=>(0, $3U8SM.default).get(`/log/csv`, {
            params: {
                group_id: groupId
            }
        }),
    getItem: (id)=>(0, $3U8SM.default).get(`/log/${id}`)
};
const $faebf13b597c0117$var$Survey = {
    addSurvey: (projectId, data)=>(0, $3U8SM.default).post(`/project/${projectId}/survey`, data),
    getSteps: (projectId, buildingId)=>(0, $3U8SM.default).get(`/project/${projectId}/building/${buildingId}/survey`),
    submitAnswer: (projectId, buildingId, stepId, value)=>(0, $3U8SM.default).post(`/project/${projectId}/building/${buildingId}/survey/step/${stepId}`, {
            value: value
        }),
    utilityDetails: (projectId, buildingId)=>(0, $3U8SM.default).post(`/project/${projectId}/building/${buildingId}/survey/utilitydetails`),
    setFinished: (projectId, buildingId)=>(0, $3U8SM.default).post(`/project/${projectId}/building/${buildingId}/survey/complete`),
    addCategory: (data = {
        label: "",
        order: 1,
        description: ""
    })=>(0, $3U8SM.default).post(`/admin/survey/category`, data),
    deleteCategory: (categoryId)=>(0, $3U8SM.default).delete(`/admin/survey/category/${categoryId}`),
    addStep: (data = {
        id: "",
        label: "",
        order: 1,
        inputType: "text",
        buildingId: "",
        description: ""
    })=>(0, $3U8SM.default).post(`/admin/survey/step`, data),
    deleteStep: (stepId)=>(0, $3U8SM.default).delete(`/admin/survey/step/${stepId}`)
};
const $faebf13b597c0117$var$Workspace = {
    createFolder: (folderId, folderName)=>(0, $3U8SM.default).post(`/workspaces/folders/${folderId}`, {
            name: folderName
        }),
    move: (pathId, newParentId)=>(0, $3U8SM.default).patch(`/workspaces/files/${pathId}`, {
            parentId: newParentId
        }),
    delete: (itemIds)=>(0, $3U8SM.default).delete(`/workspaces/folders`, {
            data: {
                ids: itemIds
            }
        }),
    renameFolder: (folderId, newName)=>(0, $3U8SM.default).patch(`/workspaces/folders/${folderId}`, {
            name: newName
        }),
    getArchiveUrl: (parentId, fileIds)=>{
        return (0, $3U8SM.default).get(`/workspaces/folders/${parentId}/download`, {
            params: {
                file_ids: fileIds.join(";")
            }
        });
    },
    createFile: (parentId, formData, params)=>(0, $3U8SM.default).post(`/workspaces/${parentId}/files`, formData, params),
    getFile: (fileId)=>(0, $3U8SM.default).get(`/workspaces/files/${fileId}`),
    get: (id, sortKey)=>(0, $3U8SM.default).get(`/workspaces/folders/${id}`, {
            params: {
                sort: sortKey
            }
        }),
    upload: (parentId, filesLike, onProgress)=>{
        let formData = null;
        if (Array.isArray(filesLike)) {
            formData = new FormData();
            filesLike.forEach((file)=>formData.append("file[]", file));
        }
        if (filesLike instanceof FormData) formData = filesLike;
        if (!formData) throw new Error(`Files must be either FormData or array`);
        return (0, $3U8SM.default).post(`/workspaces/${parentId}/files`, formData, {
            timeout: Infinity,
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress: (event)=>{
                const percentage = event.loaded / event.total * 100;
                return onProgress(percentage, event);
            }
        });
    }
};
const $faebf13b597c0117$var$Address = {
    geocode: (address)=>(0, $3U8SM.default).get(`/api/geocode`, {
            params: {
                address: address,
                key: "HwphuLg1MaToFC13M49QMG"
            }
        }),
    autocomplete: (address)=>(0, $3U8SM.default).get(`/api/autocomplete`, {
            params: {
                q: address,
                key: "HwphuLg1MaToFC13M49QMG"
            }
        })
};
var $faebf13b597c0117$export$2e2bcd8739ae039 = {
    Address: $faebf13b597c0117$var$Address,
    Dataset: $faebf13b597c0117$var$Dataset,
    SavedSearchFilters: $faebf13b597c0117$var$SavedSearchFilters,
    Data: $faebf13b597c0117$var$Data,
    Building: $faebf13b597c0117$var$Building,
    Project: $faebf13b597c0117$var$Project,
    Group: $faebf13b597c0117$var$Group,
    User: $faebf13b597c0117$var$User,
    Admin: $faebf13b597c0117$var$Admin,
    Task: $faebf13b597c0117$var$Task,
    Log: $faebf13b597c0117$var$Log,
    Survey: $faebf13b597c0117$var$Survey,
    Workspace: $faebf13b597c0117$var$Workspace
};

});
parcelRegister("96kno", function(module, exports) {

module.exports = (parcelRequire("7adkN"));

});
parcelRegister("7adkN", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");

var $aPrk0 = parcelRequire("aPrk0");

var $0yJ19 = parcelRequire("0yJ19");

var $4HCLR = parcelRequire("4HCLR");

var $eBlJu = parcelRequire("eBlJu");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5373cf85e013fcc9$var$createInstance(defaultConfig) {
    var context = new $0yJ19(defaultConfig);
    var instance = $aPrk0($0yJ19.prototype.request, context);
    // Copy axios.prototype to instance
    $lKhqw.extend(instance, $0yJ19.prototype, context);
    // Copy context to instance
    $lKhqw.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $5373cf85e013fcc9$var$axios = $5373cf85e013fcc9$var$createInstance($eBlJu);
// Expose Axios class to allow class inheritance
$5373cf85e013fcc9$var$axios.Axios = $0yJ19;
// Factory for creating new instances
$5373cf85e013fcc9$var$axios.create = function create(instanceConfig) {
    return $5373cf85e013fcc9$var$createInstance($4HCLR($5373cf85e013fcc9$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$5373cf85e013fcc9$var$axios.Cancel = (parcelRequire("2h22r"));

$5373cf85e013fcc9$var$axios.CancelToken = (parcelRequire("6pDYR"));

$5373cf85e013fcc9$var$axios.isCancel = (parcelRequire("HLDIA"));
// Expose all/spread
$5373cf85e013fcc9$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5373cf85e013fcc9$var$axios.spread = (parcelRequire("8U7FG"));
module.exports = $5373cf85e013fcc9$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5373cf85e013fcc9$var$axios;

});
parcelRegister("lKhqw", function(module, exports) {
"use strict";

var $aPrk0 = parcelRequire("aPrk0");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $fd4b6975c6d4e60d$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $fd4b6975c6d4e60d$var$isArray(val) {
    return $fd4b6975c6d4e60d$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $fd4b6975c6d4e60d$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $fd4b6975c6d4e60d$var$isBuffer(val) {
    return val !== null && !$fd4b6975c6d4e60d$var$isUndefined(val) && val.constructor !== null && !$fd4b6975c6d4e60d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $fd4b6975c6d4e60d$var$isArrayBuffer(val) {
    return $fd4b6975c6d4e60d$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $fd4b6975c6d4e60d$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $fd4b6975c6d4e60d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $fd4b6975c6d4e60d$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $fd4b6975c6d4e60d$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $fd4b6975c6d4e60d$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $fd4b6975c6d4e60d$var$isDate(val) {
    return $fd4b6975c6d4e60d$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $fd4b6975c6d4e60d$var$isFile(val) {
    return $fd4b6975c6d4e60d$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $fd4b6975c6d4e60d$var$isBlob(val) {
    return $fd4b6975c6d4e60d$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $fd4b6975c6d4e60d$var$isFunction(val) {
    return $fd4b6975c6d4e60d$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $fd4b6975c6d4e60d$var$isStream(val) {
    return $fd4b6975c6d4e60d$var$isObject(val) && $fd4b6975c6d4e60d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $fd4b6975c6d4e60d$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $fd4b6975c6d4e60d$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $fd4b6975c6d4e60d$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $fd4b6975c6d4e60d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($fd4b6975c6d4e60d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $fd4b6975c6d4e60d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $fd4b6975c6d4e60d$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$fd4b6975c6d4e60d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $fd4b6975c6d4e60d$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $fd4b6975c6d4e60d$var$deepMerge(result[key], val);
        else if (typeof val === "object") result[key] = $fd4b6975c6d4e60d$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$fd4b6975c6d4e60d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $fd4b6975c6d4e60d$var$extend(a, b, thisArg) {
    $fd4b6975c6d4e60d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $aPrk0(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $fd4b6975c6d4e60d$var$isArray,
    isArrayBuffer: $fd4b6975c6d4e60d$var$isArrayBuffer,
    isBuffer: $fd4b6975c6d4e60d$var$isBuffer,
    isFormData: $fd4b6975c6d4e60d$var$isFormData,
    isArrayBufferView: $fd4b6975c6d4e60d$var$isArrayBufferView,
    isString: $fd4b6975c6d4e60d$var$isString,
    isNumber: $fd4b6975c6d4e60d$var$isNumber,
    isObject: $fd4b6975c6d4e60d$var$isObject,
    isUndefined: $fd4b6975c6d4e60d$var$isUndefined,
    isDate: $fd4b6975c6d4e60d$var$isDate,
    isFile: $fd4b6975c6d4e60d$var$isFile,
    isBlob: $fd4b6975c6d4e60d$var$isBlob,
    isFunction: $fd4b6975c6d4e60d$var$isFunction,
    isStream: $fd4b6975c6d4e60d$var$isStream,
    isURLSearchParams: $fd4b6975c6d4e60d$var$isURLSearchParams,
    isStandardBrowserEnv: $fd4b6975c6d4e60d$var$isStandardBrowserEnv,
    forEach: $fd4b6975c6d4e60d$var$forEach,
    merge: $fd4b6975c6d4e60d$var$merge,
    deepMerge: $fd4b6975c6d4e60d$var$deepMerge,
    extend: $fd4b6975c6d4e60d$var$extend,
    trim: $fd4b6975c6d4e60d$var$trim
};

});
parcelRegister("aPrk0", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("0yJ19", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");

var $iUyGw = parcelRequire("iUyGw");

var $avirQ = parcelRequire("avirQ");

var $eiKwg = parcelRequire("eiKwg");

var $4HCLR = parcelRequire("4HCLR");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $001aefe19d856021$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $avirQ(),
        response: new $avirQ()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $001aefe19d856021$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $4HCLR(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $eiKwg,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$001aefe19d856021$var$Axios.prototype.getUri = function getUri(config) {
    config = $4HCLR(this.defaults, config);
    return $iUyGw(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$lKhqw.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $001aefe19d856021$var$Axios.prototype[method] = function(url, config) {
        return this.request($lKhqw.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$lKhqw.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $001aefe19d856021$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lKhqw.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $001aefe19d856021$var$Axios;

});
parcelRegister("iUyGw", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
function $dc485ca62913762a$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($lKhqw.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $lKhqw.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($lKhqw.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $lKhqw.forEach(val, function parseValue(v) {
                if ($lKhqw.isDate(v)) v = v.toISOString();
                else if ($lKhqw.isObject(v)) v = JSON.stringify(v);
                parts.push($dc485ca62913762a$var$encode(key) + "=" + $dc485ca62913762a$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("avirQ", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
function $7a5b1c0937c752f6$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $7a5b1c0937c752f6$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $7a5b1c0937c752f6$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $7a5b1c0937c752f6$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $lKhqw.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $7a5b1c0937c752f6$var$InterceptorManager;

});

parcelRegister("eiKwg", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");

var $lgs8l = parcelRequire("lgs8l");

var $HLDIA = parcelRequire("HLDIA");

var $eBlJu = parcelRequire("eBlJu");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $a696d4ee9286baa4$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a696d4ee9286baa4$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $lgs8l(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $lKhqw.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $lKhqw.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $eBlJu.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a696d4ee9286baa4$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $lgs8l(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$HLDIA(reason)) {
            $a696d4ee9286baa4$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $lgs8l(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("lgs8l", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $lKhqw.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("HLDIA", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("eBlJu", function(module, exports) {

var $95Bnk = parcelRequire("95Bnk");
"use strict";

var $lKhqw = parcelRequire("lKhqw");

var $8L8x3 = parcelRequire("8L8x3");
var $aa1561117f5df43f$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $aa1561117f5df43f$var$setContentTypeIfUnset(headers, value) {
    if (!$lKhqw.isUndefined(headers) && $lKhqw.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $aa1561117f5df43f$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("9gGJV"));
    else if (typeof $95Bnk !== "undefined" && Object.prototype.toString.call($95Bnk) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("9gGJV"));
    return adapter;
}
var $aa1561117f5df43f$var$defaults = {
    adapter: $aa1561117f5df43f$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $8L8x3(headers, "Accept");
            $8L8x3(headers, "Content-Type");
            if ($lKhqw.isFormData(data) || $lKhqw.isArrayBuffer(data) || $lKhqw.isBuffer(data) || $lKhqw.isStream(data) || $lKhqw.isFile(data) || $lKhqw.isBlob(data)) return data;
            if ($lKhqw.isArrayBufferView(data)) return data.buffer;
            if ($lKhqw.isURLSearchParams(data)) {
                $aa1561117f5df43f$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($lKhqw.isObject(data)) {
                $aa1561117f5df43f$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$aa1561117f5df43f$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$lKhqw.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $aa1561117f5df43f$var$defaults.headers[method] = {};
});
$lKhqw.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $aa1561117f5df43f$var$defaults.headers[method] = $lKhqw.merge($aa1561117f5df43f$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $aa1561117f5df43f$var$defaults;

});
parcelRegister("95Bnk", function(module, exports) {
// shim for using process in browser
var $69e192a00f641b7a$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $69e192a00f641b7a$var$cachedSetTimeout;
var $69e192a00f641b7a$var$cachedClearTimeout;
function $69e192a00f641b7a$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $69e192a00f641b7a$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $69e192a00f641b7a$var$cachedSetTimeout = setTimeout;
        else $69e192a00f641b7a$var$cachedSetTimeout = $69e192a00f641b7a$var$defaultSetTimout;
    } catch (e) {
        $69e192a00f641b7a$var$cachedSetTimeout = $69e192a00f641b7a$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $69e192a00f641b7a$var$cachedClearTimeout = clearTimeout;
        else $69e192a00f641b7a$var$cachedClearTimeout = $69e192a00f641b7a$var$defaultClearTimeout;
    } catch (e) {
        $69e192a00f641b7a$var$cachedClearTimeout = $69e192a00f641b7a$var$defaultClearTimeout;
    }
})();
function $69e192a00f641b7a$var$runTimeout(fun) {
    if ($69e192a00f641b7a$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($69e192a00f641b7a$var$cachedSetTimeout === $69e192a00f641b7a$var$defaultSetTimout || !$69e192a00f641b7a$var$cachedSetTimeout) && setTimeout) {
        $69e192a00f641b7a$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $69e192a00f641b7a$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $69e192a00f641b7a$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $69e192a00f641b7a$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $69e192a00f641b7a$var$runClearTimeout(marker) {
    if ($69e192a00f641b7a$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($69e192a00f641b7a$var$cachedClearTimeout === $69e192a00f641b7a$var$defaultClearTimeout || !$69e192a00f641b7a$var$cachedClearTimeout) && clearTimeout) {
        $69e192a00f641b7a$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $69e192a00f641b7a$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $69e192a00f641b7a$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $69e192a00f641b7a$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $69e192a00f641b7a$var$queue = [];
var $69e192a00f641b7a$var$draining = false;
var $69e192a00f641b7a$var$currentQueue;
var $69e192a00f641b7a$var$queueIndex = -1;
function $69e192a00f641b7a$var$cleanUpNextTick() {
    if (!$69e192a00f641b7a$var$draining || !$69e192a00f641b7a$var$currentQueue) return;
    $69e192a00f641b7a$var$draining = false;
    if ($69e192a00f641b7a$var$currentQueue.length) $69e192a00f641b7a$var$queue = $69e192a00f641b7a$var$currentQueue.concat($69e192a00f641b7a$var$queue);
    else $69e192a00f641b7a$var$queueIndex = -1;
    if ($69e192a00f641b7a$var$queue.length) $69e192a00f641b7a$var$drainQueue();
}
function $69e192a00f641b7a$var$drainQueue() {
    if ($69e192a00f641b7a$var$draining) return;
    var timeout = $69e192a00f641b7a$var$runTimeout($69e192a00f641b7a$var$cleanUpNextTick);
    $69e192a00f641b7a$var$draining = true;
    var len = $69e192a00f641b7a$var$queue.length;
    while(len){
        $69e192a00f641b7a$var$currentQueue = $69e192a00f641b7a$var$queue;
        $69e192a00f641b7a$var$queue = [];
        while(++$69e192a00f641b7a$var$queueIndex < len)if ($69e192a00f641b7a$var$currentQueue) $69e192a00f641b7a$var$currentQueue[$69e192a00f641b7a$var$queueIndex].run();
        $69e192a00f641b7a$var$queueIndex = -1;
        len = $69e192a00f641b7a$var$queue.length;
    }
    $69e192a00f641b7a$var$currentQueue = null;
    $69e192a00f641b7a$var$draining = false;
    $69e192a00f641b7a$var$runClearTimeout(timeout);
}
$69e192a00f641b7a$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $69e192a00f641b7a$var$queue.push(new $69e192a00f641b7a$var$Item(fun, args));
    if ($69e192a00f641b7a$var$queue.length === 1 && !$69e192a00f641b7a$var$draining) $69e192a00f641b7a$var$runTimeout($69e192a00f641b7a$var$drainQueue);
};
// v8 likes predictible objects
function $69e192a00f641b7a$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$69e192a00f641b7a$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$69e192a00f641b7a$var$process.title = "browser";
$69e192a00f641b7a$var$process.browser = true;
$69e192a00f641b7a$var$process.env = {};
$69e192a00f641b7a$var$process.argv = [];
$69e192a00f641b7a$var$process.version = ""; // empty string to avoid regexp issues
$69e192a00f641b7a$var$process.versions = {};
function $69e192a00f641b7a$var$noop() {}
$69e192a00f641b7a$var$process.on = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.addListener = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.once = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.off = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.removeListener = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.removeAllListeners = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.emit = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.prependListener = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.prependOnceListener = $69e192a00f641b7a$var$noop;
$69e192a00f641b7a$var$process.listeners = function(name) {
    return [];
};
$69e192a00f641b7a$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$69e192a00f641b7a$var$process.cwd = function() {
    return "/";
};
$69e192a00f641b7a$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$69e192a00f641b7a$var$process.umask = function() {
    return 0;
};

});

parcelRegister("8L8x3", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $lKhqw.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("9gGJV", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");

var $lDK0X = parcelRequire("lDK0X");

var $iUyGw = parcelRequire("iUyGw");

var $bueOp = parcelRequire("bueOp");

var $fqmMy = parcelRequire("fqmMy");

var $6YDQT = parcelRequire("6YDQT");

var $8eGGi = parcelRequire("8eGGi");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($lKhqw.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $bueOp(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $iUyGw(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $fqmMy(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $lDK0X(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($8eGGi("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($8eGGi("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($8eGGi(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($lKhqw.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("3PTc0"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $6YDQT(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $lKhqw.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$lKhqw.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("lDK0X", function(module, exports) {
"use strict";

var $8eGGi = parcelRequire("8eGGi");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($8eGGi("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("8eGGi", function(module, exports) {
"use strict";

var $4ODsI = parcelRequire("4ODsI");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $4ODsI(error, config, code, request, response);
};

});
parcelRegister("4ODsI", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("bueOp", function(module, exports) {
"use strict";

var $7sSu0 = parcelRequire("7sSu0");

var $1Sn7d = parcelRequire("1Sn7d");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$7sSu0(requestedURL)) return $1Sn7d(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("7sSu0", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("1Sn7d", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("fqmMy", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $b3aaf4cd5be16710$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $lKhqw.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $lKhqw.trim(line.substr(0, i)).toLowerCase();
        val = $lKhqw.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $b3aaf4cd5be16710$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("6YDQT", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
module.exports = $lKhqw.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $lKhqw.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("3PTc0", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
module.exports = $lKhqw.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($lKhqw.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($lKhqw.isString(path)) cookie.push("path=" + path);
            if ($lKhqw.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRegister("4HCLR", function(module, exports) {
"use strict";

var $lKhqw = parcelRequire("lKhqw");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "params",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "url",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "maxContentLength",
        "validateStatus",
        "maxRedirects",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath"
    ];
    $lKhqw.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
    });
    $lKhqw.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($lKhqw.isObject(config2[prop])) config[prop] = $lKhqw.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if ($lKhqw.isObject(config1[prop])) config[prop] = $lKhqw.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    $lKhqw.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $lKhqw.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    return config;
};

});


parcelRegister("2h22r", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $1a7ec00f9d1e1cf4$var$Cancel(message) {
    this.message = message;
}
$1a7ec00f9d1e1cf4$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$1a7ec00f9d1e1cf4$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $1a7ec00f9d1e1cf4$var$Cancel;

});

parcelRegister("6pDYR", function(module, exports) {
"use strict";

var $2h22r = parcelRequire("2h22r");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $4ab41735eb671710$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $2h22r(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $4ab41735eb671710$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $4ab41735eb671710$var$CancelToken.source = function source() {
    var cancel;
    var token = new $4ab41735eb671710$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $4ab41735eb671710$var$CancelToken;

});

parcelRegister("8U7FG", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});



parcelRegister("hqhdr", function(module, exports) {
"use strict";

var $fXzVl = parcelRequire("fXzVl");

var $iXMLF = parcelRequire("iXMLF");

var $9VinK = parcelRequire("9VinK");
module.exports = {
    formats: $9VinK,
    parse: $iXMLF,
    stringify: $fXzVl
};

});
parcelRegister("fXzVl", function(module, exports) {
"use strict";

var $ghlAC = parcelRequire("ghlAC");

var $9VinK = parcelRequire("9VinK");
var $b9e83b7738a3c801$var$has = Object.prototype.hasOwnProperty;
var $b9e83b7738a3c801$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $b9e83b7738a3c801$var$isArray = Array.isArray;
var $b9e83b7738a3c801$var$push = Array.prototype.push;
var $b9e83b7738a3c801$var$pushToArray = function(arr, valueOrArray) {
    $b9e83b7738a3c801$var$push.apply(arr, $b9e83b7738a3c801$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $b9e83b7738a3c801$var$toISO = Date.prototype.toISOString;
var $b9e83b7738a3c801$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $ghlAC.encode,
    encodeValuesOnly: false,
    formatter: $9VinK.formatters[$9VinK.default],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $b9e83b7738a3c801$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $b9e83b7738a3c801$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $b9e83b7738a3c801$var$isArray(obj)) obj = obj.join(",");
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $b9e83b7738a3c801$var$defaults.encoder, charset) : prefix;
        obj = "";
    }
    if (typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean" || $ghlAC.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $b9e83b7738a3c801$var$defaults.encoder, charset);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $b9e83b7738a3c801$var$defaults.encoder, charset))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if ($b9e83b7738a3c801$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (skipNulls && obj[key] === null) continue;
        if ($b9e83b7738a3c801$var$isArray(obj)) $b9e83b7738a3c801$var$pushToArray(values, stringify(obj[key], typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
        else $b9e83b7738a3c801$var$pushToArray(values, stringify(obj[key], prefix + (allowDots ? "." + key : "[" + key + "]"), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $b9e83b7738a3c801$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $b9e83b7738a3c801$var$defaults;
    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $b9e83b7738a3c801$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $9VinK.default;
    if (typeof opts.format !== "undefined") {
        if (!$b9e83b7738a3c801$var$has.call($9VinK.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $9VinK.formatters[format];
    var filter = $b9e83b7738a3c801$var$defaults.filter;
    if (typeof opts.filter === "function" || $b9e83b7738a3c801$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $b9e83b7738a3c801$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $b9e83b7738a3c801$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $b9e83b7738a3c801$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $b9e83b7738a3c801$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $b9e83b7738a3c801$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $b9e83b7738a3c801$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $b9e83b7738a3c801$var$defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $b9e83b7738a3c801$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $b9e83b7738a3c801$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $b9e83b7738a3c801$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $b9e83b7738a3c801$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($b9e83b7738a3c801$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $b9e83b7738a3c801$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $b9e83b7738a3c801$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $b9e83b7738a3c801$var$pushToArray(keys, $b9e83b7738a3c801$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("ghlAC", function(module, exports) {
"use strict";
var $bd9efb1a02ffc54b$var$has = Object.prototype.hasOwnProperty;
var $bd9efb1a02ffc54b$var$isArray = Array.isArray;
var $bd9efb1a02ffc54b$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $bd9efb1a02ffc54b$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($bd9efb1a02ffc54b$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $bd9efb1a02ffc54b$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $bd9efb1a02ffc54b$var$merge = function merge(target, source, options) {
    if (!source) return target;
    if (typeof source !== "object") {
        if ($bd9efb1a02ffc54b$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$bd9efb1a02ffc54b$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($bd9efb1a02ffc54b$var$isArray(target) && !$bd9efb1a02ffc54b$var$isArray(source)) mergeTarget = $bd9efb1a02ffc54b$var$arrayToObject(target, options);
    if ($bd9efb1a02ffc54b$var$isArray(target) && $bd9efb1a02ffc54b$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($bd9efb1a02ffc54b$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($bd9efb1a02ffc54b$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $bd9efb1a02ffc54b$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $bd9efb1a02ffc54b$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $bd9efb1a02ffc54b$var$encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = typeof str === "string" ? str : String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $bd9efb1a02ffc54b$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($bd9efb1a02ffc54b$var$hexTable[0xC0 | c >> 6] + $bd9efb1a02ffc54b$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($bd9efb1a02ffc54b$var$hexTable[0xE0 | c >> 12] + $bd9efb1a02ffc54b$var$hexTable[0x80 | c >> 6 & 0x3F] + $bd9efb1a02ffc54b$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        out += $bd9efb1a02ffc54b$var$hexTable[0xF0 | c >> 18] + $bd9efb1a02ffc54b$var$hexTable[0x80 | c >> 12 & 0x3F] + $bd9efb1a02ffc54b$var$hexTable[0x80 | c >> 6 & 0x3F] + $bd9efb1a02ffc54b$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $bd9efb1a02ffc54b$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $bd9efb1a02ffc54b$var$compactQueue(queue);
    return value;
};
var $bd9efb1a02ffc54b$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $bd9efb1a02ffc54b$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $bd9efb1a02ffc54b$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
module.exports = {
    arrayToObject: $bd9efb1a02ffc54b$var$arrayToObject,
    assign: $bd9efb1a02ffc54b$var$assign,
    combine: $bd9efb1a02ffc54b$var$combine,
    compact: $bd9efb1a02ffc54b$var$compact,
    decode: $bd9efb1a02ffc54b$var$decode,
    encode: $bd9efb1a02ffc54b$var$encode,
    isBuffer: $bd9efb1a02ffc54b$var$isBuffer,
    isRegExp: $bd9efb1a02ffc54b$var$isRegExp,
    merge: $bd9efb1a02ffc54b$var$merge
};

});

parcelRegister("9VinK", function(module, exports) {
"use strict";
var $7397b23337a6c3fb$var$replace = String.prototype.replace;
var $7397b23337a6c3fb$var$percentTwenties = /%20/g;
module.exports = {
    "default": "RFC3986",
    formatters: {
        RFC1738: function(value) {
            return $7397b23337a6c3fb$var$replace.call(value, $7397b23337a6c3fb$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return value;
        }
    },
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};

});


parcelRegister("iXMLF", function(module, exports) {
"use strict";

var $ghlAC = parcelRequire("ghlAC");
var $dce390f7be7ccd0b$var$has = Object.prototype.hasOwnProperty;
var $dce390f7be7ccd0b$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $ghlAC.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $dce390f7be7ccd0b$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $dce390f7be7ccd0b$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $dce390f7be7ccd0b$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $dce390f7be7ccd0b$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $dce390f7be7ccd0b$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $dce390f7be7ccd0b$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $dce390f7be7ccd0b$var$defaults.decoder, charset);
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $dce390f7be7ccd0b$var$defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), $dce390f7be7ccd0b$var$defaults.decoder, charset);
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $dce390f7be7ccd0b$var$interpretNumericEntities(val);
        if (val && options.comma && val.indexOf(",") > -1) val = val.split(",");
        if ($dce390f7be7ccd0b$var$has.call(obj, key)) obj[key] = $ghlAC.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $dce390f7be7ccd0b$var$parseObject = function(chain, val, options) {
    var leaf = val;
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $dce390f7be7ccd0b$var$parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $dce390f7be7ccd0b$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $dce390f7be7ccd0b$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $dce390f7be7ccd0b$var$parseObject(keys, val, options);
};
var $dce390f7be7ccd0b$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $dce390f7be7ccd0b$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $dce390f7be7ccd0b$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $dce390f7be7ccd0b$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $dce390f7be7ccd0b$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $dce390f7be7ccd0b$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $dce390f7be7ccd0b$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $dce390f7be7ccd0b$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $dce390f7be7ccd0b$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $ghlAC.isRegExp(opts.delimiter) ? opts.delimiter : $dce390f7be7ccd0b$var$defaults.delimiter,
        depth: typeof opts.depth === "number" ? opts.depth : $dce390f7be7ccd0b$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $dce390f7be7ccd0b$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $dce390f7be7ccd0b$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $dce390f7be7ccd0b$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $dce390f7be7ccd0b$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $dce390f7be7ccd0b$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $dce390f7be7ccd0b$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $dce390f7be7ccd0b$var$parseKeys(key, tempObj[key], options);
        obj = $ghlAC.merge(obj, newObj, options);
    }
    return $ghlAC.compact(obj);
};

});


parcelRegister("3U8SM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d7d7def1c4acb78$export$2e2bcd8739ae039; });

var $96kno = parcelRequire("96kno");

var $hqhdr = parcelRequire("hqhdr");

var $lUBOG = parcelRequire("lUBOG");
const $2d7d7def1c4acb78$var$axiosInstance = (0, (/*@__PURE__*/$parcel$interopDefault($96kno))).create({
    baseURL: (0, $lUBOG.default).E2E_API_URL,
    timeout: 60000,
    withCredentials: true,
    paramsSerializer: (params)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($hqhdr))).stringify(params, {
            skipNulls: true
        });
    }
});
var $2d7d7def1c4acb78$export$2e2bcd8739ae039 = $2d7d7def1c4acb78$var$axiosInstance;

});
parcelRegister("lUBOG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff3c298267595352$export$2e2bcd8739ae039; });
let $ff3c298267595352$var$E2E_API_URL = `https://api.gridmarket.xyz/`;
let $ff3c298267595352$var$PROSPECTING_API_URL = `https://prospecting-api.gridmarket.xyz/`;
let $ff3c298267595352$var$MARTIN_API_URL = `https://martin.gridmarket.xyz/`;
let $ff3c298267595352$var$TILES_API_URL = "https://tiles.gridmarket.xyz/";
let $ff3c298267595352$var$ENVIRONMENT = "production";
if (window.location.hostname === "dev.gridmarket.xyz") {
    $ff3c298267595352$var$E2E_API_URL = `https://api.gridmarket.xyz/`;
    $ff3c298267595352$var$PROSPECTING_API_URL = `https://prospecting-api.gridmarket.xyz/`;
    $ff3c298267595352$var$ENVIRONMENT = "development";
}
if (window.location.hostname === "dev.gridmarket.net") {
    $ff3c298267595352$var$E2E_API_URL = `https://staging.gridmarket.com/e2e-api/`;
    $ff3c298267595352$var$PROSPECTING_API_URL = `https://staging.gridmarket.com/prospecting-api/`;
    $ff3c298267595352$var$MARTIN_API_URL = `https://staging.gridmarket.com/martin/`;
    $ff3c298267595352$var$TILES_API_URL = "https://staging.gridmarket.com/tiles/";
    $ff3c298267595352$var$ENVIRONMENT = "staging";
}
if (window.location.hostname === "platform.gridmarket.xyz") {
    $ff3c298267595352$var$E2E_API_URL = `https://platform.gridmarket.xyz/e2e-api/`;
    $ff3c298267595352$var$PROSPECTING_API_URL = `https://platform.gridmarket.xyz/prospecting-api/`;
    $ff3c298267595352$var$MARTIN_API_URL = `https://platform.gridmarket.xyz/martin/`;
    $ff3c298267595352$var$TILES_API_URL = "https://platform.gridmarket.xyz/tiles/";
    $ff3c298267595352$var$ENVIRONMENT = "development";
}
if (window.location.hostname === "platform.gridmarket.com" || window.location.hostname === "live.gridmarket.net") {
    $ff3c298267595352$var$E2E_API_URL = `https://platform.gridmarket.com/e2e-api/`;
    $ff3c298267595352$var$PROSPECTING_API_URL = `https://platform.gridmarket.com/prospecting-api/`;
    $ff3c298267595352$var$MARTIN_API_URL = `https://platform.gridmarket.com/martin/`;
    $ff3c298267595352$var$TILES_API_URL = "https://platform.gridmarket.com/tiles/";
    $ff3c298267595352$var$ENVIRONMENT = "production";
}
if (window.location.hostname === "staging.gridmarket.com" || window.location.hostname === "localhost" || window.location.hostname === "devtasks--spontaneous-genie-4ce6f9.netlify.app") {
    $ff3c298267595352$var$E2E_API_URL = `https://staging.gridmarket.com/e2e-api/`;
    $ff3c298267595352$var$PROSPECTING_API_URL = `https://staging.gridmarket.com/prospecting-api/`;
    $ff3c298267595352$var$MARTIN_API_URL = `https://staging.gridmarket.com/martin/`;
    $ff3c298267595352$var$TILES_API_URL = "https://staging.gridmarket.com/tiles/";
    $ff3c298267595352$var$ENVIRONMENT = "staging";
}
var $ff3c298267595352$export$2e2bcd8739ae039 = {
    E2E_API_URL: $ff3c298267595352$var$E2E_API_URL,
    PROSPECTING_API_URL: $ff3c298267595352$var$PROSPECTING_API_URL,
    MARTIN_API_URL: $ff3c298267595352$var$MARTIN_API_URL,
    TILES_API_URL: $ff3c298267595352$var$TILES_API_URL,
    ENVIRONMENT: $ff3c298267595352$var$ENVIRONMENT
};

});



parcelRegister("4WgAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $398972cd9d4d2167$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $3U8SM = parcelRequire("3U8SM");

var $lxEiN = parcelRequire("lxEiN");

var $fuiMG = parcelRequire("fuiMG");
class $398972cd9d4d2167$var$Store {
    get groupedProjectsByTerm() {
        const projects = [
            ...this.resultMap.values()
        ].filter((project)=>{
            if (!this.filters.name) return true;
            return new RegExp(this.filters.name, "i").test(project.name);
        });
        const groupedProjects = (0, $fuiMG.groupBy)(projects, "status");
        return groupedProjects;
    }
    setResults(results) {
        this.resultMap = results;
    }
    constructor(){
        (0, $cr2GM._)(this, "project", null);
        (0, $cr2GM._)(this, "members", []);
        (0, $cr2GM._)(this, "projects", new Map());
        (0, $cr2GM._)(this, "totalResults", 0);
        (0, $cr2GM._)(this, "resultMap", new Map());
        (0, $cr2GM._)(this, "filters", {
            name: ""
        });
        (0, $cr2GM._)(this, "removeProject", (id)=>{
            this.projects.delete(id);
            const resultMap = new Map(this.resultMap);
            resultMap.delete(id);
            this.resultMap = resultMap;
        // console.log(JSON.stringify(resultMap.size));
        });
        (0, $cr2GM._)(this, "loadProject", async (id)=>{
            try {
                const { data: data } = await (0, $lxEiN.default).Project.getProject(id);
                const hasAccess = data.data.has_access;
                if (typeof hasAccess !== "undefined" && hasAccess === false) {
                    this.removeProject(id);
                    return null;
                }
                if (data.data) {
                    this.projects.set(data.data.id, data.data);
                    return this.projects.get(id);
                }
            } catch (err) {
                this.removeProject(id);
                return null;
            }
        });
        (0, $cr2GM._)(this, "setFilter", (name, value)=>{
            if (value === null) {
                (0, $gOgWf.remove)(this.filters, name, value);
                return;
            }
            (0, $gOgWf.set)(this.filters, name, value);
        });
        (0, $cr2GM._)(this, "get", (id)=>{
            return this.projects.get(id);
        });
        (0, $cr2GM._)(this, "fetchAll", async ()=>{
            const { data: data } = await (0, $lxEiN.default).Project.getProjects();
            const arr = data.data.map((result)=>{
                return [
                    result.id,
                    result
                ];
            });
            this.resultMap = new Map(arr);
        });
        (0, $cr2GM._)(this, "deleteProject", async (id)=>{
            const { data: data } = await (0, $lxEiN.default).Project.deleteProject(id);
            const currentResults = new Map(this.resultMap);
            currentResults.delete(id);
            this.resultMap = currentResults;
            return data.data;
        });
        (0, $cr2GM._)(this, "getProjectBuilding", async (projectId, buildingId)=>{
            const { data: data } = await (0, $lxEiN.default).Project.getProjectBuilding(projectId, buildingId);
            return data.data;
        });
        (0, $cr2GM._)(this, "deleteProjectBuilding", async (projectId, buildingId)=>{
            // const currentResults = new Map(this.resultMap);
            // const project = currentResults.get(projectId);
            // project.buildings = project.buildings.filter(b => b.id !== buildingId);
            // currentResults.set(project.id, project);
            // this.resultMap = currentResults;
            const { data: data } = await (0, $lxEiN.default).Project.removeBuilding(projectId, [
                {
                    id: buildingId
                }
            ]);
            return data;
        });
        (0, $cr2GM._)(this, "updateProjectBuildingGeometry", async (projectId, buildingId, geometry)=>{
            (0, $lxEiN.default).Project.updateProjectBuildingGeometry(projectId, buildingId, geometry);
        });
        (0, $cr2GM._)(this, "updateProjectBuilding", async (projectId, buildingData)=>{
            const { data: data } = await (0, $lxEiN.default).Project.updateProjectBuilding(projectId, buildingData.id, buildingData);
            return data.data;
        });
        (0, $cr2GM._)(this, "createProjectBuilding", async (projectId, buildingData)=>{
            const { data: data } = await (0, $lxEiN.default).Project.createBuilding(projectId, buildingData);
            return data.data;
        });
        (0, $cr2GM._)(this, "updateProject", async (id, params)=>{
            const { data: data } = await (0, $3U8SM.default).patch(`/project/${id}`, params);
            const project = this.resultMap.get(id);
            if (project) {
                const resultMap = new Map(this.resultMap);
                resultMap.set(id, (0, $edHbI._)((0, $2QP2i._)({}, project), {
                    name: data.data.name,
                    color: data.data.color
                }));
                this.resultMap = resultMap;
            }
        });
        (0, $cr2GM._)(this, "setMembers", async (members)=>{
            this.members = members;
        });
        (0, $cr2GM._)(this, "getProjectBuildingFeature", async (projectId, buildingId)=>{
            const { data: data } = await (0, $3U8SM.default).get(`/project/${projectId}/building/${buildingId}/feature`);
            // this.projectBuildingRegistry.set(data.data.id, formattedData);
            return data;
        });
        (0, $cr2GM._)(this, "createProject", async (params)=>{
            const { data: data } = await (0, $lxEiN.default).Project.createProject(params);
            if (data.ok) return data.data;
        });
        (0, $gOgWf.makeObservable)(this, {
            project: (0, $gOgWf.observable),
            members: (0, $gOgWf.observable),
            projects: (0, $gOgWf.observable),
            totalResults: (0, $gOgWf.observable),
            resultMap: (0, $gOgWf.observable),
            filters: (0, $gOgWf.observable),
            loadProject: (0, $gOgWf.action),
            groupedProjectsByTerm: (0, $gOgWf.computed),
            setFilter: (0, $gOgWf.action),
            get: (0, $gOgWf.action),
            setResults: (0, $gOgWf.action),
            fetchAll: (0, $gOgWf.action),
            deleteProject: (0, $gOgWf.action),
            getProjectBuilding: (0, $gOgWf.action),
            deleteProjectBuilding: (0, $gOgWf.action),
            updateProjectBuildingGeometry: (0, $gOgWf.action),
            updateProjectBuilding: (0, $gOgWf.action),
            createProjectBuilding: (0, $gOgWf.action),
            updateProject: (0, $gOgWf.action),
            setMembers: (0, $gOgWf.action),
            getProjectBuildingFeature: (0, $gOgWf.action),
            createProject: (0, $gOgWf.action)
        });
    }
}
const $398972cd9d4d2167$var$store = new $398972cd9d4d2167$var$Store();
var $398972cd9d4d2167$export$2e2bcd8739ae039 = $398972cd9d4d2167$var$store;

});
parcelRegister("fuiMG", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $b4683a7d19cfa4ef$export$f5dd818bff069720; });
$parcel$export(module.exports, "abbreviateNumber", function () { return $b4683a7d19cfa4ef$export$36d5e0d2b514f546; });
$parcel$export(module.exports, "getDistanceFromLatLonInKm", function () { return $b4683a7d19cfa4ef$export$55ad5c77306bdcab; });
$parcel$export(module.exports, "metersToMiles", function () { return $b4683a7d19cfa4ef$export$2ffb1a8ba3bb2151; });
$parcel$export(module.exports, "downloadFile", function () { return $b4683a7d19cfa4ef$export$bb3b75778e3e272; });
$parcel$export(module.exports, "abbreviate", function () { return $b4683a7d19cfa4ef$export$f8e59455b4837291; });
$parcel$export(module.exports, "groupBy", function () { return $b4683a7d19cfa4ef$export$3f063810d7bf01bd; });
$parcel$export(module.exports, "hexToRgb", function () { return $b4683a7d19cfa4ef$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "elevateGeometry", function () { return $b4683a7d19cfa4ef$export$639c3d0f541a8c10; });
$parcel$export(module.exports, "getElevationFromGeometry", function () { return $b4683a7d19cfa4ef$export$bf65b5d7dcc5a942; });
$parcel$export(module.exports, "humanDateTime", function () { return $b4683a7d19cfa4ef$export$9617bc2569567fac; });
$parcel$export(module.exports, "humanDate", function () { return $b4683a7d19cfa4ef$export$a41d61df4ac70627; });
$parcel$export(module.exports, "humanFileSize", function () { return $b4683a7d19cfa4ef$export$291541584f4e762f; });
$parcel$export(module.exports, "isElementInViewport", function () { return $b4683a7d19cfa4ef$export$7cc0e9dd2435cb30; });
$parcel$export(module.exports, "timeSince", function () { return $b4683a7d19cfa4ef$export$79c01495e306fbf5; });
/* eslint-disable no-param-reassign */ 
var $kPMXY = parcelRequire("kPMXY");

var $eFsDQ = parcelRequire("eFsDQ");

var $lUBOG = parcelRequire("lUBOG");
function $b4683a7d19cfa4ef$export$f5dd818bff069720(value, digits) {
    const options = {
        minimumFractionDigits: value > 1000 || Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: value > 1000 || Number.isInteger(value) ? 0 : 2
    };
    if (digits) {
        options.maximumFractionDigits = digits;
        options.minimumFractionDigits = digits;
    }
    return new Intl.NumberFormat("en-US", options).format(value);
}
function $b4683a7d19cfa4ef$export$36d5e0d2b514f546(value, unit) {
    const sign = Math.sign(value);
    let newValue = Math.abs(value);
    let suffixes = [
        "",
        "K",
        "M",
        "B",
        "T"
    ];
    if (unit === "kW") suffixes = [
        "kW",
        "MW",
        "GW",
        "TW",
        "PW"
    ];
    let suffixNum = 0;
    while(newValue >= 1000){
        newValue /= 1000;
        suffixNum += 1;
    }
    const newValueWithSign = sign * newValue;
    const newValueWithSignPercision = $b4683a7d19cfa4ef$export$f5dd818bff069720(newValueWithSign);
    const suffix = suffixes[suffixNum];
    const result = `${newValueWithSignPercision}${suffix}`;
    return result;
}
function $b4683a7d19cfa4ef$export$55ad5c77306bdcab(coordinates1, coordinates2) {
    const start = {
        latitude: coordinates1[1],
        longitude: coordinates1[0]
    };
    const end = {
        latitude: coordinates2[1],
        longitude: coordinates2[0]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kPMXY)))(start, end);
}
function $b4683a7d19cfa4ef$export$fa562257f40442f8(osmId) {
    return osmId < 0 ? `R${osmId}` : `W${Math.abs(osmId)}`;
}
function $b4683a7d19cfa4ef$export$1372c1a6b93abfb8(appId) {
    if (!appId) return null;
    return parseInt(appId.replace("W", "").replace("R", "-"), 10);
}
function $b4683a7d19cfa4ef$export$2ffb1a8ba3bb2151(meters, fractionDigits = 2) {
    return (meters * 0.000621371192).toFixed(fractionDigits);
}
async function $b4683a7d19cfa4ef$export$bb3b75778e3e272(url, name, delay = 0) {
    const sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
    await sleep(delay);
    const a = document.createElement("a");
    a.download = name;
    a.href = url.startsWith("http") ? url : `${(0, $lUBOG.default).E2E_API_URL}${url}`;
    a.target = "_blank";
    a.style.display = "none";
    document.body.append(a);
    a.click();
    // Chrome requires the timeout
    await sleep(100);
    a.remove();
}
function $b4683a7d19cfa4ef$export$f8e59455b4837291(val) {
    const match = val.match(/[0-9A-Z]/g);
    if (!match) return val.substring(0, 2);
    const short = match.join("").substring(0, 2);
    if (short.length > 1) return short;
    return val.substring(0, 2);
}
function $b4683a7d19cfa4ef$export$3f063810d7bf01bd(xs, key) {
    return xs.reduce((rv, x)=>{
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}
function $b4683a7d19cfa4ef$export$5a544e13ad4e1fa5(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ] : null;
}
function $b4683a7d19cfa4ef$export$639c3d0f541a8c10(geometry, elevation) {
    const { type: type } = geometry;
    let coordinates = [
        ...geometry.coordinates
    ];
    if (type === "Point") coordinates[2] = elevation;
    if (type === "Polygon") coordinates = coordinates.map((coordinateGroup)=>{
        return coordinateGroup.map((coord)=>{
            return [
                coord[0],
                coord[1],
                elevation
            ];
        });
    });
    if (type === "LineString") coordinates = coordinates.map((coord)=>{
        return [
            coord[0],
            coord[1],
            elevation
        ];
    });
    return {
        type: type,
        coordinates: coordinates
    };
}
function $b4683a7d19cfa4ef$export$bf65b5d7dcc5a942(geometry) {
    var _geometry_coordinates__, _geometry_coordinates_, _geometry_coordinates_1;
    if ((geometry === null || geometry === void 0 ? void 0 : geometry.type) === "Point" && geometry.coordinates[2]) return geometry.coordinates[2];
    if ((geometry === null || geometry === void 0 ? void 0 : geometry.type) === "Polygon" && ((_geometry_coordinates_ = geometry.coordinates[0]) === null || _geometry_coordinates_ === void 0 ? void 0 : (_geometry_coordinates__ = _geometry_coordinates_[0]) === null || _geometry_coordinates__ === void 0 ? void 0 : _geometry_coordinates__[2])) return geometry.coordinates[0][0][2];
    if ((geometry === null || geometry === void 0 ? void 0 : geometry.type) === "LineString" && ((_geometry_coordinates_1 = geometry.coordinates[0]) === null || _geometry_coordinates_1 === void 0 ? void 0 : _geometry_coordinates_1[2])) return geometry.coordinates[0][2];
    return 0;
}
function $b4683a7d19cfa4ef$export$9617bc2569567fac(timeLike) {
    const DATE_FORMAT = "MMM d, yyyy HH:mm";
    if (timeLike instanceof Date) return (0, $eFsDQ.default)(timeLike, DATE_FORMAT);
    const unixTime = typeof timeLike === "string" ? parseInt(timeLike, 10) : timeLike;
    const date = new Date(unixTime * 1000);
    return (0, $eFsDQ.default)(date, DATE_FORMAT);
}
function $b4683a7d19cfa4ef$export$a41d61df4ac70627(timeLike) {
    const DATE_FORMAT = "MMM d, yyyy";
    if (timeLike instanceof Date) return (0, $eFsDQ.default)(timeLike, DATE_FORMAT);
    const unixTime = typeof timeLike === "string" ? parseInt(timeLike, 10) : timeLike;
    const date = new Date(unixTime * 1000);
    return (0, $eFsDQ.default)(date, DATE_FORMAT);
}
function $b4683a7d19cfa4ef$export$291541584f4e762f(byteSize, si = true) {
    let bytes = byteSize;
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) return `${bytes} B`;
    const units = si ? [
        "kB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ] : [
        "KiB",
        "MiB",
        "GiB",
        "TiB",
        "PiB",
        "EiB",
        "ZiB",
        "YiB"
    ];
    let u = -1;
    do {
        bytes /= thresh;
        u += 1;
    }while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return `${bytes.toFixed(1)} ${units[u]}`;
}
function $b4683a7d19cfa4ef$export$7cc0e9dd2435cb30(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function $b4683a7d19cfa4ef$export$79c01495e306fbf5(date) {
    const seconds = Math.floor((new Date() - date) / 1000);
    let interval = seconds / 31536000;
    if (interval > 1) return `${Math.floor(interval)} years`;
    interval = seconds / 2592000;
    if (interval > 1) return `${Math.floor(interval)} months`;
    interval = seconds / 86400;
    if (interval > 1) return `${Math.floor(interval)} days`;
    interval = seconds / 3600;
    if (interval > 1) return `${Math.floor(interval)} hours`;
    interval = seconds / 60;
    if (interval > 1) return `${Math.floor(interval)} minutes`;
    return `${Math.floor(seconds)} seconds`;
}
function $b4683a7d19cfa4ef$export$da805ba9431c7107(arr, predicate) {
    const cb = typeof predicate === "function" ? predicate : (o)=>o[predicate];
    return [
        ...arr.reduce((map, item)=>{
            const key = item === null || item === undefined ? item : cb(item);
            // eslint-disable-next-line no-unused-expressions
            map.has(key) || map.set(key, item);
            return map;
        }, new Map()).values()
    ];
}

});
parcelRegister("kPMXY", function(module, exports) {
var $f2ae8dc4aac89f36$var$haversine = function() {
    var RADII = {
        km: 6371,
        mile: 3960,
        meter: 6371000,
        nmi: 3440
    };
    // convert to radians
    var toRad = function(num) {
        return num * Math.PI / 180;
    };
    // convert coordinates to standard format based on the passed format option
    var convertCoordinates = function(format, coordinates) {
        switch(format){
            case "[lat,lon]":
                return {
                    latitude: coordinates[0],
                    longitude: coordinates[1]
                };
            case "[lon,lat]":
                return {
                    latitude: coordinates[1],
                    longitude: coordinates[0]
                };
            case "{lon,lat}":
                return {
                    latitude: coordinates.lat,
                    longitude: coordinates.lon
                };
            case "{lat,lng}":
                return {
                    latitude: coordinates.lat,
                    longitude: coordinates.lng
                };
            case "geojson":
                return {
                    latitude: coordinates.geometry.coordinates[1],
                    longitude: coordinates.geometry.coordinates[0]
                };
            default:
                return coordinates;
        }
    };
    return function haversine(startCoordinates, endCoordinates, options) {
        options = options || {};
        var R = options.unit in RADII ? RADII[options.unit] : RADII.km;
        var start = convertCoordinates(options.format, startCoordinates);
        var end = convertCoordinates(options.format, endCoordinates);
        var dLat = toRad(end.latitude - start.latitude);
        var dLon = toRad(end.longitude - start.longitude);
        var lat1 = toRad(start.latitude);
        var lat2 = toRad(end.latitude);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        if (options.threshold) return options.threshold > R * c;
        return R * c;
    };
}();
if (0, module.exports) module.exports = $f2ae8dc4aac89f36$var$haversine;

});

parcelRegister("eFsDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aadb1ca5365d6e34$export$2e2bcd8739ae039; });

var $hK69R = parcelRequire("hK69R");

var $iy2cb = parcelRequire("iy2cb");

var $60RHq = parcelRequire("60RHq");

var $8H1yM = parcelRequire("8H1yM");

var $4QPmc = parcelRequire("4QPmc");

var $cMC1N = parcelRequire("cMC1N");

var $4lcyT = parcelRequire("4lcyT");

var $38P9V = parcelRequire("38P9V");

var $85Mfn = parcelRequire("85Mfn");

var $fpVqC = parcelRequire("fpVqC");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $aadb1ca5365d6e34$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $aadb1ca5365d6e34$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $aadb1ca5365d6e34$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $aadb1ca5365d6e34$var$doubleQuoteRegExp = /''/g;
var $aadb1ca5365d6e34$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $aadb1ca5365d6e34$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $fpVqC.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $iy2cb.default);
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $85Mfn.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $85Mfn.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $85Mfn.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $85Mfn.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $8H1yM.default)(dirtyDate);
    if (!(0, $hK69R.default)(originalDate)) throw new RangeError("Invalid time value");
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $4lcyT.default)(originalDate);
    var utcDate = (0, $60RHq.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($aadb1ca5365d6e34$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $cMC1N.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join("").match($aadb1ca5365d6e34$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $aadb1ca5365d6e34$var$cleanEscapedString(substring);
        var formatter = (0, $4QPmc.default)[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $38P9V.isProtectedWeekYearToken)(substring)) (0, $38P9V.throwProtectedError)(substring);
            if (!options.useAdditionalDayOfYearTokens && (0, $38P9V.isProtectedDayOfYearToken)(substring)) (0, $38P9V.throwProtectedError)(substring);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($aadb1ca5365d6e34$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $aadb1ca5365d6e34$var$cleanEscapedString(input) {
    return input.match($aadb1ca5365d6e34$var$escapedStringRegExp)[1].replace($aadb1ca5365d6e34$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("hK69R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceab8269d054413c$export$2e2bcd8739ae039; });

var $8H1yM = parcelRequire("8H1yM");

var $fpVqC = parcelRequire("fpVqC");
function $ceab8269d054413c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fpVqC.default)(1, arguments);
    var date = (0, $8H1yM.default)(dirtyDate);
    return !isNaN(date);
}

});
parcelRegister("8H1yM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65438ca42f497c65$export$2e2bcd8739ae039; });

var $fpVqC = parcelRequire("fpVqC");
function $65438ca42f497c65$export$2e2bcd8739ae039(argument) {
    (0, $fpVqC.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("fpVqC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b395bcdcf91488d5$export$2e2bcd8739ae039; });
function $b395bcdcf91488d5$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + required > 1 ? "s" : " required, but only " + args.length + " present");
}

});



parcelRegister("iy2cb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d80d1af3cca7cccb$export$2e2bcd8739ae039; });

var $b68QP = parcelRequire("b68QP");

var $3EPAv = parcelRequire("3EPAv");

var $dj1wh = parcelRequire("dj1wh");

var $5VQ3H = parcelRequire("5VQ3H");

var $ifRm8 = parcelRequire("ifRm8");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $d80d1af3cca7cccb$var$locale = {
    code: "en-US",
    formatDistance: (0, $b68QP.default),
    formatLong: (0, $3EPAv.default),
    formatRelative: (0, $dj1wh.default),
    localize: (0, $5VQ3H.default),
    match: (0, $ifRm8.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $d80d1af3cca7cccb$export$2e2bcd8739ae039 = $d80d1af3cca7cccb$var$locale;

});
parcelRegister("b68QP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81471ee80300b385$export$2e2bcd8739ae039; });
var $81471ee80300b385$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
function $81471ee80300b385$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $81471ee80300b385$var$formatDistanceLocale[token] === "string") result = $81471ee80300b385$var$formatDistanceLocale[token];
    else if (count === 1) result = $81471ee80300b385$var$formatDistanceLocale[token].one;
    else result = $81471ee80300b385$var$formatDistanceLocale[token].other.replace("{{count}}", count);
    if (options.addSuffix) {
        if (options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
}

});

parcelRegister("3EPAv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a9d1fce25ce5064$export$2e2bcd8739ae039; });

var $cbGOV = parcelRequire("cbGOV");
var $2a9d1fce25ce5064$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $2a9d1fce25ce5064$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $2a9d1fce25ce5064$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $2a9d1fce25ce5064$var$formatLong = {
    date: (0, $cbGOV.default)({
        formats: $2a9d1fce25ce5064$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $cbGOV.default)({
        formats: $2a9d1fce25ce5064$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $cbGOV.default)({
        formats: $2a9d1fce25ce5064$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2a9d1fce25ce5064$export$2e2bcd8739ae039 = $2a9d1fce25ce5064$var$formatLong;

});
parcelRegister("cbGOV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8df7ba57d069fb17$export$2e2bcd8739ae039; });
function $8df7ba57d069fb17$export$2e2bcd8739ae039(args) {
    return function(dirtyOptions) {
        var options = dirtyOptions || {};
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("dj1wh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9afe3a80e463160a$export$2e2bcd8739ae039; });
var $9afe3a80e463160a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
function $9afe3a80e463160a$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $9afe3a80e463160a$var$formatRelativeLocale[token];
}

});

parcelRegister("5VQ3H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $451aa86226740dc6$export$2e2bcd8739ae039; });

var $dh4Ji = parcelRequire("dh4Ji");
var $451aa86226740dc6$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $451aa86226740dc6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ] // Note: in English, the names of days of the week and months are capitalized.
};
var $451aa86226740dc6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $451aa86226740dc6$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $451aa86226740dc6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $451aa86226740dc6$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
function $451aa86226740dc6$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
}
var $451aa86226740dc6$var$localize = {
    ordinalNumber: $451aa86226740dc6$var$ordinalNumber,
    era: (0, $dh4Ji.default)({
        values: $451aa86226740dc6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $dh4Ji.default)({
        values: $451aa86226740dc6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $dh4Ji.default)({
        values: $451aa86226740dc6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $dh4Ji.default)({
        values: $451aa86226740dc6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $dh4Ji.default)({
        values: $451aa86226740dc6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $451aa86226740dc6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $451aa86226740dc6$export$2e2bcd8739ae039 = $451aa86226740dc6$var$localize;

});
parcelRegister("dh4Ji", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aa08813a99d756e$export$2e2bcd8739ae039; });
function $9aa08813a99d756e$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        return valuesArray[index];
    };
}

});


parcelRegister("ifRm8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a3041c0f410746$export$2e2bcd8739ae039; });

var $fRFGa = parcelRequire("fRFGa");

var $dCt7U = parcelRequire("dCt7U");
var $d4a3041c0f410746$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $d4a3041c0f410746$var$parseOrdinalNumberPattern = /\d+/i;
var $d4a3041c0f410746$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $d4a3041c0f410746$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $d4a3041c0f410746$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $d4a3041c0f410746$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d4a3041c0f410746$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $d4a3041c0f410746$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $d4a3041c0f410746$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $d4a3041c0f410746$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $d4a3041c0f410746$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $d4a3041c0f410746$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $d4a3041c0f410746$var$match = {
    ordinalNumber: (0, $fRFGa.default)({
        matchPattern: $d4a3041c0f410746$var$matchOrdinalNumberPattern,
        parsePattern: $d4a3041c0f410746$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $dCt7U.default)({
        matchPatterns: $d4a3041c0f410746$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4a3041c0f410746$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $dCt7U.default)({
        matchPatterns: $d4a3041c0f410746$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4a3041c0f410746$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $dCt7U.default)({
        matchPatterns: $d4a3041c0f410746$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4a3041c0f410746$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $dCt7U.default)({
        matchPatterns: $d4a3041c0f410746$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4a3041c0f410746$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $dCt7U.default)({
        matchPatterns: $d4a3041c0f410746$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d4a3041c0f410746$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $d4a3041c0f410746$export$2e2bcd8739ae039 = $d4a3041c0f410746$var$match;

});
parcelRegister("fRFGa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8cc22dc4a71d8c0$export$2e2bcd8739ae039; });
function $b8cc22dc4a71d8c0$export$2e2bcd8739ae039(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}

});

parcelRegister("dCt7U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ea56ae3cf8c3269$export$2e2bcd8739ae039; });
function $9ea56ae3cf8c3269$export$2e2bcd8739ae039(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var value;
        if (Object.prototype.toString.call(parsePatterns) === "[object Array]") value = $9ea56ae3cf8c3269$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(string);
        });
        else value = $9ea56ae3cf8c3269$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(string);
        });
        value = args.valueCallback ? args.valueCallback(value) : value;
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}
function $9ea56ae3cf8c3269$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
}
function $9ea56ae3cf8c3269$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
}

});



parcelRegister("60RHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $460c65c0b3cca457$export$2e2bcd8739ae039; });

var $85Mfn = parcelRequire("85Mfn");

var $7tLxu = parcelRequire("7tLxu");

var $fpVqC = parcelRequire("fpVqC");
function $460c65c0b3cca457$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fpVqC.default)(2, arguments);
    var amount = (0, $85Mfn.default)(dirtyAmount);
    return (0, $7tLxu.default)(dirtyDate, -amount);
}

});
parcelRegister("85Mfn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e443738df7dac1b$export$2e2bcd8739ae039; });
function $5e443738df7dac1b$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("7tLxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57201e19e932b8ef$export$2e2bcd8739ae039; });

var $85Mfn = parcelRequire("85Mfn");

var $8H1yM = parcelRequire("8H1yM");

var $fpVqC = parcelRequire("fpVqC");
function $57201e19e932b8ef$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fpVqC.default)(2, arguments);
    var timestamp = (0, $8H1yM.default)(dirtyDate).getTime();
    var amount = (0, $85Mfn.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("4QPmc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3883db334826ed59$export$2e2bcd8739ae039; });

var $iIxd6 = parcelRequire("iIxd6");

var $kjYwe = parcelRequire("kjYwe");

var $9vn2K = parcelRequire("9vn2K");

var $iO0fJ = parcelRequire("iO0fJ");

var $bmRWV = parcelRequire("bmRWV");

var $1ucPI = parcelRequire("1ucPI");

var $acn2e = parcelRequire("acn2e");
var $3883db334826ed59$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var $3883db334826ed59$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $iIxd6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $1ucPI.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $acn2e.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
         // Padding
        return (0, $acn2e.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $iO0fJ.default)(date); // Padding
        return (0, $acn2e.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $acn2e.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $acn2e.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $acn2e.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $iIxd6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $acn2e.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $bmRWV.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $acn2e.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $9vn2K.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $acn2e.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $iIxd6.default).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $kjYwe.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $acn2e.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $acn2e.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $acn2e.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $acn2e.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $3883db334826ed59$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $3883db334826ed59$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $3883db334826ed59$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $3883db334826ed59$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $3883db334826ed59$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $3883db334826ed59$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $iIxd6.default).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $iIxd6.default).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $acn2e.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $acn2e.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $iIxd6.default).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $iIxd6.default).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $iIxd6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $3883db334826ed59$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $3883db334826ed59$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $3883db334826ed59$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $3883db334826ed59$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $3883db334826ed59$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $3883db334826ed59$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $3883db334826ed59$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $3883db334826ed59$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $3883db334826ed59$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $3883db334826ed59$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $acn2e.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $acn2e.default)(timestamp, token.length);
    }
};
function $3883db334826ed59$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $acn2e.default)(minutes, 2);
}
function $3883db334826ed59$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $acn2e.default)(Math.abs(offset) / 60, 2);
    }
    return $3883db334826ed59$var$formatTimezone(offset, dirtyDelimiter);
}
function $3883db334826ed59$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $acn2e.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $acn2e.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $3883db334826ed59$export$2e2bcd8739ae039 = $3883db334826ed59$var$formatters;

});
parcelRegister("iIxd6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da0618eaadbf7381$export$2e2bcd8739ae039; });

var $acn2e = parcelRequire("acn2e");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $da0618eaadbf7381$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $acn2e.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $acn2e.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $acn2e.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $acn2e.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $acn2e.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $acn2e.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $acn2e.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $acn2e.default)(fractionalSeconds, token.length);
    }
};
var $da0618eaadbf7381$export$2e2bcd8739ae039 = $da0618eaadbf7381$var$formatters;

});
parcelRegister("acn2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76cce4a8f6828d26$export$2e2bcd8739ae039; });
function $76cce4a8f6828d26$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});


parcelRegister("kjYwe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecb486ccafe8a1b6$export$2e2bcd8739ae039; });

var $8H1yM = parcelRequire("8H1yM");

var $fpVqC = parcelRequire("fpVqC");
var $ecb486ccafe8a1b6$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
function $ecb486ccafe8a1b6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fpVqC.default)(1, arguments);
    var date = (0, $8H1yM.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $ecb486ccafe8a1b6$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("9vn2K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eb8e239be0a82dd$export$2e2bcd8739ae039; });

var $8H1yM = parcelRequire("8H1yM");

var $1nrz6 = parcelRequire("1nrz6");

var $jinp4 = parcelRequire("jinp4");

var $fpVqC = parcelRequire("fpVqC");
var $6eb8e239be0a82dd$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $6eb8e239be0a82dd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fpVqC.default)(1, arguments);
    var date = (0, $8H1yM.default)(dirtyDate);
    var diff = (0, $1nrz6.default)(date).getTime() - (0, $jinp4.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $6eb8e239be0a82dd$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("1nrz6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $100d5249fecb8a70$export$2e2bcd8739ae039; });

var $8H1yM = parcelRequire("8H1yM");

var $fpVqC = parcelRequire("fpVqC");
function $100d5249fecb8a70$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fpVqC.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $8H1yM.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("jinp4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0c1da2e9e14480d$export$2e2bcd8739ae039; });

var $iO0fJ = parcelRequire("iO0fJ");

var $1nrz6 = parcelRequire("1nrz6");

var $fpVqC = parcelRequire("fpVqC");
function $e0c1da2e9e14480d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fpVqC.default)(1, arguments);
    var year = (0, $iO0fJ.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $1nrz6.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("iO0fJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db0d17b3a45c37d7$export$2e2bcd8739ae039; });

var $8H1yM = parcelRequire("8H1yM");

var $1nrz6 = parcelRequire("1nrz6");

var $fpVqC = parcelRequire("fpVqC");
function $db0d17b3a45c37d7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fpVqC.default)(1, arguments);
    var date = (0, $8H1yM.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1nrz6.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1nrz6.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bmRWV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $846b99051cbfaa4a$export$2e2bcd8739ae039; });

var $8H1yM = parcelRequire("8H1yM");

var $gF90W = parcelRequire("gF90W");

var $j25kY = parcelRequire("j25kY");

var $fpVqC = parcelRequire("fpVqC");
var $846b99051cbfaa4a$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $846b99051cbfaa4a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $fpVqC.default)(1, arguments);
    var date = (0, $8H1yM.default)(dirtyDate);
    var diff = (0, $gF90W.default)(date, options).getTime() - (0, $j25kY.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $846b99051cbfaa4a$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("gF90W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c21777b0586e1634$export$2e2bcd8739ae039; });

var $85Mfn = parcelRequire("85Mfn");

var $8H1yM = parcelRequire("8H1yM");

var $fpVqC = parcelRequire("fpVqC");
function $c21777b0586e1634$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $fpVqC.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $85Mfn.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $85Mfn.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $8H1yM.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("j25kY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb25818f46a73f2$export$2e2bcd8739ae039; });

var $85Mfn = parcelRequire("85Mfn");

var $1ucPI = parcelRequire("1ucPI");

var $gF90W = parcelRequire("gF90W");

var $fpVqC = parcelRequire("fpVqC");
function $ddb25818f46a73f2$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $fpVqC.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $85Mfn.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $85Mfn.default)(options.firstWeekContainsDate);
    var year = (0, $1ucPI.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $gF90W.default)(firstWeek, dirtyOptions);
    return date;
}

});
parcelRegister("1ucPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11528c2a008ace63$export$2e2bcd8739ae039; });

var $85Mfn = parcelRequire("85Mfn");

var $8H1yM = parcelRequire("8H1yM");

var $gF90W = parcelRequire("gF90W");

var $fpVqC = parcelRequire("fpVqC");
function $11528c2a008ace63$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $fpVqC.default)(1, arguments);
    var date = (0, $8H1yM.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $85Mfn.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $85Mfn.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $gF90W.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $gF90W.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});




parcelRegister("cMC1N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94e77750bd660f52$export$2e2bcd8739ae039; });
function $94e77750bd660f52$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
}
function $94e77750bd660f52$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
}
function $94e77750bd660f52$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $94e77750bd660f52$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $94e77750bd660f52$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $94e77750bd660f52$var$timeLongFormatter(timePattern, formatLong));
}
var $94e77750bd660f52$var$longFormatters = {
    p: $94e77750bd660f52$var$timeLongFormatter,
    P: $94e77750bd660f52$var$dateTimeLongFormatter
};
var $94e77750bd660f52$export$2e2bcd8739ae039 = $94e77750bd660f52$var$longFormatters;

});

parcelRegister("4lcyT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3292de173c23ea3f$export$2e2bcd8739ae039; });
var $3292de173c23ea3f$var$MILLISECONDS_IN_MINUTE = 60000;
function $3292de173c23ea3f$export$2e2bcd8739ae039(dirtyDate) {
    var date = new Date(dirtyDate.getTime());
    var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
    date.setSeconds(0, 0);
    var millisecondsPartOfTimezoneOffset = date.getTime() % $3292de173c23ea3f$var$MILLISECONDS_IN_MINUTE;
    return baseTimezoneOffset * $3292de173c23ea3f$var$MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

});

parcelRegister("38P9V", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $2499cd99bccd64b5$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $2499cd99bccd64b5$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $2499cd99bccd64b5$export$8073c1ae88f0e727; });
var $2499cd99bccd64b5$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $2499cd99bccd64b5$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $2499cd99bccd64b5$export$c6cc36aa33304772(token) {
    return $2499cd99bccd64b5$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $2499cd99bccd64b5$export$c6b49d6dceb604a1(token) {
    return $2499cd99bccd64b5$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $2499cd99bccd64b5$export$8073c1ae88f0e727(token) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr");
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr");
    else if (token === "D") throw new RangeError("Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr");
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr");
}

});




parcelRegister("gcPmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcc59c0d830023bd$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $gOgWf = parcelRequire("gOgWf");
class $bcc59c0d830023bd$var$MapStore {
    setDeckRef(ref) {
        this.deckRef = ref;
    }
    setMode(mode) {
        this.mode = mode;
    }
    setMapboxRef(ref) {
        this.mapboxRef = ref;
    }
    setGl(gl) {
        this.gl = gl;
    }
    setBounds(bounds) {
        this.bounds = bounds;
    }
    setViewPort(viewport) {
        this.viewport = viewport;
    }
    setStatus(status) {
        this.status = status;
    }
    setEditMode(editMode) {
        this.editMode = editMode;
    }
    setShouldRedrawPoints(value) {
        this.shouldRedrawPoints = value;
    }
    setPopup(value) {
        this.popup = value;
    }
    constructor(){
        (0, $cr2GM._)(this, "viewport", {
            center: {
                lng: -73.9954260224539,
                lat: 40.723244087001774
            },
            zoom: 12,
            pitch: 0
        });
        (0, $cr2GM._)(this, "bounds", null);
        (0, $cr2GM._)(this, "status", "loading");
        (0, $cr2GM._)(this, "mode", "view");
        (0, $cr2GM._)(this, "popup", null);
        (0, $cr2GM._)(this, "gl", null);
        (0, $cr2GM._)(this, "deckRef", null);
        (0, $cr2GM._)(this, "mapboxRef", null);
        (0, $cr2GM._)(this, "shouldRedrawPoints", false);
        (0, $gOgWf.makeObservable)(this, {
            viewport: (0, $gOgWf.observable),
            gl: (0, $gOgWf.observable),
            shouldRedrawPoints: (0, $gOgWf.observable),
            bounds: (0, $gOgWf.observable),
            status: (0, $gOgWf.observable),
            mode: (0, $gOgWf.observable),
            popup: (0, $gOgWf.observable),
            setMode: (0, $gOgWf.action),
            setBounds: (0, $gOgWf.action),
            setViewPort: (0, $gOgWf.action),
            setStatus: (0, $gOgWf.action),
            setEditMode: (0, $gOgWf.action),
            setPopup: (0, $gOgWf.action)
        });
    }
}
const $bcc59c0d830023bd$var$store = new $bcc59c0d830023bd$var$MapStore();
var $bcc59c0d830023bd$export$2e2bcd8739ae039 = $bcc59c0d830023bd$var$store;

});

parcelRegister("ht0W2", function(module, exports) {

$parcel$export(module.exports, "formatBuildingDetails", function () { return $cb75dec613a20d5a$export$b8ed849243134f3; });
$parcel$export(module.exports, "formatBuildingData", function () { return $cb75dec613a20d5a$export$126d463feb878e45; });
$parcel$export(module.exports, "formatBuildingPower", function () { return $cb75dec613a20d5a$export$b1edea61042966f2; });
$parcel$export(module.exports, "formatBuildingFinancials", function () { return $cb75dec613a20d5a$export$cd5b146eaf8b654e; });
$parcel$export(module.exports, "formatBuildingRates", function () { return $cb75dec613a20d5a$export$aaca97b705d749dc; });
/* eslint-disable camelcase */ 
var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $fuiMG = parcelRequire("fuiMG");
const $cb75dec613a20d5a$var$none = "n/a";
const $cb75dec613a20d5a$var$sf = " ft\xb2";
const $cb75dec613a20d5a$var$areaUnit = "ft\xb2";
const $cb75dec613a20d5a$var$units = "imperial";
const $cb75dec613a20d5a$var$toTitleCase = (str)=>{
    return str.replace(/\w\S*/g, (txt)=>{
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
const $cb75dec613a20d5a$var$formatArea = (n)=>{
    let area = n;
    if ($cb75dec613a20d5a$var$units === "international") area /= 10.7639104;
    area = area.toLocaleString("en-US");
    return `${area} ${$cb75dec613a20d5a$var$areaUnit}`;
};
const $cb75dec613a20d5a$var$formatAddress = (arr)=>{
    if (arr) return arr[0];
    return $cb75dec613a20d5a$var$none;
};
const $cb75dec613a20d5a$export$b8ed849243134f3 = ({ annual_peak: annual_peak = $cb75dec613a20d5a$var$none, annual_property_tax: annual_property_tax, aquisition_date: aquisition_date, aquisition_price: aquisition_price, area_in_sq_meters: area_in_sq_meters, average_annual_irradiance: average_annual_irradiance, billable_assessed_value: billable_assessed_value, bins: bins, boiler_capacity: boiler_capacity = $cb75dec613a20d5a$var$none, boiler_consumption: boiler_consumption, boiler_installation_date: boiler_installation_date = $cb75dec613a20d5a$var$none, boiler_is_dual_fuel: boiler_is_dual_fuel, boiler_model: boiler_model, building_far: building_far = $cb75dec613a20d5a$var$none, building_name: building_name, burner_model: burner_model = $cb75dec613a20d5a$var$none, cdd65: cdd65, co2_reduction: co2_reduction, compliance_date: compliance_date = $cb75dec613a20d5a$var$none, construction: construction, customer_cd: customer_cd = $cb75dec613a20d5a$var$none, debt: debt, demo: demo, der_installation_date: der_installation_date = $cb75dec613a20d5a$var$none, der_installer: der_installer = $cb75dec613a20d5a$var$none, der_natural_gas_consumption: der_natural_gas_consumption = $cb75dec613a20d5a$var$none, der_output: der_output = $cb75dec613a20d5a$var$none, der_ownership_structure: der_ownership_structure = $cb75dec613a20d5a$var$none, der_type: der_type = $cb75dec613a20d5a$var$none, ele: ele, electric_utility: electric_utility = null, electricity_forecast: electricity_forecast = null, electricity_use: electricity_use, energy_star_score: energy_star_score = $cb75dec613a20d5a$var$none, esimated_boiler_retirement_year: esimated_boiler_retirement_year = $cb75dec613a20d5a$var$none, estimated_market_value: estimated_market_value, eui: eui = $cb75dec613a20d5a$var$none, floor_area_commercial: floor_area_commercial, floor_area_factory: floor_area_factory, floor_area_garage: floor_area_garage, floor_area_leasable: floor_area_leasable, floor_area_lot: floor_area_lot, floor_area_office: floor_area_office, floor_area_other: floor_area_other, floor_area_residential: floor_area_residential, floor_area_storage: floor_area_storage, floor_area_total: floor_area_total, floors: floors = $cb75dec613a20d5a$var$none, gas_comm_price: gas_comm_price, gas_customers: gas_customers, gas_ind_price: gas_ind_price, gas_name: gas_name, gas_res_price: gas_res_price, gas_total_vol: gas_total_vol, gas_website: gas_website, ghg_emission_total: ghg_emission_total, hdd65: hdd65, incentives: incentives, industry: industry = $cb75dec613a20d5a$var$none, iso_avg_load: iso_avg_load, iso_name: iso_name, iso_peak_load: iso_peak_load, iso_website: iso_website, land_use: land_use = $cb75dec613a20d5a$var$none, landmark: landmark, last_renovation: last_renovation, lender: lender = $cb75dec613a20d5a$var$none, loan_year: loan_year = $cb75dec613a20d5a$var$none, monthly_predictions: monthly_predictions = null, natural_gas_consumption: natural_gas_consumption, natural_gas_utility: natural_gas_utility, nearest_station: nearest_station, number_of_baths: number_of_baths = $cb75dec613a20d5a$var$none, number_of_beds: number_of_beds = $cb75dec613a20d5a$var$none, number_of_buildings: number_of_buildings = $cb75dec613a20d5a$var$none, operating_expense: operating_expense, opta: opta, owner_name: owner_name = $cb75dec613a20d5a$var$none, owner_type: owner_type, owner_type_code: owner_type_code = $cb75dec613a20d5a$var$none, predictions: predictions = null, predictionsTrace: predictionsTrace, primary_fuel: primary_fuel = $cb75dec613a20d5a$var$none, property_name: property_name, pvout: pvout, pvwattsTrace: pvwattsTrace, residential_units: residential_units = $cb75dec613a20d5a$var$none, revenue: revenue, share_in_aquisition_price: share_in_aquisition_price, sub_category: sub_category = $cb75dec613a20d5a$var$none, tax_rate: tax_rate = $cb75dec613a20d5a$var$none, temp: temp, total_gallons_high: total_gallons_high, total_gallons_low: total_gallons_low, total_mmbtu_high: total_mmbtu_high, total_mmbtu_low: total_mmbtu_low, utility_customers: utility_customers, utility_name: utility_name, utility_network_demand_peak: utility_network_demand_peak = $cb75dec613a20d5a$var$none, utility_total_mwh: utility_total_mwh, utility_website: utility_website, year_built: year_built = $cb75dec613a20d5a$var$none, zoning: zoning = $cb75dec613a20d5a$var$none, metrics: metrics, us_state_region: us_state_region, property_type_long: property_type_long, ev_level2_charger_count: // ev_charger_count,
// ev_charger_count_final,
ev_level2_charger_count, ev_dcfc_charger_count: ev_dcfc_charger_count, ev_registration_count: ev_registration_count, ev_registration_count_per_population: ev_registration_count_per_population, ev_state_population: ev_state_population, ev_closest_station_name: ev_closest_station_name, ev_chargers_in_10_mile_radius: ev_chargers_in_10_mile_radius, ev_chargers_in_state: ev_chargers_in_state, ev_distance_to_substation_meters: ev_distance_to_substation_meters })=>{
    let formattedArea = $cb75dec613a20d5a$var$none;
    if (area_in_sq_meters) formattedArea = $cb75dec613a20d5a$var$formatArea(Math.floor(area_in_sq_meters * 10.7639104));
    if (floor_area_total) formattedArea = $cb75dec613a20d5a$var$formatArea(floor_area_total);
    const details = {
        predictions: predictions && predictions.length || monthly_predictions && monthly_predictions.length,
        load_curve: pvwattsTrace && pvwattsTrace.length || predictionsTrace && predictionsTrace.length,
        energy_use: [
            {
                id: "annual_consumption",
                label: "Annual Consumption",
                value: (0, $fuiMG.formatNumber)(metrics === null || metrics === void 0 ? void 0 : metrics.annual_kwh_consumption) || $cb75dec613a20d5a$var$none,
                suffix: "kWh"
            },
            {
                label: "Region",
                value: us_state_region || $cb75dec613a20d5a$var$none
            },
            {
                label: "Area",
                value: formattedArea
            },
            {
                label: "Property type",
                value: property_type_long
            }
        ],
        utility_territory: [
            {
                label: "Name",
                value: utility_name ? $cb75dec613a20d5a$var$toTitleCase(utility_name) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Website",
                url: utility_website,
                value: utility_website || $cb75dec613a20d5a$var$none
            },
            {
                label: "Customers",
                value: utility_customers ? (0, $fuiMG.formatNumber)(utility_customers) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Total MWh",
                value: utility_total_mwh ? (0, $fuiMG.formatNumber)(utility_total_mwh) : $cb75dec613a20d5a$var$none
            }
        ],
        ev: [
            {
                label: "Level 2 EV charger recommendation",
                suffix: "chargers",
                hideIfZero: true,
                value: ev_level2_charger_count
            },
            {
                label: "Level 3 (DC Fast) charger recommendation",
                suffix: "chargers",
                hideIfZero: true,
                value: ev_dcfc_charger_count
            },
            {
                label: "EV Registrations per state",
                suffix: "vehicles",
                value: ev_registration_count
            },
            {
                label: "EV Registrations Per 1,000 People",
                value: ev_registration_count_per_population
            },
            {
                label: "State Population",
                value: ev_state_population
            },
            {
                label: "Closest EV Charger",
                value: ev_closest_station_name
            },
            {
                label: "Number of EV Chargers within 10 Miles",
                value: ev_chargers_in_10_mile_radius
            },
            {
                label: "Distance to Substation ",
                value: ev_chargers_in_10_mile_radius > 0 && ev_distance_to_substation_meters ? (0, $fuiMG.metersToMiles)(ev_distance_to_substation_meters) : null,
                suffix: "miles"
            },
            {
                label: "Number of EV Chargers in State",
                value: ev_chargers_in_state
            }
        ],
        iso_territory: [
            {
                label: "Name",
                value: iso_name ? $cb75dec613a20d5a$var$toTitleCase(iso_name) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Website",
                url: iso_website,
                value: iso_website || $cb75dec613a20d5a$var$none
            },
            {
                label: "Peak Load",
                suffix: "MW",
                value: iso_peak_load ? (0, $fuiMG.formatNumber)(iso_peak_load) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Average Load",
                suffix: "MW",
                value: iso_avg_load ? (0, $fuiMG.formatNumber)(iso_avg_load) : $cb75dec613a20d5a$var$none
            }
        ],
        natural_gas_service: [
            {
                label: "Utility Name",
                position: "left",
                value: gas_name ? $cb75dec613a20d5a$var$toTitleCase(gas_name) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Website",
                position: "left",
                url: gas_website,
                value: gas_website || $cb75dec613a20d5a$var$none
            },
            {
                label: "Total Volume (ccf)",
                position: "left",
                value: gas_total_vol ? (0, $fuiMG.formatNumber)(gas_total_vol) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Commercial Customers",
                position: "left",
                value: gas_customers ? (0, $fuiMG.formatNumber)(gas_customers) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Residential price $/MMBTU",
                position: "right",
                format: "currency",
                value: gas_res_price || $cb75dec613a20d5a$var$none
            },
            {
                label: "Commercial price $/MMBTU",
                position: "right",
                format: "currency",
                value: gas_comm_price || $cb75dec613a20d5a$var$none
            },
            {
                label: "Industrial price $/MMBTU",
                position: "right",
                format: "currency",
                value: gas_ind_price || $cb75dec613a20d5a$var$none
            }
        ],
        closest_power_plant: [
            ""
        ],
        power_line: [
            ""
        ],
        building: [
            {
                label: "Lot Area",
                position: "left",
                value: floor_area_lot ? $cb75dec613a20d5a$var$formatArea(floor_area_lot) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Year Built",
                position: "left",
                value: year_built,
                format: false
            },
            {
                label: "Number Of Floors",
                position: "left",
                value: floors
            },
            {
                label: "Floor Area Ratio",
                position: "left",
                value: building_far
            },
            {
                label: "Number Of Buildings",
                position: "left",
                value: number_of_buildings
            },
            {
                label: "Number Of Bedrooms",
                position: "left",
                value: number_of_beds
            },
            {
                label: "Number Of Bathrooms",
                position: "left",
                value: number_of_baths
            },
            {
                label: "Bin Numbers",
                position: "left",
                value: bins && bins.length ? bins.join(", ") : $cb75dec613a20d5a$var$none
            },
            {
                label: "Construction",
                position: "left",
                value: construction && construction.length ? construction : $cb75dec613a20d5a$var$none
            },
            {
                label: "Nearest Station",
                position: "left",
                value: nearest_station && nearest_station.length ? nearest_station : $cb75dec613a20d5a$var$none
            },
            {
                label: "Property Name",
                position: "left",
                value: property_name && property_name.length ? property_name : $cb75dec613a20d5a$var$none
            },
            {
                label: "Building Name",
                position: "left",
                value: building_name && building_name.length ? building_name : $cb75dec613a20d5a$var$none
            },
            {
                label: "Acquisition Date",
                position: "left",
                value: aquisition_date && aquisition_date.length ? aquisition_date : $cb75dec613a20d5a$var$none
            },
            {
                label: "Acquisition price",
                position: "left",
                value: aquisition_price && aquisition_price.length ? aquisition_price : $cb75dec613a20d5a$var$none
            },
            {
                label: "Share in acquisition price",
                position: "left",
                value: share_in_aquisition_price && share_in_aquisition_price.length ? share_in_aquisition_price : $cb75dec613a20d5a$var$none
            },
            {
                label: "Industry",
                position: "left",
                value: industry
            },
            {
                label: "Subcategory",
                position: "left",
                value: sub_category
            },
            {
                label: "Customer cd",
                position: "left",
                value: customer_cd
            },
            {
                label: "Total Area",
                position: "right",
                value: floor_area_total != null ? $cb75dec613a20d5a$var$formatArea(floor_area_total) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Office Area",
                position: "right",
                value: floor_area_office != null ? $cb75dec613a20d5a$var$formatArea(floor_area_office) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Commercial Area",
                position: "right",
                value: floor_area_commercial != null ? $cb75dec613a20d5a$var$formatArea(floor_area_commercial) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Zoning Code",
                position: "right",
                value: zoning
            },
            {
                label: "Factory Area",
                position: "right",
                value: floor_area_factory != null ? $cb75dec613a20d5a$var$formatArea(floor_area_factory) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Storage Area",
                position: "right",
                value: floor_area_storage != null ? $cb75dec613a20d5a$var$formatArea(floor_area_storage) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Residential Area",
                position: "right",
                value: floor_area_residential != null ? $cb75dec613a20d5a$var$formatArea(floor_area_residential) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Garage Area",
                position: "right",
                value: floor_area_garage != null ? $cb75dec613a20d5a$var$formatArea(floor_area_garage) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Roof Area",
                position: "right",
                value: area_in_sq_meters ? $cb75dec613a20d5a$var$formatArea(Math.floor(area_in_sq_meters * 10.7639104)) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Leasable Area",
                position: "right",
                value: floor_area_leasable ? $cb75dec613a20d5a$var$formatArea(Math.floor(floor_area_leasable)) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Other Area",
                position: "right",
                value: floor_area_other != null ? $cb75dec613a20d5a$var$formatArea(floor_area_other) : $cb75dec613a20d5a$var$none
            },
            {
                label: "Land Use",
                position: "right",
                value: land_use
            },
            {
                label: "Residential Units",
                position: "right",
                value: residential_units
            }
        ],
        financials: [
            {
                label: "Market Value",
                position: "left",
                format: "currency",
                value: estimated_market_value || $cb75dec613a20d5a$var$none
            },
            {
                label: "Tax Rate",
                position: "left",
                suffix: "%",
                value: tax_rate || $cb75dec613a20d5a$var$none
            },
            {
                label: "Revenue",
                position: "left",
                format: "currency",
                value: revenue || $cb75dec613a20d5a$var$none
            },
            {
                label: "OPEX",
                position: "left",
                format: "currency",
                value: operating_expense || $cb75dec613a20d5a$var$none
            },
            {
                label: "Net Operating Income",
                position: "left",
                format: "currency",
                value: revenue && operating_expense ? revenue - operating_expense : $cb75dec613a20d5a$var$none
            },
            {
                label: "Taxable Value",
                format: "currency",
                position: "right",
                value: billable_assessed_value || $cb75dec613a20d5a$var$none
            },
            {
                label: "Property Tax",
                format: "currency",
                position: "right",
                value: annual_property_tax != null ? annual_property_tax : $cb75dec613a20d5a$var$none
            },
            {
                label: "Lender",
                position: "right",
                value: lender || $cb75dec613a20d5a$var$none
            },
            {
                label: "Loan",
                format: "currency",
                position: "right",
                value: debt || $cb75dec613a20d5a$var$none
            },
            {
                label: "Loan Year",
                position: "right",
                value: loan_year || $cb75dec613a20d5a$var$none
            }
        ],
        energy: [
            {
                label: "HDD65",
                suffix: "days",
                values: hdd65 || $cb75dec613a20d5a$var$none
            },
            {
                label: "Average Annual Irradiance",
                suffix: "kWh/m<sup>2</sup>/day",
                value: average_annual_irradiance || $cb75dec613a20d5a$var$none
            },
            {
                label: "CDD65",
                suffix: "days",
                value: cdd65 || $cb75dec613a20d5a$var$none
            },
            {
                label: "Energy Use Intensity",
                suffix: `kBtu/${$cb75dec613a20d5a$var$sf}`,
                value: eui
            },
            {
                label: "energy star rating",
                value: energy_star_score
            },
            {
                label: "total ghg emissions",
                suffix: "MtCO2e",
                value: ghg_emission_total ? (0, $fuiMG.formatNumber)(ghg_emission_total) : $cb75dec613a20d5a$var$none
            },
            {
                label: "annual kwh estimate",
                suffix: "kWh",
                value: electricity_use ? (0, $fuiMG.formatNumber)(electricity_use) : $cb75dec613a20d5a$var$none
            },
            {
                label: "annual peak",
                suffix: "kW",
                value: annual_peak
            },
            {
                label: "compliance(ll87)",
                value: compliance_date
            },
            {
                label: "utility network demand peak",
                value: utility_network_demand_peak
            },
            {
                label: "electric utility",
                value: electric_utility || $cb75dec613a20d5a$var$none
            },
            {
                label: "natural gas utility",
                value: natural_gas_utility || $cb75dec613a20d5a$var$none
            }
        ],
        wind_speed: false,
        temperature: false,
        electricity_forecast: !!electricity_forecast,
        der: [
            {
                label: "Type",
                position: "left",
                value: der_type
            },
            {
                label: "Output",
                position: "left",
                suffix: "kW",
                value: der_output
            },
            {
                label: "installer & manufacturer",
                position: "right",
                value: der_installer
            },
            {
                label: "ownership structure",
                position: "right",
                value: der_ownership_structure
            },
            {
                label: "install date",
                position: "right",
                value: der_installation_date
            },
            {
                label: "natural gas consumption",
                position: "right",
                value: der_natural_gas_consumption
            }
        ],
        owner: [
            {
                label: "owner",
                value: owner_name || $cb75dec613a20d5a$var$none
            },
            {
                label: "type",
                value: owner_type || $cb75dec613a20d5a$var$none
            },
            {
                label: "type code",
                value: owner_type_code || $cb75dec613a20d5a$var$none
            }
        ]
    };
    // remove der section if non existing
    if (!der_output) delete details.der;
    // Remove energy use section if not available
    if (!metrics || !us_state_region) delete details.energy_use;
    if (total_mmbtu_low) details.energy.push({
        label: "total mmbtu",
        value: total_mmbtu_low ? `${(0, $fuiMG.formatNumber)(total_mmbtu_high)} - ${(0, $fuiMG.formatNumber)(total_mmbtu_low)}` : $cb75dec613a20d5a$var$none
    }, {
        label: "total gallons",
        value: total_gallons_low ? `${(0, $fuiMG.formatNumber)(total_gallons_low)} - ${(0, $fuiMG.formatNumber)(total_gallons_high)}` : $cb75dec613a20d5a$var$none
    }, {
        label: "burner model",
        value: burner_model
    }, {
        label: "primary fuel",
        value: primary_fuel
    }, {
        label: "boiler retirement year",
        value: esimated_boiler_retirement_year
    });
    if (incentives) details.incentives = incentives.map((incentive)=>({
            key: incentive.id,
            label: incentive.category,
            value: incentive.name
        }));
    if (natural_gas_consumption) details.energy.push({
        label: "Annual Natural Gas Consumption (MMBTu)",
        value: natural_gas_consumption ? `${(0, $fuiMG.formatNumber)(natural_gas_consumption)}` : $cb75dec613a20d5a$var$none
    });
    const co2_technologies = [
        "solar",
        "fuel_cell",
        "chp",
        "solar_thermal"
    ];
    co2_technologies.forEach((tech)=>{
        if (!co2_reduction || !co2_reduction[tech]) return;
        const { low: low } = co2_reduction[tech];
        const { high: high } = co2_reduction[tech];
        if (high > 0) {
            const v = {
                label: `CO2 Reduction with ${tech.toUpperCase().replace(/_/g, " ")}`,
                suffix: "lbs of CO2 reduced/year",
                value: high ? (0, $fuiMG.formatNumber)(low) - (0, $fuiMG.formatNumber)(high) : $cb75dec613a20d5a$var$none
            };
            if (co2_reduction[tech].high <= 0) v.value = "0";
            details.energy.push(v);
        }
    });
    if (last_renovation) details.building.push({
        label: "last renovation",
        value: last_renovation
    });
    if (landmark) details.building.push({
        label: "landmark",
        value: landmark
    });
    if (boiler_model || boiler_consumption) {
        const boilerData = [
            {
                label: "boiler model",
                value: boiler_model || $cb75dec613a20d5a$var$none
            },
            {
                label: "boiler capacity",
                suffix: "Btu",
                value: boiler_capacity
            },
            {
                label: "boiler installation Date",
                value: boiler_installation_date
            },
            {
                label: "est. boiler consumption (MMBTU)",
                value: boiler_consumption || $cb75dec613a20d5a$var$none
            },
            {
                label: "dual fuel",
                value: boiler_is_dual_fuel ? "Yes" : "No"
            }
        ];
        details.energy.push(...boilerData);
    }
    if (demo) details.building.forEach((o, i)=>{
        if (o["bin number"]) details.building.splice(i, 1);
    });
    if (opta) details.energy.push({
        label: "Solar Panel Tilt",
        suffix: "\xb0/180\xb0",
        value: opta
    });
    if (pvout) details.energy.push({
        label: "Solar Irradiance",
        suffix: "kWh/kWp per day",
        value: pvout.toFixed(2)
    });
    if (ele) details.building.push({
        label: "elevation",
        suffix: "m",
        value: ele
    });
    if (temp) details.building.push({
        label: "temperature",
        suffix: "\xb0C",
        value: temp.toFixed(2)
    });
    Object.keys(details).forEach((propName)=>{
        const skip = [
            "closest_power_plant",
            "incentives",
            "power_line",
            "predictionsTrace",
            "pvwattsTrace"
        ];
        if (Array.isArray(details[propName]) && !skip.includes(propName)) {
            const newDetails = [];
            details[propName].forEach((o)=>{
                if (o.value !== $cb75dec613a20d5a$var$none && o.value !== "NOT AVAILABLE") newDetails.push(o);
            });
            if (newDetails.length) details[propName] = newDetails;
            else delete details[propName];
        }
    });
    return details;
};
const $cb75dec613a20d5a$export$126d463feb878e45 = (_param)=>{
    var { address: address, address_ranges: address_ranges, addresses: addresses, attachments: attachments, centroid: centroid, contacts: contacts, energy_star_score: energy_star_score, estimates: estimates, eui: eui, property_type_long: property_type_long, property_type: property_type, recommendations: recommendations, reductions: reductions, therm_production: therm_production = {
        low: 0,
        high: 0
    } } = _param, rest = (0, $bmkEq._)(_param, [
        "address",
        "address_ranges",
        "addresses",
        "attachments",
        "centroid",
        "contacts",
        "energy_star_score",
        "estimates",
        "eui",
        "property_type_long",
        "property_type",
        "recommendations",
        "reductions",
        "therm_production"
    ]);
    const data = (0, $edHbI._)((0, $2QP2i._)({}, rest), {
        files: attachments,
        centroid: {
            lat: centroid[1],
            lon: centroid[0]
        },
        address: address || $cb75dec613a20d5a$var$formatAddress(addresses) || $cb75dec613a20d5a$var$none,
        address_ranges: address_ranges && address_ranges.length > 1 ? address_ranges : [],
        property_type: property_type_long,
        property_type_short: property_type,
        contacts: contacts,
        recommendations: recommendations,
        pv: recommendations.pv || 0,
        chp: recommendations.chp || 0,
        storage: recommendations.storage || 0,
        fuel_cell: recommendations.fuel_cell || 0,
        solar_thermal: recommendations.solar_thermal || 0,
        icons: {
            energystar: energy_star_score,
            eui: eui
        },
        estimates: {
            chp: estimates.chp || $cb75dec613a20d5a$var$none,
            fuel_cell: estimates.fuel_cell || $cb75dec613a20d5a$var$none,
            solar: estimates.solar || $cb75dec613a20d5a$var$none,
            storage: estimates.storage || $cb75dec613a20d5a$var$none,
            solar_thermal: estimates.solar_thermal || $cb75dec613a20d5a$var$none
        },
        therm_production: therm_production,
        reductions: reductions || {
            solar: {
                kw_reduction: {
                    low: 0,
                    high: 0
                },
                kwh_reduction: {
                    low: 0,
                    high: 0
                }
            },
            chp: {
                kw_reduction: {
                    low: 0,
                    high: 0
                },
                kwh_reduction: {
                    low: 0,
                    high: 0
                }
            },
            storage: {
                kw_reduction: {
                    low: 0,
                    high: 0
                },
                kwh_reduction: {
                    low: 0,
                    high: 0
                }
            },
            fuel_cell: {
                kw_reduction: {
                    low: 0,
                    high: 0
                },
                kwh_reduction: {
                    low: 0,
                    high: 0
                }
            }
        }
    });
    Object.keys(data).filter((propName)=>![
            "closest_power_plant",
            "contacts",
            "files",
            "incentives",
            "power_line",
            "predictionsTrace",
            "pvwattsTrace",
            "bbox"
        ].includes(propName)).forEach((propName)=>{
        const newArr = [];
        if (Array.isArray(data[propName])) {
            data[propName].filter((o)=>o !== null).forEach((o)=>{
                Object.keys(o).forEach((k)=>{
                    const v = o[k];
                    if (v !== $cb75dec613a20d5a$var$none && v !== "NOT AVAILABLE") newArr.push(o);
                });
            });
            data[propName] = newArr;
        }
    });
    return data;
};
function $cb75dec613a20d5a$export$b1edea61042966f2({ power_line_distance_in_meters: power_line_distance_in_meters, power_line_id: power_line_id, power_line_length_in_meters: power_line_length_in_meters, power_plant_desc: power_plant_desc, power_plant_distance: power_plant_distance, power_plant_fuel: power_plant_fuel, power_plant_id: power_plant_id, power_plant_name: power_plant_name, power_plant_total_mw: power_plant_total_mw }) {
    const data = {
        closest_power_plant: false,
        power_line: false
    };
    if (power_plant_id) data.closest_power_plant = [
        {
            label: "Name",
            url: power_plant_id ? `/search/${power_plant_id}` : null,
            value: power_plant_name || $cb75dec613a20d5a$var$none
        },
        {
            label: "Power Output",
            suffix: "MW",
            value: power_plant_total_mw || $cb75dec613a20d5a$var$none
        },
        {
            label: "Type",
            value: power_plant_desc || $cb75dec613a20d5a$var$none
        },
        {
            label: "Distance",
            suffix: "miles",
            value: power_plant_distance ? (0, $fuiMG.metersToMiles)(power_plant_distance) : $cb75dec613a20d5a$var$none
        },
        {
            label: "Fuel",
            value: power_plant_fuel || $cb75dec613a20d5a$var$none
        }
    ];
    if (power_line_id) data.power_line = [
        {
            label: "Powerline Length",
            value: power_line_length_in_meters ? (0, $fuiMG.metersToMiles)(power_line_length_in_meters) : $cb75dec613a20d5a$var$none,
            suffix: "miles"
        },
        {
            label: "Powerline Distance",
            value: power_line_distance_in_meters ? (0, $fuiMG.metersToMiles)(power_line_distance_in_meters) : $cb75dec613a20d5a$var$none,
            suffix: "miles"
        }
    ];
    return data;
}
function $cb75dec613a20d5a$export$cd5b146eaf8b654e({ IRR: IRR, net_present_value: net_present_value, payback_period: payback_period, total_1st_year_net_revenue: total_1st_year_net_revenue, total_30_year_net_revenue: total_30_year_net_revenue, total_gross_project_cost: total_gross_project_cost, battery_kw: battery_kw, battery_kwh: battery_kwh, chp_kw: chp_kw, fuel_cell_kw: fuel_cell_kw, pv_kw: pv_kw }) {
    return [
        {
            label: "Project Cost",
            value: total_gross_project_cost,
            format: "currency"
        },
        {
            label: "Payback Period",
            value: payback_period,
            suffix: "years"
        },
        {
            label: "IRR",
            value: IRR * 100,
            suffix: "%"
        },
        {
            label: "1st Year Net Revenue",
            value: total_1st_year_net_revenue,
            format: "currency"
        },
        {
            label: "Total Project Revenue",
            value: total_30_year_net_revenue,
            format: "currency"
        },
        {
            label: "Net Present Value",
            value: net_present_value,
            format: "currency"
        },
        {
            label: "Battery",
            value: `${(0, $fuiMG.formatNumber)(battery_kw)}kW / ${(0, $fuiMG.formatNumber)(battery_kwh)}kWh`
        },
        {
            label: "CHP",
            value: chp_kw,
            suffix: "kW"
        },
        {
            label: "Fuel Cell",
            value: fuel_cell_kw,
            suffix: "kW"
        },
        {
            label: "Solar",
            value: pv_kw,
            suffix: "kW"
        }
    ];
}
function $cb75dec613a20d5a$export$aaca97b705d749dc(rates) {
    if (!rates) return [];
    const { abbreviation: abbreviation, alternative_policy: alternative_policy, cost_solar: cost_solar, country_average_rate_kwh: country_average_rate_kwh, country_commercial_rate_kwh: country_commercial_rate_kwh, country_industrial_rate_kwh: country_industrial_rate_kwh, country_residential_rate_kwh: country_residential_rate_kwh, country_source: country_source, interconnection_spr: interconnection_spr, name: name, net_metering_allowed: net_metering_allowed, net_metering_capacity_limit: net_metering_capacity_limit, net_metering_meter_aggregation: net_metering_meter_aggregation, net_metering_notes: net_metering_notes, performance_payments_spr: performance_payments_spr, property_tax_spr: property_tax_spr, rps_spr: rps_spr, sales_tax_spr: sales_tax_spr, score_spr: score_spr, state_commercial_rate_kwh: state_commercial_rate_kwh, state_industrial_rate_kwh: state_industrial_rate_kwh, state_residential_rate_kwh: state_residential_rate_kwh, state_source: state_source, tax_credit_spr: tax_credit_spr, tariff_name: tariff_name, utility_name: utility_name, tariff_type: tariff_type } = rates;
    return [
        {
            value: name,
            name: "name",
            label: "name"
        },
        {
            value: tariff_name,
            name: "tariff_name",
            label: "tariff name"
        },
        {
            value: tariff_type,
            name: "tariff_type",
            label: "tariff type"
        },
        {
            value: utility_name,
            name: "utility_name",
            label: "utility name"
        },
        {
            value: rps_spr,
            name: "rps_spr",
            label: "rps spr"
        },
        {
            value: score_spr,
            name: "score_spr",
            label: "score spr"
        },
        {
            value: cost_solar,
            name: "cost_solar",
            label: "cost solar",
            format: "currency"
        },
        {
            value: abbreviation,
            name: "abbreviation",
            label: "abbreviation"
        },
        {
            value: state_source,
            name: "state_source",
            label: "state source"
        },
        {
            value: sales_tax_spr,
            name: "sales_tax_spr",
            label: "sales taxspr"
        },
        {
            value: country_source,
            name: "country_source",
            label: "country source"
        },
        {
            value: tax_credit_spr,
            name: "tax_credit_spr",
            label: "tax credit spr"
        },
        {
            value: property_tax_spr,
            name: "property_tax_spr",
            label: "property tax spr"
        },
        {
            value: alternative_policy,
            name: "alternative_policy",
            label: "alternative policy"
        },
        {
            value: net_metering_notes,
            name: "net_metering_notes",
            label: "net metering notes"
        },
        {
            value: interconnection_spr,
            name: "interconnection_spr",
            label: "interconnection spr"
        },
        {
            value: net_metering_allowed,
            name: "net_metering_allowed",
            label: "net metering allowed"
        },
        {
            value: country_average_rate_kwh,
            name: "country_average_rate_kwh",
            label: "country average rate",
            prefix: "$",
            suffix: "/kWh"
        },
        {
            value: performance_payments_spr,
            name: "performance_payments_spr",
            label: "performance payments spr"
        },
        {
            value: state_commercial_rate_kwh,
            name: "state_commercial_rate_kwh",
            label: "state commercial rate",
            prefix: "$",
            suffix: "/kWh"
        },
        {
            value: state_industrial_rate_kwh,
            name: "state_industrial_rate_kwh",
            label: "state industrial rate",
            prefix: "$",
            suffix: "/kWh"
        },
        {
            value: state_residential_rate_kwh,
            name: "state_residential_rate_kwh",
            label: "state residential rate",
            prefix: "$",
            suffix: "/kWh"
        },
        {
            value: country_commercial_rate_kwh,
            name: "country_commercial_rate_kwh",
            label: "country commercial rate",
            prefix: "$",
            suffix: "/kWh"
        },
        {
            value: country_industrial_rate_kwh,
            name: "country_industrial_rate_kwh",
            label: "country industrial rate",
            prefix: "$",
            suffix: "/kWh"
        },
        {
            value: net_metering_capacity_limit,
            name: "net_metering_capacity_limit",
            label: "net metering capacity limit"
        },
        {
            value: country_residential_rate_kwh,
            name: "country_residential_rate_kwh",
            label: "country residential rate",
            prefix: "$",
            suffix: "/kWh"
        },
        {
            value: net_metering_meter_aggregation,
            name: "net_metering_meter_aggregation",
            label: "net metering meter aggregation"
        }
    ];
}

});
parcelRegister("bmkEq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8451c4a8dea9d5c8$export$69fdd232f62cde60; });

var $4ac6j = parcelRequire("4ac6j");
function $8451c4a8dea9d5c8$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $4ac6j._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("4ac6j", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $30817b8edd440392$export$7a4a7e38737aceb4; });
function $30817b8edd440392$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});




parcelRegister("bccd0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $826a49161fad03e6$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $gOgWf = parcelRequire("gOgWf");

var $a2DeL = parcelRequire("a2DeL");

var $lxEiN = parcelRequire("lxEiN");

var $ht0W2 = parcelRequire("ht0W2");

var $8K8cO = parcelRequire("8K8cO");
class $826a49161fad03e6$var$Store {
    get sections() {
        if (this.details) return Object.keys(this.details).filter((key)=>this.details[key]).map((id)=>({
                id: id,
                title: (0, $8K8cO.default)[id]
            }));
        return [];
    }
    get analyticsUrl() {
        if (this.financials) return this.financials.analytics_id;
        return null;
    }
    get emissionsData() {
        if (this.financials) return this.financials.emissions;
        return null;
    }
    get cashFlow() {
        if (this.financials) return this.financials.capex_cash_flow;
        return null;
    }
    get cashFlowPPA() {
        if (this.financials) return this.financials.financials_ppa.capex_cash_flow;
        return null;
    }
    get formattedFinancials() {
        var _this_financials;
        if ((_this_financials = this.financials) === null || _this_financials === void 0 ? void 0 : _this_financials.formatted_financials) return this.financials.formatted_financials.financials;
        return [];
    }
    get formattedFinancialsPPA() {
        var _this_financials;
        if ((_this_financials = this.financials) === null || _this_financials === void 0 ? void 0 : _this_financials.formatted_financials_ppa) return this.financials.formatted_financials_ppa.financials;
        return [];
    }
    get quickMenuLinks() {
        if (this.building) {
            const { contacts: contacts, tariff: tariff } = this.building;
            const links = [
                ...this.sections
            ];
            if (tariff) links.push({
                id: "tariff",
                title: `${(0, $8K8cO.default).tariff}: ${tariff.name}`
            });
            links.push({
                id: "places",
                title: (0, $8K8cO.default).places
            });
            if (contacts && !!contacts.length) links.push({
                id: "contacts",
                title: (0, $8K8cO.default).contacts
            });
            return links;
        }
        return [];
    }
    constructor(){
        (0, $cr2GM._)(this, "isLoading", false);
        (0, $cr2GM._)(this, "id", null);
        (0, $cr2GM._)(this, "building", null);
        (0, $cr2GM._)(this, "estimates", null);
        (0, $cr2GM._)(this, "estimates_int", null);
        (0, $cr2GM._)(this, "financialsHash", null);
        (0, $cr2GM._)(this, "details", null);
        (0, $cr2GM._)(this, "weather_timestamp", null);
        (0, $cr2GM._)(this, "wind_speed", null);
        (0, $cr2GM._)(this, "temperature", null);
        (0, $cr2GM._)(this, "places", null);
        (0, $cr2GM._)(this, "financials", null);
        (0, $cr2GM._)(this, "closest_power_plant", null);
        (0, $cr2GM._)(this, "power_line", null);
        (0, $cr2GM._)(this, "weatherData", []);
        (0, $cr2GM._)(this, "predictions", []);
        (0, $cr2GM._)(this, "centroid", null);
        (0, $cr2GM._)(this, "bbox", null);
        (0, $cr2GM._)(this, "timeOfDay", new Date(1681488000000));
        (0, $cr2GM._)(this, "financialMode", "default");
        (0, $cr2GM._)(this, "showUploadedData", false);
        (0, $cr2GM._)(this, "setFinancialsHash", (hash)=>{
            this.financialsHash = hash;
        });
        (0, $cr2GM._)(this, "setFinancials", (financials)=>{
            this.financials = financials;
        });
        (0, $cr2GM._)(this, "loadBuilding", async (buildingId)=>{
            if (this.id === buildingId && !this.isLoading) return true;
            this.building = null;
            this.isLoading = true;
            this.centroid = null;
            this.bbox = null;
            this.financials = null;
            this.financialMode = "default";
            this.timeOfDay = new Date(1681488000000);
            const building = await (0, $a2DeL.default).loadBuilding(buildingId);
            if (building) {
                this.id = building.id;
                this.details = building.details;
                this.estimates = building.estimates;
                this.estimates_int = building.estimates_int;
                this.building = building;
                this.centroid = building.centroid;
                this.bbox = building.bbox;
                this.weather_timestamp = null;
                this.wind_speed = null;
                this.temperature = null;
                this.weatherData = [];
                this.predictions = [];
                this.places = null;
                this.closest_power_plant = null;
                this.power_line = null;
                this.isLoading = false;
                if (building.financials) this.setFinancials(building.financials);
                return building;
            }
            this.isLoading = false;
            return null;
        });
        (0, $cr2GM._)(this, "loadFinancials", async ()=>{
            const building = await (0, $a2DeL.default).loadBuilding(this.id);
            if (building) {
                console.log("new financials");
                this.setFinancials(building.financials);
                return building;
            }
            return null;
        });
        (0, $cr2GM._)(this, "getBuildingFinancials", async (projectId)=>{
            const { data: data } = await (0, $lxEiN.default).Project.getBuildingFinancials(projectId, this.id);
            this.financials = data.data;
        });
        (0, $cr2GM._)(this, "getWeather", async (lon, lat)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getWeather(lon, lat);
            if (data.data) this.weatherData = data.data.charts;
        });
        (0, $cr2GM._)(this, "getPredictions", async (buildingId)=>{
            if (this.building.project_id) {
                const { data: data } = await (0, $lxEiN.default).Project.getProjectBuildingPredictions(this.building.project_id, buildingId);
                this.predictions = data.data;
            } else {
                const { data: data } = await (0, $lxEiN.default).Building.getPredictions(buildingId);
                this.predictions = data.data;
            }
        });
        (0, $cr2GM._)(this, "getPlaces", async (buildingId, lon, lat)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getPlaces(lon, lat);
            if (data === null || data === void 0 ? void 0 : data.data) this.places = data.data;
        });
        (0, $cr2GM._)(this, "getPowerOptions", async (buildingId, lon, lat)=>{
            const { data: data } = await (0, $lxEiN.default).Building.getPowerOptions(lon, lat);
            if (data === null || data === void 0 ? void 0 : data.data) {
                const { power_line_closest_point: power_line_closest_point, power_line_geometry: power_line_geometry, power_line_id: power_line_id, power_plant_geometry: power_plant_geometry } = data.data;
                this.details = (0, $2QP2i._)({}, this.details, (0, $ht0W2.formatBuildingPower)(data.data));
                this.closest_power_plant = true;
                this.power_line = {
                    power_line_closest_point: power_line_closest_point,
                    power_line_geometry: power_line_geometry,
                    power_line_id: power_line_id,
                    power_plant_geometry: power_plant_geometry
                };
            }
        });
        (0, $cr2GM._)(this, "setEstimates", (estimates, estimates_int)=>{
            if (!estimates) throw new Error("estimates is required");
            if (!estimates_int) throw new Error("estimates_int is required");
            this.estimates = estimates;
            this.estimates_int = estimates_int;
        });
        (0, $cr2GM._)(this, "setFinancialMode", (mode)=>{
            this.financialMode = mode;
        });
        (0, $cr2GM._)(this, "setTimeOfDay", (time)=>{
            this.timeOfDay = time;
        });
        (0, $cr2GM._)(this, "setShowUploadedData", (show)=>{
            this.showUploadedData = show;
        });
        (0, $gOgWf.makeObservable)(this, {
            isLoading: (0, $gOgWf.observable),
            showUploadedData: (0, $gOgWf.observable),
            id: (0, $gOgWf.observable),
            centroid: (0, $gOgWf.observable),
            financialsHash: (0, $gOgWf.observable),
            estimates: (0, $gOgWf.observable),
            estimates_int: (0, $gOgWf.observable),
            timeOfDay: (0, $gOgWf.observable),
            details: (0, $gOgWf.observable),
            weather_timestamp: (0, $gOgWf.observable),
            financials: (0, $gOgWf.observable),
            wind_speed: (0, $gOgWf.observable),
            temperature: (0, $gOgWf.observable),
            places: (0, $gOgWf.observable),
            closest_power_plant: (0, $gOgWf.observable),
            power_line: (0, $gOgWf.observable),
            weatherData: (0, $gOgWf.observable),
            predictions: (0, $gOgWf.observable),
            loadBuilding: (0, $gOgWf.action),
            financialMode: (0, $gOgWf.observable),
            sections: (0, $gOgWf.computed),
            quickMenuLinks: (0, $gOgWf.computed),
            getWeather: (0, $gOgWf.action),
            getPredictions: (0, $gOgWf.action),
            getPlaces: (0, $gOgWf.action),
            setFinancialMode: (0, $gOgWf.action),
            getPowerOptions: (0, $gOgWf.action)
        });
    }
}
const $826a49161fad03e6$var$store = new $826a49161fad03e6$var$Store();
var $826a49161fad03e6$export$2e2bcd8739ae039 = $826a49161fad03e6$var$store;

});
parcelRegister("8K8cO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01a48831df6ab253$export$2e2bcd8739ae039; });
var $01a48831df6ab253$export$2e2bcd8739ae039 = {
    building: "Building",
    closest_power_plant: "Nearest Power Plant",
    der: "Der on-site",
    electricity_forecast: "Realtime Utility and Weather",
    energy: "Energy and environment",
    financials: "Property Financials",
    incentives: "Energy Incentives",
    energy_use: "Energy Use",
    iso_territory: "Independent System Operator",
    load_curve: "Predicted Load Profile",
    natural_gas_service: "Natural Gas Service Territory",
    ev: "Electric Vehicles",
    owner: "Ownership",
    power_line: "Nearest Powerline",
    predictions: "Solar Photovoltaic Production",
    temperature: "Temperature",
    utility_territory: "Utility Territory",
    wind_speed: "Wind Speed",
    contacts: "Contacts",
    tariff: "Tariff",
    places: "Places",
    descriptions: {
        storage_estimate: `A site-specific recommendation on the size of a Battery Storage system to be installed at this property`,
        storage_recommendation: `Suitability of Battery Storage technologies to this property type`,
        chp_estimate: `A site-specific recommendation on the size of a CHP system to be installed at this property`,
        chp_recommendation: `Suitability of CHP technologies to this property type`,
        fuel_cell_recommendation: `A site-specific recommendation on the size of a Fuel Cell system to be installed at this property`,
        fuel_cell_estimate: `Suitability of Fuel Cell technologies to this property type`,
        solar_recommendation: `A site-specific recommendation on the size of a Solar system to be installed at this property`,
        solar_estimate: `Suitability of Solar technologies to this type`,
        "lot area": `Total square footage value of parcel of land`,
        "total area": `Total square footage of building(s) on parcel`,
        "year built": `Date of intial building completion`,
        "office area": `area Sub-type of commercial area. Building usage breakdown for office area, allowing for a better understanding of building use`,
        "number of floors": `Maximum number of floors of building(s) on property`,
        "commercial area": `Building usage breakdown for commercial area, allowing for a better understanding of building use`,
        "floor area ratio": `Gross floor area of building(s) (total area) divided by lot area`,
        "number of buildings": `Number of buildings included on the property`,
        "factory area": `Sub-type of commercial area. Building usage breakdown for factory area, allowing for a better understanding of building use`,
        "retail area": `Sub-type of commercial area. Building usage breakdown for retail area, allowing for a better understanding of building use`,
        "storage area": `Able to search through any of the NYC data sets using this number`,
        "residential area": `Sub-type of commercial area. Building usage breakdown for storage area, allowing for a better understanding of building use`,
        "land use": `Land Use of the property, derived from building class`,
        "garage area": `Sub-type of commercial area. Building usage breakdown for garage area, allowing for a better understanding of building use`,
        landmark: `Name of the landmark designation on the building (if applicable)`,
        "other area": `Sub-type of commercial area. Building usage breakdown for other area, allowing for a better understanding of building use`,
        "residential units": `Number of residential units contained on the property (does not include hotel units)`,
        "market value": `DER project development can increase current market value of property`,
        "taxable value": `Actual or Transitional Assessed Value (whichever is less) minus any exemptions, used to calculate annual tax bill`,
        "tax rate": `The rate used to determine the tax owed, each tax class has it's own rate `,
        "property tax": "Can provide useful insight. Often when property tax is $0, the site is subsidized ",
        revenue: `Total revenue of property`,
        lender: `Name of instutution loaning the amount listed`,
        opex: `Building Operating Expense`,
        loan: `Current loan amount`,
        "net operating income": `Revenue minus OPEX`,
        "loan year": `Year of most recent loan`,
        "energy use intensity": `Total energy consumed in one year divided by total building area`,
        "electric utility": `Name of Electric Utility`,
        "energy star rating": `Screening tool that helps one assess how a building is performing. A score of 50 is the median`,
        gas_utility: `Name of Gas Utility`,
        "total ghg emissions": `Total GHG emissions from the technologies and systems on the property`,
        bouler_model: `Model of boiler currently installed on the property`,
        "total kwh": `Estimate of total kWh used on the lot in a year`,
        boiler_capacity: `Heating capacity of current boiler`,
        "year peak": `Yearly peak electric demand of building(s)`,
        "boiler installation date": `Istallation year of boiler, which can suggest a boiler is out of date and in need of an upgrade`,
        "compliance(ll87)": `Compliance years in the recent past means they energy audit information is up-to-date. A compliance year scheduled in the near future means their energy info will be updated soon`,
        "boiler oil consumption": `Estimate of yearly oil consumption by installed boiler`,
        "utility network demand peak": `When electricity demand is highest for a given network`,
        "is dual fuel": `Boiler able to accept both oil and natural gas (Y/N)`,
        owner: `Listed owner of building`,
        type: `Owner type`,
        "natural gas utility": "Name of Gas Utility",
        "e-mail": `Email address listed for contact`,
        contact: `If an organization, contact at the organization for reaching out to initiate or continue conversations`,
        "relationship to owner": "Relationship of Contact to owner",
        phone: "Phone number of contact"
    }
};

});


parcelRegister("8ERvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64db8fa61093eb9e$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $gOgWf = parcelRequire("gOgWf");
// configure({ enforceActions: true});
class $64db8fa61093eb9e$var$Store {
    setModal(modalName, data) {
        this.open = modalName;
        this.data = data;
    }
    setData(data) {
        this.data = data;
    }
    constructor(){
        (0, $cr2GM._)(this, "open", null);
        (0, $cr2GM._)(this, "data", void 0);
        (0, $gOgWf.makeObservable)(this, {
            open: (0, $gOgWf.observable),
            data: (0, $gOgWf.observable),
            setModal: (0, $gOgWf.action),
            setData: (0, $gOgWf.action)
        });
    }
}
const $64db8fa61093eb9e$var$store = new $64db8fa61093eb9e$var$Store();
var $64db8fa61093eb9e$export$2e2bcd8739ae039 = $64db8fa61093eb9e$var$store;

});

parcelRegister("PtNzY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09abe0ede62d3598$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $gOgWf = parcelRequire("gOgWf");

var $4WgAH = parcelRequire("4WgAH");
class $09abe0ede62d3598$var$Store {
    addBuilding(id, building) {
        this.buildings.set(id, building);
    }
    removeBuilding(id) {
        this.buldings.delete(id);
    }
    constructor(){
        (0, $cr2GM._)(this, "buildings", new Map());
        (0, $cr2GM._)(this, "create", async (name)=>{
            const params = {
                name: name,
                buildings: this.buildings.values()
            };
            await (0, $4WgAH.default).createProject(params);
        });
        (0, $gOgWf.makeObservable)(this, {
            buildings: (0, $gOgWf.observable),
            addBuilding: (0, $gOgWf.action),
            removeBuilding: (0, $gOgWf.action),
            create: (0, $gOgWf.action)
        });
    }
}
const $09abe0ede62d3598$var$store = new $09abe0ede62d3598$var$Store();
var $09abe0ede62d3598$export$2e2bcd8739ae039 = $09abe0ede62d3598$var$store;

});

parcelRegister("a0rcO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $748f01f1fcb334d0$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $lxEiN = parcelRequire("lxEiN");
class $748f01f1fcb334d0$var$Store {
    get total() {
        return this.tasks.size;
    }
    constructor(){
        (0, $cr2GM._)(this, "project", null);
        (0, $cr2GM._)(this, "tasks", new Map());
        (0, $cr2GM._)(this, "loadTasks", async (projectId, buildingId)=>{
            this.tasks = new Map();
            const response = await (0, $lxEiN.default).Task.getProjectTasks(projectId, buildingId);
            this.tasks = new Map(response.data.data.map((task)=>{
                return [
                    task.id,
                    task
                ];
            }));
        });
        (0, $cr2GM._)(this, "loadTask", async (id)=>{
            try {
                const { data: data } = await (0, $lxEiN.default).Task.get(id);
                if (data.ok) {
                    this.tasks.set(data.data.id, data.data);
                    return this.tasks.get(data.data.id);
                }
            } catch (e) {
                return null;
            }
        });
        (0, $cr2GM._)(this, "get", (id)=>{
            return this.tasks.get(id);
        });
        (0, $cr2GM._)(this, "create", async (taskData)=>{
            const postParams = (0, $edHbI._)((0, $2QP2i._)({}, taskData), {
                users: taskData.users.map((u)=>u.id)
            });
            const { data: data } = await (0, $lxEiN.default).Task.create(postParams);
            if (data.ok) {
                this.tasks.set(data.data.id, data.data);
                return data.data;
            }
            return null;
        });
        (0, $cr2GM._)(this, "updateStatus", async (taskData)=>{
            const task = this.tasks.get(taskData.id);
            this.tasks.set(taskData.id, taskData);
            await this.update(taskData, task);
        });
        (0, $cr2GM._)(this, "update", async (taskId, taskData)=>{
            const tasks = new Map(this.tasks);
            const task = tasks.get(taskId);
            const newTask = (0, $edHbI._)((0, $2QP2i._)({}, task), {
                status: taskData.status
            });
            if (taskData.status !== task.status) {
                tasks.set(taskId, newTask);
                this.tasks = tasks;
            }
            try {
                const { data: data } = await (0, $lxEiN.default).Task.update(taskId, taskData);
                tasks.set(data.data.id, data.data);
            } catch (err) {
                tasks.set(task.id, task);
            }
            this.tasks = tasks;
        });
        (0, $cr2GM._)(this, "deleteTask", async (id)=>{
            const { data: data } = await (0, $lxEiN.default).Task.delete(id);
            if (data.ok) {
                this.tasks.delete(id);
                return data.data;
            }
            return null;
        });
        (0, $gOgWf.makeObservable)(this, {
            project: (0, $gOgWf.observable),
            tasks: (0, $gOgWf.observable),
            loadTasks: (0, $gOgWf.action),
            loadTask: (0, $gOgWf.action),
            get: (0, $gOgWf.action),
            total: (0, $gOgWf.computed),
            create: (0, $gOgWf.action),
            updateStatus: (0, $gOgWf.action),
            update: (0, $gOgWf.action),
            deleteTask: (0, $gOgWf.action)
        });
    }
}
const $748f01f1fcb334d0$var$store = new $748f01f1fcb334d0$var$Store();
var $748f01f1fcb334d0$export$2e2bcd8739ae039 = $748f01f1fcb334d0$var$store;

});

parcelRegister("6OIJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f6a1e06e4fbabca$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $gOgWf = parcelRequire("gOgWf");
// configure({ enforceActions: true});
class $4f6a1e06e4fbabca$var$Store {
    get layoutClass() {
        return [
            this.sidebarExpanded ? "nav-expanded" : "",
            this.isContentVisible ? "content-visible" : "",
            this.isMapVisible ? "map-visible" : "",
            this.isSpeedDialOpen ? "speeddial-visible" : ""
        ].join(" ").trim();
    }
    setRadius(value) {
        this.radius = value;
    }
    setRadiusActive(value) {
        this.isRadiusActive = value;
    }
    setSearchPanelState(state) {
        this.controlPanelState = state;
    }
    setSearchFiltersState(state) {
        this.searchFiltersState = state;
    }
    setSidebarExpanded(isExpanded) {
        this.sidebarExpanded = isExpanded;
    }
    setIsSpeedDialOpen(isOpen) {
        this.isSpeedDialOpen = isOpen;
    }
    setActiveLayer(layerName, isActive) {
        if (isActive) this.activeMapLayers = [
            ...this.activeMapLayers,
            layerName
        ];
        else this.activeMapLayers = [
            ...this.activeMapLayers,
            layerName
        ].filter((layer)=>layer !== layerName);
    }
    setAnalysisPanelOpen(isOpen) {
        this.isAnalysisPanelOpen = isOpen;
    }
    setActiveMapLayers(mapLayers) {
        this.activeMapLayers = mapLayers;
    }
    setIsMapVisible(isVisible) {
        this.isMapVisible = isVisible;
    }
    setIsContentVisible(isVisible) {
        this.isContentVisible = isVisible;
    }
    setFeedbackModalOpen(open) {
        this.feedbackModalOpen = open;
    }
    setUIVersion(version) {
        this.version = version;
    }
    setREGISTRATION_VERSION(version) {
        this.REGISTRATION_VERSION = version;
    }
    constructor(){
        (0, $cr2GM._)(this, "controlPanelState", "search");
        (0, $cr2GM._)(this, "searchFiltersState", "form");
        (0, $cr2GM._)(this, "isSpeedDialOpen", false);
        (0, $cr2GM._)(this, "isAnalysisPanelOpen", false);
        (0, $cr2GM._)(this, "isMapVisible", false);
        (0, $cr2GM._)(this, "isContentVisible", false);
        (0, $cr2GM._)(this, "feedbackModalOpen", false);
        (0, $cr2GM._)(this, "version", "v2");
        (0, $cr2GM._)(this, "REGISTRATION_VERSION", "v2");
        (0, $cr2GM._)(this, "mapLayers", [
            {
                name: "coned_hosting_capacity",
                label: "Hosting Capacity"
            },
            {
                name: "coned_hosting_capacity_lines",
                label: "Feeder Hosting Capacity"
            },
            {
                name: "powerlines",
                label: "Powerlines"
            },
            {
                name: "openweather_solar",
                label: "Temperature"
            },
            {
                name: "openweather_wind",
                label: "Wind"
            },
            {
                name: "openweather_clouds",
                label: "Cloud Cover"
            }
        ]);
        (0, $cr2GM._)(this, "detailView", {
            currentTab: 0
        });
        (0, $cr2GM._)(this, "activeMapLayers", []);
        (0, $cr2GM._)(this, "radius", false);
        (0, $cr2GM._)(this, "isRadiusActive", false);
        (0, $cr2GM._)(this, "sidebarExpanded", false);
        (0, $gOgWf.makeObservable)(this, {
            isAnalysisPanelOpen: (0, $gOgWf.observable),
            controlPanelState: (0, $gOgWf.observable),
            version: (0, $gOgWf.observable),
            REGISTRATION_VERSION: (0, $gOgWf.observable),
            feedbackModalOpen: (0, $gOgWf.observable),
            searchFiltersState: (0, $gOgWf.observable),
            isSpeedDialOpen: (0, $gOgWf.observable),
            isMapVisible: (0, $gOgWf.observable),
            isContentVisible: (0, $gOgWf.observable),
            mapLayers: (0, $gOgWf.observable),
            detailView: (0, $gOgWf.observable),
            activeMapLayers: (0, $gOgWf.observable),
            radius: (0, $gOgWf.observable),
            isRadiusActive: (0, $gOgWf.observable),
            sidebarExpanded: (0, $gOgWf.observable),
            layoutClass: (0, $gOgWf.computed),
            setRadius: (0, $gOgWf.action),
            setRadiusActive: (0, $gOgWf.action),
            setSearchPanelState: (0, $gOgWf.action),
            setSearchFiltersState: (0, $gOgWf.action),
            setSidebarExpanded: (0, $gOgWf.action),
            setIsSpeedDialOpen: (0, $gOgWf.action),
            setActiveLayer: (0, $gOgWf.action),
            setIsMapVisible: (0, $gOgWf.action),
            setIsContentVisible: (0, $gOgWf.action)
        });
    }
}
const $4f6a1e06e4fbabca$var$store = new $4f6a1e06e4fbabca$var$Store();
var $4f6a1e06e4fbabca$export$2e2bcd8739ae039 = $4f6a1e06e4fbabca$var$store;

});

parcelRegister("brBQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $854f928e0b85dc7e$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $3U8SM = parcelRequire("3U8SM");

var $lxEiN = parcelRequire("lxEiN");

var $lUBOG = parcelRequire("lUBOG");
class $854f928e0b85dc7e$var$Store {
    get loggedIn() {
        return Boolean(this.user && this.user.logged_in);
    }
    get isAdmin() {
        var _this_user;
        return Boolean((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.is_admin);
    }
    get avatar() {
        var _this_user, _this_user1;
        return `${(0, $lUBOG.default).E2E_API_URL}user/${(_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.id}/avatar?${(_this_user1 = this.user) === null || _this_user1 === void 0 ? void 0 : _this_user1.last_active}`;
    }
    get isActivated() {
        var _this_user;
        return Boolean((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.is_activated);
    }
    get isOnboardingCompleted() {
        var _this_user;
        return Boolean((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.is_onboarding_completed);
    }
    hasAccess(id) {
        var _this_user_group;
        return (_this_user_group = this.user.group) === null || _this_user_group === void 0 ? void 0 : _this_user_group.menu_items.includes(id);
    }
    addNotification(notification) {
        this.notifications = [
            ...this.notifications,
            notification
        ];
    }
    constructor(){
        (0, $cr2GM._)(this, "user", null);
        (0, $cr2GM._)(this, "groupMembers", []);
        (0, $cr2GM._)(this, "notifications", []);
        (0, $cr2GM._)(this, "status", "loading");
        (0, $cr2GM._)(this, "loginWithCode", async (code)=>{
            const { data: data } = await (0, $3U8SM.default).post("/login", {
                code: code
            });
            if (data.ok !== 1) return false;
            await this.fetchCredentials();
            return true;
        });
        (0, $cr2GM._)(this, "login", async (email, password)=>{
            const { data: data } = await (0, $3U8SM.default).post("/login", {
                email: email,
                password: password
            });
            if (data.ok !== 1) return false;
            await this.fetchCredentials();
            return true;
        });
        (0, $cr2GM._)(this, "logout", async ()=>{
            localStorage.removeItem("jwt");
            await (0, $lxEiN.default).User.logout();
            this.user = null;
        });
        (0, $cr2GM._)(this, "fetchCredentials", async ()=>{
            const { data: data } = await (0, $3U8SM.default).get("/status");
            this.user = data;
            if (data.msg === "UNDER_MAINTENANCE") this.status = "UNDER_MAINTENANCE";
            else this.status = "loaded";
            if (data.is_activated && data.logged_in && data.group) this.fetchGroupMembers();
            return data;
        });
        (0, $cr2GM._)(this, "hasGroupPermission", (permission)=>{
            return Boolean(this.user.group.permissions[permission]);
        });
        (0, $cr2GM._)(this, "switchGroup", async (id)=>{
            try {
                const { data: data } = await (0, $3U8SM.default).get(`/group/${id}/switch`);
                await this.fetchCredentials();
                this.fetchGroupMembers();
                return data;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err);
                return null;
            }
        });
        (0, $cr2GM._)(this, "fetchGroupMembers", async ()=>{
            const { data: data } = await (0, $3U8SM.default).get(`/group/${this.user.group.id}/relationships/users`);
            this.groupMembers = data.data;
            return data.data;
        });
        (0, $cr2GM._)(this, "deleteGroup", async (groupId)=>{
            const newGroups = [
                ...this.user.groups
            ].filter((group)=>group.id !== groupId);
            this.user = (0, $edHbI._)((0, $2QP2i._)({}, this.user), {
                groups: newGroups
            });
            await (0, $lxEiN.default).Group.delete(groupId);
        });
        (0, $cr2GM._)(this, "removeGroupMember", async (userId)=>{
            const groupId = this.user.group.id;
            const idx = this.groupMembers.findIndex((m)=>m.id === userId);
            this.groupMembers.splice(idx, 1);
            await (0, $3U8SM.default).delete(`/group/${groupId}/relationships/users`, {
                data: [
                    {
                        id: userId
                    }
                ]
            });
        });
        (0, $gOgWf.makeObservable)(this, {
            user: (0, $gOgWf.observable),
            groupMembers: (0, $gOgWf.observable),
            notifications: (0, $gOgWf.observable),
            status: (0, $gOgWf.observable),
            loggedIn: (0, $gOgWf.computed),
            isAdmin: (0, $gOgWf.computed),
            avatar: (0, $gOgWf.computed),
            isActivated: (0, $gOgWf.computed),
            isOnboardingCompleted: (0, $gOgWf.computed),
            login: (0, $gOgWf.action),
            hasAccess: (0, $gOgWf.action),
            logout: (0, $gOgWf.action),
            addNotification: (0, $gOgWf.action),
            fetchCredentials: (0, $gOgWf.action),
            switchGroup: (0, $gOgWf.action),
            fetchGroupMembers: (0, $gOgWf.action),
            deleteGroup: (0, $gOgWf.action),
            removeGroupMember: (0, $gOgWf.action)
        });
        this.fetchCredentials();
    }
}
const $854f928e0b85dc7e$var$store = new $854f928e0b85dc7e$var$Store();
var $854f928e0b85dc7e$export$2e2bcd8739ae039 = $854f928e0b85dc7e$var$store;

});

parcelRegister("kH9gy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f10f02d5413fc340$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $drY2b = parcelRequire("drY2b");

var $ht0W2 = parcelRequire("ht0W2");

var $4WgAH = parcelRequire("4WgAH");

var $brBQs = parcelRequire("brBQs");

var $3U8SM = parcelRequire("3U8SM");

var $lxEiN = parcelRequire("lxEiN");

var $fuiMG = parcelRequire("fuiMG");

var $WXYRR = parcelRequire("WXYRR");
class $f10f02d5413fc340$var$Store {
    get financialsCalculated() {
        return this.buildings.every((building)=>building.financials);
    }
    get filteredBuildings() {
        var _this_buildingFilter;
        const geometry = (_this_buildingFilter = this.buildingFilter) === null || _this_buildingFilter === void 0 ? void 0 : _this_buildingFilter.geometry;
        if (!geometry) return this.buildings;
        const tree = (0, (/*@__PURE__*/$parcel$interopDefault($drY2b)))();
        tree.insert({
            type: "Feature",
            geometry: geometry
        });
        if (geometry.type === "Polygon") return this.buildings.filter((building)=>{
            return tree.collides({
                type: "Feature",
                geometry: building.polygon
            });
        });
        if (geometry.type === "Point") return this.buildings.reduce((acc, building)=>{
            const distance = (0, $fuiMG.getDistanceFromLatLonInKm)(geometry.coordinates, building.centroid);
            if (distance < 0.5) acc.push((0, $edHbI._)((0, $2QP2i._)({}, building), {
                distance: distance
            }));
            return acc;
        }, []);
        return this.buildings;
    }
    get selectedVendors() {
        return this.vendors.filter((vendor)=>vendor.is_selected);
    }
    addBuilding(building) {
        this.buildings = [
            ...this.buildings,
            building
        ];
    }
    setInfoMessage(message) {
        this.infoMessage = message;
        (0, $lxEiN.default).Project.setProjectSettings(this.id, {
            info_message: message
        });
    }
    setProposalMessage(message) {
        this.proposalMessage = message;
    }
    setContactMessage(message) {
        this.contactMessage = message;
    }
    setExecutiveSummaryFileId(fileId) {
        this.executiveSummaryFileId = fileId;
    }
    setCustomerName(customerName) {
        this.customerName = customerName;
    }
    setProposalDeadline(deadline) {
        this.proposalDeadline = deadline;
    }
    setStatus(status, options = {}) {
        this.status = status;
        const resultMap = new Map((0, $4WgAH.default).resultMap);
        const project = resultMap.get(this.id);
        if (project) project.status = status;
        (0, $lxEiN.default).Project.setProjectSettings(this.id, (0, $2QP2i._)({
            status: status
        }, options));
        (0, $4WgAH.default).setResults(resultMap);
    }
    setVendor(vendor) {
        this.vendor = vendor;
    }
    setVariant(variant) {
        this.variant = variant;
    }
    setRFPQuestions(questions) {
        this.rfpQuestions = questions;
    }
    getRFPQuestion(questionId) {
        return this.rfpQuestions.find((q)=>q.question_id === questionId);
    }
    setProposals(proposals) {
        this.proposals = proposals;
    }
    setFinancials(financials) {
        this.financials = financials;
    }
    // eslint-disable-next-line class-methods-use-this
    get analyticsUrl() {
        return null;
    }
    get emissionsData() {
        console.log("this.financials", this.financials);
        if (this.financials) return this.financials.emissions;
        return null;
    }
    get cashFlow() {
        var _this_financials;
        if ((_this_financials = this.financials) === null || _this_financials === void 0 ? void 0 : _this_financials.capex_cash_flow) return this.financials.capex_cash_flow;
        return null;
    }
    get formattedFinancials() {
        return this.financials.formatted_financials;
    }
    setLayerActive(layerId, isActive) {
        const layers = [
            ...this.activeLayers,
            layerId
        ];
        if (!isActive) this.setActiveLayers([
            ...this.activeLayers.filter((activeLayerId)=>activeLayerId !== layerId)
        ]);
        else this.setActiveLayers(layers);
    }
    setActiveLayers(activeLayers) {
        this.activeLayers = [
            ...new Set(activeLayers)
        ];
    }
    setBuildingFilter(filter) {
        this.buildingFilter = filter;
    }
    setAcceptedFiles(files) {
        this.acceptedFiles = files;
    }
    updateBuildingName(buildingId, buildingName) {
        const projectResult = (0, $4WgAH.default).resultMap.get(this.id);
        const newProjectResult = (0, $2QP2i._)({}, projectResult);
        const newResults = new Map((0, $4WgAH.default).resultMap);
        newProjectResult.buildings = newProjectResult.buildings.map((building)=>{
            return (0, $edHbI._)((0, $2QP2i._)({}, building), {
                name: building.id === buildingId ? buildingName : building.name
            });
        });
        newResults.set(this.id, newProjectResult);
        (0, $4WgAH.default).setResults(newResults);
        this.buildings = [
            ...this.buildings
        ].map((building)=>{
            if (building.id === buildingId) return (0, $edHbI._)((0, $2QP2i._)({}, building), {
                name: buildingName
            });
            return building;
        });
    }
    constructor(){
        (0, $cr2GM._)(this, "id", null);
        (0, $cr2GM._)(this, "name", "");
        (0, $cr2GM._)(this, "description", "");
        (0, $cr2GM._)(this, "filters", {});
        (0, $cr2GM._)(this, "acceptedFiles", []);
        (0, $cr2GM._)(this, "lat", "");
        (0, $cr2GM._)(this, "lon", "");
        (0, $cr2GM._)(this, "address", "");
        (0, $cr2GM._)(this, "color", "");
        (0, $cr2GM._)(this, "files", []);
        (0, $cr2GM._)(this, "executiveSummaryFileId", null);
        (0, $cr2GM._)(this, "tasks", []);
        (0, $cr2GM._)(this, "financials", null);
        (0, $cr2GM._)(this, "resultMap", new Map());
        (0, $cr2GM._)(this, "survey", []);
        (0, $cr2GM._)(this, "groupId", null);
        (0, $cr2GM._)(this, "buildingFilter", null);
        (0, $cr2GM._)(this, "members", []);
        (0, $cr2GM._)(this, "buildings", []);
        (0, $cr2GM._)(this, "activeLayers", []);
        (0, $cr2GM._)(this, "layers", []);
        (0, $cr2GM._)(this, "isLoading", false);
        (0, $cr2GM._)(this, "projectBuildingRegistry", new Map());
        (0, $cr2GM._)(this, "bbox", null);
        (0, $cr2GM._)(this, "pickedResults", new Set());
        (0, $cr2GM._)(this, "vendors", []);
        (0, $cr2GM._)(this, "isVendor", false);
        (0, $cr2GM._)(this, "proposals", []);
        (0, $cr2GM._)(this, "termsAccepted", true);
        (0, $cr2GM._)(this, "infoMessage", "");
        (0, $cr2GM._)(this, "seen", "none");
        (0, $cr2GM._)(this, "terms", null);
        (0, $cr2GM._)(this, "status", "in_progress");
        (0, $cr2GM._)(this, "vendor", null);
        (0, $cr2GM._)(this, "variant", "large");
        (0, $cr2GM._)(this, "headerInfo", null);
        (0, $cr2GM._)(this, "headerVariant", "map");
        (0, $cr2GM._)(this, "infoMessageOpen", false);
        (0, $cr2GM._)(this, "buildingOsmIds", new Set());
        (0, $cr2GM._)(this, "created", null);
        (0, $cr2GM._)(this, "proposalMessage", "");
        (0, $cr2GM._)(this, "contactMessage", "");
        (0, $cr2GM._)(this, "customerName", "");
        (0, $cr2GM._)(this, "proposalDeadline", "");
        (0, $cr2GM._)(this, "rfpQuestions", []);
        (0, $cr2GM._)(this, "technologies", [
            {
                id: "solar",
                label: "Solar"
            },
            {
                id: "chp",
                label: "Combined Heat and Power"
            },
            {
                id: "fuelcell",
                label: "Fuel Cell"
            },
            {
                id: "storage",
                label: "Storage"
            },
            {
                id: "efficiency",
                label: "Energy Efficiency"
            },
            {
                id: "other",
                label: "Other"
            }
        ]);
        (0, $cr2GM._)(this, "recommendations", {
            chp: 0,
            solar: 0,
            storage: 0,
            fuel_cell: 0
        });
        (0, $cr2GM._)(this, "loadProject", async (projectId)=>{
            this.isLoading = true;
            const project = await (0, $4WgAH.default).loadProject(projectId);
            if (project) {
                this.variant = "large";
                this.headerVariant = "map";
                this.id = project.id;
                this.financials = null;
                this.name = project.name;
                this.buildingFilter = null;
                this.financials = project.financials;
                this.description = project.description;
                this.color = project.color;
                this.files = project.files;
                this.tasks = project.tasks;
                this.address = project.address;
                this.lat = project.lat;
                this.lon = project.lon;
                this.survey = project.survey;
                this.members = project.members;
                this.layers = project.layers;
                this.created = project.created;
                this.filters = project.filters;
                this.proposalDeadline = project.proposal_deadline_at;
                this.executiveSummaryFileId = project.executive_summary_file_id;
                this.customerName = project.customer_name;
                this.proposalMessage = project.markdown_proposal_message;
                this.contactMessage = project.markdown_proposal_contact;
                this.bbox = project.bbox;
                this.vendors = project.vendors;
                this.groupId = project.group_id;
                this.isVendor = project.is_vendor;
                this.proposals = project.proposals;
                this.termsAccepted = project.terms_accepted;
                this.seen = project.seen;
                this.infoMessage = project.info_message;
                this.status = project.status;
                this.vendor = null;
                this.terms = project.terms;
                this.recommendations = project.recommendations;
                if (this.isVendor) this.setVendor((0, $brBQs.default).user.group);
                if (!this.termsAccepted) {
                    this.isLoading = false;
                    return null;
                }
                this.setBuildings(project.buildings);
                this.buildingOsmIds = new Set(project.buildings.map((building)=>building.original_id));
                const fetchBuildings = async ()=>{
                    const response = await (0, $lxEiN.default).Project.getProjectBuildings(this.id);
                    const { data: data, financials: financials } = response.data;
                    if (financials) this.setFinancials(financials);
                    if (data.every((building)=>building.financials)) this.setBuildings(data);
                    if (!this.financialsCalculated) setTimeout(fetchBuildings, 5000);
                };
                if (!this.financialsCalculated) fetchBuildings();
                this.isLoading = false;
                return project;
            }
            this.isLoading = false;
            return null;
        });
        (0, $cr2GM._)(this, "loadBuildings", async ()=>{
            const response = await (0, $lxEiN.default).Project.getProjectBuildings(this.id);
            const { data: data, financials: financials } = response.data;
            this.setBuildings(data);
            if (financials) this.setFinancials(financials);
            if (data.every((building)=>building.financials)) return data;
            return false;
        });
        (0, $cr2GM._)(this, "setName", (name)=>{
            this.name = name;
            (0, $lxEiN.default).Project.updateProject(this.id, {
                name: name
            });
            const resultMap = new Map((0, $4WgAH.default).resultMap);
            const result = resultMap.get(this.id);
            if (result) {
                resultMap.set(this.id, (0, $edHbI._)((0, $2QP2i._)({}, result), {
                    name: name
                }));
                (0, $4WgAH.default).setResults(resultMap);
            }
        });
        (0, $cr2GM._)(this, "setHeaderVariant", (variant)=>{
            this.headerVariant = variant;
        });
        (0, $cr2GM._)(this, "setHeaderInfo", (data)=>{
            this.headerInfo = data;
        });
        (0, $cr2GM._)(this, "getProjectFilters", ()=>{
            const { filters: filters } = this;
            const newPopularRangeFilters = JSON.parse(JSON.stringify((0, $2QP2i._)({}, (0, $WXYRR.POPULAR_RANGE_FILTERS))));
            const newRangeFilters = JSON.parse(JSON.stringify((0, $2QP2i._)({}, (0, $WXYRR.RANGE_FILTERS))));
            Object.entries(filters).forEach(([key, value])=>{
                Object.entries(newRangeFilters).forEach(([title, filters])=>{
                    const idx = filters.findIndex((f)=>f.name === key);
                    if (idx !== -1) {
                        if (value.min === null || value.max === null) newRangeFilters[title][idx].isVisible = false;
                        else newRangeFilters[title][idx] = (0, $edHbI._)((0, $2QP2i._)({}, newRangeFilters[title][idx]), {
                            start: value.min,
                            end: value.max
                        });
                    }
                });
            });
            // remove empty categories
            Object.entries(newRangeFilters).forEach(([key, value])=>{
                if (value.every((f)=>f.isVisible === false)) delete newRangeFilters[key];
            });
            Object.entries(filters).forEach(([key, value])=>{
                const idx = newPopularRangeFilters.popular.findIndex((f)=>f.name === key);
                if (idx !== -1) newPopularRangeFilters.popular[idx] = (0, $edHbI._)((0, $2QP2i._)({}, newPopularRangeFilters.popular[idx]), {
                    start: value.min,
                    end: value.max
                });
            });
            return {
                popular: newPopularRangeFilters,
                rangeFilters: newRangeFilters
            };
        });
        (0, $cr2GM._)(this, "setFilters", (projectFilters)=>{
            this.filters = projectFilters;
        });
        (0, $cr2GM._)(this, "setBuildings", (buildings)=>{
            this.buildings = buildings.map((building)=>{
                return (0, $edHbI._)((0, $2QP2i._)({}, building), {
                    // financials: null,
                    formatted_financials: building.financials ? (0, $ht0W2.formatBuildingFinancials)(building.financials) : null
                });
            });
        });
        (0, $cr2GM._)(this, "loadResult", async (ids)=>{
            if (!ids.length) return;
            // Set state to loading
            ids.forEach((id)=>{
                this.resultMap.set(id, 1);
            });
            const response = await (0, $lxEiN.default).Project.getProjectBuildings(this.id);
            response.data.data.forEach((building)=>{
                this.resultMap.set(building.id, (0, $edHbI._)((0, $2QP2i._)({}, building), {
                    formatted_financials: building.financials ? (0, $ht0W2.formatBuildingFinancials)(building.financials) : null
                }));
            });
            return response.data.data;
        });
        (0, $cr2GM._)(this, "setDescription", (description)=>{
            this.description = description;
        });
        (0, $cr2GM._)(this, "addFile", (file)=>{
            const newFiles = [
                ...this.files,
                file
            ];
            this.files = newFiles;
        });
        (0, $cr2GM._)(this, "setFileId", (fileTempId, fileId)=>{
            const index = this.files.findIndex((file)=>file.id === fileTempId);
            if (index > -1) this.files[index].id = fileId;
        });
        (0, $cr2GM._)(this, "setTerms", (terms)=>{
            this.terms = terms;
        });
        (0, $cr2GM._)(this, "deleteFiles", async (fileIds)=>{
            this.files = [
                ...this.files
            ].filter((file)=>!fileIds.includes(file.id));
            await (0, $lxEiN.default).Workspace.delete(fileIds);
        });
        (0, $cr2GM._)(this, "removeBuilding", async (buildingId)=>{
            this.buildings = [
                ...this.buildings
            ].filter((building)=>building.id !== buildingId);
        });
        (0, $cr2GM._)(this, "addFiles", async (fileIds, buildingId)=>{
            await (0, $lxEiN.default).Project.addFiles(this.id, fileIds, buildingId);
        });
        (0, $cr2GM._)(this, "addProposals", async (fileIds)=>{
            await (0, $lxEiN.default).Project.addProposals(this.id, fileIds);
        });
        (0, $cr2GM._)(this, "setMembers", async (members)=>{
            this.members = members;
            await (0, $lxEiN.default).Project.addMembers(this.id, {
                data: members.map(({ id: id })=>id)
            });
        });
        (0, $cr2GM._)(this, "setVendors", async (vendors)=>{
            this.vendors = vendors;
        });
        (0, $cr2GM._)(this, "getVendors", async ()=>{
            const response = await (0, $lxEiN.default).Project.getProjectVendors(this.id);
            this.setVendors(response.data.data);
        });
        (0, $cr2GM._)(this, "removeVendor", async (groupId)=>{
            await (0, $lxEiN.default).Project.removeVendor(this.id, groupId);
            const newVendors = this.vendors.filter((vendor)=>vendor.id !== groupId);
            this.setVendors(newVendors);
        });
        (0, $cr2GM._)(this, "addVendor", async (groupIdLike)=>{
            const { data: data } = await (0, $lxEiN.default).Project.addVendor(this.id, groupIdLike);
            const newVendors = [
                ...this.vendors,
                data
            ];
            this.setVendors(newVendors);
        });
        (0, $cr2GM._)(this, "inviteVendorByEmail", async (email)=>{
            await (0, $lxEiN.default).Project.inviteVendor(this.id, email);
        });
        (0, $cr2GM._)(this, "submit", ()=>{
            const data = {
                title: this.title,
                description: this.description,
                users: this.users,
                files: this.files,
                project_id: this.project_id
            };
            if (this.id) data.id = this.id;
        });
        (0, $cr2GM._)(this, "acceptTerms", async (projectId, terms)=>{
            var _response_data_err;
            const data = JSON.parse(JSON.stringify(terms || this.terms));
            const response = await (0, $3U8SM.default).post(`/project/${projectId || this.id}/accept`, data);
            if (((_response_data_err = response.data.err) === null || _response_data_err === void 0 ? void 0 : _response_data_err.code) === "terms_updated") {
                this.setTerms(response.data.data);
                return false;
            }
            this.termsAccepted = true;
            return true;
        });
        (0, $cr2GM._)(this, "setTermsAccepted", (termsAccepted)=>{
            this.termsAccepted = termsAccepted;
        });
        (0, $cr2GM._)(this, "acceptInfoMessage", async ()=>{
            (0, $lxEiN.default).Project.acceptInfoMessage(this.id);
        });
        (0, $cr2GM._)(this, "setRFPQuestionActive", (questionId, isActive)=>{
            this.rfpQuestions = this.rfpQuestions.map((q)=>{
                if (q.question_id === questionId) return (0, $edHbI._)((0, $2QP2i._)({}, q), {
                    is_active: isActive
                });
                return q;
            });
            (0, $lxEiN.default).Project.updateProjectRFPQuestion(this.id, questionId, {
                is_active: isActive
            });
        });
        (0, $cr2GM._)(this, "loadRFPQuestions", async ()=>{
            const { data: data } = await (0, $lxEiN.default).Project.getProjectRFPQuestions(this.id);
            this.setRFPQuestions(data.data);
        });
        (0, $cr2GM._)(this, "deleteRFPQuestion", async (questionId)=>{
            await (0, $lxEiN.default).Project.deleteProjectRFPQuestion(this.id, questionId);
        });
        (0, $cr2GM._)(this, "getFinancials", async (projectId)=>{
            const { data: data } = await (0, $lxEiN.default).Project.getProjectFinancials(projectId || this.id, this.id);
            this.financials = data.data;
        });
        (0, $cr2GM._)(this, "getLayers", async ()=>{
            const response = await (0, $lxEiN.default).Project.getProjectLayers(this.id);
            this.layers = response.data.data;
        });
        (0, $cr2GM._)(this, "loadProposals", async ()=>{
            const response = await (0, $lxEiN.default).Project.getProposals(this.id);
            this.setProposals(response.data.data);
        });
        (0, $cr2GM._)(this, "deleteProposal", async (proposalId)=>{
            await (0, $lxEiN.default).Project.deleteProposal(this.id, proposalId);
        });
        (0, $cr2GM._)(this, "waitProjectReady", async (onProgress = ()=>{
            return 0;
        }, timeout = 600000)=>{
            return new Promise((resolve)=>{
                const interval = setInterval(async ()=>{
                    const status = await this.getStatus();
                    const totalProgress = status.progress + 10 <= 100 ? status.progress + 10 : status.progress;
                    onProgress(totalProgress);
                    if (status.progress === 100) {
                        const buildings = await this.loadBuildings();
                        if (buildings) {
                            clearInterval(interval);
                            resolve();
                        }
                    }
                }, 5000);
                setTimeout(()=>{
                    clearInterval(interval);
                    resolve();
                }, timeout);
            });
        });
        (0, $cr2GM._)(this, "getStatus", async ()=>{
            const response = await (0, $lxEiN.default).Project.getStatus(this.id);
            return response.data;
        });
        (0, $cr2GM._)(this, "getProjectBuildingByOsmId", (osmIdLike)=>{
            if (!osmIdLike) return null;
            return this.buildings.find((building)=>{
                const osmId = osmIdLike.replace("osm-", "").toUpperCase();
                console.log("INCLUDES", building.original_id, osmId);
                return building.original_id.includes(osmId);
            });
        });
        (0, $cr2GM._)(this, "hasBuildingWithOsmId", (osmIdLike)=>{
            if (!osmIdLike) return false;
            const osmId = osmIdLike.replace("osm-", "").toUpperCase();
            return this.buildingOsmIds.has(osmId);
        });
        (0, $cr2GM._)(this, "setInfoMessageOpen", (open)=>{
            this.infoMessageOpen = open;
        });
        (0, $gOgWf.makeObservable)(this, {
            id: (0, $gOgWf.observable),
            name: (0, $gOgWf.observable),
            description: (0, $gOgWf.observable),
            resultMap: (0, $gOgWf.observable),
            financials: (0, $gOgWf.observable),
            lat: (0, $gOgWf.observable),
            lon: (0, $gOgWf.observable),
            address: (0, $gOgWf.observable),
            rfpQuestions: (0, $gOgWf.observable),
            color: (0, $gOgWf.observable),
            files: (0, $gOgWf.observable),
            layers: (0, $gOgWf.observable),
            tasks: (0, $gOgWf.observable),
            survey: (0, $gOgWf.observable),
            groupId: (0, $gOgWf.observable),
            members: (0, $gOgWf.observable),
            buildings: (0, $gOgWf.observable),
            isLoading: (0, $gOgWf.observable),
            acceptedFiles: (0, $gOgWf.observable),
            infoMessageOpen: (0, $gOgWf.observable),
            proposalMessage: (0, $gOgWf.observable),
            executiveSummaryFileId: (0, $gOgWf.observable),
            contactMessage: (0, $gOgWf.observable),
            customerName: (0, $gOgWf.observable),
            proposalDeadline: (0, $gOgWf.observable),
            projectBuildingRegistry: (0, $gOgWf.observable),
            bbox: (0, $gOgWf.observable),
            vendors: (0, $gOgWf.observable),
            isVendor: (0, $gOgWf.observable),
            proposals: (0, $gOgWf.observable),
            termsAccepted: (0, $gOgWf.observable),
            buildingFilter: (0, $gOgWf.observable),
            filters: (0, $gOgWf.observable),
            terms: (0, $gOgWf.observable),
            infoMessage: (0, $gOgWf.observable),
            seen: (0, $gOgWf.observable),
            status: (0, $gOgWf.observable),
            vendor: (0, $gOgWf.observable),
            variant: (0, $gOgWf.observable),
            headerInfo: (0, $gOgWf.observable),
            headerVariant: (0, $gOgWf.observable),
            recommendations: (0, $gOgWf.observable),
            activeLayers: (0, $gOgWf.observable),
            loadProject: (0, $gOgWf.action),
            setTermsAccepted: (0, $gOgWf.action),
            setInfoMessageOpen: (0, $gOgWf.action),
            setName: (0, $gOgWf.action),
            setHeaderVariant: (0, $gOgWf.action),
            setHeaderInfo: (0, $gOgWf.action),
            setBuildings: (0, $gOgWf.action),
            setDescription: (0, $gOgWf.action),
            addFile: (0, $gOgWf.action),
            financialsCalculated: (0, $gOgWf.computed),
            filteredBuildings: (0, $gOgWf.computed),
            setFileId: (0, $gOgWf.action),
            deleteFiles: (0, $gOgWf.action),
            setFilters: (0, $gOgWf.action),
            removeBuilding: (0, $gOgWf.action),
            addFiles: (0, $gOgWf.action),
            addProposals: (0, $gOgWf.action),
            setMembers: (0, $gOgWf.action),
            setVendors: (0, $gOgWf.action),
            selectedVendors: (0, $gOgWf.computed),
            addBuilding: (0, $gOgWf.action),
            submit: (0, $gOgWf.action),
            acceptTerms: (0, $gOgWf.action),
            acceptInfoMessage: (0, $gOgWf.action),
            setInfoMessage: (0, $gOgWf.action),
            setTerms: (0, $gOgWf.action),
            setStatus: (0, $gOgWf.action),
            setVendor: (0, $gOgWf.action),
            setVariant: (0, $gOgWf.action),
            updateBuildingName: (0, $gOgWf.action)
        });
    }
}
const $f10f02d5413fc340$var$store = new $f10f02d5413fc340$var$Store();
var $f10f02d5413fc340$export$2e2bcd8739ae039 = $f10f02d5413fc340$var$store;

});
parcelRegister("drY2b", function(module, exports) {

var $horFy = parcelRequire("horFy");

var $7GKQS = parcelRequire("7GKQS");

var $7aiSl = parcelRequire("7aiSl");

var $lX3Ya = parcelRequire("lX3Ya");
var $9cac5d8732cbc60d$require$turfBBox = $lX3Ya.default;
var $9cac5d8732cbc60d$var$featureEach = $7aiSl.featureEach;
var $9cac5d8732cbc60d$var$coordEach = $7aiSl.coordEach;
var $9cac5d8732cbc60d$var$polygon = $7GKQS.polygon;
var $9cac5d8732cbc60d$var$featureCollection = $7GKQS.featureCollection;
/**
 * GeoJSON implementation of [RBush](https://github.com/mourner/rbush#rbush) spatial index.
 *
 * @name rbush
 * @param {number} [maxEntries=9] defines the maximum number of entries in a tree node. 9 (used by default) is a
 * reasonable choice for most applications. Higher value means faster insertion and slower search, and vice versa.
 * @returns {RBush} GeoJSON RBush
 * @example
 * var geojsonRbush = require('geojson-rbush').default;
 * var tree = geojsonRbush();
 */ function $9cac5d8732cbc60d$var$geojsonRbush(maxEntries) {
    var tree = new $horFy(maxEntries);
    /**
     * [insert](https://github.com/mourner/rbush#data-format)
     *
     * @param {Feature} feature insert single GeoJSON Feature
     * @returns {RBush} GeoJSON RBush
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     * tree.insert(poly)
     */ tree.insert = function(feature) {
        if (feature.type !== "Feature") throw new Error("invalid feature");
        feature.bbox = feature.bbox ? feature.bbox : $9cac5d8732cbc60d$require$turfBBox(feature);
        return $horFy.prototype.insert.call(this, feature);
    };
    /**
     * [load](https://github.com/mourner/rbush#bulk-inserting-data)
     *
     * @param {FeatureCollection|Array<Feature>} features load entire GeoJSON FeatureCollection
     * @returns {RBush} GeoJSON RBush
     * @example
     * var polys = turf.polygons([
     *     [[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]],
     *     [[[-93, 32], [-83, 32], [-83, 39], [-93, 39], [-93, 32]]]
     * ]);
     * tree.load(polys);
     */ tree.load = function(features) {
        var load = [];
        // Load an Array of Features
        if (Array.isArray(features)) features.forEach(function(feature) {
            if (feature.type !== "Feature") throw new Error("invalid features");
            feature.bbox = feature.bbox ? feature.bbox : $9cac5d8732cbc60d$require$turfBBox(feature);
            load.push(feature);
        });
        else // Load a FeatureCollection
        $9cac5d8732cbc60d$var$featureEach(features, function(feature) {
            if (feature.type !== "Feature") throw new Error("invalid features");
            feature.bbox = feature.bbox ? feature.bbox : $9cac5d8732cbc60d$require$turfBBox(feature);
            load.push(feature);
        });
        return $horFy.prototype.load.call(this, load);
    };
    /**
     * [remove](https://github.com/mourner/rbush#removing-data)
     *
     * @param {Feature} feature remove single GeoJSON Feature
     * @param {Function} equals Pass a custom equals function to compare by value for removal.
     * @returns {RBush} GeoJSON RBush
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.remove(poly);
     */ tree.remove = function(feature, equals) {
        if (feature.type !== "Feature") throw new Error("invalid feature");
        feature.bbox = feature.bbox ? feature.bbox : $9cac5d8732cbc60d$require$turfBBox(feature);
        return $horFy.prototype.remove.call(this, feature, equals);
    };
    /**
     * [clear](https://github.com/mourner/rbush#removing-data)
     *
     * @returns {RBush} GeoJSON Rbush
     * @example
     * tree.clear()
     */ tree.clear = function() {
        return $horFy.prototype.clear.call(this);
    };
    /**
     * [search](https://github.com/mourner/rbush#search)
     *
     * @param {BBox|FeatureCollection|Feature} geojson search with GeoJSON
     * @returns {FeatureCollection} all features that intersects with the given GeoJSON.
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.search(poly);
     */ tree.search = function(geojson) {
        var features = $horFy.prototype.search.call(this, this.toBBox(geojson));
        return $9cac5d8732cbc60d$var$featureCollection(features);
    };
    /**
     * [collides](https://github.com/mourner/rbush#collisions)
     *
     * @param {BBox|FeatureCollection|Feature} geojson collides with GeoJSON
     * @returns {boolean} true if there are any items intersecting the given GeoJSON, otherwise false.
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.collides(poly);
     */ tree.collides = function(geojson) {
        return $horFy.prototype.collides.call(this, this.toBBox(geojson));
    };
    /**
     * [all](https://github.com/mourner/rbush#search)
     *
     * @returns {FeatureCollection} all the features in RBush
     * @example
     * tree.all()
     */ tree.all = function() {
        var features = $horFy.prototype.all.call(this);
        return $9cac5d8732cbc60d$var$featureCollection(features);
    };
    /**
     * [toJSON](https://github.com/mourner/rbush#export-and-import)
     *
     * @returns {any} export data as JSON object
     * @example
     * var exported = tree.toJSON()
     */ tree.toJSON = function() {
        return $horFy.prototype.toJSON.call(this);
    };
    /**
     * [fromJSON](https://github.com/mourner/rbush#export-and-import)
     *
     * @param {any} json import previously exported data
     * @returns {RBush} GeoJSON RBush
     * @example
     * var exported = {
     *   "children": [
     *     {
     *       "type": "Feature",
     *       "geometry": {
     *         "type": "Point",
     *         "coordinates": [110, 50]
     *       },
     *       "properties": {},
     *       "bbox": [110, 50, 110, 50]
     *     }
     *   ],
     *   "height": 1,
     *   "leaf": true,
     *   "minX": 110,
     *   "minY": 50,
     *   "maxX": 110,
     *   "maxY": 50
     * }
     * tree.fromJSON(exported)
     */ tree.fromJSON = function(json) {
        return $horFy.prototype.fromJSON.call(this, json);
    };
    /**
     * Converts GeoJSON to {minX, minY, maxX, maxY} schema
     *
     * @private
     * @param {BBox|FeatureCollection|Feature} geojson feature(s) to retrieve BBox from
     * @returns {Object} converted to {minX, minY, maxX, maxY}
     */ tree.toBBox = function(geojson) {
        var bbox;
        if (geojson.bbox) bbox = geojson.bbox;
        else if (Array.isArray(geojson) && geojson.length === 4) bbox = geojson;
        else if (Array.isArray(geojson) && geojson.length === 6) bbox = [
            geojson[0],
            geojson[1],
            geojson[3],
            geojson[4]
        ];
        else if (geojson.type === "Feature") bbox = $9cac5d8732cbc60d$require$turfBBox(geojson);
        else if (geojson.type === "FeatureCollection") bbox = $9cac5d8732cbc60d$require$turfBBox(geojson);
        else throw new Error("invalid geojson");
        return {
            minX: bbox[0],
            minY: bbox[1],
            maxX: bbox[2],
            maxY: bbox[3]
        };
    };
    return tree;
}
module.exports = $9cac5d8732cbc60d$var$geojsonRbush;
module.exports.default = $9cac5d8732cbc60d$var$geojsonRbush;

});
parcelRegister("horFy", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});

});

parcelRegister("7GKQS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ module.exports.earthRadius = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 *
 * @memberof helpers
 * @type {Object}
 */ module.exports.factors = {
    centimeters: module.exports.earthRadius * 100,
    centimetres: module.exports.earthRadius * 100,
    degrees: module.exports.earthRadius / 111325,
    feet: module.exports.earthRadius * 3.28084,
    inches: module.exports.earthRadius * 39.370,
    kilometers: module.exports.earthRadius / 1000,
    kilometres: module.exports.earthRadius / 1000,
    meters: module.exports.earthRadius,
    metres: module.exports.earthRadius,
    miles: module.exports.earthRadius / 1609.344,
    millimeters: module.exports.earthRadius * 1000,
    millimetres: module.exports.earthRadius * 1000,
    nauticalmiles: module.exports.earthRadius / 1852,
    radians: 1,
    yards: module.exports.earthRadius / 1.0936
};
/**
 * Units of measurement factors based on 1 meter.
 *
 * @memberof helpers
 * @type {Object}
 */ module.exports.unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.370,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / module.exports.earthRadius,
    yards: 1 / 1.0936
};
/**
 * Area of measurement factors based on 1 square meter.
 *
 * @memberof helpers
 * @type {Object}
 */ module.exports.areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $5990cc70d091eed0$var$feature(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
module.exports.feature = $5990cc70d091eed0$var$feature;
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */ function $5990cc70d091eed0$var$geometry(type, coordinates, options) {
    if (options === void 0) options = {};
    switch(type){
        case "Point":
            return $5990cc70d091eed0$var$point(coordinates).geometry;
        case "LineString":
            return $5990cc70d091eed0$var$lineString(coordinates).geometry;
        case "Polygon":
            return $5990cc70d091eed0$var$polygon(coordinates).geometry;
        case "MultiPoint":
            return $5990cc70d091eed0$var$multiPoint(coordinates).geometry;
        case "MultiLineString":
            return $5990cc70d091eed0$var$multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return $5990cc70d091eed0$var$multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
module.exports.geometry = $5990cc70d091eed0$var$geometry;
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $5990cc70d091eed0$var$point(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $5990cc70d091eed0$var$feature(geom, properties, options);
}
module.exports.point = $5990cc70d091eed0$var$point;
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $5990cc70d091eed0$var$points(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $5990cc70d091eed0$var$featureCollection(coordinates.map(function(coords) {
        return $5990cc70d091eed0$var$point(coords, properties);
    }), options);
}
module.exports.points = $5990cc70d091eed0$var$points;
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $5990cc70d091eed0$var$polygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $5990cc70d091eed0$var$feature(geom, properties, options);
}
module.exports.polygon = $5990cc70d091eed0$var$polygon;
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $5990cc70d091eed0$var$polygons(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $5990cc70d091eed0$var$featureCollection(coordinates.map(function(coords) {
        return $5990cc70d091eed0$var$polygon(coords, properties);
    }), options);
}
module.exports.polygons = $5990cc70d091eed0$var$polygons;
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $5990cc70d091eed0$var$lineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $5990cc70d091eed0$var$feature(geom, properties, options);
}
module.exports.lineString = $5990cc70d091eed0$var$lineString;
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $5990cc70d091eed0$var$lineStrings(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $5990cc70d091eed0$var$featureCollection(coordinates.map(function(coords) {
        return $5990cc70d091eed0$var$lineString(coords, properties);
    }), options);
}
module.exports.lineStrings = $5990cc70d091eed0$var$lineStrings;
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $5990cc70d091eed0$var$featureCollection(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
module.exports.featureCollection = $5990cc70d091eed0$var$featureCollection;
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $5990cc70d091eed0$var$multiLineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $5990cc70d091eed0$var$feature(geom, properties, options);
}
module.exports.multiLineString = $5990cc70d091eed0$var$multiLineString;
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $5990cc70d091eed0$var$multiPoint(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $5990cc70d091eed0$var$feature(geom, properties, options);
}
module.exports.multiPoint = $5990cc70d091eed0$var$multiPoint;
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $5990cc70d091eed0$var$multiPolygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $5990cc70d091eed0$var$feature(geom, properties, options);
}
module.exports.multiPolygon = $5990cc70d091eed0$var$multiPolygon;
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */ function $5990cc70d091eed0$var$geometryCollection(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $5990cc70d091eed0$var$feature(geom, properties, options);
}
module.exports.geometryCollection = $5990cc70d091eed0$var$geometryCollection;
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $5990cc70d091eed0$var$round(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
module.exports.round = $5990cc70d091eed0$var$round;
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $5990cc70d091eed0$var$radiansToLength(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = module.exports.factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
module.exports.radiansToLength = $5990cc70d091eed0$var$radiansToLength;
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $5990cc70d091eed0$var$lengthToRadians(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = module.exports.factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
module.exports.lengthToRadians = $5990cc70d091eed0$var$lengthToRadians;
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $5990cc70d091eed0$var$lengthToDegrees(distance, units) {
    return $5990cc70d091eed0$var$radiansToDegrees($5990cc70d091eed0$var$lengthToRadians(distance, units));
}
module.exports.lengthToDegrees = $5990cc70d091eed0$var$lengthToDegrees;
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $5990cc70d091eed0$var$bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
module.exports.bearingToAzimuth = $5990cc70d091eed0$var$bearingToAzimuth;
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $5990cc70d091eed0$var$radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
module.exports.radiansToDegrees = $5990cc70d091eed0$var$radiansToDegrees;
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $5990cc70d091eed0$var$degreesToRadians(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
module.exports.degreesToRadians = $5990cc70d091eed0$var$degreesToRadians;
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */ function $5990cc70d091eed0$var$convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $5990cc70d091eed0$var$radiansToLength($5990cc70d091eed0$var$lengthToRadians(length, originalUnit), finalUnit);
}
module.exports.convertLength = $5990cc70d091eed0$var$convertLength;
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted distance
 */ function $5990cc70d091eed0$var$convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = module.exports.areaFactors[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = module.exports.areaFactors[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
module.exports.convertArea = $5990cc70d091eed0$var$convertArea;
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $5990cc70d091eed0$var$isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num) && !/^\s*$/.test(num);
}
module.exports.isNumber = $5990cc70d091eed0$var$isNumber;
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $5990cc70d091eed0$var$isObject(input) {
    return !!input && input.constructor === Object;
}
module.exports.isObject = $5990cc70d091eed0$var$isObject;
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $5990cc70d091eed0$var$validateBBox(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$5990cc70d091eed0$var$isNumber(num)) throw new Error("bbox must only contain numbers");
    });
}
module.exports.validateBBox = $5990cc70d091eed0$var$validateBBox;
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $5990cc70d091eed0$var$validateId(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
module.exports.validateId = $5990cc70d091eed0$var$validateId;
// Deprecated methods
function $5990cc70d091eed0$var$radians2degrees() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
module.exports.radians2degrees = $5990cc70d091eed0$var$radians2degrees;
function $5990cc70d091eed0$var$degrees2radians() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
module.exports.degrees2radians = $5990cc70d091eed0$var$degrees2radians;
function $5990cc70d091eed0$var$distanceToDegrees() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
module.exports.distanceToDegrees = $5990cc70d091eed0$var$distanceToDegrees;
function $5990cc70d091eed0$var$distanceToRadians() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
module.exports.distanceToRadians = $5990cc70d091eed0$var$distanceToRadians;
function $5990cc70d091eed0$var$radiansToDistance() {
    throw new Error("method has been renamed to `radiansToLength`");
}
module.exports.radiansToDistance = $5990cc70d091eed0$var$radiansToDistance;
function $5990cc70d091eed0$var$bearingToAngle() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
module.exports.bearingToAngle = $5990cc70d091eed0$var$bearingToAngle;
function $5990cc70d091eed0$var$convertDistance() {
    throw new Error("method has been renamed to `convertLength`");
}
module.exports.convertDistance = $5990cc70d091eed0$var$convertDistance;

});

parcelRegister("7aiSl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $53781bdc68c68893$var$coordEach(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($53781bdc68c68893$var$coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $53781bdc68c68893$var$coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $53781bdc68c68893$var$coordEach(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $53781bdc68c68893$var$propEach(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $53781bdc68c68893$var$propReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $53781bdc68c68893$var$propEach(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $53781bdc68c68893$var$featureEach(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $53781bdc68c68893$var$featureReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $53781bdc68c68893$var$featureEach(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $53781bdc68c68893$var$coordAll(geojson) {
    var coords = [];
    $53781bdc68c68893$var$coordEach(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $53781bdc68c68893$var$geomEach(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $53781bdc68c68893$var$geomReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $53781bdc68c68893$var$geomEach(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $53781bdc68c68893$var$flattenEach(geojson, callback) {
    $53781bdc68c68893$var$geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback($7GKQS.feature(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback($7GKQS.feature(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $53781bdc68c68893$var$flattenReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $53781bdc68c68893$var$flattenEach(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $53781bdc68c68893$var$segmentEach(geojson, callback) {
    $53781bdc68c68893$var$flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($53781bdc68c68893$var$coordEach(feature, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = $7GKQS.lineString([
                previousCoords,
                currentCoord
            ], feature.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentInex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $53781bdc68c68893$var$segmentReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $53781bdc68c68893$var$segmentEach(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $53781bdc68c68893$var$lineEach(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $53781bdc68c68893$var$flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
        if (feature.geometry === null) return;
        var type = feature.geometry.type;
        var coords = feature.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback($7GKQS.lineString(coords[geometryIndex], feature.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $53781bdc68c68893$var$lineReduce(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $53781bdc68c68893$var$lineEach(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $53781bdc68c68893$var$findSegment(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!$7GKQS.isObject(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return $7GKQS.lineString([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return $7GKQS.lineString([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return $7GKQS.lineString([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return $7GKQS.lineString([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $53781bdc68c68893$var$findPoint(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!$7GKQS.isObject(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return $7GKQS.point(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return $7GKQS.point(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return $7GKQS.point(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return $7GKQS.point(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return $7GKQS.point(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return $7GKQS.point(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}
module.exports.coordEach = $53781bdc68c68893$var$coordEach;
module.exports.coordReduce = $53781bdc68c68893$var$coordReduce;
module.exports.propEach = $53781bdc68c68893$var$propEach;
module.exports.propReduce = $53781bdc68c68893$var$propReduce;
module.exports.featureEach = $53781bdc68c68893$var$featureEach;
module.exports.featureReduce = $53781bdc68c68893$var$featureReduce;
module.exports.coordAll = $53781bdc68c68893$var$coordAll;
module.exports.geomEach = $53781bdc68c68893$var$geomEach;
module.exports.geomReduce = $53781bdc68c68893$var$geomReduce;
module.exports.flattenEach = $53781bdc68c68893$var$flattenEach;
module.exports.flattenReduce = $53781bdc68c68893$var$flattenReduce;
module.exports.segmentEach = $53781bdc68c68893$var$segmentEach;
module.exports.segmentReduce = $53781bdc68c68893$var$segmentReduce;
module.exports.lineEach = $53781bdc68c68893$var$lineEach;
module.exports.lineReduce = $53781bdc68c68893$var$lineReduce;
module.exports.findSegment = $53781bdc68c68893$var$findSegment;
module.exports.findPoint = $53781bdc68c68893$var$findPoint;

});

parcelRegister("lX3Ya", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7aiSl = parcelRequire("7aiSl");
/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */ function $ffb22fee903c1acf$var$bbox(geojson) {
    var result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    $7aiSl.coordEach(geojson, function(coord) {
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
module.exports.default = $ffb22fee903c1acf$var$bbox;

});


parcelRegister("WXYRR", function(module, exports) {

$parcel$export(module.exports, "RECOMMENDATION_FILTERS", function () { return $0b13f1d1c0c1464c$export$84b324ae0bc63ae0; });
$parcel$export(module.exports, "POPULAR_RANGE_FILTERS", function () { return $0b13f1d1c0c1464c$export$b25e85153698cb3b; });
$parcel$export(module.exports, "RANGE_FILTERS", function () { return $0b13f1d1c0c1464c$export$651f966db44568df; });
$parcel$export(module.exports, "BUILDING_CLASSES", function () { return $0b13f1d1c0c1464c$export$eb5dde5c73501199; });
$parcel$export(module.exports, "PROPERTY_SUMMARY_FILTERS", function () { return $0b13f1d1c0c1464c$export$286a7f607624d59e; });

var $5d5VO = parcelRequire("5d5VO");
const $0b13f1d1c0c1464c$var$currentYear = new Date().getFullYear();
const $0b13f1d1c0c1464c$export$84b324ae0bc63ae0 = [
    {
        icon: "sun",
        label: "Solar Recommendation",
        name: "recommendations.pv",
        min: 0,
        max: 3
    },
    {
        icon: "bulb",
        label: "CHP Recommendation",
        name: "recommendations.chp",
        min: 0,
        max: 3
    },
    {
        icon: "battery",
        label: "Battery Storage Recommendation",
        name: "recommendations.storage",
        min: 0,
        max: 3
    },
    {
        icon: "hydrogen",
        label: "Fuel Cell Recommendation",
        name: "recommendations.fuel_cell",
        min: 0,
        max: 3
    }
];
const $0b13f1d1c0c1464c$export$b25e85153698cb3b = {
    popular: [
        {
            name: "estimates_int.solar",
            label: "Solar Estimates",
            start: 0,
            end: 100,
            states: [
                "ny",
                "ma",
                "tx",
                "nj",
                "ct",
                "palau",
                "japan",
                "*"
            ],
            category: null
        },
        {
            name: "estimates_int.chp",
            label: "CHP Estimates",
            start: 0,
            end: 100,
            states: [
                "ny",
                "ma",
                "tx",
                "nj",
                "ct",
                "palau",
                "japan",
                "*"
            ],
            category: null
        },
        {
            name: "estimates_int.storage",
            label: "Battery Storage Estimates",
            start: 0,
            end: 100,
            states: [
                "ny",
                "ma",
                "tx",
                "nj",
                "ct",
                "palau",
                "japan",
                "*"
            ],
            category: null
        },
        {
            name: "estimates_int.fuel_cell",
            label: "Fuel Cell Estimates",
            start: 0,
            end: 100,
            states: [
                "ny",
                "ma",
                "tx",
                "nj",
                "ct",
                "palau",
                "japan",
                "*"
            ],
            category: null
        },
        {
            name: "der_score",
            label: "DER Adoption Potential",
            start: 0,
            end: 100,
            states: [
                "ny",
                "ma",
                "tx",
                "nj",
                "ct",
                "palau",
                "japan",
                "*"
            ],
            category: null
        }
    ],
    adv_popular: []
};
const $0b13f1d1c0c1464c$export$651f966db44568df = {
    "Financial Estimates": [
        {
            name: "financial_total_gross_project_cost",
            label: "Total Gross Project Cost",
            start: 0,
            end: 100000000,
            step: 1000,
            states: [
                "ny"
            ],
            category: "financial"
        },
        {
            name: "financial_irr",
            label: "IRR",
            start: 0,
            end: 1,
            step: 0.01,
            states: [
                "ny"
            ],
            category: "financial"
        },
        {
            name: "financial_payback_period",
            label: "Payback Period",
            start: 0,
            end: 10,
            step: 0.1,
            states: [
                "ny"
            ],
            category: "financial"
        },
        {
            name: "financial_net_present_value",
            label: "Net Present Value",
            start: 0,
            end: 10000000,
            step: 1000,
            states: [
                "ny"
            ],
            category: "financial"
        },
        {
            name: "financial_ppa_1st_year_savings_to_customer",
            label: "1st Year Savings",
            start: 0,
            end: 1000000,
            step: 1000,
            states: [
                "ny"
            ],
            category: "financial"
        },
        {
            name: "financial_ppa_kwh_rate",
            label: "PPA kWh Rate",
            start: 0,
            end: 0.5,
            step: 0.01,
            states: [
                "ny"
            ],
            category: "financial"
        }
    ],
    Energy: [
        {
            name: "ghg_emission_total",
            label: "GHG Emissions",
            start: 0,
            end: 1000000,
            states: [
                "ny"
            ],
            category: "energy"
        },
        {
            name: "energy_star_score",
            label: "Energy Star Rating",
            start: 0,
            end: 100,
            states: [
                "ny"
            ],
            category: "energy"
        },
        {
            name: "eui",
            label: "Energy Use Intensity",
            start: 0,
            end: 1000000,
            states: [
                "ny"
            ],
            category: "energy"
        }
    ],
    "Building profile": [
        {
            name: "building_far",
            label: "Floor Area Ratio",
            start: 0,
            end: 200,
            states: [
                "ny"
            ]
        },
        {
            name: "last_renovation",
            label: "Last Renovation",
            start: 1700,
            end: $0b13f1d1c0c1464c$var$currentYear,
            states: [
                "ny"
            ]
        },
        {
            name: "residential_units",
            label: "Residential Units",
            start: 0,
            end: 300,
            states: [
                "ny"
            ]
        }
    ]
};
const $0b13f1d1c0c1464c$export$d9b686cf96064644 = [
    {
        value: 1,
        label: "Manhattan",
        acronym: "mn"
    },
    {
        value: 3,
        label: "Brooklyn",
        acronym: "bk"
    },
    {
        value: 4,
        label: "Queens",
        acronym: "qu"
    },
    {
        value: 2,
        label: "The Bronx",
        acronym: "bx"
    },
    {
        value: 5,
        label: "Staten Island",
        acronym: "si"
    }
];
const $0b13f1d1c0c1464c$export$4be155fc44d57dc5 = [
    {
        value: "New York",
        label: "New York",
        acronym: "ny"
    },
    {
        value: "Connecticut",
        label: "Connecticut",
        acronym: "ct"
    },
    {
        value: "Massachusetts",
        label: "Massachusetts",
        acronym: "ma"
    },
    {
        value: "New Jersey",
        label: "New Jersey",
        acronym: "nj"
    },
    {
        value: "Texas",
        label: "Texas",
        acronym: "tx"
    },
    {
        value: "Palau",
        label: "Palau",
        acronym: "palau"
    },
    {
        value: "Japan",
        label: "Japan",
        acronym: "japan"
    }
];
const $0b13f1d1c0c1464c$export$e986372e7c5bc8b4 = [
    {
        value: "A",
        label: "One Family Dwelling"
    },
    {
        value: "B",
        label: "Two Family Dwelling"
    },
    {
        value: "C",
        label: "Walk Up Apartment"
    },
    {
        value: "D",
        label: "Elevator Apartment"
    },
    {
        value: "E",
        label: "Warehouse"
    },
    {
        value: "F",
        label: "Factory/Industrial Building"
    },
    {
        value: "G",
        label: "Garage or Gasoline Station"
    },
    {
        value: "H",
        label: "Hotel"
    },
    {
        value: "I",
        label: "Healthcare"
    },
    {
        value: "J",
        label: "Theatre"
    },
    {
        value: "K",
        label: "Retail"
    },
    {
        value: "L",
        label: "Loft Building"
    },
    {
        value: "M",
        label: "Religious Building"
    },
    {
        value: "N",
        label: "Asylum/Home"
    },
    {
        value: "O",
        label: "Office Building"
    },
    {
        value: "P",
        label: "Public Assembly Place"
    },
    {
        value: "Q",
        label: "Outdoor Recreation Facility"
    },
    {
        value: "R",
        label: "Condomonium"
    },
    {
        value: "S",
        label: "Mix-Use Residence"
    },
    {
        value: "T",
        label: "Transportation Facility"
    },
    {
        value: "U",
        label: "Utility"
    },
    {
        value: "V",
        label: "Vacant Land"
    },
    {
        value: "W",
        label: "Education"
    },
    {
        value: "Y",
        label: "Government Building"
    },
    {
        value: "Z",
        label: "Miscellaneous"
    }
].sort((a, b)=>a.label.toLowerCase().localeCompare(b.label, "en", {
        sensitivity: "base"
    }));
const $0b13f1d1c0c1464c$export$3c27ed10463c06fa = (0, $5d5VO.default);
const $0b13f1d1c0c1464c$export$eb5dde5c73501199 = [
    {
        label: "Power Station",
        value: "power_station"
    },
    {
        label: "Miscellaneous",
        value: "miscellaneous"
    },
    {
        label: "Arts Center",
        value: "art_center"
    },
    {
        label: "Bank",
        value: "bank"
    },
    {
        label: "Restaurant",
        value: "bar"
    },
    {
        label: "Bus Station",
        value: "bus_station"
    },
    {
        label: "Cafe",
        value: "cafe"
    },
    {
        label: "Car Service",
        value: "car_parts"
    },
    {
        label: "Car Rental",
        value: "car_rental"
    },
    {
        label: "Car Wash",
        value: "car_wash"
    },
    {
        label: "Casino",
        value: "casino"
    },
    {
        label: "Childcare Facility",
        value: "childcare"
    },
    {
        label: "Religious Building",
        value: "church"
    },
    {
        label: "Cinema",
        value: "cinema"
    },
    {
        label: "Clinic",
        value: "clinic"
    },
    {
        label: "Higher Education",
        value: "college"
    },
    {
        label: "Community Center",
        value: "community_center"
    },
    {
        label: "Courthouse",
        value: "courthouse"
    },
    {
        label: "Healthcare Facility",
        value: "doctors"
    },
    {
        label: "Embassy",
        value: "embassy"
    },
    {
        label: "Fast Food",
        value: "fast_food"
    },
    {
        label: "Ferry Terminal",
        value: "ferry_terminal"
    },
    {
        label: "Fire Station",
        value: "fire_station"
    },
    {
        label: "Fuel Station",
        value: "fuel"
    },
    {
        label: "Healthcare",
        value: "healthcare"
    },
    {
        label: "Hospital",
        value: "hospital"
    },
    {
        label: "Library",
        value: "library"
    },
    {
        label: "Marketplace",
        value: "marketplace"
    },
    {
        label: "Nursing Home",
        value: "nursing_home"
    },
    {
        label: "Parking Facility",
        value: "parking"
    },
    {
        label: "Pharmacy",
        value: "pharmacy"
    },
    {
        label: "Police Station",
        value: "police"
    },
    {
        label: "Post Office",
        value: "post_office"
    },
    {
        label: "Prison",
        value: "prison"
    },
    {
        label: "Bar",
        value: "pub"
    },
    {
        label: "Public Building",
        value: "public_building"
    },
    {
        label: "Ranger Station",
        value: "ranger_station"
    },
    {
        label: "Recycling Facility",
        value: "recycling"
    },
    {
        label: "School",
        value: "school"
    },
    {
        label: "Shelter",
        value: "shelter"
    },
    {
        label: "Social Facility",
        value: "social_centre"
    },
    {
        label: "Studio",
        value: "studio"
    },
    {
        label: "Swimming Pool",
        value: "swimming_pool"
    },
    {
        label: "Theater",
        value: "theatre"
    },
    {
        label: "Restroom Facility",
        value: "toilets"
    },
    {
        label: "Town Hall",
        value: "town_hall"
    },
    {
        label: "Veterinary Facility",
        value: "veterinary"
    }
];
const $0b13f1d1c0c1464c$export$286a7f607624d59e = [
    {
        name: "floor_area_total",
        label: "Total Square Feet",
        start: 0,
        end: 5000000,
        states: [
            "ny"
        ],
        category: "building_area"
    },
    {
        name: "number_of_buildings",
        label: "Number Of Buildings",
        start: 0,
        end: 10,
        states: [
            "ny"
        ]
    },
    {
        name: "floors",
        label: "Number of Floors",
        start: 0,
        end: 100,
        states: [
            "ny",
            "japan"
        ],
        category: null
    },
    {
        name: "year_built",
        label: "Year Built",
        start: 1900,
        end: $0b13f1d1c0c1464c$var$currentYear,
        states: [
            "ny"
        ],
        category: null
    }
];

});
parcelRegister("5d5VO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cb2c4846bbd3aaa$export$2e2bcd8739ae039; });
const $3cb2c4846bbd3aaa$var$available = [
    88004,
    88001,
    88002,
    88003,
    9933,
    99141,
    99144,
    99145,
    99146,
    99147,
    99148,
    99149,
    99177,
    99229,
    99281,
    99298,
    99332,
    99479,
    99543,
    99580,
    99849,
    99850,
    99875,
    99940,
    99986,
    991076,
    991146,
    991284,
    991285,
    991334,
    991380,
    991381,
    991402,
    991675,
    991685,
    992529,
    992535,
    992536,
    992598,
    993017,
    993338,
    993628,
    993701,
    993783,
    993942,
    993991,
    994067,
    994283,
    994500,
    994624,
    995357,
    995678,
    995679,
    995782,
    995850,
    9922020,
    9922036,
    9922037,
    994037,
    994055,
    99345,
    993657,
    993677,
    993658,
    992107,
    995039,
    992851,
    993435,
    994791,
    995367,
    995380,
    995038,
    991339,
    991353,
    991383,
    991389,
    991400,
    993378,
    9915,
    9981,
    9982,
    99173,
    99182,
    99288,
    99702,
    99805,
    99981,
    991134,
    992766,
    992779,
    993535,
    993742,
    993743,
    994622,
    994880,
    995669,
    9921955,
    9921956,
    13,
    12,
    9980,
    99153,
    99174,
    99192,
    99217,
    99453,
    99546,
    99550,
    99616,
    99699,
    99776,
    991153,
    991155,
    991159,
    991161,
    991162,
    991234,
    991251,
    991252,
    991596,
    991672,
    992397,
    992724,
    992891,
    993177,
    993565,
    993662,
    993765,
    993925,
    994419,
    994621,
    994857,
    994874,
    995122,
    995249,
    995539,
    995660,
    995676,
    995755,
    995860,
    995861,
    995883,
    995947,
    9921863,
    9921946,
    9922022,
    99701,
    9,
    27,
    994563,
    995540,
    995549,
    24,
    994371,
    9976,
    992004,
    992806,
    993197,
    993237,
    994472,
    9921865,
    9921866,
    991396,
    991397,
    993324,
    994298,
    994557,
    994962,
    992762,
    99327,
    99511,
    99513,
    99517,
    99897,
    991088,
    992011,
    992012,
    992013,
    992014,
    992015,
    992016,
    992020,
    992749,
    992925,
    993972,
    995139,
    995154,
    995447,
    9915761,
    9915763,
    993217,
    15,
    992464,
    994864,
    993377,
    993379,
    994263,
    992088,
    993432,
    992884,
    994792,
    994793,
    99665,
    99799,
    991154,
    991157,
    992324,
    992605,
    992641,
    992725,
    992736,
    992738,
    992761,
    992845,
    993425,
    993731,
    994696,
    995375,
    99219,
    99564,
    99595,
    99797,
    991053,
    991054,
    991110,
    991148,
    991149,
    991152,
    991249,
    991326,
    991477,
    992722,
    993014,
    993100,
    993461,
    993678,
    993736,
    993756,
    993929,
    994026,
    994034,
    994335,
    994360,
    994805,
    994848,
    995109,
    995687,
    995715,
    995716,
    995728,
    995729,
    995873,
    9921919,
    9921920,
    9922023,
    9938,
    99168,
    99589,
    991150,
    991151,
    992359,
    993266,
    993330,
    993671,
    993883,
    993966,
    994933,
    995165,
    995205,
    993907,
    992910,
    994588,
    994982,
    994983,
    994378,
    991829,
    991831,
    993474,
    994282,
    995919,
    991337,
    991338,
    992886,
    993400,
    994176,
    993026,
    18,
    99129,
    99195,
    99196,
    99239,
    99240,
    99277,
    99336,
    99338,
    99721,
    991046,
    991059,
    991078,
    991247,
    991646,
    991691,
    991693,
    992613,
    992624,
    992654,
    993141,
    993373,
    993705,
    993706,
    993802,
    993930,
    994506,
    994552,
    994951,
    994958,
    995321,
    995423,
    995425,
    995730,
    995739,
    995767,
    995787,
    9921981,
    9921983,
    9921985,
    9922025,
    991236,
    991407,
    993081,
    993730,
    993941,
    994338,
    994342,
    994355,
    994356,
    994517,
    994712,
    995120,
    995242,
    995405,
    995735,
    995738,
    14,
    991375,
    991379,
    994259,
    994560,
    995567,
    995717,
    11,
    991811,
    995189,
    10,
    991342,
    992649,
    992650,
    993833,
    993834,
    994363,
    995741,
    995742,
    995743,
    995744,
    995745,
    995746,
    995748,
    991485,
    994807,
    991313,
    991315,
    991316,
    991320,
    993889,
    994358,
    995162,
    995358,
    995693,
    995737,
    993285,
    994470,
    995858,
    994379,
    993463,
    994244,
    994306,
    994574,
    994955,
    7,
    8,
    991807,
    991808,
    993728,
    995664,
    992885,
    992887,
    994720,
    995593,
    26,
    991321,
    991322,
    991323,
    991324,
    991330,
    991399,
    993445,
    993887,
    993888,
    994357,
    995164,
    995356,
    995692,
    995289,
    994605,
    993456,
    994789,
    9961,
    992036,
    992473,
    992794,
    992795,
    992797,
    994147,
    994322,
    994788,
    993905,
    994644,
    995011,
    994770,
    994771,
    994917,
    993831,
    995170,
    994748,
    994750,
    994751,
    995547,
    995893,
    995944,
    28,
    993464,
    994245,
    994304,
    994575,
    994956,
    994594,
    993660,
    994480,
    995171,
    992740,
    991543,
    991544,
    993488,
    992021,
    992028,
    993661,
    993827,
    993828,
    993829,
    9919314,
    992652,
    992653,
    993346,
    993835,
    9921750,
    991592,
    991593,
    991594,
    993652,
    995012,
    992090,
    993313,
    993322,
    992084,
    993670,
    993825,
    994289,
    995126,
    992026,
    992631,
    992946,
    992947,
    995411,
    992029,
    993838,
    993840,
    994196,
    994593,
    995545,
    993669,
    993830,
    993832,
    9919316,
    995594,
    995595,
    993727,
    993735,
    994228,
    995590,
    995592,
    992089,
    994948,
    992039,
    993430,
    993480,
    993004,
    995221,
    9914057,
    9914059,
    9914074,
    9914081,
    9914091,
    9916433,
    9917294,
    9917300,
    9917439,
    9917440,
    9917462,
    9917599,
    9917638,
    9918549,
    9918820,
    9919752,
    9920157,
    9920322,
    9921650,
    9921651,
    9921652,
    9921653,
    9921684,
    9921685,
    9921686,
    9921687,
    9921715,
    9921716,
    9921717,
    9921737,
    9921947,
    9921952,
    992647,
    992648,
    993082,
    993168,
    994601,
    995176,
    995177,
    995490,
    9915778,
    9915786,
    9915792,
    9915798,
    9917413,
    9917415,
    9917418,
    9917433,
    9917434,
    9917437,
    9917705,
    9918961,
    9918980,
    9918981,
    9919309,
    9919311,
    9919669,
    9921101,
    9921567,
    9921624,
    9921628,
    9921636,
    9921793,
    9921794,
    9921800,
    9921802,
    9921803,
    9921806,
    9921808,
    9921810,
    9921817,
    993630,
    994796,
    993037,
    994703,
    995117,
    995118,
    992729,
    995254,
    9915772,
    9917695,
    992091,
    991772,
    991773,
    995352,
    992087,
    993111,
    993115,
    994572,
    9913947,
    9913952,
    9913955,
    9913956,
    9913957,
    9914062,
    9914078,
    9916193,
    9916282,
    9916286,
    9916287,
    9916289,
    9917454,
    9917458,
    9917470,
    9917478,
    9917480,
    9917481,
    9917573,
    9917574,
    9917578,
    9917727,
    9918330,
    9918953,
    9918962,
    9919774,
    9919888,
    9919911,
    9919913,
    9919914,
    9920099,
    9920123,
    9920258,
    9920625,
    9921157,
    9921171,
    9921186,
    9921187,
    9921571,
    9921671,
    9921674,
    9917847,
    9921541,
    994587,
    9914025,
    9914029,
    9916416,
    9916482,
    9916483,
    9917594,
    9919788,
    9919892,
    9919893,
    9920368,
    9920375,
    9921635,
    9921638,
    9921921,
    995008,
    9913886,
    9916288,
    9916290,
    9916390,
    9916396,
    9916397,
    9916501,
    9916968,
    9917229,
    9917234,
    9917237,
    9917238,
    9917239,
    9918738,
    9920619
];
var $3cb2c4846bbd3aaa$export$2e2bcd8739ae039 = [
    {
        value: 88004,
        label: "BQDM",
        states: [
            "ny"
        ]
    },
    {
        value: 88001,
        label: "Non-Wires Alternative (Williamsburg)",
        states: [
            "ny"
        ]
    },
    {
        value: 88002,
        label: "Non-Wires Alternative (Prospect Park)",
        states: [
            "ny"
        ]
    },
    {
        value: 88003,
        label: "Non-Wires Alternative (Borough Hall)",
        states: [
            "ny"
        ]
    },
    {
        value: 2,
        label: "Multi-Family Building Incentive",
        states: [
            "ny"
        ]
    },
    {
        value: 3,
        label: "Demand Response Program",
        states: [
            "ny"
        ]
    },
    {
        value: 4,
        label: "Solar + Storage",
        states: [
            "ny"
        ]
    },
    {
        value: 5,
        label: "Demand Management 2.0",
        states: [
            "ny"
        ]
    },
    {
        value: 6,
        label: "CHP BQDM Incentive",
        states: [
            "ny"
        ]
    },
    {
        value: 7,
        label: "Commercial Implementation Assistance Program",
        states: [
            "ny"
        ]
    },
    {
        value: 8,
        label: "Commercial New Construction Program",
        states: [
            "ny"
        ]
    },
    {
        value: 9,
        label: "Residential New Construction Program",
        states: [
            "ny"
        ]
    },
    {
        value: 10,
        label: "PON 1746 FlexTech Program",
        states: [
            "ny"
        ]
    },
    {
        value: 11,
        label: "NY Prize Community Grid Competition (Stage 2)",
        states: [
            "ny"
        ]
    },
    {
        value: 12,
        label: "Shared Solar",
        states: [
            "ny"
        ]
    },
    {
        value: 13,
        label: "Residential/Small Commercial Solar",
        states: [
            "ny"
        ]
    },
    {
        value: 14,
        label: "Commercial/Industrial Solar",
        states: [
            "ny"
        ]
    },
    {
        value: 15,
        label: "Affordable Solar",
        states: [
            "ny"
        ]
    },
    {
        value: 16,
        label: "PON 2149 Solar Thermal Incentive Program",
        states: [
            "ny"
        ]
    },
    {
        value: 17,
        label: "PON 2568 Program",
        states: [
            "ny"
        ]
    },
    {
        value: 18,
        label: "PON 3309 RTEM",
        states: [
            "ny"
        ]
    },
    {
        value: 19,
        label: "CST Fuel Cell Program",
        states: [
            "ny"
        ]
    },
    {
        value: 20,
        label: "Small Wind Turbine Program",
        states: [
            "ny"
        ]
    },
    {
        value: 21,
        label: "Lighting Upgrade",
        states: [
            "ny"
        ]
    },
    {
        value: 22,
        label: "Insulation Improvement",
        states: [
            "ny"
        ]
    },
    {
        value: 23,
        label: "EnergyWise",
        states: [
            "ny"
        ]
    },
    {
        value: 24,
        label: "Property Tax Exemption",
        states: [
            "ny"
        ]
    },
    {
        value: 25,
        label: "Solar Energy System Equipment Credit",
        states: [
            "ny"
        ]
    },
    {
        value: 26,
        label: "Energy Efficiency Tax Incentives",
        states: [
            "ny"
        ]
    },
    {
        value: 27,
        label: "Energy Efficient Home Credit",
        states: [
            "ny"
        ]
    },
    {
        value: 28,
        label: "Energy Project Tax Credit",
        states: [
            "ny"
        ]
    },
    {
        value: 1,
        label: "LED Lighting Free Install",
        states: [
            "ny"
        ]
    },
    {
        value: 995162,
        label: "The United Illuminating Company - ZREC and LREC Long Term Contracts",
        states: [
            "ct"
        ]
    },
    {
        value: 995120,
        label: "Residential Solar Investment Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995738,
        label: "(Electric and Gas) Residential Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994958,
        label: "Local Option - Building Permit Fee Waivers for Renewable Energy Projects",
        states: [
            "ct"
        ]
    },
    {
        value: 994951,
        label: "Local Option - Residential Sustainable Energy Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994884,
        label: "CCEF - Alpha Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994712,
        label: "Small Business Energy Advantage Loan Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994576,
        label: "Energy Efficiency Fund (Gas) - Home Energy Solutions and Performance Programs",
        states: [
            "ct"
        ]
    },
    {
        value: 994572,
        label: "Norwich Public Utilities (Gas) - Residential Energy Efficiency Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994566,
        label: "Litchfield Hills Region - Business Energy Efficiency Program",
        states: [
            "ct"
        ]
    },
    {
        value: 99277,
        label: "Net Metering",
        states: [
            "ct"
        ]
    },
    {
        value: 991078,
        label: "Green Power Purchase Plan",
        states: [
            "ct"
        ]
    },
    {
        value: 991087,
        label: "CEFIA - Residential Solar PV Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9921985,
        label: "Energize Connecticut - Small Business Energy Advantage",
        states: [
            "ct"
        ]
    },
    {
        value: 9913886,
        label: "United Illuminating Company - Energy Opportunities Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995787,
        label: "Renewable Energy Investment Fund",
        states: [
            "ct"
        ]
    },
    {
        value: 995767,
        label: "Xcel Energy - Express Energy Efficiency",
        states: [
            "ct"
        ]
    },
    {
        value: 995739,
        label: "(CHIF) Home Energy Solutions Loan Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995737,
        label: "Commercial and Industrial Kitchen Equipment Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991236,
        label: "Operational Demonstration Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991247,
        label: "Sales and Use Tax Exemption for Energy-Efficient Products",
        states: [
            "ct"
        ]
    },
    {
        value: 995735,
        label: "Low Interest Energy Efficiency Loan Program (Electric and Gas)",
        states: [
            "ct"
        ]
    },
    {
        value: 991263,
        label: "On-Site Renewable DG Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9918738,
        label: "United Illuminating Company - Process Reengineering for Increased Manufacturing Efficiency (PRIME)",
        states: [
            "ct"
        ]
    },
    {
        value: 99297,
        label: "CCEF - Commercial, Industrial, Institutional PV Grant Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9922025,
        label: "Northeast Energy Efficiency Partnerships - EM&V Forum",
        states: [
            "ct"
        ]
    },
    {
        value: 991313,
        label: "The United Illuminating Company - Small Business Energy Advantage Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991314,
        label: "The United Illuminating Company - Energy Star Incentives Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9921983,
        label: "Energize Connecticut - Energy Conscious Blueprint",
        states: [
            "ct"
        ]
    },
    {
        value: 991315,
        label: "The United Illuminating Company - Energy Conscious Blueprint Grant Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991316,
        label: "The United Illuminating Company - Energy Conscious Blueprint Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991318,
        label: "The United Illuminating Company - MotorUp Commercial Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991319,
        label: "The United Illuminating Company - Cool Choice Commercial Energy Efficiency Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991320,
        label: "The United Illuminating Company - Energy Opportunities Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991321,
        label: "Connecticut Light & Power - Energy Opportunities Efficiency Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991322,
        label: "Connecticut Light & Power - Commercial Energy Efficiency Rebates",
        states: [
            "ct"
        ]
    },
    {
        value: 991323,
        label: "Connecticut Light & Power - Small Business Energy Advantage Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991324,
        label: "Connecticut Light & Power - Small Business Energy Advantage Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995730,
        label: "Multifamily Energy Conservation Loan Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991327,
        label: "Connecticut Light & Power - Express Rebate Programs",
        states: [
            "ct"
        ]
    },
    {
        value: 991329,
        label: "The United Illuminating Company - Express Lighting Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991330,
        label: "Connecticut Light & Power - Small Industrial and Commercial Energy Efficiency Loan Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9921981,
        label: "Eversource - Energy Savings Plan",
        states: [
            "ct"
        ]
    },
    {
        value: 99322,
        label: "Solar and Wind Contractor Licensing",
        states: [
            "ct"
        ]
    },
    {
        value: 99336,
        label: "CCEF - Renewable Energy Projects in Pre-Development Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9917239,
        label: "Southern Connecticut Gas - Operation & Maintenance Program",
        states: [
            "ct"
        ]
    },
    {
        value: 99338,
        label: "CCEF - Project 150 Initiative",
        states: [
            "ct"
        ]
    },
    {
        value: 99157,
        label: "Connecticut Clean Energy Fund",
        states: [
            "ct"
        ]
    },
    {
        value: 9917238,
        label: "Southern Connecticut Gas - Energy Opportunities Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9917237,
        label: "Southern Connecticut Gas - Energy Conscious Blueprint Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9917234,
        label: "Santa  Buckley Energy - Heating, Ventilation, and Air Conditioning Equipment and Service",
        states: [
            "ct"
        ]
    },
    {
        value: 9917229,
        label: "EnerNOC - Energy Procurement",
        states: [
            "ct"
        ]
    },
    {
        value: 991399,
        label: "Connecticut Light & Power - Operation and Maintenance Program",
        states: [
            "ct"
        ]
    },
    {
        value: 99128,
        label: "Alternative Fueled Vehicle Incremental Cost Credit",
        states: [
            "ct"
        ]
    },
    {
        value: 991407,
        label: "Smart-E loans",
        states: [
            "ct"
        ]
    },
    {
        value: 995693,
        label: "The United Illuminating Company - ZREC and LREC Long Term Contracts",
        states: [
            "ct"
        ]
    },
    {
        value: 995692,
        label: "Connecticut Light & Power - ZREC and LREC Long Term Contracts",
        states: [
            "ct"
        ]
    },
    {
        value: 995684,
        label: "Connecticut Light & Power - Small ZREC Tariff",
        states: [
            "ct"
        ]
    },
    {
        value: 995683,
        label: "The United Illuminating Company - Small ZREC Tariff",
        states: [
            "ct"
        ]
    },
    {
        value: 995639,
        label: "Copy of CT Clean Energy Communities",
        states: [
            "ct"
        ]
    },
    {
        value: 995638,
        label: "Combined Heat and Power Loan Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995637,
        label: "Performance based incentive for Combined Heat and Power Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991563,
        label: "Energy Efficiency Standards for Appliances",
        states: [
            "ct"
        ]
    },
    {
        value: 9916968,
        label: "Norwich Public Utilities - Commercial Energy Audit",
        states: [
            "ct"
        ]
    },
    {
        value: 995425,
        label: "Clean Energy On-Bill Financing",
        states: [
            "ct"
        ]
    },
    {
        value: 9920619,
        label: "Santa Buckley Energy - Lighting Retrofits & Upgrades",
        states: [
            "ct"
        ]
    },
    {
        value: 991619,
        label: "CT Clean Energy Communities",
        states: [
            "ct"
        ]
    },
    {
        value: 991646,
        label: "Community Innovations Grant Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9916501,
        label: "Northeast Energy Efficiency Council - Building Operator Certification (BOC)",
        states: [
            "ct"
        ]
    },
    {
        value: 991691,
        label: "DPUC - Capital Grants for Customer-Side Distributed Resources",
        states: [
            "ct"
        ]
    },
    {
        value: 991693,
        label: "Low-Interest Loans for Customer-Side Distributed Resources",
        states: [
            "ct"
        ]
    },
    {
        value: 991772,
        label: "Groton Utilities - Residential Energy Efficiency Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991773,
        label: "Groton Utilities - Commercial & Industrial Energy Efficiency Rebate Programs",
        states: [
            "ct"
        ]
    },
    {
        value: 991311,
        label: "Connecticut Natural Gas - Energy Conservation Program for State Facilities",
        states: [
            "ct"
        ]
    },
    {
        value: 99721,
        label: "Fuel Cell Initiative",
        states: [
            "ct"
        ]
    },
    {
        value: 995423,
        label: "Local Option - Property Tax Exemption for Renewable Energy Systems",
        states: [
            "ct"
        ]
    },
    {
        value: 995405,
        label: "CT Solar Loan",
        states: [
            "ct"
        ]
    },
    {
        value: 995358,
        label: "The United Illuminating Company - Small ZREC Tariff",
        states: [
            "ct"
        ]
    },
    {
        value: 995356,
        label: "Connecticut Light & Power - Small ZREC Tariff",
        states: [
            "ct"
        ]
    },
    {
        value: 995321,
        label: "Local Option - Commercial PACE Financing",
        states: [
            "ct"
        ]
    },
    {
        value: 995242,
        label: "Commercial Solar Thermal Incentive Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995213,
        label: "Combined Heat and Power Pilot Loan Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995212,
        label: "Combined Heat and Power Grant Program",
        states: [
            "ct"
        ]
    },
    {
        value: 995164,
        label: "Connecticut Light & Power - ZREC and LREC Long Term Contracts",
        states: [
            "ct"
        ]
    },
    {
        value: 995121,
        label: "Exemption from Electric Generation Tax",
        states: [
            "ct"
        ]
    },
    {
        value: 992313,
        label: "Energy Efficiency Fund",
        states: [
            "ct"
        ]
    },
    {
        value: 994552,
        label: "Sales and Use Taxes for Items Used in Renewable Energy Industries",
        states: [
            "ct"
        ]
    },
    {
        value: 992390,
        label: "Energy Efficiency Requirements for State Government",
        states: [
            "ct"
        ]
    },
    {
        value: 994517,
        label: "Energy Efficiency Fund (Electric and Gas) - Residential Energy Efficiency Financing",
        states: [
            "ct"
        ]
    },
    {
        value: 994506,
        label: "Renewable Portfolio Standards - Energy Efficiency Component",
        states: [
            "ct"
        ]
    },
    {
        value: 99195,
        label: "Renewables Portfolio Standard",
        states: [
            "ct"
        ]
    },
    {
        value: 9916397,
        label: "United Illuminating Company - Retro-Commissioning (RCx)",
        states: [
            "ct"
        ]
    },
    {
        value: 992612,
        label: "Building Energy Code",
        states: [
            "ct"
        ]
    },
    {
        value: 992613,
        label: "Sales and Use Tax Exemption for Solar and Geothermal Systems",
        states: [
            "ct"
        ]
    },
    {
        value: 992614,
        label: "OPM - Replacement Furnace Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994421,
        label: "CCEF - ARRA Commercial Solar PV Program",
        states: [
            "ct"
        ]
    },
    {
        value: 992623,
        label: "Connecticut Light & Power - Summer Saver Rewards",
        states: [
            "ct"
        ]
    },
    {
        value: 992624,
        label: "Local Option - Property Tax Exemption Cogeneration Systems",
        states: [
            "ct"
        ]
    },
    {
        value: 992625,
        label: "The United Illuminating Company - Summer Savers Rewards",
        states: [
            "ct"
        ]
    },
    {
        value: 994358,
        label: "Connecticut Light & Power - Energy Conscious Blueprint Grant Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994357,
        label: "Connecticut Light & Power - Small Business Energy Advantage Loan Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994356,
        label: "Energy Efficiency Fund (Electric) - Commercial New Construction Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994355,
        label: "(Electric) Commercial and Industrial Energy Efficiency Programs",
        states: [
            "ct"
        ]
    },
    {
        value: 994342,
        label: "(Electric and Gas)  Residential New Construction Program",
        states: [
            "ct"
        ]
    },
    {
        value: 994340,
        label: "Connecticut Light and Power (Electric) - Heating and Cooling Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 992654,
        label: "Mass Energy - Renewable Energy Certificate Incentive",
        states: [
            "ct"
        ]
    },
    {
        value: 9916396,
        label: "United Illuminating Company - Business Energy Solutions",
        states: [
            "ct"
        ]
    },
    {
        value: 994338,
        label: "(Electric and Gas ) Home Energy Solutions Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993941,
        label: "(Gas) Commercial and Industrial Gas Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993940,
        label: "Yankeegas -  Cooking and Water Heating Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993938,
        label: "Connecticut Natural Gas - Cooking and Water Heating Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993934,
        label: "Southern Connecticut Gas - Custom Commercial Energy Efficiency Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993933,
        label: "Yankee Gas - Custom Commercial Energy Efficiency Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993930,
        label: "Connecticut Natural Gas - Custom Commercial Energy Efficiency Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993889,
        label: "The United Illuminating Company - Residential New Construction Program",
        states: [
            "ct"
        ]
    },
    {
        value: 99196,
        label: "Energy Conservation Loan",
        states: [
            "ct"
        ]
    },
    {
        value: 993888,
        label: "Connecticut Light & Power - Residential New Construction Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993887,
        label: "Connecticut Light & Power - Energy Conscious Blueprint Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993844,
        label: "Connecticut - Residential Energy-Efficient Appliance Rebates",
        states: [
            "ct"
        ]
    },
    {
        value: 99197,
        label: "Alternative Fuel Vehicles and Associated Equipment",
        states: [
            "ct"
        ]
    },
    {
        value: 993802,
        label: "Geothermal Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9916390,
        label: "Commercial Conservation Programs",
        states: [
            "ct"
        ]
    },
    {
        value: 993730,
        label: "Solar Thermal Incentive Program",
        states: [
            "ct"
        ]
    },
    {
        value: 9916290,
        label: "ISO New England - Demand Resources",
        states: [
            "ct"
        ]
    },
    {
        value: 993706,
        label: "New Generation Energy - Community Solar Lending Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993705,
        label: "New Generation Energy - Community Food Service Efficiency Lending Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993447,
        label: "Energy Efficiency Fund (Electric) - Residential Heating and Cooling Rebates",
        states: [
            "ct"
        ]
    },
    {
        value: 993445,
        label: "CL&P - Residential Heating and Cooling Rebates",
        states: [
            "ct"
        ]
    },
    {
        value: 993373,
        label: "Commercial and Industrial Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993003,
        label: "CCEF - Affordable Housing Initiative Solar PV Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993081,
        label: "CT Solar Lease",
        states: [
            "ct"
        ]
    },
    {
        value: 993141,
        label: "Furnace and Boiler Replacement Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993115,
        label: "Norwich Public Utilities - Zero Percent Financing Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993111,
        label: "Norwich Public Utilities - Commercial Energy Efficiency Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 993112,
        label: "Norwich Public Utilities (Electric) - Residential Energy Efficiency Rebate Program",
        states: [
            "ct"
        ]
    },
    {
        value: 99129,
        label: "Alternative Fueled Vehicle Charging Station Credit",
        states: [
            "ct"
        ]
    },
    {
        value: 99239,
        label: "Fuel Mix and Emissions Disclosure",
        states: [
            "ct"
        ]
    },
    {
        value: 9916288,
        label: "U.S. Department of Energy Industrial Assessment Center (IAC): University of Massachusetts",
        states: [
            "ct"
        ]
    },
    {
        value: 99240,
        label: "Property Tax Exemption for Renewable Energy Systems",
        states: [
            "ct"
        ]
    },
    {
        value: 991046,
        label: "New Energy Technology Program",
        states: [
            "ct"
        ]
    },
    {
        value: 991059,
        label: "Interconnection Standards",
        states: [
            "ct"
        ]
    },
    {
        value: 9922037,
        label: "Local Option - Commercial PACE Financing",
        states: [
            "ma"
        ]
    },
    {
        value: 9933,
        label: "Green Power Predevelopment Financing Grant",
        states: [
            "ma"
        ]
    },
    {
        value: 99147,
        label: "Excise Tax Exemption for Solar or Wind Powered Systems",
        states: [
            "ma"
        ]
    },
    {
        value: 995367,
        label: "Commonwealth Outdoor Hydronic Heater Change-Out Pilot Program",
        states: [
            "ma"
        ]
    },
    {
        value: 99141,
        label: "Clustered PV Installation Program",
        states: [
            "ma"
        ]
    },
    {
        value: 99144,
        label: "Residential Renewable Energy Income Tax Credit",
        states: [
            "ma"
        ]
    },
    {
        value: 99145,
        label: "Renewable Energy Equipment Sales Tax Exemption",
        states: [
            "ma"
        ]
    },
    {
        value: 99146,
        label: "Renewable Energy Property Tax Exemption",
        states: [
            "ma"
        ]
    },
    {
        value: 99148,
        label: "Excise Tax Deduction for Solar or Wind Powered Systems",
        states: [
            "ma"
        ]
    },
    {
        value: 99149,
        label: "Alternative Energy and Energy Conservation Patent Income Tax Deduction (Corporate)",
        states: [
            "ma"
        ]
    },
    {
        value: 99177,
        label: "Mass Energy Consumers Alliance - Renewable Energy Certificate Incentive",
        states: [
            "ma"
        ]
    },
    {
        value: 99229,
        label: "Alternative Energy and Energy Conservation Patent Income Tax Deduction (Personal)",
        states: [
            "ma"
        ]
    },
    {
        value: 99281,
        label: "Net Metering",
        states: [
            "ma"
        ]
    },
    {
        value: 99298,
        label: "MTC - Renewable Energy Credit Payment Options",
        states: [
            "ma"
        ]
    },
    {
        value: 99301,
        label: "Solar Easements & Rights Laws",
        states: [
            "ma"
        ]
    },
    {
        value: 99307,
        label: "Cape Cod & Martha's Vineyard - Green Power Purchasing",
        states: [
            "ma"
        ]
    },
    {
        value: 99349,
        label: "Medford Solar Program",
        states: [
            "ma"
        ]
    },
    {
        value: 99332,
        label: "MTC - Matching Grants for Communities",
        states: [
            "ma"
        ]
    },
    {
        value: 99345,
        label: "Commonwealth Wind Incentive Program - Micro Wind Initiative",
        states: [
            "ma"
        ]
    },
    {
        value: 99479,
        label: "Renewable Portfolio Standard",
        states: [
            "ma"
        ]
    },
    {
        value: 99480,
        label: "Fuel Mix and Emissions Disclosure",
        states: [
            "ma"
        ]
    },
    {
        value: 99543,
        label: "Open PV Installation Program",
        states: [
            "ma"
        ]
    },
    {
        value: 99580,
        label: "Cape & Islands Self-Reliance Corporation - Home Energy Loan Program",
        states: [
            "ma"
        ]
    },
    {
        value: 99732,
        label: "Renewable Energy Trust Fund",
        states: [
            "ma"
        ]
    },
    {
        value: 99849,
        label: "Green Schools Initiative",
        states: [
            "ma"
        ]
    },
    {
        value: 99850,
        label: "Green Buildings Initiative",
        states: [
            "ma"
        ]
    },
    {
        value: 99875,
        label: "Newton - Solar Hot Water System Rebate",
        states: [
            "ma"
        ]
    },
    {
        value: 99930,
        label: "Green Power Purchasing",
        states: [
            "ma"
        ]
    },
    {
        value: 99940,
        label: "Fuel Cell Grants",
        states: [
            "ma"
        ]
    },
    {
        value: 99986,
        label: "Interconnection Standards",
        states: [
            "ma"
        ]
    },
    {
        value: 991076,
        label: "MTC - Large Onsite Renewables Initiative (LORI) Grants",
        states: [
            "ma"
        ]
    },
    {
        value: 991146,
        label: "Energy Conservation Improvement Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991269,
        label: "MassCEC - Sustainable Energy Economic Development (SEED) Initiative",
        states: [
            "ma"
        ]
    },
    {
        value: 991284,
        label: "Residential Solar and Efficiency Tax Credit - Personal",
        states: [
            "ma"
        ]
    },
    {
        value: 991285,
        label: "Residential Solar and Efficiency Tax Credit - Corporate",
        states: [
            "ma"
        ]
    },
    {
        value: 991303,
        label: "National Grid - Residential (Gas) Solar Water Heating Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991334,
        label: "Berkshire Gas - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991337,
        label: "Holyoke Gas & Electric - Residential Energy Conservation Loan Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991338,
        label: "Holyoke Gas & Electric - Commercial Energy Conservation Loan Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991339,
        label: "National Grid (Electric) - Residential Energy Efficiency Incentive Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991342,
        label: "Wakefield Municipal Gas & Light Department - Residential Conservation Services Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991353,
        label: "National Grid (Mass Electric) - Small Business Energy Efficiency Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991355,
        label: "New England Gas Company - Residential and Commercial Energy Efficiency Rebate Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991375,
        label: "Unitil - Residential Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991379,
        label: "Unitil (Gas) - Business Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991380,
        label: "Columbia Gas of Massachusetts - Residential Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991381,
        label: "Columbia Gas of Massachusetts - Commercial Energy Efficiency Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991383,
        label: "National Grid (Electric) - Commercial Energy Efficiency Incentive Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991389,
        label: "National Grid - Small/Mid-Sized Business Energy Efficiency Loan/Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991390,
        label: "National Grid (Nantucket) - Commercial Energy Efficiency Incentive Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991391,
        label: "National Grid (Nantucket) - Residential Energy Efficiency Incentive Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991395,
        label: "NSTAR (Gas) - Residential Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991396,
        label: "NSTAR (Electric) - Construction Solutions Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991397,
        label: "NSTAR (Electric) - Business Solutions Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991400,
        label: "National Grid - Commercial Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991402,
        label: "National Grid (Gas) - Residential Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 991403,
        label: "National Grid Energy Delivery - Building Practices and Demonstration Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991567,
        label: "Appliance Efficiency Standards",
        states: [
            "ma"
        ]
    },
    {
        value: 991598,
        label: "Corporate Tax Credit for Solar Water Heating Systems",
        states: [
            "ma"
        ]
    },
    {
        value: 9918330,
        label: "Reading Municipal Light Department - Commercial Customers",
        states: [
            "ma"
        ]
    },
    {
        value: 991675,
        label: "MTC - Clean Energy Pre-Development Financing Initiative (Grants)",
        states: [
            "ma"
        ]
    },
    {
        value: 991685,
        label: "MTC - Clean Energy Pre-Development Financing Initiative (Loans)",
        states: [
            "ma"
        ]
    },
    {
        value: 991802,
        label: "Belmont Municipal Light Department - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991817,
        label: "North Attleborough Electric Department - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991806,
        label: "Chicopee Electric Light Department - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991807,
        label: "Concord Municipal Light Plant - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991808,
        label: "Concord Municipal Light Plant - Commercial Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991811,
        label: "Mansfield Municipal Electric Department - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991812,
        label: "Marblehead Municipal Light Department - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991828,
        label: "North Attleborough Electric Department - Power Saver Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991829,
        label: "Reading Municipal Light Department - Residential Energy Star Appliance Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991831,
        label: "Reading Municipal Light Department - Commercial Lighting Retrofit Program",
        states: [
            "ma"
        ]
    },
    {
        value: 991871,
        label: "Building Energy Code",
        states: [
            "ma"
        ]
    },
    {
        value: 991929,
        label: "Shrewsbury Electric - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 992107,
        label: "Mass Save - HEAT Loan Program",
        states: [
            "ma"
        ]
    },
    {
        value: 992257,
        label: "Energy Efficiency Fund",
        states: [
            "ma"
        ]
    },
    {
        value: 992504,
        label: "City of Boston - Green Power Purchasing",
        states: [
            "ma"
        ]
    },
    {
        value: 992529,
        label: "MTC - Massachusetts Green Communities Grant",
        states: [
            "ma"
        ]
    },
    {
        value: 992535,
        label: "MTC - Massachusetts Green Communities Loan",
        states: [
            "ma"
        ]
    },
    {
        value: 992536,
        label: "Boston Community Capital - Energy Advantage Program",
        states: [
            "ma"
        ]
    },
    {
        value: 992598,
        label: "MTC - Business Expansion Initiative",
        states: [
            "ma"
        ]
    },
    {
        value: 992569,
        label: "Energy Reduction Plan for State Buildings",
        states: [
            "ma"
        ]
    },
    {
        value: 993324,
        label: "NSTAR (Electric) - Small Business Direct Install Program",
        states: [
            "ma"
        ]
    },
    {
        value: 992782,
        label: "Model As-of Right Zoning Ordinance or Bylaw: Allowing Use of Wind Energy Facilities",
        states: [
            "ma"
        ]
    },
    {
        value: 992851,
        label: "Commonwealth Solar II Rebates",
        states: [
            "ma"
        ]
    },
    {
        value: 992886,
        label: "Chicopee Electric Light - Residential Solar Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993000,
        label: "Green Power Purchasing Commitment",
        states: [
            "ma"
        ]
    },
    {
        value: 9917470,
        label: "Massachusetts Division of Energy Resources - Green Business Development",
        states: [
            "ma"
        ]
    },
    {
        value: 993017,
        label: "National Grid (Gas)\xe2\u20AC\u201C Commercial Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 993126,
        label: "Model Ordinance for Permitting of Small Wind Facilities",
        states: [
            "ma"
        ]
    },
    {
        value: 993217,
        label: "MuniHELPS - Offered by 17 Utilities through the MMWEC",
        states: [
            "ma"
        ]
    },
    {
        value: 993338,
        label: "Eversource (Gas) - Commercial Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 993377,
        label: "Western Massachusetts Electric - Commercial Energy Efficiency Rebates",
        states: [
            "ma"
        ]
    },
    {
        value: 993378,
        label: "National Grid (Electric) - Small Business Energy Efficiency Loan/Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993379,
        label: "WMECO -  New Construction/Major Renovations Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993435,
        label: "Commonwealth Wind Community-Scale Initiative",
        states: [
            "ma"
        ]
    },
    {
        value: 993456,
        label: "Marblehead Municipal Light Department - Solar Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993487,
        label: "Cape Light Compact - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993488,
        label: "Cape Light Compact - Commercial Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993628,
        label: "National Grid (Gas) - Commercial Solar Thermal Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993657,
        label: "Commonwealth Wind Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993658,
        label: "MassCEC - Commonwealth Wind Incentive Program - Commercial Wind Initiative Loan",
        states: [
            "ma"
        ]
    },
    {
        value: 993677,
        label: "Commonwealth Hydropower Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993701,
        label: "New Generation Energy - Community Solar Lending Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993728,
        label: "Concord Municipal Light Plant - Solar Photovoltaic Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993783,
        label: "New Generation Energy - Community Food Service Efficiency Lending Program",
        states: [
            "ma"
        ]
    },
    {
        value: 993862,
        label: "Massachusetts - Residential Energy-Efficient Appliance Rebates",
        states: [
            "ma"
        ]
    },
    {
        value: 993942,
        label: "MassCEC - Commonwealth Solar Stimulus",
        states: [
            "ma"
        ]
    },
    {
        value: 993991,
        label: "Solar Renewable Energy Certificates (SREC-I)",
        states: [
            "ma"
        ]
    },
    {
        value: 994037,
        label: "Residential New Construction Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994055,
        label: "Major Renovations Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994061,
        label: "Model As-of Right Zoning Ordinance or Bylaw: Allowing Use of Large-Scale Solar Energy Facilities",
        states: [
            "ma"
        ]
    },
    {
        value: 994067,
        label: "Green Communities Grant Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994214,
        label: "Unitil - Commercial and Industrial Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 994259,
        label: "Berkshire Gas - Commercial Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994263,
        label: "Western Massachusetts Electric - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9918953,
        label: "Rowley Municipal Lighting Plant - Commercial Energy Audits and Rebates",
        states: [
            "ma"
        ]
    },
    {
        value: 994282,
        label: "Taunton Municipal Lighting Plant - Residential PV Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994283,
        label: "Local Option - Energy Revolving Loan Fund",
        states: [
            "ma"
        ]
    },
    {
        value: 994298,
        label: "NSTAR (Electric) - Residential Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 994378,
        label: "MMWEC Green Opportunity Commercial and Industrial Efficiency Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994379,
        label: "Ipswich Utilities - HELPS PV Solar Rebate",
        states: [
            "ma"
        ]
    },
    {
        value: 994431,
        label: "City of Boston - Renew Boston Residential Retrofit Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994500,
        label: "Energy Efficiency First Fuel Requirement (Gas and Electric)",
        states: [
            "ma"
        ]
    },
    {
        value: 994557,
        label: "Commonwealth Residential & Small-Scale Solar Hot Water Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994561,
        label: "Taunton Municipal Lighting Plant - Residential Energy Star Appliance Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994595,
        label: "Reading Municipal Light Department - Business Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994605,
        label: "Reading Municipal Light Department - Residential Renewable Energy Rebates",
        states: [
            "ma"
        ]
    },
    {
        value: 994624,
        label: "Alternative Energy Portfolio Standard",
        states: [
            "ma"
        ]
    },
    {
        value: 994791,
        label: "MassSAVE (Electric) - Commercial New Construction/Major Renovation Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994794,
        label: "Gas Networks - Commercial Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994797,
        label: "Mass Save (Gas) - Residential Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994798,
        label: "Mass Save (Electric) - Large Commercial Retrofit Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994799,
        label: "Mass Save (Electric) - Residential Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 994807,
        label: "Wellesley Municipal Light Plant - Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994918,
        label: "City of Boston - Renew Boston Solar Program",
        states: [
            "ma"
        ]
    },
    {
        value: 994962,
        label: "Commercial Solar Hot Water Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995038,
        label: "Mass Save - Financing for Business Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995039,
        label: "Commonwealth Organics-to-Energy Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995070,
        label: "ReBuild Western Massachusetts Grant Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995071,
        label: "ReBuild Western Massachusetts Loan Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995157,
        label: "City of Cambridge - Cambridge Energy Alliance Solar Hot Water Grant",
        states: [
            "ma"
        ]
    },
    {
        value: 995189,
        label: "Hudson Light & Power - Photovoltaic Incentive Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995239,
        label: "Chicopee Electric Light - Commercial Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995289,
        label: "City of Lowell - BLEU Projects Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995319,
        label: "Taunton Municipal Lighting Plant - Residential and Non-Profit Weatherization Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995357,
        label: "Commonwealth Woodstove Change-Out Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995359,
        label: "Commercial Solar Hot Water Financing Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995380,
        label: "Commonwealth Small Pellet Boiler Grant Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9913957,
        label: "National Grid - Existing Facility Incentives",
        states: [
            "ma"
        ]
    },
    {
        value: 995515,
        label: "Solar Renewable Energy Certificates (SREC-II)",
        states: [
            "ma"
        ]
    },
    {
        value: 995635,
        label: "Residential & Small-Scale Air-Source Heat Pump Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995636,
        label: "Residential & Small-Scale Ground-Source Heat Pump Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995644,
        label: "Residential & Small-Scale Biomass Heating Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995678,
        label: "Solar Renewable Energy Certificates (SREC-I)",
        states: [
            "ma"
        ]
    },
    {
        value: 995679,
        label: "Solar Renewable Energy Certificates (SREC-II)",
        states: [
            "ma"
        ]
    },
    {
        value: 995782,
        label: "Cape Light Compact- Residential Energy Efficiency Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995808,
        label: "Leading By Example Solar Photovoltaic Canopy Grant Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995828,
        label: "Mass Save (Electric) - Small Business Direct Install Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995850,
        label: "Mass Solar Loan Program",
        states: [
            "ma"
        ]
    },
    {
        value: 995919,
        label: "City of Boston - Green Building Standard",
        states: [
            "ma"
        ]
    },
    {
        value: 9913956,
        label: "Mass Save - New Construction/Major Renovations Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9913947,
        label: "Columbia Gas of Massachusetts - Medium and Large Business Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 9913952,
        label: "Concord Municipal Light Plant - Energy Resources For Businesses",
        states: [
            "ma"
        ]
    },
    {
        value: 9913955,
        label: "National Grid - Building Operator Certification Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9914062,
        label: "National Grid - Building Practices & Demonstration Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9914078,
        label: "National Grid - Energy Profiler Online",
        states: [
            "ma"
        ]
    },
    {
        value: 9916193,
        label: "Holyoke Gas & Electric - Commercial Energy Audits",
        states: [
            "ma"
        ]
    },
    {
        value: 9916282,
        label: "Massachusetts Executive Office of Energy and Environmental Affairs - Energy Efficiency Assistance for Business",
        states: [
            "ma"
        ]
    },
    {
        value: 9916286,
        label: "Massachusetts Office of Technical Assistance and Technology - OTA Software Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 9916287,
        label: "Massachusetts Office of Technical Assistance and Technology - OTA Energy Publications",
        states: [
            "ma"
        ]
    },
    {
        value: 9916289,
        label: "U.S. Department of Energy - Massachusetts Energy Efficiency Partnership",
        states: [
            "ma"
        ]
    },
    {
        value: 9917454,
        label: "National Grid - Financing Solutions For Natural Gas Equipment",
        states: [
            "ma"
        ]
    },
    {
        value: 9917458,
        label: "National Grid - Power Quality Enhancements Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9917478,
        label: "Berkshire Gas - GasNetworks Commercial & Industrial High Efficiency Heating Rebate Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9917480,
        label: "National Grid - Demand Response",
        states: [
            "ma"
        ]
    },
    {
        value: 9917481,
        label: "National Grid - Enhanced Metering",
        states: [
            "ma"
        ]
    },
    {
        value: 9917573,
        label: "Massachusetts Division of Energy Resources - Education and Outreach Programs for Businesses",
        states: [
            "ma"
        ]
    },
    {
        value: 9917574,
        label: "Massachusetts Division of Energy Resources - Municipal Energy Efficiency",
        states: [
            "ma"
        ]
    },
    {
        value: 9917578,
        label: "Western Massachusetts Electric - Massachusetts Energy Efficiency Partnership",
        states: [
            "ma"
        ]
    },
    {
        value: 9917727,
        label: "Massachusetts Office of Technical Assistance and Technology - Energy Efficiency for Businesses & Institutions",
        states: [
            "ma"
        ]
    },
    {
        value: 9918962,
        label: "Hudson Light & Power - Commercial and Industrial Energy Audits",
        states: [
            "ma"
        ]
    },
    {
        value: 9919774,
        label: "Western Massachusetts Electric - Power Purchase",
        states: [
            "ma"
        ]
    },
    {
        value: 9919888,
        label: "Westfield Gas & Electric Light Dept. - Commercial & Industrial New Construction and Lost Opportunity Pilot Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9919911,
        label: "Ipswich Municipal Light - Commercial & Industrial Energy Efficiency Programs",
        states: [
            "ma"
        ]
    },
    {
        value: 9919913,
        label: "Ipswich Municipal Light - Commercial & Industrial New Construction and Major Renovation Pilot Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9919914,
        label: "Ipswich Municipal Light - Commercial & Industrial Renewable Energy and Demand Response Options",
        states: [
            "ma"
        ]
    },
    {
        value: 9920099,
        label: "Massachusetts Division of Energy Resources - Assessments and Audits",
        states: [
            "ma"
        ]
    },
    {
        value: 9920123,
        label: "Columbia Gas of Massachusetts - Small Business Energy Efficiency Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9920258,
        label: "Chicopee Electric Light - Custom Retrofit GO Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9920625,
        label: "Taunton Municipal Lighting Plant - Net Metering",
        states: [
            "ma"
        ]
    },
    {
        value: 9921157,
        label: "National Grid - Massachusetts Energy Efficiency Services",
        states: [
            "ma"
        ]
    },
    {
        value: 9921171,
        label: "National Grid - Rhode Island Energy Efficiency Services",
        states: [
            "ma"
        ]
    },
    {
        value: 9921186,
        label: "Mass Save - Small Business Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9921187,
        label: "National Grid - Construction Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9921571,
        label: "Unitil - Energy Saving Tips",
        states: [
            "ma"
        ]
    },
    {
        value: 9921671,
        label: "ISO New England - Demand Resources",
        states: [
            "ma"
        ]
    },
    {
        value: 9921674,
        label: "Northeast Energy Efficiency Council - Building Operator Certification (BOC)",
        states: [
            "ma"
        ]
    },
    {
        value: 9922020,
        label: "Northeast Energy Efficiency Partnerships - EM&V Forum",
        states: [
            "ma"
        ]
    },
    {
        value: 9922036,
        label: "Commercial Biomass Heating Grant Program",
        states: [
            "ma"
        ]
    },
    {
        value: 9921635,
        label: "FirstEnergy Solutions - Business Energy Analyzer",
        states: [
            "nj"
        ]
    },
    {
        value: 991477,
        label: "ENERGY STAR Homes Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995715,
        label: "SREC-Based Financing Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995716,
        label: "SREC-Based Financing Program (ACE, JCP&L, RECO)",
        states: [
            "nj"
        ]
    },
    {
        value: 995717,
        label: "SREC-Based Financing Program (ACE, JCP&L, RECO)",
        states: [
            "nj"
        ]
    },
    {
        value: 991465,
        label: "South Jersey Gas - Residential Loan Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995728,
        label: "New Jersey Natural Gas- SAVEGREEN Commercial On-Bill Financing Program",
        states: [
            "nj"
        ]
    },
    {
        value: 99898,
        label: "New Jersey - Green Power Purchasing",
        states: [
            "nj"
        ]
    },
    {
        value: 992979,
        label: "New Jersey Natural Gas (NJNG) - Home Performance with Energy Star Rebate",
        states: [
            "nj"
        ]
    },
    {
        value: 995729,
        label: "South Jersey Gas Commerical and Industrial Loan Program",
        states: [
            "nj"
        ]
    },
    {
        value: 991326,
        label: "Combined Heat & Power (CHP) Program",
        states: [
            "nj"
        ]
    },
    {
        value: 993461,
        label: "Clean Energy Solutions Capital Investment Loan/Grant Program",
        states: [
            "nj"
        ]
    },
    {
        value: 991249,
        label: "Renewable Energy Business Venture Assistance Program (REBVAP)",
        states: [
            "nj"
        ]
    },
    {
        value: 99797,
        label: "Interconnection Standards",
        states: [
            "nj"
        ]
    },
    {
        value: 991152,
        label: "Sustainable Development Loan Fund",
        states: [
            "nj"
        ]
    },
    {
        value: 991151,
        label: "NJ Clean Energy- WARMAdvantage Program (Electric and Gas)",
        states: [
            "nj"
        ]
    },
    {
        value: 994983,
        label: "PSE&G - Multi-Family Residential Efficiency Program",
        states: [
            "nj"
        ]
    },
    {
        value: 9916416,
        label: "New Jersey Natural Gas - Energy-Saving Tips for Your Business",
        states: [
            "nj"
        ]
    },
    {
        value: 991855,
        label: "Building Energy Code",
        states: [
            "nj"
        ]
    },
    {
        value: 9916482,
        label: "New Jersey Board of Public Utilities - Pay for Performance",
        states: [
            "nj"
        ]
    },
    {
        value: 9916483,
        label: "New Jersey Board of Public Utilities - Renewable Energy Program",
        states: [
            "nj"
        ]
    },
    {
        value: 992722,
        label: "Residential Solar Rights",
        states: [
            "nj"
        ]
    },
    {
        value: 995012,
        label: "Orange and Rockland Utilities (Electric) - HVAC Efficiency Program",
        states: [
            "nj"
        ]
    },
    {
        value: 994805,
        label: "New Jersey Natural Gas - SAVEGREEN Residential On-Bill Financing Program",
        states: [
            "nj"
        ]
    },
    {
        value: 9921638,
        label: "First Energy - Business Energy Analyzer",
        states: [
            "nj"
        ]
    },
    {
        value: 993671,
        label: "Solar Domestic Hot Water Pilot Program",
        states: [
            "nj"
        ]
    },
    {
        value: 99595,
        label: "Renewable Energy Advanced Power Program",
        states: [
            "nj"
        ]
    },
    {
        value: 993678,
        label: "Edison Innovation Clean Energy Fund",
        states: [
            "nj"
        ]
    },
    {
        value: 99589,
        label: "New Jersey Renewable Energy Incentive Program (Sustainable Biopower)",
        states: [
            "nj"
        ]
    },
    {
        value: 991568,
        label: "Energy Efficiency Product Standards",
        states: [
            "nj"
        ]
    },
    {
        value: 992910,
        label: "PSE&G - Solar Loan Program",
        states: [
            "nj"
        ]
    },
    {
        value: 991150,
        label: "COOLAdvantage Program",
        states: [
            "nj"
        ]
    },
    {
        value: 99565,
        label: "Environmental Information Disclosure",
        states: [
            "nj"
        ]
    },
    {
        value: 992890,
        label: "New Jersey Comfort Partners Program",
        states: [
            "nj"
        ]
    },
    {
        value: 991149,
        label: "Clean Energy Financing for Businesses",
        states: [
            "nj"
        ]
    },
    {
        value: 993736,
        label: "Grid-Connected Renewables Program",
        states: [
            "nj"
        ]
    },
    {
        value: 99219,
        label: "Solar Energy Sales Tax Exemption",
        states: [
            "nj"
        ]
    },
    {
        value: 991148,
        label: "Cogeneration Facility Sales Tax Exemption",
        states: [
            "nj"
        ]
    },
    {
        value: 993756,
        label: "New Jersey Natural Gas - SAVEGREEN Residential Rebate Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995205,
        label: "Small Scale CHP and Fuel Cell Incentive Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995811,
        label: "NJ Clean Energy- Residential New Construction Program",
        states: [
            "nj"
        ]
    },
    {
        value: 99564,
        label: "Renewables Portfolio Standard",
        states: [
            "nj"
        ]
    },
    {
        value: 994848,
        label: "Edison Innovation Green Growth Fund Loans",
        states: [
            "nj"
        ]
    },
    {
        value: 9917594,
        label: "U.S. Department of Energy Industrial Assessment Center (IAC): Lehigh University",
        states: [
            "nj"
        ]
    },
    {
        value: 9921919,
        label: "New Jersey\u2019s Clean Energy Program - Commercial Industrial and Local Government Programs",
        states: [
            "nj"
        ]
    },
    {
        value: 995873,
        label: "New Jersey Energy Resilience Bank",
        states: [
            "nj"
        ]
    },
    {
        value: 9922023,
        label: "Northeast Energy Efficiency Partnerships - EM&V Forum",
        states: [
            "nj"
        ]
    },
    {
        value: 995109,
        label: "Local Option - Property Assessed Clean Energy Financing",
        states: [
            "nj"
        ]
    },
    {
        value: 995567,
        label: "Local Energy Audit Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995568,
        label: "Large Energy Users Program",
        states: [
            "nj"
        ]
    },
    {
        value: 992359,
        label: "New Jersey SmartStart Buildings - New Construction and Retrofits",
        states: [
            "nj"
        ]
    },
    {
        value: 992615,
        label: "South Jersey Gas - Residential Energy Efficiency Rebate Program",
        states: [
            "nj"
        ]
    },
    {
        value: 9919788,
        label: "New Jersey Board of Public Utilities - NJ Clean Energy Program",
        states: [
            "nj"
        ]
    },
    {
        value: 9938,
        label: "Net Metering",
        states: [
            "nj"
        ]
    },
    {
        value: 9914025,
        label: "New Jersey Board of Public Utilities - NJ SmartStart Buildings",
        states: [
            "nj"
        ]
    },
    {
        value: 9914029,
        label: "Atlantic City Electric - Energy Profiler Online",
        states: [
            "nj"
        ]
    },
    {
        value: 99168,
        label: "Societal Benefits Charge",
        states: [
            "nj"
        ]
    },
    {
        value: 9921541,
        label: "FirstEnergy Solutions - Power Management Platform",
        states: [
            "nj"
        ]
    },
    {
        value: 993883,
        label: "Renewable Energy Manufacturing Incentives (for End-Use PV Installations)",
        states: [
            "nj"
        ]
    },
    {
        value: 994548,
        label: "Utility Solar Financing Incentive (ACE, JCP&L, RECO)",
        states: [
            "nj"
        ]
    },
    {
        value: 994588,
        label: "PSE&G - Commercial Efficiency Program",
        states: [
            "nj"
        ]
    },
    {
        value: 991110,
        label: "Solar Renewable Energy Certificates (SRECs)",
        states: [
            "nj"
        ]
    },
    {
        value: 993907,
        label: "PSE&G - Residential Efficiency Program",
        states: [
            "nj"
        ]
    },
    {
        value: 993929,
        label: "Solar and Wind Permitting Laws",
        states: [
            "nj"
        ]
    },
    {
        value: 994933,
        label: "Clean Energy Solutions Energy Efficiency Revolving Loan Fund",
        states: [
            "nj"
        ]
    },
    {
        value: 991054,
        label: "Renewable Energy Economic Development Program (REED)",
        states: [
            "nj"
        ]
    },
    {
        value: 991053,
        label: "Clean Energy Financing for Local Schools and Governments (REDO Program)",
        states: [
            "nj"
        ]
    },
    {
        value: 993100,
        label: "Property Tax Exemption for Renewable Energy Systems",
        states: [
            "nj"
        ]
    },
    {
        value: 9919,
        label: "Solar Easements",
        states: [
            "nj"
        ]
    },
    {
        value: 9921920,
        label: "New Jersey Manufacturing Extension Program - Operational Excellence Program",
        states: [
            "nj"
        ]
    },
    {
        value: 9921921,
        label: "New Jersey Board of Public Utilities - Commercial Customers",
        states: [
            "nj"
        ]
    },
    {
        value: 993966,
        label: "New Jersey Direct Install Program",
        states: [
            "nj"
        ]
    },
    {
        value: 993031,
        label: "NJ Clean Energy- ENERGY STAR Appliance Rebate program",
        states: [
            "nj"
        ]
    },
    {
        value: 993014,
        label: "High Performance Building Standards in New State Construction",
        states: [
            "nj"
        ]
    },
    {
        value: 994023,
        label: "Solar Energy Option Requirement for Residential Developments",
        states: [
            "nj"
        ]
    },
    {
        value: 994026,
        label: "Assessment of Farmland Hosting Renewable Energy Systems",
        states: [
            "nj"
        ]
    },
    {
        value: 994034,
        label: "New Jersey - Residential Energy Efficient Appliance Rebate Program",
        states: [
            "nj"
        ]
    },
    {
        value: 994335,
        label: "Clean Energy Solutions ARRA CHP Program",
        states: [
            "nj"
        ]
    },
    {
        value: 994560,
        label: "Utility Solar Financing Programs (ACE, JCP&L, RECO)",
        states: [
            "nj"
        ]
    },
    {
        value: 993266,
        label: "Edison Innovation Clean Energy Manufacturing Fund - Grants and Loans",
        states: [
            "nj"
        ]
    },
    {
        value: 994360,
        label: "Wind Manufacturing Tax Credit",
        states: [
            "nj"
        ]
    },
    {
        value: 9919892,
        label: "South Jersey Gas - Business Services",
        states: [
            "nj"
        ]
    },
    {
        value: 991906,
        label: "High Performance Schools Policy",
        states: [
            "nj"
        ]
    },
    {
        value: 9920368,
        label: "New Jersey's Clean Energy Program - Pay for Performance",
        states: [
            "nj"
        ]
    },
    {
        value: 9920375,
        label: "New Jersey's Clean Energy Program - Energy Benchmarking",
        states: [
            "nj"
        ]
    },
    {
        value: 9919893,
        label: "South Jersey Gas - Business Services \u05E0Commercial Accounts",
        states: [
            "nj"
        ]
    },
    {
        value: 993330,
        label: "Pay for Performance Program",
        states: [
            "nj"
        ]
    },
    {
        value: 994982,
        label: "PSE&G - Government and Non-Profit Facility Direct Install Efficiency Program",
        states: [
            "nj"
        ]
    },
    {
        value: 991502,
        label: "Home Performance with ENERGY STAR Program",
        states: [
            "nj"
        ]
    },
    {
        value: 992978,
        label: "Home Performance with ENERGY STAR Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995165,
        label: "Clean Energy Solutions Large Scale CHP and Fuel Cells Program",
        states: [
            "nj"
        ]
    },
    {
        value: 995687,
        label: "Solar Renewable Energy Certificates (SRECs) Registration Program",
        states: [
            "nj"
        ]
    },
    {
        value: 992014,
        label: "Austin Energy - Small Business Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995254,
        label: "Brownsville Public Utilities Board - Green Living Residential Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995304,
        label: "Texas Gas Service - Residential Solar Water Heating Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992013,
        label: "Austin Energy - Commercial Energy Management Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992012,
        label: "Austin Energy - Residential Energy Efficiency Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921808,
        label: "Xcel Energy - Energy At Risk Financial Analysis Tool",
        states: [
            "tx"
        ]
    },
    {
        value: 992011,
        label: "Austin Energy - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995352,
        label: "TXU - Commercial Energy Efficiency Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992021,
        label: "Bryan Texas Utilities - Low-Interest Insulation Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921810,
        label: "Xcel Energy - Energy Management Systems",
        states: [
            "tx"
        ]
    },
    {
        value: 991900,
        label: "Building Energy Code",
        states: [
            "tx"
        ]
    },
    {
        value: 995411,
        label: "Bryan Texas Utilities - SmartHOME Program",
        states: [
            "tx"
        ]
    },
    {
        value: 991594,
        label: "Xcel Energy - Air Conditioner Distributor Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995447,
        label: "Austin Energy - Value of Solar Residential Rate",
        states: [
            "tx"
        ]
    },
    {
        value: 991593,
        label: "Xcel Energy - Residential and Hard-to-Reach Standard Offer Program",
        states: [
            "tx"
        ]
    },
    {
        value: 991592,
        label: "Xcel Energy - Commercial and Industrial Standard Offer Program",
        states: [
            "tx"
        ]
    },
    {
        value: 991548,
        label: "Texas-New Mexico Power Company - Energy Star Homes Market Transformation Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995490,
        label: "Entergy Texas - Home Performance with ENERGY STAR",
        states: [
            "tx"
        ]
    },
    {
        value: 9921817,
        label: "Atmos Energy - Business Savings",
        states: [
            "tx"
        ]
    },
    {
        value: 995545,
        label: "El Paso Electric Company - Net Metering",
        states: [
            "tx"
        ]
    },
    {
        value: 995547,
        label: "San Antonio City Public Service (CPS Energy) - Net Metering",
        states: [
            "tx"
        ]
    },
    {
        value: 995570,
        label: "City of Denton - Green Power Purchasing",
        states: [
            "tx"
        ]
    },
    {
        value: 995592,
        label: "City of Forth Worth - Green Building Policy for Municipal Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 995590,
        label: "City of Fort Worth - Residential and Commercial Green Building Requirements",
        states: [
            "tx"
        ]
    },
    {
        value: 995593,
        label: "City of Houston - Residential and Commercial Green Building Requirements",
        states: [
            "tx"
        ]
    },
    {
        value: 995594,
        label: "City of El Paso - Green Building Policy for Municipal Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 995595,
        label: "City of El Paso - Residential and Commercial Green Building Requirements",
        states: [
            "tx"
        ]
    },
    {
        value: 991544,
        label: "Texas-New Mexico Power Company - SCORE/CitySmart, Commercial Solutions, and Small Business Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 991543,
        label: "Texas-New Mexico Power Company - Residential, Hard-to-Reach, and High-Performance New Homes Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 991542,
        label: "Texas Gas Service - Commercial Water Heating Energy Efficiency Program",
        states: [
            "tx"
        ]
    },
    {
        value: 991540,
        label: "Texas Gas Service - Food Service Equipment Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921955,
        label: "El Paso Electric Company - Tools, Tips, and Calculators",
        states: [
            "tx"
        ]
    },
    {
        value: 995669,
        label: "Austin Energy - Value of Solar Residential Rate",
        states: [
            "tx"
        ]
    },
    {
        value: 991536,
        label: "Texas Gas Service - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 991538,
        label: "Texas Gas Service - Commercial Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 991485,
        label: "American Electric Power - Standard Offer Demand Response Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995741,
        label: "CenterPoint Energy Healthcare Energy Efficiency Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995742,
        label: "CenterPoint Energy Sustainable Schools Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995743,
        label: "CenterPoint Energy New Homes Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995744,
        label: "CenterPoint Energy Advanced Residential Lighting Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995745,
        label: "CenterPoint Energy A/C Distributor Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995746,
        label: "CenterPoint Energy's Energy Wise Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995748,
        label: "CenterPoint Energy Low-Rise Multi Family Program",
        states: [
            "tx"
        ]
    },
    {
        value: 99182,
        label: "Renewable Generation Requirement",
        states: [
            "tx"
        ]
    },
    {
        value: 9921956,
        label: "El Paso Electric Company - Energy Library",
        states: [
            "tx"
        ]
    },
    {
        value: 99173,
        label: "Renewable Energy Systems Property Tax Exemption",
        states: [
            "tx"
        ]
    },
    {
        value: 995858,
        label: "Garland Power & Light - Solar Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995893,
        label: "City of San Antonio - Sec. 35-398. - Renewable Energy Systems",
        states: [
            "tx"
        ]
    },
    {
        value: 9921101,
        label: "Pedernales Electric Cooperative - My Use Energy Analyzer",
        states: [
            "tx"
        ]
    },
    {
        value: 9982,
        label: "Solar and Wind Energy Business Franchise Tax Exemption",
        states: [
            "tx"
        ]
    },
    {
        value: 995944,
        label: "City of San Antonio - Energy Conservation Code",
        states: [
            "tx"
        ]
    },
    {
        value: 991134,
        label: "LoanSTAR Revolving Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9981,
        label: "Solar and Wind Energy Device Franchise Tax Deduction",
        states: [
            "tx"
        ]
    },
    {
        value: 9961,
        label: "San Antonio City Public Service - Distributed Generation Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9915761,
        label: "Austin Energy - Load Profiler",
        states: [
            "tx"
        ]
    },
    {
        value: 9915763,
        label: "Austin Energy - Energy Conservation Audit and Disclosure Ordinance",
        states: [
            "tx"
        ]
    },
    {
        value: 991088,
        label: "Austin Energy - Residential Solar PV Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921567,
        label: "El Paso Electric - Energy Library",
        states: [
            "tx"
        ]
    },
    {
        value: 993082,
        label: "Oncor Electric Delivery - Commercial and Industrial Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993168,
        label: "Oncor Electric Delivery - Solar Photovoltaic Standard Offer Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993006,
        label: "Plano - Renewable Energy Purchasing Policy",
        states: [
            "tx"
        ]
    },
    {
        value: 9915,
        label: "Fuel Mix and Emissions Disclosure",
        states: [
            "tx"
        ]
    },
    {
        value: 993004,
        label: "City of Plano - Green Building Policy for Municipal Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 992988,
        label: "Oncor Electric Delivery - Data Center Energy Management Pilot Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993285,
        label: "Garland Power & Light - Energy Efficiency Rebate Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 993298,
        label: "Oncor Electric Delivery - Solar Water Heating Incentive Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993313,
        label: "Guadalupe Valley Electric Cooperative - Renewable Energy Rebates",
        states: [
            "tx"
        ]
    },
    {
        value: 993322,
        label: "Guadalupe Valley Electric Cooperative - Residential Energy Efficiency Rebate Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 9921624,
        label: "El Paso Electric - Tools, Tips, and Calculators",
        states: [
            "tx"
        ]
    },
    {
        value: 993346,
        label: "Entergy Texas - Home Performance with ENERGY STAR Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921628,
        label: "El Paso Electric Company - Large Commercial Solutions Program",
        states: [
            "tx"
        ]
    },
    {
        value: 99981,
        label: "Ethanol and Biodiesel Production Incentive",
        states: [
            "tx"
        ]
    },
    {
        value: 993400,
        label: "Green Mountain Energy Renewable Rewards Buy-Back Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993419,
        label: "Texas New Mexico Power Company - Solar PV Pilot Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993429,
        label: "Entergy Texas - Solar PV Pilot Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993430,
        label: "Denton Municipal Electric - Commercial Standard Offer Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993432,
        label: "Pedernales Electric Cooperative - Commercial  Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992947,
        label: "Bryan Texas Utilities - Solar Hot Water Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 99897,
        label: "City of Austin - Renewables Portfolio Standard",
        states: [
            "tx"
        ]
    },
    {
        value: 99805,
        label: "Interconnection Standards",
        states: [
            "tx"
        ]
    },
    {
        value: 993480,
        label: "Denton Municipal Electric - GreenSense Solar PV/Thermal Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992946,
        label: "Bryan Texas Utilities - Solar PV Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 99702,
        label: "Hansford County Tax Abatement",
        states: [
            "tx"
        ]
    },
    {
        value: 993630,
        label: "New Braunfels Utilities - Energy Efficiency and Water Conservation Rebate Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 993660,
        label: "AEP Texas - Commercial and Industrial Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993661,
        label: "AEP Texas Central Company - SMART Source Solar PV Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993669,
        label: "AEP Texas North Company - SMART Source Solar PV Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993670,
        label: "AEP (SWEPCO) - SMART Source Solar PV Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992925,
        label: "Austin Energy - Commercial New Construction Efficiency Rebates",
        states: [
            "tx"
        ]
    },
    {
        value: 993727,
        label: "City of Sunset Valley - PV Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993735,
        label: "City of Sunset Valley - Solar Water Heating Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993742,
        label: "Renewable Energy Demonstration Pilot Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993743,
        label: "Department of Rural Affairs - Wind Energy for Desalination Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992887,
        label: "City of Houston - Green Building Policy for Municipal Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 992885,
        label: "City of Houston - Green Power Purchasing",
        states: [
            "tx"
        ]
    },
    {
        value: 992884,
        label: "City of Dallas - Green Energy Purchasing",
        states: [
            "tx"
        ]
    },
    {
        value: 993825,
        label: "AEP SWEPCO - SCORE Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993827,
        label: "AEP Texas Central Company - CitySmart Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993828,
        label: "AEP Texas Central Company - Commercial Solutions Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993829,
        label: "AEP Texas Central Company - SCORE Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993830,
        label: "AEP Texas North Company - CitySmart Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993831,
        label: "AEP (Central, SWEPCO and North) - Commercial Solutions Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993832,
        label: "AEP Texas North Company - SCORE Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993833,
        label: "CenterPoint Energy - SCORE and CitySmart Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993834,
        label: "CenterPoint Energy - SCORE Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993835,
        label: "Entergy Texas - CitySmart Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993838,
        label: "El Paso Electric Company - Residential Solutions Program",
        states: [
            "tx"
        ]
    },
    {
        value: 993840,
        label: "El Paso Electric Company - Small Business and Large Commercial Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 992795,
        label: "CPS Energy - Commercial Energy Efficiency Rebates",
        states: [
            "tx"
        ]
    },
    {
        value: 99530,
        label: "Big Country Electric Coop - PV Water Pump Sales & Lease Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994917,
        label: "CoServ - Solar Energy Rebate",
        states: [
            "tx"
        ]
    },
    {
        value: 992794,
        label: "CPS Energy - Solar PV Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992797,
        label: "CPS Energy - Solar Hot Water Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992779,
        label: "Advanced Clean Energy Project Grants",
        states: [
            "tx"
        ]
    },
    {
        value: 992766,
        label: "ENERGY STAR Sales Tax Holiday for Energy-Efficient Products",
        states: [
            "tx"
        ]
    },
    {
        value: 992762,
        label: "City of Austin - Green Power Purchasing",
        states: [
            "tx"
        ]
    },
    {
        value: 992749,
        label: "City of Austin - Residential and Commercial Green Building Requirements",
        states: [
            "tx"
        ]
    },
    {
        value: 992741,
        label: "City of Dallas - Green Building Policy for Municipal Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 992730,
        label: "Frisco - Municipal Green Building Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992729,
        label: "City of Frisco - Residential and Commercial Green Building Requirements",
        states: [
            "tx"
        ]
    },
    {
        value: 99517,
        label: "Austin Energy - Home Energy Loans",
        states: [
            "tx"
        ]
    },
    {
        value: 993972,
        label: "Austin Energy - Commercial Solar PV Incentive Program",
        states: [
            "tx"
        ]
    },
    {
        value: 99513,
        label: "Austin Energy - Solar Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 99511,
        label: "Austin Energy - Solar Water Heating Rebate",
        states: [
            "tx"
        ]
    },
    {
        value: 993535,
        label: "PACE Financing (Local Option - Contractual Assessments for Energy Efficient Improvements)",
        states: [
            "tx"
        ]
    },
    {
        value: 99337,
        label: "Mandatory Renewable Energy Educational Materials",
        states: [
            "tx"
        ]
    },
    {
        value: 9917413,
        label: "Texas State Energy Conservation Office - Innovative Energy Demonstration Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994147,
        label: "CPS Energy - Solartricity Producer Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994176,
        label: "Green Mountain Energy Renewable Rewards Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994196,
        label: "El Paso Electric Company - Solar PV Pilot Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994228,
        label: "Bandera Electric Cooperative - Residential Heat Pump Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9917415,
        label: "Texas State Energy Conservation Office - Texas Industries of the Future Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9915772,
        label: "Brownsville Public Utilities Board - Customer Engineering-Energy Services",
        states: [
            "tx"
        ]
    },
    {
        value: 9917418,
        label: "Entergy Texas - Datalink",
        states: [
            "tx"
        ]
    },
    {
        value: 9917433,
        label: "Denton Municipal Electric - Load Profiler",
        states: [
            "tx"
        ]
    },
    {
        value: 9917434,
        label: "Lower Colorado River Authority - Energy Services",
        states: [
            "tx"
        ]
    },
    {
        value: 9917437,
        label: "Texas Renewable Energy Industries Association - General Info & Links",
        states: [
            "tx"
        ]
    },
    {
        value: 994289,
        label: "AEP SWEPCO - CitySmart Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921636,
        label: "Rio Grande Electric Coop - Interconnection",
        states: [
            "tx"
        ]
    },
    {
        value: 994320,
        label: "CPS Energy - Small Business Lighting Retrofit Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994322,
        label: "City of San Antonio and CPS Energy - City Lights Small Business Energy Efficiency Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992653,
        label: "Entergy Texas - SCORE, CitySmart, and Commercial Solutions Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 992652,
        label: "Entergy Texas - Residential and Small Commercial Standard Offer Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994350,
        label: "Texas - Residential Energy-Efficient Appliance Rebates",
        states: [
            "tx"
        ]
    },
    {
        value: 992650,
        label: "CenterPoint Energy - Residential and Small Commercial Efficiency Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992649,
        label: "CenterPoint Energy - Commercial and Industrial Energy Efficiency Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 992648,
        label: "Oncor Electric Delivery - Home Energy Efficiency Program (Texas)",
        states: [
            "tx"
        ]
    },
    {
        value: 992647,
        label: "Oncor Electric Delivery - Energy Star Homes Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992631,
        label: "Bryan Texas Utilities - Commercial Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994363,
        label: "CenterPoint Energy - ENERGY STAR Homes Efficiency Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921750,
        label: "Entergy Louisiana - DataLink",
        states: [
            "tx"
        ]
    },
    {
        value: 994470,
        label: "Garland Power & Light: Commercial Lighting Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994480,
        label: "AEP (Central and North) - Residential Energy Efficiency Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 99335,
        label: "Alternative Energy in New State Construction",
        states: [
            "tx"
        ]
    },
    {
        value: 992473,
        label: "San Antonio City Public Service (CPS Energy) - Renewable Portfolio Goal",
        states: [
            "tx"
        ]
    },
    {
        value: 992464,
        label: "City of Austin - Green Building Policy for Municipal Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 9915778,
        label: "College Station Utilities - Energy Surveys",
        states: [
            "tx"
        ]
    },
    {
        value: 992315,
        label: "Energy Efficiency Goals and Requirements for Public Entities",
        states: [
            "tx"
        ]
    },
    {
        value: 99334,
        label: "Certification of Solar Collectors",
        states: [
            "tx"
        ]
    },
    {
        value: 9921793,
        label: "Xcel Energy - Energy Design Assistance",
        states: [
            "tx"
        ]
    },
    {
        value: 992091,
        label: "Farmers Electric Cooperative - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992090,
        label: "Guadalupe Valley Electric Cooperative - Conservation Plan 7 Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992089,
        label: "Magic Valley Electric Cooperative - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9915786,
        label: "Entergy Texas - Commercial Solutions Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921794,
        label: "Xcel Energy - Online Energy Assessment",
        states: [
            "tx"
        ]
    },
    {
        value: 994587,
        label: "City of Brenham - Net Metering",
        states: [
            "tx"
        ]
    },
    {
        value: 994593,
        label: "El Paso Electric Company - SCORE Program for Counties, Municipalities, and Schools",
        states: [
            "tx"
        ]
    },
    {
        value: 994594,
        label: "AEP (Central and SWEPCO) - Coolsaver A/C Tune Up or Replacement",
        states: [
            "tx"
        ]
    },
    {
        value: 9921800,
        label: "Xcel Energy - Energy Audits and Studies",
        states: [
            "tx"
        ]
    },
    {
        value: 994601,
        label: "Oncor Electric Delivery - Government and Education Facilities Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994602,
        label: "Oncor Electric Delivery - City and School Matching Grant Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9915792,
        label: "Garland Power & Light - Energy Audit",
        states: [
            "tx"
        ]
    },
    {
        value: 994622,
        label: "Required Energy Efficiency Goals",
        states: [
            "tx"
        ]
    },
    {
        value: 9917695,
        label: "Brownsville Public Utilities Board - Customer Engineering-Energy Services",
        states: [
            "tx"
        ]
    },
    {
        value: 9915798,
        label: "New Braunfels Utilities - Energy Audit",
        states: [
            "tx"
        ]
    },
    {
        value: 994658,
        label: "City of Houston - Energy Efficiency Incentive Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992088,
        label: "Pedernales Electric Cooperative - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994720,
        label: "City of Houston - Property Tax Abatement for Green Commercial Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 994748,
        label: "City of San Antonio - Residential and Commercial Green Building Requirements",
        states: [
            "tx"
        ]
    },
    {
        value: 994750,
        label: "City of San Antonio - Green Building Policy for Municipal Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 994751,
        label: "City of San Antonio -Tax Abatement Scorecard Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994770,
        label: "CoServ Electric Cooperative - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994771,
        label: "CoServ Electric Cooperative - Commercial Energy Efficient Lighting Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 994788,
        label: "CPS Energy - New Commercial Construction Incentives",
        states: [
            "tx"
        ]
    },
    {
        value: 994789,
        label: "CPS Energy - New Residential Construction Incentives",
        states: [
            "tx"
        ]
    },
    {
        value: 9917705,
        label: "Denton Municipal Electric - Commercial Energy Services",
        states: [
            "tx"
        ]
    },
    {
        value: 994792,
        label: "City of Dallas - Green Building Expedited Plan Review",
        states: [
            "tx"
        ]
    },
    {
        value: 994793,
        label: "City of Dallas - Residential and Commercial Green Building Requirements",
        states: [
            "tx"
        ]
    },
    {
        value: 9921802,
        label: "Xcel Energy - Small Business Lighting",
        states: [
            "tx"
        ]
    },
    {
        value: 994796,
        label: "New Braunfels Utilities - Residential Solar Water Heater Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9917847,
        label: "Kerrville Public Utility Board - Business Energy Audits",
        states: [
            "tx"
        ]
    },
    {
        value: 99327,
        label: "Austin Energy - Net Metering",
        states: [
            "tx"
        ]
    },
    {
        value: 99288,
        label: "Texas - Net Metering",
        states: [
            "tx"
        ]
    },
    {
        value: 9918961,
        label: "Wharton County Electric Coop - Energy Audits",
        states: [
            "tx"
        ]
    },
    {
        value: 994864,
        label: "City of Austin - Zoning Code",
        states: [
            "tx"
        ]
    },
    {
        value: 994880,
        label: "Solar Rights",
        states: [
            "tx"
        ]
    },
    {
        value: 992087,
        label: "Tri-County Electric Cooperative - Energy Efficient Water Heater Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921803,
        label: "Xcel Energy - Business Energy Advisor",
        states: [
            "tx"
        ]
    },
    {
        value: 994911,
        label: "Harris County - Property Tax Abatement for Green Commercial Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 994912,
        label: "Harris County - Green Building Policy for County Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 994948,
        label: "Magic Valley Electric Cooperative - ENERGY STAR Builders Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992084,
        label: "United Cooperative Services - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992039,
        label: "Denton Municipal Electric - Residential GreenSense Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9918980,
        label: "TXU Energy - iThermostat for Business",
        states: [
            "tx"
        ]
    },
    {
        value: 995008,
        label: "City of Friendswood - Property Tax Abatement for Green Commercial Buildings",
        states: [
            "tx"
        ]
    },
    {
        value: 9918981,
        label: "TXU Energy - PowerReport",
        states: [
            "tx"
        ]
    },
    {
        value: 9919309,
        label: "Garland Power & Light - Energy Depot for Business",
        states: [
            "tx"
        ]
    },
    {
        value: 9919311,
        label: "TXU Energy PowerReport",
        states: [
            "tx"
        ]
    },
    {
        value: 992036,
        label: "CPS Energy (Electric) - Residential Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9919314,
        label: "AEP Texas Central Company - Commercial Solutions Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995117,
        label: "City of San Marcos - Distributed Generation Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995118,
        label: "City of San Marcos - Energy Efficient Home Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992029,
        label: "College Station Utilities - Residential Energy Back II Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992028,
        label: "Bryan Texas Utilities - Appliance Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995126,
        label: "AEP (SWEPCO) - Residential Energy Efficiency Programs",
        states: [
            "tx"
        ]
    },
    {
        value: 995139,
        label: "Austin Energy - Value of Solar Residential Rate",
        states: [
            "tx"
        ]
    },
    {
        value: 995154,
        label: "Austin Energy - Residential Solar Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9919316,
        label: "AEP Texas North Company - Commercial Solutions Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992026,
        label: "Bryan Texas Utilities - Energy Efficiency Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992020,
        label: "Austin Energy - Energy Miser Vending Products Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995170,
        label: "AEP (Central, SWEPCO and North) - SCORE Program for Schools",
        states: [
            "tx"
        ]
    },
    {
        value: 995171,
        label: "AEP (Central and North) - CitySmart Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995176,
        label: "Sharyland Utilities - Commercial Standard Offer Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995177,
        label: "Sharyland Utilities - Residential Standard Offer Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9919669,
        label: "Mid South Synergy - Business Energy Advisor",
        states: [
            "tx"
        ]
    },
    {
        value: 992016,
        label: "Austin Energy - Free Home Energy Improvements Program",
        states: [
            "tx"
        ]
    },
    {
        value: 992015,
        label: "Austin Energy - Multi-Family Energy Efficiency Rebate Program",
        states: [
            "tx"
        ]
    },
    {
        value: 995221,
        label: "City of Plano - Smart Energy Loan Program",
        states: [
            "tx"
        ]
    },
    {
        value: 9921806,
        label: "Xcel Energy - Business Solutions",
        states: [
            "tx"
        ]
    },
    {
        value: 99727,
        label: "Residential Energy Conservation Subsidy Exclusion (Corporate)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99729,
        label: "Renewable Energy Production Incentive (REPI)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99722,
        label: "USDA Rural Housing Service Loans",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991709,
        label: "Federal Appliance Standards",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917041,
        label: "The Hydraulic Institute",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917045,
        label: "Non-Ferrous Founders' Society - Energy Information",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 992393,
        label: "Energy Goals and Standards for Federal Agencies",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 995681,
        label: "USDA - Rural Energy for America Program (REAP) Energy Audit and Renewable Energy Development Assistance (EA/REDA) Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99726,
        label: "Deductions for Clean-Fuel Vehicles and Refueling Property",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99724,
        label: "Deductions for Clean-Fuel Vehicles and Refueling Property",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 992510,
        label: "Clean Renewable Energy Bonds (CREBs)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 992511,
        label: "USDA - Rural Energy for America Program (REAP) Loan Guarantees",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99734,
        label: "Renewable Electricity Production Tax Credit (PTC)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99736,
        label: "Alcohol Fuel Credit",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99737,
        label: "Small Business Administration Loan Programs",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99742,
        label: "Energy-Efficient Mortgages",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 995313,
        label: "USDA - Biorefinery Assistance Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991045,
        label: "Weatherization Assistance Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 995631,
        label: "FHA PowerSaver Loan Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9915956,
        label: "E-Source - Business Energy Advisor",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9915955,
        label: "Association of Energy Services Professionals - Brown Bag Energy Seminars",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991060,
        label: "Green Power Purchasing Goal for Federal Government",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99666,
        label: "Residential Energy Conservation Subsidy Exclusion (Personal)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 994359,
        label: "USDA - High Energy Cost Grant Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917967,
        label: "U.S. Department of Agriculture - Bioenergy Program for Advanced Biofuels",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99112,
        label: "Tax-Exempt Financing for Green Buildings, Renewable Energy & Brownfield Redevelopment",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9915954,
        label: "Association of Energy Engineers - Energy Training Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991096,
        label: "Value-Added Producer Grant Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9915953,
        label: "TPC Trainco - Industrial Energy Efficiency Training",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9922035,
        label: "Southeast Energy Efficiency Alliance (SEEA) - Resource Center",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917566,
        label: "U.S. Department of the Treasury - Payments for Specified Energy Property in Lieu of Tax Credits",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917544,
        label: "U.S. Environmental Protection Agency - ENERGY STAR Training",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 995780,
        label: "Fannie Mae Green Initiative- Loan Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99669,
        label: "Federal Excise Tax Exemption for Gasohol",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991235,
        label: "Residential Renewable Energy Tax Credit",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99348,
        label: "Conservation Security Program (CSP) Production Incentive",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 992774,
        label: "Interconnection Standards for Small Generators",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9921219,
        label: "CLEARresults",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9920736,
        label: "Gaz M\xe9tropolitain & Co., LP - Feasibility Studies",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99676,
        label: "Modified Accelerated Cost-Recovery System (MACRS)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99693,
        label: "2003 Climate Change Fuel Cell Buy-Down Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991271,
        label: "Energy-Efficient Commercial Buildings Tax Deduction",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991272,
        label: "Energy-Efficient New Homes Tax Credit for Home Builders",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9920513,
        label: "North Carolina Solar Center - Education, Analysis, and Modeling",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991273,
        label: "Energy-Efficient Appliance Manufacturing Tax Credit",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991274,
        label: "Residential Energy Efficiency Tax Credit",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991280,
        label: "Veterans Housing Guaranteed and Insured Loans",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 991616,
        label: "Energy Goals and Standards for Federal Government",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99658,
        label: "Business Energy Investment Tax Credit (ITC)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99700,
        label: "HUD Energy Efficient Mortgages",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9921075,
        label: "Dominion Hope - West Virginia - Business Energy Center",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99917,
        label: "USDA - Rural Energy for America Program (REAP) Grants",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917056,
        label: "Energy Sciences - Energy Management Services",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9916403,
        label: "Touchstone Energy Cooperatives - Commercial/Business Energy Advisor",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917051,
        label: "Energy Solutions Center -  Industrial Energy Efficiency Consortium",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 993280,
        label: "U.S. Department of Treasury - Renewable Energy Grants",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9916924,
        label: "National Center for Hydrogen Technology, University of North Dakota - Education and Outreach",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 993279,
        label: "Qualifying Advanced Energy Manufacturing Investment Tax Credit",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917050,
        label: "Edison Electric Institute - Energy Efficiency",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917049,
        label: "American Public Power Association - Energy Efficiency Resource Central",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99918,
        label: "Tribal Energy Program Grant",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917047,
        label: "Original Equipment Suppliers Association - Resources",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 993071,
        label: "U.S. Department of Energy - Loan Guarantee Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 995725,
        label: "Weatherization Assistance Program (WAP)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 995712,
        label: "Low Income Home Energy Assistance Program (LIHEAP)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 9917039,
        label: "U.S. Environmental Protection Agency - ENERGY STAR Guidelines for Energy Management",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 993098,
        label: "Qualified Energy Conservation Bonds (QECBs)",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 99718,
        label: "Energy Star Financing and Mortgages",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    },
    {
        value: 995316,
        label: "USDA - Repowering Assistance Biorefinery Program",
        states: [
            "ma",
            "nj",
            "tx",
            "ct"
        ]
    }
].filter((incentive)=>$3cb2c4846bbd3aaa$var$available.includes(incentive.value));

});



parcelRegister("7dntZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $540bf67a93d05e4a$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $fBBlk = parcelRequire("fBBlk");

var $lxEiN = parcelRequire("lxEiN");
class $540bf67a93d05e4a$var$Store {
    get issueCount() {
        return this.threads.filter((thread)=>!thread.closed).length;
    }
    constructor(){
        (0, $cr2GM._)(this, "threads", []);
        (0, $cr2GM._)(this, "projectId", null);
        (0, $cr2GM._)(this, "addMessageToThread", (threadId, messageOptions)=>{
            const newThreads = [
                ...this.threads
            ];
            const threadIndex = newThreads.findIndex((thread)=>thread.id === threadId);
            if (threadIndex !== -1) {
                const id = `${Math.round(Math.random() * 900000)}`;
                newThreads[threadIndex].items.push({
                    id: id,
                    audience: messageOptions.audience,
                    name: messageOptions.user.email,
                    date: messageOptions.date || "now",
                    user: {
                        name: messageOptions.user.email,
                        id: messageOptions.user.id,
                        email: messageOptions.user.email
                    },
                    group: {
                        name: messageOptions.user.group.name,
                        type: "vendor",
                        id: messageOptions.user.group.id
                    },
                    type: messageOptions.type,
                    content: messageOptions.message
                });
            }
        });
        (0, $cr2GM._)(this, "updateThread", async (threadId, updatedData)=>{
            const newThreads = [
                ...this.threads
            ];
            const index = newThreads.findIndex((thread)=>thread.id === threadId);
            const thread = newThreads[index];
            newThreads[index] = (0, $edHbI._)((0, $2QP2i._)({}, thread), {
                image: updatedData.highlight.content.image,
                highlight: updatedData.highlight
            });
            // FIXME set image only for thread
            newThreads[index].items[0].image = updatedData.highlight.content.image;
            this.threads = newThreads;
        });
        (0, $cr2GM._)(this, "addThread", async (messageOptions)=>{
            const id = `${Math.random()}t_bla`;
            const date = `now`;
            const thread = {
                project_id: messageOptions.project_id,
                parent_id: messageOptions.parent_id,
                highlight: messageOptions.highlight,
                image: messageOptions.image,
                audience: messageOptions.audience,
                id: id,
                items: [
                    {
                        id: `${id}-item`,
                        user: {
                            name: messageOptions.user.email,
                            id: messageOptions.user.id,
                            email: messageOptions.user.email
                        },
                        name: messageOptions.user.email,
                        date: date,
                        group: messageOptions.user.group,
                        type: messageOptions.type,
                        content: messageOptions.message
                    }
                ]
            };
            const newThreads = [
                ...this.threads,
                thread
            ];
            this.threads = newThreads;
            return id;
        });
        (0, $cr2GM._)(this, "resolveThread", (threadId)=>{
            const newThreads = [
                ...this.threads
            ];
            const threadIndex = newThreads.findIndex((thread)=>thread.id === threadId);
            if (threadIndex !== -1) {
                newThreads[threadIndex].closed = Math.floor(new Date() / 1000);
                this.threads = newThreads;
            }
        });
        (0, $cr2GM._)(this, "reset", ()=>{
            this.threads = [];
        });
        (0, $cr2GM._)(this, "loadChat", async ()=>{
            if (this.projectId) {
                const response = await (0, $lxEiN.default).Project.getChat(this.projectId);
                this.threads = response.data.data;
            }
        });
        (0, $cr2GM._)(this, "update", async ()=>{
            await (0, $lxEiN.default).Project.updateChat(this.projectId, this.threads);
        });
        (0, $cr2GM._)(this, "setProjectId", async (projectId)=>{
            this.projectId = projectId;
        });
        (0, $gOgWf.makeObservable)(this, {
            threads: (0, $gOgWf.observable),
            projectId: (0, $gOgWf.observable),
            addMessageToThread: (0, $gOgWf.action),
            resolveThread: (0, $gOgWf.action),
            issueCount: (0, $gOgWf.computed),
            addThread: (0, $gOgWf.action),
            update: (0, $gOgWf.action),
            reset: (0, $gOgWf.action),
            setProjectId: (0, $gOgWf.action)
        });
    }
}
const $540bf67a93d05e4a$var$store = new $540bf67a93d05e4a$var$Store();
const $540bf67a93d05e4a$var$debouncedUpdate = (0, $fBBlk.debounce)($540bf67a93d05e4a$var$store.update, 200);
(0, $gOgWf.reaction)(()=>JSON.stringify($540bf67a93d05e4a$var$store.threads), ()=>{
    $540bf67a93d05e4a$var$debouncedUpdate();
});
(0, $gOgWf.reaction)(()=>`${$540bf67a93d05e4a$var$store.projectId}`, ()=>{
    $540bf67a93d05e4a$var$store.loadChat();
});
var $540bf67a93d05e4a$export$2e2bcd8739ae039 = $540bf67a93d05e4a$var$store;

});

parcelRegister("5KKaN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $430510ac23ca4fe6$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $a0rcO = parcelRequire("a0rcO");
class $430510ac23ca4fe6$var$Store {
    get userIds() {
        return this.users.map((u)=>u.id);
    }
    get fileIds() {
        return this.files.map((u)=>u.id);
    }
    constructor(){
        (0, $cr2GM._)(this, "building_id", null);
        (0, $cr2GM._)(this, "description", "");
        (0, $cr2GM._)(this, "done", false);
        (0, $cr2GM._)(this, "files", []);
        (0, $cr2GM._)(this, "groupId", null);
        (0, $cr2GM._)(this, "id", null);
        (0, $cr2GM._)(this, "isLoading", false);
        (0, $cr2GM._)(this, "project_id", null);
        (0, $cr2GM._)(this, "status", null);
        (0, $cr2GM._)(this, "title", "needs_action");
        (0, $cr2GM._)(this, "users", []);
        (0, $cr2GM._)(this, "clearTask", ()=>{
            this.building_id = null;
            this.description = "";
            this.status = "needs_action";
            this.groupId = null;
            this.done = false;
            this.files = [];
            this.id = null;
            this.isLoading = false;
            this.project_id = null;
            this.title = "";
            this.users = [];
        });
        (0, $cr2GM._)(this, "loadTask", async (taskId)=>{
            this.isLoading = true;
            const task = await (0, $a0rcO.default).loadTask(taskId);
            this.building_id = task.building_id;
            this.description = task.description;
            this.done = task.done;
            this.status = task.status;
            this.files = task.files;
            this.groupId = task.group_id;
            this.id = task.id;
            this.isLoading = false;
            this.project_id = task.project_id;
            this.status = task.status;
            this.title = task.title;
            this.users = task.users;
        });
        (0, $cr2GM._)(this, "deleteTask", async (taskId)=>{
            await (0, $a0rcO.default).deleteTask(taskId);
            this.clearTask();
        });
        (0, $cr2GM._)(this, "change", (name, value)=>{
            this[name] = value;
        });
        (0, $cr2GM._)(this, "setFiles", (files)=>{
            this.files = files;
        });
        (0, $cr2GM._)(this, "setDescription", (description)=>{
            this.description = description;
        });
        (0, $cr2GM._)(this, "setGroup", (groupId)=>{
            this.groupId = groupId;
        });
        (0, $cr2GM._)(this, "setFileId", (fileTempId, fileId)=>{
            const index = this.files.findIndex((file)=>file.id === fileTempId);
            if (index > -1) this.files[index].id = fileId;
        });
        (0, $cr2GM._)(this, "submit", ()=>{
            const data = {
                description: this.description,
                status: this.status,
                title: this.title,
                users: this.users
            };
            if (this.id) return (0, $a0rcO.default).update(this.id, data);
            return (0, $a0rcO.default).create((0, $edHbI._)((0, $2QP2i._)({}, data), {
                group_id: this.groupId,
                building_id: this.building_id,
                project_id: this.project_id
            }));
        });
        (0, $gOgWf.makeObservable)(this, {
            building_id: (0, $gOgWf.observable),
            description: (0, $gOgWf.observable),
            done: (0, $gOgWf.observable),
            files: (0, $gOgWf.observable),
            groupId: (0, $gOgWf.observable),
            id: (0, $gOgWf.observable),
            isLoading: (0, $gOgWf.observable),
            project_id: (0, $gOgWf.observable),
            status: (0, $gOgWf.observable),
            title: (0, $gOgWf.observable),
            users: (0, $gOgWf.observable),
            clearTask: (0, $gOgWf.action),
            loadTask: (0, $gOgWf.action),
            deleteTask: (0, $gOgWf.action),
            change: (0, $gOgWf.action),
            setFiles: (0, $gOgWf.action),
            setDescription: (0, $gOgWf.action),
            setGroup: (0, $gOgWf.action),
            userIds: (0, $gOgWf.computed),
            fileIds: (0, $gOgWf.computed),
            setFileId: (0, $gOgWf.action),
            submit: (0, $gOgWf.action)
        });
    }
}
const $430510ac23ca4fe6$var$store = new $430510ac23ca4fe6$var$Store();
var $430510ac23ca4fe6$export$2e2bcd8739ae039 = $430510ac23ca4fe6$var$store;

});

parcelRegister("4WMcN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a1f8c4f702558f$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $gOgWf = parcelRequire("gOgWf");

var $lxEiN = parcelRequire("lxEiN");
class $39a1f8c4f702558f$var$Store {
    constructor(){
        (0, $cr2GM._)(this, "questions", [
            {
                id: "tax_liability",
                text: "Do you have a tax liability?",
                type: "checkbox",
                value: false
            },
            {
                id: "non_profit",
                text: "Is the company a non-profit ?",
                type: "checkbox",
                value: false
            },
            {
                id: "is_esco",
                text: "Are you on an ESCO?",
                type: "checkbox",
                value: false
            },
            {
                id: "has_nat_gas",
                text: "Do you have existing Natural Gas infrastructure?",
                type: "checkbox",
                value: false
            },
            {
                id: "gas_utility",
                text: "Gas Utility Name",
                type: "text",
                value: ""
            },
            {
                id: "electric_rate",
                text: "Current Electric rate",
                type: "text",
                value: ""
            },
            {
                id: "gas_rate",
                text: "Current Gas rate",
                type: "text",
                value: ""
            }
        ]);
        (0, $cr2GM._)(this, "setAnswer", (questionId, value)=>{
            const idx = this.questions.findIndex((q)=>q.id === questionId);
            const question = this.questions[idx];
            if (question.type === "checkbox") this.questions[idx].value = Boolean(value);
            else this.questions[idx].value = value;
        });
        (0, $cr2GM._)(this, "setAnswers", (answers)=>{
            if (!answers) return;
            answers.forEach((answer)=>{
                this.setAnswer(answer.id, answer.value);
            });
        });
        (0, $cr2GM._)(this, "addSurvey", async (projectId)=>{
            const answers = this.questions.map(({ id: id, value: value, checked: checked })=>({
                    id: id,
                    value: value,
                    checked: checked
                }));
            const { data: data } = await (0, $lxEiN.default).Survey.addSurvey(projectId, {
                data: answers
            });
            return data;
        });
        (0, $gOgWf.makeObservable)(this, {
            questions: (0, $gOgWf.observable),
            setAnswer: (0, $gOgWf.action),
            setAnswers: (0, $gOgWf.action),
            addSurvey: (0, $gOgWf.action)
        });
    }
}
const $39a1f8c4f702558f$var$store = new $39a1f8c4f702558f$var$Store();
var $39a1f8c4f702558f$export$2e2bcd8739ae039 = $39a1f8c4f702558f$var$store;

});

parcelRegister("iuVwc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d777a543714ff4d2$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $fBBlk = parcelRequire("fBBlk");

var $cI9tr = parcelRequire("cI9tr");

var $4WgAH = parcelRequire("4WgAH");

var $brBQs = parcelRequire("brBQs");

var $kH9gy = parcelRequire("kH9gy");

var $lxEiN = parcelRequire("lxEiN");
const $d777a543714ff4d2$var$INITIAL_VIEW_STATE = {
    latitude: 41.8825763,
    longitude: -71.3629619,
    zoom: 17,
    maxZoom: 18,
    pitch: 50,
    bearing: 0
};
const $d777a543714ff4d2$var$MODES = [
    {
        id: "drawPolyline",
        text: "Draw Polyline",
        handler: new (0, $cI9tr.DrawLineStringMode)()
    },
    {
        id: "drawPolygon",
        text: "Draw Polygon",
        handler: new (0, $cI9tr.DrawPolygonMode)()
    },
    {
        id: "drawBuilding",
        text: "Draw Building",
        handler: new (0, $cI9tr.DrawPolygonMode)()
    },
    {
        id: "drawText",
        text: "Add Text",
        handler: new (0, $cI9tr.DrawPointMode)()
    },
    {
        id: "drawPoint",
        text: "Draw Polygon",
        handler: new (0, $cI9tr.DrawPointMode)()
    },
    {
        id: "view",
        text: "Edit Feature",
        handler: new (0, $cI9tr.ViewMode)()
    },
    {
        id: "rotate",
        text: "Rotate",
        handler: new (0, $cI9tr.RotateMode)()
    },
    {
        id: "elevation",
        text: "Elevation",
        handler: new (0, $cI9tr.ElevationMode)()
    },
    {
        id: "translate",
        text: "Translate",
        handler: new (0, $cI9tr.TranslateMode)()
    },
    {
        id: "modify",
        text: "Edit Feature",
        handler: new (0, $cI9tr.ModifyMode)()
    }
];
class $d777a543714ff4d2$var$EditorStore {
    addFeature(feature) {
        this.features.push(feature);
    }
    get featureCollection() {
        return {
            type: "FeatureCollection",
            features: [
                ...this.features
            ]
        };
    }
    get projectId() {
        var _this_datasetId, _this_currentDataset_id, _this_currentDataset;
        if ((_this_datasetId = this.datasetId) === null || _this_datasetId === void 0 ? void 0 : _this_datasetId.startsWith("pr_")) return (_this_currentDataset = this.currentDataset) === null || _this_currentDataset === void 0 ? void 0 : (_this_currentDataset_id = _this_currentDataset.id) === null || _this_currentDataset_id === void 0 ? void 0 : _this_currentDataset_id.replace("pr_", "");
        return null;
    }
    get datasetId() {
        var _this_currentDataset;
        return (_this_currentDataset = this.currentDataset) === null || _this_currentDataset === void 0 ? void 0 : _this_currentDataset.id;
    }
    constructor(){
        (0, $cr2GM._)(this, "viewState", $d777a543714ff4d2$var$INITIAL_VIEW_STATE);
        (0, $cr2GM._)(this, "isLoadingFeatures", false);
        (0, $cr2GM._)(this, "pickedResults", new Set([]));
        (0, $cr2GM._)(this, "resultMap", new Map());
        (0, $cr2GM._)(this, "currentDataset", null);
        (0, $cr2GM._)(this, "deletedFeatures", []);
        (0, $cr2GM._)(this, "currentLayer", null);
        (0, $cr2GM._)(this, "datasets", []);
        (0, $cr2GM._)(this, "editMode", $d777a543714ff4d2$var$MODES.find((mode)=>mode.id === "view"));
        (0, $cr2GM._)(this, "features", []);
        (0, $cr2GM._)(this, "modal", false);
        (0, $cr2GM._)(this, "mapBounds", null);
        (0, $cr2GM._)(this, "layers", []);
        (0, $cr2GM._)(this, "arcGISLayers", []);
        (0, $cr2GM._)(this, "show3dTiles", false);
        (0, $cr2GM._)(this, "searchResults", []);
        (0, $cr2GM._)(this, "searchTerm", null);
        (0, $cr2GM._)(this, "getFeature", (featureId)=>{
            return this.features.find((feature)=>feature.id === featureId);
        });
        (0, $cr2GM._)(this, "setSearchTerm", (term)=>{
            this.searchTerm = term;
        });
        (0, $cr2GM._)(this, "setSearchResults", (results)=>{
            this.searchResults = results;
        });
        (0, $cr2GM._)(this, "setViewState", (viewState)=>{
            this.viewState = viewState;
        });
        (0, $cr2GM._)(this, "search", async ()=>{
            var _UserStore_user;
            // TODO remove groupId
            const groupId = (_UserStore_user = (0, $brBQs.default).user) === null || _UserStore_user === void 0 ? void 0 : _UserStore_user.group.id;
            const response = await (0, $lxEiN.default).Dataset.search(this.searchTerm, groupId);
            this.setSearchResults(response.data.data);
        });
        (0, $cr2GM._)(this, "reset", ()=>{
            this.currentDataset = null;
            this.editMode = $d777a543714ff4d2$var$MODES.find((mode)=>mode.id === "view");
            this.features = [];
            this.modal = false;
        });
        (0, $cr2GM._)(this, "deleteFeature", async (id)=>{
            this.deletedFeatures = [
                ...this.deletedFeatures,
                id
            ];
            (0, $lxEiN.default).Dataset.deleteFeature(this.currentDataset.id, id);
            const resultMap = new Map(this.resultMap);
            resultMap.delete(id);
            this.resultMap = resultMap;
            this.features = this.features.filter((feature)=>feature.id !== id);
        // ProjectDetailStore.removeBuilding(id.replace('pb_', ''));
        });
        (0, $cr2GM._)(this, "getLayers", async ()=>{
            var _this_currentDataset;
            if (!((_this_currentDataset = this.currentDataset) === null || _this_currentDataset === void 0 ? void 0 : _this_currentDataset.id)) return;
            const response = await (0, $lxEiN.default).Dataset.getLayers(this.currentDataset.id);
            this.layers = response.data.data;
        });
        (0, $cr2GM._)(this, "deleteAll", ()=>{
        // this.features.clear();
        });
        (0, $cr2GM._)(this, "setFeatures", (features)=>{
            this.features = features;
        });
        (0, $cr2GM._)(this, "updateLayer", async (datasetId, layerId, data)=>{
            const newLayers = [
                ...this.layers
            ];
            const index = newLayers.findIndex((layer)=>layer.id === layerId);
            newLayers[index] = (0, $2QP2i._)({}, newLayers[index], data);
            this.layers = newLayers;
            await (0, $lxEiN.default).Dataset.updateLayer(datasetId, layerId, data);
        });
        (0, $cr2GM._)(this, "updateDataset", async (datasetId, data)=>{
            await (0, $lxEiN.default).Dataset.updateDataset(datasetId, data);
        });
        (0, $cr2GM._)(this, "getDatasetFeatures", async ()=>{
            var _this_currentLayer;
            if (!this.currentDataset) return;
            const response = await (0, $lxEiN.default).Dataset.getFeatures(this.currentDataset.id);
            this.features = [];
            this.resultMap = new Map();
            this.setFeatures(response.data.data);
            this.filterResults({
                layerId: (_this_currentLayer = this.currentLayer) === null || _this_currentLayer === void 0 ? void 0 : _this_currentLayer.id
            });
            return response.data.data;
        });
        (0, $cr2GM._)(this, "getLayerFeatures", async (layerId)=>{
            const response = await (0, $lxEiN.default).Dataset.getFeatures(this.currentDataset.id, layerId);
            this.features = response.data.data;
            return response.data.data;
        });
        (0, $cr2GM._)(this, "setCurrentLayer", async (datasetId, layerId)=>{
            var _this_currentLayer, _this_currentDataset;
            if (((_this_currentLayer = this.currentLayer) === null || _this_currentLayer === void 0 ? void 0 : _this_currentLayer.id) === layerId) return;
            const response = await (0, $lxEiN.default).Dataset.getLayer(datasetId, layerId);
            if (((_this_currentDataset = this.currentDataset) === null || _this_currentDataset === void 0 ? void 0 : _this_currentDataset.id) !== response.data.data.dataset.id) this.currentDataset = response.data.data.dataset;
            this.currentLayer = response.data.data;
            return this.currentLayer;
        });
        (0, $cr2GM._)(this, "setModal", (modal)=>{
            this.modal = modal;
        });
        (0, $cr2GM._)(this, "setMapBounds", (bounds)=>{
            this.mapBounds = bounds;
        });
        (0, $cr2GM._)(this, "updateFeature", async (feature)=>{
            // axios.post(`/dataset/${datasetId}/${feature.id}`, feature);
            (0, $lxEiN.default).Dataset.updateFeature(this.datasetId, feature);
        });
        (0, $cr2GM._)(this, "setArcGISLayers", (layers)=>{
            this.arcGISLayers = layers;
        });
        (0, $cr2GM._)(this, "createFeature", async (feature)=>{
            const { datasetId: datasetId } = this;
            if (datasetId === "create_project") return;
            if (this.currentDataset.type === "project") {
                const data = await (0, $4WgAH.default).createProjectBuilding(datasetId, feature);
                (0, $kH9gy.default).addBuilding(data);
                return;
            }
            (0, $lxEiN.default).Dataset.createFeature(datasetId, feature);
        });
        (0, $cr2GM._)(this, "getDatasets", async ()=>{
            const { data: data } = await (0, $lxEiN.default).Dataset.get();
            this.datasets = data.data;
        });
        (0, $cr2GM._)(this, "createDataset", async (options)=>{
            const response = await (0, $lxEiN.default).Dataset.createDataset(options);
            this.getDatasets();
            return response.data.data;
        });
        (0, $cr2GM._)(this, "createLayer", async (data)=>{
            await (0, $lxEiN.default).Dataset.createLayer(this.currentDataset.id, data);
            this.getLayers(this.currentDataset.id);
        });
        (0, $cr2GM._)(this, "deleteDataset", async (datasetId)=>{
            this.datasets = this.datasets.filter((dataset)=>dataset.id !== datasetId);
            await (0, $lxEiN.default).Dataset.deleteDataset(datasetId);
        });
        (0, $cr2GM._)(this, "deleteLayer", async (datasetId, layerId)=>{
            const newLayers = [
                ...this.layers
            ].filter((layer)=>layer.id !== layerId);
            this.layers = newLayers;
            await (0, $lxEiN.default).Dataset.deleteLayer(datasetId, layerId);
        });
        (0, $cr2GM._)(this, "setCurrentDataset", async (dataset)=>{
            var _this_currentDataset;
            // console.log('setCurrentDataset', dataset);
            if (typeof dataset === "string") {
                var _this_currentDataset1;
                if (dataset === ((_this_currentDataset1 = this.currentDataset) === null || _this_currentDataset1 === void 0 ? void 0 : _this_currentDataset1.id)) return;
                //   console.log('setCurrentDataset1');
                const response = await (0, $lxEiN.default).Dataset.getDataset(dataset);
                //   console.log('setCurrentDataset2', response.data.data);
                this.currentDataset = response.data.data;
                return;
            }
            if (((_this_currentDataset = this.currentDataset) === null || _this_currentDataset === void 0 ? void 0 : _this_currentDataset.id) !== dataset.id) this.deleteAll();
            this.currentDataset = dataset;
        });
        (0, $cr2GM._)(this, "setCurrentDatasetLayers", (datasetIds)=>{
            this.currentDataset = (0, $edHbI._)((0, $2QP2i._)({}, this.currentDataset), {
                datasets: datasetIds
            });
        });
        (0, $cr2GM._)(this, "setCurrentDatasetName", async (name)=>{
            this.currentDataset = (0, $edHbI._)((0, $2QP2i._)({}, this.currentDataset), {
                name: name
            });
            const newDatasets = [
                ...this.datasets
            ];
            const index = newDatasets.findIndex((dataset)=>dataset.id === this.currentDataset.id);
            if (index > -1) newDatasets[index].name = name;
            this.datasets = newDatasets;
            await (0, $lxEiN.default).Dataset.updateDataset(this.currentDataset.id, {
                name: name
            });
        });
        (0, $cr2GM._)(this, "getCurrentDataset", ()=>{
            return this.datasets.find((d)=>d.current === true);
        });
        (0, $cr2GM._)(this, "setSubdomains", (subdomains)=>{
            this.currentDataset.subdomains = subdomains;
        });
        (0, $cr2GM._)(this, "setEditMode", (modeId)=>{
            const mode = $d777a543714ff4d2$var$MODES.find((mode)=>mode.id === modeId);
            if (!mode) return $d777a543714ff4d2$var$MODES.find((mode)=>mode.id === "view");
            this.editMode = mode;
        });
        (0, $cr2GM._)(this, "filterResults", ({ layerId: layerId })=>{
            const arr = this.features.filter((feature)=>{
                // filter out additional datasets
                if (feature.dataset_id !== this.datasetId) return false;
                if (layerId === "uncategorized" || layerId === null) return feature.layer_id === null || feature.layer_id === "uncategorized";
                return feature.layer_id === layerId;
            }).map((feature)=>{
                return [
                    feature.id,
                    feature
                ];
            });
            this.resultMap = new Map(arr);
        });
        (0, $cr2GM._)(this, "setShow3dTiles", (show3dTiles)=>{
            this.show3dTiles = show3dTiles;
        });
        (0, $gOgWf.makeObservable)(this, {
            show3dTiles: (0, $gOgWf.observable),
            viewState: (0, $gOgWf.observable),
            isLoadingFeatures: (0, $gOgWf.observable),
            pickedResults: (0, $gOgWf.observable),
            resultMap: (0, $gOgWf.observable),
            currentDataset: (0, $gOgWf.observable),
            arcGISLayers: (0, $gOgWf.observable),
            deletedFeatures: (0, $gOgWf.observable),
            currentLayer: (0, $gOgWf.observable),
            datasets: (0, $gOgWf.observable),
            editMode: (0, $gOgWf.observable),
            features: (0, $gOgWf.observable),
            modal: (0, $gOgWf.observable),
            mapBounds: (0, $gOgWf.observable),
            layers: (0, $gOgWf.observable),
            searchResults: (0, $gOgWf.observable),
            searchTerm: (0, $gOgWf.observable),
            getFeature: (0, $gOgWf.action),
            setSearchTerm: (0, $gOgWf.action),
            setSearchResults: (0, $gOgWf.action),
            setViewState: (0, $gOgWf.action),
            search: (0, $gOgWf.action),
            reset: (0, $gOgWf.action),
            deleteFeature: (0, $gOgWf.action),
            getLayers: (0, $gOgWf.action),
            addFeature: (0, $gOgWf.action),
            deleteAll: (0, $gOgWf.action),
            setFeatures: (0, $gOgWf.action),
            updateLayer: (0, $gOgWf.action),
            updateDataset: (0, $gOgWf.action),
            featureCollection: (0, $gOgWf.computed),
            projectId: (0, $gOgWf.computed),
            datasetId: (0, $gOgWf.computed),
            getDatasetFeatures: (0, $gOgWf.action),
            getLayerFeatures: (0, $gOgWf.action),
            setCurrentLayer: (0, $gOgWf.action),
            setModal: (0, $gOgWf.action),
            setMapBounds: (0, $gOgWf.action),
            updateFeature: (0, $gOgWf.action),
            createFeature: (0, $gOgWf.action),
            getDatasets: (0, $gOgWf.action),
            createDataset: (0, $gOgWf.action),
            createLayer: (0, $gOgWf.action),
            deleteDataset: (0, $gOgWf.action),
            deleteLayer: (0, $gOgWf.action),
            setCurrentDataset: (0, $gOgWf.action),
            setCurrentDatasetLayers: (0, $gOgWf.action),
            setCurrentDatasetName: (0, $gOgWf.action),
            getCurrentDataset: (0, $gOgWf.action),
            setSubdomains: (0, $gOgWf.action),
            setEditMode: (0, $gOgWf.action),
            filterResults: (0, $gOgWf.action)
        });
    }
}
const $d777a543714ff4d2$var$store = new $d777a543714ff4d2$var$EditorStore();
(0, $gOgWf.reaction)(()=>JSON.stringify([
        $d777a543714ff4d2$var$store.searchTerm
    ]), (0, $fBBlk.debounce)(()=>{
    if ($d777a543714ff4d2$var$store.searchTerm) $d777a543714ff4d2$var$store.search();
    else $d777a543714ff4d2$var$store.setSearchResults([]);
}, 200));
(0, $gOgWf.reaction)(()=>JSON.stringify([
        $d777a543714ff4d2$var$store.currentDataset
    ]), ()=>{
    var _store_currentDataset, _store_currentDataset1;
    if ((_store_currentDataset = $d777a543714ff4d2$var$store.currentDataset) === null || _store_currentDataset === void 0 ? void 0 : _store_currentDataset.id) $d777a543714ff4d2$var$store.getLayers((_store_currentDataset1 = $d777a543714ff4d2$var$store.currentDataset) === null || _store_currentDataset1 === void 0 ? void 0 : _store_currentDataset1.id);
});
(0, $gOgWf.reaction)(()=>$d777a543714ff4d2$var$store.datasetId, ()=>{
    if ($d777a543714ff4d2$var$store.datasetId && $d777a543714ff4d2$var$store.datasetId !== "create_project") $d777a543714ff4d2$var$store.getDatasetFeatures();
});
(0, $gOgWf.reaction)(()=>{
    var _store_currentLayer;
    return JSON.stringify((_store_currentLayer = $d777a543714ff4d2$var$store.currentLayer) === null || _store_currentLayer === void 0 ? void 0 : _store_currentLayer.id);
}, ()=>{
    var _store_currentLayer;
    $d777a543714ff4d2$var$store.filterResults({
        layerId: (_store_currentLayer = $d777a543714ff4d2$var$store.currentLayer) === null || _store_currentLayer === void 0 ? void 0 : _store_currentLayer.id
    });
});
var $d777a543714ff4d2$export$2e2bcd8739ae039 = $d777a543714ff4d2$var$store;

});
parcelRegister("cI9tr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ArrowStyles", {
    enumerable: true,
    get: function get() {
        return $4TuXT.ArrowStyles;
    }
});
Object.defineProperty(module.exports, "DEFAULT_ARROWS", {
    enumerable: true,
    get: function get() {
        return $4TuXT.DEFAULT_ARROWS;
    }
});
Object.defineProperty(module.exports, "MAX_ARROWS", {
    enumerable: true,
    get: function get() {
        return $4TuXT.MAX_ARROWS;
    }
});
Object.defineProperty(module.exports, "SELECTION_TYPE", {
    enumerable: true,
    get: function get() {
        return $cY7II.SELECTION_TYPE;
    }
});
Object.defineProperty(module.exports, "Feature", {
    enumerable: true,
    get: function get() {
        return $9410f162e13c7cc8$var$_feature["default"];
    }
});
Object.defineProperty(module.exports, "LayerMouseEvent", {
    enumerable: true,
    get: function get() {
        return $9410f162e13c7cc8$var$_layerMouseEvent["default"];
    }
});
Object.defineProperty(module.exports, "NebulaLayer", {
    enumerable: true,
    get: function get() {
        return $9410f162e13c7cc8$var$_nebulaLayer["default"];
    }
});
Object.defineProperty(module.exports, "JunctionsLayer", {
    enumerable: true,
    get: function get() {
        return $9410f162e13c7cc8$var$_junctionsLayer["default"];
    }
});
Object.defineProperty(module.exports, "TextsLayer", {
    enumerable: true,
    get: function get() {
        return $9410f162e13c7cc8$var$_textsLayer["default"];
    }
});
Object.defineProperty(module.exports, "SegmentsLayer", {
    enumerable: true,
    get: function get() {
        return $9410f162e13c7cc8$var$_segmentsLayer["default"];
    }
});
Object.defineProperty(module.exports, "NebulaCore", {
    enumerable: true,
    get: function get() {
        return $9410f162e13c7cc8$var$_nebula["default"];
    }
});
Object.defineProperty(module.exports, "PROJECTED_PIXEL_SIZE_MULTIPLIER", {
    enumerable: true,
    get: function get() {
        return $bEXHX.PROJECTED_PIXEL_SIZE_MULTIPLIER;
    }
});
Object.defineProperty(module.exports, "toDeckColor", {
    enumerable: true,
    get: function get() {
        return $h5pu5.toDeckColor;
    }
});
Object.defineProperty(module.exports, "EditableGeoJsonLayer", {
    enumerable: true,
    get: function get() {
        return $4agoo.EditableGeoJsonLayer;
    }
});
Object.defineProperty(module.exports, "SelectionLayer", {
    enumerable: true,
    get: function get() {
        return $4agoo.SelectionLayer;
    }
});
Object.defineProperty(module.exports, "ElevatedEditHandleLayer", {
    enumerable: true,
    get: function get() {
        return $4agoo.ElevatedEditHandleLayer;
    }
});
Object.defineProperty(module.exports, "PathOutlineLayer", {
    enumerable: true,
    get: function get() {
        return $4agoo.PathOutlineLayer;
    }
});
Object.defineProperty(module.exports, "PathMarkerLayer", {
    enumerable: true,
    get: function get() {
        return $4agoo.PathMarkerLayer;
    }
});
Object.defineProperty(module.exports, "GeoJsonEditMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.GeoJsonEditMode;
    }
});
Object.defineProperty(module.exports, "ModifyMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ModifyMode;
    }
});
Object.defineProperty(module.exports, "ResizeCircleMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ResizeCircleMode;
    }
});
Object.defineProperty(module.exports, "TranslateMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.TranslateMode;
    }
});
Object.defineProperty(module.exports, "ScaleMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ScaleMode;
    }
});
Object.defineProperty(module.exports, "RotateMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.RotateMode;
    }
});
Object.defineProperty(module.exports, "DuplicateMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DuplicateMode;
    }
});
Object.defineProperty(module.exports, "ExtendLineStringMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ExtendLineStringMode;
    }
});
Object.defineProperty(module.exports, "SplitPolygonMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.SplitPolygonMode;
    }
});
Object.defineProperty(module.exports, "ExtrudeMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ExtrudeMode;
    }
});
Object.defineProperty(module.exports, "ElevationMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ElevationMode;
    }
});
Object.defineProperty(module.exports, "TransformMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.TransformMode;
    }
});
Object.defineProperty(module.exports, "DrawPointMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawPointMode;
    }
});
Object.defineProperty(module.exports, "DrawLineStringMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawLineStringMode;
    }
});
Object.defineProperty(module.exports, "DrawPolygonMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawPolygonMode;
    }
});
Object.defineProperty(module.exports, "DrawRectangleMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawRectangleMode;
    }
});
Object.defineProperty(module.exports, "DrawSquareMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawSquareMode;
    }
});
Object.defineProperty(module.exports, "DrawRectangleFromCenterMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawRectangleFromCenterMode;
    }
});
Object.defineProperty(module.exports, "DrawSquareFromCenterMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawSquareFromCenterMode;
    }
});
Object.defineProperty(module.exports, "DrawCircleByDiameterMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawCircleByDiameterMode;
    }
});
Object.defineProperty(module.exports, "DrawCircleFromCenterMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawCircleFromCenterMode;
    }
});
Object.defineProperty(module.exports, "DrawEllipseByBoundingBoxMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawEllipseByBoundingBoxMode;
    }
});
Object.defineProperty(module.exports, "DrawEllipseUsingThreePointsMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawEllipseUsingThreePointsMode;
    }
});
Object.defineProperty(module.exports, "DrawRectangleUsingThreePointsMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawRectangleUsingThreePointsMode;
    }
});
Object.defineProperty(module.exports, "Draw90DegreePolygonMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.Draw90DegreePolygonMode;
    }
});
Object.defineProperty(module.exports, "DrawPolygonByDraggingMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.DrawPolygonByDraggingMode;
    }
});
Object.defineProperty(module.exports, "ImmutableFeatureCollection", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ImmutableFeatureCollection;
    }
});
Object.defineProperty(module.exports, "ViewMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.ViewMode;
    }
});
Object.defineProperty(module.exports, "MeasureDistanceMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.MeasureDistanceMode;
    }
});
Object.defineProperty(module.exports, "MeasureAreaMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.MeasureAreaMode;
    }
});
Object.defineProperty(module.exports, "MeasureAngleMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.MeasureAngleMode;
    }
});
Object.defineProperty(module.exports, "CompositeMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.CompositeMode;
    }
});
Object.defineProperty(module.exports, "SnappableMode", {
    enumerable: true,
    get: function get() {
        return $cQSdn.SnappableMode;
    }
});

var $4TuXT = parcelRequire("4TuXT");

var $cY7II = parcelRequire("cY7II");

var $9410f162e13c7cc8$var$_feature = $9410f162e13c7cc8$var$_interopRequireDefault((parcelRequire("c2GPt")));

var $9410f162e13c7cc8$var$_layerMouseEvent = $9410f162e13c7cc8$var$_interopRequireDefault((parcelRequire("iXJhp")));

var $9410f162e13c7cc8$var$_nebulaLayer = $9410f162e13c7cc8$var$_interopRequireDefault((parcelRequire("7uZXb")));

var $9410f162e13c7cc8$var$_junctionsLayer = $9410f162e13c7cc8$var$_interopRequireDefault((parcelRequire("faO1n")));

var $9410f162e13c7cc8$var$_textsLayer = $9410f162e13c7cc8$var$_interopRequireDefault((parcelRequire("cWVMd")));

var $9410f162e13c7cc8$var$_segmentsLayer = $9410f162e13c7cc8$var$_interopRequireDefault((parcelRequire("cIeIZ")));

var $9410f162e13c7cc8$var$_nebula = $9410f162e13c7cc8$var$_interopRequireDefault((parcelRequire("afly2")));

var $bEXHX = parcelRequire("bEXHX");

var $h5pu5 = parcelRequire("h5pu5");

var $4agoo = parcelRequire("4agoo");

var $cQSdn = parcelRequire("cQSdn");
function $9410f162e13c7cc8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("4TuXT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_STYLE = module.exports.MAX_ARROWS = module.exports.DEFAULT_ARROWS = module.exports.ArrowStyles = void 0;
// Describes the arrow style of polylines
var $3904517f5237c32e$var$ArrowStyles = {
    NONE: 0,
    FORWARD: 1,
    BACKWARD: 2,
    BOTH: 3
};
module.exports.ArrowStyles = $3904517f5237c32e$var$ArrowStyles;
var $3904517f5237c32e$var$DEFAULT_ARROWS = 1;
module.exports.DEFAULT_ARROWS = $3904517f5237c32e$var$DEFAULT_ARROWS;
var $3904517f5237c32e$var$MAX_ARROWS = 3;
module.exports.MAX_ARROWS = $3904517f5237c32e$var$MAX_ARROWS;
var $3904517f5237c32e$var$DEFAULT_STYLE = {
    arrowColor: [
        0,
        0,
        0,
        1
    ],
    arrowCount: $3904517f5237c32e$var$DEFAULT_ARROWS,
    arrowStyle: $3904517f5237c32e$var$ArrowStyles.NONE,
    fillColor: [
        0,
        0,
        0,
        1
    ],
    lineColor: [
        0,
        0,
        0,
        1
    ],
    lineWidthMeters: 5,
    outlineRadiusMeters: 0,
    opacity: 1,
    zLevel: 0
};
module.exports.DEFAULT_STYLE = $3904517f5237c32e$var$DEFAULT_STYLE;

});

parcelRegister("cY7II", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.SELECTION_TYPE = void 0;

var $6ey8i = parcelRequire("6ey8i");

var $7GKQS = parcelRequire("7GKQS");

var $971113b6972d660e$var$_bbox = $971113b6972d660e$var$_interopRequireDefault((parcelRequire("lX3Ya")));

var $971113b6972d660e$var$_bboxPolygon = $971113b6972d660e$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $971113b6972d660e$var$_buffer = $971113b6972d660e$var$_interopRequireDefault((parcelRequire("3qree")));

var $971113b6972d660e$var$_difference = $971113b6972d660e$var$_interopRequireDefault((parcelRequire("gZv4c")));

var $971113b6972d660e$var$_distance = $971113b6972d660e$var$_interopRequireDefault((parcelRequire("b5wF2")));
function $971113b6972d660e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $971113b6972d660e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $971113b6972d660e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $971113b6972d660e$var$ownKeys(Object(source), true).forEach(function(key) {
            $971113b6972d660e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $971113b6972d660e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $971113b6972d660e$var$_slicedToArray(arr, i) {
    return $971113b6972d660e$var$_arrayWithHoles(arr) || $971113b6972d660e$var$_iterableToArrayLimit(arr, i) || $971113b6972d660e$var$_unsupportedIterableToArray(arr, i) || $971113b6972d660e$var$_nonIterableRest();
}
function $971113b6972d660e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $971113b6972d660e$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $971113b6972d660e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $971113b6972d660e$var$_toConsumableArray(arr) {
    return $971113b6972d660e$var$_arrayWithoutHoles(arr) || $971113b6972d660e$var$_iterableToArray(arr) || $971113b6972d660e$var$_unsupportedIterableToArray(arr) || $971113b6972d660e$var$_nonIterableSpread();
}
function $971113b6972d660e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $971113b6972d660e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $971113b6972d660e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $971113b6972d660e$var$_arrayLikeToArray(o, minLen);
}
function $971113b6972d660e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $971113b6972d660e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $971113b6972d660e$var$_arrayLikeToArray(arr);
}
function $971113b6972d660e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $971113b6972d660e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $971113b6972d660e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $971113b6972d660e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $971113b6972d660e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $971113b6972d660e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $971113b6972d660e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $971113b6972d660e$var$POLYGON_LINE_COLOR = [
    0,
    255,
    0,
    255
];
var $971113b6972d660e$var$POLYGON_FILL_COLOR = [
    255,
    255,
    255,
    90
];
var $971113b6972d660e$var$POLYGON_LINE_WIDTH = 2;
var $971113b6972d660e$var$POLYGON_DASHES = [
    20,
    20
];
var $971113b6972d660e$var$POLYGON_THRESHOLD = 0.01;
var $971113b6972d660e$var$EXPANSION_KM = 10;
var $971113b6972d660e$var$LAYER_ID_VIEW = "DeckDrawerView";
var $971113b6972d660e$var$LAYER_ID_PICK = "DeckDrawerPick";
var $971113b6972d660e$var$SELECTION_TYPE = {
    NONE: null,
    RECTANGLE: "rectangle",
    POLYGON: "polygon"
};
module.exports.SELECTION_TYPE = $971113b6972d660e$var$SELECTION_TYPE;
var $971113b6972d660e$var$DeckDrawer = /*#__PURE__*/ function() {
    function DeckDrawer(nebula) {
        $971113b6972d660e$var$_classCallCheck(this, DeckDrawer);
        $971113b6972d660e$var$_defineProperty(this, "nebula", void 0);
        $971113b6972d660e$var$_defineProperty(this, "usePolygon", void 0);
        $971113b6972d660e$var$_defineProperty(this, "validPolygon", void 0);
        $971113b6972d660e$var$_defineProperty(this, "landPoints", void 0);
        $971113b6972d660e$var$_defineProperty(this, "mousePoints", void 0);
        this.nebula = nebula;
        this.usePolygon = false;
        this.landPoints = [];
        this.mousePoints = [];
    }
    $971113b6972d660e$var$_createClass(DeckDrawer, [
        {
            key: "_getLayerIds",
            value: function _getLayerIds() {
                // TODO: sort by mouse priority
                return this.nebula.deckgl.props.layers.filter(function(l) {
                    return l && l.props && l.props.nebulaLayer && l.props.nebulaLayer.enableSelection;
                }).map(function(l) {
                    return l.id;
                });
            }
        },
        {
            key: "_selectFromPickingInfos",
            value: function _selectFromPickingInfos(pickingInfos) {
                var objects = pickingInfos.map(function(_ref) {
                    var layer = _ref.layer, index = _ref.index, object = _ref.object;
                    return object.original || layer.props.nebulaLayer.deckCache.originals[index];
                });
                this.nebula.props.onSelection(objects);
            }
        },
        {
            key: "_getBoundingBox",
            value: function _getBoundingBox() {
                var mousePoints = this.mousePoints;
                var allX = mousePoints.map(function(mousePoint) {
                    return mousePoint[0];
                });
                var allY = mousePoints.map(function(mousePoint) {
                    return mousePoint[1];
                });
                var x = Math.min.apply(Math, $971113b6972d660e$var$_toConsumableArray(allX));
                var y = Math.min.apply(Math, $971113b6972d660e$var$_toConsumableArray(allY));
                var maxX = Math.max.apply(Math, $971113b6972d660e$var$_toConsumableArray(allX));
                var maxY = Math.max.apply(Math, $971113b6972d660e$var$_toConsumableArray(allY));
                return {
                    x: x,
                    y: y,
                    width: maxX - x,
                    height: maxY - y
                };
            }
        },
        {
            key: "_selectRectangleObjects",
            value: function _selectRectangleObjects() {
                if (this.landPoints.length !== 2) return;
                var _this$mousePoints$ = $971113b6972d660e$var$_slicedToArray(this.mousePoints[0], 2), x1 = _this$mousePoints$[0], y1 = _this$mousePoints$[1];
                var _this$mousePoints$2 = $971113b6972d660e$var$_slicedToArray(this.mousePoints[1], 2), x2 = _this$mousePoints$2[0], y2 = _this$mousePoints$2[1];
                var pickingInfos = this.nebula.deckgl.pickObjects({
                    x: Math.min(x1, x2),
                    y: Math.min(y1, y2),
                    width: Math.abs(x2 - x1),
                    height: Math.abs(y2 - y1),
                    layerIds: this._getLayerIds()
                });
                this._selectFromPickingInfos(pickingInfos);
            }
        },
        {
            key: "_selectPolygonObjects",
            value: function _selectPolygonObjects() {
                var pickingInfos = this.nebula.deckgl.pickObjects($971113b6972d660e$var$_objectSpread({}, this._getBoundingBox(), {
                    layerIds: [
                        $971113b6972d660e$var$LAYER_ID_PICK
                    ].concat($971113b6972d660e$var$_toConsumableArray(this._getLayerIds()))
                }));
                this._selectFromPickingInfos(pickingInfos.filter(function(item) {
                    return item.layer.id !== $971113b6972d660e$var$LAYER_ID_PICK;
                }));
            }
        },
        {
            key: "_getMousePosFromEvent",
            value: function _getMousePosFromEvent(event) {
                var offsetX = event.offsetX, offsetY = event.offsetY;
                return [
                    offsetX,
                    offsetY
                ];
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event, lngLat, selectionType) {
                // capture all events (mouse-up is needed to prevent us stuck in moving map)
                if (event.type !== "mouseup") event.stopPropagation(); // @ts-ignore
                this.usePolygon = selectionType === $971113b6972d660e$var$SELECTION_TYPE.POLYGON;
                var redraw = false;
                var deactivate = false;
                var usePolygon = this.usePolygon, landPoints = this.landPoints, mousePoints = this.mousePoints;
                if (event.type === "mousedown") {
                    if (usePolygon && landPoints.length) // if landPoints.length is zero we want to insert two points (so we let it run the else)
                    // also don't insert if polygon is invalid
                    {
                        if (this.landPoints.length < 3 || this.validPolygon) {
                            landPoints.push(lngLat);
                            mousePoints.push(this._getMousePosFromEvent(event));
                        }
                    } else {
                        this.landPoints = [
                            lngLat,
                            lngLat
                        ];
                        var m = this._getMousePosFromEvent(event);
                        this.mousePoints = [
                            m,
                            m
                        ];
                    }
                    redraw = true;
                } else if (event.type === "mousemove" && landPoints.length) {
                    // update last point
                    landPoints[landPoints.length - 1] = lngLat;
                    mousePoints[mousePoints.length - 1] = this._getMousePosFromEvent(event);
                    redraw = true;
                } else if (event.type === "mouseup") {
                    if (usePolygon) // check to see if completed
                    // TODO: Maybe double-click to finish?
                    {
                        if (landPoints.length > 4 && (0, $971113b6972d660e$var$_distance["default"])(landPoints[0], landPoints[landPoints.length - 1]) < $971113b6972d660e$var$POLYGON_THRESHOLD && this.validPolygon) {
                            this._selectPolygonObjects();
                            this.reset();
                            redraw = true;
                            deactivate = true;
                        }
                    } else {
                        this._selectRectangleObjects();
                        this.reset();
                        redraw = true;
                        deactivate = true;
                    }
                }
                return {
                    redraw: redraw,
                    deactivate: deactivate
                };
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.landPoints = [];
                this.mousePoints = [];
            }
        },
        {
            key: "_makeStartPointHighlight",
            value: function _makeStartPointHighlight(center) {
                var buffer = (0, $971113b6972d660e$var$_buffer["default"])((0, $7GKQS.point)(center), $971113b6972d660e$var$POLYGON_THRESHOLD / 4.0); // @ts-ignore
                return (0, $971113b6972d660e$var$_bboxPolygon["default"])((0, $971113b6972d660e$var$_bbox["default"])(buffer)).geometry.coordinates;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var data = [];
                var dataPick = [];
                if (!this.usePolygon && this.landPoints.length === 2) {
                    // Use mouse points instead of land points so we get the right shape
                    // no matter what bearing is.
                    var _this$mousePoints = $971113b6972d660e$var$_slicedToArray(this.mousePoints, 2), _this$mousePoints$3 = $971113b6972d660e$var$_slicedToArray(_this$mousePoints[0], 2), x1 = _this$mousePoints$3[0], y1 = _this$mousePoints$3[1], _this$mousePoints$4 = $971113b6972d660e$var$_slicedToArray(_this$mousePoints[1], 2), x2 = _this$mousePoints$4[0], y2 = _this$mousePoints$4[1];
                    var selPolygon = [
                        [
                            x1,
                            y1
                        ],
                        [
                            x1,
                            y2
                        ],
                        [
                            x2,
                            y2
                        ],
                        [
                            x2,
                            y1
                        ],
                        [
                            x1,
                            y1
                        ]
                    ].map(function(mousePos) {
                        return _this.nebula.unprojectMousePosition(mousePos);
                    });
                    data.push({
                        polygon: selPolygon,
                        lineColor: $971113b6972d660e$var$POLYGON_LINE_COLOR,
                        fillColor: $971113b6972d660e$var$POLYGON_FILL_COLOR
                    });
                } else if (this.usePolygon && this.landPoints.length) {
                    data.push({
                        polygon: this.landPoints,
                        lineColor: $971113b6972d660e$var$POLYGON_LINE_COLOR,
                        fillColor: $971113b6972d660e$var$POLYGON_FILL_COLOR
                    }); // Hack: use a polygon to hide the outside, because pickObjects()
                    // does not support polygons
                    if (this.landPoints.length >= 3) {
                        var landPointsPoly = (0, $7GKQS.polygon)([
                            [].concat($971113b6972d660e$var$_toConsumableArray(this.landPoints), [
                                this.landPoints[0]
                            ])
                        ]);
                        var bigBuffer = (0, $971113b6972d660e$var$_buffer["default"])((0, $7GKQS.point)(this.landPoints[0]), $971113b6972d660e$var$EXPANSION_KM);
                        var bigPolygon;
                        try {
                            // turfDifference throws an exception if the polygon
                            // intersects with itself
                            bigPolygon = (0, $971113b6972d660e$var$_difference["default"])(bigBuffer, landPointsPoly);
                            dataPick.push({
                                polygon: bigPolygon.geometry.coordinates,
                                fillColor: [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            });
                            this.validPolygon = true;
                        } catch (e) {
                            // invalid selection polygon
                            this.validPolygon = false;
                        }
                    }
                }
                if (this.landPoints.length) // highlight start point
                data.push({
                    polygon: this._makeStartPointHighlight(this.landPoints[0]),
                    lineColor: [
                        0,
                        0,
                        0,
                        0
                    ],
                    fillColor: $971113b6972d660e$var$POLYGON_LINE_COLOR
                });
                 // Hack to make the PolygonLayer() stay active,
                // otherwise it takes 3 seconds (!) to init!
                // TODO: fix this
                data.push({
                    polygon: [
                        [
                            0,
                            0
                        ]
                    ]
                });
                dataPick.push({
                    polygon: [
                        [
                            0,
                            0
                        ]
                    ]
                });
                return [
                    new $6ey8i.default({
                        id: $971113b6972d660e$var$LAYER_ID_VIEW,
                        data: data,
                        // @ts-ignore
                        fp64: false,
                        opacity: 1.0,
                        pickable: false,
                        lineWidthMinPixels: $971113b6972d660e$var$POLYGON_LINE_WIDTH,
                        lineWidthMaxPixels: $971113b6972d660e$var$POLYGON_LINE_WIDTH,
                        lineDashJustified: true,
                        getLineDashArray: function getLineDashArray(x) {
                            return $971113b6972d660e$var$POLYGON_DASHES;
                        },
                        // @ts-ignore
                        getLineColor: function getLineColor(obj) {
                            return obj.lineColor || [
                                0,
                                0,
                                0,
                                255
                            ];
                        },
                        // @ts-ignore
                        getFillColor: function getFillColor(obj) {
                            return obj.fillColor || [
                                0,
                                0,
                                0,
                                255
                            ];
                        },
                        // @ts-ignore
                        getPolygon: function getPolygon(o) {
                            return o.polygon;
                        }
                    }),
                    new $6ey8i.default({
                        id: $971113b6972d660e$var$LAYER_ID_PICK,
                        data: dataPick,
                        // @ts-ignore
                        getLineColor: function getLineColor(obj) {
                            return obj.lineColor || [
                                0,
                                0,
                                0,
                                255
                            ];
                        },
                        // @ts-ignore
                        getFillColor: function getFillColor(obj) {
                            return obj.fillColor || [
                                0,
                                0,
                                0,
                                255
                            ];
                        },
                        // @ts-ignore
                        fp64: false,
                        opacity: 1.0,
                        stroked: false,
                        pickable: true,
                        // @ts-ignore
                        getPolygon: function getPolygon(o) {
                            return o.polygon;
                        }
                    })
                ];
            }
        }
    ]);
    return DeckDrawer;
}();
module.exports["default"] = $971113b6972d660e$var$DeckDrawer;

});
parcelRegister("6ey8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $489e86f01fa23e27$export$2e2bcd8739ae039; });

var $lEQUF = parcelRequire("lEQUF");

var $coXLq = parcelRequire("coXLq");
var $abpME = parcelRequire("abpME");
var $4VQgq = parcelRequire("4VQgq");

var $7VEAA = parcelRequire("7VEAA");

var $lzW2S = parcelRequire("lzW2S");

var $9001n = parcelRequire("9001n");

var $cNqHj = parcelRequire("cNqHj");
const $489e86f01fa23e27$var$defaultLineColor = [
    0,
    0,
    0,
    255
];
const $489e86f01fa23e27$var$defaultFillColor = [
    0,
    0,
    0,
    255
];
const $489e86f01fa23e27$var$defaultProps = {
    stroked: true,
    filled: true,
    extruded: false,
    elevationScale: 1,
    wireframe: false,
    _normalize: true,
    _windingOrder: "CW",
    lineWidthUnits: "meters",
    lineWidthScale: 1,
    lineWidthMinPixels: 0,
    lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
    lineJointRounded: false,
    lineMiterLimit: 4,
    getPolygon: {
        type: "accessor",
        value: (f)=>f.polygon
    },
    getFillColor: {
        type: "accessor",
        value: $489e86f01fa23e27$var$defaultFillColor
    },
    getLineColor: {
        type: "accessor",
        value: $489e86f01fa23e27$var$defaultLineColor
    },
    getLineWidth: {
        type: "accessor",
        value: 1
    },
    getElevation: {
        type: "accessor",
        value: 1000
    },
    material: true
};
class $489e86f01fa23e27$export$2e2bcd8739ae039 extends (0, $coXLq.default) {
    initializeState() {
        this.state = {
            paths: []
        };
        if (this.props.getLineDashArray) (0, $4VQgq.default).removed("getLineDashArray", "PathStyleExtension")();
    }
    updateState({ changeFlags: changeFlags }) {
        const geometryChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPolygon);
        if (geometryChanged && Array.isArray(changeFlags.dataChanged)) {
            const paths = this.state.paths.slice();
            const pathsDiff = changeFlags.dataChanged.map((dataRange)=>(0, $cNqHj.replaceInRange)({
                    data: paths,
                    getIndex: (p)=>p.__source.index,
                    dataRange: dataRange,
                    replace: this._getPaths(dataRange)
                }));
            this.setState({
                paths: paths,
                pathsDiff: pathsDiff
            });
        } else if (geometryChanged) this.setState({
            paths: this._getPaths(),
            pathsDiff: null
        });
    }
    _getPaths(dataRange = {}) {
        const { data: data, getPolygon: getPolygon, positionFormat: positionFormat, _normalize: _normalize } = this.props;
        const paths = [];
        const positionSize = positionFormat === "XY" ? 2 : 3;
        const { startRow: startRow, endRow: endRow } = dataRange;
        const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(data, startRow, endRow);
        for (const object of iterable){
            objectInfo.index++;
            let polygon = getPolygon(object, objectInfo);
            if (_normalize) polygon = $9001n.normalize(polygon, positionSize);
            const { holeIndices: holeIndices } = polygon;
            const positions = polygon.positions || polygon;
            if (holeIndices) for(let i = 0; i <= holeIndices.length; i++){
                const path = positions.slice(holeIndices[i - 1] || 0, holeIndices[i] || positions.length);
                paths.push(this.getSubLayerRow({
                    path: path
                }, object, objectInfo.index));
            }
            else paths.push(this.getSubLayerRow({
                path: positions
            }, object, objectInfo.index));
        }
        return paths;
    }
    renderLayers() {
        const { data: data, _dataDiff: _dataDiff, stroked: stroked, filled: filled, extruded: extruded, wireframe: wireframe, _normalize: _normalize, _windingOrder: _windingOrder, elevationScale: elevationScale, transitions: transitions, positionFormat: positionFormat } = this.props;
        const { lineWidthUnits: lineWidthUnits, lineWidthScale: lineWidthScale, lineWidthMinPixels: lineWidthMinPixels, lineWidthMaxPixels: lineWidthMaxPixels, lineJointRounded: lineJointRounded, lineMiterLimit: lineMiterLimit, lineDashJustified: lineDashJustified } = this.props;
        const { getFillColor: getFillColor, getLineColor: getLineColor, getLineWidth: getLineWidth, getLineDashArray: getLineDashArray, getElevation: getElevation, getPolygon: getPolygon, updateTriggers: updateTriggers, material: material } = this.props;
        const { paths: paths, pathsDiff: pathsDiff } = this.state;
        const FillLayer = this.getSubLayerClass("fill", (0, $7VEAA.default));
        const StrokeLayer = this.getSubLayerClass("stroke", (0, $lzW2S.default));
        const polygonLayer = this.shouldRenderSubLayer("fill", paths) && new FillLayer({
            _dataDiff: _dataDiff,
            extruded: extruded,
            elevationScale: elevationScale,
            filled: filled,
            wireframe: wireframe,
            _normalize: _normalize,
            _windingOrder: _windingOrder,
            getElevation: getElevation,
            getFillColor: getFillColor,
            getLineColor: extruded && wireframe ? getLineColor : $489e86f01fa23e27$var$defaultLineColor,
            material: material,
            transitions: transitions
        }, this.getSubLayerProps({
            id: "fill",
            updateTriggers: updateTriggers && {
                getPolygon: updateTriggers.getPolygon,
                getElevation: updateTriggers.getElevation,
                getFillColor: updateTriggers.getFillColor,
                lineColors: extruded && wireframe,
                getLineColor: updateTriggers.getLineColor
            }
        }), {
            data: data,
            positionFormat: positionFormat,
            getPolygon: getPolygon
        });
        const polygonLineLayer = !extruded && stroked && this.shouldRenderSubLayer("stroke", paths) && new StrokeLayer({
            _dataDiff: pathsDiff && (()=>pathsDiff),
            widthUnits: lineWidthUnits,
            widthScale: lineWidthScale,
            widthMinPixels: lineWidthMinPixels,
            widthMaxPixels: lineWidthMaxPixels,
            jointRounded: lineJointRounded,
            miterLimit: lineMiterLimit,
            dashJustified: lineDashJustified,
            _pathType: "loop",
            transitions: transitions && {
                getWidth: transitions.getLineWidth,
                getColor: transitions.getLineColor,
                getPath: transitions.getPolygon
            },
            getColor: this.getSubLayerAccessor(getLineColor),
            getWidth: this.getSubLayerAccessor(getLineWidth),
            getDashArray: this.getSubLayerAccessor(getLineDashArray)
        }, this.getSubLayerProps({
            id: "stroke",
            updateTriggers: updateTriggers && {
                getWidth: updateTriggers.getLineWidth,
                getColor: updateTriggers.getLineColor,
                getDashArray: updateTriggers.getLineDashArray
            }
        }), {
            data: paths,
            positionFormat: positionFormat,
            getPath: (x)=>x.path
        });
        return [
            !extruded && polygonLayer,
            polygonLineLayer,
            extruded && polygonLayer
        ];
    }
}
(0, $lEQUF.default)($489e86f01fa23e27$export$2e2bcd8739ae039, "layerName", "PolygonLayer");
(0, $lEQUF.default)($489e86f01fa23e27$export$2e2bcd8739ae039, "defaultProps", $489e86f01fa23e27$var$defaultProps);

});
parcelRegister("lEQUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc4660d3cb41e445$export$2e2bcd8739ae039; });
function $fc4660d3cb41e445$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("coXLq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $907615c95888d543$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1zR3q = parcelRequire("1zR3q");

var $i46md = parcelRequire("i46md");

var $bwVEZ = parcelRequire("bwVEZ");

var $ivBeX = parcelRequire("ivBeX");

var $lXg0j = parcelRequire("lXg0j");
const $907615c95888d543$var$TRACE_RENDER_LAYERS = "compositeLayer.renderLayers";
class $907615c95888d543$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    get isComposite() {
        return true;
    }
    get isLoaded() {
        return super.isLoaded && this.getSubLayers().every((layer)=>layer.isLoaded);
    }
    getSubLayers() {
        return this.internalState && this.internalState.subLayers || [];
    }
    initializeState(context) {}
    setState(updateObject) {
        super.setState(updateObject);
        this.setNeedsUpdate();
    }
    getPickingInfo({ info: info }) {
        const { object: object } = info;
        const isDataWrapped = object && object.__source && object.__source.parent && object.__source.parent.id === this.id;
        if (!isDataWrapped) return info;
        info.object = object.__source.object;
        info.index = object.__source.index;
        return info;
    }
    filterSubLayer(context) {
        return true;
    }
    shouldRenderSubLayer(subLayerId, data) {
        return data && data.length;
    }
    getSubLayerClass(subLayerId, DefaultLayerClass) {
        const { _subLayerProps: overridingProps } = this.props;
        return overridingProps && overridingProps[subLayerId] && overridingProps[subLayerId].type || DefaultLayerClass;
    }
    getSubLayerRow(row, sourceObject, sourceObjectIndex) {
        row.__source = {
            parent: this,
            object: sourceObject,
            index: sourceObjectIndex
        };
        return row;
    }
    getSubLayerAccessor(accessor) {
        if (typeof accessor === "function") {
            const objectInfo = {
                index: -1,
                data: this.props.data,
                target: []
            };
            return (x, i)=>{
                if (x && x.__source) {
                    objectInfo.index = x.__source.index;
                    return accessor(x.__source.object, objectInfo);
                }
                return accessor(x, i);
            };
        }
        return accessor;
    }
    getSubLayerProps(sublayerProps = {}) {
        var _this$props$updateTri;
        const { opacity: opacity, pickable: pickable, visible: visible, parameters: parameters, getPolygonOffset: getPolygonOffset, highlightedObjectIndex: highlightedObjectIndex, autoHighlight: autoHighlight, highlightColor: highlightColor, coordinateSystem: coordinateSystem, coordinateOrigin: coordinateOrigin, wrapLongitude: wrapLongitude, positionFormat: positionFormat, modelMatrix: modelMatrix, extensions: extensions, fetch: fetch, operation: operation, _subLayerProps: overridingProps } = this.props;
        const newProps = {
            id: "",
            updateTriggers: {},
            opacity: opacity,
            pickable: pickable,
            visible: visible,
            parameters: parameters,
            getPolygonOffset: getPolygonOffset,
            highlightedObjectIndex: highlightedObjectIndex,
            autoHighlight: autoHighlight,
            highlightColor: highlightColor,
            coordinateSystem: coordinateSystem,
            coordinateOrigin: coordinateOrigin,
            wrapLongitude: wrapLongitude,
            positionFormat: positionFormat,
            modelMatrix: modelMatrix,
            extensions: extensions,
            fetch: fetch,
            operation: operation
        };
        const overridingSublayerProps = overridingProps && sublayerProps.id && overridingProps[sublayerProps.id];
        const overridingSublayerTriggers = overridingSublayerProps && overridingSublayerProps.updateTriggers;
        const sublayerId = sublayerProps.id || "sublayer";
        if (overridingSublayerProps) {
            const propTypes = this.props[0, $lXg0j.PROP_TYPES_SYMBOL];
            const subLayerPropTypes = sublayerProps.type ? sublayerProps.type._propTypes : {};
            for(const key in overridingSublayerProps){
                const propType = subLayerPropTypes[key] || propTypes[key];
                if (propType && propType.type === "accessor") overridingSublayerProps[key] = this.getSubLayerAccessor(overridingSublayerProps[key]);
            }
        }
        Object.assign(newProps, sublayerProps, overridingSublayerProps);
        newProps.id = "".concat(this.props.id, "-").concat(sublayerId);
        newProps.updateTriggers = (0, $2QP2i._)({
            all: (_this$props$updateTri = this.props.updateTriggers) === null || _this$props$updateTri === void 0 ? void 0 : _this$props$updateTri.all
        }, sublayerProps.updateTriggers, overridingSublayerTriggers);
        for (const extension of extensions){
            const passThroughProps = extension.getSubLayerProps.call(this, extension);
            if (passThroughProps) Object.assign(newProps, passThroughProps, {
                updateTriggers: Object.assign(newProps.updateTriggers, passThroughProps.updateTriggers)
            });
        }
        return newProps;
    }
    _updateAutoHighlight(info) {
        for (const layer of this.getSubLayers())layer.updateAutoHighlight(info);
    }
    _getAttributeManager() {
        return null;
    }
    _postUpdate(updateParams, forceUpdate) {
        let subLayers = this.internalState.subLayers;
        const shouldUpdate = !subLayers || this.needsUpdate();
        if (shouldUpdate) {
            const subLayersList = this.renderLayers();
            subLayers = (0, $ivBeX.flatten)(subLayersList, Boolean);
            this.internalState.subLayers = subLayers;
        }
        (0, $bwVEZ.default)($907615c95888d543$var$TRACE_RENDER_LAYERS, this, shouldUpdate, subLayers);
        for (const layer of subLayers)layer.parent = this;
    }
}
(0, $1zR3q.default)($907615c95888d543$export$2e2bcd8739ae039, "layerName", "CompositeLayer");

});
parcelRegister("1zR3q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $126236cd6470e02c$export$2e2bcd8739ae039; });
function $126236cd6470e02c$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("i46md", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d26d882a326691db$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $1zR3q = parcelRequire("1zR3q");

var $7gQQK = parcelRequire("7gQQK");

var $ke18b = parcelRequire("ke18b");

var $EIvaG = parcelRequire("EIvaG");

var $ciluY = parcelRequire("ciluY");

var $lXg0j = parcelRequire("lXg0j");

var $6CX3d = parcelRequire("6CX3d");

var $4VQgq = parcelRequire("4VQgq");

var $bwVEZ = parcelRequire("bwVEZ");
parcelRequire("73UuK");
var $2SJyH = parcelRequire("2SJyH");

var $hu5l6 = parcelRequire("hu5l6");

var $b9Qhn = parcelRequire("b9Qhn");

var $4hN1x = parcelRequire("4hN1x");

var $4cXyN = parcelRequire("4cXyN");

var $an4RE = parcelRequire("an4RE");

var $lXqRv = parcelRequire("lXqRv");

var $5UhUg = parcelRequire("5UhUg");
parcelRequire("3vYZD");
var $k5FuL = parcelRequire("k5FuL");

var $ewlwV = parcelRequire("ewlwV");
const $d26d882a326691db$var$TRACE_CHANGE_FLAG = "layer.changeFlag";
const $d26d882a326691db$var$TRACE_INITIALIZE = "layer.initialize";
const $d26d882a326691db$var$TRACE_UPDATE = "layer.update";
const $d26d882a326691db$var$TRACE_FINALIZE = "layer.finalize";
const $d26d882a326691db$var$TRACE_MATCHED = "layer.matched";
const $d26d882a326691db$var$MAX_PICKING_COLOR_CACHE_SIZE = 2 ** 24 - 1;
const $d26d882a326691db$var$EMPTY_ARRAY = Object.freeze([]);
const $d26d882a326691db$var$areViewportsEqual = (0, $b9Qhn.default)(({ oldViewport: oldViewport, viewport: viewport })=>{
    return oldViewport.equals(viewport);
});
let $d26d882a326691db$var$pickingColorCache = new Uint8ClampedArray(0);
const $d26d882a326691db$var$defaultProps = {
    data: {
        type: "data",
        value: $d26d882a326691db$var$EMPTY_ARRAY,
        async: true
    },
    dataComparator: {
        type: "function",
        value: null,
        optional: true
    },
    _dataDiff: {
        type: "function",
        value: (data)=>data && data.__diff,
        optional: true
    },
    dataTransform: {
        type: "function",
        value: null,
        optional: true
    },
    onDataLoad: {
        type: "function",
        value: null,
        optional: true
    },
    onError: {
        type: "function",
        value: null,
        optional: true
    },
    fetch: {
        type: "function",
        value: (url, { propName: propName, layer: layer, loaders: loaders, loadOptions: loadOptions, signal: signal })=>{
            const { resourceManager: resourceManager } = layer.context;
            loadOptions = loadOptions || layer.getLoadOptions();
            loaders = loaders || layer.props.loaders;
            if (signal) {
                var _loadOptions;
                loadOptions = (0, $edHbI._)((0, $2QP2i._)({}, loadOptions), {
                    fetch: (0, $edHbI._)((0, $2QP2i._)({}, (_loadOptions = loadOptions) === null || _loadOptions === void 0 ? void 0 : _loadOptions.fetch), {
                        signal: signal
                    })
                });
            }
            let inResourceManager = resourceManager.contains(url);
            if (!inResourceManager && !loadOptions) {
                resourceManager.add({
                    resourceId: url,
                    data: (0, $ewlwV.load)(url, loaders),
                    persistent: false
                });
                inResourceManager = true;
            }
            if (inResourceManager) return resourceManager.subscribe({
                resourceId: url,
                onChange: (data)=>{
                    var _layer$internalState;
                    return (_layer$internalState = layer.internalState) === null || _layer$internalState === void 0 ? void 0 : _layer$internalState.reloadAsyncProp(propName, data);
                },
                consumerId: layer.id,
                requestId: propName
            });
            return (0, $ewlwV.load)(url, loaders, loadOptions);
        }
    },
    updateTriggers: {},
    visible: true,
    pickable: false,
    opacity: {
        type: "number",
        min: 0,
        max: 1,
        value: 1
    },
    operation: "draw",
    onHover: {
        type: "function",
        value: null,
        optional: true
    },
    onClick: {
        type: "function",
        value: null,
        optional: true
    },
    onDragStart: {
        type: "function",
        value: null,
        optional: true
    },
    onDrag: {
        type: "function",
        value: null,
        optional: true
    },
    onDragEnd: {
        type: "function",
        value: null,
        optional: true
    },
    coordinateSystem: (0, $7gQQK.COORDINATE_SYSTEM).DEFAULT,
    coordinateOrigin: {
        type: "array",
        value: [
            0,
            0,
            0
        ],
        compare: true
    },
    modelMatrix: {
        type: "array",
        value: null,
        compare: true,
        optional: true
    },
    wrapLongitude: false,
    positionFormat: "XYZ",
    colorFormat: "RGBA",
    parameters: {
        type: "object",
        value: {},
        optional: true,
        compare: 2
    },
    loadOptions: {
        type: "object",
        value: null,
        optional: true,
        ignore: true
    },
    transitions: null,
    extensions: [],
    loaders: {
        type: "array",
        value: [],
        optional: true,
        ignore: true
    },
    getPolygonOffset: {
        type: "function",
        value: ({ layerIndex: layerIndex })=>[
                0,
                -layerIndex * 100
            ]
    },
    highlightedObjectIndex: null,
    autoHighlight: false,
    highlightColor: {
        type: "accessor",
        value: [
            0,
            0,
            128,
            128
        ]
    }
};
class $d26d882a326691db$export$2e2bcd8739ae039 extends (0, $lXqRv.default) {
    static get componentName() {
        return Object.prototype.hasOwnProperty.call(this, "layerName") ? this.layerName : "";
    }
    get root() {
        let layer = this;
        while(layer.parent)layer = layer.parent;
        return layer;
    }
    toString() {
        const className = this.constructor.layerName || this.constructor.name;
        return "".concat(className, "({id: '").concat(this.props.id, "'})");
    }
    project(xyz) {
        (0, $hu5l6.default)(this.internalState);
        const viewport = this.internalState.viewport || this.context.viewport;
        const worldPosition = (0, $4cXyN.getWorldPosition)(xyz, {
            viewport: viewport,
            modelMatrix: this.props.modelMatrix,
            coordinateOrigin: this.props.coordinateOrigin,
            coordinateSystem: this.props.coordinateSystem
        });
        const [x, y, z] = (0, $k5FuL.worldToPixels)(worldPosition, viewport.pixelProjectionMatrix);
        return xyz.length === 2 ? [
            x,
            y
        ] : [
            x,
            y,
            z
        ];
    }
    unproject(xy) {
        (0, $hu5l6.default)(this.internalState);
        const viewport = this.internalState.viewport || this.context.viewport;
        return viewport.unproject(xy);
    }
    projectPosition(xyz, params) {
        (0, $hu5l6.default)(this.internalState);
        const viewport = this.internalState.viewport || this.context.viewport;
        return (0, $4cXyN.projectPosition)(xyz, (0, $2QP2i._)({
            viewport: viewport,
            modelMatrix: this.props.modelMatrix,
            coordinateOrigin: this.props.coordinateOrigin,
            coordinateSystem: this.props.coordinateSystem
        }, params));
    }
    get isComposite() {
        return false;
    }
    setState(partialState) {
        this.setChangeFlags({
            stateChanged: true
        });
        Object.assign(this.state, partialState);
        this.setNeedsRedraw();
    }
    setNeedsRedraw() {
        if (this.internalState) this.internalState.needsRedraw = true;
    }
    setNeedsUpdate() {
        if (this.internalState) {
            this.context.layerManager.setNeedsUpdate(String(this));
            this.internalState.needsUpdate = true;
        }
    }
    get isLoaded() {
        return this.internalState ? !this.internalState.isAsyncPropLoading() : false;
    }
    get wrapLongitude() {
        return this.props.wrapLongitude;
    }
    isPickable() {
        return this.props.pickable && this.props.visible;
    }
    getModels() {
        return this.state && (this.state.models || this.state.model && [
            this.state.model
        ]) || [];
    }
    setModuleParameters(moduleParameters) {
        for (const model of this.getModels())model.updateModuleSettings(moduleParameters);
    }
    getAttributeManager() {
        return this.internalState && this.internalState.attributeManager;
    }
    getCurrentLayer() {
        return this.internalState && this.internalState.layer;
    }
    getLoadOptions() {
        return this.props.loadOptions;
    }
    use64bitPositions() {
        const { coordinateSystem: coordinateSystem } = this.props;
        return coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).DEFAULT || coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT || coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN;
    }
    onHover(info, pickingEvent) {
        if (this.props.onHover) return this.props.onHover(info, pickingEvent) || false;
        return false;
    }
    onClick(info, pickingEvent) {
        if (this.props.onClick) return this.props.onClick(info, pickingEvent) || false;
        return false;
    }
    nullPickingColor() {
        return [
            0,
            0,
            0
        ];
    }
    encodePickingColor(i, target = []) {
        target[0] = i + 1 & 255;
        target[1] = i + 1 >> 8 & 255;
        target[2] = i + 1 >> 8 >> 8 & 255;
        return target;
    }
    decodePickingColor(color) {
        (0, $hu5l6.default)(color instanceof Uint8Array);
        const [i1, i2, i3] = color;
        const index = i1 + i2 * 256 + i3 * 65536 - 1;
        return index;
    }
    getNumInstances() {
        if (Number.isFinite(this.props.numInstances)) return this.props.numInstances;
        if (this.state && this.state.numInstances !== undefined) return this.state.numInstances;
        return (0, $6CX3d.count)(this.props.data);
    }
    getStartIndices() {
        if (this.props.startIndices) return this.props.startIndices;
        if (this.state && this.state.startIndices) return this.state.startIndices;
        return null;
    }
    getBounds() {
        var _this$getAttributeMan;
        return (_this$getAttributeMan = this.getAttributeManager()) === null || _this$getAttributeMan === void 0 ? void 0 : _this$getAttributeMan.getBounds([
            "positions",
            "instancePositions"
        ]);
    }
    getShaders(shaders) {
        for (const extension of this.props.extensions)shaders = (0, $4hN1x.mergeShaders)(shaders, extension.getShaders.call(this, extension));
        return shaders;
    }
    shouldUpdateState(params) {
        return params.changeFlags.propsOrDataChanged;
    }
    updateState(params) {
        const attributeManager = this.getAttributeManager();
        const { dataChanged: dataChanged } = params.changeFlags;
        if (dataChanged && attributeManager) {
            if (Array.isArray(dataChanged)) for (const dataRange of dataChanged)attributeManager.invalidateAll(dataRange);
            else attributeManager.invalidateAll();
        }
        if (attributeManager) {
            const { props: props } = params;
            const hasPickingBuffer = this.internalState.hasPickingBuffer;
            const needsPickingBuffer = Number.isInteger(props.highlightedObjectIndex) || props.pickable || props.extensions.some((extension)=>extension.getNeedsPickingBuffer.call(this, extension));
            if (hasPickingBuffer !== needsPickingBuffer) {
                this.internalState.hasPickingBuffer = needsPickingBuffer;
                const { pickingColors: pickingColors, instancePickingColors: instancePickingColors } = attributeManager.attributes;
                const pickingColorsAttribute = pickingColors || instancePickingColors;
                if (pickingColorsAttribute) {
                    if (needsPickingBuffer && pickingColorsAttribute.constant) {
                        pickingColorsAttribute.constant = false;
                        attributeManager.invalidate(pickingColorsAttribute.id);
                    }
                    if (!pickingColorsAttribute.value && !needsPickingBuffer) {
                        pickingColorsAttribute.constant = true;
                        pickingColorsAttribute.value = [
                            0,
                            0,
                            0
                        ];
                    }
                }
            }
        }
    }
    finalizeState(context) {
        for (const model of this.getModels())model.delete();
        const attributeManager = this.getAttributeManager();
        if (attributeManager) attributeManager.finalize();
        if (this.context) this.context.resourceManager.unsubscribe({
            consumerId: this.id
        });
        if (this.internalState) {
            this.internalState.uniformTransitions.clear();
            this.internalState.finalize();
        }
    }
    draw(opts) {
        for (const model of this.getModels())model.draw(opts);
    }
    getPickingInfo({ info: info, mode: mode, sourceLayer: sourceLayer }) {
        const { index: index } = info;
        if (index >= 0) {
            if (Array.isArray(this.props.data)) info.object = this.props.data[index];
        }
        return info;
    }
    raiseError(error, message) {
        var _this$props$onError, _this$props;
        if (message) error = new Error("".concat(message, ": ").concat(error.message), {
            cause: error
        });
        if (!((_this$props$onError = (_this$props = this.props).onError) !== null && _this$props$onError !== void 0 && _this$props$onError.call(_this$props, error))) {
            var _this$context, _this$context$onError;
            (_this$context = this.context) === null || _this$context === void 0 || (_this$context$onError = _this$context.onError) === null || _this$context$onError === void 0 || _this$context$onError.call(_this$context, error, this);
        }
    }
    getNeedsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        return this._getNeedsRedraw(opts);
    }
    needsUpdate() {
        if (!this.internalState) return false;
        return this.internalState.needsUpdate || this.hasUniformTransition() || this.shouldUpdateState(this._getUpdateParams());
    }
    hasUniformTransition() {
        var _this$internalState;
        return ((_this$internalState = this.internalState) === null || _this$internalState === void 0 ? void 0 : _this$internalState.uniformTransitions.active) || false;
    }
    activateViewport(viewport) {
        if (!this.internalState) return;
        const oldViewport = this.internalState.viewport;
        this.internalState.viewport = viewport;
        if (!oldViewport || !$d26d882a326691db$var$areViewportsEqual({
            oldViewport: oldViewport,
            viewport: viewport
        })) {
            this.setChangeFlags({
                viewportChanged: true
            });
            if (this.isComposite) {
                if (this.needsUpdate()) this.setNeedsUpdate();
            } else this._update();
        }
    }
    invalidateAttribute(name = "all") {
        const attributeManager = this.getAttributeManager();
        if (!attributeManager) return;
        if (name === "all") attributeManager.invalidateAll();
        else attributeManager.invalidate(name);
    }
    updateAttributes(changedAttributes) {
        for (const model of this.getModels())this._setModelAttributes(model, changedAttributes);
    }
    _updateAttributes() {
        const attributeManager = this.getAttributeManager();
        if (!attributeManager) return;
        const props = this.props;
        const numInstances = this.getNumInstances();
        const startIndices = this.getStartIndices();
        attributeManager.update({
            data: props.data,
            numInstances: numInstances,
            startIndices: startIndices,
            props: props,
            transitions: props.transitions,
            buffers: props.data.attributes,
            context: this
        });
        const changedAttributes = attributeManager.getChangedAttributes({
            clearChangedFlags: true
        });
        this.updateAttributes(changedAttributes);
    }
    _updateAttributeTransition() {
        const attributeManager = this.getAttributeManager();
        if (attributeManager) attributeManager.updateTransition();
    }
    _updateUniformTransition() {
        const { uniformTransitions: uniformTransitions } = this.internalState;
        if (uniformTransitions.active) {
            const propsInTransition = uniformTransitions.update();
            const props = Object.create(this.props);
            for(const key in propsInTransition)Object.defineProperty(props, key, {
                value: propsInTransition[key]
            });
            return props;
        }
        return this.props;
    }
    calculateInstancePickingColors(attribute, { numInstances: numInstances }) {
        if (attribute.constant) return;
        const cacheSize = Math.floor($d26d882a326691db$var$pickingColorCache.length / 3);
        this.internalState.usesPickingColorCache = true;
        if (cacheSize < numInstances) {
            if (numInstances > $d26d882a326691db$var$MAX_PICKING_COLOR_CACHE_SIZE) (0, $4VQgq.default).warn("Layer has too many data objects. Picking might not be able to distinguish all objects.")();
            $d26d882a326691db$var$pickingColorCache = (0, $an4RE.default).allocate($d26d882a326691db$var$pickingColorCache, numInstances, {
                size: 3,
                copy: true,
                maxCount: Math.max(numInstances, $d26d882a326691db$var$MAX_PICKING_COLOR_CACHE_SIZE)
            });
            const newCacheSize = Math.floor($d26d882a326691db$var$pickingColorCache.length / 3);
            const pickingColor = [];
            for(let i = cacheSize; i < newCacheSize; i++){
                this.encodePickingColor(i, pickingColor);
                $d26d882a326691db$var$pickingColorCache[i * 3 + 0] = pickingColor[0];
                $d26d882a326691db$var$pickingColorCache[i * 3 + 1] = pickingColor[1];
                $d26d882a326691db$var$pickingColorCache[i * 3 + 2] = pickingColor[2];
            }
        }
        attribute.value = $d26d882a326691db$var$pickingColorCache.subarray(0, numInstances * 3);
    }
    _setModelAttributes(model, changedAttributes) {
        const attributeManager = this.getAttributeManager();
        const excludeAttributes = model.userData.excludeAttributes || {};
        const shaderAttributes = attributeManager.getShaderAttributes(changedAttributes, excludeAttributes);
        model.setAttributes(shaderAttributes);
    }
    disablePickingIndex(objectIndex) {
        const data = this.props.data;
        if (!("attributes" in data)) {
            this._disablePickingIndex(objectIndex);
            return;
        }
        const { pickingColors: pickingColors, instancePickingColors: instancePickingColors } = this.getAttributeManager().attributes;
        const colors = pickingColors || instancePickingColors;
        const externalColorAttribute = colors && data.attributes && data.attributes[colors.id];
        if (externalColorAttribute && externalColorAttribute.value) {
            const values = externalColorAttribute.value;
            const objectColor = this.encodePickingColor(objectIndex);
            for(let index = 0; index < data.length; index++){
                const i = colors.getVertexOffset(index);
                if (values[i] === objectColor[0] && values[i + 1] === objectColor[1] && values[i + 2] === objectColor[2]) this._disablePickingIndex(index);
            }
        } else this._disablePickingIndex(objectIndex);
    }
    _disablePickingIndex(objectIndex) {
        const { pickingColors: pickingColors, instancePickingColors: instancePickingColors } = this.getAttributeManager().attributes;
        const colors = pickingColors || instancePickingColors;
        if (!colors) return;
        const start = colors.getVertexOffset(objectIndex);
        const end = colors.getVertexOffset(objectIndex + 1);
        colors.buffer.subData({
            data: new Uint8Array(end - start),
            offset: start
        });
    }
    restorePickingColors() {
        const { pickingColors: pickingColors, instancePickingColors: instancePickingColors } = this.getAttributeManager().attributes;
        const colors = pickingColors || instancePickingColors;
        if (!colors) return;
        if (this.internalState.usesPickingColorCache && colors.value.buffer !== $d26d882a326691db$var$pickingColorCache.buffer) colors.value = $d26d882a326691db$var$pickingColorCache.subarray(0, colors.value.length);
        colors.updateSubBuffer({
            startOffset: 0
        });
    }
    _initialize() {
        (0, $hu5l6.default)(!this.internalState);
        (0, $hu5l6.default)(Number.isFinite(this.props.coordinateSystem));
        (0, $bwVEZ.default)($d26d882a326691db$var$TRACE_INITIALIZE, this);
        const attributeManager = this._getAttributeManager();
        if (attributeManager) attributeManager.addInstanced({
            instancePickingColors: {
                type: 5121,
                size: 3,
                noAlloc: true,
                update: this.calculateInstancePickingColors
            }
        });
        this.internalState = new (0, $5UhUg.default)({
            attributeManager: attributeManager,
            layer: this
        });
        this._clearChangeFlags();
        this.state = {};
        Object.defineProperty(this.state, "attributeManager", {
            get: ()=>{
                (0, $4VQgq.default).deprecated("layer.state.attributeManager", "layer.getAttributeManager()")();
                return attributeManager;
            }
        });
        this.internalState.uniformTransitions = new (0, $EIvaG.default)(this.context.timeline);
        this.internalState.onAsyncPropUpdated = this._onAsyncPropUpdated.bind(this);
        this.internalState.setAsyncProps(this.props);
        this.initializeState(this.context);
        for (const extension of this.props.extensions)extension.initializeState.call(this, this.context, extension);
        this.setChangeFlags({
            dataChanged: "init",
            propsChanged: "init",
            viewportChanged: true,
            extensionsChanged: true
        });
        this._update();
    }
    _transferState(oldLayer) {
        (0, $bwVEZ.default)($d26d882a326691db$var$TRACE_MATCHED, this, this === oldLayer);
        const { state: state, internalState: internalState } = oldLayer;
        if (this === oldLayer) return;
        this.internalState = internalState;
        this.state = state;
        this.internalState.setAsyncProps(this.props);
        this._diffProps(this.props, this.internalState.getOldProps());
    }
    _update() {
        const stateNeedsUpdate = this.needsUpdate();
        (0, $bwVEZ.default)($d26d882a326691db$var$TRACE_UPDATE, this, stateNeedsUpdate);
        if (!stateNeedsUpdate) return;
        const currentProps = this.props;
        const context = this.context;
        const internalState = this.internalState;
        const currentViewport = context.viewport;
        const propsInTransition = this._updateUniformTransition();
        internalState.propsInTransition = propsInTransition;
        context.viewport = internalState.viewport || currentViewport;
        this.props = propsInTransition;
        try {
            const updateParams = this._getUpdateParams();
            const oldModels = this.getModels();
            if (context.gl) this.updateState(updateParams);
            else try {
                this.updateState(updateParams);
            } catch (error) {}
            for (const extension of this.props.extensions)extension.updateState.call(this, updateParams, extension);
            const modelChanged = this.getModels()[0] !== oldModels[0];
            this._postUpdate(updateParams, modelChanged);
        } finally{
            context.viewport = currentViewport;
            this.props = currentProps;
            this._clearChangeFlags();
            internalState.needsUpdate = false;
            internalState.resetOldProps();
        }
    }
    _finalize() {
        (0, $bwVEZ.default)($d26d882a326691db$var$TRACE_FINALIZE, this);
        this.finalizeState(this.context);
        for (const extension of this.props.extensions)extension.finalizeState.call(this, this.context, extension);
    }
    _drawLayer({ moduleParameters: moduleParameters = null, uniforms: uniforms = {}, parameters: parameters = {} }) {
        this._updateAttributeTransition();
        const currentProps = this.props;
        const context = this.context;
        this.props = this.internalState.propsInTransition || currentProps;
        const opacity = this.props.opacity;
        uniforms.opacity = Math.pow(opacity, 1 / 2.2);
        try {
            if (moduleParameters) this.setModuleParameters(moduleParameters);
            const { getPolygonOffset: getPolygonOffset } = this.props;
            const offsets = getPolygonOffset && getPolygonOffset(uniforms) || [
                0,
                0
            ];
            (0, $2SJyH.setParameters)(context.gl, {
                polygonOffset: offsets
            });
            (0, $2SJyH.withParameters)(context.gl, parameters, ()=>{
                const opts = {
                    moduleParameters: moduleParameters,
                    uniforms: uniforms,
                    parameters: parameters,
                    context: context
                };
                for (const extension of this.props.extensions)extension.draw.call(this, opts, extension);
                this.draw(opts);
            });
        } finally{
            this.props = currentProps;
        }
    }
    getChangeFlags() {
        var _this$internalState2;
        return (_this$internalState2 = this.internalState) === null || _this$internalState2 === void 0 ? void 0 : _this$internalState2.changeFlags;
    }
    setChangeFlags(flags) {
        if (!this.internalState) return;
        const { changeFlags: changeFlags } = this.internalState;
        for(const key in flags)if (flags[key]) {
            let flagChanged = false;
            switch(key){
                case "dataChanged":
                    const dataChangedReason = flags[key];
                    const prevDataChangedReason = changeFlags[key];
                    if (dataChangedReason && Array.isArray(prevDataChangedReason)) {
                        changeFlags.dataChanged = Array.isArray(dataChangedReason) ? prevDataChangedReason.concat(dataChangedReason) : dataChangedReason;
                        flagChanged = true;
                    }
                default:
                    if (!changeFlags[key]) {
                        changeFlags[key] = flags[key];
                        flagChanged = true;
                    }
            }
            if (flagChanged) (0, $bwVEZ.default)($d26d882a326691db$var$TRACE_CHANGE_FLAG, this, key, flags);
        }
        const propsOrDataChanged = Boolean(changeFlags.dataChanged || changeFlags.updateTriggersChanged || changeFlags.propsChanged || changeFlags.extensionsChanged);
        changeFlags.propsOrDataChanged = propsOrDataChanged;
        changeFlags.somethingChanged = propsOrDataChanged || changeFlags.viewportChanged || changeFlags.stateChanged;
    }
    _clearChangeFlags() {
        this.internalState.changeFlags = {
            dataChanged: false,
            propsChanged: false,
            updateTriggersChanged: false,
            viewportChanged: false,
            stateChanged: false,
            extensionsChanged: false,
            propsOrDataChanged: false,
            somethingChanged: false
        };
    }
    _diffProps(newProps, oldProps) {
        const changeFlags = (0, $ciluY.diffProps)(newProps, oldProps);
        if (changeFlags.updateTriggersChanged) {
            for(const key in changeFlags.updateTriggersChanged)if (changeFlags.updateTriggersChanged[key]) this.invalidateAttribute(key);
        }
        if (changeFlags.transitionsChanged) for(const key in changeFlags.transitionsChanged){
            var _newProps$transitions;
            this.internalState.uniformTransitions.add(key, oldProps[key], newProps[key], (_newProps$transitions = newProps.transitions) === null || _newProps$transitions === void 0 ? void 0 : _newProps$transitions[key]);
        }
        return this.setChangeFlags(changeFlags);
    }
    validateProps() {
        (0, $ciluY.validateProps)(this.props);
    }
    updateAutoHighlight(info) {
        if (this.props.autoHighlight && !Number.isInteger(this.props.highlightedObjectIndex)) this._updateAutoHighlight(info);
    }
    _updateAutoHighlight(info) {
        const pickingModuleParameters = {
            pickingSelectedColor: info.picked ? info.color : null
        };
        const { highlightColor: highlightColor } = this.props;
        if (info.picked && typeof highlightColor === "function") pickingModuleParameters.pickingHighlightColor = highlightColor(info);
        this.setModuleParameters(pickingModuleParameters);
        this.setNeedsRedraw();
    }
    _getAttributeManager() {
        const context = this.context;
        return new (0, $ke18b.default)(context.gl, {
            id: this.props.id,
            stats: context.stats,
            timeline: context.timeline
        });
    }
    _postUpdate(updateParams, forceUpdate) {
        const { props: props, oldProps: oldProps } = updateParams;
        this.setNeedsRedraw();
        this._updateAttributes();
        const { model: model } = this.state;
        model === null || model === void 0 || model.setInstanceCount(this.getNumInstances());
        const { autoHighlight: autoHighlight, highlightedObjectIndex: highlightedObjectIndex, highlightColor: highlightColor } = props;
        if (forceUpdate || oldProps.autoHighlight !== autoHighlight || oldProps.highlightedObjectIndex !== highlightedObjectIndex || oldProps.highlightColor !== highlightColor) {
            const parameters = {};
            if (!autoHighlight) parameters.pickingSelectedColor = null;
            if (Array.isArray(highlightColor)) parameters.pickingHighlightColor = highlightColor;
            if (forceUpdate || highlightedObjectIndex !== oldProps.highlightedObjectIndex) parameters.pickingSelectedColor = Number.isFinite(highlightedObjectIndex) && highlightedObjectIndex >= 0 ? this.encodePickingColor(highlightedObjectIndex) : null;
            this.setModuleParameters(parameters);
        }
    }
    _getUpdateParams() {
        return {
            props: this.props,
            oldProps: this.internalState.getOldProps(),
            context: this.context,
            changeFlags: this.internalState.changeFlags
        };
    }
    _getNeedsRedraw(opts) {
        if (!this.internalState) return false;
        let redraw = false;
        redraw = redraw || this.internalState.needsRedraw && this.id;
        const attributeManager = this.getAttributeManager();
        const attributeManagerNeedsRedraw = attributeManager ? attributeManager.getNeedsRedraw(opts) : false;
        redraw = redraw || attributeManagerNeedsRedraw;
        if (redraw) for (const extension of this.props.extensions)extension.onNeedsRedraw.call(this, extension);
        this.internalState.needsRedraw = this.internalState.needsRedraw && !opts.clearRedrawFlags;
        return redraw;
    }
    _onAsyncPropUpdated() {
        this._diffProps(this.props, this.internalState.getOldProps());
        this.setNeedsUpdate();
    }
    constructor(...args){
        super(...args);
        (0, $1zR3q.default)(this, "internalState", null);
        (0, $1zR3q.default)(this, "lifecycle", (0, $lXg0j.LIFECYCLE).NO_STATE);
        (0, $1zR3q.default)(this, "context", void 0);
        (0, $1zR3q.default)(this, "state", void 0);
        (0, $1zR3q.default)(this, "parent", null);
    }
}
(0, $1zR3q.default)($d26d882a326691db$export$2e2bcd8739ae039, "defaultProps", $d26d882a326691db$var$defaultProps);
(0, $1zR3q.default)($d26d882a326691db$export$2e2bcd8739ae039, "layerName", "Layer");

});
parcelRegister("7gQQK", function(module, exports) {

$parcel$export(module.exports, "COORDINATE_SYSTEM", function () { return $54b305e24bb885b8$export$e4ccd0285368e485; });
$parcel$export(module.exports, "PROJECTION_MODE", function () { return $54b305e24bb885b8$export$3697aaebd269a548; });
$parcel$export(module.exports, "UNIT", function () { return $54b305e24bb885b8$export$97361b7a0c542045; });
$parcel$export(module.exports, "EVENTS", function () { return $54b305e24bb885b8$export$fa3d5b535a2458a1; });

var $4VQgq = parcelRequire("4VQgq");
const $54b305e24bb885b8$export$e4ccd0285368e485 = {
    DEFAULT: -1,
    LNGLAT: 1,
    METER_OFFSETS: 2,
    LNGLAT_OFFSETS: 3,
    CARTESIAN: 0
};
Object.defineProperty($54b305e24bb885b8$export$e4ccd0285368e485, "IDENTITY", {
    get: ()=>{
        (0, $4VQgq.default).deprecated("COORDINATE_SYSTEM.IDENTITY", "COORDINATE_SYSTEM.CARTESIAN")();
        return 0;
    }
});
const $54b305e24bb885b8$export$3697aaebd269a548 = {
    WEB_MERCATOR: 1,
    GLOBE: 2,
    WEB_MERCATOR_AUTO_OFFSET: 4,
    IDENTITY: 0
};
const $54b305e24bb885b8$export$97361b7a0c542045 = {
    common: 0,
    meters: 1,
    pixels: 2
};
const $54b305e24bb885b8$export$fa3d5b535a2458a1 = {
    click: {
        handler: "onClick"
    },
    panstart: {
        handler: "onDragStart"
    },
    panmove: {
        handler: "onDrag"
    },
    panend: {
        handler: "onDragEnd"
    }
};
const $54b305e24bb885b8$export$b56168d831461ce2 = {
    DRAW: "draw",
    MASK: "mask",
    TERRAIN: "terrain"
};

});
parcelRegister("4VQgq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $397506d1c45d8e82$export$2e2bcd8739ae039; });
parcelRequire("hBHxj");
var $1s4ih = parcelRequire("1s4ih");
var $397506d1c45d8e82$export$2e2bcd8739ae039 = new (0, $1s4ih.Log)({
    id: "deck"
});

});
parcelRegister("hBHxj", function(module, exports) {

$parcel$export(module.exports, "Log", function () { return (parcelRequire("1s4ih")).Log; });

var $1s4ih = parcelRequire("1s4ih");






var $cd17a9c5435a1e2f$export$2e2bcd8739ae039 = new (0, $1s4ih.Log)({
    id: "@probe.gl/log"
});

});
parcelRegister("1s4ih", function(module, exports) {

$parcel$export(module.exports, "Log", function () { return $10ebbc9d5655d27e$export$ce30dbb46644d06c; });

var $lK3ac = parcelRequire("lK3ac");

var $jeIEj = parcelRequire("jeIEj");
var $h6Pse = parcelRequire("h6Pse");

var $ae2RA = parcelRequire("ae2RA");

var $6liXj = parcelRequire("6liXj");

var $abwsY = parcelRequire("abwsY");

var $1ezvW = parcelRequire("1ezvW");

var $dkjRw = parcelRequire("dkjRw");

var $3odO6 = parcelRequire("3odO6");
const $10ebbc9d5655d27e$var$originalConsole = {
    debug: (0, $jeIEj.default) ? console.debug || console.log : console.log,
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error
};
const $10ebbc9d5655d27e$var$DEFAULT_SETTINGS = {
    enabled: true,
    level: 0
};
function $10ebbc9d5655d27e$var$noop() {}
const $10ebbc9d5655d27e$var$cache = {};
const $10ebbc9d5655d27e$var$ONCE = {
    once: true
};
class $10ebbc9d5655d27e$export$ce30dbb46644d06c {
    set level(newLevel) {
        this.setLevel(newLevel);
    }
    get level() {
        return this.getLevel();
    }
    isEnabled() {
        return this._storage.config.enabled;
    }
    getLevel() {
        return this._storage.config.level;
    }
    getTotal() {
        return Number(((0, $3odO6.getHiResTimestamp)() - this._startTs).toPrecision(10));
    }
    getDelta() {
        return Number(((0, $3odO6.getHiResTimestamp)() - this._deltaTs).toPrecision(10));
    }
    set priority(newPriority) {
        this.level = newPriority;
    }
    get priority() {
        return this.level;
    }
    getPriority() {
        return this.level;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this._storage.setConfiguration({
            enabled: enabled
        });
        return this;
    }
    setLevel(level) {
        this._storage.setConfiguration({
            level: level
        });
        return this;
    }
    get(setting) {
        return this._storage.config[setting];
    }
    set(setting, value) {
        this._storage.setConfiguration({
            [setting]: value
        });
    }
    settings() {
        if (console.table) console.table(this._storage.config);
        else console.log(this._storage.config);
    }
    assert(condition, message) {
        (0, $dkjRw.default)(condition, message);
    }
    warn(message) {
        return this._getLogFunction(0, message, $10ebbc9d5655d27e$var$originalConsole.warn, arguments, $10ebbc9d5655d27e$var$ONCE);
    }
    error(message) {
        return this._getLogFunction(0, message, $10ebbc9d5655d27e$var$originalConsole.error, arguments);
    }
    deprecated(oldUsage, newUsage) {
        return this.warn("`".concat(oldUsage, "` is deprecated and will be removed in a later version. Use `").concat(newUsage, "` instead"));
    }
    removed(oldUsage, newUsage) {
        return this.error("`".concat(oldUsage, "` has been removed. Use `").concat(newUsage, "` instead"));
    }
    probe(logLevel, message) {
        return this._getLogFunction(logLevel, message, $10ebbc9d5655d27e$var$originalConsole.log, arguments, {
            time: true,
            once: true
        });
    }
    log(logLevel, message) {
        return this._getLogFunction(logLevel, message, $10ebbc9d5655d27e$var$originalConsole.debug, arguments);
    }
    info(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.info, arguments);
    }
    once(logLevel, message) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return this._getLogFunction(logLevel, message, $10ebbc9d5655d27e$var$originalConsole.debug || $10ebbc9d5655d27e$var$originalConsole.info, arguments, $10ebbc9d5655d27e$var$ONCE);
    }
    table(logLevel, table, columns) {
        if (table) return this._getLogFunction(logLevel, table, console.table || $10ebbc9d5655d27e$var$noop, columns && [
            columns
        ], {
            tag: $10ebbc9d5655d27e$var$getTableHeader(table)
        });
        return $10ebbc9d5655d27e$var$noop;
    }
    image(_ref) {
        let { logLevel: logLevel, priority: priority, image: image, message: message = "", scale: scale = 1 } = _ref;
        if (!this._shouldLog(logLevel || priority)) return $10ebbc9d5655d27e$var$noop;
        return (0, $jeIEj.default) ? $10ebbc9d5655d27e$var$logImageInBrowser({
            image: image,
            message: message,
            scale: scale
        }) : $10ebbc9d5655d27e$var$logImageInNode({
            image: image,
            message: message,
            scale: scale
        });
    }
    time(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.time ? console.time : console.info);
    }
    timeEnd(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeEnd ? console.timeEnd : console.info);
    }
    timeStamp(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeStamp || $10ebbc9d5655d27e$var$noop);
    }
    group(logLevel, message) {
        let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            collapsed: false
        };
        const options = $10ebbc9d5655d27e$export$abc60e668512edf9({
            logLevel: logLevel,
            message: message,
            opts: opts
        });
        const { collapsed: collapsed } = opts;
        options.method = (collapsed ? console.groupCollapsed : console.group) || console.info;
        return this._getLogFunction(options);
    }
    groupCollapsed(logLevel, message) {
        let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.group(logLevel, message, Object.assign({}, opts, {
            collapsed: true
        }));
    }
    groupEnd(logLevel) {
        return this._getLogFunction(logLevel, "", console.groupEnd || $10ebbc9d5655d27e$var$noop);
    }
    withGroup(logLevel, message, func) {
        this.group(logLevel, message)();
        try {
            func();
        } finally{
            this.groupEnd(logLevel)();
        }
    }
    trace() {
        if (console.trace) console.trace();
    }
    _shouldLog(logLevel) {
        return this.isEnabled() && this.getLevel() >= $10ebbc9d5655d27e$var$normalizeLogLevel(logLevel);
    }
    _getLogFunction(logLevel, message, method, args, opts) {
        if (this._shouldLog(logLevel)) {
            opts = $10ebbc9d5655d27e$export$abc60e668512edf9({
                logLevel: logLevel,
                message: message,
                args: args,
                opts: opts
            });
            method = method || opts.method;
            (0, $dkjRw.default)(method);
            opts.total = this.getTotal();
            opts.delta = this.getDelta();
            this._deltaTs = (0, $3odO6.getHiResTimestamp)();
            const tag = opts.tag || opts.message;
            if (opts.once) {
                if (!$10ebbc9d5655d27e$var$cache[tag]) $10ebbc9d5655d27e$var$cache[tag] = (0, $3odO6.getHiResTimestamp)();
                else return $10ebbc9d5655d27e$var$noop;
            }
            message = $10ebbc9d5655d27e$var$decorateMessage(this.id, opts.message, opts);
            return method.bind(console, message, ...opts.args);
        }
        return $10ebbc9d5655d27e$var$noop;
    }
    constructor(){
        let { id: id } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            id: ""
        };
        (0, $lK3ac.default)(this, "id", void 0);
        (0, $lK3ac.default)(this, "VERSION", (0, $h6Pse.VERSION));
        (0, $lK3ac.default)(this, "_startTs", (0, $3odO6.getHiResTimestamp)());
        (0, $lK3ac.default)(this, "_deltaTs", (0, $3odO6.getHiResTimestamp)());
        (0, $lK3ac.default)(this, "_storage", void 0);
        (0, $lK3ac.default)(this, "userData", {});
        (0, $lK3ac.default)(this, "LOG_THROTTLE_TIMEOUT", 0);
        this.id = id;
        this.userData = {};
        this._storage = new (0, $ae2RA.LocalStorage)("__probe-".concat(this.id, "__"), $10ebbc9d5655d27e$var$DEFAULT_SETTINGS);
        this.timeStamp("".concat(this.id, " started"));
        (0, $1ezvW.autobind)(this);
        Object.seal(this);
    }
}
(0, $lK3ac.default)($10ebbc9d5655d27e$export$ce30dbb46644d06c, "VERSION", (0, $h6Pse.VERSION));
function $10ebbc9d5655d27e$var$normalizeLogLevel(logLevel) {
    if (!logLevel) return 0;
    let resolvedLevel;
    switch(typeof logLevel){
        case "number":
            resolvedLevel = logLevel;
            break;
        case "object":
            resolvedLevel = logLevel.logLevel || logLevel.priority || 0;
            break;
        default:
            return 0;
    }
    (0, $dkjRw.default)(Number.isFinite(resolvedLevel) && resolvedLevel >= 0);
    return resolvedLevel;
}
function $10ebbc9d5655d27e$export$abc60e668512edf9(opts) {
    const { logLevel: logLevel, message: message } = opts;
    opts.logLevel = $10ebbc9d5655d27e$var$normalizeLogLevel(logLevel);
    const args = opts.args ? Array.from(opts.args) : [];
    while(args.length && args.shift() !== message);
    switch(typeof logLevel){
        case "string":
        case "function":
            if (message !== undefined) args.unshift(message);
            opts.message = logLevel;
            break;
        case "object":
            Object.assign(opts, logLevel);
            break;
        default:
    }
    if (typeof opts.message === "function") opts.message = opts.message();
    const messageType = typeof opts.message;
    (0, $dkjRw.default)(messageType === "string" || messageType === "object");
    return Object.assign(opts, {
        args: args
    }, opts.opts);
}
function $10ebbc9d5655d27e$var$decorateMessage(id, message, opts) {
    if (typeof message === "string") {
        const time = opts.time ? (0, $6liXj.leftPad)((0, $6liXj.formatTime)(opts.total)) : "";
        message = opts.time ? "".concat(id, ": ").concat(time, "  ").concat(message) : "".concat(id, ": ").concat(message);
        message = (0, $abwsY.addColor)(message, opts.color, opts.background);
    }
    return message;
}
function $10ebbc9d5655d27e$var$logImageInNode(_ref2) {
    let { image: image, message: message = "", scale: scale = 1 } = _ref2;
    console.warn("removed");
    return $10ebbc9d5655d27e$var$noop;
}
function $10ebbc9d5655d27e$var$logImageInBrowser(_ref3) {
    let { image: image, message: message = "", scale: scale = 1 } = _ref3;
    if (typeof image === "string") {
        const img = new Image();
        img.onload = ()=>{
            const args = (0, $6liXj.formatImage)(img, message, scale);
            console.log(...args);
        };
        img.src = image;
        return $10ebbc9d5655d27e$var$noop;
    }
    const element = image.nodeName || "";
    if (element.toLowerCase() === "img") {
        console.log(...(0, $6liXj.formatImage)(image, message, scale));
        return $10ebbc9d5655d27e$var$noop;
    }
    if (element.toLowerCase() === "canvas") {
        const img = new Image();
        img.onload = ()=>console.log(...(0, $6liXj.formatImage)(img, message, scale));
        img.src = image.toDataURL();
        return $10ebbc9d5655d27e$var$noop;
    }
    return $10ebbc9d5655d27e$var$noop;
}
function $10ebbc9d5655d27e$var$getTableHeader(table) {
    for(const key in table){
        for(const title in table[key])return title || "untitled";
    }
    return "empty";
}

});
parcelRegister("lK3ac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd40590c59a4f438$export$2e2bcd8739ae039; });
function $fd40590c59a4f438$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("jeIEj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e011f5809f2010bb$export$2e2bcd8739ae039; });

var $1366E = parcelRequire("1366E");

var $95Bnk = parcelRequire("95Bnk");
function $e011f5809f2010bb$export$2e2bcd8739ae039() {
    const isNode = typeof $95Bnk === "object" && String($95Bnk) === "[object process]" && false;
    return !isNode || (0, $1366E.default)();
}
function $e011f5809f2010bb$export$fb09d24fafba666a() {
    return $e011f5809f2010bb$export$2e2bcd8739ae039() && typeof document !== "undefined";
}

});
parcelRegister("1366E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c3aced86bf66d7a$export$2e2bcd8739ae039; });

var $95Bnk = parcelRequire("95Bnk");
function $0c3aced86bf66d7a$export$2e2bcd8739ae039(mockUserAgent) {
    if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") return true;
    if (typeof $95Bnk !== "undefined" && typeof $95Bnk.versions === "object" && Boolean($95Bnk.versions["electron"])) return true;
    const realUserAgent = typeof navigator === "object" && typeof navigator.userAgent === "string" && navigator.userAgent;
    const userAgent = mockUserAgent || realUserAgent;
    if (userAgent && userAgent.indexOf("Electron") >= 0) return true;
    return false;
}

});


parcelRegister("h6Pse", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $c74ae8f327c164cf$export$a4ad2735b021c132; });

var $jeIEj = parcelRequire("jeIEj");

const $c74ae8f327c164cf$export$a4ad2735b021c132 = typeof __VERSION__ !== "undefined" ? __VERSION__ : "untranspiled source";
const $c74ae8f327c164cf$export$4e09c449d6c407f7 = (0, $jeIEj.default)();

});

parcelRegister("ae2RA", function(module, exports) {

$parcel$export(module.exports, "LocalStorage", function () { return $771d6ec6dabfad87$export$19fffca37ef3e106; });

var $lK3ac = parcelRequire("lK3ac");
function $771d6ec6dabfad87$var$getStorage(type) {
    try {
        const storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return storage;
    } catch (e) {
        return null;
    }
}
class $771d6ec6dabfad87$export$19fffca37ef3e106 {
    getConfiguration() {
        return this.config;
    }
    setConfiguration(configuration) {
        Object.assign(this.config, configuration);
        if (this.storage) {
            const serialized = JSON.stringify(this.config);
            this.storage.setItem(this.id, serialized);
        }
    }
    _loadConfiguration() {
        let configuration = {};
        if (this.storage) {
            const serializedConfiguration = this.storage.getItem(this.id);
            configuration = serializedConfiguration ? JSON.parse(serializedConfiguration) : {};
        }
        Object.assign(this.config, configuration);
        return this;
    }
    constructor(id, defaultConfig){
        let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "sessionStorage";
        (0, $lK3ac.default)(this, "storage", void 0);
        (0, $lK3ac.default)(this, "id", void 0);
        (0, $lK3ac.default)(this, "config", void 0);
        this.storage = $771d6ec6dabfad87$var$getStorage(type);
        this.id = id;
        this.config = defaultConfig;
        this._loadConfiguration();
    }
}

});

parcelRegister("6liXj", function(module, exports) {

$parcel$export(module.exports, "formatTime", function () { return $49e3686a0b35ef63$export$3203edd9e5edd663; });
$parcel$export(module.exports, "leftPad", function () { return $49e3686a0b35ef63$export$cbb503201166aab7; });
$parcel$export(module.exports, "formatImage", function () { return $49e3686a0b35ef63$export$9171d83acafa047c; });
function $49e3686a0b35ef63$export$3203edd9e5edd663(ms) {
    let formatted;
    if (ms < 10) formatted = "".concat(ms.toFixed(2), "ms");
    else if (ms < 100) formatted = "".concat(ms.toFixed(1), "ms");
    else if (ms < 1000) formatted = "".concat(ms.toFixed(0), "ms");
    else formatted = "".concat((ms / 1000).toFixed(2), "s");
    return formatted;
}
function $49e3686a0b35ef63$export$cbb503201166aab7(string) {
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    const padLength = Math.max(length - string.length, 0);
    return "".concat(" ".repeat(padLength)).concat(string);
}
function $49e3686a0b35ef63$export$390245bab32fb60f(string) {
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    const padLength = Math.max(length - string.length, 0);
    return "".concat(string).concat(" ".repeat(padLength));
}
function $49e3686a0b35ef63$export$7c4d25c0c3217d8c(v) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const EPSILON = 1e-16;
    const { isInteger: isInteger = false } = opts;
    if (Array.isArray(v) || ArrayBuffer.isView(v)) return $49e3686a0b35ef63$var$formatArrayValue(v, opts);
    if (!Number.isFinite(v)) return String(v);
    if (Math.abs(v) < EPSILON) return isInteger ? "0" : "0.";
    if (isInteger) return v.toFixed(0);
    if (Math.abs(v) > 100 && Math.abs(v) < 10000) return v.toFixed(0);
    const string = v.toPrecision(2);
    const decimal = string.indexOf(".0");
    return decimal === string.length - 2 ? string.slice(0, -1) : string;
}
function $49e3686a0b35ef63$var$formatArrayValue(v, opts) {
    const { maxElts: maxElts = 16, size: size = 1 } = opts;
    let string = "[";
    for(let i = 0; i < v.length && i < maxElts; ++i){
        if (i > 0) string += ",".concat(i % size === 0 ? " " : "");
        string += $49e3686a0b35ef63$export$7c4d25c0c3217d8c(v[i], opts);
    }
    const terminator = v.length > maxElts ? "..." : "]";
    return "".concat(string).concat(terminator);
}
function $49e3686a0b35ef63$export$9171d83acafa047c(image, message, scale) {
    let maxWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 600;
    const imageUrl = image.src.replace(/\(/g, "%28").replace(/\)/g, "%29");
    if (image.width > maxWidth) scale = Math.min(scale, maxWidth / image.width);
    const width = image.width * scale;
    const height = image.height * scale;
    const style = [
        "font-size:1px;",
        "padding:".concat(Math.floor(height / 2), "px ").concat(Math.floor(width / 2), "px;"),
        "line-height:".concat(height, "px;"),
        "background:url(".concat(imageUrl, ");"),
        "background-size:".concat(width, "px ").concat(height, "px;"),
        "color:transparent;"
    ].join("");
    return [
        "".concat(message, " %c+"),
        style
    ];
}

});

parcelRegister("abwsY", function(module, exports) {

$parcel$export(module.exports, "addColor", function () { return $76a41d98fb1b3c9a$export$4c4d9288a45f1fb3; });

var $jeIEj = parcelRequire("jeIEj");
let $76a41d98fb1b3c9a$export$9b982809044276a6;
(function(COLOR) {
    COLOR[COLOR["BLACK"] = 30] = "BLACK";
    COLOR[COLOR["RED"] = 31] = "RED";
    COLOR[COLOR["GREEN"] = 32] = "GREEN";
    COLOR[COLOR["YELLOW"] = 33] = "YELLOW";
    COLOR[COLOR["BLUE"] = 34] = "BLUE";
    COLOR[COLOR["MAGENTA"] = 35] = "MAGENTA";
    COLOR[COLOR["CYAN"] = 36] = "CYAN";
    COLOR[COLOR["WHITE"] = 37] = "WHITE";
    COLOR[COLOR["BRIGHT_BLACK"] = 90] = "BRIGHT_BLACK";
    COLOR[COLOR["BRIGHT_RED"] = 91] = "BRIGHT_RED";
    COLOR[COLOR["BRIGHT_GREEN"] = 92] = "BRIGHT_GREEN";
    COLOR[COLOR["BRIGHT_YELLOW"] = 93] = "BRIGHT_YELLOW";
    COLOR[COLOR["BRIGHT_BLUE"] = 94] = "BRIGHT_BLUE";
    COLOR[COLOR["BRIGHT_MAGENTA"] = 95] = "BRIGHT_MAGENTA";
    COLOR[COLOR["BRIGHT_CYAN"] = 96] = "BRIGHT_CYAN";
    COLOR[COLOR["BRIGHT_WHITE"] = 97] = "BRIGHT_WHITE";
})($76a41d98fb1b3c9a$export$9b982809044276a6 || ($76a41d98fb1b3c9a$export$9b982809044276a6 = {}));
function $76a41d98fb1b3c9a$var$getColor(color) {
    return typeof color === "string" ? $76a41d98fb1b3c9a$export$9b982809044276a6[color.toUpperCase()] || $76a41d98fb1b3c9a$export$9b982809044276a6.WHITE : color;
}
function $76a41d98fb1b3c9a$export$4c4d9288a45f1fb3(string, color, background) {
    if (!(0, $jeIEj.default) && typeof string === "string") {
        if (color) {
            color = $76a41d98fb1b3c9a$var$getColor(color);
            string = "\x1b[".concat(color, "m").concat(string, "\x1b[39m");
        }
        if (background) {
            color = $76a41d98fb1b3c9a$var$getColor(background);
            string = "\x1b[".concat(background + 10, "m").concat(string, "\x1b[49m");
        }
    }
    return string;
}

});

parcelRegister("1ezvW", function(module, exports) {

$parcel$export(module.exports, "autobind", function () { return $0e62a5a71b8b8104$export$f648f36420f83db; });
function $0e62a5a71b8b8104$export$f648f36420f83db(obj) {
    let predefined = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        "constructor"
    ];
    const proto = Object.getPrototypeOf(obj);
    const propNames = Object.getOwnPropertyNames(proto);
    for (const key of propNames){
        if (typeof obj[key] === "function") {
            if (!predefined.find((name)=>key === name)) obj[key] = obj[key].bind(obj);
        }
    }
}

});

parcelRegister("dkjRw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b3c8cd91ac21900$export$2e2bcd8739ae039; });
function $9b3c8cd91ac21900$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}

});

parcelRegister("3odO6", function(module, exports) {

$parcel$export(module.exports, "getHiResTimestamp", function () { return $277e52ceb50b7f2e$export$19cd34ab73b4c7a7; });

var $jeIEj = parcelRequire("jeIEj");
var $e6ekZ = parcelRequire("e6ekZ");
function $277e52ceb50b7f2e$export$19cd34ab73b4c7a7() {
    let timestamp;
    if ((0, $jeIEj.default) && "performance" in (0, $e6ekZ.window)) {
        var _window$performance, _window$performance$n;
        timestamp = (0, $e6ekZ.window) === null || (0, $e6ekZ.window) === void 0 ? void 0 : (_window$performance = (0, $e6ekZ.window).performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$n = _window$performance.now) === null || _window$performance$n === void 0 ? void 0 : _window$performance$n.call(_window$performance);
    } else if ("hrtime" in (0, $e6ekZ.process)) {
        var _process$hrtime;
        const timeParts = (0, $e6ekZ.process) === null || (0, $e6ekZ.process) === void 0 ? void 0 : (_process$hrtime = (0, $e6ekZ.process).hrtime) === null || _process$hrtime === void 0 ? void 0 : _process$hrtime.call((0, $e6ekZ.process));
        timestamp = timeParts[0] * 1000 + timeParts[1] / 1e6;
    } else timestamp = Date.now();
    return timestamp;
}

});
parcelRegister("e6ekZ", function(module, exports) {

$parcel$export(module.exports, "window", function () { return $a43cbf58b6e528bc$export$8291e5b88f90ce4; });
$parcel$export(module.exports, "process", function () { return $a43cbf58b6e528bc$export$e54fe5b0f43758f7; });

var $95Bnk = parcelRequire("95Bnk");
const $a43cbf58b6e528bc$var$globals = {
    self: typeof self !== "undefined" && self,
    window: typeof window !== "undefined" && window,
    global: typeof $parcel$global !== "undefined" && $parcel$global,
    document: typeof document !== "undefined" && document,
    process: typeof $95Bnk === "object" && $95Bnk
};
const $a43cbf58b6e528bc$export$90b4d2ff6acb88af = globalThis;
const $a43cbf58b6e528bc$export$82c2e460fb230c2a = $a43cbf58b6e528bc$var$globals.self || $a43cbf58b6e528bc$var$globals.window || $a43cbf58b6e528bc$var$globals.global;
const $a43cbf58b6e528bc$export$8291e5b88f90ce4 = $a43cbf58b6e528bc$var$globals.window || $a43cbf58b6e528bc$var$globals.self || $a43cbf58b6e528bc$var$globals.global;
const $a43cbf58b6e528bc$export$5a7bfc01df82fcd1 = $a43cbf58b6e528bc$var$globals.document || {};
const $a43cbf58b6e528bc$export$e54fe5b0f43758f7 = $a43cbf58b6e528bc$var$globals.process || {};
const $a43cbf58b6e528bc$export$e896d9a1b4631fa1 = console;

});






parcelRegister("ke18b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03ccbde779749d44$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $1zR3q = parcelRequire("1zR3q");

var $yVHST = parcelRequire("yVHST");

var $4VQgq = parcelRequire("4VQgq");

var $b9Qhn = parcelRequire("b9Qhn");

var $9kyEf = parcelRequire("9kyEf");

var $bwVEZ = parcelRequire("bwVEZ");

var $9FKfW = parcelRequire("9FKfW");
const $03ccbde779749d44$var$TRACE_INVALIDATE = "attributeManager.invalidate";
const $03ccbde779749d44$var$TRACE_UPDATE_START = "attributeManager.updateStart";
const $03ccbde779749d44$var$TRACE_UPDATE_END = "attributeManager.updateEnd";
const $03ccbde779749d44$var$TRACE_ATTRIBUTE_UPDATE_START = "attribute.updateStart";
const $03ccbde779749d44$var$TRACE_ATTRIBUTE_ALLOCATE = "attribute.allocate";
const $03ccbde779749d44$var$TRACE_ATTRIBUTE_UPDATE_END = "attribute.updateEnd";
class $03ccbde779749d44$export$2e2bcd8739ae039 {
    finalize() {
        for(const attributeName in this.attributes)this.attributes[attributeName].delete();
        this.attributeTransitionManager.finalize();
    }
    getNeedsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        const redraw = this.needsRedraw;
        this.needsRedraw = this.needsRedraw && !opts.clearRedrawFlags;
        return redraw && this.id;
    }
    setNeedsRedraw() {
        this.needsRedraw = true;
    }
    add(attributes) {
        this._add(attributes);
    }
    addInstanced(attributes) {
        this._add(attributes, {
            instanced: 1
        });
    }
    remove(attributeNameArray) {
        for (const name of attributeNameArray)if (this.attributes[name] !== undefined) {
            this.attributes[name].delete();
            delete this.attributes[name];
        }
    }
    invalidate(triggerName, dataRange) {
        const invalidatedAttributes = this._invalidateTrigger(triggerName, dataRange);
        (0, $bwVEZ.default)($03ccbde779749d44$var$TRACE_INVALIDATE, this, triggerName, invalidatedAttributes);
    }
    invalidateAll(dataRange) {
        for(const attributeName in this.attributes)this.attributes[attributeName].setNeedsUpdate(attributeName, dataRange);
        (0, $bwVEZ.default)($03ccbde779749d44$var$TRACE_INVALIDATE, this, "all");
    }
    update({ data: data, numInstances: numInstances, startIndices: startIndices = null, transitions: transitions, props: props = {}, buffers: buffers = {}, context: context = {} }) {
        let updated = false;
        (0, $bwVEZ.default)($03ccbde779749d44$var$TRACE_UPDATE_START, this);
        if (this.stats) this.stats.get("Update Attributes").timeStart();
        for(const attributeName in this.attributes){
            const attribute = this.attributes[attributeName];
            const accessorName = attribute.settings.accessor;
            attribute.startIndices = startIndices;
            attribute.numInstances = numInstances;
            if (props[attributeName]) (0, $4VQgq.default).removed("props.".concat(attributeName), "data.attributes.".concat(attributeName))();
            if (attribute.setExternalBuffer(buffers[attributeName])) ;
            else if (attribute.setBinaryValue(typeof accessorName === "string" ? buffers[accessorName] : undefined, data.startIndices)) ;
            else if (typeof accessorName === "string" && !buffers[accessorName] && attribute.setConstantValue(props[accessorName])) ;
            else if (attribute.needsUpdate()) {
                updated = true;
                this._updateAttribute({
                    attribute: attribute,
                    numInstances: numInstances,
                    data: data,
                    props: props,
                    context: context
                });
            }
            this.needsRedraw = this.needsRedraw || attribute.needsRedraw();
        }
        if (updated) (0, $bwVEZ.default)($03ccbde779749d44$var$TRACE_UPDATE_END, this, numInstances);
        if (this.stats) this.stats.get("Update Attributes").timeEnd();
        this.attributeTransitionManager.update({
            attributes: this.attributes,
            numInstances: numInstances,
            transitions: transitions
        });
    }
    updateTransition() {
        const { attributeTransitionManager: attributeTransitionManager } = this;
        const transitionUpdated = attributeTransitionManager.run();
        this.needsRedraw = this.needsRedraw || transitionUpdated;
        return transitionUpdated;
    }
    getAttributes() {
        return this.attributes;
    }
    getBounds(attributeNames) {
        const bounds = attributeNames.map((attributeName)=>{
            var _this$attributes$attr;
            return (_this$attributes$attr = this.attributes[attributeName]) === null || _this$attributes$attr === void 0 ? void 0 : _this$attributes$attr.getBounds();
        });
        return this.mergeBoundsMemoized(bounds);
    }
    getChangedAttributes(opts = {
        clearChangedFlags: false
    }) {
        const { attributes: attributes, attributeTransitionManager: attributeTransitionManager } = this;
        const changedAttributes = (0, $2QP2i._)({}, attributeTransitionManager.getAttributes());
        for(const attributeName in attributes){
            const attribute = attributes[attributeName];
            if (attribute.needsRedraw(opts) && !attributeTransitionManager.hasAttribute(attributeName)) changedAttributes[attributeName] = attribute;
        }
        return changedAttributes;
    }
    getShaderAttributes(attributes, excludeAttributes = {}) {
        if (!attributes) attributes = this.getAttributes();
        const shaderAttributes = {};
        for(const attributeName in attributes)if (!excludeAttributes[attributeName]) Object.assign(shaderAttributes, attributes[attributeName].getShaderAttributes());
        return shaderAttributes;
    }
    _add(attributes, extraProps = {}) {
        for(const attributeName in attributes){
            const attribute = attributes[attributeName];
            this.attributes[attributeName] = this._createAttribute(attributeName, attribute, extraProps);
        }
        this._mapUpdateTriggersToAttributes();
    }
    _createAttribute(name, attribute, extraProps) {
        const props = (0, $edHbI._)((0, $2QP2i._)({}, attribute), {
            id: name,
            size: attribute.isIndexed && 1 || attribute.size || 1,
            divisor: extraProps.instanced ? 1 : attribute.divisor || 0
        });
        return new (0, $yVHST.default)(this.gl, props);
    }
    _mapUpdateTriggersToAttributes() {
        const triggers = {};
        for(const attributeName in this.attributes){
            const attribute = this.attributes[attributeName];
            attribute.getUpdateTriggers().forEach((triggerName)=>{
                if (!triggers[triggerName]) triggers[triggerName] = [];
                triggers[triggerName].push(attributeName);
            });
        }
        this.updateTriggers = triggers;
    }
    _invalidateTrigger(triggerName, dataRange) {
        const { attributes: attributes, updateTriggers: updateTriggers } = this;
        const invalidatedAttributes = updateTriggers[triggerName];
        if (invalidatedAttributes) invalidatedAttributes.forEach((name)=>{
            const attribute = attributes[name];
            if (attribute) attribute.setNeedsUpdate(attribute.id, dataRange);
        });
        return invalidatedAttributes;
    }
    _updateAttribute(opts) {
        const { attribute: attribute, numInstances: numInstances } = opts;
        (0, $bwVEZ.default)($03ccbde779749d44$var$TRACE_ATTRIBUTE_UPDATE_START, attribute);
        if (attribute.constant) {
            attribute.setConstantValue(attribute.value);
            return;
        }
        if (attribute.allocate(numInstances)) (0, $bwVEZ.default)($03ccbde779749d44$var$TRACE_ATTRIBUTE_ALLOCATE, attribute, numInstances);
        const updated = attribute.updateBuffer(opts);
        if (updated) {
            this.needsRedraw = true;
            (0, $bwVEZ.default)($03ccbde779749d44$var$TRACE_ATTRIBUTE_UPDATE_END, attribute, numInstances);
        }
    }
    constructor(gl, { id: id = "attribute-manager", stats: stats, timeline: timeline } = {}){
        (0, $1zR3q.default)(this, "id", void 0);
        (0, $1zR3q.default)(this, "gl", void 0);
        (0, $1zR3q.default)(this, "attributes", void 0);
        (0, $1zR3q.default)(this, "updateTriggers", void 0);
        (0, $1zR3q.default)(this, "needsRedraw", void 0);
        (0, $1zR3q.default)(this, "userData", void 0);
        (0, $1zR3q.default)(this, "stats", void 0);
        (0, $1zR3q.default)(this, "attributeTransitionManager", void 0);
        (0, $1zR3q.default)(this, "mergeBoundsMemoized", (0, $b9Qhn.default)((0, $9kyEf.mergeBounds)));
        this.id = id;
        this.gl = gl;
        this.attributes = {};
        this.updateTriggers = {};
        this.needsRedraw = true;
        this.userData = {};
        this.stats = stats;
        this.attributeTransitionManager = new (0, $9FKfW.default)(gl, {
            id: "".concat(id, "-transitions"),
            timeline: timeline
        });
        Object.seal(this);
    }
}

});
parcelRegister("yVHST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $068ff0760839dd7d$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");

var $99Td9 = parcelRequire("99Td9");

var $hu5l6 = parcelRequire("hu5l6");

var $abpME = parcelRequire("abpME");

var $ivBeX = parcelRequire("ivBeX");

var $gZkNz = parcelRequire("gZkNz");

var $5YQrt = parcelRequire("5YQrt");
class $068ff0760839dd7d$export$2e2bcd8739ae039 extends (0, $99Td9.default) {
    get startIndices() {
        return this.state.startIndices;
    }
    set startIndices(layout) {
        this.state.startIndices = layout;
    }
    needsUpdate() {
        return this.state.needsUpdate;
    }
    needsRedraw({ clearChangedFlags: clearChangedFlags = false } = {}) {
        const needsRedraw = this.state.needsRedraw;
        this.state.needsRedraw = needsRedraw && !clearChangedFlags;
        return needsRedraw;
    }
    getUpdateTriggers() {
        const { accessor: accessor } = this.settings;
        return [
            this.id
        ].concat(typeof accessor !== "function" && accessor || []);
    }
    supportsTransition() {
        return Boolean(this.settings.transition);
    }
    getTransitionSetting(opts) {
        if (!opts || !this.supportsTransition()) return null;
        const { accessor: accessor } = this.settings;
        const layerSettings = this.settings.transition;
        const userSettings = Array.isArray(accessor) ? opts[accessor.find((a)=>opts[a])] : opts[accessor];
        return (0, $5YQrt.normalizeTransitionSettings)(userSettings, layerSettings);
    }
    setNeedsUpdate(reason = this.id, dataRange) {
        this.state.needsUpdate = this.state.needsUpdate || reason;
        this.setNeedsRedraw(reason);
        if (dataRange) {
            const { startRow: startRow = 0, endRow: endRow = Infinity } = dataRange;
            this.state.updateRanges = $gZkNz.add(this.state.updateRanges, [
                startRow,
                endRow
            ]);
        } else this.state.updateRanges = $gZkNz.FULL;
    }
    clearNeedsUpdate() {
        this.state.needsUpdate = false;
        this.state.updateRanges = $gZkNz.EMPTY;
    }
    setNeedsRedraw(reason = this.id) {
        this.state.needsRedraw = this.state.needsRedraw || reason;
    }
    allocate(numInstances) {
        const { state: state, settings: settings } = this;
        if (settings.noAlloc) return false;
        if (settings.update) {
            super.allocate(numInstances, state.updateRanges !== $gZkNz.FULL);
            return true;
        }
        return false;
    }
    updateBuffer({ numInstances: numInstances, data: data, props: props, context: context }) {
        if (!this.needsUpdate()) return false;
        const { state: { updateRanges: updateRanges }, settings: { update: update, noAlloc: noAlloc } } = this;
        let updated = true;
        if (update) {
            for (const [startRow, endRow] of updateRanges)update.call(context, this, {
                data: data,
                startRow: startRow,
                endRow: endRow,
                props: props,
                numInstances: numInstances
            });
            if (!this.value) ;
            else if (this.constant || this.buffer.byteLength < this.value.byteLength + this.byteOffset) {
                this.setData({
                    value: this.value,
                    constant: this.constant
                });
                this.constant = false;
            } else for (const [startRow, endRow] of updateRanges){
                const startOffset = Number.isFinite(startRow) ? this.getVertexOffset(startRow) : 0;
                const endOffset = Number.isFinite(endRow) ? this.getVertexOffset(endRow) : noAlloc || !Number.isFinite(numInstances) ? this.value.length : numInstances * this.size;
                super.updateSubBuffer({
                    startOffset: startOffset,
                    endOffset: endOffset
                });
            }
            this._checkAttributeArray();
        } else updated = false;
        this.clearNeedsUpdate();
        this.setNeedsRedraw();
        return updated;
    }
    setConstantValue(value) {
        if (value === undefined || typeof value === "function") return false;
        const hasChanged = this.setData({
            constant: true,
            value: value
        });
        if (hasChanged) this.setNeedsRedraw();
        this.clearNeedsUpdate();
        return true;
    }
    setExternalBuffer(buffer) {
        const { state: state } = this;
        if (!buffer) {
            state.lastExternalBuffer = null;
            return false;
        }
        this.clearNeedsUpdate();
        if (state.lastExternalBuffer === buffer) return true;
        state.lastExternalBuffer = buffer;
        this.setNeedsRedraw();
        this.setData(buffer);
        return true;
    }
    setBinaryValue(buffer, startIndices = null) {
        const { state: state, settings: settings } = this;
        if (!buffer) {
            state.binaryValue = null;
            state.binaryAccessor = null;
            return false;
        }
        if (settings.noAlloc) return false;
        if (state.binaryValue === buffer) {
            this.clearNeedsUpdate();
            return true;
        }
        state.binaryValue = buffer;
        this.setNeedsRedraw();
        const needsUpdate = settings.transform || startIndices !== this.startIndices;
        if (needsUpdate) {
            if (ArrayBuffer.isView(buffer)) buffer = {
                value: buffer
            };
            const binaryValue = buffer;
            (0, $hu5l6.default)(ArrayBuffer.isView(binaryValue.value), "invalid ".concat(settings.accessor));
            const needsNormalize = Boolean(binaryValue.size) && binaryValue.size !== this.size;
            state.binaryAccessor = (0, $abpME.getAccessorFromBuffer)(binaryValue.value, {
                size: binaryValue.size || this.size,
                stride: binaryValue.stride,
                offset: binaryValue.offset,
                startIndices: startIndices,
                nested: needsNormalize
            });
            return false;
        }
        this.clearNeedsUpdate();
        this.setData(buffer);
        return true;
    }
    getVertexOffset(row) {
        const { startIndices: startIndices } = this;
        const vertexIndex = startIndices ? row < startIndices.length ? startIndices[row] : this.numInstances : row;
        return vertexIndex * this.size;
    }
    getShaderAttributes() {
        const shaderAttributeDefs = this.settings.shaderAttributes || {
            [this.id]: null
        };
        const shaderAttributes = {};
        for(const shaderAttributeName in shaderAttributeDefs)Object.assign(shaderAttributes, super.getShaderAttributes(shaderAttributeName, shaderAttributeDefs[shaderAttributeName]));
        return shaderAttributes;
    }
    _autoUpdater(attribute, { data: data, startRow: startRow, endRow: endRow, props: props, numInstances: numInstances }) {
        if (attribute.constant) return;
        const { settings: settings, state: state, value: value, size: size, startIndices: startIndices } = attribute;
        const { accessor: accessor, transform: transform } = settings;
        const accessorFunc = state.binaryAccessor || (typeof accessor === "function" ? accessor : props[accessor]);
        (0, $hu5l6.default)(typeof accessorFunc === "function", 'accessor "'.concat(accessor, '" is not a function'));
        let i = attribute.getVertexOffset(startRow);
        const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(data, startRow, endRow);
        for (const object of iterable){
            objectInfo.index++;
            let objectValue = accessorFunc(object, objectInfo);
            if (transform) objectValue = transform.call(this, objectValue);
            if (startIndices) {
                const numVertices = (objectInfo.index < startIndices.length - 1 ? startIndices[objectInfo.index + 1] : numInstances) - startIndices[objectInfo.index];
                if (objectValue && Array.isArray(objectValue[0])) {
                    let startIndex = i;
                    for (const item of objectValue){
                        attribute._normalizeValue(item, value, startIndex);
                        startIndex += size;
                    }
                } else if (objectValue && objectValue.length > size) value.set(objectValue, i);
                else {
                    attribute._normalizeValue(objectValue, objectInfo.target, 0);
                    (0, $ivBeX.fillArray)({
                        target: value,
                        source: objectInfo.target,
                        start: i,
                        count: numVertices
                    });
                }
                i += numVertices * size;
            } else {
                attribute._normalizeValue(objectValue, value, i);
                i += size;
            }
        }
    }
    _validateAttributeUpdaters() {
        const { settings: settings } = this;
        const hasUpdater = settings.noAlloc || typeof settings.update === "function";
        if (!hasUpdater) throw new Error("Attribute ".concat(this.id, " missing update or accessor"));
    }
    _checkAttributeArray() {
        const { value: value } = this;
        const limit = Math.min(4, this.size);
        if (value && value.length >= limit) {
            let valid = true;
            switch(limit){
                case 4:
                    valid = valid && Number.isFinite(value[3]);
                case 3:
                    valid = valid && Number.isFinite(value[2]);
                case 2:
                    valid = valid && Number.isFinite(value[1]);
                case 1:
                    valid = valid && Number.isFinite(value[0]);
                    break;
                default:
                    valid = false;
            }
            if (!valid) throw new Error("Illegal attribute generated for ".concat(this.id));
        }
    }
    constructor(gl, opts){
        super(gl, opts, {
            startIndices: null,
            lastExternalBuffer: null,
            binaryValue: null,
            binaryAccessor: null,
            needsUpdate: true,
            needsRedraw: false,
            updateRanges: $gZkNz.FULL
        });
        (0, $1zR3q.default)(this, "constant", false);
        this.settings.update = opts.update || (opts.accessor ? this._autoUpdater : undefined);
        Object.seal(this.settings);
        Object.seal(this.state);
        this._validateAttributeUpdaters();
    }
}

});
parcelRegister("99Td9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6aafc81bfcdbd539$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $1zR3q = parcelRequire("1zR3q");

var $7jraD = parcelRequire("7jraD");
var $68aPy = parcelRequire("68aPy");
var $tIWfJ = parcelRequire("tIWfJ");

var $jL2pF = parcelRequire("jL2pF");

var $24b9z = parcelRequire("24b9z");

var $an4RE = parcelRequire("an4RE");

var $9kyEf = parcelRequire("9kyEf");

var $4VQgq = parcelRequire("4VQgq");
function $6aafc81bfcdbd539$var$getStride(accessor) {
    return accessor.stride || accessor.size * accessor.bytesPerElement;
}
function $6aafc81bfcdbd539$var$resolveShaderAttribute(baseAccessor, shaderAttributeOptions) {
    if (shaderAttributeOptions.offset) (0, $4VQgq.default).removed("shaderAttribute.offset", "vertexOffset, elementOffset")();
    const stride = $6aafc81bfcdbd539$var$getStride(baseAccessor);
    const vertexOffset = shaderAttributeOptions.vertexOffset !== undefined ? shaderAttributeOptions.vertexOffset : baseAccessor.vertexOffset || 0;
    const elementOffset = shaderAttributeOptions.elementOffset || 0;
    const offset = vertexOffset * stride + elementOffset * baseAccessor.bytesPerElement + (baseAccessor.offset || 0);
    return (0, $edHbI._)((0, $2QP2i._)({}, shaderAttributeOptions), {
        offset: offset,
        stride: stride
    });
}
function $6aafc81bfcdbd539$var$resolveDoublePrecisionShaderAttributes(baseAccessor, shaderAttributeOptions) {
    const resolvedOptions = $6aafc81bfcdbd539$var$resolveShaderAttribute(baseAccessor, shaderAttributeOptions);
    return {
        high: resolvedOptions,
        low: (0, $edHbI._)((0, $2QP2i._)({}, resolvedOptions), {
            offset: resolvedOptions.offset + baseAccessor.size * 4
        })
    };
}
class $6aafc81bfcdbd539$export$2e2bcd8739ae039 {
    get isConstant() {
        return this.state.constant;
    }
    get buffer() {
        if (!this._buffer) {
            const { isIndexed: isIndexed, type: type } = this.settings;
            this._buffer = new (0, $7jraD.default)(this.gl, {
                id: this.id,
                target: isIndexed ? 34963 : 34962,
                accessor: {
                    type: type
                }
            });
        }
        return this._buffer;
    }
    get byteOffset() {
        const accessor = this.getAccessor();
        if (accessor.vertexOffset) return accessor.vertexOffset * $6aafc81bfcdbd539$var$getStride(accessor);
        return 0;
    }
    get numInstances() {
        return this.state.numInstances;
    }
    set numInstances(n) {
        this.state.numInstances = n;
    }
    delete() {
        if (this._buffer) {
            this._buffer.delete();
            this._buffer = null;
        }
        (0, $an4RE.default).release(this.state.allocatedValue);
    }
    getShaderAttributes(id, options) {
        if (this.doublePrecision) {
            const shaderAttributes = {};
            const isBuffer64Bit = this.value instanceof Float64Array;
            const doubleShaderAttributeDefs = $6aafc81bfcdbd539$var$resolveDoublePrecisionShaderAttributes(this.getAccessor(), options || {});
            shaderAttributes[id] = new (0, $jL2pF.default)(this, doubleShaderAttributeDefs.high);
            shaderAttributes["".concat(id, "64Low")] = isBuffer64Bit ? new (0, $jL2pF.default)(this, doubleShaderAttributeDefs.low) : new Float32Array(this.size);
            return shaderAttributes;
        }
        if (options) {
            const shaderAttributeDef = $6aafc81bfcdbd539$var$resolveShaderAttribute(this.getAccessor(), options);
            return {
                [id]: new (0, $jL2pF.default)(this, shaderAttributeDef)
            };
        }
        return {
            [id]: this
        };
    }
    getBuffer() {
        if (this.state.constant) return null;
        return this.state.externalBuffer || this._buffer;
    }
    getValue() {
        if (this.state.constant) return this.value;
        return [
            this.getBuffer(),
            this.getAccessor()
        ];
    }
    getAccessor() {
        return this.state.bufferAccessor;
    }
    getBounds() {
        if (this.state.bounds) return this.state.bounds;
        let result = null;
        if (this.state.constant && this.value) {
            const min = Array.from(this.value);
            result = [
                min,
                min
            ];
        } else {
            const { value: value, numInstances: numInstances, size: size } = this;
            const len = numInstances * size;
            if (value && len && value.length >= len) {
                const min = new Array(size).fill(Infinity);
                const max = new Array(size).fill(-Infinity);
                for(let i = 0; i < len;)for(let j = 0; j < size; j++){
                    const v = value[i++];
                    if (v < min[j]) min[j] = v;
                    if (v > max[j]) max[j] = v;
                }
                result = [
                    min,
                    max
                ];
            }
        }
        this.state.bounds = result;
        return result;
    }
    setData(data) {
        const { state: state } = this;
        let opts;
        if (ArrayBuffer.isView(data)) opts = {
            value: data
        };
        else if (data instanceof (0, $7jraD.default)) opts = {
            buffer: data
        };
        else opts = data;
        const accessor = (0, $2QP2i._)({}, this.settings, opts);
        state.bufferAccessor = accessor;
        state.bounds = null;
        if (opts.constant) {
            let value = opts.value;
            value = this._normalizeValue(value, [], 0);
            if (this.settings.normalized) value = this.normalizeConstant(value);
            const hasChanged = !state.constant || !this._areValuesEqual(value, this.value);
            if (!hasChanged) return false;
            state.externalBuffer = null;
            state.constant = true;
            this.value = value;
        } else if (opts.buffer) {
            const buffer = opts.buffer;
            state.externalBuffer = buffer;
            state.constant = false;
            this.value = opts.value || null;
            const isBuffer64Bit = opts.value instanceof Float64Array;
            accessor.type = opts.type || buffer.accessor.type;
            accessor.bytesPerElement = buffer.accessor.BYTES_PER_ELEMENT * (isBuffer64Bit ? 2 : 1);
            accessor.stride = $6aafc81bfcdbd539$var$getStride(accessor);
        } else if (opts.value) {
            this._checkExternalBuffer(opts);
            let value = opts.value;
            state.externalBuffer = null;
            state.constant = false;
            this.value = value;
            accessor.bytesPerElement = value.BYTES_PER_ELEMENT;
            accessor.stride = $6aafc81bfcdbd539$var$getStride(accessor);
            const { buffer: buffer, byteOffset: byteOffset } = this;
            if (this.doublePrecision && value instanceof Float64Array) value = (0, $9kyEf.toDoublePrecisionArray)(value, accessor);
            const requiredBufferSize = value.byteLength + byteOffset + accessor.stride * 2;
            if (buffer.byteLength < requiredBufferSize) buffer.reallocate(requiredBufferSize);
            buffer.setAccessor(null);
            buffer.subData({
                data: value,
                offset: byteOffset
            });
            accessor.type = opts.type || buffer.accessor.type;
        }
        return true;
    }
    updateSubBuffer(opts = {}) {
        this.state.bounds = null;
        const value = this.value;
        const { startOffset: startOffset = 0, endOffset: endOffset } = opts;
        this.buffer.subData({
            data: this.doublePrecision && value instanceof Float64Array ? (0, $9kyEf.toDoublePrecisionArray)(value, {
                size: this.size,
                startIndex: startOffset,
                endIndex: endOffset
            }) : value.subarray(startOffset, endOffset),
            offset: startOffset * value.BYTES_PER_ELEMENT + this.byteOffset
        });
    }
    allocate(numInstances, copy = false) {
        const { state: state } = this;
        const oldValue = state.allocatedValue;
        const value = (0, $an4RE.default).allocate(oldValue, numInstances + 1, {
            size: this.size,
            type: this.settings.defaultType,
            copy: copy
        });
        this.value = value;
        const { buffer: buffer, byteOffset: byteOffset } = this;
        if (buffer.byteLength < value.byteLength + byteOffset) {
            buffer.reallocate(value.byteLength + byteOffset);
            if (copy && oldValue) buffer.subData({
                data: oldValue instanceof Float64Array ? (0, $9kyEf.toDoublePrecisionArray)(oldValue, this) : oldValue,
                offset: byteOffset
            });
        }
        state.allocatedValue = value;
        state.constant = false;
        state.externalBuffer = null;
        state.bufferAccessor = this.settings;
        return true;
    }
    _checkExternalBuffer(opts) {
        const { value: value } = opts;
        if (!ArrayBuffer.isView(value)) throw new Error("Attribute ".concat(this.id, " value is not TypedArray"));
        const ArrayType = this.settings.defaultType;
        let illegalArrayType = false;
        if (this.doublePrecision) illegalArrayType = value.BYTES_PER_ELEMENT < 4;
        if (illegalArrayType) throw new Error("Attribute ".concat(this.id, " does not support ").concat(value.constructor.name));
        if (!(value instanceof ArrayType) && this.settings.normalized && !("normalized" in opts)) (0, $4VQgq.default).warn("Attribute ".concat(this.id, " is normalized"))();
    }
    normalizeConstant(value) {
        switch(this.settings.type){
            case 5120:
                return new Float32Array(value).map((x)=>(x + 128) / 255 * 2 - 1);
            case 5122:
                return new Float32Array(value).map((x)=>(x + 32768) / 65535 * 2 - 1);
            case 5121:
                return new Float32Array(value).map((x)=>x / 255);
            case 5123:
                return new Float32Array(value).map((x)=>x / 65535);
            default:
                return value;
        }
    }
    _normalizeValue(value, out, start) {
        const { defaultValue: defaultValue, size: size } = this.settings;
        if (Number.isFinite(value)) {
            out[start] = value;
            return out;
        }
        if (!value) {
            let i = size;
            while(--i >= 0)out[start + i] = defaultValue[i];
            return out;
        }
        switch(size){
            case 4:
                out[start + 3] = Number.isFinite(value[3]) ? value[3] : defaultValue[3];
            case 3:
                out[start + 2] = Number.isFinite(value[2]) ? value[2] : defaultValue[2];
            case 2:
                out[start + 1] = Number.isFinite(value[1]) ? value[1] : defaultValue[1];
            case 1:
                out[start + 0] = Number.isFinite(value[0]) ? value[0] : defaultValue[0];
                break;
            default:
                let i = size;
                while(--i >= 0)out[start + i] = Number.isFinite(value[i]) ? value[i] : defaultValue[i];
        }
        return out;
    }
    _areValuesEqual(value1, value2) {
        if (!value1 || !value2) return false;
        const { size: size } = this;
        for(let i = 0; i < size; i++){
            if (value1[i] !== value2[i]) return false;
        }
        return true;
    }
    constructor(gl, opts, state){
        (0, $1zR3q.default)(this, "gl", void 0);
        (0, $1zR3q.default)(this, "id", void 0);
        (0, $1zR3q.default)(this, "size", void 0);
        (0, $1zR3q.default)(this, "settings", void 0);
        (0, $1zR3q.default)(this, "value", void 0);
        (0, $1zR3q.default)(this, "doublePrecision", void 0);
        (0, $1zR3q.default)(this, "_buffer", void 0);
        (0, $1zR3q.default)(this, "state", void 0);
        this.gl = gl;
        this.id = opts.id || "";
        this.size = opts.size || 1;
        const logicalType = opts.logicalType || opts.type;
        const doublePrecision = logicalType === 5130;
        let { defaultValue: defaultValue } = opts;
        defaultValue = Number.isFinite(defaultValue) ? [
            defaultValue
        ] : defaultValue || new Array(this.size).fill(0);
        let bufferType;
        if (doublePrecision) bufferType = 5126;
        else if (!logicalType && opts.isIndexed) bufferType = gl && (0, $tIWfJ.hasFeature)(gl, (0, $68aPy.FEATURES).ELEMENT_INDEX_UINT32) ? 5125 : 5123;
        else bufferType = logicalType || 5126;
        let defaultType = (0, $24b9z.glArrayFromType)(logicalType || bufferType || 5126);
        this.doublePrecision = doublePrecision;
        if (doublePrecision && opts.fp64 === false) defaultType = Float32Array;
        this.value = null;
        this.settings = (0, $edHbI._)((0, $2QP2i._)({}, opts), {
            defaultType: defaultType,
            defaultValue: defaultValue,
            logicalType: logicalType,
            type: bufferType,
            size: this.size,
            bytesPerElement: defaultType.BYTES_PER_ELEMENT
        });
        this.state = (0, $edHbI._)((0, $2QP2i._)({}, state), {
            externalBuffer: null,
            bufferAccessor: this.settings,
            allocatedValue: null,
            numInstances: 0,
            bounds: null,
            constant: false
        });
        this._buffer = null;
    }
}

});
parcelRegister("7jraD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $552f6243e13f2fd9$export$2e2bcd8739ae039; });

var $1OVow = parcelRequire("1OVow");

var $35tVQ = parcelRequire("35tVQ");

var $3qgcG = parcelRequire("3qgcG");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");

var $ihfnu = parcelRequire("ihfnu");

var $JOkCq = parcelRequire("JOkCq");
const $552f6243e13f2fd9$var$DEBUG_DATA_LENGTH = 10;
const $552f6243e13f2fd9$var$DEPRECATED_PROPS = {
    offset: "accessor.offset",
    stride: "accessor.stride",
    type: "accessor.type",
    size: "accessor.size",
    divisor: "accessor.divisor",
    normalized: "accessor.normalized",
    integer: "accessor.integer",
    instanced: "accessor.divisor",
    isInstanced: "accessor.divisor"
};
const $552f6243e13f2fd9$var$PROP_CHECKS_INITIALIZE = {
    removedProps: {},
    replacedProps: {
        bytes: "byteLength"
    },
    deprecatedProps: $552f6243e13f2fd9$var$DEPRECATED_PROPS
};
const $552f6243e13f2fd9$var$PROP_CHECKS_SET_PROPS = {
    removedProps: $552f6243e13f2fd9$var$DEPRECATED_PROPS
};
class $552f6243e13f2fd9$export$2e2bcd8739ae039 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "Buffer";
    }
    getElementCount() {
        let accessor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.accessor;
        return Math.round(this.byteLength / (0, $35tVQ.default).getBytesPerElement(accessor));
    }
    getVertexCount() {
        let accessor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.accessor;
        return Math.round(this.byteLength / (0, $35tVQ.default).getBytesPerVertex(accessor));
    }
    initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (ArrayBuffer.isView(props)) props = {
            data: props
        };
        if (Number.isFinite(props)) props = {
            byteLength: props
        };
        props = (0, $JOkCq.checkProps)("Buffer", props, $552f6243e13f2fd9$var$PROP_CHECKS_INITIALIZE);
        this.usage = props.usage || 35044;
        this.debugData = null;
        this.setAccessor(Object.assign({}, props, props.accessor));
        if (props.data) this._setData(props.data, props.offset, props.byteLength);
        else this._setByteLength(props.byteLength || 0);
        return this;
    }
    setProps(props) {
        props = (0, $JOkCq.checkProps)("Buffer", props, $552f6243e13f2fd9$var$PROP_CHECKS_SET_PROPS);
        if ("accessor" in props) this.setAccessor(props.accessor);
        return this;
    }
    setAccessor(accessor) {
        accessor = Object.assign({}, accessor);
        delete accessor.buffer;
        this.accessor = new (0, $35tVQ.default)(accessor);
        return this;
    }
    reallocate(byteLength) {
        if (byteLength > this.byteLength) {
            this._setByteLength(byteLength);
            return true;
        }
        this.bytesUsed = byteLength;
        return false;
    }
    setData(props) {
        return this.initialize(props);
    }
    subData(props) {
        if (ArrayBuffer.isView(props)) props = {
            data: props
        };
        const { data: data, offset: offset = 0, srcOffset: srcOffset = 0 } = props;
        const byteLength = props.byteLength || props.length;
        (0, $ihfnu.assert)(data);
        const target = this.gl.webgl2 ? 36663 : this.target;
        this.gl.bindBuffer(target, this.handle);
        if (srcOffset !== 0 || byteLength !== undefined) {
            (0, $8HKWo.assertWebGL2Context)(this.gl);
            this.gl.bufferSubData(this.target, offset, data, srcOffset, byteLength);
        } else this.gl.bufferSubData(target, offset, data);
        this.gl.bindBuffer(target, null);
        this.debugData = null;
        this._inferType(data);
        return this;
    }
    copyData(_ref) {
        let { sourceBuffer: sourceBuffer, readOffset: readOffset = 0, writeOffset: writeOffset = 0, size: size } = _ref;
        const { gl: gl } = this;
        (0, $8HKWo.assertWebGL2Context)(gl);
        gl.bindBuffer(36662, sourceBuffer.handle);
        gl.bindBuffer(36663, this.handle);
        gl.copyBufferSubData(36662, 36663, readOffset, writeOffset, size);
        gl.bindBuffer(36662, null);
        gl.bindBuffer(36663, null);
        this.debugData = null;
        return this;
    }
    getData() {
        let { dstData: dstData = null, srcByteOffset: srcByteOffset = 0, dstOffset: dstOffset = 0, length: length = 0 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $8HKWo.assertWebGL2Context)(this.gl);
        const ArrayType = (0, $3qgcG.getTypedArrayFromGLType)(this.accessor.type || 5126, {
            clamped: false
        });
        const sourceAvailableElementCount = this._getAvailableElementCount(srcByteOffset);
        const dstElementOffset = dstOffset;
        let dstAvailableElementCount;
        let dstElementCount;
        if (dstData) {
            dstElementCount = dstData.length;
            dstAvailableElementCount = dstElementCount - dstElementOffset;
        } else {
            dstAvailableElementCount = Math.min(sourceAvailableElementCount, length || sourceAvailableElementCount);
            dstElementCount = dstElementOffset + dstAvailableElementCount;
        }
        const copyElementCount = Math.min(sourceAvailableElementCount, dstAvailableElementCount);
        length = length || copyElementCount;
        (0, $ihfnu.assert)(length <= copyElementCount);
        dstData = dstData || new ArrayType(dstElementCount);
        this.gl.bindBuffer(36662, this.handle);
        this.gl.getBufferSubData(36662, srcByteOffset, dstData, dstOffset, length);
        this.gl.bindBuffer(36662, null);
        return dstData;
    }
    bind() {
        let { target: target = this.target, index: index = this.accessor && this.accessor.index, offset: offset = 0, size: size } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (target === 35345 || target === 35982) {
            if (size !== undefined) this.gl.bindBufferRange(target, index, this.handle, offset, size);
            else {
                (0, $ihfnu.assert)(offset === 0);
                this.gl.bindBufferBase(target, index, this.handle);
            }
        } else this.gl.bindBuffer(target, this.handle);
        return this;
    }
    unbind() {
        let { target: target = this.target, index: index = this.accessor && this.accessor.index } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const isIndexedBuffer = target === 35345 || target === 35982;
        if (isIndexedBuffer) this.gl.bindBufferBase(target, index, null);
        else this.gl.bindBuffer(target, null);
        return this;
    }
    getDebugData() {
        if (!this.debugData) {
            this.debugData = this.getData({
                length: Math.min($552f6243e13f2fd9$var$DEBUG_DATA_LENGTH, this.byteLength)
            });
            return {
                data: this.debugData,
                changed: true
            };
        }
        return {
            data: this.debugData,
            changed: false
        };
    }
    invalidateDebugData() {
        this.debugData = null;
    }
    _setData(data) {
        let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let byteLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : data.byteLength + offset;
        (0, $ihfnu.assert)(ArrayBuffer.isView(data));
        this._trackDeallocatedMemory();
        const target = this._getTarget();
        this.gl.bindBuffer(target, this.handle);
        this.gl.bufferData(target, byteLength, this.usage);
        this.gl.bufferSubData(target, offset, data);
        this.gl.bindBuffer(target, null);
        this.debugData = data.slice(0, $552f6243e13f2fd9$var$DEBUG_DATA_LENGTH);
        this.bytesUsed = byteLength;
        this._trackAllocatedMemory(byteLength);
        const type = (0, $3qgcG.getGLTypeFromTypedArray)(data);
        (0, $ihfnu.assert)(type);
        this.setAccessor(new (0, $35tVQ.default)(this.accessor, {
            type: type
        }));
        return this;
    }
    _setByteLength(byteLength) {
        let usage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.usage;
        (0, $ihfnu.assert)(byteLength >= 0);
        this._trackDeallocatedMemory();
        let data = byteLength;
        if (byteLength === 0) data = new Float32Array(0);
        const target = this._getTarget();
        this.gl.bindBuffer(target, this.handle);
        this.gl.bufferData(target, data, usage);
        this.gl.bindBuffer(target, null);
        this.usage = usage;
        this.debugData = null;
        this.bytesUsed = byteLength;
        this._trackAllocatedMemory(byteLength);
        return this;
    }
    _getTarget() {
        return this.gl.webgl2 ? 36663 : this.target;
    }
    _getAvailableElementCount(srcByteOffset) {
        const ArrayType = (0, $3qgcG.getTypedArrayFromGLType)(this.accessor.type || 5126, {
            clamped: false
        });
        const sourceElementOffset = srcByteOffset / ArrayType.BYTES_PER_ELEMENT;
        return this.getElementCount() - sourceElementOffset;
    }
    _inferType(data) {
        if (!this.accessor.type) this.setAccessor(new (0, $35tVQ.default)(this.accessor, {
            type: (0, $3qgcG.getGLTypeFromTypedArray)(data)
        }));
    }
    _createHandle() {
        return this.gl.createBuffer();
    }
    _deleteHandle() {
        this.gl.deleteBuffer(this.handle);
        this._trackDeallocatedMemory();
    }
    _getParameter(pname) {
        this.gl.bindBuffer(this.target, this.handle);
        const value = this.gl.getBufferParameter(this.target, pname);
        this.gl.bindBuffer(this.target, null);
        return value;
    }
    get type() {
        (0, $lvicK.log).deprecated("Buffer.type", "Buffer.accessor.type")();
        return this.accessor.type;
    }
    get bytes() {
        (0, $lvicK.log).deprecated("Buffer.bytes", "Buffer.byteLength")();
        return this.byteLength;
    }
    setByteLength(byteLength) {
        (0, $lvicK.log).deprecated("setByteLength", "reallocate")();
        return this.reallocate(byteLength);
    }
    updateAccessor(opts) {
        (0, $lvicK.log).deprecated("updateAccessor(...)", "setAccessor(new Accessor(buffer.accessor, ...)")();
        this.accessor = new (0, $35tVQ.default)(this.accessor, opts);
        return this;
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(gl, props);
        this.stubRemovedMethods("Buffer", "v6.0", [
            "layout",
            "setLayout",
            "getIndexedParameter"
        ]);
        this.target = props.target || (this.gl.webgl2 ? 36662 : 34962);
        this.initialize(props);
        Object.seal(this);
    }
}

});
parcelRegister("1OVow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1536fb5501fdc12f$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $jgMzF = parcelRequire("jgMzF");

var $5tEaG = parcelRequire("5tEaG");

var $ihfnu = parcelRequire("ihfnu");

var $iljOc = parcelRequire("iljOc");

var $z6hiF = parcelRequire("z6hiF");
const $1536fb5501fdc12f$var$ERR_RESOURCE_METHOD_UNDEFINED = "Resource subclass must define virtual methods";
class $1536fb5501fdc12f$export$2e2bcd8739ae039 {
    get [Symbol.toStringTag]() {
        return "Resource";
    }
    toString() {
        return "".concat(this[Symbol.toStringTag] || this.constructor.name, "(").concat(this.id, ")");
    }
    get handle() {
        return this._handle;
    }
    delete() {
        let { deleteChildren: deleteChildren = false } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const children = this._handle && this._deleteHandle(this._handle);
        if (this._handle) this._removeStats();
        this._handle = null;
        if (children && deleteChildren) children.filter(Boolean).forEach((child)=>child.delete());
        return this;
    }
    bind() {
        let funcOrHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.handle;
        if (typeof funcOrHandle !== "function") {
            this._bindHandle(funcOrHandle);
            return this;
        }
        let value;
        if (!this._bound) {
            this._bindHandle(this.handle);
            this._bound = true;
            value = funcOrHandle();
            this._bound = false;
            this._bindHandle(null);
        } else value = funcOrHandle();
        return value;
    }
    unbind() {
        this.bind(null);
    }
    getParameter(pname) {
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        pname = (0, $5tEaG.getKeyValue)(this.gl, pname);
        (0, $ihfnu.assert)(pname);
        const parameters = this.constructor.PARAMETERS || {};
        const parameter = parameters[pname];
        if (parameter) {
            const isWebgl2 = (0, $8HKWo.isWebGL2)(this.gl);
            const parameterAvailable = (!("webgl2" in parameter) || isWebgl2) && (!("extension" in parameter) || this.gl.getExtension(parameter.extension));
            if (!parameterAvailable) {
                const webgl1Default = parameter.webgl1;
                const webgl2Default = "webgl2" in parameter ? parameter.webgl2 : parameter.webgl1;
                const defaultValue = isWebgl2 ? webgl2Default : webgl1Default;
                return defaultValue;
            }
        }
        return this._getParameter(pname, opts);
    }
    getParameters() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { parameters: parameters, keys: keys } = options;
        const PARAMETERS = this.constructor.PARAMETERS || {};
        const isWebgl2 = (0, $8HKWo.isWebGL2)(this.gl);
        const values = {};
        const parameterKeys = parameters || Object.keys(PARAMETERS);
        for (const pname of parameterKeys){
            const parameter = PARAMETERS[pname];
            const parameterAvailable = parameter && (!("webgl2" in parameter) || isWebgl2) && (!("extension" in parameter) || this.gl.getExtension(parameter.extension));
            if (parameterAvailable) {
                const key = keys ? (0, $5tEaG.getKey)(this.gl, pname) : pname;
                values[key] = this.getParameter(pname, options);
                if (keys && parameter.type === "GLenum") values[key] = (0, $5tEaG.getKey)(this.gl, values[key]);
            }
        }
        return values;
    }
    setParameter(pname, value) {
        pname = (0, $5tEaG.getKeyValue)(this.gl, pname);
        (0, $ihfnu.assert)(pname);
        const parameters = this.constructor.PARAMETERS || {};
        const parameter = parameters[pname];
        if (parameter) {
            const isWebgl2 = (0, $8HKWo.isWebGL2)(this.gl);
            const parameterAvailable = (!("webgl2" in parameter) || isWebgl2) && (!("extension" in parameter) || this.gl.getExtension(parameter.extension));
            if (!parameterAvailable) throw new Error("Parameter not available on this platform");
            if (parameter.type === "GLenum") value = (0, $5tEaG.getKeyValue)(value);
        }
        this._setParameter(pname, value);
        return this;
    }
    setParameters(parameters) {
        for(const pname in parameters)this.setParameter(pname, parameters[pname]);
        return this;
    }
    stubRemovedMethods(className, version, methodNames) {
        return (0, $z6hiF.stubRemovedMethods)(this, className, version, methodNames);
    }
    initialize(opts) {}
    _createHandle() {
        throw new Error($1536fb5501fdc12f$var$ERR_RESOURCE_METHOD_UNDEFINED);
    }
    _deleteHandle() {
        throw new Error($1536fb5501fdc12f$var$ERR_RESOURCE_METHOD_UNDEFINED);
    }
    _bindHandle(handle) {
        throw new Error($1536fb5501fdc12f$var$ERR_RESOURCE_METHOD_UNDEFINED);
    }
    _getOptsFromHandle() {
        throw new Error($1536fb5501fdc12f$var$ERR_RESOURCE_METHOD_UNDEFINED);
    }
    _getParameter(pname, opts) {
        throw new Error($1536fb5501fdc12f$var$ERR_RESOURCE_METHOD_UNDEFINED);
    }
    _setParameter(pname, value) {
        throw new Error($1536fb5501fdc12f$var$ERR_RESOURCE_METHOD_UNDEFINED);
    }
    _context() {
        this.gl.luma = this.gl.luma || {};
        return this.gl.luma;
    }
    _addStats() {
        const name = this[Symbol.toStringTag];
        const stats = (0, $jgMzF.lumaStats).get("Resource Counts");
        stats.get("Resources Created").incrementCount();
        stats.get("".concat(name, "s Created")).incrementCount();
        stats.get("".concat(name, "s Active")).incrementCount();
    }
    _removeStats() {
        const name = this[Symbol.toStringTag];
        const stats = (0, $jgMzF.lumaStats).get("Resource Counts");
        stats.get("".concat(name, "s Active")).decrementCount();
    }
    _trackAllocatedMemory(bytes) {
        let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this[Symbol.toStringTag];
        this._trackAllocatedMemoryForContext(bytes, name);
        this._trackAllocatedMemoryForContext(bytes, name, this.gl.canvas && this.gl.canvas.id);
        this.byteLength = bytes;
    }
    _trackAllocatedMemoryForContext(bytes) {
        let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this[Symbol.toStringTag];
        let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
        const stats = (0, $jgMzF.lumaStats).get("Memory Usage".concat(id));
        stats.get("GPU Memory").addCount(bytes);
        stats.get("".concat(name, " Memory")).addCount(bytes);
    }
    _trackDeallocatedMemory() {
        let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this[Symbol.toStringTag];
        this._trackDeallocatedMemoryForContext(name);
        this._trackDeallocatedMemoryForContext(name, this.gl.canvas && this.gl.canvas.id);
        this.byteLength = 0;
    }
    _trackDeallocatedMemoryForContext() {
        let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this[Symbol.toStringTag];
        let id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const stats = (0, $jgMzF.lumaStats).get("Memory Usage".concat(id));
        stats.get("GPU Memory").subtractCount(this.byteLength);
        stats.get("".concat(name, " Memory")).subtractCount(this.byteLength);
    }
    constructor(gl){
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $8HKWo.assertWebGLContext)(gl);
        const { id: id, userData: userData = {} } = opts;
        this.gl = gl;
        this.gl2 = gl;
        this.id = id || (0, $iljOc.uid)(this[Symbol.toStringTag]);
        this.userData = userData;
        this._bound = false;
        this._handle = opts.handle;
        if (this._handle === undefined) this._handle = this._createHandle();
        this.byteLength = 0;
        this._addStats();
    }
}

});
parcelRegister("73UuK", function(module, exports) {

$parcel$export(module.exports, "log", function () { return (parcelRequire("lvicK")).log; });
$parcel$export(module.exports, "isWebGL", function () { return (parcelRequire("8HKWo")).isWebGL; });
$parcel$export(module.exports, "isWebGL2", function () { return (parcelRequire("8HKWo")).isWebGL2; });
$parcel$export(module.exports, "getWebGL2Context", function () { return (parcelRequire("8HKWo")).getWebGL2Context; });
$parcel$export(module.exports, "assertWebGLContext", function () { return (parcelRequire("8HKWo")).assertWebGLContext; });
$parcel$export(module.exports, "assertWebGL2Context", function () { return (parcelRequire("8HKWo")).assertWebGL2Context; });
$parcel$export(module.exports, "setParameters", function () { return (parcelRequire("2SJyH")).setParameters; });
$parcel$export(module.exports, "resetParameters", function () { return (parcelRequire("2SJyH")).resetParameters; });
$parcel$export(module.exports, "withParameters", function () { return (parcelRequire("2SJyH")).withParameters; });
$parcel$export(module.exports, "createGLContext", function () { return (parcelRequire("5k5Ga")).createGLContext; });
$parcel$export(module.exports, "resizeGLContext", function () { return (parcelRequire("5k5Ga")).resizeGLContext; });
$parcel$export(module.exports, "instrumentGLContext", function () { return (parcelRequire("5k5Ga")).instrumentGLContext; });
$parcel$export(module.exports, "cssToDeviceRatio", function () { return (parcelRequire("ieKgV")).cssToDeviceRatio; });
$parcel$export(module.exports, "cssToDevicePixels", function () { return (parcelRequire("ieKgV")).cssToDevicePixels; });

var $lvicK = parcelRequire("lvicK");

var $8HKWo = parcelRequire("8HKWo");

var $achLN = parcelRequire("achLN");

var $2SJyH = parcelRequire("2SJyH");

var $bMGK6 = parcelRequire("bMGK6");

var $5k5Ga = parcelRequire("5k5Ga");

var $ieKgV = parcelRequire("ieKgV");

});
parcelRegister("lvicK", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $fa7a9d4ce373782e$export$bef1f36f5486a6a3; });
parcelRequire("hBHxj");
var $1s4ih = parcelRequire("1s4ih");
const $fa7a9d4ce373782e$export$bef1f36f5486a6a3 = new (0, $1s4ih.Log)({
    id: "luma.gl"
});

});

parcelRegister("8HKWo", function(module, exports) {

$parcel$export(module.exports, "isWebGL", function () { return $6566c0606a4673f9$export$3a471d0dd6792be6; });
$parcel$export(module.exports, "isWebGL2", function () { return $6566c0606a4673f9$export$e3518b1ac7891039; });
$parcel$export(module.exports, "getWebGL2Context", function () { return $6566c0606a4673f9$export$89dcfcb9130f2c28; });
$parcel$export(module.exports, "assertWebGLContext", function () { return $6566c0606a4673f9$export$9b0605fd3c935712; });
$parcel$export(module.exports, "assertWebGL2Context", function () { return $6566c0606a4673f9$export$22897d77b4bb5316; });

var $bcsvz = parcelRequire("bcsvz");
const $6566c0606a4673f9$var$ERR_CONTEXT = "Invalid WebGLRenderingContext";
const $6566c0606a4673f9$export$48f7473fb8287ec0 = $6566c0606a4673f9$var$ERR_CONTEXT;
const $6566c0606a4673f9$export$f882315798580146 = "Requires WebGL2";
function $6566c0606a4673f9$export$3a471d0dd6792be6(gl) {
    if (typeof WebGLRenderingContext !== "undefined" && gl instanceof WebGLRenderingContext) return true;
    if (typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext) return true;
    return Boolean(gl && Number.isFinite(gl._version));
}
function $6566c0606a4673f9$export$e3518b1ac7891039(gl) {
    if (typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext) return true;
    return Boolean(gl && gl._version === 2);
}
function $6566c0606a4673f9$export$89dcfcb9130f2c28(gl) {
    return $6566c0606a4673f9$export$e3518b1ac7891039(gl) ? gl : null;
}
function $6566c0606a4673f9$export$9b0605fd3c935712(gl) {
    (0, $bcsvz.assert)($6566c0606a4673f9$export$3a471d0dd6792be6(gl), $6566c0606a4673f9$var$ERR_CONTEXT);
    return gl;
}
function $6566c0606a4673f9$export$22897d77b4bb5316(gl) {
    (0, $bcsvz.assert)($6566c0606a4673f9$export$e3518b1ac7891039(gl), $6566c0606a4673f9$export$f882315798580146);
    return gl;
}

});
parcelRegister("bcsvz", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $8276edd261c2df89$export$a7a9523472993e97; });
function $8276edd261c2df89$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "luma.gl: assertion failed.");
}

});


parcelRegister("achLN", function(module, exports) {

var $1fqfg = parcelRequire("1fqfg");

var $bcsvz = parcelRequire("bcsvz");

var $eOLk1 = parcelRequire("eOLk1");
function $76c8cf1f521e9858$export$2546a51f55104d54(gl) {
    gl.luma = gl.luma || {};
    const { luma: luma } = gl;
    if (!luma.polyfilled) {
        (0, $1fqfg.polyfillVertexArrayObject)(gl);
        $76c8cf1f521e9858$var$initializeExtensions(gl);
        $76c8cf1f521e9858$var$installPolyfills(gl, (0, $eOLk1.WEBGL2_CONTEXT_POLYFILLS));
        $76c8cf1f521e9858$var$installOverrides(gl, {
            target: luma,
            target2: gl
        });
        luma.polyfilled = true;
    }
    return gl;
}
globalThis.polyfillContext = $76c8cf1f521e9858$export$2546a51f55104d54;
function $76c8cf1f521e9858$var$initializeExtensions(gl) {
    gl.luma.extensions = {};
    const EXTENSIONS = gl.getSupportedExtensions() || [];
    for (const extension of EXTENSIONS)gl.luma[extension] = gl.getExtension(extension);
}
function $76c8cf1f521e9858$var$installOverrides(gl, _ref) {
    let { target: target, target2: target2 } = _ref;
    Object.keys((0, $eOLk1.WEBGL2_CONTEXT_OVERRIDES)).forEach((key)=>{
        if (typeof (0, $eOLk1.WEBGL2_CONTEXT_OVERRIDES)[key] === "function") {
            const originalFunc = gl[key] ? gl[key].bind(gl) : ()=>{};
            const polyfill = (0, $eOLk1.WEBGL2_CONTEXT_OVERRIDES)[key].bind(null, gl, originalFunc);
            target[key] = polyfill;
            target2[key] = polyfill;
        }
    });
}
function $76c8cf1f521e9858$var$installPolyfills(gl, polyfills) {
    for (const extension of Object.getOwnPropertyNames(polyfills))if (extension !== "overrides") $76c8cf1f521e9858$var$polyfillExtension(gl, {
        extension: extension,
        target: gl.luma,
        target2: gl
    });
}
function $76c8cf1f521e9858$var$polyfillExtension(gl, _ref2) {
    let { extension: extension, target: target, target2: target2 } = _ref2;
    const defaults = (0, $eOLk1.WEBGL2_CONTEXT_POLYFILLS)[extension];
    (0, $bcsvz.assert)(defaults);
    const { meta: meta = {} } = defaults;
    const { suffix: suffix = "" } = meta;
    const ext = gl.getExtension(extension);
    for (const key of Object.keys(defaults)){
        const extKey = "".concat(key).concat(suffix);
        let polyfill = null;
        if (key === "meta") ;
        else if (typeof gl[key] === "function") ;
        else if (ext && typeof ext[extKey] === "function") polyfill = function() {
            return ext[extKey](...arguments);
        };
        else if (typeof defaults[key] === "function") polyfill = defaults[key].bind(target);
        if (polyfill) {
            target[key] = polyfill;
            target2[key] = polyfill;
        }
    }
}

});
parcelRegister("1fqfg", function(module, exports) {

$parcel$export(module.exports, "polyfillVertexArrayObject", function () { return $0e8b8cee8f49775e$export$a14b3889aebee3e2; });
const $0e8b8cee8f49775e$var$glErrorShadow = {};
function $0e8b8cee8f49775e$var$error(msg) {
    if (globalThis.console && globalThis.console.error) globalThis.console.error(msg);
}
function $0e8b8cee8f49775e$var$log(msg) {
    if (globalThis.console && globalThis.console.log) globalThis.console.log(msg);
}
function $0e8b8cee8f49775e$var$synthesizeGLError(err, opt_msg) {
    $0e8b8cee8f49775e$var$glErrorShadow[err] = true;
    if (opt_msg !== undefined) $0e8b8cee8f49775e$var$error(opt_msg);
}
function $0e8b8cee8f49775e$var$wrapGLError(gl) {
    const f = gl.getError;
    gl.getError = function getError() {
        let err;
        do {
            err = f.apply(gl);
            if (err !== 0) $0e8b8cee8f49775e$var$glErrorShadow[err] = true;
        }while (err !== 0);
        for(err in $0e8b8cee8f49775e$var$glErrorShadow)if ($0e8b8cee8f49775e$var$glErrorShadow[err]) {
            delete $0e8b8cee8f49775e$var$glErrorShadow[err];
            return parseInt(err, 10);
        }
        return 0;
    };
}
const $0e8b8cee8f49775e$var$WebGLVertexArrayObjectOES = function WebGLVertexArrayObjectOES(ext) {
    const gl = ext.gl;
    this.ext = ext;
    this.isAlive = true;
    this.hasBeenBound = false;
    this.elementArrayBuffer = null;
    this.attribs = new Array(ext.maxVertexAttribs);
    for(let n = 0; n < this.attribs.length; n++){
        const attrib = new WebGLVertexArrayObjectOES.VertexAttrib(gl);
        this.attribs[n] = attrib;
    }
    this.maxAttrib = 0;
};
$0e8b8cee8f49775e$var$WebGLVertexArrayObjectOES.VertexAttrib = function VertexAttrib(gl) {
    this.enabled = false;
    this.buffer = null;
    this.size = 4;
    this.type = 5126;
    this.normalized = false;
    this.stride = 16;
    this.offset = 0;
    this.cached = "";
    this.recache();
};
$0e8b8cee8f49775e$var$WebGLVertexArrayObjectOES.VertexAttrib.prototype.recache = function recache() {
    this.cached = [
        this.size,
        this.type,
        this.normalized,
        this.stride,
        this.offset
    ].join(":");
};
const $0e8b8cee8f49775e$var$OESVertexArrayObject = function OESVertexArrayObject(gl) {
    const self = this;
    this.gl = gl;
    $0e8b8cee8f49775e$var$wrapGLError(gl);
    const original = this.original = {
        getParameter: gl.getParameter,
        enableVertexAttribArray: gl.enableVertexAttribArray,
        disableVertexAttribArray: gl.disableVertexAttribArray,
        bindBuffer: gl.bindBuffer,
        getVertexAttrib: gl.getVertexAttrib,
        vertexAttribPointer: gl.vertexAttribPointer
    };
    gl.getParameter = function getParameter(pname) {
        if (pname === self.VERTEX_ARRAY_BINDING_OES) {
            if (self.currentVertexArrayObject === self.defaultVertexArrayObject) return null;
            return self.currentVertexArrayObject;
        }
        return original.getParameter.apply(this, arguments);
    };
    gl.enableVertexAttribArray = function enableVertexAttribArray(index) {
        const vao = self.currentVertexArrayObject;
        vao.maxAttrib = Math.max(vao.maxAttrib, index);
        const attrib = vao.attribs[index];
        attrib.enabled = true;
        return original.enableVertexAttribArray.apply(this, arguments);
    };
    gl.disableVertexAttribArray = function disableVertexAttribArray(index) {
        const vao = self.currentVertexArrayObject;
        vao.maxAttrib = Math.max(vao.maxAttrib, index);
        const attrib = vao.attribs[index];
        attrib.enabled = false;
        return original.disableVertexAttribArray.apply(this, arguments);
    };
    gl.bindBuffer = function bindBuffer(target, buffer) {
        switch(target){
            case 34962:
                self.currentArrayBuffer = buffer;
                break;
            case 34963:
                self.currentVertexArrayObject.elementArrayBuffer = buffer;
                break;
            default:
        }
        return original.bindBuffer.apply(this, arguments);
    };
    gl.getVertexAttrib = function getVertexAttrib(index, pname) {
        const vao = self.currentVertexArrayObject;
        const attrib = vao.attribs[index];
        switch(pname){
            case 34975:
                return attrib.buffer;
            case 34338:
                return attrib.enabled;
            case 34339:
                return attrib.size;
            case 34340:
                return attrib.stride;
            case 34341:
                return attrib.type;
            case 34922:
                return attrib.normalized;
            default:
                return original.getVertexAttrib.apply(this, arguments);
        }
    };
    gl.vertexAttribPointer = function vertexAttribPointer(indx, size, type, normalized, stride, offset) {
        const vao = self.currentVertexArrayObject;
        vao.maxAttrib = Math.max(vao.maxAttrib, indx);
        const attrib = vao.attribs[indx];
        attrib.buffer = self.currentArrayBuffer;
        attrib.size = size;
        attrib.type = type;
        attrib.normalized = normalized;
        attrib.stride = stride;
        attrib.offset = offset;
        attrib.recache();
        return original.vertexAttribPointer.apply(this, arguments);
    };
    if (gl.instrumentExtension) gl.instrumentExtension(this, "OES_vertex_array_object");
    if (gl.canvas) gl.canvas.addEventListener("webglcontextrestored", ()=>{
        $0e8b8cee8f49775e$var$log("OESVertexArrayObject emulation library context restored");
        self.reset_();
    }, true);
    this.reset_();
};
$0e8b8cee8f49775e$var$OESVertexArrayObject.prototype.VERTEX_ARRAY_BINDING_OES = 0x85b5;
$0e8b8cee8f49775e$var$OESVertexArrayObject.prototype.reset_ = function reset_() {
    const contextWasLost = this.vertexArrayObjects !== undefined;
    if (contextWasLost) for(let ii = 0; ii < this.vertexArrayObjects.length; ++ii)this.vertexArrayObjects.isAlive = false;
    const gl = this.gl;
    this.maxVertexAttribs = gl.getParameter(34921);
    this.defaultVertexArrayObject = new $0e8b8cee8f49775e$var$WebGLVertexArrayObjectOES(this);
    this.currentVertexArrayObject = null;
    this.currentArrayBuffer = null;
    this.vertexArrayObjects = [
        this.defaultVertexArrayObject
    ];
    this.bindVertexArrayOES(null);
};
$0e8b8cee8f49775e$var$OESVertexArrayObject.prototype.createVertexArrayOES = function createVertexArrayOES() {
    const arrayObject = new $0e8b8cee8f49775e$var$WebGLVertexArrayObjectOES(this);
    this.vertexArrayObjects.push(arrayObject);
    return arrayObject;
};
$0e8b8cee8f49775e$var$OESVertexArrayObject.prototype.deleteVertexArrayOES = function deleteVertexArrayOES(arrayObject) {
    arrayObject.isAlive = false;
    this.vertexArrayObjects.splice(this.vertexArrayObjects.indexOf(arrayObject), 1);
    if (this.currentVertexArrayObject === arrayObject) this.bindVertexArrayOES(null);
};
$0e8b8cee8f49775e$var$OESVertexArrayObject.prototype.isVertexArrayOES = function isVertexArrayOES(arrayObject) {
    if (arrayObject && arrayObject instanceof $0e8b8cee8f49775e$var$WebGLVertexArrayObjectOES) {
        if (arrayObject.hasBeenBound && arrayObject.ext === this) return true;
    }
    return false;
};
$0e8b8cee8f49775e$var$OESVertexArrayObject.prototype.bindVertexArrayOES = function bindVertexArrayOES(arrayObject) {
    const gl = this.gl;
    if (arrayObject && !arrayObject.isAlive) {
        $0e8b8cee8f49775e$var$synthesizeGLError(1282, "bindVertexArrayOES: attempt to bind deleted arrayObject");
        return;
    }
    const original = this.original;
    const oldVAO = this.currentVertexArrayObject;
    this.currentVertexArrayObject = arrayObject || this.defaultVertexArrayObject;
    this.currentVertexArrayObject.hasBeenBound = true;
    const newVAO = this.currentVertexArrayObject;
    if (oldVAO === newVAO) return;
    if (!oldVAO || newVAO.elementArrayBuffer !== oldVAO.elementArrayBuffer) original.bindBuffer.call(gl, 34963, newVAO.elementArrayBuffer);
    let currentBinding = this.currentArrayBuffer;
    const maxAttrib = Math.max(oldVAO ? oldVAO.maxAttrib : 0, newVAO.maxAttrib);
    for(let n = 0; n <= maxAttrib; n++){
        const attrib = newVAO.attribs[n];
        const oldAttrib = oldVAO ? oldVAO.attribs[n] : null;
        if (!oldVAO || attrib.enabled !== oldAttrib.enabled) {
            if (attrib.enabled) original.enableVertexAttribArray.call(gl, n);
            else original.disableVertexAttribArray.call(gl, n);
        }
        if (attrib.enabled) {
            let bufferChanged = false;
            if (!oldVAO || attrib.buffer !== oldAttrib.buffer) {
                if (currentBinding !== attrib.buffer) {
                    original.bindBuffer.call(gl, 34962, attrib.buffer);
                    currentBinding = attrib.buffer;
                }
                bufferChanged = true;
            }
            if (bufferChanged || attrib.cached !== oldAttrib.cached) original.vertexAttribPointer.call(gl, n, attrib.size, attrib.type, attrib.normalized, attrib.stride, attrib.offset);
        }
    }
    if (this.currentArrayBuffer !== currentBinding) original.bindBuffer.call(gl, 34962, this.currentArrayBuffer);
};
function $0e8b8cee8f49775e$export$a14b3889aebee3e2(gl) {
    if (typeof gl.createVertexArray === "function") return;
    const original_getSupportedExtensions = gl.getSupportedExtensions;
    gl.getSupportedExtensions = function getSupportedExtensions() {
        const list = original_getSupportedExtensions.call(this) || [];
        if (list.indexOf("OES_vertex_array_object") < 0) list.push("OES_vertex_array_object");
        return list;
    };
    const original_getExtension = gl.getExtension;
    gl.getExtension = function getExtension(name) {
        const ext = original_getExtension.call(this, name);
        if (ext) return ext;
        if (name !== "OES_vertex_array_object") return null;
        if (!gl.__OESVertexArrayObject) this.__OESVertexArrayObject = new $0e8b8cee8f49775e$var$OESVertexArrayObject(this);
        return this.__OESVertexArrayObject;
    };
}

});

parcelRegister("eOLk1", function(module, exports) {

$parcel$export(module.exports, "WEBGL2_CONTEXT_POLYFILLS", function () { return $ac9a715e2be4b231$export$55b4f9cc9ea3ebcb; });
$parcel$export(module.exports, "WEBGL2_CONTEXT_OVERRIDES", function () { return $ac9a715e2be4b231$export$16cadaab146130da; });

var $bcsvz = parcelRequire("bcsvz");

var $8HKWo = parcelRequire("8HKWo");

var $5QFaj = parcelRequire("5QFaj");
const $ac9a715e2be4b231$var$OES_vertex_array_object = "OES_vertex_array_object";
const $ac9a715e2be4b231$var$ANGLE_instanced_arrays = "ANGLE_instanced_arrays";
const $ac9a715e2be4b231$var$WEBGL_draw_buffers = "WEBGL_draw_buffers";
const $ac9a715e2be4b231$var$EXT_disjoint_timer_query = "EXT_disjoint_timer_query";
const $ac9a715e2be4b231$var$EXT_texture_filter_anisotropic = "EXT_texture_filter_anisotropic";
const $ac9a715e2be4b231$var$ERR_VAO_NOT_SUPPORTED = "VertexArray requires WebGL2 or OES_vertex_array_object extension";
function $ac9a715e2be4b231$var$getExtensionData(gl, extension) {
    return {
        webgl2: (0, $8HKWo.isWebGL2)(gl),
        ext: gl.getExtension(extension)
    };
}
const $ac9a715e2be4b231$export$55b4f9cc9ea3ebcb = {
    [$ac9a715e2be4b231$var$OES_vertex_array_object]: {
        meta: {
            suffix: "OES"
        },
        createVertexArray: ()=>{
            (0, $bcsvz.assert)(false, $ac9a715e2be4b231$var$ERR_VAO_NOT_SUPPORTED);
        },
        deleteVertexArray: ()=>{},
        bindVertexArray: ()=>{},
        isVertexArray: ()=>false
    },
    [$ac9a715e2be4b231$var$ANGLE_instanced_arrays]: {
        meta: {
            suffix: "ANGLE"
        },
        vertexAttribDivisor (location, divisor) {
            (0, $bcsvz.assert)(divisor === 0, "WebGL instanced rendering not supported");
        },
        drawElementsInstanced: ()=>{},
        drawArraysInstanced: ()=>{}
    },
    [$ac9a715e2be4b231$var$WEBGL_draw_buffers]: {
        meta: {
            suffix: "WEBGL"
        },
        drawBuffers: ()=>{
            (0, $bcsvz.assert)(false);
        }
    },
    [$ac9a715e2be4b231$var$EXT_disjoint_timer_query]: {
        meta: {
            suffix: "EXT"
        },
        createQuery: ()=>{
            (0, $bcsvz.assert)(false);
        },
        deleteQuery: ()=>{
            (0, $bcsvz.assert)(false);
        },
        beginQuery: ()=>{
            (0, $bcsvz.assert)(false);
        },
        endQuery: ()=>{},
        getQuery (handle, pname) {
            return this.getQueryObject(handle, pname);
        },
        getQueryParameter (handle, pname) {
            return this.getQueryObject(handle, pname);
        },
        getQueryObject: ()=>{}
    }
};
const $ac9a715e2be4b231$export$16cadaab146130da = {
    readBuffer: (gl, originalFunc, attachment)=>{
        if ((0, $8HKWo.isWebGL2)(gl)) originalFunc(attachment);
    },
    getVertexAttrib: (gl, originalFunc, location, pname)=>{
        const { webgl2: webgl2, ext: ext } = $ac9a715e2be4b231$var$getExtensionData(gl, $ac9a715e2be4b231$var$ANGLE_instanced_arrays);
        let result;
        switch(pname){
            case 35069:
                result = !webgl2 ? false : undefined;
                break;
            case 35070:
                result = !webgl2 && !ext ? 0 : undefined;
                break;
            default:
        }
        return result !== undefined ? result : originalFunc(location, pname);
    },
    getProgramParameter: (gl, originalFunc, program, pname)=>{
        if (!(0, $8HKWo.isWebGL2)(gl)) switch(pname){
            case 35967:
                return 35981;
            case 35971:
                return 0;
            case 35382:
                return 0;
            default:
        }
        return originalFunc(program, pname);
    },
    getInternalformatParameter: (gl, originalFunc, target, format, pname)=>{
        if (!(0, $8HKWo.isWebGL2)(gl)) switch(pname){
            case 32937:
                return new Int32Array([
                    0
                ]);
            default:
        }
        return gl.getInternalformatParameter(target, format, pname);
    },
    getTexParameter (gl, originalFunc, target, pname) {
        switch(pname){
            case 34046:
                const { extensions: extensions } = gl.luma;
                const ext = extensions[$ac9a715e2be4b231$var$EXT_texture_filter_anisotropic];
                pname = ext && ext.TEXTURE_MAX_ANISOTROPY_EXT || 34046;
                break;
            default:
        }
        return originalFunc(target, pname);
    },
    getParameter: (0, $5QFaj.getParameterPolyfill),
    hint (gl, originalFunc, pname, value) {
        return originalFunc(pname, value);
    }
};

});
parcelRegister("5QFaj", function(module, exports) {

$parcel$export(module.exports, "getParameterPolyfill", function () { return $4421bda2d8b32c12$export$76e91f2080178ba1; });

var $8HKWo = parcelRequire("8HKWo");
const $4421bda2d8b32c12$var$OES_element_index = "OES_element_index";
const $4421bda2d8b32c12$var$WEBGL_draw_buffers = "WEBGL_draw_buffers";
const $4421bda2d8b32c12$var$EXT_disjoint_timer_query = "EXT_disjoint_timer_query";
const $4421bda2d8b32c12$var$EXT_disjoint_timer_query_webgl2 = "EXT_disjoint_timer_query_webgl2";
const $4421bda2d8b32c12$var$EXT_texture_filter_anisotropic = "EXT_texture_filter_anisotropic";
const $4421bda2d8b32c12$var$WEBGL_debug_renderer_info = "WEBGL_debug_renderer_info";
const $4421bda2d8b32c12$var$GL_FRAGMENT_SHADER_DERIVATIVE_HINT = 0x8b8b;
const $4421bda2d8b32c12$var$GL_DONT_CARE = 0x1100;
const $4421bda2d8b32c12$var$GL_GPU_DISJOINT_EXT = 0x8fbb;
const $4421bda2d8b32c12$var$GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT = 0x84ff;
const $4421bda2d8b32c12$var$GL_UNMASKED_VENDOR_WEBGL = 0x9245;
const $4421bda2d8b32c12$var$GL_UNMASKED_RENDERER_WEBGL = 0x9246;
const $4421bda2d8b32c12$var$getWebGL2ValueOrZero = (gl)=>!(0, $8HKWo.isWebGL2)(gl) ? 0 : undefined;
const $4421bda2d8b32c12$var$WEBGL_PARAMETERS = {
    [3074]: (gl)=>!(0, $8HKWo.isWebGL2)(gl) ? 36064 : undefined,
    [$4421bda2d8b32c12$var$GL_FRAGMENT_SHADER_DERIVATIVE_HINT]: (gl)=>!(0, $8HKWo.isWebGL2)(gl) ? $4421bda2d8b32c12$var$GL_DONT_CARE : undefined,
    [35977]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [32937]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [$4421bda2d8b32c12$var$GL_GPU_DISJOINT_EXT]: (gl, getParameter)=>{
        const ext = (0, $8HKWo.isWebGL2)(gl) ? gl.getExtension($4421bda2d8b32c12$var$EXT_disjoint_timer_query_webgl2) : gl.getExtension($4421bda2d8b32c12$var$EXT_disjoint_timer_query);
        return ext && ext.GPU_DISJOINT_EXT ? getParameter(ext.GPU_DISJOINT_EXT) : 0;
    },
    [$4421bda2d8b32c12$var$GL_UNMASKED_VENDOR_WEBGL]: (gl, getParameter)=>{
        const ext = gl.getExtension($4421bda2d8b32c12$var$WEBGL_debug_renderer_info);
        return getParameter(ext && ext.UNMASKED_VENDOR_WEBGL || 7936);
    },
    [$4421bda2d8b32c12$var$GL_UNMASKED_RENDERER_WEBGL]: (gl, getParameter)=>{
        const ext = gl.getExtension($4421bda2d8b32c12$var$WEBGL_debug_renderer_info);
        return getParameter(ext && ext.UNMASKED_RENDERER_WEBGL || 7937);
    },
    [$4421bda2d8b32c12$var$GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT]: (gl, getParameter)=>{
        const ext = gl.luma.extensions[$4421bda2d8b32c12$var$EXT_texture_filter_anisotropic];
        return ext ? getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 1.0;
    },
    [32883]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35071]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [37447]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [36063]: (gl, getParameter)=>{
        if (!(0, $8HKWo.isWebGL2)(gl)) {
            const ext = gl.getExtension($4421bda2d8b32c12$var$WEBGL_draw_buffers);
            return ext ? getParameter(ext.MAX_COLOR_ATTACHMENTS_WEBGL) : 0;
        }
        return undefined;
    },
    [35379]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35374]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35377]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [34852]: (gl)=>{
        if (!(0, $8HKWo.isWebGL2)(gl)) {
            const ext = gl.getExtension($4421bda2d8b32c12$var$WEBGL_draw_buffers);
            return ext ? ext.MAX_DRAW_BUFFERS_WEBGL : 0;
        }
        return undefined;
    },
    [36203]: (gl)=>gl.getExtension($4421bda2d8b32c12$var$OES_element_index) ? 2147483647 : 65535,
    [33001]: (gl)=>gl.getExtension($4421bda2d8b32c12$var$OES_element_index) ? 16777216 : 65535,
    [33000]: (gl)=>16777216,
    [37157]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35373]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35657]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [36183]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [37137]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [34045]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35978]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35979]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35968]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35376]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35375]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35659]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [37154]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35371]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35658]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35076]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35077]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero,
    [35380]: $4421bda2d8b32c12$var$getWebGL2ValueOrZero
};
function $4421bda2d8b32c12$export$76e91f2080178ba1(gl, originalGetParameter, pname) {
    const limit = $4421bda2d8b32c12$var$WEBGL_PARAMETERS[pname];
    const value = typeof limit === "function" ? limit(gl, originalGetParameter, pname) : limit;
    const result = value !== undefined ? value : originalGetParameter(pname);
    return result;
}

});



parcelRegister("2SJyH", function(module, exports) {

$parcel$export(module.exports, "setParameters", function () { return $2193f6f06732c40b$export$60752c4a8a24d484; });
$parcel$export(module.exports, "getParameters", function () { return $2193f6f06732c40b$export$1d5e65f36fbcdb49; });
$parcel$export(module.exports, "resetParameters", function () { return $2193f6f06732c40b$export$2ee1427ea70eaaab; });
$parcel$export(module.exports, "withParameters", function () { return $2193f6f06732c40b$export$b1e7058a2936b651; });

var $toBvF = parcelRequire("toBvF");

var $bMGK6 = parcelRequire("bMGK6");

var $bcsvz = parcelRequire("bcsvz");

var $8HKWo = parcelRequire("8HKWo");

var $9mLS9 = parcelRequire("9mLS9");
function $2193f6f06732c40b$export$60752c4a8a24d484(gl, values) {
    (0, $bcsvz.assert)((0, $8HKWo.isWebGL)(gl), "setParameters requires a WebGL context");
    if ((0, $9mLS9.isObjectEmpty)(values)) return;
    const compositeSetters = {};
    for(const key in values){
        const glConstant = Number(key);
        const setter = (0, $toBvF.GL_PARAMETER_SETTERS)[key];
        if (setter) {
            if (typeof setter === "string") compositeSetters[setter] = true;
            else setter(gl, values[key], glConstant);
        }
    }
    const cache = gl.state && gl.state.cache;
    if (cache) for(const key in compositeSetters){
        const compositeSetter = (0, $toBvF.GL_COMPOSITE_PARAMETER_SETTERS)[key];
        compositeSetter(gl, values, cache);
    }
}
function $2193f6f06732c40b$export$1d5e65f36fbcdb49(gl, parameters) {
    parameters = parameters || (0, $toBvF.GL_PARAMETER_DEFAULTS);
    if (typeof parameters === "number") {
        const key = parameters;
        const getter = (0, $toBvF.GL_PARAMETER_GETTERS)[key];
        return getter ? getter(gl, key) : gl.getParameter(key);
    }
    const parameterKeys = Array.isArray(parameters) ? parameters : Object.keys(parameters);
    const state = {};
    for (const key of parameterKeys){
        const getter = (0, $toBvF.GL_PARAMETER_GETTERS)[key];
        state[key] = getter ? getter(gl, Number(key)) : gl.getParameter(Number(key));
    }
    return state;
}
function $2193f6f06732c40b$export$2ee1427ea70eaaab(gl) {
    $2193f6f06732c40b$export$60752c4a8a24d484(gl, (0, $toBvF.GL_PARAMETER_DEFAULTS));
}
function $2193f6f06732c40b$export$b1e7058a2936b651(gl, parameters, func) {
    if ((0, $9mLS9.isObjectEmpty)(parameters)) return func(gl);
    const { nocatch: nocatch = true } = parameters;
    (0, $bMGK6.pushContextState)(gl);
    $2193f6f06732c40b$export$60752c4a8a24d484(gl, parameters);
    let value;
    if (nocatch) {
        value = func(gl);
        (0, $bMGK6.popContextState)(gl);
    } else try {
        value = func(gl);
    } finally{
        (0, $bMGK6.popContextState)(gl);
    }
    return value;
}

});
parcelRegister("toBvF", function(module, exports) {

$parcel$export(module.exports, "GL_PARAMETER_DEFAULTS", function () { return $0585cb639441f7d8$export$baa06478962d475e; });
$parcel$export(module.exports, "GL_PARAMETER_SETTERS", function () { return $0585cb639441f7d8$export$f29b03183ed64cfb; });
$parcel$export(module.exports, "GL_COMPOSITE_PARAMETER_SETTERS", function () { return $0585cb639441f7d8$export$ff5443824a4dc32; });
$parcel$export(module.exports, "GL_HOOKED_SETTERS", function () { return $0585cb639441f7d8$export$21a690e042a82719; });
$parcel$export(module.exports, "GL_PARAMETER_GETTERS", function () { return $0585cb639441f7d8$export$f7e7f6f928a85334; });

var $8HKWo = parcelRequire("8HKWo");
const $0585cb639441f7d8$export$baa06478962d475e = {
    [3042]: false,
    [32773]: new Float32Array([
        0,
        0,
        0,
        0
    ]),
    [32777]: 32774,
    [34877]: 32774,
    [32969]: 1,
    [32968]: 0,
    [32971]: 1,
    [32970]: 0,
    [3106]: new Float32Array([
        0,
        0,
        0,
        0
    ]),
    [3107]: [
        true,
        true,
        true,
        true
    ],
    [2884]: false,
    [2885]: 1029,
    [2929]: false,
    [2931]: 1,
    [2932]: 513,
    [2928]: new Float32Array([
        0,
        1
    ]),
    [2930]: true,
    [3024]: true,
    [36006]: null,
    [2886]: 2305,
    [33170]: 4352,
    [2849]: 1,
    [32823]: false,
    [32824]: 0,
    [10752]: 0,
    [32938]: 1.0,
    [32939]: false,
    [3089]: false,
    [3088]: new Int32Array([
        0,
        0,
        1024,
        1024
    ]),
    [2960]: false,
    [2961]: 0,
    [2968]: 0xffffffff,
    [36005]: 0xffffffff,
    [2962]: 519,
    [2967]: 0,
    [2963]: 0xffffffff,
    [34816]: 519,
    [36003]: 0,
    [36004]: 0xffffffff,
    [2964]: 7680,
    [2965]: 7680,
    [2966]: 7680,
    [34817]: 7680,
    [34818]: 7680,
    [34819]: 7680,
    [2978]: [
        0,
        0,
        1024,
        1024
    ],
    [3333]: 4,
    [3317]: 4,
    [37440]: false,
    [37441]: false,
    [37443]: 37444,
    [35723]: 4352,
    [36010]: null,
    [35977]: false,
    [3330]: 0,
    [3332]: 0,
    [3331]: 0,
    [3314]: 0,
    [32878]: 0,
    [3316]: 0,
    [3315]: 0,
    [32877]: 0
};
const $0585cb639441f7d8$var$enable = (gl, value, key)=>value ? gl.enable(key) : gl.disable(key);
const $0585cb639441f7d8$var$hint = (gl, value, key)=>gl.hint(key, value);
const $0585cb639441f7d8$var$pixelStorei = (gl, value, key)=>gl.pixelStorei(key, value);
const $0585cb639441f7d8$var$drawFramebuffer = (gl, value)=>{
    const target = (0, $8HKWo.isWebGL2)(gl) ? 36009 : 36160;
    return gl.bindFramebuffer(target, value);
};
const $0585cb639441f7d8$var$readFramebuffer = (gl, value)=>{
    return gl.bindFramebuffer(36008, value);
};
function $0585cb639441f7d8$var$isArray(array) {
    return Array.isArray(array) || ArrayBuffer.isView(array);
}
const $0585cb639441f7d8$export$f29b03183ed64cfb = {
    [3042]: $0585cb639441f7d8$var$enable,
    [32773]: (gl, value)=>gl.blendColor(...value),
    [32777]: "blendEquation",
    [34877]: "blendEquation",
    [32969]: "blendFunc",
    [32968]: "blendFunc",
    [32971]: "blendFunc",
    [32970]: "blendFunc",
    [3106]: (gl, value)=>gl.clearColor(...value),
    [3107]: (gl, value)=>gl.colorMask(...value),
    [2884]: $0585cb639441f7d8$var$enable,
    [2885]: (gl, value)=>gl.cullFace(value),
    [2929]: $0585cb639441f7d8$var$enable,
    [2931]: (gl, value)=>gl.clearDepth(value),
    [2932]: (gl, value)=>gl.depthFunc(value),
    [2928]: (gl, value)=>gl.depthRange(...value),
    [2930]: (gl, value)=>gl.depthMask(value),
    [3024]: $0585cb639441f7d8$var$enable,
    [35723]: $0585cb639441f7d8$var$hint,
    [36006]: $0585cb639441f7d8$var$drawFramebuffer,
    [2886]: (gl, value)=>gl.frontFace(value),
    [33170]: $0585cb639441f7d8$var$hint,
    [2849]: (gl, value)=>gl.lineWidth(value),
    [32823]: $0585cb639441f7d8$var$enable,
    [32824]: "polygonOffset",
    [10752]: "polygonOffset",
    [35977]: $0585cb639441f7d8$var$enable,
    [32938]: "sampleCoverage",
    [32939]: "sampleCoverage",
    [3089]: $0585cb639441f7d8$var$enable,
    [3088]: (gl, value)=>gl.scissor(...value),
    [2960]: $0585cb639441f7d8$var$enable,
    [2961]: (gl, value)=>gl.clearStencil(value),
    [2968]: (gl, value)=>gl.stencilMaskSeparate(1028, value),
    [36005]: (gl, value)=>gl.stencilMaskSeparate(1029, value),
    [2962]: "stencilFuncFront",
    [2967]: "stencilFuncFront",
    [2963]: "stencilFuncFront",
    [34816]: "stencilFuncBack",
    [36003]: "stencilFuncBack",
    [36004]: "stencilFuncBack",
    [2964]: "stencilOpFront",
    [2965]: "stencilOpFront",
    [2966]: "stencilOpFront",
    [34817]: "stencilOpBack",
    [34818]: "stencilOpBack",
    [34819]: "stencilOpBack",
    [2978]: (gl, value)=>gl.viewport(...value),
    [3333]: $0585cb639441f7d8$var$pixelStorei,
    [3317]: $0585cb639441f7d8$var$pixelStorei,
    [37440]: $0585cb639441f7d8$var$pixelStorei,
    [37441]: $0585cb639441f7d8$var$pixelStorei,
    [37443]: $0585cb639441f7d8$var$pixelStorei,
    [3330]: $0585cb639441f7d8$var$pixelStorei,
    [3332]: $0585cb639441f7d8$var$pixelStorei,
    [3331]: $0585cb639441f7d8$var$pixelStorei,
    [36010]: $0585cb639441f7d8$var$readFramebuffer,
    [3314]: $0585cb639441f7d8$var$pixelStorei,
    [32878]: $0585cb639441f7d8$var$pixelStorei,
    [3316]: $0585cb639441f7d8$var$pixelStorei,
    [3315]: $0585cb639441f7d8$var$pixelStorei,
    [32877]: $0585cb639441f7d8$var$pixelStorei,
    framebuffer: (gl, framebuffer)=>{
        const handle = framebuffer && "handle" in framebuffer ? framebuffer.handle : framebuffer;
        return gl.bindFramebuffer(36160, handle);
    },
    blend: (gl, value)=>value ? gl.enable(3042) : gl.disable(3042),
    blendColor: (gl, value)=>gl.blendColor(...value),
    blendEquation: (gl, args)=>{
        args = $0585cb639441f7d8$var$isArray(args) ? args : [
            args,
            args
        ];
        gl.blendEquationSeparate(...args);
    },
    blendFunc: (gl, args)=>{
        args = $0585cb639441f7d8$var$isArray(args) && args.length === 2 ? [
            ...args,
            ...args
        ] : args;
        gl.blendFuncSeparate(...args);
    },
    clearColor: (gl, value)=>gl.clearColor(...value),
    clearDepth: (gl, value)=>gl.clearDepth(value),
    clearStencil: (gl, value)=>gl.clearStencil(value),
    colorMask: (gl, value)=>gl.colorMask(...value),
    cull: (gl, value)=>value ? gl.enable(2884) : gl.disable(2884),
    cullFace: (gl, value)=>gl.cullFace(value),
    depthTest: (gl, value)=>value ? gl.enable(2929) : gl.disable(2929),
    depthFunc: (gl, value)=>gl.depthFunc(value),
    depthMask: (gl, value)=>gl.depthMask(value),
    depthRange: (gl, value)=>gl.depthRange(...value),
    dither: (gl, value)=>value ? gl.enable(3024) : gl.disable(3024),
    derivativeHint: (gl, value)=>{
        gl.hint(35723, value);
    },
    frontFace: (gl, value)=>gl.frontFace(value),
    mipmapHint: (gl, value)=>gl.hint(33170, value),
    lineWidth: (gl, value)=>gl.lineWidth(value),
    polygonOffsetFill: (gl, value)=>value ? gl.enable(32823) : gl.disable(32823),
    polygonOffset: (gl, value)=>gl.polygonOffset(...value),
    sampleCoverage: (gl, value)=>gl.sampleCoverage(...value),
    scissorTest: (gl, value)=>value ? gl.enable(3089) : gl.disable(3089),
    scissor: (gl, value)=>gl.scissor(...value),
    stencilTest: (gl, value)=>value ? gl.enable(2960) : gl.disable(2960),
    stencilMask: (gl, value)=>{
        value = $0585cb639441f7d8$var$isArray(value) ? value : [
            value,
            value
        ];
        const [mask, backMask] = value;
        gl.stencilMaskSeparate(1028, mask);
        gl.stencilMaskSeparate(1029, backMask);
    },
    stencilFunc: (gl, args)=>{
        args = $0585cb639441f7d8$var$isArray(args) && args.length === 3 ? [
            ...args,
            ...args
        ] : args;
        const [func, ref, mask, backFunc, backRef, backMask] = args;
        gl.stencilFuncSeparate(1028, func, ref, mask);
        gl.stencilFuncSeparate(1029, backFunc, backRef, backMask);
    },
    stencilOp: (gl, args)=>{
        args = $0585cb639441f7d8$var$isArray(args) && args.length === 3 ? [
            ...args,
            ...args
        ] : args;
        const [sfail, dpfail, dppass, backSfail, backDpfail, backDppass] = args;
        gl.stencilOpSeparate(1028, sfail, dpfail, dppass);
        gl.stencilOpSeparate(1029, backSfail, backDpfail, backDppass);
    },
    viewport: (gl, value)=>gl.viewport(...value)
};
function $0585cb639441f7d8$var$getValue(glEnum, values, cache) {
    return values[glEnum] !== undefined ? values[glEnum] : cache[glEnum];
}
const $0585cb639441f7d8$export$ff5443824a4dc32 = {
    blendEquation: (gl, values, cache)=>gl.blendEquationSeparate($0585cb639441f7d8$var$getValue(32777, values, cache), $0585cb639441f7d8$var$getValue(34877, values, cache)),
    blendFunc: (gl, values, cache)=>gl.blendFuncSeparate($0585cb639441f7d8$var$getValue(32969, values, cache), $0585cb639441f7d8$var$getValue(32968, values, cache), $0585cb639441f7d8$var$getValue(32971, values, cache), $0585cb639441f7d8$var$getValue(32970, values, cache)),
    polygonOffset: (gl, values, cache)=>gl.polygonOffset($0585cb639441f7d8$var$getValue(32824, values, cache), $0585cb639441f7d8$var$getValue(10752, values, cache)),
    sampleCoverage: (gl, values, cache)=>gl.sampleCoverage($0585cb639441f7d8$var$getValue(32938, values, cache), $0585cb639441f7d8$var$getValue(32939, values, cache)),
    stencilFuncFront: (gl, values, cache)=>gl.stencilFuncSeparate(1028, $0585cb639441f7d8$var$getValue(2962, values, cache), $0585cb639441f7d8$var$getValue(2967, values, cache), $0585cb639441f7d8$var$getValue(2963, values, cache)),
    stencilFuncBack: (gl, values, cache)=>gl.stencilFuncSeparate(1029, $0585cb639441f7d8$var$getValue(34816, values, cache), $0585cb639441f7d8$var$getValue(36003, values, cache), $0585cb639441f7d8$var$getValue(36004, values, cache)),
    stencilOpFront: (gl, values, cache)=>gl.stencilOpSeparate(1028, $0585cb639441f7d8$var$getValue(2964, values, cache), $0585cb639441f7d8$var$getValue(2965, values, cache), $0585cb639441f7d8$var$getValue(2966, values, cache)),
    stencilOpBack: (gl, values, cache)=>gl.stencilOpSeparate(1029, $0585cb639441f7d8$var$getValue(34817, values, cache), $0585cb639441f7d8$var$getValue(34818, values, cache), $0585cb639441f7d8$var$getValue(34819, values, cache))
};
const $0585cb639441f7d8$export$21a690e042a82719 = {
    enable: (update, capability)=>update({
            [capability]: true
        }),
    disable: (update, capability)=>update({
            [capability]: false
        }),
    pixelStorei: (update, pname, value)=>update({
            [pname]: value
        }),
    hint: (update, pname, hint)=>update({
            [pname]: hint
        }),
    bindFramebuffer: (update, target, framebuffer)=>{
        switch(target){
            case 36160:
                return update({
                    [36006]: framebuffer,
                    [36010]: framebuffer
                });
            case 36009:
                return update({
                    [36006]: framebuffer
                });
            case 36008:
                return update({
                    [36010]: framebuffer
                });
            default:
                return null;
        }
    },
    blendColor: (update, r, g, b, a)=>update({
            [32773]: new Float32Array([
                r,
                g,
                b,
                a
            ])
        }),
    blendEquation: (update, mode)=>update({
            [32777]: mode,
            [34877]: mode
        }),
    blendEquationSeparate: (update, modeRGB, modeAlpha)=>update({
            [32777]: modeRGB,
            [34877]: modeAlpha
        }),
    blendFunc: (update, src, dst)=>update({
            [32969]: src,
            [32968]: dst,
            [32971]: src,
            [32970]: dst
        }),
    blendFuncSeparate: (update, srcRGB, dstRGB, srcAlpha, dstAlpha)=>update({
            [32969]: srcRGB,
            [32968]: dstRGB,
            [32971]: srcAlpha,
            [32970]: dstAlpha
        }),
    clearColor: (update, r, g, b, a)=>update({
            [3106]: new Float32Array([
                r,
                g,
                b,
                a
            ])
        }),
    clearDepth: (update, depth)=>update({
            [2931]: depth
        }),
    clearStencil: (update, s)=>update({
            [2961]: s
        }),
    colorMask: (update, r, g, b, a)=>update({
            [3107]: [
                r,
                g,
                b,
                a
            ]
        }),
    cullFace: (update, mode)=>update({
            [2885]: mode
        }),
    depthFunc: (update, func)=>update({
            [2932]: func
        }),
    depthRange: (update, zNear, zFar)=>update({
            [2928]: new Float32Array([
                zNear,
                zFar
            ])
        }),
    depthMask: (update, mask)=>update({
            [2930]: mask
        }),
    frontFace: (update, face)=>update({
            [2886]: face
        }),
    lineWidth: (update, width)=>update({
            [2849]: width
        }),
    polygonOffset: (update, factor, units)=>update({
            [32824]: factor,
            [10752]: units
        }),
    sampleCoverage: (update, value, invert)=>update({
            [32938]: value,
            [32939]: invert
        }),
    scissor: (update, x, y, width, height)=>update({
            [3088]: new Int32Array([
                x,
                y,
                width,
                height
            ])
        }),
    stencilMask: (update, mask)=>update({
            [2968]: mask,
            [36005]: mask
        }),
    stencilMaskSeparate: (update, face, mask)=>update({
            [face === 1028 ? 2968 : 36005]: mask
        }),
    stencilFunc: (update, func, ref, mask)=>update({
            [2962]: func,
            [2967]: ref,
            [2963]: mask,
            [34816]: func,
            [36003]: ref,
            [36004]: mask
        }),
    stencilFuncSeparate: (update, face, func, ref, mask)=>update({
            [face === 1028 ? 2962 : 34816]: func,
            [face === 1028 ? 2967 : 36003]: ref,
            [face === 1028 ? 2963 : 36004]: mask
        }),
    stencilOp: (update, fail, zfail, zpass)=>update({
            [2964]: fail,
            [2965]: zfail,
            [2966]: zpass,
            [34817]: fail,
            [34818]: zfail,
            [34819]: zpass
        }),
    stencilOpSeparate: (update, face, fail, zfail, zpass)=>update({
            [face === 1028 ? 2964 : 34817]: fail,
            [face === 1028 ? 2965 : 34818]: zfail,
            [face === 1028 ? 2966 : 34819]: zpass
        }),
    viewport: (update, x, y, width, height)=>update({
            [2978]: [
                x,
                y,
                width,
                height
            ]
        })
};
const $0585cb639441f7d8$var$isEnabled = (gl, key)=>gl.isEnabled(key);
const $0585cb639441f7d8$export$f7e7f6f928a85334 = {
    [3042]: $0585cb639441f7d8$var$isEnabled,
    [2884]: $0585cb639441f7d8$var$isEnabled,
    [2929]: $0585cb639441f7d8$var$isEnabled,
    [3024]: $0585cb639441f7d8$var$isEnabled,
    [32823]: $0585cb639441f7d8$var$isEnabled,
    [32926]: $0585cb639441f7d8$var$isEnabled,
    [32928]: $0585cb639441f7d8$var$isEnabled,
    [3089]: $0585cb639441f7d8$var$isEnabled,
    [2960]: $0585cb639441f7d8$var$isEnabled,
    [35977]: $0585cb639441f7d8$var$isEnabled
};

});

parcelRegister("bMGK6", function(module, exports) {

$parcel$export(module.exports, "trackContextState", function () { return $89455532f443da4d$export$eda55831a64d5931; });
$parcel$export(module.exports, "pushContextState", function () { return $89455532f443da4d$export$529f9c1c84156b45; });
$parcel$export(module.exports, "popContextState", function () { return $89455532f443da4d$export$30ca4f2cb45c903e; });

var $toBvF = parcelRequire("toBvF");

var $2SJyH = parcelRequire("2SJyH");

var $bcsvz = parcelRequire("bcsvz");

var $9mLS9 = parcelRequire("9mLS9");
function $89455532f443da4d$var$installGetterOverride(gl, functionName) {
    const originalGetterFunc = gl[functionName].bind(gl);
    gl[functionName] = function get() {
        const pname = arguments.length <= 0 ? undefined : arguments[0];
        if (!(pname in gl.state.cache)) return originalGetterFunc(...arguments);
        return gl.state.enable ? gl.state.cache[pname] : originalGetterFunc(...arguments);
    };
    Object.defineProperty(gl[functionName], "name", {
        value: "".concat(functionName, "-from-cache"),
        configurable: false
    });
}
function $89455532f443da4d$var$installSetterSpy(gl, functionName, setter) {
    const originalSetterFunc = gl[functionName].bind(gl);
    gl[functionName] = function set() {
        for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++)params[_key] = arguments[_key];
        const { valueChanged: valueChanged, oldValue: oldValue } = setter(gl.state._updateCache, ...params);
        if (valueChanged) originalSetterFunc(...params);
        return oldValue;
    };
    Object.defineProperty(gl[functionName], "name", {
        value: "".concat(functionName, "-to-cache"),
        configurable: false
    });
}
function $89455532f443da4d$var$installProgramSpy(gl) {
    const originalUseProgram = gl.useProgram.bind(gl);
    gl.useProgram = function useProgramLuma(handle) {
        if (gl.state.program !== handle) {
            originalUseProgram(handle);
            gl.state.program = handle;
        }
    };
}
class $89455532f443da4d$var$GLState {
    push() {
        let values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.stateStack.push({});
    }
    pop() {
        (0, $bcsvz.assert)(this.stateStack.length > 0);
        const oldValues = this.stateStack[this.stateStack.length - 1];
        (0, $2SJyH.setParameters)(this.gl, oldValues);
        this.stateStack.pop();
    }
    _updateCache(values) {
        let valueChanged = false;
        let oldValue;
        const oldValues = this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1];
        for(const key in values){
            (0, $bcsvz.assert)(key !== undefined);
            const value = values[key];
            const cached = this.cache[key];
            if (!(0, $9mLS9.deepArrayEqual)(value, cached)) {
                valueChanged = true;
                oldValue = cached;
                if (oldValues && !(key in oldValues)) oldValues[key] = cached;
                this.cache[key] = value;
            }
        }
        return {
            valueChanged: valueChanged,
            oldValue: oldValue
        };
    }
    constructor(gl){
        let { copyState: copyState = false, log: log = ()=>{} } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.gl = gl;
        this.program = null;
        this.stateStack = [];
        this.enable = true;
        this.cache = copyState ? (0, $2SJyH.getParameters)(gl) : Object.assign({}, (0, $toBvF.GL_PARAMETER_DEFAULTS));
        this.log = log;
        this._updateCache = this._updateCache.bind(this);
        Object.seal(this);
    }
}
function $89455532f443da4d$export$eda55831a64d5931(gl) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { enable: enable = true, copyState: copyState } = options;
    (0, $bcsvz.assert)(copyState !== undefined);
    if (!gl.state) {
        const { polyfillContext: polyfillContext } = globalThis;
        if (polyfillContext) polyfillContext(gl);
        gl.state = new $89455532f443da4d$var$GLState(gl, {
            copyState: copyState
        });
        $89455532f443da4d$var$installProgramSpy(gl);
        for(const key in 0, $toBvF.GL_HOOKED_SETTERS){
            const setter = (0, $toBvF.GL_HOOKED_SETTERS)[key];
            $89455532f443da4d$var$installSetterSpy(gl, key, setter);
        }
        $89455532f443da4d$var$installGetterOverride(gl, "getParameter");
        $89455532f443da4d$var$installGetterOverride(gl, "isEnabled");
    }
    gl.state.enable = enable;
    return gl;
}
function $89455532f443da4d$export$529f9c1c84156b45(gl) {
    if (!gl.state) $89455532f443da4d$export$eda55831a64d5931(gl, {
        copyState: false
    });
    gl.state.push();
}
function $89455532f443da4d$export$30ca4f2cb45c903e(gl) {
    (0, $bcsvz.assert)(gl.state);
    gl.state.pop();
}

});
parcelRegister("9mLS9", function(module, exports) {

$parcel$export(module.exports, "isObjectEmpty", function () { return $6d1b4d9be4edfd54$export$23cfe696632d10f4; });
$parcel$export(module.exports, "deepArrayEqual", function () { return $6d1b4d9be4edfd54$export$9b55716ca87eded; });
function $6d1b4d9be4edfd54$export$23cfe696632d10f4(object) {
    for(const key in object)return false;
    return true;
}
function $6d1b4d9be4edfd54$export$9b55716ca87eded(x, y) {
    if (x === y) return true;
    const isArrayX = Array.isArray(x) || ArrayBuffer.isView(x);
    const isArrayY = Array.isArray(y) || ArrayBuffer.isView(y);
    if (isArrayX && isArrayY && x.length === y.length) {
        for(let i = 0; i < x.length; ++i){
            if (x[i] !== y[i]) return false;
        }
        return true;
    }
    return false;
}

});



parcelRegister("5k5Ga", function(module, exports) {

$parcel$export(module.exports, "createGLContext", function () { return $3e0339c659eb342d$export$a32ea65c51ffebe7; });
$parcel$export(module.exports, "instrumentGLContext", function () { return $3e0339c659eb342d$export$6b6cef073fe6a207; });
$parcel$export(module.exports, "resizeGLContext", function () { return $3e0339c659eb342d$export$4ed444b69b8944fd; });

var $jeIEj = parcelRequire("jeIEj");

var $bMGK6 = parcelRequire("bMGK6");

var $lvicK = parcelRequire("lvicK");

var $bcsvz = parcelRequire("bcsvz");

var $ieKgV = parcelRequire("ieKgV");

var $8HKWo = parcelRequire("8HKWo");
const $3e0339c659eb342d$var$isBrowser = (0, $jeIEj.default)();
const $3e0339c659eb342d$var$isPage = $3e0339c659eb342d$var$isBrowser && typeof document !== "undefined";
const $3e0339c659eb342d$var$CONTEXT_DEFAULTS = {
    webgl2: true,
    webgl1: true,
    throwOnError: true,
    manageState: true,
    canvas: null,
    debug: false,
    width: 800,
    height: 600
};
function $3e0339c659eb342d$export$a32ea65c51ffebe7() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $bcsvz.assert)($3e0339c659eb342d$var$isBrowser, "createGLContext only available in the browser.\nCreate your own headless context or use 'createHeadlessContext' from @luma.gl/test-utils");
    options = Object.assign({}, $3e0339c659eb342d$var$CONTEXT_DEFAULTS, options);
    const { width: width, height: height } = options;
    function onError(message) {
        if (options.throwOnError) throw new Error(message);
        console.error(message);
        return null;
    }
    options.onError = onError;
    let gl;
    const { canvas: canvas } = options;
    const targetCanvas = $3e0339c659eb342d$var$getCanvas({
        canvas: canvas,
        width: width,
        height: height,
        onError: onError
    });
    gl = $3e0339c659eb342d$var$createBrowserContext(targetCanvas, options);
    if (!gl) return null;
    gl = $3e0339c659eb342d$export$6b6cef073fe6a207(gl, options);
    $3e0339c659eb342d$var$logInfo(gl);
    return gl;
}
function $3e0339c659eb342d$export$6b6cef073fe6a207(gl) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!gl || gl._instrumented) return gl;
    gl._version = gl._version || $3e0339c659eb342d$var$getVersion(gl);
    gl.luma = gl.luma || {};
    gl.luma.canvasSizeInfo = gl.luma.canvasSizeInfo || {};
    options = Object.assign({}, $3e0339c659eb342d$var$CONTEXT_DEFAULTS, options);
    const { manageState: manageState, debug: debug } = options;
    if (manageState) (0, $bMGK6.trackContextState)(gl, {
        copyState: false,
        log: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $lvicK.log).log(1, ...args)();
        }
    });
    if ($3e0339c659eb342d$var$isBrowser && debug) {
        if (!globalThis.makeDebugContext) (0, $lvicK.log).warn('WebGL debug mode not activated. import "@luma.gl/debug" to enable.')();
        else {
            gl = globalThis.makeDebugContext(gl, options);
            (0, $lvicK.log).level = Math.max((0, $lvicK.log).level, 1);
        }
    }
    gl._instrumented = true;
    return gl;
}
function $3e0339c659eb342d$export$6f15ab3b829c3189(gl) {
    const vendorMasked = gl.getParameter(7936);
    const rendererMasked = gl.getParameter(7937);
    const ext = gl.getExtension("WEBGL_debug_renderer_info");
    const vendorUnmasked = ext && gl.getParameter(ext.UNMASKED_VENDOR_WEBGL || 7936);
    const rendererUnmasked = ext && gl.getParameter(ext.UNMASKED_RENDERER_WEBGL || 7937);
    return {
        vendor: vendorUnmasked || vendorMasked,
        renderer: rendererUnmasked || rendererMasked,
        vendorMasked: vendorMasked,
        rendererMasked: rendererMasked,
        version: gl.getParameter(7938),
        shadingLanguageVersion: gl.getParameter(35724)
    };
}
function $3e0339c659eb342d$export$4ed444b69b8944fd(gl) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (gl.canvas) {
        const devicePixelRatio = (0, $ieKgV.getDevicePixelRatio)(options.useDevicePixels);
        $3e0339c659eb342d$var$setDevicePixelRatio(gl, devicePixelRatio, options);
        return;
    }
    const ext = gl.getExtension("STACKGL_resize_drawingbuffer");
    if (ext && "width" in options && "height" in options) ext.resize(options.width, options.height);
}
function $3e0339c659eb342d$var$createBrowserContext(canvas, options) {
    const { onError: onError } = options;
    let errorMessage = null;
    const onCreateError = (error)=>errorMessage = error.statusMessage || errorMessage;
    canvas.addEventListener("webglcontextcreationerror", onCreateError, false);
    const { webgl1: webgl1 = true, webgl2: webgl2 = true } = options;
    let gl = null;
    if (webgl2) {
        gl = gl || canvas.getContext("webgl2", options);
        gl = gl || canvas.getContext("experimental-webgl2", options);
    }
    if (webgl1) {
        gl = gl || canvas.getContext("webgl", options);
        gl = gl || canvas.getContext("experimental-webgl", options);
    }
    canvas.removeEventListener("webglcontextcreationerror", onCreateError, false);
    if (!gl) return onError("Failed to create ".concat(webgl2 && !webgl1 ? "WebGL2" : "WebGL", " context: ").concat(errorMessage || "Unknown error"));
    if (options.onContextLost) canvas.addEventListener("webglcontextlost", options.onContextLost, false);
    if (options.onContextRestored) canvas.addEventListener("webglcontextrestored", options.onContextRestored, false);
    return gl;
}
function $3e0339c659eb342d$var$getCanvas(_ref) {
    let { canvas: canvas, width: width = 800, height: height = 600, onError: onError } = _ref;
    let targetCanvas;
    if (typeof canvas === "string") {
        const isPageLoaded = $3e0339c659eb342d$var$isPage && document.readyState === "complete";
        if (!isPageLoaded) onError("createGLContext called on canvas '".concat(canvas, "' before page was loaded"));
        targetCanvas = document.getElementById(canvas);
    } else if (canvas) targetCanvas = canvas;
    else {
        targetCanvas = document.createElement("canvas");
        targetCanvas.id = "lumagl-canvas";
        targetCanvas.style.width = Number.isFinite(width) ? "".concat(width, "px") : "100%";
        targetCanvas.style.height = Number.isFinite(height) ? "".concat(height, "px") : "100%";
        document.body.insertBefore(targetCanvas, document.body.firstChild);
    }
    return targetCanvas;
}
function $3e0339c659eb342d$var$logInfo(gl) {
    const webGL = (0, $8HKWo.isWebGL2)(gl) ? "WebGL2" : "WebGL1";
    const info = $3e0339c659eb342d$export$6f15ab3b829c3189(gl);
    const driver = info ? "(".concat(info.vendor, ",").concat(info.renderer, ")") : "";
    const debug = gl.debug ? " debug" : "";
    (0, $lvicK.log).info(1, "".concat(webGL).concat(debug, " context ").concat(driver))();
}
function $3e0339c659eb342d$var$getVersion(gl) {
    if (typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext) return 2;
    return 1;
}
function $3e0339c659eb342d$var$setDevicePixelRatio(gl, devicePixelRatio, options) {
    let clientWidth = "width" in options ? options.width : gl.canvas.clientWidth;
    let clientHeight = "height" in options ? options.height : gl.canvas.clientHeight;
    if (!clientWidth || !clientHeight) {
        (0, $lvicK.log).log(1, "Canvas clientWidth/clientHeight is 0")();
        devicePixelRatio = 1;
        clientWidth = gl.canvas.width || 1;
        clientHeight = gl.canvas.height || 1;
    }
    gl.luma = gl.luma || {};
    gl.luma.canvasSizeInfo = gl.luma.canvasSizeInfo || {};
    const cachedSize = gl.luma.canvasSizeInfo;
    if (cachedSize.clientWidth !== clientWidth || cachedSize.clientHeight !== clientHeight || cachedSize.devicePixelRatio !== devicePixelRatio) {
        let clampedPixelRatio = devicePixelRatio;
        const canvasWidth = Math.floor(clientWidth * clampedPixelRatio);
        const canvasHeight = Math.floor(clientHeight * clampedPixelRatio);
        gl.canvas.width = canvasWidth;
        gl.canvas.height = canvasHeight;
        if (gl.drawingBufferWidth !== canvasWidth || gl.drawingBufferHeight !== canvasHeight) {
            (0, $lvicK.log).warn("Device pixel ratio clamped")();
            clampedPixelRatio = Math.min(gl.drawingBufferWidth / clientWidth, gl.drawingBufferHeight / clientHeight);
            gl.canvas.width = Math.floor(clientWidth * clampedPixelRatio);
            gl.canvas.height = Math.floor(clientHeight * clampedPixelRatio);
        }
        Object.assign(gl.luma.canvasSizeInfo, {
            clientWidth: clientWidth,
            clientHeight: clientHeight,
            devicePixelRatio: devicePixelRatio
        });
    }
}

});
parcelRegister("ieKgV", function(module, exports) {

$parcel$export(module.exports, "cssToDeviceRatio", function () { return $d46d6d76d6cae6f2$export$df40057290e74703; });
$parcel$export(module.exports, "cssToDevicePixels", function () { return $d46d6d76d6cae6f2$export$af080a4e21b7825c; });
$parcel$export(module.exports, "getDevicePixelRatio", function () { return $d46d6d76d6cae6f2$export$cf4a949e5ad681d; });
function $d46d6d76d6cae6f2$export$df40057290e74703(gl) {
    const { luma: luma } = gl;
    if (gl.canvas && luma) {
        const cachedSize = luma.canvasSizeInfo;
        const clientWidth = "clientWidth" in cachedSize ? cachedSize.clientWidth : gl.canvas.clientWidth;
        return clientWidth ? gl.drawingBufferWidth / clientWidth : 1;
    }
    return 1;
}
function $d46d6d76d6cae6f2$export$af080a4e21b7825c(gl, cssPixel) {
    let yInvert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const ratio = $d46d6d76d6cae6f2$export$df40057290e74703(gl);
    const width = gl.drawingBufferWidth;
    const height = gl.drawingBufferHeight;
    return $d46d6d76d6cae6f2$var$scalePixels(cssPixel, ratio, width, height, yInvert);
}
function $d46d6d76d6cae6f2$export$cf4a949e5ad681d(useDevicePixels) {
    const windowRatio = typeof window === "undefined" ? 1 : window.devicePixelRatio || 1;
    if (Number.isFinite(useDevicePixels)) return useDevicePixels <= 0 ? 1 : useDevicePixels;
    return useDevicePixels ? windowRatio : 1;
}
function $d46d6d76d6cae6f2$var$scalePixels(pixel, ratio, width, height, yInvert) {
    const x = $d46d6d76d6cae6f2$var$scaleX(pixel[0], ratio, width);
    let y = $d46d6d76d6cae6f2$var$scaleY(pixel[1], ratio, height, yInvert);
    let t = $d46d6d76d6cae6f2$var$scaleX(pixel[0] + 1, ratio, width);
    const xHigh = t === width - 1 ? t : t - 1;
    t = $d46d6d76d6cae6f2$var$scaleY(pixel[1] + 1, ratio, height, yInvert);
    let yHigh;
    if (yInvert) {
        t = t === 0 ? t : t + 1;
        yHigh = y;
        y = t;
    } else yHigh = t === height - 1 ? t : t - 1;
    return {
        x: x,
        y: y,
        width: Math.max(xHigh - x + 1, 1),
        height: Math.max(yHigh - y + 1, 1)
    };
}
function $d46d6d76d6cae6f2$var$scaleX(x, ratio, width) {
    const r = Math.min(Math.round(x * ratio), width - 1);
    return r;
}
function $d46d6d76d6cae6f2$var$scaleY(y, ratio, height, yInvert) {
    return yInvert ? Math.max(0, height - 1 - Math.round(y * ratio)) : Math.min(Math.round(y * ratio), height - 1);
}

});



parcelRegister("jgMzF", function(module, exports) {

$parcel$export(module.exports, "lumaStats", function () { return $e07530c3d098523d$export$fb95d6e12d0fb414; });
parcelRequire("73UuK");
var $lvicK = parcelRequire("lvicK");
parcelRequire("1k2nF");
var $lL0rr = parcelRequire("lL0rr");

var $jeIEj = parcelRequire("jeIEj");
const $e07530c3d098523d$var$VERSION = "8.5.21";
const $e07530c3d098523d$var$STARTUP_MESSAGE = "set luma.log.level=1 (or higher) to trace rendering";
class $e07530c3d098523d$export$a763db1752b80c33 {
    get(name) {
        if (!this.stats.has(name)) this.stats.set(name, new (0, $lL0rr.default)({
            id: name
        }));
        return this.stats.get(name);
    }
    constructor(){
        this.stats = new Map();
    }
}
const $e07530c3d098523d$export$fb95d6e12d0fb414 = new $e07530c3d098523d$export$a763db1752b80c33();
if (globalThis.luma && globalThis.luma.VERSION !== $e07530c3d098523d$var$VERSION) throw new Error("luma.gl - multiple VERSIONs detected: ".concat(globalThis.luma.VERSION, " vs ").concat($e07530c3d098523d$var$VERSION));
if (!globalThis.luma) {
    if ((0, $jeIEj.default)()) (0, $lvicK.log).log(1, "luma.gl ".concat($e07530c3d098523d$var$VERSION, " - ").concat($e07530c3d098523d$var$STARTUP_MESSAGE))();
    globalThis.luma = globalThis.luma || {
        VERSION: $e07530c3d098523d$var$VERSION,
        version: $e07530c3d098523d$var$VERSION,
        log: $lvicK.log,
        stats: $e07530c3d098523d$export$fb95d6e12d0fb414,
        globals: {
            modules: {},
            nodeIO: {}
        }
    };
}
var $e07530c3d098523d$export$2e2bcd8739ae039 = globalThis.luma;

});
parcelRegister("1k2nF", function(module, exports) {

$parcel$export(module.exports, "Stats", function () { return (parcelRequire("lL0rr")).default; });

var $lL0rr = parcelRequire("lL0rr");

var $altPn = parcelRequire("altPn");

var $7d6hI = parcelRequire("7d6hI");

});
parcelRegister("lL0rr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd6e547550cdaf73$export$2e2bcd8739ae039; });

var $gl6YX = parcelRequire("gl6YX");

var $altPn = parcelRequire("altPn");
class $fd6e547550cdaf73$export$2e2bcd8739ae039 {
    get(name) {
        let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "count";
        return this._getOrCreate({
            name: name,
            type: type
        });
    }
    get size() {
        return Object.keys(this.stats).length;
    }
    reset() {
        for(const key in this.stats)this.stats[key].reset();
        return this;
    }
    forEach(fn) {
        for(const key in this.stats)fn(this.stats[key]);
    }
    getTable() {
        const table = {};
        this.forEach((stat)=>{
            table[stat.name] = {
                time: stat.time || 0,
                count: stat.count || 0,
                average: stat.getAverageTime() || 0,
                hz: stat.getHz() || 0
            };
        });
        return table;
    }
    _initializeStats() {
        let stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        stats.forEach((stat)=>this._getOrCreate(stat));
    }
    _getOrCreate(stat) {
        if (!stat || !stat.name) return null;
        const { name: name, type: type } = stat;
        if (!this.stats[name]) {
            if (stat instanceof (0, $altPn.default)) this.stats[name] = stat;
            else this.stats[name] = new (0, $altPn.default)(name, type);
        }
        return this.stats[name];
    }
    constructor(options){
        (0, $gl6YX.default)(this, "id", void 0);
        (0, $gl6YX.default)(this, "stats", {});
        this.id = options.id;
        this.stats = {};
        this._initializeStats(options.stats);
        Object.seal(this);
    }
}

});
parcelRegister("gl6YX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be540606661f80d5$export$2e2bcd8739ae039; });
function $be540606661f80d5$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("altPn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $788300afdbd6debc$export$2e2bcd8739ae039; });

var $gl6YX = parcelRequire("gl6YX");

var $7d6hI = parcelRequire("7d6hI");
class $788300afdbd6debc$export$2e2bcd8739ae039 {
    setSampleSize(samples) {
        this.sampleSize = samples;
        return this;
    }
    incrementCount() {
        this.addCount(1);
        return this;
    }
    decrementCount() {
        this.subtractCount(1);
        return this;
    }
    addCount(value) {
        this._count += value;
        this._samples++;
        this._checkSampling();
        return this;
    }
    subtractCount(value) {
        this._count -= value;
        this._samples++;
        this._checkSampling();
        return this;
    }
    addTime(time) {
        this._time += time;
        this.lastTiming = time;
        this._samples++;
        this._checkSampling();
        return this;
    }
    timeStart() {
        this._startTime = (0, $7d6hI.default)();
        this._timerPending = true;
        return this;
    }
    timeEnd() {
        if (!this._timerPending) return this;
        this.addTime((0, $7d6hI.default)() - this._startTime);
        this._timerPending = false;
        this._checkSampling();
        return this;
    }
    getSampleAverageCount() {
        return this.sampleSize > 0 ? this.lastSampleCount / this.sampleSize : 0;
    }
    getSampleAverageTime() {
        return this.sampleSize > 0 ? this.lastSampleTime / this.sampleSize : 0;
    }
    getSampleHz() {
        return this.lastSampleTime > 0 ? this.sampleSize / (this.lastSampleTime / 1000) : 0;
    }
    getAverageCount() {
        return this.samples > 0 ? this.count / this.samples : 0;
    }
    getAverageTime() {
        return this.samples > 0 ? this.time / this.samples : 0;
    }
    getHz() {
        return this.time > 0 ? this.samples / (this.time / 1000) : 0;
    }
    reset() {
        this.time = 0;
        this.count = 0;
        this.samples = 0;
        this.lastTiming = 0;
        this.lastSampleTime = 0;
        this.lastSampleCount = 0;
        this._count = 0;
        this._time = 0;
        this._samples = 0;
        this._startTime = 0;
        this._timerPending = false;
        return this;
    }
    _checkSampling() {
        if (this._samples === this.sampleSize) {
            this.lastSampleTime = this._time;
            this.lastSampleCount = this._count;
            this.count += this._count;
            this.time += this._time;
            this.samples += this._samples;
            this._time = 0;
            this._count = 0;
            this._samples = 0;
        }
    }
    constructor(name, type){
        (0, $gl6YX.default)(this, "name", void 0);
        (0, $gl6YX.default)(this, "type", void 0);
        (0, $gl6YX.default)(this, "sampleSize", 1);
        (0, $gl6YX.default)(this, "time", void 0);
        (0, $gl6YX.default)(this, "count", void 0);
        (0, $gl6YX.default)(this, "samples", void 0);
        (0, $gl6YX.default)(this, "lastTiming", void 0);
        (0, $gl6YX.default)(this, "lastSampleTime", void 0);
        (0, $gl6YX.default)(this, "lastSampleCount", void 0);
        (0, $gl6YX.default)(this, "_count", 0);
        (0, $gl6YX.default)(this, "_time", 0);
        (0, $gl6YX.default)(this, "_samples", 0);
        (0, $gl6YX.default)(this, "_startTime", 0);
        (0, $gl6YX.default)(this, "_timerPending", false);
        this.name = name;
        this.type = type;
        this.reset();
    }
}

});
parcelRegister("7d6hI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53fe9f535bc054c1$export$2e2bcd8739ae039; });

var $95Bnk = parcelRequire("95Bnk");
function $53fe9f535bc054c1$export$2e2bcd8739ae039() {
    let timestamp;
    if (typeof window !== "undefined" && window.performance) timestamp = window.performance.now();
    else if (typeof $95Bnk !== "undefined" && $95Bnk.hrtime) {
        const timeParts = $95Bnk.hrtime();
        timestamp = timeParts[0] * 1000 + timeParts[1] / 1e6;
    } else timestamp = Date.now();
    return timestamp;
}

});





parcelRegister("5tEaG", function(module, exports) {

$parcel$export(module.exports, "getKeyValue", function () { return $3fced25cdd798184$export$38eb86f225c9e34c; });
$parcel$export(module.exports, "getKey", function () { return $3fced25cdd798184$export$a47fb462a08de82f; });

var $ihfnu = parcelRequire("ihfnu");
function $3fced25cdd798184$export$38eb86f225c9e34c(gl, name) {
    if (typeof name !== "string") return name;
    const number = Number(name);
    if (!isNaN(number)) return number;
    name = name.replace(/^.*\./, "");
    const value = gl[name];
    (0, $ihfnu.assert)(value !== undefined, "Accessing undefined constant GL.".concat(name));
    return value;
}
function $3fced25cdd798184$export$a47fb462a08de82f(gl, value) {
    value = Number(value);
    for(const key in gl){
        if (gl[key] === value) return "GL.".concat(key);
    }
    return String(value);
}
function $3fced25cdd798184$export$7869d83d4284f7ff(gl, value) {
    (0, $ihfnu.assert)(value !== undefined, "undefined key");
    value = Number(value);
    for(const key in gl){
        if (gl[key] === value) return "GL.".concat(key);
    }
    return String(value);
}

});
parcelRegister("ihfnu", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $d4e5be436b497bef$export$a7a9523472993e97; });
function $d4e5be436b497bef$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "luma.gl: assertion failed.");
}

});


parcelRegister("iljOc", function(module, exports) {

$parcel$export(module.exports, "uid", function () { return $d5a98dc5b372788d$export$e2a22331486dcca0; });
$parcel$export(module.exports, "isPowerOfTwo", function () { return $d5a98dc5b372788d$export$b9e43d1765415474; });
$parcel$export(module.exports, "isObjectEmpty", function () { return $d5a98dc5b372788d$export$23cfe696632d10f4; });

var $ihfnu = parcelRequire("ihfnu");
const $d5a98dc5b372788d$var$uidCounters = {};
function $d5a98dc5b372788d$export$e2a22331486dcca0() {
    let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "id";
    $d5a98dc5b372788d$var$uidCounters[id] = $d5a98dc5b372788d$var$uidCounters[id] || 1;
    const count = $d5a98dc5b372788d$var$uidCounters[id]++;
    return "".concat(id, "-").concat(count);
}
function $d5a98dc5b372788d$export$b9e43d1765415474(n) {
    (0, $ihfnu.assert)(typeof n === "number", "Input must be a number");
    return n && (n & n - 1) === 0;
}
function $d5a98dc5b372788d$export$23cfe696632d10f4(obj) {
    let isEmpty = true;
    for(const key in obj){
        isEmpty = false;
        break;
    }
    return isEmpty;
}

});

parcelRegister("z6hiF", function(module, exports) {

$parcel$export(module.exports, "stubRemovedMethods", function () { return $069823af93ffba1d$export$5c9302507afeb7af; });
parcelRequire("73UuK");
var $lvicK = parcelRequire("lvicK");
function $069823af93ffba1d$export$5c9302507afeb7af(instance, className, version, methodNames) {
    const upgradeMessage = "See luma.gl ".concat(version, " Upgrade Guide at https://luma.gl/docs/upgrade-guide");
    const prototype = Object.getPrototypeOf(instance);
    methodNames.forEach((methodName)=>{
        if (prototype.methodName) return;
        prototype[methodName] = ()=>{
            (0, $lvicK.log).removed("Calling removed method ".concat(className, ".").concat(methodName, ": "), upgradeMessage)();
            throw new Error(methodName);
        };
    });
}

});


parcelRegister("35tVQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23f90e979a9ad2ad$export$2e2bcd8739ae039; });

var $3qgcG = parcelRequire("3qgcG");

var $ihfnu = parcelRequire("ihfnu");

var $JOkCq = parcelRequire("JOkCq");
const $23f90e979a9ad2ad$export$e62d85e07017bac6 = {
    offset: 0,
    stride: 0,
    type: 5126,
    size: 1,
    divisor: 0,
    normalized: false,
    integer: false
};
const $23f90e979a9ad2ad$var$PROP_CHECKS = {
    deprecatedProps: {
        instanced: "divisor",
        isInstanced: "divisor"
    }
};
class $23f90e979a9ad2ad$export$2e2bcd8739ae039 {
    static getBytesPerElement(accessor) {
        const ArrayType = (0, $3qgcG.getTypedArrayFromGLType)(accessor.type || 5126);
        return ArrayType.BYTES_PER_ELEMENT;
    }
    static getBytesPerVertex(accessor) {
        (0, $ihfnu.assert)(accessor.size);
        const ArrayType = (0, $3qgcG.getTypedArrayFromGLType)(accessor.type || 5126);
        return ArrayType.BYTES_PER_ELEMENT * accessor.size;
    }
    static resolve() {
        for(var _len = arguments.length, accessors = new Array(_len), _key = 0; _key < _len; _key++)accessors[_key] = arguments[_key];
        return new $23f90e979a9ad2ad$export$2e2bcd8739ae039(...[
            $23f90e979a9ad2ad$export$e62d85e07017bac6,
            ...accessors
        ]);
    }
    toString() {
        return JSON.stringify(this);
    }
    get BYTES_PER_ELEMENT() {
        return $23f90e979a9ad2ad$export$2e2bcd8739ae039.getBytesPerElement(this);
    }
    get BYTES_PER_VERTEX() {
        return $23f90e979a9ad2ad$export$2e2bcd8739ae039.getBytesPerVertex(this);
    }
    _assign() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        props = (0, $JOkCq.checkProps)("Accessor", props, $23f90e979a9ad2ad$var$PROP_CHECKS);
        if (props.type !== undefined) {
            this.type = props.type;
            if (props.type === 5124 || props.type === 5125) this.integer = true;
        }
        if (props.size !== undefined) this.size = props.size;
        if (props.offset !== undefined) this.offset = props.offset;
        if (props.stride !== undefined) this.stride = props.stride;
        if (props.normalized !== undefined) this.normalized = props.normalized;
        if (props.integer !== undefined) this.integer = props.integer;
        if (props.divisor !== undefined) this.divisor = props.divisor;
        if (props.buffer !== undefined) this.buffer = props.buffer;
        if (props.index !== undefined) {
            if (typeof props.index === "boolean") this.index = props.index ? 1 : 0;
            else this.index = props.index;
        }
        if (props.instanced !== undefined) this.divisor = props.instanced ? 1 : 0;
        if (props.isInstanced !== undefined) this.divisor = props.isInstanced ? 1 : 0;
        return this;
    }
    constructor(){
        for(var _len2 = arguments.length, accessors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)accessors[_key2] = arguments[_key2];
        accessors.forEach((accessor)=>this._assign(accessor));
        Object.freeze(this);
    }
}

});
parcelRegister("3qgcG", function(module, exports) {

$parcel$export(module.exports, "getGLTypeFromTypedArray", function () { return $27e05e80a26d6fa2$export$127239b7f8a5750f; });
$parcel$export(module.exports, "getTypedArrayFromGLType", function () { return $27e05e80a26d6fa2$export$9619a05b47814a85; });
$parcel$export(module.exports, "flipRows", function () { return $27e05e80a26d6fa2$export$2478197380c2212f; });
$parcel$export(module.exports, "scalePixels", function () { return $27e05e80a26d6fa2$export$b405024b493a473f; });
const $27e05e80a26d6fa2$var$ERR_TYPE_DEDUCTION = "Failed to deduce GL constant from typed array";
function $27e05e80a26d6fa2$export$127239b7f8a5750f(arrayOrType) {
    const type = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
    switch(type){
        case Float32Array:
            return 5126;
        case Uint16Array:
            return 5123;
        case Uint32Array:
            return 5125;
        case Uint8Array:
            return 5121;
        case Uint8ClampedArray:
            return 5121;
        case Int8Array:
            return 5120;
        case Int16Array:
            return 5122;
        case Int32Array:
            return 5124;
        default:
            throw new Error($27e05e80a26d6fa2$var$ERR_TYPE_DEDUCTION);
    }
}
function $27e05e80a26d6fa2$export$9619a05b47814a85(glType) {
    let { clamped: clamped = true } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    switch(glType){
        case 5126:
            return Float32Array;
        case 5123:
        case 33635:
        case 32819:
        case 32820:
            return Uint16Array;
        case 5125:
            return Uint32Array;
        case 5121:
            return clamped ? Uint8ClampedArray : Uint8Array;
        case 5120:
            return Int8Array;
        case 5122:
            return Int16Array;
        case 5124:
            return Int32Array;
        default:
            throw new Error("Failed to deduce typed array type from GL constant");
    }
}
function $27e05e80a26d6fa2$export$2478197380c2212f(_ref) {
    let { data: data, width: width, height: height, bytesPerPixel: bytesPerPixel = 4, temp: temp } = _ref;
    const bytesPerRow = width * bytesPerPixel;
    temp = temp || new Uint8Array(bytesPerRow);
    for(let y = 0; y < height / 2; ++y){
        const topOffset = y * bytesPerRow;
        const bottomOffset = (height - y - 1) * bytesPerRow;
        temp.set(data.subarray(topOffset, topOffset + bytesPerRow));
        data.copyWithin(topOffset, bottomOffset, bottomOffset + bytesPerRow);
        data.set(temp, bottomOffset);
    }
}
function $27e05e80a26d6fa2$export$b405024b493a473f(_ref2) {
    let { data: data, width: width, height: height } = _ref2;
    const newWidth = Math.round(width / 2);
    const newHeight = Math.round(height / 2);
    const newData = new Uint8Array(newWidth * newHeight * 4);
    for(let y = 0; y < newHeight; y++){
        for(let x = 0; x < newWidth; x++)for(let c = 0; c < 4; c++)newData[(y * newWidth + x) * 4 + c] = data[(y * 2 * width + x * 2) * 4 + c];
    }
    return {
        data: newData,
        width: newWidth,
        height: newHeight
    };
}

});

parcelRegister("JOkCq", function(module, exports) {

$parcel$export(module.exports, "checkProps", function () { return $089b3ee21949ce18$export$aac163a490409890; });
parcelRequire("73UuK");
var $lvicK = parcelRequire("lvicK");
function $089b3ee21949ce18$export$aac163a490409890(className, props, propChecks) {
    const { removedProps: removedProps = {}, deprecatedProps: deprecatedProps = {}, replacedProps: replacedProps = {} } = propChecks;
    for(const propName in removedProps)if (propName in props) {
        const replacementProp = removedProps[propName];
        const replacement = replacementProp ? "".concat(className, ".").concat(removedProps[propName]) : "N/A";
        (0, $lvicK.log).removed("".concat(className, ".").concat(propName), replacement)();
    }
    for(const propName in deprecatedProps)if (propName in props) {
        const replacementProp = deprecatedProps[propName];
        (0, $lvicK.log).deprecated("".concat(className, ".").concat(propName), "".concat(className, ".").concat(replacementProp))();
    }
    let newProps = null;
    for(const propName in replacedProps)if (propName in props) {
        const replacementProp = replacedProps[propName];
        (0, $lvicK.log).deprecated("".concat(className, ".").concat(propName), "".concat(className, ".").concat(replacementProp))();
        newProps = newProps || Object.assign({}, props);
        newProps[replacementProp] = props[propName];
        delete newProps[propName];
    }
    return newProps || props;
}

});



parcelRegister("68aPy", function(module, exports) {

$parcel$export(module.exports, "FEATURES", function () { return $476be425cead1097$export$d6a5c11f04f75862; });
$parcel$export(module.exports, "default", function () { return $476be425cead1097$export$2e2bcd8739ae039; });

var $cJo7e = parcelRequire("cJo7e");

var $7lUAH = parcelRequire("7lUAH");
const $476be425cead1097$export$d6a5c11f04f75862 = {
    WEBGL2: "WEBGL2",
    VERTEX_ARRAY_OBJECT: "VERTEX_ARRAY_OBJECT",
    TIMER_QUERY: "TIMER_QUERY",
    INSTANCED_RENDERING: "INSTANCED_RENDERING",
    MULTIPLE_RENDER_TARGETS: "MULTIPLE_RENDER_TARGETS",
    ELEMENT_INDEX_UINT32: "ELEMENT_INDEX_UINT32",
    BLEND_EQUATION_MINMAX: "BLEND_EQUATION_MINMAX",
    FLOAT_BLEND: "FLOAT_BLEND",
    COLOR_ENCODING_SRGB: "COLOR_ENCODING_SRGB",
    TEXTURE_DEPTH: "TEXTURE_DEPTH",
    TEXTURE_FLOAT: "TEXTURE_FLOAT",
    TEXTURE_HALF_FLOAT: "TEXTURE_HALF_FLOAT",
    TEXTURE_FILTER_LINEAR_FLOAT: "TEXTURE_FILTER_LINEAR_FLOAT",
    TEXTURE_FILTER_LINEAR_HALF_FLOAT: "TEXTURE_FILTER_LINEAR_HALF_FLOAT",
    TEXTURE_FILTER_ANISOTROPIC: "TEXTURE_FILTER_ANISOTROPIC",
    COLOR_ATTACHMENT_RGBA32F: "COLOR_ATTACHMENT_RGBA32F",
    COLOR_ATTACHMENT_FLOAT: "COLOR_ATTACHMENT_FLOAT",
    COLOR_ATTACHMENT_HALF_FLOAT: "COLOR_ATTACHMENT_HALF_FLOAT",
    GLSL_FRAG_DATA: "GLSL_FRAG_DATA",
    GLSL_FRAG_DEPTH: "GLSL_FRAG_DEPTH",
    GLSL_DERIVATIVES: "GLSL_DERIVATIVES",
    GLSL_TEXTURE_LOD: "GLSL_TEXTURE_LOD"
};
function $476be425cead1097$var$checkFloat32ColorAttachment(gl) {
    const testTexture = new (0, $7lUAH.default)(gl, {
        format: 6408,
        type: 5126,
        dataFormat: 6408
    });
    const testFb = new (0, $cJo7e.default)(gl, {
        id: "test-framebuffer",
        check: false,
        attachments: {
            [36064]: testTexture
        }
    });
    const status = testFb.getStatus();
    testTexture.delete();
    testFb.delete();
    return status === 36053;
}
var $476be425cead1097$export$2e2bcd8739ae039 = {
    [$476be425cead1097$export$d6a5c11f04f75862.WEBGL2]: [
        false,
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.VERTEX_ARRAY_OBJECT]: [
        "OES_vertex_array_object",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.TIMER_QUERY]: [
        "EXT_disjoint_timer_query",
        "EXT_disjoint_timer_query_webgl2"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.INSTANCED_RENDERING]: [
        "ANGLE_instanced_arrays",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.MULTIPLE_RENDER_TARGETS]: [
        "WEBGL_draw_buffers",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.ELEMENT_INDEX_UINT32]: [
        "OES_element_index_uint",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.BLEND_EQUATION_MINMAX]: [
        "EXT_blend_minmax",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.FLOAT_BLEND]: [
        "EXT_float_blend"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.COLOR_ENCODING_SRGB]: [
        "EXT_sRGB",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.TEXTURE_DEPTH]: [
        "WEBGL_depth_texture",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.TEXTURE_FLOAT]: [
        "OES_texture_float",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.TEXTURE_HALF_FLOAT]: [
        "OES_texture_half_float",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.TEXTURE_FILTER_LINEAR_FLOAT]: [
        "OES_texture_float_linear"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.TEXTURE_FILTER_LINEAR_HALF_FLOAT]: [
        "OES_texture_half_float_linear"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.TEXTURE_FILTER_ANISOTROPIC]: [
        "EXT_texture_filter_anisotropic"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.COLOR_ATTACHMENT_RGBA32F]: [
        $476be425cead1097$var$checkFloat32ColorAttachment,
        "EXT_color_buffer_float"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.COLOR_ATTACHMENT_FLOAT]: [
        false,
        "EXT_color_buffer_float"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.COLOR_ATTACHMENT_HALF_FLOAT]: [
        "EXT_color_buffer_half_float"
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.GLSL_FRAG_DATA]: [
        "WEBGL_draw_buffers",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.GLSL_FRAG_DEPTH]: [
        "EXT_frag_depth",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.GLSL_DERIVATIVES]: [
        "OES_standard_derivatives",
        true
    ],
    [$476be425cead1097$export$d6a5c11f04f75862.GLSL_TEXTURE_LOD]: [
        "EXT_shader_texture_lod",
        true
    ]
};

});
parcelRegister("cJo7e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $944c64e126d39361$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");

var $1OVow = parcelRequire("1OVow");

var $7lUAH = parcelRequire("7lUAH");

var $8BnKG = parcelRequire("8BnKG");

var $eU1YY = parcelRequire("eU1YY");

var $2YUMm = parcelRequire("2YUMm");

var $tIWfJ = parcelRequire("tIWfJ");

var $5tEaG = parcelRequire("5tEaG");

var $ihfnu = parcelRequire("ihfnu");
const $944c64e126d39361$var$ERR_MULTIPLE_RENDERTARGETS = "Multiple render targets not supported";
class $944c64e126d39361$export$2e2bcd8739ae039 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "Framebuffer";
    }
    static isSupported(gl) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const { colorBufferFloat: colorBufferFloat, colorBufferHalfFloat: colorBufferHalfFloat } = options;
        let supported = true;
        if (colorBufferFloat) supported = Boolean(gl.getExtension("EXT_color_buffer_float") || gl.getExtension("WEBGL_color_buffer_float") || gl.getExtension("OES_texture_float"));
        if (colorBufferHalfFloat) supported = supported && Boolean(gl.getExtension("EXT_color_buffer_float") || gl.getExtension("EXT_color_buffer_half_float"));
        return supported;
    }
    static getDefaultFramebuffer(gl) {
        gl.luma = gl.luma || {};
        gl.luma.defaultFramebuffer = gl.luma.defaultFramebuffer || new $944c64e126d39361$export$2e2bcd8739ae039(gl, {
            id: "default-framebuffer",
            handle: null,
            attachments: {}
        });
        return gl.luma.defaultFramebuffer;
    }
    get MAX_COLOR_ATTACHMENTS() {
        const gl2 = (0, $8HKWo.assertWebGL2Context)(this.gl);
        return gl2.getParameter(gl2.MAX_COLOR_ATTACHMENTS);
    }
    get MAX_DRAW_BUFFERS() {
        const gl2 = (0, $8HKWo.assertWebGL2Context)(this.gl);
        return gl2.getParameter(gl2.MAX_DRAW_BUFFERS);
    }
    get color() {
        return this.attachments[36064] || null;
    }
    get texture() {
        return this.attachments[36064] || null;
    }
    get depth() {
        return this.attachments[36096] || this.attachments[33306] || null;
    }
    get stencil() {
        return this.attachments[36128] || this.attachments[33306] || null;
    }
    initialize(_ref) {
        let { width: width = 1, height: height = 1, attachments: attachments = null, color: color = true, depth: depth = true, stencil: stencil = false, check: check = true, readBuffer: readBuffer, drawBuffers: drawBuffers } = _ref;
        (0, $ihfnu.assert)(width >= 0 && height >= 0, "Width and height need to be integers");
        this.width = width;
        this.height = height;
        if (attachments) for(const attachment in attachments){
            const target = attachments[attachment];
            const object = Array.isArray(target) ? target[0] : target;
            object.resize({
                width: width,
                height: height
            });
        }
        else attachments = this._createDefaultAttachments(color, depth, stencil, width, height);
        this.update({
            clearAttachments: true,
            attachments: attachments,
            readBuffer: readBuffer,
            drawBuffers: drawBuffers
        });
        if (attachments && check) this.checkStatus();
    }
    delete() {
        for (const resource of this.ownResources)resource.delete();
        super.delete();
        return this;
    }
    update(_ref2) {
        let { attachments: attachments = {}, readBuffer: readBuffer, drawBuffers: drawBuffers, clearAttachments: clearAttachments = false, resizeAttachments: resizeAttachments = true } = _ref2;
        this.attach(attachments, {
            clearAttachments: clearAttachments,
            resizeAttachments: resizeAttachments
        });
        const { gl: gl } = this;
        const prevHandle = gl.bindFramebuffer(36160, this.handle);
        if (readBuffer) this._setReadBuffer(readBuffer);
        if (drawBuffers) this._setDrawBuffers(drawBuffers);
        gl.bindFramebuffer(36160, prevHandle || null);
        return this;
    }
    resize() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let { width: width, height: height } = options;
        if (this.handle === null) {
            (0, $ihfnu.assert)(width === undefined && height === undefined);
            this.width = this.gl.drawingBufferWidth;
            this.height = this.gl.drawingBufferHeight;
            return this;
        }
        if (width === undefined) width = this.gl.drawingBufferWidth;
        if (height === undefined) height = this.gl.drawingBufferHeight;
        if (width !== this.width && height !== this.height) (0, $lvicK.log).log(2, "Resizing framebuffer ".concat(this.id, " to ").concat(width, "x").concat(height))();
        for(const attachmentPoint in this.attachments)this.attachments[attachmentPoint].resize({
            width: width,
            height: height
        });
        this.width = width;
        this.height = height;
        return this;
    }
    attach(attachments) {
        let { clearAttachments: clearAttachments = false, resizeAttachments: resizeAttachments = true } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const newAttachments = {};
        if (clearAttachments) Object.keys(this.attachments).forEach((key)=>{
            newAttachments[key] = null;
        });
        Object.assign(newAttachments, attachments);
        const prevHandle = this.gl.bindFramebuffer(36160, this.handle);
        for(const key in newAttachments){
            (0, $ihfnu.assert)(key !== undefined, "Misspelled framebuffer binding point?");
            const attachment = Number(key);
            const descriptor = newAttachments[attachment];
            let object = descriptor;
            if (!object) this._unattach(attachment);
            else if (object instanceof (0, $8BnKG.default)) this._attachRenderbuffer({
                attachment: attachment,
                renderbuffer: object
            });
            else if (Array.isArray(descriptor)) {
                const [texture, layer = 0, level = 0] = descriptor;
                object = texture;
                this._attachTexture({
                    attachment: attachment,
                    texture: texture,
                    layer: layer,
                    level: level
                });
            } else this._attachTexture({
                attachment: attachment,
                texture: object,
                layer: 0,
                level: 0
            });
            if (resizeAttachments && object) object.resize({
                width: this.width,
                height: this.height
            });
        }
        this.gl.bindFramebuffer(36160, prevHandle || null);
        Object.assign(this.attachments, attachments);
        Object.keys(this.attachments).filter((key)=>!this.attachments[key]).forEach((key)=>{
            delete this.attachments[key];
        });
    }
    checkStatus() {
        const { gl: gl } = this;
        const status = this.getStatus();
        if (status !== 36053) throw new Error($944c64e126d39361$var$_getFrameBufferStatus(status));
        return this;
    }
    getStatus() {
        const { gl: gl } = this;
        const prevHandle = gl.bindFramebuffer(36160, this.handle);
        const status = gl.checkFramebufferStatus(36160);
        gl.bindFramebuffer(36160, prevHandle || null);
        return status;
    }
    clear() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { color: color, depth: depth, stencil: stencil, drawBuffers: drawBuffers = [] } = options;
        const prevHandle = this.gl.bindFramebuffer(36160, this.handle);
        if (color || depth || stencil) (0, $eU1YY.clear)(this.gl, {
            color: color,
            depth: depth,
            stencil: stencil
        });
        drawBuffers.forEach((value, drawBuffer)=>{
            (0, $eU1YY.clearBuffer)(this.gl, {
                drawBuffer: drawBuffer,
                value: value
            });
        });
        this.gl.bindFramebuffer(36160, prevHandle || null);
        return this;
    }
    readPixels() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).error("Framebuffer.readPixels() is no logner supported, use readPixelsToArray(framebuffer)")();
        return null;
    }
    readPixelsToBuffer() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).error("Framebuffer.readPixelsToBuffer()is no logner supported, use readPixelsToBuffer(framebuffer)")();
        return null;
    }
    copyToDataUrl() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).error("Framebuffer.copyToDataUrl() is no logner supported, use copyToDataUrl(framebuffer)")();
        return null;
    }
    copyToImage() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).error("Framebuffer.copyToImage() is no logner supported, use copyToImage(framebuffer)")();
        return null;
    }
    copyToTexture() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).error("Framebuffer.copyToTexture({...}) is no logner supported, use copyToTexture(source, target, opts})")();
        return null;
    }
    blit() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).error("Framebuffer.blit({...}) is no logner supported, use blit(source, target, opts)")();
        return null;
    }
    invalidate(_ref3) {
        let { attachments: attachments = [], x: x = 0, y: y = 0, width: width, height: height } = _ref3;
        const gl2 = (0, $8HKWo.assertWebGL2Context)(this.gl);
        const prevHandle = gl2.bindFramebuffer(36008, this.handle);
        const invalidateAll = x === 0 && y === 0 && width === undefined && height === undefined;
        if (invalidateAll) gl2.invalidateFramebuffer(36008, attachments);
        else gl2.invalidateFramebuffer(36008, attachments, x, y, width, height);
        gl2.bindFramebuffer(36008, prevHandle);
        return this;
    }
    getAttachmentParameter(attachment, pname, keys) {
        let value = this._getAttachmentParameterFallback(pname);
        if (value === null) {
            this.gl.bindFramebuffer(36160, this.handle);
            value = this.gl.getFramebufferAttachmentParameter(36160, attachment, pname);
            this.gl.bindFramebuffer(36160, null);
        }
        if (keys && value > 1000) value = (0, $5tEaG.getKey)(this.gl, value);
        return value;
    }
    getAttachmentParameters() {
        let attachment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 36064;
        let keys = arguments.length > 1 ? arguments[1] : undefined;
        let parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.constructor.ATTACHMENT_PARAMETERS || [];
        const values = {};
        for (const pname of parameters){
            const key = keys ? (0, $5tEaG.getKey)(this.gl, pname) : pname;
            values[key] = this.getAttachmentParameter(attachment, pname, keys);
        }
        return values;
    }
    getParameters() {
        let keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        const attachments = Object.keys(this.attachments);
        const parameters = {};
        for (const attachmentName of attachments){
            const attachment = Number(attachmentName);
            const key = keys ? (0, $5tEaG.getKey)(this.gl, attachment) : attachment;
            parameters[key] = this.getAttachmentParameters(attachment, keys);
        }
        return parameters;
    }
    show() {
        if (typeof window !== "undefined") window.open((0, $2YUMm.copyToDataUrl)(this), "luma-debug-texture");
        return this;
    }
    log() {
        let logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        if (logLevel > (0, $lvicK.log).level || typeof window === "undefined") return this;
        message = message || "Framebuffer ".concat(this.id);
        const image = (0, $2YUMm.copyToDataUrl)(this, {
            targetMaxHeight: 100
        });
        (0, $lvicK.log).image({
            logLevel: logLevel,
            message: message,
            image: image
        }, message)();
        return this;
    }
    bind() {
        let { target: target = 36160 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.gl.bindFramebuffer(target, this.handle);
        return this;
    }
    unbind() {
        let { target: target = 36160 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.gl.bindFramebuffer(target, null);
        return this;
    }
    _createDefaultAttachments(color, depth, stencil, width, height) {
        let defaultAttachments = null;
        if (color) {
            defaultAttachments = defaultAttachments || {};
            defaultAttachments[36064] = new (0, $7lUAH.default)(this.gl, {
                id: "".concat(this.id, "-color0"),
                pixels: null,
                format: 6408,
                type: 5121,
                width: width,
                height: height,
                mipmaps: false,
                parameters: {
                    [10241]: 9729,
                    [10240]: 9729,
                    [10242]: 33071,
                    [10243]: 33071
                }
            });
            this.ownResources.push(defaultAttachments[36064]);
        }
        if (depth && stencil) {
            defaultAttachments = defaultAttachments || {};
            defaultAttachments[33306] = new (0, $8BnKG.default)(this.gl, {
                id: "".concat(this.id, "-depth-stencil"),
                format: 35056,
                width: width,
                height: 111
            });
            this.ownResources.push(defaultAttachments[33306]);
        } else if (depth) {
            defaultAttachments = defaultAttachments || {};
            defaultAttachments[36096] = new (0, $8BnKG.default)(this.gl, {
                id: "".concat(this.id, "-depth"),
                format: 33189,
                width: width,
                height: height
            });
            this.ownResources.push(defaultAttachments[36096]);
        } else if (stencil) (0, $ihfnu.assert)(false);
        return defaultAttachments;
    }
    _unattach(attachment) {
        const oldAttachment = this.attachments[attachment];
        if (!oldAttachment) return;
        if (oldAttachment instanceof (0, $8BnKG.default)) this.gl.framebufferRenderbuffer(36160, attachment, 36161, null);
        else this.gl.framebufferTexture2D(36160, attachment, 3553, null, 0);
        delete this.attachments[attachment];
    }
    _attachRenderbuffer(_ref4) {
        let { attachment: attachment = 36064, renderbuffer: renderbuffer } = _ref4;
        const { gl: gl } = this;
        gl.framebufferRenderbuffer(36160, attachment, 36161, renderbuffer.handle);
        this.attachments[attachment] = renderbuffer;
    }
    _attachTexture(_ref5) {
        let { attachment: attachment = 36064, texture: texture, layer: layer, level: level } = _ref5;
        const { gl: gl } = this;
        gl.bindTexture(texture.target, texture.handle);
        switch(texture.target){
            case 35866:
            case 32879:
                const gl2 = (0, $8HKWo.assertWebGL2Context)(gl);
                gl2.framebufferTextureLayer(36160, attachment, texture.target, level, layer);
                break;
            case 34067:
                const face = $944c64e126d39361$var$mapIndexToCubeMapFace(layer);
                gl.framebufferTexture2D(36160, attachment, face, texture.handle, level);
                break;
            case 3553:
                gl.framebufferTexture2D(36160, attachment, 3553, texture.handle, level);
                break;
            default:
                (0, $ihfnu.assert)(false, "Illegal texture type");
        }
        gl.bindTexture(texture.target, null);
        this.attachments[attachment] = texture;
    }
    _setReadBuffer(readBuffer) {
        const gl2 = (0, $8HKWo.getWebGL2Context)(this.gl);
        if (gl2) gl2.readBuffer(readBuffer);
        else (0, $ihfnu.assert)(readBuffer === 36064 || readBuffer === 1029, $944c64e126d39361$var$ERR_MULTIPLE_RENDERTARGETS);
        this.readBuffer = readBuffer;
    }
    _setDrawBuffers(drawBuffers) {
        const { gl: gl } = this;
        const gl2 = (0, $8HKWo.assertWebGL2Context)(gl);
        if (gl2) gl2.drawBuffers(drawBuffers);
        else {
            const ext = gl.getExtension("WEBGL_draw_buffers");
            if (ext) ext.drawBuffersWEBGL(drawBuffers);
            else (0, $ihfnu.assert)(drawBuffers.length === 1 && (drawBuffers[0] === 36064 || drawBuffers[0] === 1029), $944c64e126d39361$var$ERR_MULTIPLE_RENDERTARGETS);
        }
        this.drawBuffers = drawBuffers;
    }
    _getAttachmentParameterFallback(pname) {
        const caps = (0, $tIWfJ.getFeatures)(this.gl);
        switch(pname){
            case 36052:
                return !caps.WEBGL2 ? 0 : null;
            case 33298:
            case 33299:
            case 33300:
            case 33301:
            case 33302:
            case 33303:
                return !caps.WEBGL2 ? 8 : null;
            case 33297:
                return !caps.WEBGL2 ? 5125 : null;
            case 33296:
                return !caps.WEBGL2 && !caps.EXT_sRGB ? 9729 : null;
            default:
                return null;
        }
    }
    _createHandle() {
        return this.gl.createFramebuffer();
    }
    _deleteHandle() {
        this.gl.deleteFramebuffer(this.handle);
    }
    _bindHandle(handle) {
        return this.gl.bindFramebuffer(36160, handle);
    }
    constructor(gl){
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(gl, opts);
        this.width = null;
        this.height = null;
        this.attachments = {};
        this.readBuffer = 36064;
        this.drawBuffers = [
            36064
        ];
        this.ownResources = [];
        this.initialize(opts);
        Object.seal(this);
    }
}
function $944c64e126d39361$var$mapIndexToCubeMapFace(layer) {
    return layer < 34069 ? layer + 34069 : layer;
}
function $944c64e126d39361$var$_getFrameBufferStatus(status) {
    const STATUS = $944c64e126d39361$export$2e2bcd8739ae039.STATUS || {};
    return STATUS[status] || "Framebuffer error ".concat(status);
}
const $944c64e126d39361$export$9bc39e54f49ae5f4 = [
    36049,
    36048,
    33296,
    33298,
    33299,
    33300,
    33301,
    33302,
    33303
];
$944c64e126d39361$export$2e2bcd8739ae039.ATTACHMENT_PARAMETERS = $944c64e126d39361$export$9bc39e54f49ae5f4;

});
parcelRegister("7lUAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a6645961bd6b5f$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $3D9dM = parcelRequire("3D9dM");

var $eBf4K = parcelRequire("eBf4K");
class $55a6645961bd6b5f$export$2e2bcd8739ae039 extends (0, $3D9dM.default) {
    get [Symbol.toStringTag]() {
        return "Texture2D";
    }
    static isSupported(gl, opts) {
        return (0, $3D9dM.default).isSupported(gl, opts);
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $8HKWo.assertWebGLContext)(gl);
        if (props instanceof Promise || typeof props === "string") props = {
            data: props
        };
        if (typeof props.data === "string") props = Object.assign({}, props, {
            data: (0, $eBf4K.loadImage)(props.data)
        });
        super(gl, Object.assign({}, props, {
            target: 3553
        }));
        this.initialize(props);
        Object.seal(this);
    }
}

});
parcelRegister("3D9dM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a4c2ac8f73a57aa$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");
var $2SJyH = parcelRequire("2SJyH");

var $1OVow = parcelRequire("1OVow");

var $7jraD = parcelRequire("7jraD");

var $du43m = parcelRequire("du43m");

var $ihfnu = parcelRequire("ihfnu");

var $iljOc = parcelRequire("iljOc");
const $2a4c2ac8f73a57aa$var$NPOT_MIN_FILTERS = [
    9729,
    9728
];
const $2a4c2ac8f73a57aa$var$WebGLBuffer = globalThis.WebGLBuffer || function WebGLBuffer() {};
class $2a4c2ac8f73a57aa$export$2e2bcd8739ae039 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "Texture";
    }
    static isSupported(gl) {
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const { format: format, linearFiltering: linearFiltering } = opts;
        let supported = true;
        if (format) {
            supported = supported && (0, $du43m.isFormatSupported)(gl, format);
            supported = supported && (!linearFiltering || (0, $du43m.isLinearFilteringSupported)(gl, format));
        }
        return supported;
    }
    toString() {
        return "Texture(".concat(this.id, ",").concat(this.width, "x").concat(this.height, ")");
    }
    initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let data = props.data;
        if (data instanceof Promise) {
            data.then((resolvedImageData)=>this.initialize(Object.assign({}, props, {
                    pixels: resolvedImageData,
                    data: resolvedImageData
                })));
            return this;
        }
        const isVideo = typeof HTMLVideoElement !== "undefined" && data instanceof HTMLVideoElement;
        if (isVideo && data.readyState < HTMLVideoElement.HAVE_METADATA) {
            this._video = null;
            data.addEventListener("loadeddata", ()=>this.initialize(props));
            return this;
        }
        const { pixels: pixels = null, format: format = 6408, border: border = 0, recreate: recreate = false, parameters: parameters = {}, pixelStore: pixelStore = {}, textureUnit: textureUnit } = props;
        if (!data) data = pixels;
        let { width: width, height: height, dataFormat: dataFormat, type: type, compressed: compressed = false, mipmaps: mipmaps = true } = props;
        const { depth: depth = 0 } = props;
        ({ width: width, height: height, compressed: compressed, dataFormat: dataFormat, type: type } = this._deduceParameters({
            format: format,
            type: type,
            dataFormat: dataFormat,
            compressed: compressed,
            data: data,
            width: width,
            height: height
        }));
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.format = format;
        this.type = type;
        this.dataFormat = dataFormat;
        this.border = border;
        this.textureUnit = textureUnit;
        if (Number.isFinite(this.textureUnit)) {
            this.gl.activeTexture(33984 + this.textureUnit);
            this.gl.bindTexture(this.target, this.handle);
        }
        if (mipmaps && this._isNPOT()) {
            (0, $lvicK.log).warn("texture: ".concat(this, " is Non-Power-Of-Two, disabling mipmaping"))();
            mipmaps = false;
            this._updateForNPOT(parameters);
        }
        this.mipmaps = mipmaps;
        this.setImageData({
            data: data,
            width: width,
            height: height,
            depth: depth,
            format: format,
            type: type,
            dataFormat: dataFormat,
            border: border,
            mipmaps: mipmaps,
            parameters: pixelStore,
            compressed: compressed
        });
        if (mipmaps) this.generateMipmap();
        this.setParameters(parameters);
        if (recreate) this.data = data;
        if (isVideo) this._video = {
            video: data,
            parameters: parameters,
            lastTime: data.readyState >= HTMLVideoElement.HAVE_CURRENT_DATA ? data.currentTime : -1
        };
        return this;
    }
    update() {
        if (this._video) {
            const { video: video, parameters: parameters, lastTime: lastTime } = this._video;
            if (lastTime === video.currentTime || video.readyState < HTMLVideoElement.HAVE_CURRENT_DATA) return;
            this.setSubImageData({
                data: video,
                parameters: parameters
            });
            if (this.mipmaps) this.generateMipmap();
            this._video.lastTime = video.currentTime;
        }
    }
    resize(_ref) {
        let { height: height, width: width, mipmaps: mipmaps = false } = _ref;
        if (width !== this.width || height !== this.height) return this.initialize({
            width: width,
            height: height,
            format: this.format,
            type: this.type,
            dataFormat: this.dataFormat,
            border: this.border,
            mipmaps: mipmaps
        });
        return this;
    }
    generateMipmap() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this._isNPOT()) {
            (0, $lvicK.log).warn("texture: ".concat(this, " is Non-Power-Of-Two, disabling mipmaping"))();
            return this;
        }
        this.mipmaps = true;
        this.gl.bindTexture(this.target, this.handle);
        (0, $2SJyH.withParameters)(this.gl, params, ()=>{
            this.gl.generateMipmap(this.target);
        });
        this.gl.bindTexture(this.target, null);
        return this;
    }
    setImageData(options) {
        this._trackDeallocatedMemory("Texture");
        const { target: target = this.target, pixels: pixels = null, level: level = 0, format: format = this.format, border: border = this.border, offset: offset = 0, parameters: parameters = {} } = options;
        let { data: data = null, type: type = this.type, width: width = this.width, height: height = this.height, dataFormat: dataFormat = this.dataFormat, compressed: compressed = false } = options;
        if (!data) data = pixels;
        ({ type: type, dataFormat: dataFormat, compressed: compressed, width: width, height: height } = this._deduceParameters({
            format: format,
            type: type,
            dataFormat: dataFormat,
            compressed: compressed,
            data: data,
            width: width,
            height: height
        }));
        const { gl: gl } = this;
        gl.bindTexture(this.target, this.handle);
        let dataType = null;
        ({ data: data, dataType: dataType } = this._getDataType({
            data: data,
            compressed: compressed
        }));
        let gl2;
        let compressedTextureSize = 0;
        (0, $2SJyH.withParameters)(this.gl, parameters, ()=>{
            switch(dataType){
                case "null":
                    gl.texImage2D(target, level, format, width, height, border, dataFormat, type, data);
                    break;
                case "typed-array":
                    gl.texImage2D(target, level, format, width, height, border, dataFormat, type, data, offset);
                    break;
                case "buffer":
                    gl2 = (0, $8HKWo.assertWebGL2Context)(gl);
                    gl2.bindBuffer(35052, data.handle || data);
                    gl2.texImage2D(target, level, format, width, height, border, dataFormat, type, offset);
                    gl2.bindBuffer(35052, null);
                    break;
                case "browser-object":
                    if ((0, $8HKWo.isWebGL2)(gl)) gl.texImage2D(target, level, format, width, height, border, dataFormat, type, data);
                    else gl.texImage2D(target, level, format, dataFormat, type, data);
                    break;
                case "compressed":
                    for (const [levelIndex, levelData] of data.entries()){
                        gl.compressedTexImage2D(target, levelIndex, levelData.format, levelData.width, levelData.height, border, levelData.data);
                        compressedTextureSize += levelData.levelSize;
                    }
                    break;
                default:
                    (0, $ihfnu.assert)(false, "Unknown image data type");
            }
        });
        if (dataType === "compressed") this._trackAllocatedMemory(compressedTextureSize, "Texture");
        else if (data && data.byteLength) this._trackAllocatedMemory(data.byteLength, "Texture");
        else {
            const channels = (0, $du43m.DATA_FORMAT_CHANNELS)[this.dataFormat] || 4;
            const channelSize = (0, $du43m.TYPE_SIZES)[this.type] || 1;
            this._trackAllocatedMemory(this.width * this.height * channels * channelSize, "Texture");
        }
        this.loaded = true;
        return this;
    }
    setSubImageData(_ref2) {
        let { target: target = this.target, pixels: pixels = null, data: data = null, x: x = 0, y: y = 0, width: width = this.width, height: height = this.height, level: level = 0, format: format = this.format, type: type = this.type, dataFormat: dataFormat = this.dataFormat, compressed: compressed = false, offset: offset = 0, border: border = this.border, parameters: parameters = {} } = _ref2;
        ({ type: type, dataFormat: dataFormat, compressed: compressed, width: width, height: height } = this._deduceParameters({
            format: format,
            type: type,
            dataFormat: dataFormat,
            compressed: compressed,
            data: data,
            width: width,
            height: height
        }));
        (0, $ihfnu.assert)(this.depth === 0, "texSubImage not supported for 3D textures");
        if (!data) data = pixels;
        if (data && data.data) {
            const ndarray = data;
            data = ndarray.data;
            width = ndarray.shape[0];
            height = ndarray.shape[1];
        }
        if (data instanceof (0, $7jraD.default)) data = data.handle;
        this.gl.bindTexture(this.target, this.handle);
        (0, $2SJyH.withParameters)(this.gl, parameters, ()=>{
            if (compressed) this.gl.compressedTexSubImage2D(target, level, x, y, width, height, format, data);
            else if (data === null) this.gl.texSubImage2D(target, level, x, y, width, height, dataFormat, type, null);
            else if (ArrayBuffer.isView(data)) this.gl.texSubImage2D(target, level, x, y, width, height, dataFormat, type, data, offset);
            else if (data instanceof $2a4c2ac8f73a57aa$var$WebGLBuffer) {
                const gl2 = (0, $8HKWo.assertWebGL2Context)(this.gl);
                gl2.bindBuffer(35052, data);
                gl2.texSubImage2D(target, level, x, y, width, height, dataFormat, type, offset);
                gl2.bindBuffer(35052, null);
            } else if ((0, $8HKWo.isWebGL2)(this.gl)) {
                const gl2 = (0, $8HKWo.assertWebGL2Context)(this.gl);
                gl2.texSubImage2D(target, level, x, y, width, height, dataFormat, type, data);
            } else this.gl.texSubImage2D(target, level, x, y, dataFormat, type, data);
        });
        this.gl.bindTexture(this.target, null);
    }
    copyFramebuffer() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).error("Texture.copyFramebuffer({...}) is no logner supported, use copyToTexture(source, target, opts})")();
        return null;
    }
    getActiveUnit() {
        return this.gl.getParameter(34016) - 33984;
    }
    bind() {
        let textureUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.textureUnit;
        const { gl: gl } = this;
        if (textureUnit !== undefined) {
            this.textureUnit = textureUnit;
            gl.activeTexture(33984 + textureUnit);
        }
        gl.bindTexture(this.target, this.handle);
        return textureUnit;
    }
    unbind() {
        let textureUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.textureUnit;
        const { gl: gl } = this;
        if (textureUnit !== undefined) {
            this.textureUnit = textureUnit;
            gl.activeTexture(33984 + textureUnit);
        }
        gl.bindTexture(this.target, null);
        return textureUnit;
    }
    _getDataType(_ref3) {
        let { data: data, compressed: compressed = false } = _ref3;
        if (compressed) return {
            data: data,
            dataType: "compressed"
        };
        if (data === null) return {
            data: data,
            dataType: "null"
        };
        if (ArrayBuffer.isView(data)) return {
            data: data,
            dataType: "typed-array"
        };
        if (data instanceof (0, $7jraD.default)) return {
            data: data.handle,
            dataType: "buffer"
        };
        if (data instanceof $2a4c2ac8f73a57aa$var$WebGLBuffer) return {
            data: data,
            dataType: "buffer"
        };
        return {
            data: data,
            dataType: "browser-object"
        };
    }
    _deduceParameters(opts) {
        const { format: format, data: data } = opts;
        let { width: width, height: height, dataFormat: dataFormat, type: type, compressed: compressed } = opts;
        const textureFormat = (0, $du43m.TEXTURE_FORMATS)[format];
        dataFormat = dataFormat || textureFormat && textureFormat.dataFormat;
        type = type || textureFormat && textureFormat.types[0];
        compressed = compressed || textureFormat && textureFormat.compressed;
        ({ width: width, height: height } = this._deduceImageSize(data, width, height));
        return {
            dataFormat: dataFormat,
            type: type,
            compressed: compressed,
            width: width,
            height: height,
            format: format,
            data: data
        };
    }
    _deduceImageSize(data, width, height) {
        let size;
        if (typeof ImageData !== "undefined" && data instanceof ImageData) size = {
            width: data.width,
            height: data.height
        };
        else if (typeof HTMLImageElement !== "undefined" && data instanceof HTMLImageElement) size = {
            width: data.naturalWidth,
            height: data.naturalHeight
        };
        else if (typeof HTMLCanvasElement !== "undefined" && data instanceof HTMLCanvasElement) size = {
            width: data.width,
            height: data.height
        };
        else if (typeof ImageBitmap !== "undefined" && data instanceof ImageBitmap) size = {
            width: data.width,
            height: data.height
        };
        else if (typeof HTMLVideoElement !== "undefined" && data instanceof HTMLVideoElement) size = {
            width: data.videoWidth,
            height: data.videoHeight
        };
        else if (!data) size = {
            width: width >= 0 ? width : 1,
            height: height >= 0 ? height : 1
        };
        else size = {
            width: width,
            height: height
        };
        (0, $ihfnu.assert)(size, "Could not deduced texture size");
        (0, $ihfnu.assert)(width === undefined || size.width === width, "Deduced texture width does not match supplied width");
        (0, $ihfnu.assert)(height === undefined || size.height === height, "Deduced texture height does not match supplied height");
        return size;
    }
    _createHandle() {
        return this.gl.createTexture();
    }
    _deleteHandle() {
        this.gl.deleteTexture(this.handle);
        this._trackDeallocatedMemory("Texture");
    }
    _getParameter(pname) {
        switch(pname){
            case 4096:
                return this.width;
            case 4097:
                return this.height;
            default:
                this.gl.bindTexture(this.target, this.handle);
                const value = this.gl.getTexParameter(this.target, pname);
                this.gl.bindTexture(this.target, null);
                return value;
        }
    }
    _setParameter(pname, param) {
        this.gl.bindTexture(this.target, this.handle);
        param = this._getNPOTParam(pname, param);
        switch(pname){
            case 33082:
            case 33083:
                this.gl.texParameterf(this.handle, pname, param);
                break;
            case 4096:
            case 4097:
                (0, $ihfnu.assert)(false);
                break;
            default:
                this.gl.texParameteri(this.target, pname, param);
                break;
        }
        this.gl.bindTexture(this.target, null);
        return this;
    }
    _isNPOT() {
        if ((0, $8HKWo.isWebGL2)(this.gl)) return false;
        if (!this.width || !this.height) return false;
        return !(0, $iljOc.isPowerOfTwo)(this.width) || !(0, $iljOc.isPowerOfTwo)(this.height);
    }
    _updateForNPOT(parameters) {
        if (parameters[this.gl.TEXTURE_MIN_FILTER] === undefined) parameters[this.gl.TEXTURE_MIN_FILTER] = this.gl.LINEAR;
        if (parameters[this.gl.TEXTURE_WRAP_S] === undefined) parameters[this.gl.TEXTURE_WRAP_S] = this.gl.CLAMP_TO_EDGE;
        if (parameters[this.gl.TEXTURE_WRAP_T] === undefined) parameters[this.gl.TEXTURE_WRAP_T] = this.gl.CLAMP_TO_EDGE;
    }
    _getNPOTParam(pname, param) {
        if (this._isNPOT()) switch(pname){
            case 10241:
                if ($2a4c2ac8f73a57aa$var$NPOT_MIN_FILTERS.indexOf(param) === -1) param = 9729;
                break;
            case 10242:
            case 10243:
                if (param !== 33071) param = 33071;
                break;
            default:
                break;
        }
        return param;
    }
    constructor(gl, props){
        const { id: id = (0, $iljOc.uid)("texture"), handle: handle, target: target } = props;
        super(gl, {
            id: id,
            handle: handle
        });
        this.target = target;
        this.textureUnit = undefined;
        this.loaded = false;
        this.width = undefined;
        this.height = undefined;
        this.depth = undefined;
        this.format = undefined;
        this.type = undefined;
        this.dataFormat = undefined;
        this.border = undefined;
        this.textureUnit = undefined;
        this.mipmaps = undefined;
    }
}

});
parcelRegister("du43m", function(module, exports) {

$parcel$export(module.exports, "TEXTURE_FORMATS", function () { return $9d11389670c040da$export$ff6ccd50a74e6c72; });
$parcel$export(module.exports, "DATA_FORMAT_CHANNELS", function () { return $9d11389670c040da$export$1b400e62d2e54950; });
$parcel$export(module.exports, "TYPE_SIZES", function () { return $9d11389670c040da$export$9acf869cba30dad8; });
$parcel$export(module.exports, "isFormatSupported", function () { return $9d11389670c040da$export$a3bf67278d0a9114; });
$parcel$export(module.exports, "isLinearFilteringSupported", function () { return $9d11389670c040da$export$769628e6c078fe4c; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
const $9d11389670c040da$export$ff6ccd50a74e6c72 = {
    [6407]: {
        dataFormat: 6407,
        types: [
            5121,
            33635
        ]
    },
    [6408]: {
        dataFormat: 6408,
        types: [
            5121,
            32819,
            32820
        ]
    },
    [6406]: {
        dataFormat: 6406,
        types: [
            5121
        ]
    },
    [6409]: {
        dataFormat: 6409,
        types: [
            5121
        ]
    },
    [6410]: {
        dataFormat: 6410,
        types: [
            5121
        ]
    },
    [33326]: {
        dataFormat: 6403,
        types: [
            5126
        ],
        gl2: true
    },
    [33328]: {
        dataFormat: 33319,
        types: [
            5126
        ],
        gl2: true
    },
    [34837]: {
        dataFormat: 6407,
        types: [
            5126
        ],
        gl2: true
    },
    [34836]: {
        dataFormat: 6408,
        types: [
            5126
        ],
        gl2: true
    }
};
const $9d11389670c040da$export$1b400e62d2e54950 = {
    [6403]: 1,
    [36244]: 1,
    [33319]: 2,
    [33320]: 2,
    [6407]: 3,
    [36248]: 3,
    [6408]: 4,
    [36249]: 4,
    [6402]: 1,
    [34041]: 1,
    [6406]: 1,
    [6409]: 1,
    [6410]: 2
};
const $9d11389670c040da$export$9acf869cba30dad8 = {
    [5126]: 4,
    [5125]: 4,
    [5124]: 4,
    [5123]: 2,
    [5122]: 2,
    [5131]: 2,
    [5120]: 1,
    [5121]: 1
};
function $9d11389670c040da$export$a3bf67278d0a9114(gl, format) {
    const info = $9d11389670c040da$export$ff6ccd50a74e6c72[format];
    if (!info) return false;
    if (info.gl1 === undefined && info.gl2 === undefined) return true;
    const value = (0, $8HKWo.isWebGL2)(gl) ? info.gl2 || info.gl1 : info.gl1;
    return typeof value === "string" ? gl.getExtension(value) : value;
}
function $9d11389670c040da$export$769628e6c078fe4c(gl, format) {
    const info = $9d11389670c040da$export$ff6ccd50a74e6c72[format];
    switch(info && info.types[0]){
        case 5126:
            return gl.getExtension("OES_texture_float_linear");
        case 5131:
            return gl.getExtension("OES_texture_half_float_linear");
        default:
            return true;
    }
}

});


parcelRegister("eBf4K", function(module, exports) {

$parcel$export(module.exports, "loadImage", function () { return $aa10370fb4b27f8d$export$fe58198efe02b173; });

var $ihfnu = parcelRequire("ihfnu");
let $aa10370fb4b27f8d$var$pathPrefix = "";
function $aa10370fb4b27f8d$export$fa7cbeea6a0f8cd3(prefix) {
    $aa10370fb4b27f8d$var$pathPrefix = prefix;
}
function $aa10370fb4b27f8d$export$3ae43cdaeb063d33(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $ihfnu.assert)(typeof url === "string");
    url = $aa10370fb4b27f8d$var$pathPrefix + url;
    const dataType = options.dataType || "text";
    return fetch(url, options).then((res)=>res[dataType]());
}
function $aa10370fb4b27f8d$export$fe58198efe02b173(url, opts) {
    (0, $ihfnu.assert)(typeof url === "string");
    url = $aa10370fb4b27f8d$var$pathPrefix + url;
    return new Promise((resolve, reject)=>{
        try {
            const image = new Image();
            image.onload = ()=>resolve(image);
            image.onerror = ()=>reject(new Error("Could not load image ".concat(url, ".")));
            image.crossOrigin = opts && opts.crossOrigin || "anonymous";
            image.src = url;
        } catch (error) {
            reject(error);
        }
    });
}

});


parcelRegister("8BnKG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $643434194291d291$export$2e2bcd8739ae039; });

var $1OVow = parcelRequire("1OVow");

var $6zfWK = parcelRequire("6zfWK");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $ihfnu = parcelRequire("ihfnu");
function $643434194291d291$var$isFormatSupported(gl, format, formats) {
    const info = formats[format];
    if (!info) return false;
    const value = (0, $8HKWo.isWebGL2)(gl) ? info.gl2 || info.gl1 : info.gl1;
    if (typeof value === "string") return gl.getExtension(value);
    return value;
}
class $643434194291d291$export$2e2bcd8739ae039 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "Renderbuffer";
    }
    static isSupported(gl) {
        let { format: format } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            format: null
        };
        return !format || $643434194291d291$var$isFormatSupported(gl, format, (0, $6zfWK.default));
    }
    static getSamplesForFormat(gl, _ref) {
        let { format: format } = _ref;
        return gl.getInternalformatParameter(36161, format, 32937);
    }
    initialize(_ref2) {
        let { format: format, width: width = 1, height: height = 1, samples: samples = 0 } = _ref2;
        (0, $ihfnu.assert)(format, "Needs format");
        this._trackDeallocatedMemory();
        this.gl.bindRenderbuffer(36161, this.handle);
        if (samples !== 0 && (0, $8HKWo.isWebGL2)(this.gl)) this.gl.renderbufferStorageMultisample(36161, samples, format, width, height);
        else this.gl.renderbufferStorage(36161, format, width, height);
        this.format = format;
        this.width = width;
        this.height = height;
        this.samples = samples;
        this._trackAllocatedMemory(this.width * this.height * (this.samples || 1) * (0, $6zfWK.default)[this.format].bpp);
        return this;
    }
    resize(_ref3) {
        let { width: width, height: height } = _ref3;
        if (width !== this.width || height !== this.height) return this.initialize({
            width: width,
            height: height,
            format: this.format,
            samples: this.samples
        });
        return this;
    }
    _createHandle() {
        return this.gl.createRenderbuffer();
    }
    _deleteHandle() {
        this.gl.deleteRenderbuffer(this.handle);
        this._trackDeallocatedMemory();
    }
    _bindHandle(handle) {
        this.gl.bindRenderbuffer(36161, handle);
    }
    _syncHandle(handle) {
        this.format = this.getParameter(36164);
        this.width = this.getParameter(36162);
        this.height = this.getParameter(36163);
        this.samples = this.getParameter(36011);
    }
    _getParameter(pname) {
        this.gl.bindRenderbuffer(36161, this.handle);
        const value = this.gl.getRenderbufferParameter(36161, pname);
        return value;
    }
    constructor(gl){
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(gl, opts);
        this.initialize(opts);
        Object.seal(this);
    }
}

});
parcelRegister("6zfWK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c82619a65c6c17b$export$2e2bcd8739ae039; });
const $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2 = "EXT_color_buffer_float";
var $4c82619a65c6c17b$export$2e2bcd8739ae039 = {
    [33189]: {
        bpp: 2
    },
    [33190]: {
        gl2: true,
        bpp: 3
    },
    [36012]: {
        gl2: true,
        bpp: 4
    },
    [36168]: {
        bpp: 1
    },
    [34041]: {
        bpp: 4
    },
    [35056]: {
        gl2: true,
        bpp: 4
    },
    [36013]: {
        gl2: true,
        bpp: 5
    },
    [32854]: {
        bpp: 2
    },
    [36194]: {
        bpp: 2
    },
    [32855]: {
        bpp: 2
    },
    [33321]: {
        gl2: true,
        bpp: 1
    },
    [33330]: {
        gl2: true,
        bpp: 1
    },
    [33329]: {
        gl2: true,
        bpp: 1
    },
    [33332]: {
        gl2: true,
        bpp: 2
    },
    [33331]: {
        gl2: true,
        bpp: 2
    },
    [33334]: {
        gl2: true,
        bpp: 4
    },
    [33333]: {
        gl2: true,
        bpp: 4
    },
    [33323]: {
        gl2: true,
        bpp: 2
    },
    [33336]: {
        gl2: true,
        bpp: 2
    },
    [33335]: {
        gl2: true,
        bpp: 2
    },
    [33338]: {
        gl2: true,
        bpp: 4
    },
    [33337]: {
        gl2: true,
        bpp: 4
    },
    [33340]: {
        gl2: true,
        bpp: 8
    },
    [33339]: {
        gl2: true,
        bpp: 8
    },
    [32849]: {
        gl2: true,
        bpp: 3
    },
    [32856]: {
        gl2: true,
        bpp: 4
    },
    [32857]: {
        gl2: true,
        bpp: 4
    },
    [36220]: {
        gl2: true,
        bpp: 4
    },
    [36238]: {
        gl2: true,
        bpp: 4
    },
    [36975]: {
        gl2: true,
        bpp: 4
    },
    [36214]: {
        gl2: true,
        bpp: 8
    },
    [36232]: {
        gl2: true,
        bpp: 8
    },
    [36226]: {
        gl2: true,
        bpp: 16
    },
    [36208]: {
        gl2: true,
        bpp: 16
    },
    [33325]: {
        gl2: $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2,
        bpp: 2
    },
    [33327]: {
        gl2: $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2,
        bpp: 4
    },
    [34842]: {
        gl2: $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2,
        bpp: 8
    },
    [33326]: {
        gl2: $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2,
        bpp: 4
    },
    [33328]: {
        gl2: $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2,
        bpp: 8
    },
    [34836]: {
        gl2: $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2,
        bpp: 16
    },
    [35898]: {
        gl2: $4c82619a65c6c17b$var$EXT_FLOAT_WEBGL2,
        bpp: 4
    }
};

});


parcelRegister("eU1YY", function(module, exports) {

$parcel$export(module.exports, "clear", function () { return $ad97d555949684fb$export$42ffd38884aecdac; });
$parcel$export(module.exports, "clearBuffer", function () { return $ad97d555949684fb$export$abb0b37bc9255c0e; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $2SJyH = parcelRequire("2SJyH");

var $ihfnu = parcelRequire("ihfnu");
const $ad97d555949684fb$var$GL_DEPTH_BUFFER_BIT = 0x00000100;
const $ad97d555949684fb$var$GL_STENCIL_BUFFER_BIT = 0x00000400;
const $ad97d555949684fb$var$GL_COLOR_BUFFER_BIT = 0x00004000;
const $ad97d555949684fb$var$GL_COLOR = 0x1800;
const $ad97d555949684fb$var$GL_DEPTH = 0x1801;
const $ad97d555949684fb$var$GL_STENCIL = 0x1802;
const $ad97d555949684fb$var$GL_DEPTH_STENCIL = 0x84f9;
const $ad97d555949684fb$var$ERR_ARGUMENTS = "clear: bad arguments";
function $ad97d555949684fb$export$42ffd38884aecdac(gl) {
    let { framebuffer: framebuffer = null, color: color = null, depth: depth = null, stencil: stencil = null } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const parameters = {};
    if (framebuffer) parameters.framebuffer = framebuffer;
    let clearFlags = 0;
    if (color) {
        clearFlags |= $ad97d555949684fb$var$GL_COLOR_BUFFER_BIT;
        if (color !== true) parameters.clearColor = color;
    }
    if (depth) {
        clearFlags |= $ad97d555949684fb$var$GL_DEPTH_BUFFER_BIT;
        if (depth !== true) parameters.clearDepth = depth;
    }
    if (stencil) {
        clearFlags |= $ad97d555949684fb$var$GL_STENCIL_BUFFER_BIT;
        if (depth !== true) parameters.clearStencil = depth;
    }
    (0, $ihfnu.assert)(clearFlags !== 0, $ad97d555949684fb$var$ERR_ARGUMENTS);
    (0, $2SJyH.withParameters)(gl, parameters, ()=>{
        gl.clear(clearFlags);
    });
}
function $ad97d555949684fb$export$abb0b37bc9255c0e(gl) {
    let { framebuffer: framebuffer = null, buffer: buffer = $ad97d555949684fb$var$GL_COLOR, drawBuffer: drawBuffer = 0, value: value = [
        0,
        0,
        0,
        0
    ] } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $8HKWo.assertWebGL2Context)(gl);
    (0, $2SJyH.withParameters)(gl, {
        framebuffer: framebuffer
    }, ()=>{
        switch(buffer){
            case $ad97d555949684fb$var$GL_COLOR:
                switch(value.constructor){
                    case Int32Array:
                        gl.clearBufferiv(buffer, drawBuffer, value);
                        break;
                    case Uint32Array:
                        gl.clearBufferuiv(buffer, drawBuffer, value);
                        break;
                    case Float32Array:
                    default:
                        gl.clearBufferfv(buffer, drawBuffer, value);
                }
                break;
            case $ad97d555949684fb$var$GL_DEPTH:
                gl.clearBufferfv($ad97d555949684fb$var$GL_DEPTH, 0, [
                    value
                ]);
                break;
            case $ad97d555949684fb$var$GL_STENCIL:
                gl.clearBufferiv($ad97d555949684fb$var$GL_STENCIL, 0, [
                    value
                ]);
                break;
            case $ad97d555949684fb$var$GL_DEPTH_STENCIL:
                const [depth, stencil] = value;
                gl.clearBufferfi($ad97d555949684fb$var$GL_DEPTH_STENCIL, 0, depth, stencil);
                break;
            default:
                (0, $ihfnu.assert)(false, $ad97d555949684fb$var$ERR_ARGUMENTS);
        }
    });
}

});

parcelRegister("2YUMm", function(module, exports) {

$parcel$export(module.exports, "readPixelsToArray", function () { return $22bd3a789d744ed1$export$f9f2f48e7f9faaa5; });
$parcel$export(module.exports, "copyToDataUrl", function () { return $22bd3a789d744ed1$export$310e97e05f1c81cc; });
$parcel$export(module.exports, "copyToTexture", function () { return $22bd3a789d744ed1$export$45ef68203138b6b0; });

var $7jraD = parcelRequire("7jraD");

var $cJo7e = parcelRequire("cJo7e");

var $3D9dM = parcelRequire("3D9dM");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");
var $2SJyH = parcelRequire("2SJyH");

var $3qgcG = parcelRequire("3qgcG");

var $b54ct = parcelRequire("b54ct");

var $dwgJf = parcelRequire("dwgJf");

var $ihfnu = parcelRequire("ihfnu");
function $22bd3a789d744ed1$export$f9f2f48e7f9faaa5(source) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { sourceX: sourceX = 0, sourceY: sourceY = 0, sourceFormat: sourceFormat = 6408 } = options;
    let { sourceAttachment: sourceAttachment = 36064, target: target = null, sourceWidth: sourceWidth, sourceHeight: sourceHeight, sourceType: sourceType } = options;
    const { framebuffer: framebuffer, deleteFramebuffer: deleteFramebuffer } = $22bd3a789d744ed1$var$getFramebuffer(source);
    (0, $ihfnu.assert)(framebuffer);
    const { gl: gl, handle: handle, attachments: attachments } = framebuffer;
    sourceWidth = sourceWidth || framebuffer.width;
    sourceHeight = sourceHeight || framebuffer.height;
    if (sourceAttachment === 36064 && handle === null) sourceAttachment = 1028;
    (0, $ihfnu.assert)(attachments[sourceAttachment]);
    sourceType = sourceType || attachments[sourceAttachment].type;
    target = $22bd3a789d744ed1$var$getPixelArray(target, sourceType, sourceFormat, sourceWidth, sourceHeight);
    sourceType = sourceType || (0, $3qgcG.getGLTypeFromTypedArray)(target);
    const prevHandle = gl.bindFramebuffer(36160, handle);
    gl.readPixels(sourceX, sourceY, sourceWidth, sourceHeight, sourceFormat, sourceType, target);
    gl.bindFramebuffer(36160, prevHandle || null);
    if (deleteFramebuffer) framebuffer.delete();
    return target;
}
function $22bd3a789d744ed1$export$c063f9191f0d5b03(source, _ref) {
    let { sourceX: sourceX = 0, sourceY: sourceY = 0, sourceFormat: sourceFormat = 6408, target: target = null, targetByteOffset: targetByteOffset = 0, sourceWidth: sourceWidth, sourceHeight: sourceHeight, sourceType: sourceType } = _ref;
    const { framebuffer: framebuffer, deleteFramebuffer: deleteFramebuffer } = $22bd3a789d744ed1$var$getFramebuffer(source);
    (0, $ihfnu.assert)(framebuffer);
    sourceWidth = sourceWidth || framebuffer.width;
    sourceHeight = sourceHeight || framebuffer.height;
    const gl2 = (0, $8HKWo.assertWebGL2Context)(framebuffer.gl);
    sourceType = sourceType || (target ? target.type : 5121);
    if (!target) {
        const components = (0, $b54ct.glFormatToComponents)(sourceFormat);
        const byteCount = (0, $b54ct.glTypeToBytes)(sourceType);
        const byteLength = targetByteOffset + sourceWidth * sourceHeight * components * byteCount;
        target = new (0, $7jraD.default)(gl2, {
            byteLength: byteLength,
            accessor: {
                type: sourceType,
                size: components
            }
        });
    }
    target.bind({
        target: 35051
    });
    (0, $2SJyH.withParameters)(gl2, {
        framebuffer: framebuffer
    }, ()=>{
        gl2.readPixels(sourceX, sourceY, sourceWidth, sourceHeight, sourceFormat, sourceType, targetByteOffset);
    });
    target.unbind({
        target: 35051
    });
    if (deleteFramebuffer) framebuffer.delete();
    return target;
}
function $22bd3a789d744ed1$export$310e97e05f1c81cc(source) {
    let { sourceAttachment: sourceAttachment = 36064, targetMaxHeight: targetMaxHeight = Number.MAX_SAFE_INTEGER } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let data = $22bd3a789d744ed1$export$f9f2f48e7f9faaa5(source, {
        sourceAttachment: sourceAttachment
    });
    let { width: width, height: height } = source;
    while(height > targetMaxHeight)({ data: data, width: width, height: height } = (0, $3qgcG.scalePixels)({
        data: data,
        width: width,
        height: height
    }));
    (0, $3qgcG.flipRows)({
        data: data,
        width: width,
        height: height
    });
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    const imageData = context.createImageData(width, height);
    imageData.data.set(data);
    context.putImageData(imageData, 0, 0);
    return canvas.toDataURL();
}
function $22bd3a789d744ed1$export$d848cd44c7a9b314(source) {
    let { sourceAttachment: sourceAttachment = 36064, targetImage: targetImage = null } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const dataUrl = $22bd3a789d744ed1$export$310e97e05f1c81cc(source, {
        sourceAttachment: sourceAttachment
    });
    targetImage = targetImage || new Image();
    targetImage.src = dataUrl;
    return targetImage;
}
function $22bd3a789d744ed1$export$45ef68203138b6b0(source, target) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { sourceX: sourceX = 0, sourceY: sourceY = 0, targetMipmaplevel: targetMipmaplevel = 0, targetInternalFormat: targetInternalFormat = 6408 } = options;
    let { targetX: targetX, targetY: targetY, targetZ: targetZ, width: width, height: height } = options;
    const { framebuffer: framebuffer, deleteFramebuffer: deleteFramebuffer } = $22bd3a789d744ed1$var$getFramebuffer(source);
    (0, $ihfnu.assert)(framebuffer);
    const { gl: gl, handle: handle } = framebuffer;
    const isSubCopy = typeof targetX !== "undefined" || typeof targetY !== "undefined" || typeof targetZ !== "undefined";
    targetX = targetX || 0;
    targetY = targetY || 0;
    targetZ = targetZ || 0;
    const prevHandle = gl.bindFramebuffer(36160, handle);
    (0, $ihfnu.assert)(target);
    let texture = null;
    if (target instanceof (0, $3D9dM.default)) {
        texture = target;
        width = Number.isFinite(width) ? width : texture.width;
        height = Number.isFinite(height) ? height : texture.height;
        texture.bind(0);
        target = texture.target;
    }
    if (!isSubCopy) gl.copyTexImage2D(target, targetMipmaplevel, targetInternalFormat, sourceX, sourceY, width, height, 0);
    else switch(target){
        case 3553:
        case 34067:
            gl.copyTexSubImage2D(target, targetMipmaplevel, targetX, targetY, sourceX, sourceY, width, height);
            break;
        case 35866:
        case 32879:
            const gl2 = (0, $8HKWo.assertWebGL2Context)(gl);
            gl2.copyTexSubImage3D(target, targetMipmaplevel, targetX, targetY, targetZ, sourceX, sourceY, width, height);
            break;
        default:
    }
    if (texture) texture.unbind();
    gl.bindFramebuffer(36160, prevHandle || null);
    if (deleteFramebuffer) framebuffer.delete();
    return texture;
}
function $22bd3a789d744ed1$export$1b8713e12f56ba52(source, target) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { sourceX0: sourceX0 = 0, sourceY0: sourceY0 = 0, targetX0: targetX0 = 0, targetY0: targetY0 = 0, color: color = true, depth: depth = false, stencil: stencil = false, filter: filter = 9728 } = options;
    let { sourceX1: sourceX1, sourceY1: sourceY1, targetX1: targetX1, targetY1: targetY1, sourceAttachment: sourceAttachment = 36064, mask: mask = 0 } = options;
    const { framebuffer: srcFramebuffer, deleteFramebuffer: deleteSrcFramebuffer } = $22bd3a789d744ed1$var$getFramebuffer(source);
    const { framebuffer: dstFramebuffer, deleteFramebuffer: deleteDstFramebuffer } = $22bd3a789d744ed1$var$getFramebuffer(target);
    (0, $ihfnu.assert)(srcFramebuffer);
    (0, $ihfnu.assert)(dstFramebuffer);
    const { gl: gl, handle: handle, width: width, height: height, readBuffer: readBuffer } = dstFramebuffer;
    const gl2 = (0, $8HKWo.assertWebGL2Context)(gl);
    if (!srcFramebuffer.handle && sourceAttachment === 36064) sourceAttachment = 1028;
    if (color) mask |= 16384;
    if (depth) mask |= 256;
    if (stencil) mask |= 1024;
    if (deleteSrcFramebuffer || deleteDstFramebuffer) {
        if (mask & 1280) {
            mask = 16384;
            (0, $lvicK.log).warn("Blitting from or into a Texture object, forcing mask to GL.COLOR_BUFFER_BIT")();
        }
    }
    (0, $ihfnu.assert)(mask);
    sourceX1 = sourceX1 === undefined ? srcFramebuffer.width : sourceX1;
    sourceY1 = sourceY1 === undefined ? srcFramebuffer.height : sourceY1;
    targetX1 = targetX1 === undefined ? width : targetX1;
    targetY1 = targetY1 === undefined ? height : targetY1;
    const prevDrawHandle = gl.bindFramebuffer(36009, handle);
    const prevReadHandle = gl.bindFramebuffer(36008, srcFramebuffer.handle);
    gl2.readBuffer(sourceAttachment);
    gl2.blitFramebuffer(sourceX0, sourceY0, sourceX1, sourceY1, targetX0, targetY0, targetX1, targetY1, mask, filter);
    gl2.readBuffer(readBuffer);
    gl2.bindFramebuffer(36008, prevReadHandle || null);
    gl2.bindFramebuffer(36009, prevDrawHandle || null);
    if (deleteSrcFramebuffer) srcFramebuffer.delete();
    if (deleteDstFramebuffer) dstFramebuffer.delete();
    return dstFramebuffer;
}
function $22bd3a789d744ed1$var$getFramebuffer(source) {
    if (!(source instanceof (0, $cJo7e.default))) return {
        framebuffer: (0, $dwgJf.toFramebuffer)(source),
        deleteFramebuffer: true
    };
    return {
        framebuffer: source,
        deleteFramebuffer: false
    };
}
function $22bd3a789d744ed1$var$getPixelArray(pixelArray, type, format, width, height) {
    if (pixelArray) return pixelArray;
    type = type || 5121;
    const ArrayType = (0, $3qgcG.getTypedArrayFromGLType)(type, {
        clamped: false
    });
    const components = (0, $b54ct.glFormatToComponents)(format);
    return new ArrayType(width * height * components);
}

});
parcelRegister("b54ct", function(module, exports) {

$parcel$export(module.exports, "glFormatToComponents", function () { return $81136b663d092389$export$211a621476a5328b; });
$parcel$export(module.exports, "glTypeToBytes", function () { return $81136b663d092389$export$25c250e029e88433; });

var $ihfnu = parcelRequire("ihfnu");
function $81136b663d092389$export$211a621476a5328b(format) {
    switch(format){
        case 6406:
        case 33326:
        case 6403:
            return 1;
        case 33328:
        case 33319:
            return 2;
        case 6407:
        case 34837:
            return 3;
        case 6408:
        case 34836:
            return 4;
        default:
            (0, $ihfnu.assert)(false);
            return 0;
    }
}
function $81136b663d092389$export$25c250e029e88433(type) {
    switch(type){
        case 5121:
            return 1;
        case 33635:
        case 32819:
        case 32820:
            return 2;
        case 5126:
            return 4;
        default:
            (0, $ihfnu.assert)(false);
            return 0;
    }
}

});

parcelRegister("dwgJf", function(module, exports) {

$parcel$export(module.exports, "cloneTextureFrom", function () { return $9d7b3d8270246b94$export$a502ec217e00cfb1; });
$parcel$export(module.exports, "toFramebuffer", function () { return $9d7b3d8270246b94$export$37e0e55400e095ba; });

var $7lUAH = parcelRequire("7lUAH");

var $dUlGi = parcelRequire("dUlGi");

var $humiB = parcelRequire("humiB");

var $cJo7e = parcelRequire("cJo7e");

var $ihfnu = parcelRequire("ihfnu");
function $9d7b3d8270246b94$export$a502ec217e00cfb1(refTexture, overrides) {
    (0, $ihfnu.assert)(refTexture instanceof (0, $7lUAH.default) || refTexture instanceof (0, $dUlGi.default) || refTexture instanceof (0, $humiB.default));
    const TextureType = refTexture.constructor;
    const { gl: gl, width: width, height: height, format: format, type: type, dataFormat: dataFormat, border: border, mipmaps: mipmaps } = refTexture;
    const textureOptions = Object.assign({
        width: width,
        height: height,
        format: format,
        type: type,
        dataFormat: dataFormat,
        border: border,
        mipmaps: mipmaps
    }, overrides);
    return new TextureType(gl, textureOptions);
}
function $9d7b3d8270246b94$export$37e0e55400e095ba(texture, opts) {
    const { gl: gl, width: width, height: height, id: id } = texture;
    const framebuffer = new (0, $cJo7e.default)(gl, Object.assign({}, opts, {
        id: "framebuffer-for-".concat(id),
        width: width,
        height: height,
        attachments: {
            [36064]: texture
        }
    }));
    return framebuffer;
}

});
parcelRegister("dUlGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a20152c204cb3649$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");

var $3D9dM = parcelRequire("3D9dM");
const $a20152c204cb3649$var$FACES = [
    34069,
    34070,
    34071,
    34072,
    34073,
    34074
];
class $a20152c204cb3649$export$2e2bcd8739ae039 extends (0, $3D9dM.default) {
    get [Symbol.toStringTag]() {
        return "TextureCube";
    }
    initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { mipmaps: mipmaps = true, parameters: parameters = {} } = props;
        this.opts = props;
        this.setCubeMapImageData(props).then(()=>{
            this.loaded = true;
            if (mipmaps) this.generateMipmap(props);
            this.setParameters(parameters);
        });
        return this;
    }
    subImage(_ref) {
        let { face: face, data: data, x: x = 0, y: y = 0, mipmapLevel: mipmapLevel = 0 } = _ref;
        return this._subImage({
            target: face,
            data: data,
            x: x,
            y: y,
            mipmapLevel: mipmapLevel
        });
    }
    async setCubeMapImageData(_ref2) {
        let { width: width, height: height, pixels: pixels, data: data, border: border = 0, format: format = 6408, type: type = 5121 } = _ref2;
        const { gl: gl } = this;
        const imageDataMap = pixels || data;
        const resolvedFaces = await Promise.all($a20152c204cb3649$var$FACES.map((face)=>{
            const facePixels = imageDataMap[face];
            return Promise.all(Array.isArray(facePixels) ? facePixels : [
                facePixels
            ]);
        }));
        this.bind();
        $a20152c204cb3649$var$FACES.forEach((face, index)=>{
            if (resolvedFaces[index].length > 1 && this.opts.mipmaps !== false) (0, $lvicK.log).warn("".concat(this.id, " has mipmap and multiple LODs."))();
            resolvedFaces[index].forEach((image, lodLevel)=>{
                if (width && height) gl.texImage2D(face, lodLevel, format, width, height, border, format, type, image);
                else gl.texImage2D(face, lodLevel, format, format, type, image);
            });
        });
        this.unbind();
    }
    setImageDataForFace(options) {
        const { face: face, width: width, height: height, pixels: pixels, data: data, border: border = 0, format: format = 6408, type: type = 5121 } = options;
        const { gl: gl } = this;
        const imageData = pixels || data;
        this.bind();
        if (imageData instanceof Promise) imageData.then((resolvedImageData)=>this.setImageDataForFace(Object.assign({}, options, {
                face: face,
                data: resolvedImageData,
                pixels: resolvedImageData
            })));
        else if (this.width || this.height) gl.texImage2D(face, 0, format, width, height, border, format, type, imageData);
        else gl.texImage2D(face, 0, format, format, type, imageData);
        return this;
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $8HKWo.assertWebGLContext)(gl);
        super(gl, Object.assign({}, props, {
            target: 34067
        }));
        this.initialize(props);
        Object.seal(this);
    }
}
$a20152c204cb3649$export$2e2bcd8739ae039.FACES = $a20152c204cb3649$var$FACES;

});

parcelRegister("humiB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbb6891d05bcf94a$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $2SJyH = parcelRequire("2SJyH");

var $3D9dM = parcelRequire("3D9dM");

var $du43m = parcelRequire("du43m");

var $7jraD = parcelRequire("7jraD");
class $cbb6891d05bcf94a$export$2e2bcd8739ae039 extends (0, $3D9dM.default) {
    get [Symbol.toStringTag]() {
        return "Texture3D";
    }
    static isSupported(gl) {
        return (0, $8HKWo.isWebGL2)(gl);
    }
    setImageData(_ref) {
        let { level: level = 0, dataFormat: dataFormat = 6408, width: width, height: height, depth: depth = 1, border: border = 0, format: format, type: type = 5121, offset: offset = 0, data: data, parameters: parameters = {} } = _ref;
        this._trackDeallocatedMemory("Texture");
        this.gl.bindTexture(this.target, this.handle);
        (0, $2SJyH.withParameters)(this.gl, parameters, ()=>{
            if (ArrayBuffer.isView(data)) this.gl.texImage3D(this.target, level, dataFormat, width, height, depth, border, format, type, data);
            if (data instanceof (0, $7jraD.default)) {
                this.gl.bindBuffer(35052, data.handle);
                this.gl.texImage3D(this.target, level, dataFormat, width, height, depth, border, format, type, offset);
            }
        });
        if (data && data.byteLength) this._trackAllocatedMemory(data.byteLength, "Texture");
        else {
            const channels = (0, $du43m.DATA_FORMAT_CHANNELS)[this.dataFormat] || 4;
            const channelSize = (0, $du43m.TYPE_SIZES)[this.type] || 1;
            this._trackAllocatedMemory(this.width * this.height * this.depth * channels * channelSize, "Texture");
        }
        this.loaded = true;
        return this;
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $8HKWo.assertWebGL2Context)(gl);
        props = Object.assign({
            depth: 1
        }, props, {
            target: 32879,
            unpackFlipY: false
        });
        super(gl, props);
        this.initialize(props);
        Object.seal(this);
    }
}

});



parcelRegister("tIWfJ", function(module, exports) {

$parcel$export(module.exports, "hasFeature", function () { return $05959168ffa4f795$export$805ddaeeece0413e; });
$parcel$export(module.exports, "hasFeatures", function () { return $05959168ffa4f795$export$990fdf4f5aca9ddb; });
$parcel$export(module.exports, "getFeatures", function () { return $05959168ffa4f795$export$c5c8eb9e425b0de0; });

var $68aPy = parcelRequire("68aPy");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");

var $ihfnu = parcelRequire("ihfnu");
const $05959168ffa4f795$var$LOG_UNSUPPORTED_FEATURE = 2;
function $05959168ffa4f795$export$805ddaeeece0413e(gl, feature) {
    return $05959168ffa4f795$export$990fdf4f5aca9ddb(gl, feature);
}
function $05959168ffa4f795$export$990fdf4f5aca9ddb(gl, features) {
    features = Array.isArray(features) ? features : [
        features
    ];
    return features.every((feature)=>{
        return $05959168ffa4f795$var$isFeatureSupported(gl, feature);
    });
}
function $05959168ffa4f795$export$c5c8eb9e425b0de0(gl) {
    gl.luma = gl.luma || {};
    gl.luma.caps = gl.luma.caps || {};
    for(const cap in 0, $68aPy.default)if (gl.luma.caps[cap] === undefined) gl.luma.caps[cap] = $05959168ffa4f795$var$isFeatureSupported(gl, cap);
    return gl.luma.caps;
}
function $05959168ffa4f795$var$isFeatureSupported(gl, cap) {
    gl.luma = gl.luma || {};
    gl.luma.caps = gl.luma.caps || {};
    if (gl.luma.caps[cap] === undefined) gl.luma.caps[cap] = $05959168ffa4f795$var$queryFeature(gl, cap);
    if (!gl.luma.caps[cap]) (0, $lvicK.log).log($05959168ffa4f795$var$LOG_UNSUPPORTED_FEATURE, "Feature: ".concat(cap, " not supported"))();
    return gl.luma.caps[cap];
}
function $05959168ffa4f795$var$queryFeature(gl, cap) {
    const feature = (0, $68aPy.default)[cap];
    (0, $ihfnu.assert)(feature, cap);
    let isSupported;
    const featureDefinition = (0, $8HKWo.isWebGL2)(gl) ? feature[1] || feature[0] : feature[0];
    if (typeof featureDefinition === "function") isSupported = featureDefinition(gl);
    else if (Array.isArray(featureDefinition)) {
        isSupported = true;
        for (const extension of featureDefinition)isSupported = isSupported && Boolean(gl.getExtension(extension));
    } else if (typeof featureDefinition === "string") isSupported = Boolean(gl.getExtension(featureDefinition));
    else if (typeof featureDefinition === "boolean") isSupported = featureDefinition;
    else (0, $ihfnu.assert)(false);
    return isSupported;
}

});



parcelRegister("jL2pF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6244741b37d557c$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1zR3q = parcelRequire("1zR3q");
class $e6244741b37d557c$export$2e2bcd8739ae039 {
    get value() {
        return this.source.value;
    }
    getValue() {
        const buffer = this.source.getBuffer();
        const accessor = this.getAccessor();
        if (buffer) return [
            buffer,
            accessor
        ];
        const { value: value } = this.source;
        const { size: size } = accessor;
        let constantValue = value;
        if (value && value.length !== size) {
            constantValue = new Float32Array(size);
            const index = accessor.elementOffset || 0;
            for(let i = 0; i < size; ++i)constantValue[i] = value[index + i];
        }
        return constantValue;
    }
    getAccessor() {
        return (0, $2QP2i._)({}, this.source.getAccessor(), this.opts);
    }
    constructor(dataColumn, opts){
        (0, $1zR3q.default)(this, "opts", void 0);
        (0, $1zR3q.default)(this, "source", void 0);
        this.opts = opts;
        this.source = dataColumn;
    }
}

});

parcelRegister("24b9z", function(module, exports) {

$parcel$export(module.exports, "glArrayFromType", function () { return $18149b5662407a5e$export$99de3c889be30ec5; });
function $18149b5662407a5e$export$99de3c889be30ec5(glType) {
    switch(glType){
        case 5126:
            return Float32Array;
        case 5130:
            return Float64Array;
        case 5123:
        case 33635:
        case 32819:
        case 32820:
            return Uint16Array;
        case 5125:
            return Uint32Array;
        case 5121:
            return Uint8ClampedArray;
        case 5120:
            return Int8Array;
        case 5122:
            return Int16Array;
        case 5124:
            return Int32Array;
        default:
            throw new Error("Unknown GL type");
    }
}

});

parcelRegister("an4RE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78cfd35131f8c1e0$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");
class $78cfd35131f8c1e0$export$ae7911e6e34e8f38 {
    setOptions(options) {
        Object.assign(this.opts, options);
    }
    allocate(typedArray, count, { size: size = 1, type: type, padding: padding = 0, copy: copy = false, initialize: initialize = false, maxCount: maxCount }) {
        const Type = type || typedArray && typedArray.constructor || Float32Array;
        const newSize = count * size + padding;
        if (ArrayBuffer.isView(typedArray)) {
            if (newSize <= typedArray.length) return typedArray;
            if (newSize * typedArray.BYTES_PER_ELEMENT <= typedArray.buffer.byteLength) return new Type(typedArray.buffer, 0, newSize);
        }
        let maxSize = Infinity;
        if (maxCount) maxSize = maxCount * size + padding;
        const newArray = this._allocate(Type, newSize, initialize, maxSize);
        if (typedArray && copy) newArray.set(typedArray);
        else if (!initialize) newArray.fill(0, 0, 4);
        this._release(typedArray);
        return newArray;
    }
    release(typedArray) {
        this._release(typedArray);
    }
    _allocate(Type, size, initialize, maxSize) {
        let sizeToAllocate = Math.max(Math.ceil(size * this.opts.overAlloc), 1);
        if (sizeToAllocate > maxSize) sizeToAllocate = maxSize;
        const pool = this._pool;
        const byteLength = Type.BYTES_PER_ELEMENT * sizeToAllocate;
        const i = pool.findIndex((b)=>b.byteLength >= byteLength);
        if (i >= 0) {
            const array = new Type(pool.splice(i, 1)[0], 0, sizeToAllocate);
            if (initialize) array.fill(0);
            return array;
        }
        return new Type(sizeToAllocate);
    }
    _release(typedArray) {
        if (!ArrayBuffer.isView(typedArray)) return;
        const pool = this._pool;
        const { buffer: buffer } = typedArray;
        const { byteLength: byteLength } = buffer;
        const i = pool.findIndex((b)=>b.byteLength >= byteLength);
        if (i < 0) pool.push(buffer);
        else if (i > 0 || pool.length < this.opts.poolSize) pool.splice(i, 0, buffer);
        if (pool.length > this.opts.poolSize) pool.shift();
    }
    constructor(options = {}){
        (0, $1zR3q.default)(this, "_pool", []);
        (0, $1zR3q.default)(this, "opts", {
            overAlloc: 2,
            poolSize: 100
        });
        this.setOptions(options);
    }
}
var $78cfd35131f8c1e0$export$2e2bcd8739ae039 = new $78cfd35131f8c1e0$export$ae7911e6e34e8f38();

});

parcelRegister("9kyEf", function(module, exports) {

$parcel$export(module.exports, "createMat4", function () { return $6cb0dbbc1f78b65b$export$1a9a28cade4dcdc4; });
$parcel$export(module.exports, "getCameraPosition", function () { return $6cb0dbbc1f78b65b$export$f411fdc3e02e158b; });
$parcel$export(module.exports, "getFrustumPlanes", function () { return $6cb0dbbc1f78b65b$export$7fd6193a8fe6de4e; });
$parcel$export(module.exports, "toDoublePrecisionArray", function () { return $6cb0dbbc1f78b65b$export$550bd089be4eedcb; });
$parcel$export(module.exports, "mergeBounds", function () { return $6cb0dbbc1f78b65b$export$579a8a269cc78035; });

var $an4RE = parcelRequire("an4RE");

var $cKS36 = parcelRequire("cKS36");
function $6cb0dbbc1f78b65b$export$1a9a28cade4dcdc4() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function $6cb0dbbc1f78b65b$export$842a2cf37af977e1(value, divisor) {
    const modulus = value % divisor;
    return modulus < 0 ? divisor + modulus : modulus;
}
function $6cb0dbbc1f78b65b$export$f411fdc3e02e158b(viewMatrixInverse) {
    return [
        viewMatrixInverse[12],
        viewMatrixInverse[13],
        viewMatrixInverse[14]
    ];
}
function $6cb0dbbc1f78b65b$export$7fd6193a8fe6de4e(viewProjectionMatrix) {
    return {
        left: $6cb0dbbc1f78b65b$var$getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[0], viewProjectionMatrix[7] + viewProjectionMatrix[4], viewProjectionMatrix[11] + viewProjectionMatrix[8], viewProjectionMatrix[15] + viewProjectionMatrix[12]),
        right: $6cb0dbbc1f78b65b$var$getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[0], viewProjectionMatrix[7] - viewProjectionMatrix[4], viewProjectionMatrix[11] - viewProjectionMatrix[8], viewProjectionMatrix[15] - viewProjectionMatrix[12]),
        bottom: $6cb0dbbc1f78b65b$var$getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[1], viewProjectionMatrix[7] + viewProjectionMatrix[5], viewProjectionMatrix[11] + viewProjectionMatrix[9], viewProjectionMatrix[15] + viewProjectionMatrix[13]),
        top: $6cb0dbbc1f78b65b$var$getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[1], viewProjectionMatrix[7] - viewProjectionMatrix[5], viewProjectionMatrix[11] - viewProjectionMatrix[9], viewProjectionMatrix[15] - viewProjectionMatrix[13]),
        near: $6cb0dbbc1f78b65b$var$getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[2], viewProjectionMatrix[7] + viewProjectionMatrix[6], viewProjectionMatrix[11] + viewProjectionMatrix[10], viewProjectionMatrix[15] + viewProjectionMatrix[14]),
        far: $6cb0dbbc1f78b65b$var$getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[2], viewProjectionMatrix[7] - viewProjectionMatrix[6], viewProjectionMatrix[11] - viewProjectionMatrix[10], viewProjectionMatrix[15] - viewProjectionMatrix[14])
    };
}
const $6cb0dbbc1f78b65b$var$scratchVector = new (0, $cKS36.default)();
function $6cb0dbbc1f78b65b$var$getFrustumPlane(a, b, c, d) {
    $6cb0dbbc1f78b65b$var$scratchVector.set(a, b, c);
    const L = $6cb0dbbc1f78b65b$var$scratchVector.len();
    return {
        distance: d / L,
        normal: new (0, $cKS36.default)(-a / L, -b / L, -c / L)
    };
}
function $6cb0dbbc1f78b65b$export$4e5285c56a99f06d(x) {
    return x - Math.fround(x);
}
let $6cb0dbbc1f78b65b$var$scratchArray;
function $6cb0dbbc1f78b65b$export$550bd089be4eedcb(typedArray, options) {
    const { size: size = 1, startIndex: startIndex = 0 } = options;
    const endIndex = options.endIndex !== undefined ? options.endIndex : typedArray.length;
    const count = (endIndex - startIndex) / size;
    $6cb0dbbc1f78b65b$var$scratchArray = (0, $an4RE.default).allocate($6cb0dbbc1f78b65b$var$scratchArray, count, {
        type: Float32Array,
        size: size * 2
    });
    let sourceIndex = startIndex;
    let targetIndex = 0;
    while(sourceIndex < endIndex){
        for(let j = 0; j < size; j++){
            const value = typedArray[sourceIndex++];
            $6cb0dbbc1f78b65b$var$scratchArray[targetIndex + j] = value;
            $6cb0dbbc1f78b65b$var$scratchArray[targetIndex + j + size] = $6cb0dbbc1f78b65b$export$4e5285c56a99f06d(value);
        }
        targetIndex += size * 2;
    }
    return $6cb0dbbc1f78b65b$var$scratchArray.subarray(0, count * size * 2);
}
function $6cb0dbbc1f78b65b$export$579a8a269cc78035(boundsList) {
    let mergedBounds = null;
    let isMerged = false;
    for (const bounds of boundsList){
        if (!bounds) continue;
        if (!mergedBounds) mergedBounds = bounds;
        else {
            if (!isMerged) {
                mergedBounds = [
                    [
                        mergedBounds[0][0],
                        mergedBounds[0][1]
                    ],
                    [
                        mergedBounds[1][0],
                        mergedBounds[1][1]
                    ]
                ];
                isMerged = true;
            }
            mergedBounds[0][0] = Math.min(mergedBounds[0][0], bounds[0][0]);
            mergedBounds[0][1] = Math.min(mergedBounds[0][1], bounds[0][1]);
            mergedBounds[1][0] = Math.max(mergedBounds[1][0], bounds[1][0]);
            mergedBounds[1][1] = Math.max(mergedBounds[1][1], bounds[1][1]);
        }
    }
    return mergedBounds;
}

});
parcelRegister("cKS36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9493b4ee0416307f$export$2e2bcd8739ae039; });

var $3nAvB = parcelRequire("3nAvB");

var $cwF9s = parcelRequire("cwF9s");

var $j8wyT = parcelRequire("j8wyT");

var $bjUmI = parcelRequire("bjUmI");

var $idCXM = parcelRequire("idCXM");
const $9493b4ee0416307f$var$ORIGIN = [
    0,
    0,
    0
];
let $9493b4ee0416307f$var$ZERO;
class $9493b4ee0416307f$export$2e2bcd8739ae039 extends (0, $3nAvB.default) {
    static get ZERO() {
        if (!$9493b4ee0416307f$var$ZERO) {
            $9493b4ee0416307f$var$ZERO = new $9493b4ee0416307f$export$2e2bcd8739ae039(0, 0, 0);
            Object.freeze($9493b4ee0416307f$var$ZERO);
        }
        return $9493b4ee0416307f$var$ZERO;
    }
    set(x, y, z) {
        this[0] = x;
        this[1] = y;
        this[2] = z;
        return this.check();
    }
    copy(array) {
        this[0] = array[0];
        this[1] = array[1];
        this[2] = array[2];
        return this.check();
    }
    fromObject(object) {
        if ((0, $cwF9s.config).debug) {
            (0, $j8wyT.checkNumber)(object.x);
            (0, $j8wyT.checkNumber)(object.y);
            (0, $j8wyT.checkNumber)(object.z);
        }
        this[0] = object.x;
        this[1] = object.y;
        this[2] = object.z;
        return this.check();
    }
    toObject(object) {
        object.x = this[0];
        object.y = this[1];
        object.z = this[2];
        return object;
    }
    get ELEMENTS() {
        return 3;
    }
    get z() {
        return this[2];
    }
    set z(value) {
        this[2] = (0, $j8wyT.checkNumber)(value);
    }
    angle(vector) {
        return $bjUmI.angle(this, vector);
    }
    cross(vector) {
        $bjUmI.cross(this, this, vector);
        return this.check();
    }
    rotateX({ radians: radians, origin: origin = $9493b4ee0416307f$var$ORIGIN }) {
        $bjUmI.rotateX(this, this, origin, radians);
        return this.check();
    }
    rotateY({ radians: radians, origin: origin = $9493b4ee0416307f$var$ORIGIN }) {
        $bjUmI.rotateY(this, this, origin, radians);
        return this.check();
    }
    rotateZ({ radians: radians, origin: origin = $9493b4ee0416307f$var$ORIGIN }) {
        $bjUmI.rotateZ(this, this, origin, radians);
        return this.check();
    }
    transform(matrix4) {
        return this.transformAsPoint(matrix4);
    }
    transformAsPoint(matrix4) {
        $bjUmI.transformMat4(this, this, matrix4);
        return this.check();
    }
    transformAsVector(matrix4) {
        (0, $idCXM.vec3_transformMat4AsVector)(this, this, matrix4);
        return this.check();
    }
    transformByMatrix3(matrix3) {
        $bjUmI.transformMat3(this, this, matrix3);
        return this.check();
    }
    transformByMatrix2(matrix2) {
        (0, $idCXM.vec3_transformMat2)(this, this, matrix2);
        return this.check();
    }
    transformByQuaternion(quaternion) {
        $bjUmI.transformQuat(this, this, quaternion);
        return this.check();
    }
    constructor(x = 0, y = 0, z = 0){
        super(-0, -0, -0);
        if (arguments.length === 1 && (0, $cwF9s.isArray)(x)) this.copy(x);
        else {
            if ((0, $cwF9s.config).debug) {
                (0, $j8wyT.checkNumber)(x);
                (0, $j8wyT.checkNumber)(y);
                (0, $j8wyT.checkNumber)(z);
            }
            this[0] = x;
            this[1] = y;
            this[2] = z;
        }
    }
}

});
parcelRegister("3nAvB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $275fd6f8ce435d12$export$2e2bcd8739ae039; });

var $cCPCr = parcelRequire("cCPCr");

var $j8wyT = parcelRequire("j8wyT");

var $8EkKL = parcelRequire("8EkKL");
class $275fd6f8ce435d12$export$2e2bcd8739ae039 extends (0, $cCPCr.default) {
    get x() {
        return this[0];
    }
    set x(value) {
        this[0] = (0, $j8wyT.checkNumber)(value);
    }
    get y() {
        return this[1];
    }
    set y(value) {
        this[1] = (0, $j8wyT.checkNumber)(value);
    }
    len() {
        return Math.sqrt(this.lengthSquared());
    }
    magnitude() {
        return this.len();
    }
    lengthSquared() {
        let length = 0;
        for(let i = 0; i < this.ELEMENTS; ++i)length += this[i] * this[i];
        return length;
    }
    magnitudeSquared() {
        return this.lengthSquared();
    }
    distance(mathArray) {
        return Math.sqrt(this.distanceSquared(mathArray));
    }
    distanceSquared(mathArray) {
        let length = 0;
        for(let i = 0; i < this.ELEMENTS; ++i){
            const dist = this[i] - mathArray[i];
            length += dist * dist;
        }
        return (0, $j8wyT.checkNumber)(length);
    }
    dot(mathArray) {
        let product = 0;
        for(let i = 0; i < this.ELEMENTS; ++i)product += this[i] * mathArray[i];
        return (0, $j8wyT.checkNumber)(product);
    }
    normalize() {
        const length = this.magnitude();
        if (length !== 0) for(let i = 0; i < this.ELEMENTS; ++i)this[i] /= length;
        return this.check();
    }
    multiply(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= vector[i];
        return this.check();
    }
    divide(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] /= vector[i];
        return this.check();
    }
    lengthSq() {
        return this.lengthSquared();
    }
    distanceTo(vector) {
        return this.distance(vector);
    }
    distanceToSquared(vector) {
        return this.distanceSquared(vector);
    }
    getComponent(i) {
        (0, $8EkKL.default)(i >= 0 && i < this.ELEMENTS, "index is out of range");
        return (0, $j8wyT.checkNumber)(this[i]);
    }
    setComponent(i, value) {
        (0, $8EkKL.default)(i >= 0 && i < this.ELEMENTS, "index is out of range");
        this[i] = value;
        return this.check();
    }
    addVectors(a, b) {
        return this.copy(a).add(b);
    }
    subVectors(a, b) {
        return this.copy(a).subtract(b);
    }
    multiplyVectors(a, b) {
        return this.copy(a).multiply(b);
    }
    addScaledVector(a, b) {
        return this.add(new this.constructor(a).multiplyScalar(b));
    }
}

});
parcelRegister("cCPCr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $931113201a6ab2e9$export$2e2bcd8739ae039; });

var $cwF9s = parcelRequire("cwF9s");
function $931113201a6ab2e9$var$_extendableBuiltin(cls) {
    function ExtendableBuiltin() {
        var instance = Reflect.construct(cls, Array.from(arguments));
        Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
        return instance;
    }
    ExtendableBuiltin.prototype = Object.create(cls.prototype, {
        constructor: {
            value: cls,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (Object.setPrototypeOf) Object.setPrototypeOf(ExtendableBuiltin, cls);
    else ExtendableBuiltin.__proto__ = cls;
    return ExtendableBuiltin;
}
class $931113201a6ab2e9$export$2e2bcd8739ae039 extends $931113201a6ab2e9$var$_extendableBuiltin(Array) {
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = array[i + offset];
        return this.check();
    }
    toArray(targetArray = [], offset = 0) {
        for(let i = 0; i < this.ELEMENTS; ++i)targetArray[offset + i] = this[i];
        return targetArray;
    }
    from(arrayOrObject) {
        return Array.isArray(arrayOrObject) ? this.copy(arrayOrObject) : this.fromObject(arrayOrObject);
    }
    to(arrayOrObject) {
        if (arrayOrObject === this) return this;
        return (0, $cwF9s.isArray)(arrayOrObject) ? this.toArray(arrayOrObject) : this.toObject(arrayOrObject);
    }
    toTarget(target) {
        return target ? this.to(target) : this;
    }
    toFloat32Array() {
        return new Float32Array(this);
    }
    toString() {
        return this.formatString((0, $cwF9s.config));
    }
    formatString(opts) {
        let string = "";
        for(let i = 0; i < this.ELEMENTS; ++i)string += (i > 0 ? ", " : "") + (0, $cwF9s.formatValue)(this[i], opts);
        return "".concat(opts.printTypes ? this.constructor.name : "", "[").concat(string, "]");
    }
    equals(array) {
        if (!array || this.length !== array.length) return false;
        for(let i = 0; i < this.ELEMENTS; ++i){
            if (!(0, $cwF9s.equals)(this[i], array[i])) return false;
        }
        return true;
    }
    exactEquals(array) {
        if (!array || this.length !== array.length) return false;
        for(let i = 0; i < this.ELEMENTS; ++i){
            if (this[i] !== array[i]) return false;
        }
        return true;
    }
    negate() {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = -this[i];
        return this.check();
    }
    lerp(a, b, t) {
        if (t === undefined) return this.lerp(this, a, b);
        for(let i = 0; i < this.ELEMENTS; ++i){
            const ai = a[i];
            this[i] = ai + t * (b[i] - ai);
        }
        return this.check();
    }
    min(vector) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.min(vector[i], this[i]);
        return this.check();
    }
    max(vector) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.max(vector[i], this[i]);
        return this.check();
    }
    clamp(minVector, maxVector) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.min(Math.max(this[i], minVector[i]), maxVector[i]);
        return this.check();
    }
    add(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] += vector[i];
        return this.check();
    }
    subtract(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] -= vector[i];
        return this.check();
    }
    scale(scale) {
        if (typeof scale === "number") for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= scale;
        else for(let i = 0; i < this.ELEMENTS && i < scale.length; ++i)this[i] *= scale[i];
        return this.check();
    }
    multiplyByScalar(scalar) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= scalar;
        return this.check();
    }
    check() {
        if ((0, $cwF9s.config).debug && !this.validate()) throw new Error("math.gl: ".concat(this.constructor.name, " some fields set to invalid numbers'"));
        return this;
    }
    validate() {
        let valid = this.length === this.ELEMENTS;
        for(let i = 0; i < this.ELEMENTS; ++i)valid = valid && Number.isFinite(this[i]);
        return valid;
    }
    sub(a) {
        return this.subtract(a);
    }
    setScalar(a) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = a;
        return this.check();
    }
    addScalar(a) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] += a;
        return this.check();
    }
    subScalar(a) {
        return this.addScalar(-a);
    }
    multiplyScalar(scalar) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= scalar;
        return this.check();
    }
    divideScalar(a) {
        return this.multiplyByScalar(1 / a);
    }
    clampScalar(min, max) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.min(Math.max(this[i], min), max);
        return this.check();
    }
    get elements() {
        return this;
    }
}

});
parcelRegister("cwF9s", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $91e8650d526beecc$export$e506a1d27d1eaa20; });
$parcel$export(module.exports, "formatValue", function () { return $91e8650d526beecc$export$7c4d25c0c3217d8c; });
$parcel$export(module.exports, "isArray", function () { return $91e8650d526beecc$export$43bee75e5e14138e; });
$parcel$export(module.exports, "toRadians", function () { return $91e8650d526beecc$export$cba01ba138429a1d; });
$parcel$export(module.exports, "toDegrees", function () { return $91e8650d526beecc$export$56cb859c01fa134d; });
$parcel$export(module.exports, "degrees", function () { return $91e8650d526beecc$export$41fc368e1a942b97; });
$parcel$export(module.exports, "clamp", function () { return $91e8650d526beecc$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "lerp", function () { return $91e8650d526beecc$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "equals", function () { return $91e8650d526beecc$export$e9bab7fafb253603; });

var $8EkKL = parcelRequire("8EkKL");
const $91e8650d526beecc$var$RADIANS_TO_DEGREES = 1 / Math.PI * 180;
const $91e8650d526beecc$var$DEGREES_TO_RADIANS = 1 / 180 * Math.PI;
const $91e8650d526beecc$export$e506a1d27d1eaa20 = {
    EPSILON: 1e-12,
    debug: false,
    precision: 4,
    printTypes: false,
    printDegrees: false,
    printRowMajor: true
};
function $91e8650d526beecc$export$8d21e34596265fa2(options) {
    for(const key in options){
        (0, $8EkKL.default)(key in $91e8650d526beecc$export$e506a1d27d1eaa20);
        $91e8650d526beecc$export$e506a1d27d1eaa20[key] = options[key];
    }
    return $91e8650d526beecc$export$e506a1d27d1eaa20;
}
function $91e8650d526beecc$export$7c4d25c0c3217d8c(value, { precision: precision = $91e8650d526beecc$export$e506a1d27d1eaa20.precision } = {}) {
    value = $91e8650d526beecc$var$round(value);
    return "".concat(parseFloat(value.toPrecision(precision)));
}
function $91e8650d526beecc$export$43bee75e5e14138e(value) {
    return Array.isArray(value) || ArrayBuffer.isView(value) && !(value instanceof DataView);
}
function $91e8650d526beecc$export$9cd59f9826255e47(array) {
    return "clone" in array ? array.clone() : array.slice();
}
function $91e8650d526beecc$export$cba01ba138429a1d(degrees) {
    return $91e8650d526beecc$export$8449e153fbd325fc(degrees);
}
function $91e8650d526beecc$export$56cb859c01fa134d(radians) {
    return $91e8650d526beecc$export$41fc368e1a942b97(radians);
}
function $91e8650d526beecc$export$8449e153fbd325fc(degrees, result) {
    return $91e8650d526beecc$var$map(degrees, (degrees)=>degrees * $91e8650d526beecc$var$DEGREES_TO_RADIANS, result);
}
function $91e8650d526beecc$export$41fc368e1a942b97(radians, result) {
    return $91e8650d526beecc$var$map(radians, (radians)=>radians * $91e8650d526beecc$var$RADIANS_TO_DEGREES, result);
}
function $91e8650d526beecc$export$5de3937cb4b592ed(radians, result) {
    return $91e8650d526beecc$var$map(radians, (angle)=>Math.sin(angle), result);
}
function $91e8650d526beecc$export$50d414a77b60d802(radians, result) {
    return $91e8650d526beecc$var$map(radians, (angle)=>Math.cos(angle), result);
}
function $91e8650d526beecc$export$fcdd3b0b3246a325(radians, result) {
    return $91e8650d526beecc$var$map(radians, (angle)=>Math.tan(angle), result);
}
function $91e8650d526beecc$export$41726bdb1fc63f(radians, result) {
    return $91e8650d526beecc$var$map(radians, (angle)=>Math.asin(angle), result);
}
function $91e8650d526beecc$export$fd6306be3fde5b04(radians, result) {
    return $91e8650d526beecc$var$map(radians, (angle)=>Math.acos(angle), result);
}
function $91e8650d526beecc$export$628dc4eed22b0fbd(radians, result) {
    return $91e8650d526beecc$var$map(radians, (angle)=>Math.atan(angle), result);
}
function $91e8650d526beecc$export$7d15b64cf5a3a4c4(value, min, max) {
    return $91e8650d526beecc$var$map(value, (value)=>Math.max(min, Math.min(max, value)));
}
function $91e8650d526beecc$export$3a89f8d6f6bf6c9f(a, b, t) {
    if ($91e8650d526beecc$export$43bee75e5e14138e(a)) return a.map((ai, i)=>$91e8650d526beecc$export$3a89f8d6f6bf6c9f(ai, b[i], t));
    return t * b + (1 - t) * a;
}
function $91e8650d526beecc$export$e9bab7fafb253603(a, b, epsilon) {
    const oldEpsilon = $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON;
    if (epsilon) $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON = epsilon;
    try {
        if (a === b) return true;
        if ($91e8650d526beecc$export$43bee75e5e14138e(a) && $91e8650d526beecc$export$43bee75e5e14138e(b)) {
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; ++i){
                if (!$91e8650d526beecc$export$e9bab7fafb253603(a[i], b[i])) return false;
            }
            return true;
        }
        if (a && a.equals) return a.equals(b);
        if (b && b.equals) return b.equals(a);
        if (typeof a === "number" && typeof b === "number") return Math.abs(a - b) <= $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON * Math.max(1, Math.abs(a), Math.abs(b));
        return false;
    } finally{
        $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON = oldEpsilon;
    }
}
function $91e8650d526beecc$export$f2599a5cf1109d8(a, b) {
    if (a === b) return true;
    if (a && typeof a === "object" && b && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        if (a.exactEquals) return a.exactEquals(b);
    }
    if ($91e8650d526beecc$export$43bee75e5e14138e(a) && $91e8650d526beecc$export$43bee75e5e14138e(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; ++i){
            if (!$91e8650d526beecc$export$f2599a5cf1109d8(a[i], b[i])) return false;
        }
        return true;
    }
    return false;
}
function $91e8650d526beecc$export$33e486a830e586b3(epsilon, func) {
    const oldPrecision = $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON;
    $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON = epsilon;
    let value;
    try {
        value = func();
    } finally{
        $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON = oldPrecision;
    }
    return value;
}
function $91e8650d526beecc$var$round(value) {
    return Math.round(value / $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON) * $91e8650d526beecc$export$e506a1d27d1eaa20.EPSILON;
}
function $91e8650d526beecc$var$duplicateArray(array) {
    return array.clone ? array.clone() : new Array(array.length);
}
function $91e8650d526beecc$var$map(value, func, result) {
    if ($91e8650d526beecc$export$43bee75e5e14138e(value)) {
        const array = value;
        result = result || $91e8650d526beecc$var$duplicateArray(array);
        for(let i = 0; i < result.length && i < array.length; ++i)result[i] = func(value[i], i, result);
        return result;
    }
    return func(value);
}

});
parcelRegister("8EkKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64c2284d69da3066$export$2e2bcd8739ae039; });
function $64c2284d69da3066$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error("math.gl assertion ".concat(message));
}

});



parcelRegister("j8wyT", function(module, exports) {

$parcel$export(module.exports, "checkNumber", function () { return $dee805c5bb536af4$export$74ff82ccb88f9fb1; });
$parcel$export(module.exports, "checkVector", function () { return $dee805c5bb536af4$export$3eb62eb6ef90f888; });

var $cwF9s = parcelRequire("cwF9s");
function $dee805c5bb536af4$export$a1b6cd0c891cc7(v, length) {
    if (v.length !== length) return false;
    for(let i = 0; i < v.length; ++i){
        if (!Number.isFinite(v[i])) return false;
    }
    return true;
}
function $dee805c5bb536af4$export$74ff82ccb88f9fb1(value) {
    if (!Number.isFinite(value)) throw new Error("Invalid number ".concat(value));
    return value;
}
function $dee805c5bb536af4$export$3eb62eb6ef90f888(v, length, callerName = "") {
    if ((0, $cwF9s.config).debug && !$dee805c5bb536af4$export$a1b6cd0c891cc7(v, length)) throw new Error("math.gl: ".concat(callerName, " some fields set to invalid numbers'"));
    return v;
}
const $dee805c5bb536af4$var$map = {};
function $dee805c5bb536af4$export$cdd73fc4100a6ef4(method, version) {
    if (!$dee805c5bb536af4$var$map[method]) {
        $dee805c5bb536af4$var$map[method] = true;
        console.warn("".concat(method, " has been removed in version ").concat(version, ", see upgrade guide for more information"));
    }
}

});


parcelRegister("bjUmI", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $83dd3109b127931b$export$185802fd694ee1f5; });
$parcel$export(module.exports, "length", function () { return $83dd3109b127931b$export$f24224f1c91d8156; });
$parcel$export(module.exports, "fromValues", function () { return $83dd3109b127931b$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "add", function () { return $83dd3109b127931b$export$e16d8520af44a096; });
$parcel$export(module.exports, "negate", function () { return $83dd3109b127931b$export$aef51622e549b8b0; });
$parcel$export(module.exports, "normalize", function () { return $83dd3109b127931b$export$a3295358bff77e; });
$parcel$export(module.exports, "dot", function () { return $83dd3109b127931b$export$94132a0e348806d4; });
$parcel$export(module.exports, "cross", function () { return $83dd3109b127931b$export$bb646b20bb93d339; });
$parcel$export(module.exports, "transformMat4", function () { return $83dd3109b127931b$export$5ffbd13800309d59; });
$parcel$export(module.exports, "transformMat3", function () { return $83dd3109b127931b$export$f0bfa0a0024626ee; });
$parcel$export(module.exports, "transformQuat", function () { return $83dd3109b127931b$export$c32adef9e939ce85; });
$parcel$export(module.exports, "rotateX", function () { return $83dd3109b127931b$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateY", function () { return $83dd3109b127931b$export$cf71e4d4ca4d1cfd; });
$parcel$export(module.exports, "rotateZ", function () { return $83dd3109b127931b$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "angle", function () { return $83dd3109b127931b$export$944b09d2ad10b378; });
$parcel$export(module.exports, "mul", function () { return $83dd3109b127931b$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "len", function () { return $83dd3109b127931b$export$fc1400facf92c78; });

var $jbrKE = parcelRequire("jbrKE");
function $83dd3109b127931b$export$185802fd694ee1f5() {
    var out = new $jbrKE.ARRAY_TYPE(3);
    if ($jbrKE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $83dd3109b127931b$export$9cd59f9826255e47(a) {
    var out = new $jbrKE.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $83dd3109b127931b$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $83dd3109b127931b$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $jbrKE.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $83dd3109b127931b$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $83dd3109b127931b$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $83dd3109b127931b$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $83dd3109b127931b$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $83dd3109b127931b$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $83dd3109b127931b$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $83dd3109b127931b$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $83dd3109b127931b$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $83dd3109b127931b$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $83dd3109b127931b$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $83dd3109b127931b$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $83dd3109b127931b$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $83dd3109b127931b$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $83dd3109b127931b$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $83dd3109b127931b$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $83dd3109b127931b$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $83dd3109b127931b$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $83dd3109b127931b$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $83dd3109b127931b$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $83dd3109b127931b$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $83dd3109b127931b$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $83dd3109b127931b$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $83dd3109b127931b$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $83dd3109b127931b$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $83dd3109b127931b$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $jbrKE.RANDOM() * 2.0 * Math.PI;
    var z = $jbrKE.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $83dd3109b127931b$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $83dd3109b127931b$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $83dd3109b127931b$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $83dd3109b127931b$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $83dd3109b127931b$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $83dd3109b127931b$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $83dd3109b127931b$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $83dd3109b127931b$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $83dd3109b127931b$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $83dd3109b127931b$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $83dd3109b127931b$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $83dd3109b127931b$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $83dd3109b127931b$export$f93b5905241a7cca = $83dd3109b127931b$export$4e2d2ead65e5f7e3;
var $83dd3109b127931b$export$6e3a27864ab166fe = $83dd3109b127931b$export$2060d2db72cce88f;
var $83dd3109b127931b$export$159d9494db57879b = $83dd3109b127931b$export$cd007d971a5a2143;
var $83dd3109b127931b$export$6c4a311cc157c764 = $83dd3109b127931b$export$9f17032d917177de;
var $83dd3109b127931b$export$2422cd6c492a8b3a = $83dd3109b127931b$export$88e6ebb4fe54f538;
var $83dd3109b127931b$export$fc1400facf92c78 = $83dd3109b127931b$export$f24224f1c91d8156;
var $83dd3109b127931b$export$99d8dd3f32a3435 = $83dd3109b127931b$export$ab44e1323ffc8376;
var $83dd3109b127931b$export$4b80e395e36b5a56 = function() {
    var vec = $83dd3109b127931b$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});
parcelRegister("jbrKE", function(module, exports) {

$parcel$export(module.exports, "EPSILON", function () { return $df7492408be082e2$export$fd293b15f47e270; });
$parcel$export(module.exports, "ARRAY_TYPE", function () { return $df7492408be082e2$export$b67359430d3b1b2; });
$parcel$export(module.exports, "RANDOM", function () { return $df7492408be082e2$export$5ada478c8a628231; });
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $df7492408be082e2$export$fd293b15f47e270 = 0.000001;
var $df7492408be082e2$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $df7492408be082e2$export$5ada478c8a628231 = Math.random;
function $df7492408be082e2$export$cb2c0eb57f5e532c(type) {
    $df7492408be082e2$export$b67359430d3b1b2 = type;
}
var $df7492408be082e2$var$degree = Math.PI / 180;
function $df7492408be082e2$export$408b8ee5959eefd5(a) {
    return a * $df7492408be082e2$var$degree;
}
function $df7492408be082e2$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $df7492408be082e2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};

});


parcelRegister("idCXM", function(module, exports) {

$parcel$export(module.exports, "vec2_transformMat4AsVector", function () { return $036c40ae3447f164$export$9c22d6d462b57a6c; });
$parcel$export(module.exports, "vec3_transformMat4AsVector", function () { return $036c40ae3447f164$export$df62a5cc0f49271; });
$parcel$export(module.exports, "vec3_transformMat2", function () { return $036c40ae3447f164$export$1287c03b2c6fb6a5; });
$parcel$export(module.exports, "vec4_transformMat2", function () { return $036c40ae3447f164$export$808cc2c9e882a204; });
$parcel$export(module.exports, "vec4_transformMat3", function () { return $036c40ae3447f164$export$bfe7f279eafb7f9b; });
function $036c40ae3447f164$export$9c22d6d462b57a6c(out, a, m) {
    const x = a[0];
    const y = a[1];
    const w = m[3] * x + m[7] * y || 1.0;
    out[0] = (m[0] * x + m[4] * y) / w;
    out[1] = (m[1] * x + m[5] * y) / w;
    return out;
}
function $036c40ae3447f164$export$df62a5cc0f49271(out, a, m) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    const w = m[3] * x + m[7] * y + m[11] * z || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z) / w;
    return out;
}
function $036c40ae3447f164$export$1287c03b2c6fb6a5(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    out[2] = a[2];
    return out;
}
function $036c40ae3447f164$export$808cc2c9e882a204(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $036c40ae3447f164$export$bfe7f279eafb7f9b(out, a, m) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    out[0] = m[0] * x + m[3] * y + m[6] * z;
    out[1] = m[1] * x + m[4] * y + m[7] * z;
    out[2] = m[2] * x + m[5] * y + m[8] * z;
    out[3] = a[3];
    return out;
}

});




parcelRegister("hu5l6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cba9614a3f193089$export$2e2bcd8739ae039; });
function $cba9614a3f193089$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message || "deck.gl: assertion failed.");
}

});

parcelRegister("abpME", function(module, exports) {

$parcel$export(module.exports, "createIterable", function () { return $769eee9651aeb164$export$f9c2f07d6e2a6221; });
$parcel$export(module.exports, "isAsyncIterable", function () { return $769eee9651aeb164$export$edb10ab8dd75a915; });
$parcel$export(module.exports, "getAccessorFromBuffer", function () { return $769eee9651aeb164$export$9c57eba05c1e4d4; });
const $769eee9651aeb164$var$EMPTY_ARRAY = [];
const $769eee9651aeb164$var$placeholderArray = [];
function $769eee9651aeb164$export$f9c2f07d6e2a6221(data, startRow = 0, endRow = Infinity) {
    let iterable = $769eee9651aeb164$var$EMPTY_ARRAY;
    const objectInfo = {
        index: -1,
        data: data,
        target: []
    };
    if (!data) iterable = $769eee9651aeb164$var$EMPTY_ARRAY;
    else if (typeof data[Symbol.iterator] === "function") iterable = data;
    else if (data.length > 0) {
        $769eee9651aeb164$var$placeholderArray.length = data.length;
        iterable = $769eee9651aeb164$var$placeholderArray;
    }
    if (startRow > 0 || Number.isFinite(endRow)) {
        iterable = (Array.isArray(iterable) ? iterable : Array.from(iterable)).slice(startRow, endRow);
        objectInfo.index = startRow - 1;
    }
    return {
        iterable: iterable,
        objectInfo: objectInfo
    };
}
function $769eee9651aeb164$export$edb10ab8dd75a915(data) {
    return data && data[Symbol.asyncIterator];
}
function $769eee9651aeb164$export$9c57eba05c1e4d4(typedArray, options) {
    const { size: size, stride: stride, offset: offset, startIndices: startIndices, nested: nested } = options;
    const bytesPerElement = typedArray.BYTES_PER_ELEMENT;
    const elementStride = stride ? stride / bytesPerElement : size;
    const elementOffset = offset ? offset / bytesPerElement : 0;
    const vertexCount = Math.floor((typedArray.length - elementOffset) / elementStride);
    return (_, { index: index, target: target })=>{
        if (!startIndices) {
            const sourceIndex = index * elementStride + elementOffset;
            for(let j = 0; j < size; j++)target[j] = typedArray[sourceIndex + j];
            return target;
        }
        const startIndex = startIndices[index];
        const endIndex = startIndices[index + 1] || vertexCount;
        let result;
        if (nested) {
            result = new Array(endIndex - startIndex);
            for(let i = startIndex; i < endIndex; i++){
                const sourceIndex = i * elementStride + elementOffset;
                target = new Array(size);
                for(let j = 0; j < size; j++)target[j] = typedArray[sourceIndex + j];
                result[i - startIndex] = target;
            }
        } else if (elementStride === size) result = typedArray.subarray(startIndex * size + elementOffset, endIndex * size + elementOffset);
        else {
            result = new typedArray.constructor((endIndex - startIndex) * size);
            let targetIndex = 0;
            for(let i = startIndex; i < endIndex; i++){
                const sourceIndex = i * elementStride + elementOffset;
                for(let j = 0; j < size; j++)result[targetIndex++] = typedArray[sourceIndex + j];
            }
        }
        return result;
    };
}

});

parcelRegister("ivBeX", function(module, exports) {

$parcel$export(module.exports, "flatten", function () { return $d798026641f8fd5c$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "fillArray", function () { return $d798026641f8fd5c$export$57295b69bf9c5d15; });
function $d798026641f8fd5c$export$bffa455ba8c619a6(array, filter = ()=>true) {
    if (!Array.isArray(array)) return filter(array) ? [
        array
    ] : [];
    return $d798026641f8fd5c$var$flattenArray(array, filter, []);
}
function $d798026641f8fd5c$var$flattenArray(array, filter, result) {
    let index = -1;
    while(++index < array.length){
        const value = array[index];
        if (Array.isArray(value)) $d798026641f8fd5c$var$flattenArray(value, filter, result);
        else if (filter(value)) result.push(value);
    }
    return result;
}
function $d798026641f8fd5c$export$57295b69bf9c5d15({ target: target, source: source, start: start = 0, count: count = 1 }) {
    const length = source.length;
    const total = count * length;
    let copied = 0;
    for(let i = start; copied < length; copied++)target[i++] = source[copied];
    while(copied < total)if (copied < total - copied) {
        target.copyWithin(start + copied, start, start + copied);
        copied *= 2;
    } else {
        target.copyWithin(start + copied, start, start + total - copied);
        copied = total;
    }
    return target;
}

});

parcelRegister("gZkNz", function(module, exports) {

$parcel$export(module.exports, "EMPTY", function () { return $c5e279fef72ada14$export$ccb33e29d92c9a58; });
$parcel$export(module.exports, "FULL", function () { return $c5e279fef72ada14$export$3789e4b2a10baa2b; });
$parcel$export(module.exports, "add", function () { return $c5e279fef72ada14$export$e16d8520af44a096; });
const $c5e279fef72ada14$export$ccb33e29d92c9a58 = [];
const $c5e279fef72ada14$export$3789e4b2a10baa2b = [
    [
        0,
        Infinity
    ]
];
function $c5e279fef72ada14$export$e16d8520af44a096(rangeList, range) {
    if (rangeList === $c5e279fef72ada14$export$3789e4b2a10baa2b) return rangeList;
    if (range[0] < 0) range[0] = 0;
    if (range[0] >= range[1]) return rangeList;
    const newRangeList = [];
    const len = rangeList.length;
    let insertPosition = 0;
    for(let i = 0; i < len; i++){
        const range0 = rangeList[i];
        if (range0[1] < range[0]) {
            newRangeList.push(range0);
            insertPosition = i + 1;
        } else if (range0[0] > range[1]) newRangeList.push(range0);
        else range = [
            Math.min(range0[0], range[0]),
            Math.max(range0[1], range[1])
        ];
    }
    newRangeList.splice(insertPosition, 0, range);
    return newRangeList;
}

});

parcelRegister("5YQrt", function(module, exports) {

$parcel$export(module.exports, "normalizeTransitionSettings", function () { return $45ab3c4309e9afdc$export$47e87a95cf522e8c; });
$parcel$export(module.exports, "getSourceBufferAttribute", function () { return $45ab3c4309e9afdc$export$f3e2a32ee07ef92d; });
$parcel$export(module.exports, "getAttributeTypeFromSize", function () { return $45ab3c4309e9afdc$export$4f893656e30128e9; });
$parcel$export(module.exports, "cycleBuffers", function () { return $45ab3c4309e9afdc$export$1dcce42e2b71f528; });
$parcel$export(module.exports, "getAttributeBufferLength", function () { return $45ab3c4309e9afdc$export$bd45d69169402c18; });
$parcel$export(module.exports, "padBuffer", function () { return $45ab3c4309e9afdc$export$28f1d2df7aaab3dd; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $kMV74 = parcelRequire("kMV74");
const $45ab3c4309e9afdc$var$DEFAULT_TRANSITION_SETTINGS = {
    interpolation: {
        duration: 0,
        easing: (t)=>t
    },
    spring: {
        stiffness: 0.05,
        damping: 0.5
    }
};
function $45ab3c4309e9afdc$export$47e87a95cf522e8c(userSettings, layerSettings) {
    if (!userSettings) return null;
    if (Number.isFinite(userSettings)) userSettings = {
        type: "interpolation",
        duration: userSettings
    };
    const type = userSettings.type || "interpolation";
    return (0, $edHbI._)((0, $2QP2i._)({}, $45ab3c4309e9afdc$var$DEFAULT_TRANSITION_SETTINGS[type], layerSettings, userSettings), {
        type: type
    });
}
function $45ab3c4309e9afdc$export$f3e2a32ee07ef92d(gl, attribute) {
    const buffer = attribute.getBuffer();
    if (buffer) return [
        buffer,
        {
            divisor: 0,
            size: attribute.size,
            normalized: attribute.settings.normalized
        }
    ];
    return attribute.value;
}
function $45ab3c4309e9afdc$export$4f893656e30128e9(size) {
    switch(size){
        case 1:
            return "float";
        case 2:
            return "vec2";
        case 3:
            return "vec3";
        case 4:
            return "vec4";
        default:
            throw new Error('No defined attribute type for size "'.concat(size, '"'));
    }
}
function $45ab3c4309e9afdc$export$1dcce42e2b71f528(buffers) {
    buffers.push(buffers.shift());
}
function $45ab3c4309e9afdc$export$bd45d69169402c18(attribute, numInstances) {
    const { doublePrecision: doublePrecision, settings: settings, value: value, size: size } = attribute;
    const multiplier = doublePrecision && value instanceof Float64Array ? 2 : 1;
    return (settings.noAlloc ? value.length : numInstances * size) * multiplier;
}
function $45ab3c4309e9afdc$export$28f1d2df7aaab3dd({ buffer: buffer, numInstances: numInstances, attribute: attribute, fromLength: fromLength, fromStartIndices: fromStartIndices, getData: getData = (x)=>x }) {
    const precisionMultiplier = attribute.doublePrecision && attribute.value instanceof Float64Array ? 2 : 1;
    const size = attribute.size * precisionMultiplier;
    const byteOffset = attribute.byteOffset;
    const toStartIndices = attribute.startIndices;
    const hasStartIndices = fromStartIndices && toStartIndices;
    const toLength = $45ab3c4309e9afdc$export$bd45d69169402c18(attribute, numInstances);
    const isConstant = attribute.isConstant;
    if (!hasStartIndices && fromLength >= toLength) return;
    const toData = isConstant ? attribute.value : attribute.getBuffer().getData({
        srcByteOffset: byteOffset
    });
    if (attribute.settings.normalized && !isConstant) {
        const getter = getData;
        getData = (value, chunk)=>attribute.normalizeConstant(getter(value, chunk));
    }
    const getMissingData = isConstant ? (i, chunk)=>getData(toData, chunk) : (i, chunk)=>getData(toData.subarray(i, i + size), chunk);
    const source = buffer.getData({
        length: fromLength
    });
    const data = new Float32Array(toLength);
    (0, $kMV74.padArray)({
        source: source,
        target: data,
        sourceStartIndices: fromStartIndices,
        targetStartIndices: toStartIndices,
        size: size,
        getData: getMissingData
    });
    if (buffer.byteLength < data.byteLength + byteOffset) buffer.reallocate(data.byteLength + byteOffset);
    buffer.subData({
        data: data,
        offset: byteOffset
    });
}

});
parcelRegister("kMV74", function(module, exports) {

$parcel$export(module.exports, "padArray", function () { return $f22497d3f23167c1$export$6735fc2994e30dd0; });
function $f22497d3f23167c1$var$padArrayChunk(options) {
    const { source: source, target: target, start: start = 0, size: size, getData: getData } = options;
    const end = options.end || target.length;
    const sourceLength = source.length;
    const targetLength = end - start;
    if (sourceLength > targetLength) {
        target.set(source.subarray(0, targetLength), start);
        return;
    }
    target.set(source, start);
    if (!getData) return;
    let i = sourceLength;
    while(i < targetLength){
        const datum = getData(i, source);
        for(let j = 0; j < size; j++){
            target[start + i] = datum[j] || 0;
            i++;
        }
    }
}
function $f22497d3f23167c1$export$6735fc2994e30dd0({ source: source, target: target, size: size, getData: getData, sourceStartIndices: sourceStartIndices, targetStartIndices: targetStartIndices }) {
    if (!Array.isArray(targetStartIndices)) {
        $f22497d3f23167c1$var$padArrayChunk({
            source: source,
            target: target,
            size: size,
            getData: getData
        });
        return target;
    }
    let sourceIndex = 0;
    let targetIndex = 0;
    const getChunkData = getData && ((i, chunk)=>getData(i + targetIndex, chunk));
    const n = Math.min(sourceStartIndices.length, targetStartIndices.length);
    for(let i = 1; i < n; i++){
        const nextSourceIndex = sourceStartIndices[i] * size;
        const nextTargetIndex = targetStartIndices[i] * size;
        $f22497d3f23167c1$var$padArrayChunk({
            source: source.subarray(sourceIndex, nextSourceIndex),
            target: target,
            start: targetIndex,
            end: nextTargetIndex,
            size: size,
            getData: getChunkData
        });
        sourceIndex = nextSourceIndex;
        targetIndex = nextTargetIndex;
    }
    if (targetIndex < target.length) $f22497d3f23167c1$var$padArrayChunk({
        source: [],
        target: target,
        start: targetIndex,
        size: size,
        getData: getChunkData
    });
    return target;
}

});



parcelRegister("b9Qhn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81f916889e64be5f$export$2e2bcd8739ae039; });
function $81f916889e64be5f$var$isEqual(a, b) {
    if (a === b) return true;
    if (Array.isArray(a)) {
        const len = a.length;
        if (!b || b.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}
function $81f916889e64be5f$export$2e2bcd8739ae039(compute) {
    let cachedArgs = {};
    let cachedResult;
    return (args)=>{
        for(const key in args)if (!$81f916889e64be5f$var$isEqual(args[key], cachedArgs[key])) {
            cachedResult = compute(args);
            cachedArgs = args;
            break;
        }
        return cachedResult;
    };
}

});

parcelRegister("bwVEZ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $864f68f6f4184a28$export$6503ec6e8aabbaf; });
$parcel$export(module.exports, "default", function () { return $864f68f6f4184a28$export$2e2bcd8739ae039; });

var $4VQgq = parcelRequire("4VQgq");

let $864f68f6f4184a28$var$loggers = {};
function $864f68f6f4184a28$export$6503ec6e8aabbaf(handlers) {
    $864f68f6f4184a28$var$loggers = handlers;
}
function $864f68f6f4184a28$export$2e2bcd8739ae039(eventType, arg1, arg2, arg3) {
    if ((0, $4VQgq.default).level > 0 && $864f68f6f4184a28$var$loggers[eventType]) $864f68f6f4184a28$var$loggers[eventType].call(null, arg1, arg2, arg3);
}

});

parcelRegister("9FKfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70abd2e4c8fe280c$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");

var $bn48C = parcelRequire("bn48C");

var $9P91Q = parcelRequire("9P91Q");

var $9qj3Q = parcelRequire("9qj3Q");

var $4VQgq = parcelRequire("4VQgq");
const $70abd2e4c8fe280c$var$TRANSITION_TYPES = {
    interpolation: (0, $9P91Q.default),
    spring: (0, $9qj3Q.default)
};
class $70abd2e4c8fe280c$export$2e2bcd8739ae039 {
    finalize() {
        for(const attributeName in this.transitions)this._removeTransition(attributeName);
    }
    update({ attributes: attributes, transitions: transitions, numInstances: numInstances }) {
        this.numInstances = numInstances || 1;
        for(const attributeName in attributes){
            const attribute = attributes[attributeName];
            const settings = attribute.getTransitionSetting(transitions);
            if (!settings) continue;
            this._updateAttribute(attributeName, attribute, settings);
        }
        for(const attributeName in this.transitions){
            const attribute = attributes[attributeName];
            if (!attribute || !attribute.getTransitionSetting(transitions)) this._removeTransition(attributeName);
        }
    }
    hasAttribute(attributeName) {
        const transition = this.transitions[attributeName];
        return transition && transition.inProgress;
    }
    getAttributes() {
        const animatedAttributes = {};
        for(const attributeName in this.transitions){
            const transition = this.transitions[attributeName];
            if (transition.inProgress) animatedAttributes[attributeName] = transition.attributeInTransition;
        }
        return animatedAttributes;
    }
    run() {
        if (!this.isSupported || this.numInstances === 0) return false;
        for(const attributeName in this.transitions){
            const updated = this.transitions[attributeName].update();
            if (updated) this.needsRedraw = true;
        }
        const needsRedraw = this.needsRedraw;
        this.needsRedraw = false;
        return needsRedraw;
    }
    _removeTransition(attributeName) {
        this.transitions[attributeName].cancel();
        delete this.transitions[attributeName];
    }
    _updateAttribute(attributeName, attribute, settings) {
        const transition = this.transitions[attributeName];
        let isNew = !transition || transition.type !== settings.type;
        if (isNew) {
            if (!this.isSupported) {
                (0, $4VQgq.default).warn("WebGL2 not supported by this browser. Transition for ".concat(attributeName, " is disabled."))();
                return;
            }
            if (transition) this._removeTransition(attributeName);
            const TransitionType = $70abd2e4c8fe280c$var$TRANSITION_TYPES[settings.type];
            if (TransitionType) this.transitions[attributeName] = new TransitionType({
                attribute: attribute,
                timeline: this.timeline,
                gl: this.gl
            });
            else {
                (0, $4VQgq.default).error("unsupported transition type '".concat(settings.type, "'"))();
                isNew = false;
            }
        }
        if (isNew || attribute.needsRedraw()) {
            this.needsRedraw = true;
            this.transitions[attributeName].start(settings, this.numInstances);
        }
    }
    constructor(gl, { id: id, timeline: timeline }){
        (0, $1zR3q.default)(this, "id", void 0);
        (0, $1zR3q.default)(this, "isSupported", void 0);
        (0, $1zR3q.default)(this, "gl", void 0);
        (0, $1zR3q.default)(this, "timeline", void 0);
        (0, $1zR3q.default)(this, "transitions", void 0);
        (0, $1zR3q.default)(this, "needsRedraw", void 0);
        (0, $1zR3q.default)(this, "numInstances", void 0);
        this.id = id;
        this.gl = gl;
        this.timeline = timeline;
        this.transitions = {};
        this.needsRedraw = false;
        this.numInstances = 1;
        this.isSupported = (0, $bn48C.default).isSupported(gl);
    }
}

});
parcelRegister("bn48C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84750d6b2adee031$export$2e2bcd8739ae039; });

var $1KKN0 = parcelRequire("1KKN0");

var $auNO8 = parcelRequire("auNO8");

var $lX8C6 = parcelRequire("lX8C6");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $ihfnu = parcelRequire("ihfnu");
var $6JLAh = parcelRequire("6JLAh");
var $iljOc = parcelRequire("iljOc");

var $b2F4S = parcelRequire("b2F4S");
class $84750d6b2adee031$export$2e2bcd8739ae039 {
    static isSupported(gl) {
        return (0, $8HKWo.isWebGL2)(gl);
    }
    delete() {
        const { model: model, bufferTransform: bufferTransform, textureTransform: textureTransform } = this;
        if (model) model.delete();
        if (bufferTransform) bufferTransform.delete();
        if (textureTransform) textureTransform.delete();
    }
    run() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { clearRenderTarget: clearRenderTarget = true } = opts;
        const updatedOpts = this._updateDrawOptions(opts);
        if (clearRenderTarget && updatedOpts.framebuffer) updatedOpts.framebuffer.clear({
            color: true
        });
        this.model.transform(updatedOpts);
    }
    swap() {
        let swapped = false;
        const resourceTransforms = [
            this.bufferTransform,
            this.textureTransform
        ].filter(Boolean);
        for (const resourceTransform of resourceTransforms)swapped = swapped || resourceTransform.swap();
        (0, $ihfnu.assert)(swapped, "Nothing to swap");
    }
    getBuffer() {
        let varyingName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return this.bufferTransform && this.bufferTransform.getBuffer(varyingName);
    }
    getData() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const resourceTransforms = [
            this.bufferTransform,
            this.textureTransform
        ].filter(Boolean);
        for (const resourceTransform of resourceTransforms){
            const data = resourceTransform.getData(opts);
            if (data) return data;
        }
        return null;
    }
    getFramebuffer() {
        return this.textureTransform && this.textureTransform.getFramebuffer();
    }
    update() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ("elementCount" in opts) this.model.setVertexCount(opts.elementCount);
        const resourceTransforms = [
            this.bufferTransform,
            this.textureTransform
        ].filter(Boolean);
        for (const resourceTransform of resourceTransforms)resourceTransform.update(opts);
    }
    _initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { gl: gl } = this;
        this._buildResourceTransforms(gl, props);
        props = this._updateModelProps(props);
        this.model = new (0, $b2F4S.default)(gl, Object.assign({}, props, {
            fs: props.fs || (0, $1KKN0.getPassthroughFS)({
                version: (0, $6JLAh.default)(props.vs)
            }),
            id: props.id || "transform-model",
            drawMode: props.drawMode || 0,
            vertexCount: props.elementCount
        }));
        this.bufferTransform && this.bufferTransform.setupResources({
            model: this.model
        });
    }
    _updateModelProps(props) {
        let updatedProps = Object.assign({}, props);
        const resourceTransforms = [
            this.bufferTransform,
            this.textureTransform
        ].filter(Boolean);
        for (const resourceTransform of resourceTransforms)updatedProps = resourceTransform.updateModelProps(updatedProps);
        return updatedProps;
    }
    _buildResourceTransforms(gl, props) {
        if ($84750d6b2adee031$var$canCreateBufferTransform(props)) this.bufferTransform = new (0, $auNO8.default)(gl, props);
        if ($84750d6b2adee031$var$canCreateTextureTransform(props)) this.textureTransform = new (0, $lX8C6.default)(gl, props);
        (0, $ihfnu.assert)(this.bufferTransform || this.textureTransform, "must provide source/feedback buffers or source/target textures");
    }
    _updateDrawOptions(opts) {
        let updatedOpts = Object.assign({}, opts);
        const resourceTransforms = [
            this.bufferTransform,
            this.textureTransform
        ].filter(Boolean);
        for (const resourceTransform of resourceTransforms)updatedOpts = Object.assign(updatedOpts, resourceTransform.getDrawOptions(updatedOpts));
        return updatedOpts;
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.gl = gl;
        this.model = null;
        this.elementCount = 0;
        this.bufferTransform = null;
        this.textureTransform = null;
        this.elementIDBuffer = null;
        this._initialize(props);
        Object.seal(this);
    }
}
function $84750d6b2adee031$var$canCreateBufferTransform(props) {
    if (!(0, $iljOc.isObjectEmpty)(props.feedbackBuffers) || !(0, $iljOc.isObjectEmpty)(props.feedbackMap) || props.varyings && props.varyings.length > 0) return true;
    return false;
}
function $84750d6b2adee031$var$canCreateTextureTransform(props) {
    if (!(0, $iljOc.isObjectEmpty)(props._sourceTextures) || props._targetTexture || props._targetTextureVarying) return true;
    return false;
}

});
parcelRegister("1KKN0", function(module, exports) {

$parcel$export(module.exports, "getQualifierDetails", function () { return $146e61b494399b02$export$ca11e09347dd6309; });
$parcel$export(module.exports, "getPassthroughFS", function () { return $146e61b494399b02$export$523a4d4d9f32ef9e; });
$parcel$export(module.exports, "typeToChannelSuffix", function () { return $146e61b494399b02$export$7c9d09032d11b05d; });
$parcel$export(module.exports, "typeToChannelCount", function () { return $146e61b494399b02$export$7d9650494fc7500d; });

var $8xCEr = parcelRequire("8xCEr");
const $146e61b494399b02$var$FS100 = "void main() {gl_FragColor = vec4(0);}";
const $146e61b494399b02$var$FS_GLES = "out vec4 transform_output;\nvoid main() {\n  transform_output = vec4(0);\n}";
const $146e61b494399b02$var$FS300 = "#version 300 es\n".concat($146e61b494399b02$var$FS_GLES);
function $146e61b494399b02$export$ca11e09347dd6309(line, qualifiers) {
    qualifiers = Array.isArray(qualifiers) ? qualifiers : [
        qualifiers
    ];
    const words = line.replace(/^\s+/, "").split(/\s+/);
    const [qualifier, type, definition] = words;
    if (!qualifiers.includes(qualifier) || !type || !definition) return null;
    const name = definition.split(";")[0];
    return {
        qualifier: qualifier,
        type: type,
        name: name
    };
}
function $146e61b494399b02$export$523a4d4d9f32ef9e() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { version: version = 100, input: input, inputType: inputType, output: output } = options;
    if (!input) {
        if (version === 300) return $146e61b494399b02$var$FS300;
        else if (version > 300) return "#version ".concat(version, "\n").concat($146e61b494399b02$var$FS_GLES);
        return $146e61b494399b02$var$FS100;
    }
    const outputValue = $146e61b494399b02$export$5616b9a44ef98392(input, inputType);
    if (version >= 300) return "#version ".concat(version, " ").concat(version === 300 ? "es" : "", "\nin ").concat(inputType, " ").concat(input, ";\nout vec4 ").concat(output, ";\nvoid main() {\n  ").concat(output, " = ").concat(outputValue, ";\n}");
    return "varying ".concat(inputType, " ").concat(input, ";\nvoid main() {\n  gl_FragColor = ").concat(outputValue, ";\n}");
}
function $146e61b494399b02$export$7c9d09032d11b05d(type) {
    switch(type){
        case "float":
            return "x";
        case "vec2":
            return "xy";
        case "vec3":
            return "xyz";
        case "vec4":
            return "xyzw";
        default:
            (0, $8xCEr.default)(false);
            return null;
    }
}
function $146e61b494399b02$export$7d9650494fc7500d(type) {
    switch(type){
        case "float":
            return 1;
        case "vec2":
            return 2;
        case "vec3":
            return 3;
        case "vec4":
            return 4;
        default:
            (0, $8xCEr.default)(false);
            return null;
    }
}
function $146e61b494399b02$export$5616b9a44ef98392(variable, type) {
    switch(type){
        case "float":
            return "vec4(".concat(variable, ", 0.0, 0.0, 1.0)");
        case "vec2":
            return "vec4(".concat(variable, ", 0.0, 1.0)");
        case "vec3":
            return "vec4(".concat(variable, ", 1.0)");
        case "vec4":
            return variable;
        default:
            (0, $8xCEr.default)(false);
            return null;
    }
}

});
parcelRegister("8xCEr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $637f63276c09f9d1$export$2e2bcd8739ae039; });
function $637f63276c09f9d1$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message || "shadertools: assertion failed.");
}

});


parcelRegister("auNO8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a43577758043528$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $ihfnu = parcelRequire("ihfnu");
var $7jraD = parcelRequire("7jraD");
var $9NVBT = parcelRequire("9NVBT");
class $7a43577758043528$export$2e2bcd8739ae039 {
    setupResources(opts) {
        for (const binding of this.bindings)this._setupTransformFeedback(binding, opts);
    }
    updateModelProps() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { varyings: varyings } = this;
        if (varyings.length > 0) props = Object.assign({}, props, {
            varyings: varyings
        });
        return props;
    }
    getDrawOptions() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const binding = this.bindings[this.currentIndex];
        const { sourceBuffers: sourceBuffers, transformFeedback: transformFeedback } = binding;
        const attributes = Object.assign({}, sourceBuffers, opts.attributes);
        return {
            attributes: attributes,
            transformFeedback: transformFeedback
        };
    }
    swap() {
        if (this.feedbackMap) {
            this.currentIndex = this._getNextIndex();
            return true;
        }
        return false;
    }
    update() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._setupBuffers(opts);
    }
    getBuffer(varyingName) {
        const { feedbackBuffers: feedbackBuffers } = this.bindings[this.currentIndex];
        const bufferOrParams = varyingName ? feedbackBuffers[varyingName] : null;
        if (!bufferOrParams) return null;
        return bufferOrParams instanceof (0, $7jraD.default) ? bufferOrParams : bufferOrParams.buffer;
    }
    getData() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { varyingName: varyingName } = options;
        const buffer = this.getBuffer(varyingName);
        if (buffer) return buffer.getData();
        return null;
    }
    delete() {
        for(const name in this.resources)this.resources[name].delete();
    }
    _initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._setupBuffers(props);
        this.varyings = props.varyings || Object.keys(this.bindings[this.currentIndex].feedbackBuffers);
        if (this.varyings.length > 0) (0, $ihfnu.assert)((0, $8HKWo.isWebGL2)(this.gl));
    }
    _getFeedbackBuffers(props) {
        const { sourceBuffers: sourceBuffers = {} } = props;
        const feedbackBuffers = {};
        if (this.bindings[this.currentIndex]) Object.assign(feedbackBuffers, this.bindings[this.currentIndex].feedbackBuffers);
        if (this.feedbackMap) for(const sourceName in this.feedbackMap){
            const feedbackName = this.feedbackMap[sourceName];
            if (sourceName in sourceBuffers) feedbackBuffers[feedbackName] = sourceName;
        }
        Object.assign(feedbackBuffers, props.feedbackBuffers);
        for(const bufferName in feedbackBuffers){
            const bufferOrRef = feedbackBuffers[bufferName];
            if (typeof bufferOrRef === "string") {
                const sourceBuffer = sourceBuffers[bufferOrRef];
                const { byteLength: byteLength, usage: usage, accessor: accessor } = sourceBuffer;
                feedbackBuffers[bufferName] = this._createNewBuffer(bufferName, {
                    byteLength: byteLength,
                    usage: usage,
                    accessor: accessor
                });
            }
        }
        return feedbackBuffers;
    }
    _setupBuffers() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { sourceBuffers: sourceBuffers = null } = props;
        Object.assign(this.feedbackMap, props.feedbackMap);
        const feedbackBuffers = this._getFeedbackBuffers(props);
        this._updateBindings({
            sourceBuffers: sourceBuffers,
            feedbackBuffers: feedbackBuffers
        });
    }
    _setupTransformFeedback(binding, _ref) {
        let { model: model } = _ref;
        const { program: program } = model;
        binding.transformFeedback = new (0, $9NVBT.default)(this.gl, {
            program: program,
            buffers: binding.feedbackBuffers
        });
    }
    _updateBindings(opts) {
        this.bindings[this.currentIndex] = this._updateBinding(this.bindings[this.currentIndex], opts);
        if (this.feedbackMap) {
            const { sourceBuffers: sourceBuffers, feedbackBuffers: feedbackBuffers } = this._swapBuffers(this.bindings[this.currentIndex]);
            const nextIndex = this._getNextIndex();
            this.bindings[nextIndex] = this._updateBinding(this.bindings[nextIndex], {
                sourceBuffers: sourceBuffers,
                feedbackBuffers: feedbackBuffers
            });
        }
    }
    _updateBinding(binding, opts) {
        if (!binding) return {
            sourceBuffers: Object.assign({}, opts.sourceBuffers),
            feedbackBuffers: Object.assign({}, opts.feedbackBuffers)
        };
        Object.assign(binding.sourceBuffers, opts.sourceBuffers);
        Object.assign(binding.feedbackBuffers, opts.feedbackBuffers);
        if (binding.transformFeedback) binding.transformFeedback.setBuffers(binding.feedbackBuffers);
        return binding;
    }
    _swapBuffers(opts) {
        if (!this.feedbackMap) return null;
        const sourceBuffers = Object.assign({}, opts.sourceBuffers);
        const feedbackBuffers = Object.assign({}, opts.feedbackBuffers);
        for(const srcName in this.feedbackMap){
            const dstName = this.feedbackMap[srcName];
            sourceBuffers[srcName] = opts.feedbackBuffers[dstName];
            feedbackBuffers[dstName] = opts.sourceBuffers[srcName];
            (0, $ihfnu.assert)(feedbackBuffers[dstName] instanceof (0, $7jraD.default));
        }
        return {
            sourceBuffers: sourceBuffers,
            feedbackBuffers: feedbackBuffers
        };
    }
    _createNewBuffer(name, opts) {
        const buffer = new (0, $7jraD.default)(this.gl, opts);
        if (this.resources[name]) this.resources[name].delete();
        this.resources[name] = buffer;
        return buffer;
    }
    _getNextIndex() {
        return (this.currentIndex + 1) % 2;
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.gl = gl;
        this.currentIndex = 0;
        this.feedbackMap = {};
        this.varyings = null;
        this.bindings = [];
        this.resources = {};
        this._initialize(props);
        Object.seal(this);
    }
}

});
parcelRegister("9NVBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $723560d53e143131$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");

var $1OVow = parcelRequire("1OVow");

var $7jraD = parcelRequire("7jraD");

var $iljOc = parcelRequire("iljOc");
class $723560d53e143131$export$2e2bcd8739ae039 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "TransformFeedback";
    }
    static isSupported(gl) {
        return (0, $8HKWo.isWebGL2)(gl);
    }
    initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.buffers = {};
        this.unused = {};
        this.configuration = null;
        this.bindOnUse = true;
        if (!(0, $iljOc.isObjectEmpty)(this.buffers)) this.bind(()=>this._unbindBuffers());
        this.setProps(props);
        return this;
    }
    setProps(props) {
        if ("program" in props) this.configuration = props.program && props.program.configuration;
        if ("configuration" in props) this.configuration = props.configuration;
        if ("bindOnUse" in props) props = props.bindOnUse;
        if ("buffers" in props) this.setBuffers(props.buffers);
    }
    setBuffers() {
        let buffers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.bind(()=>{
            for(const bufferName in buffers)this.setBuffer(bufferName, buffers[bufferName]);
        });
        return this;
    }
    setBuffer(locationOrName, bufferOrParams) {
        const location = this._getVaryingIndex(locationOrName);
        const { buffer: buffer, byteSize: byteSize, byteOffset: byteOffset } = this._getBufferParams(bufferOrParams);
        if (location < 0) {
            this.unused[locationOrName] = buffer;
            (0, $lvicK.log).warn("".concat(this.id, " unused varying buffer ").concat(locationOrName))();
            return this;
        }
        this.buffers[location] = bufferOrParams;
        if (!this.bindOnUse) this._bindBuffer(location, buffer, byteOffset, byteSize);
        return this;
    }
    begin() {
        let primitiveMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this.gl.bindTransformFeedback(36386, this.handle);
        this._bindBuffers();
        this.gl.beginTransformFeedback(primitiveMode);
        return this;
    }
    end() {
        this.gl.endTransformFeedback();
        this._unbindBuffers();
        this.gl.bindTransformFeedback(36386, null);
        return this;
    }
    _getBufferParams(bufferOrParams) {
        let byteOffset;
        let byteSize;
        let buffer;
        if (bufferOrParams instanceof (0, $7jraD.default) === false) {
            buffer = bufferOrParams.buffer;
            byteSize = bufferOrParams.byteSize;
            byteOffset = bufferOrParams.byteOffset;
        } else buffer = bufferOrParams;
        if (byteOffset !== undefined || byteSize !== undefined) {
            byteOffset = byteOffset || 0;
            byteSize = byteSize || buffer.byteLength - byteOffset;
        }
        return {
            buffer: buffer,
            byteOffset: byteOffset,
            byteSize: byteSize
        };
    }
    _getVaryingInfo(locationOrName) {
        return this.configuration && this.configuration.getVaryingInfo(locationOrName);
    }
    _getVaryingIndex(locationOrName) {
        if (this.configuration) return this.configuration.getVaryingInfo(locationOrName).location;
        const location = Number(locationOrName);
        return Number.isFinite(location) ? location : -1;
    }
    _bindBuffers() {
        if (this.bindOnUse) for(const bufferIndex in this.buffers){
            const { buffer: buffer, byteSize: byteSize, byteOffset: byteOffset } = this._getBufferParams(this.buffers[bufferIndex]);
            this._bindBuffer(bufferIndex, buffer, byteOffset, byteSize);
        }
    }
    _unbindBuffers() {
        if (this.bindOnUse) for(const bufferIndex in this.buffers)this._bindBuffer(bufferIndex, null);
    }
    _bindBuffer(index, buffer) {
        let byteOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        let byteSize = arguments.length > 3 ? arguments[3] : undefined;
        const handle = buffer && buffer.handle;
        if (!handle || byteSize === undefined) this.gl.bindBufferBase(35982, index, handle);
        else this.gl.bindBufferRange(35982, index, handle, byteOffset, byteSize);
        return this;
    }
    _createHandle() {
        return this.gl.createTransformFeedback();
    }
    _deleteHandle() {
        this.gl.deleteTransformFeedback(this.handle);
    }
    _bindHandle(handle) {
        this.gl.bindTransformFeedback(36386, this.handle);
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $8HKWo.assertWebGL2Context)(gl);
        super(gl, props);
        this.initialize(props);
        this.stubRemovedMethods("TransformFeedback", "v6.0", [
            "pause",
            "resume"
        ]);
        Object.seal(this);
    }
}

});


parcelRegister("lX8C6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffb5ca24af3cae9d$export$2e2bcd8739ae039; });

var $7jraD = parcelRequire("7jraD");
var $dwgJf = parcelRequire("dwgJf");
var $cJo7e = parcelRequire("cJo7e");
var $6JLAh = parcelRequire("6JLAh");
var $2YUMm = parcelRequire("2YUMm");
var $7lUAH = parcelRequire("7lUAH");

var $XETJo = parcelRequire("XETJo");
var $aSPd9 = parcelRequire("aSPd9");
var $1KKN0 = parcelRequire("1KKN0");

var $3VnAf = parcelRequire("3VnAf");
const $ffb5ca24af3cae9d$var$SRC_TEX_PARAMETER_OVERRIDES = {
    [10241]: 9728,
    [10240]: 9728,
    [10242]: 33071,
    [10243]: 33071
};
const $ffb5ca24af3cae9d$var$FS_OUTPUT_VARIABLE = "transform_output";
class $ffb5ca24af3cae9d$export$2e2bcd8739ae039 {
    updateModelProps() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const updatedModelProps = this._processVertexShader(props);
        return Object.assign({}, props, updatedModelProps);
    }
    getDrawOptions() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { sourceBuffers: sourceBuffers, sourceTextures: sourceTextures, framebuffer: framebuffer, targetTexture: targetTexture } = this.bindings[this.currentIndex];
        const attributes = Object.assign({}, sourceBuffers, opts.attributes);
        const uniforms = Object.assign({}, opts.uniforms);
        const parameters = Object.assign({}, opts.parameters);
        let discard = opts.discard;
        if (this.hasSourceTextures || this.hasTargetTexture) {
            attributes.transform_elementID = this.elementIDBuffer;
            for(const sampler in this.samplerTextureMap){
                const textureName = this.samplerTextureMap[sampler];
                uniforms[sampler] = sourceTextures[textureName];
            }
            this._setSourceTextureParameters();
            const sizeUniforms = (0, $3VnAf.getSizeUniforms)({
                sourceTextureMap: sourceTextures,
                targetTextureVarying: this.targetTextureVarying,
                targetTexture: targetTexture
            });
            Object.assign(uniforms, sizeUniforms);
        }
        if (this.hasTargetTexture) {
            discard = false;
            parameters.viewport = [
                0,
                0,
                framebuffer.width,
                framebuffer.height
            ];
        }
        return {
            attributes: attributes,
            framebuffer: framebuffer,
            uniforms: uniforms,
            discard: discard,
            parameters: parameters
        };
    }
    swap() {
        if (this._swapTexture) {
            this.currentIndex = this._getNextIndex();
            return true;
        }
        return false;
    }
    update() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._setupTextures(opts);
    }
    getTargetTexture() {
        const { targetTexture: targetTexture } = this.bindings[this.currentIndex];
        return targetTexture;
    }
    getData() {
        let { packed: packed = false } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { framebuffer: framebuffer } = this.bindings[this.currentIndex];
        const pixels = (0, $2YUMm.readPixelsToArray)(framebuffer);
        if (!packed) return pixels;
        const ArrayType = pixels.constructor;
        const channelCount = (0, $1KKN0.typeToChannelCount)(this.targetTextureType);
        const packedPixels = new ArrayType(pixels.length * channelCount / 4);
        let packCount = 0;
        for(let i = 0; i < pixels.length; i += 4)for(let j = 0; j < channelCount; j++)packedPixels[packCount++] = pixels[i + j];
        return packedPixels;
    }
    getFramebuffer() {
        const currentResources = this.bindings[this.currentIndex];
        return currentResources.framebuffer;
    }
    delete() {
        if (this.ownTexture) this.ownTexture.delete();
        if (this.elementIDBuffer) this.elementIDBuffer.delete();
    }
    _initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { _targetTextureVarying: _targetTextureVarying, _swapTexture: _swapTexture } = props;
        this._swapTexture = _swapTexture;
        this.targetTextureVarying = _targetTextureVarying;
        this.hasTargetTexture = _targetTextureVarying;
        this._setupTextures(props);
    }
    _createTargetTexture(props) {
        const { sourceTextures: sourceTextures, textureOrReference: textureOrReference } = props;
        if (textureOrReference instanceof (0, $7lUAH.default)) return textureOrReference;
        const refTexture = sourceTextures[textureOrReference];
        if (!refTexture) return null;
        this._targetRefTexName = textureOrReference;
        return this._createNewTexture(refTexture);
    }
    _setupTextures() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { sourceBuffers: sourceBuffers, _sourceTextures: _sourceTextures = {}, _targetTexture: _targetTexture } = props;
        const targetTexture = this._createTargetTexture({
            sourceTextures: _sourceTextures,
            textureOrReference: _targetTexture
        });
        this.hasSourceTextures = this.hasSourceTextures || _sourceTextures && Object.keys(_sourceTextures).length > 0;
        this._updateBindings({
            sourceBuffers: sourceBuffers,
            sourceTextures: _sourceTextures,
            targetTexture: targetTexture
        });
        if ("elementCount" in props) this._updateElementIDBuffer(props.elementCount);
    }
    _updateElementIDBuffer(elementCount) {
        if (typeof elementCount !== "number" || this.elementCount >= elementCount) return;
        const elementIds = new Float32Array(elementCount);
        elementIds.forEach((_, index, array)=>{
            array[index] = index;
        });
        if (!this.elementIDBuffer) this.elementIDBuffer = new (0, $7jraD.default)(this.gl, {
            data: elementIds,
            accessor: {
                size: 1
            }
        });
        else this.elementIDBuffer.setData({
            data: elementIds
        });
        this.elementCount = elementCount;
    }
    _updateBindings(opts) {
        this.bindings[this.currentIndex] = this._updateBinding(this.bindings[this.currentIndex], opts);
        if (this._swapTexture) {
            const { sourceTextures: sourceTextures, targetTexture: targetTexture } = this._swapTextures(this.bindings[this.currentIndex]);
            const nextIndex = this._getNextIndex();
            this.bindings[nextIndex] = this._updateBinding(this.bindings[nextIndex], {
                sourceTextures: sourceTextures,
                targetTexture: targetTexture
            });
        }
    }
    _updateBinding(binding, opts) {
        const { sourceBuffers: sourceBuffers, sourceTextures: sourceTextures, targetTexture: targetTexture } = opts;
        if (!binding) binding = {
            sourceBuffers: {},
            sourceTextures: {},
            targetTexture: null
        };
        Object.assign(binding.sourceTextures, sourceTextures);
        Object.assign(binding.sourceBuffers, sourceBuffers);
        if (targetTexture) {
            binding.targetTexture = targetTexture;
            const { width: width, height: height } = targetTexture;
            const { framebuffer: framebuffer } = binding;
            if (framebuffer) {
                framebuffer.update({
                    attachments: {
                        [36064]: targetTexture
                    },
                    resizeAttachments: false
                });
                framebuffer.resize({
                    width: width,
                    height: height
                });
            } else binding.framebuffer = new (0, $cJo7e.default)(this.gl, {
                id: "transform-framebuffer",
                width: width,
                height: height,
                attachments: {
                    [36064]: targetTexture
                }
            });
        }
        return binding;
    }
    _setSourceTextureParameters() {
        const index = this.currentIndex;
        const { sourceTextures: sourceTextures } = this.bindings[index];
        for(const name in sourceTextures)sourceTextures[name].setParameters($ffb5ca24af3cae9d$var$SRC_TEX_PARAMETER_OVERRIDES);
    }
    _swapTextures(opts) {
        if (!this._swapTexture) return null;
        const sourceTextures = Object.assign({}, opts.sourceTextures);
        sourceTextures[this._swapTexture] = opts.targetTexture;
        const targetTexture = opts.sourceTextures[this._swapTexture];
        return {
            sourceTextures: sourceTextures,
            targetTexture: targetTexture
        };
    }
    _createNewTexture(refTexture) {
        const texture = (0, $dwgJf.cloneTextureFrom)(refTexture, {
            parameters: {
                [10241]: 9728,
                [10240]: 9728,
                [10242]: 33071,
                [10243]: 33071
            },
            pixelStore: {
                [37440]: false
            }
        });
        if (this.ownTexture) this.ownTexture.delete();
        this.ownTexture = texture;
        return texture;
    }
    _getNextIndex() {
        return (this.currentIndex + 1) % 2;
    }
    _processVertexShader() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { sourceTextures: sourceTextures, targetTexture: targetTexture } = this.bindings[this.currentIndex];
        const { vs: vs, uniforms: uniforms, targetTextureType: targetTextureType, inject: inject, samplerTextureMap: samplerTextureMap } = (0, $3VnAf.updateForTextures)({
            vs: props.vs,
            sourceTextureMap: sourceTextures,
            targetTextureVarying: this.targetTextureVarying,
            targetTexture: targetTexture
        });
        const combinedInject = (0, $aSPd9.combineInjects)([
            props.inject || {},
            inject
        ]);
        this.targetTextureType = targetTextureType;
        this.samplerTextureMap = samplerTextureMap;
        const fs = props._fs || (0, $1KKN0.getPassthroughFS)({
            version: (0, $6JLAh.default)(vs),
            input: this.targetTextureVarying,
            inputType: targetTextureType,
            output: $ffb5ca24af3cae9d$var$FS_OUTPUT_VARIABLE
        });
        const modules = this.hasSourceTextures || this.targetTextureVarying ? [
            (0, $XETJo.transform)
        ].concat(props.modules || []) : props.modules;
        return {
            vs: vs,
            fs: fs,
            modules: modules,
            uniforms: uniforms,
            inject: combinedInject
        };
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.gl = gl;
        this.id = this.currentIndex = 0;
        this._swapTexture = null;
        this.targetTextureVarying = null;
        this.targetTextureType = null;
        this.samplerTextureMap = null;
        this.bindings = [];
        this.resources = {};
        this._initialize(props);
        Object.seal(this);
    }
}

});
parcelRegister("6JLAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e7bdb48183bff11$export$2e2bcd8739ae039; });
function $4e7bdb48183bff11$export$2e2bcd8739ae039(source) {
    let version = 100;
    const words = source.match(/[^\s]+/g);
    if (words.length >= 2 && words[0] === "#version") {
        const v = parseInt(words[1], 10);
        if (Number.isFinite(v)) version = v;
    }
    return version;
}

});

parcelRegister("XETJo", function(module, exports) {

$parcel$export(module.exports, "transform", function () { return $0b353c45a6af9394$export$51186ad6e864892a; });
const $0b353c45a6af9394$var$vs = "attribute float transform_elementID;\nvec2 transform_getPixelSizeHalf(vec2 size) {\n  return vec2(1.) / (2. * size);\n}\n\nvec2 transform_getPixelIndices(vec2 texSize, vec2 pixelSizeHalf) {\n  float yIndex = floor((transform_elementID / texSize[0]) + pixelSizeHalf[1]);\n  float xIndex = transform_elementID - (yIndex * texSize[0]);\n  return vec2(xIndex, yIndex);\n}\nvec2 transform_getTexCoord(vec2 size) {\n  vec2 pixelSizeHalf = transform_getPixelSizeHalf(size);\n  vec2 indices = transform_getPixelIndices(size, pixelSizeHalf);\n  vec2 coord = indices / size + pixelSizeHalf;\n  return coord;\n}\nvec2 transform_getPos(vec2 size) {\n  vec2 texCoord = transform_getTexCoord(size);\n  vec2 pos = (texCoord * (2.0, 2.0)) - (1., 1.);\n  return pos;\n}\nvec4 transform_getInput(sampler2D texSampler, vec2 size) {\n  vec2 texCoord = transform_getTexCoord(size);\n  vec4 textureColor = texture2D(texSampler, texCoord);\n  return textureColor;\n}\n";
const $0b353c45a6af9394$export$51186ad6e864892a = {
    name: "transform",
    vs: $0b353c45a6af9394$var$vs,
    fs: null
};

});

parcelRegister("aSPd9", function(module, exports) {

$parcel$export(module.exports, "DECLARATION_INJECT_MARKER", function () { return $7ec6abfdba2183d9$export$62f6e317489649e6; });
$parcel$export(module.exports, "default", function () { return $7ec6abfdba2183d9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "combineInjects", function () { return $7ec6abfdba2183d9$export$cef13ee8fb8f32f3; });

var $b5peF = parcelRequire("b5peF");

var $lRcQn = parcelRequire("lRcQn");

var $8xCEr = parcelRequire("8xCEr");
const $7ec6abfdba2183d9$var$MODULE_INJECTORS = {
    [(0, $lRcQn.VERTEX_SHADER)]: (0, $b5peF.MODULE_INJECTORS_VS),
    [(0, $lRcQn.FRAGMENT_SHADER)]: (0, $b5peF.MODULE_INJECTORS_FS)
};
const $7ec6abfdba2183d9$export$62f6e317489649e6 = "__LUMA_INJECT_DECLARATIONS__";
const $7ec6abfdba2183d9$var$REGEX_START_OF_MAIN = /void\s+main\s*\([^)]*\)\s*\{\n?/;
const $7ec6abfdba2183d9$var$REGEX_END_OF_MAIN = /}\n?[^{}]*$/;
const $7ec6abfdba2183d9$var$fragments = [];
function $7ec6abfdba2183d9$export$2e2bcd8739ae039(source, type, inject) {
    let injectStandardStubs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const isVertex = type === (0, $lRcQn.VERTEX_SHADER);
    for(const key in inject){
        const fragmentData = inject[key];
        fragmentData.sort((a, b)=>a.order - b.order);
        $7ec6abfdba2183d9$var$fragments.length = fragmentData.length;
        for(let i = 0, len = fragmentData.length; i < len; ++i)$7ec6abfdba2183d9$var$fragments[i] = fragmentData[i].injection;
        const fragmentString = "".concat($7ec6abfdba2183d9$var$fragments.join("\n"), "\n");
        switch(key){
            case "vs:#decl":
                if (isVertex) source = source.replace($7ec6abfdba2183d9$export$62f6e317489649e6, fragmentString);
                break;
            case "vs:#main-start":
                if (isVertex) source = source.replace($7ec6abfdba2183d9$var$REGEX_START_OF_MAIN, (match)=>match + fragmentString);
                break;
            case "vs:#main-end":
                if (isVertex) source = source.replace($7ec6abfdba2183d9$var$REGEX_END_OF_MAIN, (match)=>fragmentString + match);
                break;
            case "fs:#decl":
                if (!isVertex) source = source.replace($7ec6abfdba2183d9$export$62f6e317489649e6, fragmentString);
                break;
            case "fs:#main-start":
                if (!isVertex) source = source.replace($7ec6abfdba2183d9$var$REGEX_START_OF_MAIN, (match)=>match + fragmentString);
                break;
            case "fs:#main-end":
                if (!isVertex) source = source.replace($7ec6abfdba2183d9$var$REGEX_END_OF_MAIN, (match)=>fragmentString + match);
                break;
            default:
                source = source.replace(key, (match)=>match + fragmentString);
        }
    }
    source = source.replace($7ec6abfdba2183d9$export$62f6e317489649e6, "");
    if (injectStandardStubs) source = source.replace(/\}\s*$/, (match)=>match + $7ec6abfdba2183d9$var$MODULE_INJECTORS[type]);
    return source;
}
function $7ec6abfdba2183d9$export$cef13ee8fb8f32f3(injects) {
    const result = {};
    (0, $8xCEr.default)(Array.isArray(injects) && injects.length > 1);
    injects.forEach((inject)=>{
        for(const key in inject)result[key] = result[key] ? "".concat(result[key], "\n").concat(inject[key]) : inject[key];
    });
    return result;
}

});
parcelRegister("b5peF", function(module, exports) {

$parcel$export(module.exports, "MODULE_INJECTORS_VS", function () { return $8123bc9e6b497087$export$1c7c27df7700ab1e; });
$parcel$export(module.exports, "MODULE_INJECTORS_FS", function () { return $8123bc9e6b497087$export$eb0c6f0420228c53; });
const $8123bc9e6b497087$export$1c7c27df7700ab1e = "#ifdef MODULE_LOGDEPTH\n  logdepth_adjustPosition(gl_Position);\n#endif\n";
const $8123bc9e6b497087$export$eb0c6f0420228c53 = "#ifdef MODULE_MATERIAL\n  gl_FragColor = material_filterColor(gl_FragColor);\n#endif\n\n#ifdef MODULE_LIGHTING\n  gl_FragColor = lighting_filterColor(gl_FragColor);\n#endif\n\n#ifdef MODULE_FOG\n  gl_FragColor = fog_filterColor(gl_FragColor);\n#endif\n\n#ifdef MODULE_PICKING\n  gl_FragColor = picking_filterHighlightColor(gl_FragColor);\n  gl_FragColor = picking_filterPickingColor(gl_FragColor);\n#endif\n\n#ifdef MODULE_LOGDEPTH\n  logdepth_setFragDepth();\n#endif\n";

});

parcelRegister("lRcQn", function(module, exports) {

$parcel$export(module.exports, "VERTEX_SHADER", function () { return $fe9882bd360d0947$export$9abae82e87f5416d; });
$parcel$export(module.exports, "FRAGMENT_SHADER", function () { return $fe9882bd360d0947$export$71cb6c7fe82525af; });
const $fe9882bd360d0947$export$9abae82e87f5416d = "vs";
const $fe9882bd360d0947$export$71cb6c7fe82525af = "fs";

});


parcelRegister("3VnAf", function(module, exports) {

$parcel$export(module.exports, "updateForTextures", function () { return $2db8fd306aca72f6$export$5a059e62d0049ef0; });
$parcel$export(module.exports, "getSizeUniforms", function () { return $2db8fd306aca72f6$export$9265f23b64eee61d; });

var $ihfnu = parcelRequire("ihfnu");

var $aSPd9 = parcelRequire("aSPd9");
var $1KKN0 = parcelRequire("1KKN0");
const $2db8fd306aca72f6$var$SAMPLER_UNIFORM_PREFIX = "transform_uSampler_";
const $2db8fd306aca72f6$var$SIZE_UNIFORM_PREFIX = "transform_uSize_";
const $2db8fd306aca72f6$var$VS_POS_VARIABLE = "transform_position";
function $2db8fd306aca72f6$export$5a059e62d0049ef0(_ref) {
    let { vs: vs, sourceTextureMap: sourceTextureMap, targetTextureVarying: targetTextureVarying, targetTexture: targetTexture } = _ref;
    const texAttributeNames = Object.keys(sourceTextureMap);
    let sourceCount = texAttributeNames.length;
    let targetTextureType = null;
    const samplerTextureMap = {};
    let updatedVs = vs;
    let finalInject = {};
    if (sourceCount > 0 || targetTextureVarying) {
        const vsLines = updatedVs.split("\n");
        const updateVsLines = vsLines.slice();
        vsLines.forEach((line, index, lines)=>{
            if (sourceCount > 0) {
                const updated = $2db8fd306aca72f6$export$b3d21cd7dabd1c6(line, sourceTextureMap);
                if (updated) {
                    const { updatedLine: updatedLine, inject: inject } = updated;
                    updateVsLines[index] = updatedLine;
                    finalInject = (0, $aSPd9.combineInjects)([
                        finalInject,
                        inject
                    ]);
                    Object.assign(samplerTextureMap, updated.samplerTextureMap);
                    sourceCount--;
                }
            }
            if (targetTextureVarying && !targetTextureType) targetTextureType = $2db8fd306aca72f6$export$997a69001b588146(line, targetTextureVarying);
        });
        if (targetTextureVarying) {
            (0, $ihfnu.assert)(targetTexture);
            const sizeName = "".concat($2db8fd306aca72f6$var$SIZE_UNIFORM_PREFIX).concat(targetTextureVarying);
            const uniformDeclaration = "uniform vec2 ".concat(sizeName, ";\n");
            const posInstructions = "     vec2 ".concat($2db8fd306aca72f6$var$VS_POS_VARIABLE, " = transform_getPos(").concat(sizeName, ");\n     gl_Position = vec4(").concat($2db8fd306aca72f6$var$VS_POS_VARIABLE, ", 0, 1.);\n");
            const inject = {
                "vs:#decl": uniformDeclaration,
                "vs:#main-start": posInstructions
            };
            finalInject = (0, $aSPd9.combineInjects)([
                finalInject,
                inject
            ]);
        }
        updatedVs = updateVsLines.join("\n");
    }
    return {
        vs: updatedVs,
        targetTextureType: targetTextureType,
        inject: finalInject,
        samplerTextureMap: samplerTextureMap
    };
}
function $2db8fd306aca72f6$export$9265f23b64eee61d(_ref2) {
    let { sourceTextureMap: sourceTextureMap, targetTextureVarying: targetTextureVarying, targetTexture: targetTexture } = _ref2;
    const uniforms = {};
    let width;
    let height;
    if (targetTextureVarying) {
        ({ width: width, height: height } = targetTexture);
        uniforms["".concat($2db8fd306aca72f6$var$SIZE_UNIFORM_PREFIX).concat(targetTextureVarying)] = [
            width,
            height
        ];
    }
    for(const textureName in sourceTextureMap){
        ({ width: width, height: height } = sourceTextureMap[textureName]);
        uniforms["".concat($2db8fd306aca72f6$var$SIZE_UNIFORM_PREFIX).concat(textureName)] = [
            width,
            height
        ];
    }
    return uniforms;
}
function $2db8fd306aca72f6$var$getAttributeDefinition(line) {
    return (0, $1KKN0.getQualifierDetails)(line, [
        "attribute",
        "in"
    ]);
}
function $2db8fd306aca72f6$var$getSamplerDeclerations(textureName) {
    const samplerName = "".concat($2db8fd306aca72f6$var$SAMPLER_UNIFORM_PREFIX).concat(textureName);
    const sizeName = "".concat($2db8fd306aca72f6$var$SIZE_UNIFORM_PREFIX).concat(textureName);
    const uniformDeclerations = "  uniform sampler2D ".concat(samplerName, ";\n  uniform vec2 ").concat(sizeName, ";");
    return {
        samplerName: samplerName,
        sizeName: sizeName,
        uniformDeclerations: uniformDeclerations
    };
}
function $2db8fd306aca72f6$export$997a69001b588146(line, varying) {
    const qualaiferDetails = (0, $1KKN0.getQualifierDetails)(line, [
        "varying",
        "out"
    ]);
    if (!qualaiferDetails) return null;
    return qualaiferDetails.name === varying ? qualaiferDetails.type : null;
}
function $2db8fd306aca72f6$export$b3d21cd7dabd1c6(line, textureMap) {
    const samplerTextureMap = {};
    const attributeData = $2db8fd306aca72f6$var$getAttributeDefinition(line);
    if (!attributeData) return null;
    const { type: type, name: name } = attributeData;
    if (name && textureMap[name]) {
        const updatedLine = "// ".concat(line, " => Replaced by Transform with a sampler");
        const { samplerName: samplerName, sizeName: sizeName, uniformDeclerations: uniformDeclerations } = $2db8fd306aca72f6$var$getSamplerDeclerations(name);
        const channels = (0, $1KKN0.typeToChannelSuffix)(type);
        const sampleInstruction = "  ".concat(type, " ").concat(name, " = transform_getInput(").concat(samplerName, ", ").concat(sizeName, ").").concat(channels, ";\n");
        samplerTextureMap[samplerName] = name;
        const inject = {
            "vs:#decl": uniformDeclerations,
            "vs:#main-start": sampleInstruction
        };
        return {
            updatedLine: updatedLine,
            inject: inject,
            samplerTextureMap: samplerTextureMap
        };
    }
    return null;
}

});


parcelRegister("b2F4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $809fbec796c7ebe6$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $ablN0 = parcelRequire("ablN0");

var $ihfnu = parcelRequire("ihfnu");
var $7jraD = parcelRequire("7jraD");
var $eU1YY = parcelRequire("eU1YY");
var $5Ha6k = parcelRequire("5Ha6k");
var $j4CMX = parcelRequire("j4CMX");
var $4wHgq = parcelRequire("4wHgq");
var $iljOc = parcelRequire("iljOc");parcelRequire("73UuK");
var $lvicK = parcelRequire("lvicK");
var $dwmuk = parcelRequire("dwmuk");
var $9NVBT = parcelRequire("9NVBT");
var $b7Tm8 = parcelRequire("b7Tm8");

var $lrhVz = parcelRequire("lrhVz");
const $809fbec796c7ebe6$var$LOG_DRAW_PRIORITY = 2;
const $809fbec796c7ebe6$var$LOG_DRAW_TIMEOUT = 10000;
const $809fbec796c7ebe6$var$ERR_MODEL_PARAMS = "Model needs drawMode and vertexCount";
const $809fbec796c7ebe6$var$NOOP = ()=>{};
const $809fbec796c7ebe6$var$DRAW_PARAMS = {};
class $809fbec796c7ebe6$export$2e2bcd8739ae039 {
    initialize(props) {
        this.props = {};
        this.programManager = props.programManager || (0, $ablN0.default).getDefaultProgramManager(this.gl);
        this._programManagerState = -1;
        this._managedProgram = false;
        const { program: program = null, vs: vs, fs: fs, modules: modules, defines: defines, inject: inject, varyings: varyings, bufferMode: bufferMode, transpileToGLSL100: transpileToGLSL100 } = props;
        this.programProps = {
            program: program,
            vs: vs,
            fs: fs,
            modules: modules,
            defines: defines,
            inject: inject,
            varyings: varyings,
            bufferMode: bufferMode,
            transpileToGLSL100: transpileToGLSL100
        };
        this.program = null;
        this.vertexArray = null;
        this._programDirty = true;
        this.userData = {};
        this.needsRedraw = true;
        this._attributes = {};
        this.attributes = {};
        this.uniforms = {};
        this.pickable = true;
        this._checkProgram();
        this.setUniforms(Object.assign({}, this.getModuleUniforms(props.moduleSettings)));
        this.drawMode = props.drawMode !== undefined ? props.drawMode : 4;
        this.vertexCount = props.vertexCount || 0;
        this.geometryBuffers = {};
        this.isInstanced = props.isInstanced || props.instanced || props.instanceCount > 0;
        this._setModelProps(props);
        this.geometry = {};
        (0, $ihfnu.assert)(this.drawMode !== undefined && Number.isFinite(this.vertexCount), $809fbec796c7ebe6$var$ERR_MODEL_PARAMS);
    }
    setProps(props) {
        this._setModelProps(props);
    }
    delete() {
        for(const key in this._attributes)if (this._attributes[key] !== this.attributes[key]) this._attributes[key].delete();
        if (this._managedProgram) {
            this.programManager.release(this.program);
            this._managedProgram = false;
        }
        this.vertexArray.delete();
        this._deleteGeometryBuffers();
    }
    getDrawMode() {
        return this.drawMode;
    }
    getVertexCount() {
        return this.vertexCount;
    }
    getInstanceCount() {
        return this.instanceCount;
    }
    getAttributes() {
        return this.attributes;
    }
    getProgram() {
        return this.program;
    }
    setProgram(props) {
        const { program: program, vs: vs, fs: fs, modules: modules, defines: defines, inject: inject, varyings: varyings, bufferMode: bufferMode, transpileToGLSL100: transpileToGLSL100 } = props;
        this.programProps = {
            program: program,
            vs: vs,
            fs: fs,
            modules: modules,
            defines: defines,
            inject: inject,
            varyings: varyings,
            bufferMode: bufferMode,
            transpileToGLSL100: transpileToGLSL100
        };
        this._programDirty = true;
    }
    getUniforms() {
        return this.uniforms;
    }
    setDrawMode(drawMode) {
        this.drawMode = drawMode;
        return this;
    }
    setVertexCount(vertexCount) {
        (0, $ihfnu.assert)(Number.isFinite(vertexCount));
        this.vertexCount = vertexCount;
        return this;
    }
    setInstanceCount(instanceCount) {
        (0, $ihfnu.assert)(Number.isFinite(instanceCount));
        this.instanceCount = instanceCount;
        return this;
    }
    setGeometry(geometry) {
        this.drawMode = geometry.drawMode;
        this.vertexCount = geometry.getVertexCount();
        this._deleteGeometryBuffers();
        this.geometryBuffers = (0, $lrhVz.getBuffersFromGeometry)(this.gl, geometry);
        this.vertexArray.setAttributes(this.geometryBuffers);
        return this;
    }
    setAttributes() {
        let attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $iljOc.isObjectEmpty)(attributes)) return this;
        const normalizedAttributes = {};
        for(const name in attributes){
            const attribute = attributes[name];
            normalizedAttributes[name] = attribute.getValue ? attribute.getValue() : attribute;
        }
        this.vertexArray.setAttributes(normalizedAttributes);
        return this;
    }
    setUniforms() {
        let uniforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        Object.assign(this.uniforms, uniforms);
        return this;
    }
    getModuleUniforms(opts) {
        this._checkProgram();
        const getUniforms = this.programManager.getUniforms(this.program);
        if (getUniforms) return getUniforms(opts);
        return {};
    }
    updateModuleSettings(opts) {
        const uniforms = this.getModuleUniforms(opts || {});
        return this.setUniforms(uniforms);
    }
    clear(opts) {
        (0, $eU1YY.clear)(this.program.gl, opts);
        return this;
    }
    draw() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._checkProgram();
        const { moduleSettings: moduleSettings = null, framebuffer: framebuffer, uniforms: uniforms = {}, attributes: attributes = {}, transformFeedback: transformFeedback = this.transformFeedback, parameters: parameters = {}, vertexArray: vertexArray = this.vertexArray } = opts;
        this.setAttributes(attributes);
        this.updateModuleSettings(moduleSettings);
        this.setUniforms(uniforms);
        let logPriority;
        if ((0, $lvicK.log).priority >= $809fbec796c7ebe6$var$LOG_DRAW_PRIORITY) logPriority = this._logDrawCallStart($809fbec796c7ebe6$var$LOG_DRAW_PRIORITY);
        const drawParams = this.vertexArray.getDrawParams();
        const { isIndexed: isIndexed = drawParams.isIndexed, indexType: indexType = drawParams.indexType, indexOffset: indexOffset = drawParams.indexOffset, vertexArrayInstanced: vertexArrayInstanced = drawParams.isInstanced } = this.props;
        if (vertexArrayInstanced && !this.isInstanced) (0, $lvicK.log).warn("Found instanced attributes on non-instanced model", this.id)();
        const { isInstanced: isInstanced, instanceCount: instanceCount } = this;
        const { onBeforeRender: onBeforeRender = $809fbec796c7ebe6$var$NOOP, onAfterRender: onAfterRender = $809fbec796c7ebe6$var$NOOP } = this.props;
        onBeforeRender();
        this.program.setUniforms(this.uniforms);
        const didDraw = this.program.draw(Object.assign($809fbec796c7ebe6$var$DRAW_PARAMS, opts, {
            logPriority: logPriority,
            uniforms: null,
            framebuffer: framebuffer,
            parameters: parameters,
            drawMode: this.getDrawMode(),
            vertexCount: this.getVertexCount(),
            vertexArray: vertexArray,
            transformFeedback: transformFeedback,
            isIndexed: isIndexed,
            indexType: indexType,
            isInstanced: isInstanced,
            instanceCount: instanceCount,
            offset: isIndexed ? indexOffset : 0
        }));
        onAfterRender();
        if ((0, $lvicK.log).priority >= $809fbec796c7ebe6$var$LOG_DRAW_PRIORITY) this._logDrawCallEnd(logPriority, vertexArray, framebuffer);
        return didDraw;
    }
    transform() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { discard: discard = true, feedbackBuffers: feedbackBuffers, unbindModels: unbindModels = [] } = opts;
        let { parameters: parameters } = opts;
        if (feedbackBuffers) this._setFeedbackBuffers(feedbackBuffers);
        if (discard) parameters = Object.assign({}, parameters, {
            [35977]: discard
        });
        unbindModels.forEach((model)=>model.vertexArray.unbindBuffers());
        try {
            this.draw(Object.assign({}, opts, {
                parameters: parameters
            }));
        } finally{
            unbindModels.forEach((model)=>model.vertexArray.bindBuffers());
        }
        return this;
    }
    render() {
        let uniforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $lvicK.log).warn("Model.render() is deprecated. Use Model.setUniforms() and Model.draw()")();
        return this.setUniforms(uniforms).draw();
    }
    _setModelProps(props) {
        Object.assign(this.props, props);
        if ("uniforms" in props) this.setUniforms(props.uniforms);
        if ("pickable" in props) this.pickable = props.pickable;
        if ("instanceCount" in props) this.instanceCount = props.instanceCount;
        if ("geometry" in props) this.setGeometry(props.geometry);
        if ("attributes" in props) this.setAttributes(props.attributes);
        if ("_feedbackBuffers" in props) this._setFeedbackBuffers(props._feedbackBuffers);
    }
    _checkProgram() {
        const needsUpdate = this._programDirty || this.programManager.stateHash !== this._programManagerState;
        if (!needsUpdate) return;
        let { program: program } = this.programProps;
        if (program) this._managedProgram = false;
        else {
            const { vs: vs, fs: fs, modules: modules, inject: inject, defines: defines, varyings: varyings, bufferMode: bufferMode, transpileToGLSL100: transpileToGLSL100 } = this.programProps;
            program = this.programManager.get({
                vs: vs,
                fs: fs,
                modules: modules,
                inject: inject,
                defines: defines,
                varyings: varyings,
                bufferMode: bufferMode,
                transpileToGLSL100: transpileToGLSL100
            });
            if (this.program && this._managedProgram) this.programManager.release(this.program);
            this._programManagerState = this.programManager.stateHash;
            this._managedProgram = true;
        }
        (0, $ihfnu.assert)(program instanceof (0, $dwmuk.default), "Model needs a program");
        this._programDirty = false;
        if (program === this.program) return;
        this.program = program;
        if (this.vertexArray) this.vertexArray.setProps({
            program: this.program,
            attributes: this.vertexArray.attributes
        });
        else this.vertexArray = new (0, $b7Tm8.default)(this.gl, {
            program: this.program
        });
        this.setUniforms(Object.assign({}, this.getModuleUniforms()));
    }
    _deleteGeometryBuffers() {
        for(const name in this.geometryBuffers){
            const buffer = this.geometryBuffers[name][0] || this.geometryBuffers[name];
            if (buffer instanceof (0, $7jraD.default)) buffer.delete();
        }
    }
    _setAnimationProps(animationProps) {
        if (this.animated) (0, $ihfnu.assert)(animationProps, "Model.draw(): animated uniforms but no animationProps");
    }
    _setFeedbackBuffers() {
        let feedbackBuffers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $iljOc.isObjectEmpty)(feedbackBuffers)) return this;
        const { gl: gl } = this.program;
        this.transformFeedback = this.transformFeedback || new (0, $9NVBT.default)(gl, {
            program: this.program
        });
        this.transformFeedback.setBuffers(feedbackBuffers);
        return this;
    }
    _logDrawCallStart(logLevel) {
        const logDrawTimeout = logLevel > 3 ? 0 : $809fbec796c7ebe6$var$LOG_DRAW_TIMEOUT;
        if (Date.now() - this.lastLogTime < logDrawTimeout) return undefined;
        this.lastLogTime = Date.now();
        (0, $lvicK.log).group($809fbec796c7ebe6$var$LOG_DRAW_PRIORITY, ">>> DRAWING MODEL ".concat(this.id), {
            collapsed: (0, $lvicK.log).level <= 2
        })();
        return logLevel;
    }
    _logDrawCallEnd(logLevel, vertexArray, uniforms, framebuffer) {
        if (logLevel === undefined) return;
        const attributeTable = (0, $4wHgq.getDebugTableForVertexArray)({
            vertexArray: vertexArray,
            header: "".concat(this.id, " attributes"),
            attributes: this._attributes
        });
        const { table: uniformTable, unusedTable: unusedTable, unusedCount: unusedCount } = (0, $j4CMX.getDebugTableForUniforms)({
            header: "".concat(this.id, " uniforms"),
            program: this.program,
            uniforms: Object.assign({}, this.program.uniforms, uniforms)
        });
        const { table: missingTable, count: missingCount } = (0, $j4CMX.getDebugTableForUniforms)({
            header: "".concat(this.id, " uniforms"),
            program: this.program,
            uniforms: Object.assign({}, this.program.uniforms, uniforms),
            undefinedOnly: true
        });
        if (missingCount > 0) (0, $lvicK.log).log("MISSING UNIFORMS", Object.keys(missingTable))();
        if (unusedCount > 0) (0, $lvicK.log).log("UNUSED UNIFORMS", Object.keys(unusedTable))();
        const configTable = (0, $5Ha6k.getDebugTableForProgramConfiguration)(this.vertexArray.configuration);
        (0, $lvicK.log).table(logLevel, attributeTable)();
        (0, $lvicK.log).table(logLevel, uniformTable)();
        (0, $lvicK.log).table(logLevel + 1, configTable)();
        if (framebuffer) framebuffer.log({
            logLevel: $809fbec796c7ebe6$var$LOG_DRAW_PRIORITY,
            message: "Rendered to ".concat(framebuffer.id)
        });
        (0, $lvicK.log).groupEnd($809fbec796c7ebe6$var$LOG_DRAW_PRIORITY)();
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const { id: id = (0, $iljOc.uid)("model") } = props;
        (0, $ihfnu.assert)((0, $8HKWo.isWebGL)(gl));
        this.id = id;
        this.gl = gl;
        this.id = props.id || (0, $iljOc.uid)("Model");
        this.lastLogTime = 0;
        this.animated = false;
        this.initialize(props);
    }
}

});
parcelRegister("ablN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $769bd5617b097dba$export$2e2bcd8739ae039; });

var $bboEJ = parcelRequire("bboEJ");

var $dwmuk = parcelRequire("dwmuk");
class $769bd5617b097dba$export$2e2bcd8739ae039 {
    static getDefaultProgramManager(gl) {
        gl.luma = gl.luma || {};
        gl.luma.defaultProgramManager = gl.luma.defaultProgramManager || new $769bd5617b097dba$export$2e2bcd8739ae039(gl);
        return gl.luma.defaultProgramManager;
    }
    addDefaultModule(module) {
        if (!this._defaultModules.find((m)=>m.name === module.name)) this._defaultModules.push(module);
        this.stateHash++;
    }
    removeDefaultModule(module) {
        const moduleName = typeof module === "string" ? module : module.name;
        this._defaultModules = this._defaultModules.filter((m)=>m.name !== moduleName);
        this.stateHash++;
    }
    addShaderHook(hook, opts) {
        if (opts) hook = Object.assign(opts, {
            hook: hook
        });
        this._hookFunctions.push(hook);
        this.stateHash++;
    }
    get() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { vs: vs = "", fs: fs = "", defines: defines = {}, inject: inject = {}, varyings: varyings = [], bufferMode: bufferMode = 0x8c8d, transpileToGLSL100: transpileToGLSL100 = false } = props;
        const modules = this._getModuleList(props.modules);
        const vsHash = this._getHash(vs);
        const fsHash = this._getHash(fs);
        const moduleHashes = modules.map((m)=>this._getHash(m.name)).sort();
        const varyingHashes = varyings.map((v)=>this._getHash(v));
        const defineKeys = Object.keys(defines).sort();
        const injectKeys = Object.keys(inject).sort();
        const defineHashes = [];
        const injectHashes = [];
        for (const key of defineKeys){
            defineHashes.push(this._getHash(key));
            defineHashes.push(this._getHash(defines[key]));
        }
        for (const key of injectKeys){
            injectHashes.push(this._getHash(key));
            injectHashes.push(this._getHash(inject[key]));
        }
        const hash = "".concat(vsHash, "/").concat(fsHash, "D").concat(defineHashes.join("/"), "M").concat(moduleHashes.join("/"), "I").concat(injectHashes.join("/"), "V").concat(varyingHashes.join("/"), "H").concat(this.stateHash, "B").concat(bufferMode).concat(transpileToGLSL100 ? "T" : "");
        if (!this._programCache[hash]) {
            const assembled = (0, $bboEJ.assembleShaders)(this.gl, {
                vs: vs,
                fs: fs,
                modules: modules,
                inject: inject,
                defines: defines,
                hookFunctions: this._hookFunctions,
                transpileToGLSL100: transpileToGLSL100
            });
            this._programCache[hash] = new (0, $dwmuk.default)(this.gl, {
                hash: hash,
                vs: assembled.vs,
                fs: assembled.fs,
                varyings: varyings,
                bufferMode: bufferMode
            });
            this._getUniforms[hash] = assembled.getUniforms || ((x)=>{});
            this._useCounts[hash] = 0;
        }
        this._useCounts[hash]++;
        return this._programCache[hash];
    }
    getUniforms(program) {
        return this._getUniforms[program.hash] || null;
    }
    release(program) {
        const hash = program.hash;
        this._useCounts[hash]--;
        if (this._useCounts[hash] === 0) {
            this._programCache[hash].delete();
            delete this._programCache[hash];
            delete this._getUniforms[hash];
            delete this._useCounts[hash];
        }
    }
    _getHash(key) {
        if (this._hashes[key] === undefined) this._hashes[key] = this._hashCounter++;
        return this._hashes[key];
    }
    _getModuleList() {
        let appModules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const modules = new Array(this._defaultModules.length + appModules.length);
        const seen = {};
        let count = 0;
        for(let i = 0, len = this._defaultModules.length; i < len; ++i){
            const module = this._defaultModules[i];
            const name = module.name;
            modules[count++] = module;
            seen[name] = true;
        }
        for(let i = 0, len = appModules.length; i < len; ++i){
            const module = appModules[i];
            const name = module.name;
            if (!seen[name]) {
                modules[count++] = module;
                seen[name] = true;
            }
        }
        modules.length = count;
        return modules;
    }
    constructor(gl){
        this.gl = gl;
        this._programCache = {};
        this._getUniforms = {};
        this._registeredModules = {};
        this._hookFunctions = [];
        this._defaultModules = [];
        this._hashes = {};
        this._hashCounter = 0;
        this.stateHash = 0;
        this._useCounts = {};
    }
}

});
parcelRegister("bboEJ", function(module, exports) {

$parcel$export(module.exports, "assembleShaders", function () { return $8243d8f728508920$export$284ff2a142913562; });

var $lRcQn = parcelRequire("lRcQn");

var $62jMs = parcelRequire("62jMs");

var $94X71 = parcelRequire("94X71");

var $aSPd9 = parcelRequire("aSPd9");

var $eqEdN = parcelRequire("eqEdN");

var $8xCEr = parcelRequire("8xCEr");
const $8243d8f728508920$var$INJECT_SHADER_DECLARATIONS = "\n\n".concat((0, $aSPd9.DECLARATION_INJECT_MARKER), "\n\n");
const $8243d8f728508920$var$SHADER_TYPE = {
    [(0, $lRcQn.VERTEX_SHADER)]: "vertex",
    [(0, $lRcQn.FRAGMENT_SHADER)]: "fragment"
};
const $8243d8f728508920$var$FRAGMENT_SHADER_PROLOGUE = "precision highp float;\n\n";
function $8243d8f728508920$export$284ff2a142913562(gl, opts) {
    const { vs: vs, fs: fs } = opts;
    const modules = (0, $62jMs.resolveModules)(opts.modules || []);
    return {
        gl: gl,
        vs: $8243d8f728508920$var$assembleShader(gl, Object.assign({}, opts, {
            source: vs,
            type: (0, $lRcQn.VERTEX_SHADER),
            modules: modules
        })),
        fs: $8243d8f728508920$var$assembleShader(gl, Object.assign({}, opts, {
            source: fs,
            type: (0, $lRcQn.FRAGMENT_SHADER),
            modules: modules
        })),
        getUniforms: $8243d8f728508920$var$assembleGetUniforms(modules)
    };
}
function $8243d8f728508920$var$assembleShader(gl, _ref) {
    let { id: id, source: source, type: type, modules: modules, defines: defines = {}, hookFunctions: hookFunctions = [], inject: inject = {}, transpileToGLSL100: transpileToGLSL100 = false, prologue: prologue = true, log: log } = _ref;
    (0, $8xCEr.default)(typeof source === "string", "shader source must be a string");
    const isVertex = type === (0, $lRcQn.VERTEX_SHADER);
    const sourceLines = source.split("\n");
    let glslVersion = 100;
    let versionLine = "";
    let coreSource = source;
    if (sourceLines[0].indexOf("#version ") === 0) {
        glslVersion = 300;
        versionLine = sourceLines[0];
        coreSource = sourceLines.slice(1).join("\n");
    } else versionLine = "#version ".concat(glslVersion);
    const allDefines = {};
    modules.forEach((module)=>{
        Object.assign(allDefines, module.getDefines());
    });
    Object.assign(allDefines, defines);
    let assembledSource = prologue ? "".concat(versionLine, "\n").concat($8243d8f728508920$var$getShaderName({
        id: id,
        source: source,
        type: type
    }), "\n").concat($8243d8f728508920$var$getShaderType({
        type: type
    }), "\n").concat((0, $94X71.getPlatformShaderDefines)(gl), "\n").concat((0, $94X71.getVersionDefines)(gl, glslVersion, !isVertex), "\n").concat($8243d8f728508920$var$getApplicationDefines(allDefines), "\n").concat(isVertex ? "" : $8243d8f728508920$var$FRAGMENT_SHADER_PROLOGUE, "\n") : "".concat(versionLine, "\n");
    const hookFunctionMap = $8243d8f728508920$var$normalizeHookFunctions(hookFunctions);
    const hookInjections = {};
    const declInjections = {};
    const mainInjections = {};
    for(const key in inject){
        const injection = typeof inject[key] === "string" ? {
            injection: inject[key],
            order: 0
        } : inject[key];
        const match = key.match(/^(v|f)s:(#)?([\w-]+)$/);
        if (match) {
            const hash = match[2];
            const name = match[3];
            if (hash) {
                if (name === "decl") declInjections[key] = [
                    injection
                ];
                else mainInjections[key] = [
                    injection
                ];
            } else hookInjections[key] = [
                injection
            ];
        } else mainInjections[key] = [
            injection
        ];
    }
    for (const module of modules){
        if (log) module.checkDeprecations(coreSource, log);
        const moduleSource = module.getModuleSource(type, glslVersion);
        assembledSource += moduleSource;
        const injections = module.injections[type];
        for(const key in injections){
            const match = key.match(/^(v|f)s:#([\w-]+)$/);
            if (match) {
                const name = match[2];
                const injectionType = name === "decl" ? declInjections : mainInjections;
                injectionType[key] = injectionType[key] || [];
                injectionType[key].push(injections[key]);
            } else {
                hookInjections[key] = hookInjections[key] || [];
                hookInjections[key].push(injections[key]);
            }
        }
    }
    assembledSource += $8243d8f728508920$var$INJECT_SHADER_DECLARATIONS;
    assembledSource = (0, $aSPd9.default)(assembledSource, type, declInjections);
    assembledSource += $8243d8f728508920$var$getHookFunctions(hookFunctionMap[type], hookInjections);
    assembledSource += coreSource;
    assembledSource = (0, $aSPd9.default)(assembledSource, type, mainInjections);
    assembledSource = (0, $eqEdN.default)(assembledSource, transpileToGLSL100 ? 100 : glslVersion, isVertex);
    return assembledSource;
}
function $8243d8f728508920$var$assembleGetUniforms(modules) {
    return function getUniforms(opts) {
        const uniforms = {};
        for (const module of modules){
            const moduleUniforms = module.getUniforms(opts, uniforms);
            Object.assign(uniforms, moduleUniforms);
        }
        return uniforms;
    };
}
function $8243d8f728508920$var$getShaderType(_ref2) {
    let { type: type } = _ref2;
    return "\n#define SHADER_TYPE_".concat($8243d8f728508920$var$SHADER_TYPE[type].toUpperCase(), "\n");
}
function $8243d8f728508920$var$getShaderName(_ref3) {
    let { id: id, source: source, type: type } = _ref3;
    const injectShaderName = id && typeof id === "string" && source.indexOf("SHADER_NAME") === -1;
    return injectShaderName ? "\n#define SHADER_NAME ".concat(id, "_").concat($8243d8f728508920$var$SHADER_TYPE[type], "\n\n") : "";
}
function $8243d8f728508920$var$getApplicationDefines() {
    let defines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let count = 0;
    let sourceText = "";
    for(const define in defines){
        if (count === 0) sourceText += "\n// APPLICATION DEFINES\n";
        count++;
        const value = defines[define];
        if (value || Number.isFinite(value)) sourceText += "#define ".concat(define.toUpperCase(), " ").concat(defines[define], "\n");
    }
    if (count === 0) sourceText += "\n";
    return sourceText;
}
function $8243d8f728508920$var$getHookFunctions(hookFunctions, hookInjections) {
    let result = "";
    for(const hookName in hookFunctions){
        const hookFunction = hookFunctions[hookName];
        result += "void ".concat(hookFunction.signature, " {\n");
        if (hookFunction.header) result += "  ".concat(hookFunction.header);
        if (hookInjections[hookName]) {
            const injections = hookInjections[hookName];
            injections.sort((a, b)=>a.order - b.order);
            for (const injection of injections)result += "  ".concat(injection.injection, "\n");
        }
        if (hookFunction.footer) result += "  ".concat(hookFunction.footer);
        result += "}\n";
    }
    return result;
}
function $8243d8f728508920$var$normalizeHookFunctions(hookFunctions) {
    const result = {
        vs: {},
        fs: {}
    };
    hookFunctions.forEach((hook)=>{
        let opts;
        if (typeof hook !== "string") {
            opts = hook;
            hook = opts.hook;
        } else opts = {};
        hook = hook.trim();
        const [stage, signature] = hook.split(":");
        const name = hook.replace(/\(.+/, "");
        result[stage][name] = Object.assign(opts, {
            signature: signature
        });
    });
    return result;
}

});
parcelRegister("62jMs", function(module, exports) {

$parcel$export(module.exports, "resolveModules", function () { return $465245f83ff1d29c$export$85f943437bcc1df; });

var $9a3nx = parcelRequire("9a3nx");

var $8xCEr = parcelRequire("8xCEr");
function $465245f83ff1d29c$export$85f943437bcc1df(modules) {
    return $465245f83ff1d29c$var$getShaderDependencies($465245f83ff1d29c$var$instantiateModules(modules));
}
function $465245f83ff1d29c$var$getShaderDependencies(modules) {
    const moduleMap = {};
    const moduleDepth = {};
    $465245f83ff1d29c$var$getDependencyGraph({
        modules: modules,
        level: 0,
        moduleMap: moduleMap,
        moduleDepth: moduleDepth
    });
    return Object.keys(moduleDepth).sort((a, b)=>moduleDepth[b] - moduleDepth[a]).map((name)=>moduleMap[name]);
}
function $465245f83ff1d29c$var$getDependencyGraph(_ref) {
    let { modules: modules, level: level, moduleMap: moduleMap, moduleDepth: moduleDepth } = _ref;
    if (level >= 5) throw new Error("Possible loop in shader dependency graph");
    for (const module of modules){
        moduleMap[module.name] = module;
        if (moduleDepth[module.name] === undefined || moduleDepth[module.name] < level) moduleDepth[module.name] = level;
    }
    for (const module of modules)if (module.dependencies) $465245f83ff1d29c$var$getDependencyGraph({
        modules: module.dependencies,
        level: level + 1,
        moduleMap: moduleMap,
        moduleDepth: moduleDepth
    });
}
function $465245f83ff1d29c$var$instantiateModules(modules, seen) {
    return modules.map((module)=>{
        if (module instanceof (0, $9a3nx.default)) return module;
        (0, $8xCEr.default)(typeof module !== "string", "Shader module use by name is deprecated. Import shader module '".concat(module, "' and use it directly."));
        (0, $8xCEr.default)(module.name, "shader module has no name");
        module = new (0, $9a3nx.default)(module);
        module.dependencies = $465245f83ff1d29c$var$instantiateModules(module.dependencies);
        return module;
    });
}
const $465245f83ff1d29c$export$b63c82f0e67dfc21 = {
    getShaderDependencies: $465245f83ff1d29c$var$getShaderDependencies,
    getDependencyGraph: $465245f83ff1d29c$var$getDependencyGraph
};

});
parcelRegister("9a3nx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ab7ab2e8d0100c4$export$2e2bcd8739ae039; });

var $8xCEr = parcelRequire("8xCEr");

var $h1Y6G = parcelRequire("h1Y6G");
const $6ab7ab2e8d0100c4$var$VERTEX_SHADER = "vs";
const $6ab7ab2e8d0100c4$var$FRAGMENT_SHADER = "fs";
class $6ab7ab2e8d0100c4$export$2e2bcd8739ae039 {
    getModuleSource(type) {
        let moduleSource;
        switch(type){
            case $6ab7ab2e8d0100c4$var$VERTEX_SHADER:
                moduleSource = this.vs || "";
                break;
            case $6ab7ab2e8d0100c4$var$FRAGMENT_SHADER:
                moduleSource = this.fs || "";
                break;
            default:
                (0, $8xCEr.default)(false);
        }
        return "#define MODULE_".concat(this.name.toUpperCase().replace(/[^0-9a-z]/gi, "_"), "\n").concat(moduleSource, "// END MODULE_").concat(this.name, "\n\n");
    }
    getUniforms(opts, uniforms) {
        if (this.getModuleUniforms) return this.getModuleUniforms(opts, uniforms);
        if (this.uniforms) return this._defaultGetUniforms(opts);
        return {};
    }
    getDefines() {
        return this.defines;
    }
    checkDeprecations(shaderSource, log) {
        this.deprecations.forEach((def)=>{
            if (def.regex.test(shaderSource)) {
                if (def.deprecated) log.deprecated(def.old, def.new)();
                else log.removed(def.old, def.new)();
            }
        });
    }
    _parseDeprecationDefinitions(deprecations) {
        deprecations.forEach((def)=>{
            switch(def.type){
                case "function":
                    def.regex = new RegExp("\\b".concat(def.old, "\\("));
                    break;
                default:
                    def.regex = new RegExp("".concat(def.type, " ").concat(def.old, ";"));
            }
        });
        return deprecations;
    }
    _defaultGetUniforms() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const uniforms = {};
        const propTypes = this.uniforms;
        for(const key in propTypes){
            const propDef = propTypes[key];
            if (key in opts && !propDef.private) {
                if (propDef.validate) (0, $8xCEr.default)(propDef.validate(opts[key], propDef), "".concat(this.name, ": invalid ").concat(key));
                uniforms[key] = opts[key];
            } else uniforms[key] = propDef.value;
        }
        return uniforms;
    }
    constructor(_ref){
        let { name: name, vs: vs, fs: fs, dependencies: dependencies = [], uniforms: uniforms, getUniforms: getUniforms, deprecations: deprecations = [], defines: defines = {}, inject: inject = {}, vertexShader: vertexShader, fragmentShader: fragmentShader } = _ref;
        (0, $8xCEr.default)(typeof name === "string");
        this.name = name;
        this.vs = vs || vertexShader;
        this.fs = fs || fragmentShader;
        this.getModuleUniforms = getUniforms;
        this.dependencies = dependencies;
        this.deprecations = this._parseDeprecationDefinitions(deprecations);
        this.defines = defines;
        this.injections = $6ab7ab2e8d0100c4$var$normalizeInjections(inject);
        if (uniforms) this.uniforms = (0, $h1Y6G.parsePropTypes)(uniforms);
    }
}
function $6ab7ab2e8d0100c4$export$68c1c1f4f5c924cc(module) {
    if (!module.normalized) {
        module.normalized = true;
        if (module.uniforms && !module.getUniforms) {
            const shaderModule = new $6ab7ab2e8d0100c4$export$2e2bcd8739ae039(module);
            module.getUniforms = shaderModule.getUniforms.bind(shaderModule);
        }
    }
    return module;
}
function $6ab7ab2e8d0100c4$var$normalizeInjections(injections) {
    const result = {
        vs: {},
        fs: {}
    };
    for(const hook in injections){
        let injection = injections[hook];
        const stage = hook.slice(0, 2);
        if (typeof injection === "string") injection = {
            order: 0,
            injection: injection
        };
        result[stage][hook] = injection;
    }
    return result;
}

});
parcelRegister("h1Y6G", function(module, exports) {

$parcel$export(module.exports, "parsePropTypes", function () { return $c66127a1db59e0a5$export$6335b16489944934; });
const $c66127a1db59e0a5$var$TYPE_DEFINITIONS = {
    number: {
        validate (value, propType) {
            return Number.isFinite(value) && (!("max" in propType) || value <= propType.max) && (!("min" in propType) || value >= propType.min);
        }
    },
    array: {
        validate (value, propType) {
            return Array.isArray(value) || ArrayBuffer.isView(value);
        }
    }
};
function $c66127a1db59e0a5$export$6335b16489944934(propDefs) {
    const propTypes = {};
    for(const propName in propDefs){
        const propDef = propDefs[propName];
        const propType = $c66127a1db59e0a5$var$parsePropType(propDef);
        propTypes[propName] = propType;
    }
    return propTypes;
}
function $c66127a1db59e0a5$var$parsePropType(propDef) {
    let type = $c66127a1db59e0a5$var$getTypeOf(propDef);
    if (type === "object") {
        if (!propDef) return {
            type: "object",
            value: null
        };
        if ("type" in propDef) return Object.assign({}, propDef, $c66127a1db59e0a5$var$TYPE_DEFINITIONS[propDef.type]);
        if (!("value" in propDef)) return {
            type: "object",
            value: propDef
        };
        type = $c66127a1db59e0a5$var$getTypeOf(propDef.value);
        return Object.assign({
            type: type
        }, propDef, $c66127a1db59e0a5$var$TYPE_DEFINITIONS[type]);
    }
    return Object.assign({
        type: type,
        value: propDef
    }, $c66127a1db59e0a5$var$TYPE_DEFINITIONS[type]);
}
function $c66127a1db59e0a5$var$getTypeOf(value) {
    if (Array.isArray(value) || ArrayBuffer.isView(value)) return "array";
    return typeof value;
}

});



parcelRegister("94X71", function(module, exports) {

$parcel$export(module.exports, "getPlatformShaderDefines", function () { return $69c2573810685c37$export$2c56069b1b5c9cc2; });
$parcel$export(module.exports, "getVersionDefines", function () { return $69c2573810685c37$export$e7726ded64e86312; });

var $5b05P = parcelRequire("5b05P");
function $69c2573810685c37$export$2c56069b1b5c9cc2(gl) {
    const debugInfo = (0, $5b05P.getContextInfo)(gl);
    switch(debugInfo.gpuVendor.toLowerCase()){
        case "nvidia":
            return "#define NVIDIA_GPU\n// Nvidia optimizes away the calculation necessary for emulated fp64\n#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1\n";
        case "intel":
            return "#define INTEL_GPU\n// Intel optimizes away the calculation necessary for emulated fp64\n#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1\n// Intel's built-in 'tan' function doesn't have acceptable precision\n#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1\n// Intel GPU doesn't have full 32 bits precision in same cases, causes overflow\n#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1\n";
        case "amd":
            return "#define AMD_GPU\n";
        default:
            return "#define DEFAULT_GPU\n// Prevent driver from optimizing away the calculation necessary for emulated fp64\n#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1\n// Intel's built-in 'tan' function doesn't have acceptable precision\n#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1\n// Intel GPU doesn't have full 32 bits precision in same cases, causes overflow\n#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1\n";
    }
}
function $69c2573810685c37$export$e7726ded64e86312(gl, glslVersion, isFragment) {
    let versionDefines = "#if (__VERSION__ > 120)\n\n# define FEATURE_GLSL_DERIVATIVES\n# define FEATURE_GLSL_DRAW_BUFFERS\n# define FEATURE_GLSL_FRAG_DEPTH\n# define FEATURE_GLSL_TEXTURE_LOD\n\n// DEPRECATED FLAGS, remove in v9\n# define FRAG_DEPTH\n# define DERIVATIVES\n# define DRAW_BUFFERS\n# define TEXTURE_LOD\n\n#endif // __VERSION\n";
    if ((0, $5b05P.hasFeatures)(gl, (0, $5b05P.FEATURES).GLSL_FRAG_DEPTH)) versionDefines += "\n// FRAG_DEPTH => gl_FragDepth is available\n#ifdef GL_EXT_frag_depth\n#extension GL_EXT_frag_depth : enable\n# define FEATURE_GLSL_FRAG_DEPTH\n# define FRAG_DEPTH\n# define gl_FragDepth gl_FragDepthEXT\n#endif\n";
    if ((0, $5b05P.hasFeatures)(gl, (0, $5b05P.FEATURES).GLSL_DERIVATIVES) && (0, $5b05P.canCompileGLGSExtension)(gl, (0, $5b05P.FEATURES).GLSL_DERIVATIVES)) versionDefines += "\n// DERIVATIVES => dxdF, dxdY and fwidth are available\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n# define FEATURE_GLSL_DERIVATIVES\n# define DERIVATIVES\n#endif\n";
    if ((0, $5b05P.hasFeatures)(gl, (0, $5b05P.FEATURES).GLSL_FRAG_DATA) && (0, $5b05P.canCompileGLGSExtension)(gl, (0, $5b05P.FEATURES).GLSL_FRAG_DATA, {
        behavior: "require"
    })) versionDefines += "\n// DRAW_BUFFERS => gl_FragData[] is available\n#ifdef GL_EXT_draw_buffers\n#extension GL_EXT_draw_buffers : require\n#define FEATURE_GLSL_DRAW_BUFFERS\n#define DRAW_BUFFERS\n#endif\n";
    if ((0, $5b05P.hasFeatures)(gl, (0, $5b05P.FEATURES).GLSL_TEXTURE_LOD)) versionDefines += "// TEXTURE_LOD => texture2DLod etc are available\n#ifdef GL_EXT_shader_texture_lod\n#extension GL_EXT_shader_texture_lod : enable\n\n# define FEATURE_GLSL_TEXTURE_LOD\n# define TEXTURE_LOD\n\n#endif\n";
    return versionDefines;
}

});
parcelRegister("5b05P", function(module, exports) {

$parcel$export(module.exports, "FEATURES", function () { return $3c4e0d4b8052599d$export$d6a5c11f04f75862; });
$parcel$export(module.exports, "getContextInfo", function () { return $3c4e0d4b8052599d$export$906f0ebe0848c767; });
$parcel$export(module.exports, "canCompileGLGSExtension", function () { return $3c4e0d4b8052599d$export$e5033c6f31304d8c; });
$parcel$export(module.exports, "hasFeatures", function () { return $3c4e0d4b8052599d$export$990fdf4f5aca9ddb; });

var $4fIr0 = parcelRequire("4fIr0");

var $8xCEr = parcelRequire("8xCEr");
const $3c4e0d4b8052599d$var$GL_VENDOR = 0x1f00;
const $3c4e0d4b8052599d$var$GL_RENDERER = 0x1f01;
const $3c4e0d4b8052599d$var$GL_VERSION = 0x1f02;
const $3c4e0d4b8052599d$var$GL_SHADING_LANGUAGE_VERSION = 0x8b8c;
const $3c4e0d4b8052599d$var$WEBGL_FEATURES = {
    GLSL_FRAG_DATA: [
        "WEBGL_draw_buffers",
        true
    ],
    GLSL_FRAG_DEPTH: [
        "EXT_frag_depth",
        true
    ],
    GLSL_DERIVATIVES: [
        "OES_standard_derivatives",
        true
    ],
    GLSL_TEXTURE_LOD: [
        "EXT_shader_texture_lod",
        true
    ]
};
const $3c4e0d4b8052599d$export$d6a5c11f04f75862 = {};
Object.keys($3c4e0d4b8052599d$var$WEBGL_FEATURES).forEach((key)=>{
    $3c4e0d4b8052599d$export$d6a5c11f04f75862[key] = key;
});
function $3c4e0d4b8052599d$var$isWebGL2(gl) {
    if (typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext) return true;
    return Boolean(gl && gl._version === 2);
}
function $3c4e0d4b8052599d$export$906f0ebe0848c767(gl) {
    const info = gl.getExtension("WEBGL_debug_renderer_info");
    const vendor = gl.getParameter(info && info.UNMASKED_VENDOR_WEBGL || $3c4e0d4b8052599d$var$GL_VENDOR);
    const renderer = gl.getParameter(info && info.UNMASKED_RENDERER_WEBGL || $3c4e0d4b8052599d$var$GL_RENDERER);
    const gpuVendor = $3c4e0d4b8052599d$var$identifyGPUVendor(vendor, renderer);
    const gpuInfo = {
        gpuVendor: gpuVendor,
        vendor: vendor,
        renderer: renderer,
        version: gl.getParameter($3c4e0d4b8052599d$var$GL_VERSION),
        shadingLanguageVersion: gl.getParameter($3c4e0d4b8052599d$var$GL_SHADING_LANGUAGE_VERSION)
    };
    return gpuInfo;
}
function $3c4e0d4b8052599d$var$identifyGPUVendor(vendor, renderer) {
    if (vendor.match(/NVIDIA/i) || renderer.match(/NVIDIA/i)) return "NVIDIA";
    if (vendor.match(/INTEL/i) || renderer.match(/INTEL/i)) return "INTEL";
    if (vendor.match(/AMD/i) || renderer.match(/AMD/i) || vendor.match(/ATI/i) || renderer.match(/ATI/i)) return "AMD";
    return "UNKNOWN GPU";
}
const $3c4e0d4b8052599d$var$compiledGlslExtensions = {};
function $3c4e0d4b8052599d$export$e5033c6f31304d8c(gl, cap) {
    let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const feature = $3c4e0d4b8052599d$var$WEBGL_FEATURES[cap];
    (0, $8xCEr.default)(feature, cap);
    if (!(0, $4fIr0.default)(opts)) return true;
    if (cap in $3c4e0d4b8052599d$var$compiledGlslExtensions) return $3c4e0d4b8052599d$var$compiledGlslExtensions[cap];
    const extensionName = feature[0];
    const behavior = opts.behavior || "enable";
    const source = "#extension GL_".concat(extensionName, " : ").concat(behavior, "\nvoid main(void) {}");
    const shader = gl.createShader(35633);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    const canCompile = gl.getShaderParameter(shader, 35713);
    gl.deleteShader(shader);
    $3c4e0d4b8052599d$var$compiledGlslExtensions[cap] = canCompile;
    return canCompile;
}
function $3c4e0d4b8052599d$var$getFeature(gl, cap) {
    const feature = $3c4e0d4b8052599d$var$WEBGL_FEATURES[cap];
    (0, $8xCEr.default)(feature, cap);
    const extensionName = $3c4e0d4b8052599d$var$isWebGL2(gl) ? feature[1] || feature[0] : feature[0];
    const value = typeof extensionName === "string" ? Boolean(gl.getExtension(extensionName)) : extensionName;
    (0, $8xCEr.default)(value === false || value === true);
    return value;
}
function $3c4e0d4b8052599d$export$990fdf4f5aca9ddb(gl, features) {
    features = Array.isArray(features) ? features : [
        features
    ];
    return features.every((feature)=>$3c4e0d4b8052599d$var$getFeature(gl, feature));
}

});
parcelRegister("4fIr0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $318b07eac101dbb3$export$2e2bcd8739ae039; });
function $318b07eac101dbb3$export$2e2bcd8739ae039() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const navigator = typeof window !== "undefined" ? window.navigator || {} : {};
    const userAgent = opts.userAgent || navigator.userAgent || "";
    const isMSIE = userAgent.indexOf("MSIE ") !== -1;
    const isTrident = userAgent.indexOf("Trident/") !== -1;
    return isMSIE || isTrident;
}

});



parcelRegister("eqEdN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a812b18f87e27888$export$2e2bcd8739ae039; });
function $a812b18f87e27888$var$testVariable(qualifier) {
    return new RegExp("\\b".concat(qualifier, "[ \\t]+(\\w+[ \\t]+\\w+(\\[\\w+\\])?;)"), "g");
}
const $a812b18f87e27888$var$ES300_REPLACEMENTS = [
    [
        /^(#version[ \t]+(100|300[ \t]+es))?[ \t]*\n/,
        "#version 300 es\n"
    ],
    [
        /\btexture(2D|2DProj|Cube)Lod(EXT)?\(/g,
        "textureLod("
    ],
    [
        /\btexture(2D|2DProj|Cube)(EXT)?\(/g,
        "texture("
    ]
];
const $a812b18f87e27888$var$ES300_VERTEX_REPLACEMENTS = [
    ...$a812b18f87e27888$var$ES300_REPLACEMENTS,
    [
        $a812b18f87e27888$var$testVariable("attribute"),
        "in $1"
    ],
    [
        $a812b18f87e27888$var$testVariable("varying"),
        "out $1"
    ]
];
const $a812b18f87e27888$var$ES300_FRAGMENT_REPLACEMENTS = [
    ...$a812b18f87e27888$var$ES300_REPLACEMENTS,
    [
        $a812b18f87e27888$var$testVariable("varying"),
        "in $1"
    ]
];
const $a812b18f87e27888$var$ES100_REPLACEMENTS = [
    [
        /^#version[ \t]+300[ \t]+es/,
        "#version 100"
    ],
    [
        /\btexture(2D|2DProj|Cube)Lod\(/g,
        "texture$1LodEXT("
    ],
    [
        /\btexture\(/g,
        "texture2D("
    ],
    [
        /\btextureLod\(/g,
        "texture2DLodEXT("
    ]
];
const $a812b18f87e27888$var$ES100_VERTEX_REPLACEMENTS = [
    ...$a812b18f87e27888$var$ES100_REPLACEMENTS,
    [
        $a812b18f87e27888$var$testVariable("in"),
        "attribute $1"
    ],
    [
        $a812b18f87e27888$var$testVariable("out"),
        "varying $1"
    ]
];
const $a812b18f87e27888$var$ES100_FRAGMENT_REPLACEMENTS = [
    ...$a812b18f87e27888$var$ES100_REPLACEMENTS,
    [
        $a812b18f87e27888$var$testVariable("in"),
        "varying $1"
    ]
];
const $a812b18f87e27888$var$ES100_FRAGMENT_OUTPUT_NAME = "gl_FragColor";
const $a812b18f87e27888$var$ES300_FRAGMENT_OUTPUT_REGEX = /\bout[ \t]+vec4[ \t]+(\w+)[ \t]*;\n?/;
const $a812b18f87e27888$var$REGEX_START_OF_MAIN = /void\s+main\s*\([^)]*\)\s*\{\n?/;
function $a812b18f87e27888$export$2e2bcd8739ae039(source, targetGLSLVersion, isVertex) {
    switch(targetGLSLVersion){
        case 300:
            return isVertex ? $a812b18f87e27888$var$convertShader(source, $a812b18f87e27888$var$ES300_VERTEX_REPLACEMENTS) : $a812b18f87e27888$var$convertFragmentShaderTo300(source);
        case 100:
            return isVertex ? $a812b18f87e27888$var$convertShader(source, $a812b18f87e27888$var$ES100_VERTEX_REPLACEMENTS) : $a812b18f87e27888$var$convertFragmentShaderTo100(source);
        default:
            throw new Error("unknown GLSL version ".concat(targetGLSLVersion));
    }
}
function $a812b18f87e27888$var$convertShader(source, replacements) {
    for (const [pattern, replacement] of replacements)source = source.replace(pattern, replacement);
    return source;
}
function $a812b18f87e27888$var$convertFragmentShaderTo300(source) {
    source = $a812b18f87e27888$var$convertShader(source, $a812b18f87e27888$var$ES300_FRAGMENT_REPLACEMENTS);
    const outputMatch = source.match($a812b18f87e27888$var$ES300_FRAGMENT_OUTPUT_REGEX);
    if (outputMatch) {
        const outputName = outputMatch[1];
        source = source.replace(new RegExp("\\b".concat($a812b18f87e27888$var$ES100_FRAGMENT_OUTPUT_NAME, "\\b"), "g"), outputName);
    } else {
        const outputName = "fragmentColor";
        source = source.replace($a812b18f87e27888$var$REGEX_START_OF_MAIN, (match)=>"out vec4 ".concat(outputName, ";\n").concat(match)).replace(new RegExp("\\b".concat($a812b18f87e27888$var$ES100_FRAGMENT_OUTPUT_NAME, "\\b"), "g"), outputName);
    }
    return source;
}
function $a812b18f87e27888$var$convertFragmentShaderTo100(source) {
    source = $a812b18f87e27888$var$convertShader(source, $a812b18f87e27888$var$ES100_FRAGMENT_REPLACEMENTS);
    const outputMatch = source.match($a812b18f87e27888$var$ES300_FRAGMENT_OUTPUT_REGEX);
    if (outputMatch) {
        const outputName = outputMatch[1];
        source = source.replace($a812b18f87e27888$var$ES300_FRAGMENT_OUTPUT_REGEX, "").replace(new RegExp("\\b".concat(outputName, "\\b"), "g"), $a812b18f87e27888$var$ES100_FRAGMENT_OUTPUT_NAME);
    }
    return source;
}

});


parcelRegister("dwmuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d7fb5367fbd6906$export$2e2bcd8739ae039; });

var $1OVow = parcelRequire("1OVow");

var $3D9dM = parcelRequire("3D9dM");

var $cJo7e = parcelRequire("cJo7e");

var $Lma8E = parcelRequire("Lma8E");

var $kJXQX = parcelRequire("kJXQX");

var $jw2vH = parcelRequire("jw2vH");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");
var $2SJyH = parcelRequire("2SJyH");

var $5tEaG = parcelRequire("5tEaG");

var $eX2kV = parcelRequire("eX2kV");

var $ihfnu = parcelRequire("ihfnu");

var $iljOc = parcelRequire("iljOc");
const $9d7fb5367fbd6906$var$LOG_PROGRAM_PERF_PRIORITY = 4;
const $9d7fb5367fbd6906$var$GL_SEPARATE_ATTRIBS = 0x8c8d;
const $9d7fb5367fbd6906$var$V6_DEPRECATED_METHODS = [
    "setVertexArray",
    "setAttributes",
    "setBuffers",
    "unsetBuffers",
    "use",
    "getUniformCount",
    "getUniformInfo",
    "getUniformLocation",
    "getUniformValue",
    "getVarying",
    "getFragDataLocation",
    "getAttachedShaders",
    "getAttributeCount",
    "getAttributeLocation",
    "getAttributeInfo"
];
class $9d7fb5367fbd6906$export$2e2bcd8739ae039 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "Program";
    }
    initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { hash: hash, vs: vs, fs: fs, varyings: varyings, bufferMode: bufferMode = $9d7fb5367fbd6906$var$GL_SEPARATE_ATTRIBS } = props;
        this.hash = hash || "";
        this.vs = typeof vs === "string" ? new (0, $kJXQX.VertexShader)(this.gl, {
            id: "".concat(props.id, "-vs"),
            source: vs
        }) : vs;
        this.fs = typeof fs === "string" ? new (0, $kJXQX.FragmentShader)(this.gl, {
            id: "".concat(props.id, "-fs"),
            source: fs
        }) : fs;
        (0, $ihfnu.assert)(this.vs instanceof (0, $kJXQX.VertexShader));
        (0, $ihfnu.assert)(this.fs instanceof (0, $kJXQX.FragmentShader));
        this.uniforms = {};
        this._textureUniforms = {};
        if (varyings && varyings.length > 0) {
            (0, $8HKWo.assertWebGL2Context)(this.gl);
            this.varyings = varyings;
            this.gl2.transformFeedbackVaryings(this.handle, varyings, bufferMode);
        }
        this._compileAndLink();
        this._readUniformLocationsFromLinkedProgram();
        this.configuration = new (0, $jw2vH.default)(this);
        return this.setProps(props);
    }
    delete() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this._isCached) return this;
        return super.delete(options);
    }
    setProps(props) {
        if ("uniforms" in props) this.setUniforms(props.uniforms);
        return this;
    }
    draw(_ref) {
        let { logPriority: logPriority, drawMode: drawMode = 4, vertexCount: vertexCount, offset: offset = 0, start: start, end: end, isIndexed: isIndexed = false, indexType: indexType = 5123, instanceCount: instanceCount = 0, isInstanced: isInstanced = instanceCount > 0, vertexArray: vertexArray = null, transformFeedback: transformFeedback, framebuffer: framebuffer, parameters: parameters = {}, uniforms: uniforms, samplers: samplers } = _ref;
        if (uniforms || samplers) {
            (0, $lvicK.log).deprecated("Program.draw({uniforms})", "Program.setUniforms(uniforms)")();
            this.setUniforms(uniforms || {});
        }
        if ((0, $lvicK.log).priority >= logPriority) {
            const fb = framebuffer ? framebuffer.id : "default";
            const message = "mode=".concat((0, $5tEaG.getKey)(this.gl, drawMode), " verts=").concat(vertexCount, " ") + "instances=".concat(instanceCount, " indexType=").concat((0, $5tEaG.getKey)(this.gl, indexType), " ") + "isInstanced=".concat(isInstanced, " isIndexed=").concat(isIndexed, " ") + "Framebuffer=".concat(fb);
            (0, $lvicK.log).log(logPriority, message)();
        }
        (0, $ihfnu.assert)(vertexArray);
        this.gl.useProgram(this.handle);
        if (!this._areTexturesRenderable() || vertexCount === 0 || isInstanced && instanceCount === 0) return false;
        vertexArray.bindForDraw(vertexCount, instanceCount, ()=>{
            if (framebuffer !== undefined) parameters = Object.assign({}, parameters, {
                framebuffer: framebuffer
            });
            if (transformFeedback) {
                const primitiveMode = (0, $eX2kV.getPrimitiveDrawMode)(drawMode);
                transformFeedback.begin(primitiveMode);
            }
            this._bindTextures();
            (0, $2SJyH.withParameters)(this.gl, parameters, ()=>{
                if (isIndexed && isInstanced) this.gl2.drawElementsInstanced(drawMode, vertexCount, indexType, offset, instanceCount);
                else if (isIndexed && (0, $8HKWo.isWebGL2)(this.gl) && !isNaN(start) && !isNaN(end)) this.gl2.drawRangeElements(drawMode, start, end, vertexCount, indexType, offset);
                else if (isIndexed) this.gl.drawElements(drawMode, vertexCount, indexType, offset);
                else if (isInstanced) this.gl2.drawArraysInstanced(drawMode, offset, vertexCount, instanceCount);
                else this.gl.drawArrays(drawMode, offset, vertexCount);
            });
            if (transformFeedback) transformFeedback.end();
        });
        return true;
    }
    setUniforms() {
        let uniforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $lvicK.log).priority >= 2) (0, $Lma8E.checkUniformValues)(uniforms, this.id, this._uniformSetters);
        this.gl.useProgram(this.handle);
        for(const uniformName in uniforms){
            const uniform = uniforms[uniformName];
            const uniformSetter = this._uniformSetters[uniformName];
            if (uniformSetter) {
                let value = uniform;
                let textureUpdate = false;
                if (value instanceof (0, $cJo7e.default)) value = value.texture;
                if (value instanceof (0, $3D9dM.default)) {
                    textureUpdate = this.uniforms[uniformName] !== uniform;
                    if (textureUpdate) {
                        if (uniformSetter.textureIndex === undefined) uniformSetter.textureIndex = this._textureIndexCounter++;
                        const texture = value;
                        const { textureIndex: textureIndex } = uniformSetter;
                        texture.bind(textureIndex);
                        value = textureIndex;
                        this._textureUniforms[uniformName] = texture;
                    } else value = uniformSetter.textureIndex;
                } else if (this._textureUniforms[uniformName]) delete this._textureUniforms[uniformName];
                if (uniformSetter(value) || textureUpdate) (0, $Lma8E.copyUniform)(this.uniforms, uniformName, uniform);
            }
        }
        return this;
    }
    _areTexturesRenderable() {
        let texturesRenderable = true;
        for(const uniformName in this._textureUniforms){
            const texture = this._textureUniforms[uniformName];
            texture.update();
            texturesRenderable = texturesRenderable && texture.loaded;
        }
        return texturesRenderable;
    }
    _bindTextures() {
        for(const uniformName in this._textureUniforms){
            const textureIndex = this._uniformSetters[uniformName].textureIndex;
            this._textureUniforms[uniformName].bind(textureIndex);
        }
    }
    _createHandle() {
        return this.gl.createProgram();
    }
    _deleteHandle() {
        this.gl.deleteProgram(this.handle);
    }
    _getOptionsFromHandle(handle) {
        const shaderHandles = this.gl.getAttachedShaders(handle);
        const opts = {};
        for (const shaderHandle of shaderHandles){
            const type = this.gl.getShaderParameter(this.handle, 35663);
            switch(type){
                case 35633:
                    opts.vs = new (0, $kJXQX.VertexShader)({
                        handle: shaderHandle
                    });
                    break;
                case 35632:
                    opts.fs = new (0, $kJXQX.FragmentShader)({
                        handle: shaderHandle
                    });
                    break;
                default:
            }
        }
        return opts;
    }
    _getParameter(pname) {
        return this.gl.getProgramParameter(this.handle, pname);
    }
    _setId(id) {
        if (!id) {
            const programName = this._getName();
            this.id = (0, $iljOc.uid)(programName);
        }
    }
    _getName() {
        let programName = this.vs.getName() || this.fs.getName();
        programName = programName.replace(/shader/i, "");
        programName = programName ? "".concat(programName, "-program") : "program";
        return programName;
    }
    _compileAndLink() {
        const { gl: gl } = this;
        gl.attachShader(this.handle, this.vs.handle);
        gl.attachShader(this.handle, this.fs.handle);
        (0, $lvicK.log).time($9d7fb5367fbd6906$var$LOG_PROGRAM_PERF_PRIORITY, "linkProgram for ".concat(this._getName()))();
        gl.linkProgram(this.handle);
        (0, $lvicK.log).timeEnd($9d7fb5367fbd6906$var$LOG_PROGRAM_PERF_PRIORITY, "linkProgram for ".concat(this._getName()))();
        if (gl.debug || (0, $lvicK.log).level > 0) {
            const linked = gl.getProgramParameter(this.handle, 35714);
            if (!linked) throw new Error("Error linking: ".concat(gl.getProgramInfoLog(this.handle)));
            gl.validateProgram(this.handle);
            const validated = gl.getProgramParameter(this.handle, 35715);
            if (!validated) throw new Error("Error validating: ".concat(gl.getProgramInfoLog(this.handle)));
        }
    }
    _readUniformLocationsFromLinkedProgram() {
        const { gl: gl } = this;
        this._uniformSetters = {};
        this._uniformCount = this._getParameter(35718);
        for(let i = 0; i < this._uniformCount; i++){
            const info = this.gl.getActiveUniform(this.handle, i);
            const { name: name } = (0, $Lma8E.parseUniformName)(info.name);
            let location = gl.getUniformLocation(this.handle, name);
            this._uniformSetters[name] = (0, $Lma8E.getUniformSetter)(gl, location, info);
            if (info.size > 1) for(let l = 0; l < info.size; l++){
                location = gl.getUniformLocation(this.handle, "".concat(name, "[").concat(l, "]"));
                this._uniformSetters["".concat(name, "[").concat(l, "]")] = (0, $Lma8E.getUniformSetter)(gl, location, info);
            }
        }
        this._textureIndexCounter = 0;
    }
    getActiveUniforms(uniformIndices, pname) {
        return this.gl2.getActiveUniforms(this.handle, uniformIndices, pname);
    }
    getUniformBlockIndex(blockName) {
        return this.gl2.getUniformBlockIndex(this.handle, blockName);
    }
    getActiveUniformBlockParameter(blockIndex, pname) {
        return this.gl2.getActiveUniformBlockParameter(this.handle, blockIndex, pname);
    }
    uniformBlockBinding(blockIndex, blockBinding) {
        this.gl2.uniformBlockBinding(this.handle, blockIndex, blockBinding);
    }
    constructor(gl){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(gl, props);
        this.stubRemovedMethods("Program", "v6.0", $9d7fb5367fbd6906$var$V6_DEPRECATED_METHODS);
        this._isCached = false;
        this.initialize(props);
        Object.seal(this);
        this._setId(props.id);
    }
}

});
parcelRegister("Lma8E", function(module, exports) {

$parcel$export(module.exports, "getUniformSetter", function () { return $08e594eac3dcdeb6$export$c2b5b6d0be3c2cf0; });
$parcel$export(module.exports, "parseUniformName", function () { return $08e594eac3dcdeb6$export$ae5f39dc6a50a1c7; });
$parcel$export(module.exports, "checkUniformValues", function () { return $08e594eac3dcdeb6$export$c83bcc63b305493; });
$parcel$export(module.exports, "copyUniform", function () { return $08e594eac3dcdeb6$export$5ced140387f3d289; });
parcelRequire("73UuK");
var $lvicK = parcelRequire("lvicK");

var $cJo7e = parcelRequire("cJo7e");

var $8BnKG = parcelRequire("8BnKG");

var $3D9dM = parcelRequire("3D9dM");

var $ihfnu = parcelRequire("ihfnu");
const $08e594eac3dcdeb6$var$UNIFORM_SETTERS = {
    [5126]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform1fv", $08e594eac3dcdeb6$var$toFloatArray, 1, $08e594eac3dcdeb6$var$setVectorUniform),
    [35664]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform2fv", $08e594eac3dcdeb6$var$toFloatArray, 2, $08e594eac3dcdeb6$var$setVectorUniform),
    [35665]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform3fv", $08e594eac3dcdeb6$var$toFloatArray, 3, $08e594eac3dcdeb6$var$setVectorUniform),
    [35666]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform4fv", $08e594eac3dcdeb6$var$toFloatArray, 4, $08e594eac3dcdeb6$var$setVectorUniform),
    [5124]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform1iv", $08e594eac3dcdeb6$var$toIntArray, 1, $08e594eac3dcdeb6$var$setVectorUniform),
    [35667]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform2iv", $08e594eac3dcdeb6$var$toIntArray, 2, $08e594eac3dcdeb6$var$setVectorUniform),
    [35668]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform3iv", $08e594eac3dcdeb6$var$toIntArray, 3, $08e594eac3dcdeb6$var$setVectorUniform),
    [35669]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform4iv", $08e594eac3dcdeb6$var$toIntArray, 4, $08e594eac3dcdeb6$var$setVectorUniform),
    [35670]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform1iv", $08e594eac3dcdeb6$var$toIntArray, 1, $08e594eac3dcdeb6$var$setVectorUniform),
    [35671]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform2iv", $08e594eac3dcdeb6$var$toIntArray, 2, $08e594eac3dcdeb6$var$setVectorUniform),
    [35672]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform3iv", $08e594eac3dcdeb6$var$toIntArray, 3, $08e594eac3dcdeb6$var$setVectorUniform),
    [35673]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform4iv", $08e594eac3dcdeb6$var$toIntArray, 4, $08e594eac3dcdeb6$var$setVectorUniform),
    [35674]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix2fv", $08e594eac3dcdeb6$var$toFloatArray, 4, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35675]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix3fv", $08e594eac3dcdeb6$var$toFloatArray, 9, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35676]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix4fv", $08e594eac3dcdeb6$var$toFloatArray, 16, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35678]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [35680]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [5125]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform1uiv", $08e594eac3dcdeb6$var$toUIntArray, 1, $08e594eac3dcdeb6$var$setVectorUniform),
    [36294]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform2uiv", $08e594eac3dcdeb6$var$toUIntArray, 2, $08e594eac3dcdeb6$var$setVectorUniform),
    [36295]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform3uiv", $08e594eac3dcdeb6$var$toUIntArray, 3, $08e594eac3dcdeb6$var$setVectorUniform),
    [36296]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniform4uiv", $08e594eac3dcdeb6$var$toUIntArray, 4, $08e594eac3dcdeb6$var$setVectorUniform),
    [35685]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix2x3fv", $08e594eac3dcdeb6$var$toFloatArray, 6, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35686]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix2x4fv", $08e594eac3dcdeb6$var$toFloatArray, 8, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35687]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix3x2fv", $08e594eac3dcdeb6$var$toFloatArray, 6, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35688]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix3x4fv", $08e594eac3dcdeb6$var$toFloatArray, 12, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35689]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix4x2fv", $08e594eac3dcdeb6$var$toFloatArray, 8, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35690]: $08e594eac3dcdeb6$var$getArraySetter.bind(null, "uniformMatrix4x3fv", $08e594eac3dcdeb6$var$toFloatArray, 12, $08e594eac3dcdeb6$var$setMatrixUniform),
    [35678]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [35680]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [35679]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [35682]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36289]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36292]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36293]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36298]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36299]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36300]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36303]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36306]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36307]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36308]: $08e594eac3dcdeb6$var$getSamplerSetter,
    [36311]: $08e594eac3dcdeb6$var$getSamplerSetter
};
const $08e594eac3dcdeb6$var$FLOAT_ARRAY = {};
const $08e594eac3dcdeb6$var$INT_ARRAY = {};
const $08e594eac3dcdeb6$var$UINT_ARRAY = {};
const $08e594eac3dcdeb6$var$array1 = [
    0
];
function $08e594eac3dcdeb6$var$toTypedArray(value, uniformLength, Type, cache) {
    if (uniformLength === 1 && typeof value === "boolean") value = value ? 1 : 0;
    if (Number.isFinite(value)) {
        $08e594eac3dcdeb6$var$array1[0] = value;
        value = $08e594eac3dcdeb6$var$array1;
    }
    const length = value.length;
    if (length % uniformLength) (0, $lvicK.log).warn("Uniform size should be multiples of ".concat(uniformLength), value)();
    if (value instanceof Type) return value;
    let result = cache[length];
    if (!result) {
        result = new Type(length);
        cache[length] = result;
    }
    for(let i = 0; i < length; i++)result[i] = value[i];
    return result;
}
function $08e594eac3dcdeb6$var$toFloatArray(value, uniformLength) {
    return $08e594eac3dcdeb6$var$toTypedArray(value, uniformLength, Float32Array, $08e594eac3dcdeb6$var$FLOAT_ARRAY);
}
function $08e594eac3dcdeb6$var$toIntArray(value, uniformLength) {
    return $08e594eac3dcdeb6$var$toTypedArray(value, uniformLength, Int32Array, $08e594eac3dcdeb6$var$INT_ARRAY);
}
function $08e594eac3dcdeb6$var$toUIntArray(value, uniformLength) {
    return $08e594eac3dcdeb6$var$toTypedArray(value, uniformLength, Uint32Array, $08e594eac3dcdeb6$var$UINT_ARRAY);
}
function $08e594eac3dcdeb6$export$c2b5b6d0be3c2cf0(gl, location, info) {
    const setter = $08e594eac3dcdeb6$var$UNIFORM_SETTERS[info.type];
    if (!setter) throw new Error("Unknown GLSL uniform type ".concat(info.type));
    return setter().bind(null, gl, location);
}
function $08e594eac3dcdeb6$export$ae5f39dc6a50a1c7(name) {
    if (name[name.length - 1] !== "]") return {
        name: name,
        length: 1,
        isArray: false
    };
    const UNIFORM_NAME_REGEXP = /([^[]*)(\[[0-9]+\])?/;
    const matches = name.match(UNIFORM_NAME_REGEXP);
    if (!matches || matches.length < 2) throw new Error("Failed to parse GLSL uniform name ".concat(name));
    return {
        name: matches[1],
        length: matches[2] || 1,
        isArray: Boolean(matches[2])
    };
}
function $08e594eac3dcdeb6$export$c83bcc63b305493(uniforms, source, uniformMap) {
    for(const uniformName in uniforms){
        const value = uniforms[uniformName];
        const shouldCheck = !uniformMap || Boolean(uniformMap[uniformName]);
        if (shouldCheck && !$08e594eac3dcdeb6$var$checkUniformValue(value)) {
            source = source ? "".concat(source, " ") : "";
            console.error("".concat(source, " Bad uniform ").concat(uniformName), value);
            throw new Error("".concat(source, " Bad uniform ").concat(uniformName));
        }
    }
    return true;
}
function $08e594eac3dcdeb6$var$checkUniformValue(value) {
    if (Array.isArray(value) || ArrayBuffer.isView(value)) return $08e594eac3dcdeb6$var$checkUniformArray(value);
    if (isFinite(value)) return true;
    else if (value === true || value === false) return true;
    else if (value instanceof (0, $3D9dM.default)) return true;
    else if (value instanceof (0, $8BnKG.default)) return true;
    else if (value instanceof (0, $cJo7e.default)) return Boolean(value.texture);
    return false;
}
function $08e594eac3dcdeb6$export$5ced140387f3d289(uniforms, key, value) {
    if (Array.isArray(value) || ArrayBuffer.isView(value)) {
        if (uniforms[key]) {
            const dest = uniforms[key];
            for(let i = 0, len = value.length; i < len; ++i)dest[i] = value[i];
        } else uniforms[key] = value.slice();
    } else uniforms[key] = value;
}
function $08e594eac3dcdeb6$var$checkUniformArray(value) {
    if (value.length === 0) return false;
    const checkLength = Math.min(value.length, 16);
    for(let i = 0; i < checkLength; ++i){
        if (!Number.isFinite(value[i])) return false;
    }
    return true;
}
function $08e594eac3dcdeb6$var$getSamplerSetter() {
    let cache = null;
    return (gl, location, value)=>{
        const update = cache !== value;
        if (update) {
            gl.uniform1i(location, value);
            cache = value;
        }
        return update;
    };
}
function $08e594eac3dcdeb6$var$getArraySetter(functionName, toArray, size, uniformSetter) {
    let cache = null;
    let cacheLength = null;
    return (gl, location, value)=>{
        const arrayValue = toArray(value, size);
        const length = arrayValue.length;
        let update = false;
        if (cache === null) {
            cache = new Float32Array(length);
            cacheLength = length;
            update = true;
        } else {
            (0, $ihfnu.assert)(cacheLength === length, "Uniform length cannot change.");
            for(let i = 0; i < length; ++i)if (arrayValue[i] !== cache[i]) {
                update = true;
                break;
            }
        }
        if (update) {
            uniformSetter(gl, functionName, location, arrayValue);
            cache.set(arrayValue);
        }
        return update;
    };
}
function $08e594eac3dcdeb6$var$setVectorUniform(gl, functionName, location, value) {
    gl[functionName](location, value);
}
function $08e594eac3dcdeb6$var$setMatrixUniform(gl, functionName, location, value) {
    gl[functionName](location, false, value);
}

});

parcelRegister("kJXQX", function(module, exports) {

$parcel$export(module.exports, "VertexShader", function () { return $f19670361bcd788a$export$cb28509c217600d2; });
$parcel$export(module.exports, "FragmentShader", function () { return $f19670361bcd788a$export$2d38bde43c53f87a; });
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $lvicK = parcelRequire("lvicK");

var $iUJ8p = parcelRequire("iUJ8p");
var $2Bdlp = parcelRequire("2Bdlp");

var $ihfnu = parcelRequire("ihfnu");

var $iljOc = parcelRequire("iljOc");

var $1OVow = parcelRequire("1OVow");
const $f19670361bcd788a$var$ERR_SOURCE = "Shader: GLSL source code must be a JavaScript string";
class $f19670361bcd788a$export$462bb059fed9d9e5 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "Shader";
    }
    static getTypeName(shaderType) {
        switch(shaderType){
            case 35633:
                return "vertex-shader";
            case 35632:
                return "fragment-shader";
            default:
                (0, $ihfnu.assert)(false);
                return "unknown";
        }
    }
    initialize(_ref) {
        let { source: source } = _ref;
        const shaderName = (0, $iUJ8p.default)(source, null);
        if (shaderName) this.id = (0, $iljOc.uid)(shaderName);
        this._compile(source);
    }
    getParameter(pname) {
        return this.gl.getShaderParameter(this.handle, pname);
    }
    toString() {
        return "".concat($f19670361bcd788a$export$462bb059fed9d9e5.getTypeName(this.shaderType), ":").concat(this.id);
    }
    getName() {
        return (0, $iUJ8p.default)(this.source) || "unnamed-shader";
    }
    getSource() {
        return this.gl.getShaderSource(this.handle);
    }
    getTranslatedSource() {
        const extension = this.gl.getExtension("WEBGL_debug_shaders");
        return extension ? extension.getTranslatedShaderSource(this.handle) : "No translated source available. WEBGL_debug_shaders not implemented";
    }
    _compile() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.source;
        if (!source.startsWith("#version ")) source = "#version 100\n".concat(source);
        this.source = source;
        this.gl.shaderSource(this.handle, this.source);
        this.gl.compileShader(this.handle);
        const compileStatus = this.getParameter(35713);
        if (!compileStatus) {
            const infoLog = this.gl.getShaderInfoLog(this.handle);
            const { shaderName: shaderName, errors: errors, warnings: warnings } = (0, $2Bdlp.parseGLSLCompilerError)(infoLog, this.source, this.shaderType, this.id);
            (0, $lvicK.log).error("GLSL compilation errors in ".concat(shaderName, "\n").concat(errors))();
            (0, $lvicK.log).warn("GLSL compilation warnings in ".concat(shaderName, "\n").concat(warnings))();
            throw new Error("GLSL compilation errors in ".concat(shaderName));
        }
    }
    _deleteHandle() {
        this.gl.deleteShader(this.handle);
    }
    _getOptsFromHandle() {
        return {
            type: this.getParameter(35663),
            source: this.getSource()
        };
    }
    constructor(gl, props){
        (0, $8HKWo.assertWebGLContext)(gl);
        (0, $ihfnu.assert)(typeof props.source === "string", $f19670361bcd788a$var$ERR_SOURCE);
        const id = (0, $iUJ8p.default)(props.source, null) || props.id || (0, $iljOc.uid)("unnamed ".concat($f19670361bcd788a$export$462bb059fed9d9e5.getTypeName(props.shaderType)));
        super(gl, {
            id: id
        });
        this.shaderType = props.shaderType;
        this.source = props.source;
        this.initialize(props);
    }
}
class $f19670361bcd788a$export$cb28509c217600d2 extends $f19670361bcd788a$export$462bb059fed9d9e5 {
    get [Symbol.toStringTag]() {
        return "VertexShader";
    }
    _createHandle() {
        return this.gl.createShader(35633);
    }
    constructor(gl, props){
        if (typeof props === "string") props = {
            source: props
        };
        super(gl, Object.assign({}, props, {
            shaderType: 35633
        }));
    }
}
class $f19670361bcd788a$export$2d38bde43c53f87a extends $f19670361bcd788a$export$462bb059fed9d9e5 {
    get [Symbol.toStringTag]() {
        return "FragmentShader";
    }
    _createHandle() {
        return this.gl.createShader(35632);
    }
    constructor(gl, props){
        if (typeof props === "string") props = {
            source: props
        };
        super(gl, Object.assign({}, props, {
            shaderType: 35632
        }));
    }
}

});
parcelRegister("iUJ8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc5077bd8c8fd933$export$2e2bcd8739ae039; });
function $dc5077bd8c8fd933$export$2e2bcd8739ae039(shader) {
    let defaultName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "unnamed";
    const SHADER_NAME_REGEXP = /#define[\s*]SHADER_NAME[\s*]([A-Za-z0-9_-]+)[\s*]/;
    const match = shader.match(SHADER_NAME_REGEXP);
    return match ? match[1] : defaultName;
}

});

parcelRegister("2Bdlp", function(module, exports) {

$parcel$export(module.exports, "parseGLSLCompilerError", function () { return $1e49635c8b013159$export$b279b0ccf17fdc42; });

var $iUJ8p = parcelRequire("iUJ8p");

var $f0GLy = parcelRequire("f0GLy");
function $1e49635c8b013159$export$2e2bcd8739ae039(errLog, src, shaderType) {
    const { shaderName: shaderName, errors: errors, warnings: warnings } = $1e49635c8b013159$export$b279b0ccf17fdc42(errLog, src, shaderType);
    return "GLSL compilation error in ".concat(shaderName, "\n\n").concat(errors, "\n").concat(warnings);
}
function $1e49635c8b013159$export$b279b0ccf17fdc42(errLog, src, shaderType, shaderName) {
    const errorStrings = errLog.split(/\r?\n/);
    const errors = {};
    const warnings = {};
    const name = shaderName || (0, $iUJ8p.default)(src) || "(unnamed)";
    const shaderDescription = "".concat((0, $f0GLy.default)(shaderType), " shader ").concat(name);
    for(let i = 0; i < errorStrings.length; i++){
        const errorString = errorStrings[i];
        if (errorString.length <= 1) continue;
        const segments = errorString.split(":");
        const type = segments[0];
        const line = parseInt(segments[2], 10);
        if (isNaN(line)) throw new Error("GLSL compilation error in ".concat(shaderDescription, ": ").concat(errLog));
        if (type !== "WARNING") errors[line] = errorString;
        else warnings[line] = errorString;
    }
    const lines = $1e49635c8b013159$var$addLineNumbers(src);
    return {
        shaderName: shaderDescription,
        errors: $1e49635c8b013159$var$formatErrors(errors, lines),
        warnings: $1e49635c8b013159$var$formatErrors(warnings, lines)
    };
}
function $1e49635c8b013159$var$formatErrors(errors, lines) {
    let message = "";
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        if (!errors[i + 3] && !errors[i + 2] && !errors[i + 1]) continue;
        message += "".concat(line, "\n");
        if (errors[i + 1]) {
            const error = errors[i + 1];
            const segments = error.split(":", 3);
            const type = segments[0];
            const column = parseInt(segments[1], 10) || 0;
            const err = error.substring(segments.join(":").length + 1).trim();
            message += $1e49635c8b013159$var$padLeft("^^^ ".concat(type, ": ").concat(err, "\n\n"), column);
        }
    }
    return message;
}
function $1e49635c8b013159$var$addLineNumbers(string) {
    let start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    let delim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ": ";
    const lines = string.split(/\r?\n/);
    const maxDigits = String(lines.length + start - 1).length;
    return lines.map((line, i)=>{
        const lineNumber = String(i + start);
        const digits = lineNumber.length;
        const prefix = $1e49635c8b013159$var$padLeft(lineNumber, maxDigits - digits);
        return prefix + delim + line;
    });
}
function $1e49635c8b013159$var$padLeft(string, digits) {
    let result = "";
    for(let i = 0; i < digits; ++i)result += " ";
    return "".concat(result).concat(string);
}

});
parcelRegister("f0GLy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aed80790d21dfd50$export$2e2bcd8739ae039; });
const $aed80790d21dfd50$var$GL_FRAGMENT_SHADER = 0x8b30;
const $aed80790d21dfd50$var$GL_VERTEX_SHADER = 0x8b31;
function $aed80790d21dfd50$export$2e2bcd8739ae039(type) {
    switch(type){
        case $aed80790d21dfd50$var$GL_FRAGMENT_SHADER:
            return "fragment";
        case $aed80790d21dfd50$var$GL_VERTEX_SHADER:
            return "vertex";
        default:
            return "unknown type";
    }
}

});



parcelRegister("jw2vH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e352f3fb8f43d6e4$export$2e2bcd8739ae039; });

var $35tVQ = parcelRequire("35tVQ");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $eX2kV = parcelRequire("eX2kV");
class $e352f3fb8f43d6e4$export$2e2bcd8739ae039 {
    getAttributeInfo(locationOrName) {
        const location = Number(locationOrName);
        if (Number.isFinite(location)) return this.attributeInfosByLocation[location];
        return this.attributeInfosByName[locationOrName] || null;
    }
    getAttributeLocation(locationOrName) {
        const attributeInfo = this.getAttributeInfo(locationOrName);
        return attributeInfo ? attributeInfo.location : -1;
    }
    getAttributeAccessor(locationOrName) {
        const attributeInfo = this.getAttributeInfo(locationOrName);
        return attributeInfo ? attributeInfo.accessor : null;
    }
    getVaryingInfo(locationOrName) {
        const location = Number(locationOrName);
        if (Number.isFinite(location)) return this.varyingInfos[location];
        return this.varyingInfosByName[locationOrName] || null;
    }
    getVaryingIndex(locationOrName) {
        const varying = this.getVaryingInfo();
        return varying ? varying.location : -1;
    }
    getVaryingAccessor(locationOrName) {
        const varying = this.getVaryingInfo();
        return varying ? varying.accessor : null;
    }
    _readAttributesFromProgram(program) {
        const { gl: gl } = program;
        const count = gl.getProgramParameter(program.handle, 35721);
        for(let index = 0; index < count; index++){
            const { name: name, type: type, size: size } = gl.getActiveAttrib(program.handle, index);
            const location = gl.getAttribLocation(program.handle, name);
            if (location >= 0) this._addAttribute(location, name, type, size);
        }
        this.attributeInfos.sort((a, b)=>a.location - b.location);
    }
    _readVaryingsFromProgram(program) {
        const { gl: gl } = program;
        if (!(0, $8HKWo.isWebGL2)(gl)) return;
        const count = gl.getProgramParameter(program.handle, 35971);
        for(let location = 0; location < count; location++){
            const { name: name, type: type, size: size } = gl.getTransformFeedbackVarying(program.handle, location);
            this._addVarying(location, name, type, size);
        }
        this.varyingInfos.sort((a, b)=>a.location - b.location);
    }
    _addAttribute(location, name, compositeType, size) {
        const { type: type, components: components } = (0, $eX2kV.decomposeCompositeGLType)(compositeType);
        const accessor = {
            type: type,
            size: size * components
        };
        this._inferProperties(location, name, accessor);
        const attributeInfo = {
            location: location,
            name: name,
            accessor: new (0, $35tVQ.default)(accessor)
        };
        this.attributeInfos.push(attributeInfo);
        this.attributeInfosByLocation[location] = attributeInfo;
        this.attributeInfosByName[attributeInfo.name] = attributeInfo;
    }
    _inferProperties(location, name, accessor) {
        if (/instance/i.test(name)) accessor.divisor = 1;
    }
    _addVarying(location, name, compositeType, size) {
        const { type: type, components: components } = (0, $eX2kV.decomposeCompositeGLType)(compositeType);
        const accessor = new (0, $35tVQ.default)({
            type: type,
            size: size * components
        });
        const varying = {
            location: location,
            name: name,
            accessor: accessor
        };
        this.varyingInfos.push(varying);
        this.varyingInfosByName[varying.name] = varying;
    }
    constructor(program){
        this.id = program.id;
        this.attributeInfos = [];
        this.attributeInfosByName = {};
        this.attributeInfosByLocation = [];
        this.varyingInfos = [];
        this.varyingInfosByName = {};
        Object.seal(this);
        this._readAttributesFromProgram(program);
        this._readVaryingsFromProgram(program);
    }
}

});
parcelRegister("eX2kV", function(module, exports) {

$parcel$export(module.exports, "getPrimitiveDrawMode", function () { return $ae286360388d3737$export$e50fcedcdc9b2c73; });
$parcel$export(module.exports, "decomposeCompositeGLType", function () { return $ae286360388d3737$export$646982523c4faa11; });
$parcel$export(module.exports, "getCompositeGLType", function () { return $ae286360388d3737$export$508acc40581a1522; });

var $ihfnu = parcelRequire("ihfnu");
const $ae286360388d3737$var$GL_BYTE = 0x1400;
const $ae286360388d3737$var$GL_UNSIGNED_BYTE = 0x1401;
const $ae286360388d3737$var$GL_SHORT = 0x1402;
const $ae286360388d3737$var$GL_UNSIGNED_SHORT = 0x1403;
const $ae286360388d3737$var$GL_POINTS = 0x0;
const $ae286360388d3737$var$GL_LINES = 0x1;
const $ae286360388d3737$var$GL_LINE_LOOP = 0x2;
const $ae286360388d3737$var$GL_LINE_STRIP = 0x3;
const $ae286360388d3737$var$GL_TRIANGLES = 0x4;
const $ae286360388d3737$var$GL_TRIANGLE_STRIP = 0x5;
const $ae286360388d3737$var$GL_TRIANGLE_FAN = 0x6;
const $ae286360388d3737$var$GL_FLOAT = 0x1406;
const $ae286360388d3737$var$GL_FLOAT_VEC2 = 0x8b50;
const $ae286360388d3737$var$GL_FLOAT_VEC3 = 0x8b51;
const $ae286360388d3737$var$GL_FLOAT_VEC4 = 0x8b52;
const $ae286360388d3737$var$GL_INT = 0x1404;
const $ae286360388d3737$var$GL_INT_VEC2 = 0x8b53;
const $ae286360388d3737$var$GL_INT_VEC3 = 0x8b54;
const $ae286360388d3737$var$GL_INT_VEC4 = 0x8b55;
const $ae286360388d3737$var$GL_UNSIGNED_INT = 0x1405;
const $ae286360388d3737$var$GL_UNSIGNED_INT_VEC2 = 0x8dc6;
const $ae286360388d3737$var$GL_UNSIGNED_INT_VEC3 = 0x8dc7;
const $ae286360388d3737$var$GL_UNSIGNED_INT_VEC4 = 0x8dc8;
const $ae286360388d3737$var$GL_BOOL = 0x8b56;
const $ae286360388d3737$var$GL_BOOL_VEC2 = 0x8b57;
const $ae286360388d3737$var$GL_BOOL_VEC3 = 0x8b58;
const $ae286360388d3737$var$GL_BOOL_VEC4 = 0x8b59;
const $ae286360388d3737$var$GL_FLOAT_MAT2 = 0x8b5a;
const $ae286360388d3737$var$GL_FLOAT_MAT3 = 0x8b5b;
const $ae286360388d3737$var$GL_FLOAT_MAT4 = 0x8b5c;
const $ae286360388d3737$var$GL_FLOAT_MAT2x3 = 0x8b65;
const $ae286360388d3737$var$GL_FLOAT_MAT2x4 = 0x8b66;
const $ae286360388d3737$var$GL_FLOAT_MAT3x2 = 0x8b67;
const $ae286360388d3737$var$GL_FLOAT_MAT3x4 = 0x8b68;
const $ae286360388d3737$var$GL_FLOAT_MAT4x2 = 0x8b69;
const $ae286360388d3737$var$GL_FLOAT_MAT4x3 = 0x8b6a;
const $ae286360388d3737$var$COMPOSITE_GL_TYPES = {
    [$ae286360388d3737$var$GL_FLOAT]: [
        $ae286360388d3737$var$GL_FLOAT,
        1,
        "float"
    ],
    [$ae286360388d3737$var$GL_FLOAT_VEC2]: [
        $ae286360388d3737$var$GL_FLOAT,
        2,
        "vec2"
    ],
    [$ae286360388d3737$var$GL_FLOAT_VEC3]: [
        $ae286360388d3737$var$GL_FLOAT,
        3,
        "vec3"
    ],
    [$ae286360388d3737$var$GL_FLOAT_VEC4]: [
        $ae286360388d3737$var$GL_FLOAT,
        4,
        "vec4"
    ],
    [$ae286360388d3737$var$GL_INT]: [
        $ae286360388d3737$var$GL_INT,
        1,
        "int"
    ],
    [$ae286360388d3737$var$GL_INT_VEC2]: [
        $ae286360388d3737$var$GL_INT,
        2,
        "ivec2"
    ],
    [$ae286360388d3737$var$GL_INT_VEC3]: [
        $ae286360388d3737$var$GL_INT,
        3,
        "ivec3"
    ],
    [$ae286360388d3737$var$GL_INT_VEC4]: [
        $ae286360388d3737$var$GL_INT,
        4,
        "ivec4"
    ],
    [$ae286360388d3737$var$GL_UNSIGNED_INT]: [
        $ae286360388d3737$var$GL_UNSIGNED_INT,
        1,
        "uint"
    ],
    [$ae286360388d3737$var$GL_UNSIGNED_INT_VEC2]: [
        $ae286360388d3737$var$GL_UNSIGNED_INT,
        2,
        "uvec2"
    ],
    [$ae286360388d3737$var$GL_UNSIGNED_INT_VEC3]: [
        $ae286360388d3737$var$GL_UNSIGNED_INT,
        3,
        "uvec3"
    ],
    [$ae286360388d3737$var$GL_UNSIGNED_INT_VEC4]: [
        $ae286360388d3737$var$GL_UNSIGNED_INT,
        4,
        "uvec4"
    ],
    [$ae286360388d3737$var$GL_BOOL]: [
        $ae286360388d3737$var$GL_FLOAT,
        1,
        "bool"
    ],
    [$ae286360388d3737$var$GL_BOOL_VEC2]: [
        $ae286360388d3737$var$GL_FLOAT,
        2,
        "bvec2"
    ],
    [$ae286360388d3737$var$GL_BOOL_VEC3]: [
        $ae286360388d3737$var$GL_FLOAT,
        3,
        "bvec3"
    ],
    [$ae286360388d3737$var$GL_BOOL_VEC4]: [
        $ae286360388d3737$var$GL_FLOAT,
        4,
        "bvec4"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT2]: [
        $ae286360388d3737$var$GL_FLOAT,
        8,
        "mat2"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT2x3]: [
        $ae286360388d3737$var$GL_FLOAT,
        8,
        "mat2x3"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT2x4]: [
        $ae286360388d3737$var$GL_FLOAT,
        8,
        "mat2x4"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT3]: [
        $ae286360388d3737$var$GL_FLOAT,
        12,
        "mat3"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT3x2]: [
        $ae286360388d3737$var$GL_FLOAT,
        12,
        "mat3x2"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT3x4]: [
        $ae286360388d3737$var$GL_FLOAT,
        12,
        "mat3x4"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT4]: [
        $ae286360388d3737$var$GL_FLOAT,
        16,
        "mat4"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT4x2]: [
        $ae286360388d3737$var$GL_FLOAT,
        16,
        "mat4x2"
    ],
    [$ae286360388d3737$var$GL_FLOAT_MAT4x3]: [
        $ae286360388d3737$var$GL_FLOAT,
        16,
        "mat4x3"
    ]
};
function $ae286360388d3737$export$e50fcedcdc9b2c73(drawMode) {
    switch(drawMode){
        case $ae286360388d3737$var$GL_POINTS:
            return $ae286360388d3737$var$GL_POINTS;
        case $ae286360388d3737$var$GL_LINES:
            return $ae286360388d3737$var$GL_LINES;
        case $ae286360388d3737$var$GL_LINE_STRIP:
            return $ae286360388d3737$var$GL_LINES;
        case $ae286360388d3737$var$GL_LINE_LOOP:
            return $ae286360388d3737$var$GL_LINES;
        case $ae286360388d3737$var$GL_TRIANGLES:
            return $ae286360388d3737$var$GL_TRIANGLES;
        case $ae286360388d3737$var$GL_TRIANGLE_STRIP:
            return $ae286360388d3737$var$GL_TRIANGLES;
        case $ae286360388d3737$var$GL_TRIANGLE_FAN:
            return $ae286360388d3737$var$GL_TRIANGLES;
        default:
            (0, $ihfnu.assert)(false);
            return 0;
    }
}
function $ae286360388d3737$export$eee3601b0ff4cdda(_ref) {
    let { drawMode: drawMode, vertexCount: vertexCount } = _ref;
    switch(drawMode){
        case $ae286360388d3737$var$GL_POINTS:
        case $ae286360388d3737$var$GL_LINE_LOOP:
            return vertexCount;
        case $ae286360388d3737$var$GL_LINES:
            return vertexCount / 2;
        case $ae286360388d3737$var$GL_LINE_STRIP:
            return vertexCount - 1;
        case $ae286360388d3737$var$GL_TRIANGLES:
            return vertexCount / 3;
        case $ae286360388d3737$var$GL_TRIANGLE_STRIP:
        case $ae286360388d3737$var$GL_TRIANGLE_FAN:
            return vertexCount - 2;
        default:
            (0, $ihfnu.assert)(false);
            return 0;
    }
}
function $ae286360388d3737$export$bb010cc24ecaa644(_ref2) {
    let { drawMode: drawMode, vertexCount: vertexCount } = _ref2;
    const primitiveCount = $ae286360388d3737$export$eee3601b0ff4cdda({
        drawMode: drawMode,
        vertexCount: vertexCount
    });
    switch($ae286360388d3737$export$e50fcedcdc9b2c73(drawMode)){
        case $ae286360388d3737$var$GL_POINTS:
            return primitiveCount;
        case $ae286360388d3737$var$GL_LINES:
            return primitiveCount * 2;
        case $ae286360388d3737$var$GL_TRIANGLES:
            return primitiveCount * 3;
        default:
            (0, $ihfnu.assert)(false);
            return 0;
    }
}
function $ae286360388d3737$export$646982523c4faa11(compositeGLType) {
    const typeAndSize = $ae286360388d3737$var$COMPOSITE_GL_TYPES[compositeGLType];
    if (!typeAndSize) return null;
    const [type, components] = typeAndSize;
    return {
        type: type,
        components: components
    };
}
function $ae286360388d3737$export$508acc40581a1522(type, components) {
    switch(type){
        case $ae286360388d3737$var$GL_BYTE:
        case $ae286360388d3737$var$GL_UNSIGNED_BYTE:
        case $ae286360388d3737$var$GL_SHORT:
        case $ae286360388d3737$var$GL_UNSIGNED_SHORT:
            type = $ae286360388d3737$var$GL_FLOAT;
            break;
        default:
    }
    for(const glType in $ae286360388d3737$var$COMPOSITE_GL_TYPES){
        const [compType, compComponents, name] = $ae286360388d3737$var$COMPOSITE_GL_TYPES[glType];
        if (compType === type && compComponents === components) return {
            glType: glType,
            name: name
        };
    }
    return null;
}

});




parcelRegister("5Ha6k", function(module, exports) {

$parcel$export(module.exports, "getDebugTableForProgramConfiguration", function () { return $4258cdc92cfb39b2$export$826103546372d55e; });

var $eX2kV = parcelRequire("eX2kV");
function $4258cdc92cfb39b2$export$826103546372d55e(config) {
    const table = {};
    const header = "Accessors for ".concat(config.id);
    for (const attributeInfo of config.attributeInfos)if (attributeInfo) {
        const glslDeclaration = $4258cdc92cfb39b2$var$getGLSLDeclaration(attributeInfo);
        table["in ".concat(glslDeclaration)] = {
            [header]: JSON.stringify(attributeInfo.accessor)
        };
    }
    for (const varyingInfo of config.varyingInfos)if (varyingInfo) {
        const glslDeclaration = $4258cdc92cfb39b2$var$getGLSLDeclaration(varyingInfo);
        table["out ".concat(glslDeclaration)] = {
            [header]: JSON.stringify(varyingInfo.accessor)
        };
    }
    return table;
}
function $4258cdc92cfb39b2$var$getGLSLDeclaration(attributeInfo) {
    const { type: type, size: size } = attributeInfo.accessor;
    const typeAndName = (0, $eX2kV.getCompositeGLType)(type, size);
    if (typeAndName) return "".concat(typeAndName.name, " ").concat(attributeInfo.name);
    return attributeInfo.name;
}

});

parcelRegister("j4CMX", function(module, exports) {

$parcel$export(module.exports, "getDebugTableForUniforms", function () { return $de2c7aa4c84e6a4c$export$72be64c472054e23; });

var $ihfnu = parcelRequire("ihfnu");

var $gIkfc = parcelRequire("gIkfc");
function $de2c7aa4c84e6a4c$export$72be64c472054e23(_ref) {
    let { header: header = "Uniforms", program: program, uniforms: uniforms, undefinedOnly: undefinedOnly = false } = _ref;
    (0, $ihfnu.assert)(program);
    const SHADER_MODULE_UNIFORM_REGEXP = ".*_.*";
    const PROJECT_MODULE_UNIFORM_REGEXP = ".*Matrix";
    const uniformLocations = program._uniformSetters;
    const table = {};
    const uniformNames = Object.keys(uniformLocations).sort();
    let count = 0;
    for (const uniformName of uniformNames){
        if (!uniformName.match(SHADER_MODULE_UNIFORM_REGEXP) && !uniformName.match(PROJECT_MODULE_UNIFORM_REGEXP)) {
            if ($de2c7aa4c84e6a4c$var$addUniformToTable({
                table: table,
                header: header,
                uniforms: uniforms,
                uniformName: uniformName,
                undefinedOnly: undefinedOnly
            })) count++;
        }
    }
    for (const uniformName of uniformNames){
        if (uniformName.match(PROJECT_MODULE_UNIFORM_REGEXP)) {
            if ($de2c7aa4c84e6a4c$var$addUniformToTable({
                table: table,
                header: header,
                uniforms: uniforms,
                uniformName: uniformName,
                undefinedOnly: undefinedOnly
            })) count++;
        }
    }
    for (const uniformName of uniformNames){
        if (!table[uniformName]) {
            if ($de2c7aa4c84e6a4c$var$addUniformToTable({
                table: table,
                header: header,
                uniforms: uniforms,
                uniformName: uniformName,
                undefinedOnly: undefinedOnly
            })) count++;
        }
    }
    let unusedCount = 0;
    const unusedTable = {};
    if (!undefinedOnly) for(const uniformName in uniforms){
        const uniform = uniforms[uniformName];
        if (!table[uniformName]) {
            unusedCount++;
            unusedTable[uniformName] = {
                Type: "NOT USED: ".concat(uniform),
                [header]: (0, $gIkfc.formatValue)(uniform)
            };
        }
    }
    return {
        table: table,
        count: count,
        unusedTable: unusedTable,
        unusedCount: unusedCount
    };
}
function $de2c7aa4c84e6a4c$var$addUniformToTable(_ref2) {
    let { table: table, header: header, uniforms: uniforms, uniformName: uniformName, undefinedOnly: undefinedOnly } = _ref2;
    const value = uniforms[uniformName];
    const isDefined = $de2c7aa4c84e6a4c$var$isUniformDefined(value);
    if (!undefinedOnly || !isDefined) {
        table[uniformName] = {
            [header]: isDefined ? (0, $gIkfc.formatValue)(value) : "N/A",
            "Uniform Type": isDefined ? value : "NOT PROVIDED"
        };
        return true;
    }
    return false;
}
function $de2c7aa4c84e6a4c$var$isUniformDefined(value) {
    return value !== undefined && value !== null;
}

});
parcelRegister("gIkfc", function(module, exports) {

$parcel$export(module.exports, "formatValue", function () { return $c2b0757a74d12c48$export$7c4d25c0c3217d8c; });
function $c2b0757a74d12c48$var$formatArrayValue(v, opts) {
    const { maxElts: maxElts = 16, size: size = 1 } = opts;
    let string = "[";
    for(let i = 0; i < v.length && i < maxElts; ++i){
        if (i > 0) string += ",".concat(i % size === 0 ? " " : "");
        string += $c2b0757a74d12c48$export$7c4d25c0c3217d8c(v[i], opts);
    }
    const terminator = v.length > maxElts ? "..." : "]";
    return "".concat(string).concat(terminator);
}
function $c2b0757a74d12c48$export$7c4d25c0c3217d8c(v) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const EPSILON = 1e-16;
    const { isInteger: isInteger = false } = opts;
    if (Array.isArray(v) || ArrayBuffer.isView(v)) return $c2b0757a74d12c48$var$formatArrayValue(v, opts);
    if (!Number.isFinite(v)) return String(v);
    if (Math.abs(v) < EPSILON) return isInteger ? "0" : "0.";
    if (isInteger) return v.toFixed(0);
    if (Math.abs(v) > 100 && Math.abs(v) < 10000) return v.toFixed(0);
    const string = v.toPrecision(2);
    const decimal = string.indexOf(".0");
    return decimal === string.length - 2 ? string.slice(0, -1) : string;
}

});


parcelRegister("4wHgq", function(module, exports) {

$parcel$export(module.exports, "getDebugTableForVertexArray", function () { return $34bbb5e5d4fe9d14$export$f05218eded921e71; });

var $7jraD = parcelRequire("7jraD");

var $5tEaG = parcelRequire("5tEaG");

var $eX2kV = parcelRequire("eX2kV");

var $gIkfc = parcelRequire("gIkfc");
function $34bbb5e5d4fe9d14$export$f05218eded921e71(_ref) {
    let { vertexArray: vertexArray, header: header = "Attributes" } = _ref;
    if (!vertexArray.configuration) return {};
    const table = {};
    if (vertexArray.elements) table.ELEMENT_ARRAY_BUFFER = $34bbb5e5d4fe9d14$var$getDebugTableRow(vertexArray, vertexArray.elements, null, header);
    const attributes = vertexArray.values;
    for(const attributeLocation in attributes){
        const info = vertexArray._getAttributeInfo(attributeLocation);
        if (info) {
            let rowHeader = "".concat(attributeLocation, ": ").concat(info.name);
            const accessor = vertexArray.accessors[info.location];
            if (accessor) rowHeader = "".concat(attributeLocation, ": ").concat($34bbb5e5d4fe9d14$var$getGLSLDeclaration(info.name, accessor));
            table[rowHeader] = $34bbb5e5d4fe9d14$var$getDebugTableRow(vertexArray, attributes[attributeLocation], accessor, header);
        }
    }
    return table;
}
function $34bbb5e5d4fe9d14$var$getDebugTableRow(vertexArray, attribute, accessor, header) {
    const { gl: gl } = vertexArray;
    if (!attribute) return {
        [header]: "null",
        "Format ": "N/A"
    };
    let type = "NOT PROVIDED";
    let size = 1;
    let verts = 0;
    let bytes = 0;
    let isInteger;
    let marker;
    let value;
    if (accessor) {
        type = accessor.type;
        size = accessor.size;
        type = String(type).replace("Array", "");
        isInteger = type.indexOf("nt") !== -1;
    }
    if (attribute instanceof (0, $7jraD.default)) {
        const buffer = attribute;
        const { data: data, changed: changed } = buffer.getDebugData();
        marker = changed ? "*" : "";
        value = data;
        bytes = buffer.byteLength;
        verts = bytes / data.BYTES_PER_ELEMENT / size;
        let format;
        if (accessor) {
            const instanced = accessor.divisor > 0;
            format = "".concat(instanced ? "I " : "P ", " ").concat(verts, " (x").concat(size, "=").concat(bytes, " bytes ").concat((0, $5tEaG.getKey)(gl, type), ")");
        } else {
            isInteger = true;
            format = "".concat(bytes, " bytes");
        }
        return {
            [header]: "".concat(marker).concat((0, $gIkfc.formatValue)(value, {
                size: size,
                isInteger: isInteger
            })),
            "Format ": format
        };
    }
    value = attribute;
    size = attribute.length;
    type = String(attribute.constructor.name).replace("Array", "");
    isInteger = type.indexOf("nt") !== -1;
    return {
        [header]: "".concat((0, $gIkfc.formatValue)(value, {
            size: size,
            isInteger: isInteger
        }), " (constant)"),
        "Format ": "".concat(size, "x").concat(type, " (constant)")
    };
}
function $34bbb5e5d4fe9d14$var$getGLSLDeclaration(name, accessor) {
    const { type: type, size: size } = accessor;
    const typeAndName = (0, $eX2kV.getCompositeGLType)(type, size);
    return typeAndName ? "".concat(name, " (").concat(typeAndName.name, ")") : name;
}

});

parcelRegister("b7Tm8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $819b49bb2faa961a$export$2e2bcd8739ae039; });
parcelRequire("73UuK");
var $lvicK = parcelRequire("lvicK");

var $35tVQ = parcelRequire("35tVQ");

var $7jraD = parcelRequire("7jraD");

var $37NyF = parcelRequire("37NyF");

var $ihfnu = parcelRequire("ihfnu");

var $z6hiF = parcelRequire("z6hiF");
const $819b49bb2faa961a$var$ERR_ATTRIBUTE_TYPE = "VertexArray: attributes must be Buffers or constants (i.e. typed array)";
const $819b49bb2faa961a$var$MULTI_LOCATION_ATTRIBUTE_REGEXP = /^(.+)__LOCATION_([0-9]+)$/;
const $819b49bb2faa961a$var$DEPRECATIONS_V6 = [
    "setBuffers",
    "setGeneric",
    "clearBindings",
    "setLocations",
    "setGenericValues",
    "setDivisor",
    "enable",
    "disable"
];
class $819b49bb2faa961a$export$2e2bcd8739ae039 {
    delete() {
        if (this.buffer) this.buffer.delete();
        this.vertexArrayObject.delete();
    }
    initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.reset();
        this.configuration = null;
        this.bindOnUse = false;
        return this.setProps(props);
    }
    reset() {
        this.elements = null;
        this.elementsAccessor = null;
        const { MAX_ATTRIBUTES: MAX_ATTRIBUTES } = this.vertexArrayObject;
        this.values = new Array(MAX_ATTRIBUTES).fill(null);
        this.accessors = new Array(MAX_ATTRIBUTES).fill(null);
        this.unused = {};
        this.drawParams = null;
        return this;
    }
    setProps(props) {
        if ("program" in props) this.configuration = props.program && props.program.configuration;
        if ("configuration" in props) this.configuration = props.configuration;
        if ("attributes" in props) this.setAttributes(props.attributes);
        if ("elements" in props) this.setElementBuffer(props.elements);
        if ("bindOnUse" in props) props = props.bindOnUse;
        return this;
    }
    clearDrawParams() {
        this.drawParams = null;
    }
    getDrawParams() {
        this.drawParams = this.drawParams || this._updateDrawParams();
        return this.drawParams;
    }
    setAttributes(attributes) {
        Object.assign(this.attributes, attributes);
        this.vertexArrayObject.bind(()=>{
            for(const locationOrName in attributes){
                const value = attributes[locationOrName];
                this._setAttribute(locationOrName, value);
            }
            this.gl.bindBuffer(34962, null);
        });
        return this;
    }
    setElementBuffer() {
        let elementBuffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let accessor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.elements = elementBuffer;
        this.elementsAccessor = accessor;
        this.clearDrawParams();
        this.vertexArrayObject.setElementBuffer(elementBuffer, accessor);
        return this;
    }
    setBuffer(locationOrName, buffer) {
        let appAccessor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (buffer.target === 34963) return this.setElementBuffer(buffer, appAccessor);
        const { location: location, accessor: accessor } = this._resolveLocationAndAccessor(locationOrName, buffer, buffer.accessor, appAccessor);
        if (location >= 0) {
            this.values[location] = buffer;
            this.accessors[location] = accessor;
            this.clearDrawParams();
            this.vertexArrayObject.setBuffer(location, buffer, accessor);
        }
        return this;
    }
    setConstant(locationOrName, arrayValue) {
        let appAccessor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const { location: location, accessor: accessor } = this._resolveLocationAndAccessor(locationOrName, arrayValue, Object.assign({
            size: arrayValue.length
        }, appAccessor));
        if (location >= 0) {
            arrayValue = this.vertexArrayObject._normalizeConstantArrayValue(arrayValue);
            this.values[location] = arrayValue;
            this.accessors[location] = accessor;
            this.clearDrawParams();
            this.vertexArrayObject.enable(location, false);
        }
        return this;
    }
    unbindBuffers() {
        this.vertexArrayObject.bind(()=>{
            if (this.elements) this.vertexArrayObject.setElementBuffer(null);
            this.buffer = this.buffer || new (0, $7jraD.default)(this.gl, {
                accessor: {
                    size: 4
                }
            });
            for(let location = 0; location < this.vertexArrayObject.MAX_ATTRIBUTES; location++)if (this.values[location] instanceof (0, $7jraD.default)) {
                this.gl.disableVertexAttribArray(location);
                this.gl.bindBuffer(34962, this.buffer.handle);
                this.gl.vertexAttribPointer(location, 1, 5126, false, 0, 0);
            }
        });
        return this;
    }
    bindBuffers() {
        this.vertexArrayObject.bind(()=>{
            if (this.elements) this.setElementBuffer(this.elements);
            for(let location = 0; location < this.vertexArrayObject.MAX_ATTRIBUTES; location++){
                const buffer = this.values[location];
                if (buffer instanceof (0, $7jraD.default)) this.setBuffer(location, buffer);
            }
        });
        return this;
    }
    bindForDraw(vertexCount, instanceCount, func) {
        let value;
        this.vertexArrayObject.bind(()=>{
            this._setConstantAttributes(vertexCount, instanceCount);
            value = func();
        });
        return value;
    }
    _resolveLocationAndAccessor(locationOrName, value, valueAccessor, appAccessor) {
        const INVALID_RESULT = {
            location: -1,
            accessor: null
        };
        const { location: location, name: name } = this._getAttributeIndex(locationOrName);
        if (!Number.isFinite(location) || location < 0) {
            this.unused[locationOrName] = value;
            (0, $lvicK.log).once(3, ()=>"unused value ".concat(locationOrName, " in ").concat(this.id))();
            return INVALID_RESULT;
        }
        const accessInfo = this._getAttributeInfo(name || location);
        if (!accessInfo) return INVALID_RESULT;
        const currentAccessor = this.accessors[location] || {};
        const accessor = (0, $35tVQ.default).resolve(accessInfo.accessor, currentAccessor, valueAccessor, appAccessor);
        const { size: size, type: type } = accessor;
        (0, $ihfnu.assert)(Number.isFinite(size) && Number.isFinite(type));
        return {
            location: location,
            accessor: accessor
        };
    }
    _getAttributeInfo(attributeName) {
        return this.configuration && this.configuration.getAttributeInfo(attributeName);
    }
    _getAttributeIndex(locationOrName) {
        const location = Number(locationOrName);
        if (Number.isFinite(location)) return {
            location: location
        };
        const multiLocation = $819b49bb2faa961a$var$MULTI_LOCATION_ATTRIBUTE_REGEXP.exec(locationOrName);
        const name = multiLocation ? multiLocation[1] : locationOrName;
        const locationOffset = multiLocation ? Number(multiLocation[2]) : 0;
        if (this.configuration) return {
            location: this.configuration.getAttributeLocation(name) + locationOffset,
            name: name
        };
        return {
            location: -1
        };
    }
    _setAttribute(locationOrName, value) {
        if (value instanceof (0, $7jraD.default)) this.setBuffer(locationOrName, value);
        else if (Array.isArray(value) && value.length && value[0] instanceof (0, $7jraD.default)) {
            const buffer = value[0];
            const accessor = value[1];
            this.setBuffer(locationOrName, buffer, accessor);
        } else if (ArrayBuffer.isView(value) || Array.isArray(value)) {
            const constant = value;
            this.setConstant(locationOrName, constant);
        } else if (value.buffer instanceof (0, $7jraD.default)) {
            const accessor = value;
            this.setBuffer(locationOrName, accessor.buffer, accessor);
        } else throw new Error($819b49bb2faa961a$var$ERR_ATTRIBUTE_TYPE);
    }
    _setConstantAttributes(vertexCount, instanceCount) {
        const elementCount = Math.max(vertexCount | 0, instanceCount | 0);
        let constant = this.values[0];
        if (ArrayBuffer.isView(constant)) this._setConstantAttributeZero(constant, elementCount);
        for(let location = 1; location < this.vertexArrayObject.MAX_ATTRIBUTES; location++){
            constant = this.values[location];
            if (ArrayBuffer.isView(constant)) this._setConstantAttribute(location, constant);
        }
    }
    _setConstantAttributeZero(constant, elementCount) {
        if ((0, $37NyF.default).isSupported(this.gl, {
            constantAttributeZero: true
        })) {
            this._setConstantAttribute(0, constant);
            return;
        }
        const buffer = this.vertexArrayObject.getConstantBuffer(elementCount, constant);
        this.vertexArrayObject.setBuffer(0, buffer, this.accessors[0]);
    }
    _setConstantAttribute(location, constant) {
        (0, $37NyF.default).setConstant(this.gl, location, constant);
    }
    _updateDrawParams() {
        const drawParams = {
            isIndexed: false,
            isInstanced: false,
            indexCount: Infinity,
            vertexCount: Infinity,
            instanceCount: Infinity
        };
        for(let location = 0; location < this.vertexArrayObject.MAX_ATTRIBUTES; location++)this._updateDrawParamsForLocation(drawParams, location);
        if (this.elements) {
            drawParams.elementCount = this.elements.getElementCount(this.elements.accessor);
            drawParams.isIndexed = true;
            drawParams.indexType = this.elementsAccessor.type || this.elements.accessor.type;
            drawParams.indexOffset = this.elementsAccessor.offset || 0;
        }
        if (drawParams.indexCount === Infinity) drawParams.indexCount = 0;
        if (drawParams.vertexCount === Infinity) drawParams.vertexCount = 0;
        if (drawParams.instanceCount === Infinity) drawParams.instanceCount = 0;
        return drawParams;
    }
    _updateDrawParamsForLocation(drawParams, location) {
        const value = this.values[location];
        const accessor = this.accessors[location];
        if (!value) return;
        const { divisor: divisor } = accessor;
        const isInstanced = divisor > 0;
        drawParams.isInstanced = drawParams.isInstanced || isInstanced;
        if (value instanceof (0, $7jraD.default)) {
            const buffer = value;
            if (isInstanced) {
                const instanceCount = buffer.getVertexCount(accessor);
                drawParams.instanceCount = Math.min(drawParams.instanceCount, instanceCount);
            } else {
                const vertexCount = buffer.getVertexCount(accessor);
                drawParams.vertexCount = Math.min(drawParams.vertexCount, vertexCount);
            }
        }
    }
    setElements() {
        let elementBuffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let accessor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $lvicK.log).deprecated("setElements", "setElementBuffer")();
        return this.setElementBuffer(elementBuffer, accessor);
    }
    constructor(gl){
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const id = opts.id || opts.program && opts.program.id;
        this.id = id;
        this.gl = gl;
        this.configuration = null;
        this.elements = null;
        this.elementsAccessor = null;
        this.values = null;
        this.accessors = null;
        this.unused = null;
        this.drawParams = null;
        this.buffer = null;
        this.attributes = {};
        this.vertexArrayObject = new (0, $37NyF.default)(gl);
        (0, $z6hiF.stubRemovedMethods)(this, "VertexArray", "v6.0", $819b49bb2faa961a$var$DEPRECATIONS_V6);
        this.initialize(opts);
        Object.seal(this);
    }
}

});
parcelRegister("37NyF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $246877c3891b0389$export$2e2bcd8739ae039; });

var $1OVow = parcelRequire("1OVow");

var $7jraD = parcelRequire("7jraD");
parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");

var $2lgNF = parcelRequire("2lgNF");

var $ihfnu = parcelRequire("ihfnu");

var $8P3Ct = parcelRequire("8P3Ct");
const $246877c3891b0389$var$ERR_ELEMENTS = "elements must be GL.ELEMENT_ARRAY_BUFFER";
class $246877c3891b0389$export$2e2bcd8739ae039 extends (0, $1OVow.default) {
    get [Symbol.toStringTag]() {
        return "VertexArrayObject";
    }
    static isSupported(gl) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (options.constantAttributeZero) return (0, $8HKWo.isWebGL2)(gl) || (0, $8P3Ct.default)() === "Chrome";
        return true;
    }
    static getDefaultArray(gl) {
        gl.luma = gl.luma || {};
        if (!gl.luma.defaultVertexArray) gl.luma.defaultVertexArray = new $246877c3891b0389$export$2e2bcd8739ae039(gl, {
            handle: null,
            isDefaultArray: true
        });
        return gl.luma.defaultVertexArray;
    }
    static getMaxAttributes(gl) {
        $246877c3891b0389$export$2e2bcd8739ae039.MAX_ATTRIBUTES = $246877c3891b0389$export$2e2bcd8739ae039.MAX_ATTRIBUTES || gl.getParameter(34921);
        return $246877c3891b0389$export$2e2bcd8739ae039.MAX_ATTRIBUTES;
    }
    static setConstant(gl, location, array) {
        switch(array.constructor){
            case Float32Array:
                $246877c3891b0389$export$2e2bcd8739ae039._setConstantFloatArray(gl, location, array);
                break;
            case Int32Array:
                $246877c3891b0389$export$2e2bcd8739ae039._setConstantIntArray(gl, location, array);
                break;
            case Uint32Array:
                $246877c3891b0389$export$2e2bcd8739ae039._setConstantUintArray(gl, location, array);
                break;
            default:
                (0, $ihfnu.assert)(false);
        }
    }
    delete() {
        super.delete();
        if (this.buffer) this.buffer.delete();
        return this;
    }
    get MAX_ATTRIBUTES() {
        return $246877c3891b0389$export$2e2bcd8739ae039.getMaxAttributes(this.gl);
    }
    initialize() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return this.setProps(props);
    }
    setProps(props) {
        return this;
    }
    setElementBuffer() {
        let elementBuffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $ihfnu.assert)(!elementBuffer || elementBuffer.target === 34963, $246877c3891b0389$var$ERR_ELEMENTS);
        this.bind(()=>{
            this.gl.bindBuffer(34963, elementBuffer ? elementBuffer.handle : null);
        });
        return this;
    }
    setBuffer(location, buffer, accessor) {
        if (buffer.target === 34963) return this.setElementBuffer(buffer, accessor);
        const { size: size, type: type, stride: stride, offset: offset, normalized: normalized, integer: integer, divisor: divisor } = accessor;
        const { gl: gl, gl2: gl2 } = this;
        location = Number(location);
        this.bind(()=>{
            gl.bindBuffer(34962, buffer.handle);
            if (integer) {
                (0, $ihfnu.assert)((0, $8HKWo.isWebGL2)(gl));
                gl2.vertexAttribIPointer(location, size, type, stride, offset);
            } else gl.vertexAttribPointer(location, size, type, normalized, stride, offset);
            gl.enableVertexAttribArray(location);
            gl2.vertexAttribDivisor(location, divisor || 0);
        });
        return this;
    }
    enable(location) {
        let enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        const disablingAttributeZero = !enable && location === 0 && !$246877c3891b0389$export$2e2bcd8739ae039.isSupported(this.gl, {
            constantAttributeZero: true
        });
        if (!disablingAttributeZero) {
            location = Number(location);
            this.bind(()=>enable ? this.gl.enableVertexAttribArray(location) : this.gl.disableVertexAttribArray(location));
        }
        return this;
    }
    getConstantBuffer(elementCount, value) {
        const constantValue = this._normalizeConstantArrayValue(value);
        const byteLength = constantValue.byteLength * elementCount;
        const length = constantValue.length * elementCount;
        let updateNeeded = !this.buffer;
        this.buffer = this.buffer || new (0, $7jraD.default)(this.gl, byteLength);
        updateNeeded = updateNeeded || this.buffer.reallocate(byteLength);
        updateNeeded = updateNeeded || !this._compareConstantArrayValues(constantValue, this.bufferValue);
        if (updateNeeded) {
            const typedArray = (0, $2lgNF.getScratchArray)(value.constructor, length);
            (0, $2lgNF.fillArray)({
                target: typedArray,
                source: constantValue,
                start: 0,
                count: length
            });
            this.buffer.subData(typedArray);
            this.bufferValue = value;
        }
        return this.buffer;
    }
    _normalizeConstantArrayValue(arrayValue) {
        if (Array.isArray(arrayValue)) return new Float32Array(arrayValue);
        return arrayValue;
    }
    _compareConstantArrayValues(v1, v2) {
        if (!v1 || !v2 || v1.length !== v2.length || v1.constructor !== v2.constructor) return false;
        for(let i = 0; i < v1.length; ++i){
            if (v1[i] !== v2[i]) return false;
        }
        return true;
    }
    static _setConstantFloatArray(gl, location, array) {
        switch(array.length){
            case 1:
                gl.vertexAttrib1fv(location, array);
                break;
            case 2:
                gl.vertexAttrib2fv(location, array);
                break;
            case 3:
                gl.vertexAttrib3fv(location, array);
                break;
            case 4:
                gl.vertexAttrib4fv(location, array);
                break;
            default:
                (0, $ihfnu.assert)(false);
        }
    }
    static _setConstantIntArray(gl, location, array) {
        (0, $ihfnu.assert)((0, $8HKWo.isWebGL2)(gl));
        switch(array.length){
            case 1:
                gl.vertexAttribI1iv(location, array);
                break;
            case 2:
                gl.vertexAttribI2iv(location, array);
                break;
            case 3:
                gl.vertexAttribI3iv(location, array);
                break;
            case 4:
                gl.vertexAttribI4iv(location, array);
                break;
            default:
                (0, $ihfnu.assert)(false);
        }
    }
    static _setConstantUintArray(gl, location, array) {
        (0, $ihfnu.assert)((0, $8HKWo.isWebGL2)(gl));
        switch(array.length){
            case 1:
                gl.vertexAttribI1uiv(location, array);
                break;
            case 2:
                gl.vertexAttribI2uiv(location, array);
                break;
            case 3:
                gl.vertexAttribI3uiv(location, array);
                break;
            case 4:
                gl.vertexAttribI4uiv(location, array);
                break;
            default:
                (0, $ihfnu.assert)(false);
        }
    }
    _createHandle() {
        const gl2 = this.gl;
        return gl2.createVertexArray();
    }
    _deleteHandle(handle) {
        this.gl2.deleteVertexArray(handle);
        return [
            this.elements
        ];
    }
    _bindHandle(handle) {
        this.gl2.bindVertexArray(handle);
    }
    _getParameter(pname, _ref) {
        let { location: location } = _ref;
        (0, $ihfnu.assert)(Number.isFinite(location));
        return this.bind(()=>{
            switch(pname){
                case 34373:
                    return this.gl.getVertexAttribOffset(location, pname);
                default:
                    return this.gl.getVertexAttrib(location, pname);
            }
        });
    }
    constructor(gl){
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const id = opts.id || opts.program && opts.program.id;
        super(gl, Object.assign({}, opts, {
            id: id
        }));
        this.buffer = null;
        this.bufferValue = null;
        this.isDefaultArray = opts.isDefaultArray || false;
        this.gl2 = gl;
        this.initialize(opts);
        Object.seal(this);
    }
}

});
parcelRegister("2lgNF", function(module, exports) {

$parcel$export(module.exports, "getScratchArray", function () { return $1b4a93122ae70e08$export$4c3ca7f6f110bd92; });
$parcel$export(module.exports, "fillArray", function () { return $1b4a93122ae70e08$export$57295b69bf9c5d15; });
let $1b4a93122ae70e08$var$arrayBuffer = null;
function $1b4a93122ae70e08$export$2e3ce519f08759f7(byteLength) {
    if (!$1b4a93122ae70e08$var$arrayBuffer || $1b4a93122ae70e08$var$arrayBuffer.byteLength < byteLength) $1b4a93122ae70e08$var$arrayBuffer = new ArrayBuffer(byteLength);
    return $1b4a93122ae70e08$var$arrayBuffer;
}
function $1b4a93122ae70e08$export$4c3ca7f6f110bd92(Type, length) {
    const scratchArrayBuffer = $1b4a93122ae70e08$export$2e3ce519f08759f7(Type.BYTES_PER_ELEMENT * length);
    return new Type(scratchArrayBuffer, 0, length);
}
function $1b4a93122ae70e08$export$57295b69bf9c5d15(_ref) {
    let { target: target, source: source, start: start = 0, count: count = 1 } = _ref;
    const length = source.length;
    const total = count * length;
    let copied = 0;
    for(let i = start; copied < length; copied++)target[i++] = source[copied];
    while(copied < total)if (copied < total - copied) {
        target.copyWithin(start + copied, start, start + copied);
        copied *= 2;
    } else {
        target.copyWithin(start + copied, start, start + total - copied);
        copied = total;
    }
    return target;
}

});

parcelRegister("8P3Ct", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01a85a66dbca3bf1$export$2e2bcd8739ae039; });

var $jeIEj = parcelRequire("jeIEj");

var $1366E = parcelRequire("1366E");
const $01a85a66dbca3bf1$var$window = globalThis;
function $01a85a66dbca3bf1$export$d0a8044dce8ff2fc() {
    return typeof $01a85a66dbca3bf1$var$window.orientation !== "undefined";
}
function $01a85a66dbca3bf1$export$2e2bcd8739ae039(mockUserAgent) {
    if (!mockUserAgent && !(0, $jeIEj.default)()) return "Node";
    if ((0, $1366E.default)(mockUserAgent)) return "Electron";
    const navigator_ = typeof navigator !== "undefined" ? navigator : {};
    const userAgent = mockUserAgent || navigator_.userAgent || "";
    if (userAgent.indexOf("Edge") > -1) return "Edge";
    const isMSIE = userAgent.indexOf("MSIE ") !== -1;
    const isTrident = userAgent.indexOf("Trident/") !== -1;
    if (isMSIE || isTrident) return "IE";
    if ($01a85a66dbca3bf1$var$window.chrome) return "Chrome";
    if ($01a85a66dbca3bf1$var$window.safari) return "Safari";
    if ($01a85a66dbca3bf1$var$window.mozInnerScreenX) return "Firefox";
    return "Unknown";
}

});



parcelRegister("lrhVz", function(module, exports) {

$parcel$export(module.exports, "getBuffersFromGeometry", function () { return $f9ba069d732f1d2a$export$7e4fab05163ba2d1; });

var $2QP2i = parcelRequire("2QP2i");

var $ihfnu = parcelRequire("ihfnu");
var $7jraD = parcelRequire("7jraD");
const $f9ba069d732f1d2a$var$GLTF_TO_LUMA_ATTRIBUTE_MAP = {
    POSITION: "positions",
    NORMAL: "normals",
    COLOR_0: "colors",
    TEXCOORD_0: "texCoords",
    TEXCOORD_1: "texCoords1",
    TEXCOORD_2: "texCoords2"
};
function $f9ba069d732f1d2a$export$7e4fab05163ba2d1(gl, geometry, options) {
    const buffers = {};
    let indices = geometry.indices;
    for(const name in geometry.attributes){
        const attribute = geometry.attributes[name];
        const remappedName = $f9ba069d732f1d2a$var$mapAttributeName(name, options);
        if (name === "indices") indices = attribute;
        else if (attribute.constant) buffers[remappedName] = attribute.value;
        else {
            const typedArray = attribute.value;
            const accessor = (0, $2QP2i._)({}, attribute);
            delete accessor.value;
            buffers[remappedName] = [
                new (0, $7jraD.default)(gl, typedArray),
                accessor
            ];
            $f9ba069d732f1d2a$export$3f504f33778aed92(name, accessor);
        }
    }
    if (indices) {
        const data = indices.value || indices;
        (0, $ihfnu.assert)(data instanceof Uint16Array || data instanceof Uint32Array, 'attribute array for "indices" must be of integer type');
        const accessor = {
            size: 1,
            isIndexed: indices.isIndexed === undefined ? true : indices.isIndexed
        };
        buffers.indices = [
            new (0, $7jraD.default)(gl, {
                data: data,
                target: 34963
            }),
            accessor
        ];
    }
    return buffers;
}
function $f9ba069d732f1d2a$var$mapAttributeName(name, options) {
    const { attributeMap: attributeMap = $f9ba069d732f1d2a$var$GLTF_TO_LUMA_ATTRIBUTE_MAP } = options || {};
    return attributeMap && attributeMap[name] || name;
}
function $f9ba069d732f1d2a$export$3f504f33778aed92(attributeName, attribute) {
    let category;
    switch(attributeName){
        case "texCoords":
        case "texCoord1":
        case "texCoord2":
        case "texCoord3":
            category = "uvs";
            break;
        case "vertices":
        case "positions":
        case "normals":
        case "pickingColors":
            category = "vectors";
            break;
        default:
    }
    switch(category){
        case "vectors":
            attribute.size = attribute.size || 3;
            break;
        case "uvs":
            attribute.size = attribute.size || 2;
            break;
        default:
    }
    (0, $ihfnu.assert)(Number.isFinite(attribute.size), "attribute ".concat(attributeName, " needs size"));
}

});



parcelRegister("9P91Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726fe162c2e99841$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1zR3q = parcelRequire("1zR3q");

var $7jraD = parcelRequire("7jraD");
var $bn48C = parcelRequire("bn48C");

var $yVHST = parcelRequire("yVHST");

var $5YQrt = parcelRequire("5YQrt");

var $18U1I = parcelRequire("18U1I");
class $726fe162c2e99841$export$2e2bcd8739ae039 {
    get inProgress() {
        return this.transition.inProgress;
    }
    start(transitionSettings, numInstances) {
        if (transitionSettings.duration <= 0) {
            this.transition.cancel();
            return;
        }
        this.settings = transitionSettings;
        const { gl: gl, buffers: buffers, attribute: attribute } = this;
        (0, $5YQrt.cycleBuffers)(buffers);
        const padBufferOpts = {
            numInstances: numInstances,
            attribute: attribute,
            fromLength: this.currentLength,
            fromStartIndices: this.currentStartIndices,
            getData: transitionSettings.enter
        };
        for (const buffer of buffers)(0, $5YQrt.padBuffer)((0, $2QP2i._)({
            buffer: buffer
        }, padBufferOpts));
        this.currentStartIndices = attribute.startIndices;
        this.currentLength = (0, $5YQrt.getAttributeBufferLength)(attribute, numInstances);
        this.attributeInTransition.setData({
            buffer: buffers[1],
            value: attribute.value
        });
        this.transition.start(transitionSettings);
        this.transform.update({
            elementCount: Math.floor(this.currentLength / attribute.size),
            sourceBuffers: {
                aFrom: buffers[0],
                aTo: (0, $5YQrt.getSourceBufferAttribute)(gl, attribute)
            },
            feedbackBuffers: {
                vCurrent: buffers[1]
            }
        });
    }
    update() {
        const updated = this.transition.update();
        if (updated) {
            const { duration: duration, easing: easing } = this.settings;
            const { time: time } = this.transition;
            let t = time / duration;
            if (easing) t = easing(t);
            this.transform.run({
                uniforms: {
                    time: t
                }
            });
        }
        return updated;
    }
    cancel() {
        this.transition.cancel();
        this.transform.delete();
        for (const buffer of this.buffers)buffer.delete();
        this.buffers.length = 0;
    }
    constructor({ gl: gl, attribute: attribute, timeline: timeline }){
        (0, $1zR3q.default)(this, "gl", void 0);
        (0, $1zR3q.default)(this, "type", "interpolation");
        (0, $1zR3q.default)(this, "attributeInTransition", void 0);
        (0, $1zR3q.default)(this, "settings", void 0);
        (0, $1zR3q.default)(this, "attribute", void 0);
        (0, $1zR3q.default)(this, "transition", void 0);
        (0, $1zR3q.default)(this, "currentStartIndices", void 0);
        (0, $1zR3q.default)(this, "currentLength", void 0);
        (0, $1zR3q.default)(this, "transform", void 0);
        (0, $1zR3q.default)(this, "buffers", void 0);
        this.gl = gl;
        this.transition = new (0, $18U1I.default)(timeline);
        this.attribute = attribute;
        this.attributeInTransition = new (0, $yVHST.default)(gl, attribute.settings);
        this.currentStartIndices = attribute.startIndices;
        this.currentLength = 0;
        this.transform = $726fe162c2e99841$var$getTransform(gl, attribute);
        const bufferOpts = {
            byteLength: 0,
            usage: 35050
        };
        this.buffers = [
            new (0, $7jraD.default)(gl, bufferOpts),
            new (0, $7jraD.default)(gl, bufferOpts)
        ];
    }
}
const $726fe162c2e99841$var$vs = "\n#define SHADER_NAME interpolation-transition-vertex-shader\n\nuniform float time;\nattribute ATTRIBUTE_TYPE aFrom;\nattribute ATTRIBUTE_TYPE aTo;\nvarying ATTRIBUTE_TYPE vCurrent;\n\nvoid main(void) {\n  vCurrent = mix(aFrom, aTo, time);\n  gl_Position = vec4(0.0);\n}\n";
function $726fe162c2e99841$var$getTransform(gl, attribute) {
    const attributeType = (0, $5YQrt.getAttributeTypeFromSize)(attribute.size);
    return new (0, $bn48C.default)(gl, {
        vs: $726fe162c2e99841$var$vs,
        defines: {
            ATTRIBUTE_TYPE: attributeType
        },
        varyings: [
            "vCurrent"
        ]
    });
}

});
parcelRegister("18U1I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d51ff87795113f8$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");
class $0d51ff87795113f8$export$2e2bcd8739ae039 {
    get inProgress() {
        return this._inProgress;
    }
    start(settings) {
        var _this$settings$onStar, _this$settings;
        this.cancel();
        this.settings = settings;
        this._inProgress = true;
        (_this$settings$onStar = (_this$settings = this.settings).onStart) === null || _this$settings$onStar === void 0 || _this$settings$onStar.call(_this$settings, this);
    }
    end() {
        if (this._inProgress) {
            var _this$settings$onEnd, _this$settings2;
            this._timeline.removeChannel(this._handle);
            this._handle = null;
            this._inProgress = false;
            (_this$settings$onEnd = (_this$settings2 = this.settings).onEnd) === null || _this$settings$onEnd === void 0 || _this$settings$onEnd.call(_this$settings2, this);
        }
    }
    cancel() {
        if (this._inProgress) {
            var _this$settings$onInte, _this$settings3;
            (_this$settings$onInte = (_this$settings3 = this.settings).onInterrupt) === null || _this$settings$onInte === void 0 || _this$settings$onInte.call(_this$settings3, this);
            this._timeline.removeChannel(this._handle);
            this._handle = null;
            this._inProgress = false;
        }
    }
    update() {
        var _this$settings$onUpda, _this$settings4;
        if (!this._inProgress) return false;
        if (this._handle === null) {
            const { _timeline: timeline, settings: settings } = this;
            this._handle = timeline.addChannel({
                delay: timeline.getTime(),
                duration: settings.duration
            });
        }
        this.time = this._timeline.getTime(this._handle);
        this._onUpdate();
        (_this$settings$onUpda = (_this$settings4 = this.settings).onUpdate) === null || _this$settings$onUpda === void 0 || _this$settings$onUpda.call(_this$settings4, this);
        if (this._timeline.isFinished(this._handle)) this.end();
        return true;
    }
    _onUpdate() {}
    constructor(timeline){
        (0, $1zR3q.default)(this, "_inProgress", void 0);
        (0, $1zR3q.default)(this, "_handle", void 0);
        (0, $1zR3q.default)(this, "_timeline", void 0);
        (0, $1zR3q.default)(this, "time", void 0);
        (0, $1zR3q.default)(this, "settings", void 0);
        this._inProgress = false;
        this._handle = null;
        this._timeline = timeline;
        this.time = 0;
        this.settings = {
            duration: 0
        };
    }
}

});


parcelRegister("9qj3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dc553df3367855b$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $1zR3q = parcelRequire("1zR3q");

var $7jraD = parcelRequire("7jraD");
var $cJo7e = parcelRequire("cJo7e");
var $2YUMm = parcelRequire("2YUMm");
var $7lUAH = parcelRequire("7lUAH");
var $bn48C = parcelRequire("bn48C");

var $5YQrt = parcelRequire("5YQrt");

var $yVHST = parcelRequire("yVHST");

var $18U1I = parcelRequire("18U1I");
class $6dc553df3367855b$export$2e2bcd8739ae039 {
    get inProgress() {
        return this.transition.inProgress;
    }
    start(transitionSettings, numInstances) {
        const { gl: gl, buffers: buffers, attribute: attribute } = this;
        const padBufferOpts = {
            numInstances: numInstances,
            attribute: attribute,
            fromLength: this.currentLength,
            fromStartIndices: this.currentStartIndices,
            getData: transitionSettings.enter
        };
        for (const buffer of buffers)(0, $5YQrt.padBuffer)((0, $2QP2i._)({
            buffer: buffer
        }, padBufferOpts));
        this.settings = transitionSettings;
        this.currentStartIndices = attribute.startIndices;
        this.currentLength = (0, $5YQrt.getAttributeBufferLength)(attribute, numInstances);
        this.attributeInTransition.setData({
            buffer: buffers[1],
            value: attribute.value
        });
        this.transition.start((0, $edHbI._)((0, $2QP2i._)({}, transitionSettings), {
            duration: Infinity
        }));
        this.transform.update({
            elementCount: Math.floor(this.currentLength / attribute.size),
            sourceBuffers: {
                aTo: (0, $5YQrt.getSourceBufferAttribute)(gl, attribute)
            }
        });
    }
    update() {
        const { buffers: buffers, transform: transform, framebuffer: framebuffer, transition: transition } = this;
        const updated = transition.update();
        if (!updated) return false;
        const settings = this.settings;
        transform.update({
            sourceBuffers: {
                aPrev: buffers[0],
                aCur: buffers[1]
            },
            feedbackBuffers: {
                vNext: buffers[2]
            }
        });
        transform.run({
            framebuffer: framebuffer,
            discard: false,
            clearRenderTarget: true,
            uniforms: {
                stiffness: settings.stiffness,
                damping: settings.damping
            },
            parameters: {
                depthTest: false,
                blend: true,
                viewport: [
                    0,
                    0,
                    1,
                    1
                ],
                blendFunc: [
                    1,
                    1
                ],
                blendEquation: [
                    32776,
                    32776
                ]
            }
        });
        (0, $5YQrt.cycleBuffers)(buffers);
        this.attributeInTransition.setData({
            buffer: buffers[1],
            value: this.attribute.value
        });
        const isTransitioning = (0, $2YUMm.readPixelsToArray)(framebuffer)[0] > 0;
        if (!isTransitioning) transition.end();
        return true;
    }
    cancel() {
        this.transition.cancel();
        this.transform.delete();
        for (const buffer of this.buffers)buffer.delete();
        this.buffers.length = 0;
        this.texture.delete();
        this.framebuffer.delete();
    }
    constructor({ gl: gl, attribute: attribute, timeline: timeline }){
        (0, $1zR3q.default)(this, "gl", void 0);
        (0, $1zR3q.default)(this, "type", "spring");
        (0, $1zR3q.default)(this, "attributeInTransition", void 0);
        (0, $1zR3q.default)(this, "settings", void 0);
        (0, $1zR3q.default)(this, "attribute", void 0);
        (0, $1zR3q.default)(this, "transition", void 0);
        (0, $1zR3q.default)(this, "currentStartIndices", void 0);
        (0, $1zR3q.default)(this, "currentLength", void 0);
        (0, $1zR3q.default)(this, "texture", void 0);
        (0, $1zR3q.default)(this, "framebuffer", void 0);
        (0, $1zR3q.default)(this, "transform", void 0);
        (0, $1zR3q.default)(this, "buffers", void 0);
        this.gl = gl;
        this.type = "spring";
        this.transition = new (0, $18U1I.default)(timeline);
        this.attribute = attribute;
        this.attributeInTransition = new (0, $yVHST.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, attribute.settings), {
            normalized: false
        }));
        this.currentStartIndices = attribute.startIndices;
        this.currentLength = 0;
        this.texture = $6dc553df3367855b$var$getTexture(gl);
        this.framebuffer = $6dc553df3367855b$var$getFramebuffer(gl, this.texture);
        this.transform = $6dc553df3367855b$var$getTransform(gl, attribute, this.framebuffer);
        const bufferOpts = {
            byteLength: 0,
            usage: 35050
        };
        this.buffers = [
            new (0, $7jraD.default)(gl, bufferOpts),
            new (0, $7jraD.default)(gl, bufferOpts),
            new (0, $7jraD.default)(gl, bufferOpts)
        ];
    }
}
function $6dc553df3367855b$var$getTransform(gl, attribute, framebuffer) {
    const attributeType = (0, $5YQrt.getAttributeTypeFromSize)(attribute.size);
    return new (0, $bn48C.default)(gl, {
        framebuffer: framebuffer,
        vs: "\n#define SHADER_NAME spring-transition-vertex-shader\n\n#define EPSILON 0.00001\n\nuniform float stiffness;\nuniform float damping;\nattribute ATTRIBUTE_TYPE aPrev;\nattribute ATTRIBUTE_TYPE aCur;\nattribute ATTRIBUTE_TYPE aTo;\nvarying ATTRIBUTE_TYPE vNext;\nvarying float vIsTransitioningFlag;\n\nATTRIBUTE_TYPE getNextValue(ATTRIBUTE_TYPE cur, ATTRIBUTE_TYPE prev, ATTRIBUTE_TYPE dest) {\n  ATTRIBUTE_TYPE velocity = cur - prev;\n  ATTRIBUTE_TYPE delta = dest - cur;\n  ATTRIBUTE_TYPE spring = delta * stiffness;\n  ATTRIBUTE_TYPE damper = velocity * -1.0 * damping;\n  return spring + damper + velocity + cur;\n}\n\nvoid main(void) {\n  bool isTransitioning = length(aCur - aPrev) > EPSILON || length(aTo - aCur) > EPSILON;\n  vIsTransitioningFlag = isTransitioning ? 1.0 : 0.0;\n\n  vNext = getNextValue(aCur, aPrev, aTo);\n  gl_Position = vec4(0, 0, 0, 1);\n  gl_PointSize = 100.0;\n}\n",
        fs: "\n#define SHADER_NAME spring-transition-is-transitioning-fragment-shader\n\nvarying float vIsTransitioningFlag;\n\nvoid main(void) {\n  if (vIsTransitioningFlag == 0.0) {\n    discard;\n  }\n  gl_FragColor = vec4(1.0);\n}",
        defines: {
            ATTRIBUTE_TYPE: attributeType
        },
        varyings: [
            "vNext"
        ]
    });
}
function $6dc553df3367855b$var$getTexture(gl) {
    return new (0, $7lUAH.default)(gl, {
        data: new Uint8Array(4),
        format: 6408,
        type: 5121,
        border: 0,
        mipmaps: false,
        dataFormat: 6408,
        width: 1,
        height: 1
    });
}
function $6dc553df3367855b$var$getFramebuffer(gl, texture) {
    return new (0, $cJo7e.default)(gl, {
        id: "spring-transition-is-transitioning-framebuffer",
        width: 1,
        height: 1,
        attachments: {
            [36064]: texture
        }
    });
}

});



parcelRegister("EIvaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a641aa104c7bc3$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $5YQrt = parcelRequire("5YQrt");

var $l1gew = parcelRequire("l1gew");

var $io8OD = parcelRequire("io8OD");

var $4VQgq = parcelRequire("4VQgq");
const $07a641aa104c7bc3$var$TRANSITION_TYPES = {
    interpolation: (0, $l1gew.default),
    spring: (0, $io8OD.default)
};
class $07a641aa104c7bc3$export$2e2bcd8739ae039 {
    get active() {
        return this.transitions.size > 0;
    }
    add(key, fromValue, toValue, settings) {
        const { transitions: transitions } = this;
        if (transitions.has(key)) {
            const transition = transitions.get(key);
            const { value: value = transition.settings.fromValue } = transition;
            fromValue = value;
            this.remove(key);
        }
        settings = (0, $5YQrt.normalizeTransitionSettings)(settings);
        if (!settings) return;
        const TransitionType = $07a641aa104c7bc3$var$TRANSITION_TYPES[settings.type];
        if (!TransitionType) {
            (0, $4VQgq.default).error("unsupported transition type '".concat(settings.type, "'"))();
            return;
        }
        const transition = new TransitionType(this.timeline);
        transition.start((0, $edHbI._)((0, $2QP2i._)({}, settings), {
            fromValue: fromValue,
            toValue: toValue
        }));
        transitions.set(key, transition);
    }
    remove(key) {
        const { transitions: transitions } = this;
        if (transitions.has(key)) {
            transitions.get(key).cancel();
            transitions.delete(key);
        }
    }
    update() {
        const propsInTransition = {};
        for (const [key, transition] of this.transitions){
            transition.update();
            propsInTransition[key] = transition.value;
            if (!transition.inProgress) this.remove(key);
        }
        return propsInTransition;
    }
    clear() {
        for (const key of this.transitions.keys())this.remove(key);
    }
    constructor(timeline){
        this.transitions = new Map();
        this.timeline = timeline;
    }
}

});
parcelRegister("l1gew", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4d64889ed8ec45c$export$2e2bcd8739ae039; });

var $cwF9s = parcelRequire("cwF9s");

var $18U1I = parcelRequire("18U1I");
class $f4d64889ed8ec45c$export$2e2bcd8739ae039 extends (0, $18U1I.default) {
    get value() {
        return this._value;
    }
    _onUpdate() {
        const { time: time, settings: { fromValue: fromValue, toValue: toValue, duration: duration, easing: easing } } = this;
        const t = easing(time / duration);
        this._value = (0, $cwF9s.lerp)(fromValue, toValue, t);
    }
}

});

parcelRegister("io8OD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6314e7bad35b793$export$2e2bcd8739ae039; });

var $18U1I = parcelRequire("18U1I");
const $d6314e7bad35b793$var$EPSILON = 1e-5;
function $d6314e7bad35b793$var$updateSpringElement(prev, cur, dest, damping, stiffness) {
    const velocity = cur - prev;
    const delta = dest - cur;
    const spring = delta * stiffness;
    const damper = -velocity * damping;
    return spring + damper + velocity + cur;
}
function $d6314e7bad35b793$var$updateSpring(prev, cur, dest, damping, stiffness) {
    if (Array.isArray(dest)) {
        const next = [];
        for(let i = 0; i < dest.length; i++)next[i] = $d6314e7bad35b793$var$updateSpringElement(prev[i], cur[i], dest[i], damping, stiffness);
        return next;
    }
    return $d6314e7bad35b793$var$updateSpringElement(prev, cur, dest, damping, stiffness);
}
function $d6314e7bad35b793$var$distance(value1, value2) {
    if (Array.isArray(value1)) {
        let distanceSquare = 0;
        for(let i = 0; i < value1.length; i++){
            const d = value1[i] - value2[i];
            distanceSquare += d * d;
        }
        return Math.sqrt(distanceSquare);
    }
    return Math.abs(value1 - value2);
}
class $d6314e7bad35b793$export$2e2bcd8739ae039 extends (0, $18U1I.default) {
    get value() {
        return this._currValue;
    }
    _onUpdate() {
        const { fromValue: fromValue, toValue: toValue, damping: damping, stiffness: stiffness } = this.settings;
        const { _prevValue: _prevValue = fromValue, _currValue: _currValue = fromValue } = this;
        let nextValue = $d6314e7bad35b793$var$updateSpring(_prevValue, _currValue, toValue, damping, stiffness);
        const delta = $d6314e7bad35b793$var$distance(nextValue, toValue);
        const velocity = $d6314e7bad35b793$var$distance(nextValue, _currValue);
        if (delta < $d6314e7bad35b793$var$EPSILON && velocity < $d6314e7bad35b793$var$EPSILON) {
            nextValue = toValue;
            this.end();
        }
        this._prevValue = _currValue;
        this._currValue = nextValue;
    }
}

});


parcelRegister("ciluY", function(module, exports) {

$parcel$export(module.exports, "validateProps", function () { return $8f37d7a4ee8ab893$export$45855e0dd982478b; });
$parcel$export(module.exports, "diffProps", function () { return $8f37d7a4ee8ab893$export$8b12422c455acfb9; });

var $lXg0j = parcelRequire("lXg0j");
function $8f37d7a4ee8ab893$export$45855e0dd982478b(props) {
    const propTypes = props[0, $lXg0j.PROP_TYPES_SYMBOL];
    for(const propName in propTypes){
        const propType = propTypes[propName];
        const { validate: validate } = propType;
        if (validate && !validate(props[propName], propType)) throw new Error("Invalid prop ".concat(propName, ": ").concat(props[propName]));
    }
}
function $8f37d7a4ee8ab893$export$8b12422c455acfb9(props, oldProps) {
    const propsChangedReason = $8f37d7a4ee8ab893$export$1557ccb739c4ea87({
        newProps: props,
        oldProps: oldProps,
        propTypes: props[0, $lXg0j.PROP_TYPES_SYMBOL],
        ignoreProps: {
            data: null,
            updateTriggers: null,
            extensions: null,
            transitions: null
        }
    });
    const dataChangedReason = $8f37d7a4ee8ab893$var$diffDataProps(props, oldProps);
    let updateTriggersChangedReason = false;
    if (!dataChangedReason) updateTriggersChangedReason = $8f37d7a4ee8ab893$var$diffUpdateTriggers(props, oldProps);
    return {
        dataChanged: dataChangedReason,
        propsChanged: propsChangedReason,
        updateTriggersChanged: updateTriggersChangedReason,
        extensionsChanged: $8f37d7a4ee8ab893$var$diffExtensions(props, oldProps),
        transitionsChanged: $8f37d7a4ee8ab893$var$diffTransitions(props, oldProps)
    };
}
function $8f37d7a4ee8ab893$var$diffTransitions(props, oldProps) {
    if (!props.transitions) return false;
    const result = {};
    const propTypes = props[0, $lXg0j.PROP_TYPES_SYMBOL];
    let changed = false;
    for(const key in props.transitions){
        const propType = propTypes[key];
        const type = propType && propType.type;
        const isTransitionable = type === "number" || type === "color" || type === "array";
        if (isTransitionable && $8f37d7a4ee8ab893$var$comparePropValues(props[key], oldProps[key], propType)) {
            result[key] = true;
            changed = true;
        }
    }
    return changed ? result : false;
}
function $8f37d7a4ee8ab893$export$1557ccb739c4ea87({ newProps: newProps, oldProps: oldProps, ignoreProps: ignoreProps = {}, propTypes: propTypes = {}, triggerName: triggerName = "props" }) {
    if (oldProps === newProps) return false;
    if (typeof newProps !== "object" || newProps === null) return "".concat(triggerName, " changed shallowly");
    if (typeof oldProps !== "object" || oldProps === null) return "".concat(triggerName, " changed shallowly");
    for (const key of Object.keys(newProps))if (!(key in ignoreProps)) {
        if (!(key in oldProps)) return "".concat(triggerName, ".").concat(key, " added");
        const changed = $8f37d7a4ee8ab893$var$comparePropValues(newProps[key], oldProps[key], propTypes[key]);
        if (changed) return "".concat(triggerName, ".").concat(key, " ").concat(changed);
    }
    for (const key of Object.keys(oldProps))if (!(key in ignoreProps)) {
        if (!(key in newProps)) return "".concat(triggerName, ".").concat(key, " dropped");
        if (!Object.hasOwnProperty.call(newProps, key)) {
            const changed = $8f37d7a4ee8ab893$var$comparePropValues(newProps[key], oldProps[key], propTypes[key]);
            if (changed) return "".concat(triggerName, ".").concat(key, " ").concat(changed);
        }
    }
    return false;
}
function $8f37d7a4ee8ab893$var$comparePropValues(newProp, oldProp, propType) {
    let equal = propType && propType.equal;
    if (equal && !equal(newProp, oldProp, propType)) return "changed deeply";
    if (!equal) {
        equal = newProp && oldProp && newProp.equals;
        if (equal && !equal.call(newProp, oldProp)) return "changed deeply";
    }
    if (!equal && oldProp !== newProp) return "changed shallowly";
    return null;
}
function $8f37d7a4ee8ab893$var$diffDataProps(props, oldProps) {
    if (oldProps === null) return "oldProps is null, initial diff";
    let dataChanged = false;
    const { dataComparator: dataComparator, _dataDiff: _dataDiff } = props;
    if (dataComparator) {
        if (!dataComparator(props.data, oldProps.data)) dataChanged = "Data comparator detected a change";
    } else if (props.data !== oldProps.data) dataChanged = "A new data container was supplied";
    if (dataChanged && _dataDiff) dataChanged = _dataDiff(props.data, oldProps.data) || dataChanged;
    return dataChanged;
}
function $8f37d7a4ee8ab893$var$diffUpdateTriggers(props, oldProps) {
    if (oldProps === null) return {
        all: true
    };
    if ("all" in props.updateTriggers) {
        const diffReason = $8f37d7a4ee8ab893$var$diffUpdateTrigger(props, oldProps, "all");
        if (diffReason) return {
            all: true
        };
    }
    const reason = {};
    let changed = false;
    for(const triggerName in props.updateTriggers)if (triggerName !== "all") {
        const diffReason = $8f37d7a4ee8ab893$var$diffUpdateTrigger(props, oldProps, triggerName);
        if (diffReason) {
            reason[triggerName] = true;
            changed = true;
        }
    }
    return changed ? reason : false;
}
function $8f37d7a4ee8ab893$var$diffExtensions(props, oldProps) {
    if (oldProps === null) return true;
    const oldExtensions = oldProps.extensions;
    const { extensions: extensions } = props;
    if (extensions === oldExtensions) return false;
    if (!oldExtensions || !extensions) return true;
    if (extensions.length !== oldExtensions.length) return true;
    for(let i = 0; i < extensions.length; i++){
        if (!extensions[i].equals(oldExtensions[i])) return true;
    }
    return false;
}
function $8f37d7a4ee8ab893$var$diffUpdateTrigger(props, oldProps, triggerName) {
    let newTriggers = props.updateTriggers[triggerName];
    newTriggers = newTriggers === undefined || newTriggers === null ? {} : newTriggers;
    let oldTriggers = oldProps.updateTriggers[triggerName];
    oldTriggers = oldTriggers === undefined || oldTriggers === null ? {} : oldTriggers;
    const diffReason = $8f37d7a4ee8ab893$export$1557ccb739c4ea87({
        oldProps: oldTriggers,
        newProps: newTriggers,
        triggerName: triggerName
    });
    return diffReason;
}

});
parcelRegister("lXg0j", function(module, exports) {

$parcel$export(module.exports, "LIFECYCLE", function () { return $ffbb85be0a8fc19a$export$2cb9787dd463cbf4; });
$parcel$export(module.exports, "COMPONENT_SYMBOL", function () { return $ffbb85be0a8fc19a$export$47f4402f338dd1fc; });
$parcel$export(module.exports, "PROP_TYPES_SYMBOL", function () { return $ffbb85be0a8fc19a$export$b89566a3c9b82a14; });
$parcel$export(module.exports, "DEPRECATED_PROPS_SYMBOL", function () { return $ffbb85be0a8fc19a$export$4fbadbb2b382bcdd; });
$parcel$export(module.exports, "ASYNC_DEFAULTS_SYMBOL", function () { return $ffbb85be0a8fc19a$export$23f7c42255df7b05; });
$parcel$export(module.exports, "ASYNC_ORIGINAL_SYMBOL", function () { return $ffbb85be0a8fc19a$export$c313d789070da88c; });
$parcel$export(module.exports, "ASYNC_RESOLVED_SYMBOL", function () { return $ffbb85be0a8fc19a$export$40aefa3472633071; });
const $ffbb85be0a8fc19a$export$2cb9787dd463cbf4 = {
    NO_STATE: "Awaiting state",
    MATCHED: "Matched. State transferred from previous layer",
    INITIALIZED: "Initialized",
    AWAITING_GC: "Discarded. Awaiting garbage collection",
    AWAITING_FINALIZATION: "No longer matched. Awaiting garbage collection",
    FINALIZED: "Finalized! Awaiting garbage collection"
};
const $ffbb85be0a8fc19a$export$47f4402f338dd1fc = Symbol.for("component");
const $ffbb85be0a8fc19a$export$b89566a3c9b82a14 = Symbol.for("propTypes");
const $ffbb85be0a8fc19a$export$4fbadbb2b382bcdd = Symbol.for("deprecatedProps");
const $ffbb85be0a8fc19a$export$23f7c42255df7b05 = Symbol.for("asyncPropDefaults");
const $ffbb85be0a8fc19a$export$c313d789070da88c = Symbol.for("asyncPropOriginal");
const $ffbb85be0a8fc19a$export$40aefa3472633071 = Symbol.for("asyncPropResolved");

});


parcelRegister("6CX3d", function(module, exports) {

$parcel$export(module.exports, "count", function () { return $4d3418fbc0bb964a$export$85b9a36db797e02b; });
const $4d3418fbc0bb964a$var$ERR_NOT_OBJECT = "count(): argument not an object";
const $4d3418fbc0bb964a$var$ERR_NOT_CONTAINER = "count(): argument not a container";
function $4d3418fbc0bb964a$export$85b9a36db797e02b(container) {
    if (!$4d3418fbc0bb964a$var$isObject(container)) throw new Error($4d3418fbc0bb964a$var$ERR_NOT_OBJECT);
    if (typeof container.count === "function") return container.count();
    if (Number.isFinite(container.size)) return container.size;
    if (Number.isFinite(container.length)) return container.length;
    if ($4d3418fbc0bb964a$var$isPlainObject(container)) return Object.keys(container).length;
    throw new Error($4d3418fbc0bb964a$var$ERR_NOT_CONTAINER);
}
function $4d3418fbc0bb964a$var$isPlainObject(value) {
    return value !== null && typeof value === "object" && value.constructor === Object;
}
function $4d3418fbc0bb964a$var$isObject(value) {
    return value !== null && typeof value === "object";
}

});

parcelRegister("4hN1x", function(module, exports) {

$parcel$export(module.exports, "mergeShaders", function () { return $31eec714451bbed7$export$95c481ecbbcfbbf1; });

var $2QP2i = parcelRequire("2QP2i");
function $31eec714451bbed7$export$95c481ecbbcfbbf1(target, source) {
    if (!source) return target;
    const result = (0, $2QP2i._)({}, target, source);
    if ("defines" in source) result.defines = (0, $2QP2i._)({}, target.defines, source.defines);
    if ("modules" in source) {
        result.modules = (target.modules || []).concat(source.modules);
        if (source.modules.some((module)=>module.name === "project64")) {
            const index = result.modules.findIndex((module)=>module.name === "project32");
            if (index >= 0) result.modules.splice(index, 1);
        }
    }
    if ("inject" in source) {
        if (!target.inject) result.inject = source.inject;
        else {
            const mergedInjection = (0, $2QP2i._)({}, target.inject);
            for(const key in source.inject)mergedInjection[key] = (mergedInjection[key] || "") + source.inject[key];
            result.inject = mergedInjection;
        }
    }
    return result;
}

});

parcelRegister("4cXyN", function(module, exports) {

$parcel$export(module.exports, "getWorldPosition", function () { return $31067bd486a47c9b$export$13d987dcd33aecbe; });
$parcel$export(module.exports, "projectPosition", function () { return $31067bd486a47c9b$export$a3c26af9c425194b; });

var $7gQQK = parcelRequire("7gQQK");

var $3Zb7J = parcelRequire("3Zb7J");

var $gwLQV = parcelRequire("gwLQV");

var $egbXO = parcelRequire("egbXO");

var $7xR33 = parcelRequire("7xR33");
parcelRequire("3vYZD");
var $k5FuL = parcelRequire("k5FuL");
const $31067bd486a47c9b$var$DEFAULT_COORDINATE_ORIGIN = [
    0,
    0,
    0
];
function $31067bd486a47c9b$var$lngLatZToWorldPosition(lngLatZ, viewport, offsetMode = false) {
    const p = viewport.projectPosition(lngLatZ);
    if (offsetMode && viewport instanceof (0, $gwLQV.default)) {
        const [longitude, latitude, z = 0] = lngLatZ;
        const distanceScales = viewport.getDistanceScales([
            longitude,
            latitude
        ]);
        p[2] = z * distanceScales.unitsPerMeter[2];
    }
    return p;
}
function $31067bd486a47c9b$var$normalizeParameters(opts) {
    const { viewport: viewport, modelMatrix: modelMatrix, coordinateOrigin: coordinateOrigin } = opts;
    let { coordinateSystem: coordinateSystem, fromCoordinateSystem: fromCoordinateSystem, fromCoordinateOrigin: fromCoordinateOrigin } = opts;
    if (coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).DEFAULT) coordinateSystem = viewport.isGeospatial ? (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT : (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN;
    if (fromCoordinateSystem === undefined) fromCoordinateSystem = coordinateSystem;
    if (fromCoordinateOrigin === undefined) fromCoordinateOrigin = coordinateOrigin;
    return {
        viewport: viewport,
        coordinateSystem: coordinateSystem,
        coordinateOrigin: coordinateOrigin,
        modelMatrix: modelMatrix,
        fromCoordinateSystem: fromCoordinateSystem,
        fromCoordinateOrigin: fromCoordinateOrigin
    };
}
function $31067bd486a47c9b$export$13d987dcd33aecbe(position, { viewport: viewport, modelMatrix: modelMatrix, coordinateSystem: coordinateSystem, coordinateOrigin: coordinateOrigin, offsetMode: offsetMode }) {
    let [x, y, z = 0] = position;
    if (modelMatrix) [x, y, z] = $egbXO.transformMat4([], [
        x,
        y,
        z,
        1.0
    ], modelMatrix);
    switch(coordinateSystem){
        case (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT:
            return $31067bd486a47c9b$var$lngLatZToWorldPosition([
                x,
                y,
                z
            ], viewport, offsetMode);
        case (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT_OFFSETS:
            return $31067bd486a47c9b$var$lngLatZToWorldPosition([
                x + coordinateOrigin[0],
                y + coordinateOrigin[1],
                z + (coordinateOrigin[2] || 0)
            ], viewport, offsetMode);
        case (0, $7gQQK.COORDINATE_SYSTEM).METER_OFFSETS:
            return $31067bd486a47c9b$var$lngLatZToWorldPosition((0, $k5FuL.addMetersToLngLat)(coordinateOrigin, [
                x,
                y,
                z
            ]), viewport, offsetMode);
        case (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN:
        default:
            return viewport.isGeospatial ? [
                x + coordinateOrigin[0],
                y + coordinateOrigin[1],
                z + coordinateOrigin[2]
            ] : viewport.projectPosition([
                x,
                y,
                z
            ]);
    }
}
function $31067bd486a47c9b$export$a3c26af9c425194b(position, params) {
    const { viewport: viewport, coordinateSystem: coordinateSystem, coordinateOrigin: coordinateOrigin, modelMatrix: modelMatrix, fromCoordinateSystem: fromCoordinateSystem, fromCoordinateOrigin: fromCoordinateOrigin } = $31067bd486a47c9b$var$normalizeParameters(params);
    const { autoOffset: autoOffset = true } = params;
    const { geospatialOrigin: geospatialOrigin = $31067bd486a47c9b$var$DEFAULT_COORDINATE_ORIGIN, shaderCoordinateOrigin: shaderCoordinateOrigin = $31067bd486a47c9b$var$DEFAULT_COORDINATE_ORIGIN, offsetMode: offsetMode = false } = autoOffset ? (0, $3Zb7J.getOffsetOrigin)(viewport, coordinateSystem, coordinateOrigin) : {};
    const worldPosition = $31067bd486a47c9b$export$13d987dcd33aecbe(position, {
        viewport: viewport,
        modelMatrix: modelMatrix,
        coordinateSystem: fromCoordinateSystem,
        coordinateOrigin: fromCoordinateOrigin,
        offsetMode: offsetMode
    });
    if (offsetMode) {
        const positionCommonSpace = viewport.projectPosition(geospatialOrigin || shaderCoordinateOrigin);
        $7xR33.sub(worldPosition, worldPosition, positionCommonSpace);
    }
    return worldPosition;
}

});
parcelRegister("3Zb7J", function(module, exports) {

$parcel$export(module.exports, "getOffsetOrigin", function () { return $2e6fb28603ed26c7$export$20f9eb1a42fcd22d; });
$parcel$export(module.exports, "getUniformsFromViewport", function () { return $2e6fb28603ed26c7$export$31173c1846951f93; });

var $kI1xR = parcelRequire("kI1xR");

var $egbXO = parcelRequire("egbXO");

var $7gQQK = parcelRequire("7gQQK");

var $b9Qhn = parcelRequire("b9Qhn");
const $2e6fb28603ed26c7$var$ZERO_VECTOR = [
    0,
    0,
    0,
    0
];
const $2e6fb28603ed26c7$var$VECTOR_TO_POINT_MATRIX = [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0
];
const $2e6fb28603ed26c7$var$IDENTITY_MATRIX = [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
];
const $2e6fb28603ed26c7$var$DEFAULT_PIXELS_PER_UNIT2 = [
    0,
    0,
    0
];
const $2e6fb28603ed26c7$var$DEFAULT_COORDINATE_ORIGIN = [
    0,
    0,
    0
];
const $2e6fb28603ed26c7$var$getMemoizedViewportUniforms = (0, $b9Qhn.default)($2e6fb28603ed26c7$var$calculateViewportUniforms);
function $2e6fb28603ed26c7$export$20f9eb1a42fcd22d(viewport, coordinateSystem, coordinateOrigin = $2e6fb28603ed26c7$var$DEFAULT_COORDINATE_ORIGIN) {
    if (coordinateOrigin.length < 3) coordinateOrigin = [
        coordinateOrigin[0],
        coordinateOrigin[1],
        0
    ];
    let shaderCoordinateOrigin = coordinateOrigin;
    let geospatialOrigin;
    let offsetMode = true;
    if (coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT_OFFSETS || coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).METER_OFFSETS) geospatialOrigin = coordinateOrigin;
    else geospatialOrigin = viewport.isGeospatial ? [
        Math.fround(viewport.longitude),
        Math.fround(viewport.latitude),
        0
    ] : null;
    switch(viewport.projectionMode){
        case (0, $7gQQK.PROJECTION_MODE).WEB_MERCATOR:
            if (coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT || coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN) {
                geospatialOrigin = [
                    0,
                    0,
                    0
                ];
                offsetMode = false;
            }
            break;
        case (0, $7gQQK.PROJECTION_MODE).WEB_MERCATOR_AUTO_OFFSET:
            if (coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT) shaderCoordinateOrigin = geospatialOrigin;
            else if (coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN) {
                shaderCoordinateOrigin = [
                    Math.fround(viewport.center[0]),
                    Math.fround(viewport.center[1]),
                    0
                ];
                geospatialOrigin = viewport.unprojectPosition(shaderCoordinateOrigin);
                shaderCoordinateOrigin[0] -= coordinateOrigin[0];
                shaderCoordinateOrigin[1] -= coordinateOrigin[1];
                shaderCoordinateOrigin[2] -= coordinateOrigin[2];
            }
            break;
        case (0, $7gQQK.PROJECTION_MODE).IDENTITY:
            shaderCoordinateOrigin = viewport.position.map(Math.fround);
            shaderCoordinateOrigin[2] = shaderCoordinateOrigin[2] || 0;
            break;
        case (0, $7gQQK.PROJECTION_MODE).GLOBE:
            offsetMode = false;
            geospatialOrigin = null;
            break;
        default:
            offsetMode = false;
    }
    return {
        geospatialOrigin: geospatialOrigin,
        shaderCoordinateOrigin: shaderCoordinateOrigin,
        offsetMode: offsetMode
    };
}
function $2e6fb28603ed26c7$var$calculateMatrixAndOffset(viewport, coordinateSystem, coordinateOrigin) {
    const { viewMatrixUncentered: viewMatrixUncentered, projectionMatrix: projectionMatrix } = viewport;
    let { viewMatrix: viewMatrix, viewProjectionMatrix: viewProjectionMatrix } = viewport;
    let projectionCenter = $2e6fb28603ed26c7$var$ZERO_VECTOR;
    let originCommon = $2e6fb28603ed26c7$var$ZERO_VECTOR;
    let cameraPosCommon = viewport.cameraPosition;
    const { geospatialOrigin: geospatialOrigin, shaderCoordinateOrigin: shaderCoordinateOrigin, offsetMode: offsetMode } = $2e6fb28603ed26c7$export$20f9eb1a42fcd22d(viewport, coordinateSystem, coordinateOrigin);
    if (offsetMode) {
        originCommon = viewport.projectPosition(geospatialOrigin || shaderCoordinateOrigin);
        cameraPosCommon = [
            cameraPosCommon[0] - originCommon[0],
            cameraPosCommon[1] - originCommon[1],
            cameraPosCommon[2] - originCommon[2]
        ];
        originCommon[3] = 1;
        projectionCenter = $egbXO.transformMat4([], originCommon, viewProjectionMatrix);
        viewMatrix = viewMatrixUncentered || viewMatrix;
        viewProjectionMatrix = $kI1xR.multiply([], projectionMatrix, viewMatrix);
        viewProjectionMatrix = $kI1xR.multiply([], viewProjectionMatrix, $2e6fb28603ed26c7$var$VECTOR_TO_POINT_MATRIX);
    }
    return {
        viewMatrix: viewMatrix,
        viewProjectionMatrix: viewProjectionMatrix,
        projectionCenter: projectionCenter,
        originCommon: originCommon,
        cameraPosCommon: cameraPosCommon,
        shaderCoordinateOrigin: shaderCoordinateOrigin,
        geospatialOrigin: geospatialOrigin
    };
}
function $2e6fb28603ed26c7$export$31173c1846951f93({ viewport: viewport, devicePixelRatio: devicePixelRatio = 1, modelMatrix: modelMatrix = null, coordinateSystem: coordinateSystem = (0, $7gQQK.COORDINATE_SYSTEM).DEFAULT, coordinateOrigin: coordinateOrigin = $2e6fb28603ed26c7$var$DEFAULT_COORDINATE_ORIGIN, autoWrapLongitude: autoWrapLongitude = false }) {
    if (coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).DEFAULT) coordinateSystem = viewport.isGeospatial ? (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT : (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN;
    const uniforms = $2e6fb28603ed26c7$var$getMemoizedViewportUniforms({
        viewport: viewport,
        devicePixelRatio: devicePixelRatio,
        coordinateSystem: coordinateSystem,
        coordinateOrigin: coordinateOrigin
    });
    uniforms.project_uWrapLongitude = autoWrapLongitude;
    uniforms.project_uModelMatrix = modelMatrix || $2e6fb28603ed26c7$var$IDENTITY_MATRIX;
    return uniforms;
}
function $2e6fb28603ed26c7$var$calculateViewportUniforms({ viewport: viewport, devicePixelRatio: devicePixelRatio, coordinateSystem: coordinateSystem, coordinateOrigin: coordinateOrigin }) {
    const { projectionCenter: projectionCenter, viewProjectionMatrix: viewProjectionMatrix, originCommon: originCommon, cameraPosCommon: cameraPosCommon, shaderCoordinateOrigin: shaderCoordinateOrigin, geospatialOrigin: geospatialOrigin } = $2e6fb28603ed26c7$var$calculateMatrixAndOffset(viewport, coordinateSystem, coordinateOrigin);
    const distanceScales = viewport.getDistanceScales();
    const viewportSize = [
        viewport.width * devicePixelRatio,
        viewport.height * devicePixelRatio
    ];
    const focalDistance = $egbXO.transformMat4([], [
        0,
        0,
        -viewport.focalDistance,
        1
    ], viewport.projectionMatrix)[3] || 1;
    const uniforms = {
        project_uCoordinateSystem: coordinateSystem,
        project_uProjectionMode: viewport.projectionMode,
        project_uCoordinateOrigin: shaderCoordinateOrigin,
        project_uCommonOrigin: originCommon.slice(0, 3),
        project_uCenter: projectionCenter,
        project_uPseudoMeters: Boolean(viewport._pseudoMeters),
        project_uViewportSize: viewportSize,
        project_uDevicePixelRatio: devicePixelRatio,
        project_uFocalDistance: focalDistance,
        project_uCommonUnitsPerMeter: distanceScales.unitsPerMeter,
        project_uCommonUnitsPerWorldUnit: distanceScales.unitsPerMeter,
        project_uCommonUnitsPerWorldUnit2: $2e6fb28603ed26c7$var$DEFAULT_PIXELS_PER_UNIT2,
        project_uScale: viewport.scale,
        project_uWrapLongitude: false,
        project_uViewProjectionMatrix: viewProjectionMatrix,
        project_uModelMatrix: $2e6fb28603ed26c7$var$IDENTITY_MATRIX,
        project_uCameraPosition: cameraPosCommon
    };
    if (geospatialOrigin) {
        const distanceScalesAtOrigin = viewport.getDistanceScales(geospatialOrigin);
        switch(coordinateSystem){
            case (0, $7gQQK.COORDINATE_SYSTEM).METER_OFFSETS:
                uniforms.project_uCommonUnitsPerWorldUnit = distanceScalesAtOrigin.unitsPerMeter;
                uniforms.project_uCommonUnitsPerWorldUnit2 = distanceScalesAtOrigin.unitsPerMeter2;
                break;
            case (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT:
            case (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT_OFFSETS:
                if (!viewport._pseudoMeters) uniforms.project_uCommonUnitsPerMeter = distanceScalesAtOrigin.unitsPerMeter;
                uniforms.project_uCommonUnitsPerWorldUnit = distanceScalesAtOrigin.unitsPerDegree;
                uniforms.project_uCommonUnitsPerWorldUnit2 = distanceScalesAtOrigin.unitsPerDegree2;
                break;
            case (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN:
                uniforms.project_uCommonUnitsPerWorldUnit = [
                    1,
                    1,
                    distanceScalesAtOrigin.unitsPerMeter[2]
                ];
                uniforms.project_uCommonUnitsPerWorldUnit2 = [
                    0,
                    0,
                    distanceScalesAtOrigin.unitsPerMeter2[2]
                ];
                break;
            default:
                break;
        }
    }
    return uniforms;
}

});
parcelRegister("kI1xR", function(module, exports) {

$parcel$export(module.exports, "invert", function () { return $f1391d84ba904660$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "multiply", function () { return $f1391d84ba904660$export$2060d2db72cce88f; });
$parcel$export(module.exports, "translate", function () { return $f1391d84ba904660$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "scale", function () { return $f1391d84ba904660$export$dcdf75081b88279d; });

var $bheRV = parcelRequire("bheRV");
function $f1391d84ba904660$export$185802fd694ee1f5() {
    var out = new $bheRV.ARRAY_TYPE(16);
    if ($bheRV.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$9cd59f9826255e47(a) {
    var out = new $bheRV.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $f1391d84ba904660$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $f1391d84ba904660$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $bheRV.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $f1391d84ba904660$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $f1391d84ba904660$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $f1391d84ba904660$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $f1391d84ba904660$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $f1391d84ba904660$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $f1391d84ba904660$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $f1391d84ba904660$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $f1391d84ba904660$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $f1391d84ba904660$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $bheRV.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $f1391d84ba904660$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $f1391d84ba904660$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $f1391d84ba904660$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $f1391d84ba904660$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $bheRV.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$ff497f2be31cc6a(out, a) {
    var translation = new $bheRV.ARRAY_TYPE(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $f1391d84ba904660$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $f1391d84ba904660$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $f1391d84ba904660$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $f1391d84ba904660$export$df3937d3b537df0a(out, mat) {
    var scaling = new $bheRV.ARRAY_TYPE(3);
    $f1391d84ba904660$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $f1391d84ba904660$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $f1391d84ba904660$export$541149539f3a4684(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
function $f1391d84ba904660$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $f1391d84ba904660$export$4f2167e613cfc87b(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $bheRV.EPSILON && Math.abs(eyey - centery) < $bheRV.EPSILON && Math.abs(eyez - centerz) < $bheRV.EPSILON) return $f1391d84ba904660$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $f1391d84ba904660$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $f1391d84ba904660$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $f1391d84ba904660$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $f1391d84ba904660$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $f1391d84ba904660$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $f1391d84ba904660$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $f1391d84ba904660$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $f1391d84ba904660$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $f1391d84ba904660$export$6e3a27864ab166fe = $f1391d84ba904660$export$2060d2db72cce88f;
var $f1391d84ba904660$export$f93b5905241a7cca = $f1391d84ba904660$export$4e2d2ead65e5f7e3;

});
parcelRegister("bheRV", function(module, exports) {

$parcel$export(module.exports, "EPSILON", function () { return $835cd0d95e33536f$export$fd293b15f47e270; });
$parcel$export(module.exports, "ARRAY_TYPE", function () { return $835cd0d95e33536f$export$b67359430d3b1b2; });
$parcel$export(module.exports, "RANDOM", function () { return $835cd0d95e33536f$export$5ada478c8a628231; });
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $835cd0d95e33536f$export$fd293b15f47e270 = 0.000001;
var $835cd0d95e33536f$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $835cd0d95e33536f$export$5ada478c8a628231 = Math.random;
function $835cd0d95e33536f$export$cb2c0eb57f5e532c(type) {
    $835cd0d95e33536f$export$b67359430d3b1b2 = type;
}
var $835cd0d95e33536f$var$degree = Math.PI / 180;
function $835cd0d95e33536f$export$408b8ee5959eefd5(a) {
    return a * $835cd0d95e33536f$var$degree;
}
function $835cd0d95e33536f$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $835cd0d95e33536f$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};

});


parcelRegister("egbXO", function(module, exports) {

$parcel$export(module.exports, "scale", function () { return $a61bd70e81a64e27$export$dcdf75081b88279d; });
$parcel$export(module.exports, "transformMat4", function () { return $a61bd70e81a64e27$export$5ffbd13800309d59; });

var $bheRV = parcelRequire("bheRV");
function $a61bd70e81a64e27$export$185802fd694ee1f5() {
    var out = new $bheRV.ARRAY_TYPE(4);
    if ($bheRV.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $a61bd70e81a64e27$export$9cd59f9826255e47(a) {
    var out = new $bheRV.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $a61bd70e81a64e27$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $bheRV.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $a61bd70e81a64e27$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $a61bd70e81a64e27$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $a61bd70e81a64e27$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $a61bd70e81a64e27$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $a61bd70e81a64e27$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $a61bd70e81a64e27$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $a61bd70e81a64e27$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $a61bd70e81a64e27$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $a61bd70e81a64e27$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $a61bd70e81a64e27$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $a61bd70e81a64e27$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $a61bd70e81a64e27$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $a61bd70e81a64e27$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $a61bd70e81a64e27$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $a61bd70e81a64e27$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $a61bd70e81a64e27$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $a61bd70e81a64e27$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $a61bd70e81a64e27$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $a61bd70e81a64e27$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $a61bd70e81a64e27$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $a61bd70e81a64e27$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $a61bd70e81a64e27$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $a61bd70e81a64e27$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $a61bd70e81a64e27$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $bheRV.RANDOM() * 2 - 1;
        v2 = $bheRV.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $bheRV.RANDOM() * 2 - 1;
        v4 = $bheRV.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $a61bd70e81a64e27$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $a61bd70e81a64e27$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $a61bd70e81a64e27$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $a61bd70e81a64e27$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $a61bd70e81a64e27$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $a61bd70e81a64e27$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $a61bd70e81a64e27$export$f93b5905241a7cca = $a61bd70e81a64e27$export$4e2d2ead65e5f7e3;
var $a61bd70e81a64e27$export$6e3a27864ab166fe = $a61bd70e81a64e27$export$2060d2db72cce88f;
var $a61bd70e81a64e27$export$159d9494db57879b = $a61bd70e81a64e27$export$cd007d971a5a2143;
var $a61bd70e81a64e27$export$6c4a311cc157c764 = $a61bd70e81a64e27$export$9f17032d917177de;
var $a61bd70e81a64e27$export$2422cd6c492a8b3a = $a61bd70e81a64e27$export$88e6ebb4fe54f538;
var $a61bd70e81a64e27$export$fc1400facf92c78 = $a61bd70e81a64e27$export$f24224f1c91d8156;
var $a61bd70e81a64e27$export$99d8dd3f32a3435 = $a61bd70e81a64e27$export$ab44e1323ffc8376;
var $a61bd70e81a64e27$export$4b80e395e36b5a56 = function() {
    var vec = $a61bd70e81a64e27$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});


parcelRegister("gwLQV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c084c1038dfd753a$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $1zR3q = parcelRequire("1zR3q");

var $5CtJW = parcelRequire("5CtJW");
parcelRequire("3vYZD");
var $k5FuL = parcelRequire("k5FuL");
var $gy8FM = parcelRequire("gy8FM");
var $fPplZ = parcelRequire("fPplZ");

var $7sAKl = parcelRequire("7sAKl");

var $cwF9s = parcelRequire("cwF9s");
var $1mr6W = parcelRequire("1mr6W");
class $c084c1038dfd753a$export$2e2bcd8739ae039 extends (0, $5CtJW.default) {
    get subViewports() {
        if (this._subViewports && !this._subViewports.length) {
            const bounds = this.getBounds();
            const minOffset = Math.floor((bounds[0] + 180) / 360);
            const maxOffset = Math.ceil((bounds[2] - 180) / 360);
            for(let x = minOffset; x <= maxOffset; x++){
                const offsetViewport = x ? new $c084c1038dfd753a$export$2e2bcd8739ae039((0, $edHbI._)((0, $2QP2i._)({}, this), {
                    worldOffset: x
                })) : this;
                this._subViewports.push(offsetViewport);
            }
        }
        return this._subViewports;
    }
    projectPosition(xyz) {
        if (this._pseudoMeters) return super.projectPosition(xyz);
        const [X, Y] = this.projectFlat(xyz);
        const Z = (xyz[2] || 0) * (0, $k5FuL.unitsPerMeter)(xyz[1]);
        return [
            X,
            Y,
            Z
        ];
    }
    unprojectPosition(xyz) {
        if (this._pseudoMeters) return super.unprojectPosition(xyz);
        const [X, Y] = this.unprojectFlat(xyz);
        const Z = (xyz[2] || 0) / (0, $k5FuL.unitsPerMeter)(Y);
        return [
            X,
            Y,
            Z
        ];
    }
    addMetersToLngLat(lngLatZ, xyz) {
        return (0, $k5FuL.addMetersToLngLat)(lngLatZ, xyz);
    }
    panByPosition(coords, pixel) {
        const fromLocation = (0, $k5FuL.pixelsToWorld)(pixel, this.pixelUnprojectionMatrix);
        const toLocation = this.projectFlat(coords);
        const translate = $7sAKl.add([], toLocation, $7sAKl.negate([], fromLocation));
        const newCenter = $7sAKl.add([], this.center, translate);
        const [longitude, latitude] = this.unprojectFlat(newCenter);
        return {
            longitude: longitude,
            latitude: latitude
        };
    }
    getBounds(options = {}) {
        const corners = (0, $fPplZ.default)(this, options.z || 0);
        return [
            Math.min(corners[0][0], corners[1][0], corners[2][0], corners[3][0]),
            Math.min(corners[0][1], corners[1][1], corners[2][1], corners[3][1]),
            Math.max(corners[0][0], corners[1][0], corners[2][0], corners[3][0]),
            Math.max(corners[0][1], corners[1][1], corners[2][1], corners[3][1])
        ];
    }
    fitBounds(bounds, options = {}) {
        const { width: width, height: height } = this;
        const { longitude: longitude, latitude: latitude, zoom: zoom } = (0, $gy8FM.default)((0, $2QP2i._)({
            width: width,
            height: height,
            bounds: bounds
        }, options));
        return new $c084c1038dfd753a$export$2e2bcd8739ae039({
            width: width,
            height: height,
            longitude: longitude,
            latitude: latitude,
            zoom: zoom
        });
    }
    constructor(opts = {}){
        const { latitude: latitude = 0, longitude: longitude = 0, zoom: zoom = 0, pitch: pitch = 0, bearing: bearing = 0, nearZMultiplier: nearZMultiplier = 0.1, farZMultiplier: farZMultiplier = 1.01, nearZ: nearZ, farZ: farZ, orthographic: orthographic = false, projectionMatrix: projectionMatrix, repeat: repeat = false, worldOffset: worldOffset = 0, position: position, padding: padding, legacyMeterSizes: legacyMeterSizes = false } = opts;
        let { width: width, height: height, altitude: altitude = 1.5 } = opts;
        const scale = Math.pow(2, zoom);
        width = width || 1;
        height = height || 1;
        let fovy;
        let projectionParameters = null;
        if (projectionMatrix) {
            altitude = projectionMatrix[5] / 2;
            fovy = (0, $k5FuL.altitudeToFovy)(altitude);
        } else {
            if (opts.fovy) {
                fovy = opts.fovy;
                altitude = (0, $k5FuL.fovyToAltitude)(fovy);
            } else fovy = (0, $k5FuL.altitudeToFovy)(altitude);
            let offset;
            if (padding) {
                const { top: top = 0, bottom: bottom = 0 } = padding;
                offset = [
                    0,
                    (0, $cwF9s.clamp)((top + height - bottom) / 2, 0, height) - height / 2
                ];
            }
            projectionParameters = (0, $k5FuL.getProjectionParameters)({
                width: width,
                height: height,
                scale: scale,
                center: position && [
                    0,
                    0,
                    position[2] * (0, $k5FuL.unitsPerMeter)(latitude)
                ],
                offset: offset,
                pitch: pitch,
                fovy: fovy,
                nearZMultiplier: nearZMultiplier,
                farZMultiplier: farZMultiplier
            });
            if (Number.isFinite(nearZ)) projectionParameters.near = nearZ;
            if (Number.isFinite(farZ)) projectionParameters.far = farZ;
        }
        let viewMatrixUncentered = (0, $k5FuL.getViewMatrix)({
            height: height,
            pitch: pitch,
            bearing: bearing,
            scale: scale,
            altitude: altitude
        });
        if (worldOffset) {
            const viewOffset = new (0, $1mr6W.default)().translate([
                512 * worldOffset,
                0,
                0
            ]);
            viewMatrixUncentered = viewOffset.multiplyLeft(viewMatrixUncentered);
        }
        super((0, $edHbI._)((0, $2QP2i._)((0, $edHbI._)((0, $2QP2i._)({}, opts), {
            width: width,
            height: height,
            viewMatrix: viewMatrixUncentered,
            longitude: longitude,
            latitude: latitude,
            zoom: zoom
        }), projectionParameters), {
            fovy: fovy,
            focalDistance: altitude
        }));
        (0, $1zR3q.default)(this, "longitude", void 0);
        (0, $1zR3q.default)(this, "latitude", void 0);
        (0, $1zR3q.default)(this, "pitch", void 0);
        (0, $1zR3q.default)(this, "bearing", void 0);
        (0, $1zR3q.default)(this, "altitude", void 0);
        (0, $1zR3q.default)(this, "fovy", void 0);
        (0, $1zR3q.default)(this, "orthographic", void 0);
        (0, $1zR3q.default)(this, "_subViewports", void 0);
        (0, $1zR3q.default)(this, "_pseudoMeters", void 0);
        this.latitude = latitude;
        this.longitude = longitude;
        this.zoom = zoom;
        this.pitch = pitch;
        this.bearing = bearing;
        this.altitude = altitude;
        this.fovy = fovy;
        this.orthographic = orthographic;
        this._subViewports = repeat ? [] : null;
        this._pseudoMeters = legacyMeterSizes;
        Object.freeze(this);
    }
}
(0, $1zR3q.default)($c084c1038dfd753a$export$2e2bcd8739ae039, "displayName", "WebMercatorViewport");

});
parcelRegister("5CtJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4177921fc3f81e4b$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");

var $4VQgq = parcelRequire("4VQgq");

var $9kyEf = parcelRequire("9kyEf");

var $cwF9s = parcelRequire("cwF9s");
var $1mr6W = parcelRequire("1mr6W");
var $cKS36 = parcelRequire("cKS36");

var $kI1xR = parcelRequire("kI1xR");
parcelRequire("3vYZD");
var $k5FuL = parcelRequire("k5FuL");

var $7gQQK = parcelRequire("7gQQK");
const $4177921fc3f81e4b$var$DEGREES_TO_RADIANS = Math.PI / 180;
const $4177921fc3f81e4b$var$IDENTITY = (0, $9kyEf.createMat4)();
const $4177921fc3f81e4b$var$ZERO_VECTOR = [
    0,
    0,
    0
];
const $4177921fc3f81e4b$var$DEFAULT_DISTANCE_SCALES = {
    unitsPerMeter: [
        1,
        1,
        1
    ],
    metersPerUnit: [
        1,
        1,
        1
    ]
};
function $4177921fc3f81e4b$var$createProjectionMatrix({ width: width, height: height, orthographic: orthographic, fovyRadians: fovyRadians, focalDistance: focalDistance, padding: padding, near: near, far: far }) {
    const aspect = width / height;
    const matrix = orthographic ? new (0, $1mr6W.default)().orthographic({
        fovy: fovyRadians,
        aspect: aspect,
        focalDistance: focalDistance,
        near: near,
        far: far
    }) : new (0, $1mr6W.default)().perspective({
        fovy: fovyRadians,
        aspect: aspect,
        near: near,
        far: far
    });
    if (padding) {
        const { left: left = 0, right: right = 0, top: top = 0, bottom: bottom = 0 } = padding;
        const offsetX = (0, $cwF9s.clamp)((left + width - right) / 2, 0, width) - width / 2;
        const offsetY = (0, $cwF9s.clamp)((top + height - bottom) / 2, 0, height) - height / 2;
        matrix[8] -= offsetX * 2 / width;
        matrix[9] += offsetY * 2 / height;
    }
    return matrix;
}
class $4177921fc3f81e4b$export$2e2bcd8739ae039 {
    get subViewports() {
        return null;
    }
    get metersPerPixel() {
        return this.distanceScales.metersPerUnit[2] / this.scale;
    }
    get projectionMode() {
        if (this.isGeospatial) return this.zoom < 12 ? (0, $7gQQK.PROJECTION_MODE).WEB_MERCATOR : (0, $7gQQK.PROJECTION_MODE).WEB_MERCATOR_AUTO_OFFSET;
        return (0, $7gQQK.PROJECTION_MODE).IDENTITY;
    }
    equals(viewport) {
        if (!(viewport instanceof $4177921fc3f81e4b$export$2e2bcd8739ae039)) return false;
        if (this === viewport) return true;
        return viewport.width === this.width && viewport.height === this.height && viewport.scale === this.scale && (0, $cwF9s.equals)(viewport.projectionMatrix, this.projectionMatrix) && (0, $cwF9s.equals)(viewport.viewMatrix, this.viewMatrix);
    }
    project(xyz, { topLeft: topLeft = true } = {}) {
        const worldPosition = this.projectPosition(xyz);
        const coord = (0, $k5FuL.worldToPixels)(worldPosition, this.pixelProjectionMatrix);
        const [x, y] = coord;
        const y2 = topLeft ? y : this.height - y;
        return xyz.length === 2 ? [
            x,
            y2
        ] : [
            x,
            y2,
            coord[2]
        ];
    }
    unproject(xyz, { topLeft: topLeft = true, targetZ: targetZ } = {}) {
        const [x, y, z] = xyz;
        const y2 = topLeft ? y : this.height - y;
        const targetZWorld = targetZ && targetZ * this.distanceScales.unitsPerMeter[2];
        const coord = (0, $k5FuL.pixelsToWorld)([
            x,
            y2,
            z
        ], this.pixelUnprojectionMatrix, targetZWorld);
        const [X, Y, Z] = this.unprojectPosition(coord);
        if (Number.isFinite(z)) return [
            X,
            Y,
            Z
        ];
        return Number.isFinite(targetZ) ? [
            X,
            Y,
            targetZ
        ] : [
            X,
            Y
        ];
    }
    projectPosition(xyz) {
        const [X, Y] = this.projectFlat(xyz);
        const Z = (xyz[2] || 0) * this.distanceScales.unitsPerMeter[2];
        return [
            X,
            Y,
            Z
        ];
    }
    unprojectPosition(xyz) {
        const [X, Y] = this.unprojectFlat(xyz);
        const Z = (xyz[2] || 0) * this.distanceScales.metersPerUnit[2];
        return [
            X,
            Y,
            Z
        ];
    }
    projectFlat(xyz) {
        if (this.isGeospatial) {
            const result = (0, $k5FuL.lngLatToWorld)(xyz);
            result[1] = (0, $cwF9s.clamp)(result[1], -318, 830);
            return result;
        }
        return xyz;
    }
    unprojectFlat(xyz) {
        if (this.isGeospatial) return (0, $k5FuL.worldToLngLat)(xyz);
        return xyz;
    }
    getBounds(options = {}) {
        const unprojectOption = {
            targetZ: options.z || 0
        };
        const topLeft = this.unproject([
            0,
            0
        ], unprojectOption);
        const topRight = this.unproject([
            this.width,
            0
        ], unprojectOption);
        const bottomLeft = this.unproject([
            0,
            this.height
        ], unprojectOption);
        const bottomRight = this.unproject([
            this.width,
            this.height
        ], unprojectOption);
        return [
            Math.min(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
            Math.min(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1]),
            Math.max(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
            Math.max(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1])
        ];
    }
    getDistanceScales(coordinateOrigin) {
        if (coordinateOrigin) return (0, $k5FuL.getDistanceScales)({
            longitude: coordinateOrigin[0],
            latitude: coordinateOrigin[1],
            highPrecision: true
        });
        return this.distanceScales;
    }
    containsPixel({ x: x, y: y, width: width = 1, height: height = 1 }) {
        return x < this.x + this.width && this.x < x + width && y < this.y + this.height && this.y < y + height;
    }
    getFrustumPlanes() {
        if (this._frustumPlanes.near) return this._frustumPlanes;
        Object.assign(this._frustumPlanes, (0, $9kyEf.getFrustumPlanes)(this.viewProjectionMatrix));
        return this._frustumPlanes;
    }
    panByPosition(coords, pixel) {
        return null;
    }
    _initProps(opts) {
        const longitude = opts.longitude;
        const latitude = opts.latitude;
        if (this.isGeospatial) {
            if (!Number.isFinite(opts.zoom)) this.zoom = (0, $k5FuL.getMeterZoom)({
                latitude: latitude
            }) + Math.log2(this.focalDistance);
            this.distanceScales = opts.distanceScales || (0, $k5FuL.getDistanceScales)({
                latitude: latitude,
                longitude: longitude
            });
        }
        const scale = Math.pow(2, this.zoom);
        this.scale = scale;
        const { position: position, modelMatrix: modelMatrix } = opts;
        let meterOffset = $4177921fc3f81e4b$var$ZERO_VECTOR;
        if (position) meterOffset = modelMatrix ? new (0, $1mr6W.default)(modelMatrix).transformAsVector(position, []) : position;
        if (this.isGeospatial) {
            const center = this.projectPosition([
                longitude,
                latitude,
                0
            ]);
            this.center = new (0, $cKS36.default)(meterOffset).scale(this.distanceScales.unitsPerMeter).add(center);
        } else this.center = this.projectPosition(meterOffset);
    }
    _initMatrices(opts) {
        const { viewMatrix: viewMatrix = $4177921fc3f81e4b$var$IDENTITY, projectionMatrix: projectionMatrix = null, orthographic: orthographic = false, fovyRadians: fovyRadians, fovy: fovy = 75, near: near = 0.1, far: far = 1000, padding: padding = null, focalDistance: focalDistance = 1 } = opts;
        this.viewMatrixUncentered = viewMatrix;
        this.viewMatrix = new (0, $1mr6W.default)().multiplyRight(viewMatrix).translate(new (0, $cKS36.default)(this.center).negate());
        this.projectionMatrix = projectionMatrix || $4177921fc3f81e4b$var$createProjectionMatrix({
            width: this.width,
            height: this.height,
            orthographic: orthographic,
            fovyRadians: fovyRadians || fovy * $4177921fc3f81e4b$var$DEGREES_TO_RADIANS,
            focalDistance: focalDistance,
            padding: padding,
            near: near,
            far: far
        });
        const vpm = (0, $9kyEf.createMat4)();
        $kI1xR.multiply(vpm, vpm, this.projectionMatrix);
        $kI1xR.multiply(vpm, vpm, this.viewMatrix);
        this.viewProjectionMatrix = vpm;
        this.viewMatrixInverse = $kI1xR.invert([], this.viewMatrix) || this.viewMatrix;
        this.cameraPosition = (0, $9kyEf.getCameraPosition)(this.viewMatrixInverse);
        const viewportMatrix = (0, $9kyEf.createMat4)();
        const pixelProjectionMatrix = (0, $9kyEf.createMat4)();
        $kI1xR.scale(viewportMatrix, viewportMatrix, [
            this.width / 2,
            -this.height / 2,
            1
        ]);
        $kI1xR.translate(viewportMatrix, viewportMatrix, [
            1,
            -1,
            0
        ]);
        $kI1xR.multiply(pixelProjectionMatrix, viewportMatrix, this.viewProjectionMatrix);
        this.pixelProjectionMatrix = pixelProjectionMatrix;
        this.pixelUnprojectionMatrix = $kI1xR.invert((0, $9kyEf.createMat4)(), this.pixelProjectionMatrix);
        if (!this.pixelUnprojectionMatrix) (0, $4VQgq.default).warn("Pixel project matrix not invertible")();
    }
    constructor(opts = {}){
        (0, $1zR3q.default)(this, "id", void 0);
        (0, $1zR3q.default)(this, "x", void 0);
        (0, $1zR3q.default)(this, "y", void 0);
        (0, $1zR3q.default)(this, "width", void 0);
        (0, $1zR3q.default)(this, "height", void 0);
        (0, $1zR3q.default)(this, "padding", void 0);
        (0, $1zR3q.default)(this, "isGeospatial", void 0);
        (0, $1zR3q.default)(this, "zoom", void 0);
        (0, $1zR3q.default)(this, "focalDistance", void 0);
        (0, $1zR3q.default)(this, "position", void 0);
        (0, $1zR3q.default)(this, "modelMatrix", void 0);
        (0, $1zR3q.default)(this, "distanceScales", void 0);
        (0, $1zR3q.default)(this, "scale", void 0);
        (0, $1zR3q.default)(this, "center", void 0);
        (0, $1zR3q.default)(this, "cameraPosition", void 0);
        (0, $1zR3q.default)(this, "projectionMatrix", void 0);
        (0, $1zR3q.default)(this, "viewMatrix", void 0);
        (0, $1zR3q.default)(this, "viewMatrixUncentered", void 0);
        (0, $1zR3q.default)(this, "viewMatrixInverse", void 0);
        (0, $1zR3q.default)(this, "viewProjectionMatrix", void 0);
        (0, $1zR3q.default)(this, "pixelProjectionMatrix", void 0);
        (0, $1zR3q.default)(this, "pixelUnprojectionMatrix", void 0);
        (0, $1zR3q.default)(this, "resolution", void 0);
        (0, $1zR3q.default)(this, "_frustumPlanes", {});
        this.id = opts.id || this.constructor.displayName || "viewport";
        this.x = opts.x || 0;
        this.y = opts.y || 0;
        this.width = opts.width || 1;
        this.height = opts.height || 1;
        this.zoom = opts.zoom || 0;
        this.padding = opts.padding;
        this.distanceScales = opts.distanceScales || $4177921fc3f81e4b$var$DEFAULT_DISTANCE_SCALES;
        this.focalDistance = opts.focalDistance || 1;
        this.position = opts.position || $4177921fc3f81e4b$var$ZERO_VECTOR;
        this.modelMatrix = opts.modelMatrix || null;
        const { longitude: longitude, latitude: latitude } = opts;
        this.isGeospatial = Number.isFinite(latitude) && Number.isFinite(longitude);
        this._initProps(opts);
        this._initMatrices(opts);
        this.equals = this.equals.bind(this);
        this.project = this.project.bind(this);
        this.unproject = this.unproject.bind(this);
        this.projectPosition = this.projectPosition.bind(this);
        this.unprojectPosition = this.unprojectPosition.bind(this);
        this.projectFlat = this.projectFlat.bind(this);
        this.unprojectFlat = this.unprojectFlat.bind(this);
    }
}
(0, $1zR3q.default)($4177921fc3f81e4b$export$2e2bcd8739ae039, "displayName", "Viewport");

});
parcelRegister("1mr6W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fdce02c2e767569$export$2e2bcd8739ae039; });

var $4JloE = parcelRequire("4JloE");

var $j8wyT = parcelRequire("j8wyT");

var $idCXM = parcelRequire("idCXM");

var $2PsMO = parcelRequire("2PsMO");

var $autGx = parcelRequire("autGx");

var $bjUmI = parcelRequire("bjUmI");

var $jCcHA = parcelRequire("jCcHA");
var $0fdce02c2e767569$var$INDICES;
(function(INDICES) {
    INDICES[INDICES["COL0ROW0"] = 0] = "COL0ROW0";
    INDICES[INDICES["COL0ROW1"] = 1] = "COL0ROW1";
    INDICES[INDICES["COL0ROW2"] = 2] = "COL0ROW2";
    INDICES[INDICES["COL0ROW3"] = 3] = "COL0ROW3";
    INDICES[INDICES["COL1ROW0"] = 4] = "COL1ROW0";
    INDICES[INDICES["COL1ROW1"] = 5] = "COL1ROW1";
    INDICES[INDICES["COL1ROW2"] = 6] = "COL1ROW2";
    INDICES[INDICES["COL1ROW3"] = 7] = "COL1ROW3";
    INDICES[INDICES["COL2ROW0"] = 8] = "COL2ROW0";
    INDICES[INDICES["COL2ROW1"] = 9] = "COL2ROW1";
    INDICES[INDICES["COL2ROW2"] = 10] = "COL2ROW2";
    INDICES[INDICES["COL2ROW3"] = 11] = "COL2ROW3";
    INDICES[INDICES["COL3ROW0"] = 12] = "COL3ROW0";
    INDICES[INDICES["COL3ROW1"] = 13] = "COL3ROW1";
    INDICES[INDICES["COL3ROW2"] = 14] = "COL3ROW2";
    INDICES[INDICES["COL3ROW3"] = 15] = "COL3ROW3";
})($0fdce02c2e767569$var$INDICES || ($0fdce02c2e767569$var$INDICES = {}));
const $0fdce02c2e767569$var$DEFAULT_FOVY = 45 * Math.PI / 180;
const $0fdce02c2e767569$var$DEFAULT_ASPECT = 1;
const $0fdce02c2e767569$var$DEFAULT_NEAR = 0.1;
const $0fdce02c2e767569$var$DEFAULT_FAR = 500;
const $0fdce02c2e767569$var$IDENTITY_MATRIX = Object.freeze([
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
]);
class $0fdce02c2e767569$export$2e2bcd8739ae039 extends (0, $4JloE.default) {
    static get IDENTITY() {
        return $0fdce02c2e767569$var$getIdentityMatrix();
    }
    static get ZERO() {
        return $0fdce02c2e767569$var$getZeroMatrix();
    }
    get ELEMENTS() {
        return 16;
    }
    get RANK() {
        return 4;
    }
    get INDICES() {
        return $0fdce02c2e767569$var$INDICES;
    }
    copy(array) {
        this[0] = array[0];
        this[1] = array[1];
        this[2] = array[2];
        this[3] = array[3];
        this[4] = array[4];
        this[5] = array[5];
        this[6] = array[6];
        this[7] = array[7];
        this[8] = array[8];
        this[9] = array[9];
        this[10] = array[10];
        this[11] = array[11];
        this[12] = array[12];
        this[13] = array[13];
        this[14] = array[14];
        this[15] = array[15];
        return this.check();
    }
    set(m00, m10, m20, m30, m01, m11, m21, m31, m02, m12, m22, m32, m03, m13, m23, m33) {
        this[0] = m00;
        this[1] = m10;
        this[2] = m20;
        this[3] = m30;
        this[4] = m01;
        this[5] = m11;
        this[6] = m21;
        this[7] = m31;
        this[8] = m02;
        this[9] = m12;
        this[10] = m22;
        this[11] = m32;
        this[12] = m03;
        this[13] = m13;
        this[14] = m23;
        this[15] = m33;
        return this.check();
    }
    setRowMajor(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
        this[0] = m00;
        this[1] = m10;
        this[2] = m20;
        this[3] = m30;
        this[4] = m01;
        this[5] = m11;
        this[6] = m21;
        this[7] = m31;
        this[8] = m02;
        this[9] = m12;
        this[10] = m22;
        this[11] = m32;
        this[12] = m03;
        this[13] = m13;
        this[14] = m23;
        this[15] = m33;
        return this.check();
    }
    toRowMajor(result) {
        result[0] = this[0];
        result[1] = this[4];
        result[2] = this[8];
        result[3] = this[12];
        result[4] = this[1];
        result[5] = this[5];
        result[6] = this[9];
        result[7] = this[13];
        result[8] = this[2];
        result[9] = this[6];
        result[10] = this[10];
        result[11] = this[14];
        result[12] = this[3];
        result[13] = this[7];
        result[14] = this[11];
        result[15] = this[15];
        return result;
    }
    identity() {
        return this.copy($0fdce02c2e767569$var$IDENTITY_MATRIX);
    }
    fromObject(object) {
        return this.check();
    }
    fromQuaternion(quaternion) {
        $2PsMO.fromQuat(this, quaternion);
        return this.check();
    }
    frustum(view) {
        const { left: left, right: right, bottom: bottom, top: top, near: near = $0fdce02c2e767569$var$DEFAULT_NEAR, far: far = $0fdce02c2e767569$var$DEFAULT_FAR } = view;
        if (far === Infinity) $0fdce02c2e767569$var$computeInfinitePerspectiveOffCenter(this, left, right, bottom, top, near);
        else $2PsMO.frustum(this, left, right, bottom, top, near, far);
        return this.check();
    }
    lookAt(view) {
        const { eye: eye, center: center = [
            0,
            0,
            0
        ], up: up = [
            0,
            1,
            0
        ] } = view;
        $2PsMO.lookAt(this, eye, center, up);
        return this.check();
    }
    ortho(view) {
        const { left: left, right: right, bottom: bottom, top: top, near: near = $0fdce02c2e767569$var$DEFAULT_NEAR, far: far = $0fdce02c2e767569$var$DEFAULT_FAR } = view;
        $2PsMO.ortho(this, left, right, bottom, top, near, far);
        return this.check();
    }
    orthographic(view) {
        const { fovy: fovy = $0fdce02c2e767569$var$DEFAULT_FOVY, aspect: aspect = $0fdce02c2e767569$var$DEFAULT_ASPECT, focalDistance: focalDistance = 1, near: near = $0fdce02c2e767569$var$DEFAULT_NEAR, far: far = $0fdce02c2e767569$var$DEFAULT_FAR } = view;
        $0fdce02c2e767569$var$checkRadians(fovy);
        const halfY = fovy / 2;
        const top = focalDistance * Math.tan(halfY);
        const right = top * aspect;
        return this.ortho({
            left: -right,
            right: right,
            bottom: -top,
            top: top,
            near: near,
            far: far
        });
    }
    perspective(view) {
        const { fovy: fovy = 45 * Math.PI / 180, aspect: aspect = 1, near: near = 0.1, far: far = 500 } = view;
        $0fdce02c2e767569$var$checkRadians(fovy);
        $2PsMO.perspective(this, fovy, aspect, near, far);
        return this.check();
    }
    determinant() {
        return $2PsMO.determinant(this);
    }
    getScale(result = [
        -0,
        -0,
        -0
    ]) {
        result[0] = Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]);
        result[1] = Math.sqrt(this[4] * this[4] + this[5] * this[5] + this[6] * this[6]);
        result[2] = Math.sqrt(this[8] * this[8] + this[9] * this[9] + this[10] * this[10]);
        return result;
    }
    getTranslation(result = [
        -0,
        -0,
        -0
    ]) {
        result[0] = this[12];
        result[1] = this[13];
        result[2] = this[14];
        return result;
    }
    getRotation(result, scaleResult) {
        result = result || [
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0
        ];
        scaleResult = scaleResult || [
            -0,
            -0,
            -0
        ];
        const scale = this.getScale(scaleResult);
        const inverseScale0 = 1 / scale[0];
        const inverseScale1 = 1 / scale[1];
        const inverseScale2 = 1 / scale[2];
        result[0] = this[0] * inverseScale0;
        result[1] = this[1] * inverseScale1;
        result[2] = this[2] * inverseScale2;
        result[3] = 0;
        result[4] = this[4] * inverseScale0;
        result[5] = this[5] * inverseScale1;
        result[6] = this[6] * inverseScale2;
        result[7] = 0;
        result[8] = this[8] * inverseScale0;
        result[9] = this[9] * inverseScale1;
        result[10] = this[10] * inverseScale2;
        result[11] = 0;
        result[12] = 0;
        result[13] = 0;
        result[14] = 0;
        result[15] = 1;
        return result;
    }
    getRotationMatrix3(result, scaleResult) {
        result = result || [
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0
        ];
        scaleResult = scaleResult || [
            -0,
            -0,
            -0
        ];
        const scale = this.getScale(scaleResult);
        const inverseScale0 = 1 / scale[0];
        const inverseScale1 = 1 / scale[1];
        const inverseScale2 = 1 / scale[2];
        result[0] = this[0] * inverseScale0;
        result[1] = this[1] * inverseScale1;
        result[2] = this[2] * inverseScale2;
        result[3] = this[4] * inverseScale0;
        result[4] = this[5] * inverseScale1;
        result[5] = this[6] * inverseScale2;
        result[6] = this[8] * inverseScale0;
        result[7] = this[9] * inverseScale1;
        result[8] = this[10] * inverseScale2;
        return result;
    }
    transpose() {
        $2PsMO.transpose(this, this);
        return this.check();
    }
    invert() {
        $2PsMO.invert(this, this);
        return this.check();
    }
    multiplyLeft(a) {
        $2PsMO.multiply(this, a, this);
        return this.check();
    }
    multiplyRight(a) {
        $2PsMO.multiply(this, this, a);
        return this.check();
    }
    rotateX(radians) {
        $2PsMO.rotateX(this, this, radians);
        return this.check();
    }
    rotateY(radians) {
        $2PsMO.rotateY(this, this, radians);
        return this.check();
    }
    rotateZ(radians) {
        $2PsMO.rotateZ(this, this, radians);
        return this.check();
    }
    rotateXYZ(angleXYZ) {
        return this.rotateX(angleXYZ[0]).rotateY(angleXYZ[1]).rotateZ(angleXYZ[2]);
    }
    rotateAxis(radians, axis) {
        $2PsMO.rotate(this, this, radians, axis);
        return this.check();
    }
    scale(factor) {
        $2PsMO.scale(this, this, Array.isArray(factor) ? factor : [
            factor,
            factor,
            factor
        ]);
        return this.check();
    }
    translate(vector) {
        $2PsMO.translate(this, this, vector);
        return this.check();
    }
    transform(vector, result) {
        if (vector.length === 4) {
            result = $jCcHA.transformMat4(result || [
                -0,
                -0,
                -0,
                -0
            ], vector, this);
            (0, $j8wyT.checkVector)(result, 4);
            return result;
        }
        return this.transformAsPoint(vector, result);
    }
    transformAsPoint(vector, result) {
        const { length: length } = vector;
        let out;
        switch(length){
            case 2:
                out = $autGx.transformMat4(result || [
                    -0,
                    -0
                ], vector, this);
                break;
            case 3:
                out = $bjUmI.transformMat4(result || [
                    -0,
                    -0,
                    -0
                ], vector, this);
                break;
            default:
                throw new Error("Illegal vector");
        }
        (0, $j8wyT.checkVector)(out, vector.length);
        return out;
    }
    transformAsVector(vector, result) {
        let out;
        switch(vector.length){
            case 2:
                out = (0, $idCXM.vec2_transformMat4AsVector)(result || [
                    -0,
                    -0
                ], vector, this);
                break;
            case 3:
                out = (0, $idCXM.vec3_transformMat4AsVector)(result || [
                    -0,
                    -0,
                    -0
                ], vector, this);
                break;
            default:
                throw new Error("Illegal vector");
        }
        (0, $j8wyT.checkVector)(out, vector.length);
        return out;
    }
    transformPoint(vector, result) {
        return this.transformAsPoint(vector, result);
    }
    transformVector(vector, result) {
        return this.transformAsPoint(vector, result);
    }
    transformDirection(vector, result) {
        return this.transformAsVector(vector, result);
    }
    makeRotationX(radians) {
        return this.identity().rotateX(radians);
    }
    makeTranslation(x, y, z) {
        return this.identity().translate([
            x,
            y,
            z
        ]);
    }
    constructor(array){
        super(-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0);
        if (arguments.length === 1 && Array.isArray(array)) this.copy(array);
        else this.identity();
    }
}
let $0fdce02c2e767569$var$ZERO;
let $0fdce02c2e767569$var$IDENTITY;
function $0fdce02c2e767569$var$getZeroMatrix() {
    if (!$0fdce02c2e767569$var$ZERO) {
        $0fdce02c2e767569$var$ZERO = new $0fdce02c2e767569$export$2e2bcd8739ae039([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        Object.freeze($0fdce02c2e767569$var$ZERO);
    }
    return $0fdce02c2e767569$var$ZERO;
}
function $0fdce02c2e767569$var$getIdentityMatrix() {
    if (!$0fdce02c2e767569$var$IDENTITY) {
        $0fdce02c2e767569$var$IDENTITY = new $0fdce02c2e767569$export$2e2bcd8739ae039();
        Object.freeze($0fdce02c2e767569$var$IDENTITY);
    }
    return $0fdce02c2e767569$var$IDENTITY;
}
function $0fdce02c2e767569$var$checkRadians(possiblyDegrees) {
    if (possiblyDegrees > Math.PI * 2) throw Error("expected radians");
}
function $0fdce02c2e767569$var$computeInfinitePerspectiveOffCenter(result, left, right, bottom, top, near) {
    const column0Row0 = 2 * near / (right - left);
    const column1Row1 = 2 * near / (top - bottom);
    const column2Row0 = (right + left) / (right - left);
    const column2Row1 = (top + bottom) / (top - bottom);
    const column2Row2 = -1;
    const column2Row3 = -1;
    const column3Row2 = -2 * near;
    result[0] = column0Row0;
    result[1] = 0;
    result[2] = 0;
    result[3] = 0;
    result[4] = 0;
    result[5] = column1Row1;
    result[6] = 0;
    result[7] = 0;
    result[8] = column2Row0;
    result[9] = column2Row1;
    result[10] = column2Row2;
    result[11] = column2Row3;
    result[12] = 0;
    result[13] = 0;
    result[14] = column3Row2;
    result[15] = 0;
    return result;
}

});
parcelRegister("4JloE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371bf652a3c77ed3$export$2e2bcd8739ae039; });

var $cCPCr = parcelRequire("cCPCr");

var $j8wyT = parcelRequire("j8wyT");

var $cwF9s = parcelRequire("cwF9s");
class $371bf652a3c77ed3$export$2e2bcd8739ae039 extends (0, $cCPCr.default) {
    toString() {
        let string = "[";
        if ((0, $cwF9s.config).printRowMajor) {
            string += "row-major:";
            for(let row = 0; row < this.RANK; ++row)for(let col = 0; col < this.RANK; ++col)string += " ".concat(this[col * this.RANK + row]);
        } else {
            string += "column-major:";
            for(let i = 0; i < this.ELEMENTS; ++i)string += " ".concat(this[i]);
        }
        string += "]";
        return string;
    }
    getElementIndex(row, col) {
        return col * this.RANK + row;
    }
    getElement(row, col) {
        return this[col * this.RANK + row];
    }
    setElement(row, col, value) {
        this[col * this.RANK + row] = (0, $j8wyT.checkNumber)(value);
        return this;
    }
    getColumn(columnIndex, result = new Array(this.RANK).fill(-0)) {
        const firstIndex = columnIndex * this.RANK;
        for(let i = 0; i < this.RANK; ++i)result[i] = this[firstIndex + i];
        return result;
    }
    setColumn(columnIndex, columnVector) {
        const firstIndex = columnIndex * this.RANK;
        for(let i = 0; i < this.RANK; ++i)this[firstIndex + i] = columnVector[i];
        return this;
    }
}

});

parcelRegister("2PsMO", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $20f6ac91acf0dd4a$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "invert", function () { return $20f6ac91acf0dd4a$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "determinant", function () { return $20f6ac91acf0dd4a$export$a04698f914c55ed9; });
$parcel$export(module.exports, "multiply", function () { return $20f6ac91acf0dd4a$export$2060d2db72cce88f; });
$parcel$export(module.exports, "translate", function () { return $20f6ac91acf0dd4a$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "scale", function () { return $20f6ac91acf0dd4a$export$dcdf75081b88279d; });
$parcel$export(module.exports, "rotate", function () { return $20f6ac91acf0dd4a$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "rotateX", function () { return $20f6ac91acf0dd4a$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateY", function () { return $20f6ac91acf0dd4a$export$cf71e4d4ca4d1cfd; });
$parcel$export(module.exports, "rotateZ", function () { return $20f6ac91acf0dd4a$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "getScaling", function () { return $20f6ac91acf0dd4a$export$71dc54d92bd04b57; });
$parcel$export(module.exports, "fromQuat", function () { return $20f6ac91acf0dd4a$export$2ff2bbe382249af7; });
$parcel$export(module.exports, "frustum", function () { return $20f6ac91acf0dd4a$export$89b5708c387cac6c; });
$parcel$export(module.exports, "perspective", function () { return $20f6ac91acf0dd4a$export$541149539f3a4684; });
$parcel$export(module.exports, "ortho", function () { return $20f6ac91acf0dd4a$export$4f2167e613cfc87b; });
$parcel$export(module.exports, "lookAt", function () { return $20f6ac91acf0dd4a$export$d924e14fd6d9aa66; });
$parcel$export(module.exports, "equals", function () { return $20f6ac91acf0dd4a$export$e9bab7fafb253603; });

var $jbrKE = parcelRequire("jbrKE");
function $20f6ac91acf0dd4a$export$185802fd694ee1f5() {
    var out = new $jbrKE.ARRAY_TYPE(16);
    if ($jbrKE.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$9cd59f9826255e47(a) {
    var out = new $jbrKE.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $20f6ac91acf0dd4a$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $20f6ac91acf0dd4a$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $jbrKE.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $20f6ac91acf0dd4a$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $20f6ac91acf0dd4a$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $20f6ac91acf0dd4a$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $20f6ac91acf0dd4a$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $20f6ac91acf0dd4a$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $20f6ac91acf0dd4a$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $20f6ac91acf0dd4a$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $20f6ac91acf0dd4a$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $20f6ac91acf0dd4a$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $jbrKE.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $20f6ac91acf0dd4a$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $20f6ac91acf0dd4a$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $20f6ac91acf0dd4a$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $20f6ac91acf0dd4a$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $jbrKE.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$ff497f2be31cc6a(out, a) {
    var translation = new $jbrKE.ARRAY_TYPE(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $20f6ac91acf0dd4a$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $20f6ac91acf0dd4a$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $20f6ac91acf0dd4a$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $20f6ac91acf0dd4a$export$df3937d3b537df0a(out, mat) {
    var scaling = new $jbrKE.ARRAY_TYPE(3);
    $20f6ac91acf0dd4a$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $20f6ac91acf0dd4a$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $20f6ac91acf0dd4a$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $20f6ac91acf0dd4a$export$541149539f3a4684 = $20f6ac91acf0dd4a$export$4cf19729ec9a96b8;
function $20f6ac91acf0dd4a$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $20f6ac91acf0dd4a$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $20f6ac91acf0dd4a$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $20f6ac91acf0dd4a$export$4f2167e613cfc87b = $20f6ac91acf0dd4a$export$c5f65ef3eb668f27;
function $20f6ac91acf0dd4a$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $jbrKE.EPSILON && Math.abs(eyey - centery) < $jbrKE.EPSILON && Math.abs(eyez - centerz) < $jbrKE.EPSILON) return $20f6ac91acf0dd4a$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $20f6ac91acf0dd4a$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $20f6ac91acf0dd4a$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $20f6ac91acf0dd4a$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $20f6ac91acf0dd4a$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $20f6ac91acf0dd4a$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $20f6ac91acf0dd4a$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $20f6ac91acf0dd4a$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $20f6ac91acf0dd4a$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $20f6ac91acf0dd4a$export$6e3a27864ab166fe = $20f6ac91acf0dd4a$export$2060d2db72cce88f;
var $20f6ac91acf0dd4a$export$f93b5905241a7cca = $20f6ac91acf0dd4a$export$4e2d2ead65e5f7e3;

});

parcelRegister("autGx", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $7a33bb9256db33da$export$e16d8520af44a096; });
$parcel$export(module.exports, "scale", function () { return $7a33bb9256db33da$export$dcdf75081b88279d; });
$parcel$export(module.exports, "length", function () { return $7a33bb9256db33da$export$f24224f1c91d8156; });
$parcel$export(module.exports, "negate", function () { return $7a33bb9256db33da$export$aef51622e549b8b0; });
$parcel$export(module.exports, "lerp", function () { return $7a33bb9256db33da$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "transformMat2", function () { return $7a33bb9256db33da$export$b732428d73874bfc; });
$parcel$export(module.exports, "transformMat2d", function () { return $7a33bb9256db33da$export$3e55bc4b3707dfd3; });
$parcel$export(module.exports, "transformMat3", function () { return $7a33bb9256db33da$export$f0bfa0a0024626ee; });
$parcel$export(module.exports, "transformMat4", function () { return $7a33bb9256db33da$export$5ffbd13800309d59; });
$parcel$export(module.exports, "sub", function () { return $7a33bb9256db33da$export$f93b5905241a7cca; });

var $jbrKE = parcelRequire("jbrKE");
function $7a33bb9256db33da$export$185802fd694ee1f5() {
    var out = new $jbrKE.ARRAY_TYPE(2);
    if ($jbrKE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $7a33bb9256db33da$export$9cd59f9826255e47(a) {
    var out = new $jbrKE.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $7a33bb9256db33da$export$a82be99ed2a44a7d(x, y) {
    var out = new $jbrKE.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $7a33bb9256db33da$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $7a33bb9256db33da$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $7a33bb9256db33da$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $7a33bb9256db33da$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $7a33bb9256db33da$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $7a33bb9256db33da$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $7a33bb9256db33da$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $7a33bb9256db33da$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $7a33bb9256db33da$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $7a33bb9256db33da$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $7a33bb9256db33da$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $7a33bb9256db33da$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $7a33bb9256db33da$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $7a33bb9256db33da$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $7a33bb9256db33da$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $7a33bb9256db33da$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $7a33bb9256db33da$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $7a33bb9256db33da$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $7a33bb9256db33da$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $7a33bb9256db33da$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $7a33bb9256db33da$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $7a33bb9256db33da$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $7a33bb9256db33da$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $7a33bb9256db33da$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $jbrKE.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $7a33bb9256db33da$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $7a33bb9256db33da$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $7a33bb9256db33da$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $7a33bb9256db33da$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $7a33bb9256db33da$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $7a33bb9256db33da$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $7a33bb9256db33da$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $7a33bb9256db33da$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $7a33bb9256db33da$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $7a33bb9256db33da$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $7a33bb9256db33da$export$fc1400facf92c78 = $7a33bb9256db33da$export$f24224f1c91d8156;
var $7a33bb9256db33da$export$f93b5905241a7cca = $7a33bb9256db33da$export$4e2d2ead65e5f7e3;
var $7a33bb9256db33da$export$6e3a27864ab166fe = $7a33bb9256db33da$export$2060d2db72cce88f;
var $7a33bb9256db33da$export$159d9494db57879b = $7a33bb9256db33da$export$cd007d971a5a2143;
var $7a33bb9256db33da$export$6c4a311cc157c764 = $7a33bb9256db33da$export$9f17032d917177de;
var $7a33bb9256db33da$export$2422cd6c492a8b3a = $7a33bb9256db33da$export$88e6ebb4fe54f538;
var $7a33bb9256db33da$export$99d8dd3f32a3435 = $7a33bb9256db33da$export$ab44e1323ffc8376;
var $7a33bb9256db33da$export$4b80e395e36b5a56 = function() {
    var vec = $7a33bb9256db33da$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

});

parcelRegister("jCcHA", function(module, exports) {

$parcel$export(module.exports, "clone", function () { return $e47b6b4c2027db15$export$9cd59f9826255e47; });
$parcel$export(module.exports, "fromValues", function () { return $e47b6b4c2027db15$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "copy", function () { return $e47b6b4c2027db15$export$784d13d8ee351f07; });
$parcel$export(module.exports, "set", function () { return $e47b6b4c2027db15$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "add", function () { return $e47b6b4c2027db15$export$e16d8520af44a096; });
$parcel$export(module.exports, "scale", function () { return $e47b6b4c2027db15$export$dcdf75081b88279d; });
$parcel$export(module.exports, "length", function () { return $e47b6b4c2027db15$export$f24224f1c91d8156; });
$parcel$export(module.exports, "squaredLength", function () { return $e47b6b4c2027db15$export$ab44e1323ffc8376; });
$parcel$export(module.exports, "normalize", function () { return $e47b6b4c2027db15$export$a3295358bff77e; });
$parcel$export(module.exports, "dot", function () { return $e47b6b4c2027db15$export$94132a0e348806d4; });
$parcel$export(module.exports, "lerp", function () { return $e47b6b4c2027db15$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "transformMat4", function () { return $e47b6b4c2027db15$export$5ffbd13800309d59; });
$parcel$export(module.exports, "transformQuat", function () { return $e47b6b4c2027db15$export$c32adef9e939ce85; });
$parcel$export(module.exports, "exactEquals", function () { return $e47b6b4c2027db15$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $e47b6b4c2027db15$export$e9bab7fafb253603; });

var $jbrKE = parcelRequire("jbrKE");
function $e47b6b4c2027db15$export$185802fd694ee1f5() {
    var out = new $jbrKE.ARRAY_TYPE(4);
    if ($jbrKE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $e47b6b4c2027db15$export$9cd59f9826255e47(a) {
    var out = new $jbrKE.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e47b6b4c2027db15$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $jbrKE.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e47b6b4c2027db15$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e47b6b4c2027db15$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e47b6b4c2027db15$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $e47b6b4c2027db15$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $e47b6b4c2027db15$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $e47b6b4c2027db15$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $e47b6b4c2027db15$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $e47b6b4c2027db15$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $e47b6b4c2027db15$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $e47b6b4c2027db15$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $e47b6b4c2027db15$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $e47b6b4c2027db15$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $e47b6b4c2027db15$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $e47b6b4c2027db15$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $e47b6b4c2027db15$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $e47b6b4c2027db15$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $e47b6b4c2027db15$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $e47b6b4c2027db15$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $e47b6b4c2027db15$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $e47b6b4c2027db15$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $e47b6b4c2027db15$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $e47b6b4c2027db15$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $e47b6b4c2027db15$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $e47b6b4c2027db15$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $jbrKE.RANDOM() * 2 - 1;
        v2 = $jbrKE.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $jbrKE.RANDOM() * 2 - 1;
        v4 = $jbrKE.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $e47b6b4c2027db15$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $e47b6b4c2027db15$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $e47b6b4c2027db15$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $e47b6b4c2027db15$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $e47b6b4c2027db15$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $e47b6b4c2027db15$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $jbrKE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $e47b6b4c2027db15$export$f93b5905241a7cca = $e47b6b4c2027db15$export$4e2d2ead65e5f7e3;
var $e47b6b4c2027db15$export$6e3a27864ab166fe = $e47b6b4c2027db15$export$2060d2db72cce88f;
var $e47b6b4c2027db15$export$159d9494db57879b = $e47b6b4c2027db15$export$cd007d971a5a2143;
var $e47b6b4c2027db15$export$6c4a311cc157c764 = $e47b6b4c2027db15$export$9f17032d917177de;
var $e47b6b4c2027db15$export$2422cd6c492a8b3a = $e47b6b4c2027db15$export$88e6ebb4fe54f538;
var $e47b6b4c2027db15$export$fc1400facf92c78 = $e47b6b4c2027db15$export$f24224f1c91d8156;
var $e47b6b4c2027db15$export$99d8dd3f32a3435 = $e47b6b4c2027db15$export$ab44e1323ffc8376;
var $e47b6b4c2027db15$export$4b80e395e36b5a56 = function() {
    var vec = $e47b6b4c2027db15$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});


parcelRegister("3vYZD", function(module, exports) {

$parcel$export(module.exports, "getBounds", function () { return (parcelRequire("fPplZ")).default; });
$parcel$export(module.exports, "fitBounds", function () { return (parcelRequire("gy8FM")).default; });
$parcel$export(module.exports, "normalizeViewportProps", function () { return (parcelRequire("9cckP")).default; });
$parcel$export(module.exports, "flyToViewport", function () { return (parcelRequire("6Uylx")).default; });
$parcel$export(module.exports, "getFlyToDuration", function () { return (parcelRequire("6Uylx")).getFlyToDuration; });
$parcel$export(module.exports, "lngLatToWorld", function () { return (parcelRequire("k5FuL")).lngLatToWorld; });
$parcel$export(module.exports, "worldToLngLat", function () { return (parcelRequire("k5FuL")).worldToLngLat; });
$parcel$export(module.exports, "worldToPixels", function () { return (parcelRequire("k5FuL")).worldToPixels; });
$parcel$export(module.exports, "pixelsToWorld", function () { return (parcelRequire("k5FuL")).pixelsToWorld; });
$parcel$export(module.exports, "altitudeToFovy", function () { return (parcelRequire("k5FuL")).altitudeToFovy; });
$parcel$export(module.exports, "fovyToAltitude", function () { return (parcelRequire("k5FuL")).fovyToAltitude; });
$parcel$export(module.exports, "getMeterZoom", function () { return (parcelRequire("k5FuL")).getMeterZoom; });
$parcel$export(module.exports, "unitsPerMeter", function () { return (parcelRequire("k5FuL")).unitsPerMeter; });
$parcel$export(module.exports, "getDistanceScales", function () { return (parcelRequire("k5FuL")).getDistanceScales; });
$parcel$export(module.exports, "addMetersToLngLat", function () { return (parcelRequire("k5FuL")).addMetersToLngLat; });
$parcel$export(module.exports, "getViewMatrix", function () { return (parcelRequire("k5FuL")).getViewMatrix; });
$parcel$export(module.exports, "getProjectionParameters", function () { return (parcelRequire("k5FuL")).getProjectionParameters; });

var $6rBd7 = parcelRequire("6rBd7");

var $fPplZ = parcelRequire("fPplZ");

var $gy8FM = parcelRequire("gy8FM");

var $9cckP = parcelRequire("9cckP");

var $6Uylx = parcelRequire("6Uylx");

var $k5FuL = parcelRequire("k5FuL");

});
parcelRegister("6rBd7", function(module, exports) {

var $bh3zl = parcelRequire("bh3zl");

var $9Uxs3 = parcelRequire("9Uxs3");

var $k5FuL = parcelRequire("k5FuL");

var $gy8FM = parcelRequire("gy8FM");

var $fPplZ = parcelRequire("fPplZ");

var $3SJ6M = parcelRequire("3SJ6M");

var $iLzGP = parcelRequire("iLzGP");

var $bX5ds = parcelRequire("bX5ds");
class $4b1220f373d9c412$export$2e2bcd8739ae039 {
    _initMatrices() {
        const { width: width, height: height, projectionMatrix: projectionMatrix, viewMatrix: viewMatrix } = this;
        const vpm = (0, $9Uxs3.createMat4)();
        $3SJ6M.multiply(vpm, vpm, projectionMatrix);
        $3SJ6M.multiply(vpm, vpm, viewMatrix);
        this.viewProjectionMatrix = vpm;
        const m = (0, $9Uxs3.createMat4)();
        $3SJ6M.scale(m, m, [
            width / 2,
            -height / 2,
            1
        ]);
        $3SJ6M.translate(m, m, [
            1,
            -1,
            0
        ]);
        $3SJ6M.multiply(m, m, vpm);
        const mInverse = $3SJ6M.invert((0, $9Uxs3.createMat4)(), m);
        if (!mInverse) throw new Error("Pixel project matrix not invertible");
        this.pixelProjectionMatrix = m;
        this.pixelUnprojectionMatrix = mInverse;
    }
    projectFlat(lngLat) {
        return (0, $k5FuL.lngLatToWorld)(lngLat);
    }
    unprojectFlat(xy) {
        return (0, $k5FuL.worldToLngLat)(xy);
    }
    getMapCenterByLngLatPosition({ lngLat: lngLat, pos: pos }) {
        const fromLocation = (0, $k5FuL.pixelsToWorld)(pos, this.pixelUnprojectionMatrix);
        const toLocation = (0, $k5FuL.lngLatToWorld)(lngLat);
        const translate = $iLzGP.add([], toLocation, $iLzGP.negate([], fromLocation));
        const newCenter = $iLzGP.add([], this.center, translate);
        return (0, $k5FuL.worldToLngLat)(newCenter);
    }
    fitBounds(bounds, options = {}) {
        const { width: width, height: height } = this;
        const { longitude: longitude, latitude: latitude, zoom: zoom } = (0, $gy8FM.default)(Object.assign({
            width: width,
            height: height,
            bounds: bounds
        }, options));
        return new $4b1220f373d9c412$export$2e2bcd8739ae039({
            width: width,
            height: height,
            longitude: longitude,
            latitude: latitude,
            zoom: zoom
        });
    }
    getBounds(options) {
        const corners = this.getBoundingRegion(options);
        const west = Math.min(...corners.map((p)=>p[0]));
        const east = Math.max(...corners.map((p)=>p[0]));
        const south = Math.min(...corners.map((p)=>p[1]));
        const north = Math.max(...corners.map((p)=>p[1]));
        return [
            [
                west,
                south
            ],
            [
                east,
                north
            ]
        ];
    }
    getBoundingRegion(options = {}) {
        return (0, $fPplZ.default)(this, options.z || 0);
    }
    getLocationAtPoint({ lngLat: lngLat, pos: pos }) {
        return this.getMapCenterByLngLatPosition({
            lngLat: lngLat,
            pos: pos
        });
    }
    constructor(props = {
        width: 1,
        height: 1
    }){
        (0, $bh3zl.default)(this, "latitude", void 0);
        (0, $bh3zl.default)(this, "longitude", void 0);
        (0, $bh3zl.default)(this, "zoom", void 0);
        (0, $bh3zl.default)(this, "pitch", void 0);
        (0, $bh3zl.default)(this, "bearing", void 0);
        (0, $bh3zl.default)(this, "altitude", void 0);
        (0, $bh3zl.default)(this, "fovy", void 0);
        (0, $bh3zl.default)(this, "meterOffset", void 0);
        (0, $bh3zl.default)(this, "center", void 0);
        (0, $bh3zl.default)(this, "width", void 0);
        (0, $bh3zl.default)(this, "height", void 0);
        (0, $bh3zl.default)(this, "scale", void 0);
        (0, $bh3zl.default)(this, "distanceScales", void 0);
        (0, $bh3zl.default)(this, "viewMatrix", void 0);
        (0, $bh3zl.default)(this, "projectionMatrix", void 0);
        (0, $bh3zl.default)(this, "viewProjectionMatrix", void 0);
        (0, $bh3zl.default)(this, "pixelProjectionMatrix", void 0);
        (0, $bh3zl.default)(this, "pixelUnprojectionMatrix", void 0);
        (0, $bh3zl.default)(this, "equals", (viewport)=>{
            if (!(viewport instanceof $4b1220f373d9c412$export$2e2bcd8739ae039)) return false;
            return viewport.width === this.width && viewport.height === this.height && $3SJ6M.equals(viewport.projectionMatrix, this.projectionMatrix) && $3SJ6M.equals(viewport.viewMatrix, this.viewMatrix);
        });
        (0, $bh3zl.default)(this, "project", (lngLatZ, options = {})=>{
            const { topLeft: topLeft = true } = options;
            const worldPosition = this.projectPosition(lngLatZ);
            const coord = (0, $k5FuL.worldToPixels)(worldPosition, this.pixelProjectionMatrix);
            const [x, y] = coord;
            const y2 = topLeft ? y : this.height - y;
            return lngLatZ.length === 2 ? [
                x,
                y2
            ] : [
                x,
                y2,
                coord[2]
            ];
        });
        (0, $bh3zl.default)(this, "unproject", (xyz, options = {})=>{
            const { topLeft: topLeft = true, targetZ: targetZ } = options;
            const [x, y, z] = xyz;
            const y2 = topLeft ? y : this.height - y;
            const targetZWorld = targetZ && targetZ * this.distanceScales.unitsPerMeter[2];
            const coord = (0, $k5FuL.pixelsToWorld)([
                x,
                y2,
                z
            ], this.pixelUnprojectionMatrix, targetZWorld);
            const [X, Y, Z] = this.unprojectPosition(coord);
            if (Number.isFinite(z)) return [
                X,
                Y,
                Z
            ];
            return Number.isFinite(targetZ) ? [
                X,
                Y,
                targetZ
            ] : [
                X,
                Y
            ];
        });
        (0, $bh3zl.default)(this, "projectPosition", (xyz)=>{
            const [X, Y] = (0, $k5FuL.lngLatToWorld)(xyz);
            const Z = (xyz[2] || 0) * this.distanceScales.unitsPerMeter[2];
            return [
                X,
                Y,
                Z
            ];
        });
        (0, $bh3zl.default)(this, "unprojectPosition", (xyz)=>{
            const [X, Y] = (0, $k5FuL.worldToLngLat)(xyz);
            const Z = (xyz[2] || 0) * this.distanceScales.metersPerUnit[2];
            return [
                X,
                Y,
                Z
            ];
        });
        let { width: width, height: height, altitude: altitude = null, fovy: fovy = null } = props;
        const { latitude: latitude = 0, longitude: longitude = 0, zoom: zoom = 0, pitch: pitch = 0, bearing: bearing = 0, position: position = null, nearZMultiplier: nearZMultiplier = 0.02, farZMultiplier: farZMultiplier = 1.01 } = props;
        width = width || 1;
        height = height || 1;
        if (fovy === null && altitude === null) {
            altitude = (0, $k5FuL.DEFAULT_ALTITUDE);
            fovy = (0, $k5FuL.altitudeToFovy)(altitude);
        } else if (fovy === null) fovy = (0, $k5FuL.altitudeToFovy)(altitude);
        else if (altitude === null) altitude = (0, $k5FuL.fovyToAltitude)(fovy);
        const scale = (0, $k5FuL.zoomToScale)(zoom);
        altitude = Math.max(0.75, altitude);
        const distanceScales = (0, $k5FuL.getDistanceScales)({
            longitude: longitude,
            latitude: latitude
        });
        const center = (0, $k5FuL.lngLatToWorld)([
            longitude,
            latitude
        ]);
        center.push(0);
        if (position) $bX5ds.add(center, center, $bX5ds.mul([], position, distanceScales.unitsPerMeter));
        this.projectionMatrix = (0, $k5FuL.getProjectionMatrix)({
            width: width,
            height: height,
            scale: scale,
            center: center,
            pitch: pitch,
            fovy: fovy,
            nearZMultiplier: nearZMultiplier,
            farZMultiplier: farZMultiplier
        });
        this.viewMatrix = (0, $k5FuL.getViewMatrix)({
            height: height,
            scale: scale,
            center: center,
            pitch: pitch,
            bearing: bearing,
            altitude: altitude
        });
        this.width = width;
        this.height = height;
        this.scale = scale;
        this.latitude = latitude;
        this.longitude = longitude;
        this.zoom = zoom;
        this.pitch = pitch;
        this.bearing = bearing;
        this.altitude = altitude;
        this.fovy = fovy;
        this.center = center;
        this.meterOffset = position || [
            0,
            0,
            0
        ];
        this.distanceScales = distanceScales;
        this._initMatrices();
        Object.freeze(this);
    }
}

});
parcelRegister("bh3zl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83540cf851575ede$export$2e2bcd8739ae039; });
function $83540cf851575ede$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("9Uxs3", function(module, exports) {

$parcel$export(module.exports, "createMat4", function () { return $73734acdb97e9620$export$1a9a28cade4dcdc4; });
$parcel$export(module.exports, "transformVector", function () { return $73734acdb97e9620$export$8248199402822036; });
$parcel$export(module.exports, "mod", function () { return $73734acdb97e9620$export$842a2cf37af977e1; });
$parcel$export(module.exports, "lerp", function () { return $73734acdb97e9620$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "clamp", function () { return $73734acdb97e9620$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "log2", function () { return $73734acdb97e9620$export$b9fae0bba9d9094d; });

var $kE08x = parcelRequire("kE08x");
function $73734acdb97e9620$export$1a9a28cade4dcdc4() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function $73734acdb97e9620$export$8248199402822036(matrix, vector) {
    const result = (0, $kE08x.transformMat4)([], vector, matrix);
    (0, $kE08x.scale)(result, result, 1 / result[3]);
    return result;
}
function $73734acdb97e9620$export$842a2cf37af977e1(value, divisor) {
    const modulus = value % divisor;
    return modulus < 0 ? divisor + modulus : modulus;
}
function $73734acdb97e9620$export$3a89f8d6f6bf6c9f(start, end, step) {
    return step * end + (1 - step) * start;
}
function $73734acdb97e9620$export$7d15b64cf5a3a4c4(x, min, max) {
    return x < min ? min : x > max ? max : x;
}
function $73734acdb97e9620$var$ieLog2(x) {
    return Math.log(x) * Math.LOG2E;
}
const $73734acdb97e9620$export$b9fae0bba9d9094d = Math.log2 || $73734acdb97e9620$var$ieLog2;

});
parcelRegister("kE08x", function(module, exports) {

$parcel$export(module.exports, "scale", function () { return $f077a635d80635cb$export$dcdf75081b88279d; });
$parcel$export(module.exports, "transformMat4", function () { return $f077a635d80635cb$export$5ffbd13800309d59; });

var $jfP25 = parcelRequire("jfP25");
function $f077a635d80635cb$export$185802fd694ee1f5() {
    var out = new $jfP25.ARRAY_TYPE(4);
    if ($jfP25.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $f077a635d80635cb$export$9cd59f9826255e47(a) {
    var out = new $jfP25.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $f077a635d80635cb$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $jfP25.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $f077a635d80635cb$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $f077a635d80635cb$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $f077a635d80635cb$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $f077a635d80635cb$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $f077a635d80635cb$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $f077a635d80635cb$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $f077a635d80635cb$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $f077a635d80635cb$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $f077a635d80635cb$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $f077a635d80635cb$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $f077a635d80635cb$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $f077a635d80635cb$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $f077a635d80635cb$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $f077a635d80635cb$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $f077a635d80635cb$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $f077a635d80635cb$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $f077a635d80635cb$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $f077a635d80635cb$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $f077a635d80635cb$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $f077a635d80635cb$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $f077a635d80635cb$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $f077a635d80635cb$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $f077a635d80635cb$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $f077a635d80635cb$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $jfP25.RANDOM() * 2 - 1;
        v2 = $jfP25.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $jfP25.RANDOM() * 2 - 1;
        v4 = $jfP25.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $f077a635d80635cb$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $f077a635d80635cb$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $f077a635d80635cb$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $f077a635d80635cb$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $f077a635d80635cb$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $f077a635d80635cb$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $f077a635d80635cb$export$f93b5905241a7cca = $f077a635d80635cb$export$4e2d2ead65e5f7e3;
var $f077a635d80635cb$export$6e3a27864ab166fe = $f077a635d80635cb$export$2060d2db72cce88f;
var $f077a635d80635cb$export$159d9494db57879b = $f077a635d80635cb$export$cd007d971a5a2143;
var $f077a635d80635cb$export$6c4a311cc157c764 = $f077a635d80635cb$export$9f17032d917177de;
var $f077a635d80635cb$export$2422cd6c492a8b3a = $f077a635d80635cb$export$88e6ebb4fe54f538;
var $f077a635d80635cb$export$fc1400facf92c78 = $f077a635d80635cb$export$f24224f1c91d8156;
var $f077a635d80635cb$export$99d8dd3f32a3435 = $f077a635d80635cb$export$ab44e1323ffc8376;
var $f077a635d80635cb$export$4b80e395e36b5a56 = function() {
    var vec = $f077a635d80635cb$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});
parcelRegister("jfP25", function(module, exports) {

$parcel$export(module.exports, "EPSILON", function () { return $e0470109cb7671e2$export$fd293b15f47e270; });
$parcel$export(module.exports, "ARRAY_TYPE", function () { return $e0470109cb7671e2$export$b67359430d3b1b2; });
$parcel$export(module.exports, "RANDOM", function () { return $e0470109cb7671e2$export$5ada478c8a628231; });
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $e0470109cb7671e2$export$fd293b15f47e270 = 0.000001;
var $e0470109cb7671e2$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $e0470109cb7671e2$export$5ada478c8a628231 = Math.random;
function $e0470109cb7671e2$export$cb2c0eb57f5e532c(type) {
    $e0470109cb7671e2$export$b67359430d3b1b2 = type;
}
var $e0470109cb7671e2$var$degree = Math.PI / 180;
function $e0470109cb7671e2$export$408b8ee5959eefd5(a) {
    return a * $e0470109cb7671e2$var$degree;
}
function $e0470109cb7671e2$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $e0470109cb7671e2$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};

});



parcelRegister("k5FuL", function(module, exports) {

$parcel$export(module.exports, "MAX_LATITUDE", function () { return $ea0476558ef8b494$export$6872bd9851469b83; });
$parcel$export(module.exports, "DEFAULT_ALTITUDE", function () { return $ea0476558ef8b494$export$c10d0dffa5af045; });
$parcel$export(module.exports, "zoomToScale", function () { return $ea0476558ef8b494$export$eda81de7742ad8e7; });
$parcel$export(module.exports, "scaleToZoom", function () { return $ea0476558ef8b494$export$6e08c044660f3e30; });
$parcel$export(module.exports, "lngLatToWorld", function () { return $ea0476558ef8b494$export$4a0e8ea52607cc9b; });
$parcel$export(module.exports, "worldToLngLat", function () { return $ea0476558ef8b494$export$66ee0abd8a6a9660; });
$parcel$export(module.exports, "getMeterZoom", function () { return $ea0476558ef8b494$export$f4aaab1d865abddd; });
$parcel$export(module.exports, "unitsPerMeter", function () { return $ea0476558ef8b494$export$de3bf8f403bfc548; });
$parcel$export(module.exports, "getDistanceScales", function () { return $ea0476558ef8b494$export$14a522c4e7772100; });
$parcel$export(module.exports, "addMetersToLngLat", function () { return $ea0476558ef8b494$export$86ab4399faf187a8; });
$parcel$export(module.exports, "getViewMatrix", function () { return $ea0476558ef8b494$export$a4dee078b9284944; });
$parcel$export(module.exports, "getProjectionParameters", function () { return $ea0476558ef8b494$export$3debb7b92b597428; });
$parcel$export(module.exports, "altitudeToFovy", function () { return $ea0476558ef8b494$export$4b02e2005c3c5cc; });
$parcel$export(module.exports, "fovyToAltitude", function () { return $ea0476558ef8b494$export$2e0715d5da7e224d; });
$parcel$export(module.exports, "getProjectionMatrix", function () { return $ea0476558ef8b494$export$1d64991cd669ebf9; });
$parcel$export(module.exports, "worldToPixels", function () { return $ea0476558ef8b494$export$46d0dd92e8f9a0db; });
$parcel$export(module.exports, "pixelsToWorld", function () { return $ea0476558ef8b494$export$d0eff18eb06add5f; });

var $9Uxs3 = parcelRequire("9Uxs3");

var $3SJ6M = parcelRequire("3SJ6M");

var $iLzGP = parcelRequire("iLzGP");

var $bX5ds = parcelRequire("bX5ds");

var $gugLa = parcelRequire("gugLa");
const $ea0476558ef8b494$var$PI = Math.PI;
const $ea0476558ef8b494$var$PI_4 = $ea0476558ef8b494$var$PI / 4;
const $ea0476558ef8b494$var$DEGREES_TO_RADIANS = $ea0476558ef8b494$var$PI / 180;
const $ea0476558ef8b494$var$RADIANS_TO_DEGREES = 180 / $ea0476558ef8b494$var$PI;
const $ea0476558ef8b494$var$TILE_SIZE = 512;
const $ea0476558ef8b494$var$EARTH_CIRCUMFERENCE = 40.03e6;
const $ea0476558ef8b494$export$6872bd9851469b83 = 85.051129;
const $ea0476558ef8b494$export$c10d0dffa5af045 = 1.5;
function $ea0476558ef8b494$export$eda81de7742ad8e7(zoom) {
    return Math.pow(2, zoom);
}
function $ea0476558ef8b494$export$6e08c044660f3e30(scale) {
    return (0, $9Uxs3.log2)(scale);
}
function $ea0476558ef8b494$export$4a0e8ea52607cc9b(lngLat) {
    const [lng, lat] = lngLat;
    (0, $gugLa.default)(Number.isFinite(lng));
    (0, $gugLa.default)(Number.isFinite(lat) && lat >= -90 && lat <= 90, "invalid latitude");
    const lambda2 = lng * $ea0476558ef8b494$var$DEGREES_TO_RADIANS;
    const phi2 = lat * $ea0476558ef8b494$var$DEGREES_TO_RADIANS;
    const x = $ea0476558ef8b494$var$TILE_SIZE * (lambda2 + $ea0476558ef8b494$var$PI) / (2 * $ea0476558ef8b494$var$PI);
    const y = $ea0476558ef8b494$var$TILE_SIZE * ($ea0476558ef8b494$var$PI + Math.log(Math.tan($ea0476558ef8b494$var$PI_4 + phi2 * 0.5))) / (2 * $ea0476558ef8b494$var$PI);
    return [
        x,
        y
    ];
}
function $ea0476558ef8b494$export$66ee0abd8a6a9660(xy) {
    const [x, y] = xy;
    const lambda2 = x / $ea0476558ef8b494$var$TILE_SIZE * (2 * $ea0476558ef8b494$var$PI) - $ea0476558ef8b494$var$PI;
    const phi2 = 2 * (Math.atan(Math.exp(y / $ea0476558ef8b494$var$TILE_SIZE * (2 * $ea0476558ef8b494$var$PI) - $ea0476558ef8b494$var$PI)) - $ea0476558ef8b494$var$PI_4);
    return [
        lambda2 * $ea0476558ef8b494$var$RADIANS_TO_DEGREES,
        phi2 * $ea0476558ef8b494$var$RADIANS_TO_DEGREES
    ];
}
function $ea0476558ef8b494$export$f4aaab1d865abddd(options) {
    const { latitude: latitude } = options;
    (0, $gugLa.default)(Number.isFinite(latitude));
    const latCosine = Math.cos(latitude * $ea0476558ef8b494$var$DEGREES_TO_RADIANS);
    return $ea0476558ef8b494$export$6e08c044660f3e30($ea0476558ef8b494$var$EARTH_CIRCUMFERENCE * latCosine) - 9;
}
function $ea0476558ef8b494$export$de3bf8f403bfc548(latitude) {
    const latCosine = Math.cos(latitude * $ea0476558ef8b494$var$DEGREES_TO_RADIANS);
    return $ea0476558ef8b494$var$TILE_SIZE / $ea0476558ef8b494$var$EARTH_CIRCUMFERENCE / latCosine;
}
function $ea0476558ef8b494$export$14a522c4e7772100(options) {
    const { latitude: latitude, longitude: longitude, highPrecision: highPrecision = false } = options;
    (0, $gugLa.default)(Number.isFinite(latitude) && Number.isFinite(longitude));
    const worldSize = $ea0476558ef8b494$var$TILE_SIZE;
    const latCosine = Math.cos(latitude * $ea0476558ef8b494$var$DEGREES_TO_RADIANS);
    const unitsPerDegreeX = worldSize / 360;
    const unitsPerDegreeY = unitsPerDegreeX / latCosine;
    const altUnitsPerMeter = worldSize / $ea0476558ef8b494$var$EARTH_CIRCUMFERENCE / latCosine;
    const result = {
        unitsPerMeter: [
            altUnitsPerMeter,
            altUnitsPerMeter,
            altUnitsPerMeter
        ],
        metersPerUnit: [
            1 / altUnitsPerMeter,
            1 / altUnitsPerMeter,
            1 / altUnitsPerMeter
        ],
        unitsPerDegree: [
            unitsPerDegreeX,
            unitsPerDegreeY,
            altUnitsPerMeter
        ],
        degreesPerUnit: [
            1 / unitsPerDegreeX,
            1 / unitsPerDegreeY,
            1 / altUnitsPerMeter
        ]
    };
    if (highPrecision) {
        const latCosine2 = $ea0476558ef8b494$var$DEGREES_TO_RADIANS * Math.tan(latitude * $ea0476558ef8b494$var$DEGREES_TO_RADIANS) / latCosine;
        const unitsPerDegreeY2 = unitsPerDegreeX * latCosine2 / 2;
        const altUnitsPerDegree2 = worldSize / $ea0476558ef8b494$var$EARTH_CIRCUMFERENCE * latCosine2;
        const altUnitsPerMeter2 = altUnitsPerDegree2 / unitsPerDegreeY * altUnitsPerMeter;
        result.unitsPerDegree2 = [
            0,
            unitsPerDegreeY2,
            altUnitsPerDegree2
        ];
        result.unitsPerMeter2 = [
            altUnitsPerMeter2,
            0,
            altUnitsPerMeter2
        ];
    }
    return result;
}
function $ea0476558ef8b494$export$86ab4399faf187a8(lngLatZ, xyz) {
    const [longitude, latitude, z0] = lngLatZ;
    const [x, y, z] = xyz;
    const { unitsPerMeter: unitsPerMeter, unitsPerMeter2: unitsPerMeter2 } = $ea0476558ef8b494$export$14a522c4e7772100({
        longitude: longitude,
        latitude: latitude,
        highPrecision: true
    });
    const worldspace = $ea0476558ef8b494$export$4a0e8ea52607cc9b(lngLatZ);
    worldspace[0] += x * (unitsPerMeter[0] + unitsPerMeter2[0] * y);
    worldspace[1] += y * (unitsPerMeter[1] + unitsPerMeter2[1] * y);
    const newLngLat = $ea0476558ef8b494$export$66ee0abd8a6a9660(worldspace);
    const newZ = (z0 || 0) + (z || 0);
    return Number.isFinite(z0) || Number.isFinite(z) ? [
        newLngLat[0],
        newLngLat[1],
        newZ
    ] : newLngLat;
}
function $ea0476558ef8b494$export$a4dee078b9284944(options) {
    const { height: height, pitch: pitch, bearing: bearing, altitude: altitude, scale: scale, center: center } = options;
    const vm = (0, $9Uxs3.createMat4)();
    $3SJ6M.translate(vm, vm, [
        0,
        0,
        -altitude
    ]);
    $3SJ6M.rotateX(vm, vm, -pitch * $ea0476558ef8b494$var$DEGREES_TO_RADIANS);
    $3SJ6M.rotateZ(vm, vm, bearing * $ea0476558ef8b494$var$DEGREES_TO_RADIANS);
    const relativeScale = scale / height;
    $3SJ6M.scale(vm, vm, [
        relativeScale,
        relativeScale,
        relativeScale
    ]);
    if (center) $3SJ6M.translate(vm, vm, $bX5ds.negate([], center));
    return vm;
}
function $ea0476558ef8b494$export$3debb7b92b597428(options) {
    const { width: width, height: height, altitude: altitude, pitch: pitch = 0, offset: offset, center: center, scale: scale, nearZMultiplier: nearZMultiplier = 1, farZMultiplier: farZMultiplier = 1 } = options;
    let { fovy: fovy = $ea0476558ef8b494$export$4b02e2005c3c5cc($ea0476558ef8b494$export$c10d0dffa5af045) } = options;
    if (altitude !== undefined) fovy = $ea0476558ef8b494$export$4b02e2005c3c5cc(altitude);
    const fovRadians = fovy * $ea0476558ef8b494$var$DEGREES_TO_RADIANS;
    const pitchRadians = pitch * $ea0476558ef8b494$var$DEGREES_TO_RADIANS;
    const focalDistance = $ea0476558ef8b494$export$2e0715d5da7e224d(fovy);
    let cameraToSeaLevelDistance = focalDistance;
    if (center) cameraToSeaLevelDistance += center[2] * scale / Math.cos(pitchRadians) / height;
    const fovAboveCenter = fovRadians * (0.5 + (offset ? offset[1] : 0) / height);
    const topHalfSurfaceDistance = Math.sin(fovAboveCenter) * cameraToSeaLevelDistance / Math.sin((0, $9Uxs3.clamp)(Math.PI / 2 - pitchRadians - fovAboveCenter, 0.01, Math.PI - 0.01));
    const furthestDistance = Math.sin(pitchRadians) * topHalfSurfaceDistance + cameraToSeaLevelDistance;
    const horizonDistance = cameraToSeaLevelDistance * 10;
    const farZ = Math.min(furthestDistance * farZMultiplier, horizonDistance);
    return {
        fov: fovRadians,
        aspect: width / height,
        focalDistance: focalDistance,
        near: nearZMultiplier,
        far: farZ
    };
}
function $ea0476558ef8b494$export$1d64991cd669ebf9(options) {
    const { fov: fov, aspect: aspect, near: near, far: far } = $ea0476558ef8b494$export$3debb7b92b597428(options);
    const projectionMatrix = $3SJ6M.perspective([], fov, aspect, near, far);
    return projectionMatrix;
}
function $ea0476558ef8b494$export$4b02e2005c3c5cc(altitude) {
    return 2 * Math.atan(0.5 / altitude) * $ea0476558ef8b494$var$RADIANS_TO_DEGREES;
}
function $ea0476558ef8b494$export$2e0715d5da7e224d(fovy) {
    return 0.5 / Math.tan(0.5 * fovy * $ea0476558ef8b494$var$DEGREES_TO_RADIANS);
}
function $ea0476558ef8b494$export$46d0dd92e8f9a0db(xyz, pixelProjectionMatrix) {
    const [x, y, z = 0] = xyz;
    (0, $gugLa.default)(Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(z));
    return (0, $9Uxs3.transformVector)(pixelProjectionMatrix, [
        x,
        y,
        z,
        1
    ]);
}
function $ea0476558ef8b494$export$d0eff18eb06add5f(xyz, pixelUnprojectionMatrix, targetZ = 0) {
    const [x, y, z] = xyz;
    (0, $gugLa.default)(Number.isFinite(x) && Number.isFinite(y), "invalid pixel coordinate");
    if (Number.isFinite(z)) {
        const coord = (0, $9Uxs3.transformVector)(pixelUnprojectionMatrix, [
            x,
            y,
            z,
            1
        ]);
        return coord;
    }
    const coord0 = (0, $9Uxs3.transformVector)(pixelUnprojectionMatrix, [
        x,
        y,
        0,
        1
    ]);
    const coord1 = (0, $9Uxs3.transformVector)(pixelUnprojectionMatrix, [
        x,
        y,
        1,
        1
    ]);
    const z0 = coord0[2];
    const z1 = coord1[2];
    const t = z0 === z1 ? 0 : ((targetZ || 0) - z0) / (z1 - z0);
    return $iLzGP.lerp([], coord0, coord1, t);
}

});
parcelRegister("3SJ6M", function(module, exports) {

$parcel$export(module.exports, "invert", function () { return $2d3967d2766cef10$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "multiply", function () { return $2d3967d2766cef10$export$2060d2db72cce88f; });
$parcel$export(module.exports, "translate", function () { return $2d3967d2766cef10$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "scale", function () { return $2d3967d2766cef10$export$dcdf75081b88279d; });
$parcel$export(module.exports, "rotateX", function () { return $2d3967d2766cef10$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateZ", function () { return $2d3967d2766cef10$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "perspective", function () { return $2d3967d2766cef10$export$541149539f3a4684; });
$parcel$export(module.exports, "equals", function () { return $2d3967d2766cef10$export$e9bab7fafb253603; });

var $jfP25 = parcelRequire("jfP25");
function $2d3967d2766cef10$export$185802fd694ee1f5() {
    var out = new $jfP25.ARRAY_TYPE(16);
    if ($jfP25.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$9cd59f9826255e47(a) {
    var out = new $jfP25.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2d3967d2766cef10$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2d3967d2766cef10$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $jfP25.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2d3967d2766cef10$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2d3967d2766cef10$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $2d3967d2766cef10$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $2d3967d2766cef10$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $2d3967d2766cef10$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $2d3967d2766cef10$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $2d3967d2766cef10$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $2d3967d2766cef10$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2d3967d2766cef10$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $jfP25.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $2d3967d2766cef10$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $2d3967d2766cef10$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $2d3967d2766cef10$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $2d3967d2766cef10$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $jfP25.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$ff497f2be31cc6a(out, a) {
    var translation = new $jfP25.ARRAY_TYPE(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $2d3967d2766cef10$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $2d3967d2766cef10$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $2d3967d2766cef10$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $2d3967d2766cef10$export$df3937d3b537df0a(out, mat) {
    var scaling = new $jfP25.ARRAY_TYPE(3);
    $2d3967d2766cef10$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $2d3967d2766cef10$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $2d3967d2766cef10$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $2d3967d2766cef10$export$541149539f3a4684 = $2d3967d2766cef10$export$4cf19729ec9a96b8;
function $2d3967d2766cef10$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $2d3967d2766cef10$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $2d3967d2766cef10$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $2d3967d2766cef10$export$4f2167e613cfc87b = $2d3967d2766cef10$export$c5f65ef3eb668f27;
function $2d3967d2766cef10$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $jfP25.EPSILON && Math.abs(eyey - centery) < $jfP25.EPSILON && Math.abs(eyez - centerz) < $jfP25.EPSILON) return $2d3967d2766cef10$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $2d3967d2766cef10$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $2d3967d2766cef10$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $2d3967d2766cef10$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $2d3967d2766cef10$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $2d3967d2766cef10$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $2d3967d2766cef10$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $2d3967d2766cef10$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $2d3967d2766cef10$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $2d3967d2766cef10$export$6e3a27864ab166fe = $2d3967d2766cef10$export$2060d2db72cce88f;
var $2d3967d2766cef10$export$f93b5905241a7cca = $2d3967d2766cef10$export$4e2d2ead65e5f7e3;

});

parcelRegister("iLzGP", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $da984d064645620f$export$e16d8520af44a096; });
$parcel$export(module.exports, "scale", function () { return $da984d064645620f$export$dcdf75081b88279d; });
$parcel$export(module.exports, "length", function () { return $da984d064645620f$export$f24224f1c91d8156; });
$parcel$export(module.exports, "negate", function () { return $da984d064645620f$export$aef51622e549b8b0; });
$parcel$export(module.exports, "lerp", function () { return $da984d064645620f$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "sub", function () { return $da984d064645620f$export$f93b5905241a7cca; });

var $jfP25 = parcelRequire("jfP25");
function $da984d064645620f$export$185802fd694ee1f5() {
    var out = new $jfP25.ARRAY_TYPE(2);
    if ($jfP25.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $da984d064645620f$export$9cd59f9826255e47(a) {
    var out = new $jfP25.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $da984d064645620f$export$a82be99ed2a44a7d(x, y) {
    var out = new $jfP25.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $da984d064645620f$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $da984d064645620f$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $da984d064645620f$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $da984d064645620f$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $da984d064645620f$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $da984d064645620f$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $da984d064645620f$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $da984d064645620f$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $da984d064645620f$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $da984d064645620f$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $da984d064645620f$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $da984d064645620f$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $da984d064645620f$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $da984d064645620f$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $da984d064645620f$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $da984d064645620f$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $da984d064645620f$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $da984d064645620f$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $da984d064645620f$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $da984d064645620f$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $da984d064645620f$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $da984d064645620f$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $da984d064645620f$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $da984d064645620f$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $jfP25.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $da984d064645620f$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $da984d064645620f$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $da984d064645620f$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $da984d064645620f$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $da984d064645620f$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $da984d064645620f$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $da984d064645620f$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $da984d064645620f$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $da984d064645620f$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $da984d064645620f$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $da984d064645620f$export$fc1400facf92c78 = $da984d064645620f$export$f24224f1c91d8156;
var $da984d064645620f$export$f93b5905241a7cca = $da984d064645620f$export$4e2d2ead65e5f7e3;
var $da984d064645620f$export$6e3a27864ab166fe = $da984d064645620f$export$2060d2db72cce88f;
var $da984d064645620f$export$159d9494db57879b = $da984d064645620f$export$cd007d971a5a2143;
var $da984d064645620f$export$6c4a311cc157c764 = $da984d064645620f$export$9f17032d917177de;
var $da984d064645620f$export$2422cd6c492a8b3a = $da984d064645620f$export$88e6ebb4fe54f538;
var $da984d064645620f$export$99d8dd3f32a3435 = $da984d064645620f$export$ab44e1323ffc8376;
var $da984d064645620f$export$4b80e395e36b5a56 = function() {
    var vec = $da984d064645620f$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

});

parcelRegister("bX5ds", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $8b3940326cf837bf$export$e16d8520af44a096; });
$parcel$export(module.exports, "negate", function () { return $8b3940326cf837bf$export$aef51622e549b8b0; });
$parcel$export(module.exports, "mul", function () { return $8b3940326cf837bf$export$6e3a27864ab166fe; });

var $jfP25 = parcelRequire("jfP25");
function $8b3940326cf837bf$export$185802fd694ee1f5() {
    var out = new $jfP25.ARRAY_TYPE(3);
    if ($jfP25.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $8b3940326cf837bf$export$9cd59f9826255e47(a) {
    var out = new $jfP25.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8b3940326cf837bf$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $8b3940326cf837bf$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $jfP25.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8b3940326cf837bf$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8b3940326cf837bf$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8b3940326cf837bf$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $8b3940326cf837bf$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $8b3940326cf837bf$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $8b3940326cf837bf$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $8b3940326cf837bf$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $8b3940326cf837bf$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $8b3940326cf837bf$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $8b3940326cf837bf$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $8b3940326cf837bf$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $8b3940326cf837bf$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $8b3940326cf837bf$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $8b3940326cf837bf$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $8b3940326cf837bf$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $8b3940326cf837bf$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $8b3940326cf837bf$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $8b3940326cf837bf$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $8b3940326cf837bf$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $8b3940326cf837bf$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $8b3940326cf837bf$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $8b3940326cf837bf$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $8b3940326cf837bf$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8b3940326cf837bf$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8b3940326cf837bf$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $jfP25.RANDOM() * 2.0 * Math.PI;
    var z = $jfP25.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $8b3940326cf837bf$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $8b3940326cf837bf$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $8b3940326cf837bf$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $8b3940326cf837bf$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8b3940326cf837bf$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8b3940326cf837bf$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8b3940326cf837bf$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $8b3940326cf837bf$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $8b3940326cf837bf$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $8b3940326cf837bf$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $8b3940326cf837bf$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $8b3940326cf837bf$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $jfP25.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $8b3940326cf837bf$export$f93b5905241a7cca = $8b3940326cf837bf$export$4e2d2ead65e5f7e3;
var $8b3940326cf837bf$export$6e3a27864ab166fe = $8b3940326cf837bf$export$2060d2db72cce88f;
var $8b3940326cf837bf$export$159d9494db57879b = $8b3940326cf837bf$export$cd007d971a5a2143;
var $8b3940326cf837bf$export$6c4a311cc157c764 = $8b3940326cf837bf$export$9f17032d917177de;
var $8b3940326cf837bf$export$2422cd6c492a8b3a = $8b3940326cf837bf$export$88e6ebb4fe54f538;
var $8b3940326cf837bf$export$fc1400facf92c78 = $8b3940326cf837bf$export$f24224f1c91d8156;
var $8b3940326cf837bf$export$99d8dd3f32a3435 = $8b3940326cf837bf$export$ab44e1323ffc8376;
var $8b3940326cf837bf$export$4b80e395e36b5a56 = function() {
    var vec = $8b3940326cf837bf$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});

parcelRegister("gugLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c00c72cecb16fb87$export$2e2bcd8739ae039; });
function $c00c72cecb16fb87$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message || "@math.gl/web-mercator: assertion failed.");
}

});


parcelRegister("gy8FM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c68c900829a2aa$export$2e2bcd8739ae039; });

var $gugLa = parcelRequire("gugLa");

var $9Uxs3 = parcelRequire("9Uxs3");

var $k5FuL = parcelRequire("k5FuL");
function $c0c68c900829a2aa$export$2e2bcd8739ae039(options) {
    const { width: width, height: height, bounds: bounds, minExtent: minExtent = 0, maxZoom: maxZoom = 24, offset: offset = [
        0,
        0
    ] } = options;
    const [[west, south], [east, north]] = bounds;
    const padding = $c0c68c900829a2aa$var$getPaddingObject(options.padding);
    const nw = (0, $k5FuL.lngLatToWorld)([
        west,
        (0, $9Uxs3.clamp)(north, -(0, $k5FuL.MAX_LATITUDE), (0, $k5FuL.MAX_LATITUDE))
    ]);
    const se = (0, $k5FuL.lngLatToWorld)([
        east,
        (0, $9Uxs3.clamp)(south, -(0, $k5FuL.MAX_LATITUDE), (0, $k5FuL.MAX_LATITUDE))
    ]);
    const size = [
        Math.max(Math.abs(se[0] - nw[0]), minExtent),
        Math.max(Math.abs(se[1] - nw[1]), minExtent)
    ];
    const targetSize = [
        width - padding.left - padding.right - Math.abs(offset[0]) * 2,
        height - padding.top - padding.bottom - Math.abs(offset[1]) * 2
    ];
    (0, $gugLa.default)(targetSize[0] > 0 && targetSize[1] > 0);
    const scaleX = targetSize[0] / size[0];
    const scaleY = targetSize[1] / size[1];
    const offsetX = (padding.right - padding.left) / 2 / scaleX;
    const offsetY = (padding.top - padding.bottom) / 2 / scaleY;
    const center = [
        (se[0] + nw[0]) / 2 + offsetX,
        (se[1] + nw[1]) / 2 + offsetY
    ];
    const centerLngLat = (0, $k5FuL.worldToLngLat)(center);
    const zoom = Math.min(maxZoom, (0, $9Uxs3.log2)(Math.abs(Math.min(scaleX, scaleY))));
    (0, $gugLa.default)(Number.isFinite(zoom));
    return {
        longitude: centerLngLat[0],
        latitude: centerLngLat[1],
        zoom: zoom
    };
}
function $c0c68c900829a2aa$var$getPaddingObject(padding = 0) {
    if (typeof padding === "number") return {
        top: padding,
        bottom: padding,
        left: padding,
        right: padding
    };
    (0, $gugLa.default)(Number.isFinite(padding.top) && Number.isFinite(padding.bottom) && Number.isFinite(padding.left) && Number.isFinite(padding.right));
    return padding;
}

});

parcelRegister("fPplZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b85f492ba6cfefc8$export$2e2bcd8739ae039; });

var $k5FuL = parcelRequire("k5FuL");

var $iLzGP = parcelRequire("iLzGP");

var $9Uxs3 = parcelRequire("9Uxs3");
const $b85f492ba6cfefc8$var$DEGREES_TO_RADIANS = Math.PI / 180;
function $b85f492ba6cfefc8$export$2e2bcd8739ae039(viewport, z = 0) {
    const { width: width, height: height, unproject: unproject } = viewport;
    const unprojectOps = {
        targetZ: z
    };
    const bottomLeft = unproject([
        0,
        height
    ], unprojectOps);
    const bottomRight = unproject([
        width,
        height
    ], unprojectOps);
    let topLeft;
    let topRight;
    const halfFov = viewport.fovy ? 0.5 * viewport.fovy * $b85f492ba6cfefc8$var$DEGREES_TO_RADIANS : Math.atan(0.5 / viewport.altitude);
    const angleToGround = (90 - viewport.pitch) * $b85f492ba6cfefc8$var$DEGREES_TO_RADIANS;
    if (halfFov > angleToGround - 0.01) {
        topLeft = $b85f492ba6cfefc8$var$unprojectOnFarPlane(viewport, 0, z);
        topRight = $b85f492ba6cfefc8$var$unprojectOnFarPlane(viewport, width, z);
    } else {
        topLeft = unproject([
            0,
            0
        ], unprojectOps);
        topRight = unproject([
            width,
            0
        ], unprojectOps);
    }
    return [
        bottomLeft,
        bottomRight,
        topRight,
        topLeft
    ];
}
function $b85f492ba6cfefc8$var$unprojectOnFarPlane(viewport, x, targetZ) {
    const { pixelUnprojectionMatrix: pixelUnprojectionMatrix } = viewport;
    const coord0 = (0, $9Uxs3.transformVector)(pixelUnprojectionMatrix, [
        x,
        0,
        1,
        1
    ]);
    const coord1 = (0, $9Uxs3.transformVector)(pixelUnprojectionMatrix, [
        x,
        viewport.height,
        1,
        1
    ]);
    const z = targetZ * viewport.distanceScales.unitsPerMeter[2];
    const t = (z - coord0[2]) / (coord1[2] - coord0[2]);
    const coord = $iLzGP.lerp([], coord0, coord1, t);
    const result = (0, $k5FuL.worldToLngLat)(coord);
    result.push(targetZ);
    return result;
}

});


parcelRegister("9cckP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b1ecd810d701820$export$2e2bcd8739ae039; });

var $k5FuL = parcelRequire("k5FuL");

var $9Uxs3 = parcelRequire("9Uxs3");
const $6b1ecd810d701820$var$TILE_SIZE = 512;
function $6b1ecd810d701820$export$2e2bcd8739ae039(props) {
    const { width: width, height: height, pitch: pitch = 0 } = props;
    let { longitude: longitude, latitude: latitude, zoom: zoom, bearing: bearing = 0 } = props;
    if (longitude < -180 || longitude > 180) longitude = (0, $9Uxs3.mod)(longitude + 180, 360) - 180;
    if (bearing < -180 || bearing > 180) bearing = (0, $9Uxs3.mod)(bearing + 180, 360) - 180;
    const minZoom = (0, $9Uxs3.log2)(height / $6b1ecd810d701820$var$TILE_SIZE);
    if (zoom <= minZoom) {
        zoom = minZoom;
        latitude = 0;
    } else {
        const halfHeightPixels = height / 2 / Math.pow(2, zoom);
        const minLatitude = (0, $k5FuL.worldToLngLat)([
            0,
            halfHeightPixels
        ])[1];
        if (latitude < minLatitude) latitude = minLatitude;
        else {
            const maxLatitude = (0, $k5FuL.worldToLngLat)([
                0,
                $6b1ecd810d701820$var$TILE_SIZE - halfHeightPixels
            ])[1];
            if (latitude > maxLatitude) latitude = maxLatitude;
        }
    }
    return {
        width: width,
        height: height,
        longitude: longitude,
        latitude: latitude,
        zoom: zoom,
        pitch: pitch,
        bearing: bearing
    };
}

});

parcelRegister("6Uylx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50829d8282fd979a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getFlyToDuration", function () { return $50829d8282fd979a$export$1d42c64f84307be3; });

var $2QP2i = parcelRequire("2QP2i");

var $9Uxs3 = parcelRequire("9Uxs3");

var $k5FuL = parcelRequire("k5FuL");

var $iLzGP = parcelRequire("iLzGP");
const $50829d8282fd979a$var$EPSILON = 0.01;
const $50829d8282fd979a$var$VIEWPORT_TRANSITION_PROPS = [
    "longitude",
    "latitude",
    "zoom"
];
const $50829d8282fd979a$var$DEFAULT_OPTS = {
    curve: 1.414,
    speed: 1.2
};
function $50829d8282fd979a$export$2e2bcd8739ae039(startProps, endProps, t, options) {
    const { startZoom: startZoom, startCenterXY: startCenterXY, uDelta: uDelta, w0: w0, u1: u1, S: S, rho: rho, rho2: rho2, r0: r0 } = $50829d8282fd979a$var$getFlyToTransitionParams(startProps, endProps, options);
    if (u1 < $50829d8282fd979a$var$EPSILON) {
        const viewport = {};
        for (const key of $50829d8282fd979a$var$VIEWPORT_TRANSITION_PROPS){
            const startValue = startProps[key];
            const endValue = endProps[key];
            viewport[key] = (0, $9Uxs3.lerp)(startValue, endValue, t);
        }
        return viewport;
    }
    const s = t * S;
    const w = Math.cosh(r0) / Math.cosh(r0 + rho * s);
    const u = w0 * ((Math.cosh(r0) * Math.tanh(r0 + rho * s) - Math.sinh(r0)) / rho2) / u1;
    const scaleIncrement = 1 / w;
    const newZoom = startZoom + (0, $k5FuL.scaleToZoom)(scaleIncrement);
    const newCenterWorld = $iLzGP.scale([], uDelta, u);
    $iLzGP.add(newCenterWorld, newCenterWorld, startCenterXY);
    const newCenter = (0, $k5FuL.worldToLngLat)(newCenterWorld);
    return {
        longitude: newCenter[0],
        latitude: newCenter[1],
        zoom: newZoom
    };
}
function $50829d8282fd979a$export$1d42c64f84307be3(startProps, endProps, options) {
    const opts = (0, $2QP2i._)({}, $50829d8282fd979a$var$DEFAULT_OPTS, options);
    const { screenSpeed: screenSpeed, speed: speed, maxDuration: maxDuration } = opts;
    const { S: S, rho: rho } = $50829d8282fd979a$var$getFlyToTransitionParams(startProps, endProps, opts);
    const length = 1000 * S;
    let duration;
    if (Number.isFinite(screenSpeed)) duration = length / (screenSpeed / rho);
    else duration = length / speed;
    return Number.isFinite(maxDuration) && duration > maxDuration ? 0 : duration;
}
function $50829d8282fd979a$var$getFlyToTransitionParams(startProps, endProps, opts) {
    opts = Object.assign({}, $50829d8282fd979a$var$DEFAULT_OPTS, opts);
    const rho = opts.curve;
    const startZoom = startProps.zoom;
    const startCenter = [
        startProps.longitude,
        startProps.latitude
    ];
    const startScale = (0, $k5FuL.zoomToScale)(startZoom);
    const endZoom = endProps.zoom;
    const endCenter = [
        endProps.longitude,
        endProps.latitude
    ];
    const scale = (0, $k5FuL.zoomToScale)(endZoom - startZoom);
    const startCenterXY = (0, $k5FuL.lngLatToWorld)(startCenter);
    const endCenterXY = (0, $k5FuL.lngLatToWorld)(endCenter);
    const uDelta = $iLzGP.sub([], endCenterXY, startCenterXY);
    const w0 = Math.max(startProps.width, startProps.height);
    const w1 = w0 / scale;
    const u1 = $iLzGP.length(uDelta) * startScale;
    const _u1 = Math.max(u1, $50829d8282fd979a$var$EPSILON);
    const rho2 = rho * rho;
    const b0 = (w1 * w1 - w0 * w0 + rho2 * rho2 * _u1 * _u1) / (2 * w0 * rho2 * _u1);
    const b1 = (w1 * w1 - w0 * w0 - rho2 * rho2 * _u1 * _u1) / (2 * w1 * rho2 * _u1);
    const r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0);
    const r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    const S = (r1 - r0) / rho;
    return {
        startZoom: startZoom,
        startCenterXY: startCenterXY,
        uDelta: uDelta,
        w0: w0,
        u1: u1,
        S: S,
        rho: rho,
        rho2: rho2,
        r0: r0,
        r1: r1
    };
}

});



parcelRegister("7sAKl", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $56e7a6ff0ae1fbe9$export$e16d8520af44a096; });
$parcel$export(module.exports, "negate", function () { return $56e7a6ff0ae1fbe9$export$aef51622e549b8b0; });

var $bheRV = parcelRequire("bheRV");
function $56e7a6ff0ae1fbe9$export$185802fd694ee1f5() {
    var out = new $bheRV.ARRAY_TYPE(2);
    if ($bheRV.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $56e7a6ff0ae1fbe9$export$9cd59f9826255e47(a) {
    var out = new $bheRV.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$a82be99ed2a44a7d(x, y) {
    var out = new $bheRV.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $56e7a6ff0ae1fbe9$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $56e7a6ff0ae1fbe9$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $56e7a6ff0ae1fbe9$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $56e7a6ff0ae1fbe9$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $56e7a6ff0ae1fbe9$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $56e7a6ff0ae1fbe9$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $56e7a6ff0ae1fbe9$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $56e7a6ff0ae1fbe9$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $56e7a6ff0ae1fbe9$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $56e7a6ff0ae1fbe9$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $56e7a6ff0ae1fbe9$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $56e7a6ff0ae1fbe9$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $56e7a6ff0ae1fbe9$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $56e7a6ff0ae1fbe9$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $56e7a6ff0ae1fbe9$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $56e7a6ff0ae1fbe9$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $56e7a6ff0ae1fbe9$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $bheRV.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $56e7a6ff0ae1fbe9$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $56e7a6ff0ae1fbe9$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $56e7a6ff0ae1fbe9$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $56e7a6ff0ae1fbe9$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $56e7a6ff0ae1fbe9$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $56e7a6ff0ae1fbe9$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $56e7a6ff0ae1fbe9$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $56e7a6ff0ae1fbe9$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $56e7a6ff0ae1fbe9$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $56e7a6ff0ae1fbe9$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $56e7a6ff0ae1fbe9$export$fc1400facf92c78 = $56e7a6ff0ae1fbe9$export$f24224f1c91d8156;
var $56e7a6ff0ae1fbe9$export$f93b5905241a7cca = $56e7a6ff0ae1fbe9$export$4e2d2ead65e5f7e3;
var $56e7a6ff0ae1fbe9$export$6e3a27864ab166fe = $56e7a6ff0ae1fbe9$export$2060d2db72cce88f;
var $56e7a6ff0ae1fbe9$export$159d9494db57879b = $56e7a6ff0ae1fbe9$export$cd007d971a5a2143;
var $56e7a6ff0ae1fbe9$export$6c4a311cc157c764 = $56e7a6ff0ae1fbe9$export$9f17032d917177de;
var $56e7a6ff0ae1fbe9$export$2422cd6c492a8b3a = $56e7a6ff0ae1fbe9$export$88e6ebb4fe54f538;
var $56e7a6ff0ae1fbe9$export$99d8dd3f32a3435 = $56e7a6ff0ae1fbe9$export$ab44e1323ffc8376;
var $56e7a6ff0ae1fbe9$export$4b80e395e36b5a56 = function() {
    var vec = $56e7a6ff0ae1fbe9$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

});


parcelRegister("7xR33", function(module, exports) {

$parcel$export(module.exports, "lerp", function () { return $57e4c3bf251896fe$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "sub", function () { return $57e4c3bf251896fe$export$f93b5905241a7cca; });
$parcel$export(module.exports, "len", function () { return $57e4c3bf251896fe$export$fc1400facf92c78; });
$parcel$export(module.exports, "sqrLen", function () { return $57e4c3bf251896fe$export$99d8dd3f32a3435; });

var $bheRV = parcelRequire("bheRV");
function $57e4c3bf251896fe$export$185802fd694ee1f5() {
    var out = new $bheRV.ARRAY_TYPE(3);
    if ($bheRV.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $57e4c3bf251896fe$export$9cd59f9826255e47(a) {
    var out = new $bheRV.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $57e4c3bf251896fe$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $57e4c3bf251896fe$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $bheRV.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $57e4c3bf251896fe$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $57e4c3bf251896fe$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $57e4c3bf251896fe$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $57e4c3bf251896fe$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $57e4c3bf251896fe$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $57e4c3bf251896fe$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $57e4c3bf251896fe$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $57e4c3bf251896fe$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $57e4c3bf251896fe$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $57e4c3bf251896fe$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $57e4c3bf251896fe$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $57e4c3bf251896fe$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $57e4c3bf251896fe$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $57e4c3bf251896fe$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $57e4c3bf251896fe$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $57e4c3bf251896fe$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $57e4c3bf251896fe$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $57e4c3bf251896fe$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $57e4c3bf251896fe$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $57e4c3bf251896fe$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $57e4c3bf251896fe$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $57e4c3bf251896fe$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $57e4c3bf251896fe$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $57e4c3bf251896fe$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $57e4c3bf251896fe$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $bheRV.RANDOM() * 2.0 * Math.PI;
    var z = $bheRV.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $57e4c3bf251896fe$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $57e4c3bf251896fe$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $57e4c3bf251896fe$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $57e4c3bf251896fe$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $57e4c3bf251896fe$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $57e4c3bf251896fe$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $57e4c3bf251896fe$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $57e4c3bf251896fe$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $57e4c3bf251896fe$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $57e4c3bf251896fe$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $57e4c3bf251896fe$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $57e4c3bf251896fe$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $bheRV.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $57e4c3bf251896fe$export$f93b5905241a7cca = $57e4c3bf251896fe$export$4e2d2ead65e5f7e3;
var $57e4c3bf251896fe$export$6e3a27864ab166fe = $57e4c3bf251896fe$export$2060d2db72cce88f;
var $57e4c3bf251896fe$export$159d9494db57879b = $57e4c3bf251896fe$export$cd007d971a5a2143;
var $57e4c3bf251896fe$export$6c4a311cc157c764 = $57e4c3bf251896fe$export$9f17032d917177de;
var $57e4c3bf251896fe$export$2422cd6c492a8b3a = $57e4c3bf251896fe$export$88e6ebb4fe54f538;
var $57e4c3bf251896fe$export$fc1400facf92c78 = $57e4c3bf251896fe$export$f24224f1c91d8156;
var $57e4c3bf251896fe$export$99d8dd3f32a3435 = $57e4c3bf251896fe$export$ab44e1323ffc8376;
var $57e4c3bf251896fe$export$4b80e395e36b5a56 = function() {
    var vec = $57e4c3bf251896fe$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});


parcelRegister("lXqRv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffc3f1e46cf1f899$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1zR3q = parcelRequire("1zR3q");

var $lXg0j = parcelRequire("lXg0j");

var $9y7Yj = parcelRequire("9y7Yj");
let $ffc3f1e46cf1f899$var$counter = 0;
class $ffc3f1e46cf1f899$export$2e2bcd8739ae039 {
    clone(newProps) {
        const { props: props } = this;
        const asyncProps = {};
        for(const key in props[0, $lXg0j.ASYNC_DEFAULTS_SYMBOL]){
            if (key in props[0, $lXg0j.ASYNC_RESOLVED_SYMBOL]) asyncProps[key] = props[0, $lXg0j.ASYNC_RESOLVED_SYMBOL][key];
            else if (key in props[0, $lXg0j.ASYNC_ORIGINAL_SYMBOL]) asyncProps[key] = props[0, $lXg0j.ASYNC_ORIGINAL_SYMBOL][key];
        }
        return new this.constructor((0, $2QP2i._)({}, props, asyncProps, newProps));
    }
    constructor(...propObjects){
        (0, $1zR3q.default)(this, "id", void 0);
        (0, $1zR3q.default)(this, "props", void 0);
        (0, $1zR3q.default)(this, "count", void 0);
        this.props = (0, $9y7Yj.createProps)(this, propObjects);
        this.id = this.props.id;
        this.count = $ffc3f1e46cf1f899$var$counter++;
    }
}
(0, $1zR3q.default)($ffc3f1e46cf1f899$export$2e2bcd8739ae039, "componentName", "Component");
(0, $1zR3q.default)($ffc3f1e46cf1f899$export$2e2bcd8739ae039, "defaultProps", {});

});
parcelRegister("9y7Yj", function(module, exports) {

$parcel$export(module.exports, "createProps", function () { return $6f3d790fb58d63a4$export$c94ea207b45fef3a; });

var $4VQgq = parcelRequire("4VQgq");

var $abpME = parcelRequire("abpME");

var $ewpcq = parcelRequire("ewpcq");

var $lXg0j = parcelRequire("lXg0j");
function $6f3d790fb58d63a4$export$c94ea207b45fef3a(component, propObjects) {
    let extensions;
    for(let i = propObjects.length - 1; i >= 0; i--){
        const props = propObjects[i];
        if ("extensions" in props) extensions = props.extensions;
    }
    const propsPrototype = $6f3d790fb58d63a4$var$getPropsPrototype(component.constructor, extensions);
    const propsInstance = Object.create(propsPrototype);
    propsInstance[0, $lXg0j.COMPONENT_SYMBOL] = component;
    propsInstance[0, $lXg0j.ASYNC_ORIGINAL_SYMBOL] = {};
    propsInstance[0, $lXg0j.ASYNC_RESOLVED_SYMBOL] = {};
    for(let i = 0; i < propObjects.length; ++i){
        const props = propObjects[i];
        for(const key in props)propsInstance[key] = props[key];
    }
    Object.freeze(propsInstance);
    return propsInstance;
}
const $6f3d790fb58d63a4$var$MergedDefaultPropsCacheKey = "_mergedDefaultProps";
function $6f3d790fb58d63a4$var$getPropsPrototype(componentClass, extensions) {
    let cacheKey = $6f3d790fb58d63a4$var$MergedDefaultPropsCacheKey;
    if (extensions) for (const extension of extensions){
        const ExtensionClass = extension.constructor;
        if (ExtensionClass) cacheKey += ":".concat(ExtensionClass.extensionName || ExtensionClass.name);
    }
    const defaultProps = $6f3d790fb58d63a4$var$getOwnProperty(componentClass, cacheKey);
    if (!defaultProps) return componentClass[cacheKey] = $6f3d790fb58d63a4$var$createPropsPrototypeAndTypes(componentClass, extensions || []);
    return defaultProps;
}
function $6f3d790fb58d63a4$var$createPropsPrototypeAndTypes(componentClass, extensions) {
    const parent = componentClass.prototype;
    if (!parent) return null;
    const parentClass = Object.getPrototypeOf(componentClass);
    const parentDefaultProps = $6f3d790fb58d63a4$var$getPropsPrototype(parentClass);
    const componentDefaultProps = $6f3d790fb58d63a4$var$getOwnProperty(componentClass, "defaultProps") || {};
    const componentPropDefs = (0, $ewpcq.parsePropTypes)(componentDefaultProps);
    const defaultProps = Object.assign(Object.create(null), parentDefaultProps, componentPropDefs.defaultProps);
    const propTypes = Object.assign(Object.create(null), parentDefaultProps === null || parentDefaultProps === void 0 ? void 0 : parentDefaultProps[0, $lXg0j.PROP_TYPES_SYMBOL], componentPropDefs.propTypes);
    const deprecatedProps = Object.assign(Object.create(null), parentDefaultProps === null || parentDefaultProps === void 0 ? void 0 : parentDefaultProps[0, $lXg0j.DEPRECATED_PROPS_SYMBOL], componentPropDefs.deprecatedProps);
    for (const extension of extensions){
        const extensionDefaultProps = $6f3d790fb58d63a4$var$getPropsPrototype(extension.constructor);
        if (extensionDefaultProps) {
            Object.assign(defaultProps, extensionDefaultProps);
            Object.assign(propTypes, extensionDefaultProps[0, $lXg0j.PROP_TYPES_SYMBOL]);
            Object.assign(deprecatedProps, extensionDefaultProps[0, $lXg0j.DEPRECATED_PROPS_SYMBOL]);
        }
    }
    $6f3d790fb58d63a4$var$createPropsPrototype(defaultProps, componentClass);
    $6f3d790fb58d63a4$var$addAsyncPropsToPropPrototype(defaultProps, propTypes);
    $6f3d790fb58d63a4$var$addDeprecatedPropsToPropPrototype(defaultProps, deprecatedProps);
    defaultProps[0, $lXg0j.PROP_TYPES_SYMBOL] = propTypes;
    defaultProps[0, $lXg0j.DEPRECATED_PROPS_SYMBOL] = deprecatedProps;
    if (extensions.length === 0 && !$6f3d790fb58d63a4$var$hasOwnProperty(componentClass, "_propTypes")) componentClass._propTypes = propTypes;
    return defaultProps;
}
function $6f3d790fb58d63a4$var$createPropsPrototype(defaultProps, componentClass) {
    const id = $6f3d790fb58d63a4$var$getComponentName(componentClass);
    Object.defineProperties(defaultProps, {
        id: {
            writable: true,
            value: id
        }
    });
}
function $6f3d790fb58d63a4$var$addDeprecatedPropsToPropPrototype(defaultProps, deprecatedProps) {
    for(const propName in deprecatedProps)Object.defineProperty(defaultProps, propName, {
        enumerable: false,
        set (newValue) {
            const nameStr = "".concat(this.id, ": ").concat(propName);
            for (const newPropName of deprecatedProps[propName])if (!$6f3d790fb58d63a4$var$hasOwnProperty(this, newPropName)) this[newPropName] = newValue;
            (0, $4VQgq.default).deprecated(nameStr, deprecatedProps[propName].join("/"))();
        }
    });
}
function $6f3d790fb58d63a4$var$addAsyncPropsToPropPrototype(defaultProps, propTypes) {
    const defaultValues = {};
    const descriptors = {};
    for(const propName in propTypes){
        const propType = propTypes[propName];
        const { name: name, value: value } = propType;
        if (propType.async) {
            defaultValues[name] = value;
            descriptors[name] = $6f3d790fb58d63a4$var$getDescriptorForAsyncProp(name);
        }
    }
    defaultProps[0, $lXg0j.ASYNC_DEFAULTS_SYMBOL] = defaultValues;
    defaultProps[0, $lXg0j.ASYNC_ORIGINAL_SYMBOL] = {};
    Object.defineProperties(defaultProps, descriptors);
}
function $6f3d790fb58d63a4$var$getDescriptorForAsyncProp(name) {
    return {
        enumerable: true,
        set (newValue) {
            if (typeof newValue === "string" || newValue instanceof Promise || (0, $abpME.isAsyncIterable)(newValue)) this[0, $lXg0j.ASYNC_ORIGINAL_SYMBOL][name] = newValue;
            else this[0, $lXg0j.ASYNC_RESOLVED_SYMBOL][name] = newValue;
        },
        get () {
            if (this[0, $lXg0j.ASYNC_RESOLVED_SYMBOL]) {
                if (name in this[0, $lXg0j.ASYNC_RESOLVED_SYMBOL]) {
                    const value = this[0, $lXg0j.ASYNC_RESOLVED_SYMBOL][name];
                    return value || this[0, $lXg0j.ASYNC_DEFAULTS_SYMBOL][name];
                }
                if (name in this[0, $lXg0j.ASYNC_ORIGINAL_SYMBOL]) {
                    const state = this[0, $lXg0j.COMPONENT_SYMBOL] && this[0, $lXg0j.COMPONENT_SYMBOL].internalState;
                    if (state && state.hasAsyncProp(name)) return state.getAsyncProp(name) || this[0, $lXg0j.ASYNC_DEFAULTS_SYMBOL][name];
                }
            }
            return this[0, $lXg0j.ASYNC_DEFAULTS_SYMBOL][name];
        }
    };
}
function $6f3d790fb58d63a4$var$hasOwnProperty(object, prop) {
    return Object.prototype.hasOwnProperty.call(object, prop);
}
function $6f3d790fb58d63a4$var$getOwnProperty(object, prop) {
    return $6f3d790fb58d63a4$var$hasOwnProperty(object, prop) && object[prop];
}
function $6f3d790fb58d63a4$var$getComponentName(componentClass) {
    const componentName = componentClass.componentName;
    if (!componentName) (0, $4VQgq.default).warn("".concat(componentClass.name, ".componentName not specified"))();
    return componentName || componentClass.name;
}

});
parcelRegister("ewpcq", function(module, exports) {

$parcel$export(module.exports, "parsePropTypes", function () { return $a92799eb484b7544$export$6335b16489944934; });

var $2QP2i = parcelRequire("2QP2i");

var $79r96 = parcelRequire("79r96");

var $lLwj3 = parcelRequire("lLwj3");
const $a92799eb484b7544$var$TYPE_DEFINITIONS = {
    boolean: {
        validate (value, propType) {
            return true;
        },
        equal (value1, value2, propType) {
            return Boolean(value1) === Boolean(value2);
        }
    },
    number: {
        validate (value, propType) {
            return Number.isFinite(value) && (!("max" in propType) || value <= propType.max) && (!("min" in propType) || value >= propType.min);
        }
    },
    color: {
        validate (value, propType) {
            return propType.optional && !value || $a92799eb484b7544$var$isArray(value) && (value.length === 3 || value.length === 4);
        },
        equal (value1, value2, propType) {
            return (0, $lLwj3.deepEqual)(value1, value2, 1);
        }
    },
    accessor: {
        validate (value, propType) {
            const valueType = $a92799eb484b7544$var$getTypeOf(value);
            return valueType === "function" || valueType === $a92799eb484b7544$var$getTypeOf(propType.value);
        },
        equal (value1, value2, propType) {
            if (typeof value2 === "function") return true;
            return (0, $lLwj3.deepEqual)(value1, value2, 1);
        }
    },
    array: {
        validate (value, propType) {
            return propType.optional && !value || $a92799eb484b7544$var$isArray(value);
        },
        equal (value1, value2, propType) {
            const { compare: compare } = propType;
            const depth = Number.isInteger(compare) ? compare : compare ? 1 : 0;
            return compare ? (0, $lLwj3.deepEqual)(value1, value2, depth) : value1 === value2;
        }
    },
    object: {
        equal (value1, value2, propType) {
            if (propType.ignore) return true;
            const { compare: compare } = propType;
            const depth = Number.isInteger(compare) ? compare : compare ? 1 : 0;
            return compare ? (0, $lLwj3.deepEqual)(value1, value2, depth) : value1 === value2;
        }
    },
    function: {
        validate (value, propType) {
            return propType.optional && !value || typeof value === "function";
        },
        equal (value1, value2, propType) {
            const shouldIgnore = !propType.compare && propType.ignore !== false;
            return shouldIgnore || value1 === value2;
        }
    },
    data: {
        transform: (value, propType, component)=>{
            const { dataTransform: dataTransform } = component.props;
            return dataTransform && value ? dataTransform(value) : value;
        }
    },
    image: {
        transform: (value, propType, component)=>{
            const context = component.context;
            if (!context || !context.gl) return null;
            return (0, $79r96.createTexture)(component.id, context.gl, value, (0, $2QP2i._)({}, propType.parameters, component.props.textureParameters));
        },
        release: (value, propType, component)=>{
            (0, $79r96.destroyTexture)(component.id, value);
        }
    }
};
function $a92799eb484b7544$export$6335b16489944934(propDefs) {
    const propTypes = {};
    const defaultProps = {};
    const deprecatedProps = {};
    for (const [propName, propDef] of Object.entries(propDefs)){
        const deprecated = propDef === null || propDef === void 0 ? void 0 : propDef.deprecatedFor;
        if (deprecated) deprecatedProps[propName] = Array.isArray(deprecated) ? deprecated : [
            deprecated
        ];
        else {
            const propType = $a92799eb484b7544$var$parsePropType(propName, propDef);
            propTypes[propName] = propType;
            defaultProps[propName] = propType.value;
        }
    }
    return {
        propTypes: propTypes,
        defaultProps: defaultProps,
        deprecatedProps: deprecatedProps
    };
}
function $a92799eb484b7544$var$parsePropType(name, propDef) {
    switch($a92799eb484b7544$var$getTypeOf(propDef)){
        case "object":
            return $a92799eb484b7544$var$normalizePropDefinition(name, propDef);
        case "array":
            return $a92799eb484b7544$var$normalizePropDefinition(name, {
                type: "array",
                value: propDef,
                compare: false
            });
        case "boolean":
            return $a92799eb484b7544$var$normalizePropDefinition(name, {
                type: "boolean",
                value: propDef
            });
        case "number":
            return $a92799eb484b7544$var$normalizePropDefinition(name, {
                type: "number",
                value: propDef
            });
        case "function":
            return $a92799eb484b7544$var$normalizePropDefinition(name, {
                type: "function",
                value: propDef,
                compare: true
            });
        default:
            return {
                name: name,
                type: "unknown",
                value: propDef
            };
    }
}
function $a92799eb484b7544$var$normalizePropDefinition(name, propDef) {
    if (!("type" in propDef)) {
        if (!("value" in propDef)) return {
            name: name,
            type: "object",
            value: propDef
        };
        return (0, $2QP2i._)({
            name: name,
            type: $a92799eb484b7544$var$getTypeOf(propDef.value)
        }, propDef);
    }
    return (0, $2QP2i._)({
        name: name
    }, $a92799eb484b7544$var$TYPE_DEFINITIONS[propDef.type], propDef);
}
function $a92799eb484b7544$var$isArray(value) {
    return Array.isArray(value) || ArrayBuffer.isView(value);
}
function $a92799eb484b7544$var$getTypeOf(value) {
    if ($a92799eb484b7544$var$isArray(value)) return "array";
    if (value === null) return "null";
    return typeof value;
}

});
parcelRegister("79r96", function(module, exports) {

$parcel$export(module.exports, "createTexture", function () { return $534e6e480a78c06f$export$37b981a8c575f415; });
$parcel$export(module.exports, "destroyTexture", function () { return $534e6e480a78c06f$export$2ec81868286b17e6; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $7lUAH = parcelRequire("7lUAH");
const $534e6e480a78c06f$var$DEFAULT_TEXTURE_PARAMETERS = {
    [10241]: 9987,
    [10240]: 9729,
    [10242]: 33071,
    [10243]: 33071
};
const $534e6e480a78c06f$var$internalTextures = {};
function $534e6e480a78c06f$export$37b981a8c575f415(owner, gl, image, parameters) {
    if (image instanceof (0, $7lUAH.default)) return image;
    else if (image.constructor && image.constructor.name !== "Object") image = {
        data: image
    };
    let specialTextureParameters = null;
    if (image.compressed) specialTextureParameters = {
        [10241]: image.data.length > 1 ? 9985 : 9729
    };
    const texture = new (0, $7lUAH.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, image), {
        parameters: (0, $2QP2i._)({}, $534e6e480a78c06f$var$DEFAULT_TEXTURE_PARAMETERS, specialTextureParameters, parameters)
    }));
    $534e6e480a78c06f$var$internalTextures[texture.id] = owner;
    return texture;
}
function $534e6e480a78c06f$export$2ec81868286b17e6(owner, texture) {
    if (!texture || !(texture instanceof (0, $7lUAH.default))) return;
    if ($534e6e480a78c06f$var$internalTextures[texture.id] === owner) {
        texture.delete();
        delete $534e6e480a78c06f$var$internalTextures[texture.id];
    }
}

});

parcelRegister("lLwj3", function(module, exports) {

$parcel$export(module.exports, "deepEqual", function () { return $fd870c19bbeef9ea$export$9cb4719e2e525b7a; });
function $fd870c19bbeef9ea$export$9cb4719e2e525b7a(a, b, depth) {
    if (a === b) return true;
    if (!depth || !a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$fd870c19bbeef9ea$export$9cb4719e2e525b7a(a[i], b[i], depth - 1)) return false;
        }
        return true;
    }
    if (Array.isArray(b)) return false;
    if (typeof a === "object" && typeof b === "object") {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$fd870c19bbeef9ea$export$9cb4719e2e525b7a(a[key], b[key], depth - 1)) return false;
        }
        return true;
    }
    return false;
}

});




parcelRegister("5UhUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d01292c58fa20a$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");

var $4nfzm = parcelRequire("4nfzm");
class $44d01292c58fa20a$export$2e2bcd8739ae039 extends (0, $4nfzm.default) {
    get layer() {
        return this.component;
    }
    _fetch(propName, url) {
        const layer = this.layer;
        const fetch = layer === null || layer === void 0 ? void 0 : layer.props.fetch;
        if (fetch) return fetch(url, {
            propName: propName,
            layer: layer
        });
        return super._fetch(propName, url);
    }
    _onResolve(propName, value) {
        const layer = this.layer;
        if (layer) {
            const onDataLoad = layer.props.onDataLoad;
            if (propName === "data" && onDataLoad) onDataLoad(value, {
                propName: propName,
                layer: layer
            });
        }
    }
    _onError(propName, error) {
        const layer = this.layer;
        if (layer) layer.raiseError(error, "loading ".concat(propName, " of ").concat(this.layer));
    }
    constructor({ attributeManager: attributeManager, layer: layer }){
        super(layer);
        (0, $1zR3q.default)(this, "attributeManager", void 0);
        (0, $1zR3q.default)(this, "needsRedraw", void 0);
        (0, $1zR3q.default)(this, "needsUpdate", void 0);
        (0, $1zR3q.default)(this, "subLayers", void 0);
        (0, $1zR3q.default)(this, "usesPickingColorCache", void 0);
        (0, $1zR3q.default)(this, "hasPickingBuffer", void 0);
        (0, $1zR3q.default)(this, "changeFlags", void 0);
        (0, $1zR3q.default)(this, "viewport", void 0);
        (0, $1zR3q.default)(this, "uniformTransitions", void 0);
        (0, $1zR3q.default)(this, "propsInTransition", void 0);
        this.attributeManager = attributeManager;
        this.needsRedraw = true;
        this.needsUpdate = true;
        this.subLayers = null;
        this.usesPickingColorCache = false;
    }
}

});
parcelRegister("4nfzm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32f56320eaddaf36$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");

var $abpME = parcelRequire("abpME");

var $lXg0j = parcelRequire("lXg0j");
const $32f56320eaddaf36$var$EMPTY_PROPS = Object.freeze({});
class $32f56320eaddaf36$export$2e2bcd8739ae039 {
    finalize() {
        for(const propName in this.asyncProps){
            const asyncProp = this.asyncProps[propName];
            if (asyncProp && asyncProp.type && asyncProp.type.release) asyncProp.type.release(asyncProp.resolvedValue, asyncProp.type, this.component);
        }
        this.asyncProps = {};
        this.component = null;
        this.resetOldProps();
    }
    getOldProps() {
        return this.oldAsyncProps || this.oldProps || $32f56320eaddaf36$var$EMPTY_PROPS;
    }
    resetOldProps() {
        this.oldAsyncProps = null;
        this.oldProps = this.component ? this.component.props : null;
    }
    hasAsyncProp(propName) {
        return propName in this.asyncProps;
    }
    getAsyncProp(propName) {
        const asyncProp = this.asyncProps[propName];
        return asyncProp && asyncProp.resolvedValue;
    }
    isAsyncPropLoading(propName) {
        if (propName) {
            const asyncProp = this.asyncProps[propName];
            return Boolean(asyncProp && asyncProp.pendingLoadCount > 0 && asyncProp.pendingLoadCount !== asyncProp.resolvedLoadCount);
        }
        for(const key in this.asyncProps){
            if (this.isAsyncPropLoading(key)) return true;
        }
        return false;
    }
    reloadAsyncProp(propName, value) {
        this._watchPromise(propName, Promise.resolve(value));
    }
    setAsyncProps(props) {
        this.component = props[0, $lXg0j.COMPONENT_SYMBOL] || this.component;
        const resolvedValues = props[0, $lXg0j.ASYNC_RESOLVED_SYMBOL] || {};
        const originalValues = props[0, $lXg0j.ASYNC_ORIGINAL_SYMBOL] || props;
        const defaultValues = props[0, $lXg0j.ASYNC_DEFAULTS_SYMBOL] || {};
        for(const propName in resolvedValues){
            const value = resolvedValues[propName];
            this._createAsyncPropData(propName, defaultValues[propName]);
            this._updateAsyncProp(propName, value);
            resolvedValues[propName] = this.getAsyncProp(propName);
        }
        for(const propName in originalValues){
            const value = originalValues[propName];
            this._createAsyncPropData(propName, defaultValues[propName]);
            this._updateAsyncProp(propName, value);
        }
    }
    _fetch(propName, url) {
        return null;
    }
    _onResolve(propName, value) {}
    _onError(propName, error) {}
    _updateAsyncProp(propName, value) {
        if (!this._didAsyncInputValueChange(propName, value)) return;
        if (typeof value === "string") value = this._fetch(propName, value);
        if (value instanceof Promise) {
            this._watchPromise(propName, value);
            return;
        }
        if ((0, $abpME.isAsyncIterable)(value)) {
            this._resolveAsyncIterable(propName, value);
            return;
        }
        this._setPropValue(propName, value);
    }
    _freezeAsyncOldProps() {
        if (!this.oldAsyncProps && this.oldProps) {
            this.oldAsyncProps = Object.create(this.oldProps);
            for(const propName in this.asyncProps)Object.defineProperty(this.oldAsyncProps, propName, {
                enumerable: true,
                value: this.oldProps[propName]
            });
        }
    }
    _didAsyncInputValueChange(propName, value) {
        const asyncProp = this.asyncProps[propName];
        if (value === asyncProp.resolvedValue || value === asyncProp.lastValue) return false;
        asyncProp.lastValue = value;
        return true;
    }
    _setPropValue(propName, value) {
        this._freezeAsyncOldProps();
        const asyncProp = this.asyncProps[propName];
        if (asyncProp) {
            value = this._postProcessValue(asyncProp, value);
            asyncProp.resolvedValue = value;
            asyncProp.pendingLoadCount++;
            asyncProp.resolvedLoadCount = asyncProp.pendingLoadCount;
        }
    }
    _setAsyncPropValue(propName, value, loadCount) {
        const asyncProp = this.asyncProps[propName];
        if (asyncProp && loadCount >= asyncProp.resolvedLoadCount && value !== undefined) {
            this._freezeAsyncOldProps();
            asyncProp.resolvedValue = value;
            asyncProp.resolvedLoadCount = loadCount;
            this.onAsyncPropUpdated(propName, value);
        }
    }
    _watchPromise(propName, promise) {
        const asyncProp = this.asyncProps[propName];
        if (asyncProp) {
            asyncProp.pendingLoadCount++;
            const loadCount = asyncProp.pendingLoadCount;
            promise.then((data)=>{
                if (!this.component) return;
                data = this._postProcessValue(asyncProp, data);
                this._setAsyncPropValue(propName, data, loadCount);
                this._onResolve(propName, data);
            }).catch((error)=>{
                this._onError(propName, error);
            });
        }
    }
    async _resolveAsyncIterable(propName, iterable) {
        if (propName !== "data") {
            this._setPropValue(propName, iterable);
            return;
        }
        const asyncProp = this.asyncProps[propName];
        if (!asyncProp) return;
        asyncProp.pendingLoadCount++;
        const loadCount = asyncProp.pendingLoadCount;
        let data = [];
        let count = 0;
        for await (const chunk of iterable){
            if (!this.component) return;
            const { dataTransform: dataTransform } = this.component.props;
            if (dataTransform) data = dataTransform(chunk, data);
            else data = data.concat(chunk);
            Object.defineProperty(data, "__diff", {
                enumerable: false,
                value: [
                    {
                        startRow: count,
                        endRow: data.length
                    }
                ]
            });
            count = data.length;
            this._setAsyncPropValue(propName, data, loadCount);
        }
        this._onResolve(propName, data);
    }
    _postProcessValue(asyncProp, value) {
        const propType = asyncProp.type;
        if (propType && this.component) {
            if (propType.release) propType.release(asyncProp.resolvedValue, propType, this.component);
            if (propType.transform) return propType.transform(value, propType, this.component);
        }
        return value;
    }
    _createAsyncPropData(propName, defaultValue) {
        const asyncProp = this.asyncProps[propName];
        if (!asyncProp) {
            const propTypes = this.component && this.component.props[0, $lXg0j.PROP_TYPES_SYMBOL];
            this.asyncProps[propName] = {
                type: propTypes && propTypes[propName],
                lastValue: null,
                resolvedValue: defaultValue,
                pendingLoadCount: 0,
                resolvedLoadCount: 0
            };
        }
    }
    constructor(component){
        (0, $1zR3q.default)(this, "component", void 0);
        (0, $1zR3q.default)(this, "onAsyncPropUpdated", void 0);
        (0, $1zR3q.default)(this, "asyncProps", void 0);
        (0, $1zR3q.default)(this, "oldProps", void 0);
        (0, $1zR3q.default)(this, "oldAsyncProps", void 0);
        this.component = component;
        this.asyncProps = {};
        this.onAsyncPropUpdated = ()=>{};
        this.oldProps = null;
        this.oldAsyncProps = null;
    }
}

});


parcelRegister("ewlwV", function(module, exports) {

$parcel$export(module.exports, "load", function () { return $a924c13f2eeca3d7$export$11e63f7b0f3d9900; });

var $coI4l = parcelRequire("coI4l");

var $vyOkv = parcelRequire("vyOkv");

var $j9Kyb = parcelRequire("j9Kyb");

var $a2G5Q = parcelRequire("a2G5Q");
async function $a924c13f2eeca3d7$export$11e63f7b0f3d9900(url, loaders, options, context) {
    if (!Array.isArray(loaders) && !(0, $vyOkv.isLoaderObject)(loaders)) {
        context = undefined;
        options = loaders;
        loaders = undefined;
    }
    const fetch = (0, $j9Kyb.getFetchFunction)(options);
    let data = url;
    if (typeof url === "string") data = await fetch(url);
    if ((0, $coI4l.isBlob)(url)) data = await fetch(url);
    return await (0, $a2G5Q.parse)(data, loaders, options);
}

});
parcelRegister("coI4l", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $9069e91c21caafa0$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPureObject", function () { return $9069e91c21caafa0$export$e219791d2b49856; });
$parcel$export(module.exports, "isIterable", function () { return $9069e91c21caafa0$export$9652023d9040757; });
$parcel$export(module.exports, "isAsyncIterable", function () { return $9069e91c21caafa0$export$edb10ab8dd75a915; });
$parcel$export(module.exports, "isIterator", function () { return $9069e91c21caafa0$export$50db6e277db66ea0; });
$parcel$export(module.exports, "isResponse", function () { return $9069e91c21caafa0$export$3f1eb41d9a6a6a27; });
$parcel$export(module.exports, "isBlob", function () { return $9069e91c21caafa0$export$5bcd6e94ed871c88; });
$parcel$export(module.exports, "isBuffer", function () { return $9069e91c21caafa0$export$a7884ebc965f8f54; });
$parcel$export(module.exports, "isReadableStream", function () { return $9069e91c21caafa0$export$ac613ff475b69d05; });
const $9069e91c21caafa0$var$isBoolean = (x)=>typeof x === "boolean";
const $9069e91c21caafa0$var$isFunction = (x)=>typeof x === "function";
const $9069e91c21caafa0$export$a6cdc56e425d0d0a = (x)=>x !== null && typeof x === "object";
const $9069e91c21caafa0$export$e219791d2b49856 = (x)=>$9069e91c21caafa0$export$a6cdc56e425d0d0a(x) && x.constructor === ({}).constructor;
const $9069e91c21caafa0$export$4369c812aac99591 = (x)=>$9069e91c21caafa0$export$a6cdc56e425d0d0a(x) && $9069e91c21caafa0$var$isFunction(x.then);
const $9069e91c21caafa0$export$9652023d9040757 = (x)=>x && typeof x[Symbol.iterator] === "function";
const $9069e91c21caafa0$export$edb10ab8dd75a915 = (x)=>x && typeof x[Symbol.asyncIterator] === "function";
const $9069e91c21caafa0$export$50db6e277db66ea0 = (x)=>x && $9069e91c21caafa0$var$isFunction(x.next);
const $9069e91c21caafa0$export$3f1eb41d9a6a6a27 = (x)=>typeof Response !== "undefined" && x instanceof Response || x && x.arrayBuffer && x.text && x.json;
const $9069e91c21caafa0$export$be78b3111c50efdd = (x)=>typeof File !== "undefined" && x instanceof File;
const $9069e91c21caafa0$export$5bcd6e94ed871c88 = (x)=>typeof Blob !== "undefined" && x instanceof Blob;
const $9069e91c21caafa0$export$a7884ebc965f8f54 = (x)=>x && typeof x === "object" && x.isBuffer;
const $9069e91c21caafa0$export$5536d41d90245d51 = (x)=>$9069e91c21caafa0$export$a6cdc56e425d0d0a(x) && $9069e91c21caafa0$var$isFunction(x.abort) && $9069e91c21caafa0$var$isFunction(x.getWriter);
const $9069e91c21caafa0$export$f8bb1f6b773199b7 = (x)=>typeof ReadableStream !== "undefined" && x instanceof ReadableStream || $9069e91c21caafa0$export$a6cdc56e425d0d0a(x) && $9069e91c21caafa0$var$isFunction(x.tee) && $9069e91c21caafa0$var$isFunction(x.cancel) && $9069e91c21caafa0$var$isFunction(x.getReader);
const $9069e91c21caafa0$export$eec1f46c8eef21a4 = (x)=>$9069e91c21caafa0$export$a6cdc56e425d0d0a(x) && $9069e91c21caafa0$var$isFunction(x.end) && $9069e91c21caafa0$var$isFunction(x.write) && $9069e91c21caafa0$var$isBoolean(x.writable);
const $9069e91c21caafa0$export$2940183a2d5db90f = (x)=>$9069e91c21caafa0$export$a6cdc56e425d0d0a(x) && $9069e91c21caafa0$var$isFunction(x.read) && $9069e91c21caafa0$var$isFunction(x.pipe) && $9069e91c21caafa0$var$isBoolean(x.readable);
const $9069e91c21caafa0$export$ac613ff475b69d05 = (x)=>$9069e91c21caafa0$export$f8bb1f6b773199b7(x) || $9069e91c21caafa0$export$2940183a2d5db90f(x);
const $9069e91c21caafa0$export$b58a61c52edb4f66 = (x)=>$9069e91c21caafa0$export$5536d41d90245d51(x) || $9069e91c21caafa0$export$eec1f46c8eef21a4(x);

});

parcelRegister("vyOkv", function(module, exports) {

$parcel$export(module.exports, "isLoaderObject", function () { return $05ede60f13427040$export$2db07da082dd07a7; });
$parcel$export(module.exports, "normalizeLoader", function () { return $05ede60f13427040$export$a19b0af95f3585f1; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $be06P = parcelRequire("be06P");
function $05ede60f13427040$export$2db07da082dd07a7(loader) {
    var _loader;
    if (!loader) return false;
    if (Array.isArray(loader)) loader = loader[0];
    const hasExtensions = Array.isArray((_loader = loader) === null || _loader === void 0 ? void 0 : _loader.extensions);
    return hasExtensions;
}
function $05ede60f13427040$export$a19b0af95f3585f1(loader) {
    var _loader2, _loader3;
    (0, $be06P.assert)(loader, "null loader");
    (0, $be06P.assert)($05ede60f13427040$export$2db07da082dd07a7(loader), "invalid loader");
    let options;
    if (Array.isArray(loader)) {
        options = loader[1];
        loader = loader[0];
        loader = (0, $edHbI._)((0, $2QP2i._)({}, loader), {
            options: (0, $2QP2i._)({}, loader.options, options)
        });
    }
    if ((_loader2 = loader) !== null && _loader2 !== void 0 && _loader2.parseTextSync || (_loader3 = loader) !== null && _loader3 !== void 0 && _loader3.parseText) loader.text = true;
    if (!loader.text) loader.binary = true;
    return loader;
}

});
parcelRegister("be06P", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $82c1162fa930cb52$export$a7a9523472993e97; });
function $82c1162fa930cb52$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "loader assertion failed.");
}

});


parcelRegister("j9Kyb", function(module, exports) {

$parcel$export(module.exports, "getFetchFunction", function () { return $df22f77e66eddbd9$export$9b973e0eff85009f; });

var $coI4l = parcelRequire("coI4l");

var $4OY7P = parcelRequire("4OY7P");

var $8mcNl = parcelRequire("8mcNl");
function $df22f77e66eddbd9$export$9b973e0eff85009f(options, context) {
    const globalOptions = (0, $8mcNl.getGlobalLoaderOptions)();
    const fetchOptions = options || globalOptions;
    if (typeof fetchOptions.fetch === "function") return fetchOptions.fetch;
    if ((0, $coI4l.isObject)(fetchOptions.fetch)) return (url)=>(0, $4OY7P.fetchFile)(url, fetchOptions);
    if (context !== null && context !== void 0 && context.fetch) return context === null || context === void 0 ? void 0 : context.fetch;
    return 0, $4OY7P.fetchFile;
}

});
parcelRegister("4OY7P", function(module, exports) {

$parcel$export(module.exports, "fetchFile", function () { return $382a788fedc928dc$export$d965bcb23f9d06c5; });

var $c56Kn = parcelRequire("c56Kn");

var $iQYNB = parcelRequire("iQYNB");
async function $382a788fedc928dc$export$d965bcb23f9d06c5(url, options) {
    if (typeof url === "string") {
        url = (0, $c56Kn.resolvePath)(url);
        let fetchOptions = options;
        if (options !== null && options !== void 0 && options.fetch && typeof (options === null || options === void 0 ? void 0 : options.fetch) !== "function") fetchOptions = options.fetch;
        return await fetch(url, fetchOptions);
    }
    return await (0, $iQYNB.makeResponse)(url);
}

});
parcelRegister("c56Kn", function(module, exports) {

$parcel$export(module.exports, "resolvePath", function () { return $8cbb2f7ec9cb0fcd$export$b09f2ff0bbcb43c7; });
let $8cbb2f7ec9cb0fcd$var$pathPrefix = "";
const $8cbb2f7ec9cb0fcd$var$fileAliases = {};
function $8cbb2f7ec9cb0fcd$export$fa7cbeea6a0f8cd3(prefix) {
    $8cbb2f7ec9cb0fcd$var$pathPrefix = prefix;
}
function $8cbb2f7ec9cb0fcd$export$e21ff368c7512d8e() {
    return $8cbb2f7ec9cb0fcd$var$pathPrefix;
}
function $8cbb2f7ec9cb0fcd$export$65b32f70101f5674(aliases) {
    Object.assign($8cbb2f7ec9cb0fcd$var$fileAliases, aliases);
}
function $8cbb2f7ec9cb0fcd$export$b09f2ff0bbcb43c7(filename) {
    for(const alias in $8cbb2f7ec9cb0fcd$var$fileAliases)if (filename.startsWith(alias)) {
        const replacement = $8cbb2f7ec9cb0fcd$var$fileAliases[alias];
        filename = filename.replace(alias, replacement);
    }
    if (!filename.startsWith("http://") && !filename.startsWith("https://")) filename = "".concat($8cbb2f7ec9cb0fcd$var$pathPrefix).concat(filename);
    return filename;
}

});

parcelRegister("iQYNB", function(module, exports) {

$parcel$export(module.exports, "makeResponse", function () { return $db9c3ec0b2bb2fc7$export$16d84ad959da5112; });
$parcel$export(module.exports, "checkResponse", function () { return $db9c3ec0b2bb2fc7$export$5db0ad607ce3410b; });

var $coI4l = parcelRequire("coI4l");

var $l6GmM = parcelRequire("l6GmM");
async function $db9c3ec0b2bb2fc7$export$16d84ad959da5112(resource) {
    if ((0, $coI4l.isResponse)(resource)) return resource;
    const headers = {};
    const contentLength = (0, $l6GmM.getResourceContentLength)(resource);
    if (contentLength >= 0) headers["content-length"] = String(contentLength);
    const url = (0, $l6GmM.getResourceUrl)(resource);
    const type = (0, $l6GmM.getResourceMIMEType)(resource);
    if (type) headers["content-type"] = type;
    const initialDataUrl = await $db9c3ec0b2bb2fc7$var$getInitialDataUrl(resource);
    if (initialDataUrl) headers["x-first-bytes"] = initialDataUrl;
    if (typeof resource === "string") resource = new TextEncoder().encode(resource);
    const response = new Response(resource, {
        headers: headers
    });
    Object.defineProperty(response, "url", {
        value: url
    });
    return response;
}
async function $db9c3ec0b2bb2fc7$export$5db0ad607ce3410b(response) {
    if (!response.ok) {
        const message = await $db9c3ec0b2bb2fc7$var$getResponseError(response);
        throw new Error(message);
    }
}
function $db9c3ec0b2bb2fc7$export$ef46f094beca181f(response) {
    if (!response.ok) {
        let message = "".concat(response.status, " ").concat(response.statusText);
        message = message.length > 60 ? "".concat(message.slice(0, 60), "...") : message;
        throw new Error(message);
    }
}
async function $db9c3ec0b2bb2fc7$var$getResponseError(response) {
    let message = "Failed to fetch resource ".concat(response.url, " (").concat(response.status, "): ");
    try {
        const contentType = response.headers.get("Content-Type");
        let text = response.statusText;
        if (contentType.includes("application/json")) text += " ".concat(await response.text());
        message += text;
        message = message.length > 60 ? "".concat(message.slice(0, 60), "...") : message;
    } catch (error) {}
    return message;
}
async function $db9c3ec0b2bb2fc7$var$getInitialDataUrl(resource) {
    const INITIAL_DATA_LENGTH = 5;
    if (typeof resource === "string") return "data:,".concat(resource.slice(0, INITIAL_DATA_LENGTH));
    if (resource instanceof Blob) {
        const blobSlice = resource.slice(0, 5);
        return await new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onload = (event)=>{
                var _event$target;
                return resolve(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result);
            };
            reader.readAsDataURL(blobSlice);
        });
    }
    if (resource instanceof ArrayBuffer) {
        const slice = resource.slice(0, INITIAL_DATA_LENGTH);
        const base64 = $db9c3ec0b2bb2fc7$var$arrayBufferToBase64(slice);
        return "data:base64,".concat(base64);
    }
    return null;
}
function $db9c3ec0b2bb2fc7$var$arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    for(let i = 0; i < bytes.byteLength; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
}

});
parcelRegister("l6GmM", function(module, exports) {

$parcel$export(module.exports, "getResourceUrl", function () { return $f5db059adc3ceeaf$export$d2c227b690e4eb28; });
$parcel$export(module.exports, "getResourceMIMEType", function () { return $f5db059adc3ceeaf$export$2ac0091ac07fac5c; });
$parcel$export(module.exports, "getResourceContentLength", function () { return $f5db059adc3ceeaf$export$795ad0074e2d4d36; });

var $coI4l = parcelRequire("coI4l");

var $5w0eB = parcelRequire("5w0eB");

var $2z7S5 = parcelRequire("2z7S5");
function $f5db059adc3ceeaf$export$d2c227b690e4eb28(resource) {
    if ((0, $coI4l.isResponse)(resource)) {
        const response = resource;
        return response.url;
    }
    if ((0, $coI4l.isBlob)(resource)) {
        const blob = resource;
        return blob.name || "";
    }
    if (typeof resource === "string") return resource;
    return "";
}
function $f5db059adc3ceeaf$export$2ac0091ac07fac5c(resource) {
    if ((0, $coI4l.isResponse)(resource)) {
        const response = resource;
        const contentTypeHeader = response.headers.get("content-type") || "";
        const noQueryUrl = (0, $2z7S5.stripQueryString)(response.url);
        return (0, $5w0eB.parseMIMEType)(contentTypeHeader) || (0, $5w0eB.parseMIMETypeFromURL)(noQueryUrl);
    }
    if ((0, $coI4l.isBlob)(resource)) {
        const blob = resource;
        return blob.type || "";
    }
    if (typeof resource === "string") return (0, $5w0eB.parseMIMETypeFromURL)(resource);
    return "";
}
function $f5db059adc3ceeaf$export$795ad0074e2d4d36(resource) {
    if ((0, $coI4l.isResponse)(resource)) {
        const response = resource;
        return response.headers["content-length"] || -1;
    }
    if ((0, $coI4l.isBlob)(resource)) {
        const blob = resource;
        return blob.size;
    }
    if (typeof resource === "string") return resource.length;
    if (resource instanceof ArrayBuffer) return resource.byteLength;
    if (ArrayBuffer.isView(resource)) return resource.byteLength;
    return -1;
}

});
parcelRegister("5w0eB", function(module, exports) {

$parcel$export(module.exports, "parseMIMEType", function () { return $40401f77c7215319$export$85e6adb445fa3ef0; });
$parcel$export(module.exports, "parseMIMETypeFromURL", function () { return $40401f77c7215319$export$a8aa3005f5e6c533; });
const $40401f77c7215319$var$DATA_URL_PATTERN = /^data:([-\w.]+\/[-\w.+]+)(;|,)/;
const $40401f77c7215319$var$MIME_TYPE_PATTERN = /^([-\w.]+\/[-\w.+]+)/;
function $40401f77c7215319$export$85e6adb445fa3ef0(mimeString) {
    const matches = $40401f77c7215319$var$MIME_TYPE_PATTERN.exec(mimeString);
    if (matches) return matches[1];
    return mimeString;
}
function $40401f77c7215319$export$a8aa3005f5e6c533(url) {
    const matches = $40401f77c7215319$var$DATA_URL_PATTERN.exec(url);
    if (matches) return matches[1];
    return "";
}

});

parcelRegister("2z7S5", function(module, exports) {

$parcel$export(module.exports, "extractQueryString", function () { return $1de4f4bed3d6e61b$export$a2e5c8748fb0f45a; });
$parcel$export(module.exports, "stripQueryString", function () { return $1de4f4bed3d6e61b$export$7cd817681526d337; });
const $1de4f4bed3d6e61b$var$QUERY_STRING_PATTERN = /\?.*/;
function $1de4f4bed3d6e61b$export$a2e5c8748fb0f45a(url) {
    const matches = url.match($1de4f4bed3d6e61b$var$QUERY_STRING_PATTERN);
    return matches && matches[0];
}
function $1de4f4bed3d6e61b$export$7cd817681526d337(url) {
    return url.replace($1de4f4bed3d6e61b$var$QUERY_STRING_PATTERN, "");
}

});




parcelRegister("8mcNl", function(module, exports) {

$parcel$export(module.exports, "getGlobalLoaderState", function () { return $615a4d9fbe360c68$export$2a5c5f9d1a96dd63; });
$parcel$export(module.exports, "getGlobalLoaderOptions", function () { return $615a4d9fbe360c68$export$6b0f80053d2682ea; });
$parcel$export(module.exports, "normalizeOptions", function () { return $615a4d9fbe360c68$export$eb806c0b85b62f7a; });

var $2QP2i = parcelRequire("2QP2i");

var $coI4l = parcelRequire("coI4l");

var $dqw8x = parcelRequire("dqw8x");

var $1UJbQ = parcelRequire("1UJbQ");
function $615a4d9fbe360c68$export$2a5c5f9d1a96dd63() {
    globalThis.loaders = globalThis.loaders || {};
    const { loaders: loaders } = globalThis;
    loaders._state = loaders._state || {};
    return loaders._state;
}
const $615a4d9fbe360c68$export$6b0f80053d2682ea = ()=>{
    const state = $615a4d9fbe360c68$export$2a5c5f9d1a96dd63();
    state.globalOptions = state.globalOptions || (0, $2QP2i._)({}, (0, $1UJbQ.DEFAULT_LOADER_OPTIONS));
    return state.globalOptions;
};
function $615a4d9fbe360c68$export$545eb931aeddfa08(options) {
    const state = $615a4d9fbe360c68$export$2a5c5f9d1a96dd63();
    const globalOptions = $615a4d9fbe360c68$export$6b0f80053d2682ea();
    state.globalOptions = $615a4d9fbe360c68$var$normalizeOptionsInternal(globalOptions, options);
}
function $615a4d9fbe360c68$export$eb806c0b85b62f7a(options, loader, loaders, url) {
    loaders = loaders || [];
    loaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    $615a4d9fbe360c68$var$validateOptions(options, loaders);
    return $615a4d9fbe360c68$var$normalizeOptionsInternal(loader, options, url);
}
function $615a4d9fbe360c68$var$validateOptions(options, loaders) {
    $615a4d9fbe360c68$var$validateOptionsObject(options, null, (0, $1UJbQ.DEFAULT_LOADER_OPTIONS), (0, $1UJbQ.REMOVED_LOADER_OPTIONS), loaders);
    for (const loader of loaders){
        const idOptions = options && options[loader.id] || {};
        const loaderOptions = loader.options && loader.options[loader.id] || {};
        const deprecatedOptions = loader.deprecatedOptions && loader.deprecatedOptions[loader.id] || {};
        $615a4d9fbe360c68$var$validateOptionsObject(idOptions, loader.id, loaderOptions, deprecatedOptions, loaders);
    }
}
function $615a4d9fbe360c68$var$validateOptionsObject(options, id, defaultOptions, deprecatedOptions, loaders) {
    const loaderName = id || "Top level";
    const prefix = id ? "".concat(id, ".") : "";
    for(const key in options){
        const isSubOptions = !id && (0, $coI4l.isObject)(options[key]);
        const isBaseUriOption = key === "baseUri" && !id;
        const isWorkerUrlOption = key === "workerUrl" && id;
        if (!(key in defaultOptions) && !isBaseUriOption && !isWorkerUrlOption) {
            if (key in deprecatedOptions) (0, $dqw8x.probeLog).warn("".concat(loaderName, " loader option '").concat(prefix).concat(key, "' no longer supported, use '").concat(deprecatedOptions[key], "'"))();
            else if (!isSubOptions) {
                const suggestion = $615a4d9fbe360c68$var$findSimilarOption(key, loaders);
                (0, $dqw8x.probeLog).warn("".concat(loaderName, " loader option '").concat(prefix).concat(key, "' not recognized. ").concat(suggestion))();
            }
        }
    }
}
function $615a4d9fbe360c68$var$findSimilarOption(optionKey, loaders) {
    const lowerCaseOptionKey = optionKey.toLowerCase();
    let bestSuggestion = "";
    for (const loader of loaders)for(const key in loader.options){
        if (optionKey === key) return "Did you mean '".concat(loader.id, ".").concat(key, "'?");
        const lowerCaseKey = key.toLowerCase();
        const isPartialMatch = lowerCaseOptionKey.startsWith(lowerCaseKey) || lowerCaseKey.startsWith(lowerCaseOptionKey);
        if (isPartialMatch) bestSuggestion = bestSuggestion || "Did you mean '".concat(loader.id, ".").concat(key, "'?");
    }
    return bestSuggestion;
}
function $615a4d9fbe360c68$var$normalizeOptionsInternal(loader, options, url) {
    const loaderDefaultOptions = loader.options || {};
    const mergedOptions = (0, $2QP2i._)({}, loaderDefaultOptions);
    $615a4d9fbe360c68$var$addUrlOptions(mergedOptions, url);
    if (mergedOptions.log === null) mergedOptions.log = new (0, $dqw8x.NullLog)();
    $615a4d9fbe360c68$var$mergeNestedFields(mergedOptions, $615a4d9fbe360c68$export$6b0f80053d2682ea());
    $615a4d9fbe360c68$var$mergeNestedFields(mergedOptions, options);
    return mergedOptions;
}
function $615a4d9fbe360c68$var$mergeNestedFields(mergedOptions, options) {
    for(const key in options)if (key in options) {
        const value = options[key];
        if ((0, $coI4l.isPureObject)(value) && (0, $coI4l.isPureObject)(mergedOptions[key])) mergedOptions[key] = (0, $2QP2i._)({}, mergedOptions[key], options[key]);
        else mergedOptions[key] = options[key];
    }
}
function $615a4d9fbe360c68$var$addUrlOptions(options, url) {
    if (url && !("baseUri" in options)) options.baseUri = url;
}

});
parcelRegister("dqw8x", function(module, exports) {

$parcel$export(module.exports, "probeLog", function () { return $9c66a1c5341828ff$export$775acaacb88283c4; });
$parcel$export(module.exports, "NullLog", function () { return $9c66a1c5341828ff$export$c8151b0a106d0aae; });
$parcel$export(module.exports, "ConsoleLog", function () { return $9c66a1c5341828ff$export$b0d7de77e5ad708; });

var $dUfZf = parcelRequire("dUfZf");
parcelRequire("d0O9t");
var $dwYH5 = parcelRequire("dwYH5");
const $9c66a1c5341828ff$export$775acaacb88283c4 = new (0, $dwYH5.Log)({
    id: "loaders.gl"
});
class $9c66a1c5341828ff$export$c8151b0a106d0aae {
    log() {
        return ()=>{};
    }
    info() {
        return ()=>{};
    }
    warn() {
        return ()=>{};
    }
    error() {
        return ()=>{};
    }
}
class $9c66a1c5341828ff$export$b0d7de77e5ad708 {
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.console.log.bind(this.console, ...args);
    }
    info() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.console.info.bind(this.console, ...args);
    }
    warn() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.console.warn.bind(this.console, ...args);
    }
    error() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.console.error.bind(this.console, ...args);
    }
    constructor(){
        (0, $dUfZf.default)(this, "console", void 0);
        this.console = console;
    }
}

});
parcelRegister("dUfZf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1fce7fbc0c3e74c$export$2e2bcd8739ae039; });
function $a1fce7fbc0c3e74c$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("d0O9t", function(module, exports) {

$parcel$export(module.exports, "Log", function () { return (parcelRequire("dwYH5")).Log; });

var $dwYH5 = parcelRequire("dwYH5");






var $97922d8c29471b32$export$2e2bcd8739ae039 = new (0, $dwYH5.Log)({
    id: "@probe.gl/log"
});

});
parcelRegister("dwYH5", function(module, exports) {

$parcel$export(module.exports, "Log", function () { return $9d9d5814dd0cfbf0$export$ce30dbb46644d06c; });

var $i4pca = parcelRequire("i4pca");
var $9RnaI = parcelRequire("9RnaI");

var $7hRa7 = parcelRequire("7hRa7");

var $lKlb6 = parcelRequire("lKlb6");

var $39ODx = parcelRequire("39ODx");

var $7bpT1 = parcelRequire("7bpT1");

var $2qu0I = parcelRequire("2qu0I");

var $9mYXe = parcelRequire("9mYXe");
const $9d9d5814dd0cfbf0$var$originalConsole = {
    debug: (0, $i4pca.default)() ? console.debug || console.log : console.log,
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error
};
const $9d9d5814dd0cfbf0$var$DEFAULT_LOG_CONFIGURATION = {
    enabled: true,
    level: 0
};
function $9d9d5814dd0cfbf0$var$noop() {}
const $9d9d5814dd0cfbf0$var$cache = {};
const $9d9d5814dd0cfbf0$var$ONCE = {
    once: true
};
class $9d9d5814dd0cfbf0$export$ce30dbb46644d06c {
    set level(newLevel) {
        this.setLevel(newLevel);
    }
    get level() {
        return this.getLevel();
    }
    isEnabled() {
        return this._storage.config.enabled;
    }
    getLevel() {
        return this._storage.config.level;
    }
    getTotal() {
        return Number(((0, $9mYXe.getHiResTimestamp)() - this._startTs).toPrecision(10));
    }
    getDelta() {
        return Number(((0, $9mYXe.getHiResTimestamp)() - this._deltaTs).toPrecision(10));
    }
    set priority(newPriority) {
        this.level = newPriority;
    }
    get priority() {
        return this.level;
    }
    getPriority() {
        return this.level;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this._storage.setConfiguration({
            enabled: enabled
        });
        return this;
    }
    setLevel(level) {
        this._storage.setConfiguration({
            level: level
        });
        return this;
    }
    get(setting) {
        return this._storage.config[setting];
    }
    set(setting, value) {
        this._storage.setConfiguration({
            [setting]: value
        });
    }
    settings() {
        if (console.table) console.table(this._storage.config);
        else console.log(this._storage.config);
    }
    assert(condition, message) {
        (0, $2qu0I.default)(condition, message);
    }
    warn(message) {
        return this._getLogFunction(0, message, $9d9d5814dd0cfbf0$var$originalConsole.warn, arguments, $9d9d5814dd0cfbf0$var$ONCE);
    }
    error(message) {
        return this._getLogFunction(0, message, $9d9d5814dd0cfbf0$var$originalConsole.error, arguments);
    }
    deprecated(oldUsage, newUsage) {
        return this.warn("`".concat(oldUsage, "` is deprecated and will be removed in a later version. Use `").concat(newUsage, "` instead"));
    }
    removed(oldUsage, newUsage) {
        return this.error("`".concat(oldUsage, "` has been removed. Use `").concat(newUsage, "` instead"));
    }
    probe(logLevel, message) {
        return this._getLogFunction(logLevel, message, $9d9d5814dd0cfbf0$var$originalConsole.log, arguments, {
            time: true,
            once: true
        });
    }
    log(logLevel, message) {
        return this._getLogFunction(logLevel, message, $9d9d5814dd0cfbf0$var$originalConsole.debug, arguments);
    }
    info(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.info, arguments);
    }
    once(logLevel, message) {
        return this._getLogFunction(logLevel, message, $9d9d5814dd0cfbf0$var$originalConsole.debug || $9d9d5814dd0cfbf0$var$originalConsole.info, arguments, $9d9d5814dd0cfbf0$var$ONCE);
    }
    table(logLevel, table, columns) {
        if (table) return this._getLogFunction(logLevel, table, console.table || $9d9d5814dd0cfbf0$var$noop, columns && [
            columns
        ], {
            tag: $9d9d5814dd0cfbf0$var$getTableHeader(table)
        });
        return $9d9d5814dd0cfbf0$var$noop;
    }
    image(_ref) {
        let { logLevel: logLevel, priority: priority, image: image, message: message = "", scale: scale = 1 } = _ref;
        if (!this._shouldLog(logLevel || priority)) return $9d9d5814dd0cfbf0$var$noop;
        return (0, $i4pca.default)() ? $9d9d5814dd0cfbf0$var$logImageInBrowser({
            image: image,
            message: message,
            scale: scale
        }) : $9d9d5814dd0cfbf0$var$logImageInNode({
            image: image,
            message: message,
            scale: scale
        });
    }
    time(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.time ? console.time : console.info);
    }
    timeEnd(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeEnd ? console.timeEnd : console.info);
    }
    timeStamp(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeStamp || $9d9d5814dd0cfbf0$var$noop);
    }
    group(logLevel, message) {
        let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            collapsed: false
        };
        const options = $9d9d5814dd0cfbf0$export$abc60e668512edf9({
            logLevel: logLevel,
            message: message,
            opts: opts
        });
        const { collapsed: collapsed } = opts;
        options.method = (collapsed ? console.groupCollapsed : console.group) || console.info;
        return this._getLogFunction(options);
    }
    groupCollapsed(logLevel, message) {
        let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.group(logLevel, message, Object.assign({}, opts, {
            collapsed: true
        }));
    }
    groupEnd(logLevel) {
        return this._getLogFunction(logLevel, "", console.groupEnd || $9d9d5814dd0cfbf0$var$noop);
    }
    withGroup(logLevel, message, func) {
        this.group(logLevel, message)();
        try {
            func();
        } finally{
            this.groupEnd(logLevel)();
        }
    }
    trace() {
        if (console.trace) console.trace();
    }
    _shouldLog(logLevel) {
        return this.isEnabled() && this.getLevel() >= $9d9d5814dd0cfbf0$var$normalizeLogLevel(logLevel);
    }
    _getLogFunction(logLevel, message, method, args, opts) {
        if (this._shouldLog(logLevel)) {
            opts = $9d9d5814dd0cfbf0$export$abc60e668512edf9({
                logLevel: logLevel,
                message: message,
                args: args,
                opts: opts
            });
            method = method || opts.method;
            (0, $2qu0I.default)(method);
            opts.total = this.getTotal();
            opts.delta = this.getDelta();
            this._deltaTs = (0, $9mYXe.getHiResTimestamp)();
            const tag = opts.tag || opts.message;
            if (opts.once && tag) {
                if (!$9d9d5814dd0cfbf0$var$cache[tag]) $9d9d5814dd0cfbf0$var$cache[tag] = (0, $9mYXe.getHiResTimestamp)();
                else return $9d9d5814dd0cfbf0$var$noop;
            }
            message = $9d9d5814dd0cfbf0$var$decorateMessage(this.id, opts.message, opts);
            return method.bind(console, message, ...opts.args);
        }
        return $9d9d5814dd0cfbf0$var$noop;
    }
    constructor(){
        let { id: id } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            id: ""
        };
        this.id = void 0;
        this.VERSION = (0, $9RnaI.VERSION);
        this._startTs = (0, $9mYXe.getHiResTimestamp)();
        this._deltaTs = (0, $9mYXe.getHiResTimestamp)();
        this._storage = void 0;
        this.userData = {};
        this.LOG_THROTTLE_TIMEOUT = 0;
        this.id = id;
        this.userData = {};
        this._storage = new (0, $7hRa7.LocalStorage)("__probe-".concat(this.id, "__"), $9d9d5814dd0cfbf0$var$DEFAULT_LOG_CONFIGURATION);
        this.timeStamp("".concat(this.id, " started"));
        (0, $7bpT1.autobind)(this);
        Object.seal(this);
    }
}
$9d9d5814dd0cfbf0$export$ce30dbb46644d06c.VERSION = (0, $9RnaI.VERSION);
function $9d9d5814dd0cfbf0$var$normalizeLogLevel(logLevel) {
    if (!logLevel) return 0;
    let resolvedLevel;
    switch(typeof logLevel){
        case "number":
            resolvedLevel = logLevel;
            break;
        case "object":
            resolvedLevel = logLevel.logLevel || logLevel.priority || 0;
            break;
        default:
            return 0;
    }
    (0, $2qu0I.default)(Number.isFinite(resolvedLevel) && resolvedLevel >= 0);
    return resolvedLevel;
}
function $9d9d5814dd0cfbf0$export$abc60e668512edf9(opts) {
    const { logLevel: logLevel, message: message } = opts;
    opts.logLevel = $9d9d5814dd0cfbf0$var$normalizeLogLevel(logLevel);
    const args = opts.args ? Array.from(opts.args) : [];
    while(args.length && args.shift() !== message);
    switch(typeof logLevel){
        case "string":
        case "function":
            if (message !== undefined) args.unshift(message);
            opts.message = logLevel;
            break;
        case "object":
            Object.assign(opts, logLevel);
            break;
        default:
    }
    if (typeof opts.message === "function") opts.message = opts.message();
    const messageType = typeof opts.message;
    (0, $2qu0I.default)(messageType === "string" || messageType === "object");
    return Object.assign(opts, {
        args: args
    }, opts.opts);
}
function $9d9d5814dd0cfbf0$var$decorateMessage(id, message, opts) {
    if (typeof message === "string") {
        const time = opts.time ? (0, $lKlb6.leftPad)((0, $lKlb6.formatTime)(opts.total)) : "";
        message = opts.time ? "".concat(id, ": ").concat(time, "  ").concat(message) : "".concat(id, ": ").concat(message);
        message = (0, $39ODx.addColor)(message, opts.color, opts.background);
    }
    return message;
}
function $9d9d5814dd0cfbf0$var$logImageInNode(_ref2) {
    let { image: image, message: message = "", scale: scale = 1 } = _ref2;
    console.warn("removed");
    return $9d9d5814dd0cfbf0$var$noop;
}
function $9d9d5814dd0cfbf0$var$logImageInBrowser(_ref3) {
    let { image: image, message: message = "", scale: scale = 1 } = _ref3;
    if (typeof image === "string") {
        const img = new Image();
        img.onload = ()=>{
            const args = (0, $lKlb6.formatImage)(img, message, scale);
            console.log(...args);
        };
        img.src = image;
        return $9d9d5814dd0cfbf0$var$noop;
    }
    const element = image.nodeName || "";
    if (element.toLowerCase() === "img") {
        console.log(...(0, $lKlb6.formatImage)(image, message, scale));
        return $9d9d5814dd0cfbf0$var$noop;
    }
    if (element.toLowerCase() === "canvas") {
        const img = new Image();
        img.onload = ()=>console.log(...(0, $lKlb6.formatImage)(img, message, scale));
        img.src = image.toDataURL();
        return $9d9d5814dd0cfbf0$var$noop;
    }
    return $9d9d5814dd0cfbf0$var$noop;
}
function $9d9d5814dd0cfbf0$var$getTableHeader(table) {
    for(const key in table){
        for(const title in table[key])return title || "untitled";
    }
    return "empty";
}

});
parcelRegister("i4pca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d27c24fc606ee687$export$2e2bcd8739ae039; });

var $cu9Me = parcelRequire("cu9Me");

var $95Bnk = parcelRequire("95Bnk");
function $d27c24fc606ee687$export$2e2bcd8739ae039() {
    const isNode = typeof $95Bnk === "object" && String($95Bnk) === "[object process]" && false;
    return !isNode || (0, $cu9Me.default)();
}
function $d27c24fc606ee687$export$fb09d24fafba666a() {
    return $d27c24fc606ee687$export$2e2bcd8739ae039() && typeof document !== "undefined";
}

});
parcelRegister("cu9Me", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $916fdee4348a2252$export$2e2bcd8739ae039; });

var $95Bnk = parcelRequire("95Bnk");
function $916fdee4348a2252$export$2e2bcd8739ae039(mockUserAgent) {
    if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") return true;
    if (typeof $95Bnk !== "undefined" && typeof $95Bnk.versions === "object" && Boolean($95Bnk.versions["electron"])) return true;
    const realUserAgent = typeof navigator === "object" && typeof navigator.userAgent === "string" && navigator.userAgent;
    const userAgent = mockUserAgent || realUserAgent;
    if (userAgent && userAgent.indexOf("Electron") >= 0) return true;
    return false;
}

});


parcelRegister("9RnaI", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $72db09bc59e240b3$export$a4ad2735b021c132; });

var $i4pca = parcelRequire("i4pca");

const $72db09bc59e240b3$export$a4ad2735b021c132 = typeof __VERSION__ !== "undefined" ? __VERSION__ : "untranspiled source";
const $72db09bc59e240b3$export$4e09c449d6c407f7 = (0, $i4pca.default)();

});

parcelRegister("7hRa7", function(module, exports) {

$parcel$export(module.exports, "LocalStorage", function () { return $54e35bd3a6ddb5f5$export$19fffca37ef3e106; });
function $54e35bd3a6ddb5f5$var$getStorage(type) {
    try {
        const storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return storage;
    } catch (e) {
        return null;
    }
}
class $54e35bd3a6ddb5f5$export$19fffca37ef3e106 {
    getConfiguration() {
        return this.config;
    }
    setConfiguration(configuration) {
        Object.assign(this.config, configuration);
        if (this.storage) {
            const serialized = JSON.stringify(this.config);
            this.storage.setItem(this.id, serialized);
        }
    }
    _loadConfiguration() {
        let configuration = {};
        if (this.storage) {
            const serializedConfiguration = this.storage.getItem(this.id);
            configuration = serializedConfiguration ? JSON.parse(serializedConfiguration) : {};
        }
        Object.assign(this.config, configuration);
        return this;
    }
    constructor(id, defaultConfig){
        let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "sessionStorage";
        this.storage = void 0;
        this.id = void 0;
        this.config = void 0;
        this.storage = $54e35bd3a6ddb5f5$var$getStorage(type);
        this.id = id;
        this.config = defaultConfig;
        this._loadConfiguration();
    }
}

});

parcelRegister("lKlb6", function(module, exports) {

$parcel$export(module.exports, "formatTime", function () { return $fd4e5263c01d5198$export$3203edd9e5edd663; });
$parcel$export(module.exports, "leftPad", function () { return $fd4e5263c01d5198$export$cbb503201166aab7; });
$parcel$export(module.exports, "formatImage", function () { return $fd4e5263c01d5198$export$9171d83acafa047c; });
function $fd4e5263c01d5198$export$3203edd9e5edd663(ms) {
    let formatted;
    if (ms < 10) formatted = "".concat(ms.toFixed(2), "ms");
    else if (ms < 100) formatted = "".concat(ms.toFixed(1), "ms");
    else if (ms < 1000) formatted = "".concat(ms.toFixed(0), "ms");
    else formatted = "".concat((ms / 1000).toFixed(2), "s");
    return formatted;
}
function $fd4e5263c01d5198$export$cbb503201166aab7(string) {
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    const padLength = Math.max(length - string.length, 0);
    return "".concat(" ".repeat(padLength)).concat(string);
}
function $fd4e5263c01d5198$export$390245bab32fb60f(string) {
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    const padLength = Math.max(length - string.length, 0);
    return "".concat(string).concat(" ".repeat(padLength));
}
function $fd4e5263c01d5198$export$7c4d25c0c3217d8c(v) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const EPSILON = 1e-16;
    const { isInteger: isInteger = false } = options;
    if (Array.isArray(v) || ArrayBuffer.isView(v)) return $fd4e5263c01d5198$var$formatArrayValue(v, options);
    if (!Number.isFinite(v)) return String(v);
    if (Math.abs(v) < EPSILON) return isInteger ? "0" : "0.";
    if (isInteger) return v.toFixed(0);
    if (Math.abs(v) > 100 && Math.abs(v) < 10000) return v.toFixed(0);
    const string = v.toPrecision(2);
    const decimal = string.indexOf(".0");
    return decimal === string.length - 2 ? string.slice(0, -1) : string;
}
function $fd4e5263c01d5198$var$formatArrayValue(v, options) {
    const { maxElts: maxElts = 16, size: size = 1 } = options;
    let string = "[";
    for(let i = 0; i < v.length && i < maxElts; ++i){
        if (i > 0) string += ",".concat(i % size === 0 ? " " : "");
        string += $fd4e5263c01d5198$export$7c4d25c0c3217d8c(v[i], options);
    }
    const terminator = v.length > maxElts ? "..." : "]";
    return "".concat(string).concat(terminator);
}
function $fd4e5263c01d5198$export$9171d83acafa047c(image, message, scale) {
    let maxWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 600;
    const imageUrl = image.src.replace(/\(/g, "%28").replace(/\)/g, "%29");
    if (image.width > maxWidth) scale = Math.min(scale, maxWidth / image.width);
    const width = image.width * scale;
    const height = image.height * scale;
    const style = [
        "font-size:1px;",
        "padding:".concat(Math.floor(height / 2), "px ").concat(Math.floor(width / 2), "px;"),
        "line-height:".concat(height, "px;"),
        "background:url(".concat(imageUrl, ");"),
        "background-size:".concat(width, "px ").concat(height, "px;"),
        "color:transparent;"
    ].join("");
    return [
        "".concat(message, " %c+"),
        style
    ];
}

});

parcelRegister("39ODx", function(module, exports) {

$parcel$export(module.exports, "addColor", function () { return $24c97dc08c339607$export$4c4d9288a45f1fb3; });

var $i4pca = parcelRequire("i4pca");
let $24c97dc08c339607$export$9b982809044276a6;
(function(COLOR) {
    COLOR[COLOR["BLACK"] = 30] = "BLACK";
    COLOR[COLOR["RED"] = 31] = "RED";
    COLOR[COLOR["GREEN"] = 32] = "GREEN";
    COLOR[COLOR["YELLOW"] = 33] = "YELLOW";
    COLOR[COLOR["BLUE"] = 34] = "BLUE";
    COLOR[COLOR["MAGENTA"] = 35] = "MAGENTA";
    COLOR[COLOR["CYAN"] = 36] = "CYAN";
    COLOR[COLOR["WHITE"] = 37] = "WHITE";
    COLOR[COLOR["BRIGHT_BLACK"] = 90] = "BRIGHT_BLACK";
    COLOR[COLOR["BRIGHT_RED"] = 91] = "BRIGHT_RED";
    COLOR[COLOR["BRIGHT_GREEN"] = 92] = "BRIGHT_GREEN";
    COLOR[COLOR["BRIGHT_YELLOW"] = 93] = "BRIGHT_YELLOW";
    COLOR[COLOR["BRIGHT_BLUE"] = 94] = "BRIGHT_BLUE";
    COLOR[COLOR["BRIGHT_MAGENTA"] = 95] = "BRIGHT_MAGENTA";
    COLOR[COLOR["BRIGHT_CYAN"] = 96] = "BRIGHT_CYAN";
    COLOR[COLOR["BRIGHT_WHITE"] = 97] = "BRIGHT_WHITE";
})($24c97dc08c339607$export$9b982809044276a6 || ($24c97dc08c339607$export$9b982809044276a6 = {}));
const $24c97dc08c339607$var$BACKGROUND_INCREMENT = 10;
function $24c97dc08c339607$var$getColor(color) {
    if (typeof color !== "string") return color;
    color = color.toUpperCase();
    return $24c97dc08c339607$export$9b982809044276a6[color] || $24c97dc08c339607$export$9b982809044276a6.WHITE;
}
function $24c97dc08c339607$export$4c4d9288a45f1fb3(string, color, background) {
    if (!(0, $i4pca.default) && typeof string === "string") {
        if (color) {
            const colorCode = $24c97dc08c339607$var$getColor(color);
            string = "\x1b[".concat(colorCode, "m").concat(string, "\x1b[39m");
        }
        if (background) {
            const colorCode = $24c97dc08c339607$var$getColor(background);
            string = "\x1b[".concat(colorCode + $24c97dc08c339607$var$BACKGROUND_INCREMENT, "m").concat(string, "\x1b[49m");
        }
    }
    return string;
}

});

parcelRegister("7bpT1", function(module, exports) {

$parcel$export(module.exports, "autobind", function () { return $53ada3fa80b21b15$export$f648f36420f83db; });
function $53ada3fa80b21b15$export$f648f36420f83db(obj) {
    let predefined = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        "constructor"
    ];
    const proto = Object.getPrototypeOf(obj);
    const propNames = Object.getOwnPropertyNames(proto);
    const object = obj;
    for (const key of propNames){
        const value = object[key];
        if (typeof value === "function") {
            if (!predefined.find((name)=>key === name)) object[key] = value.bind(obj);
        }
    }
}

});

parcelRegister("2qu0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4549ee5b85d845$export$2e2bcd8739ae039; });
function $1c4549ee5b85d845$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}

});

parcelRegister("9mYXe", function(module, exports) {

$parcel$export(module.exports, "getHiResTimestamp", function () { return $6d257360a3b98f14$export$19cd34ab73b4c7a7; });

var $i4pca = parcelRequire("i4pca");
var $chRO8 = parcelRequire("chRO8");
function $6d257360a3b98f14$export$19cd34ab73b4c7a7() {
    let timestamp;
    if ((0, $i4pca.default)() && (0, $chRO8.window).performance) {
        var _window$performance, _window$performance$n;
        timestamp = (0, $chRO8.window) === null || (0, $chRO8.window) === void 0 ? void 0 : (_window$performance = (0, $chRO8.window).performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$n = _window$performance.now) === null || _window$performance$n === void 0 ? void 0 : _window$performance$n.call(_window$performance);
    } else if ("hrtime" in (0, $chRO8.process)) {
        var _process$hrtime;
        const timeParts = (0, $chRO8.process) === null || (0, $chRO8.process) === void 0 ? void 0 : (_process$hrtime = (0, $chRO8.process).hrtime) === null || _process$hrtime === void 0 ? void 0 : _process$hrtime.call((0, $chRO8.process));
        timestamp = timeParts[0] * 1000 + timeParts[1] / 1e6;
    } else timestamp = Date.now();
    return timestamp;
}

});
parcelRegister("chRO8", function(module, exports) {

$parcel$export(module.exports, "window", function () { return $8f20cf9eb116a839$export$8291e5b88f90ce4; });
$parcel$export(module.exports, "process", function () { return $8f20cf9eb116a839$export$e54fe5b0f43758f7; });
const $8f20cf9eb116a839$export$90b4d2ff6acb88af = globalThis;
const $8f20cf9eb116a839$export$82c2e460fb230c2a = globalThis.self || globalThis.window || globalThis.global;
const $8f20cf9eb116a839$export$8291e5b88f90ce4 = globalThis.window || globalThis.self || globalThis.global;
const $8f20cf9eb116a839$export$5a7bfc01df82fcd1 = globalThis.document || {};
const $8f20cf9eb116a839$export$e54fe5b0f43758f7 = globalThis.process || {};
const $8f20cf9eb116a839$export$e896d9a1b4631fa1 = globalThis.console;
const $8f20cf9eb116a839$export$ec7c8efa7f5790ae = globalThis.navigator || {};

});





parcelRegister("1UJbQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOADER_OPTIONS", function () { return $164e1336511c725d$export$9e68d151f40453e2; });
$parcel$export(module.exports, "REMOVED_LOADER_OPTIONS", function () { return $164e1336511c725d$export$1bd820ce6d516afc; });

var $ckgCq = parcelRequire("ckgCq");

var $dqw8x = parcelRequire("dqw8x");
const $164e1336511c725d$export$9e68d151f40453e2 = {
    fetch: null,
    mimeType: undefined,
    nothrow: false,
    log: new (0, $dqw8x.ConsoleLog)(),
    CDN: "https://unpkg.com/@loaders.gl",
    worker: true,
    maxConcurrency: 3,
    maxMobileConcurrency: 1,
    reuseWorkers: (0, $ckgCq.isBrowser),
    _nodeWorkers: false,
    _workerType: "",
    limit: 0,
    _limitMB: 0,
    batchSize: "auto",
    batchDebounceMs: 0,
    metadata: false,
    transforms: []
};
const $164e1336511c725d$export$1bd820ce6d516afc = {
    throws: "nothrow",
    dataType: "(no longer used)",
    uri: "baseUri",
    method: "fetch.method",
    headers: "fetch.headers",
    body: "fetch.body",
    mode: "fetch.mode",
    credentials: "fetch.credentials",
    cache: "fetch.cache",
    redirect: "fetch.redirect",
    referrer: "fetch.referrer",
    referrerPolicy: "fetch.referrerPolicy",
    integrity: "fetch.integrity",
    keepalive: "fetch.keepalive",
    signal: "fetch.signal"
};

});
parcelRegister("ckgCq", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $8f943e68d95d209b$export$4e09c449d6c407f7; });

var $95Bnk = parcelRequire("95Bnk");
const $8f943e68d95d209b$var$globals = {
    self: typeof self !== "undefined" && self,
    window: typeof window !== "undefined" && window,
    global: typeof $parcel$global !== "undefined" && $parcel$global,
    document: typeof document !== "undefined" && document
};
const $8f943e68d95d209b$export$82c2e460fb230c2a = $8f943e68d95d209b$var$globals.self || $8f943e68d95d209b$var$globals.window || $8f943e68d95d209b$var$globals.global || {};
const $8f943e68d95d209b$export$8291e5b88f90ce4 = $8f943e68d95d209b$var$globals.window || $8f943e68d95d209b$var$globals.self || $8f943e68d95d209b$var$globals.global || {};
const $8f943e68d95d209b$export$90b4d2ff6acb88af = $8f943e68d95d209b$var$globals.global || $8f943e68d95d209b$var$globals.self || $8f943e68d95d209b$var$globals.window || {};
const $8f943e68d95d209b$export$5a7bfc01df82fcd1 = $8f943e68d95d209b$var$globals.document || {};
const $8f943e68d95d209b$export$4e09c449d6c407f7 = Boolean(typeof $95Bnk !== "object" || String($95Bnk) !== "[object process]" || true);
const $8f943e68d95d209b$export$3c901a5f01941a06 = typeof importScripts === "function";
const $8f943e68d95d209b$var$matches = typeof $95Bnk !== "undefined" && $95Bnk.version && /v([0-9]*)/.exec($95Bnk.version);
const $8f943e68d95d209b$export$168db21d314844a8 = $8f943e68d95d209b$var$matches && parseFloat($8f943e68d95d209b$var$matches[1]) || 0;

});




parcelRegister("a2G5Q", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $74fabe1f85c97231$export$98e6a39c04603d36; });

var $hDxa9 = parcelRequire("hDxa9");
var $9HNbJ = parcelRequire("9HNbJ");

var $fvV5p = parcelRequire("fvV5p");

var $vyOkv = parcelRequire("vyOkv");

var $coI4l = parcelRequire("coI4l");

var $8mcNl = parcelRequire("8mcNl");

var $gUP4G = parcelRequire("gUP4G");

var $7VNil = parcelRequire("7VNil");

var $l6GmM = parcelRequire("l6GmM");

var $9pRlR = parcelRequire("9pRlR");
async function $74fabe1f85c97231$export$98e6a39c04603d36(data, loaders, options, context) {
    (0, $hDxa9.assert)(!context || typeof context === "object");
    if (loaders && !Array.isArray(loaders) && !(0, $vyOkv.isLoaderObject)(loaders)) {
        context = undefined;
        options = loaders;
        loaders = undefined;
    }
    data = await data;
    options = options || {};
    const url = (0, $l6GmM.getResourceUrl)(data);
    const typedLoaders = loaders;
    const candidateLoaders = (0, $7VNil.getLoadersFromContext)(typedLoaders, context);
    const loader = await (0, $9pRlR.selectLoader)(data, candidateLoaders, options);
    if (!loader) return null;
    options = (0, $8mcNl.normalizeOptions)(options, loader, candidateLoaders, url);
    context = (0, $7VNil.getLoaderContext)({
        url: url,
        parse: $74fabe1f85c97231$export$98e6a39c04603d36,
        loaders: candidateLoaders
    }, options, context || null);
    return await $74fabe1f85c97231$var$parseWithLoader(loader, data, options, context);
}
async function $74fabe1f85c97231$var$parseWithLoader(loader, data, options, context) {
    (0, $9HNbJ.validateWorkerVersion)(loader);
    if ((0, $coI4l.isResponse)(data)) {
        const response = data;
        const { ok: ok, redirected: redirected, status: status, statusText: statusText, type: type, url: url } = response;
        const headers = Object.fromEntries(response.headers.entries());
        context.response = {
            headers: headers,
            ok: ok,
            redirected: redirected,
            status: status,
            statusText: statusText,
            type: type,
            url: url
        };
    }
    data = await (0, $gUP4G.getArrayBufferOrStringFromData)(data, loader, options);
    if (loader.parseTextSync && typeof data === "string") {
        options.dataType = "text";
        return loader.parseTextSync(data, options, context, loader);
    }
    if ((0, $fvV5p.canParseWithWorker)(loader, options)) return await (0, $fvV5p.parseWithWorker)(loader, data, options, context, $74fabe1f85c97231$export$98e6a39c04603d36);
    if (loader.parseText && typeof data === "string") return await loader.parseText(data, options, context, loader);
    if (loader.parse) return await loader.parse(data, options, context, loader);
    (0, $hDxa9.assert)(!loader.parseSync);
    throw new Error("".concat(loader.id, " loader - no parser found and worker is disabled"));
}

});
parcelRegister("hDxa9", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $cd6fcd9989f88830$export$a7a9523472993e97; });
function $cd6fcd9989f88830$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "loaders.gl assertion failed.");
}

});

parcelRegister("9HNbJ", function(module, exports) {

$parcel$export(module.exports, "validateWorkerVersion", function () { return $710e48f2b3e53882$export$95e2ee179a5692d5; });

var $hDxa9 = parcelRequire("hDxa9");

var $9Dqnm = parcelRequire("9Dqnm");
function $710e48f2b3e53882$export$95e2ee179a5692d5(worker) {
    let coreVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $9Dqnm.VERSION);
    (0, $hDxa9.assert)(worker, "no worker provided");
    const workerVersion = worker.version;
    if (!coreVersion || !workerVersion) return false;
    return true;
}
function $710e48f2b3e53882$var$parseVersion(version) {
    const parts = version.split(".").map(Number);
    return {
        major: parts[0],
        minor: parts[1]
    };
}

});
parcelRegister("9Dqnm", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $703c37438c4b59f9$export$a4ad2735b021c132; });
const $703c37438c4b59f9$var$DEFAULT_VERSION = "latest";
const $703c37438c4b59f9$export$a4ad2735b021c132 = "3.4.14";

});


parcelRegister("fvV5p", function(module, exports) {

$parcel$export(module.exports, "canParseWithWorker", function () { return $b4b608629f0269ff$export$d28453530d9dde76; });
$parcel$export(module.exports, "parseWithWorker", function () { return $b4b608629f0269ff$export$5fc1ede2a33af3b1; });

var $iOF6R = parcelRequire("iOF6R");
var $iR3LN = parcelRequire("iR3LN");
var $f3Jb7 = parcelRequire("f3Jb7");
function $b4b608629f0269ff$export$d28453530d9dde76(loader, options) {
    if (!(0, $f3Jb7.default).isSupported()) return false;
    if (!(0, $iR3LN.isBrowser) && !(options !== null && options !== void 0 && options._nodeWorkers)) return false;
    return loader.worker && (options === null || options === void 0 ? void 0 : options.worker);
}
async function $b4b608629f0269ff$export$5fc1ede2a33af3b1(loader, data, options, context, parseOnMainThread) {
    const name = loader.id;
    const url = (0, $iOF6R.getWorkerURL)(loader, options);
    const workerFarm = (0, $f3Jb7.default).getWorkerFarm(options);
    const workerPool = workerFarm.getWorkerPool({
        name: name,
        url: url
    });
    options = JSON.parse(JSON.stringify(options));
    context = JSON.parse(JSON.stringify(context || {}));
    const job = await workerPool.startJob("process-on-worker", $b4b608629f0269ff$var$onMessage.bind(null, parseOnMainThread));
    job.postMessage("process", {
        input: data,
        options: options,
        context: context
    });
    const result = await job.result;
    return await result.result;
}
async function $b4b608629f0269ff$var$onMessage(parseOnMainThread, job, type, payload) {
    switch(type){
        case "done":
            job.done(payload);
            break;
        case "error":
            job.error(new Error(payload.error));
            break;
        case "process":
            const { id: id, input: input, options: options } = payload;
            try {
                const result = await parseOnMainThread(input, options);
                job.postMessage("done", {
                    id: id,
                    result: result
                });
            } catch (error) {
                const message = error instanceof Error ? error.message : "unknown error";
                job.postMessage("error", {
                    id: id,
                    error: message
                });
            }
            break;
        default:
            console.warn("parse-with-worker unknown message ".concat(type));
    }
}

});
parcelRegister("iOF6R", function(module, exports) {

$parcel$export(module.exports, "getWorkerURL", function () { return $db2cc90afc1c6cf9$export$959914ac3383a118; });

var $hDxa9 = parcelRequire("hDxa9");

const $db2cc90afc1c6cf9$var$NPM_TAG = "latest";
const $db2cc90afc1c6cf9$var$VERSION = "3.4.14";
function $db2cc90afc1c6cf9$export$72db835c4de3b02e(worker) {
    const warning = worker.version !== $db2cc90afc1c6cf9$var$VERSION ? " (worker-utils@".concat($db2cc90afc1c6cf9$var$VERSION, ")") : "";
    return "".concat(worker.name, "@").concat(worker.version).concat(warning);
}
function $db2cc90afc1c6cf9$export$959914ac3383a118(worker) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const workerOptions = options[worker.id] || {};
    const workerFile = "".concat(worker.id, "-worker.js");
    let url = workerOptions.workerUrl;
    if (!url && worker.id === "compression") url = options.workerUrl;
    if (options._workerType === "test") url = "modules/".concat(worker.module, "/dist/").concat(workerFile);
    if (!url) {
        let version = worker.version;
        if (version === "latest") version = $db2cc90afc1c6cf9$var$NPM_TAG;
        const versionTag = version ? "@".concat(version) : "";
        url = "https://unpkg.com/@loaders.gl/".concat(worker.module).concat(versionTag, "/dist/").concat(workerFile);
    }
    (0, $hDxa9.assert)(url);
    return url;
}

});

parcelRegister("iR3LN", function(module, exports) {

$parcel$export(module.exports, "global", function () { return $dba019dda7b2ee8a$export$90b4d2ff6acb88af; });
$parcel$export(module.exports, "isBrowser", function () { return $dba019dda7b2ee8a$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWorker", function () { return $dba019dda7b2ee8a$export$3c901a5f01941a06; });
$parcel$export(module.exports, "isMobile", function () { return $dba019dda7b2ee8a$export$d0a8044dce8ff2fc; });

var $95Bnk = parcelRequire("95Bnk");
const $dba019dda7b2ee8a$var$globals = {
    self: typeof self !== "undefined" && self,
    window: typeof window !== "undefined" && window,
    global: typeof $parcel$global !== "undefined" && $parcel$global,
    document: typeof document !== "undefined" && document
};
const $dba019dda7b2ee8a$export$82c2e460fb230c2a = $dba019dda7b2ee8a$var$globals.self || $dba019dda7b2ee8a$var$globals.window || $dba019dda7b2ee8a$var$globals.global || {};
const $dba019dda7b2ee8a$export$8291e5b88f90ce4 = $dba019dda7b2ee8a$var$globals.window || $dba019dda7b2ee8a$var$globals.self || $dba019dda7b2ee8a$var$globals.global || {};
const $dba019dda7b2ee8a$export$90b4d2ff6acb88af = $dba019dda7b2ee8a$var$globals.global || $dba019dda7b2ee8a$var$globals.self || $dba019dda7b2ee8a$var$globals.window || {};
const $dba019dda7b2ee8a$export$5a7bfc01df82fcd1 = $dba019dda7b2ee8a$var$globals.document || {};
const $dba019dda7b2ee8a$export$4e09c449d6c407f7 = typeof $95Bnk !== "object" || String($95Bnk) !== "[object process]" || true;
const $dba019dda7b2ee8a$export$3c901a5f01941a06 = typeof importScripts === "function";
const $dba019dda7b2ee8a$export$d0a8044dce8ff2fc = typeof window !== "undefined" && typeof window.orientation !== "undefined";
const $dba019dda7b2ee8a$var$matches = typeof $95Bnk !== "undefined" && $95Bnk.version && /v([0-9]*)/.exec($95Bnk.version);
const $dba019dda7b2ee8a$export$168db21d314844a8 = $dba019dda7b2ee8a$var$matches && parseFloat($dba019dda7b2ee8a$var$matches[1]) || 0;

});

parcelRegister("f3Jb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af6a2e4ea8fe2bd5$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1F5uH = parcelRequire("1F5uH");

var $gCUMs = parcelRequire("gCUMs");

var $h89eS = parcelRequire("h89eS");
const $af6a2e4ea8fe2bd5$var$DEFAULT_PROPS = {
    maxConcurrency: 3,
    maxMobileConcurrency: 1,
    reuseWorkers: true,
    onDebug: ()=>{}
};
class $af6a2e4ea8fe2bd5$export$2e2bcd8739ae039 {
    static isSupported() {
        return (0, $h89eS.default).isSupported();
    }
    static getWorkerFarm() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $af6a2e4ea8fe2bd5$export$2e2bcd8739ae039._workerFarm = $af6a2e4ea8fe2bd5$export$2e2bcd8739ae039._workerFarm || new $af6a2e4ea8fe2bd5$export$2e2bcd8739ae039({});
        $af6a2e4ea8fe2bd5$export$2e2bcd8739ae039._workerFarm.setProps(props);
        return $af6a2e4ea8fe2bd5$export$2e2bcd8739ae039._workerFarm;
    }
    destroy() {
        for (const workerPool of this.workerPools.values())workerPool.destroy();
        this.workerPools = new Map();
    }
    setProps(props) {
        this.props = (0, $2QP2i._)({}, this.props, props);
        for (const workerPool of this.workerPools.values())workerPool.setProps(this._getWorkerPoolProps());
    }
    getWorkerPool(options) {
        const { name: name, source: source, url: url } = options;
        let workerPool = this.workerPools.get(name);
        if (!workerPool) {
            workerPool = new (0, $gCUMs.default)({
                name: name,
                source: source,
                url: url
            });
            workerPool.setProps(this._getWorkerPoolProps());
            this.workerPools.set(name, workerPool);
        }
        return workerPool;
    }
    _getWorkerPoolProps() {
        return {
            maxConcurrency: this.props.maxConcurrency,
            maxMobileConcurrency: this.props.maxMobileConcurrency,
            reuseWorkers: this.props.reuseWorkers,
            onDebug: this.props.onDebug
        };
    }
    constructor(props){
        (0, $1F5uH.default)(this, "props", void 0);
        (0, $1F5uH.default)(this, "workerPools", new Map());
        this.props = (0, $2QP2i._)({}, $af6a2e4ea8fe2bd5$var$DEFAULT_PROPS);
        this.setProps(props);
        this.workerPools = new Map();
    }
}
(0, $1F5uH.default)($af6a2e4ea8fe2bd5$export$2e2bcd8739ae039, "_workerFarm", void 0);

});
parcelRegister("1F5uH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $135de1d2feaed447$export$2e2bcd8739ae039; });
function $135de1d2feaed447$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("gCUMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1ac3d5f98749d0d$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1F5uH = parcelRequire("1F5uH");

var $iR3LN = parcelRequire("iR3LN");

var $h89eS = parcelRequire("h89eS");

var $k6D2w = parcelRequire("k6D2w");
class $c1ac3d5f98749d0d$export$2e2bcd8739ae039 {
    static isSupported() {
        return (0, $h89eS.default).isSupported();
    }
    destroy() {
        this.idleQueue.forEach((worker)=>worker.destroy());
        this.isDestroyed = true;
    }
    setProps(props) {
        this.props = (0, $2QP2i._)({}, this.props, props);
        if (props.name !== undefined) this.name = props.name;
        if (props.maxConcurrency !== undefined) this.maxConcurrency = props.maxConcurrency;
        if (props.maxMobileConcurrency !== undefined) this.maxMobileConcurrency = props.maxMobileConcurrency;
        if (props.reuseWorkers !== undefined) this.reuseWorkers = props.reuseWorkers;
        if (props.onDebug !== undefined) this.onDebug = props.onDebug;
    }
    async startJob(name) {
        let onMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (job, type, data)=>job.done(data);
        let onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (job, error)=>job.error(error);
        const startPromise = new Promise((onStart)=>{
            this.jobQueue.push({
                name: name,
                onMessage: onMessage,
                onError: onError,
                onStart: onStart
            });
            return this;
        });
        this._startQueuedJob();
        return await startPromise;
    }
    async _startQueuedJob() {
        if (!this.jobQueue.length) return;
        const workerThread = this._getAvailableWorker();
        if (!workerThread) return;
        const queuedJob = this.jobQueue.shift();
        if (queuedJob) {
            this.onDebug({
                message: "Starting job",
                name: queuedJob.name,
                workerThread: workerThread,
                backlog: this.jobQueue.length
            });
            const job = new (0, $k6D2w.default)(queuedJob.name, workerThread);
            workerThread.onMessage = (data)=>queuedJob.onMessage(job, data.type, data.payload);
            workerThread.onError = (error)=>queuedJob.onError(job, error);
            queuedJob.onStart(job);
            try {
                await job.result;
            } finally{
                this.returnWorkerToQueue(workerThread);
            }
        }
    }
    returnWorkerToQueue(worker) {
        const shouldDestroyWorker = this.isDestroyed || !this.reuseWorkers || this.count > this._getMaxConcurrency();
        if (shouldDestroyWorker) {
            worker.destroy();
            this.count--;
        } else this.idleQueue.push(worker);
        if (!this.isDestroyed) this._startQueuedJob();
    }
    _getAvailableWorker() {
        if (this.idleQueue.length > 0) return this.idleQueue.shift() || null;
        if (this.count < this._getMaxConcurrency()) {
            this.count++;
            const name = "".concat(this.name.toLowerCase(), " (#").concat(this.count, " of ").concat(this.maxConcurrency, ")");
            return new (0, $h89eS.default)({
                name: name,
                source: this.source,
                url: this.url
            });
        }
        return null;
    }
    _getMaxConcurrency() {
        return (0, $iR3LN.isMobile) ? this.maxMobileConcurrency : this.maxConcurrency;
    }
    constructor(props){
        (0, $1F5uH.default)(this, "name", "unnamed");
        (0, $1F5uH.default)(this, "source", void 0);
        (0, $1F5uH.default)(this, "url", void 0);
        (0, $1F5uH.default)(this, "maxConcurrency", 1);
        (0, $1F5uH.default)(this, "maxMobileConcurrency", 1);
        (0, $1F5uH.default)(this, "onDebug", ()=>{});
        (0, $1F5uH.default)(this, "reuseWorkers", true);
        (0, $1F5uH.default)(this, "props", {});
        (0, $1F5uH.default)(this, "jobQueue", []);
        (0, $1F5uH.default)(this, "idleQueue", []);
        (0, $1F5uH.default)(this, "count", 0);
        (0, $1F5uH.default)(this, "isDestroyed", false);
        this.source = props.source;
        this.url = props.url;
        this.setProps(props);
    }
}

});
parcelRegister("h89eS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c78a59b39bf3d5a5$export$2e2bcd8739ae039; });

var $1F5uH = parcelRequire("1F5uH");

var $e1B0q = parcelRequire("e1B0q");

var $iR3LN = parcelRequire("iR3LN");

var $hDxa9 = parcelRequire("hDxa9");

var $e5bfg = parcelRequire("e5bfg");

var $4MjqT = parcelRequire("4MjqT");
const $c78a59b39bf3d5a5$var$NOOP = ()=>{};
class $c78a59b39bf3d5a5$export$2e2bcd8739ae039 {
    static isSupported() {
        return typeof Worker !== "undefined" && (0, $iR3LN.isBrowser) || typeof (0, $e1B0q.NodeWorker) !== "undefined" && !(0, $iR3LN.isBrowser);
    }
    destroy() {
        this.onMessage = $c78a59b39bf3d5a5$var$NOOP;
        this.onError = $c78a59b39bf3d5a5$var$NOOP;
        this.worker.terminate();
        this.terminated = true;
    }
    get isRunning() {
        return Boolean(this.onMessage);
    }
    postMessage(data, transferList) {
        transferList = transferList || (0, $4MjqT.getTransferList)(data);
        this.worker.postMessage(data, transferList);
    }
    _getErrorFromErrorEvent(event) {
        let message = "Failed to load ";
        message += "worker ".concat(this.name, " from ").concat(this.url, ". ");
        if (event.message) message += "".concat(event.message, " in ");
        if (event.lineno) message += ":".concat(event.lineno, ":").concat(event.colno);
        return new Error(message);
    }
    _createBrowserWorker() {
        this._loadableURL = (0, $e5bfg.getLoadableWorkerURL)({
            source: this.source,
            url: this.url
        });
        const worker = new Worker(this._loadableURL, {
            name: this.name
        });
        worker.onmessage = (event)=>{
            if (!event.data) this.onError(new Error("No data received"));
            else this.onMessage(event.data);
        };
        worker.onerror = (error)=>{
            this.onError(this._getErrorFromErrorEvent(error));
            this.terminated = true;
        };
        worker.onmessageerror = (event)=>console.error(event);
        return worker;
    }
    _createNodeWorker() {
        let worker;
        if (this.url) {
            const absolute = this.url.includes(":/") || this.url.startsWith("/");
            const url = absolute ? this.url : "./".concat(this.url);
            worker = new (0, $e1B0q.NodeWorker)(url, {
                eval: false
            });
        } else if (this.source) worker = new (0, $e1B0q.NodeWorker)(this.source, {
            eval: true
        });
        else throw new Error("no worker");
        worker.on("message", (data)=>{
            this.onMessage(data);
        });
        worker.on("error", (error)=>{
            this.onError(error);
        });
        worker.on("exit", (code)=>{});
        return worker;
    }
    constructor(props){
        (0, $1F5uH.default)(this, "name", void 0);
        (0, $1F5uH.default)(this, "source", void 0);
        (0, $1F5uH.default)(this, "url", void 0);
        (0, $1F5uH.default)(this, "terminated", false);
        (0, $1F5uH.default)(this, "worker", void 0);
        (0, $1F5uH.default)(this, "onMessage", void 0);
        (0, $1F5uH.default)(this, "onError", void 0);
        (0, $1F5uH.default)(this, "_loadableURL", "");
        const { name: name, source: source, url: url } = props;
        (0, $hDxa9.assert)(source || url);
        this.name = name;
        this.source = source;
        this.url = url;
        this.onMessage = $c78a59b39bf3d5a5$var$NOOP;
        this.onError = (error)=>console.log(error);
        this.worker = (0, $iR3LN.isBrowser) ? this._createBrowserWorker() : this._createNodeWorker();
    }
}

});
parcelRegister("e1B0q", function(module, exports) {

$parcel$export(module.exports, "NodeWorker", function () { return $a35ddd4891abe8eb$export$5ff70a18b7b7760a; });
class $a35ddd4891abe8eb$export$5ff70a18b7b7760a {
    terminate() {}
}
const $a35ddd4891abe8eb$export$cf4063c86d516c29 = null;

});

parcelRegister("e5bfg", function(module, exports) {

$parcel$export(module.exports, "getLoadableWorkerURL", function () { return $a40a4165801f443c$export$fb15ef3d6a383f22; });

var $hDxa9 = parcelRequire("hDxa9");
const $a40a4165801f443c$var$workerURLCache = new Map();
function $a40a4165801f443c$export$fb15ef3d6a383f22(props) {
    (0, $hDxa9.assert)(props.source && !props.url || !props.source && props.url);
    let workerURL = $a40a4165801f443c$var$workerURLCache.get(props.source || props.url);
    if (!workerURL) {
        if (props.url) {
            workerURL = $a40a4165801f443c$var$getLoadableWorkerURLFromURL(props.url);
            $a40a4165801f443c$var$workerURLCache.set(props.url, workerURL);
        }
        if (props.source) {
            workerURL = $a40a4165801f443c$var$getLoadableWorkerURLFromSource(props.source);
            $a40a4165801f443c$var$workerURLCache.set(props.source, workerURL);
        }
    }
    (0, $hDxa9.assert)(workerURL);
    return workerURL;
}
function $a40a4165801f443c$var$getLoadableWorkerURLFromURL(url) {
    if (!url.startsWith("http")) return url;
    const workerSource = $a40a4165801f443c$var$buildScriptSource(url);
    return $a40a4165801f443c$var$getLoadableWorkerURLFromSource(workerSource);
}
function $a40a4165801f443c$var$getLoadableWorkerURLFromSource(workerSource) {
    const blob = new Blob([
        workerSource
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(blob);
}
function $a40a4165801f443c$var$buildScriptSource(workerUrl) {
    return "try {\n  importScripts('".concat(workerUrl, "');\n} catch (error) {\n  console.error(error);\n  throw error;\n}");
}

});

parcelRegister("4MjqT", function(module, exports) {

$parcel$export(module.exports, "getTransferList", function () { return $37aab808ef2d6bef$export$6464150b0a96b310; });
function $37aab808ef2d6bef$export$6464150b0a96b310(object) {
    let recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let transfers = arguments.length > 2 ? arguments[2] : undefined;
    const transfersSet = transfers || new Set();
    if (!object) ;
    else if ($37aab808ef2d6bef$var$isTransferable(object)) transfersSet.add(object);
    else if ($37aab808ef2d6bef$var$isTransferable(object.buffer)) transfersSet.add(object.buffer);
    else if (ArrayBuffer.isView(object)) ;
    else if (recursive && typeof object === "object") for(const key in object)$37aab808ef2d6bef$export$6464150b0a96b310(object[key], recursive, transfersSet);
    return transfers === undefined ? Array.from(transfersSet) : [];
}
function $37aab808ef2d6bef$var$isTransferable(object) {
    if (!object) return false;
    if (object instanceof ArrayBuffer) return true;
    if (typeof MessagePort !== "undefined" && object instanceof MessagePort) return true;
    if (typeof ImageBitmap !== "undefined" && object instanceof ImageBitmap) return true;
    if (typeof OffscreenCanvas !== "undefined" && object instanceof OffscreenCanvas) return true;
    return false;
}
function $37aab808ef2d6bef$export$6ab4b9699085844c(object) {
    if (object === null) return {};
    const clone = Object.assign({}, object);
    Object.keys(clone).forEach((key)=>{
        if (typeof object[key] === "object" && !ArrayBuffer.isView(object[key]) && !(object[key] instanceof Array)) clone[key] = $37aab808ef2d6bef$export$6ab4b9699085844c(object[key]);
        else if (typeof clone[key] === "function" || clone[key] instanceof RegExp) clone[key] = {};
        else clone[key] = object[key];
    });
    return clone;
}

});


parcelRegister("k6D2w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea32a6a12c7358b1$export$2e2bcd8739ae039; });

var $1F5uH = parcelRequire("1F5uH");

var $hDxa9 = parcelRequire("hDxa9");
class $ea32a6a12c7358b1$export$2e2bcd8739ae039 {
    postMessage(type, payload) {
        this.workerThread.postMessage({
            source: "loaders.gl",
            type: type,
            payload: payload
        });
    }
    done(value) {
        (0, $hDxa9.assert)(this.isRunning);
        this.isRunning = false;
        this._resolve(value);
    }
    error(error) {
        (0, $hDxa9.assert)(this.isRunning);
        this.isRunning = false;
        this._reject(error);
    }
    constructor(jobName, workerThread){
        (0, $1F5uH.default)(this, "name", void 0);
        (0, $1F5uH.default)(this, "workerThread", void 0);
        (0, $1F5uH.default)(this, "isRunning", true);
        (0, $1F5uH.default)(this, "result", void 0);
        (0, $1F5uH.default)(this, "_resolve", ()=>{});
        (0, $1F5uH.default)(this, "_reject", ()=>{});
        this.name = jobName;
        this.workerThread = workerThread;
        this.result = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
}

});




parcelRegister("gUP4G", function(module, exports) {

$parcel$export(module.exports, "getArrayBufferOrStringFromData", function () { return $c5097ea1ad3be1ff$export$8f911a3af008501e; });

var $fRqWc = parcelRequire("fRqWc");

var $coI4l = parcelRequire("coI4l");

var $d2pyQ = parcelRequire("d2pyQ");

var $iQYNB = parcelRequire("iQYNB");
const $c5097ea1ad3be1ff$var$ERR_DATA = "Cannot convert supplied data type";
function $c5097ea1ad3be1ff$export$1bdaa95e029beec8(data, loader, options) {
    if (loader.text && typeof data === "string") return data;
    if ((0, $coI4l.isBuffer)(data)) data = data.buffer;
    if (data instanceof ArrayBuffer) {
        const arrayBuffer = data;
        if (loader.text && !loader.binary) {
            const textDecoder = new TextDecoder("utf8");
            return textDecoder.decode(arrayBuffer);
        }
        return arrayBuffer;
    }
    if (ArrayBuffer.isView(data)) {
        if (loader.text && !loader.binary) {
            const textDecoder = new TextDecoder("utf8");
            return textDecoder.decode(data);
        }
        let arrayBuffer = data.buffer;
        const byteLength = data.byteLength || data.length;
        if (data.byteOffset !== 0 || byteLength !== arrayBuffer.byteLength) arrayBuffer = arrayBuffer.slice(data.byteOffset, data.byteOffset + byteLength);
        return arrayBuffer;
    }
    throw new Error($c5097ea1ad3be1ff$var$ERR_DATA);
}
async function $c5097ea1ad3be1ff$export$8f911a3af008501e(data, loader, options) {
    const isArrayBuffer = data instanceof ArrayBuffer || ArrayBuffer.isView(data);
    if (typeof data === "string" || isArrayBuffer) return $c5097ea1ad3be1ff$export$1bdaa95e029beec8(data, loader, options);
    if ((0, $coI4l.isBlob)(data)) data = await (0, $iQYNB.makeResponse)(data);
    if ((0, $coI4l.isResponse)(data)) {
        const response = data;
        await (0, $iQYNB.checkResponse)(response);
        return loader.binary ? await response.arrayBuffer() : await response.text();
    }
    if ((0, $coI4l.isReadableStream)(data)) data = (0, $d2pyQ.makeIterator)(data, options);
    if ((0, $coI4l.isIterable)(data) || (0, $coI4l.isAsyncIterable)(data)) return (0, $fRqWc.concatenateArrayBuffersAsync)(data);
    throw new Error($c5097ea1ad3be1ff$var$ERR_DATA);
}
async function $c5097ea1ad3be1ff$export$439b9c71d78e9e91(data, options) {
    if ((0, $coI4l.isIterator)(data)) return data;
    if ((0, $coI4l.isResponse)(data)) {
        const response = data;
        await (0, $iQYNB.checkResponse)(response);
        const body = await response.body;
        return (0, $d2pyQ.makeIterator)(body, options);
    }
    if ((0, $coI4l.isBlob)(data) || (0, $coI4l.isReadableStream)(data)) return (0, $d2pyQ.makeIterator)(data, options);
    if ((0, $coI4l.isAsyncIterable)(data)) return data[Symbol.asyncIterator]();
    return $c5097ea1ad3be1ff$var$getIterableFromData(data);
}
async function $c5097ea1ad3be1ff$export$fcaec59c9cf8d502(data) {
    if ((0, $coI4l.isReadableStream)(data)) return data;
    if ((0, $coI4l.isResponse)(data)) return data.body;
    const response = await (0, $iQYNB.makeResponse)(data);
    return response.body;
}
function $c5097ea1ad3be1ff$var$getIterableFromData(data) {
    if (ArrayBuffer.isView(data)) return function* oneChunk() {
        yield data.buffer;
    }();
    if (data instanceof ArrayBuffer) return function* oneChunk() {
        yield data;
    }();
    if ((0, $coI4l.isIterator)(data)) return data;
    if ((0, $coI4l.isIterable)(data)) return data[Symbol.iterator]();
    throw new Error($c5097ea1ad3be1ff$var$ERR_DATA);
}

});
parcelRegister("fRqWc", function(module, exports) {

$parcel$export(module.exports, "concatenateArrayBuffersAsync", function () { return $b8c0b37f1d19e0f1$export$b56e0390cdc1b1ca; });

var $grxRA = parcelRequire("grxRA");
async function $b8c0b37f1d19e0f1$export$4b80e395e36b5a56(iterator, visitor) {
    while(true){
        const { done: done, value: value } = await iterator.next();
        if (done) {
            iterator.return();
            return;
        }
        const cancel = visitor(value);
        if (cancel) return;
    }
}
async function $b8c0b37f1d19e0f1$export$b56e0390cdc1b1ca(asyncIterator) {
    const arrayBuffers = [];
    for await (const chunk of asyncIterator)arrayBuffers.push(chunk);
    return (0, $grxRA.concatenateArrayBuffers)(...arrayBuffers);
}
async function $b8c0b37f1d19e0f1$export$8a08e0b4be2e1c13(asyncIterator) {
    const strings = [];
    for await (const chunk of asyncIterator)strings.push(chunk);
    return strings.join("");
}

});
parcelRegister("grxRA", function(module, exports) {

$parcel$export(module.exports, "compareArrayBuffers", function () { return $bf896f833451c014$export$a21c1249ab709443; });
$parcel$export(module.exports, "concatenateArrayBuffers", function () { return $bf896f833451c014$export$9a3e9c78eb778da8; });
$parcel$export(module.exports, "sliceArrayBuffer", function () { return $bf896f833451c014$export$1c6babfc8b593386; });
function $bf896f833451c014$export$a21c1249ab709443(arrayBuffer1, arrayBuffer2, byteLength) {
    byteLength = byteLength || arrayBuffer1.byteLength;
    if (arrayBuffer1.byteLength < byteLength || arrayBuffer2.byteLength < byteLength) return false;
    const array1 = new Uint8Array(arrayBuffer1);
    const array2 = new Uint8Array(arrayBuffer2);
    for(let i = 0; i < array1.length; ++i){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
function $bf896f833451c014$export$9a3e9c78eb778da8() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    const sourceArrays = sources.map((source2)=>source2 instanceof ArrayBuffer ? new Uint8Array(source2) : source2);
    const byteLength = sourceArrays.reduce((length, typedArray)=>length + typedArray.byteLength, 0);
    const result = new Uint8Array(byteLength);
    let offset = 0;
    for (const sourceArray of sourceArrays){
        result.set(sourceArray, offset);
        offset += sourceArray.byteLength;
    }
    return result.buffer;
}
function $bf896f833451c014$export$b9f790e5e2031778() {
    for(var _len2 = arguments.length, typedArrays = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)typedArrays[_key2] = arguments[_key2];
    const arrays = typedArrays;
    const TypedArrayConstructor = arrays && arrays.length > 1 && arrays[0].constructor || null;
    if (!TypedArrayConstructor) throw new Error('"concatenateTypedArrays" - incorrect quantity of arguments or arguments have incompatible data types');
    const sumLength = arrays.reduce((acc, value)=>acc + value.length, 0);
    const result = new TypedArrayConstructor(sumLength);
    let offset = 0;
    for (const array of arrays){
        result.set(array, offset);
        offset += array.length;
    }
    return result;
}
function $bf896f833451c014$export$1c6babfc8b593386(arrayBuffer, byteOffset, byteLength) {
    const subArray = byteLength !== undefined ? new Uint8Array(arrayBuffer).subarray(byteOffset, byteOffset + byteLength) : new Uint8Array(arrayBuffer).subarray(byteOffset);
    const arrayCopy = new Uint8Array(subArray);
    return arrayCopy.buffer;
}

});


parcelRegister("d2pyQ", function(module, exports) {

$parcel$export(module.exports, "makeIterator", function () { return $97df4a26a6db127b$export$81c40ebfe660d3ca; });

var $dcQkc = parcelRequire("dcQkc");

var $6DBWE = parcelRequire("6DBWE");

var $tsOGf = parcelRequire("tsOGf");

var $3Nej3 = parcelRequire("3Nej3");

var $coI4l = parcelRequire("coI4l");
function $97df4a26a6db127b$export$81c40ebfe660d3ca(data, options) {
    if (typeof data === "string") return (0, $dcQkc.makeStringIterator)(data, options);
    if (data instanceof ArrayBuffer) return (0, $6DBWE.makeArrayBufferIterator)(data, options);
    if ((0, $coI4l.isBlob)(data)) return (0, $tsOGf.makeBlobIterator)(data, options);
    if ((0, $coI4l.isReadableStream)(data)) return (0, $3Nej3.makeStreamIterator)(data, options);
    if ((0, $coI4l.isResponse)(data)) {
        const response = data;
        return (0, $3Nej3.makeStreamIterator)(response.body, options);
    }
    throw new Error("makeIterator");
}

});
parcelRegister("dcQkc", function(module, exports) {

$parcel$export(module.exports, "makeStringIterator", function () { return $99d4fbf18100acc8$export$c51500126ec60dd4; });
const $99d4fbf18100acc8$var$DEFAULT_CHUNK_SIZE = 262144;
function* $99d4fbf18100acc8$export$c51500126ec60dd4(string, options) {
    const chunkSize = (options === null || options === void 0 ? void 0 : options.chunkSize) || $99d4fbf18100acc8$var$DEFAULT_CHUNK_SIZE;
    let offset = 0;
    const textEncoder = new TextEncoder();
    while(offset < string.length){
        const chunkLength = Math.min(string.length - offset, chunkSize);
        const chunk = string.slice(offset, offset + chunkLength);
        offset += chunkLength;
        yield textEncoder.encode(chunk);
    }
}

});

parcelRegister("6DBWE", function(module, exports) {

$parcel$export(module.exports, "makeArrayBufferIterator", function () { return $4d53d1af3e9d5d58$export$257e4501e13446d3; });
const $4d53d1af3e9d5d58$var$DEFAULT_CHUNK_SIZE = 262144;
function $4d53d1af3e9d5d58$export$257e4501e13446d3(arrayBuffer) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function*() {
        const { chunkSize: chunkSize = $4d53d1af3e9d5d58$var$DEFAULT_CHUNK_SIZE } = options;
        let byteOffset = 0;
        while(byteOffset < arrayBuffer.byteLength){
            const chunkByteLength = Math.min(arrayBuffer.byteLength - byteOffset, chunkSize);
            const chunk = new ArrayBuffer(chunkByteLength);
            const sourceArray = new Uint8Array(arrayBuffer, byteOffset, chunkByteLength);
            const chunkArray = new Uint8Array(chunk);
            chunkArray.set(sourceArray);
            byteOffset += chunkByteLength;
            yield chunk;
        }
    }();
}

});

parcelRegister("tsOGf", function(module, exports) {

$parcel$export(module.exports, "makeBlobIterator", function () { return $05890fe3e47fd9d8$export$97cfd032a0f445d2; });
const $05890fe3e47fd9d8$var$DEFAULT_CHUNK_SIZE = 1048576;
async function* $05890fe3e47fd9d8$export$97cfd032a0f445d2(blob, options) {
    const chunkSize = (options === null || options === void 0 ? void 0 : options.chunkSize) || $05890fe3e47fd9d8$var$DEFAULT_CHUNK_SIZE;
    let offset = 0;
    while(offset < blob.size){
        const end = offset + chunkSize;
        const chunk = await blob.slice(offset, end).arrayBuffer();
        offset = end;
        yield chunk;
    }
}

});

parcelRegister("3Nej3", function(module, exports) {

$parcel$export(module.exports, "makeStreamIterator", function () { return $2c310b9d65c4021e$export$80460602c027534f; });

var $ckgCq = parcelRequire("ckgCq");
var $7YX1b = parcelRequire("7YX1b");
function $2c310b9d65c4021e$export$80460602c027534f(stream, options) {
    return (0, $ckgCq.isBrowser) ? $2c310b9d65c4021e$var$makeBrowserStreamIterator(stream, options) : $2c310b9d65c4021e$var$makeNodeStreamIterator(stream, options);
}
async function* $2c310b9d65c4021e$var$makeBrowserStreamIterator(stream, options) {
    const reader = stream.getReader();
    let nextBatchPromise;
    try {
        while(true){
            const currentBatchPromise = nextBatchPromise || reader.read();
            if (options !== null && options !== void 0 && options._streamReadAhead) nextBatchPromise = reader.read();
            const { done: done, value: value } = await currentBatchPromise;
            if (done) return;
            yield (0, $7YX1b.toArrayBuffer)(value);
        }
    } catch (error) {
        reader.releaseLock();
    }
}
async function* $2c310b9d65c4021e$var$makeNodeStreamIterator(stream, options) {
    for await (const chunk of stream)yield (0, $7YX1b.toArrayBuffer)(chunk);
}

});
parcelRegister("7YX1b", function(module, exports) {

$parcel$export(module.exports, "toArrayBuffer", function () { return $5cfbeac9aa699d5f$export$8b22b05f429b130c; });

var $3A8IA = parcelRequire("3A8IA");
function $5cfbeac9aa699d5f$export$a7884ebc965f8f54(value) {
    return value && typeof value === "object" && value.isBuffer;
}
function $5cfbeac9aa699d5f$export$fc336dbfaf62f18f(data) {
    return $3A8IA.toBuffer ? $3A8IA.toBuffer(data) : data;
}
function $5cfbeac9aa699d5f$export$8b22b05f429b130c(data) {
    if ($5cfbeac9aa699d5f$export$a7884ebc965f8f54(data)) return $3A8IA.toArrayBuffer(data);
    if (data instanceof ArrayBuffer) return data;
    if (ArrayBuffer.isView(data)) {
        if (data.byteOffset === 0 && data.byteLength === data.buffer.byteLength) return data.buffer;
        return data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength);
    }
    if (typeof data === "string") {
        const text = data;
        const uint8Array = new TextEncoder().encode(text);
        return uint8Array.buffer;
    }
    if (data && typeof data === "object" && data._toArrayBuffer) return data._toArrayBuffer();
    throw new Error("toArrayBuffer");
}

});
parcelRegister("3A8IA", function(module, exports) {

$parcel$export(module.exports, "toArrayBuffer", function () { return $29bb7f1b76ae3ddf$export$8b22b05f429b130c; });
$parcel$export(module.exports, "toBuffer", function () { return $29bb7f1b76ae3ddf$export$fc336dbfaf62f18f; });
function $29bb7f1b76ae3ddf$export$8b22b05f429b130c(buffer) {
    return buffer;
}
function $29bb7f1b76ae3ddf$export$fc336dbfaf62f18f(binaryData) {
    throw new Error("Buffer not supported in browser");
}

});





parcelRegister("7VNil", function(module, exports) {

$parcel$export(module.exports, "getLoaderContext", function () { return $5c641837d2f5cfde$export$c9fdcdb31d4bf289; });
$parcel$export(module.exports, "getLoadersFromContext", function () { return $5c641837d2f5cfde$export$f7bef68ca326d506; });

var $2QP2i = parcelRequire("2QP2i");

var $j9Kyb = parcelRequire("j9Kyb");

var $2z7S5 = parcelRequire("2z7S5");

var $btvlZ = parcelRequire("btvlZ");
function $5c641837d2f5cfde$export$c9fdcdb31d4bf289(context, options, parentContext) {
    if (parentContext) return parentContext;
    const newContext = (0, $2QP2i._)({
        fetch: (0, $j9Kyb.getFetchFunction)(options, context)
    }, context);
    if (newContext.url) {
        const baseUrl = (0, $2z7S5.stripQueryString)(newContext.url);
        newContext.baseUrl = baseUrl;
        newContext.queryString = (0, $2z7S5.extractQueryString)(newContext.url);
        newContext.filename = (0, $btvlZ).filename(baseUrl);
        newContext.baseUrl = (0, $btvlZ).dirname(baseUrl);
    }
    if (!Array.isArray(newContext.loaders)) newContext.loaders = null;
    return newContext;
}
function $5c641837d2f5cfde$export$f7bef68ca326d506(loaders, context) {
    if (!context && loaders && !Array.isArray(loaders)) return loaders;
    let candidateLoaders;
    if (loaders) candidateLoaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    if (context && context.loaders) {
        const contextLoaders = Array.isArray(context.loaders) ? context.loaders : [
            context.loaders
        ];
        candidateLoaders = candidateLoaders ? [
            ...candidateLoaders,
            ...contextLoaders
        ] : contextLoaders;
    }
    return candidateLoaders && candidateLoaders.length ? candidateLoaders : null;
}

});
parcelRegister("btvlZ", function(module, exports) {

$parcel$export(module.exports, "filename", function () { return $85aab9553d1d93cd$export$f9107b66120eb036; });
$parcel$export(module.exports, "dirname", function () { return $85aab9553d1d93cd$export$7f7b8152cc673abe; });
$parcel$export(module.exports, "join", function () { return $85aab9553d1d93cd$export$f7e2c8231c57a8bd; });
$parcel$export(module.exports, "resolve", function () { return $85aab9553d1d93cd$export$f7ad0328861e2f03; });

var $b8TAO = parcelRequire("b8TAO");
function $85aab9553d1d93cd$export$f9107b66120eb036(url) {
    const slashIndex = url ? url.lastIndexOf("/") : -1;
    return slashIndex >= 0 ? url.substr(slashIndex + 1) : "";
}
function $85aab9553d1d93cd$export$7f7b8152cc673abe(url) {
    const slashIndex = url ? url.lastIndexOf("/") : -1;
    return slashIndex >= 0 ? url.substr(0, slashIndex) : "";
}
function $85aab9553d1d93cd$export$f7e2c8231c57a8bd() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++)parts[_key] = arguments[_key];
    const separator = "/";
    parts = parts.map((part, index)=>{
        if (index) part = part.replace(new RegExp("^".concat(separator)), "");
        if (index !== parts.length - 1) part = part.replace(new RegExp("".concat(separator, "$")), "");
        return part;
    });
    return parts.join(separator);
}
function $85aab9553d1d93cd$export$f7ad0328861e2f03() {
    const paths = [];
    for(let _i = 0; _i < arguments.length; _i++)paths[_i] = _i < 0 || arguments.length <= _i ? undefined : arguments[_i];
    let resolvedPath = "";
    let resolvedAbsolute = false;
    let cwd;
    for(let i = paths.length - 1; i >= -1 && !resolvedAbsolute; i--){
        let path;
        if (i >= 0) path = paths[i];
        else {
            if (cwd === undefined) cwd = (0, $b8TAO.getCWD)();
            path = cwd;
        }
        if (path.length === 0) continue;
        resolvedPath = "".concat(path, "/").concat(resolvedPath);
        resolvedAbsolute = path.charCodeAt(0) === $85aab9553d1d93cd$var$SLASH;
    }
    resolvedPath = $85aab9553d1d93cd$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
    if (resolvedAbsolute) return "/".concat(resolvedPath);
    else if (resolvedPath.length > 0) return resolvedPath;
    return ".";
}
const $85aab9553d1d93cd$var$SLASH = 47;
const $85aab9553d1d93cd$var$DOT = 46;
function $85aab9553d1d93cd$var$normalizeStringPosix(path, allowAboveRoot) {
    let res = "";
    let lastSlash = -1;
    let dots = 0;
    let code;
    let isAboveRoot = false;
    for(let i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === $85aab9553d1d93cd$var$SLASH) break;
        else code = $85aab9553d1d93cd$var$SLASH;
        if (code === $85aab9553d1d93cd$var$SLASH) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || !isAboveRoot || res.charCodeAt(res.length - 1) !== $85aab9553d1d93cd$var$DOT || res.charCodeAt(res.length - 2) !== $85aab9553d1d93cd$var$DOT) {
                    if (res.length > 2) {
                        const start = res.length - 1;
                        let j = start;
                        for(; j >= 0; --j){
                            if (res.charCodeAt(j) === $85aab9553d1d93cd$var$SLASH) break;
                        }
                        if (j !== start) {
                            res = j === -1 ? "" : res.slice(0, j);
                            lastSlash = i;
                            dots = 0;
                            isAboveRoot = false;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSlash = i;
                        dots = 0;
                        isAboveRoot = false;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    isAboveRoot = true;
                }
            } else {
                const slice = path.slice(lastSlash + 1, i);
                if (res.length > 0) res += "/".concat(slice);
                else res = slice;
                isAboveRoot = false;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === $85aab9553d1d93cd$var$DOT && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}

});
parcelRegister("b8TAO", function(module, exports) {

$parcel$export(module.exports, "getCWD", function () { return $81cb909c7b78704f$export$f89482d66a91eb15; });

var $95Bnk = parcelRequire("95Bnk");
function $81cb909c7b78704f$export$f89482d66a91eb15() {
    var _window$location;
    if (typeof $95Bnk !== "undefined" && typeof $95Bnk.cwd !== "undefined") return $95Bnk.cwd();
    const pathname = (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname;
    return (pathname === null || pathname === void 0 ? void 0 : pathname.slice(0, pathname.lastIndexOf("/") + 1)) || "";
}

});



parcelRegister("9pRlR", function(module, exports) {

$parcel$export(module.exports, "selectLoader", function () { return $6dafd55f4b8cbdf9$export$c633f22f376a9a73; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $grxRA = parcelRequire("grxRA");
var $btvlZ = parcelRequire("btvlZ");

var $vyOkv = parcelRequire("vyOkv");

var $2KjuU = parcelRequire("2KjuU");

var $l6GmM = parcelRequire("l6GmM");

var $21Tvc = parcelRequire("21Tvc");

var $coI4l = parcelRequire("coI4l");

var $2z7S5 = parcelRequire("2z7S5");
const $6dafd55f4b8cbdf9$var$EXT_PATTERN = /\.([^.]+)$/;
async function $6dafd55f4b8cbdf9$export$c633f22f376a9a73(data) {
    let loaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let options = arguments.length > 2 ? arguments[2] : undefined;
    let context = arguments.length > 3 ? arguments[3] : undefined;
    if (!$6dafd55f4b8cbdf9$var$validHTTPResponse(data)) return null;
    let loader = $6dafd55f4b8cbdf9$export$27c49426aa5beb44(data, loaders, (0, $edHbI._)((0, $2QP2i._)({}, options), {
        nothrow: true
    }), context);
    if (loader) return loader;
    if ((0, $coI4l.isBlob)(data)) {
        data = await data.slice(0, 10).arrayBuffer();
        loader = $6dafd55f4b8cbdf9$export$27c49426aa5beb44(data, loaders, options, context);
    }
    if (!loader && !(options !== null && options !== void 0 && options.nothrow)) throw new Error($6dafd55f4b8cbdf9$var$getNoValidLoaderMessage(data));
    return loader;
}
function $6dafd55f4b8cbdf9$export$27c49426aa5beb44(data) {
    let loaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let options = arguments.length > 2 ? arguments[2] : undefined;
    let context = arguments.length > 3 ? arguments[3] : undefined;
    if (!$6dafd55f4b8cbdf9$var$validHTTPResponse(data)) return null;
    if (loaders && !Array.isArray(loaders)) return (0, $vyOkv.normalizeLoader)(loaders);
    let candidateLoaders = [];
    if (loaders) candidateLoaders = candidateLoaders.concat(loaders);
    if (!(options !== null && options !== void 0 && options.ignoreRegisteredLoaders)) candidateLoaders.push(...(0, $21Tvc.getRegisteredLoaders)());
    $6dafd55f4b8cbdf9$var$normalizeLoaders(candidateLoaders);
    const loader = $6dafd55f4b8cbdf9$var$selectLoaderInternal(data, candidateLoaders, options, context);
    if (!loader && !(options !== null && options !== void 0 && options.nothrow)) throw new Error($6dafd55f4b8cbdf9$var$getNoValidLoaderMessage(data));
    return loader;
}
function $6dafd55f4b8cbdf9$var$selectLoaderInternal(data, loaders, options, context) {
    const url = (0, $l6GmM.getResourceUrl)(data);
    const type = (0, $l6GmM.getResourceMIMEType)(data);
    const testUrl = (0, $2z7S5.stripQueryString)(url) || (context === null || context === void 0 ? void 0 : context.url);
    let loader = null;
    let reason = "";
    if (options !== null && options !== void 0 && options.mimeType) {
        loader = $6dafd55f4b8cbdf9$var$findLoaderByMIMEType(loaders, options === null || options === void 0 ? void 0 : options.mimeType);
        reason = "match forced by supplied MIME type ".concat(options === null || options === void 0 ? void 0 : options.mimeType);
    }
    loader = loader || $6dafd55f4b8cbdf9$var$findLoaderByUrl(loaders, testUrl);
    reason = reason || (loader ? "matched url ".concat(testUrl) : "");
    loader = loader || $6dafd55f4b8cbdf9$var$findLoaderByMIMEType(loaders, type);
    reason = reason || (loader ? "matched MIME type ".concat(type) : "");
    loader = loader || $6dafd55f4b8cbdf9$var$findLoaderByInitialBytes(loaders, data);
    reason = reason || (loader ? "matched initial data ".concat($6dafd55f4b8cbdf9$var$getFirstCharacters(data)) : "");
    loader = loader || $6dafd55f4b8cbdf9$var$findLoaderByMIMEType(loaders, options === null || options === void 0 ? void 0 : options.fallbackMimeType);
    reason = reason || (loader ? "matched fallback MIME type ".concat(type) : "");
    if (reason) {
        var _loader;
        (0, $2KjuU.log).log(1, "selectLoader selected ".concat((_loader = loader) === null || _loader === void 0 ? void 0 : _loader.name, ": ").concat(reason, "."));
    }
    return loader;
}
function $6dafd55f4b8cbdf9$var$validHTTPResponse(data) {
    if (data instanceof Response) {
        if (data.status === 204) return false;
    }
    return true;
}
function $6dafd55f4b8cbdf9$var$getNoValidLoaderMessage(data) {
    const url = (0, $l6GmM.getResourceUrl)(data);
    const type = (0, $l6GmM.getResourceMIMEType)(data);
    let message = "No valid loader found (";
    message += url ? "".concat((0, $btvlZ).filename(url), ", ") : "no url provided, ";
    message += "MIME type: ".concat(type ? '"'.concat(type, '"') : "not provided", ", ");
    const firstCharacters = data ? $6dafd55f4b8cbdf9$var$getFirstCharacters(data) : "";
    message += firstCharacters ? ' first bytes: "'.concat(firstCharacters, '"') : "first bytes: not available";
    message += ")";
    return message;
}
function $6dafd55f4b8cbdf9$var$normalizeLoaders(loaders) {
    for (const loader of loaders)(0, $vyOkv.normalizeLoader)(loader);
}
function $6dafd55f4b8cbdf9$var$findLoaderByUrl(loaders, url) {
    const match = url && $6dafd55f4b8cbdf9$var$EXT_PATTERN.exec(url);
    const extension = match && match[1];
    return extension ? $6dafd55f4b8cbdf9$var$findLoaderByExtension(loaders, extension) : null;
}
function $6dafd55f4b8cbdf9$var$findLoaderByExtension(loaders, extension) {
    extension = extension.toLowerCase();
    for (const loader of loaders)for (const loaderExtension of loader.extensions){
        if (loaderExtension.toLowerCase() === extension) return loader;
    }
    return null;
}
function $6dafd55f4b8cbdf9$var$findLoaderByMIMEType(loaders, mimeType) {
    for (const loader of loaders){
        if (loader.mimeTypes && loader.mimeTypes.includes(mimeType)) return loader;
        if (mimeType === "application/x.".concat(loader.id)) return loader;
    }
    return null;
}
function $6dafd55f4b8cbdf9$var$findLoaderByInitialBytes(loaders, data) {
    if (!data) return null;
    for (const loader of loaders){
        if (typeof data === "string") {
            if ($6dafd55f4b8cbdf9$var$testDataAgainstText(data, loader)) return loader;
        } else if (ArrayBuffer.isView(data)) {
            if ($6dafd55f4b8cbdf9$var$testDataAgainstBinary(data.buffer, data.byteOffset, loader)) return loader;
        } else if (data instanceof ArrayBuffer) {
            const byteOffset = 0;
            if ($6dafd55f4b8cbdf9$var$testDataAgainstBinary(data, byteOffset, loader)) return loader;
        }
    }
    return null;
}
function $6dafd55f4b8cbdf9$var$testDataAgainstText(data, loader) {
    if (loader.testText) return loader.testText(data);
    const tests = Array.isArray(loader.tests) ? loader.tests : [
        loader.tests
    ];
    return tests.some((test)=>data.startsWith(test));
}
function $6dafd55f4b8cbdf9$var$testDataAgainstBinary(data, byteOffset, loader) {
    const tests = Array.isArray(loader.tests) ? loader.tests : [
        loader.tests
    ];
    return tests.some((test)=>$6dafd55f4b8cbdf9$var$testBinary(data, byteOffset, loader, test));
}
function $6dafd55f4b8cbdf9$var$testBinary(data, byteOffset, loader, test) {
    if (test instanceof ArrayBuffer) return (0, $grxRA.compareArrayBuffers)(test, data, test.byteLength);
    switch(typeof test){
        case "function":
            return test(data, loader);
        case "string":
            const magic = $6dafd55f4b8cbdf9$var$getMagicString(data, byteOffset, test.length);
            return test === magic;
        default:
            return false;
    }
}
function $6dafd55f4b8cbdf9$var$getFirstCharacters(data) {
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    if (typeof data === "string") return data.slice(0, length);
    else if (ArrayBuffer.isView(data)) return $6dafd55f4b8cbdf9$var$getMagicString(data.buffer, data.byteOffset, length);
    else if (data instanceof ArrayBuffer) {
        const byteOffset = 0;
        return $6dafd55f4b8cbdf9$var$getMagicString(data, byteOffset, length);
    }
    return "";
}
function $6dafd55f4b8cbdf9$var$getMagicString(arrayBuffer, byteOffset, length) {
    if (arrayBuffer.byteLength < byteOffset + length) return "";
    const dataView = new DataView(arrayBuffer);
    let magic = "";
    for(let i = 0; i < length; i++)magic += String.fromCharCode(dataView.getUint8(byteOffset + i));
    return magic;
}

});
parcelRegister("2KjuU", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $1fff0077549acd65$export$bef1f36f5486a6a3; });
parcelRequire("d0O9t");
var $dwYH5 = parcelRequire("dwYH5");
const $1fff0077549acd65$export$bef1f36f5486a6a3 = new (0, $dwYH5.Log)({
    id: "loaders.gl"
});

});

parcelRegister("21Tvc", function(module, exports) {

$parcel$export(module.exports, "registerLoaders", function () { return $17a6ba572a1d1c74$export$74069a1a10fa28e5; });
$parcel$export(module.exports, "getRegisteredLoaders", function () { return $17a6ba572a1d1c74$export$8fa02447f82aef84; });

var $vyOkv = parcelRequire("vyOkv");

var $8mcNl = parcelRequire("8mcNl");
const $17a6ba572a1d1c74$var$getGlobalLoaderRegistry = ()=>{
    const state = (0, $8mcNl.getGlobalLoaderState)();
    state.loaderRegistry = state.loaderRegistry || [];
    return state.loaderRegistry;
};
function $17a6ba572a1d1c74$export$74069a1a10fa28e5(loaders) {
    const loaderRegistry = $17a6ba572a1d1c74$var$getGlobalLoaderRegistry();
    loaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    for (const loader of loaders){
        const normalizedLoader = (0, $vyOkv.normalizeLoader)(loader);
        if (!loaderRegistry.find((registeredLoader)=>normalizedLoader === registeredLoader)) loaderRegistry.unshift(normalizedLoader);
    }
}
function $17a6ba572a1d1c74$export$8fa02447f82aef84() {
    return $17a6ba572a1d1c74$var$getGlobalLoaderRegistry();
}
function $17a6ba572a1d1c74$export$a20f34177d9a64c6() {
    const state = (0, $8mcNl.getGlobalLoaderState)();
    state.loaderRegistry = [];
}

});






parcelRegister("7VEAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c5d57721819d245$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $7gQQK = parcelRequire("7gQQK");
var $b8HWT = parcelRequire("b8HWT");
var $i46md = parcelRequire("i46md");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");

var $68aPy = parcelRequire("68aPy");
var $cxTxU = parcelRequire("cxTxU");
var $tIWfJ = parcelRequire("tIWfJ");
var $b2F4S = parcelRequire("b2F4S");

var $dzzPJ = parcelRequire("dzzPJ");

var $jrNr2 = parcelRequire("jrNr2");

var $a5Son = parcelRequire("a5Son");

var $43aPw = parcelRequire("43aPw");
const $5c5d57721819d245$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $5c5d57721819d245$var$defaultProps = {
    filled: true,
    extruded: false,
    wireframe: false,
    _normalize: true,
    _windingOrder: "CW",
    _full3d: false,
    elevationScale: {
        type: "number",
        min: 0,
        value: 1
    },
    getPolygon: {
        type: "accessor",
        value: (f)=>f.polygon
    },
    getElevation: {
        type: "accessor",
        value: 1000
    },
    getFillColor: {
        type: "accessor",
        value: $5c5d57721819d245$var$DEFAULT_COLOR
    },
    getLineColor: {
        type: "accessor",
        value: $5c5d57721819d245$var$DEFAULT_COLOR
    },
    material: true
};
const $5c5d57721819d245$var$ATTRIBUTE_TRANSITION = {
    enter: (value, chunk)=>{
        return chunk.length ? chunk.subarray(chunk.length - value.length) : value;
    }
};
class $5c5d57721819d245$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getShaders(type) {
        return super.getShaders({
            vs: type === "top" ? (0, $jrNr2.default) : (0, $a5Son.default),
            fs: $43aPw.default,
            defines: {
                RING_WINDING_ORDER_CW: !this.props._normalize && this.props._windingOrder === "CCW" ? 0 : 1
            },
            modules: [
                (0, $jRSMz.default),
                (0, $b8HWT.gouraudLighting),
                (0, $7UxuR.default)
            ]
        });
    }
    get wrapLongitude() {
        return false;
    }
    initializeState() {
        const { gl: gl, viewport: viewport } = this.context;
        let { coordinateSystem: coordinateSystem } = this.props;
        const { _full3d: _full3d } = this.props;
        if (viewport.isGeospatial && coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).DEFAULT) coordinateSystem = (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT;
        let preproject;
        if (coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).LNGLAT) {
            if (_full3d) preproject = viewport.projectPosition.bind(viewport);
            else preproject = viewport.projectFlat.bind(viewport);
        }
        this.setState({
            numInstances: 0,
            polygonTesselator: new (0, $dzzPJ.default)({
                preproject: preproject,
                fp64: this.use64bitPositions(),
                IndexType: !gl || (0, $tIWfJ.hasFeatures)(gl, (0, $68aPy.FEATURES).ELEMENT_INDEX_UINT32) ? Uint32Array : Uint16Array
            })
        });
        const attributeManager = this.getAttributeManager();
        const noAlloc = true;
        attributeManager.remove([
            "instancePickingColors"
        ]);
        attributeManager.add({
            indices: {
                size: 1,
                isIndexed: true,
                update: this.calculateIndices,
                noAlloc: noAlloc
            },
            positions: {
                size: 3,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: $5c5d57721819d245$var$ATTRIBUTE_TRANSITION,
                accessor: "getPolygon",
                update: this.calculatePositions,
                noAlloc: noAlloc,
                shaderAttributes: {
                    positions: {
                        vertexOffset: 0,
                        divisor: 0
                    },
                    instancePositions: {
                        vertexOffset: 0,
                        divisor: 1
                    },
                    nextPositions: {
                        vertexOffset: 1,
                        divisor: 1
                    }
                }
            },
            vertexValid: {
                size: 1,
                divisor: 1,
                type: 5121,
                update: this.calculateVertexValid,
                noAlloc: noAlloc
            },
            elevations: {
                size: 1,
                transition: $5c5d57721819d245$var$ATTRIBUTE_TRANSITION,
                accessor: "getElevation",
                shaderAttributes: {
                    elevations: {
                        divisor: 0
                    },
                    instanceElevations: {
                        divisor: 1
                    }
                }
            },
            fillColors: {
                size: this.props.colorFormat.length,
                type: 5121,
                normalized: true,
                transition: $5c5d57721819d245$var$ATTRIBUTE_TRANSITION,
                accessor: "getFillColor",
                defaultValue: $5c5d57721819d245$var$DEFAULT_COLOR,
                shaderAttributes: {
                    fillColors: {
                        divisor: 0
                    },
                    instanceFillColors: {
                        divisor: 1
                    }
                }
            },
            lineColors: {
                size: this.props.colorFormat.length,
                type: 5121,
                normalized: true,
                transition: $5c5d57721819d245$var$ATTRIBUTE_TRANSITION,
                accessor: "getLineColor",
                defaultValue: $5c5d57721819d245$var$DEFAULT_COLOR,
                shaderAttributes: {
                    lineColors: {
                        divisor: 0
                    },
                    instanceLineColors: {
                        divisor: 1
                    }
                }
            },
            pickingColors: {
                size: 3,
                type: 5121,
                accessor: (object, { index: index, target: value })=>this.encodePickingColor(object && object.__source ? object.__source.index : index, value),
                shaderAttributes: {
                    pickingColors: {
                        divisor: 0
                    },
                    instancePickingColors: {
                        divisor: 1
                    }
                }
            }
        });
    }
    getPickingInfo(params) {
        const info = super.getPickingInfo(params);
        const { index: index } = info;
        const { data: data } = this.props;
        if (data[0] && data[0].__source) info.object = data.find((d)=>d.__source.index === index);
        return info;
    }
    disablePickingIndex(objectIndex) {
        const { data: data } = this.props;
        if (data[0] && data[0].__source) {
            for(let i = 0; i < data.length; i++)if (data[i].__source.index === objectIndex) this._disablePickingIndex(i);
        } else super.disablePickingIndex(objectIndex);
    }
    draw({ uniforms: uniforms }) {
        const { extruded: extruded, filled: filled, wireframe: wireframe, elevationScale: elevationScale } = this.props;
        const { topModel: topModel, sideModel: sideModel, polygonTesselator: polygonTesselator } = this.state;
        const renderUniforms = (0, $edHbI._)((0, $2QP2i._)({}, uniforms), {
            extruded: Boolean(extruded),
            elevationScale: elevationScale
        });
        if (sideModel) {
            sideModel.setInstanceCount(polygonTesselator.instanceCount - 1);
            sideModel.setUniforms(renderUniforms);
            if (wireframe) {
                sideModel.setDrawMode(3);
                sideModel.setUniforms({
                    isWireframe: true
                }).draw();
            }
            if (filled) {
                sideModel.setDrawMode(6);
                sideModel.setUniforms({
                    isWireframe: false
                }).draw();
            }
        }
        if (topModel) {
            topModel.setVertexCount(polygonTesselator.vertexCount);
            topModel.setUniforms(renderUniforms).draw();
        }
    }
    updateState(updateParams) {
        super.updateState(updateParams);
        this.updateGeometry(updateParams);
        const { props: props, oldProps: oldProps, changeFlags: changeFlags } = updateParams;
        const attributeManager = this.getAttributeManager();
        const regenerateModels = changeFlags.extensionsChanged || props.filled !== oldProps.filled || props.extruded !== oldProps.extruded;
        if (regenerateModels) {
            var _this$state$models;
            (_this$state$models = this.state.models) === null || _this$state$models === void 0 || _this$state$models.forEach((model)=>model.delete());
            this.setState(this._getModels(this.context.gl));
            attributeManager.invalidateAll();
        }
    }
    updateGeometry({ props: props, oldProps: oldProps, changeFlags: changeFlags }) {
        const geometryConfigChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPolygon);
        if (geometryConfigChanged) {
            const { polygonTesselator: polygonTesselator } = this.state;
            const buffers = props.data.attributes || {};
            polygonTesselator.updateGeometry({
                data: props.data,
                normalize: props._normalize,
                geometryBuffer: buffers.getPolygon,
                buffers: buffers,
                getGeometry: props.getPolygon,
                positionFormat: props.positionFormat,
                wrapLongitude: props.wrapLongitude,
                resolution: this.context.viewport.resolution,
                fp64: this.use64bitPositions(),
                dataChanged: changeFlags.dataChanged,
                full3d: props._full3d
            });
            this.setState({
                numInstances: polygonTesselator.instanceCount,
                startIndices: polygonTesselator.vertexStarts
            });
            if (!changeFlags.dataChanged) this.getAttributeManager().invalidateAll();
        }
    }
    _getModels(gl) {
        const { id: id, filled: filled, extruded: extruded } = this.props;
        let topModel;
        let sideModel;
        if (filled) {
            const shaders = this.getShaders("top");
            shaders.defines.NON_INSTANCED_MODEL = 1;
            topModel = new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, shaders), {
                id: "".concat(id, "-top"),
                drawMode: 4,
                attributes: {
                    vertexPositions: new Float32Array([
                        0,
                        1
                    ])
                },
                uniforms: {
                    isWireframe: false,
                    isSideVertex: false
                },
                vertexCount: 0,
                isIndexed: true
            }));
        }
        if (extruded) {
            sideModel = new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders("side")), {
                id: "".concat(id, "-side"),
                geometry: new (0, $cxTxU.default)({
                    drawMode: 1,
                    vertexCount: 4,
                    attributes: {
                        vertexPositions: {
                            size: 2,
                            value: new Float32Array([
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                1,
                                1
                            ])
                        }
                    }
                }),
                instanceCount: 0,
                isInstanced: 1
            }));
            sideModel.userData.excludeAttributes = {
                indices: true
            };
        }
        return {
            models: [
                sideModel,
                topModel
            ].filter(Boolean),
            topModel: topModel,
            sideModel: sideModel
        };
    }
    calculateIndices(attribute) {
        const { polygonTesselator: polygonTesselator } = this.state;
        attribute.startIndices = polygonTesselator.indexStarts;
        attribute.value = polygonTesselator.get("indices");
    }
    calculatePositions(attribute) {
        const { polygonTesselator: polygonTesselator } = this.state;
        attribute.startIndices = polygonTesselator.vertexStarts;
        attribute.value = polygonTesselator.get("positions");
    }
    calculateVertexValid(attribute) {
        attribute.value = this.state.polygonTesselator.get("vertexValid");
    }
    constructor(...args){
        super(...args);
        (0, $lEQUF.default)(this, "state", void 0);
    }
}
(0, $lEQUF.default)($5c5d57721819d245$export$2e2bcd8739ae039, "defaultProps", $5c5d57721819d245$var$defaultProps);
(0, $lEQUF.default)($5c5d57721819d245$export$2e2bcd8739ae039, "layerName", "SolidPolygonLayer");

});
parcelRegister("b8HWT", function(module, exports) {

$parcel$export(module.exports, "gouraudLighting", function () { return $81c2886745cee65b$export$cd1f8a021f9faae3; });
$parcel$export(module.exports, "phongLighting", function () { return $81c2886745cee65b$export$99431f9f19e64025; });

var $buD3P = parcelRequire("buD3P");

var $5xLHO = parcelRequire("5xLHO");
const $81c2886745cee65b$var$INITIAL_MODULE_OPTIONS = {};
function $81c2886745cee65b$var$getMaterialUniforms(material) {
    const { ambient: ambient = 0.35, diffuse: diffuse = 0.6, shininess: shininess = 32, specularColor: specularColor = [
        30,
        30,
        30
    ] } = material;
    return {
        lighting_uAmbient: ambient,
        lighting_uDiffuse: diffuse,
        lighting_uShininess: shininess,
        lighting_uSpecularColor: specularColor.map((x)=>x / 255)
    };
}
function $81c2886745cee65b$var$getUniforms() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $81c2886745cee65b$var$INITIAL_MODULE_OPTIONS;
    if (!("material" in opts)) return {};
    const { material: material } = opts;
    if (!material) return {
        lighting_uEnabled: false
    };
    return $81c2886745cee65b$var$getMaterialUniforms(material);
}
const $81c2886745cee65b$export$cd1f8a021f9faae3 = {
    name: "gouraud-lighting",
    dependencies: [
        (0, $buD3P.lights)
    ],
    vs: (0, $5xLHO.default),
    defines: {
        LIGHTING_VERTEX: 1
    },
    getUniforms: $81c2886745cee65b$var$getUniforms
};
const $81c2886745cee65b$export$99431f9f19e64025 = {
    name: "phong-lighting",
    dependencies: [
        (0, $buD3P.lights)
    ],
    fs: (0, $5xLHO.default),
    defines: {
        LIGHTING_FRAGMENT: 1
    },
    getUniforms: $81c2886745cee65b$var$getUniforms
};

});
parcelRegister("buD3P", function(module, exports) {

$parcel$export(module.exports, "lights", function () { return $85e0cbb2edd4d3b2$export$7c1fce12d7eeb101; });

var $lrhtR = parcelRequire("lrhtR");
const $85e0cbb2edd4d3b2$var$INITIAL_MODULE_OPTIONS = {
    lightSources: {}
};
function $85e0cbb2edd4d3b2$var$convertColor() {
    let { color: color = [
        0,
        0,
        0
    ], intensity: intensity = 1.0 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return color.map((component)=>component * intensity / 255.0);
}
function $85e0cbb2edd4d3b2$var$getLightSourceUniforms(_ref) {
    let { ambientLight: ambientLight, pointLights: pointLights = [], directionalLights: directionalLights = [] } = _ref;
    const lightSourceUniforms = {};
    if (ambientLight) lightSourceUniforms["lighting_uAmbientLight.color"] = $85e0cbb2edd4d3b2$var$convertColor(ambientLight);
    else lightSourceUniforms["lighting_uAmbientLight.color"] = [
        0,
        0,
        0
    ];
    pointLights.forEach((pointLight, index)=>{
        lightSourceUniforms["lighting_uPointLight[".concat(index, "].color")] = $85e0cbb2edd4d3b2$var$convertColor(pointLight);
        lightSourceUniforms["lighting_uPointLight[".concat(index, "].position")] = pointLight.position;
        lightSourceUniforms["lighting_uPointLight[".concat(index, "].attenuation")] = pointLight.attenuation || [
            1,
            0,
            0
        ];
    });
    lightSourceUniforms.lighting_uPointLightCount = pointLights.length;
    directionalLights.forEach((directionalLight, index)=>{
        lightSourceUniforms["lighting_uDirectionalLight[".concat(index, "].color")] = $85e0cbb2edd4d3b2$var$convertColor(directionalLight);
        lightSourceUniforms["lighting_uDirectionalLight[".concat(index, "].direction")] = directionalLight.direction;
    });
    lightSourceUniforms.lighting_uDirectionalLightCount = directionalLights.length;
    return lightSourceUniforms;
}
function $85e0cbb2edd4d3b2$var$getUniforms() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $85e0cbb2edd4d3b2$var$INITIAL_MODULE_OPTIONS;
    if ("lightSources" in opts) {
        const { ambientLight: ambientLight, pointLights: pointLights, directionalLights: directionalLights } = opts.lightSources || {};
        const hasLights = ambientLight || pointLights && pointLights.length > 0 || directionalLights && directionalLights.length > 0;
        if (!hasLights) return {
            lighting_uEnabled: false
        };
        return Object.assign({}, $85e0cbb2edd4d3b2$var$getLightSourceUniforms({
            ambientLight: ambientLight,
            pointLights: pointLights,
            directionalLights: directionalLights
        }), {
            lighting_uEnabled: true
        });
    }
    if ("lights" in opts) {
        const lightSources = {
            pointLights: [],
            directionalLights: []
        };
        for (const light of opts.lights || [])switch(light.type){
            case "ambient":
                lightSources.ambientLight = light;
                break;
            case "directional":
                lightSources.directionalLights.push(light);
                break;
            case "point":
                lightSources.pointLights.push(light);
                break;
            default:
        }
        return $85e0cbb2edd4d3b2$var$getUniforms({
            lightSources: lightSources
        });
    }
    return {};
}
const $85e0cbb2edd4d3b2$export$7c1fce12d7eeb101 = {
    name: "lights",
    vs: (0, $lrhtR.default),
    fs: (0, $lrhtR.default),
    getUniforms: $85e0cbb2edd4d3b2$var$getUniforms,
    defines: {
        MAX_LIGHTS: 3
    }
};

});
parcelRegister("lrhtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9b9ade30cd85b49$export$2e2bcd8739ae039; });
var $f9b9ade30cd85b49$export$2e2bcd8739ae039 = "#if (defined(SHADER_TYPE_FRAGMENT) && defined(LIGHTING_FRAGMENT)) || (defined(SHADER_TYPE_VERTEX) && defined(LIGHTING_VERTEX))\n\nstruct AmbientLight {\n vec3 color;\n};\n\nstruct PointLight {\n vec3 color;\n vec3 position;\n vec3 attenuation;\n};\n\nstruct DirectionalLight {\n  vec3 color;\n  vec3 direction;\n};\n\nuniform AmbientLight lighting_uAmbientLight;\nuniform PointLight lighting_uPointLight[MAX_LIGHTS];\nuniform DirectionalLight lighting_uDirectionalLight[MAX_LIGHTS];\nuniform int lighting_uPointLightCount;\nuniform int lighting_uDirectionalLightCount;\n\nuniform bool lighting_uEnabled;\n\nfloat getPointLightAttenuation(PointLight pointLight, float distance) {\n  return pointLight.attenuation.x\n       + pointLight.attenuation.y * distance\n       + pointLight.attenuation.z * distance * distance;\n}\n\n#endif\n";

});


parcelRegister("5xLHO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40950a2a5f53a6e3$export$2e2bcd8739ae039; });
var $40950a2a5f53a6e3$export$2e2bcd8739ae039 = "\nuniform float lighting_uAmbient;\nuniform float lighting_uDiffuse;\nuniform float lighting_uShininess;\nuniform vec3  lighting_uSpecularColor;\n\nvec3 lighting_getLightColor(vec3 surfaceColor, vec3 light_direction, vec3 view_direction, vec3 normal_worldspace, vec3 color) {\n    vec3 halfway_direction = normalize(light_direction + view_direction);\n    float lambertian = dot(light_direction, normal_worldspace);\n    float specular = 0.0;\n    if (lambertian > 0.0) {\n      float specular_angle = max(dot(normal_worldspace, halfway_direction), 0.0);\n      specular = pow(specular_angle, lighting_uShininess);\n    }\n    lambertian = max(lambertian, 0.0);\n    return (lambertian * lighting_uDiffuse * surfaceColor + specular * lighting_uSpecularColor) * color;\n}\n\nvec3 lighting_getLightColor(vec3 surfaceColor, vec3 cameraPosition, vec3 position_worldspace, vec3 normal_worldspace) {\n  vec3 lightColor = surfaceColor;\n\n  if (lighting_uEnabled) {\n    vec3 view_direction = normalize(cameraPosition - position_worldspace);\n    lightColor = lighting_uAmbient * surfaceColor * lighting_uAmbientLight.color;\n\n    for (int i = 0; i < MAX_LIGHTS; i++) {\n      if (i >= lighting_uPointLightCount) {\n        break;\n      }\n      PointLight pointLight = lighting_uPointLight[i];\n      vec3 light_position_worldspace = pointLight.position;\n      vec3 light_direction = normalize(light_position_worldspace - position_worldspace);\n      lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);\n    }\n\n    for (int i = 0; i < MAX_LIGHTS; i++) {\n      if (i >= lighting_uDirectionalLightCount) {\n        break;\n      }\n      DirectionalLight directionalLight = lighting_uDirectionalLight[i];\n      lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);\n    }\n  }\n  return lightColor;\n}\n\nvec3 lighting_getSpecularLightColor(vec3 cameraPosition, vec3 position_worldspace, vec3 normal_worldspace) {\n  vec3 lightColor = vec3(0, 0, 0);\n  vec3 surfaceColor = vec3(0, 0, 0);\n\n  if (lighting_uEnabled) {\n    vec3 view_direction = normalize(cameraPosition - position_worldspace);\n\n    for (int i = 0; i < MAX_LIGHTS; i++) {\n      if (i >= lighting_uPointLightCount) {\n        break;\n      }\n      PointLight pointLight = lighting_uPointLight[i];\n      vec3 light_position_worldspace = pointLight.position;\n      vec3 light_direction = normalize(light_position_worldspace - position_worldspace);\n      lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);\n    }\n\n    for (int i = 0; i < MAX_LIGHTS; i++) {\n      if (i >= lighting_uDirectionalLightCount) {\n        break;\n      }\n      DirectionalLight directionalLight = lighting_uDirectionalLight[i];\n      lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);\n    }\n  }\n  return lightColor;\n}\n";

});


parcelRegister("7UxuR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c27bf22a36d36e9$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $9gFKE = parcelRequire("9gFKE");
var $5c27bf22a36d36e9$export$2e2bcd8739ae039 = (0, $2QP2i._)({
    inject: {
        "vs:DECKGL_FILTER_GL_POSITION": "\n    // for picking depth values\n    picking_setPickingAttribute(position.z / position.w);\n  ",
        "vs:DECKGL_FILTER_COLOR": "\n  picking_setPickingColor(geometry.pickingColor);\n  ",
        "fs:#decl": "\nuniform bool picking_uAttribute;\n  ",
        "fs:DECKGL_FILTER_COLOR": {
            order: 99,
            injection: "\n  // use highlight color if this fragment belongs to the selected object.\n  color = picking_filterHighlightColor(color);\n\n  // use picking color if rendering to picking FBO.\n  color = picking_filterPickingColor(color);\n    "
        }
    }
}, (0, $9gFKE.picking));

});
parcelRegister("9gFKE", function(module, exports) {

$parcel$export(module.exports, "picking", function () { return $6bf5fea5aeab0fad$export$1f1790962c6071cf; });
const $6bf5fea5aeab0fad$var$DEFAULT_HIGHLIGHT_COLOR = new Uint8Array([
    0,
    255,
    255,
    255
]);
const $6bf5fea5aeab0fad$var$DEFAULT_MODULE_OPTIONS = {
    pickingSelectedColor: null,
    pickingHighlightColor: $6bf5fea5aeab0fad$var$DEFAULT_HIGHLIGHT_COLOR,
    pickingActive: false,
    pickingAttribute: false
};
function $6bf5fea5aeab0fad$var$getUniforms() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $6bf5fea5aeab0fad$var$DEFAULT_MODULE_OPTIONS;
    const uniforms = {};
    if (opts.pickingSelectedColor !== undefined) {
        if (!opts.pickingSelectedColor) uniforms.picking_uSelectedColorValid = 0;
        else {
            const selectedColor = opts.pickingSelectedColor.slice(0, 3);
            uniforms.picking_uSelectedColorValid = 1;
            uniforms.picking_uSelectedColor = selectedColor;
        }
    }
    if (opts.pickingHighlightColor) {
        const color = Array.from(opts.pickingHighlightColor, (x)=>x / 255);
        if (!Number.isFinite(color[3])) color[3] = 1;
        uniforms.picking_uHighlightColor = color;
    }
    if (opts.pickingActive !== undefined) {
        uniforms.picking_uActive = Boolean(opts.pickingActive);
        uniforms.picking_uAttribute = Boolean(opts.pickingAttribute);
    }
    return uniforms;
}
const $6bf5fea5aeab0fad$var$vs = "uniform bool picking_uActive;\nuniform bool picking_uAttribute;\nuniform vec3 picking_uSelectedColor;\nuniform bool picking_uSelectedColorValid;\n\nout vec4 picking_vRGBcolor_Avalid;\n\nconst float COLOR_SCALE = 1. / 255.;\n\nbool picking_isColorValid(vec3 color) {\n  return dot(color, vec3(1.0)) > 0.001;\n}\n\nbool isVertexPicked(vec3 vertexColor) {\n  return\n    picking_uSelectedColorValid &&\n    !picking_isColorValid(abs(vertexColor - picking_uSelectedColor));\n}\n\nvoid picking_setPickingColor(vec3 pickingColor) {\n  if (picking_uActive) {\n    picking_vRGBcolor_Avalid.a = float(picking_isColorValid(pickingColor));\n\n    if (!picking_uAttribute) {\n      picking_vRGBcolor_Avalid.rgb = pickingColor * COLOR_SCALE;\n    }\n  } else {\n    picking_vRGBcolor_Avalid.a = float(isVertexPicked(pickingColor));\n  }\n}\n\nvoid picking_setPickingAttribute(float value) {\n  if (picking_uAttribute) {\n    picking_vRGBcolor_Avalid.r = value;\n  }\n}\nvoid picking_setPickingAttribute(vec2 value) {\n  if (picking_uAttribute) {\n    picking_vRGBcolor_Avalid.rg = value;\n  }\n}\nvoid picking_setPickingAttribute(vec3 value) {\n  if (picking_uAttribute) {\n    picking_vRGBcolor_Avalid.rgb = value;\n  }\n}\n";
const $6bf5fea5aeab0fad$var$fs = "uniform bool picking_uActive;\nuniform vec3 picking_uSelectedColor;\nuniform vec4 picking_uHighlightColor;\n\nin vec4 picking_vRGBcolor_Avalid;\nvec4 picking_filterHighlightColor(vec4 color) {\n  if (picking_uActive) {\n    return color;\n  }\n  bool selected = bool(picking_vRGBcolor_Avalid.a);\n\n  if (selected) {\n    float highLightAlpha = picking_uHighlightColor.a;\n    float blendedAlpha = highLightAlpha + color.a * (1.0 - highLightAlpha);\n    float highLightRatio = highLightAlpha / blendedAlpha;\n\n    vec3 blendedRGB = mix(color.rgb, picking_uHighlightColor.rgb, highLightRatio);\n    return vec4(blendedRGB, blendedAlpha);\n  } else {\n    return color;\n  }\n}\nvec4 picking_filterPickingColor(vec4 color) {\n  if (picking_uActive) {\n    if (picking_vRGBcolor_Avalid.a == 0.0) {\n      discard;\n    }\n    return picking_vRGBcolor_Avalid;\n  }\n  return color;\n}\nvec4 picking_filterColor(vec4 color) {\n  vec4 highightColor = picking_filterHighlightColor(color);\n  return picking_filterPickingColor(highightColor);\n}\n\n";
const $6bf5fea5aeab0fad$export$1f1790962c6071cf = {
    name: "picking",
    vs: $6bf5fea5aeab0fad$var$vs,
    fs: $6bf5fea5aeab0fad$var$fs,
    getUniforms: $6bf5fea5aeab0fad$var$getUniforms
};

});


parcelRegister("jRSMz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e76d762d9e2cf5ca$export$2e2bcd8739ae039; });

var $ctBl1 = parcelRequire("ctBl1");
const $e76d762d9e2cf5ca$var$vs = "\nvec4 project_position_to_clipspace(\n  vec3 position, vec3 position64Low, vec3 offset, out vec4 commonPosition\n) {\n  vec3 projectedPosition = project_position(position, position64Low);\n  mat3 rotation;\n  if (project_needs_rotation(projectedPosition, rotation)) {\n    // offset is specified as ENU\n    // when in globe projection, rotate offset so that the ground alighs with the surface of the globe\n    offset = rotation * offset;\n  }\n  commonPosition = vec4(projectedPosition + offset, 1.0);\n  return project_common_position_to_clipspace(commonPosition);\n}\n\nvec4 project_position_to_clipspace(\n  vec3 position, vec3 position64Low, vec3 offset\n) {\n  vec4 commonPosition;\n  return project_position_to_clipspace(position, position64Low, offset, commonPosition);\n}\n";
var $e76d762d9e2cf5ca$export$2e2bcd8739ae039 = {
    name: "project32",
    dependencies: [
        (0, $ctBl1.default)
    ],
    vs: $e76d762d9e2cf5ca$var$vs
};

});
parcelRegister("ctBl1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9155280be49abf96$export$2e2bcd8739ae039; });

var $jdvz4 = parcelRequire("jdvz4");

var $9peGQ = parcelRequire("9peGQ");

var $2MtTu = parcelRequire("2MtTu");

var $3Zb7J = parcelRequire("3Zb7J");
const $9155280be49abf96$var$INITIAL_MODULE_OPTIONS = {};
function $9155280be49abf96$var$getUniforms(opts = $9155280be49abf96$var$INITIAL_MODULE_OPTIONS) {
    if ("viewport" in opts) return (0, $3Zb7J.getUniformsFromViewport)(opts);
    return {};
}
var $9155280be49abf96$export$2e2bcd8739ae039 = {
    name: "project",
    dependencies: [
        (0, $jdvz4.fp32),
        (0, $9peGQ.default)
    ],
    vs: (0, $2MtTu.default),
    getUniforms: $9155280be49abf96$var$getUniforms
};

});
parcelRegister("jdvz4", function(module, exports) {

$parcel$export(module.exports, "fp32", function () { return $dfd7b74fc039cc4e$export$d4bf4ab3180407a1; });
const $dfd7b74fc039cc4e$var$fp32shader = "#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND\nconst float TWO_PI = 6.2831854820251465;\nconst float PI_2 = 1.5707963705062866;\nconst float PI_16 = 0.1963495463132858;\n\nconst float SIN_TABLE_0 = 0.19509032368659973;\nconst float SIN_TABLE_1 = 0.3826834261417389;\nconst float SIN_TABLE_2 = 0.5555702447891235;\nconst float SIN_TABLE_3 = 0.7071067690849304;\n\nconst float COS_TABLE_0 = 0.9807852506637573;\nconst float COS_TABLE_1 = 0.9238795042037964;\nconst float COS_TABLE_2 = 0.8314695954322815;\nconst float COS_TABLE_3 = 0.7071067690849304;\n\nconst float INVERSE_FACTORIAL_3 = 1.666666716337204e-01;\nconst float INVERSE_FACTORIAL_5 = 8.333333767950535e-03;\nconst float INVERSE_FACTORIAL_7 = 1.9841270113829523e-04;\nconst float INVERSE_FACTORIAL_9 = 2.75573188446287533e-06;\n\nfloat sin_taylor_fp32(float a) {\n  float r, s, t, x;\n\n  if (a == 0.0) {\n    return 0.0;\n  }\n\n  x = -a * a;\n  s = a;\n  r = a;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_3;\n  s = s + t;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_5;\n  s = s + t;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_7;\n  s = s + t;\n\n  r = r * x;\n  t = r * INVERSE_FACTORIAL_9;\n  s = s + t;\n\n  return s;\n}\n\nvoid sincos_taylor_fp32(float a, out float sin_t, out float cos_t) {\n  if (a == 0.0) {\n    sin_t = 0.0;\n    cos_t = 1.0;\n  }\n  sin_t = sin_taylor_fp32(a);\n  cos_t = sqrt(1.0 - sin_t * sin_t);\n}\n\nfloat tan_taylor_fp32(float a) {\n    float sin_a;\n    float cos_a;\n\n    if (a == 0.0) {\n        return 0.0;\n    }\n    float z = floor(a / TWO_PI);\n    float r = a - TWO_PI * z;\n\n    float t;\n    float q = floor(r / PI_2 + 0.5);\n    int j = int(q);\n\n    if (j < -2 || j > 2) {\n        return 1.0 / 0.0;\n    }\n\n    t = r - PI_2 * q;\n\n    q = floor(t / PI_16 + 0.5);\n    int k = int(q);\n    int abs_k = int(abs(float(k)));\n\n    if (abs_k > 4) {\n        return 1.0 / 0.0;\n    } else {\n        t = t - PI_16 * q;\n    }\n\n    float u = 0.0;\n    float v = 0.0;\n\n    float sin_t, cos_t;\n    float s, c;\n    sincos_taylor_fp32(t, sin_t, cos_t);\n\n    if (k == 0) {\n        s = sin_t;\n        c = cos_t;\n    } else {\n        if (abs(float(abs_k) - 1.0) < 0.5) {\n            u = COS_TABLE_0;\n            v = SIN_TABLE_0;\n        } else if (abs(float(abs_k) - 2.0) < 0.5) {\n            u = COS_TABLE_1;\n            v = SIN_TABLE_1;\n        } else if (abs(float(abs_k) - 3.0) < 0.5) {\n            u = COS_TABLE_2;\n            v = SIN_TABLE_2;\n        } else if (abs(float(abs_k) - 4.0) < 0.5) {\n            u = COS_TABLE_3;\n            v = SIN_TABLE_3;\n        }\n        if (k > 0) {\n            s = u * sin_t + v * cos_t;\n            c = u * cos_t - v * sin_t;\n        } else {\n            s = u * sin_t - v * cos_t;\n            c = u * cos_t + v * sin_t;\n        }\n    }\n\n    if (j == 0) {\n        sin_a = s;\n        cos_a = c;\n    } else if (j == 1) {\n        sin_a = c;\n        cos_a = -s;\n    } else if (j == -1) {\n        sin_a = -c;\n        cos_a = s;\n    } else {\n        sin_a = -s;\n        cos_a = -c;\n    }\n    return sin_a / cos_a;\n}\n#endif\n\nfloat tan_fp32(float a) {\n#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND\n  return tan_taylor_fp32(a);\n#else\n  return tan(a);\n#endif\n}\n";
const $dfd7b74fc039cc4e$export$d4bf4ab3180407a1 = {
    name: "fp32",
    vs: $dfd7b74fc039cc4e$var$fp32shader,
    fs: null
};

});

parcelRegister("9peGQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d91d8006e7ae005$export$2e2bcd8739ae039; });
const $6d91d8006e7ae005$var$defines = "#define SMOOTH_EDGE_RADIUS 0.5";
const $6d91d8006e7ae005$var$vs = "\n".concat($6d91d8006e7ae005$var$defines, "\n\nstruct VertexGeometry {\n  vec4 position;\n  vec3 worldPosition;\n  vec3 worldPositionAlt;\n  vec3 normal;\n  vec2 uv;\n  vec3 pickingColor;\n} geometry = VertexGeometry(\n  vec4(0.0, 0.0, 1.0, 0.0),\n  vec3(0.0),\n  vec3(0.0),\n  vec3(0.0),\n  vec2(0.0),\n  vec3(0.0)\n);\n");
const $6d91d8006e7ae005$var$fs = "\n".concat($6d91d8006e7ae005$var$defines, "\n\nstruct FragmentGeometry {\n  vec2 uv;\n} geometry;\n\nfloat smoothedge(float edge, float x) {\n  return smoothstep(edge - SMOOTH_EDGE_RADIUS, edge + SMOOTH_EDGE_RADIUS, x);\n}\n");
var $6d91d8006e7ae005$export$2e2bcd8739ae039 = {
    name: "geometry",
    vs: $6d91d8006e7ae005$var$vs,
    fs: $6d91d8006e7ae005$var$fs
};

});

parcelRegister("2MtTu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $206740cd7e8a2965$export$2e2bcd8739ae039; });

var $7gQQK = parcelRequire("7gQQK");
const $206740cd7e8a2965$var$COORDINATE_SYSTEM_GLSL_CONSTANTS = Object.keys((0, $7gQQK.COORDINATE_SYSTEM)).map((key)=>"const int COORDINATE_SYSTEM_".concat(key, " = ").concat((0, $7gQQK.COORDINATE_SYSTEM)[key], ";")).join("");
const $206740cd7e8a2965$var$PROJECTION_MODE_GLSL_CONSTANTS = Object.keys((0, $7gQQK.PROJECTION_MODE)).map((key)=>"const int PROJECTION_MODE_".concat(key, " = ").concat((0, $7gQQK.PROJECTION_MODE)[key], ";")).join("");
const $206740cd7e8a2965$var$UNIT_GLSL_CONSTANTS = Object.keys((0, $7gQQK.UNIT)).map((key)=>"const int UNIT_".concat(key.toUpperCase(), " = ").concat((0, $7gQQK.UNIT)[key], ";")).join("");
var $206740cd7e8a2965$export$2e2bcd8739ae039 = "".concat($206740cd7e8a2965$var$COORDINATE_SYSTEM_GLSL_CONSTANTS, "\n").concat($206740cd7e8a2965$var$PROJECTION_MODE_GLSL_CONSTANTS, "\n").concat($206740cd7e8a2965$var$UNIT_GLSL_CONSTANTS, "\n\nuniform int project_uCoordinateSystem;\nuniform int project_uProjectionMode;\nuniform float project_uScale;\nuniform bool project_uWrapLongitude;\nuniform vec3 project_uCommonUnitsPerMeter;\nuniform vec3 project_uCommonUnitsPerWorldUnit;\nuniform vec3 project_uCommonUnitsPerWorldUnit2;\nuniform vec4 project_uCenter;\nuniform mat4 project_uModelMatrix;\nuniform mat4 project_uViewProjectionMatrix;\nuniform vec2 project_uViewportSize;\nuniform float project_uDevicePixelRatio;\nuniform float project_uFocalDistance;\nuniform vec3 project_uCameraPosition;\nuniform vec3 project_uCoordinateOrigin;\nuniform vec3 project_uCommonOrigin;\nuniform bool project_uPseudoMeters;\n\nconst float TILE_SIZE = 512.0;\nconst float PI = 3.1415926536;\nconst float WORLD_SCALE = TILE_SIZE / (PI * 2.0);\nconst vec3 ZERO_64_LOW = vec3(0.0);\nconst float EARTH_RADIUS = 6370972.0;\nconst float GLOBE_RADIUS = 256.0;\nfloat project_size_at_latitude(float lat) {\n  float y = clamp(lat, -89.9, 89.9);\n  return 1.0 / cos(radians(y));\n}\n\nfloat project_size() {\n  if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR &&\n    project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT &&\n    project_uPseudoMeters == false) {\n    \n    if (geometry.position.w == 0.0) {\n      return project_size_at_latitude(geometry.worldPosition.y);\n    }\n  \n    float y = geometry.position.y / TILE_SIZE * 2.0 - 1.0;\n    float y2 = y * y;\n    float y4 = y2 * y2;\n    float y6 = y4 * y2;\n    return 1.0 + 4.9348 * y2 + 4.0587 * y4 + 1.5642 * y6;\n  }\n  return 1.0;\n}\n\nfloat project_size_at_latitude(float meters, float lat) {\n  return meters * project_uCommonUnitsPerMeter.z * project_size_at_latitude(lat);\n}\nfloat project_size(float meters) {\n  return meters * project_uCommonUnitsPerMeter.z * project_size();\n}\n\nvec2 project_size(vec2 meters) {\n  return meters * project_uCommonUnitsPerMeter.xy * project_size();\n}\n\nvec3 project_size(vec3 meters) {\n  return meters * project_uCommonUnitsPerMeter * project_size();\n}\n\nvec4 project_size(vec4 meters) {\n  return vec4(meters.xyz * project_uCommonUnitsPerMeter, meters.w);\n}\nmat3 project_get_orientation_matrix(vec3 up) {\n  vec3 uz = normalize(up);\n  vec3 ux = abs(uz.z) == 1.0 ? vec3(1.0, 0.0, 0.0) : normalize(vec3(uz.y, -uz.x, 0));\n  vec3 uy = cross(uz, ux);\n  return mat3(ux, uy, uz);\n}\n\nbool project_needs_rotation(vec3 commonPosition, out mat3 transform) {\n  if (project_uProjectionMode == PROJECTION_MODE_GLOBE) {\n    transform = project_get_orientation_matrix(commonPosition);\n    return true;\n  }\n  return false;\n}\nvec3 project_normal(vec3 vector) {\n  vec4 normal_modelspace = project_uModelMatrix * vec4(vector, 0.0);\n  vec3 n = normalize(normal_modelspace.xyz * project_uCommonUnitsPerMeter);\n  mat3 rotation;\n  if (project_needs_rotation(geometry.position.xyz, rotation)) {\n    n = rotation * n;\n  }\n  return n;\n}\n\nvec4 project_offset_(vec4 offset) {\n  float dy = offset.y;\n  vec3 commonUnitsPerWorldUnit = project_uCommonUnitsPerWorldUnit + project_uCommonUnitsPerWorldUnit2 * dy;\n  return vec4(offset.xyz * commonUnitsPerWorldUnit, offset.w);\n}\nvec2 project_mercator_(vec2 lnglat) {\n  float x = lnglat.x;\n  if (project_uWrapLongitude) {\n    x = mod(x + 180., 360.0) - 180.;\n  }\n  float y = clamp(lnglat.y, -89.9, 89.9);\n  return vec2(\n    radians(x) + PI,\n    PI + log(tan_fp32(PI * 0.25 + radians(y) * 0.5))\n  ) * WORLD_SCALE;\n}\n\nvec3 project_globe_(vec3 lnglatz) {\n  float lambda = radians(lnglatz.x);\n  float phi = radians(lnglatz.y);\n  float cosPhi = cos(phi);\n  float D = (lnglatz.z / EARTH_RADIUS + 1.0) * GLOBE_RADIUS;\n\n  return vec3(\n    sin(lambda) * cosPhi,\n    -cos(lambda) * cosPhi,\n    sin(phi)\n  ) * D;\n}\nvec4 project_position(vec4 position, vec3 position64Low) {\n  vec4 position_world = project_uModelMatrix * position;\n  if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR) {\n    if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {\n      return vec4(\n        project_mercator_(position_world.xy),\n        project_size_at_latitude(position_world.z, position_world.y),\n        position_world.w\n      );\n    }\n    if (project_uCoordinateSystem == COORDINATE_SYSTEM_CARTESIAN) {\n      position_world.xyz += project_uCoordinateOrigin;\n    }\n  }\n  if (project_uProjectionMode == PROJECTION_MODE_GLOBE) {\n    if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {\n      return vec4(\n        project_globe_(position_world.xyz),\n        position_world.w\n      );\n    }\n  }\n  if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET) {\n    if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {\n      if (abs(position_world.y - project_uCoordinateOrigin.y) > 0.25) {\n        return vec4(\n          project_mercator_(position_world.xy) - project_uCommonOrigin.xy,\n          project_size(position_world.z),\n          position_world.w\n        );\n      }\n    }\n  }\n  if (project_uProjectionMode == PROJECTION_MODE_IDENTITY ||\n    (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET &&\n    (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT ||\n     project_uCoordinateSystem == COORDINATE_SYSTEM_CARTESIAN))) {\n    position_world.xyz -= project_uCoordinateOrigin;\n  }\n  return project_offset_(position_world + project_uModelMatrix * vec4(position64Low, 0.0));\n}\n\nvec4 project_position(vec4 position) {\n  return project_position(position, ZERO_64_LOW);\n}\n\nvec3 project_position(vec3 position, vec3 position64Low) {\n  vec4 projected_position = project_position(vec4(position, 1.0), position64Low);\n  return projected_position.xyz;\n}\n\nvec3 project_position(vec3 position) {\n  vec4 projected_position = project_position(vec4(position, 1.0), ZERO_64_LOW);\n  return projected_position.xyz;\n}\n\nvec2 project_position(vec2 position) {\n  vec4 projected_position = project_position(vec4(position, 0.0, 1.0), ZERO_64_LOW);\n  return projected_position.xy;\n}\n\nvec4 project_common_position_to_clipspace(vec4 position, mat4 viewProjectionMatrix, vec4 center) {\n  return viewProjectionMatrix * position + center;\n}\nvec4 project_common_position_to_clipspace(vec4 position) {\n  return project_common_position_to_clipspace(position, project_uViewProjectionMatrix, project_uCenter);\n}\nvec2 project_pixel_size_to_clipspace(vec2 pixels) {\n  vec2 offset = pixels / project_uViewportSize * project_uDevicePixelRatio * 2.0;\n  return offset * project_uFocalDistance;\n}\n\nfloat project_size_to_pixel(float meters) {\n  return project_size(meters) * project_uScale;\n}\nfloat project_size_to_pixel(float size, int unit) {\n  if (unit == UNIT_METERS) return project_size_to_pixel(size);\n  if (unit == UNIT_COMMON) return size * project_uScale;\n  return size;\n}\nfloat project_pixel_size(float pixels) {\n  return pixels / project_uScale;\n}\nvec2 project_pixel_size(vec2 pixels) {\n  return pixels / project_uScale;\n}\n");

});



parcelRegister("cxTxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9223a764222c0021$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $ihfnu = parcelRequire("ihfnu");
var $iljOc = parcelRequire("iljOc");
const $9223a764222c0021$export$7bd2e4b5b3cb4007 = {
    POINTS: 0x0000,
    LINES: 0x0001,
    LINE_LOOP: 0x0002,
    LINE_STRIP: 0x0003,
    TRIANGLES: 0x0004,
    TRIANGLE_STRIP: 0x0005,
    TRIANGLE_FAN: 0x0006
};
class $9223a764222c0021$export$2e2bcd8739ae039 {
    static get DRAW_MODE() {
        return $9223a764222c0021$export$7bd2e4b5b3cb4007;
    }
    get mode() {
        return this.drawMode;
    }
    getVertexCount() {
        return this.vertexCount;
    }
    getAttributes() {
        return this.indices ? (0, $2QP2i._)({
            indices: this.indices
        }, this.attributes) : this.attributes;
    }
    _print(attributeName) {
        return "Geometry ".concat(this.id, " attribute ").concat(attributeName);
    }
    _setAttributes(attributes, indices) {
        if (indices) this.indices = ArrayBuffer.isView(indices) ? {
            value: indices,
            size: 1
        } : indices;
        for(const attributeName in attributes){
            let attribute = attributes[attributeName];
            attribute = ArrayBuffer.isView(attribute) ? {
                value: attribute
            } : attribute;
            (0, $ihfnu.assert)(ArrayBuffer.isView(attribute.value), "".concat(this._print(attributeName), ": must be typed array or object with value as typed array"));
            if ((attributeName === "POSITION" || attributeName === "positions") && !attribute.size) attribute.size = 3;
            if (attributeName === "indices") {
                (0, $ihfnu.assert)(!this.indices);
                this.indices = attribute;
            } else this.attributes[attributeName] = attribute;
        }
        if (this.indices && this.indices.isIndexed !== undefined) {
            this.indices = Object.assign({}, this.indices);
            delete this.indices.isIndexed;
        }
        return this;
    }
    _calculateVertexCount(attributes, indices) {
        if (indices) return indices.value.length;
        let vertexCount = Infinity;
        for(const attributeName in attributes){
            const attribute = attributes[attributeName];
            const { value: value, size: size, constant: constant } = attribute;
            if (!constant && value && size >= 1) vertexCount = Math.min(vertexCount, value.length / size);
        }
        (0, $ihfnu.assert)(Number.isFinite(vertexCount));
        return vertexCount;
    }
    constructor(){
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { id: id = (0, $iljOc.uid)("geometry"), drawMode: drawMode = $9223a764222c0021$export$7bd2e4b5b3cb4007.TRIANGLES, attributes: attributes = {}, indices: indices = null, vertexCount: vertexCount = null } = props;
        this.id = id;
        this.drawMode = drawMode | 0;
        this.attributes = {};
        this.userData = {};
        this._setAttributes(attributes, indices);
        this.vertexCount = vertexCount || this._calculateVertexCount(this.attributes, this.indices);
    }
}

});

parcelRegister("dzzPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e1a570539b95ed9$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $9001n = parcelRequire("9001n");

var $bPjHd = parcelRequire("bPjHd");
parcelRequire("b5AlO");
var $drfwC = parcelRequire("drfwC");
var $6Kcrp = parcelRequire("6Kcrp");
class $9e1a570539b95ed9$export$2e2bcd8739ae039 extends (0, $bPjHd.default) {
    get(attributeName) {
        const { attributes: attributes } = this;
        if (attributeName === "indices") return attributes.indices && attributes.indices.subarray(0, this.vertexCount);
        return attributes[attributeName];
    }
    updateGeometry(opts) {
        super.updateGeometry(opts);
        const externalIndices = this.buffers.indices;
        if (externalIndices) this.vertexCount = (externalIndices.value || externalIndices).length;
        else if (this.data && !this.getGeometry) throw new Error("missing indices buffer");
    }
    normalizeGeometry(polygon) {
        if (this.normalize) {
            const normalizedPolygon = $9001n.normalize(polygon, this.positionSize);
            if (this.opts.resolution) return (0, $drfwC.cutPolygonByGrid)($9001n.getPositions(normalizedPolygon), $9001n.getHoleIndices(normalizedPolygon), {
                size: this.positionSize,
                gridResolution: this.opts.resolution,
                edgeTypes: true
            });
            if (this.opts.wrapLongitude) return (0, $6Kcrp.cutPolygonByMercatorBounds)($9001n.getPositions(normalizedPolygon), $9001n.getHoleIndices(normalizedPolygon), {
                size: this.positionSize,
                maxLatitude: 86,
                edgeTypes: true
            });
            return normalizedPolygon;
        }
        return polygon;
    }
    getGeometrySize(polygon) {
        if ($9e1a570539b95ed9$var$isCut(polygon)) {
            let size = 0;
            for (const subPolygon of polygon)size += this.getGeometrySize(subPolygon);
            return size;
        }
        return $9001n.getPositions(polygon).length / this.positionSize;
    }
    getGeometryFromBuffer(buffer) {
        if (this.normalize || !this.buffers.indices) return super.getGeometryFromBuffer(buffer);
        return null;
    }
    updateGeometryAttributes(polygon, context) {
        if (polygon && $9e1a570539b95ed9$var$isCut(polygon)) for (const subPolygon of polygon){
            const geometrySize = this.getGeometrySize(subPolygon);
            context.geometrySize = geometrySize;
            this.updateGeometryAttributes(subPolygon, context);
            context.vertexStart += geometrySize;
            context.indexStart = this.indexStarts[context.geometryIndex + 1];
        }
        else {
            this._updateIndices(polygon, context);
            this._updatePositions(polygon, context);
            this._updateVertexValid(polygon, context);
        }
    }
    _updateIndices(polygon, { geometryIndex: geometryIndex, vertexStart: offset, indexStart: indexStart }) {
        const { attributes: attributes, indexStarts: indexStarts, typedArrayManager: typedArrayManager } = this;
        let target = attributes.indices;
        if (!target || !polygon) return;
        let i = indexStart;
        const indices = $9001n.getSurfaceIndices(polygon, this.positionSize, this.opts.preproject, this.opts.full3d);
        target = typedArrayManager.allocate(target, indexStart + indices.length, {
            copy: true
        });
        for(let j = 0; j < indices.length; j++)target[i++] = indices[j] + offset;
        indexStarts[geometryIndex + 1] = indexStart + indices.length;
        attributes.indices = target;
    }
    _updatePositions(polygon, { vertexStart: vertexStart, geometrySize: geometrySize }) {
        const { attributes: { positions: positions }, positionSize: positionSize } = this;
        if (!positions || !polygon) return;
        const polygonPositions = $9001n.getPositions(polygon);
        for(let i = vertexStart, j = 0; j < geometrySize; i++, j++){
            const x = polygonPositions[j * positionSize];
            const y = polygonPositions[j * positionSize + 1];
            const z = positionSize > 2 ? polygonPositions[j * positionSize + 2] : 0;
            positions[i * 3] = x;
            positions[i * 3 + 1] = y;
            positions[i * 3 + 2] = z;
        }
    }
    _updateVertexValid(polygon, { vertexStart: vertexStart, geometrySize: geometrySize }) {
        const { positionSize: positionSize } = this;
        const vertexValid = this.attributes.vertexValid;
        const holeIndices = polygon && $9001n.getHoleIndices(polygon);
        if (polygon && polygon.edgeTypes) vertexValid.set(polygon.edgeTypes, vertexStart);
        else vertexValid.fill(1, vertexStart, vertexStart + geometrySize);
        if (holeIndices) for(let j = 0; j < holeIndices.length; j++)vertexValid[vertexStart + holeIndices[j] / positionSize - 1] = 0;
        vertexValid[vertexStart + geometrySize - 1] = 0;
    }
    constructor(opts){
        const { fp64: fp64, IndexType: IndexType = Uint32Array } = opts;
        super((0, $edHbI._)((0, $2QP2i._)({}, opts), {
            attributes: {
                positions: {
                    size: 3,
                    type: fp64 ? Float64Array : Float32Array
                },
                vertexValid: {
                    type: Uint8ClampedArray,
                    size: 1
                },
                indices: {
                    type: IndexType,
                    size: 1
                }
            }
        }));
    }
}
function $9e1a570539b95ed9$var$isCut(polygon) {
    return Array.isArray(polygon) && polygon.length > 0 && !Number.isFinite(polygon[0]);
}

});
parcelRegister("9001n", function(module, exports) {

$parcel$export(module.exports, "getPositions", function () { return $68d4215ba53f46ac$export$c39457c570f2b189; });
$parcel$export(module.exports, "getHoleIndices", function () { return $68d4215ba53f46ac$export$a70d661c09e77ef8; });
$parcel$export(module.exports, "normalize", function () { return $68d4215ba53f46ac$export$a3295358bff77e; });
$parcel$export(module.exports, "getSurfaceIndices", function () { return $68d4215ba53f46ac$export$9cdf2cc6712e690c; });

var $3BkEZ = parcelRequire("3BkEZ");
parcelRequire("b5AlO");
var $2d6CO = parcelRequire("2d6CO");
const $68d4215ba53f46ac$var$OUTER_POLYGON_WINDING = (0, $2d6CO.WINDING).CLOCKWISE;
const $68d4215ba53f46ac$var$HOLE_POLYGON_WINDING = (0, $2d6CO.WINDING).COUNTER_CLOCKWISE;
const $68d4215ba53f46ac$var$windingOptions = {
    isClosed: true
};
function $68d4215ba53f46ac$var$validate(polygon) {
    polygon = polygon && polygon.positions || polygon;
    if (!Array.isArray(polygon) && !ArrayBuffer.isView(polygon)) throw new Error("invalid polygon");
}
function $68d4215ba53f46ac$export$c39457c570f2b189(polygon) {
    return "positions" in polygon ? polygon.positions : polygon;
}
function $68d4215ba53f46ac$export$a70d661c09e77ef8(polygon) {
    return "holeIndices" in polygon ? polygon.holeIndices : null;
}
function $68d4215ba53f46ac$var$isNested(polygon) {
    return Array.isArray(polygon[0]);
}
function $68d4215ba53f46ac$var$isSimple(polygon) {
    return polygon.length >= 1 && polygon[0].length >= 2 && Number.isFinite(polygon[0][0]);
}
function $68d4215ba53f46ac$var$isNestedRingClosed(simplePolygon) {
    const p0 = simplePolygon[0];
    const p1 = simplePolygon[simplePolygon.length - 1];
    return p0[0] === p1[0] && p0[1] === p1[1] && p0[2] === p1[2];
}
function $68d4215ba53f46ac$var$isFlatRingClosed(positions, size, startIndex, endIndex) {
    for(let i = 0; i < size; i++){
        if (positions[startIndex + i] !== positions[endIndex - size + i]) return false;
    }
    return true;
}
function $68d4215ba53f46ac$var$copyNestedRing(target, targetStartIndex, simplePolygon, size, windingDirection) {
    let targetIndex = targetStartIndex;
    const len = simplePolygon.length;
    for(let i = 0; i < len; i++)for(let j = 0; j < size; j++)target[targetIndex++] = simplePolygon[i][j] || 0;
    if (!$68d4215ba53f46ac$var$isNestedRingClosed(simplePolygon)) for(let j = 0; j < size; j++)target[targetIndex++] = simplePolygon[0][j] || 0;
    $68d4215ba53f46ac$var$windingOptions.start = targetStartIndex;
    $68d4215ba53f46ac$var$windingOptions.end = targetIndex;
    $68d4215ba53f46ac$var$windingOptions.size = size;
    (0, $2d6CO.modifyPolygonWindingDirection)(target, windingDirection, $68d4215ba53f46ac$var$windingOptions);
    return targetIndex;
}
function $68d4215ba53f46ac$var$copyFlatRing(target, targetStartIndex, positions, size, srcStartIndex = 0, srcEndIndex, windingDirection) {
    srcEndIndex = srcEndIndex || positions.length;
    const srcLength = srcEndIndex - srcStartIndex;
    if (srcLength <= 0) return targetStartIndex;
    let targetIndex = targetStartIndex;
    for(let i = 0; i < srcLength; i++)target[targetIndex++] = positions[srcStartIndex + i];
    if (!$68d4215ba53f46ac$var$isFlatRingClosed(positions, size, srcStartIndex, srcEndIndex)) for(let i = 0; i < size; i++)target[targetIndex++] = positions[srcStartIndex + i];
    $68d4215ba53f46ac$var$windingOptions.start = targetStartIndex;
    $68d4215ba53f46ac$var$windingOptions.end = targetIndex;
    $68d4215ba53f46ac$var$windingOptions.size = size;
    (0, $2d6CO.modifyPolygonWindingDirection)(target, windingDirection, $68d4215ba53f46ac$var$windingOptions);
    return targetIndex;
}
function $68d4215ba53f46ac$export$a3295358bff77e(polygon, positionSize) {
    $68d4215ba53f46ac$var$validate(polygon);
    const positions = [];
    const holeIndices = [];
    if ("positions" in polygon) {
        const { positions: srcPositions, holeIndices: srcHoleIndices } = polygon;
        if (srcHoleIndices) {
            let targetIndex = 0;
            for(let i = 0; i <= srcHoleIndices.length; i++){
                targetIndex = $68d4215ba53f46ac$var$copyFlatRing(positions, targetIndex, srcPositions, positionSize, srcHoleIndices[i - 1], srcHoleIndices[i], i === 0 ? $68d4215ba53f46ac$var$OUTER_POLYGON_WINDING : $68d4215ba53f46ac$var$HOLE_POLYGON_WINDING);
                holeIndices.push(targetIndex);
            }
            holeIndices.pop();
            return {
                positions: positions,
                holeIndices: holeIndices
            };
        }
        polygon = srcPositions;
    }
    if (!$68d4215ba53f46ac$var$isNested(polygon)) {
        $68d4215ba53f46ac$var$copyFlatRing(positions, 0, polygon, positionSize, 0, positions.length, $68d4215ba53f46ac$var$OUTER_POLYGON_WINDING);
        return positions;
    }
    if (!$68d4215ba53f46ac$var$isSimple(polygon)) {
        let targetIndex = 0;
        for (const [polygonIndex, simplePolygon] of polygon.entries()){
            targetIndex = $68d4215ba53f46ac$var$copyNestedRing(positions, targetIndex, simplePolygon, positionSize, polygonIndex === 0 ? $68d4215ba53f46ac$var$OUTER_POLYGON_WINDING : $68d4215ba53f46ac$var$HOLE_POLYGON_WINDING);
            holeIndices.push(targetIndex);
        }
        holeIndices.pop();
        return {
            positions: positions,
            holeIndices: holeIndices
        };
    }
    $68d4215ba53f46ac$var$copyNestedRing(positions, 0, polygon, positionSize, $68d4215ba53f46ac$var$OUTER_POLYGON_WINDING);
    return positions;
}
function $68d4215ba53f46ac$var$getPlaneArea(positions, xIndex, yIndex) {
    const numVerts = positions.length / 3;
    let area = 0;
    for(let i = 0; i < numVerts; i++){
        const j = (i + 1) % numVerts;
        area += positions[i * 3 + xIndex] * positions[j * 3 + yIndex];
        area -= positions[j * 3 + xIndex] * positions[i * 3 + yIndex];
    }
    return Math.abs(area / 2);
}
function $68d4215ba53f46ac$var$permutePositions(positions, xIndex, yIndex, zIndex) {
    const numVerts = positions.length / 3;
    for(let i = 0; i < numVerts; i++){
        const o = i * 3;
        const x = positions[o + 0];
        const y = positions[o + 1];
        const z = positions[o + 2];
        positions[o + xIndex] = x;
        positions[o + yIndex] = y;
        positions[o + zIndex] = z;
    }
}
function $68d4215ba53f46ac$export$9cdf2cc6712e690c(polygon, positionSize, preproject, full3d) {
    let holeIndices = $68d4215ba53f46ac$export$a70d661c09e77ef8(polygon);
    if (holeIndices) holeIndices = holeIndices.map((positionIndex)=>positionIndex / positionSize);
    let positions = $68d4215ba53f46ac$export$c39457c570f2b189(polygon);
    const is3d = full3d && positionSize === 3;
    if (preproject) {
        const n = positions.length;
        positions = positions.slice();
        const p = [];
        for(let i = 0; i < n; i += positionSize){
            p[0] = positions[i];
            p[1] = positions[i + 1];
            if (is3d) p[2] = positions[i + 2];
            const xy = preproject(p);
            positions[i] = xy[0];
            positions[i + 1] = xy[1];
            if (is3d) positions[i + 2] = xy[2];
        }
    }
    if (is3d) {
        const xyArea = $68d4215ba53f46ac$var$getPlaneArea(positions, 0, 1);
        const xzArea = $68d4215ba53f46ac$var$getPlaneArea(positions, 0, 2);
        const yzArea = $68d4215ba53f46ac$var$getPlaneArea(positions, 1, 2);
        if (!xyArea && !xzArea && !yzArea) return [];
        if (xyArea > xzArea && xyArea > yzArea) ;
        else if (xzArea > yzArea) {
            if (!preproject) positions = positions.slice();
            $68d4215ba53f46ac$var$permutePositions(positions, 0, 2, 1);
        } else {
            if (!preproject) positions = positions.slice();
            $68d4215ba53f46ac$var$permutePositions(positions, 2, 0, 1);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3BkEZ)))(positions, holeIndices, positionSize);
}

});
parcelRegister("3BkEZ", function(module, exports) {
"use strict";
module.exports = $29f4da7a45653b83$var$earcut;
module.exports.default = $29f4da7a45653b83$var$earcut;
function $29f4da7a45653b83$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $29f4da7a45653b83$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $29f4da7a45653b83$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $29f4da7a45653b83$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $29f4da7a45653b83$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $29f4da7a45653b83$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $29f4da7a45653b83$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $29f4da7a45653b83$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $29f4da7a45653b83$var$equals(last, last.next)) {
        $29f4da7a45653b83$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $29f4da7a45653b83$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($29f4da7a45653b83$var$equals(p, p.next) || $29f4da7a45653b83$var$area(p.prev, p, p.next) === 0)) {
            $29f4da7a45653b83$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $29f4da7a45653b83$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $29f4da7a45653b83$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $29f4da7a45653b83$var$isEarHashed(ear, minX, minY, invSize) : $29f4da7a45653b83$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $29f4da7a45653b83$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $29f4da7a45653b83$var$earcutLinked($29f4da7a45653b83$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $29f4da7a45653b83$var$cureLocalIntersections($29f4da7a45653b83$var$filterPoints(ear), triangles, dim);
                $29f4da7a45653b83$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $29f4da7a45653b83$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $29f4da7a45653b83$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($29f4da7a45653b83$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $29f4da7a45653b83$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $29f4da7a45653b83$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $29f4da7a45653b83$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($29f4da7a45653b83$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $29f4da7a45653b83$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $29f4da7a45653b83$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $29f4da7a45653b83$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $29f4da7a45653b83$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $29f4da7a45653b83$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $29f4da7a45653b83$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $29f4da7a45653b83$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $29f4da7a45653b83$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $29f4da7a45653b83$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $29f4da7a45653b83$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $29f4da7a45653b83$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$29f4da7a45653b83$var$equals(a, b) && $29f4da7a45653b83$var$intersects(a, p, p.next, b) && $29f4da7a45653b83$var$locallyInside(a, b) && $29f4da7a45653b83$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $29f4da7a45653b83$var$removeNode(p);
            $29f4da7a45653b83$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $29f4da7a45653b83$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $29f4da7a45653b83$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $29f4da7a45653b83$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $29f4da7a45653b83$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $29f4da7a45653b83$var$filterPoints(a, a.next);
                c = $29f4da7a45653b83$var$filterPoints(c, c.next);
                // run earcut on each half
                $29f4da7a45653b83$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $29f4da7a45653b83$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $29f4da7a45653b83$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $29f4da7a45653b83$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($29f4da7a45653b83$var$getLeftmost(list));
    }
    queue.sort($29f4da7a45653b83$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $29f4da7a45653b83$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $29f4da7a45653b83$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $29f4da7a45653b83$var$eliminateHole(hole, outerNode) {
    var bridge = $29f4da7a45653b83$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $29f4da7a45653b83$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $29f4da7a45653b83$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $29f4da7a45653b83$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $29f4da7a45653b83$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $29f4da7a45653b83$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($29f4da7a45653b83$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $29f4da7a45653b83$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $29f4da7a45653b83$var$sectorContainsSector(m, p) {
    return $29f4da7a45653b83$var$area(m.prev, m, p.prev) < 0 && $29f4da7a45653b83$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $29f4da7a45653b83$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $29f4da7a45653b83$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $29f4da7a45653b83$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $29f4da7a45653b83$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $29f4da7a45653b83$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $29f4da7a45653b83$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $29f4da7a45653b83$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $29f4da7a45653b83$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$29f4da7a45653b83$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($29f4da7a45653b83$var$locallyInside(a, b) && $29f4da7a45653b83$var$locallyInside(b, a) && $29f4da7a45653b83$var$middleInside(a, b) && // locally visible
    ($29f4da7a45653b83$var$area(a.prev, a, b.prev) || $29f4da7a45653b83$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $29f4da7a45653b83$var$equals(a, b) && $29f4da7a45653b83$var$area(a.prev, a, a.next) > 0 && $29f4da7a45653b83$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $29f4da7a45653b83$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $29f4da7a45653b83$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $29f4da7a45653b83$var$intersects(p1, q1, p2, q2) {
    var o1 = $29f4da7a45653b83$var$sign($29f4da7a45653b83$var$area(p1, q1, p2));
    var o2 = $29f4da7a45653b83$var$sign($29f4da7a45653b83$var$area(p1, q1, q2));
    var o3 = $29f4da7a45653b83$var$sign($29f4da7a45653b83$var$area(p2, q2, p1));
    var o4 = $29f4da7a45653b83$var$sign($29f4da7a45653b83$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $29f4da7a45653b83$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $29f4da7a45653b83$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $29f4da7a45653b83$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $29f4da7a45653b83$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $29f4da7a45653b83$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $29f4da7a45653b83$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $29f4da7a45653b83$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $29f4da7a45653b83$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $29f4da7a45653b83$var$locallyInside(a, b) {
    return $29f4da7a45653b83$var$area(a.prev, a, a.next) < 0 ? $29f4da7a45653b83$var$area(a, b, a.next) >= 0 && $29f4da7a45653b83$var$area(a, a.prev, b) >= 0 : $29f4da7a45653b83$var$area(a, b, a.prev) < 0 || $29f4da7a45653b83$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $29f4da7a45653b83$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $29f4da7a45653b83$var$splitPolygon(a, b) {
    var a2 = new $29f4da7a45653b83$var$Node(a.i, a.x, a.y), b2 = new $29f4da7a45653b83$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $29f4da7a45653b83$var$insertNode(i, x, y, last) {
    var p = new $29f4da7a45653b83$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $29f4da7a45653b83$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $29f4da7a45653b83$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$29f4da7a45653b83$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($29f4da7a45653b83$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($29f4da7a45653b83$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $29f4da7a45653b83$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$29f4da7a45653b83$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

});

parcelRegister("b5AlO", function(module, exports) {

$parcel$export(module.exports, "getPolygonSignedArea", function () { return (parcelRequire("2d6CO")).getPolygonSignedArea; });
$parcel$export(module.exports, "modifyPolygonWindingDirection", function () { return (parcelRequire("2d6CO")).modifyPolygonWindingDirection; });
$parcel$export(module.exports, "WINDING", function () { return (parcelRequire("2d6CO")).WINDING; });
$parcel$export(module.exports, "earcut", function () { return (parcelRequire("kbKbN")).earcut; });
$parcel$export(module.exports, "cutPolygonByGrid", function () { return (parcelRequire("drfwC")).cutPolygonByGrid; });
$parcel$export(module.exports, "cutPolylineByGrid", function () { return (parcelRequire("drfwC")).cutPolylineByGrid; });
$parcel$export(module.exports, "cutPolylineByMercatorBounds", function () { return (parcelRequire("6Kcrp")).cutPolylineByMercatorBounds; });
$parcel$export(module.exports, "cutPolygonByMercatorBounds", function () { return (parcelRequire("6Kcrp")).cutPolygonByMercatorBounds; });

var $eAvut = parcelRequire("eAvut");

var $2d6CO = parcelRequire("2d6CO");

var $kbKbN = parcelRequire("kbKbN");

var $1Uh5y = parcelRequire("1Uh5y");

var $drfwC = parcelRequire("drfwC");

var $6Kcrp = parcelRequire("6Kcrp");

});
parcelRegister("eAvut", function(module, exports) {

var $1F5uH = parcelRequire("1F5uH");

var $cwF9s = parcelRequire("cwF9s");

var $2d6CO = parcelRequire("2d6CO");
class $a9ecdad4b450b1a2$export$2e2bcd8739ae039 {
    getSignedArea() {
        if (this.isFlatArray) return (0, $2d6CO.getPolygonSignedArea)(this.points, this.options);
        return (0, $2d6CO.getPolygonSignedAreaPoints)(this.points, this.options);
    }
    getArea() {
        return Math.abs(this.getSignedArea());
    }
    getWindingDirection() {
        return Math.sign(this.getSignedArea());
    }
    forEachSegment(visitor) {
        if (this.isFlatArray) (0, $2d6CO.forEachSegmentInPolygon)(this.points, (x1, y1, x2, y2, i1, i2)=>{
            visitor([
                x1,
                y1
            ], [
                x2,
                y2
            ], i1, i2);
        }, this.options);
        else (0, $2d6CO.forEachSegmentInPolygonPoints)(this.points, visitor, this.options);
    }
    modifyWindingDirection(direction) {
        if (this.isFlatArray) return (0, $2d6CO.modifyPolygonWindingDirection)(this.points, direction, this.options);
        return (0, $2d6CO.modifyPolygonWindingDirectionPoints)(this.points, direction, this.options);
    }
    constructor(points, options = {}){
        (0, $1F5uH.default)(this, "points", void 0);
        (0, $1F5uH.default)(this, "isFlatArray", void 0);
        (0, $1F5uH.default)(this, "options", void 0);
        this.points = points;
        this.isFlatArray = !(0, $cwF9s.isArray)(points[0]);
        this.options = {
            start: options.start || 0,
            end: options.end || points.length,
            size: options.size || 2,
            isClosed: options.isClosed
        };
        Object.freeze(this);
    }
}

});
parcelRegister("2d6CO", function(module, exports) {

$parcel$export(module.exports, "WINDING", function () { return $19c1ef3bfe162178$export$7a90ca0b01b30dce; });
$parcel$export(module.exports, "modifyPolygonWindingDirection", function () { return $19c1ef3bfe162178$export$3c1df49c9961d1cb; });
$parcel$export(module.exports, "getPolygonSignedArea", function () { return $19c1ef3bfe162178$export$bd6d1e7ba21aa7f7; });
$parcel$export(module.exports, "forEachSegmentInPolygon", function () { return $19c1ef3bfe162178$export$260bd294793e0f1c; });
$parcel$export(module.exports, "modifyPolygonWindingDirectionPoints", function () { return $19c1ef3bfe162178$export$fae93f15be6f8b04; });
$parcel$export(module.exports, "getPolygonSignedAreaPoints", function () { return $19c1ef3bfe162178$export$989f242c9077c44f; });
$parcel$export(module.exports, "forEachSegmentInPolygonPoints", function () { return $19c1ef3bfe162178$export$9513103b5db0cc92; });

var $cwF9s = parcelRequire("cwF9s");
const $19c1ef3bfe162178$export$7a90ca0b01b30dce = {
    CLOCKWISE: 1,
    COUNTER_CLOCKWISE: -1
};
function $19c1ef3bfe162178$export$3c1df49c9961d1cb(points, direction, options = {}) {
    const windingDirection = $19c1ef3bfe162178$export$b673bcea9fcfa4e5(points, options);
    if (windingDirection !== direction) {
        $19c1ef3bfe162178$var$reversePolygon(points, options);
        return true;
    }
    return false;
}
function $19c1ef3bfe162178$export$b673bcea9fcfa4e5(points, options = {}) {
    return Math.sign($19c1ef3bfe162178$export$bd6d1e7ba21aa7f7(points, options));
}
function $19c1ef3bfe162178$export$bd6d1e7ba21aa7f7(points, options = {}) {
    const { start: start = 0, end: end = points.length } = options;
    const dim = options.size || 2;
    let area = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        area += (points[i] - points[j]) * (points[i + 1] + points[j + 1]);
        j = i;
    }
    return area / 2;
}
function $19c1ef3bfe162178$export$260bd294793e0f1c(points, visitor, options = {}) {
    const { start: start = 0, end: end = points.length, size: size = 2, isClosed: isClosed } = options;
    const numPoints = (end - start) / size;
    for(let i = 0; i < numPoints - 1; ++i)visitor(points[start + i * size], points[start + i * size + 1], points[start + (i + 1) * size], points[start + (i + 1) * size + 1], i, i + 1);
    const endPointIndex = start + (numPoints - 1) * size;
    const isClosedEx = isClosed || (0, $cwF9s.equals)(points[start], points[endPointIndex]) && (0, $cwF9s.equals)(points[start + 1], points[endPointIndex + 1]);
    if (!isClosedEx) visitor(points[endPointIndex], points[endPointIndex + 1], points[start], points[start + 1], numPoints - 1, 0);
}
function $19c1ef3bfe162178$var$reversePolygon(points, options) {
    const { start: start = 0, end: end = points.length, size: size = 2 } = options;
    const numPoints = (end - start) / size;
    const numSwaps = Math.floor(numPoints / 2);
    for(let i = 0; i < numSwaps; ++i){
        const b1 = start + i * size;
        const b2 = start + (numPoints - 1 - i) * size;
        for(let j = 0; j < size; ++j){
            const tmp = points[b1 + j];
            points[b1 + j] = points[b2 + j];
            points[b2 + j] = tmp;
        }
    }
}
function $19c1ef3bfe162178$export$fae93f15be6f8b04(points, direction, options = {}) {
    const currentDirection = $19c1ef3bfe162178$export$4a06945e8e3dbc40(points, options);
    if (currentDirection !== direction) {
        points.reverse();
        return true;
    }
    return false;
}
function $19c1ef3bfe162178$export$4a06945e8e3dbc40(points, options = {}) {
    return Math.sign($19c1ef3bfe162178$export$989f242c9077c44f(points, options));
}
function $19c1ef3bfe162178$export$989f242c9077c44f(points, options = {}) {
    const { start: start = 0, end: end = points.length } = options;
    let area = 0;
    for(let i = start, j = end - 1; i < end; ++i){
        area += (points[i][0] - points[j][0]) * (points[i][1] + points[j][1]);
        j = i;
    }
    return area / 2;
}
function $19c1ef3bfe162178$export$9513103b5db0cc92(points, visitor, options = {}) {
    const { start: start = 0, end: end = points.length, isClosed: isClosed } = options;
    for(let i = start; i < end - 1; ++i)visitor(points[i], points[i + 1], i, i + 1);
    const isClosedEx = isClosed || (0, $cwF9s.equals)(points[end - 1], points[0]);
    if (!isClosedEx) visitor(points[end - 1], points[0], end - 1, 0);
}

});


parcelRegister("kbKbN", function(module, exports) {

$parcel$export(module.exports, "earcut", function () { return $eb28a9f7238becb4$export$71a1409458eaaf0d; });

var $2d6CO = parcelRequire("2d6CO");
function $eb28a9f7238becb4$export$71a1409458eaaf0d(positions, holeIndices, dim = 2, areas) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : positions.length;
    let outerNode = $eb28a9f7238becb4$var$linkedList(positions, 0, outerLen, dim, true, areas && areas[0]);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let invSize;
    let maxX;
    let maxY;
    let minX;
    let minY;
    let x;
    let y;
    if (hasHoles) outerNode = $eb28a9f7238becb4$var$eliminateHoles(positions, holeIndices, outerNode, dim, areas);
    if (positions.length > 80 * dim) {
        minX = maxX = positions[0];
        minY = maxY = positions[1];
        for(let i = dim; i < outerLen; i += dim){
            x = positions[i];
            y = positions[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 1 / invSize : 0;
    }
    $eb28a9f7238becb4$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
    return triangles;
}
function $eb28a9f7238becb4$var$linkedList(data, start, end, dim, clockwise, area) {
    let i;
    let last;
    if (area === undefined) area = (0, $2d6CO.getPolygonSignedArea)(data, {
        start: start,
        end: end,
        size: dim
    });
    if (clockwise === area < 0) for(i = start; i < end; i += dim)last = $eb28a9f7238becb4$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $eb28a9f7238becb4$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $eb28a9f7238becb4$var$equals(last, last.next)) {
        $eb28a9f7238becb4$var$removeNode(last);
        last = last.next;
    }
    return last;
}
function $eb28a9f7238becb4$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start;
    let again;
    do {
        again = false;
        if (!p.steiner && ($eb28a9f7238becb4$var$equals(p, p.next) || $eb28a9f7238becb4$var$area(p.prev, p, p.next) === 0)) {
            $eb28a9f7238becb4$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
function $eb28a9f7238becb4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    if (!pass && invSize) $eb28a9f7238becb4$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    let prev;
    let next;
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $eb28a9f7238becb4$var$isEarHashed(ear, minX, minY, invSize) : $eb28a9f7238becb4$var$isEar(ear)) {
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $eb28a9f7238becb4$var$removeNode(ear);
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        if (ear === stop) {
            if (!pass) $eb28a9f7238becb4$var$earcutLinked($eb28a9f7238becb4$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $eb28a9f7238becb4$var$cureLocalIntersections($eb28a9f7238becb4$var$filterPoints(ear), triangles, dim);
                $eb28a9f7238becb4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            } else if (pass === 2) $eb28a9f7238becb4$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
function $eb28a9f7238becb4$var$isEar(ear) {
    const a = ear.prev;
    const b = ear;
    const c = ear.next;
    if ($eb28a9f7238becb4$var$area(a, b, c) >= 0) return false;
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($eb28a9f7238becb4$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $eb28a9f7238becb4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $eb28a9f7238becb4$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev;
    const b = ear;
    const c = ear.next;
    if ($eb28a9f7238becb4$var$area(a, b, c) >= 0) return false;
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x;
    const minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y;
    const maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x;
    const maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    const minZ = $eb28a9f7238becb4$var$zOrder(minTX, minTY, minX, minY, invSize);
    const maxZ = $eb28a9f7238becb4$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ;
    let n = ear.nextZ;
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $eb28a9f7238becb4$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $eb28a9f7238becb4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $eb28a9f7238becb4$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $eb28a9f7238becb4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $eb28a9f7238becb4$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $eb28a9f7238becb4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $eb28a9f7238becb4$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $eb28a9f7238becb4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
function $eb28a9f7238becb4$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev;
        const b = p.next.next;
        if (!$eb28a9f7238becb4$var$equals(a, b) && $eb28a9f7238becb4$var$intersects(a, p, p.next, b) && $eb28a9f7238becb4$var$locallyInside(a, b) && $eb28a9f7238becb4$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            $eb28a9f7238becb4$var$removeNode(p);
            $eb28a9f7238becb4$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $eb28a9f7238becb4$var$filterPoints(p);
}
function $eb28a9f7238becb4$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $eb28a9f7238becb4$var$isValidDiagonal(a, b)) {
                let c = $eb28a9f7238becb4$var$splitPolygon(a, b);
                a = $eb28a9f7238becb4$var$filterPoints(a, a.next);
                c = $eb28a9f7238becb4$var$filterPoints(c, c.next);
                $eb28a9f7238becb4$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $eb28a9f7238becb4$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
function $eb28a9f7238becb4$var$eliminateHoles(data, holeIndices, outerNode, dim, areas) {
    const queue = [];
    let i;
    let len;
    let start;
    let end;
    let list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $eb28a9f7238becb4$var$linkedList(data, start, end, dim, false, areas && areas[i + 1]);
        if (list === list.next) list.steiner = true;
        queue.push($eb28a9f7238becb4$var$getLeftmost(list));
    }
    queue.sort($eb28a9f7238becb4$var$compareX);
    for(i = 0; i < queue.length; i++){
        $eb28a9f7238becb4$var$eliminateHole(queue[i], outerNode);
        outerNode = $eb28a9f7238becb4$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $eb28a9f7238becb4$var$compareX(a, b) {
    return a.x - b.x;
}
function $eb28a9f7238becb4$var$eliminateHole(hole, outerNode) {
    outerNode = $eb28a9f7238becb4$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $eb28a9f7238becb4$var$splitPolygon(outerNode, hole);
        $eb28a9f7238becb4$var$filterPoints(outerNode, outerNode.next);
        $eb28a9f7238becb4$var$filterPoints(b, b.next);
    }
}
function $eb28a9f7238becb4$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m;
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    let tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $eb28a9f7238becb4$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x);
            if ($eb28a9f7238becb4$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $eb28a9f7238becb4$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
function $eb28a9f7238becb4$var$sectorContainsSector(m, p) {
    return $eb28a9f7238becb4$var$area(m.prev, m, p.prev) < 0 && $eb28a9f7238becb4$var$area(p.next, m, m.next) < 0;
}
function $eb28a9f7238becb4$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $eb28a9f7238becb4$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $eb28a9f7238becb4$var$sortLinked(p);
}
function $eb28a9f7238becb4$var$sortLinked(list) {
    let e;
    let i;
    let inSize = 1;
    let numMerges;
    let p;
    let pSize;
    let q;
    let qSize;
    let tail;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
function $eb28a9f7238becb4$var$zOrder(x, y, minX, minY, invSize) {
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00ff00ff;
    x = (x | x << 4) & 0x0f0f0f0f;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00ff00ff;
    y = (y | y << 4) & 0x0f0f0f0f;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
function $eb28a9f7238becb4$var$getLeftmost(start) {
    let p = start;
    let leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
function $eb28a9f7238becb4$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
function $eb28a9f7238becb4$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$eb28a9f7238becb4$var$intersectsPolygon(a, b) && ($eb28a9f7238becb4$var$locallyInside(a, b) && $eb28a9f7238becb4$var$locallyInside(b, a) && $eb28a9f7238becb4$var$middleInside(a, b) && ($eb28a9f7238becb4$var$area(a.prev, a, b.prev) || $eb28a9f7238becb4$var$area(a, b.prev, b)) || $eb28a9f7238becb4$var$equals(a, b) && $eb28a9f7238becb4$var$area(a.prev, a, a.next) > 0 && $eb28a9f7238becb4$var$area(b.prev, b, b.next) > 0);
}
function $eb28a9f7238becb4$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
function $eb28a9f7238becb4$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
function $eb28a9f7238becb4$var$intersects(p1, q1, p2, q2) {
    const o1 = $eb28a9f7238becb4$var$sign($eb28a9f7238becb4$var$area(p1, q1, p2));
    const o2 = $eb28a9f7238becb4$var$sign($eb28a9f7238becb4$var$area(p1, q1, q2));
    const o3 = $eb28a9f7238becb4$var$sign($eb28a9f7238becb4$var$area(p2, q2, p1));
    const o4 = $eb28a9f7238becb4$var$sign($eb28a9f7238becb4$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true;
    if (o1 === 0 && $eb28a9f7238becb4$var$onSegment(p1, p2, q1)) return true;
    if (o2 === 0 && $eb28a9f7238becb4$var$onSegment(p1, q2, q1)) return true;
    if (o3 === 0 && $eb28a9f7238becb4$var$onSegment(p2, p1, q2)) return true;
    if (o4 === 0 && $eb28a9f7238becb4$var$onSegment(p2, q1, q2)) return true;
    return false;
}
function $eb28a9f7238becb4$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $eb28a9f7238becb4$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function $eb28a9f7238becb4$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $eb28a9f7238becb4$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
function $eb28a9f7238becb4$var$locallyInside(a, b) {
    return $eb28a9f7238becb4$var$area(a.prev, a, a.next) < 0 ? $eb28a9f7238becb4$var$area(a, b, a.next) >= 0 && $eb28a9f7238becb4$var$area(a, a.prev, b) >= 0 : $eb28a9f7238becb4$var$area(a, b, a.prev) < 0 || $eb28a9f7238becb4$var$area(a, a.next, b) < 0;
}
function $eb28a9f7238becb4$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
function $eb28a9f7238becb4$var$splitPolygon(a, b) {
    const a2 = new $eb28a9f7238becb4$var$Node(a.i, a.x, a.y);
    const b2 = new $eb28a9f7238becb4$var$Node(b.i, b.x, b.y);
    const an = a.next;
    const bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
function $eb28a9f7238becb4$var$insertNode(i, x, y, last) {
    const p = new $eb28a9f7238becb4$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $eb28a9f7238becb4$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $eb28a9f7238becb4$var$Node(i, x, y) {
    this.i = i;
    this.x = x;
    this.y = y;
    this.prev = null;
    this.next = null;
    this.z = null;
    this.prevZ = null;
    this.nextZ = null;
    this.steiner = false;
}

});

parcelRegister("1Uh5y", function(module, exports) {

$parcel$export(module.exports, "bitCode", function () { return $163846de17e48400$export$a06e53aa5bb2c44b; });
$parcel$export(module.exports, "intersect", function () { return $163846de17e48400$export$1f4807a235930d45; });

var $96tab = parcelRequire("96tab");
function $163846de17e48400$export$7a2d1c8b44adea76(positions, bbox, options) {
    const { size: size = 2, startIndex: startIndex = 0, endIndex: endIndex = positions.length } = options || {};
    const numPoints = (endIndex - startIndex) / size;
    const result = [];
    let part = [];
    let a;
    let b;
    let codeA = -1;
    let codeB;
    let lastCode;
    for(let i = 1; i < numPoints; i++){
        a = (0, $96tab.getPointAtIndex)(positions, i - 1, size, startIndex, a);
        b = (0, $96tab.getPointAtIndex)(positions, i, size, startIndex, b);
        if (codeA < 0) codeA = $163846de17e48400$export$a06e53aa5bb2c44b(a, bbox);
        codeB = lastCode = $163846de17e48400$export$a06e53aa5bb2c44b(b, bbox);
        while(true){
            if (!(codeA | codeB)) {
                (0, $96tab.push)(part, a);
                if (codeB !== lastCode) {
                    (0, $96tab.push)(part, b);
                    if (i < numPoints - 1) {
                        result.push(part);
                        part = [];
                    }
                } else if (i === numPoints - 1) (0, $96tab.push)(part, b);
                break;
            } else if (codeA & codeB) break;
            else if (codeA) {
                $163846de17e48400$export$1f4807a235930d45(a, b, codeA, bbox, a);
                codeA = $163846de17e48400$export$a06e53aa5bb2c44b(a, bbox);
            } else {
                $163846de17e48400$export$1f4807a235930d45(a, b, codeB, bbox, b);
                codeB = $163846de17e48400$export$a06e53aa5bb2c44b(b, bbox);
            }
        }
        codeA = lastCode;
    }
    if (part.length) result.push(part);
    return result;
}
function $163846de17e48400$export$cf9573e980d97240(positions, bbox, options) {
    const { size: size = 2, endIndex: endIndex = positions.length } = options || {};
    let { startIndex: startIndex = 0 } = options || {};
    let numPoints = (endIndex - startIndex) / size;
    let result;
    let p;
    let prev;
    let inside;
    let prevInside;
    for(let edge = 1; edge <= 8; edge *= 2){
        result = [];
        prev = (0, $96tab.getPointAtIndex)(positions, numPoints - 1, size, startIndex, prev);
        prevInside = !($163846de17e48400$export$a06e53aa5bb2c44b(prev, bbox) & edge);
        for(let i = 0; i < numPoints; i++){
            p = (0, $96tab.getPointAtIndex)(positions, i, size, startIndex, p);
            inside = !($163846de17e48400$export$a06e53aa5bb2c44b(p, bbox) & edge);
            if (inside !== prevInside) (0, $96tab.push)(result, $163846de17e48400$export$1f4807a235930d45(prev, p, edge, bbox));
            if (inside) (0, $96tab.push)(result, p);
            (0, $96tab.copy)(prev, p);
            prevInside = inside;
        }
        positions = result;
        startIndex = 0;
        numPoints = result.length / size;
        if (!numPoints) break;
    }
    return result;
}
function $163846de17e48400$export$1f4807a235930d45(a, b, edge, bbox, out = []) {
    let t;
    let snap;
    if (edge & 8) {
        t = (bbox[3] - a[1]) / (b[1] - a[1]);
        snap = 3;
    } else if (edge & 4) {
        t = (bbox[1] - a[1]) / (b[1] - a[1]);
        snap = 1;
    } else if (edge & 2) {
        t = (bbox[2] - a[0]) / (b[0] - a[0]);
        snap = 2;
    } else if (edge & 1) {
        t = (bbox[0] - a[0]) / (b[0] - a[0]);
        snap = 0;
    } else return null;
    for(let i = 0; i < a.length; i++)out[i] = (snap & 1) === i ? bbox[snap] : t * (b[i] - a[i]) + a[i];
    return out;
}
function $163846de17e48400$export$a06e53aa5bb2c44b(p, bbox) {
    let code = 0;
    if (p[0] < bbox[0]) code |= 1;
    else if (p[0] > bbox[2]) code |= 2;
    if (p[1] < bbox[1]) code |= 4;
    else if (p[1] > bbox[3]) code |= 8;
    return code;
}

});
parcelRegister("96tab", function(module, exports) {

$parcel$export(module.exports, "push", function () { return $6a0b4bceadb7b0ee$export$4cbf152802aa238; });
$parcel$export(module.exports, "copy", function () { return $6a0b4bceadb7b0ee$export$784d13d8ee351f07; });
$parcel$export(module.exports, "getPointAtIndex", function () { return $6a0b4bceadb7b0ee$export$44f3a897a4708e95; });
function $6a0b4bceadb7b0ee$export$4cbf152802aa238(target, source) {
    const size = source.length;
    const startIndex = target.length;
    if (startIndex > 0) {
        let isDuplicate = true;
        for(let i = 0; i < size; i++)if (target[startIndex - size + i] !== source[i]) {
            isDuplicate = false;
            break;
        }
        if (isDuplicate) return false;
    }
    for(let i = 0; i < size; i++)target[startIndex + i] = source[i];
    return true;
}
function $6a0b4bceadb7b0ee$export$784d13d8ee351f07(target, source) {
    const size = source.length;
    for(let i = 0; i < size; i++)target[i] = source[i];
}
function $6a0b4bceadb7b0ee$export$44f3a897a4708e95(positions, index, size, offset, out = []) {
    const startI = offset + index * size;
    for(let i = 0; i < size; i++)out[i] = positions[startI + i];
    return out;
}

});


parcelRegister("drfwC", function(module, exports) {

$parcel$export(module.exports, "cutPolylineByGrid", function () { return $9c89d6f12b5117ec$export$58cf240f51ca277a; });
$parcel$export(module.exports, "cutPolygonByGrid", function () { return $9c89d6f12b5117ec$export$ffcdb188e8d27cc1; });

var $1Uh5y = parcelRequire("1Uh5y");

var $96tab = parcelRequire("96tab");
function $9c89d6f12b5117ec$export$58cf240f51ca277a(positions, options) {
    const { size: size = 2, broken: broken = false, gridResolution: gridResolution = 10, gridOffset: gridOffset = [
        0,
        0
    ], startIndex: startIndex = 0, endIndex: endIndex = positions.length } = options || {};
    const numPoints = (endIndex - startIndex) / size;
    let part = [];
    const result = [
        part
    ];
    const a = (0, $96tab.getPointAtIndex)(positions, 0, size, startIndex);
    let b;
    let codeB;
    const cell = $9c89d6f12b5117ec$var$getGridCell(a, gridResolution, gridOffset, []);
    const scratchPoint = [];
    (0, $96tab.push)(part, a);
    for(let i = 1; i < numPoints; i++){
        b = (0, $96tab.getPointAtIndex)(positions, i, size, startIndex, b);
        codeB = (0, $1Uh5y.bitCode)(b, cell);
        while(codeB){
            (0, $1Uh5y.intersect)(a, b, codeB, cell, scratchPoint);
            const codeAlt = (0, $1Uh5y.bitCode)(scratchPoint, cell);
            if (codeAlt) {
                (0, $1Uh5y.intersect)(a, scratchPoint, codeAlt, cell, scratchPoint);
                codeB = codeAlt;
            }
            (0, $96tab.push)(part, scratchPoint);
            (0, $96tab.copy)(a, scratchPoint);
            $9c89d6f12b5117ec$var$moveToNeighborCell(cell, gridResolution, codeB);
            if (broken && part.length > size) {
                part = [];
                result.push(part);
                (0, $96tab.push)(part, a);
            }
            codeB = (0, $1Uh5y.bitCode)(b, cell);
        }
        (0, $96tab.push)(part, b);
        (0, $96tab.copy)(a, b);
    }
    return broken ? result : result[0];
}
const $9c89d6f12b5117ec$var$TYPE_INSIDE = 0;
const $9c89d6f12b5117ec$var$TYPE_BORDER = 1;
function $9c89d6f12b5117ec$var$concatInPlace(arr1, arr2) {
    for(let i = 0; i < arr2.length; i++)arr1.push(arr2[i]);
    return arr1;
}
function $9c89d6f12b5117ec$export$ffcdb188e8d27cc1(positions, holeIndices = null, options) {
    if (!positions.length) return [];
    const { size: size = 2, gridResolution: gridResolution = 10, gridOffset: gridOffset = [
        0,
        0
    ], edgeTypes: edgeTypes = false } = options || {};
    const result = [];
    const queue = [
        {
            pos: positions,
            types: edgeTypes ? new Array(positions.length / size).fill($9c89d6f12b5117ec$var$TYPE_BORDER) : null,
            holes: holeIndices || []
        }
    ];
    const bbox = [
        [],
        []
    ];
    let cell = [];
    while(queue.length){
        const { pos: pos, types: types, holes: holes } = queue.shift();
        $9c89d6f12b5117ec$var$getBoundingBox(pos, size, holes[0] || pos.length, bbox);
        cell = $9c89d6f12b5117ec$var$getGridCell(bbox[0], gridResolution, gridOffset, cell);
        const code = (0, $1Uh5y.bitCode)(bbox[1], cell);
        if (code) {
            let parts = $9c89d6f12b5117ec$var$bisectPolygon(pos, types, size, 0, holes[0] || pos.length, cell, code);
            const polygonLow = {
                pos: parts[0].pos,
                types: parts[0].types,
                holes: []
            };
            const polygonHigh = {
                pos: parts[1].pos,
                types: parts[1].types,
                holes: []
            };
            queue.push(polygonLow, polygonHigh);
            for(let i = 0; i < holes.length; i++){
                parts = $9c89d6f12b5117ec$var$bisectPolygon(pos, types, size, holes[i], holes[i + 1] || pos.length, cell, code);
                if (parts[0]) {
                    polygonLow.holes.push(polygonLow.pos.length);
                    polygonLow.pos = $9c89d6f12b5117ec$var$concatInPlace(polygonLow.pos, parts[0].pos);
                    if (edgeTypes) polygonLow.types = $9c89d6f12b5117ec$var$concatInPlace(polygonLow.types, parts[0].types);
                }
                if (parts[1]) {
                    polygonHigh.holes.push(polygonHigh.pos.length);
                    polygonHigh.pos = $9c89d6f12b5117ec$var$concatInPlace(polygonHigh.pos, parts[1].pos);
                    if (edgeTypes) polygonHigh.types = $9c89d6f12b5117ec$var$concatInPlace(polygonHigh.types, parts[1].types);
                }
            }
        } else {
            const polygon = {
                positions: pos
            };
            if (edgeTypes) polygon.edgeTypes = types;
            if (holes.length) polygon.holeIndices = holes;
            result.push(polygon);
        }
    }
    return result;
}
function $9c89d6f12b5117ec$var$bisectPolygon(positions, edgeTypes, size, startIndex, endIndex, bbox, edge) {
    const numPoints = (endIndex - startIndex) / size;
    const resultLow = [];
    const resultHigh = [];
    const typesLow = [];
    const typesHigh = [];
    const scratchPoint = [];
    let p;
    let side;
    let type;
    const prev = (0, $96tab.getPointAtIndex)(positions, numPoints - 1, size, startIndex);
    let prevSide = Math.sign(edge & 8 ? prev[1] - bbox[3] : prev[0] - bbox[2]);
    let prevType = edgeTypes && edgeTypes[numPoints - 1];
    let lowPointCount = 0;
    let highPointCount = 0;
    for(let i = 0; i < numPoints; i++){
        p = (0, $96tab.getPointAtIndex)(positions, i, size, startIndex, p);
        side = Math.sign(edge & 8 ? p[1] - bbox[3] : p[0] - bbox[2]);
        type = edgeTypes && edgeTypes[startIndex / size + i];
        if (side && prevSide && prevSide !== side) {
            (0, $1Uh5y.intersect)(prev, p, edge, bbox, scratchPoint);
            (0, $96tab.push)(resultLow, scratchPoint) && typesLow.push(prevType);
            (0, $96tab.push)(resultHigh, scratchPoint) && typesHigh.push(prevType);
        }
        if (side <= 0) {
            (0, $96tab.push)(resultLow, p) && typesLow.push(type);
            lowPointCount -= side;
        } else if (typesLow.length) typesLow[typesLow.length - 1] = $9c89d6f12b5117ec$var$TYPE_INSIDE;
        if (side >= 0) {
            (0, $96tab.push)(resultHigh, p) && typesHigh.push(type);
            highPointCount += side;
        } else if (typesHigh.length) typesHigh[typesHigh.length - 1] = $9c89d6f12b5117ec$var$TYPE_INSIDE;
        (0, $96tab.copy)(prev, p);
        prevSide = side;
        prevType = type;
    }
    return [
        lowPointCount ? {
            pos: resultLow,
            types: edgeTypes && typesLow
        } : null,
        highPointCount ? {
            pos: resultHigh,
            types: edgeTypes && typesHigh
        } : null
    ];
}
function $9c89d6f12b5117ec$var$getGridCell(p, gridResolution, gridOffset, out) {
    const left = Math.floor((p[0] - gridOffset[0]) / gridResolution) * gridResolution + gridOffset[0];
    const bottom = Math.floor((p[1] - gridOffset[1]) / gridResolution) * gridResolution + gridOffset[1];
    out[0] = left;
    out[1] = bottom;
    out[2] = left + gridResolution;
    out[3] = bottom + gridResolution;
    return out;
}
function $9c89d6f12b5117ec$var$moveToNeighborCell(cell, gridResolution, edge) {
    if (edge & 8) {
        cell[1] += gridResolution;
        cell[3] += gridResolution;
    } else if (edge & 4) {
        cell[1] -= gridResolution;
        cell[3] -= gridResolution;
    } else if (edge & 2) {
        cell[0] += gridResolution;
        cell[2] += gridResolution;
    } else if (edge & 1) {
        cell[0] -= gridResolution;
        cell[2] -= gridResolution;
    }
}
function $9c89d6f12b5117ec$var$getBoundingBox(positions, size, endIndex, out) {
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for(let i = 0; i < endIndex; i += size){
        const x = positions[i];
        const y = positions[i + 1];
        minX = x < minX ? x : minX;
        maxX = x > maxX ? x : maxX;
        minY = y < minY ? y : minY;
        maxY = y > maxY ? y : maxY;
    }
    out[0][0] = minX;
    out[0][1] = minY;
    out[1][0] = maxX;
    out[1][1] = maxY;
    return out;
}

});

parcelRegister("6Kcrp", function(module, exports) {

$parcel$export(module.exports, "cutPolylineByMercatorBounds", function () { return $4e90b082c99d369b$export$d3678aab2b71fec6; });
$parcel$export(module.exports, "cutPolygonByMercatorBounds", function () { return $4e90b082c99d369b$export$98fce87c2d504c6a; });

var $drfwC = parcelRequire("drfwC");

var $96tab = parcelRequire("96tab");
const $4e90b082c99d369b$var$DEFAULT_MAX_LATITUDE = 85.051129;
function $4e90b082c99d369b$export$d3678aab2b71fec6(positions, options) {
    const { size: size = 2, startIndex: startIndex = 0, endIndex: endIndex = positions.length, normalize: normalize = true } = options || {};
    const newPositions = positions.slice(startIndex, endIndex);
    $4e90b082c99d369b$var$wrapLongitudesForShortestPath(newPositions, size, 0, endIndex - startIndex);
    const parts = (0, $drfwC.cutPolylineByGrid)(newPositions, {
        size: size,
        broken: true,
        gridResolution: 360,
        gridOffset: [
            -180,
            -180
        ]
    });
    if (normalize) for (const part of parts)$4e90b082c99d369b$var$shiftLongitudesIntoRange(part, size);
    return parts;
}
function $4e90b082c99d369b$export$98fce87c2d504c6a(positions, holeIndices = null, options) {
    const { size: size = 2, normalize: normalize = true, edgeTypes: edgeTypes = false } = options || {};
    holeIndices = holeIndices || [];
    const newPositions = [];
    const newHoleIndices = [];
    let srcStartIndex = 0;
    let targetIndex = 0;
    for(let ringIndex = 0; ringIndex <= holeIndices.length; ringIndex++){
        const srcEndIndex = holeIndices[ringIndex] || positions.length;
        const targetStartIndex = targetIndex;
        const splitIndex = $4e90b082c99d369b$var$findSplitIndex(positions, size, srcStartIndex, srcEndIndex);
        for(let i = splitIndex; i < srcEndIndex; i++)newPositions[targetIndex++] = positions[i];
        for(let i = srcStartIndex; i < splitIndex; i++)newPositions[targetIndex++] = positions[i];
        $4e90b082c99d369b$var$wrapLongitudesForShortestPath(newPositions, size, targetStartIndex, targetIndex);
        $4e90b082c99d369b$var$insertPoleVertices(newPositions, size, targetStartIndex, targetIndex, options === null || options === void 0 ? void 0 : options.maxLatitude);
        srcStartIndex = srcEndIndex;
        newHoleIndices[ringIndex] = targetIndex;
    }
    newHoleIndices.pop();
    const parts = (0, $drfwC.cutPolygonByGrid)(newPositions, newHoleIndices, {
        size: size,
        gridResolution: 360,
        gridOffset: [
            -180,
            -180
        ],
        edgeTypes: edgeTypes
    });
    if (normalize) for (const part of parts)$4e90b082c99d369b$var$shiftLongitudesIntoRange(part.positions, size);
    return parts;
}
function $4e90b082c99d369b$var$findSplitIndex(positions, size, startIndex, endIndex) {
    let maxLat = -1;
    let pointIndex = -1;
    for(let i = startIndex + 1; i < endIndex; i += size){
        const lat = Math.abs(positions[i]);
        if (lat > maxLat) {
            maxLat = lat;
            pointIndex = i - 1;
        }
    }
    return pointIndex;
}
function $4e90b082c99d369b$var$insertPoleVertices(positions, size, startIndex, endIndex, maxLatitude = $4e90b082c99d369b$var$DEFAULT_MAX_LATITUDE) {
    const firstLng = positions[startIndex];
    const lastLng = positions[endIndex - size];
    if (Math.abs(firstLng - lastLng) > 180) {
        const p = (0, $96tab.getPointAtIndex)(positions, 0, size, startIndex);
        p[0] += Math.round((lastLng - firstLng) / 360) * 360;
        (0, $96tab.push)(positions, p);
        p[1] = Math.sign(p[1]) * maxLatitude;
        (0, $96tab.push)(positions, p);
        p[0] = firstLng;
        (0, $96tab.push)(positions, p);
    }
}
function $4e90b082c99d369b$var$wrapLongitudesForShortestPath(positions, size, startIndex, endIndex) {
    let prevLng = positions[0];
    let lng;
    for(let i = startIndex; i < endIndex; i += size){
        lng = positions[i];
        const delta = lng - prevLng;
        if (delta > 180 || delta < -180) lng -= Math.round(delta / 360) * 360;
        positions[i] = prevLng = lng;
    }
}
function $4e90b082c99d369b$var$shiftLongitudesIntoRange(positions, size) {
    let refLng;
    const pointCount = positions.length / size;
    for(let i = 0; i < pointCount; i++){
        refLng = positions[i * size];
        if ((refLng + 180) % 360 !== 0) break;
    }
    const delta = -Math.round(refLng / 360) * 360;
    if (delta === 0) return;
    for(let i = 0; i < pointCount; i++)positions[i * size] += delta;
}

});



parcelRegister("bPjHd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89c3bc59462935de$export$2e2bcd8739ae039; });

var $1zR3q = parcelRequire("1zR3q");

var $abpME = parcelRequire("abpME");

var $an4RE = parcelRequire("an4RE");

var $hu5l6 = parcelRequire("hu5l6");

var $7jraD = parcelRequire("7jraD");
class $89c3bc59462935de$export$2e2bcd8739ae039 {
    updateGeometry(opts) {
        Object.assign(this.opts, opts);
        const { data: data, buffers: buffers = {}, getGeometry: getGeometry, geometryBuffer: geometryBuffer, positionFormat: positionFormat, dataChanged: dataChanged, normalize: normalize = true } = this.opts;
        this.data = data;
        this.getGeometry = getGeometry;
        this.positionSize = geometryBuffer && geometryBuffer.size || (positionFormat === "XY" ? 2 : 3);
        this.buffers = buffers;
        this.normalize = normalize;
        if (geometryBuffer) {
            (0, $hu5l6.default)(data.startIndices);
            this.getGeometry = this.getGeometryFromBuffer(geometryBuffer);
            if (!normalize) buffers.positions = geometryBuffer;
        }
        this.geometryBuffer = buffers.positions;
        if (Array.isArray(dataChanged)) for (const dataRange of dataChanged)this._rebuildGeometry(dataRange);
        else this._rebuildGeometry();
    }
    updatePartialGeometry({ startRow: startRow, endRow: endRow }) {
        this._rebuildGeometry({
            startRow: startRow,
            endRow: endRow
        });
    }
    getGeometryFromBuffer(geometryBuffer) {
        const value = geometryBuffer.value || geometryBuffer;
        if (!ArrayBuffer.isView(value)) return null;
        return (0, $abpME.getAccessorFromBuffer)(value, {
            size: this.positionSize,
            offset: geometryBuffer.offset,
            stride: geometryBuffer.stride,
            startIndices: this.data.startIndices
        });
    }
    _allocate(instanceCount, copy) {
        const { attributes: attributes, buffers: buffers, _attributeDefs: _attributeDefs, typedArrayManager: typedArrayManager } = this;
        for(const name in _attributeDefs)if (name in buffers) {
            typedArrayManager.release(attributes[name]);
            attributes[name] = null;
        } else {
            const def = _attributeDefs[name];
            def.copy = copy;
            attributes[name] = typedArrayManager.allocate(attributes[name], instanceCount, def);
        }
    }
    _forEachGeometry(visitor, startRow, endRow) {
        const { data: data, getGeometry: getGeometry } = this;
        const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(data, startRow, endRow);
        for (const object of iterable){
            objectInfo.index++;
            const geometry = getGeometry ? getGeometry(object, objectInfo) : null;
            visitor(geometry, objectInfo.index);
        }
    }
    _rebuildGeometry(dataRange) {
        if (!this.data) return;
        let { indexStarts: indexStarts, vertexStarts: vertexStarts, instanceCount: instanceCount } = this;
        const { data: data, geometryBuffer: geometryBuffer } = this;
        const { startRow: startRow = 0, endRow: endRow = Infinity } = dataRange || {};
        const normalizedData = {};
        if (!dataRange) {
            indexStarts = [
                0
            ];
            vertexStarts = [
                0
            ];
        }
        if (this.normalize || !geometryBuffer) {
            this._forEachGeometry((geometry, dataIndex)=>{
                const normalizedGeometry = geometry && this.normalizeGeometry(geometry);
                normalizedData[dataIndex] = normalizedGeometry;
                vertexStarts[dataIndex + 1] = vertexStarts[dataIndex] + (normalizedGeometry ? this.getGeometrySize(normalizedGeometry) : 0);
            }, startRow, endRow);
            instanceCount = vertexStarts[vertexStarts.length - 1];
        } else {
            vertexStarts = data.startIndices;
            instanceCount = vertexStarts[data.length] || 0;
            if (ArrayBuffer.isView(geometryBuffer)) instanceCount = instanceCount || geometryBuffer.length / this.positionSize;
            else if (geometryBuffer instanceof (0, $7jraD.default)) {
                const byteStride = geometryBuffer.accessor.stride || this.positionSize * 4;
                instanceCount = instanceCount || geometryBuffer.byteLength / byteStride;
            } else if (geometryBuffer.buffer) {
                const byteStride = geometryBuffer.stride || this.positionSize * 4;
                instanceCount = instanceCount || geometryBuffer.buffer.byteLength / byteStride;
            } else if (geometryBuffer.value) {
                const bufferValue = geometryBuffer.value;
                const elementStride = geometryBuffer.stride / bufferValue.BYTES_PER_ELEMENT || this.positionSize;
                instanceCount = instanceCount || bufferValue.length / elementStride;
            }
        }
        this._allocate(instanceCount, Boolean(dataRange));
        this.indexStarts = indexStarts;
        this.vertexStarts = vertexStarts;
        this.instanceCount = instanceCount;
        const context = {};
        this._forEachGeometry((geometry, dataIndex)=>{
            const normalizedGeometry = normalizedData[dataIndex] || geometry;
            context.vertexStart = vertexStarts[dataIndex];
            context.indexStart = indexStarts[dataIndex];
            const vertexEnd = dataIndex < vertexStarts.length - 1 ? vertexStarts[dataIndex + 1] : instanceCount;
            context.geometrySize = vertexEnd - vertexStarts[dataIndex];
            context.geometryIndex = dataIndex;
            this.updateGeometryAttributes(normalizedGeometry, context);
        }, startRow, endRow);
        this.vertexCount = indexStarts[indexStarts.length - 1];
    }
    constructor(opts){
        (0, $1zR3q.default)(this, "opts", void 0);
        (0, $1zR3q.default)(this, "typedArrayManager", void 0);
        (0, $1zR3q.default)(this, "indexStarts", [
            0
        ]);
        (0, $1zR3q.default)(this, "vertexStarts", [
            0
        ]);
        (0, $1zR3q.default)(this, "vertexCount", 0);
        (0, $1zR3q.default)(this, "instanceCount", 0);
        (0, $1zR3q.default)(this, "attributes", void 0);
        (0, $1zR3q.default)(this, "_attributeDefs", void 0);
        (0, $1zR3q.default)(this, "data", void 0);
        (0, $1zR3q.default)(this, "getGeometry", void 0);
        (0, $1zR3q.default)(this, "geometryBuffer", void 0);
        (0, $1zR3q.default)(this, "buffers", void 0);
        (0, $1zR3q.default)(this, "positionSize", void 0);
        (0, $1zR3q.default)(this, "normalize", void 0);
        const { attributes: attributes = {} } = opts;
        this.typedArrayManager = (0, $an4RE.default);
        this.attributes = {};
        this._attributeDefs = attributes;
        this.opts = opts;
        this.updateGeometry(opts);
    }
}

});


parcelRegister("jrNr2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e286e2b46b87f19b$export$2e2bcd8739ae039; });

var $hy6E6 = parcelRequire("hy6E6");
var $e286e2b46b87f19b$export$2e2bcd8739ae039 = "#define SHADER_NAME solid-polygon-layer-vertex-shader\n\nattribute vec3 positions;\nattribute vec3 positions64Low;\nattribute float elevations;\nattribute vec4 fillColors;\nattribute vec4 lineColors;\nattribute vec3 pickingColors;\n\n".concat((0, $hy6E6.default), "\n\nvoid main(void) {\n  PolygonProps props;\n\n  props.positions = positions;\n  props.positions64Low = positions64Low;\n  props.elevations = elevations;\n  props.fillColors = fillColors;\n  props.lineColors = lineColors;\n  props.pickingColors = pickingColors;\n\n  calculatePosition(props);\n}\n");

});
parcelRegister("hy6E6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc6ac45e68c12af6$export$2e2bcd8739ae039; });
var $cc6ac45e68c12af6$export$2e2bcd8739ae039 = "\nattribute vec2 vertexPositions;\nattribute float vertexValid;\n\nuniform bool extruded;\nuniform bool isWireframe;\nuniform float elevationScale;\nuniform float opacity;\n\nvarying vec4 vColor;\n\nstruct PolygonProps {\n  vec4 fillColors;\n  vec4 lineColors;\n  vec3 positions;\n  vec3 nextPositions;\n  vec3 pickingColors;\n  vec3 positions64Low;\n  vec3 nextPositions64Low;\n  float elevations;\n};\n\nvec3 project_offset_normal(vec3 vector) {\n  if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT ||\n    project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT_OFFSETS) {\n    return normalize(vector * project_uCommonUnitsPerWorldUnit);\n  }\n  return project_normal(vector);\n}\n\nvoid calculatePosition(PolygonProps props) {\n#ifdef IS_SIDE_VERTEX\n  if(vertexValid < 0.5){\n    gl_Position = vec4(0.);\n    return;\n  }\n#endif\n\n  vec3 pos;\n  vec3 pos64Low;\n  vec3 normal;\n  vec4 colors = isWireframe ? props.lineColors : props.fillColors;\n\n  geometry.worldPosition = props.positions;\n  geometry.worldPositionAlt = props.nextPositions;\n  geometry.pickingColor = props.pickingColors;\n\n#ifdef IS_SIDE_VERTEX\n  pos = mix(props.positions, props.nextPositions, vertexPositions.x);\n  pos64Low = mix(props.positions64Low, props.nextPositions64Low, vertexPositions.x);\n#else\n  pos = props.positions;\n  pos64Low = props.positions64Low;\n#endif\n\n  if (extruded) {\n    pos.z += props.elevations * vertexPositions.y * elevationScale;\n  }\n  gl_Position = project_position_to_clipspace(pos, pos64Low, vec3(0.), geometry.position);\n\n  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n\n  if (extruded) {\n  #ifdef IS_SIDE_VERTEX\n    normal = vec3(\n      props.positions.y - props.nextPositions.y + (props.positions64Low.y - props.nextPositions64Low.y),\n      props.nextPositions.x - props.positions.x + (props.nextPositions64Low.x - props.positions64Low.x),\n      0.0);\n    normal = project_offset_normal(normal);\n  #else\n    normal = project_normal(vec3(0.0, 0.0, 1.0));\n  #endif\n    geometry.normal = normal;\n    vec3 lightColor = lighting_getLightColor(colors.rgb, project_uCameraPosition, geometry.position.xyz, normal);\n    vColor = vec4(lightColor, colors.a * opacity);\n  } else {\n    vColor = vec4(colors.rgb, colors.a * opacity);\n  }\n  DECKGL_FILTER_COLOR(vColor, geometry);\n}\n";

});


parcelRegister("a5Son", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7594902b3f11d815$export$2e2bcd8739ae039; });

var $hy6E6 = parcelRequire("hy6E6");
var $7594902b3f11d815$export$2e2bcd8739ae039 = "#define SHADER_NAME solid-polygon-layer-vertex-shader-side\n#define IS_SIDE_VERTEX\n\n\nattribute vec3 instancePositions;\nattribute vec3 nextPositions;\nattribute vec3 instancePositions64Low;\nattribute vec3 nextPositions64Low;\nattribute float instanceElevations;\nattribute vec4 instanceFillColors;\nattribute vec4 instanceLineColors;\nattribute vec3 instancePickingColors;\n\n".concat((0, $hy6E6.default), "\n\nvoid main(void) {\n  PolygonProps props;\n\n  #if RING_WINDING_ORDER_CW == 1\n    props.positions = instancePositions;\n    props.positions64Low = instancePositions64Low;\n    props.nextPositions = nextPositions;\n    props.nextPositions64Low = nextPositions64Low;\n  #else\n    props.positions = nextPositions;\n    props.positions64Low = nextPositions64Low;\n    props.nextPositions = instancePositions;\n    props.nextPositions64Low = instancePositions64Low;\n  #endif\n  props.elevations = instanceElevations;\n  props.fillColors = instanceFillColors;\n  props.lineColors = instanceLineColors;\n  props.pickingColors = instancePickingColors;\n\n  calculatePosition(props);\n}\n");

});

parcelRegister("43aPw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f2fd7dad05e8321$export$2e2bcd8739ae039; });
var $2f2fd7dad05e8321$export$2e2bcd8739ae039 = "#define SHADER_NAME solid-polygon-layer-fragment-shader\n\nprecision highp float;\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  gl_FragColor = vColor;\n\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";

});


parcelRegister("lzW2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb59e47c2ae2061b$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $i46md = parcelRequire("i46md");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");
var $7gQQK = parcelRequire("7gQQK");

var $cxTxU = parcelRequire("cxTxU");
var $b2F4S = parcelRequire("b2F4S");

var $5A6P6 = parcelRequire("5A6P6");

var $9jmzc = parcelRequire("9jmzc");

var $1cBlW = parcelRequire("1cBlW");
const $fb59e47c2ae2061b$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $fb59e47c2ae2061b$var$defaultProps = {
    widthUnits: "meters",
    widthScale: {
        type: "number",
        min: 0,
        value: 1
    },
    widthMinPixels: {
        type: "number",
        min: 0,
        value: 0
    },
    widthMaxPixels: {
        type: "number",
        min: 0,
        value: Number.MAX_SAFE_INTEGER
    },
    jointRounded: false,
    capRounded: false,
    miterLimit: {
        type: "number",
        min: 0,
        value: 4
    },
    billboard: false,
    _pathType: null,
    getPath: {
        type: "accessor",
        value: (object)=>object.path
    },
    getColor: {
        type: "accessor",
        value: $fb59e47c2ae2061b$var$DEFAULT_COLOR
    },
    getWidth: {
        type: "accessor",
        value: 1
    },
    rounded: {
        deprecatedFor: [
            "jointRounded",
            "capRounded"
        ]
    }
};
const $fb59e47c2ae2061b$var$ATTRIBUTE_TRANSITION = {
    enter: (value, chunk)=>{
        return chunk.length ? chunk.subarray(chunk.length - value.length) : value;
    }
};
class $fb59e47c2ae2061b$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getShaders() {
        return super.getShaders({
            vs: $9jmzc.default,
            fs: $1cBlW.default,
            modules: [
                (0, $jRSMz.default),
                (0, $7UxuR.default)
            ]
        });
    }
    get wrapLongitude() {
        return false;
    }
    initializeState() {
        const noAlloc = true;
        const attributeManager = this.getAttributeManager();
        attributeManager.addInstanced({
            positions: {
                size: 3,
                vertexOffset: 1,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: $fb59e47c2ae2061b$var$ATTRIBUTE_TRANSITION,
                accessor: "getPath",
                update: this.calculatePositions,
                noAlloc: noAlloc,
                shaderAttributes: {
                    instanceLeftPositions: {
                        vertexOffset: 0
                    },
                    instanceStartPositions: {
                        vertexOffset: 1
                    },
                    instanceEndPositions: {
                        vertexOffset: 2
                    },
                    instanceRightPositions: {
                        vertexOffset: 3
                    }
                }
            },
            instanceTypes: {
                size: 1,
                type: 5121,
                update: this.calculateSegmentTypes,
                noAlloc: noAlloc
            },
            instanceStrokeWidths: {
                size: 1,
                accessor: "getWidth",
                transition: $fb59e47c2ae2061b$var$ATTRIBUTE_TRANSITION,
                defaultValue: 1
            },
            instanceColors: {
                size: this.props.colorFormat.length,
                type: 5121,
                normalized: true,
                accessor: "getColor",
                transition: $fb59e47c2ae2061b$var$ATTRIBUTE_TRANSITION,
                defaultValue: $fb59e47c2ae2061b$var$DEFAULT_COLOR
            },
            instancePickingColors: {
                size: 3,
                type: 5121,
                accessor: (object, { index: index, target: value })=>this.encodePickingColor(object && object.__source ? object.__source.index : index, value)
            }
        });
        this.setState({
            pathTesselator: new (0, $5A6P6.default)({
                fp64: this.use64bitPositions()
            })
        });
    }
    updateState(params) {
        super.updateState(params);
        const { props: props, changeFlags: changeFlags } = params;
        const attributeManager = this.getAttributeManager();
        const geometryChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPath);
        if (geometryChanged) {
            const { pathTesselator: pathTesselator } = this.state;
            const buffers = props.data.attributes || {};
            pathTesselator.updateGeometry({
                data: props.data,
                geometryBuffer: buffers.getPath,
                buffers: buffers,
                normalize: !props._pathType,
                loop: props._pathType === "loop",
                getGeometry: props.getPath,
                positionFormat: props.positionFormat,
                wrapLongitude: props.wrapLongitude,
                resolution: this.context.viewport.resolution,
                dataChanged: changeFlags.dataChanged
            });
            this.setState({
                numInstances: pathTesselator.instanceCount,
                startIndices: pathTesselator.vertexStarts
            });
            if (!changeFlags.dataChanged) attributeManager.invalidateAll();
        }
        if (changeFlags.extensionsChanged) {
            var _this$state$model;
            const { gl: gl } = this.context;
            (_this$state$model = this.state.model) === null || _this$state$model === void 0 || _this$state$model.delete();
            this.state.model = this._getModel(gl);
            attributeManager.invalidateAll();
        }
    }
    getPickingInfo(params) {
        const info = super.getPickingInfo(params);
        const { index: index } = info;
        const { data: data } = this.props;
        if (data[0] && data[0].__source) info.object = data.find((d)=>d.__source.index === index);
        return info;
    }
    disablePickingIndex(objectIndex) {
        const { data: data } = this.props;
        if (data[0] && data[0].__source) {
            for(let i = 0; i < data.length; i++)if (data[i].__source.index === objectIndex) this._disablePickingIndex(i);
        } else super.disablePickingIndex(objectIndex);
    }
    draw({ uniforms: uniforms }) {
        const { jointRounded: jointRounded, capRounded: capRounded, billboard: billboard, miterLimit: miterLimit, widthUnits: widthUnits, widthScale: widthScale, widthMinPixels: widthMinPixels, widthMaxPixels: widthMaxPixels } = this.props;
        this.state.model.setUniforms(uniforms).setUniforms({
            jointType: Number(jointRounded),
            capType: Number(capRounded),
            billboard: billboard,
            widthUnits: (0, $7gQQK.UNIT)[widthUnits],
            widthScale: widthScale,
            miterLimit: miterLimit,
            widthMinPixels: widthMinPixels,
            widthMaxPixels: widthMaxPixels
        }).draw();
    }
    _getModel(gl) {
        const SEGMENT_INDICES = [
            0,
            1,
            2,
            1,
            4,
            2,
            1,
            3,
            4,
            3,
            5,
            4
        ];
        const SEGMENT_POSITIONS = [
            0,
            0,
            0,
            -1,
            0,
            1,
            1,
            -1,
            1,
            1,
            1,
            0
        ];
        return new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders()), {
            id: this.props.id,
            geometry: new (0, $cxTxU.default)({
                drawMode: 4,
                attributes: {
                    indices: new Uint16Array(SEGMENT_INDICES),
                    positions: {
                        value: new Float32Array(SEGMENT_POSITIONS),
                        size: 2
                    }
                }
            }),
            isInstanced: true
        }));
    }
    calculatePositions(attribute) {
        const { pathTesselator: pathTesselator } = this.state;
        attribute.startIndices = pathTesselator.vertexStarts;
        attribute.value = pathTesselator.get("positions");
    }
    calculateSegmentTypes(attribute) {
        const { pathTesselator: pathTesselator } = this.state;
        attribute.startIndices = pathTesselator.vertexStarts;
        attribute.value = pathTesselator.get("segmentTypes");
    }
    constructor(...args){
        super(...args);
        (0, $lEQUF.default)(this, "state", void 0);
    }
}
(0, $lEQUF.default)($fb59e47c2ae2061b$export$2e2bcd8739ae039, "defaultProps", $fb59e47c2ae2061b$var$defaultProps);
(0, $lEQUF.default)($fb59e47c2ae2061b$export$2e2bcd8739ae039, "layerName", "PathLayer");

});
parcelRegister("5A6P6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41059b7bf4ee01fa$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bPjHd = parcelRequire("bPjHd");

var $gbuMl = parcelRequire("gbuMl");
const $41059b7bf4ee01fa$var$START_CAP = 1;
const $41059b7bf4ee01fa$var$END_CAP = 2;
const $41059b7bf4ee01fa$var$INVALID = 4;
class $41059b7bf4ee01fa$export$2e2bcd8739ae039 extends (0, $bPjHd.default) {
    get(attributeName) {
        return this.attributes[attributeName];
    }
    getGeometryFromBuffer(buffer) {
        if (this.normalize) return super.getGeometryFromBuffer(buffer);
        return null;
    }
    normalizeGeometry(path) {
        if (this.normalize) return (0, $gbuMl.normalizePath)(path, this.positionSize, this.opts.resolution, this.opts.wrapLongitude);
        return path;
    }
    getGeometrySize(path) {
        if ($41059b7bf4ee01fa$var$isCut(path)) {
            let size = 0;
            for (const subPath of path)size += this.getGeometrySize(subPath);
            return size;
        }
        const numPoints = this.getPathLength(path);
        if (numPoints < 2) return 0;
        if (this.isClosed(path)) return numPoints < 3 ? 0 : numPoints + 2;
        return numPoints;
    }
    updateGeometryAttributes(path, context) {
        if (context.geometrySize === 0) return;
        if (path && $41059b7bf4ee01fa$var$isCut(path)) for (const subPath of path){
            const geometrySize = this.getGeometrySize(subPath);
            context.geometrySize = geometrySize;
            this.updateGeometryAttributes(subPath, context);
            context.vertexStart += geometrySize;
        }
        else {
            this._updateSegmentTypes(path, context);
            this._updatePositions(path, context);
        }
    }
    _updateSegmentTypes(path, context) {
        const segmentTypes = this.attributes.segmentTypes;
        const isPathClosed = path ? this.isClosed(path) : false;
        const { vertexStart: vertexStart, geometrySize: geometrySize } = context;
        segmentTypes.fill(0, vertexStart, vertexStart + geometrySize);
        if (isPathClosed) {
            segmentTypes[vertexStart] = $41059b7bf4ee01fa$var$INVALID;
            segmentTypes[vertexStart + geometrySize - 2] = $41059b7bf4ee01fa$var$INVALID;
        } else {
            segmentTypes[vertexStart] += $41059b7bf4ee01fa$var$START_CAP;
            segmentTypes[vertexStart + geometrySize - 2] += $41059b7bf4ee01fa$var$END_CAP;
        }
        segmentTypes[vertexStart + geometrySize - 1] = $41059b7bf4ee01fa$var$INVALID;
    }
    _updatePositions(path, context) {
        const { positions: positions } = this.attributes;
        if (!positions || !path) return;
        const { vertexStart: vertexStart, geometrySize: geometrySize } = context;
        const p = new Array(3);
        for(let i = vertexStart, ptIndex = 0; ptIndex < geometrySize; i++, ptIndex++){
            this.getPointOnPath(path, ptIndex, p);
            positions[i * 3] = p[0];
            positions[i * 3 + 1] = p[1];
            positions[i * 3 + 2] = p[2];
        }
    }
    getPathLength(path) {
        return path.length / this.positionSize;
    }
    getPointOnPath(path, index, target = []) {
        const { positionSize: positionSize } = this;
        if (index * positionSize >= path.length) index += 1 - path.length / positionSize;
        const i = index * positionSize;
        target[0] = path[i];
        target[1] = path[i + 1];
        target[2] = positionSize === 3 && path[i + 2] || 0;
        return target;
    }
    isClosed(path) {
        if (!this.normalize) return Boolean(this.opts.loop);
        const { positionSize: positionSize } = this;
        const lastPointIndex = path.length - positionSize;
        return path[0] === path[lastPointIndex] && path[1] === path[lastPointIndex + 1] && (positionSize === 2 || path[2] === path[lastPointIndex + 2]);
    }
    constructor(opts){
        super((0, $edHbI._)((0, $2QP2i._)({}, opts), {
            attributes: {
                positions: {
                    size: 3,
                    padding: 18,
                    initialize: true,
                    type: opts.fp64 ? Float64Array : Float32Array
                },
                segmentTypes: {
                    size: 1,
                    type: Uint8ClampedArray
                }
            }
        }));
    }
}
function $41059b7bf4ee01fa$var$isCut(path) {
    return Array.isArray(path[0]);
}

});
parcelRegister("gbuMl", function(module, exports) {

$parcel$export(module.exports, "normalizePath", function () { return $bc858c6c0c681b73$export$6af368f973c74c5; });
parcelRequire("b5AlO");
var $drfwC = parcelRequire("drfwC");
var $6Kcrp = parcelRequire("6Kcrp");
function $bc858c6c0c681b73$export$6af368f973c74c5(path, size, gridResolution, wrapLongitude) {
    let flatPath;
    if (Array.isArray(path[0])) {
        const length = path.length * size;
        flatPath = new Array(length);
        for(let i = 0; i < path.length; i++)for(let j = 0; j < size; j++)flatPath[i * size + j] = path[i][j] || 0;
    } else flatPath = path;
    if (gridResolution) return (0, $drfwC.cutPolylineByGrid)(flatPath, {
        size: size,
        gridResolution: gridResolution
    });
    if (wrapLongitude) return (0, $6Kcrp.cutPolylineByMercatorBounds)(flatPath, {
        size: size
    });
    return flatPath;
}

});


parcelRegister("9jmzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c7764b49cf2d2a1$export$2e2bcd8739ae039; });
var $6c7764b49cf2d2a1$export$2e2bcd8739ae039 = "#define SHADER_NAME path-layer-vertex-shader\n\nattribute vec2 positions;\n\nattribute float instanceTypes;\nattribute vec3 instanceStartPositions;\nattribute vec3 instanceEndPositions;\nattribute vec3 instanceLeftPositions;\nattribute vec3 instanceRightPositions;\nattribute vec3 instanceLeftPositions64Low;\nattribute vec3 instanceStartPositions64Low;\nattribute vec3 instanceEndPositions64Low;\nattribute vec3 instanceRightPositions64Low;\nattribute float instanceStrokeWidths;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\n\nuniform float widthScale;\nuniform float widthMinPixels;\nuniform float widthMaxPixels;\nuniform float jointType;\nuniform float capType;\nuniform float miterLimit;\nuniform bool billboard;\nuniform int widthUnits;\n\nuniform float opacity;\n\nvarying vec4 vColor;\nvarying vec2 vCornerOffset;\nvarying float vMiterLength;\nvarying vec2 vPathPosition;\nvarying float vPathLength;\nvarying float vJointType;\n\nconst float EPSILON = 0.001;\nconst vec3 ZERO_OFFSET = vec3(0.0);\n\nfloat flipIfTrue(bool flag) {\n  return -(float(flag) * 2. - 1.);\n}\nvec3 getLineJoinOffset(\n  vec3 prevPoint, vec3 currPoint, vec3 nextPoint,\n  vec2 width\n) {\n  bool isEnd = positions.x > 0.0;\n  float sideOfPath = positions.y;\n  float isJoint = float(sideOfPath == 0.0);\n\n  vec3 deltaA3 = (currPoint - prevPoint);\n  vec3 deltaB3 = (nextPoint - currPoint);\n\n  mat3 rotationMatrix;\n  bool needsRotation = !billboard && project_needs_rotation(currPoint, rotationMatrix);\n  if (needsRotation) {\n    deltaA3 = deltaA3 * rotationMatrix;\n    deltaB3 = deltaB3 * rotationMatrix;\n  }\n  vec2 deltaA = deltaA3.xy / width;\n  vec2 deltaB = deltaB3.xy / width;\n\n  float lenA = length(deltaA);\n  float lenB = length(deltaB);\n\n  vec2 dirA = lenA > 0. ? normalize(deltaA) : vec2(0.0, 0.0);\n  vec2 dirB = lenB > 0. ? normalize(deltaB) : vec2(0.0, 0.0);\n\n  vec2 perpA = vec2(-dirA.y, dirA.x);\n  vec2 perpB = vec2(-dirB.y, dirB.x);\n  vec2 tangent = dirA + dirB;\n  tangent = length(tangent) > 0. ? normalize(tangent) : perpA;\n  vec2 miterVec = vec2(-tangent.y, tangent.x);\n  vec2 dir = isEnd ? dirA : dirB;\n  vec2 perp = isEnd ? perpA : perpB;\n  float L = isEnd ? lenA : lenB;\n  float sinHalfA = abs(dot(miterVec, perp));\n  float cosHalfA = abs(dot(dirA, miterVec));\n  float turnDirection = flipIfTrue(dirA.x * dirB.y >= dirA.y * dirB.x);\n  float cornerPosition = sideOfPath * turnDirection;\n\n  float miterSize = 1.0 / max(sinHalfA, EPSILON);\n  miterSize = mix(\n    min(miterSize, max(lenA, lenB) / max(cosHalfA, EPSILON)),\n    miterSize,\n    step(0.0, cornerPosition)\n  );\n\n  vec2 offsetVec = mix(miterVec * miterSize, perp, step(0.5, cornerPosition))\n    * (sideOfPath + isJoint * turnDirection);\n  bool isStartCap = lenA == 0.0 || (!isEnd && (instanceTypes == 1.0 || instanceTypes == 3.0));\n  bool isEndCap = lenB == 0.0 || (isEnd && (instanceTypes == 2.0 || instanceTypes == 3.0));\n  bool isCap = isStartCap || isEndCap;\n  if (isCap) {\n    offsetVec = mix(perp * sideOfPath, dir * capType * 4.0 * flipIfTrue(isStartCap), isJoint);\n    vJointType = capType;\n  } else {\n    vJointType = jointType;\n  }\n  vPathLength = L;\n  vCornerOffset = offsetVec;\n  vMiterLength = dot(vCornerOffset, miterVec * turnDirection);\n  vMiterLength = isCap ? isJoint : vMiterLength;\n\n  vec2 offsetFromStartOfPath = vCornerOffset + deltaA * float(isEnd);\n  vPathPosition = vec2(\n    dot(offsetFromStartOfPath, perp),\n    dot(offsetFromStartOfPath, dir)\n  );\n  geometry.uv = vPathPosition;\n\n  float isValid = step(instanceTypes, 3.5);\n  vec3 offset = vec3(offsetVec * width * isValid, 0.0);\n\n  if (needsRotation) {\n    offset = rotationMatrix * offset;\n  }\n  return offset;\n}\nvoid clipLine(inout vec4 position, vec4 refPosition) {\n  if (position.w < EPSILON) {\n    float r = (EPSILON - refPosition.w) / (position.w - refPosition.w);\n    position = refPosition + (position - refPosition) * r;\n  }\n}\n\nvoid main() {\n  geometry.pickingColor = instancePickingColors;\n\n  vColor = vec4(instanceColors.rgb, instanceColors.a * opacity);\n\n  float isEnd = positions.x;\n\n  vec3 prevPosition = mix(instanceLeftPositions, instanceStartPositions, isEnd);\n  vec3 prevPosition64Low = mix(instanceLeftPositions64Low, instanceStartPositions64Low, isEnd);\n\n  vec3 currPosition = mix(instanceStartPositions, instanceEndPositions, isEnd);\n  vec3 currPosition64Low = mix(instanceStartPositions64Low, instanceEndPositions64Low, isEnd);\n\n  vec3 nextPosition = mix(instanceEndPositions, instanceRightPositions, isEnd);\n  vec3 nextPosition64Low = mix(instanceEndPositions64Low, instanceRightPositions64Low, isEnd);\n\n  geometry.worldPosition = currPosition;\n  vec2 widthPixels = vec2(clamp(\n    project_size_to_pixel(instanceStrokeWidths * widthScale, widthUnits),\n    widthMinPixels, widthMaxPixels) / 2.0);\n  vec3 width;\n\n  if (billboard) {\n    vec4 prevPositionScreen = project_position_to_clipspace(prevPosition, prevPosition64Low, ZERO_OFFSET);\n    vec4 currPositionScreen = project_position_to_clipspace(currPosition, currPosition64Low, ZERO_OFFSET, geometry.position);\n    vec4 nextPositionScreen = project_position_to_clipspace(nextPosition, nextPosition64Low, ZERO_OFFSET);\n\n    clipLine(prevPositionScreen, currPositionScreen);\n    clipLine(nextPositionScreen, currPositionScreen);\n    clipLine(currPositionScreen, mix(nextPositionScreen, prevPositionScreen, isEnd));\n\n    width = vec3(widthPixels, 0.0);\n    DECKGL_FILTER_SIZE(width, geometry);\n\n    vec3 offset = getLineJoinOffset(\n      prevPositionScreen.xyz / prevPositionScreen.w,\n      currPositionScreen.xyz / currPositionScreen.w,\n      nextPositionScreen.xyz / nextPositionScreen.w,\n      project_pixel_size_to_clipspace(width.xy)\n    );\n\n    DECKGL_FILTER_GL_POSITION(currPositionScreen, geometry);\n    gl_Position = vec4(currPositionScreen.xyz + offset * currPositionScreen.w, currPositionScreen.w);\n  } else {\n    prevPosition = project_position(prevPosition, prevPosition64Low);\n    currPosition = project_position(currPosition, currPosition64Low);\n    nextPosition = project_position(nextPosition, nextPosition64Low);\n\n    width = vec3(project_pixel_size(widthPixels), 0.0);\n    DECKGL_FILTER_SIZE(width, geometry);\n\n    vec3 offset = getLineJoinOffset(prevPosition, currPosition, nextPosition, width.xy);\n    geometry.position = vec4(currPosition + offset, 1.0);\n    gl_Position = project_common_position_to_clipspace(geometry.position);\n    DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n  }\n  DECKGL_FILTER_COLOR(vColor, geometry);\n}\n";

});

parcelRegister("1cBlW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e03e2f52d1073da$export$2e2bcd8739ae039; });
var $0e03e2f52d1073da$export$2e2bcd8739ae039 = "#define SHADER_NAME path-layer-fragment-shader\n\nprecision highp float;\n\nuniform float miterLimit;\n\nvarying vec4 vColor;\nvarying vec2 vCornerOffset;\nvarying float vMiterLength;\nvarying vec2 vPathPosition;\nvarying float vPathLength;\nvarying float vJointType;\n\nvoid main(void) {\n  geometry.uv = vPathPosition;\n\n  if (vPathPosition.y < 0.0 || vPathPosition.y > vPathLength) {\n    if (vJointType > 0.5 && length(vCornerOffset) > 1.0) {\n      discard;\n    }\n    if (vJointType < 0.5 && vMiterLength > miterLimit + 1.0) {\n      discard;\n    }\n  }\n  gl_FragColor = vColor;\n\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";

});


parcelRegister("cNqHj", function(module, exports) {

$parcel$export(module.exports, "replaceInRange", function () { return $950ec53e6d3b20d4$export$27d2523e190d6166; });
function $950ec53e6d3b20d4$export$27d2523e190d6166({ data: data, getIndex: getIndex, dataRange: dataRange, replace: replace }) {
    const { startRow: startRow = 0, endRow: endRow = Infinity } = dataRange;
    const count = data.length;
    let replaceStart = count;
    let replaceEnd = count;
    for(let i = 0; i < count; i++){
        const row = getIndex(data[i]);
        if (replaceStart > i && row >= startRow) replaceStart = i;
        if (row >= endRow) {
            replaceEnd = i;
            break;
        }
    }
    let index = replaceStart;
    const dataLengthChanged = replaceEnd - replaceStart !== replace.length;
    const endChunk = dataLengthChanged ? data.slice(replaceEnd) : undefined;
    for(let i = 0; i < replace.length; i++)data[index++] = replace[i];
    if (endChunk) {
        for(let i = 0; i < endChunk.length; i++)data[index++] = endChunk[i];
        data.length = index;
    }
    return {
        startRow: replaceStart,
        endRow: replaceStart + replace.length
    };
}

});


parcelRegister("e9fnE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");
/**
 * Takes a bbox and returns an equivalent {@link Polygon|polygon}.
 *
 * @name bboxPolygon
 * @param {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @param {Object} [options={}] Optional parameters
 * @param {Properties} [options.properties={}] Translate properties to Polygon
 * @param {string|number} [options.id={}] Translate Id to Polygon
 * @returns {Feature<Polygon>} a Polygon representation of the bounding box
 * @example
 * var bbox = [0, 0, 10, 10];
 *
 * var poly = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [poly]
 */ function $02a87b3266d11327$var$bboxPolygon(bbox, options) {
    if (options === void 0) options = {};
    // Convert BBox positions to Numbers
    // No performance loss for including Number()
    // https://github.com/Turfjs/turf/issues/1119
    var west = Number(bbox[0]);
    var south = Number(bbox[1]);
    var east = Number(bbox[2]);
    var north = Number(bbox[3]);
    if (bbox.length === 6) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    var lowLeft = [
        west,
        south
    ];
    var topLeft = [
        west,
        north
    ];
    var topRight = [
        east,
        north
    ];
    var lowRight = [
        east,
        south
    ];
    return $7GKQS.polygon([
        [
            lowLeft,
            lowRight,
            topRight,
            topLeft,
            lowLeft
        ]
    ], options.properties, {
        bbox: bbox,
        id: options.id
    });
}
module.exports.default = $02a87b3266d11327$var$bboxPolygon;

});

parcelRegister("3qree", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $27e8ebd74235584a$export$2e2bcd8739ae039; });

var $9tGdu = parcelRequire("9tGdu");

var $juW7F = parcelRequire("juW7F");

var $fAhXk = parcelRequire("fAhXk");

var $l1DKV = parcelRequire("l1DKV");

var $HcJdv = parcelRequire("HcJdv");
parcelRequire("ixaKI");
var $c1N6T = parcelRequire("c1N6T");

var $brFkQ = parcelRequire("brFkQ");
/**
 * Calculates a buffer for input features for a given radius. Units supported are miles, kilometers, and degrees.
 *
 * When using a negative radius, the resulting geometry may be invalid if
 * it's too small compared to the radius magnitude. If the input is a
 * FeatureCollection, only valid members will be returned in the output
 * FeatureCollection - i.e., the output collection may have fewer members than
 * the input, or even be empty.
 *
 * @name buffer
 * @param {FeatureCollection|Geometry|Feature<any>} geojson input to be buffered
 * @param {number} radius distance to draw the buffer (negative values are allowed)
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units="kilometers"] any of the options supported by turf units
 * @param {number} [options.steps=64] number of steps
 * @returns {FeatureCollection|Feature<Polygon|MultiPolygon>|undefined} buffered features
 * @example
 * var point = turf.point([-90.548630, 14.616599]);
 * var buffered = turf.buffer(point, 500, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [point, buffered]
 */ function $27e8ebd74235584a$var$buffer(geojson, radius, options) {
    // Optional params
    options = options || {};
    var units = options.units;
    var steps = options.steps || 64;
    // validation
    if (!geojson) throw new Error("geojson is required");
    if (typeof options !== "object") throw new Error("options must be an object");
    if (typeof steps !== "number") throw new Error("steps must be an number");
    // Allow negative buffers ("erosion") or zero-sized buffers ("repair geometry")
    if (radius === undefined) throw new Error("radius is required");
    if (steps <= 0) throw new Error("steps must be greater than 0");
    // default params
    steps = steps || 64;
    units = units || "kilometers";
    var results = [];
    switch(geojson.type){
        case "GeometryCollection":
            (0, $HcJdv.geomEach)(geojson, function(geometry) {
                var buffered = $27e8ebd74235584a$var$bufferFeature(geometry, radius, units, steps);
                if (buffered) results.push(buffered);
            });
            return (0, $brFkQ.featureCollection)(results);
        case "FeatureCollection":
            (0, $HcJdv.featureEach)(geojson, function(feature$$1) {
                var multiBuffered = $27e8ebd74235584a$var$bufferFeature(feature$$1, radius, units, steps);
                if (multiBuffered) (0, $HcJdv.featureEach)(multiBuffered, function(buffered) {
                    if (buffered) results.push(buffered);
                });
            });
            return (0, $brFkQ.featureCollection)(results);
    }
    return $27e8ebd74235584a$var$bufferFeature(geojson, radius, units, steps);
}
/**
 * Buffer single Feature/Geometry
 *
 * @private
 * @param {Feature<any>} geojson input to be buffered
 * @param {number} radius distance to draw the buffer
 * @param {string} [units='kilometers'] any of the options supported by turf units
 * @param {number} [steps=64] number of steps
 * @returns {Feature<Polygon|MultiPolygon>} buffered feature
 */ function $27e8ebd74235584a$var$bufferFeature(geojson, radius, units, steps) {
    var properties = geojson.properties || {};
    var geometry = geojson.type === "Feature" ? geojson.geometry : geojson;
    // Geometry Types faster than jsts
    if (geometry.type === "GeometryCollection") {
        var results = [];
        (0, $HcJdv.geomEach)(geojson, function(geometry) {
            var buffered = $27e8ebd74235584a$var$bufferFeature(geometry, radius, units, steps);
            if (buffered) results.push(buffered);
        });
        return (0, $brFkQ.featureCollection)(results);
    }
    // Project GeoJSON to Transverse Mercator projection (convert to Meters)
    var projected;
    var bbox = (0, $juW7F.default)(geojson);
    var needsTransverseMercator = bbox[1] > 50 && bbox[3] > 50;
    if (needsTransverseMercator) projected = {
        type: geometry.type,
        coordinates: $27e8ebd74235584a$var$projectCoords(geometry.coordinates, $27e8ebd74235584a$var$defineProjection(geometry))
    };
    else projected = (0, $l1DKV.toMercator)(geometry);
    // JSTS buffer operation
    var reader = new (0, $fAhXk.GeoJSONReader)();
    var geom = reader.read(projected);
    var distance = (0, $brFkQ.radiansToLength)((0, $brFkQ.lengthToRadians)(radius, units), "meters");
    var buffered = (0, $fAhXk.BufferOp).bufferOp(geom, distance);
    var writer = new (0, $fAhXk.GeoJSONWriter)();
    buffered = writer.write(buffered);
    // Detect if empty geometries
    if ($27e8ebd74235584a$var$coordsIsNaN(buffered.coordinates)) return undefined;
    // Unproject coordinates (convert to Degrees)
    var result;
    if (needsTransverseMercator) result = {
        type: buffered.type,
        coordinates: $27e8ebd74235584a$var$unprojectCoords(buffered.coordinates, $27e8ebd74235584a$var$defineProjection(geometry))
    };
    else result = (0, $l1DKV.toWgs84)(buffered);
    return result.geometry ? result : (0, $brFkQ.feature)(result, properties);
}
/**
 * Coordinates isNaN
 *
 * @private
 * @param {Array<any>} coords GeoJSON Coordinates
 * @returns {boolean} if NaN exists
 */ function $27e8ebd74235584a$var$coordsIsNaN(coords) {
    if (Array.isArray(coords[0])) return $27e8ebd74235584a$var$coordsIsNaN(coords[0]);
    return isNaN(coords[0]);
}
/**
 * Project coordinates to projection
 *
 * @private
 * @param {Array<any>} coords to project
 * @param {GeoProjection} proj D3 Geo Projection
 * @returns {Array<any>} projected coordinates
 */ function $27e8ebd74235584a$var$projectCoords(coords, proj) {
    if (typeof coords[0] !== "object") return proj(coords);
    return coords.map(function(coord) {
        return $27e8ebd74235584a$var$projectCoords(coord, proj);
    });
}
/**
 * Un-Project coordinates to projection
 *
 * @private
 * @param {Array<any>} coords to un-project
 * @param {GeoProjection} proj D3 Geo Projection
 * @returns {Array<any>} un-projected coordinates
 */ function $27e8ebd74235584a$var$unprojectCoords(coords, proj) {
    if (typeof coords[0] !== "object") return proj.invert(coords);
    return coords.map(function(coord) {
        return $27e8ebd74235584a$var$unprojectCoords(coord, proj);
    });
}
/**
 * Define Transverse Mercator projection
 *
 * @private
 * @param {Geometry|Feature<any>} geojson Base projection on center of GeoJSON
 * @returns {GeoProjection} D3 Geo Transverse Mercator Projection
 */ function $27e8ebd74235584a$var$defineProjection(geojson) {
    var coords = (0, $9tGdu.default)(geojson).geometry.coordinates.reverse();
    var rotate = coords.map(function(coord) {
        return -coord;
    });
    return (0, $c1N6T.default)().center(coords).rotate(rotate).scale((0, $brFkQ.earthRadius));
}
var $27e8ebd74235584a$export$2e2bcd8739ae039 = $27e8ebd74235584a$var$buffer;

});
parcelRegister("9tGdu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e6791ccd8589941$export$2e2bcd8739ae039; });

var $juW7F = parcelRequire("juW7F");

var $brFkQ = parcelRequire("brFkQ");
/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the absolute center point of all features.
 *
 * @name center
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] an Object that is used as the {@link Feature}'s properties
 * @returns {Feature<Point>} a Point feature at the absolute center point of all input features
 * @example
 * var features = turf.featureCollection([
 *   turf.point( [-97.522259, 35.4691]),
 *   turf.point( [-97.502754, 35.463455]),
 *   turf.point( [-97.508269, 35.463245])
 * ]);
 *
 * var center = turf.center(features);
 *
 * //addToMap
 * var addToMap = [features, center]
 * center.properties['marker-size'] = 'large';
 * center.properties['marker-color'] = '#000';
 */ function $6e6791ccd8589941$var$center(geojson, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $brFkQ.isObject)(options)) throw new Error("options is invalid");
    var properties = options.properties;
    // Input validation
    if (!geojson) throw new Error("geojson is required");
    var ext = (0, $juW7F.default)(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return (0, $brFkQ.point)([
        x,
        y
    ], properties);
}
var $6e6791ccd8589941$export$2e2bcd8739ae039 = $6e6791ccd8589941$var$center;

});
parcelRegister("juW7F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e31de79dd14e9f77$export$2e2bcd8739ae039; });

var $HcJdv = parcelRequire("HcJdv");
/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */ function $e31de79dd14e9f77$var$bbox(geojson) {
    var BBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $HcJdv.coordEach)(geojson, function(coord) {
        if (BBox[0] > coord[0]) BBox[0] = coord[0];
        if (BBox[1] > coord[1]) BBox[1] = coord[1];
        if (BBox[2] < coord[0]) BBox[2] = coord[0];
        if (BBox[3] < coord[1]) BBox[3] = coord[1];
    });
    return BBox;
}
var $e31de79dd14e9f77$export$2e2bcd8739ae039 = $e31de79dd14e9f77$var$bbox;

});
parcelRegister("HcJdv", function(module, exports) {

$parcel$export(module.exports, "coordEach", function () { return $081de3d7e5fc587e$export$6e011439fde007ae; });
$parcel$export(module.exports, "featureEach", function () { return $081de3d7e5fc587e$export$45a31c4de8035258; });
$parcel$export(module.exports, "geomEach", function () { return $081de3d7e5fc587e$export$d2d248a56672ab3d; });

var $brFkQ = parcelRequire("brFkQ");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $081de3d7e5fc587e$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        if (geomType === "MultiPolygon") geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($081de3d7e5fc587e$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $081de3d7e5fc587e$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $081de3d7e5fc587e$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $081de3d7e5fc587e$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $081de3d7e5fc587e$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $081de3d7e5fc587e$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $081de3d7e5fc587e$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $081de3d7e5fc587e$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $081de3d7e5fc587e$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $081de3d7e5fc587e$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $081de3d7e5fc587e$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $081de3d7e5fc587e$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $081de3d7e5fc587e$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $081de3d7e5fc587e$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $081de3d7e5fc587e$export$12cba8b31beb353b(geojson, callback) {
    $081de3d7e5fc587e$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $brFkQ.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $brFkQ.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $081de3d7e5fc587e$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $081de3d7e5fc587e$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $081de3d7e5fc587e$export$d3ecc1efb2be121e(geojson, callback) {
    $081de3d7e5fc587e$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature$$1.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature$$1.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        if ($081de3d7e5fc587e$export$6e011439fde007ae(feature$$1, function(currentCoord, coordIndex, featureIndexCoord, mutliPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined) {
                previousCoords = currentCoord;
                return;
            }
            var currentSegment = (0, $brFkQ.lineString)([
                previousCoords,
                currentCoord
            ], feature$$1.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentInex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $081de3d7e5fc587e$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $081de3d7e5fc587e$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $081de3d7e5fc587e$export$985a91771cfc783d(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $081de3d7e5fc587e$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        if (feature$$1.geometry === null) return;
        var type = feature$$1.geometry.type;
        var coords = feature$$1.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature$$1, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $brFkQ.lineString)(coords[geometryIndex], feature$$1.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $081de3d7e5fc587e$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $081de3d7e5fc587e$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $081de3d7e5fc587e$export$2b6ba91fd8680d67(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $brFkQ.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $brFkQ.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $brFkQ.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $brFkQ.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $brFkQ.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $081de3d7e5fc587e$export$ed60ae5df1bac687(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $brFkQ.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $brFkQ.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $brFkQ.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $brFkQ.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $brFkQ.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $brFkQ.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $brFkQ.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

});
parcelRegister("brFkQ", function(module, exports) {

$parcel$export(module.exports, "earthRadius", function () { return $855247a7eed5dd77$export$e3a1ee0e9945697f; });
$parcel$export(module.exports, "feature", function () { return $855247a7eed5dd77$export$ced6ed16dfd6a264; });
$parcel$export(module.exports, "isObject", function () { return $855247a7eed5dd77$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "point", function () { return $855247a7eed5dd77$export$105684a3041cb6f3; });
$parcel$export(module.exports, "lineString", function () { return $855247a7eed5dd77$export$98ec381bb06902c3; });
$parcel$export(module.exports, "isNumber", function () { return $855247a7eed5dd77$export$7e4aa119212bc614; });
$parcel$export(module.exports, "featureCollection", function () { return $855247a7eed5dd77$export$4717c67ac3e5e04d; });
$parcel$export(module.exports, "radiansToLength", function () { return $855247a7eed5dd77$export$f234631d6a2eedf8; });
$parcel$export(module.exports, "lengthToRadians", function () { return $855247a7eed5dd77$export$a2280f7debae8f10; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $855247a7eed5dd77$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $855247a7eed5dd77$export$f929e47acbed771a = {
    meters: $855247a7eed5dd77$export$e3a1ee0e9945697f,
    metres: $855247a7eed5dd77$export$e3a1ee0e9945697f,
    millimeters: $855247a7eed5dd77$export$e3a1ee0e9945697f * 1000,
    millimetres: $855247a7eed5dd77$export$e3a1ee0e9945697f * 1000,
    centimeters: $855247a7eed5dd77$export$e3a1ee0e9945697f * 100,
    centimetres: $855247a7eed5dd77$export$e3a1ee0e9945697f * 100,
    kilometers: $855247a7eed5dd77$export$e3a1ee0e9945697f / 1000,
    kilometres: $855247a7eed5dd77$export$e3a1ee0e9945697f / 1000,
    miles: $855247a7eed5dd77$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $855247a7eed5dd77$export$e3a1ee0e9945697f / 1852,
    inches: $855247a7eed5dd77$export$e3a1ee0e9945697f * 39.370,
    yards: $855247a7eed5dd77$export$e3a1ee0e9945697f / 1.0936,
    feet: $855247a7eed5dd77$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $855247a7eed5dd77$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $855247a7eed5dd77$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $855247a7eed5dd77$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $855247a7eed5dd77$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $855247a7eed5dd77$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$855247a7eed5dd77$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $855247a7eed5dd77$export$28ac7bb8f5309bea(bbox);
    if (id) $855247a7eed5dd77$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $855247a7eed5dd77$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$855247a7eed5dd77$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $855247a7eed5dd77$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $855247a7eed5dd77$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $855247a7eed5dd77$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $855247a7eed5dd77$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $855247a7eed5dd77$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $855247a7eed5dd77$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $855247a7eed5dd77$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $855247a7eed5dd77$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$855247a7eed5dd77$export$7e4aa119212bc614(coordinates[0]) || !$855247a7eed5dd77$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $855247a7eed5dd77$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $855247a7eed5dd77$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $855247a7eed5dd77$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $855247a7eed5dd77$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $855247a7eed5dd77$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$855247a7eed5dd77$export$7e4aa119212bc614(ring[0][0]) || !$855247a7eed5dd77$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $855247a7eed5dd77$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $855247a7eed5dd77$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $855247a7eed5dd77$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $855247a7eed5dd77$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $855247a7eed5dd77$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$855247a7eed5dd77$export$7e4aa119212bc614(coordinates[0][1]) || !$855247a7eed5dd77$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $855247a7eed5dd77$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $855247a7eed5dd77$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $855247a7eed5dd77$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $855247a7eed5dd77$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $855247a7eed5dd77$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$855247a7eed5dd77$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $855247a7eed5dd77$export$28ac7bb8f5309bea(bbox);
    if (id) $855247a7eed5dd77$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $855247a7eed5dd77$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $855247a7eed5dd77$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $855247a7eed5dd77$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $855247a7eed5dd77$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $855247a7eed5dd77$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $855247a7eed5dd77$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $855247a7eed5dd77$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $855247a7eed5dd77$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $855247a7eed5dd77$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $855247a7eed5dd77$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $855247a7eed5dd77$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $855247a7eed5dd77$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $855247a7eed5dd77$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $855247a7eed5dd77$export$c7a138e00a89bd01(distance, units) {
    return $855247a7eed5dd77$export$c41dd2a8460d3196($855247a7eed5dd77$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $855247a7eed5dd77$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $855247a7eed5dd77$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $855247a7eed5dd77$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $855247a7eed5dd77$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $855247a7eed5dd77$export$f234631d6a2eedf8($855247a7eed5dd77$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $855247a7eed5dd77$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $855247a7eed5dd77$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $855247a7eed5dd77$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $855247a7eed5dd77$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $855247a7eed5dd77$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $855247a7eed5dd77$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$855247a7eed5dd77$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $855247a7eed5dd77$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $855247a7eed5dd77$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $855247a7eed5dd77$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $855247a7eed5dd77$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $855247a7eed5dd77$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $855247a7eed5dd77$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $855247a7eed5dd77$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $855247a7eed5dd77$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});




parcelRegister("fAhXk", function(module, exports) {
!function(t, e) {
    e(module.exports);
}(module.exports, function(t) {
    "use strict";
    function e() {}
    function n(t) {
        this.message = t || "";
    }
    function i(t) {
        this.message = t || "";
    }
    function r(t) {
        this.message = t || "";
    }
    function o() {}
    function s(t) {
        return null === t ? Mt : t.color;
    }
    function a(t) {
        return null === t ? null : t.parent;
    }
    function u(t, e) {
        null !== t && (t.color = e);
    }
    function l(t) {
        return null === t ? null : t.left;
    }
    function c(t) {
        return null === t ? null : t.right;
    }
    function p() {
        this.root_ = null, this.size_ = 0;
    }
    function h() {}
    function f() {
        this.array_ = [], arguments[0] instanceof It && this.addAll(arguments[0]);
    }
    function g() {}
    function d(t) {
        this.message = t || "";
    }
    function y() {
        this.array_ = [];
    }
    "fill" in Array.prototype || Object.defineProperty(Array.prototype, "fill", {
        configurable: !0,
        value: function(t) {
            if (void 0 === this || null === this) throw new TypeError(this + " is not an object");
            var e = Object(this), n = Math.max(Math.min(e.length, 9007199254740991), 0) || 0, i = 1 in arguments ? parseInt(Number(arguments[1]), 10) || 0 : 0;
            i = i < 0 ? Math.max(n + i, 0) : Math.min(i, n);
            var r = 2 in arguments && void 0 !== arguments[2] ? parseInt(Number(arguments[2]), 10) || 0 : n;
            for(r = r < 0 ? Math.max(n + arguments[2], 0) : Math.min(r, n); i < r;)e[i] = t, ++i;
            return e;
        },
        writable: !0
    }), Number.isFinite = Number.isFinite || function(t) {
        return "number" == typeof t && isFinite(t);
    }, Number.isInteger = Number.isInteger || function(t) {
        return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
    }, Number.parseFloat = Number.parseFloat || parseFloat, Number.isNaN = Number.isNaN || function(t) {
        return t != t;
    }, Math.trunc = Math.trunc || function(t) {
        return t < 0 ? Math.ceil(t) : Math.floor(t);
    };
    var _ = function() {};
    _.prototype.interfaces_ = function() {
        return [];
    }, _.prototype.getClass = function() {
        return _;
    }, _.prototype.equalsWithTolerance = function(t, e, n) {
        return Math.abs(t - e) <= n;
    };
    var m = function(t) {
        function e(e) {
            t.call(this, e), this.name = "IllegalArgumentException", this.message = e, this.stack = (new t).stack;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
    }(Error), v = function() {}, I = {
        MAX_VALUE: {
            configurable: !0
        }
    };
    v.isNaN = function(t) {
        return Number.isNaN(t);
    }, v.doubleToLongBits = function(t) {
        return t;
    }, v.longBitsToDouble = function(t) {
        return t;
    }, v.isInfinite = function(t) {
        return !Number.isFinite(t);
    }, I.MAX_VALUE.get = function() {
        return Number.MAX_VALUE;
    }, Object.defineProperties(v, I);
    var E = function() {}, x = function() {}, N = function() {}, C = function t() {
        if (this.x = null, this.y = null, this.z = null, 0 === arguments.length) this.x = 0, this.y = 0, this.z = t.NULL_ORDINATE;
        else if (1 === arguments.length) {
            var e = arguments[0];
            this.x = e.x, this.y = e.y, this.z = e.z;
        } else 2 === arguments.length ? (this.x = arguments[0], this.y = arguments[1], this.z = t.NULL_ORDINATE) : 3 === arguments.length && (this.x = arguments[0], this.y = arguments[1], this.z = arguments[2]);
    }, S = {
        DimensionalComparator: {
            configurable: !0
        },
        serialVersionUID: {
            configurable: !0
        },
        NULL_ORDINATE: {
            configurable: !0
        },
        X: {
            configurable: !0
        },
        Y: {
            configurable: !0
        },
        Z: {
            configurable: !0
        }
    };
    C.prototype.setOrdinate = function(t, e) {
        switch(t){
            case C.X:
                this.x = e;
                break;
            case C.Y:
                this.y = e;
                break;
            case C.Z:
                this.z = e;
                break;
            default:
                throw new m("Invalid ordinate index: " + t);
        }
    }, C.prototype.equals2D = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.x === t.x && this.y === t.y;
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return !!_.equalsWithTolerance(this.x, e.x, n) && !!_.equalsWithTolerance(this.y, e.y, n);
        }
    }, C.prototype.getOrdinate = function(t) {
        switch(t){
            case C.X:
                return this.x;
            case C.Y:
                return this.y;
            case C.Z:
                return this.z;
        }
        throw new m("Invalid ordinate index: " + t);
    }, C.prototype.equals3D = function(t) {
        return this.x === t.x && this.y === t.y && (this.z === t.z || v.isNaN(this.z)) && v.isNaN(t.z);
    }, C.prototype.equals = function(t) {
        return t instanceof C && this.equals2D(t);
    }, C.prototype.equalInZ = function(t, e) {
        return _.equalsWithTolerance(this.z, t.z, e);
    }, C.prototype.compareTo = function(t) {
        var e = t;
        return this.x < e.x ? -1 : this.x > e.x ? 1 : this.y < e.y ? -1 : this.y > e.y ? 1 : 0;
    }, C.prototype.clone = function() {}, C.prototype.copy = function() {
        return new C(this);
    }, C.prototype.toString = function() {
        return "(" + this.x + ", " + this.y + ", " + this.z + ")";
    }, C.prototype.distance3D = function(t) {
        var e = this.x - t.x, n = this.y - t.y, i = this.z - t.z;
        return Math.sqrt(e * e + n * n + i * i);
    }, C.prototype.distance = function(t) {
        var e = this.x - t.x, n = this.y - t.y;
        return Math.sqrt(e * e + n * n);
    }, C.prototype.hashCode = function() {
        var t = 17;
        return t = 37 * t + C.hashCode(this.x), t = 37 * t + C.hashCode(this.y);
    }, C.prototype.setCoordinate = function(t) {
        this.x = t.x, this.y = t.y, this.z = t.z;
    }, C.prototype.interfaces_ = function() {
        return [
            E,
            x,
            e
        ];
    }, C.prototype.getClass = function() {
        return C;
    }, C.hashCode = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = v.doubleToLongBits(t);
            return Math.trunc((e ^ e) >>> 32);
        }
    }, S.DimensionalComparator.get = function() {
        return L;
    }, S.serialVersionUID.get = function() {
        return 0x5cbf2c235c7e5800;
    }, S.NULL_ORDINATE.get = function() {
        return v.NaN;
    }, S.X.get = function() {
        return 0;
    }, S.Y.get = function() {
        return 1;
    }, S.Z.get = function() {
        return 2;
    }, Object.defineProperties(C, S);
    var L = function(t) {
        if (this._dimensionsToTest = 2, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var e = arguments[0];
            if (2 !== e && 3 !== e) throw new m("only 2 or 3 dimensions may be specified");
            this._dimensionsToTest = e;
        }
    };
    L.prototype.compare = function(t, e) {
        var n = t, i = e, r = L.compare(n.x, i.x);
        if (0 !== r) return r;
        var o = L.compare(n.y, i.y);
        if (0 !== o) return o;
        if (this._dimensionsToTest <= 2) return 0;
        return L.compare(n.z, i.z);
    }, L.prototype.interfaces_ = function() {
        return [
            N
        ];
    }, L.prototype.getClass = function() {
        return L;
    }, L.compare = function(t, e) {
        return t < e ? -1 : t > e ? 1 : v.isNaN(t) ? v.isNaN(e) ? 0 : -1 : v.isNaN(e) ? 1 : 0;
    };
    var b = function() {};
    b.prototype.create = function() {}, b.prototype.interfaces_ = function() {
        return [];
    }, b.prototype.getClass = function() {
        return b;
    };
    var w = function() {}, O = {
        INTERIOR: {
            configurable: !0
        },
        BOUNDARY: {
            configurable: !0
        },
        EXTERIOR: {
            configurable: !0
        },
        NONE: {
            configurable: !0
        }
    };
    w.prototype.interfaces_ = function() {
        return [];
    }, w.prototype.getClass = function() {
        return w;
    }, w.toLocationSymbol = function(t) {
        switch(t){
            case w.EXTERIOR:
                return "e";
            case w.BOUNDARY:
                return "b";
            case w.INTERIOR:
                return "i";
            case w.NONE:
                return "-";
        }
        throw new m("Unknown location value: " + t);
    }, O.INTERIOR.get = function() {
        return 0;
    }, O.BOUNDARY.get = function() {
        return 1;
    }, O.EXTERIOR.get = function() {
        return 2;
    }, O.NONE.get = function() {
        return -1;
    }, Object.defineProperties(w, O);
    var T = function(t, e) {
        return t.interfaces_ && t.interfaces_().indexOf(e) > -1;
    }, R = function() {}, P = {
        LOG_10: {
            configurable: !0
        }
    };
    R.prototype.interfaces_ = function() {
        return [];
    }, R.prototype.getClass = function() {
        return R;
    }, R.log10 = function(t) {
        var e = Math.log(t);
        return v.isInfinite(e) ? e : v.isNaN(e) ? e : e / R.LOG_10;
    }, R.min = function(t, e, n, i) {
        var r = t;
        return e < r && (r = e), n < r && (r = n), i < r && (r = i), r;
    }, R.clamp = function() {
        if ("number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
            var t = arguments[0], e = arguments[1], n = arguments[2];
            return t < e ? e : t > n ? n : t;
        }
        if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
            var i = arguments[0], r = arguments[1], o = arguments[2];
            return i < r ? r : i > o ? o : i;
        }
    }, R.wrap = function(t, e) {
        return t < 0 ? e - -t % e : t % e;
    }, R.max = function() {
        if (3 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2], i = t;
            return e > i && (i = e), n > i && (i = n), i;
        }
        if (4 === arguments.length) {
            var r = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3], u = r;
            return o > u && (u = o), s > u && (u = s), a > u && (u = a), u;
        }
    }, R.average = function(t, e) {
        return (t + e) / 2;
    }, P.LOG_10.get = function() {
        return Math.log(10);
    }, Object.defineProperties(R, P);
    var D = function(t) {
        this.str = t;
    };
    D.prototype.append = function(t) {
        this.str += t;
    }, D.prototype.setCharAt = function(t, e) {
        this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
    }, D.prototype.toString = function(t) {
        return this.str;
    };
    var M = function(t) {
        this.value = t;
    };
    M.prototype.intValue = function() {
        return this.value;
    }, M.prototype.compareTo = function(t) {
        return this.value < t ? -1 : this.value > t ? 1 : 0;
    }, M.isNaN = function(t) {
        return Number.isNaN(t);
    };
    var A = function() {};
    A.isWhitespace = function(t) {
        return t <= 32 && t >= 0 || 127 === t;
    }, A.toUpperCase = function(t) {
        return t.toUpperCase();
    };
    var F = function t() {
        if (this._hi = 0, this._lo = 0, 0 === arguments.length) this.init(0);
        else if (1 === arguments.length) {
            if ("number" == typeof arguments[0]) {
                var e = arguments[0];
                this.init(e);
            } else if (arguments[0] instanceof t) {
                var n = arguments[0];
                this.init(n);
            } else if ("string" == typeof arguments[0]) {
                var i = arguments[0];
                t.call(this, t.parse(i));
            }
        } else if (2 === arguments.length) {
            var r = arguments[0], o = arguments[1];
            this.init(r, o);
        }
    }, G = {
        PI: {
            configurable: !0
        },
        TWO_PI: {
            configurable: !0
        },
        PI_2: {
            configurable: !0
        },
        E: {
            configurable: !0
        },
        NaN: {
            configurable: !0
        },
        EPS: {
            configurable: !0
        },
        SPLIT: {
            configurable: !0
        },
        MAX_PRINT_DIGITS: {
            configurable: !0
        },
        TEN: {
            configurable: !0
        },
        ONE: {
            configurable: !0
        },
        SCI_NOT_EXPONENT_CHAR: {
            configurable: !0
        },
        SCI_NOT_ZERO: {
            configurable: !0
        }
    };
    F.prototype.le = function(t) {
        return (this._hi < t._hi || this._hi === t._hi) && this._lo <= t._lo;
    }, F.prototype.extractSignificantDigits = function(t, e) {
        var n = this.abs(), i = F.magnitude(n._hi), r = F.TEN.pow(i);
        (n = n.divide(r)).gt(F.TEN) ? (n = n.divide(F.TEN), i += 1) : n.lt(F.ONE) && (n = n.multiply(F.TEN), i -= 1);
        for(var o = i + 1, s = new D, a = F.MAX_PRINT_DIGITS - 1, u = 0; u <= a; u++){
            t && u === o && s.append(".");
            var l = Math.trunc(n._hi);
            if (l < 0) break;
            var c = !1, p = 0;
            l > 9 ? (c = !0, p = "9") : p = "0" + l, s.append(p), n = n.subtract(F.valueOf(l)).multiply(F.TEN), c && n.selfAdd(F.TEN);
            var h = !0, f = F.magnitude(n._hi);
            if (f < 0 && Math.abs(f) >= a - u && (h = !1), !h) break;
        }
        return e[0] = i, s.toString();
    }, F.prototype.sqr = function() {
        return this.multiply(this);
    }, F.prototype.doubleValue = function() {
        return this._hi + this._lo;
    }, F.prototype.subtract = function() {
        if (arguments[0] instanceof F) {
            var t = arguments[0];
            return this.add(t.negate());
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.add(-e);
        }
    }, F.prototype.equals = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this._hi === t._hi && this._lo === t._lo;
        }
    }, F.prototype.isZero = function() {
        return 0 === this._hi && 0 === this._lo;
    }, F.prototype.selfSubtract = function() {
        if (arguments[0] instanceof F) {
            var t = arguments[0];
            return this.isNaN() ? this : this.selfAdd(-t._hi, -t._lo);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.isNaN() ? this : this.selfAdd(-e, 0);
        }
    }, F.prototype.getSpecialNumberString = function() {
        return this.isZero() ? "0.0" : this.isNaN() ? "NaN " : null;
    }, F.prototype.min = function(t) {
        return this.le(t) ? this : t;
    }, F.prototype.selfDivide = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof F) {
                var t = arguments[0];
                return this.selfDivide(t._hi, t._lo);
            }
            if ("number" == typeof arguments[0]) {
                var e = arguments[0];
                return this.selfDivide(e, 0);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = null, o = null, s = null, a = null, u = null, l = null, c = null, p = null;
            return u = this._hi / n, l = F.SPLIT * u, r = l - u, p = F.SPLIT * n, r = l - r, o = u - r, s = p - n, c = u * n, s = p - s, a = n - s, p = r * s - c + r * a + o * s + o * a, l = (this._hi - c - p + this._lo - u * i) / n, p = u + l, this._hi = p, this._lo = u - p + l, this;
        }
    }, F.prototype.dump = function() {
        return "DD<" + this._hi + ", " + this._lo + ">";
    }, F.prototype.divide = function() {
        if (arguments[0] instanceof F) {
            var t = arguments[0], e = null, n = null, i = null, r = null, o = null, s = null, a = null, u = null;
            n = (o = this._hi / t._hi) - (e = (s = F.SPLIT * o) - (e = s - o)), u = e * (i = (u = F.SPLIT * t._hi) - (i = u - t._hi)) - (a = o * t._hi) + e * (r = t._hi - i) + n * i + n * r, s = (this._hi - a - u + this._lo - o * t._lo) / t._hi;
            return new F(u = o + s, o - u + s);
        }
        if ("number" == typeof arguments[0]) {
            var l = arguments[0];
            return v.isNaN(l) ? F.createNaN() : F.copy(this).selfDivide(l, 0);
        }
    }, F.prototype.ge = function(t) {
        return (this._hi > t._hi || this._hi === t._hi) && this._lo >= t._lo;
    }, F.prototype.pow = function(t) {
        if (0 === t) return F.valueOf(1);
        var e = new F(this), n = F.valueOf(1), i = Math.abs(t);
        if (i > 1) for(; i > 0;)i % 2 == 1 && n.selfMultiply(e), (i /= 2) > 0 && (e = e.sqr());
        else n = e;
        return t < 0 ? n.reciprocal() : n;
    }, F.prototype.ceil = function() {
        if (this.isNaN()) return F.NaN;
        var t = Math.ceil(this._hi), e = 0;
        return t === this._hi && (e = Math.ceil(this._lo)), new F(t, e);
    }, F.prototype.compareTo = function(t) {
        var e = t;
        return this._hi < e._hi ? -1 : this._hi > e._hi ? 1 : this._lo < e._lo ? -1 : this._lo > e._lo ? 1 : 0;
    }, F.prototype.rint = function() {
        if (this.isNaN()) return this;
        return this.add(.5).floor();
    }, F.prototype.setValue = function() {
        if (arguments[0] instanceof F) {
            var t = arguments[0];
            return this.init(t), this;
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.init(e), this;
        }
    }, F.prototype.max = function(t) {
        return this.ge(t) ? this : t;
    }, F.prototype.sqrt = function() {
        if (this.isZero()) return F.valueOf(0);
        if (this.isNegative()) return F.NaN;
        var t = 1 / Math.sqrt(this._hi), e = this._hi * t, n = F.valueOf(e), i = this.subtract(n.sqr())._hi * (.5 * t);
        return n.add(i);
    }, F.prototype.selfAdd = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof F) {
                var t = arguments[0];
                return this.selfAdd(t._hi, t._lo);
            }
            if ("number" == typeof arguments[0]) {
                var e = arguments[0], n = null, i = null, r = null, o = null, s = null, a = null;
                return r = this._hi + e, s = r - this._hi, o = r - s, o = e - s + (this._hi - o), a = o + this._lo, n = r + a, i = a + (r - n), this._hi = n + i, this._lo = i + (n - this._hi), this;
            }
        } else if (2 === arguments.length) {
            var u = arguments[0], l = arguments[1], c = null, p = null, h = null, f = null, g = null, d = null, y = null;
            f = this._hi + u, p = this._lo + l, g = f - (d = f - this._hi), h = p - (y = p - this._lo);
            var _ = (c = f + (d = (g = u - d + (this._hi - g)) + p)) + (d = (h = l - y + (this._lo - h)) + (d + (f - c))), m = d + (c - _);
            return this._hi = _, this._lo = m, this;
        }
    }, F.prototype.selfMultiply = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof F) {
                var t = arguments[0];
                return this.selfMultiply(t._hi, t._lo);
            }
            if ("number" == typeof arguments[0]) {
                var e = arguments[0];
                return this.selfMultiply(e, 0);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = null, o = null, s = null, a = null, u = null, l = null;
            r = (u = F.SPLIT * this._hi) - this._hi, l = F.SPLIT * n, r = u - r, o = this._hi - r, s = l - n;
            var c = (u = this._hi * n) + (l = r * (s = l - s) - u + r * (a = n - s) + o * s + o * a + (this._hi * i + this._lo * n)), p = l + (r = u - c);
            return this._hi = c, this._lo = p, this;
        }
    }, F.prototype.selfSqr = function() {
        return this.selfMultiply(this);
    }, F.prototype.floor = function() {
        if (this.isNaN()) return F.NaN;
        var t = Math.floor(this._hi), e = 0;
        return t === this._hi && (e = Math.floor(this._lo)), new F(t, e);
    }, F.prototype.negate = function() {
        return this.isNaN() ? this : new F(-this._hi, -this._lo);
    }, F.prototype.clone = function() {}, F.prototype.multiply = function() {
        if (arguments[0] instanceof F) {
            var t = arguments[0];
            return t.isNaN() ? F.createNaN() : F.copy(this).selfMultiply(t);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return v.isNaN(e) ? F.createNaN() : F.copy(this).selfMultiply(e, 0);
        }
    }, F.prototype.isNaN = function() {
        return v.isNaN(this._hi);
    }, F.prototype.intValue = function() {
        return Math.trunc(this._hi);
    }, F.prototype.toString = function() {
        var t = F.magnitude(this._hi);
        return t >= -3 && t <= 20 ? this.toStandardNotation() : this.toSciNotation();
    }, F.prototype.toStandardNotation = function() {
        var t = this.getSpecialNumberString();
        if (null !== t) return t;
        var e = new Array(1).fill(null), n = this.extractSignificantDigits(!0, e), i = e[0] + 1, r = n;
        if ("." === n.charAt(0)) r = "0" + n;
        else if (i < 0) r = "0." + F.stringOfChar("0", -i) + n;
        else if (-1 === n.indexOf(".")) {
            var o = i - n.length;
            r = n + F.stringOfChar("0", o) + ".0";
        }
        return this.isNegative() ? "-" + r : r;
    }, F.prototype.reciprocal = function() {
        var t = null, e = null, n = null, i = null, r = null, o = null, s = null, a = null;
        e = (r = 1 / this._hi) - (t = (o = F.SPLIT * r) - (t = o - r)), n = (a = F.SPLIT * this._hi) - this._hi;
        var u = r + (o = (1 - (s = r * this._hi) - (a = t * (n = a - n) - s + t * (i = this._hi - n) + e * n + e * i) - r * this._lo) / this._hi);
        return new F(u, r - u + o);
    }, F.prototype.toSciNotation = function() {
        if (this.isZero()) return F.SCI_NOT_ZERO;
        var t = this.getSpecialNumberString();
        if (null !== t) return t;
        var e = new Array(1).fill(null), n = this.extractSignificantDigits(!1, e), i = F.SCI_NOT_EXPONENT_CHAR + e[0];
        if ("0" === n.charAt(0)) throw new Error("Found leading zero: " + n);
        var r = "";
        n.length > 1 && (r = n.substring(1));
        var o = n.charAt(0) + "." + r;
        return this.isNegative() ? "-" + o + i : o + i;
    }, F.prototype.abs = function() {
        return this.isNaN() ? F.NaN : this.isNegative() ? this.negate() : new F(this);
    }, F.prototype.isPositive = function() {
        return (this._hi > 0 || 0 === this._hi) && this._lo > 0;
    }, F.prototype.lt = function(t) {
        return (this._hi < t._hi || this._hi === t._hi) && this._lo < t._lo;
    }, F.prototype.add = function() {
        if (arguments[0] instanceof F) {
            var t = arguments[0];
            return F.copy(this).selfAdd(t);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return F.copy(this).selfAdd(e);
        }
    }, F.prototype.init = function() {
        if (1 === arguments.length) {
            if ("number" == typeof arguments[0]) {
                var t = arguments[0];
                this._hi = t, this._lo = 0;
            } else if (arguments[0] instanceof F) {
                var e = arguments[0];
                this._hi = e._hi, this._lo = e._lo;
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            this._hi = n, this._lo = i;
        }
    }, F.prototype.gt = function(t) {
        return (this._hi > t._hi || this._hi === t._hi) && this._lo > t._lo;
    }, F.prototype.isNegative = function() {
        return (this._hi < 0 || 0 === this._hi) && this._lo < 0;
    }, F.prototype.trunc = function() {
        return this.isNaN() ? F.NaN : this.isPositive() ? this.floor() : this.ceil();
    }, F.prototype.signum = function() {
        return this._hi > 0 ? 1 : this._hi < 0 ? -1 : this._lo > 0 ? 1 : this._lo < 0 ? -1 : 0;
    }, F.prototype.interfaces_ = function() {
        return [
            e,
            E,
            x
        ];
    }, F.prototype.getClass = function() {
        return F;
    }, F.sqr = function(t) {
        return F.valueOf(t).selfMultiply(t);
    }, F.valueOf = function() {
        if ("string" == typeof arguments[0]) {
            var t = arguments[0];
            return F.parse(t);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return new F(e);
        }
    }, F.sqrt = function(t) {
        return F.valueOf(t).sqrt();
    }, F.parse = function(t) {
        for(var e = 0, n = t.length; A.isWhitespace(t.charAt(e));)e++;
        var i = !1;
        if (e < n) {
            var r = t.charAt(e);
            "-" !== r && "+" !== r || (e++, "-" === r && (i = !0));
        }
        for(var o = new F, s = 0, a = 0, u = 0; !(e >= n);){
            var l = t.charAt(e);
            if (e++, A.isDigit(l)) {
                var c = l - "0";
                o.selfMultiply(F.TEN), o.selfAdd(c), s++;
            } else {
                if ("." !== l) {
                    if ("e" === l || "E" === l) {
                        var p = t.substring(e);
                        try {
                            u = M.parseInt(p);
                        } catch (e) {
                            throw e instanceof Error ? new Error("Invalid exponent " + p + " in string " + t) : e;
                        }
                        break;
                    }
                    throw new Error("Unexpected character '" + l + "' at position " + e + " in string " + t);
                }
                a = s;
            }
        }
        var h = o, f = s - a - u;
        if (0 === f) h = o;
        else if (f > 0) {
            var g = F.TEN.pow(f);
            h = o.divide(g);
        } else if (f < 0) {
            var d = F.TEN.pow(-f);
            h = o.multiply(d);
        }
        return i ? h.negate() : h;
    }, F.createNaN = function() {
        return new F(v.NaN, v.NaN);
    }, F.copy = function(t) {
        return new F(t);
    }, F.magnitude = function(t) {
        var e = Math.abs(t), n = Math.log(e) / Math.log(10), i = Math.trunc(Math.floor(n));
        return 10 * Math.pow(10, i) <= e && (i += 1), i;
    }, F.stringOfChar = function(t, e) {
        for(var n = new D, i = 0; i < e; i++)n.append(t);
        return n.toString();
    }, G.PI.get = function() {
        return new F(3.141592653589793, 1.2246467991473532e-16);
    }, G.TWO_PI.get = function() {
        return new F(6.283185307179586, 2.4492935982947064e-16);
    }, G.PI_2.get = function() {
        return new F(1.5707963267948966, 6.123233995736766e-17);
    }, G.E.get = function() {
        return new F(2.718281828459045, 1.4456468917292502e-16);
    }, G.NaN.get = function() {
        return new F(v.NaN, v.NaN);
    }, G.EPS.get = function() {
        return 1.23259516440783e-32;
    }, G.SPLIT.get = function() {
        return 134217729;
    }, G.MAX_PRINT_DIGITS.get = function() {
        return 32;
    }, G.TEN.get = function() {
        return F.valueOf(10);
    }, G.ONE.get = function() {
        return F.valueOf(1);
    }, G.SCI_NOT_EXPONENT_CHAR.get = function() {
        return "E";
    }, G.SCI_NOT_ZERO.get = function() {
        return "0.0E0";
    }, Object.defineProperties(F, G);
    var q = function() {}, B = {
        DP_SAFE_EPSILON: {
            configurable: !0
        }
    };
    q.prototype.interfaces_ = function() {
        return [];
    }, q.prototype.getClass = function() {
        return q;
    }, q.orientationIndex = function(t, e, n) {
        var i = q.orientationIndexFilter(t, e, n);
        if (i <= 1) return i;
        var r = F.valueOf(e.x).selfAdd(-t.x), o = F.valueOf(e.y).selfAdd(-t.y), s = F.valueOf(n.x).selfAdd(-e.x), a = F.valueOf(n.y).selfAdd(-e.y);
        return r.selfMultiply(a).selfSubtract(o.selfMultiply(s)).signum();
    }, q.signOfDet2x2 = function(t, e, n, i) {
        return t.multiply(i).selfSubtract(e.multiply(n)).signum();
    }, q.intersection = function(t, e, n, i) {
        var r = F.valueOf(i.y).selfSubtract(n.y).selfMultiply(F.valueOf(e.x).selfSubtract(t.x)), o = F.valueOf(i.x).selfSubtract(n.x).selfMultiply(F.valueOf(e.y).selfSubtract(t.y)), s = r.subtract(o), a = F.valueOf(i.x).selfSubtract(n.x).selfMultiply(F.valueOf(t.y).selfSubtract(n.y)), u = F.valueOf(i.y).selfSubtract(n.y).selfMultiply(F.valueOf(t.x).selfSubtract(n.x)), l = a.subtract(u).selfDivide(s).doubleValue(), c = F.valueOf(t.x).selfAdd(F.valueOf(e.x).selfSubtract(t.x).selfMultiply(l)).doubleValue(), p = F.valueOf(e.x).selfSubtract(t.x).selfMultiply(F.valueOf(t.y).selfSubtract(n.y)), h = F.valueOf(e.y).selfSubtract(t.y).selfMultiply(F.valueOf(t.x).selfSubtract(n.x)), f = p.subtract(h).selfDivide(s).doubleValue(), g = F.valueOf(n.y).selfAdd(F.valueOf(i.y).selfSubtract(n.y).selfMultiply(f)).doubleValue();
        return new C(c, g);
    }, q.orientationIndexFilter = function(t, e, n) {
        var i = null, r = (t.x - n.x) * (e.y - n.y), o = (t.y - n.y) * (e.x - n.x), s = r - o;
        if (r > 0) {
            if (o <= 0) return q.signum(s);
            i = r + o;
        } else {
            if (!(r < 0)) return q.signum(s);
            if (o >= 0) return q.signum(s);
            i = -r - o;
        }
        var a = q.DP_SAFE_EPSILON * i;
        return s >= a || -s >= a ? q.signum(s) : 2;
    }, q.signum = function(t) {
        return t > 0 ? 1 : t < 0 ? -1 : 0;
    }, B.DP_SAFE_EPSILON.get = function() {
        return 1e-15;
    }, Object.defineProperties(q, B);
    var V = function() {}, U = {
        X: {
            configurable: !0
        },
        Y: {
            configurable: !0
        },
        Z: {
            configurable: !0
        },
        M: {
            configurable: !0
        }
    };
    U.X.get = function() {
        return 0;
    }, U.Y.get = function() {
        return 1;
    }, U.Z.get = function() {
        return 2;
    }, U.M.get = function() {
        return 3;
    }, V.prototype.setOrdinate = function(t, e, n) {}, V.prototype.size = function() {}, V.prototype.getOrdinate = function(t, e) {}, V.prototype.getCoordinate = function() {}, V.prototype.getCoordinateCopy = function(t) {}, V.prototype.getDimension = function() {}, V.prototype.getX = function(t) {}, V.prototype.clone = function() {}, V.prototype.expandEnvelope = function(t) {}, V.prototype.copy = function() {}, V.prototype.getY = function(t) {}, V.prototype.toCoordinateArray = function() {}, V.prototype.interfaces_ = function() {
        return [
            x
        ];
    }, V.prototype.getClass = function() {
        return V;
    }, Object.defineProperties(V, U);
    var z = function() {}, X = function(t) {
        function e() {
            t.call(this, "Projective point not representable on the Cartesian plane.");
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(z), Y = function() {};
    Y.arraycopy = function(t, e, n, i, r) {
        for(var o = 0, s = e; s < e + r; s++)n[i + o] = t[s], o++;
    }, Y.getProperty = function(t) {
        return ({
            "line.separator": "\n"
        })[t];
    };
    var k = function t() {
        if (this.x = null, this.y = null, this.w = null, 0 === arguments.length) this.x = 0, this.y = 0, this.w = 1;
        else if (1 === arguments.length) {
            var e = arguments[0];
            this.x = e.x, this.y = e.y, this.w = 1;
        } else if (2 === arguments.length) {
            if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                var n = arguments[0], i = arguments[1];
                this.x = n, this.y = i, this.w = 1;
            } else if (arguments[0] instanceof t && arguments[1] instanceof t) {
                var r = arguments[0], o = arguments[1];
                this.x = r.y * o.w - o.y * r.w, this.y = o.x * r.w - r.x * o.w, this.w = r.x * o.y - o.x * r.y;
            } else if (arguments[0] instanceof C && arguments[1] instanceof C) {
                var s = arguments[0], a = arguments[1];
                this.x = s.y - a.y, this.y = a.x - s.x, this.w = s.x * a.y - a.x * s.y;
            }
        } else if (3 === arguments.length) {
            var u = arguments[0], l = arguments[1], c = arguments[2];
            this.x = u, this.y = l, this.w = c;
        } else if (4 === arguments.length) {
            var p = arguments[0], h = arguments[1], f = arguments[2], g = arguments[3], d = p.y - h.y, y = h.x - p.x, _ = p.x * h.y - h.x * p.y, m = f.y - g.y, v = g.x - f.x, I = f.x * g.y - g.x * f.y;
            this.x = y * I - v * _, this.y = m * _ - d * I, this.w = d * v - m * y;
        }
    };
    k.prototype.getY = function() {
        var t = this.y / this.w;
        if (v.isNaN(t) || v.isInfinite(t)) throw new X;
        return t;
    }, k.prototype.getX = function() {
        var t = this.x / this.w;
        if (v.isNaN(t) || v.isInfinite(t)) throw new X;
        return t;
    }, k.prototype.getCoordinate = function() {
        var t = new C;
        return t.x = this.getX(), t.y = this.getY(), t;
    }, k.prototype.interfaces_ = function() {
        return [];
    }, k.prototype.getClass = function() {
        return k;
    }, k.intersection = function(t, e, n, i) {
        var r = t.y - e.y, o = e.x - t.x, s = t.x * e.y - e.x * t.y, a = n.y - i.y, u = i.x - n.x, l = n.x * i.y - i.x * n.y, c = r * u - a * o, p = (o * l - u * s) / c, h = (a * s - r * l) / c;
        if (v.isNaN(p) || v.isInfinite(p) || v.isNaN(h) || v.isInfinite(h)) throw new X;
        return new C(p, h);
    };
    var j = function t() {
        if (this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, 0 === arguments.length) this.init();
        else if (1 === arguments.length) {
            if (arguments[0] instanceof C) {
                var e = arguments[0];
                this.init(e.x, e.x, e.y, e.y);
            } else if (arguments[0] instanceof t) {
                var n = arguments[0];
                this.init(n);
            }
        } else if (2 === arguments.length) {
            var i = arguments[0], r = arguments[1];
            this.init(i.x, r.x, i.y, r.y);
        } else if (4 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2], u = arguments[3];
            this.init(o, s, a, u);
        }
    }, H = {
        serialVersionUID: {
            configurable: !0
        }
    };
    j.prototype.getArea = function() {
        return this.getWidth() * this.getHeight();
    }, j.prototype.equals = function(t) {
        if (!(t instanceof j)) return !1;
        var e = t;
        return this.isNull() ? e.isNull() : this._maxx === e.getMaxX() && this._maxy === e.getMaxY() && this._minx === e.getMinX() && this._miny === e.getMinY();
    }, j.prototype.intersection = function(t) {
        if (this.isNull() || t.isNull() || !this.intersects(t)) return new j;
        var e = this._minx > t._minx ? this._minx : t._minx, n = this._miny > t._miny ? this._miny : t._miny, i = this._maxx < t._maxx ? this._maxx : t._maxx, r = this._maxy < t._maxy ? this._maxy : t._maxy;
        return new j(e, i, n, r);
    }, j.prototype.isNull = function() {
        return this._maxx < this._minx;
    }, j.prototype.getMaxX = function() {
        return this._maxx;
    }, j.prototype.covers = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof C) {
                var t = arguments[0];
                return this.covers(t.x, t.y);
            }
            if (arguments[0] instanceof j) {
                var e = arguments[0];
                return !this.isNull() && !e.isNull() && e.getMinX() >= this._minx && e.getMaxX() <= this._maxx && e.getMinY() >= this._miny && e.getMaxY() <= this._maxy;
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            return !this.isNull() && n >= this._minx && n <= this._maxx && i >= this._miny && i <= this._maxy;
        }
    }, j.prototype.intersects = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof j) {
                var t = arguments[0];
                return !this.isNull() && !t.isNull() && !(t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny);
            }
            if (arguments[0] instanceof C) {
                var e = arguments[0];
                return this.intersects(e.x, e.y);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            return !this.isNull() && !(n > this._maxx || n < this._minx || i > this._maxy || i < this._miny);
        }
    }, j.prototype.getMinY = function() {
        return this._miny;
    }, j.prototype.getMinX = function() {
        return this._minx;
    }, j.prototype.expandToInclude = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof C) {
                var t = arguments[0];
                this.expandToInclude(t.x, t.y);
            } else if (arguments[0] instanceof j) {
                var e = arguments[0];
                if (e.isNull()) return null;
                this.isNull() ? (this._minx = e.getMinX(), this._maxx = e.getMaxX(), this._miny = e.getMinY(), this._maxy = e.getMaxY()) : (e._minx < this._minx && (this._minx = e._minx), e._maxx > this._maxx && (this._maxx = e._maxx), e._miny < this._miny && (this._miny = e._miny), e._maxy > this._maxy && (this._maxy = e._maxy));
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            this.isNull() ? (this._minx = n, this._maxx = n, this._miny = i, this._maxy = i) : (n < this._minx && (this._minx = n), n > this._maxx && (this._maxx = n), i < this._miny && (this._miny = i), i > this._maxy && (this._maxy = i));
        }
    }, j.prototype.minExtent = function() {
        if (this.isNull()) return 0;
        var t = this.getWidth(), e = this.getHeight();
        return t < e ? t : e;
    }, j.prototype.getWidth = function() {
        return this.isNull() ? 0 : this._maxx - this._minx;
    }, j.prototype.compareTo = function(t) {
        var e = t;
        return this.isNull() ? e.isNull() ? 0 : -1 : e.isNull() ? 1 : this._minx < e._minx ? -1 : this._minx > e._minx ? 1 : this._miny < e._miny ? -1 : this._miny > e._miny ? 1 : this._maxx < e._maxx ? -1 : this._maxx > e._maxx ? 1 : this._maxy < e._maxy ? -1 : this._maxy > e._maxy ? 1 : 0;
    }, j.prototype.translate = function(t, e) {
        if (this.isNull()) return null;
        this.init(this.getMinX() + t, this.getMaxX() + t, this.getMinY() + e, this.getMaxY() + e);
    }, j.prototype.toString = function() {
        return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
    }, j.prototype.setToNull = function() {
        this._minx = 0, this._maxx = -1, this._miny = 0, this._maxy = -1;
    }, j.prototype.getHeight = function() {
        return this.isNull() ? 0 : this._maxy - this._miny;
    }, j.prototype.maxExtent = function() {
        if (this.isNull()) return 0;
        var t = this.getWidth(), e = this.getHeight();
        return t > e ? t : e;
    }, j.prototype.expandBy = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.expandBy(t, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this.isNull()) return null;
            this._minx -= e, this._maxx += e, this._miny -= n, this._maxy += n, (this._minx > this._maxx || this._miny > this._maxy) && this.setToNull();
        }
    }, j.prototype.contains = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof j) {
                var t = arguments[0];
                return this.covers(t);
            }
            if (arguments[0] instanceof C) {
                var e = arguments[0];
                return this.covers(e);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            return this.covers(n, i);
        }
    }, j.prototype.centre = function() {
        return this.isNull() ? null : new C((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
    }, j.prototype.init = function() {
        if (0 === arguments.length) this.setToNull();
        else if (1 === arguments.length) {
            if (arguments[0] instanceof C) {
                var t = arguments[0];
                this.init(t.x, t.x, t.y, t.y);
            } else if (arguments[0] instanceof j) {
                var e = arguments[0];
                this._minx = e._minx, this._maxx = e._maxx, this._miny = e._miny, this._maxy = e._maxy;
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            this.init(n.x, i.x, n.y, i.y);
        } else if (4 === arguments.length) {
            var r = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3];
            r < o ? (this._minx = r, this._maxx = o) : (this._minx = o, this._maxx = r), s < a ? (this._miny = s, this._maxy = a) : (this._miny = a, this._maxy = s);
        }
    }, j.prototype.getMaxY = function() {
        return this._maxy;
    }, j.prototype.distance = function(t) {
        if (this.intersects(t)) return 0;
        var e = 0;
        this._maxx < t._minx ? e = t._minx - this._maxx : this._minx > t._maxx && (e = this._minx - t._maxx);
        var n = 0;
        return this._maxy < t._miny ? n = t._miny - this._maxy : this._miny > t._maxy && (n = this._miny - t._maxy), 0 === e ? n : 0 === n ? e : Math.sqrt(e * e + n * n);
    }, j.prototype.hashCode = function() {
        var t = 17;
        return t = 37 * t + C.hashCode(this._minx), t = 37 * t + C.hashCode(this._maxx), t = 37 * t + C.hashCode(this._miny), t = 37 * t + C.hashCode(this._maxy);
    }, j.prototype.interfaces_ = function() {
        return [
            E,
            e
        ];
    }, j.prototype.getClass = function() {
        return j;
    }, j.intersects = function() {
        if (3 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2];
            return n.x >= (t.x < e.x ? t.x : e.x) && n.x <= (t.x > e.x ? t.x : e.x) && n.y >= (t.y < e.y ? t.y : e.y) && n.y <= (t.y > e.y ? t.y : e.y);
        }
        if (4 === arguments.length) {
            var i = arguments[0], r = arguments[1], o = arguments[2], s = arguments[3], a = Math.min(o.x, s.x), u = Math.max(o.x, s.x), l = Math.min(i.x, r.x), c = Math.max(i.x, r.x);
            return !(l > u) && !(c < a) && (a = Math.min(o.y, s.y), u = Math.max(o.y, s.y), l = Math.min(i.y, r.y), c = Math.max(i.y, r.y), !(l > u) && !(c < a));
        }
    }, H.serialVersionUID.get = function() {
        return 0x51845cd552189800;
    }, Object.defineProperties(j, H);
    var W = {
        typeStr: /^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,
        emptyTypeStr: /^\s*(\w+)\s*EMPTY\s*$/,
        spaces: /\s+/,
        parenComma: /\)\s*,\s*\(/,
        doubleParenComma: /\)\s*\)\s*,\s*\(\s*\(/,
        trimParens: /^\s*\(?(.*?)\)?\s*$/
    }, K = function(t) {
        this.geometryFactory = t || new _e;
    };
    K.prototype.read = function(t) {
        var e, n, i;
        t = t.replace(/[\n\r]/g, " ");
        var r = W.typeStr.exec(t);
        if (-1 !== t.search("EMPTY") && ((r = W.emptyTypeStr.exec(t))[2] = void 0), r && (n = r[1].toLowerCase(), i = r[2], Q[n] && (e = Q[n].apply(this, [
            i
        ]))), void 0 === e) throw new Error("Could not parse WKT " + t);
        return e;
    }, K.prototype.write = function(t) {
        return this.extractGeometry(t);
    }, K.prototype.extractGeometry = function(t) {
        var e = t.getGeometryType().toLowerCase();
        if (!J[e]) return null;
        var n = e.toUpperCase();
        return t.isEmpty() ? n + " EMPTY" : n + "(" + J[e].apply(this, [
            t
        ]) + ")";
    };
    var J = {
        coordinate: function(t) {
            return t.x + " " + t.y;
        },
        point: function(t) {
            return J.coordinate.call(this, t._coordinates._coordinates[0]);
        },
        multipoint: function(t) {
            for(var e = [], n = 0, i = t._geometries.length; n < i; ++n)e.push("(" + J.point.apply(this, [
                t._geometries[n]
            ]) + ")");
            return e.join(",");
        },
        linestring: function(t) {
            for(var e = [], n = 0, i = t._points._coordinates.length; n < i; ++n)e.push(J.coordinate.apply(this, [
                t._points._coordinates[n]
            ]));
            return e.join(",");
        },
        linearring: function(t) {
            for(var e = [], n = 0, i = t._points._coordinates.length; n < i; ++n)e.push(J.coordinate.apply(this, [
                t._points._coordinates[n]
            ]));
            return e.join(",");
        },
        multilinestring: function(t) {
            for(var e = [], n = 0, i = t._geometries.length; n < i; ++n)e.push("(" + J.linestring.apply(this, [
                t._geometries[n]
            ]) + ")");
            return e.join(",");
        },
        polygon: function(t) {
            var e = [];
            e.push("(" + J.linestring.apply(this, [
                t._shell
            ]) + ")");
            for(var n = 0, i = t._holes.length; n < i; ++n)e.push("(" + J.linestring.apply(this, [
                t._holes[n]
            ]) + ")");
            return e.join(",");
        },
        multipolygon: function(t) {
            for(var e = [], n = 0, i = t._geometries.length; n < i; ++n)e.push("(" + J.polygon.apply(this, [
                t._geometries[n]
            ]) + ")");
            return e.join(",");
        },
        geometrycollection: function(t) {
            for(var e = [], n = 0, i = t._geometries.length; n < i; ++n)e.push(this.extractGeometry(t._geometries[n]));
            return e.join(",");
        }
    }, Q = {
        point: function(t) {
            if (void 0 === t) return this.geometryFactory.createPoint();
            var e = t.trim().split(W.spaces);
            return this.geometryFactory.createPoint(new C(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
        },
        multipoint: function(t) {
            if (void 0 === t) return this.geometryFactory.createMultiPoint();
            for(var e, n = t.trim().split(","), i = [], r = 0, o = n.length; r < o; ++r)e = n[r].replace(W.trimParens, "$1"), i.push(Q.point.apply(this, [
                e
            ]));
            return this.geometryFactory.createMultiPoint(i);
        },
        linestring: function(t) {
            if (void 0 === t) return this.geometryFactory.createLineString();
            for(var e, n = t.trim().split(","), i = [], r = 0, o = n.length; r < o; ++r)e = n[r].trim().split(W.spaces), i.push(new C(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
            return this.geometryFactory.createLineString(i);
        },
        linearring: function(t) {
            if (void 0 === t) return this.geometryFactory.createLinearRing();
            for(var e, n = t.trim().split(","), i = [], r = 0, o = n.length; r < o; ++r)e = n[r].trim().split(W.spaces), i.push(new C(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
            return this.geometryFactory.createLinearRing(i);
        },
        multilinestring: function(t) {
            if (void 0 === t) return this.geometryFactory.createMultiLineString();
            for(var e, n = t.trim().split(W.parenComma), i = [], r = 0, o = n.length; r < o; ++r)e = n[r].replace(W.trimParens, "$1"), i.push(Q.linestring.apply(this, [
                e
            ]));
            return this.geometryFactory.createMultiLineString(i);
        },
        polygon: function(t) {
            if (void 0 === t) return this.geometryFactory.createPolygon();
            for(var e, n, i, r, o = t.trim().split(W.parenComma), s = [], a = 0, u = o.length; a < u; ++a)e = o[a].replace(W.trimParens, "$1"), n = Q.linestring.apply(this, [
                e
            ]), i = this.geometryFactory.createLinearRing(n._points), 0 === a ? r = i : s.push(i);
            return this.geometryFactory.createPolygon(r, s);
        },
        multipolygon: function(t) {
            if (void 0 === t) return this.geometryFactory.createMultiPolygon();
            for(var e, n = t.trim().split(W.doubleParenComma), i = [], r = 0, o = n.length; r < o; ++r)e = n[r].replace(W.trimParens, "$1"), i.push(Q.polygon.apply(this, [
                e
            ]));
            return this.geometryFactory.createMultiPolygon(i);
        },
        geometrycollection: function(t) {
            if (void 0 === t) return this.geometryFactory.createGeometryCollection();
            for(var e = (t = t.replace(/,\s*([A-Za-z])/g, "|$1")).trim().split("|"), n = [], i = 0, r = e.length; i < r; ++i)n.push(this.read(e[i]));
            return this.geometryFactory.createGeometryCollection(n);
        }
    }, Z = function(t) {
        this.parser = new K(t);
    };
    Z.prototype.write = function(t) {
        return this.parser.write(t);
    }, Z.toLineString = function(t, e) {
        if (2 !== arguments.length) throw new Error("Not implemented");
        return "LINESTRING ( " + t.x + " " + t.y + ", " + e.x + " " + e.y + " )";
    };
    var $ = function(t) {
        function e(e) {
            t.call(this, e), this.name = "RuntimeException", this.message = e, this.stack = (new t).stack;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
    }(Error), tt = function(t) {
        function e() {
            if (t.call(this), 0 === arguments.length) t.call(this);
            else if (1 === arguments.length) {
                var e = arguments[0];
                t.call(this, e);
            }
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }($), et = function() {};
    et.prototype.interfaces_ = function() {
        return [];
    }, et.prototype.getClass = function() {
        return et;
    }, et.shouldNeverReachHere = function() {
        if (0 === arguments.length) et.shouldNeverReachHere(null);
        else if (1 === arguments.length) {
            var t = arguments[0];
            throw new tt("Should never reach here" + (null !== t ? ": " + t : ""));
        }
    }, et.isTrue = function() {
        var t, e;
        if (1 === arguments.length) t = arguments[0], et.isTrue(t, null);
        else if (2 === arguments.length && (t = arguments[0], e = arguments[1], !t)) throw null === e ? new tt : new tt(e);
    }, et.equals = function() {
        var t, e, n;
        if (2 === arguments.length) t = arguments[0], e = arguments[1], et.equals(t, e, null);
        else if (3 === arguments.length && (t = arguments[0], e = arguments[1], n = arguments[2], !e.equals(t))) throw new tt("Expected " + t + " but encountered " + e + (null !== n ? ": " + n : ""));
    };
    var nt = function() {
        this._result = null, this._inputLines = Array(2).fill().map(function() {
            return Array(2);
        }), this._intPt = new Array(2).fill(null), this._intLineIndex = null, this._isProper = null, this._pa = null, this._pb = null, this._precisionModel = null, this._intPt[0] = new C, this._intPt[1] = new C, this._pa = this._intPt[0], this._pb = this._intPt[1], this._result = 0;
    }, it = {
        DONT_INTERSECT: {
            configurable: !0
        },
        DO_INTERSECT: {
            configurable: !0
        },
        COLLINEAR: {
            configurable: !0
        },
        NO_INTERSECTION: {
            configurable: !0
        },
        POINT_INTERSECTION: {
            configurable: !0
        },
        COLLINEAR_INTERSECTION: {
            configurable: !0
        }
    };
    nt.prototype.getIndexAlongSegment = function(t, e) {
        return this.computeIntLineIndex(), this._intLineIndex[t][e];
    }, nt.prototype.getTopologySummary = function() {
        var t = new D;
        return this.isEndPoint() && t.append(" endpoint"), this._isProper && t.append(" proper"), this.isCollinear() && t.append(" collinear"), t.toString();
    }, nt.prototype.computeIntersection = function(t, e, n, i) {
        this._inputLines[0][0] = t, this._inputLines[0][1] = e, this._inputLines[1][0] = n, this._inputLines[1][1] = i, this._result = this.computeIntersect(t, e, n, i);
    }, nt.prototype.getIntersectionNum = function() {
        return this._result;
    }, nt.prototype.computeIntLineIndex = function() {
        if (0 === arguments.length) null === this._intLineIndex && (this._intLineIndex = Array(2).fill().map(function() {
            return Array(2);
        }), this.computeIntLineIndex(0), this.computeIntLineIndex(1));
        else if (1 === arguments.length) {
            var t = arguments[0];
            this.getEdgeDistance(t, 0) > this.getEdgeDistance(t, 1) ? (this._intLineIndex[t][0] = 0, this._intLineIndex[t][1] = 1) : (this._intLineIndex[t][0] = 1, this._intLineIndex[t][1] = 0);
        }
    }, nt.prototype.isProper = function() {
        return this.hasIntersection() && this._isProper;
    }, nt.prototype.setPrecisionModel = function(t) {
        this._precisionModel = t;
    }, nt.prototype.isInteriorIntersection = function() {
        if (0 === arguments.length) return !!this.isInteriorIntersection(0) || !!this.isInteriorIntersection(1);
        if (1 === arguments.length) {
            for(var t = arguments[0], e = 0; e < this._result; e++)if (!this._intPt[e].equals2D(this._inputLines[t][0]) && !this._intPt[e].equals2D(this._inputLines[t][1])) return !0;
            return !1;
        }
    }, nt.prototype.getIntersection = function(t) {
        return this._intPt[t];
    }, nt.prototype.isEndPoint = function() {
        return this.hasIntersection() && !this._isProper;
    }, nt.prototype.hasIntersection = function() {
        return this._result !== nt.NO_INTERSECTION;
    }, nt.prototype.getEdgeDistance = function(t, e) {
        return nt.computeEdgeDistance(this._intPt[e], this._inputLines[t][0], this._inputLines[t][1]);
    }, nt.prototype.isCollinear = function() {
        return this._result === nt.COLLINEAR_INTERSECTION;
    }, nt.prototype.toString = function() {
        return Z.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + Z.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
    }, nt.prototype.getEndpoint = function(t, e) {
        return this._inputLines[t][e];
    }, nt.prototype.isIntersection = function(t) {
        for(var e = 0; e < this._result; e++)if (this._intPt[e].equals2D(t)) return !0;
        return !1;
    }, nt.prototype.getIntersectionAlongSegment = function(t, e) {
        return this.computeIntLineIndex(), this._intPt[this._intLineIndex[t][e]];
    }, nt.prototype.interfaces_ = function() {
        return [];
    }, nt.prototype.getClass = function() {
        return nt;
    }, nt.computeEdgeDistance = function(t, e, n) {
        var i = Math.abs(n.x - e.x), r = Math.abs(n.y - e.y), o = -1;
        if (t.equals(e)) o = 0;
        else if (t.equals(n)) o = i > r ? i : r;
        else {
            var s = Math.abs(t.x - e.x), a = Math.abs(t.y - e.y);
            0 !== (o = i > r ? s : a) || t.equals(e) || (o = Math.max(s, a));
        }
        return et.isTrue(!(0 === o && !t.equals(e)), "Bad distance calculation"), o;
    }, nt.nonRobustComputeEdgeDistance = function(t, e, n) {
        var i = t.x - e.x, r = t.y - e.y, o = Math.sqrt(i * i + r * r);
        return et.isTrue(!(0 === o && !t.equals(e)), "Invalid distance calculation"), o;
    }, it.DONT_INTERSECT.get = function() {
        return 0;
    }, it.DO_INTERSECT.get = function() {
        return 1;
    }, it.COLLINEAR.get = function() {
        return 2;
    }, it.NO_INTERSECTION.get = function() {
        return 0;
    }, it.POINT_INTERSECTION.get = function() {
        return 1;
    }, it.COLLINEAR_INTERSECTION.get = function() {
        return 2;
    }, Object.defineProperties(nt, it);
    var rt = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isInSegmentEnvelopes = function(t) {
            var e = new j(this._inputLines[0][0], this._inputLines[0][1]), n = new j(this._inputLines[1][0], this._inputLines[1][1]);
            return e.contains(t) && n.contains(t);
        }, e.prototype.computeIntersection = function() {
            if (3 !== arguments.length) return t.prototype.computeIntersection.apply(this, arguments);
            var e = arguments[0], n = arguments[1], i = arguments[2];
            if (this._isProper = !1, j.intersects(n, i, e) && 0 === at.orientationIndex(n, i, e) && 0 === at.orientationIndex(i, n, e)) return this._isProper = !0, (e.equals(n) || e.equals(i)) && (this._isProper = !1), this._result = t.POINT_INTERSECTION, null;
            this._result = t.NO_INTERSECTION;
        }, e.prototype.normalizeToMinimum = function(t, e, n, i, r) {
            r.x = this.smallestInAbsValue(t.x, e.x, n.x, i.x), r.y = this.smallestInAbsValue(t.y, e.y, n.y, i.y), t.x -= r.x, t.y -= r.y, e.x -= r.x, e.y -= r.y, n.x -= r.x, n.y -= r.y, i.x -= r.x, i.y -= r.y;
        }, e.prototype.safeHCoordinateIntersection = function(t, n, i, r) {
            var o = null;
            try {
                o = k.intersection(t, n, i, r);
            } catch (s) {
                if (!(s instanceof X)) throw s;
                o = e.nearestEndpoint(t, n, i, r);
            }
            return o;
        }, e.prototype.intersection = function(t, n, i, r) {
            var o = this.intersectionWithNormalization(t, n, i, r);
            return this.isInSegmentEnvelopes(o) || (o = new C(e.nearestEndpoint(t, n, i, r))), null !== this._precisionModel && this._precisionModel.makePrecise(o), o;
        }, e.prototype.smallestInAbsValue = function(t, e, n, i) {
            var r = t, o = Math.abs(r);
            return Math.abs(e) < o && (r = e, o = Math.abs(e)), Math.abs(n) < o && (r = n, o = Math.abs(n)), Math.abs(i) < o && (r = i), r;
        }, e.prototype.checkDD = function(t, e, n, i, r) {
            var o = q.intersection(t, e, n, i), s = this.isInSegmentEnvelopes(o);
            Y.out.println("DD in env = " + s + "  --------------------- " + o), r.distance(o) > 1e-4 && Y.out.println("Distance = " + r.distance(o));
        }, e.prototype.intersectionWithNormalization = function(t, e, n, i) {
            var r = new C(t), o = new C(e), s = new C(n), a = new C(i), u = new C;
            this.normalizeToEnvCentre(r, o, s, a, u);
            var l = this.safeHCoordinateIntersection(r, o, s, a);
            return l.x += u.x, l.y += u.y, l;
        }, e.prototype.computeCollinearIntersection = function(e, n, i, r) {
            var o = j.intersects(e, n, i), s = j.intersects(e, n, r), a = j.intersects(i, r, e), u = j.intersects(i, r, n);
            return o && s ? (this._intPt[0] = i, this._intPt[1] = r, t.COLLINEAR_INTERSECTION) : a && u ? (this._intPt[0] = e, this._intPt[1] = n, t.COLLINEAR_INTERSECTION) : o && a ? (this._intPt[0] = i, this._intPt[1] = e, !i.equals(e) || s || u ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : o && u ? (this._intPt[0] = i, this._intPt[1] = n, !i.equals(n) || s || a ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : s && a ? (this._intPt[0] = r, this._intPt[1] = e, !r.equals(e) || o || u ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : s && u ? (this._intPt[0] = r, this._intPt[1] = n, !r.equals(n) || o || a ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : t.NO_INTERSECTION;
        }, e.prototype.normalizeToEnvCentre = function(t, e, n, i, r) {
            var o = t.x < e.x ? t.x : e.x, s = t.y < e.y ? t.y : e.y, a = t.x > e.x ? t.x : e.x, u = t.y > e.y ? t.y : e.y, l = n.x < i.x ? n.x : i.x, c = n.y < i.y ? n.y : i.y, p = n.x > i.x ? n.x : i.x, h = n.y > i.y ? n.y : i.y, f = ((o > l ? o : l) + (a < p ? a : p)) / 2, g = ((s > c ? s : c) + (u < h ? u : h)) / 2;
            r.x = f, r.y = g, t.x -= r.x, t.y -= r.y, e.x -= r.x, e.y -= r.y, n.x -= r.x, n.y -= r.y, i.x -= r.x, i.y -= r.y;
        }, e.prototype.computeIntersect = function(e, n, i, r) {
            if (this._isProper = !1, !j.intersects(e, n, i, r)) return t.NO_INTERSECTION;
            var o = at.orientationIndex(e, n, i), s = at.orientationIndex(e, n, r);
            if (o > 0 && s > 0 || o < 0 && s < 0) return t.NO_INTERSECTION;
            var a = at.orientationIndex(i, r, e), u = at.orientationIndex(i, r, n);
            if (a > 0 && u > 0 || a < 0 && u < 0) return t.NO_INTERSECTION;
            return 0 === o && 0 === s && 0 === a && 0 === u ? this.computeCollinearIntersection(e, n, i, r) : (0 === o || 0 === s || 0 === a || 0 === u ? (this._isProper = !1, e.equals2D(i) || e.equals2D(r) ? this._intPt[0] = e : n.equals2D(i) || n.equals2D(r) ? this._intPt[0] = n : 0 === o ? this._intPt[0] = new C(i) : 0 === s ? this._intPt[0] = new C(r) : 0 === a ? this._intPt[0] = new C(e) : 0 === u && (this._intPt[0] = new C(n))) : (this._isProper = !0, this._intPt[0] = this.intersection(e, n, i, r)), t.POINT_INTERSECTION);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.nearestEndpoint = function(t, e, n, i) {
            var r = t, o = at.distancePointLine(t, n, i), s = at.distancePointLine(e, n, i);
            return s < o && (o = s, r = e), (s = at.distancePointLine(n, t, e)) < o && (o = s, r = n), (s = at.distancePointLine(i, t, e)) < o && (o = s, r = i), r;
        }, e;
    }(nt), ot = function() {};
    ot.prototype.interfaces_ = function() {
        return [];
    }, ot.prototype.getClass = function() {
        return ot;
    }, ot.orientationIndex = function(t, e, n) {
        var i = e.x - t.x, r = e.y - t.y, o = n.x - e.x, s = n.y - e.y;
        return ot.signOfDet2x2(i, r, o, s);
    }, ot.signOfDet2x2 = function(t, e, n, i) {
        var r = null, o = null, s = null;
        if (r = 1, 0 === t || 0 === i) return 0 === e || 0 === n ? 0 : e > 0 ? n > 0 ? -r : r : n > 0 ? r : -r;
        if (0 === e || 0 === n) return i > 0 ? t > 0 ? r : -r : t > 0 ? -r : r;
        if (e > 0 ? i > 0 ? e <= i || (r = -r, o = t, t = n, n = o, o = e, e = i, i = o) : e <= -i ? (r = -r, n = -n, i = -i) : (o = t, t = -n, n = o, o = e, e = -i, i = o) : i > 0 ? -e <= i ? (r = -r, t = -t, e = -e) : (o = -t, t = n, n = o, o = -e, e = i, i = o) : e >= i ? (t = -t, e = -e, n = -n, i = -i) : (r = -r, o = -t, t = -n, n = o, o = -e, e = -i, i = o), t > 0) {
            if (!(n > 0)) return r;
            if (!(t <= n)) return r;
        } else {
            if (n > 0) return -r;
            if (!(t >= n)) return -r;
            r = -r, t = -t, n = -n;
        }
        for(;;){
            if (s = Math.floor(n / t), n -= s * t, (i -= s * e) < 0) return -r;
            if (i > e) return r;
            if (t > n + n) {
                if (e < i + i) return r;
            } else {
                if (e > i + i) return -r;
                n = t - n, i = e - i, r = -r;
            }
            if (0 === i) return 0 === n ? 0 : -r;
            if (0 === n) return r;
            if (s = Math.floor(t / n), t -= s * n, (e -= s * i) < 0) return r;
            if (e > i) return -r;
            if (n > t + t) {
                if (i < e + e) return -r;
            } else {
                if (i > e + e) return r;
                t = n - t, e = i - e, r = -r;
            }
            if (0 === e) return 0 === t ? 0 : r;
            if (0 === t) return -r;
        }
    };
    var st = function() {
        this._p = null, this._crossingCount = 0, this._isPointOnSegment = !1;
        var t = arguments[0];
        this._p = t;
    };
    st.prototype.countSegment = function(t, e) {
        if (t.x < this._p.x && e.x < this._p.x) return null;
        if (this._p.x === e.x && this._p.y === e.y) return this._isPointOnSegment = !0, null;
        if (t.y === this._p.y && e.y === this._p.y) {
            var n = t.x, i = e.x;
            return n > i && (n = e.x, i = t.x), this._p.x >= n && this._p.x <= i && (this._isPointOnSegment = !0), null;
        }
        if (t.y > this._p.y && e.y <= this._p.y || e.y > this._p.y && t.y <= this._p.y) {
            var r = t.x - this._p.x, o = t.y - this._p.y, s = e.x - this._p.x, a = e.y - this._p.y, u = ot.signOfDet2x2(r, o, s, a);
            if (0 === u) return this._isPointOnSegment = !0, null;
            a < o && (u = -u), u > 0 && this._crossingCount++;
        }
    }, st.prototype.isPointInPolygon = function() {
        return this.getLocation() !== w.EXTERIOR;
    }, st.prototype.getLocation = function() {
        return this._isPointOnSegment ? w.BOUNDARY : this._crossingCount % 2 == 1 ? w.INTERIOR : w.EXTERIOR;
    }, st.prototype.isOnSegment = function() {
        return this._isPointOnSegment;
    }, st.prototype.interfaces_ = function() {
        return [];
    }, st.prototype.getClass = function() {
        return st;
    }, st.locatePointInRing = function() {
        if (arguments[0] instanceof C && T(arguments[1], V)) {
            for(var t = arguments[0], e = arguments[1], n = new st(t), i = new C, r = new C, o = 1; o < e.size(); o++)if (e.getCoordinate(o, i), e.getCoordinate(o - 1, r), n.countSegment(i, r), n.isOnSegment()) return n.getLocation();
            return n.getLocation();
        }
        if (arguments[0] instanceof C && arguments[1] instanceof Array) {
            for(var s = arguments[0], a = arguments[1], u = new st(s), l = 1; l < a.length; l++){
                var c = a[l], p = a[l - 1];
                if (u.countSegment(c, p), u.isOnSegment()) return u.getLocation();
            }
            return u.getLocation();
        }
    };
    var at = function() {}, ut = {
        CLOCKWISE: {
            configurable: !0
        },
        RIGHT: {
            configurable: !0
        },
        COUNTERCLOCKWISE: {
            configurable: !0
        },
        LEFT: {
            configurable: !0
        },
        COLLINEAR: {
            configurable: !0
        },
        STRAIGHT: {
            configurable: !0
        }
    };
    at.prototype.interfaces_ = function() {
        return [];
    }, at.prototype.getClass = function() {
        return at;
    }, at.orientationIndex = function(t, e, n) {
        return q.orientationIndex(t, e, n);
    }, at.signedArea = function() {
        if (arguments[0] instanceof Array) {
            var t = arguments[0];
            if (t.length < 3) return 0;
            for(var e = 0, n = t[0].x, i = 1; i < t.length - 1; i++){
                var r = t[i].x - n, o = t[i + 1].y;
                e += r * (t[i - 1].y - o);
            }
            return e / 2;
        }
        if (T(arguments[0], V)) {
            var s = arguments[0], a = s.size();
            if (a < 3) return 0;
            var u = new C, l = new C, c = new C;
            s.getCoordinate(0, l), s.getCoordinate(1, c);
            var p = l.x;
            c.x -= p;
            for(var h = 0, f = 1; f < a - 1; f++)u.y = l.y, l.x = c.x, l.y = c.y, s.getCoordinate(f + 1, c), c.x -= p, h += l.x * (u.y - c.y);
            return h / 2;
        }
    }, at.distanceLineLine = function(t, e, n, i) {
        if (t.equals(e)) return at.distancePointLine(t, n, i);
        if (n.equals(i)) return at.distancePointLine(i, t, e);
        var r = !1;
        if (j.intersects(t, e, n, i)) {
            var o = (e.x - t.x) * (i.y - n.y) - (e.y - t.y) * (i.x - n.x);
            if (0 === o) r = !0;
            else {
                var s = (t.y - n.y) * (i.x - n.x) - (t.x - n.x) * (i.y - n.y), a = ((t.y - n.y) * (e.x - t.x) - (t.x - n.x) * (e.y - t.y)) / o, u = s / o;
                (u < 0 || u > 1 || a < 0 || a > 1) && (r = !0);
            }
        } else r = !0;
        return r ? R.min(at.distancePointLine(t, n, i), at.distancePointLine(e, n, i), at.distancePointLine(n, t, e), at.distancePointLine(i, t, e)) : 0;
    }, at.isPointInRing = function(t, e) {
        return at.locatePointInRing(t, e) !== w.EXTERIOR;
    }, at.computeLength = function(t) {
        var e = t.size();
        if (e <= 1) return 0;
        var n = 0, i = new C;
        t.getCoordinate(0, i);
        for(var r = i.x, o = i.y, s = 1; s < e; s++){
            t.getCoordinate(s, i);
            var a = i.x, u = i.y, l = a - r, c = u - o;
            n += Math.sqrt(l * l + c * c), r = a, o = u;
        }
        return n;
    }, at.isCCW = function(t) {
        var e = t.length - 1;
        if (e < 3) throw new m("Ring has fewer than 4 points, so orientation cannot be determined");
        for(var n = t[0], i = 0, r = 1; r <= e; r++){
            var o = t[r];
            o.y > n.y && (n = o, i = r);
        }
        var s = i;
        do (s -= 1) < 0 && (s = e);
        while (t[s].equals2D(n) && s !== i);
        var a = i;
        do a = (a + 1) % e;
        while (t[a].equals2D(n) && a !== i);
        var u = t[s], l = t[a];
        if (u.equals2D(n) || l.equals2D(n) || u.equals2D(l)) return !1;
        var c = at.computeOrientation(u, n, l), p = !1;
        return p = 0 === c ? u.x > l.x : c > 0, p;
    }, at.locatePointInRing = function(t, e) {
        return st.locatePointInRing(t, e);
    }, at.distancePointLinePerpendicular = function(t, e, n) {
        var i = (n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y), r = ((e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y)) / i;
        return Math.abs(r) * Math.sqrt(i);
    }, at.computeOrientation = function(t, e, n) {
        return at.orientationIndex(t, e, n);
    }, at.distancePointLine = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            if (0 === e.length) throw new m("Line array must contain at least one vertex");
            for(var n = t.distance(e[0]), i = 0; i < e.length - 1; i++){
                var r = at.distancePointLine(t, e[i], e[i + 1]);
                r < n && (n = r);
            }
            return n;
        }
        if (3 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2];
            if (s.x === a.x && s.y === a.y) return o.distance(s);
            var u = (a.x - s.x) * (a.x - s.x) + (a.y - s.y) * (a.y - s.y), l = ((o.x - s.x) * (a.x - s.x) + (o.y - s.y) * (a.y - s.y)) / u;
            if (l <= 0) return o.distance(s);
            if (l >= 1) return o.distance(a);
            var c = ((s.y - o.y) * (a.x - s.x) - (s.x - o.x) * (a.y - s.y)) / u;
            return Math.abs(c) * Math.sqrt(u);
        }
    }, at.isOnLine = function(t, e) {
        for(var n = new rt, i = 1; i < e.length; i++){
            var r = e[i - 1], o = e[i];
            if (n.computeIntersection(t, r, o), n.hasIntersection()) return !0;
        }
        return !1;
    }, ut.CLOCKWISE.get = function() {
        return -1;
    }, ut.RIGHT.get = function() {
        return at.CLOCKWISE;
    }, ut.COUNTERCLOCKWISE.get = function() {
        return 1;
    }, ut.LEFT.get = function() {
        return at.COUNTERCLOCKWISE;
    }, ut.COLLINEAR.get = function() {
        return 0;
    }, ut.STRAIGHT.get = function() {
        return at.COLLINEAR;
    }, Object.defineProperties(at, ut);
    var lt = function() {};
    lt.prototype.filter = function(t) {}, lt.prototype.interfaces_ = function() {
        return [];
    }, lt.prototype.getClass = function() {
        return lt;
    };
    var ct = function() {
        var t = arguments[0];
        this._envelope = null, this._factory = null, this._SRID = null, this._userData = null, this._factory = t, this._SRID = t.getSRID();
    }, pt = {
        serialVersionUID: {
            configurable: !0
        },
        SORTINDEX_POINT: {
            configurable: !0
        },
        SORTINDEX_MULTIPOINT: {
            configurable: !0
        },
        SORTINDEX_LINESTRING: {
            configurable: !0
        },
        SORTINDEX_LINEARRING: {
            configurable: !0
        },
        SORTINDEX_MULTILINESTRING: {
            configurable: !0
        },
        SORTINDEX_POLYGON: {
            configurable: !0
        },
        SORTINDEX_MULTIPOLYGON: {
            configurable: !0
        },
        SORTINDEX_GEOMETRYCOLLECTION: {
            configurable: !0
        },
        geometryChangedFilter: {
            configurable: !0
        }
    };
    ct.prototype.isGeometryCollection = function() {
        return this.getSortIndex() === ct.SORTINDEX_GEOMETRYCOLLECTION;
    }, ct.prototype.getFactory = function() {
        return this._factory;
    }, ct.prototype.getGeometryN = function(t) {
        return this;
    }, ct.prototype.getArea = function() {
        return 0;
    }, ct.prototype.isRectangle = function() {
        return !1;
    }, ct.prototype.equals = function() {
        if (arguments[0] instanceof ct) {
            var t = arguments[0];
            return null !== t && this.equalsTopo(t);
        }
        if (arguments[0] instanceof Object) {
            var e = arguments[0];
            if (!(e instanceof ct)) return !1;
            var n = e;
            return this.equalsExact(n);
        }
    }, ct.prototype.equalsExact = function(t) {
        return this === t || this.equalsExact(t, 0);
    }, ct.prototype.geometryChanged = function() {
        this.apply(ct.geometryChangedFilter);
    }, ct.prototype.geometryChangedAction = function() {
        this._envelope = null;
    }, ct.prototype.equalsNorm = function(t) {
        return null !== t && this.norm().equalsExact(t.norm());
    }, ct.prototype.getLength = function() {
        return 0;
    }, ct.prototype.getNumGeometries = function() {
        return 1;
    }, ct.prototype.compareTo = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = t;
            return this.getSortIndex() !== e.getSortIndex() ? this.getSortIndex() - e.getSortIndex() : this.isEmpty() && e.isEmpty() ? 0 : this.isEmpty() ? -1 : e.isEmpty() ? 1 : this.compareToSameClass(t);
        }
        if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            return this.getSortIndex() !== n.getSortIndex() ? this.getSortIndex() - n.getSortIndex() : this.isEmpty() && n.isEmpty() ? 0 : this.isEmpty() ? -1 : n.isEmpty() ? 1 : this.compareToSameClass(n, i);
        }
    }, ct.prototype.getUserData = function() {
        return this._userData;
    }, ct.prototype.getSRID = function() {
        return this._SRID;
    }, ct.prototype.getEnvelope = function() {
        return this.getFactory().toGeometry(this.getEnvelopeInternal());
    }, ct.prototype.checkNotGeometryCollection = function(t) {
        if (t.getSortIndex() === ct.SORTINDEX_GEOMETRYCOLLECTION) throw new m("This method does not support GeometryCollection arguments");
    }, ct.prototype.equal = function(t, e, n) {
        return 0 === n ? t.equals(e) : t.distance(e) <= n;
    }, ct.prototype.norm = function() {
        var t = this.copy();
        return t.normalize(), t;
    }, ct.prototype.getPrecisionModel = function() {
        return this._factory.getPrecisionModel();
    }, ct.prototype.getEnvelopeInternal = function() {
        return null === this._envelope && (this._envelope = this.computeEnvelopeInternal()), new j(this._envelope);
    }, ct.prototype.setSRID = function(t) {
        this._SRID = t;
    }, ct.prototype.setUserData = function(t) {
        this._userData = t;
    }, ct.prototype.compare = function(t, e) {
        for(var n = t.iterator(), i = e.iterator(); n.hasNext() && i.hasNext();){
            var r = n.next(), o = i.next(), s = r.compareTo(o);
            if (0 !== s) return s;
        }
        return n.hasNext() ? 1 : i.hasNext() ? -1 : 0;
    }, ct.prototype.hashCode = function() {
        return this.getEnvelopeInternal().hashCode();
    }, ct.prototype.isGeometryCollectionOrDerived = function() {
        return this.getSortIndex() === ct.SORTINDEX_GEOMETRYCOLLECTION || this.getSortIndex() === ct.SORTINDEX_MULTIPOINT || this.getSortIndex() === ct.SORTINDEX_MULTILINESTRING || this.getSortIndex() === ct.SORTINDEX_MULTIPOLYGON;
    }, ct.prototype.interfaces_ = function() {
        return [
            x,
            E,
            e
        ];
    }, ct.prototype.getClass = function() {
        return ct;
    }, ct.hasNonEmptyElements = function(t) {
        for(var e = 0; e < t.length; e++)if (!t[e].isEmpty()) return !0;
        return !1;
    }, ct.hasNullElements = function(t) {
        for(var e = 0; e < t.length; e++)if (null === t[e]) return !0;
        return !1;
    }, pt.serialVersionUID.get = function() {
        return 0x799ea46522854c00;
    }, pt.SORTINDEX_POINT.get = function() {
        return 0;
    }, pt.SORTINDEX_MULTIPOINT.get = function() {
        return 1;
    }, pt.SORTINDEX_LINESTRING.get = function() {
        return 2;
    }, pt.SORTINDEX_LINEARRING.get = function() {
        return 3;
    }, pt.SORTINDEX_MULTILINESTRING.get = function() {
        return 4;
    }, pt.SORTINDEX_POLYGON.get = function() {
        return 5;
    }, pt.SORTINDEX_MULTIPOLYGON.get = function() {
        return 6;
    }, pt.SORTINDEX_GEOMETRYCOLLECTION.get = function() {
        return 7;
    }, pt.geometryChangedFilter.get = function() {
        return ht;
    }, Object.defineProperties(ct, pt);
    var ht = function() {};
    ht.interfaces_ = function() {
        return [
            lt
        ];
    }, ht.filter = function(t) {
        t.geometryChangedAction();
    };
    var ft = function() {};
    ft.prototype.filter = function(t) {}, ft.prototype.interfaces_ = function() {
        return [];
    }, ft.prototype.getClass = function() {
        return ft;
    };
    var gt = function() {}, dt = {
        Mod2BoundaryNodeRule: {
            configurable: !0
        },
        EndPointBoundaryNodeRule: {
            configurable: !0
        },
        MultiValentEndPointBoundaryNodeRule: {
            configurable: !0
        },
        MonoValentEndPointBoundaryNodeRule: {
            configurable: !0
        },
        MOD2_BOUNDARY_RULE: {
            configurable: !0
        },
        ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
        },
        MULTIVALENT_ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
        },
        MONOVALENT_ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
        },
        OGC_SFS_BOUNDARY_RULE: {
            configurable: !0
        }
    };
    gt.prototype.isInBoundary = function(t) {}, gt.prototype.interfaces_ = function() {
        return [];
    }, gt.prototype.getClass = function() {
        return gt;
    }, dt.Mod2BoundaryNodeRule.get = function() {
        return yt;
    }, dt.EndPointBoundaryNodeRule.get = function() {
        return _t;
    }, dt.MultiValentEndPointBoundaryNodeRule.get = function() {
        return mt;
    }, dt.MonoValentEndPointBoundaryNodeRule.get = function() {
        return vt;
    }, dt.MOD2_BOUNDARY_RULE.get = function() {
        return new yt;
    }, dt.ENDPOINT_BOUNDARY_RULE.get = function() {
        return new _t;
    }, dt.MULTIVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
        return new mt;
    }, dt.MONOVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
        return new vt;
    }, dt.OGC_SFS_BOUNDARY_RULE.get = function() {
        return gt.MOD2_BOUNDARY_RULE;
    }, Object.defineProperties(gt, dt);
    var yt = function() {};
    yt.prototype.isInBoundary = function(t) {
        return t % 2 == 1;
    }, yt.prototype.interfaces_ = function() {
        return [
            gt
        ];
    }, yt.prototype.getClass = function() {
        return yt;
    };
    var _t = function() {};
    _t.prototype.isInBoundary = function(t) {
        return t > 0;
    }, _t.prototype.interfaces_ = function() {
        return [
            gt
        ];
    }, _t.prototype.getClass = function() {
        return _t;
    };
    var mt = function() {};
    mt.prototype.isInBoundary = function(t) {
        return t > 1;
    }, mt.prototype.interfaces_ = function() {
        return [
            gt
        ];
    }, mt.prototype.getClass = function() {
        return mt;
    };
    var vt = function() {};
    vt.prototype.isInBoundary = function(t) {
        return 1 === t;
    }, vt.prototype.interfaces_ = function() {
        return [
            gt
        ];
    }, vt.prototype.getClass = function() {
        return vt;
    };
    var It = function() {};
    It.prototype.add = function() {}, It.prototype.addAll = function() {}, It.prototype.isEmpty = function() {}, It.prototype.iterator = function() {}, It.prototype.size = function() {}, It.prototype.toArray = function() {}, It.prototype.remove = function() {}, (n.prototype = new Error).name = "IndexOutOfBoundsException";
    var Et = function() {};
    Et.prototype.hasNext = function() {}, Et.prototype.next = function() {}, Et.prototype.remove = function() {};
    var xt = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function() {}, e.prototype.set = function() {}, e.prototype.isEmpty = function() {}, e;
    }(It);
    (i.prototype = new Error).name = "NoSuchElementException";
    var Nt = function(t) {
        function e() {
            t.call(this), this.array_ = [], arguments[0] instanceof It && this.addAll(arguments[0]);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.ensureCapacity = function() {}, e.prototype.interfaces_ = function() {
            return [
                t,
                It
            ];
        }, e.prototype.add = function(t) {
            return 1 === arguments.length ? this.array_.push(t) : this.array_.splice(arguments[0], arguments[1]), !0;
        }, e.prototype.clear = function() {
            this.array_ = [];
        }, e.prototype.addAll = function(t) {
            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
            return !0;
        }, e.prototype.set = function(t, e) {
            var n = this.array_[t];
            return this.array_[t] = e, n;
        }, e.prototype.iterator = function() {
            return new Ct(this);
        }, e.prototype.get = function(t) {
            if (t < 0 || t >= this.size()) throw new n;
            return this.array_[t];
        }, e.prototype.isEmpty = function() {
            return 0 === this.array_.length;
        }, e.prototype.size = function() {
            return this.array_.length;
        }, e.prototype.toArray = function() {
            for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
            return t;
        }, e.prototype.remove = function(t) {
            for(var e = !1, n = 0, i = this.array_.length; n < i; n++)if (this.array_[n] === t) {
                this.array_.splice(n, 1), e = !0;
                break;
            }
            return e;
        }, e;
    }(xt), Ct = function(t) {
        function e(e) {
            t.call(this), this.arrayList_ = e, this.position_ = 0;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
            if (this.position_ === this.arrayList_.size()) throw new i;
            return this.arrayList_.get(this.position_++);
        }, e.prototype.hasNext = function() {
            return this.position_ < this.arrayList_.size();
        }, e.prototype.set = function(t) {
            return this.arrayList_.set(this.position_ - 1, t);
        }, e.prototype.remove = function() {
            this.arrayList_.remove(this.arrayList_.get(this.position_));
        }, e;
    }(Et), St = function(t) {
        function e() {
            if (t.call(this), 0 === arguments.length) ;
            else if (1 === arguments.length) {
                var e = arguments[0];
                this.ensureCapacity(e.length), this.add(e, !0);
            } else if (2 === arguments.length) {
                var n = arguments[0], i = arguments[1];
                this.ensureCapacity(n.length), this.add(n, i);
            }
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            coordArrayType: {
                configurable: !0
            }
        };
        return n.coordArrayType.get = function() {
            return new Array(0).fill(null);
        }, e.prototype.getCoordinate = function(t) {
            return this.get(t);
        }, e.prototype.addAll = function() {
            if (2 === arguments.length) {
                for(var e = arguments[0], n = arguments[1], i = !1, r = e.iterator(); r.hasNext();)this.add(r.next(), n), i = !0;
                return i;
            }
            return t.prototype.addAll.apply(this, arguments);
        }, e.prototype.clone = function() {
            for(var e = t.prototype.clone.call(this), n = 0; n < this.size(); n++)e.add(n, this.get(n).copy());
            return e;
        }, e.prototype.toCoordinateArray = function() {
            return this.toArray(e.coordArrayType);
        }, e.prototype.add = function() {
            if (1 === arguments.length) {
                var e = arguments[0];
                t.prototype.add.call(this, e);
            } else if (2 === arguments.length) {
                if (arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                    var n = arguments[0], i = arguments[1];
                    return this.add(n, i, !0), !0;
                }
                if (arguments[0] instanceof C && "boolean" == typeof arguments[1]) {
                    var r = arguments[0];
                    if (!arguments[1] && this.size() >= 1) {
                        if (this.get(this.size() - 1).equals2D(r)) return null;
                    }
                    t.prototype.add.call(this, r);
                } else if (arguments[0] instanceof Object && "boolean" == typeof arguments[1]) {
                    var o = arguments[0], s = arguments[1];
                    return this.add(o, s), !0;
                }
            } else if (3 === arguments.length) {
                if ("boolean" == typeof arguments[2] && arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                    var a = arguments[0], u = arguments[1];
                    if (arguments[2]) for(var l = 0; l < a.length; l++)this.add(a[l], u);
                    else for(var c = a.length - 1; c >= 0; c--)this.add(a[c], u);
                    return !0;
                }
                if ("boolean" == typeof arguments[2] && Number.isInteger(arguments[0]) && arguments[1] instanceof C) {
                    var p = arguments[0], h = arguments[1];
                    if (!arguments[2]) {
                        var f = this.size();
                        if (f > 0) {
                            if (p > 0) {
                                if (this.get(p - 1).equals2D(h)) return null;
                            }
                            if (p < f) {
                                if (this.get(p).equals2D(h)) return null;
                            }
                        }
                    }
                    t.prototype.add.call(this, p, h);
                }
            } else if (4 === arguments.length) {
                var g = arguments[0], d = arguments[1], y = arguments[2], _ = arguments[3], m = 1;
                y > _ && (m = -1);
                for(var v = y; v !== _; v += m)this.add(g[v], d);
                return !0;
            }
        }, e.prototype.closeRing = function() {
            this.size() > 0 && this.add(new C(this.get(0)), !1);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, Object.defineProperties(e, n), e;
    }(Nt), Lt = function() {}, bt = {
        ForwardComparator: {
            configurable: !0
        },
        BidirectionalComparator: {
            configurable: !0
        },
        coordArrayType: {
            configurable: !0
        }
    };
    bt.ForwardComparator.get = function() {
        return wt;
    }, bt.BidirectionalComparator.get = function() {
        return Ot;
    }, bt.coordArrayType.get = function() {
        return new Array(0).fill(null);
    }, Lt.prototype.interfaces_ = function() {
        return [];
    }, Lt.prototype.getClass = function() {
        return Lt;
    }, Lt.isRing = function(t) {
        return !(t.length < 4) && !!t[0].equals2D(t[t.length - 1]);
    }, Lt.ptNotInList = function(t, e) {
        for(var n = 0; n < t.length; n++){
            var i = t[n];
            if (Lt.indexOf(i, e) < 0) return i;
        }
        return null;
    }, Lt.scroll = function(t, e) {
        var n = Lt.indexOf(e, t);
        if (n < 0) return null;
        var i = new Array(t.length).fill(null);
        Y.arraycopy(t, n, i, 0, t.length - n), Y.arraycopy(t, 0, i, t.length - n, n), Y.arraycopy(i, 0, t, 0, t.length);
    }, Lt.equals = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            if (t === e) return !0;
            if (null === t || null === e) return !1;
            if (t.length !== e.length) return !1;
            for(var n = 0; n < t.length; n++)if (!t[n].equals(e[n])) return !1;
            return !0;
        }
        if (3 === arguments.length) {
            var i = arguments[0], r = arguments[1], o = arguments[2];
            if (i === r) return !0;
            if (null === i || null === r) return !1;
            if (i.length !== r.length) return !1;
            for(var s = 0; s < i.length; s++)if (0 !== o.compare(i[s], r[s])) return !1;
            return !0;
        }
    }, Lt.intersection = function(t, e) {
        for(var n = new St, i = 0; i < t.length; i++)e.intersects(t[i]) && n.add(t[i], !0);
        return n.toCoordinateArray();
    }, Lt.hasRepeatedPoints = function(t) {
        for(var e = 1; e < t.length; e++)if (t[e - 1].equals(t[e])) return !0;
        return !1;
    }, Lt.removeRepeatedPoints = function(t) {
        if (!Lt.hasRepeatedPoints(t)) return t;
        return new St(t, !1).toCoordinateArray();
    }, Lt.reverse = function(t) {
        for(var e = t.length - 1, n = Math.trunc(e / 2), i = 0; i <= n; i++){
            var r = t[i];
            t[i] = t[e - i], t[e - i] = r;
        }
    }, Lt.removeNull = function(t) {
        for(var e = 0, n = 0; n < t.length; n++)null !== t[n] && e++;
        var i = new Array(e).fill(null);
        if (0 === e) return i;
        for(var r = 0, o = 0; o < t.length; o++)null !== t[o] && (i[r++] = t[o]);
        return i;
    }, Lt.copyDeep = function() {
        if (1 === arguments.length) {
            for(var t = arguments[0], e = new Array(t.length).fill(null), n = 0; n < t.length; n++)e[n] = new C(t[n]);
            return e;
        }
        if (5 === arguments.length) for(var i = arguments[0], r = arguments[1], o = arguments[2], s = arguments[3], a = arguments[4], u = 0; u < a; u++)o[s + u] = new C(i[r + u]);
    }, Lt.isEqualReversed = function(t, e) {
        for(var n = 0; n < t.length; n++){
            var i = t[n], r = e[t.length - n - 1];
            if (0 !== i.compareTo(r)) return !1;
        }
        return !0;
    }, Lt.envelope = function(t) {
        for(var e = new j, n = 0; n < t.length; n++)e.expandToInclude(t[n]);
        return e;
    }, Lt.toCoordinateArray = function(t) {
        return t.toArray(Lt.coordArrayType);
    }, Lt.atLeastNCoordinatesOrNothing = function(t, e) {
        return e.length >= t ? e : [];
    }, Lt.indexOf = function(t, e) {
        for(var n = 0; n < e.length; n++)if (t.equals(e[n])) return n;
        return -1;
    }, Lt.increasingDirection = function(t) {
        for(var e = 0; e < Math.trunc(t.length / 2); e++){
            var n = t.length - 1 - e, i = t[e].compareTo(t[n]);
            if (0 !== i) return i;
        }
        return 1;
    }, Lt.compare = function(t, e) {
        for(var n = 0; n < t.length && n < e.length;){
            var i = t[n].compareTo(e[n]);
            if (0 !== i) return i;
            n++;
        }
        return n < e.length ? -1 : n < t.length ? 1 : 0;
    }, Lt.minCoordinate = function(t) {
        for(var e = null, n = 0; n < t.length; n++)(null === e || e.compareTo(t[n]) > 0) && (e = t[n]);
        return e;
    }, Lt.extract = function(t, e, n) {
        e = R.clamp(e, 0, t.length);
        var i = (n = R.clamp(n, -1, t.length)) - e + 1;
        n < 0 && (i = 0), e >= t.length && (i = 0), n < e && (i = 0);
        var r = new Array(i).fill(null);
        if (0 === i) return r;
        for(var o = 0, s = e; s <= n; s++)r[o++] = t[s];
        return r;
    }, Object.defineProperties(Lt, bt);
    var wt = function() {};
    wt.prototype.compare = function(t, e) {
        return Lt.compare(t, e);
    }, wt.prototype.interfaces_ = function() {
        return [
            N
        ];
    }, wt.prototype.getClass = function() {
        return wt;
    };
    var Ot = function() {};
    Ot.prototype.compare = function(t, e) {
        var n = t, i = e;
        if (n.length < i.length) return -1;
        if (n.length > i.length) return 1;
        if (0 === n.length) return 0;
        var r = Lt.compare(n, i);
        return Lt.isEqualReversed(n, i) ? 0 : r;
    }, Ot.prototype.OLDcompare = function(t, e) {
        var n = t, i = e;
        if (n.length < i.length) return -1;
        if (n.length > i.length) return 1;
        if (0 === n.length) return 0;
        for(var r = Lt.increasingDirection(n), o = Lt.increasingDirection(i), s = r > 0 ? 0 : n.length - 1, a = o > 0 ? 0 : n.length - 1, u = 0; u < n.length; u++){
            var l = n[s].compareTo(i[a]);
            if (0 !== l) return l;
            s += r, a += o;
        }
        return 0;
    }, Ot.prototype.interfaces_ = function() {
        return [
            N
        ];
    }, Ot.prototype.getClass = function() {
        return Ot;
    };
    var Tt = function() {};
    Tt.prototype.get = function() {}, Tt.prototype.put = function() {}, Tt.prototype.size = function() {}, Tt.prototype.values = function() {}, Tt.prototype.entrySet = function() {};
    var Rt = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
    }(Tt);
    (r.prototype = new Error).name = "OperationNotSupported", (o.prototype = new It).contains = function() {};
    var Pt = function(t) {
        function e() {
            t.call(this), this.array_ = [], arguments[0] instanceof It && this.addAll(arguments[0]);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.contains = function(t) {
            for(var e = 0, n = this.array_.length; e < n; e++){
                if (this.array_[e] === t) return !0;
            }
            return !1;
        }, e.prototype.add = function(t) {
            return !this.contains(t) && (this.array_.push(t), !0);
        }, e.prototype.addAll = function(t) {
            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
            return !0;
        }, e.prototype.remove = function(t) {
            throw new Error;
        }, e.prototype.size = function() {
            return this.array_.length;
        }, e.prototype.isEmpty = function() {
            return 0 === this.array_.length;
        }, e.prototype.toArray = function() {
            for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
            return t;
        }, e.prototype.iterator = function() {
            return new Dt(this);
        }, e;
    }(o), Dt = function(t) {
        function e(e) {
            t.call(this), this.hashSet_ = e, this.position_ = 0;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
            if (this.position_ === this.hashSet_.size()) throw new i;
            return this.hashSet_.array_[this.position_++];
        }, e.prototype.hasNext = function() {
            return this.position_ < this.hashSet_.size();
        }, e.prototype.remove = function() {
            throw new r;
        }, e;
    }(Et), Mt = 0;
    (p.prototype = new Rt).get = function(t) {
        for(var e = this.root_; null !== e;){
            var n = t.compareTo(e.key);
            if (n < 0) e = e.left;
            else {
                if (!(n > 0)) return e.value;
                e = e.right;
            }
        }
        return null;
    }, p.prototype.put = function(t, e) {
        if (null === this.root_) return this.root_ = {
            key: t,
            value: e,
            left: null,
            right: null,
            parent: null,
            color: Mt,
            getValue: function() {
                return this.value;
            },
            getKey: function() {
                return this.key;
            }
        }, this.size_ = 1, null;
        var n, i, r = this.root_;
        do if (n = r, (i = t.compareTo(r.key)) < 0) r = r.left;
        else {
            if (!(i > 0)) {
                var o = r.value;
                return r.value = e, o;
            }
            r = r.right;
        }
        while (null !== r);
        var s = {
            key: t,
            left: null,
            right: null,
            value: e,
            parent: n,
            color: Mt,
            getValue: function() {
                return this.value;
            },
            getKey: function() {
                return this.key;
            }
        };
        return i < 0 ? n.left = s : n.right = s, this.fixAfterInsertion(s), this.size_++, null;
    }, p.prototype.fixAfterInsertion = function(t) {
        for(t.color = 1; null != t && t !== this.root_ && 1 === t.parent.color;)if (a(t) === l(a(a(t)))) {
            var e = c(a(a(t)));
            1 === s(e) ? (u(a(t), Mt), u(e, Mt), u(a(a(t)), 1), t = a(a(t))) : (t === c(a(t)) && (t = a(t), this.rotateLeft(t)), u(a(t), Mt), u(a(a(t)), 1), this.rotateRight(a(a(t))));
        } else {
            var n = l(a(a(t)));
            1 === s(n) ? (u(a(t), Mt), u(n, Mt), u(a(a(t)), 1), t = a(a(t))) : (t === l(a(t)) && (t = a(t), this.rotateRight(t)), u(a(t), Mt), u(a(a(t)), 1), this.rotateLeft(a(a(t))));
        }
        this.root_.color = Mt;
    }, p.prototype.values = function() {
        var t = new Nt, e = this.getFirstEntry();
        if (null !== e) for(t.add(e.value); null !== (e = p.successor(e));)t.add(e.value);
        return t;
    }, p.prototype.entrySet = function() {
        var t = new Pt, e = this.getFirstEntry();
        if (null !== e) for(t.add(e); null !== (e = p.successor(e));)t.add(e);
        return t;
    }, p.prototype.rotateLeft = function(t) {
        if (null != t) {
            var e = t.right;
            t.right = e.left, null != e.left && (e.left.parent = t), e.parent = t.parent, null === t.parent ? this.root_ = e : t.parent.left === t ? t.parent.left = e : t.parent.right = e, e.left = t, t.parent = e;
        }
    }, p.prototype.rotateRight = function(t) {
        if (null != t) {
            var e = t.left;
            t.left = e.right, null != e.right && (e.right.parent = t), e.parent = t.parent, null === t.parent ? this.root_ = e : t.parent.right === t ? t.parent.right = e : t.parent.left = e, e.right = t, t.parent = e;
        }
    }, p.prototype.getFirstEntry = function() {
        var t = this.root_;
        if (null != t) for(; null != t.left;)t = t.left;
        return t;
    }, p.successor = function(t) {
        if (null === t) return null;
        if (null !== t.right) {
            for(var e = t.right; null !== e.left;)e = e.left;
            return e;
        }
        for(var n = t.parent, i = t; null !== n && i === n.right;)i = n, n = n.parent;
        return n;
    }, p.prototype.size = function() {
        return this.size_;
    };
    var At = function() {};
    At.prototype.interfaces_ = function() {
        return [];
    }, At.prototype.getClass = function() {
        return At;
    }, h.prototype = new o, (f.prototype = new h).contains = function(t) {
        for(var e = 0, n = this.array_.length; e < n; e++){
            if (0 === this.array_[e].compareTo(t)) return !0;
        }
        return !1;
    }, f.prototype.add = function(t) {
        if (this.contains(t)) return !1;
        for(var e = 0, n = this.array_.length; e < n; e++){
            if (1 === this.array_[e].compareTo(t)) return this.array_.splice(e, 0, t), !0;
        }
        return this.array_.push(t), !0;
    }, f.prototype.addAll = function(t) {
        for(var e = t.iterator(); e.hasNext();)this.add(e.next());
        return !0;
    }, f.prototype.remove = function(t) {
        throw new r;
    }, f.prototype.size = function() {
        return this.array_.length;
    }, f.prototype.isEmpty = function() {
        return 0 === this.array_.length;
    }, f.prototype.toArray = function() {
        for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
        return t;
    }, f.prototype.iterator = function() {
        return new Ft(this);
    };
    var Ft = function(t) {
        this.treeSet_ = t, this.position_ = 0;
    };
    Ft.prototype.next = function() {
        if (this.position_ === this.treeSet_.size()) throw new i;
        return this.treeSet_.array_[this.position_++];
    }, Ft.prototype.hasNext = function() {
        return this.position_ < this.treeSet_.size();
    }, Ft.prototype.remove = function() {
        throw new r;
    };
    var Gt = function() {};
    Gt.sort = function() {
        var t, e, n, i, r = arguments[0];
        if (1 === arguments.length) i = function(t, e) {
            return t.compareTo(e);
        }, r.sort(i);
        else if (2 === arguments.length) n = arguments[1], i = function(t, e) {
            return n.compare(t, e);
        }, r.sort(i);
        else if (3 === arguments.length) {
            (e = r.slice(arguments[1], arguments[2])).sort();
            var o = r.slice(0, arguments[1]).concat(e, r.slice(arguments[2], r.length));
            for(r.splice(0, r.length), t = 0; t < o.length; t++)r.push(o[t]);
        } else if (4 === arguments.length) for(e = r.slice(arguments[1], arguments[2]), n = arguments[3], i = function(t, e) {
            return n.compare(t, e);
        }, e.sort(i), o = r.slice(0, arguments[1]).concat(e, r.slice(arguments[2], r.length)), r.splice(0, r.length), t = 0; t < o.length; t++)r.push(o[t]);
    }, Gt.asList = function(t) {
        for(var e = new Nt, n = 0, i = t.length; n < i; n++)e.add(t[n]);
        return e;
    };
    var qt = function() {}, Bt = {
        P: {
            configurable: !0
        },
        L: {
            configurable: !0
        },
        A: {
            configurable: !0
        },
        FALSE: {
            configurable: !0
        },
        TRUE: {
            configurable: !0
        },
        DONTCARE: {
            configurable: !0
        },
        SYM_FALSE: {
            configurable: !0
        },
        SYM_TRUE: {
            configurable: !0
        },
        SYM_DONTCARE: {
            configurable: !0
        },
        SYM_P: {
            configurable: !0
        },
        SYM_L: {
            configurable: !0
        },
        SYM_A: {
            configurable: !0
        }
    };
    Bt.P.get = function() {
        return 0;
    }, Bt.L.get = function() {
        return 1;
    }, Bt.A.get = function() {
        return 2;
    }, Bt.FALSE.get = function() {
        return -1;
    }, Bt.TRUE.get = function() {
        return -2;
    }, Bt.DONTCARE.get = function() {
        return -3;
    }, Bt.SYM_FALSE.get = function() {
        return "F";
    }, Bt.SYM_TRUE.get = function() {
        return "T";
    }, Bt.SYM_DONTCARE.get = function() {
        return "*";
    }, Bt.SYM_P.get = function() {
        return "0";
    }, Bt.SYM_L.get = function() {
        return "1";
    }, Bt.SYM_A.get = function() {
        return "2";
    }, qt.prototype.interfaces_ = function() {
        return [];
    }, qt.prototype.getClass = function() {
        return qt;
    }, qt.toDimensionSymbol = function(t) {
        switch(t){
            case qt.FALSE:
                return qt.SYM_FALSE;
            case qt.TRUE:
                return qt.SYM_TRUE;
            case qt.DONTCARE:
                return qt.SYM_DONTCARE;
            case qt.P:
                return qt.SYM_P;
            case qt.L:
                return qt.SYM_L;
            case qt.A:
                return qt.SYM_A;
        }
        throw new m("Unknown dimension value: " + t);
    }, qt.toDimensionValue = function(t) {
        switch(A.toUpperCase(t)){
            case qt.SYM_FALSE:
                return qt.FALSE;
            case qt.SYM_TRUE:
                return qt.TRUE;
            case qt.SYM_DONTCARE:
                return qt.DONTCARE;
            case qt.SYM_P:
                return qt.P;
            case qt.SYM_L:
                return qt.L;
            case qt.SYM_A:
                return qt.A;
        }
        throw new m("Unknown dimension symbol: " + t);
    }, Object.defineProperties(qt, Bt);
    var Vt = function() {};
    Vt.prototype.filter = function(t) {}, Vt.prototype.interfaces_ = function() {
        return [];
    }, Vt.prototype.getClass = function() {
        return Vt;
    };
    var Ut = function() {};
    Ut.prototype.filter = function(t, e) {}, Ut.prototype.isDone = function() {}, Ut.prototype.isGeometryChanged = function() {}, Ut.prototype.interfaces_ = function() {
        return [];
    }, Ut.prototype.getClass = function() {
        return Ut;
    };
    var zt = function(t) {
        function e(e, n) {
            if (t.call(this, n), this._geometries = e || [], t.hasNullElements(this._geometries)) throw new m("geometries must not contain null elements");
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            for(var t = new j, e = 0; e < this._geometries.length; e++)t.expandToInclude(this._geometries[e].getEnvelopeInternal());
            return t;
        }, e.prototype.getGeometryN = function(t) {
            return this._geometries[t];
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_GEOMETRYCOLLECTION;
        }, e.prototype.getCoordinates = function() {
            for(var t = new Array(this.getNumPoints()).fill(null), e = -1, n = 0; n < this._geometries.length; n++)for(var i = this._geometries[n].getCoordinates(), r = 0; r < i.length; r++)t[++e] = i[r];
            return t;
        }, e.prototype.getArea = function() {
            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getArea();
            return t;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                if (!this.isEquivalentClass(e)) return !1;
                var i = e;
                if (this._geometries.length !== i._geometries.length) return !1;
                for(var r = 0; r < this._geometries.length; r++)if (!this._geometries[r].equalsExact(i._geometries[r], n)) return !1;
                return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {
            for(var t = 0; t < this._geometries.length; t++)this._geometries[t].normalize();
            Gt.sort(this._geometries);
        }, e.prototype.getCoordinate = function() {
            return this.isEmpty() ? null : this._geometries[0].getCoordinate();
        }, e.prototype.getBoundaryDimension = function() {
            for(var t = qt.FALSE, e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getBoundaryDimension());
            return t;
        }, e.prototype.getDimension = function() {
            for(var t = qt.FALSE, e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getDimension());
            return t;
        }, e.prototype.getLength = function() {
            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getLength();
            return t;
        }, e.prototype.getNumPoints = function() {
            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getNumPoints();
            return t;
        }, e.prototype.getNumGeometries = function() {
            return this._geometries.length;
        }, e.prototype.reverse = function() {
            for(var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++)e[n] = this._geometries[n].reverse();
            return this.getFactory().createGeometryCollection(e);
        }, e.prototype.compareToSameClass = function() {
            if (1 === arguments.length) {
                var t = arguments[0], e = new f(Gt.asList(this._geometries)), n = new f(Gt.asList(t._geometries));
                return this.compare(e, n);
            }
            if (2 === arguments.length) {
                for(var i = arguments[0], r = arguments[1], o = i, s = this.getNumGeometries(), a = o.getNumGeometries(), u = 0; u < s && u < a;){
                    var l = this.getGeometryN(u), c = o.getGeometryN(u), p = l.compareToSameClass(c, r);
                    if (0 !== p) return p;
                    u++;
                }
                return u < s ? 1 : u < a ? -1 : 0;
            }
        }, e.prototype.apply = function() {
            if (T(arguments[0], ft)) for(var t = arguments[0], e = 0; e < this._geometries.length; e++)this._geometries[e].apply(t);
            else if (T(arguments[0], Ut)) {
                var n = arguments[0];
                if (0 === this._geometries.length) return null;
                for(var i = 0; i < this._geometries.length && (this._geometries[i].apply(n), !n.isDone()); i++);
                n.isGeometryChanged() && this.geometryChanged();
            } else if (T(arguments[0], Vt)) {
                var r = arguments[0];
                r.filter(this);
                for(var o = 0; o < this._geometries.length; o++)this._geometries[o].apply(r);
            } else if (T(arguments[0], lt)) {
                var s = arguments[0];
                s.filter(this);
                for(var a = 0; a < this._geometries.length; a++)this._geometries[a].apply(s);
            }
        }, e.prototype.getBoundary = function() {
            return this.checkNotGeometryCollection(this), et.shouldNeverReachHere(), null;
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            e._geometries = new Array(this._geometries.length).fill(null);
            for(var n = 0; n < this._geometries.length; n++)e._geometries[n] = this._geometries[n].clone();
            return e;
        }, e.prototype.getGeometryType = function() {
            return "GeometryCollection";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.isEmpty = function() {
            for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isEmpty()) return !1;
            return !0;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -5694727726395021000;
        }, Object.defineProperties(e, n), e;
    }(ct), Xt = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return ct.SORTINDEX_MULTILINESTRING;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.getBoundaryDimension = function() {
            return this.isClosed() ? qt.FALSE : 0;
        }, e.prototype.isClosed = function() {
            if (this.isEmpty()) return !1;
            for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isClosed()) return !1;
            return !0;
        }, e.prototype.getDimension = function() {
            return 1;
        }, e.prototype.reverse = function() {
            for(var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++)e[t - 1 - n] = this._geometries[n].reverse();
            return this.getFactory().createMultiLineString(e);
        }, e.prototype.getBoundary = function() {
            return new Yt(this).getBoundary();
        }, e.prototype.getGeometryType = function() {
            return "MultiLineString";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.interfaces_ = function() {
            return [
                At
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return 0x7155d2ab4afa8000;
        }, Object.defineProperties(e, n), e;
    }(zt), Yt = function() {
        if (this._geom = null, this._geomFact = null, this._bnRule = null, this._endpointMap = null, 1 === arguments.length) {
            var t = arguments[0], e = gt.MOD2_BOUNDARY_RULE;
            this._geom = t, this._geomFact = t.getFactory(), this._bnRule = e;
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            this._geom = n, this._geomFact = n.getFactory(), this._bnRule = i;
        }
    };
    Yt.prototype.boundaryMultiLineString = function(t) {
        if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
        var e = this.computeBoundaryCoordinates(t);
        return 1 === e.length ? this._geomFact.createPoint(e[0]) : this._geomFact.createMultiPointFromCoords(e);
    }, Yt.prototype.getBoundary = function() {
        return this._geom instanceof Kt ? this.boundaryLineString(this._geom) : this._geom instanceof Xt ? this.boundaryMultiLineString(this._geom) : this._geom.getBoundary();
    }, Yt.prototype.boundaryLineString = function(t) {
        if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
        if (t.isClosed()) return this._bnRule.isInBoundary(2) ? t.getStartPoint() : this._geomFact.createMultiPoint();
        return this._geomFact.createMultiPoint([
            t.getStartPoint(),
            t.getEndPoint()
        ]);
    }, Yt.prototype.getEmptyMultiPoint = function() {
        return this._geomFact.createMultiPoint();
    }, Yt.prototype.computeBoundaryCoordinates = function(t) {
        var e = new Nt;
        this._endpointMap = new p;
        for(var n = 0; n < t.getNumGeometries(); n++){
            var i = t.getGeometryN(n);
            0 !== i.getNumPoints() && (this.addEndpoint(i.getCoordinateN(0)), this.addEndpoint(i.getCoordinateN(i.getNumPoints() - 1)));
        }
        for(var r = this._endpointMap.entrySet().iterator(); r.hasNext();){
            var o = r.next(), s = o.getValue().count;
            this._bnRule.isInBoundary(s) && e.add(o.getKey());
        }
        return Lt.toCoordinateArray(e);
    }, Yt.prototype.addEndpoint = function(t) {
        var e = this._endpointMap.get(t);
        null === e && (e = new kt, this._endpointMap.put(t, e)), e.count++;
    }, Yt.prototype.interfaces_ = function() {
        return [];
    }, Yt.prototype.getClass = function() {
        return Yt;
    }, Yt.getBoundary = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return new Yt(t).getBoundary();
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return new Yt(e, n).getBoundary();
        }
    };
    var kt = function() {
        this.count = null;
    };
    kt.prototype.interfaces_ = function() {
        return [];
    }, kt.prototype.getClass = function() {
        return kt;
    };
    var jt = function() {}, Ht = {
        NEWLINE: {
            configurable: !0
        },
        SIMPLE_ORDINATE_FORMAT: {
            configurable: !0
        }
    };
    jt.prototype.interfaces_ = function() {
        return [];
    }, jt.prototype.getClass = function() {
        return jt;
    }, jt.chars = function(t, e) {
        for(var n = new Array(e).fill(null), i = 0; i < e; i++)n[i] = t;
        return String(n);
    }, jt.getStackTrace = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = new function() {}, n = new function() {}(e);
            return t.printStackTrace(n), e.toString();
        }
        if (2 === arguments.length) {
            for(var i = arguments[0], r = arguments[1], o = "", s = new function() {}(new function() {}(jt.getStackTrace(i))), a = 0; a < r; a++)try {
                o += s.readLine() + jt.NEWLINE;
            } catch (t) {
                if (!(t instanceof g)) throw t;
                et.shouldNeverReachHere();
            }
            return o;
        }
    }, jt.split = function(t, e) {
        for(var n = e.length, i = new Nt, r = "" + t, o = r.indexOf(e); o >= 0;){
            var s = r.substring(0, o);
            i.add(s), o = (r = r.substring(o + n)).indexOf(e);
        }
        r.length > 0 && i.add(r);
        for(var a = new Array(i.size()).fill(null), u = 0; u < a.length; u++)a[u] = i.get(u);
        return a;
    }, jt.toString = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return jt.SIMPLE_ORDINATE_FORMAT.format(t);
        }
    }, jt.spaces = function(t) {
        return jt.chars(" ", t);
    }, Ht.NEWLINE.get = function() {
        return Y.getProperty("line.separator");
    }, Ht.SIMPLE_ORDINATE_FORMAT.get = function() {
        return new function() {}("0.#");
    }, Object.defineProperties(jt, Ht);
    var Wt = function() {};
    Wt.prototype.interfaces_ = function() {
        return [];
    }, Wt.prototype.getClass = function() {
        return Wt;
    }, Wt.copyCoord = function(t, e, n, i) {
        for(var r = Math.min(t.getDimension(), n.getDimension()), o = 0; o < r; o++)n.setOrdinate(i, o, t.getOrdinate(e, o));
    }, Wt.isRing = function(t) {
        var e = t.size();
        return 0 === e || !(e <= 3) && t.getOrdinate(0, V.X) === t.getOrdinate(e - 1, V.X) && t.getOrdinate(0, V.Y) === t.getOrdinate(e - 1, V.Y);
    }, Wt.isEqual = function(t, e) {
        var n = t.size();
        if (n !== e.size()) return !1;
        for(var i = Math.min(t.getDimension(), e.getDimension()), r = 0; r < n; r++)for(var o = 0; o < i; o++){
            var s = t.getOrdinate(r, o), a = e.getOrdinate(r, o);
            if (t.getOrdinate(r, o) !== e.getOrdinate(r, o) && (!v.isNaN(s) || !v.isNaN(a))) return !1;
        }
        return !0;
    }, Wt.extend = function(t, e, n) {
        var i = t.create(n, e.getDimension()), r = e.size();
        if (Wt.copy(e, 0, i, 0, r), r > 0) for(var o = r; o < n; o++)Wt.copy(e, r - 1, i, o, 1);
        return i;
    }, Wt.reverse = function(t) {
        for(var e = t.size() - 1, n = Math.trunc(e / 2), i = 0; i <= n; i++)Wt.swap(t, i, e - i);
    }, Wt.swap = function(t, e, n) {
        if (e === n) return null;
        for(var i = 0; i < t.getDimension(); i++){
            var r = t.getOrdinate(e, i);
            t.setOrdinate(e, i, t.getOrdinate(n, i)), t.setOrdinate(n, i, r);
        }
    }, Wt.copy = function(t, e, n, i, r) {
        for(var o = 0; o < r; o++)Wt.copyCoord(t, e + o, n, i + o);
    }, Wt.toString = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = t.size();
            if (0 === e) return "()";
            var n = t.getDimension(), i = new D;
            i.append("(");
            for(var r = 0; r < e; r++){
                r > 0 && i.append(" ");
                for(var o = 0; o < n; o++)o > 0 && i.append(","), i.append(jt.toString(t.getOrdinate(r, o)));
            }
            return i.append(")"), i.toString();
        }
    }, Wt.ensureValidRing = function(t, e) {
        var n = e.size();
        if (0 === n) return e;
        if (n <= 3) return Wt.createClosedRing(t, e, 4);
        return e.getOrdinate(0, V.X) === e.getOrdinate(n - 1, V.X) && e.getOrdinate(0, V.Y) === e.getOrdinate(n - 1, V.Y) ? e : Wt.createClosedRing(t, e, n + 1);
    }, Wt.createClosedRing = function(t, e, n) {
        var i = t.create(n, e.getDimension()), r = e.size();
        Wt.copy(e, 0, i, 0, r);
        for(var o = r; o < n; o++)Wt.copy(e, 0, i, o, 1);
        return i;
    };
    var Kt = function(t) {
        function e(e, n) {
            t.call(this, n), this._points = null, this.init(e);
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            return this.isEmpty() ? new j : this._points.expandEnvelope(new j);
        }, e.prototype.isRing = function() {
            return this.isClosed() && this.isSimple();
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_LINESTRING;
        }, e.prototype.getCoordinates = function() {
            return this._points.toCoordinateArray();
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                if (!this.isEquivalentClass(e)) return !1;
                var i = e;
                if (this._points.size() !== i._points.size()) return !1;
                for(var r = 0; r < this._points.size(); r++)if (!this.equal(this._points.getCoordinate(r), i._points.getCoordinate(r), n)) return !1;
                return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {
            for(var t = 0; t < Math.trunc(this._points.size() / 2); t++){
                var e = this._points.size() - 1 - t;
                if (!this._points.getCoordinate(t).equals(this._points.getCoordinate(e))) return this._points.getCoordinate(t).compareTo(this._points.getCoordinate(e)) > 0 && Wt.reverse(this._points), null;
            }
        }, e.prototype.getCoordinate = function() {
            return this.isEmpty() ? null : this._points.getCoordinate(0);
        }, e.prototype.getBoundaryDimension = function() {
            return this.isClosed() ? qt.FALSE : 0;
        }, e.prototype.isClosed = function() {
            return !this.isEmpty() && this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
        }, e.prototype.getEndPoint = function() {
            return this.isEmpty() ? null : this.getPointN(this.getNumPoints() - 1);
        }, e.prototype.getDimension = function() {
            return 1;
        }, e.prototype.getLength = function() {
            return at.computeLength(this._points);
        }, e.prototype.getNumPoints = function() {
            return this._points.size();
        }, e.prototype.reverse = function() {
            var t = this._points.copy();
            Wt.reverse(t);
            return this.getFactory().createLineString(t);
        }, e.prototype.compareToSameClass = function() {
            if (1 === arguments.length) {
                for(var t = arguments[0], e = 0, n = 0; e < this._points.size() && n < t._points.size();){
                    var i = this._points.getCoordinate(e).compareTo(t._points.getCoordinate(n));
                    if (0 !== i) return i;
                    e++, n++;
                }
                return e < this._points.size() ? 1 : n < t._points.size() ? -1 : 0;
            }
            if (2 === arguments.length) {
                var r = arguments[0];
                return arguments[1].compare(this._points, r._points);
            }
        }, e.prototype.apply = function() {
            if (T(arguments[0], ft)) for(var t = arguments[0], e = 0; e < this._points.size(); e++)t.filter(this._points.getCoordinate(e));
            else if (T(arguments[0], Ut)) {
                var n = arguments[0];
                if (0 === this._points.size()) return null;
                for(var i = 0; i < this._points.size() && (n.filter(this._points, i), !n.isDone()); i++);
                n.isGeometryChanged() && this.geometryChanged();
            } else if (T(arguments[0], Vt)) arguments[0].filter(this);
            else if (T(arguments[0], lt)) arguments[0].filter(this);
        }, e.prototype.getBoundary = function() {
            return new Yt(this).getBoundary();
        }, e.prototype.isEquivalentClass = function(t) {
            return t instanceof e;
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            return e._points = this._points.clone(), e;
        }, e.prototype.getCoordinateN = function(t) {
            return this._points.getCoordinate(t);
        }, e.prototype.getGeometryType = function() {
            return "LineString";
        }, e.prototype.copy = function() {
            return new e(this._points.copy(), this._factory);
        }, e.prototype.getCoordinateSequence = function() {
            return this._points;
        }, e.prototype.isEmpty = function() {
            return 0 === this._points.size();
        }, e.prototype.init = function(t) {
            if (null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), 1 === t.size()) throw new m("Invalid number of points in LineString (found " + t.size() + " - must be 0 or >= 2)");
            this._points = t;
        }, e.prototype.isCoordinate = function(t) {
            for(var e = 0; e < this._points.size(); e++)if (this._points.getCoordinate(e).equals(t)) return !0;
            return !1;
        }, e.prototype.getStartPoint = function() {
            return this.isEmpty() ? null : this.getPointN(0);
        }, e.prototype.getPointN = function(t) {
            return this.getFactory().createPoint(this._points.getCoordinate(t));
        }, e.prototype.interfaces_ = function() {
            return [
                At
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return 0x2b2b51ba435c8e00;
        }, Object.defineProperties(e, n), e;
    }(ct), Jt = function() {};
    Jt.prototype.interfaces_ = function() {
        return [];
    }, Jt.prototype.getClass = function() {
        return Jt;
    };
    var Qt = function(t) {
        function e(e, n) {
            t.call(this, n), this._coordinates = e || null, this.init(this._coordinates);
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            if (this.isEmpty()) return new j;
            var t = new j;
            return t.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0)), t;
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_POINT;
        }, e.prototype.getCoordinates = function() {
            return this.isEmpty() ? [] : [
                this.getCoordinate()
            ];
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && (!(!this.isEmpty() || !e.isEmpty()) || this.isEmpty() === e.isEmpty() && this.equal(e.getCoordinate(), this.getCoordinate(), n));
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {}, e.prototype.getCoordinate = function() {
            return 0 !== this._coordinates.size() ? this._coordinates.getCoordinate(0) : null;
        }, e.prototype.getBoundaryDimension = function() {
            return qt.FALSE;
        }, e.prototype.getDimension = function() {
            return 0;
        }, e.prototype.getNumPoints = function() {
            return this.isEmpty() ? 0 : 1;
        }, e.prototype.reverse = function() {
            return this.copy();
        }, e.prototype.getX = function() {
            if (null === this.getCoordinate()) throw new Error("getX called on empty Point");
            return this.getCoordinate().x;
        }, e.prototype.compareToSameClass = function() {
            if (1 === arguments.length) {
                var t = arguments[0];
                return this.getCoordinate().compareTo(t.getCoordinate());
            }
            if (2 === arguments.length) {
                var e = arguments[0];
                return arguments[1].compare(this._coordinates, e._coordinates);
            }
        }, e.prototype.apply = function() {
            if (T(arguments[0], ft)) {
                var t = arguments[0];
                if (this.isEmpty()) return null;
                t.filter(this.getCoordinate());
            } else if (T(arguments[0], Ut)) {
                var e = arguments[0];
                if (this.isEmpty()) return null;
                e.filter(this._coordinates, 0), e.isGeometryChanged() && this.geometryChanged();
            } else if (T(arguments[0], Vt)) arguments[0].filter(this);
            else if (T(arguments[0], lt)) arguments[0].filter(this);
        }, e.prototype.getBoundary = function() {
            return this.getFactory().createGeometryCollection(null);
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            return e._coordinates = this._coordinates.clone(), e;
        }, e.prototype.getGeometryType = function() {
            return "Point";
        }, e.prototype.copy = function() {
            return new e(this._coordinates.copy(), this._factory);
        }, e.prototype.getCoordinateSequence = function() {
            return this._coordinates;
        }, e.prototype.getY = function() {
            if (null === this.getCoordinate()) throw new Error("getY called on empty Point");
            return this.getCoordinate().y;
        }, e.prototype.isEmpty = function() {
            return 0 === this._coordinates.size();
        }, e.prototype.init = function(t) {
            null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), et.isTrue(t.size() <= 1), this._coordinates = t;
        }, e.prototype.isSimple = function() {
            return !0;
        }, e.prototype.interfaces_ = function() {
            return [
                Jt
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return 0x44077bad161cbc00;
        }, Object.defineProperties(e, n), e;
    }(ct), Zt = function() {};
    Zt.prototype.interfaces_ = function() {
        return [];
    }, Zt.prototype.getClass = function() {
        return Zt;
    };
    var $t = function(t) {
        function e(e, n, i) {
            if (t.call(this, i), this._shell = null, this._holes = null, null === e && (e = this.getFactory().createLinearRing()), null === n && (n = []), t.hasNullElements(n)) throw new m("holes must not contain null elements");
            if (e.isEmpty() && t.hasNonEmptyElements(n)) throw new m("shell is empty but holes are not");
            this._shell = e, this._holes = n;
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            return this._shell.getEnvelopeInternal();
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_POLYGON;
        }, e.prototype.getCoordinates = function() {
            if (this.isEmpty()) return [];
            for(var t = new Array(this.getNumPoints()).fill(null), e = -1, n = this._shell.getCoordinates(), i = 0; i < n.length; i++)t[++e] = n[i];
            for(var r = 0; r < this._holes.length; r++)for(var o = this._holes[r].getCoordinates(), s = 0; s < o.length; s++)t[++e] = o[s];
            return t;
        }, e.prototype.getArea = function() {
            var t = 0;
            t += Math.abs(at.signedArea(this._shell.getCoordinateSequence()));
            for(var e = 0; e < this._holes.length; e++)t -= Math.abs(at.signedArea(this._holes[e].getCoordinateSequence()));
            return t;
        }, e.prototype.isRectangle = function() {
            if (0 !== this.getNumInteriorRing()) return !1;
            if (null === this._shell) return !1;
            if (5 !== this._shell.getNumPoints()) return !1;
            for(var t = this._shell.getCoordinateSequence(), e = this.getEnvelopeInternal(), n = 0; n < 5; n++){
                var i = t.getX(n);
                if (i !== e.getMinX() && i !== e.getMaxX()) return !1;
                var r = t.getY(n);
                if (r !== e.getMinY() && r !== e.getMaxY()) return !1;
            }
            for(var o = t.getX(0), s = t.getY(0), a = 1; a <= 4; a++){
                var u = t.getX(a), l = t.getY(a);
                if (u !== o === (l !== s)) return !1;
                o = u, s = l;
            }
            return !0;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                if (!this.isEquivalentClass(e)) return !1;
                var i = e, r = this._shell, o = i._shell;
                if (!r.equalsExact(o, n)) return !1;
                if (this._holes.length !== i._holes.length) return !1;
                for(var s = 0; s < this._holes.length; s++)if (!this._holes[s].equalsExact(i._holes[s], n)) return !1;
                return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {
            if (0 === arguments.length) {
                this.normalize(this._shell, !0);
                for(var t = 0; t < this._holes.length; t++)this.normalize(this._holes[t], !1);
                Gt.sort(this._holes);
            } else if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                if (e.isEmpty()) return null;
                var i = new Array(e.getCoordinates().length - 1).fill(null);
                Y.arraycopy(e.getCoordinates(), 0, i, 0, i.length);
                var r = Lt.minCoordinate(e.getCoordinates());
                Lt.scroll(i, r), Y.arraycopy(i, 0, e.getCoordinates(), 0, i.length), e.getCoordinates()[i.length] = i[0], at.isCCW(e.getCoordinates()) === n && Lt.reverse(e.getCoordinates());
            }
        }, e.prototype.getCoordinate = function() {
            return this._shell.getCoordinate();
        }, e.prototype.getNumInteriorRing = function() {
            return this._holes.length;
        }, e.prototype.getBoundaryDimension = function() {
            return 1;
        }, e.prototype.getDimension = function() {
            return 2;
        }, e.prototype.getLength = function() {
            var t = 0;
            t += this._shell.getLength();
            for(var e = 0; e < this._holes.length; e++)t += this._holes[e].getLength();
            return t;
        }, e.prototype.getNumPoints = function() {
            for(var t = this._shell.getNumPoints(), e = 0; e < this._holes.length; e++)t += this._holes[e].getNumPoints();
            return t;
        }, e.prototype.reverse = function() {
            var t = this.copy();
            t._shell = this._shell.copy().reverse(), t._holes = new Array(this._holes.length).fill(null);
            for(var e = 0; e < this._holes.length; e++)t._holes[e] = this._holes[e].copy().reverse();
            return t;
        }, e.prototype.convexHull = function() {
            return this.getExteriorRing().convexHull();
        }, e.prototype.compareToSameClass = function() {
            if (1 === arguments.length) {
                var t = arguments[0], e = this._shell, n = t._shell;
                return e.compareToSameClass(n);
            }
            if (2 === arguments.length) {
                var i = arguments[0], r = arguments[1], o = i, s = this._shell, a = o._shell, u = s.compareToSameClass(a, r);
                if (0 !== u) return u;
                for(var l = this.getNumInteriorRing(), c = o.getNumInteriorRing(), p = 0; p < l && p < c;){
                    var h = this.getInteriorRingN(p), f = o.getInteriorRingN(p), g = h.compareToSameClass(f, r);
                    if (0 !== g) return g;
                    p++;
                }
                return p < l ? 1 : p < c ? -1 : 0;
            }
        }, e.prototype.apply = function(t) {
            if (T(t, ft)) {
                this._shell.apply(t);
                for(var e = 0; e < this._holes.length; e++)this._holes[e].apply(t);
            } else if (T(t, Ut)) {
                if (this._shell.apply(t), !t.isDone()) for(var n = 0; n < this._holes.length && (this._holes[n].apply(t), !t.isDone()); n++);
                t.isGeometryChanged() && this.geometryChanged();
            } else if (T(t, Vt)) t.filter(this);
            else if (T(t, lt)) {
                t.filter(this), this._shell.apply(t);
                for(var i = 0; i < this._holes.length; i++)this._holes[i].apply(t);
            }
        }, e.prototype.getBoundary = function() {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            var t = new Array(this._holes.length + 1).fill(null);
            t[0] = this._shell;
            for(var e = 0; e < this._holes.length; e++)t[e + 1] = this._holes[e];
            return t.length <= 1 ? this.getFactory().createLinearRing(t[0].getCoordinateSequence()) : this.getFactory().createMultiLineString(t);
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            e._shell = this._shell.clone(), e._holes = new Array(this._holes.length).fill(null);
            for(var n = 0; n < this._holes.length; n++)e._holes[n] = this._holes[n].clone();
            return e;
        }, e.prototype.getGeometryType = function() {
            return "Polygon";
        }, e.prototype.copy = function() {
            for(var t = this._shell.copy(), n = new Array(this._holes.length).fill(null), i = 0; i < n.length; i++)n[i] = this._holes[i].copy();
            return new e(t, n, this._factory);
        }, e.prototype.getExteriorRing = function() {
            return this._shell;
        }, e.prototype.isEmpty = function() {
            return this._shell.isEmpty();
        }, e.prototype.getInteriorRingN = function(t) {
            return this._holes[t];
        }, e.prototype.interfaces_ = function() {
            return [
                Zt
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -3494792200821764600;
        }, Object.defineProperties(e, n), e;
    }(ct), te = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return ct.SORTINDEX_MULTIPOINT;
        }, e.prototype.isValid = function() {
            return !0;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.getCoordinate = function() {
            if (1 === arguments.length) {
                var e = arguments[0];
                return this._geometries[e].getCoordinate();
            }
            return t.prototype.getCoordinate.apply(this, arguments);
        }, e.prototype.getBoundaryDimension = function() {
            return qt.FALSE;
        }, e.prototype.getDimension = function() {
            return 0;
        }, e.prototype.getBoundary = function() {
            return this.getFactory().createGeometryCollection(null);
        }, e.prototype.getGeometryType = function() {
            return "MultiPoint";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.interfaces_ = function() {
            return [
                Jt
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -8048474874175356000;
        }, Object.defineProperties(e, n), e;
    }(zt), ee = function(t) {
        function e(e, n) {
            e instanceof C && n instanceof _e && (e = n.getCoordinateSequenceFactory().create(e)), t.call(this, e, n), this.validateConstruction();
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            MINIMUM_VALID_SIZE: {
                configurable: !0
            },
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return ct.SORTINDEX_LINEARRING;
        }, e.prototype.getBoundaryDimension = function() {
            return qt.FALSE;
        }, e.prototype.isClosed = function() {
            return !!this.isEmpty() || t.prototype.isClosed.call(this);
        }, e.prototype.reverse = function() {
            var t = this._points.copy();
            Wt.reverse(t);
            return this.getFactory().createLinearRing(t);
        }, e.prototype.validateConstruction = function() {
            if (!this.isEmpty() && !t.prototype.isClosed.call(this)) throw new m("Points of LinearRing do not form a closed linestring");
            if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < e.MINIMUM_VALID_SIZE) throw new m("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
        }, e.prototype.getGeometryType = function() {
            return "LinearRing";
        }, e.prototype.copy = function() {
            return new e(this._points.copy(), this._factory);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, n.MINIMUM_VALID_SIZE.get = function() {
            return 4;
        }, n.serialVersionUID.get = function() {
            return -4261142084085851600;
        }, Object.defineProperties(e, n), e;
    }(Kt), ne = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return ct.SORTINDEX_MULTIPOLYGON;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.getBoundaryDimension = function() {
            return 1;
        }, e.prototype.getDimension = function() {
            return 2;
        }, e.prototype.reverse = function() {
            for(var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++)e[n] = this._geometries[n].reverse();
            return this.getFactory().createMultiPolygon(e);
        }, e.prototype.getBoundary = function() {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            for(var t = new Nt, e = 0; e < this._geometries.length; e++)for(var n = this._geometries[e].getBoundary(), i = 0; i < n.getNumGeometries(); i++)t.add(n.getGeometryN(i));
            var r = new Array(t.size()).fill(null);
            return this.getFactory().createMultiLineString(t.toArray(r));
        }, e.prototype.getGeometryType = function() {
            return "MultiPolygon";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.interfaces_ = function() {
            return [
                Zt
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -551033529766975900;
        }, Object.defineProperties(e, n), e;
    }(zt), ie = function(t) {
        this._factory = t || null, this._isUserDataCopied = !1;
    }, re = {
        NoOpGeometryOperation: {
            configurable: !0
        },
        CoordinateOperation: {
            configurable: !0
        },
        CoordinateSequenceOperation: {
            configurable: !0
        }
    };
    ie.prototype.setCopyUserData = function(t) {
        this._isUserDataCopied = t;
    }, ie.prototype.edit = function(t, e) {
        if (null === t) return null;
        var n = this.editInternal(t, e);
        return this._isUserDataCopied && n.setUserData(t.getUserData()), n;
    }, ie.prototype.editInternal = function(t, e) {
        return null === this._factory && (this._factory = t.getFactory()), t instanceof zt ? this.editGeometryCollection(t, e) : t instanceof $t ? this.editPolygon(t, e) : t instanceof Qt ? e.edit(t, this._factory) : t instanceof Kt ? e.edit(t, this._factory) : (et.shouldNeverReachHere("Unsupported Geometry class: " + t.getClass().getName()), null);
    }, ie.prototype.editGeometryCollection = function(t, e) {
        for(var n = e.edit(t, this._factory), i = new Nt, r = 0; r < n.getNumGeometries(); r++){
            var o = this.edit(n.getGeometryN(r), e);
            null === o || o.isEmpty() || i.add(o);
        }
        return n.getClass() === te ? this._factory.createMultiPoint(i.toArray([])) : n.getClass() === Xt ? this._factory.createMultiLineString(i.toArray([])) : n.getClass() === ne ? this._factory.createMultiPolygon(i.toArray([])) : this._factory.createGeometryCollection(i.toArray([]));
    }, ie.prototype.editPolygon = function(t, e) {
        var n = e.edit(t, this._factory);
        if (null === n && (n = this._factory.createPolygon(null)), n.isEmpty()) return n;
        var i = this.edit(n.getExteriorRing(), e);
        if (null === i || i.isEmpty()) return this._factory.createPolygon();
        for(var r = new Nt, o = 0; o < n.getNumInteriorRing(); o++){
            var s = this.edit(n.getInteriorRingN(o), e);
            null === s || s.isEmpty() || r.add(s);
        }
        return this._factory.createPolygon(i, r.toArray([]));
    }, ie.prototype.interfaces_ = function() {
        return [];
    }, ie.prototype.getClass = function() {
        return ie;
    }, ie.GeometryEditorOperation = function() {}, re.NoOpGeometryOperation.get = function() {
        return oe;
    }, re.CoordinateOperation.get = function() {
        return se;
    }, re.CoordinateSequenceOperation.get = function() {
        return ae;
    }, Object.defineProperties(ie, re);
    var oe = function() {};
    oe.prototype.edit = function(t, e) {
        return t;
    }, oe.prototype.interfaces_ = function() {
        return [
            ie.GeometryEditorOperation
        ];
    }, oe.prototype.getClass = function() {
        return oe;
    };
    var se = function() {};
    se.prototype.edit = function(t, e) {
        var n = this.editCoordinates(t.getCoordinates(), t);
        return null === n ? t : t instanceof ee ? e.createLinearRing(n) : t instanceof Kt ? e.createLineString(n) : t instanceof Qt ? n.length > 0 ? e.createPoint(n[0]) : e.createPoint() : t;
    }, se.prototype.interfaces_ = function() {
        return [
            ie.GeometryEditorOperation
        ];
    }, se.prototype.getClass = function() {
        return se;
    };
    var ae = function() {};
    ae.prototype.edit = function(t, e) {
        return t instanceof ee ? e.createLinearRing(this.edit(t.getCoordinateSequence(), t)) : t instanceof Kt ? e.createLineString(this.edit(t.getCoordinateSequence(), t)) : t instanceof Qt ? e.createPoint(this.edit(t.getCoordinateSequence(), t)) : t;
    }, ae.prototype.interfaces_ = function() {
        return [
            ie.GeometryEditorOperation
        ];
    }, ae.prototype.getClass = function() {
        return ae;
    };
    var ue = function() {
        if (this._dimension = 3, this._coordinates = null, 1 === arguments.length) {
            if (arguments[0] instanceof Array) this._coordinates = arguments[0], this._dimension = 3;
            else if (Number.isInteger(arguments[0])) {
                var t = arguments[0];
                this._coordinates = new Array(t).fill(null);
                for(var e = 0; e < t; e++)this._coordinates[e] = new C;
            } else if (T(arguments[0], V)) {
                var n = arguments[0];
                if (null === n) return this._coordinates = new Array(0).fill(null), null;
                this._dimension = n.getDimension(), this._coordinates = new Array(n.size()).fill(null);
                for(var i = 0; i < this._coordinates.length; i++)this._coordinates[i] = n.getCoordinateCopy(i);
            }
        } else if (2 === arguments.length) {
            if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                var r = arguments[0], o = arguments[1];
                this._coordinates = r, this._dimension = o, null === r && (this._coordinates = new Array(0).fill(null));
            } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                var s = arguments[0], a = arguments[1];
                this._coordinates = new Array(s).fill(null), this._dimension = a;
                for(var u = 0; u < s; u++)this._coordinates[u] = new C;
            }
        }
    }, le = {
        serialVersionUID: {
            configurable: !0
        }
    };
    ue.prototype.setOrdinate = function(t, e, n) {
        switch(e){
            case V.X:
                this._coordinates[t].x = n;
                break;
            case V.Y:
                this._coordinates[t].y = n;
                break;
            case V.Z:
                this._coordinates[t].z = n;
                break;
            default:
                throw new m("invalid ordinateIndex");
        }
    }, ue.prototype.size = function() {
        return this._coordinates.length;
    }, ue.prototype.getOrdinate = function(t, e) {
        switch(e){
            case V.X:
                return this._coordinates[t].x;
            case V.Y:
                return this._coordinates[t].y;
            case V.Z:
                return this._coordinates[t].z;
        }
        return v.NaN;
    }, ue.prototype.getCoordinate = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this._coordinates[t];
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            n.x = this._coordinates[e].x, n.y = this._coordinates[e].y, n.z = this._coordinates[e].z;
        }
    }, ue.prototype.getCoordinateCopy = function(t) {
        return new C(this._coordinates[t]);
    }, ue.prototype.getDimension = function() {
        return this._dimension;
    }, ue.prototype.getX = function(t) {
        return this._coordinates[t].x;
    }, ue.prototype.clone = function() {
        for(var t = new Array(this.size()).fill(null), e = 0; e < this._coordinates.length; e++)t[e] = this._coordinates[e].clone();
        return new ue(t, this._dimension);
    }, ue.prototype.expandEnvelope = function(t) {
        for(var e = 0; e < this._coordinates.length; e++)t.expandToInclude(this._coordinates[e]);
        return t;
    }, ue.prototype.copy = function() {
        for(var t = new Array(this.size()).fill(null), e = 0; e < this._coordinates.length; e++)t[e] = this._coordinates[e].copy();
        return new ue(t, this._dimension);
    }, ue.prototype.toString = function() {
        if (this._coordinates.length > 0) {
            var t = new D(17 * this._coordinates.length);
            t.append("("), t.append(this._coordinates[0]);
            for(var e = 1; e < this._coordinates.length; e++)t.append(", "), t.append(this._coordinates[e]);
            return t.append(")"), t.toString();
        }
        return "()";
    }, ue.prototype.getY = function(t) {
        return this._coordinates[t].y;
    }, ue.prototype.toCoordinateArray = function() {
        return this._coordinates;
    }, ue.prototype.interfaces_ = function() {
        return [
            V,
            e
        ];
    }, ue.prototype.getClass = function() {
        return ue;
    }, le.serialVersionUID.get = function() {
        return -915438501601840600;
    }, Object.defineProperties(ue, le);
    var ce = function() {}, pe = {
        serialVersionUID: {
            configurable: !0
        },
        instanceObject: {
            configurable: !0
        }
    };
    ce.prototype.readResolve = function() {
        return ce.instance();
    }, ce.prototype.create = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var t = arguments[0];
                return new ue(t);
            }
            if (T(arguments[0], V)) {
                var e = arguments[0];
                return new ue(e);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            return i > 3 && (i = 3), i < 2 ? new ue(n) : new ue(n, i);
        }
    }, ce.prototype.interfaces_ = function() {
        return [
            b,
            e
        ];
    }, ce.prototype.getClass = function() {
        return ce;
    }, ce.instance = function() {
        return ce.instanceObject;
    }, pe.serialVersionUID.get = function() {
        return -4099577099607551500;
    }, pe.instanceObject.get = function() {
        return new ce;
    }, Object.defineProperties(ce, pe);
    var he = function(t) {
        function e() {
            t.call(this), this.map_ = new Map;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(t) {
            return this.map_.get(t) || null;
        }, e.prototype.put = function(t, e) {
            return this.map_.set(t, e), e;
        }, e.prototype.values = function() {
            for(var t = new Nt, e = this.map_.values(), n = e.next(); !n.done;)t.add(n.value), n = e.next();
            return t;
        }, e.prototype.entrySet = function() {
            var t = new Pt;
            return this.map_.entries().forEach(function(e) {
                return t.add(e);
            }), t;
        }, e.prototype.size = function() {
            return this.map_.size();
        }, e;
    }(Tt), fe = function t() {
        if (this._modelType = null, this._scale = null, 0 === arguments.length) this._modelType = t.FLOATING;
        else if (1 === arguments.length) {
            if (arguments[0] instanceof de) {
                var e = arguments[0];
                this._modelType = e, e === t.FIXED && this.setScale(1);
            } else if ("number" == typeof arguments[0]) {
                var n = arguments[0];
                this._modelType = t.FIXED, this.setScale(n);
            } else if (arguments[0] instanceof t) {
                var i = arguments[0];
                this._modelType = i._modelType, this._scale = i._scale;
            }
        }
    }, ge = {
        serialVersionUID: {
            configurable: !0
        },
        maximumPreciseValue: {
            configurable: !0
        }
    };
    fe.prototype.equals = function(t) {
        if (!(t instanceof fe)) return !1;
        var e = t;
        return this._modelType === e._modelType && this._scale === e._scale;
    }, fe.prototype.compareTo = function(t) {
        var e = t, n = this.getMaximumSignificantDigits(), i = e.getMaximumSignificantDigits();
        return new M(n).compareTo(new M(i));
    }, fe.prototype.getScale = function() {
        return this._scale;
    }, fe.prototype.isFloating = function() {
        return this._modelType === fe.FLOATING || this._modelType === fe.FLOATING_SINGLE;
    }, fe.prototype.getType = function() {
        return this._modelType;
    }, fe.prototype.toString = function() {
        var t = "UNKNOWN";
        return this._modelType === fe.FLOATING ? t = "Floating" : this._modelType === fe.FLOATING_SINGLE ? t = "Floating-Single" : this._modelType === fe.FIXED && (t = "Fixed (Scale=" + this.getScale() + ")"), t;
    }, fe.prototype.makePrecise = function() {
        if ("number" == typeof arguments[0]) {
            var t = arguments[0];
            if (v.isNaN(t)) return t;
            if (this._modelType === fe.FLOATING_SINGLE) return t;
            return this._modelType === fe.FIXED ? Math.round(t * this._scale) / this._scale : t;
        }
        if (arguments[0] instanceof C) {
            var e = arguments[0];
            if (this._modelType === fe.FLOATING) return null;
            e.x = this.makePrecise(e.x), e.y = this.makePrecise(e.y);
        }
    }, fe.prototype.getMaximumSignificantDigits = function() {
        var t = 16;
        return this._modelType === fe.FLOATING ? t = 16 : this._modelType === fe.FLOATING_SINGLE ? t = 6 : this._modelType === fe.FIXED && (t = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)))), t;
    }, fe.prototype.setScale = function(t) {
        this._scale = Math.abs(t);
    }, fe.prototype.interfaces_ = function() {
        return [
            e,
            E
        ];
    }, fe.prototype.getClass = function() {
        return fe;
    }, fe.mostPrecise = function(t, e) {
        return t.compareTo(e) >= 0 ? t : e;
    }, ge.serialVersionUID.get = function() {
        return 0x6bee6404e9a25c00;
    }, ge.maximumPreciseValue.get = function() {
        return 9007199254740992;
    }, Object.defineProperties(fe, ge);
    var de = function t(e) {
        this._name = e || null, t.nameToTypeMap.put(e, this);
    }, ye = {
        serialVersionUID: {
            configurable: !0
        },
        nameToTypeMap: {
            configurable: !0
        }
    };
    de.prototype.readResolve = function() {
        return de.nameToTypeMap.get(this._name);
    }, de.prototype.toString = function() {
        return this._name;
    }, de.prototype.interfaces_ = function() {
        return [
            e
        ];
    }, de.prototype.getClass = function() {
        return de;
    }, ye.serialVersionUID.get = function() {
        return -5528602631731590000;
    }, ye.nameToTypeMap.get = function() {
        return new he;
    }, Object.defineProperties(de, ye), fe.Type = de, fe.FIXED = new de("FIXED"), fe.FLOATING = new de("FLOATING"), fe.FLOATING_SINGLE = new de("FLOATING SINGLE");
    var _e = function t() {
        this._precisionModel = new fe, this._SRID = 0, this._coordinateSequenceFactory = t.getDefaultCoordinateSequenceFactory(), 0 === arguments.length || (1 === arguments.length ? T(arguments[0], b) ? this._coordinateSequenceFactory = arguments[0] : arguments[0] instanceof fe && (this._precisionModel = arguments[0]) : 2 === arguments.length ? (this._precisionModel = arguments[0], this._SRID = arguments[1]) : 3 === arguments.length && (this._precisionModel = arguments[0], this._SRID = arguments[1], this._coordinateSequenceFactory = arguments[2]));
    }, me = {
        serialVersionUID: {
            configurable: !0
        }
    };
    _e.prototype.toGeometry = function(t) {
        return t.isNull() ? this.createPoint(null) : t.getMinX() === t.getMaxX() && t.getMinY() === t.getMaxY() ? this.createPoint(new C(t.getMinX(), t.getMinY())) : t.getMinX() === t.getMaxX() || t.getMinY() === t.getMaxY() ? this.createLineString([
            new C(t.getMinX(), t.getMinY()),
            new C(t.getMaxX(), t.getMaxY())
        ]) : this.createPolygon(this.createLinearRing([
            new C(t.getMinX(), t.getMinY()),
            new C(t.getMinX(), t.getMaxY()),
            new C(t.getMaxX(), t.getMaxY()),
            new C(t.getMaxX(), t.getMinY()),
            new C(t.getMinX(), t.getMinY())
        ]), null);
    }, _e.prototype.createLineString = function(t) {
        return t ? t instanceof Array ? new Kt(this.getCoordinateSequenceFactory().create(t), this) : T(t, V) ? new Kt(t, this) : void 0 : new Kt(this.getCoordinateSequenceFactory().create([]), this);
    }, _e.prototype.createMultiLineString = function() {
        if (0 === arguments.length) return new Xt(null, this);
        if (1 === arguments.length) {
            var t = arguments[0];
            return new Xt(t, this);
        }
    }, _e.prototype.buildGeometry = function(t) {
        for(var e = null, n = !1, i = !1, r = t.iterator(); r.hasNext();){
            var o = r.next(), s = o.getClass();
            null === e && (e = s), s !== e && (n = !0), o.isGeometryCollectionOrDerived() && (i = !0);
        }
        if (null === e) return this.createGeometryCollection();
        if (n || i) return this.createGeometryCollection(_e.toGeometryArray(t));
        var a = t.iterator().next();
        if (t.size() > 1) {
            if (a instanceof $t) return this.createMultiPolygon(_e.toPolygonArray(t));
            if (a instanceof Kt) return this.createMultiLineString(_e.toLineStringArray(t));
            if (a instanceof Qt) return this.createMultiPoint(_e.toPointArray(t));
            et.shouldNeverReachHere("Unhandled class: " + a.getClass().getName());
        }
        return a;
    }, _e.prototype.createMultiPointFromCoords = function(t) {
        return this.createMultiPoint(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
    }, _e.prototype.createPoint = function() {
        if (0 === arguments.length) return this.createPoint(this.getCoordinateSequenceFactory().create([]));
        if (1 === arguments.length) {
            if (arguments[0] instanceof C) {
                var t = arguments[0];
                return this.createPoint(null !== t ? this.getCoordinateSequenceFactory().create([
                    t
                ]) : null);
            }
            if (T(arguments[0], V)) {
                var e = arguments[0];
                return new Qt(e, this);
            }
        }
    }, _e.prototype.getCoordinateSequenceFactory = function() {
        return this._coordinateSequenceFactory;
    }, _e.prototype.createPolygon = function() {
        if (0 === arguments.length) return new $t(null, null, this);
        if (1 === arguments.length) {
            if (T(arguments[0], V)) {
                var t = arguments[0];
                return this.createPolygon(this.createLinearRing(t));
            }
            if (arguments[0] instanceof Array) {
                var e = arguments[0];
                return this.createPolygon(this.createLinearRing(e));
            }
            if (arguments[0] instanceof ee) {
                var n = arguments[0];
                return this.createPolygon(n, null);
            }
        } else if (2 === arguments.length) {
            var i = arguments[0], r = arguments[1];
            return new $t(i, r, this);
        }
    }, _e.prototype.getSRID = function() {
        return this._SRID;
    }, _e.prototype.createGeometryCollection = function() {
        if (0 === arguments.length) return new zt(null, this);
        if (1 === arguments.length) {
            var t = arguments[0];
            return new zt(t, this);
        }
    }, _e.prototype.createGeometry = function(t) {
        return new ie(this).edit(t, {
            edit: function() {
                if (2 === arguments.length) {
                    var t = arguments[0];
                    return this._coordinateSequenceFactory.create(t);
                }
            }
        });
    }, _e.prototype.getPrecisionModel = function() {
        return this._precisionModel;
    }, _e.prototype.createLinearRing = function() {
        if (0 === arguments.length) return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
        if (1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var t = arguments[0];
                return this.createLinearRing(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
            }
            if (T(arguments[0], V)) {
                var e = arguments[0];
                return new ee(e, this);
            }
        }
    }, _e.prototype.createMultiPolygon = function() {
        if (0 === arguments.length) return new ne(null, this);
        if (1 === arguments.length) {
            var t = arguments[0];
            return new ne(t, this);
        }
    }, _e.prototype.createMultiPoint = function() {
        if (0 === arguments.length) return new te(null, this);
        if (1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var t = arguments[0];
                return new te(t, this);
            }
            if (arguments[0] instanceof Array) {
                var e = arguments[0];
                return this.createMultiPoint(null !== e ? this.getCoordinateSequenceFactory().create(e) : null);
            }
            if (T(arguments[0], V)) {
                var n = arguments[0];
                if (null === n) return this.createMultiPoint(new Array(0).fill(null));
                for(var i = new Array(n.size()).fill(null), r = 0; r < n.size(); r++){
                    var o = this.getCoordinateSequenceFactory().create(1, n.getDimension());
                    Wt.copy(n, r, o, 0, 1), i[r] = this.createPoint(o);
                }
                return this.createMultiPoint(i);
            }
        }
    }, _e.prototype.interfaces_ = function() {
        return [
            e
        ];
    }, _e.prototype.getClass = function() {
        return _e;
    }, _e.toMultiPolygonArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.toGeometryArray = function(t) {
        if (null === t) return null;
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.getDefaultCoordinateSequenceFactory = function() {
        return ce.instance();
    }, _e.toMultiLineStringArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.toLineStringArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.toMultiPointArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.toLinearRingArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.toPointArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.toPolygonArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _e.createPointFromInternalCoord = function(t, e) {
        return e.getPrecisionModel().makePrecise(t), e.getFactory().createPoint(t);
    }, me.serialVersionUID.get = function() {
        return -6820524753094096000;
    }, Object.defineProperties(_e, me);
    var ve = [
        "Point",
        "MultiPoint",
        "LineString",
        "MultiLineString",
        "Polygon",
        "MultiPolygon"
    ], Ie = function(t) {
        this.geometryFactory = t || new _e;
    };
    Ie.prototype.read = function(t) {
        var e, n = (e = "string" == typeof t ? JSON.parse(t) : t).type;
        if (!Ee[n]) throw new Error("Unknown GeoJSON type: " + e.type);
        return -1 !== ve.indexOf(n) ? Ee[n].apply(this, [
            e.coordinates
        ]) : "GeometryCollection" === n ? Ee[n].apply(this, [
            e.geometries
        ]) : Ee[n].apply(this, [
            e
        ]);
    }, Ie.prototype.write = function(t) {
        var e = t.getGeometryType();
        if (!xe[e]) throw new Error("Geometry is not supported");
        return xe[e].apply(this, [
            t
        ]);
    };
    var Ee = {
        Feature: function(t) {
            var e = {};
            for(var n in t)e[n] = t[n];
            if (t.geometry) {
                var i = t.geometry.type;
                if (!Ee[i]) throw new Error("Unknown GeoJSON type: " + t.type);
                e.geometry = this.read(t.geometry);
            }
            return t.bbox && (e.bbox = Ee.bbox.apply(this, [
                t.bbox
            ])), e;
        },
        FeatureCollection: function(t) {
            var e = {};
            if (t.features) {
                e.features = [];
                for(var n = 0; n < t.features.length; ++n)e.features.push(this.read(t.features[n]));
            }
            return t.bbox && (e.bbox = this.parse.bbox.apply(this, [
                t.bbox
            ])), e;
        },
        coordinates: function(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var i = t[n];
                e.push(new C(i[0], i[1]));
            }
            return e;
        },
        bbox: function(t) {
            return this.geometryFactory.createLinearRing([
                new C(t[0], t[1]),
                new C(t[2], t[1]),
                new C(t[2], t[3]),
                new C(t[0], t[3]),
                new C(t[0], t[1])
            ]);
        },
        Point: function(t) {
            var e = new C(t[0], t[1]);
            return this.geometryFactory.createPoint(e);
        },
        MultiPoint: function(t) {
            for(var e = [], n = 0; n < t.length; ++n)e.push(Ee.Point.apply(this, [
                t[n]
            ]));
            return this.geometryFactory.createMultiPoint(e);
        },
        LineString: function(t) {
            var e = Ee.coordinates.apply(this, [
                t
            ]);
            return this.geometryFactory.createLineString(e);
        },
        MultiLineString: function(t) {
            for(var e = [], n = 0; n < t.length; ++n)e.push(Ee.LineString.apply(this, [
                t[n]
            ]));
            return this.geometryFactory.createMultiLineString(e);
        },
        Polygon: function(t) {
            for(var e = Ee.coordinates.apply(this, [
                t[0]
            ]), n = this.geometryFactory.createLinearRing(e), i = [], r = 1; r < t.length; ++r){
                var o = t[r], s = Ee.coordinates.apply(this, [
                    o
                ]), a = this.geometryFactory.createLinearRing(s);
                i.push(a);
            }
            return this.geometryFactory.createPolygon(n, i);
        },
        MultiPolygon: function(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var i = t[n];
                e.push(Ee.Polygon.apply(this, [
                    i
                ]));
            }
            return this.geometryFactory.createMultiPolygon(e);
        },
        GeometryCollection: function(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var i = t[n];
                e.push(this.read(i));
            }
            return this.geometryFactory.createGeometryCollection(e);
        }
    }, xe = {
        coordinate: function(t) {
            return [
                t.x,
                t.y
            ];
        },
        Point: function(t) {
            return {
                type: "Point",
                coordinates: xe.coordinate.apply(this, [
                    t.getCoordinate()
                ])
            };
        },
        MultiPoint: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = xe.Point.apply(this, [
                    i
                ]);
                e.push(r.coordinates);
            }
            return {
                type: "MultiPoint",
                coordinates: e
            };
        },
        LineString: function(t) {
            for(var e = [], n = t.getCoordinates(), i = 0; i < n.length; ++i){
                var r = n[i];
                e.push(xe.coordinate.apply(this, [
                    r
                ]));
            }
            return {
                type: "LineString",
                coordinates: e
            };
        },
        MultiLineString: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = xe.LineString.apply(this, [
                    i
                ]);
                e.push(r.coordinates);
            }
            return {
                type: "MultiLineString",
                coordinates: e
            };
        },
        Polygon: function(t) {
            var e = [], n = xe.LineString.apply(this, [
                t._shell
            ]);
            e.push(n.coordinates);
            for(var i = 0; i < t._holes.length; ++i){
                var r = t._holes[i], o = xe.LineString.apply(this, [
                    r
                ]);
                e.push(o.coordinates);
            }
            return {
                type: "Polygon",
                coordinates: e
            };
        },
        MultiPolygon: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = xe.Polygon.apply(this, [
                    i
                ]);
                e.push(r.coordinates);
            }
            return {
                type: "MultiPolygon",
                coordinates: e
            };
        },
        GeometryCollection: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = i.getGeometryType();
                e.push(xe[r].apply(this, [
                    i
                ]));
            }
            return {
                type: "GeometryCollection",
                geometries: e
            };
        }
    }, Ne = function(t) {
        this.geometryFactory = t || new _e, this.precisionModel = this.geometryFactory.getPrecisionModel(), this.parser = new Ie(this.geometryFactory);
    };
    Ne.prototype.read = function(t) {
        var e = this.parser.read(t);
        return this.precisionModel.getType() === fe.FIXED && this.reducePrecision(e), e;
    }, Ne.prototype.reducePrecision = function(t) {
        var e, n;
        if (t.coordinate) this.precisionModel.makePrecise(t.coordinate);
        else if (t.points) for(e = 0, n = t.points.length; e < n; e++)this.precisionModel.makePrecise(t.points[e]);
        else if (t.geometries) for(e = 0, n = t.geometries.length; e < n; e++)this.reducePrecision(t.geometries[e]);
    };
    var Ce = function() {
        this.parser = new Ie(this.geometryFactory);
    };
    Ce.prototype.write = function(t) {
        return this.parser.write(t);
    };
    var Se = function() {}, Le = {
        ON: {
            configurable: !0
        },
        LEFT: {
            configurable: !0
        },
        RIGHT: {
            configurable: !0
        }
    };
    Se.prototype.interfaces_ = function() {
        return [];
    }, Se.prototype.getClass = function() {
        return Se;
    }, Se.opposite = function(t) {
        return t === Se.LEFT ? Se.RIGHT : t === Se.RIGHT ? Se.LEFT : t;
    }, Le.ON.get = function() {
        return 0;
    }, Le.LEFT.get = function() {
        return 1;
    }, Le.RIGHT.get = function() {
        return 2;
    }, Object.defineProperties(Se, Le), (d.prototype = new Error).name = "EmptyStackException", (y.prototype = new xt).add = function(t) {
        return this.array_.push(t), !0;
    }, y.prototype.get = function(t) {
        if (t < 0 || t >= this.size()) throw new Error;
        return this.array_[t];
    }, y.prototype.push = function(t) {
        return this.array_.push(t), t;
    }, y.prototype.pop = function(t) {
        if (0 === this.array_.length) throw new d;
        return this.array_.pop();
    }, y.prototype.peek = function() {
        if (0 === this.array_.length) throw new d;
        return this.array_[this.array_.length - 1];
    }, y.prototype.empty = function() {
        return 0 === this.array_.length;
    }, y.prototype.isEmpty = function() {
        return this.empty();
    }, y.prototype.search = function(t) {
        return this.array_.indexOf(t);
    }, y.prototype.size = function() {
        return this.array_.length;
    }, y.prototype.toArray = function() {
        for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
        return t;
    };
    var be = function() {
        this._minIndex = -1, this._minCoord = null, this._minDe = null, this._orientedDe = null;
    };
    be.prototype.getCoordinate = function() {
        return this._minCoord;
    }, be.prototype.getRightmostSide = function(t, e) {
        var n = this.getRightmostSideOfSegment(t, e);
        return n < 0 && (n = this.getRightmostSideOfSegment(t, e - 1)), n < 0 && (this._minCoord = null, this.checkForRightmostCoordinate(t)), n;
    }, be.prototype.findRightmostEdgeAtVertex = function() {
        var t = this._minDe.getEdge().getCoordinates();
        et.isTrue(this._minIndex > 0 && this._minIndex < t.length, "rightmost point expected to be interior vertex of edge");
        var e = t[this._minIndex - 1], n = t[this._minIndex + 1], i = at.computeOrientation(this._minCoord, n, e), r = !1;
        e.y < this._minCoord.y && n.y < this._minCoord.y && i === at.COUNTERCLOCKWISE ? r = !0 : e.y > this._minCoord.y && n.y > this._minCoord.y && i === at.CLOCKWISE && (r = !0), r && (this._minIndex = this._minIndex - 1);
    }, be.prototype.getRightmostSideOfSegment = function(t, e) {
        var n = t.getEdge().getCoordinates();
        if (e < 0 || e + 1 >= n.length) return -1;
        if (n[e].y === n[e + 1].y) return -1;
        var i = Se.LEFT;
        return n[e].y < n[e + 1].y && (i = Se.RIGHT), i;
    }, be.prototype.getEdge = function() {
        return this._orientedDe;
    }, be.prototype.checkForRightmostCoordinate = function(t) {
        for(var e = t.getEdge().getCoordinates(), n = 0; n < e.length - 1; n++)(null === this._minCoord || e[n].x > this._minCoord.x) && (this._minDe = t, this._minIndex = n, this._minCoord = e[n]);
    }, be.prototype.findRightmostEdgeAtNode = function() {
        var t = this._minDe.getNode().getEdges();
        this._minDe = t.getRightmostEdge(), this._minDe.isForward() || (this._minDe = this._minDe.getSym(), this._minIndex = this._minDe.getEdge().getCoordinates().length - 1);
    }, be.prototype.findEdge = function(t) {
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next();
            n.isForward() && this.checkForRightmostCoordinate(n);
        }
        et.isTrue(0 !== this._minIndex || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing"), 0 === this._minIndex ? this.findRightmostEdgeAtNode() : this.findRightmostEdgeAtVertex(), this._orientedDe = this._minDe;
        this.getRightmostSide(this._minDe, this._minIndex) === Se.LEFT && (this._orientedDe = this._minDe.getSym());
    }, be.prototype.interfaces_ = function() {
        return [];
    }, be.prototype.getClass = function() {
        return be;
    };
    var we = function(t) {
        function e(n, i) {
            t.call(this, e.msgWithCoord(n, i)), this.pt = i ? new C(i) : null, this.name = "TopologyException";
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getCoordinate = function() {
            return this.pt;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.msgWithCoord = function(t, e) {
            return e ? t : t + " [ " + e + " ]";
        }, e;
    }($), Oe = function() {
        this.array_ = [];
    };
    Oe.prototype.addLast = function(t) {
        this.array_.push(t);
    }, Oe.prototype.removeFirst = function() {
        return this.array_.shift();
    }, Oe.prototype.isEmpty = function() {
        return 0 === this.array_.length;
    };
    var Te = function() {
        this._finder = null, this._dirEdgeList = new Nt, this._nodes = new Nt, this._rightMostCoord = null, this._env = null, this._finder = new be;
    };
    Te.prototype.clearVisitedEdges = function() {
        for(var t = this._dirEdgeList.iterator(); t.hasNext();)t.next().setVisited(!1);
    }, Te.prototype.getRightmostCoordinate = function() {
        return this._rightMostCoord;
    }, Te.prototype.computeNodeDepth = function(t) {
        for(var e = null, n = t.getEdges().iterator(); n.hasNext();){
            var i = n.next();
            if (i.isVisited() || i.getSym().isVisited()) {
                e = i;
                break;
            }
        }
        if (null === e) throw new we("unable to find edge to compute depths at " + t.getCoordinate());
        t.getEdges().computeDepths(e);
        for(var r = t.getEdges().iterator(); r.hasNext();){
            var o = r.next();
            o.setVisited(!0), this.copySymDepths(o);
        }
    }, Te.prototype.computeDepth = function(t) {
        this.clearVisitedEdges();
        var e = this._finder.getEdge();
        e.setEdgeDepths(Se.RIGHT, t), this.copySymDepths(e), this.computeDepths(e);
    }, Te.prototype.create = function(t) {
        this.addReachable(t), this._finder.findEdge(this._dirEdgeList), this._rightMostCoord = this._finder.getCoordinate();
    }, Te.prototype.findResultEdges = function() {
        for(var t = this._dirEdgeList.iterator(); t.hasNext();){
            var e = t.next();
            e.getDepth(Se.RIGHT) >= 1 && e.getDepth(Se.LEFT) <= 0 && !e.isInteriorAreaEdge() && e.setInResult(!0);
        }
    }, Te.prototype.computeDepths = function(t) {
        var e = new Pt, n = new Oe, i = t.getNode();
        for(n.addLast(i), e.add(i), t.setVisited(!0); !n.isEmpty();){
            var r = n.removeFirst();
            e.add(r), this.computeNodeDepth(r);
            for(var o = r.getEdges().iterator(); o.hasNext();){
                var s = o.next().getSym();
                if (!s.isVisited()) {
                    var a = s.getNode();
                    e.contains(a) || (n.addLast(a), e.add(a));
                }
            }
        }
    }, Te.prototype.compareTo = function(t) {
        var e = t;
        return this._rightMostCoord.x < e._rightMostCoord.x ? -1 : this._rightMostCoord.x > e._rightMostCoord.x ? 1 : 0;
    }, Te.prototype.getEnvelope = function() {
        if (null === this._env) {
            for(var t = new j, e = this._dirEdgeList.iterator(); e.hasNext();)for(var n = e.next().getEdge().getCoordinates(), i = 0; i < n.length - 1; i++)t.expandToInclude(n[i]);
            this._env = t;
        }
        return this._env;
    }, Te.prototype.addReachable = function(t) {
        var e = new y;
        for(e.add(t); !e.empty();){
            var n = e.pop();
            this.add(n, e);
        }
    }, Te.prototype.copySymDepths = function(t) {
        var e = t.getSym();
        e.setDepth(Se.LEFT, t.getDepth(Se.RIGHT)), e.setDepth(Se.RIGHT, t.getDepth(Se.LEFT));
    }, Te.prototype.add = function(t, e) {
        t.setVisited(!0), this._nodes.add(t);
        for(var n = t.getEdges().iterator(); n.hasNext();){
            var i = n.next();
            this._dirEdgeList.add(i);
            var r = i.getSym().getNode();
            r.isVisited() || e.push(r);
        }
    }, Te.prototype.getNodes = function() {
        return this._nodes;
    }, Te.prototype.getDirectedEdges = function() {
        return this._dirEdgeList;
    }, Te.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, Te.prototype.getClass = function() {
        return Te;
    };
    var Re = function t() {
        if (this.location = null, 1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var e = arguments[0];
                this.init(e.length);
            } else if (Number.isInteger(arguments[0])) {
                var n = arguments[0];
                this.init(1), this.location[Se.ON] = n;
            } else if (arguments[0] instanceof t) {
                var i = arguments[0];
                if (this.init(i.location.length), null !== i) for(var r = 0; r < this.location.length; r++)this.location[r] = i.location[r];
            }
        } else if (3 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2];
            this.init(3), this.location[Se.ON] = o, this.location[Se.LEFT] = s, this.location[Se.RIGHT] = a;
        }
    };
    Re.prototype.setAllLocations = function(t) {
        for(var e = 0; e < this.location.length; e++)this.location[e] = t;
    }, Re.prototype.isNull = function() {
        for(var t = 0; t < this.location.length; t++)if (this.location[t] !== w.NONE) return !1;
        return !0;
    }, Re.prototype.setAllLocationsIfNull = function(t) {
        for(var e = 0; e < this.location.length; e++)this.location[e] === w.NONE && (this.location[e] = t);
    }, Re.prototype.isLine = function() {
        return 1 === this.location.length;
    }, Re.prototype.merge = function(t) {
        if (t.location.length > this.location.length) {
            var e = new Array(3).fill(null);
            e[Se.ON] = this.location[Se.ON], e[Se.LEFT] = w.NONE, e[Se.RIGHT] = w.NONE, this.location = e;
        }
        for(var n = 0; n < this.location.length; n++)this.location[n] === w.NONE && n < t.location.length && (this.location[n] = t.location[n]);
    }, Re.prototype.getLocations = function() {
        return this.location;
    }, Re.prototype.flip = function() {
        if (this.location.length <= 1) return null;
        var t = this.location[Se.LEFT];
        this.location[Se.LEFT] = this.location[Se.RIGHT], this.location[Se.RIGHT] = t;
    }, Re.prototype.toString = function() {
        var t = new D;
        return this.location.length > 1 && t.append(w.toLocationSymbol(this.location[Se.LEFT])), t.append(w.toLocationSymbol(this.location[Se.ON])), this.location.length > 1 && t.append(w.toLocationSymbol(this.location[Se.RIGHT])), t.toString();
    }, Re.prototype.setLocations = function(t, e, n) {
        this.location[Se.ON] = t, this.location[Se.LEFT] = e, this.location[Se.RIGHT] = n;
    }, Re.prototype.get = function(t) {
        return t < this.location.length ? this.location[t] : w.NONE;
    }, Re.prototype.isArea = function() {
        return this.location.length > 1;
    }, Re.prototype.isAnyNull = function() {
        for(var t = 0; t < this.location.length; t++)if (this.location[t] === w.NONE) return !0;
        return !1;
    }, Re.prototype.setLocation = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setLocation(Se.ON, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this.location[e] = n;
        }
    }, Re.prototype.init = function(t) {
        this.location = new Array(t).fill(null), this.setAllLocations(w.NONE);
    }, Re.prototype.isEqualOnSide = function(t, e) {
        return this.location[e] === t.location[e];
    }, Re.prototype.allPositionsEqual = function(t) {
        for(var e = 0; e < this.location.length; e++)if (this.location[e] !== t) return !1;
        return !0;
    }, Re.prototype.interfaces_ = function() {
        return [];
    }, Re.prototype.getClass = function() {
        return Re;
    };
    var Pe = function t() {
        if (this.elt = new Array(2).fill(null), 1 === arguments.length) {
            if (Number.isInteger(arguments[0])) {
                var e = arguments[0];
                this.elt[0] = new Re(e), this.elt[1] = new Re(e);
            } else if (arguments[0] instanceof t) {
                var n = arguments[0];
                this.elt[0] = new Re(n.elt[0]), this.elt[1] = new Re(n.elt[1]);
            }
        } else if (2 === arguments.length) {
            var i = arguments[0], r = arguments[1];
            this.elt[0] = new Re(w.NONE), this.elt[1] = new Re(w.NONE), this.elt[i].setLocation(r);
        } else if (3 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2];
            this.elt[0] = new Re(o, s, a), this.elt[1] = new Re(o, s, a);
        } else if (4 === arguments.length) {
            var u = arguments[0], l = arguments[1], c = arguments[2], p = arguments[3];
            this.elt[0] = new Re(w.NONE, w.NONE, w.NONE), this.elt[1] = new Re(w.NONE, w.NONE, w.NONE), this.elt[u].setLocations(l, c, p);
        }
    };
    Pe.prototype.getGeometryCount = function() {
        var t = 0;
        return this.elt[0].isNull() || t++, this.elt[1].isNull() || t++, t;
    }, Pe.prototype.setAllLocations = function(t, e) {
        this.elt[t].setAllLocations(e);
    }, Pe.prototype.isNull = function(t) {
        return this.elt[t].isNull();
    }, Pe.prototype.setAllLocationsIfNull = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setAllLocationsIfNull(0, t), this.setAllLocationsIfNull(1, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this.elt[e].setAllLocationsIfNull(n);
        }
    }, Pe.prototype.isLine = function(t) {
        return this.elt[t].isLine();
    }, Pe.prototype.merge = function(t) {
        for(var e = 0; e < 2; e++)null === this.elt[e] && null !== t.elt[e] ? this.elt[e] = new Re(t.elt[e]) : this.elt[e].merge(t.elt[e]);
    }, Pe.prototype.flip = function() {
        this.elt[0].flip(), this.elt[1].flip();
    }, Pe.prototype.getLocation = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.elt[t].get(Se.ON);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return this.elt[e].get(n);
        }
    }, Pe.prototype.toString = function() {
        var t = new D;
        return null !== this.elt[0] && (t.append("A:"), t.append(this.elt[0].toString())), null !== this.elt[1] && (t.append(" B:"), t.append(this.elt[1].toString())), t.toString();
    }, Pe.prototype.isArea = function() {
        if (0 === arguments.length) return this.elt[0].isArea() || this.elt[1].isArea();
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.elt[t].isArea();
        }
    }, Pe.prototype.isAnyNull = function(t) {
        return this.elt[t].isAnyNull();
    }, Pe.prototype.setLocation = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this.elt[t].setLocation(Se.ON, e);
        } else if (3 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2];
            this.elt[n].setLocation(i, r);
        }
    }, Pe.prototype.isEqualOnSide = function(t, e) {
        return this.elt[0].isEqualOnSide(t.elt[0], e) && this.elt[1].isEqualOnSide(t.elt[1], e);
    }, Pe.prototype.allPositionsEqual = function(t, e) {
        return this.elt[t].allPositionsEqual(e);
    }, Pe.prototype.toLine = function(t) {
        this.elt[t].isArea() && (this.elt[t] = new Re(this.elt[t].location[0]));
    }, Pe.prototype.interfaces_ = function() {
        return [];
    }, Pe.prototype.getClass = function() {
        return Pe;
    }, Pe.toLineLabel = function(t) {
        for(var e = new Pe(w.NONE), n = 0; n < 2; n++)e.setLocation(n, t.getLocation(n));
        return e;
    };
    var De = function() {
        this._startDe = null, this._maxNodeDegree = -1, this._edges = new Nt, this._pts = new Nt, this._label = new Pe(w.NONE), this._ring = null, this._isHole = null, this._shell = null, this._holes = new Nt, this._geometryFactory = null;
        var t = arguments[0], e = arguments[1];
        this._geometryFactory = e, this.computePoints(t), this.computeRing();
    };
    De.prototype.computeRing = function() {
        if (null !== this._ring) return null;
        for(var t = new Array(this._pts.size()).fill(null), e = 0; e < this._pts.size(); e++)t[e] = this._pts.get(e);
        this._ring = this._geometryFactory.createLinearRing(t), this._isHole = at.isCCW(this._ring.getCoordinates());
    }, De.prototype.isIsolated = function() {
        return 1 === this._label.getGeometryCount();
    }, De.prototype.computePoints = function(t) {
        this._startDe = t;
        var e = t, n = !0;
        do {
            if (null === e) throw new we("Found null DirectedEdge");
            if (e.getEdgeRing() === this) throw new we("Directed Edge visited twice during ring-building at " + e.getCoordinate());
            this._edges.add(e);
            var i = e.getLabel();
            et.isTrue(i.isArea()), this.mergeLabel(i), this.addPoints(e.getEdge(), e.isForward(), n), n = !1, this.setEdgeRing(e, this), e = this.getNext(e);
        }while (e !== this._startDe);
    }, De.prototype.getLinearRing = function() {
        return this._ring;
    }, De.prototype.getCoordinate = function(t) {
        return this._pts.get(t);
    }, De.prototype.computeMaxNodeDegree = function() {
        this._maxNodeDegree = 0;
        var t = this._startDe;
        do {
            var e = t.getNode().getEdges().getOutgoingDegree(this);
            e > this._maxNodeDegree && (this._maxNodeDegree = e), t = this.getNext(t);
        }while (t !== this._startDe);
        this._maxNodeDegree *= 2;
    }, De.prototype.addPoints = function(t, e, n) {
        var i = t.getCoordinates();
        if (e) {
            var r = 1;
            n && (r = 0);
            for(var o = r; o < i.length; o++)this._pts.add(i[o]);
        } else {
            var s = i.length - 2;
            n && (s = i.length - 1);
            for(var a = s; a >= 0; a--)this._pts.add(i[a]);
        }
    }, De.prototype.isHole = function() {
        return this._isHole;
    }, De.prototype.setInResult = function() {
        var t = this._startDe;
        do t.getEdge().setInResult(!0), t = t.getNext();
        while (t !== this._startDe);
    }, De.prototype.containsPoint = function(t) {
        var e = this.getLinearRing();
        if (!e.getEnvelopeInternal().contains(t)) return !1;
        if (!at.isPointInRing(t, e.getCoordinates())) return !1;
        for(var n = this._holes.iterator(); n.hasNext();){
            if (n.next().containsPoint(t)) return !1;
        }
        return !0;
    }, De.prototype.addHole = function(t) {
        this._holes.add(t);
    }, De.prototype.isShell = function() {
        return null === this._shell;
    }, De.prototype.getLabel = function() {
        return this._label;
    }, De.prototype.getEdges = function() {
        return this._edges;
    }, De.prototype.getMaxNodeDegree = function() {
        return this._maxNodeDegree < 0 && this.computeMaxNodeDegree(), this._maxNodeDegree;
    }, De.prototype.getShell = function() {
        return this._shell;
    }, De.prototype.mergeLabel = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.mergeLabel(t, 0), this.mergeLabel(t, 1);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = e.getLocation(n, Se.RIGHT);
            if (i === w.NONE) return null;
            if (this._label.getLocation(n) === w.NONE) return this._label.setLocation(n, i), null;
        }
    }, De.prototype.setShell = function(t) {
        this._shell = t, null !== t && t.addHole(this);
    }, De.prototype.toPolygon = function(t) {
        for(var e = new Array(this._holes.size()).fill(null), n = 0; n < this._holes.size(); n++)e[n] = this._holes.get(n).getLinearRing();
        return t.createPolygon(this.getLinearRing(), e);
    }, De.prototype.interfaces_ = function() {
        return [];
    }, De.prototype.getClass = function() {
        return De;
    };
    var Me = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, n);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setEdgeRing = function(t, e) {
            t.setMinEdgeRing(e);
        }, e.prototype.getNext = function(t) {
            return t.getNextMin();
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(De), Ae = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, n);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.buildMinimalRings = function() {
            var t = new Nt, e = this._startDe;
            do {
                if (null === e.getMinEdgeRing()) {
                    var n = new Me(e, this._geometryFactory);
                    t.add(n);
                }
                e = e.getNext();
            }while (e !== this._startDe);
            return t;
        }, e.prototype.setEdgeRing = function(t, e) {
            t.setEdgeRing(e);
        }, e.prototype.linkDirectedEdgesForMinimalEdgeRings = function() {
            var t = this._startDe;
            do t.getNode().getEdges().linkMinimalDirectedEdges(this), t = t.getNext();
            while (t !== this._startDe);
        }, e.prototype.getNext = function(t) {
            return t.getNext();
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(De), Fe = function() {
        if (this._label = null, this._isInResult = !1, this._isCovered = !1, this._isCoveredSet = !1, this._isVisited = !1, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this._label = t;
        }
    };
    Fe.prototype.setVisited = function(t) {
        this._isVisited = t;
    }, Fe.prototype.setInResult = function(t) {
        this._isInResult = t;
    }, Fe.prototype.isCovered = function() {
        return this._isCovered;
    }, Fe.prototype.isCoveredSet = function() {
        return this._isCoveredSet;
    }, Fe.prototype.setLabel = function(t) {
        this._label = t;
    }, Fe.prototype.getLabel = function() {
        return this._label;
    }, Fe.prototype.setCovered = function(t) {
        this._isCovered = t, this._isCoveredSet = !0;
    }, Fe.prototype.updateIM = function(t) {
        et.isTrue(this._label.getGeometryCount() >= 2, "found partial label"), this.computeIM(t);
    }, Fe.prototype.isInResult = function() {
        return this._isInResult;
    }, Fe.prototype.isVisited = function() {
        return this._isVisited;
    }, Fe.prototype.interfaces_ = function() {
        return [];
    }, Fe.prototype.getClass = function() {
        return Fe;
    };
    var Ge = function(t) {
        function e() {
            t.call(this), this._coord = null, this._edges = null;
            var e = arguments[0], n = arguments[1];
            this._coord = e, this._edges = n, this._label = new Pe(0, w.NONE);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isIncidentEdgeInResult = function() {
            for(var t = this.getEdges().getEdges().iterator(); t.hasNext();){
                if (t.next().getEdge().isInResult()) return !0;
            }
            return !1;
        }, e.prototype.isIsolated = function() {
            return 1 === this._label.getGeometryCount();
        }, e.prototype.getCoordinate = function() {
            return this._coord;
        }, e.prototype.print = function(t) {
            t.println("node " + this._coord + " lbl: " + this._label);
        }, e.prototype.computeIM = function(t) {}, e.prototype.computeMergedLocation = function(t, e) {
            var n = w.NONE;
            if (n = this._label.getLocation(e), !t.isNull(e)) {
                var i = t.getLocation(e);
                n !== w.BOUNDARY && (n = i);
            }
            return n;
        }, e.prototype.setLabel = function() {
            if (2 !== arguments.length) return t.prototype.setLabel.apply(this, arguments);
            var e = arguments[0], n = arguments[1];
            null === this._label ? this._label = new Pe(e, n) : this._label.setLocation(e, n);
        }, e.prototype.getEdges = function() {
            return this._edges;
        }, e.prototype.mergeLabel = function() {
            if (arguments[0] instanceof e) {
                var t = arguments[0];
                this.mergeLabel(t._label);
            } else if (arguments[0] instanceof Pe) for(var n = arguments[0], i = 0; i < 2; i++){
                var r = this.computeMergedLocation(n, i);
                this._label.getLocation(i) === w.NONE && this._label.setLocation(i, r);
            }
        }, e.prototype.add = function(t) {
            this._edges.insert(t), t.setNode(this);
        }, e.prototype.setLabelBoundary = function(t) {
            if (null === this._label) return null;
            var e = w.NONE;
            null !== this._label && (e = this._label.getLocation(t));
            var n = null;
            switch(e){
                case w.BOUNDARY:
                    n = w.INTERIOR;
                    break;
                case w.INTERIOR:
                default:
                    n = w.BOUNDARY;
            }
            this._label.setLocation(t, n);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Fe), qe = function() {
        this.nodeMap = new p, this.nodeFact = null;
        var t = arguments[0];
        this.nodeFact = t;
    };
    qe.prototype.find = function(t) {
        return this.nodeMap.get(t);
    }, qe.prototype.addNode = function() {
        if (arguments[0] instanceof C) {
            var t = arguments[0], e = this.nodeMap.get(t);
            return null === e && (e = this.nodeFact.createNode(t), this.nodeMap.put(t, e)), e;
        }
        if (arguments[0] instanceof Ge) {
            var n = arguments[0], i = this.nodeMap.get(n.getCoordinate());
            return null === i ? (this.nodeMap.put(n.getCoordinate(), n), n) : (i.mergeLabel(n), i);
        }
    }, qe.prototype.print = function(t) {
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, qe.prototype.iterator = function() {
        return this.nodeMap.values().iterator();
    }, qe.prototype.values = function() {
        return this.nodeMap.values();
    }, qe.prototype.getBoundaryNodes = function(t) {
        for(var e = new Nt, n = this.iterator(); n.hasNext();){
            var i = n.next();
            i.getLabel().getLocation(t) === w.BOUNDARY && e.add(i);
        }
        return e;
    }, qe.prototype.add = function(t) {
        var e = t.getCoordinate();
        this.addNode(e).add(t);
    }, qe.prototype.interfaces_ = function() {
        return [];
    }, qe.prototype.getClass = function() {
        return qe;
    };
    var Be = function() {}, Ve = {
        NE: {
            configurable: !0
        },
        NW: {
            configurable: !0
        },
        SW: {
            configurable: !0
        },
        SE: {
            configurable: !0
        }
    };
    Be.prototype.interfaces_ = function() {
        return [];
    }, Be.prototype.getClass = function() {
        return Be;
    }, Be.isNorthern = function(t) {
        return t === Be.NE || t === Be.NW;
    }, Be.isOpposite = function(t, e) {
        if (t === e) return !1;
        return 2 === (t - e + 4) % 4;
    }, Be.commonHalfPlane = function(t, e) {
        if (t === e) return t;
        if (2 === (t - e + 4) % 4) return -1;
        var n = t < e ? t : e;
        return 0 === n && 3 === (t > e ? t : e) ? 3 : n;
    }, Be.isInHalfPlane = function(t, e) {
        return e === Be.SE ? t === Be.SE || t === Be.SW : t === e || t === e + 1;
    }, Be.quadrant = function() {
        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
            var t = arguments[0], e = arguments[1];
            if (0 === t && 0 === e) throw new m("Cannot compute the quadrant for point ( " + t + ", " + e + " )");
            return t >= 0 ? e >= 0 ? Be.NE : Be.SE : e >= 0 ? Be.NW : Be.SW;
        }
        if (arguments[0] instanceof C && arguments[1] instanceof C) {
            var n = arguments[0], i = arguments[1];
            if (i.x === n.x && i.y === n.y) throw new m("Cannot compute the quadrant for two identical points " + n);
            return i.x >= n.x ? i.y >= n.y ? Be.NE : Be.SE : i.y >= n.y ? Be.NW : Be.SW;
        }
    }, Ve.NE.get = function() {
        return 0;
    }, Ve.NW.get = function() {
        return 1;
    }, Ve.SW.get = function() {
        return 2;
    }, Ve.SE.get = function() {
        return 3;
    }, Object.defineProperties(Be, Ve);
    var Ue = function() {
        if (this._edge = null, this._label = null, this._node = null, this._p0 = null, this._p1 = null, this._dx = null, this._dy = null, this._quadrant = null, 1 === arguments.length) {
            var t = arguments[0];
            this._edge = t;
        } else if (3 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = arguments[2];
            this._edge = e, this.init(n, i), this._label = null;
        } else if (4 === arguments.length) {
            var r = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3];
            this._edge = r, this.init(o, s), this._label = a;
        }
    };
    Ue.prototype.compareDirection = function(t) {
        return this._dx === t._dx && this._dy === t._dy ? 0 : this._quadrant > t._quadrant ? 1 : this._quadrant < t._quadrant ? -1 : at.computeOrientation(t._p0, t._p1, this._p1);
    }, Ue.prototype.getDy = function() {
        return this._dy;
    }, Ue.prototype.getCoordinate = function() {
        return this._p0;
    }, Ue.prototype.setNode = function(t) {
        this._node = t;
    }, Ue.prototype.print = function(t) {
        var e = Math.atan2(this._dy, this._dx), n = this.getClass().getName(), i = n.lastIndexOf("."), r = n.substring(i + 1);
        t.print("  " + r + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + e + "   " + this._label);
    }, Ue.prototype.compareTo = function(t) {
        var e = t;
        return this.compareDirection(e);
    }, Ue.prototype.getDirectedCoordinate = function() {
        return this._p1;
    }, Ue.prototype.getDx = function() {
        return this._dx;
    }, Ue.prototype.getLabel = function() {
        return this._label;
    }, Ue.prototype.getEdge = function() {
        return this._edge;
    }, Ue.prototype.getQuadrant = function() {
        return this._quadrant;
    }, Ue.prototype.getNode = function() {
        return this._node;
    }, Ue.prototype.toString = function() {
        var t = Math.atan2(this._dy, this._dx), e = this.getClass().getName(), n = e.lastIndexOf(".");
        return "  " + e.substring(n + 1) + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + t + "   " + this._label;
    }, Ue.prototype.computeLabel = function(t) {}, Ue.prototype.init = function(t, e) {
        this._p0 = t, this._p1 = e, this._dx = e.x - t.x, this._dy = e.y - t.y, this._quadrant = Be.quadrant(this._dx, this._dy), et.isTrue(!(0 === this._dx && 0 === this._dy), "EdgeEnd with identical endpoints found");
    }, Ue.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, Ue.prototype.getClass = function() {
        return Ue;
    };
    var ze = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            if (t.call(this, e), this._isForward = null, this._isInResult = !1, this._isVisited = !1, this._sym = null, this._next = null, this._nextMin = null, this._edgeRing = null, this._minEdgeRing = null, this._depth = [
                0,
                -999,
                -999
            ], this._isForward = n, n) this.init(e.getCoordinate(0), e.getCoordinate(1));
            else {
                var i = e.getNumPoints() - 1;
                this.init(e.getCoordinate(i), e.getCoordinate(i - 1));
            }
            this.computeDirectedLabel();
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getNextMin = function() {
            return this._nextMin;
        }, e.prototype.getDepth = function(t) {
            return this._depth[t];
        }, e.prototype.setVisited = function(t) {
            this._isVisited = t;
        }, e.prototype.computeDirectedLabel = function() {
            this._label = new Pe(this._edge.getLabel()), this._isForward || this._label.flip();
        }, e.prototype.getNext = function() {
            return this._next;
        }, e.prototype.setDepth = function(t, e) {
            if (-999 !== this._depth[t] && this._depth[t] !== e) throw new we("assigned depths do not match", this.getCoordinate());
            this._depth[t] = e;
        }, e.prototype.isInteriorAreaEdge = function() {
            for(var t = !0, e = 0; e < 2; e++)this._label.isArea(e) && this._label.getLocation(e, Se.LEFT) === w.INTERIOR && this._label.getLocation(e, Se.RIGHT) === w.INTERIOR || (t = !1);
            return t;
        }, e.prototype.setNextMin = function(t) {
            this._nextMin = t;
        }, e.prototype.print = function(e) {
            t.prototype.print.call(this, e), e.print(" " + this._depth[Se.LEFT] + "/" + this._depth[Se.RIGHT]), e.print(" (" + this.getDepthDelta() + ")"), this._isInResult && e.print(" inResult");
        }, e.prototype.setMinEdgeRing = function(t) {
            this._minEdgeRing = t;
        }, e.prototype.isLineEdge = function() {
            var t = this._label.isLine(0) || this._label.isLine(1), e = !this._label.isArea(0) || this._label.allPositionsEqual(0, w.EXTERIOR), n = !this._label.isArea(1) || this._label.allPositionsEqual(1, w.EXTERIOR);
            return t && e && n;
        }, e.prototype.setEdgeRing = function(t) {
            this._edgeRing = t;
        }, e.prototype.getMinEdgeRing = function() {
            return this._minEdgeRing;
        }, e.prototype.getDepthDelta = function() {
            var t = this._edge.getDepthDelta();
            return this._isForward || (t = -t), t;
        }, e.prototype.setInResult = function(t) {
            this._isInResult = t;
        }, e.prototype.getSym = function() {
            return this._sym;
        }, e.prototype.isForward = function() {
            return this._isForward;
        }, e.prototype.getEdge = function() {
            return this._edge;
        }, e.prototype.printEdge = function(t) {
            this.print(t), t.print(" "), this._isForward ? this._edge.print(t) : this._edge.printReverse(t);
        }, e.prototype.setSym = function(t) {
            this._sym = t;
        }, e.prototype.setVisitedEdge = function(t) {
            this.setVisited(t), this._sym.setVisited(t);
        }, e.prototype.setEdgeDepths = function(t, e) {
            var n = this.getEdge().getDepthDelta();
            this._isForward || (n = -n);
            var i = 1;
            t === Se.LEFT && (i = -1);
            var r = Se.opposite(t), o = e + n * i;
            this.setDepth(t, e), this.setDepth(r, o);
        }, e.prototype.getEdgeRing = function() {
            return this._edgeRing;
        }, e.prototype.isInResult = function() {
            return this._isInResult;
        }, e.prototype.setNext = function(t) {
            this._next = t;
        }, e.prototype.isVisited = function() {
            return this._isVisited;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.depthFactor = function(t, e) {
            return t === w.EXTERIOR && e === w.INTERIOR ? 1 : t === w.INTERIOR && e === w.EXTERIOR ? -1 : 0;
        }, e;
    }(Ue), Xe = function() {};
    Xe.prototype.createNode = function(t) {
        return new Ge(t, null);
    }, Xe.prototype.interfaces_ = function() {
        return [];
    }, Xe.prototype.getClass = function() {
        return Xe;
    };
    var Ye = function() {
        if (this._edges = new Nt, this._nodes = null, this._edgeEndList = new Nt, 0 === arguments.length) this._nodes = new qe(new Xe);
        else if (1 === arguments.length) {
            var t = arguments[0];
            this._nodes = new qe(t);
        }
    };
    Ye.prototype.printEdges = function(t) {
        t.println("Edges:");
        for(var e = 0; e < this._edges.size(); e++){
            t.println("edge " + e + ":");
            var n = this._edges.get(e);
            n.print(t), n.eiList.print(t);
        }
    }, Ye.prototype.find = function(t) {
        return this._nodes.find(t);
    }, Ye.prototype.addNode = function() {
        if (arguments[0] instanceof Ge) {
            var t = arguments[0];
            return this._nodes.addNode(t);
        }
        if (arguments[0] instanceof C) {
            var e = arguments[0];
            return this._nodes.addNode(e);
        }
    }, Ye.prototype.getNodeIterator = function() {
        return this._nodes.iterator();
    }, Ye.prototype.linkResultDirectedEdges = function() {
        for(var t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkResultDirectedEdges();
    }, Ye.prototype.debugPrintln = function(t) {
        Y.out.println(t);
    }, Ye.prototype.isBoundaryNode = function(t, e) {
        var n = this._nodes.find(e);
        if (null === n) return !1;
        var i = n.getLabel();
        return null !== i && i.getLocation(t) === w.BOUNDARY;
    }, Ye.prototype.linkAllDirectedEdges = function() {
        for(var t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkAllDirectedEdges();
    }, Ye.prototype.matchInSameDirection = function(t, e, n, i) {
        return !!t.equals(n) && at.computeOrientation(t, e, i) === at.COLLINEAR && Be.quadrant(t, e) === Be.quadrant(n, i);
    }, Ye.prototype.getEdgeEnds = function() {
        return this._edgeEndList;
    }, Ye.prototype.debugPrint = function(t) {
        Y.out.print(t);
    }, Ye.prototype.getEdgeIterator = function() {
        return this._edges.iterator();
    }, Ye.prototype.findEdgeInSameDirection = function(t, e) {
        for(var n = 0; n < this._edges.size(); n++){
            var i = this._edges.get(n), r = i.getCoordinates();
            if (this.matchInSameDirection(t, e, r[0], r[1])) return i;
            if (this.matchInSameDirection(t, e, r[r.length - 1], r[r.length - 2])) return i;
        }
        return null;
    }, Ye.prototype.insertEdge = function(t) {
        this._edges.add(t);
    }, Ye.prototype.findEdgeEnd = function(t) {
        for(var e = this.getEdgeEnds().iterator(); e.hasNext();){
            var n = e.next();
            if (n.getEdge() === t) return n;
        }
        return null;
    }, Ye.prototype.addEdges = function(t) {
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next();
            this._edges.add(n);
            var i = new ze(n, !0), r = new ze(n, !1);
            i.setSym(r), r.setSym(i), this.add(i), this.add(r);
        }
    }, Ye.prototype.add = function(t) {
        this._nodes.add(t), this._edgeEndList.add(t);
    }, Ye.prototype.getNodes = function() {
        return this._nodes.values();
    }, Ye.prototype.findEdge = function(t, e) {
        for(var n = 0; n < this._edges.size(); n++){
            var i = this._edges.get(n), r = i.getCoordinates();
            if (t.equals(r[0]) && e.equals(r[1])) return i;
        }
        return null;
    }, Ye.prototype.interfaces_ = function() {
        return [];
    }, Ye.prototype.getClass = function() {
        return Ye;
    }, Ye.linkResultDirectedEdges = function(t) {
        for(var e = t.iterator(); e.hasNext();)e.next().getEdges().linkResultDirectedEdges();
    };
    var ke = function() {
        this._geometryFactory = null, this._shellList = new Nt;
        var t = arguments[0];
        this._geometryFactory = t;
    };
    ke.prototype.sortShellsAndHoles = function(t, e, n) {
        for(var i = t.iterator(); i.hasNext();){
            var r = i.next();
            r.isHole() ? n.add(r) : e.add(r);
        }
    }, ke.prototype.computePolygons = function(t) {
        for(var e = new Nt, n = t.iterator(); n.hasNext();){
            var i = n.next().toPolygon(this._geometryFactory);
            e.add(i);
        }
        return e;
    }, ke.prototype.placeFreeHoles = function(t, e) {
        for(var n = e.iterator(); n.hasNext();){
            var i = n.next();
            if (null === i.getShell()) {
                var r = this.findEdgeRingContaining(i, t);
                if (null === r) throw new we("unable to assign hole to a shell", i.getCoordinate(0));
                i.setShell(r);
            }
        }
    }, ke.prototype.buildMinimalEdgeRings = function(t, e, n) {
        for(var i = new Nt, r = t.iterator(); r.hasNext();){
            var o = r.next();
            if (o.getMaxNodeDegree() > 2) {
                o.linkDirectedEdgesForMinimalEdgeRings();
                var s = o.buildMinimalRings(), a = this.findShell(s);
                null !== a ? (this.placePolygonHoles(a, s), e.add(a)) : n.addAll(s);
            } else i.add(o);
        }
        return i;
    }, ke.prototype.containsPoint = function(t) {
        for(var e = this._shellList.iterator(); e.hasNext();){
            if (e.next().containsPoint(t)) return !0;
        }
        return !1;
    }, ke.prototype.buildMaximalEdgeRings = function(t) {
        for(var e = new Nt, n = t.iterator(); n.hasNext();){
            var i = n.next();
            if (i.isInResult() && i.getLabel().isArea() && null === i.getEdgeRing()) {
                var r = new Ae(i, this._geometryFactory);
                e.add(r), r.setInResult();
            }
        }
        return e;
    }, ke.prototype.placePolygonHoles = function(t, e) {
        for(var n = e.iterator(); n.hasNext();){
            var i = n.next();
            i.isHole() && i.setShell(t);
        }
    }, ke.prototype.getPolygons = function() {
        return this.computePolygons(this._shellList);
    }, ke.prototype.findEdgeRingContaining = function(t, e) {
        for(var n = t.getLinearRing(), i = n.getEnvelopeInternal(), r = n.getCoordinateN(0), o = null, s = null, a = e.iterator(); a.hasNext();){
            var u = a.next(), l = u.getLinearRing(), c = l.getEnvelopeInternal();
            null !== o && (s = o.getLinearRing().getEnvelopeInternal());
            var p = !1;
            c.contains(i) && at.isPointInRing(r, l.getCoordinates()) && (p = !0), p && (null === o || s.contains(c)) && (o = u);
        }
        return o;
    }, ke.prototype.findShell = function(t) {
        for(var e = 0, n = null, i = t.iterator(); i.hasNext();){
            var r = i.next();
            r.isHole() || (n = r, e++);
        }
        return et.isTrue(e <= 1, "found two shells in MinimalEdgeRing list"), n;
    }, ke.prototype.add = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.add(t.getEdgeEnds(), t.getNodes());
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            Ye.linkResultDirectedEdges(n);
            var i = this.buildMaximalEdgeRings(e), r = new Nt, o = this.buildMinimalEdgeRings(i, this._shellList, r);
            this.sortShellsAndHoles(o, this._shellList, r), this.placeFreeHoles(this._shellList, r);
        }
    }, ke.prototype.interfaces_ = function() {
        return [];
    }, ke.prototype.getClass = function() {
        return ke;
    };
    var je = function() {};
    je.prototype.getBounds = function() {}, je.prototype.interfaces_ = function() {
        return [];
    }, je.prototype.getClass = function() {
        return je;
    };
    var He = function() {
        this._bounds = null, this._item = null;
        var t = arguments[0], e = arguments[1];
        this._bounds = t, this._item = e;
    };
    He.prototype.getItem = function() {
        return this._item;
    }, He.prototype.getBounds = function() {
        return this._bounds;
    }, He.prototype.interfaces_ = function() {
        return [
            je,
            e
        ];
    }, He.prototype.getClass = function() {
        return He;
    };
    var We = function() {
        this._size = null, this._items = null, this._size = 0, this._items = new Nt, this._items.add(null);
    };
    We.prototype.poll = function() {
        if (this.isEmpty()) return null;
        var t = this._items.get(1);
        return this._items.set(1, this._items.get(this._size)), this._size -= 1, this.reorder(1), t;
    }, We.prototype.size = function() {
        return this._size;
    }, We.prototype.reorder = function(t) {
        for(var e = null, n = this._items.get(t); 2 * t <= this._size && ((e = 2 * t) !== this._size && this._items.get(e + 1).compareTo(this._items.get(e)) < 0 && e++, this._items.get(e).compareTo(n) < 0); t = e)this._items.set(t, this._items.get(e));
        this._items.set(t, n);
    }, We.prototype.clear = function() {
        this._size = 0, this._items.clear();
    }, We.prototype.isEmpty = function() {
        return 0 === this._size;
    }, We.prototype.add = function(t) {
        this._items.add(null), this._size += 1;
        var e = this._size;
        for(this._items.set(0, t); t.compareTo(this._items.get(Math.trunc(e / 2))) < 0; e /= 2)this._items.set(e, this._items.get(Math.trunc(e / 2)));
        this._items.set(e, t);
    }, We.prototype.interfaces_ = function() {
        return [];
    }, We.prototype.getClass = function() {
        return We;
    };
    var Ke = function() {};
    Ke.prototype.visitItem = function(t) {}, Ke.prototype.interfaces_ = function() {
        return [];
    }, Ke.prototype.getClass = function() {
        return Ke;
    };
    var Je = function() {};
    Je.prototype.insert = function(t, e) {}, Je.prototype.remove = function(t, e) {}, Je.prototype.query = function() {}, Je.prototype.interfaces_ = function() {
        return [];
    }, Je.prototype.getClass = function() {
        return Je;
    };
    var Qe = function() {
        if (this._childBoundables = new Nt, this._bounds = null, this._level = null, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this._level = t;
        }
    }, Ze = {
        serialVersionUID: {
            configurable: !0
        }
    };
    Qe.prototype.getLevel = function() {
        return this._level;
    }, Qe.prototype.size = function() {
        return this._childBoundables.size();
    }, Qe.prototype.getChildBoundables = function() {
        return this._childBoundables;
    }, Qe.prototype.addChildBoundable = function(t) {
        et.isTrue(null === this._bounds), this._childBoundables.add(t);
    }, Qe.prototype.isEmpty = function() {
        return this._childBoundables.isEmpty();
    }, Qe.prototype.getBounds = function() {
        return null === this._bounds && (this._bounds = this.computeBounds()), this._bounds;
    }, Qe.prototype.interfaces_ = function() {
        return [
            je,
            e
        ];
    }, Qe.prototype.getClass = function() {
        return Qe;
    }, Ze.serialVersionUID.get = function() {
        return 0x5a1e55ec41369800;
    }, Object.defineProperties(Qe, Ze);
    var $e = function() {};
    $e.reverseOrder = function() {
        return {
            compare: function(t, e) {
                return e.compareTo(t);
            }
        };
    }, $e.min = function(t) {
        return $e.sort(t), t.get(0);
    }, $e.sort = function(t, e) {
        var n = t.toArray();
        e ? Gt.sort(n, e) : Gt.sort(n);
        for(var i = t.iterator(), r = 0, o = n.length; r < o; r++)i.next(), i.set(n[r]);
    }, $e.singletonList = function(t) {
        var e = new Nt;
        return e.add(t), e;
    };
    var tn = function() {
        this._boundable1 = null, this._boundable2 = null, this._distance = null, this._itemDistance = null;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._boundable1 = t, this._boundable2 = e, this._itemDistance = n, this._distance = this.distance();
    };
    tn.prototype.expandToQueue = function(t, e) {
        var n = tn.isComposite(this._boundable1), i = tn.isComposite(this._boundable2);
        if (n && i) return tn.area(this._boundable1) > tn.area(this._boundable2) ? (this.expand(this._boundable1, this._boundable2, t, e), null) : (this.expand(this._boundable2, this._boundable1, t, e), null);
        if (n) return this.expand(this._boundable1, this._boundable2, t, e), null;
        if (i) return this.expand(this._boundable2, this._boundable1, t, e), null;
        throw new m("neither boundable is composite");
    }, tn.prototype.isLeaves = function() {
        return !(tn.isComposite(this._boundable1) || tn.isComposite(this._boundable2));
    }, tn.prototype.compareTo = function(t) {
        var e = t;
        return this._distance < e._distance ? -1 : this._distance > e._distance ? 1 : 0;
    }, tn.prototype.expand = function(t, e, n, i) {
        for(var r = t.getChildBoundables().iterator(); r.hasNext();){
            var o = r.next(), s = new tn(o, e, this._itemDistance);
            s.getDistance() < i && n.add(s);
        }
    }, tn.prototype.getBoundable = function(t) {
        return 0 === t ? this._boundable1 : this._boundable2;
    }, tn.prototype.getDistance = function() {
        return this._distance;
    }, tn.prototype.distance = function() {
        return this.isLeaves() ? this._itemDistance.distance(this._boundable1, this._boundable2) : this._boundable1.getBounds().distance(this._boundable2.getBounds());
    }, tn.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, tn.prototype.getClass = function() {
        return tn;
    }, tn.area = function(t) {
        return t.getBounds().getArea();
    }, tn.isComposite = function(t) {
        return t instanceof Qe;
    };
    var en = function t() {
        if (this._root = null, this._built = !1, this._itemBoundables = new Nt, this._nodeCapacity = null, 0 === arguments.length) {
            var e = t.DEFAULT_NODE_CAPACITY;
            this._nodeCapacity = e;
        } else if (1 === arguments.length) {
            var n = arguments[0];
            et.isTrue(n > 1, "Node capacity must be greater than 1"), this._nodeCapacity = n;
        }
    }, nn = {
        IntersectsOp: {
            configurable: !0
        },
        serialVersionUID: {
            configurable: !0
        },
        DEFAULT_NODE_CAPACITY: {
            configurable: !0
        }
    };
    en.prototype.getNodeCapacity = function() {
        return this._nodeCapacity;
    }, en.prototype.lastNode = function(t) {
        return t.get(t.size() - 1);
    }, en.prototype.size = function() {
        if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.size(this._root));
        if (1 === arguments.length) {
            for(var t = 0, e = arguments[0].getChildBoundables().iterator(); e.hasNext();){
                var n = e.next();
                n instanceof Qe ? t += this.size(n) : n instanceof He && (t += 1);
            }
            return t;
        }
    }, en.prototype.removeItem = function(t, e) {
        for(var n = null, i = t.getChildBoundables().iterator(); i.hasNext();){
            var r = i.next();
            r instanceof He && r.getItem() === e && (n = r);
        }
        return null !== n && (t.getChildBoundables().remove(n), !0);
    }, en.prototype.itemsTree = function() {
        if (0 === arguments.length) {
            this.build();
            var t = this.itemsTree(this._root);
            return null === t ? new Nt : t;
        }
        if (1 === arguments.length) {
            for(var e = arguments[0], n = new Nt, i = e.getChildBoundables().iterator(); i.hasNext();){
                var r = i.next();
                if (r instanceof Qe) {
                    var o = this.itemsTree(r);
                    null !== o && n.add(o);
                } else r instanceof He ? n.add(r.getItem()) : et.shouldNeverReachHere();
            }
            return n.size() <= 0 ? null : n;
        }
    }, en.prototype.insert = function(t, e) {
        et.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built."), this._itemBoundables.add(new He(t, e));
    }, en.prototype.boundablesAtLevel = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = new Nt;
            return this.boundablesAtLevel(t, this._root, e), e;
        }
        if (3 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2];
            if (et.isTrue(n > -2), i.getLevel() === n) return r.add(i), null;
            for(var o = i.getChildBoundables().iterator(); o.hasNext();){
                var s = o.next();
                s instanceof Qe ? this.boundablesAtLevel(n, s, r) : (et.isTrue(s instanceof He), -1 === n && r.add(s));
            }
            return null;
        }
    }, en.prototype.query = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.build();
            var e = new Nt;
            return this.isEmpty() ? e : (this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.query(t, this._root, e), e);
        }
        if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            if (this.build(), this.isEmpty()) return null;
            this.getIntersectsOp().intersects(this._root.getBounds(), n) && this.query(n, this._root, i);
        } else if (3 === arguments.length) {
            if (T(arguments[2], Ke) && arguments[0] instanceof Object && arguments[1] instanceof Qe) for(var r = arguments[0], o = arguments[1], s = arguments[2], a = o.getChildBoundables(), u = 0; u < a.size(); u++){
                var l = a.get(u);
                this.getIntersectsOp().intersects(l.getBounds(), r) && (l instanceof Qe ? this.query(r, l, s) : l instanceof He ? s.visitItem(l.getItem()) : et.shouldNeverReachHere());
            }
            else if (T(arguments[2], xt) && arguments[0] instanceof Object && arguments[1] instanceof Qe) for(var c = arguments[0], p = arguments[1], h = arguments[2], f = p.getChildBoundables(), g = 0; g < f.size(); g++){
                var d = f.get(g);
                this.getIntersectsOp().intersects(d.getBounds(), c) && (d instanceof Qe ? this.query(c, d, h) : d instanceof He ? h.add(d.getItem()) : et.shouldNeverReachHere());
            }
        }
    }, en.prototype.build = function() {
        if (this._built) return null;
        this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1), this._itemBoundables = null, this._built = !0;
    }, en.prototype.getRoot = function() {
        return this.build(), this._root;
    }, en.prototype.remove = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            return this.build(), !!this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.remove(t, this._root, e);
        }
        if (3 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2], o = this.removeItem(i, r);
            if (o) return !0;
            for(var s = null, a = i.getChildBoundables().iterator(); a.hasNext();){
                var u = a.next();
                if (this.getIntersectsOp().intersects(u.getBounds(), n) && u instanceof Qe && (o = this.remove(n, u, r))) {
                    s = u;
                    break;
                }
            }
            return null !== s && s.getChildBoundables().isEmpty() && i.getChildBoundables().remove(s), o;
        }
    }, en.prototype.createHigherLevels = function(t, e) {
        et.isTrue(!t.isEmpty());
        var n = this.createParentBoundables(t, e + 1);
        return 1 === n.size() ? n.get(0) : this.createHigherLevels(n, e + 1);
    }, en.prototype.depth = function() {
        if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.depth(this._root));
        if (1 === arguments.length) {
            for(var t = 0, e = arguments[0].getChildBoundables().iterator(); e.hasNext();){
                var n = e.next();
                if (n instanceof Qe) {
                    var i = this.depth(n);
                    i > t && (t = i);
                }
            }
            return t + 1;
        }
    }, en.prototype.createParentBoundables = function(t, e) {
        et.isTrue(!t.isEmpty());
        var n = new Nt;
        n.add(this.createNode(e));
        var i = new Nt(t);
        $e.sort(i, this.getComparator());
        for(var r = i.iterator(); r.hasNext();){
            var o = r.next();
            this.lastNode(n).getChildBoundables().size() === this.getNodeCapacity() && n.add(this.createNode(e)), this.lastNode(n).addChildBoundable(o);
        }
        return n;
    }, en.prototype.isEmpty = function() {
        return this._built ? this._root.isEmpty() : this._itemBoundables.isEmpty();
    }, en.prototype.interfaces_ = function() {
        return [
            e
        ];
    }, en.prototype.getClass = function() {
        return en;
    }, en.compareDoubles = function(t, e) {
        return t > e ? 1 : t < e ? -1 : 0;
    }, nn.IntersectsOp.get = function() {
        return rn;
    }, nn.serialVersionUID.get = function() {
        return -3886435814360241000;
    }, nn.DEFAULT_NODE_CAPACITY.get = function() {
        return 10;
    }, Object.defineProperties(en, nn);
    var rn = function() {}, on = function() {};
    on.prototype.distance = function(t, e) {}, on.prototype.interfaces_ = function() {
        return [];
    }, on.prototype.getClass = function() {
        return on;
    };
    var sn = function(t) {
        function n(e) {
            e = e || n.DEFAULT_NODE_CAPACITY, t.call(this, e);
        }
        t && (n.__proto__ = t), (n.prototype = Object.create(t && t.prototype)).constructor = n;
        var i = {
            STRtreeNode: {
                configurable: !0
            },
            serialVersionUID: {
                configurable: !0
            },
            xComparator: {
                configurable: !0
            },
            yComparator: {
                configurable: !0
            },
            intersectsOp: {
                configurable: !0
            },
            DEFAULT_NODE_CAPACITY: {
                configurable: !0
            }
        };
        return n.prototype.createParentBoundablesFromVerticalSlices = function(t, e) {
            et.isTrue(t.length > 0);
            for(var n = new Nt, i = 0; i < t.length; i++)n.addAll(this.createParentBoundablesFromVerticalSlice(t[i], e));
            return n;
        }, n.prototype.createNode = function(t) {
            return new an(t);
        }, n.prototype.size = function() {
            return 0 === arguments.length ? t.prototype.size.call(this) : t.prototype.size.apply(this, arguments);
        }, n.prototype.insert = function() {
            if (2 !== arguments.length) return t.prototype.insert.apply(this, arguments);
            var e = arguments[0], n = arguments[1];
            if (e.isNull()) return null;
            t.prototype.insert.call(this, e, n);
        }, n.prototype.getIntersectsOp = function() {
            return n.intersectsOp;
        }, n.prototype.verticalSlices = function(t, e) {
            for(var n = Math.trunc(Math.ceil(t.size() / e)), i = new Array(e).fill(null), r = t.iterator(), o = 0; o < e; o++){
                i[o] = new Nt;
                for(var s = 0; r.hasNext() && s < n;){
                    var a = r.next();
                    i[o].add(a), s++;
                }
            }
            return i;
        }, n.prototype.query = function() {
            if (1 === arguments.length) {
                var e = arguments[0];
                return t.prototype.query.call(this, e);
            }
            if (2 === arguments.length) {
                var n = arguments[0], i = arguments[1];
                t.prototype.query.call(this, n, i);
            } else if (3 === arguments.length) {
                if (T(arguments[2], Ke) && arguments[0] instanceof Object && arguments[1] instanceof Qe) {
                    var r = arguments[0], o = arguments[1], s = arguments[2];
                    t.prototype.query.call(this, r, o, s);
                } else if (T(arguments[2], xt) && arguments[0] instanceof Object && arguments[1] instanceof Qe) {
                    var a = arguments[0], u = arguments[1], l = arguments[2];
                    t.prototype.query.call(this, a, u, l);
                }
            }
        }, n.prototype.getComparator = function() {
            return n.yComparator;
        }, n.prototype.createParentBoundablesFromVerticalSlice = function(e, n) {
            return t.prototype.createParentBoundables.call(this, e, n);
        }, n.prototype.remove = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return t.prototype.remove.call(this, e, n);
            }
            return t.prototype.remove.apply(this, arguments);
        }, n.prototype.depth = function() {
            return 0 === arguments.length ? t.prototype.depth.call(this) : t.prototype.depth.apply(this, arguments);
        }, n.prototype.createParentBoundables = function(t, e) {
            et.isTrue(!t.isEmpty());
            var i = Math.trunc(Math.ceil(t.size() / this.getNodeCapacity())), r = new Nt(t);
            $e.sort(r, n.xComparator);
            var o = this.verticalSlices(r, Math.trunc(Math.ceil(Math.sqrt(i))));
            return this.createParentBoundablesFromVerticalSlices(o, e);
        }, n.prototype.nearestNeighbour = function() {
            if (1 === arguments.length) {
                if (T(arguments[0], on)) {
                    var t = arguments[0], e = new tn(this.getRoot(), this.getRoot(), t);
                    return this.nearestNeighbour(e);
                }
                if (arguments[0] instanceof tn) {
                    var i = arguments[0];
                    return this.nearestNeighbour(i, v.POSITIVE_INFINITY);
                }
            } else if (2 === arguments.length) {
                if (arguments[0] instanceof n && T(arguments[1], on)) {
                    var r = arguments[0], o = arguments[1], s = new tn(this.getRoot(), r.getRoot(), o);
                    return this.nearestNeighbour(s);
                }
                if (arguments[0] instanceof tn && "number" == typeof arguments[1]) {
                    var a = arguments[0], u = arguments[1], l = null, c = new We;
                    for(c.add(a); !c.isEmpty() && u > 0;){
                        var p = c.poll(), h = p.getDistance();
                        if (h >= u) break;
                        p.isLeaves() ? (u = h, l = p) : p.expandToQueue(c, u);
                    }
                    return [
                        l.getBoundable(0).getItem(),
                        l.getBoundable(1).getItem()
                    ];
                }
            } else if (3 === arguments.length) {
                var f = arguments[0], g = arguments[1], d = arguments[2], y = new He(f, g), _ = new tn(this.getRoot(), y, d);
                return this.nearestNeighbour(_)[0];
            }
        }, n.prototype.interfaces_ = function() {
            return [
                Je,
                e
            ];
        }, n.prototype.getClass = function() {
            return n;
        }, n.centreX = function(t) {
            return n.avg(t.getMinX(), t.getMaxX());
        }, n.avg = function(t, e) {
            return (t + e) / 2;
        }, n.centreY = function(t) {
            return n.avg(t.getMinY(), t.getMaxY());
        }, i.STRtreeNode.get = function() {
            return an;
        }, i.serialVersionUID.get = function() {
            return 0x39920f7d5f261e0;
        }, i.xComparator.get = function() {
            return {
                interfaces_: function() {
                    return [
                        N
                    ];
                },
                compare: function(e, i) {
                    return t.compareDoubles(n.centreX(e.getBounds()), n.centreX(i.getBounds()));
                }
            };
        }, i.yComparator.get = function() {
            return {
                interfaces_: function() {
                    return [
                        N
                    ];
                },
                compare: function(e, i) {
                    return t.compareDoubles(n.centreY(e.getBounds()), n.centreY(i.getBounds()));
                }
            };
        }, i.intersectsOp.get = function() {
            return {
                interfaces_: function() {
                    return [
                        t.IntersectsOp
                    ];
                },
                intersects: function(t, e) {
                    return t.intersects(e);
                }
            };
        }, i.DEFAULT_NODE_CAPACITY.get = function() {
            return 10;
        }, Object.defineProperties(n, i), n;
    }(en), an = function(t) {
        function e() {
            var e = arguments[0];
            t.call(this, e);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.computeBounds = function() {
            for(var t = null, e = this.getChildBoundables().iterator(); e.hasNext();){
                var n = e.next();
                null === t ? t = new j(n.getBounds()) : t.expandToInclude(n.getBounds());
            }
            return t;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Qe), un = function() {};
    un.prototype.interfaces_ = function() {
        return [];
    }, un.prototype.getClass = function() {
        return un;
    }, un.relativeSign = function(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
    }, un.compare = function(t, e, n) {
        if (e.equals2D(n)) return 0;
        var i = un.relativeSign(e.x, n.x), r = un.relativeSign(e.y, n.y);
        switch(t){
            case 0:
                return un.compareValue(i, r);
            case 1:
                return un.compareValue(r, i);
            case 2:
                return un.compareValue(r, -i);
            case 3:
                return un.compareValue(-i, r);
            case 4:
                return un.compareValue(-i, -r);
            case 5:
                return un.compareValue(-r, -i);
            case 6:
                return un.compareValue(-r, i);
            case 7:
                return un.compareValue(i, -r);
        }
        return et.shouldNeverReachHere("invalid octant value"), 0;
    }, un.compareValue = function(t, e) {
        return t < 0 ? -1 : t > 0 ? 1 : e < 0 ? -1 : e > 0 ? 1 : 0;
    };
    var ln = function() {
        this._segString = null, this.coord = null, this.segmentIndex = null, this._segmentOctant = null, this._isInterior = null;
        var t = arguments[0], e = arguments[1], n = arguments[2], i = arguments[3];
        this._segString = t, this.coord = new C(e), this.segmentIndex = n, this._segmentOctant = i, this._isInterior = !e.equals2D(t.getCoordinate(n));
    };
    ln.prototype.getCoordinate = function() {
        return this.coord;
    }, ln.prototype.print = function(t) {
        t.print(this.coord), t.print(" seg # = " + this.segmentIndex);
    }, ln.prototype.compareTo = function(t) {
        var e = t;
        return this.segmentIndex < e.segmentIndex ? -1 : this.segmentIndex > e.segmentIndex ? 1 : this.coord.equals2D(e.coord) ? 0 : un.compare(this._segmentOctant, this.coord, e.coord);
    }, ln.prototype.isEndPoint = function(t) {
        return 0 === this.segmentIndex && !this._isInterior || this.segmentIndex === t;
    }, ln.prototype.isInterior = function() {
        return this._isInterior;
    }, ln.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, ln.prototype.getClass = function() {
        return ln;
    };
    var cn = function() {
        this._nodeMap = new p, this._edge = null;
        var t = arguments[0];
        this._edge = t;
    };
    cn.prototype.getSplitCoordinates = function() {
        var t = new St;
        this.addEndpoints();
        for(var e = this.iterator(), n = e.next(); e.hasNext();){
            var i = e.next();
            this.addEdgeCoordinates(n, i, t), n = i;
        }
        return t.toCoordinateArray();
    }, cn.prototype.addCollapsedNodes = function() {
        var t = new Nt;
        this.findCollapsesFromInsertedNodes(t), this.findCollapsesFromExistingVertices(t);
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next().intValue();
            this.add(this._edge.getCoordinate(n), n);
        }
    }, cn.prototype.print = function(t) {
        t.println("Intersections:");
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, cn.prototype.findCollapsesFromExistingVertices = function(t) {
        for(var e = 0; e < this._edge.size() - 2; e++){
            var n = this._edge.getCoordinate(e), i = this._edge.getCoordinate(e + 2);
            n.equals2D(i) && t.add(new M(e + 1));
        }
    }, cn.prototype.addEdgeCoordinates = function(t, e, n) {
        var i = this._edge.getCoordinate(e.segmentIndex), r = e.isInterior() || !e.coord.equals2D(i);
        n.add(new C(t.coord), !1);
        for(var o = t.segmentIndex + 1; o <= e.segmentIndex; o++)n.add(this._edge.getCoordinate(o));
        r && n.add(new C(e.coord));
    }, cn.prototype.iterator = function() {
        return this._nodeMap.values().iterator();
    }, cn.prototype.addSplitEdges = function(t) {
        this.addEndpoints(), this.addCollapsedNodes();
        for(var e = this.iterator(), n = e.next(); e.hasNext();){
            var i = e.next(), r = this.createSplitEdge(n, i);
            t.add(r), n = i;
        }
    }, cn.prototype.findCollapseIndex = function(t, e, n) {
        if (!t.coord.equals2D(e.coord)) return !1;
        var i = e.segmentIndex - t.segmentIndex;
        return e.isInterior() || i--, 1 === i && (n[0] = t.segmentIndex + 1, !0);
    }, cn.prototype.findCollapsesFromInsertedNodes = function(t) {
        for(var e = new Array(1).fill(null), n = this.iterator(), i = n.next(); n.hasNext();){
            var r = n.next();
            this.findCollapseIndex(i, r, e) && t.add(new M(e[0])), i = r;
        }
    }, cn.prototype.getEdge = function() {
        return this._edge;
    }, cn.prototype.addEndpoints = function() {
        var t = this._edge.size() - 1;
        this.add(this._edge.getCoordinate(0), 0), this.add(this._edge.getCoordinate(t), t);
    }, cn.prototype.createSplitEdge = function(t, e) {
        var n = e.segmentIndex - t.segmentIndex + 2, i = this._edge.getCoordinate(e.segmentIndex), r = e.isInterior() || !e.coord.equals2D(i);
        r || n--;
        var o = new Array(n).fill(null), s = 0;
        o[s++] = new C(t.coord);
        for(var a = t.segmentIndex + 1; a <= e.segmentIndex; a++)o[s++] = this._edge.getCoordinate(a);
        return r && (o[s] = new C(e.coord)), new gn(o, this._edge.getData());
    }, cn.prototype.add = function(t, e) {
        var n = new ln(this._edge, t, e, this._edge.getSegmentOctant(e)), i = this._nodeMap.get(n);
        return null !== i ? (et.isTrue(i.coord.equals2D(t), "Found equal nodes with different coordinates"), i) : (this._nodeMap.put(n, n), n);
    }, cn.prototype.checkSplitEdgesCorrectness = function(t) {
        var e = this._edge.getCoordinates(), n = t.get(0).getCoordinate(0);
        if (!n.equals2D(e[0])) throw new $("bad split edge start point at " + n);
        var i = t.get(t.size() - 1).getCoordinates(), r = i[i.length - 1];
        if (!r.equals2D(e[e.length - 1])) throw new $("bad split edge end point at " + r);
    }, cn.prototype.interfaces_ = function() {
        return [];
    }, cn.prototype.getClass = function() {
        return cn;
    };
    var pn = function() {};
    pn.prototype.interfaces_ = function() {
        return [];
    }, pn.prototype.getClass = function() {
        return pn;
    }, pn.octant = function() {
        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
            var t = arguments[0], e = arguments[1];
            if (0 === t && 0 === e) throw new m("Cannot compute the octant for point ( " + t + ", " + e + " )");
            var n = Math.abs(t), i = Math.abs(e);
            return t >= 0 ? e >= 0 ? n >= i ? 0 : 1 : n >= i ? 7 : 6 : e >= 0 ? n >= i ? 3 : 2 : n >= i ? 4 : 5;
        }
        if (arguments[0] instanceof C && arguments[1] instanceof C) {
            var r = arguments[0], o = arguments[1], s = o.x - r.x, a = o.y - r.y;
            if (0 === s && 0 === a) throw new m("Cannot compute the octant for two identical points " + r);
            return pn.octant(s, a);
        }
    };
    var hn = function() {};
    hn.prototype.getCoordinates = function() {}, hn.prototype.size = function() {}, hn.prototype.getCoordinate = function(t) {}, hn.prototype.isClosed = function() {}, hn.prototype.setData = function(t) {}, hn.prototype.getData = function() {}, hn.prototype.interfaces_ = function() {
        return [];
    }, hn.prototype.getClass = function() {
        return hn;
    };
    var fn = function() {};
    fn.prototype.addIntersection = function(t, e) {}, fn.prototype.interfaces_ = function() {
        return [
            hn
        ];
    }, fn.prototype.getClass = function() {
        return fn;
    };
    var gn = function() {
        this._nodeList = new cn(this), this._pts = null, this._data = null;
        var t = arguments[0], e = arguments[1];
        this._pts = t, this._data = e;
    };
    gn.prototype.getCoordinates = function() {
        return this._pts;
    }, gn.prototype.size = function() {
        return this._pts.length;
    }, gn.prototype.getCoordinate = function(t) {
        return this._pts[t];
    }, gn.prototype.isClosed = function() {
        return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }, gn.prototype.getSegmentOctant = function(t) {
        return t === this._pts.length - 1 ? -1 : this.safeOctant(this.getCoordinate(t), this.getCoordinate(t + 1));
    }, gn.prototype.setData = function(t) {
        this._data = t;
    }, gn.prototype.safeOctant = function(t, e) {
        return t.equals2D(e) ? 0 : pn.octant(t, e);
    }, gn.prototype.getData = function() {
        return this._data;
    }, gn.prototype.addIntersection = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this.addIntersectionNode(t, e);
        } else if (4 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[3], o = new C(n.getIntersection(r));
            this.addIntersection(o, i);
        }
    }, gn.prototype.toString = function() {
        return Z.toLineString(new ue(this._pts));
    }, gn.prototype.getNodeList = function() {
        return this._nodeList;
    }, gn.prototype.addIntersectionNode = function(t, e) {
        var n = e, i = n + 1;
        if (i < this._pts.length) {
            var r = this._pts[i];
            t.equals2D(r) && (n = i);
        }
        return this._nodeList.add(t, n);
    }, gn.prototype.addIntersections = function(t, e, n) {
        for(var i = 0; i < t.getIntersectionNum(); i++)this.addIntersection(t, e, n, i);
    }, gn.prototype.interfaces_ = function() {
        return [
            fn
        ];
    }, gn.prototype.getClass = function() {
        return gn;
    }, gn.getNodedSubstrings = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = new Nt;
            return gn.getNodedSubstrings(t, e), e;
        }
        if (2 === arguments.length) for(var n = arguments[0], i = arguments[1], r = n.iterator(); r.hasNext();)r.next().getNodeList().addSplitEdges(i);
    };
    var dn = function() {
        if (this.p0 = null, this.p1 = null, 0 === arguments.length) this.p0 = new C, this.p1 = new C;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this.p0 = new C(t.p0), this.p1 = new C(t.p1);
        } else if (2 === arguments.length) this.p0 = arguments[0], this.p1 = arguments[1];
        else if (4 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = arguments[2], r = arguments[3];
            this.p0 = new C(e, n), this.p1 = new C(i, r);
        }
    }, yn = {
        serialVersionUID: {
            configurable: !0
        }
    };
    dn.prototype.minX = function() {
        return Math.min(this.p0.x, this.p1.x);
    }, dn.prototype.orientationIndex = function() {
        if (arguments[0] instanceof dn) {
            var t = arguments[0], e = at.orientationIndex(this.p0, this.p1, t.p0), n = at.orientationIndex(this.p0, this.p1, t.p1);
            return e >= 0 && n >= 0 ? Math.max(e, n) : e <= 0 && n <= 0 ? Math.max(e, n) : 0;
        }
        if (arguments[0] instanceof C) {
            var i = arguments[0];
            return at.orientationIndex(this.p0, this.p1, i);
        }
    }, dn.prototype.toGeometry = function(t) {
        return t.createLineString([
            this.p0,
            this.p1
        ]);
    }, dn.prototype.isVertical = function() {
        return this.p0.x === this.p1.x;
    }, dn.prototype.equals = function(t) {
        if (!(t instanceof dn)) return !1;
        var e = t;
        return this.p0.equals(e.p0) && this.p1.equals(e.p1);
    }, dn.prototype.intersection = function(t) {
        var e = new rt;
        return e.computeIntersection(this.p0, this.p1, t.p0, t.p1), e.hasIntersection() ? e.getIntersection(0) : null;
    }, dn.prototype.project = function() {
        if (arguments[0] instanceof C) {
            var t = arguments[0];
            if (t.equals(this.p0) || t.equals(this.p1)) return new C(t);
            var e = this.projectionFactor(t), n = new C;
            return n.x = this.p0.x + e * (this.p1.x - this.p0.x), n.y = this.p0.y + e * (this.p1.y - this.p0.y), n;
        }
        if (arguments[0] instanceof dn) {
            var i = arguments[0], r = this.projectionFactor(i.p0), o = this.projectionFactor(i.p1);
            if (r >= 1 && o >= 1) return null;
            if (r <= 0 && o <= 0) return null;
            var s = this.project(i.p0);
            r < 0 && (s = this.p0), r > 1 && (s = this.p1);
            var a = this.project(i.p1);
            return o < 0 && (a = this.p0), o > 1 && (a = this.p1), new dn(s, a);
        }
    }, dn.prototype.normalize = function() {
        this.p1.compareTo(this.p0) < 0 && this.reverse();
    }, dn.prototype.angle = function() {
        return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
    }, dn.prototype.getCoordinate = function(t) {
        return 0 === t ? this.p0 : this.p1;
    }, dn.prototype.distancePerpendicular = function(t) {
        return at.distancePointLinePerpendicular(t, this.p0, this.p1);
    }, dn.prototype.minY = function() {
        return Math.min(this.p0.y, this.p1.y);
    }, dn.prototype.midPoint = function() {
        return dn.midPoint(this.p0, this.p1);
    }, dn.prototype.projectionFactor = function(t) {
        if (t.equals(this.p0)) return 0;
        if (t.equals(this.p1)) return 1;
        var e = this.p1.x - this.p0.x, n = this.p1.y - this.p0.y, i = e * e + n * n;
        if (i <= 0) return v.NaN;
        return ((t.x - this.p0.x) * e + (t.y - this.p0.y) * n) / i;
    }, dn.prototype.closestPoints = function(t) {
        var e = this.intersection(t);
        if (null !== e) return [
            e,
            e
        ];
        var n = new Array(2).fill(null), i = v.MAX_VALUE, r = null, o = this.closestPoint(t.p0);
        i = o.distance(t.p0), n[0] = o, n[1] = t.p0;
        var s = this.closestPoint(t.p1);
        (r = s.distance(t.p1)) < i && (i = r, n[0] = s, n[1] = t.p1);
        var a = t.closestPoint(this.p0);
        (r = a.distance(this.p0)) < i && (i = r, n[0] = this.p0, n[1] = a);
        var u = t.closestPoint(this.p1);
        return (r = u.distance(this.p1)) < i && (i = r, n[0] = this.p1, n[1] = u), n;
    }, dn.prototype.closestPoint = function(t) {
        var e = this.projectionFactor(t);
        if (e > 0 && e < 1) return this.project(t);
        return this.p0.distance(t) < this.p1.distance(t) ? this.p0 : this.p1;
    }, dn.prototype.maxX = function() {
        return Math.max(this.p0.x, this.p1.x);
    }, dn.prototype.getLength = function() {
        return this.p0.distance(this.p1);
    }, dn.prototype.compareTo = function(t) {
        var e = t, n = this.p0.compareTo(e.p0);
        return 0 !== n ? n : this.p1.compareTo(e.p1);
    }, dn.prototype.reverse = function() {
        var t = this.p0;
        this.p0 = this.p1, this.p1 = t;
    }, dn.prototype.equalsTopo = function(t) {
        return this.p0.equals(t.p0) && (this.p1.equals(t.p1) || this.p0.equals(t.p1)) && this.p1.equals(t.p0);
    }, dn.prototype.lineIntersection = function(t) {
        try {
            return k.intersection(this.p0, this.p1, t.p0, t.p1);
        } catch (t) {
            if (!(t instanceof X)) throw t;
        }
        return null;
    }, dn.prototype.maxY = function() {
        return Math.max(this.p0.y, this.p1.y);
    }, dn.prototype.pointAlongOffset = function(t, e) {
        var n = this.p0.x + t * (this.p1.x - this.p0.x), i = this.p0.y + t * (this.p1.y - this.p0.y), r = this.p1.x - this.p0.x, o = this.p1.y - this.p0.y, s = Math.sqrt(r * r + o * o), a = 0, u = 0;
        if (0 !== e) {
            if (s <= 0) throw new Error("Cannot compute offset from zero-length line segment");
            a = e * r / s, u = e * o / s;
        }
        return new C(n - u, i + a);
    }, dn.prototype.setCoordinates = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setCoordinates(t.p0, t.p1);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this.p0.x = e.x, this.p0.y = e.y, this.p1.x = n.x, this.p1.y = n.y;
        }
    }, dn.prototype.segmentFraction = function(t) {
        var e = this.projectionFactor(t);
        return e < 0 ? e = 0 : (e > 1 || v.isNaN(e)) && (e = 1), e;
    }, dn.prototype.toString = function() {
        return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
    }, dn.prototype.isHorizontal = function() {
        return this.p0.y === this.p1.y;
    }, dn.prototype.distance = function() {
        if (arguments[0] instanceof dn) {
            var t = arguments[0];
            return at.distanceLineLine(this.p0, this.p1, t.p0, t.p1);
        }
        if (arguments[0] instanceof C) {
            var e = arguments[0];
            return at.distancePointLine(e, this.p0, this.p1);
        }
    }, dn.prototype.pointAlong = function(t) {
        var e = new C;
        return e.x = this.p0.x + t * (this.p1.x - this.p0.x), e.y = this.p0.y + t * (this.p1.y - this.p0.y), e;
    }, dn.prototype.hashCode = function() {
        var t = v.doubleToLongBits(this.p0.x);
        t ^= 31 * v.doubleToLongBits(this.p0.y);
        var e = Math.trunc(t) ^ Math.trunc(t >> 32), n = v.doubleToLongBits(this.p1.x);
        n ^= 31 * v.doubleToLongBits(this.p1.y);
        return e ^ (Math.trunc(n) ^ Math.trunc(n >> 32));
    }, dn.prototype.interfaces_ = function() {
        return [
            E,
            e
        ];
    }, dn.prototype.getClass = function() {
        return dn;
    }, dn.midPoint = function(t, e) {
        return new C((t.x + e.x) / 2, (t.y + e.y) / 2);
    }, yn.serialVersionUID.get = function() {
        return 0x2d2172135f411c00;
    }, Object.defineProperties(dn, yn);
    var _n = function() {
        this.tempEnv1 = new j, this.tempEnv2 = new j, this._overlapSeg1 = new dn, this._overlapSeg2 = new dn;
    };
    _n.prototype.overlap = function() {
        if (2 === arguments.length) ;
        else if (4 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2], i = arguments[3];
            t.getLineSegment(e, this._overlapSeg1), n.getLineSegment(i, this._overlapSeg2), this.overlap(this._overlapSeg1, this._overlapSeg2);
        }
    }, _n.prototype.interfaces_ = function() {
        return [];
    }, _n.prototype.getClass = function() {
        return _n;
    };
    var mn = function() {
        this._pts = null, this._start = null, this._end = null, this._env = null, this._context = null, this._id = null;
        var t = arguments[0], e = arguments[1], n = arguments[2], i = arguments[3];
        this._pts = t, this._start = e, this._end = n, this._context = i;
    };
    mn.prototype.getLineSegment = function(t, e) {
        e.p0 = this._pts[t], e.p1 = this._pts[t + 1];
    }, mn.prototype.computeSelect = function(t, e, n, i) {
        var r = this._pts[e], o = this._pts[n];
        if (i.tempEnv1.init(r, o), n - e == 1) return i.select(this, e), null;
        if (!t.intersects(i.tempEnv1)) return null;
        var s = Math.trunc((e + n) / 2);
        e < s && this.computeSelect(t, e, s, i), s < n && this.computeSelect(t, s, n, i);
    }, mn.prototype.getCoordinates = function() {
        for(var t = new Array(this._end - this._start + 1).fill(null), e = 0, n = this._start; n <= this._end; n++)t[e++] = this._pts[n];
        return t;
    }, mn.prototype.computeOverlaps = function(t, e) {
        this.computeOverlapsInternal(this._start, this._end, t, t._start, t._end, e);
    }, mn.prototype.setId = function(t) {
        this._id = t;
    }, mn.prototype.select = function(t, e) {
        this.computeSelect(t, this._start, this._end, e);
    }, mn.prototype.getEnvelope = function() {
        if (null === this._env) {
            var t = this._pts[this._start], e = this._pts[this._end];
            this._env = new j(t, e);
        }
        return this._env;
    }, mn.prototype.getEndIndex = function() {
        return this._end;
    }, mn.prototype.getStartIndex = function() {
        return this._start;
    }, mn.prototype.getContext = function() {
        return this._context;
    }, mn.prototype.getId = function() {
        return this._id;
    }, mn.prototype.computeOverlapsInternal = function(t, e, n, i, r, o) {
        var s = this._pts[t], a = this._pts[e], u = n._pts[i], l = n._pts[r];
        if (e - t == 1 && r - i == 1) return o.overlap(this, t, n, i), null;
        if (o.tempEnv1.init(s, a), o.tempEnv2.init(u, l), !o.tempEnv1.intersects(o.tempEnv2)) return null;
        var c = Math.trunc((t + e) / 2), p = Math.trunc((i + r) / 2);
        t < c && (i < p && this.computeOverlapsInternal(t, c, n, i, p, o), p < r && this.computeOverlapsInternal(t, c, n, p, r, o)), c < e && (i < p && this.computeOverlapsInternal(c, e, n, i, p, o), p < r && this.computeOverlapsInternal(c, e, n, p, r, o));
    }, mn.prototype.interfaces_ = function() {
        return [];
    }, mn.prototype.getClass = function() {
        return mn;
    };
    var vn = function() {};
    vn.prototype.interfaces_ = function() {
        return [];
    }, vn.prototype.getClass = function() {
        return vn;
    }, vn.getChainStartIndices = function(t) {
        var e = 0, n = new Nt;
        n.add(new M(e));
        do {
            var i = vn.findChainEnd(t, e);
            n.add(new M(i)), e = i;
        }while (e < t.length - 1);
        return vn.toIntArray(n);
    }, vn.findChainEnd = function(t, e) {
        for(var n = e; n < t.length - 1 && t[n].equals2D(t[n + 1]);)n++;
        if (n >= t.length - 1) return t.length - 1;
        for(var i = Be.quadrant(t[n], t[n + 1]), r = e + 1; r < t.length;){
            if (!t[r - 1].equals2D(t[r])) {
                if (Be.quadrant(t[r - 1], t[r]) !== i) break;
            }
            r++;
        }
        return r - 1;
    }, vn.getChains = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return vn.getChains(t, null);
        }
        if (2 === arguments.length) {
            for(var e = arguments[0], n = arguments[1], i = new Nt, r = vn.getChainStartIndices(e), o = 0; o < r.length - 1; o++){
                var s = new mn(e, r[o], r[o + 1], n);
                i.add(s);
            }
            return i;
        }
    }, vn.toIntArray = function(t) {
        for(var e = new Array(t.size()).fill(null), n = 0; n < e.length; n++)e[n] = t.get(n).intValue();
        return e;
    };
    var In = function() {};
    In.prototype.computeNodes = function(t) {}, In.prototype.getNodedSubstrings = function() {}, In.prototype.interfaces_ = function() {
        return [];
    }, In.prototype.getClass = function() {
        return In;
    };
    var En = function() {
        if (this._segInt = null, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this.setSegmentIntersector(t);
        }
    };
    En.prototype.setSegmentIntersector = function(t) {
        this._segInt = t;
    }, En.prototype.interfaces_ = function() {
        return [
            In
        ];
    }, En.prototype.getClass = function() {
        return En;
    };
    var xn = function(t) {
        function e(e) {
            e ? t.call(this, e) : t.call(this), this._monoChains = new Nt, this._index = new sn, this._idCounter = 0, this._nodedSegStrings = null, this._nOverlaps = 0;
        }
        t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
        var n = {
            SegmentOverlapAction: {
                configurable: !0
            }
        };
        return e.prototype.getMonotoneChains = function() {
            return this._monoChains;
        }, e.prototype.getNodedSubstrings = function() {
            return gn.getNodedSubstrings(this._nodedSegStrings);
        }, e.prototype.getIndex = function() {
            return this._index;
        }, e.prototype.add = function(t) {
            for(var e = vn.getChains(t.getCoordinates(), t).iterator(); e.hasNext();){
                var n = e.next();
                n.setId(this._idCounter++), this._index.insert(n.getEnvelope(), n), this._monoChains.add(n);
            }
        }, e.prototype.computeNodes = function(t) {
            this._nodedSegStrings = t;
            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
            this.intersectChains();
        }, e.prototype.intersectChains = function() {
            for(var t = new Nn(this._segInt), e = this._monoChains.iterator(); e.hasNext();)for(var n = e.next(), i = this._index.query(n.getEnvelope()).iterator(); i.hasNext();){
                var r = i.next();
                if (r.getId() > n.getId() && (n.computeOverlaps(r, t), this._nOverlaps++), this._segInt.isDone()) return null;
            }
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, n.SegmentOverlapAction.get = function() {
            return Nn;
        }, Object.defineProperties(e, n), e;
    }(En), Nn = function(t) {
        function e() {
            t.call(this), this._si = null;
            var e = arguments[0];
            this._si = e;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.overlap = function() {
            if (4 !== arguments.length) return t.prototype.overlap.apply(this, arguments);
            var e = arguments[0], n = arguments[1], i = arguments[2], r = arguments[3], o = e.getContext(), s = i.getContext();
            this._si.processIntersections(o, n, s, r);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(_n), Cn = function t() {
        if (this._quadrantSegments = t.DEFAULT_QUADRANT_SEGMENTS, this._endCapStyle = t.CAP_ROUND, this._joinStyle = t.JOIN_ROUND, this._mitreLimit = t.DEFAULT_MITRE_LIMIT, this._isSingleSided = !1, this._simplifyFactor = t.DEFAULT_SIMPLIFY_FACTOR, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var e = arguments[0];
            this.setQuadrantSegments(e);
        } else if (2 === arguments.length) {
            var n = arguments[0], i = arguments[1];
            this.setQuadrantSegments(n), this.setEndCapStyle(i);
        } else if (4 === arguments.length) {
            var r = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3];
            this.setQuadrantSegments(r), this.setEndCapStyle(o), this.setJoinStyle(s), this.setMitreLimit(a);
        }
    }, Sn = {
        CAP_ROUND: {
            configurable: !0
        },
        CAP_FLAT: {
            configurable: !0
        },
        CAP_SQUARE: {
            configurable: !0
        },
        JOIN_ROUND: {
            configurable: !0
        },
        JOIN_MITRE: {
            configurable: !0
        },
        JOIN_BEVEL: {
            configurable: !0
        },
        DEFAULT_QUADRANT_SEGMENTS: {
            configurable: !0
        },
        DEFAULT_MITRE_LIMIT: {
            configurable: !0
        },
        DEFAULT_SIMPLIFY_FACTOR: {
            configurable: !0
        }
    };
    Cn.prototype.getEndCapStyle = function() {
        return this._endCapStyle;
    }, Cn.prototype.isSingleSided = function() {
        return this._isSingleSided;
    }, Cn.prototype.setQuadrantSegments = function(t) {
        this._quadrantSegments = t, 0 === this._quadrantSegments && (this._joinStyle = Cn.JOIN_BEVEL), this._quadrantSegments < 0 && (this._joinStyle = Cn.JOIN_MITRE, this._mitreLimit = Math.abs(this._quadrantSegments)), t <= 0 && (this._quadrantSegments = 1), this._joinStyle !== Cn.JOIN_ROUND && (this._quadrantSegments = Cn.DEFAULT_QUADRANT_SEGMENTS);
    }, Cn.prototype.getJoinStyle = function() {
        return this._joinStyle;
    }, Cn.prototype.setJoinStyle = function(t) {
        this._joinStyle = t;
    }, Cn.prototype.setSimplifyFactor = function(t) {
        this._simplifyFactor = t < 0 ? 0 : t;
    }, Cn.prototype.getSimplifyFactor = function() {
        return this._simplifyFactor;
    }, Cn.prototype.getQuadrantSegments = function() {
        return this._quadrantSegments;
    }, Cn.prototype.setEndCapStyle = function(t) {
        this._endCapStyle = t;
    }, Cn.prototype.getMitreLimit = function() {
        return this._mitreLimit;
    }, Cn.prototype.setMitreLimit = function(t) {
        this._mitreLimit = t;
    }, Cn.prototype.setSingleSided = function(t) {
        this._isSingleSided = t;
    }, Cn.prototype.interfaces_ = function() {
        return [];
    }, Cn.prototype.getClass = function() {
        return Cn;
    }, Cn.bufferDistanceError = function(t) {
        var e = Math.PI / 2 / t;
        return 1 - Math.cos(e / 2);
    }, Sn.CAP_ROUND.get = function() {
        return 1;
    }, Sn.CAP_FLAT.get = function() {
        return 2;
    }, Sn.CAP_SQUARE.get = function() {
        return 3;
    }, Sn.JOIN_ROUND.get = function() {
        return 1;
    }, Sn.JOIN_MITRE.get = function() {
        return 2;
    }, Sn.JOIN_BEVEL.get = function() {
        return 3;
    }, Sn.DEFAULT_QUADRANT_SEGMENTS.get = function() {
        return 8;
    }, Sn.DEFAULT_MITRE_LIMIT.get = function() {
        return 5;
    }, Sn.DEFAULT_SIMPLIFY_FACTOR.get = function() {
        return .01;
    }, Object.defineProperties(Cn, Sn);
    var Ln = function(t) {
        this._distanceTol = null, this._isDeleted = null, this._angleOrientation = at.COUNTERCLOCKWISE, this._inputLine = t || null;
    }, bn = {
        INIT: {
            configurable: !0
        },
        DELETE: {
            configurable: !0
        },
        KEEP: {
            configurable: !0
        },
        NUM_PTS_TO_CHECK: {
            configurable: !0
        }
    };
    Ln.prototype.isDeletable = function(t, e, n, i) {
        var r = this._inputLine[t], o = this._inputLine[e], s = this._inputLine[n];
        return !!this.isConcave(r, o, s) && !!this.isShallow(r, o, s, i) && this.isShallowSampled(r, o, t, n, i);
    }, Ln.prototype.deleteShallowConcavities = function() {
        for(var t = 1, e = this.findNextNonDeletedIndex(t), n = this.findNextNonDeletedIndex(e), i = !1; n < this._inputLine.length;){
            var r = !1;
            this.isDeletable(t, e, n, this._distanceTol) && (this._isDeleted[e] = Ln.DELETE, r = !0, i = !0), t = r ? n : e, e = this.findNextNonDeletedIndex(t), n = this.findNextNonDeletedIndex(e);
        }
        return i;
    }, Ln.prototype.isShallowConcavity = function(t, e, n, i) {
        if (!(at.computeOrientation(t, e, n) === this._angleOrientation)) return !1;
        return at.distancePointLine(e, t, n) < i;
    }, Ln.prototype.isShallowSampled = function(t, e, n, i, r) {
        var o = Math.trunc((i - n) / Ln.NUM_PTS_TO_CHECK);
        o <= 0 && (o = 1);
        for(var s = n; s < i; s += o)if (!this.isShallow(t, e, this._inputLine[s], r)) return !1;
        return !0;
    }, Ln.prototype.isConcave = function(t, e, n) {
        var i = at.computeOrientation(t, e, n) === this._angleOrientation;
        return i;
    }, Ln.prototype.simplify = function(t) {
        this._distanceTol = Math.abs(t), t < 0 && (this._angleOrientation = at.CLOCKWISE), this._isDeleted = new Array(this._inputLine.length).fill(null);
        var e = !1;
        do e = this.deleteShallowConcavities();
        while (e);
        return this.collapseLine();
    }, Ln.prototype.findNextNonDeletedIndex = function(t) {
        for(var e = t + 1; e < this._inputLine.length && this._isDeleted[e] === Ln.DELETE;)e++;
        return e;
    }, Ln.prototype.isShallow = function(t, e, n, i) {
        return at.distancePointLine(e, t, n) < i;
    }, Ln.prototype.collapseLine = function() {
        for(var t = new St, e = 0; e < this._inputLine.length; e++)this._isDeleted[e] !== Ln.DELETE && t.add(this._inputLine[e]);
        return t.toCoordinateArray();
    }, Ln.prototype.interfaces_ = function() {
        return [];
    }, Ln.prototype.getClass = function() {
        return Ln;
    }, Ln.simplify = function(t, e) {
        return new Ln(t).simplify(e);
    }, bn.INIT.get = function() {
        return 0;
    }, bn.DELETE.get = function() {
        return 1;
    }, bn.KEEP.get = function() {
        return 1;
    }, bn.NUM_PTS_TO_CHECK.get = function() {
        return 10;
    }, Object.defineProperties(Ln, bn);
    var wn = function() {
        this._ptList = null, this._precisionModel = null, this._minimimVertexDistance = 0, this._ptList = new Nt;
    }, On = {
        COORDINATE_ARRAY_TYPE: {
            configurable: !0
        }
    };
    wn.prototype.getCoordinates = function() {
        return this._ptList.toArray(wn.COORDINATE_ARRAY_TYPE);
    }, wn.prototype.setPrecisionModel = function(t) {
        this._precisionModel = t;
    }, wn.prototype.addPt = function(t) {
        var e = new C(t);
        if (this._precisionModel.makePrecise(e), this.isRedundant(e)) return null;
        this._ptList.add(e);
    }, wn.prototype.revere = function() {}, wn.prototype.addPts = function(t, e) {
        if (e) for(var n = 0; n < t.length; n++)this.addPt(t[n]);
        else for(var i = t.length - 1; i >= 0; i--)this.addPt(t[i]);
    }, wn.prototype.isRedundant = function(t) {
        if (this._ptList.size() < 1) return !1;
        var e = this._ptList.get(this._ptList.size() - 1);
        return t.distance(e) < this._minimimVertexDistance;
    }, wn.prototype.toString = function() {
        return (new _e).createLineString(this.getCoordinates()).toString();
    }, wn.prototype.closeRing = function() {
        if (this._ptList.size() < 1) return null;
        var t = new C(this._ptList.get(0)), e = this._ptList.get(this._ptList.size() - 1);
        if (t.equals(e)) return null;
        this._ptList.add(t);
    }, wn.prototype.setMinimumVertexDistance = function(t) {
        this._minimimVertexDistance = t;
    }, wn.prototype.interfaces_ = function() {
        return [];
    }, wn.prototype.getClass = function() {
        return wn;
    }, On.COORDINATE_ARRAY_TYPE.get = function() {
        return new Array(0).fill(null);
    }, Object.defineProperties(wn, On);
    var Tn = function() {}, Rn = {
        PI_TIMES_2: {
            configurable: !0
        },
        PI_OVER_2: {
            configurable: !0
        },
        PI_OVER_4: {
            configurable: !0
        },
        COUNTERCLOCKWISE: {
            configurable: !0
        },
        CLOCKWISE: {
            configurable: !0
        },
        NONE: {
            configurable: !0
        }
    };
    Tn.prototype.interfaces_ = function() {
        return [];
    }, Tn.prototype.getClass = function() {
        return Tn;
    }, Tn.toDegrees = function(t) {
        return 180 * t / Math.PI;
    }, Tn.normalize = function(t) {
        for(; t > Math.PI;)t -= Tn.PI_TIMES_2;
        for(; t <= -Math.PI;)t += Tn.PI_TIMES_2;
        return t;
    }, Tn.angle = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Math.atan2(t.y, t.x);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = n.x - e.x, r = n.y - e.y;
            return Math.atan2(r, i);
        }
    }, Tn.isAcute = function(t, e, n) {
        var i = t.x - e.x, r = t.y - e.y;
        return i * (n.x - e.x) + r * (n.y - e.y) > 0;
    }, Tn.isObtuse = function(t, e, n) {
        var i = t.x - e.x, r = t.y - e.y;
        return i * (n.x - e.x) + r * (n.y - e.y) < 0;
    }, Tn.interiorAngle = function(t, e, n) {
        var i = Tn.angle(e, t), r = Tn.angle(e, n);
        return Math.abs(r - i);
    }, Tn.normalizePositive = function(t) {
        if (t < 0) {
            for(; t < 0;)t += Tn.PI_TIMES_2;
            t >= Tn.PI_TIMES_2 && (t = 0);
        } else {
            for(; t >= Tn.PI_TIMES_2;)t -= Tn.PI_TIMES_2;
            t < 0 && (t = 0);
        }
        return t;
    }, Tn.angleBetween = function(t, e, n) {
        var i = Tn.angle(e, t), r = Tn.angle(e, n);
        return Tn.diff(i, r);
    }, Tn.diff = function(t, e) {
        var n = null;
        return (n = t < e ? e - t : t - e) > Math.PI && (n = 2 * Math.PI - n), n;
    }, Tn.toRadians = function(t) {
        return t * Math.PI / 180;
    }, Tn.getTurn = function(t, e) {
        var n = Math.sin(e - t);
        return n > 0 ? Tn.COUNTERCLOCKWISE : n < 0 ? Tn.CLOCKWISE : Tn.NONE;
    }, Tn.angleBetweenOriented = function(t, e, n) {
        var i = Tn.angle(e, t), r = Tn.angle(e, n) - i;
        return r <= -Math.PI ? r + Tn.PI_TIMES_2 : r > Math.PI ? r - Tn.PI_TIMES_2 : r;
    }, Rn.PI_TIMES_2.get = function() {
        return 2 * Math.PI;
    }, Rn.PI_OVER_2.get = function() {
        return Math.PI / 2;
    }, Rn.PI_OVER_4.get = function() {
        return Math.PI / 4;
    }, Rn.COUNTERCLOCKWISE.get = function() {
        return at.COUNTERCLOCKWISE;
    }, Rn.CLOCKWISE.get = function() {
        return at.CLOCKWISE;
    }, Rn.NONE.get = function() {
        return at.COLLINEAR;
    }, Object.defineProperties(Tn, Rn);
    var Pn = function t() {
        this._maxCurveSegmentError = 0, this._filletAngleQuantum = null, this._closingSegLengthFactor = 1, this._segList = null, this._distance = 0, this._precisionModel = null, this._bufParams = null, this._li = null, this._s0 = null, this._s1 = null, this._s2 = null, this._seg0 = new dn, this._seg1 = new dn, this._offset0 = new dn, this._offset1 = new dn, this._side = 0, this._hasNarrowConcaveAngle = !1;
        var e = arguments[0], n = arguments[1], i = arguments[2];
        this._precisionModel = e, this._bufParams = n, this._li = new rt, this._filletAngleQuantum = Math.PI / 2 / n.getQuadrantSegments(), n.getQuadrantSegments() >= 8 && n.getJoinStyle() === Cn.JOIN_ROUND && (this._closingSegLengthFactor = t.MAX_CLOSING_SEG_LEN_FACTOR), this.init(i);
    }, Dn = {
        OFFSET_SEGMENT_SEPARATION_FACTOR: {
            configurable: !0
        },
        INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR: {
            configurable: !0
        },
        CURVE_VERTEX_SNAP_DISTANCE_FACTOR: {
            configurable: !0
        },
        MAX_CLOSING_SEG_LEN_FACTOR: {
            configurable: !0
        }
    };
    Pn.prototype.addNextSegment = function(t, e) {
        if (this._s0 = this._s1, this._s1 = this._s2, this._s2 = t, this._seg0.setCoordinates(this._s0, this._s1), this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0), this._seg1.setCoordinates(this._s1, this._s2), this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1), this._s1.equals(this._s2)) return null;
        var n = at.computeOrientation(this._s0, this._s1, this._s2), i = n === at.CLOCKWISE && this._side === Se.LEFT || n === at.COUNTERCLOCKWISE && this._side === Se.RIGHT;
        0 === n ? this.addCollinear(e) : i ? this.addOutsideTurn(n, e) : this.addInsideTurn(n, e);
    }, Pn.prototype.addLineEndCap = function(t, e) {
        var n = new dn(t, e), i = new dn;
        this.computeOffsetSegment(n, Se.LEFT, this._distance, i);
        var r = new dn;
        this.computeOffsetSegment(n, Se.RIGHT, this._distance, r);
        var o = e.x - t.x, s = e.y - t.y, a = Math.atan2(s, o);
        switch(this._bufParams.getEndCapStyle()){
            case Cn.CAP_ROUND:
                this._segList.addPt(i.p1), this.addFilletArc(e, a + Math.PI / 2, a - Math.PI / 2, at.CLOCKWISE, this._distance), this._segList.addPt(r.p1);
                break;
            case Cn.CAP_FLAT:
                this._segList.addPt(i.p1), this._segList.addPt(r.p1);
                break;
            case Cn.CAP_SQUARE:
                var u = new C;
                u.x = Math.abs(this._distance) * Math.cos(a), u.y = Math.abs(this._distance) * Math.sin(a);
                var l = new C(i.p1.x + u.x, i.p1.y + u.y), c = new C(r.p1.x + u.x, r.p1.y + u.y);
                this._segList.addPt(l), this._segList.addPt(c);
        }
    }, Pn.prototype.getCoordinates = function() {
        return this._segList.getCoordinates();
    }, Pn.prototype.addMitreJoin = function(t, e, n, i) {
        var r = !0, o = null;
        try {
            o = k.intersection(e.p0, e.p1, n.p0, n.p1);
            (i <= 0 ? 1 : o.distance(t) / Math.abs(i)) > this._bufParams.getMitreLimit() && (r = !1);
        } catch (t) {
            if (!(t instanceof X)) throw t;
            o = new C(0, 0), r = !1;
        }
        r ? this._segList.addPt(o) : this.addLimitedMitreJoin(e, n, i, this._bufParams.getMitreLimit());
    }, Pn.prototype.addFilletCorner = function(t, e, n, i, r) {
        var o = e.x - t.x, s = e.y - t.y, a = Math.atan2(s, o), u = n.x - t.x, l = n.y - t.y, c = Math.atan2(l, u);
        i === at.CLOCKWISE ? a <= c && (a += 2 * Math.PI) : a >= c && (a -= 2 * Math.PI), this._segList.addPt(e), this.addFilletArc(t, a, c, i, r), this._segList.addPt(n);
    }, Pn.prototype.addOutsideTurn = function(t, e) {
        if (this._offset0.p1.distance(this._offset1.p0) < this._distance * Pn.OFFSET_SEGMENT_SEPARATION_FACTOR) return this._segList.addPt(this._offset0.p1), null;
        this._bufParams.getJoinStyle() === Cn.JOIN_MITRE ? this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance) : this._bufParams.getJoinStyle() === Cn.JOIN_BEVEL ? this.addBevelJoin(this._offset0, this._offset1) : (e && this._segList.addPt(this._offset0.p1), this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, t, this._distance), this._segList.addPt(this._offset1.p0));
    }, Pn.prototype.createSquare = function(t) {
        this._segList.addPt(new C(t.x + this._distance, t.y + this._distance)), this._segList.addPt(new C(t.x + this._distance, t.y - this._distance)), this._segList.addPt(new C(t.x - this._distance, t.y - this._distance)), this._segList.addPt(new C(t.x - this._distance, t.y + this._distance)), this._segList.closeRing();
    }, Pn.prototype.addSegments = function(t, e) {
        this._segList.addPts(t, e);
    }, Pn.prototype.addFirstSegment = function() {
        this._segList.addPt(this._offset1.p0);
    }, Pn.prototype.addLastSegment = function() {
        this._segList.addPt(this._offset1.p1);
    }, Pn.prototype.initSideSegments = function(t, e, n) {
        this._s1 = t, this._s2 = e, this._side = n, this._seg1.setCoordinates(t, e), this.computeOffsetSegment(this._seg1, n, this._distance, this._offset1);
    }, Pn.prototype.addLimitedMitreJoin = function(t, e, n, i) {
        var r = this._seg0.p1, o = Tn.angle(r, this._seg0.p0), s = Tn.angleBetweenOriented(this._seg0.p0, r, this._seg1.p1) / 2, a = Tn.normalize(o + s), u = Tn.normalize(a + Math.PI), l = i * n, c = n - l * Math.abs(Math.sin(s)), p = r.x + l * Math.cos(u), h = r.y + l * Math.sin(u), f = new C(p, h), g = new dn(r, f), d = g.pointAlongOffset(1, c), y = g.pointAlongOffset(1, -c);
        this._side === Se.LEFT ? (this._segList.addPt(d), this._segList.addPt(y)) : (this._segList.addPt(y), this._segList.addPt(d));
    }, Pn.prototype.computeOffsetSegment = function(t, e, n, i) {
        var r = e === Se.LEFT ? 1 : -1, o = t.p1.x - t.p0.x, s = t.p1.y - t.p0.y, a = Math.sqrt(o * o + s * s), u = r * n * o / a, l = r * n * s / a;
        i.p0.x = t.p0.x - l, i.p0.y = t.p0.y + u, i.p1.x = t.p1.x - l, i.p1.y = t.p1.y + u;
    }, Pn.prototype.addFilletArc = function(t, e, n, i, r) {
        var o = i === at.CLOCKWISE ? -1 : 1, s = Math.abs(e - n), a = Math.trunc(s / this._filletAngleQuantum + .5);
        if (a < 1) return null;
        for(var u = s / a, l = 0, c = new C; l < s;){
            var p = e + o * l;
            c.x = t.x + r * Math.cos(p), c.y = t.y + r * Math.sin(p), this._segList.addPt(c), l += u;
        }
    }, Pn.prototype.addInsideTurn = function(t, e) {
        if (this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1), this._li.hasIntersection()) this._segList.addPt(this._li.getIntersection(0));
        else if (this._hasNarrowConcaveAngle = !0, this._offset0.p1.distance(this._offset1.p0) < this._distance * Pn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR) this._segList.addPt(this._offset0.p1);
        else {
            if (this._segList.addPt(this._offset0.p1), this._closingSegLengthFactor > 0) {
                var n = new C((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                this._segList.addPt(n);
                var i = new C((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                this._segList.addPt(i);
            } else this._segList.addPt(this._s1);
            this._segList.addPt(this._offset1.p0);
        }
    }, Pn.prototype.createCircle = function(t) {
        var e = new C(t.x + this._distance, t.y);
        this._segList.addPt(e), this.addFilletArc(t, 0, 2 * Math.PI, -1, this._distance), this._segList.closeRing();
    }, Pn.prototype.addBevelJoin = function(t, e) {
        this._segList.addPt(t.p1), this._segList.addPt(e.p0);
    }, Pn.prototype.init = function(t) {
        this._distance = t, this._maxCurveSegmentError = t * (1 - Math.cos(this._filletAngleQuantum / 2)), this._segList = new wn, this._segList.setPrecisionModel(this._precisionModel), this._segList.setMinimumVertexDistance(t * Pn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
    }, Pn.prototype.addCollinear = function(t) {
        this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2);
        this._li.getIntersectionNum() >= 2 && (this._bufParams.getJoinStyle() === Cn.JOIN_BEVEL || this._bufParams.getJoinStyle() === Cn.JOIN_MITRE ? (t && this._segList.addPt(this._offset0.p1), this._segList.addPt(this._offset1.p0)) : this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, at.CLOCKWISE, this._distance));
    }, Pn.prototype.closeRing = function() {
        this._segList.closeRing();
    }, Pn.prototype.hasNarrowConcaveAngle = function() {
        return this._hasNarrowConcaveAngle;
    }, Pn.prototype.interfaces_ = function() {
        return [];
    }, Pn.prototype.getClass = function() {
        return Pn;
    }, Dn.OFFSET_SEGMENT_SEPARATION_FACTOR.get = function() {
        return .001;
    }, Dn.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
        return .001;
    }, Dn.CURVE_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
        return 1e-6;
    }, Dn.MAX_CLOSING_SEG_LEN_FACTOR.get = function() {
        return 80;
    }, Object.defineProperties(Pn, Dn);
    var Mn = function() {
        this._distance = 0, this._precisionModel = null, this._bufParams = null;
        var t = arguments[0], e = arguments[1];
        this._precisionModel = t, this._bufParams = e;
    };
    Mn.prototype.getOffsetCurve = function(t, e) {
        if (this._distance = e, 0 === e) return null;
        var n = e < 0, i = Math.abs(e), r = this.getSegGen(i);
        t.length <= 1 ? this.computePointCurve(t[0], r) : this.computeOffsetCurve(t, n, r);
        var o = r.getCoordinates();
        return n && Lt.reverse(o), o;
    }, Mn.prototype.computeSingleSidedBufferCurve = function(t, e, n) {
        var i = this.simplifyTolerance(this._distance);
        if (e) {
            n.addSegments(t, !0);
            var r = Ln.simplify(t, -i), o = r.length - 1;
            n.initSideSegments(r[o], r[o - 1], Se.LEFT), n.addFirstSegment();
            for(var s = o - 2; s >= 0; s--)n.addNextSegment(r[s], !0);
        } else {
            n.addSegments(t, !1);
            var a = Ln.simplify(t, i), u = a.length - 1;
            n.initSideSegments(a[0], a[1], Se.LEFT), n.addFirstSegment();
            for(var l = 2; l <= u; l++)n.addNextSegment(a[l], !0);
        }
        n.addLastSegment(), n.closeRing();
    }, Mn.prototype.computeRingBufferCurve = function(t, e, n) {
        var i = this.simplifyTolerance(this._distance);
        e === Se.RIGHT && (i = -i);
        var r = Ln.simplify(t, i), o = r.length - 1;
        n.initSideSegments(r[o - 1], r[0], e);
        for(var s = 1; s <= o; s++){
            var a = 1 !== s;
            n.addNextSegment(r[s], a);
        }
        n.closeRing();
    }, Mn.prototype.computeLineBufferCurve = function(t, e) {
        var n = this.simplifyTolerance(this._distance), i = Ln.simplify(t, n), r = i.length - 1;
        e.initSideSegments(i[0], i[1], Se.LEFT);
        for(var o = 2; o <= r; o++)e.addNextSegment(i[o], !0);
        e.addLastSegment(), e.addLineEndCap(i[r - 1], i[r]);
        var s = Ln.simplify(t, -n), a = s.length - 1;
        e.initSideSegments(s[a], s[a - 1], Se.LEFT);
        for(var u = a - 2; u >= 0; u--)e.addNextSegment(s[u], !0);
        e.addLastSegment(), e.addLineEndCap(s[1], s[0]), e.closeRing();
    }, Mn.prototype.computePointCurve = function(t, e) {
        switch(this._bufParams.getEndCapStyle()){
            case Cn.CAP_ROUND:
                e.createCircle(t);
                break;
            case Cn.CAP_SQUARE:
                e.createSquare(t);
        }
    }, Mn.prototype.getLineCurve = function(t, e) {
        if (this._distance = e, e < 0 && !this._bufParams.isSingleSided()) return null;
        if (0 === e) return null;
        var n = Math.abs(e), i = this.getSegGen(n);
        if (t.length <= 1) this.computePointCurve(t[0], i);
        else if (this._bufParams.isSingleSided()) {
            var r = e < 0;
            this.computeSingleSidedBufferCurve(t, r, i);
        } else this.computeLineBufferCurve(t, i);
        return i.getCoordinates();
    }, Mn.prototype.getBufferParameters = function() {
        return this._bufParams;
    }, Mn.prototype.simplifyTolerance = function(t) {
        return t * this._bufParams.getSimplifyFactor();
    }, Mn.prototype.getRingCurve = function(t, e, n) {
        if (this._distance = n, t.length <= 2) return this.getLineCurve(t, n);
        if (0 === n) return Mn.copyCoordinates(t);
        var i = this.getSegGen(n);
        return this.computeRingBufferCurve(t, e, i), i.getCoordinates();
    }, Mn.prototype.computeOffsetCurve = function(t, e, n) {
        var i = this.simplifyTolerance(this._distance);
        if (e) {
            var r = Ln.simplify(t, -i), o = r.length - 1;
            n.initSideSegments(r[o], r[o - 1], Se.LEFT), n.addFirstSegment();
            for(var s = o - 2; s >= 0; s--)n.addNextSegment(r[s], !0);
        } else {
            var a = Ln.simplify(t, i), u = a.length - 1;
            n.initSideSegments(a[0], a[1], Se.LEFT), n.addFirstSegment();
            for(var l = 2; l <= u; l++)n.addNextSegment(a[l], !0);
        }
        n.addLastSegment();
    }, Mn.prototype.getSegGen = function(t) {
        return new Pn(this._precisionModel, this._bufParams, t);
    }, Mn.prototype.interfaces_ = function() {
        return [];
    }, Mn.prototype.getClass = function() {
        return Mn;
    }, Mn.copyCoordinates = function(t) {
        for(var e = new Array(t.length).fill(null), n = 0; n < e.length; n++)e[n] = new C(t[n]);
        return e;
    };
    var An = function() {
        this._subgraphs = null, this._seg = new dn, this._cga = new at;
        var t = arguments[0];
        this._subgraphs = t;
    }, Fn = {
        DepthSegment: {
            configurable: !0
        }
    };
    An.prototype.findStabbedSegments = function() {
        if (1 === arguments.length) {
            for(var t = arguments[0], e = new Nt, n = this._subgraphs.iterator(); n.hasNext();){
                var i = n.next(), r = i.getEnvelope();
                t.y < r.getMinY() || t.y > r.getMaxY() || this.findStabbedSegments(t, i.getDirectedEdges(), e);
            }
            return e;
        }
        if (3 === arguments.length) {
            if (T(arguments[2], xt) && arguments[0] instanceof C && arguments[1] instanceof ze) for(var o = arguments[0], s = arguments[1], a = arguments[2], u = s.getEdge().getCoordinates(), l = 0; l < u.length - 1; l++){
                this._seg.p0 = u[l], this._seg.p1 = u[l + 1], this._seg.p0.y > this._seg.p1.y && this._seg.reverse();
                if (!(Math.max(this._seg.p0.x, this._seg.p1.x) < o.x) && !(this._seg.isHorizontal() || o.y < this._seg.p0.y || o.y > this._seg.p1.y || at.computeOrientation(this._seg.p0, this._seg.p1, o) === at.RIGHT)) {
                    var c = s.getDepth(Se.LEFT);
                    this._seg.p0.equals(u[l]) || (c = s.getDepth(Se.RIGHT));
                    var p = new Gn(this._seg, c);
                    a.add(p);
                }
            }
            else if (T(arguments[2], xt) && arguments[0] instanceof C && T(arguments[1], xt)) for(var h = arguments[0], f = arguments[1], g = arguments[2], d = f.iterator(); d.hasNext();){
                var y = d.next();
                y.isForward() && this.findStabbedSegments(h, y, g);
            }
        }
    }, An.prototype.getDepth = function(t) {
        var e = this.findStabbedSegments(t);
        if (0 === e.size()) return 0;
        return $e.min(e)._leftDepth;
    }, An.prototype.interfaces_ = function() {
        return [];
    }, An.prototype.getClass = function() {
        return An;
    }, Fn.DepthSegment.get = function() {
        return Gn;
    }, Object.defineProperties(An, Fn);
    var Gn = function() {
        this._upwardSeg = null, this._leftDepth = null;
        var t = arguments[0], e = arguments[1];
        this._upwardSeg = new dn(t), this._leftDepth = e;
    };
    Gn.prototype.compareTo = function(t) {
        var e = t;
        if (this._upwardSeg.minX() >= e._upwardSeg.maxX()) return 1;
        if (this._upwardSeg.maxX() <= e._upwardSeg.minX()) return -1;
        var n = this._upwardSeg.orientationIndex(e._upwardSeg);
        return 0 !== n ? n : 0 != (n = -1 * e._upwardSeg.orientationIndex(this._upwardSeg)) ? n : this._upwardSeg.compareTo(e._upwardSeg);
    }, Gn.prototype.compareX = function(t, e) {
        var n = t.p0.compareTo(e.p0);
        return 0 !== n ? n : t.p1.compareTo(e.p1);
    }, Gn.prototype.toString = function() {
        return this._upwardSeg.toString();
    }, Gn.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, Gn.prototype.getClass = function() {
        return Gn;
    };
    var qn = function(t, e, n) {
        this.p0 = t || null, this.p1 = e || null, this.p2 = n || null;
    };
    qn.prototype.area = function() {
        return qn.area(this.p0, this.p1, this.p2);
    }, qn.prototype.signedArea = function() {
        return qn.signedArea(this.p0, this.p1, this.p2);
    }, qn.prototype.interpolateZ = function(t) {
        if (null === t) throw new m("Supplied point is null.");
        return qn.interpolateZ(t, this.p0, this.p1, this.p2);
    }, qn.prototype.longestSideLength = function() {
        return qn.longestSideLength(this.p0, this.p1, this.p2);
    }, qn.prototype.isAcute = function() {
        return qn.isAcute(this.p0, this.p1, this.p2);
    }, qn.prototype.circumcentre = function() {
        return qn.circumcentre(this.p0, this.p1, this.p2);
    }, qn.prototype.area3D = function() {
        return qn.area3D(this.p0, this.p1, this.p2);
    }, qn.prototype.centroid = function() {
        return qn.centroid(this.p0, this.p1, this.p2);
    }, qn.prototype.inCentre = function() {
        return qn.inCentre(this.p0, this.p1, this.p2);
    }, qn.prototype.interfaces_ = function() {
        return [];
    }, qn.prototype.getClass = function() {
        return qn;
    }, qn.area = function(t, e, n) {
        return Math.abs(((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2);
    }, qn.signedArea = function(t, e, n) {
        return ((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2;
    }, qn.det = function(t, e, n, i) {
        return t * i - e * n;
    }, qn.interpolateZ = function(t, e, n, i) {
        var r = e.x, o = e.y, s = n.x - r, a = i.x - r, u = n.y - o, l = i.y - o, c = s * l - a * u, p = t.x - r, h = t.y - o, f = (l * p - a * h) / c, g = (-u * p + s * h) / c;
        return e.z + f * (n.z - e.z) + g * (i.z - e.z);
    }, qn.longestSideLength = function(t, e, n) {
        var i = t.distance(e), r = e.distance(n), o = n.distance(t), s = i;
        return r > s && (s = r), o > s && (s = o), s;
    }, qn.isAcute = function(t, e, n) {
        return !!Tn.isAcute(t, e, n) && !!Tn.isAcute(e, n, t) && !!Tn.isAcute(n, t, e);
    }, qn.circumcentre = function(t, e, n) {
        var i = n.x, r = n.y, o = t.x - i, s = t.y - r, a = e.x - i, u = e.y - r, l = 2 * qn.det(o, s, a, u), c = qn.det(s, o * o + s * s, u, a * a + u * u), p = qn.det(o, o * o + s * s, a, a * a + u * u);
        return new C(i - c / l, r + p / l);
    }, qn.perpendicularBisector = function(t, e) {
        var n = e.x - t.x, i = e.y - t.y, r = new k(t.x + n / 2, t.y + i / 2, 1), o = new k(t.x - i + n / 2, t.y + n + i / 2, 1);
        return new k(r, o);
    }, qn.angleBisector = function(t, e, n) {
        var i = e.distance(t), r = i / (i + e.distance(n)), o = n.x - t.x, s = n.y - t.y;
        return new C(t.x + r * o, t.y + r * s);
    }, qn.area3D = function(t, e, n) {
        var i = e.x - t.x, r = e.y - t.y, o = e.z - t.z, s = n.x - t.x, a = n.y - t.y, u = n.z - t.z, l = r * u - o * a, c = o * s - i * u, p = i * a - r * s, h = l * l + c * c + p * p, f = Math.sqrt(h) / 2;
        return f;
    }, qn.centroid = function(t, e, n) {
        var i = (t.x + e.x + n.x) / 3, r = (t.y + e.y + n.y) / 3;
        return new C(i, r);
    }, qn.inCentre = function(t, e, n) {
        var i = e.distance(n), r = t.distance(n), o = t.distance(e), s = i + r + o, a = (i * t.x + r * e.x + o * n.x) / s, u = (i * t.y + r * e.y + o * n.y) / s;
        return new C(a, u);
    };
    var Bn = function() {
        this._inputGeom = null, this._distance = null, this._curveBuilder = null, this._curveList = new Nt;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._inputGeom = t, this._distance = e, this._curveBuilder = n;
    };
    Bn.prototype.addPoint = function(t) {
        if (this._distance <= 0) return null;
        var e = t.getCoordinates(), n = this._curveBuilder.getLineCurve(e, this._distance);
        this.addCurve(n, w.EXTERIOR, w.INTERIOR);
    }, Bn.prototype.addPolygon = function(t) {
        var e = this._distance, n = Se.LEFT;
        this._distance < 0 && (e = -this._distance, n = Se.RIGHT);
        var i = t.getExteriorRing(), r = Lt.removeRepeatedPoints(i.getCoordinates());
        if (this._distance < 0 && this.isErodedCompletely(i, this._distance)) return null;
        if (this._distance <= 0 && r.length < 3) return null;
        this.addPolygonRing(r, e, n, w.EXTERIOR, w.INTERIOR);
        for(var o = 0; o < t.getNumInteriorRing(); o++){
            var s = t.getInteriorRingN(o), a = Lt.removeRepeatedPoints(s.getCoordinates());
            this._distance > 0 && this.isErodedCompletely(s, -this._distance) || this.addPolygonRing(a, e, Se.opposite(n), w.INTERIOR, w.EXTERIOR);
        }
    }, Bn.prototype.isTriangleErodedCompletely = function(t, e) {
        var n = new qn(t[0], t[1], t[2]), i = n.inCentre();
        return at.distancePointLine(i, n.p0, n.p1) < Math.abs(e);
    }, Bn.prototype.addLineString = function(t) {
        if (this._distance <= 0 && !this._curveBuilder.getBufferParameters().isSingleSided()) return null;
        var e = Lt.removeRepeatedPoints(t.getCoordinates()), n = this._curveBuilder.getLineCurve(e, this._distance);
        this.addCurve(n, w.EXTERIOR, w.INTERIOR);
    }, Bn.prototype.addCurve = function(t, e, n) {
        if (null === t || t.length < 2) return null;
        var i = new gn(t, new Pe(0, w.BOUNDARY, e, n));
        this._curveList.add(i);
    }, Bn.prototype.getCurves = function() {
        return this.add(this._inputGeom), this._curveList;
    }, Bn.prototype.addPolygonRing = function(t, e, n, i, r) {
        if (0 === e && t.length < ee.MINIMUM_VALID_SIZE) return null;
        var o = i, s = r;
        t.length >= ee.MINIMUM_VALID_SIZE && at.isCCW(t) && (o = r, s = i, n = Se.opposite(n));
        var a = this._curveBuilder.getRingCurve(t, n, e);
        this.addCurve(a, o, s);
    }, Bn.prototype.add = function(t) {
        if (t.isEmpty()) return null;
        t instanceof $t ? this.addPolygon(t) : t instanceof Kt ? this.addLineString(t) : t instanceof Qt ? this.addPoint(t) : t instanceof te ? this.addCollection(t) : t instanceof Xt ? this.addCollection(t) : t instanceof ne ? this.addCollection(t) : t instanceof zt && this.addCollection(t);
    }, Bn.prototype.isErodedCompletely = function(t, e) {
        var n = t.getCoordinates();
        if (n.length < 4) return e < 0;
        if (4 === n.length) return this.isTriangleErodedCompletely(n, e);
        var i = t.getEnvelopeInternal(), r = Math.min(i.getHeight(), i.getWidth());
        return e < 0 && 2 * Math.abs(e) > r;
    }, Bn.prototype.addCollection = function(t) {
        for(var e = 0; e < t.getNumGeometries(); e++){
            var n = t.getGeometryN(e);
            this.add(n);
        }
    }, Bn.prototype.interfaces_ = function() {
        return [];
    }, Bn.prototype.getClass = function() {
        return Bn;
    };
    var Vn = function() {};
    Vn.prototype.locate = function(t) {}, Vn.prototype.interfaces_ = function() {
        return [];
    }, Vn.prototype.getClass = function() {
        return Vn;
    };
    var Un = function() {
        this._parent = null, this._atStart = null, this._max = null, this._index = null, this._subcollectionIterator = null;
        var t = arguments[0];
        this._parent = t, this._atStart = !0, this._index = 0, this._max = t.getNumGeometries();
    };
    Un.prototype.next = function() {
        if (this._atStart) return this._atStart = !1, Un.isAtomic(this._parent) && this._index++, this._parent;
        if (null !== this._subcollectionIterator) {
            if (this._subcollectionIterator.hasNext()) return this._subcollectionIterator.next();
            this._subcollectionIterator = null;
        }
        if (this._index >= this._max) throw new i;
        var t = this._parent.getGeometryN(this._index++);
        return t instanceof zt ? (this._subcollectionIterator = new Un(t), this._subcollectionIterator.next()) : t;
    }, Un.prototype.remove = function() {
        throw new Error(this.getClass().getName());
    }, Un.prototype.hasNext = function() {
        if (this._atStart) return !0;
        if (null !== this._subcollectionIterator) {
            if (this._subcollectionIterator.hasNext()) return !0;
            this._subcollectionIterator = null;
        }
        return !(this._index >= this._max);
    }, Un.prototype.interfaces_ = function() {
        return [
            Et
        ];
    }, Un.prototype.getClass = function() {
        return Un;
    }, Un.isAtomic = function(t) {
        return !(t instanceof zt);
    };
    var zn = function() {
        this._geom = null;
        var t = arguments[0];
        this._geom = t;
    };
    zn.prototype.locate = function(t) {
        return zn.locate(t, this._geom);
    }, zn.prototype.interfaces_ = function() {
        return [
            Vn
        ];
    }, zn.prototype.getClass = function() {
        return zn;
    }, zn.isPointInRing = function(t, e) {
        return !!e.getEnvelopeInternal().intersects(t) && at.isPointInRing(t, e.getCoordinates());
    }, zn.containsPointInPolygon = function(t, e) {
        if (e.isEmpty()) return !1;
        var n = e.getExteriorRing();
        if (!zn.isPointInRing(t, n)) return !1;
        for(var i = 0; i < e.getNumInteriorRing(); i++){
            var r = e.getInteriorRingN(i);
            if (zn.isPointInRing(t, r)) return !1;
        }
        return !0;
    }, zn.containsPoint = function(t, e) {
        if (e instanceof $t) return zn.containsPointInPolygon(t, e);
        if (e instanceof zt) for(var n = new Un(e); n.hasNext();){
            var i = n.next();
            if (i !== e && zn.containsPoint(t, i)) return !0;
        }
        return !1;
    }, zn.locate = function(t, e) {
        return e.isEmpty() ? w.EXTERIOR : zn.containsPoint(t, e) ? w.INTERIOR : w.EXTERIOR;
    };
    var Xn = function() {
        this._edgeMap = new p, this._edgeList = null, this._ptInAreaLocation = [
            w.NONE,
            w.NONE
        ];
    };
    Xn.prototype.getNextCW = function(t) {
        this.getEdges();
        var e = this._edgeList.indexOf(t), n = e - 1;
        return 0 === e && (n = this._edgeList.size() - 1), this._edgeList.get(n);
    }, Xn.prototype.propagateSideLabels = function(t) {
        for(var e = w.NONE, n = this.iterator(); n.hasNext();){
            var i = n.next().getLabel();
            i.isArea(t) && i.getLocation(t, Se.LEFT) !== w.NONE && (e = i.getLocation(t, Se.LEFT));
        }
        if (e === w.NONE) return null;
        for(var r = e, o = this.iterator(); o.hasNext();){
            var s = o.next(), a = s.getLabel();
            if (a.getLocation(t, Se.ON) === w.NONE && a.setLocation(t, Se.ON, r), a.isArea(t)) {
                var u = a.getLocation(t, Se.LEFT), l = a.getLocation(t, Se.RIGHT);
                if (l !== w.NONE) {
                    if (l !== r) throw new we("side location conflict", s.getCoordinate());
                    u === w.NONE && et.shouldNeverReachHere("found single null side (at " + s.getCoordinate() + ")"), r = u;
                } else et.isTrue(a.getLocation(t, Se.LEFT) === w.NONE, "found single null side"), a.setLocation(t, Se.RIGHT, r), a.setLocation(t, Se.LEFT, r);
            }
        }
    }, Xn.prototype.getCoordinate = function() {
        var t = this.iterator();
        if (!t.hasNext()) return null;
        return t.next().getCoordinate();
    }, Xn.prototype.print = function(t) {
        Y.out.println("EdgeEndStar:   " + this.getCoordinate());
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, Xn.prototype.isAreaLabelsConsistent = function(t) {
        return this.computeEdgeEndLabels(t.getBoundaryNodeRule()), this.checkAreaLabelsConsistent(0);
    }, Xn.prototype.checkAreaLabelsConsistent = function(t) {
        var e = this.getEdges();
        if (e.size() <= 0) return !0;
        var n = e.size() - 1, i = e.get(n).getLabel().getLocation(t, Se.LEFT);
        et.isTrue(i !== w.NONE, "Found unlabelled area edge");
        for(var r = i, o = this.iterator(); o.hasNext();){
            var s = o.next().getLabel();
            et.isTrue(s.isArea(t), "Found non-area edge");
            var a = s.getLocation(t, Se.LEFT), u = s.getLocation(t, Se.RIGHT);
            if (a === u) return !1;
            if (u !== r) return !1;
            r = a;
        }
        return !0;
    }, Xn.prototype.findIndex = function(t) {
        this.iterator();
        for(var e = 0; e < this._edgeList.size(); e++){
            if (this._edgeList.get(e) === t) return e;
        }
        return -1;
    }, Xn.prototype.iterator = function() {
        return this.getEdges().iterator();
    }, Xn.prototype.getEdges = function() {
        return null === this._edgeList && (this._edgeList = new Nt(this._edgeMap.values())), this._edgeList;
    }, Xn.prototype.getLocation = function(t, e, n) {
        return this._ptInAreaLocation[t] === w.NONE && (this._ptInAreaLocation[t] = zn.locate(e, n[t].getGeometry())), this._ptInAreaLocation[t];
    }, Xn.prototype.toString = function() {
        var t = new D;
        t.append("EdgeEndStar:   " + this.getCoordinate()), t.append("\n");
        for(var e = this.iterator(); e.hasNext();){
            var n = e.next();
            t.append(n), t.append("\n");
        }
        return t.toString();
    }, Xn.prototype.computeEdgeEndLabels = function(t) {
        for(var e = this.iterator(); e.hasNext();)e.next().computeLabel(t);
    }, Xn.prototype.computeLabelling = function(t) {
        this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()), this.propagateSideLabels(0), this.propagateSideLabels(1);
        for(var e = [
            !1,
            !1
        ], n = this.iterator(); n.hasNext();)for(var i = n.next().getLabel(), r = 0; r < 2; r++)i.isLine(r) && i.getLocation(r) === w.BOUNDARY && (e[r] = !0);
        for(var o = this.iterator(); o.hasNext();)for(var s = o.next(), a = s.getLabel(), u = 0; u < 2; u++)if (a.isAnyNull(u)) {
            var l = w.NONE;
            if (e[u]) l = w.EXTERIOR;
            else {
                var c = s.getCoordinate();
                l = this.getLocation(u, c, t);
            }
            a.setAllLocationsIfNull(u, l);
        }
    }, Xn.prototype.getDegree = function() {
        return this._edgeMap.size();
    }, Xn.prototype.insertEdgeEnd = function(t, e) {
        this._edgeMap.put(t, e), this._edgeList = null;
    }, Xn.prototype.interfaces_ = function() {
        return [];
    }, Xn.prototype.getClass = function() {
        return Xn;
    };
    var Yn = function(t) {
        function e() {
            t.call(this), this._resultAreaEdgeList = null, this._label = null, this._SCANNING_FOR_INCOMING = 1, this._LINKING_TO_OUTGOING = 2;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.linkResultDirectedEdges = function() {
            this.getResultAreaEdges();
            for(var t = null, e = null, n = this._SCANNING_FOR_INCOMING, i = 0; i < this._resultAreaEdgeList.size(); i++){
                var r = this._resultAreaEdgeList.get(i), o = r.getSym();
                if (r.getLabel().isArea()) switch(null === t && r.isInResult() && (t = r), n){
                    case this._SCANNING_FOR_INCOMING:
                        if (!o.isInResult()) continue;
                        e = o, n = this._LINKING_TO_OUTGOING;
                        break;
                    case this._LINKING_TO_OUTGOING:
                        if (!r.isInResult()) continue;
                        e.setNext(r), n = this._SCANNING_FOR_INCOMING;
                }
            }
            if (n === this._LINKING_TO_OUTGOING) {
                if (null === t) throw new we("no outgoing dirEdge found", this.getCoordinate());
                et.isTrue(t.isInResult(), "unable to link last incoming dirEdge"), e.setNext(t);
            }
        }, e.prototype.insert = function(t) {
            var e = t;
            this.insertEdgeEnd(e, e);
        }, e.prototype.getRightmostEdge = function() {
            var t = this.getEdges(), e = t.size();
            if (e < 1) return null;
            var n = t.get(0);
            if (1 === e) return n;
            var i = t.get(e - 1), r = n.getQuadrant(), o = i.getQuadrant();
            return Be.isNorthern(r) && Be.isNorthern(o) ? n : Be.isNorthern(r) || Be.isNorthern(o) ? 0 !== n.getDy() ? n : 0 !== i.getDy() ? i : (et.shouldNeverReachHere("found two horizontal edges incident on node"), null) : i;
        }, e.prototype.print = function(t) {
            Y.out.println("DirectedEdgeStar: " + this.getCoordinate());
            for(var e = this.iterator(); e.hasNext();){
                var n = e.next();
                t.print("out "), n.print(t), t.println(), t.print("in "), n.getSym().print(t), t.println();
            }
        }, e.prototype.getResultAreaEdges = function() {
            if (null !== this._resultAreaEdgeList) return this._resultAreaEdgeList;
            this._resultAreaEdgeList = new Nt;
            for(var t = this.iterator(); t.hasNext();){
                var e = t.next();
                (e.isInResult() || e.getSym().isInResult()) && this._resultAreaEdgeList.add(e);
            }
            return this._resultAreaEdgeList;
        }, e.prototype.updateLabelling = function(t) {
            for(var e = this.iterator(); e.hasNext();){
                var n = e.next().getLabel();
                n.setAllLocationsIfNull(0, t.getLocation(0)), n.setAllLocationsIfNull(1, t.getLocation(1));
            }
        }, e.prototype.linkAllDirectedEdges = function() {
            this.getEdges();
            for(var t = null, e = null, n = this._edgeList.size() - 1; n >= 0; n--){
                var i = this._edgeList.get(n), r = i.getSym();
                null === e && (e = r), null !== t && r.setNext(t), t = i;
            }
            e.setNext(t);
        }, e.prototype.computeDepths = function() {
            if (1 === arguments.length) {
                var t = arguments[0], e = this.findIndex(t), n = t.getDepth(Se.LEFT), i = t.getDepth(Se.RIGHT), r = this.computeDepths(e + 1, this._edgeList.size(), n);
                if (this.computeDepths(0, e, r) !== i) throw new we("depth mismatch at " + t.getCoordinate());
            } else if (3 === arguments.length) {
                for(var o = arguments[0], s = arguments[1], a = arguments[2], u = o; u < s; u++){
                    var l = this._edgeList.get(u);
                    l.setEdgeDepths(Se.RIGHT, a), a = l.getDepth(Se.LEFT);
                }
                return a;
            }
        }, e.prototype.mergeSymLabels = function() {
            for(var t = this.iterator(); t.hasNext();){
                var e = t.next();
                e.getLabel().merge(e.getSym().getLabel());
            }
        }, e.prototype.linkMinimalDirectedEdges = function(t) {
            for(var e = null, n = null, i = this._SCANNING_FOR_INCOMING, r = this._resultAreaEdgeList.size() - 1; r >= 0; r--){
                var o = this._resultAreaEdgeList.get(r), s = o.getSym();
                switch(null === e && o.getEdgeRing() === t && (e = o), i){
                    case this._SCANNING_FOR_INCOMING:
                        if (s.getEdgeRing() !== t) continue;
                        n = s, i = this._LINKING_TO_OUTGOING;
                        break;
                    case this._LINKING_TO_OUTGOING:
                        if (o.getEdgeRing() !== t) continue;
                        n.setNextMin(o), i = this._SCANNING_FOR_INCOMING;
                }
            }
            i === this._LINKING_TO_OUTGOING && (et.isTrue(null !== e, "found null for first outgoing dirEdge"), et.isTrue(e.getEdgeRing() === t, "unable to link last incoming dirEdge"), n.setNextMin(e));
        }, e.prototype.getOutgoingDegree = function() {
            if (0 === arguments.length) {
                for(var t = 0, e = this.iterator(); e.hasNext();)e.next().isInResult() && t++;
                return t;
            }
            if (1 === arguments.length) {
                for(var n = arguments[0], i = 0, r = this.iterator(); r.hasNext();)r.next().getEdgeRing() === n && i++;
                return i;
            }
        }, e.prototype.getLabel = function() {
            return this._label;
        }, e.prototype.findCoveredLineEdges = function() {
            for(var t = w.NONE, e = this.iterator(); e.hasNext();){
                var n = e.next(), i = n.getSym();
                if (!n.isLineEdge()) {
                    if (n.isInResult()) {
                        t = w.INTERIOR;
                        break;
                    }
                    if (i.isInResult()) {
                        t = w.EXTERIOR;
                        break;
                    }
                }
            }
            if (t === w.NONE) return null;
            for(var r = t, o = this.iterator(); o.hasNext();){
                var s = o.next(), a = s.getSym();
                s.isLineEdge() ? s.getEdge().setCovered(r === w.INTERIOR) : (s.isInResult() && (r = w.EXTERIOR), a.isInResult() && (r = w.INTERIOR));
            }
        }, e.prototype.computeLabelling = function(e) {
            t.prototype.computeLabelling.call(this, e), this._label = new Pe(w.NONE);
            for(var n = this.iterator(); n.hasNext();)for(var i = n.next().getEdge().getLabel(), r = 0; r < 2; r++){
                var o = i.getLocation(r);
                o !== w.INTERIOR && o !== w.BOUNDARY || this._label.setLocation(r, w.INTERIOR);
            }
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Xn), kn = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.createNode = function(t) {
            return new Ge(t, new Yn);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Xe), jn = function t() {
        this._pts = null, this._orientation = null;
        var e = arguments[0];
        this._pts = e, this._orientation = t.orientation(e);
    };
    jn.prototype.compareTo = function(t) {
        var e = t;
        return jn.compareOriented(this._pts, this._orientation, e._pts, e._orientation);
    }, jn.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, jn.prototype.getClass = function() {
        return jn;
    }, jn.orientation = function(t) {
        return 1 === Lt.increasingDirection(t);
    }, jn.compareOriented = function(t, e, n, i) {
        for(var r = e ? 1 : -1, o = i ? 1 : -1, s = e ? t.length : -1, a = i ? n.length : -1, u = e ? 0 : t.length - 1, l = i ? 0 : n.length - 1;;){
            var c = t[u].compareTo(n[l]);
            if (0 !== c) return c;
            var p = (u += r) === s, h = (l += o) === a;
            if (p && !h) return -1;
            if (!p && h) return 1;
            if (p && h) return 0;
        }
    };
    var Hn = function() {
        this._edges = new Nt, this._ocaMap = new p;
    };
    Hn.prototype.print = function(t) {
        t.print("MULTILINESTRING ( ");
        for(var e = 0; e < this._edges.size(); e++){
            var n = this._edges.get(e);
            e > 0 && t.print(","), t.print("(");
            for(var i = n.getCoordinates(), r = 0; r < i.length; r++)r > 0 && t.print(","), t.print(i[r].x + " " + i[r].y);
            t.println(")");
        }
        t.print(")  ");
    }, Hn.prototype.addAll = function(t) {
        for(var e = t.iterator(); e.hasNext();)this.add(e.next());
    }, Hn.prototype.findEdgeIndex = function(t) {
        for(var e = 0; e < this._edges.size(); e++)if (this._edges.get(e).equals(t)) return e;
        return -1;
    }, Hn.prototype.iterator = function() {
        return this._edges.iterator();
    }, Hn.prototype.getEdges = function() {
        return this._edges;
    }, Hn.prototype.get = function(t) {
        return this._edges.get(t);
    }, Hn.prototype.findEqualEdge = function(t) {
        var e = new jn(t.getCoordinates());
        return this._ocaMap.get(e);
    }, Hn.prototype.add = function(t) {
        this._edges.add(t);
        var e = new jn(t.getCoordinates());
        this._ocaMap.put(e, t);
    }, Hn.prototype.interfaces_ = function() {
        return [];
    }, Hn.prototype.getClass = function() {
        return Hn;
    };
    var Wn = function() {};
    Wn.prototype.processIntersections = function(t, e, n, i) {}, Wn.prototype.isDone = function() {}, Wn.prototype.interfaces_ = function() {
        return [];
    }, Wn.prototype.getClass = function() {
        return Wn;
    };
    var Kn = function() {
        this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._hasInterior = !1, this._properIntersectionPoint = null, this._li = null, this._isSelfIntersection = null, this.numIntersections = 0, this.numInteriorIntersections = 0, this.numProperIntersections = 0, this.numTests = 0;
        var t = arguments[0];
        this._li = t;
    };
    Kn.prototype.isTrivialIntersection = function(t, e, n, i) {
        if (t === n && 1 === this._li.getIntersectionNum()) {
            if (Kn.isAdjacentSegments(e, i)) return !0;
            if (t.isClosed()) {
                var r = t.size() - 1;
                if (0 === e && i === r || 0 === i && e === r) return !0;
            }
        }
        return !1;
    }, Kn.prototype.getProperIntersectionPoint = function() {
        return this._properIntersectionPoint;
    }, Kn.prototype.hasProperInteriorIntersection = function() {
        return this._hasProperInterior;
    }, Kn.prototype.getLineIntersector = function() {
        return this._li;
    }, Kn.prototype.hasProperIntersection = function() {
        return this._hasProper;
    }, Kn.prototype.processIntersections = function(t, e, n, i) {
        if (t === n && e === i) return null;
        this.numTests++;
        var r = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[i], a = n.getCoordinates()[i + 1];
        this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && (this.numIntersections++, this._li.isInteriorIntersection() && (this.numInteriorIntersections++, this._hasInterior = !0), this.isTrivialIntersection(t, e, n, i) || (this._hasIntersection = !0, t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1), this._li.isProper() && (this.numProperIntersections++, this._hasProper = !0, this._hasProperInterior = !0)));
    }, Kn.prototype.hasIntersection = function() {
        return this._hasIntersection;
    }, Kn.prototype.isDone = function() {
        return !1;
    }, Kn.prototype.hasInteriorIntersection = function() {
        return this._hasInterior;
    }, Kn.prototype.interfaces_ = function() {
        return [
            Wn
        ];
    }, Kn.prototype.getClass = function() {
        return Kn;
    }, Kn.isAdjacentSegments = function(t, e) {
        return 1 === Math.abs(t - e);
    };
    var Jn = function() {
        this.coord = null, this.segmentIndex = null, this.dist = null;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this.coord = new C(t), this.segmentIndex = e, this.dist = n;
    };
    Jn.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    }, Jn.prototype.getCoordinate = function() {
        return this.coord;
    }, Jn.prototype.print = function(t) {
        t.print(this.coord), t.print(" seg # = " + this.segmentIndex), t.println(" dist = " + this.dist);
    }, Jn.prototype.compareTo = function(t) {
        var e = t;
        return this.compare(e.segmentIndex, e.dist);
    }, Jn.prototype.isEndPoint = function(t) {
        return 0 === this.segmentIndex && 0 === this.dist || this.segmentIndex === t;
    }, Jn.prototype.toString = function() {
        return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
    }, Jn.prototype.getDistance = function() {
        return this.dist;
    }, Jn.prototype.compare = function(t, e) {
        return this.segmentIndex < t ? -1 : this.segmentIndex > t ? 1 : this.dist < e ? -1 : this.dist > e ? 1 : 0;
    }, Jn.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, Jn.prototype.getClass = function() {
        return Jn;
    };
    var Qn = function() {
        this._nodeMap = new p, this.edge = null;
        var t = arguments[0];
        this.edge = t;
    };
    Qn.prototype.print = function(t) {
        t.println("Intersections:");
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, Qn.prototype.iterator = function() {
        return this._nodeMap.values().iterator();
    }, Qn.prototype.addSplitEdges = function(t) {
        this.addEndpoints();
        for(var e = this.iterator(), n = e.next(); e.hasNext();){
            var i = e.next(), r = this.createSplitEdge(n, i);
            t.add(r), n = i;
        }
    }, Qn.prototype.addEndpoints = function() {
        var t = this.edge.pts.length - 1;
        this.add(this.edge.pts[0], 0, 0), this.add(this.edge.pts[t], t, 0);
    }, Qn.prototype.createSplitEdge = function(t, e) {
        var n = e.segmentIndex - t.segmentIndex + 2, i = this.edge.pts[e.segmentIndex], r = e.dist > 0 || !e.coord.equals2D(i);
        r || n--;
        var o = new Array(n).fill(null), s = 0;
        o[s++] = new C(t.coord);
        for(var a = t.segmentIndex + 1; a <= e.segmentIndex; a++)o[s++] = this.edge.pts[a];
        return r && (o[s] = e.coord), new ni(o, new Pe(this.edge._label));
    }, Qn.prototype.add = function(t, e, n) {
        var i = new Jn(t, e, n), r = this._nodeMap.get(i);
        return null !== r ? r : (this._nodeMap.put(i, i), i);
    }, Qn.prototype.isIntersection = function(t) {
        for(var e = this.iterator(); e.hasNext();){
            if (e.next().coord.equals(t)) return !0;
        }
        return !1;
    }, Qn.prototype.interfaces_ = function() {
        return [];
    }, Qn.prototype.getClass = function() {
        return Qn;
    };
    var Zn = function() {};
    Zn.prototype.getChainStartIndices = function(t) {
        var e = 0, n = new Nt;
        n.add(new M(e));
        do {
            var i = this.findChainEnd(t, e);
            n.add(new M(i)), e = i;
        }while (e < t.length - 1);
        return Zn.toIntArray(n);
    }, Zn.prototype.findChainEnd = function(t, e) {
        for(var n = Be.quadrant(t[e], t[e + 1]), i = e + 1; i < t.length;){
            if (Be.quadrant(t[i - 1], t[i]) !== n) break;
            i++;
        }
        return i - 1;
    }, Zn.prototype.interfaces_ = function() {
        return [];
    }, Zn.prototype.getClass = function() {
        return Zn;
    }, Zn.toIntArray = function(t) {
        for(var e = new Array(t.size()).fill(null), n = 0; n < e.length; n++)e[n] = t.get(n).intValue();
        return e;
    };
    var $n = function() {
        this.e = null, this.pts = null, this.startIndex = null, this.env1 = new j, this.env2 = new j;
        var t = arguments[0];
        this.e = t, this.pts = t.getCoordinates();
        var e = new Zn;
        this.startIndex = e.getChainStartIndices(this.pts);
    };
    $n.prototype.getCoordinates = function() {
        return this.pts;
    }, $n.prototype.getMaxX = function(t) {
        var e = this.pts[this.startIndex[t]].x, n = this.pts[this.startIndex[t + 1]].x;
        return e > n ? e : n;
    }, $n.prototype.getMinX = function(t) {
        var e = this.pts[this.startIndex[t]].x, n = this.pts[this.startIndex[t + 1]].x;
        return e < n ? e : n;
    }, $n.prototype.computeIntersectsForChain = function() {
        if (4 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2], i = arguments[3];
            this.computeIntersectsForChain(this.startIndex[t], this.startIndex[t + 1], e, e.startIndex[n], e.startIndex[n + 1], i);
        } else if (6 === arguments.length) {
            var r = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3], u = arguments[4], l = arguments[5], c = this.pts[r], p = this.pts[o], h = s.pts[a], f = s.pts[u];
            if (o - r == 1 && u - a == 1) return l.addIntersections(this.e, r, s.e, a), null;
            if (this.env1.init(c, p), this.env2.init(h, f), !this.env1.intersects(this.env2)) return null;
            var g = Math.trunc((r + o) / 2), d = Math.trunc((a + u) / 2);
            r < g && (a < d && this.computeIntersectsForChain(r, g, s, a, d, l), d < u && this.computeIntersectsForChain(r, g, s, d, u, l)), g < o && (a < d && this.computeIntersectsForChain(g, o, s, a, d, l), d < u && this.computeIntersectsForChain(g, o, s, d, u, l));
        }
    }, $n.prototype.getStartIndexes = function() {
        return this.startIndex;
    }, $n.prototype.computeIntersects = function(t, e) {
        for(var n = 0; n < this.startIndex.length - 1; n++)for(var i = 0; i < t.startIndex.length - 1; i++)this.computeIntersectsForChain(n, t, i, e);
    }, $n.prototype.interfaces_ = function() {
        return [];
    }, $n.prototype.getClass = function() {
        return $n;
    };
    var ti = function t() {
        this._depth = Array(2).fill().map(function() {
            return Array(3);
        });
        for(var e = 0; e < 2; e++)for(var n = 0; n < 3; n++)this._depth[e][n] = t.NULL_VALUE;
    }, ei = {
        NULL_VALUE: {
            configurable: !0
        }
    };
    ti.prototype.getDepth = function(t, e) {
        return this._depth[t][e];
    }, ti.prototype.setDepth = function(t, e, n) {
        this._depth[t][e] = n;
    }, ti.prototype.isNull = function() {
        if (0 === arguments.length) {
            for(var t = 0; t < 2; t++)for(var e = 0; e < 3; e++)if (this._depth[t][e] !== ti.NULL_VALUE) return !1;
            return !0;
        }
        if (1 === arguments.length) {
            var n = arguments[0];
            return this._depth[n][1] === ti.NULL_VALUE;
        }
        if (2 === arguments.length) {
            var i = arguments[0], r = arguments[1];
            return this._depth[i][r] === ti.NULL_VALUE;
        }
    }, ti.prototype.normalize = function() {
        for(var t = 0; t < 2; t++)if (!this.isNull(t)) {
            var e = this._depth[t][1];
            this._depth[t][2] < e && (e = this._depth[t][2]), e < 0 && (e = 0);
            for(var n = 1; n < 3; n++){
                var i = 0;
                this._depth[t][n] > e && (i = 1), this._depth[t][n] = i;
            }
        }
    }, ti.prototype.getDelta = function(t) {
        return this._depth[t][Se.RIGHT] - this._depth[t][Se.LEFT];
    }, ti.prototype.getLocation = function(t, e) {
        return this._depth[t][e] <= 0 ? w.EXTERIOR : w.INTERIOR;
    }, ti.prototype.toString = function() {
        return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
    }, ti.prototype.add = function() {
        if (1 === arguments.length) for(var t = arguments[0], e = 0; e < 2; e++)for(var n = 1; n < 3; n++){
            var i = t.getLocation(e, n);
            i !== w.EXTERIOR && i !== w.INTERIOR || (this.isNull(e, n) ? this._depth[e][n] = ti.depthAtLocation(i) : this._depth[e][n] += ti.depthAtLocation(i));
        }
        else if (3 === arguments.length) {
            var r = arguments[0], o = arguments[1];
            arguments[2] === w.INTERIOR && this._depth[r][o]++;
        }
    }, ti.prototype.interfaces_ = function() {
        return [];
    }, ti.prototype.getClass = function() {
        return ti;
    }, ti.depthAtLocation = function(t) {
        return t === w.EXTERIOR ? 0 : t === w.INTERIOR ? 1 : ti.NULL_VALUE;
    }, ei.NULL_VALUE.get = function() {
        return -1;
    }, Object.defineProperties(ti, ei);
    var ni = function(t) {
        function e() {
            if (t.call(this), this.pts = null, this._env = null, this.eiList = new Qn(this), this._name = null, this._mce = null, this._isIsolated = !0, this._depth = new ti, this._depthDelta = 0, 1 === arguments.length) {
                var n = arguments[0];
                e.call(this, n, null);
            } else if (2 === arguments.length) {
                var i = arguments[0], r = arguments[1];
                this.pts = i, this._label = r;
            }
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDepth = function() {
            return this._depth;
        }, e.prototype.getCollapsedEdge = function() {
            var t = new Array(2).fill(null);
            t[0] = this.pts[0], t[1] = this.pts[1];
            return new e(t, Pe.toLineLabel(this._label));
        }, e.prototype.isIsolated = function() {
            return this._isIsolated;
        }, e.prototype.getCoordinates = function() {
            return this.pts;
        }, e.prototype.setIsolated = function(t) {
            this._isIsolated = t;
        }, e.prototype.setName = function(t) {
            this._name = t;
        }, e.prototype.equals = function(t) {
            if (!(t instanceof e)) return !1;
            var n = t;
            if (this.pts.length !== n.pts.length) return !1;
            for(var i = !0, r = !0, o = this.pts.length, s = 0; s < this.pts.length; s++)if (this.pts[s].equals2D(n.pts[s]) || (i = !1), this.pts[s].equals2D(n.pts[--o]) || (r = !1), !i && !r) return !1;
            return !0;
        }, e.prototype.getCoordinate = function() {
            if (0 === arguments.length) return this.pts.length > 0 ? this.pts[0] : null;
            if (1 === arguments.length) {
                var t = arguments[0];
                return this.pts[t];
            }
        }, e.prototype.print = function(t) {
            t.print("edge " + this._name + ": "), t.print("LINESTRING (");
            for(var e = 0; e < this.pts.length; e++)e > 0 && t.print(","), t.print(this.pts[e].x + " " + this.pts[e].y);
            t.print(")  " + this._label + " " + this._depthDelta);
        }, e.prototype.computeIM = function(t) {
            e.updateIM(this._label, t);
        }, e.prototype.isCollapsed = function() {
            return !!this._label.isArea() && 3 === this.pts.length && !!this.pts[0].equals(this.pts[2]);
        }, e.prototype.isClosed = function() {
            return this.pts[0].equals(this.pts[this.pts.length - 1]);
        }, e.prototype.getMaximumSegmentIndex = function() {
            return this.pts.length - 1;
        }, e.prototype.getDepthDelta = function() {
            return this._depthDelta;
        }, e.prototype.getNumPoints = function() {
            return this.pts.length;
        }, e.prototype.printReverse = function(t) {
            t.print("edge " + this._name + ": ");
            for(var e = this.pts.length - 1; e >= 0; e--)t.print(this.pts[e] + " ");
            t.println("");
        }, e.prototype.getMonotoneChainEdge = function() {
            return null === this._mce && (this._mce = new $n(this)), this._mce;
        }, e.prototype.getEnvelope = function() {
            if (null === this._env) {
                this._env = new j;
                for(var t = 0; t < this.pts.length; t++)this._env.expandToInclude(this.pts[t]);
            }
            return this._env;
        }, e.prototype.addIntersection = function(t, e, n, i) {
            var r = new C(t.getIntersection(i)), o = e, s = t.getEdgeDistance(n, i), a = o + 1;
            if (a < this.pts.length) {
                var u = this.pts[a];
                r.equals2D(u) && (o = a, s = 0);
            }
            this.eiList.add(r, o, s);
        }, e.prototype.toString = function() {
            var t = new D;
            t.append("edge " + this._name + ": "), t.append("LINESTRING (");
            for(var e = 0; e < this.pts.length; e++)e > 0 && t.append(","), t.append(this.pts[e].x + " " + this.pts[e].y);
            return t.append(")  " + this._label + " " + this._depthDelta), t.toString();
        }, e.prototype.isPointwiseEqual = function(t) {
            if (this.pts.length !== t.pts.length) return !1;
            for(var e = 0; e < this.pts.length; e++)if (!this.pts[e].equals2D(t.pts[e])) return !1;
            return !0;
        }, e.prototype.setDepthDelta = function(t) {
            this._depthDelta = t;
        }, e.prototype.getEdgeIntersectionList = function() {
            return this.eiList;
        }, e.prototype.addIntersections = function(t, e, n) {
            for(var i = 0; i < t.getIntersectionNum(); i++)this.addIntersection(t, e, n, i);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.updateIM = function() {
            if (2 !== arguments.length) return t.prototype.updateIM.apply(this, arguments);
            var e = arguments[0], n = arguments[1];
            n.setAtLeastIfValid(e.getLocation(0, Se.ON), e.getLocation(1, Se.ON), 1), e.isArea() && (n.setAtLeastIfValid(e.getLocation(0, Se.LEFT), e.getLocation(1, Se.LEFT), 2), n.setAtLeastIfValid(e.getLocation(0, Se.RIGHT), e.getLocation(1, Se.RIGHT), 2));
        }, e;
    }(Fe), ii = function(t) {
        this._workingPrecisionModel = null, this._workingNoder = null, this._geomFact = null, this._graph = null, this._edgeList = new Hn, this._bufParams = t || null;
    };
    ii.prototype.setWorkingPrecisionModel = function(t) {
        this._workingPrecisionModel = t;
    }, ii.prototype.insertUniqueEdge = function(t) {
        var e = this._edgeList.findEqualEdge(t);
        if (null !== e) {
            var n = e.getLabel(), i = t.getLabel();
            e.isPointwiseEqual(t) || (i = new Pe(t.getLabel())).flip(), n.merge(i);
            var r = ii.depthDelta(i), o = e.getDepthDelta() + r;
            e.setDepthDelta(o);
        } else this._edgeList.add(t), t.setDepthDelta(ii.depthDelta(t.getLabel()));
    }, ii.prototype.buildSubgraphs = function(t, e) {
        for(var n = new Nt, i = t.iterator(); i.hasNext();){
            var r = i.next(), o = r.getRightmostCoordinate(), s = new An(n).getDepth(o);
            r.computeDepth(s), r.findResultEdges(), n.add(r), e.add(r.getDirectedEdges(), r.getNodes());
        }
    }, ii.prototype.createSubgraphs = function(t) {
        for(var e = new Nt, n = t.getNodes().iterator(); n.hasNext();){
            var i = n.next();
            if (!i.isVisited()) {
                var r = new Te;
                r.create(i), e.add(r);
            }
        }
        return $e.sort(e, $e.reverseOrder()), e;
    }, ii.prototype.createEmptyResultGeometry = function() {
        return this._geomFact.createPolygon();
    }, ii.prototype.getNoder = function(t) {
        if (null !== this._workingNoder) return this._workingNoder;
        var e = new xn, n = new rt;
        return n.setPrecisionModel(t), e.setSegmentIntersector(new Kn(n)), e;
    }, ii.prototype.buffer = function(t, e) {
        var n = this._workingPrecisionModel;
        null === n && (n = t.getPrecisionModel()), this._geomFact = t.getFactory();
        var i = new Mn(n, this._bufParams), r = new Bn(t, e, i).getCurves();
        if (r.size() <= 0) return this.createEmptyResultGeometry();
        this.computeNodedEdges(r, n), this._graph = new Ye(new kn), this._graph.addEdges(this._edgeList.getEdges());
        var o = this.createSubgraphs(this._graph), s = new ke(this._geomFact);
        this.buildSubgraphs(o, s);
        var a = s.getPolygons();
        if (a.size() <= 0) return this.createEmptyResultGeometry();
        return this._geomFact.buildGeometry(a);
    }, ii.prototype.computeNodedEdges = function(t, e) {
        var n = this.getNoder(e);
        n.computeNodes(t);
        for(var i = n.getNodedSubstrings().iterator(); i.hasNext();){
            var r = i.next(), o = r.getCoordinates();
            if (2 !== o.length || !o[0].equals2D(o[1])) {
                var s = r.getData(), a = new ni(r.getCoordinates(), new Pe(s));
                this.insertUniqueEdge(a);
            }
        }
    }, ii.prototype.setNoder = function(t) {
        this._workingNoder = t;
    }, ii.prototype.interfaces_ = function() {
        return [];
    }, ii.prototype.getClass = function() {
        return ii;
    }, ii.depthDelta = function(t) {
        var e = t.getLocation(0, Se.LEFT), n = t.getLocation(0, Se.RIGHT);
        return e === w.INTERIOR && n === w.EXTERIOR ? 1 : e === w.EXTERIOR && n === w.INTERIOR ? -1 : 0;
    }, ii.convertSegStrings = function(t) {
        for(var e = new _e, n = new Nt; t.hasNext();){
            var i = t.next(), r = e.createLineString(i.getCoordinates());
            n.add(r);
        }
        return e.buildGeometry(n);
    };
    var ri = function() {
        if (this._noder = null, this._scaleFactor = null, this._offsetX = null, this._offsetY = null, this._isScaled = !1, 2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._noder = t, this._scaleFactor = e, this._offsetX = 0, this._offsetY = 0, this._isScaled = !this.isIntegerPrecision();
        } else if (4 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2], o = arguments[3];
            this._noder = n, this._scaleFactor = i, this._offsetX = r, this._offsetY = o, this._isScaled = !this.isIntegerPrecision();
        }
    };
    ri.prototype.rescale = function() {
        if (T(arguments[0], It)) for(var t = arguments[0].iterator(); t.hasNext();){
            var e = t.next();
            this.rescale(e.getCoordinates());
        }
        else if (arguments[0] instanceof Array) {
            for(var n = arguments[0], i = 0; i < n.length; i++)n[i].x = n[i].x / this._scaleFactor + this._offsetX, n[i].y = n[i].y / this._scaleFactor + this._offsetY;
            2 === n.length && n[0].equals2D(n[1]) && Y.out.println(n);
        }
    }, ri.prototype.scale = function() {
        if (T(arguments[0], It)) {
            for(var t = arguments[0], e = new Nt, n = t.iterator(); n.hasNext();){
                var i = n.next();
                e.add(new gn(this.scale(i.getCoordinates()), i.getData()));
            }
            return e;
        }
        if (arguments[0] instanceof Array) {
            for(var r = arguments[0], o = new Array(r.length).fill(null), s = 0; s < r.length; s++)o[s] = new C(Math.round((r[s].x - this._offsetX) * this._scaleFactor), Math.round((r[s].y - this._offsetY) * this._scaleFactor), r[s].z);
            return Lt.removeRepeatedPoints(o);
        }
    }, ri.prototype.isIntegerPrecision = function() {
        return 1 === this._scaleFactor;
    }, ri.prototype.getNodedSubstrings = function() {
        var t = this._noder.getNodedSubstrings();
        return this._isScaled && this.rescale(t), t;
    }, ri.prototype.computeNodes = function(t) {
        var e = t;
        this._isScaled && (e = this.scale(t)), this._noder.computeNodes(e);
    }, ri.prototype.interfaces_ = function() {
        return [
            In
        ];
    }, ri.prototype.getClass = function() {
        return ri;
    };
    var oi = function() {
        this._li = new rt, this._segStrings = null;
        var t = arguments[0];
        this._segStrings = t;
    }, si = {
        fact: {
            configurable: !0
        }
    };
    oi.prototype.checkEndPtVertexIntersections = function() {
        if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();){
            var e = t.next().getCoordinates();
            this.checkEndPtVertexIntersections(e[0], this._segStrings), this.checkEndPtVertexIntersections(e[e.length - 1], this._segStrings);
        }
        else if (2 === arguments.length) {
            for(var n = arguments[0], i = arguments[1].iterator(); i.hasNext();)for(var r = i.next().getCoordinates(), o = 1; o < r.length - 1; o++)if (r[o].equals(n)) throw new $("found endpt/interior pt intersection at index " + o + " :pt " + n);
        }
    }, oi.prototype.checkInteriorIntersections = function() {
        if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();)for(var e = t.next(), n = this._segStrings.iterator(); n.hasNext();){
            var i = n.next();
            this.checkInteriorIntersections(e, i);
        }
        else if (2 === arguments.length) for(var r = arguments[0], o = arguments[1], s = r.getCoordinates(), a = o.getCoordinates(), u = 0; u < s.length - 1; u++)for(var l = 0; l < a.length - 1; l++)this.checkInteriorIntersections(r, u, o, l);
        else if (4 === arguments.length) {
            var c = arguments[0], p = arguments[1], h = arguments[2], f = arguments[3];
            if (c === h && p === f) return null;
            var g = c.getCoordinates()[p], d = c.getCoordinates()[p + 1], y = h.getCoordinates()[f], _ = h.getCoordinates()[f + 1];
            if (this._li.computeIntersection(g, d, y, _), this._li.hasIntersection() && (this._li.isProper() || this.hasInteriorIntersection(this._li, g, d) || this.hasInteriorIntersection(this._li, y, _))) throw new $("found non-noded intersection at " + g + "-" + d + " and " + y + "-" + _);
        }
    }, oi.prototype.checkValid = function() {
        this.checkEndPtVertexIntersections(), this.checkInteriorIntersections(), this.checkCollapses();
    }, oi.prototype.checkCollapses = function() {
        if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();){
            var e = t.next();
            this.checkCollapses(e);
        }
        else if (1 === arguments.length) for(var n = arguments[0].getCoordinates(), i = 0; i < n.length - 2; i++)this.checkCollapse(n[i], n[i + 1], n[i + 2]);
    }, oi.prototype.hasInteriorIntersection = function(t, e, n) {
        for(var i = 0; i < t.getIntersectionNum(); i++){
            var r = t.getIntersection(i);
            if (!r.equals(e) && !r.equals(n)) return !0;
        }
        return !1;
    }, oi.prototype.checkCollapse = function(t, e, n) {
        if (t.equals(n)) throw new $("found non-noded collapse at " + oi.fact.createLineString([
            t,
            e,
            n
        ]));
    }, oi.prototype.interfaces_ = function() {
        return [];
    }, oi.prototype.getClass = function() {
        return oi;
    }, si.fact.get = function() {
        return new _e;
    }, Object.defineProperties(oi, si);
    var ai = function() {
        this._li = null, this._pt = null, this._originalPt = null, this._ptScaled = null, this._p0Scaled = null, this._p1Scaled = null, this._scaleFactor = null, this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, this._corner = new Array(4).fill(null), this._safeEnv = null;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        if (this._originalPt = t, this._pt = t, this._scaleFactor = e, this._li = n, e <= 0) throw new m("Scale factor must be non-zero");
        1 !== e && (this._pt = new C(this.scale(t.x), this.scale(t.y)), this._p0Scaled = new C, this._p1Scaled = new C), this.initCorners(this._pt);
    }, ui = {
        SAFE_ENV_EXPANSION_FACTOR: {
            configurable: !0
        }
    };
    ai.prototype.intersectsScaled = function(t, e) {
        var n = Math.min(t.x, e.x), i = Math.max(t.x, e.x), r = Math.min(t.y, e.y), o = Math.max(t.y, e.y), s = this._maxx < n || this._minx > i || this._maxy < r || this._miny > o;
        if (s) return !1;
        var a = this.intersectsToleranceSquare(t, e);
        return et.isTrue(!(s && a), "Found bad envelope test"), a;
    }, ai.prototype.initCorners = function(t) {
        this._minx = t.x - .5, this._maxx = t.x + .5, this._miny = t.y - .5, this._maxy = t.y + .5, this._corner[0] = new C(this._maxx, this._maxy), this._corner[1] = new C(this._minx, this._maxy), this._corner[2] = new C(this._minx, this._miny), this._corner[3] = new C(this._maxx, this._miny);
    }, ai.prototype.intersects = function(t, e) {
        return 1 === this._scaleFactor ? this.intersectsScaled(t, e) : (this.copyScaled(t, this._p0Scaled), this.copyScaled(e, this._p1Scaled), this.intersectsScaled(this._p0Scaled, this._p1Scaled));
    }, ai.prototype.scale = function(t) {
        return Math.round(t * this._scaleFactor);
    }, ai.prototype.getCoordinate = function() {
        return this._originalPt;
    }, ai.prototype.copyScaled = function(t, e) {
        e.x = this.scale(t.x), e.y = this.scale(t.y);
    }, ai.prototype.getSafeEnvelope = function() {
        if (null === this._safeEnv) {
            var t = ai.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
            this._safeEnv = new j(this._originalPt.x - t, this._originalPt.x + t, this._originalPt.y - t, this._originalPt.y + t);
        }
        return this._safeEnv;
    }, ai.prototype.intersectsPixelClosure = function(t, e) {
        return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.hasIntersection())));
    }, ai.prototype.intersectsToleranceSquare = function(t, e) {
        var n = !1, i = !1;
        return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.isProper() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.isProper() || (this._li.hasIntersection() && (n = !0), this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.isProper() || (this._li.hasIntersection() && (i = !0), this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.isProper() || !(!n || !i) || !!t.equals(this._pt) || !!e.equals(this._pt))));
    }, ai.prototype.addSnappedNode = function(t, e) {
        var n = t.getCoordinate(e), i = t.getCoordinate(e + 1);
        return !!this.intersects(n, i) && (t.addIntersection(this.getCoordinate(), e), !0);
    }, ai.prototype.interfaces_ = function() {
        return [];
    }, ai.prototype.getClass = function() {
        return ai;
    }, ui.SAFE_ENV_EXPANSION_FACTOR.get = function() {
        return .75;
    }, Object.defineProperties(ai, ui);
    var li = function() {
        this.tempEnv1 = new j, this.selectedSegment = new dn;
    };
    li.prototype.select = function() {
        if (1 === arguments.length) ;
        else if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            t.getLineSegment(e, this.selectedSegment), this.select(this.selectedSegment);
        }
    }, li.prototype.interfaces_ = function() {
        return [];
    }, li.prototype.getClass = function() {
        return li;
    };
    var ci = function() {
        this._index = null;
        var t = arguments[0];
        this._index = t;
    }, pi = {
        HotPixelSnapAction: {
            configurable: !0
        }
    };
    ci.prototype.snap = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.snap(t, null, -1);
        }
        if (3 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = arguments[2], r = e.getSafeEnvelope(), o = new hi(e, n, i);
            return this._index.query(r, {
                interfaces_: function() {
                    return [
                        Ke
                    ];
                },
                visitItem: function(t) {
                    t.select(r, o);
                }
            }), o.isNodeAdded();
        }
    }, ci.prototype.interfaces_ = function() {
        return [];
    }, ci.prototype.getClass = function() {
        return ci;
    }, pi.HotPixelSnapAction.get = function() {
        return hi;
    }, Object.defineProperties(ci, pi);
    var hi = function(t) {
        function e() {
            t.call(this), this._hotPixel = null, this._parentEdge = null, this._hotPixelVertexIndex = null, this._isNodeAdded = !1;
            var e = arguments[0], n = arguments[1], i = arguments[2];
            this._hotPixel = e, this._parentEdge = n, this._hotPixelVertexIndex = i;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isNodeAdded = function() {
            return this._isNodeAdded;
        }, e.prototype.select = function() {
            if (2 !== arguments.length) return t.prototype.select.apply(this, arguments);
            var e = arguments[0], n = arguments[1], i = e.getContext();
            if (null !== this._parentEdge && i === this._parentEdge && n === this._hotPixelVertexIndex) return null;
            this._isNodeAdded = this._hotPixel.addSnappedNode(i, n);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(li), fi = function() {
        this._li = null, this._interiorIntersections = null;
        var t = arguments[0];
        this._li = t, this._interiorIntersections = new Nt;
    };
    fi.prototype.processIntersections = function(t, e, n, i) {
        if (t === n && e === i) return null;
        var r = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[i], a = n.getCoordinates()[i + 1];
        if (this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && this._li.isInteriorIntersection()) {
            for(var u = 0; u < this._li.getIntersectionNum(); u++)this._interiorIntersections.add(this._li.getIntersection(u));
            t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1);
        }
    }, fi.prototype.isDone = function() {
        return !1;
    }, fi.prototype.getInteriorIntersections = function() {
        return this._interiorIntersections;
    }, fi.prototype.interfaces_ = function() {
        return [
            Wn
        ];
    }, fi.prototype.getClass = function() {
        return fi;
    };
    var gi = function() {
        this._pm = null, this._li = null, this._scaleFactor = null, this._noder = null, this._pointSnapper = null, this._nodedSegStrings = null;
        var t = arguments[0];
        this._pm = t, this._li = new rt, this._li.setPrecisionModel(t), this._scaleFactor = t.getScale();
    };
    gi.prototype.checkCorrectness = function(t) {
        var e = gn.getNodedSubstrings(t), n = new oi(e);
        try {
            n.checkValid();
        } catch (t) {
            if (!(t instanceof z)) throw t;
            t.printStackTrace();
        }
    }, gi.prototype.getNodedSubstrings = function() {
        return gn.getNodedSubstrings(this._nodedSegStrings);
    }, gi.prototype.snapRound = function(t, e) {
        var n = this.findInteriorIntersections(t, e);
        this.computeIntersectionSnaps(n), this.computeVertexSnaps(t);
    }, gi.prototype.findInteriorIntersections = function(t, e) {
        var n = new fi(e);
        return this._noder.setSegmentIntersector(n), this._noder.computeNodes(t), n.getInteriorIntersections();
    }, gi.prototype.computeVertexSnaps = function() {
        if (T(arguments[0], It)) for(var t = arguments[0].iterator(); t.hasNext();){
            var e = t.next();
            this.computeVertexSnaps(e);
        }
        else if (arguments[0] instanceof gn) for(var n = arguments[0], i = n.getCoordinates(), r = 0; r < i.length; r++){
            var o = new ai(i[r], this._scaleFactor, this._li);
            this._pointSnapper.snap(o, n, r) && n.addIntersection(i[r], r);
        }
    }, gi.prototype.computeNodes = function(t) {
        this._nodedSegStrings = t, this._noder = new xn, this._pointSnapper = new ci(this._noder.getIndex()), this.snapRound(t, this._li);
    }, gi.prototype.computeIntersectionSnaps = function(t) {
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next(), i = new ai(n, this._scaleFactor, this._li);
            this._pointSnapper.snap(i);
        }
    }, gi.prototype.interfaces_ = function() {
        return [
            In
        ];
    }, gi.prototype.getClass = function() {
        return gi;
    };
    var di = function() {
        if (this._argGeom = null, this._distance = null, this._bufParams = new Cn, this._resultGeometry = null, this._saveException = null, 1 === arguments.length) {
            var t = arguments[0];
            this._argGeom = t;
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this._argGeom = e, this._bufParams = n;
        }
    }, yi = {
        CAP_ROUND: {
            configurable: !0
        },
        CAP_BUTT: {
            configurable: !0
        },
        CAP_FLAT: {
            configurable: !0
        },
        CAP_SQUARE: {
            configurable: !0
        },
        MAX_PRECISION_DIGITS: {
            configurable: !0
        }
    };
    di.prototype.bufferFixedPrecision = function(t) {
        var e = new ri(new gi(new fe(1)), t.getScale()), n = new ii(this._bufParams);
        n.setWorkingPrecisionModel(t), n.setNoder(e), this._resultGeometry = n.buffer(this._argGeom, this._distance);
    }, di.prototype.bufferReducedPrecision = function() {
        var t = this;
        if (0 === arguments.length) {
            for(var e = di.MAX_PRECISION_DIGITS; e >= 0; e--){
                try {
                    t.bufferReducedPrecision(e);
                } catch (e) {
                    if (!(e instanceof we)) throw e;
                    t._saveException = e;
                }
                if (null !== t._resultGeometry) return null;
            }
            throw this._saveException;
        }
        if (1 === arguments.length) {
            var n = arguments[0], i = di.precisionScaleFactor(this._argGeom, this._distance, n), r = new fe(i);
            this.bufferFixedPrecision(r);
        }
    }, di.prototype.computeGeometry = function() {
        if (this.bufferOriginalPrecision(), null !== this._resultGeometry) return null;
        var t = this._argGeom.getFactory().getPrecisionModel();
        t.getType() === fe.FIXED ? this.bufferFixedPrecision(t) : this.bufferReducedPrecision();
    }, di.prototype.setQuadrantSegments = function(t) {
        this._bufParams.setQuadrantSegments(t);
    }, di.prototype.bufferOriginalPrecision = function() {
        try {
            var t = new ii(this._bufParams);
            this._resultGeometry = t.buffer(this._argGeom, this._distance);
        } catch (t) {
            if (!(t instanceof $)) throw t;
            this._saveException = t;
        }
    }, di.prototype.getResultGeometry = function(t) {
        return this._distance = t, this.computeGeometry(), this._resultGeometry;
    }, di.prototype.setEndCapStyle = function(t) {
        this._bufParams.setEndCapStyle(t);
    }, di.prototype.interfaces_ = function() {
        return [];
    }, di.prototype.getClass = function() {
        return di;
    }, di.bufferOp = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            return new di(t).getResultGeometry(e);
        }
        if (3 === arguments.length) {
            if (Number.isInteger(arguments[2]) && arguments[0] instanceof ct && "number" == typeof arguments[1]) {
                var n = arguments[0], i = arguments[1], r = arguments[2], o = new di(n);
                o.setQuadrantSegments(r);
                return o.getResultGeometry(i);
            }
            if (arguments[2] instanceof Cn && arguments[0] instanceof ct && "number" == typeof arguments[1]) {
                var s = arguments[0], a = arguments[1], u = arguments[2];
                return new di(s, u).getResultGeometry(a);
            }
        } else if (4 === arguments.length) {
            var l = arguments[0], c = arguments[1], p = arguments[2], h = arguments[3], f = new di(l);
            f.setQuadrantSegments(p), f.setEndCapStyle(h);
            return f.getResultGeometry(c);
        }
    }, di.precisionScaleFactor = function(t, e, n) {
        var i = t.getEnvelopeInternal(), r = R.max(Math.abs(i.getMaxX()), Math.abs(i.getMaxY()), Math.abs(i.getMinX()), Math.abs(i.getMinY())) + 2 * (e > 0 ? e : 0), o = n - Math.trunc(Math.log(r) / Math.log(10) + 1);
        return Math.pow(10, o);
    }, yi.CAP_ROUND.get = function() {
        return Cn.CAP_ROUND;
    }, yi.CAP_BUTT.get = function() {
        return Cn.CAP_FLAT;
    }, yi.CAP_FLAT.get = function() {
        return Cn.CAP_FLAT;
    }, yi.CAP_SQUARE.get = function() {
        return Cn.CAP_SQUARE;
    }, yi.MAX_PRECISION_DIGITS.get = function() {
        return 12;
    }, Object.defineProperties(di, yi);
    var _i = function() {
        this._pt = [
            new C,
            new C
        ], this._distance = v.NaN, this._isNull = !0;
    };
    _i.prototype.getCoordinates = function() {
        return this._pt;
    }, _i.prototype.getCoordinate = function(t) {
        return this._pt[t];
    }, _i.prototype.setMinimum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMinimum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var i = e.distance(n);
            i < this._distance && this.initialize(e, n, i);
        }
    }, _i.prototype.initialize = function() {
        if (0 === arguments.length) this._isNull = !0;
        else if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = t.distance(e), this._isNull = !1;
        } else if (3 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2];
            this._pt[0].setCoordinate(n), this._pt[1].setCoordinate(i), this._distance = r, this._isNull = !1;
        }
    }, _i.prototype.getDistance = function() {
        return this._distance;
    }, _i.prototype.setMaximum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMaximum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var i = e.distance(n);
            i > this._distance && this.initialize(e, n, i);
        }
    }, _i.prototype.interfaces_ = function() {
        return [];
    }, _i.prototype.getClass = function() {
        return _i;
    };
    var mi = function() {};
    mi.prototype.interfaces_ = function() {
        return [];
    }, mi.prototype.getClass = function() {
        return mi;
    }, mi.computeDistance = function() {
        if (arguments[2] instanceof _i && arguments[0] instanceof Kt && arguments[1] instanceof C) for(var t = arguments[0], e = arguments[1], n = arguments[2], i = t.getCoordinates(), r = new dn, o = 0; o < i.length - 1; o++){
            r.setCoordinates(i[o], i[o + 1]);
            var s = r.closestPoint(e);
            n.setMinimum(s, e);
        }
        else if (arguments[2] instanceof _i && arguments[0] instanceof $t && arguments[1] instanceof C) {
            var a = arguments[0], u = arguments[1], l = arguments[2];
            mi.computeDistance(a.getExteriorRing(), u, l);
            for(var c = 0; c < a.getNumInteriorRing(); c++)mi.computeDistance(a.getInteriorRingN(c), u, l);
        } else if (arguments[2] instanceof _i && arguments[0] instanceof ct && arguments[1] instanceof C) {
            var p = arguments[0], h = arguments[1], f = arguments[2];
            if (p instanceof Kt) mi.computeDistance(p, h, f);
            else if (p instanceof $t) mi.computeDistance(p, h, f);
            else if (p instanceof zt) for(var g = p, d = 0; d < g.getNumGeometries(); d++){
                var y = g.getGeometryN(d);
                mi.computeDistance(y, h, f);
            }
            else f.setMinimum(p.getCoordinate(), h);
        } else if (arguments[2] instanceof _i && arguments[0] instanceof dn && arguments[1] instanceof C) {
            var _ = arguments[0], m = arguments[1], v = arguments[2], I = _.closestPoint(m);
            v.setMinimum(I, m);
        }
    };
    var vi = function(t) {
        this._maxPtDist = new _i, this._inputGeom = t || null;
    }, Ii = {
        MaxPointDistanceFilter: {
            configurable: !0
        },
        MaxMidpointDistanceFilter: {
            configurable: !0
        }
    };
    vi.prototype.computeMaxMidpointDistance = function(t) {
        var e = new xi(this._inputGeom);
        t.apply(e), this._maxPtDist.setMaximum(e.getMaxPointDistance());
    }, vi.prototype.computeMaxVertexDistance = function(t) {
        var e = new Ei(this._inputGeom);
        t.apply(e), this._maxPtDist.setMaximum(e.getMaxPointDistance());
    }, vi.prototype.findDistance = function(t) {
        return this.computeMaxVertexDistance(t), this.computeMaxMidpointDistance(t), this._maxPtDist.getDistance();
    }, vi.prototype.getDistancePoints = function() {
        return this._maxPtDist;
    }, vi.prototype.interfaces_ = function() {
        return [];
    }, vi.prototype.getClass = function() {
        return vi;
    }, Ii.MaxPointDistanceFilter.get = function() {
        return Ei;
    }, Ii.MaxMidpointDistanceFilter.get = function() {
        return xi;
    }, Object.defineProperties(vi, Ii);
    var Ei = function(t) {
        this._maxPtDist = new _i, this._minPtDist = new _i, this._geom = t || null;
    };
    Ei.prototype.filter = function(t) {
        this._minPtDist.initialize(), mi.computeDistance(this._geom, t, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, Ei.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, Ei.prototype.interfaces_ = function() {
        return [
            ft
        ];
    }, Ei.prototype.getClass = function() {
        return Ei;
    };
    var xi = function(t) {
        this._maxPtDist = new _i, this._minPtDist = new _i, this._geom = t || null;
    };
    xi.prototype.filter = function(t, e) {
        if (0 === e) return null;
        var n = t.getCoordinate(e - 1), i = t.getCoordinate(e), r = new C((n.x + i.x) / 2, (n.y + i.y) / 2);
        this._minPtDist.initialize(), mi.computeDistance(this._geom, r, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, xi.prototype.isDone = function() {
        return !1;
    }, xi.prototype.isGeometryChanged = function() {
        return !1;
    }, xi.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, xi.prototype.interfaces_ = function() {
        return [
            Ut
        ];
    }, xi.prototype.getClass = function() {
        return xi;
    };
    var Ni = function(t) {
        this._comps = t || null;
    };
    Ni.prototype.filter = function(t) {
        t instanceof $t && this._comps.add(t);
    }, Ni.prototype.interfaces_ = function() {
        return [
            Vt
        ];
    }, Ni.prototype.getClass = function() {
        return Ni;
    }, Ni.getPolygons = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Ni.getPolygons(t, new Nt);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return e instanceof $t ? n.add(e) : e instanceof zt && e.apply(new Ni(n)), n;
        }
    };
    var Ci = function() {
        if (this._lines = null, this._isForcedToLineString = !1, 1 === arguments.length) {
            var t = arguments[0];
            this._lines = t;
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this._lines = e, this._isForcedToLineString = n;
        }
    };
    Ci.prototype.filter = function(t) {
        if (this._isForcedToLineString && t instanceof ee) {
            var e = t.getFactory().createLineString(t.getCoordinateSequence());
            return this._lines.add(e), null;
        }
        t instanceof Kt && this._lines.add(t);
    }, Ci.prototype.setForceToLineString = function(t) {
        this._isForcedToLineString = t;
    }, Ci.prototype.interfaces_ = function() {
        return [
            lt
        ];
    }, Ci.prototype.getClass = function() {
        return Ci;
    }, Ci.getGeometry = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return t.getFactory().buildGeometry(Ci.getLines(t));
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return e.getFactory().buildGeometry(Ci.getLines(e, n));
        }
    }, Ci.getLines = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Ci.getLines(t, !1);
        }
        if (2 === arguments.length) {
            if (T(arguments[0], It) && T(arguments[1], It)) {
                for(var e = arguments[0], n = arguments[1], i = e.iterator(); i.hasNext();){
                    var r = i.next();
                    Ci.getLines(r, n);
                }
                return n;
            }
            if (arguments[0] instanceof ct && "boolean" == typeof arguments[1]) {
                var o = arguments[0], s = arguments[1], a = new Nt;
                return o.apply(new Ci(a, s)), a;
            }
            if (arguments[0] instanceof ct && T(arguments[1], It)) {
                var u = arguments[0], l = arguments[1];
                return u instanceof Kt ? l.add(u) : u.apply(new Ci(l)), l;
            }
        } else if (3 === arguments.length) {
            if ("boolean" == typeof arguments[2] && T(arguments[0], It) && T(arguments[1], It)) {
                for(var c = arguments[0], p = arguments[1], h = arguments[2], f = c.iterator(); f.hasNext();){
                    var g = f.next();
                    Ci.getLines(g, p, h);
                }
                return p;
            }
            if ("boolean" == typeof arguments[2] && arguments[0] instanceof ct && T(arguments[1], It)) {
                var d = arguments[0], y = arguments[1], _ = arguments[2];
                return d.apply(new Ci(y, _)), y;
            }
        }
    };
    var Si = function() {
        if (this._boundaryRule = gt.OGC_SFS_BOUNDARY_RULE, this._isIn = null, this._numBoundaries = null, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            if (null === t) throw new m("Rule must be non-null");
            this._boundaryRule = t;
        }
    };
    Si.prototype.locateInternal = function() {
        if (arguments[0] instanceof C && arguments[1] instanceof $t) {
            var t = arguments[0], e = arguments[1];
            if (e.isEmpty()) return w.EXTERIOR;
            var n = e.getExteriorRing(), i = this.locateInPolygonRing(t, n);
            if (i === w.EXTERIOR) return w.EXTERIOR;
            if (i === w.BOUNDARY) return w.BOUNDARY;
            for(var r = 0; r < e.getNumInteriorRing(); r++){
                var o = e.getInteriorRingN(r), s = this.locateInPolygonRing(t, o);
                if (s === w.INTERIOR) return w.EXTERIOR;
                if (s === w.BOUNDARY) return w.BOUNDARY;
            }
            return w.INTERIOR;
        }
        if (arguments[0] instanceof C && arguments[1] instanceof Kt) {
            var a = arguments[0], u = arguments[1];
            if (!u.getEnvelopeInternal().intersects(a)) return w.EXTERIOR;
            var l = u.getCoordinates();
            return u.isClosed() || !a.equals(l[0]) && !a.equals(l[l.length - 1]) ? at.isOnLine(a, l) ? w.INTERIOR : w.EXTERIOR : w.BOUNDARY;
        }
        if (arguments[0] instanceof C && arguments[1] instanceof Qt) {
            var c = arguments[0];
            return arguments[1].getCoordinate().equals2D(c) ? w.INTERIOR : w.EXTERIOR;
        }
    }, Si.prototype.locateInPolygonRing = function(t, e) {
        return e.getEnvelopeInternal().intersects(t) ? at.locatePointInRing(t, e.getCoordinates()) : w.EXTERIOR;
    }, Si.prototype.intersects = function(t, e) {
        return this.locate(t, e) !== w.EXTERIOR;
    }, Si.prototype.updateLocationInfo = function(t) {
        t === w.INTERIOR && (this._isIn = !0), t === w.BOUNDARY && this._numBoundaries++;
    }, Si.prototype.computeLocation = function(t, e) {
        if (e instanceof Qt && this.updateLocationInfo(this.locateInternal(t, e)), e instanceof Kt) this.updateLocationInfo(this.locateInternal(t, e));
        else if (e instanceof $t) this.updateLocationInfo(this.locateInternal(t, e));
        else if (e instanceof Xt) for(var n = e, i = 0; i < n.getNumGeometries(); i++){
            var r = n.getGeometryN(i);
            this.updateLocationInfo(this.locateInternal(t, r));
        }
        else if (e instanceof ne) for(var o = e, s = 0; s < o.getNumGeometries(); s++){
            var a = o.getGeometryN(s);
            this.updateLocationInfo(this.locateInternal(t, a));
        }
        else if (e instanceof zt) for(var u = new Un(e); u.hasNext();){
            var l = u.next();
            l !== e && this.computeLocation(t, l);
        }
    }, Si.prototype.locate = function(t, e) {
        return e.isEmpty() ? w.EXTERIOR : e instanceof Kt ? this.locateInternal(t, e) : e instanceof $t ? this.locateInternal(t, e) : (this._isIn = !1, this._numBoundaries = 0, this.computeLocation(t, e), this._boundaryRule.isInBoundary(this._numBoundaries) ? w.BOUNDARY : this._numBoundaries > 0 || this._isIn ? w.INTERIOR : w.EXTERIOR);
    }, Si.prototype.interfaces_ = function() {
        return [];
    }, Si.prototype.getClass = function() {
        return Si;
    };
    var Li = function t() {
        if (this._component = null, this._segIndex = null, this._pt = null, 2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, t.INSIDE_AREA, n);
        } else if (3 === arguments.length) {
            var i = arguments[0], r = arguments[1], o = arguments[2];
            this._component = i, this._segIndex = r, this._pt = o;
        }
    }, bi = {
        INSIDE_AREA: {
            configurable: !0
        }
    };
    Li.prototype.isInsideArea = function() {
        return this._segIndex === Li.INSIDE_AREA;
    }, Li.prototype.getCoordinate = function() {
        return this._pt;
    }, Li.prototype.getGeometryComponent = function() {
        return this._component;
    }, Li.prototype.getSegmentIndex = function() {
        return this._segIndex;
    }, Li.prototype.interfaces_ = function() {
        return [];
    }, Li.prototype.getClass = function() {
        return Li;
    }, bi.INSIDE_AREA.get = function() {
        return -1;
    }, Object.defineProperties(Li, bi);
    var wi = function(t) {
        this._pts = t || null;
    };
    wi.prototype.filter = function(t) {
        t instanceof Qt && this._pts.add(t);
    }, wi.prototype.interfaces_ = function() {
        return [
            Vt
        ];
    }, wi.prototype.getClass = function() {
        return wi;
    }, wi.getPoints = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return t instanceof Qt ? $e.singletonList(t) : wi.getPoints(t, new Nt);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return e instanceof Qt ? n.add(e) : e instanceof zt && e.apply(new wi(n)), n;
        }
    };
    var Oi = function() {
        this._locations = null;
        var t = arguments[0];
        this._locations = t;
    };
    Oi.prototype.filter = function(t) {
        (t instanceof Qt || t instanceof Kt || t instanceof $t) && this._locations.add(new Li(t, 0, t.getCoordinate()));
    }, Oi.prototype.interfaces_ = function() {
        return [
            Vt
        ];
    }, Oi.prototype.getClass = function() {
        return Oi;
    }, Oi.getLocations = function(t) {
        var e = new Nt;
        return t.apply(new Oi(e)), e;
    };
    var Ti = function() {
        if (this._geom = null, this._terminateDistance = 0, this._ptLocator = new Si, this._minDistanceLocation = null, this._minDistance = v.MAX_VALUE, 2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._geom = [
                t,
                e
            ], this._terminateDistance = 0;
        } else if (3 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2];
            this._geom = new Array(2).fill(null), this._geom[0] = n, this._geom[1] = i, this._terminateDistance = r;
        }
    };
    Ti.prototype.computeContainmentDistance = function() {
        if (0 === arguments.length) {
            var t = new Array(2).fill(null);
            if (this.computeContainmentDistance(0, t), this._minDistance <= this._terminateDistance) return null;
            this.computeContainmentDistance(1, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = 1 - e, r = Ni.getPolygons(this._geom[e]);
            if (r.size() > 0) {
                var o = Oi.getLocations(this._geom[i]);
                if (this.computeContainmentDistance(o, r, n), this._minDistance <= this._terminateDistance) return this._minDistanceLocation[i] = n[0], this._minDistanceLocation[e] = n[1], null;
            }
        } else if (3 === arguments.length) {
            if (arguments[2] instanceof Array && T(arguments[0], xt) && T(arguments[1], xt)) {
                for(var s = arguments[0], a = arguments[1], u = arguments[2], l = 0; l < s.size(); l++)for(var c = s.get(l), p = 0; p < a.size(); p++)if (this.computeContainmentDistance(c, a.get(p), u), this._minDistance <= this._terminateDistance) return null;
            } else if (arguments[2] instanceof Array && arguments[0] instanceof Li && arguments[1] instanceof $t) {
                var h = arguments[0], f = arguments[1], g = arguments[2], d = h.getCoordinate();
                if (w.EXTERIOR !== this._ptLocator.locate(d, f)) return this._minDistance = 0, g[0] = h, g[1] = new Li(f, d), null;
            }
        }
    }, Ti.prototype.computeMinDistanceLinesPoints = function(t, e, n) {
        for(var i = 0; i < t.size(); i++)for(var r = t.get(i), o = 0; o < e.size(); o++){
            var s = e.get(o);
            if (this.computeMinDistance(r, s, n), this._minDistance <= this._terminateDistance) return null;
        }
    }, Ti.prototype.computeFacetDistance = function() {
        var t = new Array(2).fill(null), e = Ci.getLines(this._geom[0]), n = Ci.getLines(this._geom[1]), i = wi.getPoints(this._geom[0]), r = wi.getPoints(this._geom[1]);
        return this.computeMinDistanceLines(e, n, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(e, r, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(n, i, t), this.updateMinDistance(t, !0), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistancePoints(i, r, t), void this.updateMinDistance(t, !1))));
    }, Ti.prototype.nearestLocations = function() {
        return this.computeMinDistance(), this._minDistanceLocation;
    }, Ti.prototype.updateMinDistance = function(t, e) {
        if (null === t[0]) return null;
        e ? (this._minDistanceLocation[0] = t[1], this._minDistanceLocation[1] = t[0]) : (this._minDistanceLocation[0] = t[0], this._minDistanceLocation[1] = t[1]);
    }, Ti.prototype.nearestPoints = function() {
        this.computeMinDistance();
        return [
            this._minDistanceLocation[0].getCoordinate(),
            this._minDistanceLocation[1].getCoordinate()
        ];
    }, Ti.prototype.computeMinDistance = function() {
        if (0 === arguments.length) {
            if (null !== this._minDistanceLocation) return null;
            if (this._minDistanceLocation = new Array(2).fill(null), this.computeContainmentDistance(), this._minDistance <= this._terminateDistance) return null;
            this.computeFacetDistance();
        } else if (3 === arguments.length) {
            if (arguments[2] instanceof Array && arguments[0] instanceof Kt && arguments[1] instanceof Qt) {
                var t = arguments[0], e = arguments[1], n = arguments[2];
                if (t.getEnvelopeInternal().distance(e.getEnvelopeInternal()) > this._minDistance) return null;
                for(var i = t.getCoordinates(), r = e.getCoordinate(), o = 0; o < i.length - 1; o++){
                    var s = at.distancePointLine(r, i[o], i[o + 1]);
                    if (s < this._minDistance) {
                        this._minDistance = s;
                        var a = new dn(i[o], i[o + 1]).closestPoint(r);
                        n[0] = new Li(t, o, a), n[1] = new Li(e, 0, r);
                    }
                    if (this._minDistance <= this._terminateDistance) return null;
                }
            } else if (arguments[2] instanceof Array && arguments[0] instanceof Kt && arguments[1] instanceof Kt) {
                var u = arguments[0], l = arguments[1], c = arguments[2];
                if (u.getEnvelopeInternal().distance(l.getEnvelopeInternal()) > this._minDistance) return null;
                for(var p = u.getCoordinates(), h = l.getCoordinates(), f = 0; f < p.length - 1; f++)for(var g = 0; g < h.length - 1; g++){
                    var d = at.distanceLineLine(p[f], p[f + 1], h[g], h[g + 1]);
                    if (d < this._minDistance) {
                        this._minDistance = d;
                        var y = new dn(p[f], p[f + 1]), _ = new dn(h[g], h[g + 1]), m = y.closestPoints(_);
                        c[0] = new Li(u, f, m[0]), c[1] = new Li(l, g, m[1]);
                    }
                    if (this._minDistance <= this._terminateDistance) return null;
                }
            }
        }
    }, Ti.prototype.computeMinDistancePoints = function(t, e, n) {
        for(var i = 0; i < t.size(); i++)for(var r = t.get(i), o = 0; o < e.size(); o++){
            var s = e.get(o), a = r.getCoordinate().distance(s.getCoordinate());
            if (a < this._minDistance && (this._minDistance = a, n[0] = new Li(r, 0, r.getCoordinate()), n[1] = new Li(s, 0, s.getCoordinate())), this._minDistance <= this._terminateDistance) return null;
        }
    }, Ti.prototype.distance = function() {
        if (null === this._geom[0] || null === this._geom[1]) throw new m("null geometries are not supported");
        return this._geom[0].isEmpty() || this._geom[1].isEmpty() ? 0 : (this.computeMinDistance(), this._minDistance);
    }, Ti.prototype.computeMinDistanceLines = function(t, e, n) {
        for(var i = 0; i < t.size(); i++)for(var r = t.get(i), o = 0; o < e.size(); o++){
            var s = e.get(o);
            if (this.computeMinDistance(r, s, n), this._minDistance <= this._terminateDistance) return null;
        }
    }, Ti.prototype.interfaces_ = function() {
        return [];
    }, Ti.prototype.getClass = function() {
        return Ti;
    }, Ti.distance = function(t, e) {
        return new Ti(t, e).distance();
    }, Ti.isWithinDistance = function(t, e, n) {
        return new Ti(t, e, n).distance() <= n;
    }, Ti.nearestPoints = function(t, e) {
        return new Ti(t, e).nearestPoints();
    };
    var Ri = function() {
        this._pt = [
            new C,
            new C
        ], this._distance = v.NaN, this._isNull = !0;
    };
    Ri.prototype.getCoordinates = function() {
        return this._pt;
    }, Ri.prototype.getCoordinate = function(t) {
        return this._pt[t];
    }, Ri.prototype.setMinimum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMinimum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var i = e.distance(n);
            i < this._distance && this.initialize(e, n, i);
        }
    }, Ri.prototype.initialize = function() {
        if (0 === arguments.length) this._isNull = !0;
        else if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = t.distance(e), this._isNull = !1;
        } else if (3 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2];
            this._pt[0].setCoordinate(n), this._pt[1].setCoordinate(i), this._distance = r, this._isNull = !1;
        }
    }, Ri.prototype.toString = function() {
        return Z.toLineString(this._pt[0], this._pt[1]);
    }, Ri.prototype.getDistance = function() {
        return this._distance;
    }, Ri.prototype.setMaximum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMaximum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var i = e.distance(n);
            i > this._distance && this.initialize(e, n, i);
        }
    }, Ri.prototype.interfaces_ = function() {
        return [];
    }, Ri.prototype.getClass = function() {
        return Ri;
    };
    var Pi = function() {};
    Pi.prototype.interfaces_ = function() {
        return [];
    }, Pi.prototype.getClass = function() {
        return Pi;
    }, Pi.computeDistance = function() {
        if (arguments[2] instanceof Ri && arguments[0] instanceof Kt && arguments[1] instanceof C) for(var t = arguments[0], e = arguments[1], n = arguments[2], i = new dn, r = t.getCoordinates(), o = 0; o < r.length - 1; o++){
            i.setCoordinates(r[o], r[o + 1]);
            var s = i.closestPoint(e);
            n.setMinimum(s, e);
        }
        else if (arguments[2] instanceof Ri && arguments[0] instanceof $t && arguments[1] instanceof C) {
            var a = arguments[0], u = arguments[1], l = arguments[2];
            Pi.computeDistance(a.getExteriorRing(), u, l);
            for(var c = 0; c < a.getNumInteriorRing(); c++)Pi.computeDistance(a.getInteriorRingN(c), u, l);
        } else if (arguments[2] instanceof Ri && arguments[0] instanceof ct && arguments[1] instanceof C) {
            var p = arguments[0], h = arguments[1], f = arguments[2];
            if (p instanceof Kt) Pi.computeDistance(p, h, f);
            else if (p instanceof $t) Pi.computeDistance(p, h, f);
            else if (p instanceof zt) for(var g = p, d = 0; d < g.getNumGeometries(); d++){
                var y = g.getGeometryN(d);
                Pi.computeDistance(y, h, f);
            }
            else f.setMinimum(p.getCoordinate(), h);
        } else if (arguments[2] instanceof Ri && arguments[0] instanceof dn && arguments[1] instanceof C) {
            var _ = arguments[0], m = arguments[1], v = arguments[2], I = _.closestPoint(m);
            v.setMinimum(I, m);
        }
    };
    var Di = function() {
        this._g0 = null, this._g1 = null, this._ptDist = new Ri, this._densifyFrac = 0;
        var t = arguments[0], e = arguments[1];
        this._g0 = t, this._g1 = e;
    }, Mi = {
        MaxPointDistanceFilter: {
            configurable: !0
        },
        MaxDensifiedByFractionDistanceFilter: {
            configurable: !0
        }
    };
    Di.prototype.getCoordinates = function() {
        return this._ptDist.getCoordinates();
    }, Di.prototype.setDensifyFraction = function(t) {
        if (t > 1 || t <= 0) throw new m("Fraction is not in range (0.0 - 1.0]");
        this._densifyFrac = t;
    }, Di.prototype.compute = function(t, e) {
        this.computeOrientedDistance(t, e, this._ptDist), this.computeOrientedDistance(e, t, this._ptDist);
    }, Di.prototype.distance = function() {
        return this.compute(this._g0, this._g1), this._ptDist.getDistance();
    }, Di.prototype.computeOrientedDistance = function(t, e, n) {
        var i = new Ai(e);
        if (t.apply(i), n.setMaximum(i.getMaxPointDistance()), this._densifyFrac > 0) {
            var r = new Fi(e, this._densifyFrac);
            t.apply(r), n.setMaximum(r.getMaxPointDistance());
        }
    }, Di.prototype.orientedDistance = function() {
        return this.computeOrientedDistance(this._g0, this._g1, this._ptDist), this._ptDist.getDistance();
    }, Di.prototype.interfaces_ = function() {
        return [];
    }, Di.prototype.getClass = function() {
        return Di;
    }, Di.distance = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            return new Di(t, e).distance();
        }
        if (3 === arguments.length) {
            var n = arguments[0], i = arguments[1], r = arguments[2], o = new Di(n, i);
            return o.setDensifyFraction(r), o.distance();
        }
    }, Mi.MaxPointDistanceFilter.get = function() {
        return Ai;
    }, Mi.MaxDensifiedByFractionDistanceFilter.get = function() {
        return Fi;
    }, Object.defineProperties(Di, Mi);
    var Ai = function() {
        this._maxPtDist = new Ri, this._minPtDist = new Ri, this._euclideanDist = new Pi, this._geom = null;
        var t = arguments[0];
        this._geom = t;
    };
    Ai.prototype.filter = function(t) {
        this._minPtDist.initialize(), Pi.computeDistance(this._geom, t, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, Ai.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, Ai.prototype.interfaces_ = function() {
        return [
            ft
        ];
    }, Ai.prototype.getClass = function() {
        return Ai;
    };
    var Fi = function() {
        this._maxPtDist = new Ri, this._minPtDist = new Ri, this._geom = null, this._numSubSegs = 0;
        var t = arguments[0], e = arguments[1];
        this._geom = t, this._numSubSegs = Math.trunc(Math.round(1 / e));
    };
    Fi.prototype.filter = function(t, e) {
        if (0 === e) return null;
        for(var n = t.getCoordinate(e - 1), i = t.getCoordinate(e), r = (i.x - n.x) / this._numSubSegs, o = (i.y - n.y) / this._numSubSegs, s = 0; s < this._numSubSegs; s++){
            var a = n.x + s * r, u = n.y + s * o, l = new C(a, u);
            this._minPtDist.initialize(), Pi.computeDistance(this._geom, l, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
        }
    }, Fi.prototype.isDone = function() {
        return !1;
    }, Fi.prototype.isGeometryChanged = function() {
        return !1;
    }, Fi.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, Fi.prototype.interfaces_ = function() {
        return [
            Ut
        ];
    }, Fi.prototype.getClass = function() {
        return Fi;
    };
    var Gi = function(t, e, n) {
        this._minValidDistance = null, this._maxValidDistance = null, this._minDistanceFound = null, this._maxDistanceFound = null, this._isValid = !0, this._errMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = t || null, this._bufDistance = e || null, this._result = n || null;
    }, qi = {
        VERBOSE: {
            configurable: !0
        },
        MAX_DISTANCE_DIFF_FRAC: {
            configurable: !0
        }
    };
    Gi.prototype.checkMaximumDistance = function(t, e, n) {
        var i = new Di(e, t);
        if (i.setDensifyFraction(.25), this._maxDistanceFound = i.orientedDistance(), this._maxDistanceFound > n) {
            this._isValid = !1;
            var r = i.getCoordinates();
            this._errorLocation = r[1], this._errorIndicator = t.getFactory().createLineString(r), this._errMsg = "Distance between buffer curve and input is too large (" + this._maxDistanceFound + " at " + Z.toLineString(r[0], r[1]) + ")";
        }
    }, Gi.prototype.isValid = function() {
        var t = Math.abs(this._bufDistance), e = Gi.MAX_DISTANCE_DIFF_FRAC * t;
        return this._minValidDistance = t - e, this._maxValidDistance = t + e, !(!this._input.isEmpty() && !this._result.isEmpty()) || (this._bufDistance > 0 ? this.checkPositiveValid() : this.checkNegativeValid(), Gi.VERBOSE && Y.out.println("Min Dist= " + this._minDistanceFound + "  err= " + (1 - this._minDistanceFound / this._bufDistance) + "  Max Dist= " + this._maxDistanceFound + "  err= " + (this._maxDistanceFound / this._bufDistance - 1)), this._isValid);
    }, Gi.prototype.checkNegativeValid = function() {
        if (!(this._input instanceof $t || this._input instanceof ne || this._input instanceof zt)) return null;
        var t = this.getPolygonLines(this._input);
        if (this.checkMinimumDistance(t, this._result, this._minValidDistance), !this._isValid) return null;
        this.checkMaximumDistance(t, this._result, this._maxValidDistance);
    }, Gi.prototype.getErrorIndicator = function() {
        return this._errorIndicator;
    }, Gi.prototype.checkMinimumDistance = function(t, e, n) {
        var i = new Ti(t, e, n);
        if (this._minDistanceFound = i.distance(), this._minDistanceFound < n) {
            this._isValid = !1;
            var r = i.nearestPoints();
            this._errorLocation = i.nearestPoints()[1], this._errorIndicator = t.getFactory().createLineString(r), this._errMsg = "Distance between buffer curve and input is too small (" + this._minDistanceFound + " at " + Z.toLineString(r[0], r[1]) + " )";
        }
    }, Gi.prototype.checkPositiveValid = function() {
        var t = this._result.getBoundary();
        if (this.checkMinimumDistance(this._input, t, this._minValidDistance), !this._isValid) return null;
        this.checkMaximumDistance(this._input, t, this._maxValidDistance);
    }, Gi.prototype.getErrorLocation = function() {
        return this._errorLocation;
    }, Gi.prototype.getPolygonLines = function(t) {
        for(var e = new Nt, n = new Ci(e), i = Ni.getPolygons(t).iterator(); i.hasNext();)i.next().apply(n);
        return t.getFactory().buildGeometry(e);
    }, Gi.prototype.getErrorMessage = function() {
        return this._errMsg;
    }, Gi.prototype.interfaces_ = function() {
        return [];
    }, Gi.prototype.getClass = function() {
        return Gi;
    }, qi.VERBOSE.get = function() {
        return !1;
    }, qi.MAX_DISTANCE_DIFF_FRAC.get = function() {
        return .012;
    }, Object.defineProperties(Gi, qi);
    var Bi = function(t, e, n) {
        this._isValid = !0, this._errorMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = t || null, this._distance = e || null, this._result = n || null;
    }, Vi = {
        VERBOSE: {
            configurable: !0
        },
        MAX_ENV_DIFF_FRAC: {
            configurable: !0
        }
    };
    Bi.prototype.isValid = function() {
        return this.checkPolygonal(), this._isValid ? (this.checkExpectedEmpty(), this._isValid ? (this.checkEnvelope(), this._isValid ? (this.checkArea(), this._isValid ? (this.checkDistance(), this._isValid) : this._isValid) : this._isValid) : this._isValid) : this._isValid;
    }, Bi.prototype.checkEnvelope = function() {
        if (this._distance < 0) return null;
        var t = this._distance * Bi.MAX_ENV_DIFF_FRAC;
        0 === t && (t = .001);
        var e = new j(this._input.getEnvelopeInternal());
        e.expandBy(this._distance);
        var n = new j(this._result.getEnvelopeInternal());
        n.expandBy(t), n.contains(e) || (this._isValid = !1, this._errorMsg = "Buffer envelope is incorrect", this._errorIndicator = this._input.getFactory().toGeometry(n)), this.report("Envelope");
    }, Bi.prototype.checkDistance = function() {
        var t = new Gi(this._input, this._distance, this._result);
        t.isValid() || (this._isValid = !1, this._errorMsg = t.getErrorMessage(), this._errorLocation = t.getErrorLocation(), this._errorIndicator = t.getErrorIndicator()), this.report("Distance");
    }, Bi.prototype.checkArea = function() {
        var t = this._input.getArea(), e = this._result.getArea();
        this._distance > 0 && t > e && (this._isValid = !1, this._errorMsg = "Area of positive buffer is smaller than input", this._errorIndicator = this._result), this._distance < 0 && t < e && (this._isValid = !1, this._errorMsg = "Area of negative buffer is larger than input", this._errorIndicator = this._result), this.report("Area");
    }, Bi.prototype.checkPolygonal = function() {
        this._result instanceof $t || this._result instanceof ne || (this._isValid = !1), this._errorMsg = "Result is not polygonal", this._errorIndicator = this._result, this.report("Polygonal");
    }, Bi.prototype.getErrorIndicator = function() {
        return this._errorIndicator;
    }, Bi.prototype.getErrorLocation = function() {
        return this._errorLocation;
    }, Bi.prototype.checkExpectedEmpty = function() {
        return this._input.getDimension() >= 2 ? null : this._distance > 0 ? null : (this._result.isEmpty() || (this._isValid = !1, this._errorMsg = "Result is non-empty", this._errorIndicator = this._result), void this.report("ExpectedEmpty"));
    }, Bi.prototype.report = function(t) {
        if (!Bi.VERBOSE) return null;
        Y.out.println("Check " + t + ": " + (this._isValid ? "passed" : "FAILED"));
    }, Bi.prototype.getErrorMessage = function() {
        return this._errorMsg;
    }, Bi.prototype.interfaces_ = function() {
        return [];
    }, Bi.prototype.getClass = function() {
        return Bi;
    }, Bi.isValidMsg = function(t, e, n) {
        var i = new Bi(t, e, n);
        return i.isValid() ? null : i.getErrorMessage();
    }, Bi.isValid = function(t, e, n) {
        return !!new Bi(t, e, n).isValid();
    }, Vi.VERBOSE.get = function() {
        return !1;
    }, Vi.MAX_ENV_DIFF_FRAC.get = function() {
        return .012;
    }, Object.defineProperties(Bi, Vi);
    var Ui = function() {
        this._pts = null, this._data = null;
        var t = arguments[0], e = arguments[1];
        this._pts = t, this._data = e;
    };
    Ui.prototype.getCoordinates = function() {
        return this._pts;
    }, Ui.prototype.size = function() {
        return this._pts.length;
    }, Ui.prototype.getCoordinate = function(t) {
        return this._pts[t];
    }, Ui.prototype.isClosed = function() {
        return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }, Ui.prototype.getSegmentOctant = function(t) {
        return t === this._pts.length - 1 ? -1 : pn.octant(this.getCoordinate(t), this.getCoordinate(t + 1));
    }, Ui.prototype.setData = function(t) {
        this._data = t;
    }, Ui.prototype.getData = function() {
        return this._data;
    }, Ui.prototype.toString = function() {
        return Z.toLineString(new ue(this._pts));
    }, Ui.prototype.interfaces_ = function() {
        return [
            hn
        ];
    }, Ui.prototype.getClass = function() {
        return Ui;
    };
    var zi = function() {
        this._findAllIntersections = !1, this._isCheckEndSegmentsOnly = !1, this._li = null, this._interiorIntersection = null, this._intSegments = null, this._intersections = new Nt, this._intersectionCount = 0, this._keepIntersections = !0;
        var t = arguments[0];
        this._li = t, this._interiorIntersection = null;
    };
    zi.prototype.getInteriorIntersection = function() {
        return this._interiorIntersection;
    }, zi.prototype.setCheckEndSegmentsOnly = function(t) {
        this._isCheckEndSegmentsOnly = t;
    }, zi.prototype.getIntersectionSegments = function() {
        return this._intSegments;
    }, zi.prototype.count = function() {
        return this._intersectionCount;
    }, zi.prototype.getIntersections = function() {
        return this._intersections;
    }, zi.prototype.setFindAllIntersections = function(t) {
        this._findAllIntersections = t;
    }, zi.prototype.setKeepIntersections = function(t) {
        this._keepIntersections = t;
    }, zi.prototype.processIntersections = function(t, e, n, i) {
        if (!this._findAllIntersections && this.hasIntersection()) return null;
        if (t === n && e === i) return null;
        if (this._isCheckEndSegmentsOnly) {
            if (!(this.isEndSegment(t, e) || this.isEndSegment(n, i))) return null;
        }
        var r = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[i], a = n.getCoordinates()[i + 1];
        this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && this._li.isInteriorIntersection() && (this._intSegments = new Array(4).fill(null), this._intSegments[0] = r, this._intSegments[1] = o, this._intSegments[2] = s, this._intSegments[3] = a, this._interiorIntersection = this._li.getIntersection(0), this._keepIntersections && this._intersections.add(this._interiorIntersection), this._intersectionCount++);
    }, zi.prototype.isEndSegment = function(t, e) {
        return 0 === e || e >= t.size() - 2;
    }, zi.prototype.hasIntersection = function() {
        return null !== this._interiorIntersection;
    }, zi.prototype.isDone = function() {
        return !this._findAllIntersections && null !== this._interiorIntersection;
    }, zi.prototype.interfaces_ = function() {
        return [
            Wn
        ];
    }, zi.prototype.getClass = function() {
        return zi;
    }, zi.createAllIntersectionsFinder = function(t) {
        var e = new zi(t);
        return e.setFindAllIntersections(!0), e;
    }, zi.createAnyIntersectionFinder = function(t) {
        return new zi(t);
    }, zi.createIntersectionCounter = function(t) {
        var e = new zi(t);
        return e.setFindAllIntersections(!0), e.setKeepIntersections(!1), e;
    };
    var Xi = function() {
        this._li = new rt, this._segStrings = null, this._findAllIntersections = !1, this._segInt = null, this._isValid = !0;
        var t = arguments[0];
        this._segStrings = t;
    };
    Xi.prototype.execute = function() {
        if (null !== this._segInt) return null;
        this.checkInteriorIntersections();
    }, Xi.prototype.getIntersections = function() {
        return this._segInt.getIntersections();
    }, Xi.prototype.isValid = function() {
        return this.execute(), this._isValid;
    }, Xi.prototype.setFindAllIntersections = function(t) {
        this._findAllIntersections = t;
    }, Xi.prototype.checkInteriorIntersections = function() {
        this._isValid = !0, this._segInt = new zi(this._li), this._segInt.setFindAllIntersections(this._findAllIntersections);
        var t = new xn;
        if (t.setSegmentIntersector(this._segInt), t.computeNodes(this._segStrings), this._segInt.hasIntersection()) return this._isValid = !1, null;
    }, Xi.prototype.checkValid = function() {
        if (this.execute(), !this._isValid) throw new we(this.getErrorMessage(), this._segInt.getInteriorIntersection());
    }, Xi.prototype.getErrorMessage = function() {
        if (this._isValid) return "no intersections found";
        var t = this._segInt.getIntersectionSegments();
        return "found non-noded intersection between " + Z.toLineString(t[0], t[1]) + " and " + Z.toLineString(t[2], t[3]);
    }, Xi.prototype.interfaces_ = function() {
        return [];
    }, Xi.prototype.getClass = function() {
        return Xi;
    }, Xi.computeIntersections = function(t) {
        var e = new Xi(t);
        return e.setFindAllIntersections(!0), e.isValid(), e.getIntersections();
    };
    var Yi = function t() {
        this._nv = null;
        var e = arguments[0];
        this._nv = new Xi(t.toSegmentStrings(e));
    };
    Yi.prototype.checkValid = function() {
        this._nv.checkValid();
    }, Yi.prototype.interfaces_ = function() {
        return [];
    }, Yi.prototype.getClass = function() {
        return Yi;
    }, Yi.toSegmentStrings = function(t) {
        for(var e = new Nt, n = t.iterator(); n.hasNext();){
            var i = n.next();
            e.add(new Ui(i.getCoordinates(), i));
        }
        return e;
    }, Yi.checkValid = function(t) {
        new Yi(t).checkValid();
    };
    var ki = function(t) {
        this._mapOp = t;
    };
    ki.prototype.map = function(t) {
        for(var e = new Nt, n = 0; n < t.getNumGeometries(); n++){
            var i = this._mapOp.map(t.getGeometryN(n));
            i.isEmpty() || e.add(i);
        }
        return t.getFactory().createGeometryCollection(_e.toGeometryArray(e));
    }, ki.prototype.interfaces_ = function() {
        return [];
    }, ki.prototype.getClass = function() {
        return ki;
    }, ki.map = function(t, e) {
        return new ki(e).map(t);
    };
    var ji = function() {
        this._op = null, this._geometryFactory = null, this._ptLocator = null, this._lineEdgesList = new Nt, this._resultLineList = new Nt;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._op = t, this._geometryFactory = e, this._ptLocator = n;
    };
    ji.prototype.collectLines = function(t) {
        for(var e = this._op.getGraph().getEdgeEnds().iterator(); e.hasNext();){
            var n = e.next();
            this.collectLineEdge(n, t, this._lineEdgesList), this.collectBoundaryTouchEdge(n, t, this._lineEdgesList);
        }
    }, ji.prototype.labelIsolatedLine = function(t, e) {
        var n = this._ptLocator.locate(t.getCoordinate(), this._op.getArgGeometry(e));
        t.getLabel().setLocation(e, n);
    }, ji.prototype.build = function(t) {
        return this.findCoveredLineEdges(), this.collectLines(t), this.buildLines(t), this._resultLineList;
    }, ji.prototype.collectLineEdge = function(t, e, n) {
        var i = t.getLabel(), r = t.getEdge();
        t.isLineEdge() && (t.isVisited() || !Lr.isResultOfOp(i, e) || r.isCovered() || (n.add(r), t.setVisitedEdge(!0)));
    }, ji.prototype.findCoveredLineEdges = function() {
        for(var t = this._op.getGraph().getNodes().iterator(); t.hasNext();)t.next().getEdges().findCoveredLineEdges();
        for(var e = this._op.getGraph().getEdgeEnds().iterator(); e.hasNext();){
            var n = e.next(), i = n.getEdge();
            if (n.isLineEdge() && !i.isCoveredSet()) {
                var r = this._op.isCoveredByA(n.getCoordinate());
                i.setCovered(r);
            }
        }
    }, ji.prototype.labelIsolatedLines = function(t) {
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next(), i = n.getLabel();
            n.isIsolated() && (i.isNull(0) ? this.labelIsolatedLine(n, 0) : this.labelIsolatedLine(n, 1));
        }
    }, ji.prototype.buildLines = function(t) {
        for(var e = this._lineEdgesList.iterator(); e.hasNext();){
            var n = e.next(), i = this._geometryFactory.createLineString(n.getCoordinates());
            this._resultLineList.add(i), n.setInResult(!0);
        }
    }, ji.prototype.collectBoundaryTouchEdge = function(t, e, n) {
        var i = t.getLabel();
        return t.isLineEdge() ? null : t.isVisited() ? null : t.isInteriorAreaEdge() ? null : t.getEdge().isInResult() ? null : (et.isTrue(!(t.isInResult() || t.getSym().isInResult()) || !t.getEdge().isInResult()), void (Lr.isResultOfOp(i, e) && e === Lr.INTERSECTION && (n.add(t.getEdge()), t.setVisitedEdge(!0))));
    }, ji.prototype.interfaces_ = function() {
        return [];
    }, ji.prototype.getClass = function() {
        return ji;
    };
    var Hi = function() {
        this._op = null, this._geometryFactory = null, this._resultPointList = new Nt;
        var t = arguments[0], e = arguments[1];
        this._op = t, this._geometryFactory = e;
    };
    Hi.prototype.filterCoveredNodeToPoint = function(t) {
        var e = t.getCoordinate();
        if (!this._op.isCoveredByLA(e)) {
            var n = this._geometryFactory.createPoint(e);
            this._resultPointList.add(n);
        }
    }, Hi.prototype.extractNonCoveredResultNodes = function(t) {
        for(var e = this._op.getGraph().getNodes().iterator(); e.hasNext();){
            var n = e.next();
            if (!n.isInResult() && !n.isIncidentEdgeInResult() && (0 === n.getEdges().getDegree() || t === Lr.INTERSECTION)) {
                var i = n.getLabel();
                Lr.isResultOfOp(i, t) && this.filterCoveredNodeToPoint(n);
            }
        }
    }, Hi.prototype.build = function(t) {
        return this.extractNonCoveredResultNodes(t), this._resultPointList;
    }, Hi.prototype.interfaces_ = function() {
        return [];
    }, Hi.prototype.getClass = function() {
        return Hi;
    };
    var Wi = function() {
        this._inputGeom = null, this._factory = null, this._pruneEmptyGeometry = !0, this._preserveGeometryCollectionType = !0, this._preserveCollections = !1, this._preserveType = !1;
    };
    Wi.prototype.transformPoint = function(t, e) {
        return this._factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(), t));
    }, Wi.prototype.transformPolygon = function(t, e) {
        var n = !0, i = this.transformLinearRing(t.getExteriorRing(), t);
        null !== i && i instanceof ee && !i.isEmpty() || (n = !1);
        for(var r = new Nt, o = 0; o < t.getNumInteriorRing(); o++){
            var s = this.transformLinearRing(t.getInteriorRingN(o), t);
            null === s || s.isEmpty() || (s instanceof ee || (n = !1), r.add(s));
        }
        if (n) return this._factory.createPolygon(i, r.toArray([]));
        var a = new Nt;
        return null !== i && a.add(i), a.addAll(r), this._factory.buildGeometry(a);
    }, Wi.prototype.createCoordinateSequence = function(t) {
        return this._factory.getCoordinateSequenceFactory().create(t);
    }, Wi.prototype.getInputGeometry = function() {
        return this._inputGeom;
    }, Wi.prototype.transformMultiLineString = function(t, e) {
        for(var n = new Nt, i = 0; i < t.getNumGeometries(); i++){
            var r = this.transformLineString(t.getGeometryN(i), t);
            null !== r && (r.isEmpty() || n.add(r));
        }
        return this._factory.buildGeometry(n);
    }, Wi.prototype.transformCoordinates = function(t, e) {
        return this.copy(t);
    }, Wi.prototype.transformLineString = function(t, e) {
        return this._factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(), t));
    }, Wi.prototype.transformMultiPoint = function(t, e) {
        for(var n = new Nt, i = 0; i < t.getNumGeometries(); i++){
            var r = this.transformPoint(t.getGeometryN(i), t);
            null !== r && (r.isEmpty() || n.add(r));
        }
        return this._factory.buildGeometry(n);
    }, Wi.prototype.transformMultiPolygon = function(t, e) {
        for(var n = new Nt, i = 0; i < t.getNumGeometries(); i++){
            var r = this.transformPolygon(t.getGeometryN(i), t);
            null !== r && (r.isEmpty() || n.add(r));
        }
        return this._factory.buildGeometry(n);
    }, Wi.prototype.copy = function(t) {
        return t.copy();
    }, Wi.prototype.transformGeometryCollection = function(t, e) {
        for(var n = new Nt, i = 0; i < t.getNumGeometries(); i++){
            var r = this.transform(t.getGeometryN(i));
            null !== r && (this._pruneEmptyGeometry && r.isEmpty() || n.add(r));
        }
        return this._preserveGeometryCollectionType ? this._factory.createGeometryCollection(_e.toGeometryArray(n)) : this._factory.buildGeometry(n);
    }, Wi.prototype.transform = function(t) {
        if (this._inputGeom = t, this._factory = t.getFactory(), t instanceof Qt) return this.transformPoint(t, null);
        if (t instanceof te) return this.transformMultiPoint(t, null);
        if (t instanceof ee) return this.transformLinearRing(t, null);
        if (t instanceof Kt) return this.transformLineString(t, null);
        if (t instanceof Xt) return this.transformMultiLineString(t, null);
        if (t instanceof $t) return this.transformPolygon(t, null);
        if (t instanceof ne) return this.transformMultiPolygon(t, null);
        if (t instanceof zt) return this.transformGeometryCollection(t, null);
        throw new m("Unknown Geometry subtype: " + t.getClass().getName());
    }, Wi.prototype.transformLinearRing = function(t, e) {
        var n = this.transformCoordinates(t.getCoordinateSequence(), t);
        if (null === n) return this._factory.createLinearRing(null);
        var i = n.size();
        return i > 0 && i < 4 && !this._preserveType ? this._factory.createLineString(n) : this._factory.createLinearRing(n);
    }, Wi.prototype.interfaces_ = function() {
        return [];
    }, Wi.prototype.getClass = function() {
        return Wi;
    };
    var Ki = function t() {
        if (this._snapTolerance = 0, this._srcPts = null, this._seg = new dn, this._allowSnappingToSourceVertices = !1, this._isClosed = !1, arguments[0] instanceof Kt && "number" == typeof arguments[1]) {
            var e = arguments[0], n = arguments[1];
            t.call(this, e.getCoordinates(), n);
        } else if (arguments[0] instanceof Array && "number" == typeof arguments[1]) {
            var i = arguments[0], r = arguments[1];
            this._srcPts = i, this._isClosed = t.isClosed(i), this._snapTolerance = r;
        }
    };
    Ki.prototype.snapVertices = function(t, e) {
        for(var n = this._isClosed ? t.size() - 1 : t.size(), i = 0; i < n; i++){
            var r = t.get(i), o = this.findSnapForVertex(r, e);
            null !== o && (t.set(i, new C(o)), 0 === i && this._isClosed && t.set(t.size() - 1, new C(o)));
        }
    }, Ki.prototype.findSnapForVertex = function(t, e) {
        for(var n = 0; n < e.length; n++){
            if (t.equals2D(e[n])) return null;
            if (t.distance(e[n]) < this._snapTolerance) return e[n];
        }
        return null;
    }, Ki.prototype.snapTo = function(t) {
        var e = new St(this._srcPts);
        this.snapVertices(e, t), this.snapSegments(e, t);
        return e.toCoordinateArray();
    }, Ki.prototype.snapSegments = function(t, e) {
        if (0 === e.length) return null;
        var n = e.length;
        e[0].equals2D(e[e.length - 1]) && (n = e.length - 1);
        for(var i = 0; i < n; i++){
            var r = e[i], o = this.findSegmentIndexToSnap(r, t);
            o >= 0 && t.add(o + 1, new C(r), !1);
        }
    }, Ki.prototype.findSegmentIndexToSnap = function(t, e) {
        for(var n = v.MAX_VALUE, i = -1, r = 0; r < e.size() - 1; r++){
            if (this._seg.p0 = e.get(r), this._seg.p1 = e.get(r + 1), this._seg.p0.equals2D(t) || this._seg.p1.equals2D(t)) {
                if (this._allowSnappingToSourceVertices) continue;
                return -1;
            }
            var o = this._seg.distance(t);
            o < this._snapTolerance && o < n && (n = o, i = r);
        }
        return i;
    }, Ki.prototype.setAllowSnappingToSourceVertices = function(t) {
        this._allowSnappingToSourceVertices = t;
    }, Ki.prototype.interfaces_ = function() {
        return [];
    }, Ki.prototype.getClass = function() {
        return Ki;
    }, Ki.isClosed = function(t) {
        return !(t.length <= 1) && t[0].equals2D(t[t.length - 1]);
    };
    var Ji = function(t) {
        this._srcGeom = t || null;
    }, Qi = {
        SNAP_PRECISION_FACTOR: {
            configurable: !0
        }
    };
    Ji.prototype.snapTo = function(t, e) {
        var n = this.extractTargetCoordinates(t);
        return new Zi(e, n).transform(this._srcGeom);
    }, Ji.prototype.snapToSelf = function(t, e) {
        var n = this.extractTargetCoordinates(this._srcGeom), i = new Zi(t, n, !0).transform(this._srcGeom), r = i;
        return e && T(r, Zt) && (r = i.buffer(0)), r;
    }, Ji.prototype.computeSnapTolerance = function(t) {
        return this.computeMinimumSegmentLength(t) / 10;
    }, Ji.prototype.extractTargetCoordinates = function(t) {
        for(var e = new f, n = t.getCoordinates(), i = 0; i < n.length; i++)e.add(n[i]);
        return e.toArray(new Array(0).fill(null));
    }, Ji.prototype.computeMinimumSegmentLength = function(t) {
        for(var e = v.MAX_VALUE, n = 0; n < t.length - 1; n++){
            var i = t[n].distance(t[n + 1]);
            i < e && (e = i);
        }
        return e;
    }, Ji.prototype.interfaces_ = function() {
        return [];
    }, Ji.prototype.getClass = function() {
        return Ji;
    }, Ji.snap = function(t, e, n) {
        var i = new Array(2).fill(null), r = new Ji(t);
        i[0] = r.snapTo(e, n);
        var o = new Ji(e);
        return i[1] = o.snapTo(i[0], n), i;
    }, Ji.computeOverlaySnapTolerance = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = Ji.computeSizeBasedSnapTolerance(t), n = t.getPrecisionModel();
            if (n.getType() === fe.FIXED) {
                var i = 1 / n.getScale() * 2 / 1.415;
                i > e && (e = i);
            }
            return e;
        }
        if (2 === arguments.length) {
            var r = arguments[0], o = arguments[1];
            return Math.min(Ji.computeOverlaySnapTolerance(r), Ji.computeOverlaySnapTolerance(o));
        }
    }, Ji.computeSizeBasedSnapTolerance = function(t) {
        var e = t.getEnvelopeInternal();
        return Math.min(e.getHeight(), e.getWidth()) * Ji.SNAP_PRECISION_FACTOR;
    }, Ji.snapToSelf = function(t, e, n) {
        return new Ji(t).snapToSelf(e, n);
    }, Qi.SNAP_PRECISION_FACTOR.get = function() {
        return 1e-9;
    }, Object.defineProperties(Ji, Qi);
    var Zi = function(t) {
        function e(e, n, i) {
            t.call(this), this._snapTolerance = e || null, this._snapPts = n || null, this._isSelfSnap = void 0 !== i && i;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.snapLine = function(t, e) {
            var n = new Ki(t, this._snapTolerance);
            return n.setAllowSnappingToSourceVertices(this._isSelfSnap), n.snapTo(e);
        }, e.prototype.transformCoordinates = function(t, e) {
            var n = t.toCoordinateArray(), i = this.snapLine(n, this._snapPts);
            return this._factory.getCoordinateSequenceFactory().create(i);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Wi), $i = function() {
        this._isFirst = !0, this._commonMantissaBitsCount = 53, this._commonBits = 0, this._commonSignExp = null;
    };
    $i.prototype.getCommon = function() {
        return v.longBitsToDouble(this._commonBits);
    }, $i.prototype.add = function(t) {
        var e = v.doubleToLongBits(t);
        if (this._isFirst) return this._commonBits = e, this._commonSignExp = $i.signExpBits(this._commonBits), this._isFirst = !1, null;
        if ($i.signExpBits(e) !== this._commonSignExp) return this._commonBits = 0, null;
        this._commonMantissaBitsCount = $i.numCommonMostSigMantissaBits(this._commonBits, e), this._commonBits = $i.zeroLowerBits(this._commonBits, 64 - (12 + this._commonMantissaBitsCount));
    }, $i.prototype.toString = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = v.longBitsToDouble(t), n = "0000000000000000000000000000000000000000000000000000000000000000" + v.toBinaryString(t), i = n.substring(n.length - 64);
            return i.substring(0, 1) + "  " + i.substring(1, 12) + "(exp) " + i.substring(12) + " [ " + e + " ]";
        }
    }, $i.prototype.interfaces_ = function() {
        return [];
    }, $i.prototype.getClass = function() {
        return $i;
    }, $i.getBit = function(t, e) {
        return 0 != (t & 1 << e) ? 1 : 0;
    }, $i.signExpBits = function(t) {
        return t >> 52;
    }, $i.zeroLowerBits = function(t, e) {
        return t & ~((1 << e) - 1);
    }, $i.numCommonMostSigMantissaBits = function(t, e) {
        for(var n = 0, i = 52; i >= 0; i--){
            if ($i.getBit(t, i) !== $i.getBit(e, i)) return n;
            n++;
        }
        return 52;
    };
    var tr = function() {
        this._commonCoord = null, this._ccFilter = new nr;
    }, er = {
        CommonCoordinateFilter: {
            configurable: !0
        },
        Translater: {
            configurable: !0
        }
    };
    tr.prototype.addCommonBits = function(t) {
        var e = new ir(this._commonCoord);
        t.apply(e), t.geometryChanged();
    }, tr.prototype.removeCommonBits = function(t) {
        if (0 === this._commonCoord.x && 0 === this._commonCoord.y) return t;
        var e = new C(this._commonCoord);
        e.x = -e.x, e.y = -e.y;
        var n = new ir(e);
        return t.apply(n), t.geometryChanged(), t;
    }, tr.prototype.getCommonCoordinate = function() {
        return this._commonCoord;
    }, tr.prototype.add = function(t) {
        t.apply(this._ccFilter), this._commonCoord = this._ccFilter.getCommonCoordinate();
    }, tr.prototype.interfaces_ = function() {
        return [];
    }, tr.prototype.getClass = function() {
        return tr;
    }, er.CommonCoordinateFilter.get = function() {
        return nr;
    }, er.Translater.get = function() {
        return ir;
    }, Object.defineProperties(tr, er);
    var nr = function() {
        this._commonBitsX = new $i, this._commonBitsY = new $i;
    };
    nr.prototype.filter = function(t) {
        this._commonBitsX.add(t.x), this._commonBitsY.add(t.y);
    }, nr.prototype.getCommonCoordinate = function() {
        return new C(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
    }, nr.prototype.interfaces_ = function() {
        return [
            ft
        ];
    }, nr.prototype.getClass = function() {
        return nr;
    };
    var ir = function() {
        this.trans = null;
        var t = arguments[0];
        this.trans = t;
    };
    ir.prototype.filter = function(t, e) {
        var n = t.getOrdinate(e, 0) + this.trans.x, i = t.getOrdinate(e, 1) + this.trans.y;
        t.setOrdinate(e, 0, n), t.setOrdinate(e, 1, i);
    }, ir.prototype.isDone = function() {
        return !1;
    }, ir.prototype.isGeometryChanged = function() {
        return !0;
    }, ir.prototype.interfaces_ = function() {
        return [
            Ut
        ];
    }, ir.prototype.getClass = function() {
        return ir;
    };
    var rr = function(t, e) {
        this._geom = new Array(2).fill(null), this._snapTolerance = null, this._cbr = null, this._geom[0] = t, this._geom[1] = e, this.computeSnapTolerance();
    };
    rr.prototype.selfSnap = function(t) {
        return new Ji(t).snapTo(t, this._snapTolerance);
    }, rr.prototype.removeCommonBits = function(t) {
        this._cbr = new tr, this._cbr.add(t[0]), this._cbr.add(t[1]);
        var e = new Array(2).fill(null);
        return e[0] = this._cbr.removeCommonBits(t[0].copy()), e[1] = this._cbr.removeCommonBits(t[1].copy()), e;
    }, rr.prototype.prepareResult = function(t) {
        return this._cbr.addCommonBits(t), t;
    }, rr.prototype.getResultGeometry = function(t) {
        var e = this.snap(this._geom), n = Lr.overlayOp(e[0], e[1], t);
        return this.prepareResult(n);
    }, rr.prototype.checkValid = function(t) {
        t.isValid() || Y.out.println("Snapped geometry is invalid");
    }, rr.prototype.computeSnapTolerance = function() {
        this._snapTolerance = Ji.computeOverlaySnapTolerance(this._geom[0], this._geom[1]);
    }, rr.prototype.snap = function(t) {
        var e = this.removeCommonBits(t);
        return Ji.snap(e[0], e[1], this._snapTolerance);
    }, rr.prototype.interfaces_ = function() {
        return [];
    }, rr.prototype.getClass = function() {
        return rr;
    }, rr.overlayOp = function(t, e, n) {
        return new rr(t, e).getResultGeometry(n);
    }, rr.union = function(t, e) {
        return rr.overlayOp(t, e, Lr.UNION);
    }, rr.intersection = function(t, e) {
        return rr.overlayOp(t, e, Lr.INTERSECTION);
    }, rr.symDifference = function(t, e) {
        return rr.overlayOp(t, e, Lr.SYMDIFFERENCE);
    }, rr.difference = function(t, e) {
        return rr.overlayOp(t, e, Lr.DIFFERENCE);
    };
    var or = function(t, e) {
        this._geom = new Array(2).fill(null), this._geom[0] = t, this._geom[1] = e;
    };
    or.prototype.getResultGeometry = function(t) {
        var e = null, n = !1, i = null;
        try {
            e = Lr.overlayOp(this._geom[0], this._geom[1], t);
            n = !0;
        } catch (t) {
            if (!(t instanceof $)) throw t;
            i = t;
        }
        if (!n) try {
            e = rr.overlayOp(this._geom[0], this._geom[1], t);
        } catch (t) {
            throw t instanceof $ ? i : t;
        }
        return e;
    }, or.prototype.interfaces_ = function() {
        return [];
    }, or.prototype.getClass = function() {
        return or;
    }, or.overlayOp = function(t, e, n) {
        return new or(t, e).getResultGeometry(n);
    }, or.union = function(t, e) {
        return or.overlayOp(t, e, Lr.UNION);
    }, or.intersection = function(t, e) {
        return or.overlayOp(t, e, Lr.INTERSECTION);
    }, or.symDifference = function(t, e) {
        return or.overlayOp(t, e, Lr.SYMDIFFERENCE);
    }, or.difference = function(t, e) {
        return or.overlayOp(t, e, Lr.DIFFERENCE);
    };
    var sr = function() {
        this.mce = null, this.chainIndex = null;
        var t = arguments[0], e = arguments[1];
        this.mce = t, this.chainIndex = e;
    };
    sr.prototype.computeIntersections = function(t, e) {
        this.mce.computeIntersectsForChain(this.chainIndex, t.mce, t.chainIndex, e);
    }, sr.prototype.interfaces_ = function() {
        return [];
    }, sr.prototype.getClass = function() {
        return sr;
    };
    var ar = function t() {
        if (this._label = null, this._xValue = null, this._eventType = null, this._insertEvent = null, this._deleteEventIndex = null, this._obj = null, 2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this._eventType = t.DELETE, this._xValue = e, this._insertEvent = n;
        } else if (3 === arguments.length) {
            var i = arguments[0], r = arguments[1], o = arguments[2];
            this._eventType = t.INSERT, this._label = i, this._xValue = r, this._obj = o;
        }
    }, ur = {
        INSERT: {
            configurable: !0
        },
        DELETE: {
            configurable: !0
        }
    };
    ar.prototype.isDelete = function() {
        return this._eventType === ar.DELETE;
    }, ar.prototype.setDeleteEventIndex = function(t) {
        this._deleteEventIndex = t;
    }, ar.prototype.getObject = function() {
        return this._obj;
    }, ar.prototype.compareTo = function(t) {
        var e = t;
        return this._xValue < e._xValue ? -1 : this._xValue > e._xValue ? 1 : this._eventType < e._eventType ? -1 : this._eventType > e._eventType ? 1 : 0;
    }, ar.prototype.getInsertEvent = function() {
        return this._insertEvent;
    }, ar.prototype.isInsert = function() {
        return this._eventType === ar.INSERT;
    }, ar.prototype.isSameLabel = function(t) {
        return null !== this._label && this._label === t._label;
    }, ar.prototype.getDeleteEventIndex = function() {
        return this._deleteEventIndex;
    }, ar.prototype.interfaces_ = function() {
        return [
            E
        ];
    }, ar.prototype.getClass = function() {
        return ar;
    }, ur.INSERT.get = function() {
        return 1;
    }, ur.DELETE.get = function() {
        return 2;
    }, Object.defineProperties(ar, ur);
    var lr = function() {};
    lr.prototype.interfaces_ = function() {
        return [];
    }, lr.prototype.getClass = function() {
        return lr;
    };
    var cr = function() {
        this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._properIntersectionPoint = null, this._li = null, this._includeProper = null, this._recordIsolated = null, this._isSelfIntersection = null, this._numIntersections = 0, this.numTests = 0, this._bdyNodes = null, this._isDone = !1, this._isDoneWhenProperInt = !1;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._li = t, this._includeProper = e, this._recordIsolated = n;
    };
    cr.prototype.isTrivialIntersection = function(t, e, n, i) {
        if (t === n && 1 === this._li.getIntersectionNum()) {
            if (cr.isAdjacentSegments(e, i)) return !0;
            if (t.isClosed()) {
                var r = t.getNumPoints() - 1;
                if (0 === e && i === r || 0 === i && e === r) return !0;
            }
        }
        return !1;
    }, cr.prototype.getProperIntersectionPoint = function() {
        return this._properIntersectionPoint;
    }, cr.prototype.setIsDoneIfProperInt = function(t) {
        this._isDoneWhenProperInt = t;
    }, cr.prototype.hasProperInteriorIntersection = function() {
        return this._hasProperInterior;
    }, cr.prototype.isBoundaryPointInternal = function(t, e) {
        for(var n = e.iterator(); n.hasNext();){
            var i = n.next().getCoordinate();
            if (t.isIntersection(i)) return !0;
        }
        return !1;
    }, cr.prototype.hasProperIntersection = function() {
        return this._hasProper;
    }, cr.prototype.hasIntersection = function() {
        return this._hasIntersection;
    }, cr.prototype.isDone = function() {
        return this._isDone;
    }, cr.prototype.isBoundaryPoint = function(t, e) {
        return null !== e && (!!this.isBoundaryPointInternal(t, e[0]) || !!this.isBoundaryPointInternal(t, e[1]));
    }, cr.prototype.setBoundaryNodes = function(t, e) {
        this._bdyNodes = new Array(2).fill(null), this._bdyNodes[0] = t, this._bdyNodes[1] = e;
    }, cr.prototype.addIntersections = function(t, e, n, i) {
        if (t === n && e === i) return null;
        this.numTests++;
        var r = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[i], a = n.getCoordinates()[i + 1];
        this._li.computeIntersection(r, o, s, a), this._li.hasIntersection() && (this._recordIsolated && (t.setIsolated(!1), n.setIsolated(!1)), this._numIntersections++, this.isTrivialIntersection(t, e, n, i) || (this._hasIntersection = !0, !this._includeProper && this._li.isProper() || (t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1)), this._li.isProper() && (this._properIntersectionPoint = this._li.getIntersection(0).copy(), this._hasProper = !0, this._isDoneWhenProperInt && (this._isDone = !0), this.isBoundaryPoint(this._li, this._bdyNodes) || (this._hasProperInterior = !0))));
    }, cr.prototype.interfaces_ = function() {
        return [];
    }, cr.prototype.getClass = function() {
        return cr;
    }, cr.isAdjacentSegments = function(t, e) {
        return 1 === Math.abs(t - e);
    };
    var pr = function(t) {
        function e() {
            t.call(this), this.events = new Nt, this.nOverlaps = null;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.prepareEvents = function() {
            $e.sort(this.events);
            for(var t = 0; t < this.events.size(); t++){
                var e = this.events.get(t);
                e.isDelete() && e.getInsertEvent().setDeleteEventIndex(t);
            }
        }, e.prototype.computeIntersections = function() {
            if (1 === arguments.length) {
                var t = arguments[0];
                this.nOverlaps = 0, this.prepareEvents();
                for(var e = 0; e < this.events.size(); e++){
                    var n = this.events.get(e);
                    if (n.isInsert() && this.processOverlaps(e, n.getDeleteEventIndex(), n, t), t.isDone()) break;
                }
            } else if (3 === arguments.length) {
                if (arguments[2] instanceof cr && T(arguments[0], xt) && T(arguments[1], xt)) {
                    var i = arguments[0], r = arguments[1], o = arguments[2];
                    this.addEdges(i, i), this.addEdges(r, r), this.computeIntersections(o);
                } else if ("boolean" == typeof arguments[2] && T(arguments[0], xt) && arguments[1] instanceof cr) {
                    var s = arguments[0], a = arguments[1];
                    arguments[2] ? this.addEdges(s, null) : this.addEdges(s), this.computeIntersections(a);
                }
            }
        }, e.prototype.addEdge = function(t, e) {
            for(var n = t.getMonotoneChainEdge(), i = n.getStartIndexes(), r = 0; r < i.length - 1; r++){
                var o = new sr(n, r), s = new ar(e, n.getMinX(r), o);
                this.events.add(s), this.events.add(new ar(n.getMaxX(r), s));
            }
        }, e.prototype.processOverlaps = function(t, e, n, i) {
            for(var r = n.getObject(), o = t; o < e; o++){
                var s = this.events.get(o);
                if (s.isInsert()) {
                    var a = s.getObject();
                    n.isSameLabel(s) || (r.computeIntersections(a, i), this.nOverlaps++);
                }
            }
        }, e.prototype.addEdges = function() {
            if (1 === arguments.length) for(var t = arguments[0].iterator(); t.hasNext();){
                var e = t.next();
                this.addEdge(e, e);
            }
            else if (2 === arguments.length) for(var n = arguments[0], i = arguments[1], r = n.iterator(); r.hasNext();){
                var o = r.next();
                this.addEdge(o, i);
            }
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(lr), hr = function() {
        this._min = v.POSITIVE_INFINITY, this._max = v.NEGATIVE_INFINITY;
    }, fr = {
        NodeComparator: {
            configurable: !0
        }
    };
    hr.prototype.getMin = function() {
        return this._min;
    }, hr.prototype.intersects = function(t, e) {
        return !(this._min > e || this._max < t);
    }, hr.prototype.getMax = function() {
        return this._max;
    }, hr.prototype.toString = function() {
        return Z.toLineString(new C(this._min, 0), new C(this._max, 0));
    }, hr.prototype.interfaces_ = function() {
        return [];
    }, hr.prototype.getClass = function() {
        return hr;
    }, fr.NodeComparator.get = function() {
        return gr;
    }, Object.defineProperties(hr, fr);
    var gr = function() {};
    gr.prototype.compare = function(t, e) {
        var n = t, i = e, r = (n._min + n._max) / 2, o = (i._min + i._max) / 2;
        return r < o ? -1 : r > o ? 1 : 0;
    }, gr.prototype.interfaces_ = function() {
        return [
            N
        ];
    }, gr.prototype.getClass = function() {
        return gr;
    };
    var dr = function(t) {
        function e() {
            t.call(this), this._item = null;
            var e = arguments[0], n = arguments[1], i = arguments[2];
            this._min = e, this._max = n, this._item = i;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.query = function(t, e, n) {
            if (!this.intersects(t, e)) return null;
            n.visitItem(this._item);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(hr), yr = function(t) {
        function e() {
            t.call(this), this._node1 = null, this._node2 = null;
            var e = arguments[0], n = arguments[1];
            this._node1 = e, this._node2 = n, this.buildExtent(this._node1, this._node2);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.buildExtent = function(t, e) {
            this._min = Math.min(t._min, e._min), this._max = Math.max(t._max, e._max);
        }, e.prototype.query = function(t, e, n) {
            if (!this.intersects(t, e)) return null;
            null !== this._node1 && this._node1.query(t, e, n), null !== this._node2 && this._node2.query(t, e, n);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(hr), _r = function() {
        this._leaves = new Nt, this._root = null, this._level = 0;
    };
    _r.prototype.buildTree = function() {
        $e.sort(this._leaves, new hr.NodeComparator);
        for(var t = this._leaves, e = null, n = new Nt;;){
            if (this.buildLevel(t, n), 1 === n.size()) return n.get(0);
            e = t, t = n, n = e;
        }
    }, _r.prototype.insert = function(t, e, n) {
        if (null !== this._root) throw new Error("Index cannot be added to once it has been queried");
        this._leaves.add(new dr(t, e, n));
    }, _r.prototype.query = function(t, e, n) {
        this.init(), this._root.query(t, e, n);
    }, _r.prototype.buildRoot = function() {
        if (null !== this._root) return null;
        this._root = this.buildTree();
    }, _r.prototype.printNode = function(t) {
        Y.out.println(Z.toLineString(new C(t._min, this._level), new C(t._max, this._level)));
    }, _r.prototype.init = function() {
        if (null !== this._root) return null;
        this.buildRoot();
    }, _r.prototype.buildLevel = function(t, e) {
        this._level++, e.clear();
        for(var n = 0; n < t.size(); n += 2){
            var i = t.get(n);
            if (null === (n + 1 < t.size() ? t.get(n) : null)) e.add(i);
            else {
                var r = new yr(t.get(n), t.get(n + 1));
                e.add(r);
            }
        }
    }, _r.prototype.interfaces_ = function() {
        return [];
    }, _r.prototype.getClass = function() {
        return _r;
    };
    var mr = function() {
        this._items = new Nt;
    };
    mr.prototype.visitItem = function(t) {
        this._items.add(t);
    }, mr.prototype.getItems = function() {
        return this._items;
    }, mr.prototype.interfaces_ = function() {
        return [
            Ke
        ];
    }, mr.prototype.getClass = function() {
        return mr;
    };
    var vr = function() {
        this._index = null;
        var t = arguments[0];
        if (!T(t, Zt)) throw new m("Argument must be Polygonal");
        this._index = new xr(t);
    }, Ir = {
        SegmentVisitor: {
            configurable: !0
        },
        IntervalIndexedGeometry: {
            configurable: !0
        }
    };
    vr.prototype.locate = function(t) {
        var e = new st(t), n = new Er(e);
        return this._index.query(t.y, t.y, n), e.getLocation();
    }, vr.prototype.interfaces_ = function() {
        return [
            Vn
        ];
    }, vr.prototype.getClass = function() {
        return vr;
    }, Ir.SegmentVisitor.get = function() {
        return Er;
    }, Ir.IntervalIndexedGeometry.get = function() {
        return xr;
    }, Object.defineProperties(vr, Ir);
    var Er = function() {
        this._counter = null;
        var t = arguments[0];
        this._counter = t;
    };
    Er.prototype.visitItem = function(t) {
        var e = t;
        this._counter.countSegment(e.getCoordinate(0), e.getCoordinate(1));
    }, Er.prototype.interfaces_ = function() {
        return [
            Ke
        ];
    }, Er.prototype.getClass = function() {
        return Er;
    };
    var xr = function() {
        this._index = new _r;
        var t = arguments[0];
        this.init(t);
    };
    xr.prototype.init = function(t) {
        for(var e = Ci.getLines(t).iterator(); e.hasNext();){
            var n = e.next().getCoordinates();
            this.addLine(n);
        }
    }, xr.prototype.addLine = function(t) {
        for(var e = 1; e < t.length; e++){
            var n = new dn(t[e - 1], t[e]), i = Math.min(n.p0.y, n.p1.y), r = Math.max(n.p0.y, n.p1.y);
            this._index.insert(i, r, n);
        }
    }, xr.prototype.query = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = new mr;
            return this._index.query(t, e, n), n.getItems();
        }
        if (3 === arguments.length) {
            var i = arguments[0], r = arguments[1], o = arguments[2];
            this._index.query(i, r, o);
        }
    }, xr.prototype.interfaces_ = function() {
        return [];
    }, xr.prototype.getClass = function() {
        return xr;
    };
    var Nr = function(t) {
        function e() {
            if (t.call(this), this._parentGeom = null, this._lineEdgeMap = new he, this._boundaryNodeRule = null, this._useBoundaryDeterminationRule = !0, this._argIndex = null, this._boundaryNodes = null, this._hasTooFewPoints = !1, this._invalidPoint = null, this._areaPtLocator = null, this._ptLocator = new Si, 2 === arguments.length) {
                var e = arguments[0], n = arguments[1], i = gt.OGC_SFS_BOUNDARY_RULE;
                this._argIndex = e, this._parentGeom = n, this._boundaryNodeRule = i, null !== n && this.add(n);
            } else if (3 === arguments.length) {
                var r = arguments[0], o = arguments[1], s = arguments[2];
                this._argIndex = r, this._parentGeom = o, this._boundaryNodeRule = s, null !== o && this.add(o);
            }
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.insertBoundaryPoint = function(t, n) {
            var i = this._nodes.addNode(n).getLabel(), r = 1;
            w.NONE;
            i.getLocation(t, Se.ON) === w.BOUNDARY && r++;
            var o = e.determineBoundary(this._boundaryNodeRule, r);
            i.setLocation(t, o);
        }, e.prototype.computeSelfNodes = function() {
            if (2 === arguments.length) {
                var t = arguments[0], e = arguments[1];
                return this.computeSelfNodes(t, e, !1);
            }
            if (3 === arguments.length) {
                var n = arguments[0], i = arguments[1], r = arguments[2], o = new cr(n, !0, !1);
                o.setIsDoneIfProperInt(r);
                var s = this.createEdgeSetIntersector(), a = this._parentGeom instanceof ee || this._parentGeom instanceof $t || this._parentGeom instanceof ne, u = i || !a;
                return s.computeIntersections(this._edges, o, u), this.addSelfIntersectionNodes(this._argIndex), o;
            }
        }, e.prototype.computeSplitEdges = function(t) {
            for(var e = this._edges.iterator(); e.hasNext();)e.next().eiList.addSplitEdges(t);
        }, e.prototype.computeEdgeIntersections = function(t, e, n) {
            var i = new cr(e, n, !0);
            i.setBoundaryNodes(this.getBoundaryNodes(), t.getBoundaryNodes());
            return this.createEdgeSetIntersector().computeIntersections(this._edges, t._edges, i), i;
        }, e.prototype.getGeometry = function() {
            return this._parentGeom;
        }, e.prototype.getBoundaryNodeRule = function() {
            return this._boundaryNodeRule;
        }, e.prototype.hasTooFewPoints = function() {
            return this._hasTooFewPoints;
        }, e.prototype.addPoint = function() {
            if (arguments[0] instanceof Qt) {
                var t = arguments[0].getCoordinate();
                this.insertPoint(this._argIndex, t, w.INTERIOR);
            } else if (arguments[0] instanceof C) {
                var e = arguments[0];
                this.insertPoint(this._argIndex, e, w.INTERIOR);
            }
        }, e.prototype.addPolygon = function(t) {
            this.addPolygonRing(t.getExteriorRing(), w.EXTERIOR, w.INTERIOR);
            for(var e = 0; e < t.getNumInteriorRing(); e++){
                var n = t.getInteriorRingN(e);
                this.addPolygonRing(n, w.INTERIOR, w.EXTERIOR);
            }
        }, e.prototype.addEdge = function(t) {
            this.insertEdge(t);
            var e = t.getCoordinates();
            this.insertPoint(this._argIndex, e[0], w.BOUNDARY), this.insertPoint(this._argIndex, e[e.length - 1], w.BOUNDARY);
        }, e.prototype.addLineString = function(t) {
            var e = Lt.removeRepeatedPoints(t.getCoordinates());
            if (e.length < 2) return this._hasTooFewPoints = !0, this._invalidPoint = e[0], null;
            var n = new ni(e, new Pe(this._argIndex, w.INTERIOR));
            this._lineEdgeMap.put(t, n), this.insertEdge(n), et.isTrue(e.length >= 2, "found LineString with single point"), this.insertBoundaryPoint(this._argIndex, e[0]), this.insertBoundaryPoint(this._argIndex, e[e.length - 1]);
        }, e.prototype.getInvalidPoint = function() {
            return this._invalidPoint;
        }, e.prototype.getBoundaryPoints = function() {
            for(var t = this.getBoundaryNodes(), e = new Array(t.size()).fill(null), n = 0, i = t.iterator(); i.hasNext();){
                var r = i.next();
                e[n++] = r.getCoordinate().copy();
            }
            return e;
        }, e.prototype.getBoundaryNodes = function() {
            return null === this._boundaryNodes && (this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex)), this._boundaryNodes;
        }, e.prototype.addSelfIntersectionNode = function(t, e, n) {
            if (this.isBoundaryNode(t, e)) return null;
            n === w.BOUNDARY && this._useBoundaryDeterminationRule ? this.insertBoundaryPoint(t, e) : this.insertPoint(t, e, n);
        }, e.prototype.addPolygonRing = function(t, e, n) {
            if (t.isEmpty()) return null;
            var i = Lt.removeRepeatedPoints(t.getCoordinates());
            if (i.length < 4) return this._hasTooFewPoints = !0, this._invalidPoint = i[0], null;
            var r = e, o = n;
            at.isCCW(i) && (r = n, o = e);
            var s = new ni(i, new Pe(this._argIndex, w.BOUNDARY, r, o));
            this._lineEdgeMap.put(t, s), this.insertEdge(s), this.insertPoint(this._argIndex, i[0], w.BOUNDARY);
        }, e.prototype.insertPoint = function(t, e, n) {
            var i = this._nodes.addNode(e), r = i.getLabel();
            null === r ? i._label = new Pe(t, n) : r.setLocation(t, n);
        }, e.prototype.createEdgeSetIntersector = function() {
            return new pr;
        }, e.prototype.addSelfIntersectionNodes = function(t) {
            for(var e = this._edges.iterator(); e.hasNext();)for(var n = e.next(), i = n.getLabel().getLocation(t), r = n.eiList.iterator(); r.hasNext();){
                var o = r.next();
                this.addSelfIntersectionNode(t, o.coord, i);
            }
        }, e.prototype.add = function() {
            if (1 !== arguments.length) return t.prototype.add.apply(this, arguments);
            var e = arguments[0];
            if (e.isEmpty()) return null;
            if (e instanceof ne && (this._useBoundaryDeterminationRule = !1), e instanceof $t) this.addPolygon(e);
            else if (e instanceof Kt) this.addLineString(e);
            else if (e instanceof Qt) this.addPoint(e);
            else if (e instanceof te) this.addCollection(e);
            else if (e instanceof Xt) this.addCollection(e);
            else if (e instanceof ne) this.addCollection(e);
            else {
                if (!(e instanceof zt)) throw new Error(e.getClass().getName());
                this.addCollection(e);
            }
        }, e.prototype.addCollection = function(t) {
            for(var e = 0; e < t.getNumGeometries(); e++){
                var n = t.getGeometryN(e);
                this.add(n);
            }
        }, e.prototype.locate = function(t) {
            return T(this._parentGeom, Zt) && this._parentGeom.getNumGeometries() > 50 ? (null === this._areaPtLocator && (this._areaPtLocator = new vr(this._parentGeom)), this._areaPtLocator.locate(t)) : this._ptLocator.locate(t, this._parentGeom);
        }, e.prototype.findEdge = function() {
            if (1 === arguments.length) {
                var e = arguments[0];
                return this._lineEdgeMap.get(e);
            }
            return t.prototype.findEdge.apply(this, arguments);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.determineBoundary = function(t, e) {
            return t.isInBoundary(e) ? w.BOUNDARY : w.INTERIOR;
        }, e;
    }(Ye), Cr = function() {
        if (this._li = new rt, this._resultPrecisionModel = null, this._arg = null, 1 === arguments.length) {
            var t = arguments[0];
            this.setComputationPrecision(t.getPrecisionModel()), this._arg = new Array(1).fill(null), this._arg[0] = new Nr(0, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = gt.OGC_SFS_BOUNDARY_RULE;
            e.getPrecisionModel().compareTo(n.getPrecisionModel()) >= 0 ? this.setComputationPrecision(e.getPrecisionModel()) : this.setComputationPrecision(n.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new Nr(0, e, i), this._arg[1] = new Nr(1, n, i);
        } else if (3 === arguments.length) {
            var r = arguments[0], o = arguments[1], s = arguments[2];
            r.getPrecisionModel().compareTo(o.getPrecisionModel()) >= 0 ? this.setComputationPrecision(r.getPrecisionModel()) : this.setComputationPrecision(o.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new Nr(0, r, s), this._arg[1] = new Nr(1, o, s);
        }
    };
    Cr.prototype.getArgGeometry = function(t) {
        return this._arg[t].getGeometry();
    }, Cr.prototype.setComputationPrecision = function(t) {
        this._resultPrecisionModel = t, this._li.setPrecisionModel(this._resultPrecisionModel);
    }, Cr.prototype.interfaces_ = function() {
        return [];
    }, Cr.prototype.getClass = function() {
        return Cr;
    };
    var Sr = function() {};
    Sr.prototype.interfaces_ = function() {
        return [];
    }, Sr.prototype.getClass = function() {
        return Sr;
    }, Sr.map = function() {
        if (arguments[0] instanceof ct && T(arguments[1], Sr.MapOp)) {
            for(var t = arguments[0], e = arguments[1], n = new Nt, i = 0; i < t.getNumGeometries(); i++){
                var r = e.map(t.getGeometryN(i));
                null !== r && n.add(r);
            }
            return t.getFactory().buildGeometry(n);
        }
        if (T(arguments[0], It) && T(arguments[1], Sr.MapOp)) {
            for(var o = arguments[0], s = arguments[1], a = new Nt, u = o.iterator(); u.hasNext();){
                var l = u.next(), c = s.map(l);
                null !== c && a.add(c);
            }
            return a;
        }
    }, Sr.MapOp = function() {};
    var Lr = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, n), this._ptLocator = new Si, this._geomFact = null, this._resultGeom = null, this._graph = null, this._edgeList = new Hn, this._resultPolyList = new Nt, this._resultLineList = new Nt, this._resultPointList = new Nt, this._graph = new Ye(new kn), this._geomFact = e.getFactory();
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.insertUniqueEdge = function(t) {
            var e = this._edgeList.findEqualEdge(t);
            if (null !== e) {
                var n = e.getLabel(), i = t.getLabel();
                e.isPointwiseEqual(t) || (i = new Pe(t.getLabel())).flip();
                var r = e.getDepth();
                r.isNull() && r.add(n), r.add(i), n.merge(i);
            } else this._edgeList.add(t);
        }, e.prototype.getGraph = function() {
            return this._graph;
        }, e.prototype.cancelDuplicateResultEdges = function() {
            for(var t = this._graph.getEdgeEnds().iterator(); t.hasNext();){
                var e = t.next(), n = e.getSym();
                e.isInResult() && n.isInResult() && (e.setInResult(!1), n.setInResult(!1));
            }
        }, e.prototype.isCoveredByLA = function(t) {
            return !!this.isCovered(t, this._resultLineList) || !!this.isCovered(t, this._resultPolyList);
        }, e.prototype.computeGeometry = function(t, n, i, r) {
            var o = new Nt;
            return o.addAll(t), o.addAll(n), o.addAll(i), o.isEmpty() ? e.createEmptyResult(r, this._arg[0].getGeometry(), this._arg[1].getGeometry(), this._geomFact) : this._geomFact.buildGeometry(o);
        }, e.prototype.mergeSymLabels = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();)t.next().getEdges().mergeSymLabels();
        }, e.prototype.isCovered = function(t, e) {
            for(var n = e.iterator(); n.hasNext();){
                var i = n.next();
                if (this._ptLocator.locate(t, i) !== w.EXTERIOR) return !0;
            }
            return !1;
        }, e.prototype.replaceCollapsedEdges = function() {
            for(var t = new Nt, e = this._edgeList.iterator(); e.hasNext();){
                var n = e.next();
                n.isCollapsed() && (e.remove(), t.add(n.getCollapsedEdge()));
            }
            this._edgeList.addAll(t);
        }, e.prototype.updateNodeLabelling = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();){
                var e = t.next(), n = e.getEdges().getLabel();
                e.getLabel().merge(n);
            }
        }, e.prototype.getResultGeometry = function(t) {
            return this.computeOverlay(t), this._resultGeom;
        }, e.prototype.insertUniqueEdges = function(t) {
            for(var e = t.iterator(); e.hasNext();){
                var n = e.next();
                this.insertUniqueEdge(n);
            }
        }, e.prototype.computeOverlay = function(t) {
            this.copyPoints(0), this.copyPoints(1), this._arg[0].computeSelfNodes(this._li, !1), this._arg[1].computeSelfNodes(this._li, !1), this._arg[0].computeEdgeIntersections(this._arg[1], this._li, !0);
            var e = new Nt;
            this._arg[0].computeSplitEdges(e), this._arg[1].computeSplitEdges(e), this.insertUniqueEdges(e), this.computeLabelsFromDepths(), this.replaceCollapsedEdges(), Yi.checkValid(this._edgeList.getEdges()), this._graph.addEdges(this._edgeList.getEdges()), this.computeLabelling(), this.labelIncompleteNodes(), this.findResultAreaEdges(t), this.cancelDuplicateResultEdges();
            var n = new ke(this._geomFact);
            n.add(this._graph), this._resultPolyList = n.getPolygons();
            var i = new ji(this, this._geomFact, this._ptLocator);
            this._resultLineList = i.build(t);
            var r = new Hi(this, this._geomFact, this._ptLocator);
            this._resultPointList = r.build(t), this._resultGeom = this.computeGeometry(this._resultPointList, this._resultLineList, this._resultPolyList, t);
        }, e.prototype.labelIncompleteNode = function(t, e) {
            var n = this._ptLocator.locate(t.getCoordinate(), this._arg[e].getGeometry());
            t.getLabel().setLocation(e, n);
        }, e.prototype.copyPoints = function(t) {
            for(var e = this._arg[t].getNodeIterator(); e.hasNext();){
                var n = e.next();
                this._graph.addNode(n.getCoordinate()).setLabel(t, n.getLabel().getLocation(t));
            }
        }, e.prototype.findResultAreaEdges = function(t) {
            for(var n = this._graph.getEdgeEnds().iterator(); n.hasNext();){
                var i = n.next(), r = i.getLabel();
                r.isArea() && !i.isInteriorAreaEdge() && e.isResultOfOp(r.getLocation(0, Se.RIGHT), r.getLocation(1, Se.RIGHT), t) && i.setInResult(!0);
            }
        }, e.prototype.computeLabelsFromDepths = function() {
            for(var t = this._edgeList.iterator(); t.hasNext();){
                var e = t.next(), n = e.getLabel(), i = e.getDepth();
                if (!i.isNull()) {
                    i.normalize();
                    for(var r = 0; r < 2; r++)n.isNull(r) || !n.isArea() || i.isNull(r) || (0 === i.getDelta(r) ? n.toLine(r) : (et.isTrue(!i.isNull(r, Se.LEFT), "depth of LEFT side has not been initialized"), n.setLocation(r, Se.LEFT, i.getLocation(r, Se.LEFT)), et.isTrue(!i.isNull(r, Se.RIGHT), "depth of RIGHT side has not been initialized"), n.setLocation(r, Se.RIGHT, i.getLocation(r, Se.RIGHT))));
                }
            }
        }, e.prototype.computeLabelling = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();)t.next().getEdges().computeLabelling(this._arg);
            this.mergeSymLabels(), this.updateNodeLabelling();
        }, e.prototype.labelIncompleteNodes = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();){
                var e = t.next(), n = e.getLabel();
                e.isIsolated() && (n.isNull(0) ? this.labelIncompleteNode(e, 0) : this.labelIncompleteNode(e, 1)), e.getEdges().updateLabelling(n);
            }
        }, e.prototype.isCoveredByA = function(t) {
            return !!this.isCovered(t, this._resultPolyList);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Cr);
    Lr.overlayOp = function(t, e, n) {
        return new Lr(t, e).getResultGeometry(n);
    }, Lr.intersection = function(t, e) {
        if (t.isEmpty() || e.isEmpty()) return Lr.createEmptyResult(Lr.INTERSECTION, t, e, t.getFactory());
        if (t.isGeometryCollection()) {
            var n = e;
            return ki.map(t, {
                interfaces_: function() {
                    return [
                        Sr.MapOp
                    ];
                },
                map: function(t) {
                    return t.intersection(n);
                }
            });
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), or.overlayOp(t, e, Lr.INTERSECTION);
    }, Lr.symDifference = function(t, e) {
        if (t.isEmpty() || e.isEmpty()) {
            if (t.isEmpty() && e.isEmpty()) return Lr.createEmptyResult(Lr.SYMDIFFERENCE, t, e, t.getFactory());
            if (t.isEmpty()) return e.copy();
            if (e.isEmpty()) return t.copy();
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), or.overlayOp(t, e, Lr.SYMDIFFERENCE);
    }, Lr.resultDimension = function(t, e, n) {
        var i = e.getDimension(), r = n.getDimension(), o = -1;
        switch(t){
            case Lr.INTERSECTION:
                o = Math.min(i, r);
                break;
            case Lr.UNION:
                o = Math.max(i, r);
                break;
            case Lr.DIFFERENCE:
                o = i;
                break;
            case Lr.SYMDIFFERENCE:
                o = Math.max(i, r);
        }
        return o;
    }, Lr.createEmptyResult = function(t, e, n, i) {
        var r = null;
        switch(Lr.resultDimension(t, e, n)){
            case -1:
                r = i.createGeometryCollection(new Array(0).fill(null));
                break;
            case 0:
                r = i.createPoint();
                break;
            case 1:
                r = i.createLineString();
                break;
            case 2:
                r = i.createPolygon();
        }
        return r;
    }, Lr.difference = function(t, e) {
        return t.isEmpty() ? Lr.createEmptyResult(Lr.DIFFERENCE, t, e, t.getFactory()) : e.isEmpty() ? t.copy() : (t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), or.overlayOp(t, e, Lr.DIFFERENCE));
    }, Lr.isResultOfOp = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = t.getLocation(0), i = t.getLocation(1);
            return Lr.isResultOfOp(n, i, e);
        }
        if (3 === arguments.length) {
            var r = arguments[0], o = arguments[1], s = arguments[2];
            switch(r === w.BOUNDARY && (r = w.INTERIOR), o === w.BOUNDARY && (o = w.INTERIOR), s){
                case Lr.INTERSECTION:
                    return r === w.INTERIOR && o === w.INTERIOR;
                case Lr.UNION:
                    return r === w.INTERIOR || o === w.INTERIOR;
                case Lr.DIFFERENCE:
                    return r === w.INTERIOR && o !== w.INTERIOR;
                case Lr.SYMDIFFERENCE:
                    return r === w.INTERIOR && o !== w.INTERIOR || r !== w.INTERIOR && o === w.INTERIOR;
            }
            return !1;
        }
    }, Lr.INTERSECTION = 1, Lr.UNION = 2, Lr.DIFFERENCE = 3, Lr.SYMDIFFERENCE = 4;
    var br = function() {
        this._g = null, this._boundaryDistanceTolerance = null, this._linework = null, this._ptLocator = new Si, this._seg = new dn;
        var t = arguments[0], e = arguments[1];
        this._g = t, this._boundaryDistanceTolerance = e, this._linework = this.extractLinework(t);
    };
    br.prototype.isWithinToleranceOfBoundary = function(t) {
        for(var e = 0; e < this._linework.getNumGeometries(); e++)for(var n = this._linework.getGeometryN(e).getCoordinateSequence(), i = 0; i < n.size() - 1; i++){
            n.getCoordinate(i, this._seg.p0), n.getCoordinate(i + 1, this._seg.p1);
            if (this._seg.distance(t) <= this._boundaryDistanceTolerance) return !0;
        }
        return !1;
    }, br.prototype.getLocation = function(t) {
        return this.isWithinToleranceOfBoundary(t) ? w.BOUNDARY : this._ptLocator.locate(t, this._g);
    }, br.prototype.extractLinework = function(t) {
        var e = new wr;
        t.apply(e);
        var n = e.getLinework(), i = _e.toLineStringArray(n);
        return t.getFactory().createMultiLineString(i);
    }, br.prototype.interfaces_ = function() {
        return [];
    }, br.prototype.getClass = function() {
        return br;
    };
    var wr = function() {
        this._linework = null, this._linework = new Nt;
    };
    wr.prototype.getLinework = function() {
        return this._linework;
    }, wr.prototype.filter = function(t) {
        if (t instanceof $t) {
            var e = t;
            this._linework.add(e.getExteriorRing());
            for(var n = 0; n < e.getNumInteriorRing(); n++)this._linework.add(e.getInteriorRingN(n));
        }
    }, wr.prototype.interfaces_ = function() {
        return [
            Vt
        ];
    }, wr.prototype.getClass = function() {
        return wr;
    };
    var Or = function() {
        this._g = null, this._doLeft = !0, this._doRight = !0;
        var t = arguments[0];
        this._g = t;
    };
    Or.prototype.extractPoints = function(t, e, n) {
        for(var i = t.getCoordinates(), r = 0; r < i.length - 1; r++)this.computeOffsetPoints(i[r], i[r + 1], e, n);
    }, Or.prototype.setSidesToGenerate = function(t, e) {
        this._doLeft = t, this._doRight = e;
    }, Or.prototype.getPoints = function(t) {
        for(var e = new Nt, n = Ci.getLines(this._g).iterator(); n.hasNext();){
            var i = n.next();
            this.extractPoints(i, t, e);
        }
        return e;
    }, Or.prototype.computeOffsetPoints = function(t, e, n, i) {
        var r = e.x - t.x, o = e.y - t.y, s = Math.sqrt(r * r + o * o), a = n * r / s, u = n * o / s, l = (e.x + t.x) / 2, c = (e.y + t.y) / 2;
        if (this._doLeft) {
            var p = new C(l - u, c + a);
            i.add(p);
        }
        if (this._doRight) {
            var h = new C(l + u, c - a);
            i.add(h);
        }
    }, Or.prototype.interfaces_ = function() {
        return [];
    }, Or.prototype.getClass = function() {
        return Or;
    };
    var Tr = function t() {
        this._geom = null, this._locFinder = null, this._location = new Array(3).fill(null), this._invalidLocation = null, this._boundaryDistanceTolerance = t.TOLERANCE, this._testCoords = new Nt;
        var e = arguments[0], n = arguments[1], i = arguments[2];
        this._boundaryDistanceTolerance = t.computeBoundaryDistanceTolerance(e, n), this._geom = [
            e,
            n,
            i
        ], this._locFinder = [
            new br(this._geom[0], this._boundaryDistanceTolerance),
            new br(this._geom[1], this._boundaryDistanceTolerance),
            new br(this._geom[2], this._boundaryDistanceTolerance)
        ];
    }, Rr = {
        TOLERANCE: {
            configurable: !0
        }
    };
    Tr.prototype.reportResult = function(t, e, n) {
        Y.out.println("Overlay result invalid - A:" + w.toLocationSymbol(e[0]) + " B:" + w.toLocationSymbol(e[1]) + " expected:" + (n ? "i" : "e") + " actual:" + w.toLocationSymbol(e[2]));
    }, Tr.prototype.isValid = function(t) {
        this.addTestPts(this._geom[0]), this.addTestPts(this._geom[1]);
        var e = this.checkValid(t);
        return e;
    }, Tr.prototype.checkValid = function() {
        if (1 === arguments.length) {
            for(var t = arguments[0], e = 0; e < this._testCoords.size(); e++){
                var n = this._testCoords.get(e);
                if (!this.checkValid(t, n)) return this._invalidLocation = n, !1;
            }
            return !0;
        }
        if (2 === arguments.length) {
            var i = arguments[0], r = arguments[1];
            return this._location[0] = this._locFinder[0].getLocation(r), this._location[1] = this._locFinder[1].getLocation(r), this._location[2] = this._locFinder[2].getLocation(r), !!Tr.hasLocation(this._location, w.BOUNDARY) || this.isValidResult(i, this._location);
        }
    }, Tr.prototype.addTestPts = function(t) {
        var e = new Or(t);
        this._testCoords.addAll(e.getPoints(5 * this._boundaryDistanceTolerance));
    }, Tr.prototype.isValidResult = function(t, e) {
        var n = Lr.isResultOfOp(e[0], e[1], t), i = !(n ^ e[2] === w.INTERIOR);
        return i || this.reportResult(t, e, n), i;
    }, Tr.prototype.getInvalidLocation = function() {
        return this._invalidLocation;
    }, Tr.prototype.interfaces_ = function() {
        return [];
    }, Tr.prototype.getClass = function() {
        return Tr;
    }, Tr.hasLocation = function(t, e) {
        for(var n = 0; n < 3; n++)if (t[n] === e) return !0;
        return !1;
    }, Tr.computeBoundaryDistanceTolerance = function(t, e) {
        return Math.min(Ji.computeSizeBasedSnapTolerance(t), Ji.computeSizeBasedSnapTolerance(e));
    }, Tr.isValid = function(t, e, n, i) {
        return new Tr(t, e, i).isValid(n);
    }, Rr.TOLERANCE.get = function() {
        return 1e-6;
    }, Object.defineProperties(Tr, Rr);
    var Pr = function t(e) {
        this._geomFactory = null, this._skipEmpty = !1, this._inputGeoms = null, this._geomFactory = t.extractFactory(e), this._inputGeoms = e;
    };
    Pr.prototype.extractElements = function(t, e) {
        if (null === t) return null;
        for(var n = 0; n < t.getNumGeometries(); n++){
            var i = t.getGeometryN(n);
            this._skipEmpty && i.isEmpty() || e.add(i);
        }
    }, Pr.prototype.combine = function() {
        for(var t = new Nt, e = this._inputGeoms.iterator(); e.hasNext();){
            var n = e.next();
            this.extractElements(n, t);
        }
        return 0 === t.size() ? null !== this._geomFactory ? this._geomFactory.createGeometryCollection(null) : null : this._geomFactory.buildGeometry(t);
    }, Pr.prototype.interfaces_ = function() {
        return [];
    }, Pr.prototype.getClass = function() {
        return Pr;
    }, Pr.combine = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return new Pr(t).combine();
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return new Pr(Pr.createList(e, n)).combine();
        }
        if (3 === arguments.length) {
            var i = arguments[0], r = arguments[1], o = arguments[2];
            return new Pr(Pr.createList(i, r, o)).combine();
        }
    }, Pr.extractFactory = function(t) {
        return t.isEmpty() ? null : t.iterator().next().getFactory();
    }, Pr.createList = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = new Nt;
            return n.add(t), n.add(e), n;
        }
        if (3 === arguments.length) {
            var i = arguments[0], r = arguments[1], o = arguments[2], s = new Nt;
            return s.add(i), s.add(r), s.add(o), s;
        }
    };
    var Dr = function() {
        this._inputPolys = null, this._geomFactory = null;
        var t = arguments[0];
        this._inputPolys = t, null === this._inputPolys && (this._inputPolys = new Nt);
    }, Mr = {
        STRTREE_NODE_CAPACITY: {
            configurable: !0
        }
    };
    Dr.prototype.reduceToGeometries = function(t) {
        for(var e = new Nt, n = t.iterator(); n.hasNext();){
            var i = n.next(), r = null;
            T(i, xt) ? r = this.unionTree(i) : i instanceof ct && (r = i), e.add(r);
        }
        return e;
    }, Dr.prototype.extractByEnvelope = function(t, e, n) {
        for(var i = new Nt, r = 0; r < e.getNumGeometries(); r++){
            var o = e.getGeometryN(r);
            o.getEnvelopeInternal().intersects(t) ? i.add(o) : n.add(o);
        }
        return this._geomFactory.buildGeometry(i);
    }, Dr.prototype.unionOptimized = function(t, e) {
        var n = t.getEnvelopeInternal(), i = e.getEnvelopeInternal();
        if (!n.intersects(i)) return Pr.combine(t, e);
        if (t.getNumGeometries() <= 1 && e.getNumGeometries() <= 1) return this.unionActual(t, e);
        var r = n.intersection(i);
        return this.unionUsingEnvelopeIntersection(t, e, r);
    }, Dr.prototype.union = function() {
        if (null === this._inputPolys) throw new Error("union() method cannot be called twice");
        if (this._inputPolys.isEmpty()) return null;
        this._geomFactory = this._inputPolys.iterator().next().getFactory();
        for(var t = new sn(Dr.STRTREE_NODE_CAPACITY), e = this._inputPolys.iterator(); e.hasNext();){
            var n = e.next();
            t.insert(n.getEnvelopeInternal(), n);
        }
        this._inputPolys = null;
        var i = t.itemsTree();
        return this.unionTree(i);
    }, Dr.prototype.binaryUnion = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.binaryUnion(t, 0, t.size());
        }
        if (3 === arguments.length) {
            var e = arguments[0], n = arguments[1], i = arguments[2];
            if (i - n <= 1) {
                var r = Dr.getGeometry(e, n);
                return this.unionSafe(r, null);
            }
            if (i - n == 2) return this.unionSafe(Dr.getGeometry(e, n), Dr.getGeometry(e, n + 1));
            var o = Math.trunc((i + n) / 2), s = this.binaryUnion(e, n, o), a = this.binaryUnion(e, o, i);
            return this.unionSafe(s, a);
        }
    }, Dr.prototype.repeatedUnion = function(t) {
        for(var e = null, n = t.iterator(); n.hasNext();){
            var i = n.next();
            e = null === e ? i.copy() : e.union(i);
        }
        return e;
    }, Dr.prototype.unionSafe = function(t, e) {
        return null === t && null === e ? null : null === t ? e.copy() : null === e ? t.copy() : this.unionOptimized(t, e);
    }, Dr.prototype.unionActual = function(t, e) {
        return Dr.restrictToPolygons(t.union(e));
    }, Dr.prototype.unionTree = function(t) {
        var e = this.reduceToGeometries(t);
        return this.binaryUnion(e);
    }, Dr.prototype.unionUsingEnvelopeIntersection = function(t, e, n) {
        var i = new Nt, r = this.extractByEnvelope(n, t, i), o = this.extractByEnvelope(n, e, i), s = this.unionActual(r, o);
        i.add(s);
        return Pr.combine(i);
    }, Dr.prototype.bufferUnion = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return t.get(0).getFactory().buildGeometry(t).buffer(0);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return e.getFactory().createGeometryCollection([
                e,
                n
            ]).buffer(0);
        }
    }, Dr.prototype.interfaces_ = function() {
        return [];
    }, Dr.prototype.getClass = function() {
        return Dr;
    }, Dr.restrictToPolygons = function(t) {
        if (T(t, Zt)) return t;
        var e = Ni.getPolygons(t);
        return 1 === e.size() ? e.get(0) : t.getFactory().createMultiPolygon(_e.toPolygonArray(e));
    }, Dr.getGeometry = function(t, e) {
        return e >= t.size() ? null : t.get(e);
    }, Dr.union = function(t) {
        return new Dr(t).union();
    }, Mr.STRTREE_NODE_CAPACITY.get = function() {
        return 4;
    }, Object.defineProperties(Dr, Mr);
    var Ar = function() {};
    Ar.prototype.interfaces_ = function() {
        return [];
    }, Ar.prototype.getClass = function() {
        return Ar;
    }, Ar.union = function(t, e) {
        if (t.isEmpty() || e.isEmpty()) {
            if (t.isEmpty() && e.isEmpty()) return Lr.createEmptyResult(Lr.UNION, t, e, t.getFactory());
            if (t.isEmpty()) return e.copy();
            if (e.isEmpty()) return t.copy();
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), or.overlayOp(t, e, Lr.UNION);
    }, t.GeoJSONReader = Ne, t.GeoJSONWriter = Ce, t.OverlayOp = Lr, t.UnionOp = Ar, t.BufferOp = di, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});

});

parcelRegister("l1DKV", function(module, exports) {

$parcel$export(module.exports, "toMercator", function () { return $f4e887aae2cc16af$export$421b346f8b34c98c; });
$parcel$export(module.exports, "toWgs84", function () { return $f4e887aae2cc16af$export$60dece424ca09436; });

var $HcJdv = parcelRequire("HcJdv");

var $brFkQ = parcelRequire("brFkQ");

var $asTyQ = parcelRequire("asTyQ");
/**
 * Converts a WGS84 GeoJSON object into Mercator (EPSG:900913) projection
 *
 * @name toMercator
 * @param {GeoJSON|Position} geojson WGS84 GeoJSON object
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} true/false
 * @example
 * var pt = turf.point([-71,41]);
 * var converted = turf.toMercator(pt);
 *
 * //addToMap
 * var addToMap = [pt, converted];
 */ function $f4e887aae2cc16af$export$421b346f8b34c98c(geojson, options) {
    return $f4e887aae2cc16af$var$convert(geojson, "mercator", options);
}
/**
 * Converts a Mercator (EPSG:900913) GeoJSON object into WGS84 projection
 *
 * @name toWgs84
 * @param {GeoJSON|Position} geojson Mercator GeoJSON object
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} true/false
 * @example
 * var pt = turf.point([-7903683.846322424, 5012341.663847514]);
 * var converted = turf.toWgs84(pt);
 *
 * //addToMap
 * var addToMap = [pt, converted];
 */ function $f4e887aae2cc16af$export$60dece424ca09436(geojson, options) {
    return $f4e887aae2cc16af$var$convert(geojson, "wgs84", options);
}
/**
 * Converts a GeoJSON coordinates to the defined `projection`
 *
 * @private
 * @param {GeoJSON} geojson GeoJSON Feature or Geometry
 * @param {string} projection defines the projection system to convert the coordinates to
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} true/false
 */ function $f4e887aae2cc16af$var$convert(geojson, projection, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $brFkQ.isObject)(options)) throw new Error("options is invalid");
    var mutate = options.mutate;
    // Validation
    if (!geojson) throw new Error("geojson is required");
    // Handle Position
    if (Array.isArray(geojson) && (0, $brFkQ.isNumber)(geojson[0])) geojson = projection === "mercator" ? $f4e887aae2cc16af$var$convertToMercator(geojson) : $f4e887aae2cc16af$var$convertToWgs84(geojson);
    else {
        // Handle possible data mutation
        if (mutate !== true) geojson = (0, $asTyQ.default)(geojson);
        (0, $HcJdv.coordEach)(geojson, function(coord) {
            var newCoord = projection === "mercator" ? $f4e887aae2cc16af$var$convertToMercator(coord) : $f4e887aae2cc16af$var$convertToWgs84(coord);
            coord[0] = newCoord[0];
            coord[1] = newCoord[1];
        });
    }
    return geojson;
}
/**
 * Convert lon/lat values to 900913 x/y.
 * (from https://github.com/mapbox/sphericalmercator)
 *
 * @private
 * @param {Array<number>} lonLat WGS84 point
 * @returns {Array<number>} Mercator [x, y] point
 */ function $f4e887aae2cc16af$var$convertToMercator(lonLat) {
    var D2R = Math.PI / 180, // 900913 properties
    A = 6378137.0, MAXEXTENT = 20037508.342789244;
    // compensate longitudes passing the 180th meridian
    // from https://github.com/proj4js/proj4js/blob/master/lib/common/adjust_lon.js
    var adjusted = Math.abs(lonLat[0]) <= 180 ? lonLat[0] : lonLat[0] - $f4e887aae2cc16af$var$sign(lonLat[0]) * 360;
    var xy = [
        A * adjusted * D2R,
        A * Math.log(Math.tan(Math.PI * 0.25 + 0.5 * lonLat[1] * D2R))
    ];
    // if xy value is beyond maxextent (e.g. poles), return maxextent
    if (xy[0] > MAXEXTENT) xy[0] = MAXEXTENT;
    if (xy[0] < -MAXEXTENT) xy[0] = -MAXEXTENT;
    if (xy[1] > MAXEXTENT) xy[1] = MAXEXTENT;
    if (xy[1] < -MAXEXTENT) xy[1] = -MAXEXTENT;
    return xy;
}
/**
 * Convert 900913 x/y values to lon/lat.
 * (from https://github.com/mapbox/sphericalmercator)
 *
 * @private
 * @param {Array<number>} xy Mercator [x, y] point
 * @returns {Array<number>} WGS84 [lon, lat] point
 */ function $f4e887aae2cc16af$var$convertToWgs84(xy) {
    // 900913 properties.
    var R2D = 180 / Math.PI;
    var A = 6378137.0;
    return [
        xy[0] * R2D / A,
        (Math.PI * 0.5 - 2.0 * Math.atan(Math.exp(-xy[1] / A))) * R2D
    ];
}
/**
 * Returns the sign of the input, or zero
 *
 * @private
 * @param {number} x input
 * @returns {number} -1|0|1 output
 */ function $f4e887aae2cc16af$var$sign(x) {
    return x < 0 ? -1 : x > 0 ? 1 : 0;
}

});
parcelRegister("asTyQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79e79e2bfc164fd2$export$2e2bcd8739ae039; });
/**
 * Returns a cloned copy of the passed GeoJSON Object, including possible 'Foreign Members'.
 * ~3-5x faster than the common JSON.parse + JSON.stringify combo method.
 *
 * @name clone
 * @param {GeoJSON} geojson GeoJSON Object
 * @returns {GeoJSON} cloned GeoJSON Object
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]], {color: 'red'});
 *
 * var lineCloned = turf.clone(line);
 */ function $79e79e2bfc164fd2$var$clone(geojson) {
    if (!geojson) throw new Error("geojson is required");
    switch(geojson.type){
        case "Feature":
            return $79e79e2bfc164fd2$var$cloneFeature(geojson);
        case "FeatureCollection":
            return $79e79e2bfc164fd2$var$cloneFeatureCollection(geojson);
        case "Point":
        case "LineString":
        case "Polygon":
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
        case "GeometryCollection":
            return $79e79e2bfc164fd2$var$cloneGeometry(geojson);
        default:
            throw new Error("unknown GeoJSON type");
    }
}
/**
 * Clone Feature
 *
 * @private
 * @param {Feature<any>} geojson GeoJSON Feature
 * @returns {Feature<any>} cloned Feature
 */ function $79e79e2bfc164fd2$var$cloneFeature(geojson) {
    var cloned = {
        type: "Feature"
    };
    // Preserve Foreign Members
    Object.keys(geojson).forEach(function(key) {
        switch(key){
            case "type":
            case "properties":
            case "geometry":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    // Add properties & geometry last
    cloned.properties = $79e79e2bfc164fd2$var$cloneProperties(geojson.properties);
    cloned.geometry = $79e79e2bfc164fd2$var$cloneGeometry(geojson.geometry);
    return cloned;
}
/**
 * Clone Properties
 *
 * @private
 * @param {Object} properties GeoJSON Properties
 * @returns {Object} cloned Properties
 */ function $79e79e2bfc164fd2$var$cloneProperties(properties) {
    var cloned = {};
    if (!properties) return cloned;
    Object.keys(properties).forEach(function(key) {
        var value = properties[key];
        if (typeof value === "object") {
            if (value === null) // handle null
            cloned[key] = null;
            else if (value.length) // handle Array
            cloned[key] = value.map(function(item) {
                return item;
            });
            else // handle generic Object
            cloned[key] = $79e79e2bfc164fd2$var$cloneProperties(value);
        } else cloned[key] = value;
    });
    return cloned;
}
/**
 * Clone Feature Collection
 *
 * @private
 * @param {FeatureCollection<any>} geojson GeoJSON Feature Collection
 * @returns {FeatureCollection<any>} cloned Feature Collection
 */ function $79e79e2bfc164fd2$var$cloneFeatureCollection(geojson) {
    var cloned = {
        type: "FeatureCollection"
    };
    // Preserve Foreign Members
    Object.keys(geojson).forEach(function(key) {
        switch(key){
            case "type":
            case "features":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    // Add features
    cloned.features = geojson.features.map(function(feature) {
        return $79e79e2bfc164fd2$var$cloneFeature(feature);
    });
    return cloned;
}
/**
 * Clone Geometry
 *
 * @private
 * @param {Geometry<any>} geometry GeoJSON Geometry
 * @returns {Geometry<any>} cloned Geometry
 */ function $79e79e2bfc164fd2$var$cloneGeometry(geometry) {
    var geom = {
        type: geometry.type
    };
    if (geometry.bbox) geom.bbox = geometry.bbox;
    if (geometry.type === "GeometryCollection") {
        geom.geometries = geometry.geometries.map(function(geom) {
            return $79e79e2bfc164fd2$var$cloneGeometry(geom);
        });
        return geom;
    }
    geom.coordinates = $79e79e2bfc164fd2$var$deepSlice(geometry.coordinates);
    return geom;
}
/**
 * Deep Slice coordinates
 *
 * @private
 * @param {Coordinates} coords Coordinates
 * @returns {Coordinates} all coordinates sliced
 */ function $79e79e2bfc164fd2$var$deepSlice(coords) {
    if (typeof coords[0] !== "object") return coords.slice();
    return coords.map(function(coord) {
        return $79e79e2bfc164fd2$var$deepSlice(coord);
    });
}
var $79e79e2bfc164fd2$export$2e2bcd8739ae039 = $79e79e2bfc164fd2$var$clone;

});


parcelRegister("ixaKI", function(module, exports) {

$parcel$export(module.exports, "geoTransverseMercator", function () { return (parcelRequire("c1N6T")).default; });

var $cOqkX = parcelRequire("cOqkX");

var $5XobB = parcelRequire("5XobB");

var $kWgmR = parcelRequire("kWgmR");

var $dWoD6 = parcelRequire("dWoD6");

var $83woy = parcelRequire("83woy");

var $9mLIr = parcelRequire("9mLIr");

var $gJwx7 = parcelRequire("gJwx7");

var $52geN = parcelRequire("52geN");

var $3v7c1 = parcelRequire("3v7c1");

var $ck2S5 = parcelRequire("ck2S5");

var $6k2uT = parcelRequire("6k2uT");

var $hsQTR = parcelRequire("hsQTR");

var $jogIs = parcelRequire("jogIs");

var $bzumx = parcelRequire("bzumx");

var $1Vrzy = parcelRequire("1Vrzy");

var $8ZZJ4 = parcelRequire("8ZZJ4");

var $hFcZE = parcelRequire("hFcZE");

var $cMbuW = parcelRequire("cMbuW");

var $bmox2 = parcelRequire("bmox2");

var $10MQ7 = parcelRequire("10MQ7");

var $8wmcz = parcelRequire("8wmcz");

var $lsk55 = parcelRequire("lsk55");

var $6ckYb = parcelRequire("6ckYb");

var $epVV2 = parcelRequire("epVV2");

var $iHocG = parcelRequire("iHocG");

var $jiCae = parcelRequire("jiCae");

var $c1N6T = parcelRequire("c1N6T");

var $hRYfY = parcelRequire("hRYfY");

var $jRJb9 = parcelRequire("jRJb9");

var $eNZUM = parcelRequire("eNZUM");

});
parcelRegister("cOqkX", function(module, exports) {

$parcel$export(module.exports, "areaRingSum", function () { return $953e9584a5393f6f$export$bf8f994332070c7f; });
$parcel$export(module.exports, "areaStream", function () { return $953e9584a5393f6f$export$cb67cfa750ae69dc; });

var $kC5ta = parcelRequire("kC5ta");

var $kNUN7 = parcelRequire("kNUN7");

var $6cZzT = parcelRequire("6cZzT");

var $jRJb9 = parcelRequire("jRJb9");
var $953e9584a5393f6f$export$bf8f994332070c7f = (0, $kC5ta.default)();
var $953e9584a5393f6f$var$areaSum = (0, $kC5ta.default)(), $953e9584a5393f6f$var$lambda00, $953e9584a5393f6f$var$phi00, $953e9584a5393f6f$var$lambda0, $953e9584a5393f6f$var$cosPhi0, $953e9584a5393f6f$var$sinPhi0;
var $953e9584a5393f6f$export$cb67cfa750ae69dc = {
    point: (0, $6cZzT.default),
    lineStart: (0, $6cZzT.default),
    lineEnd: (0, $6cZzT.default),
    polygonStart: function() {
        $953e9584a5393f6f$export$bf8f994332070c7f.reset();
        $953e9584a5393f6f$export$cb67cfa750ae69dc.lineStart = $953e9584a5393f6f$var$areaRingStart;
        $953e9584a5393f6f$export$cb67cfa750ae69dc.lineEnd = $953e9584a5393f6f$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$953e9584a5393f6f$export$bf8f994332070c7f;
        $953e9584a5393f6f$var$areaSum.add(areaRing < 0 ? (0, $kNUN7.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $6cZzT.default);
    },
    sphere: function() {
        $953e9584a5393f6f$var$areaSum.add((0, $kNUN7.tau));
    }
};
function $953e9584a5393f6f$var$areaRingStart() {
    $953e9584a5393f6f$export$cb67cfa750ae69dc.point = $953e9584a5393f6f$var$areaPointFirst;
}
function $953e9584a5393f6f$var$areaRingEnd() {
    $953e9584a5393f6f$var$areaPoint($953e9584a5393f6f$var$lambda00, $953e9584a5393f6f$var$phi00);
}
function $953e9584a5393f6f$var$areaPointFirst(lambda, phi) {
    $953e9584a5393f6f$export$cb67cfa750ae69dc.point = $953e9584a5393f6f$var$areaPoint;
    $953e9584a5393f6f$var$lambda00 = lambda, $953e9584a5393f6f$var$phi00 = phi;
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    $953e9584a5393f6f$var$lambda0 = lambda, $953e9584a5393f6f$var$cosPhi0 = (0, $kNUN7.cos)(phi = phi / 2 + (0, $kNUN7.quarterPi)), $953e9584a5393f6f$var$sinPhi0 = (0, $kNUN7.sin)(phi);
}
function $953e9584a5393f6f$var$areaPoint(lambda, phi) {
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    phi = phi / 2 + (0, $kNUN7.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $953e9584a5393f6f$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $kNUN7.cos)(phi), sinPhi = (0, $kNUN7.sin)(phi), k = $953e9584a5393f6f$var$sinPhi0 * sinPhi, u = $953e9584a5393f6f$var$cosPhi0 * cosPhi + k * (0, $kNUN7.cos)(adLambda), v = k * sdLambda * (0, $kNUN7.sin)(adLambda);
    $953e9584a5393f6f$export$bf8f994332070c7f.add((0, $kNUN7.atan2)(v, u));
    // Advance the previous points.
    $953e9584a5393f6f$var$lambda0 = lambda, $953e9584a5393f6f$var$cosPhi0 = cosPhi, $953e9584a5393f6f$var$sinPhi0 = sinPhi;
}
function $953e9584a5393f6f$export$2e2bcd8739ae039(object) {
    $953e9584a5393f6f$var$areaSum.reset();
    (0, $jRJb9.default)(object, $953e9584a5393f6f$export$cb67cfa750ae69dc);
    return $953e9584a5393f6f$var$areaSum * 2;
}

});
parcelRegister("kC5ta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f01b995a1154a1e5$export$2e2bcd8739ae039; });
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
function $f01b995a1154a1e5$export$2e2bcd8739ae039() {
    return new $f01b995a1154a1e5$var$Adder;
}
function $f01b995a1154a1e5$var$Adder() {
    this.reset();
}
$f01b995a1154a1e5$var$Adder.prototype = {
    constructor: $f01b995a1154a1e5$var$Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        $f01b995a1154a1e5$var$add($f01b995a1154a1e5$var$temp, y, this.t);
        $f01b995a1154a1e5$var$add(this, $f01b995a1154a1e5$var$temp.s, this.s);
        if (this.s) this.t += $f01b995a1154a1e5$var$temp.t;
        else this.s = $f01b995a1154a1e5$var$temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var $f01b995a1154a1e5$var$temp = new $f01b995a1154a1e5$var$Adder;
function $f01b995a1154a1e5$var$add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}

});

parcelRegister("kNUN7", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return $f2546fc8dd756024$export$6c421550c66a327d; });
$parcel$export(module.exports, "epsilon2", function () { return $f2546fc8dd756024$export$92c06fba281fe81b; });
$parcel$export(module.exports, "pi", function () { return $f2546fc8dd756024$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $f2546fc8dd756024$export$e51408a300e8929a; });
$parcel$export(module.exports, "quarterPi", function () { return $f2546fc8dd756024$export$c39a5cba78ea0fc2; });
$parcel$export(module.exports, "tau", function () { return $f2546fc8dd756024$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "degrees", function () { return $f2546fc8dd756024$export$41fc368e1a942b97; });
$parcel$export(module.exports, "radians", function () { return $f2546fc8dd756024$export$8449e153fbd325fc; });
$parcel$export(module.exports, "abs", function () { return $f2546fc8dd756024$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan", function () { return $f2546fc8dd756024$export$628dc4eed22b0fbd; });
$parcel$export(module.exports, "atan2", function () { return $f2546fc8dd756024$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $f2546fc8dd756024$export$50d414a77b60d802; });
$parcel$export(module.exports, "ceil", function () { return $f2546fc8dd756024$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "exp", function () { return $f2546fc8dd756024$export$b310ec824aaee37f; });
$parcel$export(module.exports, "log", function () { return $f2546fc8dd756024$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "pow", function () { return $f2546fc8dd756024$export$9c297f60e22e3389; });
$parcel$export(module.exports, "sin", function () { return $f2546fc8dd756024$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sign", function () { return $f2546fc8dd756024$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "sqrt", function () { return $f2546fc8dd756024$export$eba8049fb5020b81; });
$parcel$export(module.exports, "tan", function () { return $f2546fc8dd756024$export$fcdd3b0b3246a325; });
$parcel$export(module.exports, "acos", function () { return $f2546fc8dd756024$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $f2546fc8dd756024$export$41726bdb1fc63f; });
$parcel$export(module.exports, "haversin", function () { return $f2546fc8dd756024$export$e808712c2966e662; });
var $f2546fc8dd756024$export$6c421550c66a327d = 1e-6;
var $f2546fc8dd756024$export$92c06fba281fe81b = 1e-12;
var $f2546fc8dd756024$export$18c7bea995a110f = Math.PI;
var $f2546fc8dd756024$export$e51408a300e8929a = $f2546fc8dd756024$export$18c7bea995a110f / 2;
var $f2546fc8dd756024$export$c39a5cba78ea0fc2 = $f2546fc8dd756024$export$18c7bea995a110f / 4;
var $f2546fc8dd756024$export$a4b4b4d4d776fe92 = $f2546fc8dd756024$export$18c7bea995a110f * 2;
var $f2546fc8dd756024$export$41fc368e1a942b97 = 180 / $f2546fc8dd756024$export$18c7bea995a110f;
var $f2546fc8dd756024$export$8449e153fbd325fc = $f2546fc8dd756024$export$18c7bea995a110f / 180;
var $f2546fc8dd756024$export$2335f513bbd82c6d = Math.abs;
var $f2546fc8dd756024$export$628dc4eed22b0fbd = Math.atan;
var $f2546fc8dd756024$export$b8b770ee6a0d9760 = Math.atan2;
var $f2546fc8dd756024$export$50d414a77b60d802 = Math.cos;
var $f2546fc8dd756024$export$803ce6b71a0a94b2 = Math.ceil;
var $f2546fc8dd756024$export$b310ec824aaee37f = Math.exp;
var $f2546fc8dd756024$export$a3fe094919f356fd = Math.floor;
var $f2546fc8dd756024$export$bef1f36f5486a6a3 = Math.log;
var $f2546fc8dd756024$export$9c297f60e22e3389 = Math.pow;
var $f2546fc8dd756024$export$5de3937cb4b592ed = Math.sin;
var $f2546fc8dd756024$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $f2546fc8dd756024$export$eba8049fb5020b81 = Math.sqrt;
var $f2546fc8dd756024$export$fcdd3b0b3246a325 = Math.tan;
function $f2546fc8dd756024$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f2546fc8dd756024$export$18c7bea995a110f : Math.acos(x);
}
function $f2546fc8dd756024$export$41726bdb1fc63f(x) {
    return x > 1 ? $f2546fc8dd756024$export$e51408a300e8929a : x < -1 ? -$f2546fc8dd756024$export$e51408a300e8929a : Math.asin(x);
}
function $f2546fc8dd756024$export$e808712c2966e662(x) {
    return (x = $f2546fc8dd756024$export$5de3937cb4b592ed(x / 2)) * x;
}

});

parcelRegister("6cZzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4853a128abbc899f$export$2e2bcd8739ae039; });
function $4853a128abbc899f$export$2e2bcd8739ae039() {}

});

parcelRegister("jRJb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e766031f6cae3a00$export$2e2bcd8739ae039; });
function $e766031f6cae3a00$var$streamGeometry(geometry, stream) {
    if (geometry && $e766031f6cae3a00$var$streamGeometryType.hasOwnProperty(geometry.type)) $e766031f6cae3a00$var$streamGeometryType[geometry.type](geometry, stream);
}
var $e766031f6cae3a00$var$streamObjectType = {
    Feature: function(object, stream) {
        $e766031f6cae3a00$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$e766031f6cae3a00$var$streamGeometry(features[i].geometry, stream);
    }
};
var $e766031f6cae3a00$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $e766031f6cae3a00$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$e766031f6cae3a00$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $e766031f6cae3a00$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$e766031f6cae3a00$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$e766031f6cae3a00$var$streamGeometry(geometries[i], stream);
    }
};
function $e766031f6cae3a00$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $e766031f6cae3a00$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$e766031f6cae3a00$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $e766031f6cae3a00$export$2e2bcd8739ae039(object, stream) {
    if (object && $e766031f6cae3a00$var$streamObjectType.hasOwnProperty(object.type)) $e766031f6cae3a00$var$streamObjectType[object.type](object, stream);
    else $e766031f6cae3a00$var$streamGeometry(object, stream);
}

});


parcelRegister("5XobB", function(module, exports) {

var $kC5ta = parcelRequire("kC5ta");

var $cOqkX = parcelRequire("cOqkX");

var $8mHes = parcelRequire("8mHes");

var $kNUN7 = parcelRequire("kNUN7");

var $jRJb9 = parcelRequire("jRJb9");
var $4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$phi0, $4565394bb4cda60a$var$lambda1, $4565394bb4cda60a$var$phi1, $4565394bb4cda60a$var$lambda2, $4565394bb4cda60a$var$lambda00, $4565394bb4cda60a$var$phi00, $4565394bb4cda60a$var$p0, $4565394bb4cda60a$var$deltaSum = (0, $kC5ta.default)(), $4565394bb4cda60a$var$ranges, $4565394bb4cda60a$var$range;
var $4565394bb4cda60a$var$boundsStream = {
    point: $4565394bb4cda60a$var$boundsPoint,
    lineStart: $4565394bb4cda60a$var$boundsLineStart,
    lineEnd: $4565394bb4cda60a$var$boundsLineEnd,
    polygonStart: function() {
        $4565394bb4cda60a$var$boundsStream.point = $4565394bb4cda60a$var$boundsRingPoint;
        $4565394bb4cda60a$var$boundsStream.lineStart = $4565394bb4cda60a$var$boundsRingStart;
        $4565394bb4cda60a$var$boundsStream.lineEnd = $4565394bb4cda60a$var$boundsRingEnd;
        $4565394bb4cda60a$var$deltaSum.reset();
        (0, $cOqkX.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, $cOqkX.areaStream).polygonEnd();
        $4565394bb4cda60a$var$boundsStream.point = $4565394bb4cda60a$var$boundsPoint;
        $4565394bb4cda60a$var$boundsStream.lineStart = $4565394bb4cda60a$var$boundsLineStart;
        $4565394bb4cda60a$var$boundsStream.lineEnd = $4565394bb4cda60a$var$boundsLineEnd;
        if ((0, $cOqkX.areaRingSum) < 0) $4565394bb4cda60a$var$lambda0 = -($4565394bb4cda60a$var$lambda1 = 180), $4565394bb4cda60a$var$phi0 = -($4565394bb4cda60a$var$phi1 = 90);
        else if ($4565394bb4cda60a$var$deltaSum > (0, $kNUN7.epsilon)) $4565394bb4cda60a$var$phi1 = 90;
        else if ($4565394bb4cda60a$var$deltaSum < -(0, $kNUN7.epsilon)) $4565394bb4cda60a$var$phi0 = -90;
        $4565394bb4cda60a$var$range[0] = $4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$range[1] = $4565394bb4cda60a$var$lambda1;
    }
};
function $4565394bb4cda60a$var$boundsPoint(lambda, phi) {
    $4565394bb4cda60a$var$ranges.push($4565394bb4cda60a$var$range = [
        $4565394bb4cda60a$var$lambda0 = lambda,
        $4565394bb4cda60a$var$lambda1 = lambda
    ]);
    if (phi < $4565394bb4cda60a$var$phi0) $4565394bb4cda60a$var$phi0 = phi;
    if (phi > $4565394bb4cda60a$var$phi1) $4565394bb4cda60a$var$phi1 = phi;
}
function $4565394bb4cda60a$var$linePoint(lambda, phi) {
    var p = (0, $8mHes.cartesian)([
        lambda * (0, $kNUN7.radians),
        phi * (0, $kNUN7.radians)
    ]);
    if ($4565394bb4cda60a$var$p0) {
        var normal = (0, $8mHes.cartesianCross)($4565394bb4cda60a$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $8mHes.cartesianCross)(equatorial, normal);
        (0, $8mHes.cartesianNormalizeInPlace)(inflection);
        inflection = (0, $8mHes.spherical)(inflection);
        var delta = lambda - $4565394bb4cda60a$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $kNUN7.degrees) * sign, phii, antimeridian = (0, $kNUN7.abs)(delta) > 180;
        if (antimeridian ^ (sign * $4565394bb4cda60a$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $kNUN7.degrees);
            if (phii > $4565394bb4cda60a$var$phi1) $4565394bb4cda60a$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $4565394bb4cda60a$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $kNUN7.degrees);
            if (phii < $4565394bb4cda60a$var$phi0) $4565394bb4cda60a$var$phi0 = phii;
        } else {
            if (phi < $4565394bb4cda60a$var$phi0) $4565394bb4cda60a$var$phi0 = phi;
            if (phi > $4565394bb4cda60a$var$phi1) $4565394bb4cda60a$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $4565394bb4cda60a$var$lambda2) {
                if ($4565394bb4cda60a$var$angle($4565394bb4cda60a$var$lambda0, lambda) > $4565394bb4cda60a$var$angle($4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$lambda1)) $4565394bb4cda60a$var$lambda1 = lambda;
            } else if ($4565394bb4cda60a$var$angle(lambda, $4565394bb4cda60a$var$lambda1) > $4565394bb4cda60a$var$angle($4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$lambda1)) $4565394bb4cda60a$var$lambda0 = lambda;
        } else if ($4565394bb4cda60a$var$lambda1 >= $4565394bb4cda60a$var$lambda0) {
            if (lambda < $4565394bb4cda60a$var$lambda0) $4565394bb4cda60a$var$lambda0 = lambda;
            if (lambda > $4565394bb4cda60a$var$lambda1) $4565394bb4cda60a$var$lambda1 = lambda;
        } else {
            if (lambda > $4565394bb4cda60a$var$lambda2) {
                if ($4565394bb4cda60a$var$angle($4565394bb4cda60a$var$lambda0, lambda) > $4565394bb4cda60a$var$angle($4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$lambda1)) $4565394bb4cda60a$var$lambda1 = lambda;
            } else if ($4565394bb4cda60a$var$angle(lambda, $4565394bb4cda60a$var$lambda1) > $4565394bb4cda60a$var$angle($4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$lambda1)) $4565394bb4cda60a$var$lambda0 = lambda;
        }
    } else $4565394bb4cda60a$var$ranges.push($4565394bb4cda60a$var$range = [
        $4565394bb4cda60a$var$lambda0 = lambda,
        $4565394bb4cda60a$var$lambda1 = lambda
    ]);
    if (phi < $4565394bb4cda60a$var$phi0) $4565394bb4cda60a$var$phi0 = phi;
    if (phi > $4565394bb4cda60a$var$phi1) $4565394bb4cda60a$var$phi1 = phi;
    $4565394bb4cda60a$var$p0 = p, $4565394bb4cda60a$var$lambda2 = lambda;
}
function $4565394bb4cda60a$var$boundsLineStart() {
    $4565394bb4cda60a$var$boundsStream.point = $4565394bb4cda60a$var$linePoint;
}
function $4565394bb4cda60a$var$boundsLineEnd() {
    $4565394bb4cda60a$var$range[0] = $4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$range[1] = $4565394bb4cda60a$var$lambda1;
    $4565394bb4cda60a$var$boundsStream.point = $4565394bb4cda60a$var$boundsPoint;
    $4565394bb4cda60a$var$p0 = null;
}
function $4565394bb4cda60a$var$boundsRingPoint(lambda, phi) {
    if ($4565394bb4cda60a$var$p0) {
        var delta = lambda - $4565394bb4cda60a$var$lambda2;
        $4565394bb4cda60a$var$deltaSum.add((0, $kNUN7.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $4565394bb4cda60a$var$lambda00 = lambda, $4565394bb4cda60a$var$phi00 = phi;
    (0, $cOqkX.areaStream).point(lambda, phi);
    $4565394bb4cda60a$var$linePoint(lambda, phi);
}
function $4565394bb4cda60a$var$boundsRingStart() {
    (0, $cOqkX.areaStream).lineStart();
}
function $4565394bb4cda60a$var$boundsRingEnd() {
    $4565394bb4cda60a$var$boundsRingPoint($4565394bb4cda60a$var$lambda00, $4565394bb4cda60a$var$phi00);
    (0, $cOqkX.areaStream).lineEnd();
    if ((0, $kNUN7.abs)($4565394bb4cda60a$var$deltaSum) > (0, $kNUN7.epsilon)) $4565394bb4cda60a$var$lambda0 = -($4565394bb4cda60a$var$lambda1 = 180);
    $4565394bb4cda60a$var$range[0] = $4565394bb4cda60a$var$lambda0, $4565394bb4cda60a$var$range[1] = $4565394bb4cda60a$var$lambda1;
    $4565394bb4cda60a$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $4565394bb4cda60a$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $4565394bb4cda60a$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $4565394bb4cda60a$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $4565394bb4cda60a$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $4565394bb4cda60a$var$phi1 = $4565394bb4cda60a$var$lambda1 = -($4565394bb4cda60a$var$lambda0 = $4565394bb4cda60a$var$phi0 = Infinity);
    $4565394bb4cda60a$var$ranges = [];
    (0, $jRJb9.default)(feature, $4565394bb4cda60a$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $4565394bb4cda60a$var$ranges.length) {
        $4565394bb4cda60a$var$ranges.sort($4565394bb4cda60a$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $4565394bb4cda60a$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $4565394bb4cda60a$var$ranges[i];
            if ($4565394bb4cda60a$var$rangeContains(a, b[0]) || $4565394bb4cda60a$var$rangeContains(a, b[1])) {
                if ($4565394bb4cda60a$var$angle(a[0], b[1]) > $4565394bb4cda60a$var$angle(a[0], a[1])) a[1] = b[1];
                if ($4565394bb4cda60a$var$angle(b[0], a[1]) > $4565394bb4cda60a$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $4565394bb4cda60a$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $4565394bb4cda60a$var$lambda0 = b[0], $4565394bb4cda60a$var$lambda1 = a[1];
        }
    }
    $4565394bb4cda60a$var$ranges = $4565394bb4cda60a$var$range = null;
    return $4565394bb4cda60a$var$lambda0 === Infinity || $4565394bb4cda60a$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $4565394bb4cda60a$var$lambda0,
            $4565394bb4cda60a$var$phi0
        ],
        [
            $4565394bb4cda60a$var$lambda1,
            $4565394bb4cda60a$var$phi1
        ]
    ];
}

});
parcelRegister("8mHes", function(module, exports) {

$parcel$export(module.exports, "spherical", function () { return $6171e9cc3315a8a4$export$12f9ad44fe773943; });
$parcel$export(module.exports, "cartesian", function () { return $6171e9cc3315a8a4$export$6e6697ef026a96; });
$parcel$export(module.exports, "cartesianDot", function () { return $6171e9cc3315a8a4$export$2ef80f51436a9de9; });
$parcel$export(module.exports, "cartesianCross", function () { return $6171e9cc3315a8a4$export$4763f5351b14293f; });
$parcel$export(module.exports, "cartesianAddInPlace", function () { return $6171e9cc3315a8a4$export$e62eba72fc898eae; });
$parcel$export(module.exports, "cartesianScale", function () { return $6171e9cc3315a8a4$export$52d0ee3fc868d452; });
$parcel$export(module.exports, "cartesianNormalizeInPlace", function () { return $6171e9cc3315a8a4$export$6789498aec2cb34b; });

var $kNUN7 = parcelRequire("kNUN7");
function $6171e9cc3315a8a4$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $kNUN7.atan2)(cartesian[1], cartesian[0]),
        (0, $kNUN7.asin)(cartesian[2])
    ];
}
function $6171e9cc3315a8a4$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $kNUN7.cos)(phi);
    return [
        cosPhi * (0, $kNUN7.cos)(lambda),
        cosPhi * (0, $kNUN7.sin)(lambda),
        (0, $kNUN7.sin)(phi)
    ];
}
function $6171e9cc3315a8a4$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $6171e9cc3315a8a4$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $6171e9cc3315a8a4$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $6171e9cc3315a8a4$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $6171e9cc3315a8a4$export$6789498aec2cb34b(d) {
    var l = (0, $kNUN7.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

});


parcelRegister("kWgmR", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $6cZzT = parcelRequire("6cZzT");

var $jRJb9 = parcelRequire("jRJb9");
var $f3e5ebb6982a61b3$var$W0, $f3e5ebb6982a61b3$var$W1, $f3e5ebb6982a61b3$var$X0, $f3e5ebb6982a61b3$var$Y0, $f3e5ebb6982a61b3$var$Z0, $f3e5ebb6982a61b3$var$X1, $f3e5ebb6982a61b3$var$Y1, $f3e5ebb6982a61b3$var$Z1, $f3e5ebb6982a61b3$var$X2, $f3e5ebb6982a61b3$var$Y2, $f3e5ebb6982a61b3$var$Z2, $f3e5ebb6982a61b3$var$lambda00, $f3e5ebb6982a61b3$var$phi00, $f3e5ebb6982a61b3$var$x0, $f3e5ebb6982a61b3$var$y0, $f3e5ebb6982a61b3$var$z0; // previous point
var $f3e5ebb6982a61b3$var$centroidStream = {
    sphere: (0, $6cZzT.default),
    point: $f3e5ebb6982a61b3$var$centroidPoint,
    lineStart: $f3e5ebb6982a61b3$var$centroidLineStart,
    lineEnd: $f3e5ebb6982a61b3$var$centroidLineEnd,
    polygonStart: function() {
        $f3e5ebb6982a61b3$var$centroidStream.lineStart = $f3e5ebb6982a61b3$var$centroidRingStart;
        $f3e5ebb6982a61b3$var$centroidStream.lineEnd = $f3e5ebb6982a61b3$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $f3e5ebb6982a61b3$var$centroidStream.lineStart = $f3e5ebb6982a61b3$var$centroidLineStart;
        $f3e5ebb6982a61b3$var$centroidStream.lineEnd = $f3e5ebb6982a61b3$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $f3e5ebb6982a61b3$var$centroidPoint(lambda, phi) {
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    var cosPhi = (0, $kNUN7.cos)(phi);
    $f3e5ebb6982a61b3$var$centroidPointCartesian(cosPhi * (0, $kNUN7.cos)(lambda), cosPhi * (0, $kNUN7.sin)(lambda), (0, $kNUN7.sin)(phi));
}
function $f3e5ebb6982a61b3$var$centroidPointCartesian(x, y, z) {
    ++$f3e5ebb6982a61b3$var$W0;
    $f3e5ebb6982a61b3$var$X0 += (x - $f3e5ebb6982a61b3$var$X0) / $f3e5ebb6982a61b3$var$W0;
    $f3e5ebb6982a61b3$var$Y0 += (y - $f3e5ebb6982a61b3$var$Y0) / $f3e5ebb6982a61b3$var$W0;
    $f3e5ebb6982a61b3$var$Z0 += (z - $f3e5ebb6982a61b3$var$Z0) / $f3e5ebb6982a61b3$var$W0;
}
function $f3e5ebb6982a61b3$var$centroidLineStart() {
    $f3e5ebb6982a61b3$var$centroidStream.point = $f3e5ebb6982a61b3$var$centroidLinePointFirst;
}
function $f3e5ebb6982a61b3$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    var cosPhi = (0, $kNUN7.cos)(phi);
    $f3e5ebb6982a61b3$var$x0 = cosPhi * (0, $kNUN7.cos)(lambda);
    $f3e5ebb6982a61b3$var$y0 = cosPhi * (0, $kNUN7.sin)(lambda);
    $f3e5ebb6982a61b3$var$z0 = (0, $kNUN7.sin)(phi);
    $f3e5ebb6982a61b3$var$centroidStream.point = $f3e5ebb6982a61b3$var$centroidLinePoint;
    $f3e5ebb6982a61b3$var$centroidPointCartesian($f3e5ebb6982a61b3$var$x0, $f3e5ebb6982a61b3$var$y0, $f3e5ebb6982a61b3$var$z0);
}
function $f3e5ebb6982a61b3$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    var cosPhi = (0, $kNUN7.cos)(phi), x = cosPhi * (0, $kNUN7.cos)(lambda), y = cosPhi * (0, $kNUN7.sin)(lambda), z = (0, $kNUN7.sin)(phi), w = (0, $kNUN7.atan2)((0, $kNUN7.sqrt)((w = $f3e5ebb6982a61b3$var$y0 * z - $f3e5ebb6982a61b3$var$z0 * y) * w + (w = $f3e5ebb6982a61b3$var$z0 * x - $f3e5ebb6982a61b3$var$x0 * z) * w + (w = $f3e5ebb6982a61b3$var$x0 * y - $f3e5ebb6982a61b3$var$y0 * x) * w), $f3e5ebb6982a61b3$var$x0 * x + $f3e5ebb6982a61b3$var$y0 * y + $f3e5ebb6982a61b3$var$z0 * z);
    $f3e5ebb6982a61b3$var$W1 += w;
    $f3e5ebb6982a61b3$var$X1 += w * ($f3e5ebb6982a61b3$var$x0 + ($f3e5ebb6982a61b3$var$x0 = x));
    $f3e5ebb6982a61b3$var$Y1 += w * ($f3e5ebb6982a61b3$var$y0 + ($f3e5ebb6982a61b3$var$y0 = y));
    $f3e5ebb6982a61b3$var$Z1 += w * ($f3e5ebb6982a61b3$var$z0 + ($f3e5ebb6982a61b3$var$z0 = z));
    $f3e5ebb6982a61b3$var$centroidPointCartesian($f3e5ebb6982a61b3$var$x0, $f3e5ebb6982a61b3$var$y0, $f3e5ebb6982a61b3$var$z0);
}
function $f3e5ebb6982a61b3$var$centroidLineEnd() {
    $f3e5ebb6982a61b3$var$centroidStream.point = $f3e5ebb6982a61b3$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $f3e5ebb6982a61b3$var$centroidRingStart() {
    $f3e5ebb6982a61b3$var$centroidStream.point = $f3e5ebb6982a61b3$var$centroidRingPointFirst;
}
function $f3e5ebb6982a61b3$var$centroidRingEnd() {
    $f3e5ebb6982a61b3$var$centroidRingPoint($f3e5ebb6982a61b3$var$lambda00, $f3e5ebb6982a61b3$var$phi00);
    $f3e5ebb6982a61b3$var$centroidStream.point = $f3e5ebb6982a61b3$var$centroidPoint;
}
function $f3e5ebb6982a61b3$var$centroidRingPointFirst(lambda, phi) {
    $f3e5ebb6982a61b3$var$lambda00 = lambda, $f3e5ebb6982a61b3$var$phi00 = phi;
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    $f3e5ebb6982a61b3$var$centroidStream.point = $f3e5ebb6982a61b3$var$centroidRingPoint;
    var cosPhi = (0, $kNUN7.cos)(phi);
    $f3e5ebb6982a61b3$var$x0 = cosPhi * (0, $kNUN7.cos)(lambda);
    $f3e5ebb6982a61b3$var$y0 = cosPhi * (0, $kNUN7.sin)(lambda);
    $f3e5ebb6982a61b3$var$z0 = (0, $kNUN7.sin)(phi);
    $f3e5ebb6982a61b3$var$centroidPointCartesian($f3e5ebb6982a61b3$var$x0, $f3e5ebb6982a61b3$var$y0, $f3e5ebb6982a61b3$var$z0);
}
function $f3e5ebb6982a61b3$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    var cosPhi = (0, $kNUN7.cos)(phi), x = cosPhi * (0, $kNUN7.cos)(lambda), y = cosPhi * (0, $kNUN7.sin)(lambda), z = (0, $kNUN7.sin)(phi), cx = $f3e5ebb6982a61b3$var$y0 * z - $f3e5ebb6982a61b3$var$z0 * y, cy = $f3e5ebb6982a61b3$var$z0 * x - $f3e5ebb6982a61b3$var$x0 * z, cz = $f3e5ebb6982a61b3$var$x0 * y - $f3e5ebb6982a61b3$var$y0 * x, m = (0, $kNUN7.sqrt)(cx * cx + cy * cy + cz * cz), w = (0, $kNUN7.asin)(m), v = m && -w / m; // area weight multiplier
    $f3e5ebb6982a61b3$var$X2 += v * cx;
    $f3e5ebb6982a61b3$var$Y2 += v * cy;
    $f3e5ebb6982a61b3$var$Z2 += v * cz;
    $f3e5ebb6982a61b3$var$W1 += w;
    $f3e5ebb6982a61b3$var$X1 += w * ($f3e5ebb6982a61b3$var$x0 + ($f3e5ebb6982a61b3$var$x0 = x));
    $f3e5ebb6982a61b3$var$Y1 += w * ($f3e5ebb6982a61b3$var$y0 + ($f3e5ebb6982a61b3$var$y0 = y));
    $f3e5ebb6982a61b3$var$Z1 += w * ($f3e5ebb6982a61b3$var$z0 + ($f3e5ebb6982a61b3$var$z0 = z));
    $f3e5ebb6982a61b3$var$centroidPointCartesian($f3e5ebb6982a61b3$var$x0, $f3e5ebb6982a61b3$var$y0, $f3e5ebb6982a61b3$var$z0);
}
function $f3e5ebb6982a61b3$export$2e2bcd8739ae039(object) {
    $f3e5ebb6982a61b3$var$W0 = $f3e5ebb6982a61b3$var$W1 = $f3e5ebb6982a61b3$var$X0 = $f3e5ebb6982a61b3$var$Y0 = $f3e5ebb6982a61b3$var$Z0 = $f3e5ebb6982a61b3$var$X1 = $f3e5ebb6982a61b3$var$Y1 = $f3e5ebb6982a61b3$var$Z1 = $f3e5ebb6982a61b3$var$X2 = $f3e5ebb6982a61b3$var$Y2 = $f3e5ebb6982a61b3$var$Z2 = 0;
    (0, $jRJb9.default)(object, $f3e5ebb6982a61b3$var$centroidStream);
    var x = $f3e5ebb6982a61b3$var$X2, y = $f3e5ebb6982a61b3$var$Y2, z = $f3e5ebb6982a61b3$var$Z2, m = x * x + y * y + z * z;
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $kNUN7.epsilon2)) {
        x = $f3e5ebb6982a61b3$var$X1, y = $f3e5ebb6982a61b3$var$Y1, z = $f3e5ebb6982a61b3$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($f3e5ebb6982a61b3$var$W1 < (0, $kNUN7.epsilon)) x = $f3e5ebb6982a61b3$var$X0, y = $f3e5ebb6982a61b3$var$Y0, z = $f3e5ebb6982a61b3$var$Z0;
        m = x * x + y * y + z * z;
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $kNUN7.epsilon2)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $kNUN7.atan2)(y, x) * (0, $kNUN7.degrees),
        (0, $kNUN7.asin)(z / (0, $kNUN7.sqrt)(m)) * (0, $kNUN7.degrees)
    ];
}

});

parcelRegister("dWoD6", function(module, exports) {

$parcel$export(module.exports, "circleStream", function () { return $a263cc14d3773331$export$b5441eb324cd8d4e; });

var $8mHes = parcelRequire("8mHes");

var $7w4IM = parcelRequire("7w4IM");

var $kNUN7 = parcelRequire("kNUN7");

var $hRYfY = parcelRequire("hRYfY");
function $a263cc14d3773331$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $kNUN7.cos)(radius), sinRadius = (0, $kNUN7.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $kNUN7.tau);
        t1 = radius - step / 2;
    } else {
        t0 = $a263cc14d3773331$var$circleRadius(cosRadius, t0);
        t1 = $a263cc14d3773331$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $kNUN7.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $8mHes.spherical)([
            cosRadius,
            -sinRadius * (0, $kNUN7.cos)(t),
            -sinRadius * (0, $kNUN7.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $a263cc14d3773331$var$circleRadius(cosRadius, point) {
    point = (0, $8mHes.cartesian)(point), point[0] -= cosRadius;
    (0, $8mHes.cartesianNormalizeInPlace)(point);
    var radius = (0, $kNUN7.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $kNUN7.tau) - (0, $kNUN7.epsilon)) % (0, $kNUN7.tau);
}
function $a263cc14d3773331$export$2e2bcd8739ae039() {
    var center = (0, $7w4IM.default)([
        0,
        0
    ]), radius = (0, $7w4IM.default)(90), precision = (0, $7w4IM.default)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $kNUN7.degrees), x[1] *= (0, $kNUN7.degrees);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $kNUN7.radians), p = precision.apply(this, arguments) * (0, $kNUN7.radians);
        ring = [];
        rotate = (0, $hRYfY.rotateRadians)(-c[0] * (0, $kNUN7.radians), -c[1] * (0, $kNUN7.radians), 0).invert;
        $a263cc14d3773331$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $7w4IM.default)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $7w4IM.default)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $7w4IM.default)(+_), circle) : precision;
    };
    return circle;
}

});
parcelRegister("7w4IM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $578f2f1d4eca48ec$export$2e2bcd8739ae039; });
function $578f2f1d4eca48ec$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("hRYfY", function(module, exports) {

$parcel$export(module.exports, "rotateRadians", function () { return $d0262097f9bc899c$export$a2ba89726971a90f; });
$parcel$export(module.exports, "default", function () { return $d0262097f9bc899c$export$2e2bcd8739ae039; });

var $k5uhq = parcelRequire("k5uhq");

var $kNUN7 = parcelRequire("kNUN7");
function $d0262097f9bc899c$var$rotationIdentity(lambda, phi) {
    return [
        lambda > (0, $kNUN7.pi) ? lambda - (0, $kNUN7.tau) : lambda < -(0, $kNUN7.pi) ? lambda + (0, $kNUN7.tau) : lambda,
        phi
    ];
}
$d0262097f9bc899c$var$rotationIdentity.invert = $d0262097f9bc899c$var$rotationIdentity;
function $d0262097f9bc899c$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $kNUN7.tau)) ? deltaPhi || deltaGamma ? (0, $k5uhq.default)($d0262097f9bc899c$var$rotationLambda(deltaLambda), $d0262097f9bc899c$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $d0262097f9bc899c$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $d0262097f9bc899c$var$rotationPhiGamma(deltaPhi, deltaGamma) : $d0262097f9bc899c$var$rotationIdentity;
}
function $d0262097f9bc899c$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $kNUN7.pi) ? lambda - (0, $kNUN7.tau) : lambda < -(0, $kNUN7.pi) ? lambda + (0, $kNUN7.tau) : lambda,
            phi
        ];
    };
}
function $d0262097f9bc899c$var$rotationLambda(deltaLambda) {
    var rotation = $d0262097f9bc899c$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $d0262097f9bc899c$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $d0262097f9bc899c$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $kNUN7.cos)(deltaPhi), sinDeltaPhi = (0, $kNUN7.sin)(deltaPhi), cosDeltaGamma = (0, $kNUN7.cos)(deltaGamma), sinDeltaGamma = (0, $kNUN7.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $kNUN7.cos)(phi), x = (0, $kNUN7.cos)(lambda) * cosPhi, y = (0, $kNUN7.sin)(lambda) * cosPhi, z = (0, $kNUN7.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $kNUN7.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $kNUN7.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $kNUN7.cos)(phi), x = (0, $kNUN7.cos)(lambda) * cosPhi, y = (0, $kNUN7.sin)(lambda) * cosPhi, z = (0, $kNUN7.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $kNUN7.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $kNUN7.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $d0262097f9bc899c$export$2e2bcd8739ae039(rotate) {
    rotate = $d0262097f9bc899c$export$a2ba89726971a90f(rotate[0] * (0, $kNUN7.radians), rotate[1] * (0, $kNUN7.radians), rotate.length > 2 ? rotate[2] * (0, $kNUN7.radians) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $kNUN7.radians), coordinates[1] * (0, $kNUN7.radians));
        return coordinates[0] *= (0, $kNUN7.degrees), coordinates[1] *= (0, $kNUN7.degrees), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $kNUN7.radians), coordinates[1] * (0, $kNUN7.radians));
        return coordinates[0] *= (0, $kNUN7.degrees), coordinates[1] *= (0, $kNUN7.degrees), coordinates;
    };
    return forward;
}

});
parcelRegister("k5uhq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9fbc347a1e0a276$export$2e2bcd8739ae039; });
function $e9fbc347a1e0a276$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}

});



parcelRegister("83woy", function(module, exports) {

$parcel$export(module.exports, "clipExtent", function () { return $5dd7bb83dce5f6bf$export$8948798bfea5de4f; });

var $kNUN7 = parcelRequire("kNUN7");

var $NR8uS = parcelRequire("NR8uS");

var $gewek = parcelRequire("gewek");

var $lvgUr = parcelRequire("lvgUr");
parcelRequire("9rNoJ");
var $2W2qM = parcelRequire("2W2qM");
var $5dd7bb83dce5f6bf$var$clipMax = 1e9, $5dd7bb83dce5f6bf$var$clipMin = -$5dd7bb83dce5f6bf$var$clipMax;
function $5dd7bb83dce5f6bf$export$8948798bfea5de4f(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $kNUN7.abs)(p[0] - x0) < (0, $kNUN7.epsilon) ? direction > 0 ? 0 : 3 : (0, $kNUN7.abs)(p[0] - x1) < (0, $kNUN7.epsilon) ? direction > 0 ? 2 : 1 : (0, $kNUN7.abs)(p[1] - y0) < (0, $kNUN7.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $NR8uS.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $2W2qM.default)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $lvgUr.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($5dd7bb83dce5f6bf$var$clipMin, Math.min($5dd7bb83dce5f6bf$var$clipMax, x_)),
                    y_ = Math.max($5dd7bb83dce5f6bf$var$clipMin, Math.min($5dd7bb83dce5f6bf$var$clipMax, y_))
                ], b = [
                    x = Math.max($5dd7bb83dce5f6bf$var$clipMin, Math.min($5dd7bb83dce5f6bf$var$clipMax, x)),
                    y = Math.max($5dd7bb83dce5f6bf$var$clipMin, Math.min($5dd7bb83dce5f6bf$var$clipMax, y))
                ];
                if ((0, $gewek.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}
function $5dd7bb83dce5f6bf$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = $5dd7bb83dce5f6bf$export$8948798bfea5de4f(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}

});
parcelRegister("NR8uS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $095dcb6e1778883a$export$2e2bcd8739ae039; });

var $6cZzT = parcelRequire("6cZzT");
function $095dcb6e1778883a$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y) {
            line.push([
                x,
                y
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $6cZzT.default),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}

});

parcelRegister("gewek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd16f462304a1528$export$2e2bcd8739ae039; });
function $bd16f462304a1528$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}

});

parcelRegister("lvgUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa799c0eeae6fefa$export$2e2bcd8739ae039; });

var $eIArd = parcelRequire("eIArd");
function $fa799c0eeae6fefa$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $fa799c0eeae6fefa$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        // If the first and last points of a segment are coincident, then treat as a
        // closed ring. TODO if all rings are closed, then the winding order of the
        // exterior ring should be checked.
        if ((0, $eIArd.default)(p0, p1)) {
            stream.lineStart();
            for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
            stream.lineEnd();
            return;
        }
        subject.push(x = new $fa799c0eeae6fefa$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $fa799c0eeae6fefa$var$Intersection(p0, null, x, false));
        subject.push(x = new $fa799c0eeae6fefa$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $fa799c0eeae6fefa$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $fa799c0eeae6fefa$var$link(subject);
    $fa799c0eeae6fefa$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $fa799c0eeae6fefa$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

});
parcelRegister("eIArd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab71708d3928f132$export$2e2bcd8739ae039; });

var $kNUN7 = parcelRequire("kNUN7");
function $ab71708d3928f132$export$2e2bcd8739ae039(a, b) {
    return (0, $kNUN7.abs)(a[0] - b[0]) < (0, $kNUN7.epsilon) && (0, $kNUN7.abs)(a[1] - b[1]) < (0, $kNUN7.epsilon);
}

});


parcelRegister("9rNoJ", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return (parcelRequire("2W2qM")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("9hcBA")).default; });

var $bDw63 = parcelRequire("bDw63");

var $40GcE = parcelRequire("40GcE");

var $f086o = parcelRequire("f086o");

var $ePxPG = parcelRequire("ePxPG");

var $wUqCQ = parcelRequire("wUqCQ");

var $54eX2 = parcelRequire("54eX2");

var $izvMs = parcelRequire("izvMs");

var $6oqH5 = parcelRequire("6oqH5");

var $ihlZ0 = parcelRequire("ihlZ0");

var $jaNtf = parcelRequire("jaNtf");

var $8UuS6 = parcelRequire("8UuS6");

var $QJsTD = parcelRequire("QJsTD");

var $cbJNW = parcelRequire("cbJNW");

var $bewbD = parcelRequire("bewbD");

var $2W2qM = parcelRequire("2W2qM");

var $8Zi0Y = parcelRequire("8Zi0Y");

var $2YPap = parcelRequire("2YPap");

var $ldhtE = parcelRequire("ldhtE");

var $1TY76 = parcelRequire("1TY76");

var $9hcBA = parcelRequire("9hcBA");

var $4WAEx = parcelRequire("4WAEx");

var $8XG1E = parcelRequire("8XG1E");

var $kJeYz = parcelRequire("kJeYz");

var $aUb2r = parcelRequire("aUb2r");

var $6DsKJ = parcelRequire("6DsKJ");

var $gInKO = parcelRequire("gInKO");

var $4QI4x = parcelRequire("4QI4x");

});
parcelRegister("bDw63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878c3bede43841c0$export$2e2bcd8739ae039; });

var $40GcE = parcelRequire("40GcE");

var $f086o = parcelRequire("f086o");
var $878c3bede43841c0$var$ascendingBisect = (0, $f086o.default)((0, $40GcE.default));
var $878c3bede43841c0$export$4d945ad3ad5751b0 = $878c3bede43841c0$var$ascendingBisect.right;
var $878c3bede43841c0$export$df7d25c84ebd12a5 = $878c3bede43841c0$var$ascendingBisect.left;
var $878c3bede43841c0$export$2e2bcd8739ae039 = $878c3bede43841c0$export$4d945ad3ad5751b0;

});
parcelRegister("40GcE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eb7e622c972179f$export$2e2bcd8739ae039; });
function $2eb7e622c972179f$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("f086o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aebd2409b55bec32$export$2e2bcd8739ae039; });

var $40GcE = parcelRequire("40GcE");
function $aebd2409b55bec32$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $aebd2409b55bec32$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $aebd2409b55bec32$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $40GcE.default)(f(d), x);
    };
}

});


parcelRegister("ePxPG", function(module, exports) {

var $2YPap = parcelRequire("2YPap");
function $acc0128ad48ae4a0$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $2YPap.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("2YPap", function(module, exports) {

$parcel$export(module.exports, "pair", function () { return $22b8e00d64d412a2$export$a04cb3fe8b81dd; });
function $22b8e00d64d412a2$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $22b8e00d64d412a2$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $22b8e00d64d412a2$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("wUqCQ", function(module, exports) {
function $062ec2c967580cb1$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("54eX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b08ec7542d28c2c$export$2e2bcd8739ae039; });

var $gInKO = parcelRequire("gInKO");
function $3b08ec7542d28c2c$export$2e2bcd8739ae039(array, f) {
    var v = (0, $gInKO.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("gInKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2b32e7818532eff$export$2e2bcd8739ae039; });

var $2uWCs = parcelRequire("2uWCs");
function $c2b32e7818532eff$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $2uWCs.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $2uWCs.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("2uWCs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d1bdaa89db4759d$export$2e2bcd8739ae039; });
function $1d1bdaa89db4759d$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("izvMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d85425d89a565530$export$2e2bcd8739ae039; });
function $d85425d89a565530$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("6oqH5", function(module, exports) {

var $liBpW = parcelRequire("liBpW");

var $bDw63 = parcelRequire("bDw63");

var $3UMcr = parcelRequire("3UMcr");

var $izvMs = parcelRequire("izvMs");

var $x5a1L = parcelRequire("x5a1L");

var $9hcBA = parcelRequire("9hcBA");

var $aUb2r = parcelRequire("aUb2r");

var $8UuS6 = parcelRequire("8UuS6");
function $4a79b0d442a450f9$export$2e2bcd8739ae039() {
    var value = (0, $x5a1L.default), domain = (0, $izvMs.default), threshold = (0, $8UuS6.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $aUb2r.tickStep)(x0, x1, tz);
            tz = (0, $9hcBA.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $bDw63.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $3UMcr.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $3UMcr.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $3UMcr.default)((0, $liBpW.slice).call(_)) : (0, $3UMcr.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("liBpW", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $f8184db68dcf7c32$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "map", function () { return $f8184db68dcf7c32$export$871de8747c9eaa88; });
var $f8184db68dcf7c32$var$array = Array.prototype;
var $f8184db68dcf7c32$export$58adb3bec8346d0f = $f8184db68dcf7c32$var$array.slice;
var $f8184db68dcf7c32$export$871de8747c9eaa88 = $f8184db68dcf7c32$var$array.map;

});

parcelRegister("3UMcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d9bfd82977eb220$export$2e2bcd8739ae039; });
function $2d9bfd82977eb220$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("x5a1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063715feeea4f627$export$2e2bcd8739ae039; });
function $063715feeea4f627$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("9hcBA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c0f7abd208d5cc7$export$2e2bcd8739ae039; });
function $6c0f7abd208d5cc7$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("aUb2r", function(module, exports) {

$parcel$export(module.exports, "tickStep", function () { return $7f07b259815417aa$export$81087d9b915d4ede; });
var $7f07b259815417aa$var$e10 = Math.sqrt(50), $7f07b259815417aa$var$e5 = Math.sqrt(10), $7f07b259815417aa$var$e2 = Math.sqrt(2);
function $7f07b259815417aa$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $7f07b259815417aa$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $7f07b259815417aa$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $7f07b259815417aa$var$e10 ? 10 : error >= $7f07b259815417aa$var$e5 ? 5 : error >= $7f07b259815417aa$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $7f07b259815417aa$var$e10 ? 10 : error >= $7f07b259815417aa$var$e5 ? 5 : error >= $7f07b259815417aa$var$e2 ? 2 : 1);
}
function $7f07b259815417aa$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $7f07b259815417aa$var$e10) step1 *= 10;
    else if (error >= $7f07b259815417aa$var$e5) step1 *= 5;
    else if (error >= $7f07b259815417aa$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("8UuS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67cb802c1678fa20$export$2e2bcd8739ae039; });
function $67cb802c1678fa20$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("ihlZ0", function(module, exports) {

var $liBpW = parcelRequire("liBpW");

var $40GcE = parcelRequire("40GcE");

var $2uWCs = parcelRequire("2uWCs");

var $1TY76 = parcelRequire("1TY76");
function $d4eadde7233fb523$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $liBpW.map).call(values, (0, $2uWCs.default)).sort((0, $40GcE.default));
    return Math.ceil((max - min) / (2 * ((0, $1TY76.default)(values, 0.75) - (0, $1TY76.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("1TY76", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16298ed11602fce6$export$2e2bcd8739ae039; });

var $2uWCs = parcelRequire("2uWCs");
function $16298ed11602fce6$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $2uWCs.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("jaNtf", function(module, exports) {

var $54eX2 = parcelRequire("54eX2");
function $df55535c5c15baab$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $54eX2.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("QJsTD", function(module, exports) {
function $09e81fdbe6fc95d2$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("cbJNW", function(module, exports) {

var $2uWCs = parcelRequire("2uWCs");
function $024a39fba1ffdb4f$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $2uWCs.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $2uWCs.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("bewbD", function(module, exports) {

var $40GcE = parcelRequire("40GcE");

var $2uWCs = parcelRequire("2uWCs");

var $1TY76 = parcelRequire("1TY76");
function $82d9f81cc2eec440$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $2uWCs.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $2uWCs.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $1TY76.default)(numbers.sort((0, $40GcE.default)), 0.5);
}

});

parcelRegister("2W2qM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2232e2439c911213$export$2e2bcd8739ae039; });
function $2232e2439c911213$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("8Zi0Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68b1fe94f59af1cc$export$2e2bcd8739ae039; });
function $68b1fe94f59af1cc$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("ldhtE", function(module, exports) {
function $f7185e79cd845c09$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("4WAEx", function(module, exports) {

var $40GcE = parcelRequire("40GcE");
function $399902b0ffe27a26$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $40GcE.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("8XG1E", function(module, exports) {
function $68646ed35f42f1c8$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("kJeYz", function(module, exports) {
function $f173a08d64c048ea$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("6DsKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d4cb05052933ac6$export$2e2bcd8739ae039; });

var $8Zi0Y = parcelRequire("8Zi0Y");
function $4d4cb05052933ac6$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $8Zi0Y.default)(matrix, $4d4cb05052933ac6$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $4d4cb05052933ac6$var$length(d) {
    return d.length;
}

});

parcelRegister("4QI4x", function(module, exports) {

var $6DsKJ = parcelRequire("6DsKJ");
function $387e348d20a73154$export$2e2bcd8739ae039() {
    return (0, $6DsKJ.default)(arguments);
}

});



parcelRegister("9mLIr", function(module, exports) {

var $fcrWr = parcelRequire("fcrWr");

var $gJwx7 = parcelRequire("gJwx7");

var $kNUN7 = parcelRequire("kNUN7");
var $01c280bfe2effd37$var$containsObjectType = {
    Feature: function(object, point) {
        return $01c280bfe2effd37$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($01c280bfe2effd37$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $01c280bfe2effd37$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $01c280bfe2effd37$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($01c280bfe2effd37$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $01c280bfe2effd37$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($01c280bfe2effd37$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $01c280bfe2effd37$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($01c280bfe2effd37$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($01c280bfe2effd37$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $01c280bfe2effd37$var$containsGeometry(geometry, point) {
    return geometry && $01c280bfe2effd37$var$containsGeometryType.hasOwnProperty(geometry.type) ? $01c280bfe2effd37$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $01c280bfe2effd37$var$containsPoint(coordinates, point) {
    return (0, $gJwx7.default)(coordinates, point) === 0;
}
function $01c280bfe2effd37$var$containsLine(coordinates, point) {
    var ab = (0, $gJwx7.default)(coordinates[0], coordinates[1]), ao = (0, $gJwx7.default)(coordinates[0], point), ob = (0, $gJwx7.default)(point, coordinates[1]);
    return ao + ob <= ab + (0, $kNUN7.epsilon);
}
function $01c280bfe2effd37$var$containsPolygon(coordinates, point) {
    return !!(0, $fcrWr.default)(coordinates.map($01c280bfe2effd37$var$ringRadians), $01c280bfe2effd37$var$pointRadians(point));
}
function $01c280bfe2effd37$var$ringRadians(ring) {
    return ring = ring.map($01c280bfe2effd37$var$pointRadians), ring.pop(), ring;
}
function $01c280bfe2effd37$var$pointRadians(point) {
    return [
        point[0] * (0, $kNUN7.radians),
        point[1] * (0, $kNUN7.radians)
    ];
}
function $01c280bfe2effd37$export$2e2bcd8739ae039(object, point) {
    return (object && $01c280bfe2effd37$var$containsObjectType.hasOwnProperty(object.type) ? $01c280bfe2effd37$var$containsObjectType[object.type] : $01c280bfe2effd37$var$containsGeometry)(object, point);
}

});
parcelRegister("fcrWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b10da69cbe71e520$export$2e2bcd8739ae039; });

var $kC5ta = parcelRequire("kC5ta");

var $8mHes = parcelRequire("8mHes");

var $kNUN7 = parcelRequire("kNUN7");
var $b10da69cbe71e520$var$sum = (0, $kC5ta.default)();
function $b10da69cbe71e520$export$2e2bcd8739ae039(polygon, point) {
    var lambda = point[0], phi = point[1], normal = [
        (0, $kNUN7.sin)(lambda),
        -(0, $kNUN7.cos)(lambda),
        0
    ], angle = 0, winding = 0;
    $b10da69cbe71e520$var$sum.reset();
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = point0[0], phi0 = point0[1] / 2 + (0, $kNUN7.quarterPi), sinPhi0 = (0, $kNUN7.sin)(phi0), cosPhi0 = (0, $kNUN7.cos)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = point1[0], phi1 = point1[1] / 2 + (0, $kNUN7.quarterPi), sinPhi1 = (0, $kNUN7.sin)(phi1), cosPhi1 = (0, $kNUN7.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $kNUN7.pi), k = sinPhi0 * sinPhi1;
            $b10da69cbe71e520$var$sum.add((0, $kNUN7.atan2)(k * sign * (0, $kNUN7.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, $kNUN7.cos)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $kNUN7.tau) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $8mHes.cartesianCross)((0, $8mHes.cartesian)(point0), (0, $8mHes.cartesian)(point1));
                (0, $8mHes.cartesianNormalizeInPlace)(arc);
                var intersection = (0, $8mHes.cartesianCross)(normal, arc);
                (0, $8mHes.cartesianNormalizeInPlace)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $kNUN7.asin)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $kNUN7.epsilon) || angle < (0, $kNUN7.epsilon) && $b10da69cbe71e520$var$sum < -(0, $kNUN7.epsilon)) ^ winding & 1;
}

});

parcelRegister("gJwx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ea15b2230370c4$export$2e2bcd8739ae039; });

var $ck2S5 = parcelRequire("ck2S5");
var $c2ea15b2230370c4$var$coordinates = [
    null,
    null
], $c2ea15b2230370c4$var$object = {
    type: "LineString",
    coordinates: $c2ea15b2230370c4$var$coordinates
};
function $c2ea15b2230370c4$export$2e2bcd8739ae039(a, b) {
    $c2ea15b2230370c4$var$coordinates[0] = a;
    $c2ea15b2230370c4$var$coordinates[1] = b;
    return (0, $ck2S5.default)($c2ea15b2230370c4$var$object);
}

});
parcelRegister("ck2S5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f89947849e919fb$export$2e2bcd8739ae039; });

var $kC5ta = parcelRequire("kC5ta");

var $kNUN7 = parcelRequire("kNUN7");

var $6cZzT = parcelRequire("6cZzT");

var $jRJb9 = parcelRequire("jRJb9");
var $8f89947849e919fb$var$lengthSum = (0, $kC5ta.default)(), $8f89947849e919fb$var$lambda0, $8f89947849e919fb$var$sinPhi0, $8f89947849e919fb$var$cosPhi0;
var $8f89947849e919fb$var$lengthStream = {
    sphere: (0, $6cZzT.default),
    point: (0, $6cZzT.default),
    lineStart: $8f89947849e919fb$var$lengthLineStart,
    lineEnd: (0, $6cZzT.default),
    polygonStart: (0, $6cZzT.default),
    polygonEnd: (0, $6cZzT.default)
};
function $8f89947849e919fb$var$lengthLineStart() {
    $8f89947849e919fb$var$lengthStream.point = $8f89947849e919fb$var$lengthPointFirst;
    $8f89947849e919fb$var$lengthStream.lineEnd = $8f89947849e919fb$var$lengthLineEnd;
}
function $8f89947849e919fb$var$lengthLineEnd() {
    $8f89947849e919fb$var$lengthStream.point = $8f89947849e919fb$var$lengthStream.lineEnd = (0, $6cZzT.default);
}
function $8f89947849e919fb$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    $8f89947849e919fb$var$lambda0 = lambda, $8f89947849e919fb$var$sinPhi0 = (0, $kNUN7.sin)(phi), $8f89947849e919fb$var$cosPhi0 = (0, $kNUN7.cos)(phi);
    $8f89947849e919fb$var$lengthStream.point = $8f89947849e919fb$var$lengthPoint;
}
function $8f89947849e919fb$var$lengthPoint(lambda, phi) {
    lambda *= (0, $kNUN7.radians), phi *= (0, $kNUN7.radians);
    var sinPhi = (0, $kNUN7.sin)(phi), cosPhi = (0, $kNUN7.cos)(phi), delta = (0, $kNUN7.abs)(lambda - $8f89947849e919fb$var$lambda0), cosDelta = (0, $kNUN7.cos)(delta), sinDelta = (0, $kNUN7.sin)(delta), x = cosPhi * sinDelta, y = $8f89947849e919fb$var$cosPhi0 * sinPhi - $8f89947849e919fb$var$sinPhi0 * cosPhi * cosDelta, z = $8f89947849e919fb$var$sinPhi0 * sinPhi + $8f89947849e919fb$var$cosPhi0 * cosPhi * cosDelta;
    $8f89947849e919fb$var$lengthSum.add((0, $kNUN7.atan2)((0, $kNUN7.sqrt)(x * x + y * y), z));
    $8f89947849e919fb$var$lambda0 = lambda, $8f89947849e919fb$var$sinPhi0 = sinPhi, $8f89947849e919fb$var$cosPhi0 = cosPhi;
}
function $8f89947849e919fb$export$2e2bcd8739ae039(object) {
    $8f89947849e919fb$var$lengthSum.reset();
    (0, $jRJb9.default)(object, $8f89947849e919fb$var$lengthStream);
    return +$8f89947849e919fb$var$lengthSum;
}

});



parcelRegister("52geN", function(module, exports) {
parcelRequire("9rNoJ");
var $9hcBA = parcelRequire("9hcBA");

var $kNUN7 = parcelRequire("kNUN7");
function $3aa9bc1f4463ff7e$var$graticuleX(y0, y1, dy) {
    var y = (0, $9hcBA.default)(y0, y1 - (0, $kNUN7.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $3aa9bc1f4463ff7e$var$graticuleY(x0, x1, dx) {
    var x = (0, $9hcBA.default)(x0, x1 - (0, $kNUN7.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $3aa9bc1f4463ff7e$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $9hcBA.default)((0, $kNUN7.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, $9hcBA.default)((0, $kNUN7.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $9hcBA.default)((0, $kNUN7.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $kNUN7.abs)(x % DX) > (0, $kNUN7.epsilon);
        }).map(x)).concat((0, $9hcBA.default)((0, $kNUN7.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $kNUN7.abs)(y % DY) > (0, $kNUN7.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $3aa9bc1f4463ff7e$var$graticuleX(y0, y1, 90);
        y = $3aa9bc1f4463ff7e$var$graticuleY(x0, x1, precision);
        X = $3aa9bc1f4463ff7e$var$graticuleX(Y0, Y1, 90);
        Y = $3aa9bc1f4463ff7e$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $kNUN7.epsilon)
        ],
        [
            180,
            90 - (0, $kNUN7.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $kNUN7.epsilon)
        ],
        [
            180,
            80 + (0, $kNUN7.epsilon)
        ]
    ]);
}
function $3aa9bc1f4463ff7e$export$b8db4e9403a5b6f1() {
    return $3aa9bc1f4463ff7e$export$2e2bcd8739ae039()();
}

});

parcelRegister("3v7c1", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");
function $28c9d8b73efb28b2$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $kNUN7.radians), y0 = a[1] * (0, $kNUN7.radians), x1 = b[0] * (0, $kNUN7.radians), y1 = b[1] * (0, $kNUN7.radians), cy0 = (0, $kNUN7.cos)(y0), sy0 = (0, $kNUN7.sin)(y0), cy1 = (0, $kNUN7.cos)(y1), sy1 = (0, $kNUN7.sin)(y1), kx0 = cy0 * (0, $kNUN7.cos)(x0), ky0 = cy0 * (0, $kNUN7.sin)(x0), kx1 = cy1 * (0, $kNUN7.cos)(x1), ky1 = cy1 * (0, $kNUN7.sin)(x1), d = 2 * (0, $kNUN7.asin)((0, $kNUN7.sqrt)((0, $kNUN7.haversin)(y1 - y0) + cy0 * cy1 * (0, $kNUN7.haversin)(x1 - x0))), k = (0, $kNUN7.sin)(d);
    var interpolate = d ? function(t) {
        var B = (0, $kNUN7.sin)(t *= d) / k, A = (0, $kNUN7.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $kNUN7.atan2)(y, x) * (0, $kNUN7.degrees),
            (0, $kNUN7.atan2)(z, (0, $kNUN7.sqrt)(x * x + y * y)) * (0, $kNUN7.degrees)
        ];
    } : function() {
        return [
            x0 * (0, $kNUN7.degrees),
            y0 * (0, $kNUN7.degrees)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}

});

parcelRegister("6k2uT", function(module, exports) {

var $1XGJc = parcelRequire("1XGJc");

var $jRJb9 = parcelRequire("jRJb9");

var $e8M5r = parcelRequire("e8M5r");

var $2yZKa = parcelRequire("2yZKa");

var $fT3Kv = parcelRequire("fT3Kv");

var $dyqRH = parcelRequire("dyqRH");

var $4XB0S = parcelRequire("4XB0S");

var $8NKQb = parcelRequire("8NKQb");
function $49a68c4291bdecab$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $jRJb9.default)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $jRJb9.default)(object, projectionStream((0, $e8M5r.default)));
        return (0, $e8M5r.default).result();
    };
    path.measure = function(object) {
        (0, $jRJb9.default)(object, projectionStream((0, $4XB0S.default)));
        return (0, $4XB0S.default).result();
    };
    path.bounds = function(object) {
        (0, $jRJb9.default)(object, projectionStream((0, $2yZKa.default)));
        return (0, $2yZKa.default).result();
    };
    path.centroid = function(object) {
        (0, $jRJb9.default)(object, projectionStream((0, $fT3Kv.default)));
        return (0, $fT3Kv.default).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $1XGJc.default) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $8NKQb.default)) : new (0, $dyqRH.default)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}

});
parcelRegister("1XGJc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16dc7209a57bf038$export$2e2bcd8739ae039; });
function $16dc7209a57bf038$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("e8M5r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4b71d118c12fc80$export$2e2bcd8739ae039; });

var $kC5ta = parcelRequire("kC5ta");

var $kNUN7 = parcelRequire("kNUN7");

var $6cZzT = parcelRequire("6cZzT");
var $a4b71d118c12fc80$var$areaSum = (0, $kC5ta.default)(), $a4b71d118c12fc80$var$areaRingSum = (0, $kC5ta.default)(), $a4b71d118c12fc80$var$x00, $a4b71d118c12fc80$var$y00, $a4b71d118c12fc80$var$x0, $a4b71d118c12fc80$var$y0;
var $a4b71d118c12fc80$var$areaStream = {
    point: (0, $6cZzT.default),
    lineStart: (0, $6cZzT.default),
    lineEnd: (0, $6cZzT.default),
    polygonStart: function() {
        $a4b71d118c12fc80$var$areaStream.lineStart = $a4b71d118c12fc80$var$areaRingStart;
        $a4b71d118c12fc80$var$areaStream.lineEnd = $a4b71d118c12fc80$var$areaRingEnd;
    },
    polygonEnd: function() {
        $a4b71d118c12fc80$var$areaStream.lineStart = $a4b71d118c12fc80$var$areaStream.lineEnd = $a4b71d118c12fc80$var$areaStream.point = (0, $6cZzT.default);
        $a4b71d118c12fc80$var$areaSum.add((0, $kNUN7.abs)($a4b71d118c12fc80$var$areaRingSum));
        $a4b71d118c12fc80$var$areaRingSum.reset();
    },
    result: function() {
        var area = $a4b71d118c12fc80$var$areaSum / 2;
        $a4b71d118c12fc80$var$areaSum.reset();
        return area;
    }
};
function $a4b71d118c12fc80$var$areaRingStart() {
    $a4b71d118c12fc80$var$areaStream.point = $a4b71d118c12fc80$var$areaPointFirst;
}
function $a4b71d118c12fc80$var$areaPointFirst(x, y) {
    $a4b71d118c12fc80$var$areaStream.point = $a4b71d118c12fc80$var$areaPoint;
    $a4b71d118c12fc80$var$x00 = $a4b71d118c12fc80$var$x0 = x, $a4b71d118c12fc80$var$y00 = $a4b71d118c12fc80$var$y0 = y;
}
function $a4b71d118c12fc80$var$areaPoint(x, y) {
    $a4b71d118c12fc80$var$areaRingSum.add($a4b71d118c12fc80$var$y0 * x - $a4b71d118c12fc80$var$x0 * y);
    $a4b71d118c12fc80$var$x0 = x, $a4b71d118c12fc80$var$y0 = y;
}
function $a4b71d118c12fc80$var$areaRingEnd() {
    $a4b71d118c12fc80$var$areaPoint($a4b71d118c12fc80$var$x00, $a4b71d118c12fc80$var$y00);
}
var $a4b71d118c12fc80$export$2e2bcd8739ae039 = $a4b71d118c12fc80$var$areaStream;

});

parcelRegister("2yZKa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ddea6c5649c8653$export$2e2bcd8739ae039; });

var $6cZzT = parcelRequire("6cZzT");
var $1ddea6c5649c8653$var$x0 = Infinity, $1ddea6c5649c8653$var$y0 = $1ddea6c5649c8653$var$x0, $1ddea6c5649c8653$var$x1 = -$1ddea6c5649c8653$var$x0, $1ddea6c5649c8653$var$y1 = $1ddea6c5649c8653$var$x1;
var $1ddea6c5649c8653$var$boundsStream = {
    point: $1ddea6c5649c8653$var$boundsPoint,
    lineStart: (0, $6cZzT.default),
    lineEnd: (0, $6cZzT.default),
    polygonStart: (0, $6cZzT.default),
    polygonEnd: (0, $6cZzT.default),
    result: function() {
        var bounds = [
            [
                $1ddea6c5649c8653$var$x0,
                $1ddea6c5649c8653$var$y0
            ],
            [
                $1ddea6c5649c8653$var$x1,
                $1ddea6c5649c8653$var$y1
            ]
        ];
        $1ddea6c5649c8653$var$x1 = $1ddea6c5649c8653$var$y1 = -($1ddea6c5649c8653$var$y0 = $1ddea6c5649c8653$var$x0 = Infinity);
        return bounds;
    }
};
function $1ddea6c5649c8653$var$boundsPoint(x, y) {
    if (x < $1ddea6c5649c8653$var$x0) $1ddea6c5649c8653$var$x0 = x;
    if (x > $1ddea6c5649c8653$var$x1) $1ddea6c5649c8653$var$x1 = x;
    if (y < $1ddea6c5649c8653$var$y0) $1ddea6c5649c8653$var$y0 = y;
    if (y > $1ddea6c5649c8653$var$y1) $1ddea6c5649c8653$var$y1 = y;
}
var $1ddea6c5649c8653$export$2e2bcd8739ae039 = $1ddea6c5649c8653$var$boundsStream;

});

parcelRegister("fT3Kv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b90ee695979e5878$export$2e2bcd8739ae039; });

var $kNUN7 = parcelRequire("kNUN7");
// TODO Enforce positive area for exterior, negative area for interior?
var $b90ee695979e5878$var$X0 = 0, $b90ee695979e5878$var$Y0 = 0, $b90ee695979e5878$var$Z0 = 0, $b90ee695979e5878$var$X1 = 0, $b90ee695979e5878$var$Y1 = 0, $b90ee695979e5878$var$Z1 = 0, $b90ee695979e5878$var$X2 = 0, $b90ee695979e5878$var$Y2 = 0, $b90ee695979e5878$var$Z2 = 0, $b90ee695979e5878$var$x00, $b90ee695979e5878$var$y00, $b90ee695979e5878$var$x0, $b90ee695979e5878$var$y0;
var $b90ee695979e5878$var$centroidStream = {
    point: $b90ee695979e5878$var$centroidPoint,
    lineStart: $b90ee695979e5878$var$centroidLineStart,
    lineEnd: $b90ee695979e5878$var$centroidLineEnd,
    polygonStart: function() {
        $b90ee695979e5878$var$centroidStream.lineStart = $b90ee695979e5878$var$centroidRingStart;
        $b90ee695979e5878$var$centroidStream.lineEnd = $b90ee695979e5878$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $b90ee695979e5878$var$centroidStream.point = $b90ee695979e5878$var$centroidPoint;
        $b90ee695979e5878$var$centroidStream.lineStart = $b90ee695979e5878$var$centroidLineStart;
        $b90ee695979e5878$var$centroidStream.lineEnd = $b90ee695979e5878$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $b90ee695979e5878$var$Z2 ? [
            $b90ee695979e5878$var$X2 / $b90ee695979e5878$var$Z2,
            $b90ee695979e5878$var$Y2 / $b90ee695979e5878$var$Z2
        ] : $b90ee695979e5878$var$Z1 ? [
            $b90ee695979e5878$var$X1 / $b90ee695979e5878$var$Z1,
            $b90ee695979e5878$var$Y1 / $b90ee695979e5878$var$Z1
        ] : $b90ee695979e5878$var$Z0 ? [
            $b90ee695979e5878$var$X0 / $b90ee695979e5878$var$Z0,
            $b90ee695979e5878$var$Y0 / $b90ee695979e5878$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $b90ee695979e5878$var$X0 = $b90ee695979e5878$var$Y0 = $b90ee695979e5878$var$Z0 = $b90ee695979e5878$var$X1 = $b90ee695979e5878$var$Y1 = $b90ee695979e5878$var$Z1 = $b90ee695979e5878$var$X2 = $b90ee695979e5878$var$Y2 = $b90ee695979e5878$var$Z2 = 0;
        return centroid;
    }
};
function $b90ee695979e5878$var$centroidPoint(x, y) {
    $b90ee695979e5878$var$X0 += x;
    $b90ee695979e5878$var$Y0 += y;
    ++$b90ee695979e5878$var$Z0;
}
function $b90ee695979e5878$var$centroidLineStart() {
    $b90ee695979e5878$var$centroidStream.point = $b90ee695979e5878$var$centroidPointFirstLine;
}
function $b90ee695979e5878$var$centroidPointFirstLine(x, y) {
    $b90ee695979e5878$var$centroidStream.point = $b90ee695979e5878$var$centroidPointLine;
    $b90ee695979e5878$var$centroidPoint($b90ee695979e5878$var$x0 = x, $b90ee695979e5878$var$y0 = y);
}
function $b90ee695979e5878$var$centroidPointLine(x, y) {
    var dx = x - $b90ee695979e5878$var$x0, dy = y - $b90ee695979e5878$var$y0, z = (0, $kNUN7.sqrt)(dx * dx + dy * dy);
    $b90ee695979e5878$var$X1 += z * ($b90ee695979e5878$var$x0 + x) / 2;
    $b90ee695979e5878$var$Y1 += z * ($b90ee695979e5878$var$y0 + y) / 2;
    $b90ee695979e5878$var$Z1 += z;
    $b90ee695979e5878$var$centroidPoint($b90ee695979e5878$var$x0 = x, $b90ee695979e5878$var$y0 = y);
}
function $b90ee695979e5878$var$centroidLineEnd() {
    $b90ee695979e5878$var$centroidStream.point = $b90ee695979e5878$var$centroidPoint;
}
function $b90ee695979e5878$var$centroidRingStart() {
    $b90ee695979e5878$var$centroidStream.point = $b90ee695979e5878$var$centroidPointFirstRing;
}
function $b90ee695979e5878$var$centroidRingEnd() {
    $b90ee695979e5878$var$centroidPointRing($b90ee695979e5878$var$x00, $b90ee695979e5878$var$y00);
}
function $b90ee695979e5878$var$centroidPointFirstRing(x, y) {
    $b90ee695979e5878$var$centroidStream.point = $b90ee695979e5878$var$centroidPointRing;
    $b90ee695979e5878$var$centroidPoint($b90ee695979e5878$var$x00 = $b90ee695979e5878$var$x0 = x, $b90ee695979e5878$var$y00 = $b90ee695979e5878$var$y0 = y);
}
function $b90ee695979e5878$var$centroidPointRing(x, y) {
    var dx = x - $b90ee695979e5878$var$x0, dy = y - $b90ee695979e5878$var$y0, z = (0, $kNUN7.sqrt)(dx * dx + dy * dy);
    $b90ee695979e5878$var$X1 += z * ($b90ee695979e5878$var$x0 + x) / 2;
    $b90ee695979e5878$var$Y1 += z * ($b90ee695979e5878$var$y0 + y) / 2;
    $b90ee695979e5878$var$Z1 += z;
    z = $b90ee695979e5878$var$y0 * x - $b90ee695979e5878$var$x0 * y;
    $b90ee695979e5878$var$X2 += z * ($b90ee695979e5878$var$x0 + x);
    $b90ee695979e5878$var$Y2 += z * ($b90ee695979e5878$var$y0 + y);
    $b90ee695979e5878$var$Z2 += z * 3;
    $b90ee695979e5878$var$centroidPoint($b90ee695979e5878$var$x0 = x, $b90ee695979e5878$var$y0 = y);
}
var $b90ee695979e5878$export$2e2bcd8739ae039 = $b90ee695979e5878$var$centroidStream;

});

parcelRegister("dyqRH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9de34a2fbba8059e$export$2e2bcd8739ae039; });

var $kNUN7 = parcelRequire("kNUN7");

var $6cZzT = parcelRequire("6cZzT");
function $9de34a2fbba8059e$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$9de34a2fbba8059e$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $kNUN7.tau));
                break;
        }
    },
    result: (0, $6cZzT.default)
};

});

parcelRegister("4XB0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c9622086d25e6b$export$2e2bcd8739ae039; });

var $kC5ta = parcelRequire("kC5ta");

var $kNUN7 = parcelRequire("kNUN7");

var $6cZzT = parcelRequire("6cZzT");
var $39c9622086d25e6b$var$lengthSum = (0, $kC5ta.default)(), $39c9622086d25e6b$var$lengthRing, $39c9622086d25e6b$var$x00, $39c9622086d25e6b$var$y00, $39c9622086d25e6b$var$x0, $39c9622086d25e6b$var$y0;
var $39c9622086d25e6b$var$lengthStream = {
    point: (0, $6cZzT.default),
    lineStart: function() {
        $39c9622086d25e6b$var$lengthStream.point = $39c9622086d25e6b$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($39c9622086d25e6b$var$lengthRing) $39c9622086d25e6b$var$lengthPoint($39c9622086d25e6b$var$x00, $39c9622086d25e6b$var$y00);
        $39c9622086d25e6b$var$lengthStream.point = (0, $6cZzT.default);
    },
    polygonStart: function() {
        $39c9622086d25e6b$var$lengthRing = true;
    },
    polygonEnd: function() {
        $39c9622086d25e6b$var$lengthRing = null;
    },
    result: function() {
        var length = +$39c9622086d25e6b$var$lengthSum;
        $39c9622086d25e6b$var$lengthSum.reset();
        return length;
    }
};
function $39c9622086d25e6b$var$lengthPointFirst(x, y) {
    $39c9622086d25e6b$var$lengthStream.point = $39c9622086d25e6b$var$lengthPoint;
    $39c9622086d25e6b$var$x00 = $39c9622086d25e6b$var$x0 = x, $39c9622086d25e6b$var$y00 = $39c9622086d25e6b$var$y0 = y;
}
function $39c9622086d25e6b$var$lengthPoint(x, y) {
    $39c9622086d25e6b$var$x0 -= x, $39c9622086d25e6b$var$y0 -= y;
    $39c9622086d25e6b$var$lengthSum.add((0, $kNUN7.sqrt)($39c9622086d25e6b$var$x0 * $39c9622086d25e6b$var$x0 + $39c9622086d25e6b$var$y0 * $39c9622086d25e6b$var$y0));
    $39c9622086d25e6b$var$x0 = x, $39c9622086d25e6b$var$y0 = y;
}
var $39c9622086d25e6b$export$2e2bcd8739ae039 = $39c9622086d25e6b$var$lengthStream;

});

parcelRegister("8NKQb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66873be98112e204$export$2e2bcd8739ae039; });
function $66873be98112e204$export$2e2bcd8739ae039() {
    this._string = [];
}
$66873be98112e204$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $66873be98112e204$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $66873be98112e204$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $66873be98112e204$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

});


parcelRegister("hsQTR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb6e16006ca41d13$export$2e2bcd8739ae039; });

var $hFcZE = parcelRequire("hFcZE");
function $cb6e16006ca41d13$export$2e2bcd8739ae039() {
    return (0, $hFcZE.default)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}

});
parcelRegister("hFcZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdc05832f650b5f5$export$2e2bcd8739ae039; });

var $kNUN7 = parcelRequire("kNUN7");

var $lrO5L = parcelRequire("lrO5L");

var $2GFZa = parcelRequire("2GFZa");
function $cdc05832f650b5f5$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $kNUN7.sin)(y0), n = (sy0 + (0, $kNUN7.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $kNUN7.abs)(n) < (0, $kNUN7.epsilon)) return (0, $2GFZa.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $kNUN7.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, $kNUN7.sqrt)(c - 2 * n * (0, $kNUN7.sin)(y)) / n;
        return [
            r * (0, $kNUN7.sin)(x *= n),
            r0 - r * (0, $kNUN7.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y;
        return [
            (0, $kNUN7.atan2)(x, (0, $kNUN7.abs)(r0y)) / n * (0, $kNUN7.sign)(r0y),
            (0, $kNUN7.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $cdc05832f650b5f5$export$2e2bcd8739ae039() {
    return (0, $lrO5L.conicProjection)($cdc05832f650b5f5$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}

});
parcelRegister("lrO5L", function(module, exports) {

$parcel$export(module.exports, "conicProjection", function () { return $f9d2f9cc685bec3e$export$228272587c4d24d8; });

var $kNUN7 = parcelRequire("kNUN7");

var $lsk55 = parcelRequire("lsk55");
function $f9d2f9cc685bec3e$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $kNUN7.pi) / 3, m = (0, $lsk55.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $kNUN7.radians), phi1 = _[1] * (0, $kNUN7.radians)) : [
            phi0 * (0, $kNUN7.degrees),
            phi1 * (0, $kNUN7.degrees)
        ];
    };
    return p;
}

});
parcelRegister("lsk55", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9ebca31f374881f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "projectionMutator", function () { return $f9ebca31f374881f$export$155d5a6fa6fddeba; });

var $fmMcy = parcelRequire("fmMcy");

var $9Muut = parcelRequire("9Muut");

var $83woy = parcelRequire("83woy");

var $k5uhq = parcelRequire("k5uhq");

var $1XGJc = parcelRequire("1XGJc");

var $kNUN7 = parcelRequire("kNUN7");

var $hRYfY = parcelRequire("hRYfY");

var $eNZUM = parcelRequire("eNZUM");

var $aDqKD = parcelRequire("aDqKD");

var $8GI4N = parcelRequire("8GI4N");
var $f9ebca31f374881f$var$transformRadians = (0, $eNZUM.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, $kNUN7.radians), y * (0, $kNUN7.radians));
    }
});
function $f9ebca31f374881f$export$2e2bcd8739ae039(project) {
    return $f9ebca31f374881f$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $f9ebca31f374881f$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, dx, dy, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, theta = null, preclip = (0, $fmMcy.default), x0 = null, y0, x1, y1, postclip = (0, $1XGJc.default), delta2 = 0.5, projectResample = (0, $8GI4N.default)(projectTransform, delta2), cache, cacheStream;
    function projection(point) {
        point = projectRotate(point[0] * (0, $kNUN7.radians), point[1] * (0, $kNUN7.radians));
        return [
            point[0] * k + dx,
            dy - point[1] * k
        ];
    }
    function invert(point) {
        point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
        return point && [
            point[0] * (0, $kNUN7.degrees),
            point[1] * (0, $kNUN7.degrees)
        ];
    }
    function projectTransform(x, y) {
        return x = project(x, y), [
            x[0] * k + dx,
            dy - x[1] * k
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $f9ebca31f374881f$var$transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $9Muut.default)(theta = _ * (0, $kNUN7.radians), 6 * (0, $kNUN7.radians)) : (theta = null, $fmMcy.default), reset()) : theta * (0, $kNUN7.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $1XGJc.default) : (0, $83woy.clipExtent)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $kNUN7.radians), phi = _[1] % 360 * (0, $kNUN7.radians), recenter()) : [
            lambda * (0, $kNUN7.degrees),
            phi * (0, $kNUN7.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $kNUN7.radians), deltaPhi = _[1] % 360 * (0, $kNUN7.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $kNUN7.radians) : 0, recenter()) : [
            deltaLambda * (0, $kNUN7.degrees),
            deltaPhi * (0, $kNUN7.degrees),
            deltaGamma * (0, $kNUN7.degrees)
        ];
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $8GI4N.default)(projectTransform, delta2 = _ * _), reset()) : (0, $kNUN7.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $aDqKD.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $aDqKD.fitSize)(projection, size, object);
    };
    function recenter() {
        projectRotate = (0, $k5uhq.default)(rotate = (0, $hRYfY.rotateRadians)(deltaLambda, deltaPhi, deltaGamma), project);
        var center = project(lambda, phi);
        dx = x - center[0] * k;
        dy = y + center[1] * k;
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

});
parcelRegister("fmMcy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2fe4ce63b5b5d2a$export$2e2bcd8739ae039; });

var $gqdzD = parcelRequire("gqdzD");

var $kNUN7 = parcelRequire("kNUN7");
var $b2fe4ce63b5b5d2a$export$2e2bcd8739ae039 = (0, $gqdzD.default)(function() {
    return true;
}, $b2fe4ce63b5b5d2a$var$clipAntimeridianLine, $b2fe4ce63b5b5d2a$var$clipAntimeridianInterpolate, [
    -(0, $kNUN7.pi),
    -(0, $kNUN7.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $b2fe4ce63b5b5d2a$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $kNUN7.pi) : -(0, $kNUN7.pi), delta = (0, $kNUN7.abs)(lambda1 - lambda0);
            if ((0, $kNUN7.abs)(delta - (0, $kNUN7.pi)) < (0, $kNUN7.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $kNUN7.halfPi) : -(0, $kNUN7.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $kNUN7.pi)) {
                if ((0, $kNUN7.abs)(lambda0 - sign0) < (0, $kNUN7.epsilon)) lambda0 -= sign0 * (0, $kNUN7.epsilon); // handle degeneracies
                if ((0, $kNUN7.abs)(lambda1 - sign1) < (0, $kNUN7.epsilon)) lambda1 -= sign1 * (0, $kNUN7.epsilon);
                phi0 = $b2fe4ce63b5b5d2a$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $b2fe4ce63b5b5d2a$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $kNUN7.sin)(lambda0 - lambda1);
    return (0, $kNUN7.abs)(sinLambda0Lambda1) > (0, $kNUN7.epsilon) ? (0, $kNUN7.atan)(((0, $kNUN7.sin)(phi0) * (cosPhi1 = (0, $kNUN7.cos)(phi1)) * (0, $kNUN7.sin)(lambda1) - (0, $kNUN7.sin)(phi1) * (cosPhi0 = (0, $kNUN7.cos)(phi0)) * (0, $kNUN7.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $b2fe4ce63b5b5d2a$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $kNUN7.halfPi);
        stream.point(-(0, $kNUN7.pi), phi);
        stream.point(0, phi);
        stream.point((0, $kNUN7.pi), phi);
        stream.point((0, $kNUN7.pi), 0);
        stream.point((0, $kNUN7.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $kNUN7.pi), -phi);
        stream.point(-(0, $kNUN7.pi), 0);
        stream.point(-(0, $kNUN7.pi), phi);
    } else if ((0, $kNUN7.abs)(from[0] - to[0]) > (0, $kNUN7.epsilon)) {
        var lambda = from[0] < to[0] ? (0, $kNUN7.pi) : -(0, $kNUN7.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

});
parcelRegister("gqdzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf499a80d612b792$export$2e2bcd8739ae039; });

var $NR8uS = parcelRequire("NR8uS");

var $lvgUr = parcelRequire("lvgUr");

var $kNUN7 = parcelRequire("kNUN7");

var $fcrWr = parcelRequire("fcrWr");
parcelRequire("9rNoJ");
var $2W2qM = parcelRequire("2W2qM");
function $bf499a80d612b792$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(rotate, sink) {
        var line = clipLine(sink), rotatedStart = rotate.invert(start[0], start[1]), ringBuffer = (0, $NR8uS.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $2W2qM.default)(segments);
                var startInside = (0, $fcrWr.default)(polygon, rotatedStart);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $lvgUr.default)(segments, $bf499a80d612b792$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            var point = rotate(lambda, phi);
            if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            var point = rotate(lambda, phi);
            line.point(point[0], point[1]);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            var point = rotate(lambda, phi);
            ringSink.point(point[0], point[1]);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($bf499a80d612b792$var$validSegment));
        }
        return clip;
    };
}
function $bf499a80d612b792$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $bf499a80d612b792$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $kNUN7.halfPi) - (0, $kNUN7.epsilon) : (0, $kNUN7.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $kNUN7.halfPi) - (0, $kNUN7.epsilon) : (0, $kNUN7.halfPi) - b[1]);
}

});


parcelRegister("9Muut", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71f03f8b67c08e51$export$2e2bcd8739ae039; });

var $8mHes = parcelRequire("8mHes");

var $dWoD6 = parcelRequire("dWoD6");

var $kNUN7 = parcelRequire("kNUN7");

var $eIArd = parcelRequire("eIArd");

var $gqdzD = parcelRequire("gqdzD");
function $71f03f8b67c08e51$export$2e2bcd8739ae039(radius, delta) {
    var cr = (0, $kNUN7.cos)(radius), smallRadius = cr > 0, notHemisphere = (0, $kNUN7.abs)(cr) > (0, $kNUN7.epsilon); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $dWoD6.circleStream)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $kNUN7.cos)(lambda) * (0, $kNUN7.cos)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $kNUN7.pi) : -(0, $kNUN7.pi)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                // Handle degeneracies.
                // TODO ignore if not clipping polygons.
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $eIArd.default)(point0, point2) || (0, $eIArd.default)(point1, point2)) {
                        point1[0] += (0, $kNUN7.epsilon);
                        point1[1] += (0, $kNUN7.epsilon);
                        v = visible(point1[0], point1[1]);
                    }
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1]);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                        }
                    }
                }
                if (v && (!point0 || !(0, $eIArd.default)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $8mHes.cartesian)(a), pb = (0, $8mHes.cartesian)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $8mHes.cartesianCross)(pa, pb), n2n2 = (0, $8mHes.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $8mHes.cartesianCross)(n1, n2), A = (0, $8mHes.cartesianScale)(n1, c1), B = (0, $8mHes.cartesianScale)(n2, c2);
        (0, $8mHes.cartesianAddInPlace)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $8mHes.cartesianDot)(A, u), uu = (0, $8mHes.cartesianDot)(u, u), t2 = w * w - uu * ((0, $8mHes.cartesianDot)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $kNUN7.sqrt)(t2), q = (0, $8mHes.cartesianScale)(u, (-w - t) / uu);
        (0, $8mHes.cartesianAddInPlace)(q, A);
        q = (0, $8mHes.spherical)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $kNUN7.abs)(delta - (0, $kNUN7.pi)) < (0, $kNUN7.epsilon), meridian = polar || delta < (0, $kNUN7.epsilon);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $kNUN7.abs)(q[0] - lambda0) < (0, $kNUN7.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $kNUN7.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $8mHes.cartesianScale)(u, (-w + t) / uu);
            (0, $8mHes.cartesianAddInPlace)(q1, A);
            return [
                q,
                (0, $8mHes.spherical)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $kNUN7.pi) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $gqdzD.default)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $kNUN7.pi),
        radius - (0, $kNUN7.pi)
    ]);
}

});

parcelRegister("eNZUM", function(module, exports) {

$parcel$export(module.exports, "transformer", function () { return $ac75ab434ac8c5d7$export$6b468dcfb64c653c; });
function $ac75ab434ac8c5d7$export$2e2bcd8739ae039(methods) {
    return {
        stream: $ac75ab434ac8c5d7$export$6b468dcfb64c653c(methods)
    };
}
function $ac75ab434ac8c5d7$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $ac75ab434ac8c5d7$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $ac75ab434ac8c5d7$var$TransformStream() {}
$ac75ab434ac8c5d7$var$TransformStream.prototype = {
    constructor: $ac75ab434ac8c5d7$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

});

parcelRegister("aDqKD", function(module, exports) {

$parcel$export(module.exports, "fitExtent", function () { return $7be24c22a7e4806f$export$e450184041869e7f; });
$parcel$export(module.exports, "fitSize", function () { return $7be24c22a7e4806f$export$33a367fa1728c3ba; });

var $jRJb9 = parcelRequire("jRJb9");

var $2yZKa = parcelRequire("2yZKa");
function $7be24c22a7e4806f$export$e450184041869e7f(projection, extent, object) {
    var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $jRJb9.default)(object, projection.stream((0, $2yZKa.default)));
    var b = (0, $2yZKa.default).result(), k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    if (clip != null) projection.clipExtent(clip);
    return projection.scale(k * 150).translate([
        x,
        y
    ]);
}
function $7be24c22a7e4806f$export$33a367fa1728c3ba(projection, size, object) {
    return $7be24c22a7e4806f$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}

});

parcelRegister("8GI4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65346fa279e22248$export$2e2bcd8739ae039; });

var $8mHes = parcelRequire("8mHes");

var $kNUN7 = parcelRequire("kNUN7");

var $eNZUM = parcelRequire("eNZUM");
var $65346fa279e22248$var$maxDepth = 16, $65346fa279e22248$var$cosMinDistance = (0, $kNUN7.cos)(30 * (0, $kNUN7.radians)); // cos(minimum angular distance)
function $65346fa279e22248$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $65346fa279e22248$var$resample(project, delta2) : $65346fa279e22248$var$resampleNone(project);
}
function $65346fa279e22248$var$resampleNone(project) {
    return (0, $eNZUM.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $65346fa279e22248$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $kNUN7.sqrt)(a * a + b * b + c * c), phi2 = (0, $kNUN7.asin)(c /= m), lambda2 = (0, $kNUN7.abs)((0, $kNUN7.abs)(c) - 1) < (0, $kNUN7.epsilon) || (0, $kNUN7.abs)(lambda0 - lambda1) < (0, $kNUN7.epsilon) ? (lambda0 + lambda1) / 2 : (0, $kNUN7.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $kNUN7.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $65346fa279e22248$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $8mHes.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $65346fa279e22248$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $65346fa279e22248$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

});



parcelRegister("2GFZa", function(module, exports) {

$parcel$export(module.exports, "cylindricalEqualAreaRaw", function () { return $1f50127aba24e26a$export$ae68c6db8b65046a; });

var $kNUN7 = parcelRequire("kNUN7");
function $1f50127aba24e26a$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $kNUN7.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $kNUN7.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $kNUN7.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

});



parcelRegister("jogIs", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $hsQTR = parcelRequire("hsQTR");

var $hFcZE = parcelRequire("hFcZE");

var $aDqKD = parcelRequire("aDqKD");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $e1dd39b145bd3daa$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $e1dd39b145bd3daa$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $hsQTR.default)(), lower48Point, alaska = (0, $hFcZE.default)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $hFcZE.default)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $e1dd39b145bd3daa$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $kNUN7.epsilon),
                y + 0.120 * k + (0, $kNUN7.epsilon)
            ],
            [
                x - 0.214 * k - (0, $kNUN7.epsilon),
                y + 0.234 * k - (0, $kNUN7.epsilon)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $kNUN7.epsilon),
                y + 0.166 * k + (0, $kNUN7.epsilon)
            ],
            [
                x - 0.115 * k - (0, $kNUN7.epsilon),
                y + 0.234 * k - (0, $kNUN7.epsilon)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $aDqKD.fitExtent)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $aDqKD.fitSize)(albersUsa, size, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}

});

parcelRegister("bzumx", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $eoCMd = parcelRequire("eoCMd");

var $lsk55 = parcelRequire("lsk55");
var $86ca83f1da8ae91d$export$5e11f94fc4a8d2c6 = (0, $eoCMd.azimuthalRaw)(function(cxcy) {
    return (0, $kNUN7.sqrt)(2 / (1 + cxcy));
});
$86ca83f1da8ae91d$export$5e11f94fc4a8d2c6.invert = (0, $eoCMd.azimuthalInvert)(function(z) {
    return 2 * (0, $kNUN7.asin)(z / 2);
});
function $86ca83f1da8ae91d$export$2e2bcd8739ae039() {
    return (0, $lsk55.default)($86ca83f1da8ae91d$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}

});
parcelRegister("eoCMd", function(module, exports) {

$parcel$export(module.exports, "azimuthalRaw", function () { return $a7b162d52f6c1bca$export$f1211ac1bdb0796; });
$parcel$export(module.exports, "azimuthalInvert", function () { return $a7b162d52f6c1bca$export$3cee429f13e44eac; });

var $kNUN7 = parcelRequire("kNUN7");
function $a7b162d52f6c1bca$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $kNUN7.cos)(x), cy = (0, $kNUN7.cos)(y), k = scale(cx * cy);
        return [
            k * cy * (0, $kNUN7.sin)(x),
            k * (0, $kNUN7.sin)(y)
        ];
    };
}
function $a7b162d52f6c1bca$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $kNUN7.sqrt)(x * x + y * y), c = angle(z), sc = (0, $kNUN7.sin)(c), cc = (0, $kNUN7.cos)(c);
        return [
            (0, $kNUN7.atan2)(x * sc, z * cc),
            (0, $kNUN7.asin)(z && y * sc / z)
        ];
    };
}

});


parcelRegister("1Vrzy", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $eoCMd = parcelRequire("eoCMd");

var $lsk55 = parcelRequire("lsk55");
var $167080a6c21f0a54$export$b94a4d6aa3dd25c = (0, $eoCMd.azimuthalRaw)(function(c) {
    return (c = (0, $kNUN7.acos)(c)) && c / (0, $kNUN7.sin)(c);
});
$167080a6c21f0a54$export$b94a4d6aa3dd25c.invert = (0, $eoCMd.azimuthalInvert)(function(z) {
    return z;
});
function $167080a6c21f0a54$export$2e2bcd8739ae039() {
    return (0, $lsk55.default)($167080a6c21f0a54$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}

});

parcelRegister("8ZZJ4", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $lrO5L = parcelRequire("lrO5L");

var $6ckYb = parcelRequire("6ckYb");
function $68d3e6b7326440e6$var$tany(y) {
    return (0, $kNUN7.tan)(((0, $kNUN7.halfPi) + y) / 2);
}
function $68d3e6b7326440e6$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $kNUN7.cos)(y0), n = y0 === y1 ? (0, $kNUN7.sin)(y0) : (0, $kNUN7.log)(cy0 / (0, $kNUN7.cos)(y1)) / (0, $kNUN7.log)($68d3e6b7326440e6$var$tany(y1) / $68d3e6b7326440e6$var$tany(y0)), f = cy0 * (0, $kNUN7.pow)($68d3e6b7326440e6$var$tany(y0), n) / n;
    if (!n) return 0, $6ckYb.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $kNUN7.halfPi) + (0, $kNUN7.epsilon)) y = -(0, $kNUN7.halfPi) + (0, $kNUN7.epsilon);
        } else if (y > (0, $kNUN7.halfPi) - (0, $kNUN7.epsilon)) y = (0, $kNUN7.halfPi) - (0, $kNUN7.epsilon);
        var r = f / (0, $kNUN7.pow)($68d3e6b7326440e6$var$tany(y), n);
        return [
            r * (0, $kNUN7.sin)(n * x),
            f - r * (0, $kNUN7.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $kNUN7.sign)(n) * (0, $kNUN7.sqrt)(x * x + fy * fy);
        return [
            (0, $kNUN7.atan2)(x, (0, $kNUN7.abs)(fy)) / n * (0, $kNUN7.sign)(fy),
            2 * (0, $kNUN7.atan)((0, $kNUN7.pow)(f / r, 1 / n)) - (0, $kNUN7.halfPi)
        ];
    };
    return project;
}
function $68d3e6b7326440e6$export$2e2bcd8739ae039() {
    return (0, $lrO5L.conicProjection)($68d3e6b7326440e6$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}

});
parcelRegister("6ckYb", function(module, exports) {

$parcel$export(module.exports, "mercatorRaw", function () { return $483421377f1a6961$export$94ff8a57e9b91cc3; });
$parcel$export(module.exports, "mercatorProjection", function () { return $483421377f1a6961$export$44b9b66a01f2127b; });

var $kNUN7 = parcelRequire("kNUN7");

var $hRYfY = parcelRequire("hRYfY");

var $lsk55 = parcelRequire("lsk55");
function $483421377f1a6961$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $kNUN7.log)((0, $kNUN7.tan)(((0, $kNUN7.halfPi) + phi) / 2))
    ];
}
$483421377f1a6961$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $kNUN7.atan)((0, $kNUN7.exp)(y)) - (0, $kNUN7.halfPi)
    ];
};
function $483421377f1a6961$export$2e2bcd8739ae039() {
    return $483421377f1a6961$export$44b9b66a01f2127b($483421377f1a6961$export$94ff8a57e9b91cc3).scale(961 / (0, $kNUN7.tau));
}
function $483421377f1a6961$export$44b9b66a01f2127b(project) {
    var m = (0, $lsk55.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $kNUN7.pi) * scale(), t = m((0, $hRYfY.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $483421377f1a6961$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

});


parcelRegister("cMbuW", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $lrO5L = parcelRequire("lrO5L");

var $bmox2 = parcelRequire("bmox2");
function $94d2e2fab8c2fd69$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $kNUN7.cos)(y0), n = y0 === y1 ? (0, $kNUN7.sin)(y0) : (cy0 - (0, $kNUN7.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $kNUN7.abs)(n) < (0, $kNUN7.epsilon)) return 0, $bmox2.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $kNUN7.sin)(nx),
            g - gy * (0, $kNUN7.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y;
        return [
            (0, $kNUN7.atan2)(x, (0, $kNUN7.abs)(gy)) / n * (0, $kNUN7.sign)(gy),
            g - (0, $kNUN7.sign)(n) * (0, $kNUN7.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}
function $94d2e2fab8c2fd69$export$2e2bcd8739ae039() {
    return (0, $lrO5L.conicProjection)($94d2e2fab8c2fd69$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}

});
parcelRegister("bmox2", function(module, exports) {

$parcel$export(module.exports, "equirectangularRaw", function () { return $8454c7538000e064$export$f5fee52180f2f058; });

var $lsk55 = parcelRequire("lsk55");
function $8454c7538000e064$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$8454c7538000e064$export$f5fee52180f2f058.invert = $8454c7538000e064$export$f5fee52180f2f058;
function $8454c7538000e064$export$2e2bcd8739ae039() {
    return (0, $lsk55.default)($8454c7538000e064$export$f5fee52180f2f058).scale(152.63);
}

});


parcelRegister("10MQ7", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $eoCMd = parcelRequire("eoCMd");

var $lsk55 = parcelRequire("lsk55");
function $0bcbad1561355a0f$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $kNUN7.cos)(y), k = (0, $kNUN7.cos)(x) * cy;
    return [
        cy * (0, $kNUN7.sin)(x) / k,
        (0, $kNUN7.sin)(y) / k
    ];
}
$0bcbad1561355a0f$export$dc8c6ddfc8b22c85.invert = (0, $eoCMd.azimuthalInvert)((0, $kNUN7.atan));
function $0bcbad1561355a0f$export$2e2bcd8739ae039() {
    return (0, $lsk55.default)($0bcbad1561355a0f$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}

});

parcelRegister("8wmcz", function(module, exports) {

var $83woy = parcelRequire("83woy");

var $1XGJc = parcelRequire("1XGJc");

var $eNZUM = parcelRequire("eNZUM");

var $aDqKD = parcelRequire("aDqKD");
function $634288b127505a72$var$scaleTranslate(kx, ky, tx, ty) {
    return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? (0, $1XGJc.default) : (0, $eNZUM.transformer)({
        point: function(x, y) {
            this.stream.point(x * kx + tx, y * ky + ty);
        }
    });
}
function $634288b127505a72$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = (0, $1XGJc.default), x0 = null, y0, x1, y1, clip = (0, $1XGJc.default), cache, cacheStream, projection;
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return projection = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
        },
        clipExtent: function(_) {
            return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, $1XGJc.default) : (0, $83woy.clipExtent)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        },
        scale: function(_) {
            return arguments.length ? (transform = $634288b127505a72$var$scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
        },
        translate: function(_) {
            return arguments.length ? (transform = $634288b127505a72$var$scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [
                tx,
                ty
            ];
        },
        reflectX: function(_) {
            return arguments.length ? (transform = $634288b127505a72$var$scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
        },
        reflectY: function(_) {
            return arguments.length ? (transform = $634288b127505a72$var$scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
        },
        fitExtent: function(extent, object) {
            return (0, $aDqKD.fitExtent)(projection, extent, object);
        },
        fitSize: function(size, object) {
            return (0, $aDqKD.fitSize)(projection, size, object);
        }
    };
}

});

parcelRegister("epVV2", function(module, exports) {

var $lsk55 = parcelRequire("lsk55");

var $kNUN7 = parcelRequire("kNUN7");
function $a7f053fdf3ac2060$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$a7f053fdf3ac2060$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $kNUN7.abs)(delta) > (0, $kNUN7.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $a7f053fdf3ac2060$export$2e2bcd8739ae039() {
    return (0, $lsk55.default)($a7f053fdf3ac2060$export$acb6def22fe878e6).scale(175.295);
}

});

parcelRegister("iHocG", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $eoCMd = parcelRequire("eoCMd");

var $lsk55 = parcelRequire("lsk55");
function $d9cf047cb72a3aa3$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $kNUN7.cos)(y) * (0, $kNUN7.sin)(x),
        (0, $kNUN7.sin)(y)
    ];
}
$d9cf047cb72a3aa3$export$1cd9c2eb846182a.invert = (0, $eoCMd.azimuthalInvert)((0, $kNUN7.asin));
function $d9cf047cb72a3aa3$export$2e2bcd8739ae039() {
    return (0, $lsk55.default)($d9cf047cb72a3aa3$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $kNUN7.epsilon));
}

});

parcelRegister("jiCae", function(module, exports) {

var $kNUN7 = parcelRequire("kNUN7");

var $eoCMd = parcelRequire("eoCMd");

var $lsk55 = parcelRequire("lsk55");
function $e0cd4d52928d1d61$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $kNUN7.cos)(y), k = 1 + (0, $kNUN7.cos)(x) * cy;
    return [
        cy * (0, $kNUN7.sin)(x) / k,
        (0, $kNUN7.sin)(y) / k
    ];
}
$e0cd4d52928d1d61$export$f9ccbb0dcb3dcd2b.invert = (0, $eoCMd.azimuthalInvert)(function(z) {
    return 2 * (0, $kNUN7.atan)(z);
});
function $e0cd4d52928d1d61$export$2e2bcd8739ae039() {
    return (0, $lsk55.default)($e0cd4d52928d1d61$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}

});

parcelRegister("c1N6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c1bac4d8b1af34a$export$2e2bcd8739ae039; });

var $kNUN7 = parcelRequire("kNUN7");

var $6ckYb = parcelRequire("6ckYb");
function $8c1bac4d8b1af34a$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $kNUN7.log)((0, $kNUN7.tan)(((0, $kNUN7.halfPi) + phi) / 2)),
        -lambda
    ];
}
$8c1bac4d8b1af34a$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $kNUN7.atan)((0, $kNUN7.exp)(x)) - (0, $kNUN7.halfPi)
    ];
};
function $8c1bac4d8b1af34a$export$2e2bcd8739ae039() {
    var m = (0, $6ckYb.mercatorProjection)($8c1bac4d8b1af34a$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}

});



parcelRegister("gZv4c", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $084b6a00fd8fcf8a$export$2e2bcd8739ae039; });

var $ahY8G = parcelRequire("ahY8G");

var $2kUns = parcelRequire("2kUns");

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");

var $7aiSl = parcelRequire("7aiSl");
/**
 * Finds the difference between two {@link Polygon|polygons} by clipping the second polygon from the first.
 *
 * @name difference
 * @param {Feature<Polygon|MultiPolygon>} polygon1 input Polygon feature
 * @param {Feature<Polygon|MultiPolygon>} polygon2 Polygon feature to difference from polygon1
 * @returns {Feature<Polygon|MultiPolygon>|null} a Polygon or MultiPolygon feature showing the area of `polygon1` excluding the area of `polygon2` (if empty returns `null`)
 * @example
 * var polygon1 = turf.polygon([[
 *   [128, -26],
 *   [141, -26],
 *   [141, -21],
 *   [128, -21],
 *   [128, -26]
 * ]], {
 *   "fill": "#F00",
 *   "fill-opacity": 0.1
 * });
 * var polygon2 = turf.polygon([[
 *   [126, -28],
 *   [140, -28],
 *   [140, -20],
 *   [126, -20],
 *   [126, -28]
 * ]], {
 *   "fill": "#00F",
 *   "fill-opacity": 0.1
 * });
 *
 * var difference = turf.difference(polygon1, polygon2);
 *
 * //addToMap
 * var addToMap = [polygon1, polygon2, difference];
 */ function $084b6a00fd8fcf8a$var$difference(polygon1, polygon2) {
    var geom1 = (0, $8abqV.getGeom)(polygon1);
    var geom2 = (0, $8abqV.getGeom)(polygon2);
    var properties = polygon1.properties || {};
    // Issue #721 - JSTS/Martinez can't handle empty polygons
    geom1 = $084b6a00fd8fcf8a$var$removeEmptyPolygon(geom1);
    geom2 = $084b6a00fd8fcf8a$var$removeEmptyPolygon(geom2);
    if (!geom1) return null;
    if (!geom2) return (0, $7GKQS.feature)(geom1, properties);
    var differenced = $ahY8G.diff(geom1.coordinates, geom2.coordinates);
    if (differenced.length === 0) return null;
    if (differenced.length === 1) return (0, $7GKQS.polygon)(differenced[0], properties);
    return (0, $7GKQS.multiPolygon)(differenced, properties);
}
/**
 * Detect Empty Polygon
 *
 * @private
 * @param {Geometry<Polygon|MultiPolygon>} geom Geometry Object
 * @returns {Geometry<Polygon|MultiPolygon>|null} removed any polygons with no areas
 */ function $084b6a00fd8fcf8a$var$removeEmptyPolygon(geom) {
    switch(geom.type){
        case "Polygon":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($2kUns)))(geom) > 1) return geom;
            return null;
        case "MultiPolygon":
            var coordinates = [];
            (0, $7aiSl.flattenEach)(geom, function(feature) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($2kUns)))(feature) > 1) coordinates.push(feature.geometry.coordinates);
            });
            if (coordinates.length) return {
                type: "MultiPolygon",
                coordinates: coordinates
            };
    }
}
var $084b6a00fd8fcf8a$export$2e2bcd8739ae039 = $084b6a00fd8fcf8a$var$difference;

});
parcelRegister("ahY8G", function(module, exports) {
/**
 * martinez v0.4.3
 * Martinez polygon clipping algorithm, does boolean operation on polygons (multipolygons, polygons with holes etc): intersection, union, difference, xor
 *
 * @author Alex Milevski <info@w8r.name>
 * @license MIT
 * @preserve
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    function DEFAULT_COMPARE(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    var SplayTree = function SplayTree(compare, noDuplicates) {
        if (compare === void 0) compare = DEFAULT_COMPARE;
        if (noDuplicates === void 0) noDuplicates = false;
        this._compare = compare;
        this._root = null;
        this._size = 0;
        this._noDuplicates = !!noDuplicates;
    };
    var prototypeAccessors = {
        size: {
            configurable: true
        }
    };
    SplayTree.prototype.rotateLeft = function rotateLeft(x) {
        var y = x.right;
        if (y) {
            x.right = y.left;
            if (y.left) y.left.parent = x;
            y.parent = x.parent;
        }
        if (!x.parent) this._root = y;
        else if (x === x.parent.left) x.parent.left = y;
        else x.parent.right = y;
        if (y) y.left = x;
        x.parent = y;
    };
    SplayTree.prototype.rotateRight = function rotateRight(x) {
        var y = x.left;
        if (y) {
            x.left = y.right;
            if (y.right) y.right.parent = x;
            y.parent = x.parent;
        }
        if (!x.parent) this._root = y;
        else if (x === x.parent.left) x.parent.left = y;
        else x.parent.right = y;
        if (y) y.right = x;
        x.parent = y;
    };
    SplayTree.prototype._splay = function _splay(x) {
        var this$1 = this;
        while(x.parent){
            var p = x.parent;
            if (!p.parent) {
                if (p.left === x) this$1.rotateRight(p);
                else this$1.rotateLeft(p);
            } else if (p.left === x && p.parent.left === p) {
                this$1.rotateRight(p.parent);
                this$1.rotateRight(p);
            } else if (p.right === x && p.parent.right === p) {
                this$1.rotateLeft(p.parent);
                this$1.rotateLeft(p);
            } else if (p.left === x && p.parent.right === p) {
                this$1.rotateRight(p);
                this$1.rotateLeft(p);
            } else {
                this$1.rotateLeft(p);
                this$1.rotateRight(p);
            }
        }
    };
    SplayTree.prototype.splay = function splay(x) {
        var this$1 = this;
        var p, gp, ggp, l, r;
        while(x.parent){
            p = x.parent;
            gp = p.parent;
            if (gp && gp.parent) {
                ggp = gp.parent;
                if (ggp.left === gp) ggp.left = x;
                else ggp.right = x;
                x.parent = ggp;
            } else {
                x.parent = null;
                this$1._root = x;
            }
            l = x.left;
            r = x.right;
            if (x === p.left) {
                if (gp) {
                    if (gp.left === p) {
                        /* zig-zig */ if (p.right) {
                            gp.left = p.right;
                            gp.left.parent = gp;
                        } else gp.left = null;
                        p.right = gp;
                        gp.parent = p;
                    } else {
                        /* zig-zag */ if (l) {
                            gp.right = l;
                            l.parent = gp;
                        } else gp.right = null;
                        x.left = gp;
                        gp.parent = x;
                    }
                }
                if (r) {
                    p.left = r;
                    r.parent = p;
                } else p.left = null;
                x.right = p;
                p.parent = x;
            } else {
                if (gp) {
                    if (gp.right === p) {
                        /* zig-zig */ if (p.left) {
                            gp.right = p.left;
                            gp.right.parent = gp;
                        } else gp.right = null;
                        p.left = gp;
                        gp.parent = p;
                    } else {
                        /* zig-zag */ if (r) {
                            gp.left = r;
                            r.parent = gp;
                        } else gp.left = null;
                        x.right = gp;
                        gp.parent = x;
                    }
                }
                if (l) {
                    p.right = l;
                    l.parent = p;
                } else p.right = null;
                x.left = p;
                p.parent = x;
            }
        }
    };
    SplayTree.prototype.replace = function replace(u, v) {
        if (!u.parent) this._root = v;
        else if (u === u.parent.left) u.parent.left = v;
        else u.parent.right = v;
        if (v) v.parent = u.parent;
    };
    SplayTree.prototype.minNode = function minNode(u) {
        if (u === void 0) u = this._root;
        if (u) while(u.left)u = u.left;
        return u;
    };
    SplayTree.prototype.maxNode = function maxNode(u) {
        if (u === void 0) u = this._root;
        if (u) while(u.right)u = u.right;
        return u;
    };
    SplayTree.prototype.insert = function insert(key, data) {
        var z = this._root;
        var p = null;
        var comp = this._compare;
        var cmp;
        if (this._noDuplicates) while(z){
            p = z;
            cmp = comp(z.key, key);
            if (cmp === 0) return;
            else if (comp(z.key, key) < 0) z = z.right;
            else z = z.left;
        }
        else while(z){
            p = z;
            if (comp(z.key, key) < 0) z = z.right;
            else z = z.left;
        }
        z = {
            key: key,
            data: data,
            left: null,
            right: null,
            parent: p
        };
        if (!p) this._root = z;
        else if (comp(p.key, z.key) < 0) p.right = z;
        else p.left = z;
        this.splay(z);
        this._size++;
        return z;
    };
    SplayTree.prototype.find = function find(key) {
        var z = this._root;
        var comp = this._compare;
        while(z){
            var cmp = comp(z.key, key);
            if (cmp < 0) z = z.right;
            else if (cmp > 0) z = z.left;
            else return z;
        }
        return null;
    };
    /**
   * Whether the tree contains a node with the given key
   * @param{Key} key
   * @return {boolean} true/false
   */ SplayTree.prototype.contains = function contains(key) {
        var node = this._root;
        var comparator = this._compare;
        while(node){
            var cmp = comparator(key, node.key);
            if (cmp === 0) return true;
            else if (cmp < 0) node = node.left;
            else node = node.right;
        }
        return false;
    };
    SplayTree.prototype.remove = function remove(key) {
        var z = this.find(key);
        if (!z) return false;
        this.splay(z);
        if (!z.left) this.replace(z, z.right);
        else if (!z.right) this.replace(z, z.left);
        else {
            var y = this.minNode(z.right);
            if (y.parent !== z) {
                this.replace(y, y.right);
                y.right = z.right;
                y.right.parent = y;
            }
            this.replace(z, y);
            y.left = z.left;
            y.left.parent = y;
        }
        this._size--;
        return true;
    };
    SplayTree.prototype.removeNode = function removeNode(z) {
        if (!z) return false;
        this.splay(z);
        if (!z.left) this.replace(z, z.right);
        else if (!z.right) this.replace(z, z.left);
        else {
            var y = this.minNode(z.right);
            if (y.parent !== z) {
                this.replace(y, y.right);
                y.right = z.right;
                y.right.parent = y;
            }
            this.replace(z, y);
            y.left = z.left;
            y.left.parent = y;
        }
        this._size--;
        return true;
    };
    SplayTree.prototype.erase = function erase(key) {
        var z = this.find(key);
        if (!z) return;
        this.splay(z);
        var s = z.left;
        var t = z.right;
        var sMax = null;
        if (s) {
            s.parent = null;
            sMax = this.maxNode(s);
            this.splay(sMax);
            this._root = sMax;
        }
        if (t) {
            if (s) sMax.right = t;
            else this._root = t;
            t.parent = sMax;
        }
        this._size--;
    };
    /**
   * Removes and returns the node with smallest key
   * @return {?Node}
   */ SplayTree.prototype.pop = function pop() {
        var node = this._root, returnValue = null;
        if (node) {
            while(node.left)node = node.left;
            returnValue = {
                key: node.key,
                data: node.data
            };
            this.remove(node.key);
        }
        return returnValue;
    };
    /* eslint-disable class-methods-use-this */ /**
   * Successor node
   * @param{Node} node
   * @return {?Node}
   */ SplayTree.prototype.next = function next(node) {
        var successor = node;
        if (successor) {
            if (successor.right) {
                successor = successor.right;
                while(successor && successor.left)successor = successor.left;
            } else {
                successor = node.parent;
                while(successor && successor.right === node){
                    node = successor;
                    successor = successor.parent;
                }
            }
        }
        return successor;
    };
    /**
   * Predecessor node
   * @param{Node} node
   * @return {?Node}
   */ SplayTree.prototype.prev = function prev(node) {
        var predecessor = node;
        if (predecessor) {
            if (predecessor.left) {
                predecessor = predecessor.left;
                while(predecessor && predecessor.right)predecessor = predecessor.right;
            } else {
                predecessor = node.parent;
                while(predecessor && predecessor.left === node){
                    node = predecessor;
                    predecessor = predecessor.parent;
                }
            }
        }
        return predecessor;
    };
    /* eslint-enable class-methods-use-this */ /**
   * @param{forEachCallback} callback
   * @return {SplayTree}
   */ SplayTree.prototype.forEach = function forEach(callback) {
        var current = this._root;
        var s = [], done = false, i = 0;
        while(!done){
            // Reach the left most Node of the current Node
            if (current) {
                // Place pointer to a tree node on the stack
                // before traversing the node's left subtree
                s.push(current);
                current = current.left;
            } else // BackTrack from the empty subtree and visit the Node
            // at the top of the stack; however, if the stack is
            // empty you are done
            if (s.length > 0) {
                current = s.pop();
                callback(current, i++);
                // We have visited the node and its left
                // subtree. Now, it's right subtree's turn
                current = current.right;
            } else done = true;
        }
        return this;
    };
    /**
   * Walk key range from `low` to `high`. Stops if `fn` returns a value.
   * @param{Key}    low
   * @param{Key}    high
   * @param{Function} fn
   * @param{*?}     ctx
   * @return {SplayTree}
   */ SplayTree.prototype.range = function range(low, high, fn, ctx) {
        var this$1 = this;
        var Q = [];
        var compare = this._compare;
        var node = this._root, cmp;
        while(Q.length !== 0 || node)if (node) {
            Q.push(node);
            node = node.left;
        } else {
            node = Q.pop();
            cmp = compare(node.key, high);
            if (cmp > 0) break;
            else if (compare(node.key, low) >= 0) {
                if (fn.call(ctx, node)) return this$1;
                 // stop if smth is returned
            }
            node = node.right;
        }
        return this;
    };
    /**
   * Returns all keys in order
   * @return {Array<Key>}
   */ SplayTree.prototype.keys = function keys() {
        var current = this._root;
        var s = [], r = [], done = false;
        while(!done){
            if (current) {
                s.push(current);
                current = current.left;
            } else if (s.length > 0) {
                current = s.pop();
                r.push(current.key);
                current = current.right;
            } else done = true;
        }
        return r;
    };
    /**
   * Returns `data` fields of all nodes in order.
   * @return {Array<Value>}
   */ SplayTree.prototype.values = function values() {
        var current = this._root;
        var s = [], r = [], done = false;
        while(!done){
            if (current) {
                s.push(current);
                current = current.left;
            } else if (s.length > 0) {
                current = s.pop();
                r.push(current.data);
                current = current.right;
            } else done = true;
        }
        return r;
    };
    /**
   * Returns node at given index
   * @param{number} index
   * @return {?Node}
   */ SplayTree.prototype.at = function at(index) {
        // removed after a consideration, more misleading than useful
        // index = index % this.size;
        // if (index < 0) index = this.size - index;
        var current = this._root;
        var s = [], done = false, i = 0;
        while(!done){
            if (current) {
                s.push(current);
                current = current.left;
            } else if (s.length > 0) {
                current = s.pop();
                if (i === index) return current;
                i++;
                current = current.right;
            } else done = true;
        }
        return null;
    };
    /**
   * Bulk-load items. Both array have to be same size
   * @param{Array<Key>}  keys
   * @param{Array<Value>}[values]
   * @param{Boolean}     [presort=false] Pre-sort keys and values, using
   *                                       tree's comparator. Sorting is done
   *                                       in-place
   * @return {AVLTree}
   */ SplayTree.prototype.load = function load(keys, values, presort) {
        if (keys === void 0) keys = [];
        if (values === void 0) values = [];
        if (presort === void 0) presort = false;
        if (this._size !== 0) throw new Error("bulk-load: tree is not empty");
        var size = keys.length;
        if (presort) sort(keys, values, 0, size - 1, this._compare);
        this._root = loadRecursive(null, keys, values, 0, size);
        this._size = size;
        return this;
    };
    SplayTree.prototype.min = function min() {
        var node = this.minNode(this._root);
        if (node) return node.key;
        else return null;
    };
    SplayTree.prototype.max = function max() {
        var node = this.maxNode(this._root);
        if (node) return node.key;
        else return null;
    };
    SplayTree.prototype.isEmpty = function isEmpty() {
        return this._root === null;
    };
    prototypeAccessors.size.get = function() {
        return this._size;
    };
    /**
   * Create a tree and load it with items
   * @param{Array<Key>}        keys
   * @param{Array<Value>?}      [values]

   * @param{Function?}          [comparator]
   * @param{Boolean?}           [presort=false] Pre-sort keys and values, using
   *                                             tree's comparator. Sorting is done
   *                                             in-place
   * @param{Boolean?}           [noDuplicates=false] Allow duplicates
   * @return {SplayTree}
   */ SplayTree.createTree = function createTree(keys, values, comparator, presort, noDuplicates) {
        return new SplayTree(comparator, noDuplicates).load(keys, values, presort);
    };
    Object.defineProperties(SplayTree.prototype, prototypeAccessors);
    function loadRecursive(parent, keys, values, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var key = keys[middle];
            var data = values[middle];
            var node = {
                key: key,
                data: data,
                parent: parent
            };
            node.left = loadRecursive(node, keys, values, start, middle);
            node.right = loadRecursive(node, keys, values, middle + 1, end);
            return node;
        }
        return null;
    }
    function sort(keys, values, left, right, compare) {
        if (left >= right) return;
        var pivot = keys[left + right >> 1];
        var i = left - 1;
        var j = right + 1;
        while(true){
            do i++;
            while (compare(keys[i], pivot) < 0);
            do j--;
            while (compare(keys[j], pivot) > 0);
            if (i >= j) break;
            var tmp = keys[i];
            keys[i] = keys[j];
            keys[j] = tmp;
            tmp = values[i];
            values[i] = values[j];
            values[j] = tmp;
        }
        sort(keys, values, left, j, compare);
        sort(keys, values, j + 1, right, compare);
    }
    var NORMAL = 0;
    var NON_CONTRIBUTING = 1;
    var SAME_TRANSITION = 2;
    var DIFFERENT_TRANSITION = 3;
    var INTERSECTION = 0;
    var UNION = 1;
    var DIFFERENCE = 2;
    var XOR = 3;
    /**
   * @param  {SweepEvent} event
   * @param  {SweepEvent} prev
   * @param  {Operation} operation
   */ function computeFields(event, prev, operation) {
        // compute inOut and otherInOut fields
        if (prev === null) {
            event.inOut = false;
            event.otherInOut = true;
        // previous line segment in sweepline belongs to the same polygon
        } else {
            if (event.isSubject === prev.isSubject) {
                event.inOut = !prev.inOut;
                event.otherInOut = prev.otherInOut;
            // previous line segment in sweepline belongs to the clipping polygon
            } else {
                event.inOut = !prev.otherInOut;
                event.otherInOut = prev.isVertical() ? !prev.inOut : prev.inOut;
            }
            // compute prevInResult field
            if (prev) event.prevInResult = !inResult(prev, operation) || prev.isVertical() ? prev.prevInResult : prev;
        }
        // check if the line segment belongs to the Boolean operation
        event.inResult = inResult(event, operation);
    }
    /* eslint-disable indent */ function inResult(event, operation) {
        switch(event.type){
            case NORMAL:
                switch(operation){
                    case INTERSECTION:
                        return !event.otherInOut;
                    case UNION:
                        return event.otherInOut;
                    case DIFFERENCE:
                        // return (event.isSubject && !event.otherInOut) ||
                        //         (!event.isSubject && event.otherInOut);
                        return event.isSubject && event.otherInOut || !event.isSubject && !event.otherInOut;
                    case XOR:
                        return true;
                }
                break;
            case SAME_TRANSITION:
                return operation === INTERSECTION || operation === UNION;
            case DIFFERENT_TRANSITION:
                return operation === DIFFERENCE;
            case NON_CONTRIBUTING:
                return false;
        }
        return false;
    }
    /* eslint-enable indent */ var SweepEvent = function SweepEvent(point, left, otherEvent, isSubject, edgeType) {
        /**
     * Is left endpoint?
     * @type {Boolean}
     */ this.left = left;
        /**
     * @type {Array.<Number>}
     */ this.point = point;
        /**
     * Other edge reference
     * @type {SweepEvent}
     */ this.otherEvent = otherEvent;
        /**
     * Belongs to source or clipping polygon
     * @type {Boolean}
     */ this.isSubject = isSubject;
        /**
     * Edge contribution type
     * @type {Number}
     */ this.type = edgeType || NORMAL;
        /**
     * In-out transition for the sweepline crossing polygon
     * @type {Boolean}
     */ this.inOut = false;
        /**
     * @type {Boolean}
     */ this.otherInOut = false;
        /**
     * Previous event in result?
     * @type {SweepEvent}
     */ this.prevInResult = null;
        /**
     * Does event belong to result?
     * @type {Boolean}
     */ this.inResult = false;
        // connection step
        /**
     * @type {Boolean}
     */ this.resultInOut = false;
        this.isExteriorRing = true;
    };
    /**
   * @param{Array.<Number>}p
   * @return {Boolean}
   */ SweepEvent.prototype.isBelow = function isBelow(p) {
        var p0 = this.point, p1 = this.otherEvent.point;
        return this.left ? (p0[0] - p[0]) * (p1[1] - p[1]) - (p1[0] - p[0]) * (p0[1] - p[1]) > 0 : (p1[0] - p[0]) * (p0[1] - p[1]) - (p0[0] - p[0]) * (p1[1] - p[1]) > 0;
    //signedArea(this.otherEvent.point, this.point, p) > 0;
    };
    /**
   * @param{Array.<Number>}p
   * @return {Boolean}
   */ SweepEvent.prototype.isAbove = function isAbove(p) {
        return !this.isBelow(p);
    };
    /**
   * @return {Boolean}
   */ SweepEvent.prototype.isVertical = function isVertical() {
        return this.point[0] === this.otherEvent.point[0];
    };
    SweepEvent.prototype.clone = function clone() {
        var copy = new SweepEvent(this.point, this.left, this.otherEvent, this.isSubject, this.type);
        copy.inResult = this.inResult;
        copy.prevInResult = this.prevInResult;
        copy.isExteriorRing = this.isExteriorRing;
        copy.inOut = this.inOut;
        copy.otherInOut = this.otherInOut;
        return copy;
    };
    function equals(p1, p2) {
        if (p1[0] === p2[0]) {
            if (p1[1] === p2[1]) return true;
            else return false;
        }
        return false;
    }
    // const EPSILON = 1e-9;
    // const abs = Math.abs;
    // TODO https://github.com/w8r/martinez/issues/6#issuecomment-262847164
    // Precision problem.
    //
    // module.exports = function equals(p1, p2) {
    //   return abs(p1[0] - p2[0]) <= EPSILON && abs(p1[1] - p2[1]) <= EPSILON;
    // };
    /**
   * Signed area of the triangle (p0, p1, p2)
   * @param  {Array.<Number>} p0
   * @param  {Array.<Number>} p1
   * @param  {Array.<Number>} p2
   * @return {Number}
   */ function signedArea(p0, p1, p2) {
        return (p0[0] - p2[0]) * (p1[1] - p2[1]) - (p1[0] - p2[0]) * (p0[1] - p2[1]);
    }
    /**
   * @param  {SweepEvent} e1
   * @param  {SweepEvent} e2
   * @return {Number}
   */ function compareEvents(e1, e2) {
        var p1 = e1.point;
        var p2 = e2.point;
        // Different x-coordinate
        if (p1[0] > p2[0]) return 1;
        if (p1[0] < p2[0]) return -1;
        // Different points, but same x-coordinate
        // Event with lower y-coordinate is processed first
        if (p1[1] !== p2[1]) return p1[1] > p2[1] ? 1 : -1;
        return specialCases(e1, e2, p1, p2);
    }
    /* eslint-disable no-unused-vars */ function specialCases(e1, e2, p1, p2) {
        // Same coordinates, but one is a left endpoint and the other is
        // a right endpoint. The right endpoint is processed first
        if (e1.left !== e2.left) return e1.left ? 1 : -1;
        // const p2 = e1.otherEvent.point, p3 = e2.otherEvent.point;
        // const sa = (p1[0] - p3[0]) * (p2[1] - p3[1]) - (p2[0] - p3[0]) * (p1[1] - p3[1])
        // Same coordinates, both events
        // are left endpoints or right endpoints.
        // not collinear
        if (signedArea(p1, e1.otherEvent.point, e2.otherEvent.point) !== 0) // the event associate to the bottom segment is processed first
        return !e1.isBelow(e2.otherEvent.point) ? 1 : -1;
        return !e1.isSubject && e2.isSubject ? 1 : -1;
    }
    /* eslint-enable no-unused-vars */ /**
   * @param  {SweepEvent} se
   * @param  {Array.<Number>} p
   * @param  {Queue} queue
   * @return {Queue}
   */ function divideSegment(se, p, queue) {
        var r = new SweepEvent(p, false, se, se.isSubject);
        var l = new SweepEvent(p, true, se.otherEvent, se.isSubject);
        /* eslint-disable no-console */ if (equals(se.point, se.otherEvent.point)) console.warn("what is that, a collapsed segment?", se);
        /* eslint-enable no-console */ r.contourId = l.contourId = se.contourId;
        // avoid a rounding error. The left event would be processed after the right event
        if (compareEvents(l, se.otherEvent) > 0) {
            se.otherEvent.left = true;
            l.left = false;
        }
        // avoid a rounding error. The left event would be processed after the right event
        // if (compareEvents(se, r) > 0) {}
        se.otherEvent.otherEvent = l;
        se.otherEvent = r;
        queue.push(l);
        queue.push(r);
        return queue;
    }
    //const EPS = 1e-9;
    /**
   * Finds the magnitude of the cross product of two vectors (if we pretend
   * they're in three dimensions)
   *
   * @param {Object} a First vector
   * @param {Object} b Second vector
   * @private
   * @returns {Number} The magnitude of the cross product
   */ function crossProduct(a, b) {
        return a[0] * b[1] - a[1] * b[0];
    }
    /**
   * Finds the dot product of two vectors.
   *
   * @param {Object} a First vector
   * @param {Object} b Second vector
   * @private
   * @returns {Number} The dot product
   */ function dotProduct(a, b) {
        return a[0] * b[0] + a[1] * b[1];
    }
    /**
   * Finds the intersection (if any) between two line segments a and b, given the
   * line segments' end points a1, a2 and b1, b2.
   *
   * This algorithm is based on Schneider and Eberly.
   * http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf
   * Page 244.
   *
   * @param {Array.<Number>} a1 point of first line
   * @param {Array.<Number>} a2 point of first line
   * @param {Array.<Number>} b1 point of second line
   * @param {Array.<Number>} b2 point of second line
   * @param {Boolean=}       noEndpointTouch whether to skip single touchpoints
   *                                         (meaning connected segments) as
   *                                         intersections
   * @returns {Array.<Array.<Number>>|Null} If the lines intersect, the point of
   * intersection. If they overlap, the two end points of the overlapping segment.
   * Otherwise, null.
   */ function intersection(a1, a2, b1, b2, noEndpointTouch) {
        // The algorithm expects our lines in the form P + sd, where P is a point,
        // s is on the interval [0, 1], and d is a vector.
        // We are passed two points. P can be the first point of each pair. The
        // vector, then, could be thought of as the distance (in x and y components)
        // from the first point to the second point.
        // So first, let's make our vectors:
        var va = [
            a2[0] - a1[0],
            a2[1] - a1[1]
        ];
        var vb = [
            b2[0] - b1[0],
            b2[1] - b1[1]
        ];
        // We also define a function to convert back to regular point form:
        /* eslint-disable arrow-body-style */ function toPoint(p, s, d) {
            return [
                p[0] + s * d[0],
                p[1] + s * d[1]
            ];
        }
        /* eslint-enable arrow-body-style */ // The rest is pretty much a straight port of the algorithm.
        var e = [
            b1[0] - a1[0],
            b1[1] - a1[1]
        ];
        var kross = crossProduct(va, vb);
        var sqrKross = kross * kross;
        var sqrLenA = dotProduct(va, va);
        //const sqrLenB  = dotProduct(vb, vb);
        // Check for line intersection. This works because of the properties of the
        // cross product -- specifically, two vectors are parallel if and only if the
        // cross product is the 0 vector. The full calculation involves relative error
        // to account for possible very small line segments. See Schneider & Eberly
        // for details.
        if (sqrKross > 0 /* EPS * sqrLenB * sqLenA */ ) {
            // If they're not parallel, then (because these are line segments) they
            // still might not actually intersect. This code checks that the
            // intersection point of the lines is actually on both line segments.
            var s = crossProduct(e, vb) / kross;
            if (s < 0 || s > 1) // not on line segment a
            return null;
            var t = crossProduct(e, va) / kross;
            if (t < 0 || t > 1) // not on line segment b
            return null;
            if (s === 0 || s === 1) // on an endpoint of line segment a
            return noEndpointTouch ? null : [
                toPoint(a1, s, va)
            ];
            if (t === 0 || t === 1) // on an endpoint of line segment b
            return noEndpointTouch ? null : [
                toPoint(b1, t, vb)
            ];
            return [
                toPoint(a1, s, va)
            ];
        }
        // If we've reached this point, then the lines are either parallel or the
        // same, but the segments could overlap partially or fully, or not at all.
        // So we need to find the overlap, if any. To do that, we can use e, which is
        // the (vector) difference between the two initial points. If this is parallel
        // with the line itself, then the two lines are the same line, and there will
        // be overlap.
        //const sqrLenE = dotProduct(e, e);
        kross = crossProduct(e, va);
        sqrKross = kross * kross;
        if (sqrKross > 0 /* EPS * sqLenB * sqLenE */ ) // Lines are just parallel, not the same. No overlap.
        return null;
        var sa = dotProduct(va, e) / sqrLenA;
        var sb = sa + dotProduct(va, vb) / sqrLenA;
        var smin = Math.min(sa, sb);
        var smax = Math.max(sa, sb);
        // this is, essentially, the FindIntersection acting on floats from
        // Schneider & Eberly, just inlined into this function.
        if (smin <= 1 && smax >= 0) {
            // overlap on an end point
            if (smin === 1) return noEndpointTouch ? null : [
                toPoint(a1, smin > 0 ? smin : 0, va)
            ];
            if (smax === 0) return noEndpointTouch ? null : [
                toPoint(a1, smax < 1 ? smax : 1, va)
            ];
            if (noEndpointTouch && smin === 0 && smax === 1) return null;
            // There's overlap on a segment -- two points of intersection. Return both.
            return [
                toPoint(a1, smin > 0 ? smin : 0, va),
                toPoint(a1, smax < 1 ? smax : 1, va)
            ];
        }
        return null;
    }
    /**
   * @param  {SweepEvent} se1
   * @param  {SweepEvent} se2
   * @param  {Queue}      queue
   * @return {Number}
   */ function possibleIntersection(se1, se2, queue) {
        // that disallows self-intersecting polygons,
        // did cost us half a day, so I'll leave it
        // out of respect
        // if (se1.isSubject === se2.isSubject) return;
        var inter = intersection(se1.point, se1.otherEvent.point, se2.point, se2.otherEvent.point);
        var nintersections = inter ? inter.length : 0;
        if (nintersections === 0) return 0;
         // no intersection
        // the line segments intersect at an endpoint of both line segments
        if (nintersections === 1 && (equals(se1.point, se2.point) || equals(se1.otherEvent.point, se2.otherEvent.point))) return 0;
        if (nintersections === 2 && se1.isSubject === se2.isSubject) // if(se1.contourId === se2.contourId){
        // console.warn('Edges of the same polygon overlap',
        //   se1.point, se1.otherEvent.point, se2.point, se2.otherEvent.point);
        // }
        //throw new Error('Edges of the same polygon overlap');
        return 0;
        // The line segments associated to se1 and se2 intersect
        if (nintersections === 1) {
            // if the intersection point is not an endpoint of se1
            if (!equals(se1.point, inter[0]) && !equals(se1.otherEvent.point, inter[0])) divideSegment(se1, inter[0], queue);
            // if the intersection point is not an endpoint of se2
            if (!equals(se2.point, inter[0]) && !equals(se2.otherEvent.point, inter[0])) divideSegment(se2, inter[0], queue);
            return 1;
        }
        // The line segments associated to se1 and se2 overlap
        var events = [];
        var leftCoincide = false;
        var rightCoincide = false;
        if (equals(se1.point, se2.point)) leftCoincide = true; // linked
        else if (compareEvents(se1, se2) === 1) events.push(se2, se1);
        else events.push(se1, se2);
        if (equals(se1.otherEvent.point, se2.otherEvent.point)) rightCoincide = true;
        else if (compareEvents(se1.otherEvent, se2.otherEvent) === 1) events.push(se2.otherEvent, se1.otherEvent);
        else events.push(se1.otherEvent, se2.otherEvent);
        if (leftCoincide && rightCoincide || leftCoincide) {
            // both line segments are equal or share the left endpoint
            se2.type = NON_CONTRIBUTING;
            se1.type = se2.inOut === se1.inOut ? SAME_TRANSITION : DIFFERENT_TRANSITION;
            if (leftCoincide && !rightCoincide) // honestly no idea, but changing events selection from [2, 1]
            // to [0, 1] fixes the overlapping self-intersecting polygons issue
            divideSegment(events[1].otherEvent, events[0].point, queue);
            return 2;
        }
        // the line segments share the right endpoint
        if (rightCoincide) {
            divideSegment(events[0], events[1].point, queue);
            return 3;
        }
        // no line segment includes totally the other one
        if (events[0] !== events[3].otherEvent) {
            divideSegment(events[0], events[1].point, queue);
            divideSegment(events[1], events[2].point, queue);
            return 3;
        }
        // one line segment includes the other one
        divideSegment(events[0], events[1].point, queue);
        divideSegment(events[3].otherEvent, events[2].point, queue);
        return 3;
    }
    /**
   * @param  {SweepEvent} le1
   * @param  {SweepEvent} le2
   * @return {Number}
   */ function compareSegments(le1, le2) {
        if (le1 === le2) return 0;
        // Segments are not collinear
        if (signedArea(le1.point, le1.otherEvent.point, le2.point) !== 0 || signedArea(le1.point, le1.otherEvent.point, le2.otherEvent.point) !== 0) {
            // If they share their left endpoint use the right endpoint to sort
            if (equals(le1.point, le2.point)) return le1.isBelow(le2.otherEvent.point) ? -1 : 1;
            // Different left endpoint: use the left endpoint to sort
            if (le1.point[0] === le2.point[0]) return le1.point[1] < le2.point[1] ? -1 : 1;
            // has the line segment associated to e1 been inserted
            // into S after the line segment associated to e2 ?
            if (compareEvents(le1, le2) === 1) return le2.isAbove(le1.point) ? -1 : 1;
            // The line segment associated to e2 has been inserted
            // into S after the line segment associated to e1
            return le1.isBelow(le2.point) ? -1 : 1;
        }
        if (le1.isSubject === le2.isSubject) {
            var p1 = le1.point, p2 = le2.point;
            if (p1[0] === p2[0] && p1[1] === p2[1]) {
                p1 = le1.otherEvent.point;
                p2 = le2.otherEvent.point;
                if (p1[0] === p2[0] && p1[1] === p2[1]) return 0;
                else return le1.contourId > le2.contourId ? 1 : -1;
            }
        } else return le1.isSubject ? -1 : 1;
        return compareEvents(le1, le2) === 1 ? 1 : -1;
    }
    function subdivide(eventQueue, subject, clipping, sbbox, cbbox, operation) {
        var sweepLine = new SplayTree(compareSegments);
        var sortedEvents = [];
        var rightbound = Math.min(sbbox[2], cbbox[2]);
        var prev, next, begin;
        while(eventQueue.length !== 0){
            var event = eventQueue.pop();
            sortedEvents.push(event);
            // optimization by bboxes for intersection and difference goes here
            if (operation === INTERSECTION && event.point[0] > rightbound || operation === DIFFERENCE && event.point[0] > sbbox[2]) break;
            if (event.left) {
                next = prev = sweepLine.insert(event);
                begin = sweepLine.minNode();
                if (prev !== begin) prev = sweepLine.prev(prev);
                else prev = null;
                next = sweepLine.next(next);
                var prevEvent = prev ? prev.key : null;
                var prevprevEvent = void 0;
                computeFields(event, prevEvent, operation);
                if (next) {
                    if (possibleIntersection(event, next.key, eventQueue) === 2) {
                        computeFields(event, prevEvent, operation);
                        computeFields(event, next.key, operation);
                    }
                }
                if (prev) {
                    if (possibleIntersection(prev.key, event, eventQueue) === 2) {
                        var prevprev = prev;
                        if (prevprev !== begin) prevprev = sweepLine.prev(prevprev);
                        else prevprev = null;
                        prevprevEvent = prevprev ? prevprev.key : null;
                        computeFields(prevEvent, prevprevEvent, operation);
                        computeFields(event, prevEvent, operation);
                    }
                }
            } else {
                event = event.otherEvent;
                next = prev = sweepLine.find(event);
                if (prev && next) {
                    if (prev !== begin) prev = sweepLine.prev(prev);
                    else prev = null;
                    next = sweepLine.next(next);
                    sweepLine.remove(event);
                    if (next && prev) possibleIntersection(prev.key, next.key, eventQueue);
                }
            }
        }
        return sortedEvents;
    }
    /**
   * @param  {Array.<SweepEvent>} sortedEvents
   * @return {Array.<SweepEvent>}
   */ function orderEvents(sortedEvents) {
        var event, i, len, tmp;
        var resultEvents = [];
        for(i = 0, len = sortedEvents.length; i < len; i++){
            event = sortedEvents[i];
            if (event.left && event.inResult || !event.left && event.otherEvent.inResult) resultEvents.push(event);
        }
        // Due to overlapping edges the resultEvents array can be not wholly sorted
        var sorted = false;
        while(!sorted){
            sorted = true;
            for(i = 0, len = resultEvents.length; i < len; i++)if (i + 1 < len && compareEvents(resultEvents[i], resultEvents[i + 1]) === 1) {
                tmp = resultEvents[i];
                resultEvents[i] = resultEvents[i + 1];
                resultEvents[i + 1] = tmp;
                sorted = false;
            }
        }
        for(i = 0, len = resultEvents.length; i < len; i++){
            event = resultEvents[i];
            event.pos = i;
        }
        // imagine, the right event is found in the beginning of the queue,
        // when his left counterpart is not marked yet
        for(i = 0, len = resultEvents.length; i < len; i++){
            event = resultEvents[i];
            if (!event.left) {
                tmp = event.pos;
                event.pos = event.otherEvent.pos;
                event.otherEvent.pos = tmp;
            }
        }
        return resultEvents;
    }
    /**
   * @param  {Number} pos
   * @param  {Array.<SweepEvent>} resultEvents
   * @param  {Object>}    processed
   * @return {Number}
   */ function nextPos(pos, resultEvents, processed, origIndex) {
        var newPos = pos + 1;
        var length = resultEvents.length;
        if (newPos > length - 1) return pos - 1;
        var p = resultEvents[pos].point;
        var p1 = resultEvents[newPos].point;
        // while in range and not the current one by value
        while(newPos < length && p1[0] === p[0] && p1[1] === p[1]){
            if (!processed[newPos]) return newPos;
            else newPos++;
            p1 = resultEvents[newPos].point;
        }
        newPos = pos - 1;
        while(processed[newPos] && newPos >= origIndex)newPos--;
        return newPos;
    }
    /**
   * @param  {Array.<SweepEvent>} sortedEvents
   * @return {Array.<*>} polygons
   */ function connectEdges(sortedEvents, operation) {
        var i, len;
        var resultEvents = orderEvents(sortedEvents);
        // "false"-filled array
        var processed = {};
        var result = [];
        var event;
        for(i = 0, len = resultEvents.length; i < len; i++){
            if (processed[i]) continue;
            var contour = [
                []
            ];
            if (!resultEvents[i].isExteriorRing) {
                if (operation === DIFFERENCE && !resultEvents[i].isSubject && result.length === 0) result.push(contour);
                else if (result.length === 0) result.push([
                    [
                        contour
                    ]
                ]);
                else result[result.length - 1].push(contour[0]);
            } else if (operation === DIFFERENCE && !resultEvents[i].isSubject && result.length > 1) result[result.length - 1].push(contour[0]);
            else result.push(contour);
            var ringId = result.length - 1;
            var pos = i;
            var initial = resultEvents[i].point;
            contour[0].push(initial);
            while(pos >= i){
                event = resultEvents[pos];
                processed[pos] = true;
                if (event.left) {
                    event.resultInOut = false;
                    event.contourId = ringId;
                } else {
                    event.otherEvent.resultInOut = true;
                    event.otherEvent.contourId = ringId;
                }
                pos = event.pos;
                processed[pos] = true;
                contour[0].push(resultEvents[pos].point);
                pos = nextPos(pos, resultEvents, processed, i);
            }
            pos = pos === -1 ? i : pos;
            event = resultEvents[pos];
            processed[pos] = processed[event.pos] = true;
            event.otherEvent.resultInOut = true;
            event.otherEvent.contourId = ringId;
        }
        // Handle if the result is a polygon (eg not multipoly)
        // Commented it again, let's see what do we mean by that
        // if (result.length === 1) result = result[0];
        return result;
    }
    var tinyqueue = TinyQueue;
    var default_1 = TinyQueue;
    function TinyQueue(data, compare) {
        var this$1 = this;
        if (!(this instanceof TinyQueue)) return new TinyQueue(data, compare);
        this.data = data || [];
        this.length = this.data.length;
        this.compare = compare || defaultCompare;
        if (this.length > 0) for(var i = (this.length >> 1) - 1; i >= 0; i--)this$1._down(i);
    }
    function defaultCompare(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    TinyQueue.prototype = {
        push: function(item) {
            this.data.push(item);
            this.length++;
            this._up(this.length - 1);
        },
        pop: function() {
            if (this.length === 0) return undefined;
            var top = this.data[0];
            this.length--;
            if (this.length > 0) {
                this.data[0] = this.data[this.length];
                this._down(0);
            }
            this.data.pop();
            return top;
        },
        peek: function() {
            return this.data[0];
        },
        _up: function(pos) {
            var data = this.data;
            var compare = this.compare;
            var item = data[pos];
            while(pos > 0){
                var parent = pos - 1 >> 1;
                var current = data[parent];
                if (compare(item, current) >= 0) break;
                data[pos] = current;
                pos = parent;
            }
            data[pos] = item;
        },
        _down: function(pos) {
            var this$1 = this;
            var data = this.data;
            var compare = this.compare;
            var halfLength = this.length >> 1;
            var item = data[pos];
            while(pos < halfLength){
                var left = (pos << 1) + 1;
                var right = left + 1;
                var best = data[left];
                if (right < this$1.length && compare(data[right], best) < 0) {
                    left = right;
                    best = data[right];
                }
                if (compare(best, item) >= 0) break;
                data[pos] = best;
                pos = left;
            }
            data[pos] = item;
        }
    };
    tinyqueue.default = default_1;
    var max = Math.max;
    var min = Math.min;
    var contourId = 0;
    function processPolygon(contourOrHole, isSubject, depth, Q, bbox, isExteriorRing) {
        var i, len, s1, s2, e1, e2;
        for(i = 0, len = contourOrHole.length - 1; i < len; i++){
            s1 = contourOrHole[i];
            s2 = contourOrHole[i + 1];
            e1 = new SweepEvent(s1, false, undefined, isSubject);
            e2 = new SweepEvent(s2, false, e1, isSubject);
            e1.otherEvent = e2;
            if (s1[0] === s2[0] && s1[1] === s2[1]) continue; // skip collapsed edges, or it breaks
            e1.contourId = e2.contourId = depth;
            if (!isExteriorRing) {
                e1.isExteriorRing = false;
                e2.isExteriorRing = false;
            }
            if (compareEvents(e1, e2) > 0) e2.left = true;
            else e1.left = true;
            var x = s1[0], y = s1[1];
            bbox[0] = min(bbox[0], x);
            bbox[1] = min(bbox[1], y);
            bbox[2] = max(bbox[2], x);
            bbox[3] = max(bbox[3], y);
            // Pushing it so the queue is sorted from left to right,
            // with object on the left having the highest priority.
            Q.push(e1);
            Q.push(e2);
        }
    }
    function fillQueue(subject, clipping, sbbox, cbbox, operation) {
        var eventQueue = new tinyqueue(null, compareEvents);
        var polygonSet, isExteriorRing, i, ii, j, jj; //, k, kk;
        for(i = 0, ii = subject.length; i < ii; i++){
            polygonSet = subject[i];
            for(j = 0, jj = polygonSet.length; j < jj; j++){
                isExteriorRing = j === 0;
                if (isExteriorRing) contourId++;
                processPolygon(polygonSet[j], true, contourId, eventQueue, sbbox, isExteriorRing);
            }
        }
        for(i = 0, ii = clipping.length; i < ii; i++){
            polygonSet = clipping[i];
            for(j = 0, jj = polygonSet.length; j < jj; j++){
                isExteriorRing = j === 0;
                if (operation === DIFFERENCE) isExteriorRing = false;
                if (isExteriorRing) contourId++;
                processPolygon(polygonSet[j], false, contourId, eventQueue, cbbox, isExteriorRing);
            }
        }
        return eventQueue;
    }
    var EMPTY = [];
    function trivialOperation(subject, clipping, operation) {
        var result = null;
        if (subject.length * clipping.length === 0) {
            if (operation === INTERSECTION) result = EMPTY;
            else if (operation === DIFFERENCE) result = subject;
            else if (operation === UNION || operation === XOR) result = subject.length === 0 ? clipping : subject;
        }
        return result;
    }
    function compareBBoxes(subject, clipping, sbbox, cbbox, operation) {
        var result = null;
        if (sbbox[0] > cbbox[2] || cbbox[0] > sbbox[2] || sbbox[1] > cbbox[3] || cbbox[1] > sbbox[3]) {
            if (operation === INTERSECTION) result = EMPTY;
            else if (operation === DIFFERENCE) result = subject;
            else if (operation === UNION || operation === XOR) result = subject.concat(clipping);
        }
        return result;
    }
    function boolean(subject, clipping, operation) {
        if (typeof subject[0][0][0] === "number") subject = [
            subject
        ];
        if (typeof clipping[0][0][0] === "number") clipping = [
            clipping
        ];
        var trivial = trivialOperation(subject, clipping, operation);
        if (trivial) return trivial === EMPTY ? null : trivial;
        var sbbox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        var cbbox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        //console.time('fill queue');
        var eventQueue = fillQueue(subject, clipping, sbbox, cbbox, operation);
        //console.timeEnd('fill queue');
        trivial = compareBBoxes(subject, clipping, sbbox, cbbox, operation);
        if (trivial) return trivial === EMPTY ? null : trivial;
        //console.time('subdivide edges');
        var sortedEvents = subdivide(eventQueue, subject, clipping, sbbox, cbbox, operation);
        //console.timeEnd('subdivide edges');
        //console.time('connect vertices');
        var result = connectEdges(sortedEvents, operation);
        //console.timeEnd('connect vertices');
        return result;
    }
    function union(subject, clipping) {
        return boolean(subject, clipping, UNION);
    }
    function diff(subject, clipping) {
        return boolean(subject, clipping, DIFFERENCE);
    }
    function xor(subject, clipping) {
        return boolean(subject, clipping, XOR);
    }
    function intersection$1(subject, clipping) {
        return boolean(subject, clipping, INTERSECTION);
    }
    /**
   * @enum {Number}
   */ var operations = {
        UNION: UNION,
        DIFFERENCE: DIFFERENCE,
        INTERSECTION: INTERSECTION,
        XOR: XOR
    };
    exports1.union = union;
    exports1.diff = diff;
    exports1.xor = xor;
    exports1.intersection = intersection$1;
    exports1.operations = operations;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("2kUns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7aiSl = parcelRequire("7aiSl");
// Note: change RADIUS => earthRadius
var $1b392e605c187d92$var$RADIUS = 6378137;
/**
 * Takes one or more features and returns their area in square meters.
 *
 * @name area
 * @param {GeoJSON} geojson input GeoJSON feature(s)
 * @returns {number} area in square meters
 * @example
 * var polygon = turf.polygon([[[125, -15], [113, -22], [154, -27], [144, -15], [125, -15]]]);
 *
 * var area = turf.area(polygon);
 *
 * //addToMap
 * var addToMap = [polygon]
 * polygon.properties.area = area
 */ function $1b392e605c187d92$var$area(geojson) {
    return $7aiSl.geomReduce(geojson, function(value, geom) {
        return value + $1b392e605c187d92$var$calculateArea(geom);
    }, 0);
}
module.exports.default = $1b392e605c187d92$var$area;
/**
 * Calculate Area
 *
 * @private
 * @param {Geometry} geom GeoJSON Geometries
 * @returns {number} area
 */ function $1b392e605c187d92$var$calculateArea(geom) {
    var total = 0;
    var i;
    switch(geom.type){
        case "Polygon":
            return $1b392e605c187d92$var$polygonArea(geom.coordinates);
        case "MultiPolygon":
            for(i = 0; i < geom.coordinates.length; i++)total += $1b392e605c187d92$var$polygonArea(geom.coordinates[i]);
            return total;
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
            return 0;
    }
    return 0;
}
function $1b392e605c187d92$var$polygonArea(coords) {
    var total = 0;
    if (coords && coords.length > 0) {
        total += Math.abs($1b392e605c187d92$var$ringArea(coords[0]));
        for(var i = 1; i < coords.length; i++)total -= Math.abs($1b392e605c187d92$var$ringArea(coords[i]));
    }
    return total;
}
/**
 * @private
 * Calculate the approximate area of the polygon were it projected onto the earth.
 * Note that this area will be positive if ring is oriented clockwise, otherwise it will be negative.
 *
 * Reference:
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for Polygons on a Sphere",
 * JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007 http://trs-new.jpl.nasa.gov/dspace/handle/2014/40409
 *
 * @param {Array<Array<number>>} coords Ring Coordinates
 * @returns {number} The approximate signed geodesic area of the polygon in square meters.
 */ function $1b392e605c187d92$var$ringArea(coords) {
    var p1;
    var p2;
    var p3;
    var lowerIndex;
    var middleIndex;
    var upperIndex;
    var i;
    var total = 0;
    var coordsLength = coords.length;
    if (coordsLength > 2) {
        for(i = 0; i < coordsLength; i++){
            if (i === coordsLength - 2) {
                lowerIndex = coordsLength - 2;
                middleIndex = coordsLength - 1;
                upperIndex = 0;
            } else if (i === coordsLength - 1) {
                lowerIndex = coordsLength - 1;
                middleIndex = 0;
                upperIndex = 1;
            } else {
                lowerIndex = i;
                middleIndex = i + 1;
                upperIndex = i + 2;
            }
            p1 = coords[lowerIndex];
            p2 = coords[middleIndex];
            p3 = coords[upperIndex];
            total += ($1b392e605c187d92$var$rad(p3[0]) - $1b392e605c187d92$var$rad(p1[0])) * Math.sin($1b392e605c187d92$var$rad(p2[1]));
        }
        total = total * $1b392e605c187d92$var$RADIUS * $1b392e605c187d92$var$RADIUS / 2;
    }
    return total;
}
function $1b392e605c187d92$var$rad(num) {
    return num * Math.PI / 180;
}

});

parcelRegister("8abqV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $5f18204a67f20acc$var$getCoord(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
module.exports.getCoord = $5f18204a67f20acc$var$getCoord;
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $5f18204a67f20acc$var$getCoords(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
module.exports.getCoords = $5f18204a67f20acc$var$getCoords;
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $5f18204a67f20acc$var$containsNumber(coordinates) {
    if (coordinates.length > 1 && $7GKQS.isNumber(coordinates[0]) && $7GKQS.isNumber(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $5f18204a67f20acc$var$containsNumber(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
module.exports.containsNumber = $5f18204a67f20acc$var$containsNumber;
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $5f18204a67f20acc$var$geojsonType(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
module.exports.geojsonType = $5f18204a67f20acc$var$geojsonType;
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $5f18204a67f20acc$var$featureOf(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
module.exports.featureOf = $5f18204a67f20acc$var$featureOf;
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $5f18204a67f20acc$var$collectionOf(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
module.exports.collectionOf = $5f18204a67f20acc$var$collectionOf;
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $5f18204a67f20acc$var$getGeom(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
module.exports.getGeom = $5f18204a67f20acc$var$getGeom;
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $5f18204a67f20acc$var$getType(geojson, name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}
module.exports.getType = $5f18204a67f20acc$var$getType;

});


parcelRegister("b5wF2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8abqV = parcelRequire("8abqV");

var $7GKQS = parcelRequire("7GKQS");
//http://en.wikipedia.org/wiki/Haversine_formula
//http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Calculates the distance between two {@link Point|points} in degrees, radians, miles, or kilometers.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name distance
 * @param {Coord} from origin point
 * @param {Coord} to destination point
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.distance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */ function $81297f1aedde94fd$var$distance(from, to, options) {
    if (options === void 0) options = {};
    var coordinates1 = $8abqV.getCoord(from);
    var coordinates2 = $8abqV.getCoord(to);
    var dLat = $7GKQS.degreesToRadians(coordinates2[1] - coordinates1[1]);
    var dLon = $7GKQS.degreesToRadians(coordinates2[0] - coordinates1[0]);
    var lat1 = $7GKQS.degreesToRadians(coordinates1[1]);
    var lat2 = $7GKQS.degreesToRadians(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return $7GKQS.radiansToLength(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
module.exports.default = $81297f1aedde94fd$var$distance;

});


parcelRegister("c2GPt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $8c46e4e9ec718846$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8c46e4e9ec718846$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8c46e4e9ec718846$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8c46e4e9ec718846$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8c46e4e9ec718846$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8c46e4e9ec718846$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8c46e4e9ec718846$var$Feature = /*#__PURE__*/ function() {
    // geo json coordinates
    function Feature(geoJson, style) {
        var original = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var metadata = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        $8c46e4e9ec718846$var$_classCallCheck(this, Feature);
        $8c46e4e9ec718846$var$_defineProperty(this, "geoJson", void 0);
        $8c46e4e9ec718846$var$_defineProperty(this, "style", void 0);
        $8c46e4e9ec718846$var$_defineProperty(this, "original", void 0);
        $8c46e4e9ec718846$var$_defineProperty(this, "metadata", void 0);
        this.geoJson = geoJson;
        this.style = style;
        this.original = original;
        this.metadata = metadata;
    }
    $8c46e4e9ec718846$var$_createClass(Feature, [
        {
            key: "getCoords",
            value: function getCoords() {
                // @ts-ignore
                return this.geoJson.geometry.coordinates;
            }
        }
    ]);
    return Feature;
}();
module.exports["default"] = $8c46e4e9ec718846$var$Feature;

});

parcelRegister("iXJhp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $dce0dc4eb1f5625e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dce0dc4eb1f5625e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dce0dc4eb1f5625e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dce0dc4eb1f5625e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dce0dc4eb1f5625e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dce0dc4eb1f5625e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $dce0dc4eb1f5625e$var$LayerMouseEvent = /*#__PURE__*/ function() {
    // original item that this event is related to
    // internal nebula info about the object
    // the mouse [lng,lat] raycasted onto the ground
    // browser event
    // reference to nebula
    function LayerMouseEvent(nativeEvent, _ref) {
        var data = _ref.data, groundPoint = _ref.groundPoint, nebula = _ref.nebula, metadata = _ref.metadata;
        $dce0dc4eb1f5625e$var$_classCallCheck(this, LayerMouseEvent);
        $dce0dc4eb1f5625e$var$_defineProperty(this, "canceled", void 0);
        $dce0dc4eb1f5625e$var$_defineProperty(this, "data", void 0);
        $dce0dc4eb1f5625e$var$_defineProperty(this, "metadata", void 0);
        $dce0dc4eb1f5625e$var$_defineProperty(this, "groundPoint", void 0);
        $dce0dc4eb1f5625e$var$_defineProperty(this, "nativeEvent", void 0);
        $dce0dc4eb1f5625e$var$_defineProperty(this, "nebula", void 0);
        this.nativeEvent = nativeEvent;
        this.data = data;
        this.groundPoint = groundPoint;
        this.nebula = nebula;
        this.metadata = metadata;
    }
    $dce0dc4eb1f5625e$var$_createClass(LayerMouseEvent, [
        {
            key: "stopPropagation",
            value: function stopPropagation() {
                this.nativeEvent.stopPropagation();
                this.canceled = true;
            }
        }
    ]);
    return LayerMouseEvent;
}();
module.exports["default"] = $dce0dc4eb1f5625e$var$LayerMouseEvent;

});

parcelRegister("7uZXb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $575b646c50bb7391$var$_events = $575b646c50bb7391$var$_interopRequireDefault((parcelRequire("8nJ5N")));

var $eiPsc = parcelRequire("eiPsc");
function $575b646c50bb7391$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $575b646c50bb7391$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $575b646c50bb7391$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $575b646c50bb7391$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $575b646c50bb7391$var$_typeof(obj);
}
function $575b646c50bb7391$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $575b646c50bb7391$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $575b646c50bb7391$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $575b646c50bb7391$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $575b646c50bb7391$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $575b646c50bb7391$var$_createSuper(Derived) {
    return function() {
        var Super = $575b646c50bb7391$var$_getPrototypeOf(Derived), result;
        if ($575b646c50bb7391$var$_isNativeReflectConstruct()) {
            var NewTarget = $575b646c50bb7391$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $575b646c50bb7391$var$_possibleConstructorReturn(this, result);
    };
}
function $575b646c50bb7391$var$_possibleConstructorReturn(self, call) {
    if (call && ($575b646c50bb7391$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $575b646c50bb7391$var$_assertThisInitialized(self);
}
function $575b646c50bb7391$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $575b646c50bb7391$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $575b646c50bb7391$var$_getPrototypeOf(o) {
    $575b646c50bb7391$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $575b646c50bb7391$var$_getPrototypeOf(o);
}
function $575b646c50bb7391$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $575b646c50bb7391$var$_setPrototypeOf(subClass, superClass);
}
function $575b646c50bb7391$var$_setPrototypeOf(o, p) {
    $575b646c50bb7391$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $575b646c50bb7391$var$_setPrototypeOf(o, p);
}
function $575b646c50bb7391$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $575b646c50bb7391$var$NebulaLayer = /*#__PURE__*/ function(_Event$EventEmitter) {
    $575b646c50bb7391$var$_inherits(NebulaLayer, _Event$EventEmitter);
    var _super = $575b646c50bb7391$var$_createSuper(NebulaLayer);
    // flags
    //
    function NebulaLayer(_ref) {
        var _this;
        var getData = _ref.getData, on = _ref.on, toNebulaFeature = _ref.toNebulaFeature;
        $575b646c50bb7391$var$_classCallCheck(this, NebulaLayer);
        _this = _super.call(this);
        $575b646c50bb7391$var$_defineProperty($575b646c50bb7391$var$_assertThisInitialized(_this), "getData", void 0);
        $575b646c50bb7391$var$_defineProperty($575b646c50bb7391$var$_assertThisInitialized(_this), "toNebulaFeature", void 0);
        $575b646c50bb7391$var$_defineProperty($575b646c50bb7391$var$_assertThisInitialized(_this), "id", void 0);
        $575b646c50bb7391$var$_defineProperty($575b646c50bb7391$var$_assertThisInitialized(_this), "helperLayers", void 0);
        $575b646c50bb7391$var$_defineProperty($575b646c50bb7391$var$_assertThisInitialized(_this), "usesMapEvents", false);
        $575b646c50bb7391$var$_defineProperty($575b646c50bb7391$var$_assertThisInitialized(_this), "enablePicking", false);
        $575b646c50bb7391$var$_defineProperty($575b646c50bb7391$var$_assertThisInitialized(_this), "enableSelection", false);
        _this.id = (0, $eiPsc.default)();
        _this.getData = getData;
        _this.toNebulaFeature = toNebulaFeature;
        _this.helperLayers = [];
        if (on) // @ts-ignore
        Object.keys(on).forEach(function(key) {
            return _this.on(key, on[key]);
        });
        return _this;
    }
    $575b646c50bb7391$var$_createClass(NebulaLayer, [
        {
            key: "render",
            value: function render(config) {
                return null;
            }
        }
    ]);
    return NebulaLayer;
}($575b646c50bb7391$var$_events["default"].EventEmitter);
module.exports["default"] = $575b646c50bb7391$var$NebulaLayer;

});
parcelRegister("8nJ5N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $61a3731f6cdd44eb$var$R = typeof Reflect === "object" ? Reflect : null;
var $61a3731f6cdd44eb$var$ReflectApply = $61a3731f6cdd44eb$var$R && typeof $61a3731f6cdd44eb$var$R.apply === "function" ? $61a3731f6cdd44eb$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $61a3731f6cdd44eb$var$ReflectOwnKeys;
if ($61a3731f6cdd44eb$var$R && typeof $61a3731f6cdd44eb$var$R.ownKeys === "function") $61a3731f6cdd44eb$var$ReflectOwnKeys = $61a3731f6cdd44eb$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $61a3731f6cdd44eb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $61a3731f6cdd44eb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $61a3731f6cdd44eb$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $61a3731f6cdd44eb$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $61a3731f6cdd44eb$var$EventEmitter() {
    $61a3731f6cdd44eb$var$EventEmitter.init.call(this);
}
module.exports = $61a3731f6cdd44eb$var$EventEmitter;
module.exports.once = $61a3731f6cdd44eb$var$once;
// Backwards-compat with node 0.10.x
$61a3731f6cdd44eb$var$EventEmitter.EventEmitter = $61a3731f6cdd44eb$var$EventEmitter;
$61a3731f6cdd44eb$var$EventEmitter.prototype._events = undefined;
$61a3731f6cdd44eb$var$EventEmitter.prototype._eventsCount = 0;
$61a3731f6cdd44eb$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $61a3731f6cdd44eb$var$defaultMaxListeners = 10;
function $61a3731f6cdd44eb$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($61a3731f6cdd44eb$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $61a3731f6cdd44eb$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $61a3731f6cdd44eb$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $61a3731f6cdd44eb$var$defaultMaxListeners = arg;
    }
});
$61a3731f6cdd44eb$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$61a3731f6cdd44eb$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $61a3731f6cdd44eb$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $61a3731f6cdd44eb$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $61a3731f6cdd44eb$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$61a3731f6cdd44eb$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $61a3731f6cdd44eb$var$_getMaxListeners(this);
};
$61a3731f6cdd44eb$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $61a3731f6cdd44eb$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $61a3731f6cdd44eb$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$61a3731f6cdd44eb$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $61a3731f6cdd44eb$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $61a3731f6cdd44eb$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $61a3731f6cdd44eb$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $61a3731f6cdd44eb$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$61a3731f6cdd44eb$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $61a3731f6cdd44eb$var$_addListener(this, type, listener, false);
};
$61a3731f6cdd44eb$var$EventEmitter.prototype.on = $61a3731f6cdd44eb$var$EventEmitter.prototype.addListener;
$61a3731f6cdd44eb$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $61a3731f6cdd44eb$var$_addListener(this, type, listener, true);
};
function $61a3731f6cdd44eb$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $61a3731f6cdd44eb$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $61a3731f6cdd44eb$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$61a3731f6cdd44eb$var$EventEmitter.prototype.once = function once(type, listener) {
    $61a3731f6cdd44eb$var$checkListener(listener);
    this.on(type, $61a3731f6cdd44eb$var$_onceWrap(this, type, listener));
    return this;
};
$61a3731f6cdd44eb$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $61a3731f6cdd44eb$var$checkListener(listener);
    this.prependListener(type, $61a3731f6cdd44eb$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$61a3731f6cdd44eb$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $61a3731f6cdd44eb$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $61a3731f6cdd44eb$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$61a3731f6cdd44eb$var$EventEmitter.prototype.off = $61a3731f6cdd44eb$var$EventEmitter.prototype.removeListener;
$61a3731f6cdd44eb$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $61a3731f6cdd44eb$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $61a3731f6cdd44eb$var$unwrapListeners(evlistener) : $61a3731f6cdd44eb$var$arrayClone(evlistener, evlistener.length);
}
$61a3731f6cdd44eb$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $61a3731f6cdd44eb$var$_listeners(this, type, true);
};
$61a3731f6cdd44eb$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $61a3731f6cdd44eb$var$_listeners(this, type, false);
};
$61a3731f6cdd44eb$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $61a3731f6cdd44eb$var$listenerCount.call(emitter, type);
};
$61a3731f6cdd44eb$var$EventEmitter.prototype.listenerCount = $61a3731f6cdd44eb$var$listenerCount;
function $61a3731f6cdd44eb$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$61a3731f6cdd44eb$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $61a3731f6cdd44eb$var$ReflectOwnKeys(this._events) : [];
};
function $61a3731f6cdd44eb$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $61a3731f6cdd44eb$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $61a3731f6cdd44eb$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $61a3731f6cdd44eb$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $61a3731f6cdd44eb$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $61a3731f6cdd44eb$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $61a3731f6cdd44eb$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $61a3731f6cdd44eb$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $61a3731f6cdd44eb$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("eiPsc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a69aa8cab7633cac$export$2e2bcd8739ae039; });

var $8xMbH = parcelRequire("8xMbH");

var $4NkLK = parcelRequire("4NkLK");
function $a69aa8cab7633cac$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $8xMbH.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $4NkLK.default)(rnds);
}
var $a69aa8cab7633cac$export$2e2bcd8739ae039 = $a69aa8cab7633cac$var$v4;

});
parcelRegister("8xMbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6386c8e1b9cbe6bc$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $6386c8e1b9cbe6bc$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var $6386c8e1b9cbe6bc$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $6386c8e1b9cbe6bc$export$2e2bcd8739ae039() {
    if (!$6386c8e1b9cbe6bc$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $6386c8e1b9cbe6bc$var$getRandomValues($6386c8e1b9cbe6bc$var$rnds8);
}

});

parcelRegister("4NkLK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37dbd9598c955d8d$export$2e2bcd8739ae039; });
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $37dbd9598c955d8d$var$byteToHex = [];
for(var $37dbd9598c955d8d$var$i = 0; $37dbd9598c955d8d$var$i < 256; ++$37dbd9598c955d8d$var$i)$37dbd9598c955d8d$var$byteToHex[$37dbd9598c955d8d$var$i] = ($37dbd9598c955d8d$var$i + 0x100).toString(16).substr(1);
function $37dbd9598c955d8d$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $37dbd9598c955d8d$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
var $37dbd9598c955d8d$export$2e2bcd8739ae039 = $37dbd9598c955d8d$var$bytesToUuid;

});



parcelRegister("faO1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4agoo = parcelRequire("4agoo");

var $b0be975ce9f04685$var$_nebulaLayer = $b0be975ce9f04685$var$_interopRequireDefault((parcelRequire("7uZXb")));

var $h5pu5 = parcelRequire("h5pu5");

var $b0be975ce9f04685$var$_deckCache = $b0be975ce9f04685$var$_interopRequireDefault((parcelRequire("pgVSk")));
function $b0be975ce9f04685$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b0be975ce9f04685$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b0be975ce9f04685$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b0be975ce9f04685$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b0be975ce9f04685$var$_typeof(obj);
}
function $b0be975ce9f04685$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b0be975ce9f04685$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b0be975ce9f04685$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b0be975ce9f04685$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b0be975ce9f04685$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b0be975ce9f04685$var$_createSuper(Derived) {
    return function() {
        var Super = $b0be975ce9f04685$var$_getPrototypeOf(Derived), result;
        if ($b0be975ce9f04685$var$_isNativeReflectConstruct()) {
            var NewTarget = $b0be975ce9f04685$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b0be975ce9f04685$var$_possibleConstructorReturn(this, result);
    };
}
function $b0be975ce9f04685$var$_possibleConstructorReturn(self, call) {
    if (call && ($b0be975ce9f04685$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b0be975ce9f04685$var$_assertThisInitialized(self);
}
function $b0be975ce9f04685$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b0be975ce9f04685$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b0be975ce9f04685$var$_getPrototypeOf(o) {
    $b0be975ce9f04685$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b0be975ce9f04685$var$_getPrototypeOf(o);
}
function $b0be975ce9f04685$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b0be975ce9f04685$var$_setPrototypeOf(subClass, superClass);
}
function $b0be975ce9f04685$var$_setPrototypeOf(o, p) {
    $b0be975ce9f04685$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b0be975ce9f04685$var$_setPrototypeOf(o, p);
}
function $b0be975ce9f04685$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b0be975ce9f04685$var$JunctionsLayer = /*#__PURE__*/ function(_NebulaLayer) {
    $b0be975ce9f04685$var$_inherits(JunctionsLayer, _NebulaLayer);
    var _super = $b0be975ce9f04685$var$_createSuper(JunctionsLayer);
    function JunctionsLayer(config) {
        var _this;
        $b0be975ce9f04685$var$_classCallCheck(this, JunctionsLayer);
        _this = _super.call(this, config);
        $b0be975ce9f04685$var$_defineProperty($b0be975ce9f04685$var$_assertThisInitialized(_this), "deckCache", void 0);
        _this.deckCache = new $b0be975ce9f04685$var$_deckCache["default"](config.getData, function(data) {
            return config.toNebulaFeature(data);
        });
        _this.enablePicking = true;
        return _this;
    }
    $b0be975ce9f04685$var$_createClass(JunctionsLayer, [
        {
            key: "render",
            value: function render(_ref) {
                var nebula = _ref.nebula;
                var defaultColor = [
                    0x0,
                    0x0,
                    0x0,
                    0xff
                ];
                var _this$deckCache = this.deckCache, objects = _this$deckCache.objects, updateTrigger = _this$deckCache.updateTrigger;
                return new $4agoo.JunctionScatterplotLayer({
                    id: "junctions-".concat(this.id),
                    data: objects,
                    opacity: 1,
                    // @ts-ignore
                    fp64: false,
                    pickable: true,
                    getPosition: function getPosition(nf) {
                        return nf.geoJson.geometry.coordinates;
                    },
                    getFillColor: function getFillColor(nf) {
                        return (0, $h5pu5.toDeckColor)(nf.style.fillColor) || defaultColor;
                    },
                    getStrokeColor: function getStrokeColor(nf) {
                        return (0, $h5pu5.toDeckColor)(nf.style.outlineColor) || (0, $h5pu5.toDeckColor)(nf.style.fillColor) || defaultColor;
                    },
                    getRadius: function getRadius(nf) {
                        return nf.style.pointRadiusMeters + nf.style.outlineRadiusMeters || 1;
                    },
                    getInnerRadius: function getInnerRadius(nf) {
                        return nf.style.pointRadiusMeters || 0.5;
                    },
                    parameters: {
                        depthTest: false,
                        blend: false
                    },
                    updateTriggers: {
                        all: updateTrigger
                    },
                    nebulaLayer: this
                });
            }
        }
    ]);
    return JunctionsLayer;
}($b0be975ce9f04685$var$_nebulaLayer["default"]);
module.exports["default"] = $b0be975ce9f04685$var$JunctionsLayer;

});
parcelRegister("4agoo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ArrowStyles", {
    enumerable: true,
    get: function get() {
        return $5eHNu.ArrowStyles;
    }
});
Object.defineProperty(module.exports, "DEFAULT_ARROWS", {
    enumerable: true,
    get: function get() {
        return $5eHNu.DEFAULT_ARROWS;
    }
});
Object.defineProperty(module.exports, "MAX_ARROWS", {
    enumerable: true,
    get: function get() {
        return $5eHNu.MAX_ARROWS;
    }
});
Object.defineProperty(module.exports, "EditableGeoJsonLayer", {
    enumerable: true,
    get: function get() {
        return $3084cfcdfe53debb$var$_editableGeojsonLayer["default"];
    }
});
Object.defineProperty(module.exports, "EditableH3ClusterLayer", {
    enumerable: true,
    get: function get() {
        return $3084cfcdfe53debb$var$_editableH3ClusterLayer["default"];
    }
});
Object.defineProperty(module.exports, "SelectionLayer", {
    enumerable: true,
    get: function get() {
        return $3084cfcdfe53debb$var$_selectionLayer["default"];
    }
});
Object.defineProperty(module.exports, "ElevatedEditHandleLayer", {
    enumerable: true,
    get: function get() {
        return $3084cfcdfe53debb$var$_elevatedEditHandleLayer["default"];
    }
});
Object.defineProperty(module.exports, "PathOutlineLayer", {
    enumerable: true,
    get: function get() {
        return $3084cfcdfe53debb$var$_pathOutlineLayer["default"];
    }
});
Object.defineProperty(module.exports, "PathMarkerLayer", {
    enumerable: true,
    get: function get() {
        return $3084cfcdfe53debb$var$_pathMarkerLayer["default"];
    }
});
Object.defineProperty(module.exports, "JunctionScatterplotLayer", {
    enumerable: true,
    get: function get() {
        return $3084cfcdfe53debb$var$_junctionScatterplotLayer["default"];
    }
});
Object.defineProperty(module.exports, "toDeckColor", {
    enumerable: true,
    get: function get() {
        return $b3BRI.toDeckColor;
    }
});

var $5eHNu = parcelRequire("5eHNu");

var $3084cfcdfe53debb$var$_editableGeojsonLayer = $3084cfcdfe53debb$var$_interopRequireDefault((parcelRequire("lHhsg")));

var $3084cfcdfe53debb$var$_editableH3ClusterLayer = $3084cfcdfe53debb$var$_interopRequireDefault((parcelRequire("QQWRf")));

var $3084cfcdfe53debb$var$_selectionLayer = $3084cfcdfe53debb$var$_interopRequireDefault((parcelRequire("7Umyz")));

var $3084cfcdfe53debb$var$_elevatedEditHandleLayer = $3084cfcdfe53debb$var$_interopRequireDefault((parcelRequire("5p6F6")));

var $3084cfcdfe53debb$var$_pathOutlineLayer = $3084cfcdfe53debb$var$_interopRequireDefault((parcelRequire("hwgS8")));

var $3084cfcdfe53debb$var$_pathMarkerLayer = $3084cfcdfe53debb$var$_interopRequireDefault((parcelRequire("ctByJ")));

var $3084cfcdfe53debb$var$_junctionScatterplotLayer = $3084cfcdfe53debb$var$_interopRequireDefault((parcelRequire("gi8jT")));

var $b3BRI = parcelRequire("b3BRI");
function $3084cfcdfe53debb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("5eHNu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_ARROWS = module.exports.DEFAULT_ARROWS = module.exports.ArrowStyles = void 0;
// Describes the arrow style of polylines
var $3d003bc0222b5192$var$ArrowStyles = {
    NONE: 0,
    FORWARD: 1,
    BACKWARD: 2,
    BOTH: 3
};
module.exports.ArrowStyles = $3d003bc0222b5192$var$ArrowStyles;
var $3d003bc0222b5192$var$DEFAULT_ARROWS = 1;
module.exports.DEFAULT_ARROWS = $3d003bc0222b5192$var$DEFAULT_ARROWS;
var $3d003bc0222b5192$var$MAX_ARROWS = 3;
module.exports.MAX_ARROWS = $3d003bc0222b5192$var$MAX_ARROWS;

});

parcelRegister("lHhsg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ee5EG = parcelRequire("ee5EG");
var $h685K = parcelRequire("h685K");
var $cYQ5y = parcelRequire("cYQ5y");
var $9pc7R = parcelRequire("9pc7R");

var $cQSdn = parcelRequire("cQSdn");

var $9brng = parcelRequire("9brng");

var $fcbb27514d9ea607$var$_editableLayer = $fcbb27514d9ea607$var$_interopRequireDefault((parcelRequire("7epLg")));

var $fcbb27514d9ea607$var$_editablePathLayer = $fcbb27514d9ea607$var$_interopRequireDefault((parcelRequire("aQ3Iz")));
function $fcbb27514d9ea607$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $fcbb27514d9ea607$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fcbb27514d9ea607$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fcbb27514d9ea607$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fcbb27514d9ea607$var$_typeof(obj);
}
function $fcbb27514d9ea607$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fcbb27514d9ea607$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fcbb27514d9ea607$var$ownKeys(Object(source), true).forEach(function(key) {
            $fcbb27514d9ea607$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fcbb27514d9ea607$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fcbb27514d9ea607$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $fcbb27514d9ea607$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $fcbb27514d9ea607$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fcbb27514d9ea607$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fcbb27514d9ea607$var$_arrayLikeToArray(o, minLen);
}
function $fcbb27514d9ea607$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fcbb27514d9ea607$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fcbb27514d9ea607$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fcbb27514d9ea607$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fcbb27514d9ea607$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcbb27514d9ea607$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fcbb27514d9ea607$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $fcbb27514d9ea607$var$_get = Reflect.get;
    else $fcbb27514d9ea607$var$_get = function _get(target, property, receiver) {
        var base = $fcbb27514d9ea607$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $fcbb27514d9ea607$var$_get(target, property, receiver || target);
}
function $fcbb27514d9ea607$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $fcbb27514d9ea607$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $fcbb27514d9ea607$var$_createSuper(Derived) {
    return function() {
        var Super = $fcbb27514d9ea607$var$_getPrototypeOf(Derived), result;
        if ($fcbb27514d9ea607$var$_isNativeReflectConstruct()) {
            var NewTarget = $fcbb27514d9ea607$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fcbb27514d9ea607$var$_possibleConstructorReturn(this, result);
    };
}
function $fcbb27514d9ea607$var$_possibleConstructorReturn(self, call) {
    if (call && ($fcbb27514d9ea607$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fcbb27514d9ea607$var$_assertThisInitialized(self);
}
function $fcbb27514d9ea607$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fcbb27514d9ea607$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fcbb27514d9ea607$var$_getPrototypeOf(o) {
    $fcbb27514d9ea607$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fcbb27514d9ea607$var$_getPrototypeOf(o);
}
function $fcbb27514d9ea607$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fcbb27514d9ea607$var$_setPrototypeOf(subClass, superClass);
}
function $fcbb27514d9ea607$var$_setPrototypeOf(o, p) {
    $fcbb27514d9ea607$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fcbb27514d9ea607$var$_setPrototypeOf(o, p);
}
function $fcbb27514d9ea607$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $fcbb27514d9ea607$var$DEFAULT_LINE_COLOR = [
    0x0,
    0x0,
    0x0,
    0x99
];
var $fcbb27514d9ea607$var$DEFAULT_FILL_COLOR = [
    0x0,
    0x0,
    0x0,
    0x90
];
var $fcbb27514d9ea607$var$DEFAULT_SELECTED_LINE_COLOR = [
    0x0,
    0x0,
    0x0,
    0xff
];
var $fcbb27514d9ea607$var$DEFAULT_SELECTED_FILL_COLOR = [
    0x0,
    0x0,
    0x90,
    0x90
];
var $fcbb27514d9ea607$var$DEFAULT_TENTATIVE_LINE_COLOR = [
    0x90,
    0x90,
    0x90,
    0xff
];
var $fcbb27514d9ea607$var$DEFAULT_TENTATIVE_FILL_COLOR = [
    0x90,
    0x90,
    0x90,
    0x90
];
var $fcbb27514d9ea607$var$DEFAULT_EDITING_EXISTING_POINT_COLOR = [
    0xc0,
    0x0,
    0x0,
    0xff
];
var $fcbb27514d9ea607$var$DEFAULT_EDITING_INTERMEDIATE_POINT_COLOR = [
    0x0,
    0x0,
    0x0,
    0x80
];
var $fcbb27514d9ea607$var$DEFAULT_EDITING_SNAP_POINT_COLOR = [
    0x7c,
    0x00,
    0xc0,
    0xff
];
var $fcbb27514d9ea607$var$DEFAULT_EDITING_POINT_OUTLINE_COLOR = [
    0xff,
    0xff,
    0xff,
    0xff
];
var $fcbb27514d9ea607$var$DEFAULT_EDITING_EXISTING_POINT_RADIUS = 5;
var $fcbb27514d9ea607$var$DEFAULT_EDITING_INTERMEDIATE_POINT_RADIUS = 3;
var $fcbb27514d9ea607$var$DEFAULT_EDITING_SNAP_POINT_RADIUS = 7;
var $fcbb27514d9ea607$var$DEFAULT_TOOLTIP_FONT_SIZE = 32 * $9brng.PROJECTED_PIXEL_SIZE_MULTIPLIER;
var $fcbb27514d9ea607$var$DEFAULT_EDIT_MODE = $cQSdn.DrawPolygonMode;
function $fcbb27514d9ea607$var$guideAccessor(accessor) {
    if (!accessor || typeof accessor !== "function") return accessor;
    return function(guideMaybeWrapped) {
        return accessor($fcbb27514d9ea607$var$unwrapGuide(guideMaybeWrapped));
    };
} // The object handed to us from deck.gl is different depending on the version of deck.gl used, unwrap as necessary
function $fcbb27514d9ea607$var$unwrapGuide(guideMaybeWrapped) {
    if (guideMaybeWrapped.__source) return guideMaybeWrapped.__source.object;
    else if (guideMaybeWrapped.sourceFeature) return guideMaybeWrapped.sourceFeature.feature;
     // It is not wrapped, return as is
    return guideMaybeWrapped;
}
function $fcbb27514d9ea607$var$getEditHandleColor(handle) {
    switch(handle.properties.editHandleType){
        case "existing":
            return $fcbb27514d9ea607$var$DEFAULT_EDITING_EXISTING_POINT_COLOR;
        case "snap-source":
            return $fcbb27514d9ea607$var$DEFAULT_EDITING_SNAP_POINT_COLOR;
        case "intermediate":
        default:
            return $fcbb27514d9ea607$var$DEFAULT_EDITING_INTERMEDIATE_POINT_COLOR;
    }
}
function $fcbb27514d9ea607$var$getEditHandleOutlineColor(handle) {
    return $fcbb27514d9ea607$var$DEFAULT_EDITING_POINT_OUTLINE_COLOR;
}
function $fcbb27514d9ea607$var$getEditHandleRadius(handle) {
    switch(handle.properties.editHandleType){
        case "existing":
            return $fcbb27514d9ea607$var$DEFAULT_EDITING_EXISTING_POINT_RADIUS;
        case "snap":
            return $fcbb27514d9ea607$var$DEFAULT_EDITING_SNAP_POINT_RADIUS;
        case "intermediate":
        default:
            return $fcbb27514d9ea607$var$DEFAULT_EDITING_INTERMEDIATE_POINT_RADIUS;
    }
}
var $fcbb27514d9ea607$var$defaultProps = {
    mode: $fcbb27514d9ea607$var$DEFAULT_EDIT_MODE,
    // Edit and interaction events
    onEdit: function onEdit() {},
    pickable: true,
    pickingRadius: 10,
    pickingDepth: 5,
    fp64: false,
    filled: true,
    stroked: true,
    lineWidthScale: $9brng.PROJECTED_PIXEL_SIZE_MULTIPLIER,
    lineWidthMinPixels: 1,
    lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
    pickingLineWidthExtraPixels: 0,
    lineWidthUnits: "pixels",
    lineJointRounded: false,
    lineCapRounded: false,
    lineMiterLimit: 4,
    pointRadiusScale: 1,
    pointRadiusMinPixels: 2,
    pointRadiusMaxPixels: Number.MAX_SAFE_INTEGER,
    getLineColor: function getLineColor(feature, isSelected, mode) {
        return isSelected ? $fcbb27514d9ea607$var$DEFAULT_SELECTED_LINE_COLOR : $fcbb27514d9ea607$var$DEFAULT_LINE_COLOR;
    },
    getFillColor: function getFillColor(feature, isSelected, mode) {
        return isSelected ? $fcbb27514d9ea607$var$DEFAULT_SELECTED_FILL_COLOR : $fcbb27514d9ea607$var$DEFAULT_FILL_COLOR;
    },
    getRadius: function getRadius(f) {
        return f && f.properties && f.properties.radius || f && f.properties && f.properties.size || 1;
    },
    getLineWidth: function getLineWidth(f) {
        return f && f.properties && f.properties.lineWidth || 3;
    },
    // Tentative feature rendering
    getTentativeLineColor: function getTentativeLineColor(f) {
        return $fcbb27514d9ea607$var$DEFAULT_TENTATIVE_LINE_COLOR;
    },
    getTentativeFillColor: function getTentativeFillColor(f) {
        return $fcbb27514d9ea607$var$DEFAULT_TENTATIVE_FILL_COLOR;
    },
    getTentativeLineWidth: function getTentativeLineWidth(f) {
        return f && f.properties && f.properties.lineWidth || 3;
    },
    editHandleType: "point",
    // point handles
    editHandlePointRadiusScale: 1,
    editHandlePointOutline: true,
    editHandlePointStrokeWidth: 2,
    editHandlePointRadiusUnits: "pixels",
    editHandlePointRadiusMinPixels: 4,
    editHandlePointRadiusMaxPixels: 8,
    getEditHandlePointColor: $fcbb27514d9ea607$var$getEditHandleColor,
    getEditHandlePointOutlineColor: $fcbb27514d9ea607$var$getEditHandleOutlineColor,
    getEditHandlePointRadius: $fcbb27514d9ea607$var$getEditHandleRadius,
    // icon handles
    editHandleIconAtlas: null,
    editHandleIconMapping: null,
    editHandleIconSizeScale: 1,
    editHandleIconSizeUnits: "pixels",
    getEditHandleIcon: function getEditHandleIcon(handle) {
        return handle.properties.editHandleType;
    },
    getEditHandleIconSize: 10,
    getEditHandleIconColor: $fcbb27514d9ea607$var$getEditHandleColor,
    getEditHandleIconAngle: 0,
    // misc
    billboard: true
}; // Mapping of mode name to mode class (for legacy purposes)
var $fcbb27514d9ea607$var$modeNameMapping = {
    view: $cQSdn.ViewMode,
    // Alter modes
    modify: $cQSdn.ModifyMode,
    translate: new $cQSdn.SnappableMode(new $cQSdn.TranslateMode()),
    transform: new $cQSdn.SnappableMode(new $cQSdn.TransformMode()),
    scale: $cQSdn.ScaleMode,
    rotate: $cQSdn.RotateMode,
    duplicate: $cQSdn.DuplicateMode,
    split: $cQSdn.SplitPolygonMode,
    extrude: $cQSdn.ExtrudeMode,
    elevation: $cQSdn.ElevationMode,
    // Draw modes
    drawPoint: $cQSdn.DrawPointMode,
    drawLineString: $cQSdn.DrawLineStringMode,
    drawPolygon: $cQSdn.DrawPolygonMode,
    drawRectangle: $cQSdn.DrawRectangleMode,
    drawSquare: $cQSdn.DrawSquareMode,
    drawRectangleFromCenter: $cQSdn.DrawRectangleFromCenterMode,
    drawSquareFromCenter: $cQSdn.DrawSquareFromCenterMode,
    drawCircleFromCenter: $cQSdn.DrawCircleFromCenterMode,
    drawCircleByBoundingBox: $cQSdn.DrawCircleByDiameterMode,
    drawEllipseByBoundingBox: $cQSdn.DrawEllipseByBoundingBoxMode,
    drawRectangleUsing3Points: $cQSdn.DrawRectangleUsingThreePointsMode,
    drawEllipseUsing3Points: $cQSdn.DrawEllipseUsingThreePointsMode,
    draw90DegreePolygon: $cQSdn.Draw90DegreePolygonMode,
    drawPolygonByDragging: $cQSdn.DrawPolygonByDraggingMode
}; // type State = {
//   mode: GeoJsonEditMode,
//   tentativeFeature: ?Feature,
//   editHandles: any[],
//   selectedFeatures: Feature[]
// };
var $fcbb27514d9ea607$var$EditableGeoJsonLayer = /*#__PURE__*/ function(_EditableLayer) {
    $fcbb27514d9ea607$var$_inherits(EditableGeoJsonLayer, _EditableLayer);
    var _super = $fcbb27514d9ea607$var$_createSuper(EditableGeoJsonLayer);
    function EditableGeoJsonLayer() {
        $fcbb27514d9ea607$var$_classCallCheck(this, EditableGeoJsonLayer);
        return _super.apply(this, arguments);
    }
    $fcbb27514d9ea607$var$_createClass(EditableGeoJsonLayer, [
        {
            key: "renderLayers",
            // setState: ($Shape<State>) => void;
            value: function renderLayers() {
                var subLayerProps = this.getSubLayerProps({
                    id: "geojson",
                    // Proxy most GeoJsonLayer props as-is
                    data: this.props.data,
                    fp64: this.props.fp64,
                    filled: this.props.filled,
                    stroked: this.props.stroked,
                    lineWidthScale: this.props.lineWidthScale,
                    lineWidthMinPixels: this.props.lineWidthMinPixels,
                    lineWidthMaxPixels: this.props.lineWidthMaxPixels,
                    lineWidthUnits: this.props.lineWidthUnits,
                    lineJointRounded: this.props.lineJointRounded,
                    lineCapRounded: this.props.lineCapRounded,
                    lineMiterLimit: this.props.lineMiterLimit,
                    pointRadiusScale: this.props.pointRadiusScale,
                    pointRadiusMinPixels: this.props.pointRadiusMinPixels,
                    pointRadiusMaxPixels: this.props.pointRadiusMaxPixels,
                    getLineColor: this.selectionAwareAccessor(this.props.getLineColor),
                    getFillColor: this.selectionAwareAccessor(this.props.getFillColor),
                    getPointRadius: this.selectionAwareAccessor(this.props.getRadius),
                    getLineWidth: this.selectionAwareAccessor(this.props.getLineWidth),
                    _subLayerProps: {
                        linestrings: {
                            billboard: this.props.billboard,
                            updateTriggers: {
                                // required to update dashed array attribute
                                all: [
                                    this.props.selectedFeatureIndexes,
                                    this.props.mode
                                ]
                            }
                        },
                        "polygons-stroke": {
                            billboard: this.props.billboard,
                            pickingLineWidthExtraPixels: this.props.pickingLineWidthExtraPixels,
                            type: $fcbb27514d9ea607$var$_editablePathLayer["default"],
                            updateTriggers: {
                                // required to update dashed array attribute
                                all: [
                                    this.props.selectedFeatureIndexes,
                                    this.props.mode
                                ]
                            }
                        }
                    },
                    updateTriggers: {
                        getLineColor: [
                            this.props.selectedFeatureIndexes,
                            this.props.mode
                        ],
                        getFillColor: [
                            this.props.selectedFeatureIndexes,
                            this.props.mode
                        ],
                        getPointRadius: [
                            this.props.selectedFeatureIndexes,
                            this.props.mode
                        ],
                        getLineWidth: [
                            this.props.selectedFeatureIndexes,
                            this.props.mode
                        ]
                    }
                });
                var layers = [
                    new $ee5EG.default(subLayerProps)
                ];
                layers = layers.concat(this.createGuidesLayers(), this.createTooltipsLayers());
                return layers;
            }
        },
        {
            key: "initializeState",
            value: function initializeState() {
                $fcbb27514d9ea607$var$_get($fcbb27514d9ea607$var$_getPrototypeOf(EditableGeoJsonLayer.prototype), "initializeState", this).call(this);
                this.setState({
                    selectedFeatures: [],
                    editHandles: []
                });
            } // TODO: is this the best way to properly update state from an outside event handler?
        },
        {
            key: "shouldUpdateState",
            value: function shouldUpdateState(opts) {
                // console.log(
                //   'shouldUpdateState',
                //   opts.changeFlags.propsOrDataChanged,
                //   opts.changeFlags.stateChanged
                // );
                return $fcbb27514d9ea607$var$_get($fcbb27514d9ea607$var$_getPrototypeOf(EditableGeoJsonLayer.prototype), "shouldUpdateState", this).call(this, opts) || opts.changeFlags.stateChanged;
            }
        },
        {
            key: "updateState",
            value: function updateState(_ref) {
                var props = _ref.props, oldProps = _ref.oldProps, changeFlags = _ref.changeFlags, context = _ref.context;
                $fcbb27514d9ea607$var$_get($fcbb27514d9ea607$var$_getPrototypeOf(EditableGeoJsonLayer.prototype), "updateState", this).call(this, {
                    oldProps: oldProps,
                    props: props,
                    changeFlags: changeFlags,
                    context: context
                });
                if (changeFlags.propsOrDataChanged) {
                    var modePropChanged = Object.keys(oldProps).length === 0 || props.mode !== oldProps.mode;
                    if (modePropChanged) {
                        var _mode;
                        if (typeof props.mode === "function") {
                            // They passed a constructor/class, so new it up
                            var ModeConstructor = props.mode;
                            _mode = new ModeConstructor();
                        } else if (typeof props.mode === "string") {
                            // Lookup the mode based on its name (for backwards compatibility)
                            _mode = $fcbb27514d9ea607$var$modeNameMapping[props.mode]; // eslint-disable-next-line no-console
                            console.warn("Deprecated use of passing `mode` as a string. Pass the mode's class constructor instead.");
                        } else // Should be an instance of EditMode in this case
                        _mode = props.mode;
                        if (!_mode) {
                            console.warn("No mode configured for ".concat(String(props.mode))); // eslint-disable-line no-console,no-undef
                            // Use default mode
                            _mode = new $fcbb27514d9ea607$var$DEFAULT_EDIT_MODE();
                        }
                        if (_mode !== this.state.mode) this.setState({
                            mode: _mode,
                            cursor: null
                        });
                    }
                }
                var selectedFeatures = [];
                if (Array.isArray(props.selectedFeatureIndexes)) // TODO: needs improved testing, i.e. checking for duplicates, NaNs, out of range numbers, ...
                selectedFeatures = props.selectedFeatureIndexes.map(function(elem) {
                    return props.data.features[elem];
                });
                this.setState({
                    selectedFeatures: selectedFeatures
                });
            }
        },
        {
            key: "getModeProps",
            value: function getModeProps(props) {
                var _this = this;
                return {
                    modeConfig: props.modeConfig,
                    data: props.data,
                    selectedIndexes: props.selectedFeatureIndexes,
                    lastPointerMoveEvent: this.state.lastPointerMoveEvent,
                    cursor: this.state.cursor,
                    onEdit: function onEdit(editAction) {
                        // Force a re-render
                        // This supports double-click where we need to ensure that there's a re-render between the two clicks
                        // even though the data wasn't changed, just the internal tentative feature.
                        _this.setNeedsUpdate();
                        props.onEdit(editAction);
                    },
                    onUpdateCursor: function onUpdateCursor(cursor) {
                        _this.setState({
                            cursor: cursor
                        });
                    }
                };
            }
        },
        {
            key: "selectionAwareAccessor",
            value: function selectionAwareAccessor(accessor) {
                var _this2 = this;
                if (typeof accessor !== "function") return accessor;
                return function(feature) {
                    return accessor(feature, _this2.isFeatureSelected(feature), _this2.props.mode);
                };
            }
        },
        {
            key: "isFeatureSelected",
            value: function isFeatureSelected(feature) {
                if (!this.props.data || !this.props.selectedFeatureIndexes) return false;
                if (!this.props.selectedFeatureIndexes.length) return false;
                var featureIndex = this.props.data.features.indexOf(feature);
                return this.props.selectedFeatureIndexes.includes(featureIndex);
            }
        },
        {
            key: "getPickingInfo",
            value: function getPickingInfo(_ref2) {
                var info = _ref2.info, sourceLayer = _ref2.sourceLayer;
                if (sourceLayer.id.endsWith("guides")) // If user is picking an editing handle, add additional data to the info
                info.isGuide = true;
                return info;
            }
        },
        {
            key: "_updateAutoHighlight",
            value: function _updateAutoHighlight(info) {
                // Extra handling for guides
                if (info === null || info === void 0 ? void 0 : info.sourceLayer) {
                    if (info.isGuide) {
                        var _iterator = $fcbb27514d9ea607$var$_createForOfIteratorHelper(info.sourceLayer.getSubLayers()), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var layer = _step.value;
                                layer.updateAutoHighlight(info);
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                    } else info.sourceLayer.updateAutoHighlight(info);
                }
            }
        },
        {
            key: "createGuidesLayers",
            value: function createGuidesLayers() {
                var mode = this.getActiveMode();
                var guides = mode.getGuides(this.getModeProps(this.props));
                if (!guides || !guides.features.length) return [];
                var subLayerProps = {
                    linestrings: {
                        billboard: this.props.billboard,
                        autoHighlight: false
                    },
                    "polygons-fill": {
                        autoHighlight: false
                    },
                    "polygons-stroke": {
                        billboard: this.props.billboard
                    }
                };
                if (this.props.editHandleType === "icon") subLayerProps["points-icon"] = {
                    type: $h685K.default,
                    iconAtlas: this.props.editHandleIconAtlas,
                    iconMapping: this.props.editHandleIconMapping,
                    sizeUnits: this.props.editHandleIconSizeUnits,
                    sizeScale: this.props.editHandleIconSizeScale,
                    getIcon: $fcbb27514d9ea607$var$guideAccessor(this.props.getEditHandleIcon),
                    getSize: $fcbb27514d9ea607$var$guideAccessor(this.props.getEditHandleIconSize),
                    getColor: $fcbb27514d9ea607$var$guideAccessor(this.props.getEditHandleIconColor),
                    getAngle: $fcbb27514d9ea607$var$guideAccessor(this.props.getEditHandleIconAngle)
                };
                else subLayerProps["points-circle"] = {
                    type: $cYQ5y.default,
                    radiusScale: this.props.editHandlePointRadiusScale,
                    stroked: this.props.editHandlePointOutline,
                    getLineWidth: this.props.editHandlePointStrokeWidth,
                    radiusUnits: this.props.editHandlePointRadiusUnits,
                    radiusMinPixels: this.props.editHandlePointRadiusMinPixels,
                    radiusMaxPixels: this.props.editHandlePointRadiusMaxPixels,
                    getRadius: $fcbb27514d9ea607$var$guideAccessor(this.props.getEditHandlePointRadius),
                    getFillColor: $fcbb27514d9ea607$var$guideAccessor(this.props.getEditHandlePointColor),
                    getLineColor: $fcbb27514d9ea607$var$guideAccessor(this.props.getEditHandlePointOutlineColor)
                };
                var layer = new $ee5EG.default(this.getSubLayerProps({
                    id: "guides",
                    data: guides,
                    fp64: this.props.fp64,
                    _subLayerProps: subLayerProps,
                    lineWidthScale: this.props.lineWidthScale,
                    lineWidthMinPixels: this.props.lineWidthMinPixels,
                    lineWidthMaxPixels: this.props.lineWidthMaxPixels,
                    lineWidthUnits: this.props.lineWidthUnits,
                    lineJointRounded: this.props.lineJointRounded,
                    lineCapRounded: this.props.lineCapRounded,
                    lineMiterLimit: this.props.lineMiterLimit,
                    getLineColor: $fcbb27514d9ea607$var$guideAccessor(this.props.getTentativeLineColor),
                    getLineWidth: $fcbb27514d9ea607$var$guideAccessor(this.props.getTentativeLineWidth),
                    getFillColor: $fcbb27514d9ea607$var$guideAccessor(this.props.getTentativeFillColor),
                    pointType: this.props.editHandleType === "icon" ? "icon" : "circle",
                    iconAtlas: this.props.editHandleIconAtlas
                }));
                return [
                    layer
                ];
            }
        },
        {
            key: "createTooltipsLayers",
            value: function createTooltipsLayers() {
                var mode = this.getActiveMode();
                var tooltips = mode.getTooltips(this.getModeProps(this.props));
                var layer = new $9pc7R.default($fcbb27514d9ea607$var$_objectSpread({
                    getSize: $fcbb27514d9ea607$var$DEFAULT_TOOLTIP_FONT_SIZE
                }, this.getSubLayerProps({
                    id: "tooltips",
                    data: tooltips
                })));
                return [
                    layer
                ];
            }
        },
        {
            key: "onLayerClick",
            value: function onLayerClick(event) {
                this.getActiveMode().handleClick(event, this.getModeProps(this.props));
            }
        },
        {
            key: "onLayerKeyUp",
            value: function onLayerKeyUp(event) {
                this.getActiveMode().handleKeyUp(event, this.getModeProps(this.props));
            }
        },
        {
            key: "onStartDragging",
            value: function onStartDragging(event) {
                this.getActiveMode().handleStartDragging(event, this.getModeProps(this.props));
            }
        },
        {
            key: "onDragging",
            value: function onDragging(event) {
                this.getActiveMode().handleDragging(event, this.getModeProps(this.props));
            }
        },
        {
            key: "onStopDragging",
            value: function onStopDragging(event) {
                this.getActiveMode().handleStopDragging(event, this.getModeProps(this.props));
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                this.setState({
                    lastPointerMoveEvent: event
                });
                this.getActiveMode().handlePointerMove(event, this.getModeProps(this.props));
            }
        },
        {
            key: "getCursor",
            value: function getCursor(_ref3) {
                var isDragging = _ref3.isDragging;
                if (this.state === null || this.state === undefined) // Layer in 'Awaiting state'
                return null;
                var cursor = this.state.cursor;
                if (!cursor) // default cursor
                cursor = isDragging ? "grabbing" : "grab";
                return cursor;
            }
        },
        {
            key: "getActiveMode",
            value: function getActiveMode() {
                return this.state.mode;
            }
        }
    ]);
    return EditableGeoJsonLayer;
}($fcbb27514d9ea607$var$_editableLayer["default"]);
module.exports["default"] = $fcbb27514d9ea607$var$EditableGeoJsonLayer;
$fcbb27514d9ea607$var$_defineProperty($fcbb27514d9ea607$var$EditableGeoJsonLayer, "layerName", "EditableGeoJsonLayer");
$fcbb27514d9ea607$var$_defineProperty($fcbb27514d9ea607$var$EditableGeoJsonLayer, "defaultProps", $fcbb27514d9ea607$var$defaultProps);

});
parcelRegister("ee5EG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5b6c2842af299e1$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $lEQUF = parcelRequire("lEQUF");

var $coXLq = parcelRequire("coXLq");

var $cNqHj = parcelRequire("cNqHj");

var $cyxHD = parcelRequire("cyxHD");

var $fzdNr = parcelRequire("fzdNr");

var $hf80Y = parcelRequire("hf80Y");

var $8rldy = parcelRequire("8rldy");
const $a5b6c2842af299e1$var$FEATURE_TYPES = [
    "points",
    "linestrings",
    "polygons"
];
const $a5b6c2842af299e1$var$defaultProps = (0, $edHbI._)((0, $2QP2i._)({}, (0, $fzdNr.getDefaultProps)((0, $fzdNr.POINT_LAYER).circle), (0, $fzdNr.getDefaultProps)((0, $fzdNr.POINT_LAYER).icon), (0, $fzdNr.getDefaultProps)((0, $fzdNr.POINT_LAYER).text), (0, $fzdNr.getDefaultProps)((0, $fzdNr.LINE_LAYER)), (0, $fzdNr.getDefaultProps)((0, $fzdNr.POLYGON_LAYER))), {
    stroked: true,
    filled: true,
    extruded: false,
    wireframe: false,
    _full3d: false,
    iconAtlas: {
        type: "object",
        value: null
    },
    iconMapping: {
        type: "object",
        value: {}
    },
    getIcon: {
        type: "accessor",
        value: (f)=>f.properties.icon
    },
    getText: {
        type: "accessor",
        value: (f)=>f.properties.text
    },
    pointType: "circle",
    getRadius: {
        deprecatedFor: "getPointRadius"
    }
});
class $a5b6c2842af299e1$export$2e2bcd8739ae039 extends (0, $coXLq.default) {
    initializeState() {
        this.state = {
            layerProps: {},
            features: {}
        };
    }
    updateState({ props: props, changeFlags: changeFlags }) {
        if (!changeFlags.dataChanged) return;
        const { data: data } = this.props;
        const binary = data && "points" in data && "polygons" in data && "lines" in data;
        this.setState({
            binary: binary
        });
        if (binary) this._updateStateBinary({
            props: props,
            changeFlags: changeFlags
        });
        else this._updateStateJSON({
            props: props,
            changeFlags: changeFlags
        });
    }
    _updateStateBinary({ props: props, changeFlags: changeFlags }) {
        const layerProps = (0, $8rldy.createLayerPropsFromBinary)(props.data, this.encodePickingColor);
        this.setState({
            layerProps: layerProps
        });
    }
    _updateStateJSON({ props: props, changeFlags: changeFlags }) {
        const features = (0, $hf80Y.getGeojsonFeatures)(props.data);
        const wrapFeature = this.getSubLayerRow.bind(this);
        let newFeatures = {};
        const featuresDiff = {};
        if (Array.isArray(changeFlags.dataChanged)) {
            const oldFeatures = this.state.features;
            for(const key in oldFeatures){
                newFeatures[key] = oldFeatures[key].slice();
                featuresDiff[key] = [];
            }
            for (const dataRange of changeFlags.dataChanged){
                const partialFeatures = (0, $hf80Y.separateGeojsonFeatures)(features, wrapFeature, dataRange);
                for(const key in oldFeatures)featuresDiff[key].push((0, $cNqHj.replaceInRange)({
                    data: newFeatures[key],
                    getIndex: (f)=>f.__source.index,
                    dataRange: dataRange,
                    replace: partialFeatures[key]
                }));
            }
        } else newFeatures = (0, $hf80Y.separateGeojsonFeatures)(features, wrapFeature);
        const layerProps = (0, $8rldy.createLayerPropsFromFeatures)(newFeatures, featuresDiff);
        this.setState({
            features: newFeatures,
            featuresDiff: featuresDiff,
            layerProps: layerProps
        });
    }
    getPickingInfo(params) {
        const info = super.getPickingInfo(params);
        const { index: index, sourceLayer: sourceLayer } = info;
        info.featureType = $a5b6c2842af299e1$var$FEATURE_TYPES.find((ft)=>sourceLayer.id.startsWith("".concat(this.id, "-").concat(ft, "-")));
        if (index >= 0 && sourceLayer.id.startsWith("".concat(this.id, "-points-text")) && this.state.binary) info.index = this.props.data.points.globalFeatureIds.value[index];
        return info;
    }
    _updateAutoHighlight(info) {
        const pointLayerIdPrefix = "".concat(this.id, "-points-");
        const sourceIsPoints = info.featureType === "points";
        for (const layer of this.getSubLayers())if (layer.id.startsWith(pointLayerIdPrefix) === sourceIsPoints) layer.updateAutoHighlight(info);
    }
    _renderPolygonLayer() {
        const { extruded: extruded, wireframe: wireframe } = this.props;
        const { layerProps: layerProps } = this.state;
        const id = "polygons-fill";
        const PolygonFillLayer = this.shouldRenderSubLayer(id, layerProps.polygons.data) && this.getSubLayerClass(id, (0, $fzdNr.POLYGON_LAYER).type);
        if (PolygonFillLayer) {
            const forwardedProps = (0, $fzdNr.forwardProps)(this, (0, $fzdNr.POLYGON_LAYER).props);
            const useLineColor = extruded && wireframe;
            if (!useLineColor) delete forwardedProps.getLineColor;
            forwardedProps.updateTriggers.lineColors = useLineColor;
            return new PolygonFillLayer(forwardedProps, this.getSubLayerProps({
                id: id,
                updateTriggers: forwardedProps.updateTriggers
            }), layerProps.polygons);
        }
        return null;
    }
    _renderLineLayers() {
        const { extruded: extruded, stroked: stroked } = this.props;
        const { layerProps: layerProps } = this.state;
        const polygonStrokeLayerId = "polygons-stroke";
        const lineStringsLayerId = "linestrings";
        const PolygonStrokeLayer = !extruded && stroked && this.shouldRenderSubLayer(polygonStrokeLayerId, layerProps.polygonsOutline.data) && this.getSubLayerClass(polygonStrokeLayerId, (0, $fzdNr.LINE_LAYER).type);
        const LineStringsLayer = this.shouldRenderSubLayer(lineStringsLayerId, layerProps.lines.data) && this.getSubLayerClass(lineStringsLayerId, (0, $fzdNr.LINE_LAYER).type);
        if (PolygonStrokeLayer || LineStringsLayer) {
            const forwardedProps = (0, $fzdNr.forwardProps)(this, (0, $fzdNr.LINE_LAYER).props);
            return [
                PolygonStrokeLayer && new PolygonStrokeLayer(forwardedProps, this.getSubLayerProps({
                    id: polygonStrokeLayerId,
                    updateTriggers: forwardedProps.updateTriggers
                }), layerProps.polygonsOutline),
                LineStringsLayer && new LineStringsLayer(forwardedProps, this.getSubLayerProps({
                    id: lineStringsLayerId,
                    updateTriggers: forwardedProps.updateTriggers
                }), layerProps.lines)
            ];
        }
        return null;
    }
    _renderPointLayers() {
        const { pointType: pointType } = this.props;
        const { layerProps: layerProps, binary: binary } = this.state;
        let { highlightedObjectIndex: highlightedObjectIndex } = this.props;
        if (!binary && Number.isFinite(highlightedObjectIndex)) highlightedObjectIndex = layerProps.points.data.findIndex((d)=>d.__source.index === highlightedObjectIndex);
        const types = new Set(pointType.split("+"));
        const pointLayers = [];
        for (const _ref of types){
            let type = _ref;
            const id = "points-".concat(type);
            const PointLayerMapping = (0, $fzdNr.POINT_LAYER)[type];
            const PointsLayer = PointLayerMapping && this.shouldRenderSubLayer(id, layerProps.points.data) && this.getSubLayerClass(id, PointLayerMapping.type);
            if (PointsLayer) {
                const forwardedProps = (0, $fzdNr.forwardProps)(this, PointLayerMapping.props);
                let pointsLayerProps = layerProps.points;
                if (type === "text" && binary) {
                    const _pointsLayerProps_data_attributes = pointsLayerProps.data.attributes, { instancePickingColors: instancePickingColors } = _pointsLayerProps_data_attributes, rest = (0, $bmkEq._)(_pointsLayerProps_data_attributes, [
                        "instancePickingColors"
                    ]);
                    pointsLayerProps = (0, $edHbI._)((0, $2QP2i._)({}, pointsLayerProps), {
                        data: (0, $edHbI._)((0, $2QP2i._)({}, pointsLayerProps.data), {
                            attributes: rest
                        })
                    });
                }
                pointLayers.push(new PointsLayer(forwardedProps, this.getSubLayerProps({
                    id: id,
                    updateTriggers: forwardedProps.updateTriggers,
                    highlightedObjectIndex: highlightedObjectIndex
                }), pointsLayerProps));
            }
        }
        return pointLayers;
    }
    renderLayers() {
        const { extruded: extruded } = this.props;
        const polygonFillLayer = this._renderPolygonLayer();
        const lineLayers = this._renderLineLayers();
        const pointLayers = this._renderPointLayers();
        return [
            !extruded && polygonFillLayer,
            lineLayers,
            pointLayers,
            extruded && polygonFillLayer
        ];
    }
    getSubLayerAccessor(accessor) {
        const { binary: binary } = this.state;
        if (!binary || typeof accessor !== "function") return super.getSubLayerAccessor(accessor);
        return (object, info)=>{
            const { data: data, index: index } = info;
            const feature = (0, $cyxHD.binaryToFeatureForAccesor)(data, index);
            return accessor(feature, info);
        };
    }
}
(0, $lEQUF.default)($a5b6c2842af299e1$export$2e2bcd8739ae039, "layerName", "GeoJsonLayer");
(0, $lEQUF.default)($a5b6c2842af299e1$export$2e2bcd8739ae039, "defaultProps", $a5b6c2842af299e1$var$defaultProps);

});
parcelRegister("cyxHD", function(module, exports) {

$parcel$export(module.exports, "binaryToFeatureForAccesor", function () { return $9242cdb25de9fdae$export$f7eb00e06514ba7d; });
$parcel$export(module.exports, "calculatePickingColors", function () { return $9242cdb25de9fdae$export$af2f79e75e2a44d; });

var $2QP2i = parcelRequire("2QP2i");
function $9242cdb25de9fdae$export$f7eb00e06514ba7d(data, index) {
    if (!data) return null;
    const featureIndex = "startIndices" in data ? data.startIndices[index] : index;
    const geometryIndex = data.featureIds.value[featureIndex];
    if (featureIndex !== -1) return $9242cdb25de9fdae$var$getPropertiesForIndex(data, geometryIndex, featureIndex);
    return null;
}
function $9242cdb25de9fdae$var$getPropertiesForIndex(data, propertiesIndex, numericPropsIndex) {
    const feature = {
        properties: (0, $2QP2i._)({}, data.properties[propertiesIndex])
    };
    for(const prop in data.numericProps)feature.properties[prop] = data.numericProps[prop].value[numericPropsIndex];
    return feature;
}
function $9242cdb25de9fdae$export$af2f79e75e2a44d(geojsonBinary, encodePickingColor) {
    const pickingColors = {
        points: null,
        lines: null,
        polygons: null
    };
    for(const key in pickingColors){
        const featureIds = geojsonBinary[key].globalFeatureIds.value;
        pickingColors[key] = new Uint8ClampedArray(featureIds.length * 3);
        const pickingColor = [];
        for(let i = 0; i < featureIds.length; i++){
            encodePickingColor(featureIds[i], pickingColor);
            pickingColors[key][i * 3 + 0] = pickingColor[0];
            pickingColors[key][i * 3 + 1] = pickingColor[1];
            pickingColors[key][i * 3 + 2] = pickingColor[2];
        }
    }
    return pickingColors;
}

});

parcelRegister("fzdNr", function(module, exports) {

$parcel$export(module.exports, "POINT_LAYER", function () { return $b554d391c3e3c9d4$export$e6c9a6d53fb57183; });
$parcel$export(module.exports, "LINE_LAYER", function () { return $b554d391c3e3c9d4$export$24275b3ba67f8f2c; });
$parcel$export(module.exports, "POLYGON_LAYER", function () { return $b554d391c3e3c9d4$export$963b4667f7006262; });
$parcel$export(module.exports, "getDefaultProps", function () { return $b554d391c3e3c9d4$export$61b94149aeb1f59; });
$parcel$export(module.exports, "forwardProps", function () { return $b554d391c3e3c9d4$export$fa20a0db85fc7ff2; });

var $h685K = parcelRequire("h685K");

var $cYQ5y = parcelRequire("cYQ5y");

var $9pc7R = parcelRequire("9pc7R");

var $lzW2S = parcelRequire("lzW2S");

var $7VEAA = parcelRequire("7VEAA");
const $b554d391c3e3c9d4$export$e6c9a6d53fb57183 = {
    circle: {
        type: (0, $cYQ5y.default),
        props: {
            filled: "filled",
            stroked: "stroked",
            lineWidthMaxPixels: "lineWidthMaxPixels",
            lineWidthMinPixels: "lineWidthMinPixels",
            lineWidthScale: "lineWidthScale",
            lineWidthUnits: "lineWidthUnits",
            pointRadiusMaxPixels: "radiusMaxPixels",
            pointRadiusMinPixels: "radiusMinPixels",
            pointRadiusScale: "radiusScale",
            pointRadiusUnits: "radiusUnits",
            pointAntialiasing: "antialiasing",
            pointBillboard: "billboard",
            getFillColor: "getFillColor",
            getLineColor: "getLineColor",
            getLineWidth: "getLineWidth",
            getPointRadius: "getRadius"
        }
    },
    icon: {
        type: (0, $h685K.default),
        props: {
            iconAtlas: "iconAtlas",
            iconMapping: "iconMapping",
            iconSizeMaxPixels: "sizeMaxPixels",
            iconSizeMinPixels: "sizeMinPixels",
            iconSizeScale: "sizeScale",
            iconSizeUnits: "sizeUnits",
            iconAlphaCutoff: "alphaCutoff",
            iconBillboard: "billboard",
            getIcon: "getIcon",
            getIconAngle: "getAngle",
            getIconColor: "getColor",
            getIconPixelOffset: "getPixelOffset",
            getIconSize: "getSize"
        }
    },
    text: {
        type: (0, $9pc7R.default),
        props: {
            textSizeMaxPixels: "sizeMaxPixels",
            textSizeMinPixels: "sizeMinPixels",
            textSizeScale: "sizeScale",
            textSizeUnits: "sizeUnits",
            textBackground: "background",
            textBackgroundPadding: "backgroundPadding",
            textFontFamily: "fontFamily",
            textFontWeight: "fontWeight",
            textLineHeight: "lineHeight",
            textMaxWidth: "maxWidth",
            textOutlineColor: "outlineColor",
            textOutlineWidth: "outlineWidth",
            textWordBreak: "wordBreak",
            textCharacterSet: "characterSet",
            textBillboard: "billboard",
            textFontSettings: "fontSettings",
            getText: "getText",
            getTextAngle: "getAngle",
            getTextColor: "getColor",
            getTextPixelOffset: "getPixelOffset",
            getTextSize: "getSize",
            getTextAnchor: "getTextAnchor",
            getTextAlignmentBaseline: "getAlignmentBaseline",
            getTextBackgroundColor: "getBackgroundColor",
            getTextBorderColor: "getBorderColor",
            getTextBorderWidth: "getBorderWidth"
        }
    }
};
const $b554d391c3e3c9d4$export$24275b3ba67f8f2c = {
    type: (0, $lzW2S.default),
    props: {
        lineWidthUnits: "widthUnits",
        lineWidthScale: "widthScale",
        lineWidthMinPixels: "widthMinPixels",
        lineWidthMaxPixels: "widthMaxPixels",
        lineJointRounded: "jointRounded",
        lineCapRounded: "capRounded",
        lineMiterLimit: "miterLimit",
        lineBillboard: "billboard",
        getLineColor: "getColor",
        getLineWidth: "getWidth"
    }
};
const $b554d391c3e3c9d4$export$963b4667f7006262 = {
    type: (0, $7VEAA.default),
    props: {
        extruded: "extruded",
        filled: "filled",
        wireframe: "wireframe",
        elevationScale: "elevationScale",
        material: "material",
        _full3d: "_full3d",
        getElevation: "getElevation",
        getFillColor: "getFillColor",
        getLineColor: "getLineColor"
    }
};
function $b554d391c3e3c9d4$export$61b94149aeb1f59({ type: type, props: props }) {
    const result = {};
    for(const key in props)result[key] = type.defaultProps[props[key]];
    return result;
}
function $b554d391c3e3c9d4$export$fa20a0db85fc7ff2(layer, mapping) {
    const { transitions: transitions, updateTriggers: updateTriggers } = layer.props;
    const result = {
        updateTriggers: {},
        transitions: transitions && {
            getPosition: transitions.geometry
        }
    };
    for(const sourceKey in mapping){
        const targetKey = mapping[sourceKey];
        let value = layer.props[sourceKey];
        if (sourceKey.startsWith("get")) {
            value = layer.getSubLayerAccessor(value);
            result.updateTriggers[targetKey] = updateTriggers[sourceKey];
            if (transitions) result.transitions[targetKey] = transitions[sourceKey];
        }
        result[targetKey] = value;
    }
    return result;
}

});
parcelRegister("h685K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c72946135ca1cedd$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $i46md = parcelRequire("i46md");
var $4VQgq = parcelRequire("4VQgq");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");
var $7gQQK = parcelRequire("7gQQK");

var $cxTxU = parcelRequire("cxTxU");
var $b2F4S = parcelRequire("b2F4S");

var $hcGz1 = parcelRequire("hcGz1");

var $2fpBy = parcelRequire("2fpBy");

var $fAO6S = parcelRequire("fAO6S");
const $c72946135ca1cedd$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $c72946135ca1cedd$var$defaultProps = {
    iconAtlas: {
        type: "image",
        value: null,
        async: true
    },
    iconMapping: {
        type: "object",
        value: {},
        async: true
    },
    sizeScale: {
        type: "number",
        value: 1,
        min: 0
    },
    billboard: true,
    sizeUnits: "pixels",
    sizeMinPixels: {
        type: "number",
        min: 0,
        value: 0
    },
    sizeMaxPixels: {
        type: "number",
        min: 0,
        value: Number.MAX_SAFE_INTEGER
    },
    alphaCutoff: {
        type: "number",
        value: 0.05,
        min: 0,
        max: 1
    },
    getPosition: {
        type: "accessor",
        value: (x)=>x.position
    },
    getIcon: {
        type: "accessor",
        value: (x)=>x.icon
    },
    getColor: {
        type: "accessor",
        value: $c72946135ca1cedd$var$DEFAULT_COLOR
    },
    getSize: {
        type: "accessor",
        value: 1
    },
    getAngle: {
        type: "accessor",
        value: 0
    },
    getPixelOffset: {
        type: "accessor",
        value: [
            0,
            0
        ]
    },
    onIconError: {
        type: "function",
        value: null,
        optional: true
    },
    textureParameters: {
        type: "object",
        ignore: true
    }
};
class $c72946135ca1cedd$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getShaders() {
        return super.getShaders({
            vs: $hcGz1.default,
            fs: $2fpBy.default,
            modules: [
                (0, $jRSMz.default),
                (0, $7UxuR.default)
            ]
        });
    }
    initializeState() {
        this.state = {
            iconManager: new (0, $fAO6S.default)(this.context.gl, {
                onUpdate: this._onUpdate.bind(this),
                onError: this._onError.bind(this)
            })
        };
        const attributeManager = this.getAttributeManager();
        attributeManager.addInstanced({
            instancePositions: {
                size: 3,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: true,
                accessor: "getPosition"
            },
            instanceSizes: {
                size: 1,
                transition: true,
                accessor: "getSize",
                defaultValue: 1
            },
            instanceOffsets: {
                size: 2,
                accessor: "getIcon",
                transform: this.getInstanceOffset
            },
            instanceIconFrames: {
                size: 4,
                accessor: "getIcon",
                transform: this.getInstanceIconFrame
            },
            instanceColorModes: {
                size: 1,
                type: 5121,
                accessor: "getIcon",
                transform: this.getInstanceColorMode
            },
            instanceColors: {
                size: this.props.colorFormat.length,
                type: 5121,
                normalized: true,
                transition: true,
                accessor: "getColor",
                defaultValue: $c72946135ca1cedd$var$DEFAULT_COLOR
            },
            instanceAngles: {
                size: 1,
                transition: true,
                accessor: "getAngle"
            },
            instancePixelOffset: {
                size: 2,
                transition: true,
                accessor: "getPixelOffset"
            }
        });
    }
    updateState(params) {
        super.updateState(params);
        const { props: props, oldProps: oldProps, changeFlags: changeFlags } = params;
        const attributeManager = this.getAttributeManager();
        const { iconAtlas: iconAtlas, iconMapping: iconMapping, data: data, getIcon: getIcon, textureParameters: textureParameters } = props;
        const { iconManager: iconManager } = this.state;
        const prePacked = iconAtlas || this.internalState.isAsyncPropLoading("iconAtlas");
        iconManager.setProps({
            loadOptions: props.loadOptions,
            autoPacking: !prePacked,
            iconAtlas: iconAtlas,
            iconMapping: prePacked ? iconMapping : null,
            textureParameters: textureParameters
        });
        if (prePacked) {
            if (oldProps.iconMapping !== props.iconMapping) attributeManager.invalidate("getIcon");
        } else if (changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getIcon)) iconManager.packIcons(data, getIcon);
        if (changeFlags.extensionsChanged) {
            var _this$state$model;
            const { gl: gl } = this.context;
            (_this$state$model = this.state.model) === null || _this$state$model === void 0 || _this$state$model.delete();
            this.state.model = this._getModel(gl);
            attributeManager.invalidateAll();
        }
    }
    get isLoaded() {
        return super.isLoaded && this.state.iconManager.isLoaded;
    }
    finalizeState(context) {
        super.finalizeState(context);
        this.state.iconManager.finalize();
    }
    draw({ uniforms: uniforms }) {
        const { sizeScale: sizeScale, sizeMinPixels: sizeMinPixels, sizeMaxPixels: sizeMaxPixels, sizeUnits: sizeUnits, billboard: billboard, alphaCutoff: alphaCutoff } = this.props;
        const { iconManager: iconManager } = this.state;
        const iconsTexture = iconManager.getTexture();
        if (iconsTexture) this.state.model.setUniforms(uniforms).setUniforms({
            iconsTexture: iconsTexture,
            iconsTextureDim: [
                iconsTexture.width,
                iconsTexture.height
            ],
            sizeUnits: (0, $7gQQK.UNIT)[sizeUnits],
            sizeScale: sizeScale,
            sizeMinPixels: sizeMinPixels,
            sizeMaxPixels: sizeMaxPixels,
            billboard: billboard,
            alphaCutoff: alphaCutoff
        }).draw();
    }
    _getModel(gl) {
        const positions = [
            -1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1
        ];
        return new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders()), {
            id: this.props.id,
            geometry: new (0, $cxTxU.default)({
                drawMode: 6,
                attributes: {
                    positions: {
                        size: 2,
                        value: new Float32Array(positions)
                    }
                }
            }),
            isInstanced: true
        }));
    }
    _onUpdate() {
        this.setNeedsRedraw();
    }
    _onError(evt) {
        var _this$getCurrentLayer;
        const onIconError = (_this$getCurrentLayer = this.getCurrentLayer()) === null || _this$getCurrentLayer === void 0 ? void 0 : _this$getCurrentLayer.props.onIconError;
        if (onIconError) onIconError(evt);
        else (0, $4VQgq.default).error(evt.error.message)();
    }
    getInstanceOffset(icon) {
        const { width: width, height: height, anchorX: anchorX = width / 2, anchorY: anchorY = height / 2 } = this.state.iconManager.getIconMapping(icon);
        return [
            width / 2 - anchorX,
            height / 2 - anchorY
        ];
    }
    getInstanceColorMode(icon) {
        const mapping = this.state.iconManager.getIconMapping(icon);
        return mapping.mask ? 1 : 0;
    }
    getInstanceIconFrame(icon) {
        const { x: x, y: y, width: width, height: height } = this.state.iconManager.getIconMapping(icon);
        return [
            x,
            y,
            width,
            height
        ];
    }
    constructor(...args){
        super(...args);
        (0, $lEQUF.default)(this, "state", void 0);
    }
}
(0, $lEQUF.default)($c72946135ca1cedd$export$2e2bcd8739ae039, "defaultProps", $c72946135ca1cedd$var$defaultProps);
(0, $lEQUF.default)($c72946135ca1cedd$export$2e2bcd8739ae039, "layerName", "IconLayer");

});
parcelRegister("hcGz1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c86492f040cb4b2b$export$2e2bcd8739ae039; });
var $c86492f040cb4b2b$export$2e2bcd8739ae039 = "#define SHADER_NAME icon-layer-vertex-shader\n\nattribute vec2 positions;\n\nattribute vec3 instancePositions;\nattribute vec3 instancePositions64Low;\nattribute float instanceSizes;\nattribute float instanceAngles;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\nattribute vec4 instanceIconFrames;\nattribute float instanceColorModes;\nattribute vec2 instanceOffsets;\nattribute vec2 instancePixelOffset;\n\nuniform float sizeScale;\nuniform vec2 iconsTextureDim;\nuniform float sizeMinPixels;\nuniform float sizeMaxPixels;\nuniform bool billboard;\nuniform int sizeUnits;\n\nvarying float vColorMode;\nvarying vec4 vColor;\nvarying vec2 vTextureCoords;\nvarying vec2 uv;\n\nvec2 rotate_by_angle(vec2 vertex, float angle) {\n  float angle_radian = angle * PI / 180.0;\n  float cos_angle = cos(angle_radian);\n  float sin_angle = sin(angle_radian);\n  mat2 rotationMatrix = mat2(cos_angle, -sin_angle, sin_angle, cos_angle);\n  return rotationMatrix * vertex;\n}\n\nvoid main(void) {\n  geometry.worldPosition = instancePositions;\n  geometry.uv = positions;\n  geometry.pickingColor = instancePickingColors;\n  uv = positions;\n\n  vec2 iconSize = instanceIconFrames.zw;\n  float sizePixels = clamp(\n    project_size_to_pixel(instanceSizes * sizeScale, sizeUnits), \n    sizeMinPixels, sizeMaxPixels\n  );\n  float instanceScale = iconSize.y == 0.0 ? 0.0 : sizePixels / iconSize.y;\n  vec2 pixelOffset = positions / 2.0 * iconSize + instanceOffsets;\n  pixelOffset = rotate_by_angle(pixelOffset, instanceAngles) * instanceScale;\n  pixelOffset += instancePixelOffset;\n  pixelOffset.y *= -1.0;\n\n  if (billboard)  {\n    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);\n    DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n    vec3 offset = vec3(pixelOffset, 0.0);\n    DECKGL_FILTER_SIZE(offset, geometry);\n    gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);\n\n  } else {\n    vec3 offset_common = vec3(project_pixel_size(pixelOffset), 0.0);\n    DECKGL_FILTER_SIZE(offset_common, geometry);\n    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset_common, geometry.position); \n    DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n  }\n\n  vTextureCoords = mix(\n    instanceIconFrames.xy,\n    instanceIconFrames.xy + iconSize,\n    (positions.xy + 1.0) / 2.0\n  ) / iconsTextureDim;\n\n  vColor = instanceColors;\n  DECKGL_FILTER_COLOR(vColor, geometry);\n\n  vColorMode = instanceColorModes;\n}\n";

});

parcelRegister("2fpBy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a30d80b67a076f3$export$2e2bcd8739ae039; });
var $1a30d80b67a076f3$export$2e2bcd8739ae039 = "#define SHADER_NAME icon-layer-fragment-shader\n\nprecision highp float;\n\nuniform float opacity;\nuniform sampler2D iconsTexture;\nuniform float alphaCutoff;\n\nvarying float vColorMode;\nvarying vec4 vColor;\nvarying vec2 vTextureCoords;\nvarying vec2 uv;\n\nvoid main(void) {\n  geometry.uv = uv;\n\n  vec4 texColor = texture2D(iconsTexture, vTextureCoords);\n  vec3 color = mix(texColor.rgb, vColor.rgb, vColorMode);\n  float a = texColor.a * opacity * vColor.a;\n\n  if (a < alphaCutoff) {\n    discard;\n  }\n\n  gl_FragColor = vec4(color, a);\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";

});

parcelRegister("fAO6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5a11694de6165eb$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $2YUMm = parcelRequire("2YUMm");
var $7lUAH = parcelRequire("7lUAH");

var $hGAZG = parcelRequire("hGAZG");

var $abpME = parcelRequire("abpME");
const $b5a11694de6165eb$var$DEFAULT_CANVAS_WIDTH = 1024;
const $b5a11694de6165eb$var$DEFAULT_BUFFER = 4;
const $b5a11694de6165eb$var$noop = ()=>{};
const $b5a11694de6165eb$var$DEFAULT_TEXTURE_PARAMETERS = {
    [10241]: 9987,
    [10240]: 9729,
    [10242]: 33071,
    [10243]: 33071
};
function $b5a11694de6165eb$var$nextPowOfTwo(number) {
    return Math.pow(2, Math.ceil(Math.log2(number)));
}
function $b5a11694de6165eb$var$resizeImage(ctx, imageData, maxWidth, maxHeight) {
    const resizeRatio = Math.min(maxWidth / imageData.width, maxHeight / imageData.height);
    const width = Math.floor(imageData.width * resizeRatio);
    const height = Math.floor(imageData.height * resizeRatio);
    if (resizeRatio === 1) return {
        data: imageData,
        width: width,
        height: height
    };
    ctx.canvas.height = height;
    ctx.canvas.width = width;
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(imageData, 0, 0, imageData.width, imageData.height, 0, 0, width, height);
    return {
        data: ctx.canvas,
        width: width,
        height: height
    };
}
function $b5a11694de6165eb$var$getIconId(icon) {
    return icon && (icon.id || icon.url);
}
function $b5a11694de6165eb$var$resizeTexture(texture, width, height, parameters) {
    const oldWidth = texture.width;
    const oldHeight = texture.height;
    const newTexture = new (0, $7lUAH.default)(texture.gl, {
        width: width,
        height: height,
        parameters: parameters
    });
    (0, $2YUMm.copyToTexture)(texture, newTexture, {
        targetY: 0,
        width: oldWidth,
        height: oldHeight
    });
    texture.delete();
    return newTexture;
}
function $b5a11694de6165eb$var$buildRowMapping(mapping, columns, yOffset) {
    for(let i = 0; i < columns.length; i++){
        const { icon: icon, xOffset: xOffset } = columns[i];
        const id = $b5a11694de6165eb$var$getIconId(icon);
        mapping[id] = (0, $edHbI._)((0, $2QP2i._)({}, icon), {
            x: xOffset,
            y: yOffset
        });
    }
}
function $b5a11694de6165eb$export$a868857fc20192e3({ icons: icons, buffer: buffer, mapping: mapping = {}, xOffset: xOffset = 0, yOffset: yOffset = 0, rowHeight: rowHeight = 0, canvasWidth: canvasWidth }) {
    let columns = [];
    for(let i = 0; i < icons.length; i++){
        const icon = icons[i];
        const id = $b5a11694de6165eb$var$getIconId(icon);
        if (!mapping[id]) {
            const { height: height, width: width } = icon;
            if (xOffset + width + buffer > canvasWidth) {
                $b5a11694de6165eb$var$buildRowMapping(mapping, columns, yOffset);
                xOffset = 0;
                yOffset = rowHeight + yOffset + buffer;
                rowHeight = 0;
                columns = [];
            }
            columns.push({
                icon: icon,
                xOffset: xOffset
            });
            xOffset = xOffset + width + buffer;
            rowHeight = Math.max(rowHeight, height);
        }
    }
    if (columns.length > 0) $b5a11694de6165eb$var$buildRowMapping(mapping, columns, yOffset);
    return {
        mapping: mapping,
        rowHeight: rowHeight,
        xOffset: xOffset,
        yOffset: yOffset,
        canvasWidth: canvasWidth,
        canvasHeight: $b5a11694de6165eb$var$nextPowOfTwo(rowHeight + yOffset + buffer)
    };
}
function $b5a11694de6165eb$export$2f9aa8236f3bd1fa(data, getIcon, cachedIcons) {
    if (!data || !getIcon) return null;
    cachedIcons = cachedIcons || {};
    const icons = {};
    const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(data);
    for (const object of iterable){
        objectInfo.index++;
        const icon = getIcon(object, objectInfo);
        const id = $b5a11694de6165eb$var$getIconId(icon);
        if (!icon) throw new Error("Icon is missing.");
        if (!icon.url) throw new Error("Icon url is missing.");
        if (!icons[id] && (!cachedIcons[id] || icon.url !== cachedIcons[id].url)) icons[id] = (0, $edHbI._)((0, $2QP2i._)({}, icon), {
            source: object,
            sourceIndex: objectInfo.index
        });
    }
    return icons;
}
class $b5a11694de6165eb$export$2e2bcd8739ae039 {
    finalize() {
        var _this$_texture;
        (_this$_texture = this._texture) === null || _this$_texture === void 0 || _this$_texture.delete();
    }
    getTexture() {
        return this._texture || this._externalTexture;
    }
    getIconMapping(icon) {
        const id = this._autoPacking ? $b5a11694de6165eb$var$getIconId(icon) : icon;
        return this._mapping[id] || {};
    }
    setProps({ loadOptions: loadOptions, autoPacking: autoPacking, iconAtlas: iconAtlas, iconMapping: iconMapping, textureParameters: textureParameters }) {
        if (loadOptions) this._loadOptions = loadOptions;
        if (autoPacking !== undefined) this._autoPacking = autoPacking;
        if (iconMapping) this._mapping = iconMapping;
        if (iconAtlas) {
            var _this$_texture2;
            (_this$_texture2 = this._texture) === null || _this$_texture2 === void 0 || _this$_texture2.delete();
            this._texture = null;
            this._externalTexture = iconAtlas;
        }
        if (textureParameters) this._textureParameters = textureParameters;
    }
    get isLoaded() {
        return this._pendingCount === 0;
    }
    packIcons(data, getIcon) {
        if (!this._autoPacking || typeof document === "undefined") return;
        const icons = Object.values($b5a11694de6165eb$export$2f9aa8236f3bd1fa(data, getIcon, this._mapping) || {});
        if (icons.length > 0) {
            const { mapping: mapping, xOffset: xOffset, yOffset: yOffset, rowHeight: rowHeight, canvasHeight: canvasHeight } = $b5a11694de6165eb$export$a868857fc20192e3({
                icons: icons,
                buffer: this._buffer,
                canvasWidth: this._canvasWidth,
                mapping: this._mapping,
                rowHeight: this._rowHeight,
                xOffset: this._xOffset,
                yOffset: this._yOffset
            });
            this._rowHeight = rowHeight;
            this._mapping = mapping;
            this._xOffset = xOffset;
            this._yOffset = yOffset;
            this._canvasHeight = canvasHeight;
            if (!this._texture) this._texture = new (0, $7lUAH.default)(this.gl, {
                width: this._canvasWidth,
                height: this._canvasHeight,
                parameters: this._textureParameters || $b5a11694de6165eb$var$DEFAULT_TEXTURE_PARAMETERS
            });
            if (this._texture.height !== this._canvasHeight) this._texture = $b5a11694de6165eb$var$resizeTexture(this._texture, this._canvasWidth, this._canvasHeight, this._textureParameters || $b5a11694de6165eb$var$DEFAULT_TEXTURE_PARAMETERS);
            this.onUpdate();
            this._canvas = this._canvas || document.createElement("canvas");
            this._loadIcons(icons);
        }
    }
    _loadIcons(icons) {
        const ctx = this._canvas.getContext("2d", {
            willReadFrequently: true
        });
        for (const icon of icons){
            this._pendingCount++;
            (0, $hGAZG.load)(icon.url, this._loadOptions).then((imageData)=>{
                const id = $b5a11694de6165eb$var$getIconId(icon);
                const iconDef = this._mapping[id];
                const { x: x, y: y, width: maxWidth, height: maxHeight } = iconDef;
                const { data: data, width: width, height: height } = $b5a11694de6165eb$var$resizeImage(ctx, imageData, maxWidth, maxHeight);
                this._texture.setSubImageData({
                    data: data,
                    x: x + (maxWidth - width) / 2,
                    y: y + (maxHeight - height) / 2,
                    width: width,
                    height: height
                });
                iconDef.width = width;
                iconDef.height = height;
                this._texture.generateMipmap();
                this.onUpdate();
            }).catch((error)=>{
                this.onError({
                    url: icon.url,
                    source: icon.source,
                    sourceIndex: icon.sourceIndex,
                    loadOptions: this._loadOptions,
                    error: error
                });
            }).finally(()=>{
                this._pendingCount--;
            });
        }
    }
    constructor(gl, { onUpdate: onUpdate = $b5a11694de6165eb$var$noop, onError: onError = $b5a11694de6165eb$var$noop }){
        (0, $lEQUF.default)(this, "gl", void 0);
        (0, $lEQUF.default)(this, "onUpdate", void 0);
        (0, $lEQUF.default)(this, "onError", void 0);
        (0, $lEQUF.default)(this, "_loadOptions", null);
        (0, $lEQUF.default)(this, "_texture", null);
        (0, $lEQUF.default)(this, "_externalTexture", null);
        (0, $lEQUF.default)(this, "_mapping", {});
        (0, $lEQUF.default)(this, "_textureParameters", null);
        (0, $lEQUF.default)(this, "_pendingCount", 0);
        (0, $lEQUF.default)(this, "_autoPacking", false);
        (0, $lEQUF.default)(this, "_xOffset", 0);
        (0, $lEQUF.default)(this, "_yOffset", 0);
        (0, $lEQUF.default)(this, "_rowHeight", 0);
        (0, $lEQUF.default)(this, "_buffer", $b5a11694de6165eb$var$DEFAULT_BUFFER);
        (0, $lEQUF.default)(this, "_canvasWidth", $b5a11694de6165eb$var$DEFAULT_CANVAS_WIDTH);
        (0, $lEQUF.default)(this, "_canvasHeight", 0);
        (0, $lEQUF.default)(this, "_canvas", null);
        this.gl = gl;
        this.onUpdate = onUpdate;
        this.onError = onError;
    }
}

});
parcelRegister("hGAZG", function(module, exports) {

$parcel$export(module.exports, "load", function () { return $ce030e1c2e626152$export$11e63f7b0f3d9900; });

var $e1wxv = parcelRequire("e1wxv");

var $ejAXt = parcelRequire("ejAXt");

var $bT4Nz = parcelRequire("bT4Nz");

var $dNJQA = parcelRequire("dNJQA");
async function $ce030e1c2e626152$export$11e63f7b0f3d9900(url, loaders, options, context) {
    if (!Array.isArray(loaders) && !(0, $ejAXt.isLoaderObject)(loaders)) {
        context = undefined;
        options = loaders;
        loaders = undefined;
    }
    const fetch = (0, $bT4Nz.getFetchFunction)(options);
    let data = url;
    if (typeof url === "string") data = await fetch(url);
    if ((0, $e1wxv.isBlob)(url)) data = await fetch(url);
    return await (0, $dNJQA.parse)(data, loaders, options);
}

});
parcelRegister("e1wxv", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $a35a6651eb30d797$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPureObject", function () { return $a35a6651eb30d797$export$e219791d2b49856; });
$parcel$export(module.exports, "isIterable", function () { return $a35a6651eb30d797$export$9652023d9040757; });
$parcel$export(module.exports, "isAsyncIterable", function () { return $a35a6651eb30d797$export$edb10ab8dd75a915; });
$parcel$export(module.exports, "isIterator", function () { return $a35a6651eb30d797$export$50db6e277db66ea0; });
$parcel$export(module.exports, "isResponse", function () { return $a35a6651eb30d797$export$3f1eb41d9a6a6a27; });
$parcel$export(module.exports, "isBlob", function () { return $a35a6651eb30d797$export$5bcd6e94ed871c88; });
$parcel$export(module.exports, "isBuffer", function () { return $a35a6651eb30d797$export$a7884ebc965f8f54; });
$parcel$export(module.exports, "isReadableStream", function () { return $a35a6651eb30d797$export$ac613ff475b69d05; });
const $a35a6651eb30d797$var$isBoolean = (x)=>typeof x === "boolean";
const $a35a6651eb30d797$var$isFunction = (x)=>typeof x === "function";
const $a35a6651eb30d797$export$a6cdc56e425d0d0a = (x)=>x !== null && typeof x === "object";
const $a35a6651eb30d797$export$e219791d2b49856 = (x)=>$a35a6651eb30d797$export$a6cdc56e425d0d0a(x) && x.constructor === ({}).constructor;
const $a35a6651eb30d797$export$4369c812aac99591 = (x)=>$a35a6651eb30d797$export$a6cdc56e425d0d0a(x) && $a35a6651eb30d797$var$isFunction(x.then);
const $a35a6651eb30d797$export$9652023d9040757 = (x)=>x && typeof x[Symbol.iterator] === "function";
const $a35a6651eb30d797$export$edb10ab8dd75a915 = (x)=>x && typeof x[Symbol.asyncIterator] === "function";
const $a35a6651eb30d797$export$50db6e277db66ea0 = (x)=>x && $a35a6651eb30d797$var$isFunction(x.next);
const $a35a6651eb30d797$export$3f1eb41d9a6a6a27 = (x)=>typeof Response !== "undefined" && x instanceof Response || x && x.arrayBuffer && x.text && x.json;
const $a35a6651eb30d797$export$be78b3111c50efdd = (x)=>typeof File !== "undefined" && x instanceof File;
const $a35a6651eb30d797$export$5bcd6e94ed871c88 = (x)=>typeof Blob !== "undefined" && x instanceof Blob;
const $a35a6651eb30d797$export$a7884ebc965f8f54 = (x)=>x && typeof x === "object" && x.isBuffer;
const $a35a6651eb30d797$export$5536d41d90245d51 = (x)=>$a35a6651eb30d797$export$a6cdc56e425d0d0a(x) && $a35a6651eb30d797$var$isFunction(x.abort) && $a35a6651eb30d797$var$isFunction(x.getWriter);
const $a35a6651eb30d797$export$f8bb1f6b773199b7 = (x)=>typeof ReadableStream !== "undefined" && x instanceof ReadableStream || $a35a6651eb30d797$export$a6cdc56e425d0d0a(x) && $a35a6651eb30d797$var$isFunction(x.tee) && $a35a6651eb30d797$var$isFunction(x.cancel) && $a35a6651eb30d797$var$isFunction(x.getReader);
const $a35a6651eb30d797$export$eec1f46c8eef21a4 = (x)=>$a35a6651eb30d797$export$a6cdc56e425d0d0a(x) && $a35a6651eb30d797$var$isFunction(x.end) && $a35a6651eb30d797$var$isFunction(x.write) && $a35a6651eb30d797$var$isBoolean(x.writable);
const $a35a6651eb30d797$export$2940183a2d5db90f = (x)=>$a35a6651eb30d797$export$a6cdc56e425d0d0a(x) && $a35a6651eb30d797$var$isFunction(x.read) && $a35a6651eb30d797$var$isFunction(x.pipe) && $a35a6651eb30d797$var$isBoolean(x.readable);
const $a35a6651eb30d797$export$ac613ff475b69d05 = (x)=>$a35a6651eb30d797$export$f8bb1f6b773199b7(x) || $a35a6651eb30d797$export$2940183a2d5db90f(x);
const $a35a6651eb30d797$export$b58a61c52edb4f66 = (x)=>$a35a6651eb30d797$export$5536d41d90245d51(x) || $a35a6651eb30d797$export$eec1f46c8eef21a4(x);

});

parcelRegister("ejAXt", function(module, exports) {

$parcel$export(module.exports, "isLoaderObject", function () { return $a6bf8226ff587011$export$2db07da082dd07a7; });
$parcel$export(module.exports, "normalizeLoader", function () { return $a6bf8226ff587011$export$a19b0af95f3585f1; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $8LMZY = parcelRequire("8LMZY");
function $a6bf8226ff587011$export$2db07da082dd07a7(loader) {
    var _loader;
    if (!loader) return false;
    if (Array.isArray(loader)) loader = loader[0];
    const hasExtensions = Array.isArray((_loader = loader) === null || _loader === void 0 ? void 0 : _loader.extensions);
    return hasExtensions;
}
function $a6bf8226ff587011$export$a19b0af95f3585f1(loader) {
    var _loader2, _loader3;
    (0, $8LMZY.assert)(loader, "null loader");
    (0, $8LMZY.assert)($a6bf8226ff587011$export$2db07da082dd07a7(loader), "invalid loader");
    let options;
    if (Array.isArray(loader)) {
        options = loader[1];
        loader = loader[0];
        loader = (0, $edHbI._)((0, $2QP2i._)({}, loader), {
            options: (0, $2QP2i._)({}, loader.options, options)
        });
    }
    if ((_loader2 = loader) !== null && _loader2 !== void 0 && _loader2.parseTextSync || (_loader3 = loader) !== null && _loader3 !== void 0 && _loader3.parseText) loader.text = true;
    if (!loader.text) loader.binary = true;
    return loader;
}

});
parcelRegister("8LMZY", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $6628b8a26d337056$export$a7a9523472993e97; });
function $6628b8a26d337056$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "loader assertion failed.");
}

});


parcelRegister("bT4Nz", function(module, exports) {

$parcel$export(module.exports, "getGlobalLoaderState", function () { return $8a788da837da1f1f$export$2a5c5f9d1a96dd63; });
$parcel$export(module.exports, "normalizeOptions", function () { return $8a788da837da1f1f$export$eb806c0b85b62f7a; });
$parcel$export(module.exports, "getFetchFunction", function () { return $8a788da837da1f1f$export$9b973e0eff85009f; });

var $2QP2i = parcelRequire("2QP2i");

var $e1wxv = parcelRequire("e1wxv");

var $2NmWy = parcelRequire("2NmWy");

var $iTzee = parcelRequire("iTzee");

var $crAh0 = parcelRequire("crAh0");
function $8a788da837da1f1f$export$2a5c5f9d1a96dd63() {
    globalThis.loaders = globalThis.loaders || {};
    const { loaders: loaders } = globalThis;
    loaders._state = loaders._state || {};
    return loaders._state;
}
const $8a788da837da1f1f$var$getGlobalLoaderOptions = ()=>{
    const state = $8a788da837da1f1f$export$2a5c5f9d1a96dd63();
    state.globalOptions = state.globalOptions || (0, $2QP2i._)({}, (0, $crAh0.DEFAULT_LOADER_OPTIONS));
    return state.globalOptions;
};
function $8a788da837da1f1f$export$545eb931aeddfa08(options) {
    const state = $8a788da837da1f1f$export$2a5c5f9d1a96dd63();
    const globalOptions = $8a788da837da1f1f$var$getGlobalLoaderOptions();
    state.globalOptions = $8a788da837da1f1f$var$normalizeOptionsInternal(globalOptions, options);
}
function $8a788da837da1f1f$export$eb806c0b85b62f7a(options, loader, loaders, url) {
    loaders = loaders || [];
    loaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    $8a788da837da1f1f$var$validateOptions(options, loaders);
    return $8a788da837da1f1f$var$normalizeOptionsInternal(loader, options, url);
}
function $8a788da837da1f1f$export$9b973e0eff85009f(options, context) {
    const globalOptions = $8a788da837da1f1f$var$getGlobalLoaderOptions();
    const fetchOptions = options || globalOptions;
    if (typeof fetchOptions.fetch === "function") return fetchOptions.fetch;
    if ((0, $e1wxv.isObject)(fetchOptions.fetch)) return (url)=>(0, $2NmWy.fetchFile)(url, fetchOptions);
    if (context !== null && context !== void 0 && context.fetch) return context === null || context === void 0 ? void 0 : context.fetch;
    return 0, $2NmWy.fetchFile;
}
function $8a788da837da1f1f$var$validateOptions(options, loaders) {
    $8a788da837da1f1f$var$validateOptionsObject(options, null, (0, $crAh0.DEFAULT_LOADER_OPTIONS), (0, $crAh0.REMOVED_LOADER_OPTIONS), loaders);
    for (const loader of loaders){
        const idOptions = options && options[loader.id] || {};
        const loaderOptions = loader.options && loader.options[loader.id] || {};
        const deprecatedOptions = loader.deprecatedOptions && loader.deprecatedOptions[loader.id] || {};
        $8a788da837da1f1f$var$validateOptionsObject(idOptions, loader.id, loaderOptions, deprecatedOptions, loaders);
    }
}
function $8a788da837da1f1f$var$validateOptionsObject(options, id, defaultOptions, deprecatedOptions, loaders) {
    const loaderName = id || "Top level";
    const prefix = id ? `${id}.` : "";
    for(const key in options){
        const isSubOptions = !id && (0, $e1wxv.isObject)(options[key]);
        const isBaseUriOption = key === "baseUri" && !id;
        const isWorkerUrlOption = key === "workerUrl" && id;
        if (!(key in defaultOptions) && !isBaseUriOption && !isWorkerUrlOption) {
            if (key in deprecatedOptions) (0, $iTzee.probeLog).warn(`${loaderName} loader option \'${prefix}${key}\' no longer supported, use \'${deprecatedOptions[key]}\'`)();
            else if (!isSubOptions) {
                const suggestion = $8a788da837da1f1f$var$findSimilarOption(key, loaders);
                (0, $iTzee.probeLog).warn(`${loaderName} loader option \'${prefix}${key}\' not recognized. ${suggestion}`)();
            }
        }
    }
}
function $8a788da837da1f1f$var$findSimilarOption(optionKey, loaders) {
    const lowerCaseOptionKey = optionKey.toLowerCase();
    let bestSuggestion = "";
    for (const loader of loaders)for(const key in loader.options){
        if (optionKey === key) return `Did you mean \'${loader.id}.${key}\'?`;
        const lowerCaseKey = key.toLowerCase();
        const isPartialMatch = lowerCaseOptionKey.startsWith(lowerCaseKey) || lowerCaseKey.startsWith(lowerCaseOptionKey);
        if (isPartialMatch) bestSuggestion = bestSuggestion || `Did you mean \'${loader.id}.${key}\'?`;
    }
    return bestSuggestion;
}
function $8a788da837da1f1f$var$normalizeOptionsInternal(loader, options, url) {
    const loaderDefaultOptions = loader.options || {};
    const mergedOptions = (0, $2QP2i._)({}, loaderDefaultOptions);
    $8a788da837da1f1f$var$addUrlOptions(mergedOptions, url);
    if (mergedOptions.log === null) mergedOptions.log = new (0, $iTzee.NullLog)();
    $8a788da837da1f1f$var$mergeNestedFields(mergedOptions, $8a788da837da1f1f$var$getGlobalLoaderOptions());
    $8a788da837da1f1f$var$mergeNestedFields(mergedOptions, options);
    return mergedOptions;
}
function $8a788da837da1f1f$var$mergeNestedFields(mergedOptions, options) {
    for(const key in options)if (key in options) {
        const value = options[key];
        if ((0, $e1wxv.isPureObject)(value) && (0, $e1wxv.isPureObject)(mergedOptions[key])) mergedOptions[key] = (0, $2QP2i._)({}, mergedOptions[key], options[key]);
        else mergedOptions[key] = options[key];
    }
}
function $8a788da837da1f1f$var$addUrlOptions(options, url) {
    if (url && !("baseUri" in options)) options.baseUri = url;
}

});
parcelRegister("2NmWy", function(module, exports) {

$parcel$export(module.exports, "fetchFile", function () { return $2091f47518b99d4f$export$d965bcb23f9d06c5; });

var $3RzUk = parcelRequire("3RzUk");

var $dadEq = parcelRequire("dadEq");
async function $2091f47518b99d4f$export$d965bcb23f9d06c5(url, options) {
    if (typeof url === "string") {
        url = (0, $3RzUk.resolvePath)(url);
        let fetchOptions = options;
        if (options !== null && options !== void 0 && options.fetch && typeof (options === null || options === void 0 ? void 0 : options.fetch) !== "function") fetchOptions = options.fetch;
        return await fetch(url, fetchOptions);
    }
    return await (0, $dadEq.makeResponse)(url);
}

});
parcelRegister("3RzUk", function(module, exports) {

$parcel$export(module.exports, "resolvePath", function () { return $2d022cd4cd84a1b6$export$b09f2ff0bbcb43c7; });
let $2d022cd4cd84a1b6$var$pathPrefix = "";
const $2d022cd4cd84a1b6$var$fileAliases = {};
function $2d022cd4cd84a1b6$export$fa7cbeea6a0f8cd3(prefix) {
    $2d022cd4cd84a1b6$var$pathPrefix = prefix;
}
function $2d022cd4cd84a1b6$export$e21ff368c7512d8e() {
    return $2d022cd4cd84a1b6$var$pathPrefix;
}
function $2d022cd4cd84a1b6$export$65b32f70101f5674(aliases) {
    Object.assign($2d022cd4cd84a1b6$var$fileAliases, aliases);
}
function $2d022cd4cd84a1b6$export$b09f2ff0bbcb43c7(filename) {
    for(const alias in $2d022cd4cd84a1b6$var$fileAliases)if (filename.startsWith(alias)) {
        const replacement = $2d022cd4cd84a1b6$var$fileAliases[alias];
        filename = filename.replace(alias, replacement);
    }
    if (!filename.startsWith("http://") && !filename.startsWith("https://")) filename = `${$2d022cd4cd84a1b6$var$pathPrefix}${filename}`;
    return filename;
}

});

parcelRegister("dadEq", function(module, exports) {

$parcel$export(module.exports, "makeResponse", function () { return $9956cc5ca40856c5$export$16d84ad959da5112; });
$parcel$export(module.exports, "checkResponse", function () { return $9956cc5ca40856c5$export$5db0ad607ce3410b; });

var $e1wxv = parcelRequire("e1wxv");

var $5Tper = parcelRequire("5Tper");
async function $9956cc5ca40856c5$export$16d84ad959da5112(resource) {
    if ((0, $e1wxv.isResponse)(resource)) return resource;
    const headers = {};
    const contentLength = (0, $5Tper.getResourceContentLength)(resource);
    if (contentLength >= 0) headers["content-length"] = String(contentLength);
    const { url: url, type: type } = (0, $5Tper.getResourceUrlAndType)(resource);
    if (type) headers["content-type"] = type;
    const initialDataUrl = await $9956cc5ca40856c5$var$getInitialDataUrl(resource);
    if (initialDataUrl) headers["x-first-bytes"] = initialDataUrl;
    if (typeof resource === "string") resource = new TextEncoder().encode(resource);
    const response = new Response(resource, {
        headers: headers
    });
    Object.defineProperty(response, "url", {
        value: url
    });
    return response;
}
async function $9956cc5ca40856c5$export$5db0ad607ce3410b(response) {
    if (!response.ok) {
        const message = await $9956cc5ca40856c5$var$getResponseError(response);
        throw new Error(message);
    }
}
function $9956cc5ca40856c5$export$ef46f094beca181f(response) {
    if (!response.ok) {
        let message = `${response.status} ${response.statusText}`;
        message = message.length > 60 ? `${message.slice(60)}...` : message;
        throw new Error(message);
    }
}
async function $9956cc5ca40856c5$var$getResponseError(response) {
    let message = `Failed to fetch resource ${response.url} (${response.status}): `;
    try {
        const contentType = response.headers.get("Content-Type");
        let text = response.statusText;
        if (contentType.includes("application/json")) text += ` ${await response.text()}`;
        message += text;
        message = message.length > 60 ? `${message.slice(60)}...` : message;
    } catch (error) {}
    return message;
}
async function $9956cc5ca40856c5$var$getInitialDataUrl(resource) {
    const INITIAL_DATA_LENGTH = 5;
    if (typeof resource === "string") return `data:,${resource.slice(0, INITIAL_DATA_LENGTH)}`;
    if (resource instanceof Blob) {
        const blobSlice = resource.slice(0, 5);
        return await new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onload = (event)=>{
                var _event$target;
                return resolve(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result);
            };
            reader.readAsDataURL(blobSlice);
        });
    }
    if (resource instanceof ArrayBuffer) {
        const slice = resource.slice(0, INITIAL_DATA_LENGTH);
        const base64 = $9956cc5ca40856c5$var$arrayBufferToBase64(slice);
        return `data:base64,${base64}`;
    }
    return null;
}
function $9956cc5ca40856c5$var$arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    for(let i = 0; i < bytes.byteLength; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
}

});
parcelRegister("5Tper", function(module, exports) {

$parcel$export(module.exports, "getResourceUrlAndType", function () { return $44a5a95c9800610f$export$62b93576035b31a0; });
$parcel$export(module.exports, "getResourceContentLength", function () { return $44a5a95c9800610f$export$795ad0074e2d4d36; });

var $e1wxv = parcelRequire("e1wxv");

var $hCL4l = parcelRequire("hCL4l");
const $44a5a95c9800610f$var$QUERY_STRING_PATTERN = /\?.*/;
function $44a5a95c9800610f$export$62b93576035b31a0(resource) {
    if ((0, $e1wxv.isResponse)(resource)) {
        const url = $44a5a95c9800610f$var$stripQueryString(resource.url || "");
        const contentTypeHeader = resource.headers.get("content-type") || "";
        return {
            url: url,
            type: (0, $hCL4l.parseMIMEType)(contentTypeHeader) || (0, $hCL4l.parseMIMETypeFromURL)(url)
        };
    }
    if ((0, $e1wxv.isBlob)(resource)) return {
        url: $44a5a95c9800610f$var$stripQueryString(resource.name || ""),
        type: resource.type || ""
    };
    if (typeof resource === "string") return {
        url: $44a5a95c9800610f$var$stripQueryString(resource),
        type: (0, $hCL4l.parseMIMETypeFromURL)(resource)
    };
    return {
        url: "",
        type: ""
    };
}
function $44a5a95c9800610f$export$795ad0074e2d4d36(resource) {
    if ((0, $e1wxv.isResponse)(resource)) return resource.headers["content-length"] || -1;
    if ((0, $e1wxv.isBlob)(resource)) return resource.size;
    if (typeof resource === "string") return resource.length;
    if (resource instanceof ArrayBuffer) return resource.byteLength;
    if (ArrayBuffer.isView(resource)) return resource.byteLength;
    return -1;
}
function $44a5a95c9800610f$var$stripQueryString(url) {
    return url.replace($44a5a95c9800610f$var$QUERY_STRING_PATTERN, "");
}

});
parcelRegister("hCL4l", function(module, exports) {

$parcel$export(module.exports, "parseMIMEType", function () { return $cd4a7f3db6caf304$export$85e6adb445fa3ef0; });
$parcel$export(module.exports, "parseMIMETypeFromURL", function () { return $cd4a7f3db6caf304$export$a8aa3005f5e6c533; });
const $cd4a7f3db6caf304$var$DATA_URL_PATTERN = /^data:([-\w.]+\/[-\w.+]+)(;|,)/;
const $cd4a7f3db6caf304$var$MIME_TYPE_PATTERN = /^([-\w.]+\/[-\w.+]+)/;
function $cd4a7f3db6caf304$export$85e6adb445fa3ef0(mimeString) {
    const matches = $cd4a7f3db6caf304$var$MIME_TYPE_PATTERN.exec(mimeString);
    if (matches) return matches[1];
    return mimeString;
}
function $cd4a7f3db6caf304$export$a8aa3005f5e6c533(url) {
    const matches = $cd4a7f3db6caf304$var$DATA_URL_PATTERN.exec(url);
    if (matches) return matches[1];
    return "";
}

});




parcelRegister("iTzee", function(module, exports) {

$parcel$export(module.exports, "probeLog", function () { return $dc18b0b488f292dc$export$775acaacb88283c4; });
$parcel$export(module.exports, "NullLog", function () { return $dc18b0b488f292dc$export$c8151b0a106d0aae; });
$parcel$export(module.exports, "ConsoleLog", function () { return $dc18b0b488f292dc$export$b0d7de77e5ad708; });

var $1F5uH = parcelRequire("1F5uH");
parcelRequire("e4611");
var $2P1GV = parcelRequire("2P1GV");
const $dc18b0b488f292dc$export$775acaacb88283c4 = new (0, $2P1GV.default)({
    id: "loaders.gl"
});
class $dc18b0b488f292dc$export$c8151b0a106d0aae {
    log() {
        return ()=>{};
    }
    info() {
        return ()=>{};
    }
    warn() {
        return ()=>{};
    }
    error() {
        return ()=>{};
    }
}
class $dc18b0b488f292dc$export$b0d7de77e5ad708 {
    log(...args) {
        return this.console.log.bind(this.console, ...args);
    }
    info(...args) {
        return this.console.info.bind(this.console, ...args);
    }
    warn(...args) {
        return this.console.warn.bind(this.console, ...args);
    }
    error(...args) {
        return this.console.error.bind(this.console, ...args);
    }
    constructor(){
        (0, $1F5uH.default)(this, "console", void 0);
        this.console = console;
    }
}

});
parcelRegister("e4611", function(module, exports) {

$parcel$export(module.exports, "Log", function () { return (parcelRequire("2P1GV")).default; });


var $2P1GV = parcelRequire("2P1GV");











parcelRequire("6CIYR");
var $azAHT = parcelRequire("azAHT");
var $biFr5 = parcelRequire("biFr5");
var $a3d61af2324ac8d7$export$2e2bcd8739ae039 = new (0, $2P1GV.default)({
    id: "probe.gl"
});

});
parcelRegister("2P1GV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20e1a814bed818df$export$2e2bcd8739ae039; });

var $6mcwc = parcelRequire("6mcwc");

var $2wUTt = parcelRequire("2wUTt");

var $fQWC8 = parcelRequire("fQWC8");

var $4d7hv = parcelRequire("4d7hv");

var $3NdId = parcelRequire("3NdId");

var $113Uv = parcelRequire("113Uv");

var $blCq0 = parcelRequire("blCq0");
const $20e1a814bed818df$var$originalConsole = {
    debug: (0, $6mcwc.isBrowser) ? console.debug || console.log : console.log,
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error
};
const $20e1a814bed818df$var$DEFAULT_SETTINGS = {
    enabled: true,
    level: 0
};
function $20e1a814bed818df$var$noop() {}
const $20e1a814bed818df$var$cache = {};
const $20e1a814bed818df$var$ONCE = {
    once: true
};
function $20e1a814bed818df$var$getTableHeader(table) {
    for(const key in table){
        for(const title in table[key])return title || "untitled";
    }
    return "empty";
}
class $20e1a814bed818df$export$2e2bcd8739ae039 {
    set level(newLevel) {
        this.setLevel(newLevel);
    }
    get level() {
        return this.getLevel();
    }
    isEnabled() {
        return this._storage.config.enabled;
    }
    getLevel() {
        return this._storage.config.level;
    }
    getTotal() {
        return Number(((0, $blCq0.default)() - this._startTs).toPrecision(10));
    }
    getDelta() {
        return Number(((0, $blCq0.default)() - this._deltaTs).toPrecision(10));
    }
    set priority(newPriority) {
        this.level = newPriority;
    }
    get priority() {
        return this.level;
    }
    getPriority() {
        return this.level;
    }
    enable(enabled = true) {
        this._storage.updateConfiguration({
            enabled: enabled
        });
        return this;
    }
    setLevel(level) {
        this._storage.updateConfiguration({
            level: level
        });
        return this;
    }
    assert(condition, message) {
        (0, $113Uv.default)(condition, message);
    }
    warn(message) {
        return this._getLogFunction(0, message, $20e1a814bed818df$var$originalConsole.warn, arguments, $20e1a814bed818df$var$ONCE);
    }
    error(message) {
        return this._getLogFunction(0, message, $20e1a814bed818df$var$originalConsole.error, arguments);
    }
    deprecated(oldUsage, newUsage) {
        return this.warn("`".concat(oldUsage, "` is deprecated and will be removed in a later version. Use `").concat(newUsage, "` instead"));
    }
    removed(oldUsage, newUsage) {
        return this.error("`".concat(oldUsage, "` has been removed. Use `").concat(newUsage, "` instead"));
    }
    probe(logLevel, message) {
        return this._getLogFunction(logLevel, message, $20e1a814bed818df$var$originalConsole.log, arguments, {
            time: true,
            once: true
        });
    }
    log(logLevel, message) {
        return this._getLogFunction(logLevel, message, $20e1a814bed818df$var$originalConsole.debug, arguments);
    }
    info(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.info, arguments);
    }
    once(logLevel, message) {
        return this._getLogFunction(logLevel, message, $20e1a814bed818df$var$originalConsole.debug || $20e1a814bed818df$var$originalConsole.info, arguments, $20e1a814bed818df$var$ONCE);
    }
    table(logLevel, table, columns) {
        if (table) return this._getLogFunction(logLevel, table, console.table || $20e1a814bed818df$var$noop, columns && [
            columns
        ], {
            tag: $20e1a814bed818df$var$getTableHeader(table)
        });
        return $20e1a814bed818df$var$noop;
    }
    image({ logLevel: logLevel, priority: priority, image: image, message: message = "", scale: scale = 1 }) {
        if (!this._shouldLog(logLevel || priority)) return $20e1a814bed818df$var$noop;
        return (0, $6mcwc.isBrowser) ? $20e1a814bed818df$var$logImageInBrowser({
            image: image,
            message: message,
            scale: scale
        }) : $20e1a814bed818df$var$logImageInNode({
            image: image,
            message: message,
            scale: scale
        });
    }
    settings() {
        if (console.table) console.table(this._storage.config);
        else console.log(this._storage.config);
    }
    get(setting) {
        return this._storage.config[setting];
    }
    set(setting, value) {
        this._storage.updateConfiguration({
            [setting]: value
        });
    }
    time(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.time ? console.time : console.info);
    }
    timeEnd(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeEnd ? console.timeEnd : console.info);
    }
    timeStamp(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeStamp || $20e1a814bed818df$var$noop);
    }
    group(logLevel, message, opts = {
        collapsed: false
    }) {
        opts = $20e1a814bed818df$export$abc60e668512edf9({
            logLevel: logLevel,
            message: message,
            opts: opts
        });
        const { collapsed: collapsed } = opts;
        opts.method = (collapsed ? console.groupCollapsed : console.group) || console.info;
        return this._getLogFunction(opts);
    }
    groupCollapsed(logLevel, message, opts = {}) {
        return this.group(logLevel, message, Object.assign({}, opts, {
            collapsed: true
        }));
    }
    groupEnd(logLevel) {
        return this._getLogFunction(logLevel, "", console.groupEnd || $20e1a814bed818df$var$noop);
    }
    withGroup(logLevel, message, func) {
        this.group(logLevel, message)();
        try {
            func();
        } finally{
            this.groupEnd(logLevel)();
        }
    }
    trace() {
        if (console.trace) console.trace();
    }
    _shouldLog(logLevel) {
        return this.isEnabled() && this.getLevel() >= $20e1a814bed818df$var$normalizeLogLevel(logLevel);
    }
    _getLogFunction(logLevel, message, method, args = [], opts) {
        if (this._shouldLog(logLevel)) {
            opts = $20e1a814bed818df$export$abc60e668512edf9({
                logLevel: logLevel,
                message: message,
                args: args,
                opts: opts
            });
            method = method || opts.method;
            (0, $113Uv.default)(method);
            opts.total = this.getTotal();
            opts.delta = this.getDelta();
            this._deltaTs = (0, $blCq0.default)();
            const tag = opts.tag || opts.message;
            if (opts.once) {
                if (!$20e1a814bed818df$var$cache[tag]) $20e1a814bed818df$var$cache[tag] = (0, $blCq0.default)();
                else return $20e1a814bed818df$var$noop;
            }
            message = $20e1a814bed818df$var$decorateMessage(this.id, opts.message, opts);
            return method.bind(console, message, ...opts.args);
        }
        return $20e1a814bed818df$var$noop;
    }
    constructor({ id: id } = {
        id: ""
    }){
        this.id = id;
        this.VERSION = (0, $6mcwc.VERSION);
        this._startTs = (0, $blCq0.default)();
        this._deltaTs = (0, $blCq0.default)();
        this.LOG_THROTTLE_TIMEOUT = 0;
        this._storage = new (0, $2wUTt.default)("__probe-".concat(this.id, "__"), $20e1a814bed818df$var$DEFAULT_SETTINGS);
        this.userData = {};
        this.timeStamp("".concat(this.id, " started"));
        (0, $3NdId.autobind)(this);
        Object.seal(this);
    }
}
$20e1a814bed818df$export$2e2bcd8739ae039.VERSION = (0, $6mcwc.VERSION);
function $20e1a814bed818df$var$normalizeLogLevel(logLevel) {
    if (!logLevel) return 0;
    let resolvedLevel;
    switch(typeof logLevel){
        case "number":
            resolvedLevel = logLevel;
            break;
        case "object":
            resolvedLevel = logLevel.logLevel || logLevel.priority || 0;
            break;
        default:
            return 0;
    }
    (0, $113Uv.default)(Number.isFinite(resolvedLevel) && resolvedLevel >= 0);
    return resolvedLevel;
}
function $20e1a814bed818df$export$abc60e668512edf9(opts) {
    const { logLevel: logLevel, message: message } = opts;
    opts.logLevel = $20e1a814bed818df$var$normalizeLogLevel(logLevel);
    const args = opts.args ? Array.from(opts.args) : [];
    while(args.length && args.shift() !== message);
    opts.args = args;
    switch(typeof logLevel){
        case "string":
        case "function":
            if (message !== undefined) args.unshift(message);
            opts.message = logLevel;
            break;
        case "object":
            Object.assign(opts, logLevel);
            break;
        default:
    }
    if (typeof opts.message === "function") opts.message = opts.message();
    const messageType = typeof opts.message;
    (0, $113Uv.default)(messageType === "string" || messageType === "object");
    return Object.assign(opts, opts.opts);
}
function $20e1a814bed818df$var$decorateMessage(id, message, opts) {
    if (typeof message === "string") {
        const time = opts.time ? (0, $fQWC8.leftPad)((0, $fQWC8.formatTime)(opts.total)) : "";
        message = opts.time ? "".concat(id, ": ").concat(time, "  ").concat(message) : "".concat(id, ": ").concat(message);
        message = (0, $4d7hv.addColor)(message, opts.color, opts.background);
    }
    return message;
}

function $20e1a814bed818df$var$logImageInNode({ image: image, message: message = "", scale: scale = 1 }) {
    let asciify = null;
    try {
        asciify = (parcelRequire("5tWFo"));
    } catch (error) {}
    if (asciify) return ()=>asciify(image, {
            fit: "box",
            width: "".concat(Math.round(80 * scale), "%")
        }).then((data)=>console.log(data));
    return $20e1a814bed818df$var$noop;
}
function $20e1a814bed818df$var$logImageInBrowser({ image: image, message: message = "", scale: scale = 1 }) {
    if (typeof image === "string") {
        const img = new Image();
        img.onload = ()=>{
            const args = (0, $fQWC8.formatImage)(img, message, scale);
            console.log(...args);
        };
        img.src = image;
        return $20e1a814bed818df$var$noop;
    }
    const element = image.nodeName || "";
    if (element.toLowerCase() === "img") {
        console.log(...(0, $fQWC8.formatImage)(image, message, scale));
        return $20e1a814bed818df$var$noop;
    }
    if (element.toLowerCase() === "canvas") {
        const img = new Image();
        img.onload = ()=>console.log(...(0, $fQWC8.formatImage)(img, message, scale));
        img.src = image.toDataURL();
        return $20e1a814bed818df$var$noop;
    }
    return $20e1a814bed818df$var$noop;
}

});
parcelRegister("6mcwc", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $4a0e820c3db1fa54$export$a4ad2735b021c132; });
$parcel$export(module.exports, "isBrowser", function () { return $4a0e820c3db1fa54$export$4e09c449d6c407f7; });

var $gSC7V = parcelRequire("gSC7V");

var $bSvGO = parcelRequire("bSvGO");
const $4a0e820c3db1fa54$export$a4ad2735b021c132 = typeof __VERSION__ !== "undefined" ? __VERSION__ : "untranspiled source";
const $4a0e820c3db1fa54$export$4e09c449d6c407f7 = (0, $gSC7V.default)();

});
parcelRegister("gSC7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c49f43b062fa7b91$export$2e2bcd8739ae039; });

var $6Ltw5 = parcelRequire("6Ltw5");

var $95Bnk = parcelRequire("95Bnk");
function $c49f43b062fa7b91$export$2e2bcd8739ae039() {
    const isNode = typeof $95Bnk === "object" && String($95Bnk) === "[object process]" && false;
    return !isNode || (0, $6Ltw5.default)();
}
function $c49f43b062fa7b91$export$fb09d24fafba666a() {
    return $c49f43b062fa7b91$export$2e2bcd8739ae039() && typeof document !== "undefined";
}

});
parcelRegister("6Ltw5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ece0738232bb513$export$2e2bcd8739ae039; });

var $95Bnk = parcelRequire("95Bnk");
function $4ece0738232bb513$export$2e2bcd8739ae039(mockUserAgent) {
    if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") return true;
    if (typeof $95Bnk !== "undefined" && typeof $95Bnk.versions === "object" && Boolean($95Bnk.versions.electron)) return true;
    const realUserAgent = typeof navigator === "object" && typeof navigator.userAgent === "string" && navigator.userAgent;
    const userAgent = mockUserAgent || realUserAgent;
    if (userAgent && userAgent.indexOf("Electron") >= 0) return true;
    return false;
}

});


parcelRegister("bSvGO", function(module, exports) {

$parcel$export(module.exports, "window", function () { return $8a5d51c0e7483c64$export$8291e5b88f90ce4; });
$parcel$export(module.exports, "process", function () { return $8a5d51c0e7483c64$export$e54fe5b0f43758f7; });

var $95Bnk = parcelRequire("95Bnk");
const $8a5d51c0e7483c64$var$globals = {
    self: typeof self !== "undefined" && self,
    window: typeof window !== "undefined" && window,
    global: typeof $parcel$global !== "undefined" && $parcel$global,
    document: typeof document !== "undefined" && document,
    process: typeof $95Bnk === "object" && $95Bnk
};
const $8a5d51c0e7483c64$export$82c2e460fb230c2a = $8a5d51c0e7483c64$var$globals.self || $8a5d51c0e7483c64$var$globals.window || $8a5d51c0e7483c64$var$globals.global;
const $8a5d51c0e7483c64$export$8291e5b88f90ce4 = $8a5d51c0e7483c64$var$globals.window || $8a5d51c0e7483c64$var$globals.self || $8a5d51c0e7483c64$var$globals.global;
const $8a5d51c0e7483c64$export$90b4d2ff6acb88af = $8a5d51c0e7483c64$var$globals.global || $8a5d51c0e7483c64$var$globals.self || $8a5d51c0e7483c64$var$globals.window;
const $8a5d51c0e7483c64$export$5a7bfc01df82fcd1 = $8a5d51c0e7483c64$var$globals.document || {};
const $8a5d51c0e7483c64$export$e54fe5b0f43758f7 = $8a5d51c0e7483c64$var$globals.process || {};
const $8a5d51c0e7483c64$export$e896d9a1b4631fa1 = console;

});


parcelRegister("2wUTt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d7ab3dd97b18254$export$2e2bcd8739ae039; });
function $1d7ab3dd97b18254$var$getStorage(type) {
    try {
        const storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return storage;
    } catch (e) {
        return null;
    }
}
class $1d7ab3dd97b18254$export$2e2bcd8739ae039 {
    getConfiguration() {
        return this.config;
    }
    setConfiguration(configuration) {
        this.config = {};
        return this.updateConfiguration(configuration);
    }
    updateConfiguration(configuration) {
        Object.assign(this.config, configuration);
        if (this.storage) {
            const serialized = JSON.stringify(this.config);
            this.storage.setItem(this.id, serialized);
        }
        return this;
    }
    _loadConfiguration() {
        let configuration = {};
        if (this.storage) {
            const serializedConfiguration = this.storage.getItem(this.id);
            configuration = serializedConfiguration ? JSON.parse(serializedConfiguration) : {};
        }
        Object.assign(this.config, configuration);
        return this;
    }
    constructor(id, defaultSettings, type = "sessionStorage"){
        this.storage = $1d7ab3dd97b18254$var$getStorage(type);
        this.id = id;
        this.config = {};
        Object.assign(this.config, defaultSettings);
        this._loadConfiguration();
    }
}

});

parcelRegister("fQWC8", function(module, exports) {

$parcel$export(module.exports, "formatTime", function () { return $b8a92de46cb0b972$export$3203edd9e5edd663; });
$parcel$export(module.exports, "leftPad", function () { return $b8a92de46cb0b972$export$cbb503201166aab7; });
$parcel$export(module.exports, "formatImage", function () { return $b8a92de46cb0b972$export$9171d83acafa047c; });
function $b8a92de46cb0b972$export$3203edd9e5edd663(ms) {
    let formatted;
    if (ms < 10) formatted = "".concat(ms.toFixed(2), "ms");
    else if (ms < 100) formatted = "".concat(ms.toFixed(1), "ms");
    else if (ms < 1000) formatted = "".concat(ms.toFixed(0), "ms");
    else formatted = "".concat((ms / 1000).toFixed(2), "s");
    return formatted;
}
function $b8a92de46cb0b972$export$cbb503201166aab7(string, length = 8) {
    const padLength = Math.max(length - string.length, 0);
    return "".concat(" ".repeat(padLength)).concat(string);
}
function $b8a92de46cb0b972$export$390245bab32fb60f(string, length = 8) {
    const padLength = Math.max(length - string.length, 0);
    return "".concat(string).concat(" ".repeat(padLength));
}
function $b8a92de46cb0b972$export$7c4d25c0c3217d8c(v, opts = {}) {
    const EPSILON = 1e-16;
    const { isInteger: isInteger = false } = opts;
    if (Array.isArray(v) || ArrayBuffer.isView(v)) return $b8a92de46cb0b972$var$formatArrayValue(v, opts);
    if (!Number.isFinite(v)) return String(v);
    if (Math.abs(v) < EPSILON) return isInteger ? "0" : "0.";
    if (isInteger) return v.toFixed(0);
    if (Math.abs(v) > 100 && Math.abs(v) < 10000) return v.toFixed(0);
    const string = v.toPrecision(2);
    const decimal = string.indexOf(".0");
    return decimal === string.length - 2 ? string.slice(0, -1) : string;
}
function $b8a92de46cb0b972$var$formatArrayValue(v, opts) {
    const { maxElts: maxElts = 16, size: size = 1 } = opts;
    let string = "[";
    for(let i = 0; i < v.length && i < maxElts; ++i){
        if (i > 0) string += ",".concat(i % size === 0 ? " " : "");
        string += $b8a92de46cb0b972$export$7c4d25c0c3217d8c(v[i], opts);
    }
    const terminator = v.length > maxElts ? "..." : "]";
    return "".concat(string).concat(terminator);
}
function $b8a92de46cb0b972$export$9171d83acafa047c(image, message, scale, maxWidth = 600) {
    const imageUrl = image.src.replace(/\(/g, "%28").replace(/\)/g, "%29");
    if (image.width > maxWidth) scale = Math.min(scale, maxWidth / image.width);
    const width = image.width * scale;
    const height = image.height * scale;
    const style = [
        "font-size:1px;",
        "padding:".concat(Math.floor(height / 2), "px ").concat(Math.floor(width / 2), "px;"),
        "line-height:".concat(height, "px;"),
        "background:url(".concat(imageUrl, ");"),
        "background-size:".concat(width, "px ").concat(height, "px;"),
        "color:transparent;"
    ].join("");
    return [
        "".concat(message, " %c+"),
        style
    ];
}

});

parcelRegister("4d7hv", function(module, exports) {

$parcel$export(module.exports, "addColor", function () { return $310e063b9305036e$export$4c4d9288a45f1fb3; });

var $6mcwc = parcelRequire("6mcwc");
const $310e063b9305036e$export$9b982809044276a6 = {
    BLACK: 30,
    RED: 31,
    GREEN: 32,
    YELLOW: 33,
    BLUE: 34,
    MAGENTA: 35,
    CYAN: 36,
    WHITE: 37,
    BRIGHT_BLACK: 90,
    BRIGHT_RED: 91,
    BRIGHT_GREEN: 92,
    BRIGHT_YELLOW: 93,
    BRIGHT_BLUE: 94,
    BRIGHT_MAGENTA: 95,
    BRIGHT_CYAN: 96,
    BRIGHT_WHITE: 97
};
function $310e063b9305036e$var$getColor(color) {
    return typeof color === "string" ? $310e063b9305036e$export$9b982809044276a6[color.toUpperCase()] || $310e063b9305036e$export$9b982809044276a6.WHITE : color;
}
function $310e063b9305036e$export$4c4d9288a45f1fb3(string, color, background) {
    if (!(0, $6mcwc.isBrowser) && typeof string === "string") {
        if (color) {
            color = $310e063b9305036e$var$getColor(color);
            string = "\x1b[".concat(color, "m").concat(string, "\x1b[39m");
        }
        if (background) {
            color = $310e063b9305036e$var$getColor(background);
            string = "\x1b[".concat(background + 10, "m").concat(string, "\x1b[49m");
        }
    }
    return string;
}

});

parcelRegister("3NdId", function(module, exports) {

$parcel$export(module.exports, "autobind", function () { return $2c3095a9f1e08e59$export$f648f36420f83db; });
function $2c3095a9f1e08e59$export$f648f36420f83db(obj, predefined = [
    "constructor"
]) {
    const proto = Object.getPrototypeOf(obj);
    const propNames = Object.getOwnPropertyNames(proto);
    for (const key of propNames){
        if (typeof obj[key] === "function") {
            if (!predefined.find((name)=>key === name)) obj[key] = obj[key].bind(obj);
        }
    }
}

});

parcelRegister("113Uv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bd8eaf37056fb34$export$2e2bcd8739ae039; });
function $0bd8eaf37056fb34$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}

});

parcelRegister("blCq0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $842f74f93f1cab4e$export$2e2bcd8739ae039; });

var $6mcwc = parcelRequire("6mcwc");
var $bSvGO = parcelRequire("bSvGO");
function $842f74f93f1cab4e$export$2e2bcd8739ae039() {
    let timestamp;
    if ((0, $6mcwc.isBrowser) && (0, $bSvGO.window).performance) timestamp = (0, $bSvGO.window).performance.now();
    else if ((0, $bSvGO.process).hrtime) {
        const timeParts = (0, $bSvGO.process).hrtime();
        timestamp = timeParts[0] * 1000 + timeParts[1] / 1e6;
    } else timestamp = Date.now();
    return timestamp;
}

});

parcelRegister("5tWFo", function(module, exports) {
"use strict";

});


parcelRegister("6CIYR", function(module, exports) {

var $azAHT = parcelRequire("azAHT");

var $biFr5 = parcelRequire("biFr5");

var $kiwvU = parcelRequire("kiwvU");

});
parcelRegister("azAHT", function(module, exports) {

var $biFr5 = parcelRequire("biFr5");
class $7b29a586296b1dc0$export$2e2bcd8739ae039 {
    get(name, type = "count") {
        return this._getOrCreate({
            name: name,
            type: type
        });
    }
    get size() {
        return Object.keys(this.stats).length;
    }
    reset() {
        for(const key in this.stats)this.stats[key].reset();
        return this;
    }
    forEach(fn) {
        for(const key in this.stats)fn(this.stats[key]);
    }
    getTable() {
        const table = {};
        this.forEach((stat)=>{
            table[stat.name] = {
                time: stat.time || 0,
                count: stat.count || 0,
                average: stat.getAverageTime() || 0,
                hz: stat.getHz() || 0
            };
        });
        return table;
    }
    _initializeStats(stats = []) {
        stats.forEach((stat)=>this._getOrCreate(stat));
    }
    _getOrCreate(stat) {
        if (!stat || !stat.name) return null;
        const { name: name, type: type } = stat;
        if (!this.stats[name]) {
            if (stat instanceof (0, $biFr5.default)) this.stats[name] = stat;
            else this.stats[name] = new (0, $biFr5.default)(name, type);
        }
        return this.stats[name];
    }
    constructor({ id: id, stats: stats }){
        this.id = id;
        this.stats = {};
        this._initializeStats(stats);
        Object.seal(this);
    }
}

});
parcelRegister("biFr5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83a18470c8564281$export$2e2bcd8739ae039; });

var $kiwvU = parcelRequire("kiwvU");
class $83a18470c8564281$export$2e2bcd8739ae039 {
    setSampleSize(samples) {
        this.sampleSize = samples;
        return this;
    }
    incrementCount() {
        this.addCount(1);
        return this;
    }
    decrementCount() {
        this.subtractCount(1);
        return this;
    }
    addCount(value) {
        this._count += value;
        this._samples++;
        this._checkSampling();
        return this;
    }
    subtractCount(value) {
        this._count -= value;
        this._samples++;
        this._checkSampling();
        return this;
    }
    addTime(time) {
        this._time += time;
        this.lastTiming = time;
        this._samples++;
        this._checkSampling();
        return this;
    }
    timeStart() {
        this._startTime = (0, $kiwvU.default)();
        this._timerPending = true;
        return this;
    }
    timeEnd() {
        if (!this._timerPending) return this;
        this.addTime((0, $kiwvU.default)() - this._startTime);
        this._timerPending = false;
        this._checkSampling();
        return this;
    }
    getSampleAverageCount() {
        return this.sampleSize > 0 ? this.lastSampleCount / this.sampleSize : 0;
    }
    getSampleAverageTime() {
        return this.sampleSize > 0 ? this.lastSampleTime / this.sampleSize : 0;
    }
    getSampleHz() {
        return this.lastSampleTime > 0 ? this.sampleSize / (this.lastSampleTime / 1000) : 0;
    }
    getAverageCount() {
        return this.samples > 0 ? this.count / this.samples : 0;
    }
    getAverageTime() {
        return this.samples > 0 ? this.time / this.samples : 0;
    }
    getHz() {
        return this.time > 0 ? this.samples / (this.time / 1000) : 0;
    }
    reset() {
        this.time = 0;
        this.count = 0;
        this.samples = 0;
        this.lastTiming = 0;
        this.lastSampleTime = 0;
        this.lastSampleCount = 0;
        this._count = 0;
        this._time = 0;
        this._samples = 0;
        this._startTime = 0;
        this._timerPending = false;
        return this;
    }
    _checkSampling() {
        if (this._samples === this.sampleSize) {
            this.lastSampleTime = this._time;
            this.lastSampleCount = this._count;
            this.count += this._count;
            this.time += this._time;
            this.samples += this._samples;
            this._time = 0;
            this._count = 0;
            this._samples = 0;
        }
    }
    constructor(name, type){
        this.name = name;
        this.type = type;
        this.sampleSize = 1;
        this.reset();
    }
}

});
parcelRegister("kiwvU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec6eb59df0773912$export$2e2bcd8739ae039; });

var $95Bnk = parcelRequire("95Bnk");
function $ec6eb59df0773912$export$2e2bcd8739ae039() {
    let timestamp;
    if (typeof window !== "undefined" && window.performance) timestamp = window.performance.now();
    else if (typeof $95Bnk !== "undefined" && $95Bnk.hrtime) {
        const timeParts = $95Bnk.hrtime();
        timestamp = timeParts[0] * 1000 + timeParts[1] / 1e6;
    } else timestamp = Date.now();
    return timestamp;
}

});






parcelRegister("crAh0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOADER_OPTIONS", function () { return $90f424c47befe55f$export$9e68d151f40453e2; });
$parcel$export(module.exports, "REMOVED_LOADER_OPTIONS", function () { return $90f424c47befe55f$export$1bd820ce6d516afc; });

var $iTzee = parcelRequire("iTzee");
const $90f424c47befe55f$export$9e68d151f40453e2 = {
    fetch: null,
    mimeType: undefined,
    nothrow: false,
    log: new (0, $iTzee.ConsoleLog)(),
    CDN: "https://unpkg.com/@loaders.gl",
    worker: true,
    maxConcurrency: 3,
    maxMobileConcurrency: 1,
    reuseWorkers: true,
    _workerType: "",
    limit: 0,
    _limitMB: 0,
    batchSize: "auto",
    batchDebounceMs: 0,
    metadata: false,
    transforms: []
};
const $90f424c47befe55f$export$1bd820ce6d516afc = {
    throws: "nothrow",
    dataType: "(no longer used)",
    uri: "baseUri",
    method: "fetch.method",
    headers: "fetch.headers",
    body: "fetch.body",
    mode: "fetch.mode",
    credentials: "fetch.credentials",
    cache: "fetch.cache",
    redirect: "fetch.redirect",
    referrer: "fetch.referrer",
    referrerPolicy: "fetch.referrerPolicy",
    integrity: "fetch.integrity",
    keepalive: "fetch.keepalive",
    signal: "fetch.signal"
};

});


parcelRegister("dNJQA", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $a0c36a44ecfd763d$export$98e6a39c04603d36; });

var $4knIj = parcelRequire("4knIj");
var $jzxj2 = parcelRequire("jzxj2");

var $eZcKF = parcelRequire("eZcKF");

var $ejAXt = parcelRequire("ejAXt");

var $bT4Nz = parcelRequire("bT4Nz");

var $8c4WA = parcelRequire("8c4WA");

var $nVzgc = parcelRequire("nVzgc");

var $5Tper = parcelRequire("5Tper");

var $h45pu = parcelRequire("h45pu");
async function $a0c36a44ecfd763d$export$98e6a39c04603d36(data, loaders, options, context) {
    (0, $4knIj.assert)(!context || typeof context === "object");
    if (loaders && !Array.isArray(loaders) && !(0, $ejAXt.isLoaderObject)(loaders)) {
        context = undefined;
        options = loaders;
        loaders = undefined;
    }
    data = await data;
    options = options || {};
    const { url: url } = (0, $5Tper.getResourceUrlAndType)(data);
    const typedLoaders = loaders;
    const candidateLoaders = (0, $nVzgc.getLoadersFromContext)(typedLoaders, context);
    const loader = await (0, $h45pu.selectLoader)(data, candidateLoaders, options);
    if (!loader) return null;
    options = (0, $bT4Nz.normalizeOptions)(options, loader, candidateLoaders, url);
    context = (0, $nVzgc.getLoaderContext)({
        url: url,
        parse: $a0c36a44ecfd763d$export$98e6a39c04603d36,
        loaders: candidateLoaders
    }, options, context);
    return await $a0c36a44ecfd763d$var$parseWithLoader(loader, data, options, context);
}
async function $a0c36a44ecfd763d$var$parseWithLoader(loader, data, options, context) {
    (0, $jzxj2.validateWorkerVersion)(loader);
    data = await (0, $8c4WA.getArrayBufferOrStringFromData)(data, loader, options);
    if (loader.parseTextSync && typeof data === "string") {
        options.dataType = "text";
        return loader.parseTextSync(data, options, context, loader);
    }
    if ((0, $eZcKF.canParseWithWorker)(loader, options)) return await (0, $eZcKF.parseWithWorker)(loader, data, options, context, $a0c36a44ecfd763d$export$98e6a39c04603d36);
    if (loader.parseText && typeof data === "string") return await loader.parseText(data, options, context, loader);
    if (loader.parse) return await loader.parse(data, options, context, loader);
    (0, $4knIj.assert)(!loader.parseSync);
    throw new Error(`${loader.id} loader - no parser found and worker is disabled`);
}

});
parcelRegister("4knIj", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $326b6cb7998e5361$export$a7a9523472993e97; });
function $326b6cb7998e5361$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "loaders.gl assertion failed.");
}

});

parcelRegister("jzxj2", function(module, exports) {

$parcel$export(module.exports, "validateWorkerVersion", function () { return $e3fb1f189bd07783$export$95e2ee179a5692d5; });

var $4knIj = parcelRequire("4knIj");

var $fHbuA = parcelRequire("fHbuA");
function $e3fb1f189bd07783$export$95e2ee179a5692d5(worker, coreVersion = (0, $fHbuA.VERSION)) {
    (0, $4knIj.assert)(worker, "no worker provided");
    const workerVersion = worker.version;
    if (!coreVersion || !workerVersion) return false;
    return true;
}
function $e3fb1f189bd07783$var$parseVersion(version) {
    const parts = version.split(".").map(Number);
    return {
        major: parts[0],
        minor: parts[1]
    };
}

});
parcelRegister("fHbuA", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $b6d3c94ce2d3655e$export$a4ad2735b021c132; });
const $b6d3c94ce2d3655e$var$DEFAULT_VERSION = "beta";
const $b6d3c94ce2d3655e$export$a4ad2735b021c132 = "3.1.0-alpha.4";

});


parcelRegister("eZcKF", function(module, exports) {

$parcel$export(module.exports, "canParseWithWorker", function () { return $ae90a76eaa49bbee$export$d28453530d9dde76; });
$parcel$export(module.exports, "parseWithWorker", function () { return $ae90a76eaa49bbee$export$5fc1ede2a33af3b1; });

var $hSD1w = parcelRequire("hSD1w");
var $4shBS = parcelRequire("4shBS");
function $ae90a76eaa49bbee$export$d28453530d9dde76(loader, options) {
    if (!(0, $4shBS.default).isSupported()) return false;
    return loader.worker && (options === null || options === void 0 ? void 0 : options.worker);
}
async function $ae90a76eaa49bbee$export$5fc1ede2a33af3b1(loader, data, options, context, parseOnMainThread) {
    const name = loader.id;
    const url = (0, $hSD1w.getWorkerURL)(loader, options);
    const workerFarm = (0, $4shBS.default).getWorkerFarm(options);
    const workerPool = workerFarm.getWorkerPool({
        name: name,
        url: url
    });
    options = JSON.parse(JSON.stringify(options));
    const job = await workerPool.startJob("process-on-worker", $ae90a76eaa49bbee$var$onMessage.bind(null, parseOnMainThread));
    job.postMessage("process", {
        input: data,
        options: options
    });
    const result = await job.result;
    return await result.result;
}
async function $ae90a76eaa49bbee$var$onMessage(parseOnMainThread, job, type, payload) {
    switch(type){
        case "done":
            job.done(payload);
            break;
        case "error":
            job.error(payload.error);
            break;
        case "process":
            const { id: id, input: input, options: options } = payload;
            try {
                const result = await parseOnMainThread(input, options);
                job.postMessage("done", {
                    id: id,
                    result: result
                });
            } catch (error) {
                const message = error instanceof Error ? error.message : "unknown error";
                job.postMessage("error", {
                    id: id,
                    error: message
                });
            }
            break;
        default:
            console.warn(`parse-with-worker unknown message ${type}`);
    }
}

});
parcelRegister("hSD1w", function(module, exports) {

$parcel$export(module.exports, "getWorkerURL", function () { return $d045c01391b473fb$export$959914ac3383a118; });

var $4knIj = parcelRequire("4knIj");

const $d045c01391b473fb$var$NPM_TAG = "beta";
const $d045c01391b473fb$var$VERSION = "3.1.0-alpha.4";
function $d045c01391b473fb$export$72db835c4de3b02e(worker) {
    const warning = worker.version !== $d045c01391b473fb$var$VERSION ? ` (worker-utils@${$d045c01391b473fb$var$VERSION})` : "";
    return `${worker.name}@${worker.version}${warning}`;
}
function $d045c01391b473fb$export$959914ac3383a118(worker, options = {}) {
    const workerOptions = options[worker.id] || {};
    const workerFile = `${worker.id}-worker.js`;
    let url = workerOptions.workerUrl;
    if (options._workerType === "test") url = `modules/${worker.module}/dist/${workerFile}`;
    if (!url) {
        let version = worker.version;
        if (version === "latest") version = $d045c01391b473fb$var$NPM_TAG;
        const versionTag = version ? `@${version}` : "";
        url = `https://unpkg.com/@loaders.gl/${worker.module}${versionTag}/dist/${workerFile}`;
    }
    (0, $4knIj.assert)(url);
    return url;
}

});

parcelRegister("4shBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33e76fe81fecd943$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1F5uH = parcelRequire("1F5uH");

var $d3BJj = parcelRequire("d3BJj");

var $fc8VP = parcelRequire("fc8VP");
const $33e76fe81fecd943$var$DEFAULT_PROPS = {
    maxConcurrency: 3,
    maxMobileConcurrency: 1,
    onDebug: ()=>{},
    reuseWorkers: true
};
class $33e76fe81fecd943$export$2e2bcd8739ae039 {
    static isSupported() {
        return (0, $fc8VP.default).isSupported();
    }
    static getWorkerFarm(props = {}) {
        $33e76fe81fecd943$export$2e2bcd8739ae039._workerFarm = $33e76fe81fecd943$export$2e2bcd8739ae039._workerFarm || new $33e76fe81fecd943$export$2e2bcd8739ae039({});
        $33e76fe81fecd943$export$2e2bcd8739ae039._workerFarm.setProps(props);
        return $33e76fe81fecd943$export$2e2bcd8739ae039._workerFarm;
    }
    destroy() {
        for (const workerPool of this.workerPools.values())workerPool.destroy();
    }
    setProps(props) {
        this.props = (0, $2QP2i._)({}, this.props, props);
        for (const workerPool of this.workerPools.values())workerPool.setProps(this._getWorkerPoolProps());
    }
    getWorkerPool(options) {
        const { name: name, source: source, url: url } = options;
        let workerPool = this.workerPools.get(name);
        if (!workerPool) {
            workerPool = new (0, $d3BJj.default)({
                name: name,
                source: source,
                url: url
            });
            workerPool.setProps(this._getWorkerPoolProps());
            this.workerPools.set(name, workerPool);
        }
        return workerPool;
    }
    _getWorkerPoolProps() {
        return {
            maxConcurrency: this.props.maxConcurrency,
            maxMobileConcurrency: this.props.maxMobileConcurrency,
            reuseWorkers: this.props.reuseWorkers,
            onDebug: this.props.onDebug
        };
    }
    constructor(props){
        (0, $1F5uH.default)(this, "props", void 0);
        (0, $1F5uH.default)(this, "workerPools", new Map());
        this.props = (0, $2QP2i._)({}, $33e76fe81fecd943$var$DEFAULT_PROPS);
        this.setProps(props);
        this.workerPools = new Map();
    }
}
(0, $1F5uH.default)($33e76fe81fecd943$export$2e2bcd8739ae039, "_workerFarm", void 0);

});
parcelRegister("d3BJj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9818d28f3ed44e4d$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $1F5uH = parcelRequire("1F5uH");

var $gWMc6 = parcelRequire("gWMc6");

var $fc8VP = parcelRequire("fc8VP");

var $gDL4a = parcelRequire("gDL4a");
class $9818d28f3ed44e4d$export$2e2bcd8739ae039 {
    destroy() {
        this.idleQueue.forEach((worker)=>worker.destroy());
        this.isDestroyed = true;
    }
    setProps(props) {
        this.props = (0, $2QP2i._)({}, this.props, props);
        if (props.name !== undefined) this.name = props.name;
        if (props.maxConcurrency !== undefined) this.maxConcurrency = props.maxConcurrency;
        if (props.maxMobileConcurrency !== undefined) this.maxMobileConcurrency = props.maxMobileConcurrency;
        if (props.reuseWorkers !== undefined) this.reuseWorkers = props.reuseWorkers;
        if (props.onDebug !== undefined) this.onDebug = props.onDebug;
    }
    async startJob(name, onMessage = (job, type, data)=>job.done(data), onError = (job, error)=>job.error(error)) {
        const startPromise = new Promise((onStart)=>{
            this.jobQueue.push({
                name: name,
                onMessage: onMessage,
                onError: onError,
                onStart: onStart
            });
            return this;
        });
        this._startQueuedJob();
        return await startPromise;
    }
    async _startQueuedJob() {
        if (!this.jobQueue.length) return;
        const workerThread = this._getAvailableWorker();
        if (!workerThread) return;
        const queuedJob = this.jobQueue.shift();
        if (queuedJob) {
            this.onDebug({
                message: "Starting job",
                name: queuedJob.name,
                workerThread: workerThread,
                backlog: this.jobQueue.length
            });
            const job = new (0, $gDL4a.default)(queuedJob.name, workerThread);
            workerThread.onMessage = (data)=>queuedJob.onMessage(job, data.type, data.payload);
            workerThread.onError = (error)=>queuedJob.onError(job, error);
            queuedJob.onStart(job);
            try {
                await job.result;
            } finally{
                this.returnWorkerToQueue(workerThread);
            }
        }
    }
    returnWorkerToQueue(worker) {
        const shouldDestroyWorker = this.isDestroyed || !this.reuseWorkers || this.count > this._getMaxConcurrency();
        if (shouldDestroyWorker) {
            worker.destroy();
            this.count--;
        } else this.idleQueue.push(worker);
        if (!this.isDestroyed) this._startQueuedJob();
    }
    _getAvailableWorker() {
        if (this.idleQueue.length > 0) return this.idleQueue.shift() || null;
        if (this.count < this._getMaxConcurrency()) {
            this.count++;
            const name = `${this.name.toLowerCase()} (#${this.count} of ${this.maxConcurrency})`;
            return new (0, $fc8VP.default)({
                name: name,
                source: this.source,
                url: this.url
            });
        }
        return null;
    }
    _getMaxConcurrency() {
        return (0, $gWMc6.isMobile) ? this.maxMobileConcurrency : this.maxConcurrency;
    }
    constructor(props){
        (0, $1F5uH.default)(this, "name", "unnamed");
        (0, $1F5uH.default)(this, "source", void 0);
        (0, $1F5uH.default)(this, "url", void 0);
        (0, $1F5uH.default)(this, "maxConcurrency", 1);
        (0, $1F5uH.default)(this, "maxMobileConcurrency", 1);
        (0, $1F5uH.default)(this, "onDebug", ()=>{});
        (0, $1F5uH.default)(this, "reuseWorkers", true);
        (0, $1F5uH.default)(this, "props", {});
        (0, $1F5uH.default)(this, "jobQueue", []);
        (0, $1F5uH.default)(this, "idleQueue", []);
        (0, $1F5uH.default)(this, "count", 0);
        (0, $1F5uH.default)(this, "isDestroyed", false);
        this.source = props.source;
        this.url = props.url;
        this.setProps(props);
    }
}

});
parcelRegister("gWMc6", function(module, exports) {

$parcel$export(module.exports, "isMobile", function () { return $c56772821db9c297$export$d0a8044dce8ff2fc; });

var $95Bnk = parcelRequire("95Bnk");
const $c56772821db9c297$var$globals = {
    self: typeof self !== "undefined" && self,
    window: typeof window !== "undefined" && window,
    global: typeof $parcel$global !== "undefined" && $parcel$global,
    document: typeof document !== "undefined" && document
};
const $c56772821db9c297$export$82c2e460fb230c2a = $c56772821db9c297$var$globals.self || $c56772821db9c297$var$globals.window || $c56772821db9c297$var$globals.global || {};
const $c56772821db9c297$export$8291e5b88f90ce4 = $c56772821db9c297$var$globals.window || $c56772821db9c297$var$globals.self || $c56772821db9c297$var$globals.global || {};
const $c56772821db9c297$export$90b4d2ff6acb88af = $c56772821db9c297$var$globals.global || $c56772821db9c297$var$globals.self || $c56772821db9c297$var$globals.window || {};
const $c56772821db9c297$export$5a7bfc01df82fcd1 = $c56772821db9c297$var$globals.document || {};
const $c56772821db9c297$export$4e09c449d6c407f7 = typeof $95Bnk !== "object" || String($95Bnk) !== "[object process]" || true;
const $c56772821db9c297$export$3c901a5f01941a06 = typeof importScripts === "function";
const $c56772821db9c297$export$d0a8044dce8ff2fc = typeof window !== "undefined" && typeof window.orientation !== "undefined";
const $c56772821db9c297$var$matches = typeof $95Bnk !== "undefined" && $95Bnk.version && /v([0-9]*)/.exec($95Bnk.version);
const $c56772821db9c297$export$168db21d314844a8 = $c56772821db9c297$var$matches && parseFloat($c56772821db9c297$var$matches[1]) || 0;

});

parcelRegister("fc8VP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0fee7acd17b8ba1$export$2e2bcd8739ae039; });

var $1F5uH = parcelRequire("1F5uH");

var $4knIj = parcelRequire("4knIj");

var $fNd67 = parcelRequire("fNd67");

var $eHZ5m = parcelRequire("eHZ5m");
const $b0fee7acd17b8ba1$var$NOOP = ()=>{};
class $b0fee7acd17b8ba1$export$2e2bcd8739ae039 {
    static isSupported() {
        return typeof Worker !== "undefined";
    }
    destroy() {
        this.onMessage = $b0fee7acd17b8ba1$var$NOOP;
        this.onError = $b0fee7acd17b8ba1$var$NOOP;
        this.worker.terminate();
        this.terminated = true;
    }
    get isRunning() {
        return Boolean(this.onMessage);
    }
    postMessage(data, transferList) {
        transferList = transferList || (0, $eHZ5m.getTransferList)(data);
        this.worker.postMessage(data, transferList);
    }
    _getErrorFromErrorEvent(event) {
        let message = "Failed to load ";
        message += `worker ${this.name} from ${this.url}. `;
        if (event.message) message += `${event.message} in `;
        if (event.lineno) message += `:${event.lineno}:${event.colno}`;
        return new Error(message);
    }
    _createBrowserWorker() {
        this._loadableURL = (0, $fNd67.getLoadableWorkerURL)({
            source: this.source,
            url: this.url
        });
        const worker = new Worker(this._loadableURL, {
            name: this.name
        });
        worker.onmessage = (event)=>{
            if (!event.data) this.onError(new Error("No data received"));
            else this.onMessage(event.data);
        };
        worker.onerror = (error)=>{
            this.onError(this._getErrorFromErrorEvent(error));
            this.terminated = true;
        };
        worker.onmessageerror = (event)=>console.error(event);
        return worker;
    }
    constructor(props){
        (0, $1F5uH.default)(this, "name", void 0);
        (0, $1F5uH.default)(this, "source", void 0);
        (0, $1F5uH.default)(this, "url", void 0);
        (0, $1F5uH.default)(this, "terminated", false);
        (0, $1F5uH.default)(this, "worker", void 0);
        (0, $1F5uH.default)(this, "onMessage", void 0);
        (0, $1F5uH.default)(this, "onError", void 0);
        (0, $1F5uH.default)(this, "_loadableURL", "");
        const { name: name, source: source, url: url } = props;
        (0, $4knIj.assert)(source || url);
        this.name = name;
        this.source = source;
        this.url = url;
        this.onMessage = $b0fee7acd17b8ba1$var$NOOP;
        this.onError = (error)=>console.log(error);
        this.worker = this._createBrowserWorker();
    }
}

});
parcelRegister("fNd67", function(module, exports) {

$parcel$export(module.exports, "getLoadableWorkerURL", function () { return $b7f59791a28ec5c9$export$fb15ef3d6a383f22; });

var $4knIj = parcelRequire("4knIj");
const $b7f59791a28ec5c9$var$workerURLCache = new Map();
function $b7f59791a28ec5c9$export$fb15ef3d6a383f22(props) {
    (0, $4knIj.assert)(props.source && !props.url || !props.source && props.url);
    let workerURL = $b7f59791a28ec5c9$var$workerURLCache.get(props.source || props.url);
    if (!workerURL) {
        if (props.url) {
            workerURL = $b7f59791a28ec5c9$var$getLoadableWorkerURLFromURL(props.url);
            $b7f59791a28ec5c9$var$workerURLCache.set(props.url, workerURL);
        }
        if (props.source) {
            workerURL = $b7f59791a28ec5c9$var$getLoadableWorkerURLFromSource(props.source);
            $b7f59791a28ec5c9$var$workerURLCache.set(props.source, workerURL);
        }
    }
    (0, $4knIj.assert)(workerURL);
    return workerURL;
}
function $b7f59791a28ec5c9$var$getLoadableWorkerURLFromURL(url) {
    if (!url.startsWith("http")) return url;
    const workerSource = $b7f59791a28ec5c9$var$buildScriptSource(url);
    return $b7f59791a28ec5c9$var$getLoadableWorkerURLFromSource(workerSource);
}
function $b7f59791a28ec5c9$var$getLoadableWorkerURLFromSource(workerSource) {
    const blob = new Blob([
        workerSource
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(blob);
}
function $b7f59791a28ec5c9$var$buildScriptSource(workerUrl) {
    return `\
try {
  importScripts('${workerUrl}');
} catch (error) {
  console.error(error);
  throw error;
}`;
}

});

parcelRegister("eHZ5m", function(module, exports) {

$parcel$export(module.exports, "getTransferList", function () { return $ab54772494f18c38$export$6464150b0a96b310; });
function $ab54772494f18c38$export$6464150b0a96b310(object, recursive = true, transfers) {
    const transfersSet = transfers || new Set();
    if (!object) ;
    else if ($ab54772494f18c38$var$isTransferable(object)) transfersSet.add(object);
    else if ($ab54772494f18c38$var$isTransferable(object.buffer)) transfersSet.add(object.buffer);
    else if (ArrayBuffer.isView(object)) ;
    else if (recursive && typeof object === "object") for(const key in object)$ab54772494f18c38$export$6464150b0a96b310(object[key], recursive, transfersSet);
    return transfers === undefined ? Array.from(transfersSet) : [];
}
function $ab54772494f18c38$var$isTransferable(object) {
    if (!object) return false;
    if (object instanceof ArrayBuffer) return true;
    if (typeof MessagePort !== "undefined" && object instanceof MessagePort) return true;
    if (typeof ImageBitmap !== "undefined" && object instanceof ImageBitmap) return true;
    if (typeof OffscreenCanvas !== "undefined" && object instanceof OffscreenCanvas) return true;
    return false;
}

});


parcelRegister("gDL4a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1d4cc3c34e56460$export$2e2bcd8739ae039; });

var $1F5uH = parcelRequire("1F5uH");

var $4knIj = parcelRequire("4knIj");
class $c1d4cc3c34e56460$export$2e2bcd8739ae039 {
    postMessage(type, payload) {
        this.workerThread.postMessage({
            source: "loaders.gl",
            type: type,
            payload: payload
        });
    }
    done(value) {
        (0, $4knIj.assert)(this.isRunning);
        this.isRunning = false;
        this._resolve(value);
    }
    error(error) {
        (0, $4knIj.assert)(this.isRunning);
        this.isRunning = false;
        this._reject(error);
    }
    constructor(jobName, workerThread){
        (0, $1F5uH.default)(this, "name", void 0);
        (0, $1F5uH.default)(this, "workerThread", void 0);
        (0, $1F5uH.default)(this, "isRunning", void 0);
        (0, $1F5uH.default)(this, "result", void 0);
        (0, $1F5uH.default)(this, "_resolve", void 0);
        (0, $1F5uH.default)(this, "_reject", void 0);
        this.name = jobName;
        this.workerThread = workerThread;
        this.isRunning = true;
        this._resolve = ()=>{};
        this._reject = ()=>{};
        this.result = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
}

});




parcelRegister("8c4WA", function(module, exports) {

$parcel$export(module.exports, "getArrayBufferOrStringFromData", function () { return $5f734777b7e3b2b2$export$8f911a3af008501e; });

var $4cPcI = parcelRequire("4cPcI");

var $e1wxv = parcelRequire("e1wxv");

var $gG5Rn = parcelRequire("gG5Rn");

var $dadEq = parcelRequire("dadEq");
const $5f734777b7e3b2b2$var$ERR_DATA = "Cannot convert supplied data type";
function $5f734777b7e3b2b2$export$1bdaa95e029beec8(data, loader, options) {
    if (loader.text && typeof data === "string") return data;
    if ((0, $e1wxv.isBuffer)(data)) data = data.buffer;
    if (data instanceof ArrayBuffer) {
        const arrayBuffer = data;
        if (loader.text && !loader.binary) {
            const textDecoder = new TextDecoder("utf8");
            return textDecoder.decode(arrayBuffer);
        }
        return arrayBuffer;
    }
    if (ArrayBuffer.isView(data)) {
        if (loader.text && !loader.binary) {
            const textDecoder = new TextDecoder("utf8");
            return textDecoder.decode(data);
        }
        let arrayBuffer = data.buffer;
        const byteLength = data.byteLength || data.length;
        if (data.byteOffset !== 0 || byteLength !== arrayBuffer.byteLength) arrayBuffer = arrayBuffer.slice(data.byteOffset, data.byteOffset + byteLength);
        return arrayBuffer;
    }
    throw new Error($5f734777b7e3b2b2$var$ERR_DATA);
}
async function $5f734777b7e3b2b2$export$8f911a3af008501e(data, loader, options) {
    const isArrayBuffer = data instanceof ArrayBuffer || ArrayBuffer.isView(data);
    if (typeof data === "string" || isArrayBuffer) return $5f734777b7e3b2b2$export$1bdaa95e029beec8(data, loader, options);
    if ((0, $e1wxv.isBlob)(data)) data = await (0, $dadEq.makeResponse)(data);
    if ((0, $e1wxv.isResponse)(data)) {
        const response = data;
        await (0, $dadEq.checkResponse)(response);
        return loader.binary ? await response.arrayBuffer() : await response.text();
    }
    if ((0, $e1wxv.isReadableStream)(data)) data = (0, $gG5Rn.makeIterator)(data, options);
    if ((0, $e1wxv.isIterable)(data) || (0, $e1wxv.isAsyncIterable)(data)) return (0, $4cPcI.concatenateArrayBuffersAsync)(data);
    throw new Error($5f734777b7e3b2b2$var$ERR_DATA);
}
async function $5f734777b7e3b2b2$export$439b9c71d78e9e91(data, options) {
    if ((0, $e1wxv.isIterator)(data)) return data;
    if ((0, $e1wxv.isResponse)(data)) {
        const response = data;
        await (0, $dadEq.checkResponse)(response);
        const body = await response.body;
        return (0, $gG5Rn.makeIterator)(body, options);
    }
    if ((0, $e1wxv.isBlob)(data) || (0, $e1wxv.isReadableStream)(data)) return (0, $gG5Rn.makeIterator)(data, options);
    if ((0, $e1wxv.isAsyncIterable)(data)) return data[Symbol.asyncIterator]();
    return $5f734777b7e3b2b2$var$getIterableFromData(data);
}
async function $5f734777b7e3b2b2$export$fcaec59c9cf8d502(data) {
    if ((0, $e1wxv.isReadableStream)(data)) return data;
    if ((0, $e1wxv.isResponse)(data)) return data.body;
    const response = await (0, $dadEq.makeResponse)(data);
    return response.body;
}
function $5f734777b7e3b2b2$var$getIterableFromData(data) {
    if (ArrayBuffer.isView(data)) return function* oneChunk() {
        yield data.buffer;
    }();
    if (data instanceof ArrayBuffer) return function* oneChunk() {
        yield data;
    }();
    if ((0, $e1wxv.isIterator)(data)) return data;
    if ((0, $e1wxv.isIterable)(data)) return data[Symbol.iterator]();
    throw new Error($5f734777b7e3b2b2$var$ERR_DATA);
}

});
parcelRegister("4cPcI", function(module, exports) {

$parcel$export(module.exports, "concatenateArrayBuffersAsync", function () { return $310000745b13889a$export$b56e0390cdc1b1ca; });

var $fG4p0 = parcelRequire("fG4p0");
async function $310000745b13889a$export$4b80e395e36b5a56(iterator, visitor) {
    while(true){
        const { done: done, value: value } = await iterator.next();
        if (done) {
            iterator.return();
            return;
        }
        const cancel = visitor(value);
        if (cancel) return;
    }
}
async function $310000745b13889a$export$b56e0390cdc1b1ca(asyncIterator) {
    const arrayBuffers = [];
    for await (const chunk of asyncIterator)arrayBuffers.push(chunk);
    return (0, $fG4p0.concatenateArrayBuffers)(...arrayBuffers);
}
async function $310000745b13889a$export$8a08e0b4be2e1c13(asyncIterator) {
    const strings = [];
    for await (const chunk of asyncIterator)strings.push(chunk);
    return strings.join("");
}

});
parcelRegister("fG4p0", function(module, exports) {

$parcel$export(module.exports, "toArrayBuffer", function () { return $b69e317688ecdfb1$export$8b22b05f429b130c; });
$parcel$export(module.exports, "compareArrayBuffers", function () { return $b69e317688ecdfb1$export$a21c1249ab709443; });
$parcel$export(module.exports, "concatenateArrayBuffers", function () { return $b69e317688ecdfb1$export$9a3e9c78eb778da8; });

var $aFb0J = parcelRequire("aFb0J");
function $b69e317688ecdfb1$export$8b22b05f429b130c(data) {
    if ((0, $aFb0J.isBuffer)(data)) return (0, $aFb0J.bufferToArrayBuffer)(data);
    if (data instanceof ArrayBuffer) return data;
    if (ArrayBuffer.isView(data)) {
        if (data.byteOffset === 0 && data.byteLength === data.buffer.byteLength) return data.buffer;
        return data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength);
    }
    if (typeof data === "string") {
        const text = data;
        const uint8Array = new TextEncoder().encode(text);
        return uint8Array.buffer;
    }
    if (data && typeof data === "object" && data._toArrayBuffer) return data._toArrayBuffer();
    throw new Error("toArrayBuffer");
}
function $b69e317688ecdfb1$export$a21c1249ab709443(arrayBuffer1, arrayBuffer2, byteLength) {
    byteLength = byteLength || arrayBuffer1.byteLength;
    if (arrayBuffer1.byteLength < byteLength || arrayBuffer2.byteLength < byteLength) return false;
    const array1 = new Uint8Array(arrayBuffer1);
    const array2 = new Uint8Array(arrayBuffer2);
    for(let i = 0; i < array1.length; ++i){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
function $b69e317688ecdfb1$export$9a3e9c78eb778da8(...sources) {
    const sourceArrays = sources.map((source2)=>source2 instanceof ArrayBuffer ? new Uint8Array(source2) : source2);
    const byteLength = sourceArrays.reduce((length, typedArray)=>length + typedArray.byteLength, 0);
    const result = new Uint8Array(byteLength);
    let offset = 0;
    for (const sourceArray of sourceArrays){
        result.set(sourceArray, offset);
        offset += sourceArray.byteLength;
    }
    return result.buffer;
}
function $b69e317688ecdfb1$export$b9f790e5e2031778(...typedArrays) {
    const arrays = typedArrays;
    const TypedArrayConstructor = arrays && arrays.length > 1 && arrays[0].constructor || null;
    if (!TypedArrayConstructor) throw new Error('"concatenateTypedArrays" - incorrect quantity of arguments or arguments have incompatible data types');
    const sumLength = arrays.reduce((acc, value)=>acc + value.length, 0);
    const result = new TypedArrayConstructor(sumLength);
    let offset = 0;
    for (const array of arrays){
        result.set(array, offset);
        offset += array.length;
    }
    return result;
}
function $b69e317688ecdfb1$export$1c6babfc8b593386(arrayBuffer, byteOffset, byteLength) {
    const subArray = byteLength !== undefined ? new Uint8Array(arrayBuffer).subarray(byteOffset, byteOffset + byteLength) : new Uint8Array(arrayBuffer).subarray(byteOffset);
    const arrayCopy = new Uint8Array(subArray);
    return arrayCopy.buffer;
}

});
parcelRegister("aFb0J", function(module, exports) {

$parcel$export(module.exports, "isBuffer", function () { return $0200e019cd059283$export$a7884ebc965f8f54; });
$parcel$export(module.exports, "bufferToArrayBuffer", function () { return $0200e019cd059283$export$1a478f4dd664a01f; });

var $5tWFo = parcelRequire("5tWFo");
function $0200e019cd059283$export$a7884ebc965f8f54(value) {
    return value && typeof value === "object" && value.isBuffer;
}
function $0200e019cd059283$export$fc336dbfaf62f18f(data) {
    return $5tWFo.toBuffer ? $5tWFo.toBuffer(data) : data;
}
function $0200e019cd059283$export$1a478f4dd664a01f(buffer) {
    if ($0200e019cd059283$export$a7884ebc965f8f54(buffer)) {
        const typedArray = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.length);
        return typedArray.slice().buffer;
    }
    return buffer;
}

});



parcelRegister("gG5Rn", function(module, exports) {

$parcel$export(module.exports, "makeIterator", function () { return $c2451d3bf8665ce8$export$81c40ebfe660d3ca; });

var $4S9mD = parcelRequire("4S9mD");

var $lJdwb = parcelRequire("lJdwb");

var $5TZKQ = parcelRequire("5TZKQ");

var $34TQj = parcelRequire("34TQj");

var $e1wxv = parcelRequire("e1wxv");
function $c2451d3bf8665ce8$export$81c40ebfe660d3ca(data, options) {
    if (typeof data === "string") return (0, $4S9mD.makeStringIterator)(data, options);
    if (data instanceof ArrayBuffer) return (0, $lJdwb.makeArrayBufferIterator)(data, options);
    if ((0, $e1wxv.isBlob)(data)) return (0, $5TZKQ.makeBlobIterator)(data, options);
    if ((0, $e1wxv.isReadableStream)(data)) return (0, $34TQj.makeStreamIterator)(data, options);
    if ((0, $e1wxv.isResponse)(data)) {
        const response = data;
        return (0, $34TQj.makeStreamIterator)(response.body, options);
    }
    throw new Error("makeIterator");
}

});
parcelRegister("4S9mD", function(module, exports) {

$parcel$export(module.exports, "makeStringIterator", function () { return $38c37819c1c2be14$export$c51500126ec60dd4; });
const $38c37819c1c2be14$var$DEFAULT_CHUNK_SIZE = 262144;
function* $38c37819c1c2be14$export$c51500126ec60dd4(string, options) {
    const chunkSize = (options === null || options === void 0 ? void 0 : options.chunkSize) || $38c37819c1c2be14$var$DEFAULT_CHUNK_SIZE;
    let offset = 0;
    const textEncoder = new TextEncoder();
    while(offset < string.length){
        const chunkLength = Math.min(string.length - offset, chunkSize);
        const chunk = string.slice(offset, offset + chunkLength);
        offset += chunkLength;
        yield textEncoder.encode(chunk);
    }
}

});

parcelRegister("lJdwb", function(module, exports) {

$parcel$export(module.exports, "makeArrayBufferIterator", function () { return $fd18495c415b4159$export$257e4501e13446d3; });
const $fd18495c415b4159$var$DEFAULT_CHUNK_SIZE = 262144;
function* $fd18495c415b4159$export$257e4501e13446d3(arrayBuffer, options = {}) {
    const { chunkSize: chunkSize = $fd18495c415b4159$var$DEFAULT_CHUNK_SIZE } = options;
    let byteOffset = 0;
    while(byteOffset < arrayBuffer.byteLength){
        const chunkByteLength = Math.min(arrayBuffer.byteLength - byteOffset, chunkSize);
        const chunk = new ArrayBuffer(chunkByteLength);
        const sourceArray = new Uint8Array(arrayBuffer, byteOffset, chunkByteLength);
        const chunkArray = new Uint8Array(chunk);
        chunkArray.set(sourceArray);
        byteOffset += chunkByteLength;
        yield chunk;
    }
}

});

parcelRegister("5TZKQ", function(module, exports) {

$parcel$export(module.exports, "makeBlobIterator", function () { return $44c1fdfd3b98fdd3$export$97cfd032a0f445d2; });
const $44c1fdfd3b98fdd3$var$DEFAULT_CHUNK_SIZE = 1048576;
async function* $44c1fdfd3b98fdd3$export$97cfd032a0f445d2(blob, options) {
    const chunkSize = (options === null || options === void 0 ? void 0 : options.chunkSize) || $44c1fdfd3b98fdd3$var$DEFAULT_CHUNK_SIZE;
    let offset = 0;
    while(offset < blob.size){
        const end = offset + chunkSize;
        const chunk = await blob.slice(offset, end).arrayBuffer();
        offset = end;
        yield chunk;
    }
}

});

parcelRegister("34TQj", function(module, exports) {

$parcel$export(module.exports, "makeStreamIterator", function () { return $23dd1009e1ce72a2$export$80460602c027534f; });

var $8Iogt = parcelRequire("8Iogt");
var $fG4p0 = parcelRequire("fG4p0");
function $23dd1009e1ce72a2$export$80460602c027534f(stream, options) {
    return (0, $8Iogt.isBrowser) ? $23dd1009e1ce72a2$var$makeBrowserStreamIterator(stream, options) : $23dd1009e1ce72a2$var$makeNodeStreamIterator(stream, options);
}
async function* $23dd1009e1ce72a2$var$makeBrowserStreamIterator(stream, options) {
    const reader = stream.getReader();
    let nextBatchPromise;
    try {
        while(true){
            const currentBatchPromise = nextBatchPromise || reader.read();
            if (options !== null && options !== void 0 && options._streamReadAhead) nextBatchPromise = reader.read();
            const { done: done, value: value } = await currentBatchPromise;
            if (done) return;
            yield (0, $fG4p0.toArrayBuffer)(value);
        }
    } catch (error) {
        reader.releaseLock();
    }
}
async function* $23dd1009e1ce72a2$var$makeNodeStreamIterator(stream, options) {
    for await (const chunk of stream)yield (0, $fG4p0.toArrayBuffer)(chunk);
}

});
parcelRegister("8Iogt", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $65854146007758e4$export$4e09c449d6c407f7; });

var $95Bnk = parcelRequire("95Bnk");
const $65854146007758e4$var$globals = {
    self: typeof self !== "undefined" && self,
    window: typeof window !== "undefined" && window,
    global: typeof $parcel$global !== "undefined" && $parcel$global,
    document: typeof document !== "undefined" && document
};
const $65854146007758e4$export$82c2e460fb230c2a = $65854146007758e4$var$globals.self || $65854146007758e4$var$globals.window || $65854146007758e4$var$globals.global || {};
const $65854146007758e4$export$8291e5b88f90ce4 = $65854146007758e4$var$globals.window || $65854146007758e4$var$globals.self || $65854146007758e4$var$globals.global || {};
const $65854146007758e4$export$90b4d2ff6acb88af = $65854146007758e4$var$globals.global || $65854146007758e4$var$globals.self || $65854146007758e4$var$globals.window || {};
const $65854146007758e4$export$5a7bfc01df82fcd1 = $65854146007758e4$var$globals.document || {};
const $65854146007758e4$export$4e09c449d6c407f7 = Boolean(typeof $95Bnk !== "object" || String($95Bnk) !== "[object process]" || true);
const $65854146007758e4$export$3c901a5f01941a06 = typeof importScripts === "function";
const $65854146007758e4$var$matches = typeof $95Bnk !== "undefined" && $95Bnk.version && /v([0-9]*)/.exec($95Bnk.version);
const $65854146007758e4$export$168db21d314844a8 = $65854146007758e4$var$matches && parseFloat($65854146007758e4$var$matches[1]) || 0;

});




parcelRegister("nVzgc", function(module, exports) {

$parcel$export(module.exports, "getLoaderContext", function () { return $047ecdd8a4c5ec07$export$c9fdcdb31d4bf289; });
$parcel$export(module.exports, "getLoadersFromContext", function () { return $047ecdd8a4c5ec07$export$f7bef68ca326d506; });

var $2QP2i = parcelRequire("2QP2i");

var $bT4Nz = parcelRequire("bT4Nz");
function $047ecdd8a4c5ec07$export$c9fdcdb31d4bf289(context, options, previousContext = null) {
    if (previousContext) return previousContext;
    const resolvedContext = (0, $2QP2i._)({
        fetch: (0, $bT4Nz.getFetchFunction)(options, context)
    }, context);
    if (!Array.isArray(resolvedContext.loaders)) resolvedContext.loaders = null;
    return resolvedContext;
}
function $047ecdd8a4c5ec07$export$f7bef68ca326d506(loaders, context) {
    if (!context && loaders && !Array.isArray(loaders)) return loaders;
    let candidateLoaders;
    if (loaders) candidateLoaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    if (context && context.loaders) {
        const contextLoaders = Array.isArray(context.loaders) ? context.loaders : [
            context.loaders
        ];
        candidateLoaders = candidateLoaders ? [
            ...candidateLoaders,
            ...contextLoaders
        ] : contextLoaders;
    }
    return candidateLoaders && candidateLoaders.length ? candidateLoaders : null;
}

});

parcelRegister("h45pu", function(module, exports) {

$parcel$export(module.exports, "selectLoader", function () { return $c6c701b825ea89d0$export$c633f22f376a9a73; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $fG4p0 = parcelRequire("fG4p0");
var $7peSl = parcelRequire("7peSl");

var $ejAXt = parcelRequire("ejAXt");

var $5Tper = parcelRequire("5Tper");

var $aZt53 = parcelRequire("aZt53");

var $e1wxv = parcelRequire("e1wxv");
const $c6c701b825ea89d0$var$EXT_PATTERN = /\.([^.]+)$/;
async function $c6c701b825ea89d0$export$c633f22f376a9a73(data, loaders = [], options, context) {
    if (!$c6c701b825ea89d0$var$validHTTPResponse(data)) return null;
    let loader = $c6c701b825ea89d0$export$27c49426aa5beb44(data, loaders, (0, $edHbI._)((0, $2QP2i._)({}, options), {
        nothrow: true
    }), context);
    if (loader) return loader;
    if ((0, $e1wxv.isBlob)(data)) {
        data = await data.slice(0, 10).arrayBuffer();
        loader = $c6c701b825ea89d0$export$27c49426aa5beb44(data, loaders, options, context);
    }
    if (!loader && !(options !== null && options !== void 0 && options.nothrow)) throw new Error($c6c701b825ea89d0$var$getNoValidLoaderMessage(data));
    return loader;
}
function $c6c701b825ea89d0$export$27c49426aa5beb44(data, loaders = [], options, context) {
    if (!$c6c701b825ea89d0$var$validHTTPResponse(data)) return null;
    if (loaders && !Array.isArray(loaders)) return (0, $ejAXt.normalizeLoader)(loaders);
    let candidateLoaders = [];
    if (loaders) candidateLoaders = candidateLoaders.concat(loaders);
    if (!(options !== null && options !== void 0 && options.ignoreRegisteredLoaders)) candidateLoaders.push(...(0, $aZt53.getRegisteredLoaders)());
    $c6c701b825ea89d0$var$normalizeLoaders(candidateLoaders);
    const loader = $c6c701b825ea89d0$var$selectLoaderInternal(data, candidateLoaders, options, context);
    if (!loader && !(options !== null && options !== void 0 && options.nothrow)) throw new Error($c6c701b825ea89d0$var$getNoValidLoaderMessage(data));
    return loader;
}
function $c6c701b825ea89d0$var$selectLoaderInternal(data, loaders, options, context) {
    const { url: url, type: type } = (0, $5Tper.getResourceUrlAndType)(data);
    const testUrl = url || (context === null || context === void 0 ? void 0 : context.url);
    let loader = null;
    if (options !== null && options !== void 0 && options.mimeType) loader = $c6c701b825ea89d0$var$findLoaderByMIMEType(loaders, options === null || options === void 0 ? void 0 : options.mimeType);
    loader = loader || $c6c701b825ea89d0$var$findLoaderByUrl(loaders, testUrl);
    loader = loader || $c6c701b825ea89d0$var$findLoaderByMIMEType(loaders, type);
    loader = loader || $c6c701b825ea89d0$var$findLoaderByInitialBytes(loaders, data);
    loader = loader || $c6c701b825ea89d0$var$findLoaderByMIMEType(loaders, options === null || options === void 0 ? void 0 : options.fallbackMimeType);
    return loader;
}
function $c6c701b825ea89d0$var$validHTTPResponse(data) {
    if (data instanceof Response) {
        if (data.status === 204) return false;
    }
    return true;
}
function $c6c701b825ea89d0$var$getNoValidLoaderMessage(data) {
    const { url: url, type: type } = (0, $5Tper.getResourceUrlAndType)(data);
    let message = "No valid loader found (";
    message += url ? `${(0, $7peSl).filename(url)}, ` : "no url provided, ";
    message += `MIME type: ${type ? `"${type}"` : "not provided"}, `;
    const firstCharacters = data ? $c6c701b825ea89d0$var$getFirstCharacters(data) : "";
    message += firstCharacters ? ` first bytes: "${firstCharacters}"` : "first bytes: not available";
    message += ")";
    return message;
}
function $c6c701b825ea89d0$var$normalizeLoaders(loaders) {
    for (const loader of loaders)(0, $ejAXt.normalizeLoader)(loader);
}
function $c6c701b825ea89d0$var$findLoaderByUrl(loaders, url) {
    const match = url && $c6c701b825ea89d0$var$EXT_PATTERN.exec(url);
    const extension = match && match[1];
    return extension ? $c6c701b825ea89d0$var$findLoaderByExtension(loaders, extension) : null;
}
function $c6c701b825ea89d0$var$findLoaderByExtension(loaders, extension) {
    extension = extension.toLowerCase();
    for (const loader of loaders)for (const loaderExtension of loader.extensions){
        if (loaderExtension.toLowerCase() === extension) return loader;
    }
    return null;
}
function $c6c701b825ea89d0$var$findLoaderByMIMEType(loaders, mimeType) {
    for (const loader of loaders){
        if (loader.mimeTypes && loader.mimeTypes.includes(mimeType)) return loader;
        if (mimeType === `application/x.${loader.id}`) return loader;
    }
    return null;
}
function $c6c701b825ea89d0$var$findLoaderByInitialBytes(loaders, data) {
    if (!data) return null;
    for (const loader of loaders){
        if (typeof data === "string") {
            if ($c6c701b825ea89d0$var$testDataAgainstText(data, loader)) return loader;
        } else if (ArrayBuffer.isView(data)) {
            if ($c6c701b825ea89d0$var$testDataAgainstBinary(data.buffer, data.byteOffset, loader)) return loader;
        } else if (data instanceof ArrayBuffer) {
            const byteOffset = 0;
            if ($c6c701b825ea89d0$var$testDataAgainstBinary(data, byteOffset, loader)) return loader;
        }
    }
    return null;
}
function $c6c701b825ea89d0$var$testDataAgainstText(data, loader) {
    if (loader.testText) return loader.testText(data);
    const tests = Array.isArray(loader.tests) ? loader.tests : [
        loader.tests
    ];
    return tests.some((test)=>data.startsWith(test));
}
function $c6c701b825ea89d0$var$testDataAgainstBinary(data, byteOffset, loader) {
    const tests = Array.isArray(loader.tests) ? loader.tests : [
        loader.tests
    ];
    return tests.some((test)=>$c6c701b825ea89d0$var$testBinary(data, byteOffset, loader, test));
}
function $c6c701b825ea89d0$var$testBinary(data, byteOffset, loader, test) {
    if (test instanceof ArrayBuffer) return (0, $fG4p0.compareArrayBuffers)(test, data, test.byteLength);
    switch(typeof test){
        case "function":
            return test(data, loader);
        case "string":
            const magic = $c6c701b825ea89d0$var$getMagicString(data, byteOffset, test.length);
            return test === magic;
        default:
            return false;
    }
}
function $c6c701b825ea89d0$var$getFirstCharacters(data, length = 5) {
    if (typeof data === "string") return data.slice(0, length);
    else if (ArrayBuffer.isView(data)) return $c6c701b825ea89d0$var$getMagicString(data.buffer, data.byteOffset, length);
    else if (data instanceof ArrayBuffer) {
        const byteOffset = 0;
        return $c6c701b825ea89d0$var$getMagicString(data, byteOffset, length);
    }
    return "";
}
function $c6c701b825ea89d0$var$getMagicString(arrayBuffer, byteOffset, length) {
    if (arrayBuffer.byteLength < byteOffset + length) return "";
    const dataView = new DataView(arrayBuffer);
    let magic = "";
    for(let i = 0; i < length; i++)magic += String.fromCharCode(dataView.getUint8(byteOffset + i));
    return magic;
}

});
parcelRegister("7peSl", function(module, exports) {

$parcel$export(module.exports, "filename", function () { return $56466828b6733385$export$f9107b66120eb036; });
$parcel$export(module.exports, "dirname", function () { return $56466828b6733385$export$7f7b8152cc673abe; });
$parcel$export(module.exports, "join", function () { return $56466828b6733385$export$f7e2c8231c57a8bd; });
function $56466828b6733385$export$f9107b66120eb036(url) {
    const slashIndex = url && url.lastIndexOf("/");
    return slashIndex >= 0 ? url.substr(slashIndex + 1) : "";
}
function $56466828b6733385$export$7f7b8152cc673abe(url) {
    const slashIndex = url && url.lastIndexOf("/");
    return slashIndex >= 0 ? url.substr(0, slashIndex) : "";
}
function $56466828b6733385$export$f7e2c8231c57a8bd(...parts) {
    const separator = "/";
    parts = parts.map((part, index)=>{
        if (index) part = part.replace(new RegExp(`^${separator}`), "");
        if (index !== parts.length - 1) part = part.replace(new RegExp(`${separator}$`), "");
        return part;
    });
    return parts.join(separator);
}

});

parcelRegister("aZt53", function(module, exports) {

$parcel$export(module.exports, "registerLoaders", function () { return $02109d8f267461b1$export$74069a1a10fa28e5; });
$parcel$export(module.exports, "getRegisteredLoaders", function () { return $02109d8f267461b1$export$8fa02447f82aef84; });

var $ejAXt = parcelRequire("ejAXt");

var $bT4Nz = parcelRequire("bT4Nz");
const $02109d8f267461b1$var$getGlobalLoaderRegistry = ()=>{
    const state = (0, $bT4Nz.getGlobalLoaderState)();
    state.loaderRegistry = state.loaderRegistry || [];
    return state.loaderRegistry;
};
function $02109d8f267461b1$export$74069a1a10fa28e5(loaders) {
    const loaderRegistry = $02109d8f267461b1$var$getGlobalLoaderRegistry();
    loaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    for (const loader of loaders){
        const normalizedLoader = (0, $ejAXt.normalizeLoader)(loader);
        if (!loaderRegistry.find((registeredLoader)=>normalizedLoader === registeredLoader)) loaderRegistry.unshift(normalizedLoader);
    }
}
function $02109d8f267461b1$export$8fa02447f82aef84() {
    return $02109d8f267461b1$var$getGlobalLoaderRegistry();
}
function $02109d8f267461b1$export$a20f34177d9a64c6() {
    const state = (0, $bT4Nz.getGlobalLoaderState)();
    state.loaderRegistry = [];
}

});






parcelRegister("cYQ5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97337e5d8e12d3ff$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $i46md = parcelRequire("i46md");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");
var $7gQQK = parcelRequire("7gQQK");

var $cxTxU = parcelRequire("cxTxU");
var $b2F4S = parcelRequire("b2F4S");

var $h0OZb = parcelRequire("h0OZb");

var $dNjAg = parcelRequire("dNjAg");
const $97337e5d8e12d3ff$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $97337e5d8e12d3ff$var$defaultProps = {
    radiusUnits: "meters",
    radiusScale: {
        type: "number",
        min: 0,
        value: 1
    },
    radiusMinPixels: {
        type: "number",
        min: 0,
        value: 0
    },
    radiusMaxPixels: {
        type: "number",
        min: 0,
        value: Number.MAX_SAFE_INTEGER
    },
    lineWidthUnits: "meters",
    lineWidthScale: {
        type: "number",
        min: 0,
        value: 1
    },
    lineWidthMinPixels: {
        type: "number",
        min: 0,
        value: 0
    },
    lineWidthMaxPixels: {
        type: "number",
        min: 0,
        value: Number.MAX_SAFE_INTEGER
    },
    stroked: false,
    filled: true,
    billboard: false,
    antialiasing: true,
    getPosition: {
        type: "accessor",
        value: (x)=>x.position
    },
    getRadius: {
        type: "accessor",
        value: 1
    },
    getFillColor: {
        type: "accessor",
        value: $97337e5d8e12d3ff$var$DEFAULT_COLOR
    },
    getLineColor: {
        type: "accessor",
        value: $97337e5d8e12d3ff$var$DEFAULT_COLOR
    },
    getLineWidth: {
        type: "accessor",
        value: 1
    },
    strokeWidth: {
        deprecatedFor: "getLineWidth"
    },
    outline: {
        deprecatedFor: "stroked"
    },
    getColor: {
        deprecatedFor: [
            "getFillColor",
            "getLineColor"
        ]
    }
};
class $97337e5d8e12d3ff$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getShaders() {
        return super.getShaders({
            vs: $h0OZb.default,
            fs: $dNjAg.default,
            modules: [
                (0, $jRSMz.default),
                (0, $7UxuR.default)
            ]
        });
    }
    initializeState() {
        this.getAttributeManager().addInstanced({
            instancePositions: {
                size: 3,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: true,
                accessor: "getPosition"
            },
            instanceRadius: {
                size: 1,
                transition: true,
                accessor: "getRadius",
                defaultValue: 1
            },
            instanceFillColors: {
                size: this.props.colorFormat.length,
                transition: true,
                normalized: true,
                type: 5121,
                accessor: "getFillColor",
                defaultValue: [
                    0,
                    0,
                    0,
                    255
                ]
            },
            instanceLineColors: {
                size: this.props.colorFormat.length,
                transition: true,
                normalized: true,
                type: 5121,
                accessor: "getLineColor",
                defaultValue: [
                    0,
                    0,
                    0,
                    255
                ]
            },
            instanceLineWidths: {
                size: 1,
                transition: true,
                accessor: "getLineWidth",
                defaultValue: 1
            }
        });
    }
    updateState(params) {
        super.updateState(params);
        if (params.changeFlags.extensionsChanged) {
            var _this$state$model;
            const { gl: gl } = this.context;
            (_this$state$model = this.state.model) === null || _this$state$model === void 0 || _this$state$model.delete();
            this.state.model = this._getModel(gl);
            this.getAttributeManager().invalidateAll();
        }
    }
    draw({ uniforms: uniforms }) {
        const { radiusUnits: radiusUnits, radiusScale: radiusScale, radiusMinPixels: radiusMinPixels, radiusMaxPixels: radiusMaxPixels, stroked: stroked, filled: filled, billboard: billboard, antialiasing: antialiasing, lineWidthUnits: lineWidthUnits, lineWidthScale: lineWidthScale, lineWidthMinPixels: lineWidthMinPixels, lineWidthMaxPixels: lineWidthMaxPixels } = this.props;
        this.state.model.setUniforms(uniforms).setUniforms({
            stroked: stroked ? 1 : 0,
            filled: filled,
            billboard: billboard,
            antialiasing: antialiasing,
            radiusUnits: (0, $7gQQK.UNIT)[radiusUnits],
            radiusScale: radiusScale,
            radiusMinPixels: radiusMinPixels,
            radiusMaxPixels: radiusMaxPixels,
            lineWidthUnits: (0, $7gQQK.UNIT)[lineWidthUnits],
            lineWidthScale: lineWidthScale,
            lineWidthMinPixels: lineWidthMinPixels,
            lineWidthMaxPixels: lineWidthMaxPixels
        }).draw();
    }
    _getModel(gl) {
        const positions = [
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0
        ];
        return new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders()), {
            id: this.props.id,
            geometry: new (0, $cxTxU.default)({
                drawMode: 6,
                vertexCount: 4,
                attributes: {
                    positions: {
                        size: 3,
                        value: new Float32Array(positions)
                    }
                }
            }),
            isInstanced: true
        }));
    }
}
(0, $lEQUF.default)($97337e5d8e12d3ff$export$2e2bcd8739ae039, "defaultProps", $97337e5d8e12d3ff$var$defaultProps);
(0, $lEQUF.default)($97337e5d8e12d3ff$export$2e2bcd8739ae039, "layerName", "ScatterplotLayer");

});
parcelRegister("h0OZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c629fc7f5bde3113$export$2e2bcd8739ae039; });
var $c629fc7f5bde3113$export$2e2bcd8739ae039 = "#define SHADER_NAME scatterplot-layer-vertex-shader\n\nattribute vec3 positions;\n\nattribute vec3 instancePositions;\nattribute vec3 instancePositions64Low;\nattribute float instanceRadius;\nattribute float instanceLineWidths;\nattribute vec4 instanceFillColors;\nattribute vec4 instanceLineColors;\nattribute vec3 instancePickingColors;\n\nuniform float opacity;\nuniform float radiusScale;\nuniform float radiusMinPixels;\nuniform float radiusMaxPixels;\nuniform float lineWidthScale;\nuniform float lineWidthMinPixels;\nuniform float lineWidthMaxPixels;\nuniform float stroked;\nuniform bool filled;\nuniform bool antialiasing;\nuniform bool billboard;\nuniform int radiusUnits;\nuniform int lineWidthUnits;\n\nvarying vec4 vFillColor;\nvarying vec4 vLineColor;\nvarying vec2 unitPosition;\nvarying float innerUnitRadius;\nvarying float outerRadiusPixels;\n\n\nvoid main(void) {\n  geometry.worldPosition = instancePositions;\n  outerRadiusPixels = clamp(\n    project_size_to_pixel(radiusScale * instanceRadius, radiusUnits),\n    radiusMinPixels, radiusMaxPixels\n  );\n  float lineWidthPixels = clamp(\n    project_size_to_pixel(lineWidthScale * instanceLineWidths, lineWidthUnits),\n    lineWidthMinPixels, lineWidthMaxPixels\n  );\n  outerRadiusPixels += stroked * lineWidthPixels / 2.0;\n  float edgePadding = antialiasing ? (outerRadiusPixels + SMOOTH_EDGE_RADIUS) / outerRadiusPixels : 1.0;\n  unitPosition = edgePadding * positions.xy;\n  geometry.uv = unitPosition;\n  geometry.pickingColor = instancePickingColors;\n\n  innerUnitRadius = 1.0 - stroked * lineWidthPixels / outerRadiusPixels;\n  \n  if (billboard) {\n    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);\n    DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n    vec3 offset = edgePadding * positions * outerRadiusPixels;\n    DECKGL_FILTER_SIZE(offset, geometry);\n    gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);\n  } else {\n    vec3 offset = edgePadding * positions * project_pixel_size(outerRadiusPixels);\n    DECKGL_FILTER_SIZE(offset, geometry);\n    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset, geometry.position);\n    DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n  }\n  vFillColor = vec4(instanceFillColors.rgb, instanceFillColors.a * opacity);\n  DECKGL_FILTER_COLOR(vFillColor, geometry);\n  vLineColor = vec4(instanceLineColors.rgb, instanceLineColors.a * opacity);\n  DECKGL_FILTER_COLOR(vLineColor, geometry);\n}\n";

});

parcelRegister("dNjAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0af0ae7d30a5aa2$export$2e2bcd8739ae039; });
var $a0af0ae7d30a5aa2$export$2e2bcd8739ae039 = "#define SHADER_NAME scatterplot-layer-fragment-shader\n\nprecision highp float;\n\nuniform bool filled;\nuniform float stroked;\nuniform bool antialiasing;\n\nvarying vec4 vFillColor;\nvarying vec4 vLineColor;\nvarying vec2 unitPosition;\nvarying float innerUnitRadius;\nvarying float outerRadiusPixels;\n\nvoid main(void) {\n  geometry.uv = unitPosition;\n\n  float distToCenter = length(unitPosition) * outerRadiusPixels;\n  float inCircle = antialiasing ? \n    smoothedge(distToCenter, outerRadiusPixels) : \n    step(distToCenter, outerRadiusPixels);\n\n  if (inCircle == 0.0) {\n    discard;\n  }\n\n  if (stroked > 0.5) {\n    float isLine = antialiasing ? \n      smoothedge(innerUnitRadius * outerRadiusPixels, distToCenter) :\n      step(innerUnitRadius * outerRadiusPixels, distToCenter);\n\n    if (filled) {\n      gl_FragColor = mix(vFillColor, vLineColor, isLine);\n    } else {\n      if (isLine == 0.0) {\n        discard;\n      }\n      gl_FragColor = vec4(vLineColor.rgb, vLineColor.a * isLine);\n    }\n  } else if (!filled) {\n    discard;\n  } else {\n    gl_FragColor = vFillColor;\n  }\n\n  gl_FragColor.a *= inCircle;\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";

});


parcelRegister("9pc7R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d8fdac97b4123f8$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $coXLq = parcelRequire("coXLq");
var $abpME = parcelRequire("abpME");
var $4VQgq = parcelRequire("4VQgq");

var $32r5R = parcelRequire("32r5R");

var $7wR39 = parcelRequire("7wR39");

var $2hbs4 = parcelRequire("2hbs4");

var $1xAPT = parcelRequire("1xAPT");
const $6d8fdac97b4123f8$var$TEXT_ANCHOR = {
    start: 1,
    middle: 0,
    end: -1
};
const $6d8fdac97b4123f8$var$ALIGNMENT_BASELINE = {
    top: 1,
    center: 0,
    bottom: -1
};
const $6d8fdac97b4123f8$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $6d8fdac97b4123f8$var$DEFAULT_LINE_HEIGHT = 1.0;
const $6d8fdac97b4123f8$var$defaultProps = {
    billboard: true,
    sizeScale: 1,
    sizeUnits: "pixels",
    sizeMinPixels: 0,
    sizeMaxPixels: Number.MAX_SAFE_INTEGER,
    background: false,
    getBackgroundColor: {
        type: "accessor",
        value: [
            255,
            255,
            255,
            255
        ]
    },
    getBorderColor: {
        type: "accessor",
        value: $6d8fdac97b4123f8$var$DEFAULT_COLOR
    },
    getBorderWidth: {
        type: "accessor",
        value: 0
    },
    backgroundPadding: {
        type: "array",
        value: [
            0,
            0,
            0,
            0
        ]
    },
    characterSet: {
        type: "object",
        value: (0, $7wR39.DEFAULT_FONT_SETTINGS).characterSet
    },
    fontFamily: (0, $7wR39.DEFAULT_FONT_SETTINGS).fontFamily,
    fontWeight: (0, $7wR39.DEFAULT_FONT_SETTINGS).fontWeight,
    lineHeight: $6d8fdac97b4123f8$var$DEFAULT_LINE_HEIGHT,
    outlineWidth: {
        type: "number",
        value: 0,
        min: 0
    },
    outlineColor: {
        type: "color",
        value: $6d8fdac97b4123f8$var$DEFAULT_COLOR
    },
    fontSettings: {
        type: "object",
        value: {},
        compare: 1
    },
    wordBreak: "break-word",
    maxWidth: {
        type: "number",
        value: -1
    },
    getText: {
        type: "accessor",
        value: (x)=>x.text
    },
    getPosition: {
        type: "accessor",
        value: (x)=>x.position
    },
    getColor: {
        type: "accessor",
        value: $6d8fdac97b4123f8$var$DEFAULT_COLOR
    },
    getSize: {
        type: "accessor",
        value: 32
    },
    getAngle: {
        type: "accessor",
        value: 0
    },
    getTextAnchor: {
        type: "accessor",
        value: "middle"
    },
    getAlignmentBaseline: {
        type: "accessor",
        value: "center"
    },
    getPixelOffset: {
        type: "accessor",
        value: [
            0,
            0
        ]
    },
    backgroundColor: {
        deprecatedFor: [
            "background",
            "getBackgroundColor"
        ]
    }
};
class $6d8fdac97b4123f8$export$2e2bcd8739ae039 extends (0, $coXLq.default) {
    initializeState() {
        this.state = {
            styleVersion: 0,
            fontAtlasManager: new (0, $7wR39.default)()
        };
        if (this.props.maxWidth > 0) (0, $4VQgq.default).warn("v8.9 breaking change: TextLayer maxWidth is now relative to text size")();
    }
    updateState(params) {
        const { props: props, oldProps: oldProps, changeFlags: changeFlags } = params;
        const textChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getText);
        if (textChanged) this._updateText();
        const fontChanged = this._updateFontAtlas();
        const styleChanged = fontChanged || props.lineHeight !== oldProps.lineHeight || props.wordBreak !== oldProps.wordBreak || props.maxWidth !== oldProps.maxWidth;
        if (styleChanged) this.setState({
            styleVersion: this.state.styleVersion + 1
        });
    }
    getPickingInfo({ info: info }) {
        info.object = info.index >= 0 ? this.props.data[info.index] : null;
        return info;
    }
    _updateFontAtlas() {
        const { fontSettings: fontSettings, fontFamily: fontFamily, fontWeight: fontWeight } = this.props;
        const { fontAtlasManager: fontAtlasManager, characterSet: characterSet } = this.state;
        const fontProps = (0, $edHbI._)((0, $2QP2i._)({}, fontSettings), {
            characterSet: characterSet,
            fontFamily: fontFamily,
            fontWeight: fontWeight
        });
        if (!fontAtlasManager.mapping) {
            fontAtlasManager.setProps(fontProps);
            return true;
        }
        for(const key in fontProps)if (fontProps[key] !== fontAtlasManager.props[key]) {
            fontAtlasManager.setProps(fontProps);
            return true;
        }
        return false;
    }
    _updateText() {
        var _attributes;
        const { data: data, characterSet: characterSet } = this.props;
        const textBuffer = (_attributes = data.attributes) === null || _attributes === void 0 ? void 0 : _attributes.getText;
        let { getText: getText } = this.props;
        let startIndices = data.startIndices;
        let numInstances;
        const autoCharacterSet = characterSet === "auto" && new Set();
        if (textBuffer && startIndices) {
            const { texts: texts, characterCount: characterCount } = (0, $2hbs4.getTextFromBuffer)((0, $edHbI._)((0, $2QP2i._)({}, ArrayBuffer.isView(textBuffer) ? {
                value: textBuffer
            } : textBuffer), {
                length: data.length,
                startIndices: startIndices,
                characterSet: autoCharacterSet
            }));
            numInstances = characterCount;
            getText = (_, { index: index })=>texts[index];
        } else {
            const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(data);
            startIndices = [
                0
            ];
            numInstances = 0;
            for (const object of iterable){
                objectInfo.index++;
                const text = Array.from(getText(object, objectInfo) || "");
                if (autoCharacterSet) text.forEach(autoCharacterSet.add, autoCharacterSet);
                numInstances += text.length;
                startIndices.push(numInstances);
            }
        }
        this.setState({
            getText: getText,
            startIndices: startIndices,
            numInstances: numInstances,
            characterSet: autoCharacterSet || characterSet
        });
    }
    transformParagraph(object, objectInfo) {
        const { fontAtlasManager: fontAtlasManager } = this.state;
        const iconMapping = fontAtlasManager.mapping;
        const getText = this.state.getText;
        const { wordBreak: wordBreak, lineHeight: lineHeight, maxWidth: maxWidth } = this.props;
        const paragraph = getText(object, objectInfo) || "";
        return (0, $2hbs4.transformParagraph)(paragraph, lineHeight, wordBreak, maxWidth * fontAtlasManager.props.fontSize, iconMapping);
    }
    renderLayers() {
        const { startIndices: startIndices, numInstances: numInstances, getText: getText, fontAtlasManager: { scale: scale, texture: texture, mapping: mapping }, styleVersion: styleVersion } = this.state;
        const { data: data, _dataDiff: _dataDiff, getPosition: getPosition, getColor: getColor, getSize: getSize, getAngle: getAngle, getPixelOffset: getPixelOffset, getBackgroundColor: getBackgroundColor, getBorderColor: getBorderColor, getBorderWidth: getBorderWidth, backgroundPadding: backgroundPadding, background: background, billboard: billboard, fontSettings: fontSettings, outlineWidth: outlineWidth, outlineColor: outlineColor, sizeScale: sizeScale, sizeUnits: sizeUnits, sizeMinPixels: sizeMinPixels, sizeMaxPixels: sizeMaxPixels, transitions: transitions, updateTriggers: updateTriggers } = this.props;
        const CharactersLayerClass = this.getSubLayerClass("characters", (0, $32r5R.default));
        const BackgroundLayerClass = this.getSubLayerClass("background", (0, $1xAPT.default));
        return [
            background && new BackgroundLayerClass({
                getFillColor: getBackgroundColor,
                getLineColor: getBorderColor,
                getLineWidth: getBorderWidth,
                padding: backgroundPadding,
                getPosition: getPosition,
                getSize: getSize,
                getAngle: getAngle,
                getPixelOffset: getPixelOffset,
                billboard: billboard,
                sizeScale: sizeScale,
                sizeUnits: sizeUnits,
                sizeMinPixels: sizeMinPixels,
                sizeMaxPixels: sizeMaxPixels,
                transitions: transitions && {
                    getPosition: transitions.getPosition,
                    getAngle: transitions.getAngle,
                    getSize: transitions.getSize,
                    getFillColor: transitions.getBackgroundColor,
                    getLineColor: transitions.getBorderColor,
                    getLineWidth: transitions.getBorderWidth,
                    getPixelOffset: transitions.getPixelOffset
                }
            }, this.getSubLayerProps({
                id: "background",
                updateTriggers: {
                    getPosition: updateTriggers.getPosition,
                    getAngle: updateTriggers.getAngle,
                    getSize: updateTriggers.getSize,
                    getFillColor: updateTriggers.getBackgroundColor,
                    getLineColor: updateTriggers.getBorderColor,
                    getLineWidth: updateTriggers.getBorderWidth,
                    getPixelOffset: updateTriggers.getPixelOffset,
                    getBoundingRect: {
                        getText: updateTriggers.getText,
                        getTextAnchor: updateTriggers.getTextAnchor,
                        getAlignmentBaseline: updateTriggers.getAlignmentBaseline,
                        styleVersion: styleVersion
                    }
                }
            }), {
                data: data.attributes && data.attributes.background ? {
                    length: data.length,
                    attributes: data.attributes.background
                } : data,
                _dataDiff: _dataDiff,
                autoHighlight: false,
                getBoundingRect: this.getBoundingRect
            }),
            new CharactersLayerClass({
                sdf: fontSettings.sdf,
                smoothing: Number.isFinite(fontSettings.smoothing) ? fontSettings.smoothing : (0, $7wR39.DEFAULT_FONT_SETTINGS).smoothing,
                outlineWidth: outlineWidth / (fontSettings.radius || (0, $7wR39.DEFAULT_FONT_SETTINGS).radius),
                outlineColor: outlineColor,
                iconAtlas: texture,
                iconMapping: mapping,
                getPosition: getPosition,
                getColor: getColor,
                getSize: getSize,
                getAngle: getAngle,
                getPixelOffset: getPixelOffset,
                billboard: billboard,
                sizeScale: sizeScale * scale,
                sizeUnits: sizeUnits,
                sizeMinPixels: sizeMinPixels * scale,
                sizeMaxPixels: sizeMaxPixels * scale,
                transitions: transitions && {
                    getPosition: transitions.getPosition,
                    getAngle: transitions.getAngle,
                    getColor: transitions.getColor,
                    getSize: transitions.getSize,
                    getPixelOffset: transitions.getPixelOffset
                }
            }, this.getSubLayerProps({
                id: "characters",
                updateTriggers: {
                    all: updateTriggers.getText,
                    getPosition: updateTriggers.getPosition,
                    getAngle: updateTriggers.getAngle,
                    getColor: updateTriggers.getColor,
                    getSize: updateTriggers.getSize,
                    getPixelOffset: updateTriggers.getPixelOffset,
                    getIconOffsets: {
                        getTextAnchor: updateTriggers.getTextAnchor,
                        getAlignmentBaseline: updateTriggers.getAlignmentBaseline,
                        styleVersion: styleVersion
                    }
                }
            }), {
                data: data,
                _dataDiff: _dataDiff,
                startIndices: startIndices,
                numInstances: numInstances,
                getIconOffsets: this.getIconOffsets,
                getIcon: getText
            })
        ];
    }
    static set fontAtlasCacheLimit(limit) {
        (0, $7wR39.setFontAtlasCacheLimit)(limit);
    }
    constructor(...args){
        super(...args);
        (0, $lEQUF.default)(this, "state", void 0);
        (0, $lEQUF.default)(this, "getBoundingRect", (object, objectInfo)=>{
            let { size: [width, height] } = this.transformParagraph(object, objectInfo);
            const { fontSize: fontSize } = this.state.fontAtlasManager.props;
            width /= fontSize;
            height /= fontSize;
            const { getTextAnchor: getTextAnchor, getAlignmentBaseline: getAlignmentBaseline } = this.props;
            const anchorX = $6d8fdac97b4123f8$var$TEXT_ANCHOR[typeof getTextAnchor === "function" ? getTextAnchor(object, objectInfo) : getTextAnchor];
            const anchorY = $6d8fdac97b4123f8$var$ALIGNMENT_BASELINE[typeof getAlignmentBaseline === "function" ? getAlignmentBaseline(object, objectInfo) : getAlignmentBaseline];
            return [
                (anchorX - 1) * width / 2,
                (anchorY - 1) * height / 2,
                width,
                height
            ];
        });
        (0, $lEQUF.default)(this, "getIconOffsets", (object, objectInfo)=>{
            const { getTextAnchor: getTextAnchor, getAlignmentBaseline: getAlignmentBaseline } = this.props;
            const { x: x, y: y, rowWidth: rowWidth, size: [width, height] } = this.transformParagraph(object, objectInfo);
            const anchorX = $6d8fdac97b4123f8$var$TEXT_ANCHOR[typeof getTextAnchor === "function" ? getTextAnchor(object, objectInfo) : getTextAnchor];
            const anchorY = $6d8fdac97b4123f8$var$ALIGNMENT_BASELINE[typeof getAlignmentBaseline === "function" ? getAlignmentBaseline(object, objectInfo) : getAlignmentBaseline];
            const numCharacters = x.length;
            const offsets = new Array(numCharacters * 2);
            let index = 0;
            for(let i = 0; i < numCharacters; i++){
                const rowOffset = (1 - anchorX) * (width - rowWidth[i]) / 2;
                offsets[index++] = (anchorX - 1) * width / 2 + rowOffset + x[i];
                offsets[index++] = (anchorY - 1) * height / 2 + y[i];
            }
            return offsets;
        });
    }
}
(0, $lEQUF.default)($6d8fdac97b4123f8$export$2e2bcd8739ae039, "defaultProps", $6d8fdac97b4123f8$var$defaultProps);
(0, $lEQUF.default)($6d8fdac97b4123f8$export$2e2bcd8739ae039, "layerName", "TextLayer");

});
parcelRegister("32r5R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2366933a1579e576$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $4VQgq = parcelRequire("4VQgq");

var $h685K = parcelRequire("h685K");

var $lakAP = parcelRequire("lakAP");
const $2366933a1579e576$var$DEFAULT_BUFFER = 0.75;
const $2366933a1579e576$var$EMPTY_ARRAY = [];
const $2366933a1579e576$var$defaultProps = {
    getIconOffsets: {
        type: "accessor",
        value: (x)=>x.offsets
    },
    alphaCutoff: 0.001,
    smoothing: 0.1,
    outlineWidth: 0,
    outlineColor: {
        type: "color",
        value: [
            0,
            0,
            0,
            255
        ]
    }
};
class $2366933a1579e576$export$2e2bcd8739ae039 extends (0, $h685K.default) {
    getShaders() {
        return (0, $edHbI._)((0, $2QP2i._)({}, super.getShaders()), {
            fs: $lakAP.default
        });
    }
    initializeState() {
        super.initializeState();
        const attributeManager = this.getAttributeManager();
        attributeManager.addInstanced({
            instanceOffsets: {
                size: 2,
                accessor: "getIconOffsets"
            },
            instancePickingColors: {
                type: 5121,
                size: 3,
                accessor: (object, { index: index, target: value })=>this.encodePickingColor(index, value)
            }
        });
    }
    updateState(params) {
        super.updateState(params);
        const { props: props, oldProps: oldProps } = params;
        let { outlineColor: outlineColor } = props;
        if (outlineColor !== oldProps.outlineColor) {
            outlineColor = outlineColor.map((x)=>x / 255);
            outlineColor[3] = Number.isFinite(outlineColor[3]) ? outlineColor[3] : 1;
            this.setState({
                outlineColor: outlineColor
            });
        }
        if (!props.sdf && props.outlineWidth) (0, $4VQgq.default).warn("".concat(this.id, ": fontSettings.sdf is required to render outline"))();
    }
    draw(params) {
        const { sdf: sdf, smoothing: smoothing, outlineWidth: outlineWidth } = this.props;
        const { outlineColor: outlineColor } = this.state;
        const outlineBuffer = outlineWidth ? Math.max(smoothing, $2366933a1579e576$var$DEFAULT_BUFFER * (1 - outlineWidth)) : -1;
        params.uniforms = (0, $edHbI._)((0, $2QP2i._)({}, params.uniforms), {
            sdfBuffer: $2366933a1579e576$var$DEFAULT_BUFFER,
            outlineBuffer: outlineBuffer,
            gamma: smoothing,
            sdf: Boolean(sdf),
            outlineColor: outlineColor
        });
        super.draw(params);
        if (sdf && outlineWidth) {
            const { iconManager: iconManager } = this.state;
            const iconsTexture = iconManager.getTexture();
            if (iconsTexture) this.state.model.draw({
                uniforms: {
                    outlineBuffer: $2366933a1579e576$var$DEFAULT_BUFFER
                }
            });
        }
    }
    getInstanceOffset(icons) {
        return icons ? Array.from(icons).flatMap((icon)=>super.getInstanceOffset(icon)) : $2366933a1579e576$var$EMPTY_ARRAY;
    }
    getInstanceColorMode(icons) {
        return 1;
    }
    getInstanceIconFrame(icons) {
        return icons ? Array.from(icons).flatMap((icon)=>super.getInstanceIconFrame(icon)) : $2366933a1579e576$var$EMPTY_ARRAY;
    }
    constructor(...args){
        super(...args);
        (0, $lEQUF.default)(this, "state", void 0);
    }
}
(0, $lEQUF.default)($2366933a1579e576$export$2e2bcd8739ae039, "defaultProps", $2366933a1579e576$var$defaultProps);
(0, $lEQUF.default)($2366933a1579e576$export$2e2bcd8739ae039, "layerName", "MultiIconLayer");

});
parcelRegister("lakAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f68a8178c4383b53$export$2e2bcd8739ae039; });
var $f68a8178c4383b53$export$2e2bcd8739ae039 = "#define SHADER_NAME multi-icon-layer-fragment-shader\n\nprecision highp float;\n\nuniform float opacity;\nuniform sampler2D iconsTexture;\nuniform float gamma;\nuniform bool sdf;\nuniform float alphaCutoff;\nuniform float sdfBuffer;\nuniform float outlineBuffer;\nuniform vec4 outlineColor;\n\nvarying vec4 vColor;\nvarying vec2 vTextureCoords;\nvarying vec2 uv;\n\nvoid main(void) {\n  geometry.uv = uv;\n\n  if (!picking_uActive) {\n    float alpha = texture2D(iconsTexture, vTextureCoords).a;\n    vec4 color = vColor;\n    if (sdf) {\n      float distance = alpha;\n      alpha = smoothstep(sdfBuffer - gamma, sdfBuffer + gamma, distance);\n\n      if (outlineBuffer > 0.0) {\n        float inFill = alpha;\n        float inBorder = smoothstep(outlineBuffer - gamma, outlineBuffer + gamma, distance);\n        color = mix(outlineColor, vColor, inFill);\n        alpha = inBorder;\n      }\n    }\n    float a = alpha * color.a;\n    \n    if (a < alphaCutoff) {\n      discard;\n    }\n\n    gl_FragColor = vec4(color.rgb, a * opacity);\n  }\n\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";

});


parcelRegister("7wR39", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT_SETTINGS", function () { return $57b4ac2ca71db903$export$ed0f3a73a3e52a5; });
$parcel$export(module.exports, "setFontAtlasCacheLimit", function () { return $57b4ac2ca71db903$export$1ff3beb648c640c1; });
$parcel$export(module.exports, "default", function () { return $57b4ac2ca71db903$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $lEQUF = parcelRequire("lEQUF");

var $5POoC = parcelRequire("5POoC");

var $4VQgq = parcelRequire("4VQgq");

var $2hbs4 = parcelRequire("2hbs4");

var $1Kynu = parcelRequire("1Kynu");
function $57b4ac2ca71db903$var$getDefaultCharacterSet() {
    const charSet = [];
    for(let i = 32; i < 128; i++)charSet.push(String.fromCharCode(i));
    return charSet;
}
const $57b4ac2ca71db903$export$ed0f3a73a3e52a5 = {
    fontFamily: "Monaco, monospace",
    fontWeight: "normal",
    characterSet: $57b4ac2ca71db903$var$getDefaultCharacterSet(),
    fontSize: 64,
    buffer: 4,
    sdf: false,
    cutoff: 0.25,
    radius: 12,
    smoothing: 0.1
};
const $57b4ac2ca71db903$var$MAX_CANVAS_WIDTH = 1024;
const $57b4ac2ca71db903$var$BASELINE_SCALE = 0.9;
const $57b4ac2ca71db903$var$HEIGHT_SCALE = 1.2;
const $57b4ac2ca71db903$var$CACHE_LIMIT = 3;
let $57b4ac2ca71db903$var$cache = new (0, $1Kynu.default)($57b4ac2ca71db903$var$CACHE_LIMIT);
function $57b4ac2ca71db903$var$getNewChars(cacheKey, characterSet) {
    let newCharSet;
    if (typeof characterSet === "string") newCharSet = new Set(Array.from(characterSet));
    else newCharSet = new Set(characterSet);
    const cachedFontAtlas = $57b4ac2ca71db903$var$cache.get(cacheKey);
    if (!cachedFontAtlas) return newCharSet;
    for(const char in cachedFontAtlas.mapping)if (newCharSet.has(char)) newCharSet.delete(char);
    return newCharSet;
}
function $57b4ac2ca71db903$var$populateAlphaChannel(alphaChannel, imageData) {
    for(let i = 0; i < alphaChannel.length; i++)imageData.data[4 * i + 3] = alphaChannel[i];
}
function $57b4ac2ca71db903$var$setTextStyle(ctx, fontFamily, fontSize, fontWeight) {
    ctx.font = "".concat(fontWeight, " ").concat(fontSize, "px ").concat(fontFamily);
    ctx.fillStyle = "#000";
    ctx.textBaseline = "alphabetic";
    ctx.textAlign = "left";
}
function $57b4ac2ca71db903$export$1ff3beb648c640c1(limit) {
    (0, $4VQgq.default).assert(Number.isFinite(limit) && limit >= $57b4ac2ca71db903$var$CACHE_LIMIT, "Invalid cache limit");
    $57b4ac2ca71db903$var$cache = new (0, $1Kynu.default)(limit);
}
class $57b4ac2ca71db903$export$2e2bcd8739ae039 {
    get texture() {
        return this._atlas;
    }
    get mapping() {
        return this._atlas && this._atlas.mapping;
    }
    get scale() {
        const { fontSize: fontSize, buffer: buffer } = this.props;
        return (fontSize * $57b4ac2ca71db903$var$HEIGHT_SCALE + buffer * 2) / fontSize;
    }
    setProps(props = {}) {
        Object.assign(this.props, props);
        this._key = this._getKey();
        const charSet = $57b4ac2ca71db903$var$getNewChars(this._key, this.props.characterSet);
        const cachedFontAtlas = $57b4ac2ca71db903$var$cache.get(this._key);
        if (cachedFontAtlas && charSet.size === 0) {
            if (this._atlas !== cachedFontAtlas) this._atlas = cachedFontAtlas;
            return;
        }
        const fontAtlas = this._generateFontAtlas(charSet, cachedFontAtlas);
        this._atlas = fontAtlas;
        $57b4ac2ca71db903$var$cache.set(this._key, fontAtlas);
    }
    _generateFontAtlas(characterSet, cachedFontAtlas) {
        const { fontFamily: fontFamily, fontWeight: fontWeight, fontSize: fontSize, buffer: buffer, sdf: sdf, radius: radius, cutoff: cutoff } = this.props;
        let canvas = cachedFontAtlas && cachedFontAtlas.data;
        if (!canvas) {
            canvas = document.createElement("canvas");
            canvas.width = $57b4ac2ca71db903$var$MAX_CANVAS_WIDTH;
        }
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        $57b4ac2ca71db903$var$setTextStyle(ctx, fontFamily, fontSize, fontWeight);
        const { mapping: mapping, canvasHeight: canvasHeight, xOffset: xOffset, yOffset: yOffset } = (0, $2hbs4.buildMapping)((0, $2QP2i._)({
            getFontWidth: (char)=>ctx.measureText(char).width,
            fontHeight: fontSize * $57b4ac2ca71db903$var$HEIGHT_SCALE,
            buffer: buffer,
            characterSet: characterSet,
            maxCanvasWidth: $57b4ac2ca71db903$var$MAX_CANVAS_WIDTH
        }, cachedFontAtlas && {
            mapping: cachedFontAtlas.mapping,
            xOffset: cachedFontAtlas.xOffset,
            yOffset: cachedFontAtlas.yOffset
        }));
        if (canvas.height !== canvasHeight) {
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            canvas.height = canvasHeight;
            ctx.putImageData(imageData, 0, 0);
        }
        $57b4ac2ca71db903$var$setTextStyle(ctx, fontFamily, fontSize, fontWeight);
        if (sdf) {
            const tinySDF = new (0, $5POoC.default)({
                fontSize: fontSize,
                buffer: buffer,
                radius: radius,
                cutoff: cutoff,
                fontFamily: fontFamily,
                fontWeight: "".concat(fontWeight)
            });
            for (const char of characterSet){
                const { data: data, width: width, height: height, glyphTop: glyphTop } = tinySDF.draw(char);
                mapping[char].width = width;
                mapping[char].layoutOffsetY = fontSize * $57b4ac2ca71db903$var$BASELINE_SCALE - glyphTop;
                const imageData = ctx.createImageData(width, height);
                $57b4ac2ca71db903$var$populateAlphaChannel(data, imageData);
                ctx.putImageData(imageData, mapping[char].x, mapping[char].y);
            }
        } else for (const char of characterSet)ctx.fillText(char, mapping[char].x, mapping[char].y + buffer + fontSize * $57b4ac2ca71db903$var$BASELINE_SCALE);
        return {
            xOffset: xOffset,
            yOffset: yOffset,
            mapping: mapping,
            data: canvas,
            width: canvas.width,
            height: canvas.height
        };
    }
    _getKey() {
        const { fontFamily: fontFamily, fontWeight: fontWeight, fontSize: fontSize, buffer: buffer, sdf: sdf, radius: radius, cutoff: cutoff } = this.props;
        if (sdf) return "".concat(fontFamily, " ").concat(fontWeight, " ").concat(fontSize, " ").concat(buffer, " ").concat(radius, " ").concat(cutoff);
        return "".concat(fontFamily, " ").concat(fontWeight, " ").concat(fontSize, " ").concat(buffer);
    }
    constructor(){
        (0, $lEQUF.default)(this, "props", (0, $2QP2i._)({}, $57b4ac2ca71db903$export$ed0f3a73a3e52a5));
        (0, $lEQUF.default)(this, "_key", void 0);
        (0, $lEQUF.default)(this, "_atlas", void 0);
    }
}

});
parcelRegister("5POoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43f8cec4dd2e8653$export$2e2bcd8739ae039; });
const $43f8cec4dd2e8653$var$INF = 1e20;
class $43f8cec4dd2e8653$export$2e2bcd8739ae039 {
    _createCanvas(size) {
        const canvas = document.createElement("canvas");
        canvas.width = canvas.height = size;
        return canvas;
    }
    draw(char) {
        const { width: glyphAdvance, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight } = this.ctx.measureText(char);
        // The integer/pixel part of the top alignment is encoded in metrics.glyphTop
        // The remainder is implicitly encoded in the rasterization
        const glyphTop = Math.ceil(actualBoundingBoxAscent);
        const glyphLeft = 0;
        // If the glyph overflows the canvas size, it will be clipped at the bottom/right
        const glyphWidth = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(actualBoundingBoxRight - actualBoundingBoxLeft)));
        const glyphHeight = Math.min(this.size - this.buffer, glyphTop + Math.ceil(actualBoundingBoxDescent));
        const width = glyphWidth + 2 * this.buffer;
        const height = glyphHeight + 2 * this.buffer;
        const len = Math.max(width * height, 0);
        const data = new Uint8ClampedArray(len);
        const glyph = {
            data: data,
            width: width,
            height: height,
            glyphWidth: glyphWidth,
            glyphHeight: glyphHeight,
            glyphTop: glyphTop,
            glyphLeft: glyphLeft,
            glyphAdvance: glyphAdvance
        };
        if (glyphWidth === 0 || glyphHeight === 0) return glyph;
        const { ctx: ctx, buffer: buffer, gridInner: gridInner, gridOuter: gridOuter } = this;
        ctx.clearRect(buffer, buffer, glyphWidth, glyphHeight);
        ctx.fillText(char, buffer, buffer + glyphTop);
        const imgData = ctx.getImageData(buffer, buffer, glyphWidth, glyphHeight);
        // Initialize grids outside the glyph range to alpha 0
        gridOuter.fill($43f8cec4dd2e8653$var$INF, 0, len);
        gridInner.fill(0, 0, len);
        for(let y = 0; y < glyphHeight; y++)for(let x = 0; x < glyphWidth; x++){
            const a = imgData.data[4 * (y * glyphWidth + x) + 3] / 255; // alpha value
            if (a === 0) continue; // empty pixels
            const j = (y + buffer) * width + x + buffer;
            if (a === 1) {
                gridOuter[j] = 0;
                gridInner[j] = $43f8cec4dd2e8653$var$INF;
            } else {
                const d = 0.5 - a;
                gridOuter[j] = d > 0 ? d * d : 0;
                gridInner[j] = d < 0 ? d * d : 0;
            }
        }
        $43f8cec4dd2e8653$var$edt(gridOuter, 0, 0, width, height, width, this.f, this.v, this.z);
        $43f8cec4dd2e8653$var$edt(gridInner, buffer, buffer, glyphWidth, glyphHeight, width, this.f, this.v, this.z);
        for(let i = 0; i < len; i++){
            const d = Math.sqrt(gridOuter[i]) - Math.sqrt(gridInner[i]);
            data[i] = Math.round(255 - 255 * (d / this.radius + this.cutoff));
        }
        return glyph;
    }
    constructor({ fontSize: fontSize = 24, buffer: buffer = 3, radius: radius = 8, cutoff: cutoff = 0.25, fontFamily: fontFamily = "sans-serif", fontWeight: fontWeight = "normal", fontStyle: fontStyle = "normal" } = {}){
        this.buffer = buffer;
        this.cutoff = cutoff;
        this.radius = radius;
        // make the canvas size big enough to both have the specified buffer around the glyph
        // for "halo", and account for some glyphs possibly being larger than their font size
        const size = this.size = fontSize + buffer * 4;
        const canvas = this._createCanvas(size);
        const ctx = this.ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
        ctx.textBaseline = "alphabetic";
        ctx.textAlign = "left"; // Necessary so that RTL text doesn't have different alignment
        ctx.fillStyle = "black";
        // temporary arrays for the distance transform
        this.gridOuter = new Float64Array(size * size);
        this.gridInner = new Float64Array(size * size);
        this.f = new Float64Array(size);
        this.z = new Float64Array(size + 1);
        this.v = new Uint16Array(size);
    }
}
// 2D Euclidean squared distance transform by Felzenszwalb & Huttenlocher https://cs.brown.edu/~pff/papers/dt-final.pdf
function $43f8cec4dd2e8653$var$edt(data, x0, y0, width, height, gridSize, f, v, z) {
    for(let x = x0; x < x0 + width; x++)$43f8cec4dd2e8653$var$edt1d(data, y0 * gridSize + x, gridSize, height, f, v, z);
    for(let y = y0; y < y0 + height; y++)$43f8cec4dd2e8653$var$edt1d(data, y * gridSize + x0, 1, width, f, v, z);
}
// 1D squared distance transform
function $43f8cec4dd2e8653$var$edt1d(grid, offset, stride, length, f, v, z) {
    v[0] = 0;
    z[0] = -$43f8cec4dd2e8653$var$INF;
    z[1] = $43f8cec4dd2e8653$var$INF;
    f[0] = grid[offset];
    for(let q = 1, k = 0, s = 0; q < length; q++){
        f[q] = grid[offset + q * stride];
        const q2 = q * q;
        do {
            const r = v[k];
            s = (f[q] - f[r] + q2 - r * r) / (q - r) / 2;
        }while (s <= z[k] && --k > -1);
        k++;
        v[k] = q;
        z[k] = s;
        z[k + 1] = $43f8cec4dd2e8653$var$INF;
    }
    for(let q = 0, k = 0; q < length; q++){
        while(z[k + 1] < q)k++;
        const r = v[k];
        const qr = q - r;
        grid[offset + q * stride] = f[r] + qr * qr;
    }
}

});

parcelRegister("2hbs4", function(module, exports) {

$parcel$export(module.exports, "buildMapping", function () { return $1a860d6580fd8805$export$a868857fc20192e3; });
$parcel$export(module.exports, "transformParagraph", function () { return $1a860d6580fd8805$export$1fa0b59a8da5a8b8; });
$parcel$export(module.exports, "getTextFromBuffer", function () { return $1a860d6580fd8805$export$ec514602ef54b577; });

var $4VQgq = parcelRequire("4VQgq");
const $1a860d6580fd8805$var$MISSING_CHAR_WIDTH = 32;
const $1a860d6580fd8805$var$SINGLE_LINE = [];
function $1a860d6580fd8805$export$dbdf0b374a78effc(number) {
    return Math.pow(2, Math.ceil(Math.log2(number)));
}
function $1a860d6580fd8805$export$a868857fc20192e3({ characterSet: characterSet, getFontWidth: getFontWidth, fontHeight: fontHeight, buffer: buffer, maxCanvasWidth: maxCanvasWidth, mapping: mapping = {}, xOffset: xOffset = 0, yOffset: yOffset = 0 }) {
    let row = 0;
    let x = xOffset;
    const rowHeight = fontHeight + buffer * 2;
    for (const char of characterSet)if (!mapping[char]) {
        const width = getFontWidth(char);
        if (x + width + buffer * 2 > maxCanvasWidth) {
            x = 0;
            row++;
        }
        mapping[char] = {
            x: x + buffer,
            y: yOffset + row * rowHeight + buffer,
            width: width,
            height: rowHeight,
            layoutWidth: width,
            layoutHeight: fontHeight
        };
        x += width + buffer * 2;
    }
    return {
        mapping: mapping,
        xOffset: x,
        yOffset: yOffset + row * rowHeight,
        canvasHeight: $1a860d6580fd8805$export$dbdf0b374a78effc(yOffset + (row + 1) * rowHeight)
    };
}
function $1a860d6580fd8805$var$getTextWidth(text, startIndex, endIndex, mapping) {
    let width = 0;
    for(let i = startIndex; i < endIndex; i++){
        var _mapping$character;
        const character = text[i];
        width += ((_mapping$character = mapping[character]) === null || _mapping$character === void 0 ? void 0 : _mapping$character.layoutWidth) || 0;
    }
    return width;
}
function $1a860d6580fd8805$var$breakAll(text, startIndex, endIndex, maxWidth, iconMapping, target) {
    let rowStartCharIndex = startIndex;
    let rowOffsetLeft = 0;
    for(let i = startIndex; i < endIndex; i++){
        const textWidth = $1a860d6580fd8805$var$getTextWidth(text, i, i + 1, iconMapping);
        if (rowOffsetLeft + textWidth > maxWidth) {
            if (rowStartCharIndex < i) target.push(i);
            rowStartCharIndex = i;
            rowOffsetLeft = 0;
        }
        rowOffsetLeft += textWidth;
    }
    return rowOffsetLeft;
}
function $1a860d6580fd8805$var$breakWord(text, startIndex, endIndex, maxWidth, iconMapping, target) {
    let rowStartCharIndex = startIndex;
    let groupStartCharIndex = startIndex;
    let groupEndCharIndex = startIndex;
    let rowOffsetLeft = 0;
    for(let i = startIndex; i < endIndex; i++){
        if (text[i] === " ") groupEndCharIndex = i + 1;
        else if (text[i + 1] === " " || i + 1 === endIndex) groupEndCharIndex = i + 1;
        if (groupEndCharIndex > groupStartCharIndex) {
            let groupWidth = $1a860d6580fd8805$var$getTextWidth(text, groupStartCharIndex, groupEndCharIndex, iconMapping);
            if (rowOffsetLeft + groupWidth > maxWidth) {
                if (rowStartCharIndex < groupStartCharIndex) {
                    target.push(groupStartCharIndex);
                    rowStartCharIndex = groupStartCharIndex;
                    rowOffsetLeft = 0;
                }
                if (groupWidth > maxWidth) {
                    groupWidth = $1a860d6580fd8805$var$breakAll(text, groupStartCharIndex, groupEndCharIndex, maxWidth, iconMapping, target);
                    rowStartCharIndex = target[target.length - 1];
                }
            }
            groupStartCharIndex = groupEndCharIndex;
            rowOffsetLeft += groupWidth;
        }
    }
    return rowOffsetLeft;
}
function $1a860d6580fd8805$export$4e7f5b633f31f273(text, wordBreak, maxWidth, iconMapping, startIndex = 0, endIndex) {
    if (endIndex === undefined) endIndex = text.length;
    const result = [];
    if (wordBreak === "break-all") $1a860d6580fd8805$var$breakAll(text, startIndex, endIndex, maxWidth, iconMapping, result);
    else $1a860d6580fd8805$var$breakWord(text, startIndex, endIndex, maxWidth, iconMapping, result);
    return result;
}
function $1a860d6580fd8805$var$transformRow(line, startIndex, endIndex, iconMapping, leftOffsets, rowSize) {
    let x = 0;
    let rowHeight = 0;
    for(let i = startIndex; i < endIndex; i++){
        const character = line[i];
        const frame = iconMapping[character];
        if (frame) {
            if (!rowHeight) rowHeight = frame.layoutHeight;
            leftOffsets[i] = x + frame.layoutWidth / 2;
            x += frame.layoutWidth;
        } else {
            (0, $4VQgq.default).warn("Missing character: ".concat(character, " (").concat(character.codePointAt(0), ")"))();
            leftOffsets[i] = x;
            x += $1a860d6580fd8805$var$MISSING_CHAR_WIDTH;
        }
    }
    rowSize[0] = x;
    rowSize[1] = rowHeight;
}
function $1a860d6580fd8805$export$1fa0b59a8da5a8b8(paragraph, lineHeight, wordBreak, maxWidth, iconMapping) {
    const characters = Array.from(paragraph);
    const numCharacters = characters.length;
    const x = new Array(numCharacters);
    const y = new Array(numCharacters);
    const rowWidth = new Array(numCharacters);
    const autoWrappingEnabled = (wordBreak === "break-word" || wordBreak === "break-all") && isFinite(maxWidth) && maxWidth > 0;
    const size = [
        0,
        0
    ];
    const rowSize = [
        0,
        0
    ];
    let rowOffsetTop = 0;
    let lineStartIndex = 0;
    let lineEndIndex = 0;
    for(let i = 0; i <= numCharacters; i++){
        const char = characters[i];
        if (char === "\n" || i === numCharacters) lineEndIndex = i;
        if (lineEndIndex > lineStartIndex) {
            const rows = autoWrappingEnabled ? $1a860d6580fd8805$export$4e7f5b633f31f273(characters, wordBreak, maxWidth, iconMapping, lineStartIndex, lineEndIndex) : $1a860d6580fd8805$var$SINGLE_LINE;
            for(let rowIndex = 0; rowIndex <= rows.length; rowIndex++){
                const rowStart = rowIndex === 0 ? lineStartIndex : rows[rowIndex - 1];
                const rowEnd = rowIndex < rows.length ? rows[rowIndex] : lineEndIndex;
                $1a860d6580fd8805$var$transformRow(characters, rowStart, rowEnd, iconMapping, x, rowSize);
                for(let j = rowStart; j < rowEnd; j++){
                    var _iconMapping$char;
                    const char = characters[j];
                    const layoutOffsetY = ((_iconMapping$char = iconMapping[char]) === null || _iconMapping$char === void 0 ? void 0 : _iconMapping$char.layoutOffsetY) || 0;
                    y[j] = rowOffsetTop + rowSize[1] / 2 + layoutOffsetY;
                    rowWidth[j] = rowSize[0];
                }
                rowOffsetTop = rowOffsetTop + rowSize[1] * lineHeight;
                size[0] = Math.max(size[0], rowSize[0]);
            }
            lineStartIndex = lineEndIndex;
        }
        if (char === "\n") {
            x[lineStartIndex] = 0;
            y[lineStartIndex] = 0;
            rowWidth[lineStartIndex] = 0;
            lineStartIndex++;
        }
    }
    size[1] = rowOffsetTop;
    return {
        x: x,
        y: y,
        rowWidth: rowWidth,
        size: size
    };
}
function $1a860d6580fd8805$export$ec514602ef54b577({ value: value, length: length, stride: stride, offset: offset, startIndices: startIndices, characterSet: characterSet }) {
    const bytesPerElement = value.BYTES_PER_ELEMENT;
    const elementStride = stride ? stride / bytesPerElement : 1;
    const elementOffset = offset ? offset / bytesPerElement : 0;
    const characterCount = startIndices[length] || Math.ceil((value.length - elementOffset) / elementStride);
    const autoCharacterSet = characterSet && new Set();
    const texts = new Array(length);
    let codes = value;
    if (elementStride > 1 || elementOffset > 0) {
        const ArrayType = value.constructor;
        codes = new ArrayType(characterCount);
        for(let i = 0; i < characterCount; i++)codes[i] = value[i * elementStride + elementOffset];
    }
    for(let index = 0; index < length; index++){
        const startIndex = startIndices[index];
        const endIndex = startIndices[index + 1] || characterCount;
        const codesAtIndex = codes.subarray(startIndex, endIndex);
        texts[index] = String.fromCodePoint.apply(null, codesAtIndex);
        if (autoCharacterSet) codesAtIndex.forEach(autoCharacterSet.add, autoCharacterSet);
    }
    if (autoCharacterSet) for (const charCode of autoCharacterSet)characterSet.add(String.fromCodePoint(charCode));
    return {
        texts: texts,
        characterCount: characterCount
    };
}

});

parcelRegister("1Kynu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1464c10b4afb5ee4$export$2e2bcd8739ae039; });

var $lEQUF = parcelRequire("lEQUF");
class $1464c10b4afb5ee4$export$2e2bcd8739ae039 {
    get(key) {
        const value = this._cache[key];
        if (value) {
            this._deleteOrder(key);
            this._appendOrder(key);
        }
        return value;
    }
    set(key, value) {
        if (!this._cache[key]) {
            if (Object.keys(this._cache).length === this.limit) this.delete(this._order[0]);
            this._cache[key] = value;
            this._appendOrder(key);
        } else {
            this.delete(key);
            this._cache[key] = value;
            this._appendOrder(key);
        }
    }
    delete(key) {
        const value = this._cache[key];
        if (value) {
            delete this._cache[key];
            this._deleteOrder(key);
        }
    }
    _deleteOrder(key) {
        const index = this._order.indexOf(key);
        if (index >= 0) this._order.splice(index, 1);
    }
    _appendOrder(key) {
        this._order.push(key);
    }
    constructor(limit = 5){
        (0, $lEQUF.default)(this, "limit", void 0);
        (0, $lEQUF.default)(this, "_cache", {});
        (0, $lEQUF.default)(this, "_order", []);
        this.limit = limit;
    }
}

});


parcelRegister("1xAPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11f5725f748aea46$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $i46md = parcelRequire("i46md");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");
var $7gQQK = parcelRequire("7gQQK");

var $cxTxU = parcelRequire("cxTxU");
var $b2F4S = parcelRequire("b2F4S");

var $hhaan = parcelRequire("hhaan");

var $3ih6r = parcelRequire("3ih6r");
const $11f5725f748aea46$var$defaultProps = {
    billboard: true,
    sizeScale: 1,
    sizeUnits: "pixels",
    sizeMinPixels: 0,
    sizeMaxPixels: Number.MAX_SAFE_INTEGER,
    padding: {
        type: "array",
        value: [
            0,
            0,
            0,
            0
        ]
    },
    getPosition: {
        type: "accessor",
        value: (x)=>x.position
    },
    getSize: {
        type: "accessor",
        value: 1
    },
    getAngle: {
        type: "accessor",
        value: 0
    },
    getPixelOffset: {
        type: "accessor",
        value: [
            0,
            0
        ]
    },
    getBoundingRect: {
        type: "accessor",
        value: [
            0,
            0,
            0,
            0
        ]
    },
    getFillColor: {
        type: "accessor",
        value: [
            0,
            0,
            0,
            255
        ]
    },
    getLineColor: {
        type: "accessor",
        value: [
            0,
            0,
            0,
            255
        ]
    },
    getLineWidth: {
        type: "accessor",
        value: 1
    }
};
class $11f5725f748aea46$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getShaders() {
        return super.getShaders({
            vs: $hhaan.default,
            fs: $3ih6r.default,
            modules: [
                (0, $jRSMz.default),
                (0, $7UxuR.default)
            ]
        });
    }
    initializeState() {
        this.getAttributeManager().addInstanced({
            instancePositions: {
                size: 3,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: true,
                accessor: "getPosition"
            },
            instanceSizes: {
                size: 1,
                transition: true,
                accessor: "getSize",
                defaultValue: 1
            },
            instanceAngles: {
                size: 1,
                transition: true,
                accessor: "getAngle"
            },
            instanceRects: {
                size: 4,
                accessor: "getBoundingRect"
            },
            instancePixelOffsets: {
                size: 2,
                transition: true,
                accessor: "getPixelOffset"
            },
            instanceFillColors: {
                size: 4,
                transition: true,
                normalized: true,
                type: 5121,
                accessor: "getFillColor",
                defaultValue: [
                    0,
                    0,
                    0,
                    255
                ]
            },
            instanceLineColors: {
                size: 4,
                transition: true,
                normalized: true,
                type: 5121,
                accessor: "getLineColor",
                defaultValue: [
                    0,
                    0,
                    0,
                    255
                ]
            },
            instanceLineWidths: {
                size: 1,
                transition: true,
                accessor: "getLineWidth",
                defaultValue: 1
            }
        });
    }
    updateState(params) {
        super.updateState(params);
        const { changeFlags: changeFlags } = params;
        if (changeFlags.extensionsChanged) {
            var _this$state$model;
            const { gl: gl } = this.context;
            (_this$state$model = this.state.model) === null || _this$state$model === void 0 || _this$state$model.delete();
            this.state.model = this._getModel(gl);
            this.getAttributeManager().invalidateAll();
        }
    }
    draw({ uniforms: uniforms }) {
        const { billboard: billboard, sizeScale: sizeScale, sizeUnits: sizeUnits, sizeMinPixels: sizeMinPixels, sizeMaxPixels: sizeMaxPixels, getLineWidth: getLineWidth } = this.props;
        let { padding: padding } = this.props;
        if (padding.length < 4) padding = [
            padding[0],
            padding[1],
            padding[0],
            padding[1]
        ];
        this.state.model.setUniforms(uniforms).setUniforms({
            billboard: billboard,
            stroked: Boolean(getLineWidth),
            padding: padding,
            sizeUnits: (0, $7gQQK.UNIT)[sizeUnits],
            sizeScale: sizeScale,
            sizeMinPixels: sizeMinPixels,
            sizeMaxPixels: sizeMaxPixels
        }).draw();
    }
    _getModel(gl) {
        const positions = [
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ];
        return new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders()), {
            id: this.props.id,
            geometry: new (0, $cxTxU.default)({
                drawMode: 6,
                vertexCount: 4,
                attributes: {
                    positions: {
                        size: 2,
                        value: new Float32Array(positions)
                    }
                }
            }),
            isInstanced: true
        }));
    }
    constructor(...args){
        super(...args);
        (0, $lEQUF.default)(this, "state", void 0);
    }
}
(0, $lEQUF.default)($11f5725f748aea46$export$2e2bcd8739ae039, "defaultProps", $11f5725f748aea46$var$defaultProps);
(0, $lEQUF.default)($11f5725f748aea46$export$2e2bcd8739ae039, "layerName", "TextBackgroundLayer");

});
parcelRegister("hhaan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c93be90768b1913a$export$2e2bcd8739ae039; });
var $c93be90768b1913a$export$2e2bcd8739ae039 = "#define SHADER_NAME text-background-layer-vertex-shader\n\nattribute vec2 positions;\n\nattribute vec3 instancePositions;\nattribute vec3 instancePositions64Low;\nattribute vec4 instanceRects;\nattribute float instanceSizes;\nattribute float instanceAngles;\nattribute vec2 instancePixelOffsets;\nattribute float instanceLineWidths;\nattribute vec4 instanceFillColors;\nattribute vec4 instanceLineColors;\nattribute vec3 instancePickingColors;\n\nuniform bool billboard;\nuniform float opacity;\nuniform float sizeScale;\nuniform float sizeMinPixels;\nuniform float sizeMaxPixels;\nuniform vec4 padding;\nuniform int sizeUnits;\n\nvarying vec4 vFillColor;\nvarying vec4 vLineColor;\nvarying float vLineWidth;\nvarying vec2 uv;\nvarying vec2 dimensions;\n\nvec2 rotate_by_angle(vec2 vertex, float angle) {\n  float angle_radian = radians(angle);\n  float cos_angle = cos(angle_radian);\n  float sin_angle = sin(angle_radian);\n  mat2 rotationMatrix = mat2(cos_angle, -sin_angle, sin_angle, cos_angle);\n  return rotationMatrix * vertex;\n}\n\nvoid main(void) {\n  geometry.worldPosition = instancePositions;\n  geometry.uv = positions;\n  geometry.pickingColor = instancePickingColors;\n  uv = positions;\n  vLineWidth = instanceLineWidths;\n  float sizePixels = clamp(\n    project_size_to_pixel(instanceSizes * sizeScale, sizeUnits),\n    sizeMinPixels, sizeMaxPixels\n  );\n\n  dimensions = instanceRects.zw * sizePixels + padding.xy + padding.zw;\n\n  vec2 pixelOffset = (positions * instanceRects.zw + instanceRects.xy) * sizePixels + mix(-padding.xy, padding.zw, positions);\n  pixelOffset = rotate_by_angle(pixelOffset, instanceAngles);\n  pixelOffset += instancePixelOffsets;\n  pixelOffset.y *= -1.0;\n\n  if (billboard)  {\n    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);\n    DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n    vec3 offset = vec3(pixelOffset, 0.0);\n    DECKGL_FILTER_SIZE(offset, geometry);\n    gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);\n  } else {\n    vec3 offset_common = vec3(project_pixel_size(pixelOffset), 0.0);\n    DECKGL_FILTER_SIZE(offset_common, geometry);\n    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset_common, geometry.position);\n    DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n  }\n  vFillColor = vec4(instanceFillColors.rgb, instanceFillColors.a * opacity);\n  DECKGL_FILTER_COLOR(vFillColor, geometry);\n  vLineColor = vec4(instanceLineColors.rgb, instanceLineColors.a * opacity);\n  DECKGL_FILTER_COLOR(vLineColor, geometry);\n}\n";

});

parcelRegister("3ih6r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $266051d5b1c39edb$export$2e2bcd8739ae039; });
var $266051d5b1c39edb$export$2e2bcd8739ae039 = "#define SHADER_NAME text-background-layer-fragment-shader\n\nprecision highp float;\n\nuniform bool stroked;\n\nvarying vec4 vFillColor;\nvarying vec4 vLineColor;\nvarying float vLineWidth;\nvarying vec2 uv;\nvarying vec2 dimensions;\n\nvoid main(void) {\n  geometry.uv = uv;\n\n  vec2 pixelPosition = uv * dimensions;\n  if (stroked) {\n    float distToEdge = min(\n      min(pixelPosition.x, dimensions.x - pixelPosition.x),\n      min(pixelPosition.y, dimensions.y - pixelPosition.y)\n    );\n    float isBorder = smoothedge(distToEdge, vLineWidth);\n    gl_FragColor = mix(vFillColor, vLineColor, isBorder);\n  } else {\n    gl_FragColor = vFillColor;\n  }\n\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";

});




parcelRegister("hf80Y", function(module, exports) {

$parcel$export(module.exports, "getGeojsonFeatures", function () { return $c8da0df440d93107$export$216216e94774cbbf; });
$parcel$export(module.exports, "separateGeojsonFeatures", function () { return $c8da0df440d93107$export$990901b6a075c7ff; });

var $4VQgq = parcelRequire("4VQgq");
function $c8da0df440d93107$export$216216e94774cbbf(geojson) {
    if (Array.isArray(geojson)) return geojson;
    (0, $4VQgq.default).assert(geojson.type, "GeoJSON does not have type");
    switch(geojson.type){
        case "Feature":
            return [
                geojson
            ];
        case "FeatureCollection":
            (0, $4VQgq.default).assert(Array.isArray(geojson.features), "GeoJSON does not have features array");
            return geojson.features;
        default:
            return [
                {
                    geometry: geojson
                }
            ];
    }
}
function $c8da0df440d93107$export$990901b6a075c7ff(features, wrapFeature, dataRange = {}) {
    const separated = {
        pointFeatures: [],
        lineFeatures: [],
        polygonFeatures: [],
        polygonOutlineFeatures: []
    };
    const { startRow: startRow = 0, endRow: endRow = features.length } = dataRange;
    for(let featureIndex = startRow; featureIndex < endRow; featureIndex++){
        const feature = features[featureIndex];
        const { geometry: geometry } = feature;
        if (!geometry) continue;
        if (geometry.type === "GeometryCollection") {
            (0, $4VQgq.default).assert(Array.isArray(geometry.geometries), "GeoJSON does not have geometries array");
            const { geometries: geometries } = geometry;
            for(let i = 0; i < geometries.length; i++){
                const subGeometry = geometries[i];
                $c8da0df440d93107$var$separateGeometry(subGeometry, separated, wrapFeature, feature, featureIndex);
            }
        } else $c8da0df440d93107$var$separateGeometry(geometry, separated, wrapFeature, feature, featureIndex);
    }
    return separated;
}
function $c8da0df440d93107$var$separateGeometry(geometry, separated, wrapFeature, sourceFeature, sourceFeatureIndex) {
    const { type: type, coordinates: coordinates } = geometry;
    const { pointFeatures: pointFeatures, lineFeatures: lineFeatures, polygonFeatures: polygonFeatures, polygonOutlineFeatures: polygonOutlineFeatures } = separated;
    if (!$c8da0df440d93107$export$29eaf29d02a6830c(type, coordinates)) {
        (0, $4VQgq.default).warn("".concat(type, " coordinates are malformed"))();
        return;
    }
    switch(type){
        case "Point":
            pointFeatures.push(wrapFeature({
                geometry: geometry
            }, sourceFeature, sourceFeatureIndex));
            break;
        case "MultiPoint":
            coordinates.forEach((point)=>{
                pointFeatures.push(wrapFeature({
                    geometry: {
                        type: "Point",
                        coordinates: point
                    }
                }, sourceFeature, sourceFeatureIndex));
            });
            break;
        case "LineString":
            lineFeatures.push(wrapFeature({
                geometry: geometry
            }, sourceFeature, sourceFeatureIndex));
            break;
        case "MultiLineString":
            coordinates.forEach((path)=>{
                lineFeatures.push(wrapFeature({
                    geometry: {
                        type: "LineString",
                        coordinates: path
                    }
                }, sourceFeature, sourceFeatureIndex));
            });
            break;
        case "Polygon":
            polygonFeatures.push(wrapFeature({
                geometry: geometry
            }, sourceFeature, sourceFeatureIndex));
            coordinates.forEach((path)=>{
                polygonOutlineFeatures.push(wrapFeature({
                    geometry: {
                        type: "LineString",
                        coordinates: path
                    }
                }, sourceFeature, sourceFeatureIndex));
            });
            break;
        case "MultiPolygon":
            coordinates.forEach((polygon)=>{
                polygonFeatures.push(wrapFeature({
                    geometry: {
                        type: "Polygon",
                        coordinates: polygon
                    }
                }, sourceFeature, sourceFeatureIndex));
                polygon.forEach((path)=>{
                    polygonOutlineFeatures.push(wrapFeature({
                        geometry: {
                            type: "LineString",
                            coordinates: path
                        }
                    }, sourceFeature, sourceFeatureIndex));
                });
            });
            break;
        default:
    }
}
const $c8da0df440d93107$var$COORDINATE_NEST_LEVEL = {
    Point: 1,
    MultiPoint: 2,
    LineString: 2,
    MultiLineString: 3,
    Polygon: 3,
    MultiPolygon: 4
};
function $c8da0df440d93107$export$29eaf29d02a6830c(type, coordinates) {
    let nestLevel = $c8da0df440d93107$var$COORDINATE_NEST_LEVEL[type];
    (0, $4VQgq.default).assert(nestLevel, "Unknown GeoJSON type ".concat(type));
    while(coordinates && --nestLevel > 0)coordinates = coordinates[0];
    return coordinates && Number.isFinite(coordinates[0]);
}

});

parcelRegister("8rldy", function(module, exports) {

$parcel$export(module.exports, "createLayerPropsFromFeatures", function () { return $62514db782e6c447$export$3dfb2307ba5294fe; });
$parcel$export(module.exports, "createLayerPropsFromBinary", function () { return $62514db782e6c447$export$4b887125b3ad5b1b; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $cyxHD = parcelRequire("cyxHD");
function $62514db782e6c447$var$createEmptyLayerProps() {
    return {
        points: {},
        lines: {},
        polygons: {},
        polygonsOutline: {}
    };
}
function $62514db782e6c447$var$getCoordinates(f) {
    return f.geometry.coordinates;
}
function $62514db782e6c447$export$3dfb2307ba5294fe(features, featuresDiff) {
    const layerProps = $62514db782e6c447$var$createEmptyLayerProps();
    const { pointFeatures: pointFeatures, lineFeatures: lineFeatures, polygonFeatures: polygonFeatures, polygonOutlineFeatures: polygonOutlineFeatures } = features;
    layerProps.points.data = pointFeatures;
    layerProps.points._dataDiff = featuresDiff.pointFeatures && (()=>featuresDiff.pointFeatures);
    layerProps.points.getPosition = $62514db782e6c447$var$getCoordinates;
    layerProps.lines.data = lineFeatures;
    layerProps.lines._dataDiff = featuresDiff.lineFeatures && (()=>featuresDiff.lineFeatures);
    layerProps.lines.getPath = $62514db782e6c447$var$getCoordinates;
    layerProps.polygons.data = polygonFeatures;
    layerProps.polygons._dataDiff = featuresDiff.polygonFeatures && (()=>featuresDiff.polygonFeatures);
    layerProps.polygons.getPolygon = $62514db782e6c447$var$getCoordinates;
    layerProps.polygonsOutline.data = polygonOutlineFeatures;
    layerProps.polygonsOutline._dataDiff = featuresDiff.polygonOutlineFeatures && (()=>featuresDiff.polygonOutlineFeatures);
    layerProps.polygonsOutline.getPath = $62514db782e6c447$var$getCoordinates;
    return layerProps;
}
function $62514db782e6c447$export$4b887125b3ad5b1b(geojsonBinary, encodePickingColor) {
    const layerProps = $62514db782e6c447$var$createEmptyLayerProps();
    const { points: points, lines: lines, polygons: polygons } = geojsonBinary;
    const customPickingColors = (0, $cyxHD.calculatePickingColors)(geojsonBinary, encodePickingColor);
    layerProps.points.data = {
        length: points.positions.value.length / points.positions.size,
        attributes: (0, $edHbI._)((0, $2QP2i._)({}, points.attributes), {
            getPosition: points.positions,
            instancePickingColors: {
                size: 3,
                value: customPickingColors.points
            }
        }),
        properties: points.properties,
        numericProps: points.numericProps,
        featureIds: points.featureIds
    };
    layerProps.lines.data = {
        length: lines.pathIndices.value.length - 1,
        startIndices: lines.pathIndices.value,
        attributes: (0, $edHbI._)((0, $2QP2i._)({}, lines.attributes), {
            getPath: lines.positions,
            instancePickingColors: {
                size: 3,
                value: customPickingColors.lines
            }
        }),
        properties: lines.properties,
        numericProps: lines.numericProps,
        featureIds: lines.featureIds
    };
    layerProps.lines._pathType = "open";
    layerProps.polygons.data = {
        length: polygons.polygonIndices.value.length - 1,
        startIndices: polygons.polygonIndices.value,
        attributes: (0, $edHbI._)((0, $2QP2i._)({}, polygons.attributes), {
            getPolygon: polygons.positions,
            pickingColors: {
                size: 3,
                value: customPickingColors.polygons
            }
        }),
        properties: polygons.properties,
        numericProps: polygons.numericProps,
        featureIds: polygons.featureIds
    };
    layerProps.polygons._normalize = false;
    if (polygons.triangles) layerProps.polygons.data.attributes.indices = polygons.triangles.value;
    layerProps.polygonsOutline.data = {
        length: polygons.primitivePolygonIndices.value.length - 1,
        startIndices: polygons.primitivePolygonIndices.value,
        attributes: (0, $edHbI._)((0, $2QP2i._)({}, polygons.attributes), {
            getPath: polygons.positions,
            instancePickingColors: {
                size: 3,
                value: customPickingColors.polygons
            }
        }),
        properties: polygons.properties,
        numericProps: polygons.numericProps,
        featureIds: polygons.featureIds
    };
    layerProps.polygonsOutline._pathType = "open";
    return layerProps;
}

});


parcelRegister("cQSdn", function(module, exports) {
"use strict";
function $95b465442bbdc135$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $95b465442bbdc135$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $95b465442bbdc135$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $95b465442bbdc135$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GeoJsonEditMode", {
    enumerable: true,
    get: function get() {
        return $1tPZO.GeoJsonEditMode;
    }
});
Object.defineProperty(module.exports, "ModifyMode", {
    enumerable: true,
    get: function get() {
        return $gFC9Z.ModifyMode;
    }
});
Object.defineProperty(module.exports, "ResizeCircleMode", {
    enumerable: true,
    get: function get() {
        return $dm5qM.ResizeCircleMode;
    }
});
Object.defineProperty(module.exports, "TranslateMode", {
    enumerable: true,
    get: function get() {
        return $lWzrG.TranslateMode;
    }
});
Object.defineProperty(module.exports, "ScaleMode", {
    enumerable: true,
    get: function get() {
        return $ljwRq.ScaleMode;
    }
});
Object.defineProperty(module.exports, "RotateMode", {
    enumerable: true,
    get: function get() {
        return $cjd37.RotateMode;
    }
});
Object.defineProperty(module.exports, "DuplicateMode", {
    enumerable: true,
    get: function get() {
        return $44vWS.DuplicateMode;
    }
});
Object.defineProperty(module.exports, "ExtendLineStringMode", {
    enumerable: true,
    get: function get() {
        return $iS49Q.ExtendLineStringMode;
    }
});
Object.defineProperty(module.exports, "SplitPolygonMode", {
    enumerable: true,
    get: function get() {
        return $jW3FH.SplitPolygonMode;
    }
});
Object.defineProperty(module.exports, "ExtrudeMode", {
    enumerable: true,
    get: function get() {
        return $8Gejd.ExtrudeMode;
    }
});
Object.defineProperty(module.exports, "ElevationMode", {
    enumerable: true,
    get: function get() {
        return $bmi4Q.ElevationMode;
    }
});
Object.defineProperty(module.exports, "TransformMode", {
    enumerable: true,
    get: function get() {
        return $8dTIP.TransformMode;
    }
});
Object.defineProperty(module.exports, "DrawPointMode", {
    enumerable: true,
    get: function get() {
        return $8Vy0o.DrawPointMode;
    }
});
Object.defineProperty(module.exports, "DrawLineStringMode", {
    enumerable: true,
    get: function get() {
        return $4qOqT.DrawLineStringMode;
    }
});
Object.defineProperty(module.exports, "DrawPolygonMode", {
    enumerable: true,
    get: function get() {
        return $fVfme.DrawPolygonMode;
    }
});
Object.defineProperty(module.exports, "DrawRectangleMode", {
    enumerable: true,
    get: function get() {
        return $4pNaf.DrawRectangleMode;
    }
});
Object.defineProperty(module.exports, "DrawSquareMode", {
    enumerable: true,
    get: function get() {
        return $87lGF.DrawSquareMode;
    }
});
Object.defineProperty(module.exports, "DrawRectangleFromCenterMode", {
    enumerable: true,
    get: function get() {
        return $clLbb.DrawRectangleFromCenterMode;
    }
});
Object.defineProperty(module.exports, "DrawSquareFromCenterMode", {
    enumerable: true,
    get: function get() {
        return $iMVab.DrawSquareFromCenterMode;
    }
});
Object.defineProperty(module.exports, "DrawCircleByDiameterMode", {
    enumerable: true,
    get: function get() {
        return $aS0fb.DrawCircleByDiameterMode;
    }
});
Object.defineProperty(module.exports, "DrawCircleFromCenterMode", {
    enumerable: true,
    get: function get() {
        return $ca4GA.DrawCircleFromCenterMode;
    }
});
Object.defineProperty(module.exports, "DrawEllipseByBoundingBoxMode", {
    enumerable: true,
    get: function get() {
        return $7sSbx.DrawEllipseByBoundingBoxMode;
    }
});
Object.defineProperty(module.exports, "DrawEllipseUsingThreePointsMode", {
    enumerable: true,
    get: function get() {
        return $eypkN.DrawEllipseUsingThreePointsMode;
    }
});
Object.defineProperty(module.exports, "DrawRectangleUsingThreePointsMode", {
    enumerable: true,
    get: function get() {
        return $9wvMY.DrawRectangleUsingThreePointsMode;
    }
});
Object.defineProperty(module.exports, "Draw90DegreePolygonMode", {
    enumerable: true,
    get: function get() {
        return $9qPDu.Draw90DegreePolygonMode;
    }
});
Object.defineProperty(module.exports, "DrawPolygonByDraggingMode", {
    enumerable: true,
    get: function get() {
        return $kfRKf.DrawPolygonByDraggingMode;
    }
});
Object.defineProperty(module.exports, "ImmutableFeatureCollection", {
    enumerable: true,
    get: function get() {
        return $eJgQU.ImmutableFeatureCollection;
    }
});
Object.defineProperty(module.exports, "ViewMode", {
    enumerable: true,
    get: function get() {
        return $ksxR2.ViewMode;
    }
});
Object.defineProperty(module.exports, "MeasureDistanceMode", {
    enumerable: true,
    get: function get() {
        return $hva1l.MeasureDistanceMode;
    }
});
Object.defineProperty(module.exports, "MeasureAreaMode", {
    enumerable: true,
    get: function get() {
        return $dZhwn.MeasureAreaMode;
    }
});
Object.defineProperty(module.exports, "MeasureAngleMode", {
    enumerable: true,
    get: function get() {
        return $h2dZX.MeasureAngleMode;
    }
});
Object.defineProperty(module.exports, "CompositeMode", {
    enumerable: true,
    get: function get() {
        return $6J4Ij.CompositeMode;
    }
});
Object.defineProperty(module.exports, "SnappableMode", {
    enumerable: true,
    get: function get() {
        return $enK8I.SnappableMode;
    }
});
Object.defineProperty(module.exports, "_memoize", {
    enumerable: true,
    get: function get() {
        return $95b465442bbdc135$var$_memoize["default"];
    }
});
module.exports.utils = void 0;

var $1tPZO = parcelRequire("1tPZO");

var $gFC9Z = parcelRequire("gFC9Z");

var $dm5qM = parcelRequire("dm5qM");

var $lWzrG = parcelRequire("lWzrG");

var $ljwRq = parcelRequire("ljwRq");

var $cjd37 = parcelRequire("cjd37");

var $44vWS = parcelRequire("44vWS");

var $iS49Q = parcelRequire("iS49Q");

var $jW3FH = parcelRequire("jW3FH");

var $8Gejd = parcelRequire("8Gejd");

var $bmi4Q = parcelRequire("bmi4Q");

var $8dTIP = parcelRequire("8dTIP");

var $8Vy0o = parcelRequire("8Vy0o");

var $4qOqT = parcelRequire("4qOqT");

var $fVfme = parcelRequire("fVfme");

var $4pNaf = parcelRequire("4pNaf");

var $87lGF = parcelRequire("87lGF");

var $clLbb = parcelRequire("clLbb");

var $iMVab = parcelRequire("iMVab");

var $aS0fb = parcelRequire("aS0fb");

var $ca4GA = parcelRequire("ca4GA");

var $7sSbx = parcelRequire("7sSbx");

var $eypkN = parcelRequire("eypkN");

var $9wvMY = parcelRequire("9wvMY");

var $9qPDu = parcelRequire("9qPDu");

var $kfRKf = parcelRequire("kfRKf");

var $eJgQU = parcelRequire("eJgQU");

var $ksxR2 = parcelRequire("ksxR2");

var $hva1l = parcelRequire("hva1l");

var $dZhwn = parcelRequire("dZhwn");

var $h2dZX = parcelRequire("h2dZX");

var $6J4Ij = parcelRequire("6J4Ij");

var $enK8I = parcelRequire("enK8I");

var $95b465442bbdc135$var$_memoize = $95b465442bbdc135$var$_interopRequireDefault((parcelRequire("7zWhR")));

var $95b465442bbdc135$var$utils = $95b465442bbdc135$var$_interopRequireWildcard((parcelRequire("hs5Hv")));
module.exports.utils = $95b465442bbdc135$var$utils;
function $95b465442bbdc135$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $95b465442bbdc135$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $95b465442bbdc135$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $95b465442bbdc135$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $95b465442bbdc135$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $95b465442bbdc135$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("1tPZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getIntermediatePosition = $1140d53340a523c6$var$getIntermediatePosition;
module.exports.GeoJsonEditMode = void 0;

var $1140d53340a523c6$var$_union = $1140d53340a523c6$var$_interopRequireDefault((parcelRequire("3lP9u")));

var $1140d53340a523c6$var$_difference = $1140d53340a523c6$var$_interopRequireDefault((parcelRequire("gZv4c")));

var $1140d53340a523c6$var$_intersect = $1140d53340a523c6$var$_interopRequireDefault((parcelRequire("bQG2Y")));

var $1140d53340a523c6$var$_rewind = $1140d53340a523c6$var$_interopRequireDefault((parcelRequire("6Jlxv")));

var $hs5Hv = parcelRequire("hs5Hv");

var $eJgQU = parcelRequire("eJgQU");
function $1140d53340a523c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1140d53340a523c6$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $1140d53340a523c6$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $1140d53340a523c6$var$_toConsumableArray(arr) {
    return $1140d53340a523c6$var$_arrayWithoutHoles(arr) || $1140d53340a523c6$var$_iterableToArray(arr) || $1140d53340a523c6$var$_unsupportedIterableToArray(arr) || $1140d53340a523c6$var$_nonIterableSpread();
}
function $1140d53340a523c6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1140d53340a523c6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1140d53340a523c6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1140d53340a523c6$var$_arrayLikeToArray(o, minLen);
}
function $1140d53340a523c6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $1140d53340a523c6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1140d53340a523c6$var$_arrayLikeToArray(arr);
}
function $1140d53340a523c6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1140d53340a523c6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1140d53340a523c6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1140d53340a523c6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1140d53340a523c6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1140d53340a523c6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1140d53340a523c6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1140d53340a523c6$var$DEFAULT_GUIDES = {
    type: "FeatureCollection",
    features: []
};
var $1140d53340a523c6$var$DEFAULT_TOOLTIPS = []; // Main interface for `EditMode`s that edit GeoJSON
var $1140d53340a523c6$var$GeoJsonEditMode = /*#__PURE__*/ function() {
    function GeoJsonEditMode() {
        $1140d53340a523c6$var$_classCallCheck(this, GeoJsonEditMode);
        $1140d53340a523c6$var$_defineProperty(this, "_clickSequence", []);
    }
    $1140d53340a523c6$var$_createClass(GeoJsonEditMode, [
        {
            key: "getGuides",
            value: function getGuides(props) {
                return $1140d53340a523c6$var$DEFAULT_GUIDES;
            }
        },
        {
            key: "getTooltips",
            value: function getTooltips(props) {
                return $1140d53340a523c6$var$DEFAULT_TOOLTIPS;
            }
        },
        {
            key: "getSelectedFeature",
            value: function getSelectedFeature(props) {
                if (props.selectedIndexes.length === 1) return props.data.features[props.selectedIndexes[0]];
                return null;
            }
        },
        {
            key: "getSelectedGeometry",
            value: function getSelectedGeometry(props) {
                var feature = this.getSelectedFeature(props);
                if (feature) return feature.geometry;
                return null;
            }
        },
        {
            key: "getSelectedFeaturesAsFeatureCollection",
            value: function getSelectedFeaturesAsFeatureCollection(props) {
                var features = props.data.features;
                var selectedFeatures = props.selectedIndexes.map(function(selectedIndex) {
                    return features[selectedIndex];
                });
                return {
                    type: "FeatureCollection",
                    features: selectedFeatures
                };
            }
        },
        {
            key: "getClickSequence",
            value: function getClickSequence() {
                return this._clickSequence;
            }
        },
        {
            key: "addClickSequence",
            value: function addClickSequence(_ref) {
                var mapCoords = _ref.mapCoords;
                this._clickSequence.push(mapCoords);
            }
        },
        {
            key: "resetClickSequence",
            value: function resetClickSequence() {
                this._clickSequence = [];
            }
        },
        {
            key: "getTentativeGuide",
            value: function getTentativeGuide(props) {
                var guides = this.getGuides(props); // @ts-ignore
                return guides.features.find(function(f) {
                    return f.properties && f.properties.guideType === "tentative";
                });
            }
        },
        {
            key: "isSelectionPicked",
            value: function isSelectionPicked(picks, props) {
                if (!picks.length) return false;
                var pickedFeatures = (0, $hs5Hv.getNonGuidePicks)(picks).map(function(_ref2) {
                    var index = _ref2.index;
                    return index;
                });
                var pickedHandles = (0, $hs5Hv.getPickedEditHandles)(picks).map(function(_ref3) {
                    var properties = _ref3.properties;
                    return properties.featureIndex;
                });
                var pickedIndexes = new Set([].concat($1140d53340a523c6$var$_toConsumableArray(pickedFeatures), $1140d53340a523c6$var$_toConsumableArray(pickedHandles)));
                return props.selectedIndexes.some(function(index) {
                    return pickedIndexes.has(index);
                });
            }
        },
        {
            key: "rewindPolygon",
            value: function rewindPolygon(feature) {
                var geometry = feature.geometry;
                var isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
                if (isPolygonal) // @ts-ignore
                return (0, $1140d53340a523c6$var$_rewind["default"])(feature);
                return feature;
            }
        },
        {
            key: "getAddFeatureAction",
            value: function getAddFeatureAction(featureOrGeometry, features) {
                // Unsure why flow can't deal with Geometry type, but there I fixed it
                var featureOrGeometryAsAny = featureOrGeometry;
                var feature = featureOrGeometryAsAny.type === "Feature" ? featureOrGeometryAsAny : {
                    type: "Feature",
                    properties: {},
                    geometry: featureOrGeometryAsAny
                };
                var rewindFeature = this.rewindPolygon(feature);
                var updatedData = new $eJgQU.ImmutableFeatureCollection(features).addFeature(rewindFeature).getObject();
                return {
                    updatedData: updatedData,
                    editType: "addFeature",
                    editContext: {
                        featureIndexes: [
                            updatedData.features.length - 1
                        ]
                    }
                };
            }
        },
        {
            key: "getAddManyFeaturesAction",
            value: function getAddManyFeaturesAction(_ref4, features) {
                var featuresToAdd = _ref4.features;
                var updatedData = new $eJgQU.ImmutableFeatureCollection(features);
                var initialIndex = updatedData.getObject().features.length;
                var updatedIndexes = [];
                var _iterator = $1140d53340a523c6$var$_createForOfIteratorHelper(featuresToAdd), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var feature = _step.value;
                        var properties = feature.properties, geometry = feature.geometry;
                        var geometryAsAny = geometry;
                        updatedData = updatedData.addFeature({
                            type: "Feature",
                            properties: properties,
                            geometry: geometryAsAny
                        });
                        updatedIndexes.push(initialIndex + updatedIndexes.length);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return {
                    updatedData: updatedData.getObject(),
                    editType: "addFeature",
                    editContext: {
                        featureIndexes: updatedIndexes
                    }
                };
            }
        },
        {
            key: "getAddFeatureOrBooleanPolygonAction",
            value: function getAddFeatureOrBooleanPolygonAction(featureOrGeometry, props) {
                var featureOrGeometryAsAny = featureOrGeometry;
                var selectedFeature = this.getSelectedFeature(props);
                var modeConfig = props.modeConfig;
                if (modeConfig && modeConfig.booleanOperation) {
                    if (!selectedFeature || selectedFeature.geometry.type !== "Polygon" && selectedFeature.geometry.type !== "MultiPolygon") {
                        // eslint-disable-next-line no-console,no-undef
                        console.warn("booleanOperation only supported for single Polygon or MultiPolygon selection");
                        return null;
                    }
                    var feature = featureOrGeometryAsAny.type === "Feature" ? featureOrGeometryAsAny : {
                        type: "Feature",
                        geometry: featureOrGeometryAsAny
                    };
                    var updatedGeometry;
                    if (modeConfig.booleanOperation === "union") updatedGeometry = (0, $1140d53340a523c6$var$_union["default"])(selectedFeature, feature);
                    else if (modeConfig.booleanOperation === "difference") // @ts-ignore
                    updatedGeometry = (0, $1140d53340a523c6$var$_difference["default"])(selectedFeature, feature);
                    else if (modeConfig.booleanOperation === "intersection") // @ts-ignore
                    updatedGeometry = (0, $1140d53340a523c6$var$_intersect["default"])(selectedFeature, feature);
                    else {
                        // eslint-disable-next-line no-console,no-undef
                        console.warn("Invalid booleanOperation ".concat(modeConfig.booleanOperation));
                        return null;
                    }
                    if (!updatedGeometry) {
                        // eslint-disable-next-line no-console,no-undef
                        console.warn("Canceling edit. Boolean operation erased entire polygon.");
                        return null;
                    }
                    var featureIndex = props.selectedIndexes[0];
                    var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).replaceGeometry(featureIndex, updatedGeometry.geometry).getObject();
                    var editAction = {
                        updatedData: updatedData,
                        editType: "unionGeometry",
                        editContext: {
                            featureIndexes: [
                                featureIndex
                            ]
                        }
                    };
                    return editAction;
                }
                return this.getAddFeatureAction(featureOrGeometry, props.data);
            }
        },
        {
            key: "createTentativeFeature",
            value: function createTentativeFeature(props) {
                return null;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {}
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                var tentativeFeature = this.createTentativeFeature(props);
                if (tentativeFeature) props.onEdit({
                    updatedData: props.data,
                    editType: "updateTentativeFeature",
                    editContext: {
                        feature: tentativeFeature
                    }
                });
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {}
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {}
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {}
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(event, props) {
                if (event.key === "Escape") {
                    this.resetClickSequence();
                    props.onEdit({
                        // Because the new drawing feature is dropped, so the data will keep as the same.
                        updatedData: props.data,
                        editType: "cancelFeature",
                        editContext: {}
                    });
                }
            }
        }
    ]);
    return GeoJsonEditMode;
}();
module.exports.GeoJsonEditMode = $1140d53340a523c6$var$GeoJsonEditMode;
function $1140d53340a523c6$var$getIntermediatePosition(position1, position2) {
    var intermediatePosition = [
        (position1[0] + position2[0]) / 2.0,
        (position1[1] + position2[1]) / 2.0
    ]; // @ts-ignore
    return intermediatePosition;
}

});
parcelRegister("3lP9u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ahY8G = parcelRequire("ahY8G");

var $8abqV = parcelRequire("8abqV");

var $7GKQS = parcelRequire("7GKQS");
/**
 * Takes two {@link (Multi)Polygon(s)} and returns a combined polygon. If the input polygons are not contiguous, this function returns a {@link MultiPolygon} feature.
 *
 * @name union
 * @param {Feature<Polygon|MultiPolygon>} polygon1 input Polygon feature
 * @param {Feature<Polygon|MultiPolygon>} polygon2 Polygon feature to difference from polygon1
 * @param {Object} [options={}] Optional Parameters
 * @param {Object} [options.properties={}] Translate Properties to output Feature
 * @returns {Feature<(Polygon|MultiPolygon)>} a combined {@link Polygon} or {@link MultiPolygon} feature
 * @example
 * var poly1 = turf.polygon([[
 *     [-82.574787, 35.594087],
 *     [-82.574787, 35.615581],
 *     [-82.545261, 35.615581],
 *     [-82.545261, 35.594087],
 *     [-82.574787, 35.594087]
 * ]], {"fill": "#0f0"});
 * var poly2 = turf.polygon([[
 *     [-82.560024, 35.585153],
 *     [-82.560024, 35.602602],
 *     [-82.52964, 35.602602],
 *     [-82.52964, 35.585153],
 *     [-82.560024, 35.585153]
 * ]], {"fill": "#00f"});
 *
 * var union = turf.union(poly1, poly2);
 *
 * //addToMap
 * var addToMap = [poly1, poly2, union];
 */ function $270b02fea83b1911$var$union(polygon1, polygon2, options) {
    if (options === void 0) options = {};
    var coords1 = $8abqV.getGeom(polygon1).coordinates;
    var coords2 = $8abqV.getGeom(polygon2).coordinates;
    var unioned = $ahY8G.union(coords1, coords2);
    if (unioned.length === 0) return null;
    if (unioned.length === 1) return $7GKQS.polygon(unioned[0], options.properties);
    else return $7GKQS.multiPolygon(unioned, options.properties);
}
module.exports.default = $270b02fea83b1911$var$union;

});

parcelRegister("bQG2Y", function(module, exports) {
"use strict";
var $8a052aabd7f0cd40$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");

var $8a052aabd7f0cd40$var$martinez = $8a052aabd7f0cd40$var$__importStar((parcelRequire("ahY8G")));
/**
 * Takes two {@link Polygon|polygon} or {@link MultiPolygon|multi-polygon} geometries and
 * finds their polygonal intersection. If they don't intersect, returns null.
 *
 * @name intersect
 * @param {Feature<Polygon | MultiPolygon>} poly1 the first polygon or multipolygon
 * @param {Feature<Polygon | MultiPolygon>} poly2 the second polygon or multipolygon
 * @param {Object} [options={}] Optional Parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Feature
 * @returns {Feature|null} returns a feature representing the area they share (either a {@link Polygon} or
 * {@link MultiPolygon}). If they do not share any area, returns `null`.
 * @example
 * var poly1 = turf.polygon([[
 *   [-122.801742, 45.48565],
 *   [-122.801742, 45.60491],
 *   [-122.584762, 45.60491],
 *   [-122.584762, 45.48565],
 *   [-122.801742, 45.48565]
 * ]]);
 *
 * var poly2 = turf.polygon([[
 *   [-122.520217, 45.535693],
 *   [-122.64038, 45.553967],
 *   [-122.720031, 45.526554],
 *   [-122.669906, 45.507309],
 *   [-122.723464, 45.446643],
 *   [-122.532577, 45.408574],
 *   [-122.487258, 45.477466],
 *   [-122.520217, 45.535693]
 * ]]);
 *
 * var intersection = turf.intersect(poly1, poly2);
 *
 * //addToMap
 * var addToMap = [poly1, poly2, intersection];
 */ function $8a052aabd7f0cd40$var$intersect(poly1, poly2, options) {
    if (options === void 0) options = {};
    var geom1 = $8abqV.getGeom(poly1);
    var geom2 = $8abqV.getGeom(poly2);
    if (geom1.type === "Polygon" && geom2.type === "Polygon") {
        var intersection = $8a052aabd7f0cd40$var$martinez.intersection(geom1.coordinates, geom2.coordinates);
        if (intersection === null || intersection.length === 0) return null;
        if (intersection.length === 1) {
            var start = intersection[0][0][0];
            var end = intersection[0][0][intersection[0][0].length - 1];
            if (start[0] === end[0] && start[1] === end[1]) return $7GKQS.polygon(intersection[0], options.properties);
            return null;
        }
        return $7GKQS.multiPolygon(intersection, options.properties);
    } else if (geom1.type === "MultiPolygon") {
        var resultCoords = [];
        // iterate through the polygon and run intersect with each part, adding to the resultCoords.
        for(var _i = 0, _a = geom1.coordinates; _i < _a.length; _i++){
            var coords = _a[_i];
            var subGeom = $8abqV.getGeom($7GKQS.polygon(coords));
            var subIntersection = $8a052aabd7f0cd40$var$intersect(subGeom, geom2);
            if (subIntersection) {
                var subIntGeom = $8abqV.getGeom(subIntersection);
                if (subIntGeom.type === "Polygon") resultCoords.push(subIntGeom.coordinates);
                else if (subIntGeom.type === "MultiPolygon") resultCoords = resultCoords.concat(subIntGeom.coordinates);
                else throw new Error("intersection is invalid");
            }
        }
        // Make a polygon with the result
        if (resultCoords.length === 0) return null;
        if (resultCoords.length === 1) return $7GKQS.polygon(resultCoords[0], options.properties);
        else return $7GKQS.multiPolygon(resultCoords, options.properties);
    } else if (geom2.type === "MultiPolygon") // geom1 is a polygon and geom2 a multiPolygon,
    // put the multiPolygon first and fallback to the previous case.
    return $8a052aabd7f0cd40$var$intersect(geom2, geom1);
    else // handle invalid geometry types
    throw new Error("poly1 and poly2 must be either polygons or multiPolygons");
}
module.exports.default = $8a052aabd7f0cd40$var$intersect;

});

parcelRegister("6Jlxv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4e67a75176238153$export$2e2bcd8739ae039; });

var $asTyQ = parcelRequire("asTyQ");

var $54sVM = parcelRequire("54sVM");

var $f8xmd = parcelRequire("f8xmd");

var $gtJiw = parcelRequire("gtJiw");

var $bcb8J = parcelRequire("bcb8J");
/**
 * Rewind {@link LineString|(Multi)LineString} or {@link Polygon|(Multi)Polygon} outer ring counterclockwise and inner rings clockwise (Uses {@link http://en.wikipedia.org/wiki/Shoelace_formula|Shoelace Formula}).
 *
 * @name rewind
 * @param {GeoJSON} geojson input GeoJSON Polygon
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.reverse=false] enable reverse winding
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} rewind Polygon
 * @example
 * var polygon = turf.polygon([[[121, -29], [138, -29], [138, -18], [121, -18], [121, -29]]]);
 *
 * var rewind = turf.rewind(polygon);
 *
 * //addToMap
 * var addToMap = [rewind];
 */ function $4e67a75176238153$var$rewind(geojson, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $bcb8J.isObject)(options)) throw new Error("options is invalid");
    var reverse = options.reverse || false;
    var mutate = options.mutate || false;
    // validation
    if (!geojson) throw new Error("<geojson> is required");
    if (typeof reverse !== "boolean") throw new Error("<reverse> must be a boolean");
    if (typeof mutate !== "boolean") throw new Error("<mutate> must be a boolean");
    // prevent input mutation
    if (mutate === false) geojson = (0, $asTyQ.default)(geojson);
    // Support Feature Collection or Geometry Collection
    var results = [];
    switch(geojson.type){
        case "GeometryCollection":
            (0, $f8xmd.geomEach)(geojson, function(geometry) {
                $4e67a75176238153$var$rewindFeature(geometry, reverse);
            });
            return geojson;
        case "FeatureCollection":
            (0, $f8xmd.featureEach)(geojson, function(feature) {
                (0, $f8xmd.featureEach)($4e67a75176238153$var$rewindFeature(feature, reverse), function(result) {
                    results.push(result);
                });
            });
            return (0, $bcb8J.featureCollection)(results);
    }
    // Support Feature or Geometry Objects
    return $4e67a75176238153$var$rewindFeature(geojson, reverse);
}
/**
 * Rewind
 *
 * @private
 * @param {Geometry|Feature<any>} geojson Geometry or Feature
 * @param {Boolean} [reverse=false] enable reverse winding
 * @returns {Geometry|Feature<any>} rewind Geometry or Feature
 */ function $4e67a75176238153$var$rewindFeature(geojson, reverse) {
    var type = geojson.type === "Feature" ? geojson.geometry.type : geojson.type;
    // Support all GeoJSON Geometry Objects
    switch(type){
        case "GeometryCollection":
            (0, $f8xmd.geomEach)(geojson, function(geometry) {
                $4e67a75176238153$var$rewindFeature(geometry, reverse);
            });
            return geojson;
        case "LineString":
            $4e67a75176238153$var$rewindLineString((0, $gtJiw.getCoords)(geojson), reverse);
            return geojson;
        case "Polygon":
            $4e67a75176238153$var$rewindPolygon((0, $gtJiw.getCoords)(geojson), reverse);
            return geojson;
        case "MultiLineString":
            (0, $gtJiw.getCoords)(geojson).forEach(function(lineCoords) {
                $4e67a75176238153$var$rewindLineString(lineCoords, reverse);
            });
            return geojson;
        case "MultiPolygon":
            (0, $gtJiw.getCoords)(geojson).forEach(function(lineCoords) {
                $4e67a75176238153$var$rewindPolygon(lineCoords, reverse);
            });
            return geojson;
        case "Point":
        case "MultiPoint":
            return geojson;
    }
}
/**
 * Rewind LineString - outer ring clockwise
 *
 * @private
 * @param {Array<Array<number>>} coords GeoJSON LineString geometry coordinates
 * @param {Boolean} [reverse=false] enable reverse winding
 * @returns {void} mutates coordinates
 */ function $4e67a75176238153$var$rewindLineString(coords, reverse) {
    if ((0, $54sVM.default)(coords) === reverse) coords.reverse();
}
/**
 * Rewind Polygon - outer ring counterclockwise and inner rings clockwise.
 *
 * @private
 * @param {Array<Array<Array<number>>>} coords GeoJSON Polygon geometry coordinates
 * @param {Boolean} [reverse=false] enable reverse winding
 * @returns {void} mutates coordinates
 */ function $4e67a75176238153$var$rewindPolygon(coords, reverse) {
    // outer ring
    if ((0, $54sVM.default)(coords[0]) !== reverse) coords[0].reverse();
    // inner rings
    for(var i = 1; i < coords.length; i++)if ((0, $54sVM.default)(coords[i]) === reverse) coords[i].reverse();
}
var $4e67a75176238153$export$2e2bcd8739ae039 = $4e67a75176238153$var$rewind;

});
parcelRegister("54sVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b13c48c1bf7f489$export$2e2bcd8739ae039; });

var $buBa6 = parcelRequire("buBa6");
/**
 * Takes a ring and return true or false whether or not the ring is clockwise or counter-clockwise.
 *
 * @name booleanClockwise
 * @param {Feature<LineString>} line to be evaluated
 * @returns {boolean} true/false
 * @example
 * var clockwiseRing = turf.lineString([[0,0],[1,1],[1,0],[0,0]]);
 * var counterClockwiseRing = turf.lineString([[0,0],[1,0],[1,1],[0,0]]);
 *
 * turf.booleanClockwise(clockwiseRing)
 * //=true
 * turf.booleanClockwise(counterClockwiseRing)
 * //=false
 */ function $3b13c48c1bf7f489$var$booleanClockwise(line) {
    // validation
    if (!line) throw new Error("line is required");
    var type = line.geometry ? line.geometry.type : line.type;
    if (!Array.isArray(line) && type !== "LineString") throw new Error("geometry must be a LineString");
    var ring = (0, $buBa6.getCoords)(line);
    var sum = 0;
    var i = 1;
    var prev, cur;
    while(i < ring.length){
        prev = cur || ring[0];
        cur = ring[i];
        sum += (cur[0] - prev[0]) * (cur[1] + prev[1]);
        i++;
    }
    return sum > 0;
}
var $3b13c48c1bf7f489$export$2e2bcd8739ae039 = $3b13c48c1bf7f489$var$booleanClockwise;

});
parcelRegister("buBa6", function(module, exports) {

$parcel$export(module.exports, "getCoords", function () { return $85df529e29000ac3$export$39e042fd83f1b62e; });

var $lPkUu = parcelRequire("lPkUu");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $85df529e29000ac3$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $85df529e29000ac3$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $85df529e29000ac3$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $lPkUu.isNumber)(coordinates[0]) && (0, $lPkUu.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $85df529e29000ac3$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $85df529e29000ac3$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $85df529e29000ac3$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $85df529e29000ac3$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $85df529e29000ac3$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $85df529e29000ac3$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $85df529e29000ac3$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});
parcelRegister("lPkUu", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $fe3e94ba5cfe9b9d$export$7e4aa119212bc614; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $fe3e94ba5cfe9b9d$export$f929e47acbed771a = {
    meters: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f,
    metres: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f,
    millimeters: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f * 1000,
    millimetres: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f * 1000,
    centimeters: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f * 100,
    centimetres: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f * 100,
    kilometers: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f / 1000,
    kilometres: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f / 1000,
    miles: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f / 1852,
    inches: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f * 39.370,
    yards: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f / 1.0936,
    feet: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $fe3e94ba5cfe9b9d$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $fe3e94ba5cfe9b9d$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $fe3e94ba5cfe9b9d$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$fe3e94ba5cfe9b9d$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $fe3e94ba5cfe9b9d$export$28ac7bb8f5309bea(bbox);
    if (id) $fe3e94ba5cfe9b9d$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $fe3e94ba5cfe9b9d$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$fe3e94ba5cfe9b9d$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $fe3e94ba5cfe9b9d$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $fe3e94ba5cfe9b9d$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $fe3e94ba5cfe9b9d$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $fe3e94ba5cfe9b9d$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $fe3e94ba5cfe9b9d$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $fe3e94ba5cfe9b9d$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $fe3e94ba5cfe9b9d$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $fe3e94ba5cfe9b9d$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$fe3e94ba5cfe9b9d$export$7e4aa119212bc614(coordinates[0]) || !$fe3e94ba5cfe9b9d$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $fe3e94ba5cfe9b9d$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $fe3e94ba5cfe9b9d$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $fe3e94ba5cfe9b9d$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $fe3e94ba5cfe9b9d$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$fe3e94ba5cfe9b9d$export$7e4aa119212bc614(ring[0][0]) || !$fe3e94ba5cfe9b9d$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $fe3e94ba5cfe9b9d$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $fe3e94ba5cfe9b9d$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $fe3e94ba5cfe9b9d$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $fe3e94ba5cfe9b9d$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$fe3e94ba5cfe9b9d$export$7e4aa119212bc614(coordinates[0][1]) || !$fe3e94ba5cfe9b9d$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $fe3e94ba5cfe9b9d$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $fe3e94ba5cfe9b9d$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $fe3e94ba5cfe9b9d$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $fe3e94ba5cfe9b9d$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$fe3e94ba5cfe9b9d$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $fe3e94ba5cfe9b9d$export$28ac7bb8f5309bea(bbox);
    if (id) $fe3e94ba5cfe9b9d$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $fe3e94ba5cfe9b9d$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $fe3e94ba5cfe9b9d$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $fe3e94ba5cfe9b9d$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $fe3e94ba5cfe9b9d$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $fe3e94ba5cfe9b9d$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $fe3e94ba5cfe9b9d$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $fe3e94ba5cfe9b9d$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $fe3e94ba5cfe9b9d$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $fe3e94ba5cfe9b9d$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $fe3e94ba5cfe9b9d$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $fe3e94ba5cfe9b9d$export$c7a138e00a89bd01(distance, units) {
    return $fe3e94ba5cfe9b9d$export$c41dd2a8460d3196($fe3e94ba5cfe9b9d$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $fe3e94ba5cfe9b9d$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $fe3e94ba5cfe9b9d$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $fe3e94ba5cfe9b9d$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $fe3e94ba5cfe9b9d$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $fe3e94ba5cfe9b9d$export$f234631d6a2eedf8($fe3e94ba5cfe9b9d$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $fe3e94ba5cfe9b9d$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $fe3e94ba5cfe9b9d$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $fe3e94ba5cfe9b9d$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $fe3e94ba5cfe9b9d$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $fe3e94ba5cfe9b9d$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $fe3e94ba5cfe9b9d$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$fe3e94ba5cfe9b9d$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $fe3e94ba5cfe9b9d$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $fe3e94ba5cfe9b9d$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $fe3e94ba5cfe9b9d$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $fe3e94ba5cfe9b9d$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $fe3e94ba5cfe9b9d$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $fe3e94ba5cfe9b9d$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $fe3e94ba5cfe9b9d$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $fe3e94ba5cfe9b9d$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});



parcelRegister("f8xmd", function(module, exports) {

$parcel$export(module.exports, "featureEach", function () { return $b0517a6c610a2d01$export$45a31c4de8035258; });
$parcel$export(module.exports, "geomEach", function () { return $b0517a6c610a2d01$export$d2d248a56672ab3d; });

var $bcb8J = parcelRequire("bcb8J");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $b0517a6c610a2d01$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        if (geomType === "MultiPolygon") geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($b0517a6c610a2d01$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $b0517a6c610a2d01$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $b0517a6c610a2d01$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $b0517a6c610a2d01$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $b0517a6c610a2d01$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $b0517a6c610a2d01$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $b0517a6c610a2d01$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $b0517a6c610a2d01$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $b0517a6c610a2d01$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $b0517a6c610a2d01$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $b0517a6c610a2d01$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $b0517a6c610a2d01$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $b0517a6c610a2d01$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $b0517a6c610a2d01$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $b0517a6c610a2d01$export$12cba8b31beb353b(geojson, callback) {
    $b0517a6c610a2d01$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $bcb8J.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $bcb8J.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $b0517a6c610a2d01$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $b0517a6c610a2d01$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $b0517a6c610a2d01$export$d3ecc1efb2be121e(geojson, callback) {
    $b0517a6c610a2d01$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature$$1.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature$$1.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        if ($b0517a6c610a2d01$export$6e011439fde007ae(feature$$1, function(currentCoord, coordIndex, featureIndexCoord, mutliPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined) {
                previousCoords = currentCoord;
                return;
            }
            var currentSegment = (0, $bcb8J.lineString)([
                previousCoords,
                currentCoord
            ], feature$$1.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentInex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $b0517a6c610a2d01$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $b0517a6c610a2d01$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $b0517a6c610a2d01$export$985a91771cfc783d(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $b0517a6c610a2d01$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        if (feature$$1.geometry === null) return;
        var type = feature$$1.geometry.type;
        var coords = feature$$1.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature$$1, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $bcb8J.lineString)(coords[geometryIndex], feature$$1.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $b0517a6c610a2d01$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $b0517a6c610a2d01$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $b0517a6c610a2d01$export$2b6ba91fd8680d67(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $bcb8J.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $bcb8J.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $bcb8J.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $bcb8J.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $bcb8J.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $b0517a6c610a2d01$export$ed60ae5df1bac687(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $bcb8J.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $bcb8J.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $bcb8J.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $bcb8J.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $bcb8J.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $bcb8J.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $bcb8J.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

});
parcelRegister("bcb8J", function(module, exports) {

$parcel$export(module.exports, "feature", function () { return $826974d85cf5abd4$export$ced6ed16dfd6a264; });
$parcel$export(module.exports, "isObject", function () { return $826974d85cf5abd4$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "point", function () { return $826974d85cf5abd4$export$105684a3041cb6f3; });
$parcel$export(module.exports, "lineString", function () { return $826974d85cf5abd4$export$98ec381bb06902c3; });
$parcel$export(module.exports, "isNumber", function () { return $826974d85cf5abd4$export$7e4aa119212bc614; });
$parcel$export(module.exports, "featureCollection", function () { return $826974d85cf5abd4$export$4717c67ac3e5e04d; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $826974d85cf5abd4$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $826974d85cf5abd4$export$f929e47acbed771a = {
    meters: $826974d85cf5abd4$export$e3a1ee0e9945697f,
    metres: $826974d85cf5abd4$export$e3a1ee0e9945697f,
    millimeters: $826974d85cf5abd4$export$e3a1ee0e9945697f * 1000,
    millimetres: $826974d85cf5abd4$export$e3a1ee0e9945697f * 1000,
    centimeters: $826974d85cf5abd4$export$e3a1ee0e9945697f * 100,
    centimetres: $826974d85cf5abd4$export$e3a1ee0e9945697f * 100,
    kilometers: $826974d85cf5abd4$export$e3a1ee0e9945697f / 1000,
    kilometres: $826974d85cf5abd4$export$e3a1ee0e9945697f / 1000,
    miles: $826974d85cf5abd4$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $826974d85cf5abd4$export$e3a1ee0e9945697f / 1852,
    inches: $826974d85cf5abd4$export$e3a1ee0e9945697f * 39.370,
    yards: $826974d85cf5abd4$export$e3a1ee0e9945697f / 1.0936,
    feet: $826974d85cf5abd4$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $826974d85cf5abd4$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $826974d85cf5abd4$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $826974d85cf5abd4$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $826974d85cf5abd4$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $826974d85cf5abd4$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$826974d85cf5abd4$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $826974d85cf5abd4$export$28ac7bb8f5309bea(bbox);
    if (id) $826974d85cf5abd4$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $826974d85cf5abd4$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$826974d85cf5abd4$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $826974d85cf5abd4$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $826974d85cf5abd4$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $826974d85cf5abd4$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $826974d85cf5abd4$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $826974d85cf5abd4$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $826974d85cf5abd4$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $826974d85cf5abd4$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $826974d85cf5abd4$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$826974d85cf5abd4$export$7e4aa119212bc614(coordinates[0]) || !$826974d85cf5abd4$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $826974d85cf5abd4$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $826974d85cf5abd4$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $826974d85cf5abd4$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $826974d85cf5abd4$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $826974d85cf5abd4$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$826974d85cf5abd4$export$7e4aa119212bc614(ring[0][0]) || !$826974d85cf5abd4$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $826974d85cf5abd4$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $826974d85cf5abd4$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $826974d85cf5abd4$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $826974d85cf5abd4$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $826974d85cf5abd4$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$826974d85cf5abd4$export$7e4aa119212bc614(coordinates[0][1]) || !$826974d85cf5abd4$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $826974d85cf5abd4$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $826974d85cf5abd4$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $826974d85cf5abd4$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $826974d85cf5abd4$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $826974d85cf5abd4$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$826974d85cf5abd4$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $826974d85cf5abd4$export$28ac7bb8f5309bea(bbox);
    if (id) $826974d85cf5abd4$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $826974d85cf5abd4$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $826974d85cf5abd4$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $826974d85cf5abd4$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $826974d85cf5abd4$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $826974d85cf5abd4$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $826974d85cf5abd4$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $826974d85cf5abd4$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $826974d85cf5abd4$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $826974d85cf5abd4$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $826974d85cf5abd4$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $826974d85cf5abd4$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $826974d85cf5abd4$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $826974d85cf5abd4$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $826974d85cf5abd4$export$c7a138e00a89bd01(distance, units) {
    return $826974d85cf5abd4$export$c41dd2a8460d3196($826974d85cf5abd4$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $826974d85cf5abd4$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $826974d85cf5abd4$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $826974d85cf5abd4$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $826974d85cf5abd4$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $826974d85cf5abd4$export$f234631d6a2eedf8($826974d85cf5abd4$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $826974d85cf5abd4$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $826974d85cf5abd4$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $826974d85cf5abd4$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $826974d85cf5abd4$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $826974d85cf5abd4$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $826974d85cf5abd4$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$826974d85cf5abd4$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $826974d85cf5abd4$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $826974d85cf5abd4$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $826974d85cf5abd4$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $826974d85cf5abd4$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $826974d85cf5abd4$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $826974d85cf5abd4$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $826974d85cf5abd4$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $826974d85cf5abd4$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});


parcelRegister("gtJiw", function(module, exports) {

$parcel$export(module.exports, "getCoords", function () { return $bff27df390727b17$export$39e042fd83f1b62e; });

var $bcb8J = parcelRequire("bcb8J");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $bff27df390727b17$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $bff27df390727b17$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $bff27df390727b17$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $bcb8J.isNumber)(coordinates[0]) && (0, $bcb8J.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $bff27df390727b17$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $bff27df390727b17$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $bff27df390727b17$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $bff27df390727b17$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $bff27df390727b17$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $bff27df390727b17$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $bff27df390727b17$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});


parcelRegister("hs5Hv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toDeckColor = $cb497939a269a2bd$var$toDeckColor;
module.exports.recursivelyTraverseNestedArrays = $cb497939a269a2bd$var$recursivelyTraverseNestedArrays;
module.exports.generatePointsParallelToLinePoints = $cb497939a269a2bd$var$generatePointsParallelToLinePoints;
module.exports.distance2d = $cb497939a269a2bd$var$distance2d;
module.exports.mix = $cb497939a269a2bd$var$mix;
module.exports.nearestPointOnProjectedLine = $cb497939a269a2bd$var$nearestPointOnProjectedLine;
module.exports.nearestPointOnLine = $cb497939a269a2bd$var$nearestPointOnLine;
module.exports.getPickedEditHandle = $cb497939a269a2bd$var$getPickedEditHandle;
module.exports.getPickedSnapSourceEditHandle = $cb497939a269a2bd$var$getPickedSnapSourceEditHandle;
module.exports.getNonGuidePicks = $cb497939a269a2bd$var$getNonGuidePicks;
module.exports.getPickedExistingEditHandle = $cb497939a269a2bd$var$getPickedExistingEditHandle;
module.exports.getPickedIntermediateEditHandle = $cb497939a269a2bd$var$getPickedIntermediateEditHandle;
module.exports.getPickedEditHandles = $cb497939a269a2bd$var$getPickedEditHandles;
module.exports.getEditHandlesForGeometry = $cb497939a269a2bd$var$getEditHandlesForGeometry;
module.exports.updateRectanglePosition = $cb497939a269a2bd$var$updateRectanglePosition;
module.exports.mapCoords = $cb497939a269a2bd$var$mapCoords;

var $cb497939a269a2bd$var$_destination = $cb497939a269a2bd$var$_interopRequireDefault((parcelRequire("1UAWS")));

var $cb497939a269a2bd$var$_bearing = $cb497939a269a2bd$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $cb497939a269a2bd$var$_pointToLineDistance = $cb497939a269a2bd$var$_interopRequireDefault((parcelRequire("3OoMQ")));

var $cJNDJ = parcelRequire("cJNDJ");

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");

var $cb497939a269a2bd$var$_viewportMercatorProject = $cb497939a269a2bd$var$_interopRequireDefault((parcelRequire("1LAFs")));
function $cb497939a269a2bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $cb497939a269a2bd$var$_slicedToArray(arr, i) {
    return $cb497939a269a2bd$var$_arrayWithHoles(arr) || $cb497939a269a2bd$var$_iterableToArrayLimit(arr, i) || $cb497939a269a2bd$var$_unsupportedIterableToArray(arr, i) || $cb497939a269a2bd$var$_nonIterableRest();
}
function $cb497939a269a2bd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cb497939a269a2bd$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $cb497939a269a2bd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cb497939a269a2bd$var$_toConsumableArray(arr) {
    return $cb497939a269a2bd$var$_arrayWithoutHoles(arr) || $cb497939a269a2bd$var$_iterableToArray(arr) || $cb497939a269a2bd$var$_unsupportedIterableToArray(arr) || $cb497939a269a2bd$var$_nonIterableSpread();
}
function $cb497939a269a2bd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cb497939a269a2bd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cb497939a269a2bd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cb497939a269a2bd$var$_arrayLikeToArray(o, minLen);
}
function $cb497939a269a2bd$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $cb497939a269a2bd$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cb497939a269a2bd$var$_arrayLikeToArray(arr);
}
function $cb497939a269a2bd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cb497939a269a2bd$var$toDeckColor(color) {
    var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        255,
        0,
        0,
        255
    ];
    if (!Array.isArray(color)) return defaultColor;
    return [
        color[0] * 255,
        color[1] * 255,
        color[2] * 255,
        color[3] * 255
    ];
} //
// a GeoJSON helper function that calls the provided function with
// an argument that is the most deeply-nested array having elements
// that are arrays of primitives as an argument, e.g.
//
// {
//   "type": "MultiPolygon",
//   "coordinates": [
//       [
//           [[30, 20], [45, 40], [10, 40], [30, 20]]
//       ],
//       [
//           [[15, 5], [40, 10], [10, 20], [5, 10], [15, 5]]
//       ]
//   ]
// }
//
// the function would be called on:
//
// [[30, 20], [45, 40], [10, 40], [30, 20]]
//
// and
//
// [[15, 5], [40, 10], [10, 20], [5, 10], [15, 5]]
//
function $cb497939a269a2bd$var$recursivelyTraverseNestedArrays(array, prefix, fn) {
    if (!Array.isArray(array[0])) return true;
    for(var i = 0; i < array.length; i++)if ($cb497939a269a2bd$var$recursivelyTraverseNestedArrays(array[i], [].concat($cb497939a269a2bd$var$_toConsumableArray(prefix), [
        i
    ]), fn)) {
        fn(array, prefix);
        break;
    }
    return false;
}
function $cb497939a269a2bd$var$generatePointsParallelToLinePoints(p1, p2, mapCoords) {
    var lineString = {
        type: "LineString",
        coordinates: [
            p1,
            p2
        ]
    };
    var pt = (0, $7GKQS.point)(mapCoords);
    var ddistance = (0, $cb497939a269a2bd$var$_pointToLineDistance["default"])(pt, lineString);
    var lineBearing = (0, $cb497939a269a2bd$var$_bearing["default"])(p1, p2); // Check if current point is to the left or right of line
    // Line from A=(x1,y1) to B=(x2,y2) a point P=(x,y)
    // then (x−x1)(y2−y1)−(y−y1)(x2−x1)
    var isPointToLeftOfLine = (mapCoords[0] - p1[0]) * (p2[1] - p1[1]) - (mapCoords[1] - p1[1]) * (p2[0] - p1[0]); // Bearing to draw perpendicular to the line string
    var orthogonalBearing = isPointToLeftOfLine < 0 ? lineBearing - 90 : lineBearing - 270; // Get coordinates for the point p3 and p4 which are perpendicular to the lineString
    // Add the distance as the current position moves away from the lineString
    var p3 = (0, $cb497939a269a2bd$var$_destination["default"])(p2, ddistance, orthogonalBearing);
    var p4 = (0, $cb497939a269a2bd$var$_destination["default"])(p1, ddistance, orthogonalBearing);
    return [
        p3.geometry.coordinates,
        p4.geometry.coordinates
    ];
}
function $cb497939a269a2bd$var$distance2d(x1, y1, x2, y2) {
    var dx = x1 - x2;
    var dy = y1 - y2;
    return Math.sqrt(dx * dx + dy * dy);
}
function $cb497939a269a2bd$var$mix(a, b, ratio) {
    return b * ratio + a * (1 - ratio);
}
function $cb497939a269a2bd$var$nearestPointOnProjectedLine(line, inPoint, viewport) {
    var wmViewport = new $cb497939a269a2bd$var$_viewportMercatorProject["default"](viewport); // Project the line to viewport, then find the nearest point
    var coordinates = line.geometry.coordinates;
    var projectedCoords = coordinates.map(function(_ref) {
        var _ref2 = $cb497939a269a2bd$var$_slicedToArray(_ref, 3), x = _ref2[0], y = _ref2[1], _ref2$ = _ref2[2], z = _ref2$ === void 0 ? 0 : _ref2$;
        return wmViewport.project([
            x,
            y,
            z
        ]);
    }); // @ts-ignore
    var _wmViewport$project = wmViewport.project(inPoint.geometry.coordinates), _wmViewport$project2 = $cb497939a269a2bd$var$_slicedToArray(_wmViewport$project, 2), x = _wmViewport$project2[0], y = _wmViewport$project2[1]; // console.log('projectedCoords', JSON.stringify(projectedCoords));
    var minDistance = Infinity;
    var minPointInfo = {};
    projectedCoords.forEach(function(_ref3, index) {
        var _ref4 = $cb497939a269a2bd$var$_slicedToArray(_ref3, 2), x2 = _ref4[0], y2 = _ref4[1];
        if (index === 0) return;
        var _projectedCoords = $cb497939a269a2bd$var$_slicedToArray(projectedCoords[index - 1], 2), x1 = _projectedCoords[0], y1 = _projectedCoords[1]; // line from projectedCoords[index - 1] to projectedCoords[index]
        // convert to Ax + By + C = 0
        var A = y1 - y2;
        var B = x2 - x1;
        var C = x1 * y2 - x2 * y1; // https://en.wikipedia.org/wiki/Distance_from_a_point_to_a_line
        var div = A * A + B * B;
        var distance = Math.abs(A * x + B * y + C) / Math.sqrt(div); // TODO: Check if inside bounds
        if (distance < minDistance) {
            minDistance = distance;
            minPointInfo = {
                index: index,
                x0: (B * (B * x - A * y) - A * C) / div,
                y0: (A * (-B * x + A * y) - B * C) / div
            };
        }
    }); // @ts-ignore
    var _minPointInfo = minPointInfo, index = _minPointInfo.index, x0 = _minPointInfo.x0, y0 = _minPointInfo.y0;
    var _projectedCoords2 = $cb497939a269a2bd$var$_slicedToArray(projectedCoords[index - 1], 3), x1 = _projectedCoords2[0], y1 = _projectedCoords2[1], _projectedCoords2$ = _projectedCoords2[2], z1 = _projectedCoords2$ === void 0 ? 0 : _projectedCoords2$;
    var _projectedCoords$inde = $cb497939a269a2bd$var$_slicedToArray(projectedCoords[index], 3), x2 = _projectedCoords$inde[0], y2 = _projectedCoords$inde[1], _projectedCoords$inde2 = _projectedCoords$inde[2], z2 = _projectedCoords$inde2 === void 0 ? 0 : _projectedCoords$inde2; // calculate what ratio of the line we are on to find the proper z
    var lineLength = $cb497939a269a2bd$var$distance2d(x1, y1, x2, y2);
    var startToPointLength = $cb497939a269a2bd$var$distance2d(x1, y1, x0, y0);
    var ratio = startToPointLength / lineLength;
    var z0 = $cb497939a269a2bd$var$mix(z1, z2, ratio);
    return {
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: wmViewport.unproject([
                x0,
                y0,
                z0
            ])
        },
        properties: {
            // TODO: calculate the distance in proper units
            dist: minDistance,
            index: index - 1
        }
    };
}
function $cb497939a269a2bd$var$nearestPointOnLine(lines, inPoint, viewport) {
    var _lines$geometry, _lines$geometry2;
    var mercator;
    if (viewport) mercator = new $cb497939a269a2bd$var$_viewportMercatorProject["default"](viewport);
    var closestPoint = (0, $7GKQS.point)([
        Infinity,
        Infinity
    ], {
        dist: Infinity
    });
    if (!((_lines$geometry = lines.geometry) === null || _lines$geometry === void 0 ? void 0 : _lines$geometry.coordinates.length) || ((_lines$geometry2 = lines.geometry) === null || _lines$geometry2 === void 0 ? void 0 : _lines$geometry2.coordinates.length) < 2) return closestPoint;
     // @ts-ignore
    (0, $cJNDJ.flattenEach)(lines, function(line) {
        var coords = (0, $8abqV.getCoords)(line); // @ts-ignore
        var pointCoords = (0, $8abqV.getCoords)(inPoint);
        var minDist;
        var to;
        var from;
        var x;
        var y;
        var segmentIdx;
        var dist;
        if (coords.length > 1 && pointCoords.length) {
            var lineCoordinates;
            var pointCoordinate; // If viewport is given, then translate these coordinates to pixels to increase precision
            if (mercator) {
                lineCoordinates = coords.map(function(lineCoordinate) {
                    return mercator.project(lineCoordinate);
                });
                pointCoordinate = mercator.project(pointCoords);
            } else {
                lineCoordinates = coords;
                pointCoordinate = pointCoords;
            }
            for(var n = 1; n < lineCoordinates.length; n++){
                if (lineCoordinates[n][0] !== lineCoordinates[n - 1][0]) {
                    var slope = (lineCoordinates[n][1] - lineCoordinates[n - 1][1]) / (lineCoordinates[n][0] - lineCoordinates[n - 1][0]);
                    var inverseSlope = lineCoordinates[n][1] - slope * lineCoordinates[n][0];
                    dist = Math.abs(slope * pointCoordinate[0] + inverseSlope - pointCoordinate[1]) / Math.sqrt(slope * slope + 1);
                } else dist = Math.abs(pointCoordinate[0] - lineCoordinates[n][0]); // length^2 of line segment
                var rl2 = Math.pow(lineCoordinates[n][1] - lineCoordinates[n - 1][1], 2) + Math.pow(lineCoordinates[n][0] - lineCoordinates[n - 1][0], 2); // distance^2 of pt to end line segment
                var ln2 = Math.pow(lineCoordinates[n][1] - pointCoordinate[1], 2) + Math.pow(lineCoordinates[n][0] - pointCoordinate[0], 2); // distance^2 of pt to begin line segment
                var lnm12 = Math.pow(lineCoordinates[n - 1][1] - pointCoordinate[1], 2) + Math.pow(lineCoordinates[n - 1][0] - pointCoordinate[0], 2); // minimum distance^2 of pt to infinite line
                var dist2 = Math.pow(dist, 2); // calculated length^2 of line segment
                var calcrl2 = ln2 - dist2 + lnm12 - dist2; // redefine minimum distance to line segment (not infinite line) if necessary
                if (calcrl2 > rl2) dist = Math.sqrt(Math.min(ln2, lnm12));
                if (minDist === null || minDist === undefined || minDist > dist) {
                    // eslint-disable-next-line max-depth
                    if (calcrl2 > rl2) {
                        // eslint-disable-next-line max-depth
                        if (lnm12 < ln2) {
                            to = 0; // nearer to previous point
                            from = 1;
                        } else {
                            from = 0; // nearer to current point
                            to = 1;
                        }
                    } else {
                        // perpendicular from point intersects line segment
                        to = Math.sqrt(lnm12 - dist2) / Math.sqrt(rl2);
                        from = Math.sqrt(ln2 - dist2) / Math.sqrt(rl2);
                    }
                    minDist = dist;
                    segmentIdx = n;
                }
            }
            var dx = lineCoordinates[segmentIdx - 1][0] - lineCoordinates[segmentIdx][0];
            var dy = lineCoordinates[segmentIdx - 1][1] - lineCoordinates[segmentIdx][1];
            x = lineCoordinates[segmentIdx - 1][0] - dx * to;
            y = lineCoordinates[segmentIdx - 1][1] - dy * to;
        } // index needs to be -1 because we have to account for the shift from initial backscan
        var snapPoint = {
            x: x,
            y: y,
            idx: segmentIdx - 1,
            to: to,
            from: from
        };
        if (mercator) {
            var pixelToLatLong = mercator.unproject([
                snapPoint.x,
                snapPoint.y
            ]);
            snapPoint = {
                x: pixelToLatLong[0],
                y: pixelToLatLong[1],
                idx: segmentIdx - 1,
                to: to,
                from: from
            };
        }
        closestPoint = (0, $7GKQS.point)([
            snapPoint.x,
            snapPoint.y
        ], {
            dist: Math.abs(snapPoint.from - snapPoint.to),
            index: snapPoint.idx
        });
    });
    return closestPoint;
}
function $cb497939a269a2bd$var$getPickedEditHandle(picks) {
    var handles = $cb497939a269a2bd$var$getPickedEditHandles(picks);
    return handles.length ? handles[0] : null;
}
function $cb497939a269a2bd$var$getPickedSnapSourceEditHandle(picks) {
    var handles = $cb497939a269a2bd$var$getPickedEditHandles(picks);
    return handles.find(function(handle) {
        return handle.properties.editHandleType === "snap-source";
    });
}
function $cb497939a269a2bd$var$getNonGuidePicks(picks) {
    return picks && picks.filter(function(pick) {
        return !pick.isGuide;
    });
}
function $cb497939a269a2bd$var$getPickedExistingEditHandle(picks) {
    var handles = $cb497939a269a2bd$var$getPickedEditHandles(picks);
    return handles.find(function(_ref5) {
        var properties = _ref5.properties;
        return properties.featureIndex >= 0 && properties.editHandleType === "existing";
    });
}
function $cb497939a269a2bd$var$getPickedIntermediateEditHandle(picks) {
    var handles = $cb497939a269a2bd$var$getPickedEditHandles(picks);
    return handles.find(function(_ref6) {
        var properties = _ref6.properties;
        return properties.featureIndex >= 0 && properties.editHandleType === "intermediate";
    });
}
function $cb497939a269a2bd$var$getPickedEditHandles(picks) {
    var handles = picks && picks.filter(function(pick) {
        return pick.isGuide && pick.object.properties.guideType === "editHandle";
    }).map(function(pick) {
        return pick.object;
    }) || [];
    return handles;
}
function $cb497939a269a2bd$var$getEditHandlesForGeometry(geometry, featureIndex) {
    var editHandleType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "existing";
    var handles = [];
    switch(geometry.type){
        case "Point":
            // positions are not nested
            handles = [
                {
                    type: "Feature",
                    properties: {
                        guideType: "editHandle",
                        editHandleType: editHandleType,
                        positionIndexes: [],
                        featureIndex: featureIndex
                    },
                    geometry: {
                        type: "Point",
                        coordinates: geometry.coordinates
                    }
                }
            ];
            break;
        case "MultiPoint":
        case "LineString":
            // positions are nested 1 level
            handles = handles.concat($cb497939a269a2bd$var$getEditHandlesForCoordinates(geometry.coordinates, [], featureIndex, editHandleType));
            break;
        case "Polygon":
        case "MultiLineString":
            // positions are nested 2 levels
            for(var a = 0; a < geometry.coordinates.length; a++){
                handles = handles.concat($cb497939a269a2bd$var$getEditHandlesForCoordinates(geometry.coordinates[a], [
                    a
                ], featureIndex, editHandleType));
                if (geometry.type === "Polygon") // Don't repeat the first/last handle for Polygons
                handles = handles.slice(0, -1);
            }
            break;
        case "MultiPolygon":
            // positions are nested 3 levels
            for(var _a = 0; _a < geometry.coordinates.length; _a++)for(var b = 0; b < geometry.coordinates[_a].length; b++){
                handles = handles.concat($cb497939a269a2bd$var$getEditHandlesForCoordinates(geometry.coordinates[_a][b], [
                    _a,
                    b
                ], featureIndex, editHandleType)); // Don't repeat the first/last handle for Polygons
                handles = handles.slice(0, -1);
            }
            break;
        default:
            // @ts-ignore
            throw Error("Unhandled geometry type: ".concat(geometry.type));
    }
    return handles;
}
function $cb497939a269a2bd$var$getEditHandlesForCoordinates(coordinates, positionIndexPrefix, featureIndex) {
    var editHandleType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "existing";
    var editHandles = [];
    for(var i = 0; i < coordinates.length; i++){
        var position = coordinates[i];
        editHandles.push({
            type: "Feature",
            properties: {
                guideType: "editHandle",
                positionIndexes: [].concat($cb497939a269a2bd$var$_toConsumableArray(positionIndexPrefix), [
                    i
                ]),
                featureIndex: featureIndex,
                editHandleType: editHandleType
            },
            geometry: {
                type: "Point",
                coordinates: position
            }
        });
    }
    return editHandles;
}
/**
 * Calculates coordinates for a feature preserving rectangular shape.
 * @param feature Feature before modification.
 * @param editHandleIndex Index of the point to modify.
 * @param mapCoords New position for the point.
 * @returns Updated coordinates.
 */ function $cb497939a269a2bd$var$updateRectanglePosition(feature, editHandleIndex, mapCoords) {
    var coordinates = feature.geometry.coordinates;
    if (!coordinates) return null;
    var points = coordinates[0].slice(0, 4);
    points[editHandleIndex % 4] = mapCoords;
    var p0 = points[(editHandleIndex + 2) % 4];
    var p2 = points[editHandleIndex % 4];
    points[(editHandleIndex + 1) % 4] = [
        p2[0],
        p0[1]
    ];
    points[(editHandleIndex + 3) % 4] = [
        p0[0],
        p2[1]
    ];
    return [
        [].concat($cb497939a269a2bd$var$_toConsumableArray(points), [
            points[0]
        ])
    ];
}
/** Creates a copy of feature's coordinates.
 * Each position in coordinates is transformed by calling the provided function.
 * @param coords Coordinates of a feature.
 * @param callback A function to transform each coordinate.
 * @retuns Transformed coordinates.
 */ function $cb497939a269a2bd$var$mapCoords(coords, callback) {
    if (typeof coords[0] === "number") {
        if (!isNaN(coords[0]) && isFinite(coords[0])) return callback(coords);
        return coords;
    }
    return coords.map(function(coord) {
        return $cb497939a269a2bd$var$mapCoords(coord, callback);
    }).filter(Boolean);
}

});
parcelRegister("1UAWS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");
/**
 * Takes a {@link Point} and calculates the location of a destination point given a distance in
 * degrees, radians, miles, or kilometers; and bearing in degrees.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name destination
 * @param {Coord} origin starting point
 * @param {number} distance distance from the origin point
 * @param {number} bearing ranging from -180 to 180
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {Object} [options.properties={}] Translate properties to Point
 * @returns {Feature<Point>} destination point
 * @example
 * var point = turf.point([-75.343, 39.984]);
 * var distance = 50;
 * var bearing = 90;
 * var options = {units: 'miles'};
 *
 * var destination = turf.destination(point, distance, bearing, options);
 *
 * //addToMap
 * var addToMap = [point, destination]
 * destination.properties['marker-color'] = '#f00';
 * point.properties['marker-color'] = '#0f0';
 */ function $1647aea68aba4095$var$destination(origin, distance, bearing, options) {
    if (options === void 0) options = {};
    // Handle input
    var coordinates1 = $8abqV.getCoord(origin);
    var longitude1 = $7GKQS.degreesToRadians(coordinates1[0]);
    var latitude1 = $7GKQS.degreesToRadians(coordinates1[1]);
    var bearingRad = $7GKQS.degreesToRadians(bearing);
    var radians = $7GKQS.lengthToRadians(distance, options.units);
    // Main
    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) + Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad));
    var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1), Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
    var lng = $7GKQS.radiansToDegrees(longitude2);
    var lat = $7GKQS.radiansToDegrees(latitude2);
    return $7GKQS.point([
        lng,
        lat
    ], options.properties);
}
module.exports.default = $1647aea68aba4095$var$destination;

});

parcelRegister("aDE4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");
// http://en.wikipedia.org/wiki/Haversine_formula
// http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Takes two {@link Point|points} and finds the geographic bearing between them,
 * i.e. the angle measured in degrees from the north line (0 degrees)
 *
 * @name bearing
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.final=false] calculates the final bearing if true
 * @returns {number} bearing in decimal degrees, between -180 and 180 degrees (positive clockwise)
 * @example
 * var point1 = turf.point([-75.343, 39.984]);
 * var point2 = turf.point([-75.534, 39.123]);
 *
 * var bearing = turf.bearing(point1, point2);
 *
 * //addToMap
 * var addToMap = [point1, point2]
 * point1.properties['marker-color'] = '#f00'
 * point2.properties['marker-color'] = '#0f0'
 * point1.properties.bearing = bearing
 */ function $7beca0c55060dc11$var$bearing(start, end, options) {
    if (options === void 0) options = {};
    // Reverse calculation
    if (options.final === true) return $7beca0c55060dc11$var$calculateFinalBearing(start, end);
    var coordinates1 = $8abqV.getCoord(start);
    var coordinates2 = $8abqV.getCoord(end);
    var lon1 = $7GKQS.degreesToRadians(coordinates1[0]);
    var lon2 = $7GKQS.degreesToRadians(coordinates2[0]);
    var lat1 = $7GKQS.degreesToRadians(coordinates1[1]);
    var lat2 = $7GKQS.degreesToRadians(coordinates2[1]);
    var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    return $7GKQS.radiansToDegrees(Math.atan2(a, b));
}
/**
 * Calculates Final Bearing
 *
 * @private
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @returns {number} bearing
 */ function $7beca0c55060dc11$var$calculateFinalBearing(start, end) {
    // Swap start & end
    var bear = $7beca0c55060dc11$var$bearing(end, start);
    bear = (bear + 180) % 360;
    return bear;
}
module.exports.default = $7beca0c55060dc11$var$bearing;

});

parcelRegister("3OoMQ", function(module, exports) {
"use strict";
var $2c6944c4589193ef$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Taken from http://geomalgorithms.com/a02-_lines.html
var $2c6944c4589193ef$var$distance_1 = $2c6944c4589193ef$var$__importDefault((parcelRequire("b5wF2")));

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");

var $7aiSl = parcelRequire("7aiSl");

var $2c6944c4589193ef$var$rhumb_distance_1 = $2c6944c4589193ef$var$__importDefault((parcelRequire("jcSlP")));
/**
 * Returns the minimum distance between a {@link Point} and a {@link LineString}, being the distance from a line the
 * minimum distance between the point and any segment of the `LineString`.
 *
 * @name pointToLineDistance
 * @param {Feature<Point>|Array<number>} pt Feature or Geometry
 * @param {Feature<LineString>} line GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units="kilometers"] can be anything supported by turf/convertLength
 * (ex: degrees, radians, miles, or kilometers)
 * @param {string} [options.method="geodesic"] wether to calculate the distance based on geodesic (spheroid) or
 * planar (flat) method. Valid options are 'geodesic' or 'planar'.
 * @returns {number} distance between point and line
 * @example
 * var pt = turf.point([0, 0]);
 * var line = turf.lineString([[1, 1],[-1, 1]]);
 *
 * var distance = turf.pointToLineDistance(pt, line, {units: 'miles'});
 * //=69.11854715938406
 */ function $2c6944c4589193ef$var$pointToLineDistance(pt, line, options) {
    if (options === void 0) options = {};
    // Optional parameters
    if (!options.method) options.method = "geodesic";
    if (!options.units) options.units = "kilometers";
    // validation
    if (!pt) throw new Error("pt is required");
    if (Array.isArray(pt)) pt = $7GKQS.point(pt);
    else if (pt.type === "Point") pt = $7GKQS.feature(pt);
    else $8abqV.featureOf(pt, "Point", "point");
    if (!line) throw new Error("line is required");
    if (Array.isArray(line)) line = $7GKQS.lineString(line);
    else if (line.type === "LineString") line = $7GKQS.feature(line);
    else $8abqV.featureOf(line, "LineString", "line");
    var distance = Infinity;
    var p = pt.geometry.coordinates;
    $7aiSl.segmentEach(line, function(segment) {
        var a = segment.geometry.coordinates[0];
        var b = segment.geometry.coordinates[1];
        var d = $2c6944c4589193ef$var$distanceToSegment(p, a, b, options);
        if (d < distance) distance = d;
    });
    return $7GKQS.convertLength(distance, "degrees", options.units);
}
/**
 * Returns the distance between a point P on a segment AB.
 *
 * @private
 * @param {Array<number>} p external point
 * @param {Array<number>} a first segment point
 * @param {Array<number>} b second segment point
 * @param {Object} [options={}] Optional parameters
 * @returns {number} distance
 */ function $2c6944c4589193ef$var$distanceToSegment(p, a, b, options) {
    var v = [
        b[0] - a[0],
        b[1] - a[1]
    ];
    var w = [
        p[0] - a[0],
        p[1] - a[1]
    ];
    var c1 = $2c6944c4589193ef$var$dot(w, v);
    if (c1 <= 0) return $2c6944c4589193ef$var$calcDistance(p, a, {
        method: options.method,
        units: "degrees"
    });
    var c2 = $2c6944c4589193ef$var$dot(v, v);
    if (c2 <= c1) return $2c6944c4589193ef$var$calcDistance(p, b, {
        method: options.method,
        units: "degrees"
    });
    var b2 = c1 / c2;
    var Pb = [
        a[0] + b2 * v[0],
        a[1] + b2 * v[1]
    ];
    return $2c6944c4589193ef$var$calcDistance(p, Pb, {
        method: options.method,
        units: "degrees"
    });
}
function $2c6944c4589193ef$var$dot(u, v) {
    return u[0] * v[0] + u[1] * v[1];
}
function $2c6944c4589193ef$var$calcDistance(a, b, options) {
    return options.method === "planar" ? $2c6944c4589193ef$var$rhumb_distance_1.default(a, b, options) : $2c6944c4589193ef$var$distance_1.default(a, b, options);
}
module.exports.default = $2c6944c4589193ef$var$pointToLineDistance;

});
parcelRegister("jcSlP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");
/**
 * Calculates the distance along a rhumb line between two {@link Point|points} in degrees, radians,
 * miles, or kilometers.
 *
 * @name rhumbDistance
 * @param {Coord} from origin point
 * @param {Coord} to destination point
 * @param {Object} [options] Optional parameters
 * @param {string} [options.units="kilometers"] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.rhumbDistance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */ function $dfb94c52071aaa01$var$rhumbDistance(from, to, options) {
    if (options === void 0) options = {};
    var origin = $8abqV.getCoord(from);
    var destination = $8abqV.getCoord(to);
    // compensate the crossing of the 180th meridian (https://macwright.org/2016/09/26/the-180th-meridian.html)
    // solution from https://github.com/mapbox/mapbox-gl-js/issues/3250#issuecomment-294887678
    destination[0] += destination[0] - origin[0] > 180 ? -360 : origin[0] - destination[0] > 180 ? 360 : 0;
    var distanceInMeters = $dfb94c52071aaa01$var$calculateRhumbDistance(origin, destination);
    var distance = $7GKQS.convertLength(distanceInMeters, "meters", options.units);
    return distance;
}
/**
 * Returns the distance travelling from ‘this’ point to destination point along a rhumb line.
 * Adapted from Geodesy: https://github.com/chrisveness/geodesy/blob/master/latlon-spherical.js
 *
 * @private
 * @param   {Array<number>} origin point.
 * @param   {Array<number>} destination point.
 * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
 * @returns {number} Distance in km between this point and destination point (same units as radius).
 *
 * @example
 *     var p1 = new LatLon(51.127, 1.338);
 *     var p2 = new LatLon(50.964, 1.853);
 *     var d = p1.distanceTo(p2); // 40.31 km
 */ function $dfb94c52071aaa01$var$calculateRhumbDistance(origin, destination, radius) {
    // φ => phi
    // λ => lambda
    // ψ => psi
    // Δ => Delta
    // δ => delta
    // θ => theta
    radius = radius === undefined ? $7GKQS.earthRadius : Number(radius);
    // see www.edwilliams.org/avform.htm#Rhumb
    var R = radius;
    var phi1 = origin[1] * Math.PI / 180;
    var phi2 = destination[1] * Math.PI / 180;
    var DeltaPhi = phi2 - phi1;
    var DeltaLambda = Math.abs(destination[0] - origin[0]) * Math.PI / 180;
    // if dLon over 180° take shorter rhumb line across the anti-meridian:
    if (DeltaLambda > Math.PI) DeltaLambda -= 2 * Math.PI;
    // on Mercator projection, longitude distances shrink by latitude; q is the 'stretch factor'
    // q becomes ill-conditioned along E-W line (0/0); use empirical tolerance to avoid it
    var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
    // distance is pythagoras on 'stretched' Mercator projection
    var delta = Math.sqrt(DeltaPhi * DeltaPhi + q * q * DeltaLambda * DeltaLambda); // angular distance in radians
    var dist = delta * R;
    return dist;
}
module.exports.default = $dfb94c52071aaa01$var$rhumbDistance;

});


parcelRegister("cJNDJ", function(module, exports) {

$parcel$export(module.exports, "coordEach", function () { return $9460316bfb92eba0$export$6e011439fde007ae; });
$parcel$export(module.exports, "geomReduce", function () { return $9460316bfb92eba0$export$30055ae7bd157809; });
$parcel$export(module.exports, "flattenEach", function () { return $9460316bfb92eba0$export$12cba8b31beb353b; });

var $ekY0d = parcelRequire("ekY0d");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $9460316bfb92eba0$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($9460316bfb92eba0$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $9460316bfb92eba0$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $9460316bfb92eba0$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $9460316bfb92eba0$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $9460316bfb92eba0$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $9460316bfb92eba0$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $9460316bfb92eba0$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $9460316bfb92eba0$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $9460316bfb92eba0$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $9460316bfb92eba0$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $9460316bfb92eba0$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $9460316bfb92eba0$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $9460316bfb92eba0$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $9460316bfb92eba0$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $9460316bfb92eba0$export$12cba8b31beb353b(geojson, callback) {
    $9460316bfb92eba0$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $ekY0d.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $ekY0d.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $9460316bfb92eba0$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $9460316bfb92eba0$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $9460316bfb92eba0$export$d3ecc1efb2be121e(geojson, callback) {
    $9460316bfb92eba0$export$12cba8b31beb353b(geojson, function(feature, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($9460316bfb92eba0$export$6e011439fde007ae(feature, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $ekY0d.lineString)([
                previousCoords,
                currentCoord
            ], feature.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentIndex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $9460316bfb92eba0$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $9460316bfb92eba0$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $9460316bfb92eba0$export$985a91771cfc783d(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $9460316bfb92eba0$export$12cba8b31beb353b(geojson, function(feature, featureIndex, multiFeatureIndex) {
        if (feature.geometry === null) return;
        var type = feature.geometry.type;
        var coords = feature.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $ekY0d.lineString)(coords[geometryIndex], feature.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $9460316bfb92eba0$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $9460316bfb92eba0$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $9460316bfb92eba0$export$2b6ba91fd8680d67(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $ekY0d.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $ekY0d.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $ekY0d.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $ekY0d.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $ekY0d.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $9460316bfb92eba0$export$ed60ae5df1bac687(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $ekY0d.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $ekY0d.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $ekY0d.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $ekY0d.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $ekY0d.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $ekY0d.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $ekY0d.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

});
parcelRegister("ekY0d", function(module, exports) {

$parcel$export(module.exports, "feature", function () { return $a7017a2dca8a70e0$export$ced6ed16dfd6a264; });
$parcel$export(module.exports, "point", function () { return $a7017a2dca8a70e0$export$105684a3041cb6f3; });
$parcel$export(module.exports, "lineString", function () { return $a7017a2dca8a70e0$export$98ec381bb06902c3; });
$parcel$export(module.exports, "isObject", function () { return $a7017a2dca8a70e0$export$a6cdc56e425d0d0a; });
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var $a7017a2dca8a70e0$export$e3a1ee0e9945697f = 6371008.8;
var $a7017a2dca8a70e0$export$f929e47acbed771a = {
    centimeters: $a7017a2dca8a70e0$export$e3a1ee0e9945697f * 100,
    centimetres: $a7017a2dca8a70e0$export$e3a1ee0e9945697f * 100,
    degrees: $a7017a2dca8a70e0$export$e3a1ee0e9945697f / 111325,
    feet: $a7017a2dca8a70e0$export$e3a1ee0e9945697f * 3.28084,
    inches: $a7017a2dca8a70e0$export$e3a1ee0e9945697f * 39.37,
    kilometers: $a7017a2dca8a70e0$export$e3a1ee0e9945697f / 1000,
    kilometres: $a7017a2dca8a70e0$export$e3a1ee0e9945697f / 1000,
    meters: $a7017a2dca8a70e0$export$e3a1ee0e9945697f,
    metres: $a7017a2dca8a70e0$export$e3a1ee0e9945697f,
    miles: $a7017a2dca8a70e0$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $a7017a2dca8a70e0$export$e3a1ee0e9945697f * 1000,
    millimetres: $a7017a2dca8a70e0$export$e3a1ee0e9945697f * 1000,
    nauticalmiles: $a7017a2dca8a70e0$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $a7017a2dca8a70e0$export$e3a1ee0e9945697f * 1.0936
};
var $a7017a2dca8a70e0$export$95cef4899be7420 = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / $a7017a2dca8a70e0$export$e3a1ee0e9945697f,
    yards: 1.0936133
};
var $a7017a2dca8a70e0$export$44665ce4f7f4c82b = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $a7017a2dca8a70e0$export$42a7622cbf932bb(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return $a7017a2dca8a70e0$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $a7017a2dca8a70e0$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $a7017a2dca8a70e0$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $a7017a2dca8a70e0$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $a7017a2dca8a70e0$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $a7017a2dca8a70e0$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $a7017a2dca8a70e0$export$105684a3041cb6f3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$a7017a2dca8a70e0$export$7e4aa119212bc614(coordinates[0]) || !$a7017a2dca8a70e0$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options);
}
function $a7017a2dca8a70e0$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $a7017a2dca8a70e0$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $a7017a2dca8a70e0$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $a7017a2dca8a70e0$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options);
}
function $a7017a2dca8a70e0$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $a7017a2dca8a70e0$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $a7017a2dca8a70e0$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $a7017a2dca8a70e0$export$98ec381bb06902c3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options);
}
function $a7017a2dca8a70e0$export$74f7306c35db993f(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $a7017a2dca8a70e0$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $a7017a2dca8a70e0$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $a7017a2dca8a70e0$export$4717c67ac3e5e04d(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $a7017a2dca8a70e0$export$bd735230309493da(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options);
}
function $a7017a2dca8a70e0$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options);
}
function $a7017a2dca8a70e0$export$79bd594da96638d3(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options);
}
function $a7017a2dca8a70e0$export$9242f1e18250422a(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $a7017a2dca8a70e0$export$ced6ed16dfd6a264(geom, properties, options);
}
function $a7017a2dca8a70e0$export$2077e0241d6afd3c(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $a7017a2dca8a70e0$export$f234631d6a2eedf8(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = $a7017a2dca8a70e0$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $a7017a2dca8a70e0$export$a2280f7debae8f10(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = $a7017a2dca8a70e0$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $a7017a2dca8a70e0$export$c7a138e00a89bd01(distance, units) {
    return $a7017a2dca8a70e0$export$c41dd2a8460d3196($a7017a2dca8a70e0$export$a2280f7debae8f10(distance, units));
}
function $a7017a2dca8a70e0$export$f2077d29c73b33ec(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $a7017a2dca8a70e0$export$c41dd2a8460d3196(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function $a7017a2dca8a70e0$export$c9fcf1a7df975d78(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function $a7017a2dca8a70e0$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $a7017a2dca8a70e0$export$f234631d6a2eedf8($a7017a2dca8a70e0$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $a7017a2dca8a70e0$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $a7017a2dca8a70e0$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $a7017a2dca8a70e0$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $a7017a2dca8a70e0$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $a7017a2dca8a70e0$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
function $a7017a2dca8a70e0$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$a7017a2dca8a70e0$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $a7017a2dca8a70e0$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

});


parcelRegister("1LAFs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2NnPF")).default; });
parcelRequire("dsJSX");
var $2NnPF = parcelRequire("2NnPF");
var $dsJSX = parcelRequire("dsJSX");
$parcel$exportWildcard(module.exports, $dsJSX);

});
parcelRegister("dsJSX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2NnPF")).default; });
$parcel$export(module.exports, "WebMercatorViewport", function () { return (parcelRequire("2NnPF")).default; });
$parcel$export(module.exports, "fitBounds", function () { return (parcelRequire("8fo7C")).default; });
$parcel$export(module.exports, "normalizeViewportProps", function () { return (parcelRequire("2wWtu")).default; });
$parcel$export(module.exports, "flyToViewport", function () { return (parcelRequire("czbEE")).default; });
$parcel$export(module.exports, "getFlyToDuration", function () { return (parcelRequire("czbEE")).getFlyToDuration; });
$parcel$export(module.exports, "lngLatToWorld", function () { return (parcelRequire("kwLGk")).lngLatToWorld; });
$parcel$export(module.exports, "worldToLngLat", function () { return (parcelRequire("kwLGk")).worldToLngLat; });
$parcel$export(module.exports, "worldToPixels", function () { return (parcelRequire("kwLGk")).worldToPixels; });
$parcel$export(module.exports, "pixelsToWorld", function () { return (parcelRequire("kwLGk")).pixelsToWorld; });
$parcel$export(module.exports, "zoomToScale", function () { return (parcelRequire("kwLGk")).zoomToScale; });
$parcel$export(module.exports, "scaleToZoom", function () { return (parcelRequire("kwLGk")).scaleToZoom; });
$parcel$export(module.exports, "getMeterZoom", function () { return (parcelRequire("kwLGk")).getMeterZoom; });
$parcel$export(module.exports, "getDistanceScales", function () { return (parcelRequire("kwLGk")).getDistanceScales; });
$parcel$export(module.exports, "addMetersToLngLat", function () { return (parcelRequire("kwLGk")).addMetersToLngLat; });
$parcel$export(module.exports, "getViewMatrix", function () { return (parcelRequire("kwLGk")).getViewMatrix; });
$parcel$export(module.exports, "getProjectionMatrix", function () { return (parcelRequire("kwLGk")).getProjectionMatrix; });
$parcel$export(module.exports, "getProjectionParameters", function () { return (parcelRequire("kwLGk")).getProjectionParameters; });

var $2NnPF = parcelRequire("2NnPF");

var $8fo7C = parcelRequire("8fo7C");

var $2wWtu = parcelRequire("2wWtu");

var $czbEE = parcelRequire("czbEE");

var $kwLGk = parcelRequire("kwLGk");

});
parcelRegister("2NnPF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2092a5003543a5d1$export$2e2bcd8739ae039; });

var $dYxCI = parcelRequire("dYxCI");

var $16cE9 = parcelRequire("16cE9");

var $7BQbw = parcelRequire("7BQbw");

var $02VYc = parcelRequire("02VYc");

var $bqRYk = parcelRequire("bqRYk");

var $59aVE = parcelRequire("59aVE");

var $7KSX8 = parcelRequire("7KSX8");

var $kwLGk = parcelRequire("kwLGk");

var $8fo7C = parcelRequire("8fo7C");

var $2SWep = parcelRequire("2SWep");
var $2092a5003543a5d1$export$2e2bcd8739ae039 = function(_Viewport) {
    (0, $59aVE.default)(WebMercatorViewport, _Viewport);
    function WebMercatorViewport() {
        var _this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, width = _ref.width, height = _ref.height, _ref$latitude = _ref.latitude, latitude = _ref$latitude === void 0 ? 0 : _ref$latitude, _ref$longitude = _ref.longitude, longitude = _ref$longitude === void 0 ? 0 : _ref$longitude, _ref$zoom = _ref.zoom, zoom = _ref$zoom === void 0 ? 0 : _ref$zoom, _ref$pitch = _ref.pitch, pitch = _ref$pitch === void 0 ? 0 : _ref$pitch, _ref$bearing = _ref.bearing, bearing = _ref$bearing === void 0 ? 0 : _ref$bearing, _ref$altitude = _ref.altitude, altitude = _ref$altitude === void 0 ? 1.5 : _ref$altitude, _ref$nearZMultiplier = _ref.nearZMultiplier, nearZMultiplier = _ref$nearZMultiplier === void 0 ? 0.02 : _ref$nearZMultiplier, _ref$farZMultiplier = _ref.farZMultiplier, farZMultiplier = _ref$farZMultiplier === void 0 ? 1.01 : _ref$farZMultiplier;
        (0, $dYxCI.default)(this, WebMercatorViewport);
        width = width || 1;
        height = height || 1;
        var scale = (0, $kwLGk.zoomToScale)(zoom);
        altitude = Math.max(0.75, altitude);
        var center = (0, $kwLGk.lngLatToWorld)([
            longitude,
            latitude
        ]);
        center[2] = 0;
        var projectionMatrix = (0, $kwLGk.getProjectionMatrix)({
            width: width,
            height: height,
            pitch: pitch,
            bearing: bearing,
            altitude: altitude,
            nearZMultiplier: nearZMultiplier,
            farZMultiplier: farZMultiplier
        });
        var viewMatrix = (0, $kwLGk.getViewMatrix)({
            height: height,
            scale: scale,
            center: center,
            pitch: pitch,
            bearing: bearing,
            altitude: altitude
        });
        _this = (0, $7BQbw.default)(this, (0, $02VYc.default)(WebMercatorViewport).call(this, {
            width: width,
            height: height,
            scale: scale,
            viewMatrix: viewMatrix,
            projectionMatrix: projectionMatrix
        }));
        _this.latitude = latitude;
        _this.longitude = longitude;
        _this.zoom = zoom;
        _this.pitch = pitch;
        _this.bearing = bearing;
        _this.altitude = altitude;
        _this.center = center;
        _this.unitsPerMeter = (0, $kwLGk.getDistanceScales)((0, $bqRYk.default)(_this)).unitsPerMeter[2];
        Object.freeze((0, $bqRYk.default)(_this));
        return _this;
    }
    (0, $16cE9.default)(WebMercatorViewport, [
        {
            key: "projectFlat",
            value: function projectFlat(lngLat) {
                return (0, $kwLGk.lngLatToWorld)(lngLat);
            }
        },
        {
            key: "unprojectFlat",
            value: function unprojectFlat(xy) {
                return (0, $kwLGk.worldToLngLat)(xy);
            }
        },
        {
            key: "getMapCenterByLngLatPosition",
            value: function getMapCenterByLngLatPosition(_ref2) {
                var lngLat = _ref2.lngLat, pos = _ref2.pos;
                var fromLocation = (0, $kwLGk.pixelsToWorld)(pos, this.pixelUnprojectionMatrix);
                var toLocation = (0, $kwLGk.lngLatToWorld)(lngLat);
                var translate = $2SWep.add([], toLocation, $2SWep.negate([], fromLocation));
                var newCenter = $2SWep.add([], this.center, translate);
                return (0, $kwLGk.worldToLngLat)(newCenter, this.scale);
            }
        },
        {
            key: "getLocationAtPoint",
            value: function getLocationAtPoint(_ref3) {
                var lngLat = _ref3.lngLat, pos = _ref3.pos;
                return this.getMapCenterByLngLatPosition({
                    lngLat: lngLat,
                    pos: pos
                });
            }
        },
        {
            key: "fitBounds",
            value: function fitBounds(bounds) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var width = this.width, height = this.height;
                var _fitBounds2 = (0, $8fo7C.default)(Object.assign({
                    width: width,
                    height: height,
                    bounds: bounds
                }, options)), longitude = _fitBounds2.longitude, latitude = _fitBounds2.latitude, zoom = _fitBounds2.zoom;
                return new WebMercatorViewport({
                    width: width,
                    height: height,
                    longitude: longitude,
                    latitude: latitude,
                    zoom: zoom
                });
            }
        }
    ]);
    return WebMercatorViewport;
}((0, $7KSX8.default));

});
parcelRegister("dYxCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2caf5e003e8c581$export$2e2bcd8739ae039; });
function $a2caf5e003e8c581$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("16cE9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cd0295bab3691a5$export$2e2bcd8739ae039; });
function $0cd0295bab3691a5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0cd0295bab3691a5$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $0cd0295bab3691a5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0cd0295bab3691a5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("7BQbw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58a477ebbc7a3ace$export$2e2bcd8739ae039; });

var $94j5f = parcelRequire("94j5f");

var $bqRYk = parcelRequire("bqRYk");
function $58a477ebbc7a3ace$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $94j5f.default)(call) === "object" || typeof call === "function")) return call;
    return (0, $bqRYk.default)(self);
}

});
parcelRegister("94j5f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69a34a5f06e77f7a$export$2e2bcd8739ae039; });
function $69a34a5f06e77f7a$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $69a34a5f06e77f7a$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $69a34a5f06e77f7a$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $69a34a5f06e77f7a$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("bqRYk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $852bfd241f2b403e$export$2e2bcd8739ae039; });
function $852bfd241f2b403e$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRegister("02VYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $008d27aa72bdac94$export$2e2bcd8739ae039; });
function $008d27aa72bdac94$export$2e2bcd8739ae039(o) {
    $008d27aa72bdac94$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $008d27aa72bdac94$export$2e2bcd8739ae039(o);
}

});

parcelRegister("59aVE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf64541cd3d1b83$export$2e2bcd8739ae039; });

var $1kHih = parcelRequire("1kHih");
function $3bf64541cd3d1b83$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $1kHih.default)(subClass, superClass);
}

});
parcelRegister("1kHih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f893df7fba7b0f2$export$2e2bcd8739ae039; });
function $0f893df7fba7b0f2$export$2e2bcd8739ae039(o, p) {
    $0f893df7fba7b0f2$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0f893df7fba7b0f2$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("7KSX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a5774bdec835d33$export$2e2bcd8739ae039; });

var $kkBq7 = parcelRequire("kkBq7");

var $dYxCI = parcelRequire("dYxCI");

var $16cE9 = parcelRequire("16cE9");

var $8Ke6L = parcelRequire("8Ke6L");

var $kwLGk = parcelRequire("kwLGk");

var $9SfcV = parcelRequire("9SfcV");
var $5a5774bdec835d33$var$IDENTITY = (0, $8Ke6L.createMat4)();
var $5a5774bdec835d33$export$2e2bcd8739ae039 = function() {
    function Viewport() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, width = _ref.width, height = _ref.height, scale = _ref.scale, _ref$viewMatrix = _ref.viewMatrix, viewMatrix = _ref$viewMatrix === void 0 ? $5a5774bdec835d33$var$IDENTITY : _ref$viewMatrix, _ref$projectionMatrix = _ref.projectionMatrix, projectionMatrix = _ref$projectionMatrix === void 0 ? $5a5774bdec835d33$var$IDENTITY : _ref$projectionMatrix;
        (0, $dYxCI.default)(this, Viewport);
        this.width = width || 1;
        this.height = height || 1;
        this.scale = scale;
        this.unitsPerMeter = 1;
        this.viewMatrix = viewMatrix;
        this.projectionMatrix = projectionMatrix;
        var vpm = (0, $8Ke6L.createMat4)();
        $9SfcV.multiply(vpm, vpm, this.projectionMatrix);
        $9SfcV.multiply(vpm, vpm, this.viewMatrix);
        this.viewProjectionMatrix = vpm;
        var m = (0, $8Ke6L.createMat4)();
        $9SfcV.scale(m, m, [
            this.width / 2,
            -this.height / 2,
            1
        ]);
        $9SfcV.translate(m, m, [
            1,
            -1,
            0
        ]);
        $9SfcV.multiply(m, m, this.viewProjectionMatrix);
        var mInverse = $9SfcV.invert((0, $8Ke6L.createMat4)(), m);
        if (!mInverse) throw new Error("Pixel project matrix not invertible");
        this.pixelProjectionMatrix = m;
        this.pixelUnprojectionMatrix = mInverse;
        this.equals = this.equals.bind(this);
        this.project = this.project.bind(this);
        this.unproject = this.unproject.bind(this);
        this.projectPosition = this.projectPosition.bind(this);
        this.unprojectPosition = this.unprojectPosition.bind(this);
        this.projectFlat = this.projectFlat.bind(this);
        this.unprojectFlat = this.unprojectFlat.bind(this);
    }
    (0, $16cE9.default)(Viewport, [
        {
            key: "equals",
            value: function equals(viewport) {
                if (!(viewport instanceof Viewport)) return false;
                return viewport.width === this.width && viewport.height === this.height && $9SfcV.equals(viewport.projectionMatrix, this.projectionMatrix) && $9SfcV.equals(viewport.viewMatrix, this.viewMatrix);
            }
        },
        {
            key: "project",
            value: function project(xyz) {
                var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$topLeft = _ref2.topLeft, topLeft = _ref2$topLeft === void 0 ? true : _ref2$topLeft;
                var worldPosition = this.projectPosition(xyz);
                var coord = (0, $kwLGk.worldToPixels)(worldPosition, this.pixelProjectionMatrix);
                var _coord = (0, $kkBq7.default)(coord, 2), x = _coord[0], y = _coord[1];
                var y2 = topLeft ? y : this.height - y;
                return xyz.length === 2 ? [
                    x,
                    y2
                ] : [
                    x,
                    y2,
                    coord[2]
                ];
            }
        },
        {
            key: "unproject",
            value: function unproject(xyz) {
                var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref3$topLeft = _ref3.topLeft, topLeft = _ref3$topLeft === void 0 ? true : _ref3$topLeft, targetZ = _ref3.targetZ;
                var _xyz = (0, $kkBq7.default)(xyz, 3), x = _xyz[0], y = _xyz[1], z = _xyz[2];
                var y2 = topLeft ? y : this.height - y;
                var targetZWorld = targetZ && targetZ * this.unitsPerMeter;
                var coord = (0, $kwLGk.pixelsToWorld)([
                    x,
                    y2,
                    z
                ], this.pixelUnprojectionMatrix, targetZWorld);
                var _this$unprojectPositi = this.unprojectPosition(coord), _this$unprojectPositi2 = (0, $kkBq7.default)(_this$unprojectPositi, 3), X = _this$unprojectPositi2[0], Y = _this$unprojectPositi2[1], Z = _this$unprojectPositi2[2];
                if (Number.isFinite(z)) return [
                    X,
                    Y,
                    Z
                ];
                return Number.isFinite(targetZ) ? [
                    X,
                    Y,
                    targetZ
                ] : [
                    X,
                    Y
                ];
            }
        },
        {
            key: "projectPosition",
            value: function projectPosition(xyz) {
                var _this$projectFlat = this.projectFlat(xyz), _this$projectFlat2 = (0, $kkBq7.default)(_this$projectFlat, 2), X = _this$projectFlat2[0], Y = _this$projectFlat2[1];
                var Z = (xyz[2] || 0) * this.unitsPerMeter;
                return [
                    X,
                    Y,
                    Z
                ];
            }
        },
        {
            key: "unprojectPosition",
            value: function unprojectPosition(xyz) {
                var _this$unprojectFlat = this.unprojectFlat(xyz), _this$unprojectFlat2 = (0, $kkBq7.default)(_this$unprojectFlat, 2), X = _this$unprojectFlat2[0], Y = _this$unprojectFlat2[1];
                var Z = (xyz[2] || 0) / this.unitsPerMeter;
                return [
                    X,
                    Y,
                    Z
                ];
            }
        },
        {
            key: "projectFlat",
            value: function projectFlat(xyz) {
                var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
                return xyz;
            }
        },
        {
            key: "unprojectFlat",
            value: function unprojectFlat(xyz) {
                var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scale;
                return xyz;
            }
        }
    ]);
    return Viewport;
}();

});
parcelRegister("kkBq7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecd2b3c76fb94345$export$2e2bcd8739ae039; });

var $eGfCf = parcelRequire("eGfCf");

var $hr5VG = parcelRequire("hr5VG");

var $jlviv = parcelRequire("jlviv");

var $f0MNS = parcelRequire("f0MNS");
function $ecd2b3c76fb94345$export$2e2bcd8739ae039(arr, i) {
    return (0, $eGfCf.default)(arr) || (0, $hr5VG.default)(arr, i) || (0, $jlviv.default)(arr, i) || (0, $f0MNS.default)();
}

});
parcelRegister("eGfCf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab0119f132be4533$export$2e2bcd8739ae039; });
function $ab0119f132be4533$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("hr5VG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb198ebf5d450510$export$2e2bcd8739ae039; });
function $cb198ebf5d450510$export$2e2bcd8739ae039(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("jlviv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1584180bebf7e16$export$2e2bcd8739ae039; });

var $lAFYl = parcelRequire("lAFYl");
function $e1584180bebf7e16$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $lAFYl.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $lAFYl.default)(o, minLen);
}

});
parcelRegister("lAFYl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb7d8492755baaa1$export$2e2bcd8739ae039; });
function $fb7d8492755baaa1$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("f0MNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aedcb6730bbdd7a0$export$2e2bcd8739ae039; });
function $aedcb6730bbdd7a0$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8Ke6L", function(module, exports) {

$parcel$export(module.exports, "createMat4", function () { return $65dd9033e92b6a5a$export$1a9a28cade4dcdc4; });
$parcel$export(module.exports, "transformVector", function () { return $65dd9033e92b6a5a$export$8248199402822036; });
$parcel$export(module.exports, "mod", function () { return $65dd9033e92b6a5a$export$842a2cf37af977e1; });
$parcel$export(module.exports, "lerp", function () { return $65dd9033e92b6a5a$export$3a89f8d6f6bf6c9f; });

var $ecdDb = parcelRequire("ecdDb");
function $65dd9033e92b6a5a$export$1a9a28cade4dcdc4() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function $65dd9033e92b6a5a$export$8248199402822036(matrix, vector) {
    var result = $ecdDb.transformMat4([], vector, matrix);
    $ecdDb.scale(result, result, 1 / result[3]);
    return result;
}
function $65dd9033e92b6a5a$export$842a2cf37af977e1(value, divisor) {
    var modulus = value % divisor;
    return modulus < 0 ? divisor + modulus : modulus;
}
function $65dd9033e92b6a5a$export$3a89f8d6f6bf6c9f(start, end, step) {
    return step * end + (1 - step) * start;
}

});
parcelRegister("ecdDb", function(module, exports) {

$parcel$export(module.exports, "scale", function () { return $a55cc2826f401162$export$dcdf75081b88279d; });
$parcel$export(module.exports, "transformMat4", function () { return $a55cc2826f401162$export$5ffbd13800309d59; });

var $9lyvx = parcelRequire("9lyvx");
function $a55cc2826f401162$export$185802fd694ee1f5() {
    var out = new $9lyvx.ARRAY_TYPE(4);
    if ($9lyvx.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $a55cc2826f401162$export$9cd59f9826255e47(a) {
    var out = new $9lyvx.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $a55cc2826f401162$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $9lyvx.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $a55cc2826f401162$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $a55cc2826f401162$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $a55cc2826f401162$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $a55cc2826f401162$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $a55cc2826f401162$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $a55cc2826f401162$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $a55cc2826f401162$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $a55cc2826f401162$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $a55cc2826f401162$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $a55cc2826f401162$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $a55cc2826f401162$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $a55cc2826f401162$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $a55cc2826f401162$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $a55cc2826f401162$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $a55cc2826f401162$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $a55cc2826f401162$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $a55cc2826f401162$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $a55cc2826f401162$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $a55cc2826f401162$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $a55cc2826f401162$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $a55cc2826f401162$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $a55cc2826f401162$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $a55cc2826f401162$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $a55cc2826f401162$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $9lyvx.RANDOM() * 2 - 1;
        v2 = $9lyvx.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $9lyvx.RANDOM() * 2 - 1;
        v4 = $9lyvx.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $a55cc2826f401162$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $a55cc2826f401162$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $a55cc2826f401162$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $a55cc2826f401162$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $a55cc2826f401162$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $a55cc2826f401162$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $a55cc2826f401162$export$f93b5905241a7cca = $a55cc2826f401162$export$4e2d2ead65e5f7e3;
var $a55cc2826f401162$export$6e3a27864ab166fe = $a55cc2826f401162$export$2060d2db72cce88f;
var $a55cc2826f401162$export$159d9494db57879b = $a55cc2826f401162$export$cd007d971a5a2143;
var $a55cc2826f401162$export$6c4a311cc157c764 = $a55cc2826f401162$export$9f17032d917177de;
var $a55cc2826f401162$export$2422cd6c492a8b3a = $a55cc2826f401162$export$88e6ebb4fe54f538;
var $a55cc2826f401162$export$fc1400facf92c78 = $a55cc2826f401162$export$f24224f1c91d8156;
var $a55cc2826f401162$export$99d8dd3f32a3435 = $a55cc2826f401162$export$ab44e1323ffc8376;
var $a55cc2826f401162$export$4b80e395e36b5a56 = function() {
    var vec = $a55cc2826f401162$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});
parcelRegister("9lyvx", function(module, exports) {

$parcel$export(module.exports, "EPSILON", function () { return $6ce0d7bdb6009507$export$fd293b15f47e270; });
$parcel$export(module.exports, "ARRAY_TYPE", function () { return $6ce0d7bdb6009507$export$b67359430d3b1b2; });
$parcel$export(module.exports, "RANDOM", function () { return $6ce0d7bdb6009507$export$5ada478c8a628231; });
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $6ce0d7bdb6009507$export$fd293b15f47e270 = 0.000001;
var $6ce0d7bdb6009507$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $6ce0d7bdb6009507$export$5ada478c8a628231 = Math.random;
function $6ce0d7bdb6009507$export$cb2c0eb57f5e532c(type) {
    $6ce0d7bdb6009507$export$b67359430d3b1b2 = type;
}
var $6ce0d7bdb6009507$var$degree = Math.PI / 180;
function $6ce0d7bdb6009507$export$408b8ee5959eefd5(a) {
    return a * $6ce0d7bdb6009507$var$degree;
}
function $6ce0d7bdb6009507$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $6ce0d7bdb6009507$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};

});



parcelRegister("kwLGk", function(module, exports) {

$parcel$export(module.exports, "zoomToScale", function () { return $ef1bc868ec4f3759$export$eda81de7742ad8e7; });
$parcel$export(module.exports, "scaleToZoom", function () { return $ef1bc868ec4f3759$export$6e08c044660f3e30; });
$parcel$export(module.exports, "lngLatToWorld", function () { return $ef1bc868ec4f3759$export$4a0e8ea52607cc9b; });
$parcel$export(module.exports, "worldToLngLat", function () { return $ef1bc868ec4f3759$export$66ee0abd8a6a9660; });
$parcel$export(module.exports, "getMeterZoom", function () { return $ef1bc868ec4f3759$export$f4aaab1d865abddd; });
$parcel$export(module.exports, "getDistanceScales", function () { return $ef1bc868ec4f3759$export$14a522c4e7772100; });
$parcel$export(module.exports, "addMetersToLngLat", function () { return $ef1bc868ec4f3759$export$86ab4399faf187a8; });
$parcel$export(module.exports, "getViewMatrix", function () { return $ef1bc868ec4f3759$export$a4dee078b9284944; });
$parcel$export(module.exports, "getProjectionParameters", function () { return $ef1bc868ec4f3759$export$3debb7b92b597428; });
$parcel$export(module.exports, "getProjectionMatrix", function () { return $ef1bc868ec4f3759$export$1d64991cd669ebf9; });
$parcel$export(module.exports, "worldToPixels", function () { return $ef1bc868ec4f3759$export$46d0dd92e8f9a0db; });
$parcel$export(module.exports, "pixelsToWorld", function () { return $ef1bc868ec4f3759$export$d0eff18eb06add5f; });

var $kkBq7 = parcelRequire("kkBq7");

var $8Ke6L = parcelRequire("8Ke6L");

var $9SfcV = parcelRequire("9SfcV");

var $2SWep = parcelRequire("2SWep");

var $b4Q0K = parcelRequire("b4Q0K");

var $9rQ4F = parcelRequire("9rQ4F");
var $ef1bc868ec4f3759$var$PI = Math.PI;
var $ef1bc868ec4f3759$var$PI_4 = $ef1bc868ec4f3759$var$PI / 4;
var $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS = $ef1bc868ec4f3759$var$PI / 180;
var $ef1bc868ec4f3759$var$RADIANS_TO_DEGREES = 180 / $ef1bc868ec4f3759$var$PI;
var $ef1bc868ec4f3759$var$TILE_SIZE = 512;
var $ef1bc868ec4f3759$var$EARTH_CIRCUMFERENCE = 40.03e6;
var $ef1bc868ec4f3759$var$DEFAULT_ALTITUDE = 1.5;
function $ef1bc868ec4f3759$export$eda81de7742ad8e7(zoom) {
    return Math.pow(2, zoom);
}
function $ef1bc868ec4f3759$export$6e08c044660f3e30(scale) {
    return Math.log2(scale);
}
function $ef1bc868ec4f3759$export$4a0e8ea52607cc9b(_ref) {
    var _ref2 = (0, $kkBq7.default)(_ref, 2), lng = _ref2[0], lat = _ref2[1];
    (0, $9rQ4F.default)(Number.isFinite(lng));
    (0, $9rQ4F.default)(Number.isFinite(lat) && lat >= -90 && lat <= 90, "invalid latitude");
    var lambda2 = lng * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS;
    var phi2 = lat * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS;
    var x = $ef1bc868ec4f3759$var$TILE_SIZE * (lambda2 + $ef1bc868ec4f3759$var$PI) / (2 * $ef1bc868ec4f3759$var$PI);
    var y = $ef1bc868ec4f3759$var$TILE_SIZE * ($ef1bc868ec4f3759$var$PI + Math.log(Math.tan($ef1bc868ec4f3759$var$PI_4 + phi2 * 0.5))) / (2 * $ef1bc868ec4f3759$var$PI);
    return [
        x,
        y
    ];
}
function $ef1bc868ec4f3759$export$66ee0abd8a6a9660(_ref3) {
    var _ref4 = (0, $kkBq7.default)(_ref3, 2), x = _ref4[0], y = _ref4[1];
    var lambda2 = x / $ef1bc868ec4f3759$var$TILE_SIZE * (2 * $ef1bc868ec4f3759$var$PI) - $ef1bc868ec4f3759$var$PI;
    var phi2 = 2 * (Math.atan(Math.exp(y / $ef1bc868ec4f3759$var$TILE_SIZE * (2 * $ef1bc868ec4f3759$var$PI) - $ef1bc868ec4f3759$var$PI)) - $ef1bc868ec4f3759$var$PI_4);
    return [
        lambda2 * $ef1bc868ec4f3759$var$RADIANS_TO_DEGREES,
        phi2 * $ef1bc868ec4f3759$var$RADIANS_TO_DEGREES
    ];
}
function $ef1bc868ec4f3759$export$f4aaab1d865abddd(_ref5) {
    var latitude = _ref5.latitude;
    (0, $9rQ4F.default)(Number.isFinite(latitude));
    var latCosine = Math.cos(latitude * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS);
    return $ef1bc868ec4f3759$export$6e08c044660f3e30($ef1bc868ec4f3759$var$EARTH_CIRCUMFERENCE * latCosine) - 9;
}
function $ef1bc868ec4f3759$export$14a522c4e7772100(_ref6) {
    var latitude = _ref6.latitude, longitude = _ref6.longitude, _ref6$highPrecision = _ref6.highPrecision, highPrecision = _ref6$highPrecision === void 0 ? false : _ref6$highPrecision;
    (0, $9rQ4F.default)(Number.isFinite(latitude) && Number.isFinite(longitude));
    var result = {};
    var worldSize = $ef1bc868ec4f3759$var$TILE_SIZE;
    var latCosine = Math.cos(latitude * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS);
    var unitsPerDegreeX = worldSize / 360;
    var unitsPerDegreeY = unitsPerDegreeX / latCosine;
    var altUnitsPerMeter = worldSize / $ef1bc868ec4f3759$var$EARTH_CIRCUMFERENCE / latCosine;
    result.unitsPerMeter = [
        altUnitsPerMeter,
        altUnitsPerMeter,
        altUnitsPerMeter
    ];
    result.metersPerUnit = [
        1 / altUnitsPerMeter,
        1 / altUnitsPerMeter,
        1 / altUnitsPerMeter
    ];
    result.unitsPerDegree = [
        unitsPerDegreeX,
        unitsPerDegreeY,
        altUnitsPerMeter
    ];
    result.degreesPerUnit = [
        1 / unitsPerDegreeX,
        1 / unitsPerDegreeY,
        1 / altUnitsPerMeter
    ];
    if (highPrecision) {
        var latCosine2 = $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS * Math.tan(latitude * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS) / latCosine;
        var unitsPerDegreeY2 = unitsPerDegreeX * latCosine2 / 2;
        var altUnitsPerDegree2 = worldSize / $ef1bc868ec4f3759$var$EARTH_CIRCUMFERENCE * latCosine2;
        var altUnitsPerMeter2 = altUnitsPerDegree2 / unitsPerDegreeY * altUnitsPerMeter;
        result.unitsPerDegree2 = [
            0,
            unitsPerDegreeY2,
            altUnitsPerDegree2
        ];
        result.unitsPerMeter2 = [
            altUnitsPerMeter2,
            0,
            altUnitsPerMeter2
        ];
    }
    return result;
}
function $ef1bc868ec4f3759$export$86ab4399faf187a8(lngLatZ, xyz) {
    var _lngLatZ = (0, $kkBq7.default)(lngLatZ, 3), longitude = _lngLatZ[0], latitude = _lngLatZ[1], z0 = _lngLatZ[2];
    var _xyz = (0, $kkBq7.default)(xyz, 3), x = _xyz[0], y = _xyz[1], z = _xyz[2];
    var _getDistanceScales = $ef1bc868ec4f3759$export$14a522c4e7772100({
        longitude: longitude,
        latitude: latitude,
        highPrecision: true
    }), unitsPerMeter = _getDistanceScales.unitsPerMeter, unitsPerMeter2 = _getDistanceScales.unitsPerMeter2;
    var worldspace = $ef1bc868ec4f3759$export$4a0e8ea52607cc9b(lngLatZ);
    worldspace[0] += x * (unitsPerMeter[0] + unitsPerMeter2[0] * y);
    worldspace[1] += y * (unitsPerMeter[1] + unitsPerMeter2[1] * y);
    var newLngLat = $ef1bc868ec4f3759$export$66ee0abd8a6a9660(worldspace);
    var newZ = (z0 || 0) + (z || 0);
    return Number.isFinite(z0) || Number.isFinite(z) ? [
        newLngLat[0],
        newLngLat[1],
        newZ
    ] : newLngLat;
}
function $ef1bc868ec4f3759$export$a4dee078b9284944(_ref7) {
    var height = _ref7.height, pitch = _ref7.pitch, bearing = _ref7.bearing, altitude = _ref7.altitude, scale = _ref7.scale, _ref7$center = _ref7.center, center = _ref7$center === void 0 ? null : _ref7$center;
    var vm = (0, $8Ke6L.createMat4)();
    $9SfcV.translate(vm, vm, [
        0,
        0,
        -altitude
    ]);
    $9SfcV.rotateX(vm, vm, -pitch * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS);
    $9SfcV.rotateZ(vm, vm, bearing * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS);
    scale /= height;
    $9SfcV.scale(vm, vm, [
        scale,
        scale,
        scale
    ]);
    if (center) $9SfcV.translate(vm, vm, $b4Q0K.negate([], center));
    return vm;
}
function $ef1bc868ec4f3759$export$3debb7b92b597428(_ref8) {
    var width = _ref8.width, height = _ref8.height, _ref8$altitude = _ref8.altitude, altitude = _ref8$altitude === void 0 ? $ef1bc868ec4f3759$var$DEFAULT_ALTITUDE : _ref8$altitude, _ref8$pitch = _ref8.pitch, pitch = _ref8$pitch === void 0 ? 0 : _ref8$pitch, _ref8$nearZMultiplier = _ref8.nearZMultiplier, nearZMultiplier = _ref8$nearZMultiplier === void 0 ? 1 : _ref8$nearZMultiplier, _ref8$farZMultiplier = _ref8.farZMultiplier, farZMultiplier = _ref8$farZMultiplier === void 0 ? 1 : _ref8$farZMultiplier;
    var pitchRadians = pitch * $ef1bc868ec4f3759$var$DEGREES_TO_RADIANS;
    var halfFov = Math.atan(0.5 / altitude);
    var topHalfSurfaceDistance = Math.sin(halfFov) * altitude / Math.sin(Math.PI / 2 - pitchRadians - halfFov);
    var farZ = Math.cos(Math.PI / 2 - pitchRadians) * topHalfSurfaceDistance + altitude;
    return {
        fov: 2 * halfFov,
        aspect: width / height,
        focalDistance: altitude,
        near: nearZMultiplier,
        far: farZ * farZMultiplier
    };
}
function $ef1bc868ec4f3759$export$1d64991cd669ebf9(_ref9) {
    var width = _ref9.width, height = _ref9.height, pitch = _ref9.pitch, altitude = _ref9.altitude, nearZMultiplier = _ref9.nearZMultiplier, farZMultiplier = _ref9.farZMultiplier;
    var _getProjectionParamet = $ef1bc868ec4f3759$export$3debb7b92b597428({
        width: width,
        height: height,
        altitude: altitude,
        pitch: pitch,
        nearZMultiplier: nearZMultiplier,
        farZMultiplier: farZMultiplier
    }), fov = _getProjectionParamet.fov, aspect = _getProjectionParamet.aspect, near = _getProjectionParamet.near, far = _getProjectionParamet.far;
    var projectionMatrix = $9SfcV.perspective([], fov, aspect, near, far);
    return projectionMatrix;
}
function $ef1bc868ec4f3759$export$46d0dd92e8f9a0db(xyz, pixelProjectionMatrix) {
    var _xyz2 = (0, $kkBq7.default)(xyz, 3), x = _xyz2[0], y = _xyz2[1], _xyz2$ = _xyz2[2], z = _xyz2$ === void 0 ? 0 : _xyz2$;
    (0, $9rQ4F.default)(Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(z));
    return (0, $8Ke6L.transformVector)(pixelProjectionMatrix, [
        x,
        y,
        z,
        1
    ]);
}
function $ef1bc868ec4f3759$export$d0eff18eb06add5f(xyz, pixelUnprojectionMatrix) {
    var targetZ = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _xyz3 = (0, $kkBq7.default)(xyz, 3), x = _xyz3[0], y = _xyz3[1], z = _xyz3[2];
    (0, $9rQ4F.default)(Number.isFinite(x) && Number.isFinite(y), "invalid pixel coordinate");
    if (Number.isFinite(z)) {
        var coord = (0, $8Ke6L.transformVector)(pixelUnprojectionMatrix, [
            x,
            y,
            z,
            1
        ]);
        return coord;
    }
    var coord0 = (0, $8Ke6L.transformVector)(pixelUnprojectionMatrix, [
        x,
        y,
        0,
        1
    ]);
    var coord1 = (0, $8Ke6L.transformVector)(pixelUnprojectionMatrix, [
        x,
        y,
        1,
        1
    ]);
    var z0 = coord0[2];
    var z1 = coord1[2];
    var t = z0 === z1 ? 0 : ((targetZ || 0) - z0) / (z1 - z0);
    return $2SWep.lerp([], coord0, coord1, t);
}

});
parcelRegister("9SfcV", function(module, exports) {

$parcel$export(module.exports, "invert", function () { return $7304f41566363639$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "multiply", function () { return $7304f41566363639$export$2060d2db72cce88f; });
$parcel$export(module.exports, "translate", function () { return $7304f41566363639$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "scale", function () { return $7304f41566363639$export$dcdf75081b88279d; });
$parcel$export(module.exports, "rotateX", function () { return $7304f41566363639$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateZ", function () { return $7304f41566363639$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "perspective", function () { return $7304f41566363639$export$541149539f3a4684; });
$parcel$export(module.exports, "equals", function () { return $7304f41566363639$export$e9bab7fafb253603; });

var $9lyvx = parcelRequire("9lyvx");
function $7304f41566363639$export$185802fd694ee1f5() {
    var out = new $9lyvx.ARRAY_TYPE(16);
    if ($9lyvx.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$9cd59f9826255e47(a) {
    var out = new $9lyvx.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $7304f41566363639$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $7304f41566363639$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $9lyvx.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $7304f41566363639$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $7304f41566363639$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $7304f41566363639$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $7304f41566363639$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $7304f41566363639$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $7304f41566363639$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $7304f41566363639$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $7304f41566363639$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $7304f41566363639$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $9lyvx.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $7304f41566363639$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $7304f41566363639$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $7304f41566363639$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $7304f41566363639$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $9lyvx.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$ff497f2be31cc6a(out, a) {
    var translation = new $9lyvx.ARRAY_TYPE(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $7304f41566363639$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $7304f41566363639$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $7304f41566363639$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $7304f41566363639$export$df3937d3b537df0a(out, mat) {
    var scaling = new $9lyvx.ARRAY_TYPE(3);
    $7304f41566363639$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $7304f41566363639$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $7304f41566363639$export$541149539f3a4684(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
function $7304f41566363639$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $7304f41566363639$export$4f2167e613cfc87b(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $9lyvx.EPSILON && Math.abs(eyey - centery) < $9lyvx.EPSILON && Math.abs(eyez - centerz) < $9lyvx.EPSILON) return $7304f41566363639$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $7304f41566363639$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $7304f41566363639$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $7304f41566363639$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $7304f41566363639$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $7304f41566363639$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $7304f41566363639$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $7304f41566363639$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $7304f41566363639$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $7304f41566363639$export$6e3a27864ab166fe = $7304f41566363639$export$2060d2db72cce88f;
var $7304f41566363639$export$f93b5905241a7cca = $7304f41566363639$export$4e2d2ead65e5f7e3;

});

parcelRegister("2SWep", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $219dcb74654080fe$export$e16d8520af44a096; });
$parcel$export(module.exports, "scale", function () { return $219dcb74654080fe$export$dcdf75081b88279d; });
$parcel$export(module.exports, "length", function () { return $219dcb74654080fe$export$f24224f1c91d8156; });
$parcel$export(module.exports, "negate", function () { return $219dcb74654080fe$export$aef51622e549b8b0; });
$parcel$export(module.exports, "lerp", function () { return $219dcb74654080fe$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "sub", function () { return $219dcb74654080fe$export$f93b5905241a7cca; });

var $9lyvx = parcelRequire("9lyvx");
function $219dcb74654080fe$export$185802fd694ee1f5() {
    var out = new $9lyvx.ARRAY_TYPE(2);
    if ($9lyvx.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $219dcb74654080fe$export$9cd59f9826255e47(a) {
    var out = new $9lyvx.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $219dcb74654080fe$export$a82be99ed2a44a7d(x, y) {
    var out = new $9lyvx.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $219dcb74654080fe$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $219dcb74654080fe$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $219dcb74654080fe$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $219dcb74654080fe$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $219dcb74654080fe$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $219dcb74654080fe$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $219dcb74654080fe$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $219dcb74654080fe$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $219dcb74654080fe$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $219dcb74654080fe$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $219dcb74654080fe$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $219dcb74654080fe$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $219dcb74654080fe$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $219dcb74654080fe$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $219dcb74654080fe$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $219dcb74654080fe$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $219dcb74654080fe$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $219dcb74654080fe$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $219dcb74654080fe$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $219dcb74654080fe$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $219dcb74654080fe$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $219dcb74654080fe$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $219dcb74654080fe$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $219dcb74654080fe$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $9lyvx.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $219dcb74654080fe$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $219dcb74654080fe$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $219dcb74654080fe$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $219dcb74654080fe$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $219dcb74654080fe$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $219dcb74654080fe$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $219dcb74654080fe$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $219dcb74654080fe$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $219dcb74654080fe$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $219dcb74654080fe$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $219dcb74654080fe$export$fc1400facf92c78 = $219dcb74654080fe$export$f24224f1c91d8156;
var $219dcb74654080fe$export$f93b5905241a7cca = $219dcb74654080fe$export$4e2d2ead65e5f7e3;
var $219dcb74654080fe$export$6e3a27864ab166fe = $219dcb74654080fe$export$2060d2db72cce88f;
var $219dcb74654080fe$export$159d9494db57879b = $219dcb74654080fe$export$cd007d971a5a2143;
var $219dcb74654080fe$export$6c4a311cc157c764 = $219dcb74654080fe$export$9f17032d917177de;
var $219dcb74654080fe$export$2422cd6c492a8b3a = $219dcb74654080fe$export$88e6ebb4fe54f538;
var $219dcb74654080fe$export$99d8dd3f32a3435 = $219dcb74654080fe$export$ab44e1323ffc8376;
var $219dcb74654080fe$export$4b80e395e36b5a56 = function() {
    var vec = $219dcb74654080fe$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

});

parcelRegister("b4Q0K", function(module, exports) {

$parcel$export(module.exports, "negate", function () { return $810869c39f835e02$export$aef51622e549b8b0; });

var $9lyvx = parcelRequire("9lyvx");
function $810869c39f835e02$export$185802fd694ee1f5() {
    var out = new $9lyvx.ARRAY_TYPE(3);
    if ($9lyvx.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $810869c39f835e02$export$9cd59f9826255e47(a) {
    var out = new $9lyvx.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $810869c39f835e02$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $810869c39f835e02$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $9lyvx.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $810869c39f835e02$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $810869c39f835e02$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $810869c39f835e02$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $810869c39f835e02$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $810869c39f835e02$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $810869c39f835e02$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $810869c39f835e02$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $810869c39f835e02$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $810869c39f835e02$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $810869c39f835e02$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $810869c39f835e02$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $810869c39f835e02$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $810869c39f835e02$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $810869c39f835e02$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $810869c39f835e02$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $810869c39f835e02$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $810869c39f835e02$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $810869c39f835e02$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $810869c39f835e02$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $810869c39f835e02$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $810869c39f835e02$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $810869c39f835e02$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $810869c39f835e02$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $810869c39f835e02$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $810869c39f835e02$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $9lyvx.RANDOM() * 2.0 * Math.PI;
    var z = $9lyvx.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $810869c39f835e02$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $810869c39f835e02$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $810869c39f835e02$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $810869c39f835e02$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $810869c39f835e02$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $810869c39f835e02$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $810869c39f835e02$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $810869c39f835e02$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $810869c39f835e02$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $810869c39f835e02$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $810869c39f835e02$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $810869c39f835e02$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $9lyvx.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $810869c39f835e02$export$f93b5905241a7cca = $810869c39f835e02$export$4e2d2ead65e5f7e3;
var $810869c39f835e02$export$6e3a27864ab166fe = $810869c39f835e02$export$2060d2db72cce88f;
var $810869c39f835e02$export$159d9494db57879b = $810869c39f835e02$export$cd007d971a5a2143;
var $810869c39f835e02$export$6c4a311cc157c764 = $810869c39f835e02$export$9f17032d917177de;
var $810869c39f835e02$export$2422cd6c492a8b3a = $810869c39f835e02$export$88e6ebb4fe54f538;
var $810869c39f835e02$export$fc1400facf92c78 = $810869c39f835e02$export$f24224f1c91d8156;
var $810869c39f835e02$export$99d8dd3f32a3435 = $810869c39f835e02$export$ab44e1323ffc8376;
var $810869c39f835e02$export$4b80e395e36b5a56 = function() {
    var vec = $810869c39f835e02$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});

parcelRegister("9rQ4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e0f078cef3edca2$export$2e2bcd8739ae039; });
function $6e0f078cef3edca2$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message || "@math.gl/web-mercator: assertion failed.");
}

});



parcelRegister("8fo7C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60126f8c1083e194$export$2e2bcd8739ae039; });

var $kkBq7 = parcelRequire("kkBq7");

var $2NnPF = parcelRequire("2NnPF");

var $9rQ4F = parcelRequire("9rQ4F");
function $60126f8c1083e194$export$2e2bcd8739ae039(_ref) {
    var width = _ref.width, height = _ref.height, bounds = _ref.bounds, _ref$minExtent = _ref.minExtent, minExtent = _ref$minExtent === void 0 ? 0 : _ref$minExtent, _ref$maxZoom = _ref.maxZoom, maxZoom = _ref$maxZoom === void 0 ? 24 : _ref$maxZoom, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 0 : _ref$padding, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? [
        0,
        0
    ] : _ref$offset;
    var _bounds = (0, $kkBq7.default)(bounds, 2), _bounds$ = (0, $kkBq7.default)(_bounds[0], 2), west = _bounds$[0], south = _bounds$[1], _bounds$2 = (0, $kkBq7.default)(_bounds[1], 2), east = _bounds$2[0], north = _bounds$2[1];
    if (Number.isFinite(padding)) {
        var p = padding;
        padding = {
            top: p,
            bottom: p,
            left: p,
            right: p
        };
    } else (0, $9rQ4F.default)(Number.isFinite(padding.top) && Number.isFinite(padding.bottom) && Number.isFinite(padding.left) && Number.isFinite(padding.right));
    var viewport = new (0, $2NnPF.default)({
        width: width,
        height: height,
        longitude: 0,
        latitude: 0,
        zoom: 0
    });
    var nw = viewport.project([
        west,
        north
    ]);
    var se = viewport.project([
        east,
        south
    ]);
    var size = [
        Math.max(Math.abs(se[0] - nw[0]), minExtent),
        Math.max(Math.abs(se[1] - nw[1]), minExtent)
    ];
    var targetSize = [
        width - padding.left - padding.right - Math.abs(offset[0]) * 2,
        height - padding.top - padding.bottom - Math.abs(offset[1]) * 2
    ];
    (0, $9rQ4F.default)(targetSize[0] > 0 && targetSize[1] > 0);
    var scaleX = targetSize[0] / size[0];
    var scaleY = targetSize[1] / size[1];
    var offsetX = (padding.right - padding.left) / 2 / scaleX;
    var offsetY = (padding.bottom - padding.top) / 2 / scaleY;
    var center = [
        (se[0] + nw[0]) / 2 + offsetX,
        (se[1] + nw[1]) / 2 + offsetY
    ];
    var centerLngLat = viewport.unproject(center);
    var zoom = Math.min(maxZoom, viewport.zoom + Math.log2(Math.abs(Math.min(scaleX, scaleY))));
    (0, $9rQ4F.default)(Number.isFinite(zoom));
    return {
        longitude: centerLngLat[0],
        latitude: centerLngLat[1],
        zoom: zoom
    };
}

});


parcelRegister("2wWtu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d7bedcb4945700f$export$2e2bcd8739ae039; });

var $2NnPF = parcelRequire("2NnPF");

var $8Ke6L = parcelRequire("8Ke6L");
var $1d7bedcb4945700f$var$MAX_LATITUDE = 85.05113;
var $1d7bedcb4945700f$var$MIN_LATITUDE = -85.05113;
function $1d7bedcb4945700f$export$2e2bcd8739ae039(_ref) {
    var width = _ref.width, height = _ref.height, longitude = _ref.longitude, latitude = _ref.latitude, zoom = _ref.zoom, _ref$pitch = _ref.pitch, pitch = _ref$pitch === void 0 ? 0 : _ref$pitch, _ref$bearing = _ref.bearing, bearing = _ref$bearing === void 0 ? 0 : _ref$bearing;
    if (longitude < -180 || longitude > 180) longitude = (0, $8Ke6L.mod)(longitude + 180, 360) - 180;
    if (bearing < -180 || bearing > 180) bearing = (0, $8Ke6L.mod)(bearing + 180, 360) - 180;
    var flatViewport = new (0, $2NnPF.default)({
        width: width,
        height: height,
        longitude: longitude,
        latitude: latitude,
        zoom: zoom
    });
    var topY = flatViewport.project([
        longitude,
        $1d7bedcb4945700f$var$MAX_LATITUDE
    ])[1];
    var bottomY = flatViewport.project([
        longitude,
        $1d7bedcb4945700f$var$MIN_LATITUDE
    ])[1];
    var shiftY = 0;
    if (bottomY - topY < height) {
        zoom += Math.log2(height / (bottomY - topY));
        flatViewport = new (0, $2NnPF.default)({
            width: width,
            height: height,
            longitude: longitude,
            latitude: latitude,
            zoom: zoom
        });
        topY = flatViewport.project([
            longitude,
            $1d7bedcb4945700f$var$MAX_LATITUDE
        ])[1];
        bottomY = flatViewport.project([
            longitude,
            $1d7bedcb4945700f$var$MIN_LATITUDE
        ])[1];
    }
    if (topY > 0) shiftY = topY;
    else if (bottomY < height) shiftY = bottomY - height;
    if (shiftY) latitude = flatViewport.unproject([
        width / 2,
        height / 2 + shiftY
    ])[1];
    return {
        width: width,
        height: height,
        longitude: longitude,
        latitude: latitude,
        zoom: zoom,
        pitch: pitch,
        bearing: bearing
    };
}

});

parcelRegister("czbEE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9261cb47f99281d9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getFlyToDuration", function () { return $9261cb47f99281d9$export$1d42c64f84307be3; });

var $8Ke6L = parcelRequire("8Ke6L");

var $kwLGk = parcelRequire("kwLGk");

var $2SWep = parcelRequire("2SWep");
var $9261cb47f99281d9$var$EPSILON = 0.01;
var $9261cb47f99281d9$var$VIEWPORT_TRANSITION_PROPS = [
    "longitude",
    "latitude",
    "zoom"
];
var $9261cb47f99281d9$var$DEFAULT_OPTS = {
    curve: 1.414,
    speed: 1.2
};
function $9261cb47f99281d9$export$2e2bcd8739ae039(startProps, endProps, t) {
    var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var viewport = {};
    var _getFlyToTransitionPa = $9261cb47f99281d9$var$getFlyToTransitionParams(startProps, endProps, opts), startZoom = _getFlyToTransitionPa.startZoom, startCenterXY = _getFlyToTransitionPa.startCenterXY, uDelta = _getFlyToTransitionPa.uDelta, w0 = _getFlyToTransitionPa.w0, u1 = _getFlyToTransitionPa.u1, S = _getFlyToTransitionPa.S, rho = _getFlyToTransitionPa.rho, rho2 = _getFlyToTransitionPa.rho2, r0 = _getFlyToTransitionPa.r0;
    if (u1 < $9261cb47f99281d9$var$EPSILON) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = $9261cb47f99281d9$var$VIEWPORT_TRANSITION_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var startValue = startProps[key];
                var endValue = endProps[key];
                viewport[key] = (0, $8Ke6L.lerp)(startValue, endValue, t);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) _iterator["return"]();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return viewport;
    }
    var s = t * S;
    var w = Math.cosh(r0) / Math.cosh(r0 + rho * s);
    var u = w0 * ((Math.cosh(r0) * Math.tanh(r0 + rho * s) - Math.sinh(r0)) / rho2) / u1;
    var scaleIncrement = 1 / w;
    var newZoom = startZoom + (0, $kwLGk.scaleToZoom)(scaleIncrement);
    var newCenterWorld = $2SWep.scale([], uDelta, u);
    $2SWep.add(newCenterWorld, newCenterWorld, startCenterXY);
    var newCenter = (0, $kwLGk.worldToLngLat)(newCenterWorld);
    viewport.longitude = newCenter[0];
    viewport.latitude = newCenter[1];
    viewport.zoom = newZoom;
    return viewport;
}
function $9261cb47f99281d9$export$1d42c64f84307be3(startProps, endProps) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    opts = Object.assign({}, $9261cb47f99281d9$var$DEFAULT_OPTS, opts);
    var _opts = opts, screenSpeed = _opts.screenSpeed, speed = _opts.speed, maxDuration = _opts.maxDuration;
    var _getFlyToTransitionPa2 = $9261cb47f99281d9$var$getFlyToTransitionParams(startProps, endProps, opts), S = _getFlyToTransitionPa2.S, rho = _getFlyToTransitionPa2.rho;
    var length = 1000 * S;
    var duration;
    if (Number.isFinite(screenSpeed)) duration = length / (screenSpeed / rho);
    else duration = length / speed;
    return Number.isFinite(maxDuration) && duration > maxDuration ? 0 : duration;
}
function $9261cb47f99281d9$var$getFlyToTransitionParams(startProps, endProps, opts) {
    opts = Object.assign({}, $9261cb47f99281d9$var$DEFAULT_OPTS, opts);
    var rho = opts.curve;
    var startZoom = startProps.zoom;
    var startCenter = [
        startProps.longitude,
        startProps.latitude
    ];
    var startScale = (0, $kwLGk.zoomToScale)(startZoom);
    var endZoom = endProps.zoom;
    var endCenter = [
        endProps.longitude,
        endProps.latitude
    ];
    var scale = (0, $kwLGk.zoomToScale)(endZoom - startZoom);
    var startCenterXY = (0, $kwLGk.lngLatToWorld)(startCenter);
    var endCenterXY = (0, $kwLGk.lngLatToWorld)(endCenter);
    var uDelta = $2SWep.sub([], endCenterXY, startCenterXY);
    var w0 = Math.max(startProps.width, startProps.height);
    var w1 = w0 / scale;
    var u1 = $2SWep.length(uDelta) * startScale;
    var _u1 = Math.max(u1, $9261cb47f99281d9$var$EPSILON);
    var rho2 = rho * rho;
    var b0 = (w1 * w1 - w0 * w0 + rho2 * rho2 * _u1 * _u1) / (2 * w0 * rho2 * _u1);
    var b1 = (w1 * w1 - w0 * w0 - rho2 * rho2 * _u1 * _u1) / (2 * w1 * rho2 * _u1);
    var r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0);
    var r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    var S = (r1 - r0) / rho;
    return {
        startZoom: startZoom,
        startCenterXY: startCenterXY,
        uDelta: uDelta,
        w0: w0,
        u1: u1,
        S: S,
        rho: rho,
        rho2: rho2,
        r0: r0,
        r1: r1
    };
}

});




parcelRegister("eJgQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImmutableFeatureCollection = void 0;
function $ab9257319456f908$var$_toConsumableArray(arr) {
    return $ab9257319456f908$var$_arrayWithoutHoles(arr) || $ab9257319456f908$var$_iterableToArray(arr) || $ab9257319456f908$var$_unsupportedIterableToArray(arr) || $ab9257319456f908$var$_nonIterableSpread();
}
function $ab9257319456f908$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ab9257319456f908$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ab9257319456f908$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ab9257319456f908$var$_arrayLikeToArray(o, minLen);
}
function $ab9257319456f908$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $ab9257319456f908$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ab9257319456f908$var$_arrayLikeToArray(arr);
}
function $ab9257319456f908$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ab9257319456f908$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ab9257319456f908$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ab9257319456f908$var$ownKeys(Object(source), true).forEach(function(key) {
            $ab9257319456f908$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ab9257319456f908$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ab9257319456f908$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ab9257319456f908$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ab9257319456f908$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ab9257319456f908$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ab9257319456f908$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ab9257319456f908$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ab9257319456f908$var$ImmutableFeatureCollection = /*#__PURE__*/ function() {
    function ImmutableFeatureCollection(featureCollection) {
        $ab9257319456f908$var$_classCallCheck(this, ImmutableFeatureCollection);
        $ab9257319456f908$var$_defineProperty(this, "featureCollection", void 0);
        this.featureCollection = featureCollection;
    }
    $ab9257319456f908$var$_createClass(ImmutableFeatureCollection, [
        {
            key: "getObject",
            value: function getObject() {
                return this.featureCollection;
            }
        },
        {
            key: "replacePosition",
            value: function replacePosition(featureIndex, positionIndexes, updatedPosition) {
                var geometry = this.featureCollection.features[featureIndex].geometry;
                var isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
                var updatedGeometry = $ab9257319456f908$var$_objectSpread({}, geometry, {
                    coordinates: $ab9257319456f908$var$immutablyReplacePosition(geometry.coordinates, positionIndexes, updatedPosition, isPolygonal)
                });
                return this.replaceGeometry(featureIndex, updatedGeometry);
            }
        },
        {
            key: "removePosition",
            value: function removePosition(featureIndex, positionIndexes) {
                var geometry = this.featureCollection.features[featureIndex].geometry;
                if (geometry.type === "Point") throw Error("Can't remove a position from a Point or there'd be nothing left");
                if (geometry.type === "MultiPoint" && // only 1 point left
                geometry.coordinates.length < 2) throw Error("Can't remove the last point of a MultiPoint or there'd be nothing left");
                if (geometry.type === "LineString" && // only 2 positions
                geometry.coordinates.length < 3) throw Error("Can't remove position. LineString must have at least two positions");
                if (geometry.type === "Polygon" && // outer ring is a triangle
                geometry.coordinates[0].length < 5 && Array.isArray(positionIndexes) && // trying to remove from outer ring
                positionIndexes[0] === 0) throw Error("Can't remove position. Polygon's outer ring must have at least four positions");
                if (geometry.type === "MultiLineString" && // only 1 LineString left
                geometry.coordinates.length === 1 && // only 2 positions
                geometry.coordinates[0].length < 3) throw Error("Can't remove position. MultiLineString must have at least two positions");
                if (geometry.type === "MultiPolygon" && // only 1 polygon left
                geometry.coordinates.length === 1 && // outer ring is a triangle
                geometry.coordinates[0][0].length < 5 && Array.isArray(positionIndexes) && // trying to remove from first polygon
                positionIndexes[0] === 0 && // trying to remove from outer ring
                positionIndexes[1] === 0) throw Error("Can't remove position. MultiPolygon's outer ring must have at least four positions");
                var isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
                var updatedGeometry = $ab9257319456f908$var$_objectSpread({}, geometry, {
                    coordinates: $ab9257319456f908$var$immutablyRemovePosition(geometry.coordinates, positionIndexes, isPolygonal)
                }); // Handle cases where incomplete geometries need pruned (e.g. holes that were triangles)
                $ab9257319456f908$var$pruneGeometryIfNecessary(updatedGeometry);
                return this.replaceGeometry(featureIndex, updatedGeometry);
            }
        },
        {
            key: "addPosition",
            value: function addPosition(featureIndex, positionIndexes, positionToAdd) {
                var geometry = this.featureCollection.features[featureIndex].geometry;
                if (geometry.type === "Point") throw new Error("Unable to add a position to a Point feature");
                var isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
                var updatedGeometry = $ab9257319456f908$var$_objectSpread({}, geometry, {
                    coordinates: $ab9257319456f908$var$immutablyAddPosition(geometry.coordinates, positionIndexes, positionToAdd, isPolygonal)
                });
                return this.replaceGeometry(featureIndex, updatedGeometry);
            }
        },
        {
            key: "replaceGeometry",
            value: function replaceGeometry(featureIndex, geometry) {
                var updatedFeature = $ab9257319456f908$var$_objectSpread({}, this.featureCollection.features[featureIndex], {
                    geometry: geometry
                });
                var updatedFeatureCollection = $ab9257319456f908$var$_objectSpread({}, this.featureCollection, {
                    features: [].concat($ab9257319456f908$var$_toConsumableArray(this.featureCollection.features.slice(0, featureIndex)), [
                        updatedFeature
                    ], $ab9257319456f908$var$_toConsumableArray(this.featureCollection.features.slice(featureIndex + 1)))
                });
                return new ImmutableFeatureCollection(updatedFeatureCollection);
            }
        },
        {
            key: "addFeature",
            value: function addFeature(feature) {
                return this.addFeatures([
                    feature
                ]);
            }
        },
        {
            key: "addFeatures",
            value: function addFeatures(features) {
                var updatedFeatureCollection = $ab9257319456f908$var$_objectSpread({}, this.featureCollection, {
                    features: [].concat($ab9257319456f908$var$_toConsumableArray(this.featureCollection.features), $ab9257319456f908$var$_toConsumableArray(features))
                });
                return new ImmutableFeatureCollection(updatedFeatureCollection);
            }
        },
        {
            key: "deleteFeature",
            value: function deleteFeature(featureIndex) {
                return this.deleteFeatures([
                    featureIndex
                ]);
            }
        },
        {
            key: "deleteFeatures",
            value: function deleteFeatures(featureIndexes) {
                var features = $ab9257319456f908$var$_toConsumableArray(this.featureCollection.features);
                featureIndexes.sort();
                for(var i = featureIndexes.length - 1; i >= 0; i--){
                    var featureIndex = featureIndexes[i];
                    if (featureIndex >= 0 && featureIndex < features.length) features.splice(featureIndex, 1);
                }
                var updatedFeatureCollection = $ab9257319456f908$var$_objectSpread({}, this.featureCollection, {
                    features: features
                });
                return new ImmutableFeatureCollection(updatedFeatureCollection);
            }
        }
    ]);
    return ImmutableFeatureCollection;
}();
module.exports.ImmutableFeatureCollection = $ab9257319456f908$var$ImmutableFeatureCollection;
function $ab9257319456f908$var$getUpdatedPosition(updatedPosition, previousPosition) {
    // This function checks if the updatedPosition is missing elevation
    // and copies it from previousPosition
    if (updatedPosition.length === 2 && previousPosition.length === 3) {
        var elevation = previousPosition[2];
        return [
            updatedPosition[0],
            updatedPosition[1],
            elevation
        ];
    }
    return updatedPosition;
}
function $ab9257319456f908$var$immutablyReplacePosition(coordinates, positionIndexes, updatedPosition, isPolygonal) {
    if (!positionIndexes) return coordinates;
    if (positionIndexes.length === 0) return $ab9257319456f908$var$getUpdatedPosition(updatedPosition, coordinates);
    if (positionIndexes.length === 1) {
        var updated = [].concat($ab9257319456f908$var$_toConsumableArray(coordinates.slice(0, positionIndexes[0])), [
            $ab9257319456f908$var$getUpdatedPosition(updatedPosition, coordinates[positionIndexes[0]])
        ], $ab9257319456f908$var$_toConsumableArray(coordinates.slice(positionIndexes[0] + 1)));
        if (isPolygonal && (positionIndexes[0] === 0 || positionIndexes[0] === coordinates.length - 1)) {
            // for polygons, the first point is repeated at the end of the array
            // so, update it on both ends of the array
            updated[0] = $ab9257319456f908$var$getUpdatedPosition(updatedPosition, coordinates[0]);
            updated[coordinates.length - 1] = $ab9257319456f908$var$getUpdatedPosition(updatedPosition, coordinates[0]);
        }
        return updated;
    } // recursively update inner array
    return [].concat($ab9257319456f908$var$_toConsumableArray(coordinates.slice(0, positionIndexes[0])), [
        $ab9257319456f908$var$immutablyReplacePosition(coordinates[positionIndexes[0]], positionIndexes.slice(1, positionIndexes.length), updatedPosition, isPolygonal)
    ], $ab9257319456f908$var$_toConsumableArray(coordinates.slice(positionIndexes[0] + 1)));
}
function $ab9257319456f908$var$immutablyRemovePosition(coordinates, positionIndexes, isPolygonal) {
    if (!positionIndexes) return coordinates;
    if (positionIndexes.length === 0) throw Error("Must specify the index of the position to remove");
    if (positionIndexes.length === 1) {
        var updated = [].concat($ab9257319456f908$var$_toConsumableArray(coordinates.slice(0, positionIndexes[0])), $ab9257319456f908$var$_toConsumableArray(coordinates.slice(positionIndexes[0] + 1)));
        if (isPolygonal && (positionIndexes[0] === 0 || positionIndexes[0] === coordinates.length - 1)) {
            // for polygons, the first point is repeated at the end of the array
            // so, if the first/last coordinate is to be removed, coordinates[1] will be the new first/last coordinate
            if (positionIndexes[0] === 0) // change the last to be the same as the first
            updated[updated.length - 1] = updated[0];
            else if (positionIndexes[0] === coordinates.length - 1) // change the first to be the same as the last
            updated[0] = updated[updated.length - 1];
        }
        return updated;
    } // recursively update inner array
    return [].concat($ab9257319456f908$var$_toConsumableArray(coordinates.slice(0, positionIndexes[0])), [
        $ab9257319456f908$var$immutablyRemovePosition(coordinates[positionIndexes[0]], positionIndexes.slice(1, positionIndexes.length), isPolygonal)
    ], $ab9257319456f908$var$_toConsumableArray(coordinates.slice(positionIndexes[0] + 1)));
}
function $ab9257319456f908$var$immutablyAddPosition(coordinates, positionIndexes, positionToAdd, isPolygonal) {
    if (!positionIndexes) return coordinates;
    if (positionIndexes.length === 0) throw Error("Must specify the index of the position to remove");
    if (positionIndexes.length === 1) {
        var updated = [].concat($ab9257319456f908$var$_toConsumableArray(coordinates.slice(0, positionIndexes[0])), [
            positionToAdd
        ], $ab9257319456f908$var$_toConsumableArray(coordinates.slice(positionIndexes[0])));
        return updated;
    } // recursively update inner array
    return [].concat($ab9257319456f908$var$_toConsumableArray(coordinates.slice(0, positionIndexes[0])), [
        $ab9257319456f908$var$immutablyAddPosition(coordinates[positionIndexes[0]], positionIndexes.slice(1, positionIndexes.length), positionToAdd, isPolygonal)
    ], $ab9257319456f908$var$_toConsumableArray(coordinates.slice(positionIndexes[0] + 1)));
}
function $ab9257319456f908$var$pruneGeometryIfNecessary(geometry) {
    switch(geometry.type){
        case "Polygon":
            $ab9257319456f908$var$prunePolygonIfNecessary(geometry);
            break;
        case "MultiLineString":
            $ab9257319456f908$var$pruneMultiLineStringIfNecessary(geometry);
            break;
        case "MultiPolygon":
            $ab9257319456f908$var$pruneMultiPolygonIfNecessary(geometry);
            break;
        default:
            break;
    }
}
function $ab9257319456f908$var$prunePolygonIfNecessary(geometry) {
    var polygon = geometry.coordinates; // If any hole is no longer a polygon, remove the hole entirely
    for(var holeIndex = 1; holeIndex < polygon.length; holeIndex++)if ($ab9257319456f908$var$removeHoleIfNecessary(polygon, holeIndex)) // It was removed, so keep the index the same
    holeIndex--;
}
function $ab9257319456f908$var$pruneMultiLineStringIfNecessary(geometry) {
    for(var lineStringIndex = 0; lineStringIndex < geometry.coordinates.length; lineStringIndex++){
        var lineString = geometry.coordinates[lineStringIndex];
        if (lineString.length === 1) {
            // Only a single position left on this LineString, so remove it (can't have Point in MultiLineString)
            geometry.coordinates.splice(lineStringIndex, 1); // Keep the index the same
            lineStringIndex--;
        }
    }
}
function $ab9257319456f908$var$pruneMultiPolygonIfNecessary(geometry) {
    for(var polygonIndex = 0; polygonIndex < geometry.coordinates.length; polygonIndex++){
        var polygon = geometry.coordinates[polygonIndex];
        var outerRing = polygon[0]; // If the outer ring is no longer a polygon, remove the whole polygon
        if (outerRing.length <= 3) {
            geometry.coordinates.splice(polygonIndex, 1); // It was removed, so keep the index the same
            polygonIndex--;
        }
        for(var holeIndex = 1; holeIndex < polygon.length; holeIndex++)if ($ab9257319456f908$var$removeHoleIfNecessary(polygon, holeIndex)) // It was removed, so keep the index the same
        holeIndex--;
    }
}
function $ab9257319456f908$var$removeHoleIfNecessary(polygon, holeIndex) {
    var hole = polygon[holeIndex];
    if (hole.length <= 3) {
        polygon.splice(holeIndex, 1);
        return true;
    }
    return false;
}

});


parcelRegister("gFC9Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModifyMode = void 0;

var $7GKQS = parcelRequire("7GKQS");

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");

var $eJgQU = parcelRequire("eJgQU");
function $c22e137e708ef0c9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c22e137e708ef0c9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c22e137e708ef0c9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c22e137e708ef0c9$var$_typeof(obj);
}
function $c22e137e708ef0c9$var$_toConsumableArray(arr) {
    return $c22e137e708ef0c9$var$_arrayWithoutHoles(arr) || $c22e137e708ef0c9$var$_iterableToArray(arr) || $c22e137e708ef0c9$var$_unsupportedIterableToArray(arr) || $c22e137e708ef0c9$var$_nonIterableSpread();
}
function $c22e137e708ef0c9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c22e137e708ef0c9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c22e137e708ef0c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c22e137e708ef0c9$var$_arrayLikeToArray(arr);
}
function $c22e137e708ef0c9$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $c22e137e708ef0c9$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c22e137e708ef0c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c22e137e708ef0c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c22e137e708ef0c9$var$_arrayLikeToArray(o, minLen);
}
function $c22e137e708ef0c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c22e137e708ef0c9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c22e137e708ef0c9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c22e137e708ef0c9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c22e137e708ef0c9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c22e137e708ef0c9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c22e137e708ef0c9$var$_createSuper(Derived) {
    return function() {
        var Super = $c22e137e708ef0c9$var$_getPrototypeOf(Derived), result;
        if ($c22e137e708ef0c9$var$_isNativeReflectConstruct()) {
            var NewTarget = $c22e137e708ef0c9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c22e137e708ef0c9$var$_possibleConstructorReturn(this, result);
    };
}
function $c22e137e708ef0c9$var$_possibleConstructorReturn(self, call) {
    if (call && ($c22e137e708ef0c9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c22e137e708ef0c9$var$_assertThisInitialized(self);
}
function $c22e137e708ef0c9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c22e137e708ef0c9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c22e137e708ef0c9$var$_getPrototypeOf(o) {
    $c22e137e708ef0c9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c22e137e708ef0c9$var$_getPrototypeOf(o);
}
function $c22e137e708ef0c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c22e137e708ef0c9$var$_setPrototypeOf(subClass, superClass);
}
function $c22e137e708ef0c9$var$_setPrototypeOf(o, p) {
    $c22e137e708ef0c9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c22e137e708ef0c9$var$_setPrototypeOf(o, p);
}
var $c22e137e708ef0c9$var$ModifyMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $c22e137e708ef0c9$var$_inherits(ModifyMode, _GeoJsonEditMode);
    var _super = $c22e137e708ef0c9$var$_createSuper(ModifyMode);
    function ModifyMode() {
        $c22e137e708ef0c9$var$_classCallCheck(this, ModifyMode);
        return _super.apply(this, arguments);
    }
    $c22e137e708ef0c9$var$_createClass(ModifyMode, [
        {
            key: "getGuides",
            value: function getGuides(props) {
                var _this = this;
                var handles = [];
                var data = props.data, lastPointerMoveEvent = props.lastPointerMoveEvent;
                var features = data.features;
                var picks = lastPointerMoveEvent && lastPointerMoveEvent.picks;
                var mapCoords = lastPointerMoveEvent && lastPointerMoveEvent.mapCoords;
                var _iterator = $c22e137e708ef0c9$var$_createForOfIteratorHelper(props.selectedIndexes), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _index = _step.value;
                        if (_index < features.length) {
                            var geometry = features[_index].geometry;
                            handles.push.apply(handles, $c22e137e708ef0c9$var$_toConsumableArray((0, $hs5Hv.getEditHandlesForGeometry)(geometry, _index)));
                        } else console.warn("selectedFeatureIndexes out of range ".concat(_index)); // eslint-disable-line no-console,no-undef
                    } // intermediate edit handle
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (picks && picks.length && mapCoords) {
                    var _props$modeConfig;
                    var existingEditHandle = (0, $hs5Hv.getPickedExistingEditHandle)(picks); // don't show intermediate point when too close to an existing edit handle
                    var featureAsPick = !existingEditHandle && picks.find(function(pick) {
                        return !pick.isGuide;
                    }); // is the feature in the pick selected
                    if (featureAsPick && !featureAsPick.object.geometry.type.includes("Point") && !(((_props$modeConfig = props.modeConfig) === null || _props$modeConfig === void 0 ? void 0 : _props$modeConfig.lockRectangles) && featureAsPick.object.properties.shape === "Rectangle") && props.selectedIndexes.includes(featureAsPick.index)) {
                        var intermediatePoint = null;
                        var positionIndexPrefix = [];
                        var referencePoint = (0, $7GKQS.point)(mapCoords); // process all lines of the (single) feature
                        (0, $hs5Hv.recursivelyTraverseNestedArrays)(featureAsPick.object.geometry.coordinates, [], function(lineString, prefix) {
                            var lineStringFeature = (0, $7GKQS.lineString)(lineString);
                            var candidateIntermediatePoint = _this.getNearestPoint(lineStringFeature, referencePoint, props.modeConfig && props.modeConfig.viewport);
                            if (!intermediatePoint || candidateIntermediatePoint.properties.dist < intermediatePoint.properties.dist) {
                                intermediatePoint = candidateIntermediatePoint;
                                positionIndexPrefix = prefix;
                            }
                        }); // tack on the lone intermediate point to the set of handles
                        if (intermediatePoint) {
                            var _intermediatePoint = intermediatePoint, position = _intermediatePoint.geometry.coordinates, index = _intermediatePoint.properties.index;
                            handles.push({
                                type: "Feature",
                                properties: {
                                    guideType: "editHandle",
                                    editHandleType: "intermediate",
                                    featureIndex: featureAsPick.index,
                                    positionIndexes: [].concat($c22e137e708ef0c9$var$_toConsumableArray(positionIndexPrefix), [
                                        index + 1
                                    ])
                                },
                                geometry: {
                                    type: "Point",
                                    coordinates: position
                                }
                            });
                        }
                    }
                }
                return {
                    type: "FeatureCollection",
                    features: handles
                };
            } // turf.js does not support elevation for nearestPointOnLine
        },
        {
            key: "getNearestPoint",
            value: function getNearestPoint(line, inPoint, viewport) {
                var coordinates = line.geometry.coordinates;
                if (coordinates.some(function(coord) {
                    return coord.length > 2;
                })) {
                    if (viewport) // This line has elevation, we need to use alternative algorithm
                    return (0, $hs5Hv.nearestPointOnProjectedLine)(line, inPoint, viewport);
                     // eslint-disable-next-line no-console,no-undef
                    console.log("Editing 3D point but modeConfig.viewport not provided. Falling back to 2D logic.");
                }
                return (0, $hs5Hv.nearestPointOnLine)(line, inPoint, viewport);
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var pickedExistingHandle = (0, $hs5Hv.getPickedExistingEditHandle)(event.picks);
                var pickedIntermediateHandle = (0, $hs5Hv.getPickedIntermediateEditHandle)(event.picks);
                if (pickedExistingHandle) {
                    var _pickedExistingHandle = pickedExistingHandle.properties, featureIndex = _pickedExistingHandle.featureIndex, positionIndexes = _pickedExistingHandle.positionIndexes;
                    var updatedData;
                    try {
                        updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).removePosition(featureIndex, positionIndexes).getObject();
                    } catch (ignored) {}
                    if (updatedData) props.onEdit({
                        updatedData: updatedData,
                        editType: "removePosition",
                        editContext: {
                            featureIndexes: [
                                featureIndex
                            ],
                            positionIndexes: positionIndexes,
                            position: pickedExistingHandle.geometry.coordinates
                        }
                    });
                } else if (pickedIntermediateHandle) {
                    var _props$modeConfig2;
                    var _pickedIntermediateHa = pickedIntermediateHandle.properties, _featureIndex = _pickedIntermediateHa.featureIndex, _positionIndexes = _pickedIntermediateHa.positionIndexes;
                    var feature = props.data.features[_featureIndex];
                    var canAddPosition = !(((_props$modeConfig2 = props.modeConfig) === null || _props$modeConfig2 === void 0 ? void 0 : _props$modeConfig2.lockRectangles) && (feature === null || feature === void 0 ? void 0 : feature.properties.shape) === "Rectangle");
                    if (canAddPosition) {
                        var _updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).addPosition(_featureIndex, _positionIndexes, pickedIntermediateHandle.geometry.coordinates).getObject();
                        if (_updatedData) props.onEdit({
                            updatedData: _updatedData,
                            editType: "addPosition",
                            editContext: {
                                featureIndexes: [
                                    _featureIndex
                                ],
                                positionIndexes: _positionIndexes,
                                position: pickedIntermediateHandle.geometry.coordinates
                            }
                        });
                    }
                }
            }
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                var editHandle = (0, $hs5Hv.getPickedEditHandle)(event.pointerDownPicks);
                if (editHandle) {
                    // Cancel map panning if pointer went down on an edit handle
                    event.cancelPan();
                    this._dragEditHandle("movePosition", props, editHandle, event);
                }
            }
        },
        {
            key: "_dragEditHandle",
            value: function _dragEditHandle(editType, props, editHandle, event) {
                var _props$modeConfig3;
                var editHandleProperties = editHandle.properties;
                var editedFeature = props.data.features[editHandleProperties.featureIndex];
                var updatedData;
                if (((_props$modeConfig3 = props.modeConfig) === null || _props$modeConfig3 === void 0 ? void 0 : _props$modeConfig3.lockRectangles) && editedFeature.properties.shape === "Rectangle") {
                    var coordinates = (0, $hs5Hv.updateRectanglePosition)(editedFeature, editHandleProperties.positionIndexes[1], event.mapCoords);
                    updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).replaceGeometry(editHandleProperties.featureIndex, {
                        coordinates: coordinates,
                        type: "Polygon"
                    }).getObject();
                } else updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).replacePosition(editHandleProperties.featureIndex, editHandleProperties.positionIndexes, event.mapCoords).getObject();
                props.onEdit({
                    updatedData: updatedData,
                    editType: editType,
                    editContext: {
                        featureIndexes: [
                            editHandleProperties.featureIndex
                        ],
                        positionIndexes: editHandleProperties.positionIndexes,
                        position: event.mapCoords
                    }
                });
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                var cursor = this.getCursor(event);
                props.onUpdateCursor(cursor);
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                var selectedFeatureIndexes = props.selectedIndexes;
                var editHandle = (0, $hs5Hv.getPickedIntermediateEditHandle)(event.picks);
                if (selectedFeatureIndexes.length && editHandle) {
                    var editHandleProperties = editHandle.properties;
                    var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).addPosition(editHandleProperties.featureIndex, editHandleProperties.positionIndexes, event.mapCoords).getObject();
                    props.onEdit({
                        updatedData: updatedData,
                        editType: "addPosition",
                        editContext: {
                            featureIndexes: [
                                editHandleProperties.featureIndex
                            ],
                            positionIndexes: editHandleProperties.positionIndexes,
                            position: event.mapCoords
                        }
                    });
                }
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                var selectedFeatureIndexes = props.selectedIndexes;
                var editHandle = (0, $hs5Hv.getPickedEditHandle)(event.picks);
                if (selectedFeatureIndexes.length && editHandle) this._dragEditHandle("finishMovePosition", props, editHandle, event);
            }
        },
        {
            key: "getCursor",
            value: function getCursor(event) {
                var picks = event && event.picks || [];
                var handlesPicked = (0, $hs5Hv.getPickedEditHandles)(picks);
                if (handlesPicked.length) return "cell";
                return null;
            }
        }
    ]);
    return ModifyMode;
}($1tPZO.GeoJsonEditMode);
module.exports.ModifyMode = $c22e137e708ef0c9$var$ModifyMode;

});

parcelRegister("dm5qM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResizeCircleMode = void 0;

var $9b918ae6c41f6e4f$var$_nearestPointOnLine = $9b918ae6c41f6e4f$var$_interopRequireDefault((parcelRequire("ecyJ3")));

var $7GKQS = parcelRequire("7GKQS");

var $9b918ae6c41f6e4f$var$_circle = $9b918ae6c41f6e4f$var$_interopRequireDefault((parcelRequire("lzQHn")));

var $9b918ae6c41f6e4f$var$_distance = $9b918ae6c41f6e4f$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $9b918ae6c41f6e4f$var$_center = $9b918ae6c41f6e4f$var$_interopRequireDefault((parcelRequire("4B93b")));

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");

var $eJgQU = parcelRequire("eJgQU");
function $9b918ae6c41f6e4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9b918ae6c41f6e4f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9b918ae6c41f6e4f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9b918ae6c41f6e4f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9b918ae6c41f6e4f$var$_typeof(obj);
}
function $9b918ae6c41f6e4f$var$_toConsumableArray(arr) {
    return $9b918ae6c41f6e4f$var$_arrayWithoutHoles(arr) || $9b918ae6c41f6e4f$var$_iterableToArray(arr) || $9b918ae6c41f6e4f$var$_unsupportedIterableToArray(arr) || $9b918ae6c41f6e4f$var$_nonIterableSpread();
}
function $9b918ae6c41f6e4f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b918ae6c41f6e4f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9b918ae6c41f6e4f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9b918ae6c41f6e4f$var$_arrayLikeToArray(o, minLen);
}
function $9b918ae6c41f6e4f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $9b918ae6c41f6e4f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9b918ae6c41f6e4f$var$_arrayLikeToArray(arr);
}
function $9b918ae6c41f6e4f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9b918ae6c41f6e4f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9b918ae6c41f6e4f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9b918ae6c41f6e4f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9b918ae6c41f6e4f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9b918ae6c41f6e4f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9b918ae6c41f6e4f$var$_createSuper(Derived) {
    return function() {
        var Super = $9b918ae6c41f6e4f$var$_getPrototypeOf(Derived), result;
        if ($9b918ae6c41f6e4f$var$_isNativeReflectConstruct()) {
            var NewTarget = $9b918ae6c41f6e4f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9b918ae6c41f6e4f$var$_possibleConstructorReturn(this, result);
    };
}
function $9b918ae6c41f6e4f$var$_possibleConstructorReturn(self, call) {
    if (call && ($9b918ae6c41f6e4f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9b918ae6c41f6e4f$var$_assertThisInitialized(self);
}
function $9b918ae6c41f6e4f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9b918ae6c41f6e4f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9b918ae6c41f6e4f$var$_getPrototypeOf(o) {
    $9b918ae6c41f6e4f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9b918ae6c41f6e4f$var$_getPrototypeOf(o);
}
function $9b918ae6c41f6e4f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9b918ae6c41f6e4f$var$_setPrototypeOf(subClass, superClass);
}
function $9b918ae6c41f6e4f$var$_setPrototypeOf(o, p) {
    $9b918ae6c41f6e4f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9b918ae6c41f6e4f$var$_setPrototypeOf(o, p);
}
function $9b918ae6c41f6e4f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9b918ae6c41f6e4f$var$ResizeCircleMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $9b918ae6c41f6e4f$var$_inherits(ResizeCircleMode, _GeoJsonEditMode);
    var _super = $9b918ae6c41f6e4f$var$_createSuper(ResizeCircleMode);
    function ResizeCircleMode() {
        var _this;
        $9b918ae6c41f6e4f$var$_classCallCheck(this, ResizeCircleMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $9b918ae6c41f6e4f$var$_defineProperty($9b918ae6c41f6e4f$var$_assertThisInitialized(_this), "_selectedEditHandle", void 0);
        $9b918ae6c41f6e4f$var$_defineProperty($9b918ae6c41f6e4f$var$_assertThisInitialized(_this), "_isResizing", false);
        return _this;
    }
    $9b918ae6c41f6e4f$var$_createClass(ResizeCircleMode, [
        {
            key: "getGuides",
            value: function getGuides(props) {
                var _this2 = this;
                var handles = [];
                var selectedFeatureIndexes = props.selectedIndexes;
                var lastPointerMoveEvent = props.lastPointerMoveEvent;
                var picks = lastPointerMoveEvent && lastPointerMoveEvent.picks;
                var mapCoords = lastPointerMoveEvent && lastPointerMoveEvent.mapCoords; // intermediate edit handle
                if (picks && picks.length && mapCoords && selectedFeatureIndexes.length === 1 && !this._isResizing) {
                    var featureAsPick = picks.find(function(pick) {
                        return !pick.isGuide;
                    }); // is the feature in the pick selected
                    if (featureAsPick && featureAsPick.object.properties.shape && featureAsPick.object.properties.shape.includes("Circle") && props.selectedIndexes.includes(featureAsPick.index)) {
                        var intermediatePoint = null;
                        var positionIndexPrefix = [];
                        var referencePoint = (0, $7GKQS.point)(mapCoords); // process all lines of the (single) feature
                        (0, $hs5Hv.recursivelyTraverseNestedArrays)(featureAsPick.object.geometry.coordinates, [], function(lineString, prefix) {
                            var lineStringFeature = (0, $7GKQS.lineString)(lineString);
                            var candidateIntermediatePoint = _this2.getNearestPoint(lineStringFeature, referencePoint, props.modeConfig && props.modeConfig.viewport);
                            if (!intermediatePoint || candidateIntermediatePoint.properties.dist < intermediatePoint.properties.dist) {
                                intermediatePoint = candidateIntermediatePoint;
                                positionIndexPrefix = prefix;
                            }
                        }); // tack on the lone intermediate point to the set of handles
                        if (intermediatePoint) {
                            var _intermediatePoint = intermediatePoint, position = _intermediatePoint.geometry.coordinates, index = _intermediatePoint.properties.index;
                            handles.push({
                                type: "Feature",
                                properties: {
                                    guideType: "editHandle",
                                    editHandleType: "intermediate",
                                    featureIndex: featureAsPick.index,
                                    positionIndexes: [].concat($9b918ae6c41f6e4f$var$_toConsumableArray(positionIndexPrefix), [
                                        index + 1
                                    ])
                                },
                                geometry: {
                                    type: "Point",
                                    coordinates: position
                                }
                            });
                        }
                    }
                }
                return {
                    type: "FeatureCollection",
                    features: handles
                };
            } // turf.js does not support elevation for nearestPointOnLine
        },
        {
            key: "getNearestPoint",
            value: function getNearestPoint(line, inPoint, viewport) {
                var coordinates = line.geometry.coordinates;
                if (coordinates.some(function(coord) {
                    return coord.length > 2;
                })) {
                    if (viewport) // This line has elevation, we need to use alternative algorithm
                    return (0, $hs5Hv.nearestPointOnProjectedLine)(line, inPoint, viewport);
                     // eslint-disable-next-line no-console,no-undef
                    console.log("Editing 3D point but modeConfig.viewport not provided. Falling back to 2D logic.");
                }
                return (0, $9b918ae6c41f6e4f$var$_nearestPointOnLine["default"])(line, inPoint);
            }
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                var editHandle = (0, $hs5Hv.getPickedEditHandle)(event.pointerDownPicks);
                if (editHandle) {
                    // Cancel map panning if pointer went down on an edit handle
                    event.cancelPan();
                    var editHandleProperties = editHandle.properties;
                    var feature = this.getSelectedFeature(props);
                    var center = (0, $9b918ae6c41f6e4f$var$_center["default"])(feature).geometry.coordinates;
                    var numberOfSteps = Object.entries(feature.geometry.coordinates[0]).length - 1;
                    var radius = Math.max((0, $9b918ae6c41f6e4f$var$_distance["default"])(center, event.mapCoords), 0.001);
                    var _ref = {}, _ref$steps = _ref.steps, steps = _ref$steps === void 0 ? numberOfSteps : _ref$steps;
                    var options = {
                        steps: steps
                    };
                    var updatedFeature = (0, $9b918ae6c41f6e4f$var$_circle["default"])(center, radius, options);
                    var geometry = updatedFeature.geometry;
                    var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).replaceGeometry(editHandleProperties.featureIndex, geometry).getObject();
                    props.onEdit({
                        updatedData: updatedData,
                        editType: "unionGeometry",
                        editContext: {
                            featureIndexes: [
                                editHandleProperties.featureIndex
                            ]
                        }
                    });
                }
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                if (!this._isResizing) {
                    var selectedEditHandle = (0, $hs5Hv.getPickedEditHandle)(event.picks);
                    this._selectedEditHandle = selectedEditHandle && selectedEditHandle.properties.editHandleType === "intermediate" ? selectedEditHandle : null;
                }
                var cursor = this.getCursor(event);
                props.onUpdateCursor(cursor);
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                if (this._selectedEditHandle) this._isResizing = true;
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                if (this._isResizing) {
                    this._selectedEditHandle = null;
                    this._isResizing = false;
                }
            }
        },
        {
            key: "getCursor",
            value: function getCursor(event) {
                var picks = event && event.picks || [];
                var handlesPicked = (0, $hs5Hv.getPickedEditHandles)(picks);
                if (handlesPicked.length) return "cell";
                return null;
            }
        }
    ]);
    return ResizeCircleMode;
}($1tPZO.GeoJsonEditMode);
module.exports.ResizeCircleMode = $9b918ae6c41f6e4f$var$ResizeCircleMode;

});
parcelRegister("ecyJ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aDE4l = parcelRequire("aDE4l");

var $b5wF2 = parcelRequire("b5wF2");

var $1UAWS = parcelRequire("1UAWS");

var $iXvoQ = parcelRequire("iXvoQ");

var $7aiSl = parcelRequire("7aiSl");

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");
/**
 * Takes a {@link Point} and a {@link LineString} and calculates the closest Point on the (Multi)LineString.
 *
 * @name nearestPointOnLine
 * @param {Geometry|Feature<LineString|MultiLineString>} lines lines to snap to
 * @param {Geometry|Feature<Point>|number[]} pt point to snap from
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {Feature<Point>} closest point on the `line` to `point`. The properties object will contain three values: `index`: closest point was found on nth line part, `dist`: distance between pt and the closest point, `location`: distance along the line between start and the closest point.
 * @example
 * var line = turf.lineString([
 *     [-77.031669, 38.878605],
 *     [-77.029609, 38.881946],
 *     [-77.020339, 38.884084],
 *     [-77.025661, 38.885821],
 *     [-77.021884, 38.889563],
 *     [-77.019824, 38.892368]
 * ]);
 * var pt = turf.point([-77.037076, 38.884017]);
 *
 * var snapped = turf.nearestPointOnLine(line, pt, {units: 'miles'});
 *
 * //addToMap
 * var addToMap = [line, pt, snapped];
 * snapped.properties['marker-color'] = '#00f';
 */ function $a56d1f7e3beb6b48$var$nearestPointOnLine(lines, pt, options) {
    if (options === void 0) options = {};
    var closestPt = $7GKQS.point([
        Infinity,
        Infinity
    ], {
        dist: Infinity
    });
    var length = 0.0;
    $7aiSl.flattenEach(lines, function(line) {
        var coords = $8abqV.getCoords(line);
        for(var i = 0; i < coords.length - 1; i++){
            //start
            var start = $7GKQS.point(coords[i]);
            start.properties.dist = $b5wF2.default(pt, start, options);
            //stop
            var stop_1 = $7GKQS.point(coords[i + 1]);
            stop_1.properties.dist = $b5wF2.default(pt, stop_1, options);
            // sectionLength
            var sectionLength = $b5wF2.default(start, stop_1, options);
            //perpendicular
            var heightDistance = Math.max(start.properties.dist, stop_1.properties.dist);
            var direction = $aDE4l.default(start, stop_1);
            var perpendicularPt1 = $1UAWS.default(pt, heightDistance, direction + 90, options);
            var perpendicularPt2 = $1UAWS.default(pt, heightDistance, direction - 90, options);
            var intersect = $iXvoQ.default($7GKQS.lineString([
                perpendicularPt1.geometry.coordinates,
                perpendicularPt2.geometry.coordinates
            ]), $7GKQS.lineString([
                start.geometry.coordinates,
                stop_1.geometry.coordinates
            ]));
            var intersectPt = null;
            if (intersect.features.length > 0) {
                intersectPt = intersect.features[0];
                intersectPt.properties.dist = $b5wF2.default(pt, intersectPt, options);
                intersectPt.properties.location = length + $b5wF2.default(start, intersectPt, options);
            }
            if (start.properties.dist < closestPt.properties.dist) {
                closestPt = start;
                closestPt.properties.index = i;
                closestPt.properties.location = length;
            }
            if (stop_1.properties.dist < closestPt.properties.dist) {
                closestPt = stop_1;
                closestPt.properties.index = i + 1;
                closestPt.properties.location = length + sectionLength;
            }
            if (intersectPt && intersectPt.properties.dist < closestPt.properties.dist) {
                closestPt = intersectPt;
                closestPt.properties.index = i;
            }
            // update length
            length += sectionLength;
        }
    });
    return closestPt;
}
module.exports.default = $a56d1f7e3beb6b48$var$nearestPointOnLine;

});
parcelRegister("iXvoQ", function(module, exports) {
"use strict";
var $dcd617ffcca28111$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");

var $dcd617ffcca28111$var$line_segment_1 = $dcd617ffcca28111$var$__importDefault((parcelRequire("9dq48")));

var $7aiSl = parcelRequire("7aiSl");

var $dcd617ffcca28111$var$geojson_rbush_1 = $dcd617ffcca28111$var$__importDefault((parcelRequire("gvVG2")));
/**
 * Takes any LineString or Polygon GeoJSON and returns the intersecting point(s).
 *
 * @name lineIntersect
 * @param {GeoJSON} line1 any LineString or Polygon
 * @param {GeoJSON} line2 any LineString or Polygon
 * @returns {FeatureCollection<Point>} point(s) that intersect both
 * @example
 * var line1 = turf.lineString([[126, -11], [129, -21]]);
 * var line2 = turf.lineString([[123, -18], [131, -14]]);
 * var intersects = turf.lineIntersect(line1, line2);
 *
 * //addToMap
 * var addToMap = [line1, line2, intersects]
 */ function $dcd617ffcca28111$var$lineIntersect(line1, line2) {
    var unique = {};
    var results = [];
    // First, normalize geometries to features
    // Then, handle simple 2-vertex segments
    if (line1.type === "LineString") line1 = $7GKQS.feature(line1);
    if (line2.type === "LineString") line2 = $7GKQS.feature(line2);
    if (line1.type === "Feature" && line2.type === "Feature" && line1.geometry !== null && line2.geometry !== null && line1.geometry.type === "LineString" && line2.geometry.type === "LineString" && line1.geometry.coordinates.length === 2 && line2.geometry.coordinates.length === 2) {
        var intersect = $dcd617ffcca28111$var$intersects(line1, line2);
        if (intersect) results.push(intersect);
        return $7GKQS.featureCollection(results);
    }
    // Handles complex GeoJSON Geometries
    var tree = $dcd617ffcca28111$var$geojson_rbush_1.default();
    tree.load($dcd617ffcca28111$var$line_segment_1.default(line2));
    $7aiSl.featureEach($dcd617ffcca28111$var$line_segment_1.default(line1), function(segment) {
        $7aiSl.featureEach(tree.search(segment), function(match) {
            var intersect = $dcd617ffcca28111$var$intersects(segment, match);
            if (intersect) {
                // prevent duplicate points https://github.com/Turfjs/turf/issues/688
                var key = $8abqV.getCoords(intersect).join(",");
                if (!unique[key]) {
                    unique[key] = true;
                    results.push(intersect);
                }
            }
        });
    });
    return $7GKQS.featureCollection(results);
}
/**
 * Find a point that intersects LineStrings with two coordinates each
 *
 * @private
 * @param {Feature<LineString>} line1 GeoJSON LineString (Must only contain 2 coordinates)
 * @param {Feature<LineString>} line2 GeoJSON LineString (Must only contain 2 coordinates)
 * @returns {Feature<Point>} intersecting GeoJSON Point
 */ function $dcd617ffcca28111$var$intersects(line1, line2) {
    var coords1 = $8abqV.getCoords(line1);
    var coords2 = $8abqV.getCoords(line2);
    if (coords1.length !== 2) throw new Error("<intersects> line1 must only contain 2 coordinates");
    if (coords2.length !== 2) throw new Error("<intersects> line2 must only contain 2 coordinates");
    var x1 = coords1[0][0];
    var y1 = coords1[0][1];
    var x2 = coords1[1][0];
    var y2 = coords1[1][1];
    var x3 = coords2[0][0];
    var y3 = coords2[0][1];
    var x4 = coords2[1][0];
    var y4 = coords2[1][1];
    var denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    var numeA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
    var numeB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
    if (denom === 0) {
        if (numeA === 0 && numeB === 0) return null;
        return null;
    }
    var uA = numeA / denom;
    var uB = numeB / denom;
    if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
        var x = x1 + uA * (x2 - x1);
        var y = y1 + uA * (y2 - y1);
        return $7GKQS.point([
            x,
            y
        ]);
    }
    return null;
}
module.exports.default = $dcd617ffcca28111$var$lineIntersect;

});
parcelRegister("9dq48", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");

var $7aiSl = parcelRequire("7aiSl");
/**
 * Creates a {@link FeatureCollection} of 2-vertex {@link LineString} segments from a
 * {@link LineString|(Multi)LineString} or {@link Polygon|(Multi)Polygon}.
 *
 * @name lineSegment
 * @param {GeoJSON} geojson GeoJSON Polygon or LineString
 * @returns {FeatureCollection<LineString>} 2-vertex line segments
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 * var segments = turf.lineSegment(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, segments]
 */ function $6b598c09e02e4426$var$lineSegment(geojson) {
    if (!geojson) throw new Error("geojson is required");
    var results = [];
    $7aiSl.flattenEach(geojson, function(feature) {
        $6b598c09e02e4426$var$lineSegmentFeature(feature, results);
    });
    return $7GKQS.featureCollection(results);
}
/**
 * Line Segment
 *
 * @private
 * @param {Feature<LineString|Polygon>} geojson Line or polygon feature
 * @param {Array} results push to results
 * @returns {void}
 */ function $6b598c09e02e4426$var$lineSegmentFeature(geojson, results) {
    var coords = [];
    var geometry = geojson.geometry;
    if (geometry !== null) {
        switch(geometry.type){
            case "Polygon":
                coords = $8abqV.getCoords(geometry);
                break;
            case "LineString":
                coords = [
                    $8abqV.getCoords(geometry)
                ];
        }
        coords.forEach(function(coord) {
            var segments = $6b598c09e02e4426$var$createSegments(coord, geojson.properties);
            segments.forEach(function(segment) {
                segment.id = results.length;
                results.push(segment);
            });
        });
    }
}
/**
 * Create Segments from LineString coordinates
 *
 * @private
 * @param {Array<Array<number>>} coords LineString coordinates
 * @param {*} properties GeoJSON properties
 * @returns {Array<Feature<LineString>>} line segments
 */ function $6b598c09e02e4426$var$createSegments(coords, properties) {
    var segments = [];
    coords.reduce(function(previousCoords, currentCoords) {
        var segment = $7GKQS.lineString([
            previousCoords,
            currentCoords
        ], properties);
        segment.bbox = $6b598c09e02e4426$var$bbox(previousCoords, currentCoords);
        segments.push(segment);
        return currentCoords;
    });
    return segments;
}
/**
 * Create BBox between two coordinates (faster than @turf/bbox)
 *
 * @private
 * @param {Array<number>} coords1 Point coordinate
 * @param {Array<number>} coords2 Point coordinate
 * @returns {BBox} [west, south, east, north]
 */ function $6b598c09e02e4426$var$bbox(coords1, coords2) {
    var x1 = coords1[0];
    var y1 = coords1[1];
    var x2 = coords2[0];
    var y2 = coords2[1];
    var west = x1 < x2 ? x1 : x2;
    var south = y1 < y2 ? y1 : y2;
    var east = x1 > x2 ? x1 : x2;
    var north = y1 > y2 ? y1 : y2;
    return [
        west,
        south,
        east,
        north
    ];
}
module.exports.default = $6b598c09e02e4426$var$lineSegment;

});

parcelRegister("gvVG2", function(module, exports) {

var $euGzP = parcelRequire("euGzP");

var $7GKQS = parcelRequire("7GKQS");

var $7aiSl = parcelRequire("7aiSl");

var $lX3Ya = parcelRequire("lX3Ya");
var $c05c480d27922c9a$require$turfBBox = $lX3Ya.default;
var $c05c480d27922c9a$var$featureEach = $7aiSl.featureEach;
var $c05c480d27922c9a$var$coordEach = $7aiSl.coordEach;
var $c05c480d27922c9a$var$polygon = $7GKQS.polygon;
var $c05c480d27922c9a$var$featureCollection = $7GKQS.featureCollection;
/**
 * GeoJSON implementation of [RBush](https://github.com/mourner/rbush#rbush) spatial index.
 *
 * @name rbush
 * @param {number} [maxEntries=9] defines the maximum number of entries in a tree node. 9 (used by default) is a
 * reasonable choice for most applications. Higher value means faster insertion and slower search, and vice versa.
 * @returns {RBush} GeoJSON RBush
 * @example
 * var geojsonRbush = require('geojson-rbush').default;
 * var tree = geojsonRbush();
 */ function $c05c480d27922c9a$var$geojsonRbush(maxEntries) {
    var tree = $euGzP(maxEntries);
    /**
     * [insert](https://github.com/mourner/rbush#data-format)
     *
     * @param {Feature} feature insert single GeoJSON Feature
     * @returns {RBush} GeoJSON RBush
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     * tree.insert(poly)
     */ tree.insert = function(feature) {
        if (feature.type !== "Feature") throw new Error("invalid feature");
        feature.bbox = feature.bbox ? feature.bbox : $c05c480d27922c9a$require$turfBBox(feature);
        return $euGzP.prototype.insert.call(this, feature);
    };
    /**
     * [load](https://github.com/mourner/rbush#bulk-inserting-data)
     *
     * @param {FeatureCollection|Array<Feature>} features load entire GeoJSON FeatureCollection
     * @returns {RBush} GeoJSON RBush
     * @example
     * var polys = turf.polygons([
     *     [[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]],
     *     [[[-93, 32], [-83, 32], [-83, 39], [-93, 39], [-93, 32]]]
     * ]);
     * tree.load(polys);
     */ tree.load = function(features) {
        var load = [];
        // Load an Array of Features
        if (Array.isArray(features)) features.forEach(function(feature) {
            if (feature.type !== "Feature") throw new Error("invalid features");
            feature.bbox = feature.bbox ? feature.bbox : $c05c480d27922c9a$require$turfBBox(feature);
            load.push(feature);
        });
        else // Load a FeatureCollection
        $c05c480d27922c9a$var$featureEach(features, function(feature) {
            if (feature.type !== "Feature") throw new Error("invalid features");
            feature.bbox = feature.bbox ? feature.bbox : $c05c480d27922c9a$require$turfBBox(feature);
            load.push(feature);
        });
        return $euGzP.prototype.load.call(this, load);
    };
    /**
     * [remove](https://github.com/mourner/rbush#removing-data)
     *
     * @param {Feature} feature remove single GeoJSON Feature
     * @param {Function} equals Pass a custom equals function to compare by value for removal.
     * @returns {RBush} GeoJSON RBush
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.remove(poly);
     */ tree.remove = function(feature, equals) {
        if (feature.type !== "Feature") throw new Error("invalid feature");
        feature.bbox = feature.bbox ? feature.bbox : $c05c480d27922c9a$require$turfBBox(feature);
        return $euGzP.prototype.remove.call(this, feature, equals);
    };
    /**
     * [clear](https://github.com/mourner/rbush#removing-data)
     *
     * @returns {RBush} GeoJSON Rbush
     * @example
     * tree.clear()
     */ tree.clear = function() {
        return $euGzP.prototype.clear.call(this);
    };
    /**
     * [search](https://github.com/mourner/rbush#search)
     *
     * @param {BBox|FeatureCollection|Feature} geojson search with GeoJSON
     * @returns {FeatureCollection} all features that intersects with the given GeoJSON.
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.search(poly);
     */ tree.search = function(geojson) {
        var features = $euGzP.prototype.search.call(this, this.toBBox(geojson));
        return $c05c480d27922c9a$var$featureCollection(features);
    };
    /**
     * [collides](https://github.com/mourner/rbush#collisions)
     *
     * @param {BBox|FeatureCollection|Feature} geojson collides with GeoJSON
     * @returns {boolean} true if there are any items intersecting the given GeoJSON, otherwise false.
     * @example
     * var poly = turf.polygon([[[-78, 41], [-67, 41], [-67, 48], [-78, 48], [-78, 41]]]);
     *
     * tree.collides(poly);
     */ tree.collides = function(geojson) {
        return $euGzP.prototype.collides.call(this, this.toBBox(geojson));
    };
    /**
     * [all](https://github.com/mourner/rbush#search)
     *
     * @returns {FeatureCollection} all the features in RBush
     * @example
     * tree.all()
     */ tree.all = function() {
        var features = $euGzP.prototype.all.call(this);
        return $c05c480d27922c9a$var$featureCollection(features);
    };
    /**
     * [toJSON](https://github.com/mourner/rbush#export-and-import)
     *
     * @returns {any} export data as JSON object
     * @example
     * var exported = tree.toJSON()
     */ tree.toJSON = function() {
        return $euGzP.prototype.toJSON.call(this);
    };
    /**
     * [fromJSON](https://github.com/mourner/rbush#export-and-import)
     *
     * @param {any} json import previously exported data
     * @returns {RBush} GeoJSON RBush
     * @example
     * var exported = {
     *   "children": [
     *     {
     *       "type": "Feature",
     *       "geometry": {
     *         "type": "Point",
     *         "coordinates": [110, 50]
     *       },
     *       "properties": {},
     *       "bbox": [110, 50, 110, 50]
     *     }
     *   ],
     *   "height": 1,
     *   "leaf": true,
     *   "minX": 110,
     *   "minY": 50,
     *   "maxX": 110,
     *   "maxY": 50
     * }
     * tree.fromJSON(exported)
     */ tree.fromJSON = function(json) {
        return $euGzP.prototype.fromJSON.call(this, json);
    };
    /**
     * Converts GeoJSON to {minX, minY, maxX, maxY} schema
     *
     * @private
     * @param {BBox|FeatureCollection|Feature} geojson feature(s) to retrieve BBox from
     * @returns {Object} converted to {minX, minY, maxX, maxY}
     */ tree.toBBox = function(geojson) {
        var bbox;
        if (geojson.bbox) bbox = geojson.bbox;
        else if (Array.isArray(geojson) && geojson.length === 4) bbox = geojson;
        else if (Array.isArray(geojson) && geojson.length === 6) bbox = [
            geojson[0],
            geojson[1],
            geojson[3],
            geojson[4]
        ];
        else if (geojson.type === "Feature") bbox = $c05c480d27922c9a$require$turfBBox(geojson);
        else if (geojson.type === "FeatureCollection") bbox = $c05c480d27922c9a$require$turfBBox(geojson);
        else throw new Error("invalid geojson");
        return {
            minX: bbox[0],
            minY: bbox[1],
            maxX: bbox[2],
            maxY: bbox[3]
        };
    };
    return tree;
}
module.exports = $c05c480d27922c9a$var$geojsonRbush;
module.exports.default = $c05c480d27922c9a$var$geojsonRbush;

});
parcelRegister("euGzP", function(module, exports) {
"use strict";
module.exports = $a8d4e4ef6b2c428a$var$rbush;
module.exports.default = $a8d4e4ef6b2c428a$var$rbush;

var $g1Wnf = parcelRequire("g1Wnf");
function $a8d4e4ef6b2c428a$var$rbush(maxEntries, format) {
    if (!(this instanceof $a8d4e4ef6b2c428a$var$rbush)) return new $a8d4e4ef6b2c428a$var$rbush(maxEntries, format);
    // max entries in a node is 9 by default; min node fill is 40% for best performance
    this._maxEntries = Math.max(4, maxEntries || 9);
    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
    if (format) this._initFormat(format);
    this.clear();
}
$a8d4e4ef6b2c428a$var$rbush.prototype = {
    all: function() {
        return this._all(this.data, []);
    },
    search: function(bbox) {
        var node = this.data, result = [], toBBox = this.toBBox;
        if (!$a8d4e4ef6b2c428a$var$intersects(bbox, node)) return result;
        var nodesToSearch = [], i, len, child, childBBox;
        while(node){
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;
                if ($a8d4e4ef6b2c428a$var$intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if ($a8d4e4ef6b2c428a$var$contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return result;
    },
    collides: function(bbox) {
        var node = this.data, toBBox = this.toBBox;
        if (!$a8d4e4ef6b2c428a$var$intersects(bbox, node)) return false;
        var nodesToSearch = [], i, len, child, childBBox;
        while(node){
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;
                if ($a8d4e4ef6b2c428a$var$intersects(bbox, childBBox)) {
                    if (node.leaf || $a8d4e4ef6b2c428a$var$contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return false;
    },
    load: function(data) {
        if (!(data && data.length)) return this;
        if (data.length < this._minEntries) {
            for(var i = 0, len = data.length; i < len; i++)this.insert(data[i]);
            return this;
        }
        // recursively build the tree with the given data from scratch using OMT algorithm
        var node = this._build(data.slice(), 0, data.length - 1, 0);
        if (!this.data.children.length) // save as is if tree is empty
        this.data = node;
        else if (this.data.height === node.height) // split root if trees have the same height
        this._splitRoot(this.data, node);
        else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                var tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }
            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }
        return this;
    },
    insert: function(item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    },
    clear: function() {
        this.data = $a8d4e4ef6b2c428a$var$createNode([]);
        return this;
    },
    remove: function(item, equalsFn) {
        if (!item) return this;
        var node = this.data, bbox = this.toBBox(item), path = [], indexes = [], i, parent, index, goingUp;
        // depth-first iterative tree traversal
        while(node || path.length){
            if (!node) {
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }
            if (node.leaf) {
                index = $a8d4e4ef6b2c428a$var$findItem(item, node.children, equalsFn);
                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }
            if (!goingUp && !node.leaf && $a8d4e4ef6b2c428a$var$contains(node, bbox)) {
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];
            } else if (parent) {
                i++;
                node = parent.children[i];
                goingUp = false;
            } else node = null; // nothing found
        }
        return this;
    },
    toBBox: function(item) {
        return item;
    },
    compareMinX: $a8d4e4ef6b2c428a$var$compareNodeMinX,
    compareMinY: $a8d4e4ef6b2c428a$var$compareNodeMinY,
    toJSON: function() {
        return this.data;
    },
    fromJSON: function(data) {
        this.data = data;
        return this;
    },
    _all: function(node, result) {
        var nodesToSearch = [];
        while(node){
            if (node.leaf) result.push.apply(result, node.children);
            else nodesToSearch.push.apply(nodesToSearch, node.children);
            node = nodesToSearch.pop();
        }
        return result;
    },
    _build: function(items, left, right, height) {
        var N = right - left + 1, M = this._maxEntries, node;
        if (N <= M) {
            // reached leaf level; return leaf
            node = $a8d4e4ef6b2c428a$var$createNode(items.slice(left, right + 1));
            $a8d4e4ef6b2c428a$var$calcBBox(node, this.toBBox);
            return node;
        }
        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));
            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }
        node = $a8d4e4ef6b2c428a$var$createNode([]);
        node.leaf = false;
        node.height = height;
        // split the items into M mostly square tiles
        var N2 = Math.ceil(N / M), N1 = N2 * Math.ceil(Math.sqrt(M)), i, j, right2, right3;
        $a8d4e4ef6b2c428a$var$multiSelect(items, left, right, N1, this.compareMinX);
        for(i = left; i <= right; i += N1){
            right2 = Math.min(i + N1 - 1, right);
            $a8d4e4ef6b2c428a$var$multiSelect(items, i, right2, N2, this.compareMinY);
            for(j = i; j <= right2; j += N2){
                right3 = Math.min(j + N2 - 1, right2);
                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }
        $a8d4e4ef6b2c428a$var$calcBBox(node, this.toBBox);
        return node;
    },
    _chooseSubtree: function(bbox, node, level, path) {
        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
        while(true){
            path.push(node);
            if (node.leaf || path.length - 1 === level) break;
            minArea = minEnlargement = Infinity;
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                area = $a8d4e4ef6b2c428a$var$bboxArea(child);
                enlargement = $a8d4e4ef6b2c428a$var$enlargedArea(bbox, child) - area;
                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;
                } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                {
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }
            node = targetNode || node.children[0];
        }
        return node;
    },
    _insert: function(item, level, isNode) {
        var toBBox = this.toBBox, bbox = isNode ? item : toBBox(item), insertPath = [];
        // find the best node for accommodating the item, saving all nodes along the path too
        var node = this._chooseSubtree(bbox, this.data, level, insertPath);
        // put the item into the node
        node.children.push(item);
        $a8d4e4ef6b2c428a$var$extend(node, bbox);
        // split on node overflow; propagate upwards if necessary
        while(level >= 0){
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }
        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    },
    // split overflowed node into two
    _split: function(insertPath, level) {
        var node = insertPath[level], M = node.children.length, m = this._minEntries;
        this._chooseSplitAxis(node, m, M);
        var splitIndex = this._chooseSplitIndex(node, m, M);
        var newNode = $a8d4e4ef6b2c428a$var$createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;
        $a8d4e4ef6b2c428a$var$calcBBox(node, this.toBBox);
        $a8d4e4ef6b2c428a$var$calcBBox(newNode, this.toBBox);
        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    },
    _splitRoot: function(node, newNode) {
        // split root node
        this.data = $a8d4e4ef6b2c428a$var$createNode([
            node,
            newNode
        ]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        $a8d4e4ef6b2c428a$var$calcBBox(this.data, this.toBBox);
    },
    _chooseSplitIndex: function(node, m, M) {
        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
        minOverlap = minArea = Infinity;
        for(i = m; i <= M - m; i++){
            bbox1 = $a8d4e4ef6b2c428a$var$distBBox(node, 0, i, this.toBBox);
            bbox2 = $a8d4e4ef6b2c428a$var$distBBox(node, i, M, this.toBBox);
            overlap = $a8d4e4ef6b2c428a$var$intersectionArea(bbox1, bbox2);
            area = $a8d4e4ef6b2c428a$var$bboxArea(bbox1) + $a8d4e4ef6b2c428a$var$bboxArea(bbox2);
            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;
                minArea = area < minArea ? area : minArea;
            } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
            {
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }
        return index;
    },
    // sorts node children by the best axis for split
    _chooseSplitAxis: function(node, m, M) {
        var compareMinX = node.leaf ? this.compareMinX : $a8d4e4ef6b2c428a$var$compareNodeMinX, compareMinY = node.leaf ? this.compareMinY : $a8d4e4ef6b2c428a$var$compareNodeMinY, xMargin = this._allDistMargin(node, m, M, compareMinX), yMargin = this._allDistMargin(node, m, M, compareMinY);
        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    },
    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin: function(node, m, M, compare) {
        node.children.sort(compare);
        var toBBox = this.toBBox, leftBBox = $a8d4e4ef6b2c428a$var$distBBox(node, 0, m, toBBox), rightBBox = $a8d4e4ef6b2c428a$var$distBBox(node, M - m, M, toBBox), margin = $a8d4e4ef6b2c428a$var$bboxMargin(leftBBox) + $a8d4e4ef6b2c428a$var$bboxMargin(rightBBox), i, child;
        for(i = m; i < M - m; i++){
            child = node.children[i];
            $a8d4e4ef6b2c428a$var$extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += $a8d4e4ef6b2c428a$var$bboxMargin(leftBBox);
        }
        for(i = M - m - 1; i >= m; i--){
            child = node.children[i];
            $a8d4e4ef6b2c428a$var$extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += $a8d4e4ef6b2c428a$var$bboxMargin(rightBBox);
        }
        return margin;
    },
    _adjustParentBBoxes: function(bbox, path, level) {
        // adjust bboxes along the given tree path
        for(var i = level; i >= 0; i--)$a8d4e4ef6b2c428a$var$extend(path[i], bbox);
    },
    _condense: function(path) {
        // go through the path, removing empty nodes and updating bboxes
        for(var i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
            if (i > 0) {
                siblings = path[i - 1].children;
                siblings.splice(siblings.indexOf(path[i]), 1);
            } else this.clear();
        } else $a8d4e4ef6b2c428a$var$calcBBox(path[i], this.toBBox);
    },
    _initFormat: function(format) {
        // data format (minX, minY, maxX, maxY accessors)
        // uses eval-type function compilation instead of just accepting a toBBox function
        // because the algorithms are very sensitive to sorting functions performance,
        // so they should be dead simple and without inner calls
        var compareArr = [
            "return a",
            " - b",
            ";"
        ];
        this.compareMinX = new Function("a", "b", compareArr.join(format[0]));
        this.compareMinY = new Function("a", "b", compareArr.join(format[1]));
        this.toBBox = new Function("a", "return {minX: a" + format[0] + ", minY: a" + format[1] + ", maxX: a" + format[2] + ", maxY: a" + format[3] + "};");
    }
};
function $a8d4e4ef6b2c428a$var$findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);
    for(var i = 0; i < items.length; i++){
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}
// calculate node's bbox from bboxes of its children
function $a8d4e4ef6b2c428a$var$calcBBox(node, toBBox) {
    $a8d4e4ef6b2c428a$var$distBBox(node, 0, node.children.length, toBBox, node);
}
// min bounding rectangle of node children from k to p-1
function $a8d4e4ef6b2c428a$var$distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = $a8d4e4ef6b2c428a$var$createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;
    for(var i = k, child; i < p; i++){
        child = node.children[i];
        $a8d4e4ef6b2c428a$var$extend(destNode, node.leaf ? toBBox(child) : child);
    }
    return destNode;
}
function $a8d4e4ef6b2c428a$var$extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}
function $a8d4e4ef6b2c428a$var$compareNodeMinX(a, b) {
    return a.minX - b.minX;
}
function $a8d4e4ef6b2c428a$var$compareNodeMinY(a, b) {
    return a.minY - b.minY;
}
function $a8d4e4ef6b2c428a$var$bboxArea(a) {
    return (a.maxX - a.minX) * (a.maxY - a.minY);
}
function $a8d4e4ef6b2c428a$var$bboxMargin(a) {
    return a.maxX - a.minX + (a.maxY - a.minY);
}
function $a8d4e4ef6b2c428a$var$enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}
function $a8d4e4ef6b2c428a$var$intersectionArea(a, b) {
    var minX = Math.max(a.minX, b.minX), minY = Math.max(a.minY, b.minY), maxX = Math.min(a.maxX, b.maxX), maxY = Math.min(a.maxY, b.maxY);
    return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
}
function $a8d4e4ef6b2c428a$var$contains(a, b) {
    return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
}
function $a8d4e4ef6b2c428a$var$intersects(a, b) {
    return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
}
function $a8d4e4ef6b2c428a$var$createNode(children) {
    return {
        children: children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}
// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach
function $a8d4e4ef6b2c428a$var$multiSelect(arr, left, right, n, compare) {
    var stack = [
        left,
        right
    ], mid;
    while(stack.length){
        right = stack.pop();
        left = stack.pop();
        if (right - left <= n) continue;
        mid = left + Math.ceil((right - left) / n / 2) * n;
        $g1Wnf(arr, mid, left, right, compare);
        stack.push(left, mid, mid, right);
    }
}

});
parcelRegister("g1Wnf", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function quickselect(arr, k, left, right, compare) {
        quickselectStep(arr, k, left || 0, right || arr.length - 1, compare || defaultCompare);
    }
    function quickselectStep(arr, k, left, right, compare) {
        while(right > left){
            if (right - left > 600) {
                var n = right - left + 1;
                var m = k - left + 1;
                var z = Math.log(n);
                var s = 0.5 * Math.exp(2 * z / 3);
                var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                quickselectStep(arr, k, newLeft, newRight, compare);
            }
            var t = arr[k];
            var i = left;
            var j = right;
            swap(arr, left, k);
            if (compare(arr[right], t) > 0) swap(arr, left, right);
            while(i < j){
                swap(arr, i, j);
                i++;
                j--;
                while(compare(arr[i], t) < 0)i++;
                while(compare(arr[j], t) > 0)j--;
            }
            if (compare(arr[left], t) === 0) swap(arr, left, j);
            else {
                j++;
                swap(arr, j, right);
            }
            if (j <= k) left = j + 1;
            if (k <= j) right = j - 1;
        }
    }
    function swap(arr, i, j) {
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }
    function defaultCompare(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    return quickselect;
});

});





parcelRegister("lzQHn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1UAWS = parcelRequire("1UAWS");

var $7GKQS = parcelRequire("7GKQS");
/**
 * Takes a {@link Point} and calculates the circle polygon given a radius in degrees, radians, miles, or kilometers; and steps for precision.
 *
 * @name circle
 * @param {Feature<Point>|number[]} center center point
 * @param {number} radius radius of the circle
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.steps=64] number of steps
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {Object} [options.properties={}] properties
 * @returns {Feature<Polygon>} circle polygon
 * @example
 * var center = [-75.343, 39.984];
 * var radius = 5;
 * var options = {steps: 10, units: 'kilometers', properties: {foo: 'bar'}};
 * var circle = turf.circle(center, radius, options);
 *
 * //addToMap
 * var addToMap = [turf.point(center), circle]
 */ function $fb55beb0eb8f96f2$var$circle(center, radius, options) {
    if (options === void 0) options = {};
    // default params
    var steps = options.steps || 64;
    var properties = options.properties ? options.properties : !Array.isArray(center) && center.type === "Feature" && center.properties ? center.properties : {};
    // main
    var coordinates = [];
    for(var i = 0; i < steps; i++)coordinates.push($1UAWS.default(center, radius, i * -360 / steps, options).geometry.coordinates);
    coordinates.push(coordinates[0]);
    return $7GKQS.polygon([
        coordinates
    ], properties);
}
module.exports.default = $fb55beb0eb8f96f2$var$circle;

});

parcelRegister("4B93b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lX3Ya = parcelRequire("lX3Ya");

var $7GKQS = parcelRequire("7GKQS");
/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the absolute center point of all features.
 *
 * @name center
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Point
 * @param {Object} [options.bbox={}] Translate GeoJSON BBox to Point
 * @param {Object} [options.id={}] Translate GeoJSON Id to Point
 * @returns {Feature<Point>} a Point feature at the absolute center point of all input features
 * @example
 * var features = turf.points([
 *   [-97.522259, 35.4691],
 *   [-97.502754, 35.463455],
 *   [-97.508269, 35.463245]
 * ]);
 *
 * var center = turf.center(features);
 *
 * //addToMap
 * var addToMap = [features, center]
 * center.properties['marker-size'] = 'large';
 * center.properties['marker-color'] = '#000';
 */ function $3591a35128f0f03e$var$center(geojson, options) {
    if (options === void 0) options = {};
    var ext = $lX3Ya.default(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return $7GKQS.point([
        x,
        y
    ], options.properties, options);
}
module.exports.default = $3591a35128f0f03e$var$center;

});


parcelRegister("lWzrG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslateMode = void 0;

var $ff9a827959d738b1$var$_bearing = $ff9a827959d738b1$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $ff9a827959d738b1$var$_distance = $ff9a827959d738b1$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $ff9a827959d738b1$var$_transformTranslate = $ff9a827959d738b1$var$_interopRequireDefault((parcelRequire("6QfJH")));

var $7GKQS = parcelRequire("7GKQS");

var $ff9a827959d738b1$var$_viewportMercatorProject = $ff9a827959d738b1$var$_interopRequireDefault((parcelRequire("1LAFs")));

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");

var $eJgQU = parcelRequire("eJgQU");
function $ff9a827959d738b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ff9a827959d738b1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ff9a827959d738b1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ff9a827959d738b1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ff9a827959d738b1$var$_typeof(obj);
}
function $ff9a827959d738b1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ff9a827959d738b1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ff9a827959d738b1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ff9a827959d738b1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ff9a827959d738b1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ff9a827959d738b1$var$_createSuper(Derived) {
    return function() {
        var Super = $ff9a827959d738b1$var$_getPrototypeOf(Derived), result;
        if ($ff9a827959d738b1$var$_isNativeReflectConstruct()) {
            var NewTarget = $ff9a827959d738b1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ff9a827959d738b1$var$_possibleConstructorReturn(this, result);
    };
}
function $ff9a827959d738b1$var$_possibleConstructorReturn(self, call) {
    if (call && ($ff9a827959d738b1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ff9a827959d738b1$var$_assertThisInitialized(self);
}
function $ff9a827959d738b1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ff9a827959d738b1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ff9a827959d738b1$var$_getPrototypeOf(o) {
    $ff9a827959d738b1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ff9a827959d738b1$var$_getPrototypeOf(o);
}
function $ff9a827959d738b1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ff9a827959d738b1$var$_setPrototypeOf(subClass, superClass);
}
function $ff9a827959d738b1$var$_setPrototypeOf(o, p) {
    $ff9a827959d738b1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ff9a827959d738b1$var$_setPrototypeOf(o, p);
}
function $ff9a827959d738b1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ff9a827959d738b1$var$TranslateMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $ff9a827959d738b1$var$_inherits(TranslateMode, _GeoJsonEditMode);
    var _super = $ff9a827959d738b1$var$_createSuper(TranslateMode);
    function TranslateMode() {
        var _this;
        $ff9a827959d738b1$var$_classCallCheck(this, TranslateMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $ff9a827959d738b1$var$_defineProperty($ff9a827959d738b1$var$_assertThisInitialized(_this), "_geometryBeforeTranslate", void 0);
        $ff9a827959d738b1$var$_defineProperty($ff9a827959d738b1$var$_assertThisInitialized(_this), "_isTranslatable", void 0);
        return _this;
    }
    $ff9a827959d738b1$var$_createClass(TranslateMode, [
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                if (!this._isTranslatable) // Nothing to do
                return;
                if (this._geometryBeforeTranslate) {
                    // Translate the geometry
                    var editAction = this.getTranslateAction(event.pointerDownMapCoords, event.mapCoords, "translating", props);
                    if (editAction) props.onEdit(editAction);
                } // cancel map panning
                event.cancelPan();
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                this._isTranslatable = this.isSelectionPicked(event.pointerDownPicks || event.picks, props);
                this.updateCursor(props);
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                if (!this._isTranslatable) return;
                this._geometryBeforeTranslate = this.getSelectedFeaturesAsFeatureCollection(props);
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                if (this._geometryBeforeTranslate) {
                    // Translate the geometry
                    var editAction = this.getTranslateAction(event.pointerDownMapCoords, event.mapCoords, "translated", props);
                    if (editAction) props.onEdit(editAction);
                    this._geometryBeforeTranslate = null;
                }
            }
        },
        {
            key: "updateCursor",
            value: function updateCursor(props) {
                if (this._isTranslatable) props.onUpdateCursor("move");
                else props.onUpdateCursor(null);
            }
        },
        {
            key: "getTranslateAction",
            value: function getTranslateAction(startDragPoint, currentPoint, editType, props) {
                var _this2 = this;
                if (!this._geometryBeforeTranslate) return null;
                var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data);
                var selectedIndexes = props.selectedIndexes;
                var _ref = props.modeConfig || {}, viewportDesc = _ref.viewport, screenSpace = _ref.screenSpace;
                if (viewportDesc && screenSpace) (function() {
                    var viewport = viewportDesc.project ? viewportDesc : new $ff9a827959d738b1$var$_viewportMercatorProject["default"](viewportDesc);
                    var from = viewport.project(startDragPoint);
                    var to = viewport.project(currentPoint);
                    var dx = to[0] - from[0];
                    var dy = to[1] - from[1];
                    for(var i = 0; i < selectedIndexes.length; i++){
                        var selectedIndex = selectedIndexes[i];
                        var feature = _this2._geometryBeforeTranslate.features[i];
                        var coordinates = feature.geometry.coordinates;
                        if (coordinates) {
                            coordinates = (0, $hs5Hv.mapCoords)(coordinates, function(coord) {
                                var pixels = viewport.project(coord);
                                if (pixels) {
                                    pixels[0] += dx;
                                    pixels[1] += dy;
                                    return viewport.unproject(pixels);
                                }
                                return null;
                            }); // @ts-ignore
                            updatedData = updatedData.replaceGeometry(selectedIndex, {
                                type: feature.geometry.type,
                                coordinates: coordinates
                            });
                        }
                    }
                })();
                else {
                    var p1 = (0, $7GKQS.point)(startDragPoint);
                    var p2 = (0, $7GKQS.point)(currentPoint);
                    var distanceMoved = (0, $ff9a827959d738b1$var$_distance["default"])(p1, p2);
                    var direction = (0, $ff9a827959d738b1$var$_bearing["default"])(p1, p2);
                    var movedFeatures = (0, $ff9a827959d738b1$var$_transformTranslate["default"])(this._geometryBeforeTranslate, distanceMoved, direction);
                    for(var i = 0; i < selectedIndexes.length; i++){
                        var selectedIndex = selectedIndexes[i];
                        var movedFeature = movedFeatures.features[i];
                        updatedData = updatedData.replaceGeometry(selectedIndex, movedFeature.geometry);
                    }
                }
                return {
                    updatedData: updatedData.getObject(),
                    editType: editType,
                    editContext: {
                        featureIndexes: selectedIndexes
                    }
                };
            }
        }
    ]);
    return TranslateMode;
}($1tPZO.GeoJsonEditMode);
module.exports.TranslateMode = $ff9a827959d738b1$var$TranslateMode;

});
parcelRegister("6QfJH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4fb3ce49b5617949$export$2e2bcd8739ae039; });

var $7Lf5N = parcelRequire("7Lf5N");

var $2HWCK = parcelRequire("2HWCK");

var $aCDhp = parcelRequire("aCDhp");

var $asTyQ = parcelRequire("asTyQ");

var $35NAj = parcelRequire("35NAj");
/**
 * Moves any geojson Feature or Geometry of a specified distance along a Rhumb Line
 * on the provided direction angle.
 *
 * @name transformTranslate
 * @param {GeoJSON} geojson object to be translated
 * @param {number} distance length of the motion; negative values determine motion in opposite direction
 * @param {number} direction of the motion; angle from North in decimal degrees, positive clockwise
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] in which `distance` will be express; miles, kilometers, degrees, or radians
 * @param {number} [options.zTranslation=0] length of the vertical motion, same unit of distance
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} the translated GeoJSON object
 * @example
 * var poly = turf.polygon([[[0,29],[3.5,29],[2.5,32],[0,29]]]);
 * var translatedPoly = turf.transformTranslate(poly, 100, 35);
 *
 * //addToMap
 * var addToMap = [poly, translatedPoly];
 * translatedPoly.properties = {stroke: '#F00', 'stroke-width': 4};
 */ function $4fb3ce49b5617949$var$transformTranslate(geojson, distance, direction, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $2HWCK.isObject)(options)) throw new Error("options is invalid");
    var units = options.units;
    var zTranslation = options.zTranslation;
    var mutate = options.mutate;
    // Input validation
    if (!geojson) throw new Error("geojson is required");
    if (distance === undefined || distance === null || isNaN(distance)) throw new Error("distance is required");
    if (zTranslation && typeof zTranslation !== "number" && isNaN(zTranslation)) throw new Error("zTranslation is not a number");
    // Shortcut no-motion
    zTranslation = zTranslation !== undefined ? zTranslation : 0;
    if (distance === 0 && zTranslation === 0) return geojson;
    if (direction === undefined || direction === null || isNaN(direction)) throw new Error("direction is required");
    // Invert with negative distances
    if (distance < 0) {
        distance = -distance;
        direction = -direction;
    }
    // Clone geojson to avoid side effects
    if (mutate === false || mutate === undefined) geojson = (0, $asTyQ.default)(geojson);
    // Translate each coordinate
    (0, $7Lf5N.coordEach)(geojson, function(pointCoords) {
        var newCoords = (0, $aCDhp.getCoords)((0, $35NAj.default)(pointCoords, distance, direction, {
            units: units
        }));
        pointCoords[0] = newCoords[0];
        pointCoords[1] = newCoords[1];
        if (zTranslation && pointCoords.length === 3) pointCoords[2] += zTranslation;
    });
    return geojson;
}
var $4fb3ce49b5617949$export$2e2bcd8739ae039 = $4fb3ce49b5617949$var$transformTranslate;

});
parcelRegister("7Lf5N", function(module, exports) {

$parcel$export(module.exports, "coordEach", function () { return $5a68a13b21e38b8a$export$6e011439fde007ae; });

var $2HWCK = parcelRequire("2HWCK");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $5a68a13b21e38b8a$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        if (geomType === "MultiPolygon") geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($5a68a13b21e38b8a$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $5a68a13b21e38b8a$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $5a68a13b21e38b8a$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $5a68a13b21e38b8a$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $5a68a13b21e38b8a$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $5a68a13b21e38b8a$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $5a68a13b21e38b8a$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $5a68a13b21e38b8a$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $5a68a13b21e38b8a$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $5a68a13b21e38b8a$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $5a68a13b21e38b8a$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $5a68a13b21e38b8a$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $5a68a13b21e38b8a$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $5a68a13b21e38b8a$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $5a68a13b21e38b8a$export$12cba8b31beb353b(geojson, callback) {
    $5a68a13b21e38b8a$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $2HWCK.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $2HWCK.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $5a68a13b21e38b8a$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $5a68a13b21e38b8a$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $5a68a13b21e38b8a$export$d3ecc1efb2be121e(geojson, callback) {
    $5a68a13b21e38b8a$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature$$1.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature$$1.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        if ($5a68a13b21e38b8a$export$6e011439fde007ae(feature$$1, function(currentCoord, coordIndex, featureIndexCoord, mutliPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined) {
                previousCoords = currentCoord;
                return;
            }
            var currentSegment = (0, $2HWCK.lineString)([
                previousCoords,
                currentCoord
            ], feature$$1.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentInex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $5a68a13b21e38b8a$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $5a68a13b21e38b8a$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $5a68a13b21e38b8a$export$985a91771cfc783d(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $5a68a13b21e38b8a$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        if (feature$$1.geometry === null) return;
        var type = feature$$1.geometry.type;
        var coords = feature$$1.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature$$1, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $2HWCK.lineString)(coords[geometryIndex], feature$$1.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $5a68a13b21e38b8a$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $5a68a13b21e38b8a$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $5a68a13b21e38b8a$export$2b6ba91fd8680d67(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $2HWCK.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $2HWCK.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $2HWCK.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $2HWCK.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $2HWCK.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $5a68a13b21e38b8a$export$ed60ae5df1bac687(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $2HWCK.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $2HWCK.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $2HWCK.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $2HWCK.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $2HWCK.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $2HWCK.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $2HWCK.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

});
parcelRegister("2HWCK", function(module, exports) {

$parcel$export(module.exports, "feature", function () { return $1f8d1265c89b392b$export$ced6ed16dfd6a264; });
$parcel$export(module.exports, "isObject", function () { return $1f8d1265c89b392b$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "point", function () { return $1f8d1265c89b392b$export$105684a3041cb6f3; });
$parcel$export(module.exports, "lineString", function () { return $1f8d1265c89b392b$export$98ec381bb06902c3; });
$parcel$export(module.exports, "isNumber", function () { return $1f8d1265c89b392b$export$7e4aa119212bc614; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $1f8d1265c89b392b$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $1f8d1265c89b392b$export$f929e47acbed771a = {
    meters: $1f8d1265c89b392b$export$e3a1ee0e9945697f,
    metres: $1f8d1265c89b392b$export$e3a1ee0e9945697f,
    millimeters: $1f8d1265c89b392b$export$e3a1ee0e9945697f * 1000,
    millimetres: $1f8d1265c89b392b$export$e3a1ee0e9945697f * 1000,
    centimeters: $1f8d1265c89b392b$export$e3a1ee0e9945697f * 100,
    centimetres: $1f8d1265c89b392b$export$e3a1ee0e9945697f * 100,
    kilometers: $1f8d1265c89b392b$export$e3a1ee0e9945697f / 1000,
    kilometres: $1f8d1265c89b392b$export$e3a1ee0e9945697f / 1000,
    miles: $1f8d1265c89b392b$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $1f8d1265c89b392b$export$e3a1ee0e9945697f / 1852,
    inches: $1f8d1265c89b392b$export$e3a1ee0e9945697f * 39.370,
    yards: $1f8d1265c89b392b$export$e3a1ee0e9945697f / 1.0936,
    feet: $1f8d1265c89b392b$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $1f8d1265c89b392b$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $1f8d1265c89b392b$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $1f8d1265c89b392b$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $1f8d1265c89b392b$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $1f8d1265c89b392b$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$1f8d1265c89b392b$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $1f8d1265c89b392b$export$28ac7bb8f5309bea(bbox);
    if (id) $1f8d1265c89b392b$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $1f8d1265c89b392b$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$1f8d1265c89b392b$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $1f8d1265c89b392b$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $1f8d1265c89b392b$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $1f8d1265c89b392b$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $1f8d1265c89b392b$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $1f8d1265c89b392b$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $1f8d1265c89b392b$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $1f8d1265c89b392b$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $1f8d1265c89b392b$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$1f8d1265c89b392b$export$7e4aa119212bc614(coordinates[0]) || !$1f8d1265c89b392b$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $1f8d1265c89b392b$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $1f8d1265c89b392b$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $1f8d1265c89b392b$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $1f8d1265c89b392b$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $1f8d1265c89b392b$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$1f8d1265c89b392b$export$7e4aa119212bc614(ring[0][0]) || !$1f8d1265c89b392b$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $1f8d1265c89b392b$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $1f8d1265c89b392b$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $1f8d1265c89b392b$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $1f8d1265c89b392b$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $1f8d1265c89b392b$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$1f8d1265c89b392b$export$7e4aa119212bc614(coordinates[0][1]) || !$1f8d1265c89b392b$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $1f8d1265c89b392b$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $1f8d1265c89b392b$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $1f8d1265c89b392b$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $1f8d1265c89b392b$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $1f8d1265c89b392b$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$1f8d1265c89b392b$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $1f8d1265c89b392b$export$28ac7bb8f5309bea(bbox);
    if (id) $1f8d1265c89b392b$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $1f8d1265c89b392b$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $1f8d1265c89b392b$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $1f8d1265c89b392b$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $1f8d1265c89b392b$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $1f8d1265c89b392b$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $1f8d1265c89b392b$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $1f8d1265c89b392b$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $1f8d1265c89b392b$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $1f8d1265c89b392b$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $1f8d1265c89b392b$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $1f8d1265c89b392b$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $1f8d1265c89b392b$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $1f8d1265c89b392b$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $1f8d1265c89b392b$export$c7a138e00a89bd01(distance, units) {
    return $1f8d1265c89b392b$export$c41dd2a8460d3196($1f8d1265c89b392b$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $1f8d1265c89b392b$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $1f8d1265c89b392b$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $1f8d1265c89b392b$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $1f8d1265c89b392b$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $1f8d1265c89b392b$export$f234631d6a2eedf8($1f8d1265c89b392b$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $1f8d1265c89b392b$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $1f8d1265c89b392b$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $1f8d1265c89b392b$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $1f8d1265c89b392b$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $1f8d1265c89b392b$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $1f8d1265c89b392b$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$1f8d1265c89b392b$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $1f8d1265c89b392b$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $1f8d1265c89b392b$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $1f8d1265c89b392b$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $1f8d1265c89b392b$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $1f8d1265c89b392b$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $1f8d1265c89b392b$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $1f8d1265c89b392b$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $1f8d1265c89b392b$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});


parcelRegister("aCDhp", function(module, exports) {

$parcel$export(module.exports, "getCoords", function () { return $7bbbec1f72658b64$export$39e042fd83f1b62e; });

var $2HWCK = parcelRequire("2HWCK");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $7bbbec1f72658b64$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $7bbbec1f72658b64$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $7bbbec1f72658b64$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $2HWCK.isNumber)(coordinates[0]) && (0, $2HWCK.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $7bbbec1f72658b64$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $7bbbec1f72658b64$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $7bbbec1f72658b64$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $7bbbec1f72658b64$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $7bbbec1f72658b64$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $7bbbec1f72658b64$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $7bbbec1f72658b64$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});

parcelRegister("35NAj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24084d39202eb3c6$export$2e2bcd8739ae039; });

var $csOZg = parcelRequire("csOZg");

var $aNgeK = parcelRequire("aNgeK");
// https://en.wikipedia.org/wiki/Rhumb_line
/**
 * Returns the destination {@link Point} having travelled the given distance along a Rhumb line from the
 * origin Point with the (varant) given bearing.
 *
 * @name rhumbDestination
 * @param {Coord} origin starting point
 * @param {number} distance distance from the starting point
 * @param {number} bearing varant bearing angle ranging from -180 to 180 degrees from north
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @param {Object} [options.properties={}] translate properties to destination point
 * @returns {Feature<Point>} Destination point.
 * @example
 * var pt = turf.point([-75.343, 39.984], {"marker-color": "F00"});
 * var distance = 50;
 * var bearing = 90;
 * var options = {units: 'miles'};
 *
 * var destination = turf.rhumbDestination(pt, distance, bearing, options);
 *
 * //addToMap
 * var addToMap = [pt, destination]
 * destination.properties['marker-color'] = '#00F';
 */ function $24084d39202eb3c6$var$rhumbDestination(origin, distance, bearing, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $csOZg.isObject)(options)) throw new Error("options is invalid");
    var units = options.units;
    var properties = options.properties;
    // validation
    if (!origin) throw new Error("origin is required");
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (bearing === undefined || bearing === null) throw new Error("bearing is required");
    if (!(distance >= 0)) throw new Error("distance must be greater than 0");
    var distanceInMeters = (0, $csOZg.convertLength)(distance, units, "meters");
    var coords = (0, $aNgeK.getCoord)(origin);
    var destination = $24084d39202eb3c6$var$calculateRhumbDestination(coords, distanceInMeters, bearing);
    // compensate the crossing of the 180th meridian (https://macwright.org/2016/09/26/the-180th-meridian.html)
    // solution from https://github.com/mapbox/mapbox-gl-js/issues/3250#issuecomment-294887678
    destination[0] += destination[0] - coords[0] > 180 ? -360 : coords[0] - destination[0] > 180 ? 360 : 0;
    return (0, $csOZg.point)(destination, properties);
}
/**
 * Returns the destination point having travelled along a rhumb line from origin point the given
 * distance on the  given bearing.
 * Adapted from Geodesy: http://www.movable-type.co.uk/scripts/latlong.html#rhumblines
 *
 * @private
 * @param   {Array<number>} origin - point
 * @param   {number} distance - Distance travelled, in same units as earth radius (default: metres).
 * @param   {number} bearing - Bearing in degrees from north.
 * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
 * @returns {Array<number>} Destination point.
 */ function $24084d39202eb3c6$var$calculateRhumbDestination(origin, distance, bearing, radius) {
    // φ => phi
    // λ => lambda
    // ψ => psi
    // Δ => Delta
    // δ => delta
    // θ => theta
    radius = radius === undefined ? (0, $csOZg.earthRadius) : Number(radius);
    var delta = distance / radius; // angular distance in radians
    var lambda1 = origin[0] * Math.PI / 180; // to radians, but without normalize to 𝜋
    var phi1 = (0, $csOZg.degreesToRadians)(origin[1]);
    var theta = (0, $csOZg.degreesToRadians)(bearing);
    var DeltaPhi = delta * Math.cos(theta);
    var phi2 = phi1 + DeltaPhi;
    // check for some daft bugger going past the pole, normalise latitude if so
    if (Math.abs(phi2) > Math.PI / 2) phi2 = phi2 > 0 ? Math.PI - phi2 : -Math.PI - phi2;
    var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1); // E-W course becomes ill-conditioned with 0/0
    var DeltaLambda = delta * Math.sin(theta) / q;
    var lambda2 = lambda1 + DeltaLambda;
    return [
        (lambda2 * 180 / Math.PI + 540) % 360 - 180,
        phi2 * 180 / Math.PI
    ]; // normalise to −180..+180°
}
var $24084d39202eb3c6$export$2e2bcd8739ae039 = $24084d39202eb3c6$var$rhumbDestination;

});
parcelRegister("csOZg", function(module, exports) {

$parcel$export(module.exports, "earthRadius", function () { return $912fa68bd3d0db4e$export$e3a1ee0e9945697f; });
$parcel$export(module.exports, "isObject", function () { return $912fa68bd3d0db4e$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "point", function () { return $912fa68bd3d0db4e$export$105684a3041cb6f3; });
$parcel$export(module.exports, "isNumber", function () { return $912fa68bd3d0db4e$export$7e4aa119212bc614; });
$parcel$export(module.exports, "degreesToRadians", function () { return $912fa68bd3d0db4e$export$c9fcf1a7df975d78; });
$parcel$export(module.exports, "convertLength", function () { return $912fa68bd3d0db4e$export$ea1536a749e80563; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $912fa68bd3d0db4e$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $912fa68bd3d0db4e$export$f929e47acbed771a = {
    meters: $912fa68bd3d0db4e$export$e3a1ee0e9945697f,
    metres: $912fa68bd3d0db4e$export$e3a1ee0e9945697f,
    millimeters: $912fa68bd3d0db4e$export$e3a1ee0e9945697f * 1000,
    millimetres: $912fa68bd3d0db4e$export$e3a1ee0e9945697f * 1000,
    centimeters: $912fa68bd3d0db4e$export$e3a1ee0e9945697f * 100,
    centimetres: $912fa68bd3d0db4e$export$e3a1ee0e9945697f * 100,
    kilometers: $912fa68bd3d0db4e$export$e3a1ee0e9945697f / 1000,
    kilometres: $912fa68bd3d0db4e$export$e3a1ee0e9945697f / 1000,
    miles: $912fa68bd3d0db4e$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $912fa68bd3d0db4e$export$e3a1ee0e9945697f / 1852,
    inches: $912fa68bd3d0db4e$export$e3a1ee0e9945697f * 39.370,
    yards: $912fa68bd3d0db4e$export$e3a1ee0e9945697f / 1.0936,
    feet: $912fa68bd3d0db4e$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $912fa68bd3d0db4e$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $912fa68bd3d0db4e$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $912fa68bd3d0db4e$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $912fa68bd3d0db4e$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $912fa68bd3d0db4e$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$912fa68bd3d0db4e$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $912fa68bd3d0db4e$export$28ac7bb8f5309bea(bbox);
    if (id) $912fa68bd3d0db4e$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $912fa68bd3d0db4e$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$912fa68bd3d0db4e$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $912fa68bd3d0db4e$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $912fa68bd3d0db4e$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $912fa68bd3d0db4e$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $912fa68bd3d0db4e$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $912fa68bd3d0db4e$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $912fa68bd3d0db4e$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $912fa68bd3d0db4e$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $912fa68bd3d0db4e$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$912fa68bd3d0db4e$export$7e4aa119212bc614(coordinates[0]) || !$912fa68bd3d0db4e$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $912fa68bd3d0db4e$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $912fa68bd3d0db4e$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $912fa68bd3d0db4e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $912fa68bd3d0db4e$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $912fa68bd3d0db4e$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$912fa68bd3d0db4e$export$7e4aa119212bc614(ring[0][0]) || !$912fa68bd3d0db4e$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $912fa68bd3d0db4e$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $912fa68bd3d0db4e$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $912fa68bd3d0db4e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $912fa68bd3d0db4e$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $912fa68bd3d0db4e$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$912fa68bd3d0db4e$export$7e4aa119212bc614(coordinates[0][1]) || !$912fa68bd3d0db4e$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $912fa68bd3d0db4e$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $912fa68bd3d0db4e$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $912fa68bd3d0db4e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $912fa68bd3d0db4e$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $912fa68bd3d0db4e$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$912fa68bd3d0db4e$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $912fa68bd3d0db4e$export$28ac7bb8f5309bea(bbox);
    if (id) $912fa68bd3d0db4e$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $912fa68bd3d0db4e$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $912fa68bd3d0db4e$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $912fa68bd3d0db4e$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $912fa68bd3d0db4e$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $912fa68bd3d0db4e$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $912fa68bd3d0db4e$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $912fa68bd3d0db4e$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $912fa68bd3d0db4e$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $912fa68bd3d0db4e$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $912fa68bd3d0db4e$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $912fa68bd3d0db4e$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $912fa68bd3d0db4e$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $912fa68bd3d0db4e$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $912fa68bd3d0db4e$export$c7a138e00a89bd01(distance, units) {
    return $912fa68bd3d0db4e$export$c41dd2a8460d3196($912fa68bd3d0db4e$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $912fa68bd3d0db4e$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $912fa68bd3d0db4e$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $912fa68bd3d0db4e$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $912fa68bd3d0db4e$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $912fa68bd3d0db4e$export$f234631d6a2eedf8($912fa68bd3d0db4e$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $912fa68bd3d0db4e$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $912fa68bd3d0db4e$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $912fa68bd3d0db4e$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $912fa68bd3d0db4e$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $912fa68bd3d0db4e$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $912fa68bd3d0db4e$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$912fa68bd3d0db4e$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $912fa68bd3d0db4e$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $912fa68bd3d0db4e$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $912fa68bd3d0db4e$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $912fa68bd3d0db4e$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $912fa68bd3d0db4e$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $912fa68bd3d0db4e$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $912fa68bd3d0db4e$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $912fa68bd3d0db4e$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});

parcelRegister("aNgeK", function(module, exports) {

$parcel$export(module.exports, "getCoord", function () { return $7dbb134aa98666a9$export$b4663c6e64a770bc; });

var $csOZg = parcelRequire("csOZg");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $7dbb134aa98666a9$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $7dbb134aa98666a9$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $7dbb134aa98666a9$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $csOZg.isNumber)(coordinates[0]) && (0, $csOZg.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $7dbb134aa98666a9$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $7dbb134aa98666a9$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $7dbb134aa98666a9$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $7dbb134aa98666a9$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $7dbb134aa98666a9$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $7dbb134aa98666a9$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $7dbb134aa98666a9$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});




parcelRegister("ljwRq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScaleMode = void 0;

var $f844dcc60d4a8003$var$_bbox = $f844dcc60d4a8003$var$_interopRequireDefault((parcelRequire("lX3Ya")));

var $f844dcc60d4a8003$var$_centroid = $f844dcc60d4a8003$var$_interopRequireDefault((parcelRequire("d9r3a")));

var $f844dcc60d4a8003$var$_bearing = $f844dcc60d4a8003$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $f844dcc60d4a8003$var$_bboxPolygon = $f844dcc60d4a8003$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $7GKQS = parcelRequire("7GKQS");

var $f844dcc60d4a8003$var$_polygonToLine = $f844dcc60d4a8003$var$_interopRequireDefault((parcelRequire("eGOxi")));

var $cJNDJ = parcelRequire("cJNDJ");

var $f844dcc60d4a8003$var$_distance = $f844dcc60d4a8003$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $f844dcc60d4a8003$var$_transformScale = $f844dcc60d4a8003$var$_interopRequireDefault((parcelRequire("kYjHo")));

var $8abqV = parcelRequire("8abqV");

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");

var $eJgQU = parcelRequire("eJgQU");
function $f844dcc60d4a8003$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f844dcc60d4a8003$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f844dcc60d4a8003$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f844dcc60d4a8003$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f844dcc60d4a8003$var$_typeof(obj);
}
function $f844dcc60d4a8003$var$_toConsumableArray(arr) {
    return $f844dcc60d4a8003$var$_arrayWithoutHoles(arr) || $f844dcc60d4a8003$var$_iterableToArray(arr) || $f844dcc60d4a8003$var$_unsupportedIterableToArray(arr) || $f844dcc60d4a8003$var$_nonIterableSpread();
}
function $f844dcc60d4a8003$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f844dcc60d4a8003$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f844dcc60d4a8003$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f844dcc60d4a8003$var$_arrayLikeToArray(o, minLen);
}
function $f844dcc60d4a8003$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $f844dcc60d4a8003$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f844dcc60d4a8003$var$_arrayLikeToArray(arr);
}
function $f844dcc60d4a8003$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f844dcc60d4a8003$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f844dcc60d4a8003$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f844dcc60d4a8003$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f844dcc60d4a8003$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f844dcc60d4a8003$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f844dcc60d4a8003$var$_createSuper(Derived) {
    return function() {
        var Super = $f844dcc60d4a8003$var$_getPrototypeOf(Derived), result;
        if ($f844dcc60d4a8003$var$_isNativeReflectConstruct()) {
            var NewTarget = $f844dcc60d4a8003$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f844dcc60d4a8003$var$_possibleConstructorReturn(this, result);
    };
}
function $f844dcc60d4a8003$var$_possibleConstructorReturn(self, call) {
    if (call && ($f844dcc60d4a8003$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f844dcc60d4a8003$var$_assertThisInitialized(self);
}
function $f844dcc60d4a8003$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f844dcc60d4a8003$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f844dcc60d4a8003$var$_getPrototypeOf(o) {
    $f844dcc60d4a8003$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f844dcc60d4a8003$var$_getPrototypeOf(o);
}
function $f844dcc60d4a8003$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f844dcc60d4a8003$var$_setPrototypeOf(subClass, superClass);
}
function $f844dcc60d4a8003$var$_setPrototypeOf(o, p) {
    $f844dcc60d4a8003$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f844dcc60d4a8003$var$_setPrototypeOf(o, p);
}
function $f844dcc60d4a8003$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f844dcc60d4a8003$var$ScaleMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $f844dcc60d4a8003$var$_inherits(ScaleMode, _GeoJsonEditMode);
    var _super = $f844dcc60d4a8003$var$_createSuper(ScaleMode);
    function ScaleMode() {
        var _this;
        $f844dcc60d4a8003$var$_classCallCheck(this, ScaleMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_geometryBeingScaled", void 0);
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_selectedEditHandle", void 0);
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_cornerGuidePoints", void 0);
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_cursor", void 0);
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_isScaling", false);
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_isSinglePointGeometrySelected", function(geometry) {
            var _ref = geometry || {}, features = _ref.features;
            if (Array.isArray(features) && features.length === 1) {
                // @ts-ignore
                var _getGeom = (0, $8abqV.getGeom)(features[0]), type = _getGeom.type;
                return type === "Point";
            }
            return false;
        });
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_getOppositeScaleHandle", function(selectedHandle) {
            var selectedHandleIndex = selectedHandle && selectedHandle.properties && Array.isArray(selectedHandle.properties.positionIndexes) && selectedHandle.properties.positionIndexes[0];
            if (typeof selectedHandleIndex !== "number") return null;
            var guidePointCount = _this._cornerGuidePoints.length;
            var oppositeIndex = (selectedHandleIndex + guidePointCount / 2) % guidePointCount;
            return _this._cornerGuidePoints.find(function(p) {
                if (!Array.isArray(p.properties.positionIndexes)) return false;
                return p.properties.positionIndexes[0] === oppositeIndex;
            });
        });
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "_getUpdatedData", function(props, editedData) {
            var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data);
            var selectedIndexes = props.selectedIndexes;
            for(var i = 0; i < selectedIndexes.length; i++){
                var selectedIndex = selectedIndexes[i];
                var movedFeature = editedData.features[i];
                updatedData = updatedData.replaceGeometry(selectedIndex, movedFeature.geometry);
            }
            return updatedData.getObject();
        });
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "isEditHandleSelected", function() {
            return Boolean(_this._selectedEditHandle);
        });
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "getScaleAction", function(startDragPoint, currentPoint, editType, props) {
            if (!_this._selectedEditHandle) return null;
            var oppositeHandle = _this._getOppositeScaleHandle(_this._selectedEditHandle);
            var origin = (0, $8abqV.getCoord)(oppositeHandle); // @ts-ignore
            var scaleFactor = $f844dcc60d4a8003$var$getScaleFactor(origin, startDragPoint, currentPoint); // @ts-ignore
            var scaledFeatures = (0, $f844dcc60d4a8003$var$_transformScale["default"])(_this._geometryBeingScaled, scaleFactor, {
                origin: origin
            });
            return {
                updatedData: _this._getUpdatedData(props, scaledFeatures),
                editType: editType,
                editContext: {
                    featureIndexes: props.selectedIndexes
                }
            };
        });
        $f844dcc60d4a8003$var$_defineProperty($f844dcc60d4a8003$var$_assertThisInitialized(_this), "updateCursor", function(props) {
            if (_this._selectedEditHandle) {
                if (_this._cursor) props.onUpdateCursor(_this._cursor);
                var cursorGeometry = _this.getSelectedFeaturesAsFeatureCollection(props); // Get resize cursor direction from the hovered scale editHandle (e.g. nesw or nwse)
                var centroid = (0, $f844dcc60d4a8003$var$_centroid["default"])(cursorGeometry);
                var bearing = (0, $f844dcc60d4a8003$var$_bearing["default"])(centroid, _this._selectedEditHandle);
                var positiveBearing = bearing < 0 ? bearing + 180 : bearing;
                if (positiveBearing >= 0 && positiveBearing <= 90 || positiveBearing >= 180 && positiveBearing <= 270) {
                    _this._cursor = "nesw-resize";
                    props.onUpdateCursor("nesw-resize");
                } else {
                    _this._cursor = "nwse-resize";
                    props.onUpdateCursor("nwse-resize");
                }
            } else {
                props.onUpdateCursor(null);
                _this._cursor = null;
            }
        });
        return _this;
    }
    $f844dcc60d4a8003$var$_createClass(ScaleMode, [
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                if (!this._isScaling) {
                    var selectedEditHandle = (0, $hs5Hv.getPickedEditHandle)(event.picks);
                    this._selectedEditHandle = selectedEditHandle && selectedEditHandle.properties.editHandleType === "scale" ? selectedEditHandle : null;
                    this.updateCursor(props);
                }
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                if (this._selectedEditHandle) {
                    this._isScaling = true;
                    this._geometryBeingScaled = this.getSelectedFeaturesAsFeatureCollection(props);
                }
            }
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                if (!this._isScaling) return;
                props.onUpdateCursor(this._cursor);
                var scaleAction = this.getScaleAction(event.pointerDownMapCoords, event.mapCoords, "scaling", props);
                if (scaleAction) props.onEdit(scaleAction);
                event.cancelPan();
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                if (this._isScaling) {
                    // Scale the geometry
                    var scaleAction = this.getScaleAction(event.pointerDownMapCoords, event.mapCoords, "scaled", props);
                    if (scaleAction) props.onEdit(scaleAction);
                    props.onUpdateCursor(null);
                    this._geometryBeingScaled = null;
                    this._selectedEditHandle = null;
                    this._cursor = null;
                    this._isScaling = false;
                }
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                this._cornerGuidePoints = [];
                var selectedGeometry = this.getSelectedFeaturesAsFeatureCollection(props); // Add buffer to the enveloping box if a single Point feature is selected
                if (this._isSinglePointGeometrySelected(selectedGeometry)) return {
                    type: "FeatureCollection",
                    features: []
                };
                var boundingBox = (0, $f844dcc60d4a8003$var$_bboxPolygon["default"])((0, $f844dcc60d4a8003$var$_bbox["default"])(selectedGeometry));
                boundingBox.properties.mode = "scale";
                var cornerGuidePoints = [];
                (0, $cJNDJ.coordEach)(boundingBox, function(coord, coordIndex) {
                    if (coordIndex < 4) {
                        // Get corner midpoint guides from the enveloping box
                        var cornerPoint = (0, $7GKQS.point)(coord, {
                            guideType: "editHandle",
                            editHandleType: "scale",
                            positionIndexes: [
                                coordIndex
                            ]
                        });
                        cornerGuidePoints.push(cornerPoint);
                    }
                });
                this._cornerGuidePoints = cornerGuidePoints; // @ts-ignore
                return (0, $7GKQS.featureCollection)([
                    (0, $f844dcc60d4a8003$var$_polygonToLine["default"])(boundingBox)
                ].concat($f844dcc60d4a8003$var$_toConsumableArray(this._cornerGuidePoints)));
            }
        }
    ]);
    return ScaleMode;
}($1tPZO.GeoJsonEditMode);
module.exports.ScaleMode = $f844dcc60d4a8003$var$ScaleMode;
function $f844dcc60d4a8003$var$getScaleFactor(centroid, startDragPoint, currentPoint) {
    var startDistance = (0, $f844dcc60d4a8003$var$_distance["default"])(centroid, startDragPoint);
    var endDistance = (0, $f844dcc60d4a8003$var$_distance["default"])(centroid, currentPoint);
    return endDistance / startDistance;
}

});
parcelRegister("d9r3a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7aiSl = parcelRequire("7aiSl");

var $7GKQS = parcelRequire("7GKQS");
/**
 * Takes one or more features and calculates the centroid using the mean of all vertices.
 * This lessens the effect of small islands and artifacts when calculating the centroid of a set of polygons.
 *
 * @name centroid
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional Parameters
 * @param {Object} [options.properties={}] an Object that is used as the {@link Feature}'s properties
 * @returns {Feature<Point>} the centroid of the input features
 * @example
 * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
 *
 * var centroid = turf.centroid(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, centroid]
 */ function $99311931cfda31eb$var$centroid(geojson, options) {
    if (options === void 0) options = {};
    var xSum = 0;
    var ySum = 0;
    var len = 0;
    $7aiSl.coordEach(geojson, function(coord) {
        xSum += coord[0];
        ySum += coord[1];
        len++;
    });
    return $7GKQS.point([
        xSum / len,
        ySum / len
    ], options.properties);
}
module.exports.default = $99311931cfda31eb$var$centroid;

});

parcelRegister("eGOxi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7GKQS = parcelRequire("7GKQS");

var $8abqV = parcelRequire("8abqV");
/**
 * Converts a {@link Polygon} to {@link LineString|(Multi)LineString} or {@link MultiPolygon} to a
 * {@link FeatureCollection} of {@link LineString|(Multi)LineString}.
 *
 * @name polygonToLine
 * @param {Feature<Polygon|MultiPolygon>} poly Feature to convert
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] translates GeoJSON properties to Feature
 * @returns {FeatureCollection|Feature<LineString|MultiLinestring>} converted (Multi)Polygon to (Multi)LineString
 * @example
 * var poly = turf.polygon([[[125, -30], [145, -30], [145, -20], [125, -20], [125, -30]]]);
 *
 * var line = turf.polygonToLine(poly);
 *
 * //addToMap
 * var addToMap = [line];
 */ function $ab1c305148a056ec$var$default_1(poly, options) {
    if (options === void 0) options = {};
    var geom = $8abqV.getGeom(poly);
    if (!options.properties && poly.type === "Feature") options.properties = poly.properties;
    switch(geom.type){
        case "Polygon":
            return $ab1c305148a056ec$var$polygonToLine(geom, options);
        case "MultiPolygon":
            return $ab1c305148a056ec$var$multiPolygonToLine(geom, options);
        default:
            throw new Error("invalid poly");
    }
}
module.exports.default = $ab1c305148a056ec$var$default_1;
/**
 * @private
 */ function $ab1c305148a056ec$var$polygonToLine(poly, options) {
    if (options === void 0) options = {};
    var geom = $8abqV.getGeom(poly);
    var type = geom.type;
    var coords = geom.coordinates;
    var properties = options.properties ? options.properties : poly.type === "Feature" ? poly.properties : {};
    return $ab1c305148a056ec$var$coordsToLine(coords, properties);
}
module.exports.polygonToLine = $ab1c305148a056ec$var$polygonToLine;
/**
 * @private
 */ function $ab1c305148a056ec$var$multiPolygonToLine(multiPoly, options) {
    if (options === void 0) options = {};
    var geom = $8abqV.getGeom(multiPoly);
    var type = geom.type;
    var coords = geom.coordinates;
    var properties = options.properties ? options.properties : multiPoly.type === "Feature" ? multiPoly.properties : {};
    var lines = [];
    coords.forEach(function(coord) {
        lines.push($ab1c305148a056ec$var$coordsToLine(coord, properties));
    });
    return $7GKQS.featureCollection(lines);
}
module.exports.multiPolygonToLine = $ab1c305148a056ec$var$multiPolygonToLine;
/**
 * @private
 */ function $ab1c305148a056ec$var$coordsToLine(coords, properties) {
    if (coords.length > 1) return $7GKQS.multiLineString(coords, properties);
    return $7GKQS.lineString(coords[0], properties);
}
module.exports.coordsToLine = $ab1c305148a056ec$var$coordsToLine;

});

parcelRegister("kYjHo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f448b1056658201d$export$2e2bcd8739ae039; });

var $asTyQ = parcelRequire("asTyQ");

var $ceONs = parcelRequire("ceONs");

var $2U63x = parcelRequire("2U63x");

var $8dXS4 = parcelRequire("8dXS4");

var $9QF0q = parcelRequire("9QF0q");

var $kYTRt = parcelRequire("kYTRt");

var $35NAj = parcelRequire("35NAj");

var $1Kxcv = parcelRequire("1Kxcv");

var $ulOUz = parcelRequire("ulOUz");

var $jNIoO = parcelRequire("jNIoO");
/**
 * Scale a GeoJSON from a given point by a factor of scaling (ex: factor=2 would make the GeoJSON 200% larger).
 * If a FeatureCollection is provided, the origin point will be calculated based on each individual Feature.
 *
 * @name transformScale
 * @param {GeoJSON} geojson GeoJSON to be scaled
 * @param {number} factor of scaling, positive or negative values greater than 0
 * @param {Object} [options={}] Optional parameters
 * @param {string|Coord} [options.origin='centroid'] Point from which the scaling will occur (string options: sw/se/nw/ne/center/centroid)
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} scaled GeoJSON
 * @example
 * var poly = turf.polygon([[[0,29],[3.5,29],[2.5,32],[0,29]]]);
 * var scaledPoly = turf.transformScale(poly, 3);
 *
 * //addToMap
 * var addToMap = [poly, scaledPoly];
 * scaledPoly.properties = {stroke: '#F00', 'stroke-width': 4};
 */ function $f448b1056658201d$var$transformScale(geojson, factor, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $ulOUz.isObject)(options)) throw new Error("options is invalid");
    var origin = options.origin;
    var mutate = options.mutate;
    // Input validation
    if (!geojson) throw new Error("geojson required");
    if (typeof factor !== "number" || factor === 0) throw new Error("invalid factor");
    var originIsPoint = Array.isArray(origin) || typeof origin === "object";
    // Clone geojson to avoid side effects
    if (mutate !== true) geojson = (0, $asTyQ.default)(geojson);
    // Scale each Feature separately
    if (geojson.type === "FeatureCollection" && !originIsPoint) {
        (0, $1Kxcv.featureEach)(geojson, function(feature, index) {
            geojson.features[index] = $f448b1056658201d$var$scale(feature, factor, origin);
        });
        return geojson;
    }
    // Scale Feature/Geometry
    return $f448b1056658201d$var$scale(geojson, factor, origin);
}
/**
 * Scale Feature/Geometry
 *
 * @private
 * @param {Feature|Geometry} feature GeoJSON Feature/Geometry
 * @param {number} factor of scaling, positive or negative values greater than 0
 * @param {string|Coord} [origin="centroid"] Point from which the scaling will occur (string options: sw/se/nw/ne/center/centroid)
 * @returns {Feature|Geometry} scaled GeoJSON Feature/Geometry
 */ function $f448b1056658201d$var$scale(feature, factor, origin) {
    // Default params
    var isPoint = (0, $jNIoO.getType)(feature) === "Point";
    origin = $f448b1056658201d$var$defineOrigin(feature, origin);
    // Shortcut no-scaling
    if (factor === 1 || isPoint) return feature;
    // Scale each coordinate
    (0, $1Kxcv.coordEach)(feature, function(coord) {
        var originalDistance = (0, $kYTRt.default)(origin, coord);
        var bearing = (0, $9QF0q.default)(origin, coord);
        var newDistance = originalDistance * factor;
        var newCoord = (0, $jNIoO.getCoords)((0, $35NAj.default)(origin, newDistance, bearing));
        coord[0] = newCoord[0];
        coord[1] = newCoord[1];
        if (coord.length === 3) coord[2] *= factor;
    });
    return feature;
}
/**
 * Define Origin
 *
 * @private
 * @param {GeoJSON} geojson GeoJSON
 * @param {string|Coord} origin sw/se/nw/ne/center/centroid
 * @returns {Feature<Point>} Point origin
 */ function $f448b1056658201d$var$defineOrigin(geojson, origin) {
    // Default params
    if (origin === undefined || origin === null) origin = "centroid";
    // Input Coord
    if (Array.isArray(origin) || typeof origin === "object") return (0, $jNIoO.getCoord)(origin);
    // Define BBox
    var bbox = geojson.bbox ? geojson.bbox : (0, $8dXS4.default)(geojson);
    var west = bbox[0];
    var south = bbox[1];
    var east = bbox[2];
    var north = bbox[3];
    switch(origin){
        case "sw":
        case "southwest":
        case "westsouth":
        case "bottomleft":
            return (0, $ulOUz.point)([
                west,
                south
            ]);
        case "se":
        case "southeast":
        case "eastsouth":
        case "bottomright":
            return (0, $ulOUz.point)([
                east,
                south
            ]);
        case "nw":
        case "northwest":
        case "westnorth":
        case "topleft":
            return (0, $ulOUz.point)([
                west,
                north
            ]);
        case "ne":
        case "northeast":
        case "eastnorth":
        case "topright":
            return (0, $ulOUz.point)([
                east,
                north
            ]);
        case "center":
            return (0, $ceONs.default)(geojson);
        case undefined:
        case null:
        case "centroid":
            return (0, $2U63x.default)(geojson);
        default:
            throw new Error("invalid origin");
    }
}
var $f448b1056658201d$export$2e2bcd8739ae039 = $f448b1056658201d$var$transformScale;

});
parcelRegister("ceONs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e8e31fdd4103f45$export$2e2bcd8739ae039; });

var $8dXS4 = parcelRequire("8dXS4");

var $ulOUz = parcelRequire("ulOUz");
/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the absolute center point of all features.
 *
 * @name center
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] an Object that is used as the {@link Feature}'s properties
 * @returns {Feature<Point>} a Point feature at the absolute center point of all input features
 * @example
 * var features = turf.featureCollection([
 *   turf.point( [-97.522259, 35.4691]),
 *   turf.point( [-97.502754, 35.463455]),
 *   turf.point( [-97.508269, 35.463245])
 * ]);
 *
 * var center = turf.center(features);
 *
 * //addToMap
 * var addToMap = [features, center]
 * center.properties['marker-size'] = 'large';
 * center.properties['marker-color'] = '#000';
 */ function $8e8e31fdd4103f45$var$center(geojson, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $ulOUz.isObject)(options)) throw new Error("options is invalid");
    var properties = options.properties;
    // Input validation
    if (!geojson) throw new Error("geojson is required");
    var ext = (0, $8dXS4.default)(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return (0, $ulOUz.point)([
        x,
        y
    ], properties);
}
var $8e8e31fdd4103f45$export$2e2bcd8739ae039 = $8e8e31fdd4103f45$var$center;

});
parcelRegister("8dXS4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fcdfac6c7690a60$export$2e2bcd8739ae039; });

var $1Kxcv = parcelRequire("1Kxcv");
/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */ function $5fcdfac6c7690a60$var$bbox(geojson) {
    var BBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $1Kxcv.coordEach)(geojson, function(coord) {
        if (BBox[0] > coord[0]) BBox[0] = coord[0];
        if (BBox[1] > coord[1]) BBox[1] = coord[1];
        if (BBox[2] < coord[0]) BBox[2] = coord[0];
        if (BBox[3] < coord[1]) BBox[3] = coord[1];
    });
    return BBox;
}
var $5fcdfac6c7690a60$export$2e2bcd8739ae039 = $5fcdfac6c7690a60$var$bbox;

});
parcelRegister("1Kxcv", function(module, exports) {

$parcel$export(module.exports, "coordEach", function () { return $1463d750ae67dc8e$export$6e011439fde007ae; });
$parcel$export(module.exports, "featureEach", function () { return $1463d750ae67dc8e$export$45a31c4de8035258; });

var $ulOUz = parcelRequire("ulOUz");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $1463d750ae67dc8e$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        if (geomType === "MultiPolygon") geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($1463d750ae67dc8e$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $1463d750ae67dc8e$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $1463d750ae67dc8e$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $1463d750ae67dc8e$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $1463d750ae67dc8e$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1463d750ae67dc8e$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $1463d750ae67dc8e$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $1463d750ae67dc8e$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1463d750ae67dc8e$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $1463d750ae67dc8e$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $1463d750ae67dc8e$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $1463d750ae67dc8e$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $1463d750ae67dc8e$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1463d750ae67dc8e$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $1463d750ae67dc8e$export$12cba8b31beb353b(geojson, callback) {
    $1463d750ae67dc8e$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $ulOUz.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $ulOUz.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $1463d750ae67dc8e$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1463d750ae67dc8e$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $1463d750ae67dc8e$export$d3ecc1efb2be121e(geojson, callback) {
    $1463d750ae67dc8e$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature$$1.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature$$1.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        if ($1463d750ae67dc8e$export$6e011439fde007ae(feature$$1, function(currentCoord, coordIndex, featureIndexCoord, mutliPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined) {
                previousCoords = currentCoord;
                return;
            }
            var currentSegment = (0, $ulOUz.lineString)([
                previousCoords,
                currentCoord
            ], feature$$1.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentInex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $1463d750ae67dc8e$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $1463d750ae67dc8e$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $1463d750ae67dc8e$export$985a91771cfc783d(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $1463d750ae67dc8e$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        if (feature$$1.geometry === null) return;
        var type = feature$$1.geometry.type;
        var coords = feature$$1.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature$$1, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $ulOUz.lineString)(coords[geometryIndex], feature$$1.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $1463d750ae67dc8e$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $1463d750ae67dc8e$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $1463d750ae67dc8e$export$2b6ba91fd8680d67(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $ulOUz.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $ulOUz.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $ulOUz.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $ulOUz.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $ulOUz.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $1463d750ae67dc8e$export$ed60ae5df1bac687(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $ulOUz.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $ulOUz.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $ulOUz.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $ulOUz.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $ulOUz.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $ulOUz.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $ulOUz.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

});
parcelRegister("ulOUz", function(module, exports) {

$parcel$export(module.exports, "feature", function () { return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264; });
$parcel$export(module.exports, "isObject", function () { return $05b3ba7bfb64fcde$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "point", function () { return $05b3ba7bfb64fcde$export$105684a3041cb6f3; });
$parcel$export(module.exports, "lineString", function () { return $05b3ba7bfb64fcde$export$98ec381bb06902c3; });
$parcel$export(module.exports, "isNumber", function () { return $05b3ba7bfb64fcde$export$7e4aa119212bc614; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $05b3ba7bfb64fcde$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $05b3ba7bfb64fcde$export$f929e47acbed771a = {
    meters: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f,
    metres: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f,
    millimeters: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f * 1000,
    millimetres: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f * 1000,
    centimeters: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f * 100,
    centimetres: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f * 100,
    kilometers: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f / 1000,
    kilometres: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f / 1000,
    miles: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f / 1852,
    inches: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f * 39.370,
    yards: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f / 1.0936,
    feet: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $05b3ba7bfb64fcde$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $05b3ba7bfb64fcde$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $05b3ba7bfb64fcde$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $05b3ba7bfb64fcde$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $05b3ba7bfb64fcde$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$05b3ba7bfb64fcde$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $05b3ba7bfb64fcde$export$28ac7bb8f5309bea(bbox);
    if (id) $05b3ba7bfb64fcde$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $05b3ba7bfb64fcde$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$05b3ba7bfb64fcde$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $05b3ba7bfb64fcde$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $05b3ba7bfb64fcde$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $05b3ba7bfb64fcde$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $05b3ba7bfb64fcde$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $05b3ba7bfb64fcde$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $05b3ba7bfb64fcde$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $05b3ba7bfb64fcde$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $05b3ba7bfb64fcde$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$05b3ba7bfb64fcde$export$7e4aa119212bc614(coordinates[0]) || !$05b3ba7bfb64fcde$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $05b3ba7bfb64fcde$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $05b3ba7bfb64fcde$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $05b3ba7bfb64fcde$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $05b3ba7bfb64fcde$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$05b3ba7bfb64fcde$export$7e4aa119212bc614(ring[0][0]) || !$05b3ba7bfb64fcde$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $05b3ba7bfb64fcde$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $05b3ba7bfb64fcde$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $05b3ba7bfb64fcde$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $05b3ba7bfb64fcde$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$05b3ba7bfb64fcde$export$7e4aa119212bc614(coordinates[0][1]) || !$05b3ba7bfb64fcde$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $05b3ba7bfb64fcde$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $05b3ba7bfb64fcde$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $05b3ba7bfb64fcde$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $05b3ba7bfb64fcde$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$05b3ba7bfb64fcde$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $05b3ba7bfb64fcde$export$28ac7bb8f5309bea(bbox);
    if (id) $05b3ba7bfb64fcde$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $05b3ba7bfb64fcde$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $05b3ba7bfb64fcde$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $05b3ba7bfb64fcde$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $05b3ba7bfb64fcde$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $05b3ba7bfb64fcde$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $05b3ba7bfb64fcde$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $05b3ba7bfb64fcde$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $05b3ba7bfb64fcde$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $05b3ba7bfb64fcde$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $05b3ba7bfb64fcde$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $05b3ba7bfb64fcde$export$c7a138e00a89bd01(distance, units) {
    return $05b3ba7bfb64fcde$export$c41dd2a8460d3196($05b3ba7bfb64fcde$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $05b3ba7bfb64fcde$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $05b3ba7bfb64fcde$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $05b3ba7bfb64fcde$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $05b3ba7bfb64fcde$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $05b3ba7bfb64fcde$export$f234631d6a2eedf8($05b3ba7bfb64fcde$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $05b3ba7bfb64fcde$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $05b3ba7bfb64fcde$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $05b3ba7bfb64fcde$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $05b3ba7bfb64fcde$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $05b3ba7bfb64fcde$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $05b3ba7bfb64fcde$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$05b3ba7bfb64fcde$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $05b3ba7bfb64fcde$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $05b3ba7bfb64fcde$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $05b3ba7bfb64fcde$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $05b3ba7bfb64fcde$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $05b3ba7bfb64fcde$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $05b3ba7bfb64fcde$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $05b3ba7bfb64fcde$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $05b3ba7bfb64fcde$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});




parcelRegister("2U63x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21d582520d741123$export$2e2bcd8739ae039; });

var $1Kxcv = parcelRequire("1Kxcv");

var $ulOUz = parcelRequire("ulOUz");
/**
 * Takes one or more features and calculates the centroid using the mean of all vertices.
 * This lessens the effect of small islands and artifacts when calculating the centroid of a set of polygons.
 *
 * @name centroid
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [properties={}] an Object that is used as the {@link Feature}'s properties
 * @returns {Feature<Point>} the centroid of the input features
 * @example
 * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
 *
 * var centroid = turf.centroid(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, centroid]
 */ function $21d582520d741123$var$centroid(geojson, properties) {
    var xSum = 0;
    var ySum = 0;
    var len = 0;
    (0, $1Kxcv.coordEach)(geojson, function(coord) {
        xSum += coord[0];
        ySum += coord[1];
        len++;
    }, true);
    return (0, $ulOUz.point)([
        xSum / len,
        ySum / len
    ], properties);
}
var $21d582520d741123$export$2e2bcd8739ae039 = $21d582520d741123$var$centroid;

});

parcelRegister("9QF0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72b8c751bc9305a8$export$2e2bcd8739ae039; });

var $cmN1X = parcelRequire("cmN1X");

var $ie4KC = parcelRequire("ie4KC");
// https://en.wikipedia.org/wiki/Rhumb_line
/**
 * Takes two {@link Point|points} and finds the bearing angle between them along a Rhumb line
 * i.e. the angle measured in degrees start the north line (0 degrees)
 *
 * @name rhumbBearing
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @param {Object} [options] Optional parameters
 * @param {boolean} [options.final=false] calculates the final bearing if true
 * @returns {number} bearing from north in decimal degrees, between -180 and 180 degrees (positive clockwise)
 * @example
 * var point1 = turf.point([-75.343, 39.984], {"marker-color": "#F00"});
 * var point2 = turf.point([-75.534, 39.123], {"marker-color": "#00F"});
 *
 * var bearing = turf.rhumbBearing(point1, point2);
 *
 * //addToMap
 * var addToMap = [point1, point2];
 * point1.properties.bearing = bearing;
 * point2.properties.bearing = bearing;
 */ function $72b8c751bc9305a8$var$rhumbBearing(start, end, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $ie4KC.isObject)(options)) throw new Error("options is invalid");
    var final = options.final;
    // validation
    if (!start) throw new Error("start point is required");
    if (!end) throw new Error("end point is required");
    var bear360;
    if (final) bear360 = $72b8c751bc9305a8$var$calculateRhumbBearing((0, $cmN1X.getCoord)(end), (0, $cmN1X.getCoord)(start));
    else bear360 = $72b8c751bc9305a8$var$calculateRhumbBearing((0, $cmN1X.getCoord)(start), (0, $cmN1X.getCoord)(end));
    var bear180 = bear360 > 180 ? -(360 - bear360) : bear360;
    return bear180;
}
/**
 * Returns the bearing from ‘this’ point to destination point along a rhumb line.
 * Adapted from Geodesy: https://github.com/chrisveness/geodesy/blob/master/latlon-spherical.js
 *
 * @private
 * @param   {Array<number>} from - origin point.
 * @param   {Array<number>} to - destination point.
 * @returns {number} Bearing in degrees from north.
 * @example
 * var p1 = new LatLon(51.127, 1.338);
 * var p2 = new LatLon(50.964, 1.853);
 * var d = p1.rhumbBearingTo(p2); // 116.7 m
 */ function $72b8c751bc9305a8$var$calculateRhumbBearing(from, to) {
    // φ => phi
    // Δλ => deltaLambda
    // Δψ => deltaPsi
    // θ => theta
    var phi1 = (0, $ie4KC.degreesToRadians)(from[1]);
    var phi2 = (0, $ie4KC.degreesToRadians)(to[1]);
    var deltaLambda = (0, $ie4KC.degreesToRadians)(to[0] - from[0]);
    // if deltaLambdaon over 180° take shorter rhumb line across the anti-meridian:
    if (deltaLambda > Math.PI) deltaLambda -= 2 * Math.PI;
    if (deltaLambda < -Math.PI) deltaLambda += 2 * Math.PI;
    var deltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var theta = Math.atan2(deltaLambda, deltaPsi);
    return ((0, $ie4KC.radiansToDegrees)(theta) + 360) % 360;
}
var $72b8c751bc9305a8$export$2e2bcd8739ae039 = $72b8c751bc9305a8$var$rhumbBearing;

});
parcelRegister("cmN1X", function(module, exports) {

$parcel$export(module.exports, "getCoord", function () { return $900d9291beba929e$export$b4663c6e64a770bc; });

var $ie4KC = parcelRequire("ie4KC");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $900d9291beba929e$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $900d9291beba929e$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $900d9291beba929e$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $ie4KC.isNumber)(coordinates[0]) && (0, $ie4KC.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $900d9291beba929e$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $900d9291beba929e$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $900d9291beba929e$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $900d9291beba929e$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $900d9291beba929e$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $900d9291beba929e$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $900d9291beba929e$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});
parcelRegister("ie4KC", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $d44d383889ae1f54$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isNumber", function () { return $d44d383889ae1f54$export$7e4aa119212bc614; });
$parcel$export(module.exports, "radiansToDegrees", function () { return $d44d383889ae1f54$export$c41dd2a8460d3196; });
$parcel$export(module.exports, "degreesToRadians", function () { return $d44d383889ae1f54$export$c9fcf1a7df975d78; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $d44d383889ae1f54$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $d44d383889ae1f54$export$f929e47acbed771a = {
    meters: $d44d383889ae1f54$export$e3a1ee0e9945697f,
    metres: $d44d383889ae1f54$export$e3a1ee0e9945697f,
    millimeters: $d44d383889ae1f54$export$e3a1ee0e9945697f * 1000,
    millimetres: $d44d383889ae1f54$export$e3a1ee0e9945697f * 1000,
    centimeters: $d44d383889ae1f54$export$e3a1ee0e9945697f * 100,
    centimetres: $d44d383889ae1f54$export$e3a1ee0e9945697f * 100,
    kilometers: $d44d383889ae1f54$export$e3a1ee0e9945697f / 1000,
    kilometres: $d44d383889ae1f54$export$e3a1ee0e9945697f / 1000,
    miles: $d44d383889ae1f54$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $d44d383889ae1f54$export$e3a1ee0e9945697f / 1852,
    inches: $d44d383889ae1f54$export$e3a1ee0e9945697f * 39.370,
    yards: $d44d383889ae1f54$export$e3a1ee0e9945697f / 1.0936,
    feet: $d44d383889ae1f54$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $d44d383889ae1f54$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $d44d383889ae1f54$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $d44d383889ae1f54$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $d44d383889ae1f54$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $d44d383889ae1f54$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$d44d383889ae1f54$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $d44d383889ae1f54$export$28ac7bb8f5309bea(bbox);
    if (id) $d44d383889ae1f54$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $d44d383889ae1f54$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$d44d383889ae1f54$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $d44d383889ae1f54$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $d44d383889ae1f54$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $d44d383889ae1f54$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $d44d383889ae1f54$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $d44d383889ae1f54$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $d44d383889ae1f54$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $d44d383889ae1f54$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $d44d383889ae1f54$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$d44d383889ae1f54$export$7e4aa119212bc614(coordinates[0]) || !$d44d383889ae1f54$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $d44d383889ae1f54$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $d44d383889ae1f54$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $d44d383889ae1f54$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $d44d383889ae1f54$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $d44d383889ae1f54$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$d44d383889ae1f54$export$7e4aa119212bc614(ring[0][0]) || !$d44d383889ae1f54$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $d44d383889ae1f54$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $d44d383889ae1f54$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $d44d383889ae1f54$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $d44d383889ae1f54$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $d44d383889ae1f54$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$d44d383889ae1f54$export$7e4aa119212bc614(coordinates[0][1]) || !$d44d383889ae1f54$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $d44d383889ae1f54$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $d44d383889ae1f54$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $d44d383889ae1f54$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $d44d383889ae1f54$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $d44d383889ae1f54$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$d44d383889ae1f54$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $d44d383889ae1f54$export$28ac7bb8f5309bea(bbox);
    if (id) $d44d383889ae1f54$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $d44d383889ae1f54$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $d44d383889ae1f54$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $d44d383889ae1f54$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $d44d383889ae1f54$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $d44d383889ae1f54$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $d44d383889ae1f54$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $d44d383889ae1f54$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $d44d383889ae1f54$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $d44d383889ae1f54$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $d44d383889ae1f54$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $d44d383889ae1f54$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $d44d383889ae1f54$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $d44d383889ae1f54$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $d44d383889ae1f54$export$c7a138e00a89bd01(distance, units) {
    return $d44d383889ae1f54$export$c41dd2a8460d3196($d44d383889ae1f54$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $d44d383889ae1f54$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $d44d383889ae1f54$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $d44d383889ae1f54$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $d44d383889ae1f54$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $d44d383889ae1f54$export$f234631d6a2eedf8($d44d383889ae1f54$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $d44d383889ae1f54$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $d44d383889ae1f54$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $d44d383889ae1f54$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $d44d383889ae1f54$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $d44d383889ae1f54$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $d44d383889ae1f54$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$d44d383889ae1f54$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $d44d383889ae1f54$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $d44d383889ae1f54$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $d44d383889ae1f54$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $d44d383889ae1f54$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $d44d383889ae1f54$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $d44d383889ae1f54$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $d44d383889ae1f54$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $d44d383889ae1f54$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});



parcelRegister("kYTRt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f464be2eac77db8e$export$2e2bcd8739ae039; });

var $4hSRO = parcelRequire("4hSRO");

var $g4VP6 = parcelRequire("g4VP6");
// https://en.wikipedia.org/wiki/Rhumb_line
/**
 * Calculates the distance along a rhumb line between two {@link Point|points} in degrees, radians,
 * miles, or kilometers.
 *
 * @name rhumbDistance
 * @param {Coord} from origin point
 * @param {Coord} to destination point
 * @param {Object} [options] Optional parameters
 * @param {string} [options.units="kilometers"] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.rhumbDistance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */ function $f464be2eac77db8e$var$rhumbDistance(from, to, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $4hSRO.isObject)(options)) throw new Error("options is invalid");
    var units = options.units;
    // validation
    if (!from) throw new Error("from point is required");
    if (!to) throw new Error("to point is required");
    var origin = (0, $g4VP6.getCoord)(from);
    var destination = (0, $g4VP6.getCoord)(to);
    // compensate the crossing of the 180th meridian (https://macwright.org/2016/09/26/the-180th-meridian.html)
    // solution from https://github.com/mapbox/mapbox-gl-js/issues/3250#issuecomment-294887678
    destination[0] += destination[0] - origin[0] > 180 ? -360 : origin[0] - destination[0] > 180 ? 360 : 0;
    var distanceInMeters = $f464be2eac77db8e$var$calculateRhumbDistance(origin, destination);
    var distance = (0, $4hSRO.convertLength)(distanceInMeters, "meters", units);
    return distance;
}
/**
 * Returns the distance travelling from ‘this’ point to destination point along a rhumb line.
 * Adapted from Geodesy: https://github.com/chrisveness/geodesy/blob/master/latlon-spherical.js
 *
 * @private
 * @param   {Array<number>} origin point.
 * @param   {Array<number>} destination point.
 * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
 * @returns {number} Distance in km between this point and destination point (same units as radius).
 *
 * @example
 *     var p1 = new LatLon(51.127, 1.338);
 *     var p2 = new LatLon(50.964, 1.853);
 *     var d = p1.distanceTo(p2); // 40.31 km
 */ function $f464be2eac77db8e$var$calculateRhumbDistance(origin, destination, radius) {
    // φ => phi
    // λ => lambda
    // ψ => psi
    // Δ => Delta
    // δ => delta
    // θ => theta
    radius = radius === undefined ? (0, $4hSRO.earthRadius) : Number(radius);
    // see www.edwilliams.org/avform.htm#Rhumb
    var R = radius;
    var phi1 = origin[1] * Math.PI / 180;
    var phi2 = destination[1] * Math.PI / 180;
    var DeltaPhi = phi2 - phi1;
    var DeltaLambda = Math.abs(destination[0] - origin[0]) * Math.PI / 180;
    // if dLon over 180° take shorter rhumb line across the anti-meridian:
    if (DeltaLambda > Math.PI) DeltaLambda -= 2 * Math.PI;
    // on Mercator projection, longitude distances shrink by latitude; q is the 'stretch factor'
    // q becomes ill-conditioned along E-W line (0/0); use empirical tolerance to avoid it
    var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
    // distance is pythagoras on 'stretched' Mercator projection
    var delta = Math.sqrt(DeltaPhi * DeltaPhi + q * q * DeltaLambda * DeltaLambda); // angular distance in radians
    var dist = delta * R;
    return dist;
}
var $f464be2eac77db8e$export$2e2bcd8739ae039 = $f464be2eac77db8e$var$rhumbDistance;

});
parcelRegister("4hSRO", function(module, exports) {

$parcel$export(module.exports, "earthRadius", function () { return $31f34f5dc68b727e$export$e3a1ee0e9945697f; });
$parcel$export(module.exports, "isObject", function () { return $31f34f5dc68b727e$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isNumber", function () { return $31f34f5dc68b727e$export$7e4aa119212bc614; });
$parcel$export(module.exports, "convertLength", function () { return $31f34f5dc68b727e$export$ea1536a749e80563; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $31f34f5dc68b727e$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $31f34f5dc68b727e$export$f929e47acbed771a = {
    meters: $31f34f5dc68b727e$export$e3a1ee0e9945697f,
    metres: $31f34f5dc68b727e$export$e3a1ee0e9945697f,
    millimeters: $31f34f5dc68b727e$export$e3a1ee0e9945697f * 1000,
    millimetres: $31f34f5dc68b727e$export$e3a1ee0e9945697f * 1000,
    centimeters: $31f34f5dc68b727e$export$e3a1ee0e9945697f * 100,
    centimetres: $31f34f5dc68b727e$export$e3a1ee0e9945697f * 100,
    kilometers: $31f34f5dc68b727e$export$e3a1ee0e9945697f / 1000,
    kilometres: $31f34f5dc68b727e$export$e3a1ee0e9945697f / 1000,
    miles: $31f34f5dc68b727e$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $31f34f5dc68b727e$export$e3a1ee0e9945697f / 1852,
    inches: $31f34f5dc68b727e$export$e3a1ee0e9945697f * 39.370,
    yards: $31f34f5dc68b727e$export$e3a1ee0e9945697f / 1.0936,
    feet: $31f34f5dc68b727e$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $31f34f5dc68b727e$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $31f34f5dc68b727e$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $31f34f5dc68b727e$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $31f34f5dc68b727e$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $31f34f5dc68b727e$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$31f34f5dc68b727e$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $31f34f5dc68b727e$export$28ac7bb8f5309bea(bbox);
    if (id) $31f34f5dc68b727e$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $31f34f5dc68b727e$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$31f34f5dc68b727e$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $31f34f5dc68b727e$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $31f34f5dc68b727e$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $31f34f5dc68b727e$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $31f34f5dc68b727e$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $31f34f5dc68b727e$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $31f34f5dc68b727e$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $31f34f5dc68b727e$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $31f34f5dc68b727e$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$31f34f5dc68b727e$export$7e4aa119212bc614(coordinates[0]) || !$31f34f5dc68b727e$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $31f34f5dc68b727e$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $31f34f5dc68b727e$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $31f34f5dc68b727e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $31f34f5dc68b727e$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $31f34f5dc68b727e$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$31f34f5dc68b727e$export$7e4aa119212bc614(ring[0][0]) || !$31f34f5dc68b727e$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $31f34f5dc68b727e$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $31f34f5dc68b727e$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $31f34f5dc68b727e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $31f34f5dc68b727e$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $31f34f5dc68b727e$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$31f34f5dc68b727e$export$7e4aa119212bc614(coordinates[0][1]) || !$31f34f5dc68b727e$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $31f34f5dc68b727e$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $31f34f5dc68b727e$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $31f34f5dc68b727e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $31f34f5dc68b727e$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $31f34f5dc68b727e$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$31f34f5dc68b727e$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $31f34f5dc68b727e$export$28ac7bb8f5309bea(bbox);
    if (id) $31f34f5dc68b727e$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $31f34f5dc68b727e$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $31f34f5dc68b727e$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $31f34f5dc68b727e$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $31f34f5dc68b727e$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $31f34f5dc68b727e$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $31f34f5dc68b727e$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $31f34f5dc68b727e$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $31f34f5dc68b727e$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $31f34f5dc68b727e$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $31f34f5dc68b727e$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $31f34f5dc68b727e$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $31f34f5dc68b727e$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $31f34f5dc68b727e$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $31f34f5dc68b727e$export$c7a138e00a89bd01(distance, units) {
    return $31f34f5dc68b727e$export$c41dd2a8460d3196($31f34f5dc68b727e$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $31f34f5dc68b727e$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $31f34f5dc68b727e$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $31f34f5dc68b727e$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $31f34f5dc68b727e$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $31f34f5dc68b727e$export$f234631d6a2eedf8($31f34f5dc68b727e$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $31f34f5dc68b727e$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $31f34f5dc68b727e$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $31f34f5dc68b727e$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $31f34f5dc68b727e$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $31f34f5dc68b727e$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $31f34f5dc68b727e$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$31f34f5dc68b727e$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $31f34f5dc68b727e$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $31f34f5dc68b727e$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $31f34f5dc68b727e$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $31f34f5dc68b727e$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $31f34f5dc68b727e$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $31f34f5dc68b727e$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $31f34f5dc68b727e$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $31f34f5dc68b727e$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});

parcelRegister("g4VP6", function(module, exports) {

$parcel$export(module.exports, "getCoord", function () { return $bb49df88c3a6a43c$export$b4663c6e64a770bc; });

var $4hSRO = parcelRequire("4hSRO");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $bb49df88c3a6a43c$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $bb49df88c3a6a43c$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $bb49df88c3a6a43c$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $4hSRO.isNumber)(coordinates[0]) && (0, $4hSRO.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $bb49df88c3a6a43c$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $bb49df88c3a6a43c$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $bb49df88c3a6a43c$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $bb49df88c3a6a43c$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $bb49df88c3a6a43c$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $bb49df88c3a6a43c$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $bb49df88c3a6a43c$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});


parcelRegister("jNIoO", function(module, exports) {

$parcel$export(module.exports, "getCoord", function () { return $e6a508b41b165edb$export$b4663c6e64a770bc; });
$parcel$export(module.exports, "getCoords", function () { return $e6a508b41b165edb$export$39e042fd83f1b62e; });
$parcel$export(module.exports, "getType", function () { return $e6a508b41b165edb$export$e2b5c5db9e2009fd; });

var $ulOUz = parcelRequire("ulOUz");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $e6a508b41b165edb$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $e6a508b41b165edb$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $e6a508b41b165edb$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $ulOUz.isNumber)(coordinates[0]) && (0, $ulOUz.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $e6a508b41b165edb$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $e6a508b41b165edb$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $e6a508b41b165edb$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $e6a508b41b165edb$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $e6a508b41b165edb$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $e6a508b41b165edb$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $e6a508b41b165edb$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});



parcelRegister("cjd37", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RotateMode = void 0;

var $8f6161b0b1fb2a2e$var$_bbox = $8f6161b0b1fb2a2e$var$_interopRequireDefault((parcelRequire("lX3Ya")));

var $8f6161b0b1fb2a2e$var$_centroid = $8f6161b0b1fb2a2e$var$_interopRequireDefault((parcelRequire("d9r3a")));

var $8f6161b0b1fb2a2e$var$_bearing = $8f6161b0b1fb2a2e$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $8f6161b0b1fb2a2e$var$_bboxPolygon = $8f6161b0b1fb2a2e$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $8f6161b0b1fb2a2e$var$_distance = $8f6161b0b1fb2a2e$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $cJNDJ = parcelRequire("cJNDJ");

var $8abqV = parcelRequire("8abqV");

var $7GKQS = parcelRequire("7GKQS");

var $8f6161b0b1fb2a2e$var$_transformRotate = $8f6161b0b1fb2a2e$var$_interopRequireDefault((parcelRequire("j6dRg")));

var $8f6161b0b1fb2a2e$var$_polygonToLine = $8f6161b0b1fb2a2e$var$_interopRequireDefault((parcelRequire("eGOxi")));

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");

var $eJgQU = parcelRequire("eJgQU");
function $8f6161b0b1fb2a2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8f6161b0b1fb2a2e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8f6161b0b1fb2a2e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8f6161b0b1fb2a2e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8f6161b0b1fb2a2e$var$_typeof(obj);
}
function $8f6161b0b1fb2a2e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8f6161b0b1fb2a2e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8f6161b0b1fb2a2e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8f6161b0b1fb2a2e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8f6161b0b1fb2a2e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8f6161b0b1fb2a2e$var$_createSuper(Derived) {
    return function() {
        var Super = $8f6161b0b1fb2a2e$var$_getPrototypeOf(Derived), result;
        if ($8f6161b0b1fb2a2e$var$_isNativeReflectConstruct()) {
            var NewTarget = $8f6161b0b1fb2a2e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8f6161b0b1fb2a2e$var$_possibleConstructorReturn(this, result);
    };
}
function $8f6161b0b1fb2a2e$var$_possibleConstructorReturn(self, call) {
    if (call && ($8f6161b0b1fb2a2e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8f6161b0b1fb2a2e$var$_assertThisInitialized(self);
}
function $8f6161b0b1fb2a2e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8f6161b0b1fb2a2e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8f6161b0b1fb2a2e$var$_getPrototypeOf(o) {
    $8f6161b0b1fb2a2e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8f6161b0b1fb2a2e$var$_getPrototypeOf(o);
}
function $8f6161b0b1fb2a2e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8f6161b0b1fb2a2e$var$_setPrototypeOf(subClass, superClass);
}
function $8f6161b0b1fb2a2e$var$_setPrototypeOf(o, p) {
    $8f6161b0b1fb2a2e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8f6161b0b1fb2a2e$var$_setPrototypeOf(o, p);
}
function $8f6161b0b1fb2a2e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8f6161b0b1fb2a2e$var$RotateMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $8f6161b0b1fb2a2e$var$_inherits(RotateMode, _GeoJsonEditMode);
    var _super = $8f6161b0b1fb2a2e$var$_createSuper(RotateMode);
    function RotateMode() {
        var _this;
        $8f6161b0b1fb2a2e$var$_classCallCheck(this, RotateMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $8f6161b0b1fb2a2e$var$_defineProperty($8f6161b0b1fb2a2e$var$_assertThisInitialized(_this), "_selectedEditHandle", void 0);
        $8f6161b0b1fb2a2e$var$_defineProperty($8f6161b0b1fb2a2e$var$_assertThisInitialized(_this), "_geometryBeingRotated", void 0);
        $8f6161b0b1fb2a2e$var$_defineProperty($8f6161b0b1fb2a2e$var$_assertThisInitialized(_this), "_isRotating", false);
        $8f6161b0b1fb2a2e$var$_defineProperty($8f6161b0b1fb2a2e$var$_assertThisInitialized(_this), "_isSinglePointGeometrySelected", function(geometry) {
            var _ref = geometry || {}, features = _ref.features;
            if (Array.isArray(features) && features.length === 1) {
                // @ts-ignore
                var _getGeom = (0, $8abqV.getGeom)(features[0]), type = _getGeom.type;
                return type === "Point";
            }
            return false;
        });
        $8f6161b0b1fb2a2e$var$_defineProperty($8f6161b0b1fb2a2e$var$_assertThisInitialized(_this), "getIsRotating", function() {
            return _this._isRotating;
        });
        return _this;
    }
    $8f6161b0b1fb2a2e$var$_createClass(RotateMode, [
        {
            key: "getGuides",
            value: function getGuides(props) {
                var selectedGeometry = this._geometryBeingRotated || this.getSelectedFeaturesAsFeatureCollection(props);
                if (this._isSinglePointGeometrySelected(selectedGeometry)) return {
                    type: "FeatureCollection",
                    features: []
                };
                if (this._isRotating) // Display rotate pivot
                return (0, $7GKQS.featureCollection)([
                    (0, $8f6161b0b1fb2a2e$var$_centroid["default"])(selectedGeometry)
                ]);
                var boundingBox = (0, $8f6161b0b1fb2a2e$var$_bboxPolygon["default"])((0, $8f6161b0b1fb2a2e$var$_bbox["default"])(selectedGeometry));
                var previousCoord = null;
                var topEdgeMidpointCoords = null;
                var longestEdgeLength = 0;
                (0, $cJNDJ.coordEach)(boundingBox, function(coord) {
                    if (previousCoord) {
                        // @ts-ignore
                        var edgeMidpoint = (0, $1tPZO.getIntermediatePosition)(coord, previousCoord);
                        if (!topEdgeMidpointCoords || edgeMidpoint[1] > topEdgeMidpointCoords[1]) // Get the top edge midpoint of the enveloping box
                        topEdgeMidpointCoords = edgeMidpoint;
                         // Get the length of the longest edge of the enveloping box
                        var edgeDistance = (0, $8f6161b0b1fb2a2e$var$_distance["default"])(coord, previousCoord);
                        longestEdgeLength = Math.max(longestEdgeLength, edgeDistance);
                    }
                    previousCoord = coord;
                }); // Scale the length of the line between the rotate handler and the enveloping box
                // relative to the length of the longest edge of the enveloping box
                var rotateHandleCoords = topEdgeMidpointCoords && [
                    topEdgeMidpointCoords[0],
                    topEdgeMidpointCoords[1] + longestEdgeLength / 1000
                ];
                var lineFromEnvelopeToRotateHandle = (0, $7GKQS.lineString)([
                    topEdgeMidpointCoords,
                    rotateHandleCoords
                ]);
                var rotateHandle = (0, $7GKQS.point)(rotateHandleCoords, {
                    guideType: "editHandle",
                    editHandleType: "rotate"
                }); // @ts-ignore
                return (0, $7GKQS.featureCollection)([
                    (0, $8f6161b0b1fb2a2e$var$_polygonToLine["default"])(boundingBox),
                    rotateHandle,
                    lineFromEnvelopeToRotateHandle
                ]);
            }
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                if (!this._isRotating) return;
                var rotateAction = this.getRotateAction(event.pointerDownMapCoords, event.mapCoords, "rotating", props);
                if (rotateAction) props.onEdit(rotateAction);
                event.cancelPan();
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                if (!this._isRotating) {
                    var selectedEditHandle = (0, $hs5Hv.getPickedEditHandle)(event.picks);
                    this._selectedEditHandle = selectedEditHandle && selectedEditHandle.properties.editHandleType === "rotate" ? selectedEditHandle : null;
                }
                this.updateCursor(props);
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                if (this._selectedEditHandle) {
                    this._isRotating = true;
                    this._geometryBeingRotated = this.getSelectedFeaturesAsFeatureCollection(props);
                }
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                if (this._isRotating) {
                    // Rotate the geometry
                    var rotateAction = this.getRotateAction(event.pointerDownMapCoords, event.mapCoords, "rotated", props);
                    if (rotateAction) props.onEdit(rotateAction);
                    this._geometryBeingRotated = null;
                    this._selectedEditHandle = null;
                    this._isRotating = false;
                }
            }
        },
        {
            key: "updateCursor",
            value: function updateCursor(props) {
                if (this._selectedEditHandle) // TODO: look at doing SVG cursors to get a better "rotate" cursor
                props.onUpdateCursor("crosshair");
                else props.onUpdateCursor(null);
            }
        },
        {
            key: "getRotateAction",
            value: function getRotateAction(startDragPoint, currentPoint, editType, props) {
                if (!this._geometryBeingRotated) return null;
                var centroid = (0, $8f6161b0b1fb2a2e$var$_centroid["default"])(this._geometryBeingRotated);
                var angle = $8f6161b0b1fb2a2e$var$getRotationAngle(centroid, startDragPoint, currentPoint); // @ts-ignore
                var rotatedFeatures = (0, $8f6161b0b1fb2a2e$var$_transformRotate["default"])(this._geometryBeingRotated, angle, {
                    pivot: centroid
                });
                var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data);
                var selectedIndexes = props.selectedIndexes;
                for(var i = 0; i < selectedIndexes.length; i++){
                    var selectedIndex = selectedIndexes[i];
                    var movedFeature = rotatedFeatures.features[i];
                    updatedData = updatedData.replaceGeometry(selectedIndex, movedFeature.geometry);
                }
                return {
                    updatedData: updatedData.getObject(),
                    editType: editType,
                    editContext: {
                        featureIndexes: selectedIndexes
                    }
                };
            }
        }
    ]);
    return RotateMode;
}($1tPZO.GeoJsonEditMode);
module.exports.RotateMode = $8f6161b0b1fb2a2e$var$RotateMode;
function $8f6161b0b1fb2a2e$var$getRotationAngle(centroid, startDragPoint, currentPoint) {
    var bearing1 = (0, $8f6161b0b1fb2a2e$var$_bearing["default"])(centroid, startDragPoint);
    var bearing2 = (0, $8f6161b0b1fb2a2e$var$_bearing["default"])(centroid, currentPoint);
    return bearing2 - bearing1;
}

});
parcelRegister("j6dRg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $03969a202747da77$export$2e2bcd8739ae039; });

var $lBPns = parcelRequire("lBPns");

var $9QF0q = parcelRequire("9QF0q");

var $kYTRt = parcelRequire("kYTRt");

var $35NAj = parcelRequire("35NAj");

var $asTyQ = parcelRequire("asTyQ");

var $h0rmX = parcelRequire("h0rmX");

var $4OmLb = parcelRequire("4OmLb");

var $4THjE = parcelRequire("4THjE");
/**
 * Rotates any geojson Feature or Geometry of a specified angle, around its `centroid` or a given `pivot` point;
 * all rotations follow the right-hand rule: https://en.wikipedia.org/wiki/Right-hand_rule
 *
 * @name transformRotate
 * @param {GeoJSON} geojson object to be rotated
 * @param {number} angle of rotation (along the vertical axis), from North in decimal degrees, negative clockwise
 * @param {Object} [options={}] Optional parameters
 * @param {Coord} [options.pivot='centroid'] point around which the rotation will be performed
 * @param {boolean} [options.mutate=false] allows GeoJSON input to be mutated (significant performance increase if true)
 * @returns {GeoJSON} the rotated GeoJSON feature
 * @example
 * var poly = turf.polygon([[[0,29],[3.5,29],[2.5,32],[0,29]]]);
 * var options = {pivot: [0, 25]};
 * var rotatedPoly = turf.transformRotate(poly, 10, options);
 *
 * //addToMap
 * var addToMap = [poly, rotatedPoly];
 * rotatedPoly.properties = {stroke: '#F00', 'stroke-width': 4};
 */ function $03969a202747da77$var$transformRotate(geojson, angle, options) {
    // Optional parameters
    options = options || {};
    if (!(0, $4THjE.isObject)(options)) throw new Error("options is invalid");
    var pivot = options.pivot;
    var mutate = options.mutate;
    // Input validation
    if (!geojson) throw new Error("geojson is required");
    if (angle === undefined || angle === null || isNaN(angle)) throw new Error("angle is required");
    // Shortcut no-rotation
    if (angle === 0) return geojson;
    // Use centroid of GeoJSON if pivot is not provided
    if (!pivot) pivot = (0, $lBPns.default)(geojson);
    // Clone geojson to avoid side effects
    if (mutate === false || mutate === undefined) geojson = (0, $asTyQ.default)(geojson);
    // Rotate each coordinate
    (0, $h0rmX.coordEach)(geojson, function(pointCoords) {
        var initialAngle = (0, $9QF0q.default)(pivot, pointCoords);
        var finalAngle = initialAngle + angle;
        var distance = (0, $kYTRt.default)(pivot, pointCoords);
        var newCoords = (0, $4OmLb.getCoords)((0, $35NAj.default)(pivot, distance, finalAngle));
        pointCoords[0] = newCoords[0];
        pointCoords[1] = newCoords[1];
    });
    return geojson;
}
var $03969a202747da77$export$2e2bcd8739ae039 = $03969a202747da77$var$transformRotate;

});
parcelRegister("lBPns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbb4e82a421a41d7$export$2e2bcd8739ae039; });

var $h0rmX = parcelRequire("h0rmX");

var $4THjE = parcelRequire("4THjE");
/**
 * Takes one or more features and calculates the centroid using the mean of all vertices.
 * This lessens the effect of small islands and artifacts when calculating the centroid of a set of polygons.
 *
 * @name centroid
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [properties={}] an Object that is used as the {@link Feature}'s properties
 * @returns {Feature<Point>} the centroid of the input features
 * @example
 * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
 *
 * var centroid = turf.centroid(polygon);
 *
 * //addToMap
 * var addToMap = [polygon, centroid]
 */ function $fbb4e82a421a41d7$var$centroid(geojson, properties) {
    var xSum = 0;
    var ySum = 0;
    var len = 0;
    (0, $h0rmX.coordEach)(geojson, function(coord) {
        xSum += coord[0];
        ySum += coord[1];
        len++;
    }, true);
    return (0, $4THjE.point)([
        xSum / len,
        ySum / len
    ], properties);
}
var $fbb4e82a421a41d7$export$2e2bcd8739ae039 = $fbb4e82a421a41d7$var$centroid;

});
parcelRegister("h0rmX", function(module, exports) {

$parcel$export(module.exports, "coordEach", function () { return $c617aab8255d729d$export$6e011439fde007ae; });

var $4THjE = parcelRequire("4THjE");
/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $c617aab8255d729d$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        if (geomType === "MultiPolygon") geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($c617aab8255d729d$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $c617aab8255d729d$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $c617aab8255d729d$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $c617aab8255d729d$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $c617aab8255d729d$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $c617aab8255d729d$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $c617aab8255d729d$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $c617aab8255d729d$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $c617aab8255d729d$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $c617aab8255d729d$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $c617aab8255d729d$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $c617aab8255d729d$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $c617aab8255d729d$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $c617aab8255d729d$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $c617aab8255d729d$export$12cba8b31beb353b(geojson, callback) {
    $c617aab8255d729d$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $4THjE.feature)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $4THjE.feature)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $c617aab8255d729d$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $c617aab8255d729d$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $c617aab8255d729d$export$d3ecc1efb2be121e(geojson, callback) {
    $c617aab8255d729d$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature$$1.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature$$1.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        if ($c617aab8255d729d$export$6e011439fde007ae(feature$$1, function(currentCoord, coordIndex, featureIndexCoord, mutliPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined) {
                previousCoords = currentCoord;
                return;
            }
            var currentSegment = (0, $4THjE.lineString)([
                previousCoords,
                currentCoord
            ], feature$$1.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentInex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $c617aab8255d729d$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $c617aab8255d729d$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $c617aab8255d729d$export$985a91771cfc783d(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $c617aab8255d729d$export$12cba8b31beb353b(geojson, function(feature$$1, featureIndex, multiFeatureIndex) {
        if (feature$$1.geometry === null) return;
        var type = feature$$1.geometry.type;
        var coords = feature$$1.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature$$1, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $4THjE.lineString)(coords[geometryIndex], feature$$1.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $c617aab8255d729d$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $c617aab8255d729d$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $c617aab8255d729d$export$2b6ba91fd8680d67(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $4THjE.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $4THjE.lineString)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $4THjE.lineString)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $4THjE.lineString)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $4THjE.lineString)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $c617aab8255d729d$export$ed60ae5df1bac687(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $4THjE.isObject)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $4THjE.point)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $4THjE.point)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $4THjE.point)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $4THjE.point)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $4THjE.point)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $4THjE.point)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}

});
parcelRegister("4THjE", function(module, exports) {

$parcel$export(module.exports, "feature", function () { return $390de6263a9949cf$export$ced6ed16dfd6a264; });
$parcel$export(module.exports, "isObject", function () { return $390de6263a9949cf$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "point", function () { return $390de6263a9949cf$export$105684a3041cb6f3; });
$parcel$export(module.exports, "lineString", function () { return $390de6263a9949cf$export$98ec381bb06902c3; });
$parcel$export(module.exports, "isNumber", function () { return $390de6263a9949cf$export$7e4aa119212bc614; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $390de6263a9949cf$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $390de6263a9949cf$export$f929e47acbed771a = {
    meters: $390de6263a9949cf$export$e3a1ee0e9945697f,
    metres: $390de6263a9949cf$export$e3a1ee0e9945697f,
    millimeters: $390de6263a9949cf$export$e3a1ee0e9945697f * 1000,
    millimetres: $390de6263a9949cf$export$e3a1ee0e9945697f * 1000,
    centimeters: $390de6263a9949cf$export$e3a1ee0e9945697f * 100,
    centimetres: $390de6263a9949cf$export$e3a1ee0e9945697f * 100,
    kilometers: $390de6263a9949cf$export$e3a1ee0e9945697f / 1000,
    kilometres: $390de6263a9949cf$export$e3a1ee0e9945697f / 1000,
    miles: $390de6263a9949cf$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $390de6263a9949cf$export$e3a1ee0e9945697f / 1852,
    inches: $390de6263a9949cf$export$e3a1ee0e9945697f * 39.370,
    yards: $390de6263a9949cf$export$e3a1ee0e9945697f / 1.0936,
    feet: $390de6263a9949cf$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $390de6263a9949cf$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $390de6263a9949cf$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $390de6263a9949cf$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $390de6263a9949cf$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $390de6263a9949cf$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$390de6263a9949cf$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $390de6263a9949cf$export$28ac7bb8f5309bea(bbox);
    if (id) $390de6263a9949cf$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $390de6263a9949cf$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$390de6263a9949cf$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $390de6263a9949cf$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $390de6263a9949cf$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $390de6263a9949cf$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $390de6263a9949cf$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $390de6263a9949cf$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $390de6263a9949cf$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $390de6263a9949cf$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $390de6263a9949cf$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$390de6263a9949cf$export$7e4aa119212bc614(coordinates[0]) || !$390de6263a9949cf$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $390de6263a9949cf$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $390de6263a9949cf$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $390de6263a9949cf$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $390de6263a9949cf$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $390de6263a9949cf$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$390de6263a9949cf$export$7e4aa119212bc614(ring[0][0]) || !$390de6263a9949cf$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $390de6263a9949cf$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $390de6263a9949cf$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $390de6263a9949cf$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $390de6263a9949cf$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $390de6263a9949cf$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$390de6263a9949cf$export$7e4aa119212bc614(coordinates[0][1]) || !$390de6263a9949cf$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $390de6263a9949cf$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $390de6263a9949cf$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $390de6263a9949cf$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $390de6263a9949cf$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $390de6263a9949cf$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$390de6263a9949cf$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $390de6263a9949cf$export$28ac7bb8f5309bea(bbox);
    if (id) $390de6263a9949cf$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $390de6263a9949cf$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $390de6263a9949cf$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $390de6263a9949cf$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $390de6263a9949cf$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $390de6263a9949cf$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $390de6263a9949cf$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $390de6263a9949cf$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $390de6263a9949cf$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $390de6263a9949cf$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $390de6263a9949cf$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $390de6263a9949cf$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $390de6263a9949cf$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $390de6263a9949cf$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $390de6263a9949cf$export$c7a138e00a89bd01(distance, units) {
    return $390de6263a9949cf$export$c41dd2a8460d3196($390de6263a9949cf$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $390de6263a9949cf$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $390de6263a9949cf$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $390de6263a9949cf$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $390de6263a9949cf$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $390de6263a9949cf$export$f234631d6a2eedf8($390de6263a9949cf$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $390de6263a9949cf$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $390de6263a9949cf$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $390de6263a9949cf$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $390de6263a9949cf$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $390de6263a9949cf$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $390de6263a9949cf$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$390de6263a9949cf$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $390de6263a9949cf$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $390de6263a9949cf$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $390de6263a9949cf$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $390de6263a9949cf$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $390de6263a9949cf$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $390de6263a9949cf$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $390de6263a9949cf$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $390de6263a9949cf$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});



parcelRegister("4OmLb", function(module, exports) {

$parcel$export(module.exports, "getCoords", function () { return $380d7c958fe06b23$export$39e042fd83f1b62e; });

var $4THjE = parcelRequire("4THjE");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $380d7c958fe06b23$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $380d7c958fe06b23$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $380d7c958fe06b23$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $4THjE.isNumber)(coordinates[0]) && (0, $4THjE.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $380d7c958fe06b23$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $380d7c958fe06b23$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $380d7c958fe06b23$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $380d7c958fe06b23$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $380d7c958fe06b23$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $380d7c958fe06b23$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $380d7c958fe06b23$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});



parcelRegister("44vWS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DuplicateMode = void 0;

var $lWzrG = parcelRequire("lWzrG");
function $2f70517a7f5bb8b4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2f70517a7f5bb8b4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2f70517a7f5bb8b4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2f70517a7f5bb8b4$var$_typeof(obj);
}
function $2f70517a7f5bb8b4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2f70517a7f5bb8b4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2f70517a7f5bb8b4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2f70517a7f5bb8b4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2f70517a7f5bb8b4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2f70517a7f5bb8b4$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $2f70517a7f5bb8b4$var$_get = Reflect.get;
    else $2f70517a7f5bb8b4$var$_get = function _get(target, property, receiver) {
        var base = $2f70517a7f5bb8b4$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $2f70517a7f5bb8b4$var$_get(target, property, receiver || target);
}
function $2f70517a7f5bb8b4$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $2f70517a7f5bb8b4$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $2f70517a7f5bb8b4$var$_createSuper(Derived) {
    return function() {
        var Super = $2f70517a7f5bb8b4$var$_getPrototypeOf(Derived), result;
        if ($2f70517a7f5bb8b4$var$_isNativeReflectConstruct()) {
            var NewTarget = $2f70517a7f5bb8b4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2f70517a7f5bb8b4$var$_possibleConstructorReturn(this, result);
    };
}
function $2f70517a7f5bb8b4$var$_possibleConstructorReturn(self, call) {
    if (call && ($2f70517a7f5bb8b4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $2f70517a7f5bb8b4$var$_assertThisInitialized(self);
}
function $2f70517a7f5bb8b4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2f70517a7f5bb8b4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2f70517a7f5bb8b4$var$_getPrototypeOf(o) {
    $2f70517a7f5bb8b4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2f70517a7f5bb8b4$var$_getPrototypeOf(o);
}
function $2f70517a7f5bb8b4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2f70517a7f5bb8b4$var$_setPrototypeOf(subClass, superClass);
}
function $2f70517a7f5bb8b4$var$_setPrototypeOf(o, p) {
    $2f70517a7f5bb8b4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2f70517a7f5bb8b4$var$_setPrototypeOf(o, p);
}
var $2f70517a7f5bb8b4$var$DuplicateMode = /*#__PURE__*/ function(_TranslateMode) {
    $2f70517a7f5bb8b4$var$_inherits(DuplicateMode, _TranslateMode);
    var _super = $2f70517a7f5bb8b4$var$_createSuper(DuplicateMode);
    function DuplicateMode() {
        $2f70517a7f5bb8b4$var$_classCallCheck(this, DuplicateMode);
        return _super.apply(this, arguments);
    }
    $2f70517a7f5bb8b4$var$_createClass(DuplicateMode, [
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                $2f70517a7f5bb8b4$var$_get($2f70517a7f5bb8b4$var$_getPrototypeOf(DuplicateMode.prototype), "handleStartDragging", this).call(this, event, props);
                if (this._geometryBeforeTranslate) props.onEdit(this.getAddManyFeaturesAction(this._geometryBeforeTranslate, props.data));
            }
        },
        {
            key: "updateCursor",
            value: function updateCursor(props) {
                if (this._isTranslatable) props.onUpdateCursor("copy");
                else props.onUpdateCursor(null);
            }
        }
    ]);
    return DuplicateMode;
}($lWzrG.TranslateMode);
module.exports.DuplicateMode = $2f70517a7f5bb8b4$var$DuplicateMode;

});

parcelRegister("iS49Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendLineStringMode = void 0;

var $1tPZO = parcelRequire("1tPZO");

var $eJgQU = parcelRequire("eJgQU");
function $dbd07eca1b13c5a6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dbd07eca1b13c5a6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dbd07eca1b13c5a6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dbd07eca1b13c5a6$var$_typeof(obj);
}
function $dbd07eca1b13c5a6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dbd07eca1b13c5a6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dbd07eca1b13c5a6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dbd07eca1b13c5a6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dbd07eca1b13c5a6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dbd07eca1b13c5a6$var$_createSuper(Derived) {
    return function() {
        var Super = $dbd07eca1b13c5a6$var$_getPrototypeOf(Derived), result;
        if ($dbd07eca1b13c5a6$var$_isNativeReflectConstruct()) {
            var NewTarget = $dbd07eca1b13c5a6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dbd07eca1b13c5a6$var$_possibleConstructorReturn(this, result);
    };
}
function $dbd07eca1b13c5a6$var$_possibleConstructorReturn(self, call) {
    if (call && ($dbd07eca1b13c5a6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $dbd07eca1b13c5a6$var$_assertThisInitialized(self);
}
function $dbd07eca1b13c5a6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dbd07eca1b13c5a6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dbd07eca1b13c5a6$var$_getPrototypeOf(o) {
    $dbd07eca1b13c5a6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dbd07eca1b13c5a6$var$_getPrototypeOf(o);
}
function $dbd07eca1b13c5a6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dbd07eca1b13c5a6$var$_setPrototypeOf(subClass, superClass);
}
function $dbd07eca1b13c5a6$var$_setPrototypeOf(o, p) {
    $dbd07eca1b13c5a6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dbd07eca1b13c5a6$var$_setPrototypeOf(o, p);
}
var $dbd07eca1b13c5a6$var$ExtendLineStringMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $dbd07eca1b13c5a6$var$_inherits(ExtendLineStringMode, _GeoJsonEditMode);
    var _super = $dbd07eca1b13c5a6$var$_createSuper(ExtendLineStringMode);
    function ExtendLineStringMode() {
        $dbd07eca1b13c5a6$var$_classCallCheck(this, ExtendLineStringMode);
        return _super.apply(this, arguments);
    }
    $dbd07eca1b13c5a6$var$_createClass(ExtendLineStringMode, [
        {
            key: "getSingleSelectedLineString",
            value: function getSingleSelectedLineString(props) {
                var selectedGeometry = this.getSelectedGeometry(props);
                if (selectedGeometry && selectedGeometry.type === "LineString") return selectedGeometry;
                return null;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var selectedIndexes = props.selectedIndexes;
                var selectedLineString = this.getSingleSelectedLineString(props);
                if (!selectedLineString) {
                    console.warn("ExtendLineStringMode only supported for single LineString selection"); // eslint-disable-line
                    return;
                } // Extend the LineString
                var positionIndexes = [
                    selectedLineString.coordinates.length
                ];
                var modeConfig = props.modeConfig;
                if (modeConfig && modeConfig.drawAtFront) positionIndexes = [
                    0
                ];
                var featureIndex = selectedIndexes[0];
                var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).addPosition(featureIndex, positionIndexes, event.mapCoords).getObject();
                props.onEdit({
                    updatedData: updatedData,
                    editType: "addPosition",
                    editContext: {
                        featureIndexes: [
                            featureIndex
                        ],
                        positionIndexes: positionIndexes,
                        position: event.mapCoords
                    }
                });
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                var selectedLineString = this.getSingleSelectedLineString(props);
                if (!selectedLineString) // nothing to do
                // @ts-ignore
                return guides;
                var mapCoords = props.lastPointerMoveEvent && props.lastPointerMoveEvent.mapCoords; // Draw an extension line starting from one end of the selected LineString to the cursor
                var startPosition = null;
                var modeConfig = props.modeConfig;
                if (modeConfig && modeConfig.drawAtFront) startPosition = selectedLineString.coordinates[0];
                else startPosition = selectedLineString.coordinates[selectedLineString.coordinates.length - 1];
                guides.features.push({
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [
                            startPosition,
                            mapCoords
                        ]
                    }
                }); // @ts-ignore
                return guides;
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
            }
        }
    ]);
    return ExtendLineStringMode;
}($1tPZO.GeoJsonEditMode);
module.exports.ExtendLineStringMode = $dbd07eca1b13c5a6$var$ExtendLineStringMode;

});

parcelRegister("jW3FH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SplitPolygonMode = void 0;

var $e836482f156ba68c$var$_booleanPointInPolygon = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("fAAQU")));

var $e836482f156ba68c$var$_difference = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("gZv4c")));

var $e836482f156ba68c$var$_buffer = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("3qree")));

var $e836482f156ba68c$var$_lineIntersect = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("iXvoQ")));

var $7GKQS = parcelRequire("7GKQS");

var $e836482f156ba68c$var$_bearing = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $e836482f156ba68c$var$_distance = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $e836482f156ba68c$var$_destination = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("1UAWS")));

var $e836482f156ba68c$var$_polygonToLine = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("eGOxi")));

var $e836482f156ba68c$var$_nearestPointOnLine = $e836482f156ba68c$var$_interopRequireDefault((parcelRequire("ecyJ3")));

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");

var $eJgQU = parcelRequire("eJgQU");
function $e836482f156ba68c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e836482f156ba68c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e836482f156ba68c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e836482f156ba68c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e836482f156ba68c$var$_typeof(obj);
}
function $e836482f156ba68c$var$_toConsumableArray(arr) {
    return $e836482f156ba68c$var$_arrayWithoutHoles(arr) || $e836482f156ba68c$var$_iterableToArray(arr) || $e836482f156ba68c$var$_unsupportedIterableToArray(arr) || $e836482f156ba68c$var$_nonIterableSpread();
}
function $e836482f156ba68c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e836482f156ba68c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $e836482f156ba68c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e836482f156ba68c$var$_arrayLikeToArray(arr);
}
function $e836482f156ba68c$var$_slicedToArray(arr, i) {
    return $e836482f156ba68c$var$_arrayWithHoles(arr) || $e836482f156ba68c$var$_iterableToArrayLimit(arr, i) || $e836482f156ba68c$var$_unsupportedIterableToArray(arr, i) || $e836482f156ba68c$var$_nonIterableRest();
}
function $e836482f156ba68c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e836482f156ba68c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e836482f156ba68c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e836482f156ba68c$var$_arrayLikeToArray(o, minLen);
}
function $e836482f156ba68c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e836482f156ba68c$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e836482f156ba68c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e836482f156ba68c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e836482f156ba68c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e836482f156ba68c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e836482f156ba68c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e836482f156ba68c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e836482f156ba68c$var$_createSuper(Derived) {
    return function() {
        var Super = $e836482f156ba68c$var$_getPrototypeOf(Derived), result;
        if ($e836482f156ba68c$var$_isNativeReflectConstruct()) {
            var NewTarget = $e836482f156ba68c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e836482f156ba68c$var$_possibleConstructorReturn(this, result);
    };
}
function $e836482f156ba68c$var$_possibleConstructorReturn(self, call) {
    if (call && ($e836482f156ba68c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e836482f156ba68c$var$_assertThisInitialized(self);
}
function $e836482f156ba68c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e836482f156ba68c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e836482f156ba68c$var$_getPrototypeOf(o) {
    $e836482f156ba68c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e836482f156ba68c$var$_getPrototypeOf(o);
}
function $e836482f156ba68c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e836482f156ba68c$var$_setPrototypeOf(subClass, superClass);
}
function $e836482f156ba68c$var$_setPrototypeOf(o, p) {
    $e836482f156ba68c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e836482f156ba68c$var$_setPrototypeOf(o, p);
}
var $e836482f156ba68c$var$SplitPolygonMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $e836482f156ba68c$var$_inherits(SplitPolygonMode, _GeoJsonEditMode);
    var _super = $e836482f156ba68c$var$_createSuper(SplitPolygonMode);
    function SplitPolygonMode() {
        $e836482f156ba68c$var$_classCallCheck(this, SplitPolygonMode);
        return _super.apply(this, arguments);
    }
    $e836482f156ba68c$var$_createClass(SplitPolygonMode, [
        {
            key: "calculateMapCoords",
            value: function calculateMapCoords(clickSequence, mapCoords, props) {
                var modeConfig = props.modeConfig;
                if (!modeConfig || !modeConfig.lock90Degree || !clickSequence.length) return mapCoords;
                if (clickSequence.length === 1) {
                    // if first point is clicked, then find closest polygon point and build ~90deg vector
                    var firstPoint = clickSequence[0];
                    var selectedGeometry = this.getSelectedGeometry(props); // @ts-ignore
                    var feature = (0, $e836482f156ba68c$var$_polygonToLine["default"])(selectedGeometry);
                    var lines = feature.type === "FeatureCollection" ? feature.features : [
                        feature
                    ];
                    var minDistance = Number.MAX_SAFE_INTEGER;
                    var closestPoint = null; // If Multipolygon, then we should find nearest polygon line and stick split to it.
                    lines.forEach(function(line) {
                        var snapPoint = (0, $e836482f156ba68c$var$_nearestPointOnLine["default"])(line, firstPoint);
                        var distanceFromOrigin = (0, $e836482f156ba68c$var$_distance["default"])(snapPoint, firstPoint);
                        if (minDistance > distanceFromOrigin) {
                            minDistance = distanceFromOrigin;
                            closestPoint = snapPoint;
                        }
                    });
                    if (closestPoint) {
                        // closest point is used as 90degree entry to the polygon
                        var lastBearing = (0, $e836482f156ba68c$var$_bearing["default"])(firstPoint, closestPoint);
                        var currentDistance = (0, $e836482f156ba68c$var$_distance["default"])(firstPoint, mapCoords, {
                            units: "meters"
                        });
                        return (0, $e836482f156ba68c$var$_destination["default"])(firstPoint, currentDistance, lastBearing, {
                            units: "meters"
                        }).geometry.coordinates;
                    }
                    return mapCoords;
                } // Allow only 90 degree turns
                var lastPoint = clickSequence[clickSequence.length - 1];
                var _generatePointsParall = (0, $hs5Hv.generatePointsParallelToLinePoints)(clickSequence[clickSequence.length - 2], lastPoint, mapCoords), _generatePointsParall2 = $e836482f156ba68c$var$_slicedToArray(_generatePointsParall, 1), approximatePoint = _generatePointsParall2[0]; // align point with current ground
                var nearestPt = (0, $e836482f156ba68c$var$_nearestPointOnLine["default"])((0, $7GKQS.lineString)([
                    lastPoint,
                    approximatePoint
                ]), mapCoords).geometry.coordinates;
                return nearestPt;
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var clickSequence = this.getClickSequence();
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                if (clickSequence.length === 0 || !props.lastPointerMoveEvent) // nothing to do yet
                return guides;
                var mapCoords = props.lastPointerMoveEvent.mapCoords;
                guides.features.push({
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [].concat($e836482f156ba68c$var$_toConsumableArray(clickSequence), [
                            this.calculateMapCoords(clickSequence, mapCoords, props)
                        ])
                    }
                });
                return guides;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var tentativeFeature = this.getTentativeGuide(props);
                var selectedGeometry = this.getSelectedGeometry(props);
                if (!selectedGeometry) {
                    // eslint-disable-next-line no-console,no-undef
                    console.warn("A polygon must be selected for splitting");
                    return;
                }
                var clickSequence = this.getClickSequence();
                if (tentativeFeature && tentativeFeature.geometry.type === "LineString") clickSequence.push(tentativeFeature.geometry.coordinates[tentativeFeature.geometry.coordinates.length - 1]);
                else this.addClickSequence(event);
                var pt = {
                    type: "Point",
                    coordinates: clickSequence[clickSequence.length - 1]
                }; // @ts-ignore
                var isPointInPolygon = (0, $e836482f156ba68c$var$_booleanPointInPolygon["default"])(pt, selectedGeometry);
                if (clickSequence.length > 1 && tentativeFeature && !isPointInPolygon) {
                    this.resetClickSequence(); // @ts-ignore
                    var isLineInterectingWithPolygon = (0, $e836482f156ba68c$var$_lineIntersect["default"])(tentativeFeature, selectedGeometry);
                    if (isLineInterectingWithPolygon.features.length === 0) return;
                    var editAction = this.splitPolygon(tentativeFeature, props);
                    if (editAction) props.onEdit(editAction);
                }
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
            }
        },
        {
            key: "splitPolygon",
            value: function splitPolygon(tentativeFeature, props) {
                var selectedGeometry = this.getSelectedGeometry(props);
                var featureIndex = props.selectedIndexes[0];
                var modeConfig = props.modeConfig || {}; // Default gap in between the polygon
                var _modeConfig$gap = modeConfig.gap, gap = _modeConfig$gap === void 0 ? 0.1 : _modeConfig$gap, _modeConfig$units = modeConfig.units, units = _modeConfig$units === void 0 ? "centimeters" : _modeConfig$units;
                if (gap === 0) {
                    gap = 0.1;
                    units = "centimeters";
                }
                var buffer = (0, $e836482f156ba68c$var$_buffer["default"])(tentativeFeature, gap, {
                    units: units
                }); // @ts-ignore
                var updatedGeometry = (0, $e836482f156ba68c$var$_difference["default"])(selectedGeometry, buffer);
                if (!updatedGeometry) {
                    // eslint-disable-next-line no-console,no-undef
                    console.warn("Canceling edit. Split Polygon erased");
                    return null;
                }
                var _updatedGeometry$geom = updatedGeometry.geometry, type = _updatedGeometry$geom.type, coordinates = _updatedGeometry$geom.coordinates;
                var updatedCoordinates = [];
                if (type === "Polygon") // Update the coordinates as per Multipolygon
                // @ts-ignore
                updatedCoordinates = coordinates.map(function(c) {
                    return [
                        c
                    ];
                });
                else // Handle Case when Multipolygon has holes
                // @ts-ignore
                updatedCoordinates = coordinates.reduce(function(agg, prev) {
                    prev.forEach(function(p) {
                        agg.push([
                            p
                        ]);
                    });
                    return agg;
                }, []);
                 // Update the type to Mulitpolygon
                var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).replaceGeometry(featureIndex, {
                    type: "MultiPolygon",
                    coordinates: updatedCoordinates
                });
                var editAction = {
                    updatedData: updatedData.getObject(),
                    editType: "split",
                    editContext: {
                        featureIndexes: [
                            featureIndex
                        ]
                    }
                };
                return editAction;
            }
        }
    ]);
    return SplitPolygonMode;
}($1tPZO.GeoJsonEditMode);
module.exports.SplitPolygonMode = $e836482f156ba68c$var$SplitPolygonMode;

});
parcelRegister("fAAQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8abqV = parcelRequire("8abqV");
// http://en.wikipedia.org/wiki/Even%E2%80%93odd_rule
// modified from: https://github.com/substack/point-in-polygon/blob/master/index.js
// which was modified from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
/**
 * Takes a {@link Point} and a {@link Polygon} or {@link MultiPolygon} and determines if the point
 * resides inside the polygon. The polygon can be convex or concave. The function accounts for holes.
 *
 * @name booleanPointInPolygon
 * @param {Coord} point input point
 * @param {Feature<Polygon|MultiPolygon>} polygon input polygon or multipolygon
 * @param {Object} [options={}] Optional parameters
 * @param {boolean} [options.ignoreBoundary=false] True if polygon boundary should be ignored when determining if
 * the point is inside the polygon otherwise false.
 * @returns {boolean} `true` if the Point is inside the Polygon; `false` if the Point is not inside the Polygon
 * @example
 * var pt = turf.point([-77, 44]);
 * var poly = turf.polygon([[
 *   [-81, 41],
 *   [-81, 47],
 *   [-72, 47],
 *   [-72, 41],
 *   [-81, 41]
 * ]]);
 *
 * turf.booleanPointInPolygon(pt, poly);
 * //= true
 */ function $b596cdec7d82c4c3$var$booleanPointInPolygon(point, polygon, options) {
    if (options === void 0) options = {};
    // validation
    if (!point) throw new Error("point is required");
    if (!polygon) throw new Error("polygon is required");
    var pt = $8abqV.getCoord(point);
    var geom = $8abqV.getGeom(polygon);
    var type = geom.type;
    var bbox = polygon.bbox;
    var polys = geom.coordinates;
    // Quick elimination if point is not inside bbox
    if (bbox && $b596cdec7d82c4c3$var$inBBox(pt, bbox) === false) return false;
    // normalize to multipolygon
    if (type === "Polygon") polys = [
        polys
    ];
    var insidePoly = false;
    for(var i = 0; i < polys.length && !insidePoly; i++)// check if it is in the outer ring first
    if ($b596cdec7d82c4c3$var$inRing(pt, polys[i][0], options.ignoreBoundary)) {
        var inHole = false;
        var k = 1;
        // check for the point in any of the holes
        while(k < polys[i].length && !inHole){
            if ($b596cdec7d82c4c3$var$inRing(pt, polys[i][k], !options.ignoreBoundary)) inHole = true;
            k++;
        }
        if (!inHole) insidePoly = true;
    }
    return insidePoly;
}
module.exports.default = $b596cdec7d82c4c3$var$booleanPointInPolygon;
/**
 * inRing
 *
 * @private
 * @param {Array<number>} pt [x,y]
 * @param {Array<Array<number>>} ring [[x,y], [x,y],..]
 * @param {boolean} ignoreBoundary ignoreBoundary
 * @returns {boolean} inRing
 */ function $b596cdec7d82c4c3$var$inRing(pt, ring, ignoreBoundary) {
    var isInside = false;
    if (ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1]) ring = ring.slice(0, ring.length - 1);
    for(var i = 0, j = ring.length - 1; i < ring.length; j = i++){
        var xi = ring[i][0];
        var yi = ring[i][1];
        var xj = ring[j][0];
        var yj = ring[j][1];
        var onBoundary = pt[1] * (xi - xj) + yi * (xj - pt[0]) + yj * (pt[0] - xi) === 0 && (xi - pt[0]) * (xj - pt[0]) <= 0 && (yi - pt[1]) * (yj - pt[1]) <= 0;
        if (onBoundary) return !ignoreBoundary;
        var intersect = yi > pt[1] !== yj > pt[1] && pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
/**
 * inBBox
 *
 * @private
 * @param {Position} pt point [x,y]
 * @param {BBox} bbox BBox [west, south, east, north]
 * @returns {boolean} true/false if point is inside BBox
 */ function $b596cdec7d82c4c3$var$inBBox(pt, bbox) {
    return bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1];
}

});


parcelRegister("8Gejd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtrudeMode = void 0;

var $651d586e4a8ec60f$var$_bearing = $651d586e4a8ec60f$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $hs5Hv = parcelRequire("hs5Hv");

var $gFC9Z = parcelRequire("gFC9Z");

var $eJgQU = parcelRequire("eJgQU");
function $651d586e4a8ec60f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $651d586e4a8ec60f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $651d586e4a8ec60f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $651d586e4a8ec60f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $651d586e4a8ec60f$var$_typeof(obj);
}
function $651d586e4a8ec60f$var$_toConsumableArray(arr) {
    return $651d586e4a8ec60f$var$_arrayWithoutHoles(arr) || $651d586e4a8ec60f$var$_iterableToArray(arr) || $651d586e4a8ec60f$var$_unsupportedIterableToArray(arr) || $651d586e4a8ec60f$var$_nonIterableSpread();
}
function $651d586e4a8ec60f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $651d586e4a8ec60f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $651d586e4a8ec60f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $651d586e4a8ec60f$var$_arrayLikeToArray(arr);
}
function $651d586e4a8ec60f$var$_slicedToArray(arr, i) {
    return $651d586e4a8ec60f$var$_arrayWithHoles(arr) || $651d586e4a8ec60f$var$_iterableToArrayLimit(arr, i) || $651d586e4a8ec60f$var$_unsupportedIterableToArray(arr, i) || $651d586e4a8ec60f$var$_nonIterableRest();
}
function $651d586e4a8ec60f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $651d586e4a8ec60f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $651d586e4a8ec60f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $651d586e4a8ec60f$var$_arrayLikeToArray(o, minLen);
}
function $651d586e4a8ec60f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $651d586e4a8ec60f$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $651d586e4a8ec60f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $651d586e4a8ec60f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $651d586e4a8ec60f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $651d586e4a8ec60f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $651d586e4a8ec60f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $651d586e4a8ec60f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $651d586e4a8ec60f$var$_createSuper(Derived) {
    return function() {
        var Super = $651d586e4a8ec60f$var$_getPrototypeOf(Derived), result;
        if ($651d586e4a8ec60f$var$_isNativeReflectConstruct()) {
            var NewTarget = $651d586e4a8ec60f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $651d586e4a8ec60f$var$_possibleConstructorReturn(this, result);
    };
}
function $651d586e4a8ec60f$var$_possibleConstructorReturn(self, call) {
    if (call && ($651d586e4a8ec60f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $651d586e4a8ec60f$var$_assertThisInitialized(self);
}
function $651d586e4a8ec60f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $651d586e4a8ec60f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $651d586e4a8ec60f$var$_getPrototypeOf(o) {
    $651d586e4a8ec60f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $651d586e4a8ec60f$var$_getPrototypeOf(o);
}
function $651d586e4a8ec60f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $651d586e4a8ec60f$var$_setPrototypeOf(subClass, superClass);
}
function $651d586e4a8ec60f$var$_setPrototypeOf(o, p) {
    $651d586e4a8ec60f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $651d586e4a8ec60f$var$_setPrototypeOf(o, p);
}
function $651d586e4a8ec60f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $651d586e4a8ec60f$var$ExtrudeMode = /*#__PURE__*/ function(_ModifyMode) {
    $651d586e4a8ec60f$var$_inherits(ExtrudeMode, _ModifyMode);
    var _super = $651d586e4a8ec60f$var$_createSuper(ExtrudeMode);
    function ExtrudeMode() {
        var _this;
        $651d586e4a8ec60f$var$_classCallCheck(this, ExtrudeMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $651d586e4a8ec60f$var$_defineProperty($651d586e4a8ec60f$var$_assertThisInitialized(_this), "isPointAdded", false);
        return _this;
    }
    $651d586e4a8ec60f$var$_createClass(ExtrudeMode, [
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                var editHandle = (0, $hs5Hv.getPickedEditHandle)(event.pointerDownPicks);
                if (editHandle) {
                    var featureIndex = editHandle.properties.featureIndex;
                    var positionIndexes = editHandle.properties.positionIndexes;
                    var size = this.coordinatesSize(positionIndexes, featureIndex, props.data);
                    positionIndexes = this.isPointAdded ? this.nextPositionIndexes(positionIndexes, size) : positionIndexes; // p1 and p1 are end points for edge
                    var p1 = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, props.data);
                    var p2 = this.getPointForPositionIndexes(positionIndexes, featureIndex, props.data);
                    if (p1 && p2) {
                        // p3 and p4 are end points for moving (extruding) edge
                        var _generatePointsParall = (0, $hs5Hv.generatePointsParallelToLinePoints)(p1, p2, event.mapCoords), _generatePointsParall2 = $651d586e4a8ec60f$var$_slicedToArray(_generatePointsParall, 2), p3 = _generatePointsParall2[0], p4 = _generatePointsParall2[1];
                        var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).replacePosition(featureIndex, this.prevPositionIndexes(positionIndexes, size), p4).replacePosition(featureIndex, positionIndexes, p3).getObject();
                        props.onEdit({
                            updatedData: updatedData,
                            editType: "extruding",
                            editContext: {
                                featureIndexes: [
                                    featureIndex
                                ],
                                positionIndexes: this.nextPositionIndexes(positionIndexes, size),
                                position: p3
                            }
                        });
                        event.cancelPan();
                    }
                }
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                var selectedFeatureIndexes = props.selectedIndexes;
                var editHandle = (0, $hs5Hv.getPickedIntermediateEditHandle)(event.picks);
                if (selectedFeatureIndexes.length && editHandle) {
                    var _editHandle$propertie = editHandle.properties, positionIndexes = _editHandle$propertie.positionIndexes, featureIndex = _editHandle$propertie.featureIndex;
                    var size = this.coordinatesSize(positionIndexes, featureIndex, props.data); // p1 and p1 are end points for edge
                    var p1 = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, props.data);
                    var p2 = this.getPointForPositionIndexes(positionIndexes, featureIndex, props.data);
                    if (p1 && p2) {
                        var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data);
                        if (!this.isOrthogonal(positionIndexes, featureIndex, size, props.data)) updatedData = updatedData.addPosition(featureIndex, positionIndexes, p2);
                        if (!this.isOrthogonal(this.prevPositionIndexes(positionIndexes, size), featureIndex, size, props.data)) {
                            updatedData = updatedData.addPosition(featureIndex, positionIndexes, p1);
                            this.isPointAdded = true;
                        }
                        props.onEdit({
                            updatedData: updatedData.getObject(),
                            editType: "startExtruding",
                            editContext: {
                                featureIndexes: [
                                    featureIndex
                                ],
                                positionIndexes: positionIndexes,
                                position: p1
                            }
                        });
                    }
                }
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                var selectedFeatureIndexes = props.selectedIndexes;
                var editHandle = (0, $hs5Hv.getPickedEditHandle)(event.pointerDownPicks);
                if (selectedFeatureIndexes.length && editHandle) {
                    var featureIndex = editHandle.properties.featureIndex;
                    var positionIndexes = editHandle.properties.positionIndexes;
                    var size = this.coordinatesSize(positionIndexes, featureIndex, props.data);
                    positionIndexes = this.isPointAdded ? this.nextPositionIndexes(positionIndexes, size) : positionIndexes; // p1 and p1 are end points for edge
                    var p1 = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, props.data);
                    var p2 = this.getPointForPositionIndexes(positionIndexes, featureIndex, props.data);
                    if (p1 && p2) {
                        // p3 and p4 are end points for new moved (extruded) edge
                        var _generatePointsParall3 = (0, $hs5Hv.generatePointsParallelToLinePoints)(p1, p2, event.mapCoords), _generatePointsParall4 = $651d586e4a8ec60f$var$_slicedToArray(_generatePointsParall3, 2), p3 = _generatePointsParall4[0], p4 = _generatePointsParall4[1];
                        var updatedData = new $eJgQU.ImmutableFeatureCollection(props.data).replacePosition(featureIndex, this.prevPositionIndexes(positionIndexes, size), p4).replacePosition(featureIndex, positionIndexes, p3).getObject();
                        props.onEdit({
                            updatedData: updatedData,
                            editType: "extruded",
                            editContext: {
                                featureIndexes: [
                                    featureIndex
                                ],
                                positionIndexes: positionIndexes,
                                position: p3
                            }
                        });
                    }
                }
                this.isPointAdded = false;
            }
        },
        {
            key: "coordinatesSize",
            value: function coordinatesSize(positionIndexes, featureIndex, _ref) {
                var features = _ref.features;
                var size = 0;
                if (Array.isArray(positionIndexes)) {
                    var feature = features[featureIndex];
                    var coordinates = feature.geometry.coordinates; // for Multi polygons, length will be 3
                    if (positionIndexes.length === 3) {
                        var _positionIndexes = $651d586e4a8ec60f$var$_slicedToArray(positionIndexes, 2), a = _positionIndexes[0], b = _positionIndexes[1];
                        if (coordinates.length && coordinates[a].length) size = coordinates[a][b].length;
                    } else {
                        var _positionIndexes2 = $651d586e4a8ec60f$var$_slicedToArray(positionIndexes, 1), _b = _positionIndexes2[0];
                        if (coordinates.length && coordinates[_b].length) size = coordinates[_b].length;
                    }
                }
                return size;
            }
        },
        {
            key: "getBearing",
            value: function getBearing(p1, p2) {
                var angle = (0, $651d586e4a8ec60f$var$_bearing["default"])(p1, p2);
                if (angle < 0) return Math.floor(360 + angle);
                return Math.floor(angle);
            }
        },
        {
            key: "isOrthogonal",
            value: function isOrthogonal(positionIndexes, featureIndex, size, features) {
                if (!Array.isArray(positionIndexes)) return false;
                if (positionIndexes[positionIndexes.length - 1] === size - 1) positionIndexes[positionIndexes.length - 1] = 0;
                var prevPoint = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, features);
                var nextPoint = this.getPointForPositionIndexes(this.nextPositionIndexes(positionIndexes, size), featureIndex, features);
                var currentPoint = this.getPointForPositionIndexes(positionIndexes, featureIndex, features);
                var prevAngle = this.getBearing(currentPoint, prevPoint);
                var nextAngle = this.getBearing(currentPoint, nextPoint);
                return [
                    89,
                    90,
                    91,
                    269,
                    270,
                    271
                ].includes(Math.abs(prevAngle - nextAngle));
            }
        },
        {
            key: "nextPositionIndexes",
            value: function nextPositionIndexes(positionIndexes, size) {
                if (!Array.isArray(positionIndexes)) return [];
                var next = $651d586e4a8ec60f$var$_toConsumableArray(positionIndexes);
                if (next.length) next[next.length - 1] = next[next.length - 1] === size - 1 ? 0 : next[next.length - 1] + 1;
                return next;
            }
        },
        {
            key: "prevPositionIndexes",
            value: function prevPositionIndexes(positionIndexes, size) {
                if (!Array.isArray(positionIndexes)) return [];
                var prev = $651d586e4a8ec60f$var$_toConsumableArray(positionIndexes);
                if (prev.length) prev[prev.length - 1] = prev[prev.length - 1] === 0 ? size - 2 : prev[prev.length - 1] - 1;
                return prev;
            }
        },
        {
            key: "getPointForPositionIndexes",
            value: function getPointForPositionIndexes(positionIndexes, featureIndex, _ref2) {
                var features = _ref2.features;
                var p1;
                if (Array.isArray(positionIndexes)) {
                    var feature = features[featureIndex];
                    var coordinates = feature.geometry.coordinates; // for Multi polygons, length will be 3
                    if (positionIndexes.length === 3) {
                        var _positionIndexes3 = $651d586e4a8ec60f$var$_slicedToArray(positionIndexes, 3), a = _positionIndexes3[0], b = _positionIndexes3[1], c = _positionIndexes3[2];
                        if (coordinates.length && coordinates[a].length) p1 = coordinates[a][b][c];
                    } else {
                        var _positionIndexes4 = $651d586e4a8ec60f$var$_slicedToArray(positionIndexes, 2), _b2 = _positionIndexes4[0], _c = _positionIndexes4[1];
                        if (coordinates.length && coordinates[_b2].length) p1 = coordinates[_b2][_c];
                    }
                }
                return p1;
            }
        }
    ]);
    return ExtrudeMode;
}($gFC9Z.ModifyMode);
module.exports.ExtrudeMode = $651d586e4a8ec60f$var$ExtrudeMode;

});

parcelRegister("bmi4Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ElevationMode = void 0;

var $hs5Hv = parcelRequire("hs5Hv");

var $gFC9Z = parcelRequire("gFC9Z");
function $844fc58390bd0d81$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $844fc58390bd0d81$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $844fc58390bd0d81$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $844fc58390bd0d81$var$_typeof(obj);
}
function $844fc58390bd0d81$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $844fc58390bd0d81$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $844fc58390bd0d81$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $844fc58390bd0d81$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $844fc58390bd0d81$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $844fc58390bd0d81$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $844fc58390bd0d81$var$_get = Reflect.get;
    else $844fc58390bd0d81$var$_get = function _get(target, property, receiver) {
        var base = $844fc58390bd0d81$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $844fc58390bd0d81$var$_get(target, property, receiver || target);
}
function $844fc58390bd0d81$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $844fc58390bd0d81$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $844fc58390bd0d81$var$_createSuper(Derived) {
    return function() {
        var Super = $844fc58390bd0d81$var$_getPrototypeOf(Derived), result;
        if ($844fc58390bd0d81$var$_isNativeReflectConstruct()) {
            var NewTarget = $844fc58390bd0d81$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $844fc58390bd0d81$var$_possibleConstructorReturn(this, result);
    };
}
function $844fc58390bd0d81$var$_possibleConstructorReturn(self, call) {
    if (call && ($844fc58390bd0d81$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $844fc58390bd0d81$var$_assertThisInitialized(self);
}
function $844fc58390bd0d81$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $844fc58390bd0d81$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $844fc58390bd0d81$var$_getPrototypeOf(o) {
    $844fc58390bd0d81$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $844fc58390bd0d81$var$_getPrototypeOf(o);
}
function $844fc58390bd0d81$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $844fc58390bd0d81$var$_setPrototypeOf(subClass, superClass);
}
function $844fc58390bd0d81$var$_setPrototypeOf(o, p) {
    $844fc58390bd0d81$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $844fc58390bd0d81$var$_setPrototypeOf(o, p);
}
function $844fc58390bd0d81$var$defaultCalculateElevationChange(_ref) {
    var pointerDownScreenCoords = _ref.pointerDownScreenCoords, screenCoords = _ref.screenCoords;
    return 10 * (pointerDownScreenCoords[1] - screenCoords[1]);
}
var $844fc58390bd0d81$var$ElevationMode = /*#__PURE__*/ function(_ModifyMode) {
    $844fc58390bd0d81$var$_inherits(ElevationMode, _ModifyMode);
    var _super = $844fc58390bd0d81$var$_createSuper(ElevationMode);
    function ElevationMode() {
        $844fc58390bd0d81$var$_classCallCheck(this, ElevationMode);
        return _super.apply(this, arguments);
    }
    $844fc58390bd0d81$var$_createClass(ElevationMode, [
        {
            key: "makeElevatedEvent",
            value: function makeElevatedEvent(event, position, props) {
                var _ref2 = props.modeConfig || {}, _ref2$minElevation = _ref2.minElevation, minElevation = _ref2$minElevation === void 0 ? 0 : _ref2$minElevation, _ref2$maxElevation = _ref2.maxElevation, maxElevation = _ref2$maxElevation === void 0 ? 20000 : _ref2$maxElevation, _ref2$calculateElevat = _ref2.calculateElevationChange, calculateElevationChange = _ref2$calculateElevat === void 0 ? $844fc58390bd0d81$var$defaultCalculateElevationChange : _ref2$calculateElevat;
                if (!event.pointerDownScreenCoords) return event;
                 // $FlowFixMe - really, I know it has something at index 2
                var elevation = position.length === 3 ? position[2] : 0; // calculateElevationChange is configurable because (at this time) modes are not aware of the viewport
                elevation += calculateElevationChange({
                    pointerDownScreenCoords: event.pointerDownScreenCoords,
                    screenCoords: event.screenCoords
                });
                elevation = Math.min(elevation, maxElevation);
                elevation = Math.max(elevation, minElevation);
                return Object.assign({}, event, {
                    mapCoords: [
                        position[0],
                        position[1],
                        elevation
                    ]
                });
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                var editHandle = (0, $hs5Hv.getPickedEditHandle)(event.pointerDownPicks);
                var position = editHandle ? editHandle.geometry.coordinates : event.mapCoords; // @ts-ignore
                $844fc58390bd0d81$var$_get($844fc58390bd0d81$var$_getPrototypeOf(ElevationMode.prototype), "handlePointerMove", this).call(this, this.makeElevatedEvent(event, position, props), props);
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                var editHandle = (0, $hs5Hv.getPickedEditHandle)(event.picks);
                var position = editHandle ? editHandle.geometry.coordinates : event.mapCoords; // @ts-ignore
                $844fc58390bd0d81$var$_get($844fc58390bd0d81$var$_getPrototypeOf(ElevationMode.prototype), "handleStopDragging", this).call(this, this.makeElevatedEvent(event, position, props), props);
            }
        },
        {
            key: "getCursor",
            value: function getCursor(event) {
                var cursor = $844fc58390bd0d81$var$_get($844fc58390bd0d81$var$_getPrototypeOf(ElevationMode.prototype), "getCursor", this).call(this, event);
                if (cursor === "cell") cursor = "ns-resize";
                return cursor;
            }
        }
    ], [
        {
            key: "calculateElevationChangeWithViewport",
            value: function calculateElevationChangeWithViewport(viewport, _ref3) {
                var pointerDownScreenCoords = _ref3.pointerDownScreenCoords, screenCoords = _ref3.screenCoords;
                // Source: https://gis.stackexchange.com/a/127949/111804
                var metersPerPixel = 156543.03392 * Math.cos(viewport.latitude * Math.PI / 180) / Math.pow(2, viewport.zoom);
                return metersPerPixel * (pointerDownScreenCoords[1] - screenCoords[1]) / 2;
            }
        }
    ]);
    return ElevationMode;
}($gFC9Z.ModifyMode);
module.exports.ElevationMode = $844fc58390bd0d81$var$ElevationMode;

});

parcelRegister("8dTIP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransformMode = void 0;

var $7GKQS = parcelRequire("7GKQS");

var $lWzrG = parcelRequire("lWzrG");

var $ljwRq = parcelRequire("ljwRq");

var $cjd37 = parcelRequire("cjd37");

var $6J4Ij = parcelRequire("6J4Ij");
function $5fcac2d6e2d15b27$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5fcac2d6e2d15b27$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5fcac2d6e2d15b27$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5fcac2d6e2d15b27$var$_typeof(obj);
}
function $5fcac2d6e2d15b27$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5fcac2d6e2d15b27$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5fcac2d6e2d15b27$var$ownKeys(Object(source), true).forEach(function(key) {
            $5fcac2d6e2d15b27$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5fcac2d6e2d15b27$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5fcac2d6e2d15b27$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5fcac2d6e2d15b27$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5fcac2d6e2d15b27$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5fcac2d6e2d15b27$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5fcac2d6e2d15b27$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5fcac2d6e2d15b27$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5fcac2d6e2d15b27$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $5fcac2d6e2d15b27$var$_get = Reflect.get;
    else $5fcac2d6e2d15b27$var$_get = function _get(target, property, receiver) {
        var base = $5fcac2d6e2d15b27$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $5fcac2d6e2d15b27$var$_get(target, property, receiver || target);
}
function $5fcac2d6e2d15b27$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $5fcac2d6e2d15b27$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $5fcac2d6e2d15b27$var$_createSuper(Derived) {
    return function() {
        var Super = $5fcac2d6e2d15b27$var$_getPrototypeOf(Derived), result;
        if ($5fcac2d6e2d15b27$var$_isNativeReflectConstruct()) {
            var NewTarget = $5fcac2d6e2d15b27$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5fcac2d6e2d15b27$var$_possibleConstructorReturn(this, result);
    };
}
function $5fcac2d6e2d15b27$var$_possibleConstructorReturn(self, call) {
    if (call && ($5fcac2d6e2d15b27$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5fcac2d6e2d15b27$var$_assertThisInitialized(self);
}
function $5fcac2d6e2d15b27$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5fcac2d6e2d15b27$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5fcac2d6e2d15b27$var$_getPrototypeOf(o) {
    $5fcac2d6e2d15b27$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5fcac2d6e2d15b27$var$_getPrototypeOf(o);
}
function $5fcac2d6e2d15b27$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5fcac2d6e2d15b27$var$_setPrototypeOf(subClass, superClass);
}
function $5fcac2d6e2d15b27$var$_setPrototypeOf(o, p) {
    $5fcac2d6e2d15b27$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5fcac2d6e2d15b27$var$_setPrototypeOf(o, p);
}
var $5fcac2d6e2d15b27$var$TransformMode = /*#__PURE__*/ function(_CompositeMode) {
    $5fcac2d6e2d15b27$var$_inherits(TransformMode, _CompositeMode);
    var _super = $5fcac2d6e2d15b27$var$_createSuper(TransformMode);
    function TransformMode() {
        $5fcac2d6e2d15b27$var$_classCallCheck(this, TransformMode);
        return _super.call(this, [
            new $lWzrG.TranslateMode(),
            new $ljwRq.ScaleMode(),
            new $cjd37.RotateMode()
        ]);
    }
    $5fcac2d6e2d15b27$var$_createClass(TransformMode, [
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                var updatedCursor = null;
                $5fcac2d6e2d15b27$var$_get($5fcac2d6e2d15b27$var$_getPrototypeOf(TransformMode.prototype), "handlePointerMove", this).call(this, event, $5fcac2d6e2d15b27$var$_objectSpread({}, props, {
                    onUpdateCursor: function onUpdateCursor(cursor) {
                        updatedCursor = cursor || updatedCursor;
                    }
                }));
                props.onUpdateCursor(updatedCursor);
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                var scaleMode = null;
                var translateMode = null;
                var filteredModes = []; // If the user selects a scaling edit handle that overlaps with part of the selected feature,
                // it is possible for both scale and translate actions to be triggered. This logic prevents
                // this simultaneous action trigger from happening by putting a higher priority on scaling
                // since the user needs to be more precise to hover over a scaling edit handle.
                this._modes.forEach(function(mode) {
                    if (mode instanceof $lWzrG.TranslateMode) translateMode = mode;
                    else {
                        if (mode instanceof $ljwRq.ScaleMode) scaleMode = mode;
                        filteredModes.push(mode);
                    }
                });
                if (scaleMode instanceof $ljwRq.ScaleMode && !scaleMode.isEditHandleSelected()) filteredModes.push(translateMode);
                filteredModes.filter(Boolean).forEach(function(mode) {
                    return mode.handleStartDragging(event, props);
                });
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var compositeGuides = $5fcac2d6e2d15b27$var$_get($5fcac2d6e2d15b27$var$_getPrototypeOf(TransformMode.prototype), "getGuides", this).call(this, props);
                var rotateMode = (this._modes || []).find(function(mode) {
                    return mode instanceof $cjd37.RotateMode;
                });
                if (rotateMode instanceof $cjd37.RotateMode) {
                    var nonEnvelopeGuides = compositeGuides.features.filter(function(guide) {
                        var _ref = guide.properties || {}, editHandleType = _ref.editHandleType, mode = _ref.mode; // Both scale and rotate modes have the same enveloping box as a guide - only need one
                        var guidesToFilterOut = [
                            mode
                        ]; // Do not render scaling edit handles if rotating
                        if (rotateMode.getIsRotating()) guidesToFilterOut.push(editHandleType);
                        return !guidesToFilterOut.includes("scale");
                    }); // @ts-ignore
                    compositeGuides = (0, $7GKQS.featureCollection)(nonEnvelopeGuides);
                }
                return compositeGuides;
            }
        }
    ]);
    return TransformMode;
}($6J4Ij.CompositeMode);
module.exports.TransformMode = $5fcac2d6e2d15b27$var$TransformMode;

});
parcelRegister("6J4Ij", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompositeMode = void 0;

var $1tPZO = parcelRequire("1tPZO");
function $4e5a9a17f03a35c9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4e5a9a17f03a35c9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4e5a9a17f03a35c9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4e5a9a17f03a35c9$var$_typeof(obj);
}
function $4e5a9a17f03a35c9$var$_toConsumableArray(arr) {
    return $4e5a9a17f03a35c9$var$_arrayWithoutHoles(arr) || $4e5a9a17f03a35c9$var$_iterableToArray(arr) || $4e5a9a17f03a35c9$var$_unsupportedIterableToArray(arr) || $4e5a9a17f03a35c9$var$_nonIterableSpread();
}
function $4e5a9a17f03a35c9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4e5a9a17f03a35c9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $4e5a9a17f03a35c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4e5a9a17f03a35c9$var$_arrayLikeToArray(arr);
}
function $4e5a9a17f03a35c9$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $4e5a9a17f03a35c9$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $4e5a9a17f03a35c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4e5a9a17f03a35c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4e5a9a17f03a35c9$var$_arrayLikeToArray(o, minLen);
}
function $4e5a9a17f03a35c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4e5a9a17f03a35c9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4e5a9a17f03a35c9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4e5a9a17f03a35c9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4e5a9a17f03a35c9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4e5a9a17f03a35c9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4e5a9a17f03a35c9$var$_createSuper(Derived) {
    return function() {
        var Super = $4e5a9a17f03a35c9$var$_getPrototypeOf(Derived), result;
        if ($4e5a9a17f03a35c9$var$_isNativeReflectConstruct()) {
            var NewTarget = $4e5a9a17f03a35c9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4e5a9a17f03a35c9$var$_possibleConstructorReturn(this, result);
    };
}
function $4e5a9a17f03a35c9$var$_possibleConstructorReturn(self, call) {
    if (call && ($4e5a9a17f03a35c9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $4e5a9a17f03a35c9$var$_assertThisInitialized(self);
}
function $4e5a9a17f03a35c9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4e5a9a17f03a35c9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4e5a9a17f03a35c9$var$_getPrototypeOf(o) {
    $4e5a9a17f03a35c9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4e5a9a17f03a35c9$var$_getPrototypeOf(o);
}
function $4e5a9a17f03a35c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4e5a9a17f03a35c9$var$_setPrototypeOf(subClass, superClass);
}
function $4e5a9a17f03a35c9$var$_setPrototypeOf(o, p) {
    $4e5a9a17f03a35c9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4e5a9a17f03a35c9$var$_setPrototypeOf(o, p);
}
function $4e5a9a17f03a35c9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $4e5a9a17f03a35c9$var$CompositeMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $4e5a9a17f03a35c9$var$_inherits(CompositeMode, _GeoJsonEditMode);
    var _super = $4e5a9a17f03a35c9$var$_createSuper(CompositeMode);
    function CompositeMode(modes) {
        var _this;
        $4e5a9a17f03a35c9$var$_classCallCheck(this, CompositeMode);
        _this = _super.call(this);
        $4e5a9a17f03a35c9$var$_defineProperty($4e5a9a17f03a35c9$var$_assertThisInitialized(_this), "_modes", void 0);
        _this._modes = modes;
        return _this;
    }
    $4e5a9a17f03a35c9$var$_createClass(CompositeMode, [
        {
            key: "_coalesce",
            value: function _coalesce(callback) {
                var resultEval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var result;
                for(var i = 0; i < this._modes.length; i++){
                    result = callback(this._modes[i]);
                    if (resultEval ? resultEval(result) : result) break;
                }
                return result;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                this._coalesce(function(handler) {
                    return handler.handleClick(event, props);
                });
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                return this._coalesce(function(handler) {
                    return handler.handlePointerMove(event, props);
                });
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                return this._coalesce(function(handler) {
                    return handler.handleStartDragging(event, props);
                });
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                return this._coalesce(function(handler) {
                    return handler.handleStopDragging(event, props);
                });
            }
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                return this._coalesce(function(handler) {
                    return handler.handleDragging(event, props);
                });
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                // TODO: Combine the guides *BUT* make sure if none of the results have
                // changed to return the same object so that "guides !== this.state.guides"
                // in editable-geojson-layer works.
                var allGuides = [];
                var _iterator = $4e5a9a17f03a35c9$var$_createForOfIteratorHelper(this._modes), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var mode = _step.value;
                        allGuides.push.apply(allGuides, $4e5a9a17f03a35c9$var$_toConsumableArray(mode.getGuides(props).features));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return {
                    type: "FeatureCollection",
                    features: allGuides
                };
            }
        }
    ]);
    return CompositeMode;
}($1tPZO.GeoJsonEditMode);
module.exports.CompositeMode = $4e5a9a17f03a35c9$var$CompositeMode;

});


parcelRegister("8Vy0o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawPointMode = void 0;

var $1tPZO = parcelRequire("1tPZO");
function $67fe065d9ee8b737$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $67fe065d9ee8b737$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $67fe065d9ee8b737$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $67fe065d9ee8b737$var$_typeof(obj);
}
function $67fe065d9ee8b737$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $67fe065d9ee8b737$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $67fe065d9ee8b737$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $67fe065d9ee8b737$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $67fe065d9ee8b737$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $67fe065d9ee8b737$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $67fe065d9ee8b737$var$_get = Reflect.get;
    else $67fe065d9ee8b737$var$_get = function _get(target, property, receiver) {
        var base = $67fe065d9ee8b737$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $67fe065d9ee8b737$var$_get(target, property, receiver || target);
}
function $67fe065d9ee8b737$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $67fe065d9ee8b737$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $67fe065d9ee8b737$var$_createSuper(Derived) {
    return function() {
        var Super = $67fe065d9ee8b737$var$_getPrototypeOf(Derived), result;
        if ($67fe065d9ee8b737$var$_isNativeReflectConstruct()) {
            var NewTarget = $67fe065d9ee8b737$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $67fe065d9ee8b737$var$_possibleConstructorReturn(this, result);
    };
}
function $67fe065d9ee8b737$var$_possibleConstructorReturn(self, call) {
    if (call && ($67fe065d9ee8b737$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $67fe065d9ee8b737$var$_assertThisInitialized(self);
}
function $67fe065d9ee8b737$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $67fe065d9ee8b737$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $67fe065d9ee8b737$var$_getPrototypeOf(o) {
    $67fe065d9ee8b737$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $67fe065d9ee8b737$var$_getPrototypeOf(o);
}
function $67fe065d9ee8b737$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $67fe065d9ee8b737$var$_setPrototypeOf(subClass, superClass);
}
function $67fe065d9ee8b737$var$_setPrototypeOf(o, p) {
    $67fe065d9ee8b737$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $67fe065d9ee8b737$var$_setPrototypeOf(o, p);
}
var $67fe065d9ee8b737$var$DrawPointMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $67fe065d9ee8b737$var$_inherits(DrawPointMode, _GeoJsonEditMode);
    var _super = $67fe065d9ee8b737$var$_createSuper(DrawPointMode);
    function DrawPointMode() {
        $67fe065d9ee8b737$var$_classCallCheck(this, DrawPointMode);
        return _super.apply(this, arguments);
    }
    $67fe065d9ee8b737$var$_createClass(DrawPointMode, [
        {
            key: "createTentativeFeature",
            value: function createTentativeFeature(props) {
                var lastPointerMoveEvent = props.lastPointerMoveEvent;
                var lastCoords = lastPointerMoveEvent ? [
                    lastPointerMoveEvent.mapCoords
                ] : [];
                return {
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "Point",
                        coordinates: lastCoords[0]
                    }
                };
            }
        },
        {
            key: "handleClick",
            value: function handleClick(_ref, props) {
                var mapCoords = _ref.mapCoords;
                var geometry = {
                    type: "Point",
                    coordinates: mapCoords
                }; // @ts-ignore
                props.onEdit(this.getAddFeatureAction(geometry, props.data));
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
                $67fe065d9ee8b737$var$_get($67fe065d9ee8b737$var$_getPrototypeOf(DrawPointMode.prototype), "handlePointerMove", this).call(this, event, props);
            }
        }
    ]);
    return DrawPointMode;
}($1tPZO.GeoJsonEditMode);
module.exports.DrawPointMode = $67fe065d9ee8b737$var$DrawPointMode;

});

parcelRegister("4qOqT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawLineStringMode = void 0;

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");
function $33a0b604068aedff$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $33a0b604068aedff$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $33a0b604068aedff$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $33a0b604068aedff$var$_typeof(obj);
}
function $33a0b604068aedff$var$_toConsumableArray(arr) {
    return $33a0b604068aedff$var$_arrayWithoutHoles(arr) || $33a0b604068aedff$var$_iterableToArray(arr) || $33a0b604068aedff$var$_unsupportedIterableToArray(arr) || $33a0b604068aedff$var$_nonIterableSpread();
}
function $33a0b604068aedff$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $33a0b604068aedff$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $33a0b604068aedff$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $33a0b604068aedff$var$_arrayLikeToArray(o, minLen);
}
function $33a0b604068aedff$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $33a0b604068aedff$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $33a0b604068aedff$var$_arrayLikeToArray(arr);
}
function $33a0b604068aedff$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $33a0b604068aedff$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $33a0b604068aedff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $33a0b604068aedff$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $33a0b604068aedff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $33a0b604068aedff$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $33a0b604068aedff$var$_createSuper(Derived) {
    return function() {
        var Super = $33a0b604068aedff$var$_getPrototypeOf(Derived), result;
        if ($33a0b604068aedff$var$_isNativeReflectConstruct()) {
            var NewTarget = $33a0b604068aedff$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $33a0b604068aedff$var$_possibleConstructorReturn(this, result);
    };
}
function $33a0b604068aedff$var$_possibleConstructorReturn(self, call) {
    if (call && ($33a0b604068aedff$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $33a0b604068aedff$var$_assertThisInitialized(self);
}
function $33a0b604068aedff$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $33a0b604068aedff$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $33a0b604068aedff$var$_getPrototypeOf(o) {
    $33a0b604068aedff$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $33a0b604068aedff$var$_getPrototypeOf(o);
}
function $33a0b604068aedff$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $33a0b604068aedff$var$_setPrototypeOf(subClass, superClass);
}
function $33a0b604068aedff$var$_setPrototypeOf(o, p) {
    $33a0b604068aedff$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $33a0b604068aedff$var$_setPrototypeOf(o, p);
}
var $33a0b604068aedff$var$DrawLineStringMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $33a0b604068aedff$var$_inherits(DrawLineStringMode, _GeoJsonEditMode);
    var _super = $33a0b604068aedff$var$_createSuper(DrawLineStringMode);
    function DrawLineStringMode() {
        $33a0b604068aedff$var$_classCallCheck(this, DrawLineStringMode);
        return _super.apply(this, arguments);
    }
    $33a0b604068aedff$var$_createClass(DrawLineStringMode, [
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var picks = event.picks;
                var clickedEditHandle = (0, $hs5Hv.getPickedEditHandle)(picks);
                var positionAdded = false;
                if (!clickedEditHandle) {
                    // Don't add another point right next to an existing one
                    this.addClickSequence(event);
                    positionAdded = true;
                }
                var clickSequence = this.getClickSequence();
                if (clickSequence.length > 1 && clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && clickedEditHandle.properties.positionIndexes[0] === clickSequence.length - 1) {
                    // They clicked the last point (or double-clicked), so add the LineString
                    var lineStringToAdd = {
                        type: "LineString",
                        coordinates: $33a0b604068aedff$var$_toConsumableArray(clickSequence)
                    };
                    this.resetClickSequence();
                    var editAction = this.getAddFeatureAction(lineStringToAdd, props.data);
                    if (editAction) props.onEdit(editAction);
                } else if (positionAdded) // new tentative point
                props.onEdit({
                    // data is the same
                    updatedData: props.data,
                    editType: "addTentativePosition",
                    editContext: {
                        position: event.mapCoords
                    }
                });
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(event, props) {
                var key = event.key;
                if (key === "Enter") {
                    var clickSequence = this.getClickSequence();
                    if (clickSequence.length > 1) {
                        var lineStringToAdd = {
                            type: "LineString",
                            coordinates: $33a0b604068aedff$var$_toConsumableArray(clickSequence)
                        };
                        this.resetClickSequence();
                        var editAction = this.getAddFeatureAction(lineStringToAdd, props.data);
                        if (editAction) props.onEdit(editAction);
                    }
                }
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var _guides$features;
                var lastPointerMoveEvent = props.lastPointerMoveEvent;
                var clickSequence = this.getClickSequence();
                var lastCoords = lastPointerMoveEvent ? [
                    lastPointerMoveEvent.mapCoords
                ] : [];
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                var tentativeFeature;
                if (clickSequence.length > 0) tentativeFeature = {
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [].concat($33a0b604068aedff$var$_toConsumableArray(clickSequence), lastCoords)
                    }
                };
                if (tentativeFeature) guides.features.push(tentativeFeature);
                var editHandles = clickSequence.map(function(clickedCoord, index) {
                    return {
                        type: "Feature",
                        properties: {
                            guideType: "editHandle",
                            editHandleType: "existing",
                            featureIndex: -1,
                            positionIndexes: [
                                index
                            ]
                        },
                        geometry: {
                            type: "Point",
                            coordinates: clickedCoord
                        }
                    };
                });
                (_guides$features = guides.features).push.apply(_guides$features, $33a0b604068aedff$var$_toConsumableArray(editHandles)); // @ts-ignore
                return guides;
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
            }
        }
    ]);
    return DrawLineStringMode;
}($1tPZO.GeoJsonEditMode);
module.exports.DrawLineStringMode = $33a0b604068aedff$var$DrawLineStringMode;

});

parcelRegister("fVfme", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawPolygonMode = void 0;

var $b9781794dbbee251$var$_lineIntersect = $b9781794dbbee251$var$_interopRequireDefault((parcelRequire("iXvoQ")));

var $7GKQS = parcelRequire("7GKQS");

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");
function $b9781794dbbee251$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b9781794dbbee251$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b9781794dbbee251$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b9781794dbbee251$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b9781794dbbee251$var$_typeof(obj);
}
function $b9781794dbbee251$var$_toConsumableArray(arr) {
    return $b9781794dbbee251$var$_arrayWithoutHoles(arr) || $b9781794dbbee251$var$_iterableToArray(arr) || $b9781794dbbee251$var$_unsupportedIterableToArray(arr) || $b9781794dbbee251$var$_nonIterableSpread();
}
function $b9781794dbbee251$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b9781794dbbee251$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b9781794dbbee251$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b9781794dbbee251$var$_arrayLikeToArray(o, minLen);
}
function $b9781794dbbee251$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $b9781794dbbee251$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b9781794dbbee251$var$_arrayLikeToArray(arr);
}
function $b9781794dbbee251$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b9781794dbbee251$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b9781794dbbee251$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b9781794dbbee251$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b9781794dbbee251$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b9781794dbbee251$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b9781794dbbee251$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $b9781794dbbee251$var$_get = Reflect.get;
    else $b9781794dbbee251$var$_get = function _get(target, property, receiver) {
        var base = $b9781794dbbee251$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $b9781794dbbee251$var$_get(target, property, receiver || target);
}
function $b9781794dbbee251$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $b9781794dbbee251$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $b9781794dbbee251$var$_createSuper(Derived) {
    return function() {
        var Super = $b9781794dbbee251$var$_getPrototypeOf(Derived), result;
        if ($b9781794dbbee251$var$_isNativeReflectConstruct()) {
            var NewTarget = $b9781794dbbee251$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b9781794dbbee251$var$_possibleConstructorReturn(this, result);
    };
}
function $b9781794dbbee251$var$_possibleConstructorReturn(self, call) {
    if (call && ($b9781794dbbee251$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b9781794dbbee251$var$_assertThisInitialized(self);
}
function $b9781794dbbee251$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b9781794dbbee251$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b9781794dbbee251$var$_getPrototypeOf(o) {
    $b9781794dbbee251$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b9781794dbbee251$var$_getPrototypeOf(o);
}
function $b9781794dbbee251$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b9781794dbbee251$var$_setPrototypeOf(subClass, superClass);
}
function $b9781794dbbee251$var$_setPrototypeOf(o, p) {
    $b9781794dbbee251$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b9781794dbbee251$var$_setPrototypeOf(o, p);
}
var $b9781794dbbee251$var$DrawPolygonMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $b9781794dbbee251$var$_inherits(DrawPolygonMode, _GeoJsonEditMode);
    var _super = $b9781794dbbee251$var$_createSuper(DrawPolygonMode);
    function DrawPolygonMode() {
        $b9781794dbbee251$var$_classCallCheck(this, DrawPolygonMode);
        return _super.apply(this, arguments);
    }
    $b9781794dbbee251$var$_createClass(DrawPolygonMode, [
        {
            key: "createTentativeFeature",
            value: function createTentativeFeature(props) {
                var lastPointerMoveEvent = props.lastPointerMoveEvent;
                var clickSequence = this.getClickSequence();
                var lastCoords = lastPointerMoveEvent ? [
                    lastPointerMoveEvent.mapCoords
                ] : [];
                var tentativeFeature;
                if (clickSequence.length === 1 || clickSequence.length === 2) tentativeFeature = {
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [].concat($b9781794dbbee251$var$_toConsumableArray(clickSequence), lastCoords)
                    }
                };
                else if (clickSequence.length > 2) tentativeFeature = {
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "Polygon",
                        coordinates: [
                            [].concat($b9781794dbbee251$var$_toConsumableArray(clickSequence), lastCoords, [
                                clickSequence[0]
                            ])
                        ]
                    }
                };
                return tentativeFeature;
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var _guides$features;
                var clickSequence = this.getClickSequence();
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                var tentativeFeature = this.createTentativeFeature(props);
                if (tentativeFeature) guides.features.push(tentativeFeature);
                var editHandles = clickSequence.map(function(clickedCoord, index) {
                    return {
                        type: "Feature",
                        properties: {
                            guideType: "editHandle",
                            editHandleType: "existing",
                            featureIndex: -1,
                            positionIndexes: [
                                index
                            ]
                        },
                        geometry: {
                            type: "Point",
                            coordinates: clickedCoord
                        }
                    };
                });
                (_guides$features = guides.features).push.apply(_guides$features, $b9781794dbbee251$var$_toConsumableArray(editHandles)); // @ts-ignore
                return guides;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var picks = event.picks;
                var clickedEditHandle = (0, $hs5Hv.getPickedEditHandle)(picks);
                var clickSequence = this.getClickSequence();
                var overlappingLines = false;
                if (clickSequence.length > 2 && props.modeConfig && props.modeConfig.preventOverlappingLines) {
                    var currentLine = (0, $7GKQS.lineString)([
                        clickSequence[clickSequence.length - 1],
                        event.mapCoords
                    ]);
                    var otherLines = (0, $7GKQS.lineString)($b9781794dbbee251$var$_toConsumableArray(clickSequence.slice(0, clickSequence.length - 1)));
                    var intersectingPoints = (0, $b9781794dbbee251$var$_lineIntersect["default"])(currentLine, otherLines);
                    if (intersectingPoints.features.length > 0) overlappingLines = true;
                }
                var positionAdded = false;
                if (!clickedEditHandle && !overlappingLines) {
                    // Don't add another point right next to an existing one
                    this.addClickSequence(event);
                    positionAdded = true;
                }
                if (clickSequence.length > 2 && clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && (clickedEditHandle.properties.positionIndexes[0] === 0 || clickedEditHandle.properties.positionIndexes[0] === clickSequence.length - 1)) {
                    // They clicked the first or last point (or double-clicked), so complete the polygon
                    // Remove the hovered position
                    var polygonToAdd = {
                        type: "Polygon",
                        coordinates: [
                            [].concat($b9781794dbbee251$var$_toConsumableArray(clickSequence), [
                                clickSequence[0]
                            ])
                        ]
                    };
                    this.resetClickSequence();
                    var editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
                    if (editAction) props.onEdit(editAction);
                } else if (positionAdded) // new tentative point
                props.onEdit({
                    // data is the same
                    updatedData: props.data,
                    editType: "addTentativePosition",
                    editContext: {
                        position: event.mapCoords
                    }
                });
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(event, props) {
                if (event.key === "Enter") {
                    var clickSequence = this.getClickSequence();
                    if (clickSequence.length > 2) {
                        var polygonToAdd = {
                            type: "Polygon",
                            coordinates: [
                                [].concat($b9781794dbbee251$var$_toConsumableArray(clickSequence), [
                                    clickSequence[0]
                                ])
                            ]
                        };
                        this.resetClickSequence();
                        var editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
                        if (editAction) props.onEdit(editAction);
                    }
                }
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
                $b9781794dbbee251$var$_get($b9781794dbbee251$var$_getPrototypeOf(DrawPolygonMode.prototype), "handlePointerMove", this).call(this, event, props);
            }
        }
    ]);
    return DrawPolygonMode;
}($1tPZO.GeoJsonEditMode);
module.exports.DrawPolygonMode = $b9781794dbbee251$var$DrawPolygonMode;

});

parcelRegister("4pNaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawRectangleMode = void 0;

var $336fa23499c19762$var$_bboxPolygon = $336fa23499c19762$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $74Uyk = parcelRequire("74Uyk");
function $336fa23499c19762$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $336fa23499c19762$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $336fa23499c19762$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $336fa23499c19762$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $336fa23499c19762$var$_typeof(obj);
}
function $336fa23499c19762$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $336fa23499c19762$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $336fa23499c19762$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $336fa23499c19762$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $336fa23499c19762$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $336fa23499c19762$var$_createSuper(Derived) {
    return function() {
        var Super = $336fa23499c19762$var$_getPrototypeOf(Derived), result;
        if ($336fa23499c19762$var$_isNativeReflectConstruct()) {
            var NewTarget = $336fa23499c19762$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $336fa23499c19762$var$_possibleConstructorReturn(this, result);
    };
}
function $336fa23499c19762$var$_possibleConstructorReturn(self, call) {
    if (call && ($336fa23499c19762$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $336fa23499c19762$var$_assertThisInitialized(self);
}
function $336fa23499c19762$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $336fa23499c19762$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $336fa23499c19762$var$_getPrototypeOf(o) {
    $336fa23499c19762$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $336fa23499c19762$var$_getPrototypeOf(o);
}
function $336fa23499c19762$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $336fa23499c19762$var$_setPrototypeOf(subClass, superClass);
}
function $336fa23499c19762$var$_setPrototypeOf(o, p) {
    $336fa23499c19762$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $336fa23499c19762$var$_setPrototypeOf(o, p);
}
var $336fa23499c19762$var$DrawRectangleMode = /*#__PURE__*/ function(_TwoClickPolygonMode) {
    $336fa23499c19762$var$_inherits(DrawRectangleMode, _TwoClickPolygonMode);
    var _super = $336fa23499c19762$var$_createSuper(DrawRectangleMode);
    function DrawRectangleMode() {
        $336fa23499c19762$var$_classCallCheck(this, DrawRectangleMode);
        return _super.apply(this, arguments);
    }
    $336fa23499c19762$var$_createClass(DrawRectangleMode, [
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                var rectangle = (0, $336fa23499c19762$var$_bboxPolygon["default"])([
                    coord1[0],
                    coord1[1],
                    coord2[0],
                    coord2[1]
                ]);
                rectangle.properties = rectangle.properties || {};
                rectangle.properties.shape = "Rectangle"; // @ts-ignore
                return rectangle;
            }
        }
    ]);
    return DrawRectangleMode;
}($74Uyk.TwoClickPolygonMode);
module.exports.DrawRectangleMode = $336fa23499c19762$var$DrawRectangleMode;

});
parcelRegister("74Uyk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwoClickPolygonMode = void 0;

var $1tPZO = parcelRequire("1tPZO");
function $5274c6547d82efaf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5274c6547d82efaf$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5274c6547d82efaf$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5274c6547d82efaf$var$_typeof(obj);
}
function $5274c6547d82efaf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5274c6547d82efaf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5274c6547d82efaf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5274c6547d82efaf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5274c6547d82efaf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5274c6547d82efaf$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $5274c6547d82efaf$var$_get = Reflect.get;
    else $5274c6547d82efaf$var$_get = function _get(target, property, receiver) {
        var base = $5274c6547d82efaf$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $5274c6547d82efaf$var$_get(target, property, receiver || target);
}
function $5274c6547d82efaf$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $5274c6547d82efaf$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $5274c6547d82efaf$var$_createSuper(Derived) {
    return function() {
        var Super = $5274c6547d82efaf$var$_getPrototypeOf(Derived), result;
        if ($5274c6547d82efaf$var$_isNativeReflectConstruct()) {
            var NewTarget = $5274c6547d82efaf$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5274c6547d82efaf$var$_possibleConstructorReturn(this, result);
    };
}
function $5274c6547d82efaf$var$_possibleConstructorReturn(self, call) {
    if (call && ($5274c6547d82efaf$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5274c6547d82efaf$var$_assertThisInitialized(self);
}
function $5274c6547d82efaf$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5274c6547d82efaf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5274c6547d82efaf$var$_getPrototypeOf(o) {
    $5274c6547d82efaf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5274c6547d82efaf$var$_getPrototypeOf(o);
}
function $5274c6547d82efaf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5274c6547d82efaf$var$_setPrototypeOf(subClass, superClass);
}
function $5274c6547d82efaf$var$_setPrototypeOf(o, p) {
    $5274c6547d82efaf$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5274c6547d82efaf$var$_setPrototypeOf(o, p);
}
var $5274c6547d82efaf$var$TwoClickPolygonMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $5274c6547d82efaf$var$_inherits(TwoClickPolygonMode, _GeoJsonEditMode);
    var _super = $5274c6547d82efaf$var$_createSuper(TwoClickPolygonMode);
    function TwoClickPolygonMode() {
        $5274c6547d82efaf$var$_classCallCheck(this, TwoClickPolygonMode);
        return _super.apply(this, arguments);
    }
    $5274c6547d82efaf$var$_createClass(TwoClickPolygonMode, [
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                if (props.modeConfig && props.modeConfig.dragToDraw) // handled in drag handlers
                return;
                this.addClickSequence(event);
                this.checkAndFinishPolygon(props);
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                if (!props.modeConfig || !props.modeConfig.dragToDraw) // handled in click handlers
                return;
                this.addClickSequence(event);
                event.cancelPan();
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                if (!props.modeConfig || !props.modeConfig.dragToDraw) // handled in click handlers
                return;
                this.addClickSequence(event);
                this.checkAndFinishPolygon(props);
            }
        },
        {
            key: "checkAndFinishPolygon",
            value: function checkAndFinishPolygon(props) {
                var clickSequence = this.getClickSequence();
                var tentativeFeature = this.getTentativeGuide(props);
                if (clickSequence.length > 1 && tentativeFeature && tentativeFeature.geometry.type === "Polygon") {
                    var feature = {
                        type: "Feature",
                        properties: {
                            shape: tentativeFeature.properties.shape
                        },
                        geometry: {
                            type: "Polygon",
                            coordinates: tentativeFeature.geometry.coordinates
                        }
                    };
                    var editAction = this.getAddFeatureOrBooleanPolygonAction(feature, props);
                    this.resetClickSequence();
                    if (editAction) props.onEdit(editAction);
                }
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var lastPointerMoveEvent = props.lastPointerMoveEvent, modeConfig = props.modeConfig;
                var clickSequence = this.getClickSequence();
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                if (clickSequence.length === 0) // nothing to do yet
                return guides;
                var corner1 = clickSequence[0];
                var corner2 = lastPointerMoveEvent.mapCoords;
                var polygon = this.getTwoClickPolygon(corner1, corner2, modeConfig);
                if (polygon) guides.features.push({
                    type: "Feature",
                    properties: {
                        shape: polygon.properties && polygon.properties.shape,
                        guideType: "tentative"
                    },
                    geometry: polygon.geometry
                });
                return guides;
            }
        },
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                return null;
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
                $5274c6547d82efaf$var$_get($5274c6547d82efaf$var$_getPrototypeOf(TwoClickPolygonMode.prototype), "handlePointerMove", this).call(this, event, props);
            }
        },
        {
            key: "createTentativeFeature",
            value: function createTentativeFeature(props) {
                var lastPointerMoveEvent = props.lastPointerMoveEvent;
                var clickSequence = this.getClickSequence();
                var lastCoords = lastPointerMoveEvent ? [
                    lastPointerMoveEvent.mapCoords
                ] : [];
                var tentativeFeature;
                if (clickSequence.length === 1) tentativeFeature = this.getTwoClickPolygon(clickSequence[0], lastCoords[0], props.modeConfig);
                return tentativeFeature;
            }
        }
    ]);
    return TwoClickPolygonMode;
}($1tPZO.GeoJsonEditMode);
module.exports.TwoClickPolygonMode = $5274c6547d82efaf$var$TwoClickPolygonMode;

});


parcelRegister("87lGF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawSquareMode = void 0;

var $5e8fcccd569d17b3$var$_bboxPolygon = $5e8fcccd569d17b3$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $5e8fcccd569d17b3$var$_distance = $5e8fcccd569d17b3$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $5e8fcccd569d17b3$var$_along = $5e8fcccd569d17b3$var$_interopRequireDefault((parcelRequire("ekWQM")));

var $7GKQS = parcelRequire("7GKQS");

var $74Uyk = parcelRequire("74Uyk");
function $5e8fcccd569d17b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5e8fcccd569d17b3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5e8fcccd569d17b3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5e8fcccd569d17b3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5e8fcccd569d17b3$var$_typeof(obj);
}
function $5e8fcccd569d17b3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5e8fcccd569d17b3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5e8fcccd569d17b3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5e8fcccd569d17b3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5e8fcccd569d17b3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5e8fcccd569d17b3$var$_createSuper(Derived) {
    return function() {
        var Super = $5e8fcccd569d17b3$var$_getPrototypeOf(Derived), result;
        if ($5e8fcccd569d17b3$var$_isNativeReflectConstruct()) {
            var NewTarget = $5e8fcccd569d17b3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5e8fcccd569d17b3$var$_possibleConstructorReturn(this, result);
    };
}
function $5e8fcccd569d17b3$var$_possibleConstructorReturn(self, call) {
    if (call && ($5e8fcccd569d17b3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5e8fcccd569d17b3$var$_assertThisInitialized(self);
}
function $5e8fcccd569d17b3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5e8fcccd569d17b3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5e8fcccd569d17b3$var$_getPrototypeOf(o) {
    $5e8fcccd569d17b3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5e8fcccd569d17b3$var$_getPrototypeOf(o);
}
function $5e8fcccd569d17b3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5e8fcccd569d17b3$var$_setPrototypeOf(subClass, superClass);
}
function $5e8fcccd569d17b3$var$_setPrototypeOf(o, p) {
    $5e8fcccd569d17b3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5e8fcccd569d17b3$var$_setPrototypeOf(o, p);
}
var $5e8fcccd569d17b3$var$DrawSquareMode = /*#__PURE__*/ function(_TwoClickPolygonMode) {
    $5e8fcccd569d17b3$var$_inherits(DrawSquareMode, _TwoClickPolygonMode);
    var _super = $5e8fcccd569d17b3$var$_createSuper(DrawSquareMode);
    function DrawSquareMode() {
        $5e8fcccd569d17b3$var$_classCallCheck(this, DrawSquareMode);
        return _super.apply(this, arguments);
    }
    $5e8fcccd569d17b3$var$_createClass(DrawSquareMode, [
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                // get the coordinates of the other two rectangle vertices
                var coord3 = [
                    coord2[0],
                    coord1[1]
                ];
                var coord4 = [
                    coord1[0],
                    coord2[1]
                ]; // determine the shortest distance to the origin, which will be the length of each square side
                var distance1 = (0, $5e8fcccd569d17b3$var$_distance["default"])((0, $7GKQS.point)(coord3), (0, $7GKQS.point)(coord1));
                var distance2 = (0, $5e8fcccd569d17b3$var$_distance["default"])((0, $7GKQS.point)(coord4), (0, $7GKQS.point)(coord1));
                var shortestDistance = distance1 <= distance2 ? distance1 : distance2; // determine which coordinate pair of the two is closest to the origin
                var closestPoint = distance1 <= distance2 ? coord3 : coord4; // create a linestring which will used to locate the second square vertex
                var line = (0, $7GKQS.lineString)([
                    closestPoint,
                    coord2
                ]); // get the coordinates of the second square vertex
                var newPoint = (0, $5e8fcccd569d17b3$var$_along["default"])(line, shortestDistance);
                var corner = newPoint.geometry.coordinates;
                var square = (0, $5e8fcccd569d17b3$var$_bboxPolygon["default"])([
                    coord1[0],
                    coord1[1],
                    corner[0],
                    corner[1]
                ]);
                square.properties = square.properties || {};
                square.properties.shape = "Square"; // @ts-ignore
                return square;
            }
        }
    ]);
    return DrawSquareMode;
}($74Uyk.TwoClickPolygonMode);
module.exports.DrawSquareMode = $5e8fcccd569d17b3$var$DrawSquareMode;

});
parcelRegister("ekWQM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a70095645efd1544$export$2e2bcd8739ae039; });

var $g8zlF = parcelRequire("g8zlF");

var $eVN5t = parcelRequire("eVN5t");

var $lghTP = parcelRequire("lghTP");

var $geeei = parcelRequire("geeei");

var $4ILYg = parcelRequire("4ILYg");
function $a70095645efd1544$export$2e2bcd8739ae039(line, distance, options) {
    if (options === void 0) options = {};
    // Get Coords
    var geom = (0, $4ILYg.getGeom)(line);
    var coords = geom.coordinates;
    var travelled = 0;
    for(var i = 0; i < coords.length; i++){
        if (distance >= travelled && i === coords.length - 1) break;
        else if (travelled >= distance) {
            var overshot = distance - travelled;
            if (!overshot) return (0, $geeei.point)(coords[i]);
            else {
                var direction = (0, $g8zlF.default)(coords[i], coords[i - 1]) - 180;
                var interpolated = (0, $eVN5t.default)(coords[i], overshot, direction, options);
                return interpolated;
            }
        } else travelled += (0, $lghTP.default)(coords[i], coords[i + 1], options);
    }
    return (0, $geeei.point)(coords[coords.length - 1]);
}

});
parcelRegister("g8zlF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbf8d02eba7f0737$export$2e2bcd8739ae039; });

var $geeei = parcelRequire("geeei");

var $4ILYg = parcelRequire("4ILYg");
function $bbf8d02eba7f0737$export$2e2bcd8739ae039(start, end, options) {
    if (options === void 0) options = {};
    // Reverse calculation
    if (options.final === true) return $bbf8d02eba7f0737$var$calculateFinalBearing(start, end);
    var coordinates1 = (0, $4ILYg.getCoord)(start);
    var coordinates2 = (0, $4ILYg.getCoord)(end);
    var lon1 = (0, $geeei.degreesToRadians)(coordinates1[0]);
    var lon2 = (0, $geeei.degreesToRadians)(coordinates2[0]);
    var lat1 = (0, $geeei.degreesToRadians)(coordinates1[1]);
    var lat2 = (0, $geeei.degreesToRadians)(coordinates2[1]);
    var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    return (0, $geeei.radiansToDegrees)(Math.atan2(a, b));
}
/**
 * Calculates Final Bearing
 *
 * @private
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @returns {number} bearing
 */ function $bbf8d02eba7f0737$var$calculateFinalBearing(start, end) {
    // Swap start & end
    var bear = $bbf8d02eba7f0737$export$2e2bcd8739ae039(end, start);
    bear = (bear + 180) % 360;
    return bear;
}

});
parcelRegister("geeei", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $bd08fddf02b8d754$export$105684a3041cb6f3; });
$parcel$export(module.exports, "isNumber", function () { return $bd08fddf02b8d754$export$7e4aa119212bc614; });
$parcel$export(module.exports, "radiansToLength", function () { return $bd08fddf02b8d754$export$f234631d6a2eedf8; });
$parcel$export(module.exports, "lengthToRadians", function () { return $bd08fddf02b8d754$export$a2280f7debae8f10; });
$parcel$export(module.exports, "radiansToDegrees", function () { return $bd08fddf02b8d754$export$c41dd2a8460d3196; });
$parcel$export(module.exports, "degreesToRadians", function () { return $bd08fddf02b8d754$export$c9fcf1a7df975d78; });
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var $bd08fddf02b8d754$export$e3a1ee0e9945697f = 6371008.8;
var $bd08fddf02b8d754$export$f929e47acbed771a = {
    centimeters: $bd08fddf02b8d754$export$e3a1ee0e9945697f * 100,
    centimetres: $bd08fddf02b8d754$export$e3a1ee0e9945697f * 100,
    degrees: $bd08fddf02b8d754$export$e3a1ee0e9945697f / 111325,
    feet: $bd08fddf02b8d754$export$e3a1ee0e9945697f * 3.28084,
    inches: $bd08fddf02b8d754$export$e3a1ee0e9945697f * 39.37,
    kilometers: $bd08fddf02b8d754$export$e3a1ee0e9945697f / 1000,
    kilometres: $bd08fddf02b8d754$export$e3a1ee0e9945697f / 1000,
    meters: $bd08fddf02b8d754$export$e3a1ee0e9945697f,
    metres: $bd08fddf02b8d754$export$e3a1ee0e9945697f,
    miles: $bd08fddf02b8d754$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $bd08fddf02b8d754$export$e3a1ee0e9945697f * 1000,
    millimetres: $bd08fddf02b8d754$export$e3a1ee0e9945697f * 1000,
    nauticalmiles: $bd08fddf02b8d754$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $bd08fddf02b8d754$export$e3a1ee0e9945697f * 1.0936
};
var $bd08fddf02b8d754$export$95cef4899be7420 = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / $bd08fddf02b8d754$export$e3a1ee0e9945697f,
    yards: 1.0936133
};
var $bd08fddf02b8d754$export$44665ce4f7f4c82b = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $bd08fddf02b8d754$export$42a7622cbf932bb(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return $bd08fddf02b8d754$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $bd08fddf02b8d754$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $bd08fddf02b8d754$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $bd08fddf02b8d754$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $bd08fddf02b8d754$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $bd08fddf02b8d754$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $bd08fddf02b8d754$export$105684a3041cb6f3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$bd08fddf02b8d754$export$7e4aa119212bc614(coordinates[0]) || !$bd08fddf02b8d754$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options);
}
function $bd08fddf02b8d754$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $bd08fddf02b8d754$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $bd08fddf02b8d754$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $bd08fddf02b8d754$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options);
}
function $bd08fddf02b8d754$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $bd08fddf02b8d754$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $bd08fddf02b8d754$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $bd08fddf02b8d754$export$98ec381bb06902c3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options);
}
function $bd08fddf02b8d754$export$74f7306c35db993f(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $bd08fddf02b8d754$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $bd08fddf02b8d754$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $bd08fddf02b8d754$export$4717c67ac3e5e04d(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $bd08fddf02b8d754$export$bd735230309493da(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options);
}
function $bd08fddf02b8d754$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options);
}
function $bd08fddf02b8d754$export$79bd594da96638d3(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options);
}
function $bd08fddf02b8d754$export$9242f1e18250422a(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $bd08fddf02b8d754$export$ced6ed16dfd6a264(geom, properties, options);
}
function $bd08fddf02b8d754$export$2077e0241d6afd3c(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $bd08fddf02b8d754$export$f234631d6a2eedf8(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = $bd08fddf02b8d754$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $bd08fddf02b8d754$export$a2280f7debae8f10(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = $bd08fddf02b8d754$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $bd08fddf02b8d754$export$c7a138e00a89bd01(distance, units) {
    return $bd08fddf02b8d754$export$c41dd2a8460d3196($bd08fddf02b8d754$export$a2280f7debae8f10(distance, units));
}
function $bd08fddf02b8d754$export$f2077d29c73b33ec(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $bd08fddf02b8d754$export$c41dd2a8460d3196(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function $bd08fddf02b8d754$export$c9fcf1a7df975d78(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function $bd08fddf02b8d754$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $bd08fddf02b8d754$export$f234631d6a2eedf8($bd08fddf02b8d754$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $bd08fddf02b8d754$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $bd08fddf02b8d754$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $bd08fddf02b8d754$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $bd08fddf02b8d754$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $bd08fddf02b8d754$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
function $bd08fddf02b8d754$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$bd08fddf02b8d754$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $bd08fddf02b8d754$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

});

parcelRegister("4ILYg", function(module, exports) {

$parcel$export(module.exports, "getCoord", function () { return $37007b88e54f38f3$export$b4663c6e64a770bc; });
$parcel$export(module.exports, "getGeom", function () { return $37007b88e54f38f3$export$b8f320eb9549c8fd; });

var $geeei = parcelRequire("geeei");
function $37007b88e54f38f3$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $37007b88e54f38f3$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $37007b88e54f38f3$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $geeei.isNumber)(coordinates[0]) && (0, $geeei.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $37007b88e54f38f3$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $37007b88e54f38f3$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $37007b88e54f38f3$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $37007b88e54f38f3$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $37007b88e54f38f3$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $37007b88e54f38f3$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

});


parcelRegister("eVN5t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adec774a48c34f45$export$2e2bcd8739ae039; });
// http://en.wikipedia.org/wiki/Haversine_formula
// http://www.movable-type.co.uk/scripts/latlong.html

var $geeei = parcelRequire("geeei");

var $4ILYg = parcelRequire("4ILYg");
function $adec774a48c34f45$export$2e2bcd8739ae039(origin, distance, bearing, options) {
    if (options === void 0) options = {};
    // Handle input
    var coordinates1 = (0, $4ILYg.getCoord)(origin);
    var longitude1 = (0, $geeei.degreesToRadians)(coordinates1[0]);
    var latitude1 = (0, $geeei.degreesToRadians)(coordinates1[1]);
    var bearingRad = (0, $geeei.degreesToRadians)(bearing);
    var radians = (0, $geeei.lengthToRadians)(distance, options.units);
    // Main
    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) + Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad));
    var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1), Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
    var lng = (0, $geeei.radiansToDegrees)(longitude2);
    var lat = (0, $geeei.radiansToDegrees)(latitude2);
    return (0, $geeei.point)([
        lng,
        lat
    ], options.properties);
}

});

parcelRegister("lghTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7a8fa08ee1d17e2$export$2e2bcd8739ae039; });

var $4ILYg = parcelRequire("4ILYg");

var $geeei = parcelRequire("geeei");
//http://en.wikipedia.org/wiki/Haversine_formula
//http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Calculates the distance between two {@link Point|points} in degrees, radians, miles, or kilometers.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name distance
 * @param {Coord | Point} from origin point or coordinate
 * @param {Coord | Point} to destination point or coordinate
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.distance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */ function $f7a8fa08ee1d17e2$var$distance(from, to, options) {
    if (options === void 0) options = {};
    var coordinates1 = (0, $4ILYg.getCoord)(from);
    var coordinates2 = (0, $4ILYg.getCoord)(to);
    var dLat = (0, $geeei.degreesToRadians)(coordinates2[1] - coordinates1[1]);
    var dLon = (0, $geeei.degreesToRadians)(coordinates2[0] - coordinates1[0]);
    var lat1 = (0, $geeei.degreesToRadians)(coordinates1[1]);
    var lat2 = (0, $geeei.degreesToRadians)(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return (0, $geeei.radiansToLength)(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
var $f7a8fa08ee1d17e2$export$2e2bcd8739ae039 = $f7a8fa08ee1d17e2$var$distance;

});



parcelRegister("clLbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawRectangleFromCenterMode = void 0;

var $8fdc0b10d34aad2c$var$_bboxPolygon = $8fdc0b10d34aad2c$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $74Uyk = parcelRequire("74Uyk");
function $8fdc0b10d34aad2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8fdc0b10d34aad2c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8fdc0b10d34aad2c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8fdc0b10d34aad2c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8fdc0b10d34aad2c$var$_typeof(obj);
}
function $8fdc0b10d34aad2c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8fdc0b10d34aad2c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8fdc0b10d34aad2c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8fdc0b10d34aad2c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8fdc0b10d34aad2c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8fdc0b10d34aad2c$var$_createSuper(Derived) {
    return function() {
        var Super = $8fdc0b10d34aad2c$var$_getPrototypeOf(Derived), result;
        if ($8fdc0b10d34aad2c$var$_isNativeReflectConstruct()) {
            var NewTarget = $8fdc0b10d34aad2c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8fdc0b10d34aad2c$var$_possibleConstructorReturn(this, result);
    };
}
function $8fdc0b10d34aad2c$var$_possibleConstructorReturn(self, call) {
    if (call && ($8fdc0b10d34aad2c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8fdc0b10d34aad2c$var$_assertThisInitialized(self);
}
function $8fdc0b10d34aad2c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8fdc0b10d34aad2c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8fdc0b10d34aad2c$var$_getPrototypeOf(o) {
    $8fdc0b10d34aad2c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8fdc0b10d34aad2c$var$_getPrototypeOf(o);
}
function $8fdc0b10d34aad2c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8fdc0b10d34aad2c$var$_setPrototypeOf(subClass, superClass);
}
function $8fdc0b10d34aad2c$var$_setPrototypeOf(o, p) {
    $8fdc0b10d34aad2c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8fdc0b10d34aad2c$var$_setPrototypeOf(o, p);
}
var $8fdc0b10d34aad2c$var$DrawRectangleFromCenterMode = /*#__PURE__*/ function(_TwoClickPolygonMode) {
    $8fdc0b10d34aad2c$var$_inherits(DrawRectangleFromCenterMode, _TwoClickPolygonMode);
    var _super = $8fdc0b10d34aad2c$var$_createSuper(DrawRectangleFromCenterMode);
    function DrawRectangleFromCenterMode() {
        $8fdc0b10d34aad2c$var$_classCallCheck(this, DrawRectangleFromCenterMode);
        return _super.apply(this, arguments);
    }
    $8fdc0b10d34aad2c$var$_createClass(DrawRectangleFromCenterMode, [
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                var longitude = coord1[0] > coord2[0] ? coord1[0] + Math.abs(coord1[0] - coord2[0]) : coord1[0] - Math.abs(coord1[0] - coord2[0]);
                var latitude = coord1[1] > coord2[1] ? coord1[1] + Math.abs(coord1[1] - coord2[1]) : coord1[1] - Math.abs(coord1[1] - coord2[1]);
                var rectangle = (0, $8fdc0b10d34aad2c$var$_bboxPolygon["default"])([
                    longitude,
                    latitude,
                    coord2[0],
                    coord2[1]
                ]);
                rectangle.properties = rectangle.properties || {};
                rectangle.properties.shape = "Rectangle"; // @ts-ignore
                return rectangle;
            }
        }
    ]);
    return DrawRectangleFromCenterMode;
}($74Uyk.TwoClickPolygonMode);
module.exports.DrawRectangleFromCenterMode = $8fdc0b10d34aad2c$var$DrawRectangleFromCenterMode;

});

parcelRegister("iMVab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawSquareFromCenterMode = void 0;

var $dad90d1ab40ac83e$var$_bboxPolygon = $dad90d1ab40ac83e$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $dad90d1ab40ac83e$var$_distance = $dad90d1ab40ac83e$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $dad90d1ab40ac83e$var$_along = $dad90d1ab40ac83e$var$_interopRequireDefault((parcelRequire("ekWQM")));

var $7GKQS = parcelRequire("7GKQS");

var $74Uyk = parcelRequire("74Uyk");
function $dad90d1ab40ac83e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $dad90d1ab40ac83e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dad90d1ab40ac83e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dad90d1ab40ac83e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dad90d1ab40ac83e$var$_typeof(obj);
}
function $dad90d1ab40ac83e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dad90d1ab40ac83e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dad90d1ab40ac83e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dad90d1ab40ac83e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dad90d1ab40ac83e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dad90d1ab40ac83e$var$_createSuper(Derived) {
    return function() {
        var Super = $dad90d1ab40ac83e$var$_getPrototypeOf(Derived), result;
        if ($dad90d1ab40ac83e$var$_isNativeReflectConstruct()) {
            var NewTarget = $dad90d1ab40ac83e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dad90d1ab40ac83e$var$_possibleConstructorReturn(this, result);
    };
}
function $dad90d1ab40ac83e$var$_possibleConstructorReturn(self, call) {
    if (call && ($dad90d1ab40ac83e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $dad90d1ab40ac83e$var$_assertThisInitialized(self);
}
function $dad90d1ab40ac83e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dad90d1ab40ac83e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dad90d1ab40ac83e$var$_getPrototypeOf(o) {
    $dad90d1ab40ac83e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dad90d1ab40ac83e$var$_getPrototypeOf(o);
}
function $dad90d1ab40ac83e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dad90d1ab40ac83e$var$_setPrototypeOf(subClass, superClass);
}
function $dad90d1ab40ac83e$var$_setPrototypeOf(o, p) {
    $dad90d1ab40ac83e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dad90d1ab40ac83e$var$_setPrototypeOf(o, p);
}
var $dad90d1ab40ac83e$var$DrawSquareFromCenterMode = /*#__PURE__*/ function(_TwoClickPolygonMode) {
    $dad90d1ab40ac83e$var$_inherits(DrawSquareFromCenterMode, _TwoClickPolygonMode);
    var _super = $dad90d1ab40ac83e$var$_createSuper(DrawSquareFromCenterMode);
    function DrawSquareFromCenterMode() {
        $dad90d1ab40ac83e$var$_classCallCheck(this, DrawSquareFromCenterMode);
        return _super.apply(this, arguments);
    }
    $dad90d1ab40ac83e$var$_createClass(DrawSquareFromCenterMode, [
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                // get the coordinates of the other two rectangle vertices
                var coord3 = [
                    coord2[0],
                    coord1[1]
                ];
                var coord4 = [
                    coord1[0],
                    coord2[1]
                ]; // determine the shortest distance to the origin, which will be the length of each square side
                var distance1 = (0, $dad90d1ab40ac83e$var$_distance["default"])((0, $7GKQS.point)(coord3), (0, $7GKQS.point)(coord1));
                var distance2 = (0, $dad90d1ab40ac83e$var$_distance["default"])((0, $7GKQS.point)(coord4), (0, $7GKQS.point)(coord1));
                var shortestDistance = distance1 <= distance2 ? distance1 : distance2; // determine which coordinate pair of the two is closest to the origin
                var closestPoint = distance1 <= distance2 ? coord3 : coord4; // create a linestring which will used to locate the second square vertex
                var line = (0, $7GKQS.lineString)([
                    closestPoint,
                    coord2
                ]); // get the coordinates of the second square vertex
                var newPoint = (0, $dad90d1ab40ac83e$var$_along["default"])(line, shortestDistance);
                var corner = newPoint.geometry.coordinates; // determine the longitude and latitude values of the opposite corner
                var longitude = coord1[0] > corner[0] ? coord1[0] + Math.abs(coord1[0] - corner[0]) : coord1[0] - Math.abs(coord1[0] - corner[0]);
                var latitude = coord1[1] > corner[1] ? coord1[1] + Math.abs(coord1[1] - corner[1]) : coord1[1] - Math.abs(coord1[1] - corner[1]);
                var square = (0, $dad90d1ab40ac83e$var$_bboxPolygon["default"])([
                    longitude,
                    latitude,
                    corner[0],
                    corner[1]
                ]);
                square.properties = square.properties || {};
                square.properties.shape = "Square"; // @ts-ignore
                return square;
            }
        }
    ]);
    return DrawSquareFromCenterMode;
}($74Uyk.TwoClickPolygonMode);
module.exports.DrawSquareFromCenterMode = $dad90d1ab40ac83e$var$DrawSquareFromCenterMode;

});

parcelRegister("aS0fb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawCircleByDiameterMode = void 0;

var $7e9f22f624527ff4$var$_circle = $7e9f22f624527ff4$var$_interopRequireDefault((parcelRequire("lzQHn")));

var $7e9f22f624527ff4$var$_distance = $7e9f22f624527ff4$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $1tPZO = parcelRequire("1tPZO");

var $74Uyk = parcelRequire("74Uyk");
function $7e9f22f624527ff4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7e9f22f624527ff4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7e9f22f624527ff4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7e9f22f624527ff4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7e9f22f624527ff4$var$_typeof(obj);
}
function $7e9f22f624527ff4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7e9f22f624527ff4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7e9f22f624527ff4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7e9f22f624527ff4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7e9f22f624527ff4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7e9f22f624527ff4$var$_createSuper(Derived) {
    return function() {
        var Super = $7e9f22f624527ff4$var$_getPrototypeOf(Derived), result;
        if ($7e9f22f624527ff4$var$_isNativeReflectConstruct()) {
            var NewTarget = $7e9f22f624527ff4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7e9f22f624527ff4$var$_possibleConstructorReturn(this, result);
    };
}
function $7e9f22f624527ff4$var$_possibleConstructorReturn(self, call) {
    if (call && ($7e9f22f624527ff4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7e9f22f624527ff4$var$_assertThisInitialized(self);
}
function $7e9f22f624527ff4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7e9f22f624527ff4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7e9f22f624527ff4$var$_getPrototypeOf(o) {
    $7e9f22f624527ff4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7e9f22f624527ff4$var$_getPrototypeOf(o);
}
function $7e9f22f624527ff4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7e9f22f624527ff4$var$_setPrototypeOf(subClass, superClass);
}
function $7e9f22f624527ff4$var$_setPrototypeOf(o, p) {
    $7e9f22f624527ff4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7e9f22f624527ff4$var$_setPrototypeOf(o, p);
}
var $7e9f22f624527ff4$var$DrawCircleByDiameterMode = /*#__PURE__*/ function(_TwoClickPolygonMode) {
    $7e9f22f624527ff4$var$_inherits(DrawCircleByDiameterMode, _TwoClickPolygonMode);
    var _super = $7e9f22f624527ff4$var$_createSuper(DrawCircleByDiameterMode);
    function DrawCircleByDiameterMode() {
        $7e9f22f624527ff4$var$_classCallCheck(this, DrawCircleByDiameterMode);
        return _super.apply(this, arguments);
    }
    $7e9f22f624527ff4$var$_createClass(DrawCircleByDiameterMode, [
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                // Default turf value for circle is 64
                var _ref = modeConfig || {}, _ref$steps = _ref.steps, steps = _ref$steps === void 0 ? 64 : _ref$steps;
                var options = {
                    steps: steps
                };
                if (steps < 4) {
                    console.warn("Minimum steps to draw a circle is 4 "); // eslint-disable-line no-console,no-undef
                    options.steps = 4;
                }
                var centerCoordinates = (0, $1tPZO.getIntermediatePosition)(coord1, coord2);
                var radius = Math.max((0, $7e9f22f624527ff4$var$_distance["default"])(coord1, centerCoordinates), 0.001);
                var geometry = (0, $7e9f22f624527ff4$var$_circle["default"])(centerCoordinates, radius, options);
                geometry.properties = geometry.properties || {};
                geometry.properties.shape = "Circle";
                return geometry;
            }
        }
    ]);
    return DrawCircleByDiameterMode;
}($74Uyk.TwoClickPolygonMode);
module.exports.DrawCircleByDiameterMode = $7e9f22f624527ff4$var$DrawCircleByDiameterMode;

});

parcelRegister("ca4GA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawCircleFromCenterMode = void 0;

var $8daa0db6ba896d05$var$_circle = $8daa0db6ba896d05$var$_interopRequireDefault((parcelRequire("lzQHn")));

var $8daa0db6ba896d05$var$_distance = $8daa0db6ba896d05$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $74Uyk = parcelRequire("74Uyk");
function $8daa0db6ba896d05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8daa0db6ba896d05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8daa0db6ba896d05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8daa0db6ba896d05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8daa0db6ba896d05$var$_typeof(obj);
}
function $8daa0db6ba896d05$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8daa0db6ba896d05$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8daa0db6ba896d05$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8daa0db6ba896d05$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8daa0db6ba896d05$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8daa0db6ba896d05$var$_createSuper(Derived) {
    return function() {
        var Super = $8daa0db6ba896d05$var$_getPrototypeOf(Derived), result;
        if ($8daa0db6ba896d05$var$_isNativeReflectConstruct()) {
            var NewTarget = $8daa0db6ba896d05$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8daa0db6ba896d05$var$_possibleConstructorReturn(this, result);
    };
}
function $8daa0db6ba896d05$var$_possibleConstructorReturn(self, call) {
    if (call && ($8daa0db6ba896d05$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8daa0db6ba896d05$var$_assertThisInitialized(self);
}
function $8daa0db6ba896d05$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8daa0db6ba896d05$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8daa0db6ba896d05$var$_getPrototypeOf(o) {
    $8daa0db6ba896d05$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8daa0db6ba896d05$var$_getPrototypeOf(o);
}
function $8daa0db6ba896d05$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8daa0db6ba896d05$var$_setPrototypeOf(subClass, superClass);
}
function $8daa0db6ba896d05$var$_setPrototypeOf(o, p) {
    $8daa0db6ba896d05$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8daa0db6ba896d05$var$_setPrototypeOf(o, p);
}
var $8daa0db6ba896d05$var$DrawCircleFromCenterMode = /*#__PURE__*/ function(_TwoClickPolygonMode) {
    $8daa0db6ba896d05$var$_inherits(DrawCircleFromCenterMode, _TwoClickPolygonMode);
    var _super = $8daa0db6ba896d05$var$_createSuper(DrawCircleFromCenterMode);
    function DrawCircleFromCenterMode() {
        $8daa0db6ba896d05$var$_classCallCheck(this, DrawCircleFromCenterMode);
        return _super.apply(this, arguments);
    }
    $8daa0db6ba896d05$var$_createClass(DrawCircleFromCenterMode, [
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                // Default turf value for circle is 64
                var _ref = modeConfig || {}, _ref$steps = _ref.steps, steps = _ref$steps === void 0 ? 64 : _ref$steps;
                var options = {
                    steps: steps
                };
                if (steps < 4) {
                    console.warn("Minimum steps to draw a circle is 4 "); // eslint-disable-line no-console,no-undef
                    options.steps = 4;
                }
                var radius = Math.max((0, $8daa0db6ba896d05$var$_distance["default"])(coord1, coord2), 0.001);
                var geometry = (0, $8daa0db6ba896d05$var$_circle["default"])(coord1, radius, options);
                geometry.properties = geometry.properties || {};
                geometry.properties.shape = "Circle";
                return geometry;
            }
        }
    ]);
    return DrawCircleFromCenterMode;
}($74Uyk.TwoClickPolygonMode);
module.exports.DrawCircleFromCenterMode = $8daa0db6ba896d05$var$DrawCircleFromCenterMode;

});

parcelRegister("7sSbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawEllipseByBoundingBoxMode = void 0;

var $56f52df8a7a124b7$var$_bboxPolygon = $56f52df8a7a124b7$var$_interopRequireDefault((parcelRequire("e9fnE")));

var $56f52df8a7a124b7$var$_distance = $56f52df8a7a124b7$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $56f52df8a7a124b7$var$_ellipse = $56f52df8a7a124b7$var$_interopRequireDefault((parcelRequire("6dYcK")));

var $7GKQS = parcelRequire("7GKQS");

var $1tPZO = parcelRequire("1tPZO");

var $74Uyk = parcelRequire("74Uyk");
function $56f52df8a7a124b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $56f52df8a7a124b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $56f52df8a7a124b7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $56f52df8a7a124b7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $56f52df8a7a124b7$var$_typeof(obj);
}
function $56f52df8a7a124b7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $56f52df8a7a124b7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $56f52df8a7a124b7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $56f52df8a7a124b7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $56f52df8a7a124b7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $56f52df8a7a124b7$var$_createSuper(Derived) {
    return function() {
        var Super = $56f52df8a7a124b7$var$_getPrototypeOf(Derived), result;
        if ($56f52df8a7a124b7$var$_isNativeReflectConstruct()) {
            var NewTarget = $56f52df8a7a124b7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $56f52df8a7a124b7$var$_possibleConstructorReturn(this, result);
    };
}
function $56f52df8a7a124b7$var$_possibleConstructorReturn(self, call) {
    if (call && ($56f52df8a7a124b7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $56f52df8a7a124b7$var$_assertThisInitialized(self);
}
function $56f52df8a7a124b7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $56f52df8a7a124b7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $56f52df8a7a124b7$var$_getPrototypeOf(o) {
    $56f52df8a7a124b7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $56f52df8a7a124b7$var$_getPrototypeOf(o);
}
function $56f52df8a7a124b7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $56f52df8a7a124b7$var$_setPrototypeOf(subClass, superClass);
}
function $56f52df8a7a124b7$var$_setPrototypeOf(o, p) {
    $56f52df8a7a124b7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $56f52df8a7a124b7$var$_setPrototypeOf(o, p);
}
var $56f52df8a7a124b7$var$DrawEllipseByBoundingBoxMode = /*#__PURE__*/ function(_TwoClickPolygonMode) {
    $56f52df8a7a124b7$var$_inherits(DrawEllipseByBoundingBoxMode, _TwoClickPolygonMode);
    var _super = $56f52df8a7a124b7$var$_createSuper(DrawEllipseByBoundingBoxMode);
    function DrawEllipseByBoundingBoxMode() {
        $56f52df8a7a124b7$var$_classCallCheck(this, DrawEllipseByBoundingBoxMode);
        return _super.apply(this, arguments);
    }
    $56f52df8a7a124b7$var$_createClass(DrawEllipseByBoundingBoxMode, [
        {
            key: "getTwoClickPolygon",
            value: function getTwoClickPolygon(coord1, coord2, modeConfig) {
                var minX = Math.min(coord1[0], coord2[0]);
                var minY = Math.min(coord1[1], coord2[1]);
                var maxX = Math.max(coord1[0], coord2[0]);
                var maxY = Math.max(coord1[1], coord2[1]);
                var polygonPoints = (0, $56f52df8a7a124b7$var$_bboxPolygon["default"])([
                    minX,
                    minY,
                    maxX,
                    maxY
                ]).geometry.coordinates[0];
                var centerCoordinates = (0, $1tPZO.getIntermediatePosition)(coord1, coord2);
                var xSemiAxis = Math.max((0, $56f52df8a7a124b7$var$_distance["default"])((0, $7GKQS.point)(polygonPoints[0]), (0, $7GKQS.point)(polygonPoints[1])), 0.001);
                var ySemiAxis = Math.max((0, $56f52df8a7a124b7$var$_distance["default"])((0, $7GKQS.point)(polygonPoints[0]), (0, $7GKQS.point)(polygonPoints[3])), 0.001); // @ts-ignore
                return (0, $56f52df8a7a124b7$var$_ellipse["default"])(centerCoordinates, xSemiAxis, ySemiAxis);
            }
        }
    ]);
    return DrawEllipseByBoundingBoxMode;
}($74Uyk.TwoClickPolygonMode);
module.exports.DrawEllipseByBoundingBoxMode = $56f52df8a7a124b7$var$DrawEllipseByBoundingBoxMode;

});
parcelRegister("6dYcK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4882a861852a1e88$export$2e2bcd8739ae039; });

var $kTfmD = parcelRequire("kTfmD");

var $35NAj = parcelRequire("35NAj");

var $j6dRg = parcelRequire("j6dRg");

var $kbGTO = parcelRequire("kbGTO");
/**
 * Takes a {@link Point} and calculates the ellipse polygon given two semi-axes expressed in variable units and steps for precision.
 *
 * @param {Coord} center center point
 * @param {number} xSemiAxis semi (major) axis of the ellipse along the x-axis
 * @param {number} ySemiAxis semi (minor) axis of the ellipse along the y-axis
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.angle=0] angle of rotation (along the vertical axis), from North in decimal degrees, negative clockwise
 * @param {Coord} [options.pivot='origin'] point around which the rotation will be performed
 * @param {number} [options.steps=64] number of steps
 * @param {string} [options.units='kilometers'] unit of measurement for axes
 * @param {Object} [options.properties={}] properties
 * @returns {Feature<Polygon>} ellipse polygon
 * @example
 * var center = [-75, 40];
 * var xSemiAxis = 5;
 * var ySemiAxis = 2;
 * var ellipse = turf.ellipse(center, xSemiAxis, ySemiAxis);
 *
 * //addToMap
 * var addToMap = [turf.point(center), ellipse]
 */ function $4882a861852a1e88$var$ellipse(center, xSemiAxis, ySemiAxis, options) {
    // Optional params
    options = options || {};
    var steps = options.steps || 64;
    var units = options.units || "kilometers";
    var angle = options.angle || 0;
    var pivot = options.pivot || center;
    var properties = options.properties || center.properties || {};
    // validation
    if (!center) throw new Error("center is required");
    if (!xSemiAxis) throw new Error("xSemiAxis is required");
    if (!ySemiAxis) throw new Error("ySemiAxis is required");
    if (!(0, $kTfmD.isObject)(options)) throw new Error("options must be an object");
    if (!(0, $kTfmD.isNumber)(steps)) throw new Error("steps must be a number");
    if (!(0, $kTfmD.isNumber)(angle)) throw new Error("angle must be a number");
    var centerCoords = (0, $kbGTO.getCoord)(center);
    if (units === "degrees") var angleRad = (0, $kTfmD.degreesToRadians)(angle);
    else {
        xSemiAxis = (0, $35NAj.default)(center, xSemiAxis, 90, {
            units: units
        });
        ySemiAxis = (0, $35NAj.default)(center, ySemiAxis, 0, {
            units: units
        });
        xSemiAxis = (0, $kbGTO.getCoord)(xSemiAxis)[0] - centerCoords[0];
        ySemiAxis = (0, $kbGTO.getCoord)(ySemiAxis)[1] - centerCoords[1];
    }
    var coordinates = [];
    for(var i = 0; i < steps; i += 1){
        var stepAngle = i * -360 / steps;
        var x = xSemiAxis * ySemiAxis / Math.sqrt(Math.pow(ySemiAxis, 2) + Math.pow(xSemiAxis, 2) * Math.pow($4882a861852a1e88$var$getTanDeg(stepAngle), 2));
        var y = xSemiAxis * ySemiAxis / Math.sqrt(Math.pow(xSemiAxis, 2) + Math.pow(ySemiAxis, 2) / Math.pow($4882a861852a1e88$var$getTanDeg(stepAngle), 2));
        if (stepAngle < -90 && stepAngle >= -270) x = -x;
        if (stepAngle < -180 && stepAngle >= -360) y = -y;
        if (units === "degrees") {
            var newx = x * Math.cos(angleRad) + y * Math.sin(angleRad);
            var newy = y * Math.cos(angleRad) - x * Math.sin(angleRad);
            x = newx;
            y = newy;
        }
        coordinates.push([
            x + centerCoords[0],
            y + centerCoords[1]
        ]);
    }
    coordinates.push(coordinates[0]);
    if (units === "degrees") return (0, $kTfmD.polygon)([
        coordinates
    ], properties);
    else return (0, $j6dRg.default)((0, $kTfmD.polygon)([
        coordinates
    ], properties), angle, {
        pivot: pivot
    });
}
/**
 * Get Tan Degrees
 *
 * @private
 * @param {number} deg Degrees
 * @returns {number} Tan Degrees
 */ function $4882a861852a1e88$var$getTanDeg(deg) {
    var rad = deg * Math.PI / 180;
    return Math.tan(rad);
}
var $4882a861852a1e88$export$2e2bcd8739ae039 = $4882a861852a1e88$var$ellipse;

});
parcelRegister("kTfmD", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $f354dcb01154eb28$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "polygon", function () { return $f354dcb01154eb28$export$b7b19aa0ee06c73; });
$parcel$export(module.exports, "isNumber", function () { return $f354dcb01154eb28$export$7e4aa119212bc614; });
$parcel$export(module.exports, "degreesToRadians", function () { return $f354dcb01154eb28$export$c9fcf1a7df975d78; });
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 */ var $f354dcb01154eb28$export$e3a1ee0e9945697f = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 */ var $f354dcb01154eb28$export$f929e47acbed771a = {
    meters: $f354dcb01154eb28$export$e3a1ee0e9945697f,
    metres: $f354dcb01154eb28$export$e3a1ee0e9945697f,
    millimeters: $f354dcb01154eb28$export$e3a1ee0e9945697f * 1000,
    millimetres: $f354dcb01154eb28$export$e3a1ee0e9945697f * 1000,
    centimeters: $f354dcb01154eb28$export$e3a1ee0e9945697f * 100,
    centimetres: $f354dcb01154eb28$export$e3a1ee0e9945697f * 100,
    kilometers: $f354dcb01154eb28$export$e3a1ee0e9945697f / 1000,
    kilometres: $f354dcb01154eb28$export$e3a1ee0e9945697f / 1000,
    miles: $f354dcb01154eb28$export$e3a1ee0e9945697f / 1609.344,
    nauticalmiles: $f354dcb01154eb28$export$e3a1ee0e9945697f / 1852,
    inches: $f354dcb01154eb28$export$e3a1ee0e9945697f * 39.370,
    yards: $f354dcb01154eb28$export$e3a1ee0e9945697f / 1.0936,
    feet: $f354dcb01154eb28$export$e3a1ee0e9945697f * 3.28084,
    radians: 1,
    degrees: $f354dcb01154eb28$export$e3a1ee0e9945697f / 111325
};
/**
 * Units of measurement factors based on 1 meter.
 */ var $f354dcb01154eb28$export$95cef4899be7420 = {
    meters: 1,
    metres: 1,
    millimeters: 1000,
    millimetres: 1000,
    centimeters: 100,
    centimetres: 100,
    kilometers: 0.001,
    kilometres: 0.001,
    miles: 1 / 1609.344,
    nauticalmiles: 1 / 1852,
    inches: 39.370,
    yards: 1 / 1.0936,
    feet: 3.28084,
    radians: 1 / $f354dcb01154eb28$export$e3a1ee0e9945697f,
    degrees: 1 / 111325
};
/**
 * Area of measurement factors based on 1 square meter.
 */ var $f354dcb01154eb28$export$44665ce4f7f4c82b = {
    meters: 1,
    metres: 1,
    millimeters: 1000000,
    millimetres: 1000000,
    centimeters: 10000,
    centimetres: 10000,
    kilometers: 0.000001,
    kilometres: 0.000001,
    acres: 0.000247105,
    miles: 3.86e-7,
    yards: 1.195990046,
    feet: 10.763910417,
    inches: 1550.003100006
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ function $f354dcb01154eb28$export$ced6ed16dfd6a264(geometry, properties, options) {
    // Optional Parameters
    options = options || {};
    if (!$f354dcb01154eb28$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (geometry === undefined) throw new Error("geometry is required");
    if (properties && properties.constructor !== Object) throw new Error("properties must be an Object");
    if (bbox) $f354dcb01154eb28$export$28ac7bb8f5309bea(bbox);
    if (id) $f354dcb01154eb28$export$f35f128fd59ea256(id);
    // Main
    var feat = {
        type: "Feature"
    };
    if (id) feat.id = id;
    if (bbox) feat.bbox = bbox;
    feat.properties = properties || {};
    feat.geometry = geometry;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<number>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Geometry
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = 'Point';
 * var coordinates = [110, 50];
 *
 * var geometry = turf.geometry(type, coordinates);
 *
 * //=geometry
 */ function $f354dcb01154eb28$export$42a7622cbf932bb(type, coordinates, options) {
    // Optional Parameters
    options = options || {};
    if (!$f354dcb01154eb28$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    // Validation
    if (!type) throw new Error("type is required");
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (bbox) $f354dcb01154eb28$export$28ac7bb8f5309bea(bbox);
    // Main
    var geom;
    switch(type){
        case "Point":
            geom = $f354dcb01154eb28$export$105684a3041cb6f3(coordinates).geometry;
            break;
        case "LineString":
            geom = $f354dcb01154eb28$export$98ec381bb06902c3(coordinates).geometry;
            break;
        case "Polygon":
            geom = $f354dcb01154eb28$export$b7b19aa0ee06c73(coordinates).geometry;
            break;
        case "MultiPoint":
            geom = $f354dcb01154eb28$export$335fc20ed6b6dbb6(coordinates).geometry;
            break;
        case "MultiLineString":
            geom = $f354dcb01154eb28$export$bd735230309493da(coordinates).geometry;
            break;
        case "MultiPolygon":
            geom = $f354dcb01154eb28$export$79bd594da96638d3(coordinates).geometry;
            break;
        default:
            throw new Error(type + " is invalid");
    }
    if (bbox) geom.bbox = bbox;
    return geom;
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ function $f354dcb01154eb28$export$105684a3041cb6f3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$f354dcb01154eb28$export$7e4aa119212bc614(coordinates[0]) || !$f354dcb01154eb28$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    return $f354dcb01154eb28$export$ced6ed16dfd6a264({
        type: "Point",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ function $f354dcb01154eb28$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $f354dcb01154eb28$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $f354dcb01154eb28$export$105684a3041cb6f3(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ function $f354dcb01154eb28$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    for(var i = 0; i < coordinates.length; i++){
        var ring = coordinates[i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (i === 0 && j === 0 && !$f354dcb01154eb28$export$7e4aa119212bc614(ring[0][0]) || !$f354dcb01154eb28$export$7e4aa119212bc614(ring[0][1])) throw new Error("coordinates must contain numbers");
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    return $f354dcb01154eb28$export$ced6ed16dfd6a264({
        type: "Polygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ function $f354dcb01154eb28$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $f354dcb01154eb28$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $f354dcb01154eb28$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ function $f354dcb01154eb28$export$98ec381bb06902c3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    // Check if first point of LineString contains two numbers
    if (!$f354dcb01154eb28$export$7e4aa119212bc614(coordinates[0][1]) || !$f354dcb01154eb28$export$7e4aa119212bc614(coordinates[0][1])) throw new Error("coordinates must contain numbers");
    return $f354dcb01154eb28$export$ced6ed16dfd6a264({
        type: "LineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<number>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ function $f354dcb01154eb28$export$74f7306c35db993f(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    return $f354dcb01154eb28$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $f354dcb01154eb28$export$98ec381bb06902c3(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ function $f354dcb01154eb28$export$4717c67ac3e5e04d(features, options) {
    // Optional Parameters
    options = options || {};
    if (!$f354dcb01154eb28$export$a6cdc56e425d0d0a(options)) throw new Error("options is invalid");
    var bbox = options.bbox;
    var id = options.id;
    // Validation
    if (!features) throw new Error("No features passed");
    if (!Array.isArray(features)) throw new Error("features must be an Array");
    if (bbox) $f354dcb01154eb28$export$28ac7bb8f5309bea(bbox);
    if (id) $f354dcb01154eb28$export$f35f128fd59ea256(id);
    // Main
    var fc = {
        type: "FeatureCollection"
    };
    if (id) fc.id = id;
    if (bbox) fc.bbox = bbox;
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ function $f354dcb01154eb28$export$bd735230309493da(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $f354dcb01154eb28$export$ced6ed16dfd6a264({
        type: "MultiLineString",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ function $f354dcb01154eb28$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $f354dcb01154eb28$export$ced6ed16dfd6a264({
        type: "MultiPoint",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ function $f354dcb01154eb28$export$79bd594da96638d3(coordinates, properties, options) {
    if (!coordinates) throw new Error("coordinates is required");
    return $f354dcb01154eb28$export$ced6ed16dfd6a264({
        type: "MultiPolygon",
        coordinates: coordinates
    }, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = {
 *     "type": "Point",
 *       "coordinates": [100, 0]
 *     };
 * var line = {
 *     "type": "LineString",
 *     "coordinates": [ [101, 0], [102, 1] ]
 *   };
 * var collection = turf.geometryCollection([pt, line]);
 *
 * //=collection
 */ function $f354dcb01154eb28$export$9242f1e18250422a(geometries, properties, options) {
    if (!geometries) throw new Error("geometries is required");
    if (!Array.isArray(geometries)) throw new Error("geometries must be an Array");
    return $f354dcb01154eb28$export$ced6ed16dfd6a264({
        type: "GeometryCollection",
        geometries: geometries
    }, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ function $f354dcb01154eb28$export$2077e0241d6afd3c(num, precision) {
    if (num === undefined || num === null || isNaN(num)) throw new Error("num is required");
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} distance
 */ function $f354dcb01154eb28$export$f234631d6a2eedf8(radians, units) {
    if (radians === undefined || radians === null) throw new Error("radians is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $f354dcb01154eb28$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} radians
 */ function $f354dcb01154eb28$export$a2280f7debae8f10(distance, units) {
    if (distance === undefined || distance === null) throw new Error("distance is required");
    if (units && typeof units !== "string") throw new Error("units must be a string");
    var factor = $f354dcb01154eb28$export$f929e47acbed771a[units || "kilometers"];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units='kilometers'] can be degrees, radians, miles, or kilometers inches, yards, metres, meters, kilometres, kilometers.
 * @returns {number} degrees
 */ function $f354dcb01154eb28$export$c7a138e00a89bd01(distance, units) {
    return $f354dcb01154eb28$export$c41dd2a8460d3196($f354dcb01154eb28$export$a2280f7debae8f10(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ function $f354dcb01154eb28$export$f2077d29c73b33ec(bearing) {
    if (bearing === null || bearing === undefined) throw new Error("bearing is required");
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ function $f354dcb01154eb28$export$c41dd2a8460d3196(radians) {
    if (radians === null || radians === undefined) throw new Error("radians is required");
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ function $f354dcb01154eb28$export$c9fcf1a7df975d78(degrees) {
    if (degrees === null || degrees === undefined) throw new Error("degrees is required");
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {string} originalUnit of the length
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted length
 */ function $f354dcb01154eb28$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (length === null || length === undefined) throw new Error("length is required");
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $f354dcb01154eb28$export$f234631d6a2eedf8($f354dcb01154eb28$export$a2280f7debae8f10(length, originalUnit), finalUnit || "kilometers");
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
 * @param {number} area to be converted
 * @param {string} [originalUnit='meters'] of the distance
 * @param {string} [finalUnit='kilometers'] returned unit
 * @returns {number} the converted distance
 */ function $f354dcb01154eb28$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (area === null || area === undefined) throw new Error("area is required");
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $f354dcb01154eb28$export$44665ce4f7f4c82b[originalUnit || "meters"];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $f354dcb01154eb28$export$44665ce4f7f4c82b[finalUnit || "kilometers"];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ function $f354dcb01154eb28$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ function $f354dcb01154eb28$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ function $f354dcb01154eb28$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$f354dcb01154eb28$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ function $f354dcb01154eb28$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
// Deprecated methods
function $f354dcb01154eb28$export$b7eac44a74fbbf44() {
    throw new Error("method has been renamed to `radiansToDegrees`");
}
function $f354dcb01154eb28$export$429f6664de4d6783() {
    throw new Error("method has been renamed to `degreesToRadians`");
}
function $f354dcb01154eb28$export$682f47d8f6f8f330() {
    throw new Error("method has been renamed to `lengthToDegrees`");
}
function $f354dcb01154eb28$export$8fc0c652b1df31fd() {
    throw new Error("method has been renamed to `lengthToRadians`");
}
function $f354dcb01154eb28$export$dc0d90c052e1e7ea() {
    throw new Error("method has been renamed to `radiansToLength`");
}
function $f354dcb01154eb28$export$97a5bf601f8e0e61() {
    throw new Error("method has been renamed to `bearingToAzimuth`");
}
function $f354dcb01154eb28$export$1d848d23272abfae() {
    throw new Error("method has been renamed to `convertLength`");
}

});

parcelRegister("kbGTO", function(module, exports) {

$parcel$export(module.exports, "getCoord", function () { return $eb261ca02a4a3cd9$export$b4663c6e64a770bc; });

var $kTfmD = parcelRequire("kTfmD");
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ function $eb261ca02a4a3cd9$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
    if (coord.type === "Point") return coord.coordinates;
    if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === undefined && coord[1].length === undefined) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ function $eb261ca02a4a3cd9$export$39e042fd83f1b62e(coords) {
    if (!coords) throw new Error("coords is required");
    // Feature
    if (coords.type === "Feature" && coords.geometry !== null) return coords.geometry.coordinates;
    // Geometry
    if (coords.coordinates) return coords.coordinates;
    // Array of numbers
    if (Array.isArray(coords)) return coords;
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ function $eb261ca02a4a3cd9$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $kTfmD.isNumber)(coordinates[0]) && (0, $kTfmD.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $eb261ca02a4a3cd9$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $eb261ca02a4a3cd9$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ function $eb261ca02a4a3cd9$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ function $eb261ca02a4a3cd9$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var i = 0; i < featureCollection.features.length; i++){
        var feature = featureCollection.features[i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ function $eb261ca02a4a3cd9$export$b8f320eb9549c8fd(geojson) {
    if (!geojson) throw new Error("geojson is required");
    if (geojson.geometry !== undefined) return geojson.geometry;
    if (geojson.coordinates || geojson.geometries) return geojson;
    throw new Error("geojson must be a valid Feature or Geometry Object");
}
/**
 * Get Geometry Type from Feature or Geometry Object
 *
 * @throws {Error} **DEPRECATED** in v5.0.0 in favor of getType
 */ function $eb261ca02a4a3cd9$export$cf92de84f30da2c5() {
    throw new Error("invariant.getGeomType has been deprecated in v5.0 in favor of invariant.getType");
}
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ function $eb261ca02a4a3cd9$export$e2b5c5db9e2009fd(geojson, name) {
    if (!geojson) throw new Error((name || "geojson") + " is required");
    // GeoJSON Feature & GeometryCollection
    if (geojson.geometry && geojson.geometry.type) return geojson.geometry.type;
    // GeoJSON Geometry & FeatureCollection
    if (geojson.type) return geojson.type;
    throw new Error((name || "geojson") + " is invalid");
}

});



parcelRegister("eypkN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawEllipseUsingThreePointsMode = void 0;

var $a987e48fffaf6536$var$_distance = $a987e48fffaf6536$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $a987e48fffaf6536$var$_ellipse = $a987e48fffaf6536$var$_interopRequireDefault((parcelRequire("6dYcK")));

var $a987e48fffaf6536$var$_bearing = $a987e48fffaf6536$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $7GKQS = parcelRequire("7GKQS");

var $1tPZO = parcelRequire("1tPZO");

var $lQYvW = parcelRequire("lQYvW");
function $a987e48fffaf6536$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a987e48fffaf6536$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a987e48fffaf6536$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a987e48fffaf6536$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a987e48fffaf6536$var$_typeof(obj);
}
function $a987e48fffaf6536$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a987e48fffaf6536$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a987e48fffaf6536$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a987e48fffaf6536$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a987e48fffaf6536$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a987e48fffaf6536$var$_createSuper(Derived) {
    return function() {
        var Super = $a987e48fffaf6536$var$_getPrototypeOf(Derived), result;
        if ($a987e48fffaf6536$var$_isNativeReflectConstruct()) {
            var NewTarget = $a987e48fffaf6536$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a987e48fffaf6536$var$_possibleConstructorReturn(this, result);
    };
}
function $a987e48fffaf6536$var$_possibleConstructorReturn(self, call) {
    if (call && ($a987e48fffaf6536$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a987e48fffaf6536$var$_assertThisInitialized(self);
}
function $a987e48fffaf6536$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a987e48fffaf6536$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a987e48fffaf6536$var$_getPrototypeOf(o) {
    $a987e48fffaf6536$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a987e48fffaf6536$var$_getPrototypeOf(o);
}
function $a987e48fffaf6536$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a987e48fffaf6536$var$_setPrototypeOf(subClass, superClass);
}
function $a987e48fffaf6536$var$_setPrototypeOf(o, p) {
    $a987e48fffaf6536$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a987e48fffaf6536$var$_setPrototypeOf(o, p);
}
var $a987e48fffaf6536$var$DrawEllipseUsingThreePointsMode = /*#__PURE__*/ function(_ThreeClickPolygonMod) {
    $a987e48fffaf6536$var$_inherits(DrawEllipseUsingThreePointsMode, _ThreeClickPolygonMod);
    var _super = $a987e48fffaf6536$var$_createSuper(DrawEllipseUsingThreePointsMode);
    function DrawEllipseUsingThreePointsMode() {
        $a987e48fffaf6536$var$_classCallCheck(this, DrawEllipseUsingThreePointsMode);
        return _super.apply(this, arguments);
    }
    $a987e48fffaf6536$var$_createClass(DrawEllipseUsingThreePointsMode, [
        {
            key: "getThreeClickPolygon",
            value: function getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
                var centerCoordinates = (0, $1tPZO.getIntermediatePosition)(coord1, coord2);
                var xSemiAxis = Math.max((0, $a987e48fffaf6536$var$_distance["default"])(centerCoordinates, (0, $7GKQS.point)(coord3)), 0.001);
                var ySemiAxis = Math.max((0, $a987e48fffaf6536$var$_distance["default"])(coord1, coord2), 0.001) / 2;
                var options = {
                    angle: (0, $a987e48fffaf6536$var$_bearing["default"])(coord1, coord2)
                }; // @ts-ignore
                return (0, $a987e48fffaf6536$var$_ellipse["default"])(centerCoordinates, xSemiAxis, ySemiAxis, options);
            }
        }
    ]);
    return DrawEllipseUsingThreePointsMode;
}($lQYvW.ThreeClickPolygonMode);
module.exports.DrawEllipseUsingThreePointsMode = $a987e48fffaf6536$var$DrawEllipseUsingThreePointsMode;

});
parcelRegister("lQYvW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ThreeClickPolygonMode = void 0;

var $1tPZO = parcelRequire("1tPZO");
function $fe8d652587427aa1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fe8d652587427aa1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fe8d652587427aa1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fe8d652587427aa1$var$_typeof(obj);
}
function $fe8d652587427aa1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fe8d652587427aa1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fe8d652587427aa1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe8d652587427aa1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe8d652587427aa1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fe8d652587427aa1$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $fe8d652587427aa1$var$_get = Reflect.get;
    else $fe8d652587427aa1$var$_get = function _get(target, property, receiver) {
        var base = $fe8d652587427aa1$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $fe8d652587427aa1$var$_get(target, property, receiver || target);
}
function $fe8d652587427aa1$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $fe8d652587427aa1$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $fe8d652587427aa1$var$_createSuper(Derived) {
    return function() {
        var Super = $fe8d652587427aa1$var$_getPrototypeOf(Derived), result;
        if ($fe8d652587427aa1$var$_isNativeReflectConstruct()) {
            var NewTarget = $fe8d652587427aa1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fe8d652587427aa1$var$_possibleConstructorReturn(this, result);
    };
}
function $fe8d652587427aa1$var$_possibleConstructorReturn(self, call) {
    if (call && ($fe8d652587427aa1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fe8d652587427aa1$var$_assertThisInitialized(self);
}
function $fe8d652587427aa1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fe8d652587427aa1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fe8d652587427aa1$var$_getPrototypeOf(o) {
    $fe8d652587427aa1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fe8d652587427aa1$var$_getPrototypeOf(o);
}
function $fe8d652587427aa1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fe8d652587427aa1$var$_setPrototypeOf(subClass, superClass);
}
function $fe8d652587427aa1$var$_setPrototypeOf(o, p) {
    $fe8d652587427aa1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe8d652587427aa1$var$_setPrototypeOf(o, p);
}
var $fe8d652587427aa1$var$ThreeClickPolygonMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $fe8d652587427aa1$var$_inherits(ThreeClickPolygonMode, _GeoJsonEditMode);
    var _super = $fe8d652587427aa1$var$_createSuper(ThreeClickPolygonMode);
    function ThreeClickPolygonMode() {
        $fe8d652587427aa1$var$_classCallCheck(this, ThreeClickPolygonMode);
        return _super.apply(this, arguments);
    }
    $fe8d652587427aa1$var$_createClass(ThreeClickPolygonMode, [
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                this.addClickSequence(event);
                var clickSequence = this.getClickSequence();
                var tentativeFeature = this.getTentativeGuide(props);
                if (clickSequence.length > 2 && tentativeFeature && tentativeFeature.geometry.type === "Polygon") {
                    var editAction = this.getAddFeatureOrBooleanPolygonAction(tentativeFeature.geometry, props);
                    this.resetClickSequence();
                    if (editAction) props.onEdit(editAction);
                }
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var lastPointerMoveEvent = props.lastPointerMoveEvent, modeConfig = props.modeConfig;
                var clickSequence = this.getClickSequence();
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                if (clickSequence.length === 0) // nothing to do yet
                return guides;
                var hoveredCoord = lastPointerMoveEvent.mapCoords;
                if (clickSequence.length === 1) guides.features.push({
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [
                            clickSequence[0],
                            hoveredCoord
                        ]
                    }
                });
                else {
                    var polygon = this.getThreeClickPolygon(clickSequence[0], clickSequence[1], hoveredCoord, modeConfig);
                    if (polygon) guides.features.push({
                        type: "Feature",
                        properties: {
                            guideType: "tentative"
                        },
                        geometry: polygon.geometry
                    });
                }
                return guides;
            }
        },
        {
            key: "getThreeClickPolygon",
            value: function getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
                return null;
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
                $fe8d652587427aa1$var$_get($fe8d652587427aa1$var$_getPrototypeOf(ThreeClickPolygonMode.prototype), "handlePointerMove", this).call(this, event, props);
            }
        },
        {
            key: "createTentativeFeature",
            value: function createTentativeFeature(props) {
                var lastPointerMoveEvent = props.lastPointerMoveEvent;
                var clickSequence = this.getClickSequence();
                var lastCoords = lastPointerMoveEvent ? [
                    lastPointerMoveEvent.mapCoords
                ] : [];
                var tentativeFeature;
                if (clickSequence.length === 2) tentativeFeature = this.getThreeClickPolygon(clickSequence[0], clickSequence[1], lastCoords[0], props.modeConfig);
                return tentativeFeature;
            }
        }
    ]);
    return ThreeClickPolygonMode;
}($1tPZO.GeoJsonEditMode);
module.exports.ThreeClickPolygonMode = $fe8d652587427aa1$var$ThreeClickPolygonMode;

});


parcelRegister("9wvMY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawRectangleUsingThreePointsMode = void 0;

var $hs5Hv = parcelRequire("hs5Hv");

var $lQYvW = parcelRequire("lQYvW");
function $6eefc2d0db21dcfe$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6eefc2d0db21dcfe$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6eefc2d0db21dcfe$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6eefc2d0db21dcfe$var$_typeof(obj);
}
function $6eefc2d0db21dcfe$var$_slicedToArray(arr, i) {
    return $6eefc2d0db21dcfe$var$_arrayWithHoles(arr) || $6eefc2d0db21dcfe$var$_iterableToArrayLimit(arr, i) || $6eefc2d0db21dcfe$var$_unsupportedIterableToArray(arr, i) || $6eefc2d0db21dcfe$var$_nonIterableRest();
}
function $6eefc2d0db21dcfe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6eefc2d0db21dcfe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6eefc2d0db21dcfe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6eefc2d0db21dcfe$var$_arrayLikeToArray(o, minLen);
}
function $6eefc2d0db21dcfe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6eefc2d0db21dcfe$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6eefc2d0db21dcfe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6eefc2d0db21dcfe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6eefc2d0db21dcfe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6eefc2d0db21dcfe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6eefc2d0db21dcfe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6eefc2d0db21dcfe$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6eefc2d0db21dcfe$var$_createSuper(Derived) {
    return function() {
        var Super = $6eefc2d0db21dcfe$var$_getPrototypeOf(Derived), result;
        if ($6eefc2d0db21dcfe$var$_isNativeReflectConstruct()) {
            var NewTarget = $6eefc2d0db21dcfe$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6eefc2d0db21dcfe$var$_possibleConstructorReturn(this, result);
    };
}
function $6eefc2d0db21dcfe$var$_possibleConstructorReturn(self, call) {
    if (call && ($6eefc2d0db21dcfe$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6eefc2d0db21dcfe$var$_assertThisInitialized(self);
}
function $6eefc2d0db21dcfe$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6eefc2d0db21dcfe$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6eefc2d0db21dcfe$var$_getPrototypeOf(o) {
    $6eefc2d0db21dcfe$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6eefc2d0db21dcfe$var$_getPrototypeOf(o);
}
function $6eefc2d0db21dcfe$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6eefc2d0db21dcfe$var$_setPrototypeOf(subClass, superClass);
}
function $6eefc2d0db21dcfe$var$_setPrototypeOf(o, p) {
    $6eefc2d0db21dcfe$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6eefc2d0db21dcfe$var$_setPrototypeOf(o, p);
}
var $6eefc2d0db21dcfe$var$DrawRectangleUsingThreePointsMode = /*#__PURE__*/ function(_ThreeClickPolygonMod) {
    $6eefc2d0db21dcfe$var$_inherits(DrawRectangleUsingThreePointsMode, _ThreeClickPolygonMod);
    var _super = $6eefc2d0db21dcfe$var$_createSuper(DrawRectangleUsingThreePointsMode);
    function DrawRectangleUsingThreePointsMode() {
        $6eefc2d0db21dcfe$var$_classCallCheck(this, DrawRectangleUsingThreePointsMode);
        return _super.apply(this, arguments);
    }
    $6eefc2d0db21dcfe$var$_createClass(DrawRectangleUsingThreePointsMode, [
        {
            key: "getThreeClickPolygon",
            value: function getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
                var _generatePointsParall = (0, $hs5Hv.generatePointsParallelToLinePoints)(coord1, coord2, coord3), _generatePointsParall2 = $6eefc2d0db21dcfe$var$_slicedToArray(_generatePointsParall, 2), p3 = _generatePointsParall2[0], p4 = _generatePointsParall2[1];
                return {
                    type: "Feature",
                    properties: {
                        shape: "Rectangle"
                    },
                    geometry: {
                        type: "Polygon",
                        coordinates: [
                            [
                                // then the points orthogonal to the lineString,
                                // then back to the starting position
                                coord1,
                                coord2,
                                p3,
                                p4,
                                coord1
                            ]
                        ]
                    }
                };
            }
        }
    ]);
    return DrawRectangleUsingThreePointsMode;
}($lQYvW.ThreeClickPolygonMode);
module.exports.DrawRectangleUsingThreePointsMode = $6eefc2d0db21dcfe$var$DrawRectangleUsingThreePointsMode;

});

parcelRegister("9qPDu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Draw90DegreePolygonMode = void 0;

var $6dde9895d5d6c828$var$_destination = $6dde9895d5d6c828$var$_interopRequireDefault((parcelRequire("1UAWS")));

var $6dde9895d5d6c828$var$_bearing = $6dde9895d5d6c828$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $6dde9895d5d6c828$var$_lineIntersect = $6dde9895d5d6c828$var$_interopRequireDefault((parcelRequire("iXvoQ")));

var $6dde9895d5d6c828$var$_distance = $6dde9895d5d6c828$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $7GKQS = parcelRequire("7GKQS");

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");
function $6dde9895d5d6c828$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6dde9895d5d6c828$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6dde9895d5d6c828$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6dde9895d5d6c828$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6dde9895d5d6c828$var$_typeof(obj);
}
function $6dde9895d5d6c828$var$_toConsumableArray(arr) {
    return $6dde9895d5d6c828$var$_arrayWithoutHoles(arr) || $6dde9895d5d6c828$var$_iterableToArray(arr) || $6dde9895d5d6c828$var$_unsupportedIterableToArray(arr) || $6dde9895d5d6c828$var$_nonIterableSpread();
}
function $6dde9895d5d6c828$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6dde9895d5d6c828$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $6dde9895d5d6c828$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6dde9895d5d6c828$var$_arrayLikeToArray(arr);
}
function $6dde9895d5d6c828$var$_slicedToArray(arr, i) {
    return $6dde9895d5d6c828$var$_arrayWithHoles(arr) || $6dde9895d5d6c828$var$_iterableToArrayLimit(arr, i) || $6dde9895d5d6c828$var$_unsupportedIterableToArray(arr, i) || $6dde9895d5d6c828$var$_nonIterableRest();
}
function $6dde9895d5d6c828$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6dde9895d5d6c828$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6dde9895d5d6c828$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6dde9895d5d6c828$var$_arrayLikeToArray(o, minLen);
}
function $6dde9895d5d6c828$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6dde9895d5d6c828$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6dde9895d5d6c828$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6dde9895d5d6c828$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6dde9895d5d6c828$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6dde9895d5d6c828$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6dde9895d5d6c828$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6dde9895d5d6c828$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6dde9895d5d6c828$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $6dde9895d5d6c828$var$_get = Reflect.get;
    else $6dde9895d5d6c828$var$_get = function _get(target, property, receiver) {
        var base = $6dde9895d5d6c828$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $6dde9895d5d6c828$var$_get(target, property, receiver || target);
}
function $6dde9895d5d6c828$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $6dde9895d5d6c828$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $6dde9895d5d6c828$var$_createSuper(Derived) {
    return function() {
        var Super = $6dde9895d5d6c828$var$_getPrototypeOf(Derived), result;
        if ($6dde9895d5d6c828$var$_isNativeReflectConstruct()) {
            var NewTarget = $6dde9895d5d6c828$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6dde9895d5d6c828$var$_possibleConstructorReturn(this, result);
    };
}
function $6dde9895d5d6c828$var$_possibleConstructorReturn(self, call) {
    if (call && ($6dde9895d5d6c828$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6dde9895d5d6c828$var$_assertThisInitialized(self);
}
function $6dde9895d5d6c828$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6dde9895d5d6c828$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6dde9895d5d6c828$var$_getPrototypeOf(o) {
    $6dde9895d5d6c828$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6dde9895d5d6c828$var$_getPrototypeOf(o);
}
function $6dde9895d5d6c828$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6dde9895d5d6c828$var$_setPrototypeOf(subClass, superClass);
}
function $6dde9895d5d6c828$var$_setPrototypeOf(o, p) {
    $6dde9895d5d6c828$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6dde9895d5d6c828$var$_setPrototypeOf(o, p);
}
var $6dde9895d5d6c828$var$Draw90DegreePolygonMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $6dde9895d5d6c828$var$_inherits(Draw90DegreePolygonMode, _GeoJsonEditMode);
    var _super = $6dde9895d5d6c828$var$_createSuper(Draw90DegreePolygonMode);
    function Draw90DegreePolygonMode() {
        $6dde9895d5d6c828$var$_classCallCheck(this, Draw90DegreePolygonMode);
        return _super.apply(this, arguments);
    }
    $6dde9895d5d6c828$var$_createClass(Draw90DegreePolygonMode, [
        {
            key: "createTentativeFeature",
            value: function createTentativeFeature(props) {
                var clickSequence = this.getClickSequence();
                var mapCoords = props.lastPointerMoveEvent.mapCoords;
                var p3;
                if (clickSequence.length === 1) p3 = mapCoords;
                else {
                    var p1 = clickSequence[clickSequence.length - 2];
                    var p2 = clickSequence[clickSequence.length - 1];
                    var _generatePointsParall = (0, $hs5Hv.generatePointsParallelToLinePoints)(p1, p2, mapCoords);
                    var _generatePointsParall2 = $6dde9895d5d6c828$var$_slicedToArray(_generatePointsParall, 1);
                    p3 = _generatePointsParall2[0];
                }
                var tentativeFeature;
                if (clickSequence.length < 3) // Draw a LineString connecting all the clicked points with the hovered point
                tentativeFeature = {
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [].concat($6dde9895d5d6c828$var$_toConsumableArray(clickSequence), [
                            p3
                        ])
                    }
                };
                else // Draw a Polygon connecting all the clicked points with the hovered point
                tentativeFeature = {
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "Polygon",
                        coordinates: [
                            [].concat($6dde9895d5d6c828$var$_toConsumableArray(clickSequence), [
                                p3,
                                clickSequence[0]
                            ])
                        ]
                    }
                };
                return tentativeFeature;
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                var clickSequence = this.getClickSequence();
                if (clickSequence.length === 0 || !props.lastPointerMoveEvent) return guides;
                var tentativeFeature = this.createTentativeFeature(props);
                guides.features.push(tentativeFeature);
                guides.features = guides.features.concat((0, $hs5Hv.getEditHandlesForGeometry)(tentativeFeature.geometry, -1)); // Slice off the handles that are are next to the pointer
                guides.features = guides.features.slice(0, -1);
                return guides;
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
                $6dde9895d5d6c828$var$_get($6dde9895d5d6c828$var$_getPrototypeOf(Draw90DegreePolygonMode.prototype), "handlePointerMove", this).call(this, event, props);
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var picks = event.picks;
                var tentativeFeature = this.getTentativeGuide(props);
                this.addClickSequence(event);
                var clickSequence = this.getClickSequence();
                if (!tentativeFeature) // nothing else to do
                return;
                if (clickSequence.length === 3 && tentativeFeature.geometry.type === "LineString") {
                    var lineString = tentativeFeature.geometry; // Tweak the clicked position to be the snapped 90 degree point along the polygon
                    clickSequence[clickSequence.length - 1] = lineString.coordinates[lineString.coordinates.length - 1];
                } else if (clickSequence.length > 3 && tentativeFeature.geometry.type === "Polygon") {
                    var polygon = tentativeFeature.geometry; // Tweak the clicked position to be the snapped 90 degree point along the polygon
                    clickSequence[clickSequence.length - 1] = polygon.coordinates[0][polygon.coordinates[0].length - 2];
                    var clickedEditHandle = (0, $hs5Hv.getPickedEditHandle)(picks);
                    if (clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && (clickedEditHandle.properties.positionIndexes[1] === 0 || clickedEditHandle.properties.positionIndexes[1] === polygon.coordinates[0].length - 3)) {
                        // They clicked the first or last point (or double-clicked), so complete the polygon
                        var polygonToAdd = {
                            type: "Polygon",
                            coordinates: this.finalizedCoordinates($6dde9895d5d6c828$var$_toConsumableArray(polygon.coordinates[0]))
                        };
                        this.resetClickSequence();
                        var editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
                        if (editAction) props.onEdit(editAction);
                    }
                } // Trigger pointer move right away in order for it to update edit handles (to support double-click)
                var fakePointerMoveEvent = {
                    screenCoords: [
                        -1,
                        -1
                    ],
                    mapCoords: event.mapCoords,
                    picks: [],
                    pointerDownPicks: null,
                    pointerDownScreenCoords: null,
                    pointerDownMapCoords: null,
                    cancelPan: function cancelPan() {},
                    sourceEvent: null
                };
                this.handlePointerMove(fakePointerMoveEvent, props);
            }
        },
        {
            key: "finalizedCoordinates",
            value: function finalizedCoordinates(coords) {
                // Remove the hovered position
                var coordinates = [
                    [].concat($6dde9895d5d6c828$var$_toConsumableArray(coords.slice(0, -2)), [
                        coords[0]
                    ])
                ];
                var pt = this.getIntermediatePoint($6dde9895d5d6c828$var$_toConsumableArray(coords));
                if (!pt) {
                    // if intermediate point with 90 degree not available
                    // try remove the last clicked point and get the intermediate point.
                    var tc = $6dde9895d5d6c828$var$_toConsumableArray(coords);
                    tc.splice(-3, 1);
                    pt = this.getIntermediatePoint($6dde9895d5d6c828$var$_toConsumableArray(tc));
                    if (pt) coordinates = [
                        [].concat($6dde9895d5d6c828$var$_toConsumableArray(coords.slice(0, -3)), [
                            pt,
                            coords[0]
                        ])
                    ];
                } else coordinates = [
                    [].concat($6dde9895d5d6c828$var$_toConsumableArray(coords.slice(0, -2)), [
                        pt,
                        coords[0]
                    ])
                ];
                return coordinates;
            }
        },
        {
            key: "getIntermediatePoint",
            value: function getIntermediatePoint(coordinates) {
                var pt;
                if (coordinates.length > 4) {
                    var _ref = $6dde9895d5d6c828$var$_toConsumableArray(coordinates), p1 = _ref[0], p2 = _ref[1];
                    var angle1 = (0, $6dde9895d5d6c828$var$_bearing["default"])(p1, p2);
                    var p3 = coordinates[coordinates.length - 3];
                    var p4 = coordinates[coordinates.length - 4];
                    var angle2 = (0, $6dde9895d5d6c828$var$_bearing["default"])(p3, p4);
                    var angles = {
                        first: [],
                        second: []
                    }; // calculate 3 right angle points for first and last points in lineString
                    [
                        1,
                        2,
                        3
                    ].forEach(function(factor) {
                        var newAngle1 = angle1 + factor * 90; // convert angles to 0 to -180 for anti-clock and 0 to 180 for clock wise
                        angles.first.push(newAngle1 > 180 ? newAngle1 - 360 : newAngle1);
                        var newAngle2 = angle2 + factor * 90;
                        angles.second.push(newAngle2 > 180 ? newAngle2 - 360 : newAngle2);
                    });
                    var distance = (0, $6dde9895d5d6c828$var$_distance["default"])((0, $7GKQS.point)(p1), (0, $7GKQS.point)(p3)); // Draw imaginary right angle lines for both first and last points in lineString
                    // If there is intersection point for any 2 lines, will be the 90 degree point.
                    [
                        0,
                        1,
                        2
                    ].forEach(function(indexFirst) {
                        var line1 = (0, $7GKQS.lineString)([
                            p1,
                            (0, $6dde9895d5d6c828$var$_destination["default"])(p1, distance, angles.first[indexFirst]).geometry.coordinates
                        ]);
                        [
                            0,
                            1,
                            2
                        ].forEach(function(indexSecond) {
                            var line2 = (0, $7GKQS.lineString)([
                                p3,
                                (0, $6dde9895d5d6c828$var$_destination["default"])(p3, distance, angles.second[indexSecond]).geometry.coordinates
                            ]);
                            var fc = (0, $6dde9895d5d6c828$var$_lineIntersect["default"])(line1, line2);
                            if (fc && fc.features.length) // found the intersect point
                            pt = fc.features[0].geometry.coordinates;
                        });
                    });
                }
                return pt;
            }
        }
    ]);
    return Draw90DegreePolygonMode;
}($1tPZO.GeoJsonEditMode);
module.exports.Draw90DegreePolygonMode = $6dde9895d5d6c828$var$Draw90DegreePolygonMode;

});

parcelRegister("kfRKf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrawPolygonByDraggingMode = void 0;

var $ebeee5f81c1adf90$var$_lodash = $ebeee5f81c1adf90$var$_interopRequireDefault((parcelRequire("3DqGr")));

var $hs5Hv = parcelRequire("hs5Hv");

var $fVfme = parcelRequire("fVfme");
function $ebeee5f81c1adf90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ebeee5f81c1adf90$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ebeee5f81c1adf90$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ebeee5f81c1adf90$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ebeee5f81c1adf90$var$_typeof(obj);
}
function $ebeee5f81c1adf90$var$_toConsumableArray(arr) {
    return $ebeee5f81c1adf90$var$_arrayWithoutHoles(arr) || $ebeee5f81c1adf90$var$_iterableToArray(arr) || $ebeee5f81c1adf90$var$_unsupportedIterableToArray(arr) || $ebeee5f81c1adf90$var$_nonIterableSpread();
}
function $ebeee5f81c1adf90$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ebeee5f81c1adf90$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ebeee5f81c1adf90$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ebeee5f81c1adf90$var$_arrayLikeToArray(o, minLen);
}
function $ebeee5f81c1adf90$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $ebeee5f81c1adf90$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ebeee5f81c1adf90$var$_arrayLikeToArray(arr);
}
function $ebeee5f81c1adf90$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ebeee5f81c1adf90$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ebeee5f81c1adf90$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ebeee5f81c1adf90$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ebeee5f81c1adf90$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ebeee5f81c1adf90$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ebeee5f81c1adf90$var$_createSuper(Derived) {
    return function() {
        var Super = $ebeee5f81c1adf90$var$_getPrototypeOf(Derived), result;
        if ($ebeee5f81c1adf90$var$_isNativeReflectConstruct()) {
            var NewTarget = $ebeee5f81c1adf90$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ebeee5f81c1adf90$var$_possibleConstructorReturn(this, result);
    };
}
function $ebeee5f81c1adf90$var$_possibleConstructorReturn(self, call) {
    if (call && ($ebeee5f81c1adf90$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ebeee5f81c1adf90$var$_assertThisInitialized(self);
}
function $ebeee5f81c1adf90$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ebeee5f81c1adf90$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ebeee5f81c1adf90$var$_getPrototypeOf(o) {
    $ebeee5f81c1adf90$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ebeee5f81c1adf90$var$_getPrototypeOf(o);
}
function $ebeee5f81c1adf90$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ebeee5f81c1adf90$var$_setPrototypeOf(subClass, superClass);
}
function $ebeee5f81c1adf90$var$_setPrototypeOf(o, p) {
    $ebeee5f81c1adf90$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ebeee5f81c1adf90$var$_setPrototypeOf(o, p);
}
function $ebeee5f81c1adf90$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ebeee5f81c1adf90$var$DrawPolygonByDraggingMode = /*#__PURE__*/ function(_DrawPolygonMode) {
    $ebeee5f81c1adf90$var$_inherits(DrawPolygonByDraggingMode, _DrawPolygonMode);
    var _super = $ebeee5f81c1adf90$var$_createSuper(DrawPolygonByDraggingMode);
    function DrawPolygonByDraggingMode() {
        var _this;
        $ebeee5f81c1adf90$var$_classCallCheck(this, DrawPolygonByDraggingMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $ebeee5f81c1adf90$var$_defineProperty($ebeee5f81c1adf90$var$_assertThisInitialized(_this), "handleDraggingThrottled", null);
        return _this;
    }
    $ebeee5f81c1adf90$var$_createClass(DrawPolygonByDraggingMode, [
        {
            key: "handleClick",
            value: function handleClick(event, props) {}
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                event.cancelPan();
                if (props.modeConfig && props.modeConfig.throttleMs) this.handleDraggingThrottled = (0, $ebeee5f81c1adf90$var$_lodash["default"])(this.handleDraggingAux, props.modeConfig.throttleMs);
                else this.handleDraggingThrottled = this.handleDraggingAux;
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                this.addClickSequence(event);
                var clickSequence = this.getClickSequence(); // @ts-ignore
                if (this.handleDraggingThrottled && this.handleDraggingThrottled.cancel) // @ts-ignore
                this.handleDraggingThrottled.cancel();
                if (clickSequence.length > 2) {
                    // Complete the polygon.
                    var polygonToAdd = {
                        type: "Polygon",
                        coordinates: [
                            [].concat($ebeee5f81c1adf90$var$_toConsumableArray(clickSequence), [
                                clickSequence[0]
                            ])
                        ]
                    };
                    this.resetClickSequence();
                    var editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
                    if (editAction) props.onEdit(editAction);
                }
            }
        },
        {
            key: "handleDraggingAux",
            value: function handleDraggingAux(event, props) {
                var picks = event.picks;
                var clickedEditHandle = (0, $hs5Hv.getPickedEditHandle)(picks);
                if (!clickedEditHandle) // Don't add another point right next to an existing one.
                this.addClickSequence(event);
            }
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                if (this.handleDraggingThrottled) this.handleDraggingThrottled(event, props);
            }
        }
    ]);
    return DrawPolygonByDraggingMode;
}($fVfme.DrawPolygonMode);
module.exports.DrawPolygonByDraggingMode = $ebeee5f81c1adf90$var$DrawPolygonByDraggingMode;

});
parcelRegister("3DqGr", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $2a59b66d4da7b2c1$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $2a59b66d4da7b2c1$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $2a59b66d4da7b2c1$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $2a59b66d4da7b2c1$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $2a59b66d4da7b2c1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $2a59b66d4da7b2c1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $2a59b66d4da7b2c1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $2a59b66d4da7b2c1$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $2a59b66d4da7b2c1$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $2a59b66d4da7b2c1$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2a59b66d4da7b2c1$var$root = $2a59b66d4da7b2c1$var$freeGlobal || $2a59b66d4da7b2c1$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $2a59b66d4da7b2c1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2a59b66d4da7b2c1$var$objectToString = $2a59b66d4da7b2c1$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2a59b66d4da7b2c1$var$nativeMax = Math.max, $2a59b66d4da7b2c1$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2a59b66d4da7b2c1$var$now = function() {
    return $2a59b66d4da7b2c1$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $2a59b66d4da7b2c1$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($2a59b66d4da7b2c1$var$FUNC_ERROR_TEXT);
    wait = $2a59b66d4da7b2c1$var$toNumber(wait) || 0;
    if ($2a59b66d4da7b2c1$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $2a59b66d4da7b2c1$var$nativeMax($2a59b66d4da7b2c1$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $2a59b66d4da7b2c1$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $2a59b66d4da7b2c1$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($2a59b66d4da7b2c1$var$now());
    }
    function debounced() {
        var time = $2a59b66d4da7b2c1$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $2a59b66d4da7b2c1$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($2a59b66d4da7b2c1$var$FUNC_ERROR_TEXT);
    if ($2a59b66d4da7b2c1$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $2a59b66d4da7b2c1$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2a59b66d4da7b2c1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2a59b66d4da7b2c1$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2a59b66d4da7b2c1$var$isSymbol(value) {
    return typeof value == "symbol" || $2a59b66d4da7b2c1$var$isObjectLike(value) && $2a59b66d4da7b2c1$var$objectToString.call(value) == $2a59b66d4da7b2c1$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $2a59b66d4da7b2c1$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($2a59b66d4da7b2c1$var$isSymbol(value)) return $2a59b66d4da7b2c1$var$NAN;
    if ($2a59b66d4da7b2c1$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $2a59b66d4da7b2c1$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($2a59b66d4da7b2c1$var$reTrim, "");
    var isBinary = $2a59b66d4da7b2c1$var$reIsBinary.test(value);
    return isBinary || $2a59b66d4da7b2c1$var$reIsOctal.test(value) ? $2a59b66d4da7b2c1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $2a59b66d4da7b2c1$var$reIsBadHex.test(value) ? $2a59b66d4da7b2c1$var$NAN : +value;
}
module.exports = $2a59b66d4da7b2c1$var$throttle;

});


parcelRegister("ksxR2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ViewMode = void 0;

var $1tPZO = parcelRequire("1tPZO");
function $ee50aef087047888$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ee50aef087047888$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ee50aef087047888$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ee50aef087047888$var$_typeof(obj);
}
function $ee50aef087047888$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ee50aef087047888$var$_createSuper(Derived) {
    return function() {
        var Super = $ee50aef087047888$var$_getPrototypeOf(Derived), result;
        if ($ee50aef087047888$var$_isNativeReflectConstruct()) {
            var NewTarget = $ee50aef087047888$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ee50aef087047888$var$_possibleConstructorReturn(this, result);
    };
}
function $ee50aef087047888$var$_possibleConstructorReturn(self, call) {
    if (call && ($ee50aef087047888$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ee50aef087047888$var$_assertThisInitialized(self);
}
function $ee50aef087047888$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ee50aef087047888$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ee50aef087047888$var$_getPrototypeOf(o) {
    $ee50aef087047888$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ee50aef087047888$var$_getPrototypeOf(o);
}
function $ee50aef087047888$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ee50aef087047888$var$_setPrototypeOf(subClass, superClass);
}
function $ee50aef087047888$var$_setPrototypeOf(o, p) {
    $ee50aef087047888$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ee50aef087047888$var$_setPrototypeOf(o, p);
}
var $ee50aef087047888$var$ViewMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $ee50aef087047888$var$_inherits(ViewMode, _GeoJsonEditMode);
    var _super = $ee50aef087047888$var$_createSuper(ViewMode);
    function ViewMode() {
        $ee50aef087047888$var$_classCallCheck(this, ViewMode);
        return _super.apply(this, arguments);
    }
    return ViewMode;
}($1tPZO.GeoJsonEditMode);
module.exports.ViewMode = $ee50aef087047888$var$ViewMode;

});

parcelRegister("hva1l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeasureDistanceMode = void 0;

var $cbdd1ad6c7eac60d$var$_distance = $cbdd1ad6c7eac60d$var$_interopRequireDefault((parcelRequire("b5wF2")));

var $cbdd1ad6c7eac60d$var$_midpoint = $cbdd1ad6c7eac60d$var$_interopRequireDefault((parcelRequire("k2FWh")));

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");
function $cbdd1ad6c7eac60d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $cbdd1ad6c7eac60d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cbdd1ad6c7eac60d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cbdd1ad6c7eac60d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cbdd1ad6c7eac60d$var$_typeof(obj);
}
function $cbdd1ad6c7eac60d$var$_toConsumableArray(arr) {
    return $cbdd1ad6c7eac60d$var$_arrayWithoutHoles(arr) || $cbdd1ad6c7eac60d$var$_iterableToArray(arr) || $cbdd1ad6c7eac60d$var$_unsupportedIterableToArray(arr) || $cbdd1ad6c7eac60d$var$_nonIterableSpread();
}
function $cbdd1ad6c7eac60d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cbdd1ad6c7eac60d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cbdd1ad6c7eac60d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cbdd1ad6c7eac60d$var$_arrayLikeToArray(o, minLen);
}
function $cbdd1ad6c7eac60d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $cbdd1ad6c7eac60d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cbdd1ad6c7eac60d$var$_arrayLikeToArray(arr);
}
function $cbdd1ad6c7eac60d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cbdd1ad6c7eac60d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cbdd1ad6c7eac60d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbdd1ad6c7eac60d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cbdd1ad6c7eac60d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbdd1ad6c7eac60d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cbdd1ad6c7eac60d$var$_createSuper(Derived) {
    return function() {
        var Super = $cbdd1ad6c7eac60d$var$_getPrototypeOf(Derived), result;
        if ($cbdd1ad6c7eac60d$var$_isNativeReflectConstruct()) {
            var NewTarget = $cbdd1ad6c7eac60d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cbdd1ad6c7eac60d$var$_possibleConstructorReturn(this, result);
    };
}
function $cbdd1ad6c7eac60d$var$_possibleConstructorReturn(self, call) {
    if (call && ($cbdd1ad6c7eac60d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cbdd1ad6c7eac60d$var$_assertThisInitialized(self);
}
function $cbdd1ad6c7eac60d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cbdd1ad6c7eac60d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cbdd1ad6c7eac60d$var$_getPrototypeOf(o) {
    $cbdd1ad6c7eac60d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cbdd1ad6c7eac60d$var$_getPrototypeOf(o);
}
function $cbdd1ad6c7eac60d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cbdd1ad6c7eac60d$var$_setPrototypeOf(subClass, superClass);
}
function $cbdd1ad6c7eac60d$var$_setPrototypeOf(o, p) {
    $cbdd1ad6c7eac60d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cbdd1ad6c7eac60d$var$_setPrototypeOf(o, p);
}
function $cbdd1ad6c7eac60d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cbdd1ad6c7eac60d$var$MeasureDistanceMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $cbdd1ad6c7eac60d$var$_inherits(MeasureDistanceMode, _GeoJsonEditMode);
    var _super = $cbdd1ad6c7eac60d$var$_createSuper(MeasureDistanceMode);
    function MeasureDistanceMode() {
        var _this;
        $cbdd1ad6c7eac60d$var$_classCallCheck(this, MeasureDistanceMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $cbdd1ad6c7eac60d$var$_defineProperty($cbdd1ad6c7eac60d$var$_assertThisInitialized(_this), "_isMeasuringSessionFinished", false);
        $cbdd1ad6c7eac60d$var$_defineProperty($cbdd1ad6c7eac60d$var$_assertThisInitialized(_this), "_currentTooltips", []);
        $cbdd1ad6c7eac60d$var$_defineProperty($cbdd1ad6c7eac60d$var$_assertThisInitialized(_this), "_currentDistance", 0);
        $cbdd1ad6c7eac60d$var$_defineProperty($cbdd1ad6c7eac60d$var$_assertThisInitialized(_this), "_calculateDistanceForTooltip", function(_ref) {
            var positionA = _ref.positionA, positionB = _ref.positionB, modeConfig = _ref.modeConfig;
            var _ref2 = modeConfig || {}, turfOptions = _ref2.turfOptions, measurementCallback = _ref2.measurementCallback;
            var distance = (0, $cbdd1ad6c7eac60d$var$_distance["default"])(positionA, positionB, turfOptions);
            if (measurementCallback) measurementCallback(distance);
            return distance;
        });
        return _this;
    }
    $cbdd1ad6c7eac60d$var$_createClass(MeasureDistanceMode, [
        {
            key: "_formatTooltip",
            value: function _formatTooltip(distance, modeConfig) {
                var _ref3 = modeConfig || {}, formatTooltip = _ref3.formatTooltip, turfOptions = _ref3.turfOptions;
                var units = turfOptions && turfOptions.units || "kilometers";
                var text;
                if (formatTooltip) text = formatTooltip(distance);
                else // By default, round to 2 decimal places and append units
                text = "".concat(parseFloat(distance).toFixed(2), " ").concat(units);
                return text;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var modeConfig = props.modeConfig, data = props.data, onEdit = props.onEdit;
                var _ref4 = modeConfig || {}, _ref4$centerTooltipsO = _ref4.centerTooltipsOnLine, centerTooltipsOnLine = _ref4$centerTooltipsO === void 0 ? false : _ref4$centerTooltipsO; // restart measuring session
                if (this._isMeasuringSessionFinished) {
                    this._isMeasuringSessionFinished = false;
                    this.resetClickSequence();
                    this._currentTooltips = [];
                    this._currentDistance = 0;
                }
                var picks = event.picks;
                var clickedEditHandle = (0, $hs5Hv.getPickedEditHandle)(picks);
                var positionAdded = false;
                if (!clickedEditHandle) {
                    // Don't add another point right next to an existing one
                    this.addClickSequence(event);
                    positionAdded = true;
                }
                var clickSequence = this.getClickSequence();
                if (clickSequence.length > 1 && clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && clickedEditHandle.properties.positionIndexes[0] === clickSequence.length - 1) // They clicked the last point (or double-clicked), so add the LineString
                this._isMeasuringSessionFinished = true;
                else if (positionAdded) {
                    if (clickSequence.length > 1) {
                        this._currentDistance += this._calculateDistanceForTooltip({
                            positionA: clickSequence[clickSequence.length - 2],
                            positionB: clickSequence[clickSequence.length - 1],
                            modeConfig: modeConfig
                        });
                        var tooltipPosition = centerTooltipsOnLine ? (0, $cbdd1ad6c7eac60d$var$_midpoint["default"])(clickSequence[clickSequence.length - 2], clickSequence[clickSequence.length - 1]).geometry.coordinates : event.mapCoords;
                        this._currentTooltips.push({
                            position: tooltipPosition,
                            text: this._formatTooltip(this._currentDistance, modeConfig)
                        });
                    } // new tentative point
                    onEdit({
                        // data is the same
                        updatedData: data,
                        editType: "addTentativePosition",
                        editContext: {
                            position: event.mapCoords
                        }
                    });
                }
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(event, props) {
                if (this._isMeasuringSessionFinished) return;
                event.stopPropagation();
                var key = event.key;
                var clickSequenceLength = this.getClickSequence().length;
                switch(key){
                    case "Escape":
                        this._isMeasuringSessionFinished = true;
                        if (clickSequenceLength === 1) {
                            this.resetClickSequence();
                            this._currentTooltips = [];
                        } // force update drawings
                        props.onUpdateCursor("cell");
                        break;
                    case "Enter":
                        this.handleClick(props.lastPointerMoveEvent, props);
                        this._isMeasuringSessionFinished = true;
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var _guides$features;
                var lastPointerMoveEvent = props.lastPointerMoveEvent;
                var clickSequence = this.getClickSequence();
                var lastCoords = lastPointerMoveEvent && !this._isMeasuringSessionFinished ? [
                    lastPointerMoveEvent.mapCoords
                ] : [];
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                if (clickSequence.length > 0) guides.features.push({
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [].concat($cbdd1ad6c7eac60d$var$_toConsumableArray(clickSequence), lastCoords)
                    }
                });
                var editHandles = clickSequence.map(function(clickedCoord, index) {
                    return {
                        type: "Feature",
                        properties: {
                            guideType: "editHandle",
                            editHandleType: "existing",
                            featureIndex: -1,
                            positionIndexes: [
                                index
                            ]
                        },
                        geometry: {
                            type: "Point",
                            coordinates: clickedCoord
                        }
                    };
                });
                (_guides$features = guides.features).push.apply(_guides$features, $cbdd1ad6c7eac60d$var$_toConsumableArray(editHandles)); // @ts-ignore
                return guides;
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
            }
        },
        {
            key: "getTooltips",
            value: function getTooltips(props) {
                var lastPointerMoveEvent = props.lastPointerMoveEvent, modeConfig = props.modeConfig;
                var _ref5 = modeConfig || {}, _ref5$centerTooltipsO = _ref5.centerTooltipsOnLine, centerTooltipsOnLine = _ref5$centerTooltipsO === void 0 ? false : _ref5$centerTooltipsO;
                var positions = this.getClickSequence();
                if (positions.length > 0 && lastPointerMoveEvent && !this._isMeasuringSessionFinished) {
                    var distance = this._calculateDistanceForTooltip({
                        positionA: positions[positions.length - 1],
                        positionB: lastPointerMoveEvent.mapCoords,
                        modeConfig: props.modeConfig
                    });
                    var tooltipPosition = centerTooltipsOnLine ? (0, $cbdd1ad6c7eac60d$var$_midpoint["default"])(positions[positions.length - 1], lastPointerMoveEvent.mapCoords).geometry.coordinates : lastPointerMoveEvent.mapCoords;
                    return [].concat($cbdd1ad6c7eac60d$var$_toConsumableArray(this._currentTooltips), [
                        {
                            position: tooltipPosition,
                            text: this._formatTooltip(this._currentDistance + distance, modeConfig)
                        }
                    ]);
                }
                return this._currentTooltips;
            }
        }
    ]);
    return MeasureDistanceMode;
}($1tPZO.GeoJsonEditMode);
module.exports.MeasureDistanceMode = $cbdd1ad6c7eac60d$var$MeasureDistanceMode;

});
parcelRegister("k2FWh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $03c3f1a83bad9469$export$2e2bcd8739ae039; });

var $fIrif = parcelRequire("fIrif");

var $6mkzC = parcelRequire("6mkzC");

var $3mqzs = parcelRequire("3mqzs");
/**
 * Takes two {@link Point|points} and returns a point midway between them.
 * The midpoint is calculated geodesically, meaning the curvature of the earth is taken into account.
 *
 * @name midpoint
 * @param {Coord} point1 first point
 * @param {Coord} point2 second point
 * @returns {Feature<Point>} a point midway between `pt1` and `pt2`
 * @example
 * var point1 = turf.point([144.834823, -37.771257]);
 * var point2 = turf.point([145.14244, -37.830937]);
 *
 * var midpoint = turf.midpoint(point1, point2);
 *
 * //addToMap
 * var addToMap = [point1, point2, midpoint];
 * midpoint.properties['marker-color'] = '#f00';
 */ function $03c3f1a83bad9469$var$midpoint(point1, point2) {
    var dist = (0, $3mqzs.default)(point1, point2);
    var heading = (0, $fIrif.default)(point1, point2);
    var midpoint = (0, $6mkzC.default)(point1, dist / 2, heading);
    return midpoint;
}
var $03c3f1a83bad9469$export$2e2bcd8739ae039 = $03c3f1a83bad9469$var$midpoint;

});
parcelRegister("fIrif", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b71022f5333f7ca3$export$2e2bcd8739ae039; });

var $jTOKR = parcelRequire("jTOKR");

var $56tzG = parcelRequire("56tzG");
function $b71022f5333f7ca3$export$2e2bcd8739ae039(start, end, options) {
    if (options === void 0) options = {};
    // Reverse calculation
    if (options.final === true) return $b71022f5333f7ca3$var$calculateFinalBearing(start, end);
    var coordinates1 = (0, $56tzG.getCoord)(start);
    var coordinates2 = (0, $56tzG.getCoord)(end);
    var lon1 = (0, $jTOKR.degreesToRadians)(coordinates1[0]);
    var lon2 = (0, $jTOKR.degreesToRadians)(coordinates2[0]);
    var lat1 = (0, $jTOKR.degreesToRadians)(coordinates1[1]);
    var lat2 = (0, $jTOKR.degreesToRadians)(coordinates2[1]);
    var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    return (0, $jTOKR.radiansToDegrees)(Math.atan2(a, b));
}
/**
 * Calculates Final Bearing
 *
 * @private
 * @param {Coord} start starting Point
 * @param {Coord} end ending Point
 * @returns {number} bearing
 */ function $b71022f5333f7ca3$var$calculateFinalBearing(start, end) {
    // Swap start & end
    var bear = $b71022f5333f7ca3$export$2e2bcd8739ae039(end, start);
    bear = (bear + 180) % 360;
    return bear;
}

});
parcelRegister("jTOKR", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $e7ca863dd06c8a84$export$105684a3041cb6f3; });
$parcel$export(module.exports, "isNumber", function () { return $e7ca863dd06c8a84$export$7e4aa119212bc614; });
$parcel$export(module.exports, "radiansToLength", function () { return $e7ca863dd06c8a84$export$f234631d6a2eedf8; });
$parcel$export(module.exports, "lengthToRadians", function () { return $e7ca863dd06c8a84$export$a2280f7debae8f10; });
$parcel$export(module.exports, "radiansToDegrees", function () { return $e7ca863dd06c8a84$export$c41dd2a8460d3196; });
$parcel$export(module.exports, "degreesToRadians", function () { return $e7ca863dd06c8a84$export$c9fcf1a7df975d78; });
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var $e7ca863dd06c8a84$export$e3a1ee0e9945697f = 6371008.8;
var $e7ca863dd06c8a84$export$f929e47acbed771a = {
    centimeters: $e7ca863dd06c8a84$export$e3a1ee0e9945697f * 100,
    centimetres: $e7ca863dd06c8a84$export$e3a1ee0e9945697f * 100,
    degrees: $e7ca863dd06c8a84$export$e3a1ee0e9945697f / 111325,
    feet: $e7ca863dd06c8a84$export$e3a1ee0e9945697f * 3.28084,
    inches: $e7ca863dd06c8a84$export$e3a1ee0e9945697f * 39.37,
    kilometers: $e7ca863dd06c8a84$export$e3a1ee0e9945697f / 1000,
    kilometres: $e7ca863dd06c8a84$export$e3a1ee0e9945697f / 1000,
    meters: $e7ca863dd06c8a84$export$e3a1ee0e9945697f,
    metres: $e7ca863dd06c8a84$export$e3a1ee0e9945697f,
    miles: $e7ca863dd06c8a84$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $e7ca863dd06c8a84$export$e3a1ee0e9945697f * 1000,
    millimetres: $e7ca863dd06c8a84$export$e3a1ee0e9945697f * 1000,
    nauticalmiles: $e7ca863dd06c8a84$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $e7ca863dd06c8a84$export$e3a1ee0e9945697f * 1.0936
};
var $e7ca863dd06c8a84$export$95cef4899be7420 = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / $e7ca863dd06c8a84$export$e3a1ee0e9945697f,
    yards: 1.0936133
};
var $e7ca863dd06c8a84$export$44665ce4f7f4c82b = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $e7ca863dd06c8a84$export$42a7622cbf932bb(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return $e7ca863dd06c8a84$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $e7ca863dd06c8a84$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $e7ca863dd06c8a84$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $e7ca863dd06c8a84$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $e7ca863dd06c8a84$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $e7ca863dd06c8a84$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $e7ca863dd06c8a84$export$105684a3041cb6f3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$e7ca863dd06c8a84$export$7e4aa119212bc614(coordinates[0]) || !$e7ca863dd06c8a84$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options);
}
function $e7ca863dd06c8a84$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $e7ca863dd06c8a84$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $e7ca863dd06c8a84$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $e7ca863dd06c8a84$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options);
}
function $e7ca863dd06c8a84$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $e7ca863dd06c8a84$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $e7ca863dd06c8a84$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $e7ca863dd06c8a84$export$98ec381bb06902c3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options);
}
function $e7ca863dd06c8a84$export$74f7306c35db993f(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $e7ca863dd06c8a84$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $e7ca863dd06c8a84$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $e7ca863dd06c8a84$export$4717c67ac3e5e04d(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $e7ca863dd06c8a84$export$bd735230309493da(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options);
}
function $e7ca863dd06c8a84$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options);
}
function $e7ca863dd06c8a84$export$79bd594da96638d3(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options);
}
function $e7ca863dd06c8a84$export$9242f1e18250422a(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $e7ca863dd06c8a84$export$ced6ed16dfd6a264(geom, properties, options);
}
function $e7ca863dd06c8a84$export$2077e0241d6afd3c(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $e7ca863dd06c8a84$export$f234631d6a2eedf8(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = $e7ca863dd06c8a84$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $e7ca863dd06c8a84$export$a2280f7debae8f10(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = $e7ca863dd06c8a84$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $e7ca863dd06c8a84$export$c7a138e00a89bd01(distance, units) {
    return $e7ca863dd06c8a84$export$c41dd2a8460d3196($e7ca863dd06c8a84$export$a2280f7debae8f10(distance, units));
}
function $e7ca863dd06c8a84$export$f2077d29c73b33ec(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $e7ca863dd06c8a84$export$c41dd2a8460d3196(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function $e7ca863dd06c8a84$export$c9fcf1a7df975d78(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function $e7ca863dd06c8a84$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $e7ca863dd06c8a84$export$f234631d6a2eedf8($e7ca863dd06c8a84$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $e7ca863dd06c8a84$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $e7ca863dd06c8a84$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $e7ca863dd06c8a84$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $e7ca863dd06c8a84$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $e7ca863dd06c8a84$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
function $e7ca863dd06c8a84$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$e7ca863dd06c8a84$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $e7ca863dd06c8a84$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

});

parcelRegister("56tzG", function(module, exports) {

$parcel$export(module.exports, "getCoord", function () { return $3b74742ca348be90$export$b4663c6e64a770bc; });

var $jTOKR = parcelRequire("jTOKR");
function $3b74742ca348be90$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $3b74742ca348be90$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $3b74742ca348be90$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $jTOKR.isNumber)(coordinates[0]) && (0, $jTOKR.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $3b74742ca348be90$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $3b74742ca348be90$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $3b74742ca348be90$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $3b74742ca348be90$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $3b74742ca348be90$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $3b74742ca348be90$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

});


parcelRegister("6mkzC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a14c1a4dad10688$export$2e2bcd8739ae039; });
// http://en.wikipedia.org/wiki/Haversine_formula
// http://www.movable-type.co.uk/scripts/latlong.html

var $jTOKR = parcelRequire("jTOKR");

var $56tzG = parcelRequire("56tzG");
function $4a14c1a4dad10688$export$2e2bcd8739ae039(origin, distance, bearing, options) {
    if (options === void 0) options = {};
    // Handle input
    var coordinates1 = (0, $56tzG.getCoord)(origin);
    var longitude1 = (0, $jTOKR.degreesToRadians)(coordinates1[0]);
    var latitude1 = (0, $jTOKR.degreesToRadians)(coordinates1[1]);
    var bearingRad = (0, $jTOKR.degreesToRadians)(bearing);
    var radians = (0, $jTOKR.lengthToRadians)(distance, options.units);
    // Main
    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) + Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad));
    var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1), Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
    var lng = (0, $jTOKR.radiansToDegrees)(longitude2);
    var lat = (0, $jTOKR.radiansToDegrees)(latitude2);
    return (0, $jTOKR.point)([
        lng,
        lat
    ], options.properties);
}

});

parcelRegister("3mqzs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2728099f4843c338$export$2e2bcd8739ae039; });

var $56tzG = parcelRequire("56tzG");

var $jTOKR = parcelRequire("jTOKR");
//http://en.wikipedia.org/wiki/Haversine_formula
//http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Calculates the distance between two {@link Point|points} in degrees, radians, miles, or kilometers.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name distance
 * @param {Coord | Point} from origin point or coordinate
 * @param {Coord | Point} to destination point or coordinate
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.distance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */ function $2728099f4843c338$var$distance(from, to, options) {
    if (options === void 0) options = {};
    var coordinates1 = (0, $56tzG.getCoord)(from);
    var coordinates2 = (0, $56tzG.getCoord)(to);
    var dLat = (0, $jTOKR.degreesToRadians)(coordinates2[1] - coordinates1[1]);
    var dLon = (0, $jTOKR.degreesToRadians)(coordinates2[0] - coordinates1[0]);
    var lat1 = (0, $jTOKR.degreesToRadians)(coordinates1[1]);
    var lat2 = (0, $jTOKR.degreesToRadians)(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return (0, $jTOKR.radiansToLength)(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
var $2728099f4843c338$export$2e2bcd8739ae039 = $2728099f4843c338$var$distance;

});



parcelRegister("dZhwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeasureAreaMode = void 0;

var $a2ee90377a4a1953$var$_area = $a2ee90377a4a1953$var$_interopRequireDefault((parcelRequire("lSVDw")));

var $a2ee90377a4a1953$var$_centroid = $a2ee90377a4a1953$var$_interopRequireDefault((parcelRequire("d9r3a")));

var $fVfme = parcelRequire("fVfme");
function $a2ee90377a4a1953$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a2ee90377a4a1953$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a2ee90377a4a1953$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a2ee90377a4a1953$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a2ee90377a4a1953$var$_typeof(obj);
}
function $a2ee90377a4a1953$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a2ee90377a4a1953$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a2ee90377a4a1953$var$ownKeys(Object(source), true).forEach(function(key) {
            $a2ee90377a4a1953$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a2ee90377a4a1953$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a2ee90377a4a1953$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a2ee90377a4a1953$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a2ee90377a4a1953$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a2ee90377a4a1953$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a2ee90377a4a1953$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a2ee90377a4a1953$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a2ee90377a4a1953$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $a2ee90377a4a1953$var$_get = Reflect.get;
    else $a2ee90377a4a1953$var$_get = function _get(target, property, receiver) {
        var base = $a2ee90377a4a1953$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $a2ee90377a4a1953$var$_get(target, property, receiver || target);
}
function $a2ee90377a4a1953$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $a2ee90377a4a1953$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $a2ee90377a4a1953$var$_createSuper(Derived) {
    return function() {
        var Super = $a2ee90377a4a1953$var$_getPrototypeOf(Derived), result;
        if ($a2ee90377a4a1953$var$_isNativeReflectConstruct()) {
            var NewTarget = $a2ee90377a4a1953$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a2ee90377a4a1953$var$_possibleConstructorReturn(this, result);
    };
}
function $a2ee90377a4a1953$var$_possibleConstructorReturn(self, call) {
    if (call && ($a2ee90377a4a1953$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a2ee90377a4a1953$var$_assertThisInitialized(self);
}
function $a2ee90377a4a1953$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a2ee90377a4a1953$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a2ee90377a4a1953$var$_getPrototypeOf(o) {
    $a2ee90377a4a1953$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a2ee90377a4a1953$var$_getPrototypeOf(o);
}
function $a2ee90377a4a1953$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a2ee90377a4a1953$var$_setPrototypeOf(subClass, superClass);
}
function $a2ee90377a4a1953$var$_setPrototypeOf(o, p) {
    $a2ee90377a4a1953$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a2ee90377a4a1953$var$_setPrototypeOf(o, p);
}
var $a2ee90377a4a1953$var$DEFAULT_TOOLTIPS = [];
var $a2ee90377a4a1953$var$MeasureAreaMode = /*#__PURE__*/ function(_DrawPolygonMode) {
    $a2ee90377a4a1953$var$_inherits(MeasureAreaMode, _DrawPolygonMode);
    var _super = $a2ee90377a4a1953$var$_createSuper(MeasureAreaMode);
    function MeasureAreaMode() {
        $a2ee90377a4a1953$var$_classCallCheck(this, MeasureAreaMode);
        return _super.apply(this, arguments);
    }
    $a2ee90377a4a1953$var$_createClass(MeasureAreaMode, [
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                var propsWithoutEdit = $a2ee90377a4a1953$var$_objectSpread({}, props, {
                    // @ts-ignore
                    onEdit: function onEdit() {}
                });
                $a2ee90377a4a1953$var$_get($a2ee90377a4a1953$var$_getPrototypeOf(MeasureAreaMode.prototype), "handleClick", this).call(this, event, propsWithoutEdit);
            }
        },
        {
            key: "getTooltips",
            value: function getTooltips(props) {
                var tentativeGuide = this.getTentativeGuide(props);
                if (tentativeGuide && tentativeGuide.geometry.type === "Polygon") {
                    var modeConfig = props.modeConfig;
                    var _ref = modeConfig || {}, formatTooltip = _ref.formatTooltip, measurementCallback = _ref.measurementCallback;
                    var units = "sq. m";
                    var centroid = (0, $a2ee90377a4a1953$var$_centroid["default"])(tentativeGuide);
                    var area = (0, $a2ee90377a4a1953$var$_area["default"])(tentativeGuide);
                    var text;
                    if (formatTooltip) text = formatTooltip(area);
                    else // By default, round to 2 decimal places and append units
                    // @ts-ignore
                    text = "".concat(parseFloat(area).toFixed(2), " ").concat(units);
                    if (measurementCallback) measurementCallback(area);
                    return [
                        {
                            position: centroid.geometry.coordinates,
                            text: text
                        }
                    ];
                }
                return $a2ee90377a4a1953$var$DEFAULT_TOOLTIPS;
            }
        }
    ]);
    return MeasureAreaMode;
}($fVfme.DrawPolygonMode);
module.exports.MeasureAreaMode = $a2ee90377a4a1953$var$MeasureAreaMode;

});
parcelRegister("lSVDw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $feeb598a6a7bc109$export$2e2bcd8739ae039; });

var $cJNDJ = parcelRequire("cJNDJ");
// Note: change RADIUS => earthRadius
var $feeb598a6a7bc109$var$RADIUS = 6378137;
function $feeb598a6a7bc109$export$2e2bcd8739ae039(geojson) {
    return (0, $cJNDJ.geomReduce)(geojson, function(value, geom) {
        return value + $feeb598a6a7bc109$var$calculateArea(geom);
    }, 0);
}
/**
 * Calculate Area
 *
 * @private
 * @param {Geometry} geom GeoJSON Geometries
 * @returns {number} area
 */ function $feeb598a6a7bc109$var$calculateArea(geom) {
    var total = 0;
    var i;
    switch(geom.type){
        case "Polygon":
            return $feeb598a6a7bc109$var$polygonArea(geom.coordinates);
        case "MultiPolygon":
            for(i = 0; i < geom.coordinates.length; i++)total += $feeb598a6a7bc109$var$polygonArea(geom.coordinates[i]);
            return total;
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
            return 0;
    }
    return 0;
}
function $feeb598a6a7bc109$var$polygonArea(coords) {
    var total = 0;
    if (coords && coords.length > 0) {
        total += Math.abs($feeb598a6a7bc109$var$ringArea(coords[0]));
        for(var i = 1; i < coords.length; i++)total -= Math.abs($feeb598a6a7bc109$var$ringArea(coords[i]));
    }
    return total;
}
/**
 * @private
 * Calculate the approximate area of the polygon were it projected onto the earth.
 * Note that this area will be positive if ring is oriented clockwise, otherwise it will be negative.
 *
 * Reference:
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for Polygons on a Sphere",
 * JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007 https://trs.jpl.nasa.gov/handle/2014/40409
 *
 * @param {Array<Array<number>>} coords Ring Coordinates
 * @returns {number} The approximate signed geodesic area of the polygon in square meters.
 */ function $feeb598a6a7bc109$var$ringArea(coords) {
    var p1;
    var p2;
    var p3;
    var lowerIndex;
    var middleIndex;
    var upperIndex;
    var i;
    var total = 0;
    var coordsLength = coords.length;
    if (coordsLength > 2) {
        for(i = 0; i < coordsLength; i++){
            if (i === coordsLength - 2) {
                // i = N-2
                lowerIndex = coordsLength - 2;
                middleIndex = coordsLength - 1;
                upperIndex = 0;
            } else if (i === coordsLength - 1) {
                // i = N-1
                lowerIndex = coordsLength - 1;
                middleIndex = 0;
                upperIndex = 1;
            } else {
                // i = 0 to N-3
                lowerIndex = i;
                middleIndex = i + 1;
                upperIndex = i + 2;
            }
            p1 = coords[lowerIndex];
            p2 = coords[middleIndex];
            p3 = coords[upperIndex];
            total += ($feeb598a6a7bc109$var$rad(p3[0]) - $feeb598a6a7bc109$var$rad(p1[0])) * Math.sin($feeb598a6a7bc109$var$rad(p2[1]));
        }
        total = total * $feeb598a6a7bc109$var$RADIUS * $feeb598a6a7bc109$var$RADIUS / 2;
    }
    return total;
}
function $feeb598a6a7bc109$var$rad(num) {
    return num * Math.PI / 180;
}

});


parcelRegister("h2dZX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeasureAngleMode = void 0;

var $c66d7b575bd3dd12$var$_bearing = $c66d7b575bd3dd12$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $c66d7b575bd3dd12$var$_center = $c66d7b575bd3dd12$var$_interopRequireDefault((parcelRequire("4B93b")));

var $c66d7b575bd3dd12$var$_memoize = $c66d7b575bd3dd12$var$_interopRequireDefault((parcelRequire("7zWhR")));

var $1tPZO = parcelRequire("1tPZO");
function $c66d7b575bd3dd12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c66d7b575bd3dd12$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c66d7b575bd3dd12$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c66d7b575bd3dd12$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c66d7b575bd3dd12$var$_typeof(obj);
}
function $c66d7b575bd3dd12$var$_toConsumableArray(arr) {
    return $c66d7b575bd3dd12$var$_arrayWithoutHoles(arr) || $c66d7b575bd3dd12$var$_iterableToArray(arr) || $c66d7b575bd3dd12$var$_unsupportedIterableToArray(arr) || $c66d7b575bd3dd12$var$_nonIterableSpread();
}
function $c66d7b575bd3dd12$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c66d7b575bd3dd12$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c66d7b575bd3dd12$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c66d7b575bd3dd12$var$_arrayLikeToArray(o, minLen);
}
function $c66d7b575bd3dd12$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c66d7b575bd3dd12$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c66d7b575bd3dd12$var$_arrayLikeToArray(arr);
}
function $c66d7b575bd3dd12$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c66d7b575bd3dd12$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c66d7b575bd3dd12$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c66d7b575bd3dd12$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c66d7b575bd3dd12$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c66d7b575bd3dd12$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c66d7b575bd3dd12$var$_createSuper(Derived) {
    return function() {
        var Super = $c66d7b575bd3dd12$var$_getPrototypeOf(Derived), result;
        if ($c66d7b575bd3dd12$var$_isNativeReflectConstruct()) {
            var NewTarget = $c66d7b575bd3dd12$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c66d7b575bd3dd12$var$_possibleConstructorReturn(this, result);
    };
}
function $c66d7b575bd3dd12$var$_possibleConstructorReturn(self, call) {
    if (call && ($c66d7b575bd3dd12$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c66d7b575bd3dd12$var$_assertThisInitialized(self);
}
function $c66d7b575bd3dd12$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c66d7b575bd3dd12$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c66d7b575bd3dd12$var$_getPrototypeOf(o) {
    $c66d7b575bd3dd12$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c66d7b575bd3dd12$var$_getPrototypeOf(o);
}
function $c66d7b575bd3dd12$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c66d7b575bd3dd12$var$_setPrototypeOf(subClass, superClass);
}
function $c66d7b575bd3dd12$var$_setPrototypeOf(o, p) {
    $c66d7b575bd3dd12$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c66d7b575bd3dd12$var$_setPrototypeOf(o, p);
}
function $c66d7b575bd3dd12$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c66d7b575bd3dd12$var$DEFAULT_TOOLTIPS = [];
var $c66d7b575bd3dd12$var$MeasureAngleMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $c66d7b575bd3dd12$var$_inherits(MeasureAngleMode, _GeoJsonEditMode);
    var _super = $c66d7b575bd3dd12$var$_createSuper(MeasureAngleMode);
    function MeasureAngleMode() {
        var _this;
        $c66d7b575bd3dd12$var$_classCallCheck(this, MeasureAngleMode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $c66d7b575bd3dd12$var$_defineProperty($c66d7b575bd3dd12$var$_assertThisInitialized(_this), "_getTooltips", (0, $c66d7b575bd3dd12$var$_memoize["default"])(function(_ref) {
            var modeConfig = _ref.modeConfig, vertex = _ref.vertex, point1 = _ref.point1, point2 = _ref.point2;
            var tooltips = $c66d7b575bd3dd12$var$DEFAULT_TOOLTIPS;
            if (vertex && point1 && point2) {
                var _ref2 = modeConfig || {}, formatTooltip = _ref2.formatTooltip, measurementCallback = _ref2.measurementCallback;
                var units = "deg";
                var angle1 = (0, $c66d7b575bd3dd12$var$_bearing["default"])(vertex, point1);
                var angle2 = (0, $c66d7b575bd3dd12$var$_bearing["default"])(vertex, point2);
                var angle = Math.abs(angle1 - angle2);
                if (angle > 180) angle = 360 - angle;
                var text;
                if (formatTooltip) text = formatTooltip(angle);
                else // By default, round to 2 decimal places and append units
                // @ts-ignore
                text = "".concat(parseFloat(angle).toFixed(2), " ").concat(units);
                if (measurementCallback) measurementCallback(angle);
                var position = (0, $c66d7b575bd3dd12$var$_center["default"])({
                    type: "FeatureCollection",
                    features: [
                        point1,
                        point2
                    ].map(function(p) {
                        return {
                            type: "Feature",
                            geometry: {
                                type: "Point",
                                coordinates: p
                            }
                        };
                    })
                }).geometry.coordinates;
                tooltips = [
                    {
                        position: position,
                        text: text
                    }
                ];
            }
            return tooltips;
        }));
        return _this;
    }
    $c66d7b575bd3dd12$var$_createClass(MeasureAngleMode, [
        {
            key: "handleClick",
            value: function handleClick(event, props) {
                if (this.getClickSequence().length >= 3) this.resetClickSequence();
                this.addClickSequence(event);
            } // Called when the pointer moved, regardless of whether the pointer is down, up, and whether something was picked
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                props.onUpdateCursor("cell");
            }
        },
        {
            key: "getPoints",
            value: function getPoints(props) {
                var clickSequence = this.getClickSequence();
                var points = $c66d7b575bd3dd12$var$_toConsumableArray(clickSequence);
                if (clickSequence.length < 3 && props.lastPointerMoveEvent) points.push(props.lastPointerMoveEvent.mapCoords);
                return points;
            } // Return features that can be used as a guide for editing the data
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var guides = {
                    type: "FeatureCollection",
                    features: []
                };
                var features = guides.features;
                var points = this.getPoints(props);
                if (points.length > 2) features.push({
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [
                            points[1],
                            points[0],
                            points[2]
                        ]
                    }
                });
                else if (points.length > 1) features.push({
                    type: "Feature",
                    properties: {
                        guideType: "tentative"
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [
                            points[1],
                            points[0]
                        ]
                    }
                });
                return guides;
            }
        },
        {
            key: "getTooltips",
            value: function getTooltips(props) {
                var points = this.getPoints(props);
                return this._getTooltips({
                    modeConfig: props.modeConfig,
                    vertex: points[0],
                    point1: points[1],
                    point2: points[2]
                });
            }
        }
    ]);
    return MeasureAngleMode;
}($1tPZO.GeoJsonEditMode);
module.exports.MeasureAngleMode = $c66d7b575bd3dd12$var$MeasureAngleMode;

});
parcelRegister("7zWhR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $584903e32bf1406a$var$memoize;
// port from @deck.gl/core
function $584903e32bf1406a$var$isEqual(a, b) {
    if (a === b) return true;
    if (Array.isArray(a)) {
        // Special treatment for arrays: compare 1-level deep
        // This is to support equality of matrix/coordinate props
        var len = a.length;
        if (!b || b.length !== len) return false;
        for(var i = 0; i < len; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}
/**
 * Speed up consecutive function calls by caching the result of calls with identical input
 * https://en.wikipedia.org/wiki/Memoization
 * @param {function} compute - the function to be memoized
 */ function $584903e32bf1406a$var$memoize(compute) {
    var cachedArgs = {};
    var cachedResult;
    return function(args) {
        for(var key in args)if (!$584903e32bf1406a$var$isEqual(args[key], cachedArgs[key])) {
            cachedResult = compute(args);
            cachedArgs = args;
            break;
        }
        return cachedResult;
    };
}

});


parcelRegister("enK8I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SnappableMode = void 0;

var $hs5Hv = parcelRequire("hs5Hv");

var $1tPZO = parcelRequire("1tPZO");
function $a787010dc91c18c7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a787010dc91c18c7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a787010dc91c18c7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a787010dc91c18c7$var$_typeof(obj);
}
function $a787010dc91c18c7$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $a787010dc91c18c7$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a787010dc91c18c7$var$_toConsumableArray(arr) {
    return $a787010dc91c18c7$var$_arrayWithoutHoles(arr) || $a787010dc91c18c7$var$_iterableToArray(arr) || $a787010dc91c18c7$var$_unsupportedIterableToArray(arr) || $a787010dc91c18c7$var$_nonIterableSpread();
}
function $a787010dc91c18c7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a787010dc91c18c7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a787010dc91c18c7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a787010dc91c18c7$var$_arrayLikeToArray(o, minLen);
}
function $a787010dc91c18c7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $a787010dc91c18c7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a787010dc91c18c7$var$_arrayLikeToArray(arr);
}
function $a787010dc91c18c7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a787010dc91c18c7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a787010dc91c18c7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a787010dc91c18c7$var$ownKeys(Object(source), true).forEach(function(key) {
            $a787010dc91c18c7$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a787010dc91c18c7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a787010dc91c18c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a787010dc91c18c7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a787010dc91c18c7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a787010dc91c18c7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a787010dc91c18c7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a787010dc91c18c7$var$_createSuper(Derived) {
    return function() {
        var Super = $a787010dc91c18c7$var$_getPrototypeOf(Derived), result;
        if ($a787010dc91c18c7$var$_isNativeReflectConstruct()) {
            var NewTarget = $a787010dc91c18c7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a787010dc91c18c7$var$_possibleConstructorReturn(this, result);
    };
}
function $a787010dc91c18c7$var$_possibleConstructorReturn(self, call) {
    if (call && ($a787010dc91c18c7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a787010dc91c18c7$var$_assertThisInitialized(self);
}
function $a787010dc91c18c7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a787010dc91c18c7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a787010dc91c18c7$var$_getPrototypeOf(o) {
    $a787010dc91c18c7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a787010dc91c18c7$var$_getPrototypeOf(o);
}
function $a787010dc91c18c7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a787010dc91c18c7$var$_setPrototypeOf(subClass, superClass);
}
function $a787010dc91c18c7$var$_setPrototypeOf(o, p) {
    $a787010dc91c18c7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a787010dc91c18c7$var$_setPrototypeOf(o, p);
}
function $a787010dc91c18c7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a787010dc91c18c7$var$SnappableMode = /*#__PURE__*/ function(_GeoJsonEditMode) {
    $a787010dc91c18c7$var$_inherits(SnappableMode, _GeoJsonEditMode);
    var _super = $a787010dc91c18c7$var$_createSuper(SnappableMode);
    function SnappableMode(handler) {
        var _this;
        $a787010dc91c18c7$var$_classCallCheck(this, SnappableMode);
        _this = _super.call(this);
        $a787010dc91c18c7$var$_defineProperty($a787010dc91c18c7$var$_assertThisInitialized(_this), "_handler", void 0);
        _this._handler = handler;
        return _this;
    }
    $a787010dc91c18c7$var$_createClass(SnappableMode, [
        {
            key: "_getSnappedMouseEvent",
            value: function _getSnappedMouseEvent(event, snapSource, snapTarget) {
                return Object.assign(event, {
                    mapCoords: snapTarget.geometry.coordinates,
                    pointerDownMapCoords: snapSource && snapSource.geometry.coordinates
                });
            }
        },
        {
            key: "_getPickedSnapTarget",
            value: function _getPickedSnapTarget(picks) {
                return (0, $hs5Hv.getPickedEditHandles)(picks).find(function(handle) {
                    return handle.properties.editHandleType === "snap-target";
                });
            }
        },
        {
            key: "_getPickedSnapSource",
            value: function _getPickedSnapSource(pointerDownPicks) {
                return (0, $hs5Hv.getPickedSnapSourceEditHandle)(pointerDownPicks);
            }
        },
        {
            key: "_getUpdatedSnapSourceHandle",
            value: function _getUpdatedSnapSourceHandle(snapSourceHandle, data) {
                var _snapSourceHandle$pro = snapSourceHandle.properties, featureIndex = _snapSourceHandle$pro.featureIndex, positionIndexes = _snapSourceHandle$pro.positionIndexes;
                if (!Array.isArray(positionIndexes)) return snapSourceHandle;
                var snapSourceFeature = data.features[featureIndex]; // $FlowFixMe
                var snapSourceCoordinates = positionIndexes.reduce(function(a, b) {
                    return a[b];
                }, snapSourceFeature.geometry.coordinates);
                return $a787010dc91c18c7$var$_objectSpread({}, snapSourceHandle, {
                    geometry: {
                        type: "Point",
                        coordinates: snapSourceCoordinates
                    }
                });
            } // If additionalSnapTargets is present in modeConfig and is populated, this
        },
        {
            key: "_getSnapTargets",
            value: function _getSnapTargets(props) {
                var _ref = props.modeConfig || {}, additionalSnapTargets = _ref.additionalSnapTargets;
                additionalSnapTargets = additionalSnapTargets || [];
                var features = [].concat($a787010dc91c18c7$var$_toConsumableArray(props.data.features), $a787010dc91c18c7$var$_toConsumableArray(additionalSnapTargets));
                return features;
            }
        },
        {
            key: "_getSnapTargetHandles",
            value: function _getSnapTargetHandles(props) {
                var handles = [];
                var features = this._getSnapTargets(props);
                for(var i = 0; i < features.length; i++){
                    // Filter out the currently selected feature(s)
                    var isCurrentIndexFeatureNotSelected = !props.selectedIndexes.includes(i);
                    if (isCurrentIndexFeatureNotSelected) {
                        var geometry = features[i].geometry;
                        handles.push.apply(handles, $a787010dc91c18c7$var$_toConsumableArray((0, $hs5Hv.getEditHandlesForGeometry)(geometry, i, "snap-target")));
                    }
                }
                return handles;
            } // If no snap handle has been picked, only display the edit handles of the
        },
        {
            key: "getGuides",
            value: function getGuides(props) {
                var modeConfig = props.modeConfig, lastPointerMoveEvent = props.lastPointerMoveEvent;
                var _ref2 = modeConfig || {}, enableSnapping = _ref2.enableSnapping;
                var guides = {
                    type: "FeatureCollection",
                    features: $a787010dc91c18c7$var$_toConsumableArray(this._handler.getGuides(props).features)
                };
                if (!enableSnapping) return guides;
                var snapSourceHandle = lastPointerMoveEvent && this._getPickedSnapSource(lastPointerMoveEvent.pointerDownPicks); // They started dragging a handle
                // So render the picked handle (in its updated location) and all possible snap targets
                if (snapSourceHandle) {
                    var _guides$features;
                    (_guides$features = guides.features).push.apply(_guides$features, $a787010dc91c18c7$var$_toConsumableArray(this._getSnapTargetHandles(props)).concat([
                        this._getUpdatedSnapSourceHandle(snapSourceHandle, props.data)
                    ]));
                    return guides;
                } // Render the possible snap source handles
                var features = props.data.features;
                var _iterator = $a787010dc91c18c7$var$_createForOfIteratorHelper(props.selectedIndexes), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var index = _step.value;
                        if (index < features.length) {
                            var _guides$features2;
                            var geometry = features[index].geometry;
                            (_guides$features2 = guides.features).push.apply(_guides$features2, $a787010dc91c18c7$var$_toConsumableArray((0, $hs5Hv.getEditHandlesForGeometry)(geometry, index, "snap-source")));
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return guides;
            }
        },
        {
            key: "_getSnapAwareEvent",
            value: function _getSnapAwareEvent(event, props) {
                var snapSource = this._getPickedSnapSource(props.lastPointerMoveEvent.pointerDownPicks);
                var snapTarget = this._getPickedSnapTarget(event.picks);
                return snapSource && snapTarget ? this._getSnappedMouseEvent(event, snapSource, snapTarget) : event;
            }
        },
        {
            key: "handleStartDragging",
            value: function handleStartDragging(event, props) {
                this._handler.handleStartDragging(event, props);
            }
        },
        {
            key: "handleStopDragging",
            value: function handleStopDragging(event, props) {
                this._handler.handleStopDragging(this._getSnapAwareEvent(event, props), props);
            }
        },
        {
            key: "handleDragging",
            value: function handleDragging(event, props) {
                this._handler.handleDragging(this._getSnapAwareEvent(event, props), props);
            }
        },
        {
            key: "handlePointerMove",
            value: function handlePointerMove(event, props) {
                this._handler.handlePointerMove(this._getSnapAwareEvent(event, props), props);
            }
        }
    ]);
    return SnappableMode;
}($1tPZO.GeoJsonEditMode);
module.exports.SnappableMode = $a787010dc91c18c7$var$SnappableMode;

});


parcelRegister("9brng", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UNIT = module.exports.PROJECTED_PIXEL_SIZE_MULTIPLIER = void 0;
/**
 * A multiplier for screen-space width/scale for Arc, Line, Icon and Text layers.
 * Required in order to maintain the same appearance after upgrading to deck.gl v8.5.
 * https://github.com/visgl/deck.gl/blob/master/docs/upgrade-guide.md
 */ var $6afa6014874935db$var$PROJECTED_PIXEL_SIZE_MULTIPLIER = 2 / 3;
/**
 * Unit literal to shader unit number conversion.
 */ module.exports.PROJECTED_PIXEL_SIZE_MULTIPLIER = $6afa6014874935db$var$PROJECTED_PIXEL_SIZE_MULTIPLIER;
var $6afa6014874935db$var$UNIT = {
    common: 0,
    meters: 1,
    pixels: 2
};
module.exports.UNIT = $6afa6014874935db$var$UNIT;

});

parcelRegister("7epLg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $coXLq = parcelRequire("coXLq");
function $543dd2e3fbf800bb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $543dd2e3fbf800bb$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $543dd2e3fbf800bb$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $543dd2e3fbf800bb$var$_typeof(obj);
}
function $543dd2e3fbf800bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $543dd2e3fbf800bb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $543dd2e3fbf800bb$var$ownKeys(Object(source), true).forEach(function(key) {
            $543dd2e3fbf800bb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $543dd2e3fbf800bb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $543dd2e3fbf800bb$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $543dd2e3fbf800bb$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $543dd2e3fbf800bb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $543dd2e3fbf800bb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $543dd2e3fbf800bb$var$_arrayLikeToArray(o, minLen);
}
function $543dd2e3fbf800bb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $543dd2e3fbf800bb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $543dd2e3fbf800bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $543dd2e3fbf800bb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $543dd2e3fbf800bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $543dd2e3fbf800bb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $543dd2e3fbf800bb$var$_createSuper(Derived) {
    return function() {
        var Super = $543dd2e3fbf800bb$var$_getPrototypeOf(Derived), result;
        if ($543dd2e3fbf800bb$var$_isNativeReflectConstruct()) {
            var NewTarget = $543dd2e3fbf800bb$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $543dd2e3fbf800bb$var$_possibleConstructorReturn(this, result);
    };
}
function $543dd2e3fbf800bb$var$_possibleConstructorReturn(self, call) {
    if (call && ($543dd2e3fbf800bb$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $543dd2e3fbf800bb$var$_assertThisInitialized(self);
}
function $543dd2e3fbf800bb$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $543dd2e3fbf800bb$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $543dd2e3fbf800bb$var$_getPrototypeOf(o) {
    $543dd2e3fbf800bb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $543dd2e3fbf800bb$var$_getPrototypeOf(o);
}
function $543dd2e3fbf800bb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $543dd2e3fbf800bb$var$_setPrototypeOf(subClass, superClass);
}
function $543dd2e3fbf800bb$var$_setPrototypeOf(o, p) {
    $543dd2e3fbf800bb$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $543dd2e3fbf800bb$var$_setPrototypeOf(o, p);
}
function $543dd2e3fbf800bb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $543dd2e3fbf800bb$var$EVENT_TYPES = [
    "anyclick",
    "pointermove",
    "panstart",
    "panmove",
    "panend",
    "keyup"
];
var $543dd2e3fbf800bb$var$EditableLayer = /*#__PURE__*/ function(_CompositeLayer) {
    $543dd2e3fbf800bb$var$_inherits(EditableLayer, _CompositeLayer);
    var _super = $543dd2e3fbf800bb$var$_createSuper(EditableLayer);
    function EditableLayer() {
        $543dd2e3fbf800bb$var$_classCallCheck(this, EditableLayer);
        return _super.apply(this, arguments);
    }
    $543dd2e3fbf800bb$var$_createClass(EditableLayer, [
        {
            key: "onLayerClick",
            // Overridable interaction event handlers
            value: function onLayerClick(event) {}
        },
        {
            key: "onStartDragging",
            value: function onStartDragging(event) {}
        },
        {
            key: "onStopDragging",
            value: function onStopDragging(event) {}
        },
        {
            key: "onDragging",
            value: function onDragging(event) {}
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {}
        },
        {
            key: "onLayerKeyUp",
            value: function onLayerKeyUp(event) {} // default implementation - do nothing;
        },
        {
            key: "initializeState",
            value: function initializeState() {
                this.setState({
                    _editableLayerState: {
                        // Picked objects at the time the pointer went down
                        pointerDownPicks: null,
                        // Screen coordinates where the pointer went down
                        pointerDownScreenCoords: null,
                        // Ground coordinates where the pointer went down
                        pointerDownMapCoords: null,
                        // Keep track of the mjolnir.js event handler so it can be deregistered
                        eventHandler: this._forwardEventToCurrentLayer.bind(this)
                    }
                });
                this._addEventHandlers();
            }
        },
        {
            key: "finalizeState",
            value: function finalizeState() {
                this._removeEventHandlers();
            }
        },
        {
            key: "_addEventHandlers",
            value: function _addEventHandlers() {
                // @ts-ignore
                var eventManager = this.context.deck.eventManager;
                var eventHandler = this.state._editableLayerState.eventHandler;
                var _iterator = $543dd2e3fbf800bb$var$_createForOfIteratorHelper($543dd2e3fbf800bb$var$EVENT_TYPES), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var eventType = _step.value;
                        eventManager.on(eventType, eventHandler, {
                            // give nebula a higher priority so that it can stop propagation to deck.gl's map panning handlers
                            priority: 100
                        });
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "_removeEventHandlers",
            value: function _removeEventHandlers() {
                // @ts-ignore
                var eventManager = this.context.deck.eventManager;
                var eventHandler = this.state._editableLayerState.eventHandler;
                var _iterator2 = $543dd2e3fbf800bb$var$_createForOfIteratorHelper($543dd2e3fbf800bb$var$EVENT_TYPES), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var eventType = _step2.value;
                        eventManager.off(eventType, eventHandler);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            } // A new layer instance is created on every render, so forward the event to the current layer
        },
        {
            key: "_forwardEventToCurrentLayer",
            value: function _forwardEventToCurrentLayer(event) {
                var currentLayer = this.getCurrentLayer(); // Use a naming convention to find the event handling function for this event type
                var func = currentLayer["_on".concat(event.type)].bind(currentLayer);
                if (!func) {
                    console.warn("no handler for mjolnir.js event ".concat(event.type)); // eslint-disable-line
                    return;
                }
                func(event);
            }
        },
        {
            key: "_onanyclick",
            value: function _onanyclick(_ref) {
                var srcEvent = _ref.srcEvent;
                var screenCoords = this.getScreenCoords(srcEvent);
                var mapCoords = this.getMapCoords(screenCoords); // @ts-ignore
                var picks = this.getPicks(screenCoords);
                this.onLayerClick({
                    mapCoords: mapCoords,
                    // @ts-ignore
                    screenCoords: screenCoords,
                    picks: picks,
                    sourceEvent: srcEvent
                });
            }
        },
        {
            key: "_onkeyup",
            value: function _onkeyup(_ref2) {
                var srcEvent = _ref2.srcEvent;
                this.onLayerKeyUp(srcEvent);
            }
        },
        {
            key: "_onpanstart",
            value: function _onpanstart(event) {
                var screenCoords = this.getScreenCoords(event.srcEvent);
                var mapCoords = this.getMapCoords(screenCoords); // @ts-ignore
                var picks = this.getPicks(screenCoords);
                this.setState({
                    _editableLayerState: $543dd2e3fbf800bb$var$_objectSpread({}, this.state._editableLayerState, {
                        pointerDownScreenCoords: screenCoords,
                        pointerDownMapCoords: mapCoords,
                        pointerDownPicks: picks
                    })
                });
                this.onStartDragging({
                    picks: picks,
                    // @ts-ignore
                    screenCoords: screenCoords,
                    // @ts-ignore
                    mapCoords: mapCoords,
                    // @ts-ignore
                    pointerDownScreenCoords: screenCoords,
                    pointerDownMapCoords: mapCoords,
                    cancelPan: event.stopImmediatePropagation,
                    sourceEvent: event.srcEvent
                });
            }
        },
        {
            key: "_onpanmove",
            value: function _onpanmove(event) {
                var srcEvent = event.srcEvent;
                var screenCoords = this.getScreenCoords(srcEvent);
                var mapCoords = this.getMapCoords(screenCoords);
                var _this$state$_editable = this.state._editableLayerState, pointerDownPicks = _this$state$_editable.pointerDownPicks, pointerDownScreenCoords = _this$state$_editable.pointerDownScreenCoords, pointerDownMapCoords = _this$state$_editable.pointerDownMapCoords; // @ts-ignore
                var picks = this.getPicks(screenCoords);
                this.onDragging({
                    // @ts-ignore
                    screenCoords: screenCoords,
                    mapCoords: mapCoords,
                    picks: picks,
                    pointerDownPicks: pointerDownPicks,
                    pointerDownScreenCoords: pointerDownScreenCoords,
                    pointerDownMapCoords: pointerDownMapCoords,
                    sourceEvent: srcEvent,
                    cancelPan: event.stopImmediatePropagation // another (hacky) approach for cancelling map panning
                });
            }
        },
        {
            key: "_onpanend",
            value: function _onpanend(_ref3) {
                var srcEvent = _ref3.srcEvent;
                var screenCoords = this.getScreenCoords(srcEvent);
                var mapCoords = this.getMapCoords(screenCoords);
                var _this$state$_editable2 = this.state._editableLayerState, pointerDownPicks = _this$state$_editable2.pointerDownPicks, pointerDownScreenCoords = _this$state$_editable2.pointerDownScreenCoords, pointerDownMapCoords = _this$state$_editable2.pointerDownMapCoords; // @ts-ignore
                var picks = this.getPicks(screenCoords);
                this.onStopDragging({
                    picks: picks,
                    // @ts-ignore
                    screenCoords: screenCoords,
                    mapCoords: mapCoords,
                    pointerDownPicks: pointerDownPicks,
                    pointerDownScreenCoords: pointerDownScreenCoords,
                    pointerDownMapCoords: pointerDownMapCoords,
                    sourceEvent: srcEvent
                });
                this.setState({
                    _editableLayerState: $543dd2e3fbf800bb$var$_objectSpread({}, this.state._editableLayerState, {
                        pointerDownScreenCoords: null,
                        pointerDownMapCoords: null,
                        pointerDownPicks: null
                    })
                });
            }
        },
        {
            key: "_onpointermove",
            value: function _onpointermove(event) {
                var srcEvent = event.srcEvent;
                var screenCoords = this.getScreenCoords(srcEvent);
                var mapCoords = this.getMapCoords(screenCoords);
                var _this$state$_editable3 = this.state._editableLayerState, pointerDownPicks = _this$state$_editable3.pointerDownPicks, pointerDownScreenCoords = _this$state$_editable3.pointerDownScreenCoords, pointerDownMapCoords = _this$state$_editable3.pointerDownMapCoords; // @ts-ignore
                var picks = this.getPicks(screenCoords);
                this.onPointerMove({
                    // @ts-ignore
                    screenCoords: screenCoords,
                    mapCoords: mapCoords,
                    picks: picks,
                    pointerDownPicks: pointerDownPicks,
                    pointerDownScreenCoords: pointerDownScreenCoords,
                    pointerDownMapCoords: pointerDownMapCoords,
                    sourceEvent: srcEvent
                });
            }
        },
        {
            key: "getPicks",
            value: function getPicks(screenCoords) {
                // @ts-ignore
                return this.context.deck.pickMultipleObjects({
                    x: screenCoords[0],
                    y: screenCoords[1],
                    layerIds: [
                        this.props.id
                    ],
                    radius: this.props.pickingRadius,
                    depth: this.props.pickingDepth
                });
            }
        },
        {
            key: "getScreenCoords",
            value: function getScreenCoords(pointerEvent) {
                return [
                    pointerEvent.clientX - this.context.gl.canvas.getBoundingClientRect().left,
                    pointerEvent.clientY - this.context.gl.canvas.getBoundingClientRect().top
                ];
            }
        },
        {
            key: "getMapCoords",
            value: function getMapCoords(screenCoords) {
                // @ts-ignore
                return this.context.viewport.unproject([
                    screenCoords[0],
                    screenCoords[1]
                ]);
            }
        }
    ]);
    return EditableLayer;
}($coXLq.default);
module.exports["default"] = $543dd2e3fbf800bb$var$EditableLayer;
$543dd2e3fbf800bb$var$_defineProperty($543dd2e3fbf800bb$var$EditableLayer, "layerName", "EditableLayer");

});

parcelRegister("aQ3Iz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $lzW2S = parcelRequire("lzW2S");

var $b3BRI = parcelRequire("b3BRI");
function $7e41a4fc2954488d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7e41a4fc2954488d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7e41a4fc2954488d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7e41a4fc2954488d$var$_typeof(obj);
}
function $7e41a4fc2954488d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7e41a4fc2954488d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7e41a4fc2954488d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7e41a4fc2954488d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7e41a4fc2954488d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7e41a4fc2954488d$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $7e41a4fc2954488d$var$_get = Reflect.get;
    else $7e41a4fc2954488d$var$_get = function _get(target, property, receiver) {
        var base = $7e41a4fc2954488d$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $7e41a4fc2954488d$var$_get(target, property, receiver || target);
}
function $7e41a4fc2954488d$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $7e41a4fc2954488d$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $7e41a4fc2954488d$var$_createSuper(Derived) {
    return function() {
        var Super = $7e41a4fc2954488d$var$_getPrototypeOf(Derived), result;
        if ($7e41a4fc2954488d$var$_isNativeReflectConstruct()) {
            var NewTarget = $7e41a4fc2954488d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7e41a4fc2954488d$var$_possibleConstructorReturn(this, result);
    };
}
function $7e41a4fc2954488d$var$_possibleConstructorReturn(self, call) {
    if (call && ($7e41a4fc2954488d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7e41a4fc2954488d$var$_assertThisInitialized(self);
}
function $7e41a4fc2954488d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7e41a4fc2954488d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7e41a4fc2954488d$var$_getPrototypeOf(o) {
    $7e41a4fc2954488d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7e41a4fc2954488d$var$_getPrototypeOf(o);
}
function $7e41a4fc2954488d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7e41a4fc2954488d$var$_setPrototypeOf(subClass, superClass);
}
function $7e41a4fc2954488d$var$_setPrototypeOf(o, p) {
    $7e41a4fc2954488d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7e41a4fc2954488d$var$_setPrototypeOf(o, p);
}
function $7e41a4fc2954488d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7e41a4fc2954488d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7e41a4fc2954488d$var$ownKeys(Object(source), true).forEach(function(key) {
            $7e41a4fc2954488d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7e41a4fc2954488d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7e41a4fc2954488d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $7e41a4fc2954488d$var$defaultProps = $7e41a4fc2954488d$var$_objectSpread({}, $lzW2S.default.defaultProps, {
    pickingLineWidthExtraPixels: {
        type: "number",
        min: 0,
        value: Number.MAX_SAFE_INTEGER
    }
});
var $7e41a4fc2954488d$var$EditablePathLayer = /*#__PURE__*/ function(_PathLayer) {
    $7e41a4fc2954488d$var$_inherits(EditablePathLayer, _PathLayer);
    var _super = $7e41a4fc2954488d$var$_createSuper(EditablePathLayer);
    function EditablePathLayer() {
        $7e41a4fc2954488d$var$_classCallCheck(this, EditablePathLayer);
        return _super.apply(this, arguments);
    }
    $7e41a4fc2954488d$var$_createClass(EditablePathLayer, [
        {
            key: "getShaders",
            value: function getShaders() {
                var _shaders$inject;
                var shaders = $7e41a4fc2954488d$var$_get($7e41a4fc2954488d$var$_getPrototypeOf(EditablePathLayer.prototype), "getShaders", this).call(this);
                shaders.vs = (0, $b3BRI.insertBefore)(shaders.vs, "vec3 width;", "\n       if(picking_uActive){\n        widthPixels.xy += pickingLineWidthExtraPixels;\n       }\n      ");
                return $7e41a4fc2954488d$var$_objectSpread({}, shaders, {
                    inject: $7e41a4fc2954488d$var$_objectSpread({}, shaders.inject || {}, {
                        "vs:#decl": (((_shaders$inject = shaders.inject) === null || _shaders$inject === void 0 ? void 0 : _shaders$inject["vs:#decl"]) || "").concat("uniform float pickingLineWidthExtraPixels;")
                    })
                });
            }
        },
        {
            key: "draw",
            value: function draw(props) {
                $7e41a4fc2954488d$var$_get($7e41a4fc2954488d$var$_getPrototypeOf(EditablePathLayer.prototype), "draw", this).call(this, $7e41a4fc2954488d$var$_objectSpread({}, props, {
                    uniforms: $7e41a4fc2954488d$var$_objectSpread({}, props.uniforms, {
                        pickingLineWidthExtraPixels: this.props.pickingLineWidthExtraPixels
                    })
                }));
            }
        }
    ]);
    return EditablePathLayer;
}($lzW2S.default);
module.exports["default"] = $7e41a4fc2954488d$var$EditablePathLayer;
$7e41a4fc2954488d$var$EditablePathLayer.defaultProps = $7e41a4fc2954488d$var$defaultProps;
$7e41a4fc2954488d$var$EditablePathLayer.layerName = "EditablePathLayer";

});
parcelRegister("b3BRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toDeckColor = $80cd58cec7d40001$var$toDeckColor;
module.exports.recursivelyTraverseNestedArrays = $80cd58cec7d40001$var$recursivelyTraverseNestedArrays;
module.exports.generatePointsParallelToLinePoints = $80cd58cec7d40001$var$generatePointsParallelToLinePoints;
module.exports.distance2d = $80cd58cec7d40001$var$distance2d;
module.exports.mix = $80cd58cec7d40001$var$mix;
module.exports.nearestPointOnProjectedLine = $80cd58cec7d40001$var$nearestPointOnProjectedLine;
module.exports.insertBefore = $80cd58cec7d40001$var$insertBefore;

var $80cd58cec7d40001$var$_destination = $80cd58cec7d40001$var$_interopRequireDefault((parcelRequire("1UAWS")));

var $80cd58cec7d40001$var$_bearing = $80cd58cec7d40001$var$_interopRequireDefault((parcelRequire("aDE4l")));

var $80cd58cec7d40001$var$_pointToLineDistance = $80cd58cec7d40001$var$_interopRequireDefault((parcelRequire("3OoMQ")));

var $7GKQS = parcelRequire("7GKQS");

var $80cd58cec7d40001$var$_viewportMercatorProject = $80cd58cec7d40001$var$_interopRequireDefault((parcelRequire("1LAFs")));
function $80cd58cec7d40001$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $80cd58cec7d40001$var$_slicedToArray(arr, i) {
    return $80cd58cec7d40001$var$_arrayWithHoles(arr) || $80cd58cec7d40001$var$_iterableToArrayLimit(arr, i) || $80cd58cec7d40001$var$_unsupportedIterableToArray(arr, i) || $80cd58cec7d40001$var$_nonIterableRest();
}
function $80cd58cec7d40001$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $80cd58cec7d40001$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $80cd58cec7d40001$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $80cd58cec7d40001$var$_toConsumableArray(arr) {
    return $80cd58cec7d40001$var$_arrayWithoutHoles(arr) || $80cd58cec7d40001$var$_iterableToArray(arr) || $80cd58cec7d40001$var$_unsupportedIterableToArray(arr) || $80cd58cec7d40001$var$_nonIterableSpread();
}
function $80cd58cec7d40001$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $80cd58cec7d40001$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $80cd58cec7d40001$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $80cd58cec7d40001$var$_arrayLikeToArray(o, minLen);
}
function $80cd58cec7d40001$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $80cd58cec7d40001$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $80cd58cec7d40001$var$_arrayLikeToArray(arr);
}
function $80cd58cec7d40001$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $80cd58cec7d40001$var$toDeckColor(color) {
    var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        255,
        0,
        0,
        255
    ];
    if (!Array.isArray(color)) return defaultColor;
    return [
        color[0] * 255,
        color[1] * 255,
        color[2] * 255,
        color[3] * 255
    ];
} //
// a GeoJSON helper function that calls the provided function with
// an argument that is the most deeply-nested array having elements
// that are arrays of primitives as an argument, e.g.
//
// {
//   "type": "MultiPolygon",
//   "coordinates": [
//       [
//           [[30, 20], [45, 40], [10, 40], [30, 20]]
//       ],
//       [
//           [[15, 5], [40, 10], [10, 20], [5, 10], [15, 5]]
//       ]
//   ]
// }
//
// the function would be called on:
//
// [[30, 20], [45, 40], [10, 40], [30, 20]]
//
// and
//
// [[15, 5], [40, 10], [10, 20], [5, 10], [15, 5]]
//
function $80cd58cec7d40001$var$recursivelyTraverseNestedArrays(array, prefix, fn) {
    if (!Array.isArray(array[0])) return true;
    for(var i = 0; i < array.length; i++)if ($80cd58cec7d40001$var$recursivelyTraverseNestedArrays(array[i], [].concat($80cd58cec7d40001$var$_toConsumableArray(prefix), [
        i
    ]), fn)) {
        fn(array, prefix);
        break;
    }
    return false;
}
function $80cd58cec7d40001$var$generatePointsParallelToLinePoints(p1, p2, groundCoords) {
    var lineString = {
        type: "LineString",
        coordinates: [
            p1,
            p2
        ]
    };
    var pt = (0, $7GKQS.point)(groundCoords);
    var ddistance = (0, $80cd58cec7d40001$var$_pointToLineDistance["default"])(pt, lineString);
    var lineBearing = (0, $80cd58cec7d40001$var$_bearing["default"])(p1, p2); // Check if current point is to the left or right of line
    // Line from A=(x1,y1) to B=(x2,y2) a point P=(x,y)
    // then (x−x1)(y2−y1)−(y−y1)(x2−x1)
    var isPointToLeftOfLine = (groundCoords[0] - p1[0]) * (p2[1] - p1[1]) - (groundCoords[1] - p1[1]) * (p2[0] - p1[0]); // Bearing to draw perpendicular to the line string
    var orthogonalBearing = isPointToLeftOfLine < 0 ? lineBearing - 90 : lineBearing - 270; // Get coordinates for the point p3 and p4 which are perpendicular to the lineString
    // Add the distance as the current position moves away from the lineString
    var p3 = (0, $80cd58cec7d40001$var$_destination["default"])(p2, ddistance, orthogonalBearing);
    var p4 = (0, $80cd58cec7d40001$var$_destination["default"])(p1, ddistance, orthogonalBearing); //@ts-ignore
    return [
        p3.geometry.coordinates,
        p4.geometry.coordinates
    ];
}
function $80cd58cec7d40001$var$distance2d(x1, y1, x2, y2) {
    var dx = x1 - x2;
    var dy = y1 - y2;
    return Math.sqrt(dx * dx + dy * dy);
}
function $80cd58cec7d40001$var$mix(a, b, ratio) {
    return b * ratio + a * (1 - ratio);
}
function $80cd58cec7d40001$var$nearestPointOnProjectedLine(line, inPoint, viewport) {
    var wmViewport = new $80cd58cec7d40001$var$_viewportMercatorProject["default"](viewport); // Project the line to viewport, then find the nearest point
    var coordinates = line.geometry.coordinates;
    var projectedCoords = coordinates.map(function(_ref) {
        var _ref2 = $80cd58cec7d40001$var$_slicedToArray(_ref, 3), x = _ref2[0], y = _ref2[1], _ref2$ = _ref2[2], z = _ref2$ === void 0 ? 0 : _ref2$;
        return wmViewport.project([
            x,
            y,
            z
        ]);
    }); //@ts-ignore
    var _wmViewport$project = wmViewport.project(inPoint.geometry.coordinates), _wmViewport$project2 = $80cd58cec7d40001$var$_slicedToArray(_wmViewport$project, 2), x = _wmViewport$project2[0], y = _wmViewport$project2[1]; // console.log('projectedCoords', JSON.stringify(projectedCoords));
    var minDistance = Infinity;
    var minPointInfo = {};
    projectedCoords.forEach(function(_ref3, index) {
        var _ref4 = $80cd58cec7d40001$var$_slicedToArray(_ref3, 2), x2 = _ref4[0], y2 = _ref4[1];
        if (index === 0) return;
        var _projectedCoords = $80cd58cec7d40001$var$_slicedToArray(projectedCoords[index - 1], 2), x1 = _projectedCoords[0], y1 = _projectedCoords[1]; // line from projectedCoords[index - 1] to projectedCoords[index]
        // convert to Ax + By + C = 0
        var A = y1 - y2;
        var B = x2 - x1;
        var C = x1 * y2 - x2 * y1; // https://en.wikipedia.org/wiki/Distance_from_a_point_to_a_line
        var div = A * A + B * B;
        var distance = Math.abs(A * x + B * y + C) / Math.sqrt(div); // TODO: Check if inside bounds
        if (distance < minDistance) {
            minDistance = distance;
            minPointInfo = {
                index: index,
                x0: (B * (B * x - A * y) - A * C) / div,
                y0: (A * (-B * x + A * y) - B * C) / div
            };
        }
    }); //@ts-ignore
    var _minPointInfo = minPointInfo, index = _minPointInfo.index, x0 = _minPointInfo.x0, y0 = _minPointInfo.y0;
    var _projectedCoords2 = $80cd58cec7d40001$var$_slicedToArray(projectedCoords[index - 1], 3), x1 = _projectedCoords2[0], y1 = _projectedCoords2[1], _projectedCoords2$ = _projectedCoords2[2], z1 = _projectedCoords2$ === void 0 ? 0 : _projectedCoords2$;
    var _projectedCoords$inde = $80cd58cec7d40001$var$_slicedToArray(projectedCoords[index], 3), x2 = _projectedCoords$inde[0], y2 = _projectedCoords$inde[1], _projectedCoords$inde2 = _projectedCoords$inde[2], z2 = _projectedCoords$inde2 === void 0 ? 0 : _projectedCoords$inde2; // calculate what ratio of the line we are on to find the proper z
    var lineLength = $80cd58cec7d40001$var$distance2d(x1, y1, x2, y2);
    var startToPointLength = $80cd58cec7d40001$var$distance2d(x1, y1, x0, y0);
    var ratio = startToPointLength / lineLength;
    var z0 = $80cd58cec7d40001$var$mix(z1, z2, ratio);
    return {
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: wmViewport.unproject([
                x0,
                y0,
                z0
            ])
        },
        properties: {
            // TODO: calculate the distance in proper units
            dist: minDistance,
            index: index - 1
        }
    };
}
/**
 * Inserts toInsert string into base string before insertBefore string.
 * @param base A string to insert into.
 * @param insertBefore A sub string in `base` string to insert before.
 * @param toInsert A string to insert.
 * @returns Combined string. `base` string if `insertBefore` string isn't found.
 */ function $80cd58cec7d40001$var$insertBefore(base, insertBefore, toInsert) {
    var at = base.indexOf(insertBefore);
    if (at < 0) return base;
    return base.slice(0, at) + toInsert + base.slice(at);
}

});



parcelRegister("QQWRf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bYQax = parcelRequire("bYQax");

var $cQSdn = parcelRequire("cQSdn");

var $1LI2z = parcelRequire("1LI2z");

var $9brng = parcelRequire("9brng");

var $09edede0906ccc60$var$_editableGeojsonLayer = $09edede0906ccc60$var$_interopRequireDefault((parcelRequire("lHhsg")));

var $09edede0906ccc60$var$_editableLayer = $09edede0906ccc60$var$_interopRequireDefault((parcelRequire("7epLg")));
function $09edede0906ccc60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $09edede0906ccc60$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $09edede0906ccc60$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $09edede0906ccc60$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $09edede0906ccc60$var$_typeof(obj);
}
function $09edede0906ccc60$var$_toConsumableArray(arr) {
    return $09edede0906ccc60$var$_arrayWithoutHoles(arr) || $09edede0906ccc60$var$_iterableToArray(arr) || $09edede0906ccc60$var$_unsupportedIterableToArray(arr) || $09edede0906ccc60$var$_nonIterableSpread();
}
function $09edede0906ccc60$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $09edede0906ccc60$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $09edede0906ccc60$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $09edede0906ccc60$var$_arrayLikeToArray(o, minLen);
}
function $09edede0906ccc60$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $09edede0906ccc60$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $09edede0906ccc60$var$_arrayLikeToArray(arr);
}
function $09edede0906ccc60$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $09edede0906ccc60$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $09edede0906ccc60$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $09edede0906ccc60$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $09edede0906ccc60$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $09edede0906ccc60$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $09edede0906ccc60$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $09edede0906ccc60$var$_get = Reflect.get;
    else $09edede0906ccc60$var$_get = function _get(target, property, receiver) {
        var base = $09edede0906ccc60$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $09edede0906ccc60$var$_get(target, property, receiver || target);
}
function $09edede0906ccc60$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $09edede0906ccc60$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $09edede0906ccc60$var$_createSuper(Derived) {
    return function() {
        var Super = $09edede0906ccc60$var$_getPrototypeOf(Derived), result;
        if ($09edede0906ccc60$var$_isNativeReflectConstruct()) {
            var NewTarget = $09edede0906ccc60$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $09edede0906ccc60$var$_possibleConstructorReturn(this, result);
    };
}
function $09edede0906ccc60$var$_possibleConstructorReturn(self, call) {
    if (call && ($09edede0906ccc60$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $09edede0906ccc60$var$_assertThisInitialized(self);
}
function $09edede0906ccc60$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $09edede0906ccc60$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $09edede0906ccc60$var$_getPrototypeOf(o) {
    $09edede0906ccc60$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $09edede0906ccc60$var$_getPrototypeOf(o);
}
function $09edede0906ccc60$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $09edede0906ccc60$var$_setPrototypeOf(subClass, superClass);
}
function $09edede0906ccc60$var$_setPrototypeOf(o, p) {
    $09edede0906ccc60$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $09edede0906ccc60$var$_setPrototypeOf(o, p);
}
function $09edede0906ccc60$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $09edede0906ccc60$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $09edede0906ccc60$var$ownKeys(Object(source), true).forEach(function(key) {
            $09edede0906ccc60$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $09edede0906ccc60$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $09edede0906ccc60$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $09edede0906ccc60$var$DEFAULT_EDIT_MODE = $cQSdn.ViewMode;
var $09edede0906ccc60$var$DEFAULT_H3_RESOLUTION = 9;
var $09edede0906ccc60$var$EMPTY_FEATURE_COLLECTION = {
    type: "FeatureCollection",
    features: []
};
var $09edede0906ccc60$var$defaultProps = $09edede0906ccc60$var$_objectSpread({
    mode: $09edede0906ccc60$var$DEFAULT_EDIT_MODE
}, $09edede0906ccc60$var$_editableGeojsonLayer["default"].defaultProps, {
    // h3 layer
    data: [],
    selectedIndexes: [],
    filled: false,
    stroked: true,
    lineWidthScale: $9brng.PROJECTED_PIXEL_SIZE_MULTIPLIER,
    lineWidthMinPixels: 1,
    lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
    lineWidthUnits: "pixels",
    getHexagons: function getHexagons(d) {
        return d.hexIds;
    },
    getEditedCluster: function getEditedCluster(updatedHexagons, existingCluster) {
        if (existingCluster) return $09edede0906ccc60$var$_objectSpread({}, existingCluster, {
            hexIds: updatedHexagons
        });
        return {
            hexIds: updatedHexagons
        };
    },
    resolution: $09edede0906ccc60$var$DEFAULT_H3_RESOLUTION
});
var $09edede0906ccc60$var$EditableH3ClusterLayer = /*#__PURE__*/ function(_EditableLayer) {
    $09edede0906ccc60$var$_inherits(EditableH3ClusterLayer, _EditableLayer);
    var _super = $09edede0906ccc60$var$_createSuper(EditableH3ClusterLayer);
    function EditableH3ClusterLayer() {
        $09edede0906ccc60$var$_classCallCheck(this, EditableH3ClusterLayer);
        return _super.apply(this, arguments);
    }
    $09edede0906ccc60$var$_createClass(EditableH3ClusterLayer, [
        {
            key: "initializeState",
            value: function initializeState() {
                $09edede0906ccc60$var$_get($09edede0906ccc60$var$_getPrototypeOf(EditableH3ClusterLayer.prototype), "initializeState", this).call(this);
                this.setState({
                    tentativeHexagonIDs: []
                });
            } // convert array of (lng, lat) coords to cluster of hexes
        },
        {
            key: "getDerivedHexagonIDs",
            value: function getDerivedHexagonIDs(coords) {
                return (0, $1LI2z.polyfill)(coords, this.props.resolution, true);
            } // convert pair of (lng, lat) coords into single hex
        },
        {
            key: "getDerivedHexagonID",
            value: function getDerivedHexagonID(coords) {
                return (0, $1LI2z.geoToH3)(coords[1], coords[0], this.props.resolution);
            }
        },
        {
            key: "renderLayers",
            value: function renderLayers() {
                var _this = this;
                var layers = [
                    new $09edede0906ccc60$var$_editableGeojsonLayer["default"](this.getSubLayerProps({
                        id: "editable-geojson",
                        mode: this.props.mode,
                        data: $09edede0906ccc60$var$EMPTY_FEATURE_COLLECTION,
                        selectedFeatureIndexes: [],
                        onEdit: function onEdit(editAction) {
                            var editType = editAction.editType, editContext = editAction.editContext;
                            switch(editType){
                                case "updateTentativeFeature":
                                    // tentative feature updates, updated on every pointer move
                                    if (editContext.feature.geometry.type === "Polygon") {
                                        var coords = editContext.feature.geometry.coordinates;
                                        var hexIDs = _this.getDerivedHexagonIDs(coords);
                                        _this.setState({
                                            tentativeHexagonIDs: hexIDs
                                        });
                                    } else if (editContext.feature.geometry.type === "Point") {
                                        var _coords = editContext.feature.geometry.coordinates;
                                        var hexID = _this.getDerivedHexagonID(_coords);
                                        _this.setState({
                                            tentativeHexagonIDs: [
                                                hexID
                                            ]
                                        });
                                    }
                                    break;
                                case "addFeature":
                                    var _updatedData = $09edede0906ccc60$var$_toConsumableArray(_this.props.data);
                                    var modeConfig = _this.props.modeConfig;
                                    if (!modeConfig || !modeConfig.booleanOperation) // add new h3 cluster
                                    _updatedData.push(_this.props.getEditedCluster(_this.state.tentativeHexagonIDs, null));
                                    else if (_this.props.selectedIndexes.length !== 1) // eslint-disable-next-line no-console,no-undef
                                    console.warn("booleanOperation only supported for single cluster selection");
                                    else {
                                        // they're affecting a selected cluster
                                        var finalHexagonIDs;
                                        var committedHexagonIDs = new Set(_this.getSelectedHexIDs());
                                        var tentativeHexagonIDs = new Set(_this.state.tentativeHexagonIDs);
                                        switch(modeConfig.booleanOperation){
                                            case "union":
                                            default:
                                                finalHexagonIDs = $09edede0906ccc60$var$_toConsumableArray(new Set([].concat($09edede0906ccc60$var$_toConsumableArray(committedHexagonIDs), $09edede0906ccc60$var$_toConsumableArray(tentativeHexagonIDs))));
                                                break;
                                            case "intersection":
                                                finalHexagonIDs = $09edede0906ccc60$var$_toConsumableArray(committedHexagonIDs).filter(function(hexID) {
                                                    return tentativeHexagonIDs.has(hexID);
                                                });
                                                break;
                                            case "difference":
                                                finalHexagonIDs = $09edede0906ccc60$var$_toConsumableArray(committedHexagonIDs).filter(function(hexID) {
                                                    return !tentativeHexagonIDs.has(hexID);
                                                });
                                                break;
                                        }
                                        var selectedIndex = _this.props.selectedIndexes[0];
                                        var _existingCluster = _this.props.data[selectedIndex];
                                        _updatedData[selectedIndex] = _this.props.getEditedCluster(finalHexagonIDs, _existingCluster);
                                    }
                                    _this.setState({
                                        tentativeHexagonIDs: []
                                    });
                                    _this.props.onEdit({
                                        updatedData: _updatedData
                                    });
                                    break;
                                default:
                                    break;
                            }
                        }
                    })),
                    new $bYQax.default(this.getSubLayerProps({
                        id: "hexagons",
                        data: this.props.data,
                        getHexagons: this.props.getHexagons
                    })),
                    new $bYQax.default(this.getSubLayerProps({
                        id: "tentative-hexagons",
                        data: [
                            {
                                hexIds: this.state.tentativeHexagonIDs
                            }
                        ],
                        getHexagons: function getHexagons(d) {
                            return d.hexIds;
                        }
                    }))
                ];
                return layers;
            } // because data is an array of hexagon data, we take the cumulative of all selected indexes,
        },
        {
            key: "getSelectedHexIDs",
            value: function getSelectedHexIDs() {
                var _this2 = this;
                var cumulativeHexIDs = [];
                this.props.selectedIndexes.forEach(function(index) {
                    var selectedCluster = _this2.props.data[index];
                    var hexIDs = _this2.props.getHexagons(selectedCluster);
                    cumulativeHexIDs = cumulativeHexIDs.concat(hexIDs);
                });
                return cumulativeHexIDs;
            }
        },
        {
            key: "getCursor",
            value: function getCursor(_ref) {
                var isDragging = _ref.isDragging;
                var _ref2 = this.state || {}, cursor = _ref2.cursor;
                if (!cursor) // default cursor
                cursor = isDragging ? "grabbing" : "grab";
                return cursor;
            }
        }
    ]);
    return EditableH3ClusterLayer;
}($09edede0906ccc60$var$_editableLayer["default"]);
module.exports["default"] = $09edede0906ccc60$var$EditableH3ClusterLayer;
$09edede0906ccc60$var$_defineProperty($09edede0906ccc60$var$EditableH3ClusterLayer, "layerName", "EditableH3ClusterLayer");
$09edede0906ccc60$var$_defineProperty($09edede0906ccc60$var$EditableH3ClusterLayer, "defaultProps", $09edede0906ccc60$var$defaultProps);

});
parcelRegister("bYQax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b8dc3f3e74d7364$export$2e2bcd8739ae039; });

var $fsooW = parcelRequire("fsooW");

var $aC2tH = parcelRequire("aC2tH");

var $abpME = parcelRequire("abpME");

var $7Nl5T = parcelRequire("7Nl5T");

var $gpJBL = parcelRequire("gpJBL");
const $8b8dc3f3e74d7364$var$defaultProps = {
    getHexagons: {
        type: "accessor",
        value: (d)=>d.hexagons
    }
};
class $8b8dc3f3e74d7364$export$2e2bcd8739ae039 extends (0, $gpJBL.default) {
    initializeState() {
        (0, $7Nl5T.default)._checkH3Lib();
    }
    updateState({ props: props, changeFlags: changeFlags }) {
        if (changeFlags.dataChanged || changeFlags.updateTriggersChanged && changeFlags.updateTriggersChanged.getHexagons) {
            const { data: data, getHexagons: getHexagons } = props;
            const polygons = [];
            const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(data);
            for (const object of iterable){
                objectInfo.index++;
                const hexagons = getHexagons(object, objectInfo);
                const multiPolygon = (0, $aC2tH.h3SetToMultiPolygon)(hexagons, true);
                for (const polygon of multiPolygon)polygons.push(this.getSubLayerRow({
                    polygon: polygon
                }, object, objectInfo.index));
            }
            this.setState({
                polygons: polygons
            });
        }
    }
    indexToBounds() {
        const { getElevation: getElevation, getFillColor: getFillColor, getLineColor: getLineColor, getLineWidth: getLineWidth } = this.props;
        return {
            data: this.state.polygons,
            getPolygon: (d)=>d.polygon,
            getElevation: this.getSubLayerAccessor(getElevation),
            getFillColor: this.getSubLayerAccessor(getFillColor),
            getLineColor: this.getSubLayerAccessor(getLineColor),
            getLineWidth: this.getSubLayerAccessor(getLineWidth)
        };
    }
}
(0, $fsooW.default)($8b8dc3f3e74d7364$export$2e2bcd8739ae039, "layerName", "H3ClusterLayer");
(0, $fsooW.default)($8b8dc3f3e74d7364$export$2e2bcd8739ae039, "defaultProps", $8b8dc3f3e74d7364$var$defaultProps);

});
parcelRegister("fsooW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b40c661e338907f3$export$2e2bcd8739ae039; });
function $b40c661e338907f3$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("aC2tH", function(module, exports) {

$parcel$export(module.exports, "h3IsPentagon", function () { return $7b9f60117f9c280b$export$9e7403b9b01e136f; });
$parcel$export(module.exports, "h3GetResolution", function () { return $7b9f60117f9c280b$export$6827467f3394e8f4; });
$parcel$export(module.exports, "geoToH3", function () { return $7b9f60117f9c280b$export$24131a74a154ec65; });
$parcel$export(module.exports, "h3ToGeo", function () { return $7b9f60117f9c280b$export$317dd65f3721e7c4; });
$parcel$export(module.exports, "h3ToGeoBoundary", function () { return $7b9f60117f9c280b$export$c87d5f55314c67cf; });
$parcel$export(module.exports, "h3SetToMultiPolygon", function () { return $7b9f60117f9c280b$export$911a0c41d9f5c4ed; });
$parcel$export(module.exports, "h3Distance", function () { return $7b9f60117f9c280b$export$f56b06aabd98a7d0; });
$parcel$export(module.exports, "edgeLength", function () { return $7b9f60117f9c280b$export$f9bb3d14d246c386; });
var $7b9f60117f9c280b$var$libh3 = function(libh3) {
    libh3 = libh3 || {};
    var Module = typeof libh3 !== "undefined" ? libh3 : {};
    var moduleOverrides = {};
    var key;
    for(key in Module)if (Module.hasOwnProperty(key)) moduleOverrides[key] = Module[key];
    var arguments_ = [];
    var scriptDirectory = "";
    function locateFile(path) {
        if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
        return scriptDirectory + path;
    }
    var readAsync;
    if (document.currentScript) scriptDirectory = document.currentScript.src;
    if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf("/") + 1);
    else scriptDirectory = "";
    readAsync = function readAsync(url, onload, onerror) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "arraybuffer";
        xhr.onload = function xhr_onload() {
            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                onload(xhr.response);
                return;
            }
            var data = tryParseAsDataURI(url);
            if (data) {
                onload(data.buffer);
                return;
            }
            onerror();
        };
        xhr.onerror = onerror;
        xhr.send(null);
    };
    var out = Module["print"] || console.log.bind(console);
    var err = Module["printErr"] || console.warn.bind(console);
    for(key in moduleOverrides)if (moduleOverrides.hasOwnProperty(key)) Module[key] = moduleOverrides[key];
    moduleOverrides = null;
    if (Module["arguments"]) arguments_ = Module["arguments"];
    var tempRet0 = 0;
    var setTempRet0 = function(value) {
        tempRet0 = value;
    };
    var getTempRet0 = function() {
        return tempRet0;
    };
    var GLOBAL_BASE = 8;
    function setValue(ptr, value, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                HEAP8[ptr >> 0] = value;
                break;
            case "i8":
                HEAP8[ptr >> 0] = value;
                break;
            case "i16":
                HEAP16[ptr >> 1] = value;
                break;
            case "i32":
                HEAP32[ptr >> 2] = value;
                break;
            case "i64":
                tempI64 = [
                    value >>> 0,
                    (tempDouble = value, +Math_abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math_min(+Math_floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];
                break;
            case "float":
                HEAPF32[ptr >> 2] = value;
                break;
            case "double":
                HEAPF64[ptr >> 3] = value;
                break;
            default:
                abort("invalid type for setValue: " + type);
        }
    }
    function getValue(ptr, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                return HEAP8[ptr >> 0];
            case "i8":
                return HEAP8[ptr >> 0];
            case "i16":
                return HEAP16[ptr >> 1];
            case "i32":
                return HEAP32[ptr >> 2];
            case "i64":
                return HEAP32[ptr >> 2];
            case "float":
                return HEAPF32[ptr >> 2];
            case "double":
                return HEAPF64[ptr >> 3];
            default:
                abort("invalid type for getValue: " + type);
        }
        return null;
    }
    var ABORT = false;
    function assert(condition, text) {
        if (!condition) abort("Assertion failed: " + text);
    }
    function getCFunc(ident) {
        var func = Module["_" + ident];
        assert(func, "Cannot call unknown function " + ident + ", make sure it is exported");
        return func;
    }
    function ccall(ident, returnType, argTypes, args, opts) {
        var toC = {
            "string": function(str) {
                var ret = 0;
                if (str !== null && str !== undefined && str !== 0) {
                    var len = (str.length << 2) + 1;
                    ret = stackAlloc(len);
                    stringToUTF8(str, ret, len);
                }
                return ret;
            },
            "array": function(arr) {
                var ret = stackAlloc(arr.length);
                writeArrayToMemory(arr, ret);
                return ret;
            }
        };
        function convertReturnValue(ret) {
            if (returnType === "string") return UTF8ToString(ret);
            if (returnType === "boolean") return Boolean(ret);
            return ret;
        }
        var func = getCFunc(ident);
        var cArgs = [];
        var stack = 0;
        if (args) for(var i = 0; i < args.length; i++){
            var converter = toC[argTypes[i]];
            if (converter) {
                if (stack === 0) stack = stackSave();
                cArgs[i] = converter(args[i]);
            } else cArgs[i] = args[i];
        }
        var ret = func.apply(null, cArgs);
        ret = convertReturnValue(ret);
        if (stack !== 0) stackRestore(stack);
        return ret;
    }
    function cwrap(ident, returnType, argTypes, opts) {
        argTypes = argTypes || [];
        var numericArgs = argTypes.every(function(type) {
            return type === "number";
        });
        var numericRet = returnType !== "string";
        if (numericRet && numericArgs && !opts) return getCFunc(ident);
        return function() {
            return ccall(ident, returnType, argTypes, arguments, opts);
        };
    }
    var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : undefined;
    function UTF8ArrayToString(u8Array, idx, maxBytesToRead) {
        var endIdx = idx + maxBytesToRead;
        var endPtr = idx;
        while(u8Array[endPtr] && !(endPtr >= endIdx))++endPtr;
        if (endPtr - idx > 16 && u8Array.subarray && UTF8Decoder) return UTF8Decoder.decode(u8Array.subarray(idx, endPtr));
        else {
            var str = "";
            while(idx < endPtr){
                var u0 = u8Array[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = u8Array[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = u8Array[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | u8Array[idx++] & 63;
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
        }
        return str;
    }
    function UTF8ToString(ptr, maxBytesToRead) {
        return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
    }
    function stringToUTF8Array(str, outU8Array, outIdx, maxBytesToWrite) {
        if (!(maxBytesToWrite > 0)) return 0;
        var startIdx = outIdx;
        var endIdx = outIdx + maxBytesToWrite - 1;
        for(var i = 0; i < str.length; ++i){
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
                var u1 = str.charCodeAt(++i);
                u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
                if (outIdx >= endIdx) break;
                outU8Array[outIdx++] = u;
            } else if (u <= 2047) {
                if (outIdx + 1 >= endIdx) break;
                outU8Array[outIdx++] = 192 | u >> 6;
                outU8Array[outIdx++] = 128 | u & 63;
            } else if (u <= 65535) {
                if (outIdx + 2 >= endIdx) break;
                outU8Array[outIdx++] = 224 | u >> 12;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            } else {
                if (outIdx + 3 >= endIdx) break;
                outU8Array[outIdx++] = 240 | u >> 18;
                outU8Array[outIdx++] = 128 | u >> 12 & 63;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            }
        }
        outU8Array[outIdx] = 0;
        return outIdx - startIdx;
    }
    function stringToUTF8(str, outPtr, maxBytesToWrite) {
        return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
    }
    var UTF16Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : undefined;
    function writeArrayToMemory(array, buffer) {
        HEAP8.set(array, buffer);
    }
    function alignUp(x, multiple) {
        if (x % multiple > 0) x += multiple - x % multiple;
        return x;
    }
    var buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
    function updateGlobalBufferAndViews(buf) {
        buffer = buf;
        Module["HEAP8"] = HEAP8 = new Int8Array(buf);
        Module["HEAP16"] = HEAP16 = new Int16Array(buf);
        Module["HEAP32"] = HEAP32 = new Int32Array(buf);
        Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
        Module["HEAPU16"] = HEAPU16 = new Uint16Array(buf);
        Module["HEAPU32"] = HEAPU32 = new Uint32Array(buf);
        Module["HEAPF32"] = HEAPF32 = new Float32Array(buf);
        Module["HEAPF64"] = HEAPF64 = new Float64Array(buf);
    }
    var DYNAMIC_BASE = 5266928, DYNAMICTOP_PTR = 24016;
    var INITIAL_TOTAL_MEMORY = Module["TOTAL_MEMORY"] || 33554432;
    if (Module["buffer"]) buffer = Module["buffer"];
    else buffer = new ArrayBuffer(INITIAL_TOTAL_MEMORY);
    INITIAL_TOTAL_MEMORY = buffer.byteLength;
    updateGlobalBufferAndViews(buffer);
    HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;
    function callRuntimeCallbacks(callbacks) {
        while(callbacks.length > 0){
            var callback = callbacks.shift();
            if (typeof callback == "function") {
                callback();
                continue;
            }
            var func = callback.func;
            if (typeof func === "number") {
                if (callback.arg === undefined) Module["dynCall_v"](func);
                else Module["dynCall_vi"](func, callback.arg);
            } else func(callback.arg === undefined ? null : callback.arg);
        }
    }
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATMAIN__ = [];
    var __ATPOSTRUN__ = [];
    function preRun() {
        if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [
                Module["preRun"]
            ];
            while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
        }
        callRuntimeCallbacks(__ATPRERUN__);
    }
    function initRuntime() {
        callRuntimeCallbacks(__ATINIT__);
    }
    function preMain() {
        callRuntimeCallbacks(__ATMAIN__);
    }
    function postRun() {
        if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [
                Module["postRun"]
            ];
            while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
        }
        callRuntimeCallbacks(__ATPOSTRUN__);
    }
    function addOnPreRun(cb) {
        __ATPRERUN__.unshift(cb);
    }
    function addOnPostRun(cb) {
        __ATPOSTRUN__.unshift(cb);
    }
    var Math_abs = Math.abs;
    var Math_ceil = Math.ceil;
    var Math_floor = Math.floor;
    var Math_min = Math.min;
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;
    function addRunDependency(id) {
        runDependencies++;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
    }
    function removeRunDependency(id) {
        runDependencies--;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
                clearInterval(runDependencyWatcher);
                runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
                var callback = dependenciesFulfilled;
                dependenciesFulfilled = null;
                callback();
            }
        }
    }
    Module["preloadedImages"] = {};
    Module["preloadedAudios"] = {};
    var memoryInitializer = null;
    var dataURIPrefix = "data:application/octet-stream;base64,";
    function isDataURI(filename) {
        return String.prototype.startsWith ? filename.startsWith(dataURIPrefix) : filename.indexOf(dataURIPrefix) === 0;
    }
    var tempDouble;
    var tempI64;
    memoryInitializer = "data:application/octet-stream;base64,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";
    var tempDoublePtr = 24032;
    function demangle(func) {
        return func;
    }
    function demangleAll(text) {
        var regex = /\b__Z[\w\d_]+/g;
        return text.replace(regex, function(x) {
            var y = demangle(x);
            return x === y ? x : y + " [" + x + "]";
        });
    }
    function jsStackTrace() {
        var err = new Error();
        if (!err.stack) {
            try {
                throw new Error(0);
            } catch (e) {
                err = e;
            }
            if (!err.stack) return "(no stack trace available)";
        }
        return err.stack.toString();
    }
    function stackTrace() {
        var js = jsStackTrace();
        if (Module["extraStackTrace"]) js += "\n" + Module["extraStackTrace"]();
        return demangleAll(js);
    }
    function ___assert_fail(condition, filename, line, func) {
        abort("Assertion failed: " + UTF8ToString(condition) + ", at: " + [
            filename ? UTF8ToString(filename) : "unknown filename",
            line,
            func ? UTF8ToString(func) : "unknown function"
        ]);
    }
    function _emscripten_get_heap_size() {
        return HEAP8.length;
    }
    function _emscripten_memcpy_big(dest, src, num) {
        HEAPU8.set(HEAPU8.subarray(src, src + num), dest);
    }
    function ___setErrNo(value) {
        if (Module["___errno_location"]) HEAP32[Module["___errno_location"]() >> 2] = value;
        return value;
    }
    function abortOnCannotGrowMemory(requestedSize) {
        abort("OOM");
    }
    function emscripten_realloc_buffer(size) {
        try {
            var newBuffer = new ArrayBuffer(size);
            if (newBuffer.byteLength != size) return;
            new Int8Array(newBuffer).set(HEAP8);
            _emscripten_replace_memory(newBuffer);
            updateGlobalBufferAndViews(newBuffer);
            return 1;
        } catch (e) {}
    }
    function _emscripten_resize_heap(requestedSize) {
        var oldSize = _emscripten_get_heap_size();
        var PAGE_MULTIPLE = 16777216;
        var LIMIT = 2147483648 - PAGE_MULTIPLE;
        if (requestedSize > LIMIT) return false;
        var MIN_TOTAL_MEMORY = 16777216;
        var newSize = Math.max(oldSize, MIN_TOTAL_MEMORY);
        while(newSize < requestedSize)if (newSize <= 536870912) newSize = alignUp(2 * newSize, PAGE_MULTIPLE);
        else newSize = Math.min(alignUp((3 * newSize + 2147483648) / 4, PAGE_MULTIPLE), LIMIT);
        var replacement = emscripten_realloc_buffer(newSize);
        if (!replacement) return false;
        return true;
    }
    var decodeBase64 = typeof atob === "function" ? atob : function(input) {
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        do {
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 !== 64) output = output + String.fromCharCode(chr2);
            if (enc4 !== 64) output = output + String.fromCharCode(chr3);
        }while (i < input.length);
        return output;
    };
    function intArrayFromBase64(s) {
        try {
            var decoded = decodeBase64(s);
            var bytes = new Uint8Array(decoded.length);
            for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
            return bytes;
        } catch (_) {
            throw new Error("Converting base64 string to bytes failed.");
        }
    }
    function tryParseAsDataURI(filename) {
        if (!isDataURI(filename)) return;
        return intArrayFromBase64(filename.slice(dataURIPrefix.length));
    }
    var asmGlobalArg = {
        "Math": Math,
        "Int8Array": Int8Array,
        "Int32Array": Int32Array,
        "Uint8Array": Uint8Array,
        "Float32Array": Float32Array,
        "Float64Array": Float64Array
    };
    var asmLibraryArg = {
        "a": abort,
        "b": setTempRet0,
        "c": getTempRet0,
        "d": ___assert_fail,
        "e": ___setErrNo,
        "f": _emscripten_get_heap_size,
        "g": _emscripten_memcpy_big,
        "h": _emscripten_resize_heap,
        "i": abortOnCannotGrowMemory,
        "j": demangle,
        "k": demangleAll,
        "l": emscripten_realloc_buffer,
        "m": jsStackTrace,
        "n": stackTrace,
        "o": tempDoublePtr,
        "p": DYNAMICTOP_PTR
    }; // EMSCRIPTEN_START_ASM
    var asm = /** @suppress {uselessCode} */ function(global, env, buffer) {
        "almost asm";
        var a = new global.Int8Array(buffer), b = new global.Int32Array(buffer), c = new global.Uint8Array(buffer), d = new global.Float32Array(buffer), e = new global.Float64Array(buffer), g = env.p | 0, p = global.Math.floor, q = global.Math.abs, r = global.Math.sqrt, s = global.Math.pow, t = global.Math.cos, u = global.Math.sin, v = global.Math.tan, w = global.Math.acos, x = global.Math.asin, y = global.Math.atan, z = global.Math.atan2, A = global.Math.ceil, B = global.Math.imul, C = global.Math.min, D = global.Math.clz32, F = env.b, G = env.c, H = env.d, I = env.e, J = env.f, K = env.g, L = env.h, M = env.i, S = 24048;
        function V(newBuffer) {
            a = new Int8Array(newBuffer);
            c = new Uint8Array(newBuffer);
            b = new Int32Array(newBuffer);
            d = new Float32Array(newBuffer);
            e = new Float64Array(newBuffer);
            buffer = newBuffer;
            return true;
        } // EMSCRIPTEN_START_FUNCS
        function W(a) {
            a = a | 0;
            var b = 0;
            b = S;
            S = S + a | 0;
            S = S + 15 & -16;
            return b | 0;
        }
        function X() {
            return S | 0;
        }
        function Y(a) {
            a = a | 0;
            S = a;
        }
        function Z(a, b) {
            a = a | 0;
            b = b | 0;
            S = a;
        }
        function _(a) {
            a = a | 0;
            return (B(a * 3 | 0, a + 1 | 0) | 0) + 1 | 0;
        }
        function $(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            if (!(ba(a, b, c, d, 0) | 0)) return;
            f = (B(c * 3 | 0, c + 1 | 0) | 0) + 1 | 0;
            hd(d | 0, 0, f << 3 | 0);
            e = Yc(f, 4) | 0;
            if (!e) return;
            ca(a, b, c, d, e, f, 0);
            Xc(e);
            return;
        }
        function aa(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            if (!(ba(a, b, c, d, e) | 0)) return;
            f = (B(c * 3 | 0, c + 1 | 0) | 0) + 1 | 0;
            hd(d | 0, 0, f << 3 | 0);
            if (e | 0) {
                hd(e | 0, 0, f << 2 | 0);
                ca(a, b, c, d, e, f, 0);
                return;
            }
            e = Yc(f, 4) | 0;
            if (!e) return;
            ca(a, b, c, d, e, f, 0);
            Xc(e);
            return;
        }
        function ba(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
            o = S;
            S = S + 16 | 0;
            n = o;
            g = e;
            b[g >> 2] = a;
            b[g + 4 >> 2] = c;
            g = (f | 0) != 0;
            if (g) b[f >> 2] = 0;
            if (Fb(a, c) | 0) {
                n = 1;
                S = o;
                return n | 0;
            }
            b[n >> 2] = 0;
            a: do if ((d | 0) >= 1) {
                if (g) {
                    k = 0;
                    l = 1;
                    m = 1;
                    h = 0;
                    g = a;
                    while(true){
                        if (!(h | k)) {
                            g = da(g, c, 4, n) | 0;
                            c = G() | 0;
                            if ((g | 0) == 0 & (c | 0) == 0) {
                                g = 2;
                                break a;
                            }
                            if (Fb(g, c) | 0) {
                                g = 1;
                                break a;
                            }
                        }
                        g = da(g, c, b[16 + (k << 2) >> 2] | 0, n) | 0;
                        c = G() | 0;
                        if ((g | 0) == 0 & (c | 0) == 0) {
                            g = 2;
                            break a;
                        }
                        a = e + (m << 3) | 0;
                        b[a >> 2] = g;
                        b[a + 4 >> 2] = c;
                        b[f + (m << 2) >> 2] = l;
                        h = h + 1 | 0;
                        a = (h | 0) == (l | 0);
                        i = k + 1 | 0;
                        j = (i | 0) == 6;
                        if (Fb(g, c) | 0) {
                            g = 1;
                            break a;
                        }
                        l = l + (j & a & 1) | 0;
                        if ((l | 0) > (d | 0)) {
                            g = 0;
                            break;
                        } else {
                            k = a ? j ? 0 : i : k;
                            m = m + 1 | 0;
                            h = a ? 0 : h;
                        }
                    }
                } else {
                    k = 0;
                    l = 1;
                    m = 1;
                    h = 0;
                    g = a;
                    while(true){
                        if (!(h | k)) {
                            g = da(g, c, 4, n) | 0;
                            c = G() | 0;
                            if ((g | 0) == 0 & (c | 0) == 0) {
                                g = 2;
                                break a;
                            }
                            if (Fb(g, c) | 0) {
                                g = 1;
                                break a;
                            }
                        }
                        g = da(g, c, b[16 + (k << 2) >> 2] | 0, n) | 0;
                        c = G() | 0;
                        if ((g | 0) == 0 & (c | 0) == 0) {
                            g = 2;
                            break a;
                        }
                        a = e + (m << 3) | 0;
                        b[a >> 2] = g;
                        b[a + 4 >> 2] = c;
                        h = h + 1 | 0;
                        a = (h | 0) == (l | 0);
                        i = k + 1 | 0;
                        j = (i | 0) == 6;
                        if (Fb(g, c) | 0) {
                            g = 1;
                            break a;
                        }
                        l = l + (j & a & 1) | 0;
                        if ((l | 0) > (d | 0)) {
                            g = 0;
                            break;
                        } else {
                            k = a ? j ? 0 : i : k;
                            m = m + 1 | 0;
                            h = a ? 0 : h;
                        }
                    }
                }
            } else g = 0;
            while (0);
            n = g;
            S = o;
            return n | 0;
        }
        function ca(a, c, d, e, f, g, h) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
            m = S;
            S = S + 16 | 0;
            l = m;
            if ((a | 0) == 0 & (c | 0) == 0) {
                S = m;
                return;
            }
            i = bd(a | 0, c | 0, g | 0, ((g | 0) < 0) << 31 >> 31 | 0) | 0;
            G();
            j = e + (i << 3) | 0;
            n = j;
            o = b[n >> 2] | 0;
            n = b[n + 4 >> 2] | 0;
            k = (o | 0) == (a | 0) & (n | 0) == (c | 0);
            if (!((o | 0) == 0 & (n | 0) == 0 | k)) do {
                i = (i + 1 | 0) % (g | 0) | 0;
                j = e + (i << 3) | 0;
                o = j;
                n = b[o >> 2] | 0;
                o = b[o + 4 >> 2] | 0;
                k = (n | 0) == (a | 0) & (o | 0) == (c | 0);
            }while (!((n | 0) == 0 & (o | 0) == 0 | k));
            i = f + (i << 2) | 0;
            if (k ? (b[i >> 2] | 0) <= (h | 0) : 0) {
                S = m;
                return;
            }
            o = j;
            b[o >> 2] = a;
            b[o + 4 >> 2] = c;
            b[i >> 2] = h;
            if ((h | 0) >= (d | 0)) {
                S = m;
                return;
            }
            o = h + 1 | 0;
            b[l >> 2] = 0;
            n = da(a, c, 2, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 3, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 1, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 5, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 4, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 6, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            S = m;
            return;
        }
        function da(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
            if ((b[e >> 2] | 0) > 0) {
                f = 0;
                do {
                    d = Pa(d) | 0;
                    f = f + 1 | 0;
                }while ((f | 0) < (b[e >> 2] | 0));
            }
            i = cd(a | 0, c | 0, 45) | 0;
            G();
            j = i & 127;
            g = Lb(a, c) | 0;
            f = cd(a | 0, c | 0, 52) | 0;
            G();
            f = f & 15;
            a: do {
                if (!f) h = 6;
                else while(true){
                    m = (15 - f | 0) * 3 | 0;
                    n = cd(a | 0, c | 0, m | 0) | 0;
                    G();
                    n = n & 7;
                    o = (Rb(f) | 0) == 0;
                    f = f + -1 | 0;
                    l = dd(7, 0, m | 0) | 0;
                    c = c & ~(G() | 0);
                    m = dd(b[(o ? 464 : 48) + (n * 28 | 0) + (d << 2) >> 2] | 0, 0, m | 0) | 0;
                    k = G() | 0;
                    d = b[(o ? 672 : 256) + (n * 28 | 0) + (d << 2) >> 2] | 0;
                    a = m | a & ~l;
                    c = k | c;
                    if (!d) {
                        d = 0;
                        break a;
                    }
                    if (!f) {
                        h = 6;
                        break;
                    }
                }
            }while (0);
            if ((h | 0) == 6) {
                o = b[880 + (j * 28 | 0) + (d << 2) >> 2] | 0;
                n = dd(o | 0, 0, 45) | 0;
                a = n | a;
                c = G() | 0 | c & -1040385;
                d = b[4304 + (j * 28 | 0) + (d << 2) >> 2] | 0;
                if ((o & 127 | 0) == 127) {
                    o = dd(b[880 + (j * 28 | 0) + 20 >> 2] | 0, 0, 45) | 0;
                    c = G() | 0 | c & -1040385;
                    d = b[4304 + (j * 28 | 0) + 20 >> 2] | 0;
                    a = Nb(o | a, c) | 0;
                    c = G() | 0;
                    b[e >> 2] = (b[e >> 2] | 0) + 1;
                }
            }
            h = cd(a | 0, c | 0, 45) | 0;
            G();
            h = h & 127;
            b: do {
                if (!(la(h) | 0)) {
                    if ((d | 0) > 0) {
                        f = 0;
                        do {
                            a = Nb(a, c) | 0;
                            c = G() | 0;
                            f = f + 1 | 0;
                        }while ((f | 0) != (d | 0));
                    }
                } else {
                    c: do if ((Lb(a, c) | 0) == 1) {
                        if ((j | 0) != (h | 0)) {
                            if (ra(h, b[7728 + (j * 28 | 0) >> 2] | 0) | 0) {
                                a = Pb(a, c) | 0;
                                g = 1;
                                c = G() | 0;
                                break;
                            } else {
                                a = Nb(a, c) | 0;
                                g = 1;
                                c = G() | 0;
                                break;
                            }
                        }
                        switch(g | 0){
                            case 5:
                                a = Pb(a, c) | 0;
                                c = G() | 0;
                                b[e >> 2] = (b[e >> 2] | 0) + 5;
                                g = 0;
                                break c;
                            case 3:
                                a = Nb(a, c) | 0;
                                c = G() | 0;
                                b[e >> 2] = (b[e >> 2] | 0) + 1;
                                g = 0;
                                break c;
                            default:
                                n = 0;
                                o = 0;
                                F(n | 0);
                                return o | 0;
                        }
                    } else g = 0;
                    while (0);
                    if ((d | 0) > 0) {
                        f = 0;
                        do {
                            a = Mb(a, c) | 0;
                            c = G() | 0;
                            f = f + 1 | 0;
                        }while ((f | 0) != (d | 0));
                    }
                    if ((j | 0) != (h | 0)) {
                        if (!(ma(h) | 0)) {
                            if ((g | 0) != 0 | (Lb(a, c) | 0) != 5) break;
                            b[e >> 2] = (b[e >> 2] | 0) + 1;
                            break;
                        }
                        switch(i & 127){
                            case 8:
                            case 118:
                                break b;
                            default:
                        }
                        if ((Lb(a, c) | 0) != 3) b[e >> 2] = (b[e >> 2] | 0) + 1;
                    }
                }
            }while (0);
            b[e >> 2] = ((b[e >> 2] | 0) + d | 0) % 6 | 0;
            n = c;
            o = a;
            F(n | 0);
            return o | 0;
        }
        function ea(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            m = S;
            S = S + 16 | 0;
            l = m;
            if (!d) {
                l = e;
                b[l >> 2] = a;
                b[l + 4 >> 2] = c;
                l = 0;
                S = m;
                return l | 0;
            }
            b[l >> 2] = 0;
            a: do if (!(Fb(a, c) | 0)) {
                g = (d | 0) > 0;
                if (g) {
                    f = 0;
                    k = a;
                    do {
                        k = da(k, c, 4, l) | 0;
                        c = G() | 0;
                        if ((k | 0) == 0 & (c | 0) == 0) {
                            a = 2;
                            break a;
                        }
                        f = f + 1 | 0;
                        if (Fb(k, c) | 0) {
                            a = 1;
                            break a;
                        }
                    }while ((f | 0) < (d | 0));
                    j = e;
                    b[j >> 2] = k;
                    b[j + 4 >> 2] = c;
                    j = d + -1 | 0;
                    if (g) {
                        g = 0;
                        h = 1;
                        f = k;
                        a = c;
                        do {
                            f = da(f, a, 2, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (h << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            h = h + 1 | 0;
                            if (Fb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            g = g + 1 | 0;
                        }while ((g | 0) < (d | 0));
                        i = 0;
                        g = h;
                        do {
                            f = da(f, a, 3, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            h = e + (g << 3) | 0;
                            b[h >> 2] = f;
                            b[h + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Fb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            i = i + 1 | 0;
                        }while ((i | 0) < (d | 0));
                        h = 0;
                        do {
                            f = da(f, a, 1, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (g << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Fb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            h = h + 1 | 0;
                        }while ((h | 0) < (d | 0));
                        h = 0;
                        do {
                            f = da(f, a, 5, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (g << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Fb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            h = h + 1 | 0;
                        }while ((h | 0) < (d | 0));
                        h = 0;
                        do {
                            f = da(f, a, 4, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (g << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Fb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            h = h + 1 | 0;
                        }while ((h | 0) < (d | 0));
                        h = 0;
                        while(true){
                            f = da(f, a, 6, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            if ((h | 0) != (j | 0)) {
                                i = e + (g << 3) | 0;
                                b[i >> 2] = f;
                                b[i + 4 >> 2] = a;
                                if (!(Fb(f, a) | 0)) g = g + 1 | 0;
                                else {
                                    a = 1;
                                    break a;
                                }
                            }
                            h = h + 1 | 0;
                            if ((h | 0) >= (d | 0)) {
                                h = k;
                                g = c;
                                break;
                            }
                        }
                    } else {
                        h = k;
                        f = k;
                        g = c;
                        a = c;
                    }
                } else {
                    h = e;
                    b[h >> 2] = a;
                    b[h + 4 >> 2] = c;
                    h = a;
                    f = a;
                    g = c;
                    a = c;
                }
                a = ((h | 0) != (f | 0) | (g | 0) != (a | 0)) & 1;
            } else a = 1;
            while (0);
            l = a;
            S = m;
            return l | 0;
        }
        function fa(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            g = S;
            S = S + 48 | 0;
            f = g + 8 | 0;
            e = g;
            i = a;
            h = b[i + 4 >> 2] | 0;
            d = e;
            b[d >> 2] = b[i >> 2];
            b[d + 4 >> 2] = h;
            vc(e, f);
            f = ya(f, c) | 0;
            c = b[e >> 2] | 0;
            e = b[a + 8 >> 2] | 0;
            if ((e | 0) <= 0) {
                i = c;
                h = (f | 0) < (i | 0);
                i = h ? i : f;
                i = i + 12 | 0;
                S = g;
                return i | 0;
            }
            d = b[a + 12 >> 2] | 0;
            a = 0;
            do {
                c = (b[d + (a << 3) >> 2] | 0) + c | 0;
                a = a + 1 | 0;
            }while ((a | 0) < (e | 0));
            i = (f | 0) < (c | 0);
            i = i ? c : f;
            i = i + 12 | 0;
            S = g;
            return i | 0;
        }
        function ga(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = S;
            S = S + 48 | 0;
            e = i + 8 | 0;
            f = i;
            if (!(ha(a, c, d) | 0)) {
                S = i;
                return;
            }
            j = a;
            g = b[j + 4 >> 2] | 0;
            h = f;
            b[h >> 2] = b[j >> 2];
            b[h + 4 >> 2] = g;
            vc(f, e);
            h = ya(e, c) | 0;
            c = b[f >> 2] | 0;
            g = b[a + 8 >> 2] | 0;
            if ((g | 0) > 0) {
                f = b[a + 12 >> 2] | 0;
                e = 0;
                do {
                    c = (b[f + (e << 3) >> 2] | 0) + c | 0;
                    e = e + 1 | 0;
                }while ((e | 0) != (g | 0));
            }
            c = (h | 0) < (c | 0) ? c : h;
            if ((c | 0) <= -12) {
                S = i;
                return;
            }
            j = c + 11 | 0;
            hd(d | 0, 0, (((j | 0) > 0 ? j : 0) << 3) + 8 | 0);
            S = i;
            return;
        }
        function ha(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, I = 0, J = 0;
            J = S;
            S = S + 112 | 0;
            D = J + 80 | 0;
            j = J + 72 | 0;
            E = J;
            F = J + 56 | 0;
            k = a + 8 | 0;
            I = Wc((b[k >> 2] << 5) + 32 | 0) | 0;
            if (!I) H(22848, 22448, 800, 22456);
            wc(a, I);
            g = a;
            e = b[g + 4 >> 2] | 0;
            i = j;
            b[i >> 2] = b[g >> 2];
            b[i + 4 >> 2] = e;
            vc(j, D);
            i = ya(D, c) | 0;
            e = b[j >> 2] | 0;
            g = b[k >> 2] | 0;
            if ((g | 0) > 0) {
                h = b[a + 12 >> 2] | 0;
                f = 0;
                do {
                    e = (b[h + (f << 3) >> 2] | 0) + e | 0;
                    f = f + 1 | 0;
                }while ((f | 0) != (g | 0));
            }
            i = (i | 0) < (e | 0) ? e : i;
            C = i + 12 | 0;
            f = Yc(C, 8) | 0;
            l = Yc(C, 8) | 0;
            b[D >> 2] = 0;
            A = a;
            B = b[A + 4 >> 2] | 0;
            e = j;
            b[e >> 2] = b[A >> 2];
            b[e + 4 >> 2] = B;
            e = ia(j, C, c, D, f, l) | 0;
            if (e | 0) {
                Xc(f);
                Xc(l);
                Xc(I);
                I = e;
                S = J;
                return I | 0;
            }
            a: do if ((b[k >> 2] | 0) > 0) {
                g = a + 12 | 0;
                e = 0;
                while(true){
                    h = ia((b[g >> 2] | 0) + (e << 3) | 0, C, c, D, f, l) | 0;
                    e = e + 1 | 0;
                    if (h | 0) break;
                    if ((e | 0) >= (b[k >> 2] | 0)) break a;
                }
                Xc(f);
                Xc(l);
                Xc(I);
                I = h;
                S = J;
                return I | 0;
            }
            while (0);
            if ((i | 0) > -12) hd(l | 0, 0, ((C | 0) > 1 ? C : 1) << 3 | 0);
            b: do if ((b[D >> 2] | 0) > 0) {
                B = ((C | 0) < 0) << 31 >> 31;
                v = f;
                w = l;
                x = f;
                y = f;
                z = l;
                A = f;
                e = f;
                r = f;
                s = l;
                t = l;
                u = l;
                f = l;
                c: while(true){
                    q = b[D >> 2] | 0;
                    o = 0;
                    p = 0;
                    g = 0;
                    while(true){
                        h = E;
                        i = h + 56 | 0;
                        do {
                            b[h >> 2] = 0;
                            h = h + 4 | 0;
                        }while ((h | 0) < (i | 0));
                        c = v + (o << 3) | 0;
                        j = b[c >> 2] | 0;
                        c = b[c + 4 >> 2] | 0;
                        if (ba(j, c, 1, E, 0) | 0) {
                            h = E;
                            i = h + 56 | 0;
                            do {
                                b[h >> 2] = 0;
                                h = h + 4 | 0;
                            }while ((h | 0) < (i | 0));
                            h = Yc(7, 4) | 0;
                            if (h | 0) {
                                ca(j, c, 1, E, h, 7, 0);
                                Xc(h);
                            }
                        }
                        n = 0;
                        do {
                            m = E + (n << 3) | 0;
                            l = b[m >> 2] | 0;
                            m = b[m + 4 >> 2] | 0;
                            d: do if (!((l | 0) == 0 & (m | 0) == 0)) {
                                j = bd(l | 0, m | 0, C | 0, B | 0) | 0;
                                G();
                                h = d + (j << 3) | 0;
                                i = h;
                                c = b[i >> 2] | 0;
                                i = b[i + 4 >> 2] | 0;
                                if (!((c | 0) == 0 & (i | 0) == 0)) {
                                    k = 0;
                                    while(true){
                                        if ((k | 0) > (C | 0)) break c;
                                        if ((c | 0) == (l | 0) & (i | 0) == (m | 0)) break d;
                                        j = (j + 1 | 0) % (C | 0) | 0;
                                        h = d + (j << 3) | 0;
                                        i = h;
                                        c = b[i >> 2] | 0;
                                        i = b[i + 4 >> 2] | 0;
                                        if ((c | 0) == 0 & (i | 0) == 0) break;
                                        else k = k + 1 | 0;
                                    }
                                }
                                if (!((l | 0) == 0 & (m | 0) == 0)) {
                                    Vb(l, m, F);
                                    if (xc(a, I, F) | 0) {
                                        k = h;
                                        b[k >> 2] = l;
                                        b[k + 4 >> 2] = m;
                                        k = w + (g << 3) | 0;
                                        b[k >> 2] = l;
                                        b[k + 4 >> 2] = m;
                                        g = g + 1 | 0;
                                    }
                                }
                            }
                            while (0);
                            n = n + 1 | 0;
                        }while (n >>> 0 < 7);
                        p = p + 1 | 0;
                        if ((p | 0) >= (q | 0)) break;
                        else o = o + 1 | 0;
                    }
                    if ((q | 0) > 0) hd(x | 0, 0, q << 3 | 0);
                    b[D >> 2] = g;
                    if ((g | 0) > 0) {
                        l = f;
                        m = u;
                        n = A;
                        o = t;
                        p = s;
                        q = w;
                        f = r;
                        u = e;
                        t = y;
                        s = x;
                        r = l;
                        e = m;
                        A = z;
                        z = n;
                        y = o;
                        x = p;
                        w = v;
                        v = q;
                    } else break b;
                }
                Xc(y);
                Xc(z);
                Xc(I);
                I = -1;
                S = J;
                return I | 0;
            } else e = l;
            while (0);
            Xc(I);
            Xc(f);
            Xc(e);
            I = 0;
            S = J;
            return I | 0;
        }
        function ia(a, c, d, f, g, h) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0.0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0.0, E = 0.0;
            C = S;
            S = S + 48 | 0;
            y = C + 32 | 0;
            z = C + 16 | 0;
            A = C;
            i = b[a >> 2] | 0;
            if ((i | 0) <= 0) {
                B = 0;
                S = C;
                return B | 0;
            }
            t = a + 4 | 0;
            u = y + 8 | 0;
            v = z + 8 | 0;
            w = A + 8 | 0;
            x = ((c | 0) < 0) << 31 >> 31;
            s = 0;
            a: while(true){
                j = b[t >> 2] | 0;
                q = j + (s << 4) | 0;
                b[y >> 2] = b[q >> 2];
                b[y + 4 >> 2] = b[q + 4 >> 2];
                b[y + 8 >> 2] = b[q + 8 >> 2];
                b[y + 12 >> 2] = b[q + 12 >> 2];
                if ((s | 0) == (i + -1 | 0)) {
                    b[z >> 2] = b[j >> 2];
                    b[z + 4 >> 2] = b[j + 4 >> 2];
                    b[z + 8 >> 2] = b[j + 8 >> 2];
                    b[z + 12 >> 2] = b[j + 12 >> 2];
                } else {
                    q = j + (s + 1 << 4) | 0;
                    b[z >> 2] = b[q >> 2];
                    b[z + 4 >> 2] = b[q + 4 >> 2];
                    b[z + 8 >> 2] = b[q + 8 >> 2];
                    b[z + 12 >> 2] = b[q + 12 >> 2];
                }
                q = za(y, z, d) | 0;
                b: do if ((q | 0) > 0) {
                    r = +(q | 0);
                    p = 0;
                    c: while(true){
                        E = +(q - p | 0);
                        D = +(p | 0);
                        e[A >> 3] = +e[y >> 3] * E / r + +e[z >> 3] * D / r;
                        e[w >> 3] = +e[u >> 3] * E / r + +e[v >> 3] * D / r;
                        n = Sb(A, d) | 0;
                        o = G() | 0;
                        j = bd(n | 0, o | 0, c | 0, x | 0) | 0;
                        G();
                        i = h + (j << 3) | 0;
                        k = i;
                        l = b[k >> 2] | 0;
                        k = b[k + 4 >> 2] | 0;
                        d: do if ((l | 0) == 0 & (k | 0) == 0) B = 14;
                        else {
                            m = 0;
                            while(true){
                                if ((m | 0) > (c | 0)) {
                                    i = 1;
                                    break d;
                                }
                                if ((l | 0) == (n | 0) & (k | 0) == (o | 0)) {
                                    i = 7;
                                    break d;
                                }
                                j = (j + 1 | 0) % (c | 0) | 0;
                                i = h + (j << 3) | 0;
                                k = i;
                                l = b[k >> 2] | 0;
                                k = b[k + 4 >> 2] | 0;
                                if ((l | 0) == 0 & (k | 0) == 0) {
                                    B = 14;
                                    break;
                                } else m = m + 1 | 0;
                            }
                        }
                        while (0);
                        if ((B | 0) == 14) {
                            B = 0;
                            if ((n | 0) == 0 & (o | 0) == 0) i = 7;
                            else {
                                b[i >> 2] = n;
                                b[i + 4 >> 2] = o;
                                i = b[f >> 2] | 0;
                                m = g + (i << 3) | 0;
                                b[m >> 2] = n;
                                b[m + 4 >> 2] = o;
                                b[f >> 2] = i + 1;
                                i = 0;
                            }
                        }
                        switch(i & 7){
                            case 7:
                            case 0:
                                break;
                            default:
                                break c;
                        }
                        p = p + 1 | 0;
                        if ((q | 0) <= (p | 0)) {
                            B = 8;
                            break b;
                        }
                    }
                    if (i | 0) {
                        i = -1;
                        B = 20;
                        break a;
                    }
                } else B = 8;
                while (0);
                if ((B | 0) == 8) B = 0;
                s = s + 1 | 0;
                i = b[a >> 2] | 0;
                if ((s | 0) >= (i | 0)) {
                    i = 0;
                    B = 20;
                    break;
                }
            }
            if ((B | 0) == 20) {
                S = C;
                return i | 0;
            }
            return 0;
        }
        function ja(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            k = S;
            S = S + 176 | 0;
            j = k;
            if ((c | 0) < 1) {
                Mc(d, 0, 0);
                S = k;
                return;
            }
            h = a;
            h = cd(b[h >> 2] | 0, b[h + 4 >> 2] | 0, 52) | 0;
            G();
            Mc(d, (c | 0) > 6 ? c : 6, h & 15);
            h = 0;
            do {
                e = a + (h << 3) | 0;
                Wb(b[e >> 2] | 0, b[e + 4 >> 2] | 0, j);
                e = b[j >> 2] | 0;
                if ((e | 0) > 0) {
                    i = 0;
                    do {
                        g = j + 8 + (i << 4) | 0;
                        i = i + 1 | 0;
                        e = j + 8 + (((i | 0) % (e | 0) | 0) << 4) | 0;
                        f = Rc(d, e, g) | 0;
                        if (!f) Qc(d, g, e);
                        else Pc(d, f);
                        e = b[j >> 2] | 0;
                    }while ((i | 0) < (e | 0));
                }
                h = h + 1 | 0;
            }while ((h | 0) != (c | 0));
            S = k;
            return;
        }
        function ka(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 32 | 0;
            e = g;
            f = g + 16 | 0;
            ja(a, c, f);
            b[d >> 2] = 0;
            b[d + 4 >> 2] = 0;
            b[d + 8 >> 2] = 0;
            a = Oc(f) | 0;
            if (!a) {
                kc(d);
                Nc(f);
                S = g;
                return;
            }
            do {
                c = hc(d) | 0;
                do {
                    ic(c, a);
                    h = a + 16 | 0;
                    b[e >> 2] = b[h >> 2];
                    b[e + 4 >> 2] = b[h + 4 >> 2];
                    b[e + 8 >> 2] = b[h + 8 >> 2];
                    b[e + 12 >> 2] = b[h + 12 >> 2];
                    Pc(f, a);
                    a = Sc(f, e) | 0;
                }while ((a | 0) != 0);
                a = Oc(f) | 0;
            }while ((a | 0) != 0);
            kc(d);
            Nc(f);
            S = g;
            return;
        }
        function la(a) {
            a = a | 0;
            return b[7728 + (a * 28 | 0) + 16 >> 2] | 0;
        }
        function ma(a) {
            a = a | 0;
            return (a | 0) == 4 | (a | 0) == 117 | 0;
        }
        function na(a) {
            a = a | 0;
            return b[11152 + ((b[a >> 2] | 0) * 216 | 0) + ((b[a + 4 >> 2] | 0) * 72 | 0) + ((b[a + 8 >> 2] | 0) * 24 | 0) + (b[a + 12 >> 2] << 3) >> 2] | 0;
        }
        function oa(a) {
            a = a | 0;
            return b[11152 + ((b[a >> 2] | 0) * 216 | 0) + ((b[a + 4 >> 2] | 0) * 72 | 0) + ((b[a + 8 >> 2] | 0) * 24 | 0) + (b[a + 12 >> 2] << 3) + 4 >> 2] | 0;
        }
        function pa(a, c) {
            a = a | 0;
            c = c | 0;
            a = 7728 + (a * 28 | 0) | 0;
            b[c >> 2] = b[a >> 2];
            b[c + 4 >> 2] = b[a + 4 >> 2];
            b[c + 8 >> 2] = b[a + 8 >> 2];
            b[c + 12 >> 2] = b[a + 12 >> 2];
            return;
        }
        function qa(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            if (c >>> 0 > 20) {
                c = -1;
                return c | 0;
            }
            do if ((b[11152 + (c * 216 | 0) >> 2] | 0) != (a | 0)) {
                if ((b[11152 + (c * 216 | 0) + 8 >> 2] | 0) != (a | 0)) {
                    if ((b[11152 + (c * 216 | 0) + 16 >> 2] | 0) != (a | 0)) {
                        if ((b[11152 + (c * 216 | 0) + 24 >> 2] | 0) != (a | 0)) {
                            if ((b[11152 + (c * 216 | 0) + 32 >> 2] | 0) != (a | 0)) {
                                if ((b[11152 + (c * 216 | 0) + 40 >> 2] | 0) != (a | 0)) {
                                    if ((b[11152 + (c * 216 | 0) + 48 >> 2] | 0) != (a | 0)) {
                                        if ((b[11152 + (c * 216 | 0) + 56 >> 2] | 0) != (a | 0)) {
                                            if ((b[11152 + (c * 216 | 0) + 64 >> 2] | 0) != (a | 0)) {
                                                if ((b[11152 + (c * 216 | 0) + 72 >> 2] | 0) != (a | 0)) {
                                                    if ((b[11152 + (c * 216 | 0) + 80 >> 2] | 0) != (a | 0)) {
                                                        if ((b[11152 + (c * 216 | 0) + 88 >> 2] | 0) != (a | 0)) {
                                                            if ((b[11152 + (c * 216 | 0) + 96 >> 2] | 0) != (a | 0)) {
                                                                if ((b[11152 + (c * 216 | 0) + 104 >> 2] | 0) != (a | 0)) {
                                                                    if ((b[11152 + (c * 216 | 0) + 112 >> 2] | 0) != (a | 0)) {
                                                                        if ((b[11152 + (c * 216 | 0) + 120 >> 2] | 0) != (a | 0)) {
                                                                            if ((b[11152 + (c * 216 | 0) + 128 >> 2] | 0) != (a | 0)) {
                                                                                if ((b[11152 + (c * 216 | 0) + 136 >> 2] | 0) == (a | 0)) {
                                                                                    a = 2;
                                                                                    d = 1;
                                                                                    e = 2;
                                                                                } else {
                                                                                    if ((b[11152 + (c * 216 | 0) + 144 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 152 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 160 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 168 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 176 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 184 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 192 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 200 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 208 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    } else a = -1;
                                                                                    return a | 0;
                                                                                }
                                                                            } else {
                                                                                a = 2;
                                                                                d = 1;
                                                                                e = 1;
                                                                            }
                                                                        } else {
                                                                            a = 2;
                                                                            d = 1;
                                                                            e = 0;
                                                                        }
                                                                    } else {
                                                                        a = 1;
                                                                        d = 1;
                                                                        e = 2;
                                                                    }
                                                                } else {
                                                                    a = 1;
                                                                    d = 1;
                                                                    e = 1;
                                                                }
                                                            } else {
                                                                a = 1;
                                                                d = 1;
                                                                e = 0;
                                                            }
                                                        } else {
                                                            a = 0;
                                                            d = 1;
                                                            e = 2;
                                                        }
                                                    } else {
                                                        a = 0;
                                                        d = 1;
                                                        e = 1;
                                                    }
                                                } else {
                                                    a = 0;
                                                    d = 1;
                                                    e = 0;
                                                }
                                            } else {
                                                a = 2;
                                                d = 0;
                                                e = 2;
                                            }
                                        } else {
                                            a = 2;
                                            d = 0;
                                            e = 1;
                                        }
                                    } else {
                                        a = 2;
                                        d = 0;
                                        e = 0;
                                    }
                                } else {
                                    a = 1;
                                    d = 0;
                                    e = 2;
                                }
                            } else {
                                a = 1;
                                d = 0;
                                e = 1;
                            }
                        } else {
                            a = 1;
                            d = 0;
                            e = 0;
                        }
                    } else {
                        a = 0;
                        d = 0;
                        e = 2;
                    }
                } else {
                    a = 0;
                    d = 0;
                    e = 1;
                }
            } else {
                a = 0;
                d = 0;
                e = 0;
            }
            while (0);
            c = b[11152 + (c * 216 | 0) + (d * 72 | 0) + (a * 24 | 0) + (e << 3) + 4 >> 2] | 0;
            return c | 0;
        }
        function ra(a, c) {
            a = a | 0;
            c = c | 0;
            if ((b[7728 + (a * 28 | 0) + 20 >> 2] | 0) == (c | 0)) {
                c = 1;
                return c | 0;
            }
            c = (b[7728 + (a * 28 | 0) + 24 >> 2] | 0) == (c | 0);
            return c | 0;
        }
        function sa(a, c) {
            a = a | 0;
            c = c | 0;
            return b[880 + (a * 28 | 0) + (c << 2) >> 2] | 0;
        }
        function ta(a, c) {
            a = a | 0;
            c = c | 0;
            if ((b[880 + (a * 28 | 0) >> 2] | 0) == (c | 0)) {
                c = 0;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 4 >> 2] | 0) == (c | 0)) {
                c = 1;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 8 >> 2] | 0) == (c | 0)) {
                c = 2;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 12 >> 2] | 0) == (c | 0)) {
                c = 3;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 16 >> 2] | 0) == (c | 0)) {
                c = 4;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 20 >> 2] | 0) == (c | 0)) {
                c = 5;
                return c | 0;
            } else return ((b[880 + (a * 28 | 0) + 24 >> 2] | 0) == (c | 0) ? 6 : 7) | 0;
            return 0;
        }
        function ua() {
            return 122;
        }
        function va(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            c = 0;
            do {
                dd(c | 0, 0, 45);
                e = G() | 134225919;
                d = a + (c << 3) | 0;
                b[d >> 2] = -1;
                b[d + 4 >> 2] = e;
                c = c + 1 | 0;
            }while ((c | 0) != 122);
            return;
        }
        function wa(a) {
            a = a | 0;
            return +e[a + 16 >> 3] < +e[a + 24 >> 3] | 0;
        }
        function xa(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            c = +e[b >> 3];
            if (!(c >= +e[a + 8 >> 3])) {
                b = 0;
                return b | 0;
            }
            if (!(c <= +e[a >> 3])) {
                b = 0;
                return b | 0;
            }
            d = +e[a + 16 >> 3];
            c = +e[a + 24 >> 3];
            f = +e[b + 8 >> 3];
            b = f >= c;
            a = f <= d & 1;
            if (d < c) {
                if (b) a = 1;
            } else if (!b) a = 0;
            b = (a | 0) != 0;
            return b | 0;
        }
        function ya(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0.0, l = 0.0;
            i = S;
            S = S + 288 | 0;
            d = i + 264 | 0;
            f = i + 96 | 0;
            g = i;
            h = g;
            j = h + 96 | 0;
            do {
                b[h >> 2] = 0;
                h = h + 4 | 0;
            }while ((h | 0) < (j | 0));
            _b(c, g);
            h = g;
            j = b[h >> 2] | 0;
            h = b[h + 4 >> 2] | 0;
            Vb(j, h, d);
            Wb(j, h, f);
            k = +jb(d, f + 8 | 0);
            e[d >> 3] = +e[a >> 3];
            h = d + 8 | 0;
            e[h >> 3] = +e[a + 16 >> 3];
            e[f >> 3] = +e[a + 8 >> 3];
            j = f + 8 | 0;
            e[j >> 3] = +e[a + 24 >> 3];
            l = +jb(d, f);
            j = ~~+A(+(l * l / +ed(+ +q(+((+e[h >> 3] - +e[j >> 3]) / (+e[d >> 3] - +e[f >> 3]))), 3.0) / (k * (k * 2.59807621135) * .8)));
            S = i;
            return ((j | 0) == 0 ? 1 : j) | 0;
        }
        function za(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0.0;
            i = S;
            S = S + 288 | 0;
            e = i + 264 | 0;
            f = i + 96 | 0;
            g = i;
            h = g;
            j = h + 96 | 0;
            do {
                b[h >> 2] = 0;
                h = h + 4 | 0;
            }while ((h | 0) < (j | 0));
            _b(d, g);
            j = g;
            h = b[j >> 2] | 0;
            j = b[j + 4 >> 2] | 0;
            Vb(h, j, e);
            Wb(h, j, f);
            k = +jb(e, f + 8 | 0);
            j = ~~+A(+(+jb(a, c) / (k * 2.0)));
            S = i;
            return ((j | 0) == 0 ? 1 : j) | 0;
        }
        function Aa(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            b[a >> 2] = c;
            b[a + 4 >> 2] = d;
            b[a + 8 >> 2] = e;
            return;
        }
        function Ba(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0, n = 0, o = 0.0;
            n = c + 8 | 0;
            b[n >> 2] = 0;
            k = +e[a >> 3];
            i = +q(+k);
            l = +e[a + 8 >> 3];
            j = +q(+l) / .8660254037844386;
            i = i + j * .5;
            d = ~~i;
            a = ~~j;
            i = i - +(d | 0);
            j = j - +(a | 0);
            do if (i < .5) {
                if (i < .3333333333333333) {
                    b[c >> 2] = d;
                    if (j < (i + 1.0) * .5) {
                        b[c + 4 >> 2] = a;
                        break;
                    } else {
                        a = a + 1 | 0;
                        b[c + 4 >> 2] = a;
                        break;
                    }
                } else {
                    o = 1.0 - i;
                    a = (!(j < o) & 1) + a | 0;
                    b[c + 4 >> 2] = a;
                    if (o <= j & j < i * 2.0) {
                        d = d + 1 | 0;
                        b[c >> 2] = d;
                        break;
                    } else {
                        b[c >> 2] = d;
                        break;
                    }
                }
            } else {
                if (!(i < .6666666666666666)) {
                    d = d + 1 | 0;
                    b[c >> 2] = d;
                    if (j < i * .5) {
                        b[c + 4 >> 2] = a;
                        break;
                    } else {
                        a = a + 1 | 0;
                        b[c + 4 >> 2] = a;
                        break;
                    }
                }
                if (j < 1.0 - i) {
                    b[c + 4 >> 2] = a;
                    if (i * 2.0 + -1 < j) {
                        b[c >> 2] = d;
                        break;
                    }
                } else {
                    a = a + 1 | 0;
                    b[c + 4 >> 2] = a;
                }
                d = d + 1 | 0;
                b[c >> 2] = d;
            }
            while (0);
            do if (k < 0.0) {
                if (!(a & 1)) {
                    m = (a | 0) / 2 | 0;
                    m = _c(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, m | 0, ((m | 0) < 0) << 31 >> 31 | 0) | 0;
                    d = ~~(+(d | 0) - (+(m >>> 0) + 4294967296.0 * +(G() | 0)) * 2.0);
                    b[c >> 2] = d;
                    break;
                } else {
                    m = (a + 1 | 0) / 2 | 0;
                    m = _c(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, m | 0, ((m | 0) < 0) << 31 >> 31 | 0) | 0;
                    d = ~~(+(d | 0) - ((+(m >>> 0) + 4294967296.0 * +(G() | 0)) * 2.0 + 1.0));
                    b[c >> 2] = d;
                    break;
                }
            }
            while (0);
            m = c + 4 | 0;
            if (l < 0.0) {
                d = d - ((a << 1 | 1) / 2 | 0) | 0;
                b[c >> 2] = d;
                a = 0 - a | 0;
                b[m >> 2] = a;
            }
            f = a - d | 0;
            if ((d | 0) < 0) {
                g = 0 - d | 0;
                b[m >> 2] = f;
                b[n >> 2] = g;
                b[c >> 2] = 0;
                a = f;
                d = 0;
            } else g = 0;
            if ((a | 0) < 0) {
                d = d - a | 0;
                b[c >> 2] = d;
                g = g - a | 0;
                b[n >> 2] = g;
                b[m >> 2] = 0;
                a = 0;
            }
            h = d - g | 0;
            f = a - g | 0;
            if ((g | 0) < 0) {
                b[c >> 2] = h;
                b[m >> 2] = f;
                b[n >> 2] = 0;
                a = f;
                d = h;
                g = 0;
            }
            f = (a | 0) < (d | 0) ? a : d;
            f = (g | 0) < (f | 0) ? g : f;
            if ((f | 0) <= 0) return;
            b[c >> 2] = d - f;
            b[m >> 2] = a - f;
            b[n >> 2] = g - f;
            return;
        }
        function Ca(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            if ((c | 0) < 0) {
                d = d - c | 0;
                b[h >> 2] = d;
                g = a + 8 | 0;
                b[g >> 2] = (b[g >> 2] | 0) - c;
                b[a >> 2] = 0;
                c = 0;
            }
            if ((d | 0) < 0) {
                c = c - d | 0;
                b[a >> 2] = c;
                g = a + 8 | 0;
                f = (b[g >> 2] | 0) - d | 0;
                b[g >> 2] = f;
                b[h >> 2] = 0;
                d = 0;
            } else {
                f = a + 8 | 0;
                g = f;
                f = b[f >> 2] | 0;
            }
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[a >> 2] = c;
                d = d - f | 0;
                b[h >> 2] = d;
                b[g >> 2] = 0;
                f = 0;
            }
            e = (d | 0) < (c | 0) ? d : c;
            e = (f | 0) < (e | 0) ? f : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = c - e;
            b[h >> 2] = d - e;
            b[g >> 2] = f - e;
            return;
        }
        function Da(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0;
            f = b[a + 8 >> 2] | 0;
            d = +((b[a + 4 >> 2] | 0) - f | 0);
            e[c >> 3] = +((b[a >> 2] | 0) - f | 0) - d * .5;
            e[c + 8 >> 3] = d * .8660254037844386;
            return;
        }
        function Ea(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            b[d >> 2] = (b[c >> 2] | 0) + (b[a >> 2] | 0);
            b[d + 4 >> 2] = (b[c + 4 >> 2] | 0) + (b[a + 4 >> 2] | 0);
            b[d + 8 >> 2] = (b[c + 8 >> 2] | 0) + (b[a + 8 >> 2] | 0);
            return;
        }
        function Fa(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            b[d >> 2] = (b[a >> 2] | 0) - (b[c >> 2] | 0);
            b[d + 4 >> 2] = (b[a + 4 >> 2] | 0) - (b[c + 4 >> 2] | 0);
            b[d + 8 >> 2] = (b[a + 8 >> 2] | 0) - (b[c + 8 >> 2] | 0);
            return;
        }
        function Ga(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = B(b[a >> 2] | 0, c) | 0;
            b[a >> 2] = d;
            d = a + 4 | 0;
            e = B(b[d >> 2] | 0, c) | 0;
            b[d >> 2] = e;
            a = a + 8 | 0;
            c = B(b[a >> 2] | 0, c) | 0;
            b[a >> 2] = c;
            return;
        }
        function Ha(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = b[a >> 2] | 0;
            i = (h | 0) < 0;
            e = (b[a + 4 >> 2] | 0) - (i ? h : 0) | 0;
            g = (e | 0) < 0;
            f = (g ? 0 - e | 0 : 0) + ((b[a + 8 >> 2] | 0) - (i ? h : 0)) | 0;
            d = (f | 0) < 0;
            a = d ? 0 : f;
            c = (g ? 0 : e) - (d ? f : 0) | 0;
            f = (i ? 0 : h) - (g ? e : 0) - (d ? f : 0) | 0;
            d = (c | 0) < (f | 0) ? c : f;
            d = (a | 0) < (d | 0) ? a : d;
            e = (d | 0) > 0;
            a = a - (e ? d : 0) | 0;
            c = c - (e ? d : 0) | 0;
            a: do switch(f - (e ? d : 0) | 0){
                case 0:
                    switch(c | 0){
                        case 0:
                            i = (a | 0) == 0 ? 0 : (a | 0) == 1 ? 1 : 7;
                            return i | 0;
                        case 1:
                            i = (a | 0) == 0 ? 2 : (a | 0) == 1 ? 3 : 7;
                            return i | 0;
                        default:
                            break a;
                    }
                case 1:
                    switch(c | 0){
                        case 0:
                            i = (a | 0) == 0 ? 4 : (a | 0) == 1 ? 5 : 7;
                            return i | 0;
                        case 1:
                            if (!a) a = 6;
                            else break a;
                            return a | 0;
                        default:
                            break a;
                    }
                default:
            }
            while (0);
            i = 7;
            return i | 0;
        }
        function Ia(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = a + 8 | 0;
            d = b[h >> 2] | 0;
            c = (b[a >> 2] | 0) - d | 0;
            i = a + 4 | 0;
            d = (b[i >> 2] | 0) - d | 0;
            e = Vc(+((c * 3 | 0) - d | 0) / 7.0) | 0;
            b[a >> 2] = e;
            c = Vc(+((d << 1) + c | 0) / 7.0) | 0;
            b[i >> 2] = c;
            b[h >> 2] = 0;
            d = c - e | 0;
            if ((e | 0) < 0) {
                g = 0 - e | 0;
                b[i >> 2] = d;
                b[h >> 2] = g;
                b[a >> 2] = 0;
                c = d;
                e = 0;
                d = g;
            } else d = 0;
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = f - e;
            b[i >> 2] = c - e;
            b[h >> 2] = d - e;
            return;
        }
        function Ja(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = a + 8 | 0;
            d = b[h >> 2] | 0;
            c = (b[a >> 2] | 0) - d | 0;
            i = a + 4 | 0;
            d = (b[i >> 2] | 0) - d | 0;
            e = Vc(+((c << 1) + d | 0) / 7.0) | 0;
            b[a >> 2] = e;
            c = Vc(+((d * 3 | 0) - c | 0) / 7.0) | 0;
            b[i >> 2] = c;
            b[h >> 2] = 0;
            d = c - e | 0;
            if ((e | 0) < 0) {
                g = 0 - e | 0;
                b[i >> 2] = d;
                b[h >> 2] = g;
                b[a >> 2] = 0;
                c = d;
                e = 0;
                d = g;
            } else d = 0;
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = f - e;
            b[i >> 2] = c - e;
            b[h >> 2] = d - e;
            return;
        }
        function Ka(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            i = a + 8 | 0;
            e = b[i >> 2] | 0;
            f = d + (c * 3 | 0) | 0;
            b[a >> 2] = f;
            d = e + (d * 3 | 0) | 0;
            b[h >> 2] = d;
            c = (e * 3 | 0) + c | 0;
            b[i >> 2] = c;
            e = d - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = e;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                d = e;
                e = 0;
            } else e = f;
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function La(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = (c * 3 | 0) + f | 0;
            f = d + (f * 3 | 0) | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = (d * 3 | 0) + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                f = 0;
            } else d = e;
            if ((d | 0) < 0) {
                f = f - d | 0;
                b[a >> 2] = f;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = f - c | 0;
            e = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = e;
                b[i >> 2] = 0;
                f = g;
                c = 0;
            } else e = d;
            d = (e | 0) < (f | 0) ? e : f;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = f - d;
            b[h >> 2] = e - d;
            b[i >> 2] = c - d;
            return;
        }
        function Ma(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            if ((c + -1 | 0) >>> 0 >= 6) return;
            f = (b[15472 + (c * 12 | 0) >> 2] | 0) + (b[a >> 2] | 0) | 0;
            b[a >> 2] = f;
            i = a + 4 | 0;
            e = (b[15472 + (c * 12 | 0) + 4 >> 2] | 0) + (b[i >> 2] | 0) | 0;
            b[i >> 2] = e;
            h = a + 8 | 0;
            c = (b[15472 + (c * 12 | 0) + 8 >> 2] | 0) + (b[h >> 2] | 0) | 0;
            b[h >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[i >> 2] = d;
                b[h >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[h >> 2] = c;
                b[i >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[i >> 2] = f - d;
            b[h >> 2] = c - d;
            return;
        }
        function Na(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = c + f | 0;
            f = d + f | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = d + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Oa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            e = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            f = e + c | 0;
            b[a >> 2] = f;
            e = d + e | 0;
            b[h >> 2] = e;
            c = d + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Pa(a) {
            a = a | 0;
            switch(a | 0){
                case 1:
                    a = 5;
                    break;
                case 5:
                    a = 4;
                    break;
                case 4:
                    a = 6;
                    break;
                case 6:
                    a = 2;
                    break;
                case 2:
                    a = 3;
                    break;
                case 3:
                    a = 1;
                    break;
                default:
            }
            return a | 0;
        }
        function Qa(a) {
            a = a | 0;
            switch(a | 0){
                case 1:
                    a = 3;
                    break;
                case 3:
                    a = 2;
                    break;
                case 2:
                    a = 6;
                    break;
                case 6:
                    a = 4;
                    break;
                case 4:
                    a = 5;
                    break;
                case 5:
                    a = 1;
                    break;
                default:
            }
            return a | 0;
        }
        function Ra(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            i = a + 8 | 0;
            e = b[i >> 2] | 0;
            f = d + (c << 1) | 0;
            b[a >> 2] = f;
            d = e + (d << 1) | 0;
            b[h >> 2] = d;
            c = (e << 1) + c | 0;
            b[i >> 2] = c;
            e = d - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = e;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                d = e;
                e = 0;
            } else e = f;
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Sa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = (c << 1) + f | 0;
            f = d + (f << 1) | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = (d << 1) + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                f = 0;
            } else d = e;
            if ((d | 0) < 0) {
                f = f - d | 0;
                b[a >> 2] = f;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = f - c | 0;
            e = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = e;
                b[i >> 2] = 0;
                f = g;
                c = 0;
            } else e = d;
            d = (e | 0) < (f | 0) ? e : f;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = f - d;
            b[h >> 2] = e - d;
            b[i >> 2] = c - d;
            return;
        }
        function Ta(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = (b[a >> 2] | 0) - (b[c >> 2] | 0) | 0;
            i = (h | 0) < 0;
            e = (b[a + 4 >> 2] | 0) - (b[c + 4 >> 2] | 0) - (i ? h : 0) | 0;
            g = (e | 0) < 0;
            f = (i ? 0 - h | 0 : 0) + (b[a + 8 >> 2] | 0) - (b[c + 8 >> 2] | 0) + (g ? 0 - e | 0 : 0) | 0;
            a = (f | 0) < 0;
            c = a ? 0 : f;
            d = (g ? 0 : e) - (a ? f : 0) | 0;
            f = (i ? 0 : h) - (g ? e : 0) - (a ? f : 0) | 0;
            a = (d | 0) < (f | 0) ? d : f;
            a = (c | 0) < (a | 0) ? c : a;
            e = (a | 0) > 0;
            c = c - (e ? a : 0) | 0;
            d = d - (e ? a : 0) | 0;
            a = f - (e ? a : 0) | 0;
            a = (a | 0) > -1 ? a : 0 - a | 0;
            d = (d | 0) > -1 ? d : 0 - d | 0;
            c = (c | 0) > -1 ? c : 0 - c | 0;
            c = (d | 0) > (c | 0) ? d : c;
            return ((a | 0) > (c | 0) ? a : c) | 0;
        }
        function Ua(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            d = b[a + 8 >> 2] | 0;
            b[c >> 2] = (b[a >> 2] | 0) - d;
            b[c + 4 >> 2] = (b[a + 4 >> 2] | 0) - d;
            return;
        }
        function Va(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            e = b[a >> 2] | 0;
            b[c >> 2] = e;
            a = b[a + 4 >> 2] | 0;
            h = c + 4 | 0;
            b[h >> 2] = a;
            i = c + 8 | 0;
            b[i >> 2] = 0;
            d = a - e | 0;
            if ((e | 0) < 0) {
                a = 0 - e | 0;
                b[h >> 2] = d;
                b[i >> 2] = a;
                b[c >> 2] = 0;
                e = 0;
            } else {
                d = a;
                a = 0;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[c >> 2] = e;
                a = a - d | 0;
                b[i >> 2] = a;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - a | 0;
            f = d - a | 0;
            if ((a | 0) < 0) {
                b[c >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                d = f;
                f = g;
                a = 0;
            } else f = e;
            e = (d | 0) < (f | 0) ? d : f;
            e = (a | 0) < (e | 0) ? a : e;
            if ((e | 0) <= 0) return;
            b[c >> 2] = f - e;
            b[h >> 2] = d - e;
            b[i >> 2] = a - e;
            return;
        }
        function Wa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0;
            c = a + 8 | 0;
            f = b[c >> 2] | 0;
            d = f - (b[a >> 2] | 0) | 0;
            b[a >> 2] = d;
            e = a + 4 | 0;
            a = (b[e >> 2] | 0) - f | 0;
            b[e >> 2] = a;
            b[c >> 2] = 0 - (a + d);
            return;
        }
        function Xa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            d = b[a >> 2] | 0;
            c = 0 - d | 0;
            b[a >> 2] = c;
            h = a + 8 | 0;
            b[h >> 2] = 0;
            i = a + 4 | 0;
            e = b[i >> 2] | 0;
            f = e + d | 0;
            if ((d | 0) > 0) {
                b[i >> 2] = f;
                b[h >> 2] = d;
                b[a >> 2] = 0;
                c = 0;
                e = f;
            } else d = 0;
            if ((e | 0) < 0) {
                g = c - e | 0;
                b[a >> 2] = g;
                d = d - e | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                f = g - d | 0;
                c = 0 - d | 0;
                if ((d | 0) < 0) {
                    b[a >> 2] = f;
                    b[i >> 2] = c;
                    b[h >> 2] = 0;
                    e = c;
                    d = 0;
                } else {
                    e = 0;
                    f = g;
                }
            } else f = c;
            c = (e | 0) < (f | 0) ? e : f;
            c = (d | 0) < (c | 0) ? d : c;
            if ((c | 0) <= 0) return;
            b[a >> 2] = f - c;
            b[i >> 2] = e - c;
            b[h >> 2] = d - c;
            return;
        }
        function Ya(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = S;
            S = S + 16 | 0;
            e = d;
            Za(a, b, c, e);
            Ba(e, c + 4 | 0);
            S = d;
            return;
        }
        function Za(a, c, d, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0.0, h = 0, i = 0.0, j = 0.0, k = 0;
            k = S;
            S = S + 32 | 0;
            h = k;
            Jc(a, h);
            b[d >> 2] = 0;
            g = +Ic(15888, h);
            i = +Ic(15912, h);
            if (i < g) {
                b[d >> 2] = 1;
                g = i;
            }
            i = +Ic(15936, h);
            if (i < g) {
                b[d >> 2] = 2;
                g = i;
            }
            i = +Ic(15960, h);
            if (i < g) {
                b[d >> 2] = 3;
                g = i;
            }
            i = +Ic(15984, h);
            if (i < g) {
                b[d >> 2] = 4;
                g = i;
            }
            i = +Ic(16008, h);
            if (i < g) {
                b[d >> 2] = 5;
                g = i;
            }
            i = +Ic(16032, h);
            if (i < g) {
                b[d >> 2] = 6;
                g = i;
            }
            i = +Ic(16056, h);
            if (i < g) {
                b[d >> 2] = 7;
                g = i;
            }
            i = +Ic(16080, h);
            if (i < g) {
                b[d >> 2] = 8;
                g = i;
            }
            i = +Ic(16104, h);
            if (i < g) {
                b[d >> 2] = 9;
                g = i;
            }
            i = +Ic(16128, h);
            if (i < g) {
                b[d >> 2] = 10;
                g = i;
            }
            i = +Ic(16152, h);
            if (i < g) {
                b[d >> 2] = 11;
                g = i;
            }
            i = +Ic(16176, h);
            if (i < g) {
                b[d >> 2] = 12;
                g = i;
            }
            i = +Ic(16200, h);
            if (i < g) {
                b[d >> 2] = 13;
                g = i;
            }
            i = +Ic(16224, h);
            if (i < g) {
                b[d >> 2] = 14;
                g = i;
            }
            i = +Ic(16248, h);
            if (i < g) {
                b[d >> 2] = 15;
                g = i;
            }
            i = +Ic(16272, h);
            if (i < g) {
                b[d >> 2] = 16;
                g = i;
            }
            i = +Ic(16296, h);
            if (i < g) {
                b[d >> 2] = 17;
                g = i;
            }
            i = +Ic(16320, h);
            if (i < g) {
                b[d >> 2] = 18;
                g = i;
            }
            i = +Ic(16344, h);
            if (i < g) {
                b[d >> 2] = 19;
                g = i;
            }
            i = +w(+(1.0 - g * .5));
            if (i < 1.0e-16) {
                b[f >> 2] = 0;
                b[f + 4 >> 2] = 0;
                b[f + 8 >> 2] = 0;
                b[f + 12 >> 2] = 0;
                S = k;
                return;
            }
            d = b[d >> 2] | 0;
            g = +e[16368 + (d * 24 | 0) >> 3];
            g = +gb(g - +gb(+lb(15568 + (d << 4) | 0, a)));
            if (!(Rb(c) | 0)) j = g;
            else j = +gb(g + -0.3334731722518321);
            g = +v(+i) / .381966011250105;
            if ((c | 0) > 0) {
                h = 0;
                do {
                    g = g * 2.6457513110645907;
                    h = h + 1 | 0;
                }while ((h | 0) != (c | 0));
            }
            i = +t(+j) * g;
            e[f >> 3] = i;
            j = +u(+j) * g;
            e[f + 8 >> 3] = j;
            S = k;
            return;
        }
        function _a(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0.0, i = 0.0;
            h = +Fc(a);
            if (h < 1.0e-16) {
                c = 15568 + (c << 4) | 0;
                b[g >> 2] = b[c >> 2];
                b[g + 4 >> 2] = b[c + 4 >> 2];
                b[g + 8 >> 2] = b[c + 8 >> 2];
                b[g + 12 >> 2] = b[c + 12 >> 2];
                return;
            }
            i = +z(+ +e[a + 8 >> 3], + +e[a >> 3]);
            if ((d | 0) > 0) {
                a = 0;
                do {
                    h = h / 2.6457513110645907;
                    a = a + 1 | 0;
                }while ((a | 0) != (d | 0));
            }
            if (!f) {
                h = +y(+(h * .381966011250105));
                if (Rb(d) | 0) i = +gb(i + .3334731722518321);
            } else {
                h = h / 3.0;
                d = (Rb(d) | 0) == 0;
                h = +y(+((d ? h : h / 2.6457513110645907) * .381966011250105));
            }
            mb(15568 + (c << 4) | 0, +gb(+e[16368 + (c * 24 | 0) >> 3] - i), h, g);
            return;
        }
        function $a(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = S;
            S = S + 16 | 0;
            f = e;
            Da(a + 4 | 0, f);
            _a(f, b[a >> 2] | 0, c, 0, d);
            S = e;
            return;
        }
        function ab(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, I = 0.0, J = 0.0;
            G = S;
            S = S + 272 | 0;
            h = G + 256 | 0;
            u = G + 240 | 0;
            D = G;
            E = G + 224 | 0;
            F = G + 208 | 0;
            v = G + 176 | 0;
            w = G + 160 | 0;
            x = G + 192 | 0;
            y = G + 144 | 0;
            z = G + 128 | 0;
            A = G + 112 | 0;
            B = G + 96 | 0;
            C = G + 80 | 0;
            b[h >> 2] = c;
            b[u >> 2] = b[a >> 2];
            b[u + 4 >> 2] = b[a + 4 >> 2];
            b[u + 8 >> 2] = b[a + 8 >> 2];
            b[u + 12 >> 2] = b[a + 12 >> 2];
            bb(u, h, D);
            b[g >> 2] = 0;
            u = f + d + ((f | 0) == 5 & 1) | 0;
            if ((u | 0) <= (d | 0)) {
                S = G;
                return;
            }
            k = b[h >> 2] | 0;
            l = E + 4 | 0;
            m = v + 4 | 0;
            n = d + 5 | 0;
            o = 16848 + (k << 2) | 0;
            p = 16928 + (k << 2) | 0;
            q = z + 8 | 0;
            r = A + 8 | 0;
            s = B + 8 | 0;
            t = F + 4 | 0;
            j = d;
            a: while(true){
                i = D + (((j | 0) % 5 | 0) << 4) | 0;
                b[F >> 2] = b[i >> 2];
                b[F + 4 >> 2] = b[i + 4 >> 2];
                b[F + 8 >> 2] = b[i + 8 >> 2];
                b[F + 12 >> 2] = b[i + 12 >> 2];
                do ;
                while ((cb(F, k, 0, 1) | 0) == 2);
                if ((j | 0) > (d | 0) & (Rb(c) | 0) != 0) {
                    b[v >> 2] = b[F >> 2];
                    b[v + 4 >> 2] = b[F + 4 >> 2];
                    b[v + 8 >> 2] = b[F + 8 >> 2];
                    b[v + 12 >> 2] = b[F + 12 >> 2];
                    Da(l, w);
                    f = b[v >> 2] | 0;
                    h = b[17008 + (f * 80 | 0) + (b[E >> 2] << 2) >> 2] | 0;
                    b[v >> 2] = b[18608 + (f * 80 | 0) + (h * 20 | 0) >> 2];
                    i = b[18608 + (f * 80 | 0) + (h * 20 | 0) + 16 >> 2] | 0;
                    if ((i | 0) > 0) {
                        a = 0;
                        do {
                            Na(m);
                            a = a + 1 | 0;
                        }while ((a | 0) < (i | 0));
                    }
                    i = 18608 + (f * 80 | 0) + (h * 20 | 0) + 4 | 0;
                    b[x >> 2] = b[i >> 2];
                    b[x + 4 >> 2] = b[i + 4 >> 2];
                    b[x + 8 >> 2] = b[i + 8 >> 2];
                    Ga(x, (b[o >> 2] | 0) * 3 | 0);
                    Ea(m, x, m);
                    Ca(m);
                    Da(m, y);
                    I = +(b[p >> 2] | 0);
                    e[z >> 3] = I * 3.0;
                    e[q >> 3] = 0.0;
                    J = I * -1.5;
                    e[A >> 3] = J;
                    e[r >> 3] = I * 2.598076211353316;
                    e[B >> 3] = J;
                    e[s >> 3] = I * -2.598076211353316;
                    switch(b[17008 + ((b[v >> 2] | 0) * 80 | 0) + (b[F >> 2] << 2) >> 2] | 0){
                        case 1:
                            a = A;
                            f = z;
                            break;
                        case 3:
                            a = B;
                            f = A;
                            break;
                        case 2:
                            a = z;
                            f = B;
                            break;
                        default:
                            a = 12;
                            break a;
                    }
                    Gc(w, y, f, a, C);
                    _a(C, b[v >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                if ((j | 0) < (n | 0)) {
                    Da(t, v);
                    _a(v, b[F >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                b[E >> 2] = b[F >> 2];
                b[E + 4 >> 2] = b[F + 4 >> 2];
                b[E + 8 >> 2] = b[F + 8 >> 2];
                b[E + 12 >> 2] = b[F + 12 >> 2];
                j = j + 1 | 0;
                if ((j | 0) >= (u | 0)) {
                    a = 3;
                    break;
                }
            }
            if ((a | 0) == 3) {
                S = G;
                return;
            } else if ((a | 0) == 12) H(22474, 22521, 581, 22531);
        }
        function bb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = S;
            S = S + 128 | 0;
            e = j + 64 | 0;
            f = j;
            g = e;
            h = 20208;
            i = g + 60 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            g = f;
            h = 20272;
            i = g + 60 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            i = (Rb(b[c >> 2] | 0) | 0) == 0;
            e = i ? e : f;
            f = a + 4 | 0;
            Ra(f);
            Sa(f);
            if (Rb(b[c >> 2] | 0) | 0) {
                La(f);
                b[c >> 2] = (b[c >> 2] | 0) + 1;
            }
            b[d >> 2] = b[a >> 2];
            c = d + 4 | 0;
            Ea(f, e, c);
            Ca(c);
            b[d + 16 >> 2] = b[a >> 2];
            c = d + 20 | 0;
            Ea(f, e + 12 | 0, c);
            Ca(c);
            b[d + 32 >> 2] = b[a >> 2];
            c = d + 36 | 0;
            Ea(f, e + 24 | 0, c);
            Ca(c);
            b[d + 48 >> 2] = b[a >> 2];
            c = d + 52 | 0;
            Ea(f, e + 36 | 0, c);
            Ca(c);
            b[d + 64 >> 2] = b[a >> 2];
            d = d + 68 | 0;
            Ea(f, e + 48 | 0, d);
            Ca(d);
            S = j;
            return;
        }
        function cb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            p = S;
            S = S + 32 | 0;
            n = p + 12 | 0;
            i = p;
            o = a + 4 | 0;
            m = b[16928 + (c << 2) >> 2] | 0;
            l = (e | 0) != 0;
            m = l ? m * 3 | 0 : m;
            f = b[o >> 2] | 0;
            k = a + 8 | 0;
            h = b[k >> 2] | 0;
            if (l) {
                g = a + 12 | 0;
                e = b[g >> 2] | 0;
                f = h + f + e | 0;
                if ((f | 0) == (m | 0)) {
                    o = 1;
                    S = p;
                    return o | 0;
                } else j = g;
            } else {
                j = a + 12 | 0;
                e = b[j >> 2] | 0;
                f = h + f + e | 0;
            }
            if ((f | 0) <= (m | 0)) {
                o = 0;
                S = p;
                return o | 0;
            }
            do if ((e | 0) > 0) {
                e = b[a >> 2] | 0;
                if ((h | 0) > 0) {
                    g = 18608 + (e * 80 | 0) + 60 | 0;
                    e = a;
                    break;
                }
                e = 18608 + (e * 80 | 0) + 40 | 0;
                if (!d) {
                    g = e;
                    e = a;
                } else {
                    Aa(n, m, 0, 0);
                    Fa(o, n, i);
                    Oa(i);
                    Ea(i, n, o);
                    g = e;
                    e = a;
                }
            } else {
                g = 18608 + ((b[a >> 2] | 0) * 80 | 0) + 20 | 0;
                e = a;
            }
            while (0);
            b[e >> 2] = b[g >> 2];
            f = g + 16 | 0;
            if ((b[f >> 2] | 0) > 0) {
                e = 0;
                do {
                    Na(o);
                    e = e + 1 | 0;
                }while ((e | 0) < (b[f >> 2] | 0));
            }
            a = g + 4 | 0;
            b[n >> 2] = b[a >> 2];
            b[n + 4 >> 2] = b[a + 4 >> 2];
            b[n + 8 >> 2] = b[a + 8 >> 2];
            c = b[16848 + (c << 2) >> 2] | 0;
            Ga(n, l ? c * 3 | 0 : c);
            Ea(o, n, o);
            Ca(o);
            if (l) e = ((b[k >> 2] | 0) + (b[o >> 2] | 0) + (b[j >> 2] | 0) | 0) == (m | 0) ? 1 : 2;
            else e = 2;
            o = e;
            S = p;
            return o | 0;
        }
        function db(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            do c = cb(a, b, 0, 1) | 0;
            while ((c | 0) == 2);
            return c | 0;
        }
        function eb(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0.0, D = 0.0;
            B = S;
            S = S + 240 | 0;
            h = B + 224 | 0;
            x = B + 208 | 0;
            y = B;
            z = B + 192 | 0;
            A = B + 176 | 0;
            s = B + 160 | 0;
            t = B + 144 | 0;
            u = B + 128 | 0;
            v = B + 112 | 0;
            w = B + 96 | 0;
            b[h >> 2] = c;
            b[x >> 2] = b[a >> 2];
            b[x + 4 >> 2] = b[a + 4 >> 2];
            b[x + 8 >> 2] = b[a + 8 >> 2];
            b[x + 12 >> 2] = b[a + 12 >> 2];
            fb(x, h, y);
            b[g >> 2] = 0;
            r = f + d + ((f | 0) == 6 & 1) | 0;
            if ((r | 0) <= (d | 0)) {
                S = B;
                return;
            }
            k = b[h >> 2] | 0;
            l = d + 6 | 0;
            m = 16928 + (k << 2) | 0;
            n = t + 8 | 0;
            o = u + 8 | 0;
            p = v + 8 | 0;
            q = z + 4 | 0;
            i = 0;
            j = d;
            f = -1;
            a: while(true){
                h = (j | 0) % 6 | 0;
                a = y + (h << 4) | 0;
                b[z >> 2] = b[a >> 2];
                b[z + 4 >> 2] = b[a + 4 >> 2];
                b[z + 8 >> 2] = b[a + 8 >> 2];
                b[z + 12 >> 2] = b[a + 12 >> 2];
                a = i;
                i = cb(z, k, 0, 1) | 0;
                if ((j | 0) > (d | 0) & (Rb(c) | 0) != 0 ? (a | 0) != 1 ? (b[z >> 2] | 0) != (f | 0) : 0 : 0) {
                    Da(y + (((h + 5 | 0) % 6 | 0) << 4) + 4 | 0, A);
                    Da(y + (h << 4) + 4 | 0, s);
                    C = +(b[m >> 2] | 0);
                    e[t >> 3] = C * 3.0;
                    e[n >> 3] = 0.0;
                    D = C * -1.5;
                    e[u >> 3] = D;
                    e[o >> 3] = C * 2.598076211353316;
                    e[v >> 3] = D;
                    e[p >> 3] = C * -2.598076211353316;
                    h = b[x >> 2] | 0;
                    switch(b[17008 + (h * 80 | 0) + (((f | 0) == (h | 0) ? b[z >> 2] | 0 : f) << 2) >> 2] | 0){
                        case 1:
                            a = u;
                            f = t;
                            break;
                        case 3:
                            a = v;
                            f = u;
                            break;
                        case 2:
                            a = t;
                            f = v;
                            break;
                        default:
                            a = 8;
                            break a;
                    }
                    Gc(A, s, f, a, w);
                    if (!(Hc(A, w) | 0) ? !(Hc(s, w) | 0) : 0) {
                        _a(w, b[x >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                        b[g >> 2] = (b[g >> 2] | 0) + 1;
                    }
                }
                if ((j | 0) < (l | 0)) {
                    Da(q, A);
                    _a(A, b[z >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                j = j + 1 | 0;
                if ((j | 0) >= (r | 0)) {
                    a = 3;
                    break;
                } else f = b[z >> 2] | 0;
            }
            if ((a | 0) == 3) {
                S = B;
                return;
            } else if ((a | 0) == 8) H(22557, 22521, 746, 22602);
        }
        function fb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = S;
            S = S + 160 | 0;
            e = j + 80 | 0;
            f = j;
            g = e;
            h = 20336;
            i = g + 72 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            g = f;
            h = 20416;
            i = g + 72 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            i = (Rb(b[c >> 2] | 0) | 0) == 0;
            e = i ? e : f;
            f = a + 4 | 0;
            Ra(f);
            Sa(f);
            if (Rb(b[c >> 2] | 0) | 0) {
                La(f);
                b[c >> 2] = (b[c >> 2] | 0) + 1;
            }
            b[d >> 2] = b[a >> 2];
            c = d + 4 | 0;
            Ea(f, e, c);
            Ca(c);
            b[d + 16 >> 2] = b[a >> 2];
            c = d + 20 | 0;
            Ea(f, e + 12 | 0, c);
            Ca(c);
            b[d + 32 >> 2] = b[a >> 2];
            c = d + 36 | 0;
            Ea(f, e + 24 | 0, c);
            Ca(c);
            b[d + 48 >> 2] = b[a >> 2];
            c = d + 52 | 0;
            Ea(f, e + 36 | 0, c);
            Ca(c);
            b[d + 64 >> 2] = b[a >> 2];
            c = d + 68 | 0;
            Ea(f, e + 48 | 0, c);
            Ca(c);
            b[d + 80 >> 2] = b[a >> 2];
            d = d + 84 | 0;
            Ea(f, e + 60 | 0, d);
            Ca(d);
            S = j;
            return;
        }
        function gb(a) {
            a = +a;
            var b = 0.0;
            b = a < 0.0 ? a + 6.283185307179586 : a;
            return +(!(a >= 6.283185307179586) ? b : b + -6.283185307179586);
        }
        function hb(a, b) {
            a = a | 0;
            b = b | 0;
            if (!(+q(+(+e[a >> 3] - +e[b >> 3])) < 1.7453292519943298e-11)) {
                b = 0;
                return b | 0;
            }
            b = +q(+(+e[a + 8 >> 3] - +e[b + 8 >> 3])) < 1.7453292519943298e-11;
            return b | 0;
        }
        function ib(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 2.0);
        }
        function jb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 12742.01436183695);
        }
        function kb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 12742014.36183695);
        }
        function lb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0, h = 0.0;
            g = +e[b >> 3];
            d = +t(+g);
            f = +e[b + 8 >> 3] - +e[a + 8 >> 3];
            h = d * +u(+f);
            c = +e[a >> 3];
            return + +z(+h, +(+u(+g) * +t(+c) - +t(+f) * (d * +u(+c))));
        }
        function mb(a, c, d, f) {
            a = a | 0;
            c = +c;
            d = +d;
            f = f | 0;
            var g = 0, h = 0.0, i = 0.0, j = 0.0;
            if (d < 1.0e-16) {
                b[f >> 2] = b[a >> 2];
                b[f + 4 >> 2] = b[a + 4 >> 2];
                b[f + 8 >> 2] = b[a + 8 >> 2];
                b[f + 12 >> 2] = b[a + 12 >> 2];
                return;
            }
            h = c < 0.0 ? c + 6.283185307179586 : c;
            h = !(c >= 6.283185307179586) ? h : h + -6.283185307179586;
            do if (h < 1.0e-16) {
                c = +e[a >> 3] + d;
                e[f >> 3] = c;
                g = f;
            } else {
                g = +q(+(h + -3.141592653589793)) < 1.0e-16;
                c = +e[a >> 3];
                if (g) {
                    c = c - d;
                    e[f >> 3] = c;
                    g = f;
                    break;
                }
                i = +t(+d);
                d = +u(+d);
                c = i * +u(+c) + +t(+h) * (d * +t(+c));
                c = c > 1.0 ? 1.0 : c;
                c = +x(+(c < -1 ? -1 : c));
                e[f >> 3] = c;
                if (+q(+(c + -1.5707963267948966)) < 1.0e-16) {
                    e[f >> 3] = 1.5707963267948966;
                    e[f + 8 >> 3] = 0.0;
                    return;
                }
                if (+q(+(c + 1.5707963267948966)) < 1.0e-16) {
                    e[f >> 3] = -1.5707963267948966;
                    e[f + 8 >> 3] = 0.0;
                    return;
                }
                j = +t(+c);
                h = d * +u(+h) / j;
                d = +e[a >> 3];
                c = (i - +u(+c) * +u(+d)) / +t(+d) / j;
                i = h > 1.0 ? 1.0 : h;
                c = c > 1.0 ? 1.0 : c;
                c = +e[a + 8 >> 3] + +z(+(i < -1 ? -1 : i), +(c < -1 ? -1 : c));
                if (c > 3.141592653589793) do c = c + -6.283185307179586;
                while (c > 3.141592653589793);
                if (c < -3.141592653589793) do c = c + 6.283185307179586;
                while (c < -3.141592653589793);
                e[f + 8 >> 3] = c;
                return;
            }
            while (0);
            if (+q(+(c + -1.5707963267948966)) < 1.0e-16) {
                e[g >> 3] = 1.5707963267948966;
                e[f + 8 >> 3] = 0.0;
                return;
            }
            if (+q(+(c + 1.5707963267948966)) < 1.0e-16) {
                e[g >> 3] = -1.5707963267948966;
                e[f + 8 >> 3] = 0.0;
                return;
            }
            c = +e[a + 8 >> 3];
            if (c > 3.141592653589793) do c = c + -6.283185307179586;
            while (c > 3.141592653589793);
            if (c < -3.141592653589793) do c = c + 6.283185307179586;
            while (c < -3.141592653589793);
            e[f + 8 >> 3] = c;
            return;
        }
        function nb(a) {
            a = a | 0;
            return + +e[20496 + (a << 3) >> 3];
        }
        function ob(a) {
            a = a | 0;
            return + +e[20624 + (a << 3) >> 3];
        }
        function pb(a) {
            a = a | 0;
            return + +e[20752 + (a << 3) >> 3];
        }
        function qb(a) {
            a = a | 0;
            return + +e[20880 + (a << 3) >> 3];
        }
        function rb(a) {
            a = a | 0;
            var c = 0;
            c = 21008 + (a << 3) | 0;
            a = b[c >> 2] | 0;
            F(b[c + 4 >> 2] | 0);
            return a | 0;
        }
        function sb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0;
            n = +e[b >> 3];
            l = +e[a >> 3];
            j = +u(+((n - l) * .5));
            g = +e[b + 8 >> 3];
            k = +e[a + 8 >> 3];
            h = +u(+((g - k) * .5));
            i = +t(+l);
            m = +t(+n);
            h = j * j + h * (m * i * h);
            h = +z(+ +r(+h), + +r(+(1.0 - h))) * 2.0;
            j = +e[c >> 3];
            n = +u(+((j - n) * .5));
            d = +e[c + 8 >> 3];
            g = +u(+((d - g) * .5));
            f = +t(+j);
            g = n * n + g * (m * f * g);
            g = +z(+ +r(+g), + +r(+(1.0 - g))) * 2.0;
            j = +u(+((l - j) * .5));
            d = +u(+((k - d) * .5));
            d = j * j + d * (i * f * d);
            d = +z(+ +r(+d), + +r(+(1.0 - d))) * 2.0;
            f = (h + g + d) * .5;
            return +(+y(+ +r(+(+v(+(f * .5)) * +v(+((f - h) * .5)) * +v(+((f - g) * .5)) * +v(+((f - d) * .5))))) * 4.0);
        }
        function tb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 192 | 0;
            e = g + 168 | 0;
            f = g;
            Vb(a, c, e);
            Wb(a, c, f);
            c = b[f >> 2] | 0;
            if ((c | 0) <= 0) {
                d = 0.0;
                S = g;
                return +d;
            }
            d = +sb(f + 8 | 0, f + 8 + (((c | 0) != 1 & 1) << 4) | 0, e) + 0.0;
            if ((c | 0) == 1) {
                S = g;
                return +d;
            }
            a = 1;
            do {
                h = a;
                a = a + 1 | 0;
                d = d + +sb(f + 8 + (h << 4) | 0, f + 8 + (((a | 0) % (c | 0) | 0) << 4) | 0, e);
            }while ((a | 0) < (c | 0));
            S = g;
            return +d;
        }
        function ub(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 192 | 0;
            e = g + 168 | 0;
            f = g;
            Vb(a, c, e);
            Wb(a, c, f);
            c = b[f >> 2] | 0;
            if ((c | 0) > 0) {
                d = +sb(f + 8 | 0, f + 8 + (((c | 0) != 1 & 1) << 4) | 0, e) + 0.0;
                if ((c | 0) != 1) {
                    a = 1;
                    do {
                        h = a;
                        a = a + 1 | 0;
                        d = d + +sb(f + 8 + (h << 4) | 0, f + 8 + (((a | 0) % (c | 0) | 0) << 4) | 0, e);
                    }while ((a | 0) < (c | 0));
                }
            } else d = 0.0;
            S = g;
            return +(d * 40589732.49931477);
        }
        function vb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 192 | 0;
            e = g + 168 | 0;
            f = g;
            Vb(a, c, e);
            Wb(a, c, f);
            c = b[f >> 2] | 0;
            if ((c | 0) > 0) {
                d = +sb(f + 8 | 0, f + 8 + (((c | 0) != 1 & 1) << 4) | 0, e) + 0.0;
                if ((c | 0) != 1) {
                    a = 1;
                    do {
                        h = a;
                        a = a + 1 | 0;
                        d = d + +sb(f + 8 + (h << 4) | 0, f + 8 + (((a | 0) % (c | 0) | 0) << 4) | 0, e);
                    }while ((a | 0) < (c | 0));
                }
            } else d = 0.0;
            S = g;
            return +(d * 40589732499314.77);
        }
        function wb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            i = S;
            S = S + 176 | 0;
            h = i;
            gc(a, c, h);
            a = b[h >> 2] | 0;
            if ((a | 0) <= 1) {
                g = 0.0;
                S = i;
                return +g;
            }
            c = a + -1 | 0;
            a = 0;
            d = 0.0;
            f = +e[h + 8 >> 3];
            g = +e[h + 16 >> 3];
            do {
                a = a + 1 | 0;
                k = f;
                f = +e[h + 8 + (a << 4) >> 3];
                l = +u(+((f - k) * .5));
                j = g;
                g = +e[h + 8 + (a << 4) + 8 >> 3];
                j = +u(+((g - j) * .5));
                j = l * l + j * (+t(+f) * +t(+k) * j);
                d = d + +z(+ +r(+j), + +r(+(1.0 - j))) * 2.0;
            }while ((a | 0) < (c | 0));
            S = i;
            return +d;
        }
        function xb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            i = S;
            S = S + 176 | 0;
            h = i;
            gc(a, c, h);
            a = b[h >> 2] | 0;
            if ((a | 0) <= 1) {
                g = 0.0;
                S = i;
                return +g;
            }
            c = a + -1 | 0;
            a = 0;
            d = 0.0;
            f = +e[h + 8 >> 3];
            g = +e[h + 16 >> 3];
            do {
                a = a + 1 | 0;
                k = f;
                f = +e[h + 8 + (a << 4) >> 3];
                l = +u(+((f - k) * .5));
                j = g;
                g = +e[h + 8 + (a << 4) + 8 >> 3];
                j = +u(+((g - j) * .5));
                j = l * l + j * (+t(+k) * +t(+f) * j);
                d = d + +z(+ +r(+j), + +r(+(1.0 - j))) * 2.0;
            }while ((a | 0) != (c | 0));
            l = d * 6371.007180918475;
            S = i;
            return +l;
        }
        function yb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            i = S;
            S = S + 176 | 0;
            h = i;
            gc(a, c, h);
            a = b[h >> 2] | 0;
            if ((a | 0) <= 1) {
                g = 0.0;
                S = i;
                return +g;
            }
            c = a + -1 | 0;
            a = 0;
            d = 0.0;
            f = +e[h + 8 >> 3];
            g = +e[h + 16 >> 3];
            do {
                a = a + 1 | 0;
                k = f;
                f = +e[h + 8 + (a << 4) >> 3];
                l = +u(+((f - k) * .5));
                j = g;
                g = +e[h + 8 + (a << 4) + 8 >> 3];
                j = +u(+((g - j) * .5));
                j = l * l + j * (+t(+k) * +t(+f) * j);
                d = d + +z(+ +r(+j), + +r(+(1.0 - j))) * 2.0;
            }while ((a | 0) != (c | 0));
            l = d * 6371007.180918475;
            S = i;
            return +l;
        }
        function zb(a, b) {
            a = a | 0;
            b = b | 0;
            b = cd(a | 0, b | 0, 52) | 0;
            G();
            return b & 15 | 0;
        }
        function Ab(a, b) {
            a = a | 0;
            b = b | 0;
            b = cd(a | 0, b | 0, 45) | 0;
            G();
            return b & 127 | 0;
        }
        function Bb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            if (!(true & (b & -16777216 | 0) == 134217728)) {
                b = 0;
                return b | 0;
            }
            g = cd(a | 0, b | 0, 45) | 0;
            G();
            g = g & 127;
            if (g >>> 0 > 121) {
                b = 0;
                return b | 0;
            }
            c = cd(a | 0, b | 0, 52) | 0;
            G();
            c = c & 15;
            do if (c | 0) {
                e = 1;
                d = 0;
                while(true){
                    f = cd(a | 0, b | 0, (15 - e | 0) * 3 | 0) | 0;
                    G();
                    f = f & 7;
                    if ((f | 0) != 0 & (d ^ 1)) {
                        if ((f | 0) == 1 & (la(g) | 0) != 0) {
                            h = 0;
                            d = 13;
                            break;
                        } else d = 1;
                    }
                    if ((f | 0) == 7) {
                        h = 0;
                        d = 13;
                        break;
                    }
                    if (e >>> 0 < c >>> 0) e = e + 1 | 0;
                    else {
                        d = 9;
                        break;
                    }
                }
                if ((d | 0) == 9) {
                    if ((c | 0) == 15) h = 1;
                    else break;
                    return h | 0;
                } else if ((d | 0) == 13) return h | 0;
            }
            while (0);
            while(true){
                h = cd(a | 0, b | 0, (14 - c | 0) * 3 | 0) | 0;
                G();
                if (!((h & 7 | 0) == 7 & true)) {
                    h = 0;
                    d = 13;
                    break;
                }
                if (c >>> 0 < 14) c = c + 1 | 0;
                else {
                    h = 1;
                    d = 13;
                    break;
                }
            }
            if ((d | 0) == 13) return h | 0;
            return 0;
        }
        function Cb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = cd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if ((d | 0) >= (c | 0)) {
                if ((d | 0) != (c | 0)) {
                    if (c >>> 0 <= 15) {
                        e = dd(c | 0, 0, 52) | 0;
                        a = e | a;
                        b = G() | 0 | b & -15728641;
                        if ((d | 0) > (c | 0)) do {
                            e = dd(7, 0, (14 - c | 0) * 3 | 0) | 0;
                            c = c + 1 | 0;
                            a = e | a;
                            b = G() | 0 | b;
                        }while ((c | 0) < (d | 0));
                    } else {
                        b = 0;
                        a = 0;
                    }
                }
            } else {
                b = 0;
                a = 0;
            }
            F(b | 0);
            return a | 0;
        }
        function Db(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            a = cd(a | 0, b | 0, 52) | 0;
            G();
            a = a & 15;
            if (!((c | 0) < 16 & (a | 0) <= (c | 0))) {
                c = 0;
                return c | 0;
            }
            c = tc(7, c - a | 0) | 0;
            return c | 0;
        }
        function Eb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            h = cd(a | 0, c | 0, 52) | 0;
            G();
            h = h & 15;
            if (!((d | 0) < 16 & (h | 0) <= (d | 0))) return;
            if ((h | 0) == (d | 0)) {
                d = e;
                b[d >> 2] = a;
                b[d + 4 >> 2] = c;
                return;
            }
            j = tc(7, d - h | 0) | 0;
            k = (j | 0) / 7 | 0;
            i = cd(a | 0, c | 0, 45) | 0;
            G();
            if (!(la(i & 127) | 0)) g = 0;
            else {
                a: do if (!h) f = 0;
                else {
                    g = 1;
                    while(true){
                        f = cd(a | 0, c | 0, (15 - g | 0) * 3 | 0) | 0;
                        G();
                        f = f & 7;
                        if (f | 0) break a;
                        if (g >>> 0 < h >>> 0) g = g + 1 | 0;
                        else {
                            f = 0;
                            break;
                        }
                    }
                }
                while (0);
                g = (f | 0) == 0;
            }
            l = dd(h + 1 | 0, 0, 52) | 0;
            f = G() | 0 | c & -15728641;
            i = (14 - h | 0) * 3 | 0;
            c = dd(7, 0, i | 0) | 0;
            c = (l | a) & ~c;
            h = f & ~(G() | 0);
            Eb(c, h, d, e);
            f = e + (k << 3) | 0;
            if (!g) {
                l = dd(1, 0, i | 0) | 0;
                Eb(l | c, G() | 0 | h, d, f);
                l = f + (k << 3) | 0;
                j = dd(2, 0, i | 0) | 0;
                Eb(j | c, G() | 0 | h, d, l);
                l = l + (k << 3) | 0;
                j = dd(3, 0, i | 0) | 0;
                Eb(j | c, G() | 0 | h, d, l);
                l = l + (k << 3) | 0;
                j = dd(4, 0, i | 0) | 0;
                Eb(j | c, G() | 0 | h, d, l);
                l = l + (k << 3) | 0;
                j = dd(5, 0, i | 0) | 0;
                Eb(j | c, G() | 0 | h, d, l);
                j = dd(6, 0, i | 0) | 0;
                Eb(j | c, G() | 0 | h, d, l + (k << 3) | 0);
                return;
            }
            g = f + (k << 3) | 0;
            if ((j | 0) > 6) {
                j = f + 8 | 0;
                l = (g >>> 0 > j >>> 0 ? g : j) + -1 + (0 - f) | 0;
                hd(f | 0, 0, l + 8 & -8 | 0);
                f = j + (l >>> 3 << 3) | 0;
            }
            l = dd(2, 0, i | 0) | 0;
            Eb(l | c, G() | 0 | h, d, f);
            l = f + (k << 3) | 0;
            j = dd(3, 0, i | 0) | 0;
            Eb(j | c, G() | 0 | h, d, l);
            l = l + (k << 3) | 0;
            j = dd(4, 0, i | 0) | 0;
            Eb(j | c, G() | 0 | h, d, l);
            l = l + (k << 3) | 0;
            j = dd(5, 0, i | 0) | 0;
            Eb(j | c, G() | 0 | h, d, l);
            j = dd(6, 0, i | 0) | 0;
            Eb(j | c, G() | 0 | h, d, l + (k << 3) | 0);
            return;
        }
        function Fb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            e = cd(a | 0, b | 0, 45) | 0;
            G();
            if (!(la(e & 127) | 0)) {
                e = 0;
                return e | 0;
            }
            e = cd(a | 0, b | 0, 52) | 0;
            G();
            e = e & 15;
            a: do if (!e) c = 0;
            else {
                d = 1;
                while(true){
                    c = cd(a | 0, b | 0, (15 - d | 0) * 3 | 0) | 0;
                    G();
                    c = c & 7;
                    if (c | 0) break a;
                    if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                    else {
                        c = 0;
                        break;
                    }
                }
            }
            while (0);
            e = (c | 0) == 0 & 1;
            return e | 0;
        }
        function Gb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = cd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if ((c | 0) < 16 & (d | 0) <= (c | 0)) {
                if ((d | 0) != (c | 0)) {
                    e = dd(c | 0, 0, 52) | 0;
                    a = e | a;
                    b = G() | 0 | b & -15728641;
                    if ((d | 0) < (c | 0)) do {
                        e = dd(7, 0, (14 - d | 0) * 3 | 0) | 0;
                        d = d + 1 | 0;
                        a = a & ~e;
                        b = b & ~(G() | 0);
                    }while ((d | 0) < (c | 0));
                }
            } else {
                b = 0;
                a = 0;
            }
            F(b | 0);
            return a | 0;
        }
        function Hb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0;
            if (!d) {
                y = 0;
                return y | 0;
            }
            f = a;
            e = b[f >> 2] | 0;
            f = b[f + 4 >> 2] | 0;
            if (true & (f & 15728640 | 0) == 0) {
                if ((d | 0) <= 0) {
                    y = 0;
                    return y | 0;
                }
                y = c;
                b[y >> 2] = e;
                b[y + 4 >> 2] = f;
                if ((d | 0) == 1) {
                    y = 0;
                    return y | 0;
                }
                e = 1;
                do {
                    w = a + (e << 3) | 0;
                    x = b[w + 4 >> 2] | 0;
                    y = c + (e << 3) | 0;
                    b[y >> 2] = b[w >> 2];
                    b[y + 4 >> 2] = x;
                    e = e + 1 | 0;
                }while ((e | 0) != (d | 0));
                e = 0;
                return e | 0;
            }
            w = d << 3;
            x = Wc(w) | 0;
            if (!x) {
                y = -3;
                return y | 0;
            }
            gd(x | 0, a | 0, w | 0);
            v = Yc(d, 8) | 0;
            if (!v) {
                Xc(x);
                y = -3;
                return y | 0;
            }
            e = d;
            a: while(true){
                h = x;
                l = b[h >> 2] | 0;
                h = b[h + 4 >> 2] | 0;
                t = cd(l | 0, h | 0, 52) | 0;
                G();
                t = t & 15;
                u = t + -1 | 0;
                s = (e | 0) > 0;
                b: do if (s) {
                    r = ((e | 0) < 0) << 31 >> 31;
                    p = dd(u | 0, 0, 52) | 0;
                    q = G() | 0;
                    if (u >>> 0 > 15) {
                        f = 0;
                        a = l;
                        d = h;
                        while(true){
                            if (!((a | 0) == 0 & (d | 0) == 0)) {
                                g = cd(a | 0, d | 0, 52) | 0;
                                G();
                                g = g & 15;
                                i = (g | 0) < (u | 0);
                                g = (g | 0) == (u | 0);
                                k = i ? 0 : g ? a : 0;
                                a = i ? 0 : g ? d : 0;
                                d = bd(k | 0, a | 0, e | 0, r | 0) | 0;
                                G();
                                g = v + (d << 3) | 0;
                                i = g;
                                j = b[i >> 2] | 0;
                                i = b[i + 4 >> 2] | 0;
                                if ((j | 0) == 0 & (i | 0) == 0) d = k;
                                else {
                                    p = 0;
                                    o = d;
                                    n = i;
                                    d = k;
                                    while(true){
                                        if ((p | 0) > (e | 0)) {
                                            y = 41;
                                            break a;
                                        }
                                        if ((j | 0) == (d | 0) & (n & -117440513 | 0) == (a | 0)) {
                                            k = cd(j | 0, n | 0, 56) | 0;
                                            G();
                                            k = k & 7;
                                            m = k + 1 | 0;
                                            q = cd(j | 0, n | 0, 45) | 0;
                                            G();
                                            c: do if (!(la(q & 127) | 0)) i = 7;
                                            else {
                                                j = cd(j | 0, n | 0, 52) | 0;
                                                G();
                                                j = j & 15;
                                                if (!j) {
                                                    i = 6;
                                                    break;
                                                }
                                                i = 1;
                                                while(true){
                                                    q = dd(7, 0, (15 - i | 0) * 3 | 0) | 0;
                                                    if (!((q & d | 0) == 0 & ((G() | 0) & a | 0) == 0)) {
                                                        i = 7;
                                                        break c;
                                                    }
                                                    if (i >>> 0 < j >>> 0) i = i + 1 | 0;
                                                    else {
                                                        i = 6;
                                                        break;
                                                    }
                                                }
                                            }
                                            while (0);
                                            if ((k + 2 | 0) >>> 0 > i >>> 0) {
                                                y = 51;
                                                break a;
                                            }
                                            q = dd(m | 0, 0, 56) | 0;
                                            a = G() | 0 | a & -117440513;
                                            i = g;
                                            b[i >> 2] = 0;
                                            b[i + 4 >> 2] = 0;
                                            i = o;
                                            d = q | d;
                                        } else i = (o + 1 | 0) % (e | 0) | 0;
                                        g = v + (i << 3) | 0;
                                        n = g;
                                        j = b[n >> 2] | 0;
                                        n = b[n + 4 >> 2] | 0;
                                        if ((j | 0) == 0 & (n | 0) == 0) break;
                                        else {
                                            p = p + 1 | 0;
                                            o = i;
                                        }
                                    }
                                }
                                q = g;
                                b[q >> 2] = d;
                                b[q + 4 >> 2] = a;
                            }
                            f = f + 1 | 0;
                            if ((f | 0) >= (e | 0)) break b;
                            d = x + (f << 3) | 0;
                            a = b[d >> 2] | 0;
                            d = b[d + 4 >> 2] | 0;
                        }
                    }
                    f = 0;
                    a = l;
                    d = h;
                    while(true){
                        if (!((a | 0) == 0 & (d | 0) == 0)) {
                            i = cd(a | 0, d | 0, 52) | 0;
                            G();
                            i = i & 15;
                            if ((i | 0) >= (u | 0)) {
                                if ((i | 0) != (u | 0)) {
                                    a = a | p;
                                    d = d & -15728641 | q;
                                    if (i >>> 0 >= t >>> 0) {
                                        g = u;
                                        do {
                                            o = dd(7, 0, (14 - g | 0) * 3 | 0) | 0;
                                            g = g + 1 | 0;
                                            a = o | a;
                                            d = G() | 0 | d;
                                        }while (g >>> 0 < i >>> 0);
                                    }
                                }
                            } else {
                                a = 0;
                                d = 0;
                            }
                            i = bd(a | 0, d | 0, e | 0, r | 0) | 0;
                            G();
                            g = v + (i << 3) | 0;
                            j = g;
                            k = b[j >> 2] | 0;
                            j = b[j + 4 >> 2] | 0;
                            if (!((k | 0) == 0 & (j | 0) == 0)) {
                                o = 0;
                                while(true){
                                    if ((o | 0) > (e | 0)) {
                                        y = 41;
                                        break a;
                                    }
                                    if ((k | 0) == (a | 0) & (j & -117440513 | 0) == (d | 0)) {
                                        m = cd(k | 0, j | 0, 56) | 0;
                                        G();
                                        m = m & 7;
                                        n = m + 1 | 0;
                                        z = cd(k | 0, j | 0, 45) | 0;
                                        G();
                                        d: do if (!(la(z & 127) | 0)) j = 7;
                                        else {
                                            k = cd(k | 0, j | 0, 52) | 0;
                                            G();
                                            k = k & 15;
                                            if (!k) {
                                                j = 6;
                                                break;
                                            }
                                            j = 1;
                                            while(true){
                                                z = dd(7, 0, (15 - j | 0) * 3 | 0) | 0;
                                                if (!((z & a | 0) == 0 & ((G() | 0) & d | 0) == 0)) {
                                                    j = 7;
                                                    break d;
                                                }
                                                if (j >>> 0 < k >>> 0) j = j + 1 | 0;
                                                else {
                                                    j = 6;
                                                    break;
                                                }
                                            }
                                        }
                                        while (0);
                                        if ((m + 2 | 0) >>> 0 > j >>> 0) {
                                            y = 51;
                                            break a;
                                        }
                                        z = dd(n | 0, 0, 56) | 0;
                                        d = G() | 0 | d & -117440513;
                                        n = g;
                                        b[n >> 2] = 0;
                                        b[n + 4 >> 2] = 0;
                                        a = z | a;
                                    } else i = (i + 1 | 0) % (e | 0) | 0;
                                    g = v + (i << 3) | 0;
                                    j = g;
                                    k = b[j >> 2] | 0;
                                    j = b[j + 4 >> 2] | 0;
                                    if ((k | 0) == 0 & (j | 0) == 0) break;
                                    else o = o + 1 | 0;
                                }
                            }
                            z = g;
                            b[z >> 2] = a;
                            b[z + 4 >> 2] = d;
                        }
                        f = f + 1 | 0;
                        if ((f | 0) >= (e | 0)) break b;
                        d = x + (f << 3) | 0;
                        a = b[d >> 2] | 0;
                        d = b[d + 4 >> 2] | 0;
                    }
                }
                while (0);
                if ((e + 5 | 0) >>> 0 < 11) {
                    y = 99;
                    break;
                }
                q = Yc((e | 0) / 6 | 0, 8) | 0;
                if (!q) {
                    y = 58;
                    break;
                }
                e: do if (s) {
                    o = 0;
                    n = 0;
                    do {
                        i = v + (o << 3) | 0;
                        a = i;
                        f = b[a >> 2] | 0;
                        a = b[a + 4 >> 2] | 0;
                        if (!((f | 0) == 0 & (a | 0) == 0)) {
                            j = cd(f | 0, a | 0, 56) | 0;
                            G();
                            j = j & 7;
                            d = j + 1 | 0;
                            k = a & -117440513;
                            z = cd(f | 0, a | 0, 45) | 0;
                            G();
                            f: do if (la(z & 127) | 0) {
                                m = cd(f | 0, a | 0, 52) | 0;
                                G();
                                m = m & 15;
                                if (m | 0) {
                                    g = 1;
                                    while(true){
                                        z = dd(7, 0, (15 - g | 0) * 3 | 0) | 0;
                                        if (!((f & z | 0) == 0 & (k & (G() | 0) | 0) == 0)) break f;
                                        if (g >>> 0 < m >>> 0) g = g + 1 | 0;
                                        else break;
                                    }
                                }
                                a = dd(d | 0, 0, 56) | 0;
                                f = a | f;
                                a = G() | 0 | k;
                                d = i;
                                b[d >> 2] = f;
                                b[d + 4 >> 2] = a;
                                d = j + 2 | 0;
                            }
                            while (0);
                            if ((d | 0) == 7) {
                                z = q + (n << 3) | 0;
                                b[z >> 2] = f;
                                b[z + 4 >> 2] = a & -117440513;
                                n = n + 1 | 0;
                            }
                        }
                        o = o + 1 | 0;
                    }while ((o | 0) != (e | 0));
                    if (s) {
                        p = ((e | 0) < 0) << 31 >> 31;
                        m = dd(u | 0, 0, 52) | 0;
                        o = G() | 0;
                        if (u >>> 0 > 15) {
                            a = 0;
                            f = 0;
                            while(true){
                                do if (!((l | 0) == 0 & (h | 0) == 0)) {
                                    j = cd(l | 0, h | 0, 52) | 0;
                                    G();
                                    j = j & 15;
                                    g = (j | 0) < (u | 0);
                                    j = (j | 0) == (u | 0);
                                    i = g ? 0 : j ? l : 0;
                                    j = g ? 0 : j ? h : 0;
                                    g = bd(i | 0, j | 0, e | 0, p | 0) | 0;
                                    G();
                                    d = 0;
                                    while(true){
                                        if ((d | 0) > (e | 0)) {
                                            y = 98;
                                            break a;
                                        }
                                        z = v + (g << 3) | 0;
                                        k = b[z + 4 >> 2] | 0;
                                        if ((k & -117440513 | 0) == (j | 0) ? (b[z >> 2] | 0) == (i | 0) : 0) {
                                            y = 70;
                                            break;
                                        }
                                        g = (g + 1 | 0) % (e | 0) | 0;
                                        z = v + (g << 3) | 0;
                                        if ((b[z >> 2] | 0) == (i | 0) ? (b[z + 4 >> 2] | 0) == (j | 0) : 0) break;
                                        else d = d + 1 | 0;
                                    }
                                    if ((y | 0) == 70 ? (y = 0, true & (k & 117440512 | 0) == 100663296) : 0) break;
                                    z = c + (f << 3) | 0;
                                    b[z >> 2] = l;
                                    b[z + 4 >> 2] = h;
                                    f = f + 1 | 0;
                                }
                                while (0);
                                a = a + 1 | 0;
                                if ((a | 0) >= (e | 0)) {
                                    e = n;
                                    break e;
                                }
                                h = x + (a << 3) | 0;
                                l = b[h >> 2] | 0;
                                h = b[h + 4 >> 2] | 0;
                            }
                        }
                        a = 0;
                        f = 0;
                        while(true){
                            do if (!((l | 0) == 0 & (h | 0) == 0)) {
                                j = cd(l | 0, h | 0, 52) | 0;
                                G();
                                j = j & 15;
                                if ((j | 0) >= (u | 0)) {
                                    if ((j | 0) != (u | 0)) {
                                        d = l | m;
                                        g = h & -15728641 | o;
                                        if (j >>> 0 < t >>> 0) j = g;
                                        else {
                                            i = u;
                                            do {
                                                z = dd(7, 0, (14 - i | 0) * 3 | 0) | 0;
                                                i = i + 1 | 0;
                                                d = z | d;
                                                g = G() | 0 | g;
                                            }while (i >>> 0 < j >>> 0);
                                            j = g;
                                        }
                                    } else {
                                        d = l;
                                        j = h;
                                    }
                                } else {
                                    d = 0;
                                    j = 0;
                                }
                                i = bd(d | 0, j | 0, e | 0, p | 0) | 0;
                                G();
                                g = 0;
                                while(true){
                                    if ((g | 0) > (e | 0)) {
                                        y = 98;
                                        break a;
                                    }
                                    z = v + (i << 3) | 0;
                                    k = b[z + 4 >> 2] | 0;
                                    if ((k & -117440513 | 0) == (j | 0) ? (b[z >> 2] | 0) == (d | 0) : 0) {
                                        y = 93;
                                        break;
                                    }
                                    i = (i + 1 | 0) % (e | 0) | 0;
                                    z = v + (i << 3) | 0;
                                    if ((b[z >> 2] | 0) == (d | 0) ? (b[z + 4 >> 2] | 0) == (j | 0) : 0) break;
                                    else g = g + 1 | 0;
                                }
                                if ((y | 0) == 93 ? (y = 0, true & (k & 117440512 | 0) == 100663296) : 0) break;
                                z = c + (f << 3) | 0;
                                b[z >> 2] = l;
                                b[z + 4 >> 2] = h;
                                f = f + 1 | 0;
                            }
                            while (0);
                            a = a + 1 | 0;
                            if ((a | 0) >= (e | 0)) {
                                e = n;
                                break e;
                            }
                            h = x + (a << 3) | 0;
                            l = b[h >> 2] | 0;
                            h = b[h + 4 >> 2] | 0;
                        }
                    } else {
                        f = 0;
                        e = n;
                    }
                } else {
                    f = 0;
                    e = 0;
                }
                while (0);
                hd(v | 0, 0, w | 0);
                gd(x | 0, q | 0, e << 3 | 0);
                Xc(q);
                if (!e) break;
                else c = c + (f << 3) | 0;
            }
            if ((y | 0) == 41) {
                Xc(x);
                Xc(v);
                z = -1;
                return z | 0;
            } else if ((y | 0) == 51) {
                Xc(x);
                Xc(v);
                z = -2;
                return z | 0;
            } else if ((y | 0) == 58) {
                Xc(x);
                Xc(v);
                z = -3;
                return z | 0;
            } else if ((y | 0) == 98) {
                Xc(q);
                Xc(x);
                Xc(v);
                z = -1;
                return z | 0;
            } else if ((y | 0) == 99) gd(c | 0, x | 0, e << 3 | 0);
            Xc(x);
            Xc(v);
            z = 0;
            return z | 0;
        }
        function Ib(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            if ((c | 0) <= 0) {
                f = 0;
                return f | 0;
            }
            if ((f | 0) >= 16) {
                g = 0;
                while(true){
                    l = a + (g << 3) | 0;
                    if (!((b[l >> 2] | 0) == 0 & (b[l + 4 >> 2] | 0) == 0)) {
                        g = 14;
                        break;
                    }
                    g = g + 1 | 0;
                    if ((g | 0) >= (c | 0)) {
                        h = 0;
                        g = 16;
                        break;
                    }
                }
                if ((g | 0) == 14) return ((e | 0) > 0 ? -2 : -1) | 0;
                else if ((g | 0) == 16) return h | 0;
            }
            g = 0;
            l = 0;
            a: while(true){
                k = a + (l << 3) | 0;
                i = k;
                h = b[i >> 2] | 0;
                i = b[i + 4 >> 2] | 0;
                do if (!((h | 0) == 0 & (i | 0) == 0)) {
                    if ((g | 0) >= (e | 0)) {
                        h = -1;
                        g = 16;
                        break a;
                    }
                    j = cd(h | 0, i | 0, 52) | 0;
                    G();
                    j = j & 15;
                    if ((j | 0) > (f | 0)) {
                        h = -2;
                        g = 16;
                        break a;
                    }
                    if ((j | 0) == (f | 0)) {
                        k = d + (g << 3) | 0;
                        b[k >> 2] = h;
                        b[k + 4 >> 2] = i;
                        g = g + 1 | 0;
                        break;
                    }
                    h = (tc(7, f - j | 0) | 0) + g | 0;
                    if ((h | 0) > (e | 0)) {
                        h = -1;
                        g = 16;
                        break a;
                    }
                    Eb(b[k >> 2] | 0, b[k + 4 >> 2] | 0, f, d + (g << 3) | 0);
                    g = h;
                }
                while (0);
                l = l + 1 | 0;
                if ((l | 0) >= (c | 0)) {
                    h = 0;
                    g = 16;
                    break;
                }
            }
            if ((g | 0) == 16) return h | 0;
            return 0;
        }
        function Jb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            if ((c | 0) <= 0) {
                d = 0;
                return d | 0;
            }
            if ((d | 0) >= 16) {
                e = 0;
                while(true){
                    h = a + (e << 3) | 0;
                    if (!((b[h >> 2] | 0) == 0 & (b[h + 4 >> 2] | 0) == 0)) {
                        e = -1;
                        f = 13;
                        break;
                    }
                    e = e + 1 | 0;
                    if ((e | 0) >= (c | 0)) {
                        e = 0;
                        f = 13;
                        break;
                    }
                }
                if ((f | 0) == 13) return e | 0;
            }
            e = 0;
            h = 0;
            a: while(true){
                f = a + (h << 3) | 0;
                g = b[f >> 2] | 0;
                f = b[f + 4 >> 2] | 0;
                do if (!((g | 0) == 0 & (f | 0) == 0)) {
                    f = cd(g | 0, f | 0, 52) | 0;
                    G();
                    f = f & 15;
                    if ((f | 0) > (d | 0)) {
                        e = -1;
                        f = 13;
                        break a;
                    }
                    if ((f | 0) == (d | 0)) {
                        e = e + 1 | 0;
                        break;
                    } else {
                        e = (tc(7, d - f | 0) | 0) + e | 0;
                        break;
                    }
                }
                while (0);
                h = h + 1 | 0;
                if ((h | 0) >= (c | 0)) {
                    f = 13;
                    break;
                }
            }
            if ((f | 0) == 13) return e | 0;
            return 0;
        }
        function Kb(a, b) {
            a = a | 0;
            b = b | 0;
            b = cd(a | 0, b | 0, 52) | 0;
            G();
            return b & 1 | 0;
        }
        function Lb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            e = cd(a | 0, b | 0, 52) | 0;
            G();
            e = e & 15;
            if (!e) {
                e = 0;
                return e | 0;
            }
            d = 1;
            while(true){
                c = cd(a | 0, b | 0, (15 - d | 0) * 3 | 0) | 0;
                G();
                c = c & 7;
                if (c | 0) {
                    d = 5;
                    break;
                }
                if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                else {
                    c = 0;
                    d = 5;
                    break;
                }
            }
            if ((d | 0) == 5) return c | 0;
            return 0;
        }
        function Mb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            i = cd(a | 0, b | 0, 52) | 0;
            G();
            i = i & 15;
            if (!i) {
                h = b;
                i = a;
                F(h | 0);
                return i | 0;
            }
            h = 1;
            c = 0;
            while(true){
                f = (15 - h | 0) * 3 | 0;
                d = dd(7, 0, f | 0) | 0;
                e = G() | 0;
                g = cd(a | 0, b | 0, f | 0) | 0;
                G();
                f = dd(Pa(g & 7) | 0, 0, f | 0) | 0;
                g = G() | 0;
                a = f | a & ~d;
                b = g | b & ~e;
                a: do if (!c) {
                    if (!((f & d | 0) == 0 & (g & e | 0) == 0)) {
                        d = cd(a | 0, b | 0, 52) | 0;
                        G();
                        d = d & 15;
                        if (!d) c = 1;
                        else {
                            c = 1;
                            b: while(true){
                                g = cd(a | 0, b | 0, (15 - c | 0) * 3 | 0) | 0;
                                G();
                                switch(g & 7){
                                    case 1:
                                        break b;
                                    case 0:
                                        break;
                                    default:
                                        c = 1;
                                        break a;
                                }
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break a;
                                }
                            }
                            c = 1;
                            while(true){
                                g = (15 - c | 0) * 3 | 0;
                                e = cd(a | 0, b | 0, g | 0) | 0;
                                G();
                                f = dd(7, 0, g | 0) | 0;
                                b = b & ~(G() | 0);
                                g = dd(Pa(e & 7) | 0, 0, g | 0) | 0;
                                a = a & ~f | g;
                                b = b | (G() | 0);
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break;
                                }
                            }
                        }
                    } else c = 0;
                }
                while (0);
                if (h >>> 0 < i >>> 0) h = h + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Nb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0;
            d = cd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if (!d) {
                c = b;
                d = a;
                F(c | 0);
                return d | 0;
            }
            c = 1;
            while(true){
                f = (15 - c | 0) * 3 | 0;
                g = cd(a | 0, b | 0, f | 0) | 0;
                G();
                e = dd(7, 0, f | 0) | 0;
                b = b & ~(G() | 0);
                f = dd(Pa(g & 7) | 0, 0, f | 0) | 0;
                a = f | a & ~e;
                b = G() | 0 | b;
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Ob(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            i = cd(a | 0, b | 0, 52) | 0;
            G();
            i = i & 15;
            if (!i) {
                h = b;
                i = a;
                F(h | 0);
                return i | 0;
            }
            h = 1;
            c = 0;
            while(true){
                f = (15 - h | 0) * 3 | 0;
                d = dd(7, 0, f | 0) | 0;
                e = G() | 0;
                g = cd(a | 0, b | 0, f | 0) | 0;
                G();
                f = dd(Qa(g & 7) | 0, 0, f | 0) | 0;
                g = G() | 0;
                a = f | a & ~d;
                b = g | b & ~e;
                a: do if (!c) {
                    if (!((f & d | 0) == 0 & (g & e | 0) == 0)) {
                        d = cd(a | 0, b | 0, 52) | 0;
                        G();
                        d = d & 15;
                        if (!d) c = 1;
                        else {
                            c = 1;
                            b: while(true){
                                g = cd(a | 0, b | 0, (15 - c | 0) * 3 | 0) | 0;
                                G();
                                switch(g & 7){
                                    case 1:
                                        break b;
                                    case 0:
                                        break;
                                    default:
                                        c = 1;
                                        break a;
                                }
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break a;
                                }
                            }
                            c = 1;
                            while(true){
                                e = (15 - c | 0) * 3 | 0;
                                f = dd(7, 0, e | 0) | 0;
                                g = b & ~(G() | 0);
                                b = cd(a | 0, b | 0, e | 0) | 0;
                                G();
                                b = dd(Qa(b & 7) | 0, 0, e | 0) | 0;
                                a = a & ~f | b;
                                b = g | (G() | 0);
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break;
                                }
                            }
                        }
                    } else c = 0;
                }
                while (0);
                if (h >>> 0 < i >>> 0) h = h + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Pb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0;
            d = cd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if (!d) {
                c = b;
                d = a;
                F(c | 0);
                return d | 0;
            }
            c = 1;
            while(true){
                g = (15 - c | 0) * 3 | 0;
                f = dd(7, 0, g | 0) | 0;
                e = b & ~(G() | 0);
                b = cd(a | 0, b | 0, g | 0) | 0;
                G();
                b = dd(Qa(b & 7) | 0, 0, g | 0) | 0;
                a = b | a & ~f;
                b = G() | 0 | e;
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Qb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            j = S;
            S = S + 64 | 0;
            i = j + 40 | 0;
            e = j + 24 | 0;
            f = j + 12 | 0;
            g = j;
            dd(c | 0, 0, 52);
            d = G() | 134225919;
            if (!c) {
                if ((b[a + 4 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    F(h | 0);
                    S = j;
                    return i | 0;
                }
                if ((b[a + 8 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    F(h | 0);
                    S = j;
                    return i | 0;
                }
                if ((b[a + 12 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    F(h | 0);
                    S = j;
                    return i | 0;
                }
                dd(na(a) | 0, 0, 45);
                h = G() | 0 | d;
                i = -1;
                F(h | 0);
                S = j;
                return i | 0;
            }
            b[i >> 2] = b[a >> 2];
            b[i + 4 >> 2] = b[a + 4 >> 2];
            b[i + 8 >> 2] = b[a + 8 >> 2];
            b[i + 12 >> 2] = b[a + 12 >> 2];
            h = i + 4 | 0;
            if ((c | 0) > 0) {
                a = -1;
                while(true){
                    b[e >> 2] = b[h >> 2];
                    b[e + 4 >> 2] = b[h + 4 >> 2];
                    b[e + 8 >> 2] = b[h + 8 >> 2];
                    if (!(c & 1)) {
                        Ja(h);
                        b[f >> 2] = b[h >> 2];
                        b[f + 4 >> 2] = b[h + 4 >> 2];
                        b[f + 8 >> 2] = b[h + 8 >> 2];
                        La(f);
                    } else {
                        Ia(h);
                        b[f >> 2] = b[h >> 2];
                        b[f + 4 >> 2] = b[h + 4 >> 2];
                        b[f + 8 >> 2] = b[h + 8 >> 2];
                        Ka(f);
                    }
                    Fa(e, f, g);
                    Ca(g);
                    l = (15 - c | 0) * 3 | 0;
                    k = dd(7, 0, l | 0) | 0;
                    d = d & ~(G() | 0);
                    l = dd(Ha(g) | 0, 0, l | 0) | 0;
                    a = l | a & ~k;
                    d = G() | 0 | d;
                    if ((c | 0) > 1) c = c + -1 | 0;
                    else break;
                }
            } else a = -1;
            a: do if (((b[h >> 2] | 0) <= 2 ? (b[i + 8 >> 2] | 0) <= 2 : 0) ? (b[i + 12 >> 2] | 0) <= 2 : 0) {
                e = na(i) | 0;
                c = dd(e | 0, 0, 45) | 0;
                c = c | a;
                a = G() | 0 | d & -1040385;
                g = oa(i) | 0;
                if (!(la(e) | 0)) {
                    if ((g | 0) <= 0) break;
                    f = 0;
                    while(true){
                        e = cd(c | 0, a | 0, 52) | 0;
                        G();
                        e = e & 15;
                        if (e) {
                            d = 1;
                            while(true){
                                l = (15 - d | 0) * 3 | 0;
                                i = cd(c | 0, a | 0, l | 0) | 0;
                                G();
                                k = dd(7, 0, l | 0) | 0;
                                a = a & ~(G() | 0);
                                l = dd(Pa(i & 7) | 0, 0, l | 0) | 0;
                                c = c & ~k | l;
                                a = a | (G() | 0);
                                if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                                else break;
                            }
                        }
                        f = f + 1 | 0;
                        if ((f | 0) == (g | 0)) break a;
                    }
                }
                f = cd(c | 0, a | 0, 52) | 0;
                G();
                f = f & 15;
                b: do if (f) {
                    d = 1;
                    c: while(true){
                        l = cd(c | 0, a | 0, (15 - d | 0) * 3 | 0) | 0;
                        G();
                        switch(l & 7){
                            case 1:
                                break c;
                            case 0:
                                break;
                            default:
                                break b;
                        }
                        if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                        else break b;
                    }
                    if (ra(e, b[i >> 2] | 0) | 0) {
                        d = 1;
                        while(true){
                            i = (15 - d | 0) * 3 | 0;
                            k = dd(7, 0, i | 0) | 0;
                            l = a & ~(G() | 0);
                            a = cd(c | 0, a | 0, i | 0) | 0;
                            G();
                            a = dd(Qa(a & 7) | 0, 0, i | 0) | 0;
                            c = c & ~k | a;
                            a = l | (G() | 0);
                            if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                            else break;
                        }
                    } else {
                        d = 1;
                        while(true){
                            l = (15 - d | 0) * 3 | 0;
                            i = cd(c | 0, a | 0, l | 0) | 0;
                            G();
                            k = dd(7, 0, l | 0) | 0;
                            a = a & ~(G() | 0);
                            l = dd(Pa(i & 7) | 0, 0, l | 0) | 0;
                            c = c & ~k | l;
                            a = a | (G() | 0);
                            if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                            else break;
                        }
                    }
                }
                while (0);
                if ((g | 0) > 0) {
                    d = 0;
                    do {
                        c = Mb(c, a) | 0;
                        a = G() | 0;
                        d = d + 1 | 0;
                    }while ((d | 0) != (g | 0));
                }
            } else {
                c = 0;
                a = 0;
            }
            while (0);
            k = a;
            l = c;
            F(k | 0);
            S = j;
            return l | 0;
        }
        function Rb(a) {
            a = a | 0;
            return (a | 0) % 2 | 0;
        }
        function Sb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            e = S;
            S = S + 16 | 0;
            d = e;
            if ((c >>> 0 <= 15 ? !((b[a + 4 >> 2] & 2146435072 | 0) == 2146435072) : 0) ? !((b[a + 8 + 4 >> 2] & 2146435072 | 0) == 2146435072) : 0) {
                Ya(a, c, d);
                c = Qb(d, c) | 0;
                a = G() | 0;
            } else {
                a = 0;
                c = 0;
            }
            F(a | 0);
            S = e;
            return c | 0;
        }
        function Tb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            f = d + 4 | 0;
            g = cd(a | 0, c | 0, 52) | 0;
            G();
            g = g & 15;
            h = cd(a | 0, c | 0, 45) | 0;
            G();
            e = (g | 0) == 0;
            if (!(la(h & 127) | 0)) {
                if (e) {
                    h = 0;
                    return h | 0;
                }
                if ((b[f >> 2] | 0) == 0 ? (b[d + 8 >> 2] | 0) == 0 : 0) e = (b[d + 12 >> 2] | 0) != 0 & 1;
                else e = 1;
            } else if (e) {
                h = 1;
                return h | 0;
            } else e = 1;
            d = 1;
            while(true){
                if (!(d & 1)) La(f);
                else Ka(f);
                h = cd(a | 0, c | 0, (15 - d | 0) * 3 | 0) | 0;
                G();
                Ma(f, h & 7);
                if (d >>> 0 < g >>> 0) d = d + 1 | 0;
                else break;
            }
            return e | 0;
        }
        function Ub(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            l = S;
            S = S + 16 | 0;
            j = l;
            k = cd(a | 0, c | 0, 45) | 0;
            G();
            k = k & 127;
            a: do if ((la(k) | 0) != 0 ? (g = cd(a | 0, c | 0, 52) | 0, G(), g = g & 15, (g | 0) != 0) : 0) {
                e = 1;
                b: while(true){
                    i = cd(a | 0, c | 0, (15 - e | 0) * 3 | 0) | 0;
                    G();
                    switch(i & 7){
                        case 5:
                            break b;
                        case 0:
                            break;
                        default:
                            e = c;
                            break a;
                    }
                    if (e >>> 0 < g >>> 0) e = e + 1 | 0;
                    else {
                        e = c;
                        break a;
                    }
                }
                f = 1;
                e = c;
                while(true){
                    c = (15 - f | 0) * 3 | 0;
                    h = dd(7, 0, c | 0) | 0;
                    i = e & ~(G() | 0);
                    e = cd(a | 0, e | 0, c | 0) | 0;
                    G();
                    e = dd(Qa(e & 7) | 0, 0, c | 0) | 0;
                    a = a & ~h | e;
                    e = i | (G() | 0);
                    if (f >>> 0 < g >>> 0) f = f + 1 | 0;
                    else break;
                }
            } else e = c;
            while (0);
            i = 7728 + (k * 28 | 0) | 0;
            b[d >> 2] = b[i >> 2];
            b[d + 4 >> 2] = b[i + 4 >> 2];
            b[d + 8 >> 2] = b[i + 8 >> 2];
            b[d + 12 >> 2] = b[i + 12 >> 2];
            if (!(Tb(a, e, d) | 0)) {
                S = l;
                return;
            }
            h = d + 4 | 0;
            b[j >> 2] = b[h >> 2];
            b[j + 4 >> 2] = b[h + 4 >> 2];
            b[j + 8 >> 2] = b[h + 8 >> 2];
            g = cd(a | 0, e | 0, 52) | 0;
            G();
            i = g & 15;
            if (!(g & 1)) g = i;
            else {
                La(h);
                g = i + 1 | 0;
            }
            if (!(la(k) | 0)) e = 0;
            else {
                c: do if (!i) e = 0;
                else {
                    c = 1;
                    while(true){
                        f = cd(a | 0, e | 0, (15 - c | 0) * 3 | 0) | 0;
                        G();
                        f = f & 7;
                        if (f | 0) {
                            e = f;
                            break c;
                        }
                        if (c >>> 0 < i >>> 0) c = c + 1 | 0;
                        else {
                            e = 0;
                            break;
                        }
                    }
                }
                while (0);
                e = (e | 0) == 4 & 1;
            }
            if (!(cb(d, g, e, 0) | 0)) {
                if ((g | 0) != (i | 0)) {
                    b[h >> 2] = b[j >> 2];
                    b[h + 4 >> 2] = b[j + 4 >> 2];
                    b[h + 8 >> 2] = b[j + 8 >> 2];
                }
            } else {
                if (la(k) | 0) {
                    do ;
                    while ((cb(d, g, 0, 0) | 0) != 0);
                }
                if ((g | 0) != (i | 0)) Ja(h);
            }
            S = l;
            return;
        }
        function Vb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = S;
            S = S + 16 | 0;
            e = d;
            Ub(a, b, e);
            b = cd(a | 0, b | 0, 52) | 0;
            G();
            $a(e, b & 15, c);
            S = d;
            return;
        }
        function Wb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 16 | 0;
            f = g;
            Ub(a, b, f);
            d = cd(a | 0, b | 0, 45) | 0;
            G();
            d = (la(d & 127) | 0) == 0;
            e = cd(a | 0, b | 0, 52) | 0;
            G();
            e = e & 15;
            a: do if (!d) {
                if (e | 0) {
                    d = 1;
                    while(true){
                        h = dd(7, 0, (15 - d | 0) * 3 | 0) | 0;
                        if (!((h & a | 0) == 0 & ((G() | 0) & b | 0) == 0)) break a;
                        if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                        else break;
                    }
                }
                ab(f, e, 0, 5, c);
                S = g;
                return;
            }
            while (0);
            eb(f, e, 0, 6, c);
            S = g;
            return;
        }
        function Xb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            d = cd(a | 0, b | 0, 45) | 0;
            G();
            if (!(la(d & 127) | 0)) {
                d = 2;
                return d | 0;
            }
            d = cd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if (!d) {
                d = 5;
                return d | 0;
            }
            c = 1;
            while(true){
                e = dd(7, 0, (15 - c | 0) * 3 | 0) | 0;
                if (!((e & a | 0) == 0 & ((G() | 0) & b | 0) == 0)) {
                    c = 2;
                    a = 6;
                    break;
                }
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else {
                    c = 5;
                    a = 6;
                    break;
                }
            }
            if ((a | 0) == 6) return c | 0;
            return 0;
        }
        function Yb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            m = S;
            S = S + 128 | 0;
            k = m + 112 | 0;
            g = m + 96 | 0;
            l = m;
            f = cd(a | 0, c | 0, 52) | 0;
            G();
            i = f & 15;
            b[k >> 2] = i;
            h = cd(a | 0, c | 0, 45) | 0;
            G();
            h = h & 127;
            a: do if (la(h) | 0) {
                if (i | 0) {
                    e = 1;
                    while(true){
                        j = dd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        if (!((j & a | 0) == 0 & ((G() | 0) & c | 0) == 0)) {
                            f = 0;
                            break a;
                        }
                        if (e >>> 0 < i >>> 0) e = e + 1 | 0;
                        else break;
                    }
                }
                if (!(f & 1)) {
                    j = dd(i + 1 | 0, 0, 52) | 0;
                    l = G() | 0 | c & -15728641;
                    k = dd(7, 0, (14 - i | 0) * 3 | 0) | 0;
                    Yb((j | a) & ~k, l & ~(G() | 0), d);
                    S = m;
                    return;
                } else f = 1;
            } else f = 0;
            while (0);
            Ub(a, c, g);
            if (f) {
                bb(g, k, l);
                j = 5;
            } else {
                fb(g, k, l);
                j = 6;
            }
            b: do if (la(h) | 0) {
                if (!i) e = 20;
                else {
                    e = 1;
                    while(true){
                        h = dd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        if (!((h & a | 0) == 0 & ((G() | 0) & c | 0) == 0)) {
                            e = 8;
                            break b;
                        }
                        if (e >>> 0 < i >>> 0) e = e + 1 | 0;
                        else {
                            e = 20;
                            break;
                        }
                    }
                }
            } else e = 8;
            while (0);
            hd(d | 0, -1, e | 0);
            if (f) {
                f = 0;
                do {
                    g = l + (f << 4) | 0;
                    db(g, b[k >> 2] | 0);
                    g = b[g >> 2] | 0;
                    e = 0;
                    while(true){
                        h = d + (e << 2) | 0;
                        i = b[h >> 2] | 0;
                        if ((i | 0) == -1 | (i | 0) == (g | 0)) break;
                        else e = e + 1 | 0;
                    }
                    b[h >> 2] = g;
                    f = f + 1 | 0;
                }while ((f | 0) != (j | 0));
            } else {
                f = 0;
                do {
                    g = l + (f << 4) | 0;
                    cb(g, b[k >> 2] | 0, 0, 1);
                    g = b[g >> 2] | 0;
                    e = 0;
                    while(true){
                        h = d + (e << 2) | 0;
                        i = b[h >> 2] | 0;
                        if ((i | 0) == -1 | (i | 0) == (g | 0)) break;
                        else e = e + 1 | 0;
                    }
                    b[h >> 2] = g;
                    f = f + 1 | 0;
                }while ((f | 0) != (j | 0));
            }
            S = m;
            return;
        }
        function Zb() {
            return 12;
        }
        function _b(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            dd(a | 0, 0, 52);
            i = G() | 134225919;
            if ((a | 0) < 1) {
                e = 0;
                d = 0;
                do {
                    if (la(e) | 0) {
                        dd(e | 0, 0, 45);
                        h = i | (G() | 0);
                        a = c + (d << 3) | 0;
                        b[a >> 2] = -1;
                        b[a + 4 >> 2] = h;
                        d = d + 1 | 0;
                    }
                    e = e + 1 | 0;
                }while ((e | 0) != 122);
                return;
            }
            h = 0;
            d = 0;
            do {
                if (la(h) | 0) {
                    dd(h | 0, 0, 45);
                    e = 1;
                    f = -1;
                    g = i | (G() | 0);
                    while(true){
                        j = dd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        f = f & ~j;
                        g = g & ~(G() | 0);
                        if ((e | 0) == (a | 0)) break;
                        else e = e + 1 | 0;
                    }
                    j = c + (d << 3) | 0;
                    b[j >> 2] = f;
                    b[j + 4 >> 2] = g;
                    d = d + 1 | 0;
                }
                h = h + 1 | 0;
            }while ((h | 0) != 122);
            return;
        }
        function $b(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            i = S;
            S = S + 64 | 0;
            h = i;
            if ((a | 0) == (d | 0) & (c | 0) == (e | 0) | (false | (c & 2013265920 | 0) != 134217728 | (false | (e & 2013265920 | 0) != 134217728))) {
                h = 0;
                S = i;
                return h | 0;
            }
            f = cd(a | 0, c | 0, 52) | 0;
            G();
            f = f & 15;
            g = cd(d | 0, e | 0, 52) | 0;
            G();
            if ((f | 0) != (g & 15 | 0)) {
                h = 0;
                S = i;
                return h | 0;
            }
            g = f + -1 | 0;
            if (f >>> 0 > 1 ? (k = Cb(a, c, g) | 0, j = G() | 0, g = Cb(d, e, g) | 0, (k | 0) == (g | 0) & (j | 0) == (G() | 0)) : 0) {
                g = (f ^ 15) * 3 | 0;
                f = cd(a | 0, c | 0, g | 0) | 0;
                G();
                f = f & 7;
                g = cd(d | 0, e | 0, g | 0) | 0;
                G();
                g = g & 7;
                if ((f | 0) == 0 | (g | 0) == 0) {
                    k = 1;
                    S = i;
                    return k | 0;
                }
                if ((b[21136 + (f << 2) >> 2] | 0) == (g | 0)) {
                    k = 1;
                    S = i;
                    return k | 0;
                }
                if ((b[21168 + (f << 2) >> 2] | 0) == (g | 0)) {
                    k = 1;
                    S = i;
                    return k | 0;
                }
            }
            f = h;
            g = f + 56 | 0;
            do {
                b[f >> 2] = 0;
                f = f + 4 | 0;
            }while ((f | 0) < (g | 0));
            $(a, c, 1, h);
            k = h;
            if (((((!((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0) ? (k = h + 8 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 16 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 24 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 32 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 40 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) {
                f = h + 48 | 0;
                f = ((b[f >> 2] | 0) == (d | 0) ? (b[f + 4 >> 2] | 0) == (e | 0) : 0) & 1;
            } else f = 1;
            k = f;
            S = i;
            return k | 0;
        }
        function ac(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            k = S;
            S = S + 16 | 0;
            h = k;
            if (!($b(a, c, d, e) | 0)) {
                i = 0;
                j = 0;
                F(i | 0);
                S = k;
                return j | 0;
            }
            i = c & -2130706433;
            f = (Fb(a, c) | 0) == 0;
            f = f ? 1 : 2;
            while(true){
                b[h >> 2] = 0;
                l = da(a, c, f, h) | 0;
                g = f + 1 | 0;
                if ((l | 0) == (d | 0) & (G() | 0) == (e | 0)) break;
                if (g >>> 0 < 7) f = g;
                else {
                    f = 0;
                    a = 0;
                    j = 6;
                    break;
                }
            }
            if ((j | 0) == 6) {
                F(f | 0);
                S = k;
                return a | 0;
            }
            l = dd(f | 0, 0, 56) | 0;
            j = i | (G() | 0) | 268435456;
            l = a | l;
            F(j | 0);
            S = k;
            return l | 0;
        }
        function bc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            c = true & (b & 2013265920 | 0) == 268435456;
            F((c ? b & -2130706433 | 134217728 : 0) | 0);
            return (c ? a : 0) | 0;
        }
        function cc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0;
            e = S;
            S = S + 16 | 0;
            d = e;
            if (!(true & (c & 2013265920 | 0) == 268435456)) {
                c = 0;
                d = 0;
                F(c | 0);
                S = e;
                return d | 0;
            }
            f = cd(a | 0, c | 0, 56) | 0;
            G();
            b[d >> 2] = 0;
            d = da(a, c & -2130706433 | 134217728, f & 7, d) | 0;
            c = G() | 0;
            F(c | 0);
            S = e;
            return d | 0;
        }
        function dc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            if (!(true & (b & 2013265920 | 0) == 268435456)) {
                c = 0;
                return c | 0;
            }
            c = cd(a | 0, b | 0, 56) | 0;
            G();
            switch(c & 7){
                case 0:
                case 7:
                    c = 0;
                    return c | 0;
                default:
            }
            c = b & -2130706433 | 134217728;
            if (true & (b & 117440512 | 0) == 16777216 & (Fb(a, c) | 0) != 0) {
                c = 0;
                return c | 0;
            }
            c = Bb(a, c) | 0;
            return c | 0;
        }
        function ec(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            g = S;
            S = S + 16 | 0;
            e = g;
            h = true & (c & 2013265920 | 0) == 268435456;
            f = c & -2130706433 | 134217728;
            i = d;
            b[i >> 2] = h ? a : 0;
            b[i + 4 >> 2] = h ? f : 0;
            if (h) {
                c = cd(a | 0, c | 0, 56) | 0;
                G();
                b[e >> 2] = 0;
                a = da(a, f, c & 7, e) | 0;
                c = G() | 0;
            } else {
                a = 0;
                c = 0;
            }
            i = d + 8 | 0;
            b[i >> 2] = a;
            b[i + 4 >> 2] = c;
            S = g;
            return;
        }
        function fc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            f = (Fb(a, c) | 0) == 0;
            c = c & -2130706433;
            e = d;
            b[e >> 2] = f ? a : 0;
            b[e + 4 >> 2] = f ? c | 285212672 : 0;
            e = d + 8 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 301989888;
            e = d + 16 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 318767104;
            e = d + 24 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 335544320;
            e = d + 32 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 352321536;
            d = d + 40 | 0;
            b[d >> 2] = a;
            b[d + 4 >> 2] = c | 369098752;
            return;
        }
        function gc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            h = S;
            S = S + 16 | 0;
            g = h;
            e = cd(a | 0, c | 0, 56) | 0;
            G();
            i = true & (c & 2013265920 | 0) == 268435456;
            f = i ? a : 0;
            a = i ? c & -2130706433 | 134217728 : 0;
            c = Lc(f, a, e & 7) | 0;
            if ((c | 0) == -1) {
                b[d >> 2] = 0;
                S = h;
                return;
            }
            Ub(f, a, g);
            e = cd(f | 0, a | 0, 52) | 0;
            G();
            e = e & 15;
            if (!(Fb(f, a) | 0)) eb(g, e, c, 2, d);
            else ab(g, e, c, 2, d);
            S = h;
            return;
        }
        function hc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            c = Yc(1, 12) | 0;
            if (!c) H(22691, 22646, 49, 22704);
            d = a + 4 | 0;
            e = b[d >> 2] | 0;
            if (e | 0) {
                e = e + 8 | 0;
                b[e >> 2] = c;
                b[d >> 2] = c;
                return c | 0;
            }
            if (b[a >> 2] | 0) H(22721, 22646, 61, 22744);
            e = a;
            b[e >> 2] = c;
            b[d >> 2] = c;
            return c | 0;
        }
        function ic(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            e = Wc(24) | 0;
            if (!e) H(22758, 22646, 78, 22772);
            b[e >> 2] = b[c >> 2];
            b[e + 4 >> 2] = b[c + 4 >> 2];
            b[e + 8 >> 2] = b[c + 8 >> 2];
            b[e + 12 >> 2] = b[c + 12 >> 2];
            b[e + 16 >> 2] = 0;
            c = a + 4 | 0;
            d = b[c >> 2] | 0;
            if (d | 0) {
                b[d + 16 >> 2] = e;
                b[c >> 2] = e;
                return e | 0;
            }
            if (b[a >> 2] | 0) H(22787, 22646, 82, 22772);
            b[a >> 2] = e;
            b[c >> 2] = e;
            return e | 0;
        }
        function jc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0;
            if (!a) return;
            e = 1;
            while(true){
                c = b[a >> 2] | 0;
                if (c | 0) do {
                    d = b[c >> 2] | 0;
                    if (d | 0) do {
                        f = d;
                        d = b[d + 16 >> 2] | 0;
                        Xc(f);
                    }while ((d | 0) != 0);
                    f = c;
                    c = b[c + 8 >> 2] | 0;
                    Xc(f);
                }while ((c | 0) != 0);
                c = a;
                a = b[a + 8 >> 2] | 0;
                if (!e) Xc(c);
                if (!a) break;
                else e = 0;
            }
            return;
        }
        function kc(a) {
            a = a | 0;
            var c = 0, d = 0, f = 0, g = 0, h = 0.0, i = 0, j = 0.0, k = 0.0, l = 0, m = 0, n = 0, o = 0, p = 0, r = 0, s = 0.0, t = 0.0, u = 0.0, v = 0.0, w = 0.0, x = 0.0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, I = 0, J = 0, K = 0;
            g = a + 8 | 0;
            if (b[g >> 2] | 0) {
                K = 1;
                return K | 0;
            }
            f = b[a >> 2] | 0;
            if (!f) {
                K = 0;
                return K | 0;
            }
            c = f;
            d = 0;
            do {
                d = d + 1 | 0;
                c = b[c + 8 >> 2] | 0;
            }while ((c | 0) != 0);
            if (d >>> 0 < 2) {
                K = 0;
                return K | 0;
            }
            I = Wc(d << 2) | 0;
            if (!I) H(22807, 22646, 317, 22826);
            G = Wc(d << 5) | 0;
            if (!G) H(22848, 22646, 321, 22826);
            b[a >> 2] = 0;
            z = a + 4 | 0;
            b[z >> 2] = 0;
            b[g >> 2] = 0;
            d = 0;
            F = 0;
            y = 0;
            n = 0;
            a: while(true){
                m = b[f >> 2] | 0;
                if (m) {
                    h = 0.0;
                    i = m;
                    do {
                        k = +e[i + 8 >> 3];
                        c = i;
                        i = b[i + 16 >> 2] | 0;
                        l = (i | 0) == 0;
                        g = l ? m : i;
                        j = +e[g + 8 >> 3];
                        if (+q(+(k - j)) > 3.141592653589793) {
                            K = 14;
                            break;
                        }
                        h = h + (j - k) * (+e[c >> 3] + +e[g >> 3]);
                    }while (!l);
                    if ((K | 0) == 14) {
                        K = 0;
                        h = 0.0;
                        c = m;
                        do {
                            x = +e[c + 8 >> 3];
                            E = c + 16 | 0;
                            D = b[E >> 2] | 0;
                            D = (D | 0) == 0 ? m : D;
                            w = +e[D + 8 >> 3];
                            h = h + (+e[c >> 3] + +e[D >> 3]) * ((w < 0.0 ? w + 6.283185307179586 : w) - (x < 0.0 ? x + 6.283185307179586 : x));
                            c = b[((c | 0) == 0 ? f : E) >> 2] | 0;
                        }while ((c | 0) != 0);
                    }
                    if (h > 0.0) {
                        b[I + (F << 2) >> 2] = f;
                        F = F + 1 | 0;
                        g = y;
                        c = n;
                    } else K = 19;
                } else K = 19;
                if ((K | 0) == 19) {
                    K = 0;
                    do if (!d) {
                        if (!n) {
                            if (!(b[a >> 2] | 0)) {
                                g = z;
                                i = a;
                                c = f;
                                d = a;
                                break;
                            } else {
                                K = 27;
                                break a;
                            }
                        } else {
                            g = z;
                            i = n + 8 | 0;
                            c = f;
                            d = a;
                            break;
                        }
                    } else {
                        c = d + 8 | 0;
                        if (b[c >> 2] | 0) {
                            K = 21;
                            break a;
                        }
                        d = Yc(1, 12) | 0;
                        if (!d) {
                            K = 23;
                            break a;
                        }
                        b[c >> 2] = d;
                        g = d + 4 | 0;
                        i = d;
                        c = n;
                    }
                    while (0);
                    b[i >> 2] = f;
                    b[g >> 2] = f;
                    i = G + (y << 5) | 0;
                    l = b[f >> 2] | 0;
                    if (l) {
                        m = G + (y << 5) + 8 | 0;
                        e[m >> 3] = 1797693134862315708145274.0e284;
                        n = G + (y << 5) + 24 | 0;
                        e[n >> 3] = 1797693134862315708145274.0e284;
                        e[i >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        o = G + (y << 5) + 16 | 0;
                        e[o >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        u = 1797693134862315708145274.0e284;
                        v = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        g = 0;
                        p = l;
                        k = 1797693134862315708145274.0e284;
                        s = 1797693134862315708145274.0e284;
                        t = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        j = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        while(true){
                            h = +e[p >> 3];
                            x = +e[p + 8 >> 3];
                            p = b[p + 16 >> 2] | 0;
                            r = (p | 0) == 0;
                            w = +e[(r ? l : p) + 8 >> 3];
                            if (h < k) {
                                e[m >> 3] = h;
                                k = h;
                            }
                            if (x < s) {
                                e[n >> 3] = x;
                                s = x;
                            }
                            if (h > t) e[i >> 3] = h;
                            else h = t;
                            if (x > j) {
                                e[o >> 3] = x;
                                j = x;
                            }
                            u = x > 0.0 & x < u ? x : u;
                            v = x < 0.0 & x > v ? x : v;
                            g = g | +q(+(x - w)) > 3.141592653589793;
                            if (r) break;
                            else t = h;
                        }
                        if (g) {
                            e[o >> 3] = v;
                            e[n >> 3] = u;
                        }
                    } else {
                        b[i >> 2] = 0;
                        b[i + 4 >> 2] = 0;
                        b[i + 8 >> 2] = 0;
                        b[i + 12 >> 2] = 0;
                        b[i + 16 >> 2] = 0;
                        b[i + 20 >> 2] = 0;
                        b[i + 24 >> 2] = 0;
                        b[i + 28 >> 2] = 0;
                    }
                    g = y + 1 | 0;
                }
                E = f + 8 | 0;
                f = b[E >> 2] | 0;
                b[E >> 2] = 0;
                if (!f) {
                    K = 45;
                    break;
                } else {
                    y = g;
                    n = c;
                }
            }
            if ((K | 0) == 21) H(22624, 22646, 35, 22658);
            else if ((K | 0) == 23) H(22678, 22646, 37, 22658);
            else if ((K | 0) == 27) H(22721, 22646, 61, 22744);
            else if ((K | 0) == 45) {
                b: do if ((F | 0) > 0) {
                    E = (g | 0) == 0;
                    C = g << 2;
                    D = (a | 0) == 0;
                    B = 0;
                    c = 0;
                    while(true){
                        A = b[I + (B << 2) >> 2] | 0;
                        if (!E) {
                            y = Wc(C) | 0;
                            if (!y) {
                                K = 50;
                                break;
                            }
                            z = Wc(C) | 0;
                            if (!z) {
                                K = 52;
                                break;
                            }
                            c: do if (!D) {
                                g = 0;
                                d = 0;
                                i = a;
                                while(true){
                                    f = G + (g << 5) | 0;
                                    if (lc(b[i >> 2] | 0, f, b[A >> 2] | 0) | 0) {
                                        b[y + (d << 2) >> 2] = i;
                                        b[z + (d << 2) >> 2] = f;
                                        r = d + 1 | 0;
                                    } else r = d;
                                    i = b[i + 8 >> 2] | 0;
                                    if (!i) break;
                                    else {
                                        g = g + 1 | 0;
                                        d = r;
                                    }
                                }
                                if ((r | 0) > 0) {
                                    f = b[y >> 2] | 0;
                                    if ((r | 0) == 1) d = f;
                                    else {
                                        o = 0;
                                        p = -1;
                                        d = f;
                                        n = f;
                                        while(true){
                                            l = b[n >> 2] | 0;
                                            f = 0;
                                            i = 0;
                                            while(true){
                                                g = b[b[y + (i << 2) >> 2] >> 2] | 0;
                                                if ((g | 0) == (l | 0)) m = f;
                                                else m = f + ((lc(g, b[z + (i << 2) >> 2] | 0, b[l >> 2] | 0) | 0) & 1) | 0;
                                                i = i + 1 | 0;
                                                if ((i | 0) == (r | 0)) break;
                                                else f = m;
                                            }
                                            g = (m | 0) > (p | 0);
                                            d = g ? n : d;
                                            f = o + 1 | 0;
                                            if ((f | 0) == (r | 0)) break c;
                                            o = f;
                                            p = g ? m : p;
                                            n = b[y + (f << 2) >> 2] | 0;
                                        }
                                    }
                                } else d = 0;
                            } else d = 0;
                            while (0);
                            Xc(y);
                            Xc(z);
                            if (d) {
                                g = d + 4 | 0;
                                f = b[g >> 2] | 0;
                                if (!f) {
                                    if (b[d >> 2] | 0) {
                                        K = 70;
                                        break;
                                    }
                                } else d = f + 8 | 0;
                                b[d >> 2] = A;
                                b[g >> 2] = A;
                            } else K = 73;
                        } else K = 73;
                        if ((K | 0) == 73) {
                            K = 0;
                            c = b[A >> 2] | 0;
                            if (c | 0) do {
                                z = c;
                                c = b[c + 16 >> 2] | 0;
                                Xc(z);
                            }while ((c | 0) != 0);
                            Xc(A);
                            c = 2;
                        }
                        B = B + 1 | 0;
                        if ((B | 0) >= (F | 0)) {
                            J = c;
                            break b;
                        }
                    }
                    if ((K | 0) == 50) H(22863, 22646, 249, 22882);
                    else if ((K | 0) == 52) H(22901, 22646, 252, 22882);
                    else if ((K | 0) == 70) H(22721, 22646, 61, 22744);
                } else J = 0;
                while (0);
                Xc(I);
                Xc(G);
                K = J;
                return K | 0;
            }
            return 0;
        }
        function lc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0;
            if (!(xa(c, d) | 0)) {
                a = 0;
                return a | 0;
            }
            c = wa(c) | 0;
            l = +e[d >> 3];
            f = +e[d + 8 >> 3];
            f = c & f < 0.0 ? f + 6.283185307179586 : f;
            a = b[a >> 2] | 0;
            if (!a) {
                a = 0;
                return a | 0;
            }
            if (c) {
                c = 0;
                d = a;
                a: while(true){
                    while(true){
                        i = +e[d >> 3];
                        k = +e[d + 8 >> 3];
                        d = d + 16 | 0;
                        m = b[d >> 2] | 0;
                        m = (m | 0) == 0 ? a : m;
                        h = +e[m >> 3];
                        g = +e[m + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(l < h | l > j)) break;
                        d = b[d >> 2] | 0;
                        if (!d) {
                            d = 22;
                            break a;
                        }
                    }
                    k = g < 0.0 ? g + 6.283185307179586 : g;
                    i = i < 0.0 ? i + 6.283185307179586 : i;
                    f = i == f | k == f ? f + -0.0000000000000002220446049250313 : f;
                    k = k + (l - h) / (j - h) * (i - k);
                    if ((k < 0.0 ? k + 6.283185307179586 : k) > f) c = c ^ 1;
                    d = b[d >> 2] | 0;
                    if (!d) {
                        d = 22;
                        break;
                    }
                }
                if ((d | 0) == 22) return c | 0;
            } else {
                c = 0;
                d = a;
                b: while(true){
                    while(true){
                        i = +e[d >> 3];
                        k = +e[d + 8 >> 3];
                        d = d + 16 | 0;
                        m = b[d >> 2] | 0;
                        m = (m | 0) == 0 ? a : m;
                        h = +e[m >> 3];
                        g = +e[m + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(l < h | l > j)) break;
                        d = b[d >> 2] | 0;
                        if (!d) {
                            d = 22;
                            break b;
                        }
                    }
                    f = i == f | g == f ? f + -0.0000000000000002220446049250313 : f;
                    if (g + (l - h) / (j - h) * (i - g) > f) c = c ^ 1;
                    d = b[d >> 2] | 0;
                    if (!d) {
                        d = 22;
                        break;
                    }
                }
                if ((d | 0) == 22) return c | 0;
            }
            return 0;
        }
        function mc(c, d, e, f, g) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0;
            u = S;
            S = S + 32 | 0;
            t = u + 16 | 0;
            s = u;
            h = cd(c | 0, d | 0, 52) | 0;
            G();
            h = h & 15;
            p = cd(e | 0, f | 0, 52) | 0;
            G();
            if ((h | 0) != (p & 15 | 0)) {
                t = 1;
                S = u;
                return t | 0;
            }
            l = cd(c | 0, d | 0, 45) | 0;
            G();
            l = l & 127;
            m = cd(e | 0, f | 0, 45) | 0;
            G();
            m = m & 127;
            p = (l | 0) != (m | 0);
            if (p) {
                j = ta(l, m) | 0;
                if ((j | 0) == 7) {
                    t = 2;
                    S = u;
                    return t | 0;
                }
                k = ta(m, l) | 0;
                if ((k | 0) == 7) H(22925, 22949, 151, 22959);
                else {
                    q = j;
                    i = k;
                }
            } else {
                q = 0;
                i = 0;
            }
            n = la(l) | 0;
            o = la(m) | 0;
            b[t >> 2] = 0;
            b[t + 4 >> 2] = 0;
            b[t + 8 >> 2] = 0;
            b[t + 12 >> 2] = 0;
            do if (!q) {
                Tb(e, f, t);
                if ((n | 0) != 0 & (o | 0) != 0) {
                    if ((m | 0) != (l | 0)) H(23077, 22949, 243, 22959);
                    i = Lb(c, d) | 0;
                    h = Lb(e, f) | 0;
                    if (!(a[22032 + (i * 7 | 0) + h >> 0] | 0)) {
                        i = b[21200 + (i * 28 | 0) + (h << 2) >> 2] | 0;
                        if ((i | 0) > 0) {
                            j = t + 4 | 0;
                            h = 0;
                            do {
                                Oa(j);
                                h = h + 1 | 0;
                            }while ((h | 0) != (i | 0));
                            r = 50;
                        } else r = 50;
                    } else h = 5;
                } else r = 50;
            } else {
                m = b[4304 + (l * 28 | 0) + (q << 2) >> 2] | 0;
                j = (m | 0) > 0;
                if (!o) {
                    if (j) {
                        l = 0;
                        k = e;
                        j = f;
                        do {
                            k = Pb(k, j) | 0;
                            j = G() | 0;
                            i = Qa(i) | 0;
                            l = l + 1 | 0;
                        }while ((l | 0) != (m | 0));
                        m = i;
                        l = k;
                        k = j;
                    } else {
                        m = i;
                        l = e;
                        k = f;
                    }
                } else if (j) {
                    l = 0;
                    k = e;
                    j = f;
                    do {
                        k = Ob(k, j) | 0;
                        j = G() | 0;
                        i = Qa(i) | 0;
                        if ((i | 0) == 1) i = Qa(1) | 0;
                        l = l + 1 | 0;
                    }while ((l | 0) != (m | 0));
                    m = i;
                    l = k;
                    k = j;
                } else {
                    m = i;
                    l = e;
                    k = f;
                }
                Tb(l, k, t);
                if (!p) H(22972, 22949, 181, 22959);
                j = (n | 0) != 0;
                i = (o | 0) != 0;
                if (j & i) H(22999, 22949, 182, 22959);
                if (!j) {
                    if (i) {
                        i = Lb(l, k) | 0;
                        if (a[22032 + (i * 7 | 0) + m >> 0] | 0) {
                            h = 4;
                            break;
                        }
                        l = 0;
                        k = b[21200 + (m * 28 | 0) + (i << 2) >> 2] | 0;
                        r = 26;
                    } else i = 0;
                } else {
                    i = Lb(c, d) | 0;
                    if (a[22032 + (i * 7 | 0) + q >> 0] | 0) {
                        h = 3;
                        break;
                    }
                    k = b[21200 + (i * 28 | 0) + (q << 2) >> 2] | 0;
                    l = k;
                    r = 26;
                }
                if ((r | 0) == 26) {
                    if ((k | 0) <= -1) H(23030, 22949, 212, 22959);
                    if ((l | 0) <= -1) H(23053, 22949, 213, 22959);
                    if ((k | 0) > 0) {
                        j = t + 4 | 0;
                        i = 0;
                        do {
                            Oa(j);
                            i = i + 1 | 0;
                        }while ((i | 0) != (k | 0));
                        i = l;
                    } else i = l;
                }
                b[s >> 2] = 0;
                b[s + 4 >> 2] = 0;
                b[s + 8 >> 2] = 0;
                Ma(s, q);
                if (h | 0) while(true){
                    if (!(Rb(h) | 0)) La(s);
                    else Ka(s);
                    if ((h | 0) > 1) h = h + -1 | 0;
                    else break;
                }
                if ((i | 0) > 0) {
                    h = 0;
                    do {
                        Oa(s);
                        h = h + 1 | 0;
                    }while ((h | 0) != (i | 0));
                }
                r = t + 4 | 0;
                Ea(r, s, r);
                Ca(r);
                r = 50;
            }
            while (0);
            if ((r | 0) == 50) {
                h = t + 4 | 0;
                b[g >> 2] = b[h >> 2];
                b[g + 4 >> 2] = b[h + 4 >> 2];
                b[g + 8 >> 2] = b[h + 8 >> 2];
                h = 0;
            }
            t = h;
            S = u;
            return t | 0;
        }
        function nc(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
            p = S;
            S = S + 48 | 0;
            h = p + 36 | 0;
            i = p + 24 | 0;
            j = p + 12 | 0;
            k = p;
            g = cd(a | 0, c | 0, 52) | 0;
            G();
            g = g & 15;
            n = cd(a | 0, c | 0, 45) | 0;
            G();
            n = n & 127;
            l = la(n) | 0;
            dd(g | 0, 0, 52);
            r = G() | 134225919;
            q = e;
            b[q >> 2] = -1;
            b[q + 4 >> 2] = r;
            if (!g) {
                if ((b[d >> 2] | 0) > 1) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                if ((b[d + 4 >> 2] | 0) > 1) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                if ((b[d + 8 >> 2] | 0) > 1) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                f = sa(n, Ha(d) | 0) | 0;
                if ((f | 0) == 127) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                o = dd(f | 0, 0, 45) | 0;
                q = G() | 0;
                n = e;
                q = b[n + 4 >> 2] & -1040385 | q;
                r = e;
                b[r >> 2] = b[n >> 2] | o;
                b[r + 4 >> 2] = q;
                r = 0;
                S = p;
                return r | 0;
            }
            b[h >> 2] = b[d >> 2];
            b[h + 4 >> 2] = b[d + 4 >> 2];
            b[h + 8 >> 2] = b[d + 8 >> 2];
            while(true){
                b[i >> 2] = b[h >> 2];
                b[i + 4 >> 2] = b[h + 4 >> 2];
                b[i + 8 >> 2] = b[h + 8 >> 2];
                if (!(Rb(g) | 0)) {
                    Ja(h);
                    b[j >> 2] = b[h >> 2];
                    b[j + 4 >> 2] = b[h + 4 >> 2];
                    b[j + 8 >> 2] = b[h + 8 >> 2];
                    La(j);
                } else {
                    Ia(h);
                    b[j >> 2] = b[h >> 2];
                    b[j + 4 >> 2] = b[h + 4 >> 2];
                    b[j + 8 >> 2] = b[h + 8 >> 2];
                    Ka(j);
                }
                Fa(i, j, k);
                Ca(k);
                q = e;
                s = b[q >> 2] | 0;
                q = b[q + 4 >> 2] | 0;
                t = (15 - g | 0) * 3 | 0;
                d = dd(7, 0, t | 0) | 0;
                q = q & ~(G() | 0);
                t = dd(Ha(k) | 0, 0, t | 0) | 0;
                q = G() | 0 | q;
                r = e;
                b[r >> 2] = t | s & ~d;
                b[r + 4 >> 2] = q;
                if ((g | 0) > 1) g = g + -1 | 0;
                else break;
            }
            a: do if (((b[h >> 2] | 0) <= 1 ? (b[h + 4 >> 2] | 0) <= 1 : 0) ? (b[h + 8 >> 2] | 0) <= 1 : 0) {
                g = Ha(h) | 0;
                i = sa(n, g) | 0;
                if ((i | 0) == 127) k = 0;
                else k = la(i) | 0;
                b: do if (!g) {
                    if ((l | 0) != 0 & (k | 0) != 0) {
                        t = Lb(a, c) | 0;
                        g = e;
                        g = 21408 + (t * 28 | 0) + ((Lb(b[g >> 2] | 0, b[g + 4 >> 2] | 0) | 0) << 2) | 0;
                        g = b[g >> 2] | 0;
                        if ((g | 0) <= -1) H(23201, 22949, 433, 23134);
                        if (!g) {
                            f = i;
                            g = 55;
                        } else {
                            h = e;
                            f = 0;
                            d = b[h >> 2] | 0;
                            h = b[h + 4 >> 2] | 0;
                            do {
                                d = Nb(d, h) | 0;
                                h = G() | 0;
                                t = e;
                                b[t >> 2] = d;
                                b[t + 4 >> 2] = h;
                                f = f + 1 | 0;
                            }while ((f | 0) < (g | 0));
                            f = i;
                            g = 54;
                        }
                    } else {
                        f = i;
                        g = 54;
                    }
                } else {
                    if (l) {
                        h = 21408 + ((Lb(a, c) | 0) * 28 | 0) + (g << 2) | 0;
                        h = b[h >> 2] | 0;
                        if ((h | 0) > 0) {
                            d = 0;
                            do {
                                g = Pa(g) | 0;
                                d = d + 1 | 0;
                            }while ((d | 0) != (h | 0));
                        }
                        if ((g | 0) == 1) {
                            f = 3;
                            break a;
                        }
                        d = sa(n, g) | 0;
                        if ((d | 0) == 127) H(23104, 22949, 376, 23134);
                        if (!(la(d) | 0)) {
                            o = h;
                            m = g;
                            f = d;
                        } else H(23147, 22949, 377, 23134);
                    } else {
                        o = 0;
                        m = g;
                        f = i;
                    }
                    j = b[4304 + (n * 28 | 0) + (m << 2) >> 2] | 0;
                    if ((j | 0) <= -1) H(23178, 22949, 384, 23134);
                    if (!k) {
                        if ((o | 0) <= -1) H(23030, 22949, 417, 23134);
                        if (o | 0) {
                            h = e;
                            g = 0;
                            d = b[h >> 2] | 0;
                            h = b[h + 4 >> 2] | 0;
                            do {
                                d = Nb(d, h) | 0;
                                h = G() | 0;
                                t = e;
                                b[t >> 2] = d;
                                b[t + 4 >> 2] = h;
                                g = g + 1 | 0;
                            }while ((g | 0) < (o | 0));
                        }
                        if ((j | 0) <= 0) {
                            g = 54;
                            break;
                        }
                        h = e;
                        g = 0;
                        d = b[h >> 2] | 0;
                        h = b[h + 4 >> 2] | 0;
                        while(true){
                            d = Nb(d, h) | 0;
                            h = G() | 0;
                            t = e;
                            b[t >> 2] = d;
                            b[t + 4 >> 2] = h;
                            g = g + 1 | 0;
                            if ((g | 0) == (j | 0)) {
                                g = 54;
                                break b;
                            }
                        }
                    }
                    i = ta(f, n) | 0;
                    if ((i | 0) == 7) H(22925, 22949, 393, 23134);
                    g = e;
                    d = b[g >> 2] | 0;
                    g = b[g + 4 >> 2] | 0;
                    if ((j | 0) > 0) {
                        h = 0;
                        do {
                            d = Nb(d, g) | 0;
                            g = G() | 0;
                            t = e;
                            b[t >> 2] = d;
                            b[t + 4 >> 2] = g;
                            h = h + 1 | 0;
                        }while ((h | 0) != (j | 0));
                    }
                    d = Lb(d, g) | 0;
                    t = ma(f) | 0;
                    d = b[(t ? 21824 : 21616) + (i * 28 | 0) + (d << 2) >> 2] | 0;
                    if ((d | 0) <= -1) H(23030, 22949, 412, 23134);
                    if (!d) g = 54;
                    else {
                        i = e;
                        g = 0;
                        h = b[i >> 2] | 0;
                        i = b[i + 4 >> 2] | 0;
                        do {
                            h = Mb(h, i) | 0;
                            i = G() | 0;
                            t = e;
                            b[t >> 2] = h;
                            b[t + 4 >> 2] = i;
                            g = g + 1 | 0;
                        }while ((g | 0) < (d | 0));
                        g = 54;
                    }
                }
                while (0);
                if ((g | 0) == 54) {
                    if (k) g = 55;
                }
                if ((g | 0) == 55) {
                    t = e;
                    if ((Lb(b[t >> 2] | 0, b[t + 4 >> 2] | 0) | 0) == 1) {
                        f = 4;
                        break;
                    }
                }
                t = e;
                r = b[t >> 2] | 0;
                t = b[t + 4 >> 2] & -1040385;
                s = dd(f | 0, 0, 45) | 0;
                t = t | (G() | 0);
                f = e;
                b[f >> 2] = r | s;
                b[f + 4 >> 2] = t;
                f = 0;
            } else f = 2;
            while (0);
            t = f;
            S = p;
            return t | 0;
        }
        function oc(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = S;
            S = S + 16 | 0;
            f = g;
            a = mc(a, b, c, d, f) | 0;
            if (!a) {
                Ua(f, e);
                a = 0;
            }
            S = g;
            return a | 0;
        }
        function pc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = S;
            S = S + 16 | 0;
            f = e;
            Va(c, f);
            d = nc(a, b, f, d) | 0;
            S = e;
            return d | 0;
        }
        function qc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = S;
            S = S + 32 | 0;
            e = g + 12 | 0;
            f = g;
            if ((mc(a, b, a, b, e) | 0) == 0 ? (mc(a, b, c, d, f) | 0) == 0 : 0) a = Ta(e, f) | 0;
            else a = -1;
            S = g;
            return a | 0;
        }
        function rc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = S;
            S = S + 32 | 0;
            e = g + 12 | 0;
            f = g;
            if ((mc(a, b, a, b, e) | 0) == 0 ? (mc(a, b, c, d, f) | 0) == 0 : 0) a = Ta(e, f) | 0;
            else a = -1;
            S = g;
            return (a >>> 31 ^ 1) + a | 0;
        }
        function sc(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0.0, j = 0.0, k = 0, l = 0, m = 0, n = 0, o = 0.0, p = 0.0, r = 0.0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0.0;
            x = S;
            S = S + 48 | 0;
            g = x + 24 | 0;
            h = x + 12 | 0;
            w = x;
            if ((mc(a, c, a, c, g) | 0) == 0 ? (mc(a, c, d, e, h) | 0) == 0 : 0) {
                v = Ta(g, h) | 0;
                if ((v | 0) < 0) {
                    w = v;
                    S = x;
                    return w | 0;
                }
                b[g >> 2] = 0;
                b[g + 4 >> 2] = 0;
                b[g + 8 >> 2] = 0;
                b[h >> 2] = 0;
                b[h + 4 >> 2] = 0;
                b[h + 8 >> 2] = 0;
                mc(a, c, a, c, g);
                mc(a, c, d, e, h);
                Wa(g);
                Wa(h);
                if (!v) {
                    e = g + 4 | 0;
                    n = g + 8 | 0;
                    s = e;
                    t = n;
                    u = g;
                    d = b[g >> 2] | 0;
                    e = b[e >> 2] | 0;
                    g = b[n >> 2] | 0;
                    p = 0.0;
                    r = 0.0;
                    o = 0.0;
                } else {
                    l = b[g >> 2] | 0;
                    o = +(v | 0);
                    s = g + 4 | 0;
                    m = b[s >> 2] | 0;
                    t = g + 8 | 0;
                    n = b[t >> 2] | 0;
                    u = g;
                    d = l;
                    e = m;
                    g = n;
                    p = +((b[h >> 2] | 0) - l | 0) / o;
                    r = +((b[h + 4 >> 2] | 0) - m | 0) / o;
                    o = +((b[h + 8 >> 2] | 0) - n | 0) / o;
                }
                b[w >> 2] = d;
                n = w + 4 | 0;
                b[n >> 2] = e;
                m = w + 8 | 0;
                b[m >> 2] = g;
                l = 0;
                while(true){
                    j = +(l | 0);
                    y = p * j + +(d | 0);
                    i = r * j + +(b[s >> 2] | 0);
                    j = o * j + +(b[t >> 2] | 0);
                    e = ~~+fd(+y);
                    h = ~~+fd(+i);
                    d = ~~+fd(+j);
                    y = +q(+(+(e | 0) - y));
                    i = +q(+(+(h | 0) - i));
                    j = +q(+(+(d | 0) - j));
                    do if (!(y > i & y > j)) {
                        k = 0 - e | 0;
                        if (i > j) {
                            g = k - d | 0;
                            break;
                        } else {
                            g = h;
                            d = k - h | 0;
                            break;
                        }
                    } else {
                        e = 0 - (h + d) | 0;
                        g = h;
                    }
                    while (0);
                    b[w >> 2] = e;
                    b[n >> 2] = g;
                    b[m >> 2] = d;
                    Xa(w);
                    nc(a, c, w, f + (l << 3) | 0);
                    if ((l | 0) == (v | 0)) break;
                    l = l + 1 | 0;
                    d = b[u >> 2] | 0;
                }
                w = 0;
                S = x;
                return w | 0;
            }
            w = -1;
            S = x;
            return w | 0;
        }
        function tc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            if (!b) {
                c = 1;
                return c | 0;
            }
            c = a;
            a = 1;
            do {
                a = B((b & 1 | 0) == 0 ? 1 : c, a) | 0;
                b = b >> 1;
                c = B(c, c) | 0;
            }while ((b | 0) != 0);
            return a | 0;
        }
        function uc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0, m = 0, n = 0, o = 0.0;
            if (!(xa(c, d) | 0)) {
                n = 0;
                return n | 0;
            }
            c = wa(c) | 0;
            o = +e[d >> 3];
            f = +e[d + 8 >> 3];
            f = c & f < 0.0 ? f + 6.283185307179586 : f;
            n = b[a >> 2] | 0;
            if ((n | 0) <= 0) {
                n = 0;
                return n | 0;
            }
            m = b[a + 4 >> 2] | 0;
            if (c) {
                c = 0;
                d = -1;
                a = 0;
                a: while(true){
                    l = a;
                    while(true){
                        i = +e[m + (l << 4) >> 3];
                        k = +e[m + (l << 4) + 8 >> 3];
                        a = (d + 2 | 0) % (n | 0) | 0;
                        h = +e[m + (a << 4) >> 3];
                        g = +e[m + (a << 4) + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(o < h | o > j)) break;
                        d = l + 1 | 0;
                        if ((d | 0) < (n | 0)) {
                            a = l;
                            l = d;
                            d = a;
                        } else {
                            d = 22;
                            break a;
                        }
                    }
                    k = g < 0.0 ? g + 6.283185307179586 : g;
                    i = i < 0.0 ? i + 6.283185307179586 : i;
                    f = i == f | k == f ? f + -0.0000000000000002220446049250313 : f;
                    k = k + (o - h) / (j - h) * (i - k);
                    if ((k < 0.0 ? k + 6.283185307179586 : k) > f) c = c ^ 1;
                    a = l + 1 | 0;
                    if ((a | 0) >= (n | 0)) {
                        d = 22;
                        break;
                    } else d = l;
                }
                if ((d | 0) == 22) return c | 0;
            } else {
                c = 0;
                d = -1;
                a = 0;
                b: while(true){
                    l = a;
                    while(true){
                        i = +e[m + (l << 4) >> 3];
                        k = +e[m + (l << 4) + 8 >> 3];
                        a = (d + 2 | 0) % (n | 0) | 0;
                        h = +e[m + (a << 4) >> 3];
                        g = +e[m + (a << 4) + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(o < h | o > j)) break;
                        d = l + 1 | 0;
                        if ((d | 0) < (n | 0)) {
                            a = l;
                            l = d;
                            d = a;
                        } else {
                            d = 22;
                            break b;
                        }
                    }
                    f = i == f | g == f ? f + -0.0000000000000002220446049250313 : f;
                    if (g + (o - h) / (j - h) * (i - g) > f) c = c ^ 1;
                    a = l + 1 | 0;
                    if ((a | 0) >= (n | 0)) {
                        d = 22;
                        break;
                    } else d = l;
                }
                if ((d | 0) == 22) return c | 0;
            }
            return 0;
        }
        function vc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0, o = 0, p = 0, r = 0, s = 0, t = 0, u = 0, v = 0;
            r = b[a >> 2] | 0;
            if (!r) {
                b[c >> 2] = 0;
                b[c + 4 >> 2] = 0;
                b[c + 8 >> 2] = 0;
                b[c + 12 >> 2] = 0;
                b[c + 16 >> 2] = 0;
                b[c + 20 >> 2] = 0;
                b[c + 24 >> 2] = 0;
                b[c + 28 >> 2] = 0;
                return;
            }
            s = c + 8 | 0;
            e[s >> 3] = 1797693134862315708145274.0e284;
            t = c + 24 | 0;
            e[t >> 3] = 1797693134862315708145274.0e284;
            e[c >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            u = c + 16 | 0;
            e[u >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            if ((r | 0) <= 0) return;
            o = b[a + 4 >> 2] | 0;
            l = 1797693134862315708145274.0e284;
            m = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            n = 0;
            a = -1;
            h = 1797693134862315708145274.0e284;
            i = 1797693134862315708145274.0e284;
            k = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            f = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            p = 0;
            while(true){
                d = +e[o + (p << 4) >> 3];
                j = +e[o + (p << 4) + 8 >> 3];
                a = a + 2 | 0;
                g = +e[o + (((a | 0) == (r | 0) ? 0 : a) << 4) + 8 >> 3];
                if (d < h) {
                    e[s >> 3] = d;
                    h = d;
                }
                if (j < i) {
                    e[t >> 3] = j;
                    i = j;
                }
                if (d > k) e[c >> 3] = d;
                else d = k;
                if (j > f) {
                    e[u >> 3] = j;
                    f = j;
                }
                l = j > 0.0 & j < l ? j : l;
                m = j < 0.0 & j > m ? j : m;
                n = n | +q(+(j - g)) > 3.141592653589793;
                a = p + 1 | 0;
                if ((a | 0) == (r | 0)) break;
                else {
                    v = p;
                    k = d;
                    p = a;
                    a = v;
                }
            }
            if (!n) return;
            e[u >> 3] = m;
            e[t >> 3] = l;
            return;
        }
        function wc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0, o = 0.0, p = 0.0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0;
            r = b[a >> 2] | 0;
            if (r) {
                s = c + 8 | 0;
                e[s >> 3] = 1797693134862315708145274.0e284;
                t = c + 24 | 0;
                e[t >> 3] = 1797693134862315708145274.0e284;
                e[c >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                u = c + 16 | 0;
                e[u >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                if ((r | 0) > 0) {
                    g = b[a + 4 >> 2] | 0;
                    o = 1797693134862315708145274.0e284;
                    p = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    f = 0;
                    d = -1;
                    k = 1797693134862315708145274.0e284;
                    l = 1797693134862315708145274.0e284;
                    n = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    i = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    v = 0;
                    while(true){
                        h = +e[g + (v << 4) >> 3];
                        m = +e[g + (v << 4) + 8 >> 3];
                        z = d + 2 | 0;
                        j = +e[g + (((z | 0) == (r | 0) ? 0 : z) << 4) + 8 >> 3];
                        if (h < k) {
                            e[s >> 3] = h;
                            k = h;
                        }
                        if (m < l) {
                            e[t >> 3] = m;
                            l = m;
                        }
                        if (h > n) e[c >> 3] = h;
                        else h = n;
                        if (m > i) {
                            e[u >> 3] = m;
                            i = m;
                        }
                        o = m > 0.0 & m < o ? m : o;
                        p = m < 0.0 & m > p ? m : p;
                        f = f | +q(+(m - j)) > 3.141592653589793;
                        d = v + 1 | 0;
                        if ((d | 0) == (r | 0)) break;
                        else {
                            z = v;
                            n = h;
                            v = d;
                            d = z;
                        }
                    }
                    if (f) {
                        e[u >> 3] = p;
                        e[t >> 3] = o;
                    }
                }
            } else {
                b[c >> 2] = 0;
                b[c + 4 >> 2] = 0;
                b[c + 8 >> 2] = 0;
                b[c + 12 >> 2] = 0;
                b[c + 16 >> 2] = 0;
                b[c + 20 >> 2] = 0;
                b[c + 24 >> 2] = 0;
                b[c + 28 >> 2] = 0;
            }
            z = a + 8 | 0;
            d = b[z >> 2] | 0;
            if ((d | 0) <= 0) return;
            y = a + 12 | 0;
            x = 0;
            do {
                g = b[y >> 2] | 0;
                f = x;
                x = x + 1 | 0;
                t = c + (x << 5) | 0;
                u = b[g + (f << 3) >> 2] | 0;
                if (u) {
                    v = c + (x << 5) + 8 | 0;
                    e[v >> 3] = 1797693134862315708145274.0e284;
                    a = c + (x << 5) + 24 | 0;
                    e[a >> 3] = 1797693134862315708145274.0e284;
                    e[t >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    w = c + (x << 5) + 16 | 0;
                    e[w >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    if ((u | 0) > 0) {
                        r = b[g + (f << 3) + 4 >> 2] | 0;
                        o = 1797693134862315708145274.0e284;
                        p = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        g = 0;
                        f = -1;
                        s = 0;
                        k = 1797693134862315708145274.0e284;
                        l = 1797693134862315708145274.0e284;
                        m = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        i = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        while(true){
                            h = +e[r + (s << 4) >> 3];
                            n = +e[r + (s << 4) + 8 >> 3];
                            f = f + 2 | 0;
                            j = +e[r + (((f | 0) == (u | 0) ? 0 : f) << 4) + 8 >> 3];
                            if (h < k) {
                                e[v >> 3] = h;
                                k = h;
                            }
                            if (n < l) {
                                e[a >> 3] = n;
                                l = n;
                            }
                            if (h > m) e[t >> 3] = h;
                            else h = m;
                            if (n > i) {
                                e[w >> 3] = n;
                                i = n;
                            }
                            o = n > 0.0 & n < o ? n : o;
                            p = n < 0.0 & n > p ? n : p;
                            g = g | +q(+(n - j)) > 3.141592653589793;
                            f = s + 1 | 0;
                            if ((f | 0) == (u | 0)) break;
                            else {
                                A = s;
                                s = f;
                                m = h;
                                f = A;
                            }
                        }
                        if (g) {
                            e[w >> 3] = p;
                            e[a >> 3] = o;
                        }
                    }
                } else {
                    b[t >> 2] = 0;
                    b[t + 4 >> 2] = 0;
                    b[t + 8 >> 2] = 0;
                    b[t + 12 >> 2] = 0;
                    b[t + 16 >> 2] = 0;
                    b[t + 20 >> 2] = 0;
                    b[t + 24 >> 2] = 0;
                    b[t + 28 >> 2] = 0;
                    d = b[z >> 2] | 0;
                }
            }while ((x | 0) < (d | 0));
            return;
        }
        function xc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            if (!(uc(a, c, d) | 0)) {
                f = 0;
                return f | 0;
            }
            f = a + 8 | 0;
            if ((b[f >> 2] | 0) <= 0) {
                f = 1;
                return f | 0;
            }
            e = a + 12 | 0;
            a = 0;
            while(true){
                g = a;
                a = a + 1 | 0;
                if (uc((b[e >> 2] | 0) + (g << 3) | 0, c + (a << 5) | 0, d) | 0) {
                    a = 0;
                    e = 6;
                    break;
                }
                if ((a | 0) >= (b[f >> 2] | 0)) {
                    a = 1;
                    e = 6;
                    break;
                }
            }
            if ((e | 0) == 6) return a | 0;
            return 0;
        }
        function yc() {
            return 8;
        }
        function zc() {
            return 16;
        }
        function Ac() {
            return 168;
        }
        function Bc() {
            return 8;
        }
        function Cc() {
            return 16;
        }
        function Dc() {
            return 12;
        }
        function Ec() {
            return 8;
        }
        function Fc(a) {
            a = a | 0;
            var b = 0.0, c = 0.0;
            c = +e[a >> 3];
            b = +e[a + 8 >> 3];
            return + +r(+(c * c + b * b));
        }
        function Gc(a, b, c, d, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0;
            k = +e[a >> 3];
            j = +e[b >> 3] - k;
            i = +e[a + 8 >> 3];
            h = +e[b + 8 >> 3] - i;
            m = +e[c >> 3];
            g = +e[d >> 3] - m;
            n = +e[c + 8 >> 3];
            l = +e[d + 8 >> 3] - n;
            g = (g * (i - n) - (k - m) * l) / (j * l - h * g);
            e[f >> 3] = k + j * g;
            e[f + 8 >> 3] = i + h * g;
            return;
        }
        function Hc(a, b) {
            a = a | 0;
            b = b | 0;
            if (!(+e[a >> 3] == +e[b >> 3])) {
                b = 0;
                return b | 0;
            }
            b = +e[a + 8 >> 3] == +e[b + 8 >> 3];
            return b | 0;
        }
        function Ic(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            f = +e[a >> 3] - +e[b >> 3];
            d = +e[a + 8 >> 3] - +e[b + 8 >> 3];
            c = +e[a + 16 >> 3] - +e[b + 16 >> 3];
            return +(f * f + d * d + c * c);
        }
        function Jc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            c = +e[a >> 3];
            d = +t(+c);
            c = +u(+c);
            e[b + 16 >> 3] = c;
            c = +e[a + 8 >> 3];
            f = d * +t(+c);
            e[b >> 3] = f;
            c = d * +u(+c);
            e[b + 8 >> 3] = c;
            return;
        }
        function Kc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            k = S;
            S = S + 32 | 0;
            f = k + 16 | 0;
            g = k;
            Ub(a, c, f);
            h = Ab(a, c) | 0;
            j = Lb(a, c) | 0;
            pa(h, g);
            c = qa(h, b[f >> 2] | 0) | 0;
            if (!(la(h) | 0)) {
                j = c;
                S = k;
                return j | 0;
            }
            do switch(h | 0){
                case 4:
                    a = 0;
                    d = 14;
                    break;
                case 14:
                    a = 1;
                    d = 14;
                    break;
                case 24:
                    a = 2;
                    d = 14;
                    break;
                case 38:
                    a = 3;
                    d = 14;
                    break;
                case 49:
                    a = 4;
                    d = 14;
                    break;
                case 58:
                    a = 5;
                    d = 14;
                    break;
                case 63:
                    a = 6;
                    d = 14;
                    break;
                case 72:
                    a = 7;
                    d = 14;
                    break;
                case 83:
                    a = 8;
                    d = 14;
                    break;
                case 97:
                    a = 9;
                    d = 14;
                    break;
                case 107:
                    a = 10;
                    d = 14;
                    break;
                case 117:
                    a = 11;
                    d = 14;
                    break;
                default:
                    i = 0;
                    e = 0;
            }
            while (0);
            if ((d | 0) == 14) {
                i = b[22096 + (a * 24 | 0) + 8 >> 2] | 0;
                e = b[22096 + (a * 24 | 0) + 16 >> 2] | 0;
            }
            a = b[f >> 2] | 0;
            if ((a | 0) != (b[g >> 2] | 0)) {
                h = ma(h) | 0;
                a = b[f >> 2] | 0;
                if (h | (a | 0) == (e | 0)) c = (c + 1 | 0) % 6 | 0;
            }
            if ((j | 0) == 3 & (a | 0) == (e | 0)) {
                j = (c + 5 | 0) % 6 | 0;
                S = k;
                return j | 0;
            }
            if (!((j | 0) == 5 & (a | 0) == (i | 0))) {
                j = c;
                S = k;
                return j | 0;
            }
            j = (c + 1 | 0) % 6 | 0;
            S = k;
            return j | 0;
        }
        function Lc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = Fb(a, c) | 0;
            if ((d + -1 | 0) >>> 0 > 5) {
                d = -1;
                return d | 0;
            }
            f = (e | 0) != 0;
            if ((d | 0) == 1 & f) {
                d = -1;
                return d | 0;
            }
            e = Kc(a, c) | 0;
            if (f) {
                d = (5 - e + (b[22384 + (d << 2) >> 2] | 0) | 0) % 5 | 0;
                return d | 0;
            } else {
                d = (6 - e + (b[22416 + (d << 2) >> 2] | 0) | 0) % 6 | 0;
                return d | 0;
            }
            return 0;
        }
        function Mc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            if ((c | 0) > 0) {
                e = Yc(c, 4) | 0;
                b[a >> 2] = e;
                if (!e) H(23230, 23253, 40, 23267);
            } else b[a >> 2] = 0;
            b[a + 4 >> 2] = c;
            b[a + 8 >> 2] = 0;
            b[a + 12 >> 2] = d;
            return;
        }
        function Nc(a) {
            a = a | 0;
            var c = 0, d = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            g = a + 4 | 0;
            h = a + 12 | 0;
            i = a + 8 | 0;
            a: while(true){
                d = b[g >> 2] | 0;
                c = 0;
                while(true){
                    if ((c | 0) >= (d | 0)) break a;
                    f = b[a >> 2] | 0;
                    j = b[f + (c << 2) >> 2] | 0;
                    if (!j) c = c + 1 | 0;
                    else break;
                }
                c = f + (~~(+q(+(+s(10.0, + +(15 - (b[h >> 2] | 0) | 0)) * (+e[j >> 3] + +e[j + 8 >> 3]))) % +(d | 0)) >>> 0 << 2) | 0;
                d = b[c >> 2] | 0;
                b: do if (d | 0) {
                    f = j + 32 | 0;
                    if ((d | 0) == (j | 0)) b[c >> 2] = b[f >> 2];
                    else {
                        d = d + 32 | 0;
                        c = b[d >> 2] | 0;
                        if (!c) break;
                        while(true){
                            if ((c | 0) == (j | 0)) break;
                            d = c + 32 | 0;
                            c = b[d >> 2] | 0;
                            if (!c) break b;
                        }
                        b[d >> 2] = b[f >> 2];
                    }
                    Xc(j);
                    b[i >> 2] = (b[i >> 2] | 0) + -1;
                }
                while (0);
            }
            Xc(b[a >> 2] | 0);
            return;
        }
        function Oc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            e = b[a + 4 >> 2] | 0;
            d = 0;
            while(true){
                if ((d | 0) >= (e | 0)) {
                    c = 0;
                    d = 4;
                    break;
                }
                c = b[(b[a >> 2] | 0) + (d << 2) >> 2] | 0;
                if (!c) d = d + 1 | 0;
                else {
                    d = 4;
                    break;
                }
            }
            if ((d | 0) == 4) return c | 0;
            return 0;
        }
        function Pc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0;
            d = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            d = (b[a >> 2] | 0) + (d << 2) | 0;
            f = b[d >> 2] | 0;
            if (!f) {
                h = 1;
                return h | 0;
            }
            h = c + 32 | 0;
            do if ((f | 0) != (c | 0)) {
                d = b[f + 32 >> 2] | 0;
                if (!d) {
                    h = 1;
                    return h | 0;
                }
                g = d;
                while(true){
                    if ((g | 0) == (c | 0)) {
                        g = 8;
                        break;
                    }
                    d = b[g + 32 >> 2] | 0;
                    if (!d) {
                        d = 1;
                        g = 10;
                        break;
                    } else {
                        f = g;
                        g = d;
                    }
                }
                if ((g | 0) == 8) {
                    b[f + 32 >> 2] = b[h >> 2];
                    break;
                } else if ((g | 0) == 10) return d | 0;
            } else b[d >> 2] = b[h >> 2];
            while (0);
            Xc(c);
            h = a + 8 | 0;
            b[h >> 2] = (b[h >> 2] | 0) + -1;
            h = 0;
            return h | 0;
        }
        function Qc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = Wc(40) | 0;
            if (!h) H(23283, 23253, 98, 23296);
            b[h >> 2] = b[c >> 2];
            b[h + 4 >> 2] = b[c + 4 >> 2];
            b[h + 8 >> 2] = b[c + 8 >> 2];
            b[h + 12 >> 2] = b[c + 12 >> 2];
            g = h + 16 | 0;
            b[g >> 2] = b[d >> 2];
            b[g + 4 >> 2] = b[d + 4 >> 2];
            b[g + 8 >> 2] = b[d + 8 >> 2];
            b[g + 12 >> 2] = b[d + 12 >> 2];
            b[h + 32 >> 2] = 0;
            g = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            g = (b[a >> 2] | 0) + (g << 2) | 0;
            f = b[g >> 2] | 0;
            do if (!f) b[g >> 2] = h;
            else {
                while(true){
                    if (hb(f, c) | 0 ? hb(f + 16 | 0, d) | 0 : 0) break;
                    g = b[f + 32 >> 2] | 0;
                    f = (g | 0) == 0 ? f : g;
                    if (!(b[f + 32 >> 2] | 0)) {
                        i = 10;
                        break;
                    }
                }
                if ((i | 0) == 10) {
                    b[f + 32 >> 2] = h;
                    break;
                }
                Xc(h);
                i = f;
                return i | 0;
            }
            while (0);
            i = a + 8 | 0;
            b[i >> 2] = (b[i >> 2] | 0) + 1;
            i = h;
            return i | 0;
        }
        function Rc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0, g = 0;
            g = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            g = b[(b[a >> 2] | 0) + (g << 2) >> 2] | 0;
            if (!g) {
                d = 0;
                return d | 0;
            }
            if (!d) {
                a = g;
                while(true){
                    if (hb(a, c) | 0) {
                        f = 10;
                        break;
                    }
                    a = b[a + 32 >> 2] | 0;
                    if (!a) {
                        a = 0;
                        f = 10;
                        break;
                    }
                }
                if ((f | 0) == 10) return a | 0;
            }
            a = g;
            while(true){
                if (hb(a, c) | 0 ? hb(a + 16 | 0, d) | 0 : 0) {
                    f = 10;
                    break;
                }
                a = b[a + 32 >> 2] | 0;
                if (!a) {
                    a = 0;
                    f = 10;
                    break;
                }
            }
            if ((f | 0) == 10) return a | 0;
            return 0;
        }
        function Sc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            d = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            a = b[(b[a >> 2] | 0) + (d << 2) >> 2] | 0;
            if (!a) {
                d = 0;
                return d | 0;
            }
            while(true){
                if (hb(a, c) | 0) {
                    c = 5;
                    break;
                }
                a = b[a + 32 >> 2] | 0;
                if (!a) {
                    a = 0;
                    c = 5;
                    break;
                }
            }
            if ((c | 0) == 5) return a | 0;
            return 0;
        }
        function Tc() {
            return 23312;
        }
        function Uc(a) {
            a = +a;
            return + +id(+a);
        }
        function Vc(a) {
            a = +a;
            return ~~+Uc(a) | 0;
        }
        function Wc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0;
            w = S;
            S = S + 16 | 0;
            n = w;
            do {
                if (a >>> 0 < 245) {
                    k = a >>> 0 < 11 ? 16 : a + 11 & -8;
                    a = k >>> 3;
                    m = b[5829] | 0;
                    d = m >>> a;
                    if (d & 3 | 0) {
                        c = (d & 1 ^ 1) + a | 0;
                        a = 23356 + (c << 1 << 2) | 0;
                        d = a + 8 | 0;
                        e = b[d >> 2] | 0;
                        f = e + 8 | 0;
                        g = b[f >> 2] | 0;
                        if ((g | 0) == (a | 0)) b[5829] = m & ~(1 << c);
                        else {
                            b[g + 12 >> 2] = a;
                            b[d >> 2] = g;
                        }
                        v = c << 3;
                        b[e + 4 >> 2] = v | 3;
                        v = e + v + 4 | 0;
                        b[v >> 2] = b[v >> 2] | 1;
                        v = f;
                        S = w;
                        return v | 0;
                    }
                    l = b[5831] | 0;
                    if (k >>> 0 > l >>> 0) {
                        if (d | 0) {
                            c = 2 << a;
                            c = d << a & (c | 0 - c);
                            c = (c & 0 - c) + -1 | 0;
                            i = c >>> 12 & 16;
                            c = c >>> i;
                            d = c >>> 5 & 8;
                            c = c >>> d;
                            g = c >>> 2 & 4;
                            c = c >>> g;
                            a = c >>> 1 & 2;
                            c = c >>> a;
                            e = c >>> 1 & 1;
                            e = (d | i | g | a | e) + (c >>> e) | 0;
                            c = 23356 + (e << 1 << 2) | 0;
                            a = c + 8 | 0;
                            g = b[a >> 2] | 0;
                            i = g + 8 | 0;
                            d = b[i >> 2] | 0;
                            if ((d | 0) == (c | 0)) {
                                a = m & ~(1 << e);
                                b[5829] = a;
                            } else {
                                b[d + 12 >> 2] = c;
                                b[a >> 2] = d;
                                a = m;
                            }
                            v = e << 3;
                            h = v - k | 0;
                            b[g + 4 >> 2] = k | 3;
                            f = g + k | 0;
                            b[f + 4 >> 2] = h | 1;
                            b[g + v >> 2] = h;
                            if (l | 0) {
                                e = b[5834] | 0;
                                c = l >>> 3;
                                d = 23356 + (c << 1 << 2) | 0;
                                c = 1 << c;
                                if (!(a & c)) {
                                    b[5829] = a | c;
                                    c = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    c = b[a >> 2] | 0;
                                }
                                b[a >> 2] = e;
                                b[c + 12 >> 2] = e;
                                b[e + 8 >> 2] = c;
                                b[e + 12 >> 2] = d;
                            }
                            b[5831] = h;
                            b[5834] = f;
                            v = i;
                            S = w;
                            return v | 0;
                        }
                        g = b[5830] | 0;
                        if (g) {
                            d = (g & 0 - g) + -1 | 0;
                            f = d >>> 12 & 16;
                            d = d >>> f;
                            e = d >>> 5 & 8;
                            d = d >>> e;
                            h = d >>> 2 & 4;
                            d = d >>> h;
                            i = d >>> 1 & 2;
                            d = d >>> i;
                            j = d >>> 1 & 1;
                            j = b[23620 + ((e | f | h | i | j) + (d >>> j) << 2) >> 2] | 0;
                            d = j;
                            i = j;
                            j = (b[j + 4 >> 2] & -8) - k | 0;
                            while(true){
                                a = b[d + 16 >> 2] | 0;
                                if (!a) {
                                    a = b[d + 20 >> 2] | 0;
                                    if (!a) break;
                                }
                                h = (b[a + 4 >> 2] & -8) - k | 0;
                                f = h >>> 0 < j >>> 0;
                                d = a;
                                i = f ? a : i;
                                j = f ? h : j;
                            }
                            h = i + k | 0;
                            if (h >>> 0 > i >>> 0) {
                                f = b[i + 24 >> 2] | 0;
                                c = b[i + 12 >> 2] | 0;
                                do if ((c | 0) == (i | 0)) {
                                    a = i + 20 | 0;
                                    c = b[a >> 2] | 0;
                                    if (!c) {
                                        a = i + 16 | 0;
                                        c = b[a >> 2] | 0;
                                        if (!c) {
                                            d = 0;
                                            break;
                                        }
                                    }
                                    while(true){
                                        e = c + 20 | 0;
                                        d = b[e >> 2] | 0;
                                        if (!d) {
                                            e = c + 16 | 0;
                                            d = b[e >> 2] | 0;
                                            if (!d) break;
                                            else {
                                                c = d;
                                                a = e;
                                            }
                                        } else {
                                            c = d;
                                            a = e;
                                        }
                                    }
                                    b[a >> 2] = 0;
                                    d = c;
                                } else {
                                    d = b[i + 8 >> 2] | 0;
                                    b[d + 12 >> 2] = c;
                                    b[c + 8 >> 2] = d;
                                    d = c;
                                }
                                while (0);
                                do if (f | 0) {
                                    c = b[i + 28 >> 2] | 0;
                                    a = 23620 + (c << 2) | 0;
                                    if ((i | 0) == (b[a >> 2] | 0)) {
                                        b[a >> 2] = d;
                                        if (!d) {
                                            b[5830] = g & ~(1 << c);
                                            break;
                                        }
                                    } else {
                                        v = f + 16 | 0;
                                        b[((b[v >> 2] | 0) == (i | 0) ? v : f + 20 | 0) >> 2] = d;
                                        if (!d) break;
                                    }
                                    b[d + 24 >> 2] = f;
                                    c = b[i + 16 >> 2] | 0;
                                    if (c | 0) {
                                        b[d + 16 >> 2] = c;
                                        b[c + 24 >> 2] = d;
                                    }
                                    c = b[i + 20 >> 2] | 0;
                                    if (c | 0) {
                                        b[d + 20 >> 2] = c;
                                        b[c + 24 >> 2] = d;
                                    }
                                }
                                while (0);
                                if (j >>> 0 < 16) {
                                    v = j + k | 0;
                                    b[i + 4 >> 2] = v | 3;
                                    v = i + v + 4 | 0;
                                    b[v >> 2] = b[v >> 2] | 1;
                                } else {
                                    b[i + 4 >> 2] = k | 3;
                                    b[h + 4 >> 2] = j | 1;
                                    b[h + j >> 2] = j;
                                    if (l | 0) {
                                        e = b[5834] | 0;
                                        c = l >>> 3;
                                        d = 23356 + (c << 1 << 2) | 0;
                                        c = 1 << c;
                                        if (!(c & m)) {
                                            b[5829] = c | m;
                                            c = d;
                                            a = d + 8 | 0;
                                        } else {
                                            a = d + 8 | 0;
                                            c = b[a >> 2] | 0;
                                        }
                                        b[a >> 2] = e;
                                        b[c + 12 >> 2] = e;
                                        b[e + 8 >> 2] = c;
                                        b[e + 12 >> 2] = d;
                                    }
                                    b[5831] = j;
                                    b[5834] = h;
                                }
                                v = i + 8 | 0;
                                S = w;
                                return v | 0;
                            } else m = k;
                        } else m = k;
                    } else m = k;
                } else if (a >>> 0 <= 4294967231) {
                    a = a + 11 | 0;
                    k = a & -8;
                    e = b[5830] | 0;
                    if (e) {
                        f = 0 - k | 0;
                        a = a >>> 8;
                        if (a) {
                            if (k >>> 0 > 16777215) j = 31;
                            else {
                                m = (a + 1048320 | 0) >>> 16 & 8;
                                q = a << m;
                                i = (q + 520192 | 0) >>> 16 & 4;
                                q = q << i;
                                j = (q + 245760 | 0) >>> 16 & 2;
                                j = 14 - (i | m | j) + (q << j >>> 15) | 0;
                                j = k >>> (j + 7 | 0) & 1 | j << 1;
                            }
                        } else j = 0;
                        d = b[23620 + (j << 2) >> 2] | 0;
                        a: do if (!d) {
                            d = 0;
                            a = 0;
                            q = 61;
                        } else {
                            a = 0;
                            i = k << ((j | 0) == 31 ? 0 : 25 - (j >>> 1) | 0);
                            g = 0;
                            while(true){
                                h = (b[d + 4 >> 2] & -8) - k | 0;
                                if (h >>> 0 < f >>> 0) {
                                    if (!h) {
                                        a = d;
                                        f = 0;
                                        q = 65;
                                        break a;
                                    } else {
                                        a = d;
                                        f = h;
                                    }
                                }
                                q = b[d + 20 >> 2] | 0;
                                d = b[d + 16 + (i >>> 31 << 2) >> 2] | 0;
                                g = (q | 0) == 0 | (q | 0) == (d | 0) ? g : q;
                                if (!d) {
                                    d = g;
                                    q = 61;
                                    break;
                                } else i = i << 1;
                            }
                        }
                        while (0);
                        if ((q | 0) == 61) {
                            if ((d | 0) == 0 & (a | 0) == 0) {
                                a = 2 << j;
                                a = (a | 0 - a) & e;
                                if (!a) {
                                    m = k;
                                    break;
                                }
                                m = (a & 0 - a) + -1 | 0;
                                h = m >>> 12 & 16;
                                m = m >>> h;
                                g = m >>> 5 & 8;
                                m = m >>> g;
                                i = m >>> 2 & 4;
                                m = m >>> i;
                                j = m >>> 1 & 2;
                                m = m >>> j;
                                d = m >>> 1 & 1;
                                a = 0;
                                d = b[23620 + ((g | h | i | j | d) + (m >>> d) << 2) >> 2] | 0;
                            }
                            if (!d) {
                                i = a;
                                h = f;
                            } else q = 65;
                        }
                        if ((q | 0) == 65) {
                            g = d;
                            while(true){
                                m = (b[g + 4 >> 2] & -8) - k | 0;
                                d = m >>> 0 < f >>> 0;
                                f = d ? m : f;
                                a = d ? g : a;
                                d = b[g + 16 >> 2] | 0;
                                if (!d) d = b[g + 20 >> 2] | 0;
                                if (!d) {
                                    i = a;
                                    h = f;
                                    break;
                                } else g = d;
                            }
                        }
                        if (((i | 0) != 0 ? h >>> 0 < ((b[5831] | 0) - k | 0) >>> 0 : 0) ? (l = i + k | 0, l >>> 0 > i >>> 0) : 0) {
                            g = b[i + 24 >> 2] | 0;
                            c = b[i + 12 >> 2] | 0;
                            do if ((c | 0) == (i | 0)) {
                                a = i + 20 | 0;
                                c = b[a >> 2] | 0;
                                if (!c) {
                                    a = i + 16 | 0;
                                    c = b[a >> 2] | 0;
                                    if (!c) {
                                        c = 0;
                                        break;
                                    }
                                }
                                while(true){
                                    f = c + 20 | 0;
                                    d = b[f >> 2] | 0;
                                    if (!d) {
                                        f = c + 16 | 0;
                                        d = b[f >> 2] | 0;
                                        if (!d) break;
                                        else {
                                            c = d;
                                            a = f;
                                        }
                                    } else {
                                        c = d;
                                        a = f;
                                    }
                                }
                                b[a >> 2] = 0;
                            } else {
                                v = b[i + 8 >> 2] | 0;
                                b[v + 12 >> 2] = c;
                                b[c + 8 >> 2] = v;
                            }
                            while (0);
                            do if (g) {
                                a = b[i + 28 >> 2] | 0;
                                d = 23620 + (a << 2) | 0;
                                if ((i | 0) == (b[d >> 2] | 0)) {
                                    b[d >> 2] = c;
                                    if (!c) {
                                        e = e & ~(1 << a);
                                        b[5830] = e;
                                        break;
                                    }
                                } else {
                                    v = g + 16 | 0;
                                    b[((b[v >> 2] | 0) == (i | 0) ? v : g + 20 | 0) >> 2] = c;
                                    if (!c) break;
                                }
                                b[c + 24 >> 2] = g;
                                a = b[i + 16 >> 2] | 0;
                                if (a | 0) {
                                    b[c + 16 >> 2] = a;
                                    b[a + 24 >> 2] = c;
                                }
                                a = b[i + 20 >> 2] | 0;
                                if (a) {
                                    b[c + 20 >> 2] = a;
                                    b[a + 24 >> 2] = c;
                                }
                            }
                            while (0);
                            b: do if (h >>> 0 < 16) {
                                v = h + k | 0;
                                b[i + 4 >> 2] = v | 3;
                                v = i + v + 4 | 0;
                                b[v >> 2] = b[v >> 2] | 1;
                            } else {
                                b[i + 4 >> 2] = k | 3;
                                b[l + 4 >> 2] = h | 1;
                                b[l + h >> 2] = h;
                                c = h >>> 3;
                                if (h >>> 0 < 256) {
                                    d = 23356 + (c << 1 << 2) | 0;
                                    a = b[5829] | 0;
                                    c = 1 << c;
                                    if (!(a & c)) {
                                        b[5829] = a | c;
                                        c = d;
                                        a = d + 8 | 0;
                                    } else {
                                        a = d + 8 | 0;
                                        c = b[a >> 2] | 0;
                                    }
                                    b[a >> 2] = l;
                                    b[c + 12 >> 2] = l;
                                    b[l + 8 >> 2] = c;
                                    b[l + 12 >> 2] = d;
                                    break;
                                }
                                c = h >>> 8;
                                if (c) {
                                    if (h >>> 0 > 16777215) d = 31;
                                    else {
                                        u = (c + 1048320 | 0) >>> 16 & 8;
                                        v = c << u;
                                        t = (v + 520192 | 0) >>> 16 & 4;
                                        v = v << t;
                                        d = (v + 245760 | 0) >>> 16 & 2;
                                        d = 14 - (t | u | d) + (v << d >>> 15) | 0;
                                        d = h >>> (d + 7 | 0) & 1 | d << 1;
                                    }
                                } else d = 0;
                                c = 23620 + (d << 2) | 0;
                                b[l + 28 >> 2] = d;
                                a = l + 16 | 0;
                                b[a + 4 >> 2] = 0;
                                b[a >> 2] = 0;
                                a = 1 << d;
                                if (!(e & a)) {
                                    b[5830] = e | a;
                                    b[c >> 2] = l;
                                    b[l + 24 >> 2] = c;
                                    b[l + 12 >> 2] = l;
                                    b[l + 8 >> 2] = l;
                                    break;
                                }
                                c = b[c >> 2] | 0;
                                c: do if ((b[c + 4 >> 2] & -8 | 0) != (h | 0)) {
                                    e = h << ((d | 0) == 31 ? 0 : 25 - (d >>> 1) | 0);
                                    while(true){
                                        d = c + 16 + (e >>> 31 << 2) | 0;
                                        a = b[d >> 2] | 0;
                                        if (!a) break;
                                        if ((b[a + 4 >> 2] & -8 | 0) == (h | 0)) {
                                            c = a;
                                            break c;
                                        } else {
                                            e = e << 1;
                                            c = a;
                                        }
                                    }
                                    b[d >> 2] = l;
                                    b[l + 24 >> 2] = c;
                                    b[l + 12 >> 2] = l;
                                    b[l + 8 >> 2] = l;
                                    break b;
                                }
                                while (0);
                                u = c + 8 | 0;
                                v = b[u >> 2] | 0;
                                b[v + 12 >> 2] = l;
                                b[u >> 2] = l;
                                b[l + 8 >> 2] = v;
                                b[l + 12 >> 2] = c;
                                b[l + 24 >> 2] = 0;
                            }
                            while (0);
                            v = i + 8 | 0;
                            S = w;
                            return v | 0;
                        } else m = k;
                    } else m = k;
                } else m = -1;
            }while (0);
            d = b[5831] | 0;
            if (d >>> 0 >= m >>> 0) {
                c = d - m | 0;
                a = b[5834] | 0;
                if (c >>> 0 > 15) {
                    v = a + m | 0;
                    b[5834] = v;
                    b[5831] = c;
                    b[v + 4 >> 2] = c | 1;
                    b[a + d >> 2] = c;
                    b[a + 4 >> 2] = m | 3;
                } else {
                    b[5831] = 0;
                    b[5834] = 0;
                    b[a + 4 >> 2] = d | 3;
                    v = a + d + 4 | 0;
                    b[v >> 2] = b[v >> 2] | 1;
                }
                v = a + 8 | 0;
                S = w;
                return v | 0;
            }
            h = b[5832] | 0;
            if (h >>> 0 > m >>> 0) {
                t = h - m | 0;
                b[5832] = t;
                v = b[5835] | 0;
                u = v + m | 0;
                b[5835] = u;
                b[u + 4 >> 2] = t | 1;
                b[v + 4 >> 2] = m | 3;
                v = v + 8 | 0;
                S = w;
                return v | 0;
            }
            if (!(b[5947] | 0)) {
                b[5949] = 4096;
                b[5948] = 4096;
                b[5950] = -1;
                b[5951] = -1;
                b[5952] = 0;
                b[5940] = 0;
                b[5947] = n & -16 ^ 1431655768;
                a = 4096;
            } else a = b[5949] | 0;
            i = m + 48 | 0;
            j = m + 47 | 0;
            g = a + j | 0;
            f = 0 - a | 0;
            k = g & f;
            if (k >>> 0 <= m >>> 0) {
                v = 0;
                S = w;
                return v | 0;
            }
            a = b[5939] | 0;
            if (a | 0 ? (l = b[5937] | 0, n = l + k | 0, n >>> 0 <= l >>> 0 | n >>> 0 > a >>> 0) : 0) {
                v = 0;
                S = w;
                return v | 0;
            }
            d: do if (!(b[5940] & 4)) {
                d = b[5835] | 0;
                e: do if (d) {
                    e = 23764;
                    while(true){
                        n = b[e >> 2] | 0;
                        if (n >>> 0 <= d >>> 0 ? (n + (b[e + 4 >> 2] | 0) | 0) >>> 0 > d >>> 0 : 0) break;
                        a = b[e + 8 >> 2] | 0;
                        if (!a) {
                            q = 128;
                            break e;
                        } else e = a;
                    }
                    c = g - h & f;
                    if (c >>> 0 < 2147483647) {
                        a = jd(c | 0) | 0;
                        if ((a | 0) == ((b[e >> 2] | 0) + (b[e + 4 >> 2] | 0) | 0)) {
                            if ((a | 0) != -1) {
                                h = c;
                                g = a;
                                q = 145;
                                break d;
                            }
                        } else {
                            e = a;
                            q = 136;
                        }
                    } else c = 0;
                } else q = 128;
                while (0);
                do if ((q | 0) == 128) {
                    d = jd(0) | 0;
                    if ((d | 0) != -1 ? (c = d, o = b[5948] | 0, p = o + -1 | 0, c = ((p & c | 0) == 0 ? 0 : (p + c & 0 - o) - c | 0) + k | 0, o = b[5937] | 0, p = c + o | 0, c >>> 0 > m >>> 0 & c >>> 0 < 2147483647) : 0) {
                        n = b[5939] | 0;
                        if (n | 0 ? p >>> 0 <= o >>> 0 | p >>> 0 > n >>> 0 : 0) {
                            c = 0;
                            break;
                        }
                        a = jd(c | 0) | 0;
                        if ((a | 0) == (d | 0)) {
                            h = c;
                            g = d;
                            q = 145;
                            break d;
                        } else {
                            e = a;
                            q = 136;
                        }
                    } else c = 0;
                }
                while (0);
                do if ((q | 0) == 136) {
                    d = 0 - c | 0;
                    if (!(i >>> 0 > c >>> 0 & (c >>> 0 < 2147483647 & (e | 0) != -1))) {
                        if ((e | 0) == -1) {
                            c = 0;
                            break;
                        } else {
                            h = c;
                            g = e;
                            q = 145;
                            break d;
                        }
                    }
                    a = b[5949] | 0;
                    a = j - c + a & 0 - a;
                    if (a >>> 0 >= 2147483647) {
                        h = c;
                        g = e;
                        q = 145;
                        break d;
                    }
                    if ((jd(a | 0) | 0) == -1) {
                        jd(d | 0);
                        c = 0;
                        break;
                    } else {
                        h = a + c | 0;
                        g = e;
                        q = 145;
                        break d;
                    }
                }
                while (0);
                b[5940] = b[5940] | 4;
                q = 143;
            } else {
                c = 0;
                q = 143;
            }
            while (0);
            if (((q | 0) == 143 ? k >>> 0 < 2147483647 : 0) ? (t = jd(k | 0) | 0, p = jd(0) | 0, r = p - t | 0, s = r >>> 0 > (m + 40 | 0) >>> 0, !((t | 0) == -1 | s ^ 1 | t >>> 0 < p >>> 0 & ((t | 0) != -1 & (p | 0) != -1) ^ 1)) : 0) {
                h = s ? r : c;
                g = t;
                q = 145;
            }
            if ((q | 0) == 145) {
                c = (b[5937] | 0) + h | 0;
                b[5937] = c;
                if (c >>> 0 > (b[5938] | 0) >>> 0) b[5938] = c;
                j = b[5835] | 0;
                f: do if (j) {
                    c = 23764;
                    while(true){
                        a = b[c >> 2] | 0;
                        d = b[c + 4 >> 2] | 0;
                        if ((g | 0) == (a + d | 0)) {
                            q = 154;
                            break;
                        }
                        e = b[c + 8 >> 2] | 0;
                        if (!e) break;
                        else c = e;
                    }
                    if (((q | 0) == 154 ? (u = c + 4 | 0, (b[c + 12 >> 2] & 8 | 0) == 0) : 0) ? g >>> 0 > j >>> 0 & a >>> 0 <= j >>> 0 : 0) {
                        b[u >> 2] = d + h;
                        v = (b[5832] | 0) + h | 0;
                        t = j + 8 | 0;
                        t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                        u = j + t | 0;
                        t = v - t | 0;
                        b[5835] = u;
                        b[5832] = t;
                        b[u + 4 >> 2] = t | 1;
                        b[j + v + 4 >> 2] = 40;
                        b[5836] = b[5951];
                        break;
                    }
                    if (g >>> 0 < (b[5833] | 0) >>> 0) b[5833] = g;
                    d = g + h | 0;
                    c = 23764;
                    while(true){
                        if ((b[c >> 2] | 0) == (d | 0)) {
                            q = 162;
                            break;
                        }
                        a = b[c + 8 >> 2] | 0;
                        if (!a) break;
                        else c = a;
                    }
                    if ((q | 0) == 162 ? (b[c + 12 >> 2] & 8 | 0) == 0 : 0) {
                        b[c >> 2] = g;
                        l = c + 4 | 0;
                        b[l >> 2] = (b[l >> 2] | 0) + h;
                        l = g + 8 | 0;
                        l = g + ((l & 7 | 0) == 0 ? 0 : 0 - l & 7) | 0;
                        c = d + 8 | 0;
                        c = d + ((c & 7 | 0) == 0 ? 0 : 0 - c & 7) | 0;
                        k = l + m | 0;
                        i = c - l - m | 0;
                        b[l + 4 >> 2] = m | 3;
                        g: do if ((j | 0) == (c | 0)) {
                            v = (b[5832] | 0) + i | 0;
                            b[5832] = v;
                            b[5835] = k;
                            b[k + 4 >> 2] = v | 1;
                        } else {
                            if ((b[5834] | 0) == (c | 0)) {
                                v = (b[5831] | 0) + i | 0;
                                b[5831] = v;
                                b[5834] = k;
                                b[k + 4 >> 2] = v | 1;
                                b[k + v >> 2] = v;
                                break;
                            }
                            a = b[c + 4 >> 2] | 0;
                            if ((a & 3 | 0) == 1) {
                                h = a & -8;
                                e = a >>> 3;
                                h: do if (a >>> 0 < 256) {
                                    a = b[c + 8 >> 2] | 0;
                                    d = b[c + 12 >> 2] | 0;
                                    if ((d | 0) == (a | 0)) {
                                        b[5829] = b[5829] & ~(1 << e);
                                        break;
                                    } else {
                                        b[a + 12 >> 2] = d;
                                        b[d + 8 >> 2] = a;
                                        break;
                                    }
                                } else {
                                    g = b[c + 24 >> 2] | 0;
                                    a = b[c + 12 >> 2] | 0;
                                    do if ((a | 0) == (c | 0)) {
                                        d = c + 16 | 0;
                                        e = d + 4 | 0;
                                        a = b[e >> 2] | 0;
                                        if (!a) {
                                            a = b[d >> 2] | 0;
                                            if (!a) {
                                                a = 0;
                                                break;
                                            }
                                        } else d = e;
                                        while(true){
                                            f = a + 20 | 0;
                                            e = b[f >> 2] | 0;
                                            if (!e) {
                                                f = a + 16 | 0;
                                                e = b[f >> 2] | 0;
                                                if (!e) break;
                                                else {
                                                    a = e;
                                                    d = f;
                                                }
                                            } else {
                                                a = e;
                                                d = f;
                                            }
                                        }
                                        b[d >> 2] = 0;
                                    } else {
                                        v = b[c + 8 >> 2] | 0;
                                        b[v + 12 >> 2] = a;
                                        b[a + 8 >> 2] = v;
                                    }
                                    while (0);
                                    if (!g) break;
                                    d = b[c + 28 >> 2] | 0;
                                    e = 23620 + (d << 2) | 0;
                                    do if ((b[e >> 2] | 0) != (c | 0)) {
                                        v = g + 16 | 0;
                                        b[((b[v >> 2] | 0) == (c | 0) ? v : g + 20 | 0) >> 2] = a;
                                        if (!a) break h;
                                    } else {
                                        b[e >> 2] = a;
                                        if (a | 0) break;
                                        b[5830] = b[5830] & ~(1 << d);
                                        break h;
                                    }
                                    while (0);
                                    b[a + 24 >> 2] = g;
                                    d = c + 16 | 0;
                                    e = b[d >> 2] | 0;
                                    if (e | 0) {
                                        b[a + 16 >> 2] = e;
                                        b[e + 24 >> 2] = a;
                                    }
                                    d = b[d + 4 >> 2] | 0;
                                    if (!d) break;
                                    b[a + 20 >> 2] = d;
                                    b[d + 24 >> 2] = a;
                                }
                                while (0);
                                c = c + h | 0;
                                f = h + i | 0;
                            } else f = i;
                            c = c + 4 | 0;
                            b[c >> 2] = b[c >> 2] & -2;
                            b[k + 4 >> 2] = f | 1;
                            b[k + f >> 2] = f;
                            c = f >>> 3;
                            if (f >>> 0 < 256) {
                                d = 23356 + (c << 1 << 2) | 0;
                                a = b[5829] | 0;
                                c = 1 << c;
                                if (!(a & c)) {
                                    b[5829] = a | c;
                                    c = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    c = b[a >> 2] | 0;
                                }
                                b[a >> 2] = k;
                                b[c + 12 >> 2] = k;
                                b[k + 8 >> 2] = c;
                                b[k + 12 >> 2] = d;
                                break;
                            }
                            c = f >>> 8;
                            do if (!c) e = 0;
                            else {
                                if (f >>> 0 > 16777215) {
                                    e = 31;
                                    break;
                                }
                                u = (c + 1048320 | 0) >>> 16 & 8;
                                v = c << u;
                                t = (v + 520192 | 0) >>> 16 & 4;
                                v = v << t;
                                e = (v + 245760 | 0) >>> 16 & 2;
                                e = 14 - (t | u | e) + (v << e >>> 15) | 0;
                                e = f >>> (e + 7 | 0) & 1 | e << 1;
                            }
                            while (0);
                            c = 23620 + (e << 2) | 0;
                            b[k + 28 >> 2] = e;
                            a = k + 16 | 0;
                            b[a + 4 >> 2] = 0;
                            b[a >> 2] = 0;
                            a = b[5830] | 0;
                            d = 1 << e;
                            if (!(a & d)) {
                                b[5830] = a | d;
                                b[c >> 2] = k;
                                b[k + 24 >> 2] = c;
                                b[k + 12 >> 2] = k;
                                b[k + 8 >> 2] = k;
                                break;
                            }
                            c = b[c >> 2] | 0;
                            i: do if ((b[c + 4 >> 2] & -8 | 0) != (f | 0)) {
                                e = f << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                                while(true){
                                    d = c + 16 + (e >>> 31 << 2) | 0;
                                    a = b[d >> 2] | 0;
                                    if (!a) break;
                                    if ((b[a + 4 >> 2] & -8 | 0) == (f | 0)) {
                                        c = a;
                                        break i;
                                    } else {
                                        e = e << 1;
                                        c = a;
                                    }
                                }
                                b[d >> 2] = k;
                                b[k + 24 >> 2] = c;
                                b[k + 12 >> 2] = k;
                                b[k + 8 >> 2] = k;
                                break g;
                            }
                            while (0);
                            u = c + 8 | 0;
                            v = b[u >> 2] | 0;
                            b[v + 12 >> 2] = k;
                            b[u >> 2] = k;
                            b[k + 8 >> 2] = v;
                            b[k + 12 >> 2] = c;
                            b[k + 24 >> 2] = 0;
                        }
                        while (0);
                        v = l + 8 | 0;
                        S = w;
                        return v | 0;
                    }
                    c = 23764;
                    while(true){
                        a = b[c >> 2] | 0;
                        if (a >>> 0 <= j >>> 0 ? (v = a + (b[c + 4 >> 2] | 0) | 0, v >>> 0 > j >>> 0) : 0) break;
                        c = b[c + 8 >> 2] | 0;
                    }
                    f = v + -47 | 0;
                    a = f + 8 | 0;
                    a = f + ((a & 7 | 0) == 0 ? 0 : 0 - a & 7) | 0;
                    f = j + 16 | 0;
                    a = a >>> 0 < f >>> 0 ? j : a;
                    c = a + 8 | 0;
                    d = h + -40 | 0;
                    t = g + 8 | 0;
                    t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                    u = g + t | 0;
                    t = d - t | 0;
                    b[5835] = u;
                    b[5832] = t;
                    b[u + 4 >> 2] = t | 1;
                    b[g + d + 4 >> 2] = 40;
                    b[5836] = b[5951];
                    d = a + 4 | 0;
                    b[d >> 2] = 27;
                    b[c >> 2] = b[5941];
                    b[c + 4 >> 2] = b[5942];
                    b[c + 8 >> 2] = b[5943];
                    b[c + 12 >> 2] = b[5944];
                    b[5941] = g;
                    b[5942] = h;
                    b[5944] = 0;
                    b[5943] = c;
                    c = a + 24 | 0;
                    do {
                        u = c;
                        c = c + 4 | 0;
                        b[c >> 2] = 7;
                    }while ((u + 8 | 0) >>> 0 < v >>> 0);
                    if ((a | 0) != (j | 0)) {
                        g = a - j | 0;
                        b[d >> 2] = b[d >> 2] & -2;
                        b[j + 4 >> 2] = g | 1;
                        b[a >> 2] = g;
                        c = g >>> 3;
                        if (g >>> 0 < 256) {
                            d = 23356 + (c << 1 << 2) | 0;
                            a = b[5829] | 0;
                            c = 1 << c;
                            if (!(a & c)) {
                                b[5829] = a | c;
                                c = d;
                                a = d + 8 | 0;
                            } else {
                                a = d + 8 | 0;
                                c = b[a >> 2] | 0;
                            }
                            b[a >> 2] = j;
                            b[c + 12 >> 2] = j;
                            b[j + 8 >> 2] = c;
                            b[j + 12 >> 2] = d;
                            break;
                        }
                        c = g >>> 8;
                        if (c) {
                            if (g >>> 0 > 16777215) e = 31;
                            else {
                                u = (c + 1048320 | 0) >>> 16 & 8;
                                v = c << u;
                                t = (v + 520192 | 0) >>> 16 & 4;
                                v = v << t;
                                e = (v + 245760 | 0) >>> 16 & 2;
                                e = 14 - (t | u | e) + (v << e >>> 15) | 0;
                                e = g >>> (e + 7 | 0) & 1 | e << 1;
                            }
                        } else e = 0;
                        d = 23620 + (e << 2) | 0;
                        b[j + 28 >> 2] = e;
                        b[j + 20 >> 2] = 0;
                        b[f >> 2] = 0;
                        c = b[5830] | 0;
                        a = 1 << e;
                        if (!(c & a)) {
                            b[5830] = c | a;
                            b[d >> 2] = j;
                            b[j + 24 >> 2] = d;
                            b[j + 12 >> 2] = j;
                            b[j + 8 >> 2] = j;
                            break;
                        }
                        c = b[d >> 2] | 0;
                        j: do if ((b[c + 4 >> 2] & -8 | 0) != (g | 0)) {
                            e = g << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                            while(true){
                                d = c + 16 + (e >>> 31 << 2) | 0;
                                a = b[d >> 2] | 0;
                                if (!a) break;
                                if ((b[a + 4 >> 2] & -8 | 0) == (g | 0)) {
                                    c = a;
                                    break j;
                                } else {
                                    e = e << 1;
                                    c = a;
                                }
                            }
                            b[d >> 2] = j;
                            b[j + 24 >> 2] = c;
                            b[j + 12 >> 2] = j;
                            b[j + 8 >> 2] = j;
                            break f;
                        }
                        while (0);
                        u = c + 8 | 0;
                        v = b[u >> 2] | 0;
                        b[v + 12 >> 2] = j;
                        b[u >> 2] = j;
                        b[j + 8 >> 2] = v;
                        b[j + 12 >> 2] = c;
                        b[j + 24 >> 2] = 0;
                    }
                } else {
                    v = b[5833] | 0;
                    if ((v | 0) == 0 | g >>> 0 < v >>> 0) b[5833] = g;
                    b[5941] = g;
                    b[5942] = h;
                    b[5944] = 0;
                    b[5838] = b[5947];
                    b[5837] = -1;
                    b[5842] = 23356;
                    b[5841] = 23356;
                    b[5844] = 23364;
                    b[5843] = 23364;
                    b[5846] = 23372;
                    b[5845] = 23372;
                    b[5848] = 23380;
                    b[5847] = 23380;
                    b[5850] = 23388;
                    b[5849] = 23388;
                    b[5852] = 23396;
                    b[5851] = 23396;
                    b[5854] = 23404;
                    b[5853] = 23404;
                    b[5856] = 23412;
                    b[5855] = 23412;
                    b[5858] = 23420;
                    b[5857] = 23420;
                    b[5860] = 23428;
                    b[5859] = 23428;
                    b[5862] = 23436;
                    b[5861] = 23436;
                    b[5864] = 23444;
                    b[5863] = 23444;
                    b[5866] = 23452;
                    b[5865] = 23452;
                    b[5868] = 23460;
                    b[5867] = 23460;
                    b[5870] = 23468;
                    b[5869] = 23468;
                    b[5872] = 23476;
                    b[5871] = 23476;
                    b[5874] = 23484;
                    b[5873] = 23484;
                    b[5876] = 23492;
                    b[5875] = 23492;
                    b[5878] = 23500;
                    b[5877] = 23500;
                    b[5880] = 23508;
                    b[5879] = 23508;
                    b[5882] = 23516;
                    b[5881] = 23516;
                    b[5884] = 23524;
                    b[5883] = 23524;
                    b[5886] = 23532;
                    b[5885] = 23532;
                    b[5888] = 23540;
                    b[5887] = 23540;
                    b[5890] = 23548;
                    b[5889] = 23548;
                    b[5892] = 23556;
                    b[5891] = 23556;
                    b[5894] = 23564;
                    b[5893] = 23564;
                    b[5896] = 23572;
                    b[5895] = 23572;
                    b[5898] = 23580;
                    b[5897] = 23580;
                    b[5900] = 23588;
                    b[5899] = 23588;
                    b[5902] = 23596;
                    b[5901] = 23596;
                    b[5904] = 23604;
                    b[5903] = 23604;
                    v = h + -40 | 0;
                    t = g + 8 | 0;
                    t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                    u = g + t | 0;
                    t = v - t | 0;
                    b[5835] = u;
                    b[5832] = t;
                    b[u + 4 >> 2] = t | 1;
                    b[g + v + 4 >> 2] = 40;
                    b[5836] = b[5951];
                }
                while (0);
                c = b[5832] | 0;
                if (c >>> 0 > m >>> 0) {
                    t = c - m | 0;
                    b[5832] = t;
                    v = b[5835] | 0;
                    u = v + m | 0;
                    b[5835] = u;
                    b[u + 4 >> 2] = t | 1;
                    b[v + 4 >> 2] = m | 3;
                    v = v + 8 | 0;
                    S = w;
                    return v | 0;
                }
            }
            v = Tc() | 0;
            b[v >> 2] = 12;
            v = 0;
            S = w;
            return v | 0;
        }
        function Xc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            if (!a) return;
            d = a + -8 | 0;
            f = b[5833] | 0;
            a = b[a + -4 >> 2] | 0;
            c = a & -8;
            j = d + c | 0;
            do if (!(a & 1)) {
                e = b[d >> 2] | 0;
                if (!(a & 3)) return;
                h = d + (0 - e) | 0;
                g = e + c | 0;
                if (h >>> 0 < f >>> 0) return;
                if ((b[5834] | 0) == (h | 0)) {
                    a = j + 4 | 0;
                    c = b[a >> 2] | 0;
                    if ((c & 3 | 0) != 3) {
                        i = h;
                        c = g;
                        break;
                    }
                    b[5831] = g;
                    b[a >> 2] = c & -2;
                    b[h + 4 >> 2] = g | 1;
                    b[h + g >> 2] = g;
                    return;
                }
                d = e >>> 3;
                if (e >>> 0 < 256) {
                    a = b[h + 8 >> 2] | 0;
                    c = b[h + 12 >> 2] | 0;
                    if ((c | 0) == (a | 0)) {
                        b[5829] = b[5829] & ~(1 << d);
                        i = h;
                        c = g;
                        break;
                    } else {
                        b[a + 12 >> 2] = c;
                        b[c + 8 >> 2] = a;
                        i = h;
                        c = g;
                        break;
                    }
                }
                f = b[h + 24 >> 2] | 0;
                a = b[h + 12 >> 2] | 0;
                do if ((a | 0) == (h | 0)) {
                    c = h + 16 | 0;
                    d = c + 4 | 0;
                    a = b[d >> 2] | 0;
                    if (!a) {
                        a = b[c >> 2] | 0;
                        if (!a) {
                            a = 0;
                            break;
                        }
                    } else c = d;
                    while(true){
                        e = a + 20 | 0;
                        d = b[e >> 2] | 0;
                        if (!d) {
                            e = a + 16 | 0;
                            d = b[e >> 2] | 0;
                            if (!d) break;
                            else {
                                a = d;
                                c = e;
                            }
                        } else {
                            a = d;
                            c = e;
                        }
                    }
                    b[c >> 2] = 0;
                } else {
                    i = b[h + 8 >> 2] | 0;
                    b[i + 12 >> 2] = a;
                    b[a + 8 >> 2] = i;
                }
                while (0);
                if (f) {
                    c = b[h + 28 >> 2] | 0;
                    d = 23620 + (c << 2) | 0;
                    if ((b[d >> 2] | 0) == (h | 0)) {
                        b[d >> 2] = a;
                        if (!a) {
                            b[5830] = b[5830] & ~(1 << c);
                            i = h;
                            c = g;
                            break;
                        }
                    } else {
                        i = f + 16 | 0;
                        b[((b[i >> 2] | 0) == (h | 0) ? i : f + 20 | 0) >> 2] = a;
                        if (!a) {
                            i = h;
                            c = g;
                            break;
                        }
                    }
                    b[a + 24 >> 2] = f;
                    c = h + 16 | 0;
                    d = b[c >> 2] | 0;
                    if (d | 0) {
                        b[a + 16 >> 2] = d;
                        b[d + 24 >> 2] = a;
                    }
                    c = b[c + 4 >> 2] | 0;
                    if (c) {
                        b[a + 20 >> 2] = c;
                        b[c + 24 >> 2] = a;
                        i = h;
                        c = g;
                    } else {
                        i = h;
                        c = g;
                    }
                } else {
                    i = h;
                    c = g;
                }
            } else {
                i = d;
                h = d;
            }
            while (0);
            if (h >>> 0 >= j >>> 0) return;
            a = j + 4 | 0;
            e = b[a >> 2] | 0;
            if (!(e & 1)) return;
            if (!(e & 2)) {
                if ((b[5835] | 0) == (j | 0)) {
                    j = (b[5832] | 0) + c | 0;
                    b[5832] = j;
                    b[5835] = i;
                    b[i + 4 >> 2] = j | 1;
                    if ((i | 0) != (b[5834] | 0)) return;
                    b[5834] = 0;
                    b[5831] = 0;
                    return;
                }
                if ((b[5834] | 0) == (j | 0)) {
                    j = (b[5831] | 0) + c | 0;
                    b[5831] = j;
                    b[5834] = h;
                    b[i + 4 >> 2] = j | 1;
                    b[h + j >> 2] = j;
                    return;
                }
                f = (e & -8) + c | 0;
                d = e >>> 3;
                do if (e >>> 0 < 256) {
                    c = b[j + 8 >> 2] | 0;
                    a = b[j + 12 >> 2] | 0;
                    if ((a | 0) == (c | 0)) {
                        b[5829] = b[5829] & ~(1 << d);
                        break;
                    } else {
                        b[c + 12 >> 2] = a;
                        b[a + 8 >> 2] = c;
                        break;
                    }
                } else {
                    g = b[j + 24 >> 2] | 0;
                    a = b[j + 12 >> 2] | 0;
                    do if ((a | 0) == (j | 0)) {
                        c = j + 16 | 0;
                        d = c + 4 | 0;
                        a = b[d >> 2] | 0;
                        if (!a) {
                            a = b[c >> 2] | 0;
                            if (!a) {
                                d = 0;
                                break;
                            }
                        } else c = d;
                        while(true){
                            e = a + 20 | 0;
                            d = b[e >> 2] | 0;
                            if (!d) {
                                e = a + 16 | 0;
                                d = b[e >> 2] | 0;
                                if (!d) break;
                                else {
                                    a = d;
                                    c = e;
                                }
                            } else {
                                a = d;
                                c = e;
                            }
                        }
                        b[c >> 2] = 0;
                        d = a;
                    } else {
                        d = b[j + 8 >> 2] | 0;
                        b[d + 12 >> 2] = a;
                        b[a + 8 >> 2] = d;
                        d = a;
                    }
                    while (0);
                    if (g | 0) {
                        a = b[j + 28 >> 2] | 0;
                        c = 23620 + (a << 2) | 0;
                        if ((b[c >> 2] | 0) == (j | 0)) {
                            b[c >> 2] = d;
                            if (!d) {
                                b[5830] = b[5830] & ~(1 << a);
                                break;
                            }
                        } else {
                            e = g + 16 | 0;
                            b[((b[e >> 2] | 0) == (j | 0) ? e : g + 20 | 0) >> 2] = d;
                            if (!d) break;
                        }
                        b[d + 24 >> 2] = g;
                        a = j + 16 | 0;
                        c = b[a >> 2] | 0;
                        if (c | 0) {
                            b[d + 16 >> 2] = c;
                            b[c + 24 >> 2] = d;
                        }
                        a = b[a + 4 >> 2] | 0;
                        if (a | 0) {
                            b[d + 20 >> 2] = a;
                            b[a + 24 >> 2] = d;
                        }
                    }
                }
                while (0);
                b[i + 4 >> 2] = f | 1;
                b[h + f >> 2] = f;
                if ((i | 0) == (b[5834] | 0)) {
                    b[5831] = f;
                    return;
                }
            } else {
                b[a >> 2] = e & -2;
                b[i + 4 >> 2] = c | 1;
                b[h + c >> 2] = c;
                f = c;
            }
            a = f >>> 3;
            if (f >>> 0 < 256) {
                d = 23356 + (a << 1 << 2) | 0;
                c = b[5829] | 0;
                a = 1 << a;
                if (!(c & a)) {
                    b[5829] = c | a;
                    a = d;
                    c = d + 8 | 0;
                } else {
                    c = d + 8 | 0;
                    a = b[c >> 2] | 0;
                }
                b[c >> 2] = i;
                b[a + 12 >> 2] = i;
                b[i + 8 >> 2] = a;
                b[i + 12 >> 2] = d;
                return;
            }
            a = f >>> 8;
            if (a) {
                if (f >>> 0 > 16777215) e = 31;
                else {
                    h = (a + 1048320 | 0) >>> 16 & 8;
                    j = a << h;
                    g = (j + 520192 | 0) >>> 16 & 4;
                    j = j << g;
                    e = (j + 245760 | 0) >>> 16 & 2;
                    e = 14 - (g | h | e) + (j << e >>> 15) | 0;
                    e = f >>> (e + 7 | 0) & 1 | e << 1;
                }
            } else e = 0;
            a = 23620 + (e << 2) | 0;
            b[i + 28 >> 2] = e;
            b[i + 20 >> 2] = 0;
            b[i + 16 >> 2] = 0;
            c = b[5830] | 0;
            d = 1 << e;
            a: do if (!(c & d)) {
                b[5830] = c | d;
                b[a >> 2] = i;
                b[i + 24 >> 2] = a;
                b[i + 12 >> 2] = i;
                b[i + 8 >> 2] = i;
            } else {
                a = b[a >> 2] | 0;
                b: do if ((b[a + 4 >> 2] & -8 | 0) != (f | 0)) {
                    e = f << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                    while(true){
                        d = a + 16 + (e >>> 31 << 2) | 0;
                        c = b[d >> 2] | 0;
                        if (!c) break;
                        if ((b[c + 4 >> 2] & -8 | 0) == (f | 0)) {
                            a = c;
                            break b;
                        } else {
                            e = e << 1;
                            a = c;
                        }
                    }
                    b[d >> 2] = i;
                    b[i + 24 >> 2] = a;
                    b[i + 12 >> 2] = i;
                    b[i + 8 >> 2] = i;
                    break a;
                }
                while (0);
                h = a + 8 | 0;
                j = b[h >> 2] | 0;
                b[j + 12 >> 2] = i;
                b[h >> 2] = i;
                b[i + 8 >> 2] = j;
                b[i + 12 >> 2] = a;
                b[i + 24 >> 2] = 0;
            }
            while (0);
            j = (b[5837] | 0) + -1 | 0;
            b[5837] = j;
            if (j | 0) return;
            a = 23772;
            while(true){
                a = b[a >> 2] | 0;
                if (!a) break;
                else a = a + 8 | 0;
            }
            b[5837] = -1;
            return;
        }
        function Yc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            if (a) {
                d = B(c, a) | 0;
                if ((c | a) >>> 0 > 65535) d = ((d >>> 0) / (a >>> 0) | 0) == (c | 0) ? d : -1;
            } else d = 0;
            a = Wc(d) | 0;
            if (!a) return a | 0;
            if (!(b[a + -4 >> 2] & 3)) return a | 0;
            hd(a | 0, 0, d | 0);
            return a | 0;
        }
        function Zc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            c = a + c >>> 0;
            return (F(b + d + (c >>> 0 < a >>> 0 | 0) >>> 0 | 0), c | 0) | 0;
        }
        function _c(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            d = b - d - (c >>> 0 > a >>> 0 | 0) >>> 0;
            return (F(d | 0), a - c >>> 0 | 0) | 0;
        }
        function $c(a) {
            a = a | 0;
            return (a ? 31 - (D(a ^ a - 1) | 0) | 0 : 32) | 0;
        }
        function ad(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            l = a;
            j = c;
            k = j;
            h = d;
            n = e;
            i = n;
            if (!k) {
                g = (f | 0) != 0;
                if (!i) {
                    if (g) {
                        b[f >> 2] = (l >>> 0) % (h >>> 0);
                        b[f + 4 >> 2] = 0;
                    }
                    n = 0;
                    f = (l >>> 0) / (h >>> 0) >>> 0;
                    return (F(n | 0), f) | 0;
                } else {
                    if (!g) {
                        n = 0;
                        f = 0;
                        return (F(n | 0), f) | 0;
                    }
                    b[f >> 2] = a | 0;
                    b[f + 4 >> 2] = c & 0;
                    n = 0;
                    f = 0;
                    return (F(n | 0), f) | 0;
                }
            }
            g = (i | 0) == 0;
            do if (h) {
                if (!g) {
                    g = (D(i | 0) | 0) - (D(k | 0) | 0) | 0;
                    if (g >>> 0 <= 31) {
                        m = g + 1 | 0;
                        i = 31 - g | 0;
                        c = g - 31 >> 31;
                        h = m;
                        a = l >>> (m >>> 0) & c | k << i;
                        c = k >>> (m >>> 0) & c;
                        g = 0;
                        i = l << i;
                        break;
                    }
                    if (!f) {
                        n = 0;
                        f = 0;
                        return (F(n | 0), f) | 0;
                    }
                    b[f >> 2] = a | 0;
                    b[f + 4 >> 2] = j | c & 0;
                    n = 0;
                    f = 0;
                    return (F(n | 0), f) | 0;
                }
                g = h - 1 | 0;
                if (g & h | 0) {
                    i = (D(h | 0) | 0) + 33 - (D(k | 0) | 0) | 0;
                    p = 64 - i | 0;
                    m = 32 - i | 0;
                    j = m >> 31;
                    o = i - 32 | 0;
                    c = o >> 31;
                    h = i;
                    a = m - 1 >> 31 & k >>> (o >>> 0) | (k << m | l >>> (i >>> 0)) & c;
                    c = c & k >>> (i >>> 0);
                    g = l << p & j;
                    i = (k << p | l >>> (o >>> 0)) & j | l << m & i - 33 >> 31;
                    break;
                }
                if (f | 0) {
                    b[f >> 2] = g & l;
                    b[f + 4 >> 2] = 0;
                }
                if ((h | 0) == 1) {
                    o = j | c & 0;
                    p = a | 0;
                    return (F(o | 0), p) | 0;
                } else {
                    p = $c(h | 0) | 0;
                    o = k >>> (p >>> 0) | 0;
                    p = k << 32 - p | l >>> (p >>> 0) | 0;
                    return (F(o | 0), p) | 0;
                }
            } else {
                if (g) {
                    if (f | 0) {
                        b[f >> 2] = (k >>> 0) % (h >>> 0);
                        b[f + 4 >> 2] = 0;
                    }
                    o = 0;
                    p = (k >>> 0) / (h >>> 0) >>> 0;
                    return (F(o | 0), p) | 0;
                }
                if (!l) {
                    if (f | 0) {
                        b[f >> 2] = 0;
                        b[f + 4 >> 2] = (k >>> 0) % (i >>> 0);
                    }
                    o = 0;
                    p = (k >>> 0) / (i >>> 0) >>> 0;
                    return (F(o | 0), p) | 0;
                }
                g = i - 1 | 0;
                if (!(g & i)) {
                    if (f | 0) {
                        b[f >> 2] = a | 0;
                        b[f + 4 >> 2] = g & k | c & 0;
                    }
                    o = 0;
                    p = k >>> (($c(i | 0) | 0) >>> 0);
                    return (F(o | 0), p) | 0;
                }
                g = (D(i | 0) | 0) - (D(k | 0) | 0) | 0;
                if (g >>> 0 <= 30) {
                    c = g + 1 | 0;
                    i = 31 - g | 0;
                    h = c;
                    a = k << i | l >>> (c >>> 0);
                    c = k >>> (c >>> 0);
                    g = 0;
                    i = l << i;
                    break;
                }
                if (!f) {
                    o = 0;
                    p = 0;
                    return (F(o | 0), p) | 0;
                }
                b[f >> 2] = a | 0;
                b[f + 4 >> 2] = j | c & 0;
                o = 0;
                p = 0;
                return (F(o | 0), p) | 0;
            }
            while (0);
            if (!h) {
                k = i;
                j = 0;
                i = 0;
            } else {
                m = d | 0;
                l = n | e & 0;
                k = Zc(m | 0, l | 0, -1, -1) | 0;
                d = G() | 0;
                j = i;
                i = 0;
                do {
                    e = j;
                    j = g >>> 31 | j << 1;
                    g = i | g << 1;
                    e = a << 1 | e >>> 31 | 0;
                    n = a >>> 31 | c << 1 | 0;
                    _c(k | 0, d | 0, e | 0, n | 0);
                    p = G() | 0;
                    o = p >> 31 | ((p | 0) < 0 ? -1 : 0) << 1;
                    i = o & 1;
                    a = _c(e | 0, n | 0, o & m | 0, (((p | 0) < 0 ? -1 : 0) >> 31 | ((p | 0) < 0 ? -1 : 0) << 1) & l | 0) | 0;
                    c = G() | 0;
                    h = h - 1 | 0;
                }while ((h | 0) != 0);
                k = j;
                j = 0;
            }
            h = 0;
            if (f | 0) {
                b[f >> 2] = a;
                b[f + 4 >> 2] = c;
            }
            o = (g | 0) >>> 31 | (k | h) << 1 | (h << 1 | g >>> 31) & 0 | j;
            p = (g << 1 | 0) & -2 | i;
            return (F(o | 0), p) | 0;
        }
        function bd(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = S;
            S = S + 16 | 0;
            f = g | 0;
            ad(a, c, d, e, f);
            S = g;
            return (F(b[f + 4 >> 2] | 0), b[f >> 2] | 0) | 0;
        }
        function cd(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                F(b >>> c | 0);
                return a >>> c | (b & (1 << c) - 1) << 32 - c;
            }
            F(0);
            return b >>> c - 32 | 0;
        }
        function dd(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                F(b << c | (a & (1 << c) - 1 << 32 - c) >>> 32 - c | 0);
                return a << c;
            }
            F(a << c - 32 | 0);
            return 0;
        }
        function ed(a, b) {
            a = +a;
            b = +b;
            if (a != a) return +b;
            if (b != b) return +a;
            return +C(+a, +b);
        }
        function fd(a) {
            a = +a;
            return a >= 0.0 ? +p(a + .5) : +A(a - .5);
        }
        function gd(c, d, e) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0;
            if ((e | 0) >= 8192) {
                K(c | 0, d | 0, e | 0);
                return c | 0;
            }
            h = c | 0;
            g = c + e | 0;
            if ((c & 3) == (d & 3)) {
                while(c & 3){
                    if (!e) return h | 0;
                    a[c >> 0] = a[d >> 0] | 0;
                    c = c + 1 | 0;
                    d = d + 1 | 0;
                    e = e - 1 | 0;
                }
                e = g & -4 | 0;
                f = e - 64 | 0;
                while((c | 0) <= (f | 0)){
                    b[c >> 2] = b[d >> 2];
                    b[c + 4 >> 2] = b[d + 4 >> 2];
                    b[c + 8 >> 2] = b[d + 8 >> 2];
                    b[c + 12 >> 2] = b[d + 12 >> 2];
                    b[c + 16 >> 2] = b[d + 16 >> 2];
                    b[c + 20 >> 2] = b[d + 20 >> 2];
                    b[c + 24 >> 2] = b[d + 24 >> 2];
                    b[c + 28 >> 2] = b[d + 28 >> 2];
                    b[c + 32 >> 2] = b[d + 32 >> 2];
                    b[c + 36 >> 2] = b[d + 36 >> 2];
                    b[c + 40 >> 2] = b[d + 40 >> 2];
                    b[c + 44 >> 2] = b[d + 44 >> 2];
                    b[c + 48 >> 2] = b[d + 48 >> 2];
                    b[c + 52 >> 2] = b[d + 52 >> 2];
                    b[c + 56 >> 2] = b[d + 56 >> 2];
                    b[c + 60 >> 2] = b[d + 60 >> 2];
                    c = c + 64 | 0;
                    d = d + 64 | 0;
                }
                while((c | 0) < (e | 0)){
                    b[c >> 2] = b[d >> 2];
                    c = c + 4 | 0;
                    d = d + 4 | 0;
                }
            } else {
                e = g - 4 | 0;
                while((c | 0) < (e | 0)){
                    a[c >> 0] = a[d >> 0] | 0;
                    a[c + 1 >> 0] = a[d + 1 >> 0] | 0;
                    a[c + 2 >> 0] = a[d + 2 >> 0] | 0;
                    a[c + 3 >> 0] = a[d + 3 >> 0] | 0;
                    c = c + 4 | 0;
                    d = d + 4 | 0;
                }
            }
            while((c | 0) < (g | 0)){
                a[c >> 0] = a[d >> 0] | 0;
                c = c + 1 | 0;
                d = d + 1 | 0;
            }
            return h | 0;
        }
        function hd(c, d, e) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = c + e | 0;
            d = d & 255;
            if ((e | 0) >= 67) {
                while(c & 3){
                    a[c >> 0] = d;
                    c = c + 1 | 0;
                }
                f = h & -4 | 0;
                i = d | d << 8 | d << 16 | d << 24;
                g = f - 64 | 0;
                while((c | 0) <= (g | 0)){
                    b[c >> 2] = i;
                    b[c + 4 >> 2] = i;
                    b[c + 8 >> 2] = i;
                    b[c + 12 >> 2] = i;
                    b[c + 16 >> 2] = i;
                    b[c + 20 >> 2] = i;
                    b[c + 24 >> 2] = i;
                    b[c + 28 >> 2] = i;
                    b[c + 32 >> 2] = i;
                    b[c + 36 >> 2] = i;
                    b[c + 40 >> 2] = i;
                    b[c + 44 >> 2] = i;
                    b[c + 48 >> 2] = i;
                    b[c + 52 >> 2] = i;
                    b[c + 56 >> 2] = i;
                    b[c + 60 >> 2] = i;
                    c = c + 64 | 0;
                }
                while((c | 0) < (f | 0)){
                    b[c >> 2] = i;
                    c = c + 4 | 0;
                }
            }
            while((c | 0) < (h | 0)){
                a[c >> 0] = d;
                c = c + 1 | 0;
            }
            return h - e | 0;
        }
        function id(a) {
            a = +a;
            return a >= 0.0 ? +p(a + .5) : +A(a - .5);
        }
        function jd(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            e = J() | 0;
            d = b[g >> 2] | 0;
            c = d + a | 0;
            if ((a | 0) > 0 & (c | 0) < (d | 0) | (c | 0) < 0) {
                M(c | 0);
                I(12);
                return -1;
            }
            if ((c | 0) > (e | 0)) {
                if (!(L(c | 0) | 0)) {
                    I(12);
                    return -1;
                }
            }
            b[g >> 2] = c;
            return d | 0;
        } // EMSCRIPTEN_END_FUNCS
        return {
            ___uremdi3: bd,
            _bitshift64Lshr: cd,
            _bitshift64Shl: dd,
            _calloc: Yc,
            _cellAreaKm2: ub,
            _cellAreaM2: vb,
            _cellAreaRads2: tb,
            _compact: Hb,
            _destroyLinkedPolygon: jc,
            _edgeLengthKm: pb,
            _edgeLengthM: qb,
            _emscripten_replace_memory: V,
            _exactEdgeLengthKm: xb,
            _exactEdgeLengthM: yb,
            _exactEdgeLengthRads: wb,
            _experimentalH3ToLocalIj: oc,
            _experimentalLocalIjToH3: pc,
            _free: Xc,
            _geoToH3: Sb,
            _getDestinationH3IndexFromUnidirectionalEdge: cc,
            _getH3IndexesFromUnidirectionalEdge: ec,
            _getH3UnidirectionalEdge: ac,
            _getH3UnidirectionalEdgeBoundary: gc,
            _getH3UnidirectionalEdgesFromHexagon: fc,
            _getOriginH3IndexFromUnidirectionalEdge: bc,
            _getPentagonIndexes: _b,
            _getRes0Indexes: va,
            _h3Distance: qc,
            _h3GetBaseCell: Ab,
            _h3GetFaces: Yb,
            _h3GetResolution: zb,
            _h3IndexesAreNeighbors: $b,
            _h3IsPentagon: Fb,
            _h3IsResClassIII: Kb,
            _h3IsValid: Bb,
            _h3Line: sc,
            _h3LineSize: rc,
            _h3SetToLinkedGeo: ka,
            _h3ToCenterChild: Gb,
            _h3ToChildren: Eb,
            _h3ToGeo: Vb,
            _h3ToGeoBoundary: Wb,
            _h3ToParent: Cb,
            _h3UnidirectionalEdgeIsValid: dc,
            _hexAreaKm2: nb,
            _hexAreaM2: ob,
            _hexRing: ea,
            _i64Subtract: _c,
            _kRing: $,
            _kRingDistances: aa,
            _llvm_minnum_f64: ed,
            _llvm_round_f64: fd,
            _malloc: Wc,
            _maxFaceCount: Xb,
            _maxH3ToChildrenSize: Db,
            _maxKringSize: _,
            _maxPolyfillSize: fa,
            _maxUncompactSize: Jb,
            _memcpy: gd,
            _memset: hd,
            _numHexagons: rb,
            _pentagonIndexCount: Zb,
            _pointDistKm: jb,
            _pointDistM: kb,
            _pointDistRads: ib,
            _polyfill: ga,
            _res0IndexCount: ua,
            _round: id,
            _sbrk: jd,
            _sizeOfCoordIJ: Ec,
            _sizeOfGeoBoundary: Ac,
            _sizeOfGeoCoord: zc,
            _sizeOfGeoPolygon: Cc,
            _sizeOfGeofence: Bc,
            _sizeOfH3Index: yc,
            _sizeOfLinkedGeoPolygon: Dc,
            _uncompact: Ib,
            establishStackSpace: Z,
            stackAlloc: W,
            stackRestore: Y,
            stackSave: X
        };
    }(asmGlobalArg, asmLibraryArg, buffer);
    var ___uremdi3 = Module["___uremdi3"] = asm["___uremdi3"];
    var _bitshift64Lshr = Module["_bitshift64Lshr"] = asm["_bitshift64Lshr"];
    var _bitshift64Shl = Module["_bitshift64Shl"] = asm["_bitshift64Shl"];
    var _calloc = Module["_calloc"] = asm["_calloc"];
    var _cellAreaKm2 = Module["_cellAreaKm2"] = asm["_cellAreaKm2"];
    var _cellAreaM2 = Module["_cellAreaM2"] = asm["_cellAreaM2"];
    var _cellAreaRads2 = Module["_cellAreaRads2"] = asm["_cellAreaRads2"];
    var _compact = Module["_compact"] = asm["_compact"];
    var _destroyLinkedPolygon = Module["_destroyLinkedPolygon"] = asm["_destroyLinkedPolygon"];
    var _edgeLengthKm = Module["_edgeLengthKm"] = asm["_edgeLengthKm"];
    var _edgeLengthM = Module["_edgeLengthM"] = asm["_edgeLengthM"];
    var _emscripten_replace_memory = Module["_emscripten_replace_memory"] = asm["_emscripten_replace_memory"];
    var _exactEdgeLengthKm = Module["_exactEdgeLengthKm"] = asm["_exactEdgeLengthKm"];
    var _exactEdgeLengthM = Module["_exactEdgeLengthM"] = asm["_exactEdgeLengthM"];
    var _exactEdgeLengthRads = Module["_exactEdgeLengthRads"] = asm["_exactEdgeLengthRads"];
    var _experimentalH3ToLocalIj = Module["_experimentalH3ToLocalIj"] = asm["_experimentalH3ToLocalIj"];
    var _experimentalLocalIjToH3 = Module["_experimentalLocalIjToH3"] = asm["_experimentalLocalIjToH3"];
    var _free = Module["_free"] = asm["_free"];
    var _geoToH3 = Module["_geoToH3"] = asm["_geoToH3"];
    var _getDestinationH3IndexFromUnidirectionalEdge = Module["_getDestinationH3IndexFromUnidirectionalEdge"] = asm["_getDestinationH3IndexFromUnidirectionalEdge"];
    var _getH3IndexesFromUnidirectionalEdge = Module["_getH3IndexesFromUnidirectionalEdge"] = asm["_getH3IndexesFromUnidirectionalEdge"];
    var _getH3UnidirectionalEdge = Module["_getH3UnidirectionalEdge"] = asm["_getH3UnidirectionalEdge"];
    var _getH3UnidirectionalEdgeBoundary = Module["_getH3UnidirectionalEdgeBoundary"] = asm["_getH3UnidirectionalEdgeBoundary"];
    var _getH3UnidirectionalEdgesFromHexagon = Module["_getH3UnidirectionalEdgesFromHexagon"] = asm["_getH3UnidirectionalEdgesFromHexagon"];
    var _getOriginH3IndexFromUnidirectionalEdge = Module["_getOriginH3IndexFromUnidirectionalEdge"] = asm["_getOriginH3IndexFromUnidirectionalEdge"];
    var _getPentagonIndexes = Module["_getPentagonIndexes"] = asm["_getPentagonIndexes"];
    var _getRes0Indexes = Module["_getRes0Indexes"] = asm["_getRes0Indexes"];
    var _h3Distance = Module["_h3Distance"] = asm["_h3Distance"];
    var _h3GetBaseCell = Module["_h3GetBaseCell"] = asm["_h3GetBaseCell"];
    var _h3GetFaces = Module["_h3GetFaces"] = asm["_h3GetFaces"];
    var _h3GetResolution = Module["_h3GetResolution"] = asm["_h3GetResolution"];
    var _h3IndexesAreNeighbors = Module["_h3IndexesAreNeighbors"] = asm["_h3IndexesAreNeighbors"];
    var _h3IsPentagon = Module["_h3IsPentagon"] = asm["_h3IsPentagon"];
    var _h3IsResClassIII = Module["_h3IsResClassIII"] = asm["_h3IsResClassIII"];
    var _h3IsValid = Module["_h3IsValid"] = asm["_h3IsValid"];
    var _h3Line = Module["_h3Line"] = asm["_h3Line"];
    var _h3LineSize = Module["_h3LineSize"] = asm["_h3LineSize"];
    var _h3SetToLinkedGeo = Module["_h3SetToLinkedGeo"] = asm["_h3SetToLinkedGeo"];
    var _h3ToCenterChild = Module["_h3ToCenterChild"] = asm["_h3ToCenterChild"];
    var _h3ToChildren = Module["_h3ToChildren"] = asm["_h3ToChildren"];
    var _h3ToGeo = Module["_h3ToGeo"] = asm["_h3ToGeo"];
    var _h3ToGeoBoundary = Module["_h3ToGeoBoundary"] = asm["_h3ToGeoBoundary"];
    var _h3ToParent = Module["_h3ToParent"] = asm["_h3ToParent"];
    var _h3UnidirectionalEdgeIsValid = Module["_h3UnidirectionalEdgeIsValid"] = asm["_h3UnidirectionalEdgeIsValid"];
    var _hexAreaKm2 = Module["_hexAreaKm2"] = asm["_hexAreaKm2"];
    var _hexAreaM2 = Module["_hexAreaM2"] = asm["_hexAreaM2"];
    var _hexRing = Module["_hexRing"] = asm["_hexRing"];
    var _i64Subtract = Module["_i64Subtract"] = asm["_i64Subtract"];
    var _kRing = Module["_kRing"] = asm["_kRing"];
    var _kRingDistances = Module["_kRingDistances"] = asm["_kRingDistances"];
    var _llvm_minnum_f64 = Module["_llvm_minnum_f64"] = asm["_llvm_minnum_f64"];
    var _llvm_round_f64 = Module["_llvm_round_f64"] = asm["_llvm_round_f64"];
    var _malloc = Module["_malloc"] = asm["_malloc"];
    var _maxFaceCount = Module["_maxFaceCount"] = asm["_maxFaceCount"];
    var _maxH3ToChildrenSize = Module["_maxH3ToChildrenSize"] = asm["_maxH3ToChildrenSize"];
    var _maxKringSize = Module["_maxKringSize"] = asm["_maxKringSize"];
    var _maxPolyfillSize = Module["_maxPolyfillSize"] = asm["_maxPolyfillSize"];
    var _maxUncompactSize = Module["_maxUncompactSize"] = asm["_maxUncompactSize"];
    var _memcpy = Module["_memcpy"] = asm["_memcpy"];
    var _memset = Module["_memset"] = asm["_memset"];
    var _numHexagons = Module["_numHexagons"] = asm["_numHexagons"];
    var _pentagonIndexCount = Module["_pentagonIndexCount"] = asm["_pentagonIndexCount"];
    var _pointDistKm = Module["_pointDistKm"] = asm["_pointDistKm"];
    var _pointDistM = Module["_pointDistM"] = asm["_pointDistM"];
    var _pointDistRads = Module["_pointDistRads"] = asm["_pointDistRads"];
    var _polyfill = Module["_polyfill"] = asm["_polyfill"];
    var _res0IndexCount = Module["_res0IndexCount"] = asm["_res0IndexCount"];
    var _round = Module["_round"] = asm["_round"];
    var _sbrk = Module["_sbrk"] = asm["_sbrk"];
    var _sizeOfCoordIJ = Module["_sizeOfCoordIJ"] = asm["_sizeOfCoordIJ"];
    var _sizeOfGeoBoundary = Module["_sizeOfGeoBoundary"] = asm["_sizeOfGeoBoundary"];
    var _sizeOfGeoCoord = Module["_sizeOfGeoCoord"] = asm["_sizeOfGeoCoord"];
    var _sizeOfGeoPolygon = Module["_sizeOfGeoPolygon"] = asm["_sizeOfGeoPolygon"];
    var _sizeOfGeofence = Module["_sizeOfGeofence"] = asm["_sizeOfGeofence"];
    var _sizeOfH3Index = Module["_sizeOfH3Index"] = asm["_sizeOfH3Index"];
    var _sizeOfLinkedGeoPolygon = Module["_sizeOfLinkedGeoPolygon"] = asm["_sizeOfLinkedGeoPolygon"];
    var _uncompact = Module["_uncompact"] = asm["_uncompact"];
    var establishStackSpace = Module["establishStackSpace"] = asm["establishStackSpace"];
    var stackAlloc = Module["stackAlloc"] = asm["stackAlloc"];
    var stackRestore = Module["stackRestore"] = asm["stackRestore"];
    var stackSave = Module["stackSave"] = asm["stackSave"];
    Module["asm"] = asm;
    Module["cwrap"] = cwrap;
    Module["setValue"] = setValue;
    Module["getValue"] = getValue;
    Module["getTempRet0"] = getTempRet0;
    if (memoryInitializer) {
        if (!isDataURI(memoryInitializer)) memoryInitializer = locateFile(memoryInitializer);
        addRunDependency("memory initializer");
        var applyMemoryInitializer = function(data) {
            if (data.byteLength) data = new Uint8Array(data);
            HEAPU8.set(data, GLOBAL_BASE);
            if (Module["memoryInitializerRequest"]) delete Module["memoryInitializerRequest"].response;
            removeRunDependency("memory initializer");
        };
        var doBrowserLoad = function() {
            readAsync(memoryInitializer, applyMemoryInitializer, function() {
                throw "could not load memory initializer " + memoryInitializer;
            });
        };
        var memoryInitializerBytes = tryParseAsDataURI(memoryInitializer);
        if (memoryInitializerBytes) applyMemoryInitializer(memoryInitializerBytes.buffer);
        else if (Module["memoryInitializerRequest"]) {
            var useRequest = function() {
                var request = Module["memoryInitializerRequest"];
                var response = request.response;
                if (request.status !== 200 && request.status !== 0) {
                    var data = tryParseAsDataURI(Module["memoryInitializerRequestURL"]);
                    if (data) response = data.buffer;
                    else {
                        console.warn("a problem seems to have happened with Module.memoryInitializerRequest, status: " + request.status + ", retrying " + memoryInitializer);
                        doBrowserLoad();
                        return;
                    }
                }
                applyMemoryInitializer(response);
            };
            if (Module["memoryInitializerRequest"].response) setTimeout(useRequest, 0);
            else Module["memoryInitializerRequest"].addEventListener("load", useRequest);
        } else doBrowserLoad();
    }
    var calledRun;
    dependenciesFulfilled = function runCaller() {
        if (!calledRun) run();
        if (!calledRun) dependenciesFulfilled = runCaller;
    };
    function run(args) {
        args = args || arguments_;
        if (runDependencies > 0) return;
        preRun();
        if (runDependencies > 0) return;
        function doRun() {
            if (calledRun) return;
            calledRun = true;
            if (ABORT) return;
            initRuntime();
            preMain();
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            postRun();
        }
        if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
                setTimeout(function() {
                    Module["setStatus"]("");
                }, 1);
                doRun();
            }, 1);
        } else doRun();
    }
    Module["run"] = run;
    function abort(what) {
        if (Module["onAbort"]) Module["onAbort"](what);
        what += "";
        out(what);
        err(what);
        ABORT = true;
        throw "abort(" + what + "). Build with -s ASSERTIONS=1 for more info.";
    }
    Module["abort"] = abort;
    if (Module["preInit"]) {
        if (typeof Module["preInit"] == "function") Module["preInit"] = [
            Module["preInit"]
        ];
        while(Module["preInit"].length > 0)Module["preInit"].pop()();
    }
    run();
    return libh3;
}(typeof $7b9f60117f9c280b$var$libh3 === "object" ? $7b9f60117f9c280b$var$libh3 : {});
/*
 * Copyright 2018-2019 Uber Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Define the C bindings for the h3 library
// Add some aliases to make the function definitions more intelligible
var $7b9f60117f9c280b$var$NUMBER = "number";
var $7b9f60117f9c280b$var$BOOLEAN = $7b9f60117f9c280b$var$NUMBER;
var $7b9f60117f9c280b$var$H3_LOWER = $7b9f60117f9c280b$var$NUMBER;
var $7b9f60117f9c280b$var$H3_UPPER = $7b9f60117f9c280b$var$NUMBER;
var $7b9f60117f9c280b$var$RESOLUTION = $7b9f60117f9c280b$var$NUMBER;
var $7b9f60117f9c280b$var$POINTER = $7b9f60117f9c280b$var$NUMBER; // Define the bindings to functions in the C lib. Functions are defined as
// [name, return type, [arg types]]. You must run `npm run build-emscripten`
// before new functions added here will be available.
var $7b9f60117f9c280b$var$BINDINGS = [
    [
        "sizeOfH3Index",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "sizeOfGeoCoord",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "sizeOfGeoBoundary",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "sizeOfGeoPolygon",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "sizeOfGeofence",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "sizeOfLinkedGeoPolygon",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "sizeOfCoordIJ",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "h3IsValid",
        $7b9f60117f9c280b$var$BOOLEAN,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "geoToH3",
        $7b9f60117f9c280b$var$H3_LOWER,
        [
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "h3ToGeo",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "h3ToGeoBoundary",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "maxKringSize",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$NUMBER
        ]
    ],
    [
        "kRing",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "kRingDistances",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "hexRing",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "maxPolyfillSize",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "polyfill",
        null,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$RESOLUTION,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "h3SetToLinkedGeo",
        null,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "destroyLinkedPolygon",
        null,
        [
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "compact",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$NUMBER
        ]
    ],
    [
        "uncompact",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "maxUncompactSize",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "h3IsPentagon",
        $7b9f60117f9c280b$var$BOOLEAN,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "h3IsResClassIII",
        $7b9f60117f9c280b$var$BOOLEAN,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "h3GetBaseCell",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "h3GetResolution",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "maxFaceCount",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "h3GetFaces",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "h3ToParent",
        $7b9f60117f9c280b$var$H3_LOWER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "h3ToChildren",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$RESOLUTION,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "h3ToCenterChild",
        $7b9f60117f9c280b$var$H3_LOWER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "maxH3ToChildrenSize",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "h3IndexesAreNeighbors",
        $7b9f60117f9c280b$var$BOOLEAN,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "getH3UnidirectionalEdge",
        $7b9f60117f9c280b$var$H3_LOWER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "getOriginH3IndexFromUnidirectionalEdge",
        $7b9f60117f9c280b$var$H3_LOWER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "getDestinationH3IndexFromUnidirectionalEdge",
        $7b9f60117f9c280b$var$H3_LOWER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "h3UnidirectionalEdgeIsValid",
        $7b9f60117f9c280b$var$BOOLEAN,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "getH3IndexesFromUnidirectionalEdge",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "getH3UnidirectionalEdgesFromHexagon",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "getH3UnidirectionalEdgeBoundary",
        null,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "h3Distance",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "h3Line",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "h3LineSize",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "experimentalH3ToLocalIj",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "experimentalLocalIjToH3",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER,
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "hexAreaM2",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "hexAreaKm2",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "edgeLengthM",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "edgeLengthKm",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "pointDistM",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "pointDistKm",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "pointDistRads",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$POINTER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "cellAreaM2",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "cellAreaKm2",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "cellAreaRads2",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "exactEdgeLengthM",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "exactEdgeLengthKm",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "exactEdgeLengthRads",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$H3_LOWER,
            $7b9f60117f9c280b$var$H3_UPPER
        ]
    ],
    [
        "numHexagons",
        $7b9f60117f9c280b$var$NUMBER,
        [
            $7b9f60117f9c280b$var$RESOLUTION
        ]
    ],
    [
        "getRes0Indexes",
        null,
        [
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "res0IndexCount",
        $7b9f60117f9c280b$var$NUMBER
    ],
    [
        "getPentagonIndexes",
        null,
        [
            $7b9f60117f9c280b$var$NUMBER,
            $7b9f60117f9c280b$var$POINTER
        ]
    ],
    [
        "pentagonIndexCount",
        $7b9f60117f9c280b$var$NUMBER
    ]
];
/*
 * Copyright 2018-2019 Uber Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7b9f60117f9c280b$var$H3 = {}; // Create the bound functions themselves
$7b9f60117f9c280b$var$BINDINGS.forEach(function bind(def) {
    $7b9f60117f9c280b$var$H3[def[0]] = $7b9f60117f9c280b$var$libh3.cwrap.apply($7b9f60117f9c280b$var$libh3, def);
}); // Alias the hexidecimal base for legibility
var $7b9f60117f9c280b$var$BASE_16 = 16; // ----------------------------------------------------------------------------
// Byte size imports
var $7b9f60117f9c280b$var$SZ_INT = 4;
var $7b9f60117f9c280b$var$SZ_PTR = 4;
var $7b9f60117f9c280b$var$SZ_DBL = 8;
var $7b9f60117f9c280b$var$SZ_H3INDEX = $7b9f60117f9c280b$var$H3.sizeOfH3Index();
var $7b9f60117f9c280b$var$SZ_GEOCOORD = $7b9f60117f9c280b$var$H3.sizeOfGeoCoord();
var $7b9f60117f9c280b$var$SZ_GEOBOUNDARY = $7b9f60117f9c280b$var$H3.sizeOfGeoBoundary();
var $7b9f60117f9c280b$var$SZ_GEOPOLYGON = $7b9f60117f9c280b$var$H3.sizeOfGeoPolygon();
var $7b9f60117f9c280b$var$SZ_GEOFENCE = $7b9f60117f9c280b$var$H3.sizeOfGeofence();
var $7b9f60117f9c280b$var$SZ_LINKED_GEOPOLYGON = $7b9f60117f9c280b$var$H3.sizeOfLinkedGeoPolygon();
var $7b9f60117f9c280b$var$SZ_COORDIJ = $7b9f60117f9c280b$var$H3.sizeOfCoordIJ(); // ----------------------------------------------------------------------------
// Custom types
/**
 * 64-bit hexidecimal string representation of an H3 index
 * @static
 * @typedef {string} H3Index
 */ /**
 * 64-bit hexidecimal string representation of an H3 index,
 * or two 32-bit integers in little endian order in an array.
 * @static
 * @typedef {string | number[]} H3IndexInput
 */ /**
 * Coordinates as an `{i, j}` pair
 * @static
 * @typedef CoordIJ
 * @type {Object}
 * @property {number} i
 * @property {number} j
 */ // ----------------------------------------------------------------------------
// Unit constants
/**
 * Length/Area units
 * @static
 * @typedef UNITS
 * @type {Object}
 * @property {string} m
 * @property {string} m2
 * @property {string} km
 * @property {string} km2
 * @property {string} rads
 * @property {string} rads2
 */ var $7b9f60117f9c280b$export$a037d132965e1c9f = {
    m: "m",
    m2: "m2",
    km: "km",
    km2: "km2",
    rads: "rads",
    rads2: "rads2"
}; // ----------------------------------------------------------------------------
// Utilities and helpers
/**
 * Validate a resolution, throwing an error if invalid
 * @private
 * @param  {mixed} res Value to validate
 * @throws {Error}     Error if invalid
 */ function $7b9f60117f9c280b$var$validateRes(res) {
    if (typeof res !== "number" || res < 0 || res > 15 || Math.floor(res) !== res) throw new Error("Invalid resolution: " + res);
}
var $7b9f60117f9c280b$var$INVALID_HEXIDECIMAL_CHAR = /[^0-9a-fA-F]/;
/**
 * Convert an H3 index (64-bit hexidecimal string) into a "split long" - a pair of 32-bit ints
 * @private
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {number[]}         A two-element array with 32 lower bits and 32 upper bits
 */ function $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index) {
    if (Array.isArray(h3Index) && h3Index.length === 2 && Number.isInteger(h3Index[0]) && Number.isInteger(h3Index[1])) return h3Index;
    if (typeof h3Index !== "string" || $7b9f60117f9c280b$var$INVALID_HEXIDECIMAL_CHAR.test(h3Index)) return [
        0,
        0
    ];
    var upper = parseInt(h3Index.substring(0, h3Index.length - 8), $7b9f60117f9c280b$var$BASE_16);
    var lower = parseInt(h3Index.substring(h3Index.length - 8), $7b9f60117f9c280b$var$BASE_16);
    return [
        lower,
        upper
    ];
}
/**
 * Convert a 32-bit int to a hexdecimal string
 * @private
 * @param  {number} num  Integer to convert
 * @return {H3Index}     Hexidecimal string
 */ function $7b9f60117f9c280b$var$hexFrom32Bit(num) {
    if (num >= 0) return num.toString($7b9f60117f9c280b$var$BASE_16);
     // Handle negative numbers
    num = num & 0x7fffffff;
    var tempStr = $7b9f60117f9c280b$var$zeroPad(8, num.toString($7b9f60117f9c280b$var$BASE_16));
    var topNum = (parseInt(tempStr[0], $7b9f60117f9c280b$var$BASE_16) + 8).toString($7b9f60117f9c280b$var$BASE_16);
    tempStr = topNum + tempStr.substring(1);
    return tempStr;
}
/**
 * Get a H3 index from a split long (pair of 32-bit ints)
 * @private
 * @param  {number} lower Lower 32 bits
 * @param  {number} upper Upper 32 bits
 * @return {H3Index}       H3 index
 */ function $7b9f60117f9c280b$export$94dcc16939fe0462(lower, upper) {
    return $7b9f60117f9c280b$var$hexFrom32Bit(upper) + $7b9f60117f9c280b$var$zeroPad(8, $7b9f60117f9c280b$var$hexFrom32Bit(lower));
}
/**
 * Zero-pad a string to a given length
 * @private
 * @param  {number} fullLen Target length
 * @param  {string} numStr  String to zero-pad
 * @return {string}         Zero-padded string
 */ function $7b9f60117f9c280b$var$zeroPad(fullLen, numStr) {
    var numZeroes = fullLen - numStr.length;
    var outStr = "";
    for(var i = 0; i < numZeroes; i++)outStr += "0";
    outStr = outStr + numStr;
    return outStr;
}
/**
 * Populate a C-appropriate Geofence struct from a polygon array
 * @private
 * @param  {Array[]} polygonArray Polygon, as an array of coordinate pairs
 * @param  {number}  geofence     C pointer to a Geofence struct
 * @param  {boolean} isGeoJson    Whether coordinates are in [lng, lat] order per GeoJSON spec
 * @return {number}               C pointer to populated Geofence struct
 */ function $7b9f60117f9c280b$var$polygonArrayToGeofence(polygonArray, geofence, isGeoJson) {
    var numVerts = polygonArray.length;
    var geoCoordArray = $7b9f60117f9c280b$var$libh3._calloc(numVerts, $7b9f60117f9c280b$var$SZ_GEOCOORD); // Support [lng, lat] pairs if GeoJSON is specified
    var latIndex = isGeoJson ? 1 : 0;
    var lngIndex = isGeoJson ? 0 : 1;
    for(var i = 0; i < numVerts * 2; i += 2)$7b9f60117f9c280b$var$libh3.HEAPF64.set([
        polygonArray[i / 2][latIndex],
        polygonArray[i / 2][lngIndex]
    ].map($7b9f60117f9c280b$export$18f2af2888c1a46b), geoCoordArray / $7b9f60117f9c280b$var$SZ_DBL + i);
    $7b9f60117f9c280b$var$libh3.HEAPU32.set([
        numVerts,
        geoCoordArray
    ], geofence / $7b9f60117f9c280b$var$SZ_INT);
    return geofence;
}
/**
 * Create a C-appropriate GeoPolygon struct from an array of polygons
 * @private
 * @param  {Array[]} coordinates  Array of polygons, each an array of coordinate pairs
 * @param  {boolean} isGeoJson    Whether coordinates are in [lng, lat] order per GeoJSON spec
 * @return {number}               C pointer to populated GeoPolygon struct
 */ function $7b9f60117f9c280b$var$coordinatesToGeoPolygon(coordinates, isGeoJson) {
    // Any loops beyond the first loop are holes
    var numHoles = coordinates.length - 1;
    var geoPolygon = $7b9f60117f9c280b$var$libh3._calloc($7b9f60117f9c280b$var$SZ_GEOPOLYGON); // Byte positions within the struct
    var geofenceOffset = 0;
    var numHolesOffset = geofenceOffset + $7b9f60117f9c280b$var$SZ_GEOFENCE;
    var holesOffset = numHolesOffset + $7b9f60117f9c280b$var$SZ_INT; // geofence is first part of struct
    $7b9f60117f9c280b$var$polygonArrayToGeofence(coordinates[0], geoPolygon + geofenceOffset, isGeoJson);
    var holes;
    if (numHoles > 0) {
        holes = $7b9f60117f9c280b$var$libh3._calloc(numHoles, $7b9f60117f9c280b$var$SZ_GEOFENCE);
        for(var i = 0; i < numHoles; i++)$7b9f60117f9c280b$var$polygonArrayToGeofence(coordinates[i + 1], holes + $7b9f60117f9c280b$var$SZ_GEOFENCE * i, isGeoJson);
    }
    $7b9f60117f9c280b$var$libh3.setValue(geoPolygon + numHolesOffset, numHoles, "i32");
    $7b9f60117f9c280b$var$libh3.setValue(geoPolygon + holesOffset, holes, "i32");
    return geoPolygon;
}
/**
 * Free memory allocated for a GeoPolygon struct. It is an error to access the struct
 * after passing it to this method.
 * @private
 * @return {number} geoPolygon C pointer to populated GeoPolygon struct
 */ function $7b9f60117f9c280b$var$destroyGeoPolygon(geoPolygon) {
    // Byte positions within the struct
    var geofenceOffset = 0;
    var numHolesOffset = geofenceOffset + $7b9f60117f9c280b$var$SZ_GEOFENCE;
    var holesOffset = numHolesOffset + $7b9f60117f9c280b$var$SZ_INT; // Offset of the geofence vertex array pointer within the Geofence struct
    var geofenceArrayOffset = $7b9f60117f9c280b$var$SZ_INT; // Free the outer vertex array
    $7b9f60117f9c280b$var$libh3._free($7b9f60117f9c280b$var$libh3.getValue(geoPolygon + geofenceOffset + geofenceArrayOffset, "i8*")); // Free the vertex array for the holes, if any
    var numHoles = $7b9f60117f9c280b$var$libh3.getValue(geoPolygon + numHolesOffset, "i32");
    if (numHoles > 0) {
        var holes = $7b9f60117f9c280b$var$libh3.getValue(geoPolygon + holesOffset, "i32");
        for(var i = 0; i < numHoles; i++)$7b9f60117f9c280b$var$libh3._free($7b9f60117f9c280b$var$libh3.getValue(holes + $7b9f60117f9c280b$var$SZ_GEOFENCE * i + geofenceArrayOffset, "i8*"));
        $7b9f60117f9c280b$var$libh3._free(holes);
    }
    $7b9f60117f9c280b$var$libh3._free(geoPolygon);
}
/**
 * Read a long value, returning the lower and upper portions as separate 32-bit integers.
 * Because the upper bits are returned via side effect, the argument to this function is
 * intended to be the invocation that caused the side effect, e.g. readLong(H3.getSomeLong())
 * @private
 * @param  {number} invocation Invoked function returning a long value. The actual return
 *                             value of these functions is a 32-bit integer.
 * @return {number}            Long value as a [lower, upper] pair
 */ function $7b9f60117f9c280b$var$readLong(invocation) {
    // Upper 32-bits of the long set via side-effect
    var upper = $7b9f60117f9c280b$var$libh3.getTempRet0();
    return [
        invocation,
        upper
    ];
}
/**
 * Read an H3 index from a C return value. As with readLong, the argument to this function
 * is intended to be an invocation, e.g. readH3Index(H3.getSomeAddress()), to help ensure that
 * the temp value storing the upper bits of the long is still set.
 * @private
 * @param  {number} invocation  Invoked function returning a single H3 index
 * @return {H3Index}            H3 index, or null if index was invalid
 */ function $7b9f60117f9c280b$var$readH3Index(invocation) {
    var ref = $7b9f60117f9c280b$var$readLong(invocation);
    var lower = ref[0];
    var upper = ref[1]; // The lower bits are allowed to be 0s, but if the upper bits are 0
    // this represents an invalid H3 index
    return upper ? $7b9f60117f9c280b$export$94dcc16939fe0462(lower, upper) : null;
}
/**
 * Read an H3 index from a pointer to C memory.
 * @private
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of H3 indexes, in case we're
 *                            reading an array
 * @return {H3Index}          H3 index, or null if index was invalid
 */ function $7b9f60117f9c280b$var$readH3IndexFromPointer(cAddress, offset) {
    if (offset === void 0) offset = 0;
    var lower = $7b9f60117f9c280b$var$libh3.getValue(cAddress + $7b9f60117f9c280b$var$SZ_INT * offset * 2, "i32");
    var upper = $7b9f60117f9c280b$var$libh3.getValue(cAddress + $7b9f60117f9c280b$var$SZ_INT * (offset * 2 + 1), "i32"); // The lower bits are allowed to be 0s, but if the upper bits are 0
    // this represents an invalid H3 index
    return upper ? $7b9f60117f9c280b$export$94dcc16939fe0462(lower, upper) : null;
}
/**
 * Store an H3 index in C memory. Primarily used as an efficient way to
 * write sets of hexagons.
 * @private
 * @param  {H3IndexInput} h3Index  H3 index to store
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of H3 indexes from beginning
 *                            of the current array
 */ function $7b9f60117f9c280b$var$storeH3Index(h3Index, cAddress, offset) {
    // HEAPU32 is a typed array projection on the index space
    // as unsigned 32-bit integers. This means the index needs
    // to be divided by SZ_INT (4) to access correctly. Also,
    // the H3 index is 64 bits, so we skip by twos as we're writing
    // to 32-bit integers in the proper order.
    $7b9f60117f9c280b$var$libh3.HEAPU32.set($7b9f60117f9c280b$export$746fb3599c285d6a(h3Index), cAddress / $7b9f60117f9c280b$var$SZ_INT + 2 * offset);
}
/**
 * Read an array of 64-bit H3 indexes from C and convert to a JS array of
 * H3 index strings
 * @private
 * @param  {number} cAddress    Pointer to C ouput array
 * @param  {number} maxCount    Max number of hexagons in array. Hexagons with
 *                              the value 0 will be skipped, so this isn't
 *                              necessarily the length of the output array.
 * @return {H3Index[]}          Array of H3 indexes
 */ function $7b9f60117f9c280b$var$readArrayOfHexagons(cAddress, maxCount) {
    var out = [];
    for(var i = 0; i < maxCount; i++){
        var h3Index = $7b9f60117f9c280b$var$readH3IndexFromPointer(cAddress, i);
        if (h3Index !== null) out.push(h3Index);
    }
    return out;
}
/**
 * Store an array of H3 index strings as a C array of 64-bit integers.
 * @private
 * @param  {number} cAddress    Pointer to C input array
 * @param  {H3IndexInput[]} hexagons H3 indexes to pass to the C lib
 */ function $7b9f60117f9c280b$var$storeArrayOfHexagons(cAddress, hexagons) {
    // Assuming the cAddress points to an already appropriately
    // allocated space
    var count = hexagons.length;
    for(var i = 0; i < count; i++)$7b9f60117f9c280b$var$storeH3Index(hexagons[i], cAddress, i);
}
/**
 * Populate a C-appropriate GeoCoord struct from a [lat, lng] array
 * @private
 * @param {number} lat     Coordinate latitude
 * @param {number} lng     Coordinate longitude
 * @return {number}        C pointer to populated GeoCoord struct
 */ function $7b9f60117f9c280b$var$storeGeoCoord(lat, lng) {
    var geoCoord = $7b9f60117f9c280b$var$libh3._calloc(1, $7b9f60117f9c280b$var$SZ_GEOCOORD);
    $7b9f60117f9c280b$var$libh3.HEAPF64.set([
        lat,
        lng
    ].map($7b9f60117f9c280b$export$18f2af2888c1a46b), geoCoord / $7b9f60117f9c280b$var$SZ_DBL);
    return geoCoord;
}
function $7b9f60117f9c280b$var$readSingleCoord(cAddress) {
    return $7b9f60117f9c280b$export$3eb27537c08caf0f($7b9f60117f9c280b$var$libh3.getValue(cAddress, "double"));
}
/**
 * Read a GeoCoord from C and return a [lat, lng] pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {number[]}           [lat, lng] pair
 */ function $7b9f60117f9c280b$var$readGeoCoord(cAddress) {
    return [
        $7b9f60117f9c280b$var$readSingleCoord(cAddress),
        $7b9f60117f9c280b$var$readSingleCoord(cAddress + $7b9f60117f9c280b$var$SZ_DBL)
    ];
}
/**
 * Read a GeoCoord from C and return a GeoJSON-style [lng, lat] pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {number[]}           [lng, lat] pair
 */ function $7b9f60117f9c280b$var$readGeoCoordGeoJson(cAddress) {
    return [
        $7b9f60117f9c280b$var$readSingleCoord(cAddress + $7b9f60117f9c280b$var$SZ_DBL),
        $7b9f60117f9c280b$var$readSingleCoord(cAddress)
    ];
}
/**
 * Read the GeoBoundary structure into a list of geo coordinate pairs
 * @private
 * @param {number}  geoBoundary     C pointer to GeoBoundary struct
 * @param {boolean} geoJsonCoords   Whether to provide GeoJSON coordinate order: [lng, lat]
 * @param {boolean} closedLoop      Whether to close the loop
 * @return {Array[]}                Array of geo coordinate pairs
 */ function $7b9f60117f9c280b$var$readGeoBoundary(geoBoundary, geoJsonCoords, closedLoop) {
    var numVerts = $7b9f60117f9c280b$var$libh3.getValue(geoBoundary, "i32"); // Note that though numVerts is an int, the coordinate doubles have to be
    // aligned to 8 bytes, hence the 8-byte offset here
    var vertsPos = geoBoundary + $7b9f60117f9c280b$var$SZ_DBL;
    var out = []; // Support [lng, lat] pairs if GeoJSON is specified
    var readCoord = geoJsonCoords ? $7b9f60117f9c280b$var$readGeoCoordGeoJson : $7b9f60117f9c280b$var$readGeoCoord;
    for(var i = 0; i < numVerts * 2; i += 2)out.push(readCoord(vertsPos + $7b9f60117f9c280b$var$SZ_DBL * i));
    if (closedLoop) // Close loop if GeoJSON is specified
    out.push(out[0]);
    return out;
}
/**
 * Read the LinkedGeoPolygon structure into a nested array of MultiPolygon coordinates
 * @private
 * @param {number}  polygon         C pointer to LinkedGeoPolygon struct
 * @param {boolean} formatAsGeoJson Whether to provide GeoJSON output: [lng, lat], closed loops
 * @return {number[][][][]}         MultiPolygon-style output.
 */ function $7b9f60117f9c280b$var$readMultiPolygon(polygon, formatAsGeoJson) {
    var output = [];
    var readCoord = formatAsGeoJson ? $7b9f60117f9c280b$var$readGeoCoordGeoJson : $7b9f60117f9c280b$var$readGeoCoord;
    var loops;
    var loop;
    var coords;
    var coord; // Loop through the linked structure, building the output
    while(polygon){
        output.push(loops = []); // Follow ->first pointer
        loop = $7b9f60117f9c280b$var$libh3.getValue(polygon, "i8*");
        while(loop){
            loops.push(coords = []); // Follow ->first pointer
            coord = $7b9f60117f9c280b$var$libh3.getValue(loop, "i8*");
            while(coord){
                coords.push(readCoord(coord)); // Follow ->next pointer
                coord = $7b9f60117f9c280b$var$libh3.getValue(coord + $7b9f60117f9c280b$var$SZ_DBL * 2, "i8*");
            }
            if (formatAsGeoJson) // Close loop if GeoJSON is requested
            coords.push(coords[0]);
             // Follow ->next pointer
            loop = $7b9f60117f9c280b$var$libh3.getValue(loop + $7b9f60117f9c280b$var$SZ_PTR * 2, "i8*");
        } // Follow ->next pointer
        polygon = $7b9f60117f9c280b$var$libh3.getValue(polygon + $7b9f60117f9c280b$var$SZ_PTR * 2, "i8*");
    }
    return output;
}
/**
 * Read a CoordIJ from C and return an {i, j} pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {CoordIJ}            {i, j} pair
 */ function $7b9f60117f9c280b$var$readCoordIJ(cAddress) {
    return {
        i: $7b9f60117f9c280b$var$libh3.getValue(cAddress, "i32"),
        j: $7b9f60117f9c280b$var$libh3.getValue(cAddress + $7b9f60117f9c280b$var$SZ_INT, "i32")
    };
}
/**
 * Store an {i, j} pair to a C CoordIJ struct.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {CoordIJ}            {i, j} pair
 */ function $7b9f60117f9c280b$var$storeCoordIJ(cAddress, ref) {
    var i = ref.i;
    var j = ref.j;
    $7b9f60117f9c280b$var$libh3.setValue(cAddress, i, "i32");
    $7b9f60117f9c280b$var$libh3.setValue(cAddress + $7b9f60117f9c280b$var$SZ_INT, j, "i32");
}
/**
 * Read an array of positive integers array from C. Negative
 * values are considered invalid and ignored in output.
 * @private
 * @param  {number} cAddress    Pointer to C array
 * @param  {number} count       Length of C array
 * @return {number[]}           Javascript integer array
 */ function $7b9f60117f9c280b$var$readArrayOfPositiveIntegers(cAddress, count) {
    var out = [];
    for(var i = 0; i < count; i++){
        var int = $7b9f60117f9c280b$var$libh3.getValue(cAddress + $7b9f60117f9c280b$var$SZ_INT * i, "i32");
        if (int >= 0) out.push(int);
    }
    return out;
} // ----------------------------------------------------------------------------
// Public API functions: Core
/**
 * Whether a given string represents a valid H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          Whether the index is valid
 */ function $7b9f60117f9c280b$export$c1faec3db2fca891(h3Index) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($7b9f60117f9c280b$var$H3.h3IsValid(lower, upper));
}
/**
 * Whether the given H3 index is a pentagon
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          isPentagon
 */ function $7b9f60117f9c280b$export$9e7403b9b01e136f(h3Index) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($7b9f60117f9c280b$var$H3.h3IsPentagon(lower, upper));
}
/**
 * Whether the given H3 index is in a Class III resolution (rotated versus
 * the icosahedron and subject to shape distortion adding extra points on
 * icosahedron edges, making them not true hexagons).
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          isResClassIII
 */ function $7b9f60117f9c280b$export$6019beb3542e7aad(h3Index) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($7b9f60117f9c280b$var$H3.h3IsResClassIII(lower, upper));
}
/**
 * Get the number of the base cell for a given H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get the base cell for
 * @return {number}           Index of the base cell (0-121)
 */ function $7b9f60117f9c280b$export$558febf58c7ab0b8(h3Index) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return $7b9f60117f9c280b$var$H3.h3GetBaseCell(lower, upper);
}
/**
 * Get the indices of all icosahedron faces intersected by a given H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get faces for
 * @return {number[]}         Indices (0-19) of all intersected faces
 */ function $7b9f60117f9c280b$export$d1cf4a12a694db3a(h3Index) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var count = $7b9f60117f9c280b$var$H3.maxFaceCount(lower, upper);
    var faces = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_INT * count);
    $7b9f60117f9c280b$var$H3.h3GetFaces(lower, upper, faces);
    var out = $7b9f60117f9c280b$var$readArrayOfPositiveIntegers(faces, count);
    $7b9f60117f9c280b$var$libh3._free(faces);
    return out;
}
/**
 * Returns the resolution of an H3 index
 * @static
 * @param  {H3IndexInput} h3Index H3 index to get resolution
 * @return {number}          The number (0-15) resolution, or -1 if invalid
 */ function $7b9f60117f9c280b$export$6827467f3394e8f4(h3Index) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    if (!$7b9f60117f9c280b$var$H3.h3IsValid(lower, upper)) // Compatability with stated API
    return -1;
    return $7b9f60117f9c280b$var$H3.h3GetResolution(lower, upper);
}
/**
 * Get the hexagon containing a lat,lon point
 * @static
 * @param  {number} lat Latitude of point
 * @param  {number} lng Longtitude of point
 * @param  {number} res Resolution of hexagons to return
 * @return {H3Index}    H3 index
 */ function $7b9f60117f9c280b$export$24131a74a154ec65(lat, lng, res) {
    var latlng = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_GEOCOORD); // Slightly more efficient way to set the memory
    $7b9f60117f9c280b$var$libh3.HEAPF64.set([
        lat,
        lng
    ].map($7b9f60117f9c280b$export$18f2af2888c1a46b), latlng / $7b9f60117f9c280b$var$SZ_DBL); // Read value as a split long
    var h3Index = $7b9f60117f9c280b$var$readH3Index($7b9f60117f9c280b$var$H3.geoToH3(latlng, res));
    $7b9f60117f9c280b$var$libh3._free(latlng);
    return h3Index;
}
/**
 * Get the lat,lon center of a given hexagon
 * @static
 * @param  {H3IndexInput} h3Index  H3 index
 * @return {number[]}         Point as a [lat, lng] pair
 */ function $7b9f60117f9c280b$export$317dd65f3721e7c4(h3Index) {
    var latlng = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_GEOCOORD);
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    $7b9f60117f9c280b$var$H3.h3ToGeo(lower, upper, latlng);
    var out = $7b9f60117f9c280b$var$readGeoCoord(latlng);
    $7b9f60117f9c280b$var$libh3._free(latlng);
    return out;
}
/**
 * Get the vertices of a given hexagon (or pentagon), as an array of [lat, lng]
 * points. For pentagons and hexagons on the edge of an icosahedron face, this
 * function may return up to 10 vertices.
 * @static
 * @param  {H3Index} h3Index          H3 index
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat], closed loops
 * @return {number[][]}               Array of [lat, lng] pairs
 */ function $7b9f60117f9c280b$export$c87d5f55314c67cf(h3Index, formatAsGeoJson) {
    var geoBoundary = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_GEOBOUNDARY);
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    $7b9f60117f9c280b$var$H3.h3ToGeoBoundary(lower, upper, geoBoundary);
    var out = $7b9f60117f9c280b$var$readGeoBoundary(geoBoundary, formatAsGeoJson, formatAsGeoJson);
    $7b9f60117f9c280b$var$libh3._free(geoBoundary);
    return out;
} // ----------------------------------------------------------------------------
// Public API functions: Algorithms
/**
 * Get the parent of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get parent for
 * @param  {number} res       Resolution of hexagon to return
 * @return {H3Index}          H3 index of parent, or null for invalid input
 */ function $7b9f60117f9c280b$export$6e83bc1001b134db(h3Index, res) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return $7b9f60117f9c280b$var$readH3Index($7b9f60117f9c280b$var$H3.h3ToParent(lower, upper, res));
}
/**
 * Get the children/descendents of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get children for
 * @param  {number} res       Resolution of hexagons to return
 * @return {H3Index[]}        H3 indexes of children, or empty array for invalid input
 */ function $7b9f60117f9c280b$export$e8b20439271d254c(h3Index, res) {
    // Bad input in this case can potentially result in high computation volume
    // using the current C algorithm. Validate and return an empty array on failure.
    if (!$7b9f60117f9c280b$export$c1faec3db2fca891(h3Index)) return [];
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var maxCount = $7b9f60117f9c280b$var$H3.maxH3ToChildrenSize(lower, upper, res);
    var hexagons = $7b9f60117f9c280b$var$libh3._calloc(maxCount, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$H3.h3ToChildren(lower, upper, res, hexagons);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, maxCount);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    return out;
}
/**
 * Get the center child of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get center child for
 * @param  {number} res       Resolution of hexagon to return
 * @return {H3Index}          H3 index of child, or null for invalid input
 */ function $7b9f60117f9c280b$export$6db75718879de215(h3Index, res) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return $7b9f60117f9c280b$var$readH3Index($7b9f60117f9c280b$var$H3.h3ToCenterChild(lower, upper, res));
}
/**
 * Get all hexagons in a k-ring around a given center. The order of the hexagons is undefined.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of k-ring
 * @return {H3Index[]}        H3 indexes for all hexagons in ring
 */ function $7b9f60117f9c280b$export$36e8217e0351e612(h3Index, ringSize) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var maxCount = $7b9f60117f9c280b$var$H3.maxKringSize(ringSize);
    var hexagons = $7b9f60117f9c280b$var$libh3._calloc(maxCount, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$H3.kRing(lower, upper, ringSize, hexagons);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, maxCount);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    return out;
}
/**
 * Get all hexagons in a k-ring around a given center, in an array of arrays
 * ordered by distance from the origin. The order of the hexagons within each ring is undefined.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of k-ring
 * @return {H3Index[][]}      Array of arrays with H3 indexes for all hexagons each ring
 */ function $7b9f60117f9c280b$export$501db62b56874355(h3Index, ringSize) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var maxCount = $7b9f60117f9c280b$var$H3.maxKringSize(ringSize);
    var kRings = $7b9f60117f9c280b$var$libh3._calloc(maxCount, $7b9f60117f9c280b$var$SZ_H3INDEX);
    var distances = $7b9f60117f9c280b$var$libh3._calloc(maxCount, $7b9f60117f9c280b$var$SZ_INT);
    $7b9f60117f9c280b$var$H3.kRingDistances(lower, upper, ringSize, kRings, distances); // Create an array of empty arrays to hold the output
    var out = [];
    for(var i = 0; i < ringSize + 1; i++)out.push([]);
     // Read the array of hexagons, putting them into the appropriate rings
    for(var i$1 = 0; i$1 < maxCount * 2; i$1 += 2){
        var hexLower = $7b9f60117f9c280b$var$libh3.getValue(kRings + $7b9f60117f9c280b$var$SZ_INT * i$1, "i32");
        var hexUpper = $7b9f60117f9c280b$var$libh3.getValue(kRings + $7b9f60117f9c280b$var$SZ_INT * (i$1 + 1), "i32");
        var index = $7b9f60117f9c280b$var$libh3.getValue(distances + $7b9f60117f9c280b$var$SZ_INT * (i$1 / 2), "i32");
        if (hexLower !== 0 || hexUpper !== 0) out[index].push($7b9f60117f9c280b$export$94dcc16939fe0462(hexLower, hexUpper));
    }
    $7b9f60117f9c280b$var$libh3._free(kRings);
    $7b9f60117f9c280b$var$libh3._free(distances);
    return out;
}
/**
 * Get all hexagons in a hollow hexagonal ring centered at origin with sides of a given length.
 * Unlike kRing, this function will throw an error if there is a pentagon anywhere in the ring.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of ring
 * @return {H3Index[]}        H3 indexes for all hexagons in ring
 * @throws {Error}            If the algorithm could not calculate the ring
 */ function $7b9f60117f9c280b$export$496038b5ca9585a1(h3Index, ringSize) {
    var maxCount = ringSize === 0 ? 1 : 6 * ringSize;
    var hexagons = $7b9f60117f9c280b$var$libh3._calloc(maxCount, $7b9f60117f9c280b$var$SZ_H3INDEX);
    var retVal = $7b9f60117f9c280b$var$H3.hexRing.apply($7b9f60117f9c280b$var$H3, $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index).concat([
        ringSize
    ], [
        hexagons
    ]));
    if (retVal !== 0) {
        $7b9f60117f9c280b$var$libh3._free(hexagons);
        throw new Error("Failed to get hexRing (encountered a pentagon?)");
    }
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, maxCount);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    return out;
}
/**
 * Get all hexagons with centers contained in a given polygon. The polygon
 * is specified with GeoJson semantics as an array of loops. Each loop is
 * an array of [lat, lng] pairs (or [lng, lat] if isGeoJson is specified).
 * The first loop is the perimeter of the polygon, and subsequent loops are
 * expected to be holes.
 * @static
 * @param  {number[][] | number[][][]} coordinates
 *                                  Array of loops, or a single loop
 * @param  {number} res             Resolution of hexagons to return
 * @param  {boolean} [isGeoJson]    Whether to expect GeoJson-style [lng, lat]
 *                                  pairs instead of [lat, lng]
 * @return {H3Index[]}              H3 indexes for all hexagons in polygon
 */ function $7b9f60117f9c280b$export$cea1c58a6db52bca(coordinates, res, isGeoJson) {
    $7b9f60117f9c280b$var$validateRes(res);
    isGeoJson = Boolean(isGeoJson); // Guard against empty input
    if (coordinates.length === 0 || coordinates[0].length === 0) return [];
     // Wrap to expected format if a single loop is provided
    if (typeof coordinates[0][0] === "number") coordinates = [
        coordinates
    ];
    var geoPolygon = $7b9f60117f9c280b$var$coordinatesToGeoPolygon(coordinates, isGeoJson);
    var arrayLen = $7b9f60117f9c280b$var$H3.maxPolyfillSize(geoPolygon, res);
    var hexagons = $7b9f60117f9c280b$var$libh3._calloc(arrayLen, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$H3.polyfill(geoPolygon, res, hexagons);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, arrayLen);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    $7b9f60117f9c280b$var$destroyGeoPolygon(geoPolygon);
    return out;
}
/**
 * Get the outlines of a set of H3 hexagons, returned in GeoJSON MultiPolygon
 * format (an array of polygons, each with an array of loops, each an array of
 * coordinates). Coordinates are returned as [lat, lng] pairs unless GeoJSON
 * is requested.
 *
 * It is the responsibility of the caller to ensure that all hexagons in the
 * set have the same resolution and that the set contains no duplicates. Behavior
 * is undefined if duplicates or multiple resolutions are present, and the
 * algorithm may produce unexpected or invalid polygons.
 *
 * @static
 * @param {H3IndexInput[]} h3Indexes       H3 indexes to get outlines for
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output:
 *                                    [lng, lat], closed loops
 * @return {number[][][][]}           MultiPolygon-style output.
 */ function $7b9f60117f9c280b$export$911a0c41d9f5c4ed(h3Indexes, formatAsGeoJson) {
    // Early exit on empty input
    if (!h3Indexes || !h3Indexes.length) return [];
     // Set up input set
    var indexCount = h3Indexes.length;
    var set = $7b9f60117f9c280b$var$libh3._calloc(indexCount, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$storeArrayOfHexagons(set, h3Indexes); // Allocate memory for output linked polygon
    var polygon = $7b9f60117f9c280b$var$libh3._calloc($7b9f60117f9c280b$var$SZ_LINKED_GEOPOLYGON); // Store a reference to the first polygon - that's the one we need for
    // memory deallocation
    var originalPolygon = polygon;
    $7b9f60117f9c280b$var$H3.h3SetToLinkedGeo(set, indexCount, polygon);
    var multiPolygon = $7b9f60117f9c280b$var$readMultiPolygon(polygon, formatAsGeoJson); // Clean up
    $7b9f60117f9c280b$var$H3.destroyLinkedPolygon(originalPolygon);
    $7b9f60117f9c280b$var$libh3._free(originalPolygon);
    $7b9f60117f9c280b$var$libh3._free(set);
    return multiPolygon;
}
/**
 * Compact a set of hexagons of the same resolution into a set of hexagons across
 * multiple levels that represents the same area.
 * @static
 * @param  {H3IndexInput[]} h3Set H3 indexes to compact
 * @return {H3Index[]}       Compacted H3 indexes
 * @throws {Error}           If the input is invalid (e.g. duplicate hexagons)
 */ function $7b9f60117f9c280b$export$8e16b83750b44988(h3Set) {
    if (!h3Set || !h3Set.length) return [];
     // Set up input set
    var count = h3Set.length;
    var set = $7b9f60117f9c280b$var$libh3._calloc(count, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$storeArrayOfHexagons(set, h3Set); // Allocate memory for compacted hexagons, worst-case is no compaction
    var compactedSet = $7b9f60117f9c280b$var$libh3._calloc(count, $7b9f60117f9c280b$var$SZ_H3INDEX);
    var retVal = $7b9f60117f9c280b$var$H3.compact(set, compactedSet, count);
    if (retVal !== 0) {
        $7b9f60117f9c280b$var$libh3._free(set);
        $7b9f60117f9c280b$var$libh3._free(compactedSet);
        throw new Error("Failed to compact, malformed input data (duplicate hexagons?)");
    }
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(compactedSet, count);
    $7b9f60117f9c280b$var$libh3._free(set);
    $7b9f60117f9c280b$var$libh3._free(compactedSet);
    return out;
}
/**
 * Uncompact a compacted set of hexagons to hexagons of the same resolution
 * @static
 * @param  {H3IndexInput[]} compactedSet H3 indexes to uncompact
 * @param  {number}    res          The resolution to uncompact to
 * @return {H3Index[]}              The uncompacted H3 indexes
 * @throws {Error}                  If the input is invalid (e.g. invalid resolution)
 */ function $7b9f60117f9c280b$export$da59f65535392b73(compactedSet, res) {
    $7b9f60117f9c280b$var$validateRes(res);
    if (!compactedSet || !compactedSet.length) return [];
     // Set up input set
    var count = compactedSet.length;
    var set = $7b9f60117f9c280b$var$libh3._calloc(count, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$storeArrayOfHexagons(set, compactedSet); // Estimate how many hexagons we need (always overestimates if in error)
    var maxUncompactedNum = $7b9f60117f9c280b$var$H3.maxUncompactSize(set, count, res); // Allocate memory for uncompacted hexagons
    var uncompactedSet = $7b9f60117f9c280b$var$libh3._calloc(maxUncompactedNum, $7b9f60117f9c280b$var$SZ_H3INDEX);
    var retVal = $7b9f60117f9c280b$var$H3.uncompact(set, count, uncompactedSet, maxUncompactedNum, res);
    if (retVal !== 0) {
        $7b9f60117f9c280b$var$libh3._free(set);
        $7b9f60117f9c280b$var$libh3._free(uncompactedSet);
        throw new Error("Failed to uncompact (bad resolution?)");
    }
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(uncompactedSet, maxUncompactedNum);
    $7b9f60117f9c280b$var$libh3._free(set);
    $7b9f60117f9c280b$var$libh3._free(uncompactedSet);
    return out;
} // ----------------------------------------------------------------------------
// Public API functions: Unidirectional edges
/**
 * Whether two H3 indexes are neighbors (share an edge)
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {boolean}             Whether the hexagons share an edge
 */ function $7b9f60117f9c280b$export$eb50eb4056349f0e(origin, destination) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $7b9f60117f9c280b$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    return Boolean($7b9f60117f9c280b$var$H3.h3IndexesAreNeighbors(oLower, oUpper, dLower, dUpper));
}
/**
 * Get an H3 index representing a unidirectional edge for a given origin and destination
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {H3Index}             H3 index of the edge, or null if no edge is shared
 */ function $7b9f60117f9c280b$export$b89869ac33946464(origin, destination) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $7b9f60117f9c280b$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    return $7b9f60117f9c280b$var$readH3Index($7b9f60117f9c280b$var$H3.getH3UnidirectionalEdge(oLower, oUpper, dLower, dUpper));
}
/**
 * Get the origin hexagon from an H3 index representing a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index}           H3 index of the edge origin
 */ function $7b9f60117f9c280b$export$13279f23c835bdb8(edgeIndex) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    return $7b9f60117f9c280b$var$readH3Index($7b9f60117f9c280b$var$H3.getOriginH3IndexFromUnidirectionalEdge(lower, upper));
}
/**
 * Get the destination hexagon from an H3 index representing a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index}           H3 index of the edge destination
 */ function $7b9f60117f9c280b$export$100636a95be53c47(edgeIndex) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    return $7b9f60117f9c280b$var$readH3Index($7b9f60117f9c280b$var$H3.getDestinationH3IndexFromUnidirectionalEdge(lower, upper));
}
/**
 * Whether the input is a valid unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {boolean}           Whether the index is valid
 */ function $7b9f60117f9c280b$export$7ba0147f717e0e86(edgeIndex) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($7b9f60117f9c280b$var$H3.h3UnidirectionalEdgeIsValid(lower, upper));
}
/**
 * Get the [origin, destination] pair represented by a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index[]}         [origin, destination] pair as H3 indexes
 */ function $7b9f60117f9c280b$export$baea9ec8d71e57f1(edgeIndex) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    var count = 2;
    var hexagons = $7b9f60117f9c280b$var$libh3._calloc(count, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$H3.getH3IndexesFromUnidirectionalEdge(lower, upper, hexagons);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, count);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    return out;
}
/**
 * Get all of the unidirectional edges with the given H3 index as the origin (i.e. an edge to
 * every neighbor)
 * @static
 * @param  {H3IndexInput} h3Index   H3 index of the origin hexagon
 * @return {H3Index[]}         List of unidirectional edges
 */ function $7b9f60117f9c280b$export$30e11ffcf56640f3(h3Index) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var count = 6;
    var edges = $7b9f60117f9c280b$var$libh3._calloc(count, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$H3.getH3UnidirectionalEdgesFromHexagon(lower, upper, edges);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(edges, count);
    $7b9f60117f9c280b$var$libh3._free(edges);
    return out;
}
/**
 * Get the vertices of a given edge as an array of [lat, lng] points. Note that for edges that
 * cross the edge of an icosahedron face, this may return 3 coordinates.
 * @static
 * @param  {H3IndexInput} edgeIndex        H3 index of the edge
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat]
 * @return {number[][]}               Array of geo coordinate pairs
 */ function $7b9f60117f9c280b$export$6b2ac03a6029686(edgeIndex, formatAsGeoJson) {
    var geoBoundary = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_GEOBOUNDARY);
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    $7b9f60117f9c280b$var$H3.getH3UnidirectionalEdgeBoundary(lower, upper, geoBoundary);
    var out = $7b9f60117f9c280b$var$readGeoBoundary(geoBoundary, formatAsGeoJson);
    $7b9f60117f9c280b$var$libh3._free(geoBoundary);
    return out;
}
/**
 * Get the grid distance between two hex indexes. This function may fail
 * to find the distance between two indexes if they are very far apart or
 * on opposite sides of a pentagon.
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {number}              Distance between hexagons, or a negative
 *                               number if the distance could not be computed
 */ function $7b9f60117f9c280b$export$f56b06aabd98a7d0(origin, destination) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $7b9f60117f9c280b$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    return $7b9f60117f9c280b$var$H3.h3Distance(oLower, oUpper, dLower, dUpper);
}
/**
 * Given two H3 indexes, return the line of indexes between them (inclusive).
 *
 * This function may fail to find the line between two indexes, for
 * example if they are very far apart. It may also fail when finding
 * distances for indexes on opposite sides of a pentagon.
 *
 * Notes:
 *
 *  - The specific output of this function should not be considered stable
 *    across library versions. The only guarantees the library provides are
 *    that the line length will be `h3Distance(start, end) + 1` and that
 *    every index in the line will be a neighbor of the preceding index.
 *  - Lines are drawn in grid space, and may not correspond exactly to either
 *    Cartesian lines or great arcs.
 *
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {H3Index[]}           H3 indexes connecting origin and destination
 * @throws {Error}               If the line cannot be calculated
 */ function $7b9f60117f9c280b$export$3c4374231d75ac73(origin, destination) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $7b9f60117f9c280b$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    var count = $7b9f60117f9c280b$var$H3.h3LineSize(oLower, oUpper, dLower, dUpper);
    if (count < 0) // We can't get the specific error code here - may be any of
    // the errors possible in experimentalH3ToLocalIj
    throw new Error("Line cannot be calculated");
    var hexagons = $7b9f60117f9c280b$var$libh3._calloc(count, $7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$H3.h3Line(oLower, oUpper, dLower, dUpper, hexagons);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, count);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    return out;
}
/**
 * Produces IJ coordinates for an H3 index anchored by an origin.
 *
 * - The coordinate space used by this function may have deleted
 * regions or warping due to pentagonal distortion.
 * - Coordinates are only comparable if they come from the same
 * origin index.
 * - Failure may occur if the index is too far away from the origin
 * or if the index is on the other side of a pentagon.
 * - This function is experimental, and its output is not guaranteed
 * to be compatible across different versions of H3.
 * @static
 * @param  {H3IndexInput} origin      Origin H3 index
 * @param  {H3IndexInput} destination H3 index for which to find relative coordinates
 * @return {CoordIJ}             Coordinates as an `{i, j}` pair
 * @throws {Error}               If the IJ coordinates cannot be calculated
 */ function $7b9f60117f9c280b$export$f5137e86c7310bce(origin, destination) {
    var ij = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_COORDIJ);
    var retVal = $7b9f60117f9c280b$var$H3.experimentalH3ToLocalIj.apply($7b9f60117f9c280b$var$H3, $7b9f60117f9c280b$export$746fb3599c285d6a(origin).concat($7b9f60117f9c280b$export$746fb3599c285d6a(destination), [
        ij
    ]));
    var coords = $7b9f60117f9c280b$var$readCoordIJ(ij);
    $7b9f60117f9c280b$var$libh3._free(ij); // Return the pair, or throw if an error code was returned.
    // Switch statement and error codes cribbed from h3-java's implementation.
    switch(retVal){
        case 0:
            return coords;
        case 1:
            throw new Error("Incompatible origin and index.");
        case 2:
        default:
            throw new Error("Local IJ coordinates undefined for this origin and index pair. The index may be too far from the origin.");
        case 3:
        case 4:
        case 5:
            throw new Error("Encountered possible pentagon distortion");
    }
}
/**
 * Produces an H3 index for IJ coordinates anchored by an origin.
 *
 * - The coordinate space used by this function may have deleted
 * regions or warping due to pentagonal distortion.
 * - Coordinates are only comparable if they come from the same
 * origin index.
 * - Failure may occur if the index is too far away from the origin
 * or if the index is on the other side of a pentagon.
 * - This function is experimental, and its output is not guaranteed
 * to be compatible across different versions of H3.
 * @static
 * @param  {H3IndexInput} origin     Origin H3 index
 * @param  {CoordIJ} coords     Coordinates as an `{i, j}` pair
 * @return {H3Index}            H3 index at the relative coordinates
 * @throws {Error}              If the H3 index cannot be calculated
 */ function $7b9f60117f9c280b$export$699ec478a27688ea(origin, coords) {
    // Validate input coords
    if (!coords || typeof coords.i !== "number" || typeof coords.j !== "number") throw new Error("Coordinates must be provided as an {i, j} object");
     // Allocate memory for the CoordIJ struct and an H3 index to hold the return value
    var ij = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_COORDIJ);
    var out = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_H3INDEX);
    $7b9f60117f9c280b$var$storeCoordIJ(ij, coords);
    var retVal = $7b9f60117f9c280b$var$H3.experimentalLocalIjToH3.apply($7b9f60117f9c280b$var$H3, $7b9f60117f9c280b$export$746fb3599c285d6a(origin).concat([
        ij
    ], [
        out
    ]));
    var h3Index = $7b9f60117f9c280b$var$readH3IndexFromPointer(out);
    $7b9f60117f9c280b$var$libh3._free(ij);
    $7b9f60117f9c280b$var$libh3._free(out);
    if (retVal !== 0) throw new Error("Index not defined for this origin and IJ coordinates pair. IJ coordinates may be too far from origin, or a pentagon distortion was encountered.");
    return h3Index;
} // ----------------------------------------------------------------------------
// Public API functions: Distance/area utilities
/**
 * Great circle distance between two geo points. This is not specific to H3,
 * but is implemented in the library and provided here as a convenience.
 * @static
 * @param  {number[]} latlng1 Origin coordinate as [lat, lng]
 * @param  {number[]} latlng2 Destination coordinate as [lat, lng]
 * @param  {string}   unit    Distance unit (either UNITS.m or UNITS.km)
 * @return {number}           Great circle distance
 * @throws {Error}            If the unit is invalid
 */ function $7b9f60117f9c280b$export$f091827d0d13bea5(latlng1, latlng2, unit) {
    var coord1 = $7b9f60117f9c280b$var$storeGeoCoord(latlng1[0], latlng1[1]);
    var coord2 = $7b9f60117f9c280b$var$storeGeoCoord(latlng2[0], latlng2[1]);
    var result;
    switch(unit){
        case $7b9f60117f9c280b$export$a037d132965e1c9f.m:
            result = $7b9f60117f9c280b$var$H3.pointDistM(coord1, coord2);
            break;
        case $7b9f60117f9c280b$export$a037d132965e1c9f.km:
            result = $7b9f60117f9c280b$var$H3.pointDistKm(coord1, coord2);
            break;
        case $7b9f60117f9c280b$export$a037d132965e1c9f.rads:
            result = $7b9f60117f9c280b$var$H3.pointDistRads(coord1, coord2);
            break;
        default:
            result = null;
    }
    $7b9f60117f9c280b$var$libh3._free(coord1);
    $7b9f60117f9c280b$var$libh3._free(coord2);
    if (result === null) throw new Error("Unknown unit: " + unit);
    return result;
}
/**
 * Exact area of a given cell
 * @static
 * @param  {H3Index} h3Index  H3 index of the hexagon to measure
 * @param  {string}  unit     Distance unit (either UNITS.m2 or UNITS.km2)
 * @return {number}           Cell area
 * @throws {Error}            If the unit is invalid
 */ function $7b9f60117f9c280b$export$dd1eba531ccc01d(h3Index, unit) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    switch(unit){
        case $7b9f60117f9c280b$export$a037d132965e1c9f.m2:
            return $7b9f60117f9c280b$var$H3.cellAreaM2(lower, upper);
        case $7b9f60117f9c280b$export$a037d132965e1c9f.km2:
            return $7b9f60117f9c280b$var$H3.cellAreaKm2(lower, upper);
        case $7b9f60117f9c280b$export$a037d132965e1c9f.rads2:
            return $7b9f60117f9c280b$var$H3.cellAreaRads2(lower, upper);
        default:
            throw new Error("Unknown unit: " + unit);
    }
}
/**
 * Exact length of a given unidirectional edge
 * @static
 * @param  {H3Index} edge     H3 index of the edge to measure
 * @param  {string}  unit     Distance unit (either UNITS.m, UNITS.km, or UNITS.rads)
 * @return {number}           Cell area
 * @throws {Error}            If the unit is invalid
 */ function $7b9f60117f9c280b$export$27082d4db7c8790c(edge, unit) {
    var ref = $7b9f60117f9c280b$export$746fb3599c285d6a(edge);
    var lower = ref[0];
    var upper = ref[1];
    switch(unit){
        case $7b9f60117f9c280b$export$a037d132965e1c9f.m:
            return $7b9f60117f9c280b$var$H3.exactEdgeLengthM(lower, upper);
        case $7b9f60117f9c280b$export$a037d132965e1c9f.km:
            return $7b9f60117f9c280b$var$H3.exactEdgeLengthKm(lower, upper);
        case $7b9f60117f9c280b$export$a037d132965e1c9f.rads:
            return $7b9f60117f9c280b$var$H3.exactEdgeLengthRads(lower, upper);
        default:
            throw new Error("Unknown unit: " + unit);
    }
}
/**
 * Average hexagon area at a given resolution
 * @static
 * @param  {number} res  Hexagon resolution
 * @param  {string} unit Area unit (either UNITS.m2, UNITS.km2, or UNITS.rads2)
 * @return {number}      Average area
 * @throws {Error}       If the unit is invalid
 */ function $7b9f60117f9c280b$export$597dd479d4cc1bc9(res, unit) {
    $7b9f60117f9c280b$var$validateRes(res);
    switch(unit){
        case $7b9f60117f9c280b$export$a037d132965e1c9f.m2:
            return $7b9f60117f9c280b$var$H3.hexAreaM2(res);
        case $7b9f60117f9c280b$export$a037d132965e1c9f.km2:
            return $7b9f60117f9c280b$var$H3.hexAreaKm2(res);
        default:
            throw new Error("Unknown unit: " + unit);
    }
}
/**
 * Average hexagon edge length at a given resolution
 * @static
 * @param  {number} res  Hexagon resolution
 * @param  {string} unit Distance unit (either UNITS.m, UNITS.km, or UNITS.rads)
 * @return {number}      Average edge length
 * @throws {Error}       If the unit is invalid
 */ function $7b9f60117f9c280b$export$f9bb3d14d246c386(res, unit) {
    $7b9f60117f9c280b$var$validateRes(res);
    switch(unit){
        case $7b9f60117f9c280b$export$a037d132965e1c9f.m:
            return $7b9f60117f9c280b$var$H3.edgeLengthM(res);
        case $7b9f60117f9c280b$export$a037d132965e1c9f.km:
            return $7b9f60117f9c280b$var$H3.edgeLengthKm(res);
        default:
            throw new Error("Unknown unit: " + unit);
    }
} // ----------------------------------------------------------------------------
// Public informational utilities
/**
 * The total count of hexagons in the world at a given resolution. Note that above
 * resolution 8 the exact count cannot be represented in a JavaScript 32-bit number,
 * so consumers should use caution when applying further operations to the output.
 * @static
 * @param  {number} res  Hexagon resolution
 * @return {number}      Count
 */ function $7b9f60117f9c280b$export$fb1fbf4925957012(res) {
    $7b9f60117f9c280b$var$validateRes(res); // Get number as a long value
    var ref = $7b9f60117f9c280b$var$readLong($7b9f60117f9c280b$var$H3.numHexagons(res));
    var lower = ref[0];
    var upper = ref[1]; // If we're using <= 32 bits we can use normal JS numbers
    if (!upper) return lower;
     // Above 32 bit, make a JS number that's correct in order of magnitude
    return upper * Math.pow(2, 32) + lower;
}
/**
 * Get all H3 indexes at resolution 0. As every index at every resolution > 0 is
 * the descendant of a res 0 index, this can be used with h3ToChildren to iterate
 * over H3 indexes at any resolution.
 * @static
 * @return {H3Index[]}  All H3 indexes at res 0
 */ function $7b9f60117f9c280b$export$c6297e04da1d9191() {
    var count = $7b9f60117f9c280b$var$H3.res0IndexCount();
    var hexagons = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_H3INDEX * count);
    $7b9f60117f9c280b$var$H3.getRes0Indexes(hexagons);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, count);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    return out;
}
/**
 * Get the twelve pentagon indexes at a given resolution.
 * @static
 * @param  {number} res  Hexagon resolution
 * @return {H3Index[]}  All H3 pentagon indexes at res
 */ function $7b9f60117f9c280b$export$ecc8411f8c9b1ec1(res) {
    $7b9f60117f9c280b$var$validateRes(res);
    var count = $7b9f60117f9c280b$var$H3.pentagonIndexCount();
    var hexagons = $7b9f60117f9c280b$var$libh3._malloc($7b9f60117f9c280b$var$SZ_H3INDEX * count);
    $7b9f60117f9c280b$var$H3.getPentagonIndexes(res, hexagons);
    var out = $7b9f60117f9c280b$var$readArrayOfHexagons(hexagons, count);
    $7b9f60117f9c280b$var$libh3._free(hexagons);
    return out;
}
/**
 * Convert degrees to radians
 * @static
 * @param  {number} deg Value in degrees
 * @return {number}     Value in radians
 */ function $7b9f60117f9c280b$export$18f2af2888c1a46b(deg) {
    return deg * Math.PI / 180;
}
/**
 * Convert radians to degrees
 * @static
 * @param  {number} rad Value in radians
 * @return {number}     Value in degrees
 */ function $7b9f60117f9c280b$export$3eb27537c08caf0f(rad) {
    return rad * 180 / Math.PI;
}

});

parcelRegister("7Nl5T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5acd78db0a0647e6$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $fsooW = parcelRequire("fsooW");

var $aC2tH = parcelRequire("aC2tH");

var $cwF9s = parcelRequire("cwF9s");

var $coXLq = parcelRequire("coXLq");
var $abpME = parcelRequire("abpME");

var $WRwuG = parcelRequire("WRwuG");
var $6ey8i = parcelRequire("6ey8i");
const $5acd78db0a0647e6$var$UPDATE_THRESHOLD_KM = 10;
function $5acd78db0a0647e6$export$e871080d474bbdcf(vertices, refLng) {
    refLng = refLng === undefined ? vertices[0][0] : refLng;
    for (const pt of vertices){
        const deltaLng = pt[0] - refLng;
        if (deltaLng > 180) pt[0] -= 360;
        else if (deltaLng < -180) pt[0] += 360;
    }
}
function $5acd78db0a0647e6$export$b32c4d26933d0880(hexId, vertices, factor) {
    const [lat, lng] = (0, $aC2tH.h3ToGeo)(hexId);
    const actualCount = vertices.length;
    $5acd78db0a0647e6$export$e871080d474bbdcf(vertices, lng);
    const vertexCount = vertices[0] === vertices[actualCount - 1] ? actualCount - 1 : actualCount;
    for(let i = 0; i < vertexCount; i++){
        vertices[i][0] = (0, $cwF9s.lerp)(lng, vertices[i][0], factor);
        vertices[i][1] = (0, $cwF9s.lerp)(lat, vertices[i][1], factor);
    }
}
function $5acd78db0a0647e6$var$getHexagonCentroid(getHexagon, object, objectInfo) {
    const hexagonId = getHexagon(object, objectInfo);
    const [lat, lng] = (0, $aC2tH.h3ToGeo)(hexagonId);
    return [
        lng,
        lat
    ];
}
function $5acd78db0a0647e6$var$h3ToPolygon(hexId, coverage = 1) {
    const vertices = (0, $aC2tH.h3ToGeoBoundary)(hexId, true);
    if (coverage !== 1) $5acd78db0a0647e6$export$b32c4d26933d0880(hexId, vertices, coverage);
    else $5acd78db0a0647e6$export$e871080d474bbdcf(vertices);
    return vertices;
}
function $5acd78db0a0647e6$var$flattenPolygon(vertices) {
    const positions = new Float64Array(vertices.length * 2);
    let i = 0;
    for (const pt of vertices){
        positions[i++] = pt[0];
        positions[i++] = pt[1];
    }
    return positions;
}
function $5acd78db0a0647e6$var$mergeTriggers(getHexagon, coverage) {
    let trigger;
    if (getHexagon === undefined || getHexagon === null) trigger = coverage;
    else if (typeof getHexagon === "object") trigger = (0, $edHbI._)((0, $2QP2i._)({}, getHexagon), {
        coverage: coverage
    });
    else trigger = {
        getHexagon: getHexagon,
        coverage: coverage
    };
    return trigger;
}
const $5acd78db0a0647e6$var$defaultProps = (0, $edHbI._)((0, $2QP2i._)({}, (0, $6ey8i.default).defaultProps), {
    highPrecision: "auto",
    coverage: {
        type: "number",
        min: 0,
        max: 1,
        value: 1
    },
    centerHexagon: null,
    getHexagon: {
        type: "accessor",
        value: (x)=>x.hexagon
    },
    extruded: true
});
class $5acd78db0a0647e6$export$2e2bcd8739ae039 extends (0, $coXLq.default) {
    initializeState() {
        $5acd78db0a0647e6$export$2e2bcd8739ae039._checkH3Lib();
        this.state = {
            edgeLengthKM: 0,
            resolution: -1
        };
    }
    shouldUpdateState({ changeFlags: changeFlags }) {
        return this._shouldUseHighPrecision() ? changeFlags.propsOrDataChanged : changeFlags.somethingChanged;
    }
    updateState({ props: props, changeFlags: changeFlags }) {
        if (props.highPrecision !== true && (changeFlags.dataChanged || changeFlags.updateTriggersChanged && changeFlags.updateTriggersChanged.getHexagon)) {
            const dataProps = this._calculateH3DataProps();
            this.setState(dataProps);
        }
        this._updateVertices(this.context.viewport);
    }
    _calculateH3DataProps() {
        let resolution = -1;
        let hasPentagon = false;
        let hasMultipleRes = false;
        const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(this.props.data);
        for (const object of iterable){
            objectInfo.index++;
            const hexId = this.props.getHexagon(object, objectInfo);
            const hexResolution = (0, $aC2tH.h3GetResolution)(hexId);
            if (resolution < 0) {
                resolution = hexResolution;
                if (!this.props.highPrecision) break;
            } else if (resolution !== hexResolution) {
                hasMultipleRes = true;
                break;
            }
            if ((0, $aC2tH.h3IsPentagon)(hexId)) {
                hasPentagon = true;
                break;
            }
        }
        return {
            resolution: resolution,
            edgeLengthKM: resolution >= 0 ? (0, $aC2tH.edgeLength)(resolution, "km") : 0,
            hasMultipleRes: hasMultipleRes,
            hasPentagon: hasPentagon
        };
    }
    _shouldUseHighPrecision() {
        if (this.props.highPrecision === "auto") {
            const { resolution: resolution, hasPentagon: hasPentagon, hasMultipleRes: hasMultipleRes } = this.state;
            const { viewport: viewport } = this.context;
            return Boolean(viewport === null || viewport === void 0 ? void 0 : viewport.resolution) || hasMultipleRes || hasPentagon || resolution >= 0 && resolution <= 5;
        }
        return this.props.highPrecision;
    }
    _updateVertices(viewport) {
        if (this._shouldUseHighPrecision()) return;
        const { resolution: resolution, edgeLengthKM: edgeLengthKM, centerHex: centerHex } = this.state;
        if (resolution < 0) return;
        const hex = this.props.centerHexagon || (0, $aC2tH.geoToH3)(viewport.latitude, viewport.longitude, resolution);
        if (centerHex === hex) return;
        if (centerHex) {
            const distance = (0, $aC2tH.h3Distance)(centerHex, hex);
            if (distance >= 0 && distance * edgeLengthKM < $5acd78db0a0647e6$var$UPDATE_THRESHOLD_KM) return;
        }
        const { unitsPerMeter: unitsPerMeter } = viewport.distanceScales;
        let vertices = $5acd78db0a0647e6$var$h3ToPolygon(hex);
        const [centerLat, centerLng] = (0, $aC2tH.h3ToGeo)(hex);
        const [centerX, centerY] = viewport.projectFlat([
            centerLng,
            centerLat
        ]);
        vertices = vertices.map((p)=>{
            const worldPosition = viewport.projectFlat(p);
            return [
                (worldPosition[0] - centerX) / unitsPerMeter[0],
                (worldPosition[1] - centerY) / unitsPerMeter[1]
            ];
        });
        this.setState({
            centerHex: hex,
            vertices: vertices
        });
    }
    renderLayers() {
        return this._shouldUseHighPrecision() ? this._renderPolygonLayer() : this._renderColumnLayer();
    }
    _getForwardProps() {
        const { elevationScale: elevationScale, material: material, coverage: coverage, extruded: extruded, wireframe: wireframe, stroked: stroked, filled: filled, lineWidthUnits: lineWidthUnits, lineWidthScale: lineWidthScale, lineWidthMinPixels: lineWidthMinPixels, lineWidthMaxPixels: lineWidthMaxPixels, getFillColor: getFillColor, getElevation: getElevation, getLineColor: getLineColor, getLineWidth: getLineWidth, transitions: transitions, updateTriggers: updateTriggers } = this.props;
        return {
            elevationScale: elevationScale,
            extruded: extruded,
            coverage: coverage,
            wireframe: wireframe,
            stroked: stroked,
            filled: filled,
            lineWidthUnits: lineWidthUnits,
            lineWidthScale: lineWidthScale,
            lineWidthMinPixels: lineWidthMinPixels,
            lineWidthMaxPixels: lineWidthMaxPixels,
            material: material,
            getElevation: getElevation,
            getFillColor: getFillColor,
            getLineColor: getLineColor,
            getLineWidth: getLineWidth,
            transitions: transitions,
            updateTriggers: {
                getFillColor: updateTriggers.getFillColor,
                getElevation: updateTriggers.getElevation,
                getLineColor: updateTriggers.getLineColor,
                getLineWidth: updateTriggers.getLineWidth
            }
        };
    }
    _renderPolygonLayer() {
        const { data: data, getHexagon: getHexagon, updateTriggers: updateTriggers, coverage: coverage } = this.props;
        const SubLayerClass = this.getSubLayerClass("hexagon-cell-hifi", (0, $6ey8i.default));
        const forwardProps = this._getForwardProps();
        forwardProps.updateTriggers.getPolygon = $5acd78db0a0647e6$var$mergeTriggers(updateTriggers.getHexagon, coverage);
        return new SubLayerClass(forwardProps, this.getSubLayerProps({
            id: "hexagon-cell-hifi",
            updateTriggers: forwardProps.updateTriggers
        }), {
            data: data,
            _normalize: false,
            _windingOrder: "CCW",
            positionFormat: "XY",
            getPolygon: (object, objectInfo)=>{
                const hexagonId = getHexagon(object, objectInfo);
                return $5acd78db0a0647e6$var$flattenPolygon($5acd78db0a0647e6$var$h3ToPolygon(hexagonId, coverage));
            }
        });
    }
    _renderColumnLayer() {
        const { data: data, getHexagon: getHexagon, updateTriggers: updateTriggers } = this.props;
        const SubLayerClass = this.getSubLayerClass("hexagon-cell", (0, $WRwuG.default));
        const forwardProps = this._getForwardProps();
        forwardProps.updateTriggers.getPosition = updateTriggers.getHexagon;
        return new SubLayerClass(forwardProps, this.getSubLayerProps({
            id: "hexagon-cell",
            flatShading: true,
            updateTriggers: forwardProps.updateTriggers
        }), {
            data: data,
            diskResolution: 6,
            radius: 1,
            vertices: this.state.vertices,
            getPosition: $5acd78db0a0647e6$var$getHexagonCentroid.bind(null, getHexagon)
        });
    }
    constructor(...args){
        super(...args);
        (0, $fsooW.default)(this, "state", void 0);
    }
}
(0, $fsooW.default)($5acd78db0a0647e6$export$2e2bcd8739ae039, "defaultProps", $5acd78db0a0647e6$var$defaultProps);
(0, $fsooW.default)($5acd78db0a0647e6$export$2e2bcd8739ae039, "layerName", "H3HexagonLayer");
(0, $fsooW.default)($5acd78db0a0647e6$export$2e2bcd8739ae039, "_checkH3Lib", ()=>{});

});
parcelRegister("WRwuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b0eef7759c953e9$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $b8HWT = parcelRequire("b8HWT");
var $i46md = parcelRequire("i46md");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");
var $7gQQK = parcelRequire("7gQQK");

var $68aPy = parcelRequire("68aPy");
var $tIWfJ = parcelRequire("tIWfJ");parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $b2F4S = parcelRequire("b2F4S");

var $XMj3k = parcelRequire("XMj3k");

var $jPf8H = parcelRequire("jPf8H");

var $c3KZe = parcelRequire("c3KZe");
const $0b0eef7759c953e9$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $0b0eef7759c953e9$var$defaultProps = {
    diskResolution: {
        type: "number",
        min: 4,
        value: 20
    },
    vertices: null,
    radius: {
        type: "number",
        min: 0,
        value: 1000
    },
    angle: {
        type: "number",
        value: 0
    },
    offset: {
        type: "array",
        value: [
            0,
            0
        ]
    },
    coverage: {
        type: "number",
        min: 0,
        max: 1,
        value: 1
    },
    elevationScale: {
        type: "number",
        min: 0,
        value: 1
    },
    radiusUnits: "meters",
    lineWidthUnits: "meters",
    lineWidthScale: 1,
    lineWidthMinPixels: 0,
    lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
    extruded: true,
    wireframe: false,
    filled: true,
    stroked: false,
    getPosition: {
        type: "accessor",
        value: (x)=>x.position
    },
    getFillColor: {
        type: "accessor",
        value: $0b0eef7759c953e9$var$DEFAULT_COLOR
    },
    getLineColor: {
        type: "accessor",
        value: $0b0eef7759c953e9$var$DEFAULT_COLOR
    },
    getLineWidth: {
        type: "accessor",
        value: 1
    },
    getElevation: {
        type: "accessor",
        value: 1000
    },
    material: true,
    getColor: {
        deprecatedFor: [
            "getFillColor",
            "getLineColor"
        ]
    }
};
class $0b0eef7759c953e9$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getShaders() {
        const { gl: gl } = this.context;
        const transpileToGLSL100 = !(0, $8HKWo.isWebGL2)(gl);
        const defines = {};
        const useDerivatives = this.props.flatShading && (0, $tIWfJ.hasFeature)(gl, (0, $68aPy.FEATURES).GLSL_DERIVATIVES);
        if (useDerivatives) defines.FLAT_SHADING = 1;
        return super.getShaders({
            vs: $jPf8H.default,
            fs: $c3KZe.default,
            defines: defines,
            transpileToGLSL100: transpileToGLSL100,
            modules: [
                (0, $jRSMz.default),
                useDerivatives ? (0, $b8HWT.phongLighting) : (0, $b8HWT.gouraudLighting),
                (0, $7UxuR.default)
            ]
        });
    }
    initializeState() {
        const attributeManager = this.getAttributeManager();
        attributeManager.addInstanced({
            instancePositions: {
                size: 3,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: true,
                accessor: "getPosition"
            },
            instanceElevations: {
                size: 1,
                transition: true,
                accessor: "getElevation"
            },
            instanceFillColors: {
                size: this.props.colorFormat.length,
                type: 5121,
                normalized: true,
                transition: true,
                accessor: "getFillColor",
                defaultValue: $0b0eef7759c953e9$var$DEFAULT_COLOR
            },
            instanceLineColors: {
                size: this.props.colorFormat.length,
                type: 5121,
                normalized: true,
                transition: true,
                accessor: "getLineColor",
                defaultValue: $0b0eef7759c953e9$var$DEFAULT_COLOR
            },
            instanceStrokeWidths: {
                size: 1,
                accessor: "getLineWidth",
                transition: true
            }
        });
    }
    updateState(params) {
        super.updateState(params);
        const { props: props, oldProps: oldProps, changeFlags: changeFlags } = params;
        const regenerateModels = changeFlags.extensionsChanged || props.flatShading !== oldProps.flatShading;
        if (regenerateModels) {
            var _this$state$model;
            const { gl: gl } = this.context;
            (_this$state$model = this.state.model) === null || _this$state$model === void 0 || _this$state$model.delete();
            this.state.model = this._getModel(gl);
            this.getAttributeManager().invalidateAll();
        }
        if (regenerateModels || props.diskResolution !== oldProps.diskResolution || props.vertices !== oldProps.vertices || (props.extruded || props.stroked) !== (oldProps.extruded || oldProps.stroked)) this._updateGeometry(props);
    }
    getGeometry(diskResolution, vertices, hasThinkness) {
        const geometry = new (0, $XMj3k.default)({
            radius: 1,
            height: hasThinkness ? 2 : 0,
            vertices: vertices,
            nradial: diskResolution
        });
        let meanVertexDistance = 0;
        if (vertices) for(let i = 0; i < diskResolution; i++){
            const p = vertices[i];
            const d = Math.sqrt(p[0] * p[0] + p[1] * p[1]);
            meanVertexDistance += d / diskResolution;
        }
        else meanVertexDistance = 1;
        this.setState({
            edgeDistance: Math.cos(Math.PI / diskResolution) * meanVertexDistance
        });
        return geometry;
    }
    _getModel(gl) {
        return new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders()), {
            id: this.props.id,
            isInstanced: true
        }));
    }
    _updateGeometry({ diskResolution: diskResolution, vertices: vertices, extruded: extruded, stroked: stroked }) {
        const geometry = this.getGeometry(diskResolution, vertices, extruded || stroked);
        this.setState({
            fillVertexCount: geometry.attributes.POSITION.value.length / 3,
            wireframeVertexCount: geometry.indices.value.length
        });
        this.state.model.setProps({
            geometry: geometry
        });
    }
    draw({ uniforms: uniforms }) {
        const { lineWidthUnits: lineWidthUnits, lineWidthScale: lineWidthScale, lineWidthMinPixels: lineWidthMinPixels, lineWidthMaxPixels: lineWidthMaxPixels, radiusUnits: radiusUnits, elevationScale: elevationScale, extruded: extruded, filled: filled, stroked: stroked, wireframe: wireframe, offset: offset, coverage: coverage, radius: radius, angle: angle } = this.props;
        const { model: model, fillVertexCount: fillVertexCount, wireframeVertexCount: wireframeVertexCount, edgeDistance: edgeDistance } = this.state;
        model.setUniforms(uniforms).setUniforms({
            radius: radius,
            angle: angle / 180 * Math.PI,
            offset: offset,
            extruded: extruded,
            stroked: stroked,
            coverage: coverage,
            elevationScale: elevationScale,
            edgeDistance: edgeDistance,
            radiusUnits: (0, $7gQQK.UNIT)[radiusUnits],
            widthUnits: (0, $7gQQK.UNIT)[lineWidthUnits],
            widthScale: lineWidthScale,
            widthMinPixels: lineWidthMinPixels,
            widthMaxPixels: lineWidthMaxPixels
        });
        if (extruded && wireframe) {
            model.setProps({
                isIndexed: true
            });
            model.setVertexCount(wireframeVertexCount).setDrawMode(1).setUniforms({
                isStroke: true
            }).draw();
        }
        if (filled) {
            model.setProps({
                isIndexed: false
            });
            model.setVertexCount(fillVertexCount).setDrawMode(5).setUniforms({
                isStroke: false
            }).draw();
        }
        if (!extruded && stroked) {
            model.setProps({
                isIndexed: false
            });
            model.setVertexCount(fillVertexCount * 2 / 3).setDrawMode(5).setUniforms({
                isStroke: true
            }).draw();
        }
    }
}
(0, $lEQUF.default)($0b0eef7759c953e9$export$2e2bcd8739ae039, "layerName", "ColumnLayer");
(0, $lEQUF.default)($0b0eef7759c953e9$export$2e2bcd8739ae039, "defaultProps", $0b0eef7759c953e9$var$defaultProps);

});
parcelRegister("XMj3k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b3afb6da2751738$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4VQgq = parcelRequire("4VQgq");

var $cxTxU = parcelRequire("cxTxU");
var $iljOc = parcelRequire("iljOc");
parcelRequire("b5AlO");
var $2d6CO = parcelRequire("2d6CO");
class $0b3afb6da2751738$export$2e2bcd8739ae039 extends (0, $cxTxU.default) {
    constructor(props){
        const { id: id = (0, $iljOc.uid)("column-geometry") } = props;
        const { indices: indices, attributes: attributes } = $0b3afb6da2751738$var$tesselateColumn(props);
        super((0, $edHbI._)((0, $2QP2i._)({}, props), {
            id: id,
            indices: indices,
            attributes: attributes
        }));
    }
}
function $0b3afb6da2751738$var$tesselateColumn(props) {
    const { radius: radius, height: height = 1, nradial: nradial = 10 } = props;
    let { vertices: vertices } = props;
    if (vertices) {
        (0, $4VQgq.default).assert(vertices.length >= nradial);
        vertices = vertices.flatMap((v)=>[
                v[0],
                v[1]
            ]);
        (0, $2d6CO.modifyPolygonWindingDirection)(vertices, (0, $2d6CO.WINDING).COUNTER_CLOCKWISE);
    }
    const isExtruded = height > 0;
    const vertsAroundEdge = nradial + 1;
    const numVertices = isExtruded ? vertsAroundEdge * 3 + 1 : nradial;
    const stepAngle = Math.PI * 2 / nradial;
    const indices = new Uint16Array(isExtruded ? nradial * 6 : 0);
    const positions = new Float32Array(numVertices * 3);
    const normals = new Float32Array(numVertices * 3);
    let i = 0;
    if (isExtruded) {
        for(let j = 0; j < vertsAroundEdge; j++){
            const a = j * stepAngle;
            const vertexIndex = j % nradial;
            const sin = Math.sin(a);
            const cos = Math.cos(a);
            for(let k = 0; k < 2; k++){
                positions[i + 0] = vertices ? vertices[vertexIndex * 2] : cos * radius;
                positions[i + 1] = vertices ? vertices[vertexIndex * 2 + 1] : sin * radius;
                positions[i + 2] = (0.5 - k) * height;
                normals[i + 0] = vertices ? vertices[vertexIndex * 2] : cos;
                normals[i + 1] = vertices ? vertices[vertexIndex * 2 + 1] : sin;
                i += 3;
            }
        }
        positions[i + 0] = positions[i - 3];
        positions[i + 1] = positions[i - 2];
        positions[i + 2] = positions[i - 1];
        i += 3;
    }
    for(let j = isExtruded ? 0 : 1; j < vertsAroundEdge; j++){
        const v = Math.floor(j / 2) * Math.sign(0.5 - j % 2);
        const a = v * stepAngle;
        const vertexIndex = (v + nradial) % nradial;
        const sin = Math.sin(a);
        const cos = Math.cos(a);
        positions[i + 0] = vertices ? vertices[vertexIndex * 2] : cos * radius;
        positions[i + 1] = vertices ? vertices[vertexIndex * 2 + 1] : sin * radius;
        positions[i + 2] = height / 2;
        normals[i + 2] = 1;
        i += 3;
    }
    if (isExtruded) {
        let index = 0;
        for(let j = 0; j < nradial; j++){
            indices[index++] = j * 2 + 0;
            indices[index++] = j * 2 + 2;
            indices[index++] = j * 2 + 0;
            indices[index++] = j * 2 + 1;
            indices[index++] = j * 2 + 1;
            indices[index++] = j * 2 + 3;
        }
    }
    return {
        indices: indices,
        attributes: {
            POSITION: {
                size: 3,
                value: positions
            },
            NORMAL: {
                size: 3,
                value: normals
            }
        }
    };
}

});

parcelRegister("jPf8H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6ee861d981f4086$export$2e2bcd8739ae039; });
var $e6ee861d981f4086$export$2e2bcd8739ae039 = "#version 300 es\n\n#define SHADER_NAME column-layer-vertex-shader\n\nin vec3 positions;\nin vec3 normals;\n\nin vec3 instancePositions;\nin float instanceElevations;\nin vec3 instancePositions64Low;\nin vec4 instanceFillColors;\nin vec4 instanceLineColors;\nin float instanceStrokeWidths;\n\nin vec3 instancePickingColors;\nuniform float opacity;\nuniform float radius;\nuniform float angle;\nuniform vec2 offset;\nuniform bool extruded;\nuniform bool stroked;\nuniform bool isStroke;\nuniform float coverage;\nuniform float elevationScale;\nuniform float edgeDistance;\nuniform float widthScale;\nuniform float widthMinPixels;\nuniform float widthMaxPixels;\nuniform int radiusUnits;\nuniform int widthUnits;\nout vec4 vColor;\n#ifdef FLAT_SHADING\nout vec4 position_commonspace;\n#endif\n\nvoid main(void) {\n  geometry.worldPosition = instancePositions;\n\n  vec4 color = isStroke ? instanceLineColors : instanceFillColors;\n  mat2 rotationMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  float elevation = 0.0;\n  float strokeOffsetRatio = 1.0;\n\n  if (extruded) {\n    elevation = instanceElevations * (positions.z + 1.0) / 2.0 * elevationScale;\n  } else if (stroked) {\n    float widthPixels = clamp(\n      project_size_to_pixel(instanceStrokeWidths * widthScale, widthUnits),\n      widthMinPixels, widthMaxPixels) / 2.0;\n    float halfOffset = project_pixel_size(widthPixels) / project_size(edgeDistance * coverage * radius);\n    if (isStroke) {\n      strokeOffsetRatio -= sign(positions.z) * halfOffset;\n    } else {\n      strokeOffsetRatio -= halfOffset;\n    }\n  }\n  float shouldRender = float(color.a > 0.0 && instanceElevations >= 0.0);\n  float dotRadius = radius * coverage * shouldRender;\n\n  geometry.pickingColor = instancePickingColors;\n  vec3 centroidPosition = vec3(instancePositions.xy, instancePositions.z + elevation);\n  vec3 centroidPosition64Low = instancePositions64Low;\n  vec2 offset = (rotationMatrix * positions.xy * strokeOffsetRatio + offset) * dotRadius;\n  if (radiusUnits == UNIT_METERS) {\n    offset = project_size(offset);\n  }\n  vec3 pos = vec3(offset, 0.);\n  DECKGL_FILTER_SIZE(pos, geometry);\n\n  gl_Position = project_position_to_clipspace(centroidPosition, centroidPosition64Low, pos, geometry.position);\n  geometry.normal = project_normal(vec3(rotationMatrix * normals.xy, normals.z));\n  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n  if (extruded && !isStroke) {\n#ifdef FLAT_SHADING\n    position_commonspace = geometry.position;\n    vColor = vec4(color.rgb, color.a * opacity);\n#else\n    vec3 lightColor = lighting_getLightColor(color.rgb, project_uCameraPosition, geometry.position.xyz, geometry.normal);\n    vColor = vec4(lightColor, color.a * opacity);\n#endif\n  } else {\n    vColor = vec4(color.rgb, color.a * opacity);\n  }\n  DECKGL_FILTER_COLOR(vColor, geometry);\n}\n";

});

parcelRegister("c3KZe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7a3669e1f85a24$export$2e2bcd8739ae039; });
var $8c7a3669e1f85a24$export$2e2bcd8739ae039 = "#version 300 es\n#define SHADER_NAME column-layer-fragment-shader\n\nprecision highp float;\n\nuniform vec3 project_uCameraPosition;\nuniform bool extruded;\nuniform bool isStroke;\n\nout vec4 fragColor;\n\nin vec4 vColor;\n#ifdef FLAT_SHADING\nin vec4 position_commonspace;\n#endif\n\nvoid main(void) {\n  fragColor = vColor;\n#ifdef FLAT_SHADING\n  if (extruded && !isStroke && !picking_uActive) {\n    vec3 normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));\n    fragColor.rgb = lighting_getLightColor(vColor.rgb, project_uCameraPosition, position_commonspace.xyz, normal);\n  }\n#endif\n  DECKGL_FILTER_COLOR(fragColor, geometry);\n}\n";

});



parcelRegister("gpJBL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf325bf6469f0f15$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $fsooW = parcelRequire("fsooW");

var $coXLq = parcelRequire("coXLq");

var $6ey8i = parcelRequire("6ey8i");
const $bf325bf6469f0f15$var$defaultProps = (0, $2QP2i._)({}, (0, $6ey8i.default).defaultProps);
class $bf325bf6469f0f15$export$2e2bcd8739ae039 extends (0, $coXLq.default) {
    indexToBounds() {
        return null;
    }
    renderLayers() {
        const { elevationScale: elevationScale, extruded: extruded, wireframe: wireframe, filled: filled, stroked: stroked, lineWidthUnits: lineWidthUnits, lineWidthScale: lineWidthScale, lineWidthMinPixels: lineWidthMinPixels, lineWidthMaxPixels: lineWidthMaxPixels, lineJointRounded: lineJointRounded, lineMiterLimit: lineMiterLimit, lineDashJustified: lineDashJustified, getElevation: getElevation, getFillColor: getFillColor, getLineColor: getLineColor, getLineWidth: getLineWidth } = this.props;
        const { updateTriggers: updateTriggers, material: material, transitions: transitions } = this.props;
        const CellLayer = this.getSubLayerClass("cell", (0, $6ey8i.default));
        const _ref = this.indexToBounds() || {}, { updateTriggers: boundsUpdateTriggers } = _ref, boundsProps = (0, $bmkEq._)(_ref, [
            "updateTriggers"
        ]);
        return new CellLayer({
            filled: filled,
            wireframe: wireframe,
            extruded: extruded,
            elevationScale: elevationScale,
            stroked: stroked,
            lineWidthUnits: lineWidthUnits,
            lineWidthScale: lineWidthScale,
            lineWidthMinPixels: lineWidthMinPixels,
            lineWidthMaxPixels: lineWidthMaxPixels,
            lineJointRounded: lineJointRounded,
            lineMiterLimit: lineMiterLimit,
            lineDashJustified: lineDashJustified,
            material: material,
            transitions: transitions,
            getElevation: getElevation,
            getFillColor: getFillColor,
            getLineColor: getLineColor,
            getLineWidth: getLineWidth
        }, this.getSubLayerProps({
            id: "cell",
            updateTriggers: updateTriggers && (0, $edHbI._)((0, $2QP2i._)({}, boundsUpdateTriggers), {
                getElevation: updateTriggers.getElevation,
                getFillColor: updateTriggers.getFillColor,
                getLineColor: updateTriggers.getLineColor,
                getLineWidth: updateTriggers.getLineWidth
            })
        }), boundsProps);
    }
}
(0, $fsooW.default)($bf325bf6469f0f15$export$2e2bcd8739ae039, "layerName", "GeoCellLayer");
(0, $fsooW.default)($bf325bf6469f0f15$export$2e2bcd8739ae039, "defaultProps", $bf325bf6469f0f15$var$defaultProps);

});


parcelRegister("1LI2z", function(module, exports) {

$parcel$export(module.exports, "geoToH3", function () { return $149c57bfd39d3746$export$24131a74a154ec65; });
$parcel$export(module.exports, "polyfill", function () { return $149c57bfd39d3746$export$cea1c58a6db52bca; });
var $149c57bfd39d3746$var$libh3 = function(libh3) {
    libh3 = libh3 || {};
    var Module = typeof libh3 !== "undefined" ? libh3 : {};
    var moduleOverrides = {};
    var key;
    for(key in Module)if (Module.hasOwnProperty(key)) moduleOverrides[key] = Module[key];
    var arguments_ = [];
    var scriptDirectory = "";
    function locateFile(path) {
        if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
        return scriptDirectory + path;
    }
    var readAsync;
    if (document.currentScript) scriptDirectory = document.currentScript.src;
    if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf("/") + 1);
    else scriptDirectory = "";
    readAsync = function readAsync(url, onload, onerror) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "arraybuffer";
        xhr.onload = function xhr_onload() {
            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                onload(xhr.response);
                return;
            }
            var data = tryParseAsDataURI(url);
            if (data) {
                onload(data.buffer);
                return;
            }
            onerror();
        };
        xhr.onerror = onerror;
        xhr.send(null);
    };
    var out = Module["print"] || console.log.bind(console);
    var err = Module["printErr"] || console.warn.bind(console);
    for(key in moduleOverrides)if (moduleOverrides.hasOwnProperty(key)) Module[key] = moduleOverrides[key];
    moduleOverrides = null;
    if (Module["arguments"]) arguments_ = Module["arguments"];
    var tempRet0 = 0;
    var setTempRet0 = function(value) {
        tempRet0 = value;
    };
    var getTempRet0 = function() {
        return tempRet0;
    };
    var GLOBAL_BASE = 8;
    function setValue(ptr, value, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                HEAP8[ptr >> 0] = value;
                break;
            case "i8":
                HEAP8[ptr >> 0] = value;
                break;
            case "i16":
                HEAP16[ptr >> 1] = value;
                break;
            case "i32":
                HEAP32[ptr >> 2] = value;
                break;
            case "i64":
                tempI64 = [
                    value >>> 0,
                    (tempDouble = value, +Math_abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math_min(+Math_floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];
                break;
            case "float":
                HEAPF32[ptr >> 2] = value;
                break;
            case "double":
                HEAPF64[ptr >> 3] = value;
                break;
            default:
                abort("invalid type for setValue: " + type);
        }
    }
    function getValue(ptr, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                return HEAP8[ptr >> 0];
            case "i8":
                return HEAP8[ptr >> 0];
            case "i16":
                return HEAP16[ptr >> 1];
            case "i32":
                return HEAP32[ptr >> 2];
            case "i64":
                return HEAP32[ptr >> 2];
            case "float":
                return HEAPF32[ptr >> 2];
            case "double":
                return HEAPF64[ptr >> 3];
            default:
                abort("invalid type for getValue: " + type);
        }
        return null;
    }
    var ABORT = false;
    function assert(condition, text) {
        if (!condition) abort("Assertion failed: " + text);
    }
    function getCFunc(ident) {
        var func = Module["_" + ident];
        assert(func, "Cannot call unknown function " + ident + ", make sure it is exported");
        return func;
    }
    function ccall(ident, returnType, argTypes, args, opts) {
        var toC = {
            "string": function(str) {
                var ret = 0;
                if (str !== null && str !== undefined && str !== 0) {
                    var len = (str.length << 2) + 1;
                    ret = stackAlloc(len);
                    stringToUTF8(str, ret, len);
                }
                return ret;
            },
            "array": function(arr) {
                var ret = stackAlloc(arr.length);
                writeArrayToMemory(arr, ret);
                return ret;
            }
        };
        function convertReturnValue(ret) {
            if (returnType === "string") return UTF8ToString(ret);
            if (returnType === "boolean") return Boolean(ret);
            return ret;
        }
        var func = getCFunc(ident);
        var cArgs = [];
        var stack = 0;
        if (args) for(var i = 0; i < args.length; i++){
            var converter = toC[argTypes[i]];
            if (converter) {
                if (stack === 0) stack = stackSave();
                cArgs[i] = converter(args[i]);
            } else cArgs[i] = args[i];
        }
        var ret = func.apply(null, cArgs);
        ret = convertReturnValue(ret);
        if (stack !== 0) stackRestore(stack);
        return ret;
    }
    function cwrap(ident, returnType, argTypes, opts) {
        argTypes = argTypes || [];
        var numericArgs = argTypes.every(function(type) {
            return type === "number";
        });
        var numericRet = returnType !== "string";
        if (numericRet && numericArgs && !opts) return getCFunc(ident);
        return function() {
            return ccall(ident, returnType, argTypes, arguments, opts);
        };
    }
    var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : undefined;
    function UTF8ArrayToString(u8Array, idx, maxBytesToRead) {
        var endIdx = idx + maxBytesToRead;
        var endPtr = idx;
        while(u8Array[endPtr] && !(endPtr >= endIdx))++endPtr;
        if (endPtr - idx > 16 && u8Array.subarray && UTF8Decoder) return UTF8Decoder.decode(u8Array.subarray(idx, endPtr));
        else {
            var str = "";
            while(idx < endPtr){
                var u0 = u8Array[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = u8Array[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = u8Array[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | u8Array[idx++] & 63;
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
        }
        return str;
    }
    function UTF8ToString(ptr, maxBytesToRead) {
        return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
    }
    function stringToUTF8Array(str, outU8Array, outIdx, maxBytesToWrite) {
        if (!(maxBytesToWrite > 0)) return 0;
        var startIdx = outIdx;
        var endIdx = outIdx + maxBytesToWrite - 1;
        for(var i = 0; i < str.length; ++i){
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
                var u1 = str.charCodeAt(++i);
                u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
                if (outIdx >= endIdx) break;
                outU8Array[outIdx++] = u;
            } else if (u <= 2047) {
                if (outIdx + 1 >= endIdx) break;
                outU8Array[outIdx++] = 192 | u >> 6;
                outU8Array[outIdx++] = 128 | u & 63;
            } else if (u <= 65535) {
                if (outIdx + 2 >= endIdx) break;
                outU8Array[outIdx++] = 224 | u >> 12;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            } else {
                if (outIdx + 3 >= endIdx) break;
                outU8Array[outIdx++] = 240 | u >> 18;
                outU8Array[outIdx++] = 128 | u >> 12 & 63;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            }
        }
        outU8Array[outIdx] = 0;
        return outIdx - startIdx;
    }
    function stringToUTF8(str, outPtr, maxBytesToWrite) {
        return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
    }
    var UTF16Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : undefined;
    function writeArrayToMemory(array, buffer) {
        HEAP8.set(array, buffer);
    }
    function alignUp(x, multiple) {
        if (x % multiple > 0) x += multiple - x % multiple;
        return x;
    }
    var buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
    function updateGlobalBufferAndViews(buf) {
        buffer = buf;
        Module["HEAP8"] = HEAP8 = new Int8Array(buf);
        Module["HEAP16"] = HEAP16 = new Int16Array(buf);
        Module["HEAP32"] = HEAP32 = new Int32Array(buf);
        Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
        Module["HEAPU16"] = HEAPU16 = new Uint16Array(buf);
        Module["HEAPU32"] = HEAPU32 = new Uint32Array(buf);
        Module["HEAPF32"] = HEAPF32 = new Float32Array(buf);
        Module["HEAPF64"] = HEAPF64 = new Float64Array(buf);
    }
    var DYNAMIC_BASE = 5266928, DYNAMICTOP_PTR = 24016;
    var INITIAL_TOTAL_MEMORY = Module["TOTAL_MEMORY"] || 33554432;
    if (Module["buffer"]) buffer = Module["buffer"];
    else buffer = new ArrayBuffer(INITIAL_TOTAL_MEMORY);
    INITIAL_TOTAL_MEMORY = buffer.byteLength;
    updateGlobalBufferAndViews(buffer);
    HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;
    function callRuntimeCallbacks(callbacks) {
        while(callbacks.length > 0){
            var callback = callbacks.shift();
            if (typeof callback == "function") {
                callback();
                continue;
            }
            var func = callback.func;
            if (typeof func === "number") {
                if (callback.arg === undefined) Module["dynCall_v"](func);
                else Module["dynCall_vi"](func, callback.arg);
            } else func(callback.arg === undefined ? null : callback.arg);
        }
    }
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATMAIN__ = [];
    var __ATPOSTRUN__ = [];
    function preRun() {
        if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [
                Module["preRun"]
            ];
            while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
        }
        callRuntimeCallbacks(__ATPRERUN__);
    }
    function initRuntime() {
        callRuntimeCallbacks(__ATINIT__);
    }
    function preMain() {
        callRuntimeCallbacks(__ATMAIN__);
    }
    function postRun() {
        if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [
                Module["postRun"]
            ];
            while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
        }
        callRuntimeCallbacks(__ATPOSTRUN__);
    }
    function addOnPreRun(cb) {
        __ATPRERUN__.unshift(cb);
    }
    function addOnPostRun(cb) {
        __ATPOSTRUN__.unshift(cb);
    }
    var Math_abs = Math.abs;
    var Math_ceil = Math.ceil;
    var Math_floor = Math.floor;
    var Math_min = Math.min;
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;
    function addRunDependency(id) {
        runDependencies++;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
    }
    function removeRunDependency(id) {
        runDependencies--;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
                clearInterval(runDependencyWatcher);
                runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
                var callback = dependenciesFulfilled;
                dependenciesFulfilled = null;
                callback();
            }
        }
    }
    Module["preloadedImages"] = {};
    Module["preloadedAudios"] = {};
    var memoryInitializer = null;
    var dataURIPrefix = "data:application/octet-stream;base64,";
    function isDataURI(filename) {
        return String.prototype.startsWith ? filename.startsWith(dataURIPrefix) : filename.indexOf(dataURIPrefix) === 0;
    }
    var tempDouble;
    var tempI64;
    memoryInitializer = "data:application/octet-stream;base64,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";
    var tempDoublePtr = 24032;
    function demangle(func) {
        return func;
    }
    function demangleAll(text) {
        var regex = /\b__Z[\w\d_]+/g;
        return text.replace(regex, function(x) {
            var y = demangle(x);
            return x === y ? x : y + " [" + x + "]";
        });
    }
    function jsStackTrace() {
        var err = new Error();
        if (!err.stack) {
            try {
                throw new Error(0);
            } catch (e) {
                err = e;
            }
            if (!err.stack) return "(no stack trace available)";
        }
        return err.stack.toString();
    }
    function stackTrace() {
        var js = jsStackTrace();
        if (Module["extraStackTrace"]) js += "\n" + Module["extraStackTrace"]();
        return demangleAll(js);
    }
    function ___assert_fail(condition, filename, line, func) {
        abort("Assertion failed: " + UTF8ToString(condition) + ", at: " + [
            filename ? UTF8ToString(filename) : "unknown filename",
            line,
            func ? UTF8ToString(func) : "unknown function"
        ]);
    }
    function _emscripten_get_heap_size() {
        return HEAP8.length;
    }
    function _emscripten_memcpy_big(dest, src, num) {
        HEAPU8.set(HEAPU8.subarray(src, src + num), dest);
    }
    function ___setErrNo(value) {
        if (Module["___errno_location"]) HEAP32[Module["___errno_location"]() >> 2] = value;
        return value;
    }
    function abortOnCannotGrowMemory(requestedSize) {
        abort("OOM");
    }
    function emscripten_realloc_buffer(size) {
        try {
            var newBuffer = new ArrayBuffer(size);
            if (newBuffer.byteLength != size) return;
            new Int8Array(newBuffer).set(HEAP8);
            _emscripten_replace_memory(newBuffer);
            updateGlobalBufferAndViews(newBuffer);
            return 1;
        } catch (e) {}
    }
    function _emscripten_resize_heap(requestedSize) {
        var oldSize = _emscripten_get_heap_size();
        var PAGE_MULTIPLE = 16777216;
        var LIMIT = 2147483648 - PAGE_MULTIPLE;
        if (requestedSize > LIMIT) return false;
        var MIN_TOTAL_MEMORY = 16777216;
        var newSize = Math.max(oldSize, MIN_TOTAL_MEMORY);
        while(newSize < requestedSize)if (newSize <= 536870912) newSize = alignUp(2 * newSize, PAGE_MULTIPLE);
        else newSize = Math.min(alignUp((3 * newSize + 2147483648) / 4, PAGE_MULTIPLE), LIMIT);
        var replacement = emscripten_realloc_buffer(newSize);
        if (!replacement) return false;
        return true;
    }
    var decodeBase64 = typeof atob === "function" ? atob : function(input) {
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        do {
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 !== 64) output = output + String.fromCharCode(chr2);
            if (enc4 !== 64) output = output + String.fromCharCode(chr3);
        }while (i < input.length);
        return output;
    };
    function intArrayFromBase64(s) {
        try {
            var decoded = decodeBase64(s);
            var bytes = new Uint8Array(decoded.length);
            for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
            return bytes;
        } catch (_) {
            throw new Error("Converting base64 string to bytes failed.");
        }
    }
    function tryParseAsDataURI(filename) {
        if (!isDataURI(filename)) return;
        return intArrayFromBase64(filename.slice(dataURIPrefix.length));
    }
    var asmGlobalArg = {
        "Math": Math,
        "Int8Array": Int8Array,
        "Int32Array": Int32Array,
        "Uint8Array": Uint8Array,
        "Float32Array": Float32Array,
        "Float64Array": Float64Array
    };
    var asmLibraryArg = {
        "a": abort,
        "b": setTempRet0,
        "c": getTempRet0,
        "d": ___assert_fail,
        "e": ___setErrNo,
        "f": _emscripten_get_heap_size,
        "g": _emscripten_memcpy_big,
        "h": _emscripten_resize_heap,
        "i": abortOnCannotGrowMemory,
        "j": demangle,
        "k": demangleAll,
        "l": emscripten_realloc_buffer,
        "m": jsStackTrace,
        "n": stackTrace,
        "o": tempDoublePtr,
        "p": DYNAMICTOP_PTR
    }; // EMSCRIPTEN_START_ASM
    var asm = /** @suppress {uselessCode} */ function(global, env, buffer) {
        "almost asm";
        var a = new global.Int8Array(buffer), b = new global.Int32Array(buffer), c = new global.Uint8Array(buffer), d = new global.Float32Array(buffer), e = new global.Float64Array(buffer), g = env.p | 0, p = global.Math.floor, q = global.Math.abs, r = global.Math.sqrt, s = global.Math.pow, t = global.Math.cos, u = global.Math.sin, v = global.Math.tan, w = global.Math.acos, x = global.Math.asin, y = global.Math.atan, z = global.Math.atan2, A = global.Math.ceil, B = global.Math.imul, C = global.Math.min, D = global.Math.clz32, F = env.b, G = env.c, H = env.d, I = env.e, J = env.f, K = env.g, L = env.h, M = env.i, S = 24048;
        function V(newBuffer) {
            a = new Int8Array(newBuffer);
            c = new Uint8Array(newBuffer);
            b = new Int32Array(newBuffer);
            d = new Float32Array(newBuffer);
            e = new Float64Array(newBuffer);
            buffer = newBuffer;
            return true;
        } // EMSCRIPTEN_START_FUNCS
        function W(a) {
            a = a | 0;
            var b = 0;
            b = S;
            S = S + a | 0;
            S = S + 15 & -16;
            return b | 0;
        }
        function X() {
            return S | 0;
        }
        function Y(a) {
            a = a | 0;
            S = a;
        }
        function Z(a, b) {
            a = a | 0;
            b = b | 0;
            S = a;
        }
        function _(a) {
            a = a | 0;
            return (B(a * 3 | 0, a + 1 | 0) | 0) + 1 | 0;
        }
        function $(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            if (!(ba(a, b, c, d, 0) | 0)) return;
            f = (B(c * 3 | 0, c + 1 | 0) | 0) + 1 | 0;
            gd(d | 0, 0, f << 3 | 0);
            e = Xc(f, 4) | 0;
            if (!e) return;
            ca(a, b, c, d, e, f, 0);
            Wc(e);
            return;
        }
        function aa(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            if (!(ba(a, b, c, d, e) | 0)) return;
            f = (B(c * 3 | 0, c + 1 | 0) | 0) + 1 | 0;
            gd(d | 0, 0, f << 3 | 0);
            if (e | 0) {
                gd(e | 0, 0, f << 2 | 0);
                ca(a, b, c, d, e, f, 0);
                return;
            }
            e = Xc(f, 4) | 0;
            if (!e) return;
            ca(a, b, c, d, e, f, 0);
            Wc(e);
            return;
        }
        function ba(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
            o = S;
            S = S + 16 | 0;
            n = o;
            g = e;
            b[g >> 2] = a;
            b[g + 4 >> 2] = c;
            g = (f | 0) != 0;
            if (g) b[f >> 2] = 0;
            if (Eb(a, c) | 0) {
                n = 1;
                S = o;
                return n | 0;
            }
            b[n >> 2] = 0;
            a: do if ((d | 0) >= 1) {
                if (g) {
                    k = 0;
                    l = 1;
                    m = 1;
                    h = 0;
                    g = a;
                    while(true){
                        if (!(h | k)) {
                            g = da(g, c, 4, n) | 0;
                            c = G() | 0;
                            if ((g | 0) == 0 & (c | 0) == 0) {
                                g = 2;
                                break a;
                            }
                            if (Eb(g, c) | 0) {
                                g = 1;
                                break a;
                            }
                        }
                        g = da(g, c, b[16 + (k << 2) >> 2] | 0, n) | 0;
                        c = G() | 0;
                        if ((g | 0) == 0 & (c | 0) == 0) {
                            g = 2;
                            break a;
                        }
                        a = e + (m << 3) | 0;
                        b[a >> 2] = g;
                        b[a + 4 >> 2] = c;
                        b[f + (m << 2) >> 2] = l;
                        h = h + 1 | 0;
                        a = (h | 0) == (l | 0);
                        i = k + 1 | 0;
                        j = (i | 0) == 6;
                        if (Eb(g, c) | 0) {
                            g = 1;
                            break a;
                        }
                        l = l + (j & a & 1) | 0;
                        if ((l | 0) > (d | 0)) {
                            g = 0;
                            break;
                        } else {
                            k = a ? j ? 0 : i : k;
                            m = m + 1 | 0;
                            h = a ? 0 : h;
                        }
                    }
                } else {
                    k = 0;
                    l = 1;
                    m = 1;
                    h = 0;
                    g = a;
                    while(true){
                        if (!(h | k)) {
                            g = da(g, c, 4, n) | 0;
                            c = G() | 0;
                            if ((g | 0) == 0 & (c | 0) == 0) {
                                g = 2;
                                break a;
                            }
                            if (Eb(g, c) | 0) {
                                g = 1;
                                break a;
                            }
                        }
                        g = da(g, c, b[16 + (k << 2) >> 2] | 0, n) | 0;
                        c = G() | 0;
                        if ((g | 0) == 0 & (c | 0) == 0) {
                            g = 2;
                            break a;
                        }
                        a = e + (m << 3) | 0;
                        b[a >> 2] = g;
                        b[a + 4 >> 2] = c;
                        h = h + 1 | 0;
                        a = (h | 0) == (l | 0);
                        i = k + 1 | 0;
                        j = (i | 0) == 6;
                        if (Eb(g, c) | 0) {
                            g = 1;
                            break a;
                        }
                        l = l + (j & a & 1) | 0;
                        if ((l | 0) > (d | 0)) {
                            g = 0;
                            break;
                        } else {
                            k = a ? j ? 0 : i : k;
                            m = m + 1 | 0;
                            h = a ? 0 : h;
                        }
                    }
                }
            } else g = 0;
            while (0);
            n = g;
            S = o;
            return n | 0;
        }
        function ca(a, c, d, e, f, g, h) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
            m = S;
            S = S + 16 | 0;
            l = m;
            if ((a | 0) == 0 & (c | 0) == 0) {
                S = m;
                return;
            }
            i = ad(a | 0, c | 0, g | 0, ((g | 0) < 0) << 31 >> 31 | 0) | 0;
            G();
            j = e + (i << 3) | 0;
            n = j;
            o = b[n >> 2] | 0;
            n = b[n + 4 >> 2] | 0;
            k = (o | 0) == (a | 0) & (n | 0) == (c | 0);
            if (!((o | 0) == 0 & (n | 0) == 0 | k)) do {
                i = (i + 1 | 0) % (g | 0) | 0;
                j = e + (i << 3) | 0;
                o = j;
                n = b[o >> 2] | 0;
                o = b[o + 4 >> 2] | 0;
                k = (n | 0) == (a | 0) & (o | 0) == (c | 0);
            }while (!((n | 0) == 0 & (o | 0) == 0 | k));
            i = f + (i << 2) | 0;
            if (k ? (b[i >> 2] | 0) <= (h | 0) : 0) {
                S = m;
                return;
            }
            o = j;
            b[o >> 2] = a;
            b[o + 4 >> 2] = c;
            b[i >> 2] = h;
            if ((h | 0) >= (d | 0)) {
                S = m;
                return;
            }
            o = h + 1 | 0;
            b[l >> 2] = 0;
            n = da(a, c, 2, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 3, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 1, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 5, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 4, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            b[l >> 2] = 0;
            n = da(a, c, 6, l) | 0;
            ca(n, G() | 0, d, e, f, g, o);
            S = m;
            return;
        }
        function da(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
            if ((b[e >> 2] | 0) > 0) {
                f = 0;
                do {
                    d = Pa(d) | 0;
                    f = f + 1 | 0;
                }while ((f | 0) < (b[e >> 2] | 0));
            }
            i = bd(a | 0, c | 0, 45) | 0;
            G();
            j = i & 127;
            g = Kb(a, c) | 0;
            f = bd(a | 0, c | 0, 52) | 0;
            G();
            f = f & 15;
            a: do {
                if (!f) h = 6;
                else while(true){
                    m = (15 - f | 0) * 3 | 0;
                    n = bd(a | 0, c | 0, m | 0) | 0;
                    G();
                    n = n & 7;
                    o = (Qb(f) | 0) == 0;
                    f = f + -1 | 0;
                    l = cd(7, 0, m | 0) | 0;
                    c = c & ~(G() | 0);
                    m = cd(b[(o ? 464 : 48) + (n * 28 | 0) + (d << 2) >> 2] | 0, 0, m | 0) | 0;
                    k = G() | 0;
                    d = b[(o ? 672 : 256) + (n * 28 | 0) + (d << 2) >> 2] | 0;
                    a = m | a & ~l;
                    c = k | c;
                    if (!d) {
                        d = 0;
                        break a;
                    }
                    if (!f) {
                        h = 6;
                        break;
                    }
                }
            }while (0);
            if ((h | 0) == 6) {
                o = b[880 + (j * 28 | 0) + (d << 2) >> 2] | 0;
                n = cd(o | 0, 0, 45) | 0;
                a = n | a;
                c = G() | 0 | c & -1040385;
                d = b[4304 + (j * 28 | 0) + (d << 2) >> 2] | 0;
                if ((o & 127 | 0) == 127) {
                    o = cd(b[880 + (j * 28 | 0) + 20 >> 2] | 0, 0, 45) | 0;
                    c = G() | 0 | c & -1040385;
                    d = b[4304 + (j * 28 | 0) + 20 >> 2] | 0;
                    a = Mb(o | a, c) | 0;
                    c = G() | 0;
                    b[e >> 2] = (b[e >> 2] | 0) + 1;
                }
            }
            h = bd(a | 0, c | 0, 45) | 0;
            G();
            h = h & 127;
            b: do {
                if (!(la(h) | 0)) {
                    if ((d | 0) > 0) {
                        f = 0;
                        do {
                            a = Mb(a, c) | 0;
                            c = G() | 0;
                            f = f + 1 | 0;
                        }while ((f | 0) != (d | 0));
                    }
                } else {
                    c: do if ((Kb(a, c) | 0) == 1) {
                        if ((j | 0) != (h | 0)) {
                            if (ra(h, b[7728 + (j * 28 | 0) >> 2] | 0) | 0) {
                                a = Ob(a, c) | 0;
                                g = 1;
                                c = G() | 0;
                                break;
                            } else {
                                a = Mb(a, c) | 0;
                                g = 1;
                                c = G() | 0;
                                break;
                            }
                        }
                        switch(g | 0){
                            case 5:
                                a = Ob(a, c) | 0;
                                c = G() | 0;
                                b[e >> 2] = (b[e >> 2] | 0) + 5;
                                g = 0;
                                break c;
                            case 3:
                                a = Mb(a, c) | 0;
                                c = G() | 0;
                                b[e >> 2] = (b[e >> 2] | 0) + 1;
                                g = 0;
                                break c;
                            default:
                                n = 0;
                                o = 0;
                                F(n | 0);
                                return o | 0;
                        }
                    } else g = 0;
                    while (0);
                    if ((d | 0) > 0) {
                        f = 0;
                        do {
                            a = Lb(a, c) | 0;
                            c = G() | 0;
                            f = f + 1 | 0;
                        }while ((f | 0) != (d | 0));
                    }
                    if ((j | 0) != (h | 0)) {
                        if (!(ma(h) | 0)) {
                            if ((g | 0) != 0 | (Kb(a, c) | 0) != 5) break;
                            b[e >> 2] = (b[e >> 2] | 0) + 1;
                            break;
                        }
                        switch(i & 127){
                            case 8:
                            case 118:
                                break b;
                            default:
                        }
                        if ((Kb(a, c) | 0) != 3) b[e >> 2] = (b[e >> 2] | 0) + 1;
                    }
                }
            }while (0);
            b[e >> 2] = ((b[e >> 2] | 0) + d | 0) % 6 | 0;
            n = c;
            o = a;
            F(n | 0);
            return o | 0;
        }
        function ea(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            m = S;
            S = S + 16 | 0;
            l = m;
            if (!d) {
                l = e;
                b[l >> 2] = a;
                b[l + 4 >> 2] = c;
                l = 0;
                S = m;
                return l | 0;
            }
            b[l >> 2] = 0;
            a: do if (!(Eb(a, c) | 0)) {
                g = (d | 0) > 0;
                if (g) {
                    f = 0;
                    k = a;
                    do {
                        k = da(k, c, 4, l) | 0;
                        c = G() | 0;
                        if ((k | 0) == 0 & (c | 0) == 0) {
                            a = 2;
                            break a;
                        }
                        f = f + 1 | 0;
                        if (Eb(k, c) | 0) {
                            a = 1;
                            break a;
                        }
                    }while ((f | 0) < (d | 0));
                    j = e;
                    b[j >> 2] = k;
                    b[j + 4 >> 2] = c;
                    j = d + -1 | 0;
                    if (g) {
                        g = 0;
                        h = 1;
                        f = k;
                        a = c;
                        do {
                            f = da(f, a, 2, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (h << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            h = h + 1 | 0;
                            if (Eb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            g = g + 1 | 0;
                        }while ((g | 0) < (d | 0));
                        i = 0;
                        g = h;
                        do {
                            f = da(f, a, 3, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            h = e + (g << 3) | 0;
                            b[h >> 2] = f;
                            b[h + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Eb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            i = i + 1 | 0;
                        }while ((i | 0) < (d | 0));
                        h = 0;
                        do {
                            f = da(f, a, 1, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (g << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Eb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            h = h + 1 | 0;
                        }while ((h | 0) < (d | 0));
                        h = 0;
                        do {
                            f = da(f, a, 5, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (g << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Eb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            h = h + 1 | 0;
                        }while ((h | 0) < (d | 0));
                        h = 0;
                        do {
                            f = da(f, a, 4, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            i = e + (g << 3) | 0;
                            b[i >> 2] = f;
                            b[i + 4 >> 2] = a;
                            g = g + 1 | 0;
                            if (Eb(f, a) | 0) {
                                a = 1;
                                break a;
                            }
                            h = h + 1 | 0;
                        }while ((h | 0) < (d | 0));
                        h = 0;
                        while(true){
                            f = da(f, a, 6, l) | 0;
                            a = G() | 0;
                            if ((f | 0) == 0 & (a | 0) == 0) {
                                a = 2;
                                break a;
                            }
                            if ((h | 0) != (j | 0)) {
                                i = e + (g << 3) | 0;
                                b[i >> 2] = f;
                                b[i + 4 >> 2] = a;
                                if (!(Eb(f, a) | 0)) g = g + 1 | 0;
                                else {
                                    a = 1;
                                    break a;
                                }
                            }
                            h = h + 1 | 0;
                            if ((h | 0) >= (d | 0)) {
                                h = k;
                                g = c;
                                break;
                            }
                        }
                    } else {
                        h = k;
                        f = k;
                        g = c;
                        a = c;
                    }
                } else {
                    h = e;
                    b[h >> 2] = a;
                    b[h + 4 >> 2] = c;
                    h = a;
                    f = a;
                    g = c;
                    a = c;
                }
                a = ((h | 0) != (f | 0) | (g | 0) != (a | 0)) & 1;
            } else a = 1;
            while (0);
            l = a;
            S = m;
            return l | 0;
        }
        function fa(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            g = S;
            S = S + 48 | 0;
            f = g + 8 | 0;
            e = g;
            i = a;
            h = b[i + 4 >> 2] | 0;
            d = e;
            b[d >> 2] = b[i >> 2];
            b[d + 4 >> 2] = h;
            uc(e, f);
            f = ya(f, c) | 0;
            c = b[e >> 2] | 0;
            e = b[a + 8 >> 2] | 0;
            if ((e | 0) <= 0) {
                i = c;
                h = (f | 0) < (i | 0);
                i = h ? i : f;
                i = i + 12 | 0;
                S = g;
                return i | 0;
            }
            d = b[a + 12 >> 2] | 0;
            a = 0;
            do {
                c = (b[d + (a << 3) >> 2] | 0) + c | 0;
                a = a + 1 | 0;
            }while ((a | 0) < (e | 0));
            i = (f | 0) < (c | 0);
            i = i ? c : f;
            i = i + 12 | 0;
            S = g;
            return i | 0;
        }
        function ga(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = S;
            S = S + 48 | 0;
            e = i + 8 | 0;
            f = i;
            if (!(ha(a, c, d) | 0)) {
                S = i;
                return;
            }
            j = a;
            g = b[j + 4 >> 2] | 0;
            h = f;
            b[h >> 2] = b[j >> 2];
            b[h + 4 >> 2] = g;
            uc(f, e);
            h = ya(e, c) | 0;
            c = b[f >> 2] | 0;
            g = b[a + 8 >> 2] | 0;
            if ((g | 0) > 0) {
                f = b[a + 12 >> 2] | 0;
                e = 0;
                do {
                    c = (b[f + (e << 3) >> 2] | 0) + c | 0;
                    e = e + 1 | 0;
                }while ((e | 0) != (g | 0));
            }
            c = (h | 0) < (c | 0) ? c : h;
            if ((c | 0) <= -12) {
                S = i;
                return;
            }
            j = c + 11 | 0;
            gd(d | 0, 0, (((j | 0) > 0 ? j : 0) << 3) + 8 | 0);
            S = i;
            return;
        }
        function ha(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, I = 0, J = 0;
            J = S;
            S = S + 112 | 0;
            D = J + 80 | 0;
            j = J + 72 | 0;
            E = J;
            F = J + 56 | 0;
            k = a + 8 | 0;
            I = Vc((b[k >> 2] << 5) + 32 | 0) | 0;
            if (!I) H(22848, 22448, 800, 22456);
            vc(a, I);
            g = a;
            e = b[g + 4 >> 2] | 0;
            i = j;
            b[i >> 2] = b[g >> 2];
            b[i + 4 >> 2] = e;
            uc(j, D);
            i = ya(D, c) | 0;
            e = b[j >> 2] | 0;
            g = b[k >> 2] | 0;
            if ((g | 0) > 0) {
                h = b[a + 12 >> 2] | 0;
                f = 0;
                do {
                    e = (b[h + (f << 3) >> 2] | 0) + e | 0;
                    f = f + 1 | 0;
                }while ((f | 0) != (g | 0));
            }
            i = (i | 0) < (e | 0) ? e : i;
            C = i + 12 | 0;
            f = Xc(C, 8) | 0;
            l = Xc(C, 8) | 0;
            b[D >> 2] = 0;
            A = a;
            B = b[A + 4 >> 2] | 0;
            e = j;
            b[e >> 2] = b[A >> 2];
            b[e + 4 >> 2] = B;
            e = ia(j, C, c, D, f, l) | 0;
            if (e | 0) {
                Wc(f);
                Wc(l);
                Wc(I);
                I = e;
                S = J;
                return I | 0;
            }
            a: do if ((b[k >> 2] | 0) > 0) {
                g = a + 12 | 0;
                e = 0;
                while(true){
                    h = ia((b[g >> 2] | 0) + (e << 3) | 0, C, c, D, f, l) | 0;
                    e = e + 1 | 0;
                    if (h | 0) break;
                    if ((e | 0) >= (b[k >> 2] | 0)) break a;
                }
                Wc(f);
                Wc(l);
                Wc(I);
                I = h;
                S = J;
                return I | 0;
            }
            while (0);
            if ((i | 0) > -12) gd(l | 0, 0, ((C | 0) > 1 ? C : 1) << 3 | 0);
            b: do if ((b[D >> 2] | 0) > 0) {
                B = ((C | 0) < 0) << 31 >> 31;
                v = f;
                w = l;
                x = f;
                y = f;
                z = l;
                A = f;
                e = f;
                r = f;
                s = l;
                t = l;
                u = l;
                f = l;
                c: while(true){
                    q = b[D >> 2] | 0;
                    o = 0;
                    p = 0;
                    g = 0;
                    while(true){
                        h = E;
                        i = h + 56 | 0;
                        do {
                            b[h >> 2] = 0;
                            h = h + 4 | 0;
                        }while ((h | 0) < (i | 0));
                        c = v + (o << 3) | 0;
                        j = b[c >> 2] | 0;
                        c = b[c + 4 >> 2] | 0;
                        if (ba(j, c, 1, E, 0) | 0) {
                            h = E;
                            i = h + 56 | 0;
                            do {
                                b[h >> 2] = 0;
                                h = h + 4 | 0;
                            }while ((h | 0) < (i | 0));
                            h = Xc(7, 4) | 0;
                            if (h | 0) {
                                ca(j, c, 1, E, h, 7, 0);
                                Wc(h);
                            }
                        }
                        n = 0;
                        do {
                            m = E + (n << 3) | 0;
                            l = b[m >> 2] | 0;
                            m = b[m + 4 >> 2] | 0;
                            d: do if (!((l | 0) == 0 & (m | 0) == 0)) {
                                j = ad(l | 0, m | 0, C | 0, B | 0) | 0;
                                G();
                                h = d + (j << 3) | 0;
                                i = h;
                                c = b[i >> 2] | 0;
                                i = b[i + 4 >> 2] | 0;
                                if (!((c | 0) == 0 & (i | 0) == 0)) {
                                    k = 0;
                                    while(true){
                                        if ((k | 0) > (C | 0)) break c;
                                        if ((c | 0) == (l | 0) & (i | 0) == (m | 0)) break d;
                                        j = (j + 1 | 0) % (C | 0) | 0;
                                        h = d + (j << 3) | 0;
                                        i = h;
                                        c = b[i >> 2] | 0;
                                        i = b[i + 4 >> 2] | 0;
                                        if ((c | 0) == 0 & (i | 0) == 0) break;
                                        else k = k + 1 | 0;
                                    }
                                }
                                if (!((l | 0) == 0 & (m | 0) == 0)) {
                                    Ub(l, m, F);
                                    if (wc(a, I, F) | 0) {
                                        k = h;
                                        b[k >> 2] = l;
                                        b[k + 4 >> 2] = m;
                                        k = w + (g << 3) | 0;
                                        b[k >> 2] = l;
                                        b[k + 4 >> 2] = m;
                                        g = g + 1 | 0;
                                    }
                                }
                            }
                            while (0);
                            n = n + 1 | 0;
                        }while (n >>> 0 < 7);
                        p = p + 1 | 0;
                        if ((p | 0) >= (q | 0)) break;
                        else o = o + 1 | 0;
                    }
                    if ((q | 0) > 0) gd(x | 0, 0, q << 3 | 0);
                    b[D >> 2] = g;
                    if ((g | 0) > 0) {
                        l = f;
                        m = u;
                        n = A;
                        o = t;
                        p = s;
                        q = w;
                        f = r;
                        u = e;
                        t = y;
                        s = x;
                        r = l;
                        e = m;
                        A = z;
                        z = n;
                        y = o;
                        x = p;
                        w = v;
                        v = q;
                    } else break b;
                }
                Wc(y);
                Wc(z);
                Wc(I);
                I = -1;
                S = J;
                return I | 0;
            } else e = l;
            while (0);
            Wc(I);
            Wc(f);
            Wc(e);
            I = 0;
            S = J;
            return I | 0;
        }
        function ia(a, c, d, f, g, h) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0.0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0.0, E = 0.0;
            C = S;
            S = S + 48 | 0;
            y = C + 32 | 0;
            z = C + 16 | 0;
            A = C;
            i = b[a >> 2] | 0;
            if ((i | 0) <= 0) {
                B = 0;
                S = C;
                return B | 0;
            }
            t = a + 4 | 0;
            u = y + 8 | 0;
            v = z + 8 | 0;
            w = A + 8 | 0;
            x = ((c | 0) < 0) << 31 >> 31;
            s = 0;
            a: while(true){
                j = b[t >> 2] | 0;
                q = j + (s << 4) | 0;
                b[y >> 2] = b[q >> 2];
                b[y + 4 >> 2] = b[q + 4 >> 2];
                b[y + 8 >> 2] = b[q + 8 >> 2];
                b[y + 12 >> 2] = b[q + 12 >> 2];
                if ((s | 0) == (i + -1 | 0)) {
                    b[z >> 2] = b[j >> 2];
                    b[z + 4 >> 2] = b[j + 4 >> 2];
                    b[z + 8 >> 2] = b[j + 8 >> 2];
                    b[z + 12 >> 2] = b[j + 12 >> 2];
                } else {
                    q = j + (s + 1 << 4) | 0;
                    b[z >> 2] = b[q >> 2];
                    b[z + 4 >> 2] = b[q + 4 >> 2];
                    b[z + 8 >> 2] = b[q + 8 >> 2];
                    b[z + 12 >> 2] = b[q + 12 >> 2];
                }
                q = za(y, z, d) | 0;
                b: do if ((q | 0) > 0) {
                    r = +(q | 0);
                    p = 0;
                    c: while(true){
                        E = +(q - p | 0);
                        D = +(p | 0);
                        e[A >> 3] = +e[y >> 3] * E / r + +e[z >> 3] * D / r;
                        e[w >> 3] = +e[u >> 3] * E / r + +e[v >> 3] * D / r;
                        n = Rb(A, d) | 0;
                        o = G() | 0;
                        j = ad(n | 0, o | 0, c | 0, x | 0) | 0;
                        G();
                        i = h + (j << 3) | 0;
                        k = i;
                        l = b[k >> 2] | 0;
                        k = b[k + 4 >> 2] | 0;
                        d: do if ((l | 0) == 0 & (k | 0) == 0) B = 14;
                        else {
                            m = 0;
                            while(true){
                                if ((m | 0) > (c | 0)) {
                                    i = 1;
                                    break d;
                                }
                                if ((l | 0) == (n | 0) & (k | 0) == (o | 0)) {
                                    i = 7;
                                    break d;
                                }
                                j = (j + 1 | 0) % (c | 0) | 0;
                                i = h + (j << 3) | 0;
                                k = i;
                                l = b[k >> 2] | 0;
                                k = b[k + 4 >> 2] | 0;
                                if ((l | 0) == 0 & (k | 0) == 0) {
                                    B = 14;
                                    break;
                                } else m = m + 1 | 0;
                            }
                        }
                        while (0);
                        if ((B | 0) == 14) {
                            B = 0;
                            if ((n | 0) == 0 & (o | 0) == 0) i = 7;
                            else {
                                b[i >> 2] = n;
                                b[i + 4 >> 2] = o;
                                i = b[f >> 2] | 0;
                                m = g + (i << 3) | 0;
                                b[m >> 2] = n;
                                b[m + 4 >> 2] = o;
                                b[f >> 2] = i + 1;
                                i = 0;
                            }
                        }
                        switch(i & 7){
                            case 7:
                            case 0:
                                break;
                            default:
                                break c;
                        }
                        p = p + 1 | 0;
                        if ((q | 0) <= (p | 0)) {
                            B = 8;
                            break b;
                        }
                    }
                    if (i | 0) {
                        i = -1;
                        B = 20;
                        break a;
                    }
                } else B = 8;
                while (0);
                if ((B | 0) == 8) B = 0;
                s = s + 1 | 0;
                i = b[a >> 2] | 0;
                if ((s | 0) >= (i | 0)) {
                    i = 0;
                    B = 20;
                    break;
                }
            }
            if ((B | 0) == 20) {
                S = C;
                return i | 0;
            }
            return 0;
        }
        function ja(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            k = S;
            S = S + 176 | 0;
            j = k;
            if ((c | 0) < 1) {
                Lc(d, 0, 0);
                S = k;
                return;
            }
            h = a;
            h = bd(b[h >> 2] | 0, b[h + 4 >> 2] | 0, 52) | 0;
            G();
            Lc(d, (c | 0) > 6 ? c : 6, h & 15);
            h = 0;
            do {
                e = a + (h << 3) | 0;
                Vb(b[e >> 2] | 0, b[e + 4 >> 2] | 0, j);
                e = b[j >> 2] | 0;
                if ((e | 0) > 0) {
                    i = 0;
                    do {
                        g = j + 8 + (i << 4) | 0;
                        i = i + 1 | 0;
                        e = j + 8 + (((i | 0) % (e | 0) | 0) << 4) | 0;
                        f = Qc(d, e, g) | 0;
                        if (!f) Pc(d, g, e);
                        else Oc(d, f);
                        e = b[j >> 2] | 0;
                    }while ((i | 0) < (e | 0));
                }
                h = h + 1 | 0;
            }while ((h | 0) != (c | 0));
            S = k;
            return;
        }
        function ka(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 32 | 0;
            e = g;
            f = g + 16 | 0;
            ja(a, c, f);
            b[d >> 2] = 0;
            b[d + 4 >> 2] = 0;
            b[d + 8 >> 2] = 0;
            a = Nc(f) | 0;
            if (!a) {
                jc(d);
                Mc(f);
                S = g;
                return;
            }
            do {
                c = gc(d) | 0;
                do {
                    hc(c, a);
                    h = a + 16 | 0;
                    b[e >> 2] = b[h >> 2];
                    b[e + 4 >> 2] = b[h + 4 >> 2];
                    b[e + 8 >> 2] = b[h + 8 >> 2];
                    b[e + 12 >> 2] = b[h + 12 >> 2];
                    Oc(f, a);
                    a = Rc(f, e) | 0;
                }while ((a | 0) != 0);
                a = Nc(f) | 0;
            }while ((a | 0) != 0);
            jc(d);
            Mc(f);
            S = g;
            return;
        }
        function la(a) {
            a = a | 0;
            return b[7728 + (a * 28 | 0) + 16 >> 2] | 0;
        }
        function ma(a) {
            a = a | 0;
            return (a | 0) == 4 | (a | 0) == 117 | 0;
        }
        function na(a) {
            a = a | 0;
            return b[11152 + ((b[a >> 2] | 0) * 216 | 0) + ((b[a + 4 >> 2] | 0) * 72 | 0) + ((b[a + 8 >> 2] | 0) * 24 | 0) + (b[a + 12 >> 2] << 3) >> 2] | 0;
        }
        function oa(a) {
            a = a | 0;
            return b[11152 + ((b[a >> 2] | 0) * 216 | 0) + ((b[a + 4 >> 2] | 0) * 72 | 0) + ((b[a + 8 >> 2] | 0) * 24 | 0) + (b[a + 12 >> 2] << 3) + 4 >> 2] | 0;
        }
        function pa(a, c) {
            a = a | 0;
            c = c | 0;
            a = 7728 + (a * 28 | 0) | 0;
            b[c >> 2] = b[a >> 2];
            b[c + 4 >> 2] = b[a + 4 >> 2];
            b[c + 8 >> 2] = b[a + 8 >> 2];
            b[c + 12 >> 2] = b[a + 12 >> 2];
            return;
        }
        function qa(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            if (c >>> 0 > 20) {
                c = -1;
                return c | 0;
            }
            do if ((b[11152 + (c * 216 | 0) >> 2] | 0) != (a | 0)) {
                if ((b[11152 + (c * 216 | 0) + 8 >> 2] | 0) != (a | 0)) {
                    if ((b[11152 + (c * 216 | 0) + 16 >> 2] | 0) != (a | 0)) {
                        if ((b[11152 + (c * 216 | 0) + 24 >> 2] | 0) != (a | 0)) {
                            if ((b[11152 + (c * 216 | 0) + 32 >> 2] | 0) != (a | 0)) {
                                if ((b[11152 + (c * 216 | 0) + 40 >> 2] | 0) != (a | 0)) {
                                    if ((b[11152 + (c * 216 | 0) + 48 >> 2] | 0) != (a | 0)) {
                                        if ((b[11152 + (c * 216 | 0) + 56 >> 2] | 0) != (a | 0)) {
                                            if ((b[11152 + (c * 216 | 0) + 64 >> 2] | 0) != (a | 0)) {
                                                if ((b[11152 + (c * 216 | 0) + 72 >> 2] | 0) != (a | 0)) {
                                                    if ((b[11152 + (c * 216 | 0) + 80 >> 2] | 0) != (a | 0)) {
                                                        if ((b[11152 + (c * 216 | 0) + 88 >> 2] | 0) != (a | 0)) {
                                                            if ((b[11152 + (c * 216 | 0) + 96 >> 2] | 0) != (a | 0)) {
                                                                if ((b[11152 + (c * 216 | 0) + 104 >> 2] | 0) != (a | 0)) {
                                                                    if ((b[11152 + (c * 216 | 0) + 112 >> 2] | 0) != (a | 0)) {
                                                                        if ((b[11152 + (c * 216 | 0) + 120 >> 2] | 0) != (a | 0)) {
                                                                            if ((b[11152 + (c * 216 | 0) + 128 >> 2] | 0) != (a | 0)) {
                                                                                if ((b[11152 + (c * 216 | 0) + 136 >> 2] | 0) == (a | 0)) {
                                                                                    a = 2;
                                                                                    d = 1;
                                                                                    e = 2;
                                                                                } else {
                                                                                    if ((b[11152 + (c * 216 | 0) + 144 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 152 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 160 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 168 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 176 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 184 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 192 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 200 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11152 + (c * 216 | 0) + 208 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    } else a = -1;
                                                                                    return a | 0;
                                                                                }
                                                                            } else {
                                                                                a = 2;
                                                                                d = 1;
                                                                                e = 1;
                                                                            }
                                                                        } else {
                                                                            a = 2;
                                                                            d = 1;
                                                                            e = 0;
                                                                        }
                                                                    } else {
                                                                        a = 1;
                                                                        d = 1;
                                                                        e = 2;
                                                                    }
                                                                } else {
                                                                    a = 1;
                                                                    d = 1;
                                                                    e = 1;
                                                                }
                                                            } else {
                                                                a = 1;
                                                                d = 1;
                                                                e = 0;
                                                            }
                                                        } else {
                                                            a = 0;
                                                            d = 1;
                                                            e = 2;
                                                        }
                                                    } else {
                                                        a = 0;
                                                        d = 1;
                                                        e = 1;
                                                    }
                                                } else {
                                                    a = 0;
                                                    d = 1;
                                                    e = 0;
                                                }
                                            } else {
                                                a = 2;
                                                d = 0;
                                                e = 2;
                                            }
                                        } else {
                                            a = 2;
                                            d = 0;
                                            e = 1;
                                        }
                                    } else {
                                        a = 2;
                                        d = 0;
                                        e = 0;
                                    }
                                } else {
                                    a = 1;
                                    d = 0;
                                    e = 2;
                                }
                            } else {
                                a = 1;
                                d = 0;
                                e = 1;
                            }
                        } else {
                            a = 1;
                            d = 0;
                            e = 0;
                        }
                    } else {
                        a = 0;
                        d = 0;
                        e = 2;
                    }
                } else {
                    a = 0;
                    d = 0;
                    e = 1;
                }
            } else {
                a = 0;
                d = 0;
                e = 0;
            }
            while (0);
            c = b[11152 + (c * 216 | 0) + (d * 72 | 0) + (a * 24 | 0) + (e << 3) + 4 >> 2] | 0;
            return c | 0;
        }
        function ra(a, c) {
            a = a | 0;
            c = c | 0;
            if ((b[7728 + (a * 28 | 0) + 20 >> 2] | 0) == (c | 0)) {
                c = 1;
                return c | 0;
            }
            c = (b[7728 + (a * 28 | 0) + 24 >> 2] | 0) == (c | 0);
            return c | 0;
        }
        function sa(a, c) {
            a = a | 0;
            c = c | 0;
            return b[880 + (a * 28 | 0) + (c << 2) >> 2] | 0;
        }
        function ta(a, c) {
            a = a | 0;
            c = c | 0;
            if ((b[880 + (a * 28 | 0) >> 2] | 0) == (c | 0)) {
                c = 0;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 4 >> 2] | 0) == (c | 0)) {
                c = 1;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 8 >> 2] | 0) == (c | 0)) {
                c = 2;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 12 >> 2] | 0) == (c | 0)) {
                c = 3;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 16 >> 2] | 0) == (c | 0)) {
                c = 4;
                return c | 0;
            }
            if ((b[880 + (a * 28 | 0) + 20 >> 2] | 0) == (c | 0)) {
                c = 5;
                return c | 0;
            } else return ((b[880 + (a * 28 | 0) + 24 >> 2] | 0) == (c | 0) ? 6 : 7) | 0;
            return 0;
        }
        function ua() {
            return 122;
        }
        function va(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            c = 0;
            do {
                cd(c | 0, 0, 45);
                e = G() | 134225919;
                d = a + (c << 3) | 0;
                b[d >> 2] = -1;
                b[d + 4 >> 2] = e;
                c = c + 1 | 0;
            }while ((c | 0) != 122);
            return;
        }
        function wa(a) {
            a = a | 0;
            return +e[a + 16 >> 3] < +e[a + 24 >> 3] | 0;
        }
        function xa(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            c = +e[b >> 3];
            if (!(c >= +e[a + 8 >> 3])) {
                b = 0;
                return b | 0;
            }
            if (!(c <= +e[a >> 3])) {
                b = 0;
                return b | 0;
            }
            d = +e[a + 16 >> 3];
            c = +e[a + 24 >> 3];
            f = +e[b + 8 >> 3];
            b = f >= c;
            a = f <= d & 1;
            if (d < c) {
                if (b) a = 1;
            } else if (!b) a = 0;
            b = (a | 0) != 0;
            return b | 0;
        }
        function ya(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0.0, l = 0.0;
            i = S;
            S = S + 288 | 0;
            d = i + 264 | 0;
            f = i + 96 | 0;
            g = i;
            h = g;
            j = h + 96 | 0;
            do {
                b[h >> 2] = 0;
                h = h + 4 | 0;
            }while ((h | 0) < (j | 0));
            Zb(c, g);
            h = g;
            j = b[h >> 2] | 0;
            h = b[h + 4 >> 2] | 0;
            Ub(j, h, d);
            Vb(j, h, f);
            k = +jb(d, f + 8 | 0);
            e[d >> 3] = +e[a >> 3];
            h = d + 8 | 0;
            e[h >> 3] = +e[a + 16 >> 3];
            e[f >> 3] = +e[a + 8 >> 3];
            j = f + 8 | 0;
            e[j >> 3] = +e[a + 24 >> 3];
            l = +jb(d, f);
            j = ~~+A(+(l * l / +dd(+ +q(+((+e[h >> 3] - +e[j >> 3]) / (+e[d >> 3] - +e[f >> 3]))), 3.0) / (k * (k * 2.59807621135) * .8)));
            S = i;
            return ((j | 0) == 0 ? 1 : j) | 0;
        }
        function za(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0.0;
            i = S;
            S = S + 288 | 0;
            e = i + 264 | 0;
            f = i + 96 | 0;
            g = i;
            h = g;
            j = h + 96 | 0;
            do {
                b[h >> 2] = 0;
                h = h + 4 | 0;
            }while ((h | 0) < (j | 0));
            Zb(d, g);
            j = g;
            h = b[j >> 2] | 0;
            j = b[j + 4 >> 2] | 0;
            Ub(h, j, e);
            Vb(h, j, f);
            k = +jb(e, f + 8 | 0);
            j = ~~+A(+(+jb(a, c) / (k * 2.0)));
            S = i;
            return ((j | 0) == 0 ? 1 : j) | 0;
        }
        function Aa(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            b[a >> 2] = c;
            b[a + 4 >> 2] = d;
            b[a + 8 >> 2] = e;
            return;
        }
        function Ba(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0, n = 0, o = 0.0;
            n = c + 8 | 0;
            b[n >> 2] = 0;
            k = +e[a >> 3];
            i = +q(+k);
            l = +e[a + 8 >> 3];
            j = +q(+l) / .8660254037844386;
            i = i + j * .5;
            d = ~~i;
            a = ~~j;
            i = i - +(d | 0);
            j = j - +(a | 0);
            do if (i < .5) {
                if (i < .3333333333333333) {
                    b[c >> 2] = d;
                    if (j < (i + 1.0) * .5) {
                        b[c + 4 >> 2] = a;
                        break;
                    } else {
                        a = a + 1 | 0;
                        b[c + 4 >> 2] = a;
                        break;
                    }
                } else {
                    o = 1.0 - i;
                    a = (!(j < o) & 1) + a | 0;
                    b[c + 4 >> 2] = a;
                    if (o <= j & j < i * 2.0) {
                        d = d + 1 | 0;
                        b[c >> 2] = d;
                        break;
                    } else {
                        b[c >> 2] = d;
                        break;
                    }
                }
            } else {
                if (!(i < .6666666666666666)) {
                    d = d + 1 | 0;
                    b[c >> 2] = d;
                    if (j < i * .5) {
                        b[c + 4 >> 2] = a;
                        break;
                    } else {
                        a = a + 1 | 0;
                        b[c + 4 >> 2] = a;
                        break;
                    }
                }
                if (j < 1.0 - i) {
                    b[c + 4 >> 2] = a;
                    if (i * 2.0 + -1 < j) {
                        b[c >> 2] = d;
                        break;
                    }
                } else {
                    a = a + 1 | 0;
                    b[c + 4 >> 2] = a;
                }
                d = d + 1 | 0;
                b[c >> 2] = d;
            }
            while (0);
            do if (k < 0.0) {
                if (!(a & 1)) {
                    m = (a | 0) / 2 | 0;
                    m = Zc(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, m | 0, ((m | 0) < 0) << 31 >> 31 | 0) | 0;
                    d = ~~(+(d | 0) - (+(m >>> 0) + 4294967296.0 * +(G() | 0)) * 2.0);
                    b[c >> 2] = d;
                    break;
                } else {
                    m = (a + 1 | 0) / 2 | 0;
                    m = Zc(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, m | 0, ((m | 0) < 0) << 31 >> 31 | 0) | 0;
                    d = ~~(+(d | 0) - ((+(m >>> 0) + 4294967296.0 * +(G() | 0)) * 2.0 + 1.0));
                    b[c >> 2] = d;
                    break;
                }
            }
            while (0);
            m = c + 4 | 0;
            if (l < 0.0) {
                d = d - ((a << 1 | 1) / 2 | 0) | 0;
                b[c >> 2] = d;
                a = 0 - a | 0;
                b[m >> 2] = a;
            }
            f = a - d | 0;
            if ((d | 0) < 0) {
                g = 0 - d | 0;
                b[m >> 2] = f;
                b[n >> 2] = g;
                b[c >> 2] = 0;
                a = f;
                d = 0;
            } else g = 0;
            if ((a | 0) < 0) {
                d = d - a | 0;
                b[c >> 2] = d;
                g = g - a | 0;
                b[n >> 2] = g;
                b[m >> 2] = 0;
                a = 0;
            }
            h = d - g | 0;
            f = a - g | 0;
            if ((g | 0) < 0) {
                b[c >> 2] = h;
                b[m >> 2] = f;
                b[n >> 2] = 0;
                a = f;
                d = h;
                g = 0;
            }
            f = (a | 0) < (d | 0) ? a : d;
            f = (g | 0) < (f | 0) ? g : f;
            if ((f | 0) <= 0) return;
            b[c >> 2] = d - f;
            b[m >> 2] = a - f;
            b[n >> 2] = g - f;
            return;
        }
        function Ca(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            if ((c | 0) < 0) {
                d = d - c | 0;
                b[h >> 2] = d;
                g = a + 8 | 0;
                b[g >> 2] = (b[g >> 2] | 0) - c;
                b[a >> 2] = 0;
                c = 0;
            }
            if ((d | 0) < 0) {
                c = c - d | 0;
                b[a >> 2] = c;
                g = a + 8 | 0;
                f = (b[g >> 2] | 0) - d | 0;
                b[g >> 2] = f;
                b[h >> 2] = 0;
                d = 0;
            } else {
                f = a + 8 | 0;
                g = f;
                f = b[f >> 2] | 0;
            }
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[a >> 2] = c;
                d = d - f | 0;
                b[h >> 2] = d;
                b[g >> 2] = 0;
                f = 0;
            }
            e = (d | 0) < (c | 0) ? d : c;
            e = (f | 0) < (e | 0) ? f : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = c - e;
            b[h >> 2] = d - e;
            b[g >> 2] = f - e;
            return;
        }
        function Da(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0;
            f = b[a + 8 >> 2] | 0;
            d = +((b[a + 4 >> 2] | 0) - f | 0);
            e[c >> 3] = +((b[a >> 2] | 0) - f | 0) - d * .5;
            e[c + 8 >> 3] = d * .8660254037844386;
            return;
        }
        function Ea(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            b[d >> 2] = (b[c >> 2] | 0) + (b[a >> 2] | 0);
            b[d + 4 >> 2] = (b[c + 4 >> 2] | 0) + (b[a + 4 >> 2] | 0);
            b[d + 8 >> 2] = (b[c + 8 >> 2] | 0) + (b[a + 8 >> 2] | 0);
            return;
        }
        function Fa(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            b[d >> 2] = (b[a >> 2] | 0) - (b[c >> 2] | 0);
            b[d + 4 >> 2] = (b[a + 4 >> 2] | 0) - (b[c + 4 >> 2] | 0);
            b[d + 8 >> 2] = (b[a + 8 >> 2] | 0) - (b[c + 8 >> 2] | 0);
            return;
        }
        function Ga(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = B(b[a >> 2] | 0, c) | 0;
            b[a >> 2] = d;
            d = a + 4 | 0;
            e = B(b[d >> 2] | 0, c) | 0;
            b[d >> 2] = e;
            a = a + 8 | 0;
            c = B(b[a >> 2] | 0, c) | 0;
            b[a >> 2] = c;
            return;
        }
        function Ha(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = b[a >> 2] | 0;
            i = (h | 0) < 0;
            e = (b[a + 4 >> 2] | 0) - (i ? h : 0) | 0;
            g = (e | 0) < 0;
            f = (g ? 0 - e | 0 : 0) + ((b[a + 8 >> 2] | 0) - (i ? h : 0)) | 0;
            d = (f | 0) < 0;
            a = d ? 0 : f;
            c = (g ? 0 : e) - (d ? f : 0) | 0;
            f = (i ? 0 : h) - (g ? e : 0) - (d ? f : 0) | 0;
            d = (c | 0) < (f | 0) ? c : f;
            d = (a | 0) < (d | 0) ? a : d;
            e = (d | 0) > 0;
            a = a - (e ? d : 0) | 0;
            c = c - (e ? d : 0) | 0;
            a: do switch(f - (e ? d : 0) | 0){
                case 0:
                    switch(c | 0){
                        case 0:
                            i = (a | 0) == 0 ? 0 : (a | 0) == 1 ? 1 : 7;
                            return i | 0;
                        case 1:
                            i = (a | 0) == 0 ? 2 : (a | 0) == 1 ? 3 : 7;
                            return i | 0;
                        default:
                            break a;
                    }
                case 1:
                    switch(c | 0){
                        case 0:
                            i = (a | 0) == 0 ? 4 : (a | 0) == 1 ? 5 : 7;
                            return i | 0;
                        case 1:
                            if (!a) a = 6;
                            else break a;
                            return a | 0;
                        default:
                            break a;
                    }
                default:
            }
            while (0);
            i = 7;
            return i | 0;
        }
        function Ia(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = a + 8 | 0;
            d = b[h >> 2] | 0;
            c = (b[a >> 2] | 0) - d | 0;
            i = a + 4 | 0;
            d = (b[i >> 2] | 0) - d | 0;
            e = Uc(+((c * 3 | 0) - d | 0) / 7.0) | 0;
            b[a >> 2] = e;
            c = Uc(+((d << 1) + c | 0) / 7.0) | 0;
            b[i >> 2] = c;
            b[h >> 2] = 0;
            d = c - e | 0;
            if ((e | 0) < 0) {
                g = 0 - e | 0;
                b[i >> 2] = d;
                b[h >> 2] = g;
                b[a >> 2] = 0;
                c = d;
                e = 0;
                d = g;
            } else d = 0;
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = f - e;
            b[i >> 2] = c - e;
            b[h >> 2] = d - e;
            return;
        }
        function Ja(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = a + 8 | 0;
            d = b[h >> 2] | 0;
            c = (b[a >> 2] | 0) - d | 0;
            i = a + 4 | 0;
            d = (b[i >> 2] | 0) - d | 0;
            e = Uc(+((c << 1) + d | 0) / 7.0) | 0;
            b[a >> 2] = e;
            c = Uc(+((d * 3 | 0) - c | 0) / 7.0) | 0;
            b[i >> 2] = c;
            b[h >> 2] = 0;
            d = c - e | 0;
            if ((e | 0) < 0) {
                g = 0 - e | 0;
                b[i >> 2] = d;
                b[h >> 2] = g;
                b[a >> 2] = 0;
                c = d;
                e = 0;
                d = g;
            } else d = 0;
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = f - e;
            b[i >> 2] = c - e;
            b[h >> 2] = d - e;
            return;
        }
        function Ka(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            i = a + 8 | 0;
            e = b[i >> 2] | 0;
            f = d + (c * 3 | 0) | 0;
            b[a >> 2] = f;
            d = e + (d * 3 | 0) | 0;
            b[h >> 2] = d;
            c = (e * 3 | 0) + c | 0;
            b[i >> 2] = c;
            e = d - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = e;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                d = e;
                e = 0;
            } else e = f;
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function La(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = (c * 3 | 0) + f | 0;
            f = d + (f * 3 | 0) | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = (d * 3 | 0) + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                f = 0;
            } else d = e;
            if ((d | 0) < 0) {
                f = f - d | 0;
                b[a >> 2] = f;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = f - c | 0;
            e = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = e;
                b[i >> 2] = 0;
                f = g;
                c = 0;
            } else e = d;
            d = (e | 0) < (f | 0) ? e : f;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = f - d;
            b[h >> 2] = e - d;
            b[i >> 2] = c - d;
            return;
        }
        function Ma(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            if ((c + -1 | 0) >>> 0 >= 6) return;
            f = (b[15472 + (c * 12 | 0) >> 2] | 0) + (b[a >> 2] | 0) | 0;
            b[a >> 2] = f;
            i = a + 4 | 0;
            e = (b[15472 + (c * 12 | 0) + 4 >> 2] | 0) + (b[i >> 2] | 0) | 0;
            b[i >> 2] = e;
            h = a + 8 | 0;
            c = (b[15472 + (c * 12 | 0) + 8 >> 2] | 0) + (b[h >> 2] | 0) | 0;
            b[h >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[i >> 2] = d;
                b[h >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[h >> 2] = c;
                b[i >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[i >> 2] = f - d;
            b[h >> 2] = c - d;
            return;
        }
        function Na(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = c + f | 0;
            f = d + f | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = d + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Oa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            e = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            f = e + c | 0;
            b[a >> 2] = f;
            e = d + e | 0;
            b[h >> 2] = e;
            c = d + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Pa(a) {
            a = a | 0;
            switch(a | 0){
                case 1:
                    a = 5;
                    break;
                case 5:
                    a = 4;
                    break;
                case 4:
                    a = 6;
                    break;
                case 6:
                    a = 2;
                    break;
                case 2:
                    a = 3;
                    break;
                case 3:
                    a = 1;
                    break;
                default:
            }
            return a | 0;
        }
        function Qa(a) {
            a = a | 0;
            switch(a | 0){
                case 1:
                    a = 3;
                    break;
                case 3:
                    a = 2;
                    break;
                case 2:
                    a = 6;
                    break;
                case 6:
                    a = 4;
                    break;
                case 4:
                    a = 5;
                    break;
                case 5:
                    a = 1;
                    break;
                default:
            }
            return a | 0;
        }
        function Ra(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            i = a + 8 | 0;
            e = b[i >> 2] | 0;
            f = d + (c << 1) | 0;
            b[a >> 2] = f;
            d = e + (d << 1) | 0;
            b[h >> 2] = d;
            c = (e << 1) + c | 0;
            b[i >> 2] = c;
            e = d - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = e;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                d = e;
                e = 0;
            } else e = f;
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Sa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = (c << 1) + f | 0;
            f = d + (f << 1) | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = (d << 1) + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                f = 0;
            } else d = e;
            if ((d | 0) < 0) {
                f = f - d | 0;
                b[a >> 2] = f;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = f - c | 0;
            e = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = e;
                b[i >> 2] = 0;
                f = g;
                c = 0;
            } else e = d;
            d = (e | 0) < (f | 0) ? e : f;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = f - d;
            b[h >> 2] = e - d;
            b[i >> 2] = c - d;
            return;
        }
        function Ta(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = (b[a >> 2] | 0) - (b[c >> 2] | 0) | 0;
            i = (h | 0) < 0;
            e = (b[a + 4 >> 2] | 0) - (b[c + 4 >> 2] | 0) - (i ? h : 0) | 0;
            g = (e | 0) < 0;
            f = (i ? 0 - h | 0 : 0) + (b[a + 8 >> 2] | 0) - (b[c + 8 >> 2] | 0) + (g ? 0 - e | 0 : 0) | 0;
            a = (f | 0) < 0;
            c = a ? 0 : f;
            d = (g ? 0 : e) - (a ? f : 0) | 0;
            f = (i ? 0 : h) - (g ? e : 0) - (a ? f : 0) | 0;
            a = (d | 0) < (f | 0) ? d : f;
            a = (c | 0) < (a | 0) ? c : a;
            e = (a | 0) > 0;
            c = c - (e ? a : 0) | 0;
            d = d - (e ? a : 0) | 0;
            a = f - (e ? a : 0) | 0;
            a = (a | 0) > -1 ? a : 0 - a | 0;
            d = (d | 0) > -1 ? d : 0 - d | 0;
            c = (c | 0) > -1 ? c : 0 - c | 0;
            c = (d | 0) > (c | 0) ? d : c;
            return ((a | 0) > (c | 0) ? a : c) | 0;
        }
        function Ua(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            d = b[a + 8 >> 2] | 0;
            b[c >> 2] = (b[a >> 2] | 0) - d;
            b[c + 4 >> 2] = (b[a + 4 >> 2] | 0) - d;
            return;
        }
        function Va(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            e = b[a >> 2] | 0;
            b[c >> 2] = e;
            a = b[a + 4 >> 2] | 0;
            h = c + 4 | 0;
            b[h >> 2] = a;
            i = c + 8 | 0;
            b[i >> 2] = 0;
            d = a - e | 0;
            if ((e | 0) < 0) {
                a = 0 - e | 0;
                b[h >> 2] = d;
                b[i >> 2] = a;
                b[c >> 2] = 0;
                e = 0;
            } else {
                d = a;
                a = 0;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[c >> 2] = e;
                a = a - d | 0;
                b[i >> 2] = a;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - a | 0;
            f = d - a | 0;
            if ((a | 0) < 0) {
                b[c >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                d = f;
                f = g;
                a = 0;
            } else f = e;
            e = (d | 0) < (f | 0) ? d : f;
            e = (a | 0) < (e | 0) ? a : e;
            if ((e | 0) <= 0) return;
            b[c >> 2] = f - e;
            b[h >> 2] = d - e;
            b[i >> 2] = a - e;
            return;
        }
        function Wa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0;
            c = a + 8 | 0;
            f = b[c >> 2] | 0;
            d = f - (b[a >> 2] | 0) | 0;
            b[a >> 2] = d;
            e = a + 4 | 0;
            a = (b[e >> 2] | 0) - f | 0;
            b[e >> 2] = a;
            b[c >> 2] = 0 - (a + d);
            return;
        }
        function Xa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            d = b[a >> 2] | 0;
            c = 0 - d | 0;
            b[a >> 2] = c;
            h = a + 8 | 0;
            b[h >> 2] = 0;
            i = a + 4 | 0;
            e = b[i >> 2] | 0;
            f = e + d | 0;
            if ((d | 0) > 0) {
                b[i >> 2] = f;
                b[h >> 2] = d;
                b[a >> 2] = 0;
                c = 0;
                e = f;
            } else d = 0;
            if ((e | 0) < 0) {
                g = c - e | 0;
                b[a >> 2] = g;
                d = d - e | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                f = g - d | 0;
                c = 0 - d | 0;
                if ((d | 0) < 0) {
                    b[a >> 2] = f;
                    b[i >> 2] = c;
                    b[h >> 2] = 0;
                    e = c;
                    d = 0;
                } else {
                    e = 0;
                    f = g;
                }
            } else f = c;
            c = (e | 0) < (f | 0) ? e : f;
            c = (d | 0) < (c | 0) ? d : c;
            if ((c | 0) <= 0) return;
            b[a >> 2] = f - c;
            b[i >> 2] = e - c;
            b[h >> 2] = d - c;
            return;
        }
        function Ya(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = S;
            S = S + 16 | 0;
            e = d;
            Za(a, b, c, e);
            Ba(e, c + 4 | 0);
            S = d;
            return;
        }
        function Za(a, c, d, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0.0, h = 0, i = 0.0, j = 0.0, k = 0;
            k = S;
            S = S + 32 | 0;
            h = k;
            Ic(a, h);
            b[d >> 2] = 0;
            g = +Hc(15888, h);
            i = +Hc(15912, h);
            if (i < g) {
                b[d >> 2] = 1;
                g = i;
            }
            i = +Hc(15936, h);
            if (i < g) {
                b[d >> 2] = 2;
                g = i;
            }
            i = +Hc(15960, h);
            if (i < g) {
                b[d >> 2] = 3;
                g = i;
            }
            i = +Hc(15984, h);
            if (i < g) {
                b[d >> 2] = 4;
                g = i;
            }
            i = +Hc(16008, h);
            if (i < g) {
                b[d >> 2] = 5;
                g = i;
            }
            i = +Hc(16032, h);
            if (i < g) {
                b[d >> 2] = 6;
                g = i;
            }
            i = +Hc(16056, h);
            if (i < g) {
                b[d >> 2] = 7;
                g = i;
            }
            i = +Hc(16080, h);
            if (i < g) {
                b[d >> 2] = 8;
                g = i;
            }
            i = +Hc(16104, h);
            if (i < g) {
                b[d >> 2] = 9;
                g = i;
            }
            i = +Hc(16128, h);
            if (i < g) {
                b[d >> 2] = 10;
                g = i;
            }
            i = +Hc(16152, h);
            if (i < g) {
                b[d >> 2] = 11;
                g = i;
            }
            i = +Hc(16176, h);
            if (i < g) {
                b[d >> 2] = 12;
                g = i;
            }
            i = +Hc(16200, h);
            if (i < g) {
                b[d >> 2] = 13;
                g = i;
            }
            i = +Hc(16224, h);
            if (i < g) {
                b[d >> 2] = 14;
                g = i;
            }
            i = +Hc(16248, h);
            if (i < g) {
                b[d >> 2] = 15;
                g = i;
            }
            i = +Hc(16272, h);
            if (i < g) {
                b[d >> 2] = 16;
                g = i;
            }
            i = +Hc(16296, h);
            if (i < g) {
                b[d >> 2] = 17;
                g = i;
            }
            i = +Hc(16320, h);
            if (i < g) {
                b[d >> 2] = 18;
                g = i;
            }
            i = +Hc(16344, h);
            if (i < g) {
                b[d >> 2] = 19;
                g = i;
            }
            i = +w(+(1.0 - g * .5));
            if (i < 1.0e-16) {
                b[f >> 2] = 0;
                b[f + 4 >> 2] = 0;
                b[f + 8 >> 2] = 0;
                b[f + 12 >> 2] = 0;
                S = k;
                return;
            }
            d = b[d >> 2] | 0;
            g = +e[16368 + (d * 24 | 0) >> 3];
            g = +gb(g - +gb(+lb(15568 + (d << 4) | 0, a)));
            if (!(Qb(c) | 0)) j = g;
            else j = +gb(g + -0.3334731722518321);
            g = +v(+i) / .381966011250105;
            if ((c | 0) > 0) {
                h = 0;
                do {
                    g = g * 2.6457513110645907;
                    h = h + 1 | 0;
                }while ((h | 0) != (c | 0));
            }
            i = +t(+j) * g;
            e[f >> 3] = i;
            j = +u(+j) * g;
            e[f + 8 >> 3] = j;
            S = k;
            return;
        }
        function _a(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0.0, i = 0.0;
            h = +Ec(a);
            if (h < 1.0e-16) {
                c = 15568 + (c << 4) | 0;
                b[g >> 2] = b[c >> 2];
                b[g + 4 >> 2] = b[c + 4 >> 2];
                b[g + 8 >> 2] = b[c + 8 >> 2];
                b[g + 12 >> 2] = b[c + 12 >> 2];
                return;
            }
            i = +z(+ +e[a + 8 >> 3], + +e[a >> 3]);
            if ((d | 0) > 0) {
                a = 0;
                do {
                    h = h / 2.6457513110645907;
                    a = a + 1 | 0;
                }while ((a | 0) != (d | 0));
            }
            if (!f) {
                h = +y(+(h * .381966011250105));
                if (Qb(d) | 0) i = +gb(i + .3334731722518321);
            } else {
                h = h / 3.0;
                d = (Qb(d) | 0) == 0;
                h = +y(+((d ? h : h / 2.6457513110645907) * .381966011250105));
            }
            mb(15568 + (c << 4) | 0, +gb(+e[16368 + (c * 24 | 0) >> 3] - i), h, g);
            return;
        }
        function $a(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = S;
            S = S + 16 | 0;
            f = e;
            Da(a + 4 | 0, f);
            _a(f, b[a >> 2] | 0, c, 0, d);
            S = e;
            return;
        }
        function ab(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, I = 0.0, J = 0.0;
            G = S;
            S = S + 272 | 0;
            h = G + 256 | 0;
            u = G + 240 | 0;
            D = G;
            E = G + 224 | 0;
            F = G + 208 | 0;
            v = G + 176 | 0;
            w = G + 160 | 0;
            x = G + 192 | 0;
            y = G + 144 | 0;
            z = G + 128 | 0;
            A = G + 112 | 0;
            B = G + 96 | 0;
            C = G + 80 | 0;
            b[h >> 2] = c;
            b[u >> 2] = b[a >> 2];
            b[u + 4 >> 2] = b[a + 4 >> 2];
            b[u + 8 >> 2] = b[a + 8 >> 2];
            b[u + 12 >> 2] = b[a + 12 >> 2];
            bb(u, h, D);
            b[g >> 2] = 0;
            u = f + d + ((f | 0) == 5 & 1) | 0;
            if ((u | 0) <= (d | 0)) {
                S = G;
                return;
            }
            k = b[h >> 2] | 0;
            l = E + 4 | 0;
            m = v + 4 | 0;
            n = d + 5 | 0;
            o = 16848 + (k << 2) | 0;
            p = 16928 + (k << 2) | 0;
            q = z + 8 | 0;
            r = A + 8 | 0;
            s = B + 8 | 0;
            t = F + 4 | 0;
            j = d;
            a: while(true){
                i = D + (((j | 0) % 5 | 0) << 4) | 0;
                b[F >> 2] = b[i >> 2];
                b[F + 4 >> 2] = b[i + 4 >> 2];
                b[F + 8 >> 2] = b[i + 8 >> 2];
                b[F + 12 >> 2] = b[i + 12 >> 2];
                do ;
                while ((cb(F, k, 0, 1) | 0) == 2);
                if ((j | 0) > (d | 0) & (Qb(c) | 0) != 0) {
                    b[v >> 2] = b[F >> 2];
                    b[v + 4 >> 2] = b[F + 4 >> 2];
                    b[v + 8 >> 2] = b[F + 8 >> 2];
                    b[v + 12 >> 2] = b[F + 12 >> 2];
                    Da(l, w);
                    f = b[v >> 2] | 0;
                    h = b[17008 + (f * 80 | 0) + (b[E >> 2] << 2) >> 2] | 0;
                    b[v >> 2] = b[18608 + (f * 80 | 0) + (h * 20 | 0) >> 2];
                    i = b[18608 + (f * 80 | 0) + (h * 20 | 0) + 16 >> 2] | 0;
                    if ((i | 0) > 0) {
                        a = 0;
                        do {
                            Na(m);
                            a = a + 1 | 0;
                        }while ((a | 0) < (i | 0));
                    }
                    i = 18608 + (f * 80 | 0) + (h * 20 | 0) + 4 | 0;
                    b[x >> 2] = b[i >> 2];
                    b[x + 4 >> 2] = b[i + 4 >> 2];
                    b[x + 8 >> 2] = b[i + 8 >> 2];
                    Ga(x, (b[o >> 2] | 0) * 3 | 0);
                    Ea(m, x, m);
                    Ca(m);
                    Da(m, y);
                    I = +(b[p >> 2] | 0);
                    e[z >> 3] = I * 3.0;
                    e[q >> 3] = 0.0;
                    J = I * -1.5;
                    e[A >> 3] = J;
                    e[r >> 3] = I * 2.598076211353316;
                    e[B >> 3] = J;
                    e[s >> 3] = I * -2.598076211353316;
                    switch(b[17008 + ((b[v >> 2] | 0) * 80 | 0) + (b[F >> 2] << 2) >> 2] | 0){
                        case 1:
                            a = A;
                            f = z;
                            break;
                        case 3:
                            a = B;
                            f = A;
                            break;
                        case 2:
                            a = z;
                            f = B;
                            break;
                        default:
                            a = 12;
                            break a;
                    }
                    Fc(w, y, f, a, C);
                    _a(C, b[v >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                if ((j | 0) < (n | 0)) {
                    Da(t, v);
                    _a(v, b[F >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                b[E >> 2] = b[F >> 2];
                b[E + 4 >> 2] = b[F + 4 >> 2];
                b[E + 8 >> 2] = b[F + 8 >> 2];
                b[E + 12 >> 2] = b[F + 12 >> 2];
                j = j + 1 | 0;
                if ((j | 0) >= (u | 0)) {
                    a = 3;
                    break;
                }
            }
            if ((a | 0) == 3) {
                S = G;
                return;
            } else if ((a | 0) == 12) H(22474, 22521, 581, 22531);
        }
        function bb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = S;
            S = S + 128 | 0;
            e = j + 64 | 0;
            f = j;
            g = e;
            h = 20208;
            i = g + 60 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            g = f;
            h = 20272;
            i = g + 60 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            i = (Qb(b[c >> 2] | 0) | 0) == 0;
            e = i ? e : f;
            f = a + 4 | 0;
            Ra(f);
            Sa(f);
            if (Qb(b[c >> 2] | 0) | 0) {
                La(f);
                b[c >> 2] = (b[c >> 2] | 0) + 1;
            }
            b[d >> 2] = b[a >> 2];
            c = d + 4 | 0;
            Ea(f, e, c);
            Ca(c);
            b[d + 16 >> 2] = b[a >> 2];
            c = d + 20 | 0;
            Ea(f, e + 12 | 0, c);
            Ca(c);
            b[d + 32 >> 2] = b[a >> 2];
            c = d + 36 | 0;
            Ea(f, e + 24 | 0, c);
            Ca(c);
            b[d + 48 >> 2] = b[a >> 2];
            c = d + 52 | 0;
            Ea(f, e + 36 | 0, c);
            Ca(c);
            b[d + 64 >> 2] = b[a >> 2];
            d = d + 68 | 0;
            Ea(f, e + 48 | 0, d);
            Ca(d);
            S = j;
            return;
        }
        function cb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            p = S;
            S = S + 32 | 0;
            n = p + 12 | 0;
            i = p;
            o = a + 4 | 0;
            m = b[16928 + (c << 2) >> 2] | 0;
            l = (e | 0) != 0;
            m = l ? m * 3 | 0 : m;
            f = b[o >> 2] | 0;
            k = a + 8 | 0;
            h = b[k >> 2] | 0;
            if (l) {
                g = a + 12 | 0;
                e = b[g >> 2] | 0;
                f = h + f + e | 0;
                if ((f | 0) == (m | 0)) {
                    o = 1;
                    S = p;
                    return o | 0;
                } else j = g;
            } else {
                j = a + 12 | 0;
                e = b[j >> 2] | 0;
                f = h + f + e | 0;
            }
            if ((f | 0) <= (m | 0)) {
                o = 0;
                S = p;
                return o | 0;
            }
            do if ((e | 0) > 0) {
                e = b[a >> 2] | 0;
                if ((h | 0) > 0) {
                    g = 18608 + (e * 80 | 0) + 60 | 0;
                    e = a;
                    break;
                }
                e = 18608 + (e * 80 | 0) + 40 | 0;
                if (!d) {
                    g = e;
                    e = a;
                } else {
                    Aa(n, m, 0, 0);
                    Fa(o, n, i);
                    Oa(i);
                    Ea(i, n, o);
                    g = e;
                    e = a;
                }
            } else {
                g = 18608 + ((b[a >> 2] | 0) * 80 | 0) + 20 | 0;
                e = a;
            }
            while (0);
            b[e >> 2] = b[g >> 2];
            f = g + 16 | 0;
            if ((b[f >> 2] | 0) > 0) {
                e = 0;
                do {
                    Na(o);
                    e = e + 1 | 0;
                }while ((e | 0) < (b[f >> 2] | 0));
            }
            a = g + 4 | 0;
            b[n >> 2] = b[a >> 2];
            b[n + 4 >> 2] = b[a + 4 >> 2];
            b[n + 8 >> 2] = b[a + 8 >> 2];
            c = b[16848 + (c << 2) >> 2] | 0;
            Ga(n, l ? c * 3 | 0 : c);
            Ea(o, n, o);
            Ca(o);
            if (l) e = ((b[k >> 2] | 0) + (b[o >> 2] | 0) + (b[j >> 2] | 0) | 0) == (m | 0) ? 1 : 2;
            else e = 2;
            o = e;
            S = p;
            return o | 0;
        }
        function db(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            do c = cb(a, b, 0, 1) | 0;
            while ((c | 0) == 2);
            return c | 0;
        }
        function eb(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0.0, D = 0.0;
            B = S;
            S = S + 240 | 0;
            h = B + 224 | 0;
            x = B + 208 | 0;
            y = B;
            z = B + 192 | 0;
            A = B + 176 | 0;
            s = B + 160 | 0;
            t = B + 144 | 0;
            u = B + 128 | 0;
            v = B + 112 | 0;
            w = B + 96 | 0;
            b[h >> 2] = c;
            b[x >> 2] = b[a >> 2];
            b[x + 4 >> 2] = b[a + 4 >> 2];
            b[x + 8 >> 2] = b[a + 8 >> 2];
            b[x + 12 >> 2] = b[a + 12 >> 2];
            fb(x, h, y);
            b[g >> 2] = 0;
            r = f + d + ((f | 0) == 6 & 1) | 0;
            if ((r | 0) <= (d | 0)) {
                S = B;
                return;
            }
            k = b[h >> 2] | 0;
            l = d + 6 | 0;
            m = 16928 + (k << 2) | 0;
            n = t + 8 | 0;
            o = u + 8 | 0;
            p = v + 8 | 0;
            q = z + 4 | 0;
            i = 0;
            j = d;
            f = -1;
            a: while(true){
                h = (j | 0) % 6 | 0;
                a = y + (h << 4) | 0;
                b[z >> 2] = b[a >> 2];
                b[z + 4 >> 2] = b[a + 4 >> 2];
                b[z + 8 >> 2] = b[a + 8 >> 2];
                b[z + 12 >> 2] = b[a + 12 >> 2];
                a = i;
                i = cb(z, k, 0, 1) | 0;
                if ((j | 0) > (d | 0) & (Qb(c) | 0) != 0 ? (a | 0) != 1 ? (b[z >> 2] | 0) != (f | 0) : 0 : 0) {
                    Da(y + (((h + 5 | 0) % 6 | 0) << 4) + 4 | 0, A);
                    Da(y + (h << 4) + 4 | 0, s);
                    C = +(b[m >> 2] | 0);
                    e[t >> 3] = C * 3.0;
                    e[n >> 3] = 0.0;
                    D = C * -1.5;
                    e[u >> 3] = D;
                    e[o >> 3] = C * 2.598076211353316;
                    e[v >> 3] = D;
                    e[p >> 3] = C * -2.598076211353316;
                    h = b[x >> 2] | 0;
                    switch(b[17008 + (h * 80 | 0) + (((f | 0) == (h | 0) ? b[z >> 2] | 0 : f) << 2) >> 2] | 0){
                        case 1:
                            a = u;
                            f = t;
                            break;
                        case 3:
                            a = v;
                            f = u;
                            break;
                        case 2:
                            a = t;
                            f = v;
                            break;
                        default:
                            a = 8;
                            break a;
                    }
                    Fc(A, s, f, a, w);
                    if (!(Gc(A, w) | 0) ? !(Gc(s, w) | 0) : 0) {
                        _a(w, b[x >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                        b[g >> 2] = (b[g >> 2] | 0) + 1;
                    }
                }
                if ((j | 0) < (l | 0)) {
                    Da(q, A);
                    _a(A, b[z >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                j = j + 1 | 0;
                if ((j | 0) >= (r | 0)) {
                    a = 3;
                    break;
                } else f = b[z >> 2] | 0;
            }
            if ((a | 0) == 3) {
                S = B;
                return;
            } else if ((a | 0) == 8) H(22557, 22521, 746, 22602);
        }
        function fb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = S;
            S = S + 160 | 0;
            e = j + 80 | 0;
            f = j;
            g = e;
            h = 20336;
            i = g + 72 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            g = f;
            h = 20416;
            i = g + 72 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            i = (Qb(b[c >> 2] | 0) | 0) == 0;
            e = i ? e : f;
            f = a + 4 | 0;
            Ra(f);
            Sa(f);
            if (Qb(b[c >> 2] | 0) | 0) {
                La(f);
                b[c >> 2] = (b[c >> 2] | 0) + 1;
            }
            b[d >> 2] = b[a >> 2];
            c = d + 4 | 0;
            Ea(f, e, c);
            Ca(c);
            b[d + 16 >> 2] = b[a >> 2];
            c = d + 20 | 0;
            Ea(f, e + 12 | 0, c);
            Ca(c);
            b[d + 32 >> 2] = b[a >> 2];
            c = d + 36 | 0;
            Ea(f, e + 24 | 0, c);
            Ca(c);
            b[d + 48 >> 2] = b[a >> 2];
            c = d + 52 | 0;
            Ea(f, e + 36 | 0, c);
            Ca(c);
            b[d + 64 >> 2] = b[a >> 2];
            c = d + 68 | 0;
            Ea(f, e + 48 | 0, c);
            Ca(c);
            b[d + 80 >> 2] = b[a >> 2];
            d = d + 84 | 0;
            Ea(f, e + 60 | 0, d);
            Ca(d);
            S = j;
            return;
        }
        function gb(a) {
            a = +a;
            var b = 0.0;
            b = a < 0.0 ? a + 6.283185307179586 : a;
            return +(!(a >= 6.283185307179586) ? b : b + -6.283185307179586);
        }
        function hb(a, b) {
            a = a | 0;
            b = b | 0;
            if (!(+q(+(+e[a >> 3] - +e[b >> 3])) < 1.7453292519943298e-11)) {
                b = 0;
                return b | 0;
            }
            b = +q(+(+e[a + 8 >> 3] - +e[b + 8 >> 3])) < 1.7453292519943298e-11;
            return b | 0;
        }
        function ib(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 2.0);
        }
        function jb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 12742.01436183695);
        }
        function kb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 12742014.36183695);
        }
        function lb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0, h = 0.0;
            g = +e[b >> 3];
            d = +t(+g);
            f = +e[b + 8 >> 3] - +e[a + 8 >> 3];
            h = d * +u(+f);
            c = +e[a >> 3];
            return + +z(+h, +(+u(+g) * +t(+c) - +t(+f) * (d * +u(+c))));
        }
        function mb(a, c, d, f) {
            a = a | 0;
            c = +c;
            d = +d;
            f = f | 0;
            var g = 0, h = 0.0, i = 0.0, j = 0.0;
            if (d < 1.0e-16) {
                b[f >> 2] = b[a >> 2];
                b[f + 4 >> 2] = b[a + 4 >> 2];
                b[f + 8 >> 2] = b[a + 8 >> 2];
                b[f + 12 >> 2] = b[a + 12 >> 2];
                return;
            }
            h = c < 0.0 ? c + 6.283185307179586 : c;
            h = !(c >= 6.283185307179586) ? h : h + -6.283185307179586;
            do if (h < 1.0e-16) {
                c = +e[a >> 3] + d;
                e[f >> 3] = c;
                g = f;
            } else {
                g = +q(+(h + -3.141592653589793)) < 1.0e-16;
                c = +e[a >> 3];
                if (g) {
                    c = c - d;
                    e[f >> 3] = c;
                    g = f;
                    break;
                }
                i = +t(+d);
                d = +u(+d);
                c = i * +u(+c) + +t(+h) * (d * +t(+c));
                c = c > 1.0 ? 1.0 : c;
                c = +x(+(c < -1 ? -1 : c));
                e[f >> 3] = c;
                if (+q(+(c + -1.5707963267948966)) < 1.0e-16) {
                    e[f >> 3] = 1.5707963267948966;
                    e[f + 8 >> 3] = 0.0;
                    return;
                }
                if (+q(+(c + 1.5707963267948966)) < 1.0e-16) {
                    e[f >> 3] = -1.5707963267948966;
                    e[f + 8 >> 3] = 0.0;
                    return;
                }
                j = +t(+c);
                h = d * +u(+h) / j;
                d = +e[a >> 3];
                c = (i - +u(+c) * +u(+d)) / +t(+d) / j;
                i = h > 1.0 ? 1.0 : h;
                c = c > 1.0 ? 1.0 : c;
                c = +e[a + 8 >> 3] + +z(+(i < -1 ? -1 : i), +(c < -1 ? -1 : c));
                if (c > 3.141592653589793) do c = c + -6.283185307179586;
                while (c > 3.141592653589793);
                if (c < -3.141592653589793) do c = c + 6.283185307179586;
                while (c < -3.141592653589793);
                e[f + 8 >> 3] = c;
                return;
            }
            while (0);
            if (+q(+(c + -1.5707963267948966)) < 1.0e-16) {
                e[g >> 3] = 1.5707963267948966;
                e[f + 8 >> 3] = 0.0;
                return;
            }
            if (+q(+(c + 1.5707963267948966)) < 1.0e-16) {
                e[g >> 3] = -1.5707963267948966;
                e[f + 8 >> 3] = 0.0;
                return;
            }
            c = +e[a + 8 >> 3];
            if (c > 3.141592653589793) do c = c + -6.283185307179586;
            while (c > 3.141592653589793);
            if (c < -3.141592653589793) do c = c + 6.283185307179586;
            while (c < -3.141592653589793);
            e[f + 8 >> 3] = c;
            return;
        }
        function nb(a) {
            a = a | 0;
            return + +e[20496 + (a << 3) >> 3];
        }
        function ob(a) {
            a = a | 0;
            return + +e[20624 + (a << 3) >> 3];
        }
        function pb(a) {
            a = a | 0;
            return + +e[20752 + (a << 3) >> 3];
        }
        function qb(a) {
            a = a | 0;
            return + +e[20880 + (a << 3) >> 3];
        }
        function rb(a) {
            a = a | 0;
            var c = 0;
            c = 21008 + (a << 3) | 0;
            a = b[c >> 2] | 0;
            F(b[c + 4 >> 2] | 0);
            return a | 0;
        }
        function sb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0;
            n = +e[b >> 3];
            l = +e[a >> 3];
            j = +u(+((n - l) * .5));
            g = +e[b + 8 >> 3];
            k = +e[a + 8 >> 3];
            h = +u(+((g - k) * .5));
            i = +t(+l);
            m = +t(+n);
            h = j * j + h * (m * i * h);
            h = +z(+ +r(+h), + +r(+(1.0 - h))) * 2.0;
            j = +e[c >> 3];
            n = +u(+((j - n) * .5));
            d = +e[c + 8 >> 3];
            g = +u(+((d - g) * .5));
            f = +t(+j);
            g = n * n + g * (m * f * g);
            g = +z(+ +r(+g), + +r(+(1.0 - g))) * 2.0;
            j = +u(+((l - j) * .5));
            d = +u(+((k - d) * .5));
            d = j * j + d * (i * f * d);
            d = +z(+ +r(+d), + +r(+(1.0 - d))) * 2.0;
            f = (h + g + d) * .5;
            return +(+y(+ +r(+(+v(+(f * .5)) * +v(+((f - h) * .5)) * +v(+((f - g) * .5)) * +v(+((f - d) * .5))))) * 4.0);
        }
        function tb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 192 | 0;
            e = g + 168 | 0;
            f = g;
            Ub(a, c, e);
            Vb(a, c, f);
            c = b[f >> 2] | 0;
            if ((c | 0) <= 0) {
                d = 0.0;
                S = g;
                return +d;
            }
            d = +sb(f + 8 | 0, f + 8 + (((c | 0) != 1 & 1) << 4) | 0, e) + 0.0;
            if ((c | 0) == 1) {
                S = g;
                return +d;
            }
            a = 1;
            do {
                h = a;
                a = a + 1 | 0;
                d = d + +sb(f + 8 + (h << 4) | 0, f + 8 + (((a | 0) % (c | 0) | 0) << 4) | 0, e);
            }while ((a | 0) < (c | 0));
            S = g;
            return +d;
        }
        function ub(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 192 | 0;
            e = g + 168 | 0;
            f = g;
            Ub(a, c, e);
            Vb(a, c, f);
            c = b[f >> 2] | 0;
            if ((c | 0) > 0) {
                d = +sb(f + 8 | 0, f + 8 + (((c | 0) != 1 & 1) << 4) | 0, e) + 0.0;
                if ((c | 0) != 1) {
                    a = 1;
                    do {
                        h = a;
                        a = a + 1 | 0;
                        d = d + +sb(f + 8 + (h << 4) | 0, f + 8 + (((a | 0) % (c | 0) | 0) << 4) | 0, e);
                    }while ((a | 0) < (c | 0));
                }
            } else d = 0.0;
            S = g;
            return +(d * 40589732.49931477);
        }
        function vb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 192 | 0;
            e = g + 168 | 0;
            f = g;
            Ub(a, c, e);
            Vb(a, c, f);
            c = b[f >> 2] | 0;
            if ((c | 0) > 0) {
                d = +sb(f + 8 | 0, f + 8 + (((c | 0) != 1 & 1) << 4) | 0, e) + 0.0;
                if ((c | 0) != 1) {
                    a = 1;
                    do {
                        h = a;
                        a = a + 1 | 0;
                        d = d + +sb(f + 8 + (h << 4) | 0, f + 8 + (((a | 0) % (c | 0) | 0) << 4) | 0, e);
                    }while ((a | 0) < (c | 0));
                }
            } else d = 0.0;
            S = g;
            return +(d * 40589732499314.77);
        }
        function wb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            i = S;
            S = S + 176 | 0;
            h = i;
            fc(a, c, h);
            a = b[h >> 2] | 0;
            if ((a | 0) <= 1) {
                g = 0.0;
                S = i;
                return +g;
            }
            c = a + -1 | 0;
            a = 0;
            d = 0.0;
            f = +e[h + 8 >> 3];
            g = +e[h + 16 >> 3];
            do {
                a = a + 1 | 0;
                k = f;
                f = +e[h + 8 + (a << 4) >> 3];
                l = +u(+((f - k) * .5));
                j = g;
                g = +e[h + 8 + (a << 4) + 8 >> 3];
                j = +u(+((g - j) * .5));
                j = l * l + j * (+t(+f) * +t(+k) * j);
                d = d + +z(+ +r(+j), + +r(+(1.0 - j))) * 2.0;
            }while ((a | 0) < (c | 0));
            S = i;
            return +d;
        }
        function xb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            i = S;
            S = S + 176 | 0;
            h = i;
            fc(a, c, h);
            a = b[h >> 2] | 0;
            if ((a | 0) <= 1) {
                g = 0.0;
                S = i;
                return +g;
            }
            c = a + -1 | 0;
            a = 0;
            d = 0.0;
            f = +e[h + 8 >> 3];
            g = +e[h + 16 >> 3];
            do {
                a = a + 1 | 0;
                k = f;
                f = +e[h + 8 + (a << 4) >> 3];
                l = +u(+((f - k) * .5));
                j = g;
                g = +e[h + 8 + (a << 4) + 8 >> 3];
                j = +u(+((g - j) * .5));
                j = l * l + j * (+t(+k) * +t(+f) * j);
                d = d + +z(+ +r(+j), + +r(+(1.0 - j))) * 2.0;
            }while ((a | 0) != (c | 0));
            l = d * 6371.007180918475;
            S = i;
            return +l;
        }
        function yb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            i = S;
            S = S + 176 | 0;
            h = i;
            fc(a, c, h);
            a = b[h >> 2] | 0;
            if ((a | 0) <= 1) {
                g = 0.0;
                S = i;
                return +g;
            }
            c = a + -1 | 0;
            a = 0;
            d = 0.0;
            f = +e[h + 8 >> 3];
            g = +e[h + 16 >> 3];
            do {
                a = a + 1 | 0;
                k = f;
                f = +e[h + 8 + (a << 4) >> 3];
                l = +u(+((f - k) * .5));
                j = g;
                g = +e[h + 8 + (a << 4) + 8 >> 3];
                j = +u(+((g - j) * .5));
                j = l * l + j * (+t(+k) * +t(+f) * j);
                d = d + +z(+ +r(+j), + +r(+(1.0 - j))) * 2.0;
            }while ((a | 0) != (c | 0));
            l = d * 6371007.180918475;
            S = i;
            return +l;
        }
        function zb(a, b) {
            a = a | 0;
            b = b | 0;
            b = bd(a | 0, b | 0, 45) | 0;
            G();
            return b & 127 | 0;
        }
        function Ab(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            if (!(true & (b & -16777216 | 0) == 134217728)) {
                b = 0;
                return b | 0;
            }
            g = bd(a | 0, b | 0, 45) | 0;
            G();
            g = g & 127;
            if (g >>> 0 > 121) {
                b = 0;
                return b | 0;
            }
            c = bd(a | 0, b | 0, 52) | 0;
            G();
            c = c & 15;
            do if (c | 0) {
                e = 1;
                d = 0;
                while(true){
                    f = bd(a | 0, b | 0, (15 - e | 0) * 3 | 0) | 0;
                    G();
                    f = f & 7;
                    if ((f | 0) != 0 & (d ^ 1)) {
                        if ((f | 0) == 1 & (la(g) | 0) != 0) {
                            h = 0;
                            d = 13;
                            break;
                        } else d = 1;
                    }
                    if ((f | 0) == 7) {
                        h = 0;
                        d = 13;
                        break;
                    }
                    if (e >>> 0 < c >>> 0) e = e + 1 | 0;
                    else {
                        d = 9;
                        break;
                    }
                }
                if ((d | 0) == 9) {
                    if ((c | 0) == 15) h = 1;
                    else break;
                    return h | 0;
                } else if ((d | 0) == 13) return h | 0;
            }
            while (0);
            while(true){
                h = bd(a | 0, b | 0, (14 - c | 0) * 3 | 0) | 0;
                G();
                if (!((h & 7 | 0) == 7 & true)) {
                    h = 0;
                    d = 13;
                    break;
                }
                if (c >>> 0 < 14) c = c + 1 | 0;
                else {
                    h = 1;
                    d = 13;
                    break;
                }
            }
            if ((d | 0) == 13) return h | 0;
            return 0;
        }
        function Bb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = bd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if ((d | 0) >= (c | 0)) {
                if ((d | 0) != (c | 0)) {
                    if (c >>> 0 <= 15) {
                        e = cd(c | 0, 0, 52) | 0;
                        a = e | a;
                        b = G() | 0 | b & -15728641;
                        if ((d | 0) > (c | 0)) do {
                            e = cd(7, 0, (14 - c | 0) * 3 | 0) | 0;
                            c = c + 1 | 0;
                            a = e | a;
                            b = G() | 0 | b;
                        }while ((c | 0) < (d | 0));
                    } else {
                        b = 0;
                        a = 0;
                    }
                }
            } else {
                b = 0;
                a = 0;
            }
            F(b | 0);
            return a | 0;
        }
        function Cb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            a = bd(a | 0, b | 0, 52) | 0;
            G();
            a = a & 15;
            if (!((c | 0) < 16 & (a | 0) <= (c | 0))) {
                c = 0;
                return c | 0;
            }
            c = sc(7, c - a | 0) | 0;
            return c | 0;
        }
        function Db(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            h = bd(a | 0, c | 0, 52) | 0;
            G();
            h = h & 15;
            if (!((d | 0) < 16 & (h | 0) <= (d | 0))) return;
            if ((h | 0) == (d | 0)) {
                d = e;
                b[d >> 2] = a;
                b[d + 4 >> 2] = c;
                return;
            }
            j = sc(7, d - h | 0) | 0;
            k = (j | 0) / 7 | 0;
            i = bd(a | 0, c | 0, 45) | 0;
            G();
            if (!(la(i & 127) | 0)) g = 0;
            else {
                a: do if (!h) f = 0;
                else {
                    g = 1;
                    while(true){
                        f = bd(a | 0, c | 0, (15 - g | 0) * 3 | 0) | 0;
                        G();
                        f = f & 7;
                        if (f | 0) break a;
                        if (g >>> 0 < h >>> 0) g = g + 1 | 0;
                        else {
                            f = 0;
                            break;
                        }
                    }
                }
                while (0);
                g = (f | 0) == 0;
            }
            l = cd(h + 1 | 0, 0, 52) | 0;
            f = G() | 0 | c & -15728641;
            i = (14 - h | 0) * 3 | 0;
            c = cd(7, 0, i | 0) | 0;
            c = (l | a) & ~c;
            h = f & ~(G() | 0);
            Db(c, h, d, e);
            f = e + (k << 3) | 0;
            if (!g) {
                l = cd(1, 0, i | 0) | 0;
                Db(l | c, G() | 0 | h, d, f);
                l = f + (k << 3) | 0;
                j = cd(2, 0, i | 0) | 0;
                Db(j | c, G() | 0 | h, d, l);
                l = l + (k << 3) | 0;
                j = cd(3, 0, i | 0) | 0;
                Db(j | c, G() | 0 | h, d, l);
                l = l + (k << 3) | 0;
                j = cd(4, 0, i | 0) | 0;
                Db(j | c, G() | 0 | h, d, l);
                l = l + (k << 3) | 0;
                j = cd(5, 0, i | 0) | 0;
                Db(j | c, G() | 0 | h, d, l);
                j = cd(6, 0, i | 0) | 0;
                Db(j | c, G() | 0 | h, d, l + (k << 3) | 0);
                return;
            }
            g = f + (k << 3) | 0;
            if ((j | 0) > 6) {
                j = f + 8 | 0;
                l = (g >>> 0 > j >>> 0 ? g : j) + -1 + (0 - f) | 0;
                gd(f | 0, 0, l + 8 & -8 | 0);
                f = j + (l >>> 3 << 3) | 0;
            }
            l = cd(2, 0, i | 0) | 0;
            Db(l | c, G() | 0 | h, d, f);
            l = f + (k << 3) | 0;
            j = cd(3, 0, i | 0) | 0;
            Db(j | c, G() | 0 | h, d, l);
            l = l + (k << 3) | 0;
            j = cd(4, 0, i | 0) | 0;
            Db(j | c, G() | 0 | h, d, l);
            l = l + (k << 3) | 0;
            j = cd(5, 0, i | 0) | 0;
            Db(j | c, G() | 0 | h, d, l);
            j = cd(6, 0, i | 0) | 0;
            Db(j | c, G() | 0 | h, d, l + (k << 3) | 0);
            return;
        }
        function Eb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            e = bd(a | 0, b | 0, 45) | 0;
            G();
            if (!(la(e & 127) | 0)) {
                e = 0;
                return e | 0;
            }
            e = bd(a | 0, b | 0, 52) | 0;
            G();
            e = e & 15;
            a: do if (!e) c = 0;
            else {
                d = 1;
                while(true){
                    c = bd(a | 0, b | 0, (15 - d | 0) * 3 | 0) | 0;
                    G();
                    c = c & 7;
                    if (c | 0) break a;
                    if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                    else {
                        c = 0;
                        break;
                    }
                }
            }
            while (0);
            e = (c | 0) == 0 & 1;
            return e | 0;
        }
        function Fb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = bd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if ((c | 0) < 16 & (d | 0) <= (c | 0)) {
                if ((d | 0) != (c | 0)) {
                    e = cd(c | 0, 0, 52) | 0;
                    a = e | a;
                    b = G() | 0 | b & -15728641;
                    if ((d | 0) < (c | 0)) do {
                        e = cd(7, 0, (14 - d | 0) * 3 | 0) | 0;
                        d = d + 1 | 0;
                        a = a & ~e;
                        b = b & ~(G() | 0);
                    }while ((d | 0) < (c | 0));
                }
            } else {
                b = 0;
                a = 0;
            }
            F(b | 0);
            return a | 0;
        }
        function Gb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0;
            if (!d) {
                y = 0;
                return y | 0;
            }
            f = a;
            e = b[f >> 2] | 0;
            f = b[f + 4 >> 2] | 0;
            if (true & (f & 15728640 | 0) == 0) {
                if ((d | 0) <= 0) {
                    y = 0;
                    return y | 0;
                }
                y = c;
                b[y >> 2] = e;
                b[y + 4 >> 2] = f;
                if ((d | 0) == 1) {
                    y = 0;
                    return y | 0;
                }
                e = 1;
                do {
                    w = a + (e << 3) | 0;
                    x = b[w + 4 >> 2] | 0;
                    y = c + (e << 3) | 0;
                    b[y >> 2] = b[w >> 2];
                    b[y + 4 >> 2] = x;
                    e = e + 1 | 0;
                }while ((e | 0) != (d | 0));
                e = 0;
                return e | 0;
            }
            w = d << 3;
            x = Vc(w) | 0;
            if (!x) {
                y = -3;
                return y | 0;
            }
            fd(x | 0, a | 0, w | 0);
            v = Xc(d, 8) | 0;
            if (!v) {
                Wc(x);
                y = -3;
                return y | 0;
            }
            e = d;
            a: while(true){
                h = x;
                l = b[h >> 2] | 0;
                h = b[h + 4 >> 2] | 0;
                t = bd(l | 0, h | 0, 52) | 0;
                G();
                t = t & 15;
                u = t + -1 | 0;
                s = (e | 0) > 0;
                b: do if (s) {
                    r = ((e | 0) < 0) << 31 >> 31;
                    p = cd(u | 0, 0, 52) | 0;
                    q = G() | 0;
                    if (u >>> 0 > 15) {
                        f = 0;
                        a = l;
                        d = h;
                        while(true){
                            if (!((a | 0) == 0 & (d | 0) == 0)) {
                                g = bd(a | 0, d | 0, 52) | 0;
                                G();
                                g = g & 15;
                                i = (g | 0) < (u | 0);
                                g = (g | 0) == (u | 0);
                                k = i ? 0 : g ? a : 0;
                                a = i ? 0 : g ? d : 0;
                                d = ad(k | 0, a | 0, e | 0, r | 0) | 0;
                                G();
                                g = v + (d << 3) | 0;
                                i = g;
                                j = b[i >> 2] | 0;
                                i = b[i + 4 >> 2] | 0;
                                if ((j | 0) == 0 & (i | 0) == 0) d = k;
                                else {
                                    p = 0;
                                    o = d;
                                    n = i;
                                    d = k;
                                    while(true){
                                        if ((p | 0) > (e | 0)) {
                                            y = 41;
                                            break a;
                                        }
                                        if ((j | 0) == (d | 0) & (n & -117440513 | 0) == (a | 0)) {
                                            k = bd(j | 0, n | 0, 56) | 0;
                                            G();
                                            k = k & 7;
                                            m = k + 1 | 0;
                                            q = bd(j | 0, n | 0, 45) | 0;
                                            G();
                                            c: do if (!(la(q & 127) | 0)) i = 7;
                                            else {
                                                j = bd(j | 0, n | 0, 52) | 0;
                                                G();
                                                j = j & 15;
                                                if (!j) {
                                                    i = 6;
                                                    break;
                                                }
                                                i = 1;
                                                while(true){
                                                    q = cd(7, 0, (15 - i | 0) * 3 | 0) | 0;
                                                    if (!((q & d | 0) == 0 & ((G() | 0) & a | 0) == 0)) {
                                                        i = 7;
                                                        break c;
                                                    }
                                                    if (i >>> 0 < j >>> 0) i = i + 1 | 0;
                                                    else {
                                                        i = 6;
                                                        break;
                                                    }
                                                }
                                            }
                                            while (0);
                                            if ((k + 2 | 0) >>> 0 > i >>> 0) {
                                                y = 51;
                                                break a;
                                            }
                                            q = cd(m | 0, 0, 56) | 0;
                                            a = G() | 0 | a & -117440513;
                                            i = g;
                                            b[i >> 2] = 0;
                                            b[i + 4 >> 2] = 0;
                                            i = o;
                                            d = q | d;
                                        } else i = (o + 1 | 0) % (e | 0) | 0;
                                        g = v + (i << 3) | 0;
                                        n = g;
                                        j = b[n >> 2] | 0;
                                        n = b[n + 4 >> 2] | 0;
                                        if ((j | 0) == 0 & (n | 0) == 0) break;
                                        else {
                                            p = p + 1 | 0;
                                            o = i;
                                        }
                                    }
                                }
                                q = g;
                                b[q >> 2] = d;
                                b[q + 4 >> 2] = a;
                            }
                            f = f + 1 | 0;
                            if ((f | 0) >= (e | 0)) break b;
                            d = x + (f << 3) | 0;
                            a = b[d >> 2] | 0;
                            d = b[d + 4 >> 2] | 0;
                        }
                    }
                    f = 0;
                    a = l;
                    d = h;
                    while(true){
                        if (!((a | 0) == 0 & (d | 0) == 0)) {
                            i = bd(a | 0, d | 0, 52) | 0;
                            G();
                            i = i & 15;
                            if ((i | 0) >= (u | 0)) {
                                if ((i | 0) != (u | 0)) {
                                    a = a | p;
                                    d = d & -15728641 | q;
                                    if (i >>> 0 >= t >>> 0) {
                                        g = u;
                                        do {
                                            o = cd(7, 0, (14 - g | 0) * 3 | 0) | 0;
                                            g = g + 1 | 0;
                                            a = o | a;
                                            d = G() | 0 | d;
                                        }while (g >>> 0 < i >>> 0);
                                    }
                                }
                            } else {
                                a = 0;
                                d = 0;
                            }
                            i = ad(a | 0, d | 0, e | 0, r | 0) | 0;
                            G();
                            g = v + (i << 3) | 0;
                            j = g;
                            k = b[j >> 2] | 0;
                            j = b[j + 4 >> 2] | 0;
                            if (!((k | 0) == 0 & (j | 0) == 0)) {
                                o = 0;
                                while(true){
                                    if ((o | 0) > (e | 0)) {
                                        y = 41;
                                        break a;
                                    }
                                    if ((k | 0) == (a | 0) & (j & -117440513 | 0) == (d | 0)) {
                                        m = bd(k | 0, j | 0, 56) | 0;
                                        G();
                                        m = m & 7;
                                        n = m + 1 | 0;
                                        z = bd(k | 0, j | 0, 45) | 0;
                                        G();
                                        d: do if (!(la(z & 127) | 0)) j = 7;
                                        else {
                                            k = bd(k | 0, j | 0, 52) | 0;
                                            G();
                                            k = k & 15;
                                            if (!k) {
                                                j = 6;
                                                break;
                                            }
                                            j = 1;
                                            while(true){
                                                z = cd(7, 0, (15 - j | 0) * 3 | 0) | 0;
                                                if (!((z & a | 0) == 0 & ((G() | 0) & d | 0) == 0)) {
                                                    j = 7;
                                                    break d;
                                                }
                                                if (j >>> 0 < k >>> 0) j = j + 1 | 0;
                                                else {
                                                    j = 6;
                                                    break;
                                                }
                                            }
                                        }
                                        while (0);
                                        if ((m + 2 | 0) >>> 0 > j >>> 0) {
                                            y = 51;
                                            break a;
                                        }
                                        z = cd(n | 0, 0, 56) | 0;
                                        d = G() | 0 | d & -117440513;
                                        n = g;
                                        b[n >> 2] = 0;
                                        b[n + 4 >> 2] = 0;
                                        a = z | a;
                                    } else i = (i + 1 | 0) % (e | 0) | 0;
                                    g = v + (i << 3) | 0;
                                    j = g;
                                    k = b[j >> 2] | 0;
                                    j = b[j + 4 >> 2] | 0;
                                    if ((k | 0) == 0 & (j | 0) == 0) break;
                                    else o = o + 1 | 0;
                                }
                            }
                            z = g;
                            b[z >> 2] = a;
                            b[z + 4 >> 2] = d;
                        }
                        f = f + 1 | 0;
                        if ((f | 0) >= (e | 0)) break b;
                        d = x + (f << 3) | 0;
                        a = b[d >> 2] | 0;
                        d = b[d + 4 >> 2] | 0;
                    }
                }
                while (0);
                if ((e + 5 | 0) >>> 0 < 11) {
                    y = 99;
                    break;
                }
                q = Xc((e | 0) / 6 | 0, 8) | 0;
                if (!q) {
                    y = 58;
                    break;
                }
                e: do if (s) {
                    o = 0;
                    n = 0;
                    do {
                        i = v + (o << 3) | 0;
                        a = i;
                        f = b[a >> 2] | 0;
                        a = b[a + 4 >> 2] | 0;
                        if (!((f | 0) == 0 & (a | 0) == 0)) {
                            j = bd(f | 0, a | 0, 56) | 0;
                            G();
                            j = j & 7;
                            d = j + 1 | 0;
                            k = a & -117440513;
                            z = bd(f | 0, a | 0, 45) | 0;
                            G();
                            f: do if (la(z & 127) | 0) {
                                m = bd(f | 0, a | 0, 52) | 0;
                                G();
                                m = m & 15;
                                if (m | 0) {
                                    g = 1;
                                    while(true){
                                        z = cd(7, 0, (15 - g | 0) * 3 | 0) | 0;
                                        if (!((f & z | 0) == 0 & (k & (G() | 0) | 0) == 0)) break f;
                                        if (g >>> 0 < m >>> 0) g = g + 1 | 0;
                                        else break;
                                    }
                                }
                                a = cd(d | 0, 0, 56) | 0;
                                f = a | f;
                                a = G() | 0 | k;
                                d = i;
                                b[d >> 2] = f;
                                b[d + 4 >> 2] = a;
                                d = j + 2 | 0;
                            }
                            while (0);
                            if ((d | 0) == 7) {
                                z = q + (n << 3) | 0;
                                b[z >> 2] = f;
                                b[z + 4 >> 2] = a & -117440513;
                                n = n + 1 | 0;
                            }
                        }
                        o = o + 1 | 0;
                    }while ((o | 0) != (e | 0));
                    if (s) {
                        p = ((e | 0) < 0) << 31 >> 31;
                        m = cd(u | 0, 0, 52) | 0;
                        o = G() | 0;
                        if (u >>> 0 > 15) {
                            a = 0;
                            f = 0;
                            while(true){
                                do if (!((l | 0) == 0 & (h | 0) == 0)) {
                                    j = bd(l | 0, h | 0, 52) | 0;
                                    G();
                                    j = j & 15;
                                    g = (j | 0) < (u | 0);
                                    j = (j | 0) == (u | 0);
                                    i = g ? 0 : j ? l : 0;
                                    j = g ? 0 : j ? h : 0;
                                    g = ad(i | 0, j | 0, e | 0, p | 0) | 0;
                                    G();
                                    d = 0;
                                    while(true){
                                        if ((d | 0) > (e | 0)) {
                                            y = 98;
                                            break a;
                                        }
                                        z = v + (g << 3) | 0;
                                        k = b[z + 4 >> 2] | 0;
                                        if ((k & -117440513 | 0) == (j | 0) ? (b[z >> 2] | 0) == (i | 0) : 0) {
                                            y = 70;
                                            break;
                                        }
                                        g = (g + 1 | 0) % (e | 0) | 0;
                                        z = v + (g << 3) | 0;
                                        if ((b[z >> 2] | 0) == (i | 0) ? (b[z + 4 >> 2] | 0) == (j | 0) : 0) break;
                                        else d = d + 1 | 0;
                                    }
                                    if ((y | 0) == 70 ? (y = 0, true & (k & 117440512 | 0) == 100663296) : 0) break;
                                    z = c + (f << 3) | 0;
                                    b[z >> 2] = l;
                                    b[z + 4 >> 2] = h;
                                    f = f + 1 | 0;
                                }
                                while (0);
                                a = a + 1 | 0;
                                if ((a | 0) >= (e | 0)) {
                                    e = n;
                                    break e;
                                }
                                h = x + (a << 3) | 0;
                                l = b[h >> 2] | 0;
                                h = b[h + 4 >> 2] | 0;
                            }
                        }
                        a = 0;
                        f = 0;
                        while(true){
                            do if (!((l | 0) == 0 & (h | 0) == 0)) {
                                j = bd(l | 0, h | 0, 52) | 0;
                                G();
                                j = j & 15;
                                if ((j | 0) >= (u | 0)) {
                                    if ((j | 0) != (u | 0)) {
                                        d = l | m;
                                        g = h & -15728641 | o;
                                        if (j >>> 0 < t >>> 0) j = g;
                                        else {
                                            i = u;
                                            do {
                                                z = cd(7, 0, (14 - i | 0) * 3 | 0) | 0;
                                                i = i + 1 | 0;
                                                d = z | d;
                                                g = G() | 0 | g;
                                            }while (i >>> 0 < j >>> 0);
                                            j = g;
                                        }
                                    } else {
                                        d = l;
                                        j = h;
                                    }
                                } else {
                                    d = 0;
                                    j = 0;
                                }
                                i = ad(d | 0, j | 0, e | 0, p | 0) | 0;
                                G();
                                g = 0;
                                while(true){
                                    if ((g | 0) > (e | 0)) {
                                        y = 98;
                                        break a;
                                    }
                                    z = v + (i << 3) | 0;
                                    k = b[z + 4 >> 2] | 0;
                                    if ((k & -117440513 | 0) == (j | 0) ? (b[z >> 2] | 0) == (d | 0) : 0) {
                                        y = 93;
                                        break;
                                    }
                                    i = (i + 1 | 0) % (e | 0) | 0;
                                    z = v + (i << 3) | 0;
                                    if ((b[z >> 2] | 0) == (d | 0) ? (b[z + 4 >> 2] | 0) == (j | 0) : 0) break;
                                    else g = g + 1 | 0;
                                }
                                if ((y | 0) == 93 ? (y = 0, true & (k & 117440512 | 0) == 100663296) : 0) break;
                                z = c + (f << 3) | 0;
                                b[z >> 2] = l;
                                b[z + 4 >> 2] = h;
                                f = f + 1 | 0;
                            }
                            while (0);
                            a = a + 1 | 0;
                            if ((a | 0) >= (e | 0)) {
                                e = n;
                                break e;
                            }
                            h = x + (a << 3) | 0;
                            l = b[h >> 2] | 0;
                            h = b[h + 4 >> 2] | 0;
                        }
                    } else {
                        f = 0;
                        e = n;
                    }
                } else {
                    f = 0;
                    e = 0;
                }
                while (0);
                gd(v | 0, 0, w | 0);
                fd(x | 0, q | 0, e << 3 | 0);
                Wc(q);
                if (!e) break;
                else c = c + (f << 3) | 0;
            }
            if ((y | 0) == 41) {
                Wc(x);
                Wc(v);
                z = -1;
                return z | 0;
            } else if ((y | 0) == 51) {
                Wc(x);
                Wc(v);
                z = -2;
                return z | 0;
            } else if ((y | 0) == 58) {
                Wc(x);
                Wc(v);
                z = -3;
                return z | 0;
            } else if ((y | 0) == 98) {
                Wc(q);
                Wc(x);
                Wc(v);
                z = -1;
                return z | 0;
            } else if ((y | 0) == 99) fd(c | 0, x | 0, e << 3 | 0);
            Wc(x);
            Wc(v);
            z = 0;
            return z | 0;
        }
        function Hb(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            if ((c | 0) <= 0) {
                f = 0;
                return f | 0;
            }
            if ((f | 0) >= 16) {
                g = 0;
                while(true){
                    l = a + (g << 3) | 0;
                    if (!((b[l >> 2] | 0) == 0 & (b[l + 4 >> 2] | 0) == 0)) {
                        g = 14;
                        break;
                    }
                    g = g + 1 | 0;
                    if ((g | 0) >= (c | 0)) {
                        h = 0;
                        g = 16;
                        break;
                    }
                }
                if ((g | 0) == 14) return ((e | 0) > 0 ? -2 : -1) | 0;
                else if ((g | 0) == 16) return h | 0;
            }
            g = 0;
            l = 0;
            a: while(true){
                k = a + (l << 3) | 0;
                i = k;
                h = b[i >> 2] | 0;
                i = b[i + 4 >> 2] | 0;
                do if (!((h | 0) == 0 & (i | 0) == 0)) {
                    if ((g | 0) >= (e | 0)) {
                        h = -1;
                        g = 16;
                        break a;
                    }
                    j = bd(h | 0, i | 0, 52) | 0;
                    G();
                    j = j & 15;
                    if ((j | 0) > (f | 0)) {
                        h = -2;
                        g = 16;
                        break a;
                    }
                    if ((j | 0) == (f | 0)) {
                        k = d + (g << 3) | 0;
                        b[k >> 2] = h;
                        b[k + 4 >> 2] = i;
                        g = g + 1 | 0;
                        break;
                    }
                    h = (sc(7, f - j | 0) | 0) + g | 0;
                    if ((h | 0) > (e | 0)) {
                        h = -1;
                        g = 16;
                        break a;
                    }
                    Db(b[k >> 2] | 0, b[k + 4 >> 2] | 0, f, d + (g << 3) | 0);
                    g = h;
                }
                while (0);
                l = l + 1 | 0;
                if ((l | 0) >= (c | 0)) {
                    h = 0;
                    g = 16;
                    break;
                }
            }
            if ((g | 0) == 16) return h | 0;
            return 0;
        }
        function Ib(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            if ((c | 0) <= 0) {
                d = 0;
                return d | 0;
            }
            if ((d | 0) >= 16) {
                e = 0;
                while(true){
                    h = a + (e << 3) | 0;
                    if (!((b[h >> 2] | 0) == 0 & (b[h + 4 >> 2] | 0) == 0)) {
                        e = -1;
                        f = 13;
                        break;
                    }
                    e = e + 1 | 0;
                    if ((e | 0) >= (c | 0)) {
                        e = 0;
                        f = 13;
                        break;
                    }
                }
                if ((f | 0) == 13) return e | 0;
            }
            e = 0;
            h = 0;
            a: while(true){
                f = a + (h << 3) | 0;
                g = b[f >> 2] | 0;
                f = b[f + 4 >> 2] | 0;
                do if (!((g | 0) == 0 & (f | 0) == 0)) {
                    f = bd(g | 0, f | 0, 52) | 0;
                    G();
                    f = f & 15;
                    if ((f | 0) > (d | 0)) {
                        e = -1;
                        f = 13;
                        break a;
                    }
                    if ((f | 0) == (d | 0)) {
                        e = e + 1 | 0;
                        break;
                    } else {
                        e = (sc(7, d - f | 0) | 0) + e | 0;
                        break;
                    }
                }
                while (0);
                h = h + 1 | 0;
                if ((h | 0) >= (c | 0)) {
                    f = 13;
                    break;
                }
            }
            if ((f | 0) == 13) return e | 0;
            return 0;
        }
        function Jb(a, b) {
            a = a | 0;
            b = b | 0;
            b = bd(a | 0, b | 0, 52) | 0;
            G();
            return b & 1 | 0;
        }
        function Kb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            e = bd(a | 0, b | 0, 52) | 0;
            G();
            e = e & 15;
            if (!e) {
                e = 0;
                return e | 0;
            }
            d = 1;
            while(true){
                c = bd(a | 0, b | 0, (15 - d | 0) * 3 | 0) | 0;
                G();
                c = c & 7;
                if (c | 0) {
                    d = 5;
                    break;
                }
                if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                else {
                    c = 0;
                    d = 5;
                    break;
                }
            }
            if ((d | 0) == 5) return c | 0;
            return 0;
        }
        function Lb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            i = bd(a | 0, b | 0, 52) | 0;
            G();
            i = i & 15;
            if (!i) {
                h = b;
                i = a;
                F(h | 0);
                return i | 0;
            }
            h = 1;
            c = 0;
            while(true){
                f = (15 - h | 0) * 3 | 0;
                d = cd(7, 0, f | 0) | 0;
                e = G() | 0;
                g = bd(a | 0, b | 0, f | 0) | 0;
                G();
                f = cd(Pa(g & 7) | 0, 0, f | 0) | 0;
                g = G() | 0;
                a = f | a & ~d;
                b = g | b & ~e;
                a: do if (!c) {
                    if (!((f & d | 0) == 0 & (g & e | 0) == 0)) {
                        d = bd(a | 0, b | 0, 52) | 0;
                        G();
                        d = d & 15;
                        if (!d) c = 1;
                        else {
                            c = 1;
                            b: while(true){
                                g = bd(a | 0, b | 0, (15 - c | 0) * 3 | 0) | 0;
                                G();
                                switch(g & 7){
                                    case 1:
                                        break b;
                                    case 0:
                                        break;
                                    default:
                                        c = 1;
                                        break a;
                                }
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break a;
                                }
                            }
                            c = 1;
                            while(true){
                                g = (15 - c | 0) * 3 | 0;
                                e = bd(a | 0, b | 0, g | 0) | 0;
                                G();
                                f = cd(7, 0, g | 0) | 0;
                                b = b & ~(G() | 0);
                                g = cd(Pa(e & 7) | 0, 0, g | 0) | 0;
                                a = a & ~f | g;
                                b = b | (G() | 0);
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break;
                                }
                            }
                        }
                    } else c = 0;
                }
                while (0);
                if (h >>> 0 < i >>> 0) h = h + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Mb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0;
            d = bd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if (!d) {
                c = b;
                d = a;
                F(c | 0);
                return d | 0;
            }
            c = 1;
            while(true){
                f = (15 - c | 0) * 3 | 0;
                g = bd(a | 0, b | 0, f | 0) | 0;
                G();
                e = cd(7, 0, f | 0) | 0;
                b = b & ~(G() | 0);
                f = cd(Pa(g & 7) | 0, 0, f | 0) | 0;
                a = f | a & ~e;
                b = G() | 0 | b;
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Nb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            i = bd(a | 0, b | 0, 52) | 0;
            G();
            i = i & 15;
            if (!i) {
                h = b;
                i = a;
                F(h | 0);
                return i | 0;
            }
            h = 1;
            c = 0;
            while(true){
                f = (15 - h | 0) * 3 | 0;
                d = cd(7, 0, f | 0) | 0;
                e = G() | 0;
                g = bd(a | 0, b | 0, f | 0) | 0;
                G();
                f = cd(Qa(g & 7) | 0, 0, f | 0) | 0;
                g = G() | 0;
                a = f | a & ~d;
                b = g | b & ~e;
                a: do if (!c) {
                    if (!((f & d | 0) == 0 & (g & e | 0) == 0)) {
                        d = bd(a | 0, b | 0, 52) | 0;
                        G();
                        d = d & 15;
                        if (!d) c = 1;
                        else {
                            c = 1;
                            b: while(true){
                                g = bd(a | 0, b | 0, (15 - c | 0) * 3 | 0) | 0;
                                G();
                                switch(g & 7){
                                    case 1:
                                        break b;
                                    case 0:
                                        break;
                                    default:
                                        c = 1;
                                        break a;
                                }
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break a;
                                }
                            }
                            c = 1;
                            while(true){
                                e = (15 - c | 0) * 3 | 0;
                                f = cd(7, 0, e | 0) | 0;
                                g = b & ~(G() | 0);
                                b = bd(a | 0, b | 0, e | 0) | 0;
                                G();
                                b = cd(Qa(b & 7) | 0, 0, e | 0) | 0;
                                a = a & ~f | b;
                                b = g | (G() | 0);
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break;
                                }
                            }
                        }
                    } else c = 0;
                }
                while (0);
                if (h >>> 0 < i >>> 0) h = h + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Ob(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0;
            d = bd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if (!d) {
                c = b;
                d = a;
                F(c | 0);
                return d | 0;
            }
            c = 1;
            while(true){
                g = (15 - c | 0) * 3 | 0;
                f = cd(7, 0, g | 0) | 0;
                e = b & ~(G() | 0);
                b = bd(a | 0, b | 0, g | 0) | 0;
                G();
                b = cd(Qa(b & 7) | 0, 0, g | 0) | 0;
                a = b | a & ~f;
                b = G() | 0 | e;
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else break;
            }
            F(b | 0);
            return a | 0;
        }
        function Pb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            j = S;
            S = S + 64 | 0;
            i = j + 40 | 0;
            e = j + 24 | 0;
            f = j + 12 | 0;
            g = j;
            cd(c | 0, 0, 52);
            d = G() | 134225919;
            if (!c) {
                if ((b[a + 4 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    F(h | 0);
                    S = j;
                    return i | 0;
                }
                if ((b[a + 8 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    F(h | 0);
                    S = j;
                    return i | 0;
                }
                if ((b[a + 12 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    F(h | 0);
                    S = j;
                    return i | 0;
                }
                cd(na(a) | 0, 0, 45);
                h = G() | 0 | d;
                i = -1;
                F(h | 0);
                S = j;
                return i | 0;
            }
            b[i >> 2] = b[a >> 2];
            b[i + 4 >> 2] = b[a + 4 >> 2];
            b[i + 8 >> 2] = b[a + 8 >> 2];
            b[i + 12 >> 2] = b[a + 12 >> 2];
            h = i + 4 | 0;
            if ((c | 0) > 0) {
                a = -1;
                while(true){
                    b[e >> 2] = b[h >> 2];
                    b[e + 4 >> 2] = b[h + 4 >> 2];
                    b[e + 8 >> 2] = b[h + 8 >> 2];
                    if (!(c & 1)) {
                        Ja(h);
                        b[f >> 2] = b[h >> 2];
                        b[f + 4 >> 2] = b[h + 4 >> 2];
                        b[f + 8 >> 2] = b[h + 8 >> 2];
                        La(f);
                    } else {
                        Ia(h);
                        b[f >> 2] = b[h >> 2];
                        b[f + 4 >> 2] = b[h + 4 >> 2];
                        b[f + 8 >> 2] = b[h + 8 >> 2];
                        Ka(f);
                    }
                    Fa(e, f, g);
                    Ca(g);
                    l = (15 - c | 0) * 3 | 0;
                    k = cd(7, 0, l | 0) | 0;
                    d = d & ~(G() | 0);
                    l = cd(Ha(g) | 0, 0, l | 0) | 0;
                    a = l | a & ~k;
                    d = G() | 0 | d;
                    if ((c | 0) > 1) c = c + -1 | 0;
                    else break;
                }
            } else a = -1;
            a: do if (((b[h >> 2] | 0) <= 2 ? (b[i + 8 >> 2] | 0) <= 2 : 0) ? (b[i + 12 >> 2] | 0) <= 2 : 0) {
                e = na(i) | 0;
                c = cd(e | 0, 0, 45) | 0;
                c = c | a;
                a = G() | 0 | d & -1040385;
                g = oa(i) | 0;
                if (!(la(e) | 0)) {
                    if ((g | 0) <= 0) break;
                    f = 0;
                    while(true){
                        e = bd(c | 0, a | 0, 52) | 0;
                        G();
                        e = e & 15;
                        if (e) {
                            d = 1;
                            while(true){
                                l = (15 - d | 0) * 3 | 0;
                                i = bd(c | 0, a | 0, l | 0) | 0;
                                G();
                                k = cd(7, 0, l | 0) | 0;
                                a = a & ~(G() | 0);
                                l = cd(Pa(i & 7) | 0, 0, l | 0) | 0;
                                c = c & ~k | l;
                                a = a | (G() | 0);
                                if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                                else break;
                            }
                        }
                        f = f + 1 | 0;
                        if ((f | 0) == (g | 0)) break a;
                    }
                }
                f = bd(c | 0, a | 0, 52) | 0;
                G();
                f = f & 15;
                b: do if (f) {
                    d = 1;
                    c: while(true){
                        l = bd(c | 0, a | 0, (15 - d | 0) * 3 | 0) | 0;
                        G();
                        switch(l & 7){
                            case 1:
                                break c;
                            case 0:
                                break;
                            default:
                                break b;
                        }
                        if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                        else break b;
                    }
                    if (ra(e, b[i >> 2] | 0) | 0) {
                        d = 1;
                        while(true){
                            i = (15 - d | 0) * 3 | 0;
                            k = cd(7, 0, i | 0) | 0;
                            l = a & ~(G() | 0);
                            a = bd(c | 0, a | 0, i | 0) | 0;
                            G();
                            a = cd(Qa(a & 7) | 0, 0, i | 0) | 0;
                            c = c & ~k | a;
                            a = l | (G() | 0);
                            if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                            else break;
                        }
                    } else {
                        d = 1;
                        while(true){
                            l = (15 - d | 0) * 3 | 0;
                            i = bd(c | 0, a | 0, l | 0) | 0;
                            G();
                            k = cd(7, 0, l | 0) | 0;
                            a = a & ~(G() | 0);
                            l = cd(Pa(i & 7) | 0, 0, l | 0) | 0;
                            c = c & ~k | l;
                            a = a | (G() | 0);
                            if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                            else break;
                        }
                    }
                }
                while (0);
                if ((g | 0) > 0) {
                    d = 0;
                    do {
                        c = Lb(c, a) | 0;
                        a = G() | 0;
                        d = d + 1 | 0;
                    }while ((d | 0) != (g | 0));
                }
            } else {
                c = 0;
                a = 0;
            }
            while (0);
            k = a;
            l = c;
            F(k | 0);
            S = j;
            return l | 0;
        }
        function Qb(a) {
            a = a | 0;
            return (a | 0) % 2 | 0;
        }
        function Rb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            e = S;
            S = S + 16 | 0;
            d = e;
            if ((c >>> 0 <= 15 ? !((b[a + 4 >> 2] & 2146435072 | 0) == 2146435072) : 0) ? !((b[a + 8 + 4 >> 2] & 2146435072 | 0) == 2146435072) : 0) {
                Ya(a, c, d);
                c = Pb(d, c) | 0;
                a = G() | 0;
            } else {
                a = 0;
                c = 0;
            }
            F(a | 0);
            S = e;
            return c | 0;
        }
        function Sb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            f = d + 4 | 0;
            g = bd(a | 0, c | 0, 52) | 0;
            G();
            g = g & 15;
            h = bd(a | 0, c | 0, 45) | 0;
            G();
            e = (g | 0) == 0;
            if (!(la(h & 127) | 0)) {
                if (e) {
                    h = 0;
                    return h | 0;
                }
                if ((b[f >> 2] | 0) == 0 ? (b[d + 8 >> 2] | 0) == 0 : 0) e = (b[d + 12 >> 2] | 0) != 0 & 1;
                else e = 1;
            } else if (e) {
                h = 1;
                return h | 0;
            } else e = 1;
            d = 1;
            while(true){
                if (!(d & 1)) La(f);
                else Ka(f);
                h = bd(a | 0, c | 0, (15 - d | 0) * 3 | 0) | 0;
                G();
                Ma(f, h & 7);
                if (d >>> 0 < g >>> 0) d = d + 1 | 0;
                else break;
            }
            return e | 0;
        }
        function Tb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            l = S;
            S = S + 16 | 0;
            j = l;
            k = bd(a | 0, c | 0, 45) | 0;
            G();
            k = k & 127;
            a: do if ((la(k) | 0) != 0 ? (g = bd(a | 0, c | 0, 52) | 0, G(), g = g & 15, (g | 0) != 0) : 0) {
                e = 1;
                b: while(true){
                    i = bd(a | 0, c | 0, (15 - e | 0) * 3 | 0) | 0;
                    G();
                    switch(i & 7){
                        case 5:
                            break b;
                        case 0:
                            break;
                        default:
                            e = c;
                            break a;
                    }
                    if (e >>> 0 < g >>> 0) e = e + 1 | 0;
                    else {
                        e = c;
                        break a;
                    }
                }
                f = 1;
                e = c;
                while(true){
                    c = (15 - f | 0) * 3 | 0;
                    h = cd(7, 0, c | 0) | 0;
                    i = e & ~(G() | 0);
                    e = bd(a | 0, e | 0, c | 0) | 0;
                    G();
                    e = cd(Qa(e & 7) | 0, 0, c | 0) | 0;
                    a = a & ~h | e;
                    e = i | (G() | 0);
                    if (f >>> 0 < g >>> 0) f = f + 1 | 0;
                    else break;
                }
            } else e = c;
            while (0);
            i = 7728 + (k * 28 | 0) | 0;
            b[d >> 2] = b[i >> 2];
            b[d + 4 >> 2] = b[i + 4 >> 2];
            b[d + 8 >> 2] = b[i + 8 >> 2];
            b[d + 12 >> 2] = b[i + 12 >> 2];
            if (!(Sb(a, e, d) | 0)) {
                S = l;
                return;
            }
            h = d + 4 | 0;
            b[j >> 2] = b[h >> 2];
            b[j + 4 >> 2] = b[h + 4 >> 2];
            b[j + 8 >> 2] = b[h + 8 >> 2];
            g = bd(a | 0, e | 0, 52) | 0;
            G();
            i = g & 15;
            if (!(g & 1)) g = i;
            else {
                La(h);
                g = i + 1 | 0;
            }
            if (!(la(k) | 0)) e = 0;
            else {
                c: do if (!i) e = 0;
                else {
                    c = 1;
                    while(true){
                        f = bd(a | 0, e | 0, (15 - c | 0) * 3 | 0) | 0;
                        G();
                        f = f & 7;
                        if (f | 0) {
                            e = f;
                            break c;
                        }
                        if (c >>> 0 < i >>> 0) c = c + 1 | 0;
                        else {
                            e = 0;
                            break;
                        }
                    }
                }
                while (0);
                e = (e | 0) == 4 & 1;
            }
            if (!(cb(d, g, e, 0) | 0)) {
                if ((g | 0) != (i | 0)) {
                    b[h >> 2] = b[j >> 2];
                    b[h + 4 >> 2] = b[j + 4 >> 2];
                    b[h + 8 >> 2] = b[j + 8 >> 2];
                }
            } else {
                if (la(k) | 0) {
                    do ;
                    while ((cb(d, g, 0, 0) | 0) != 0);
                }
                if ((g | 0) != (i | 0)) Ja(h);
            }
            S = l;
            return;
        }
        function Ub(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = S;
            S = S + 16 | 0;
            e = d;
            Tb(a, b, e);
            b = bd(a | 0, b | 0, 52) | 0;
            G();
            $a(e, b & 15, c);
            S = d;
            return;
        }
        function Vb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            g = S;
            S = S + 16 | 0;
            f = g;
            Tb(a, b, f);
            d = bd(a | 0, b | 0, 45) | 0;
            G();
            d = (la(d & 127) | 0) == 0;
            e = bd(a | 0, b | 0, 52) | 0;
            G();
            e = e & 15;
            a: do if (!d) {
                if (e | 0) {
                    d = 1;
                    while(true){
                        h = cd(7, 0, (15 - d | 0) * 3 | 0) | 0;
                        if (!((h & a | 0) == 0 & ((G() | 0) & b | 0) == 0)) break a;
                        if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                        else break;
                    }
                }
                ab(f, e, 0, 5, c);
                S = g;
                return;
            }
            while (0);
            eb(f, e, 0, 6, c);
            S = g;
            return;
        }
        function Wb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            d = bd(a | 0, b | 0, 45) | 0;
            G();
            if (!(la(d & 127) | 0)) {
                d = 2;
                return d | 0;
            }
            d = bd(a | 0, b | 0, 52) | 0;
            G();
            d = d & 15;
            if (!d) {
                d = 5;
                return d | 0;
            }
            c = 1;
            while(true){
                e = cd(7, 0, (15 - c | 0) * 3 | 0) | 0;
                if (!((e & a | 0) == 0 & ((G() | 0) & b | 0) == 0)) {
                    c = 2;
                    a = 6;
                    break;
                }
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else {
                    c = 5;
                    a = 6;
                    break;
                }
            }
            if ((a | 0) == 6) return c | 0;
            return 0;
        }
        function Xb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            m = S;
            S = S + 128 | 0;
            k = m + 112 | 0;
            g = m + 96 | 0;
            l = m;
            f = bd(a | 0, c | 0, 52) | 0;
            G();
            i = f & 15;
            b[k >> 2] = i;
            h = bd(a | 0, c | 0, 45) | 0;
            G();
            h = h & 127;
            a: do if (la(h) | 0) {
                if (i | 0) {
                    e = 1;
                    while(true){
                        j = cd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        if (!((j & a | 0) == 0 & ((G() | 0) & c | 0) == 0)) {
                            f = 0;
                            break a;
                        }
                        if (e >>> 0 < i >>> 0) e = e + 1 | 0;
                        else break;
                    }
                }
                if (!(f & 1)) {
                    j = cd(i + 1 | 0, 0, 52) | 0;
                    l = G() | 0 | c & -15728641;
                    k = cd(7, 0, (14 - i | 0) * 3 | 0) | 0;
                    Xb((j | a) & ~k, l & ~(G() | 0), d);
                    S = m;
                    return;
                } else f = 1;
            } else f = 0;
            while (0);
            Tb(a, c, g);
            if (f) {
                bb(g, k, l);
                j = 5;
            } else {
                fb(g, k, l);
                j = 6;
            }
            b: do if (la(h) | 0) {
                if (!i) e = 20;
                else {
                    e = 1;
                    while(true){
                        h = cd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        if (!((h & a | 0) == 0 & ((G() | 0) & c | 0) == 0)) {
                            e = 8;
                            break b;
                        }
                        if (e >>> 0 < i >>> 0) e = e + 1 | 0;
                        else {
                            e = 20;
                            break;
                        }
                    }
                }
            } else e = 8;
            while (0);
            gd(d | 0, -1, e | 0);
            if (f) {
                f = 0;
                do {
                    g = l + (f << 4) | 0;
                    db(g, b[k >> 2] | 0);
                    g = b[g >> 2] | 0;
                    e = 0;
                    while(true){
                        h = d + (e << 2) | 0;
                        i = b[h >> 2] | 0;
                        if ((i | 0) == -1 | (i | 0) == (g | 0)) break;
                        else e = e + 1 | 0;
                    }
                    b[h >> 2] = g;
                    f = f + 1 | 0;
                }while ((f | 0) != (j | 0));
            } else {
                f = 0;
                do {
                    g = l + (f << 4) | 0;
                    cb(g, b[k >> 2] | 0, 0, 1);
                    g = b[g >> 2] | 0;
                    e = 0;
                    while(true){
                        h = d + (e << 2) | 0;
                        i = b[h >> 2] | 0;
                        if ((i | 0) == -1 | (i | 0) == (g | 0)) break;
                        else e = e + 1 | 0;
                    }
                    b[h >> 2] = g;
                    f = f + 1 | 0;
                }while ((f | 0) != (j | 0));
            }
            S = m;
            return;
        }
        function Yb() {
            return 12;
        }
        function Zb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            cd(a | 0, 0, 52);
            i = G() | 134225919;
            if ((a | 0) < 1) {
                e = 0;
                d = 0;
                do {
                    if (la(e) | 0) {
                        cd(e | 0, 0, 45);
                        h = i | (G() | 0);
                        a = c + (d << 3) | 0;
                        b[a >> 2] = -1;
                        b[a + 4 >> 2] = h;
                        d = d + 1 | 0;
                    }
                    e = e + 1 | 0;
                }while ((e | 0) != 122);
                return;
            }
            h = 0;
            d = 0;
            do {
                if (la(h) | 0) {
                    cd(h | 0, 0, 45);
                    e = 1;
                    f = -1;
                    g = i | (G() | 0);
                    while(true){
                        j = cd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        f = f & ~j;
                        g = g & ~(G() | 0);
                        if ((e | 0) == (a | 0)) break;
                        else e = e + 1 | 0;
                    }
                    j = c + (d << 3) | 0;
                    b[j >> 2] = f;
                    b[j + 4 >> 2] = g;
                    d = d + 1 | 0;
                }
                h = h + 1 | 0;
            }while ((h | 0) != 122);
            return;
        }
        function _b(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            i = S;
            S = S + 64 | 0;
            h = i;
            if ((a | 0) == (d | 0) & (c | 0) == (e | 0) | (false | (c & 2013265920 | 0) != 134217728 | (false | (e & 2013265920 | 0) != 134217728))) {
                h = 0;
                S = i;
                return h | 0;
            }
            f = bd(a | 0, c | 0, 52) | 0;
            G();
            f = f & 15;
            g = bd(d | 0, e | 0, 52) | 0;
            G();
            if ((f | 0) != (g & 15 | 0)) {
                h = 0;
                S = i;
                return h | 0;
            }
            g = f + -1 | 0;
            if (f >>> 0 > 1 ? (k = Bb(a, c, g) | 0, j = G() | 0, g = Bb(d, e, g) | 0, (k | 0) == (g | 0) & (j | 0) == (G() | 0)) : 0) {
                g = (f ^ 15) * 3 | 0;
                f = bd(a | 0, c | 0, g | 0) | 0;
                G();
                f = f & 7;
                g = bd(d | 0, e | 0, g | 0) | 0;
                G();
                g = g & 7;
                if ((f | 0) == 0 | (g | 0) == 0) {
                    k = 1;
                    S = i;
                    return k | 0;
                }
                if ((b[21136 + (f << 2) >> 2] | 0) == (g | 0)) {
                    k = 1;
                    S = i;
                    return k | 0;
                }
                if ((b[21168 + (f << 2) >> 2] | 0) == (g | 0)) {
                    k = 1;
                    S = i;
                    return k | 0;
                }
            }
            f = h;
            g = f + 56 | 0;
            do {
                b[f >> 2] = 0;
                f = f + 4 | 0;
            }while ((f | 0) < (g | 0));
            $(a, c, 1, h);
            k = h;
            if (((((!((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0) ? (k = h + 8 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 16 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 24 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 32 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (k = h + 40 | 0, !((b[k >> 2] | 0) == (d | 0) ? (b[k + 4 >> 2] | 0) == (e | 0) : 0)) : 0) {
                f = h + 48 | 0;
                f = ((b[f >> 2] | 0) == (d | 0) ? (b[f + 4 >> 2] | 0) == (e | 0) : 0) & 1;
            } else f = 1;
            k = f;
            S = i;
            return k | 0;
        }
        function $b(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            k = S;
            S = S + 16 | 0;
            h = k;
            if (!(_b(a, c, d, e) | 0)) {
                i = 0;
                j = 0;
                F(i | 0);
                S = k;
                return j | 0;
            }
            i = c & -2130706433;
            f = (Eb(a, c) | 0) == 0;
            f = f ? 1 : 2;
            while(true){
                b[h >> 2] = 0;
                l = da(a, c, f, h) | 0;
                g = f + 1 | 0;
                if ((l | 0) == (d | 0) & (G() | 0) == (e | 0)) break;
                if (g >>> 0 < 7) f = g;
                else {
                    f = 0;
                    a = 0;
                    j = 6;
                    break;
                }
            }
            if ((j | 0) == 6) {
                F(f | 0);
                S = k;
                return a | 0;
            }
            l = cd(f | 0, 0, 56) | 0;
            j = i | (G() | 0) | 268435456;
            l = a | l;
            F(j | 0);
            S = k;
            return l | 0;
        }
        function ac(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            c = true & (b & 2013265920 | 0) == 268435456;
            F((c ? b & -2130706433 | 134217728 : 0) | 0);
            return (c ? a : 0) | 0;
        }
        function bc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0;
            e = S;
            S = S + 16 | 0;
            d = e;
            if (!(true & (c & 2013265920 | 0) == 268435456)) {
                c = 0;
                d = 0;
                F(c | 0);
                S = e;
                return d | 0;
            }
            f = bd(a | 0, c | 0, 56) | 0;
            G();
            b[d >> 2] = 0;
            d = da(a, c & -2130706433 | 134217728, f & 7, d) | 0;
            c = G() | 0;
            F(c | 0);
            S = e;
            return d | 0;
        }
        function cc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            if (!(true & (b & 2013265920 | 0) == 268435456)) {
                c = 0;
                return c | 0;
            }
            c = bd(a | 0, b | 0, 56) | 0;
            G();
            switch(c & 7){
                case 0:
                case 7:
                    c = 0;
                    return c | 0;
                default:
            }
            c = b & -2130706433 | 134217728;
            if (true & (b & 117440512 | 0) == 16777216 & (Eb(a, c) | 0) != 0) {
                c = 0;
                return c | 0;
            }
            c = Ab(a, c) | 0;
            return c | 0;
        }
        function dc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            g = S;
            S = S + 16 | 0;
            e = g;
            h = true & (c & 2013265920 | 0) == 268435456;
            f = c & -2130706433 | 134217728;
            i = d;
            b[i >> 2] = h ? a : 0;
            b[i + 4 >> 2] = h ? f : 0;
            if (h) {
                c = bd(a | 0, c | 0, 56) | 0;
                G();
                b[e >> 2] = 0;
                a = da(a, f, c & 7, e) | 0;
                c = G() | 0;
            } else {
                a = 0;
                c = 0;
            }
            i = d + 8 | 0;
            b[i >> 2] = a;
            b[i + 4 >> 2] = c;
            S = g;
            return;
        }
        function ec(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            f = (Eb(a, c) | 0) == 0;
            c = c & -2130706433;
            e = d;
            b[e >> 2] = f ? a : 0;
            b[e + 4 >> 2] = f ? c | 285212672 : 0;
            e = d + 8 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 301989888;
            e = d + 16 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 318767104;
            e = d + 24 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 335544320;
            e = d + 32 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 352321536;
            d = d + 40 | 0;
            b[d >> 2] = a;
            b[d + 4 >> 2] = c | 369098752;
            return;
        }
        function fc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            h = S;
            S = S + 16 | 0;
            g = h;
            e = bd(a | 0, c | 0, 56) | 0;
            G();
            i = true & (c & 2013265920 | 0) == 268435456;
            f = i ? a : 0;
            a = i ? c & -2130706433 | 134217728 : 0;
            c = Kc(f, a, e & 7) | 0;
            if ((c | 0) == -1) {
                b[d >> 2] = 0;
                S = h;
                return;
            }
            Tb(f, a, g);
            e = bd(f | 0, a | 0, 52) | 0;
            G();
            e = e & 15;
            if (!(Eb(f, a) | 0)) eb(g, e, c, 2, d);
            else ab(g, e, c, 2, d);
            S = h;
            return;
        }
        function gc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            c = Xc(1, 12) | 0;
            if (!c) H(22691, 22646, 49, 22704);
            d = a + 4 | 0;
            e = b[d >> 2] | 0;
            if (e | 0) {
                e = e + 8 | 0;
                b[e >> 2] = c;
                b[d >> 2] = c;
                return c | 0;
            }
            if (b[a >> 2] | 0) H(22721, 22646, 61, 22744);
            e = a;
            b[e >> 2] = c;
            b[d >> 2] = c;
            return c | 0;
        }
        function hc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            e = Vc(24) | 0;
            if (!e) H(22758, 22646, 78, 22772);
            b[e >> 2] = b[c >> 2];
            b[e + 4 >> 2] = b[c + 4 >> 2];
            b[e + 8 >> 2] = b[c + 8 >> 2];
            b[e + 12 >> 2] = b[c + 12 >> 2];
            b[e + 16 >> 2] = 0;
            c = a + 4 | 0;
            d = b[c >> 2] | 0;
            if (d | 0) {
                b[d + 16 >> 2] = e;
                b[c >> 2] = e;
                return e | 0;
            }
            if (b[a >> 2] | 0) H(22787, 22646, 82, 22772);
            b[a >> 2] = e;
            b[c >> 2] = e;
            return e | 0;
        }
        function ic(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0;
            if (!a) return;
            e = 1;
            while(true){
                c = b[a >> 2] | 0;
                if (c | 0) do {
                    d = b[c >> 2] | 0;
                    if (d | 0) do {
                        f = d;
                        d = b[d + 16 >> 2] | 0;
                        Wc(f);
                    }while ((d | 0) != 0);
                    f = c;
                    c = b[c + 8 >> 2] | 0;
                    Wc(f);
                }while ((c | 0) != 0);
                c = a;
                a = b[a + 8 >> 2] | 0;
                if (!e) Wc(c);
                if (!a) break;
                else e = 0;
            }
            return;
        }
        function jc(a) {
            a = a | 0;
            var c = 0, d = 0, f = 0, g = 0, h = 0.0, i = 0, j = 0.0, k = 0.0, l = 0, m = 0, n = 0, o = 0, p = 0, r = 0, s = 0.0, t = 0.0, u = 0.0, v = 0.0, w = 0.0, x = 0.0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, I = 0, J = 0, K = 0;
            g = a + 8 | 0;
            if (b[g >> 2] | 0) {
                K = 1;
                return K | 0;
            }
            f = b[a >> 2] | 0;
            if (!f) {
                K = 0;
                return K | 0;
            }
            c = f;
            d = 0;
            do {
                d = d + 1 | 0;
                c = b[c + 8 >> 2] | 0;
            }while ((c | 0) != 0);
            if (d >>> 0 < 2) {
                K = 0;
                return K | 0;
            }
            I = Vc(d << 2) | 0;
            if (!I) H(22807, 22646, 317, 22826);
            G = Vc(d << 5) | 0;
            if (!G) H(22848, 22646, 321, 22826);
            b[a >> 2] = 0;
            z = a + 4 | 0;
            b[z >> 2] = 0;
            b[g >> 2] = 0;
            d = 0;
            F = 0;
            y = 0;
            n = 0;
            a: while(true){
                m = b[f >> 2] | 0;
                if (m) {
                    h = 0.0;
                    i = m;
                    do {
                        k = +e[i + 8 >> 3];
                        c = i;
                        i = b[i + 16 >> 2] | 0;
                        l = (i | 0) == 0;
                        g = l ? m : i;
                        j = +e[g + 8 >> 3];
                        if (+q(+(k - j)) > 3.141592653589793) {
                            K = 14;
                            break;
                        }
                        h = h + (j - k) * (+e[c >> 3] + +e[g >> 3]);
                    }while (!l);
                    if ((K | 0) == 14) {
                        K = 0;
                        h = 0.0;
                        c = m;
                        do {
                            x = +e[c + 8 >> 3];
                            E = c + 16 | 0;
                            D = b[E >> 2] | 0;
                            D = (D | 0) == 0 ? m : D;
                            w = +e[D + 8 >> 3];
                            h = h + (+e[c >> 3] + +e[D >> 3]) * ((w < 0.0 ? w + 6.283185307179586 : w) - (x < 0.0 ? x + 6.283185307179586 : x));
                            c = b[((c | 0) == 0 ? f : E) >> 2] | 0;
                        }while ((c | 0) != 0);
                    }
                    if (h > 0.0) {
                        b[I + (F << 2) >> 2] = f;
                        F = F + 1 | 0;
                        g = y;
                        c = n;
                    } else K = 19;
                } else K = 19;
                if ((K | 0) == 19) {
                    K = 0;
                    do if (!d) {
                        if (!n) {
                            if (!(b[a >> 2] | 0)) {
                                g = z;
                                i = a;
                                c = f;
                                d = a;
                                break;
                            } else {
                                K = 27;
                                break a;
                            }
                        } else {
                            g = z;
                            i = n + 8 | 0;
                            c = f;
                            d = a;
                            break;
                        }
                    } else {
                        c = d + 8 | 0;
                        if (b[c >> 2] | 0) {
                            K = 21;
                            break a;
                        }
                        d = Xc(1, 12) | 0;
                        if (!d) {
                            K = 23;
                            break a;
                        }
                        b[c >> 2] = d;
                        g = d + 4 | 0;
                        i = d;
                        c = n;
                    }
                    while (0);
                    b[i >> 2] = f;
                    b[g >> 2] = f;
                    i = G + (y << 5) | 0;
                    l = b[f >> 2] | 0;
                    if (l) {
                        m = G + (y << 5) + 8 | 0;
                        e[m >> 3] = 1797693134862315708145274.0e284;
                        n = G + (y << 5) + 24 | 0;
                        e[n >> 3] = 1797693134862315708145274.0e284;
                        e[i >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        o = G + (y << 5) + 16 | 0;
                        e[o >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        u = 1797693134862315708145274.0e284;
                        v = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        g = 0;
                        p = l;
                        k = 1797693134862315708145274.0e284;
                        s = 1797693134862315708145274.0e284;
                        t = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        j = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        while(true){
                            h = +e[p >> 3];
                            x = +e[p + 8 >> 3];
                            p = b[p + 16 >> 2] | 0;
                            r = (p | 0) == 0;
                            w = +e[(r ? l : p) + 8 >> 3];
                            if (h < k) {
                                e[m >> 3] = h;
                                k = h;
                            }
                            if (x < s) {
                                e[n >> 3] = x;
                                s = x;
                            }
                            if (h > t) e[i >> 3] = h;
                            else h = t;
                            if (x > j) {
                                e[o >> 3] = x;
                                j = x;
                            }
                            u = x > 0.0 & x < u ? x : u;
                            v = x < 0.0 & x > v ? x : v;
                            g = g | +q(+(x - w)) > 3.141592653589793;
                            if (r) break;
                            else t = h;
                        }
                        if (g) {
                            e[o >> 3] = v;
                            e[n >> 3] = u;
                        }
                    } else {
                        b[i >> 2] = 0;
                        b[i + 4 >> 2] = 0;
                        b[i + 8 >> 2] = 0;
                        b[i + 12 >> 2] = 0;
                        b[i + 16 >> 2] = 0;
                        b[i + 20 >> 2] = 0;
                        b[i + 24 >> 2] = 0;
                        b[i + 28 >> 2] = 0;
                    }
                    g = y + 1 | 0;
                }
                E = f + 8 | 0;
                f = b[E >> 2] | 0;
                b[E >> 2] = 0;
                if (!f) {
                    K = 45;
                    break;
                } else {
                    y = g;
                    n = c;
                }
            }
            if ((K | 0) == 21) H(22624, 22646, 35, 22658);
            else if ((K | 0) == 23) H(22678, 22646, 37, 22658);
            else if ((K | 0) == 27) H(22721, 22646, 61, 22744);
            else if ((K | 0) == 45) {
                b: do if ((F | 0) > 0) {
                    E = (g | 0) == 0;
                    C = g << 2;
                    D = (a | 0) == 0;
                    B = 0;
                    c = 0;
                    while(true){
                        A = b[I + (B << 2) >> 2] | 0;
                        if (!E) {
                            y = Vc(C) | 0;
                            if (!y) {
                                K = 50;
                                break;
                            }
                            z = Vc(C) | 0;
                            if (!z) {
                                K = 52;
                                break;
                            }
                            c: do if (!D) {
                                g = 0;
                                d = 0;
                                i = a;
                                while(true){
                                    f = G + (g << 5) | 0;
                                    if (kc(b[i >> 2] | 0, f, b[A >> 2] | 0) | 0) {
                                        b[y + (d << 2) >> 2] = i;
                                        b[z + (d << 2) >> 2] = f;
                                        r = d + 1 | 0;
                                    } else r = d;
                                    i = b[i + 8 >> 2] | 0;
                                    if (!i) break;
                                    else {
                                        g = g + 1 | 0;
                                        d = r;
                                    }
                                }
                                if ((r | 0) > 0) {
                                    f = b[y >> 2] | 0;
                                    if ((r | 0) == 1) d = f;
                                    else {
                                        o = 0;
                                        p = -1;
                                        d = f;
                                        n = f;
                                        while(true){
                                            l = b[n >> 2] | 0;
                                            f = 0;
                                            i = 0;
                                            while(true){
                                                g = b[b[y + (i << 2) >> 2] >> 2] | 0;
                                                if ((g | 0) == (l | 0)) m = f;
                                                else m = f + ((kc(g, b[z + (i << 2) >> 2] | 0, b[l >> 2] | 0) | 0) & 1) | 0;
                                                i = i + 1 | 0;
                                                if ((i | 0) == (r | 0)) break;
                                                else f = m;
                                            }
                                            g = (m | 0) > (p | 0);
                                            d = g ? n : d;
                                            f = o + 1 | 0;
                                            if ((f | 0) == (r | 0)) break c;
                                            o = f;
                                            p = g ? m : p;
                                            n = b[y + (f << 2) >> 2] | 0;
                                        }
                                    }
                                } else d = 0;
                            } else d = 0;
                            while (0);
                            Wc(y);
                            Wc(z);
                            if (d) {
                                g = d + 4 | 0;
                                f = b[g >> 2] | 0;
                                if (!f) {
                                    if (b[d >> 2] | 0) {
                                        K = 70;
                                        break;
                                    }
                                } else d = f + 8 | 0;
                                b[d >> 2] = A;
                                b[g >> 2] = A;
                            } else K = 73;
                        } else K = 73;
                        if ((K | 0) == 73) {
                            K = 0;
                            c = b[A >> 2] | 0;
                            if (c | 0) do {
                                z = c;
                                c = b[c + 16 >> 2] | 0;
                                Wc(z);
                            }while ((c | 0) != 0);
                            Wc(A);
                            c = 2;
                        }
                        B = B + 1 | 0;
                        if ((B | 0) >= (F | 0)) {
                            J = c;
                            break b;
                        }
                    }
                    if ((K | 0) == 50) H(22863, 22646, 249, 22882);
                    else if ((K | 0) == 52) H(22901, 22646, 252, 22882);
                    else if ((K | 0) == 70) H(22721, 22646, 61, 22744);
                } else J = 0;
                while (0);
                Wc(I);
                Wc(G);
                K = J;
                return K | 0;
            }
            return 0;
        }
        function kc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0;
            if (!(xa(c, d) | 0)) {
                a = 0;
                return a | 0;
            }
            c = wa(c) | 0;
            l = +e[d >> 3];
            f = +e[d + 8 >> 3];
            f = c & f < 0.0 ? f + 6.283185307179586 : f;
            a = b[a >> 2] | 0;
            if (!a) {
                a = 0;
                return a | 0;
            }
            if (c) {
                c = 0;
                d = a;
                a: while(true){
                    while(true){
                        i = +e[d >> 3];
                        k = +e[d + 8 >> 3];
                        d = d + 16 | 0;
                        m = b[d >> 2] | 0;
                        m = (m | 0) == 0 ? a : m;
                        h = +e[m >> 3];
                        g = +e[m + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(l < h | l > j)) break;
                        d = b[d >> 2] | 0;
                        if (!d) {
                            d = 22;
                            break a;
                        }
                    }
                    k = g < 0.0 ? g + 6.283185307179586 : g;
                    i = i < 0.0 ? i + 6.283185307179586 : i;
                    f = i == f | k == f ? f + -0.0000000000000002220446049250313 : f;
                    k = k + (l - h) / (j - h) * (i - k);
                    if ((k < 0.0 ? k + 6.283185307179586 : k) > f) c = c ^ 1;
                    d = b[d >> 2] | 0;
                    if (!d) {
                        d = 22;
                        break;
                    }
                }
                if ((d | 0) == 22) return c | 0;
            } else {
                c = 0;
                d = a;
                b: while(true){
                    while(true){
                        i = +e[d >> 3];
                        k = +e[d + 8 >> 3];
                        d = d + 16 | 0;
                        m = b[d >> 2] | 0;
                        m = (m | 0) == 0 ? a : m;
                        h = +e[m >> 3];
                        g = +e[m + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(l < h | l > j)) break;
                        d = b[d >> 2] | 0;
                        if (!d) {
                            d = 22;
                            break b;
                        }
                    }
                    f = i == f | g == f ? f + -0.0000000000000002220446049250313 : f;
                    if (g + (l - h) / (j - h) * (i - g) > f) c = c ^ 1;
                    d = b[d >> 2] | 0;
                    if (!d) {
                        d = 22;
                        break;
                    }
                }
                if ((d | 0) == 22) return c | 0;
            }
            return 0;
        }
        function lc(c, d, e, f, g) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0;
            u = S;
            S = S + 32 | 0;
            t = u + 16 | 0;
            s = u;
            h = bd(c | 0, d | 0, 52) | 0;
            G();
            h = h & 15;
            p = bd(e | 0, f | 0, 52) | 0;
            G();
            if ((h | 0) != (p & 15 | 0)) {
                t = 1;
                S = u;
                return t | 0;
            }
            l = bd(c | 0, d | 0, 45) | 0;
            G();
            l = l & 127;
            m = bd(e | 0, f | 0, 45) | 0;
            G();
            m = m & 127;
            p = (l | 0) != (m | 0);
            if (p) {
                j = ta(l, m) | 0;
                if ((j | 0) == 7) {
                    t = 2;
                    S = u;
                    return t | 0;
                }
                k = ta(m, l) | 0;
                if ((k | 0) == 7) H(22925, 22949, 151, 22959);
                else {
                    q = j;
                    i = k;
                }
            } else {
                q = 0;
                i = 0;
            }
            n = la(l) | 0;
            o = la(m) | 0;
            b[t >> 2] = 0;
            b[t + 4 >> 2] = 0;
            b[t + 8 >> 2] = 0;
            b[t + 12 >> 2] = 0;
            do if (!q) {
                Sb(e, f, t);
                if ((n | 0) != 0 & (o | 0) != 0) {
                    if ((m | 0) != (l | 0)) H(23077, 22949, 243, 22959);
                    i = Kb(c, d) | 0;
                    h = Kb(e, f) | 0;
                    if (!(a[22032 + (i * 7 | 0) + h >> 0] | 0)) {
                        i = b[21200 + (i * 28 | 0) + (h << 2) >> 2] | 0;
                        if ((i | 0) > 0) {
                            j = t + 4 | 0;
                            h = 0;
                            do {
                                Oa(j);
                                h = h + 1 | 0;
                            }while ((h | 0) != (i | 0));
                            r = 50;
                        } else r = 50;
                    } else h = 5;
                } else r = 50;
            } else {
                m = b[4304 + (l * 28 | 0) + (q << 2) >> 2] | 0;
                j = (m | 0) > 0;
                if (!o) {
                    if (j) {
                        l = 0;
                        k = e;
                        j = f;
                        do {
                            k = Ob(k, j) | 0;
                            j = G() | 0;
                            i = Qa(i) | 0;
                            l = l + 1 | 0;
                        }while ((l | 0) != (m | 0));
                        m = i;
                        l = k;
                        k = j;
                    } else {
                        m = i;
                        l = e;
                        k = f;
                    }
                } else if (j) {
                    l = 0;
                    k = e;
                    j = f;
                    do {
                        k = Nb(k, j) | 0;
                        j = G() | 0;
                        i = Qa(i) | 0;
                        if ((i | 0) == 1) i = Qa(1) | 0;
                        l = l + 1 | 0;
                    }while ((l | 0) != (m | 0));
                    m = i;
                    l = k;
                    k = j;
                } else {
                    m = i;
                    l = e;
                    k = f;
                }
                Sb(l, k, t);
                if (!p) H(22972, 22949, 181, 22959);
                j = (n | 0) != 0;
                i = (o | 0) != 0;
                if (j & i) H(22999, 22949, 182, 22959);
                if (!j) {
                    if (i) {
                        i = Kb(l, k) | 0;
                        if (a[22032 + (i * 7 | 0) + m >> 0] | 0) {
                            h = 4;
                            break;
                        }
                        l = 0;
                        k = b[21200 + (m * 28 | 0) + (i << 2) >> 2] | 0;
                        r = 26;
                    } else i = 0;
                } else {
                    i = Kb(c, d) | 0;
                    if (a[22032 + (i * 7 | 0) + q >> 0] | 0) {
                        h = 3;
                        break;
                    }
                    k = b[21200 + (i * 28 | 0) + (q << 2) >> 2] | 0;
                    l = k;
                    r = 26;
                }
                if ((r | 0) == 26) {
                    if ((k | 0) <= -1) H(23030, 22949, 212, 22959);
                    if ((l | 0) <= -1) H(23053, 22949, 213, 22959);
                    if ((k | 0) > 0) {
                        j = t + 4 | 0;
                        i = 0;
                        do {
                            Oa(j);
                            i = i + 1 | 0;
                        }while ((i | 0) != (k | 0));
                        i = l;
                    } else i = l;
                }
                b[s >> 2] = 0;
                b[s + 4 >> 2] = 0;
                b[s + 8 >> 2] = 0;
                Ma(s, q);
                if (h | 0) while(true){
                    if (!(Qb(h) | 0)) La(s);
                    else Ka(s);
                    if ((h | 0) > 1) h = h + -1 | 0;
                    else break;
                }
                if ((i | 0) > 0) {
                    h = 0;
                    do {
                        Oa(s);
                        h = h + 1 | 0;
                    }while ((h | 0) != (i | 0));
                }
                r = t + 4 | 0;
                Ea(r, s, r);
                Ca(r);
                r = 50;
            }
            while (0);
            if ((r | 0) == 50) {
                h = t + 4 | 0;
                b[g >> 2] = b[h >> 2];
                b[g + 4 >> 2] = b[h + 4 >> 2];
                b[g + 8 >> 2] = b[h + 8 >> 2];
                h = 0;
            }
            t = h;
            S = u;
            return t | 0;
        }
        function mc(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
            p = S;
            S = S + 48 | 0;
            h = p + 36 | 0;
            i = p + 24 | 0;
            j = p + 12 | 0;
            k = p;
            g = bd(a | 0, c | 0, 52) | 0;
            G();
            g = g & 15;
            n = bd(a | 0, c | 0, 45) | 0;
            G();
            n = n & 127;
            l = la(n) | 0;
            cd(g | 0, 0, 52);
            r = G() | 134225919;
            q = e;
            b[q >> 2] = -1;
            b[q + 4 >> 2] = r;
            if (!g) {
                if ((b[d >> 2] | 0) > 1) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                if ((b[d + 4 >> 2] | 0) > 1) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                if ((b[d + 8 >> 2] | 0) > 1) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                f = sa(n, Ha(d) | 0) | 0;
                if ((f | 0) == 127) {
                    r = 1;
                    S = p;
                    return r | 0;
                }
                o = cd(f | 0, 0, 45) | 0;
                q = G() | 0;
                n = e;
                q = b[n + 4 >> 2] & -1040385 | q;
                r = e;
                b[r >> 2] = b[n >> 2] | o;
                b[r + 4 >> 2] = q;
                r = 0;
                S = p;
                return r | 0;
            }
            b[h >> 2] = b[d >> 2];
            b[h + 4 >> 2] = b[d + 4 >> 2];
            b[h + 8 >> 2] = b[d + 8 >> 2];
            while(true){
                b[i >> 2] = b[h >> 2];
                b[i + 4 >> 2] = b[h + 4 >> 2];
                b[i + 8 >> 2] = b[h + 8 >> 2];
                if (!(Qb(g) | 0)) {
                    Ja(h);
                    b[j >> 2] = b[h >> 2];
                    b[j + 4 >> 2] = b[h + 4 >> 2];
                    b[j + 8 >> 2] = b[h + 8 >> 2];
                    La(j);
                } else {
                    Ia(h);
                    b[j >> 2] = b[h >> 2];
                    b[j + 4 >> 2] = b[h + 4 >> 2];
                    b[j + 8 >> 2] = b[h + 8 >> 2];
                    Ka(j);
                }
                Fa(i, j, k);
                Ca(k);
                q = e;
                s = b[q >> 2] | 0;
                q = b[q + 4 >> 2] | 0;
                t = (15 - g | 0) * 3 | 0;
                d = cd(7, 0, t | 0) | 0;
                q = q & ~(G() | 0);
                t = cd(Ha(k) | 0, 0, t | 0) | 0;
                q = G() | 0 | q;
                r = e;
                b[r >> 2] = t | s & ~d;
                b[r + 4 >> 2] = q;
                if ((g | 0) > 1) g = g + -1 | 0;
                else break;
            }
            a: do if (((b[h >> 2] | 0) <= 1 ? (b[h + 4 >> 2] | 0) <= 1 : 0) ? (b[h + 8 >> 2] | 0) <= 1 : 0) {
                g = Ha(h) | 0;
                i = sa(n, g) | 0;
                if ((i | 0) == 127) k = 0;
                else k = la(i) | 0;
                b: do if (!g) {
                    if ((l | 0) != 0 & (k | 0) != 0) {
                        t = Kb(a, c) | 0;
                        g = e;
                        g = 21408 + (t * 28 | 0) + ((Kb(b[g >> 2] | 0, b[g + 4 >> 2] | 0) | 0) << 2) | 0;
                        g = b[g >> 2] | 0;
                        if ((g | 0) <= -1) H(23201, 22949, 433, 23134);
                        if (!g) {
                            f = i;
                            g = 55;
                        } else {
                            h = e;
                            f = 0;
                            d = b[h >> 2] | 0;
                            h = b[h + 4 >> 2] | 0;
                            do {
                                d = Mb(d, h) | 0;
                                h = G() | 0;
                                t = e;
                                b[t >> 2] = d;
                                b[t + 4 >> 2] = h;
                                f = f + 1 | 0;
                            }while ((f | 0) < (g | 0));
                            f = i;
                            g = 54;
                        }
                    } else {
                        f = i;
                        g = 54;
                    }
                } else {
                    if (l) {
                        h = 21408 + ((Kb(a, c) | 0) * 28 | 0) + (g << 2) | 0;
                        h = b[h >> 2] | 0;
                        if ((h | 0) > 0) {
                            d = 0;
                            do {
                                g = Pa(g) | 0;
                                d = d + 1 | 0;
                            }while ((d | 0) != (h | 0));
                        }
                        if ((g | 0) == 1) {
                            f = 3;
                            break a;
                        }
                        d = sa(n, g) | 0;
                        if ((d | 0) == 127) H(23104, 22949, 376, 23134);
                        if (!(la(d) | 0)) {
                            o = h;
                            m = g;
                            f = d;
                        } else H(23147, 22949, 377, 23134);
                    } else {
                        o = 0;
                        m = g;
                        f = i;
                    }
                    j = b[4304 + (n * 28 | 0) + (m << 2) >> 2] | 0;
                    if ((j | 0) <= -1) H(23178, 22949, 384, 23134);
                    if (!k) {
                        if ((o | 0) <= -1) H(23030, 22949, 417, 23134);
                        if (o | 0) {
                            h = e;
                            g = 0;
                            d = b[h >> 2] | 0;
                            h = b[h + 4 >> 2] | 0;
                            do {
                                d = Mb(d, h) | 0;
                                h = G() | 0;
                                t = e;
                                b[t >> 2] = d;
                                b[t + 4 >> 2] = h;
                                g = g + 1 | 0;
                            }while ((g | 0) < (o | 0));
                        }
                        if ((j | 0) <= 0) {
                            g = 54;
                            break;
                        }
                        h = e;
                        g = 0;
                        d = b[h >> 2] | 0;
                        h = b[h + 4 >> 2] | 0;
                        while(true){
                            d = Mb(d, h) | 0;
                            h = G() | 0;
                            t = e;
                            b[t >> 2] = d;
                            b[t + 4 >> 2] = h;
                            g = g + 1 | 0;
                            if ((g | 0) == (j | 0)) {
                                g = 54;
                                break b;
                            }
                        }
                    }
                    i = ta(f, n) | 0;
                    if ((i | 0) == 7) H(22925, 22949, 393, 23134);
                    g = e;
                    d = b[g >> 2] | 0;
                    g = b[g + 4 >> 2] | 0;
                    if ((j | 0) > 0) {
                        h = 0;
                        do {
                            d = Mb(d, g) | 0;
                            g = G() | 0;
                            t = e;
                            b[t >> 2] = d;
                            b[t + 4 >> 2] = g;
                            h = h + 1 | 0;
                        }while ((h | 0) != (j | 0));
                    }
                    d = Kb(d, g) | 0;
                    t = ma(f) | 0;
                    d = b[(t ? 21824 : 21616) + (i * 28 | 0) + (d << 2) >> 2] | 0;
                    if ((d | 0) <= -1) H(23030, 22949, 412, 23134);
                    if (!d) g = 54;
                    else {
                        i = e;
                        g = 0;
                        h = b[i >> 2] | 0;
                        i = b[i + 4 >> 2] | 0;
                        do {
                            h = Lb(h, i) | 0;
                            i = G() | 0;
                            t = e;
                            b[t >> 2] = h;
                            b[t + 4 >> 2] = i;
                            g = g + 1 | 0;
                        }while ((g | 0) < (d | 0));
                        g = 54;
                    }
                }
                while (0);
                if ((g | 0) == 54) {
                    if (k) g = 55;
                }
                if ((g | 0) == 55) {
                    t = e;
                    if ((Kb(b[t >> 2] | 0, b[t + 4 >> 2] | 0) | 0) == 1) {
                        f = 4;
                        break;
                    }
                }
                t = e;
                r = b[t >> 2] | 0;
                t = b[t + 4 >> 2] & -1040385;
                s = cd(f | 0, 0, 45) | 0;
                t = t | (G() | 0);
                f = e;
                b[f >> 2] = r | s;
                b[f + 4 >> 2] = t;
                f = 0;
            } else f = 2;
            while (0);
            t = f;
            S = p;
            return t | 0;
        }
        function nc(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = S;
            S = S + 16 | 0;
            f = g;
            a = lc(a, b, c, d, f) | 0;
            if (!a) {
                Ua(f, e);
                a = 0;
            }
            S = g;
            return a | 0;
        }
        function oc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = S;
            S = S + 16 | 0;
            f = e;
            Va(c, f);
            d = mc(a, b, f, d) | 0;
            S = e;
            return d | 0;
        }
        function pc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = S;
            S = S + 32 | 0;
            e = g + 12 | 0;
            f = g;
            if ((lc(a, b, a, b, e) | 0) == 0 ? (lc(a, b, c, d, f) | 0) == 0 : 0) a = Ta(e, f) | 0;
            else a = -1;
            S = g;
            return a | 0;
        }
        function qc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = S;
            S = S + 32 | 0;
            e = g + 12 | 0;
            f = g;
            if ((lc(a, b, a, b, e) | 0) == 0 ? (lc(a, b, c, d, f) | 0) == 0 : 0) a = Ta(e, f) | 0;
            else a = -1;
            S = g;
            return (a >>> 31 ^ 1) + a | 0;
        }
        function rc(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0.0, j = 0.0, k = 0, l = 0, m = 0, n = 0, o = 0.0, p = 0.0, r = 0.0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0.0;
            x = S;
            S = S + 48 | 0;
            g = x + 24 | 0;
            h = x + 12 | 0;
            w = x;
            if ((lc(a, c, a, c, g) | 0) == 0 ? (lc(a, c, d, e, h) | 0) == 0 : 0) {
                v = Ta(g, h) | 0;
                if ((v | 0) < 0) {
                    w = v;
                    S = x;
                    return w | 0;
                }
                b[g >> 2] = 0;
                b[g + 4 >> 2] = 0;
                b[g + 8 >> 2] = 0;
                b[h >> 2] = 0;
                b[h + 4 >> 2] = 0;
                b[h + 8 >> 2] = 0;
                lc(a, c, a, c, g);
                lc(a, c, d, e, h);
                Wa(g);
                Wa(h);
                if (!v) {
                    e = g + 4 | 0;
                    n = g + 8 | 0;
                    s = e;
                    t = n;
                    u = g;
                    d = b[g >> 2] | 0;
                    e = b[e >> 2] | 0;
                    g = b[n >> 2] | 0;
                    p = 0.0;
                    r = 0.0;
                    o = 0.0;
                } else {
                    l = b[g >> 2] | 0;
                    o = +(v | 0);
                    s = g + 4 | 0;
                    m = b[s >> 2] | 0;
                    t = g + 8 | 0;
                    n = b[t >> 2] | 0;
                    u = g;
                    d = l;
                    e = m;
                    g = n;
                    p = +((b[h >> 2] | 0) - l | 0) / o;
                    r = +((b[h + 4 >> 2] | 0) - m | 0) / o;
                    o = +((b[h + 8 >> 2] | 0) - n | 0) / o;
                }
                b[w >> 2] = d;
                n = w + 4 | 0;
                b[n >> 2] = e;
                m = w + 8 | 0;
                b[m >> 2] = g;
                l = 0;
                while(true){
                    j = +(l | 0);
                    y = p * j + +(d | 0);
                    i = r * j + +(b[s >> 2] | 0);
                    j = o * j + +(b[t >> 2] | 0);
                    e = ~~+ed(+y);
                    h = ~~+ed(+i);
                    d = ~~+ed(+j);
                    y = +q(+(+(e | 0) - y));
                    i = +q(+(+(h | 0) - i));
                    j = +q(+(+(d | 0) - j));
                    do if (!(y > i & y > j)) {
                        k = 0 - e | 0;
                        if (i > j) {
                            g = k - d | 0;
                            break;
                        } else {
                            g = h;
                            d = k - h | 0;
                            break;
                        }
                    } else {
                        e = 0 - (h + d) | 0;
                        g = h;
                    }
                    while (0);
                    b[w >> 2] = e;
                    b[n >> 2] = g;
                    b[m >> 2] = d;
                    Xa(w);
                    mc(a, c, w, f + (l << 3) | 0);
                    if ((l | 0) == (v | 0)) break;
                    l = l + 1 | 0;
                    d = b[u >> 2] | 0;
                }
                w = 0;
                S = x;
                return w | 0;
            }
            w = -1;
            S = x;
            return w | 0;
        }
        function sc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            if (!b) {
                c = 1;
                return c | 0;
            }
            c = a;
            a = 1;
            do {
                a = B((b & 1 | 0) == 0 ? 1 : c, a) | 0;
                b = b >> 1;
                c = B(c, c) | 0;
            }while ((b | 0) != 0);
            return a | 0;
        }
        function tc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0, m = 0, n = 0, o = 0.0;
            if (!(xa(c, d) | 0)) {
                n = 0;
                return n | 0;
            }
            c = wa(c) | 0;
            o = +e[d >> 3];
            f = +e[d + 8 >> 3];
            f = c & f < 0.0 ? f + 6.283185307179586 : f;
            n = b[a >> 2] | 0;
            if ((n | 0) <= 0) {
                n = 0;
                return n | 0;
            }
            m = b[a + 4 >> 2] | 0;
            if (c) {
                c = 0;
                d = -1;
                a = 0;
                a: while(true){
                    l = a;
                    while(true){
                        i = +e[m + (l << 4) >> 3];
                        k = +e[m + (l << 4) + 8 >> 3];
                        a = (d + 2 | 0) % (n | 0) | 0;
                        h = +e[m + (a << 4) >> 3];
                        g = +e[m + (a << 4) + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(o < h | o > j)) break;
                        d = l + 1 | 0;
                        if ((d | 0) < (n | 0)) {
                            a = l;
                            l = d;
                            d = a;
                        } else {
                            d = 22;
                            break a;
                        }
                    }
                    k = g < 0.0 ? g + 6.283185307179586 : g;
                    i = i < 0.0 ? i + 6.283185307179586 : i;
                    f = i == f | k == f ? f + -0.0000000000000002220446049250313 : f;
                    k = k + (o - h) / (j - h) * (i - k);
                    if ((k < 0.0 ? k + 6.283185307179586 : k) > f) c = c ^ 1;
                    a = l + 1 | 0;
                    if ((a | 0) >= (n | 0)) {
                        d = 22;
                        break;
                    } else d = l;
                }
                if ((d | 0) == 22) return c | 0;
            } else {
                c = 0;
                d = -1;
                a = 0;
                b: while(true){
                    l = a;
                    while(true){
                        i = +e[m + (l << 4) >> 3];
                        k = +e[m + (l << 4) + 8 >> 3];
                        a = (d + 2 | 0) % (n | 0) | 0;
                        h = +e[m + (a << 4) >> 3];
                        g = +e[m + (a << 4) + 8 >> 3];
                        if (i > h) {
                            j = i;
                            i = k;
                        } else {
                            j = h;
                            h = i;
                            i = g;
                            g = k;
                        }
                        if (!(o < h | o > j)) break;
                        d = l + 1 | 0;
                        if ((d | 0) < (n | 0)) {
                            a = l;
                            l = d;
                            d = a;
                        } else {
                            d = 22;
                            break b;
                        }
                    }
                    f = i == f | g == f ? f + -0.0000000000000002220446049250313 : f;
                    if (g + (o - h) / (j - h) * (i - g) > f) c = c ^ 1;
                    a = l + 1 | 0;
                    if ((a | 0) >= (n | 0)) {
                        d = 22;
                        break;
                    } else d = l;
                }
                if ((d | 0) == 22) return c | 0;
            }
            return 0;
        }
        function uc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0, o = 0, p = 0, r = 0, s = 0, t = 0, u = 0, v = 0;
            r = b[a >> 2] | 0;
            if (!r) {
                b[c >> 2] = 0;
                b[c + 4 >> 2] = 0;
                b[c + 8 >> 2] = 0;
                b[c + 12 >> 2] = 0;
                b[c + 16 >> 2] = 0;
                b[c + 20 >> 2] = 0;
                b[c + 24 >> 2] = 0;
                b[c + 28 >> 2] = 0;
                return;
            }
            s = c + 8 | 0;
            e[s >> 3] = 1797693134862315708145274.0e284;
            t = c + 24 | 0;
            e[t >> 3] = 1797693134862315708145274.0e284;
            e[c >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            u = c + 16 | 0;
            e[u >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            if ((r | 0) <= 0) return;
            o = b[a + 4 >> 2] | 0;
            l = 1797693134862315708145274.0e284;
            m = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            n = 0;
            a = -1;
            h = 1797693134862315708145274.0e284;
            i = 1797693134862315708145274.0e284;
            k = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            f = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            p = 0;
            while(true){
                d = +e[o + (p << 4) >> 3];
                j = +e[o + (p << 4) + 8 >> 3];
                a = a + 2 | 0;
                g = +e[o + (((a | 0) == (r | 0) ? 0 : a) << 4) + 8 >> 3];
                if (d < h) {
                    e[s >> 3] = d;
                    h = d;
                }
                if (j < i) {
                    e[t >> 3] = j;
                    i = j;
                }
                if (d > k) e[c >> 3] = d;
                else d = k;
                if (j > f) {
                    e[u >> 3] = j;
                    f = j;
                }
                l = j > 0.0 & j < l ? j : l;
                m = j < 0.0 & j > m ? j : m;
                n = n | +q(+(j - g)) > 3.141592653589793;
                a = p + 1 | 0;
                if ((a | 0) == (r | 0)) break;
                else {
                    v = p;
                    k = d;
                    p = a;
                    a = v;
                }
            }
            if (!n) return;
            e[u >> 3] = m;
            e[t >> 3] = l;
            return;
        }
        function vc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0, o = 0.0, p = 0.0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0;
            r = b[a >> 2] | 0;
            if (r) {
                s = c + 8 | 0;
                e[s >> 3] = 1797693134862315708145274.0e284;
                t = c + 24 | 0;
                e[t >> 3] = 1797693134862315708145274.0e284;
                e[c >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                u = c + 16 | 0;
                e[u >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                if ((r | 0) > 0) {
                    g = b[a + 4 >> 2] | 0;
                    o = 1797693134862315708145274.0e284;
                    p = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    f = 0;
                    d = -1;
                    k = 1797693134862315708145274.0e284;
                    l = 1797693134862315708145274.0e284;
                    n = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    i = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    v = 0;
                    while(true){
                        h = +e[g + (v << 4) >> 3];
                        m = +e[g + (v << 4) + 8 >> 3];
                        z = d + 2 | 0;
                        j = +e[g + (((z | 0) == (r | 0) ? 0 : z) << 4) + 8 >> 3];
                        if (h < k) {
                            e[s >> 3] = h;
                            k = h;
                        }
                        if (m < l) {
                            e[t >> 3] = m;
                            l = m;
                        }
                        if (h > n) e[c >> 3] = h;
                        else h = n;
                        if (m > i) {
                            e[u >> 3] = m;
                            i = m;
                        }
                        o = m > 0.0 & m < o ? m : o;
                        p = m < 0.0 & m > p ? m : p;
                        f = f | +q(+(m - j)) > 3.141592653589793;
                        d = v + 1 | 0;
                        if ((d | 0) == (r | 0)) break;
                        else {
                            z = v;
                            n = h;
                            v = d;
                            d = z;
                        }
                    }
                    if (f) {
                        e[u >> 3] = p;
                        e[t >> 3] = o;
                    }
                }
            } else {
                b[c >> 2] = 0;
                b[c + 4 >> 2] = 0;
                b[c + 8 >> 2] = 0;
                b[c + 12 >> 2] = 0;
                b[c + 16 >> 2] = 0;
                b[c + 20 >> 2] = 0;
                b[c + 24 >> 2] = 0;
                b[c + 28 >> 2] = 0;
            }
            z = a + 8 | 0;
            d = b[z >> 2] | 0;
            if ((d | 0) <= 0) return;
            y = a + 12 | 0;
            x = 0;
            do {
                g = b[y >> 2] | 0;
                f = x;
                x = x + 1 | 0;
                t = c + (x << 5) | 0;
                u = b[g + (f << 3) >> 2] | 0;
                if (u) {
                    v = c + (x << 5) + 8 | 0;
                    e[v >> 3] = 1797693134862315708145274.0e284;
                    a = c + (x << 5) + 24 | 0;
                    e[a >> 3] = 1797693134862315708145274.0e284;
                    e[t >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    w = c + (x << 5) + 16 | 0;
                    e[w >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    if ((u | 0) > 0) {
                        r = b[g + (f << 3) + 4 >> 2] | 0;
                        o = 1797693134862315708145274.0e284;
                        p = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        g = 0;
                        f = -1;
                        s = 0;
                        k = 1797693134862315708145274.0e284;
                        l = 1797693134862315708145274.0e284;
                        m = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        i = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        while(true){
                            h = +e[r + (s << 4) >> 3];
                            n = +e[r + (s << 4) + 8 >> 3];
                            f = f + 2 | 0;
                            j = +e[r + (((f | 0) == (u | 0) ? 0 : f) << 4) + 8 >> 3];
                            if (h < k) {
                                e[v >> 3] = h;
                                k = h;
                            }
                            if (n < l) {
                                e[a >> 3] = n;
                                l = n;
                            }
                            if (h > m) e[t >> 3] = h;
                            else h = m;
                            if (n > i) {
                                e[w >> 3] = n;
                                i = n;
                            }
                            o = n > 0.0 & n < o ? n : o;
                            p = n < 0.0 & n > p ? n : p;
                            g = g | +q(+(n - j)) > 3.141592653589793;
                            f = s + 1 | 0;
                            if ((f | 0) == (u | 0)) break;
                            else {
                                A = s;
                                s = f;
                                m = h;
                                f = A;
                            }
                        }
                        if (g) {
                            e[w >> 3] = p;
                            e[a >> 3] = o;
                        }
                    }
                } else {
                    b[t >> 2] = 0;
                    b[t + 4 >> 2] = 0;
                    b[t + 8 >> 2] = 0;
                    b[t + 12 >> 2] = 0;
                    b[t + 16 >> 2] = 0;
                    b[t + 20 >> 2] = 0;
                    b[t + 24 >> 2] = 0;
                    b[t + 28 >> 2] = 0;
                    d = b[z >> 2] | 0;
                }
            }while ((x | 0) < (d | 0));
            return;
        }
        function wc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            if (!(tc(a, c, d) | 0)) {
                f = 0;
                return f | 0;
            }
            f = a + 8 | 0;
            if ((b[f >> 2] | 0) <= 0) {
                f = 1;
                return f | 0;
            }
            e = a + 12 | 0;
            a = 0;
            while(true){
                g = a;
                a = a + 1 | 0;
                if (tc((b[e >> 2] | 0) + (g << 3) | 0, c + (a << 5) | 0, d) | 0) {
                    a = 0;
                    e = 6;
                    break;
                }
                if ((a | 0) >= (b[f >> 2] | 0)) {
                    a = 1;
                    e = 6;
                    break;
                }
            }
            if ((e | 0) == 6) return a | 0;
            return 0;
        }
        function xc() {
            return 8;
        }
        function yc() {
            return 16;
        }
        function zc() {
            return 168;
        }
        function Ac() {
            return 8;
        }
        function Bc() {
            return 16;
        }
        function Cc() {
            return 12;
        }
        function Dc() {
            return 8;
        }
        function Ec(a) {
            a = a | 0;
            var b = 0.0, c = 0.0;
            c = +e[a >> 3];
            b = +e[a + 8 >> 3];
            return + +r(+(c * c + b * b));
        }
        function Fc(a, b, c, d, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0;
            k = +e[a >> 3];
            j = +e[b >> 3] - k;
            i = +e[a + 8 >> 3];
            h = +e[b + 8 >> 3] - i;
            m = +e[c >> 3];
            g = +e[d >> 3] - m;
            n = +e[c + 8 >> 3];
            l = +e[d + 8 >> 3] - n;
            g = (g * (i - n) - (k - m) * l) / (j * l - h * g);
            e[f >> 3] = k + j * g;
            e[f + 8 >> 3] = i + h * g;
            return;
        }
        function Gc(a, b) {
            a = a | 0;
            b = b | 0;
            if (!(+e[a >> 3] == +e[b >> 3])) {
                b = 0;
                return b | 0;
            }
            b = +e[a + 8 >> 3] == +e[b + 8 >> 3];
            return b | 0;
        }
        function Hc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            f = +e[a >> 3] - +e[b >> 3];
            d = +e[a + 8 >> 3] - +e[b + 8 >> 3];
            c = +e[a + 16 >> 3] - +e[b + 16 >> 3];
            return +(f * f + d * d + c * c);
        }
        function Ic(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            c = +e[a >> 3];
            d = +t(+c);
            c = +u(+c);
            e[b + 16 >> 3] = c;
            c = +e[a + 8 >> 3];
            f = d * +t(+c);
            e[b >> 3] = f;
            c = d * +u(+c);
            e[b + 8 >> 3] = c;
            return;
        }
        function Jc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            k = S;
            S = S + 32 | 0;
            f = k + 16 | 0;
            g = k;
            Tb(a, c, f);
            h = zb(a, c) | 0;
            j = Kb(a, c) | 0;
            pa(h, g);
            c = qa(h, b[f >> 2] | 0) | 0;
            if (!(la(h) | 0)) {
                j = c;
                S = k;
                return j | 0;
            }
            do switch(h | 0){
                case 4:
                    a = 0;
                    d = 14;
                    break;
                case 14:
                    a = 1;
                    d = 14;
                    break;
                case 24:
                    a = 2;
                    d = 14;
                    break;
                case 38:
                    a = 3;
                    d = 14;
                    break;
                case 49:
                    a = 4;
                    d = 14;
                    break;
                case 58:
                    a = 5;
                    d = 14;
                    break;
                case 63:
                    a = 6;
                    d = 14;
                    break;
                case 72:
                    a = 7;
                    d = 14;
                    break;
                case 83:
                    a = 8;
                    d = 14;
                    break;
                case 97:
                    a = 9;
                    d = 14;
                    break;
                case 107:
                    a = 10;
                    d = 14;
                    break;
                case 117:
                    a = 11;
                    d = 14;
                    break;
                default:
                    i = 0;
                    e = 0;
            }
            while (0);
            if ((d | 0) == 14) {
                i = b[22096 + (a * 24 | 0) + 8 >> 2] | 0;
                e = b[22096 + (a * 24 | 0) + 16 >> 2] | 0;
            }
            a = b[f >> 2] | 0;
            if ((a | 0) != (b[g >> 2] | 0)) {
                h = ma(h) | 0;
                a = b[f >> 2] | 0;
                if (h | (a | 0) == (e | 0)) c = (c + 1 | 0) % 6 | 0;
            }
            if ((j | 0) == 3 & (a | 0) == (e | 0)) {
                j = (c + 5 | 0) % 6 | 0;
                S = k;
                return j | 0;
            }
            if (!((j | 0) == 5 & (a | 0) == (i | 0))) {
                j = c;
                S = k;
                return j | 0;
            }
            j = (c + 1 | 0) % 6 | 0;
            S = k;
            return j | 0;
        }
        function Kc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = Eb(a, c) | 0;
            if ((d + -1 | 0) >>> 0 > 5) {
                d = -1;
                return d | 0;
            }
            f = (e | 0) != 0;
            if ((d | 0) == 1 & f) {
                d = -1;
                return d | 0;
            }
            e = Jc(a, c) | 0;
            if (f) {
                d = (5 - e + (b[22384 + (d << 2) >> 2] | 0) | 0) % 5 | 0;
                return d | 0;
            } else {
                d = (6 - e + (b[22416 + (d << 2) >> 2] | 0) | 0) % 6 | 0;
                return d | 0;
            }
            return 0;
        }
        function Lc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            if ((c | 0) > 0) {
                e = Xc(c, 4) | 0;
                b[a >> 2] = e;
                if (!e) H(23230, 23253, 40, 23267);
            } else b[a >> 2] = 0;
            b[a + 4 >> 2] = c;
            b[a + 8 >> 2] = 0;
            b[a + 12 >> 2] = d;
            return;
        }
        function Mc(a) {
            a = a | 0;
            var c = 0, d = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            g = a + 4 | 0;
            h = a + 12 | 0;
            i = a + 8 | 0;
            a: while(true){
                d = b[g >> 2] | 0;
                c = 0;
                while(true){
                    if ((c | 0) >= (d | 0)) break a;
                    f = b[a >> 2] | 0;
                    j = b[f + (c << 2) >> 2] | 0;
                    if (!j) c = c + 1 | 0;
                    else break;
                }
                c = f + (~~(+q(+(+s(10.0, + +(15 - (b[h >> 2] | 0) | 0)) * (+e[j >> 3] + +e[j + 8 >> 3]))) % +(d | 0)) >>> 0 << 2) | 0;
                d = b[c >> 2] | 0;
                b: do if (d | 0) {
                    f = j + 32 | 0;
                    if ((d | 0) == (j | 0)) b[c >> 2] = b[f >> 2];
                    else {
                        d = d + 32 | 0;
                        c = b[d >> 2] | 0;
                        if (!c) break;
                        while(true){
                            if ((c | 0) == (j | 0)) break;
                            d = c + 32 | 0;
                            c = b[d >> 2] | 0;
                            if (!c) break b;
                        }
                        b[d >> 2] = b[f >> 2];
                    }
                    Wc(j);
                    b[i >> 2] = (b[i >> 2] | 0) + -1;
                }
                while (0);
            }
            Wc(b[a >> 2] | 0);
            return;
        }
        function Nc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            e = b[a + 4 >> 2] | 0;
            d = 0;
            while(true){
                if ((d | 0) >= (e | 0)) {
                    c = 0;
                    d = 4;
                    break;
                }
                c = b[(b[a >> 2] | 0) + (d << 2) >> 2] | 0;
                if (!c) d = d + 1 | 0;
                else {
                    d = 4;
                    break;
                }
            }
            if ((d | 0) == 4) return c | 0;
            return 0;
        }
        function Oc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0;
            d = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            d = (b[a >> 2] | 0) + (d << 2) | 0;
            f = b[d >> 2] | 0;
            if (!f) {
                h = 1;
                return h | 0;
            }
            h = c + 32 | 0;
            do if ((f | 0) != (c | 0)) {
                d = b[f + 32 >> 2] | 0;
                if (!d) {
                    h = 1;
                    return h | 0;
                }
                g = d;
                while(true){
                    if ((g | 0) == (c | 0)) {
                        g = 8;
                        break;
                    }
                    d = b[g + 32 >> 2] | 0;
                    if (!d) {
                        d = 1;
                        g = 10;
                        break;
                    } else {
                        f = g;
                        g = d;
                    }
                }
                if ((g | 0) == 8) {
                    b[f + 32 >> 2] = b[h >> 2];
                    break;
                } else if ((g | 0) == 10) return d | 0;
            } else b[d >> 2] = b[h >> 2];
            while (0);
            Wc(c);
            h = a + 8 | 0;
            b[h >> 2] = (b[h >> 2] | 0) + -1;
            h = 0;
            return h | 0;
        }
        function Pc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = Vc(40) | 0;
            if (!h) H(23283, 23253, 98, 23296);
            b[h >> 2] = b[c >> 2];
            b[h + 4 >> 2] = b[c + 4 >> 2];
            b[h + 8 >> 2] = b[c + 8 >> 2];
            b[h + 12 >> 2] = b[c + 12 >> 2];
            g = h + 16 | 0;
            b[g >> 2] = b[d >> 2];
            b[g + 4 >> 2] = b[d + 4 >> 2];
            b[g + 8 >> 2] = b[d + 8 >> 2];
            b[g + 12 >> 2] = b[d + 12 >> 2];
            b[h + 32 >> 2] = 0;
            g = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            g = (b[a >> 2] | 0) + (g << 2) | 0;
            f = b[g >> 2] | 0;
            do if (!f) b[g >> 2] = h;
            else {
                while(true){
                    if (hb(f, c) | 0 ? hb(f + 16 | 0, d) | 0 : 0) break;
                    g = b[f + 32 >> 2] | 0;
                    f = (g | 0) == 0 ? f : g;
                    if (!(b[f + 32 >> 2] | 0)) {
                        i = 10;
                        break;
                    }
                }
                if ((i | 0) == 10) {
                    b[f + 32 >> 2] = h;
                    break;
                }
                Wc(h);
                i = f;
                return i | 0;
            }
            while (0);
            i = a + 8 | 0;
            b[i >> 2] = (b[i >> 2] | 0) + 1;
            i = h;
            return i | 0;
        }
        function Qc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0, g = 0;
            g = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            g = b[(b[a >> 2] | 0) + (g << 2) >> 2] | 0;
            if (!g) {
                d = 0;
                return d | 0;
            }
            if (!d) {
                a = g;
                while(true){
                    if (hb(a, c) | 0) {
                        f = 10;
                        break;
                    }
                    a = b[a + 32 >> 2] | 0;
                    if (!a) {
                        a = 0;
                        f = 10;
                        break;
                    }
                }
                if ((f | 0) == 10) return a | 0;
            }
            a = g;
            while(true){
                if (hb(a, c) | 0 ? hb(a + 16 | 0, d) | 0 : 0) {
                    f = 10;
                    break;
                }
                a = b[a + 32 >> 2] | 0;
                if (!a) {
                    a = 0;
                    f = 10;
                    break;
                }
            }
            if ((f | 0) == 10) return a | 0;
            return 0;
        }
        function Rc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            d = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            a = b[(b[a >> 2] | 0) + (d << 2) >> 2] | 0;
            if (!a) {
                d = 0;
                return d | 0;
            }
            while(true){
                if (hb(a, c) | 0) {
                    c = 5;
                    break;
                }
                a = b[a + 32 >> 2] | 0;
                if (!a) {
                    a = 0;
                    c = 5;
                    break;
                }
            }
            if ((c | 0) == 5) return a | 0;
            return 0;
        }
        function Sc() {
            return 23312;
        }
        function Tc(a) {
            a = +a;
            return + +hd(+a);
        }
        function Uc(a) {
            a = +a;
            return ~~+Tc(a) | 0;
        }
        function Vc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0;
            w = S;
            S = S + 16 | 0;
            n = w;
            do {
                if (a >>> 0 < 245) {
                    k = a >>> 0 < 11 ? 16 : a + 11 & -8;
                    a = k >>> 3;
                    m = b[5829] | 0;
                    d = m >>> a;
                    if (d & 3 | 0) {
                        c = (d & 1 ^ 1) + a | 0;
                        a = 23356 + (c << 1 << 2) | 0;
                        d = a + 8 | 0;
                        e = b[d >> 2] | 0;
                        f = e + 8 | 0;
                        g = b[f >> 2] | 0;
                        if ((g | 0) == (a | 0)) b[5829] = m & ~(1 << c);
                        else {
                            b[g + 12 >> 2] = a;
                            b[d >> 2] = g;
                        }
                        v = c << 3;
                        b[e + 4 >> 2] = v | 3;
                        v = e + v + 4 | 0;
                        b[v >> 2] = b[v >> 2] | 1;
                        v = f;
                        S = w;
                        return v | 0;
                    }
                    l = b[5831] | 0;
                    if (k >>> 0 > l >>> 0) {
                        if (d | 0) {
                            c = 2 << a;
                            c = d << a & (c | 0 - c);
                            c = (c & 0 - c) + -1 | 0;
                            i = c >>> 12 & 16;
                            c = c >>> i;
                            d = c >>> 5 & 8;
                            c = c >>> d;
                            g = c >>> 2 & 4;
                            c = c >>> g;
                            a = c >>> 1 & 2;
                            c = c >>> a;
                            e = c >>> 1 & 1;
                            e = (d | i | g | a | e) + (c >>> e) | 0;
                            c = 23356 + (e << 1 << 2) | 0;
                            a = c + 8 | 0;
                            g = b[a >> 2] | 0;
                            i = g + 8 | 0;
                            d = b[i >> 2] | 0;
                            if ((d | 0) == (c | 0)) {
                                a = m & ~(1 << e);
                                b[5829] = a;
                            } else {
                                b[d + 12 >> 2] = c;
                                b[a >> 2] = d;
                                a = m;
                            }
                            v = e << 3;
                            h = v - k | 0;
                            b[g + 4 >> 2] = k | 3;
                            f = g + k | 0;
                            b[f + 4 >> 2] = h | 1;
                            b[g + v >> 2] = h;
                            if (l | 0) {
                                e = b[5834] | 0;
                                c = l >>> 3;
                                d = 23356 + (c << 1 << 2) | 0;
                                c = 1 << c;
                                if (!(a & c)) {
                                    b[5829] = a | c;
                                    c = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    c = b[a >> 2] | 0;
                                }
                                b[a >> 2] = e;
                                b[c + 12 >> 2] = e;
                                b[e + 8 >> 2] = c;
                                b[e + 12 >> 2] = d;
                            }
                            b[5831] = h;
                            b[5834] = f;
                            v = i;
                            S = w;
                            return v | 0;
                        }
                        g = b[5830] | 0;
                        if (g) {
                            d = (g & 0 - g) + -1 | 0;
                            f = d >>> 12 & 16;
                            d = d >>> f;
                            e = d >>> 5 & 8;
                            d = d >>> e;
                            h = d >>> 2 & 4;
                            d = d >>> h;
                            i = d >>> 1 & 2;
                            d = d >>> i;
                            j = d >>> 1 & 1;
                            j = b[23620 + ((e | f | h | i | j) + (d >>> j) << 2) >> 2] | 0;
                            d = j;
                            i = j;
                            j = (b[j + 4 >> 2] & -8) - k | 0;
                            while(true){
                                a = b[d + 16 >> 2] | 0;
                                if (!a) {
                                    a = b[d + 20 >> 2] | 0;
                                    if (!a) break;
                                }
                                h = (b[a + 4 >> 2] & -8) - k | 0;
                                f = h >>> 0 < j >>> 0;
                                d = a;
                                i = f ? a : i;
                                j = f ? h : j;
                            }
                            h = i + k | 0;
                            if (h >>> 0 > i >>> 0) {
                                f = b[i + 24 >> 2] | 0;
                                c = b[i + 12 >> 2] | 0;
                                do if ((c | 0) == (i | 0)) {
                                    a = i + 20 | 0;
                                    c = b[a >> 2] | 0;
                                    if (!c) {
                                        a = i + 16 | 0;
                                        c = b[a >> 2] | 0;
                                        if (!c) {
                                            d = 0;
                                            break;
                                        }
                                    }
                                    while(true){
                                        e = c + 20 | 0;
                                        d = b[e >> 2] | 0;
                                        if (!d) {
                                            e = c + 16 | 0;
                                            d = b[e >> 2] | 0;
                                            if (!d) break;
                                            else {
                                                c = d;
                                                a = e;
                                            }
                                        } else {
                                            c = d;
                                            a = e;
                                        }
                                    }
                                    b[a >> 2] = 0;
                                    d = c;
                                } else {
                                    d = b[i + 8 >> 2] | 0;
                                    b[d + 12 >> 2] = c;
                                    b[c + 8 >> 2] = d;
                                    d = c;
                                }
                                while (0);
                                do if (f | 0) {
                                    c = b[i + 28 >> 2] | 0;
                                    a = 23620 + (c << 2) | 0;
                                    if ((i | 0) == (b[a >> 2] | 0)) {
                                        b[a >> 2] = d;
                                        if (!d) {
                                            b[5830] = g & ~(1 << c);
                                            break;
                                        }
                                    } else {
                                        v = f + 16 | 0;
                                        b[((b[v >> 2] | 0) == (i | 0) ? v : f + 20 | 0) >> 2] = d;
                                        if (!d) break;
                                    }
                                    b[d + 24 >> 2] = f;
                                    c = b[i + 16 >> 2] | 0;
                                    if (c | 0) {
                                        b[d + 16 >> 2] = c;
                                        b[c + 24 >> 2] = d;
                                    }
                                    c = b[i + 20 >> 2] | 0;
                                    if (c | 0) {
                                        b[d + 20 >> 2] = c;
                                        b[c + 24 >> 2] = d;
                                    }
                                }
                                while (0);
                                if (j >>> 0 < 16) {
                                    v = j + k | 0;
                                    b[i + 4 >> 2] = v | 3;
                                    v = i + v + 4 | 0;
                                    b[v >> 2] = b[v >> 2] | 1;
                                } else {
                                    b[i + 4 >> 2] = k | 3;
                                    b[h + 4 >> 2] = j | 1;
                                    b[h + j >> 2] = j;
                                    if (l | 0) {
                                        e = b[5834] | 0;
                                        c = l >>> 3;
                                        d = 23356 + (c << 1 << 2) | 0;
                                        c = 1 << c;
                                        if (!(c & m)) {
                                            b[5829] = c | m;
                                            c = d;
                                            a = d + 8 | 0;
                                        } else {
                                            a = d + 8 | 0;
                                            c = b[a >> 2] | 0;
                                        }
                                        b[a >> 2] = e;
                                        b[c + 12 >> 2] = e;
                                        b[e + 8 >> 2] = c;
                                        b[e + 12 >> 2] = d;
                                    }
                                    b[5831] = j;
                                    b[5834] = h;
                                }
                                v = i + 8 | 0;
                                S = w;
                                return v | 0;
                            } else m = k;
                        } else m = k;
                    } else m = k;
                } else if (a >>> 0 <= 4294967231) {
                    a = a + 11 | 0;
                    k = a & -8;
                    e = b[5830] | 0;
                    if (e) {
                        f = 0 - k | 0;
                        a = a >>> 8;
                        if (a) {
                            if (k >>> 0 > 16777215) j = 31;
                            else {
                                m = (a + 1048320 | 0) >>> 16 & 8;
                                q = a << m;
                                i = (q + 520192 | 0) >>> 16 & 4;
                                q = q << i;
                                j = (q + 245760 | 0) >>> 16 & 2;
                                j = 14 - (i | m | j) + (q << j >>> 15) | 0;
                                j = k >>> (j + 7 | 0) & 1 | j << 1;
                            }
                        } else j = 0;
                        d = b[23620 + (j << 2) >> 2] | 0;
                        a: do if (!d) {
                            d = 0;
                            a = 0;
                            q = 61;
                        } else {
                            a = 0;
                            i = k << ((j | 0) == 31 ? 0 : 25 - (j >>> 1) | 0);
                            g = 0;
                            while(true){
                                h = (b[d + 4 >> 2] & -8) - k | 0;
                                if (h >>> 0 < f >>> 0) {
                                    if (!h) {
                                        a = d;
                                        f = 0;
                                        q = 65;
                                        break a;
                                    } else {
                                        a = d;
                                        f = h;
                                    }
                                }
                                q = b[d + 20 >> 2] | 0;
                                d = b[d + 16 + (i >>> 31 << 2) >> 2] | 0;
                                g = (q | 0) == 0 | (q | 0) == (d | 0) ? g : q;
                                if (!d) {
                                    d = g;
                                    q = 61;
                                    break;
                                } else i = i << 1;
                            }
                        }
                        while (0);
                        if ((q | 0) == 61) {
                            if ((d | 0) == 0 & (a | 0) == 0) {
                                a = 2 << j;
                                a = (a | 0 - a) & e;
                                if (!a) {
                                    m = k;
                                    break;
                                }
                                m = (a & 0 - a) + -1 | 0;
                                h = m >>> 12 & 16;
                                m = m >>> h;
                                g = m >>> 5 & 8;
                                m = m >>> g;
                                i = m >>> 2 & 4;
                                m = m >>> i;
                                j = m >>> 1 & 2;
                                m = m >>> j;
                                d = m >>> 1 & 1;
                                a = 0;
                                d = b[23620 + ((g | h | i | j | d) + (m >>> d) << 2) >> 2] | 0;
                            }
                            if (!d) {
                                i = a;
                                h = f;
                            } else q = 65;
                        }
                        if ((q | 0) == 65) {
                            g = d;
                            while(true){
                                m = (b[g + 4 >> 2] & -8) - k | 0;
                                d = m >>> 0 < f >>> 0;
                                f = d ? m : f;
                                a = d ? g : a;
                                d = b[g + 16 >> 2] | 0;
                                if (!d) d = b[g + 20 >> 2] | 0;
                                if (!d) {
                                    i = a;
                                    h = f;
                                    break;
                                } else g = d;
                            }
                        }
                        if (((i | 0) != 0 ? h >>> 0 < ((b[5831] | 0) - k | 0) >>> 0 : 0) ? (l = i + k | 0, l >>> 0 > i >>> 0) : 0) {
                            g = b[i + 24 >> 2] | 0;
                            c = b[i + 12 >> 2] | 0;
                            do if ((c | 0) == (i | 0)) {
                                a = i + 20 | 0;
                                c = b[a >> 2] | 0;
                                if (!c) {
                                    a = i + 16 | 0;
                                    c = b[a >> 2] | 0;
                                    if (!c) {
                                        c = 0;
                                        break;
                                    }
                                }
                                while(true){
                                    f = c + 20 | 0;
                                    d = b[f >> 2] | 0;
                                    if (!d) {
                                        f = c + 16 | 0;
                                        d = b[f >> 2] | 0;
                                        if (!d) break;
                                        else {
                                            c = d;
                                            a = f;
                                        }
                                    } else {
                                        c = d;
                                        a = f;
                                    }
                                }
                                b[a >> 2] = 0;
                            } else {
                                v = b[i + 8 >> 2] | 0;
                                b[v + 12 >> 2] = c;
                                b[c + 8 >> 2] = v;
                            }
                            while (0);
                            do if (g) {
                                a = b[i + 28 >> 2] | 0;
                                d = 23620 + (a << 2) | 0;
                                if ((i | 0) == (b[d >> 2] | 0)) {
                                    b[d >> 2] = c;
                                    if (!c) {
                                        e = e & ~(1 << a);
                                        b[5830] = e;
                                        break;
                                    }
                                } else {
                                    v = g + 16 | 0;
                                    b[((b[v >> 2] | 0) == (i | 0) ? v : g + 20 | 0) >> 2] = c;
                                    if (!c) break;
                                }
                                b[c + 24 >> 2] = g;
                                a = b[i + 16 >> 2] | 0;
                                if (a | 0) {
                                    b[c + 16 >> 2] = a;
                                    b[a + 24 >> 2] = c;
                                }
                                a = b[i + 20 >> 2] | 0;
                                if (a) {
                                    b[c + 20 >> 2] = a;
                                    b[a + 24 >> 2] = c;
                                }
                            }
                            while (0);
                            b: do if (h >>> 0 < 16) {
                                v = h + k | 0;
                                b[i + 4 >> 2] = v | 3;
                                v = i + v + 4 | 0;
                                b[v >> 2] = b[v >> 2] | 1;
                            } else {
                                b[i + 4 >> 2] = k | 3;
                                b[l + 4 >> 2] = h | 1;
                                b[l + h >> 2] = h;
                                c = h >>> 3;
                                if (h >>> 0 < 256) {
                                    d = 23356 + (c << 1 << 2) | 0;
                                    a = b[5829] | 0;
                                    c = 1 << c;
                                    if (!(a & c)) {
                                        b[5829] = a | c;
                                        c = d;
                                        a = d + 8 | 0;
                                    } else {
                                        a = d + 8 | 0;
                                        c = b[a >> 2] | 0;
                                    }
                                    b[a >> 2] = l;
                                    b[c + 12 >> 2] = l;
                                    b[l + 8 >> 2] = c;
                                    b[l + 12 >> 2] = d;
                                    break;
                                }
                                c = h >>> 8;
                                if (c) {
                                    if (h >>> 0 > 16777215) d = 31;
                                    else {
                                        u = (c + 1048320 | 0) >>> 16 & 8;
                                        v = c << u;
                                        t = (v + 520192 | 0) >>> 16 & 4;
                                        v = v << t;
                                        d = (v + 245760 | 0) >>> 16 & 2;
                                        d = 14 - (t | u | d) + (v << d >>> 15) | 0;
                                        d = h >>> (d + 7 | 0) & 1 | d << 1;
                                    }
                                } else d = 0;
                                c = 23620 + (d << 2) | 0;
                                b[l + 28 >> 2] = d;
                                a = l + 16 | 0;
                                b[a + 4 >> 2] = 0;
                                b[a >> 2] = 0;
                                a = 1 << d;
                                if (!(e & a)) {
                                    b[5830] = e | a;
                                    b[c >> 2] = l;
                                    b[l + 24 >> 2] = c;
                                    b[l + 12 >> 2] = l;
                                    b[l + 8 >> 2] = l;
                                    break;
                                }
                                c = b[c >> 2] | 0;
                                c: do if ((b[c + 4 >> 2] & -8 | 0) != (h | 0)) {
                                    e = h << ((d | 0) == 31 ? 0 : 25 - (d >>> 1) | 0);
                                    while(true){
                                        d = c + 16 + (e >>> 31 << 2) | 0;
                                        a = b[d >> 2] | 0;
                                        if (!a) break;
                                        if ((b[a + 4 >> 2] & -8 | 0) == (h | 0)) {
                                            c = a;
                                            break c;
                                        } else {
                                            e = e << 1;
                                            c = a;
                                        }
                                    }
                                    b[d >> 2] = l;
                                    b[l + 24 >> 2] = c;
                                    b[l + 12 >> 2] = l;
                                    b[l + 8 >> 2] = l;
                                    break b;
                                }
                                while (0);
                                u = c + 8 | 0;
                                v = b[u >> 2] | 0;
                                b[v + 12 >> 2] = l;
                                b[u >> 2] = l;
                                b[l + 8 >> 2] = v;
                                b[l + 12 >> 2] = c;
                                b[l + 24 >> 2] = 0;
                            }
                            while (0);
                            v = i + 8 | 0;
                            S = w;
                            return v | 0;
                        } else m = k;
                    } else m = k;
                } else m = -1;
            }while (0);
            d = b[5831] | 0;
            if (d >>> 0 >= m >>> 0) {
                c = d - m | 0;
                a = b[5834] | 0;
                if (c >>> 0 > 15) {
                    v = a + m | 0;
                    b[5834] = v;
                    b[5831] = c;
                    b[v + 4 >> 2] = c | 1;
                    b[a + d >> 2] = c;
                    b[a + 4 >> 2] = m | 3;
                } else {
                    b[5831] = 0;
                    b[5834] = 0;
                    b[a + 4 >> 2] = d | 3;
                    v = a + d + 4 | 0;
                    b[v >> 2] = b[v >> 2] | 1;
                }
                v = a + 8 | 0;
                S = w;
                return v | 0;
            }
            h = b[5832] | 0;
            if (h >>> 0 > m >>> 0) {
                t = h - m | 0;
                b[5832] = t;
                v = b[5835] | 0;
                u = v + m | 0;
                b[5835] = u;
                b[u + 4 >> 2] = t | 1;
                b[v + 4 >> 2] = m | 3;
                v = v + 8 | 0;
                S = w;
                return v | 0;
            }
            if (!(b[5947] | 0)) {
                b[5949] = 4096;
                b[5948] = 4096;
                b[5950] = -1;
                b[5951] = -1;
                b[5952] = 0;
                b[5940] = 0;
                b[5947] = n & -16 ^ 1431655768;
                a = 4096;
            } else a = b[5949] | 0;
            i = m + 48 | 0;
            j = m + 47 | 0;
            g = a + j | 0;
            f = 0 - a | 0;
            k = g & f;
            if (k >>> 0 <= m >>> 0) {
                v = 0;
                S = w;
                return v | 0;
            }
            a = b[5939] | 0;
            if (a | 0 ? (l = b[5937] | 0, n = l + k | 0, n >>> 0 <= l >>> 0 | n >>> 0 > a >>> 0) : 0) {
                v = 0;
                S = w;
                return v | 0;
            }
            d: do if (!(b[5940] & 4)) {
                d = b[5835] | 0;
                e: do if (d) {
                    e = 23764;
                    while(true){
                        n = b[e >> 2] | 0;
                        if (n >>> 0 <= d >>> 0 ? (n + (b[e + 4 >> 2] | 0) | 0) >>> 0 > d >>> 0 : 0) break;
                        a = b[e + 8 >> 2] | 0;
                        if (!a) {
                            q = 128;
                            break e;
                        } else e = a;
                    }
                    c = g - h & f;
                    if (c >>> 0 < 2147483647) {
                        a = id(c | 0) | 0;
                        if ((a | 0) == ((b[e >> 2] | 0) + (b[e + 4 >> 2] | 0) | 0)) {
                            if ((a | 0) != -1) {
                                h = c;
                                g = a;
                                q = 145;
                                break d;
                            }
                        } else {
                            e = a;
                            q = 136;
                        }
                    } else c = 0;
                } else q = 128;
                while (0);
                do if ((q | 0) == 128) {
                    d = id(0) | 0;
                    if ((d | 0) != -1 ? (c = d, o = b[5948] | 0, p = o + -1 | 0, c = ((p & c | 0) == 0 ? 0 : (p + c & 0 - o) - c | 0) + k | 0, o = b[5937] | 0, p = c + o | 0, c >>> 0 > m >>> 0 & c >>> 0 < 2147483647) : 0) {
                        n = b[5939] | 0;
                        if (n | 0 ? p >>> 0 <= o >>> 0 | p >>> 0 > n >>> 0 : 0) {
                            c = 0;
                            break;
                        }
                        a = id(c | 0) | 0;
                        if ((a | 0) == (d | 0)) {
                            h = c;
                            g = d;
                            q = 145;
                            break d;
                        } else {
                            e = a;
                            q = 136;
                        }
                    } else c = 0;
                }
                while (0);
                do if ((q | 0) == 136) {
                    d = 0 - c | 0;
                    if (!(i >>> 0 > c >>> 0 & (c >>> 0 < 2147483647 & (e | 0) != -1))) {
                        if ((e | 0) == -1) {
                            c = 0;
                            break;
                        } else {
                            h = c;
                            g = e;
                            q = 145;
                            break d;
                        }
                    }
                    a = b[5949] | 0;
                    a = j - c + a & 0 - a;
                    if (a >>> 0 >= 2147483647) {
                        h = c;
                        g = e;
                        q = 145;
                        break d;
                    }
                    if ((id(a | 0) | 0) == -1) {
                        id(d | 0);
                        c = 0;
                        break;
                    } else {
                        h = a + c | 0;
                        g = e;
                        q = 145;
                        break d;
                    }
                }
                while (0);
                b[5940] = b[5940] | 4;
                q = 143;
            } else {
                c = 0;
                q = 143;
            }
            while (0);
            if (((q | 0) == 143 ? k >>> 0 < 2147483647 : 0) ? (t = id(k | 0) | 0, p = id(0) | 0, r = p - t | 0, s = r >>> 0 > (m + 40 | 0) >>> 0, !((t | 0) == -1 | s ^ 1 | t >>> 0 < p >>> 0 & ((t | 0) != -1 & (p | 0) != -1) ^ 1)) : 0) {
                h = s ? r : c;
                g = t;
                q = 145;
            }
            if ((q | 0) == 145) {
                c = (b[5937] | 0) + h | 0;
                b[5937] = c;
                if (c >>> 0 > (b[5938] | 0) >>> 0) b[5938] = c;
                j = b[5835] | 0;
                f: do if (j) {
                    c = 23764;
                    while(true){
                        a = b[c >> 2] | 0;
                        d = b[c + 4 >> 2] | 0;
                        if ((g | 0) == (a + d | 0)) {
                            q = 154;
                            break;
                        }
                        e = b[c + 8 >> 2] | 0;
                        if (!e) break;
                        else c = e;
                    }
                    if (((q | 0) == 154 ? (u = c + 4 | 0, (b[c + 12 >> 2] & 8 | 0) == 0) : 0) ? g >>> 0 > j >>> 0 & a >>> 0 <= j >>> 0 : 0) {
                        b[u >> 2] = d + h;
                        v = (b[5832] | 0) + h | 0;
                        t = j + 8 | 0;
                        t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                        u = j + t | 0;
                        t = v - t | 0;
                        b[5835] = u;
                        b[5832] = t;
                        b[u + 4 >> 2] = t | 1;
                        b[j + v + 4 >> 2] = 40;
                        b[5836] = b[5951];
                        break;
                    }
                    if (g >>> 0 < (b[5833] | 0) >>> 0) b[5833] = g;
                    d = g + h | 0;
                    c = 23764;
                    while(true){
                        if ((b[c >> 2] | 0) == (d | 0)) {
                            q = 162;
                            break;
                        }
                        a = b[c + 8 >> 2] | 0;
                        if (!a) break;
                        else c = a;
                    }
                    if ((q | 0) == 162 ? (b[c + 12 >> 2] & 8 | 0) == 0 : 0) {
                        b[c >> 2] = g;
                        l = c + 4 | 0;
                        b[l >> 2] = (b[l >> 2] | 0) + h;
                        l = g + 8 | 0;
                        l = g + ((l & 7 | 0) == 0 ? 0 : 0 - l & 7) | 0;
                        c = d + 8 | 0;
                        c = d + ((c & 7 | 0) == 0 ? 0 : 0 - c & 7) | 0;
                        k = l + m | 0;
                        i = c - l - m | 0;
                        b[l + 4 >> 2] = m | 3;
                        g: do if ((j | 0) == (c | 0)) {
                            v = (b[5832] | 0) + i | 0;
                            b[5832] = v;
                            b[5835] = k;
                            b[k + 4 >> 2] = v | 1;
                        } else {
                            if ((b[5834] | 0) == (c | 0)) {
                                v = (b[5831] | 0) + i | 0;
                                b[5831] = v;
                                b[5834] = k;
                                b[k + 4 >> 2] = v | 1;
                                b[k + v >> 2] = v;
                                break;
                            }
                            a = b[c + 4 >> 2] | 0;
                            if ((a & 3 | 0) == 1) {
                                h = a & -8;
                                e = a >>> 3;
                                h: do if (a >>> 0 < 256) {
                                    a = b[c + 8 >> 2] | 0;
                                    d = b[c + 12 >> 2] | 0;
                                    if ((d | 0) == (a | 0)) {
                                        b[5829] = b[5829] & ~(1 << e);
                                        break;
                                    } else {
                                        b[a + 12 >> 2] = d;
                                        b[d + 8 >> 2] = a;
                                        break;
                                    }
                                } else {
                                    g = b[c + 24 >> 2] | 0;
                                    a = b[c + 12 >> 2] | 0;
                                    do if ((a | 0) == (c | 0)) {
                                        d = c + 16 | 0;
                                        e = d + 4 | 0;
                                        a = b[e >> 2] | 0;
                                        if (!a) {
                                            a = b[d >> 2] | 0;
                                            if (!a) {
                                                a = 0;
                                                break;
                                            }
                                        } else d = e;
                                        while(true){
                                            f = a + 20 | 0;
                                            e = b[f >> 2] | 0;
                                            if (!e) {
                                                f = a + 16 | 0;
                                                e = b[f >> 2] | 0;
                                                if (!e) break;
                                                else {
                                                    a = e;
                                                    d = f;
                                                }
                                            } else {
                                                a = e;
                                                d = f;
                                            }
                                        }
                                        b[d >> 2] = 0;
                                    } else {
                                        v = b[c + 8 >> 2] | 0;
                                        b[v + 12 >> 2] = a;
                                        b[a + 8 >> 2] = v;
                                    }
                                    while (0);
                                    if (!g) break;
                                    d = b[c + 28 >> 2] | 0;
                                    e = 23620 + (d << 2) | 0;
                                    do if ((b[e >> 2] | 0) != (c | 0)) {
                                        v = g + 16 | 0;
                                        b[((b[v >> 2] | 0) == (c | 0) ? v : g + 20 | 0) >> 2] = a;
                                        if (!a) break h;
                                    } else {
                                        b[e >> 2] = a;
                                        if (a | 0) break;
                                        b[5830] = b[5830] & ~(1 << d);
                                        break h;
                                    }
                                    while (0);
                                    b[a + 24 >> 2] = g;
                                    d = c + 16 | 0;
                                    e = b[d >> 2] | 0;
                                    if (e | 0) {
                                        b[a + 16 >> 2] = e;
                                        b[e + 24 >> 2] = a;
                                    }
                                    d = b[d + 4 >> 2] | 0;
                                    if (!d) break;
                                    b[a + 20 >> 2] = d;
                                    b[d + 24 >> 2] = a;
                                }
                                while (0);
                                c = c + h | 0;
                                f = h + i | 0;
                            } else f = i;
                            c = c + 4 | 0;
                            b[c >> 2] = b[c >> 2] & -2;
                            b[k + 4 >> 2] = f | 1;
                            b[k + f >> 2] = f;
                            c = f >>> 3;
                            if (f >>> 0 < 256) {
                                d = 23356 + (c << 1 << 2) | 0;
                                a = b[5829] | 0;
                                c = 1 << c;
                                if (!(a & c)) {
                                    b[5829] = a | c;
                                    c = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    c = b[a >> 2] | 0;
                                }
                                b[a >> 2] = k;
                                b[c + 12 >> 2] = k;
                                b[k + 8 >> 2] = c;
                                b[k + 12 >> 2] = d;
                                break;
                            }
                            c = f >>> 8;
                            do if (!c) e = 0;
                            else {
                                if (f >>> 0 > 16777215) {
                                    e = 31;
                                    break;
                                }
                                u = (c + 1048320 | 0) >>> 16 & 8;
                                v = c << u;
                                t = (v + 520192 | 0) >>> 16 & 4;
                                v = v << t;
                                e = (v + 245760 | 0) >>> 16 & 2;
                                e = 14 - (t | u | e) + (v << e >>> 15) | 0;
                                e = f >>> (e + 7 | 0) & 1 | e << 1;
                            }
                            while (0);
                            c = 23620 + (e << 2) | 0;
                            b[k + 28 >> 2] = e;
                            a = k + 16 | 0;
                            b[a + 4 >> 2] = 0;
                            b[a >> 2] = 0;
                            a = b[5830] | 0;
                            d = 1 << e;
                            if (!(a & d)) {
                                b[5830] = a | d;
                                b[c >> 2] = k;
                                b[k + 24 >> 2] = c;
                                b[k + 12 >> 2] = k;
                                b[k + 8 >> 2] = k;
                                break;
                            }
                            c = b[c >> 2] | 0;
                            i: do if ((b[c + 4 >> 2] & -8 | 0) != (f | 0)) {
                                e = f << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                                while(true){
                                    d = c + 16 + (e >>> 31 << 2) | 0;
                                    a = b[d >> 2] | 0;
                                    if (!a) break;
                                    if ((b[a + 4 >> 2] & -8 | 0) == (f | 0)) {
                                        c = a;
                                        break i;
                                    } else {
                                        e = e << 1;
                                        c = a;
                                    }
                                }
                                b[d >> 2] = k;
                                b[k + 24 >> 2] = c;
                                b[k + 12 >> 2] = k;
                                b[k + 8 >> 2] = k;
                                break g;
                            }
                            while (0);
                            u = c + 8 | 0;
                            v = b[u >> 2] | 0;
                            b[v + 12 >> 2] = k;
                            b[u >> 2] = k;
                            b[k + 8 >> 2] = v;
                            b[k + 12 >> 2] = c;
                            b[k + 24 >> 2] = 0;
                        }
                        while (0);
                        v = l + 8 | 0;
                        S = w;
                        return v | 0;
                    }
                    c = 23764;
                    while(true){
                        a = b[c >> 2] | 0;
                        if (a >>> 0 <= j >>> 0 ? (v = a + (b[c + 4 >> 2] | 0) | 0, v >>> 0 > j >>> 0) : 0) break;
                        c = b[c + 8 >> 2] | 0;
                    }
                    f = v + -47 | 0;
                    a = f + 8 | 0;
                    a = f + ((a & 7 | 0) == 0 ? 0 : 0 - a & 7) | 0;
                    f = j + 16 | 0;
                    a = a >>> 0 < f >>> 0 ? j : a;
                    c = a + 8 | 0;
                    d = h + -40 | 0;
                    t = g + 8 | 0;
                    t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                    u = g + t | 0;
                    t = d - t | 0;
                    b[5835] = u;
                    b[5832] = t;
                    b[u + 4 >> 2] = t | 1;
                    b[g + d + 4 >> 2] = 40;
                    b[5836] = b[5951];
                    d = a + 4 | 0;
                    b[d >> 2] = 27;
                    b[c >> 2] = b[5941];
                    b[c + 4 >> 2] = b[5942];
                    b[c + 8 >> 2] = b[5943];
                    b[c + 12 >> 2] = b[5944];
                    b[5941] = g;
                    b[5942] = h;
                    b[5944] = 0;
                    b[5943] = c;
                    c = a + 24 | 0;
                    do {
                        u = c;
                        c = c + 4 | 0;
                        b[c >> 2] = 7;
                    }while ((u + 8 | 0) >>> 0 < v >>> 0);
                    if ((a | 0) != (j | 0)) {
                        g = a - j | 0;
                        b[d >> 2] = b[d >> 2] & -2;
                        b[j + 4 >> 2] = g | 1;
                        b[a >> 2] = g;
                        c = g >>> 3;
                        if (g >>> 0 < 256) {
                            d = 23356 + (c << 1 << 2) | 0;
                            a = b[5829] | 0;
                            c = 1 << c;
                            if (!(a & c)) {
                                b[5829] = a | c;
                                c = d;
                                a = d + 8 | 0;
                            } else {
                                a = d + 8 | 0;
                                c = b[a >> 2] | 0;
                            }
                            b[a >> 2] = j;
                            b[c + 12 >> 2] = j;
                            b[j + 8 >> 2] = c;
                            b[j + 12 >> 2] = d;
                            break;
                        }
                        c = g >>> 8;
                        if (c) {
                            if (g >>> 0 > 16777215) e = 31;
                            else {
                                u = (c + 1048320 | 0) >>> 16 & 8;
                                v = c << u;
                                t = (v + 520192 | 0) >>> 16 & 4;
                                v = v << t;
                                e = (v + 245760 | 0) >>> 16 & 2;
                                e = 14 - (t | u | e) + (v << e >>> 15) | 0;
                                e = g >>> (e + 7 | 0) & 1 | e << 1;
                            }
                        } else e = 0;
                        d = 23620 + (e << 2) | 0;
                        b[j + 28 >> 2] = e;
                        b[j + 20 >> 2] = 0;
                        b[f >> 2] = 0;
                        c = b[5830] | 0;
                        a = 1 << e;
                        if (!(c & a)) {
                            b[5830] = c | a;
                            b[d >> 2] = j;
                            b[j + 24 >> 2] = d;
                            b[j + 12 >> 2] = j;
                            b[j + 8 >> 2] = j;
                            break;
                        }
                        c = b[d >> 2] | 0;
                        j: do if ((b[c + 4 >> 2] & -8 | 0) != (g | 0)) {
                            e = g << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                            while(true){
                                d = c + 16 + (e >>> 31 << 2) | 0;
                                a = b[d >> 2] | 0;
                                if (!a) break;
                                if ((b[a + 4 >> 2] & -8 | 0) == (g | 0)) {
                                    c = a;
                                    break j;
                                } else {
                                    e = e << 1;
                                    c = a;
                                }
                            }
                            b[d >> 2] = j;
                            b[j + 24 >> 2] = c;
                            b[j + 12 >> 2] = j;
                            b[j + 8 >> 2] = j;
                            break f;
                        }
                        while (0);
                        u = c + 8 | 0;
                        v = b[u >> 2] | 0;
                        b[v + 12 >> 2] = j;
                        b[u >> 2] = j;
                        b[j + 8 >> 2] = v;
                        b[j + 12 >> 2] = c;
                        b[j + 24 >> 2] = 0;
                    }
                } else {
                    v = b[5833] | 0;
                    if ((v | 0) == 0 | g >>> 0 < v >>> 0) b[5833] = g;
                    b[5941] = g;
                    b[5942] = h;
                    b[5944] = 0;
                    b[5838] = b[5947];
                    b[5837] = -1;
                    b[5842] = 23356;
                    b[5841] = 23356;
                    b[5844] = 23364;
                    b[5843] = 23364;
                    b[5846] = 23372;
                    b[5845] = 23372;
                    b[5848] = 23380;
                    b[5847] = 23380;
                    b[5850] = 23388;
                    b[5849] = 23388;
                    b[5852] = 23396;
                    b[5851] = 23396;
                    b[5854] = 23404;
                    b[5853] = 23404;
                    b[5856] = 23412;
                    b[5855] = 23412;
                    b[5858] = 23420;
                    b[5857] = 23420;
                    b[5860] = 23428;
                    b[5859] = 23428;
                    b[5862] = 23436;
                    b[5861] = 23436;
                    b[5864] = 23444;
                    b[5863] = 23444;
                    b[5866] = 23452;
                    b[5865] = 23452;
                    b[5868] = 23460;
                    b[5867] = 23460;
                    b[5870] = 23468;
                    b[5869] = 23468;
                    b[5872] = 23476;
                    b[5871] = 23476;
                    b[5874] = 23484;
                    b[5873] = 23484;
                    b[5876] = 23492;
                    b[5875] = 23492;
                    b[5878] = 23500;
                    b[5877] = 23500;
                    b[5880] = 23508;
                    b[5879] = 23508;
                    b[5882] = 23516;
                    b[5881] = 23516;
                    b[5884] = 23524;
                    b[5883] = 23524;
                    b[5886] = 23532;
                    b[5885] = 23532;
                    b[5888] = 23540;
                    b[5887] = 23540;
                    b[5890] = 23548;
                    b[5889] = 23548;
                    b[5892] = 23556;
                    b[5891] = 23556;
                    b[5894] = 23564;
                    b[5893] = 23564;
                    b[5896] = 23572;
                    b[5895] = 23572;
                    b[5898] = 23580;
                    b[5897] = 23580;
                    b[5900] = 23588;
                    b[5899] = 23588;
                    b[5902] = 23596;
                    b[5901] = 23596;
                    b[5904] = 23604;
                    b[5903] = 23604;
                    v = h + -40 | 0;
                    t = g + 8 | 0;
                    t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                    u = g + t | 0;
                    t = v - t | 0;
                    b[5835] = u;
                    b[5832] = t;
                    b[u + 4 >> 2] = t | 1;
                    b[g + v + 4 >> 2] = 40;
                    b[5836] = b[5951];
                }
                while (0);
                c = b[5832] | 0;
                if (c >>> 0 > m >>> 0) {
                    t = c - m | 0;
                    b[5832] = t;
                    v = b[5835] | 0;
                    u = v + m | 0;
                    b[5835] = u;
                    b[u + 4 >> 2] = t | 1;
                    b[v + 4 >> 2] = m | 3;
                    v = v + 8 | 0;
                    S = w;
                    return v | 0;
                }
            }
            v = Sc() | 0;
            b[v >> 2] = 12;
            v = 0;
            S = w;
            return v | 0;
        }
        function Wc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            if (!a) return;
            d = a + -8 | 0;
            f = b[5833] | 0;
            a = b[a + -4 >> 2] | 0;
            c = a & -8;
            j = d + c | 0;
            do if (!(a & 1)) {
                e = b[d >> 2] | 0;
                if (!(a & 3)) return;
                h = d + (0 - e) | 0;
                g = e + c | 0;
                if (h >>> 0 < f >>> 0) return;
                if ((b[5834] | 0) == (h | 0)) {
                    a = j + 4 | 0;
                    c = b[a >> 2] | 0;
                    if ((c & 3 | 0) != 3) {
                        i = h;
                        c = g;
                        break;
                    }
                    b[5831] = g;
                    b[a >> 2] = c & -2;
                    b[h + 4 >> 2] = g | 1;
                    b[h + g >> 2] = g;
                    return;
                }
                d = e >>> 3;
                if (e >>> 0 < 256) {
                    a = b[h + 8 >> 2] | 0;
                    c = b[h + 12 >> 2] | 0;
                    if ((c | 0) == (a | 0)) {
                        b[5829] = b[5829] & ~(1 << d);
                        i = h;
                        c = g;
                        break;
                    } else {
                        b[a + 12 >> 2] = c;
                        b[c + 8 >> 2] = a;
                        i = h;
                        c = g;
                        break;
                    }
                }
                f = b[h + 24 >> 2] | 0;
                a = b[h + 12 >> 2] | 0;
                do if ((a | 0) == (h | 0)) {
                    c = h + 16 | 0;
                    d = c + 4 | 0;
                    a = b[d >> 2] | 0;
                    if (!a) {
                        a = b[c >> 2] | 0;
                        if (!a) {
                            a = 0;
                            break;
                        }
                    } else c = d;
                    while(true){
                        e = a + 20 | 0;
                        d = b[e >> 2] | 0;
                        if (!d) {
                            e = a + 16 | 0;
                            d = b[e >> 2] | 0;
                            if (!d) break;
                            else {
                                a = d;
                                c = e;
                            }
                        } else {
                            a = d;
                            c = e;
                        }
                    }
                    b[c >> 2] = 0;
                } else {
                    i = b[h + 8 >> 2] | 0;
                    b[i + 12 >> 2] = a;
                    b[a + 8 >> 2] = i;
                }
                while (0);
                if (f) {
                    c = b[h + 28 >> 2] | 0;
                    d = 23620 + (c << 2) | 0;
                    if ((b[d >> 2] | 0) == (h | 0)) {
                        b[d >> 2] = a;
                        if (!a) {
                            b[5830] = b[5830] & ~(1 << c);
                            i = h;
                            c = g;
                            break;
                        }
                    } else {
                        i = f + 16 | 0;
                        b[((b[i >> 2] | 0) == (h | 0) ? i : f + 20 | 0) >> 2] = a;
                        if (!a) {
                            i = h;
                            c = g;
                            break;
                        }
                    }
                    b[a + 24 >> 2] = f;
                    c = h + 16 | 0;
                    d = b[c >> 2] | 0;
                    if (d | 0) {
                        b[a + 16 >> 2] = d;
                        b[d + 24 >> 2] = a;
                    }
                    c = b[c + 4 >> 2] | 0;
                    if (c) {
                        b[a + 20 >> 2] = c;
                        b[c + 24 >> 2] = a;
                        i = h;
                        c = g;
                    } else {
                        i = h;
                        c = g;
                    }
                } else {
                    i = h;
                    c = g;
                }
            } else {
                i = d;
                h = d;
            }
            while (0);
            if (h >>> 0 >= j >>> 0) return;
            a = j + 4 | 0;
            e = b[a >> 2] | 0;
            if (!(e & 1)) return;
            if (!(e & 2)) {
                if ((b[5835] | 0) == (j | 0)) {
                    j = (b[5832] | 0) + c | 0;
                    b[5832] = j;
                    b[5835] = i;
                    b[i + 4 >> 2] = j | 1;
                    if ((i | 0) != (b[5834] | 0)) return;
                    b[5834] = 0;
                    b[5831] = 0;
                    return;
                }
                if ((b[5834] | 0) == (j | 0)) {
                    j = (b[5831] | 0) + c | 0;
                    b[5831] = j;
                    b[5834] = h;
                    b[i + 4 >> 2] = j | 1;
                    b[h + j >> 2] = j;
                    return;
                }
                f = (e & -8) + c | 0;
                d = e >>> 3;
                do if (e >>> 0 < 256) {
                    c = b[j + 8 >> 2] | 0;
                    a = b[j + 12 >> 2] | 0;
                    if ((a | 0) == (c | 0)) {
                        b[5829] = b[5829] & ~(1 << d);
                        break;
                    } else {
                        b[c + 12 >> 2] = a;
                        b[a + 8 >> 2] = c;
                        break;
                    }
                } else {
                    g = b[j + 24 >> 2] | 0;
                    a = b[j + 12 >> 2] | 0;
                    do if ((a | 0) == (j | 0)) {
                        c = j + 16 | 0;
                        d = c + 4 | 0;
                        a = b[d >> 2] | 0;
                        if (!a) {
                            a = b[c >> 2] | 0;
                            if (!a) {
                                d = 0;
                                break;
                            }
                        } else c = d;
                        while(true){
                            e = a + 20 | 0;
                            d = b[e >> 2] | 0;
                            if (!d) {
                                e = a + 16 | 0;
                                d = b[e >> 2] | 0;
                                if (!d) break;
                                else {
                                    a = d;
                                    c = e;
                                }
                            } else {
                                a = d;
                                c = e;
                            }
                        }
                        b[c >> 2] = 0;
                        d = a;
                    } else {
                        d = b[j + 8 >> 2] | 0;
                        b[d + 12 >> 2] = a;
                        b[a + 8 >> 2] = d;
                        d = a;
                    }
                    while (0);
                    if (g | 0) {
                        a = b[j + 28 >> 2] | 0;
                        c = 23620 + (a << 2) | 0;
                        if ((b[c >> 2] | 0) == (j | 0)) {
                            b[c >> 2] = d;
                            if (!d) {
                                b[5830] = b[5830] & ~(1 << a);
                                break;
                            }
                        } else {
                            e = g + 16 | 0;
                            b[((b[e >> 2] | 0) == (j | 0) ? e : g + 20 | 0) >> 2] = d;
                            if (!d) break;
                        }
                        b[d + 24 >> 2] = g;
                        a = j + 16 | 0;
                        c = b[a >> 2] | 0;
                        if (c | 0) {
                            b[d + 16 >> 2] = c;
                            b[c + 24 >> 2] = d;
                        }
                        a = b[a + 4 >> 2] | 0;
                        if (a | 0) {
                            b[d + 20 >> 2] = a;
                            b[a + 24 >> 2] = d;
                        }
                    }
                }
                while (0);
                b[i + 4 >> 2] = f | 1;
                b[h + f >> 2] = f;
                if ((i | 0) == (b[5834] | 0)) {
                    b[5831] = f;
                    return;
                }
            } else {
                b[a >> 2] = e & -2;
                b[i + 4 >> 2] = c | 1;
                b[h + c >> 2] = c;
                f = c;
            }
            a = f >>> 3;
            if (f >>> 0 < 256) {
                d = 23356 + (a << 1 << 2) | 0;
                c = b[5829] | 0;
                a = 1 << a;
                if (!(c & a)) {
                    b[5829] = c | a;
                    a = d;
                    c = d + 8 | 0;
                } else {
                    c = d + 8 | 0;
                    a = b[c >> 2] | 0;
                }
                b[c >> 2] = i;
                b[a + 12 >> 2] = i;
                b[i + 8 >> 2] = a;
                b[i + 12 >> 2] = d;
                return;
            }
            a = f >>> 8;
            if (a) {
                if (f >>> 0 > 16777215) e = 31;
                else {
                    h = (a + 1048320 | 0) >>> 16 & 8;
                    j = a << h;
                    g = (j + 520192 | 0) >>> 16 & 4;
                    j = j << g;
                    e = (j + 245760 | 0) >>> 16 & 2;
                    e = 14 - (g | h | e) + (j << e >>> 15) | 0;
                    e = f >>> (e + 7 | 0) & 1 | e << 1;
                }
            } else e = 0;
            a = 23620 + (e << 2) | 0;
            b[i + 28 >> 2] = e;
            b[i + 20 >> 2] = 0;
            b[i + 16 >> 2] = 0;
            c = b[5830] | 0;
            d = 1 << e;
            a: do if (!(c & d)) {
                b[5830] = c | d;
                b[a >> 2] = i;
                b[i + 24 >> 2] = a;
                b[i + 12 >> 2] = i;
                b[i + 8 >> 2] = i;
            } else {
                a = b[a >> 2] | 0;
                b: do if ((b[a + 4 >> 2] & -8 | 0) != (f | 0)) {
                    e = f << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                    while(true){
                        d = a + 16 + (e >>> 31 << 2) | 0;
                        c = b[d >> 2] | 0;
                        if (!c) break;
                        if ((b[c + 4 >> 2] & -8 | 0) == (f | 0)) {
                            a = c;
                            break b;
                        } else {
                            e = e << 1;
                            a = c;
                        }
                    }
                    b[d >> 2] = i;
                    b[i + 24 >> 2] = a;
                    b[i + 12 >> 2] = i;
                    b[i + 8 >> 2] = i;
                    break a;
                }
                while (0);
                h = a + 8 | 0;
                j = b[h >> 2] | 0;
                b[j + 12 >> 2] = i;
                b[h >> 2] = i;
                b[i + 8 >> 2] = j;
                b[i + 12 >> 2] = a;
                b[i + 24 >> 2] = 0;
            }
            while (0);
            j = (b[5837] | 0) + -1 | 0;
            b[5837] = j;
            if (j | 0) return;
            a = 23772;
            while(true){
                a = b[a >> 2] | 0;
                if (!a) break;
                else a = a + 8 | 0;
            }
            b[5837] = -1;
            return;
        }
        function Xc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            if (a) {
                d = B(c, a) | 0;
                if ((c | a) >>> 0 > 65535) d = ((d >>> 0) / (a >>> 0) | 0) == (c | 0) ? d : -1;
            } else d = 0;
            a = Vc(d) | 0;
            if (!a) return a | 0;
            if (!(b[a + -4 >> 2] & 3)) return a | 0;
            gd(a | 0, 0, d | 0);
            return a | 0;
        }
        function Yc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            c = a + c >>> 0;
            return (F(b + d + (c >>> 0 < a >>> 0 | 0) >>> 0 | 0), c | 0) | 0;
        }
        function Zc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            d = b - d - (c >>> 0 > a >>> 0 | 0) >>> 0;
            return (F(d | 0), a - c >>> 0 | 0) | 0;
        }
        function _c(a) {
            a = a | 0;
            return (a ? 31 - (D(a ^ a - 1) | 0) | 0 : 32) | 0;
        }
        function $c(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            l = a;
            j = c;
            k = j;
            h = d;
            n = e;
            i = n;
            if (!k) {
                g = (f | 0) != 0;
                if (!i) {
                    if (g) {
                        b[f >> 2] = (l >>> 0) % (h >>> 0);
                        b[f + 4 >> 2] = 0;
                    }
                    n = 0;
                    f = (l >>> 0) / (h >>> 0) >>> 0;
                    return (F(n | 0), f) | 0;
                } else {
                    if (!g) {
                        n = 0;
                        f = 0;
                        return (F(n | 0), f) | 0;
                    }
                    b[f >> 2] = a | 0;
                    b[f + 4 >> 2] = c & 0;
                    n = 0;
                    f = 0;
                    return (F(n | 0), f) | 0;
                }
            }
            g = (i | 0) == 0;
            do if (h) {
                if (!g) {
                    g = (D(i | 0) | 0) - (D(k | 0) | 0) | 0;
                    if (g >>> 0 <= 31) {
                        m = g + 1 | 0;
                        i = 31 - g | 0;
                        c = g - 31 >> 31;
                        h = m;
                        a = l >>> (m >>> 0) & c | k << i;
                        c = k >>> (m >>> 0) & c;
                        g = 0;
                        i = l << i;
                        break;
                    }
                    if (!f) {
                        n = 0;
                        f = 0;
                        return (F(n | 0), f) | 0;
                    }
                    b[f >> 2] = a | 0;
                    b[f + 4 >> 2] = j | c & 0;
                    n = 0;
                    f = 0;
                    return (F(n | 0), f) | 0;
                }
                g = h - 1 | 0;
                if (g & h | 0) {
                    i = (D(h | 0) | 0) + 33 - (D(k | 0) | 0) | 0;
                    p = 64 - i | 0;
                    m = 32 - i | 0;
                    j = m >> 31;
                    o = i - 32 | 0;
                    c = o >> 31;
                    h = i;
                    a = m - 1 >> 31 & k >>> (o >>> 0) | (k << m | l >>> (i >>> 0)) & c;
                    c = c & k >>> (i >>> 0);
                    g = l << p & j;
                    i = (k << p | l >>> (o >>> 0)) & j | l << m & i - 33 >> 31;
                    break;
                }
                if (f | 0) {
                    b[f >> 2] = g & l;
                    b[f + 4 >> 2] = 0;
                }
                if ((h | 0) == 1) {
                    o = j | c & 0;
                    p = a | 0;
                    return (F(o | 0), p) | 0;
                } else {
                    p = _c(h | 0) | 0;
                    o = k >>> (p >>> 0) | 0;
                    p = k << 32 - p | l >>> (p >>> 0) | 0;
                    return (F(o | 0), p) | 0;
                }
            } else {
                if (g) {
                    if (f | 0) {
                        b[f >> 2] = (k >>> 0) % (h >>> 0);
                        b[f + 4 >> 2] = 0;
                    }
                    o = 0;
                    p = (k >>> 0) / (h >>> 0) >>> 0;
                    return (F(o | 0), p) | 0;
                }
                if (!l) {
                    if (f | 0) {
                        b[f >> 2] = 0;
                        b[f + 4 >> 2] = (k >>> 0) % (i >>> 0);
                    }
                    o = 0;
                    p = (k >>> 0) / (i >>> 0) >>> 0;
                    return (F(o | 0), p) | 0;
                }
                g = i - 1 | 0;
                if (!(g & i)) {
                    if (f | 0) {
                        b[f >> 2] = a | 0;
                        b[f + 4 >> 2] = g & k | c & 0;
                    }
                    o = 0;
                    p = k >>> ((_c(i | 0) | 0) >>> 0);
                    return (F(o | 0), p) | 0;
                }
                g = (D(i | 0) | 0) - (D(k | 0) | 0) | 0;
                if (g >>> 0 <= 30) {
                    c = g + 1 | 0;
                    i = 31 - g | 0;
                    h = c;
                    a = k << i | l >>> (c >>> 0);
                    c = k >>> (c >>> 0);
                    g = 0;
                    i = l << i;
                    break;
                }
                if (!f) {
                    o = 0;
                    p = 0;
                    return (F(o | 0), p) | 0;
                }
                b[f >> 2] = a | 0;
                b[f + 4 >> 2] = j | c & 0;
                o = 0;
                p = 0;
                return (F(o | 0), p) | 0;
            }
            while (0);
            if (!h) {
                k = i;
                j = 0;
                i = 0;
            } else {
                m = d | 0;
                l = n | e & 0;
                k = Yc(m | 0, l | 0, -1, -1) | 0;
                d = G() | 0;
                j = i;
                i = 0;
                do {
                    e = j;
                    j = g >>> 31 | j << 1;
                    g = i | g << 1;
                    e = a << 1 | e >>> 31 | 0;
                    n = a >>> 31 | c << 1 | 0;
                    Zc(k | 0, d | 0, e | 0, n | 0);
                    p = G() | 0;
                    o = p >> 31 | ((p | 0) < 0 ? -1 : 0) << 1;
                    i = o & 1;
                    a = Zc(e | 0, n | 0, o & m | 0, (((p | 0) < 0 ? -1 : 0) >> 31 | ((p | 0) < 0 ? -1 : 0) << 1) & l | 0) | 0;
                    c = G() | 0;
                    h = h - 1 | 0;
                }while ((h | 0) != 0);
                k = j;
                j = 0;
            }
            h = 0;
            if (f | 0) {
                b[f >> 2] = a;
                b[f + 4 >> 2] = c;
            }
            o = (g | 0) >>> 31 | (k | h) << 1 | (h << 1 | g >>> 31) & 0 | j;
            p = (g << 1 | 0) & -2 | i;
            return (F(o | 0), p) | 0;
        }
        function ad(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = S;
            S = S + 16 | 0;
            f = g | 0;
            $c(a, c, d, e, f);
            S = g;
            return (F(b[f + 4 >> 2] | 0), b[f >> 2] | 0) | 0;
        }
        function bd(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                F(b >>> c | 0);
                return a >>> c | (b & (1 << c) - 1) << 32 - c;
            }
            F(0);
            return b >>> c - 32 | 0;
        }
        function cd(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                F(b << c | (a & (1 << c) - 1 << 32 - c) >>> 32 - c | 0);
                return a << c;
            }
            F(a << c - 32 | 0);
            return 0;
        }
        function dd(a, b) {
            a = +a;
            b = +b;
            if (a != a) return +b;
            if (b != b) return +a;
            return +C(+a, +b);
        }
        function ed(a) {
            a = +a;
            return a >= 0.0 ? +p(a + .5) : +A(a - .5);
        }
        function fd(c, d, e) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0;
            if ((e | 0) >= 8192) {
                K(c | 0, d | 0, e | 0);
                return c | 0;
            }
            h = c | 0;
            g = c + e | 0;
            if ((c & 3) == (d & 3)) {
                while(c & 3){
                    if (!e) return h | 0;
                    a[c >> 0] = a[d >> 0] | 0;
                    c = c + 1 | 0;
                    d = d + 1 | 0;
                    e = e - 1 | 0;
                }
                e = g & -4 | 0;
                f = e - 64 | 0;
                while((c | 0) <= (f | 0)){
                    b[c >> 2] = b[d >> 2];
                    b[c + 4 >> 2] = b[d + 4 >> 2];
                    b[c + 8 >> 2] = b[d + 8 >> 2];
                    b[c + 12 >> 2] = b[d + 12 >> 2];
                    b[c + 16 >> 2] = b[d + 16 >> 2];
                    b[c + 20 >> 2] = b[d + 20 >> 2];
                    b[c + 24 >> 2] = b[d + 24 >> 2];
                    b[c + 28 >> 2] = b[d + 28 >> 2];
                    b[c + 32 >> 2] = b[d + 32 >> 2];
                    b[c + 36 >> 2] = b[d + 36 >> 2];
                    b[c + 40 >> 2] = b[d + 40 >> 2];
                    b[c + 44 >> 2] = b[d + 44 >> 2];
                    b[c + 48 >> 2] = b[d + 48 >> 2];
                    b[c + 52 >> 2] = b[d + 52 >> 2];
                    b[c + 56 >> 2] = b[d + 56 >> 2];
                    b[c + 60 >> 2] = b[d + 60 >> 2];
                    c = c + 64 | 0;
                    d = d + 64 | 0;
                }
                while((c | 0) < (e | 0)){
                    b[c >> 2] = b[d >> 2];
                    c = c + 4 | 0;
                    d = d + 4 | 0;
                }
            } else {
                e = g - 4 | 0;
                while((c | 0) < (e | 0)){
                    a[c >> 0] = a[d >> 0] | 0;
                    a[c + 1 >> 0] = a[d + 1 >> 0] | 0;
                    a[c + 2 >> 0] = a[d + 2 >> 0] | 0;
                    a[c + 3 >> 0] = a[d + 3 >> 0] | 0;
                    c = c + 4 | 0;
                    d = d + 4 | 0;
                }
            }
            while((c | 0) < (g | 0)){
                a[c >> 0] = a[d >> 0] | 0;
                c = c + 1 | 0;
                d = d + 1 | 0;
            }
            return h | 0;
        }
        function gd(c, d, e) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = c + e | 0;
            d = d & 255;
            if ((e | 0) >= 67) {
                while(c & 3){
                    a[c >> 0] = d;
                    c = c + 1 | 0;
                }
                f = h & -4 | 0;
                i = d | d << 8 | d << 16 | d << 24;
                g = f - 64 | 0;
                while((c | 0) <= (g | 0)){
                    b[c >> 2] = i;
                    b[c + 4 >> 2] = i;
                    b[c + 8 >> 2] = i;
                    b[c + 12 >> 2] = i;
                    b[c + 16 >> 2] = i;
                    b[c + 20 >> 2] = i;
                    b[c + 24 >> 2] = i;
                    b[c + 28 >> 2] = i;
                    b[c + 32 >> 2] = i;
                    b[c + 36 >> 2] = i;
                    b[c + 40 >> 2] = i;
                    b[c + 44 >> 2] = i;
                    b[c + 48 >> 2] = i;
                    b[c + 52 >> 2] = i;
                    b[c + 56 >> 2] = i;
                    b[c + 60 >> 2] = i;
                    c = c + 64 | 0;
                }
                while((c | 0) < (f | 0)){
                    b[c >> 2] = i;
                    c = c + 4 | 0;
                }
            }
            while((c | 0) < (h | 0)){
                a[c >> 0] = d;
                c = c + 1 | 0;
            }
            return h - e | 0;
        }
        function hd(a) {
            a = +a;
            return a >= 0.0 ? +p(a + .5) : +A(a - .5);
        }
        function id(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            e = J() | 0;
            d = b[g >> 2] | 0;
            c = d + a | 0;
            if ((a | 0) > 0 & (c | 0) < (d | 0) | (c | 0) < 0) {
                M(c | 0);
                I(12);
                return -1;
            }
            if ((c | 0) > (e | 0)) {
                if (!(L(c | 0) | 0)) {
                    I(12);
                    return -1;
                }
            }
            b[g >> 2] = c;
            return d | 0;
        } // EMSCRIPTEN_END_FUNCS
        return {
            ___uremdi3: ad,
            _bitshift64Lshr: bd,
            _bitshift64Shl: cd,
            _calloc: Xc,
            _cellAreaKm2: ub,
            _cellAreaM2: vb,
            _cellAreaRads2: tb,
            _compact: Gb,
            _destroyLinkedPolygon: ic,
            _edgeLengthKm: pb,
            _edgeLengthM: qb,
            _emscripten_replace_memory: V,
            _exactEdgeLengthKm: xb,
            _exactEdgeLengthM: yb,
            _exactEdgeLengthRads: wb,
            _experimentalH3ToLocalIj: nc,
            _experimentalLocalIjToH3: oc,
            _free: Wc,
            _geoToH3: Rb,
            _getDestinationH3IndexFromUnidirectionalEdge: bc,
            _getH3IndexesFromUnidirectionalEdge: dc,
            _getH3UnidirectionalEdge: $b,
            _getH3UnidirectionalEdgeBoundary: fc,
            _getH3UnidirectionalEdgesFromHexagon: ec,
            _getOriginH3IndexFromUnidirectionalEdge: ac,
            _getPentagonIndexes: Zb,
            _getRes0Indexes: va,
            _h3Distance: pc,
            _h3GetBaseCell: zb,
            _h3GetFaces: Xb,
            _h3IndexesAreNeighbors: _b,
            _h3IsPentagon: Eb,
            _h3IsResClassIII: Jb,
            _h3IsValid: Ab,
            _h3Line: rc,
            _h3LineSize: qc,
            _h3SetToLinkedGeo: ka,
            _h3ToCenterChild: Fb,
            _h3ToChildren: Db,
            _h3ToGeo: Ub,
            _h3ToGeoBoundary: Vb,
            _h3ToParent: Bb,
            _h3UnidirectionalEdgeIsValid: cc,
            _hexAreaKm2: nb,
            _hexAreaM2: ob,
            _hexRing: ea,
            _i64Subtract: Zc,
            _kRing: $,
            _kRingDistances: aa,
            _llvm_minnum_f64: dd,
            _llvm_round_f64: ed,
            _malloc: Vc,
            _maxFaceCount: Wb,
            _maxH3ToChildrenSize: Cb,
            _maxKringSize: _,
            _maxPolyfillSize: fa,
            _maxUncompactSize: Ib,
            _memcpy: fd,
            _memset: gd,
            _numHexagons: rb,
            _pentagonIndexCount: Yb,
            _pointDistKm: jb,
            _pointDistM: kb,
            _pointDistRads: ib,
            _polyfill: ga,
            _res0IndexCount: ua,
            _round: hd,
            _sbrk: id,
            _sizeOfCoordIJ: Dc,
            _sizeOfGeoBoundary: zc,
            _sizeOfGeoCoord: yc,
            _sizeOfGeoPolygon: Bc,
            _sizeOfGeofence: Ac,
            _sizeOfH3Index: xc,
            _sizeOfLinkedGeoPolygon: Cc,
            _uncompact: Hb,
            establishStackSpace: Z,
            stackAlloc: W,
            stackRestore: Y,
            stackSave: X
        };
    }(asmGlobalArg, asmLibraryArg, buffer);
    var ___uremdi3 = Module["___uremdi3"] = asm["___uremdi3"];
    var _bitshift64Lshr = Module["_bitshift64Lshr"] = asm["_bitshift64Lshr"];
    var _bitshift64Shl = Module["_bitshift64Shl"] = asm["_bitshift64Shl"];
    var _calloc = Module["_calloc"] = asm["_calloc"];
    var _cellAreaKm2 = Module["_cellAreaKm2"] = asm["_cellAreaKm2"];
    var _cellAreaM2 = Module["_cellAreaM2"] = asm["_cellAreaM2"];
    var _cellAreaRads2 = Module["_cellAreaRads2"] = asm["_cellAreaRads2"];
    var _compact = Module["_compact"] = asm["_compact"];
    var _destroyLinkedPolygon = Module["_destroyLinkedPolygon"] = asm["_destroyLinkedPolygon"];
    var _edgeLengthKm = Module["_edgeLengthKm"] = asm["_edgeLengthKm"];
    var _edgeLengthM = Module["_edgeLengthM"] = asm["_edgeLengthM"];
    var _emscripten_replace_memory = Module["_emscripten_replace_memory"] = asm["_emscripten_replace_memory"];
    var _exactEdgeLengthKm = Module["_exactEdgeLengthKm"] = asm["_exactEdgeLengthKm"];
    var _exactEdgeLengthM = Module["_exactEdgeLengthM"] = asm["_exactEdgeLengthM"];
    var _exactEdgeLengthRads = Module["_exactEdgeLengthRads"] = asm["_exactEdgeLengthRads"];
    var _experimentalH3ToLocalIj = Module["_experimentalH3ToLocalIj"] = asm["_experimentalH3ToLocalIj"];
    var _experimentalLocalIjToH3 = Module["_experimentalLocalIjToH3"] = asm["_experimentalLocalIjToH3"];
    var _free = Module["_free"] = asm["_free"];
    var _geoToH3 = Module["_geoToH3"] = asm["_geoToH3"];
    var _getDestinationH3IndexFromUnidirectionalEdge = Module["_getDestinationH3IndexFromUnidirectionalEdge"] = asm["_getDestinationH3IndexFromUnidirectionalEdge"];
    var _getH3IndexesFromUnidirectionalEdge = Module["_getH3IndexesFromUnidirectionalEdge"] = asm["_getH3IndexesFromUnidirectionalEdge"];
    var _getH3UnidirectionalEdge = Module["_getH3UnidirectionalEdge"] = asm["_getH3UnidirectionalEdge"];
    var _getH3UnidirectionalEdgeBoundary = Module["_getH3UnidirectionalEdgeBoundary"] = asm["_getH3UnidirectionalEdgeBoundary"];
    var _getH3UnidirectionalEdgesFromHexagon = Module["_getH3UnidirectionalEdgesFromHexagon"] = asm["_getH3UnidirectionalEdgesFromHexagon"];
    var _getOriginH3IndexFromUnidirectionalEdge = Module["_getOriginH3IndexFromUnidirectionalEdge"] = asm["_getOriginH3IndexFromUnidirectionalEdge"];
    var _getPentagonIndexes = Module["_getPentagonIndexes"] = asm["_getPentagonIndexes"];
    var _getRes0Indexes = Module["_getRes0Indexes"] = asm["_getRes0Indexes"];
    var _h3Distance = Module["_h3Distance"] = asm["_h3Distance"];
    var _h3GetBaseCell = Module["_h3GetBaseCell"] = asm["_h3GetBaseCell"];
    var _h3GetFaces = Module["_h3GetFaces"] = asm["_h3GetFaces"];
    var _h3IndexesAreNeighbors = Module["_h3IndexesAreNeighbors"] = asm["_h3IndexesAreNeighbors"];
    var _h3IsPentagon = Module["_h3IsPentagon"] = asm["_h3IsPentagon"];
    var _h3IsResClassIII = Module["_h3IsResClassIII"] = asm["_h3IsResClassIII"];
    var _h3IsValid = Module["_h3IsValid"] = asm["_h3IsValid"];
    var _h3Line = Module["_h3Line"] = asm["_h3Line"];
    var _h3LineSize = Module["_h3LineSize"] = asm["_h3LineSize"];
    var _h3SetToLinkedGeo = Module["_h3SetToLinkedGeo"] = asm["_h3SetToLinkedGeo"];
    var _h3ToCenterChild = Module["_h3ToCenterChild"] = asm["_h3ToCenterChild"];
    var _h3ToChildren = Module["_h3ToChildren"] = asm["_h3ToChildren"];
    var _h3ToGeo = Module["_h3ToGeo"] = asm["_h3ToGeo"];
    var _h3ToGeoBoundary = Module["_h3ToGeoBoundary"] = asm["_h3ToGeoBoundary"];
    var _h3ToParent = Module["_h3ToParent"] = asm["_h3ToParent"];
    var _h3UnidirectionalEdgeIsValid = Module["_h3UnidirectionalEdgeIsValid"] = asm["_h3UnidirectionalEdgeIsValid"];
    var _hexAreaKm2 = Module["_hexAreaKm2"] = asm["_hexAreaKm2"];
    var _hexAreaM2 = Module["_hexAreaM2"] = asm["_hexAreaM2"];
    var _hexRing = Module["_hexRing"] = asm["_hexRing"];
    var _i64Subtract = Module["_i64Subtract"] = asm["_i64Subtract"];
    var _kRing = Module["_kRing"] = asm["_kRing"];
    var _kRingDistances = Module["_kRingDistances"] = asm["_kRingDistances"];
    var _llvm_minnum_f64 = Module["_llvm_minnum_f64"] = asm["_llvm_minnum_f64"];
    var _llvm_round_f64 = Module["_llvm_round_f64"] = asm["_llvm_round_f64"];
    var _malloc = Module["_malloc"] = asm["_malloc"];
    var _maxFaceCount = Module["_maxFaceCount"] = asm["_maxFaceCount"];
    var _maxH3ToChildrenSize = Module["_maxH3ToChildrenSize"] = asm["_maxH3ToChildrenSize"];
    var _maxKringSize = Module["_maxKringSize"] = asm["_maxKringSize"];
    var _maxPolyfillSize = Module["_maxPolyfillSize"] = asm["_maxPolyfillSize"];
    var _maxUncompactSize = Module["_maxUncompactSize"] = asm["_maxUncompactSize"];
    var _memcpy = Module["_memcpy"] = asm["_memcpy"];
    var _memset = Module["_memset"] = asm["_memset"];
    var _numHexagons = Module["_numHexagons"] = asm["_numHexagons"];
    var _pentagonIndexCount = Module["_pentagonIndexCount"] = asm["_pentagonIndexCount"];
    var _pointDistKm = Module["_pointDistKm"] = asm["_pointDistKm"];
    var _pointDistM = Module["_pointDistM"] = asm["_pointDistM"];
    var _pointDistRads = Module["_pointDistRads"] = asm["_pointDistRads"];
    var _polyfill = Module["_polyfill"] = asm["_polyfill"];
    var _res0IndexCount = Module["_res0IndexCount"] = asm["_res0IndexCount"];
    var _round = Module["_round"] = asm["_round"];
    var _sbrk = Module["_sbrk"] = asm["_sbrk"];
    var _sizeOfCoordIJ = Module["_sizeOfCoordIJ"] = asm["_sizeOfCoordIJ"];
    var _sizeOfGeoBoundary = Module["_sizeOfGeoBoundary"] = asm["_sizeOfGeoBoundary"];
    var _sizeOfGeoCoord = Module["_sizeOfGeoCoord"] = asm["_sizeOfGeoCoord"];
    var _sizeOfGeoPolygon = Module["_sizeOfGeoPolygon"] = asm["_sizeOfGeoPolygon"];
    var _sizeOfGeofence = Module["_sizeOfGeofence"] = asm["_sizeOfGeofence"];
    var _sizeOfH3Index = Module["_sizeOfH3Index"] = asm["_sizeOfH3Index"];
    var _sizeOfLinkedGeoPolygon = Module["_sizeOfLinkedGeoPolygon"] = asm["_sizeOfLinkedGeoPolygon"];
    var _uncompact = Module["_uncompact"] = asm["_uncompact"];
    var establishStackSpace = Module["establishStackSpace"] = asm["establishStackSpace"];
    var stackAlloc = Module["stackAlloc"] = asm["stackAlloc"];
    var stackRestore = Module["stackRestore"] = asm["stackRestore"];
    var stackSave = Module["stackSave"] = asm["stackSave"];
    Module["asm"] = asm;
    Module["cwrap"] = cwrap;
    Module["setValue"] = setValue;
    Module["getValue"] = getValue;
    Module["getTempRet0"] = getTempRet0;
    if (memoryInitializer) {
        if (!isDataURI(memoryInitializer)) memoryInitializer = locateFile(memoryInitializer);
        addRunDependency("memory initializer");
        var applyMemoryInitializer = function(data) {
            if (data.byteLength) data = new Uint8Array(data);
            HEAPU8.set(data, GLOBAL_BASE);
            if (Module["memoryInitializerRequest"]) delete Module["memoryInitializerRequest"].response;
            removeRunDependency("memory initializer");
        };
        var doBrowserLoad = function() {
            readAsync(memoryInitializer, applyMemoryInitializer, function() {
                throw "could not load memory initializer " + memoryInitializer;
            });
        };
        var memoryInitializerBytes = tryParseAsDataURI(memoryInitializer);
        if (memoryInitializerBytes) applyMemoryInitializer(memoryInitializerBytes.buffer);
        else if (Module["memoryInitializerRequest"]) {
            var useRequest = function() {
                var request = Module["memoryInitializerRequest"];
                var response = request.response;
                if (request.status !== 200 && request.status !== 0) {
                    var data = tryParseAsDataURI(Module["memoryInitializerRequestURL"]);
                    if (data) response = data.buffer;
                    else {
                        console.warn("a problem seems to have happened with Module.memoryInitializerRequest, status: " + request.status + ", retrying " + memoryInitializer);
                        doBrowserLoad();
                        return;
                    }
                }
                applyMemoryInitializer(response);
            };
            if (Module["memoryInitializerRequest"].response) setTimeout(useRequest, 0);
            else Module["memoryInitializerRequest"].addEventListener("load", useRequest);
        } else doBrowserLoad();
    }
    var calledRun;
    dependenciesFulfilled = function runCaller() {
        if (!calledRun) run();
        if (!calledRun) dependenciesFulfilled = runCaller;
    };
    function run(args) {
        args = args || arguments_;
        if (runDependencies > 0) return;
        preRun();
        if (runDependencies > 0) return;
        function doRun() {
            if (calledRun) return;
            calledRun = true;
            if (ABORT) return;
            initRuntime();
            preMain();
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            postRun();
        }
        if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
                setTimeout(function() {
                    Module["setStatus"]("");
                }, 1);
                doRun();
            }, 1);
        } else doRun();
    }
    Module["run"] = run;
    function abort(what) {
        if (Module["onAbort"]) Module["onAbort"](what);
        what += "";
        out(what);
        err(what);
        ABORT = true;
        throw "abort(" + what + "). Build with -s ASSERTIONS=1 for more info.";
    }
    Module["abort"] = abort;
    if (Module["preInit"]) {
        if (typeof Module["preInit"] == "function") Module["preInit"] = [
            Module["preInit"]
        ];
        while(Module["preInit"].length > 0)Module["preInit"].pop()();
    }
    run();
    return libh3;
}(typeof $149c57bfd39d3746$var$libh3 === "object" ? $149c57bfd39d3746$var$libh3 : {});
/*
 * Copyright 2018-2019 Uber Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Define the C bindings for the h3 library
// Add some aliases to make the function definitions more intelligible
var $149c57bfd39d3746$var$NUMBER = "number";
var $149c57bfd39d3746$var$BOOLEAN = $149c57bfd39d3746$var$NUMBER;
var $149c57bfd39d3746$var$H3_LOWER = $149c57bfd39d3746$var$NUMBER;
var $149c57bfd39d3746$var$H3_UPPER = $149c57bfd39d3746$var$NUMBER;
var $149c57bfd39d3746$var$RESOLUTION = $149c57bfd39d3746$var$NUMBER;
var $149c57bfd39d3746$var$POINTER = $149c57bfd39d3746$var$NUMBER; // Define the bindings to functions in the C lib. Functions are defined as
// [name, return type, [arg types]]. You must run `npm run build-emscripten`
// before new functions added here will be available.
var $149c57bfd39d3746$var$BINDINGS = [
    [
        "sizeOfH3Index",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "sizeOfGeoCoord",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "sizeOfGeoBoundary",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "sizeOfGeoPolygon",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "sizeOfGeofence",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "sizeOfLinkedGeoPolygon",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "sizeOfCoordIJ",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "h3IsValid",
        $149c57bfd39d3746$var$BOOLEAN,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "geoToH3",
        $149c57bfd39d3746$var$H3_LOWER,
        [
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "h3ToGeo",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "h3ToGeoBoundary",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "maxKringSize",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$NUMBER
        ]
    ],
    [
        "kRing",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "kRingDistances",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "hexRing",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "maxPolyfillSize",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "polyfill",
        null,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$RESOLUTION,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "h3SetToLinkedGeo",
        null,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "destroyLinkedPolygon",
        null,
        [
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "compact",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$NUMBER
        ]
    ],
    [
        "uncompact",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "maxUncompactSize",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "h3IsPentagon",
        $149c57bfd39d3746$var$BOOLEAN,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "h3IsResClassIII",
        $149c57bfd39d3746$var$BOOLEAN,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "h3GetBaseCell",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "maxFaceCount",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "h3GetFaces",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "h3ToParent",
        $149c57bfd39d3746$var$H3_LOWER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "h3ToChildren",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$RESOLUTION,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "h3ToCenterChild",
        $149c57bfd39d3746$var$H3_LOWER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "maxH3ToChildrenSize",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "h3IndexesAreNeighbors",
        $149c57bfd39d3746$var$BOOLEAN,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "getH3UnidirectionalEdge",
        $149c57bfd39d3746$var$H3_LOWER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "getOriginH3IndexFromUnidirectionalEdge",
        $149c57bfd39d3746$var$H3_LOWER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "getDestinationH3IndexFromUnidirectionalEdge",
        $149c57bfd39d3746$var$H3_LOWER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "h3UnidirectionalEdgeIsValid",
        $149c57bfd39d3746$var$BOOLEAN,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "getH3IndexesFromUnidirectionalEdge",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "getH3UnidirectionalEdgesFromHexagon",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "getH3UnidirectionalEdgeBoundary",
        null,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "h3Distance",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "h3Line",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "h3LineSize",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "experimentalH3ToLocalIj",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "experimentalLocalIjToH3",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER,
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "hexAreaM2",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "hexAreaKm2",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "edgeLengthM",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "edgeLengthKm",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "pointDistM",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "pointDistKm",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "pointDistRads",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$POINTER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "cellAreaM2",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "cellAreaKm2",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "cellAreaRads2",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "exactEdgeLengthM",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "exactEdgeLengthKm",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "exactEdgeLengthRads",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$H3_LOWER,
            $149c57bfd39d3746$var$H3_UPPER
        ]
    ],
    [
        "numHexagons",
        $149c57bfd39d3746$var$NUMBER,
        [
            $149c57bfd39d3746$var$RESOLUTION
        ]
    ],
    [
        "getRes0Indexes",
        null,
        [
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "res0IndexCount",
        $149c57bfd39d3746$var$NUMBER
    ],
    [
        "getPentagonIndexes",
        null,
        [
            $149c57bfd39d3746$var$NUMBER,
            $149c57bfd39d3746$var$POINTER
        ]
    ],
    [
        "pentagonIndexCount",
        $149c57bfd39d3746$var$NUMBER
    ]
];
/*
 * Copyright 2018-2019 Uber Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $149c57bfd39d3746$var$H3 = {}; // Create the bound functions themselves
$149c57bfd39d3746$var$BINDINGS.forEach(function bind(def) {
    $149c57bfd39d3746$var$H3[def[0]] = $149c57bfd39d3746$var$libh3.cwrap.apply($149c57bfd39d3746$var$libh3, def);
}); // Alias the hexidecimal base for legibility
var $149c57bfd39d3746$var$BASE_16 = 16; // ----------------------------------------------------------------------------
// Byte size imports
var $149c57bfd39d3746$var$SZ_INT = 4;
var $149c57bfd39d3746$var$SZ_PTR = 4;
var $149c57bfd39d3746$var$SZ_DBL = 8;
var $149c57bfd39d3746$var$SZ_H3INDEX = $149c57bfd39d3746$var$H3.sizeOfH3Index();
var $149c57bfd39d3746$var$SZ_GEOCOORD = $149c57bfd39d3746$var$H3.sizeOfGeoCoord();
var $149c57bfd39d3746$var$SZ_GEOBOUNDARY = $149c57bfd39d3746$var$H3.sizeOfGeoBoundary();
var $149c57bfd39d3746$var$SZ_GEOPOLYGON = $149c57bfd39d3746$var$H3.sizeOfGeoPolygon();
var $149c57bfd39d3746$var$SZ_GEOFENCE = $149c57bfd39d3746$var$H3.sizeOfGeofence();
var $149c57bfd39d3746$var$SZ_LINKED_GEOPOLYGON = $149c57bfd39d3746$var$H3.sizeOfLinkedGeoPolygon();
var $149c57bfd39d3746$var$SZ_COORDIJ = $149c57bfd39d3746$var$H3.sizeOfCoordIJ(); // ----------------------------------------------------------------------------
// Custom types
/**
 * 64-bit hexidecimal string representation of an H3 index
 * @static
 * @typedef {string} H3Index
 */ /**
 * 64-bit hexidecimal string representation of an H3 index,
 * or two 32-bit integers in little endian order in an array.
 * @static
 * @typedef {string | number[]} H3IndexInput
 */ /**
 * Coordinates as an `{i, j}` pair
 * @static
 * @typedef CoordIJ
 * @type {Object}
 * @property {number} i
 * @property {number} j
 */ // ----------------------------------------------------------------------------
// Unit constants
/**
 * Length/Area units
 * @static
 * @typedef UNITS
 * @type {Object}
 * @property {string} m
 * @property {string} m2
 * @property {string} km
 * @property {string} km2
 * @property {string} rads
 * @property {string} rads2
 */ var $149c57bfd39d3746$export$a037d132965e1c9f = {
    m: "m",
    m2: "m2",
    km: "km",
    km2: "km2",
    rads: "rads",
    rads2: "rads2"
}; // ----------------------------------------------------------------------------
// Utilities and helpers
/**
 * Validate a resolution, throwing an error if invalid
 * @private
 * @param  {mixed} res Value to validate
 * @throws {Error}     Error if invalid
 */ function $149c57bfd39d3746$var$validateRes(res) {
    if (typeof res !== "number" || res < 0 || res > 15 || Math.floor(res) !== res) throw new Error("Invalid resolution: " + res);
}
var $149c57bfd39d3746$var$INVALID_HEXIDECIMAL_CHAR = /[^0-9a-fA-F]/;
/**
 * Convert an H3 index (64-bit hexidecimal string) into a "split long" - a pair of 32-bit ints
 * @private
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {number[]}         A two-element array with 32 lower bits and 32 upper bits
 */ function $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index) {
    if (Array.isArray(h3Index) && h3Index.length === 2 && Number.isInteger(h3Index[0]) && Number.isInteger(h3Index[1])) return h3Index;
    if (typeof h3Index !== "string" || $149c57bfd39d3746$var$INVALID_HEXIDECIMAL_CHAR.test(h3Index)) return [
        0,
        0
    ];
    var upper = parseInt(h3Index.substring(0, h3Index.length - 8), $149c57bfd39d3746$var$BASE_16);
    var lower = parseInt(h3Index.substring(h3Index.length - 8), $149c57bfd39d3746$var$BASE_16);
    return [
        lower,
        upper
    ];
}
/**
 * Convert a 32-bit int to a hexdecimal string
 * @private
 * @param  {number} num  Integer to convert
 * @return {H3Index}     Hexidecimal string
 */ function $149c57bfd39d3746$var$hexFrom32Bit(num) {
    if (num >= 0) return num.toString($149c57bfd39d3746$var$BASE_16);
     // Handle negative numbers
    num = num & 0x7fffffff;
    var tempStr = $149c57bfd39d3746$var$zeroPad(8, num.toString($149c57bfd39d3746$var$BASE_16));
    var topNum = (parseInt(tempStr[0], $149c57bfd39d3746$var$BASE_16) + 8).toString($149c57bfd39d3746$var$BASE_16);
    tempStr = topNum + tempStr.substring(1);
    return tempStr;
}
/**
 * Get a H3 index from a split long (pair of 32-bit ints)
 * @private
 * @param  {number} lower Lower 32 bits
 * @param  {number} upper Upper 32 bits
 * @return {H3Index}       H3 index
 */ function $149c57bfd39d3746$var$splitLongToh3Index(lower, upper) {
    return $149c57bfd39d3746$var$hexFrom32Bit(upper) + $149c57bfd39d3746$var$zeroPad(8, $149c57bfd39d3746$var$hexFrom32Bit(lower));
}
/**
 * Zero-pad a string to a given length
 * @private
 * @param  {number} fullLen Target length
 * @param  {string} numStr  String to zero-pad
 * @return {string}         Zero-padded string
 */ function $149c57bfd39d3746$var$zeroPad(fullLen, numStr) {
    var numZeroes = fullLen - numStr.length;
    var outStr = "";
    for(var i = 0; i < numZeroes; i++)outStr += "0";
    outStr = outStr + numStr;
    return outStr;
}
/**
 * Populate a C-appropriate Geofence struct from a polygon array
 * @private
 * @param  {Array[]} polygonArray Polygon, as an array of coordinate pairs
 * @param  {number}  geofence     C pointer to a Geofence struct
 * @param  {boolean} isGeoJson    Whether coordinates are in [lng, lat] order per GeoJSON spec
 * @return {number}               C pointer to populated Geofence struct
 */ function $149c57bfd39d3746$var$polygonArrayToGeofence(polygonArray, geofence, isGeoJson) {
    var numVerts = polygonArray.length;
    var geoCoordArray = $149c57bfd39d3746$var$libh3._calloc(numVerts, $149c57bfd39d3746$var$SZ_GEOCOORD); // Support [lng, lat] pairs if GeoJSON is specified
    var latIndex = isGeoJson ? 1 : 0;
    var lngIndex = isGeoJson ? 0 : 1;
    for(var i = 0; i < numVerts * 2; i += 2)$149c57bfd39d3746$var$libh3.HEAPF64.set([
        polygonArray[i / 2][latIndex],
        polygonArray[i / 2][lngIndex]
    ].map($149c57bfd39d3746$export$18f2af2888c1a46b), geoCoordArray / $149c57bfd39d3746$var$SZ_DBL + i);
    $149c57bfd39d3746$var$libh3.HEAPU32.set([
        numVerts,
        geoCoordArray
    ], geofence / $149c57bfd39d3746$var$SZ_INT);
    return geofence;
}
/**
 * Create a C-appropriate GeoPolygon struct from an array of polygons
 * @private
 * @param  {Array[]} coordinates  Array of polygons, each an array of coordinate pairs
 * @param  {boolean} isGeoJson    Whether coordinates are in [lng, lat] order per GeoJSON spec
 * @return {number}               C pointer to populated GeoPolygon struct
 */ function $149c57bfd39d3746$var$coordinatesToGeoPolygon(coordinates, isGeoJson) {
    // Any loops beyond the first loop are holes
    var numHoles = coordinates.length - 1;
    var geoPolygon = $149c57bfd39d3746$var$libh3._calloc($149c57bfd39d3746$var$SZ_GEOPOLYGON); // Byte positions within the struct
    var geofenceOffset = 0;
    var numHolesOffset = geofenceOffset + $149c57bfd39d3746$var$SZ_GEOFENCE;
    var holesOffset = numHolesOffset + $149c57bfd39d3746$var$SZ_INT; // geofence is first part of struct
    $149c57bfd39d3746$var$polygonArrayToGeofence(coordinates[0], geoPolygon + geofenceOffset, isGeoJson);
    var holes;
    if (numHoles > 0) {
        holes = $149c57bfd39d3746$var$libh3._calloc(numHoles, $149c57bfd39d3746$var$SZ_GEOFENCE);
        for(var i = 0; i < numHoles; i++)$149c57bfd39d3746$var$polygonArrayToGeofence(coordinates[i + 1], holes + $149c57bfd39d3746$var$SZ_GEOFENCE * i, isGeoJson);
    }
    $149c57bfd39d3746$var$libh3.setValue(geoPolygon + numHolesOffset, numHoles, "i32");
    $149c57bfd39d3746$var$libh3.setValue(geoPolygon + holesOffset, holes, "i32");
    return geoPolygon;
}
/**
 * Free memory allocated for a GeoPolygon struct. It is an error to access the struct
 * after passing it to this method.
 * @private
 * @return {number} geoPolygon C pointer to populated GeoPolygon struct
 */ function $149c57bfd39d3746$var$destroyGeoPolygon(geoPolygon) {
    // Byte positions within the struct
    var geofenceOffset = 0;
    var numHolesOffset = geofenceOffset + $149c57bfd39d3746$var$SZ_GEOFENCE;
    var holesOffset = numHolesOffset + $149c57bfd39d3746$var$SZ_INT; // Free the outer loop
    $149c57bfd39d3746$var$libh3._free($149c57bfd39d3746$var$libh3.getValue(geoPolygon + geofenceOffset, "i8*")); // Free the holes, if any
    var numHoles = $149c57bfd39d3746$var$libh3.getValue(geoPolygon + numHolesOffset, "i32");
    for(var i = 0; i < numHoles; i++)$149c57bfd39d3746$var$libh3._free($149c57bfd39d3746$var$libh3.getValue(geoPolygon + holesOffset + $149c57bfd39d3746$var$SZ_GEOFENCE * i, "i8*"));
    $149c57bfd39d3746$var$libh3._free(geoPolygon);
}
/**
 * Read a long value, returning the lower and upper portions as separate 32-bit integers.
 * Because the upper bits are returned via side effect, the argument to this function is
 * intended to be the invocation that caused the side effect, e.g. readLong(H3.getSomeLong())
 * @private
 * @param  {number} invocation Invoked function returning a long value. The actual return
 *                             value of these functions is a 32-bit integer.
 * @return {number}            Long value as a [lower, upper] pair
 */ function $149c57bfd39d3746$var$readLong(invocation) {
    // Upper 32-bits of the long set via side-effect
    var upper = $149c57bfd39d3746$var$libh3.getTempRet0();
    return [
        invocation,
        upper
    ];
}
/**
 * Read an H3 index from a C return value. As with readLong, the argument to this function
 * is intended to be an invocation, e.g. readH3Index(H3.getSomeAddress()), to help ensure that
 * the temp value storing the upper bits of the long is still set.
 * @private
 * @param  {number} invocation  Invoked function returning a single H3 index
 * @return {H3Index}            H3 index, or null if index was invalid
 */ function $149c57bfd39d3746$var$readH3Index(invocation) {
    var ref = $149c57bfd39d3746$var$readLong(invocation);
    var lower = ref[0];
    var upper = ref[1]; // The lower bits are allowed to be 0s, but if the upper bits are 0
    // this represents an invalid H3 index
    return upper ? $149c57bfd39d3746$var$splitLongToh3Index(lower, upper) : null;
}
/**
 * Read an H3 index from a pointer to C memory.
 * @private
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of H3 indexes, in case we're
 *                            reading an array
 * @return {H3Index}          H3 index, or null if index was invalid
 */ function $149c57bfd39d3746$var$readH3IndexFromPointer(cAddress, offset) {
    if (offset === void 0) offset = 0;
    var lower = $149c57bfd39d3746$var$libh3.getValue(cAddress + $149c57bfd39d3746$var$SZ_INT * offset * 2, "i32");
    var upper = $149c57bfd39d3746$var$libh3.getValue(cAddress + $149c57bfd39d3746$var$SZ_INT * (offset * 2 + 1), "i32"); // The lower bits are allowed to be 0s, but if the upper bits are 0
    // this represents an invalid H3 index
    return upper ? $149c57bfd39d3746$var$splitLongToh3Index(lower, upper) : null;
}
/**
 * Store an H3 index in C memory. Primarily used as an efficient way to
 * write sets of hexagons.
 * @private
 * @param  {H3IndexInput} h3Index  H3 index to store
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of H3 indexes from beginning
 *                            of the current array
 */ function $149c57bfd39d3746$var$storeH3Index(h3Index, cAddress, offset) {
    // HEAPU32 is a typed array projection on the index space
    // as unsigned 32-bit integers. This means the index needs
    // to be divided by SZ_INT (4) to access correctly. Also,
    // the H3 index is 64 bits, so we skip by twos as we're writing
    // to 32-bit integers in the proper order.
    $149c57bfd39d3746$var$libh3.HEAPU32.set($149c57bfd39d3746$var$h3IndexToSplitLong(h3Index), cAddress / $149c57bfd39d3746$var$SZ_INT + 2 * offset);
}
/**
 * Read an array of 64-bit H3 indexes from C and convert to a JS array of
 * H3 index strings
 * @private
 * @param  {number} cAddress    Pointer to C ouput array
 * @param  {number} maxCount    Max number of hexagons in array. Hexagons with
 *                              the value 0 will be skipped, so this isn't
 *                              necessarily the length of the output array.
 * @return {H3Index[]}          Array of H3 indexes
 */ function $149c57bfd39d3746$var$readArrayOfHexagons(cAddress, maxCount) {
    var out = [];
    for(var i = 0; i < maxCount; i++){
        var h3Index = $149c57bfd39d3746$var$readH3IndexFromPointer(cAddress, i);
        if (h3Index !== null) out.push(h3Index);
    }
    return out;
}
/**
 * Store an array of H3 index strings as a C array of 64-bit integers.
 * @private
 * @param  {number} cAddress    Pointer to C input array
 * @param  {H3IndexInput[]} hexagons H3 indexes to pass to the C lib
 */ function $149c57bfd39d3746$var$storeArrayOfHexagons(cAddress, hexagons) {
    // Assuming the cAddress points to an already appropriately
    // allocated space
    var count = hexagons.length;
    for(var i = 0; i < count; i++)$149c57bfd39d3746$var$storeH3Index(hexagons[i], cAddress, i);
}
/**
 * Populate a C-appropriate GeoCoord struct from a [lat, lng] array
 * @private
 * @param {number} lat     Coordinate latitude
 * @param {number} lng     Coordinate longitude
 * @return {number}        C pointer to populated GeoCoord struct
 */ function $149c57bfd39d3746$var$storeGeoCoord(lat, lng) {
    var geoCoord = $149c57bfd39d3746$var$libh3._calloc(1, $149c57bfd39d3746$var$SZ_GEOCOORD);
    $149c57bfd39d3746$var$libh3.HEAPF64.set([
        lat,
        lng
    ].map($149c57bfd39d3746$export$18f2af2888c1a46b), geoCoord / $149c57bfd39d3746$var$SZ_DBL);
    return geoCoord;
}
function $149c57bfd39d3746$var$readSingleCoord(cAddress) {
    return $149c57bfd39d3746$export$3eb27537c08caf0f($149c57bfd39d3746$var$libh3.getValue(cAddress, "double"));
}
/**
 * Read a GeoCoord from C and return a [lat, lng] pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {number[]}           [lat, lng] pair
 */ function $149c57bfd39d3746$var$readGeoCoord(cAddress) {
    return [
        $149c57bfd39d3746$var$readSingleCoord(cAddress),
        $149c57bfd39d3746$var$readSingleCoord(cAddress + $149c57bfd39d3746$var$SZ_DBL)
    ];
}
/**
 * Read a GeoCoord from C and return a GeoJSON-style [lng, lat] pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {number[]}           [lng, lat] pair
 */ function $149c57bfd39d3746$var$readGeoCoordGeoJson(cAddress) {
    return [
        $149c57bfd39d3746$var$readSingleCoord(cAddress + $149c57bfd39d3746$var$SZ_DBL),
        $149c57bfd39d3746$var$readSingleCoord(cAddress)
    ];
}
/**
 * Read the GeoBoundary structure into a list of geo coordinate pairs
 * @private
 * @param {number}  geoBoundary     C pointer to GeoBoundary struct
 * @param {boolean} geoJsonCoords   Whether to provide GeoJSON coordinate order: [lng, lat]
 * @param {boolean} closedLoop      Whether to close the loop
 * @return {Array[]}                Array of geo coordinate pairs
 */ function $149c57bfd39d3746$var$readGeoBoundary(geoBoundary, geoJsonCoords, closedLoop) {
    var numVerts = $149c57bfd39d3746$var$libh3.getValue(geoBoundary, "i32"); // Note that though numVerts is an int, the coordinate doubles have to be
    // aligned to 8 bytes, hence the 8-byte offset here
    var vertsPos = geoBoundary + $149c57bfd39d3746$var$SZ_DBL;
    var out = []; // Support [lng, lat] pairs if GeoJSON is specified
    var readCoord = geoJsonCoords ? $149c57bfd39d3746$var$readGeoCoordGeoJson : $149c57bfd39d3746$var$readGeoCoord;
    for(var i = 0; i < numVerts * 2; i += 2)out.push(readCoord(vertsPos + $149c57bfd39d3746$var$SZ_DBL * i));
    if (closedLoop) // Close loop if GeoJSON is specified
    out.push(out[0]);
    return out;
}
/**
 * Read the LinkedGeoPolygon structure into a nested array of MultiPolygon coordinates
 * @private
 * @param {number}  polygon         C pointer to LinkedGeoPolygon struct
 * @param {boolean} formatAsGeoJson Whether to provide GeoJSON output: [lng, lat], closed loops
 * @return {number[][][][]}         MultiPolygon-style output.
 */ function $149c57bfd39d3746$var$readMultiPolygon(polygon, formatAsGeoJson) {
    var output = [];
    var readCoord = formatAsGeoJson ? $149c57bfd39d3746$var$readGeoCoordGeoJson : $149c57bfd39d3746$var$readGeoCoord;
    var loops;
    var loop;
    var coords;
    var coord; // Loop through the linked structure, building the output
    while(polygon){
        output.push(loops = []); // Follow ->first pointer
        loop = $149c57bfd39d3746$var$libh3.getValue(polygon, "i8*");
        while(loop){
            loops.push(coords = []); // Follow ->first pointer
            coord = $149c57bfd39d3746$var$libh3.getValue(loop, "i8*");
            while(coord){
                coords.push(readCoord(coord)); // Follow ->next pointer
                coord = $149c57bfd39d3746$var$libh3.getValue(coord + $149c57bfd39d3746$var$SZ_DBL * 2, "i8*");
            }
            if (formatAsGeoJson) // Close loop if GeoJSON is requested
            coords.push(coords[0]);
             // Follow ->next pointer
            loop = $149c57bfd39d3746$var$libh3.getValue(loop + $149c57bfd39d3746$var$SZ_PTR * 2, "i8*");
        } // Follow ->next pointer
        polygon = $149c57bfd39d3746$var$libh3.getValue(polygon + $149c57bfd39d3746$var$SZ_PTR * 2, "i8*");
    }
    return output;
}
/**
 * Read a CoordIJ from C and return an {i, j} pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {CoordIJ}            {i, j} pair
 */ function $149c57bfd39d3746$var$readCoordIJ(cAddress) {
    return {
        i: $149c57bfd39d3746$var$libh3.getValue(cAddress, "i32"),
        j: $149c57bfd39d3746$var$libh3.getValue(cAddress + $149c57bfd39d3746$var$SZ_INT, "i32")
    };
}
/**
 * Store an {i, j} pair to a C CoordIJ struct.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {CoordIJ}            {i, j} pair
 */ function $149c57bfd39d3746$var$storeCoordIJ(cAddress, ref) {
    var i = ref.i;
    var j = ref.j;
    $149c57bfd39d3746$var$libh3.setValue(cAddress, i, "i32");
    $149c57bfd39d3746$var$libh3.setValue(cAddress + $149c57bfd39d3746$var$SZ_INT, j, "i32");
}
/**
 * Read an array of positive integers array from C. Negative
 * values are considered invalid and ignored in output.
 * @private
 * @param  {number} cAddress    Pointer to C array
 * @param  {number} count       Length of C array
 * @return {number[]}           Javascript integer array
 */ function $149c57bfd39d3746$var$readArrayOfPositiveIntegers(cAddress, count) {
    var out = [];
    for(var i = 0; i < count; i++){
        var int = $149c57bfd39d3746$var$libh3.getValue(cAddress + $149c57bfd39d3746$var$SZ_INT * i, "i32");
        if (int >= 0) out.push(int);
    }
    return out;
} // ----------------------------------------------------------------------------
// Public API functions: Core
/**
 * Whether a given string represents a valid H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          Whether the index is valid
 */ function $149c57bfd39d3746$export$c1faec3db2fca891(h3Index) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($149c57bfd39d3746$var$H3.h3IsValid(lower, upper));
}
/**
 * Whether the given H3 index is a pentagon
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          isPentagon
 */ function $149c57bfd39d3746$export$9e7403b9b01e136f(h3Index) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($149c57bfd39d3746$var$H3.h3IsPentagon(lower, upper));
}
/**
 * Whether the given H3 index is in a Class III resolution (rotated versus
 * the icosahedron and subject to shape distortion adding extra points on
 * icosahedron edges, making them not true hexagons).
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          isResClassIII
 */ function $149c57bfd39d3746$export$6019beb3542e7aad(h3Index) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($149c57bfd39d3746$var$H3.h3IsResClassIII(lower, upper));
}
/**
 * Get the number of the base cell for a given H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get the base cell for
 * @return {number}           Index of the base cell (0-121)
 */ function $149c57bfd39d3746$export$558febf58c7ab0b8(h3Index) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return $149c57bfd39d3746$var$H3.h3GetBaseCell(lower, upper);
}
/**
 * Get the indices of all icosahedron faces intersected by a given H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get faces for
 * @return {number[]}         Indices (0-19) of all intersected faces
 */ function $149c57bfd39d3746$export$d1cf4a12a694db3a(h3Index) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var count = $149c57bfd39d3746$var$H3.maxFaceCount(lower, upper);
    var faces = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_INT * count);
    $149c57bfd39d3746$var$H3.h3GetFaces(lower, upper, faces);
    var out = $149c57bfd39d3746$var$readArrayOfPositiveIntegers(faces, count);
    $149c57bfd39d3746$var$libh3._free(faces);
    return out;
}
/**
 * Returns the resolution of an H3 index
 * @static
 * @param  {H3IndexInput} h3Index H3 index to get resolution
 * @return {number}          The number (0-15) resolution, or -1 if invalid
 */ function $149c57bfd39d3746$export$6827467f3394e8f4(h3Index) {
    if (typeof h3Index !== "string") return -1;
    return parseInt(h3Index.charAt(1), $149c57bfd39d3746$var$BASE_16);
}
/**
 * Get the hexagon containing a lat,lon point
 * @static
 * @param  {number} lat Latitude of point
 * @param  {number} lng Longtitude of point
 * @param  {number} res Resolution of hexagons to return
 * @return {H3Index}    H3 index
 */ function $149c57bfd39d3746$export$24131a74a154ec65(lat, lng, res) {
    var latlng = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_GEOCOORD); // Slightly more efficient way to set the memory
    $149c57bfd39d3746$var$libh3.HEAPF64.set([
        lat,
        lng
    ].map($149c57bfd39d3746$export$18f2af2888c1a46b), latlng / $149c57bfd39d3746$var$SZ_DBL); // Read value as a split long
    var h3Index = $149c57bfd39d3746$var$readH3Index($149c57bfd39d3746$var$H3.geoToH3(latlng, res));
    $149c57bfd39d3746$var$libh3._free(latlng);
    return h3Index;
}
/**
 * Get the lat,lon center of a given hexagon
 * @static
 * @param  {H3IndexInput} h3Index  H3 index
 * @return {number[]}         Point as a [lat, lng] pair
 */ function $149c57bfd39d3746$export$317dd65f3721e7c4(h3Index) {
    var latlng = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_GEOCOORD);
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    $149c57bfd39d3746$var$H3.h3ToGeo(lower, upper, latlng);
    var out = $149c57bfd39d3746$var$readGeoCoord(latlng);
    $149c57bfd39d3746$var$libh3._free(latlng);
    return out;
}
/**
 * Get the vertices of a given hexagon (or pentagon), as an array of [lat, lng]
 * points. For pentagons and hexagons on the edge of an icosahedron face, this
 * function may return up to 10 vertices.
 * @static
 * @param  {H3Index} h3Index          H3 index
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat], closed loops
 * @return {number[][]}               Array of [lat, lng] pairs
 */ function $149c57bfd39d3746$export$c87d5f55314c67cf(h3Index, formatAsGeoJson) {
    var geoBoundary = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_GEOBOUNDARY);
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    $149c57bfd39d3746$var$H3.h3ToGeoBoundary(lower, upper, geoBoundary);
    var out = $149c57bfd39d3746$var$readGeoBoundary(geoBoundary, formatAsGeoJson, formatAsGeoJson);
    $149c57bfd39d3746$var$libh3._free(geoBoundary);
    return out;
} // ----------------------------------------------------------------------------
// Public API functions: Algorithms
/**
 * Get the parent of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get parent for
 * @param  {number} res       Resolution of hexagon to return
 * @return {H3Index}          H3 index of parent, or null for invalid input
 */ function $149c57bfd39d3746$export$6e83bc1001b134db(h3Index, res) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return $149c57bfd39d3746$var$readH3Index($149c57bfd39d3746$var$H3.h3ToParent(lower, upper, res));
}
/**
 * Get the children/descendents of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get children for
 * @param  {number} res       Resolution of hexagons to return
 * @return {H3Index[]}        H3 indexes of children, or empty array for invalid input
 */ function $149c57bfd39d3746$export$e8b20439271d254c(h3Index, res) {
    // Bad input in this case can potentially result in high computation volume
    // using the current C algorithm. Validate and return an empty array on failure.
    if (!$149c57bfd39d3746$export$c1faec3db2fca891(h3Index)) return [];
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var maxCount = $149c57bfd39d3746$var$H3.maxH3ToChildrenSize(lower, upper, res);
    var hexagons = $149c57bfd39d3746$var$libh3._calloc(maxCount, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$H3.h3ToChildren(lower, upper, res, hexagons);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, maxCount);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    return out;
}
/**
 * Get the center child of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get center child for
 * @param  {number} res       Resolution of hexagon to return
 * @return {H3Index}          H3 index of child, or null for invalid input
 */ function $149c57bfd39d3746$export$6db75718879de215(h3Index, res) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return $149c57bfd39d3746$var$readH3Index($149c57bfd39d3746$var$H3.h3ToCenterChild(lower, upper, res));
}
/**
 * Get all hexagons in a k-ring around a given center. The order of the hexagons is undefined.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of k-ring
 * @return {H3Index[]}        H3 indexes for all hexagons in ring
 */ function $149c57bfd39d3746$export$36e8217e0351e612(h3Index, ringSize) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var maxCount = $149c57bfd39d3746$var$H3.maxKringSize(ringSize);
    var hexagons = $149c57bfd39d3746$var$libh3._calloc(maxCount, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$H3.kRing(lower, upper, ringSize, hexagons);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, maxCount);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    return out;
}
/**
 * Get all hexagons in a k-ring around a given center, in an array of arrays
 * ordered by distance from the origin. The order of the hexagons within each ring is undefined.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of k-ring
 * @return {H3Index[][]}      Array of arrays with H3 indexes for all hexagons each ring
 */ function $149c57bfd39d3746$export$501db62b56874355(h3Index, ringSize) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var maxCount = $149c57bfd39d3746$var$H3.maxKringSize(ringSize);
    var kRings = $149c57bfd39d3746$var$libh3._calloc(maxCount, $149c57bfd39d3746$var$SZ_H3INDEX);
    var distances = $149c57bfd39d3746$var$libh3._calloc(maxCount, $149c57bfd39d3746$var$SZ_INT);
    $149c57bfd39d3746$var$H3.kRingDistances(lower, upper, ringSize, kRings, distances); // Create an array of empty arrays to hold the output
    var out = [];
    for(var i = 0; i < ringSize + 1; i++)out.push([]);
     // Read the array of hexagons, putting them into the appropriate rings
    for(var i$1 = 0; i$1 < maxCount * 2; i$1 += 2){
        var hexLower = $149c57bfd39d3746$var$libh3.getValue(kRings + $149c57bfd39d3746$var$SZ_INT * i$1, "i32");
        var hexUpper = $149c57bfd39d3746$var$libh3.getValue(kRings + $149c57bfd39d3746$var$SZ_INT * (i$1 + 1), "i32");
        var index = $149c57bfd39d3746$var$libh3.getValue(distances + $149c57bfd39d3746$var$SZ_INT * (i$1 / 2), "i32");
        if (hexLower !== 0 || hexUpper !== 0) out[index].push($149c57bfd39d3746$var$splitLongToh3Index(hexLower, hexUpper));
    }
    $149c57bfd39d3746$var$libh3._free(kRings);
    $149c57bfd39d3746$var$libh3._free(distances);
    return out;
}
/**
 * Get all hexagons in a hollow hexagonal ring centered at origin with sides of a given length.
 * Unlike kRing, this function will throw an error if there is a pentagon anywhere in the ring.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of ring
 * @return {H3Index[]}        H3 indexes for all hexagons in ring
 * @throws {Error}            If the algorithm could not calculate the ring
 */ function $149c57bfd39d3746$export$496038b5ca9585a1(h3Index, ringSize) {
    var maxCount = ringSize === 0 ? 1 : 6 * ringSize;
    var hexagons = $149c57bfd39d3746$var$libh3._calloc(maxCount, $149c57bfd39d3746$var$SZ_H3INDEX);
    var retVal = $149c57bfd39d3746$var$H3.hexRing.apply($149c57bfd39d3746$var$H3, $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index).concat([
        ringSize
    ], [
        hexagons
    ]));
    if (retVal !== 0) {
        $149c57bfd39d3746$var$libh3._free(hexagons);
        throw new Error("Failed to get hexRing (encountered a pentagon?)");
    }
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, maxCount);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    return out;
}
/**
 * Get all hexagons with centers contained in a given polygon. The polygon
 * is specified with GeoJson semantics as an array of loops. Each loop is
 * an array of [lat, lng] pairs (or [lng, lat] if isGeoJson is specified).
 * The first loop is the perimeter of the polygon, and subsequent loops are
 * expected to be holes.
 * @static
 * @param  {number[][] | number[][][]} coordinates
 *                                  Array of loops, or a single loop
 * @param  {number} res             Resolution of hexagons to return
 * @param  {boolean} [isGeoJson]    Whether to expect GeoJson-style [lng, lat]
 *                                  pairs instead of [lat, lng]
 * @return {H3Index[]}              H3 indexes for all hexagons in polygon
 */ function $149c57bfd39d3746$export$cea1c58a6db52bca(coordinates, res, isGeoJson) {
    $149c57bfd39d3746$var$validateRes(res);
    isGeoJson = Boolean(isGeoJson); // Guard against empty input
    if (coordinates.length === 0 || coordinates[0].length === 0) return [];
     // Wrap to expected format if a single loop is provided
    if (typeof coordinates[0][0] === "number") coordinates = [
        coordinates
    ];
    var geoPolygon = $149c57bfd39d3746$var$coordinatesToGeoPolygon(coordinates, isGeoJson);
    var arrayLen = $149c57bfd39d3746$var$H3.maxPolyfillSize(geoPolygon, res);
    var hexagons = $149c57bfd39d3746$var$libh3._calloc(arrayLen, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$H3.polyfill(geoPolygon, res, hexagons);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, arrayLen);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    $149c57bfd39d3746$var$destroyGeoPolygon(geoPolygon);
    return out;
}
/**
 * Get the outlines of a set of H3 hexagons, returned in GeoJSON MultiPolygon
 * format (an array of polygons, each with an array of loops, each an array of
 * coordinates). Coordinates are returned as [lat, lng] pairs unless GeoJSON
 * is requested.
 *
 * It is the responsibility of the caller to ensure that all hexagons in the
 * set have the same resolution and that the set contains no duplicates. Behavior
 * is undefined if duplicates or multiple resolutions are present, and the
 * algorithm may produce unexpected or invalid polygons.
 *
 * @static
 * @param {H3IndexInput[]} h3Indexes       H3 indexes to get outlines for
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output:
 *                                    [lng, lat], closed loops
 * @return {number[][][][]}           MultiPolygon-style output.
 */ function $149c57bfd39d3746$export$911a0c41d9f5c4ed(h3Indexes, formatAsGeoJson) {
    // Early exit on empty input
    if (!h3Indexes || !h3Indexes.length) return [];
     // Set up input set
    var indexCount = h3Indexes.length;
    var set = $149c57bfd39d3746$var$libh3._calloc(indexCount, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$storeArrayOfHexagons(set, h3Indexes); // Allocate memory for output linked polygon
    var polygon = $149c57bfd39d3746$var$libh3._calloc($149c57bfd39d3746$var$SZ_LINKED_GEOPOLYGON); // Store a reference to the first polygon - that's the one we need for
    // memory deallocation
    var originalPolygon = polygon;
    $149c57bfd39d3746$var$H3.h3SetToLinkedGeo(set, indexCount, polygon);
    var multiPolygon = $149c57bfd39d3746$var$readMultiPolygon(polygon, formatAsGeoJson); // Clean up
    $149c57bfd39d3746$var$H3.destroyLinkedPolygon(originalPolygon);
    $149c57bfd39d3746$var$libh3._free(originalPolygon);
    $149c57bfd39d3746$var$libh3._free(set);
    return multiPolygon;
}
/**
 * Compact a set of hexagons of the same resolution into a set of hexagons across
 * multiple levels that represents the same area.
 * @static
 * @param  {H3IndexInput[]} h3Set H3 indexes to compact
 * @return {H3Index[]}       Compacted H3 indexes
 * @throws {Error}           If the input is invalid (e.g. duplicate hexagons)
 */ function $149c57bfd39d3746$export$8e16b83750b44988(h3Set) {
    if (!h3Set || !h3Set.length) return [];
     // Set up input set
    var count = h3Set.length;
    var set = $149c57bfd39d3746$var$libh3._calloc(count, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$storeArrayOfHexagons(set, h3Set); // Allocate memory for compacted hexagons, worst-case is no compaction
    var compactedSet = $149c57bfd39d3746$var$libh3._calloc(count, $149c57bfd39d3746$var$SZ_H3INDEX);
    var retVal = $149c57bfd39d3746$var$H3.compact(set, compactedSet, count);
    if (retVal !== 0) {
        $149c57bfd39d3746$var$libh3._free(set);
        $149c57bfd39d3746$var$libh3._free(compactedSet);
        throw new Error("Failed to compact, malformed input data (duplicate hexagons?)");
    }
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(compactedSet, count);
    $149c57bfd39d3746$var$libh3._free(set);
    $149c57bfd39d3746$var$libh3._free(compactedSet);
    return out;
}
/**
 * Uncompact a compacted set of hexagons to hexagons of the same resolution
 * @static
 * @param  {H3IndexInput[]} compactedSet H3 indexes to uncompact
 * @param  {number}    res          The resolution to uncompact to
 * @return {H3Index[]}              The uncompacted H3 indexes
 * @throws {Error}                  If the input is invalid (e.g. invalid resolution)
 */ function $149c57bfd39d3746$export$da59f65535392b73(compactedSet, res) {
    $149c57bfd39d3746$var$validateRes(res);
    if (!compactedSet || !compactedSet.length) return [];
     // Set up input set
    var count = compactedSet.length;
    var set = $149c57bfd39d3746$var$libh3._calloc(count, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$storeArrayOfHexagons(set, compactedSet); // Estimate how many hexagons we need (always overestimates if in error)
    var maxUncompactedNum = $149c57bfd39d3746$var$H3.maxUncompactSize(set, count, res); // Allocate memory for uncompacted hexagons
    var uncompactedSet = $149c57bfd39d3746$var$libh3._calloc(maxUncompactedNum, $149c57bfd39d3746$var$SZ_H3INDEX);
    var retVal = $149c57bfd39d3746$var$H3.uncompact(set, count, uncompactedSet, maxUncompactedNum, res);
    if (retVal !== 0) {
        $149c57bfd39d3746$var$libh3._free(set);
        $149c57bfd39d3746$var$libh3._free(uncompactedSet);
        throw new Error("Failed to uncompact (bad resolution?)");
    }
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(uncompactedSet, maxUncompactedNum);
    $149c57bfd39d3746$var$libh3._free(set);
    $149c57bfd39d3746$var$libh3._free(uncompactedSet);
    return out;
} // ----------------------------------------------------------------------------
// Public API functions: Unidirectional edges
/**
 * Whether two H3 indexes are neighbors (share an edge)
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {boolean}             Whether the hexagons share an edge
 */ function $149c57bfd39d3746$export$eb50eb4056349f0e(origin, destination) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $149c57bfd39d3746$var$h3IndexToSplitLong(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    return Boolean($149c57bfd39d3746$var$H3.h3IndexesAreNeighbors(oLower, oUpper, dLower, dUpper));
}
/**
 * Get an H3 index representing a unidirectional edge for a given origin and destination
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {H3Index}             H3 index of the edge, or null if no edge is shared
 */ function $149c57bfd39d3746$export$b89869ac33946464(origin, destination) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $149c57bfd39d3746$var$h3IndexToSplitLong(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    return $149c57bfd39d3746$var$readH3Index($149c57bfd39d3746$var$H3.getH3UnidirectionalEdge(oLower, oUpper, dLower, dUpper));
}
/**
 * Get the origin hexagon from an H3 index representing a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index}           H3 index of the edge origin
 */ function $149c57bfd39d3746$export$13279f23c835bdb8(edgeIndex) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    return $149c57bfd39d3746$var$readH3Index($149c57bfd39d3746$var$H3.getOriginH3IndexFromUnidirectionalEdge(lower, upper));
}
/**
 * Get the destination hexagon from an H3 index representing a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index}           H3 index of the edge destination
 */ function $149c57bfd39d3746$export$100636a95be53c47(edgeIndex) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    return $149c57bfd39d3746$var$readH3Index($149c57bfd39d3746$var$H3.getDestinationH3IndexFromUnidirectionalEdge(lower, upper));
}
/**
 * Whether the input is a valid unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {boolean}           Whether the index is valid
 */ function $149c57bfd39d3746$export$7ba0147f717e0e86(edgeIndex) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($149c57bfd39d3746$var$H3.h3UnidirectionalEdgeIsValid(lower, upper));
}
/**
 * Get the [origin, destination] pair represented by a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index[]}         [origin, destination] pair as H3 indexes
 */ function $149c57bfd39d3746$export$baea9ec8d71e57f1(edgeIndex) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    var count = 2;
    var hexagons = $149c57bfd39d3746$var$libh3._calloc(count, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$H3.getH3IndexesFromUnidirectionalEdge(lower, upper, hexagons);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, count);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    return out;
}
/**
 * Get all of the unidirectional edges with the given H3 index as the origin (i.e. an edge to
 * every neighbor)
 * @static
 * @param  {H3IndexInput} h3Index   H3 index of the origin hexagon
 * @return {H3Index[]}         List of unidirectional edges
 */ function $149c57bfd39d3746$export$30e11ffcf56640f3(h3Index) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var count = 6;
    var edges = $149c57bfd39d3746$var$libh3._calloc(count, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$H3.getH3UnidirectionalEdgesFromHexagon(lower, upper, edges);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(edges, count);
    $149c57bfd39d3746$var$libh3._free(edges);
    return out;
}
/**
 * Get the vertices of a given edge as an array of [lat, lng] points. Note that for edges that
 * cross the edge of an icosahedron face, this may return 3 coordinates.
 * @static
 * @param  {H3IndexInput} edgeIndex        H3 index of the edge
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat]
 * @return {number[][]}               Array of geo coordinate pairs
 */ function $149c57bfd39d3746$export$6b2ac03a6029686(edgeIndex, formatAsGeoJson) {
    var geoBoundary = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_GEOBOUNDARY);
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    $149c57bfd39d3746$var$H3.getH3UnidirectionalEdgeBoundary(lower, upper, geoBoundary);
    var out = $149c57bfd39d3746$var$readGeoBoundary(geoBoundary, formatAsGeoJson);
    $149c57bfd39d3746$var$libh3._free(geoBoundary);
    return out;
}
/**
 * Get the grid distance between two hex indexes. This function may fail
 * to find the distance between two indexes if they are very far apart or
 * on opposite sides of a pentagon.
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {number}              Distance between hexagons, or a negative
 *                               number if the distance could not be computed
 */ function $149c57bfd39d3746$export$f56b06aabd98a7d0(origin, destination) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $149c57bfd39d3746$var$h3IndexToSplitLong(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    return $149c57bfd39d3746$var$H3.h3Distance(oLower, oUpper, dLower, dUpper);
}
/**
 * Given two H3 indexes, return the line of indexes between them (inclusive).
 *
 * This function may fail to find the line between two indexes, for
 * example if they are very far apart. It may also fail when finding
 * distances for indexes on opposite sides of a pentagon.
 *
 * Notes:
 *
 *  - The specific output of this function should not be considered stable
 *    across library versions. The only guarantees the library provides are
 *    that the line length will be `h3Distance(start, end) + 1` and that
 *    every index in the line will be a neighbor of the preceding index.
 *  - Lines are drawn in grid space, and may not correspond exactly to either
 *    Cartesian lines or great arcs.
 *
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {H3Index[]}           H3 indexes connecting origin and destination
 * @throws {Error}               If the line cannot be calculated
 */ function $149c57bfd39d3746$export$3c4374231d75ac73(origin, destination) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $149c57bfd39d3746$var$h3IndexToSplitLong(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    var count = $149c57bfd39d3746$var$H3.h3LineSize(oLower, oUpper, dLower, dUpper);
    if (count < 0) // We can't get the specific error code here - may be any of
    // the errors possible in experimentalH3ToLocalIj
    throw new Error("Line cannot be calculated");
    var hexagons = $149c57bfd39d3746$var$libh3._calloc(count, $149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$H3.h3Line(oLower, oUpper, dLower, dUpper, hexagons);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, count);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    return out;
}
/**
 * Produces IJ coordinates for an H3 index anchored by an origin.
 *
 * - The coordinate space used by this function may have deleted
 * regions or warping due to pentagonal distortion.
 * - Coordinates are only comparable if they come from the same
 * origin index.
 * - Failure may occur if the index is too far away from the origin
 * or if the index is on the other side of a pentagon.
 * - This function is experimental, and its output is not guaranteed
 * to be compatible across different versions of H3.
 * @static
 * @param  {H3IndexInput} origin      Origin H3 index
 * @param  {H3IndexInput} destination H3 index for which to find relative coordinates
 * @return {CoordIJ}             Coordinates as an `{i, j}` pair
 * @throws {Error}               If the IJ coordinates cannot be calculated
 */ function $149c57bfd39d3746$export$f5137e86c7310bce(origin, destination) {
    var ij = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_COORDIJ);
    var retVal = $149c57bfd39d3746$var$H3.experimentalH3ToLocalIj.apply($149c57bfd39d3746$var$H3, $149c57bfd39d3746$var$h3IndexToSplitLong(origin).concat($149c57bfd39d3746$var$h3IndexToSplitLong(destination), [
        ij
    ]));
    var coords = $149c57bfd39d3746$var$readCoordIJ(ij);
    $149c57bfd39d3746$var$libh3._free(ij); // Return the pair, or throw if an error code was returned.
    // Switch statement and error codes cribbed from h3-java's implementation.
    switch(retVal){
        case 0:
            return coords;
        case 1:
            throw new Error("Incompatible origin and index.");
        case 2:
        default:
            throw new Error("Local IJ coordinates undefined for this origin and index pair. The index may be too far from the origin.");
        case 3:
        case 4:
        case 5:
            throw new Error("Encountered possible pentagon distortion");
    }
}
/**
 * Produces an H3 index for IJ coordinates anchored by an origin.
 *
 * - The coordinate space used by this function may have deleted
 * regions or warping due to pentagonal distortion.
 * - Coordinates are only comparable if they come from the same
 * origin index.
 * - Failure may occur if the index is too far away from the origin
 * or if the index is on the other side of a pentagon.
 * - This function is experimental, and its output is not guaranteed
 * to be compatible across different versions of H3.
 * @static
 * @param  {H3IndexInput} origin     Origin H3 index
 * @param  {CoordIJ} coords     Coordinates as an `{i, j}` pair
 * @return {H3Index}            H3 index at the relative coordinates
 * @throws {Error}              If the H3 index cannot be calculated
 */ function $149c57bfd39d3746$export$699ec478a27688ea(origin, coords) {
    // Validate input coords
    if (!coords || typeof coords.i !== "number" || typeof coords.j !== "number") throw new Error("Coordinates must be provided as an {i, j} object");
     // Allocate memory for the CoordIJ struct and an H3 index to hold the return value
    var ij = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_COORDIJ);
    var out = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_H3INDEX);
    $149c57bfd39d3746$var$storeCoordIJ(ij, coords);
    var retVal = $149c57bfd39d3746$var$H3.experimentalLocalIjToH3.apply($149c57bfd39d3746$var$H3, $149c57bfd39d3746$var$h3IndexToSplitLong(origin).concat([
        ij
    ], [
        out
    ]));
    var h3Index = $149c57bfd39d3746$var$readH3IndexFromPointer(out);
    $149c57bfd39d3746$var$libh3._free(ij);
    $149c57bfd39d3746$var$libh3._free(out);
    if (retVal !== 0) throw new Error("Index not defined for this origin and IJ coordinates pair. IJ coordinates may be too far from origin, or a pentagon distortion was encountered.");
    return h3Index;
} // ----------------------------------------------------------------------------
// Public API functions: Distance/area utilities
/**
 * Great circle distance between two geo points. This is not specific to H3,
 * but is implemented in the library and provided here as a convenience.
 * @static
 * @param  {number[]} latlng1 Origin coordinate as [lat, lng]
 * @param  {number[]} latlng2 Destination coordinate as [lat, lng]
 * @param  {string}   unit    Distance unit (either UNITS.m or UNITS.km)
 * @return {number}           Great circle distance
 * @throws {Error}            If the unit is invalid
 */ function $149c57bfd39d3746$export$f091827d0d13bea5(latlng1, latlng2, unit) {
    var coord1 = $149c57bfd39d3746$var$storeGeoCoord(latlng1[0], latlng1[1]);
    var coord2 = $149c57bfd39d3746$var$storeGeoCoord(latlng2[0], latlng2[1]);
    var result;
    switch(unit){
        case $149c57bfd39d3746$export$a037d132965e1c9f.m:
            result = $149c57bfd39d3746$var$H3.pointDistM(coord1, coord2);
            break;
        case $149c57bfd39d3746$export$a037d132965e1c9f.km:
            result = $149c57bfd39d3746$var$H3.pointDistKm(coord1, coord2);
            break;
        case $149c57bfd39d3746$export$a037d132965e1c9f.rads:
            result = $149c57bfd39d3746$var$H3.pointDistRads(coord1, coord2);
            break;
        default:
            result = null;
    }
    $149c57bfd39d3746$var$libh3._free(coord1);
    $149c57bfd39d3746$var$libh3._free(coord2);
    if (result === null) throw new Error("Unknown unit: " + unit);
    return result;
}
/**
 * Exact area of a given cell
 * @static
 * @param  {H3Index} h3Index  H3 index of the hexagon to measure
 * @param  {string}  unit     Distance unit (either UNITS.m2 or UNITS.km2)
 * @return {number}           Cell area
 * @throws {Error}            If the unit is invalid
 */ function $149c57bfd39d3746$export$dd1eba531ccc01d(h3Index, unit) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    switch(unit){
        case $149c57bfd39d3746$export$a037d132965e1c9f.m2:
            return $149c57bfd39d3746$var$H3.cellAreaM2(lower, upper);
        case $149c57bfd39d3746$export$a037d132965e1c9f.km2:
            return $149c57bfd39d3746$var$H3.cellAreaKm2(lower, upper);
        case $149c57bfd39d3746$export$a037d132965e1c9f.rads2:
            return $149c57bfd39d3746$var$H3.cellAreaRads2(lower, upper);
        default:
            throw new Error("Unknown unit: " + unit);
    }
}
/**
 * Exact length of a given unidirectional edge
 * @static
 * @param  {H3Index} edge     H3 index of the edge to measure
 * @param  {string}  unit     Distance unit (either UNITS.m, UNITS.km, or UNITS.rads)
 * @return {number}           Cell area
 * @throws {Error}            If the unit is invalid
 */ function $149c57bfd39d3746$export$27082d4db7c8790c(edge, unit) {
    var ref = $149c57bfd39d3746$var$h3IndexToSplitLong(edge);
    var lower = ref[0];
    var upper = ref[1];
    switch(unit){
        case $149c57bfd39d3746$export$a037d132965e1c9f.m:
            return $149c57bfd39d3746$var$H3.exactEdgeLengthM(lower, upper);
        case $149c57bfd39d3746$export$a037d132965e1c9f.km:
            return $149c57bfd39d3746$var$H3.exactEdgeLengthKm(lower, upper);
        case $149c57bfd39d3746$export$a037d132965e1c9f.rads:
            return $149c57bfd39d3746$var$H3.exactEdgeLengthRads(lower, upper);
        default:
            throw new Error("Unknown unit: " + unit);
    }
}
/**
 * Average hexagon area at a given resolution
 * @static
 * @param  {number} res  Hexagon resolution
 * @param  {string} unit Area unit (either UNITS.m2, UNITS.km2, or UNITS.rads2)
 * @return {number}      Average area
 * @throws {Error}       If the unit is invalid
 */ function $149c57bfd39d3746$export$597dd479d4cc1bc9(res, unit) {
    $149c57bfd39d3746$var$validateRes(res);
    switch(unit){
        case $149c57bfd39d3746$export$a037d132965e1c9f.m2:
            return $149c57bfd39d3746$var$H3.hexAreaM2(res);
        case $149c57bfd39d3746$export$a037d132965e1c9f.km2:
            return $149c57bfd39d3746$var$H3.hexAreaKm2(res);
        default:
            throw new Error("Unknown unit: " + unit);
    }
}
/**
 * Average hexagon edge length at a given resolution
 * @static
 * @param  {number} res  Hexagon resolution
 * @param  {string} unit Distance unit (either UNITS.m, UNITS.km, or UNITS.rads)
 * @return {number}      Average edge length
 * @throws {Error}       If the unit is invalid
 */ function $149c57bfd39d3746$export$f9bb3d14d246c386(res, unit) {
    $149c57bfd39d3746$var$validateRes(res);
    switch(unit){
        case $149c57bfd39d3746$export$a037d132965e1c9f.m:
            return $149c57bfd39d3746$var$H3.edgeLengthM(res);
        case $149c57bfd39d3746$export$a037d132965e1c9f.km:
            return $149c57bfd39d3746$var$H3.edgeLengthKm(res);
        default:
            throw new Error("Unknown unit: " + unit);
    }
} // ----------------------------------------------------------------------------
// Public informational utilities
/**
 * The total count of hexagons in the world at a given resolution. Note that above
 * resolution 8 the exact count cannot be represented in a JavaScript 32-bit number,
 * so consumers should use caution when applying further operations to the output.
 * @static
 * @param  {number} res  Hexagon resolution
 * @return {number}      Count
 */ function $149c57bfd39d3746$export$fb1fbf4925957012(res) {
    $149c57bfd39d3746$var$validateRes(res); // Get number as a long value
    var ref = $149c57bfd39d3746$var$readLong($149c57bfd39d3746$var$H3.numHexagons(res));
    var lower = ref[0];
    var upper = ref[1]; // If we're using <= 32 bits we can use normal JS numbers
    if (!upper) return lower;
     // Above 32 bit, make a JS number that's correct in order of magnitude
    return upper * Math.pow(2, 32) + lower;
}
/**
 * Get all H3 indexes at resolution 0. As every index at every resolution > 0 is
 * the descendant of a res 0 index, this can be used with h3ToChildren to iterate
 * over H3 indexes at any resolution.
 * @static
 * @return {H3Index[]}  All H3 indexes at res 0
 */ function $149c57bfd39d3746$export$c6297e04da1d9191() {
    var count = $149c57bfd39d3746$var$H3.res0IndexCount();
    var hexagons = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_H3INDEX * count);
    $149c57bfd39d3746$var$H3.getRes0Indexes(hexagons);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, count);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    return out;
}
/**
 * Get the twelve pentagon indexes at a given resolution.
 * @static
 * @param  {number} res  Hexagon resolution
 * @return {H3Index[]}  All H3 pentagon indexes at res
 */ function $149c57bfd39d3746$export$ecc8411f8c9b1ec1(res) {
    $149c57bfd39d3746$var$validateRes(res);
    var count = $149c57bfd39d3746$var$H3.pentagonIndexCount();
    var hexagons = $149c57bfd39d3746$var$libh3._malloc($149c57bfd39d3746$var$SZ_H3INDEX * count);
    $149c57bfd39d3746$var$H3.getPentagonIndexes(res, hexagons);
    var out = $149c57bfd39d3746$var$readArrayOfHexagons(hexagons, count);
    $149c57bfd39d3746$var$libh3._free(hexagons);
    return out;
}
/**
 * Convert degrees to radians
 * @static
 * @param  {number} deg Value in degrees
 * @return {number}     Value in radians
 */ function $149c57bfd39d3746$export$18f2af2888c1a46b(deg) {
    return deg * Math.PI / 180;
}
/**
 * Convert radians to degrees
 * @static
 * @param  {number} rad Value in radians
 * @return {number}     Value in degrees
 */ function $149c57bfd39d3746$export$3eb27537c08caf0f(rad) {
    return rad * 180 / Math.PI;
}

});


parcelRegister("7Umyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.SELECTION_TYPE = void 0;

var $coXLq = parcelRequire("coXLq");

var $6ey8i = parcelRequire("6ey8i");

var $7GKQS = parcelRequire("7GKQS");

var $5c1f429e0d20adef$var$_buffer = $5c1f429e0d20adef$var$_interopRequireDefault((parcelRequire("3qree")));

var $5c1f429e0d20adef$var$_difference = $5c1f429e0d20adef$var$_interopRequireDefault((parcelRequire("gZv4c")));

var $cQSdn = parcelRequire("cQSdn");

var $5c1f429e0d20adef$var$_editableGeojsonLayer = $5c1f429e0d20adef$var$_interopRequireDefault((parcelRequire("lHhsg")));
var $5c1f429e0d20adef$var$_MODE_MAP;
function $5c1f429e0d20adef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5c1f429e0d20adef$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5c1f429e0d20adef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5c1f429e0d20adef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5c1f429e0d20adef$var$_typeof(obj);
}
function $5c1f429e0d20adef$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5c1f429e0d20adef$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5c1f429e0d20adef$var$ownKeys(Object(source), true).forEach(function(key) {
            $5c1f429e0d20adef$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5c1f429e0d20adef$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5c1f429e0d20adef$var$_toConsumableArray(arr) {
    return $5c1f429e0d20adef$var$_arrayWithoutHoles(arr) || $5c1f429e0d20adef$var$_iterableToArray(arr) || $5c1f429e0d20adef$var$_unsupportedIterableToArray(arr) || $5c1f429e0d20adef$var$_nonIterableSpread();
}
function $5c1f429e0d20adef$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5c1f429e0d20adef$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $5c1f429e0d20adef$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5c1f429e0d20adef$var$_arrayLikeToArray(arr);
}
function $5c1f429e0d20adef$var$_slicedToArray(arr, i) {
    return $5c1f429e0d20adef$var$_arrayWithHoles(arr) || $5c1f429e0d20adef$var$_iterableToArrayLimit(arr, i) || $5c1f429e0d20adef$var$_unsupportedIterableToArray(arr, i) || $5c1f429e0d20adef$var$_nonIterableRest();
}
function $5c1f429e0d20adef$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5c1f429e0d20adef$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5c1f429e0d20adef$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5c1f429e0d20adef$var$_arrayLikeToArray(o, minLen);
}
function $5c1f429e0d20adef$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5c1f429e0d20adef$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5c1f429e0d20adef$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5c1f429e0d20adef$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5c1f429e0d20adef$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5c1f429e0d20adef$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5c1f429e0d20adef$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5c1f429e0d20adef$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5c1f429e0d20adef$var$_createSuper(Derived) {
    return function() {
        var Super = $5c1f429e0d20adef$var$_getPrototypeOf(Derived), result;
        if ($5c1f429e0d20adef$var$_isNativeReflectConstruct()) {
            var NewTarget = $5c1f429e0d20adef$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5c1f429e0d20adef$var$_possibleConstructorReturn(this, result);
    };
}
function $5c1f429e0d20adef$var$_possibleConstructorReturn(self, call) {
    if (call && ($5c1f429e0d20adef$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5c1f429e0d20adef$var$_assertThisInitialized(self);
}
function $5c1f429e0d20adef$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5c1f429e0d20adef$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5c1f429e0d20adef$var$_getPrototypeOf(o) {
    $5c1f429e0d20adef$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5c1f429e0d20adef$var$_getPrototypeOf(o);
}
function $5c1f429e0d20adef$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5c1f429e0d20adef$var$_setPrototypeOf(subClass, superClass);
}
function $5c1f429e0d20adef$var$_setPrototypeOf(o, p) {
    $5c1f429e0d20adef$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5c1f429e0d20adef$var$_setPrototypeOf(o, p);
}
function $5c1f429e0d20adef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5c1f429e0d20adef$var$SELECTION_TYPE = {
    NONE: null,
    RECTANGLE: "rectangle",
    POLYGON: "polygon"
};
module.exports.SELECTION_TYPE = $5c1f429e0d20adef$var$SELECTION_TYPE;
var $5c1f429e0d20adef$var$MODE_MAP = ($5c1f429e0d20adef$var$_MODE_MAP = {}, $5c1f429e0d20adef$var$_defineProperty($5c1f429e0d20adef$var$_MODE_MAP, $5c1f429e0d20adef$var$SELECTION_TYPE.RECTANGLE, $cQSdn.DrawRectangleMode), $5c1f429e0d20adef$var$_defineProperty($5c1f429e0d20adef$var$_MODE_MAP, $5c1f429e0d20adef$var$SELECTION_TYPE.POLYGON, $cQSdn.DrawPolygonMode), $5c1f429e0d20adef$var$_MODE_MAP);
var $5c1f429e0d20adef$var$MODE_CONFIG_MAP = $5c1f429e0d20adef$var$_defineProperty({}, $5c1f429e0d20adef$var$SELECTION_TYPE.RECTANGLE, {
    dragToDraw: true
});
var $5c1f429e0d20adef$var$defaultProps = {
    selectionType: $5c1f429e0d20adef$var$SELECTION_TYPE.RECTANGLE,
    layerIds: [],
    onSelect: function onSelect() {}
};
var $5c1f429e0d20adef$var$EMPTY_DATA = {
    type: "FeatureCollection",
    features: []
};
var $5c1f429e0d20adef$var$EXPANSION_KM = 50;
var $5c1f429e0d20adef$var$LAYER_ID_GEOJSON = "selection-geojson";
var $5c1f429e0d20adef$var$LAYER_ID_BLOCKER = "selection-blocker";
var $5c1f429e0d20adef$var$PASS_THROUGH_PROPS = [
    "lineWidthScale",
    "lineWidthMinPixels",
    "lineWidthMaxPixels",
    "lineWidthUnits",
    "lineJointRounded",
    "lineCapRounded",
    "lineMiterLimit",
    "pointRadiusScale",
    "pointRadiusMinPixels",
    "pointRadiusMaxPixels",
    "lineDashJustified",
    "getLineColor",
    "getFillColor",
    "getRadius",
    "getLineWidth",
    "getLineDashArray",
    "getTentativeLineDashArray",
    "getTentativeLineColor",
    "getTentativeFillColor",
    "getTentativeLineWidth"
];
var $5c1f429e0d20adef$var$SelectionLayer = /*#__PURE__*/ function(_CompositeLayer) {
    $5c1f429e0d20adef$var$_inherits(SelectionLayer, _CompositeLayer);
    var _super = $5c1f429e0d20adef$var$_createSuper(SelectionLayer);
    function SelectionLayer() {
        $5c1f429e0d20adef$var$_classCallCheck(this, SelectionLayer);
        return _super.apply(this, arguments);
    }
    $5c1f429e0d20adef$var$_createClass(SelectionLayer, [
        {
            key: "_selectRectangleObjects",
            value: function _selectRectangleObjects(coordinates) {
                var _this$props = this.props, layerIds = _this$props.layerIds, onSelect = _this$props.onSelect; // @ts-ignore
                var _this$context$viewpor = this.context.viewport.project(coordinates[0][0]), _this$context$viewpor2 = $5c1f429e0d20adef$var$_slicedToArray(_this$context$viewpor, 2), x1 = _this$context$viewpor2[0], y1 = _this$context$viewpor2[1]; // @ts-ignore
                var _this$context$viewpor3 = this.context.viewport.project(coordinates[0][2]), _this$context$viewpor4 = $5c1f429e0d20adef$var$_slicedToArray(_this$context$viewpor3, 2), x2 = _this$context$viewpor4[0], y2 = _this$context$viewpor4[1]; // @ts-ignore
                var pickingInfos = this.context.deck.pickObjects({
                    x: Math.min(x1, x2),
                    y: Math.min(y1, y2),
                    width: Math.abs(x2 - x1),
                    height: Math.abs(y2 - y1),
                    layerIds: layerIds
                });
                onSelect({
                    pickingInfos: pickingInfos
                });
            }
        },
        {
            key: "_selectPolygonObjects",
            value: function _selectPolygonObjects(coordinates) {
                var _this = this;
                var _this$props2 = this.props, layerIds = _this$props2.layerIds, onSelect = _this$props2.onSelect; // @ts-ignore
                var mousePoints = coordinates[0].map(function(c) {
                    return _this.context.viewport.project(c);
                });
                var allX = mousePoints.map(function(mousePoint) {
                    return mousePoint[0];
                });
                var allY = mousePoints.map(function(mousePoint) {
                    return mousePoint[1];
                });
                var x = Math.min.apply(Math, $5c1f429e0d20adef$var$_toConsumableArray(allX));
                var y = Math.min.apply(Math, $5c1f429e0d20adef$var$_toConsumableArray(allY));
                var maxX = Math.max.apply(Math, $5c1f429e0d20adef$var$_toConsumableArray(allX));
                var maxY = Math.max.apply(Math, $5c1f429e0d20adef$var$_toConsumableArray(allY)); // Use a polygon to hide the outside, because pickObjects()
                // does not support polygons
                var landPointsPoly = (0, $7GKQS.polygon)(coordinates);
                var bigBuffer = (0, $5c1f429e0d20adef$var$_buffer["default"])(landPointsPoly, $5c1f429e0d20adef$var$EXPANSION_KM);
                var bigPolygon;
                try {
                    // turfDifference throws an exception if the polygon
                    // intersects with itself (TODO: check if true in all versions)
                    bigPolygon = (0, $5c1f429e0d20adef$var$_difference["default"])(bigBuffer, landPointsPoly);
                } catch (e) {
                    // invalid selection polygon
                    console.log("turfDifference() error", e); // eslint-disable-line
                    return;
                }
                this.setState({
                    pendingPolygonSelection: {
                        bigPolygon: bigPolygon
                    }
                });
                var blockerId = "".concat(this.props.id, "-").concat($5c1f429e0d20adef$var$LAYER_ID_BLOCKER); // HACK, find a better way
                setTimeout(function() {
                    // @ts-ignore
                    var pickingInfos = _this.context.deck.pickObjects({
                        x: x,
                        y: y,
                        width: maxX - x,
                        height: maxY - y,
                        layerIds: [
                            blockerId
                        ].concat($5c1f429e0d20adef$var$_toConsumableArray(layerIds))
                    });
                    onSelect({
                        pickingInfos: pickingInfos.filter(function(item) {
                            return item.layer.id !== _this.props.id;
                        })
                    });
                }, 250);
            }
        },
        {
            key: "renderLayers",
            value: function renderLayers() {
                var _this2 = this;
                var pendingPolygonSelection = this.state.pendingPolygonSelection;
                var mode = $5c1f429e0d20adef$var$MODE_MAP[this.props.selectionType] || $cQSdn.ViewMode;
                var modeConfig = $5c1f429e0d20adef$var$MODE_CONFIG_MAP[this.props.selectionType];
                var inheritedProps = {};
                $5c1f429e0d20adef$var$PASS_THROUGH_PROPS.forEach(function(p) {
                    if (_this2.props[p] !== undefined) inheritedProps[p] = _this2.props[p];
                });
                var layers = [
                    new $5c1f429e0d20adef$var$_editableGeojsonLayer["default"](this.getSubLayerProps($5c1f429e0d20adef$var$_objectSpread({
                        id: $5c1f429e0d20adef$var$LAYER_ID_GEOJSON,
                        pickable: true,
                        mode: mode,
                        modeConfig: modeConfig,
                        selectedFeatureIndexes: [],
                        data: $5c1f429e0d20adef$var$EMPTY_DATA,
                        onEdit: function onEdit(_ref) {
                            var updatedData = _ref.updatedData, editType = _ref.editType;
                            if (editType === "addFeature") {
                                var coordinates = updatedData.features[0].geometry.coordinates;
                                if (_this2.props.selectionType === $5c1f429e0d20adef$var$SELECTION_TYPE.RECTANGLE) _this2._selectRectangleObjects(coordinates);
                                else if (_this2.props.selectionType === $5c1f429e0d20adef$var$SELECTION_TYPE.POLYGON) _this2._selectPolygonObjects(coordinates);
                            }
                        }
                    }, inheritedProps)))
                ];
                if (pendingPolygonSelection) {
                    var bigPolygon = pendingPolygonSelection.bigPolygon;
                    layers.push(new $6ey8i.default(this.getSubLayerProps({
                        id: $5c1f429e0d20adef$var$LAYER_ID_BLOCKER,
                        pickable: true,
                        stroked: false,
                        opacity: 1.0,
                        data: [
                            bigPolygon
                        ],
                        getLineColor: function getLineColor(obj) {
                            return [
                                0,
                                0,
                                0,
                                1
                            ];
                        },
                        getFillColor: function getFillColor(obj) {
                            return [
                                0,
                                0,
                                0,
                                1
                            ];
                        },
                        getPolygon: function getPolygon(o) {
                            return o.geometry.coordinates;
                        }
                    })));
                }
                return layers;
            }
        },
        {
            key: "shouldUpdateState",
            value: function shouldUpdateState(_ref2) {
                var _ref2$changeFlags = _ref2.changeFlags, stateChanged = _ref2$changeFlags.stateChanged, propsOrDataChanged = _ref2$changeFlags.propsOrDataChanged;
                return stateChanged || propsOrDataChanged;
            }
        }
    ]);
    return SelectionLayer;
}($coXLq.default);
module.exports["default"] = $5c1f429e0d20adef$var$SelectionLayer;
$5c1f429e0d20adef$var$_defineProperty($5c1f429e0d20adef$var$SelectionLayer, "layerName", "SelectionLayer");
$5c1f429e0d20adef$var$_defineProperty($5c1f429e0d20adef$var$SelectionLayer, "defaultProps", $5c1f429e0d20adef$var$defaultProps);

});

parcelRegister("5p6F6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $coXLq = parcelRequire("coXLq");

var $h7vzQ = parcelRequire("h7vzQ");
var $cYQ5y = parcelRequire("cYQ5y");
function $3ef4747b9a071852$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3ef4747b9a071852$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3ef4747b9a071852$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3ef4747b9a071852$var$_typeof(obj);
}
function $3ef4747b9a071852$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3ef4747b9a071852$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3ef4747b9a071852$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3ef4747b9a071852$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3ef4747b9a071852$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3ef4747b9a071852$var$_createSuper(Derived) {
    return function() {
        var Super = $3ef4747b9a071852$var$_getPrototypeOf(Derived), result;
        if ($3ef4747b9a071852$var$_isNativeReflectConstruct()) {
            var NewTarget = $3ef4747b9a071852$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3ef4747b9a071852$var$_possibleConstructorReturn(this, result);
    };
}
function $3ef4747b9a071852$var$_possibleConstructorReturn(self, call) {
    if (call && ($3ef4747b9a071852$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3ef4747b9a071852$var$_assertThisInitialized(self);
}
function $3ef4747b9a071852$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3ef4747b9a071852$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3ef4747b9a071852$var$_getPrototypeOf(o) {
    $3ef4747b9a071852$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3ef4747b9a071852$var$_getPrototypeOf(o);
}
function $3ef4747b9a071852$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3ef4747b9a071852$var$_setPrototypeOf(subClass, superClass);
}
function $3ef4747b9a071852$var$_setPrototypeOf(o, p) {
    $3ef4747b9a071852$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3ef4747b9a071852$var$_setPrototypeOf(o, p);
}
function $3ef4747b9a071852$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3ef4747b9a071852$var$defaultProps = {};
var $3ef4747b9a071852$var$ElevatedEditHandleLayer = /*#__PURE__*/ function(_CompositeLayer) {
    $3ef4747b9a071852$var$_inherits(ElevatedEditHandleLayer, _CompositeLayer);
    var _super = $3ef4747b9a071852$var$_createSuper(ElevatedEditHandleLayer);
    function ElevatedEditHandleLayer() {
        $3ef4747b9a071852$var$_classCallCheck(this, ElevatedEditHandleLayer);
        return _super.apply(this, arguments);
    }
    $3ef4747b9a071852$var$_createClass(ElevatedEditHandleLayer, [
        {
            key: "renderLayers",
            value: function renderLayers() {
                var handles = new $cYQ5y.default(Object.assign({}, this.props, {
                    id: "".concat(this.props.id, "-ScatterplotLayer"),
                    data: this.props.data
                }));
                var lines = new $h7vzQ.default(Object.assign({}, this.props, {
                    id: "".concat(this.props.id, "-LineLayer"),
                    data: this.props.data,
                    pickable: false,
                    getSourcePosition: function getSourcePosition(_ref) {
                        var position = _ref.position;
                        return [
                            position[0],
                            position[1],
                            0
                        ];
                    },
                    getTargetPosition: function getTargetPosition(_ref2) {
                        var position = _ref2.position;
                        return [
                            position[0],
                            position[1],
                            position[2] || 0
                        ];
                    },
                    getColor: [
                        150,
                        150,
                        150,
                        200
                    ],
                    getStrokeWidth: 3
                }));
                return [
                    handles,
                    lines
                ];
            }
        }
    ]);
    return ElevatedEditHandleLayer;
}($coXLq.default);
module.exports["default"] = $3ef4747b9a071852$var$ElevatedEditHandleLayer;
$3ef4747b9a071852$var$_defineProperty($3ef4747b9a071852$var$ElevatedEditHandleLayer, "layerName", "ElevatedEditHandleLayer");
$3ef4747b9a071852$var$_defineProperty($3ef4747b9a071852$var$ElevatedEditHandleLayer, "defaultProps", $3ef4747b9a071852$var$defaultProps);

});
parcelRegister("h7vzQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c76b95a99c2450eb$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $lEQUF = parcelRequire("lEQUF");

var $i46md = parcelRequire("i46md");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");
var $7gQQK = parcelRequire("7gQQK");

var $cxTxU = parcelRequire("cxTxU");
var $b2F4S = parcelRequire("b2F4S");

var $liSuz = parcelRequire("liSuz");

var $bzPIt = parcelRequire("bzPIt");
const $c76b95a99c2450eb$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $c76b95a99c2450eb$var$defaultProps = {
    getSourcePosition: {
        type: "accessor",
        value: (x)=>x.sourcePosition
    },
    getTargetPosition: {
        type: "accessor",
        value: (x)=>x.targetPosition
    },
    getColor: {
        type: "accessor",
        value: $c76b95a99c2450eb$var$DEFAULT_COLOR
    },
    getWidth: {
        type: "accessor",
        value: 1
    },
    widthUnits: "pixels",
    widthScale: {
        type: "number",
        value: 1,
        min: 0
    },
    widthMinPixels: {
        type: "number",
        value: 0,
        min: 0
    },
    widthMaxPixels: {
        type: "number",
        value: Number.MAX_SAFE_INTEGER,
        min: 0
    }
};
class $c76b95a99c2450eb$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getBounds() {
        var _this$getAttributeMan;
        return (_this$getAttributeMan = this.getAttributeManager()) === null || _this$getAttributeMan === void 0 ? void 0 : _this$getAttributeMan.getBounds([
            "instanceSourcePositions",
            "instanceTargetPositions"
        ]);
    }
    getShaders() {
        return super.getShaders({
            vs: $liSuz.default,
            fs: $bzPIt.default,
            modules: [
                (0, $jRSMz.default),
                (0, $7UxuR.default)
            ]
        });
    }
    get wrapLongitude() {
        return false;
    }
    initializeState() {
        const attributeManager = this.getAttributeManager();
        attributeManager.addInstanced({
            instanceSourcePositions: {
                size: 3,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: true,
                accessor: "getSourcePosition"
            },
            instanceTargetPositions: {
                size: 3,
                type: 5130,
                fp64: this.use64bitPositions(),
                transition: true,
                accessor: "getTargetPosition"
            },
            instanceColors: {
                size: this.props.colorFormat.length,
                type: 5121,
                normalized: true,
                transition: true,
                accessor: "getColor",
                defaultValue: [
                    0,
                    0,
                    0,
                    255
                ]
            },
            instanceWidths: {
                size: 1,
                transition: true,
                accessor: "getWidth",
                defaultValue: 1
            }
        });
    }
    updateState(params) {
        super.updateState(params);
        if (params.changeFlags.extensionsChanged) {
            var _this$state$model;
            const { gl: gl } = this.context;
            (_this$state$model = this.state.model) === null || _this$state$model === void 0 || _this$state$model.delete();
            this.state.model = this._getModel(gl);
            this.getAttributeManager().invalidateAll();
        }
    }
    draw({ uniforms: uniforms }) {
        const { widthUnits: widthUnits, widthScale: widthScale, widthMinPixels: widthMinPixels, widthMaxPixels: widthMaxPixels, wrapLongitude: wrapLongitude } = this.props;
        this.state.model.setUniforms(uniforms).setUniforms({
            widthUnits: (0, $7gQQK.UNIT)[widthUnits],
            widthScale: widthScale,
            widthMinPixels: widthMinPixels,
            widthMaxPixels: widthMaxPixels,
            useShortestPath: wrapLongitude ? 1 : 0
        }).draw();
        if (wrapLongitude) this.state.model.setUniforms({
            useShortestPath: -1
        }).draw();
    }
    _getModel(gl) {
        const positions = [
            0,
            -1,
            0,
            0,
            1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        return new (0, $b2F4S.default)(gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders()), {
            id: this.props.id,
            geometry: new (0, $cxTxU.default)({
                drawMode: 5,
                attributes: {
                    positions: new Float32Array(positions)
                }
            }),
            isInstanced: true
        }));
    }
}
(0, $lEQUF.default)($c76b95a99c2450eb$export$2e2bcd8739ae039, "layerName", "LineLayer");
(0, $lEQUF.default)($c76b95a99c2450eb$export$2e2bcd8739ae039, "defaultProps", $c76b95a99c2450eb$var$defaultProps);

});
parcelRegister("liSuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8258c66d18bab63$export$2e2bcd8739ae039; });
var $f8258c66d18bab63$export$2e2bcd8739ae039 = "#define SHADER_NAME line-layer-vertex-shader\n\nattribute vec3 positions;\nattribute vec3 instanceSourcePositions;\nattribute vec3 instanceTargetPositions;\nattribute vec3 instanceSourcePositions64Low;\nattribute vec3 instanceTargetPositions64Low;\nattribute vec4 instanceColors;\nattribute vec3 instancePickingColors;\nattribute float instanceWidths;\n\nuniform float opacity;\nuniform float widthScale;\nuniform float widthMinPixels;\nuniform float widthMaxPixels;\nuniform float useShortestPath;\nuniform int widthUnits;\n\nvarying vec4 vColor;\nvarying vec2 uv;\nvec2 getExtrusionOffset(vec2 line_clipspace, float offset_direction, float width) {\n  vec2 dir_screenspace = normalize(line_clipspace * project_uViewportSize);\n  dir_screenspace = vec2(-dir_screenspace.y, dir_screenspace.x);\n\n  return dir_screenspace * offset_direction * width / 2.0;\n}\n\nvec3 splitLine(vec3 a, vec3 b, float x) {\n  float t = (x - a.x) / (b.x - a.x);\n  return vec3(x, mix(a.yz, b.yz, t));\n}\n\nvoid main(void) {\n  geometry.worldPosition = instanceSourcePositions;\n  geometry.worldPositionAlt = instanceTargetPositions;\n\n  vec3 source_world = instanceSourcePositions;\n  vec3 target_world = instanceTargetPositions;\n  vec3 source_world_64low = instanceSourcePositions64Low;\n  vec3 target_world_64low = instanceTargetPositions64Low;\n\n  if (useShortestPath > 0.5 || useShortestPath < -0.5) {\n    source_world.x = mod(source_world.x + 180., 360.0) - 180.;\n    target_world.x = mod(target_world.x + 180., 360.0) - 180.;\n    float deltaLng = target_world.x - source_world.x;\n\n    if (deltaLng * useShortestPath > 180.) {\n      source_world.x += 360. * useShortestPath;\n      source_world = splitLine(source_world, target_world, 180. * useShortestPath);\n      source_world_64low = vec3(0.0);\n    } else if (deltaLng * useShortestPath < -180.) {\n      target_world.x += 360. * useShortestPath;\n      target_world = splitLine(source_world, target_world, 180. * useShortestPath);\n      target_world_64low = vec3(0.0);\n    } else if (useShortestPath < 0.) {\n      gl_Position = vec4(0.);\n      return;\n    }\n  }\n  vec4 source_commonspace;\n  vec4 target_commonspace;\n  vec4 source = project_position_to_clipspace(source_world, source_world_64low, vec3(0.), source_commonspace);\n  vec4 target = project_position_to_clipspace(target_world, target_world_64low, vec3(0.), target_commonspace);\n  float segmentIndex = positions.x;\n  vec4 p = mix(source, target, segmentIndex);\n  geometry.position = mix(source_commonspace, target_commonspace, segmentIndex);\n  uv = positions.xy;\n  geometry.uv = uv;\n  geometry.pickingColor = instancePickingColors;\n  float widthPixels = clamp(\n    project_size_to_pixel(instanceWidths * widthScale, widthUnits),\n    widthMinPixels, widthMaxPixels\n  );\n  vec3 offset = vec3(\n    getExtrusionOffset(target.xy - source.xy, positions.y, widthPixels),\n    0.0);\n  DECKGL_FILTER_SIZE(offset, geometry);\n  DECKGL_FILTER_GL_POSITION(p, geometry);\n  gl_Position = p + vec4(project_pixel_size_to_clipspace(offset.xy), 0.0, 0.0);\n  vColor = vec4(instanceColors.rgb, instanceColors.a * opacity);\n  DECKGL_FILTER_COLOR(vColor, geometry);\n}\n";

});

parcelRegister("bzPIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86db145e4f5b9bc6$export$2e2bcd8739ae039; });
var $86db145e4f5b9bc6$export$2e2bcd8739ae039 = "#define SHADER_NAME line-layer-fragment-shader\n\nprecision highp float;\n\nvarying vec4 vColor;\nvarying vec2 uv;\n\nvoid main(void) {\n  geometry.uv = uv;\n\n  gl_FragColor = vColor;\n\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";

});



parcelRegister("hwgS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $lzW2S = parcelRequire("lzW2S");

var $cc12834887805e55$var$_constants = $cc12834887805e55$var$_interopRequireDefault((parcelRequire("6ZpD9")));

var $cJo7e = parcelRequire("cJo7e");
var $7lUAH = parcelRequire("7lUAH");

var $cc12834887805e55$var$_outline = $cc12834887805e55$var$_interopRequireDefault((parcelRequire("jT2Ca")));

var $9brng = parcelRequire("9brng");
function $cc12834887805e55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $cc12834887805e55$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cc12834887805e55$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cc12834887805e55$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cc12834887805e55$var$_typeof(obj);
}
function $cc12834887805e55$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cc12834887805e55$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cc12834887805e55$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cc12834887805e55$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cc12834887805e55$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cc12834887805e55$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $cc12834887805e55$var$_get = Reflect.get;
    else $cc12834887805e55$var$_get = function _get(target, property, receiver) {
        var base = $cc12834887805e55$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $cc12834887805e55$var$_get(target, property, receiver || target);
}
function $cc12834887805e55$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $cc12834887805e55$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $cc12834887805e55$var$_createSuper(Derived) {
    return function() {
        var Super = $cc12834887805e55$var$_getPrototypeOf(Derived), result;
        if ($cc12834887805e55$var$_isNativeReflectConstruct()) {
            var NewTarget = $cc12834887805e55$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cc12834887805e55$var$_possibleConstructorReturn(this, result);
    };
}
function $cc12834887805e55$var$_possibleConstructorReturn(self, call) {
    if (call && ($cc12834887805e55$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cc12834887805e55$var$_assertThisInitialized(self);
}
function $cc12834887805e55$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cc12834887805e55$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cc12834887805e55$var$_getPrototypeOf(o) {
    $cc12834887805e55$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cc12834887805e55$var$_getPrototypeOf(o);
}
function $cc12834887805e55$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cc12834887805e55$var$_setPrototypeOf(subClass, superClass);
}
function $cc12834887805e55$var$_setPrototypeOf(o, p) {
    $cc12834887805e55$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cc12834887805e55$var$_setPrototypeOf(o, p);
}
function $cc12834887805e55$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// TODO - this should be built into assembleShaders
function $cc12834887805e55$var$injectShaderCode(_ref) {
    var source = _ref.source, _ref$code = _ref.code, code = _ref$code === void 0 ? "" : _ref$code;
    var INJECT_CODE = /}[^{}]*$/;
    return source.replace(INJECT_CODE, code.concat("\n}\n"));
}
var $cc12834887805e55$var$VS_CODE = "  outline_setUV(gl_Position);\n  outline_setZLevel(instanceZLevel);\n";
var $cc12834887805e55$var$FS_CODE = "  gl_FragColor = outline_filterColor(gl_FragColor);\n";
var $cc12834887805e55$var$defaultProps = {
    getZLevel: function getZLevel() {
        return 0;
    }
};
var $cc12834887805e55$var$PathOutlineLayer = /*#__PURE__*/ function(_PathLayer) {
    $cc12834887805e55$var$_inherits(PathOutlineLayer, _PathLayer);
    var _super = $cc12834887805e55$var$_createSuper(PathOutlineLayer);
    function PathOutlineLayer() {
        $cc12834887805e55$var$_classCallCheck(this, PathOutlineLayer);
        return _super.apply(this, arguments);
    }
    $cc12834887805e55$var$_createClass(PathOutlineLayer, [
        {
            key: "getShaders",
            // Override getShaders to inject the outline module
            value: function getShaders() {
                var shaders = $cc12834887805e55$var$_get($cc12834887805e55$var$_getPrototypeOf(PathOutlineLayer.prototype), "getShaders", this).call(this);
                return Object.assign({}, shaders, {
                    modules: shaders.modules.concat([
                        $cc12834887805e55$var$_outline["default"]
                    ]),
                    vs: $cc12834887805e55$var$injectShaderCode({
                        source: shaders.vs,
                        code: $cc12834887805e55$var$VS_CODE
                    }),
                    fs: $cc12834887805e55$var$injectShaderCode({
                        source: shaders.fs,
                        code: $cc12834887805e55$var$FS_CODE
                    })
                });
            }
        },
        {
            key: "initializeState",
            value: function initializeState(context) {
                $cc12834887805e55$var$_get($cc12834887805e55$var$_getPrototypeOf(PathOutlineLayer.prototype), "initializeState", this).call(this, context); // Create an outline "shadow" map
                // TODO - we should create a single outlineMap for all layers
                this.setState({
                    outlineFramebuffer: new $cJo7e.default(context.gl),
                    dummyTexture: new $7lUAH.default(context.gl)
                }); // Create an attribute manager
                this.state.attributeManager.addInstanced({
                    instanceZLevel: {
                        size: 1,
                        type: $cc12834887805e55$var$_constants["default"].UNSIGNED_BYTE,
                        accessor: "getZLevel"
                    }
                });
            } // Override draw to add render module
        },
        {
            key: "draw",
            value: function draw(_ref2) {
                var _ref2$moduleParameter = _ref2.moduleParameters, moduleParameters = _ref2$moduleParameter === void 0 ? {} : _ref2$moduleParameter, parameters = _ref2.parameters, uniforms = _ref2.uniforms, context = _ref2.context;
                // Need to calculate same uniforms as base layer
                var _this$props = this.props, jointRounded = _this$props.jointRounded, capRounded = _this$props.capRounded, billboard = _this$props.billboard, miterLimit = _this$props.miterLimit, widthUnits = _this$props.widthUnits, widthScale = _this$props.widthScale, widthMinPixels = _this$props.widthMinPixels, widthMaxPixels = _this$props.widthMaxPixels;
                uniforms = Object.assign({}, uniforms, {
                    jointType: Number(jointRounded),
                    capType: Number(capRounded),
                    billboard: billboard,
                    widthUnits: $9brng.UNIT[widthUnits],
                    widthScale: widthScale,
                    miterLimit: miterLimit,
                    widthMinPixels: widthMinPixels,
                    widthMaxPixels: widthMaxPixels
                }); // Render the outline shadowmap (based on segment z orders)
                var _this$state = this.state, outlineFramebuffer = _this$state.outlineFramebuffer, dummyTexture = _this$state.dummyTexture;
                outlineFramebuffer.resize();
                outlineFramebuffer.clear({
                    color: true,
                    depth: true
                });
                this.state.model.updateModuleSettings({
                    outlineEnabled: true,
                    outlineRenderShadowmap: true,
                    outlineShadowmap: dummyTexture
                });
                this.state.model.draw({
                    uniforms: Object.assign({}, uniforms, {
                        jointType: 0,
                        widthScale: this.props.widthScale * 1.3
                    }),
                    parameters: {
                        depthTest: false,
                        // Biggest value needs to go into buffer
                        blendEquation: $cc12834887805e55$var$_constants["default"].MAX
                    },
                    framebuffer: outlineFramebuffer
                }); // Now use the outline shadowmap to render the lines (with outlines)
                this.state.model.updateModuleSettings({
                    outlineEnabled: true,
                    outlineRenderShadowmap: false,
                    outlineShadowmap: outlineFramebuffer
                });
                this.state.model.draw({
                    uniforms: Object.assign({}, uniforms, {
                        jointType: Number(jointRounded),
                        capType: Number(capRounded),
                        widthScale: this.props.widthScale
                    }),
                    parameters: {
                        depthTest: false
                    }
                });
            }
        }
    ]);
    return PathOutlineLayer;
}($lzW2S.default);
module.exports["default"] = $cc12834887805e55$var$PathOutlineLayer;
$cc12834887805e55$var$_defineProperty($cc12834887805e55$var$PathOutlineLayer, "layerName", "PathOutlineLayer");
$cc12834887805e55$var$_defineProperty($cc12834887805e55$var$PathOutlineLayer, "defaultProps", $cc12834887805e55$var$defaultProps);

});
parcelRegister("6ZpD9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $516c5244f4abe995$export$2e2bcd8739ae039; });
var $516c5244f4abe995$export$2e2bcd8739ae039 = {
    DEPTH_BUFFER_BIT: 0x00000100,
    STENCIL_BUFFER_BIT: 0x00000400,
    COLOR_BUFFER_BIT: 0x00004000,
    POINTS: 0x0000,
    LINES: 0x0001,
    LINE_LOOP: 0x0002,
    LINE_STRIP: 0x0003,
    TRIANGLES: 0x0004,
    TRIANGLE_STRIP: 0x0005,
    TRIANGLE_FAN: 0x0006,
    ZERO: 0,
    ONE: 1,
    SRC_COLOR: 0x0300,
    ONE_MINUS_SRC_COLOR: 0x0301,
    SRC_ALPHA: 0x0302,
    ONE_MINUS_SRC_ALPHA: 0x0303,
    DST_ALPHA: 0x0304,
    ONE_MINUS_DST_ALPHA: 0x0305,
    DST_COLOR: 0x0306,
    ONE_MINUS_DST_COLOR: 0x0307,
    SRC_ALPHA_SATURATE: 0x0308,
    CONSTANT_COLOR: 0x8001,
    ONE_MINUS_CONSTANT_COLOR: 0x8002,
    CONSTANT_ALPHA: 0x8003,
    ONE_MINUS_CONSTANT_ALPHA: 0x8004,
    FUNC_ADD: 0x8006,
    FUNC_SUBTRACT: 0x800a,
    FUNC_REVERSE_SUBTRACT: 0x800b,
    BLEND_EQUATION: 0x8009,
    BLEND_EQUATION_RGB: 0x8009,
    BLEND_EQUATION_ALPHA: 0x883d,
    BLEND_DST_RGB: 0x80c8,
    BLEND_SRC_RGB: 0x80c9,
    BLEND_DST_ALPHA: 0x80ca,
    BLEND_SRC_ALPHA: 0x80cb,
    BLEND_COLOR: 0x8005,
    ARRAY_BUFFER_BINDING: 0x8894,
    ELEMENT_ARRAY_BUFFER_BINDING: 0x8895,
    LINE_WIDTH: 0x0b21,
    ALIASED_POINT_SIZE_RANGE: 0x846d,
    ALIASED_LINE_WIDTH_RANGE: 0x846e,
    CULL_FACE_MODE: 0x0b45,
    FRONT_FACE: 0x0b46,
    DEPTH_RANGE: 0x0b70,
    DEPTH_WRITEMASK: 0x0b72,
    DEPTH_CLEAR_VALUE: 0x0b73,
    DEPTH_FUNC: 0x0b74,
    STENCIL_CLEAR_VALUE: 0x0b91,
    STENCIL_FUNC: 0x0b92,
    STENCIL_FAIL: 0x0b94,
    STENCIL_PASS_DEPTH_FAIL: 0x0b95,
    STENCIL_PASS_DEPTH_PASS: 0x0b96,
    STENCIL_REF: 0x0b97,
    STENCIL_VALUE_MASK: 0x0b93,
    STENCIL_WRITEMASK: 0x0b98,
    STENCIL_BACK_FUNC: 0x8800,
    STENCIL_BACK_FAIL: 0x8801,
    STENCIL_BACK_PASS_DEPTH_FAIL: 0x8802,
    STENCIL_BACK_PASS_DEPTH_PASS: 0x8803,
    STENCIL_BACK_REF: 0x8ca3,
    STENCIL_BACK_VALUE_MASK: 0x8ca4,
    STENCIL_BACK_WRITEMASK: 0x8ca5,
    VIEWPORT: 0x0ba2,
    SCISSOR_BOX: 0x0c10,
    COLOR_CLEAR_VALUE: 0x0c22,
    COLOR_WRITEMASK: 0x0c23,
    UNPACK_ALIGNMENT: 0x0cf5,
    PACK_ALIGNMENT: 0x0d05,
    MAX_TEXTURE_SIZE: 0x0d33,
    MAX_VIEWPORT_DIMS: 0x0d3a,
    SUBPIXEL_BITS: 0x0d50,
    RED_BITS: 0x0d52,
    GREEN_BITS: 0x0d53,
    BLUE_BITS: 0x0d54,
    ALPHA_BITS: 0x0d55,
    DEPTH_BITS: 0x0d56,
    STENCIL_BITS: 0x0d57,
    POLYGON_OFFSET_UNITS: 0x2a00,
    POLYGON_OFFSET_FACTOR: 0x8038,
    TEXTURE_BINDING_2D: 0x8069,
    SAMPLE_BUFFERS: 0x80a8,
    SAMPLES: 0x80a9,
    SAMPLE_COVERAGE_VALUE: 0x80aa,
    SAMPLE_COVERAGE_INVERT: 0x80ab,
    COMPRESSED_TEXTURE_FORMATS: 0x86a3,
    VENDOR: 0x1f00,
    RENDERER: 0x1f01,
    VERSION: 0x1f02,
    IMPLEMENTATION_COLOR_READ_TYPE: 0x8b9a,
    IMPLEMENTATION_COLOR_READ_FORMAT: 0x8b9b,
    BROWSER_DEFAULT_WEBGL: 0x9244,
    STATIC_DRAW: 0x88e4,
    STREAM_DRAW: 0x88e0,
    DYNAMIC_DRAW: 0x88e8,
    ARRAY_BUFFER: 0x8892,
    ELEMENT_ARRAY_BUFFER: 0x8893,
    BUFFER_SIZE: 0x8764,
    BUFFER_USAGE: 0x8765,
    CURRENT_VERTEX_ATTRIB: 0x8626,
    VERTEX_ATTRIB_ARRAY_ENABLED: 0x8622,
    VERTEX_ATTRIB_ARRAY_SIZE: 0x8623,
    VERTEX_ATTRIB_ARRAY_STRIDE: 0x8624,
    VERTEX_ATTRIB_ARRAY_TYPE: 0x8625,
    VERTEX_ATTRIB_ARRAY_NORMALIZED: 0x886a,
    VERTEX_ATTRIB_ARRAY_POINTER: 0x8645,
    VERTEX_ATTRIB_ARRAY_BUFFER_BINDING: 0x889f,
    CULL_FACE: 0x0b44,
    FRONT: 0x0404,
    BACK: 0x0405,
    FRONT_AND_BACK: 0x0408,
    BLEND: 0x0be2,
    DEPTH_TEST: 0x0b71,
    DITHER: 0x0bd0,
    POLYGON_OFFSET_FILL: 0x8037,
    SAMPLE_ALPHA_TO_COVERAGE: 0x809e,
    SAMPLE_COVERAGE: 0x80a0,
    SCISSOR_TEST: 0x0c11,
    STENCIL_TEST: 0x0b90,
    NO_ERROR: 0,
    INVALID_ENUM: 0x0500,
    INVALID_VALUE: 0x0501,
    INVALID_OPERATION: 0x0502,
    OUT_OF_MEMORY: 0x0505,
    CONTEXT_LOST_WEBGL: 0x9242,
    CW: 0x0900,
    CCW: 0x0901,
    DONT_CARE: 0x1100,
    FASTEST: 0x1101,
    NICEST: 0x1102,
    GENERATE_MIPMAP_HINT: 0x8192,
    BYTE: 0x1400,
    UNSIGNED_BYTE: 0x1401,
    SHORT: 0x1402,
    UNSIGNED_SHORT: 0x1403,
    INT: 0x1404,
    UNSIGNED_INT: 0x1405,
    FLOAT: 0x1406,
    DOUBLE: 0x140a,
    DEPTH_COMPONENT: 0x1902,
    ALPHA: 0x1906,
    RGB: 0x1907,
    RGBA: 0x1908,
    LUMINANCE: 0x1909,
    LUMINANCE_ALPHA: 0x190a,
    UNSIGNED_SHORT_4_4_4_4: 0x8033,
    UNSIGNED_SHORT_5_5_5_1: 0x8034,
    UNSIGNED_SHORT_5_6_5: 0x8363,
    FRAGMENT_SHADER: 0x8b30,
    VERTEX_SHADER: 0x8b31,
    COMPILE_STATUS: 0x8b81,
    DELETE_STATUS: 0x8b80,
    LINK_STATUS: 0x8b82,
    VALIDATE_STATUS: 0x8b83,
    ATTACHED_SHADERS: 0x8b85,
    ACTIVE_ATTRIBUTES: 0x8b89,
    ACTIVE_UNIFORMS: 0x8b86,
    MAX_VERTEX_ATTRIBS: 0x8869,
    MAX_VERTEX_UNIFORM_VECTORS: 0x8dfb,
    MAX_VARYING_VECTORS: 0x8dfc,
    MAX_COMBINED_TEXTURE_IMAGE_UNITS: 0x8b4d,
    MAX_VERTEX_TEXTURE_IMAGE_UNITS: 0x8b4c,
    MAX_TEXTURE_IMAGE_UNITS: 0x8872,
    MAX_FRAGMENT_UNIFORM_VECTORS: 0x8dfd,
    SHADER_TYPE: 0x8b4f,
    SHADING_LANGUAGE_VERSION: 0x8b8c,
    CURRENT_PROGRAM: 0x8b8d,
    NEVER: 0x0200,
    ALWAYS: 0x0207,
    LESS: 0x0201,
    EQUAL: 0x0202,
    LEQUAL: 0x0203,
    GREATER: 0x0204,
    GEQUAL: 0x0206,
    NOTEQUAL: 0x0205,
    KEEP: 0x1e00,
    REPLACE: 0x1e01,
    INCR: 0x1e02,
    DECR: 0x1e03,
    INVERT: 0x150a,
    INCR_WRAP: 0x8507,
    DECR_WRAP: 0x8508,
    NEAREST: 0x2600,
    LINEAR: 0x2601,
    NEAREST_MIPMAP_NEAREST: 0x2700,
    LINEAR_MIPMAP_NEAREST: 0x2701,
    NEAREST_MIPMAP_LINEAR: 0x2702,
    LINEAR_MIPMAP_LINEAR: 0x2703,
    TEXTURE_MAG_FILTER: 0x2800,
    TEXTURE_MIN_FILTER: 0x2801,
    TEXTURE_WRAP_S: 0x2802,
    TEXTURE_WRAP_T: 0x2803,
    TEXTURE_2D: 0x0de1,
    TEXTURE: 0x1702,
    TEXTURE_CUBE_MAP: 0x8513,
    TEXTURE_BINDING_CUBE_MAP: 0x8514,
    TEXTURE_CUBE_MAP_POSITIVE_X: 0x8515,
    TEXTURE_CUBE_MAP_NEGATIVE_X: 0x8516,
    TEXTURE_CUBE_MAP_POSITIVE_Y: 0x8517,
    TEXTURE_CUBE_MAP_NEGATIVE_Y: 0x8518,
    TEXTURE_CUBE_MAP_POSITIVE_Z: 0x8519,
    TEXTURE_CUBE_MAP_NEGATIVE_Z: 0x851a,
    MAX_CUBE_MAP_TEXTURE_SIZE: 0x851c,
    TEXTURE0: 0x84c0,
    ACTIVE_TEXTURE: 0x84e0,
    REPEAT: 0x2901,
    CLAMP_TO_EDGE: 0x812f,
    MIRRORED_REPEAT: 0x8370,
    TEXTURE_WIDTH: 0x1000,
    TEXTURE_HEIGHT: 0x1001,
    FLOAT_VEC2: 0x8b50,
    FLOAT_VEC3: 0x8b51,
    FLOAT_VEC4: 0x8b52,
    INT_VEC2: 0x8b53,
    INT_VEC3: 0x8b54,
    INT_VEC4: 0x8b55,
    BOOL: 0x8b56,
    BOOL_VEC2: 0x8b57,
    BOOL_VEC3: 0x8b58,
    BOOL_VEC4: 0x8b59,
    FLOAT_MAT2: 0x8b5a,
    FLOAT_MAT3: 0x8b5b,
    FLOAT_MAT4: 0x8b5c,
    SAMPLER_2D: 0x8b5e,
    SAMPLER_CUBE: 0x8b60,
    LOW_FLOAT: 0x8df0,
    MEDIUM_FLOAT: 0x8df1,
    HIGH_FLOAT: 0x8df2,
    LOW_INT: 0x8df3,
    MEDIUM_INT: 0x8df4,
    HIGH_INT: 0x8df5,
    FRAMEBUFFER: 0x8d40,
    RENDERBUFFER: 0x8d41,
    RGBA4: 0x8056,
    RGB5_A1: 0x8057,
    RGB565: 0x8d62,
    DEPTH_COMPONENT16: 0x81a5,
    STENCIL_INDEX: 0x1901,
    STENCIL_INDEX8: 0x8d48,
    DEPTH_STENCIL: 0x84f9,
    RENDERBUFFER_WIDTH: 0x8d42,
    RENDERBUFFER_HEIGHT: 0x8d43,
    RENDERBUFFER_INTERNAL_FORMAT: 0x8d44,
    RENDERBUFFER_RED_SIZE: 0x8d50,
    RENDERBUFFER_GREEN_SIZE: 0x8d51,
    RENDERBUFFER_BLUE_SIZE: 0x8d52,
    RENDERBUFFER_ALPHA_SIZE: 0x8d53,
    RENDERBUFFER_DEPTH_SIZE: 0x8d54,
    RENDERBUFFER_STENCIL_SIZE: 0x8d55,
    FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE: 0x8cd0,
    FRAMEBUFFER_ATTACHMENT_OBJECT_NAME: 0x8cd1,
    FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL: 0x8cd2,
    FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE: 0x8cd3,
    COLOR_ATTACHMENT0: 0x8ce0,
    DEPTH_ATTACHMENT: 0x8d00,
    STENCIL_ATTACHMENT: 0x8d20,
    DEPTH_STENCIL_ATTACHMENT: 0x821a,
    NONE: 0,
    FRAMEBUFFER_COMPLETE: 0x8cd5,
    FRAMEBUFFER_INCOMPLETE_ATTACHMENT: 0x8cd6,
    FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT: 0x8cd7,
    FRAMEBUFFER_INCOMPLETE_DIMENSIONS: 0x8cd9,
    FRAMEBUFFER_UNSUPPORTED: 0x8cdd,
    FRAMEBUFFER_BINDING: 0x8ca6,
    RENDERBUFFER_BINDING: 0x8ca7,
    READ_FRAMEBUFFER: 0x8ca8,
    DRAW_FRAMEBUFFER: 0x8ca9,
    MAX_RENDERBUFFER_SIZE: 0x84e8,
    INVALID_FRAMEBUFFER_OPERATION: 0x0506,
    UNPACK_FLIP_Y_WEBGL: 0x9240,
    UNPACK_PREMULTIPLY_ALPHA_WEBGL: 0x9241,
    UNPACK_COLORSPACE_CONVERSION_WEBGL: 0x9243,
    READ_BUFFER: 0x0c02,
    UNPACK_ROW_LENGTH: 0x0cf2,
    UNPACK_SKIP_ROWS: 0x0cf3,
    UNPACK_SKIP_PIXELS: 0x0cf4,
    PACK_ROW_LENGTH: 0x0d02,
    PACK_SKIP_ROWS: 0x0d03,
    PACK_SKIP_PIXELS: 0x0d04,
    TEXTURE_BINDING_3D: 0x806a,
    UNPACK_SKIP_IMAGES: 0x806d,
    UNPACK_IMAGE_HEIGHT: 0x806e,
    MAX_3D_TEXTURE_SIZE: 0x8073,
    MAX_ELEMENTS_VERTICES: 0x80e8,
    MAX_ELEMENTS_INDICES: 0x80e9,
    MAX_TEXTURE_LOD_BIAS: 0x84fd,
    MAX_FRAGMENT_UNIFORM_COMPONENTS: 0x8b49,
    MAX_VERTEX_UNIFORM_COMPONENTS: 0x8b4a,
    MAX_ARRAY_TEXTURE_LAYERS: 0x88ff,
    MIN_PROGRAM_TEXEL_OFFSET: 0x8904,
    MAX_PROGRAM_TEXEL_OFFSET: 0x8905,
    MAX_VARYING_COMPONENTS: 0x8b4b,
    FRAGMENT_SHADER_DERIVATIVE_HINT: 0x8b8b,
    RASTERIZER_DISCARD: 0x8c89,
    VERTEX_ARRAY_BINDING: 0x85b5,
    MAX_VERTEX_OUTPUT_COMPONENTS: 0x9122,
    MAX_FRAGMENT_INPUT_COMPONENTS: 0x9125,
    MAX_SERVER_WAIT_TIMEOUT: 0x9111,
    MAX_ELEMENT_INDEX: 0x8d6b,
    RED: 0x1903,
    RGB8: 0x8051,
    RGBA8: 0x8058,
    RGB10_A2: 0x8059,
    TEXTURE_3D: 0x806f,
    TEXTURE_WRAP_R: 0x8072,
    TEXTURE_MIN_LOD: 0x813a,
    TEXTURE_MAX_LOD: 0x813b,
    TEXTURE_BASE_LEVEL: 0x813c,
    TEXTURE_MAX_LEVEL: 0x813d,
    TEXTURE_COMPARE_MODE: 0x884c,
    TEXTURE_COMPARE_FUNC: 0x884d,
    SRGB: 0x8c40,
    SRGB8: 0x8c41,
    SRGB8_ALPHA8: 0x8c43,
    COMPARE_REF_TO_TEXTURE: 0x884e,
    RGBA32F: 0x8814,
    RGB32F: 0x8815,
    RGBA16F: 0x881a,
    RGB16F: 0x881b,
    TEXTURE_2D_ARRAY: 0x8c1a,
    TEXTURE_BINDING_2D_ARRAY: 0x8c1d,
    R11F_G11F_B10F: 0x8c3a,
    RGB9_E5: 0x8c3d,
    RGBA32UI: 0x8d70,
    RGB32UI: 0x8d71,
    RGBA16UI: 0x8d76,
    RGB16UI: 0x8d77,
    RGBA8UI: 0x8d7c,
    RGB8UI: 0x8d7d,
    RGBA32I: 0x8d82,
    RGB32I: 0x8d83,
    RGBA16I: 0x8d88,
    RGB16I: 0x8d89,
    RGBA8I: 0x8d8e,
    RGB8I: 0x8d8f,
    RED_INTEGER: 0x8d94,
    RGB_INTEGER: 0x8d98,
    RGBA_INTEGER: 0x8d99,
    R8: 0x8229,
    RG8: 0x822b,
    R16F: 0x822d,
    R32F: 0x822e,
    RG16F: 0x822f,
    RG32F: 0x8230,
    R8I: 0x8231,
    R8UI: 0x8232,
    R16I: 0x8233,
    R16UI: 0x8234,
    R32I: 0x8235,
    R32UI: 0x8236,
    RG8I: 0x8237,
    RG8UI: 0x8238,
    RG16I: 0x8239,
    RG16UI: 0x823a,
    RG32I: 0x823b,
    RG32UI: 0x823c,
    R8_SNORM: 0x8f94,
    RG8_SNORM: 0x8f95,
    RGB8_SNORM: 0x8f96,
    RGBA8_SNORM: 0x8f97,
    RGB10_A2UI: 0x906f,
    TEXTURE_IMMUTABLE_FORMAT: 0x912f,
    TEXTURE_IMMUTABLE_LEVELS: 0x82df,
    UNSIGNED_INT_2_10_10_10_REV: 0x8368,
    UNSIGNED_INT_10F_11F_11F_REV: 0x8c3b,
    UNSIGNED_INT_5_9_9_9_REV: 0x8c3e,
    FLOAT_32_UNSIGNED_INT_24_8_REV: 0x8dad,
    UNSIGNED_INT_24_8: 0x84fa,
    HALF_FLOAT: 0x140b,
    RG: 0x8227,
    RG_INTEGER: 0x8228,
    INT_2_10_10_10_REV: 0x8d9f,
    CURRENT_QUERY: 0x8865,
    QUERY_RESULT: 0x8866,
    QUERY_RESULT_AVAILABLE: 0x8867,
    ANY_SAMPLES_PASSED: 0x8c2f,
    ANY_SAMPLES_PASSED_CONSERVATIVE: 0x8d6a,
    MAX_DRAW_BUFFERS: 0x8824,
    DRAW_BUFFER0: 0x8825,
    DRAW_BUFFER1: 0x8826,
    DRAW_BUFFER2: 0x8827,
    DRAW_BUFFER3: 0x8828,
    DRAW_BUFFER4: 0x8829,
    DRAW_BUFFER5: 0x882a,
    DRAW_BUFFER6: 0x882b,
    DRAW_BUFFER7: 0x882c,
    DRAW_BUFFER8: 0x882d,
    DRAW_BUFFER9: 0x882e,
    DRAW_BUFFER10: 0x882f,
    DRAW_BUFFER11: 0x8830,
    DRAW_BUFFER12: 0x8831,
    DRAW_BUFFER13: 0x8832,
    DRAW_BUFFER14: 0x8833,
    DRAW_BUFFER15: 0x8834,
    MAX_COLOR_ATTACHMENTS: 0x8cdf,
    COLOR_ATTACHMENT1: 0x8ce1,
    COLOR_ATTACHMENT2: 0x8ce2,
    COLOR_ATTACHMENT3: 0x8ce3,
    COLOR_ATTACHMENT4: 0x8ce4,
    COLOR_ATTACHMENT5: 0x8ce5,
    COLOR_ATTACHMENT6: 0x8ce6,
    COLOR_ATTACHMENT7: 0x8ce7,
    COLOR_ATTACHMENT8: 0x8ce8,
    COLOR_ATTACHMENT9: 0x8ce9,
    COLOR_ATTACHMENT10: 0x8cea,
    COLOR_ATTACHMENT11: 0x8ceb,
    COLOR_ATTACHMENT12: 0x8cec,
    COLOR_ATTACHMENT13: 0x8ced,
    COLOR_ATTACHMENT14: 0x8cee,
    COLOR_ATTACHMENT15: 0x8cef,
    SAMPLER_3D: 0x8b5f,
    SAMPLER_2D_SHADOW: 0x8b62,
    SAMPLER_2D_ARRAY: 0x8dc1,
    SAMPLER_2D_ARRAY_SHADOW: 0x8dc4,
    SAMPLER_CUBE_SHADOW: 0x8dc5,
    INT_SAMPLER_2D: 0x8dca,
    INT_SAMPLER_3D: 0x8dcb,
    INT_SAMPLER_CUBE: 0x8dcc,
    INT_SAMPLER_2D_ARRAY: 0x8dcf,
    UNSIGNED_INT_SAMPLER_2D: 0x8dd2,
    UNSIGNED_INT_SAMPLER_3D: 0x8dd3,
    UNSIGNED_INT_SAMPLER_CUBE: 0x8dd4,
    UNSIGNED_INT_SAMPLER_2D_ARRAY: 0x8dd7,
    MAX_SAMPLES: 0x8d57,
    SAMPLER_BINDING: 0x8919,
    PIXEL_PACK_BUFFER: 0x88eb,
    PIXEL_UNPACK_BUFFER: 0x88ec,
    PIXEL_PACK_BUFFER_BINDING: 0x88ed,
    PIXEL_UNPACK_BUFFER_BINDING: 0x88ef,
    COPY_READ_BUFFER: 0x8f36,
    COPY_WRITE_BUFFER: 0x8f37,
    COPY_READ_BUFFER_BINDING: 0x8f36,
    COPY_WRITE_BUFFER_BINDING: 0x8f37,
    FLOAT_MAT2x3: 0x8b65,
    FLOAT_MAT2x4: 0x8b66,
    FLOAT_MAT3x2: 0x8b67,
    FLOAT_MAT3x4: 0x8b68,
    FLOAT_MAT4x2: 0x8b69,
    FLOAT_MAT4x3: 0x8b6a,
    UNSIGNED_INT_VEC2: 0x8dc6,
    UNSIGNED_INT_VEC3: 0x8dc7,
    UNSIGNED_INT_VEC4: 0x8dc8,
    UNSIGNED_NORMALIZED: 0x8c17,
    SIGNED_NORMALIZED: 0x8f9c,
    VERTEX_ATTRIB_ARRAY_INTEGER: 0x88fd,
    VERTEX_ATTRIB_ARRAY_DIVISOR: 0x88fe,
    TRANSFORM_FEEDBACK_BUFFER_MODE: 0x8c7f,
    MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS: 0x8c80,
    TRANSFORM_FEEDBACK_VARYINGS: 0x8c83,
    TRANSFORM_FEEDBACK_BUFFER_START: 0x8c84,
    TRANSFORM_FEEDBACK_BUFFER_SIZE: 0x8c85,
    TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN: 0x8c88,
    MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS: 0x8c8a,
    MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS: 0x8c8b,
    INTERLEAVED_ATTRIBS: 0x8c8c,
    SEPARATE_ATTRIBS: 0x8c8d,
    TRANSFORM_FEEDBACK_BUFFER: 0x8c8e,
    TRANSFORM_FEEDBACK_BUFFER_BINDING: 0x8c8f,
    TRANSFORM_FEEDBACK: 0x8e22,
    TRANSFORM_FEEDBACK_PAUSED: 0x8e23,
    TRANSFORM_FEEDBACK_ACTIVE: 0x8e24,
    TRANSFORM_FEEDBACK_BINDING: 0x8e25,
    FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING: 0x8210,
    FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE: 0x8211,
    FRAMEBUFFER_ATTACHMENT_RED_SIZE: 0x8212,
    FRAMEBUFFER_ATTACHMENT_GREEN_SIZE: 0x8213,
    FRAMEBUFFER_ATTACHMENT_BLUE_SIZE: 0x8214,
    FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE: 0x8215,
    FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE: 0x8216,
    FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE: 0x8217,
    FRAMEBUFFER_DEFAULT: 0x8218,
    DEPTH24_STENCIL8: 0x88f0,
    DRAW_FRAMEBUFFER_BINDING: 0x8ca6,
    READ_FRAMEBUFFER_BINDING: 0x8caa,
    RENDERBUFFER_SAMPLES: 0x8cab,
    FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER: 0x8cd4,
    FRAMEBUFFER_INCOMPLETE_MULTISAMPLE: 0x8d56,
    UNIFORM_BUFFER: 0x8a11,
    UNIFORM_BUFFER_BINDING: 0x8a28,
    UNIFORM_BUFFER_START: 0x8a29,
    UNIFORM_BUFFER_SIZE: 0x8a2a,
    MAX_VERTEX_UNIFORM_BLOCKS: 0x8a2b,
    MAX_FRAGMENT_UNIFORM_BLOCKS: 0x8a2d,
    MAX_COMBINED_UNIFORM_BLOCKS: 0x8a2e,
    MAX_UNIFORM_BUFFER_BINDINGS: 0x8a2f,
    MAX_UNIFORM_BLOCK_SIZE: 0x8a30,
    MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS: 0x8a31,
    MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS: 0x8a33,
    UNIFORM_BUFFER_OFFSET_ALIGNMENT: 0x8a34,
    ACTIVE_UNIFORM_BLOCKS: 0x8a36,
    UNIFORM_TYPE: 0x8a37,
    UNIFORM_SIZE: 0x8a38,
    UNIFORM_BLOCK_INDEX: 0x8a3a,
    UNIFORM_OFFSET: 0x8a3b,
    UNIFORM_ARRAY_STRIDE: 0x8a3c,
    UNIFORM_MATRIX_STRIDE: 0x8a3d,
    UNIFORM_IS_ROW_MAJOR: 0x8a3e,
    UNIFORM_BLOCK_BINDING: 0x8a3f,
    UNIFORM_BLOCK_DATA_SIZE: 0x8a40,
    UNIFORM_BLOCK_ACTIVE_UNIFORMS: 0x8a42,
    UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES: 0x8a43,
    UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER: 0x8a44,
    UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER: 0x8a46,
    OBJECT_TYPE: 0x9112,
    SYNC_CONDITION: 0x9113,
    SYNC_STATUS: 0x9114,
    SYNC_FLAGS: 0x9115,
    SYNC_FENCE: 0x9116,
    SYNC_GPU_COMMANDS_COMPLETE: 0x9117,
    UNSIGNALED: 0x9118,
    SIGNALED: 0x9119,
    ALREADY_SIGNALED: 0x911a,
    TIMEOUT_EXPIRED: 0x911b,
    CONDITION_SATISFIED: 0x911c,
    WAIT_FAILED: 0x911d,
    SYNC_FLUSH_COMMANDS_BIT: 0x00000001,
    COLOR: 0x1800,
    DEPTH: 0x1801,
    STENCIL: 0x1802,
    MIN: 0x8007,
    MAX: 0x8008,
    DEPTH_COMPONENT24: 0x81a6,
    STREAM_READ: 0x88e1,
    STREAM_COPY: 0x88e2,
    STATIC_READ: 0x88e5,
    STATIC_COPY: 0x88e6,
    DYNAMIC_READ: 0x88e9,
    DYNAMIC_COPY: 0x88ea,
    DEPTH_COMPONENT32F: 0x8cac,
    DEPTH32F_STENCIL8: 0x8cad,
    INVALID_INDEX: 0xffffffff,
    TIMEOUT_IGNORED: -1,
    MAX_CLIENT_WAIT_TIMEOUT_WEBGL: 0x9247,
    VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE: 0x88fe,
    UNMASKED_VENDOR_WEBGL: 0x9245,
    UNMASKED_RENDERER_WEBGL: 0x9246,
    MAX_TEXTURE_MAX_ANISOTROPY_EXT: 0x84ff,
    TEXTURE_MAX_ANISOTROPY_EXT: 0x84fe,
    COMPRESSED_RGB_S3TC_DXT1_EXT: 0x83f0,
    COMPRESSED_RGBA_S3TC_DXT1_EXT: 0x83f1,
    COMPRESSED_RGBA_S3TC_DXT3_EXT: 0x83f2,
    COMPRESSED_RGBA_S3TC_DXT5_EXT: 0x83f3,
    COMPRESSED_R11_EAC: 0x9270,
    COMPRESSED_SIGNED_R11_EAC: 0x9271,
    COMPRESSED_RG11_EAC: 0x9272,
    COMPRESSED_SIGNED_RG11_EAC: 0x9273,
    COMPRESSED_RGB8_ETC2: 0x9274,
    COMPRESSED_RGBA8_ETC2_EAC: 0x9275,
    COMPRESSED_SRGB8_ETC2: 0x9276,
    COMPRESSED_SRGB8_ALPHA8_ETC2_EAC: 0x9277,
    COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2: 0x9278,
    COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2: 0x9279,
    COMPRESSED_RGB_PVRTC_4BPPV1_IMG: 0x8c00,
    COMPRESSED_RGBA_PVRTC_4BPPV1_IMG: 0x8c02,
    COMPRESSED_RGB_PVRTC_2BPPV1_IMG: 0x8c01,
    COMPRESSED_RGBA_PVRTC_2BPPV1_IMG: 0x8c03,
    COMPRESSED_RGB_ETC1_WEBGL: 0x8d64,
    COMPRESSED_RGB_ATC_WEBGL: 0x8c92,
    COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL: 0x8c92,
    COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL: 0x87ee,
    UNSIGNED_INT_24_8_WEBGL: 0x84fa,
    HALF_FLOAT_OES: 0x8d61,
    RGBA32F_EXT: 0x8814,
    RGB32F_EXT: 0x8815,
    FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE_EXT: 0x8211,
    UNSIGNED_NORMALIZED_EXT: 0x8c17,
    MIN_EXT: 0x8007,
    MAX_EXT: 0x8008,
    SRGB_EXT: 0x8c40,
    SRGB_ALPHA_EXT: 0x8c42,
    SRGB8_ALPHA8_EXT: 0x8c43,
    FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING_EXT: 0x8210,
    FRAGMENT_SHADER_DERIVATIVE_HINT_OES: 0x8b8b,
    COLOR_ATTACHMENT0_WEBGL: 0x8ce0,
    COLOR_ATTACHMENT1_WEBGL: 0x8ce1,
    COLOR_ATTACHMENT2_WEBGL: 0x8ce2,
    COLOR_ATTACHMENT3_WEBGL: 0x8ce3,
    COLOR_ATTACHMENT4_WEBGL: 0x8ce4,
    COLOR_ATTACHMENT5_WEBGL: 0x8ce5,
    COLOR_ATTACHMENT6_WEBGL: 0x8ce6,
    COLOR_ATTACHMENT7_WEBGL: 0x8ce7,
    COLOR_ATTACHMENT8_WEBGL: 0x8ce8,
    COLOR_ATTACHMENT9_WEBGL: 0x8ce9,
    COLOR_ATTACHMENT10_WEBGL: 0x8cea,
    COLOR_ATTACHMENT11_WEBGL: 0x8ceb,
    COLOR_ATTACHMENT12_WEBGL: 0x8cec,
    COLOR_ATTACHMENT13_WEBGL: 0x8ced,
    COLOR_ATTACHMENT14_WEBGL: 0x8cee,
    COLOR_ATTACHMENT15_WEBGL: 0x8cef,
    DRAW_BUFFER0_WEBGL: 0x8825,
    DRAW_BUFFER1_WEBGL: 0x8826,
    DRAW_BUFFER2_WEBGL: 0x8827,
    DRAW_BUFFER3_WEBGL: 0x8828,
    DRAW_BUFFER4_WEBGL: 0x8829,
    DRAW_BUFFER5_WEBGL: 0x882a,
    DRAW_BUFFER6_WEBGL: 0x882b,
    DRAW_BUFFER7_WEBGL: 0x882c,
    DRAW_BUFFER8_WEBGL: 0x882d,
    DRAW_BUFFER9_WEBGL: 0x882e,
    DRAW_BUFFER10_WEBGL: 0x882f,
    DRAW_BUFFER11_WEBGL: 0x8830,
    DRAW_BUFFER12_WEBGL: 0x8831,
    DRAW_BUFFER13_WEBGL: 0x8832,
    DRAW_BUFFER14_WEBGL: 0x8833,
    DRAW_BUFFER15_WEBGL: 0x8834,
    MAX_COLOR_ATTACHMENTS_WEBGL: 0x8cdf,
    MAX_DRAW_BUFFERS_WEBGL: 0x8824,
    VERTEX_ARRAY_BINDING_OES: 0x85b5,
    QUERY_COUNTER_BITS_EXT: 0x8864,
    CURRENT_QUERY_EXT: 0x8865,
    QUERY_RESULT_EXT: 0x8866,
    QUERY_RESULT_AVAILABLE_EXT: 0x8867,
    TIME_ELAPSED_EXT: 0x88bf,
    TIMESTAMP_EXT: 0x8e28,
    GPU_DISJOINT_EXT: 0x8fbb
};

});

parcelRegister("jT2Ca", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/* eslint-disable camelcase */ var $e7a52e95fe0ce428$var$INITIAL_STATE = {
    outlineEnabled: false,
    outlineRenderShadowmap: false,
    outlineShadowmap: null
};
function $e7a52e95fe0ce428$var$getUniforms() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e7a52e95fe0ce428$var$INITIAL_STATE, outlineEnabled = _ref.outlineEnabled, outlineRenderShadowmap = _ref.outlineRenderShadowmap, outlineShadowmap = _ref.outlineShadowmap;
    var uniforms = {};
    if (outlineEnabled !== undefined) // ? 1.0 : 0.0;
    uniforms.outline_uEnabled = outlineEnabled;
    if (outlineRenderShadowmap !== undefined) // ? 1.0 : 0.0;
    uniforms.outline_uRenderOutlines = outlineRenderShadowmap;
    if (outlineShadowmap !== undefined) uniforms.outline_uShadowmap = outlineShadowmap;
    return uniforms;
}
var $e7a52e95fe0ce428$var$vs = "attribute float instanceZLevel;\nvarying float outline_vzLevel;\nvarying vec4 outline_vPosition;\n\n// Set the z level for the outline shadowmap rendering\nvoid outline_setZLevel(float zLevel) {\n  outline_vzLevel = zLevel;\n}\n\n// Store an adjusted position for texture2DProj\nvoid outline_setUV(vec4 position) {\n  // mat4(\n  //   0.5, 0.0, 0.0, 0.0,\n  //   0.0, 0.5, 0.0, 0.0,\n  //   0.0, 0.0, 0.5, 0.0,\n  //   0.5, 0.5, 0.5, 1.0\n  // ) * position;\n  outline_vPosition = vec4(position.xyz * 0.5 + position.w * 0.5, position.w);\n}\n";
var $e7a52e95fe0ce428$var$fs = "uniform bool outline_uEnabled;\nuniform bool outline_uRenderOutlines;\nuniform sampler2D outline_uShadowmap;\n\nvarying float outline_vzLevel;\n// varying vec2 outline_vUV;\nvarying vec4 outline_vPosition;\n\nconst float OUTLINE_Z_LEVEL_ERROR = 0.01;\n\n// Return a darker color in shadowmap\nvec4 outline_filterShadowColor(vec4 color) {\n  return vec4(outline_vzLevel / 255., outline_vzLevel / 255., outline_vzLevel / 255., 1.);\n}\n\n// Return a darker color if in shadowmap\nvec4 outline_filterDarkenColor(vec4 color) {\n  if (outline_uEnabled) {\n    float maxZLevel;\n    if (outline_vPosition.q > 0.0) {\n      maxZLevel = texture2DProj(outline_uShadowmap, outline_vPosition).r * 255.;\n    } else {\n      discard;\n    }\n    if (maxZLevel < outline_vzLevel + OUTLINE_Z_LEVEL_ERROR) {\n      vec4(color.rgb * 0.5, color.a);\n    } else {\n      discard;\n    }\n  }\n  return color;\n}\n\n// if enabled and rendering outlines - Render depth to shadowmap\n// if enabled and rendering colors - Return a darker color if in shadowmap\n// if disabled, just return color\nvec4 outline_filterColor(vec4 color) {\n  if (outline_uEnabled) {\n    return outline_uRenderOutlines ?\n      outline_filterShadowColor(color) :\n      outline_filterDarkenColor(color);\n  }\n  return color;\n}\n";
var $e7a52e95fe0ce428$var$_default = {
    name: "outline",
    vs: $e7a52e95fe0ce428$var$vs,
    fs: $e7a52e95fe0ce428$var$fs,
    getUniforms: $e7a52e95fe0ce428$var$getUniforms
};
module.exports["default"] = $e7a52e95fe0ce428$var$_default;

});


parcelRegister("ctByJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $coXLq = parcelRequire("coXLq");
var $7gQQK = parcelRequire("7gQQK");

var $cYQ5y = parcelRequire("cYQ5y");

var $cNooP = parcelRequire("cNooP");

var $915553ed5370bf6e$var$_pathOutlineLayer = $915553ed5370bf6e$var$_interopRequireDefault((parcelRequire("hwgS8")));

var $915553ed5370bf6e$var$_arrow2dGeometry = $915553ed5370bf6e$var$_interopRequireDefault((parcelRequire("kdbZI")));

var $915553ed5370bf6e$var$_createPathMarkers = $915553ed5370bf6e$var$_interopRequireDefault((parcelRequire("ckc25")));

var $9HybI = parcelRequire("9HybI");
function $915553ed5370bf6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $915553ed5370bf6e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $915553ed5370bf6e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $915553ed5370bf6e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $915553ed5370bf6e$var$_typeof(obj);
}
function $915553ed5370bf6e$var$_slicedToArray(arr, i) {
    return $915553ed5370bf6e$var$_arrayWithHoles(arr) || $915553ed5370bf6e$var$_iterableToArrayLimit(arr, i) || $915553ed5370bf6e$var$_unsupportedIterableToArray(arr, i) || $915553ed5370bf6e$var$_nonIterableRest();
}
function $915553ed5370bf6e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $915553ed5370bf6e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $915553ed5370bf6e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $915553ed5370bf6e$var$_arrayLikeToArray(o, minLen);
}
function $915553ed5370bf6e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $915553ed5370bf6e$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $915553ed5370bf6e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $915553ed5370bf6e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $915553ed5370bf6e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $915553ed5370bf6e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $915553ed5370bf6e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $915553ed5370bf6e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $915553ed5370bf6e$var$_createSuper(Derived) {
    return function() {
        var Super = $915553ed5370bf6e$var$_getPrototypeOf(Derived), result;
        if ($915553ed5370bf6e$var$_isNativeReflectConstruct()) {
            var NewTarget = $915553ed5370bf6e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $915553ed5370bf6e$var$_possibleConstructorReturn(this, result);
    };
}
function $915553ed5370bf6e$var$_possibleConstructorReturn(self, call) {
    if (call && ($915553ed5370bf6e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $915553ed5370bf6e$var$_assertThisInitialized(self);
}
function $915553ed5370bf6e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $915553ed5370bf6e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $915553ed5370bf6e$var$_getPrototypeOf(o) {
    $915553ed5370bf6e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $915553ed5370bf6e$var$_getPrototypeOf(o);
}
function $915553ed5370bf6e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $915553ed5370bf6e$var$_setPrototypeOf(subClass, superClass);
}
function $915553ed5370bf6e$var$_setPrototypeOf(o, p) {
    $915553ed5370bf6e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $915553ed5370bf6e$var$_setPrototypeOf(o, p);
}
function $915553ed5370bf6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $915553ed5370bf6e$var$DISTANCE_FOR_MULTI_ARROWS = 0.1;
var $915553ed5370bf6e$var$ARROW_HEAD_SIZE = 0.2;
var $915553ed5370bf6e$var$ARROW_TAIL_WIDTH = 0.05; // const ARROW_CENTER_ADJUST = -0.8;
var $915553ed5370bf6e$var$DEFAULT_MARKER_LAYER = $cNooP.default;
var $915553ed5370bf6e$var$DEFAULT_MARKER_LAYER_PROPS = {
    mesh: new $915553ed5370bf6e$var$_arrow2dGeometry["default"]({
        headSize: $915553ed5370bf6e$var$ARROW_HEAD_SIZE,
        tailWidth: $915553ed5370bf6e$var$ARROW_TAIL_WIDTH
    })
};
var $915553ed5370bf6e$var$defaultProps = Object.assign({}, $915553ed5370bf6e$var$_pathOutlineLayer["default"].defaultProps, {
    MarkerLayer: $915553ed5370bf6e$var$DEFAULT_MARKER_LAYER,
    markerLayerProps: $915553ed5370bf6e$var$DEFAULT_MARKER_LAYER_PROPS,
    sizeScale: 100,
    fp64: false,
    highlightIndex: -1,
    highlightPoint: null,
    getPath: function getPath(x) {
        return x.path;
    },
    getColor: function getColor(x) {
        return x.color;
    },
    getMarkerColor: function getMarkerColor(x) {
        return [
            0,
            0,
            0,
            255
        ];
    },
    getDirection: function getDirection(x) {
        return x.direction;
    },
    getMarkerPercentages: function getMarkerPercentages(object, _ref) {
        var lineLength = _ref.lineLength;
        return lineLength > $915553ed5370bf6e$var$DISTANCE_FOR_MULTI_ARROWS ? [
            0.25,
            0.5,
            0.75
        ] : [
            0.5
        ];
    }
});
var $915553ed5370bf6e$var$PathMarkerLayer = /*#__PURE__*/ function(_CompositeLayer) {
    $915553ed5370bf6e$var$_inherits(PathMarkerLayer, _CompositeLayer);
    var _super = $915553ed5370bf6e$var$_createSuper(PathMarkerLayer);
    function PathMarkerLayer() {
        $915553ed5370bf6e$var$_classCallCheck(this, PathMarkerLayer);
        return _super.apply(this, arguments);
    }
    $915553ed5370bf6e$var$_createClass(PathMarkerLayer, [
        {
            key: "initializeState",
            value: function initializeState() {
                this.state = {
                    markers: [],
                    mesh: new $915553ed5370bf6e$var$_arrow2dGeometry["default"]({
                        headSize: $915553ed5370bf6e$var$ARROW_HEAD_SIZE,
                        tailWidth: $915553ed5370bf6e$var$ARROW_TAIL_WIDTH
                    }),
                    closestPoint: null
                };
            } // @ts-ignore
        },
        {
            key: "projectFlat",
            value: function projectFlat(xyz, viewport, coordinateSystem, coordinateOrigin) {
                if (coordinateSystem === $7gQQK.COORDINATE_SYSTEM.METER_OFFSETS) {
                    var _viewport$metersToLng = viewport.metersToLngLatDelta(xyz), _viewport$metersToLng2 = $915553ed5370bf6e$var$_slicedToArray(_viewport$metersToLng, 2), dx = _viewport$metersToLng2[0], dy = _viewport$metersToLng2[1];
                    var _coordinateOrigin = $915553ed5370bf6e$var$_slicedToArray(coordinateOrigin, 2), _x = _coordinateOrigin[0], y = _coordinateOrigin[1];
                    return viewport.projectFlat([
                        _x + dx,
                        dy + y
                    ]);
                } else if (coordinateSystem === $7gQQK.COORDINATE_SYSTEM.LNGLAT_OFFSETS) {
                    var _xyz = $915553ed5370bf6e$var$_slicedToArray(xyz, 2), _dx = _xyz[0], _dy = _xyz[1];
                    var _coordinateOrigin2 = $915553ed5370bf6e$var$_slicedToArray(coordinateOrigin, 2), _x2 = _coordinateOrigin2[0], _y = _coordinateOrigin2[1];
                    return viewport.projectFlat([
                        _x2 + _dx,
                        _dy + _y
                    ]);
                }
                return viewport.projectFlat(xyz);
            }
        },
        {
            key: "updateState",
            value: function updateState(_ref2) {
                var _this = this;
                var props = _ref2.props, oldProps = _ref2.oldProps, changeFlags = _ref2.changeFlags;
                if (changeFlags.dataChanged || changeFlags.updateTriggersChanged) {
                    var _this$props = this.props, data = _this$props.data, getPath = _this$props.getPath, getDirection = _this$props.getDirection, getMarkerColor = _this$props.getMarkerColor, getMarkerPercentages = _this$props.getMarkerPercentages, coordinateSystem = _this$props.coordinateSystem, coordinateOrigin = _this$props.coordinateOrigin; // @ts-ignore
                    var viewport = this.context.viewport;
                    var projectFlat = function projectFlat(o) {
                        return _this.projectFlat(o, viewport, coordinateSystem, coordinateOrigin);
                    };
                    this.state.markers = (0, $915553ed5370bf6e$var$_createPathMarkers["default"])({
                        data: data,
                        getPath: getPath,
                        getDirection: getDirection,
                        getColor: getMarkerColor,
                        getMarkerPercentages: getMarkerPercentages,
                        projectFlat: projectFlat
                    });
                    this._recalculateClosestPoint();
                }
                if (changeFlags.propsChanged) {
                    if (props.point !== oldProps.point) this._recalculateClosestPoint();
                }
            }
        },
        {
            key: "_recalculateClosestPoint",
            value: function _recalculateClosestPoint() {
                var _this$props2 = this.props, highlightPoint = _this$props2.highlightPoint, highlightIndex = _this$props2.highlightIndex;
                if (highlightPoint && highlightIndex >= 0) {
                    var object = this.props.data[highlightIndex];
                    var points = this.props.getPath(object);
                    var _getClosestPointOnPol = (0, $9HybI.getClosestPointOnPolyline)({
                        points: points,
                        p: highlightPoint
                    }), point = _getClosestPointOnPol.point;
                    this.state.closestPoints = [
                        {
                            position: point
                        }
                    ];
                } else this.state.closestPoints = [];
            }
        },
        {
            key: "getPickingInfo",
            value: function getPickingInfo(_ref3) {
                var info = _ref3.info;
                return Object.assign(info, {
                    // override object with picked feature
                    object: info.object && info.object.path || info.object
                });
            }
        },
        {
            key: "renderLayers",
            value: function renderLayers() {
                return [
                    new $915553ed5370bf6e$var$_pathOutlineLayer["default"](this.props, this.getSubLayerProps({
                        id: "paths",
                        // Note: data has to be passed explicitly like this to avoid being empty
                        data: this.props.data
                    })),
                    new this.props.MarkerLayer(this.getSubLayerProps(Object.assign({}, this.props.markerLayerProps, {
                        id: "markers",
                        data: this.state.markers,
                        getOrientation: function getOrientation(x) {
                            return [
                                0,
                                -x.angle,
                                0
                            ];
                        },
                        getColor: function getColor(x) {
                            return x.color;
                        },
                        sizeScale: this.props.sizeScale,
                        fp64: this.props.fp64,
                        pickable: false,
                        parameters: {
                            blend: false,
                            depthTest: false
                        }
                    }))),
                    this.state.closestPoints && new $cYQ5y.default({
                        id: "".concat(this.props.id, "-highlight"),
                        data: this.state.closestPoints,
                        // @ts-ignore
                        fp64: this.props.fp64
                    })
                ];
            }
        }
    ]);
    return PathMarkerLayer;
}($coXLq.default);
module.exports["default"] = $915553ed5370bf6e$var$PathMarkerLayer;
$915553ed5370bf6e$var$_defineProperty($915553ed5370bf6e$var$PathMarkerLayer, "layerName", "PathMarkerLayer");
$915553ed5370bf6e$var$_defineProperty($915553ed5370bf6e$var$PathMarkerLayer, "defaultProps", $915553ed5370bf6e$var$defaultProps);

});
parcelRegister("cNooP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $950cfce1f41765ca$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $hAx0Q = parcelRequire("hAx0Q");

var $i46md = parcelRequire("i46md");
var $4VQgq = parcelRequire("4VQgq");
var $b8HWT = parcelRequire("b8HWT");
var $7UxuR = parcelRequire("7UxuR");
var $jRSMz = parcelRequire("jRSMz");

var $cxTxU = parcelRequire("cxTxU");parcelRequire("73UuK");
var $8HKWo = parcelRequire("8HKWo");
var $b2F4S = parcelRequire("b2F4S");
var $7lUAH = parcelRequire("7lUAH");

var $68aPy = parcelRequire("68aPy");
var $tIWfJ = parcelRequire("tIWfJ");

var $2mgFj = parcelRequire("2mgFj");

var $lU3dn = parcelRequire("lU3dn");

var $9aGRS = parcelRequire("9aGRS");

var $ksLIL = parcelRequire("ksLIL");
function $950cfce1f41765ca$var$validateGeometryAttributes(attributes, useMeshColors) {
    const hasColorAttribute = attributes.COLOR_0 || attributes.colors;
    const useColorAttribute = hasColorAttribute && useMeshColors;
    if (!useColorAttribute) attributes.colors = {
        constant: true,
        value: new Float32Array([
            1,
            1,
            1
        ])
    };
    (0, $4VQgq.default).assert(attributes.positions || attributes.POSITION, 'no "postions" or "POSITION" attribute in mesh');
}
function $950cfce1f41765ca$var$getGeometry(data, useMeshColors) {
    if (data.attributes) {
        $950cfce1f41765ca$var$validateGeometryAttributes(data.attributes, useMeshColors);
        if (data instanceof (0, $cxTxU.default)) return data;
        else return new (0, $cxTxU.default)(data);
    } else if (data.positions || data.POSITION) {
        $950cfce1f41765ca$var$validateGeometryAttributes(data, useMeshColors);
        return new (0, $cxTxU.default)({
            attributes: data
        });
    }
    throw Error("Invalid mesh");
}
const $950cfce1f41765ca$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const $950cfce1f41765ca$var$defaultProps = {
    mesh: {
        type: "object",
        value: null,
        async: true
    },
    texture: {
        type: "image",
        value: null,
        async: true
    },
    sizeScale: {
        type: "number",
        value: 1,
        min: 0
    },
    _useMeshColors: {
        type: "boolean",
        value: false
    },
    _instanced: true,
    wireframe: false,
    material: true,
    getPosition: {
        type: "accessor",
        value: (x)=>x.position
    },
    getColor: {
        type: "accessor",
        value: $950cfce1f41765ca$var$DEFAULT_COLOR
    },
    getOrientation: {
        type: "accessor",
        value: [
            0,
            0,
            0
        ]
    },
    getScale: {
        type: "accessor",
        value: [
            1,
            1,
            1
        ]
    },
    getTranslation: {
        type: "accessor",
        value: [
            0,
            0,
            0
        ]
    },
    getTransformMatrix: {
        type: "accessor",
        value: []
    },
    textureParameters: {
        type: "object",
        ignore: true
    }
};
class $950cfce1f41765ca$export$2e2bcd8739ae039 extends (0, $i46md.default) {
    getShaders() {
        const transpileToGLSL100 = !(0, $8HKWo.isWebGL2)(this.context.gl);
        const defines = {};
        if ((0, $tIWfJ.hasFeature)(this.context.gl, (0, $68aPy.FEATURES).GLSL_DERIVATIVES)) defines.DERIVATIVES_AVAILABLE = 1;
        return super.getShaders({
            vs: $lU3dn.default,
            fs: $9aGRS.default,
            modules: [
                (0, $jRSMz.default),
                (0, $b8HWT.phongLighting),
                (0, $7UxuR.default)
            ],
            transpileToGLSL100: transpileToGLSL100,
            defines: defines
        });
    }
    getBounds() {
        var _mesh$header;
        if (this.props._instanced) return super.getBounds();
        let result = this.state.positionBounds;
        if (result) return result;
        const { mesh: mesh } = this.props;
        if (!mesh) return null;
        result = (_mesh$header = mesh.header) === null || _mesh$header === void 0 ? void 0 : _mesh$header.boundingBox;
        if (!result) {
            const { attributes: attributes } = $950cfce1f41765ca$var$getGeometry(mesh, this.props._useMeshColors);
            attributes.POSITION = attributes.POSITION || attributes.positions;
            result = (0, $ksLIL.getMeshBoundingBox)(attributes);
        }
        this.state.positionBounds = result;
        return result;
    }
    initializeState() {
        const attributeManager = this.getAttributeManager();
        attributeManager.addInstanced({
            instancePositions: {
                transition: true,
                type: 5130,
                fp64: this.use64bitPositions(),
                size: 3,
                accessor: "getPosition"
            },
            instanceColors: {
                type: 5121,
                transition: true,
                size: this.props.colorFormat.length,
                normalized: true,
                accessor: "getColor",
                defaultValue: [
                    0,
                    0,
                    0,
                    255
                ]
            },
            instanceModelMatrix: (0, $2mgFj.MATRIX_ATTRIBUTES)
        });
        this.setState({
            emptyTexture: new (0, $7lUAH.default)(this.context.gl, {
                data: new Uint8Array(4),
                width: 1,
                height: 1
            })
        });
    }
    updateState(params) {
        super.updateState(params);
        const { props: props, oldProps: oldProps, changeFlags: changeFlags } = params;
        if (props.mesh !== oldProps.mesh || changeFlags.extensionsChanged) {
            var _this$state$model;
            this.state.positionBounds = null;
            (_this$state$model = this.state.model) === null || _this$state$model === void 0 || _this$state$model.delete();
            if (props.mesh) {
                this.state.model = this.getModel(props.mesh);
                const attributes = props.mesh.attributes || props.mesh;
                this.setState({
                    hasNormals: Boolean(attributes.NORMAL || attributes.normals)
                });
            }
            this.getAttributeManager().invalidateAll();
        }
        if (props.texture !== oldProps.texture) this.setTexture(props.texture);
        if (this.state.model) this.state.model.setDrawMode(this.props.wireframe ? 3 : 4);
    }
    finalizeState(context) {
        super.finalizeState(context);
        this.state.emptyTexture.delete();
    }
    draw({ uniforms: uniforms }) {
        if (!this.state.model) return;
        const { viewport: viewport } = this.context;
        const { sizeScale: sizeScale, coordinateSystem: coordinateSystem, _instanced: _instanced } = this.props;
        this.state.model.setUniforms(uniforms).setUniforms({
            sizeScale: sizeScale,
            composeModelMatrix: !_instanced || (0, $2mgFj.shouldComposeModelMatrix)(viewport, coordinateSystem),
            flatShading: !this.state.hasNormals
        }).draw();
    }
    get isLoaded() {
        var _this$state;
        return ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.model) && super.isLoaded;
    }
    getModel(mesh) {
        const model = new (0, $b2F4S.default)(this.context.gl, (0, $edHbI._)((0, $2QP2i._)({}, this.getShaders()), {
            id: this.props.id,
            geometry: $950cfce1f41765ca$var$getGeometry(mesh, this.props._useMeshColors),
            isInstanced: true
        }));
        const { texture: texture } = this.props;
        const { emptyTexture: emptyTexture } = this.state;
        model.setUniforms({
            sampler: texture || emptyTexture,
            hasTexture: Boolean(texture)
        });
        return model;
    }
    setTexture(texture) {
        const { emptyTexture: emptyTexture, model: model } = this.state;
        if (model) model.setUniforms({
            sampler: texture || emptyTexture,
            hasTexture: Boolean(texture)
        });
    }
    constructor(...args){
        super(...args);
        (0, $hAx0Q.default)(this, "state", void 0);
    }
}
(0, $hAx0Q.default)($950cfce1f41765ca$export$2e2bcd8739ae039, "defaultProps", $950cfce1f41765ca$var$defaultProps);
(0, $hAx0Q.default)($950cfce1f41765ca$export$2e2bcd8739ae039, "layerName", "SimpleMeshLayer");

});
parcelRegister("hAx0Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccdf6816ede45a05$export$2e2bcd8739ae039; });
function $ccdf6816ede45a05$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("2mgFj", function(module, exports) {

$parcel$export(module.exports, "MATRIX_ATTRIBUTES", function () { return $1b7a903a353ecd86$export$71da704eccf80df1; });
$parcel$export(module.exports, "shouldComposeModelMatrix", function () { return $1b7a903a353ecd86$export$920b8d6af485174f; });

var $7gQQK = parcelRequire("7gQQK");
var $abpME = parcelRequire("abpME");
const $1b7a903a353ecd86$var$RADIAN_PER_DEGREE = Math.PI / 180;
const $1b7a903a353ecd86$var$modelMatrix = new Float32Array(16);
const $1b7a903a353ecd86$var$valueArray = new Float32Array(12);
function $1b7a903a353ecd86$var$calculateTransformMatrix(targetMatrix, orientation, scale) {
    const pitch = orientation[0] * $1b7a903a353ecd86$var$RADIAN_PER_DEGREE;
    const yaw = orientation[1] * $1b7a903a353ecd86$var$RADIAN_PER_DEGREE;
    const roll = orientation[2] * $1b7a903a353ecd86$var$RADIAN_PER_DEGREE;
    const sr = Math.sin(roll);
    const sp = Math.sin(pitch);
    const sw = Math.sin(yaw);
    const cr = Math.cos(roll);
    const cp = Math.cos(pitch);
    const cw = Math.cos(yaw);
    const scx = scale[0];
    const scy = scale[1];
    const scz = scale[2];
    targetMatrix[0] = scx * cw * cp;
    targetMatrix[1] = scx * sw * cp;
    targetMatrix[2] = scx * -sp;
    targetMatrix[3] = scy * (-sw * cr + cw * sp * sr);
    targetMatrix[4] = scy * (cw * cr + sw * sp * sr);
    targetMatrix[5] = scy * cp * sr;
    targetMatrix[6] = scz * (sw * sr + cw * sp * cr);
    targetMatrix[7] = scz * (-cw * sr + sw * sp * cr);
    targetMatrix[8] = scz * cp * cr;
}
function $1b7a903a353ecd86$var$getExtendedMat3FromMat4(mat4) {
    mat4[0] = mat4[0];
    mat4[1] = mat4[1];
    mat4[2] = mat4[2];
    mat4[3] = mat4[4];
    mat4[4] = mat4[5];
    mat4[5] = mat4[6];
    mat4[6] = mat4[8];
    mat4[7] = mat4[9];
    mat4[8] = mat4[10];
    mat4[9] = mat4[12];
    mat4[10] = mat4[13];
    mat4[11] = mat4[14];
    return mat4.subarray(0, 12);
}
const $1b7a903a353ecd86$export$71da704eccf80df1 = {
    size: 12,
    accessor: [
        "getOrientation",
        "getScale",
        "getTranslation",
        "getTransformMatrix"
    ],
    shaderAttributes: {
        instanceModelMatrix__LOCATION_0: {
            size: 3,
            elementOffset: 0
        },
        instanceModelMatrix__LOCATION_1: {
            size: 3,
            elementOffset: 3
        },
        instanceModelMatrix__LOCATION_2: {
            size: 3,
            elementOffset: 6
        },
        instanceTranslation: {
            size: 3,
            elementOffset: 9
        }
    },
    update (attribute, { startRow: startRow, endRow: endRow }) {
        const { data: data, getOrientation: getOrientation, getScale: getScale, getTranslation: getTranslation, getTransformMatrix: getTransformMatrix } = this.props;
        const arrayMatrix = Array.isArray(getTransformMatrix);
        const constantMatrix = arrayMatrix && getTransformMatrix.length === 16;
        const constantScale = Array.isArray(getScale);
        const constantOrientation = Array.isArray(getOrientation);
        const constantTranslation = Array.isArray(getTranslation);
        const hasMatrix = constantMatrix || !arrayMatrix && Boolean(getTransformMatrix(data[0]));
        if (hasMatrix) attribute.constant = constantMatrix;
        else attribute.constant = constantOrientation && constantScale && constantTranslation;
        const instanceModelMatrixData = attribute.value;
        if (attribute.constant) {
            let matrix;
            if (hasMatrix) {
                $1b7a903a353ecd86$var$modelMatrix.set(getTransformMatrix);
                matrix = $1b7a903a353ecd86$var$getExtendedMat3FromMat4($1b7a903a353ecd86$var$modelMatrix);
            } else {
                matrix = $1b7a903a353ecd86$var$valueArray;
                const orientation = getOrientation;
                const scale = getScale;
                $1b7a903a353ecd86$var$calculateTransformMatrix(matrix, orientation, scale);
                matrix.set(getTranslation, 9);
            }
            attribute.value = new Float32Array(matrix);
        } else {
            let i = startRow * attribute.size;
            const { iterable: iterable, objectInfo: objectInfo } = (0, $abpME.createIterable)(data, startRow, endRow);
            for (const object of iterable){
                objectInfo.index++;
                let matrix;
                if (hasMatrix) {
                    $1b7a903a353ecd86$var$modelMatrix.set(constantMatrix ? getTransformMatrix : getTransformMatrix(object, objectInfo));
                    matrix = $1b7a903a353ecd86$var$getExtendedMat3FromMat4($1b7a903a353ecd86$var$modelMatrix);
                } else {
                    matrix = $1b7a903a353ecd86$var$valueArray;
                    const orientation = constantOrientation ? getOrientation : getOrientation(object, objectInfo);
                    const scale = constantScale ? getScale : getScale(object, objectInfo);
                    $1b7a903a353ecd86$var$calculateTransformMatrix(matrix, orientation, scale);
                    matrix.set(constantTranslation ? getTranslation : getTranslation(object, objectInfo), 9);
                }
                instanceModelMatrixData[i++] = matrix[0];
                instanceModelMatrixData[i++] = matrix[1];
                instanceModelMatrixData[i++] = matrix[2];
                instanceModelMatrixData[i++] = matrix[3];
                instanceModelMatrixData[i++] = matrix[4];
                instanceModelMatrixData[i++] = matrix[5];
                instanceModelMatrixData[i++] = matrix[6];
                instanceModelMatrixData[i++] = matrix[7];
                instanceModelMatrixData[i++] = matrix[8];
                instanceModelMatrixData[i++] = matrix[9];
                instanceModelMatrixData[i++] = matrix[10];
                instanceModelMatrixData[i++] = matrix[11];
            }
        }
    }
};
function $1b7a903a353ecd86$export$920b8d6af485174f(viewport, coordinateSystem) {
    return coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).CARTESIAN || coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).METER_OFFSETS || coordinateSystem === (0, $7gQQK.COORDINATE_SYSTEM).DEFAULT && !viewport.isGeospatial;
}

});

parcelRegister("lU3dn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff21524f774927b7$export$2e2bcd8739ae039; });
var $ff21524f774927b7$export$2e2bcd8739ae039 = "#version 300 es\n#define SHADER_NAME simple-mesh-layer-vs\nuniform float sizeScale;\nuniform bool composeModelMatrix;\nin vec3 positions;\nin vec3 normals;\nin vec3 colors;\nin vec2 texCoords;\nin vec3 instancePositions;\nin vec3 instancePositions64Low;\nin vec4 instanceColors;\nin vec3 instancePickingColors;\nin mat3 instanceModelMatrix;\nin vec3 instanceTranslation;\nout vec2 vTexCoord;\nout vec3 cameraPosition;\nout vec3 normals_commonspace;\nout vec4 position_commonspace;\nout vec4 vColor;\n\nvoid main(void) {\n  geometry.worldPosition = instancePositions;\n  geometry.uv = texCoords;\n  geometry.pickingColor = instancePickingColors;\n\n  vTexCoord = texCoords;\n  cameraPosition = project_uCameraPosition;\n  vColor = vec4(colors * instanceColors.rgb, instanceColors.a);\n\n  vec3 pos = (instanceModelMatrix * positions) * sizeScale + instanceTranslation;\n\n  if (composeModelMatrix) {\n    DECKGL_FILTER_SIZE(pos, geometry);\n    normals_commonspace = project_normal(instanceModelMatrix * normals);\n    geometry.worldPosition += pos;\n    gl_Position = project_position_to_clipspace(pos + instancePositions, instancePositions64Low, vec3(0.0), position_commonspace);\n    geometry.position = position_commonspace;\n  }\n  else {\n    pos = project_size(pos);\n    DECKGL_FILTER_SIZE(pos, geometry);\n    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, pos, position_commonspace);\n    geometry.position = position_commonspace;\n    normals_commonspace = project_normal(instanceModelMatrix * normals);\n  }\n\n  geometry.normal = normals_commonspace;\n  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);\n\n  DECKGL_FILTER_COLOR(vColor, geometry);\n}\n";

});

parcelRegister("9aGRS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ad64ce654e56711$export$2e2bcd8739ae039; });
var $6ad64ce654e56711$export$2e2bcd8739ae039 = "#version 300 es\n#define SHADER_NAME simple-mesh-layer-fs\n\nprecision highp float;\n\nuniform bool hasTexture;\nuniform sampler2D sampler;\nuniform bool flatShading;\nuniform float opacity;\n\nin vec2 vTexCoord;\nin vec3 cameraPosition;\nin vec3 normals_commonspace;\nin vec4 position_commonspace;\nin vec4 vColor;\n\nout vec4 fragColor;\n\nvoid main(void) {\n  geometry.uv = vTexCoord;\n\n  vec3 normal;\n  if (flatShading) {\n#ifdef DERIVATIVES_AVAILABLE\n    normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));\n#else\n    normal = vec3(0.0, 0.0, 1.0);\n#endif\n  } else {\n    normal = normals_commonspace;\n  }\n\n  vec4 color = hasTexture ? texture(sampler, vTexCoord) : vColor;\n  DECKGL_FILTER_COLOR(color, geometry);\n\n  vec3 lightColor = lighting_getLightColor(color.rgb, cameraPosition, position_commonspace.xyz, normal);\n  fragColor = vec4(lightColor, color.a * opacity);\n}\n";

});

parcelRegister("ksLIL", function(module, exports) {

$parcel$export(module.exports, "getMeshBoundingBox", function () { return $ee5b7095d0db1e4f$export$190511c0a5f57f36; });
function $ee5b7095d0db1e4f$export$2c3cef6f832db216(attributes) {
    let size = 0;
    for(const attributeName in attributes){
        const attribute = attributes[attributeName];
        if (ArrayBuffer.isView(attribute)) size += attribute.byteLength * attribute.BYTES_PER_ELEMENT;
    }
    return size;
}
function $ee5b7095d0db1e4f$export$190511c0a5f57f36(attributes) {
    let minX = Infinity;
    let minY = Infinity;
    let minZ = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    let maxZ = -Infinity;
    const positions = attributes.POSITION ? attributes.POSITION.value : [];
    const len = positions && positions.length;
    for(let i = 0; i < len; i += 3){
        const x = positions[i];
        const y = positions[i + 1];
        const z = positions[i + 2];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        minZ = z < minZ ? z : minZ;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        maxZ = z > maxZ ? z : maxZ;
    }
    return [
        [
            minX,
            minY,
            minZ
        ],
        [
            maxX,
            maxY,
            maxZ
        ]
    ];
}

});


parcelRegister("kdbZI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $cxTxU = parcelRequire("cxTxU");
function $eb6e5363a77c8ff9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eb6e5363a77c8ff9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eb6e5363a77c8ff9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eb6e5363a77c8ff9$var$_typeof(obj);
}
function $eb6e5363a77c8ff9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eb6e5363a77c8ff9$var$_createSuper(Derived) {
    return function() {
        var Super = $eb6e5363a77c8ff9$var$_getPrototypeOf(Derived), result;
        if ($eb6e5363a77c8ff9$var$_isNativeReflectConstruct()) {
            var NewTarget = $eb6e5363a77c8ff9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $eb6e5363a77c8ff9$var$_possibleConstructorReturn(this, result);
    };
}
function $eb6e5363a77c8ff9$var$_possibleConstructorReturn(self, call) {
    if (call && ($eb6e5363a77c8ff9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $eb6e5363a77c8ff9$var$_assertThisInitialized(self);
}
function $eb6e5363a77c8ff9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $eb6e5363a77c8ff9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $eb6e5363a77c8ff9$var$_getPrototypeOf(o) {
    $eb6e5363a77c8ff9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $eb6e5363a77c8ff9$var$_getPrototypeOf(o);
}
function $eb6e5363a77c8ff9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $eb6e5363a77c8ff9$var$_setPrototypeOf(subClass, superClass);
}
function $eb6e5363a77c8ff9$var$_setPrototypeOf(o, p) {
    $eb6e5363a77c8ff9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eb6e5363a77c8ff9$var$_setPrototypeOf(o, p);
}
var $eb6e5363a77c8ff9$var$Arrow2DGeometry = /*#__PURE__*/ function(_Geometry) {
    $eb6e5363a77c8ff9$var$_inherits(Arrow2DGeometry, _Geometry);
    var _super = $eb6e5363a77c8ff9$var$_createSuper(Arrow2DGeometry);
    function Arrow2DGeometry() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $eb6e5363a77c8ff9$var$_classCallCheck(this, Arrow2DGeometry);
        return _super.call(this, Object.assign({}, opts, {
            attributes: $eb6e5363a77c8ff9$var$getArrowAttributes(opts)
        }));
    }
    return Arrow2DGeometry;
}($cxTxU.default);
module.exports["default"] = $eb6e5363a77c8ff9$var$Arrow2DGeometry;
function $eb6e5363a77c8ff9$var$getArrowAttributes(_ref) {
    var _ref$length = _ref.length, length = _ref$length === void 0 ? 1 : _ref$length, _ref$headSize = _ref.headSize, headSize = _ref$headSize === void 0 ? 0.2 : _ref$headSize, _ref$tailWidth = _ref.tailWidth, tailWidth = _ref$tailWidth === void 0 ? 0.05 : _ref$tailWidth, _ref$tailStart = _ref.tailStart, tailStart = _ref$tailStart === void 0 ? 0.05 : _ref$tailStart;
    var texCoords = [
        0.5,
        1.0,
        0,
        0.5 - headSize / 2,
        1.0 - headSize,
        0,
        0.5 + headSize / 2,
        1.0 - headSize,
        0,
        0.5 - tailWidth / 2,
        tailStart,
        0,
        0.5 + tailWidth / 2,
        1.0 - headSize,
        0,
        0.5 + tailWidth / 2,
        tailStart,
        0,
        0.5 - tailWidth / 2,
        tailStart,
        0,
        0.5 - tailWidth / 2,
        1.0 - headSize,
        0,
        0.5 + tailWidth / 2,
        1.0 - headSize,
        0
    ];
    var normals = [
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1
    ]; // Center and scale
    var positions = new Array(texCoords.length);
    for(var i = 0; i < texCoords.length / 3; i++){
        var i3 = i * 3;
        positions[i3 + 0] = (texCoords[i3 + 0] - 0.5) * length;
        positions[i3 + 1] = (texCoords[i3 + 1] - 0.5) * length;
        positions[i3 + 2] = 0;
    }
    return {
        positions: new Float32Array(positions),
        normals: new Float32Array(normals),
        texCoords: new Float32Array(texCoords)
    };
}

});

parcelRegister("ckc25", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8f90afbe7dd3767e$var$createPathMarkers;
parcelRequire("cO3S1");
var $SuJmn = parcelRequire("SuJmn");
function $8f90afbe7dd3767e$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $8f90afbe7dd3767e$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $8f90afbe7dd3767e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8f90afbe7dd3767e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8f90afbe7dd3767e$var$_arrayLikeToArray(o, minLen);
}
function $8f90afbe7dd3767e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8f90afbe7dd3767e$var$getLineLength(vPoints) {
    // calculate total length
    var lineLength = 0;
    for(var i = 0; i < vPoints.length - 1; i++)lineLength += vPoints[i].distance(vPoints[i + 1]);
    return lineLength;
}
var $8f90afbe7dd3767e$var$DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
var $8f90afbe7dd3767e$var$DEFAULT_DIRECTION = {
    forward: true,
    backward: false
};
function $8f90afbe7dd3767e$var$createPathMarkers(_ref) {
    var data = _ref.data, _ref$getPath = _ref.getPath, getPath = _ref$getPath === void 0 ? function(x) {
        return x.path;
    } : _ref$getPath, _ref$getDirection = _ref.getDirection, getDirection = _ref$getDirection === void 0 ? function(x) {
        return x.direction;
    } : _ref$getDirection, _ref$getColor = _ref.getColor, getColor = _ref$getColor === void 0 ? function(x) {
        return $8f90afbe7dd3767e$var$DEFAULT_COLOR;
    } : _ref$getColor, _ref$getMarkerPercent = _ref.getMarkerPercentages, getMarkerPercentages = _ref$getMarkerPercent === void 0 ? function(x, info) {
        return [
            0.5
        ];
    } : _ref$getMarkerPercent, projectFlat = _ref.projectFlat;
    var markers = [];
    var _iterator = $8f90afbe7dd3767e$var$_createForOfIteratorHelper(data), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var object = _step.value;
            var path = getPath(object);
            var direction = getDirection(object) || $8f90afbe7dd3767e$var$DEFAULT_DIRECTION;
            var color = getColor(object);
            var vPoints = path.map(function(p) {
                return new $SuJmn.default(p);
            });
            var vPointsReverse = vPoints.slice(0).reverse(); // calculate total length
            var lineLength = $8f90afbe7dd3767e$var$getLineLength(vPoints); // Ask for where to put markers
            // @ts-ignore
            var percentages = getMarkerPercentages(object, {
                lineLength: lineLength
            }); // Create the markers
            var _iterator2 = $8f90afbe7dd3767e$var$_createForOfIteratorHelper(percentages), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var percentage = _step2.value;
                    if (direction.forward) {
                        var marker = $8f90afbe7dd3767e$var$createMarkerAlongPath({
                            path: vPoints,
                            percentage: percentage,
                            lineLength: lineLength,
                            color: color,
                            object: object,
                            projectFlat: projectFlat
                        });
                        markers.push(marker);
                    }
                    if (direction.backward) {
                        var _marker = $8f90afbe7dd3767e$var$createMarkerAlongPath({
                            path: vPointsReverse,
                            percentage: percentage,
                            lineLength: lineLength,
                            color: color,
                            object: object,
                            projectFlat: projectFlat
                        });
                        markers.push(_marker);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return markers;
}
function $8f90afbe7dd3767e$var$createMarkerAlongPath(_ref2) {
    var path = _ref2.path, percentage = _ref2.percentage, lineLength = _ref2.lineLength, color = _ref2.color, object = _ref2.object, projectFlat = _ref2.projectFlat;
    var distanceAlong = lineLength * percentage;
    var currentDistance = 0;
    var previousDistance = 0;
    var i = 0;
    for(i = 0; i < path.length - 1; i++){
        currentDistance += path[i].distance(path[i + 1]);
        if (currentDistance > distanceAlong) break;
        previousDistance = currentDistance;
    } // If reached the end of the loop without exiting early,
    // undo the final increment to avoid a null-pointer exception
    if (i === path.length - 1) i -= 1;
    var vDirection = path[i + 1].clone().subtract(path[i]).normalize();
    var along = distanceAlong - previousDistance;
    var vCenter = vDirection.clone().multiply(new $SuJmn.default(along, along)).add(path[i]);
    var vDirection2 = new $SuJmn.default(projectFlat(path[i + 1])).subtract(projectFlat(path[i]));
    var angle = vDirection2.verticalAngle() * 180 / Math.PI;
    return {
        position: [
            vCenter.x,
            vCenter.y,
            0
        ],
        angle: angle,
        color: color,
        object: object
    };
}

});
parcelRegister("cO3S1", function(module, exports) {
$parcel$export(module.exports, "clamp", function () { return (parcelRequire("cwF9s")).clamp; });

$parcel$export(module.exports, "Vector2", function () { return (parcelRequire("SuJmn")).default; });
$parcel$export(module.exports, "Vector3", function () { return (parcelRequire("cKS36")).default; });
parcelRequire("cwF9s");
var $SuJmn = parcelRequire("SuJmn");
var $cKS36 = parcelRequire("cKS36");

});
parcelRegister("SuJmn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a3ce1b84b0c9d9c$export$2e2bcd8739ae039; });

var $3nAvB = parcelRequire("3nAvB");

var $cwF9s = parcelRequire("cwF9s");

var $j8wyT = parcelRequire("j8wyT");

var $autGx = parcelRequire("autGx");

var $idCXM = parcelRequire("idCXM");
class $0a3ce1b84b0c9d9c$export$2e2bcd8739ae039 extends (0, $3nAvB.default) {
    set(x, y) {
        this[0] = x;
        this[1] = y;
        return this.check();
    }
    copy(array) {
        this[0] = array[0];
        this[1] = array[1];
        return this.check();
    }
    fromObject(object) {
        if ((0, $cwF9s.config).debug) {
            (0, $j8wyT.checkNumber)(object.x);
            (0, $j8wyT.checkNumber)(object.y);
        }
        this[0] = object.x;
        this[1] = object.y;
        return this.check();
    }
    toObject(object) {
        object.x = this[0];
        object.y = this[1];
        return object;
    }
    get ELEMENTS() {
        return 2;
    }
    horizontalAngle() {
        return Math.atan2(this.y, this.x);
    }
    verticalAngle() {
        return Math.atan2(this.x, this.y);
    }
    transform(matrix4) {
        return this.transformAsPoint(matrix4);
    }
    transformAsPoint(matrix4) {
        $autGx.transformMat4(this, this, matrix4);
        return this.check();
    }
    transformAsVector(matrix4) {
        (0, $idCXM.vec2_transformMat4AsVector)(this, this, matrix4);
        return this.check();
    }
    transformByMatrix3(matrix3) {
        $autGx.transformMat3(this, this, matrix3);
        return this.check();
    }
    transformByMatrix2x3(matrix2x3) {
        $autGx.transformMat2d(this, this, matrix2x3);
        return this.check();
    }
    transformByMatrix2(matrix2) {
        $autGx.transformMat2(this, this, matrix2);
        return this.check();
    }
    constructor(x = 0, y = 0){
        super(2);
        if ((0, $cwF9s.isArray)(x) && arguments.length === 1) this.copy(x);
        else {
            if ((0, $cwF9s.config).debug) {
                (0, $j8wyT.checkNumber)(x);
                (0, $j8wyT.checkNumber)(y);
            }
            this[0] = x;
            this[1] = y;
        }
    }
}

});



parcelRegister("9HybI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getClosestPointOnLine = $7102a63c24b5352b$var$getClosestPointOnLine;
module.exports.getClosestPointOnPolyline = $7102a63c24b5352b$var$getClosestPointOnPolyline;
parcelRequire("cO3S1");
var $cwF9s = parcelRequire("cwF9s");
var $cKS36 = parcelRequire("cKS36");
// Return the closest point on a line segment
function $7102a63c24b5352b$var$getClosestPointOnLine(_ref) {
    var p = _ref.p, p1 = _ref.p1, p2 = _ref.p2, _ref$clampToLine = _ref.clampToLine, clampToLine = _ref$clampToLine === void 0 ? true : _ref$clampToLine;
    var lineVector = new $cKS36.default(p2).subtract(p1);
    var pointVector = new $cKS36.default(p).subtract(p1);
    var dotProduct = lineVector.dot(pointVector);
    if (clampToLine) dotProduct = (0, $cwF9s.clamp)(dotProduct, 0, 1);
     // @ts-ignore
    return lineVector.lerp(dotProduct);
} // Return the closest point on a line segment
function $7102a63c24b5352b$var$getClosestPointOnPolyline(_ref2) {
    var p = _ref2.p, points = _ref2.points;
    p = new $cKS36.default(p);
    var pClosest = null;
    var distanceSquared = Infinity;
    var index = -1;
    for(var i = 0; i < points.length - 1; ++i){
        var p1 = points[i];
        var p2 = points[i + 1];
        var pClosestOnLine = $7102a63c24b5352b$var$getClosestPointOnLine({
            p: p,
            p1: p1,
            p2: p2
        });
        var distanceToLineSquared = p.distanceSquared(pClosestOnLine);
        if (distanceToLineSquared < distanceSquared) {
            distanceSquared = distanceToLineSquared;
            pClosest = pClosestOnLine;
            index = i;
        }
    }
    return {
        point: pClosest,
        index: index,
        p1: points[index],
        p2: points[index + 1],
        distanceSquared: distanceSquared,
        distance: Math.sqrt(distanceSquared)
    };
}

});


parcelRegister("gi8jT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $coXLq = parcelRequire("coXLq");

var $cYQ5y = parcelRequire("cYQ5y");
function $bdc4c7f085a94789$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bdc4c7f085a94789$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bdc4c7f085a94789$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bdc4c7f085a94789$var$_typeof(obj);
}
function $bdc4c7f085a94789$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bdc4c7f085a94789$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bdc4c7f085a94789$var$ownKeys(Object(source), true).forEach(function(key) {
            $bdc4c7f085a94789$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bdc4c7f085a94789$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bdc4c7f085a94789$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bdc4c7f085a94789$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bdc4c7f085a94789$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bdc4c7f085a94789$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bdc4c7f085a94789$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bdc4c7f085a94789$var$_createSuper(Derived) {
    return function() {
        var Super = $bdc4c7f085a94789$var$_getPrototypeOf(Derived), result;
        if ($bdc4c7f085a94789$var$_isNativeReflectConstruct()) {
            var NewTarget = $bdc4c7f085a94789$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bdc4c7f085a94789$var$_possibleConstructorReturn(this, result);
    };
}
function $bdc4c7f085a94789$var$_possibleConstructorReturn(self, call) {
    if (call && ($bdc4c7f085a94789$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bdc4c7f085a94789$var$_assertThisInitialized(self);
}
function $bdc4c7f085a94789$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bdc4c7f085a94789$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bdc4c7f085a94789$var$_getPrototypeOf(o) {
    $bdc4c7f085a94789$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bdc4c7f085a94789$var$_getPrototypeOf(o);
}
function $bdc4c7f085a94789$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bdc4c7f085a94789$var$_setPrototypeOf(subClass, superClass);
}
function $bdc4c7f085a94789$var$_setPrototypeOf(o, p) {
    $bdc4c7f085a94789$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bdc4c7f085a94789$var$_setPrototypeOf(o, p);
}
function $bdc4c7f085a94789$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $bdc4c7f085a94789$var$JunctionScatterplotLayer = /*#__PURE__*/ function(_CompositeLayer) {
    $bdc4c7f085a94789$var$_inherits(JunctionScatterplotLayer, _CompositeLayer);
    var _super = $bdc4c7f085a94789$var$_createSuper(JunctionScatterplotLayer);
    function JunctionScatterplotLayer() {
        $bdc4c7f085a94789$var$_classCallCheck(this, JunctionScatterplotLayer);
        return _super.apply(this, arguments);
    }
    $bdc4c7f085a94789$var$_createClass(JunctionScatterplotLayer, [
        {
            key: "renderLayers",
            value: function renderLayers() {
                var _this$props = this.props, id = _this$props.id, getFillColor = _this$props.getFillColor, getStrokeColor = _this$props.getStrokeColor, getInnerRadius = _this$props.getInnerRadius, updateTriggers = _this$props.updateTriggers; // data needs to be passed explicitly after deck.gl 5.3
                return [
                    new $cYQ5y.default($bdc4c7f085a94789$var$_objectSpread({}, this.props, {
                        id: "".concat(id, "-full"),
                        data: this.props.data,
                        getLineColor: getStrokeColor,
                        updateTriggers: $bdc4c7f085a94789$var$_objectSpread({}, updateTriggers, {
                            getStrokeColor: updateTriggers.getStrokeColor
                        })
                    })),
                    new $cYQ5y.default($bdc4c7f085a94789$var$_objectSpread({}, this.props, {
                        id: "".concat(id, "-inner"),
                        data: this.props.data,
                        getFillColor: getFillColor,
                        getRadius: getInnerRadius,
                        pickable: false,
                        updateTriggers: $bdc4c7f085a94789$var$_objectSpread({}, updateTriggers, {
                            getFillColor: updateTriggers.getFillColor,
                            getRadius: updateTriggers.getInnerRadius
                        })
                    }))
                ];
            }
        }
    ]);
    return JunctionScatterplotLayer;
}($coXLq.default);
module.exports["default"] = $bdc4c7f085a94789$var$JunctionScatterplotLayer;
$bdc4c7f085a94789$var$_defineProperty($bdc4c7f085a94789$var$JunctionScatterplotLayer, "layerName", "JunctionScatterplotLayer");
$bdc4c7f085a94789$var$_defineProperty($bdc4c7f085a94789$var$JunctionScatterplotLayer, "defaultProps", $bdc4c7f085a94789$var$_objectSpread({}, $cYQ5y.default.defaultProps, {
    getFillColor: function getFillColor(d) {
        return [
            0,
            0,
            0,
            255
        ];
    },
    getStrokeColor: function getStrokeColor(d) {
        return [
            255,
            255,
            255,
            255
        ];
    },
    getInnerRadius: function getInnerRadius(d) {
        return 1;
    }
}));

});


parcelRegister("h5pu5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toDeckColor = $c706abeed9ed1bf8$var$toDeckColor;
module.exports.recursivelyTraverseNestedArrays = $c706abeed9ed1bf8$var$recursivelyTraverseNestedArrays;
function $c706abeed9ed1bf8$var$_toConsumableArray(arr) {
    return $c706abeed9ed1bf8$var$_arrayWithoutHoles(arr) || $c706abeed9ed1bf8$var$_iterableToArray(arr) || $c706abeed9ed1bf8$var$_unsupportedIterableToArray(arr) || $c706abeed9ed1bf8$var$_nonIterableSpread();
}
function $c706abeed9ed1bf8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c706abeed9ed1bf8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c706abeed9ed1bf8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c706abeed9ed1bf8$var$_arrayLikeToArray(o, minLen);
}
function $c706abeed9ed1bf8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c706abeed9ed1bf8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c706abeed9ed1bf8$var$_arrayLikeToArray(arr);
}
function $c706abeed9ed1bf8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c706abeed9ed1bf8$var$toDeckColor(color) {
    var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        255,
        0,
        0,
        255
    ];
    if (!Array.isArray(color)) return defaultColor;
    return [
        color[0] * 255,
        color[1] * 255,
        color[2] * 255,
        color[3] * 255
    ];
} //
// a GeoJSON helper function that calls the provided function with
// an argument that is the most deeply-nested array having elements
// that are arrays of primitives as an argument, e.g.
//
// {
//   "type": "MultiPolygon",
//   "coordinates": [
//       [
//           [[30, 20], [45, 40], [10, 40], [30, 20]]
//       ],
//       [
//           [[15, 5], [40, 10], [10, 20], [5, 10], [15, 5]]
//       ]
//   ]
// }
//
// the function would be called on:
//
// [[30, 20], [45, 40], [10, 40], [30, 20]]
//
// and
//
// [[15, 5], [40, 10], [10, 20], [5, 10], [15, 5]]
//
function $c706abeed9ed1bf8$var$recursivelyTraverseNestedArrays(array, prefix, fn) {
    if (!Array.isArray(array[0])) return true;
    for(var i = 0; i < array.length; i++)if ($c706abeed9ed1bf8$var$recursivelyTraverseNestedArrays(array[i], [].concat($c706abeed9ed1bf8$var$_toConsumableArray(prefix), [
        i
    ]), fn)) {
        fn(array, prefix);
        break;
    }
    return false;
}

});

parcelRegister("pgVSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $04bf7859a38934d4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $04bf7859a38934d4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $04bf7859a38934d4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $04bf7859a38934d4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $04bf7859a38934d4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $04bf7859a38934d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $04bf7859a38934d4$var$DeckCache = /*#__PURE__*/ function() {
    function DeckCache(getData, convert) {
        $04bf7859a38934d4$var$_classCallCheck(this, DeckCache);
        $04bf7859a38934d4$var$_defineProperty(this, "objects", void 0);
        $04bf7859a38934d4$var$_defineProperty(this, "originals", void 0);
        $04bf7859a38934d4$var$_defineProperty(this, "updateTrigger", void 0);
        $04bf7859a38934d4$var$_defineProperty(this, "_idToPosition", void 0);
        $04bf7859a38934d4$var$_defineProperty(this, "_getData", void 0);
        $04bf7859a38934d4$var$_defineProperty(this, "_convert", void 0);
        this.objects = [];
        this.originals = [];
        this.updateTrigger = 0;
        this._idToPosition = new Map();
        this._getData = getData;
        this._convert = convert;
    }
    $04bf7859a38934d4$var$_createClass(DeckCache, [
        {
            key: "updateAllDeckObjects",
            value: function updateAllDeckObjects() {
                var _this = this;
                if (!this._getData || !this._convert) return;
                this.originals.length = 0;
                this.objects.length = 0;
                this._idToPosition.clear();
                this._getData().forEach(function(d) {
                    _this._idToPosition.set(d.id, _this.objects.length);
                    _this.originals.push(d);
                    _this.objects.push(_this._convert(d));
                });
                this.triggerUpdate();
            }
        },
        {
            key: "updateDeckObjectsByIds",
            value: function updateDeckObjectsByIds(ids) {
                var _this2 = this;
                if (!this._getData || !this._convert) return;
                ids.forEach(function(id) {
                    var p = _this2._idToPosition.get(id);
                    if (p !== undefined) _this2.objects[p] = _this2._convert(_this2.originals[p]);
                });
                this.triggerUpdate();
            }
        },
        {
            key: "triggerUpdate",
            value: function triggerUpdate() {
                this.updateTrigger++;
            }
        },
        {
            key: "getDeckObjectById",
            value: function getDeckObjectById(id) {
                var p = this._idToPosition.get(id);
                return p !== undefined ? this.objects[p] : null;
            }
        },
        {
            key: "getOriginalById",
            value: function getOriginalById(id) {
                var p = this._idToPosition.get(id);
                return p !== undefined ? this.originals[p] : null;
            }
        }
    ]);
    return DeckCache;
}();
module.exports["default"] = $04bf7859a38934d4$var$DeckCache;

});


parcelRegister("cWVMd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9pc7R = parcelRequire("9pc7R");

var $96d7b80ecefdbb97$var$_nebulaLayer = $96d7b80ecefdbb97$var$_interopRequireDefault((parcelRequire("7uZXb")));

var $h5pu5 = parcelRequire("h5pu5");

var $bEXHX = parcelRequire("bEXHX");

var $96d7b80ecefdbb97$var$_deckCache = $96d7b80ecefdbb97$var$_interopRequireDefault((parcelRequire("pgVSk")));
function $96d7b80ecefdbb97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $96d7b80ecefdbb97$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $96d7b80ecefdbb97$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $96d7b80ecefdbb97$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $96d7b80ecefdbb97$var$_typeof(obj);
}
function $96d7b80ecefdbb97$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $96d7b80ecefdbb97$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $96d7b80ecefdbb97$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $96d7b80ecefdbb97$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $96d7b80ecefdbb97$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $96d7b80ecefdbb97$var$_createSuper(Derived) {
    return function() {
        var Super = $96d7b80ecefdbb97$var$_getPrototypeOf(Derived), result;
        if ($96d7b80ecefdbb97$var$_isNativeReflectConstruct()) {
            var NewTarget = $96d7b80ecefdbb97$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $96d7b80ecefdbb97$var$_possibleConstructorReturn(this, result);
    };
}
function $96d7b80ecefdbb97$var$_possibleConstructorReturn(self, call) {
    if (call && ($96d7b80ecefdbb97$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $96d7b80ecefdbb97$var$_assertThisInitialized(self);
}
function $96d7b80ecefdbb97$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $96d7b80ecefdbb97$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $96d7b80ecefdbb97$var$_getPrototypeOf(o) {
    $96d7b80ecefdbb97$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $96d7b80ecefdbb97$var$_getPrototypeOf(o);
}
function $96d7b80ecefdbb97$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $96d7b80ecefdbb97$var$_setPrototypeOf(subClass, superClass);
}
function $96d7b80ecefdbb97$var$_setPrototypeOf(o, p) {
    $96d7b80ecefdbb97$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $96d7b80ecefdbb97$var$_setPrototypeOf(o, p);
}
function $96d7b80ecefdbb97$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $96d7b80ecefdbb97$var$TextsLayer = /*#__PURE__*/ function(_NebulaLayer) {
    $96d7b80ecefdbb97$var$_inherits(TextsLayer, _NebulaLayer);
    var _super = $96d7b80ecefdbb97$var$_createSuper(TextsLayer);
    function TextsLayer(config) {
        var _this;
        $96d7b80ecefdbb97$var$_classCallCheck(this, TextsLayer);
        _this = _super.call(this, config);
        $96d7b80ecefdbb97$var$_defineProperty($96d7b80ecefdbb97$var$_assertThisInitialized(_this), "deckCache", void 0);
        _this.deckCache = new $96d7b80ecefdbb97$var$_deckCache["default"](config.getData, function(data) {
            return config.toNebulaFeature(data);
        });
        return _this;
    }
    $96d7b80ecefdbb97$var$_createClass(TextsLayer, [
        {
            key: "render",
            value: function render(_ref) {
                var nebula = _ref.nebula;
                var defaultColor = [
                    0x0,
                    0x0,
                    0x0,
                    0xff
                ];
                var _this$deckCache = this.deckCache, objects = _this$deckCache.objects, updateTrigger = _this$deckCache.updateTrigger;
                var zoom = nebula.props.viewport.zoom;
                return new $9pc7R.default({
                    id: "texts-".concat(this.id),
                    data: objects,
                    opacity: 1,
                    fp64: false,
                    pickable: false,
                    // @ts-ignore
                    getText: function getText(nf) {
                        return nf.style.text;
                    },
                    // @ts-ignore
                    getPosition: function getPosition(nf) {
                        return nf.geoJson.geometry.coordinates;
                    },
                    // @ts-ignore
                    getColor: function getColor(nf) {
                        return (0, $h5pu5.toDeckColor)(nf.style.fillColor) || defaultColor;
                    },
                    // TODO: layer should offer option to scale with zoom
                    sizeScale: 1 / Math.pow(2, 20 - zoom),
                    getSize: $bEXHX.PROJECTED_PIXEL_SIZE_MULTIPLIER,
                    updateTriggers: {
                        all: updateTrigger
                    },
                    nebulaLayer: this
                });
            }
        }
    ]);
    return TextsLayer;
}($96d7b80ecefdbb97$var$_nebulaLayer["default"]);
module.exports["default"] = $96d7b80ecefdbb97$var$TextsLayer;

});
parcelRegister("bEXHX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PROJECTED_PIXEL_SIZE_MULTIPLIER = void 0;
/**
 * A multiplier for screen-space width/scale for Arc, Line, Icon and Text layers.
 * Required in order to maintain the same appearance after upgrading to deck.gl v8.5.
 * https://github.com/visgl/deck.gl/blob/master/docs/upgrade-guide.md
 */ var $87d1bee9911d11f9$var$PROJECTED_PIXEL_SIZE_MULTIPLIER = 2 / 3;
module.exports.PROJECTED_PIXEL_SIZE_MULTIPLIER = $87d1bee9911d11f9$var$PROJECTED_PIXEL_SIZE_MULTIPLIER;

});


parcelRegister("cIeIZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4agoo = parcelRequire("4agoo");

var $9415041b4eaa9f0d$var$_constants = $9415041b4eaa9f0d$var$_interopRequireDefault((parcelRequire("6ZpD9")));

var $4TuXT = parcelRequire("4TuXT");

var $9415041b4eaa9f0d$var$_nebulaLayer = $9415041b4eaa9f0d$var$_interopRequireDefault((parcelRequire("7uZXb")));

var $h5pu5 = parcelRequire("h5pu5");

var $9415041b4eaa9f0d$var$_deckCache = $9415041b4eaa9f0d$var$_interopRequireDefault((parcelRequire("pgVSk")));
var $9415041b4eaa9f0d$var$_NEBULA_TO_DECK_DIREC;
function $9415041b4eaa9f0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9415041b4eaa9f0d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9415041b4eaa9f0d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9415041b4eaa9f0d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9415041b4eaa9f0d$var$_typeof(obj);
}
function $9415041b4eaa9f0d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9415041b4eaa9f0d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9415041b4eaa9f0d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9415041b4eaa9f0d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9415041b4eaa9f0d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9415041b4eaa9f0d$var$_createSuper(Derived) {
    return function() {
        var Super = $9415041b4eaa9f0d$var$_getPrototypeOf(Derived), result;
        if ($9415041b4eaa9f0d$var$_isNativeReflectConstruct()) {
            var NewTarget = $9415041b4eaa9f0d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9415041b4eaa9f0d$var$_possibleConstructorReturn(this, result);
    };
}
function $9415041b4eaa9f0d$var$_possibleConstructorReturn(self, call) {
    if (call && ($9415041b4eaa9f0d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9415041b4eaa9f0d$var$_assertThisInitialized(self);
}
function $9415041b4eaa9f0d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9415041b4eaa9f0d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9415041b4eaa9f0d$var$_getPrototypeOf(o) {
    $9415041b4eaa9f0d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9415041b4eaa9f0d$var$_getPrototypeOf(o);
}
function $9415041b4eaa9f0d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9415041b4eaa9f0d$var$_setPrototypeOf(subClass, superClass);
}
function $9415041b4eaa9f0d$var$_setPrototypeOf(o, p) {
    $9415041b4eaa9f0d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9415041b4eaa9f0d$var$_setPrototypeOf(o, p);
}
function $9415041b4eaa9f0d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9415041b4eaa9f0d$var$NEBULA_TO_DECK_DIRECTIONS = ($9415041b4eaa9f0d$var$_NEBULA_TO_DECK_DIREC = {}, $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_NEBULA_TO_DECK_DIREC, $4TuXT.ArrowStyles.NONE, {
    forward: false,
    backward: false
}), $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_NEBULA_TO_DECK_DIREC, $4TuXT.ArrowStyles.FORWARD, {
    forward: true,
    backward: false
}), $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_NEBULA_TO_DECK_DIREC, $4TuXT.ArrowStyles.BACKWARD, {
    forward: false,
    backward: true
}), $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_NEBULA_TO_DECK_DIREC, $4TuXT.ArrowStyles.BOTH, {
    forward: true,
    backward: true
}), $9415041b4eaa9f0d$var$_NEBULA_TO_DECK_DIREC);
var $9415041b4eaa9f0d$var$SegmentsLayer = /*#__PURE__*/ function(_NebulaLayer) {
    $9415041b4eaa9f0d$var$_inherits(SegmentsLayer, _NebulaLayer);
    var _super = $9415041b4eaa9f0d$var$_createSuper(SegmentsLayer);
    function SegmentsLayer(config) {
        var _this;
        $9415041b4eaa9f0d$var$_classCallCheck(this, SegmentsLayer);
        _this = _super.call(this, config);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "deckCache", void 0);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "noBlend", void 0);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "highlightColor", void 0);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "arrowSize", void 0);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "jointRounded", void 0);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "capRounded", void 0);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "dashed", void 0);
        $9415041b4eaa9f0d$var$_defineProperty($9415041b4eaa9f0d$var$_assertThisInitialized(_this), "markerLayerProps", void 0);
        _this.deckCache = new $9415041b4eaa9f0d$var$_deckCache["default"](config.getData, function(data) {
            return config.toNebulaFeature(data);
        });
        _this.enableSelection = true;
        var _config$enablePicking = config.enablePicking, enablePicking = _config$enablePicking === void 0 ? true : _config$enablePicking, _config$noBlend = config.noBlend, noBlend = _config$noBlend === void 0 ? false : _config$noBlend, _config$jointRounded = config.jointRounded, jointRounded = _config$jointRounded === void 0 ? true : _config$jointRounded, _config$capRounded = config.capRounded, capRounded = _config$capRounded === void 0 ? true : _config$capRounded, _config$dashed = config.dashed, dashed = _config$dashed === void 0 ? false : _config$dashed, _config$markerLayerPr = config.markerLayerProps, markerLayerProps = _config$markerLayerPr === void 0 ? null : _config$markerLayerPr;
        Object.assign($9415041b4eaa9f0d$var$_assertThisInitialized(_this), {
            enablePicking: enablePicking,
            noBlend: noBlend,
            jointRounded: jointRounded,
            capRounded: capRounded,
            dashed: dashed,
            markerLayerProps: markerLayerProps
        });
        return _this;
    }
    $9415041b4eaa9f0d$var$_createClass(SegmentsLayer, [
        {
            key: "getMouseOverSegment",
            value: function getMouseOverSegment() {
                // TODO: remove references
                return null;
            }
        },
        {
            key: "_calcMarkerPercentages",
            value: function _calcMarkerPercentages(nf) {
                var arrowPercentages = nf.style.arrowPercentages;
                if (arrowPercentages) return arrowPercentages;
                var arrowStyle = nf.style.arrowStyle || $4TuXT.DEFAULT_STYLE.arrowStyle;
                if (arrowStyle === $4TuXT.ArrowStyles.NONE) return [];
                var arrowCount = Math.min(nf.style.arrowCount || $4TuXT.DEFAULT_STYLE.arrowCount, $4TuXT.MAX_ARROWS);
                return [
                    [
                        0.5
                    ],
                    [
                        0.33,
                        0.66
                    ],
                    [
                        0.25,
                        0.5,
                        0.75
                    ]
                ][arrowCount - 1];
            }
        },
        {
            key: "_getHighlightedObjectIndex",
            value: function _getHighlightedObjectIndex(_ref) {
                var nebula = _ref.nebula;
                var deckglMouseOverInfo = nebula.deckglMouseOverInfo;
                if (deckglMouseOverInfo) {
                    var originalLayer = deckglMouseOverInfo.originalLayer, index = deckglMouseOverInfo.index;
                    if (originalLayer === this) return index;
                } // no object
                return -1;
            }
        },
        {
            key: "render",
            value: function render(_ref2) {
                var nebula = _ref2.nebula;
                var defaultColor = [
                    0x0,
                    0x0,
                    0x0,
                    0xff
                ];
                var _this$deckCache = this.deckCache, objects = _this$deckCache.objects, updateTrigger = _this$deckCache.updateTrigger;
                return new $4agoo.PathMarkerLayer({
                    id: "segments-".concat(this.id),
                    data: objects,
                    opacity: 1,
                    fp64: false,
                    jointRounded: this.jointRounded,
                    capRounded: this.capRounded,
                    pickable: true,
                    sizeScale: this.arrowSize || 6,
                    parameters: {
                        depthTest: false,
                        blend: !this.noBlend,
                        blendEquation: $9415041b4eaa9f0d$var$_constants["default"].MAX
                    },
                    getPath: function getPath(nf) {
                        return nf.geoJson.geometry.coordinates;
                    },
                    getColor: function getColor(nf) {
                        return (0, $h5pu5.toDeckColor)(nf.style.lineColor, defaultColor);
                    },
                    getWidth: function getWidth(nf) {
                        return nf.style.lineWidthMeters || 1;
                    },
                    getZLevel: function getZLevel(nf) {
                        return nf.style.zLevel * 255;
                    },
                    getDirection: function getDirection(nf) {
                        return $9415041b4eaa9f0d$var$NEBULA_TO_DECK_DIRECTIONS[nf.style.arrowStyle];
                    },
                    getMarkerColor: function getMarkerColor(nf) {
                        return (0, $h5pu5.toDeckColor)(nf.style.arrowColor, defaultColor);
                    },
                    getMarkerPercentages: this._calcMarkerPercentages,
                    updateTriggers: {
                        all: updateTrigger
                    },
                    highlightedObjectIndex: this._getHighlightedObjectIndex({
                        nebula: nebula
                    }),
                    highlightColor: (0, $h5pu5.toDeckColor)(this.highlightColor),
                    dashJustified: this.dashed,
                    getDashArray: this.dashed ? function(nf) {
                        return nf.style.dashArray;
                    } : null,
                    markerLayerProps: this.markerLayerProps || $4agoo.PathMarkerLayer.defaultProps.markerLayerProps,
                    nebulaLayer: this
                });
            }
        }
    ]);
    return SegmentsLayer;
}($9415041b4eaa9f0d$var$_nebulaLayer["default"]);
module.exports["default"] = $9415041b4eaa9f0d$var$SegmentsLayer;

});

parcelRegister("afly2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8nJ5N = parcelRequire("8nJ5N");

var $775c05120235343a$var$_document = $775c05120235343a$var$_interopRequireDefault((parcelRequire("f6y2O")));

var $gwLQV = parcelRequire("gwLQV");

var $775c05120235343a$var$_deckDrawer = $775c05120235343a$var$_interopRequireDefault((parcelRequire("cY7II")));

var $775c05120235343a$var$_layerMouseEvent = $775c05120235343a$var$_interopRequireDefault((parcelRequire("iXJhp")));

var $775c05120235343a$var$_nebulaLayer = $775c05120235343a$var$_interopRequireDefault((parcelRequire("7uZXb")));
function $775c05120235343a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $775c05120235343a$var$_toConsumableArray(arr) {
    return $775c05120235343a$var$_arrayWithoutHoles(arr) || $775c05120235343a$var$_iterableToArray(arr) || $775c05120235343a$var$_unsupportedIterableToArray(arr) || $775c05120235343a$var$_nonIterableSpread();
}
function $775c05120235343a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $775c05120235343a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $775c05120235343a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $775c05120235343a$var$_arrayLikeToArray(o, minLen);
}
function $775c05120235343a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $775c05120235343a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $775c05120235343a$var$_arrayLikeToArray(arr);
}
function $775c05120235343a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $775c05120235343a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $775c05120235343a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $775c05120235343a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $775c05120235343a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $775c05120235343a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $775c05120235343a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $775c05120235343a$var$LOGGER_PREFIX = "Nebula: ";
var $775c05120235343a$var$Nebula = /*#__PURE__*/ function() {
    function Nebula() {
        var _this = this;
        $775c05120235343a$var$_classCallCheck(this, Nebula);
        $775c05120235343a$var$_defineProperty(this, "props", void 0);
        $775c05120235343a$var$_defineProperty(this, "deckgl", void 0);
        $775c05120235343a$var$_defineProperty(this, "mainContainer", void 0);
        $775c05120235343a$var$_defineProperty(this, "deckglMouseOverInfo", void 0);
        $775c05120235343a$var$_defineProperty(this, "_deckDrawer", void 0);
        $775c05120235343a$var$_defineProperty(this, "_mouseWasDown", void 0);
        $775c05120235343a$var$_defineProperty(this, "wmViewport", void 0);
        $775c05120235343a$var$_defineProperty(this, "queryObjectEvents", new $8nJ5N.EventEmitter());
        $775c05120235343a$var$_defineProperty(this, "forceUpdate", void 0);
        $775c05120235343a$var$_defineProperty(this, "inited", void 0);
        $775c05120235343a$var$_defineProperty(this, "_onMouseEvent", function(event) {
            if (!_this._isNebulaEvent(event)) return;
            if (event.type === "mousedown") _this._mouseWasDown = true;
             // offsetX/Y of the MouseEvent provides the offset in the X/Y coordinate
            // of the mouse pointer between that event and the padding edge of the target node.
            // We set our listener to document so we need to adjust offsetX/Y
            // in case the target is not be our WebGL canvas.
            var _ref = _this.mainContainer ? _this.mainContainer.getBoundingClientRect() : {}, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left;
            var proxyEvent = new Proxy(event, {
                get: function get(original, propertyName) {
                    if (propertyName === "offsetX") return original.pageX - left;
                    if (propertyName === "offsetY") return original.pageY - top;
                     // TODO: Properly use pointer events
                    if (propertyName === "type") return original.type.replace("pointer", "mouse");
                    var result = original[propertyName];
                    if (typeof result === "function") return result.bind(original);
                    return result;
                }
            });
            _this._handleDeckGLEvent(proxyEvent);
        });
    }
    $775c05120235343a$var$_createClass(Nebula, [
        {
            key: "init",
            value: function init(props) {
                var _this2 = this;
                this.props = props;
                this.wmViewport = new $gwLQV.default(this.props.viewport); // TODO: Properly use pointer events: ['click', 'pointermove', 'pointerup', 'pointerdown']
                [
                    "click",
                    "mousemove",
                    "mouseup",
                    "mousedown"
                ].forEach(function(name) {
                    return $775c05120235343a$var$_document["default"].addEventListener(name, _this2._onMouseEvent, true);
                });
            }
        },
        {
            key: "detach",
            value: function detach() {
                var _this3 = this;
                // TODO: Properly use pointer events: ['click', 'pointermove', 'pointerup', 'pointerdown']
                [
                    "click",
                    "mousemove",
                    "mouseup",
                    "mousedown"
                ].forEach(function(name) {
                    return $775c05120235343a$var$_document["default"].removeEventListener(name, _this3._onMouseEvent, true);
                });
            }
        },
        {
            key: "updateProps",
            value: function updateProps(newProps) {
                this.props = newProps;
                var viewport = this.props.viewport;
                this.wmViewport = new $gwLQV.default(viewport);
            }
        },
        {
            key: "log",
            value: function log(message) {
                var logger = this.props.logger;
                if (logger && logger.info) logger.info($775c05120235343a$var$LOGGER_PREFIX + message);
            }
        },
        {
            key: "updateAllDeckObjects",
            value: function updateAllDeckObjects() {
                this.getAllLayers().forEach(function(layer) {
                    if (layer && layer.deckCache) layer.deckCache.updateAllDeckObjects();
                });
                this.forceUpdate();
            }
        },
        {
            key: "updateDeckObjectsByIds",
            value: function updateDeckObjectsByIds(ids) {
                this.getAllLayers().forEach(function(layer) {
                    if (layer && layer.deckCache) layer.deckCache.updateDeckObjectsByIds(ids);
                });
                this.forceUpdate();
            }
        },
        {
            key: "rerenderLayers",
            value: function rerenderLayers() {
                this.updateAllDeckObjects();
            }
        },
        {
            key: "_isNebulaEvent",
            value: function _isNebulaEvent(_ref2) {
                var buttons = _ref2.buttons, target = _ref2.target, type = _ref2.type;
                var viewport = this.props.viewport; // allow mouseup event aggressively to cancel drag properly
                // TODO: use pointer capture setPointerCapture() to capture mouseup properly after deckgl
                if (this._mouseWasDown && type === "mouseup") {
                    this._mouseWasDown = false;
                    return true;
                } // allow mousemove event while dragging
                if (type === "mousemove" && buttons > 0) return true;
                if (!target.getBoundingClientRect) return false;
                var rect = target.getBoundingClientRect(); // Only listen to events coming from the basemap
                // identified by the canvas of the same size as viewport.
                // Need to round the rect dimension as some monitors
                // have some sub-pixel difference with viewport.
                return Math.round(rect.width) === Math.round(viewport.width) && Math.round(rect.height) === Math.round(viewport.height);
            }
        },
        {
            key: "getMouseGroundPosition",
            value: function getMouseGroundPosition(event) {
                return this.wmViewport.unproject([
                    event.offsetX,
                    event.offsetY
                ]);
            }
        },
        {
            key: "unprojectMousePosition",
            value: function unprojectMousePosition(mousePosition) {
                // @ts-ignore
                return this.wmViewport.unproject(mousePosition);
            }
        },
        {
            key: "_handleDeckGLEvent",
            value: function _handleDeckGLEvent(event) {
                var deckgl = this.deckgl, _this$props = this.props, onMapMouseEvent = _this$props.onMapMouseEvent, selectionType = _this$props.selectionType, eventFilter = _this$props.eventFilter;
                var sendMapEvent = true;
                var cursor = "auto";
                if (event && deckgl && selectionType) {
                    if (!this._deckDrawer) this._deckDrawer = new $775c05120235343a$var$_deckDrawer["default"](this);
                    var lngLat = this.getMouseGroundPosition(event);
                    if (eventFilter && !eventFilter(lngLat, event)) return; // @ts-ignore
                    var drawerResult = this._deckDrawer.handleEvent(event, lngLat, selectionType);
                    if (drawerResult.redraw) this.forceUpdate();
                    return;
                }
                if (event && deckgl && (!event.buttons || event.type !== "mousemove")) {
                    // TODO: sort by mouse priority
                    var layerIds = deckgl.props.layers.filter(function(l) {
                        return l && l.props && l.props.nebulaLayer && l.props.nebulaLayer.enablePicking;
                    }).map(function(l) {
                        return l.id;
                    });
                    var pickingInfo = deckgl.pickObject({
                        x: event.offsetX,
                        y: event.offsetY,
                        radius: 5,
                        layerIds: layerIds
                    });
                    this.queryObjectEvents.emit("pick", {
                        event: event,
                        pickingInfo: pickingInfo
                    });
                    if (pickingInfo) {
                        sendMapEvent = false;
                        var index = pickingInfo.index, _lngLat = pickingInfo.lngLat;
                        if (eventFilter && !eventFilter(_lngLat, event)) return;
                        var deckLayer = pickingInfo.layer, object = pickingInfo.object;
                        if (deckLayer && deckLayer.props && deckLayer.props.nebulaLayer && deckLayer.props.nebulaLayer.eventHandler) deckLayer.props.nebulaLayer.eventHandler(event, pickingInfo);
                        var original = object.original || deckLayer.props.nebulaLayer && deckLayer.props.nebulaLayer.deckCache && deckLayer.props.nebulaLayer.deckCache.originals[index];
                        if (original) {
                            this.deckglMouseOverInfo = {
                                originalLayer: deckLayer.props.nebulaLayer,
                                index: index
                            }; // @ts-ignore
                            var nebulaMouseEvent = new $775c05120235343a$var$_layerMouseEvent["default"](event, {
                                data: original,
                                metadata: object.metadata,
                                groundPoint: _lngLat,
                                nebula: this
                            });
                            deckLayer.props.nebulaLayer.emit(event.type, nebulaMouseEvent);
                            this.forceUpdate();
                        }
                        cursor = "pointer";
                    }
                }
                if ($775c05120235343a$var$_document["default"].documentElement) $775c05120235343a$var$_document["default"].documentElement.style.cursor = cursor;
                if (sendMapEvent) {
                    this.deckglMouseOverInfo = null;
                    var _lngLat2 = this.getMouseGroundPosition(event);
                    if (eventFilter && !eventFilter(_lngLat2, event)) return; // send to layers first
                    // @ts-ignore
                    var _nebulaMouseEvent = new $775c05120235343a$var$_layerMouseEvent["default"](event, {
                        groundPoint: _lngLat2,
                        nebula: this
                    });
                    this.getAllLayers().filter(function(layer) {
                        return layer && layer.usesMapEvents;
                    }).forEach(function(layer) {
                        return layer.emit("mapMouseEvent", _nebulaMouseEvent);
                    });
                    this.getAllLayers().filter(function(layer) {
                        return layer && layer.props && layer.props.nebulaLayer && layer.props.nebulaLayer.mapMouseEvent;
                    }).forEach(function(layer) {
                        return layer.props.nebulaLayer.mapMouseEvent(_nebulaMouseEvent, layer);
                    });
                    if (onMapMouseEvent) onMapMouseEvent(event, _lngLat2);
                }
            }
        },
        {
            key: "getExtraDeckLayers",
            value: function getExtraDeckLayers() {
                var result = [];
                if (this._deckDrawer) result.push.apply(result, $775c05120235343a$var$_toConsumableArray(this._deckDrawer.render()));
                return result;
            }
        },
        {
            key: "renderDeckLayers",
            value: function renderDeckLayers() {
                var _this4 = this;
                return this.getAllLayers().map(function(layer) {
                    return layer instanceof $775c05120235343a$var$_nebulaLayer["default"] ? layer.render({
                        nebula: _this4
                    }) : layer;
                }).filter(Boolean);
            }
        },
        {
            key: "getAllLayers",
            value: function getAllLayers() {
                var result = [];
                this.props.layers.filter(Boolean).forEach(function(layer) {
                    result.push(layer); // Only NebulaLayers have helpers, Deck GL layers don't.
                    if (layer instanceof $775c05120235343a$var$_nebulaLayer["default"]) result.push.apply(result, $775c05120235343a$var$_toConsumableArray(layer.helperLayers));
                });
                return result.filter(Boolean);
            }
        },
        {
            key: "getRenderedLayers",
            value: function getRenderedLayers() {
                return [].concat($775c05120235343a$var$_toConsumableArray(this.renderDeckLayers()), $775c05120235343a$var$_toConsumableArray(this.getExtraDeckLayers()));
            }
        },
        {
            key: "updateAndGetRenderedLayers",
            value: function updateAndGetRenderedLayers(layers, viewport, container) {
                if (this.inited) {
                    this.updateProps({
                        layers: layers,
                        viewport: viewport
                    });
                    this.forceUpdate = function() {
                        return container.forceUpdate();
                    };
                } else {
                    this.inited = true;
                    this.init({
                        layers: layers,
                        viewport: viewport
                    });
                    this.forceUpdate = function() {
                        return container.forceUpdate();
                    };
                    this.updateAllDeckObjects();
                }
                return this.getRenderedLayers();
            }
        },
        {
            key: "setDeck",
            value: function setDeck(deckgl) {
                if (deckgl) this.deckgl = deckgl;
            }
        },
        {
            key: "setMainContainer",
            value: function setMainContainer(mainContainer) {
                if (mainContainer) this.mainContainer = mainContainer;
            }
        }
    ]);
    return Nebula;
}();
module.exports["default"] = $775c05120235343a$var$Nebula;

});
parcelRegister("f6y2O", function(module, exports) {
var $aff1d311f28a6c5c$var$topLevel = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : {};

var $5tWFo = parcelRequire("5tWFo");
var $aff1d311f28a6c5c$var$doccy;
if (typeof document !== "undefined") $aff1d311f28a6c5c$var$doccy = document;
else {
    $aff1d311f28a6c5c$var$doccy = $aff1d311f28a6c5c$var$topLevel["__GLOBAL_DOCUMENT_CACHE@4"];
    if (!$aff1d311f28a6c5c$var$doccy) $aff1d311f28a6c5c$var$doccy = $aff1d311f28a6c5c$var$topLevel["__GLOBAL_DOCUMENT_CACHE@4"] = $5tWFo;
}
module.exports = $aff1d311f28a6c5c$var$doccy;

});




parcelRegister("gABF7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c13d391174fda24e$export$2e2bcd8739ae039; });

var $cr2GM = parcelRequire("cr2GM");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $gOgWf = parcelRequire("gOgWf");

var $fBBlk = parcelRequire("fBBlk");

var $9O4Sc = parcelRequire("9O4Sc");

var $iuVwc = parcelRequire("iuVwc");

var $lxEiN = parcelRequire("lxEiN");

var $fuiMG = parcelRequire("fuiMG");
class $c13d391174fda24e$var$FeatureSettingsStore {
    setProperty(id, field, value) {
        const newProperties = [
            ...this.properties
        ];
        const idx = newProperties.findIndex((item)=>item.id === id);
        if (idx !== -1) {
            if (field === "name") newProperties[idx].name = value;
            else if (field === "value") newProperties[idx].value = value;
            else newProperties[idx].value = value;
        } else if ([
            "_opacity"
        ].includes(id)) newProperties.push({
            value: value,
            id: id,
            name: id
        });
        this.properties = newProperties;
    }
    get isBuilding() {
        var _this_id;
        return (_this_id = this.id) === null || _this_id === void 0 ? void 0 : _this_id.startsWith("pb_");
    }
    get heightInFeet() {
        return Math.round(this.height * 3.28084);
    }
    get elevationInFeet() {
        return Math.round(this.elevation * 3.28084);
    }
    get selectedColor() {
        const { color: color, allColors: allColors } = this;
        const item = allColors.find((c)=>color.slice(0, 3).join() === c.rgb.join());
        return item;
    }
    get opacityPercentage() {
        const value = Math.round(this.color[3] / 255 * 100);
        return value;
    }
    get elevation() {
        return (0, $fuiMG.getElevationFromGeometry)(this.geometry);
    }
    get geoJSON() {
        var _this_layer;
        const properties = [
            ...this.properties
        ].reduce((acc, prop)=>{
            acc[prop.name] = prop.value;
            return acc;
        }, {});
        const feature = {
            id: this.id,
            name: this.name,
            height: this.height,
            color: this.color,
            layer_id: (_this_layer = this.layer) === null || _this_layer === void 0 ? void 0 : _this_layer.id,
            icon: this.icon,
            stroke_width: this.strokeWidth,
            angle: this.angle,
            scale: this.scale,
            geometry: this.geometry,
            properties: properties
        };
        return feature;
    }
    constructor(){
        (0, $cr2GM._)(this, "id", null);
        (0, $cr2GM._)(this, "properties", []);
        (0, $cr2GM._)(this, "metadata", []);
        (0, $cr2GM._)(this, "dataset", null);
        (0, $cr2GM._)(this, "layer", null);
        (0, $cr2GM._)(this, "name", null);
        (0, $cr2GM._)(this, "height", 0);
        (0, $cr2GM._)(this, "scale", 1);
        (0, $cr2GM._)(this, "strokeWidth", 1);
        (0, $cr2GM._)(this, "color", [
            0,
            112,
            255,
            255
        ]);
        (0, $cr2GM._)(this, "icon", null);
        (0, $cr2GM._)(this, "layerId", null);
        (0, $cr2GM._)(this, "isLoading", true);
        (0, $cr2GM._)(this, "geometry", null);
        (0, $cr2GM._)(this, "angle", 0);
        (0, $cr2GM._)(this, "bbox", null);
        (0, $cr2GM._)(this, "allColors", Object.entries($9O4Sc).reduce((acc, [key, val])=>{
            if (key === "common") return acc;
            if (key.split(/(?=[A-Z])/).length > 1) return acc;
            const label = key.charAt(0).toUpperCase() + key.slice(1);
            const value = val[400];
            const rgb = (0, $fuiMG.hexToRgb)(value);
            if (rgb) acc.push({
                label: label,
                value: value,
                rgb: rgb
            });
            return acc;
        }, [
            {
                label: "Dark Blue (Default)",
                value: "#0070FF",
                rgb: (0, $fuiMG.hexToRgb)("#0070FF")
            },
            {
                label: "Orange (CHP)",
                value: "#ff6c00",
                rgb: (0, $fuiMG.hexToRgb)("#ff6c00")
            },
            {
                label: "Blue (Fuel Cell)",
                value: "#01A3FF",
                rgb: (0, $fuiMG.hexToRgb)("#01A3FF")
            },
            {
                label: "Green (Storage)",
                value: "#05D748",
                rgb: (0, $fuiMG.hexToRgb)("#05D748")
            },
            {
                label: "Yellow (Solar)",
                value: "#FFBC00",
                rgb: (0, $fuiMG.hexToRgb)("#FFBC00")
            }
        ]));
        (0, $cr2GM._)(this, "loadFeature", async (datasetId, featureId)=>{
            var _response_data, _EditorStore_currentDataset, _feature_dataset, _EditorStore_currentLayer, _feature_layer;
            this.isLoading = true;
            this.id = null;
            this.strokeWidth = 1;
            this.angle = 0;
            this.scale = 1;
            this.name = null;
            this.dataset = null;
            this.geometry = null;
            this.icon = null;
            this.layer = null;
            this.color = [
                0,
                112,
                255,
                255
            ];
            this.height = 1;
            this.layerId = null;
            this.layer = null;
            this.bbox = null;
            this.properties = [];
            this.metadata = [];
            if (datasetId === null) {
                this.isLoading = false;
                return;
            }
            const response = await (0, $lxEiN.default).Dataset.getFeature(datasetId, featureId);
            const feature = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data;
            if (!feature) {
                console.error(`No Feature Found`);
                return;
            }
            this.dataset = feature.dataset;
            this.layer = feature.layer;
            this.bbox = feature.bbox;
            this.name = feature.name;
            this.layer = feature.layer;
            this.icon = feature.icon;
            this.strokeWidth = feature.stroke_width;
            this.angle = feature.angle || 0;
            this.scale = feature.scale || 1;
            this.height = feature.height || 0;
            if (feature.color) this.color = feature.color;
            if (((_EditorStore_currentDataset = (0, $iuVwc.default).currentDataset) === null || _EditorStore_currentDataset === void 0 ? void 0 : _EditorStore_currentDataset.id) !== ((_feature_dataset = feature.dataset) === null || _feature_dataset === void 0 ? void 0 : _feature_dataset.id)) (0, $iuVwc.default).currentDataset = feature.dataset;
            if (((_EditorStore_currentLayer = (0, $iuVwc.default).currentLayer) === null || _EditorStore_currentLayer === void 0 ? void 0 : _EditorStore_currentLayer.id) !== ((_feature_layer = feature.layer) === null || _feature_layer === void 0 ? void 0 : _feature_layer.id)) (0, $iuVwc.default).currentLayer = feature.layer;
            this.geometry = feature.geometry;
            this.properties = Object.entries(feature.properties).reduce((acc, kv, idx)=>{
                const [name, value] = kv;
                const id = `${idx + 1}`;
                acc.push({
                    id: id,
                    name: name,
                    value: value
                });
                return acc;
            }, []);
            if (feature.properties.project_id) this.projectId = feature.properties.project_id;
            this.id = feature.id;
            this.layerId = feature.layer_id;
            // this.setProperties(properties);
            this.isLoading = false;
            return response.data.data;
        });
        (0, $cr2GM._)(this, "addProperty", ()=>{
            const row = {
                id: `${this.properties.length + 2}`,
                name: "",
                val: ""
            };
            this.properties = [
                ...this.properties,
                row
            ];
        });
        (0, $cr2GM._)(this, "setLayer", async (layer)=>{
            this.layer = layer;
            // update layer immediately since layer feature count depends on it
            await this.update();
            (0, $iuVwc.default).getDatasetFeatures();
            (0, $iuVwc.default).getLayers();
        });
        (0, $cr2GM._)(this, "setHeight", (value)=>{
            this.height = value;
        });
        (0, $cr2GM._)(this, "setIcon", (value)=>{
            this.icon = value;
        });
        (0, $cr2GM._)(this, "setOpacity", (value)=>{
            this.color = [
                ...this.color.slice(0, 3),
                value
            ];
        });
        (0, $cr2GM._)(this, "setStrokeWidth", (value)=>{
            this.strokeWidth = value;
        });
        (0, $cr2GM._)(this, "setElevation", (value)=>{
            this.geometry = (0, $fuiMG.elevateGeometry)(this.geometry, value);
        });
        (0, $cr2GM._)(this, "setName", (name)=>{
            this.name = name;
        });
        (0, $cr2GM._)(this, "setScale", (scale)=>{
            this.scale = scale;
        });
        (0, $cr2GM._)(this, "setColor", (value)=>{
            let rgb = value;
            if (value.startsWith("#")) rgb = (0, $fuiMG.hexToRgb)(value);
            this.color = [
                ...rgb,
                this.color[3]
            ];
        });
        (0, $cr2GM._)(this, "update", async ()=>{
            const feature = this.geoJSON;
            try {
                var _res_data_data, _res_data;
                const res = await (0, $lxEiN.default).Dataset.updateFeature(this.dataset.id, feature);
                if ((_res_data = res.data) === null || _res_data === void 0 ? void 0 : (_res_data_data = _res_data.data) === null || _res_data_data === void 0 ? void 0 : _res_data_data.area_in_sq_meters) {
                    const area = res.data.data.area_in_sq_meters;
                    const areaInSqFeet = (area * 10.76391).toFixed(2);
                    // const areaInSqMetersIndex = this.metadata.findIndex(
                    //   item => item.label === 'area in sq meters'
                    // );
                    const areaInSqFeetIndex = this.metadata.findIndex((item)=>item.label === "Area");
                    // if (areaInSqMetersIndex !== -1) {
                    //   this.metadata[areaInSqMetersIndex].value = area;
                    // } else {
                    //   this.metadata.push({
                    //     label: 'area in sq meters',
                    //     value: area
                    //   });
                    // }
                    if (areaInSqFeetIndex !== -1) this.metadata[areaInSqFeetIndex].value = areaInSqFeet;
                    else this.metadata.push({
                        label: "Area",
                        value: `${areaInSqFeet} ft\xb2`
                    });
                }
            } catch (error) {
                console.error(error);
            }
        });
        (0, $cr2GM._)(this, "deleteProperty", (itemId)=>{
            const newProperties = [
                ...this.properties
            ].filter((item)=>item.id !== itemId);
            this.properties = newProperties;
        });
        (0, $cr2GM._)(this, "setGeometry", (geometry)=>{
            this.geometry = geometry;
        });
        (0, $cr2GM._)(this, "setAngle", (angle)=>{
            this.angle = angle;
        });
        (0, $cr2GM._)(this, "getProperties", ()=>{
            return this.properties.reduce((acc, val)=>{
                acc[val.name] = val.value;
                return acc;
            }, {});
        });
        (0, $cr2GM._)(this, "deleteFeature", async ()=>{
            // this.features.delete(featureId);
            // agent.Dataset.deleteFeature(this.dataset.id, this.id);
            await (0, $iuVwc.default).deleteFeature(this.id);
            this.loadFeature(null);
        });
        (0, $cr2GM._)(this, "getId", ()=>{
            return this.id;
        });
        (0, $cr2GM._)(this, "duplicate", async ()=>{
            const feature = this.geoJSON;
            const response = await (0, $lxEiN.default).Dataset.createFeature(this.dataset.id, (0, $edHbI._)((0, $2QP2i._)({}, feature), {
                id: null
            }));
            const { id: id } = response.data.data;
            return id;
        });
        (0, $gOgWf.makeObservable)(this, {
            id: (0, $gOgWf.observable),
            properties: (0, $gOgWf.observable),
            metadata: (0, $gOgWf.observable),
            dataset: (0, $gOgWf.observable),
            layer: (0, $gOgWf.observable),
            name: (0, $gOgWf.observable),
            height: (0, $gOgWf.observable),
            scale: (0, $gOgWf.observable),
            strokeWidth: (0, $gOgWf.observable),
            angle: (0, $gOgWf.observable),
            color: (0, $gOgWf.observable),
            icon: (0, $gOgWf.observable),
            layerId: (0, $gOgWf.observable),
            isLoading: (0, $gOgWf.observable),
            geometry: (0, $gOgWf.observable),
            bbox: (0, $gOgWf.observable),
            loadFeature: (0, $gOgWf.action),
            setProperty: (0, $gOgWf.action),
            addProperty: (0, $gOgWf.action),
            setLayer: (0, $gOgWf.action),
            setHeight: (0, $gOgWf.action),
            setIcon: (0, $gOgWf.action),
            setOpacity: (0, $gOgWf.action),
            setStrokeWidth: (0, $gOgWf.action),
            setElevation: (0, $gOgWf.action),
            setName: (0, $gOgWf.action),
            setScale: (0, $gOgWf.action),
            setColor: (0, $gOgWf.action),
            isBuilding: (0, $gOgWf.computed),
            heightInFeet: (0, $gOgWf.computed),
            elevationInFeet: (0, $gOgWf.computed),
            selectedColor: (0, $gOgWf.computed),
            opacityPercentage: (0, $gOgWf.computed),
            elevation: (0, $gOgWf.computed),
            geoJSON: (0, $gOgWf.computed),
            update: (0, $gOgWf.action),
            deleteProperty: (0, $gOgWf.action),
            setGeometry: (0, $gOgWf.action),
            getProperties: (0, $gOgWf.action),
            deleteFeature: (0, $gOgWf.action),
            getId: (0, $gOgWf.action),
            duplicate: (0, $gOgWf.action)
        });
    }
}
const $c13d391174fda24e$var$store = new $c13d391174fda24e$var$FeatureSettingsStore();
const $c13d391174fda24e$var$debouncedUpdate = (0, $fBBlk.debounce)($c13d391174fda24e$var$store.update, 200);
(0, $gOgWf.reaction)(()=>JSON.stringify([
        $c13d391174fda24e$var$store.color,
        $c13d391174fda24e$var$store.icon,
        $c13d391174fda24e$var$store.height,
        $c13d391174fda24e$var$store.properties,
        $c13d391174fda24e$var$store.strokeWidth,
        $c13d391174fda24e$var$store.name,
        $c13d391174fda24e$var$store.geometry,
        $c13d391174fda24e$var$store.scale,
        $c13d391174fda24e$var$store.angle
    ]), ()=>{
    if ($c13d391174fda24e$var$store.id && !$c13d391174fda24e$var$store.isLoading) $c13d391174fda24e$var$debouncedUpdate();
});
var $c13d391174fda24e$export$2e2bcd8739ae039 = $c13d391174fda24e$var$store;

});
parcelRegister("9O4Sc", function(module, exports) {

$parcel$export(module.exports, "common", function () { return (parcelRequire("AC97U")).default; });
$parcel$export(module.exports, "red", function () { return (parcelRequire("d39yA")).default; });
$parcel$export(module.exports, "pink", function () { return (parcelRequire("gffu7")).default; });
$parcel$export(module.exports, "purple", function () { return (parcelRequire("jibMW")).default; });
$parcel$export(module.exports, "deepPurple", function () { return (parcelRequire("1YKA1")).default; });
$parcel$export(module.exports, "indigo", function () { return (parcelRequire("hpUOc")).default; });
$parcel$export(module.exports, "blue", function () { return (parcelRequire("aXDgw")).default; });
$parcel$export(module.exports, "lightBlue", function () { return (parcelRequire("8mydd")).default; });
$parcel$export(module.exports, "cyan", function () { return (parcelRequire("dl52B")).default; });
$parcel$export(module.exports, "teal", function () { return (parcelRequire("7Pmfg")).default; });
$parcel$export(module.exports, "green", function () { return (parcelRequire("du1yB")).default; });
$parcel$export(module.exports, "lightGreen", function () { return (parcelRequire("16VSS")).default; });
$parcel$export(module.exports, "lime", function () { return (parcelRequire("hd6af")).default; });
$parcel$export(module.exports, "yellow", function () { return (parcelRequire("hpI6i")).default; });
$parcel$export(module.exports, "amber", function () { return (parcelRequire("j2BR8")).default; });
$parcel$export(module.exports, "orange", function () { return (parcelRequire("1QBMq")).default; });
$parcel$export(module.exports, "deepOrange", function () { return (parcelRequire("i0zMe")).default; });
$parcel$export(module.exports, "brown", function () { return (parcelRequire("gs1fu")).default; });
$parcel$export(module.exports, "grey", function () { return (parcelRequire("eYsCg")).default; });
$parcel$export(module.exports, "blueGrey", function () { return (parcelRequire("d9jmQ")).default; });

var $AC97U = parcelRequire("AC97U");

var $d39yA = parcelRequire("d39yA");

var $gffu7 = parcelRequire("gffu7");

var $jibMW = parcelRequire("jibMW");

var $1YKA1 = parcelRequire("1YKA1");

var $hpUOc = parcelRequire("hpUOc");

var $aXDgw = parcelRequire("aXDgw");

var $8mydd = parcelRequire("8mydd");

var $dl52B = parcelRequire("dl52B");

var $7Pmfg = parcelRequire("7Pmfg");

var $du1yB = parcelRequire("du1yB");

var $16VSS = parcelRequire("16VSS");

var $hd6af = parcelRequire("hd6af");

var $hpI6i = parcelRequire("hpI6i");

var $j2BR8 = parcelRequire("j2BR8");

var $1QBMq = parcelRequire("1QBMq");

var $i0zMe = parcelRequire("i0zMe");

var $gs1fu = parcelRequire("gs1fu");

var $eYsCg = parcelRequire("eYsCg");

var $d9jmQ = parcelRequire("d9jmQ");

});
parcelRegister("gffu7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd3a0f013ffc105e$export$2e2bcd8739ae039; });
const $bd3a0f013ffc105e$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $bd3a0f013ffc105e$export$2e2bcd8739ae039 = $bd3a0f013ffc105e$var$pink;

});

parcelRegister("1YKA1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $170f86d891dbc44b$export$2e2bcd8739ae039; });
const $170f86d891dbc44b$var$deepPurple = {
    50: "#ede7f6",
    100: "#d1c4e9",
    200: "#b39ddb",
    300: "#9575cd",
    400: "#7e57c2",
    500: "#673ab7",
    600: "#5e35b1",
    700: "#512da8",
    800: "#4527a0",
    900: "#311b92",
    A100: "#b388ff",
    A200: "#7c4dff",
    A400: "#651fff",
    A700: "#6200ea"
};
var $170f86d891dbc44b$export$2e2bcd8739ae039 = $170f86d891dbc44b$var$deepPurple;

});

parcelRegister("hpUOc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cae0d67dfcbfd89c$export$2e2bcd8739ae039; });
const $cae0d67dfcbfd89c$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $cae0d67dfcbfd89c$export$2e2bcd8739ae039 = $cae0d67dfcbfd89c$var$indigo;

});

parcelRegister("dl52B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b61258ef475f839$export$2e2bcd8739ae039; });
const $9b61258ef475f839$var$cyan = {
    50: "#e0f7fa",
    100: "#b2ebf2",
    200: "#80deea",
    300: "#4dd0e1",
    400: "#26c6da",
    500: "#00bcd4",
    600: "#00acc1",
    700: "#0097a7",
    800: "#00838f",
    900: "#006064",
    A100: "#84ffff",
    A200: "#18ffff",
    A400: "#00e5ff",
    A700: "#00b8d4"
};
var $9b61258ef475f839$export$2e2bcd8739ae039 = $9b61258ef475f839$var$cyan;

});

parcelRegister("7Pmfg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b2e8d455d49ac36$export$2e2bcd8739ae039; });
const $5b2e8d455d49ac36$var$teal = {
    50: "#e0f2f1",
    100: "#b2dfdb",
    200: "#80cbc4",
    300: "#4db6ac",
    400: "#26a69a",
    500: "#009688",
    600: "#00897b",
    700: "#00796b",
    800: "#00695c",
    900: "#004d40",
    A100: "#a7ffeb",
    A200: "#64ffda",
    A400: "#1de9b6",
    A700: "#00bfa5"
};
var $5b2e8d455d49ac36$export$2e2bcd8739ae039 = $5b2e8d455d49ac36$var$teal;

});

parcelRegister("16VSS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf340949fa0ec51$export$2e2bcd8739ae039; });
const $0cf340949fa0ec51$var$lightGreen = {
    50: "#f1f8e9",
    100: "#dcedc8",
    200: "#c5e1a5",
    300: "#aed581",
    400: "#9ccc65",
    500: "#8bc34a",
    600: "#7cb342",
    700: "#689f38",
    800: "#558b2f",
    900: "#33691e",
    A100: "#ccff90",
    A200: "#b2ff59",
    A400: "#76ff03",
    A700: "#64dd17"
};
var $0cf340949fa0ec51$export$2e2bcd8739ae039 = $0cf340949fa0ec51$var$lightGreen;

});

parcelRegister("hd6af", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8786ea9df4c5900$export$2e2bcd8739ae039; });
const $c8786ea9df4c5900$var$lime = {
    50: "#f9fbe7",
    100: "#f0f4c3",
    200: "#e6ee9c",
    300: "#dce775",
    400: "#d4e157",
    500: "#cddc39",
    600: "#c0ca33",
    700: "#afb42b",
    800: "#9e9d24",
    900: "#827717",
    A100: "#f4ff81",
    A200: "#eeff41",
    A400: "#c6ff00",
    A700: "#aeea00"
};
var $c8786ea9df4c5900$export$2e2bcd8739ae039 = $c8786ea9df4c5900$var$lime;

});

parcelRegister("hpI6i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cad6fae92a8b2f5e$export$2e2bcd8739ae039; });
const $cad6fae92a8b2f5e$var$yellow = {
    50: "#fffde7",
    100: "#fff9c4",
    200: "#fff59d",
    300: "#fff176",
    400: "#ffee58",
    500: "#ffeb3b",
    600: "#fdd835",
    700: "#fbc02d",
    800: "#f9a825",
    900: "#f57f17",
    A100: "#ffff8d",
    A200: "#ffff00",
    A400: "#ffea00",
    A700: "#ffd600"
};
var $cad6fae92a8b2f5e$export$2e2bcd8739ae039 = $cad6fae92a8b2f5e$var$yellow;

});

parcelRegister("j2BR8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddcb919f8af9f3d4$export$2e2bcd8739ae039; });
const $ddcb919f8af9f3d4$var$amber = {
    50: "#fff8e1",
    100: "#ffecb3",
    200: "#ffe082",
    300: "#ffd54f",
    400: "#ffca28",
    500: "#ffc107",
    600: "#ffb300",
    700: "#ffa000",
    800: "#ff8f00",
    900: "#ff6f00",
    A100: "#ffe57f",
    A200: "#ffd740",
    A400: "#ffc400",
    A700: "#ffab00"
};
var $ddcb919f8af9f3d4$export$2e2bcd8739ae039 = $ddcb919f8af9f3d4$var$amber;

});

parcelRegister("i0zMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1c3faa83bee7597$export$2e2bcd8739ae039; });
const $d1c3faa83bee7597$var$deepOrange = {
    50: "#fbe9e7",
    100: "#ffccbc",
    200: "#ffab91",
    300: "#ff8a65",
    400: "#ff7043",
    500: "#ff5722",
    600: "#f4511e",
    700: "#e64a19",
    800: "#d84315",
    900: "#bf360c",
    A100: "#ff9e80",
    A200: "#ff6e40",
    A400: "#ff3d00",
    A700: "#dd2c00"
};
var $d1c3faa83bee7597$export$2e2bcd8739ae039 = $d1c3faa83bee7597$var$deepOrange;

});

parcelRegister("gs1fu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfa03ad691edecab$export$2e2bcd8739ae039; });
const $bfa03ad691edecab$var$brown = {
    50: "#efebe9",
    100: "#d7ccc8",
    200: "#bcaaa4",
    300: "#a1887f",
    400: "#8d6e63",
    500: "#795548",
    600: "#6d4c41",
    700: "#5d4037",
    800: "#4e342e",
    900: "#3e2723",
    A100: "#d7ccc8",
    A200: "#bcaaa4",
    A400: "#8d6e63",
    A700: "#5d4037"
};
var $bfa03ad691edecab$export$2e2bcd8739ae039 = $bfa03ad691edecab$var$brown;

});

parcelRegister("d9jmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $992b2396cafaf48b$export$2e2bcd8739ae039; });
const $992b2396cafaf48b$var$blueGrey = {
    50: "#eceff1",
    100: "#cfd8dc",
    200: "#b0bec5",
    300: "#90a4ae",
    400: "#78909c",
    500: "#607d8b",
    600: "#546e7a",
    700: "#455a64",
    800: "#37474f",
    900: "#263238",
    A100: "#cfd8dc",
    A200: "#b0bec5",
    A400: "#78909c",
    A700: "#455a64"
};
var $992b2396cafaf48b$export$2e2bcd8739ae039 = $992b2396cafaf48b$var$blueGrey;

});





parcelRegister("7zM2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5841103569e05b41$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $6LrsC = parcelRequire("6LrsC");

var $71Pr4 = parcelRequire("71Pr4");

var $2mnfJ = parcelRequire("2mnfJ");

var $cNmNk = parcelRequire("cNmNk");

var $duaP9 = parcelRequire("duaP9");

var $aAAPW = parcelRequire("aAAPW");

var $54wpe = parcelRequire("54wpe");

var $fTbhH = parcelRequire("fTbhH");

var $1bnPO = parcelRequire("1bnPO");

var $4x3bm = parcelRequire("4x3bm");
const $5841103569e05b41$var$_excluded = [
    "onEnter",
    "onExited"
], $5841103569e05b41$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $5841103569e05b41$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $aAAPW.default)(anchorOrigin.vertical)}${(0, $aAAPW.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $1bnPO.getSnackbarUtilityClass), classes);
};
const $5841103569e05b41$var$SnackbarRoot = (0, $71Pr4.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $aAAPW.default)(ownerState.anchorOrigin.vertical)}${(0, $aAAPW.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = (0, $20MOv.default)({}, !ownerState.isRtl && {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    }, ownerState.isRtl && {
        right: "50%",
        left: "auto",
        transform: "translateX(50%)"
    });
    return (0, $20MOv.default)({
        zIndex: theme.zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $20MOv.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && (0, $20MOv.default)({}, !ownerState.isRtl && {
            left: 24,
            right: "auto"
        }, ownerState.isRtl && {
            right: 24,
            left: "auto"
        }), ownerState.anchorOrigin.horizontal === "right" && (0, $20MOv.default)({}, !ownerState.isRtl && {
            right: 24,
            left: "auto"
        }, ownerState.isRtl && {
            left: 24,
            right: "auto"
        }))
    });
});
const $5841103569e05b41$var$Snackbar = /*#__PURE__*/ $70fFQ.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $2mnfJ.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, TransitionComponent: TransitionComponent = (0, $54wpe.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $79yYo.default)(props.TransitionProps, $5841103569e05b41$var$_excluded), other = (0, $79yYo.default)(props, $5841103569e05b41$var$_excluded2);
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $20MOv.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        isRtl: isRtl
    });
    const classes = $5841103569e05b41$var$useUtilityClasses(ownerState);
    const timerAutoHide = $70fFQ.useRef();
    const [exited, setExited] = $70fFQ.useState(true);
    const handleClose = (0, $duaP9.default)((...args)=>{
        if (onClose) onClose(...args);
    });
    const setAutoHideTimer = (0, $duaP9.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $70fFQ.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $70fFQ.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        handlePause();
    };
    const handleMouseEnter = (event)=>{
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        handleResume();
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    const handleClickAway = (event)=>{
        if (onClose) onClose(event, "clickaway");
    };
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    $70fFQ.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    $70fFQ.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                // IE11, Edge (prior to using Bink?) use 'Esc'
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                {
                    if (onClose) onClose(nativeEvent, "escapeKeyDown");
                }
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        exited,
        open,
        onClose
    ]); // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6LrsC.default), (0, $20MOv.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($5841103569e05b41$var$SnackbarRoot, (0, $20MOv.default)({
            className: (0, $gjktY.default)(classes.root, className),
            onBlur: handleBlur,
            onFocus: handleFocus,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            ownerState: ownerState,
            ref: ref // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            ,
            role: "presentation"
        }, other, {
            children: /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fTbhH.default), (0, $20MOv.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $5841103569e05b41$export$2e2bcd8739ae039 = $5841103569e05b41$var$Snackbar;

});
parcelRegister("gjktY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdfe4f154ca8ef7d$export$2e2bcd8739ae039; });
function $bdfe4f154ca8ef7d$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $bdfe4f154ca8ef7d$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $bdfe4f154ca8ef7d$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = "";
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $bdfe4f154ca8ef7d$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("8dWxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fccf3e7863e4fd1$export$2e2bcd8739ae039; });
function $5fccf3e7863e4fd1$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                if (classes && classes[key]) acc.push(classes[key]);
                acc.push(getUtilityClass(key));
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("6LrsC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ecc6ef49a2f625b$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");


var $iMBVa = parcelRequire("iMBVa");
var $3Fato = parcelRequire("3Fato");
var $4Rshd = parcelRequire("4Rshd");

var $4x3bm = parcelRequire("4x3bm");
function $4ecc6ef49a2f625b$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $4ecc6ef49a2f625b$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click Away Listener](https://mui.com/components/click-away-listener/)
 * - [Menus](https://mui.com/components/menus/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/api/click-away-listener/)
 */ function $4ecc6ef49a2f625b$var$ClickAwayListener(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $70fFQ.useRef(false);
    const nodeRef = $70fFQ.useRef(null);
    const activatedRef = $70fFQ.useRef(false);
    const syntheticEventRef = $70fFQ.useRef(false);
    $70fFQ.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $4Rshd.default)(children.ref, nodeRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $3Fato.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $iMBVa.default)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $4ecc6ef49a2f625b$var$clickedRootScrollbar(event, doc)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $70fFQ.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $4ecc6ef49a2f625b$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $iMBVa.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $70fFQ.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $4ecc6ef49a2f625b$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $iMBVa.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($70fFQ.Fragment, {
        children: /*#__PURE__*/ $70fFQ.cloneElement(children, childrenProps)
    });
}
var $4ecc6ef49a2f625b$export$2e2bcd8739ae039 = $4ecc6ef49a2f625b$var$ClickAwayListener;

});
parcelRegister("iMBVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daca2002b98a27df$export$2e2bcd8739ae039; });
function $daca2002b98a27df$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("3Fato", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aad532a0a761544$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $qEgbK = parcelRequire("qEgbK");
function $2aad532a0a761544$export$2e2bcd8739ae039(fn) {
    const ref = $70fFQ.useRef(fn);
    (0, $qEgbK.default)(()=>{
        ref.current = fn;
    });
    return $70fFQ.useCallback((...args)=>// tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}

});
parcelRegister("qEgbK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0501a8a415b03ebe$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
const $0501a8a415b03ebe$var$useEnhancedEffect = typeof window !== "undefined" ? $70fFQ.useLayoutEffect : $70fFQ.useEffect;
var $0501a8a415b03ebe$export$2e2bcd8739ae039 = $0501a8a415b03ebe$var$useEnhancedEffect;

});


parcelRegister("4Rshd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38a20bd12982da9e$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $eSJYK = parcelRequire("eSJYK");
function $38a20bd12982da9e$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $70fFQ.useMemo(()=>{
        if (refA == null && refB == null) return null;
        return (refValue)=>{
            (0, $eSJYK.default)(refA, refValue);
            (0, $eSJYK.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("eSJYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad59c641d95a91b2$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $ad59c641d95a91b2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("71Pr4", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $51e08670a2a83030$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $51e08670a2a83030$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $51e08670a2a83030$export$2e2bcd8739ae039; });

var $X2XUj = parcelRequire("X2XUj");

var $7Rxn3 = parcelRequire("7Rxn3");
const $51e08670a2a83030$export$effb20ecdbf4d6aa = (prop)=>(0, $X2XUj.shouldForwardProp)(prop) && prop !== "classes";
const $51e08670a2a83030$export$f10c5a10d27438e5 = (0, $X2XUj.shouldForwardProp);
const $51e08670a2a83030$var$styled = (0, $X2XUj.default)({
    defaultTheme: $7Rxn3.default,
    rootShouldForwardProp: $51e08670a2a83030$export$effb20ecdbf4d6aa
});
var $51e08670a2a83030$export$2e2bcd8739ae039 = $51e08670a2a83030$var$styled;

});
parcelRegister("X2XUj", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $0b17cfa38c1b3ae4$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $0b17cfa38c1b3ae4$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $iGWDe = parcelRequire("iGWDe");


var $ketPc = parcelRequire("ketPc");

var $4MfEP = parcelRequire("4MfEP");

var $5CMDM = parcelRequire("5CMDM");
const $0b17cfa38c1b3ae4$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
], $0b17cfa38c1b3ae4$var$_excluded2 = [
    "theme"
], $0b17cfa38c1b3ae4$var$_excluded3 = [
    "theme"
];
function $0b17cfa38c1b3ae4$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
const $0b17cfa38c1b3ae4$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $0b17cfa38c1b3ae4$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $4MfEP.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $0b17cfa38c1b3ae4$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $4MfEP.default)(themeVariant.props)]);
    });
    return variantsStyles;
}; // Update /system/styled/#api in case if this changes
function $0b17cfa38c1b3ae4$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $0b17cfa38c1b3ae4$export$35e57303dbd8a66 = (0, $ketPc.default)();
const $0b17cfa38c1b3ae4$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0b17cfa38c1b3ae4$export$2e2bcd8739ae039(input = {}) {
    const { defaultTheme: defaultTheme = $0b17cfa38c1b3ae4$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0b17cfa38c1b3ae4$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0b17cfa38c1b3ae4$export$3ba67b570e26eea0, styleFunctionSx: styleFunctionSx = (0, $5CMDM.default) } = input;
    return (tag, inputOptions = {})=>{
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: overridesResolver } = inputOptions, options = (0, $79yYo.default)(inputOptions, $0b17cfa38c1b3ae4$var$_excluded); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0b17cfa38c1b3ae4$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        const defaultStyledResolver = (0, $iGWDe.default)(tag, (0, $20MOv.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                // eslint-disable-next-line no-underscore-dangle
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (_ref)=>{
                    let { theme: themeInput } = _ref, other = (0, $79yYo.default)(_ref, $0b17cfa38c1b3ae4$var$_excluded2);
                    return stylesArg((0, $20MOv.default)({
                        theme: $0b17cfa38c1b3ae4$var$isEmpty(themeInput) ? defaultTheme : themeInput
                    }, other));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0b17cfa38c1b3ae4$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                const styleOverrides = $0b17cfa38c1b3ae4$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle(props) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0b17cfa38c1b3ae4$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                return $0b17cfa38c1b3ae4$var$variantsResolver(props, $0b17cfa38c1b3ae4$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0b17cfa38c1b3ae4$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                return styleFunctionSx((0, $20MOv.default)({}, props, {
                    theme: theme
                }));
            });
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill(""); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            // eslint-disable-next-line no-underscore-dangle
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (_ref2)=>{
                let { theme: themeInput } = _ref2, other = (0, $79yYo.default)(_ref2, $0b17cfa38c1b3ae4$var$_excluded3);
                return styleArg((0, $20MOv.default)({
                    theme: $0b17cfa38c1b3ae4$var$isEmpty(themeInput) ? defaultTheme : themeInput
                }, other));
            };
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("iGWDe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9b9a14886b55763$export$2e2bcd8739ae039; });
/** @license MUI v5.5.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2ptPP = parcelRequire("2ptPP");

var $l1z3A = parcelRequire("l1z3A");
var $e5Z97 = parcelRequire("e5Z97");

var $lM6lR = parcelRequire("lM6lR");

var $lpQxs = parcelRequire("lpQxs");
function $d9b9a14886b55763$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $2ptPP.default)(tag, options);
    var styles, style;
    return stylesFactory;
}

});
parcelRegister("2ptPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c150f2cead177ea$export$2e2bcd8739ae039; });
parcelRequire("2i5nE");
parcelRequire("70fFQ");
parcelRequire("2YPJB");

var $3iac0 = parcelRequire("3iac0");

parcelRequire("jJpXM");
parcelRequire("asszK");
var $1c150f2cead177ea$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $1c150f2cead177ea$var$newStyled = (0, $3iac0.default).bind();
$1c150f2cead177ea$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $1c150f2cead177ea$var$newStyled[tagName] = $1c150f2cead177ea$var$newStyled(tagName);
});
var $1c150f2cead177ea$export$2e2bcd8739ae039 = $1c150f2cead177ea$var$newStyled;

});
parcelRegister("2YPJB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22b950c0141a4b00$export$2e2bcd8739ae039; });

var $fWAyu = parcelRequire("fWAyu");
var $22b950c0141a4b00$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $22b950c0141a4b00$var$isPropValid = /* #__PURE__ */ (0, $fWAyu.default)(function(prop) {
    return $22b950c0141a4b00$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $22b950c0141a4b00$export$2e2bcd8739ae039 = $22b950c0141a4b00$var$isPropValid;

});

parcelRegister("3iac0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $265af59acc099ace$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");

var $2YPJB = parcelRequire("2YPJB");
parcelRequire("l1z3A");
var $e5Z97 = parcelRequire("e5Z97");

var $jJpXM = parcelRequire("jJpXM");

var $asszK = parcelRequire("asszK");
var $265af59acc099ace$var$testOmitPropsOnStringTag = (0, $2YPJB.default);
var $265af59acc099ace$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $265af59acc099ace$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $265af59acc099ace$var$testOmitPropsOnStringTag : $265af59acc099ace$var$testOmitPropsOnComponent;
};
var $265af59acc099ace$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $265af59acc099ace$var$useInsertionEffect = $70fFQ.useInsertionEffect ? $70fFQ.useInsertionEffect : function useInsertionEffect(create) {
    create();
};
function $265af59acc099ace$var$useInsertionEffectMaybe(create) {
    $265af59acc099ace$var$useInsertionEffect(create);
}
var $265af59acc099ace$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $265af59acc099ace$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $jJpXM.registerStyles)(cache, serialized, isStringTag);
    var rules = $265af59acc099ace$var$useInsertionEffectMaybe(function() {
        return (0, $jJpXM.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $265af59acc099ace$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $265af59acc099ace$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $265af59acc099ace$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $e5Z97.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $70fFQ.useContext)((0, $e5Z97.T));
            }
            if (typeof props.className === "string") className = (0, $jJpXM.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $asszK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $265af59acc099ace$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $70fFQ.createElement)((0, $70fFQ.Fragment), null, /*#__PURE__*/ (0, $70fFQ.createElement)($265af59acc099ace$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ (0, $70fFQ.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $20MOv.default)({}, options, nextOptions, {
                shouldForwardProp: $265af59acc099ace$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $265af59acc099ace$export$2e2bcd8739ae039 = $265af59acc099ace$var$createStyled;

});


parcelRegister("lpQxs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f974afd82160e271$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");


var $l1z3A = parcelRequire("l1z3A");

var $4x3bm = parcelRequire("4x3bm");
function $f974afd82160e271$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $f974afd82160e271$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($f974afd82160e271$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $l1z3A.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("4MfEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37a7ca5daa74389e$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $9vGQi = parcelRequire("9vGQi");
const $37a7ca5daa74389e$var$_excluded = [
    "variant"
];
function $37a7ca5daa74389e$var$isEmpty(string) {
    return string.length === 0;
}
function $37a7ca5daa74389e$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $79yYo.default)(props, $37a7ca5daa74389e$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $37a7ca5daa74389e$var$isEmpty(classKey) ? props[key] : (0, $9vGQi.default)(props[key]);
        else classKey += `${$37a7ca5daa74389e$var$isEmpty(classKey) ? key : (0, $9vGQi.default)(key)}${(0, $9vGQi.default)(props[key].toString())}`;
    });
    return classKey;
}

});

parcelRegister("5CMDM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41863b62c58fb8f2$export$2e2bcd8739ae039; });

var $bs0XL = parcelRequire("bs0XL");

var $eiC3N = parcelRequire("eiC3N");

var $bXmqm = parcelRequire("bXmqm");
function $41863b62c58fb8f2$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $41863b62c58fb8f2$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
} // eslint-disable-next-line @typescript-eslint/naming-convention
function $41863b62c58fb8f2$export$7d53d8bf2911e013(styleFunctionMapping = (0, $eiC3N.styleFunctionMapping)) {
    const propToStyleFunction = Object.keys(styleFunctionMapping).reduce((acc, styleFnName)=>{
        styleFunctionMapping[styleFnName].filterProps.forEach((propName)=>{
            acc[propName] = styleFunctionMapping[styleFnName];
        });
        return acc;
    }, {});
    function getThemeValue(prop, value, theme) {
        const inputProps = {
            [prop]: value,
            theme: theme
        };
        const styleFunction = propToStyleFunction[prop];
        return styleFunction ? styleFunction(inputProps) : {
            [prop]: value
        };
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // emotion & styled-components will neglect null
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $bXmqm.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $41863b62c58fb8f2$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (propToStyleFunction[styleKey]) css = (0, $bs0XL.default)(css, getThemeValue(styleKey, value, theme));
                        else {
                            const breakpointsValues = (0, $bXmqm.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($41863b62c58fb8f2$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $bs0XL.default)(css, breakpointsValues);
                        }
                    } else css = (0, $bs0XL.default)(css, getThemeValue(styleKey, value, theme));
                }
            });
            return (0, $bXmqm.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $41863b62c58fb8f2$var$styleFunctionSx = $41863b62c58fb8f2$export$7d53d8bf2911e013();
$41863b62c58fb8f2$var$styleFunctionSx.filterProps = [
    "sx"
];
var $41863b62c58fb8f2$export$2e2bcd8739ae039 = $41863b62c58fb8f2$var$styleFunctionSx;

});
parcelRegister("eiC3N", function(module, exports) {

$parcel$export(module.exports, "styleFunctionMapping", function () { return $a690451f7002e152$export$40acc74e51be579a; });
$parcel$export(module.exports, "propToStyleFunction", function () { return $a690451f7002e152$export$2ec640062268c7c4; });

var $97tH1 = parcelRequire("97tH1");

var $ik28E = parcelRequire("ik28E");

var $iODQ9 = parcelRequire("iODQ9");

var $1qnM1 = parcelRequire("1qnM1");

var $fJcR6 = parcelRequire("fJcR6");

var $8zwD3 = parcelRequire("8zwD3");

var $4pbgV = parcelRequire("4pbgV");

var $28fpZ = parcelRequire("28fpZ");

var $eHQ84 = parcelRequire("eHQ84");

var $YcRIZ = parcelRequire("YcRIZ");
const $a690451f7002e152$var$filterPropsMapping = {
    borders: (0, $97tH1.default).filterProps,
    display: (0, $ik28E.default).filterProps,
    flexbox: (0, $iODQ9.default).filterProps,
    grid: (0, $1qnM1.default).filterProps,
    positions: (0, $fJcR6.default).filterProps,
    palette: (0, $8zwD3.default).filterProps,
    shadows: (0, $4pbgV.default).filterProps,
    sizing: (0, $28fpZ.default).filterProps,
    spacing: (0, $eHQ84.default).filterProps,
    typography: (0, $YcRIZ.default).filterProps
};
const $a690451f7002e152$export$40acc74e51be579a = {
    borders: $97tH1.default,
    display: $ik28E.default,
    flexbox: $iODQ9.default,
    grid: $1qnM1.default,
    positions: $fJcR6.default,
    palette: $8zwD3.default,
    shadows: $4pbgV.default,
    sizing: $28fpZ.default,
    spacing: $eHQ84.default,
    typography: $YcRIZ.default
};
const $a690451f7002e152$export$2ec640062268c7c4 = Object.keys($a690451f7002e152$var$filterPropsMapping).reduce((acc, styleFnName)=>{
    $a690451f7002e152$var$filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = $a690451f7002e152$export$40acc74e51be579a[styleFnName];
    });
    return acc;
}, {});
function $a690451f7002e152$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $a690451f7002e152$export$2ec640062268c7c4[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $a690451f7002e152$export$2e2bcd8739ae039 = $a690451f7002e152$var$getThemeValue;

});
parcelRegister("97tH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a3bcce8c57e9eef$export$2e2bcd8739ae039; });


var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");

var $eHQ84 = parcelRequire("eHQ84");

var $bXmqm = parcelRequire("bXmqm");
function $6a3bcce8c57e9eef$var$getBorder(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $6a3bcce8c57e9eef$export$1edee58a52776cd9 = (0, $1sJkf.default)({
    prop: "border",
    themeKey: "borders",
    transform: $6a3bcce8c57e9eef$var$getBorder
});
const $6a3bcce8c57e9eef$export$f9a7b6bd24892946 = (0, $1sJkf.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $6a3bcce8c57e9eef$var$getBorder
});
const $6a3bcce8c57e9eef$export$5abca33e6be905d2 = (0, $1sJkf.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $6a3bcce8c57e9eef$var$getBorder
});
const $6a3bcce8c57e9eef$export$e2ce9f12a980a822 = (0, $1sJkf.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $6a3bcce8c57e9eef$var$getBorder
});
const $6a3bcce8c57e9eef$export$47658cca1a909427 = (0, $1sJkf.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $6a3bcce8c57e9eef$var$getBorder
});
const $6a3bcce8c57e9eef$export$e7fb0694ba2404fc = (0, $1sJkf.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $6a3bcce8c57e9eef$export$126a92c968acdb85 = (0, $1sJkf.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $6a3bcce8c57e9eef$export$85cc51cb8fbb8c0e = (0, $1sJkf.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $6a3bcce8c57e9eef$export$340b0327727f6d1a = (0, $1sJkf.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $6a3bcce8c57e9eef$export$60beef91a985b4bf = (0, $1sJkf.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $6a3bcce8c57e9eef$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $eHQ84.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $eHQ84.getValue)(transformer, propValue)
            });
        return (0, $bXmqm.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$6a3bcce8c57e9eef$export$7a57f79000377ca2.propTypes = {};
$6a3bcce8c57e9eef$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $6a3bcce8c57e9eef$var$borders = (0, $aia9M.default)($6a3bcce8c57e9eef$export$1edee58a52776cd9, $6a3bcce8c57e9eef$export$f9a7b6bd24892946, $6a3bcce8c57e9eef$export$5abca33e6be905d2, $6a3bcce8c57e9eef$export$e2ce9f12a980a822, $6a3bcce8c57e9eef$export$47658cca1a909427, $6a3bcce8c57e9eef$export$e7fb0694ba2404fc, $6a3bcce8c57e9eef$export$126a92c968acdb85, $6a3bcce8c57e9eef$export$85cc51cb8fbb8c0e, $6a3bcce8c57e9eef$export$340b0327727f6d1a, $6a3bcce8c57e9eef$export$60beef91a985b4bf, $6a3bcce8c57e9eef$export$7a57f79000377ca2);
var $6a3bcce8c57e9eef$export$2e2bcd8739ae039 = $6a3bcce8c57e9eef$var$borders;

});
parcelRegister("aia9M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77e376bf8c5246b9$export$2e2bcd8739ae039; });

var $bs0XL = parcelRequire("bs0XL");
function $77e376bf8c5246b9$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $bs0XL.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $77e376bf8c5246b9$export$2e2bcd8739ae039 = $77e376bf8c5246b9$var$compose;

});


parcelRegister("ik28E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d56bc0f1765d1a28$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");
const $d56bc0f1765d1a28$export$95a5c40fb210fe3e = (0, $1sJkf.default)({
    prop: "displayPrint",
    cssProperty: false,
    transform: (value)=>({
            "@media print": {
                display: value
            }
        })
});
const $d56bc0f1765d1a28$export$e5efd59aba9975ad = (0, $1sJkf.default)({
    prop: "display"
});
const $d56bc0f1765d1a28$export$f6530fb6e67e00bd = (0, $1sJkf.default)({
    prop: "overflow"
});
const $d56bc0f1765d1a28$export$f00f69a6f0e8c5b6 = (0, $1sJkf.default)({
    prop: "textOverflow"
});
const $d56bc0f1765d1a28$export$91fa9ac3f4021ce4 = (0, $1sJkf.default)({
    prop: "visibility"
});
const $d56bc0f1765d1a28$export$9ef81298ca34ad41 = (0, $1sJkf.default)({
    prop: "whiteSpace"
});
var $d56bc0f1765d1a28$export$2e2bcd8739ae039 = (0, $aia9M.default)($d56bc0f1765d1a28$export$95a5c40fb210fe3e, $d56bc0f1765d1a28$export$e5efd59aba9975ad, $d56bc0f1765d1a28$export$f6530fb6e67e00bd, $d56bc0f1765d1a28$export$f00f69a6f0e8c5b6, $d56bc0f1765d1a28$export$91fa9ac3f4021ce4, $d56bc0f1765d1a28$export$9ef81298ca34ad41);

});

parcelRegister("iODQ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db2bccf38673e184$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");
const $db2bccf38673e184$export$d2ad290394bbc49d = (0, $1sJkf.default)({
    prop: "flexBasis"
});
const $db2bccf38673e184$export$84c3c16c9ed6c908 = (0, $1sJkf.default)({
    prop: "flexDirection"
});
const $db2bccf38673e184$export$9a4bcd01f5c204bc = (0, $1sJkf.default)({
    prop: "flexWrap"
});
const $db2bccf38673e184$export$8dea3061ba53bfd1 = (0, $1sJkf.default)({
    prop: "justifyContent"
});
const $db2bccf38673e184$export$898d9006406726bd = (0, $1sJkf.default)({
    prop: "alignItems"
});
const $db2bccf38673e184$export$38c32c6918694134 = (0, $1sJkf.default)({
    prop: "alignContent"
});
const $db2bccf38673e184$export$aaaeab0fac9a3ccb = (0, $1sJkf.default)({
    prop: "order"
});
const $db2bccf38673e184$export$97691fbb80847c19 = (0, $1sJkf.default)({
    prop: "flex"
});
const $db2bccf38673e184$export$36c65c169152373d = (0, $1sJkf.default)({
    prop: "flexGrow"
});
const $db2bccf38673e184$export$2670ac60b02109d2 = (0, $1sJkf.default)({
    prop: "flexShrink"
});
const $db2bccf38673e184$export$4545dd3632cb520b = (0, $1sJkf.default)({
    prop: "alignSelf"
});
const $db2bccf38673e184$export$55e6b7a7f0eaa3ff = (0, $1sJkf.default)({
    prop: "justifyItems"
});
const $db2bccf38673e184$export$d012640ac9a6446f = (0, $1sJkf.default)({
    prop: "justifySelf"
});
const $db2bccf38673e184$var$flexbox = (0, $aia9M.default)($db2bccf38673e184$export$d2ad290394bbc49d, $db2bccf38673e184$export$84c3c16c9ed6c908, $db2bccf38673e184$export$9a4bcd01f5c204bc, $db2bccf38673e184$export$8dea3061ba53bfd1, $db2bccf38673e184$export$898d9006406726bd, $db2bccf38673e184$export$38c32c6918694134, $db2bccf38673e184$export$aaaeab0fac9a3ccb, $db2bccf38673e184$export$97691fbb80847c19, $db2bccf38673e184$export$36c65c169152373d, $db2bccf38673e184$export$2670ac60b02109d2, $db2bccf38673e184$export$4545dd3632cb520b, $db2bccf38673e184$export$55e6b7a7f0eaa3ff, $db2bccf38673e184$export$d012640ac9a6446f);
var $db2bccf38673e184$export$2e2bcd8739ae039 = $db2bccf38673e184$var$flexbox;

});

parcelRegister("1qnM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $109aa9177f13fd8f$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");

var $eHQ84 = parcelRequire("eHQ84");

var $bXmqm = parcelRequire("bXmqm");

const $109aa9177f13fd8f$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $eHQ84.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $eHQ84.getValue)(transformer, propValue)
            });
        return (0, $bXmqm.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$109aa9177f13fd8f$export$5df9adcb0db95e1e.propTypes = {};
$109aa9177f13fd8f$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $109aa9177f13fd8f$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $eHQ84.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $eHQ84.getValue)(transformer, propValue)
            });
        return (0, $bXmqm.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$109aa9177f13fd8f$export$ec60d70ff941a580.propTypes = {};
$109aa9177f13fd8f$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $109aa9177f13fd8f$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $eHQ84.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $eHQ84.getValue)(transformer, propValue)
            });
        return (0, $bXmqm.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$109aa9177f13fd8f$export$8a833ffa5f5dbeda.propTypes = {};
$109aa9177f13fd8f$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $109aa9177f13fd8f$export$baf44164ca3a34e8 = (0, $1sJkf.default)({
    prop: "gridColumn"
});
const $109aa9177f13fd8f$export$8f7213a1cd01e832 = (0, $1sJkf.default)({
    prop: "gridRow"
});
const $109aa9177f13fd8f$export$b0e0abbc49ba668 = (0, $1sJkf.default)({
    prop: "gridAutoFlow"
});
const $109aa9177f13fd8f$export$bcd8b929d4b4142 = (0, $1sJkf.default)({
    prop: "gridAutoColumns"
});
const $109aa9177f13fd8f$export$e5039a674e14c828 = (0, $1sJkf.default)({
    prop: "gridAutoRows"
});
const $109aa9177f13fd8f$export$42bd9088661ffb03 = (0, $1sJkf.default)({
    prop: "gridTemplateColumns"
});
const $109aa9177f13fd8f$export$920682ae05b999bc = (0, $1sJkf.default)({
    prop: "gridTemplateRows"
});
const $109aa9177f13fd8f$export$1b88fbdd482fd33a = (0, $1sJkf.default)({
    prop: "gridTemplateAreas"
});
const $109aa9177f13fd8f$export$bdb486e40d52d26f = (0, $1sJkf.default)({
    prop: "gridArea"
});
const $109aa9177f13fd8f$var$grid = (0, $aia9M.default)($109aa9177f13fd8f$export$5df9adcb0db95e1e, $109aa9177f13fd8f$export$ec60d70ff941a580, $109aa9177f13fd8f$export$8a833ffa5f5dbeda, $109aa9177f13fd8f$export$baf44164ca3a34e8, $109aa9177f13fd8f$export$8f7213a1cd01e832, $109aa9177f13fd8f$export$b0e0abbc49ba668, $109aa9177f13fd8f$export$bcd8b929d4b4142, $109aa9177f13fd8f$export$e5039a674e14c828, $109aa9177f13fd8f$export$42bd9088661ffb03, $109aa9177f13fd8f$export$920682ae05b999bc, $109aa9177f13fd8f$export$1b88fbdd482fd33a, $109aa9177f13fd8f$export$bdb486e40d52d26f);
var $109aa9177f13fd8f$export$2e2bcd8739ae039 = $109aa9177f13fd8f$var$grid;

});

parcelRegister("fJcR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b73507d607106f66$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");
const $b73507d607106f66$export$5880b8b5730aff45 = (0, $1sJkf.default)({
    prop: "position"
});
const $b73507d607106f66$export$56446adcecbeec34 = (0, $1sJkf.default)({
    prop: "zIndex",
    themeKey: "zIndex"
});
const $b73507d607106f66$export$1e95b668f3b82d = (0, $1sJkf.default)({
    prop: "top"
});
const $b73507d607106f66$export$79ffe56a765070d2 = (0, $1sJkf.default)({
    prop: "right"
});
const $b73507d607106f66$export$40e543e69a8b3fbb = (0, $1sJkf.default)({
    prop: "bottom"
});
const $b73507d607106f66$export$eabcd2c8791e7bf4 = (0, $1sJkf.default)({
    prop: "left"
});
var $b73507d607106f66$export$2e2bcd8739ae039 = (0, $aia9M.default)($b73507d607106f66$export$5880b8b5730aff45, $b73507d607106f66$export$56446adcecbeec34, $b73507d607106f66$export$1e95b668f3b82d, $b73507d607106f66$export$79ffe56a765070d2, $b73507d607106f66$export$40e543e69a8b3fbb, $b73507d607106f66$export$eabcd2c8791e7bf4);

});

parcelRegister("8zwD3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63dae70d0592896c$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");
const $63dae70d0592896c$export$35e9368ef982300f = (0, $1sJkf.default)({
    prop: "color",
    themeKey: "palette"
});
const $63dae70d0592896c$export$2506f56c10355b33 = (0, $1sJkf.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette"
});
const $63dae70d0592896c$export$8c5a050822fd698c = (0, $1sJkf.default)({
    prop: "backgroundColor",
    themeKey: "palette"
});
const $63dae70d0592896c$var$palette = (0, $aia9M.default)($63dae70d0592896c$export$35e9368ef982300f, $63dae70d0592896c$export$2506f56c10355b33, $63dae70d0592896c$export$8c5a050822fd698c);
var $63dae70d0592896c$export$2e2bcd8739ae039 = $63dae70d0592896c$var$palette;

});

parcelRegister("4pbgV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33523d97c85915a3$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");
const $33523d97c85915a3$var$boxShadow = (0, $1sJkf.default)({
    prop: "boxShadow",
    themeKey: "shadows"
});
var $33523d97c85915a3$export$2e2bcd8739ae039 = $33523d97c85915a3$var$boxShadow;

});

parcelRegister("28fpZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18d849dcf70f4699$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");

var $bXmqm = parcelRequire("bXmqm");
function $18d849dcf70f4699$var$transform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $18d849dcf70f4699$export$7e3df82ee760448c = (0, $1sJkf.default)({
    prop: "width",
    transform: $18d849dcf70f4699$var$transform
});
const $18d849dcf70f4699$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $bXmqm.values)[propValue];
            return {
                maxWidth: breakpoint || $18d849dcf70f4699$var$transform(propValue)
            };
        };
        return (0, $bXmqm.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$18d849dcf70f4699$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $18d849dcf70f4699$export$ee148fbbe8357dd2 = (0, $1sJkf.default)({
    prop: "minWidth",
    transform: $18d849dcf70f4699$var$transform
});
const $18d849dcf70f4699$export$ac607276a8fe9f0a = (0, $1sJkf.default)({
    prop: "height",
    transform: $18d849dcf70f4699$var$transform
});
const $18d849dcf70f4699$export$dc0d8bd0b94f8570 = (0, $1sJkf.default)({
    prop: "maxHeight",
    transform: $18d849dcf70f4699$var$transform
});
const $18d849dcf70f4699$export$a43cf604e12f3b17 = (0, $1sJkf.default)({
    prop: "minHeight",
    transform: $18d849dcf70f4699$var$transform
});
const $18d849dcf70f4699$export$ffed9f14fb65e276 = (0, $1sJkf.default)({
    prop: "size",
    cssProperty: "width",
    transform: $18d849dcf70f4699$var$transform
});
const $18d849dcf70f4699$export$905076ed6620e671 = (0, $1sJkf.default)({
    prop: "size",
    cssProperty: "height",
    transform: $18d849dcf70f4699$var$transform
});
const $18d849dcf70f4699$export$6ccc93f785106a58 = (0, $1sJkf.default)({
    prop: "boxSizing"
});
const $18d849dcf70f4699$var$sizing = (0, $aia9M.default)($18d849dcf70f4699$export$7e3df82ee760448c, $18d849dcf70f4699$export$488fda99655ff65a, $18d849dcf70f4699$export$ee148fbbe8357dd2, $18d849dcf70f4699$export$ac607276a8fe9f0a, $18d849dcf70f4699$export$dc0d8bd0b94f8570, $18d849dcf70f4699$export$a43cf604e12f3b17, $18d849dcf70f4699$export$6ccc93f785106a58);
var $18d849dcf70f4699$export$2e2bcd8739ae039 = $18d849dcf70f4699$var$sizing;

});

parcelRegister("YcRIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b4f95897bfa58fd$export$2e2bcd8739ae039; });

var $1sJkf = parcelRequire("1sJkf");

var $aia9M = parcelRequire("aia9M");
const $0b4f95897bfa58fd$export$a5975749f0374264 = (0, $1sJkf.default)({
    prop: "fontFamily",
    themeKey: "typography"
});
const $0b4f95897bfa58fd$export$85e3c3ca0c6fb93 = (0, $1sJkf.default)({
    prop: "fontSize",
    themeKey: "typography"
});
const $0b4f95897bfa58fd$export$a827189a08c5a3a3 = (0, $1sJkf.default)({
    prop: "fontStyle",
    themeKey: "typography"
});
const $0b4f95897bfa58fd$export$bc0b29e67df3229e = (0, $1sJkf.default)({
    prop: "fontWeight",
    themeKey: "typography"
});
const $0b4f95897bfa58fd$export$3eb52878e4502ad1 = (0, $1sJkf.default)({
    prop: "letterSpacing"
});
const $0b4f95897bfa58fd$export$d1b52fec4405b471 = (0, $1sJkf.default)({
    prop: "textTransform"
});
const $0b4f95897bfa58fd$export$c9b91427b594e14 = (0, $1sJkf.default)({
    prop: "lineHeight"
});
const $0b4f95897bfa58fd$export$a87999391cd10ae9 = (0, $1sJkf.default)({
    prop: "textAlign"
});
const $0b4f95897bfa58fd$export$60b2982fc282cca6 = (0, $1sJkf.default)({
    prop: "typography",
    cssProperty: false,
    themeKey: "typography"
});
const $0b4f95897bfa58fd$var$typography = (0, $aia9M.default)($0b4f95897bfa58fd$export$60b2982fc282cca6, $0b4f95897bfa58fd$export$a5975749f0374264, $0b4f95897bfa58fd$export$85e3c3ca0c6fb93, $0b4f95897bfa58fd$export$a827189a08c5a3a3, $0b4f95897bfa58fd$export$bc0b29e67df3229e, $0b4f95897bfa58fd$export$3eb52878e4502ad1, $0b4f95897bfa58fd$export$c9b91427b594e14, $0b4f95897bfa58fd$export$a87999391cd10ae9, $0b4f95897bfa58fd$export$d1b52fec4405b471);
var $0b4f95897bfa58fd$export$2e2bcd8739ae039 = $0b4f95897bfa58fd$var$typography;

});





parcelRegister("2mnfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b7fac55b9a74292$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $3yh9K = parcelRequire("3yh9K");

var $7Rxn3 = parcelRequire("7Rxn3");
function $1b7fac55b9a74292$export$2e2bcd8739ae039() {
    const theme = (0, $3yh9K.default)((0, $7Rxn3.default));
    return theme;
}

});

parcelRegister("duaP9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d16791b876690e2$export$2e2bcd8739ae039; });

var $3Fato = parcelRequire("3Fato");
var $9d16791b876690e2$export$2e2bcd8739ae039 = (0, $3Fato.default);

});

parcelRegister("aAAPW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b59d732bf33d3a1$export$2e2bcd8739ae039; });

var $9vGQi = parcelRequire("9vGQi");
var $7b59d732bf33d3a1$export$2e2bcd8739ae039 = (0, $9vGQi.default);

});

parcelRegister("54wpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b1676a4d56f489b$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");



var $dxolJ = parcelRequire("dxolJ");

var $2mnfJ = parcelRequire("2mnfJ");

var $ceSe6 = parcelRequire("ceSe6");

var $5Up1l = parcelRequire("5Up1l");

var $4x3bm = parcelRequire("4x3bm");
const $3b1676a4d56f489b$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $3b1676a4d56f489b$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $3b1676a4d56f489b$var$styles = {
    entering: {
        opacity: 1,
        transform: $3b1676a4d56f489b$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $3b1676a4d56f489b$var$Grow = /*#__PURE__*/ $70fFQ.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $dxolJ.default) } = props, other = (0, $79yYo.default)(props, $3b1676a4d56f489b$var$_excluded);
    const timer = $70fFQ.useRef();
    const autoTimeout = $70fFQ.useRef();
    const theme = (0, $2mnfJ.default)();
    const nodeRef = $70fFQ.useRef(null);
    const foreignRef = (0, $5Up1l.default)(children.ref, ref);
    const handleRef = (0, $5Up1l.default)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $ceSe6.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $3b1676a4d56f489b$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $70fFQ.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $70fFQ.cloneElement(children, (0, $20MOv.default)({
                style: (0, $20MOv.default)({
                    opacity: 0,
                    transform: $3b1676a4d56f489b$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $3b1676a4d56f489b$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$3b1676a4d56f489b$var$Grow.muiSupportAuto = true;
var $3b1676a4d56f489b$export$2e2bcd8739ae039 = $3b1676a4d56f489b$var$Grow;

});
parcelRegister("dxolJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db13ec28496ca72$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $b0Bcw = parcelRequire("b0Bcw");


var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");

var $fbeMJ = parcelRequire("fbeMJ");


var $kZNVB = parcelRequire("kZNVB");
var $9db13ec28496ca72$export$bb38bb9a1161268 = "unmounted";
var $9db13ec28496ca72$export$84cbff306f539230 = "exited";
var $9db13ec28496ca72$export$df38205c966be359 = "entering";
var $9db13ec28496ca72$export$78e9e6e3e014d60a = "entered";
var $9db13ec28496ca72$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9db13ec28496ca72$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $b0Bcw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9db13ec28496ca72$export$84cbff306f539230;
                _this.appearStatus = $9db13ec28496ca72$export$df38205c966be359;
            } else initialStatus = $9db13ec28496ca72$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9db13ec28496ca72$export$bb38bb9a1161268;
        else initialStatus = $9db13ec28496ca72$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9db13ec28496ca72$export$bb38bb9a1161268) return {
            status: $9db13ec28496ca72$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9db13ec28496ca72$export$df38205c966be359 && status !== $9db13ec28496ca72$export$78e9e6e3e014d60a) nextStatus = $9db13ec28496ca72$export$df38205c966be359;
            } else if (status === $9db13ec28496ca72$export$df38205c966be359 || status === $9db13ec28496ca72$export$78e9e6e3e014d60a) nextStatus = $9db13ec28496ca72$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9db13ec28496ca72$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9db13ec28496ca72$export$84cbff306f539230) this.setState({
            status: $9db13ec28496ca72$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $fbeMJ.default).disabled) {
            this.safeSetState({
                status: $9db13ec28496ca72$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9db13ec28496ca72$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9db13ec28496ca72$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $fbeMJ.default).disabled) {
            this.safeSetState({
                status: $9db13ec28496ca72$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9db13ec28496ca72$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9db13ec28496ca72$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9db13ec28496ca72$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $79yYo.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $kZNVB.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
$9db13ec28496ca72$var$Transition.contextType = (0, $kZNVB.default);
$9db13ec28496ca72$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9db13ec28496ca72$var$noop() {}
$9db13ec28496ca72$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9db13ec28496ca72$var$noop,
    onEntering: $9db13ec28496ca72$var$noop,
    onEntered: $9db13ec28496ca72$var$noop,
    onExit: $9db13ec28496ca72$var$noop,
    onExiting: $9db13ec28496ca72$var$noop,
    onExited: $9db13ec28496ca72$var$noop
};
$9db13ec28496ca72$var$Transition.UNMOUNTED = $9db13ec28496ca72$export$bb38bb9a1161268;
$9db13ec28496ca72$var$Transition.EXITED = $9db13ec28496ca72$export$84cbff306f539230;
$9db13ec28496ca72$var$Transition.ENTERING = $9db13ec28496ca72$export$df38205c966be359;
$9db13ec28496ca72$var$Transition.ENTERED = $9db13ec28496ca72$export$78e9e6e3e014d60a;
$9db13ec28496ca72$var$Transition.EXITING = $9db13ec28496ca72$export$4aacc83d4d59139f;
var $9db13ec28496ca72$export$2e2bcd8739ae039 = $9db13ec28496ca72$var$Transition;

});
parcelRegister("b0Bcw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $803c8d214cd5af94$export$2e2bcd8739ae039; });

var $bREB1 = parcelRequire("bREB1");
function $803c8d214cd5af94$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $bREB1.default)(subClass, superClass);
}

});
parcelRegister("bREB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a34227ecc16a73c$export$2e2bcd8739ae039; });
function $8a34227ecc16a73c$export$2e2bcd8739ae039(o, p) {
    $8a34227ecc16a73c$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8a34227ecc16a73c$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("fbeMJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0d35a19ac8db1d9$export$2e2bcd8739ae039; });
var $b0d35a19ac8db1d9$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("kZNVB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4903bd70f38464d$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
var $f4903bd70f38464d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(null);

});


parcelRegister("ceSe6", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $8e90db129429ecba$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $8e90db129429ecba$export$8cb1e9b404609ae9; });
const $8e90db129429ecba$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $8e90db129429ecba$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});

parcelRegister("5Up1l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d5974cfa9f5a1a$export$2e2bcd8739ae039; });

var $4Rshd = parcelRequire("4Rshd");
var $44d5974cfa9f5a1a$export$2e2bcd8739ae039 = (0, $4Rshd.default);

});


parcelRegister("fTbhH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b914bee8273c38c1$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $1mImZ = parcelRequire("1mImZ");

var $14olw = parcelRequire("14olw");

var $4x3bm = parcelRequire("4x3bm");
const $b914bee8273c38c1$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $b914bee8273c38c1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $14olw.getSnackbarContentUtilityClass), classes);
};
const $b914bee8273c38c1$var$SnackbarContentRoot = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $bFVgt.emphasize)(theme.palette.background.default, emphasis);
    return (0, $20MOv.default)({}, theme.typography.body2, {
        color: theme.palette.getContrastText(backgroundColor),
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: theme.shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $b914bee8273c38c1$var$SnackbarContentMessage = (0, $71Pr4.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $b914bee8273c38c1$var$SnackbarContentAction = (0, $71Pr4.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $b914bee8273c38c1$var$SnackbarContent = /*#__PURE__*/ $70fFQ.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $79yYo.default)(props, $b914bee8273c38c1$var$_excluded);
    const ownerState = props;
    const classes = $b914bee8273c38c1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($b914bee8273c38c1$var$SnackbarContentRoot, (0, $20MOv.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($b914bee8273c38c1$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $4x3bm.jsx)($b914bee8273c38c1$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $b914bee8273c38c1$export$2e2bcd8739ae039 = $b914bee8273c38c1$var$SnackbarContent;

});
parcelRegister("1mImZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fea436a9a933368$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");


var $4qR8t = parcelRequire("4qR8t");

var $4x3bm = parcelRequire("4x3bm");
const $0fea436a9a933368$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $0fea436a9a933368$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
const $0fea436a9a933368$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $4qR8t.getPaperUtilityClass), classes);
};
const $0fea436a9a933368$var$PaperRoot = (0, $71Pr4.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${theme.palette.divider}`
    }, ownerState.variant === "elevation" && (0, $20MOv.default)({
        boxShadow: theme.shadows[ownerState.elevation]
    }, theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $bFVgt.alpha)("#fff", $0fea436a9a933368$var$getOverlayAlpha(ownerState.elevation))}, ${(0, $bFVgt.alpha)("#fff", $0fea436a9a933368$var$getOverlayAlpha(ownerState.elevation))})`
    })));
const $0fea436a9a933368$var$Paper = /*#__PURE__*/ $70fFQ.forwardRef(function Paper(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $79yYo.default)(props, $0fea436a9a933368$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $0fea436a9a933368$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($0fea436a9a933368$var$PaperRoot, (0, $20MOv.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref
    }, other));
});
var $0fea436a9a933368$export$2e2bcd8739ae039 = $0fea436a9a933368$var$Paper;

});
parcelRegister("4qR8t", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $33a2cec8ff59aa37$export$29cdb466b9b6f20b; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $33a2cec8ff59aa37$export$29cdb466b9b6f20b(slot) {
    return (0, $dtsUs.default)("MuiPaper", slot);
}
const $33a2cec8ff59aa37$var$paperClasses = (0, $jLqVN.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $33a2cec8ff59aa37$export$2e2bcd8739ae039 = $33a2cec8ff59aa37$var$paperClasses;

});
parcelRegister("dtsUs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cf468a9723d94da$export$2e2bcd8739ae039; });

var $kZEgR = parcelRequire("kZEgR");
const $9cf468a9723d94da$var$globalStateClassesMapping = {
    active: "Mui-active",
    checked: "Mui-checked",
    completed: "Mui-completed",
    disabled: "Mui-disabled",
    error: "Mui-error",
    expanded: "Mui-expanded",
    focused: "Mui-focused",
    focusVisible: "Mui-focusVisible",
    required: "Mui-required",
    selected: "Mui-selected"
};
function $9cf468a9723d94da$export$2e2bcd8739ae039(componentName, slot) {
    const globalStateClass = $9cf468a9723d94da$var$globalStateClassesMapping[slot];
    return globalStateClass || `${(0, $kZEgR.default).generate(componentName)}-${slot}`;
}

});
parcelRegister("kZEgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f488be1aa2aca3a6$export$2e2bcd8739ae039; });
const $f488be1aa2aca3a6$var$defaultGenerator = (componentName)=>componentName;
const $f488be1aa2aca3a6$var$createClassNameGenerator = ()=>{
    let generate = $f488be1aa2aca3a6$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f488be1aa2aca3a6$var$defaultGenerator;
        }
    };
};
const $f488be1aa2aca3a6$var$ClassNameGenerator = $f488be1aa2aca3a6$var$createClassNameGenerator();
var $f488be1aa2aca3a6$export$2e2bcd8739ae039 = $f488be1aa2aca3a6$var$ClassNameGenerator;

});


parcelRegister("jLqVN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6374c162e5db52c$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
function $e6374c162e5db52c$export$2e2bcd8739ae039(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $dtsUs.default)(componentName, slot);
    });
    return result;
}

});



parcelRegister("14olw", function(module, exports) {

$parcel$export(module.exports, "getSnackbarContentUtilityClass", function () { return $0c790cceb9a44f43$export$def81488db1a3216; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $0c790cceb9a44f43$export$def81488db1a3216(slot) {
    return (0, $dtsUs.default)("MuiSnackbarContent", slot);
}
const $0c790cceb9a44f43$var$snackbarContentClasses = (0, $jLqVN.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $0c790cceb9a44f43$export$2e2bcd8739ae039 = $0c790cceb9a44f43$var$snackbarContentClasses;

});


parcelRegister("1bnPO", function(module, exports) {

$parcel$export(module.exports, "getSnackbarUtilityClass", function () { return $0dc94e92eff900db$export$6cb096457f5926f4; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $0dc94e92eff900db$export$6cb096457f5926f4(slot) {
    return (0, $dtsUs.default)("MuiSnackbar", slot);
}
const $0dc94e92eff900db$var$snackbarClasses = (0, $jLqVN.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $0dc94e92eff900db$export$2e2bcd8739ae039 = $0dc94e92eff900db$var$snackbarClasses;

});


parcelRegister("27ZKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18cc21b0f0979073$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $859H5 = parcelRequire("859H5");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $aAAPW = parcelRequire("aAAPW");

var $5aaio = parcelRequire("5aaio");

var $4x3bm = parcelRequire("4x3bm");
const $18cc21b0f0979073$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $18cc21b0f0979073$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $aAAPW.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $5aaio.getTypographyUtilityClass), classes);
};
const $18cc21b0f0979073$export$140e2f5526d3cad8 = (0, $71Pr4.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $aAAPW.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $18cc21b0f0979073$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
}; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $18cc21b0f0979073$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $18cc21b0f0979073$var$transformDeprecatedColors = (color)=>{
    return $18cc21b0f0979073$var$colorTransformations[color] || color;
};
const $18cc21b0f0979073$var$Typography = /*#__PURE__*/ $70fFQ.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $18cc21b0f0979073$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $859H5.default)((0, $20MOv.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $18cc21b0f0979073$var$defaultVariantMapping } = props, other = (0, $79yYo.default)(props, $18cc21b0f0979073$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $18cc21b0f0979073$var$defaultVariantMapping[variant]) || "span";
    const classes = $18cc21b0f0979073$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($18cc21b0f0979073$export$140e2f5526d3cad8, (0, $20MOv.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $gjktY.default)(classes.root, className)
    }, other));
});
var $18cc21b0f0979073$export$2e2bcd8739ae039 = $18cc21b0f0979073$var$Typography;

});
parcelRegister("859H5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e264f5f8308376f$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $jWrHX = parcelRequire("jWrHX");

var $eiC3N = parcelRequire("eiC3N");
const $5e264f5f8308376f$var$_excluded = [
    "sx"
];
const $5e264f5f8308376f$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    Object.keys(props).forEach((prop)=>{
        if ((0, $eiC3N.propToStyleFunction)[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $5e264f5f8308376f$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $79yYo.default)(props, $5e264f5f8308376f$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $5e264f5f8308376f$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $jWrHX.isPlainObject)(result)) return systemProps;
        return (0, $20MOv.default)({}, systemProps, result);
    };
    else finalSx = (0, $20MOv.default)({}, systemProps, inSx);
    return (0, $20MOv.default)({}, otherProps, {
        sx: finalSx
    });
}

});

parcelRegister("5aaio", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $3c25df6d9f61048f$export$24c1f8f60cbac79e; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $3c25df6d9f61048f$export$24c1f8f60cbac79e(slot) {
    return (0, $dtsUs.default)("MuiTypography", slot);
}
const $3c25df6d9f61048f$var$typographyClasses = (0, $jLqVN.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $3c25df6d9f61048f$export$2e2bcd8739ae039 = $3c25df6d9f61048f$var$typographyClasses;

});


parcelRegister("bdM1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82b62a26c616bf31$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8q2ES");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $ko2mC = parcelRequire("ko2mC");

var $1mImZ = parcelRequire("1mImZ");

var $frduM = parcelRequire("frduM");

var $6Apvh = parcelRequire("6Apvh");

var $gCG2L = parcelRequire("gCG2L");

var $4x3bm = parcelRequire("4x3bm");
const $82b62a26c616bf31$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "TransitionComponent",
    "TransitionProps"
];
const $82b62a26c616bf31$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            !square && "rounded",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        region: [
            "region"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $gCG2L.getAccordionUtilityClass), classes);
};
const $82b62a26c616bf31$var$AccordionRoot = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiAccordion",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $gCG2L.default).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: "relative",
        transition: theme.transitions.create([
            "margin"
        ], transition),
        overflowAnchor: "none",
        // Keep the same scrolling position
        "&:before": {
            position: "absolute",
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: theme.palette.divider,
            transition: theme.transitions.create([
                "opacity",
                "background-color"
            ], transition)
        },
        "&:first-of-type": {
            "&:before": {
                display: "none"
            }
        },
        [`&.${(0, $gCG2L.default).expanded}`]: {
            "&:before": {
                opacity: 0
            },
            "&:first-of-type": {
                marginTop: 0
            },
            "&:last-of-type": {
                marginBottom: 0
            },
            "& + &": {
                "&:before": {
                    display: "none"
                }
            }
        },
        [`&.${(0, $gCG2L.default).disabled}`]: {
            backgroundColor: theme.palette.action.disabledBackground
        }
    };
}, ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, !ownerState.square && {
        borderRadius: 0,
        "&:first-of-type": {
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius
        },
        "&:last-of-type": {
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
            // Fix a rendering issue on Edge
            "@supports (-ms-ime-align: auto)": {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $gCG2L.default).expanded}`]: {
            margin: "16px 0"
        }
    }));
const $82b62a26c616bf31$var$Accordion = /*#__PURE__*/ $70fFQ.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiAccordion"
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, TransitionComponent: TransitionComponent = (0, $ko2mC.default), TransitionProps: TransitionProps } = props, other = (0, $79yYo.default)(props, $82b62a26c616bf31$var$_excluded);
    const [expanded, setExpandedState] = (0, $6Apvh.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: "Accordion",
        state: "expanded"
    });
    const handleChange = $70fFQ.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $70fFQ.Children.toArray(childrenProp);
    const contextValue = $70fFQ.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $20MOv.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $82b62a26c616bf31$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($82b62a26c616bf31$var$AccordionRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $frduM.default).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
                in: expanded,
                timeout: "auto"
            }, TransitionProps, {
                children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props["aria-controls"],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $82b62a26c616bf31$export$2e2bcd8739ae039 = $82b62a26c616bf31$var$Accordion;

});
parcelRegister("8q2ES", function(module, exports) {
"use strict";

module.exports = (parcelRequire("huhRz"));

});
parcelRegister("huhRz", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $cbb31839606066a8$export$a7c73072b1a182ae; }, function (v) { return $cbb31839606066a8$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cbb31839606066a8$export$9f27bc3417b4524d; }, function (v) { return $cbb31839606066a8$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cbb31839606066a8$export$db77ccec0bb4ccac; }, function (v) { return $cbb31839606066a8$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cbb31839606066a8$export$8392c0c9d3dcbd35; }, function (v) { return $cbb31839606066a8$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cbb31839606066a8$export$ffb0004e005737fa; }, function (v) { return $cbb31839606066a8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cbb31839606066a8$export$b624eff549462981; }, function (v) { return $cbb31839606066a8$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cbb31839606066a8$export$7897aa7841a5380c; }, function (v) { return $cbb31839606066a8$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cbb31839606066a8$export$602eac185826482c; }, function (v) { return $cbb31839606066a8$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cbb31839606066a8$export$e2c29f18771995cb; }, function (v) { return $cbb31839606066a8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cbb31839606066a8$export$5f8d39834fd61797; }, function (v) { return $cbb31839606066a8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cbb31839606066a8$export$74bf444e3cd11ea5; }, function (v) { return $cbb31839606066a8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cbb31839606066a8$export$92387174baf9b227; }, function (v) { return $cbb31839606066a8$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cbb31839606066a8$export$ec112efeb987d9c6; }, function (v) { return $cbb31839606066a8$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cbb31839606066a8$export$b706b080d889d2c9; }, function (v) { return $cbb31839606066a8$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cbb31839606066a8$export$5be5a87408f70ddc; }, function (v) { return $cbb31839606066a8$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cbb31839606066a8$export$45a5e7f76e0caa8d; }, function (v) { return $cbb31839606066a8$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cbb31839606066a8$export$455c2e768291efa6; }, function (v) { return $cbb31839606066a8$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cbb31839606066a8$export$9522e17588c12572; }, function (v) { return $cbb31839606066a8$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cbb31839606066a8$export$2110ac352bb060b9; }, function (v) { return $cbb31839606066a8$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cbb31839606066a8$export$56885ab8b9c456ab; }, function (v) { return $cbb31839606066a8$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cbb31839606066a8$export$d927fcb6adf8f9de; }, function (v) { return $cbb31839606066a8$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cbb31839606066a8$export$b82d16f27459e05a; }, function (v) { return $cbb31839606066a8$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cbb31839606066a8$export$522c17b4f5e123e8; }, function (v) { return $cbb31839606066a8$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cbb31839606066a8$export$1aabd8a0274ecfd6; }, function (v) { return $cbb31839606066a8$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cbb31839606066a8$export$9b621391a187a31a; }, function (v) { return $cbb31839606066a8$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cbb31839606066a8$export$f5bbd400c2f4426f; }, function (v) { return $cbb31839606066a8$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbb31839606066a8$export$a7c73072b1a182ae;
var $cbb31839606066a8$export$9f27bc3417b4524d;
var $cbb31839606066a8$export$db77ccec0bb4ccac;
var $cbb31839606066a8$export$8392c0c9d3dcbd35;
var $cbb31839606066a8$export$ffb0004e005737fa;
var $cbb31839606066a8$export$b624eff549462981;
var $cbb31839606066a8$export$7897aa7841a5380c;
var $cbb31839606066a8$export$602eac185826482c;
var $cbb31839606066a8$export$e2c29f18771995cb;
var $cbb31839606066a8$export$5f8d39834fd61797;
var $cbb31839606066a8$export$74bf444e3cd11ea5;
var $cbb31839606066a8$export$92387174baf9b227;
var $cbb31839606066a8$export$ec112efeb987d9c6;
var $cbb31839606066a8$export$b706b080d889d2c9;
var $cbb31839606066a8$export$5be5a87408f70ddc;
var $cbb31839606066a8$export$45a5e7f76e0caa8d;
var $cbb31839606066a8$export$455c2e768291efa6;
var $cbb31839606066a8$export$9522e17588c12572;
var $cbb31839606066a8$export$2110ac352bb060b9;
var $cbb31839606066a8$export$56885ab8b9c456ab;
var $cbb31839606066a8$export$d927fcb6adf8f9de;
var $cbb31839606066a8$export$b82d16f27459e05a;
var $cbb31839606066a8$export$522c17b4f5e123e8;
var $cbb31839606066a8$export$1aabd8a0274ecfd6;
var $cbb31839606066a8$export$9b621391a187a31a;
var $cbb31839606066a8$export$f5bbd400c2f4426f;
"use strict";
var $cbb31839606066a8$var$b = 60103, $cbb31839606066a8$var$c = 60106, $cbb31839606066a8$var$d = 60107, $cbb31839606066a8$var$e = 60108, $cbb31839606066a8$var$f = 60114, $cbb31839606066a8$var$g = 60109, $cbb31839606066a8$var$h = 60110, $cbb31839606066a8$var$k = 60112, $cbb31839606066a8$var$l = 60113, $cbb31839606066a8$var$m = 60120, $cbb31839606066a8$var$n = 60115, $cbb31839606066a8$var$p = 60116, $cbb31839606066a8$var$q = 60121, $cbb31839606066a8$var$r = 60122, $cbb31839606066a8$var$u = 60117, $cbb31839606066a8$var$v = 60129, $cbb31839606066a8$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $cbb31839606066a8$var$x = Symbol.for;
    $cbb31839606066a8$var$b = $cbb31839606066a8$var$x("react.element");
    $cbb31839606066a8$var$c = $cbb31839606066a8$var$x("react.portal");
    $cbb31839606066a8$var$d = $cbb31839606066a8$var$x("react.fragment");
    $cbb31839606066a8$var$e = $cbb31839606066a8$var$x("react.strict_mode");
    $cbb31839606066a8$var$f = $cbb31839606066a8$var$x("react.profiler");
    $cbb31839606066a8$var$g = $cbb31839606066a8$var$x("react.provider");
    $cbb31839606066a8$var$h = $cbb31839606066a8$var$x("react.context");
    $cbb31839606066a8$var$k = $cbb31839606066a8$var$x("react.forward_ref");
    $cbb31839606066a8$var$l = $cbb31839606066a8$var$x("react.suspense");
    $cbb31839606066a8$var$m = $cbb31839606066a8$var$x("react.suspense_list");
    $cbb31839606066a8$var$n = $cbb31839606066a8$var$x("react.memo");
    $cbb31839606066a8$var$p = $cbb31839606066a8$var$x("react.lazy");
    $cbb31839606066a8$var$q = $cbb31839606066a8$var$x("react.block");
    $cbb31839606066a8$var$r = $cbb31839606066a8$var$x("react.server.block");
    $cbb31839606066a8$var$u = $cbb31839606066a8$var$x("react.fundamental");
    $cbb31839606066a8$var$v = $cbb31839606066a8$var$x("react.debug_trace_mode");
    $cbb31839606066a8$var$w = $cbb31839606066a8$var$x("react.legacy_hidden");
}
function $cbb31839606066a8$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $cbb31839606066a8$var$b:
                switch(a = a.type, a){
                    case $cbb31839606066a8$var$d:
                    case $cbb31839606066a8$var$f:
                    case $cbb31839606066a8$var$e:
                    case $cbb31839606066a8$var$l:
                    case $cbb31839606066a8$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cbb31839606066a8$var$h:
                            case $cbb31839606066a8$var$k:
                            case $cbb31839606066a8$var$p:
                            case $cbb31839606066a8$var$n:
                            case $cbb31839606066a8$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $cbb31839606066a8$var$c:
                return t;
        }
    }
}
var $cbb31839606066a8$var$z = $cbb31839606066a8$var$g, $cbb31839606066a8$var$A = $cbb31839606066a8$var$b, $cbb31839606066a8$var$B = $cbb31839606066a8$var$k, $cbb31839606066a8$var$C = $cbb31839606066a8$var$d, $cbb31839606066a8$var$D = $cbb31839606066a8$var$p, $cbb31839606066a8$var$E = $cbb31839606066a8$var$n, $cbb31839606066a8$var$F = $cbb31839606066a8$var$c, $cbb31839606066a8$var$G = $cbb31839606066a8$var$f, $cbb31839606066a8$var$H = $cbb31839606066a8$var$e, $cbb31839606066a8$var$I = $cbb31839606066a8$var$l;
$cbb31839606066a8$export$a7c73072b1a182ae = $cbb31839606066a8$var$h;
$cbb31839606066a8$export$9f27bc3417b4524d = $cbb31839606066a8$var$z;
$cbb31839606066a8$export$db77ccec0bb4ccac = $cbb31839606066a8$var$A;
$cbb31839606066a8$export$8392c0c9d3dcbd35 = $cbb31839606066a8$var$B;
$cbb31839606066a8$export$ffb0004e005737fa = $cbb31839606066a8$var$C;
$cbb31839606066a8$export$b624eff549462981 = $cbb31839606066a8$var$D;
$cbb31839606066a8$export$7897aa7841a5380c = $cbb31839606066a8$var$E;
$cbb31839606066a8$export$602eac185826482c = $cbb31839606066a8$var$F;
$cbb31839606066a8$export$e2c29f18771995cb = $cbb31839606066a8$var$G;
$cbb31839606066a8$export$5f8d39834fd61797 = $cbb31839606066a8$var$H;
$cbb31839606066a8$export$74bf444e3cd11ea5 = $cbb31839606066a8$var$I;
$cbb31839606066a8$export$92387174baf9b227 = function() {
    return !1;
};
$cbb31839606066a8$export$ec112efeb987d9c6 = function() {
    return !1;
};
$cbb31839606066a8$export$b706b080d889d2c9 = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$h;
};
$cbb31839606066a8$export$5be5a87408f70ddc = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$g;
};
$cbb31839606066a8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cbb31839606066a8$var$b;
};
$cbb31839606066a8$export$455c2e768291efa6 = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$k;
};
$cbb31839606066a8$export$9522e17588c12572 = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$d;
};
$cbb31839606066a8$export$2110ac352bb060b9 = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$p;
};
$cbb31839606066a8$export$56885ab8b9c456ab = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$n;
};
$cbb31839606066a8$export$d927fcb6adf8f9de = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$c;
};
$cbb31839606066a8$export$b82d16f27459e05a = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$f;
};
$cbb31839606066a8$export$522c17b4f5e123e8 = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$e;
};
$cbb31839606066a8$export$1aabd8a0274ecfd6 = function(a) {
    return $cbb31839606066a8$var$y(a) === $cbb31839606066a8$var$l;
};
$cbb31839606066a8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cbb31839606066a8$var$d || a === $cbb31839606066a8$var$f || a === $cbb31839606066a8$var$v || a === $cbb31839606066a8$var$e || a === $cbb31839606066a8$var$l || a === $cbb31839606066a8$var$m || a === $cbb31839606066a8$var$w || "object" === typeof a && null !== a && (a.$$typeof === $cbb31839606066a8$var$p || a.$$typeof === $cbb31839606066a8$var$n || a.$$typeof === $cbb31839606066a8$var$g || a.$$typeof === $cbb31839606066a8$var$h || a.$$typeof === $cbb31839606066a8$var$k || a.$$typeof === $cbb31839606066a8$var$u || a.$$typeof === $cbb31839606066a8$var$q || a[0] === $cbb31839606066a8$var$r) ? !0 : !1;
};
$cbb31839606066a8$export$f5bbd400c2f4426f = $cbb31839606066a8$var$y;

});


parcelRegister("ko2mC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03d483a4f287dd31$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");

var $gjktY = parcelRequire("gjktY");


var $dxolJ = parcelRequire("dxolJ");


var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $a3nje = parcelRequire("a3nje");

var $ceSe6 = parcelRequire("ceSe6");

var $2mnfJ = parcelRequire("2mnfJ");

var $5Up1l = parcelRequire("5Up1l");

var $8zTpR = parcelRequire("8zTpR");

var $4x3bm = parcelRequire("4x3bm");
const $03d483a4f287dd31$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $03d483a4f287dd31$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $8zTpR.getCollapseUtilityClass), classes);
};
const $03d483a4f287dd31$var$CollapseRoot = (0, $71Pr4.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $20MOv.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $03d483a4f287dd31$var$CollapseWrapper = (0, $71Pr4.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $03d483a4f287dd31$var$CollapseWrapperInner = (0, $71Pr4.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $03d483a4f287dd31$var$Collapse = /*#__PURE__*/ $70fFQ.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $a3nje.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $dxolJ.default) } = props, other = (0, $79yYo.default)(props, $03d483a4f287dd31$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $03d483a4f287dd31$var$useUtilityClasses(ownerState);
    const theme = (0, $2mnfJ.default)();
    const timer = $70fFQ.useRef();
    const wrapperRef = $70fFQ.useRef(null);
    const autoTransitionDuration = $70fFQ.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    $70fFQ.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    const nodeRef = $70fFQ.useRef(null);
    const handleRef = (0, $5Up1l.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $4x3bm.jsx)($03d483a4f287dd31$var$CollapseRoot, (0, $20MOv.default)({
                as: component,
                className: (0, $gjktY.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $20MOv.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $20MOv.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $4x3bm.jsx)($03d483a4f287dd31$var$CollapseWrapper, {
                    ownerState: (0, $20MOv.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)($03d483a4f287dd31$var$CollapseWrapperInner, {
                        ownerState: (0, $20MOv.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$03d483a4f287dd31$var$Collapse.muiSupportAuto = true;
var $03d483a4f287dd31$export$2e2bcd8739ae039 = $03d483a4f287dd31$var$Collapse;

});
parcelRegister("8zTpR", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", function () { return $63ec941ec5c4d901$export$5162da8f798e0959; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $63ec941ec5c4d901$export$5162da8f798e0959(slot) {
    return (0, $dtsUs.default)("MuiCollapse", slot);
}
const $63ec941ec5c4d901$var$collapseClasses = (0, $jLqVN.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $63ec941ec5c4d901$export$2e2bcd8739ae039 = $63ec941ec5c4d901$var$collapseClasses;

});


parcelRegister("frduM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d3d891f1e4c580$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $b3d3d891f1e4c580$var$AccordionContext = /*#__PURE__*/ $70fFQ.createContext({});
var $b3d3d891f1e4c580$export$2e2bcd8739ae039 = $b3d3d891f1e4c580$var$AccordionContext;

});

parcelRegister("6Apvh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb9e358b67aff39$export$2e2bcd8739ae039; });

var $dyLoc = parcelRequire("dyLoc");
var $4cb9e358b67aff39$export$2e2bcd8739ae039 = (0, $dyLoc.default);

});
parcelRegister("dyLoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9df335d84ec252be$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $70fFQ = parcelRequire("70fFQ");
function $9df335d84ec252be$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $70fFQ.useRef(controlled !== undefined);
    const [valueState, setValue] = $70fFQ.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $70fFQ.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("gCG2L", function(module, exports) {

$parcel$export(module.exports, "getAccordionUtilityClass", function () { return $c1a0cef05ccc1c00$export$80fb6a2cb3f13b8b; });
$parcel$export(module.exports, "default", function () { return $c1a0cef05ccc1c00$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $c1a0cef05ccc1c00$export$80fb6a2cb3f13b8b(slot) {
    return (0, $dtsUs.default)("MuiAccordion", slot);
}
const $c1a0cef05ccc1c00$var$accordionClasses = (0, $jLqVN.default)("MuiAccordion", [
    "root",
    "rounded",
    "expanded",
    "disabled",
    "gutters",
    "region"
]);
var $c1a0cef05ccc1c00$export$2e2bcd8739ae039 = $c1a0cef05ccc1c00$var$accordionClasses;

});


parcelRegister("fRNcc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8d1f787a316c909$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $dAAhM = parcelRequire("dAAhM");

var $4x3bm = parcelRequire("4x3bm");
const $b8d1f787a316c909$var$_excluded = [
    "className"
];
const $b8d1f787a316c909$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $dAAhM.getAccordionDetailsUtilityClass), classes);
};
const $b8d1f787a316c909$var$AccordionDetailsRoot = (0, $71Pr4.default)("div", {
    name: "MuiAccordionDetails",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $b8d1f787a316c909$var$AccordionDetails = /*#__PURE__*/ $70fFQ.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiAccordionDetails"
    });
    const { className: className } = props, other = (0, $79yYo.default)(props, $b8d1f787a316c909$var$_excluded);
    const ownerState = props;
    const classes = $b8d1f787a316c909$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($b8d1f787a316c909$var$AccordionDetailsRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $b8d1f787a316c909$export$2e2bcd8739ae039 = $b8d1f787a316c909$var$AccordionDetails;

});
parcelRegister("dAAhM", function(module, exports) {

$parcel$export(module.exports, "getAccordionDetailsUtilityClass", function () { return $9e4ac8c044a25bd8$export$a6afb527becfac26; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $9e4ac8c044a25bd8$export$a6afb527becfac26(slot) {
    return (0, $dtsUs.default)("MuiAccordionDetails", slot);
}
const $9e4ac8c044a25bd8$var$accordionDetailsClasses = (0, $jLqVN.default)("MuiAccordionDetails", [
    "root"
]);
var $9e4ac8c044a25bd8$export$2e2bcd8739ae039 = $9e4ac8c044a25bd8$var$accordionDetailsClasses;

});


parcelRegister("3PGZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ca77c537e9f6ce2$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $eGmvM = parcelRequire("eGmvM");

var $frduM = parcelRequire("frduM");

var $1q7Zr = parcelRequire("1q7Zr");

var $4x3bm = parcelRequire("4x3bm");
const $2ca77c537e9f6ce2$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $2ca77c537e9f6ce2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        focusVisible: [
            "focusVisible"
        ],
        content: [
            "content",
            expanded && "expanded",
            !disableGutters && "contentGutters"
        ],
        expandIconWrapper: [
            "expandIconWrapper",
            expanded && "expanded"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $1q7Zr.getAccordionSummaryUtilityClass), classes);
};
const $2ca77c537e9f6ce2$var$AccordionSummaryRoot = (0, $71Pr4.default)((0, $eGmvM.default), {
    name: "MuiAccordionSummary",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return (0, $20MOv.default)({
        display: "flex",
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            "min-height",
            "background-color"
        ], transition),
        [`&.${(0, $1q7Zr.default).focusVisible}`]: {
            backgroundColor: theme.palette.action.focus
        },
        [`&.${(0, $1q7Zr.default).disabled}`]: {
            opacity: theme.palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $1q7Zr.default).disabled})`]: {
            cursor: "pointer"
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $1q7Zr.default).expanded}`]: {
            minHeight: 64
        }
    });
});
const $2ca77c537e9f6ce2$var$AccordionSummaryContent = (0, $71Pr4.default)("div", {
    name: "MuiAccordionSummary",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        flexGrow: 1,
        margin: "12px 0"
    }, !ownerState.disableGutters && {
        transition: theme.transitions.create([
            "margin"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $1q7Zr.default).expanded}`]: {
            margin: "20px 0"
        }
    }));
const $2ca77c537e9f6ce2$var$AccordionSummaryExpandIconWrapper = (0, $71Pr4.default)("div", {
    name: "MuiAccordionSummary",
    slot: "ExpandIconWrapper",
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: "flex",
        color: theme.palette.action.active,
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $1q7Zr.default).expanded}`]: {
            transform: "rotate(180deg)"
        }
    }));
const $2ca77c537e9f6ce2$var$AccordionSummary = /*#__PURE__*/ $70fFQ.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiAccordionSummary"
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $79yYo.default)(props, $2ca77c537e9f6ce2$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $70fFQ.useContext((0, $frduM.default));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $20MOv.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $2ca77c537e9f6ce2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($2ca77c537e9f6ce2$var$AccordionSummaryRoot, (0, $20MOv.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $gjktY.default)(classes.root, className),
        focusVisibleClassName: (0, $gjktY.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($2ca77c537e9f6ce2$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $4x3bm.jsx)($2ca77c537e9f6ce2$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $2ca77c537e9f6ce2$export$2e2bcd8739ae039 = $2ca77c537e9f6ce2$var$AccordionSummary;

});
parcelRegister("eGmvM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06733fd85b95ce$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $5Up1l = parcelRequire("5Up1l");

var $duaP9 = parcelRequire("duaP9");

var $kdx2B = parcelRequire("kdx2B");

var $8BDmq = parcelRequire("8BDmq");

var $4J5F2 = parcelRequire("4J5F2");

var $4x3bm = parcelRequire("4x3bm");
const $ab06733fd85b95ce$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $ab06733fd85b95ce$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $4J5F2.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $ab06733fd85b95ce$export$7ec0dcc5e3cdcd36 = (0, $71Pr4.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $4J5F2.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $ab06733fd85b95ce$var$ButtonBase = /*#__PURE__*/ $70fFQ.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $79yYo.default)(props, $ab06733fd85b95ce$var$_excluded);
    const buttonRef = $70fFQ.useRef(null);
    const rippleRef = $70fFQ.useRef(null);
    const handleRippleRef = (0, $5Up1l.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $kdx2B.default)();
    const [focusVisible, setFocusVisible] = $70fFQ.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $70fFQ.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    $70fFQ.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $duaP9.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $duaP9.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $70fFQ.useRef(false);
    const handleKeyDown = (0, $duaP9.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $duaP9.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleOwnRef = (0, $5Up1l.default)(focusVisibleRef, buttonRef);
    const handleRef = (0, $5Up1l.default)(ref, handleOwnRef);
    const [mountedState, setMountedState] = $70fFQ.useState(false);
    $70fFQ.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    const ownerState = (0, $20MOv.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $ab06733fd85b95ce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($ab06733fd85b95ce$export$7ec0dcc5e3cdcd36, (0, $20MOv.default)({
        as: ComponentProp,
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $4x3bm.jsx)((0, $8BDmq.default), (0, $20MOv.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $ab06733fd85b95ce$export$2e2bcd8739ae039 = $ab06733fd85b95ce$var$ButtonBase;

});
parcelRegister("kdx2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb7ea6c59e49ebe1$export$2e2bcd8739ae039; });

var $8YYzU = parcelRequire("8YYzU");
var $eb7ea6c59e49ebe1$export$2e2bcd8739ae039 = (0, $8YYzU.default);

});
parcelRegister("8YYzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68a2eade1108a34d$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $70fFQ = parcelRequire("70fFQ");
let $68a2eade1108a34d$var$hadKeyboardEvent = true;
let $68a2eade1108a34d$var$hadFocusVisibleRecently = false;
let $68a2eade1108a34d$var$hadFocusVisibleRecentlyTimeout;
const $68a2eade1108a34d$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $68a2eade1108a34d$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $68a2eade1108a34d$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $68a2eade1108a34d$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $68a2eade1108a34d$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $68a2eade1108a34d$var$handlePointerDown() {
    $68a2eade1108a34d$var$hadKeyboardEvent = false;
}
function $68a2eade1108a34d$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($68a2eade1108a34d$var$hadFocusVisibleRecently) $68a2eade1108a34d$var$hadKeyboardEvent = true;
    }
}
function $68a2eade1108a34d$var$prepare(doc) {
    doc.addEventListener("keydown", $68a2eade1108a34d$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $68a2eade1108a34d$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $68a2eade1108a34d$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $68a2eade1108a34d$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $68a2eade1108a34d$var$handleVisibilityChange, true);
}
function $68a2eade1108a34d$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $68a2eade1108a34d$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $68a2eade1108a34d$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $68a2eade1108a34d$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $68a2eade1108a34d$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $68a2eade1108a34d$var$handleVisibilityChange, true);
}
function $68a2eade1108a34d$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    } // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $68a2eade1108a34d$var$hadKeyboardEvent || $68a2eade1108a34d$var$focusTriggersKeyboardModality(target);
}
function $68a2eade1108a34d$export$2e2bcd8739ae039() {
    const ref = $70fFQ.useCallback((node)=>{
        if (node != null) $68a2eade1108a34d$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $70fFQ.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $68a2eade1108a34d$var$hadFocusVisibleRecently = true;
            window.clearTimeout($68a2eade1108a34d$var$hadFocusVisibleRecentlyTimeout);
            $68a2eade1108a34d$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $68a2eade1108a34d$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($68a2eade1108a34d$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});


parcelRegister("8BDmq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64404fa9312cadb9$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $3CzWw = parcelRequire("3CzWw");

var $gjktY = parcelRequire("gjktY");

var $l1z3A = parcelRequire("l1z3A");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $g7sEq = parcelRequire("g7sEq");

var $3rm35 = parcelRequire("3rm35");

var $4x3bm = parcelRequire("4x3bm");
let $64404fa9312cadb9$var$_ = (t)=>t, $64404fa9312cadb9$var$t, $64404fa9312cadb9$var$t1, $64404fa9312cadb9$var$t2, $64404fa9312cadb9$var$t3;
const $64404fa9312cadb9$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $64404fa9312cadb9$var$_1 = (t)=>t, $64404fa9312cadb9$var$_t, $64404fa9312cadb9$var$_t2, $64404fa9312cadb9$var$_t3, $64404fa9312cadb9$var$_t4;
const $64404fa9312cadb9$var$DURATION = 550;
const $64404fa9312cadb9$export$95d0c9356b2231a3 = 80;
const $64404fa9312cadb9$var$enterKeyframe = (0, $l1z3A.keyframes)($64404fa9312cadb9$var$_t || ($64404fa9312cadb9$var$_t = $64404fa9312cadb9$var$_1($64404fa9312cadb9$var$t || ($64404fa9312cadb9$var$t = $64404fa9312cadb9$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $64404fa9312cadb9$var$exitKeyframe = (0, $l1z3A.keyframes)($64404fa9312cadb9$var$_t2 || ($64404fa9312cadb9$var$_t2 = $64404fa9312cadb9$var$_1($64404fa9312cadb9$var$t1 || ($64404fa9312cadb9$var$t1 = $64404fa9312cadb9$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $64404fa9312cadb9$var$pulsateKeyframe = (0, $l1z3A.keyframes)($64404fa9312cadb9$var$_t3 || ($64404fa9312cadb9$var$_t3 = $64404fa9312cadb9$var$_1($64404fa9312cadb9$var$t2 || ($64404fa9312cadb9$var$t2 = $64404fa9312cadb9$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $64404fa9312cadb9$export$f6b7418508c72c25 = (0, $71Pr4.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
}); // This `styled()` function invokes keyframes. `styled-components` only supports keyframes
const $64404fa9312cadb9$export$676cfe7b12693c4b = (0, $71Pr4.default)((0, $g7sEq.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($64404fa9312cadb9$var$_t4 || ($64404fa9312cadb9$var$_t4 = $64404fa9312cadb9$var$_1($64404fa9312cadb9$var$t3 || ($64404fa9312cadb9$var$t3 = $64404fa9312cadb9$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $3rm35.default).rippleVisible, $64404fa9312cadb9$var$enterKeyframe, $64404fa9312cadb9$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $3rm35.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $3rm35.default).child, (0, $3rm35.default).childLeaving, $64404fa9312cadb9$var$exitKeyframe, $64404fa9312cadb9$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $3rm35.default).childPulsate, $64404fa9312cadb9$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $64404fa9312cadb9$var$TouchRipple = /*#__PURE__*/ $70fFQ.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $79yYo.default)(props, $64404fa9312cadb9$var$_excluded);
    const [ripples, setRipples] = $70fFQ.useState([]);
    const nextKey = $70fFQ.useRef(0);
    const rippleCallback = $70fFQ.useRef(null);
    $70fFQ.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $70fFQ.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $70fFQ.useRef(null); // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $70fFQ.useRef(null);
    const container = $70fFQ.useRef(null);
    $70fFQ.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $70fFQ.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $4x3bm.jsx)($64404fa9312cadb9$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $gjktY.default)(classes.ripple, (0, $3rm35.default).ripple),
                        rippleVisible: (0, $gjktY.default)(classes.rippleVisible, (0, $3rm35.default).rippleVisible),
                        ripplePulsate: (0, $gjktY.default)(classes.ripplePulsate, (0, $3rm35.default).ripplePulsate),
                        child: (0, $gjktY.default)(classes.child, (0, $3rm35.default).child),
                        childLeaving: (0, $gjktY.default)(classes.childLeaving, (0, $3rm35.default).childLeaving),
                        childPulsate: (0, $gjktY.default)(classes.childPulsate, (0, $3rm35.default).childPulsate)
                    },
                    timeout: $64404fa9312cadb9$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $70fFQ.useCallback((event = {}, options = {}, cb)=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3); // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $64404fa9312cadb9$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $70fFQ.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $70fFQ.useCallback((event, cb)=>{
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $70fFQ.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($64404fa9312cadb9$export$f6b7418508c72c25, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, (0, $3rm35.default).root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3CzWw.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $64404fa9312cadb9$export$2e2bcd8739ae039 = $64404fa9312cadb9$var$TouchRipple;

});
parcelRegister("3CzWw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a30cd387c5fa2e3$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $cHjwI = parcelRequire("cHjwI");

var $b0Bcw = parcelRequire("b0Bcw");


var $70fFQ = parcelRequire("70fFQ");

var $kZNVB = parcelRequire("kZNVB");

var $aLKec = parcelRequire("aLKec");
var $2a30cd387c5fa2e3$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $2a30cd387c5fa2e3$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $2a30cd387c5fa2e3$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $b0Bcw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cHjwI.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $aLKec.getInitialChildMapping)(nextProps, handleExited) : (0, $aLKec.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $aLKec.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $20MOv.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $79yYo.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $2a30cd387c5fa2e3$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $kZNVB.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $kZNVB.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
$2a30cd387c5fa2e3$var$TransitionGroup.propTypes = {};
$2a30cd387c5fa2e3$var$TransitionGroup.defaultProps = $2a30cd387c5fa2e3$var$defaultProps;
var $2a30cd387c5fa2e3$export$2e2bcd8739ae039 = $2a30cd387c5fa2e3$var$TransitionGroup;

});
parcelRegister("cHjwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0262b859e0d0c401$export$2e2bcd8739ae039; });
function $0262b859e0d0c401$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("aLKec", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $7d72271c63cf4726$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $7d72271c63cf4726$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $7d72271c63cf4726$export$36fd1af28d383ec0; });

var $70fFQ = parcelRequire("70fFQ");
function $7d72271c63cf4726$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $70fFQ.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $70fFQ.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $7d72271c63cf4726$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $7d72271c63cf4726$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $7d72271c63cf4726$export$fa71e2345c31d7a2(props, onExited) {
    return $7d72271c63cf4726$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $7d72271c63cf4726$var$getProp(child, "appear", props),
            enter: $7d72271c63cf4726$var$getProp(child, "enter", props),
            exit: $7d72271c63cf4726$var$getProp(child, "exit", props)
        });
    });
}
function $7d72271c63cf4726$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $7d72271c63cf4726$export$bbc8a025727ea824(nextProps.children);
    var children = $7d72271c63cf4726$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $70fFQ.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $70fFQ.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $7d72271c63cf4726$var$getProp(child, "exit", nextProps),
            enter: $7d72271c63cf4726$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $70fFQ.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $7d72271c63cf4726$var$getProp(child, "exit", nextProps),
            enter: $7d72271c63cf4726$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("g7sEq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbc38648fc7aec0a$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $4x3bm = parcelRequire("4x3bm");
function $bbc38648fc7aec0a$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $70fFQ.useState(false);
    const rippleClassName = (0, $gjktY.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $gjktY.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $70fFQ.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
            className: childClassName
        })
    });
}
var $bbc38648fc7aec0a$export$2e2bcd8739ae039 = $bbc38648fc7aec0a$var$Ripple;

});

parcelRegister("3rm35", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2814ff23aeed1219$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $2814ff23aeed1219$export$b464606f735ab902(slot) {
    return (0, $dtsUs.default)("MuiTouchRipple", slot);
}
const $2814ff23aeed1219$var$touchRippleClasses = (0, $jLqVN.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $2814ff23aeed1219$export$2e2bcd8739ae039 = $2814ff23aeed1219$var$touchRippleClasses;

});


parcelRegister("4J5F2", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $370fc18395bed354$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $370fc18395bed354$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $370fc18395bed354$export$fccb0498dcd99783(slot) {
    return (0, $dtsUs.default)("MuiButtonBase", slot);
}
const $370fc18395bed354$var$buttonBaseClasses = (0, $jLqVN.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $370fc18395bed354$export$2e2bcd8739ae039 = $370fc18395bed354$var$buttonBaseClasses;

});


parcelRegister("1q7Zr", function(module, exports) {

$parcel$export(module.exports, "getAccordionSummaryUtilityClass", function () { return $108e6ac8576ca51a$export$282216ad123d6580; });
$parcel$export(module.exports, "default", function () { return $108e6ac8576ca51a$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $108e6ac8576ca51a$export$282216ad123d6580(slot) {
    return (0, $dtsUs.default)("MuiAccordionSummary", slot);
}
const $108e6ac8576ca51a$var$accordionSummaryClasses = (0, $jLqVN.default)("MuiAccordionSummary", [
    "root",
    "expanded",
    "focusVisible",
    "disabled",
    "gutters",
    "contentGutters",
    "content",
    "expandIconWrapper"
]);
var $108e6ac8576ca51a$export$2e2bcd8739ae039 = $108e6ac8576ca51a$var$accordionSummaryClasses;

});


parcelRegister("hsXqC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb732668661ab4db$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $bVfv5 = parcelRequire("bVfv5");

var $jLqVN = parcelRequire("jLqVN");

var $ia1SG = parcelRequire("ia1SG");
var $bVk70 = parcelRequire("bVk70");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $cvjmQ = parcelRequire("cvjmQ");

var $aAAPW = parcelRequire("aAAPW");

var $4x3bm = parcelRequire("4x3bm");
const $cb732668661ab4db$var$_excluded = [
    "anchorOrigin",
    "component",
    "components",
    "componentsProps",
    "overlap",
    "color",
    "invisible",
    "badgeContent",
    "showZero",
    "variant"
];
const $cb732668661ab4db$export$e7fbbeea031dbd70 = (0, $20MOv.default)({}, (0, $ia1SG.default), (0, $jLqVN.default)("MuiBadge", [
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]));
const $cb732668661ab4db$var$RADIUS_STANDARD = 10;
const $cb732668661ab4db$var$RADIUS_DOT = 4;
const $cb732668661ab4db$var$extendUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, overlap: overlap, classes: classes = {} } = ownerState;
    return (0, $20MOv.default)({}, classes, {
        badge: (0, $gjktY.default)(classes.badge, (0, $ia1SG.getBadgeUtilityClass)(`anchorOrigin${(0, $aAAPW.default)(anchorOrigin.vertical)}${(0, $aAAPW.default)(anchorOrigin.horizontal)}${(0, $aAAPW.default)(overlap)}`), (0, $ia1SG.getBadgeUtilityClass)(`overlap${(0, $aAAPW.default)(overlap)}`), color !== "default" && [
            (0, $ia1SG.getBadgeUtilityClass)(`color${(0, $aAAPW.default)(color)}`),
            classes[`color${(0, $aAAPW.default)(color)}`]
        ])
    });
};
const $cb732668661ab4db$var$BadgeRoot = (0, $71Pr4.default)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const $cb732668661ab4db$var$BadgeBadge = (0, $71Pr4.default)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $aAAPW.default)(ownerState.anchorOrigin.vertical)}${(0, $aAAPW.default)(ownerState.anchorOrigin.horizontal)}${(0, $aAAPW.default)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, $aAAPW.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $cb732668661ab4db$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: $cb732668661ab4db$var$RADIUS_STANDARD * 2,
        borderRadius: $cb732668661ab4db$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        })
    }, ownerState.color !== "default" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.variant === "dot" && {
        borderRadius: $cb732668661ab4db$var$RADIUS_DOT,
        height: $cb732668661ab4db$var$RADIUS_DOT * 2,
        minWidth: $cb732668661ab4db$var$RADIUS_DOT * 2,
        padding: 0
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular" && {
        top: 0,
        right: 0,
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular" && {
        bottom: 0,
        right: 0,
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(50%, 50%)"
        }
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular" && {
        top: 0,
        left: 0,
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(-50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular" && {
        bottom: 0,
        left: 0,
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(-50%, 50%)"
        }
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular" && {
        top: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular" && {
        bottom: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(50%, 50%)"
        }
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular" && {
        top: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(-50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular" && {
        bottom: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${$cb732668661ab4db$export$e7fbbeea031dbd70.invisible}`]: {
            transform: "scale(0) translate(-50%, 50%)"
        }
    }, ownerState.invisible && {
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.leavingScreen
        })
    }));
const $cb732668661ab4db$var$Badge = /*#__PURE__*/ $70fFQ.forwardRef(function Badge(inProps, ref) {
    var _componentsProps$root, _componentsProps$badg;
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, component: component = "span", components: components = {}, componentsProps: componentsProps = {}, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, badgeContent: badgeContentProp, showZero: showZero = false, variant: variantProp = "standard" } = props, other = (0, $79yYo.default)(props, $cb732668661ab4db$var$_excluded);
    const prevProps = (0, $bVfv5.default)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && (badgeContentProp === 0 && !showZero || badgeContentProp == null && variantProp !== "dot")) invisible = true;
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp } = invisible ? prevProps : props;
    const ownerState = (0, $20MOv.default)({}, props, {
        anchorOrigin: anchorOrigin,
        invisible: invisible,
        color: color,
        overlap: overlap
    });
    const classes = $cb732668661ab4db$var$extendUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bVk70.default), (0, $20MOv.default)({
        anchorOrigin: anchorOrigin,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero,
        variant: variantProp
    }, other, {
        components: (0, $20MOv.default)({
            Root: $cb732668661ab4db$var$BadgeRoot,
            Badge: $cb732668661ab4db$var$BadgeBadge
        }, components),
        componentsProps: {
            root: (0, $20MOv.default)({}, componentsProps.root, (0, $cvjmQ.default)(components.Root) && {
                as: component,
                ownerState: (0, $20MOv.default)({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState, {
                    color: color,
                    overlap: overlap
                })
            }),
            badge: (0, $20MOv.default)({}, componentsProps.badge, (0, $cvjmQ.default)(components.Badge) && {
                ownerState: (0, $20MOv.default)({}, (_componentsProps$badg = componentsProps.badge) == null ? void 0 : _componentsProps$badg.ownerState, {
                    color: color,
                    overlap: overlap
                })
            })
        },
        classes: classes,
        ref: ref
    }));
});
var $cb732668661ab4db$export$2e2bcd8739ae039 = $cb732668661ab4db$var$Badge;

});
parcelRegister("bVfv5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ae10aa725014b6c$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
const $8ae10aa725014b6c$var$usePreviousProps = (value)=>{
    const ref = $70fFQ.useRef({});
    $70fFQ.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $8ae10aa725014b6c$export$2e2bcd8739ae039 = $8ae10aa725014b6c$var$usePreviousProps;

});

parcelRegister("ia1SG", function(module, exports) {

$parcel$export(module.exports, "getBadgeUtilityClass", function () { return $d38a9eb78f6e3fec$export$aaccef17e6dab084; });
$parcel$export(module.exports, "default", function () { return $d38a9eb78f6e3fec$export$2e2bcd8739ae039; });

var $jLqVN = parcelRequire("jLqVN");

var $dtsUs = parcelRequire("dtsUs");
function $d38a9eb78f6e3fec$export$aaccef17e6dab084(slot) {
    return (0, $dtsUs.default)("MuiBadge", slot);
}
const $d38a9eb78f6e3fec$var$badgeUnstyledClasses = (0, $jLqVN.default)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopLeft",
    "anchorOriginTopRight",
    "anchorOriginBottomLeft",
    "anchorOriginBottomRight",
    "invisible"
]);
var $d38a9eb78f6e3fec$export$2e2bcd8739ae039 = $d38a9eb78f6e3fec$var$badgeUnstyledClasses;

});

parcelRegister("bVk70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ae49e6a6fa31d57$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $9vGQi = parcelRequire("9vGQi");

var $8dWxZ = parcelRequire("8dWxZ");

var $3GrfC = parcelRequire("3GrfC");

var $iu6uE = parcelRequire("iu6uE");

var $ia1SG = parcelRequire("ia1SG");

var $4x3bm = parcelRequire("4x3bm");
const $8ae49e6a6fa31d57$var$_excluded = [
    "anchorOrigin",
    "classes",
    "badgeContent",
    "component",
    "children",
    "className",
    "components",
    "componentsProps",
    "invisible",
    "max",
    "showZero",
    "variant"
];
const $8ae49e6a6fa31d57$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, anchorOrigin: anchorOrigin, invisible: invisible, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            `anchorOrigin${(0, $9vGQi.default)(anchorOrigin.vertical)}${(0, $9vGQi.default)(anchorOrigin.horizontal)}`,
            invisible && "invisible"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $ia1SG.getBadgeUtilityClass), classes);
};
const $8ae49e6a6fa31d57$var$BadgeUnstyled = /*#__PURE__*/ $70fFQ.forwardRef(function BadgeUnstyled(props, ref) {
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, classes: classesProp, component: component, children: children, className: className, components: components = {}, componentsProps: componentsProps = {}, max: maxProp = 99, showZero: showZero = false, variant: variantProp = "standard" } = props, other = (0, $79yYo.default)(props, $8ae49e6a6fa31d57$var$_excluded);
    const { anchorOrigin: anchorOrigin, badgeContent: badgeContent, max: max, variant: variant, displayValue: displayValue, invisible: invisible } = (0, $iu6uE.default)((0, $20MOv.default)({}, props, {
        anchorOrigin: anchorOriginProp,
        max: maxProp,
        variant: variantProp
    }));
    const ownerState = (0, $20MOv.default)({}, props, {
        anchorOrigin: anchorOrigin,
        badgeContent: badgeContent,
        classes: classesProp,
        invisible: invisible,
        max: max,
        variant: variant,
        showZero: showZero
    });
    const classes = $8ae49e6a6fa31d57$var$useUtilityClasses(ownerState);
    const Root = component || components.Root || "span";
    const rootProps = (0, $3GrfC.default)(Root, (0, $20MOv.default)({}, other, componentsProps.root), ownerState);
    const Badge = components.Badge || "span";
    const badgeProps = (0, $3GrfC.default)(Badge, componentsProps.badge, ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)(Root, (0, $20MOv.default)({}, rootProps, {
        ref: ref
    }, other, {
        className: (0, $gjktY.default)(classes.root, rootProps.className, className),
        children: [
            children,
            /*#__PURE__*/ (0, $4x3bm.jsx)(Badge, (0, $20MOv.default)({}, badgeProps, {
                className: (0, $gjktY.default)(classes.badge, badgeProps.className),
                children: displayValue
            }))
        ]
    }));
});
var $8ae49e6a6fa31d57$export$2e2bcd8739ae039 = $8ae49e6a6fa31d57$var$BadgeUnstyled;

});
parcelRegister("3GrfC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aea6ecd6b18fc90$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $gZaTl = parcelRequire("gZaTl");
function $2aea6ecd6b18fc90$export$2e2bcd8739ae039(elementType, existingProps = {}, ownerState) {
    if ((0, $gZaTl.default)(elementType)) return existingProps;
    return (0, $20MOv.default)({}, existingProps, {
        ownerState: (0, $20MOv.default)({}, existingProps.ownerState, ownerState)
    });
}

});
parcelRegister("gZaTl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5dacab426b23fd2$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $c5dacab426b23fd2$var$isHostComponent(element) {
    return typeof element === "string";
}
var $c5dacab426b23fd2$export$2e2bcd8739ae039 = $c5dacab426b23fd2$var$isHostComponent;

});


parcelRegister("iu6uE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d75010c27d75521e$export$2e2bcd8739ae039; });

var $bVfv5 = parcelRequire("bVfv5");
function $d75010c27d75521e$export$2e2bcd8739ae039(props) {
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false, variant: variantProp = "standard" } = props;
    const prevProps = (0, $bVfv5.default)({
        anchorOrigin: anchorOriginProp,
        badgeContent: badgeContentProp,
        max: maxProp,
        variant: variantProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && (badgeContentProp === 0 && !showZero || badgeContentProp == null && variantProp !== "dot")) invisible = true;
    const { anchorOrigin: anchorOrigin = anchorOriginProp, badgeContent: badgeContent, max: max = maxProp, variant: variant = variantProp } = invisible ? prevProps : props;
    let displayValue = "";
    if (variant !== "dot") displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        anchorOrigin: anchorOrigin,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        variant: variant,
        displayValue: displayValue
    };
}

});


parcelRegister("cvjmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91a7673eff33540f$export$2e2bcd8739ae039; });

var $gZaTl = parcelRequire("gZaTl");
const $91a7673eff33540f$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $gZaTl.default)(Slot);
};
var $91a7673eff33540f$export$2e2bcd8739ae039 = $91a7673eff33540f$var$shouldSpreadAdditionalProps;

});


parcelRegister("bDcYY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $877d684795dc36b4$export$2e2bcd8739ae039; });

var $i1HWH = parcelRequire("i1HWH");

var $kZEgR = parcelRequire("kZEgR");

var $bMr3l = parcelRequire("bMr3l");
const $877d684795dc36b4$var$defaultTheme = (0, $bMr3l.default)();
/**
 * @ignore - do not document.
 */ const $877d684795dc36b4$var$Box = (0, $i1HWH.default)({
    defaultTheme: $877d684795dc36b4$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $kZEgR.default).generate
});
var $877d684795dc36b4$export$2e2bcd8739ae039 = $877d684795dc36b4$var$Box;

});
parcelRegister("i1HWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1fa68b736e490a2$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $iGWDe = parcelRequire("iGWDe");

var $5CMDM = parcelRequire("5CMDM");
var $859H5 = parcelRequire("859H5");

var $3yh9K = parcelRequire("3yh9K");

var $4x3bm = parcelRequire("4x3bm");
const $d1fa68b736e490a2$var$_excluded = [
    "className",
    "component"
];
function $d1fa68b736e490a2$export$2e2bcd8739ae039(options = {}) {
    const { defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName, styleFunctionSx: styleFunctionSx = (0, $5CMDM.default) } = options;
    const BoxRoot = (0, $iGWDe.default)("div")(styleFunctionSx);
    const Box = /*#__PURE__*/ $70fFQ.forwardRef(function Box(inProps, ref) {
        const theme = (0, $3yh9K.default)(defaultTheme);
        const _extendSxProp = (0, $859H5.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $79yYo.default)(_extendSxProp, $d1fa68b736e490a2$var$_excluded);
        return /*#__PURE__*/ (0, $4x3bm.jsx)(BoxRoot, (0, $20MOv.default)({
            as: component,
            ref: ref,
            className: (0, $gjktY.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: theme
        }, other));
    });
    return Box;
}

});


parcelRegister("fKdUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b765f0ee0acfd245$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");

var $kbb8d = parcelRequire("kbb8d");

var $4x3bm = parcelRequire("4x3bm");
function $b765f0ee0acfd245$export$2e2bcd8739ae039(path, displayName) {
    const Component = (props, ref)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $kbb8d.default), (0, $20MOv.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    Component.muiName = (0, $kbb8d.default).muiName;
    return /*#__PURE__*/ $70fFQ.memo(/*#__PURE__*/ $70fFQ.forwardRef(Component));
}

});
parcelRegister("kbb8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb0d7837578d9e6a$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $aAAPW = parcelRequire("aAAPW");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $fTLqq = parcelRequire("fTLqq");

var $4x3bm = parcelRequire("4x3bm");
const $eb0d7837578d9e6a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $eb0d7837578d9e6a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $aAAPW.default)(color)}`,
            `fontSize${(0, $aAAPW.default)(fontSize)}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $fTLqq.getSvgIconUtilityClass), classes);
};
const $eb0d7837578d9e6a$var$SvgIconRoot = (0, $71Pr4.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $aAAPW.default)(ownerState.color)}`],
            styles[`fontSize${(0, $aAAPW.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _theme$palette$ownerS, _theme$palette, _theme$palette$ownerS2, _theme$palette2, _theme$palette2$actio, _theme$palette3, _theme$palette3$actio;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_theme$palette$ownerS = (_theme$palette = theme.palette) == null ? void 0 : (_theme$palette$ownerS2 = _theme$palette[ownerState.color]) == null ? void 0 : _theme$palette$ownerS2.main) != null ? _theme$palette$ownerS : ({
            action: (_theme$palette2 = theme.palette) == null ? void 0 : (_theme$palette2$actio = _theme$palette2.action) == null ? void 0 : _theme$palette2$actio.active,
            disabled: (_theme$palette3 = theme.palette) == null ? void 0 : (_theme$palette3$actio = _theme$palette3.action) == null ? void 0 : _theme$palette3$actio.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $eb0d7837578d9e6a$var$SvgIcon = /*#__PURE__*/ $70fFQ.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $79yYo.default)(props, $eb0d7837578d9e6a$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $eb0d7837578d9e6a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($eb0d7837578d9e6a$var$SvgIconRoot, (0, $20MOv.default)({
        as: component,
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $4x3bm.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$eb0d7837578d9e6a$var$SvgIcon.muiName = "SvgIcon";
var $eb0d7837578d9e6a$export$2e2bcd8739ae039 = $eb0d7837578d9e6a$var$SvgIcon;

});
parcelRegister("fTLqq", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $b930c7bf5502b7b3$export$c7c50641356bdfa5; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $b930c7bf5502b7b3$export$c7c50641356bdfa5(slot) {
    return (0, $dtsUs.default)("MuiSvgIcon", slot);
}
const $b930c7bf5502b7b3$var$svgIconClasses = (0, $jLqVN.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $b930c7bf5502b7b3$export$2e2bcd8739ae039 = $b930c7bf5502b7b3$var$svgIconClasses;

});



parcelRegister("4KbVS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3744b6d3d79210a3$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $3744b6d3d79210a3$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");

});

parcelRegister("7xvOw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d44b07bf2d98a7$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $b913t = parcelRequire("b913t");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $eGmvM = parcelRequire("eGmvM");

var $aAAPW = parcelRequire("aAAPW");

var $7xp03 = parcelRequire("7xp03");

var $auLbN = parcelRequire("auLbN");

var $4x3bm = parcelRequire("4x3bm");
const $57d44b07bf2d98a7$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $57d44b07bf2d98a7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $aAAPW.default)(color)}`,
            `size${(0, $aAAPW.default)(size)}`,
            `${variant}Size${(0, $aAAPW.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $aAAPW.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $aAAPW.default)(size)}`
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $7xp03.getButtonUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $57d44b07bf2d98a7$var$commonIconStyles = (ownerState)=>(0, $20MOv.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $57d44b07bf2d98a7$var$ButtonRoot = (0, $71Pr4.default)((0, $eGmvM.default), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $aAAPW.default)(ownerState.color)}`],
            styles[`size${(0, $aAAPW.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $aAAPW.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: theme.shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $20MOv.default)({
            textDecoration: "none",
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${theme.palette[ownerState.color].main}`,
            backgroundColor: (0, $bFVgt.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.palette.grey.A100,
            boxShadow: theme.shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: theme.shadows[2],
                backgroundColor: theme.palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: theme.palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.palette[ownerState.color].main
            }
        }),
        "&:active": (0, $20MOv.default)({}, ownerState.variant === "contained" && {
            boxShadow: theme.shadows[8]
        }),
        [`&.${(0, $7xp03.default).focusVisible}`]: (0, $20MOv.default)({}, ownerState.variant === "contained" && {
            boxShadow: theme.shadows[6]
        }),
        [`&.${(0, $7xp03.default).disabled}`]: (0, $20MOv.default)({
            color: theme.palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${theme.palette.action.disabledBackground}`
        }, ownerState.variant === "outlined" && ownerState.color === "secondary" && {
            border: `1px solid ${theme.palette.action.disabled}`
        }, ownerState.variant === "contained" && {
            color: theme.palette.action.disabled,
            boxShadow: theme.shadows[0],
            backgroundColor: theme.palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: theme.palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: theme.palette[ownerState.color].main,
        border: `1px solid ${(0, $bFVgt.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.palette.getContrastText(theme.palette.grey[300]),
        backgroundColor: theme.palette.grey[300],
        boxShadow: theme.shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: theme.palette[ownerState.color].contrastText,
        backgroundColor: theme.palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    }), ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $7xp03.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $7xp03.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const $57d44b07bf2d98a7$var$ButtonStartIcon = (0, $71Pr4.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $aAAPW.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $57d44b07bf2d98a7$var$commonIconStyles(ownerState)));
const $57d44b07bf2d98a7$var$ButtonEndIcon = (0, $71Pr4.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $aAAPW.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $57d44b07bf2d98a7$var$commonIconStyles(ownerState)));
const $57d44b07bf2d98a7$var$Button = /*#__PURE__*/ $70fFQ.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $70fFQ.useContext((0, $auLbN.default));
    const resolvedProps = (0, $b913t.default)(contextProps, inProps);
    const props = (0, $cNmNk.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $79yYo.default)(props, $57d44b07bf2d98a7$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $57d44b07bf2d98a7$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $4x3bm.jsx)($57d44b07bf2d98a7$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $4x3bm.jsx)($57d44b07bf2d98a7$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($57d44b07bf2d98a7$var$ButtonRoot, (0, $20MOv.default)({
        ownerState: ownerState,
        className: (0, $gjktY.default)(className, contextProps.className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $gjktY.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $57d44b07bf2d98a7$export$2e2bcd8739ae039 = $57d44b07bf2d98a7$var$Button;

});
parcelRegister("7xp03", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $57cf01f36bedabae$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $57cf01f36bedabae$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $57cf01f36bedabae$export$5a6f9035944c8119(slot) {
    return (0, $dtsUs.default)("MuiButton", slot);
}
const $57cf01f36bedabae$var$buttonClasses = (0, $jLqVN.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $57cf01f36bedabae$export$2e2bcd8739ae039 = $57cf01f36bedabae$var$buttonClasses;

});

parcelRegister("auLbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a414f82d248a2da$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 */ const $7a414f82d248a2da$var$ButtonGroupContext = /*#__PURE__*/ $70fFQ.createContext({});
var $7a414f82d248a2da$export$2e2bcd8739ae039 = $7a414f82d248a2da$var$ButtonGroupContext;

});


parcelRegister("9Vd8j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73939fe8368532d7$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");



var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $bKj54 = parcelRequire("bKj54");

var $hUoUi = parcelRequire("hUoUi");

var $03Ouk = parcelRequire("03Ouk");

var $4oBvo = parcelRequire("4oBvo");

var $aAAPW = parcelRequire("aAAPW");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $bN4Jp = parcelRequire("bN4Jp");

var $4x3bm = parcelRequire("4x3bm");
const $73939fe8368532d7$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size"
];
const $73939fe8368532d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $aAAPW.default)(color)}`
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $bN4Jp.getCheckboxUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $73939fe8368532d7$var$CheckboxRoot = (0, $71Pr4.default)((0, $bKj54.default), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $aAAPW.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        color: theme.palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: (0, $bFVgt.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $bN4Jp.default).checked}, &.${(0, $bN4Jp.default).indeterminate}`]: {
            color: theme.palette[ownerState.color].main
        },
        [`&.${(0, $bN4Jp.default).disabled}`]: {
            color: theme.palette.action.disabled
        }
    }));
const $73939fe8368532d7$var$defaultCheckedIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $03Ouk.default), {});
const $73939fe8368532d7$var$defaultIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hUoUi.default), {});
const $73939fe8368532d7$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4oBvo.default), {});
const $73939fe8368532d7$var$Checkbox = /*#__PURE__*/ $70fFQ.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $73939fe8368532d7$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $73939fe8368532d7$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $73939fe8368532d7$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium" } = props, other = (0, $79yYo.default)(props, $73939fe8368532d7$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $73939fe8368532d7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($73939fe8368532d7$var$CheckboxRoot, (0, $20MOv.default)({
        type: "checkbox",
        inputProps: (0, $20MOv.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $70fFQ.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $70fFQ.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes
    }));
});
var $73939fe8368532d7$export$2e2bcd8739ae039 = $73939fe8368532d7$var$Checkbox;

});
parcelRegister("bKj54", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88d2ca9f829467d0$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $aAAPW = parcelRequire("aAAPW");

var $71Pr4 = parcelRequire("71Pr4");

var $6Apvh = parcelRequire("6Apvh");

var $7kxx2 = parcelRequire("7kxx2");

var $eGmvM = parcelRequire("eGmvM");

var $8TJZ0 = parcelRequire("8TJZ0");

var $4x3bm = parcelRequire("4x3bm");
const $88d2ca9f829467d0$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $88d2ca9f829467d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $aAAPW.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $8TJZ0.getSwitchBaseUtilityClass), classes);
};
const $88d2ca9f829467d0$var$SwitchBaseRoot = (0, $71Pr4.default)((0, $eGmvM.default))(({ ownerState: ownerState })=>(0, $20MOv.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $88d2ca9f829467d0$var$SwitchBaseInput = (0, $71Pr4.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $88d2ca9f829467d0$var$SwitchBase = /*#__PURE__*/ $70fFQ.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $79yYo.default)(props, $88d2ca9f829467d0$var$_excluded);
    const [checked, setCheckedState] = (0, $6Apvh.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $7kxx2.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $20MOv.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $88d2ca9f829467d0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($88d2ca9f829467d0$var$SwitchBaseRoot, (0, $20MOv.default)({
        component: "span",
        className: (0, $gjktY.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($88d2ca9f829467d0$var$SwitchBaseInput, (0, $20MOv.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor && id,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
}); // NB: If changed, please update Checkbox, Switch and Radio
var $88d2ca9f829467d0$export$2e2bcd8739ae039 = $88d2ca9f829467d0$var$SwitchBase;

});
parcelRegister("7kxx2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55646961606079d3$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $eNpqa = parcelRequire("eNpqa");
function $55646961606079d3$export$2e2bcd8739ae039() {
    return $70fFQ.useContext((0, $eNpqa.default));
}

});
parcelRegister("eNpqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac595c6400074fa9$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 */ const $ac595c6400074fa9$var$FormControlContext = /*#__PURE__*/ $70fFQ.createContext();
var $ac595c6400074fa9$export$2e2bcd8739ae039 = $ac595c6400074fa9$var$FormControlContext;

});


parcelRegister("8TJZ0", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", function () { return $67a7210dbb7e9362$export$baa0faa0c7ad8085; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $67a7210dbb7e9362$export$baa0faa0c7ad8085(slot) {
    return (0, $dtsUs.default)("PrivateSwitchBase", slot);
}
const $67a7210dbb7e9362$var$switchBaseClasses = (0, $jLqVN.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $67a7210dbb7e9362$export$2e2bcd8739ae039 = $67a7210dbb7e9362$var$switchBaseClasses;

});


parcelRegister("hUoUi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d09afca8ea29043a$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $d09afca8ea29043a$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRegister("03Ouk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00b771d301c94cb7$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $00b771d301c94cb7$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRegister("4oBvo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33367f1960093264$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $33367f1960093264$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});

parcelRegister("bN4Jp", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", function () { return $8957f0e45022b91f$export$6c57c6e16b4063b; });
$parcel$export(module.exports, "default", function () { return $8957f0e45022b91f$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $8957f0e45022b91f$export$6c57c6e16b4063b(slot) {
    return (0, $dtsUs.default)("MuiCheckbox", slot);
}
const $8957f0e45022b91f$var$checkboxClasses = (0, $jLqVN.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary"
]);
var $8957f0e45022b91f$export$2e2bcd8739ae039 = $8957f0e45022b91f$var$checkboxClasses;

});


parcelRegister("697xl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47996df8ff07669a$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $bLa8E = parcelRequire("bLa8E");

var $aAAPW = parcelRequire("aAAPW");

var $6ATFq = parcelRequire("6ATFq");

var $eNpqa = parcelRequire("eNpqa");

var $lHSl0 = parcelRequire("lHSl0");

var $4x3bm = parcelRequire("4x3bm");
const $47996df8ff07669a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $47996df8ff07669a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $aAAPW.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $lHSl0.getFormControlUtilityClasses), classes);
};
const $47996df8ff07669a$var$FormControlRoot = (0, $71Pr4.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $20MOv.default)({}, styles.root, styles[`margin${(0, $aAAPW.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $47996df8ff07669a$var$FormControl = /*#__PURE__*/ $70fFQ.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $79yYo.default)(props, $47996df8ff07669a$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $47996df8ff07669a$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $70fFQ.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $70fFQ.Children.forEach(children, (child)=>{
            if (!(0, $6ATFq.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $6ATFq.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $bLa8E.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $70fFQ.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $70fFQ.Children.forEach(children, (child)=>{
            if (!(0, $6ATFq.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $bLa8E.isFilled)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $70fFQ.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const onFilled = $70fFQ.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $70fFQ.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        size: size,
        onBlur: ()=>{
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: ()=>{
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $eNpqa.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($47996df8ff07669a$var$FormControlRoot, (0, $20MOv.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $gjktY.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $47996df8ff07669a$export$2e2bcd8739ae039 = $47996df8ff07669a$var$FormControl;

});
parcelRegister("bLa8E", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $88fbf2c8a2aa0e22$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $88fbf2c8a2aa0e22$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $88fbf2c8a2aa0e22$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $88fbf2c8a2aa0e22$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($88fbf2c8a2aa0e22$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $88fbf2c8a2aa0e22$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $88fbf2c8a2aa0e22$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("6ATFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cd14937900d956a$export$2e2bcd8739ae039; });

var $i5Yx2 = parcelRequire("i5Yx2");
var $4cd14937900d956a$export$2e2bcd8739ae039 = (0, $i5Yx2.default);

});
parcelRegister("i5Yx2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2c7a5f8c7653eb0$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
function $d2c7a5f8c7653eb0$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $70fFQ.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRegister("lHSl0", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $fcd7c3799e985f80$export$149c8b8bab2289d1; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $fcd7c3799e985f80$export$149c8b8bab2289d1(slot) {
    return (0, $dtsUs.default)("MuiFormControl", slot);
}
const $fcd7c3799e985f80$var$formControlClasses = (0, $jLqVN.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $fcd7c3799e985f80$export$2e2bcd8739ae039 = $fcd7c3799e985f80$var$formControlClasses;

});


parcelRegister("b2gZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $808d10d8729d1be3$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $7kxx2 = parcelRequire("7kxx2");

var $27ZKj = parcelRequire("27ZKj");

var $aAAPW = parcelRequire("aAAPW");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $kqcxJ = parcelRequire("kqcxJ");

var $et0sX = parcelRequire("et0sX");

var $4x3bm = parcelRequire("4x3bm");
const $808d10d8729d1be3$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "value"
];
const $808d10d8729d1be3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $aAAPW.default)(labelPlacement)}`,
            error && "error"
        ],
        label: [
            "label",
            disabled && "disabled"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $kqcxJ.getFormControlLabelUtilityClasses), classes);
};
const $808d10d8729d1be3$export$1b479270917a5676 = (0, $71Pr4.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $kqcxJ.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $aAAPW.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $kqcxJ.default).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $kqcxJ.default).label}`]: {
            [`&.${(0, $kqcxJ.default).disabled}`]: {
                color: theme.palette.text.disabled
            }
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $808d10d8729d1be3$var$FormControlLabel = /*#__PURE__*/ $70fFQ.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: label, labelPlacement: labelPlacement = "end" } = props, other = (0, $79yYo.default)(props, $808d10d8729d1be3$var$_excluded);
    const muiFormControl = (0, $7kxx2.default)();
    let disabled = disabledProp;
    if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") disabled = control.props.disabled;
    if (typeof disabled === "undefined" && muiFormControl) disabled = muiFormControl.disabled;
    const controlProps = {
        disabled: disabled
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $20MOv.default)({}, props, {
        disabled: disabled,
        label: label,
        labelPlacement: labelPlacement,
        error: fcs.error
    });
    const classes = $808d10d8729d1be3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($808d10d8729d1be3$export$1b479270917a5676, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $70fFQ.cloneElement(control, controlProps),
            label.type === (0, $27ZKj.default) || disableTypography ? label : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), (0, $20MOv.default)({
                component: "span",
                className: classes.label
            }, componentsProps.typography, {
                children: label
            }))
        ]
    }));
});
var $808d10d8729d1be3$export$2e2bcd8739ae039 = $808d10d8729d1be3$var$FormControlLabel;

});
parcelRegister("kqcxJ", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", function () { return $eddff7259e88e0b8$export$717666c39ec07e12; });
$parcel$export(module.exports, "default", function () { return $eddff7259e88e0b8$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $eddff7259e88e0b8$export$717666c39ec07e12(slot) {
    return (0, $dtsUs.default)("MuiFormControlLabel", slot);
}
const $eddff7259e88e0b8$var$formControlLabelClasses = (0, $jLqVN.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error"
]);
var $eddff7259e88e0b8$export$2e2bcd8739ae039 = $eddff7259e88e0b8$var$formControlLabelClasses;

});

parcelRegister("et0sX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a88422acd7c0fc0e$export$2e2bcd8739ae039; });
function $a88422acd7c0fc0e$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});


parcelRegister("7adKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5374211c7856a294$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $et0sX = parcelRequire("et0sX");

var $7kxx2 = parcelRequire("7kxx2");

var $71Pr4 = parcelRequire("71Pr4");

var $aAAPW = parcelRequire("aAAPW");

var $b24N6 = parcelRequire("b24N6");

var $cNmNk = parcelRequire("cNmNk");

var $4x3bm = parcelRequire("4x3bm");
var $5374211c7856a294$var$_span;
const $5374211c7856a294$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $5374211c7856a294$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $aAAPW.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $b24N6.getFormHelperTextUtilityClasses), classes);
};
const $5374211c7856a294$var$FormHelperTextRoot = (0, $71Pr4.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $aAAPW.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        color: theme.palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $b24N6.default).disabled}`]: {
            color: theme.palette.text.disabled
        },
        [`&.${(0, $b24N6.default).error}`]: {
            color: theme.palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $5374211c7856a294$var$FormHelperText = /*#__PURE__*/ $70fFQ.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $79yYo.default)(props, $5374211c7856a294$var$_excluded);
    const muiFormControl = (0, $7kxx2.default)();
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $5374211c7856a294$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($5374211c7856a294$var$FormHelperTextRoot, (0, $20MOv.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $5374211c7856a294$var$_span || ($5374211c7856a294$var$_span = /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $5374211c7856a294$export$2e2bcd8739ae039 = $5374211c7856a294$var$FormHelperText;

});
parcelRegister("b24N6", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $808398fed9101092$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $808398fed9101092$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $808398fed9101092$export$a394fa61b1d583a9(slot) {
    return (0, $dtsUs.default)("MuiFormHelperText", slot);
}
const $808398fed9101092$var$formHelperTextClasses = (0, $jLqVN.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $808398fed9101092$export$2e2bcd8739ae039 = $808398fed9101092$var$formHelperTextClasses;

});


parcelRegister("8VJ2N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68069668e274bf05$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $bXmqm = parcelRequire("bXmqm");
var $859H5 = parcelRequire("859H5");

var $8dWxZ = parcelRequire("8dWxZ");


var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $34Wpi = parcelRequire("34Wpi");

var $kHgYA = parcelRequire("kHgYA");

var $4x3bm = parcelRequire("4x3bm");
const $68069668e274bf05$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "lg",
    "md",
    "rowSpacing",
    "sm",
    "spacing",
    "wrap",
    "xl",
    "xs",
    "zeroMinWidth"
];
function $68069668e274bf05$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $68069668e274bf05$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $bXmqm.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
             // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$68069668e274bf05$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            } // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $20MOv.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        } // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $68069668e274bf05$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $bXmqm.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $bXmqm.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $kHgYA.default).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
function $68069668e274bf05$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $bXmqm.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        styles = (0, $bXmqm.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$68069668e274bf05$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $kHgYA.default).item}`]: {
                    paddingTop: $68069668e274bf05$var$getOffset(themeSpacing)
                }
            };
            return {};
        });
    }
    return styles;
}
function $68069668e274bf05$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $bXmqm.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        styles = (0, $bXmqm.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$68069668e274bf05$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$68069668e274bf05$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $kHgYA.default).item}`]: {
                    paddingLeft: $68069668e274bf05$var$getOffset(themeSpacing)
                }
            };
            return {};
        });
    }
    return styles;
}
function $68069668e274bf05$export$2d1097e8e67cf24b(spacing, container, styles = {}) {
    // in case of grid item or undefined/null or `spacing` <= 0
    if (!container || !spacing || spacing <= 0) return [];
     // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`] || `spacing-xs-${String(spacing)}`
    ];
     // in case of object `spacing`
    const { xs: xs, sm: sm, md: md, lg: lg, xl: xl } = spacing;
    return [
        Number(xs) > 0 && (styles[`spacing-xs-${String(xs)}`] || `spacing-xs-${String(xs)}`),
        Number(sm) > 0 && (styles[`spacing-sm-${String(sm)}`] || `spacing-sm-${String(sm)}`),
        Number(md) > 0 && (styles[`spacing-md-${String(md)}`] || `spacing-md-${String(md)}`),
        Number(lg) > 0 && (styles[`spacing-lg-${String(lg)}`] || `spacing-lg-${String(lg)}`),
        Number(xl) > 0 && (styles[`spacing-xl-${String(xl)}`] || `spacing-xl-${String(xl)}`)
    ];
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $68069668e274bf05$var$GridRoot = (0, $71Pr4.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { container: container, direction: direction, item: item, lg: lg, md: md, sm: sm, spacing: spacing, wrap: wrap, xl: xl, xs: xs, zeroMinWidth: zeroMinWidth } = props.ownerState;
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...$68069668e274bf05$export$2d1097e8e67cf24b(spacing, container, styles),
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            xs !== false && styles[`grid-xs-${String(xs)}`],
            sm !== false && styles[`grid-sm-${String(sm)}`],
            md !== false && styles[`grid-md-${String(md)}`],
            lg !== false && styles[`grid-lg-${String(lg)}`],
            xl !== false && styles[`grid-xl-${String(xl)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $68069668e274bf05$export$71d4225eeb1bc13e, $68069668e274bf05$export$380604d7c79f9e8f, $68069668e274bf05$export$4315fba5128fb4a1, $68069668e274bf05$export$ca2a698f6020fda);
const $68069668e274bf05$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, lg: lg, md: md, sm: sm, spacing: spacing, wrap: wrap, xl: xl, xs: xs, zeroMinWidth: zeroMinWidth } = ownerState;
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...$68069668e274bf05$export$2d1097e8e67cf24b(spacing, container),
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            xs !== false && `grid-xs-${String(xs)}`,
            sm !== false && `grid-sm-${String(sm)}`,
            md !== false && `grid-md-${String(md)}`,
            lg !== false && `grid-lg-${String(lg)}`,
            xl !== false && `grid-xl-${String(xl)}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $kHgYA.getGridUtilityClass), classes);
};
const $68069668e274bf05$var$Grid = /*#__PURE__*/ $70fFQ.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const props = (0, $859H5.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, lg: lg = false, md: md = false, rowSpacing: rowSpacingProp, sm: sm = false, spacing: spacing = 0, wrap: wrap = "wrap", xl: xl = false, xs: xs = false, zeroMinWidth: zeroMinWidth = false } = props, other = (0, $79yYo.default)(props, $68069668e274bf05$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $70fFQ.useContext((0, $34Wpi.default)); // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const ownerState = (0, $20MOv.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        lg: lg,
        md: md,
        sm: sm,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        xl: xl,
        xs: xs,
        zeroMinWidth: zeroMinWidth
    });
    const classes = $68069668e274bf05$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $34Wpi.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($68069668e274bf05$var$GridRoot, (0, $20MOv.default)({
            ownerState: ownerState,
            className: (0, $gjktY.default)(classes.root, className),
            as: component,
            ref: ref
        }, other))
    });
});
var $68069668e274bf05$export$2e2bcd8739ae039 = $68069668e274bf05$var$Grid;

});
parcelRegister("34Wpi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23df0d4114cb8c80$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 */ const $23df0d4114cb8c80$var$GridContext = /*#__PURE__*/ $70fFQ.createContext();
var $23df0d4114cb8c80$export$2e2bcd8739ae039 = $23df0d4114cb8c80$var$GridContext;

});

parcelRegister("kHgYA", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", function () { return $f114fde7048d4e40$export$9973ac5fd0181f33; });
$parcel$export(module.exports, "default", function () { return $f114fde7048d4e40$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $f114fde7048d4e40$export$9973ac5fd0181f33(slot) {
    return (0, $dtsUs.default)("MuiGrid", slot);
}
const $f114fde7048d4e40$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f114fde7048d4e40$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $f114fde7048d4e40$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $f114fde7048d4e40$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f114fde7048d4e40$var$gridClasses = (0, $jLqVN.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    ...$f114fde7048d4e40$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    ...$f114fde7048d4e40$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    ...$f114fde7048d4e40$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    ...$f114fde7048d4e40$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f114fde7048d4e40$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f114fde7048d4e40$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f114fde7048d4e40$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f114fde7048d4e40$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f114fde7048d4e40$export$2e2bcd8739ae039 = $f114fde7048d4e40$var$gridClasses;

});


parcelRegister("3cESc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $255232a4a7eebed8$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $8dWxZ = parcelRequire("8dWxZ");

var $jWrHX = parcelRequire("jWrHX");

var $5DHXT = parcelRequire("5DHXT");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $1k5uZ = parcelRequire("1k5uZ");

var $5DHXT = parcelRequire("5DHXT");

var $4x3bm = parcelRequire("4x3bm");
const $255232a4a7eebed8$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "type"
];
const $255232a4a7eebed8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $1k5uZ.getInputUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $255232a4a7eebed8$var$InputRoot = (0, $71Pr4.default)((0, $5DHXT.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $5DHXT.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return (0, $20MOv.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $1k5uZ.default).focused}:after`]: {
            transform: "scaleX(1)"
        },
        [`&.${(0, $1k5uZ.default).error}:after`]: {
            borderBottomColor: theme.palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $1k5uZ.default).disabled}):before`]: {
            borderBottom: `2px solid ${theme.palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $1k5uZ.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $255232a4a7eebed8$var$InputInput = (0, $71Pr4.default)((0, $5DHXT.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $5DHXT.inputOverridesResolver)
})({});
const $255232a4a7eebed8$var$Input = /*#__PURE__*/ $70fFQ.forwardRef(function Input(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, type: type = "text" } = props, other = (0, $79yYo.default)(props, $255232a4a7eebed8$var$_excluded);
    const classes = $255232a4a7eebed8$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = componentsPropsProp ? (0, $jWrHX.default)(componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), (0, $20MOv.default)({
        components: (0, $20MOv.default)({
            Root: $255232a4a7eebed8$var$InputRoot,
            Input: $255232a4a7eebed8$var$InputInput
        }, components),
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$255232a4a7eebed8$var$Input.muiName = "Input";
var $255232a4a7eebed8$export$2e2bcd8739ae039 = $255232a4a7eebed8$var$Input;

});
parcelRegister("5DHXT", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $41b2b2c85bd8ddf8$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $41b2b2c85bd8ddf8$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $41b2b2c85bd8ddf8$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseComponent", function () { return $41b2b2c85bd8ddf8$export$a1ad29c901026019; });
$parcel$export(module.exports, "default", function () { return $41b2b2c85bd8ddf8$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $awKLE = parcelRequire("awKLE");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $gZaTl = parcelRequire("gZaTl");
var $dAWOM = parcelRequire("dAWOM");
var $8dWxZ = parcelRequire("8dWxZ");

var $et0sX = parcelRequire("et0sX");

var $eNpqa = parcelRequire("eNpqa");

var $7kxx2 = parcelRequire("7kxx2");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $aAAPW = parcelRequire("aAAPW");

var $5Up1l = parcelRequire("5Up1l");

var $7kxc8 = parcelRequire("7kxc8");

var $kfZqu = parcelRequire("kfZqu");

var $bLa8E = parcelRequire("bLa8E");

var $b29Hy = parcelRequire("b29Hy");

var $4x3bm = parcelRequire("4x3bm");
const $41b2b2c85bd8ddf8$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "startAdornment",
    "type",
    "value"
];
const $41b2b2c85bd8ddf8$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $aAAPW.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $41b2b2c85bd8ddf8$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $41b2b2c85bd8ddf8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $aAAPW.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $b29Hy.getInputBaseUtilityClass), classes);
};
const $41b2b2c85bd8ddf8$export$298a043133d72a38 = (0, $71Pr4.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $41b2b2c85bd8ddf8$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, theme.typography.body1, {
        color: theme.palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $b29Hy.default).disabled}`]: {
            color: theme.palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $20MOv.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $41b2b2c85bd8ddf8$export$a1ad29c901026019 = (0, $71Pr4.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $41b2b2c85bd8ddf8$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $20MOv.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $b29Hy.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $b29Hy.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: theme.palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $41b2b2c85bd8ddf8$var$inputGlobalStyles = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $kfZqu.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $41b2b2c85bd8ddf8$var$InputBase = /*#__PURE__*/ $70fFQ.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $79yYo.default)(props, $41b2b2c85bd8ddf8$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $70fFQ.useRef(value != null);
    const inputRef = $70fFQ.useRef();
    const handleInputRefWarning = $70fFQ.useCallback((instance)=>{}, []);
    const handleInputPropsRefProp = (0, $5Up1l.default)(inputPropsProp.ref, handleInputRefWarning);
    const handleInputRefProp = (0, $5Up1l.default)(inputRefProp, handleInputPropsRefProp);
    const handleInputRef = (0, $5Up1l.default)(inputRef, handleInputRefProp);
    const [focused, setFocused] = $70fFQ.useState(false);
    const muiFormControl = (0, $7kxx2.default)();
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $70fFQ.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $70fFQ.useCallback((obj)=>{
        if ((0, $bLa8E.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $7kxc8.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $awKLE.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
         // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $70fFQ.useEffect(()=>{
        checkDirty(inputRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $20MOv.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $20MOv.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $dAWOM.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $70fFQ.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $41b2b2c85bd8ddf8$var$useUtilityClasses(ownerState);
    const Root = components.Root || $41b2b2c85bd8ddf8$export$298a043133d72a38;
    const rootProps = componentsProps.root || {};
    const Input = components.Input || $41b2b2c85bd8ddf8$export$a1ad29c901026019;
    inputProps = (0, $20MOv.default)({}, inputProps, componentsProps.input);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $41b2b2c85bd8ddf8$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $4x3bm.jsxs)(Root, (0, $20MOv.default)({}, rootProps, !(0, $gZaTl.default)(Root) && {
                ownerState: (0, $20MOv.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $gjktY.default)(classes.root, rootProps.className, className),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $eNpqa.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)(Input, (0, $20MOv.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $gZaTl.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $20MOv.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $gjktY.default)(classes.input, inputProps.className),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $20MOv.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $41b2b2c85bd8ddf8$export$2e2bcd8739ae039 = $41b2b2c85bd8ddf8$var$InputBase;

});
parcelRegister("dAWOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e5c432a8bb7977e$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $5NQ9H = parcelRequire("5NQ9H");
var $blhVx = parcelRequire("blhVx");
var $qEgbK = parcelRequire("qEgbK");
var $4Rshd = parcelRequire("4Rshd");

var $4x3bm = parcelRequire("4x3bm");
const $9e5c432a8bb7977e$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $9e5c432a8bb7977e$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
const $9e5c432a8bb7977e$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
const $9e5c432a8bb7977e$var$TextareaAutosize = /*#__PURE__*/ $70fFQ.forwardRef(function TextareaAutosize(props, ref) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $79yYo.default)(props, $9e5c432a8bb7977e$var$_excluded);
    const { current: isControlled } = $70fFQ.useRef(value != null);
    const inputRef = $70fFQ.useRef(null);
    const handleRef = (0, $4Rshd.default)(ref, inputRef);
    const shadowRef = $70fFQ.useRef(null);
    const renders = $70fFQ.useRef(0);
    const [state, setState] = $70fFQ.useState({});
    const syncHeight = $70fFQ.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $blhVx.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return;
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle["box-sizing"];
        const padding = $9e5c432a8bb7977e$var$getStyleValue(computedStyle, "padding-bottom") + $9e5c432a8bb7977e$var$getStyleValue(computedStyle, "padding-top");
        const border = $9e5c432a8bb7977e$var$getStyleValue(computedStyle, "border-bottom-width") + $9e5c432a8bb7977e$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        const innerHeight = inputShallow.scrollHeight; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight; // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState((prevState)=>{
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $70fFQ.useEffect(()=>{
        const handleResize = (0, $5NQ9H.default)(()=>{
            renders.current = 0;
            syncHeight();
        });
        const containerWindow = (0, $blhVx.default)(inputRef.current);
        containerWindow.addEventListener("resize", handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(inputRef.current);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        syncHeight
    ]);
    (0, $qEgbK.default)(()=>{
        syncHeight();
    });
    $70fFQ.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("textarea", (0, $20MOv.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
                ,
                rows: minRows,
                style: (0, $20MOv.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : null
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $4x3bm.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $20MOv.default)({}, $9e5c432a8bb7977e$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $9e5c432a8bb7977e$export$2e2bcd8739ae039 = $9e5c432a8bb7977e$var$TextareaAutosize;

});
parcelRegister("5NQ9H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4399fc5ca6385ca5$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $4399fc5ca6385ca5$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("blhVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $841f8fce851348da$export$2e2bcd8739ae039; });

var $iMBVa = parcelRequire("iMBVa");
function $841f8fce851348da$export$2e2bcd8739ae039(node) {
    const doc = (0, $iMBVa.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("7kxc8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55642675be122f73$export$2e2bcd8739ae039; });

var $qEgbK = parcelRequire("qEgbK");
var $55642675be122f73$export$2e2bcd8739ae039 = (0, $qEgbK.default);

});

parcelRegister("kfZqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf4db5622d88ab9$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");
parcelRequire("70fFQ");


var $lpQxs = parcelRequire("lpQxs");

var $7Rxn3 = parcelRequire("7Rxn3");

var $4x3bm = parcelRequire("4x3bm");
function $ebf4db5622d88ab9$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $lpQxs.default), (0, $20MOv.default)({}, props, {
        defaultTheme: (0, $7Rxn3.default)
    }));
}
var $ebf4db5622d88ab9$export$2e2bcd8739ae039 = $ebf4db5622d88ab9$var$GlobalStyles;

});

parcelRegister("b29Hy", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $808768244282a2c3$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $808768244282a2c3$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $808768244282a2c3$export$ef57d5c8ca2278f6(slot) {
    return (0, $dtsUs.default)("MuiInputBase", slot);
}
const $808768244282a2c3$var$inputBaseClasses = (0, $jLqVN.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $808768244282a2c3$export$2e2bcd8739ae039 = $808768244282a2c3$var$inputBaseClasses;

});


parcelRegister("1k5uZ", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $0f6beca82e532312$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $0f6beca82e532312$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");

var $b29Hy = parcelRequire("b29Hy");
function $0f6beca82e532312$export$cdb270390122322b(slot) {
    return (0, $dtsUs.default)("MuiInput", slot);
}
const $0f6beca82e532312$var$inputClasses = (0, $20MOv.default)({}, (0, $b29Hy.default), (0, $jLqVN.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $0f6beca82e532312$export$2e2bcd8739ae039 = $0f6beca82e532312$var$inputClasses;

});


parcelRegister("1IOh3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1410e5deaf6964c2$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $8dWxZ = parcelRequire("8dWxZ");

var $et0sX = parcelRequire("et0sX");

var $7kxx2 = parcelRequire("7kxx2");

var $3mOp8 = parcelRequire("3mOp8");
var $50R4F = parcelRequire("50R4F");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $8l2Tl = parcelRequire("8l2Tl");

var $4x3bm = parcelRequire("4x3bm");
const $1410e5deaf6964c2$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant"
];
const $1410e5deaf6964c2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size === "small" && "sizeSmall",
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $8l2Tl.getInputLabelUtilityClasses), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $1410e5deaf6964c2$var$InputLabelRoot = (0, $71Pr4.default)((0, $3mOp8.default), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $50R4F.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $20MOv.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $20MOv.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $20MOv.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        maxWidth: "calc(133% - 24px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $1410e5deaf6964c2$var$InputLabel = /*#__PURE__*/ $70fFQ.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $cNmNk.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp } = props, other = (0, $79yYo.default)(props, $1410e5deaf6964c2$var$_excluded);
    const muiFormControl = (0, $7kxx2.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $20MOv.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $1410e5deaf6964c2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($1410e5deaf6964c2$var$InputLabelRoot, (0, $20MOv.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes
    }));
});
var $1410e5deaf6964c2$export$2e2bcd8739ae039 = $1410e5deaf6964c2$var$InputLabel;

});
parcelRegister("3mOp8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273a8670c118dbc2$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $et0sX = parcelRequire("et0sX");

var $7kxx2 = parcelRequire("7kxx2");

var $aAAPW = parcelRequire("aAAPW");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $50R4F = parcelRequire("50R4F");

var $4x3bm = parcelRequire("4x3bm");
const $273a8670c118dbc2$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $273a8670c118dbc2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $aAAPW.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $50R4F.getFormLabelUtilityClasses), classes);
};
const $273a8670c118dbc2$export$aa5bc7f8a4705b27 = (0, $71Pr4.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $20MOv.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        color: theme.palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $50R4F.default).focused}`]: {
            color: theme.palette[ownerState.color].main
        },
        [`&.${(0, $50R4F.default).disabled}`]: {
            color: theme.palette.text.disabled
        },
        [`&.${(0, $50R4F.default).error}`]: {
            color: theme.palette.error.main
        }
    }));
const $273a8670c118dbc2$var$AsteriskComponent = (0, $71Pr4.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $50R4F.default).error}`]: {
            color: theme.palette.error.main
        }
    }));
const $273a8670c118dbc2$var$FormLabel = /*#__PURE__*/ $70fFQ.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $79yYo.default)(props, $273a8670c118dbc2$var$_excluded);
    const muiFormControl = (0, $7kxx2.default)();
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $20MOv.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $273a8670c118dbc2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($273a8670c118dbc2$export$aa5bc7f8a4705b27, (0, $20MOv.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $4x3bm.jsxs)($273a8670c118dbc2$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $273a8670c118dbc2$export$2e2bcd8739ae039 = $273a8670c118dbc2$var$FormLabel;

});
parcelRegister("50R4F", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $3a661f46a520c695$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $3a661f46a520c695$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $3a661f46a520c695$export$f7d501e40371cd17(slot) {
    return (0, $dtsUs.default)("MuiFormLabel", slot);
}
const $3a661f46a520c695$var$formLabelClasses = (0, $jLqVN.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $3a661f46a520c695$export$2e2bcd8739ae039 = $3a661f46a520c695$var$formLabelClasses;

});


parcelRegister("8l2Tl", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $612287198d59478a$export$c1c4b4545ad2ea5f; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $612287198d59478a$export$c1c4b4545ad2ea5f(slot) {
    return (0, $dtsUs.default)("MuiInputLabel", slot);
}
const $612287198d59478a$var$inputLabelClasses = (0, $jLqVN.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $612287198d59478a$export$2e2bcd8739ae039 = $612287198d59478a$var$inputLabelClasses;

});


parcelRegister("etOpj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8aadff1801af161$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

const $a8aadff1801af161$var$Spinner = (props)=>{
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", (0, $edHbI._)((0, $2QP2i._)({
        className: "loader-container"
    }, props), {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)("svg", {
            className: "loader",
            viewBox: "25 25 50 50",
            children: /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                className: "path",
                cx: "50",
                cy: "50",
                r: "20",
                fill: "none",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            })
        })
    }));
};
var $a8aadff1801af161$export$2e2bcd8739ae039 = $a8aadff1801af161$var$Spinner;

});

parcelRegister("fuVrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48637cbf37e751f$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $ci6ap = parcelRequire("ci6ap");

var $4x3bm = parcelRequire("4x3bm");
const $b48637cbf37e751f$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $b48637cbf37e751f$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $ci6ap.getDividerUtilityClass), classes);
};
const $b48637cbf37e751f$var$DividerRoot = (0, $71Pr4.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: (0, $bFVgt.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            position: "relative",
            width: "100%",
            borderTop: `thin solid ${theme.palette.divider}`,
            top: "50%",
            content: '""',
            transform: "translateY(50%)"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            top: "0%",
            left: "50%",
            borderTop: 0,
            borderLeft: `thin solid ${theme.palette.divider}`,
            transform: "translateX(0%)"
        }
    }), ({ ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $b48637cbf37e751f$var$DividerWrapper = (0, $71Pr4.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $b48637cbf37e751f$var$Divider = /*#__PURE__*/ $70fFQ.forwardRef(function Divider(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $79yYo.default)(props, $b48637cbf37e751f$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $b48637cbf37e751f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($b48637cbf37e751f$var$DividerRoot, (0, $20MOv.default)({
        as: component,
        className: (0, $gjktY.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $4x3bm.jsx)($b48637cbf37e751f$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
var $b48637cbf37e751f$export$2e2bcd8739ae039 = $b48637cbf37e751f$var$Divider;

});
parcelRegister("ci6ap", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", function () { return $8f2bf31d1d47ab7a$export$46f01d01378ec5a2; });
$parcel$export(module.exports, "default", function () { return $8f2bf31d1d47ab7a$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $8f2bf31d1d47ab7a$export$46f01d01378ec5a2(slot) {
    return (0, $dtsUs.default)("MuiDivider", slot);
}
const $8f2bf31d1d47ab7a$var$dividerClasses = (0, $jLqVN.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $8f2bf31d1d47ab7a$export$2e2bcd8739ae039 = $8f2bf31d1d47ab7a$var$dividerClasses;

});


parcelRegister("cGU07", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93d4d8e3178ba8d7$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $eGmvM = parcelRequire("eGmvM");

var $aAAPW = parcelRequire("aAAPW");

var $b7I6J = parcelRequire("b7I6J");

var $4x3bm = parcelRequire("4x3bm");
const $93d4d8e3178ba8d7$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $93d4d8e3178ba8d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $aAAPW.default)(color)}`,
            edge && `edge${(0, $aAAPW.default)(edge)}`,
            `size${(0, $aAAPW.default)(size)}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $b7I6J.getIconButtonUtilityClass), classes);
};
const $93d4d8e3178ba8d7$var$IconButtonRoot = (0, $71Pr4.default)((0, $eGmvM.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $aAAPW.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $aAAPW.default)(ownerState.edge)}`],
            styles[`size${(0, $aAAPW.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: theme.palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $20MOv.default)({
        color: theme.palette[ownerState.color].main
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $b7I6J.default).disabled}`]: {
            backgroundColor: "transparent",
            color: theme.palette.action.disabled
        }
    }));
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ const $93d4d8e3178ba8d7$var$IconButton = /*#__PURE__*/ $70fFQ.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $79yYo.default)(props, $93d4d8e3178ba8d7$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $93d4d8e3178ba8d7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($93d4d8e3178ba8d7$var$IconButtonRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $93d4d8e3178ba8d7$export$2e2bcd8739ae039 = $93d4d8e3178ba8d7$var$IconButton;

});
parcelRegister("b7I6J", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $81928ffa710c6024$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $81928ffa710c6024$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $81928ffa710c6024$export$5e8702d71474f093(slot) {
    return (0, $dtsUs.default)("MuiIconButton", slot);
}
const $81928ffa710c6024$var$iconButtonClasses = (0, $jLqVN.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $81928ffa710c6024$export$2e2bcd8739ae039 = $81928ffa710c6024$var$iconButtonClasses;

});


parcelRegister("dsTz1", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $89b98fd5f6a9c559$export$3ae376d12526dd6f; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $3NIZY = parcelRequire("3NIZY");

var $dsi9Z = parcelRequire("dsi9Z");

var $cvSBx = parcelRequire("cvSBx");
function $89b98fd5f6a9c559$var$getChildKey(child) {
    return child.key || "";
}
function $89b98fd5f6a9c559$var$updateChildLookup(children, allChildren) {
    var seenChildren = null;
    children.forEach(function(child) {
        var key = $89b98fd5f6a9c559$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $89b98fd5f6a9c559$var$onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $70fFQ.Children).forEach(children, function(child) {
        if ((0, $70fFQ.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $89b98fd5f6a9c559$export$3ae376d12526dd6f = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var _d = (0, $h2AC2.__read)((0, $3NIZY.useForceUpdate)(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = (0, $70fFQ.useContext)((0, $cvSBx.LayoutGroupContext)).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    var isInitialRender = (0, $70fFQ.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = $89b98fd5f6a9c559$var$onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, $70fFQ.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0, $70fFQ.useRef)(new Map()).current;
    // A living record of all currently exiting components.
    var exiting = (0, $70fFQ.useRef)(new Set()).current;
    $89b98fd5f6a9c559$var$updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return $70fFQ.createElement($70fFQ.Fragment, null, filteredChildren.map(function(child) {
            return $70fFQ.createElement((0, $dsi9Z.PresenceChild), {
                key: $89b98fd5f6a9c559$var$getChildKey(child),
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout
            }, child);
        }));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)(filteredChildren), false);
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map($89b98fd5f6a9c559$var$getChildKey);
    var targetKeys = filteredChildren.map($89b98fd5f6a9c559$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
        else // In case this key has re-entered, remove from the exiting list
        exiting.delete(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $70fFQ.createElement((0, $dsi9Z.PresenceChild), {
            key: $89b98fd5f6a9c559$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : $70fFQ.createElement((0, $dsi9Z.PresenceChild), {
            key: $89b98fd5f6a9c559$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    presentChildren.current = childrenToRender;
    return $70fFQ.createElement($70fFQ.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, $70fFQ.cloneElement)(child);
    }));
};

});
parcelRegister("h2AC2", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $c67f060bb024e5f4$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $c67f060bb024e5f4$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $c67f060bb024e5f4$export$3c9a16f847548506; });
$parcel$export(module.exports, "__read", function () { return $c67f060bb024e5f4$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $c67f060bb024e5f4$export$1216008129fb82ed; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c67f060bb024e5f4$var$extendStatics = function(d, b) {
    $c67f060bb024e5f4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c67f060bb024e5f4$var$extendStatics(d, b);
};
function $c67f060bb024e5f4$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c67f060bb024e5f4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c67f060bb024e5f4$export$18ce0697a983be9b = function() {
    $c67f060bb024e5f4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c67f060bb024e5f4$export$18ce0697a983be9b.apply(this, arguments);
};
function $c67f060bb024e5f4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c67f060bb024e5f4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c67f060bb024e5f4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c67f060bb024e5f4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c67f060bb024e5f4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c67f060bb024e5f4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c67f060bb024e5f4$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c67f060bb024e5f4$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c67f060bb024e5f4$export$45d3717a4c69092e(o, m, p);
}
function $c67f060bb024e5f4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c67f060bb024e5f4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c67f060bb024e5f4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c67f060bb024e5f4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c67f060bb024e5f4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c67f060bb024e5f4$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c67f060bb024e5f4$export$10c90e4f7922046c(v) {
    return this instanceof $c67f060bb024e5f4$export$10c90e4f7922046c ? (this.v = v, this) : new $c67f060bb024e5f4$export$10c90e4f7922046c(v);
}
function $c67f060bb024e5f4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c67f060bb024e5f4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c67f060bb024e5f4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c67f060bb024e5f4$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c67f060bb024e5f4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c67f060bb024e5f4$export$19a8beecd37a4c45 === "function" ? $c67f060bb024e5f4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c67f060bb024e5f4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c67f060bb024e5f4$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c67f060bb024e5f4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c67f060bb024e5f4$export$45d3717a4c69092e(result, mod, k);
    }
    $c67f060bb024e5f4$var$__setModuleDefault(result, mod);
    return result;
}
function $c67f060bb024e5f4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c67f060bb024e5f4$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c67f060bb024e5f4$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}

});

parcelRegister("3NIZY", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", function () { return $58f81abe17889c42$export$91db9bc4f8ac944a; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $lrQ4W = parcelRequire("lrQ4W");
function $58f81abe17889c42$export$91db9bc4f8ac944a() {
    var unloadingRef = (0, $70fFQ.useRef)(false);
    var _a = (0, $h2AC2.__read)((0, $70fFQ.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0, $lrQ4W.useUnmountEffect)(function() {
        return unloadingRef.current = true;
    });
    return [
        (0, $70fFQ.useCallback)(function() {
            !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
        }, [
            forcedRenderCount
        ]),
        forcedRenderCount
    ];
}

});
parcelRegister("lrQ4W", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", function () { return $7584666275c5c37f$export$f3a192d0cbd30b96; });

var $70fFQ = parcelRequire("70fFQ");
function $7584666275c5c37f$export$f3a192d0cbd30b96(callback) {
    return (0, $70fFQ.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}

});


parcelRegister("dsi9Z", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $b0d24c04459b5301$export$979daf65881a382a; });

var $70fFQ = parcelRequire("70fFQ");

var $2etTF = parcelRequire("2etTF");

var $0h0lm = parcelRequire("0h0lm");
var $b0d24c04459b5301$var$presenceId = 0;
function $b0d24c04459b5301$var$getPresenceId() {
    var id = $b0d24c04459b5301$var$presenceId;
    $b0d24c04459b5301$var$presenceId++;
    return id;
}
var $b0d24c04459b5301$export$979daf65881a382a = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0, $0h0lm.useConstant)($b0d24c04459b5301$var$newChildrenMap);
    var id = (0, $0h0lm.useConstant)($b0d24c04459b5301$var$getPresenceId);
    var context = (0, $70fFQ.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                presenceChildren.set(childId, true);
                var allComplete = true;
                presenceChildren.forEach(function(isComplete) {
                    if (!isComplete) allComplete = false;
                });
                allComplete && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $70fFQ.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $70fFQ.useEffect(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return $70fFQ.createElement((0, $2etTF.PresenceContext).Provider, {
        value: context
    }, children);
};
function $b0d24c04459b5301$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("2etTF", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $d9eca87129c44a0c$export$f224e4635b6f8ce2; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @public
 */ var $d9eca87129c44a0c$export$f224e4635b6f8ce2 = (0, $70fFQ.createContext)(null);

});

parcelRegister("0h0lm", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $f8fa4b18c4142d92$export$fe4300aa8eebea86; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $f8fa4b18c4142d92$export$fe4300aa8eebea86(init) {
    var ref = (0, $70fFQ.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});


parcelRegister("cvSBx", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $84b9f3306a556010$export$a3579ca508007a95; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @internal
 */ var $84b9f3306a556010$export$a3579ca508007a95 = (0, $70fFQ.createContext)({});

});


parcelRegister("6mDA2", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $dbaa9550a0bc7db7$export$e25e478948902b8b; });

var $h2AC2 = parcelRequire("h2AC2");

var $knVM4 = parcelRequire("knVM4");

var $6mbap = parcelRequire("6mbap");

var $4uQc8 = parcelRequire("4uQc8");

var $dNS1d = parcelRequire("dNS1d");

var $3J11a = parcelRequire("3J11a");

var $gy4YE = parcelRequire("gy4YE");

var $dAoXe = parcelRequire("dAoXe");

var $cBKqW = parcelRequire("cBKqW");
var $dbaa9550a0bc7db7$var$featureBundle = (0, $h2AC2.__assign)((0, $h2AC2.__assign)((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, (0, $3J11a.animations)), (0, $dNS1d.gestureAnimations)), (0, $gy4YE.drag)), (0, $cBKqW.layoutFeatures));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $dbaa9550a0bc7db7$export$e25e478948902b8b = /*@__PURE__*/ (0, $6mbap.createMotionProxy)(function(Component, config) {
    return (0, $4uQc8.createDomMotionConfig)(Component, config, $dbaa9550a0bc7db7$var$featureBundle, (0, $dAoXe.createDomVisualElement));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $dbaa9550a0bc7db7$export$546614c4a05701f9(key) {
    return (0, $knVM4.createMotionComponent)((0, $4uQc8.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $dbaa9550a0bc7db7$var$featureBundle, (0, $dAoXe.createDomVisualElement)));
}

});
parcelRegister("knVM4", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $27dd377e53cdc311$export$46b7e4b9dc6110c3; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $h0zNP = parcelRequire("h0zNP");

var $i715C = parcelRequire("i715C");

var $7aiFr = parcelRequire("7aiFr");

var $ees8x = parcelRequire("ees8x");

var $7DJUj = parcelRequire("7DJUj");

var $dEEWK = parcelRequire("dEEWK");

var $jNGoK = parcelRequire("jNGoK");

var $gzrOo = parcelRequire("gzrOo");

var $4ISm9 = parcelRequire("4ISm9");

var $cvSBx = parcelRequire("cvSBx");

var $iHdVw = parcelRequire("iHdVw");

var $axLzK = parcelRequire("axLzK");

var $9X7ZU = parcelRequire("9X7ZU");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */ function $27dd377e53cdc311$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $jNGoK.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = $27dd377e53cdc311$var$useLayoutId(props);
        props = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, props), {
            layoutId: layoutId
        });
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var config = (0, $70fFQ.useContext)((0, $i715C.MotionConfigContext));
        var features = null;
        /**
         * Create the tree context. This is memoized and will only trigger renders
         * when the current tree variant changes in static mode.
         */ var context = (0, $dEEWK.useCreateMotionContext)(props, config.isStatic);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ var projectionId = (0, $4ISm9.useProjectionId)();
        /**
         *
         */ var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && (0, $gzrOo.isBrowser)) /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $ees8x.useVisualElement)(Component, visualState, (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, config), props), createVisualElement);
        if (!config.isStatic && (0, $gzrOo.isBrowser)) {
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             *
             * TODO: The intention is to move these away from a React-centric to a
             * VisualElement-centric lifecycle scheme.
             */ features = (0, $h0zNP.useFeatures)(props, projectionId, context.visualElement, preloadedFeatures);
            // TODO Allow lazy load of projection node
            var _a = (0, $70fFQ.useContext)((0, $axLzK.SwitchLayoutGroupContext)), transition = _a.transition, shouldPreserveFollowOpacity = _a.shouldPreserveFollowOpacity;
            (0, $iHdVw.useProjection)(projectionId, props, context.visualElement, {
                transition: transition,
                shouldPreserveFollowOpacity: shouldPreserveFollowOpacity
            });
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $70fFQ.createElement((0, $9X7ZU.VisualElementHandler), {
            visualElement: context.visualElement,
            props: (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, config), props)
        }, features, $70fFQ.createElement((0, $7aiFr.MotionContext).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $7DJUj.useMotionRef)(visualState, context.visualElement, externalRef), visualState, config.isStatic)));
    }
    return (0, $70fFQ.forwardRef)(MotionComponent);
}
function $27dd377e53cdc311$var$useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = (0, $70fFQ.useContext)((0, $cvSBx.LayoutGroupContext))) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

});
parcelRegister("h0zNP", function(module, exports) {

$parcel$export(module.exports, "useFeatures", function () { return $8a37d7bb3c88f2a9$export$4a39035bacc4ed76; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $jNGoK = parcelRequire("jNGoK");
parcelRequire("8hGPO");

var $8u9gp = parcelRequire("8u9gp");
var $8a37d7bb3c88f2a9$var$featureNames = Object.keys((0, $jNGoK.featureDefinitions));
var $8a37d7bb3c88f2a9$var$numFeatures = $8a37d7bb3c88f2a9$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $8a37d7bb3c88f2a9$export$4a39035bacc4ed76(props, projectionId, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $70fFQ.useContext)((0, $8u9gp.LazyContext));
    if (!visualElement) return null;
    for(var i = 0; i < $8a37d7bb3c88f2a9$var$numFeatures; i++){
        var name_1 = $8a37d7bb3c88f2a9$var$featureNames[i];
        var _a = (0, $jNGoK.featureDefinitions)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($70fFQ.createElement(Component, (0, $h2AC2.__assign)({
            key: name_1
        }, props, {
            visualElement: visualElement,
            projectionId: projectionId
        })));
    }
    return features;
}

});
parcelRegister("jNGoK", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $9f50c3b88b9d0148$export$65570e08d843624d; });
$parcel$export(module.exports, "loadFeatures", function () { return $9f50c3b88b9d0148$export$449561ec5703cdc8; });
var $9f50c3b88b9d0148$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $9f50c3b88b9d0148$export$65570e08d843624d = {
    measureLayout: $9f50c3b88b9d0148$var$createDefinition([
        "layout",
        "layoutId",
        "drag",
        "_layoutResetTransform"
    ]),
    animation: $9f50c3b88b9d0148$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag"
    ]),
    exit: $9f50c3b88b9d0148$var$createDefinition([
        "exit"
    ]),
    drag: $9f50c3b88b9d0148$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $9f50c3b88b9d0148$var$createDefinition([
        "whileFocus"
    ]),
    hover: $9f50c3b88b9d0148$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $9f50c3b88b9d0148$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $9f50c3b88b9d0148$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ])
};
function $9f50c3b88b9d0148$export$449561ec5703cdc8(features) {
    for(var key in features){
        var Component = features[key];
        if (Component !== null) $9f50c3b88b9d0148$export$65570e08d843624d[key].Component = Component;
    }
}

});

parcelRegister("8hGPO", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $608123514182bd33$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $608123514182bd33$export$f5708dca728d7177; });
var $608123514182bd33$export$491112666e282270 = function() {};
var $608123514182bd33$export$f5708dca728d7177 = function() {};

});

parcelRegister("8u9gp", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $479eff4bb753dbaa$export$40f10139ecf1f171; });

var $70fFQ = parcelRequire("70fFQ");
var $479eff4bb753dbaa$export$40f10139ecf1f171 = (0, $70fFQ.createContext)({
    strict: false
});

});


parcelRegister("i715C", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $a9ba8415f53eab68$export$22a697fb29aac98d; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @public
 */ var $a9ba8415f53eab68$export$22a697fb29aac98d = (0, $70fFQ.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false
});

});

parcelRegister("7aiFr", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $333792dadb3ecfa9$export$2285bbca2c666415; });
$parcel$export(module.exports, "useVisualElementContext", function () { return $333792dadb3ecfa9$export$cd995842eb2ab956; });

var $70fFQ = parcelRequire("70fFQ");
var $333792dadb3ecfa9$export$2285bbca2c666415 = (0, $70fFQ.createContext)({});
function $333792dadb3ecfa9$export$cd995842eb2ab956() {
    return (0, $70fFQ.useContext)($333792dadb3ecfa9$export$2285bbca2c666415).visualElement;
}

});

parcelRegister("ees8x", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $39265c7b52953a5b$export$dc0335d73ab0b115; });

var $70fFQ = parcelRequire("70fFQ");

var $2etTF = parcelRequire("2etTF");

var $7aiFr = parcelRequire("7aiFr");

var $9QEIe = parcelRequire("9QEIe");

var $8u9gp = parcelRequire("8u9gp");
function $39265c7b52953a5b$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var lazyContext = (0, $70fFQ.useContext)((0, $8u9gp.LazyContext));
    var parent = (0, $7aiFr.useVisualElementContext)();
    var presenceContext = (0, $70fFQ.useContext)((0, $2etTF.PresenceContext));
    var visualElementRef = (0, $70fFQ.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false
    });
    var visualElement = visualElementRef.current;
    (0, $9QEIe.useIsomorphicLayoutEffect)(function() {
        visualElement === null || visualElement === void 0 || visualElement.syncRender();
    });
    (0, $70fFQ.useEffect)(function() {
        var _a;
        /**
         * In a future refactor we can replace the features-as-components and
         * have this loop through them all firing "effect" listeners
         */ (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $9QEIe.useIsomorphicLayoutEffect)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}

});
parcelRegister("9QEIe", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $53b33d2eb056bf30$export$700979bc83e7db82; });

var $70fFQ = parcelRequire("70fFQ");

var $gzrOo = parcelRequire("gzrOo");
var $53b33d2eb056bf30$export$700979bc83e7db82 = (0, $gzrOo.isBrowser) ? (0, $70fFQ.useLayoutEffect) : (0, $70fFQ.useEffect);

});
parcelRegister("gzrOo", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $bd0f66d68883c095$export$4e09c449d6c407f7; });
var $bd0f66d68883c095$export$4e09c449d6c407f7 = typeof window !== "undefined";

});



parcelRegister("7DJUj", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $db02a056d219c2de$export$c684914703d321fd; });

var $70fFQ = parcelRequire("70fFQ");

var $iinLf = parcelRequire("iinLf");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $db02a056d219c2de$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $70fFQ.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $iinLf.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRegister("iinLf", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $bf2d79c0cc513e61$export$dedd81df7bc1307; });
function $bf2d79c0cc513e61$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("dEEWK", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $669826a5c8aa8ea1$export$c5638d843b37a176; });

var $70fFQ = parcelRequire("70fFQ");

var $7aiFr = parcelRequire("7aiFr");

var $9dly8 = parcelRequire("9dly8");
function $669826a5c8aa8ea1$export$c5638d843b37a176(props, isStatic) {
    var _a = (0, $9dly8.getCurrentTreeVariants)(props, (0, $70fFQ.useContext)((0, $7aiFr.MotionContext))), initial = _a.initial, animate = _a.animate;
    return (0, $70fFQ.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, /**
     * Only break memoisation in static mode
     */ isStatic ? [
        $669826a5c8aa8ea1$var$variantLabelsAsDependency(initial),
        $669826a5c8aa8ea1$var$variantLabelsAsDependency(animate)
    ] : []);
}
function $669826a5c8aa8ea1$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("9dly8", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $a71d08f32de531bb$export$12fc32fc096a04a3; });

var $22rd0 = parcelRequire("22rd0");
function $a71d08f32de531bb$export$12fc32fc096a04a3(props, context) {
    if ((0, $22rd0.checkIfControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $22rd0.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $22rd0.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("22rd0", function(module, exports) {

$parcel$export(module.exports, "isVariantLabels", function () { return $318efdd67e01e928$export$562271cd22f751d; });
$parcel$export(module.exports, "isVariantLabel", function () { return $318efdd67e01e928$export$720b90e312cea233; });
$parcel$export(module.exports, "resolveVariantFromProps", function () { return $318efdd67e01e928$export$d68f140c4d9b48bc; });
$parcel$export(module.exports, "resolveVariant", function () { return $318efdd67e01e928$export$7b1b1c981f4f0558; });
$parcel$export(module.exports, "checkIfControllingVariants", function () { return $318efdd67e01e928$export$cf3a7bd331c35bf0; });
$parcel$export(module.exports, "checkIfVariantNode", function () { return $318efdd67e01e928$export$c0eba02279c18fea; });
/**
 * Decides if the supplied variable is an array of variant labels
 */ function $318efdd67e01e928$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $318efdd67e01e928$export$720b90e312cea233(v) {
    return typeof v === "string" || $318efdd67e01e928$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $318efdd67e01e928$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $318efdd67e01e928$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $318efdd67e01e928$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    return typeof definition === "function" ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity) : definition;
}
function $318efdd67e01e928$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $318efdd67e01e928$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $318efdd67e01e928$var$getCurrent(visualElement), $318efdd67e01e928$var$getVelocity(visualElement));
}
function $318efdd67e01e928$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $318efdd67e01e928$export$720b90e312cea233(props.initial) || $318efdd67e01e928$export$720b90e312cea233(props.animate) || $318efdd67e01e928$export$720b90e312cea233(props.whileHover) || $318efdd67e01e928$export$720b90e312cea233(props.whileDrag) || $318efdd67e01e928$export$720b90e312cea233(props.whileTap) || $318efdd67e01e928$export$720b90e312cea233(props.whileFocus) || $318efdd67e01e928$export$720b90e312cea233(props.exit);
}
function $318efdd67e01e928$export$c0eba02279c18fea(props) {
    return Boolean($318efdd67e01e928$export$cf3a7bd331c35bf0(props) || props.variants);
}

});



parcelRegister("4ISm9", function(module, exports) {

$parcel$export(module.exports, "useProjectionId", function () { return $f54d3aeae30a9411$export$5ed57b87c18af11a; });

var $0h0lm = parcelRequire("0h0lm");

var $e98Ft = parcelRequire("e98Ft");
var $f54d3aeae30a9411$var$id = 1;
function $f54d3aeae30a9411$export$5ed57b87c18af11a() {
    return (0, $0h0lm.useConstant)(function() {
        if ((0, $e98Ft.globalProjectionState).hasEverUpdated) return $f54d3aeae30a9411$var$id++;
    });
}

});
parcelRegister("e98Ft", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", function () { return $5079641bc3897f18$export$97db156a3ed1593b; });
$parcel$export(module.exports, "createProjectionNode", function () { return $5079641bc3897f18$export$a84b61f69daa9da0; });

var $h2AC2 = parcelRequire("h2AC2");

var $ghy0K = parcelRequire("ghy0K");

var $4ZJs1 = parcelRequire("4ZJs1");

var $lUc56 = parcelRequire("lUc56");

var $8nsIL = parcelRequire("8nsIL");

var $7DJC2 = parcelRequire("7DJC2");

var $1gL61 = parcelRequire("1gL61");

var $kWzRX = parcelRequire("kWzRX");

var $8jMj5 = parcelRequire("8jMj5");

var $04Dq7 = parcelRequire("04Dq7");

var $a25ec = parcelRequire("a25ec");

var $5npex = parcelRequire("5npex");

var $fnOZP = parcelRequire("fnOZP");

var $1YYMz = parcelRequire("1YYMz");

var $01NoW = parcelRequire("01NoW");

var $6qvq2 = parcelRequire("6qvq2");

var $6k0Is = parcelRequire("6k0Is");

var $8Ahc1 = parcelRequire("8Ahc1");

var $1wxj0 = parcelRequire("1wxj0");

var $apWKf = parcelRequire("apWKf");

var $coOVK = parcelRequire("coOVK");
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $5079641bc3897f18$var$animationTarget = 1000;
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $5079641bc3897f18$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};
function $5079641bc3897f18$export$a84b61f69daa9da0(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, resetTransform = _a.resetTransform;
    return /** @class */ function() {
        function ProjectionNode(id, latestValues, parent) {
            var _this = this;
            if (latestValues === void 0) latestValues = {};
            if (parent === void 0) parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to actually
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function() {
                _this.nodes.forEach($5079641bc3897f18$var$resolveTargetDelta);
                _this.nodes.forEach($5079641bc3897f18$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            /**
             * Animation
             */ this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $h2AC2.__spreadArray)((0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)(parent.path), false), [
                parent
            ], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $apWKf.FlatTree)();
        }
        ProjectionNode.prototype.addEventListener = function(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $8nsIL.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function(name) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify.apply(subscriptionManager, (0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)(args), false));
        };
        ProjectionNode.prototype.hasListeners = function(name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function(id, node) {
            this.potentialNodes.set(id, node);
        };
        /**
         * Lifecycles
         */ ProjectionNode.prototype.mount = function(instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) isLayoutDirty = false;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function() {
                    return _this.root.updateBlockedByResize = false;
                };
                attachResizeListener(instance, function() {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = setTimeout(resizeUnblockUpdate_1, 250);
                    if ($5079641bc3897f18$export$97db156a3ed1593b.hasAnimatedSinceResize) {
                        $5079641bc3897f18$export$97db156a3ed1593b.hasAnimatedSinceResize = false;
                        _this.nodes.forEach($5079641bc3897f18$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(_a) {
                var _b, _c, _d;
                var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                var dragControls = (0, $coOVK.elementDragControls).get(visualElement);
                if (dragControls === null || dragControls === void 0 ? void 0 : dragControls.isDragging) return;
                // TODO: Check here if an animation exists
                var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : $5079641bc3897f18$var$defaultLayoutTransition;
                var onLayoutAnimationComplete = visualElement.getProps().onLayoutAnimationComplete;
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var targetChanged = !_this.targetLayout || !(0, $fnOZP.boxEquals)(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
                    if (_this.resumeFrom) {
                        _this.resumingFrom = _this.resumeFrom;
                        _this.resumingFrom.resumingFrom = undefined;
                    }
                    _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    _this.startAnimation((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, (0, $5npex.getValueTransition)(layoutTransition, "layout")), {
                        onComplete: onLayoutAnimationComplete
                    }));
                }
                _this.targetLayout = newLayout;
            });
        };
        ProjectionNode.prototype.unmount = function() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $ghy0K.cancelSync).preRender(this.updateProjection);
        };
        // only on the root
        ProjectionNode.prototype.blockUpdate = function() {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function() {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        // Note: currently only running on root node
        ProjectionNode.prototype.startUpdate = function() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($5079641bc3897f18$var$resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
            var _a;
            if (shouldNotifyListeners === void 0) shouldNotifyListeners = true;
            if (this.root.isUpdateBlocked()) return;
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * TODO: Check we haven't updated the scroll
                 * since the last didUpdate
                 */ node.updateScroll();
            }
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout;
            if (!layoutId && !layout) return;
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        // Note: Currently only running on root node
        ProjectionNode.prototype.didUpdate = function() {
            var updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($5079641bc3897f18$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($5079641bc3897f18$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($5079641bc3897f18$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($5079641bc3897f18$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($5079641bc3897f18$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $ghy0K.flushSync).update();
            (0, $ghy0K.flushSync).preRender();
            (0, $ghy0K.flushSync).render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function() {
            this.nodes.forEach($5079641bc3897f18$var$clearSnapshot);
            this.sharedNodes.forEach($5079641bc3897f18$var$removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function() {
            (0, $ghy0K.default).preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
            var _this = this;
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $ghy0K.default).postRender(function() {
                if (_this.isLayoutDirty) _this.root.didUpdate();
                else _this.root.checkUpdateFailed();
            });
        };
        /**
         * Update measurements
         */ ProjectionNode.prototype.updateSnapshot = function() {
            if (this.snapshot || !this.instance) return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            $5079641bc3897f18$var$roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {}
            };
        };
        ProjectionNode.prototype.updateLayout = function() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.updateScroll();
            }
            var measured = this.measure();
            $5079641bc3897f18$var$roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured)
            };
            this.layoutCorrected = (0, $a25ec.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure");
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function() {
            if (this.options.shouldMeasureScroll && this.instance) this.scroll = measureScroll(this.instance);
        };
        ProjectionNode.prototype.resetTransform = function() {
            var _a;
            if (!resetTransform) return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !(0, $fnOZP.isDeltaZero)(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $8Ahc1.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return (0, $a25ec.createBox)();
            var box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            var scroll = this.root.scroll;
            if (scroll) {
                (0, $kWzRX.translateAxis)(box.x, scroll.x);
                (0, $kWzRX.translateAxis)(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function(box) {
            var boxWithoutScroll = (0, $a25ec.createBox)();
            (0, $1gL61.copyBoxInto)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options;
                if (node !== this.root && scroll_1 && options.shouldMeasureScroll) {
                    (0, $kWzRX.translateAxis)(boxWithoutScroll.x, scroll_1.x);
                    (0, $kWzRX.translateAxis)(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function(box) {
            var withTransforms = (0, $a25ec.createBox)();
            (0, $1gL61.copyBoxInto)(withTransforms, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!(0, $8Ahc1.hasTransform)(node.latestValues)) continue;
                (0, $kWzRX.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $8Ahc1.hasTransform)(this.latestValues)) (0, $kWzRX.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function(box) {
            var _a;
            var boxWithoutTransform = (0, $a25ec.createBox)();
            (0, $1gL61.copyBoxInto)(boxWithoutTransform, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $8Ahc1.hasTransform)(node.latestValues)) continue;
                (0, $8Ahc1.hasScale)(node.latestValues) && node.updateSnapshot();
                var sourceBox = (0, $a25ec.createBox)();
                var nodeBox = node.measure();
                (0, $1gL61.copyBoxInto)(sourceBox, nodeBox);
                (0, $04Dq7.removeBoxTransforms)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if ((0, $8Ahc1.hasTransform)(this.latestValues)) (0, $04Dq7.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        };
        /**
         *
         */ ProjectionNode.prototype.setTargetDelta = function(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function(options) {
            var _a;
            this.options = (0, $h2AC2.__assign)((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, this.options), options), {
                crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true
            });
        };
        ProjectionNode.prototype.clearMeasurements = function() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        /**
         * Frame calculations
         */ ProjectionNode.prototype.resolveTargetDelta = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = (0, $a25ec.createBox)();
                    this.relativeTargetOrigin = (0, $a25ec.createBox)();
                    (0, $8jMj5.calcRelativePosition)(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    (0, $1gL61.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            /**
             * If we have no relative target or no target delta we can't perform projection
             * so early return.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a25ec.createBox)();
                this.targetWithTransforms = (0, $a25ec.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $8jMj5.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.actual);
                else (0, $1gL61.copyBoxInto)(this.target, this.layout.actual);
                (0, $kWzRX.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $1gL61.copyBoxInto)(this.target, this.layout.actual);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.target) {
                    this.relativeTarget = (0, $a25ec.createBox)();
                    this.relativeTargetOrigin = (0, $a25ec.createBox)();
                    (0, $8jMj5.calcRelativePosition)(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    (0, $1gL61.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function() {
            if (!this.parent || (0, $8Ahc1.hasTransform)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        };
        ProjectionNode.prototype.calcProjection = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            var lead = this.getLead();
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $1gL61.copyBoxInto)(this.layoutCorrected, this.layout.actual);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $kWzRX.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a25ec.createDelta)();
                this.projectionDeltaWithTransform = (0, $a25ec.createDelta)();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $8jMj5.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $6qvq2.buildProjectionTransform)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.hide = function() {
            this.isVisible = false;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.show = function() {
            this.isVisible = true;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.scheduleRender = function(notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) notifyAll = true;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        };
        ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) hasOnlyRelativeTargetChanged = false;
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = (0, $h2AC2.__assign)({}, this.latestValues);
            var targetDelta = (0, $a25ec.createDelta)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = (0, $a25ec.createBox)();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($5079641bc3897f18$var$hasOpacityCrossfade));
            this.mixTargetDelta = function(latest) {
                var _a;
                var progress = latest / 1000;
                $5079641bc3897f18$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $5079641bc3897f18$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $8jMj5.calcRelativePosition)(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    $5079641bc3897f18$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    (0, $7DJC2.mixValues)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function(options) {
            var _this = this;
            var _a, _b;
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $ghy0K.cancelSync).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $ghy0K.default).update(function() {
                $5079641bc3897f18$export$97db156a3ed1593b.hasAnimatedSinceResize = true;
                _this.currentAnimation = (0, $lUc56.animate)(0, $5079641bc3897f18$var$animationTarget, (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, options), {
                    onUpdate: function(latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: function() {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        _this.completeAnimation();
                    }
                }));
                if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
        };
        ProjectionNode.prototype.finishAnimation = function() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $5079641bc3897f18$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function() {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout) return;
            (0, $1gL61.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $kWzRX.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its actual layout
             * into the desired bounding box.
             */ (0, $8jMj5.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $1YYMz.NodeStack)());
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        };
        ProjectionNode.prototype.isLead = function() {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function() {
            var layoutId = this.options.layoutId;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function(_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        };
        ProjectionNode.prototype.relegate = function() {
            var stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        };
        ProjectionNode.prototype.resetRotation = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            var hasRotate = false;
            // Keep a record of all the values we've reset
            var resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(var i = 0; i < (0, $1wxj0.transformAxes).length; i++){
                var axis = (0, $1wxj0.transformAxes)[i];
                var key = "rotate" + axis;
                // If this rotation doesn't exist as a motion value, then we don't
                // need to reset it
                if (!visualElement.getStaticValue(key)) continue;
                hasRotate = true;
                // Record the rotation and then temporarily set it to 0
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.syncRender();
            // Put back all the values we reset
            for(var key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function() {
            var _a, _b, _c, _d, _e, _f;
            // TODO: Return lifecycle-persistent object
            var styles = {};
            if (!this.instance || this.isSVG) return styles;
            var lead = this.getLead();
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                if (this.hasProjected && !(0, $8Ahc1.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $6qvq2.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            // TODO Move into stand-alone, testable function
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = x.origin * 100 + "% " + y.origin * 100 + "% 0";
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its actual
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            /**
             * Apply scale correction
             */ for(var key in 0, $01NoW.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                var _h = (0, $01NoW.scaleCorrectors)[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for(var i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function() {
            this.resumeFrom = this.snapshot = undefined;
        };
        // Only run on root
        ProjectionNode.prototype.resetTree = function() {
            this.root.nodes.forEach(function(node) {
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($5079641bc3897f18$var$clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }();
}
function $5079641bc3897f18$var$updateLayout(node) {
    node.updateLayout();
}
function $5079641bc3897f18$var$notifyLayoutUpdate(node) {
    var _a, _b;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _c = node.layout, layout_1 = _c.actual, measuredLayout = _c.measured;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (node.options.animationType === "size") (0, $6k0Is.eachAxis)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $8jMj5.calcLength)(axisSnapshot);
            axisSnapshot.min = layout_1[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (node.options.animationType === "position") (0, $6k0Is.eachAxis)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $8jMj5.calcLength)(layout_1[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        var layoutDelta = (0, $a25ec.createDelta)();
        (0, $8jMj5.calcBoxDelta)(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = (0, $a25ec.createDelta)();
        if (snapshot.isShared) (0, $8jMj5.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout), snapshot.measured);
        else (0, $8jMj5.calcBoxDelta)(visualDelta, layout_1, snapshot.layout);
        var hasLayoutChanged = !(0, $fnOZP.isDeltaZero)(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _d = node.relativeParent, parentSnapshot = _d.snapshot, parentLayout = _d.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = (0, $a25ec.createBox)();
                    (0, $8jMj5.calcRelativePosition)(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = (0, $a25ec.createBox)();
                    (0, $8jMj5.calcRelativePosition)(relativeLayout, layout_1, parentLayout.actual);
                    if (!(0, $fnOZP.boxEquals)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $5079641bc3897f18$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $5079641bc3897f18$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $5079641bc3897f18$var$resetTransformStyle(node) {
    node.resetTransform();
}
function $5079641bc3897f18$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $5079641bc3897f18$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $5079641bc3897f18$var$calcProjection(node) {
    node.calcProjection();
}
function $5079641bc3897f18$var$resetRotation(node) {
    node.resetRotation();
}
function $5079641bc3897f18$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $5079641bc3897f18$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $4ZJs1.mix)(delta.translate, 0, p);
    output.scale = (0, $4ZJs1.mix)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $5079641bc3897f18$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $4ZJs1.mix)(from.min, to.min, p);
    output.max = (0, $4ZJs1.mix)(from.max, to.max, p);
}
function $5079641bc3897f18$export$6ffd3e6ae339a132(output, from, to, p) {
    $5079641bc3897f18$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $5079641bc3897f18$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $5079641bc3897f18$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $5079641bc3897f18$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $5079641bc3897f18$var$mountNodeEarly(node, id) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ var searchNode = node.root;
    for(var i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector('[data-projection-id="' + id + '"]');
    if (element) node.mount(element, true);
}
function $5079641bc3897f18$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $5079641bc3897f18$var$roundBox(box) {
    $5079641bc3897f18$var$roundAxis(box.x);
    $5079641bc3897f18$var$roundAxis(box.y);
}

});
parcelRegister("ghy0K", function(module, exports) {

$parcel$export(module.exports, "cancelSync", function () { return $6cac36772a68623e$export$d93e9c1fe0553512; });
$parcel$export(module.exports, "flushSync", function () { return $6cac36772a68623e$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "getFrameData", function () { return $6cac36772a68623e$export$7244445918e670ed; });
$parcel$export(module.exports, "default", function () { return $6cac36772a68623e$export$2e2bcd8739ae039; });

var $55BXa = parcelRequire("55BXa");

var $7vNXN = parcelRequire("7vNXN");
const $6cac36772a68623e$var$maxElapsed = 40;
let $6cac36772a68623e$var$useDefaultElapsed = true;
let $6cac36772a68623e$var$runNextFrame = false;
let $6cac36772a68623e$var$isProcessing = false;
const $6cac36772a68623e$var$frame = {
    delta: 0,
    timestamp: 0
};
const $6cac36772a68623e$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $6cac36772a68623e$var$steps = $6cac36772a68623e$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $7vNXN.createRenderStep)(()=>$6cac36772a68623e$var$runNextFrame = true);
    return acc;
}, {});
const $6cac36772a68623e$var$sync = $6cac36772a68623e$var$stepsOrder.reduce((acc, key)=>{
    const step = $6cac36772a68623e$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$6cac36772a68623e$var$runNextFrame) $6cac36772a68623e$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $6cac36772a68623e$export$d93e9c1fe0553512 = $6cac36772a68623e$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $6cac36772a68623e$var$steps[key].cancel;
    return acc;
}, {});
const $6cac36772a68623e$export$cd75ccfd720a3cd4 = $6cac36772a68623e$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$6cac36772a68623e$var$steps[key].process($6cac36772a68623e$var$frame);
    return acc;
}, {});
const $6cac36772a68623e$var$processStep = (stepId)=>$6cac36772a68623e$var$steps[stepId].process($6cac36772a68623e$var$frame);
const $6cac36772a68623e$var$processFrame = (timestamp)=>{
    $6cac36772a68623e$var$runNextFrame = false;
    $6cac36772a68623e$var$frame.delta = $6cac36772a68623e$var$useDefaultElapsed ? (0, $55BXa.defaultTimestep) : Math.max(Math.min(timestamp - $6cac36772a68623e$var$frame.timestamp, $6cac36772a68623e$var$maxElapsed), 1);
    $6cac36772a68623e$var$frame.timestamp = timestamp;
    $6cac36772a68623e$var$isProcessing = true;
    $6cac36772a68623e$var$stepsOrder.forEach($6cac36772a68623e$var$processStep);
    $6cac36772a68623e$var$isProcessing = false;
    if ($6cac36772a68623e$var$runNextFrame) {
        $6cac36772a68623e$var$useDefaultElapsed = false;
        (0, $55BXa.onNextFrame)($6cac36772a68623e$var$processFrame);
    }
};
const $6cac36772a68623e$var$startLoop = ()=>{
    $6cac36772a68623e$var$runNextFrame = true;
    $6cac36772a68623e$var$useDefaultElapsed = true;
    if (!$6cac36772a68623e$var$isProcessing) (0, $55BXa.onNextFrame)($6cac36772a68623e$var$processFrame);
};
const $6cac36772a68623e$export$7244445918e670ed = ()=>$6cac36772a68623e$var$frame;
var $6cac36772a68623e$export$2e2bcd8739ae039 = $6cac36772a68623e$var$sync;

});
parcelRegister("55BXa", function(module, exports) {

$parcel$export(module.exports, "defaultTimestep", function () { return $d085c472efaf6401$export$f8caf8121275292d; });
$parcel$export(module.exports, "onNextFrame", function () { return $d085c472efaf6401$export$4fdea63ab5513fd5; });
const $d085c472efaf6401$export$f8caf8121275292d = 1 / 60 * 1000;
const $d085c472efaf6401$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $d085c472efaf6401$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($d085c472efaf6401$var$getCurrentTime()), $d085c472efaf6401$export$f8caf8121275292d);

});

parcelRegister("7vNXN", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $7db5526e18499106$export$b995e5e85f5c8289; });
function $7db5526e18499106$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
        }
    };
    return step;
}

});


parcelRegister("4ZJs1", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $0f6aa8b835773405$export$2c9e8a9632a706b2; });
const $0f6aa8b835773405$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;

});

parcelRegister("lUc56", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $f3e88f802fd73819$export$e3607ec2d7a891c4; });

var $7bKIM = parcelRequire("7bKIM");

var $39Z1B = parcelRequire("39Z1B");

var $5npex = parcelRequire("5npex");
/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $f3e88f802fd73819$export$e3607ec2d7a891c4(from, to, transition) {
    if (transition === void 0) transition = {};
    var value = (0, $39Z1B.isMotionValue)(from) ? from : (0, $7bKIM.motionValue)(from);
    (0, $5npex.startAnimation)("", value, to, transition);
    return {
        stop: function() {
            return value.stop();
        },
        isAnimating: function() {
            return value.isAnimating();
        }
    };
}

});
parcelRegister("7bKIM", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $b29959ebf3476d73$export$ce8bdc721e76545f; });

var $ghy0K = parcelRequire("ghy0K");

var $7RtAm = parcelRequire("7RtAm");

var $8nsIL = parcelRequire("8nsIL");
var $b29959ebf3476d73$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $b29959ebf3476d73$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $8nsIL.SubscriptionManager)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $8nsIL.SubscriptionManager)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $8nsIL.SubscriptionManager)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $ghy0K.getFrameData)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $ghy0K.default).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $ghy0K.default).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $b29959ebf3476d73$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $7RtAm.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
/**
 * @internal
 */ function $b29959ebf3476d73$export$ce8bdc721e76545f(init) {
    return new $b29959ebf3476d73$export$8cea36d14ee64562(init);
}

});
parcelRegister("7RtAm", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $31842177c2da1cf6$export$eab0632f7ad4f9d7; });
function $31842177c2da1cf6$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});

parcelRegister("8nsIL", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $59d92d9bfa5c3b42$export$e7dff9482a5fd23c; });

var $eOw3w = parcelRequire("eOw3w");
var $59d92d9bfa5c3b42$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $eOw3w.addUniqueItem)(this.subscriptions, handler);
        return function() {
            return (0, $eOw3w.removeItem)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();

});
parcelRegister("eOw3w", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $ae2e28583730ef49$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $ae2e28583730ef49$export$fe2d9b4e03920b4c; });

var $h2AC2 = parcelRequire("h2AC2");
function $ae2e28583730ef49$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $ae2e28583730ef49$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}
// Adapted from array-move
function $ae2e28583730ef49$export$ec937e64de6c1257(_a, fromIndex, toIndex) {
    var _b = (0, $h2AC2.__read)(_a), arr = _b.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _c = (0, $h2AC2.__read)(arr.splice(fromIndex, 1), 1), item = _c[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});



parcelRegister("39Z1B", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $82dc46de06d33917$export$605d60a2578142d3; });
var $82dc46de06d33917$export$605d60a2578142d3 = function(value) {
    return value !== null && typeof value === "object" && value.getVelocity;
};

});

parcelRegister("5npex", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $189736c07384cf8e$export$7c1391340308742e; });
$parcel$export(module.exports, "startAnimation", function () { return $189736c07384cf8e$export$592dbd515a49cf1b; });

var $h2AC2 = parcelRequire("h2AC2");

var $kbvje = parcelRequire("kbvje");
var $3rYl9 = parcelRequire("3rYl9");

var $iJsHS = parcelRequire("iJsHS");

var $hc11K = parcelRequire("hc11K");

var $53M7p = parcelRequire("53M7p");

var $698xx = parcelRequire("698xx");

var $8hGPO = parcelRequire("8hGPO");

var $k6qEY = parcelRequire("k6qEY");
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $189736c07384cf8e$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $h2AC2.__rest)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $189736c07384cf8e$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $189736c07384cf8e$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $h2AC2.__rest)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $h2AC2.__assign)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $iJsHS.secondsToMilliseconds)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $iJsHS.secondsToMilliseconds)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $hc11K.isEasingArray)(ease) ? ease.map((0, $hc11K.easingDefinitionToFunction)) : (0, $hc11K.easingDefinitionToFunction)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $8hGPO.warning)(!$189736c07384cf8e$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $189736c07384cf8e$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $189736c07384cf8e$export$b55a0e77aebddb70(transition, key) {
    var _a;
    var valueTransition = $189736c07384cf8e$export$7c1391340308742e(transition, key) || {};
    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function $189736c07384cf8e$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function $189736c07384cf8e$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $189736c07384cf8e$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$189736c07384cf8e$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, transition), (0, $698xx.getDefaultTransition)(key, options.to));
    return (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, options), $189736c07384cf8e$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $189736c07384cf8e$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $189736c07384cf8e$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $53M7p.isAnimatable)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $k6qEY.getAnimatableNone)(key, target);
    else if ($189736c07384cf8e$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $189736c07384cf8e$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $189736c07384cf8e$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $189736c07384cf8e$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $53M7p.isAnimatable)(key, origin);
    (0, $8hGPO.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + ' from "' + origin + '" to "' + target + '". ' + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $3rYl9.inertia)((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, options), valueTransition)) : (0, $kbvje.animate)((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, $189736c07384cf8e$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a, _b;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, target);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 || _b.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $189736c07384cf8e$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $189736c07384cf8e$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $k6qEY.getAnimatableNone)("", potentialUnitType);
}
function $189736c07384cf8e$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */ function $189736c07384cf8e$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $189736c07384cf8e$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $189736c07384cf8e$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = setTimeout(start, (0, $iJsHS.secondsToMilliseconds)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}

});
parcelRegister("kbvje", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $7977af7f4f491235$export$e3607ec2d7a891c4; });

var $h2AC2 = parcelRequire("h2AC2");

var $6r9WJ = parcelRequire("6r9WJ");

var $ghy0K = parcelRequire("ghy0K");

var $csONh = parcelRequire("csONh");

var $9Bwsy = parcelRequire("9Bwsy");
const $7977af7f4f491235$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $ghy0K.default).update(passTimestamp, true),
        stop: ()=>(0, $ghy0K.cancelSync).update(passTimestamp)
    };
};
function $7977af7f4f491235$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var { from: from, autoplay: autoplay = true, driver: driver = $7977af7f4f491235$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate } = _a, options = (0, $h2AC2.__rest)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    let { to: to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = (0, $6r9WJ.detectAnimationFromOptions)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $csONh.interpolate)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $9Bwsy.reverseElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $9Bwsy.loopElapsed)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $9Bwsy.hasRepeatDelayElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}

});
parcelRegister("6r9WJ", function(module, exports) {

$parcel$export(module.exports, "detectAnimationFromOptions", function () { return $bfacd1f9c83caeb6$export$74df49bbebf8cb2c; });

var $7YB9X = parcelRequire("7YB9X");

var $3Ux8r = parcelRequire("3Ux8r");

var $7Ko8T = parcelRequire("7Ko8T");
const $bfacd1f9c83caeb6$var$types = {
    keyframes: $3Ux8r.keyframes,
    spring: $7YB9X.spring,
    decay: $7Ko8T.decay
};
function $bfacd1f9c83caeb6$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $3Ux8r.keyframes;
    else if ($bfacd1f9c83caeb6$var$types[config.type]) return $bfacd1f9c83caeb6$var$types[config.type];
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $3Ux8r.keyframes;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $7YB9X.spring;
    return 0, $3Ux8r.keyframes;
}

});
parcelRegister("7YB9X", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $3227140a5301c449$export$b36281d89752ae66; });

var $h2AC2 = parcelRequire("h2AC2");

var $1BIF4 = parcelRequire("1BIF4");
const $3227140a5301c449$var$durationKeys = [
    "duration",
    "bounce"
];
const $3227140a5301c449$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $3227140a5301c449$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $3227140a5301c449$var$getSpringOptions(options) {
    let springOptions = Object.assign({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$3227140a5301c449$var$isSpringType(options, $3227140a5301c449$var$physicsKeys) && $3227140a5301c449$var$isSpringType(options, $3227140a5301c449$var$durationKeys)) {
        const derived = (0, $1BIF4.findSpring)(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $3227140a5301c449$export$b36281d89752ae66(_a) {
    var { from: from = 0.0, to: to = 1.0, restSpeed: restSpeed = 2, restDelta: restDelta } = _a, options = (0, $h2AC2.__rest)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    const state = {
        done: false,
        value: from
    };
    let { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $3227140a5301c449$var$getSpringOptions(options);
    let resolveSpring = $3227140a5301c449$var$zero;
    let resolveVelocity = $3227140a5301c449$var$zero;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4;
        if (dampingRatio < 1) {
            const angularFreq = (0, $1BIF4.calcAngularFreq)(undampedAngularFreq, dampingRatio);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
            resolveVelocity = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t)) - envelope * (Math.cos(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t));
            };
        } else if (dampingRatio === 1) resolveSpring = (t)=>to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: ()=>{
            velocity = -velocity;
            [from, to] = [
                to,
                from
            ];
            createSpring();
        }
    };
}
$3227140a5301c449$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $3227140a5301c449$var$zero = (_t)=>0;

});
parcelRegister("1BIF4", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $d043ab62b06acafa$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $d043ab62b06acafa$export$5f679887c3a78b15; });

var $8hGPO = parcelRequire("8hGPO");

var $WSOSw = parcelRequire("WSOSw");
const $d043ab62b06acafa$var$safeMin = 0.001;
const $d043ab62b06acafa$export$a3cdb76e84ee608e = 0.01;
const $d043ab62b06acafa$export$1824b851fad8862b = 10.0;
const $d043ab62b06acafa$export$ff08f2d53484465 = 0.05;
const $d043ab62b06acafa$export$201ca48e54038115 = 1;
function $d043ab62b06acafa$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $8hGPO.warning)(duration <= $d043ab62b06acafa$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = (0, $WSOSw.clamp)($d043ab62b06acafa$export$ff08f2d53484465, $d043ab62b06acafa$export$201ca48e54038115, dampingRatio);
    duration = (0, $WSOSw.clamp)($d043ab62b06acafa$export$a3cdb76e84ee608e, $d043ab62b06acafa$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $d043ab62b06acafa$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $d043ab62b06acafa$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $d043ab62b06acafa$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $d043ab62b06acafa$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$d043ab62b06acafa$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $d043ab62b06acafa$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $d043ab62b06acafa$var$rootIterations = 12;
function $d043ab62b06acafa$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $d043ab62b06acafa$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $d043ab62b06acafa$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});
parcelRegister("WSOSw", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $bfc5b86603782678$export$7d15b64cf5a3a4c4; });
const $bfc5b86603782678$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);

});



parcelRegister("3Ux8r", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $d91e7fc82132f081$export$d25ddfdf17c3ad3e; });

var $csONh = parcelRequire("csONh");

var $dqZUV = parcelRequire("dqZUV");
function $d91e7fc82132f081$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $dqZUV.easeInOut)).splice(0, values.length - 1);
}
function $d91e7fc82132f081$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $d91e7fc82132f081$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $d91e7fc82132f081$export$d25ddfdf17c3ad3e({ from: from = 0, to: to = 1, ease: ease, offset: offset, duration: duration = 300 }) {
    const state = {
        done: false,
        value: from
    };
    const values = Array.isArray(to) ? to : [
        from,
        to
    ];
    const times = $d91e7fc82132f081$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $d91e7fc82132f081$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $csONh.interpolate)(times, values, {
            ease: Array.isArray(ease) ? ease : $d91e7fc82132f081$export$6b60b58e4ea7d715(values, ease)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}

});
parcelRegister("csONh", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $1bd36dab93def386$export$89e29e4ab65e70a9; });

var $7WsgJ = parcelRequire("7WsgJ");

var $4ZJs1 = parcelRequire("4ZJs1");

var $brp2o = parcelRequire("brp2o");

var $6aC4j = parcelRequire("6aC4j");

var $emRO9 = parcelRequire("emRO9");

var $WSOSw = parcelRequire("WSOSw");

var $3mlnP = parcelRequire("3mlnP");

var $8hGPO = parcelRequire("8hGPO");
const $1bd36dab93def386$var$mixNumber = (from, to)=>(p)=>(0, $4ZJs1.mix)(from, to, p);
function $1bd36dab93def386$var$detectMixerFactory(v) {
    if (typeof v === "number") return $1bd36dab93def386$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $emRO9.color).test(v)) return 0, $brp2o.mixColor;
        else return 0, $6aC4j.mixComplex;
    } else if (Array.isArray(v)) return 0, $6aC4j.mixArray;
    else if (typeof v === "object") return 0, $6aC4j.mixObject;
}
function $1bd36dab93def386$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $1bd36dab93def386$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $3mlnP.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $1bd36dab93def386$var$fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer((0, $7WsgJ.progress)(from, to, v));
}
function $1bd36dab93def386$var$slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = (0, $7WsgJ.progress)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $1bd36dab93def386$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $8hGPO.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $8hGPO.invariant)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = $1bd36dab93def386$var$createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? $1bd36dab93def386$var$fastInterpolate(input, mixers) : $1bd36dab93def386$var$slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator((0, $WSOSw.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("7WsgJ", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $afc2f1eacdfe6b83$export$504d7abb21fa8c9; });
const $afc2f1eacdfe6b83$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("brp2o", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $e6aef35f111a98e8$export$51e568cf5c039bac; });

var $4ZJs1 = parcelRequire("4ZJs1");

var $1veZ3 = parcelRequire("1veZ3");
var $6wX54 = parcelRequire("6wX54");
var $4lc4Q = parcelRequire("4lc4Q");

var $8hGPO = parcelRequire("8hGPO");
const $e6aef35f111a98e8$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const $e6aef35f111a98e8$var$colorTypes = [
    (0, $1veZ3.hex),
    (0, $4lc4Q.rgba),
    (0, $6wX54.hsla)
];
const $e6aef35f111a98e8$var$getColorType = (v)=>$e6aef35f111a98e8$var$colorTypes.find((type)=>type.test(v));
const $e6aef35f111a98e8$var$notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const $e6aef35f111a98e8$export$51e568cf5c039bac = (from, to)=>{
    const fromColorType = $e6aef35f111a98e8$var$getColorType(from);
    const toColorType = $e6aef35f111a98e8$var$getColorType(to);
    (0, $8hGPO.invariant)(!!fromColorType, $e6aef35f111a98e8$var$notAnimatable(from));
    (0, $8hGPO.invariant)(!!toColorType, $e6aef35f111a98e8$var$notAnimatable(to));
    (0, $8hGPO.invariant)(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    if (!fromColorType || !toColorType || fromColorType.transform !== toColorType.transform) return (p)=>`${p > 0 ? to : from}`;
    const fromColor = fromColorType.parse(from);
    const toColor = toColorType.parse(to);
    const blended = Object.assign({}, fromColor);
    const mixFunc = fromColorType === (0, $6wX54.hsla) ? (0, $4ZJs1.mix) : $e6aef35f111a98e8$export$d4ecea248cce73c;
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = mixFunc(fromColor[key], toColor[key], v);
        blended.alpha = (0, $4ZJs1.mix)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

});
parcelRegister("1veZ3", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $1c66edff1830e54f$export$834dfc94dde4b3d8; });

var $4lc4Q = parcelRequire("4lc4Q");

var $7RzKG = parcelRequire("7RzKG");
function $1c66edff1830e54f$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $1c66edff1830e54f$export$834dfc94dde4b3d8 = {
    test: (0, $7RzKG.isColorString)("#"),
    parse: $1c66edff1830e54f$var$parseHex,
    transform: (0, $4lc4Q.rgba).transform
};

});
parcelRegister("4lc4Q", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $8e7c0eb354b7f5f5$export$4e46ac54fc82cf3b; });

var $85C7Z = parcelRequire("85C7Z");

var $6vMaC = parcelRequire("6vMaC");

var $7RzKG = parcelRequire("7RzKG");
const $8e7c0eb354b7f5f5$var$clampRgbUnit = (0, $6vMaC.clamp)(0, 255);
const $8e7c0eb354b7f5f5$export$7a99c86b5b1f4c9e = Object.assign(Object.assign({}, (0, $85C7Z.number)), {
    transform: (v)=>Math.round($8e7c0eb354b7f5f5$var$clampRgbUnit(v))
});
const $8e7c0eb354b7f5f5$export$4e46ac54fc82cf3b = {
    test: (0, $7RzKG.isColorString)("rgb", "red"),
    parse: (0, $7RzKG.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $8e7c0eb354b7f5f5$export$7a99c86b5b1f4c9e.transform(red) + ", " + $8e7c0eb354b7f5f5$export$7a99c86b5b1f4c9e.transform(green) + ", " + $8e7c0eb354b7f5f5$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $6vMaC.sanitize)((0, $85C7Z.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("85C7Z", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $1b9fc04a4ca68aaf$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $1b9fc04a4ca68aaf$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $1b9fc04a4ca68aaf$export$dcdf75081b88279d; });

var $6vMaC = parcelRequire("6vMaC");
const $1b9fc04a4ca68aaf$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $1b9fc04a4ca68aaf$export$58f0f39f63f3cf42 = Object.assign(Object.assign({}, $1b9fc04a4ca68aaf$export$98e628dec113755e), {
    transform: (0, $6vMaC.clamp)(0, 1)
});
const $1b9fc04a4ca68aaf$export$dcdf75081b88279d = Object.assign(Object.assign({}, $1b9fc04a4ca68aaf$export$98e628dec113755e), {
    default: 1
});

});
parcelRegister("6vMaC", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $c9c29adec9f8d93c$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "sanitize", function () { return $c9c29adec9f8d93c$export$83d2e9e3e4ee39ed; });
$parcel$export(module.exports, "floatRegex", function () { return $c9c29adec9f8d93c$export$2444ca58c08448e4; });
$parcel$export(module.exports, "colorRegex", function () { return $c9c29adec9f8d93c$export$740b69c5fad25dba; });
$parcel$export(module.exports, "singleColorRegex", function () { return $c9c29adec9f8d93c$export$ed808ff6ecd39e8d; });
$parcel$export(module.exports, "isString", function () { return $c9c29adec9f8d93c$export$844ec244b1367d54; });
const $c9c29adec9f8d93c$export$7d15b64cf5a3a4c4 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const $c9c29adec9f8d93c$export$83d2e9e3e4ee39ed = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const $c9c29adec9f8d93c$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $c9c29adec9f8d93c$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const $c9c29adec9f8d93c$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $c9c29adec9f8d93c$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});


parcelRegister("7RzKG", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $644ab547c30ad0ac$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $644ab547c30ad0ac$export$73d6f35be992df24; });

var $6vMaC = parcelRequire("6vMaC");
const $644ab547c30ad0ac$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $6vMaC.isString)(v) && (0, $6vMaC.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $644ab547c30ad0ac$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $6vMaC.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $6vMaC.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("6wX54", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $c0887a802a98fc61$export$810b04175080204c; });

var $85C7Z = parcelRequire("85C7Z");

var $aak4Q = parcelRequire("aak4Q");

var $6vMaC = parcelRequire("6vMaC");

var $7RzKG = parcelRequire("7RzKG");
const $c0887a802a98fc61$export$810b04175080204c = {
    test: (0, $7RzKG.isColorString)("hsl", "hue"),
    parse: (0, $7RzKG.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $aak4Q.percent).transform((0, $6vMaC.sanitize)(saturation)) + ", " + (0, $aak4Q.percent).transform((0, $6vMaC.sanitize)(lightness)) + ", " + (0, $6vMaC.sanitize)((0, $85C7Z.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("aak4Q", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $1297dd3464e0ed5e$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $1297dd3464e0ed5e$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $1297dd3464e0ed5e$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $1297dd3464e0ed5e$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $1297dd3464e0ed5e$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $1297dd3464e0ed5e$export$44e2e1705876d7ed; });

var $6vMaC = parcelRequire("6vMaC");
const $1297dd3464e0ed5e$var$createUnitType = (unit)=>({
        test: (v)=>(0, $6vMaC.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $1297dd3464e0ed5e$export$41fc368e1a942b97 = $1297dd3464e0ed5e$var$createUnitType("deg");
const $1297dd3464e0ed5e$export$626336c2cd4b14de = $1297dd3464e0ed5e$var$createUnitType("%");
const $1297dd3464e0ed5e$export$91c0eda1d06bf008 = $1297dd3464e0ed5e$var$createUnitType("px");
const $1297dd3464e0ed5e$export$f91e8c45a95a32f2 = $1297dd3464e0ed5e$var$createUnitType("vh");
const $1297dd3464e0ed5e$export$aed3d7b7d206c196 = $1297dd3464e0ed5e$var$createUnitType("vw");
const $1297dd3464e0ed5e$export$44e2e1705876d7ed = Object.assign(Object.assign({}, $1297dd3464e0ed5e$export$626336c2cd4b14de), {
    parse: (v)=>$1297dd3464e0ed5e$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$1297dd3464e0ed5e$export$626336c2cd4b14de.transform(v * 100)
});

});



parcelRegister("6aC4j", function(module, exports) {

$parcel$export(module.exports, "mixComplex", function () { return $7811af02b16f9543$export$65516310a87d8205; });
$parcel$export(module.exports, "mixArray", function () { return $7811af02b16f9543$export$3bbefa2f402845c4; });
$parcel$export(module.exports, "mixObject", function () { return $7811af02b16f9543$export$ebc23b6840c51ba1; });

var $emRO9 = parcelRequire("emRO9");
var $j9CZ5 = parcelRequire("j9CZ5");

var $4ZJs1 = parcelRequire("4ZJs1");

var $brp2o = parcelRequire("brp2o");

var $dXEz4 = parcelRequire("dXEz4");

var $3mlnP = parcelRequire("3mlnP");

var $8hGPO = parcelRequire("8hGPO");
function $7811af02b16f9543$var$getMixer(origin, target) {
    if ((0, $dXEz4.isNum)(origin)) return (v)=>(0, $4ZJs1.mix)(origin, target, v);
    else if ((0, $emRO9.color).test(origin)) return (0, $brp2o.mixColor)(origin, target);
    else return $7811af02b16f9543$export$65516310a87d8205(origin, target);
}
const $7811af02b16f9543$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$7811af02b16f9543$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $7811af02b16f9543$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $7811af02b16f9543$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $7811af02b16f9543$var$analyse(value) {
    const parsed = (0, $j9CZ5.complex).parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
const $7811af02b16f9543$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $j9CZ5.complex).createTransformer(target);
    const originStats = $7811af02b16f9543$var$analyse(origin);
    const targetStats = $7811af02b16f9543$var$analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $3mlnP.pipe)($7811af02b16f9543$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
    else {
        (0, $8hGPO.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};

});
parcelRegister("emRO9", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $5621be1afe707b8d$export$35e9368ef982300f; });

var $6vMaC = parcelRequire("6vMaC");

var $1veZ3 = parcelRequire("1veZ3");

var $6wX54 = parcelRequire("6wX54");

var $4lc4Q = parcelRequire("4lc4Q");
const $5621be1afe707b8d$export$35e9368ef982300f = {
    test: (v)=>(0, $4lc4Q.rgba).test(v) || (0, $1veZ3.hex).test(v) || (0, $6wX54.hsla).test(v),
    parse: (v)=>{
        if ((0, $4lc4Q.rgba).test(v)) return (0, $4lc4Q.rgba).parse(v);
        else if ((0, $6wX54.hsla).test(v)) return (0, $6wX54.hsla).parse(v);
        else return (0, $1veZ3.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $6vMaC.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $4lc4Q.rgba).transform(v) : (0, $6wX54.hsla).transform(v);
    }
};

});

parcelRegister("j9CZ5", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $16b7c420779346e8$export$83a0e34f1302825b; });

var $emRO9 = parcelRequire("emRO9");

var $85C7Z = parcelRequire("85C7Z");

var $6vMaC = parcelRequire("6vMaC");
const $16b7c420779346e8$var$colorToken = "${c}";
const $16b7c420779346e8$var$numberToken = "${n}";
function $16b7c420779346e8$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $6vMaC.isString)(v) && ((_b = (_a = v.match((0, $6vMaC.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $6vMaC.colorRegex))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $16b7c420779346e8$var$analyse(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match((0, $6vMaC.colorRegex));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $6vMaC.colorRegex), $16b7c420779346e8$var$colorToken);
        values.push(...colors.map((0, $emRO9.color).parse));
    }
    const numbers = v.match((0, $6vMaC.floatRegex));
    if (numbers) {
        v = v.replace((0, $6vMaC.floatRegex), $16b7c420779346e8$var$numberToken);
        values.push(...numbers.map((0, $85C7Z.number).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $16b7c420779346e8$var$parse(v) {
    return $16b7c420779346e8$var$analyse(v).values;
}
function $16b7c420779346e8$var$createTransformer(v) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $16b7c420779346e8$var$analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $16b7c420779346e8$var$colorToken : $16b7c420779346e8$var$numberToken, i < numColors ? (0, $emRO9.color).transform(v[i]) : (0, $6vMaC.sanitize)(v[i]));
        return output;
    };
}
const $16b7c420779346e8$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $16b7c420779346e8$var$getAnimatableNone(v) {
    const parsed = $16b7c420779346e8$var$parse(v);
    const transformer = $16b7c420779346e8$var$createTransformer(v);
    return transformer(parsed.map($16b7c420779346e8$var$convertNumbersToZero));
}
const $16b7c420779346e8$export$83a0e34f1302825b = {
    test: $16b7c420779346e8$var$test,
    parse: $16b7c420779346e8$var$parse,
    createTransformer: $16b7c420779346e8$var$createTransformer,
    getAnimatableNone: $16b7c420779346e8$var$getAnimatableNone
};

});

parcelRegister("dXEz4", function(module, exports) {

$parcel$export(module.exports, "isNum", function () { return $74371751417a6fe5$export$4e960b977ccfec97; });
const $74371751417a6fe5$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
const $74371751417a6fe5$export$4e960b977ccfec97 = (v)=>typeof v === "number";

});

parcelRegister("3mlnP", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $24b73ca08caf52bc$export$a4627e546088548d; });
const $24b73ca08caf52bc$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $24b73ca08caf52bc$export$a4627e546088548d = (...transformers)=>transformers.reduce($24b73ca08caf52bc$var$combineFunctions);

});



parcelRegister("dqZUV", function(module, exports) {

$parcel$export(module.exports, "linear", function () { return $45a264c05aa428bc$export$45db2fc2f15997e7; });
$parcel$export(module.exports, "easeIn", function () { return $45a264c05aa428bc$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $45a264c05aa428bc$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $45a264c05aa428bc$export$c07234257a03d5e9; });
$parcel$export(module.exports, "circIn", function () { return $45a264c05aa428bc$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $45a264c05aa428bc$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $45a264c05aa428bc$export$30d3455eee55bed5; });
$parcel$export(module.exports, "backIn", function () { return $45a264c05aa428bc$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backOut", function () { return $45a264c05aa428bc$export$77edfce482316a60; });
$parcel$export(module.exports, "backInOut", function () { return $45a264c05aa428bc$export$ddc5fd596f6c71b2; });
$parcel$export(module.exports, "anticipate", function () { return $45a264c05aa428bc$export$6b0af63b873d419e; });
$parcel$export(module.exports, "bounceOut", function () { return $45a264c05aa428bc$export$cccc9e04465dce11; });
$parcel$export(module.exports, "bounceIn", function () { return $45a264c05aa428bc$export$fccebd7948554554; });
$parcel$export(module.exports, "bounceInOut", function () { return $45a264c05aa428bc$export$41ad9e9849a703ce; });

var $h7Lh0 = parcelRequire("h7Lh0");
const $45a264c05aa428bc$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const $45a264c05aa428bc$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const $45a264c05aa428bc$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const $45a264c05aa428bc$var$BOUNCE_THIRD_THRESHOLD = 0.9;
const $45a264c05aa428bc$export$45db2fc2f15997e7 = (p)=>p;
const $45a264c05aa428bc$export$929e5a82286172a6 = (0, $h7Lh0.createExpoIn)(2);
const $45a264c05aa428bc$export$57636bb43b1ccbb0 = (0, $h7Lh0.reverseEasing)($45a264c05aa428bc$export$929e5a82286172a6);
const $45a264c05aa428bc$export$c07234257a03d5e9 = (0, $h7Lh0.mirrorEasing)($45a264c05aa428bc$export$929e5a82286172a6);
const $45a264c05aa428bc$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $45a264c05aa428bc$export$c8d67a19199d1a50 = (0, $h7Lh0.reverseEasing)($45a264c05aa428bc$export$e444123e42d03385);
const $45a264c05aa428bc$export$30d3455eee55bed5 = (0, $h7Lh0.mirrorEasing)($45a264c05aa428bc$export$c8d67a19199d1a50);
const $45a264c05aa428bc$export$b01116c84cdfe1a2 = (0, $h7Lh0.createBackIn)($45a264c05aa428bc$var$DEFAULT_OVERSHOOT_STRENGTH);
const $45a264c05aa428bc$export$77edfce482316a60 = (0, $h7Lh0.reverseEasing)($45a264c05aa428bc$export$b01116c84cdfe1a2);
const $45a264c05aa428bc$export$ddc5fd596f6c71b2 = (0, $h7Lh0.mirrorEasing)($45a264c05aa428bc$export$b01116c84cdfe1a2);
const $45a264c05aa428bc$export$6b0af63b873d419e = (0, $h7Lh0.createAnticipate)($45a264c05aa428bc$var$DEFAULT_OVERSHOOT_STRENGTH);
const $45a264c05aa428bc$var$ca = 4356.0 / 361.0;
const $45a264c05aa428bc$var$cb = 35442.0 / 1805.0;
const $45a264c05aa428bc$var$cc = 16061.0 / 1805.0;
const $45a264c05aa428bc$export$cccc9e04465dce11 = (p)=>{
    if (p === 1 || p === 0) return p;
    const p2 = p * p;
    return p < $45a264c05aa428bc$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $45a264c05aa428bc$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $45a264c05aa428bc$var$BOUNCE_THIRD_THRESHOLD ? $45a264c05aa428bc$var$ca * p2 - $45a264c05aa428bc$var$cb * p + $45a264c05aa428bc$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
const $45a264c05aa428bc$export$fccebd7948554554 = (0, $h7Lh0.reverseEasing)($45a264c05aa428bc$export$cccc9e04465dce11);
const $45a264c05aa428bc$export$41ad9e9849a703ce = (p)=>p < 0.5 ? 0.5 * (1.0 - $45a264c05aa428bc$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $45a264c05aa428bc$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;

});
parcelRegister("h7Lh0", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $0c45e22d5d465859$export$2c07eeff45156d4d; });
$parcel$export(module.exports, "mirrorEasing", function () { return $0c45e22d5d465859$export$f946554fb8aeaf0d; });
$parcel$export(module.exports, "createExpoIn", function () { return $0c45e22d5d465859$export$c90c8c5a3c7a5e80; });
$parcel$export(module.exports, "createBackIn", function () { return $0c45e22d5d465859$export$2a739ba6da1d1495; });
$parcel$export(module.exports, "createAnticipate", function () { return $0c45e22d5d465859$export$222fa0be41d8b537; });
const $0c45e22d5d465859$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);
const $0c45e22d5d465859$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const $0c45e22d5d465859$export$c90c8c5a3c7a5e80 = (power)=>(p)=>Math.pow(p, power);
const $0c45e22d5d465859$export$2a739ba6da1d1495 = (power)=>(p)=>p * p * ((power + 1) * p - power);
const $0c45e22d5d465859$export$222fa0be41d8b537 = (power)=>{
    const backEasing = $0c45e22d5d465859$export$2a739ba6da1d1495(power);
    return (p)=>(p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

});



parcelRegister("7Ko8T", function(module, exports) {

$parcel$export(module.exports, "decay", function () { return $e385093fd1125dcd$export$e9341ba102272ab9; });
function $e385093fd1125dcd$export$e9341ba102272ab9({ velocity: velocity = 0, from: from = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const state = {
        done: false,
        value: from
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}

});


parcelRegister("9Bwsy", function(module, exports) {

$parcel$export(module.exports, "loopElapsed", function () { return $2dadb4e86eec4e06$export$7d0784e050d8e25f; });
$parcel$export(module.exports, "reverseElapsed", function () { return $2dadb4e86eec4e06$export$ab9042754680126b; });
$parcel$export(module.exports, "hasRepeatDelayElapsed", function () { return $2dadb4e86eec4e06$export$c9c9437f9b8733b5; });
function $2dadb4e86eec4e06$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $2dadb4e86eec4e06$export$ab9042754680126b(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $2dadb4e86eec4e06$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $2dadb4e86eec4e06$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

});


parcelRegister("3rYl9", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $67c4c57375f77319$export$ee3ff3a17106998; });

var $kbvje = parcelRequire("kbvje");

var $7RtAm = parcelRequire("7RtAm");

var $ghy0K = parcelRequire("ghy0K");
function $67c4c57375f77319$export$ee3ff3a17106998({ from: from = 0, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $kbvje.animate)(Object.assign(Object.assign({}, options), {
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $7RtAm.velocityPerSecond)(v - prev, (0, $ghy0K.getFrameData)().delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                from: v,
                to: boundary,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}

});

parcelRegister("iJsHS", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $2e3d237c9cf952fc$export$fc3e7e8557f8c8c7; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $2e3d237c9cf952fc$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};

});

parcelRegister("hc11K", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $7124e701ee99d078$export$ef97fe084f156ca4; });
$parcel$export(module.exports, "isEasingArray", function () { return $7124e701ee99d078$export$216948827bbdc797; });

var $h2AC2 = parcelRequire("h2AC2");

var $8hGPO = parcelRequire("8hGPO");

var $dqZUV = parcelRequire("dqZUV");
var $c5pEt = parcelRequire("c5pEt");
var $7124e701ee99d078$var$easingLookup = {
    linear: (0, $dqZUV.linear),
    easeIn: (0, $dqZUV.easeIn),
    easeInOut: (0, $dqZUV.easeInOut),
    easeOut: (0, $dqZUV.easeOut),
    circIn: (0, $dqZUV.circIn),
    circInOut: (0, $dqZUV.circInOut),
    circOut: (0, $dqZUV.circOut),
    backIn: (0, $dqZUV.backIn),
    backInOut: (0, $dqZUV.backInOut),
    backOut: (0, $dqZUV.backOut),
    anticipate: (0, $dqZUV.anticipate),
    bounceIn: (0, $dqZUV.bounceIn),
    bounceInOut: (0, $dqZUV.bounceInOut),
    bounceOut: (0, $dqZUV.bounceOut)
};
var $7124e701ee99d078$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $8hGPO.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $h2AC2.__read)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $c5pEt.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $8hGPO.invariant)($7124e701ee99d078$var$easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return $7124e701ee99d078$var$easingLookup[definition];
    }
    return definition;
};
var $7124e701ee99d078$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});
parcelRegister("c5pEt", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $d215edb3717fdfa8$export$2c575fa1d20488bd; });

var $dqZUV = parcelRequire("dqZUV");
const $d215edb3717fdfa8$var$a = (a1, a2)=>1.0 - 3.0 * a2 + 3.0 * a1;
const $d215edb3717fdfa8$var$b = (a1, a2)=>3.0 * a2 - 6.0 * a1;
const $d215edb3717fdfa8$var$c = (a1)=>3.0 * a1;
const $d215edb3717fdfa8$var$calcBezier = (t, a1, a2)=>(($d215edb3717fdfa8$var$a(a1, a2) * t + $d215edb3717fdfa8$var$b(a1, a2)) * t + $d215edb3717fdfa8$var$c(a1)) * t;
const $d215edb3717fdfa8$var$getSlope = (t, a1, a2)=>3.0 * $d215edb3717fdfa8$var$a(a1, a2) * t * t + 2.0 * $d215edb3717fdfa8$var$b(a1, a2) * t + $d215edb3717fdfa8$var$c(a1);
const $d215edb3717fdfa8$var$subdivisionPrecision = 0.0000001;
const $d215edb3717fdfa8$var$subdivisionMaxIterations = 10;
function $d215edb3717fdfa8$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $d215edb3717fdfa8$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $d215edb3717fdfa8$var$subdivisionPrecision && ++i < $d215edb3717fdfa8$var$subdivisionMaxIterations);
    return currentT;
}
const $d215edb3717fdfa8$var$newtonIterations = 8;
const $d215edb3717fdfa8$var$newtonMinSlope = 0.001;
function $d215edb3717fdfa8$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(let i = 0; i < $d215edb3717fdfa8$var$newtonIterations; ++i){
        const currentSlope = $d215edb3717fdfa8$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        const currentX = $d215edb3717fdfa8$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const $d215edb3717fdfa8$var$kSplineTableSize = 11;
const $d215edb3717fdfa8$var$kSampleStepSize = 1.0 / ($d215edb3717fdfa8$var$kSplineTableSize - 1.0);
function $d215edb3717fdfa8$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $dqZUV.linear;
    const sampleValues = new Float32Array($d215edb3717fdfa8$var$kSplineTableSize);
    for(let i = 0; i < $d215edb3717fdfa8$var$kSplineTableSize; ++i)sampleValues[i] = $d215edb3717fdfa8$var$calcBezier(i * $d215edb3717fdfa8$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = $d215edb3717fdfa8$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $d215edb3717fdfa8$var$kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * $d215edb3717fdfa8$var$kSampleStepSize;
        const initialSlope = $d215edb3717fdfa8$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $d215edb3717fdfa8$var$newtonMinSlope) return $d215edb3717fdfa8$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $d215edb3717fdfa8$var$binarySubdivide(aX, intervalStart, intervalStart + $d215edb3717fdfa8$var$kSampleStepSize, mX1, mX2);
    }
    return (t)=>t === 0 || t === 1 ? t : $d215edb3717fdfa8$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("53M7p", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $bda5db73ca72351e$export$65676b58b122bc38; });

var $j9CZ5 = parcelRequire("j9CZ5");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $bda5db73ca72351e$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $j9CZ5.complex).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});

parcelRegister("698xx", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $7b9be584769add29$export$262124b154b9f1c0; });

var $h2AC2 = parcelRequire("h2AC2");

var $8H8R4 = parcelRequire("8H8R4");
var $7b9be584769add29$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    };
};
var $7b9be584769add29$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restDelta: 0.01,
        restSpeed: 10
    };
};
var $7b9be584769add29$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $7b9be584769add29$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $7b9be584769add29$var$defaultTransitions = {
    x: $7b9be584769add29$export$2577c2184b2254d3,
    y: $7b9be584769add29$export$2577c2184b2254d3,
    z: $7b9be584769add29$export$2577c2184b2254d3,
    rotate: $7b9be584769add29$export$2577c2184b2254d3,
    rotateX: $7b9be584769add29$export$2577c2184b2254d3,
    rotateY: $7b9be584769add29$export$2577c2184b2254d3,
    rotateZ: $7b9be584769add29$export$2577c2184b2254d3,
    scaleX: $7b9be584769add29$export$a743142a31c132c,
    scaleY: $7b9be584769add29$export$a743142a31c132c,
    scale: $7b9be584769add29$export$a743142a31c132c,
    opacity: $7b9be584769add29$export$c2d663fbb86d66d6,
    backgroundColor: $7b9be584769add29$export$c2d663fbb86d66d6,
    color: $7b9be584769add29$export$c2d663fbb86d66d6,
    default: $7b9be584769add29$export$a743142a31c132c
};
var $7b9be584769add29$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $8H8R4.isKeyframesTarget)(to)) transitionFactory = $7b9be584769add29$var$keyframes;
    else transitionFactory = $7b9be584769add29$var$defaultTransitions[valueKey] || $7b9be584769add29$var$defaultTransitions.default;
    return (0, $h2AC2.__assign)({
        to: to
    }, transitionFactory(to));
};

});
parcelRegister("8H8R4", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $a83d96373c4008b7$export$9153ad4c4999f4a0; });
var $a83d96373c4008b7$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});


parcelRegister("k6qEY", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $4d7337c0cd7b430b$export$cea0cedcb94873b5; });

var $j9CZ5 = parcelRequire("j9CZ5");
var $d4KQD = parcelRequire("d4KQD");

var $eCtvR = parcelRequire("eCtvR");
function $4d7337c0cd7b430b$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $eCtvR.getDefaultValueType)(key);
    if (defaultValueType !== (0, $d4KQD.filter)) defaultValueType = (0, $j9CZ5.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

});
parcelRegister("d4KQD", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $8aa758a2d42dd79a$export$3dea766d36a8935f; });

var $j9CZ5 = parcelRequire("j9CZ5");

var $6vMaC = parcelRequire("6vMaC");
const $8aa758a2d42dd79a$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $8aa758a2d42dd79a$var$applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $6vMaC.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $8aa758a2d42dd79a$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $8aa758a2d42dd79a$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $8aa758a2d42dd79a$export$3dea766d36a8935f = Object.assign(Object.assign({}, (0, $j9CZ5.complex)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($8aa758a2d42dd79a$var$functionRegex);
        return functions ? functions.map($8aa758a2d42dd79a$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRegister("eCtvR", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $2ff2bc0454319e53$export$67d1babe0338d23b; });

var $h2AC2 = parcelRequire("h2AC2");

var $emRO9 = parcelRequire("emRO9");
var $d4KQD = parcelRequire("d4KQD");

var $aFWSZ = parcelRequire("aFWSZ");
/**
 * A map of default value types for common values
 */ var $2ff2bc0454319e53$export$98cd7c72c5a731fb = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, (0, $aFWSZ.numberValueTypes)), {
    // Color props
    color: (0, $emRO9.color),
    backgroundColor: (0, $emRO9.color),
    outlineColor: (0, $emRO9.color),
    fill: (0, $emRO9.color),
    stroke: (0, $emRO9.color),
    // Border props
    borderColor: (0, $emRO9.color),
    borderTopColor: (0, $emRO9.color),
    borderRightColor: (0, $emRO9.color),
    borderBottomColor: (0, $emRO9.color),
    borderLeftColor: (0, $emRO9.color),
    filter: (0, $d4KQD.filter),
    WebkitFilter: (0, $d4KQD.filter)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $2ff2bc0454319e53$export$67d1babe0338d23b = function(key) {
    return $2ff2bc0454319e53$export$98cd7c72c5a731fb[key];
};

});
parcelRegister("aFWSZ", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $4a247115137dbd23$export$eec14432cd1cb67b; });

var $85C7Z = parcelRequire("85C7Z");
var $aak4Q = parcelRequire("aak4Q");

var $de7lV = parcelRequire("de7lV");
var $4a247115137dbd23$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $aak4Q.px),
    borderTopWidth: (0, $aak4Q.px),
    borderRightWidth: (0, $aak4Q.px),
    borderBottomWidth: (0, $aak4Q.px),
    borderLeftWidth: (0, $aak4Q.px),
    borderRadius: (0, $aak4Q.px),
    radius: (0, $aak4Q.px),
    borderTopLeftRadius: (0, $aak4Q.px),
    borderTopRightRadius: (0, $aak4Q.px),
    borderBottomRightRadius: (0, $aak4Q.px),
    borderBottomLeftRadius: (0, $aak4Q.px),
    // Positioning props
    width: (0, $aak4Q.px),
    maxWidth: (0, $aak4Q.px),
    height: (0, $aak4Q.px),
    maxHeight: (0, $aak4Q.px),
    size: (0, $aak4Q.px),
    top: (0, $aak4Q.px),
    right: (0, $aak4Q.px),
    bottom: (0, $aak4Q.px),
    left: (0, $aak4Q.px),
    // Spacing props
    padding: (0, $aak4Q.px),
    paddingTop: (0, $aak4Q.px),
    paddingRight: (0, $aak4Q.px),
    paddingBottom: (0, $aak4Q.px),
    paddingLeft: (0, $aak4Q.px),
    margin: (0, $aak4Q.px),
    marginTop: (0, $aak4Q.px),
    marginRight: (0, $aak4Q.px),
    marginBottom: (0, $aak4Q.px),
    marginLeft: (0, $aak4Q.px),
    // Transform props
    rotate: (0, $aak4Q.degrees),
    rotateX: (0, $aak4Q.degrees),
    rotateY: (0, $aak4Q.degrees),
    rotateZ: (0, $aak4Q.degrees),
    scale: (0, $85C7Z.scale),
    scaleX: (0, $85C7Z.scale),
    scaleY: (0, $85C7Z.scale),
    scaleZ: (0, $85C7Z.scale),
    skew: (0, $aak4Q.degrees),
    skewX: (0, $aak4Q.degrees),
    skewY: (0, $aak4Q.degrees),
    distance: (0, $aak4Q.px),
    translateX: (0, $aak4Q.px),
    translateY: (0, $aak4Q.px),
    translateZ: (0, $aak4Q.px),
    x: (0, $aak4Q.px),
    y: (0, $aak4Q.px),
    z: (0, $aak4Q.px),
    perspective: (0, $aak4Q.px),
    transformPerspective: (0, $aak4Q.px),
    opacity: (0, $85C7Z.alpha),
    originX: (0, $aak4Q.progressPercentage),
    originY: (0, $aak4Q.progressPercentage),
    originZ: (0, $aak4Q.px),
    // Misc
    zIndex: (0, $de7lV.int),
    // SVG
    fillOpacity: (0, $85C7Z.alpha),
    strokeOpacity: (0, $85C7Z.alpha),
    numOctaves: (0, $de7lV.int)
};

});
parcelRegister("de7lV", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $aa0bed663f214f28$export$7d260a2a5f8bc19e; });

var $h2AC2 = parcelRequire("h2AC2");

var $85C7Z = parcelRequire("85C7Z");
var $aa0bed663f214f28$export$7d260a2a5f8bc19e = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, (0, $85C7Z.number)), {
    transform: Math.round
});

});






parcelRegister("7DJC2", function(module, exports) {

$parcel$export(module.exports, "mixValues", function () { return $269ca928b46e8491$export$739e279c17d51c3d; });

var $dqZUV = parcelRequire("dqZUV");
var $4ZJs1 = parcelRequire("4ZJs1");
var $7WsgJ = parcelRequire("7WsgJ");
var $269ca928b46e8491$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var $269ca928b46e8491$var$numBorders = $269ca928b46e8491$var$borders.length;
function $269ca928b46e8491$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $4ZJs1.mix)(0, // (follow?.opacity as number) ?? 0,
        // TODO Reinstate this if only child
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, $269ca928b46e8491$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $4ZJs1.mix)((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, $269ca928b46e8491$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $4ZJs1.mix)((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $269ca928b46e8491$var$numBorders; i++){
        var borderLabel = "border" + $269ca928b46e8491$var$borders[i] + "Radius";
        var followRadius = $269ca928b46e8491$var$getRadius(follow, borderLabel);
        var leadRadius = $269ca928b46e8491$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        /**
         * Currently we're only crossfading between numerical border radius.
         * It would be possible to crossfade between percentages for a little
         * extra bundle size.
         */ if (typeof followRadius === "number" && typeof leadRadius === "number") {
            var radius = Math.max((0, $4ZJs1.mix)(followRadius, leadRadius, progress), 0);
            target[borderLabel] = radius;
        }
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $4ZJs1.mix)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $269ca928b46e8491$var$getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var $269ca928b46e8491$var$easeCrossfadeIn = $269ca928b46e8491$var$compress(0, 0.5, (0, $dqZUV.circOut));
var $269ca928b46e8491$var$easeCrossfadeOut = $269ca928b46e8491$var$compress(0.5, 0.95, (0, $dqZUV.linear));
function $269ca928b46e8491$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $7WsgJ.progress)(min, max, p));
    };
}

});

parcelRegister("1gL61", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", function () { return $b15f696dd036e722$export$c53fd88f45d77e4b; });
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $b15f696dd036e722$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $b15f696dd036e722$export$c53fd88f45d77e4b(box, originBox) {
    $b15f696dd036e722$export$a0230ae482601ae8(box.x, originBox.x);
    $b15f696dd036e722$export$a0230ae482601ae8(box.y, originBox.y);
}

});

parcelRegister("kWzRX", function(module, exports) {

$parcel$export(module.exports, "scalePoint", function () { return $e22dc10fe24093e5$export$2290ec7febe36dd6; });
$parcel$export(module.exports, "applyBoxDelta", function () { return $e22dc10fe24093e5$export$d80074982803af5c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $e22dc10fe24093e5$export$e2a980535c55eabb; });
$parcel$export(module.exports, "transformBox", function () { return $e22dc10fe24093e5$export$58b16271041fbfb; });
$parcel$export(module.exports, "translateAxis", function () { return $e22dc10fe24093e5$export$a807a5ce5ebb3895; });

var $h2AC2 = parcelRequire("h2AC2");

var $4ZJs1 = parcelRequire("4ZJs1");

var $8Ahc1 = parcelRequire("8Ahc1");
/**
 * Scales a point based on a factor and an originPoint
 */ function $e22dc10fe24093e5$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $e22dc10fe24093e5$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $e22dc10fe24093e5$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $e22dc10fe24093e5$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $e22dc10fe24093e5$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $e22dc10fe24093e5$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $e22dc10fe24093e5$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $e22dc10fe24093e5$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $e22dc10fe24093e5$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $e22dc10fe24093e5$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $e22dc10fe24093e5$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) isSharedTransition = false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $e22dc10fe24093e5$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $8Ahc1.hasTransform)(node.latestValues)) $e22dc10fe24093e5$export$58b16271041fbfb(box, node.latestValues);
    }
}
function $e22dc10fe24093e5$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $e22dc10fe24093e5$export$625f1dd140a2f5e7(axis, transforms, _a) {
    var _b = (0, $h2AC2.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $4ZJs1.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $e22dc10fe24093e5$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $e22dc10fe24093e5$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $e22dc10fe24093e5$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $e22dc10fe24093e5$export$58b16271041fbfb(box, transform) {
    $e22dc10fe24093e5$export$625f1dd140a2f5e7(box.x, transform, $e22dc10fe24093e5$var$xKeys);
    $e22dc10fe24093e5$export$625f1dd140a2f5e7(box.y, transform, $e22dc10fe24093e5$var$yKeys);
}

});
parcelRegister("8Ahc1", function(module, exports) {

$parcel$export(module.exports, "hasScale", function () { return $3888b9fc81497b1e$export$bdf30dca883ea463; });
$parcel$export(module.exports, "hasTransform", function () { return $3888b9fc81497b1e$export$a545127cf1fbb600; });
function $3888b9fc81497b1e$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $3888b9fc81497b1e$export$bdf30dca883ea463(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return !$3888b9fc81497b1e$var$isIdentityScale(scale) || !$3888b9fc81497b1e$var$isIdentityScale(scaleX) || !$3888b9fc81497b1e$var$isIdentityScale(scaleY);
}
function $3888b9fc81497b1e$export$a545127cf1fbb600(values) {
    return $3888b9fc81497b1e$export$bdf30dca883ea463(values) || $3888b9fc81497b1e$var$hasTranslate(values.x) || $3888b9fc81497b1e$var$hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $3888b9fc81497b1e$var$hasTranslate(value) {
    return value && value !== "0%";
}

});


parcelRegister("8jMj5", function(module, exports) {

$parcel$export(module.exports, "calcLength", function () { return $59498c2c98f9051e$export$c1c127004b72a37; });
$parcel$export(module.exports, "calcBoxDelta", function () { return $59498c2c98f9051e$export$c0d25e96fc67d310; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $59498c2c98f9051e$export$426154f9d100f99; });
$parcel$export(module.exports, "calcRelativePosition", function () { return $59498c2c98f9051e$export$2785bfcc929c5650; });

var $68qV4 = parcelRequire("68qV4");
var $4ZJs1 = parcelRequire("4ZJs1");
function $59498c2c98f9051e$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $59498c2c98f9051e$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $68qV4.distance)(value, target) < maxDistance;
}
function $59498c2c98f9051e$export$e90fc1ae5e3e48ed(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $4ZJs1.mix)(source.min, source.max, delta.origin);
    delta.scale = $59498c2c98f9051e$export$c1c127004b72a37(target) / $59498c2c98f9051e$export$c1c127004b72a37(source);
    if ($59498c2c98f9051e$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $4ZJs1.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($59498c2c98f9051e$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $59498c2c98f9051e$export$c0d25e96fc67d310(delta, source, target, origin) {
    $59498c2c98f9051e$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $59498c2c98f9051e$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $59498c2c98f9051e$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $59498c2c98f9051e$export$c1c127004b72a37(relative);
}
function $59498c2c98f9051e$export$426154f9d100f99(target, relative, parent) {
    $59498c2c98f9051e$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $59498c2c98f9051e$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $59498c2c98f9051e$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $59498c2c98f9051e$export$c1c127004b72a37(layout);
}
function $59498c2c98f9051e$export$2785bfcc929c5650(target, layout, parent) {
    $59498c2c98f9051e$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $59498c2c98f9051e$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});
parcelRegister("68qV4", function(module, exports) {

$parcel$export(module.exports, "distance", function () { return $207bc01ef6d865a7$export$9f17032d917177de; });

var $4iQot = parcelRequire("4iQot");

var $1lEuS = parcelRequire("1lEuS");

var $dXEz4 = parcelRequire("dXEz4");
const $207bc01ef6d865a7$var$distance1D = (a, b)=>Math.abs(a - b);
function $207bc01ef6d865a7$export$9f17032d917177de(a, b) {
    if ((0, $dXEz4.isNum)(a) && (0, $dXEz4.isNum)(b)) return $207bc01ef6d865a7$var$distance1D(a, b);
    else if ((0, $4iQot.isPoint)(a) && (0, $4iQot.isPoint)(b)) {
        const xDelta = $207bc01ef6d865a7$var$distance1D(a.x, b.x);
        const yDelta = $207bc01ef6d865a7$var$distance1D(a.y, b.y);
        const zDelta = (0, $1lEuS.isPoint3D)(a) && (0, $1lEuS.isPoint3D)(b) ? $207bc01ef6d865a7$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

});
parcelRegister("4iQot", function(module, exports) {

$parcel$export(module.exports, "isPoint", function () { return $8fed030839bcbaed$export$aff838a5553f2a92; });
const $8fed030839bcbaed$export$aff838a5553f2a92 = (point)=>point.hasOwnProperty("x") && point.hasOwnProperty("y");

});

parcelRegister("1lEuS", function(module, exports) {

$parcel$export(module.exports, "isPoint3D", function () { return $5c78f63cd4c9529a$export$319d74662aaa2966; });

var $4iQot = parcelRequire("4iQot");
const $5c78f63cd4c9529a$export$319d74662aaa2966 = (point)=>(0, $4iQot.isPoint)(point) && point.hasOwnProperty("z");

});



parcelRegister("04Dq7", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", function () { return $ca69142dd55675c8$export$73e1ad0a9694e25c; });

var $h2AC2 = parcelRequire("h2AC2");

var $4ZJs1 = parcelRequire("4ZJs1");

var $aak4Q = parcelRequire("aak4Q");

var $kWzRX = parcelRequire("kWzRX");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $ca69142dd55675c8$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $kWzRX.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $kWzRX.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $ca69142dd55675c8$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    if (originAxis === void 0) originAxis = axis;
    if (sourceAxis === void 0) sourceAxis = axis;
    if ((0, $aak4Q.percent).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $4ZJs1.mix)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $4ZJs1.mix)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $ca69142dd55675c8$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $ca69142dd55675c8$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $ca69142dd55675c8$export$42b76f1d0d16d5b(axis, transforms, _a, origin, sourceAxis) {
    var _b = (0, $h2AC2.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $ca69142dd55675c8$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $ca69142dd55675c8$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $ca69142dd55675c8$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $ca69142dd55675c8$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $ca69142dd55675c8$export$42b76f1d0d16d5b(box.x, transforms, $ca69142dd55675c8$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $ca69142dd55675c8$export$42b76f1d0d16d5b(box.y, transforms, $ca69142dd55675c8$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}

});

parcelRegister("a25ec", function(module, exports) {

$parcel$export(module.exports, "createDelta", function () { return $53361134eea6347f$export$3d227df54007d73a; });
$parcel$export(module.exports, "createBox", function () { return $53361134eea6347f$export$6459fc9e86be362e; });
var $53361134eea6347f$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $53361134eea6347f$export$3d227df54007d73a = function() {
    return {
        x: $53361134eea6347f$export$ff25708b37f72782(),
        y: $53361134eea6347f$export$ff25708b37f72782()
    };
};
var $53361134eea6347f$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $53361134eea6347f$export$6459fc9e86be362e = function() {
    return {
        x: $53361134eea6347f$export$6db76765312617ac(),
        y: $53361134eea6347f$export$6db76765312617ac()
    };
};

});

parcelRegister("fnOZP", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", function () { return $3f713a8d768d4fd4$export$a7ec7642fe550fb6; });
$parcel$export(module.exports, "boxEquals", function () { return $3f713a8d768d4fd4$export$8d5cf76bb7daff09; });
function $3f713a8d768d4fd4$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $3f713a8d768d4fd4$export$a7ec7642fe550fb6(delta) {
    return $3f713a8d768d4fd4$var$isAxisDeltaZero(delta.x) && $3f713a8d768d4fd4$var$isAxisDeltaZero(delta.y);
}
function $3f713a8d768d4fd4$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}

});

parcelRegister("1YYMz", function(module, exports) {

$parcel$export(module.exports, "NodeStack", function () { return $c0712a3b878043ee$export$39be5b2d82fc9dc7; });

var $eOw3w = parcelRequire("eOw3w");
var $c0712a3b878043ee$export$39be5b2d82fc9dc7 = /** @class */ function() {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function(node) {
        (0, $eOw3w.addUniqueItem)(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function(node) {
        (0, $eOw3w.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    };
    NodeStack.prototype.relegate = function(node) {
        var indexOfNode = this.members.findIndex(function(member) {
            return node === member;
        });
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ var prevLead;
        for(var i = indexOfNode; i >= 0; i--){
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    };
    NodeStack.prototype.promote = function(node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            var crossfade = node.options.crossfade;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    };
    NodeStack.prototype.exitAnimationComplete = function() {
        this.members.forEach(function(node) {
            var _a, _b;
            return (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    NodeStack.prototype.scheduleRender = function() {
        this.members.forEach(function(node) {
            node.instance && node.scheduleRender(false);
        });
    };
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ NodeStack.prototype.removeLeadSnapshot = function() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    };
    return NodeStack;
}();

});

parcelRegister("01NoW", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $3e03ea88c316ef05$export$91ddd985b97788d1; });
$parcel$export(module.exports, "addScaleCorrector", function () { return $3e03ea88c316ef05$export$de9e7791c71225fd; });
var $3e03ea88c316ef05$export$91ddd985b97788d1 = {};
function $3e03ea88c316ef05$export$de9e7791c71225fd(correctors) {
    Object.assign($3e03ea88c316ef05$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("6qvq2", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", function () { return $216ee9a3292cadae$export$d33653b270fe725c; });
var $216ee9a3292cadae$export$f6730f82d2dcfda3 = "translate3d(0px, 0px, 0) scale(1, 1)";
function $216ee9a3292cadae$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(" + rotate + "deg) ";
        if (rotateX) transform += "rotateX(" + rotateX + "deg) ";
        if (rotateY) transform += "rotateY(" + rotateY + "deg) ";
    }
    transform += "scale(" + delta.x.scale + ", " + delta.y.scale + ")";
    return transform === $216ee9a3292cadae$export$f6730f82d2dcfda3 ? "none" : transform;
}

});

parcelRegister("6k0Is", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $7d4ee8370e54388b$export$b789de563eb43b1; });
function $7d4ee8370e54388b$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("1wxj0", function(module, exports) {

$parcel$export(module.exports, "transformAxes", function () { return $c92aa2a8871aa8a0$export$67cd428da31419e1; });
$parcel$export(module.exports, "transformProps", function () { return $c92aa2a8871aa8a0$export$7b42a0094fb00b6e; });
$parcel$export(module.exports, "sortTransformProps", function () { return $c92aa2a8871aa8a0$export$61f68472e7973485; });
$parcel$export(module.exports, "isTransformProp", function () { return $c92aa2a8871aa8a0$export$15240a8a4379d8de; });
$parcel$export(module.exports, "isTransformOriginProp", function () { return $c92aa2a8871aa8a0$export$91fe49ee9d172523; });
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $c92aa2a8871aa8a0$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $c92aa2a8871aa8a0$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $c92aa2a8871aa8a0$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$c92aa2a8871aa8a0$var$order.forEach(function(operationKey) {
    return $c92aa2a8871aa8a0$export$67cd428da31419e1.forEach(function(axesKey) {
        return $c92aa2a8871aa8a0$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $c92aa2a8871aa8a0$export$61f68472e7973485(a, b) {
    return $c92aa2a8871aa8a0$export$7b42a0094fb00b6e.indexOf(a) - $c92aa2a8871aa8a0$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $c92aa2a8871aa8a0$var$transformPropSet = new Set($c92aa2a8871aa8a0$export$7b42a0094fb00b6e);
function $c92aa2a8871aa8a0$export$15240a8a4379d8de(key) {
    return $c92aa2a8871aa8a0$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $c92aa2a8871aa8a0$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $c92aa2a8871aa8a0$export$91fe49ee9d172523(key) {
    return $c92aa2a8871aa8a0$var$transformOriginProps.has(key);
}

});

parcelRegister("apWKf", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $b9931c8add2343f9$export$1465d17e3de78a96; });

var $eOw3w = parcelRequire("eOw3w");

var $gO3ez = parcelRequire("gO3ez");
var $b9931c8add2343f9$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $eOw3w.addUniqueItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $eOw3w.removeItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $gO3ez.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();

});
parcelRegister("gO3ez", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $f31e493b981c50fd$export$d689d9dec5ad338; });
var $f31e493b981c50fd$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});


parcelRegister("coOVK", function(module, exports) {

$parcel$export(module.exports, "elementDragControls", function () { return $3ab88a5d97dd0ddb$export$f0a15892c27dc07c; });
$parcel$export(module.exports, "VisualElementDragControls", function () { return $3ab88a5d97dd0ddb$export$86bff71f18910307; });

var $h2AC2 = parcelRequire("h2AC2");

var $8hGPO = parcelRequire("8hGPO");

var $4WIgB = parcelRequire("4WIgB");

var $dw5od = parcelRequire("dw5od");

var $iinLf = parcelRequire("iinLf");

var $emeFu = parcelRequire("emeFu");

var $iPyNW = parcelRequire("iPyNW");

var $3uQDG = parcelRequire("3uQDG");

var $a25ec = parcelRequire("a25ec");

var $6k0Is = parcelRequire("6k0Is");

var $jIuON = parcelRequire("jIuON");

var $4AK4z = parcelRequire("4AK4z");

var $5npex = parcelRequire("5npex");

var $kSPlp = parcelRequire("kSPlp");
var $3ab88a5d97dd0ddb$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
var $3ab88a5d97dd0ddb$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a25ec.createBox)();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        var initialPoint;
        var onSessionStart = function(event) {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopAnimation();
            /**
             * Save the initial point. We'll use this to calculate the pointer's position rather
             * than the one we receive when the gesture actually starts. By then, the pointer will
             * have already moved, and the perception will be of the pointer "slipping" across the element
             */ initialPoint = (0, $4AK4z.getViewportPointFromEvent)(event).point;
        };
        var onStart = function(event, info) {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $dw5od.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            // TODO: Block layout animations
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (snapToCursor) _this.snapToCursor(initialPoint);
            if (_this.visualElement.projection) _this.visualElement.projection.target = undefined;
            /**
             * Record gesture origin
             */ (0, $6k0Is.eachAxis)(function(axis) {
                _this.originPoint[axis] = _this.getAxisMotionValue(axis).get();
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3uQDG.AnimationType).Drag, true);
        };
        var onMove = function(event, info) {
            // latestPointerEvent = event
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $3ab88a5d97dd0ddb$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(_this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.syncRender();
            /**
             * This must fire after the syncRender call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new (0, $4WIgB.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function() {
        var _a, _b;
        // TODO: Unblock layout animations
        this.isDragging = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $3uQDG.AnimationType).Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function(axis, _point, offset) {
        var drag = this.getProps().drag;
        // If we're not dragging this axis, do an early return.
        if (!offset || !$3ab88a5d97dd0ddb$var$shouldDrag(axis, drag, this.currentDirection)) return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $iPyNW.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function() {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && (0, $iinLf.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $iPyNW.calcRelativeConstraints)(layout.actual, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $iPyNW.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $6k0Is.eachAxis)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $iPyNW.rebaseAxisConstraints)(layout.actual[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function() {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !(0, $iinLf.isRefObject)(constraints)) return false;
        var constraintsElement = constraints.current;
        (0, $8hGPO.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        // TODO
        if (!projection || !projection.layout) return false;
        var constraintsBox = (0, $jIuON.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = (0, $iPyNW.calcViewportConstraints)(projection.layout.actual, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $kSPlp.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $kSPlp.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function(velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = (0, $6k0Is.eachAxis)(function(axis) {
            var _a;
            if (!$3ab88a5d97dd0ddb$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return (0, $5npex.startAnimation)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function() {
        var _this = this;
        (0, $6k0Is.eachAxis)(function(axis) {
            return _this.getAxisMotionValue(axis).stop();
        });
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function(_point) {};
    VisualElementDragControls.prototype.addListeners = function() {
        var _this = this;
        $3ab88a5d97dd0ddb$export$f0a15892c27dc07c.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $emeFu.addPointerEvent)(element, "pointerdown", function(event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function() {
            var dragConstraints = _this.getProps().dragConstraints;
            if ((0, $iinLf.isRefObject)(dragConstraints)) _this.constraints = _this.resolveRefConstraints();
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (!projection.layout) projection.updateLayout();
        measureDragConstraints();
        // TODO: Scale point on resize
        projection.addEventListener("didUpdate", function(_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                (0, $6k0Is.eachAxis)(function(axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        });
        return function() {
            stopPointerListener();
            stopMeasureLayoutListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function() {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? (0, $iPyNW.defaultElastic) : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    };
    return VisualElementDragControls;
}();
function $3ab88a5d97dd0ddb$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $3ab88a5d97dd0ddb$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("4WIgB", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $63eabbc753591c91$export$d9c66232c9c4689c; });

var $h2AC2 = parcelRequire("h2AC2");

var $25Zd9 = parcelRequire("25Zd9");

var $4AK4z = parcelRequire("4AK4z");

var $ghy0K = parcelRequire("ghy0K");

var $iJsHS = parcelRequire("iJsHS");

var $emeFu = parcelRequire("emeFu");

var $68qV4 = parcelRequire("68qV4");
var $3mlnP = parcelRequire("3mlnP");
/**
 * @internal
 */ var $63eabbc753591c91$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $63eabbc753591c91$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $68qV4.distance)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $ghy0K.getFrameData)().timestamp;
            _this.history.push((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $63eabbc753591c91$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $25Zd9.isMouseEvent)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $ghy0K.default).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $63eabbc753591c91$var$getPanInfo($63eabbc753591c91$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $25Zd9.isTouchEvent)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $4AK4z.extractEventInfo)(event);
        var initialInfo = $63eabbc753591c91$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $ghy0K.getFrameData)().timestamp;
        this.history = [
            (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $63eabbc753591c91$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $3mlnP.pipe)((0, $emeFu.addPointerEvent)(window, "pointermove", this.handlePointerMove), (0, $emeFu.addPointerEvent)(window, "pointerup", this.handlePointerUp), (0, $emeFu.addPointerEvent)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $ghy0K.cancelSync).update(this.updatePoint);
    };
    return PanSession;
}();
function $63eabbc753591c91$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $63eabbc753591c91$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $63eabbc753591c91$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $63eabbc753591c91$var$subtractPoint(point, $63eabbc753591c91$var$lastDevicePoint(history)),
        offset: $63eabbc753591c91$var$subtractPoint(point, $63eabbc753591c91$var$startDevicePoint(history)),
        velocity: $63eabbc753591c91$var$getVelocity(history, 0.1)
    };
}
function $63eabbc753591c91$var$startDevicePoint(history) {
    return history[0];
}
function $63eabbc753591c91$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $63eabbc753591c91$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $63eabbc753591c91$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $iJsHS.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("25Zd9", function(module, exports) {

$parcel$export(module.exports, "isMouseEvent", function () { return $0791425f070600ea$export$764db16956f554f8; });
$parcel$export(module.exports, "isTouchEvent", function () { return $0791425f070600ea$export$c4dfce035d43d1e0; });
function $0791425f070600ea$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $0791425f070600ea$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

});

parcelRegister("4AK4z", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $42b1e911ff87146a$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "getViewportPointFromEvent", function () { return $42b1e911ff87146a$export$750e59ed656e0503; });
$parcel$export(module.exports, "wrapHandler", function () { return $42b1e911ff87146a$export$f4437ba81469b709; });

var $25Zd9 = parcelRequire("25Zd9");
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $42b1e911ff87146a$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $42b1e911ff87146a$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $42b1e911ff87146a$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $42b1e911ff87146a$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $42b1e911ff87146a$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $42b1e911ff87146a$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $25Zd9.isTouchEvent)(event) ? $42b1e911ff87146a$var$pointFromTouch(event, pointType) : $42b1e911ff87146a$var$pointFromMouse(event, pointType)
    };
}
function $42b1e911ff87146a$export$750e59ed656e0503(event) {
    return $42b1e911ff87146a$export$12f84bb882d06e1a(event, "client");
}
var $42b1e911ff87146a$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $42b1e911ff87146a$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $42b1e911ff87146a$var$filterPrimaryPointer(listener) : listener;
};

});

parcelRegister("emeFu", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $3f161e0f7c30fb80$export$fcff2e64e6676b81; });
$parcel$export(module.exports, "usePointerEvent", function () { return $3f161e0f7c30fb80$export$734d04395f5243cd; });

var $i21Bo = parcelRequire("i21Bo");

var $4AK4z = parcelRequire("4AK4z");

var $lKxgx = parcelRequire("lKxgx");
var $3f161e0f7c30fb80$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $3f161e0f7c30fb80$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $3f161e0f7c30fb80$var$getPointerEventName(name) {
    if ((0, $lKxgx.supportsPointerEvents)()) return name;
    else if ((0, $lKxgx.supportsTouchEvents)()) return $3f161e0f7c30fb80$var$touchEventNames[name];
    else if ((0, $lKxgx.supportsMouseEvents)()) return $3f161e0f7c30fb80$var$mouseEventNames[name];
    return name;
}
function $3f161e0f7c30fb80$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $i21Bo.addDomEvent)(target, $3f161e0f7c30fb80$var$getPointerEventName(eventName), (0, $4AK4z.wrapHandler)(handler, eventName === "pointerdown"), options);
}
function $3f161e0f7c30fb80$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $i21Bo.useDomEvent)(ref, $3f161e0f7c30fb80$var$getPointerEventName(eventName), handler && (0, $4AK4z.wrapHandler)(handler, eventName === "pointerdown"), options);
}

});
parcelRegister("i21Bo", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $1ef6b6a41e757fc1$export$b1d829ddf82884aa; });
$parcel$export(module.exports, "useDomEvent", function () { return $1ef6b6a41e757fc1$export$c1052189363cb2e0; });

var $70fFQ = parcelRequire("70fFQ");
function $1ef6b6a41e757fc1$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $1ef6b6a41e757fc1$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $70fFQ.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $1ef6b6a41e757fc1$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}

});

parcelRegister("lKxgx", function(module, exports) {

$parcel$export(module.exports, "supportsPointerEvents", function () { return $fc5bbbab43ab2d31$export$ed662207763ba653; });
$parcel$export(module.exports, "supportsTouchEvents", function () { return $fc5bbbab43ab2d31$export$58e9cbc5718eb8c2; });
$parcel$export(module.exports, "supportsMouseEvents", function () { return $fc5bbbab43ab2d31$export$1a3879af679d3ede; });

var $gzrOo = parcelRequire("gzrOo");
// We check for event support via functions in case they've been mocked by a testing suite.
var $fc5bbbab43ab2d31$export$ed662207763ba653 = function() {
    return (0, $gzrOo.isBrowser) && window.onpointerdown === null;
};
var $fc5bbbab43ab2d31$export$58e9cbc5718eb8c2 = function() {
    return (0, $gzrOo.isBrowser) && window.ontouchstart === null;
};
var $fc5bbbab43ab2d31$export$1a3879af679d3ede = function() {
    return (0, $gzrOo.isBrowser) && window.onmousedown === null;
};

});



parcelRegister("dw5od", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", function () { return $6e3570f8edfc2f97$export$2b7959ed03c1a3fe; });
$parcel$export(module.exports, "isDragActive", function () { return $6e3570f8edfc2f97$export$1b3dd616664938e4; });
function $6e3570f8edfc2f97$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $6e3570f8edfc2f97$var$globalHorizontalLock = $6e3570f8edfc2f97$export$518c5fc2dcb7974b("dragHorizontal");
var $6e3570f8edfc2f97$var$globalVerticalLock = $6e3570f8edfc2f97$export$518c5fc2dcb7974b("dragVertical");
function $6e3570f8edfc2f97$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $6e3570f8edfc2f97$var$globalVerticalLock();
    else if (drag === "x") lock = $6e3570f8edfc2f97$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $6e3570f8edfc2f97$var$globalHorizontalLock();
        var openVertical_1 = $6e3570f8edfc2f97$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $6e3570f8edfc2f97$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $6e3570f8edfc2f97$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});

parcelRegister("iPyNW", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $f442fe96e36b1c8a$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $f442fe96e36b1c8a$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $f442fe96e36b1c8a$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $f442fe96e36b1c8a$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $f442fe96e36b1c8a$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $f442fe96e36b1c8a$export$7c5eaef8f4723d22; });

var $h2AC2 = parcelRequire("h2AC2");

var $4ZJs1 = parcelRequire("4ZJs1");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $f442fe96e36b1c8a$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $4ZJs1.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $4ZJs1.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $f442fe96e36b1c8a$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $f442fe96e36b1c8a$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $f442fe96e36b1c8a$export$690c180aa5775042(layoutBox.x, left, right),
        y: $f442fe96e36b1c8a$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $f442fe96e36b1c8a$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $h2AC2.__read)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $f442fe96e36b1c8a$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $f442fe96e36b1c8a$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $f442fe96e36b1c8a$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $f442fe96e36b1c8a$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $f442fe96e36b1c8a$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $f442fe96e36b1c8a$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === void 0) dragElastic = $f442fe96e36b1c8a$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $f442fe96e36b1c8a$export$a3366d3bac43a742;
    return {
        x: $f442fe96e36b1c8a$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $f442fe96e36b1c8a$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $f442fe96e36b1c8a$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $f442fe96e36b1c8a$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $f442fe96e36b1c8a$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $f442fe96e36b1c8a$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

});

parcelRegister("3uQDG", function(module, exports) {

$parcel$export(module.exports, "AnimationType", function () { return $6312c4a215e0ad2a$export$2deb71ebd3734d23; });
var $6312c4a215e0ad2a$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})($6312c4a215e0ad2a$export$2deb71ebd3734d23 || ($6312c4a215e0ad2a$export$2deb71ebd3734d23 = {}));

});

parcelRegister("jIuON", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $1ad6e9a7e88dadbf$export$d8718b6a7e5c624e; });
$parcel$export(module.exports, "measurePageBox", function () { return $1ad6e9a7e88dadbf$export$6a597be7a7940a96; });

var $kSPlp = parcelRequire("kSPlp");

var $kWzRX = parcelRequire("kWzRX");
function $1ad6e9a7e88dadbf$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $kSPlp.convertBoundingBoxToBox)((0, $kSPlp.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $1ad6e9a7e88dadbf$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $1ad6e9a7e88dadbf$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $kWzRX.translateAxis)(viewportBox.x, scroll.x);
        (0, $kWzRX.translateAxis)(viewportBox.y, scroll.y);
    }
    return viewportBox;
}

});
parcelRegister("kSPlp", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $1a0587b43f6fbea7$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "convertBoxToBoundingBox", function () { return $1a0587b43f6fbea7$export$b6b9cd4198191a47; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $1a0587b43f6fbea7$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $1a0587b43f6fbea7$export$d3955c6a8f65a36b(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $1a0587b43f6fbea7$export$b6b9cd4198191a47(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $1a0587b43f6fbea7$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});





parcelRegister("iHdVw", function(module, exports) {

$parcel$export(module.exports, "useProjection", function () { return $b3a3a0ffd40daa16$export$80ade90e64f5118b; });

var $lh3oQ = parcelRequire("lh3oQ");

var $iinLf = parcelRequire("iinLf");
function $b3a3a0ffd40daa16$export$80ade90e64f5118b(projectionId, _a, visualElement, initialPromotionConfig) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, shouldMeasureScroll = _a.shouldMeasureScroll;
    if (!visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) return;
    visualElement.projection = new (0, $lh3oQ.HTMLProjectionNode)(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $iinLf.isRefObject)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: function() {
            return visualElement.scheduleRender();
        },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        shouldMeasureScroll: shouldMeasureScroll
    });
}

});
parcelRegister("lh3oQ", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", function () { return $7def4cf26b12fa25$export$b61a9eb3dbde8858; });

var $e98Ft = parcelRequire("e98Ft");

var $iVcfh = parcelRequire("iVcfh");
var $7def4cf26b12fa25$export$b91509fcf893b648 = {
    current: undefined
};
var $7def4cf26b12fa25$export$b61a9eb3dbde8858 = (0, $e98Ft.createProjectionNode)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$7def4cf26b12fa25$export$b91509fcf893b648.current) {
            var documentNode = new (0, $iVcfh.DocumentProjectionNode)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                shouldMeasureScroll: true
            });
            $7def4cf26b12fa25$export$b91509fcf893b648.current = documentNode;
        }
        return $7def4cf26b12fa25$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    }
});

});
parcelRegister("iVcfh", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", function () { return $a465340a47693084$export$2d029a49a09b6177; });

var $e98Ft = parcelRequire("e98Ft");
var $a465340a47693084$export$2d029a49a09b6177 = (0, $e98Ft.createProjectionNode)({
    attachResizeListener: function(ref, notify) {
        ref.addEventListener("resize", notify, {
            passive: true
        });
        return function() {
            return ref.removeEventListener("resize", notify);
        };
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    }
});

});



parcelRegister("axLzK", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $f98ef2b956152118$export$da5f7b802957459a; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @internal
 */ var $f98ef2b956152118$export$da5f7b802957459a = (0, $70fFQ.createContext)({});

});

parcelRegister("9X7ZU", function(module, exports) {

$parcel$export(module.exports, "VisualElementHandler", function () { return $55c7df680cf82c9b$export$a9ca437df31f9491; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");
var $55c7df680cf82c9b$export$a9ca437df31f9491 = /** @class */ function(_super) {
    (0, $h2AC2.__extends)(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VisualElementHandler.prototype.componentDidMount = function() {
        this.updateProps();
    };
    VisualElementHandler.prototype.getSnapshotBeforeUpdate = function() {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function() {};
    VisualElementHandler.prototype.updateProps = function() {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement) visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function() {
        return this.props.children;
    };
    return VisualElementHandler;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);

});


parcelRegister("6mbap", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $cde5772bc0de60dc$export$a28d6df673050e18; });

var $knVM4 = parcelRequire("knVM4");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $cde5772bc0de60dc$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $knVM4.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("4uQc8", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", function () { return $1dd985c9d2ef6b1b$export$732916c0e88175fb; });

var $h2AC2 = parcelRequire("h2AC2");

var $asI36 = parcelRequire("asI36");

var $bcg2p = parcelRequire("bcg2p");

var $askod = parcelRequire("askod");

var $7zfgA = parcelRequire("7zfgA");
function $1dd985c9d2ef6b1b$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $asI36.isSVGComponent)(Component) ? (0, $askod.svgMotionConfig) : (0, $7zfgA.htmlMotionConfig);
    return (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $bcg2p.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    });
}

});
parcelRegister("asI36", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $8132079a6b05789f$export$88f3fc2fd3766989; });

var $hCl65 = parcelRequire("hCl65");
function $8132079a6b05789f$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $hCl65.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

});
parcelRegister("hCl65", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $fea68bb8e031fee9$export$40209c4c512158e6; });
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $fea68bb8e031fee9$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("bcg2p", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $c865bc1be6faefd8$export$5d29104eefd89cc8; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $axwEE = parcelRequire("axwEE");

var $4a3BP = parcelRequire("4a3BP");

var $asI36 = parcelRequire("asI36");

var $djKZy = parcelRequire("djKZy");
function $c865bc1be6faefd8$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $asI36.isSVGComponent)(Component) ? (0, $djKZy.useSVGProps) : (0, $axwEE.useHTMLProps);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $4a3BP.filterProps)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $h2AC2.__assign)((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, filteredProps), visualProps), {
            ref: ref
        });
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $70fFQ.createElement)(Component, elementProps);
    };
    return useRender;
}

});
parcelRegister("axwEE", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $1f7b345814c2eb81$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $1f7b345814c2eb81$export$57be0a314572d87d; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $2qx4M = parcelRequire("2qx4M");

var $39Z1B = parcelRequire("39Z1B");

var $dY0q5 = parcelRequire("dY0q5");

var $lcdHn = parcelRequire("lcdHn");
function $1f7b345814c2eb81$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $39Z1B.isMotionValue)(source[key]) && !(0, $2qx4M.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $1f7b345814c2eb81$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $70fFQ.useMemo)(function() {
        var state = (0, $lcdHn.createHtmlRenderState)();
        (0, $dY0q5.buildHTMLStyles)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, vars), style);
    }, [
        visualState
    ]);
}
function $1f7b345814c2eb81$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $1f7b345814c2eb81$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $1f7b345814c2eb81$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $1f7b345814c2eb81$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $1f7b345814c2eb81$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag)) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-" + (props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("2qx4M", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $264c028007dde59f$export$6d27ce8e3de1c3cf; });

var $01NoW = parcelRequire("01NoW");

var $1wxj0 = parcelRequire("1wxj0");
function $264c028007dde59f$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $1wxj0.isTransformProp)(key) || (0, $1wxj0.isTransformOriginProp)(key) || (layout || layoutId !== undefined) && (!!(0, $01NoW.scaleCorrectors)[key] || key === "opacity");
}

});

parcelRegister("dY0q5", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $3f24747556419333$export$bb517f8b40f8e99d; });

var $eyLS4 = parcelRequire("eyLS4");

var $fTJLc = parcelRequire("fTJLc");

var $1wxj0 = parcelRequire("1wxj0");

var $6QcTE = parcelRequire("6QcTE");

var $aFWSZ = parcelRequire("aFWSZ");
function $3f24747556419333$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $fTJLc.isCSSVariable)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $aFWSZ.numberValueTypes)[key];
        var valueAsType = (0, $6QcTE.getValueAsType)(value, valueType);
        if ((0, $1wxj0.isTransformProp)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $1wxj0.isTransformOriginProp)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else style[key] = valueAsType;
    }
    if (hasTransform) style.transform = (0, $eyLS4.buildTransform)(state, options, transformIsNone, transformTemplate);
    else if (transformTemplate) style.transform = transformTemplate({}, "");
    if (hasTransformOrigin) style.transformOrigin = (0, $eyLS4.buildTransformOrigin)(transformOrigin);
}

});
parcelRegister("eyLS4", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $64ae727bc5f348dd$export$bdc96e0d5c8f914; });
$parcel$export(module.exports, "buildTransformOrigin", function () { return $64ae727bc5f348dd$export$22d2fbf39767d07a; });

var $1wxj0 = parcelRequire("1wxj0");
var $64ae727bc5f348dd$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $64ae727bc5f348dd$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $1wxj0.sortTransformProps));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += ($64ae727bc5f348dd$var$translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $64ae727bc5f348dd$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}

});

parcelRegister("fTJLc", function(module, exports) {

$parcel$export(module.exports, "isCSSVariable", function () { return $bbca42f9051602dc$export$451bc42768436155; });
/**
 * Returns true if the provided key is a CSS variable
 */ function $bbca42f9051602dc$export$451bc42768436155(key) {
    return key.startsWith("--");
}

});

parcelRegister("6QcTE", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $27b3e00f43bbffd1$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $27b3e00f43bbffd1$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});


parcelRegister("lcdHn", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $84a09e20b78fc43e$export$8940b483cf52eeda; });
var $84a09e20b78fc43e$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRegister("4a3BP", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $ab3043df4e1eac40$export$d697c39a2985a4c; });

var $gRRhf = parcelRequire("gRRhf");
var $ab3043df4e1eac40$var$shouldForward = function(key) {
    return !(0, $gRRhf.isValidMotionProp)(key);
};

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    var $ab3043df4e1eac40$var$emotionIsPropValid_1 = (parcelRequire("1PTSn")).default;
    $ab3043df4e1eac40$var$shouldForward = function(key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) return !(0, $gRRhf.isValidMotionProp)(key);
        else return $ab3043df4e1eac40$var$emotionIsPropValid_1(key);
    };
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $ab3043df4e1eac40$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($ab3043df4e1eac40$var$shouldForward(key) || forwardMotionProps === true && (0, $gRRhf.isValidMotionProp)(key) || !isDom && !(0, $gRRhf.isValidMotionProp)(key)) filteredProps[key] = props[key];
    return filteredProps;
}

});
parcelRegister("gRRhf", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $3ebe52cacf06f7b0$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $3ebe52cacf06f7b0$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "shouldMeasureScroll"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $3ebe52cacf06f7b0$export$2f9c46555243bf04(key) {
    return $3ebe52cacf06f7b0$var$validMotionProps.has(key);
}

});

parcelRegister("1PTSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1565e5aeef488d7b$export$2e2bcd8739ae039; });

var $iZzZN = parcelRequire("iZzZN");
var $1565e5aeef488d7b$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $1565e5aeef488d7b$var$index = (0, $iZzZN.default)(function(prop) {
    return $1565e5aeef488d7b$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $1565e5aeef488d7b$export$2e2bcd8739ae039 = $1565e5aeef488d7b$var$index;

});
parcelRegister("iZzZN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $039172f9d3e9b746$export$2e2bcd8739ae039; });
function $039172f9d3e9b746$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $039172f9d3e9b746$export$2e2bcd8739ae039 = $039172f9d3e9b746$var$memoize;

});



parcelRegister("djKZy", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $cf81b006d8477f23$export$84309c4f53cb1bd5; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $axwEE = parcelRequire("axwEE");

var $bi2eK = parcelRequire("bi2eK");

var $ecxom = parcelRequire("ecxom");
function $cf81b006d8477f23$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $70fFQ.useMemo)(function() {
        var state = (0, $ecxom.createSvgRenderState)();
        (0, $bi2eK.buildSVGAttrs)(state, visualState, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, state.attrs), {
            style: (0, $h2AC2.__assign)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $axwEE.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

});
parcelRegister("bi2eK", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $459fe9e8691031c0$export$5475d24f125d7053; });

var $h2AC2 = parcelRequire("h2AC2");

var $dY0q5 = parcelRequire("dY0q5");

var $hdzJY = parcelRequire("hdzJY");

var $4P5Ms = parcelRequire("4P5Ms");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $459fe9e8691031c0$export$5475d24f125d7053(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $h2AC2.__rest)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $dY0q5.buildHTMLStyles)(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $hdzJY.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) (0, $4P5Ms.buildSVGPath)(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("hdzJY", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $0e4a9aeecbb70ebe$export$d4fbcfc8e5472155; });

var $aak4Q = parcelRequire("aak4Q");
function $0e4a9aeecbb70ebe$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $aak4Q.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $0e4a9aeecbb70ebe$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $0e4a9aeecbb70ebe$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $0e4a9aeecbb70ebe$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}

});

parcelRegister("4P5Ms", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $dc0e6d668b3c5cca$export$311b43f666da1d82; });

var $aak4Q = parcelRequire("aak4Q");
// Convert a progress 0-1 to a pixels value based on the provided length
var $dc0e6d668b3c5cca$var$progressToPixels = function(progress, length) {
    return (0, $aak4Q.px).transform(progress * length);
};
var $dc0e6d668b3c5cca$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $dc0e6d668b3c5cca$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $dc0e6d668b3c5cca$export$311b43f666da1d82(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $dc0e6d668b3c5cca$var$dashKeys : $dc0e6d668b3c5cca$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = $dc0e6d668b3c5cca$var$progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = $dc0e6d668b3c5cca$var$progressToPixels(length, totalLength);
    var pathSpacing = $dc0e6d668b3c5cca$var$progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}

});


parcelRegister("ecxom", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $f004d97c2c77decd$export$41be8b43e1c4d4f9; });

var $h2AC2 = parcelRequire("h2AC2");

var $lcdHn = parcelRequire("lcdHn");
var $f004d97c2c77decd$export$41be8b43e1c4d4f9 = function() {
    return (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, (0, $lcdHn.createHtmlRenderState)()), {
        attrs: {}
    });
};

});



parcelRegister("askod", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $5caa72942ef3967f$export$44dabd3fae512e85; });

var $k4uZK = parcelRequire("k4uZK");

var $dBZ8W = parcelRequire("dBZ8W");

var $4NQY0 = parcelRequire("4NQY0");

var $ecxom = parcelRequire("ecxom");

var $bi2eK = parcelRequire("bi2eK");
var $5caa72942ef3967f$export$44dabd3fae512e85 = {
    useVisualState: (0, $4NQY0.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $dBZ8W.scrapeMotionValuesFromProps),
        createRenderState: (0, $ecxom.createSvgRenderState),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            if ($5caa72942ef3967f$var$isPath(instance)) renderState.totalPathLength = instance.getTotalLength();
            (0, $bi2eK.buildSVGAttrs)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            // TODO: Replace with direct assignment
            (0, $k4uZK.renderSVG)(instance, renderState);
        }
    })
};
function $5caa72942ef3967f$var$isPath(element) {
    return element.tagName === "path";
}

});
parcelRegister("k4uZK", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $0f6c439168edebf9$export$c5f8399d19a7394b; });

var $hbTRe = parcelRequire("hbTRe");

var $5GMb3 = parcelRequire("5GMb3");

var $cObMc = parcelRequire("cObMc");
function $0f6c439168edebf9$export$c5f8399d19a7394b(element, renderState) {
    (0, $5GMb3.renderHTML)(element, renderState);
    for(var key in renderState.attrs)element.setAttribute(!(0, $cObMc.camelCaseAttributes).has(key) ? (0, $hbTRe.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("hbTRe", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $faf4dd91ecb27c7b$export$9fd24a634729c672; });
var $faf4dd91ecb27c7b$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $faf4dd91ecb27c7b$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $faf4dd91ecb27c7b$export$9fd24a634729c672 = function(str) {
    return str.replace($faf4dd91ecb27c7b$var$CAMEL_CASE_PATTERN, $faf4dd91ecb27c7b$var$REPLACE_TEMPLATE).toLowerCase();
};

});

parcelRegister("5GMb3", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $3d174f83013e0ef9$export$1a32bf6229c258c0; });
function $3d174f83013e0ef9$export$1a32bf6229c258c0(element, _a, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles());
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("cObMc", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $7746840152d3622f$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $7746840152d3622f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform"
]);

});


parcelRegister("dBZ8W", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $6ef03e56ecbd7f14$export$16da615486abaa45; });

var $39Z1B = parcelRequire("39Z1B");

var $7LBSL = parcelRequire("7LBSL");
function $6ef03e56ecbd7f14$export$16da615486abaa45(props) {
    var newValues = (0, $7LBSL.scrapeMotionValuesFromProps)(props);
    for(var key in props)if ((0, $39Z1B.isMotionValue)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("7LBSL", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $791b3f176769f5a7$export$16da615486abaa45; });

var $2qx4M = parcelRequire("2qx4M");

var $39Z1B = parcelRequire("39Z1B");
function $791b3f176769f5a7$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $39Z1B.isMotionValue)(style[key]) || (0, $2qx4M.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

});


parcelRegister("4NQY0", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $9e69868019547e2e$export$e91e107bc6d03a8e; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $hyM3r = parcelRequire("hyM3r");

var $2etTF = parcelRequire("2etTF");

var $22rd0 = parcelRequire("22rd0");

var $0h0lm = parcelRequire("0h0lm");

var $iEn7z = parcelRequire("iEn7z");

var $7aiFr = parcelRequire("7aiFr");
function $9e69868019547e2e$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $9e69868019547e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $9e69868019547e2e$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $70fFQ.useContext)((0, $7aiFr.MotionContext));
        var presenceContext = (0, $70fFQ.useContext)((0, $2etTF.PresenceContext));
        return isStatic ? $9e69868019547e2e$var$makeState(config, props, context, presenceContext) : (0, $0h0lm.useConstant)(function() {
            return $9e69868019547e2e$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $9e69868019547e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $iEn7z.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $22rd0.checkIfControllingVariants)(props);
    var isVariantNode = (0, $22rd0.checkIfVariantNode)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $hyM3r.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $22rd0.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $h2AC2.__rest)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target)values[key] = target[key];
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("hyM3r", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $949b182f3cb7bee1$export$aa71198ceeaf53ce; });
function $949b182f3cb7bee1$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("iEn7z", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $41ab560b2e9e5c8b$export$fcc2206ecb6d74b; });

var $4zwAd = parcelRequire("4zwAd");

var $39Z1B = parcelRequire("39Z1B");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */ function $41ab560b2e9e5c8b$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $39Z1B.isMotionValue)(value) ? value.get() : value;
    return (0, $4zwAd.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("4zwAd", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $de04e19b7553a5fd$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $de04e19b7553a5fd$export$5485128c47bd48bb; });

var $8H8R4 = parcelRequire("8H8R4");
var $de04e19b7553a5fd$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $de04e19b7553a5fd$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $8H8R4.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});




parcelRegister("7zfgA", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $38bf9609b5d399a9$export$e13ea21d87ea57c8; });

var $4NQY0 = parcelRequire("4NQY0");

var $7LBSL = parcelRequire("7LBSL");

var $lcdHn = parcelRequire("lcdHn");
var $38bf9609b5d399a9$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $4NQY0.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $7LBSL.scrapeMotionValuesFromProps),
        createRenderState: (0, $lcdHn.createHtmlRenderState)
    })
};

});


parcelRegister("dNS1d", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $acd2334bd4a7f52c$export$e5b72898e5a201f1; });

var $ikyYM = parcelRequire("ikyYM");

var $5WTMB = parcelRequire("5WTMB");

var $3Cg3I = parcelRequire("3Cg3I");

var $jFESt = parcelRequire("jFESt");
var $acd2334bd4a7f52c$export$e5b72898e5a201f1 = {
    tap: (0, $jFESt.makeRenderlessComponent)((0, $3Cg3I.useTapGesture)),
    focus: (0, $jFESt.makeRenderlessComponent)((0, $ikyYM.useFocusGesture)),
    hover: (0, $jFESt.makeRenderlessComponent)((0, $5WTMB.useHoverGesture))
};

});
parcelRegister("ikyYM", function(module, exports) {

$parcel$export(module.exports, "useFocusGesture", function () { return $1f5d0f69283cf58b$export$cac52d7cca250a66; });

var $3uQDG = parcelRequire("3uQDG");

var $i21Bo = parcelRequire("i21Bo");
/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $1f5d0f69283cf58b$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3uQDG.AnimationType).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3uQDG.AnimationType).Focus, false);
    };
    (0, $i21Bo.useDomEvent)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $i21Bo.useDomEvent)(visualElement, "blur", whileFocus ? onBlur : undefined);
}

});

parcelRegister("5WTMB", function(module, exports) {

$parcel$export(module.exports, "useHoverGesture", function () { return $28d164d5340f612c$export$dea06860711b7ebc; });

var $25Zd9 = parcelRequire("25Zd9");

var $3uQDG = parcelRequire("3uQDG");

var $emeFu = parcelRequire("emeFu");

var $dw5od = parcelRequire("dw5od");
function $28d164d5340f612c$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $25Zd9.isMouseEvent)(event) || (0, $dw5od.isDragActive)()) return;
        callback === null || callback === void 0 || callback(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3uQDG.AnimationType).Hover, isActive);
    };
}
function $28d164d5340f612c$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $emeFu.usePointerEvent)(visualElement, "pointerenter", onHoverStart || whileHover ? $28d164d5340f612c$var$createHoverEvent(visualElement, true, onHoverStart) : undefined);
    (0, $emeFu.usePointerEvent)(visualElement, "pointerleave", onHoverEnd || whileHover ? $28d164d5340f612c$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined);
}

});

parcelRegister("3Cg3I", function(module, exports) {

$parcel$export(module.exports, "useTapGesture", function () { return $7dd5df6d0cf738f0$export$16dee6ef8c34532; });

var $70fFQ = parcelRequire("70fFQ");

var $iruwW = parcelRequire("iruwW");

var $emeFu = parcelRequire("emeFu");

var $lrQ4W = parcelRequire("lrQ4W");

var $3mlnP = parcelRequire("3mlnP");

var $3uQDG = parcelRequire("3uQDG");

var $dw5od = parcelRequire("dw5od");
/**
 * @param handlers -
 * @internal
 */ function $7dd5df6d0cf738f0$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $70fFQ.useRef)(false);
    var cancelPointerEndListeners = (0, $70fFQ.useRef)(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3uQDG.AnimationType).Tap, false);
        return !(0, $dw5od.isDragActive)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $iruwW.isNodeOrChild)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $3mlnP.pipe)((0, $emeFu.addPointerEvent)(window, "pointerup", onPointerUp), (0, $emeFu.addPointerEvent)(window, "pointercancel", onPointerCancel));
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3uQDG.AnimationType).Tap, true);
    }
    (0, $emeFu.usePointerEvent)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    (0, $lrQ4W.useUnmountEffect)(removePointerEndListener);
}

});
parcelRegister("iruwW", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $acea29e6852d75a8$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $acea29e6852d75a8$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $acea29e6852d75a8$export$e841ada32ff745b(parent, child.parentElement);
};

});


parcelRegister("jFESt", function(module, exports) {

$parcel$export(module.exports, "makeRenderlessComponent", function () { return $f6f6aebb9c1e8d8f$export$46d1d6d046f826e4; });
var $f6f6aebb9c1e8d8f$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};

});


parcelRegister("3J11a", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $5885145ab890166c$export$7f9953c70dacfd7f; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $hyM3r = parcelRequire("hyM3r");

var $buSY0 = parcelRequire("buSY0");

var $2etTF = parcelRequire("2etTF");

var $aTF3J = parcelRequire("aTF3J");

var $3uQDG = parcelRequire("3uQDG");

var $jFESt = parcelRequire("jFESt");
var $5885145ab890166c$export$7f9953c70dacfd7f = {
    animation: (0, $jFESt.makeRenderlessComponent)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $aTF3J.createAnimationState)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $hyM3r.isAnimationControls)(animate)) (0, $70fFQ.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $jFESt.makeRenderlessComponent)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $h2AC2.__read)((0, $buSY0.usePresence)(), 2), isPresent = _a[0], onExitComplete = _a[1];
        var presenceContext = (0, $70fFQ.useContext)((0, $2etTF.PresenceContext));
        (0, $70fFQ.useEffect)(function() {
            var _a, _b;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $3uQDG.AnimationType).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(onExitComplete));
        }, [
            isPresent
        ]);
    })
};

});
parcelRegister("buSY0", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $15f88e1b7ccb733b$export$2a8c16d82a0a0e26; });

var $70fFQ = parcelRequire("70fFQ");

var $2etTF = parcelRequire("2etTF");

var $0h0lm = parcelRequire("0h0lm");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $15f88e1b7ccb733b$export$2a8c16d82a0a0e26() {
    var context = (0, $70fFQ.useContext)((0, $2etTF.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = $15f88e1b7ccb733b$var$useUniqueId();
    (0, $70fFQ.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $15f88e1b7ccb733b$export$8249053f690ea39a() {
    return $15f88e1b7ccb733b$export$ee27c052bca048fb((0, $70fFQ.useContext)((0, $2etTF.PresenceContext)));
}
function $15f88e1b7ccb733b$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}
var $15f88e1b7ccb733b$var$counter = 0;
var $15f88e1b7ccb733b$var$incrementId = function() {
    return $15f88e1b7ccb733b$var$counter++;
};
var $15f88e1b7ccb733b$var$useUniqueId = function() {
    return (0, $0h0lm.useConstant)($15f88e1b7ccb733b$var$incrementId);
};

});

parcelRegister("aTF3J", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $644bfd3daa130909$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "createAnimationState", function () { return $644bfd3daa130909$export$bb53502b7a672aa8; });

var $h2AC2 = parcelRequire("h2AC2");

var $hyM3r = parcelRequire("hyM3r");

var $8H8R4 = parcelRequire("8H8R4");

var $bnuuH = parcelRequire("bnuuH");

var $eWQyF = parcelRequire("eWQyF");

var $3uQDG = parcelRequire("3uQDG");

var $22rd0 = parcelRequire("22rd0");
var $644bfd3daa130909$export$16e45afcc206d3a8 = [
    (0, $3uQDG.AnimationType).Animate,
    (0, $3uQDG.AnimationType).Hover,
    (0, $3uQDG.AnimationType).Tap,
    (0, $3uQDG.AnimationType).Drag,
    (0, $3uQDG.AnimationType).Focus,
    (0, $3uQDG.AnimationType).Exit
];
var $644bfd3daa130909$var$reversePriorityOrder = (0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)($644bfd3daa130909$export$16e45afcc206d3a8), false).reverse();
var $644bfd3daa130909$var$numAnimationTypes = $644bfd3daa130909$export$16e45afcc206d3a8.length;
function $644bfd3daa130909$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $eWQyF.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $644bfd3daa130909$export$bb53502b7a672aa8(visualElement) {
    var animate = $644bfd3daa130909$var$animateList(visualElement);
    var state = $644bfd3daa130909$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $22rd0.resolveVariant)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $h2AC2.__rest)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $h2AC2.__assign)((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $644bfd3daa130909$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $22rd0.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $h2AC2.__assign)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $hyM3r.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var shouldAnimateType = $644bfd3daa130909$export$b9d9a225005a5327(typeState.prevProp, prop) || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $8H8R4.isKeyframesTarget)(next) && (0, $8H8R4.isKeyframesTarget)(prev)) {
                        if (!(0, $bnuuH.shallowCompare)(next, prev)) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $h2AC2.__assign)({
                        type: type
                    }, options)
                };
            })), false));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $644bfd3daa130909$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $h2AC2.__assign)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $644bfd3daa130909$export$b9d9a225005a5327(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $22rd0.isVariantLabels)(next)) return !(0, $bnuuH.shallowCompare)(next, prev);
    return false;
}
function $644bfd3daa130909$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $644bfd3daa130909$var$createState() {
    var _a;
    return _a = {}, _a[(0, $3uQDG.AnimationType).Animate] = $644bfd3daa130909$var$createTypeState(true), _a[(0, $3uQDG.AnimationType).Hover] = $644bfd3daa130909$var$createTypeState(), _a[(0, $3uQDG.AnimationType).Tap] = $644bfd3daa130909$var$createTypeState(), _a[(0, $3uQDG.AnimationType).Drag] = $644bfd3daa130909$var$createTypeState(), _a[(0, $3uQDG.AnimationType).Focus] = $644bfd3daa130909$var$createTypeState(), _a[(0, $3uQDG.AnimationType).Exit] = $644bfd3daa130909$var$createTypeState(), _a;
}

});
parcelRegister("bnuuH", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $6ce2a7082e6dfb7c$export$90e866afbd6b9f1a; });
function $6ce2a7082e6dfb7c$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("eWQyF", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $d914c19389a08f29$export$ff62cf473653f109; });

var $h2AC2 = parcelRequire("h2AC2");

var $5npex = parcelRequire("5npex");

var $l9ena = parcelRequire("l9ena");

var $22rd0 = parcelRequire("22rd0");
/**
 * @internal
 */ function $d914c19389a08f29$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart();
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $d914c19389a08f29$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $d914c19389a08f29$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $22rd0.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = $d914c19389a08f29$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $d914c19389a08f29$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $22rd0.resolveVariant)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $d914c19389a08f29$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $d914c19389a08f29$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $h2AC2.__read)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $d914c19389a08f29$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $h2AC2.__rest)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $d914c19389a08f29$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var animation = (0, $5npex.startAnimation)(key, value, valueTarget, (0, $h2AC2.__assign)({
            delay: delay
        }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $l9ena.setTarget)(visualElement, transitionEnd);
    });
}
function $d914c19389a08f29$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($d914c19389a08f29$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($d914c19389a08f29$var$animateVariant(child, variant, (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $d914c19389a08f29$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $d914c19389a08f29$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $d914c19389a08f29$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

});
parcelRegister("l9ena", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $4c177a56f8f6df1c$export$1f61c53461aff4a5; });
$parcel$export(module.exports, "checkTargetForNewValues", function () { return $4c177a56f8f6df1c$export$6afbed164019a54c; });
$parcel$export(module.exports, "getOrigin", function () { return $4c177a56f8f6df1c$export$5a759dc7a1cfb72a; });

var $h2AC2 = parcelRequire("h2AC2");

var $j9CZ5 = parcelRequire("j9CZ5");

var $cRALl = parcelRequire("cRALl");

var $ixZUG = parcelRequire("ixZUG");

var $4zwAd = parcelRequire("4zwAd");

var $7bKIM = parcelRequire("7bKIM");

var $k6qEY = parcelRequire("k6qEY");

var $5BV6E = parcelRequire("5BV6E");

var $22rd0 = parcelRequire("22rd0");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $4c177a56f8f6df1c$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $7bKIM.motionValue)(value));
}
function $4c177a56f8f6df1c$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $22rd0.resolveVariant)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $h2AC2.__rest)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $4zwAd.resolveFinalValueInKeyframes)(target[key]);
        $4c177a56f8f6df1c$var$setMotionValue(visualElement, key, value);
    }
}
function $4c177a56f8f6df1c$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)(variantLabels), false).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $4c177a56f8f6df1c$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $4c177a56f8f6df1c$var$setVariants(child, variantLabels);
        });
    });
}
function $4c177a56f8f6df1c$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $4c177a56f8f6df1c$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $4c177a56f8f6df1c$var$setVariants(visualElement, [
        definition
    ]);
    else $4c177a56f8f6df1c$export$1f61c53461aff4a5(visualElement, definition);
}
function $4c177a56f8f6df1c$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $cRALl.isNumericalString)(value) || (0, $ixZUG.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $5BV6E.findValueType)(value) && (0, $j9CZ5.complex).test(targetValue)) value = (0, $k6qEY.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, $7bKIM.motionValue)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $4c177a56f8f6df1c$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $4c177a56f8f6df1c$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $4c177a56f8f6df1c$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}

});
parcelRegister("cRALl", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $ba24bc7fc6d9f110$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $ba24bc7fc6d9f110$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};

});

parcelRegister("ixZUG", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $b252df69af4c8ed3$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $b252df69af4c8ed3$export$ade84c85e44a6cb1 = function(v) {
    return /^0[^.\s]+$/.test(v);
};

});

parcelRegister("5BV6E", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $3cef7e943b253383$export$950e7e59ea1ffed7; });

var $h2AC2 = parcelRequire("h2AC2");

var $emRO9 = parcelRequire("emRO9");
var $j9CZ5 = parcelRequire("j9CZ5");

var $jzdqW = parcelRequire("jzdqW");

var $5ed4W = parcelRequire("5ed4W");
/**
 * A list of all ValueTypes
 */ var $3cef7e943b253383$var$valueTypes = (0, $h2AC2.__spreadArray)((0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)((0, $jzdqW.dimensionValueTypes)), false), [
    (0, $emRO9.color),
    (0, $j9CZ5.complex)
], false);
/**
 * Tests a value against the list of ValueTypes
 */ var $3cef7e943b253383$export$950e7e59ea1ffed7 = function(v) {
    return $3cef7e943b253383$var$valueTypes.find((0, $5ed4W.testValueType)(v));
};

});
parcelRegister("jzdqW", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $9aa0faf7f534935b$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $9aa0faf7f534935b$export$eefdd52e3ccae428; });

var $aak4Q = parcelRequire("aak4Q");
var $85C7Z = parcelRequire("85C7Z");

var $5ed4W = parcelRequire("5ed4W");

var $kUDOB = parcelRequire("kUDOB");
/**
 * A list of value types commonly used for dimensions
 */ var $9aa0faf7f534935b$export$d176691c1998a1f5 = [
    (0, $85C7Z.number),
    (0, $aak4Q.px),
    (0, $aak4Q.percent),
    (0, $aak4Q.degrees),
    (0, $aak4Q.vw),
    (0, $aak4Q.vh),
    (0, $kUDOB.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $9aa0faf7f534935b$export$eefdd52e3ccae428 = function(v) {
    return $9aa0faf7f534935b$export$d176691c1998a1f5.find((0, $5ed4W.testValueType)(v));
};

});
parcelRegister("5ed4W", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $05433d68cb067c53$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $05433d68cb067c53$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});

parcelRegister("kUDOB", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $6f4b38fa396a9bb8$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $6f4b38fa396a9bb8$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});







parcelRegister("gy4YE", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $937b5227b69bf278$export$d7d5d435647ed5a0; });

var $awAdk = parcelRequire("awAdk");

var $aCTHo = parcelRequire("aCTHo");

var $jFESt = parcelRequire("jFESt");
var $937b5227b69bf278$export$d7d5d435647ed5a0 = {
    pan: (0, $jFESt.makeRenderlessComponent)((0, $aCTHo.usePanGesture)),
    drag: (0, $jFESt.makeRenderlessComponent)((0, $awAdk.useDrag))
};

});
parcelRegister("awAdk", function(module, exports) {

$parcel$export(module.exports, "useDrag", function () { return $42d23c60d06c6f9b$export$7941f8aafa4b6021; });

var $70fFQ = parcelRequire("70fFQ");

var $coOVK = parcelRequire("coOVK");

var $0h0lm = parcelRequire("0h0lm");
/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $42d23c60d06c6f9b$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = (0, $0h0lm.useConstant)(function() {
        return new (0, $coOVK.VisualElementDragControls)(visualElement);
    });
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $70fFQ.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $70fFQ.useEffect)(function() {
        return dragControls.addListeners();
    }, [
        dragControls
    ]);
}

});

parcelRegister("aCTHo", function(module, exports) {

$parcel$export(module.exports, "usePanGesture", function () { return $b1e6e1d3e30000d3$export$eb0f62174cac1aec; });

var $70fFQ = parcelRequire("70fFQ");

var $i715C = parcelRequire("i715C");

var $lrQ4W = parcelRequire("lrQ4W");

var $emeFu = parcelRequire("emeFu");

var $4WIgB = parcelRequire("4WIgB");
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $b1e6e1d3e30000d3$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $70fFQ.useRef)(null);
    var transformPagePoint = (0, $70fFQ.useContext)((0, $i715C.MotionConfigContext)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $70fFQ.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $4WIgB.PanSession)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $emeFu.usePointerEvent)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $lrQ4W.useUnmountEffect)(function() {
        return panSession.current && panSession.current.end();
    });
}

});


parcelRegister("dAoXe", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $7171a018f4e19e87$export$56ba0183203348f5; });

var $7tftA = parcelRequire("7tftA");

var $jhVrc = parcelRequire("jhVrc");

var $asI36 = parcelRequire("asI36");
var $7171a018f4e19e87$export$56ba0183203348f5 = function(Component, options) {
    return (0, $asI36.isSVGComponent)(Component) ? (0, $jhVrc.svgVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : (0, $7tftA.htmlVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("7tftA", function(module, exports) {

$parcel$export(module.exports, "htmlConfig", function () { return $252f8c483a7cfbe7$export$985b1494d4aeee90; });
$parcel$export(module.exports, "htmlVisualElement", function () { return $252f8c483a7cfbe7$export$9509f7c142585e92; });

var $h2AC2 = parcelRequire("h2AC2");

var $1nJMy = parcelRequire("1nJMy");

var $l9ena = parcelRequire("l9ena");

var $dY0q5 = parcelRequire("dY0q5");

var $fTJLc = parcelRequire("fTJLc");

var $bJJqq = parcelRequire("bJJqq");

var $1wxj0 = parcelRequire("1wxj0");

var $7LBSL = parcelRequire("7LBSL");

var $5GMb3 = parcelRequire("5GMb3");

var $eCtvR = parcelRequire("eCtvR");

var $jIuON = parcelRequire("jIuON");
function $252f8c483a7cfbe7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $252f8c483a7cfbe7$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $1wxj0.isTransformProp)(key)) {
            var defaultType = (0, $eCtvR.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $252f8c483a7cfbe7$export$3735103072e4a80(domElement);
            return ((0, $fTJLc.isCSSVariable)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $jIuON.measureViewportBox)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $h2AC2.__rest)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $l9ena.getOrigin)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $l9ena.checkTargetForNewValues)(element, target, origin);
            var parsed = (0, $bJJqq.parseDomVariant)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $h2AC2.__assign)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $7LBSL.scrapeMotionValuesFromProps),
    build: function(element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        (0, $dY0q5.buildHTMLStyles)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $5GMb3.renderHTML)
};
var $252f8c483a7cfbe7$export$9509f7c142585e92 = (0, $1nJMy.visualElement)($252f8c483a7cfbe7$export$985b1494d4aeee90);

});
parcelRegister("1nJMy", function(module, exports) {

$parcel$export(module.exports, "visualElement", function () { return $e0ab88a28c024320$export$5ad594e944c33d76; });

var $h2AC2 = parcelRequire("h2AC2");

var $ghy0K = parcelRequire("ghy0K");

var $7bKIM = parcelRequire("7bKIM");

var $39Z1B = parcelRequire("39Z1B");

var $aTF3J = parcelRequire("aTF3J");

var $3Hc0k = parcelRequire("3Hc0k");

var $2o9fK = parcelRequire("2o9fK");

var $22rd0 = parcelRequire("22rd0");
var $e0ab88a28c024320$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) options = {};
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender
         */ var lifecycles = (0, $3Hc0k.createLifecycles)();
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $h2AC2.__assign)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         * Render the element with the latest styles outside of the React
         * render lifecycle
         */ function render() {
            if (!instance || !isMounted) return;
            triggerBuild();
            renderInstance(instance, renderState, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $ghy0K.default).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $39Z1B.isMotionValue)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $22rd0.checkIfControllingVariants)(props);
        var isVariantNode = (0, $22rd0.checkIfVariantNode)(props);
        var element = (0, $h2AC2.__assign)((0, $h2AC2.__assign)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             *
             */ presenceId: presenceId,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by the projection tree, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) element.projection.mount(newInstance);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                parent === null || parent === void 0 || parent.children.add(element);
            },
            /**
             *
             */ unmount: function() {
                var _a;
                (_a = element.projection) === null || _a === void 0 || _a.unmount();
                (0, $ghy0K.cancelSync).update(update);
                (0, $ghy0K.cancelSync).render(render);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function() {
                return measureViewportBox(instance, props);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $7bKIM.motionValue)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $39Z1B.isMotionValue)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $ghy0K.default).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $2o9fK.updateMotionValuesFromProps)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            getTransformPagePoint: function() {
                return props.transformPagePoint;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $e0ab88a28c024320$var$numVariantProps; i++){
                    var name_1 = $e0ab88a28c024320$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $22rd0.isVariantLabel)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            }
        });
        return element;
    };
};
var $e0ab88a28c024320$var$variantProps = (0, $h2AC2.__spreadArray)([
    "initial"
], (0, $h2AC2.__read)((0, $aTF3J.variantPriorityOrder)), false);
var $e0ab88a28c024320$var$numVariantProps = $e0ab88a28c024320$var$variantProps.length;

});
parcelRegister("3Hc0k", function(module, exports) {

$parcel$export(module.exports, "createLifecycles", function () { return $590c3dc43ab87ca9$export$f6841af6ea5003ab; });

var $h2AC2 = parcelRequire("h2AC2");

var $8nsIL = parcelRequire("8nsIL");
var $590c3dc43ab87ca9$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $590c3dc43ab87ca9$export$f6841af6ea5003ab() {
    var managers = $590c3dc43ab87ca9$var$names.map(function() {
        return new (0, $8nsIL.SubscriptionManager)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            return $590c3dc43ab87ca9$var$names.forEach(function(name) {
                var on = "on" + name;
                var propListener = props[on];
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $590c3dc43ab87ca9$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $590c3dc43ab87ca9$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $h2AC2.__spreadArray)([], (0, $h2AC2.__read)(args), false));
        };
    });
    return lifecycles;
}

});

parcelRegister("2o9fK", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $07d33030b949a155$export$9a552858d5197f6e; });

var $7bKIM = parcelRequire("7bKIM");

var $39Z1B = parcelRequire("39Z1B");
function $07d33030b949a155$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $39Z1B.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $39Z1B.isMotionValue)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $7bKIM.motionValue)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $7bKIM.motionValue)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});


parcelRegister("bJJqq", function(module, exports) {

$parcel$export(module.exports, "parseDomVariant", function () { return $448a34eecf474ad5$export$5849e743e29831d6; });

var $i7y7j = parcelRequire("i7y7j");

var $1sSNw = parcelRequire("1sSNw");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $448a34eecf474ad5$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $i7y7j.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $1sSNw.unitConversion)(visualElement, target, origin, transitionEnd);
};

});
parcelRegister("i7y7j", function(module, exports) {

$parcel$export(module.exports, "cssVariableRegex", function () { return $63aca0707e29d4f2$export$f7c0a352d8ef6313; });
$parcel$export(module.exports, "resolveCSSVariables", function () { return $63aca0707e29d4f2$export$669319b042b57350; });

var $h2AC2 = parcelRequire("h2AC2");

var $8hGPO = parcelRequire("8hGPO");
function $63aca0707e29d4f2$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $63aca0707e29d4f2$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $63aca0707e29d4f2$export$b9f0c1f373aee2b0(current) {
    var match = $63aca0707e29d4f2$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $h2AC2.__read)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $63aca0707e29d4f2$var$maxDepth = 4;
function $63aca0707e29d4f2$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $8hGPO.invariant)(depth <= $63aca0707e29d4f2$var$maxDepth, 'Max CSS variable fallback depth detected in property "' + current + '". This may indicate a circular fallback dependency.');
    var _a = (0, $h2AC2.__read)($63aca0707e29d4f2$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($63aca0707e29d4f2$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $63aca0707e29d4f2$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $63aca0707e29d4f2$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $h2AC2.__rest)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $h2AC2.__assign)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$63aca0707e29d4f2$var$isCSSVariable(current)) return;
        var resolved = $63aca0707e29d4f2$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$63aca0707e29d4f2$var$isCSSVariable(current)) continue;
        var resolved = $63aca0707e29d4f2$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}

});

parcelRegister("1sSNw", function(module, exports) {

$parcel$export(module.exports, "unitConversion", function () { return $cafdd59bf5ad805b$export$9e04b0cab841a28; });

var $h2AC2 = parcelRequire("h2AC2");

var $85C7Z = parcelRequire("85C7Z");
var $aak4Q = parcelRequire("aak4Q");

var $8H8R4 = parcelRequire("8H8R4");

var $8hGPO = parcelRequire("8hGPO");

var $1wxj0 = parcelRequire("1wxj0");

var $jzdqW = parcelRequire("jzdqW");
var $cafdd59bf5ad805b$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $cafdd59bf5ad805b$var$isPositionalKey = function(key) {
    return $cafdd59bf5ad805b$var$positionalKeys.has(key);
};
var $cafdd59bf5ad805b$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($cafdd59bf5ad805b$var$isPositionalKey);
};
var $cafdd59bf5ad805b$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $cafdd59bf5ad805b$var$isNumOrPxType = function(v) {
    return v === (0, $85C7Z.number) || v === (0, $aak4Q.px);
};
var $cafdd59bf5ad805b$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($cafdd59bf5ad805b$export$d0c75e4fa9e69db8 || ($cafdd59bf5ad805b$export$d0c75e4fa9e69db8 = {}));
var $cafdd59bf5ad805b$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $cafdd59bf5ad805b$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $cafdd59bf5ad805b$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $cafdd59bf5ad805b$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $cafdd59bf5ad805b$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $cafdd59bf5ad805b$var$nonTranslationalTransformKeys = (0, $1wxj0.transformProps).filter(function(key) {
    return !$cafdd59bf5ad805b$var$transformKeys.has(key);
});
function $cafdd59bf5ad805b$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $cafdd59bf5ad805b$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $cafdd59bf5ad805b$var$positionalValues = {
    // Dimensions
    width: function(_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function(_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $cafdd59bf5ad805b$var$getTranslateFromMatrix(4, 13),
    y: $cafdd59bf5ad805b$var$getTranslateFromMatrix(5, 14)
};
var $cafdd59bf5ad805b$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        transform: transform
    };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $cafdd59bf5ad805b$var$setAndResetVelocity(value, $cafdd59bf5ad805b$var$positionalValues[key](originBbox, originComputedStyle));
        target[key] = $cafdd59bf5ad805b$var$positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $cafdd59bf5ad805b$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $h2AC2.__assign)({}, target);
    transitionEnd = (0, $h2AC2.__assign)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($cafdd59bf5ad805b$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var to = target[key];
        var fromType = (0, $jzdqW.findDimensionValueType)(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $8H8R4.isKeyframesTarget)(to)) {
            var numKeyframes = to.length;
            for(var i = to[0] === null ? 1 : 0; i < numKeyframes; i++)if (!toType) {
                toType = (0, $jzdqW.findDimensionValueType)(to[i]);
                (0, $8hGPO.invariant)(toType === fromType || $cafdd59bf5ad805b$var$isNumOrPxType(fromType) && $cafdd59bf5ad805b$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $8hGPO.invariant)((0, $jzdqW.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $jzdqW.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($cafdd59bf5ad805b$var$isNumOrPxType(fromType) && $cafdd59bf5ad805b$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $aak4Q.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $cafdd59bf5ad805b$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $cafdd59bf5ad805b$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = $cafdd59bf5ad805b$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $h2AC2.__read)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $cafdd59bf5ad805b$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $cafdd59bf5ad805b$var$hasPositionalKey(target) ? $cafdd59bf5ad805b$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRegister("jhVrc", function(module, exports) {

$parcel$export(module.exports, "svgVisualElement", function () { return $f527124816d4bb56$export$3ba8992de7b705bc; });

var $h2AC2 = parcelRequire("h2AC2");

var $1nJMy = parcelRequire("1nJMy");

var $dBZ8W = parcelRequire("dBZ8W");

var $7tftA = parcelRequire("7tftA");

var $bi2eK = parcelRequire("bi2eK");

var $hbTRe = parcelRequire("hbTRe");

var $cObMc = parcelRequire("cObMc");

var $1wxj0 = parcelRequire("1wxj0");

var $k4uZK = parcelRequire("k4uZK");

var $eCtvR = parcelRequire("eCtvR");
var $f527124816d4bb56$export$3ba8992de7b705bc = (0, $1nJMy.visualElement)((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, (0, $7tftA.htmlConfig)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $1wxj0.isTransformProp)(key)) return ((_a = (0, $eCtvR.getDefaultValueType)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $cObMc.camelCaseAttributes).has(key) ? (0, $hbTRe.camelToDash)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $dBZ8W.scrapeMotionValuesFromProps),
    build: function(_element, renderState, latestValues, options, props) {
        (0, $bi2eK.buildSVGAttrs)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $k4uZK.renderSVG)
}));

});


parcelRegister("cBKqW", function(module, exports) {

$parcel$export(module.exports, "layoutFeatures", function () { return $c314768fae638cd5$export$518df03f164c507; });

var $2jSTD = parcelRequire("2jSTD");
var $c314768fae638cd5$export$518df03f164c507 = {
    measureLayout: (0, $2jSTD.MeasureLayout)
};

});
parcelRegister("2jSTD", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", function () { return $23b6006705462657$export$779f5fb01ad751cd; });

var $h2AC2 = parcelRequire("h2AC2");

var $70fFQ = parcelRequire("70fFQ");

var $buSY0 = parcelRequire("buSY0");

var $cvSBx = parcelRequire("cvSBx");

var $axLzK = parcelRequire("axLzK");

var $e98Ft = parcelRequire("e98Ft");

var $dRNGd = parcelRequire("dRNGd");

var $d042t = parcelRequire("d042t");

var $01NoW = parcelRequire("01NoW");
var $23b6006705462657$var$MeasureLayoutWithContext = /** @class */ function(_super) {
    (0, $h2AC2.__extends)(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ MeasureLayoutWithContext.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        (0, $01NoW.addScaleCorrector)($23b6006705462657$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function() {
                _this.safeToRemove();
            });
            projection.setOptions((0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, projection.options), {
                onExitComplete: function() {
                    return _this.safeToRemove();
                }
            }));
        }
        (0, $e98Ft.globalProjectionState).hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else projection.relegate();
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function() {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function() {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function() {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 || _b.call(_a);
    };
    MeasureLayoutWithContext.prototype.render = function() {
        return null;
    };
    return MeasureLayoutWithContext;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
function $23b6006705462657$export$779f5fb01ad751cd(props) {
    var _a = (0, $h2AC2.__read)((0, $buSY0.usePresence)(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = (0, $70fFQ.useContext)((0, $cvSBx.LayoutGroupContext));
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement($23b6006705462657$var$MeasureLayoutWithContext, (0, $h2AC2.__assign)({}, props, {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $70fFQ.useContext)((0, $axLzK.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
var $23b6006705462657$var$defaultScaleCorrectors = {
    borderRadius: (0, $h2AC2.__assign)((0, $h2AC2.__assign)({}, (0, $dRNGd.correctBorderRadius)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $dRNGd.correctBorderRadius),
    borderTopRightRadius: (0, $dRNGd.correctBorderRadius),
    borderBottomLeftRadius: (0, $dRNGd.correctBorderRadius),
    borderBottomRightRadius: (0, $dRNGd.correctBorderRadius),
    boxShadow: (0, $d042t.correctBoxShadow)
};

});
parcelRegister("dRNGd", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $1699bfa45c87af85$export$5eafb6257a5844c; });

var $aak4Q = parcelRequire("aak4Q");
function $1699bfa45c87af85$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $1699bfa45c87af85$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $aak4Q.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $1699bfa45c87af85$export$fafff692be55225d(latest, node.target.x);
        var y = $1699bfa45c87af85$export$fafff692be55225d(latest, node.target.y);
        return x + "% " + y + "%";
    }
};

});

parcelRegister("d042t", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $de8b79ba2f1feafe$export$eb0bc629e74dcf8; });

var $4ZJs1 = parcelRequire("4ZJs1");

var $j9CZ5 = parcelRequire("j9CZ5");

var $i7y7j = parcelRequire("i7y7j");
var $de8b79ba2f1feafe$var$varToken = "_$css";
var $de8b79ba2f1feafe$export$eb0bc629e74dcf8 = {
    correct: function(latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $i7y7j.cssVariableRegex), function(match) {
            cssVariables.push(match);
            return $de8b79ba2f1feafe$var$varToken;
        });
        var shadow = (0, $j9CZ5.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $j9CZ5.complex).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $4ZJs1.mix)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace($de8b79ba2f1feafe$var$varToken, function() {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    }
};

});




parcelRegister("0qEbJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0014abc7b8249864$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $0014abc7b8249864$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");

});

parcelRegister("gfxK7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd4838b19f2887d1$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $7xvOw = parcelRequire("7xvOw");
var $1mImZ = parcelRequire("1mImZ");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $dsvUQ = parcelRequire("dsvUQ");

var $iWaGk = parcelRequire("iWaGk");

var $6dtKY = parcelRequire("6dtKY");

var $aCjsb = parcelRequire("aCjsb");



var $3cTYK = parcelRequire("3cTYK");

var $bPwEc = parcelRequire("bPwEc");

var $1qCAt = parcelRequire("1qCAt");
const $bd4838b19f2887d1$var$Building = ({ isDemo: isDemo = false, noHeaderMap: noHeaderMap, noHeader: noHeader, history: history, match: match, style: style = {} })=>{
    const detailsContainerRef = (0, $70fFQ.useRef)();
    const { buildingId: buildingId } = match.params;
    const { buildingDetailStore: buildingDetailStore, projectDetailStore: projectDetailStore, mapStore: mapStore, editorStore: editorStore } = (0, $iWaGk.default)();
    const { isLoading: isLoading, building: building } = buildingDetailStore;
    (0, $70fFQ.useEffect)(()=>{
        (async ()=>{
            await buildingDetailStore.loadBuilding(buildingId);
        })();
    }, [
        buildingId
    ]);
    const { polygon: polygon, address: address, centroid: centroid } = building || {};
    if (!isLoading && !building) return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cTYK.default), {
        onClick: ()=>history.push("/search"),
        title: "Property not found"
    });
    let description = "";
    if (building === null || building === void 0 ? void 0 : building.building_name) description += ` ${building.building_name}`;
    if (building === null || building === void 0 ? void 0 : building.property_type_short) {
        if (description.length > 0) description += ` - ${building.property_type_short}`;
        else description += `${building.property_type_short}`;
    }
    const buildingHeader = building && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6dtKY.default), {
        noHeaderMap: noHeaderMap,
        mapStore: mapStore,
        editorStore: editorStore,
        showPanoramaToggle: true,
        headerInfo: {
            name: address,
            description: description
        },
        buildingId: buildingId,
        buildings: [
            {
                polygon: polygon,
                address: address,
                centroid: [
                    centroid.lon,
                    centroid.lat
                ],
                id: buildingId
            }
        ],
        variant: projectDetailStore.variant,
        history: history,
        onClick: ()=>{
            projectDetailStore.setVariant(projectDetailStore.variant === "small" ? "large" : "small");
            const element = document.querySelector("#details.building-details");
            const pointerEvents = projectDetailStore.variant === "small" ? "none" : "all";
            if (element === null || element === void 0 ? void 0 : element.style) element.style.pointerEvents = pointerEvents;
        }
    });
    const views = projectDetailStore.variant === "small" ? [
        "map",
        "satellite"
    ] : [
        "map",
        "panorama",
        "satellite"
    ];
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $1mImZ.default), {
        style: style,
        ref: detailsContainerRef,
        id: "details",
        className: `building building-details project-details-${projectDetailStore.variant}`,
        elevation: 0,
        square: true,
        children: [
            !noHeader && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        className: "button-close",
                        component: (0, $dsvUQ.Link),
                        to: "/search/",
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                        className: "header-map-toggle-wrapper",
                        style: {
                            zIndex: 101
                        },
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bPwEc.default), {
                            mapboxMapRef: mapStore.mapboxRef,
                            views: views,
                            gl: mapStore.gl,
                            deckRef: mapStore.deckRef,
                            viewState: editorStore.viewState,
                            onChange: (variant)=>{
                                projectDetailStore.setHeaderVariant(variant);
                            }
                        })
                    }),
                    projectDetailStore.headerVariant === "panorama" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1qCAt.default), {
                        viewState: editorStore.viewState,
                        onMouseOver: ()=>{
                            const element = document.querySelector("#details.project-details");
                            if (element === null || element === void 0 ? void 0 : element.style) element.style.pointerEvents = "none";
                        },
                        role: "region"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                style: {
                    pointerEvents: projectDetailStore.variant === "small" ? "none" : "all"
                },
                className: "details-container",
                children: [
                    buildingHeader,
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $aCjsb.default), {
                        isDemo: isDemo,
                        detailsContainerRef: detailsContainerRef,
                        building: building,
                        buildingId: buildingId
                    })
                ]
            })
        ]
    });
};
var $bd4838b19f2887d1$export$2e2bcd8739ae039 = (0, $87gt0.observer)($bd4838b19f2887d1$var$Building);

});
parcelRegister("6dtKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $486b0a0bb36496bc$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $bDcYY = parcelRequire("bDcYY");
var $1mImZ = parcelRequire("1mImZ");
var $27ZKj = parcelRequire("27ZKj");

var $8me0n = parcelRequire("8me0n");

var $eIwlZ = parcelRequire("eIwlZ");

const $486b0a0bb36496bc$var$ProjectHeader = ({ noHeaderMap: noHeaderMap, projectDetailStore: projectDetailStore, variant: variant, onChangeProjectName: onChangeProjectName, onChangeBuildingName: onChangeBuildingName, onClick: onClick, project: project, buildings: buildings, vendor: vendor, building: building, headerInfo: headerInfo })=>{
    const mapContainer = (0, $70fFQ.useRef)(null);
    const buildingNameInput = (0, $70fFQ.useRef)(null);
    const getOverridenHeaderInfo = ()=>{
        if (headerInfo) return headerInfo;
        const projectHeaderInfo = projectDetailStore === null || projectDetailStore === void 0 ? void 0 : projectDetailStore.headerInfo;
        if (projectHeaderInfo && variant === "small") {
            var _projectHeaderInfo_properties, _feature_properties, _feature_properties1;
            const id = (_projectHeaderInfo_properties = projectHeaderInfo.properties) === null || _projectHeaderInfo_properties === void 0 ? void 0 : _projectHeaderInfo_properties.id;
            const osmId = id ? `${id}`.replace("pb_", "").replace("osm-", "").toUpperCase() : null;
            const foundBuilding = buildings.find((b)=>{
                var _projectHeaderInfo_id;
                return b.id === ((_projectHeaderInfo_id = projectHeaderInfo.id) === null || _projectHeaderInfo_id === void 0 ? void 0 : _projectHeaderInfo_id.replace("pb_", "")) || b.original_id === osmId;
            });
            if (foundBuilding) return (0, $edHbI._)((0, $2QP2i._)({}, projectHeaderInfo), {
                name: foundBuilding.address || "Unnamed feature",
                recommendations: (foundBuilding === null || foundBuilding === void 0 ? void 0 : foundBuilding.recommendations) || null
            });
            const feature = projectHeaderInfo;
            return (0, $edHbI._)((0, $2QP2i._)({}, feature), {
                name: ((_feature_properties = feature.properties) === null || _feature_properties === void 0 ? void 0 : _feature_properties.name) || ((_feature_properties1 = feature.properties) === null || _feature_properties1 === void 0 ? void 0 : _feature_properties1.Name) || "Unnamed feature"
            });
        }
    };
    const overridenHeaderInfo = getOverridenHeaderInfo();
    const BuildingNameInput = building && /*#__PURE__*/ (0, $4x3bm.jsx)("input", {
        onClick: (e)=>e.stopPropagation(),
        ref: buildingNameInput,
        type: "text",
        defaultValue: building.building_name || building.address,
        onBlur: onChangeBuildingName
    }, building.id);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("header", {
        className: "detail-header",
        children: [
            !noHeaderMap && /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                role: "region",
                ref: mapContainer,
                onClick: onClick,
                className: "detail-header-map"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $1mImZ.default), {
                className: "project-header-info",
                elevation: 0,
                square: true,
                children: [
                    variant === "small" && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $eIwlZ.default), {}),
                            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                role: "region",
                                onClick: onClick,
                                className: "project-header-info-click-overlay"
                            })
                        ]
                    }),
                    overridenHeaderInfo && /*#__PURE__*/ (0, $4x3bm.jsx)($486b0a0bb36496bc$var$OverridenHeaderInfo, {
                        onClick: onClick,
                        info: overridenHeaderInfo
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)($486b0a0bb36496bc$var$ProjectDetails, {
                        project: project,
                        building: building,
                        buildings: buildings,
                        vendor: vendor,
                        onChangeProjectName: onChangeProjectName,
                        BuildingNameInput: BuildingNameInput,
                        headerInfo: headerInfo
                    })
                ]
            })
        ]
    });
};
const $486b0a0bb36496bc$var$OverridenHeaderInfo = ({ onClick: onClick, info: info })=>{
    var _info_properties;
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        role: "region",
        onClick: onClick,
        className: "project-header-hover-overlay",
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
            p: 2,
            children: [
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    variant: "h6",
                    children: info.name
                }),
                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                    display: "flex",
                    children: [
                        info.recommendations && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8me0n.default), (0, $2QP2i._)({}, info.recommendations)),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                            style: {
                                opacity: 0.8
                            },
                            variant: "body2",
                            children: info.description || ((_info_properties = info.properties) === null || _info_properties === void 0 ? void 0 : _info_properties.description)
                        })
                    ]
                })
            ]
        })
    });
};
const $486b0a0bb36496bc$var$ProjectDetails = (0, $87gt0.observer)(({ project: project, building: building, buildings: buildings, vendor: vendor, onChangeProjectName: onChangeProjectName, BuildingNameInput: BuildingNameInput, headerInfo: headerInfo })=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
        p: 3,
        pt: 2,
        pb: 2,
        style: {
            zIndex: 5
        },
        children: [
            project && (!building || buildings.length === 1) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                gutterBottom: true,
                variant: "h6",
                children: /*#__PURE__*/ (0, $4x3bm.jsx)("input", {
                    onClick: (e)=>e.stopPropagation(),
                    disabled: vendor,
                    onChange: onChangeProjectName,
                    type: "text",
                    value: vendor ? `${project.name} - ${vendor.name}` : project.name,
                    onBlur: onChangeProjectName
                })
            }),
            project && building && buildings.length !== 1 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                gutterBottom: true,
                variant: "h6",
                children: BuildingNameInput
            }),
            !project && building && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                gutterBottom: true,
                variant: "h6",
                children: building.address
            }),
            !headerInfo && /*#__PURE__*/ (0, $4x3bm.jsx)($486b0a0bb36496bc$var$ProjectDescription, {
                project: project,
                building: building,
                buildings: buildings,
                BuildingNameInput: BuildingNameInput
            })
        ]
    }));
const $486b0a0bb36496bc$var$ProjectDescription = (0, $87gt0.observer)(({ project: project, building: building, buildings: buildings, BuildingNameInput: BuildingNameInput })=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
        display: "flex",
        children: [
            project && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8me0n.default), (0, $2QP2i._)({}, project.recommendations)),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                style: {
                    opacity: 0.8
                },
                variant: "body2",
                children: [
                    project && !building && buildings.length !== 1 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                        children: [
                            buildings.length,
                            " buildings"
                        ]
                    }),
                    project && building && buildings.length !== 1 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                        children: project.name
                    }),
                    project && building && buildings.length === 1 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                        children: BuildingNameInput
                    })
                ]
            })
        ]
    }));
var $486b0a0bb36496bc$export$2e2bcd8739ae039 = (0, $87gt0.observer)($486b0a0bb36496bc$var$ProjectHeader);

});
parcelRegister("8me0n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $615b3dea6e2cba54$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $bDcYY = parcelRequire("bDcYY");

var $irwVr = parcelRequire("irwVr");
function $615b3dea6e2cba54$var$RecommendationIconGroup({ storage: storage = 0, chp: chp = 0, fuel_cell: fuel_cell = 0, solar: solar = 0, pv: pv = 0 }) {
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
        className: "recommendations",
        display: "flex",
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $irwVr.default), {
                type: "storage",
                value: storage
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $irwVr.default), {
                type: "fuel_cell",
                value: fuel_cell
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $irwVr.default), {
                type: "chp",
                value: chp
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $irwVr.default), {
                type: "solar",
                value: solar || pv
            })
        ]
    });
}
var $615b3dea6e2cba54$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).memo($615b3dea6e2cba54$var$RecommendationIconGroup);

});
parcelRegister("irwVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6d449e6c9a5d281$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");
function $d6d449e6c9a5d281$export$2e2bcd8739ae039({ type: type, value: value }) {
    const colors = {
        storage: "#05D748",
        chp: "#ff6c00",
        fuel_cell: "#01A3FF",
        solar: "#ffbc00"
    };
    const color = colors[type];
    const strokeDasharray = [
        "15.07964496 999",
        "15.07964496 1.6587609456 15.07964496 999",
        "15.07964496 1.6587609456"
    ];
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("svg", {
        viewBox: "0 0 18 18",
        width: "18px",
        height: "18px",
        fill: color,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsxs)("g", {
                transform: "rotate(-120 7.098 1.902)",
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                        r: "8",
                        fill: "none",
                        stroke: color,
                        strokeWidth: "1.5",
                        opacity: "0.2",
                        strokeDashoffset: "-5.03",
                        strokeDasharray: "15.07964496 1.6587609456"
                    }),
                    value && /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                        r: "8",
                        stroke: color,
                        fill: "none",
                        strokeWidth: "1.5",
                        strokeDashoffset: "-5.03",
                        strokeDasharray: strokeDasharray[value - 1]
                    })
                ]
            }),
            type === "storage" && /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
                transform: "translate(-1.5 -.5)",
                d: "M12.76 6.282c-.092-.09-.234-.136-.425-.136h-.881v-.417c0-.199-.044-.346-.132-.441-.092-.092-.234-.137-.426-.137h-.803c-.192 0-.334.045-.426.137-.087.095-.131.242-.131.441v.417h-.881c-.192 0-.334.045-.426.136-.088.096-.132.243-.132.442v5.807c0 .199.044.346.132.441.092.091.234.137.426.137h3.68c.191 0 .333-.045.425-.137.088-.095.132-.242.132-.441V6.724c0-.2-.044-.346-.132-.442"
            }),
            type === "fuel_cell" && /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
                transform: "translate(-1.5 -.5)",
                d: "M10.6 4.5s2.11 2.045 2.858 2.775a4.208 4.208 0 011.264 3.023c0 2.326-1.847 4.202-4.111 4.202-2.275 0-4.111-1.888-4.111-4.202 0-1.169.462-2.202 1.198-2.967C8.435 6.567 10.6 4.5 10.6 4.5zm-.856 3.706h-.942v4.284h.942v-1.848h1.734v1.848h.942V8.206h-.942V9.85H9.744V8.206z"
            }),
            type === "chp" && /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
                transform: "translate(-1.5 -.5)",
                d: "M11.827 4c-1.403 2.354.836 3.66.836 5.892 0-.744.77-1.028.41-2.465.923 1.001 1.782 4.926-1.643 6.573-.626.177-1.473.177-2.054 0-2.853-.822-4.336-4.314-.83-7.806-.558 1.02.205 2.512.42 2.876 0-3.287 2.861-5.07 2.861-5.07zm-.107 3.41l-3.086 3.252.968-.008-1.012 2.757 3.152-3.26h-1.036l1.014-2.74z"
            }),
            type === "solar" && /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
                transform: "translate(.15)",
                d: "M8.844 12.264c.312.002.312.031.312.413v.914c-.002.296-.025.323-.305.325h-.176c-.284-.002-.31-.026-.312-.317v-.922c0-.382 0-.41.312-.413h.17zm-2.327-.97c.254.268.277.292.069.513l-.07.072-.56.585c-.282.291-.282.291-.562 0-.254-.265-.277-.289-.07-.511l.07-.074.561-.584c.28-.292.28-.292.562 0zm4.977-.071l.07.072.56.584c.28.294.28.294 0 .585-.253.265-.276.29-.49.072l-.07-.072-.562-.585c-.28-.29-.28-.29 0-.584.256-.265.28-.29.492-.072zM8.76 6.479c1.314 0 2.38 1.11 2.38 2.48 0 1.368-1.066 2.478-2.38 2.478-1.315 0-2.38-1.11-2.38-2.479S7.445 6.48 8.76 6.48zm4.447 2.066c.312.002.312.032.312.413 0 .382 0 .411-.312.413h-.963c-.283-.002-.309-.026-.311-.317V8.87c.002-.295.025-.322.304-.325h.97zm-8.81 0h.878c.283.002.309.027.311.318v.183c-.002.296-.025.323-.304.325h-.97c-.284-.002-.31-.026-.312-.317V8.87c.002-.295.026-.322.305-.325h.97zm7.728-3.093c.254.265.277.29.07.512l-.07.073-.561.585c-.28.291-.28.291-.562 0-.254-.267-.277-.291-.069-.512l.07-.073.56-.585c.282-.291.282-.291.562 0zm-6.24-.072l.07.072.562.585c.28.291.28.291 0 .585-.256.265-.28.289-.492.072l-.07-.072-.56-.585c-.28-.293-.28-.293 0-.585.253-.264.276-.289.49-.072zM8.845 4c.311.002.311.032.311.413v.915c-.002.295-.025.322-.305.325h-.176c-.284-.002-.31-.027-.312-.318v-.922c0-.381 0-.41.312-.413h.17z"
            })
        ]
    });
}

});


parcelRegister("eIwlZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab6e45870b852ac2$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");
const $ab6e45870b852ac2$var$DragHandle = ()=>{
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        style: {
            width: 26,
            position: "absolute",
            left: "50%",
            zIndex: 100,
            top: 8,
            height: 5,
            background: "#ddd",
            borderRadius: "50px"
        }
    });
};
var $ab6e45870b852ac2$export$2e2bcd8739ae039 = $ab6e45870b852ac2$var$DragHandle;

});


parcelRegister("aCjsb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bac8b0e70e37996$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $dih0O = parcelRequire("dih0O");

var $8VJ2N = parcelRequire("8VJ2N");

var $5RWGb = parcelRequire("5RWGb");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $8K8cO = parcelRequire("8K8cO");

var $iWaGk = parcelRequire("iWaGk");

var $ezukV = parcelRequire("ezukV");

var $bNddL = parcelRequire("bNddL");

var $k8aZE = parcelRequire("k8aZE");

var $cLwEj = parcelRequire("cLwEj");
parcelRequire("kaUpJ");
var $etOpj = parcelRequire("etOpj");

var $7VCZk = parcelRequire("7VCZk");

var $fJ9i4 = parcelRequire("fJ9i4");

var $5H7Tw = parcelRequire("5H7Tw");

var $jQZSN = parcelRequire("jQZSN");

var $93Bu5 = parcelRequire("93Bu5");

var $8AxZQ = parcelRequire("8AxZQ");

var $jxLxf = parcelRequire("jxLxf");

var $e5JnQ = parcelRequire("e5JnQ");
function $7bac8b0e70e37996$var$BuildingDetails({ isDemo: isDemo, isVendor: isVendor, building: building, projectId: projectId, buildingId: buildingId, isAdmin: isAdmin, detailsContainerRef: detailsContainerRef }) {
    var _buildingDetailStore_financials;
    const { descriptions: descriptions } = (0, $8K8cO.default);
    const { buildingDetailStore: buildingDetailStore } = (0, $iWaGk.default)();
    const history = (0, $dih0O.useHistory)();
    const [isLazyLoading, setIsLazyLoading] = (0, $70fFQ.useState)(false);
    const [quickMenuAnchor, setQuickMenuAnchor] = (0, $70fFQ.useState)(null);
    const { location: { hash: hash } } = history;
    const activeHash = !isLazyLoading && hash && hash.replace("#", "");
    const { details: details, sections: sections, quickMenuLinks: quickMenuLinks, places: places, power_line: power_line, temperature: temperature, estimates: estimates, weather_timestamp: weather_timestamp, wind_speed: wind_speed, building: buildingData } = buildingDetailStore;
    const visibleSections = [
        ...sections
    ].filter((section)=>{
        if (isVendor && section.id === "load_curve") return false;
        return true;
    });
    const handleLazyLoad = (key)=>{
        const promises = [];
        const { lon: lon, lat: lat } = building.centroid;
        if ((!key || key === "places") && !places) promises.push(buildingDetailStore.getPlaces(buildingId, lon, lat));
        if ((!key || [
            "closest_power_plant",
            "power_line"
        ].includes(key)) && !power_line) promises.push(buildingDetailStore.getPowerOptions(buildingId, lon, lat));
        if ((!key || [
            "temperature",
            "wind_speed"
        ].includes(key)) && !temperature) promises.push(Promise.resolve());
        return Promise.all(promises);
    };
    (0, $70fFQ.useEffect)(()=>{
        if (hash && building && visibleSections.length) // setQuickMenuAnchor(null);
        (async ()=>{
            setIsLazyLoading(true);
            await handleLazyLoad();
            setIsLazyLoading(false);
        })();
    }, [
        building,
        hash,
        visibleSections
    ]);
    const onVisibilityChange = async (isVisible, id)=>{
        if (isVisible) await handleLazyLoad(id);
    };
    if (!building || !visibleSections.length) return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {
        style: {
            marginTop: "50vh",
            transform: "translateY(-50%)"
        }
    });
    const { address: address, centroid: centroid, chp: chp, contacts: contacts, electric_utility_short: electric_utility_short, electricity_forecast: electricity_forecast, fuel_cell: fuel_cell, hourly_predictions: hourly_predictions, icons: icons, monthly_predictions: monthly_predictions, predictionsTrace: predictionsTrace, pv: pv, pvwattsTrace: pvwattsTrace, reductions: reductions, solar_thermal: solar_thermal, storage: storage, tariff: tariff, therm_production: therm_production, formatted_details: formatted_details } = building;
    if (predictionsTrace && predictionsTrace.length) (0, $8K8cO.default).predictions = "Predicted Load Profile";
    const { lon: lon, lat: lat } = building.centroid;
    const showUploadedData = isAdmin && buildingDetailStore.showUploadedData;
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                className: "building--details",
                children: [
                    showUploadedData && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "DATA",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ezukV.default), {
                                data: formatted_details
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                        className: "data-section data-section-recommendations",
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                            className: "data-section-content",
                            children: isVendor ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                children: (icons.energystar || icons.eui) && icons.energystar !== "n/a" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8AxZQ.default), {
                                    nowrap: true,
                                    icons: icons
                                })
                            }) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7VCZk.default), {
                                chp: chp,
                                descriptions: descriptions,
                                estimates: estimates,
                                fuel_cell: fuel_cell,
                                icons: icons,
                                pv: pv,
                                reductions: reductions,
                                solar_thermal: solar_thermal,
                                storage: storage,
                                therm_production: therm_production
                            })
                        })
                    }),
                    isDemo && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            id: "load_curve",
                            loading: false,
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Load Curve",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fJ9i4.default), {
                                chartType: "load_curve",
                                showMenu: isAdmin,
                                electric_utility_short: electric_utility_short,
                                electricity_forecast: electricity_forecast,
                                hourly_predictions: hourly_predictions,
                                monthly_predictions: monthly_predictions,
                                predictionsTrace: predictionsTrace,
                                pvwattsTrace: pvwattsTrace,
                                temperature: temperature,
                                wind_speed: wind_speed,
                                weather_timestamp: weather_timestamp,
                                latitude: lat,
                                longitude: lon,
                                buildingId: buildingId,
                                projectId: projectId
                            })
                        })
                    }),
                    projectId && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                        id: "financials",
                        loading: false,
                        setQuickMenuAnchor: setQuickMenuAnchor,
                        title: "Financials",
                        secondaryAction: ((_buildingDetailStore_financials = buildingDetailStore.financials) === null || _buildingDetailStore_financials === void 0 ? void 0 : _buildingDetailStore_financials.formatted_financials_ppa) ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e5JnQ.default), {
                            options: [
                                {
                                    id: "capex",
                                    label: "Capex"
                                },
                                {
                                    id: "ppa",
                                    label: "PPA"
                                }
                            ],
                            onChange: (event, value)=>{
                                buildingDetailStore.setFinancialMode(value.id);
                            }
                        }) : null,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jxLxf.default), {
                            disablePadding: true,
                            projectId: projectId,
                            buildingId: buildingId,
                            isVendor: isVendor,
                            isAdmin: isAdmin
                        })
                    }),
                    visibleSections.filter((section)=>{
                        if (isDemo || projectId) return section.id !== "load_curve";
                        return true;
                    }).map((section)=>{
                        const { id: id, title: title } = section;
                        return /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RWGb))), {
                            delayedCall: true,
                            containment: detailsContainerRef.current,
                            partialVisibility: true,
                            offset: {
                                top: 200
                            },
                            active: [
                                "closest_power_plant",
                                "places",
                                "power_line",
                                "temperature",
                                "wind_speed"
                            ].includes(id),
                            onChange: (isVisible)=>onVisibilityChange(isVisible, id),
                            children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bNddL.default), {
                                id: id,
                                isActive: id === activeHash,
                                loading: [
                                    "closest_power_plant",
                                    "places",
                                    "power_line"
                                ].includes(id) && !buildingDetailStore[id],
                                setQuickMenuAnchor: setQuickMenuAnchor,
                                title: title,
                                children: [
                                    [
                                        "predictions",
                                        "load_curve",
                                        "wind_speed",
                                        "temperature",
                                        "electricity_forecast"
                                    ].includes(id) ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fJ9i4.default), {
                                        chartType: id,
                                        showMenu: isAdmin,
                                        electric_utility_short: electric_utility_short,
                                        electricity_forecast: electricity_forecast,
                                        hourly_predictions: hourly_predictions,
                                        monthly_predictions: monthly_predictions,
                                        predictionsTrace: predictionsTrace,
                                        pvwattsTrace: pvwattsTrace,
                                        temperature: temperature,
                                        wind_speed: wind_speed,
                                        weather_timestamp: weather_timestamp,
                                        latitude: lat,
                                        longitude: lon,
                                        buildingId: buildingId,
                                        projectId: projectId
                                    }) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                        children: id !== "energy_use" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ezukV.default), {
                                            data: details[id]
                                        })
                                    }),
                                    id === "power_line" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $93Bu5.default), {
                                        address: address,
                                        building: building,
                                        buildingId: buildingId,
                                        centroid: centroid,
                                        power_line: power_line
                                    }),
                                    id === "energy_use" && (buildingData === null || buildingData === void 0 ? void 0 : buildingData.metrics) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cLwEj.default), {
                                        data: details.energy_use,
                                        cbecsData: buildingData.cbecs,
                                        metrics: buildingData.metrics
                                    })
                                ]
                            })
                        }, id);
                    }),
                    tariff && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                        id: "tariff",
                        isActive: activeHash === "tariff",
                        setQuickMenuAnchor: setQuickMenuAnchor,
                        title: `Tariff: ${tariff.name}`,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)("table", {
                            width: "100%",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)("tbody", {
                                children: tariff.data.map((col)=>/*#__PURE__*/ (0, $4x3bm.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)("td", {
                                                children: col[0]
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)("td", {
                                                children: col[1]
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)("td", {
                                                children: col[2]
                                            })
                                        ]
                                    }))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RWGb))), {
                        delayedCall: true,
                        containment: detailsContainerRef.current,
                        partialVisibility: true,
                        offset: {
                            top: 200
                        },
                        onChange: (isVisible)=>onVisibilityChange(isVisible, "places"),
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            id: "places",
                            isActive: activeHash === "places",
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Places",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                container: true,
                                spacing: 2,
                                children: places && places.map((place)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jQZSN.default), (0, $2QP2i._)({}, place))
                                    }, place.id))
                            })
                        })
                    }),
                    contacts && !!contacts.length && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                        id: "contacts",
                        isActive: activeHash === "contacts",
                        setQuickMenuAnchor: setQuickMenuAnchor,
                        title: "Contacts",
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                            container: true,
                            spacing: 2,
                            children: contacts.map((contact)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5H7Tw.default), (0, $2QP2i._)({}, contact))
                                }, contact.name))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $k8aZE.default), {
                anchorEl: quickMenuAnchor,
                links: quickMenuLinks,
                onClose: ()=>setQuickMenuAnchor(null),
                onExit: ()=>setQuickMenuAnchor(null)
            })
        ]
    });
}
var $7bac8b0e70e37996$export$2e2bcd8739ae039 = (0, $87gt0.observer)($7bac8b0e70e37996$var$BuildingDetails);

});
parcelRegister("5RWGb", function(module, exports) {


(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("70fFQ")), (parcelRequire("3glZ1")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _react = __webpack_require__(1);
            var _react2 = _interopRequireDefault(_react);
            var _reactDom = __webpack_require__(2);
            var _reactDom2 = _interopRequireDefault(_reactDom);
            var _propTypes = __webpack_require__(3);
            var _propTypes2 = _interopRequireDefault(_propTypes);
            var _isVisibleWithOffset = __webpack_require__(6);
            var _isVisibleWithOffset2 = _interopRequireDefault(_isVisibleWithOffset);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            function normalizeRect(rect) {
                if (rect.width === undefined) rect.width = rect.right - rect.left;
                if (rect.height === undefined) rect.height = rect.bottom - rect.top;
                return rect;
            }
            var VisibilitySensor = function(_React$Component) {
                _inherits(VisibilitySensor, _React$Component);
                function VisibilitySensor(props) {
                    _classCallCheck(this, VisibilitySensor);
                    var _this = _possibleConstructorReturn(this, (VisibilitySensor.__proto__ || Object.getPrototypeOf(VisibilitySensor)).call(this, props));
                    _this.getContainer = function() {
                        return _this.props.containment || window;
                    };
                    _this.addEventListener = function(target, event, delay, throttle) {
                        if (!_this.debounceCheck) _this.debounceCheck = {};
                        var timeout = void 0;
                        var func = void 0;
                        var later = function later() {
                            timeout = null;
                            _this.check();
                        };
                        if (throttle > -1) func = function func() {
                            if (!timeout) timeout = setTimeout(later, throttle || 0);
                        };
                        else func = function func() {
                            clearTimeout(timeout);
                            timeout = setTimeout(later, delay || 0);
                        };
                        var info = {
                            target: target,
                            fn: func,
                            getLastTimeout: function getLastTimeout() {
                                return timeout;
                            }
                        };
                        target.addEventListener(event, info.fn);
                        _this.debounceCheck[event] = info;
                    };
                    _this.startWatching = function() {
                        if (_this.debounceCheck || _this.interval) return;
                        if (_this.props.intervalCheck) _this.interval = setInterval(_this.check, _this.props.intervalDelay);
                        if (_this.props.scrollCheck) _this.addEventListener(_this.getContainer(), "scroll", _this.props.scrollDelay, _this.props.scrollThrottle);
                        if (_this.props.resizeCheck) _this.addEventListener(window, "resize", _this.props.resizeDelay, _this.props.resizeThrottle);
                        // if dont need delayed call, check on load ( before the first interval fires )
                        !_this.props.delayedCall && _this.check();
                    };
                    _this.stopWatching = function() {
                        if (_this.debounceCheck) {
                            // clean up event listeners and their debounce callers
                            for(var debounceEvent in _this.debounceCheck)if (_this.debounceCheck.hasOwnProperty(debounceEvent)) {
                                var debounceInfo = _this.debounceCheck[debounceEvent];
                                clearTimeout(debounceInfo.getLastTimeout());
                                debounceInfo.target.removeEventListener(debounceEvent, debounceInfo.fn);
                                _this.debounceCheck[debounceEvent] = null;
                            }
                        }
                        _this.debounceCheck = null;
                        if (_this.interval) _this.interval = clearInterval(_this.interval);
                    };
                    _this.check = function() {
                        var el = _this.node;
                        var rect = void 0;
                        var containmentRect = void 0;
                        // if the component has rendered to null, dont update visibility
                        if (!el) return _this.state;
                        rect = normalizeRect(_this.roundRectDown(el.getBoundingClientRect()));
                        if (_this.props.containment) {
                            var containmentDOMRect = _this.props.containment.getBoundingClientRect();
                            containmentRect = {
                                top: containmentDOMRect.top,
                                left: containmentDOMRect.left,
                                bottom: containmentDOMRect.bottom,
                                right: containmentDOMRect.right
                            };
                        } else containmentRect = {
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight || document.documentElement.clientHeight,
                            right: window.innerWidth || document.documentElement.clientWidth
                        };
                        // Check if visibility is wanted via offset?
                        var offset = _this.props.offset || {};
                        var hasValidOffset = (typeof offset === "undefined" ? "undefined" : _typeof(offset)) === "object";
                        if (hasValidOffset) {
                            containmentRect.top += offset.top || 0;
                            containmentRect.left += offset.left || 0;
                            containmentRect.bottom -= offset.bottom || 0;
                            containmentRect.right -= offset.right || 0;
                        }
                        var visibilityRect = {
                            top: rect.top >= containmentRect.top,
                            left: rect.left >= containmentRect.left,
                            bottom: rect.bottom <= containmentRect.bottom,
                            right: rect.right <= containmentRect.right
                        };
                        // https://github.com/joshwnj/react-visibility-sensor/pull/114
                        var hasSize = rect.height > 0 && rect.width > 0;
                        var isVisible = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right;
                        // check for partial visibility
                        if (hasSize && _this.props.partialVisibility) {
                            var partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left;
                            // account for partial visibility on a single edge
                            if (typeof _this.props.partialVisibility === "string") partialVisible = visibilityRect[_this.props.partialVisibility];
                            // if we have minimum top visibility set by props, lets check, if it meets the passed value
                            // so if for instance element is at least 200px in viewport, then show it.
                            isVisible = _this.props.minTopValue ? partialVisible && rect.top <= containmentRect.bottom - _this.props.minTopValue : partialVisible;
                        }
                        // Deprecated options for calculating offset.
                        if (typeof offset.direction === "string" && typeof offset.value === "number") {
                            console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", offset.direction, offset.value);
                            isVisible = (0, _isVisibleWithOffset2.default)(offset, rect, containmentRect);
                        }
                        var state = _this.state;
                        // notify the parent when the value changes
                        if (_this.state.isVisible !== isVisible) {
                            state = {
                                isVisible: isVisible,
                                visibilityRect: visibilityRect
                            };
                            _this.setState(state);
                            if (_this.props.onChange) _this.props.onChange(isVisible);
                        }
                        return state;
                    };
                    _this.state = {
                        isVisible: null,
                        visibilityRect: {}
                    };
                    return _this;
                }
                _createClass(VisibilitySensor, [
                    {
                        key: "componentDidMount",
                        value: function componentDidMount() {
                            this.node = _reactDom2.default.findDOMNode(this);
                            if (this.props.active) this.startWatching();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            this.stopWatching();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function componentDidUpdate(prevProps) {
                            // re-register node in componentDidUpdate if children diffs [#103]
                            this.node = _reactDom2.default.findDOMNode(this);
                            if (this.props.active && !prevProps.active) {
                                this.setState({
                                    isVisible: null,
                                    visibilityRect: {}
                                });
                                this.startWatching();
                            } else if (!this.props.active) this.stopWatching();
                        }
                    },
                    {
                        key: "roundRectDown",
                        value: function roundRectDown(rect) {
                            return {
                                top: Math.floor(rect.top),
                                left: Math.floor(rect.left),
                                bottom: Math.floor(rect.bottom),
                                right: Math.floor(rect.right)
                            };
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            if (this.props.children instanceof Function) return this.props.children({
                                isVisible: this.state.isVisible,
                                visibilityRect: this.state.visibilityRect
                            });
                            return _react2.default.Children.only(this.props.children);
                        }
                    }
                ]);
                return VisibilitySensor;
            }(_react2.default.Component);
            VisibilitySensor.defaultProps = {
                active: true,
                partialVisibility: false,
                minTopValue: 0,
                scrollCheck: false,
                scrollDelay: 250,
                scrollThrottle: -1,
                resizeCheck: false,
                resizeDelay: 250,
                resizeThrottle: -1,
                intervalCheck: true,
                intervalDelay: 100,
                delayedCall: false,
                offset: {},
                containment: null,
                children: _react2.default.createElement("span", null)
            };
            VisibilitySensor.propTypes = {
                onChange: _propTypes2.default.func,
                active: _propTypes2.default.bool,
                partialVisibility: _propTypes2.default.oneOfType([
                    _propTypes2.default.bool,
                    _propTypes2.default.oneOf([
                        "top",
                        "right",
                        "bottom",
                        "left"
                    ])
                ]),
                delayedCall: _propTypes2.default.bool,
                offset: _propTypes2.default.oneOfType([
                    _propTypes2.default.shape({
                        top: _propTypes2.default.number,
                        left: _propTypes2.default.number,
                        bottom: _propTypes2.default.number,
                        right: _propTypes2.default.number
                    }),
                    // deprecated offset property
                    _propTypes2.default.shape({
                        direction: _propTypes2.default.oneOf([
                            "top",
                            "right",
                            "bottom",
                            "left"
                        ]),
                        value: _propTypes2.default.number
                    })
                ]),
                scrollCheck: _propTypes2.default.bool,
                scrollDelay: _propTypes2.default.number,
                scrollThrottle: _propTypes2.default.number,
                resizeCheck: _propTypes2.default.bool,
                resizeDelay: _propTypes2.default.number,
                resizeThrottle: _propTypes2.default.number,
                intervalCheck: _propTypes2.default.bool,
                intervalDelay: _propTypes2.default.number,
                containment: typeof window !== "undefined" ? _propTypes2.default.instanceOf(window.Element) : _propTypes2.default.any,
                children: _propTypes2.default.oneOfType([
                    _propTypes2.default.element,
                    _propTypes2.default.func
                ]),
                minTopValue: _propTypes2.default.number
            };
            exports.default = VisibilitySensor;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__1__;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__2__;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            var throwOnDirectAccess, isValidElement, REACT_ELEMENT_TYPE;
            // By explicitly using `prop-types` you are opting into new production behavior.
            // http://fb.me/prop-types-in-prod
            module1.exports = __webpack_require__(4)();
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = __webpack_require__(5);
            function emptyFunction() {}
            module1.exports = function() {
                function shim(props, propName, componentName, location, propFullName, secret) {
                    if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                    return;
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                }
                shim.isRequired = shim;
                function getShim() {
                    return shim;
                }
                // Important!
                // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
                var ReactPropTypes = {
                    array: shim,
                    bool: shim,
                    func: shim,
                    number: shim,
                    object: shim,
                    string: shim,
                    symbol: shim,
                    any: shim,
                    arrayOf: getShim,
                    element: shim,
                    instanceOf: getShim,
                    node: shim,
                    objectOf: getShim,
                    oneOf: getShim,
                    oneOfType: getShim,
                    shape: getShim,
                    exact: getShim
                };
                ReactPropTypes.checkPropTypes = emptyFunction;
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            module1.exports = ReactPropTypesSecret;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Tell whether the rect is visible, given an offset
            //
            // return: boolean
            module1.exports = function(offset, rect, containmentRect) {
                var offsetDir = offset.direction;
                var offsetVal = offset.value;
                // Rules for checking different kind of offsets. In example if the element is
                // 90px below viewport and offsetTop is 100, it is considered visible.
                switch(offsetDir){
                    case "top":
                        return containmentRect.top + offsetVal < rect.top && containmentRect.bottom > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right;
                    case "left":
                        return containmentRect.left + offsetVal < rect.left && containmentRect.bottom > rect.bottom && containmentRect.top < rect.top && containmentRect.right > rect.right;
                    case "bottom":
                        return containmentRect.bottom - offsetVal > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right && containmentRect.top < rect.top;
                    case "right":
                        return containmentRect.right - offsetVal > rect.right && containmentRect.left < rect.left && containmentRect.top < rect.top && containmentRect.bottom > rect.bottom;
                }
            };
        /***/ }
    ]);
});

});

parcelRegister("ezukV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9bbddc1e4a93aec$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $8VJ2N = parcelRequire("8VJ2N");


var $5tCXN = parcelRequire("5tCXN");
const $a9bbddc1e4a93aec$var$DataGrid = ({ data: data, compact: compact })=>{
    const dataObj = data.reduce((acc, item)=>{
        if (item.position === "left" || item.position === "right") {
            acc[item.position].push(item);
            return acc;
        }
        acc.sequential.push(item);
        return acc;
    }, {
        left: [],
        right: [],
        sequential: []
    });
    const { left: left, right: right, sequential: sequential } = dataObj;
    let className = "data-grid";
    if (compact) className += " compact";
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
        container: true,
        spacing: 2,
        children: [
            sequential.length > 0 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                    container: true,
                    spacing: 2,
                    className: className,
                    children: sequential.map((item)=>{
                        return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), (0, $2QP2i._)({}, item), item.id || item.key || item.label);
                    })
                })
            }),
            left.length > 0 && right.length > 0 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
                    container: true,
                    spacing: 2,
                    className: "data-columns",
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                            item: true,
                            xs: 12,
                            md: 6,
                            className: "data-col",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                container: true,
                                spacing: 2,
                                children: left.map((item)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), (0, $2QP2i._)({
                                        md: 12,
                                        className: "col"
                                    }, item), item.id || item.key || item.label))
                            })
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                            item: true,
                            xs: 12,
                            md: 6,
                            className: "data-col",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                container: true,
                                spacing: 2,
                                children: right.map((item)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), (0, $2QP2i._)({
                                        md: 12,
                                        className: "col"
                                    }, item), item.id || item.key || item.label))
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $a9bbddc1e4a93aec$export$2e2bcd8739ae039 = $a9bbddc1e4a93aec$var$DataGrid;

});
parcelRegister("5tCXN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fcde284afe2bfb9$export$2e2bcd8739ae039; });
/* eslint react/no-danger: 0 */ 
var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $dsvUQ = parcelRequire("dsvUQ");

var $8VJ2N = parcelRequire("8VJ2N");
var $27ZKj = parcelRequire("27ZKj");

var $1Kscq = parcelRequire("1Kscq");

var $2mnfJ = parcelRequire("2mnfJ");

var $fuiMG = parcelRequire("fuiMG");
const $3fcde284afe2bfb9$var$ItemContent = ({ format: format, value: value, suffix: suffix, prefix: prefix, digits: digits })=>{
    let formattedValue = value;
    if (format === "currency") {
        const options = {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: value > 1000 ? 0 : 2,
            maximumFractionDigits: value > 1000 ? 0 : 2
        };
        if (digits) {
            options.minimumFractionDigits = digits;
            options.maximumFractionDigits = digits;
        }
        formattedValue = new Intl.NumberFormat("en-US", options).format(value);
    } else if (format !== false && !isNaN(value)) formattedValue = (0, $fuiMG.formatNumber)(value, digits);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            prefix && /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                className: "value-unit",
                dangerouslySetInnerHTML: {
                    __html: `${prefix}`
                }
            }),
            formattedValue,
            suffix && /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                className: "value-unit",
                dangerouslySetInnerHTML: {
                    __html: ` ${suffix}`
                }
            })
        ]
    });
};
const $3fcde284afe2bfb9$var$ItemLink = ({ url: url, children: children })=>{
    if (url.startsWith("http") || url.startsWith("www")) {
        const httpUrl = url.startsWith("www") ? `//${url}` : url;
        return /*#__PURE__*/ (0, $4x3bm.jsx)("a", {
            href: httpUrl,
            rel: "noopener noreferrer",
            target: "_blank",
            children: children
        });
    }
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsvUQ.Link), {
        to: url,
        children: children
    });
};
const $3fcde284afe2bfb9$var$DataGridItem = (_param)=>{
    var { className: className, format: format, Icon: Icon, label: label, md: md = 6, prefix: prefix, digits: digits, hideIfZero: hideIfZero = false, suffix: suffix, url: url, value: value, valueProps: valueProps = {}, isLoading: isLoading = false, style: style = {} } = _param, rest = (0, $bmkEq._)(_param, [
        "className",
        "format",
        "Icon",
        "label",
        "md",
        "prefix",
        "digits",
        "hideIfZero",
        "suffix",
        "url",
        "value",
        "valueProps",
        "isLoading",
        "style"
    ]);
    const theme = (0, $2mnfJ.default)();
    if ((value === "0" || value === 0) && hideIfZero) return null;
    if (typeof value === "undefined" || value === null) return null;
    if (isLoading) return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), (0, $edHbI._)((0, $2QP2i._)({
        item: true,
        xs: 12,
        md: md,
        className: `data-grid-item ${className || ""}`
    }, rest), {
        children: [
            !label && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1Kscq.default), {
                        variant: "rectangular",
                        width: 70,
                        style: {
                            marginRight: 10
                        }
                    }),
                    " "
                ]
            }),
            label && /*#__PURE__*/ (0, $4x3bm.jsx)("label", {
                children: label
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1Kscq.default), {
                variant: "rectangular",
                width: 40
            })
        ]
    }));
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), (0, $edHbI._)((0, $2QP2i._)({
        className: `data-grid-item ${className || ""}`,
        item: true,
        md: md,
        xs: 12
    }, rest), {
        style: (0, $2QP2i._)({}, style),
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
            alignItems: "center",
            container: true,
            spacing: 0,
            children: [
                Icon && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                    item: true,
                    xs: "auto",
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                        style: {
                            backgroundColor: theme.palette.background.default
                        },
                        className: "data-grid-item-icon",
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)(Icon, {
                            fontSize: "large"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
                    item: true,
                    xs: true,
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)("label", {
                            children: label
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), (0, $edHbI._)((0, $2QP2i._)({
                            variant: "body2"
                        }, valueProps), {
                            children: url ? /*#__PURE__*/ (0, $4x3bm.jsx)($3fcde284afe2bfb9$var$ItemLink, {
                                url: url,
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)($3fcde284afe2bfb9$var$ItemContent, {
                                    format: format,
                                    prefix: prefix,
                                    suffix: suffix,
                                    value: value
                                })
                            }) : /*#__PURE__*/ (0, $4x3bm.jsx)($3fcde284afe2bfb9$var$ItemContent, {
                                format: format,
                                prefix: prefix,
                                suffix: suffix,
                                value: value,
                                digits: digits
                            })
                        }))
                    ]
                })
            ]
        })
    }));
};
var $3fcde284afe2bfb9$export$2e2bcd8739ae039 = $3fcde284afe2bfb9$var$DataGridItem;

});
parcelRegister("1Kscq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $145ff6264d1f736f$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");

var $gjktY = parcelRequire("gjktY");


var $l1z3A = parcelRequire("l1z3A");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");
var $aTuQZ = parcelRequire("aTuQZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $dllM6 = parcelRequire("dllM6");

var $4x3bm = parcelRequire("4x3bm");
let $145ff6264d1f736f$var$_ = (t)=>t, $145ff6264d1f736f$var$t, $145ff6264d1f736f$var$t1, $145ff6264d1f736f$var$t2, $145ff6264d1f736f$var$t3;
const $145ff6264d1f736f$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $145ff6264d1f736f$var$_1 = (t)=>t, $145ff6264d1f736f$var$_t, $145ff6264d1f736f$var$_t2, $145ff6264d1f736f$var$_t3, $145ff6264d1f736f$var$_t4;
const $145ff6264d1f736f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $dllM6.getSkeletonUtilityClass), classes);
};
const $145ff6264d1f736f$var$pulseKeyframe = (0, $l1z3A.keyframes)($145ff6264d1f736f$var$_t || ($145ff6264d1f736f$var$_t = $145ff6264d1f736f$var$_1($145ff6264d1f736f$var$t || ($145ff6264d1f736f$var$t = $145ff6264d1f736f$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`))));
const $145ff6264d1f736f$var$waveKeyframe = (0, $l1z3A.keyframes)($145ff6264d1f736f$var$_t2 || ($145ff6264d1f736f$var$_t2 = $145ff6264d1f736f$var$_1($145ff6264d1f736f$var$t1 || ($145ff6264d1f736f$var$t1 = $145ff6264d1f736f$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`))));
const $145ff6264d1f736f$var$SkeletonRoot = (0, $71Pr4.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $aTuQZ.getUnit)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $aTuQZ.toUnitless)(theme.shape.borderRadius);
    return (0, $20MOv.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: (0, $bFVgt.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $l1z3A.css)($145ff6264d1f736f$var$_t3 || ($145ff6264d1f736f$var$_t3 = $145ff6264d1f736f$var$_1($145ff6264d1f736f$var$t2 || ($145ff6264d1f736f$var$t2 = $145ff6264d1f736f$var$_`
      animation: ${0} 1.5s ease-in-out 0.5s infinite;
    `), 0)), $145ff6264d1f736f$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $l1z3A.css)($145ff6264d1f736f$var$_t4 || ($145ff6264d1f736f$var$_t4 = $145ff6264d1f736f$var$_1($145ff6264d1f736f$var$t3 || ($145ff6264d1f736f$var$t3 = $145ff6264d1f736f$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(90deg, transparent, ${0}, transparent);
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), 0, 0)), $145ff6264d1f736f$var$waveKeyframe, theme.palette.action.hover));
const $145ff6264d1f736f$var$Skeleton = /*#__PURE__*/ $70fFQ.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $79yYo.default)(props, $145ff6264d1f736f$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $145ff6264d1f736f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($145ff6264d1f736f$var$SkeletonRoot, (0, $20MOv.default)({
        as: component,
        ref: ref,
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $20MOv.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $145ff6264d1f736f$export$2e2bcd8739ae039 = $145ff6264d1f736f$var$Skeleton;

});
parcelRegister("aTuQZ", function(module, exports) {

$parcel$export(module.exports, "getUnit", function () { return $7ee6f95454ffaa19$export$65f2564e9a9b9222; });
$parcel$export(module.exports, "toUnitless", function () { return $7ee6f95454ffaa19$export$8af1d214c6c2f0f1; });
function $7ee6f95454ffaa19$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
function $7ee6f95454ffaa19$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
} // Emulate the sass function "unitless"
function $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
function $7ee6f95454ffaa19$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $7ee6f95454ffaa19$export$65f2564e9a9b9222(length); // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
         // Convert input length to pixels.
        let pxLength = $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(length) * $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(length) * $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(baseFontSize);
        } // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $7ee6f95454ffaa19$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $7ee6f95454ffaa19$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
function $7ee6f95454ffaa19$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $7ee6f95454ffaa19$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("dllM6", function(module, exports) {

$parcel$export(module.exports, "getSkeletonUtilityClass", function () { return $9b6e208e063e3bc3$export$c987db9fc844f86; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $9b6e208e063e3bc3$export$c987db9fc844f86(slot) {
    return (0, $dtsUs.default)("MuiSkeleton", slot);
}
const $9b6e208e063e3bc3$var$skeletonClasses = (0, $jLqVN.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $9b6e208e063e3bc3$export$2e2bcd8739ae039 = $9b6e208e063e3bc3$var$skeletonClasses;

});




parcelRegister("bNddL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $895e86bee12d14b7$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $lNJTn = parcelRequire("lNJTn");

var $bDcYY = parcelRequire("bDcYY");
var $cGU07 = parcelRequire("cGU07");
var $27ZKj = parcelRequire("27ZKj");
parcelRequire("kaUpJ");
var $etOpj = parcelRequire("etOpj");

function $895e86bee12d14b7$export$2e2bcd8739ae039(_param) {
    var { children: children, className: className, id: id, isActive: isActive, loading: loading = false, setQuickMenuAnchor: setQuickMenuAnchor, title: title, secondaryAction: secondaryAction, style: style = {} } = _param, rest = (0, $bmkEq._)(_param, [
        "children",
        "className",
        "id",
        "isActive",
        "loading",
        "setQuickMenuAnchor",
        "title",
        "secondaryAction",
        "style"
    ]);
    const ref = (0, $70fFQ.useRef)(null);
    (0, $70fFQ.useEffect)(()=>{
        if (isActive && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            setQuickMenuAnchor(null);
            ref.current.scrollIntoView();
        }
    }, [
        isActive,
        ref
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("section", (0, $edHbI._)((0, $2QP2i._)({
        ref: ref,
        id: id,
        className: `data-section ${className || ""}`,
        style: style
    }, rest), {
        children: [
            title && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                bgcolor: "background.default",
                color: "text.secondary",
                className: "data-section-header",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                        onClick: (event)=>{
                            setQuickMenuAnchor(event.target);
                        },
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                style: {
                                    cursor: "pointer"
                                },
                                variant: "body2",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)("strong", {
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                className: "quick-menu-chevron",
                                component: "span",
                                size: "small",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lNJTn))), {})
                            })
                        ]
                    }),
                    secondaryAction
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                style: {
                    height: [
                        "wind_speed",
                        "temperature",
                        "load_curve"
                    ].includes(id) ? 280 : "100%"
                },
                className: "data-section-content",
                children: loading ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {}) : children
            })
        ]
    }));
}

});
parcelRegister("lNJTn", function(module, exports) {
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdf1c5d07a60efe4$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $fdf1c5d07a60efe4$var$_default = (0, $fdf1c5d07a60efe4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
module.exports.default = $fdf1c5d07a60efe4$var$_default;

});
parcelRegister("hTVTj", function(module, exports) {
function $d0847ab44727ca56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $d0847ab44727ca56$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7Jp6i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fKdUq.default;
    }
});

var $fKdUq = parcelRequire("fKdUq");

});


parcelRegister("kaUpJ", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return (parcelRequire("duEqu")).default; });
$parcel$export(module.exports, "Spinner", function () { return (parcelRequire("etOpj")).default; });

var $duEqu = parcelRequire("duEqu");

var $etOpj = parcelRequire("etOpj");

});
parcelRegister("duEqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d2d6f7ffdd4c0a2$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

const $9d2d6f7ffdd4c0a2$var$shapes = {
    bulb: {
        shape: "M4.280964,9.82210428 C4.44277141,9.8907857 4.61039952,9.95028147 4.78304712,10 L6.83725081,10 C10.2620192,8.35252864 9.40336207,4.4281779 8.48061377,3.42654818 C8.84051026,4.86449076 8.06977303,5.14756003 8.06977303,5.89159261 C8.06977303,4.97970956 7.69572183,4.22225362 7.34926122,3.48456061 L6.21112395,6.56125694 L7.43496376,6.56125694 L4.280964,9.82210428 Z M3.97975148,9.68019388 C1.6852242,8.48715804 0.794326045,5.340592 3.95273798,2.19402596 C3.39481626,3.21414351 4.15815835,4.70631708 4.37220638,5.06991113 C4.37220638,1.78318522 7.23448682,0 7.23448682,0 C6.42175167,1.36328233 6.83045952,2.37526923 7.31848311,3.41889803 L3.76318719,7.16438881 L4.90676207,7.15508485 L3.97975148,9.68019388 Z",
        alt: "bulb"
    },
    battery: {
        shape: "M7.6630225,2.13158306 C7.57119055,2.04038155 7.42926147,1.9947808 7.23746541,1.9947808 L6.35643103,1.9947808 L6.35643103,1.57824618 C6.35643103,1.37929002 6.31254809,1.23214205 6.22455206,1.13680226 C6.13272011,1.04560075 5.99079102,1 5.79899496,1 L4.99590651,1 C4.80411045,1 4.66225808,1.04560075 4.57034941,1.13680226 C4.4824301,1.23214205 4.43847044,1.37929002 4.43847044,1.57824618 L4.43847044,1.9947808 L3.55743607,1.9947808 C3.36564001,1.9947808 3.22378764,2.04038155 3.13187897,2.13158306 C3.04395966,2.22692285 3,2.37407082 3,2.57302698 L3,8.3800798 C3,8.57903596 3.04395966,8.72626352 3.13187897,8.82152373 C3.22378764,8.91272523 3.36564001,8.95832599 3.55743607,8.95832599 L7.23754212,8.95832599 C7.42933818,8.95832599 7.57126727,8.91280482 7.66309922,8.82152373 C7.75101853,8.72626352 7.79497819,8.57903596 7.79497819,8.3800798 L7.79497819,2.57302698 C7.79490147,2.37407082 7.75101853,2.22692285 7.6630225,2.13158306",
        alt: "battery"
    },
    hydrogen: {
        shape: "M5.6 0S3.433 2.067 2.697 2.83C1.962 3.597 1.5 4.63 1.5 5.8 1.5 8.112 3.335 10 5.61 10c2.264 0 4.11-1.876 4.11-4.202 0-1.19-.484-2.26-1.264-3.023C7.71 2.045 5.6 0 5.6 0zM3.8 3.706V7.99h.943V6.142h1.734V7.99h.942V3.706h-.943V5.35H4.743V3.706H3.8z",
        alt: "hydrogen"
    },
    sun: {
        shape: "M3.26689772,7.79549835 C2.98529611,7.50412272 2.98529611,7.50412272 2.70559849,7.79549835 L2.14429927,8.38023311 C1.86460165,8.67359224 1.86460165,8.67359224 2.14429927,8.96496787 C2.42399688,9.2563435 2.42399688,9.2563435 2.70559849,8.96496787 L3.26689772,8.38023311 C3.54650013,8.08895666 3.54650013,8.08895666 3.26689772,7.79549835 Z M8.87570119,1.95251446 C8.59600358,1.66113883 8.59600358,1.66113883 8.31440196,1.95251446 L7.75310274,2.53724922 C7.47340512,2.82862485 7.47340512,2.82862485 7.75310274,3.12198398 C8.03470435,3.41335961 8.03470435,3.41335961 8.31440196,3.12198398 L8.87570119,2.53724922 C9.1553988,2.24379092 9.1553988,2.24379092 8.87570119,1.95251446 Z M7.75310274,7.79549835 C7.47340512,8.08885748 7.47340512,8.08885748 7.75310274,8.38023311 L8.31440196,8.96496787 C8.59600358,9.2563435 8.59600358,9.2563435 8.87570119,8.96496787 C9.1553988,8.67359224 9.1553988,8.67359224 8.87570119,8.38023311 L8.31440196,7.79549835 C8.03479955,7.5042219 8.03479955,7.5042219 7.75310274,7.79549835 Z M2.14429927,1.95251446 C1.86460165,2.24389009 1.86460165,2.24389009 2.14429927,2.53724922 L2.70559849,3.12198398 C2.98529611,3.41335961 2.98529611,3.41335961 3.26689772,3.12198398 C3.54659533,2.82862485 3.54659533,2.82862485 3.26689772,2.53724922 L2.70559849,1.95251446 C2.42390168,1.66113883 2.42390168,1.66113883 2.14429927,1.95251446 Z M5.51000023,8.76453555 C5.11330181,8.76453555 5.11330181,8.76453555 5.11330181,9.17779704 L5.11330181,10.0042208 C5.11330181,10.4174823 5.11330181,10.4174823 5.51000023,10.4174823 C5.90669865,10.4174823 5.90669865,10.4174823 5.90669865,10.0042208 L5.90669865,9.17779704 C5.90669865,8.76453555 5.90669865,8.76453555 5.51000023,8.76453555 Z M5.51000023,0.5 C5.11330181,0.5 5.11330181,0.5 5.11330181,0.913261489 L5.11330181,1.73968529 C5.11330181,2.15294678 5.11330181,2.15294678 5.51000023,2.15294678 C5.90669865,2.15294678 5.90669865,2.15294678 5.90669865,1.73968529 L5.90669865,0.913261489 C5.90669865,0.5 5.90669865,0.5 5.51000023,0.5 Z M8.68330198,5.45874117 C8.68330198,5.87200265 8.68330198,5.87200265 9.0800004,5.87200265 L9.87330204,5.87200265 C10.2700005,5.87200265 10.2700005,5.87200265 10.2700005,5.45874117 C10.2700005,5.04547968 10.2700005,5.04547968 9.87330204,5.04547968 L9.0800004,5.04547968 C8.68330198,5.04547968 8.68330198,5.04547968 8.68330198,5.45874117 Z M0.75,5.45874117 C0.75,5.87200265 0.75,5.87200265 1.14669842,5.87200265 L1.94000006,5.87200265 C2.33669848,5.87200265 2.33669848,5.87200265 2.33669848,5.45874117 C2.33669848,5.04547968 2.33669848,5.04547968 1.94000006,5.04547968 L1.14669842,5.04547968 C0.75,5.04547968 0.75,5.04547968 0.75,5.45874117 Z M5.51000023,7.93811175 C6.82442669,7.93811175 7.89000034,6.82804795 7.89000034,5.45874117 C7.89000034,4.08943438 6.82442669,2.97937058 5.51000023,2.97937058 C4.19557377,2.97937058 3.13000011,4.08943438 3.13000011,5.45874117 C3.13000011,6.82804795 4.19557377,7.93811175 5.51000023,7.93811175 Z",
        alt: "sun"
    },
    solar_thermal: {
        shape: "M72.707 361.77c-17.192 50.203 17.192 70.147 0 120.35H89.9c17.19-50.203-17.193-70.147 0-120.35H72.706zM110.702 361.77c-17.193 50.203 17.192 70.147 0 120.35h17.192c17.193-50.203-17.192-70.147 0-120.35h-17.192zM148.526 361.77c-17.193 50.203 17.192 70.147 0 120.35h17.192c17.193-50.203-17.192-70.147 0-120.35h-17.192z",
        alt: "solar thermal"
    }
};
const $9d2d6f7ffdd4c0a2$var$styles = {
    default: {
        strokeWidth: 0
    },
    circleFull: {
        strokeWidth: ".5px"
    },
    circleEmpty: {
        fill: "none",
        strokeWidth: ".5px"
    }
};
function $9d2d6f7ffdd4c0a2$export$2e2bcd8739ae039({ name: name, title: title, value: value }) {
    if (name === "solar_thermal") return /*#__PURE__*/ (0, $4x3bm.jsxs)("svg", {
        className: name,
        style: $9d2d6f7ffdd4c0a2$var$styles.default,
        alt: $9d2d6f7ffdd4c0a2$var$shapes[name] && $9d2d6f7ffdd4c0a2$var$shapes[name].alt,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-18.479 833.854 37 15",
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                fill: "#FA2A00",
                cx: "-11.182",
                cy: "841.354",
                r: "7.385"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                style: value >= 1 ? $9d2d6f7ffdd4c0a2$var$styles.circleFull : $9d2d6f7ffdd4c0a2$var$styles.circleEmpty,
                stroke: "#FA2A00",
                strokeWidth: ".5",
                cx: ".95",
                cy: "841.354",
                r: "2.638"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                style: value >= 2 ? $9d2d6f7ffdd4c0a2$var$styles.circleFull : $9d2d6f7ffdd4c0a2$var$styles.circleEmpty,
                stroke: "#FA2A00",
                strokeWidth: ".5",
                cx: "8.336",
                cy: "841.354",
                r: "2.638"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                style: value >= 3 ? $9d2d6f7ffdd4c0a2$var$styles.circleFull : $9d2d6f7ffdd4c0a2$var$styles.circleEmpty,
                stroke: "#FA2A00",
                strokeWidth: ".5",
                cx: "15.721",
                cy: "841.354",
                r: "2.638"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("g", {
                fill: "#FFF",
                children: /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
                    fill: "#FFF",
                    d: "M-15.016 838.34h1.167v6.73h-1.166zM-12.85 838.34h1.168v6.73h-1.167zM-10.683 838.34h1.167v6.73h-1.167zM-8.516 838.34h1.167v6.73h-1.166z"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
        className: "technology-icon",
        title: title,
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)("svg", {
            className: name,
            viewBox: "-2 -2 37 15",
            style: $9d2d6f7ffdd4c0a2$var$styles.default,
            alt: $9d2d6f7ffdd4c0a2$var$shapes[name] && $9d2d6f7ffdd4c0a2$var$shapes[name].alt,
            children: [
                /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                    cx: "5.5",
                    cy: "5.5",
                    r: "7"
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
                    fill: "white",
                    d: $9d2d6f7ffdd4c0a2$var$shapes[name] && $9d2d6f7ffdd4c0a2$var$shapes[name].shape,
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                    cx: "17",
                    cy: "5.5",
                    r: "2.5",
                    style: value >= 1 ? $9d2d6f7ffdd4c0a2$var$styles.circleFull : $9d2d6f7ffdd4c0a2$var$styles.circleEmpty
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                    cx: "24",
                    cy: "5.5",
                    r: "2.5",
                    style: value >= 2 ? $9d2d6f7ffdd4c0a2$var$styles.circleFull : $9d2d6f7ffdd4c0a2$var$styles.circleEmpty
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
                    cx: "31",
                    cy: "5.5",
                    r: "2.5",
                    style: value >= 3 ? $9d2d6f7ffdd4c0a2$var$styles.circleFull : $9d2d6f7ffdd4c0a2$var$styles.circleEmpty
                })
            ]
        })
    });
}

});



parcelRegister("k8aZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea7d150f6230fc09$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $4x3bm = parcelRequire("4x3bm");

var $ajp8Q = parcelRequire("ajp8Q");
var $6yY4r = parcelRequire("6yY4r");

var $dih0O = parcelRequire("dih0O");
parcelRequire("70fFQ");
function $ea7d150f6230fc09$export$2e2bcd8739ae039(_param) {
    var { anchorEl: anchorEl, onClose: onClose = ()=>{}, links: links } = _param, rest = (0, $bmkEq._)(_param, [
        "anchorEl",
        "onClose",
        "links"
    ]);
    const history = (0, $dih0O.useHistory)();
    const handleClick = (id)=>{
        history.push(`#${id}`);
        onClose();
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ajp8Q.default), (0, $edHbI._)((0, $2QP2i._)({
        anchorEl: anchorEl,
        keepMounted: true,
        open: !!anchorEl
    }, rest), {
        children: links.map(({ id: id, title: title })=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $6yY4r.default), {
                onClick: ()=>handleClick(id),
                value: id,
                children: title
            }, `quickNav_${id}`))
    }));
}

});
parcelRegister("ajp8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $781f2e524fe0eacc$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8q2ES");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");


var $e7K89 = parcelRequire("e7K89");

var $1mImZ = parcelRequire("1mImZ");

var $8KZHc = parcelRequire("8KZHc");

var $71Pr4 = parcelRequire("71Pr4");

var $2mnfJ = parcelRequire("2mnfJ");

var $cNmNk = parcelRequire("cNmNk");

var $6QSmI = parcelRequire("6QSmI");

var $4x3bm = parcelRequire("4x3bm");
const $781f2e524fe0eacc$var$_excluded = [
    "onEntering"
], $781f2e524fe0eacc$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $781f2e524fe0eacc$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $781f2e524fe0eacc$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $781f2e524fe0eacc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $6QSmI.getMenuUtilityClass), classes);
};
const $781f2e524fe0eacc$var$MenuRoot = (0, $71Pr4.default)((0, $8KZHc.default), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $781f2e524fe0eacc$var$MenuPaper = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $781f2e524fe0eacc$var$MenuMenuList = (0, $71Pr4.default)((0, $e7K89.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $781f2e524fe0eacc$var$Menu = /*#__PURE__*/ $70fFQ.forwardRef(function Menu(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu" } = props, TransitionProps = (0, $79yYo.default)(props.TransitionProps, $781f2e524fe0eacc$var$_excluded), other = (0, $79yYo.default)(props, $781f2e524fe0eacc$var$_excluded2);
    const theme = (0, $2mnfJ.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $20MOv.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $781f2e524fe0eacc$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $70fFQ.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $70fFQ.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $70fFQ.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)($781f2e524fe0eacc$var$MenuRoot, (0, $20MOv.default)({
        classes: PopoverClasses,
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $781f2e524fe0eacc$var$RTL_ORIGIN : $781f2e524fe0eacc$var$LTR_ORIGIN,
        PaperProps: (0, $20MOv.default)({
            component: $781f2e524fe0eacc$var$MenuPaper
        }, PaperProps, {
            classes: (0, $20MOv.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $20MOv.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($781f2e524fe0eacc$var$MenuMenuList, (0, $20MOv.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $gjktY.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $781f2e524fe0eacc$export$2e2bcd8739ae039 = $781f2e524fe0eacc$var$Menu;

});
parcelRegister("e7K89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a48580ae9b5beb17$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8q2ES");


var $9YaqH = parcelRequire("9YaqH");

var $W7alG = parcelRequire("W7alG");

var $f9H9r = parcelRequire("f9H9r");

var $5Up1l = parcelRequire("5Up1l");

var $7kxc8 = parcelRequire("7kxc8");

var $4x3bm = parcelRequire("4x3bm");
const $a48580ae9b5beb17$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $a48580ae9b5beb17$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $a48580ae9b5beb17$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $a48580ae9b5beb17$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $a48580ae9b5beb17$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$a48580ae9b5beb17$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $a48580ae9b5beb17$var$MenuList = /*#__PURE__*/ $70fFQ.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $79yYo.default)(props, $a48580ae9b5beb17$var$_excluded);
    const listRef = $70fFQ.useRef(null);
    const textCriteriaRef = $70fFQ.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $7kxc8.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $70fFQ.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $f9H9r.default)((0, $9YaqH.default)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $9YaqH.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $a48580ae9b5beb17$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $a48580ae9b5beb17$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $a48580ae9b5beb17$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $a48580ae9b5beb17$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $a48580ae9b5beb17$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $a48580ae9b5beb17$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $a48580ae9b5beb17$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $a48580ae9b5beb17$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $a48580ae9b5beb17$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $a48580ae9b5beb17$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $a48580ae9b5beb17$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $5Up1l.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $70fFQ.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $70fFQ.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const items = $70fFQ.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $70fFQ.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $W7alG.default), (0, $20MOv.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $a48580ae9b5beb17$export$2e2bcd8739ae039 = $a48580ae9b5beb17$var$MenuList;

});
parcelRegister("9YaqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7421cebde394ea7b$export$2e2bcd8739ae039; });

var $iMBVa = parcelRequire("iMBVa");
var $7421cebde394ea7b$export$2e2bcd8739ae039 = (0, $iMBVa.default);

});

parcelRegister("W7alG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aeaf9e557ca8caf$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $jgeht = parcelRequire("jgeht");

var $iaxGO = parcelRequire("iaxGO");

var $4x3bm = parcelRequire("4x3bm");
const $0aeaf9e557ca8caf$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $0aeaf9e557ca8caf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $iaxGO.getListUtilityClass), classes);
};
const $0aeaf9e557ca8caf$var$ListRoot = (0, $71Pr4.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $0aeaf9e557ca8caf$var$List = /*#__PURE__*/ $70fFQ.forwardRef(function List(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $79yYo.default)(props, $0aeaf9e557ca8caf$var$_excluded);
    const context = $70fFQ.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $0aeaf9e557ca8caf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jgeht.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)($0aeaf9e557ca8caf$var$ListRoot, (0, $20MOv.default)({
            as: component,
            className: (0, $gjktY.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $0aeaf9e557ca8caf$export$2e2bcd8739ae039 = $0aeaf9e557ca8caf$var$List;

});
parcelRegister("jgeht", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e05a96d18fe82a0e$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 */ const $e05a96d18fe82a0e$var$ListContext = /*#__PURE__*/ $70fFQ.createContext({});
var $e05a96d18fe82a0e$export$2e2bcd8739ae039 = $e05a96d18fe82a0e$var$ListContext;

});

parcelRegister("iaxGO", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $d3a34b329bfb5d9d$export$c6bd6795ed6e3203; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $d3a34b329bfb5d9d$export$c6bd6795ed6e3203(slot) {
    return (0, $dtsUs.default)("MuiList", slot);
}
const $d3a34b329bfb5d9d$var$listClasses = (0, $jLqVN.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $d3a34b329bfb5d9d$export$2e2bcd8739ae039 = $d3a34b329bfb5d9d$var$listClasses;

});


parcelRegister("f9H9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0892b3ba8ea23de$export$2e2bcd8739ae039; });

var $kzmpV = parcelRequire("kzmpV");
var $b0892b3ba8ea23de$export$2e2bcd8739ae039 = (0, $kzmpV.default);

});
parcelRegister("kzmpV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef98771d17755681$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $ef98771d17755681$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRegister("8KZHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66027a1e870a32d7$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");


var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $zMoYI = parcelRequire("zMoYI");

var $9YaqH = parcelRequire("9YaqH");

var $eQjPF = parcelRequire("eQjPF");

var $5Up1l = parcelRequire("5Up1l");

var $54wpe = parcelRequire("54wpe");

var $7aifL = parcelRequire("7aifL");

var $1mImZ = parcelRequire("1mImZ");

var $eljrF = parcelRequire("eljrF");

var $4x3bm = parcelRequire("4x3bm");
const $66027a1e870a32d7$var$_excluded = [
    "onEntering"
], $66027a1e870a32d7$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
function $66027a1e870a32d7$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $66027a1e870a32d7$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $66027a1e870a32d7$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $66027a1e870a32d7$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $66027a1e870a32d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $eljrF.getPopoverUtilityClass), classes);
};
const $66027a1e870a32d7$var$PopoverRoot = (0, $71Pr4.default)((0, $7aifL.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $66027a1e870a32d7$var$PopoverPaper = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $66027a1e870a32d7$var$Popover = /*#__PURE__*/ $70fFQ.forwardRef(function Popover(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperProps = {}, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $54wpe.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {} } = props, TransitionProps = (0, $79yYo.default)(props.TransitionProps, $66027a1e870a32d7$var$_excluded), other = (0, $79yYo.default)(props, $66027a1e870a32d7$var$_excluded2);
    const paperRef = $70fFQ.useRef();
    const handlePaperRef = (0, $5Up1l.default)(paperRef, PaperProps.ref);
    const ownerState = (0, $20MOv.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        PaperProps: PaperProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $66027a1e870a32d7$var$useUtilityClasses(ownerState); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $70fFQ.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $66027a1e870a32d7$var$resolveAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $9YaqH.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $66027a1e870a32d7$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $66027a1e870a32d7$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the base transform origin using the element
    const getTransformOrigin = $70fFQ.useCallback((elemRect)=>{
        return {
            vertical: $66027a1e870a32d7$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $66027a1e870a32d7$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $70fFQ.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $66027a1e870a32d7$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset(); // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $eQjPF.default)($66027a1e870a32d7$var$resolveAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $66027a1e870a32d7$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const setPositioningStyles = $70fFQ.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    $70fFQ.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $70fFQ.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $70fFQ.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $zMoYI.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $eQjPF.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $9YaqH.default)($66027a1e870a32d7$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($66027a1e870a32d7$var$PopoverRoot, (0, $20MOv.default)({
        BackdropProps: {
            invisible: true
        },
        className: (0, $gjktY.default)(classes.root, className),
        container: container,
        open: open,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $4x3bm.jsx)($66027a1e870a32d7$var$PopoverPaper, (0, $20MOv.default)({
                elevation: elevation
            }, PaperProps, {
                ref: handlePaperRef,
                className: (0, $gjktY.default)(classes.paper, PaperProps.className),
                children: children
            }))
        }))
    }));
});
var $66027a1e870a32d7$export$2e2bcd8739ae039 = $66027a1e870a32d7$var$Popover;

});
parcelRegister("zMoYI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06b8d09a72ea42fa$export$2e2bcd8739ae039; });

var $5NQ9H = parcelRequire("5NQ9H");
var $06b8d09a72ea42fa$export$2e2bcd8739ae039 = (0, $5NQ9H.default);

});

parcelRegister("eQjPF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ace54e4f64c2e269$export$2e2bcd8739ae039; });

var $blhVx = parcelRequire("blhVx");
var $ace54e4f64c2e269$export$2e2bcd8739ae039 = (0, $blhVx.default);

});

parcelRegister("7aifL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5377a04f6495b89b$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gZaTl = parcelRequire("gZaTl");


var $a0enY = parcelRequire("a0enY");
var $i8Zft = parcelRequire("i8Zft");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $bfhCA = parcelRequire("bfhCA");

var $4x3bm = parcelRequire("4x3bm");
const $5377a04f6495b89b$var$_excluded = [
    "BackdropComponent",
    "closeAfterTransition",
    "children",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted"
];
const $5377a04f6495b89b$export$eb211a494147b724 = (0, $i8Zft.default);
const $5377a04f6495b89b$var$extendUtilityClasses = (ownerState)=>{
    return ownerState.classes;
};
const $5377a04f6495b89b$var$ModalRoot = (0, $71Pr4.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        position: "fixed",
        zIndex: theme.zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $5377a04f6495b89b$var$ModalBackdrop = (0, $71Pr4.default)((0, $bfhCA.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $5377a04f6495b89b$var$Modal = /*#__PURE__*/ $70fFQ.forwardRef(function Modal(inProps, ref) {
    var _componentsProps$root;
    const props = (0, $cNmNk.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $5377a04f6495b89b$var$ModalBackdrop, closeAfterTransition: closeAfterTransition = false, children: children, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false } = props, other = (0, $79yYo.default)(props, $5377a04f6495b89b$var$_excluded);
    const [exited, setExited] = $70fFQ.useState(true);
    const commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const ownerState = (0, $20MOv.default)({}, props, commonProps, {
        exited: exited
    });
    const classes = $5377a04f6495b89b$var$extendUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $a0enY.default), (0, $20MOv.default)({
        components: (0, $20MOv.default)({
            Root: $5377a04f6495b89b$var$ModalRoot
        }, components),
        componentsProps: {
            root: (0, $20MOv.default)({}, componentsProps.root, (!components.Root || !(0, $gZaTl.default)(components.Root)) && {
                ownerState: (0, $20MOv.default)({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
            })
        },
        BackdropComponent: BackdropComponent,
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, {
        classes: classes
    }, commonProps, {
        children: children
    }));
});
var $5377a04f6495b89b$export$2e2bcd8739ae039 = $5377a04f6495b89b$var$Modal;

});
parcelRegister("a0enY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7485102e5a93d65a$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $6tMUR = parcelRequire("6tMUR");
var $iMBVa = parcelRequire("iMBVa");
var $3Fato = parcelRequire("3Fato");
var $4Rshd = parcelRequire("4Rshd");

var $8dWxZ = parcelRequire("8dWxZ");

var $gZaTl = parcelRequire("gZaTl");

var $7niyo = parcelRequire("7niyo");

var $7FmSh = parcelRequire("7FmSh");

var $5qD9y = parcelRequire("5qD9y");

var $i8Zft = parcelRequire("i8Zft");

var $4x3bm = parcelRequire("4x3bm");
const $7485102e5a93d65a$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "children",
    "classes",
    "className",
    "closeAfterTransition",
    "component",
    "components",
    "componentsProps",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "theme",
    "onTransitionEnter",
    "onTransitionExited"
];
const $7485102e5a93d65a$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $i8Zft.getModalUtilityClass), classes);
};
function $7485102e5a93d65a$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $7485102e5a93d65a$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $7485102e5a93d65a$var$defaultManager = new (0, $7FmSh.default)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $7485102e5a93d65a$var$ModalUnstyled = /*#__PURE__*/ $70fFQ.forwardRef(function ModalUnstyled(props, ref) {
    const { BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, container: container, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, manager: // private
    // eslint-disable-next-line react/prop-types
    manager = $7485102e5a93d65a$var$defaultManager, onBackdropClick: onBackdropClick, onClose: onClose, onKeyDown: onKeyDown, open: open, theme: /* eslint-disable react/prop-types */ theme, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited } = props, other = (0, $79yYo.default)(props, $7485102e5a93d65a$var$_excluded);
    const [exited, setExited] = $70fFQ.useState(true);
    const modal = $70fFQ.useRef({});
    const mountNodeRef = $70fFQ.useRef(null);
    const modalRef = $70fFQ.useRef(null);
    const handleRef = (0, $4Rshd.default)(modalRef, ref);
    const hasTransition = $7485102e5a93d65a$var$getHasTransition(props);
    const getDoc = ()=>(0, $iMBVa.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $3Fato.default)(()=>{
        const resolvedContainer = $7485102e5a93d65a$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $70fFQ.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $3Fato.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else (0, $7FmSh.ariaHidden)(modalRef.current, true);
    });
    const handleClose = $70fFQ.useCallback(()=>{
        manager.remove(getModal());
    }, [
        manager
    ]);
    $70fFQ.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $70fFQ.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $20MOv.default)({}, props, {
        classes: classesProp,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $7485102e5a93d65a$var$useUtilityClasses(ownerState);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
         // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $6tMUR.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $6tMUR.default)(handleExited, children.props.onExited);
    }
    const Root = components.Root || component;
    const rootProps = componentsProps.root || {};
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7niyo.default), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)(Root, (0, $20MOv.default)({
            role: "presentation"
        }, rootProps, !(0, $gZaTl.default)(Root) && {
            as: component,
            ownerState: (0, $20MOv.default)({}, ownerState, rootProps.ownerState),
            theme: theme
        }, other, {
            ref: handleRef,
            onKeyDown: handleKeyDown,
            className: (0, $gjktY.default)(classes.root, rootProps.className, className),
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $4x3bm.jsx)(BackdropComponent, (0, $20MOv.default)({
                    open: open,
                    onClick: handleBackdropClick
                }, BackdropProps)) : null,
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5qD9y.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $70fFQ.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $7485102e5a93d65a$export$2e2bcd8739ae039 = $7485102e5a93d65a$var$ModalUnstyled;

});
parcelRegister("6tMUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b7b65389bbd7d88$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $4b7b65389bbd7d88$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("7niyo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55e912c2bc10adad$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");


var $eSJYK = parcelRequire("eSJYK");
var $qEgbK = parcelRequire("qEgbK");
var $4Rshd = parcelRequire("4Rshd");
function $55e912c2bc10adad$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ const $55e912c2bc10adad$var$Portal = /*#__PURE__*/ $70fFQ.forwardRef(function Portal(props, ref) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $70fFQ.useState(null);
    const handleRef = (0, $4Rshd.default)(/*#__PURE__*/ $70fFQ.isValidElement(children) ? children.ref : null, ref);
    (0, $qEgbK.default)(()=>{
        if (!disablePortal) setMountNode($55e912c2bc10adad$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $qEgbK.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $eSJYK.default)(ref, mountNode);
            return ()=>{
                (0, $eSJYK.default)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $70fFQ.isValidElement(children)) return /*#__PURE__*/ $70fFQ.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $3glZ1.createPortal(children, mountNode) : mountNode;
});
var $55e912c2bc10adad$export$2e2bcd8739ae039 = $55e912c2bc10adad$var$Portal;

});

parcelRegister("7FmSh", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $594e1b21bdaa8ac8$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "default", function () { return $594e1b21bdaa8ac8$export$2e2bcd8739ae039; });

var $kzmpV = parcelRequire("kzmpV");
var $iMBVa = parcelRequire("iMBVa");
var $blhVx = parcelRequire("blhVx");
// Is a vertical scrollbar displayed?
function $594e1b21bdaa8ac8$var$isOverflowing(container) {
    const doc = (0, $iMBVa.default)(container);
    if (doc.body === container) return (0, $blhVx.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $594e1b21bdaa8ac8$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $594e1b21bdaa8ac8$var$getPaddingRight(element) {
    return parseInt((0, $blhVx.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $594e1b21bdaa8ac8$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude = [], show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    const blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, (element)=>{
        if (blacklist.indexOf(element) === -1 && blacklistTagNames.indexOf(element.tagName) === -1) $594e1b21bdaa8ac8$export$e1bd0c6150f13d96(element, show);
    });
}
function $594e1b21bdaa8ac8$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $594e1b21bdaa8ac8$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($594e1b21bdaa8ac8$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $kzmpV.default)((0, $iMBVa.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$594e1b21bdaa8ac8$var$getPaddingRight(container) + scrollbarSize}px`; // .mui-fixed is a global helper.
            const fixedElements = (0, $iMBVa.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$594e1b21bdaa8ac8$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        const parent = container.parentElement;
        const containerWindow = (0, $blhVx.default)(container);
        const scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $594e1b21bdaa8ac8$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $594e1b21bdaa8ac8$export$2e2bcd8739ae039 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal); // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $594e1b21bdaa8ac8$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $594e1b21bdaa8ac8$var$getHiddenSiblings(container);
        $594e1b21bdaa8ac8$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $594e1b21bdaa8ac8$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $594e1b21bdaa8ac8$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $594e1b21bdaa8ac8$var$handleContainer(containerInfo, props);
    }
    remove(modal) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $594e1b21bdaa8ac8$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $594e1b21bdaa8ac8$export$e1bd0c6150f13d96(modal.modalRef, true);
            $594e1b21bdaa8ac8$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $594e1b21bdaa8ac8$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}

});

parcelRegister("5qD9y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f3dc0761c6854b9$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/naming-convention, consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $70fFQ = parcelRequire("70fFQ");


var $iMBVa = parcelRequire("iMBVa");
var $4Rshd = parcelRequire("4Rshd");

var $4x3bm = parcelRequire("4x3bm");
const $3f3dc0761c6854b9$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $3f3dc0761c6854b9$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
     // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $3f3dc0761c6854b9$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $3f3dc0761c6854b9$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $3f3dc0761c6854b9$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $3f3dc0761c6854b9$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($3f3dc0761c6854b9$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $3f3dc0761c6854b9$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$3f3dc0761c6854b9$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $3f3dc0761c6854b9$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 */ function $3f3dc0761c6854b9$var$Unstable_TrapFocus(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $3f3dc0761c6854b9$var$defaultGetTabbable, isEnabled: isEnabled = $3f3dc0761c6854b9$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $70fFQ.useRef();
    const sentinelStart = $70fFQ.useRef(null);
    const sentinelEnd = $70fFQ.useRef(null);
    const nodeToRestore = $70fFQ.useRef(null);
    const reactFocusEventTarget = $70fFQ.useRef(null); // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $70fFQ.useRef(false);
    const rootRef = $70fFQ.useRef(null);
    const handleRef = (0, $4Rshd.default)(children.ref, rootRef);
    const lastKeydown = $70fFQ.useRef(null);
    $70fFQ.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $70fFQ.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $iMBVa.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        }; // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open TrapFocus
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $70fFQ.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $iMBVa.default)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
             // Make sure the next tab starts from the right place.
            // doc.activeElement referes to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                tabIndex: 0,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-test": "sentinelStart"
            }),
            /*#__PURE__*/ $70fFQ.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                tabIndex: 0,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-test": "sentinelEnd"
            })
        ]
    });
}
var $3f3dc0761c6854b9$export$2e2bcd8739ae039 = $3f3dc0761c6854b9$var$Unstable_TrapFocus;

});

parcelRegister("i8Zft", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $d3587c0d26dcab79$export$67960e22b12a638d; });
$parcel$export(module.exports, "default", function () { return $d3587c0d26dcab79$export$2e2bcd8739ae039; });

var $jLqVN = parcelRequire("jLqVN");

var $dtsUs = parcelRequire("dtsUs");
function $d3587c0d26dcab79$export$67960e22b12a638d(slot) {
    return (0, $dtsUs.default)("MuiModal", slot);
}
const $d3587c0d26dcab79$var$modalUnstyledClasses = (0, $jLqVN.default)("MuiModal", [
    "root",
    "hidden"
]);
var $d3587c0d26dcab79$export$2e2bcd8739ae039 = $d3587c0d26dcab79$var$modalUnstyledClasses;

});


parcelRegister("bfhCA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82fec3ae85d5c39c$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gZaTl = parcelRequire("gZaTl");

var $fYtnx = parcelRequire("fYtnx");
var $3RX4D = parcelRequire("3RX4D");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $kcSl7 = parcelRequire("kcSl7");

var $4x3bm = parcelRequire("4x3bm");
const $82fec3ae85d5c39c$var$_excluded = [
    "children",
    "components",
    "componentsProps",
    "className",
    "invisible",
    "open",
    "transitionDuration",
    "TransitionComponent"
];
const $82fec3ae85d5c39c$export$d3dc778836e7d1ec = (0, $fYtnx.default);
const $82fec3ae85d5c39c$var$extendUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $82fec3ae85d5c39c$var$BackdropRoot = (0, $71Pr4.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $82fec3ae85d5c39c$var$Backdrop = /*#__PURE__*/ $70fFQ.forwardRef(function Backdrop(inProps, ref) {
    var _componentsProps$root;
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, components: components = {}, componentsProps: componentsProps = {}, className: className, invisible: invisible = false, open: open, transitionDuration: transitionDuration, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $kcSl7.default) } = props, other = (0, $79yYo.default)(props, $82fec3ae85d5c39c$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        invisible: invisible
    });
    const classes = $82fec3ae85d5c39c$var$extendUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3RX4D.default), {
            className: className,
            invisible: invisible,
            components: (0, $20MOv.default)({
                Root: $82fec3ae85d5c39c$var$BackdropRoot
            }, components),
            componentsProps: {
                root: (0, $20MOv.default)({}, componentsProps.root, (!components.Root || !(0, $gZaTl.default)(components.Root)) && {
                    ownerState: (0, $20MOv.default)({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
                })
            },
            classes: classes,
            ref: ref,
            children: children
        })
    }));
});
var $82fec3ae85d5c39c$export$2e2bcd8739ae039 = $82fec3ae85d5c39c$var$Backdrop;

});
parcelRegister("fYtnx", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $ba133f97e3dd9eb5$export$9927a91fd93152bd; });
$parcel$export(module.exports, "default", function () { return $ba133f97e3dd9eb5$export$2e2bcd8739ae039; });

var $jLqVN = parcelRequire("jLqVN");

var $dtsUs = parcelRequire("dtsUs");
function $ba133f97e3dd9eb5$export$9927a91fd93152bd(slot) {
    return (0, $dtsUs.default)("MuiBackdrop", slot);
}
const $ba133f97e3dd9eb5$var$backdropUnstyledClasses = (0, $jLqVN.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $ba133f97e3dd9eb5$export$2e2bcd8739ae039 = $ba133f97e3dd9eb5$var$backdropUnstyledClasses;

});

parcelRegister("3RX4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d14252a1828732b$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $gZaTl = parcelRequire("gZaTl");

var $fYtnx = parcelRequire("fYtnx");

var $4x3bm = parcelRequire("4x3bm");
const $2d14252a1828732b$var$_excluded = [
    "classes",
    "className",
    "invisible",
    "component",
    "components",
    "componentsProps",
    "theme"
];
const $2d14252a1828732b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $fYtnx.getBackdropUtilityClass), classes);
};
const $2d14252a1828732b$var$BackdropUnstyled = /*#__PURE__*/ $70fFQ.forwardRef(function BackdropUnstyled(props, ref) {
    const { classes: classesProp, className: className, invisible: invisible = false, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, theme: /* eslint-disable react/prop-types */ theme } = props, other = (0, $79yYo.default)(props, $2d14252a1828732b$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        classes: classesProp,
        invisible: invisible
    });
    const classes = $2d14252a1828732b$var$useUtilityClasses(ownerState);
    const Root = components.Root || component;
    const rootProps = componentsProps.root || {};
    return /*#__PURE__*/ (0, $4x3bm.jsx)(Root, (0, $20MOv.default)({
        "aria-hidden": true
    }, rootProps, !(0, $gZaTl.default)(Root) && {
        as: component,
        ownerState: (0, $20MOv.default)({}, ownerState, rootProps.ownerState),
        theme: theme
    }, {
        ref: ref
    }, other, {
        className: (0, $gjktY.default)(classes.root, rootProps.className, className)
    }));
});
var $2d14252a1828732b$export$2e2bcd8739ae039 = $2d14252a1828732b$var$BackdropUnstyled;

});

parcelRegister("kcSl7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb5f145c220b2dc4$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $dxolJ = parcelRequire("dxolJ");


var $2mnfJ = parcelRequire("2mnfJ");

var $ceSe6 = parcelRequire("ceSe6");

var $5Up1l = parcelRequire("5Up1l");

var $4x3bm = parcelRequire("4x3bm");
const $eb5f145c220b2dc4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $eb5f145c220b2dc4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $eb5f145c220b2dc4$var$Fade = /*#__PURE__*/ $70fFQ.forwardRef(function Fade(props, ref) {
    const theme = (0, $2mnfJ.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $dxolJ.default) } = props, other = (0, $79yYo.default)(props, $eb5f145c220b2dc4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $70fFQ.useRef(null);
    const foreignRef = (0, $5Up1l.default)(children.ref, ref);
    const handleRef = (0, $5Up1l.default)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $ceSe6.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $70fFQ.cloneElement(children, (0, $20MOv.default)({
                style: (0, $20MOv.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $eb5f145c220b2dc4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $eb5f145c220b2dc4$export$2e2bcd8739ae039 = $eb5f145c220b2dc4$var$Fade;

});



parcelRegister("eljrF", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $a7121c48ff469f97$export$88f455dd56c95edb; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $a7121c48ff469f97$export$88f455dd56c95edb(slot) {
    return (0, $dtsUs.default)("MuiPopover", slot);
}
const $a7121c48ff469f97$var$popoverClasses = (0, $jLqVN.default)("MuiPopover", [
    "root",
    "paper"
]);
var $a7121c48ff469f97$export$2e2bcd8739ae039 = $a7121c48ff469f97$var$popoverClasses;

});


parcelRegister("6QSmI", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $4fd1c5409e5bd97e$export$2cf86a63a84fe23d; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $4fd1c5409e5bd97e$export$2cf86a63a84fe23d(slot) {
    return (0, $dtsUs.default)("MuiMenu", slot);
}
const $4fd1c5409e5bd97e$var$menuClasses = (0, $jLqVN.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $4fd1c5409e5bd97e$export$2e2bcd8739ae039 = $4fd1c5409e5bd97e$var$menuClasses;

});


parcelRegister("6yY4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c7483cea996585e$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $jgeht = parcelRequire("jgeht");

var $eGmvM = parcelRequire("eGmvM");

var $7kxc8 = parcelRequire("7kxc8");

var $5Up1l = parcelRequire("5Up1l");

var $ci6ap = parcelRequire("ci6ap");

var $1uWNS = parcelRequire("1uWNS");

var $c7ir8 = parcelRequire("c7ir8");

var $l19vw = parcelRequire("l19vw");

var $4x3bm = parcelRequire("4x3bm");
const $4c7483cea996585e$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex"
];
const $4c7483cea996585e$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $4c7483cea996585e$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $l19vw.getMenuItemUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $4c7483cea996585e$var$MenuItemRoot = (0, $71Pr4.default)((0, $eGmvM.default), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $4c7483cea996585e$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: theme.palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $l19vw.default).selected}`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $l19vw.default).focusVisible}`]: {
                backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $l19vw.default).selected}:hover`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $l19vw.default).focusVisible}`]: {
            backgroundColor: theme.palette.action.focus
        },
        [`&.${(0, $l19vw.default).disabled}`]: {
            opacity: theme.palette.action.disabledOpacity
        },
        [`& + .${(0, $ci6ap.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $ci6ap.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $c7ir8.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $c7ir8.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $1uWNS.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $20MOv.default)({
        minHeight: 32,
        // https://material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $1uWNS.default).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $4c7483cea996585e$var$MenuItem = /*#__PURE__*/ $70fFQ.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp } = props, other = (0, $79yYo.default)(props, $4c7483cea996585e$var$_excluded);
    const context = $70fFQ.useContext((0, $jgeht.default));
    const childContext = {
        dense: dense || context.dense || false,
        disableGutters: disableGutters
    };
    const menuItemRef = $70fFQ.useRef(null);
    (0, $7kxc8.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $20MOv.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $4c7483cea996585e$var$useUtilityClasses(props);
    const handleRef = (0, $5Up1l.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jgeht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($4c7483cea996585e$var$MenuItemRoot, (0, $20MOv.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $gjktY.default)(classes.focusVisible, focusVisibleClassName)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $4c7483cea996585e$export$2e2bcd8739ae039 = $4c7483cea996585e$var$MenuItem;

});
parcelRegister("1uWNS", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", function () { return $117634ee392affcc$export$81478e24460c57f2; });
$parcel$export(module.exports, "default", function () { return $117634ee392affcc$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $117634ee392affcc$export$81478e24460c57f2(slot) {
    return (0, $dtsUs.default)("MuiListItemIcon", slot);
}
const $117634ee392affcc$var$listItemIconClasses = (0, $jLqVN.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $117634ee392affcc$export$2e2bcd8739ae039 = $117634ee392affcc$var$listItemIconClasses;

});

parcelRegister("c7ir8", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", function () { return $8d247098e08c2090$export$1061006a0db3aeb5; });
$parcel$export(module.exports, "default", function () { return $8d247098e08c2090$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $8d247098e08c2090$export$1061006a0db3aeb5(slot) {
    return (0, $dtsUs.default)("MuiListItemText", slot);
}
const $8d247098e08c2090$var$listItemTextClasses = (0, $jLqVN.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $8d247098e08c2090$export$2e2bcd8739ae039 = $8d247098e08c2090$var$listItemTextClasses;

});

parcelRegister("l19vw", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", function () { return $f4d110eb88abd0f6$export$515f8c67b5305377; });
$parcel$export(module.exports, "default", function () { return $f4d110eb88abd0f6$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $f4d110eb88abd0f6$export$515f8c67b5305377(slot) {
    return (0, $dtsUs.default)("MuiMenuItem", slot);
}
const $f4d110eb88abd0f6$var$menuItemClasses = (0, $jLqVN.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $f4d110eb88abd0f6$export$2e2bcd8739ae039 = $f4d110eb88abd0f6$var$menuItemClasses;

});



parcelRegister("cLwEj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94b3334b06c7a87b$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $3fLZ2 = parcelRequire("3fLZ2");
var $bDcYY = parcelRequire("bDcYY");
var $7xvOw = parcelRequire("7xvOw");
var $5DHXT = parcelRequire("5DHXT");
var $6yY4r = parcelRequire("6yY4r");
var $69ubn = parcelRequire("69ubn");
var $iWVbX = parcelRequire("iWVbX");
var $3DLOK = parcelRequire("3DLOK");
var $c9kiU = parcelRequire("c9kiU");
var $iTwQr = parcelRequire("iTwQr");
var $bOUdn = parcelRequire("bOUdn");
var $8Hhl0 = parcelRequire("8Hhl0");
var $27ZKj = parcelRequire("27ZKj");

var $j2BR8 = parcelRequire("j2BR8");
var $aXDgw = parcelRequire("aXDgw");
var $d9jmQ = parcelRequire("d9jmQ");
var $dl52B = parcelRequire("dl52B");
var $i0zMe = parcelRequire("i0zMe");
var $hpUOc = parcelRequire("hpUOc");
var $hd6af = parcelRequire("hd6af");
var $1QBMq = parcelRequire("1QBMq");
var $gffu7 = parcelRequire("gffu7");
var $d39yA = parcelRequire("d39yA");
var $7Pmfg = parcelRequire("7Pmfg");

var $fuiMG = parcelRequire("fuiMG");

var $lzkmL = parcelRequire("lzkmL");

var $ezukV = parcelRequire("ezukV");
function $94b3334b06c7a87b$var$hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
const $94b3334b06c7a87b$var$fields = [
    {
        color: $gffu7.default[400],
        id: "space_heating",
        label: "Space heating",
        description: `As an energy end use, the use of mechanical equipment (including wood stoves and active solar heating devices) to heat all, or part, of a building to at least 50\xb0F.`
    },
    {
        id: "cooling",
        label: "Cooling",
        color: $hpUOc.default[400],
        description: `The conditioning of air in a room for human comfort by a refrigeration unit (such as an air conditioner or heat pump) or by a central cooling or district cooling system that circulates chilled water. Use of fans or blowers by themselves without chilled air or water is not included in this definition of air-conditioning.`
    },
    {
        id: "ventilation",
        label: "Ventilation",
        color: $d39yA.default[400],
        ventilation: `The conditioning of air in a room for human comfort by a refrigeration unit (such as an air conditioner or heat pump) or by a central cooling or district cooling system that circulates chilled water. Use of fans or blowers by themselves without chilled air or water is not included in this definition of air-conditioning.`
    },
    {
        id: "waterheating",
        label: "Water Heating",
        color: $7Pmfg.default[400],
        description: `As an energy end use, the use of energy to heat water for purposes other than space heating. Also referred to as domestic hot water heating.`
    },
    {
        id: "lighting",
        label: "Lighting",
        color: $i0zMe.default[400],
        description: `The illumination of the interior of a building by use of artificial sources of light.`
    },
    {
        id: "cooking",
        label: "Cooking",
        color: $j2BR8.default[400],
        description: `As an energy end use, the use of energy for food preparation. It does not include food preparation in areas such as employee lounges, breakrooms, or vending areas that only involve equipment such as microwaves, coffee pots, and vending machines.`
    },
    {
        id: "refrigeration",
        label: "Refrigeration",
        color: $aXDgw.default[400],
        description: `Refrigeration equipment is designed to maintain the stored items below room temperature but above the freezing point of water. This category also includes commercial ice machines and freezer equipment, which are designed to keep their contents below the freezing point of water (32\xb0F).`
    },
    {
        id: "office_equipment",
        label: "Office equipment",
        color: $1QBMq.default[400],
        description: ``
    },
    {
        id: "computing",
        label: "Computing",
        color: $hd6af.default[400],
        description: ``
    },
    {
        id: "other",
        label: "Other",
        color: $d9jmQ.default[400],
        description: ``
    }
];
const $94b3334b06c7a87b$var$additionalUses = [
    {
        id: "use_ev_charger_2",
        label: "EV Charger (Level 2)",
        color: $1QBMq.default[400],
        value: 40000
    },
    {
        id: "use_ev_charger_3",
        label: "EV Charger (Level 3)",
        color: $dl52B.default[400],
        value: 300000
    }
];
const $94b3334b06c7a87b$var$UseChart = ({ data: data, metrics: metrics, cbecsData: cbecsData })=>{
    const [energyUseData, setEnergyUseData] = (0, $70fFQ.useState)(data);
    const [activeRow, setActiveRow] = (0, $70fFQ.useState)(null);
    const annualKwhConsumption = metrics === null || metrics === void 0 ? void 0 : metrics.annual_kwh_consumption;
    // const originalOtherPercentage = parseFloat(cbecsData.other_percentage);
    const [rows, setRows] = (0, $70fFQ.useState)($94b3334b06c7a87b$var$fields.map(({ id: id, label: label, color: color, description: description })=>{
        return {
            id: id,
            label: label,
            color: color,
            description: description
        };
    }));
    const sortedRows = rows.map((row)=>{
        let rawValue = typeof row.value !== "undefined" ? row.value : annualKwhConsumption * (parseFloat(cbecsData[`${row.id}_percentage`]) / 100);
        if (row.use_id) rawValue = parseInt(row.total_units, 10) * row.value;
        if (!rawValue) rawValue = 0;
        return (0, $edHbI._)((0, $2QP2i._)({}, row), {
            value: (0, $fuiMG.formatNumber)(rawValue),
            value_raw: rawValue,
            percentage: (0, $fuiMG.formatNumber)(rawValue / annualKwhConsumption * 100)
        });
    });
    // .sort((a, b) => b.value_raw - a.value_raw);
    const totalKwh = sortedRows.reduce((acc, val)=>{
        return acc + parseFloat(val.value_raw);
    }, 0);
    (0, $70fFQ.useEffect)(()=>{
        const newEnergyUseData = [
            ...energyUseData
        ];
        const idx = newEnergyUseData.findIndex((item)=>item.id === "annual_consumption");
        if (idx !== -1) // newEnergyUseData[idx].value = formatNumber(totalKwh);
        setEnergyUseData(newEnergyUseData);
    }, [
        totalKwh
    ]);
    const normalizedRows = sortedRows.map((row)=>{
        return (0, $edHbI._)((0, $2QP2i._)({}, row), {
            percentage: (0, $fuiMG.formatNumber)(row.value_raw / totalKwh * 100)
        });
    });
    const addRow = ()=>{
        setRows([
            ...rows,
            (0, $edHbI._)((0, $2QP2i._)({
                label: null,
                color: "#ddd",
                description: "Select use",
                value: (0, $fuiMG.formatNumber)(0),
                percentage: (0, $fuiMG.formatNumber)(0),
                use_id: $94b3334b06c7a87b$var$additionalUses[0].id,
                total_units: 1
            }, $94b3334b06c7a87b$var$additionalUses[0]), {
                suffix: "unit"
            })
        ]);
    };
    const chartRows = normalizedRows.map((row)=>{
        const newRow = (0, $edHbI._)((0, $2QP2i._)({}, row), {
            value: row.percentage
        });
        if (!activeRow) return (0, $2QP2i._)({}, newRow);
        if (newRow.id !== activeRow.id) {
            const rgb = $94b3334b06c7a87b$var$hexToRgb(row.color);
            return (0, $edHbI._)((0, $2QP2i._)({}, newRow), {
                color: rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.2)` : ""
            });
        }
        return (0, $2QP2i._)({}, newRow);
    });
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ezukV.default), {
                data: energyUseData
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                mt: 4,
                display: "flex",
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iTwQr.default), {
                        sx: {
                            width: {
                                sm: "100%",
                                md: "100%",
                                lg: "60%"
                            }
                        },
                        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $iWVbX.default), {
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bOUdn.default), {
                                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8Hhl0.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {}),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                children: "Use"
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                align: "left",
                                                children: "Percentage"
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                align: "right",
                                                children: "Value"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $3DLOK.default), {
                                    children: [
                                        normalizedRows.map((row)=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8Hhl0.default), {
                                                hover: true,
                                                onMouseOver: ()=>{
                                                    if (!row.id.startsWith("new")) setActiveRow(row);
                                                },
                                                onMouseOut: ()=>setActiveRow(null),
                                                sx: {
                                                    "&:last-child td, &:last-child th": {
                                                        border: 0
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                        component: "th",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3fLZ2.default), {
                                                            sx: {
                                                                bgcolor: row.color,
                                                                width: 24,
                                                                height: 24
                                                            },
                                                            children: "\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                        component: "th",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                                            style: {
                                                                cursor: row.description ? "help" : "default"
                                                            },
                                                            title: row.description,
                                                            children: row.id.startsWith("use") ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $69ubn.default), {
                                                                sx: {
                                                                    padding: 0,
                                                                    fontSize: "0.875rem"
                                                                },
                                                                defaultValue: row.id,
                                                                variant: "standard",
                                                                disableUnderline: true,
                                                                fullWidth: true,
                                                                // value=""
                                                                onChange: (event)=>{
                                                                    const { value: value } = event.target;
                                                                    setRows((rows)=>{
                                                                        const additionalUse = $94b3334b06c7a87b$var$additionalUses.find((use)=>use.id === value);
                                                                        const currRowIndex = rows.findIndex((item)=>item.id === row.id);
                                                                        const newRows = [
                                                                            ...rows
                                                                        ];
                                                                        newRows[currRowIndex] = (0, $edHbI._)((0, $2QP2i._)({}, rows[currRowIndex]), {
                                                                            value: additionalUse.value,
                                                                            // label: additionalUse.label,
                                                                            color: additionalUse === null || additionalUse === void 0 ? void 0 : additionalUse.color,
                                                                            suffix: value === 1 ? "unit" : "units",
                                                                            use_id: additionalUse.id
                                                                        });
                                                                        return newRows;
                                                                    });
                                                                },
                                                                children: $94b3334b06c7a87b$var$additionalUses.map((use)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $6yY4r.default), {
                                                                        value: use.id,
                                                                        children: use.label
                                                                    }, use.id))
                                                            }) : row.label
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $c9kiU.default), {
                                                        align: "left",
                                                        component: "th",
                                                        scope: "row",
                                                        children: [
                                                            row.percentage,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                        align: "right",
                                                        component: "th",
                                                        scope: "row",
                                                        children: row.id.startsWith("use") ? /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                                            alignItems: "center",
                                                            display: "flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), {
                                                                    onChange: (event)=>{
                                                                        const { value: totalUnits } = event.target;
                                                                        // const newOtherRow = otherRow.value_raw - value;
                                                                        setRows((rows)=>{
                                                                            const currRowIndex = rows.findIndex((item)=>item.id === row.id);
                                                                            const additionalUse = $94b3334b06c7a87b$var$additionalUses.find((use)=>use.id === row.use_id);
                                                                            const newRows = [
                                                                                ...rows
                                                                            ];
                                                                            // newRows[currRowIndex].value = value;
                                                                            if (additionalUse) newRows[currRowIndex] = (0, $edHbI._)((0, $2QP2i._)({}, newRows[currRowIndex]), {
                                                                                value: additionalUse.value,
                                                                                total_units: totalUnits,
                                                                                suffix: totalUnits === 1 ? "unit" : "units"
                                                                            });
                                                                            return newRows;
                                                                        });
                                                                    },
                                                                    defaultValue: 1,
                                                                    inputProps: {
                                                                        style: {
                                                                            textAlign: "right"
                                                                        },
                                                                        min: 0,
                                                                        step: 1
                                                                    },
                                                                    type: "number"
                                                                }),
                                                                row.suffix || "kWh"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                                            children: [
                                                                row.value,
                                                                row.suffix || "kWh"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, row.id)),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8Hhl0.default), {
                                            hover: true,
                                            sx: {
                                                "&:last-child td, &:last-child th": {
                                                    border: 0
                                                }
                                            },
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                colspan: 4,
                                                component: "th",
                                                scope: "row",
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                    onClick: addRow,
                                                    color: "secondary",
                                                    children: "Add use"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                        style: {
                            width: 300,
                            height: 300,
                            position: "relative",
                            marginLeft: 64
                        },
                        sx: {
                            display: {
                                sm: "none",
                                md: "none",
                                lg: "block"
                            }
                        },
                        children: [
                            activeRow && /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    left: "50%",
                                    top: "50%",
                                    transform: "translate(-50%, -50%)",
                                    whiteSpace: "nowrap",
                                    textAlign: "center"
                                },
                                className: "overlay",
                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                    style: {
                                        fontSize: 12,
                                        textAlign: "center"
                                    },
                                    variant: "body1",
                                    children: [
                                        /*#__PURE__*/ (0, $4x3bm.jsx)("b", {
                                            children: activeRow.label
                                        }),
                                        " ",
                                        activeRow.value,
                                        "kW (",
                                        activeRow.percentage,
                                        "%)"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $lzkmL.default), {
                                data: chartRows
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $94b3334b06c7a87b$export$2e2bcd8739ae039 = $94b3334b06c7a87b$var$UseChart;

});
parcelRegister("3fLZ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25e7fe5b5118567f$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $9Vhbx = parcelRequire("9Vhbx");

var $9OGwN = parcelRequire("9OGwN");

var $4x3bm = parcelRequire("4x3bm");
const $25e7fe5b5118567f$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $25e7fe5b5118567f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $9OGwN.getAvatarUtilityClass), classes);
};
const $25e7fe5b5118567f$var$AvatarRoot = (0, $71Pr4.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && {
        color: theme.palette.background.default,
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    }));
const $25e7fe5b5118567f$var$AvatarImg = (0, $71Pr4.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $25e7fe5b5118567f$var$AvatarFallback = (0, $71Pr4.default)((0, $9Vhbx.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $25e7fe5b5118567f$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $70fFQ.useState(false);
    $70fFQ.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $25e7fe5b5118567f$var$Avatar = /*#__PURE__*/ $70fFQ.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $79yYo.default)(props, $25e7fe5b5118567f$var$_excluded);
    let children = null; // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $25e7fe5b5118567f$var$useLoaded((0, $20MOv.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $20MOv.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $25e7fe5b5118567f$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $4x3bm.jsx)($25e7fe5b5118567f$var$AvatarImg, (0, $20MOv.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $4x3bm.jsx)($25e7fe5b5118567f$var$AvatarFallback, {
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)($25e7fe5b5118567f$var$AvatarRoot, (0, $20MOv.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $25e7fe5b5118567f$export$2e2bcd8739ae039 = $25e7fe5b5118567f$var$Avatar;

});
parcelRegister("9Vhbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7396c48849272dc0$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $7396c48849272dc0$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRegister("9OGwN", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", function () { return $7259c5b64f1e086a$export$ffd560f22c0ecf04; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $7259c5b64f1e086a$export$ffd560f22c0ecf04(slot) {
    return (0, $dtsUs.default)("MuiAvatar", slot);
}
const $7259c5b64f1e086a$var$avatarClasses = (0, $jLqVN.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $7259c5b64f1e086a$export$2e2bcd8739ae039 = $7259c5b64f1e086a$var$avatarClasses;

});


parcelRegister("69ubn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47aafeee9d5f487e$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $jWrHX = parcelRequire("jWrHX");

var $7Ymes = parcelRequire("7Ymes");

var $et0sX = parcelRequire("et0sX");

var $7kxx2 = parcelRequire("7kxx2");

var $1MKx1 = parcelRequire("1MKx1");

var $3cESc = parcelRequire("3cESc");

var $jTSPE = parcelRequire("jTSPE");

var $dWKKV = parcelRequire("dWKKV");

var $13NkT = parcelRequire("13NkT");

var $cNmNk = parcelRequire("cNmNk");

var $5Up1l = parcelRequire("5Up1l");

var $71Pr4 = parcelRequire("71Pr4");

var $4x3bm = parcelRequire("4x3bm");
var $47aafeee9d5f487e$var$_StyledInput, $47aafeee9d5f487e$var$_StyledFilledInput;
const $47aafeee9d5f487e$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $47aafeee9d5f487e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $47aafeee9d5f487e$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $47aafeee9d5f487e$var$StyledInput = (0, $71Pr4.default)((0, $3cESc.default), $47aafeee9d5f487e$var$styledRootConfig)("");
const $47aafeee9d5f487e$var$StyledOutlinedInput = (0, $71Pr4.default)((0, $13NkT.default), $47aafeee9d5f487e$var$styledRootConfig)("");
const $47aafeee9d5f487e$var$StyledFilledInput = (0, $71Pr4.default)((0, $dWKKV.default), $47aafeee9d5f487e$var$styledRootConfig)("");
const $47aafeee9d5f487e$var$Select = /*#__PURE__*/ $70fFQ.forwardRef(function Select(inProps, ref) {
    const props = (0, $cNmNk.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $1MKx1.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $79yYo.default)(props, $47aafeee9d5f487e$var$_excluded);
    const inputComponent = native ? (0, $jTSPE.default) : (0, $7Ymes.default);
    const muiFormControl = (0, $7kxx2.default)();
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    const variant = fcs.variant || variantProp;
    const InputComponent = input || ({
        standard: $47aafeee9d5f487e$var$_StyledInput || ($47aafeee9d5f487e$var$_StyledInput = /*#__PURE__*/ (0, $4x3bm.jsx)($47aafeee9d5f487e$var$StyledInput, {})),
        outlined: /*#__PURE__*/ (0, $4x3bm.jsx)($47aafeee9d5f487e$var$StyledOutlinedInput, {
            label: label
        }),
        filled: $47aafeee9d5f487e$var$_StyledFilledInput || ($47aafeee9d5f487e$var$_StyledFilledInput = /*#__PURE__*/ (0, $4x3bm.jsx)($47aafeee9d5f487e$var$StyledFilledInput, {}))
    })[variant];
    const ownerState = (0, $20MOv.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $47aafeee9d5f487e$var$useUtilityClasses(ownerState);
    const inputComponentRef = (0, $5Up1l.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ $70fFQ.cloneElement(InputComponent, (0, $20MOv.default)({
        inputComponent: // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent,
        inputProps: (0, $20MOv.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            multiple: // We render a select. We can ignore the type provided by the `Input`.
            multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            defaultOpen: defaultOpen,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $20MOv.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $jWrHX.default)(classes, inputProps.classes) : classes
        }, input ? input.props.inputProps : {})
    }, multiple && native && variant === "outlined" ? {
        notched: true
    } : {}, {
        ref: inputComponentRef,
        className: (0, $gjktY.default)(InputComponent.props.className, className),
        variant: variant
    }, other));
});
$47aafeee9d5f487e$var$Select.muiName = "Select";
var $47aafeee9d5f487e$export$2e2bcd8739ae039 = $47aafeee9d5f487e$var$Select;

});
parcelRegister("7Ymes", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cdf61daf7d3be90$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $awKLE = parcelRequire("awKLE");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8q2ES");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $9YaqH = parcelRequire("9YaqH");

var $aAAPW = parcelRequire("aAAPW");

var $ajp8Q = parcelRequire("ajp8Q");

var $jTSPE = parcelRequire("jTSPE");

var $bLa8E = parcelRequire("bLa8E");

var $71Pr4 = parcelRequire("71Pr4");

var $5Up1l = parcelRequire("5Up1l");

var $6Apvh = parcelRequire("6Apvh");

var $1nuDZ = parcelRequire("1nuDZ");

var $4x3bm = parcelRequire("4x3bm");
var $5cdf61daf7d3be90$var$_span;
const $5cdf61daf7d3be90$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $5cdf61daf7d3be90$var$SelectSelect = (0, $71Pr4.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`&.${(0, $1nuDZ.default).select}`]: styles.select
            },
            {
                [`&.${(0, $1nuDZ.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $1nuDZ.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $jTSPE.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $1nuDZ.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $5cdf61daf7d3be90$var$SelectIcon = (0, $71Pr4.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $aAAPW.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $jTSPE.nativeSelectIconStyles));
const $5cdf61daf7d3be90$var$SelectNativeInput = (0, $71Pr4.default)("input", {
    shouldForwardProp: (prop)=>(0, $71Pr4.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $5cdf61daf7d3be90$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
     // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $5cdf61daf7d3be90$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $5cdf61daf7d3be90$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $aAAPW.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $1nuDZ.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $5cdf61daf7d3be90$var$SelectInput = /*#__PURE__*/ $70fFQ.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $79yYo.default)(props, $5cdf61daf7d3be90$var$_excluded);
    const [value, setValueState] = (0, $6Apvh.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $6Apvh.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $70fFQ.useRef(null);
    const displayRef = $70fFQ.useRef(null);
    const [displayNode, setDisplayNode] = $70fFQ.useState(null);
    const { current: isOpenControlled } = $70fFQ.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $70fFQ.useState();
    const handleRef = (0, $5Up1l.default)(ref, inputRefProp);
    const handleDisplayRef = $70fFQ.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    $70fFQ.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]); // Resize menu on `defaultOpen` automatic toggle.
    $70fFQ.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            displayRef.current.focus();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]); // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $70fFQ.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $70fFQ.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $9YaqH.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $70fFQ.Children.toArray(children); // Support autofill.
    const handleChange = (event)=>{
        const index = childrenArray.map((child)=>child.props.value).indexOf(event.target.value);
        if (index === -1) return;
        const child = childrenArray[index];
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue; // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $bLa8E.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $70fFQ.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $awKLE.default)(2));
            selected = value.some((v)=>$5cdf61daf7d3be90$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $5cdf61daf7d3be90$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $70fFQ.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    } // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $20MOv.default)({}, props, {
        variant: variant,
        value: value,
        open: open
    });
    const classes = $5cdf61daf7d3be90$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($5cdf61daf7d3be90$var$SelectSelect, (0, $20MOv.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $gjktY.default)(classes.select, className, SelectDisplayProps.className) // The id is required for proper a11y
                ,
                id: buttonId,
                children: $5cdf61daf7d3be90$var$isEmpty(display) ? $5cdf61daf7d3be90$var$_span || ($5cdf61daf7d3be90$var$_span = /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $4x3bm.jsx)($5cdf61daf7d3be90$var$SelectNativeInput, (0, $20MOv.default)({
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $4x3bm.jsx)($5cdf61daf7d3be90$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ajp8Q.default), (0, $20MOv.default)({
                id: `menu-${name || ""}`,
                anchorEl: displayNode,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $20MOv.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $20MOv.default)({}, MenuProps.PaperProps, {
                    style: (0, $20MOv.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $5cdf61daf7d3be90$export$2e2bcd8739ae039 = $5cdf61daf7d3be90$var$SelectInput;

});
parcelRegister("jTSPE", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", function () { return $e7cdafdef914c226$export$c1eccd1617458c87; });
$parcel$export(module.exports, "nativeSelectIconStyles", function () { return $e7cdafdef914c226$export$e7a817afd12a40d0; });
$parcel$export(module.exports, "default", function () { return $e7cdafdef914c226$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $aAAPW = parcelRequire("aAAPW");

var $2Ckwr = parcelRequire("2Ckwr");

var $71Pr4 = parcelRequire("71Pr4");

var $4x3bm = parcelRequire("4x3bm");
const $e7cdafdef914c226$var$_excluded = [
    "className",
    "disabled",
    "IconComponent",
    "inputRef",
    "variant"
];
const $e7cdafdef914c226$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $aAAPW.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $2Ckwr.getNativeSelectUtilityClasses), classes);
};
const $e7cdafdef914c226$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": {
            // Show that it's not an text input
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
            borderRadius: 0 // Reset Chrome style
        },
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $2Ckwr.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: theme.palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: theme.shape.borderRadius,
        "&:focus": {
            borderRadius: theme.shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $e7cdafdef914c226$var$NativeSelectSelect = (0, $71Pr4.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $71Pr4.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            {
                [`&.${(0, $2Ckwr.default).multiple}`]: styles.multiple
            }
        ];
    }
})($e7cdafdef914c226$export$c1eccd1617458c87);
const $e7cdafdef914c226$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: theme.palette.action.active,
        [`&.${(0, $2Ckwr.default).disabled}`]: {
            color: theme.palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $e7cdafdef914c226$var$NativeSelectIcon = (0, $71Pr4.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $aAAPW.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($e7cdafdef914c226$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $e7cdafdef914c226$var$NativeSelectInput = /*#__PURE__*/ $70fFQ.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $79yYo.default)(props, $e7cdafdef914c226$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        disabled: disabled,
        variant: variant
    });
    const classes = $e7cdafdef914c226$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($e7cdafdef914c226$var$NativeSelectSelect, (0, $20MOv.default)({
                ownerState: ownerState,
                className: (0, $gjktY.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $4x3bm.jsx)($e7cdafdef914c226$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $e7cdafdef914c226$export$2e2bcd8739ae039 = $e7cdafdef914c226$var$NativeSelectInput;

});
parcelRegister("2Ckwr", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $1e7f0cb09e5060e2$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $1e7f0cb09e5060e2$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $1e7f0cb09e5060e2$export$1ee13051fd9e2ab5(slot) {
    return (0, $dtsUs.default)("MuiNativeSelect", slot);
}
const $1e7f0cb09e5060e2$var$nativeSelectClasses = (0, $jLqVN.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $1e7f0cb09e5060e2$export$2e2bcd8739ae039 = $1e7f0cb09e5060e2$var$nativeSelectClasses;

});


parcelRegister("1nuDZ", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $100fb5ad30202eca$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $100fb5ad30202eca$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $100fb5ad30202eca$export$2c0c1ee5a3392e(slot) {
    return (0, $dtsUs.default)("MuiSelect", slot);
}
const $100fb5ad30202eca$var$selectClasses = (0, $jLqVN.default)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $100fb5ad30202eca$export$2e2bcd8739ae039 = $100fb5ad30202eca$var$selectClasses;

});


parcelRegister("1MKx1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14ce5e5ea6df1a90$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $14ce5e5ea6df1a90$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});

parcelRegister("dWKKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a274f5e6ac6f476a$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");

var $jWrHX = parcelRequire("jWrHX");


var $8dWxZ = parcelRequire("8dWxZ");

var $5DHXT = parcelRequire("5DHXT");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $d8LGX = parcelRequire("d8LGX");

var $5DHXT = parcelRequire("5DHXT");

var $4x3bm = parcelRequire("4x3bm");
const $a274f5e6ac6f476a$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "type"
];
const $a274f5e6ac6f476a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $d8LGX.getFilledInputUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $a274f5e6ac6f476a$var$FilledInputRoot = (0, $71Pr4.default)((0, $5DHXT.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $5DHXT.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    return (0, $20MOv.default)({
        position: "relative",
        backgroundColor: backgroundColor,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)",
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: backgroundColor
            }
        },
        [`&.${(0, $d8LGX.default).focused}`]: {
            backgroundColor: backgroundColor
        },
        [`&.${(0, $d8LGX.default).disabled}`]: {
            backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $d8LGX.default).focused}:after`]: {
            transform: "scaleX(1)"
        },
        [`&.${(0, $d8LGX.default).error}:after`]: {
            borderBottomColor: theme.palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $d8LGX.default).disabled}):before`]: {
            borderBottom: `1px solid ${theme.palette.text.primary}`
        },
        [`&.${(0, $d8LGX.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $20MOv.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $a274f5e6ac6f476a$var$FilledInputInput = (0, $71Pr4.default)((0, $5DHXT.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $5DHXT.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $a274f5e6ac6f476a$var$FilledInput = /*#__PURE__*/ $70fFQ.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, type: type = "text" } = props, other = (0, $79yYo.default)(props, $a274f5e6ac6f476a$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $a274f5e6ac6f476a$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = componentsPropsProp ? (0, $jWrHX.default)(componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), (0, $20MOv.default)({
        components: (0, $20MOv.default)({
            Root: $a274f5e6ac6f476a$var$FilledInputRoot,
            Input: $a274f5e6ac6f476a$var$FilledInputInput
        }, components),
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$a274f5e6ac6f476a$var$FilledInput.muiName = "Input";
var $a274f5e6ac6f476a$export$2e2bcd8739ae039 = $a274f5e6ac6f476a$var$FilledInput;

});
parcelRegister("d8LGX", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $99110451dc492e04$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $99110451dc492e04$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");

var $b29Hy = parcelRequire("b29Hy");
function $99110451dc492e04$export$3331e419f1a48437(slot) {
    return (0, $dtsUs.default)("MuiFilledInput", slot);
}
const $99110451dc492e04$var$filledInputClasses = (0, $20MOv.default)({}, (0, $b29Hy.default), (0, $jLqVN.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $99110451dc492e04$export$2e2bcd8739ae039 = $99110451dc492e04$var$filledInputClasses;

});


parcelRegister("13NkT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c5c575e3fb0fc3c$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");



var $8dWxZ = parcelRequire("8dWxZ");

var $jwMxE = parcelRequire("jwMxE");

var $7kxx2 = parcelRequire("7kxx2");

var $et0sX = parcelRequire("et0sX");

var $71Pr4 = parcelRequire("71Pr4");

var $4XGo8 = parcelRequire("4XGo8");

var $5DHXT = parcelRequire("5DHXT");

var $cNmNk = parcelRequire("cNmNk");

var $4x3bm = parcelRequire("4x3bm");
const $0c5c575e3fb0fc3c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "type"
];
const $0c5c575e3fb0fc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $4XGo8.getOutlinedInputUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $0c5c575e3fb0fc3c$var$OutlinedInputRoot = (0, $71Pr4.default)((0, $5DHXT.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $5DHXT.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $20MOv.default)({
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        [`&:hover .${(0, $4XGo8.default).notchedOutline}`]: {
            borderColor: theme.palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $4XGo8.default).notchedOutline}`]: {
                borderColor: borderColor
            }
        },
        [`&.${(0, $4XGo8.default).focused} .${(0, $4XGo8.default).notchedOutline}`]: {
            borderColor: theme.palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $4XGo8.default).error} .${(0, $4XGo8.default).notchedOutline}`]: {
            borderColor: theme.palette.error.main
        },
        [`&.${(0, $4XGo8.default).disabled} .${(0, $4XGo8.default).notchedOutline}`]: {
            borderColor: theme.palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $20MOv.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $0c5c575e3fb0fc3c$var$NotchedOutlineRoot = (0, $71Pr4.default)((0, $jwMxE.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>({
        borderColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"
    }));
const $0c5c575e3fb0fc3c$var$OutlinedInputInput = (0, $71Pr4.default)((0, $5DHXT.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $5DHXT.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        padding: "16.5px 14px",
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $0c5c575e3fb0fc3c$var$OutlinedInput = /*#__PURE__*/ $70fFQ.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, type: type = "text" } = props, other = (0, $79yYo.default)(props, $0c5c575e3fb0fc3c$var$_excluded);
    const classes = $0c5c575e3fb0fc3c$var$useUtilityClasses(props);
    const muiFormControl = (0, $7kxx2.default)();
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), (0, $20MOv.default)({
        components: (0, $20MOv.default)({
            Root: $0c5c575e3fb0fc3c$var$OutlinedInputRoot,
            Input: $0c5c575e3fb0fc3c$var$OutlinedInputInput
        }, components),
        renderSuffix: (state)=>/*#__PURE__*/ (0, $4x3bm.jsx)($0c5c575e3fb0fc3c$var$NotchedOutlineRoot, {
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
                    children: [
                        label,
                        "\xa0",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $20MOv.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$0c5c575e3fb0fc3c$var$OutlinedInput.muiName = "Input";
var $0c5c575e3fb0fc3c$export$2e2bcd8739ae039 = $0c5c575e3fb0fc3c$var$OutlinedInput;

});
parcelRegister("jwMxE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e376a8d82bca8730$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");
parcelRequire("70fFQ");


var $71Pr4 = parcelRequire("71Pr4");

var $4x3bm = parcelRequire("4x3bm");
var $e376a8d82bca8730$var$_span;
const $e376a8d82bca8730$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $e376a8d82bca8730$var$NotchedOutlineRoot = (0, $71Pr4.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $e376a8d82bca8730$var$NotchedOutlineLegend = (0, $71Pr4.default)("legend")(({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        float: "unset",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $20MOv.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        width: "auto",
        // Fix conflict with bootstrap
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $e376a8d82bca8730$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $79yYo.default)(props, $e376a8d82bca8730$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $20MOv.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)($e376a8d82bca8730$var$NotchedOutlineRoot, (0, $20MOv.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($e376a8d82bca8730$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                children: label
            }) : $e376a8d82bca8730$var$_span || ($e376a8d82bca8730$var$_span = /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

});

parcelRegister("4XGo8", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $39cd8d8cdbbe5faf$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $39cd8d8cdbbe5faf$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");

var $b29Hy = parcelRequire("b29Hy");
function $39cd8d8cdbbe5faf$export$89922944c7227687(slot) {
    return (0, $dtsUs.default)("MuiOutlinedInput", slot);
}
const $39cd8d8cdbbe5faf$var$outlinedInputClasses = (0, $20MOv.default)({}, (0, $b29Hy.default), (0, $jLqVN.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $39cd8d8cdbbe5faf$export$2e2bcd8739ae039 = $39cd8d8cdbbe5faf$var$outlinedInputClasses;

});



parcelRegister("iWVbX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcba01e61ff02f3d$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $emD5C = parcelRequire("emD5C");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $cwziK = parcelRequire("cwziK");

var $4x3bm = parcelRequire("4x3bm");
const $dcba01e61ff02f3d$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $dcba01e61ff02f3d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $cwziK.getTableUtilityClass), classes);
};
const $dcba01e61ff02f3d$var$TableRoot = (0, $71Pr4.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $20MOv.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: theme.palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $dcba01e61ff02f3d$var$defaultComponent = "table";
const $dcba01e61ff02f3d$var$Table = /*#__PURE__*/ $70fFQ.forwardRef(function Table(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $dcba01e61ff02f3d$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $79yYo.default)(props, $dcba01e61ff02f3d$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $dcba01e61ff02f3d$var$useUtilityClasses(ownerState);
    const table = $70fFQ.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $emD5C.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($dcba01e61ff02f3d$var$TableRoot, (0, $20MOv.default)({
            as: component,
            role: component === $dcba01e61ff02f3d$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $gjktY.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $dcba01e61ff02f3d$export$2e2bcd8739ae039 = $dcba01e61ff02f3d$var$Table;

});
parcelRegister("emD5C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a75171292f5678ba$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 */ const $a75171292f5678ba$var$TableContext = /*#__PURE__*/ $70fFQ.createContext();
var $a75171292f5678ba$export$2e2bcd8739ae039 = $a75171292f5678ba$var$TableContext;

});

parcelRegister("cwziK", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", function () { return $91e3db4cab24cb31$export$315cb19215f77ce0; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $91e3db4cab24cb31$export$315cb19215f77ce0(slot) {
    return (0, $dtsUs.default)("MuiTable", slot);
}
const $91e3db4cab24cb31$var$tableClasses = (0, $jLqVN.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $91e3db4cab24cb31$export$2e2bcd8739ae039 = $91e3db4cab24cb31$var$tableClasses;

});


parcelRegister("3DLOK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a6a1b32abb63d78$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $fev83 = parcelRequire("fev83");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $8PsT0 = parcelRequire("8PsT0");

var $4x3bm = parcelRequire("4x3bm");
const $2a6a1b32abb63d78$var$_excluded = [
    "className",
    "component"
];
const $2a6a1b32abb63d78$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $8PsT0.getTableBodyUtilityClass), classes);
};
const $2a6a1b32abb63d78$var$TableBodyRoot = (0, $71Pr4.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $2a6a1b32abb63d78$var$tablelvl2 = {
    variant: "body"
};
const $2a6a1b32abb63d78$var$defaultComponent = "tbody";
const $2a6a1b32abb63d78$var$TableBody = /*#__PURE__*/ $70fFQ.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $2a6a1b32abb63d78$var$defaultComponent } = props, other = (0, $79yYo.default)(props, $2a6a1b32abb63d78$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component
    });
    const classes = $2a6a1b32abb63d78$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fev83.default).Provider, {
        value: $2a6a1b32abb63d78$var$tablelvl2,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($2a6a1b32abb63d78$var$TableBodyRoot, (0, $20MOv.default)({
            className: (0, $gjktY.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $2a6a1b32abb63d78$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $2a6a1b32abb63d78$export$2e2bcd8739ae039 = $2a6a1b32abb63d78$var$TableBody;

});
parcelRegister("fev83", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1704f6105d15e5a$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 */ const $b1704f6105d15e5a$var$Tablelvl2Context = /*#__PURE__*/ $70fFQ.createContext();
var $b1704f6105d15e5a$export$2e2bcd8739ae039 = $b1704f6105d15e5a$var$Tablelvl2Context;

});

parcelRegister("8PsT0", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", function () { return $66d97e554d6b2ce9$export$98bd2a9b566ec665; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $66d97e554d6b2ce9$export$98bd2a9b566ec665(slot) {
    return (0, $dtsUs.default)("MuiTableBody", slot);
}
const $66d97e554d6b2ce9$var$tableBodyClasses = (0, $jLqVN.default)("MuiTableBody", [
    "root"
]);
var $66d97e554d6b2ce9$export$2e2bcd8739ae039 = $66d97e554d6b2ce9$var$tableBodyClasses;

});


parcelRegister("c9kiU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d86133fe7e20ab5$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $aAAPW = parcelRequire("aAAPW");

var $emD5C = parcelRequire("emD5C");

var $fev83 = parcelRequire("fev83");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $9SWzT = parcelRequire("9SWzT");

var $4x3bm = parcelRequire("4x3bm");
const $8d86133fe7e20ab5$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $8d86133fe7e20ab5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $aAAPW.default)(align)}`,
            padding !== "normal" && `padding${(0, $aAAPW.default)(padding)}`,
            `size${(0, $aAAPW.default)(size)}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $9SWzT.getTableCellUtilityClass), classes);
};
const $8d86133fe7e20ab5$var$TableCellRoot = (0, $71Pr4.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $aAAPW.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $aAAPW.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $aAAPW.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: `1px solid
    ${theme.palette.mode === "light" ? (0, $bFVgt.lighten)((0, $bFVgt.alpha)(theme.palette.divider, 1), 0.88) : (0, $bFVgt.darken)((0, $bFVgt.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: theme.palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: theme.palette.text.primary
    }, ownerState.variant === "footer" && {
        color: theme.palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $9SWzT.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: theme.palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $8d86133fe7e20ab5$var$TableCell = /*#__PURE__*/ $70fFQ.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $79yYo.default)(props, $8d86133fe7e20ab5$var$_excluded);
    const table = $70fFQ.useContext((0, $emD5C.default));
    const tablelvl2 = $70fFQ.useContext((0, $fev83.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $20MOv.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $8d86133fe7e20ab5$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $4x3bm.jsx)($8d86133fe7e20ab5$var$TableCellRoot, (0, $20MOv.default)({
        as: component,
        ref: ref,
        className: (0, $gjktY.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $8d86133fe7e20ab5$export$2e2bcd8739ae039 = $8d86133fe7e20ab5$var$TableCell;

});
parcelRegister("9SWzT", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", function () { return $73269893c4feb8b6$export$33a0f07a16a10b1b; });
$parcel$export(module.exports, "default", function () { return $73269893c4feb8b6$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $73269893c4feb8b6$export$33a0f07a16a10b1b(slot) {
    return (0, $dtsUs.default)("MuiTableCell", slot);
}
const $73269893c4feb8b6$var$tableCellClasses = (0, $jLqVN.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $73269893c4feb8b6$export$2e2bcd8739ae039 = $73269893c4feb8b6$var$tableCellClasses;

});


parcelRegister("iTwQr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc16d75eb90398a9$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $hJG0x = parcelRequire("hJG0x");

var $4x3bm = parcelRequire("4x3bm");
const $dc16d75eb90398a9$var$_excluded = [
    "className",
    "component"
];
const $dc16d75eb90398a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $hJG0x.getTableContainerUtilityClass), classes);
};
const $dc16d75eb90398a9$var$TableContainerRoot = (0, $71Pr4.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: "100%",
    overflowX: "auto"
});
const $dc16d75eb90398a9$var$TableContainer = /*#__PURE__*/ $70fFQ.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTableContainer"
    });
    const { className: className, component: component = "div" } = props, other = (0, $79yYo.default)(props, $dc16d75eb90398a9$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component
    });
    const classes = $dc16d75eb90398a9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($dc16d75eb90398a9$var$TableContainerRoot, (0, $20MOv.default)({
        ref: ref,
        as: component,
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $dc16d75eb90398a9$export$2e2bcd8739ae039 = $dc16d75eb90398a9$var$TableContainer;

});
parcelRegister("hJG0x", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", function () { return $ce9739799f2a4747$export$eed427986a7abdf9; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $ce9739799f2a4747$export$eed427986a7abdf9(slot) {
    return (0, $dtsUs.default)("MuiTableContainer", slot);
}
const $ce9739799f2a4747$var$tableContainerClasses = (0, $jLqVN.default)("MuiTableContainer", [
    "root"
]);
var $ce9739799f2a4747$export$2e2bcd8739ae039 = $ce9739799f2a4747$var$tableContainerClasses;

});


parcelRegister("bOUdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89aff84c5eadcc5a$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $fev83 = parcelRequire("fev83");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $3RTSG = parcelRequire("3RTSG");

var $4x3bm = parcelRequire("4x3bm");
const $89aff84c5eadcc5a$var$_excluded = [
    "className",
    "component"
];
const $89aff84c5eadcc5a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $3RTSG.getTableHeadUtilityClass), classes);
};
const $89aff84c5eadcc5a$var$TableHeadRoot = (0, $71Pr4.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $89aff84c5eadcc5a$var$tablelvl2 = {
    variant: "head"
};
const $89aff84c5eadcc5a$var$defaultComponent = "thead";
const $89aff84c5eadcc5a$var$TableHead = /*#__PURE__*/ $70fFQ.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $89aff84c5eadcc5a$var$defaultComponent } = props, other = (0, $79yYo.default)(props, $89aff84c5eadcc5a$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component
    });
    const classes = $89aff84c5eadcc5a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fev83.default).Provider, {
        value: $89aff84c5eadcc5a$var$tablelvl2,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($89aff84c5eadcc5a$var$TableHeadRoot, (0, $20MOv.default)({
            as: component,
            className: (0, $gjktY.default)(classes.root, className),
            ref: ref,
            role: component === $89aff84c5eadcc5a$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $89aff84c5eadcc5a$export$2e2bcd8739ae039 = $89aff84c5eadcc5a$var$TableHead;

});
parcelRegister("3RTSG", function(module, exports) {

$parcel$export(module.exports, "getTableHeadUtilityClass", function () { return $2d11ab2614ff113a$export$2e731cea2d1c2392; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $2d11ab2614ff113a$export$2e731cea2d1c2392(slot) {
    return (0, $dtsUs.default)("MuiTableHead", slot);
}
const $2d11ab2614ff113a$var$tableHeadClasses = (0, $jLqVN.default)("MuiTableHead", [
    "root"
]);
var $2d11ab2614ff113a$export$2e2bcd8739ae039 = $2d11ab2614ff113a$var$tableHeadClasses;

});


parcelRegister("8Hhl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $654fc9caf3e1b5df$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $fev83 = parcelRequire("fev83");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $5ZAet = parcelRequire("5ZAet");

var $4x3bm = parcelRequire("4x3bm");
const $654fc9caf3e1b5df$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $654fc9caf3e1b5df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $5ZAet.getTableRowUtilityClass), classes);
};
const $654fc9caf3e1b5df$var$TableRowRoot = (0, $71Pr4.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $5ZAet.default).hover}:hover`]: {
            backgroundColor: theme.palette.action.hover
        },
        [`&.${(0, $5ZAet.default).selected}`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $654fc9caf3e1b5df$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $654fc9caf3e1b5df$var$TableRow = /*#__PURE__*/ $70fFQ.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $654fc9caf3e1b5df$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $79yYo.default)(props, $654fc9caf3e1b5df$var$_excluded);
    const tablelvl2 = $70fFQ.useContext((0, $fev83.default));
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $654fc9caf3e1b5df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($654fc9caf3e1b5df$var$TableRowRoot, (0, $20MOv.default)({
        as: component,
        ref: ref,
        className: (0, $gjktY.default)(classes.root, className),
        role: component === $654fc9caf3e1b5df$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $654fc9caf3e1b5df$export$2e2bcd8739ae039 = $654fc9caf3e1b5df$var$TableRow;

});
parcelRegister("5ZAet", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", function () { return $45cec142faea5d00$export$ba0a6d6c28940107; });
$parcel$export(module.exports, "default", function () { return $45cec142faea5d00$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $45cec142faea5d00$export$ba0a6d6c28940107(slot) {
    return (0, $dtsUs.default)("MuiTableRow", slot);
}
const $45cec142faea5d00$var$tableRowClasses = (0, $jLqVN.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $45cec142faea5d00$export$2e2bcd8739ae039 = $45cec142faea5d00$var$tableRowClasses;

});


parcelRegister("lzkmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb3caa28ac8f2b64$export$2e2bcd8739ae039; });
// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/pie

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $iRxU6 = parcelRequire("iRxU6");

var $3fLZ2 = parcelRequire("3fLZ2");

var $1mImZ = parcelRequire("1mImZ");

var $27ZKj = parcelRequire("27ZKj");
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const $fb3caa28ac8f2b64$var$PieChart = ({ data: data, enableArcLinkLabels: enableArcLinkLabels = false })=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $iRxU6.ResponsivePie), {
        theme: {
            fontFamily: "Roboto"
        },
        tooltip: ({ datum: datum })=>{
            return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $1mImZ.default), {
                    style: {
                        padding: 16,
                        display: "inline-flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3fLZ2.default), {
                            sx: {
                                bgcolor: datum.color,
                                width: 24,
                                height: 24
                            },
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                            style: {
                                marginLeft: 16,
                                fontSize: 12,
                                textAlign: "left"
                            },
                            variant: "body1",
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)("b", {
                                    children: datum.label
                                }),
                                " ",
                                datum.value,
                                "%"
                            ]
                        })
                    ]
                })
            });
        },
        data: data,
        margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        innerRadius: 0.8,
        padAngle: 3,
        cornerRadius: 0,
        activeOuterRadiusOffset: 8,
        borderWidth: 0,
        arcLabelsRadiusOffset: 3,
        colors: {
            datum: "data.color"
        },
        // arcLinkLabel={arcLabel}
        borderColor: {
            from: "color",
            modifiers: [
                [
                    "darker",
                    0.2
                ]
            ]
        },
        arcLinkLabelsSkipAngle: 10,
        arcLinkLabelsTextColor: "#333333",
        arcLinkLabelsThickness: 2,
        arcLinkLabelsColor: {
            from: "color"
        },
        arcLabelsSkipAngle: 10,
        arcLabel: null,
        enableArcLinkLabels: enableArcLinkLabels,
        arcLabelsTextColor: {
            from: "color",
            modifiers: [
                [
                    "darker",
                    2
                ]
            ]
        }
    });
var $fb3caa28ac8f2b64$export$2e2bcd8739ae039 = $fb3caa28ac8f2b64$var$PieChart;

});
parcelRegister("iRxU6", function(module, exports) {

$parcel$export(module.exports, "ResponsivePie", function () { return $dbb779dc1a24301b$export$7da90bf8925efdaf; });

var $70fFQ = parcelRequire("70fFQ");

var $2qXGl = parcelRequire("2qXGl");

var $9PQlg = parcelRequire("9PQlg");

var $fpOVP = parcelRequire("fpOVP");

var $4x3bm = parcelRequire("4x3bm");

var $b4aj1 = parcelRequire("b4aj1");

var $boipe = parcelRequire("boipe");

var $lITvm = parcelRequire("lITvm");
function $dbb779dc1a24301b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dbb779dc1a24301b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dbb779dc1a24301b$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dbb779dc1a24301b$var$ownKeys(Object(source), true).forEach(function(key) {
            $dbb779dc1a24301b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dbb779dc1a24301b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dbb779dc1a24301b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dbb779dc1a24301b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dbb779dc1a24301b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $dbb779dc1a24301b$var$PieLegends = function PieLegends(_ref) {
    var width = _ref.width, height = _ref.height, legends = _ref.legends, data = _ref.data, toggleSerie = _ref.toggleSerie;
    return (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
        children: legends.map(function(legend, i) {
            var _legend$data;
            return (0, $4x3bm.jsx)((0, $fpOVP.BoxLegendSvg), $dbb779dc1a24301b$var$_objectSpread2($dbb779dc1a24301b$var$_objectSpread2({}, legend), {}, {
                containerWidth: width,
                containerHeight: height,
                data: (_legend$data = legend.data) !== null && _legend$data !== void 0 ? _legend$data : data,
                toggleSerie: legend.toggleSerie ? toggleSerie : undefined
            }), i);
        })
    });
};
function $dbb779dc1a24301b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dbb779dc1a24301b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dbb779dc1a24301b$var$_arrayLikeToArray(arr);
}
function $dbb779dc1a24301b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $dbb779dc1a24301b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dbb779dc1a24301b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dbb779dc1a24301b$var$_arrayLikeToArray(o, minLen);
}
function $dbb779dc1a24301b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dbb779dc1a24301b$var$_toConsumableArray(arr) {
    return $dbb779dc1a24301b$var$_arrayWithoutHoles(arr) || $dbb779dc1a24301b$var$_iterableToArray(arr) || $dbb779dc1a24301b$var$_unsupportedIterableToArray(arr) || $dbb779dc1a24301b$var$_nonIterableSpread();
}
function $dbb779dc1a24301b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dbb779dc1a24301b$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $dbb779dc1a24301b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dbb779dc1a24301b$var$_slicedToArray(arr, i) {
    return $dbb779dc1a24301b$var$_arrayWithHoles(arr) || $dbb779dc1a24301b$var$_iterableToArrayLimit(arr, i) || $dbb779dc1a24301b$var$_unsupportedIterableToArray(arr, i) || $dbb779dc1a24301b$var$_nonIterableRest();
}
var $dbb779dc1a24301b$var$PieTooltip = function PieTooltip(_ref) {
    var datum = _ref.datum;
    return (0, $4x3bm.jsx)((0, $lITvm.BasicTooltip), {
        id: datum.id,
        value: datum.formattedValue,
        enableChip: true,
        color: datum.color
    });
};
var $dbb779dc1a24301b$var$_window$devicePixelRa;
var $dbb779dc1a24301b$export$9c21a3269931e1e6 = {
    id: "id",
    value: "value",
    sortByValue: false,
    innerRadius: 0,
    padAngle: 0,
    cornerRadius: 0,
    layers: [
        "arcLinkLabels",
        "arcs",
        "arcLabels",
        "legends"
    ],
    startAngle: 0,
    endAngle: 360,
    fit: true,
    activeInnerRadiusOffset: 0,
    activeOuterRadiusOffset: 0,
    borderWidth: 0,
    borderColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                1
            ]
        ]
    },
    enableArcLabels: true,
    arcLabel: "formattedValue",
    arcLabelsSkipAngle: 0,
    arcLabelsRadiusOffset: 0.5,
    arcLabelsTextColor: {
        theme: "labels.text.fill"
    },
    enableArcLinkLabels: true,
    arcLinkLabel: "id",
    arcLinkLabelsSkipAngle: 0,
    arcLinkLabelsOffset: 0,
    arcLinkLabelsDiagonalLength: 16,
    arcLinkLabelsStraightLength: 24,
    arcLinkLabelsThickness: 1,
    arcLinkLabelsTextOffset: 6,
    arcLinkLabelsTextColor: {
        theme: "labels.text.fill"
    },
    arcLinkLabelsColor: {
        theme: "axis.ticks.line.stroke"
    },
    colors: {
        scheme: "nivo"
    },
    defs: [],
    fill: [],
    isInteractive: true,
    animate: true,
    motionConfig: "gentle",
    transitionMode: "innerRadius",
    tooltip: $dbb779dc1a24301b$var$PieTooltip,
    legends: [],
    role: "img",
    pixelRatio: typeof window !== "undefined" ? ($dbb779dc1a24301b$var$_window$devicePixelRa = window.devicePixelRatio) !== null && $dbb779dc1a24301b$var$_window$devicePixelRa !== void 0 ? $dbb779dc1a24301b$var$_window$devicePixelRa : 1 : 1
};
var $dbb779dc1a24301b$export$dcf407681f3a467d = function useNormalizedData(_ref) {
    var data = _ref.data, _ref$id = _ref.id, id = _ref$id === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.id : _ref$id, _ref$value = _ref.value, value = _ref$value === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.value : _ref$value, valueFormat = _ref.valueFormat, _ref$colors = _ref.colors, colors = _ref$colors === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.colors : _ref$colors;
    var getId = (0, $2qXGl.usePropertyAccessor)(id);
    var getValue = (0, $2qXGl.usePropertyAccessor)(value);
    var formatValue = (0, $2qXGl.useValueFormatter)(valueFormat);
    var getColor = (0, $boipe.useOrdinalColorScale)(colors, "id");
    return (0, $70fFQ.useMemo)(function() {
        return data.map(function(datum) {
            var _datum$label;
            var datumId = getId(datum);
            var datumValue = getValue(datum);
            var normalizedDatum = {
                id: datumId,
                label: (_datum$label = datum.label) !== null && _datum$label !== void 0 ? _datum$label : datumId,
                hidden: false,
                value: datumValue,
                formattedValue: formatValue(datumValue),
                data: datum
            };
            return $dbb779dc1a24301b$var$_objectSpread2($dbb779dc1a24301b$var$_objectSpread2({}, normalizedDatum), {}, {
                color: getColor(normalizedDatum)
            });
        });
    }, [
        data,
        getId,
        getValue,
        formatValue,
        getColor
    ]);
};
var $dbb779dc1a24301b$export$b3e3150fa43f236d = function usePieArcs(_ref2) {
    var data = _ref2.data, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, padAngle = _ref2.padAngle, sortByValue = _ref2.sortByValue, activeId = _ref2.activeId, activeInnerRadiusOffset = _ref2.activeInnerRadiusOffset, activeOuterRadiusOffset = _ref2.activeOuterRadiusOffset, hiddenIds = _ref2.hiddenIds;
    var pie$1 = (0, $70fFQ.useMemo)(function() {
        var innerPie = (0, $b4aj1.default)().value(function(d) {
            return d.value;
        }).startAngle((0, $2qXGl.degreesToRadians)(startAngle)).endAngle((0, $2qXGl.degreesToRadians)(endAngle)).padAngle((0, $2qXGl.degreesToRadians)(padAngle));
        if (!sortByValue) innerPie.sortValues(null);
        return innerPie;
    }, [
        startAngle,
        endAngle,
        padAngle,
        sortByValue
    ]);
    return (0, $70fFQ.useMemo)(function() {
        var hiddenData = data.filter(function(item) {
            return !hiddenIds.includes(item.id);
        });
        var dataWithArc = pie$1(hiddenData).map(function(arc) {
            var angle = Math.abs(arc.endAngle - arc.startAngle);
            return $dbb779dc1a24301b$var$_objectSpread2($dbb779dc1a24301b$var$_objectSpread2({}, arc.data), {}, {
                arc: {
                    index: arc.index,
                    startAngle: arc.startAngle,
                    endAngle: arc.endAngle,
                    innerRadius: activeId === arc.data.id ? innerRadius - activeInnerRadiusOffset : innerRadius,
                    outerRadius: activeId === arc.data.id ? outerRadius + activeOuterRadiusOffset : outerRadius,
                    thickness: outerRadius - innerRadius,
                    padAngle: arc.padAngle,
                    angle: angle,
                    angleDeg: (0, $2qXGl.radiansToDegrees)(angle)
                }
            });
        });
        var legendData = data.map(function(item) {
            return $dbb779dc1a24301b$var$_objectSpread2($dbb779dc1a24301b$var$_objectSpread2({}, item), {}, {
                hidden: hiddenIds.includes(item.id)
            });
        });
        return {
            dataWithArc: dataWithArc,
            legendData: legendData
        };
    }, [
        pie$1,
        data,
        hiddenIds,
        activeId,
        innerRadius,
        activeInnerRadiusOffset,
        outerRadius,
        activeOuterRadiusOffset
    ]);
};
var $dbb779dc1a24301b$export$2eb91d8e84ccbdd0 = function usePie(_ref3) {
    var data = _ref3.data, radius = _ref3.radius, innerRadius = _ref3.innerRadius, _ref3$startAngle = _ref3.startAngle, startAngle = _ref3$startAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.startAngle : _ref3$startAngle, _ref3$endAngle = _ref3.endAngle, endAngle = _ref3$endAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.endAngle : _ref3$endAngle, _ref3$padAngle = _ref3.padAngle, padAngle = _ref3$padAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.padAngle : _ref3$padAngle, _ref3$sortByValue = _ref3.sortByValue, sortByValue = _ref3$sortByValue === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.sortByValue : _ref3$sortByValue, _ref3$cornerRadius = _ref3.cornerRadius, cornerRadius = _ref3$cornerRadius === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.cornerRadius : _ref3$cornerRadius, _ref3$activeInnerRadi = _ref3.activeInnerRadiusOffset, activeInnerRadiusOffset = _ref3$activeInnerRadi === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeInnerRadiusOffset : _ref3$activeInnerRadi, _ref3$activeOuterRadi = _ref3.activeOuterRadiusOffset, activeOuterRadiusOffset = _ref3$activeOuterRadi === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeOuterRadiusOffset : _ref3$activeOuterRadi;
    var _useState = (0, $70fFQ.useState)(null), _useState2 = $dbb779dc1a24301b$var$_slicedToArray(_useState, 2), activeId = _useState2[0], setActiveId = _useState2[1];
    var _useState3 = (0, $70fFQ.useState)([]), _useState4 = $dbb779dc1a24301b$var$_slicedToArray(_useState3, 2), hiddenIds = _useState4[0], setHiddenIds = _useState4[1];
    var pieArcs = $dbb779dc1a24301b$export$b3e3150fa43f236d({
        data: data,
        startAngle: startAngle,
        endAngle: endAngle,
        innerRadius: innerRadius,
        outerRadius: radius,
        padAngle: padAngle,
        sortByValue: sortByValue,
        activeId: activeId,
        activeInnerRadiusOffset: activeInnerRadiusOffset,
        activeOuterRadiusOffset: activeOuterRadiusOffset,
        hiddenIds: hiddenIds
    });
    var toggleSerie = (0, $70fFQ.useCallback)(function(id) {
        setHiddenIds(function(state) {
            return state.indexOf(id) > -1 ? state.filter(function(item) {
                return item !== id;
            }) : [].concat($dbb779dc1a24301b$var$_toConsumableArray(state), [
                id
            ]);
        });
    }, []);
    var arcGenerator = (0, $9PQlg.useArcGenerator)({
        cornerRadius: cornerRadius,
        padAngle: (0, $2qXGl.degreesToRadians)(padAngle)
    });
    return $dbb779dc1a24301b$var$_objectSpread2($dbb779dc1a24301b$var$_objectSpread2({}, pieArcs), {}, {
        arcGenerator: arcGenerator,
        setActiveId: setActiveId,
        toggleSerie: toggleSerie
    });
};
var $dbb779dc1a24301b$export$eae94ae087ae8903 = function usePieFromBox(_ref4) {
    var data = _ref4.data, width = _ref4.width, height = _ref4.height, _ref4$innerRadius = _ref4.innerRadius, innerRadiusRatio = _ref4$innerRadius === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.innerRadius : _ref4$innerRadius, _ref4$startAngle = _ref4.startAngle, startAngle = _ref4$startAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.startAngle : _ref4$startAngle, _ref4$endAngle = _ref4.endAngle, endAngle = _ref4$endAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.endAngle : _ref4$endAngle, _ref4$padAngle = _ref4.padAngle, padAngle = _ref4$padAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.padAngle : _ref4$padAngle, _ref4$sortByValue = _ref4.sortByValue, sortByValue = _ref4$sortByValue === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.sortByValue : _ref4$sortByValue, _ref4$cornerRadius = _ref4.cornerRadius, cornerRadius = _ref4$cornerRadius === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.cornerRadius : _ref4$cornerRadius, _ref4$fit = _ref4.fit, fit = _ref4$fit === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.fit : _ref4$fit, _ref4$activeInnerRadi = _ref4.activeInnerRadiusOffset, activeInnerRadiusOffset = _ref4$activeInnerRadi === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeInnerRadiusOffset : _ref4$activeInnerRadi, _ref4$activeOuterRadi = _ref4.activeOuterRadiusOffset, activeOuterRadiusOffset = _ref4$activeOuterRadi === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeOuterRadiusOffset : _ref4$activeOuterRadi;
    var _useState5 = (0, $70fFQ.useState)(null), _useState6 = $dbb779dc1a24301b$var$_slicedToArray(_useState5, 2), activeId = _useState6[0], setActiveId = _useState6[1];
    var _useState7 = (0, $70fFQ.useState)([]), _useState8 = $dbb779dc1a24301b$var$_slicedToArray(_useState7, 2), hiddenIds = _useState8[0], setHiddenIds = _useState8[1];
    var computedProps = (0, $70fFQ.useMemo)(function() {
        var radius = Math.min(width, height) / 2;
        var innerRadius = radius * Math.min(innerRadiusRatio, 1);
        var centerX = width / 2;
        var centerY = height / 2;
        var boundingBox;
        if (fit) {
            var _computeArcBoundingBo = (0, $9PQlg.computeArcBoundingBox)(centerX, centerY, radius, startAngle - 90, endAngle - 90), points = _computeArcBoundingBo.points, box = $dbb779dc1a24301b$var$_objectWithoutProperties(_computeArcBoundingBo, [
                "points"
            ]);
            var ratio = Math.min(width / box.width, height / box.height);
            var adjustedBox = {
                width: box.width * ratio,
                height: box.height * ratio
            };
            adjustedBox.x = (width - adjustedBox.width) / 2;
            adjustedBox.y = (height - adjustedBox.height) / 2;
            centerX = (centerX - box.x) / box.width * box.width * ratio + adjustedBox.x;
            centerY = (centerY - box.y) / box.height * box.height * ratio + adjustedBox.y;
            boundingBox = {
                box: box,
                ratio: ratio,
                points: points
            };
            radius = radius * ratio;
            innerRadius = innerRadius * ratio;
        }
        return {
            centerX: centerX,
            centerY: centerY,
            radius: radius,
            innerRadius: innerRadius,
            debug: boundingBox
        };
    }, [
        width,
        height,
        innerRadiusRatio,
        startAngle,
        endAngle,
        fit,
        cornerRadius
    ]);
    var pieArcs = $dbb779dc1a24301b$export$b3e3150fa43f236d({
        data: data,
        startAngle: startAngle,
        endAngle: endAngle,
        innerRadius: computedProps.innerRadius,
        outerRadius: computedProps.radius,
        padAngle: padAngle,
        sortByValue: sortByValue,
        activeId: activeId,
        activeInnerRadiusOffset: activeInnerRadiusOffset,
        activeOuterRadiusOffset: activeOuterRadiusOffset,
        hiddenIds: hiddenIds
    });
    var toggleSerie = (0, $70fFQ.useCallback)(function(id) {
        setHiddenIds(function(state) {
            return state.indexOf(id) > -1 ? state.filter(function(item) {
                return item !== id;
            }) : [].concat($dbb779dc1a24301b$var$_toConsumableArray(state), [
                id
            ]);
        });
    }, []);
    var arcGenerator = (0, $9PQlg.useArcGenerator)({
        cornerRadius: cornerRadius,
        padAngle: (0, $2qXGl.degreesToRadians)(padAngle)
    });
    return $dbb779dc1a24301b$var$_objectSpread2($dbb779dc1a24301b$var$_objectSpread2({
        arcGenerator: arcGenerator,
        setActiveId: setActiveId,
        toggleSerie: toggleSerie
    }, pieArcs), computedProps);
};
var $dbb779dc1a24301b$export$f0ce867b70c00d2a = function usePieLayerContext(_ref5) {
    var dataWithArc = _ref5.dataWithArc, arcGenerator = _ref5.arcGenerator, centerX = _ref5.centerX, centerY = _ref5.centerY, radius = _ref5.radius, innerRadius = _ref5.innerRadius;
    return (0, $70fFQ.useMemo)(function() {
        return {
            dataWithArc: dataWithArc,
            arcGenerator: arcGenerator,
            centerX: centerX,
            centerY: centerY,
            radius: radius,
            innerRadius: innerRadius
        };
    }, [
        dataWithArc,
        arcGenerator,
        centerX,
        centerY,
        radius,
        innerRadius
    ]);
};
var $dbb779dc1a24301b$var$Arcs = function Arcs(_ref) {
    var center = _ref.center, data = _ref.data, arcGenerator = _ref.arcGenerator, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor, isInteractive = _ref.isInteractive, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseMove = _ref.onMouseMove, onMouseLeave = _ref.onMouseLeave, setActiveId = _ref.setActiveId, tooltip = _ref.tooltip, transitionMode = _ref.transitionMode;
    var _useTooltip = (0, $lITvm.useTooltip)(), showTooltipFromEvent = _useTooltip.showTooltipFromEvent, hideTooltip = _useTooltip.hideTooltip;
    var handleClick = (0, $70fFQ.useMemo)(function() {
        if (!isInteractive) return undefined;
        return function(datum, event) {
            onClick === null || onClick === void 0 || onClick(datum, event);
        };
    }, [
        isInteractive,
        onClick
    ]);
    var handleMouseEnter = (0, $70fFQ.useMemo)(function() {
        if (!isInteractive) return undefined;
        return function(datum, event) {
            showTooltipFromEvent((0, $70fFQ.createElement)(tooltip, {
                datum: datum
            }), event);
            setActiveId(datum.id);
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter(datum, event);
        };
    }, [
        isInteractive,
        showTooltipFromEvent,
        setActiveId,
        onMouseEnter
    ]);
    var handleMouseMove = (0, $70fFQ.useMemo)(function() {
        if (!isInteractive) return undefined;
        return function(datum, event) {
            showTooltipFromEvent((0, $70fFQ.createElement)(tooltip, {
                datum: datum
            }), event);
            onMouseMove === null || onMouseMove === void 0 || onMouseMove(datum, event);
        };
    }, [
        isInteractive,
        showTooltipFromEvent,
        onMouseMove
    ]);
    var handleMouseLeave = (0, $70fFQ.useMemo)(function() {
        if (!isInteractive) return undefined;
        return function(datum, event) {
            hideTooltip();
            setActiveId(null);
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave(datum, event);
        };
    }, [
        isInteractive,
        hideTooltip,
        setActiveId,
        onMouseLeave
    ]);
    return (0, $4x3bm.jsx)((0, $9PQlg.ArcsLayer), {
        center: center,
        data: data,
        arcGenerator: arcGenerator,
        borderWidth: borderWidth,
        borderColor: borderColor,
        transitionMode: transitionMode,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseMove: handleMouseMove,
        onMouseLeave: handleMouseLeave
    });
};
var $dbb779dc1a24301b$var$InnerPie = function InnerPie(_ref) {
    var data = _ref.data, _ref$id = _ref.id, id = _ref$id === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.id : _ref$id, _ref$value = _ref.value, value = _ref$value === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.value : _ref$value, valueFormat = _ref.valueFormat, _ref$sortByValue = _ref.sortByValue, sortByValue = _ref$sortByValue === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.sortByValue : _ref$sortByValue, _ref$layers = _ref.layers, layers = _ref$layers === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.layers : _ref$layers, _ref$startAngle = _ref.startAngle, startAngle = _ref$startAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.startAngle : _ref$startAngle, _ref$endAngle = _ref.endAngle, endAngle = _ref$endAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.endAngle : _ref$endAngle, _ref$padAngle = _ref.padAngle, padAngle = _ref$padAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.padAngle : _ref$padAngle, _ref$fit = _ref.fit, fit = _ref$fit === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.fit : _ref$fit, _ref$innerRadius = _ref.innerRadius, innerRadiusRatio = _ref$innerRadius === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.innerRadius : _ref$innerRadius, _ref$cornerRadius = _ref.cornerRadius, cornerRadius = _ref$cornerRadius === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.cornerRadius : _ref$cornerRadius, _ref$activeInnerRadiu = _ref.activeInnerRadiusOffset, activeInnerRadiusOffset = _ref$activeInnerRadiu === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeInnerRadiusOffset : _ref$activeInnerRadiu, _ref$activeOuterRadiu = _ref.activeOuterRadiusOffset, activeOuterRadiusOffset = _ref$activeOuterRadiu === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeOuterRadiusOffset : _ref$activeOuterRadiu, width = _ref.width, height = _ref.height, partialMargin = _ref.margin, _ref$colors = _ref.colors, colors = _ref$colors === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.colors : _ref$colors, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.borderWidth : _ref$borderWidth, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.borderColor : _ref$borderColor, _ref$enableArcLabels = _ref.enableArcLabels, enableArcLabels = _ref$enableArcLabels === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.enableArcLabels : _ref$enableArcLabels, _ref$arcLabel = _ref.arcLabel, arcLabel = _ref$arcLabel === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabel : _ref$arcLabel, _ref$arcLabelsSkipAng = _ref.arcLabelsSkipAngle, arcLabelsSkipAngle = _ref$arcLabelsSkipAng === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabelsSkipAngle : _ref$arcLabelsSkipAng, _ref$arcLabelsTextCol = _ref.arcLabelsTextColor, arcLabelsTextColor = _ref$arcLabelsTextCol === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabelsTextColor : _ref$arcLabelsTextCol, _ref$arcLabelsRadiusO = _ref.arcLabelsRadiusOffset, arcLabelsRadiusOffset = _ref$arcLabelsRadiusO === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabelsRadiusOffset : _ref$arcLabelsRadiusO, arcLabelsComponent = _ref.arcLabelsComponent, _ref$enableArcLinkLab = _ref.enableArcLinkLabels, enableArcLinkLabels = _ref$enableArcLinkLab === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.enableArcLinkLabels : _ref$enableArcLinkLab, _ref$arcLinkLabel = _ref.arcLinkLabel, arcLinkLabel = _ref$arcLinkLabel === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabel : _ref$arcLinkLabel, _ref$arcLinkLabelsSki = _ref.arcLinkLabelsSkipAngle, arcLinkLabelsSkipAngle = _ref$arcLinkLabelsSki === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsSkipAngle : _ref$arcLinkLabelsSki, _ref$arcLinkLabelsOff = _ref.arcLinkLabelsOffset, arcLinkLabelsOffset = _ref$arcLinkLabelsOff === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsOffset : _ref$arcLinkLabelsOff, _ref$arcLinkLabelsDia = _ref.arcLinkLabelsDiagonalLength, arcLinkLabelsDiagonalLength = _ref$arcLinkLabelsDia === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsDiagonalLength : _ref$arcLinkLabelsDia, _ref$arcLinkLabelsStr = _ref.arcLinkLabelsStraightLength, arcLinkLabelsStraightLength = _ref$arcLinkLabelsStr === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsStraightLength : _ref$arcLinkLabelsStr, _ref$arcLinkLabelsThi = _ref.arcLinkLabelsThickness, arcLinkLabelsThickness = _ref$arcLinkLabelsThi === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsThickness : _ref$arcLinkLabelsThi, _ref$arcLinkLabelsTex = _ref.arcLinkLabelsTextOffset, arcLinkLabelsTextOffset = _ref$arcLinkLabelsTex === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsTextOffset : _ref$arcLinkLabelsTex, _ref$arcLinkLabelsTex2 = _ref.arcLinkLabelsTextColor, arcLinkLabelsTextColor = _ref$arcLinkLabelsTex2 === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsTextColor : _ref$arcLinkLabelsTex2, _ref$arcLinkLabelsCol = _ref.arcLinkLabelsColor, arcLinkLabelsColor = _ref$arcLinkLabelsCol === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsColor : _ref$arcLinkLabelsCol, arcLinkLabelComponent = _ref.arcLinkLabelComponent, _ref$defs = _ref.defs, defs = _ref$defs === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.defs : _ref$defs, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.fill : _ref$fill, _ref$isInteractive = _ref.isInteractive, isInteractive = _ref$isInteractive === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.isInteractive : _ref$isInteractive, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseMove = _ref.onMouseMove, onMouseLeave = _ref.onMouseLeave, _ref$tooltip = _ref.tooltip, tooltip = _ref$tooltip === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.tooltip : _ref$tooltip, _ref$transitionMode = _ref.transitionMode, transitionMode = _ref$transitionMode === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.transitionMode : _ref$transitionMode, _ref$legends = _ref.legends, legends = _ref$legends === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.legends : _ref$legends, _ref$role = _ref.role, role = _ref$role === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.role : _ref$role;
    var _useDimensions = (0, $2qXGl.useDimensions)(width, height, partialMargin), outerWidth = _useDimensions.outerWidth, outerHeight = _useDimensions.outerHeight, margin = _useDimensions.margin, innerWidth = _useDimensions.innerWidth, innerHeight = _useDimensions.innerHeight;
    var normalizedData = $dbb779dc1a24301b$export$dcf407681f3a467d({
        data: data,
        id: id,
        value: value,
        valueFormat: valueFormat,
        colors: colors
    });
    var _usePieFromBox = $dbb779dc1a24301b$export$eae94ae087ae8903({
        data: normalizedData,
        width: innerWidth,
        height: innerHeight,
        fit: fit,
        innerRadius: innerRadiusRatio,
        startAngle: startAngle,
        endAngle: endAngle,
        padAngle: padAngle,
        sortByValue: sortByValue,
        cornerRadius: cornerRadius,
        activeInnerRadiusOffset: activeInnerRadiusOffset,
        activeOuterRadiusOffset: activeOuterRadiusOffset
    }), dataWithArc = _usePieFromBox.dataWithArc, legendData = _usePieFromBox.legendData, arcGenerator = _usePieFromBox.arcGenerator, centerX = _usePieFromBox.centerX, centerY = _usePieFromBox.centerY, radius = _usePieFromBox.radius, innerRadius = _usePieFromBox.innerRadius, setActiveId = _usePieFromBox.setActiveId, toggleSerie = _usePieFromBox.toggleSerie;
    var boundDefs = (0, $2qXGl.bindDefs)(defs, dataWithArc, fill);
    var layerById = {
        arcLinkLabels: null,
        arcs: null,
        arcLabels: null,
        legends: null
    };
    if (enableArcLinkLabels && layers.includes("arcLinkLabels")) layerById.arcLinkLabels = (0, $4x3bm.jsx)((0, $9PQlg.ArcLinkLabelsLayer), {
        center: [
            centerX,
            centerY
        ],
        data: dataWithArc,
        label: arcLinkLabel,
        skipAngle: arcLinkLabelsSkipAngle,
        offset: arcLinkLabelsOffset,
        diagonalLength: arcLinkLabelsDiagonalLength,
        straightLength: arcLinkLabelsStraightLength,
        strokeWidth: arcLinkLabelsThickness,
        textOffset: arcLinkLabelsTextOffset,
        textColor: arcLinkLabelsTextColor,
        linkColor: arcLinkLabelsColor,
        component: arcLinkLabelComponent
    }, "arcLinkLabels");
    if (layers.includes("arcs")) layerById.arcs = (0, $4x3bm.jsx)($dbb779dc1a24301b$var$Arcs, {
        center: [
            centerX,
            centerY
        ],
        data: dataWithArc,
        arcGenerator: arcGenerator,
        borderWidth: borderWidth,
        borderColor: borderColor,
        isInteractive: isInteractive,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        setActiveId: setActiveId,
        tooltip: tooltip,
        transitionMode: transitionMode
    }, "arcs");
    if (enableArcLabels && layers.includes("arcLabels")) layerById.arcLabels = (0, $4x3bm.jsx)((0, $9PQlg.ArcLabelsLayer), {
        center: [
            centerX,
            centerY
        ],
        data: dataWithArc,
        label: arcLabel,
        radiusOffset: arcLabelsRadiusOffset,
        skipAngle: arcLabelsSkipAngle,
        textColor: arcLabelsTextColor,
        transitionMode: transitionMode,
        component: arcLabelsComponent
    }, "arcLabels");
    if (legends.length > 0 && layers.includes("legends")) layerById.legends = (0, $4x3bm.jsx)($dbb779dc1a24301b$var$PieLegends, {
        width: innerWidth,
        height: innerHeight,
        data: legendData,
        legends: legends,
        toggleSerie: toggleSerie
    }, "legends");
    var layerContext = $dbb779dc1a24301b$export$f0ce867b70c00d2a({
        dataWithArc: dataWithArc,
        arcGenerator: arcGenerator,
        centerX: centerX,
        centerY: centerY,
        radius: radius,
        innerRadius: innerRadius
    });
    return (0, $4x3bm.jsx)((0, $2qXGl.SvgWrapper), {
        width: outerWidth,
        height: outerHeight,
        margin: margin,
        defs: boundDefs,
        role: role,
        children: layers.map(function(layer, i) {
            if (layerById[layer] !== undefined) return layerById[layer];
            if (typeof layer === "function") return (0, $4x3bm.jsx)((0, $70fFQ.Fragment), {
                children: (0, $70fFQ.createElement)(layer, layerContext)
            }, i);
            return null;
        })
    });
};
var $dbb779dc1a24301b$export$2ae8800cf67c848c = function Pie(_ref2) {
    var _ref2$isInteractive = _ref2.isInteractive, isInteractive = _ref2$isInteractive === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.isInteractive : _ref2$isInteractive, _ref2$animate = _ref2.animate, animate = _ref2$animate === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.animate : _ref2$animate, _ref2$motionConfig = _ref2.motionConfig, motionConfig = _ref2$motionConfig === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.motionConfig : _ref2$motionConfig, theme = _ref2.theme, renderWrapper = _ref2.renderWrapper, otherProps = $dbb779dc1a24301b$var$_objectWithoutProperties(_ref2, [
        "isInteractive",
        "animate",
        "motionConfig",
        "theme",
        "renderWrapper"
    ]);
    return (0, $4x3bm.jsx)((0, $2qXGl.Container), {
        animate: animate,
        isInteractive: isInteractive,
        motionConfig: motionConfig,
        renderWrapper: renderWrapper,
        theme: theme,
        children: (0, $4x3bm.jsx)($dbb779dc1a24301b$var$InnerPie, $dbb779dc1a24301b$var$_objectSpread2({
            isInteractive: isInteractive
        }, otherProps))
    });
};
var $dbb779dc1a24301b$export$7da90bf8925efdaf = function ResponsivePie(props) {
    return (0, $4x3bm.jsx)((0, $2qXGl.ResponsiveWrapper), {
        children: function children(_ref) {
            var width = _ref.width, height = _ref.height;
            return (0, $4x3bm.jsx)($dbb779dc1a24301b$export$2ae8800cf67c848c, $dbb779dc1a24301b$var$_objectSpread2({
                width: width,
                height: height
            }, props));
        }
    });
};
var $dbb779dc1a24301b$var$InnerPieCanvas = function InnerPieCanvas(_ref) {
    var data = _ref.data, _ref$id = _ref.id, id = _ref$id === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.id : _ref$id, _ref$value = _ref.value, value = _ref$value === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.value : _ref$value, valueFormat = _ref.valueFormat, _ref$sortByValue = _ref.sortByValue, sortByValue = _ref$sortByValue === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.sortByValue : _ref$sortByValue, _ref$startAngle = _ref.startAngle, startAngle = _ref$startAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.startAngle : _ref$startAngle, _ref$endAngle = _ref.endAngle, endAngle = _ref$endAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.endAngle : _ref$endAngle, _ref$padAngle = _ref.padAngle, padAngle = _ref$padAngle === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.padAngle : _ref$padAngle, _ref$fit = _ref.fit, fit = _ref$fit === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.fit : _ref$fit, _ref$innerRadius = _ref.innerRadius, innerRadiusRatio = _ref$innerRadius === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.innerRadius : _ref$innerRadius, _ref$cornerRadius = _ref.cornerRadius, cornerRadius = _ref$cornerRadius === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.cornerRadius : _ref$cornerRadius, _ref$activeInnerRadiu = _ref.activeInnerRadiusOffset, activeInnerRadiusOffset = _ref$activeInnerRadiu === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeInnerRadiusOffset : _ref$activeInnerRadiu, _ref$activeOuterRadiu = _ref.activeOuterRadiusOffset, activeOuterRadiusOffset = _ref$activeOuterRadiu === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.activeOuterRadiusOffset : _ref$activeOuterRadiu, width = _ref.width, height = _ref.height, partialMargin = _ref.margin, _ref$pixelRatio = _ref.pixelRatio, pixelRatio = _ref$pixelRatio === void 0 ? 1 : _ref$pixelRatio, _ref$colors = _ref.colors, colors = _ref$colors === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.colors : _ref$colors, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.borderWidth : _ref$borderWidth, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.borderColor : _ref$borderColor, _ref$enableArcLabels = _ref.enableArcLabels, enableArcLabels = _ref$enableArcLabels === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.enableArcLabels : _ref$enableArcLabels, _ref$arcLabel = _ref.arcLabel, arcLabel = _ref$arcLabel === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabel : _ref$arcLabel, _ref$arcLabelsSkipAng = _ref.arcLabelsSkipAngle, arcLabelsSkipAngle = _ref$arcLabelsSkipAng === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabelsSkipAngle : _ref$arcLabelsSkipAng, _ref$arcLabelsTextCol = _ref.arcLabelsTextColor, arcLabelsTextColor = _ref$arcLabelsTextCol === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabelsTextColor : _ref$arcLabelsTextCol, _ref$arcLabelsRadiusO = _ref.arcLabelsRadiusOffset, arcLabelsRadiusOffset = _ref$arcLabelsRadiusO === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLabelsRadiusOffset : _ref$arcLabelsRadiusO, _ref$enableArcLinkLab = _ref.enableArcLinkLabels, enableArcLinkLabels = _ref$enableArcLinkLab === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.enableArcLinkLabels : _ref$enableArcLinkLab, _ref$arcLinkLabel = _ref.arcLinkLabel, arcLinkLabel = _ref$arcLinkLabel === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabel : _ref$arcLinkLabel, _ref$arcLinkLabelsSki = _ref.arcLinkLabelsSkipAngle, arcLinkLabelsSkipAngle = _ref$arcLinkLabelsSki === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsSkipAngle : _ref$arcLinkLabelsSki, _ref$arcLinkLabelsOff = _ref.arcLinkLabelsOffset, arcLinkLabelsOffset = _ref$arcLinkLabelsOff === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsOffset : _ref$arcLinkLabelsOff, _ref$arcLinkLabelsDia = _ref.arcLinkLabelsDiagonalLength, arcLinkLabelsDiagonalLength = _ref$arcLinkLabelsDia === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsDiagonalLength : _ref$arcLinkLabelsDia, _ref$arcLinkLabelsStr = _ref.arcLinkLabelsStraightLength, arcLinkLabelsStraightLength = _ref$arcLinkLabelsStr === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsStraightLength : _ref$arcLinkLabelsStr, _ref$arcLinkLabelsThi = _ref.arcLinkLabelsThickness, arcLinkLabelsThickness = _ref$arcLinkLabelsThi === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsThickness : _ref$arcLinkLabelsThi, _ref$arcLinkLabelsTex = _ref.arcLinkLabelsTextOffset, arcLinkLabelsTextOffset = _ref$arcLinkLabelsTex === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsTextOffset : _ref$arcLinkLabelsTex, _ref$arcLinkLabelsTex2 = _ref.arcLinkLabelsTextColor, arcLinkLabelsTextColor = _ref$arcLinkLabelsTex2 === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsTextColor : _ref$arcLinkLabelsTex2, _ref$arcLinkLabelsCol = _ref.arcLinkLabelsColor, arcLinkLabelsColor = _ref$arcLinkLabelsCol === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.arcLinkLabelsColor : _ref$arcLinkLabelsCol, _ref$isInteractive = _ref.isInteractive, isInteractive = _ref$isInteractive === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.isInteractive : _ref$isInteractive, onClick = _ref.onClick, onMouseMove = _ref.onMouseMove, _ref$tooltip = _ref.tooltip, tooltip = _ref$tooltip === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.tooltip : _ref$tooltip, _ref$legends = _ref.legends, legends = _ref$legends === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.legends : _ref$legends;
    var canvasEl = (0, $70fFQ.useRef)(null);
    var theme = (0, $2qXGl.useTheme)();
    var _useDimensions = (0, $2qXGl.useDimensions)(width, height, partialMargin), margin = _useDimensions.margin, innerWidth = _useDimensions.innerWidth, innerHeight = _useDimensions.innerHeight, outerWidth = _useDimensions.outerWidth, outerHeight = _useDimensions.outerHeight;
    var normalizedData = $dbb779dc1a24301b$export$dcf407681f3a467d({
        data: data,
        id: id,
        value: value,
        valueFormat: valueFormat,
        colors: colors
    });
    var _usePieFromBox = $dbb779dc1a24301b$export$eae94ae087ae8903({
        data: normalizedData,
        width: innerWidth,
        height: innerHeight,
        fit: fit,
        innerRadius: innerRadiusRatio,
        startAngle: startAngle,
        endAngle: endAngle,
        padAngle: padAngle,
        sortByValue: sortByValue,
        cornerRadius: cornerRadius,
        activeInnerRadiusOffset: activeInnerRadiusOffset,
        activeOuterRadiusOffset: activeOuterRadiusOffset
    }), dataWithArc = _usePieFromBox.dataWithArc, arcGenerator = _usePieFromBox.arcGenerator, centerX = _usePieFromBox.centerX, centerY = _usePieFromBox.centerY, radius = _usePieFromBox.radius, innerRadius = _usePieFromBox.innerRadius, setActiveId = _usePieFromBox.setActiveId;
    var getBorderColor = (0, $boipe.useInheritedColor)(borderColor, theme);
    var arcLabels = (0, $9PQlg.useArcLabels)({
        data: dataWithArc,
        label: arcLabel,
        skipAngle: arcLabelsSkipAngle,
        offset: arcLabelsRadiusOffset,
        textColor: arcLabelsTextColor
    });
    var arcLinkLabels = (0, $9PQlg.useArcLinkLabels)({
        data: dataWithArc,
        skipAngle: arcLinkLabelsSkipAngle,
        offset: arcLinkLabelsOffset,
        diagonalLength: arcLinkLabelsDiagonalLength,
        straightLength: arcLinkLabelsStraightLength,
        label: arcLinkLabel,
        linkColor: arcLinkLabelsColor,
        textOffset: arcLinkLabelsTextOffset,
        textColor: arcLinkLabelsTextColor
    });
    (0, $70fFQ.useEffect)(function() {
        if (!canvasEl.current) return;
        canvasEl.current.width = outerWidth * pixelRatio;
        canvasEl.current.height = outerHeight * pixelRatio;
        var ctx = canvasEl.current.getContext("2d");
        ctx.scale(pixelRatio, pixelRatio);
        ctx.fillStyle = theme.background;
        ctx.fillRect(0, 0, outerWidth, outerHeight);
        ctx.save();
        ctx.translate(margin.left, margin.top);
        arcGenerator.context(ctx);
        ctx.save();
        ctx.translate(centerX, centerY);
        dataWithArc.forEach(function(arc) {
            ctx.beginPath();
            ctx.fillStyle = arc.color;
            ctx.strokeStyle = getBorderColor(arc);
            ctx.lineWidth = borderWidth;
            arcGenerator(arc.arc);
            ctx.fill();
            if (borderWidth > 0) ctx.stroke();
        });
        if (enableArcLinkLabels === true) (0, $9PQlg.drawCanvasArcLinkLabels)(ctx, arcLinkLabels, theme, arcLinkLabelsThickness);
        if (enableArcLabels === true) (0, $9PQlg.drawCanvasArcLabels)(ctx, arcLabels, theme);
        ctx.restore();
        legends.forEach(function(legend) {
            (0, $fpOVP.renderLegendToCanvas)(ctx, $dbb779dc1a24301b$var$_objectSpread2($dbb779dc1a24301b$var$_objectSpread2({}, legend), {}, {
                data: dataWithArc,
                containerWidth: innerWidth,
                containerHeight: innerHeight,
                theme: theme
            }));
        });
    }, [
        canvasEl,
        innerWidth,
        innerHeight,
        outerWidth,
        outerHeight,
        margin.top,
        margin.left,
        pixelRatio,
        centerX,
        centerY,
        arcGenerator,
        dataWithArc,
        getBorderColor,
        enableArcLabels,
        arcLabels,
        enableArcLinkLabels,
        arcLinkLabels,
        arcLinkLabelsThickness,
        legends,
        theme
    ]);
    var arcs = (0, $70fFQ.useMemo)(function() {
        return dataWithArc.map(function(datum) {
            return $dbb779dc1a24301b$var$_objectSpread2({
                id: datum.id
            }, datum.arc);
        });
    }, [
        dataWithArc
    ]);
    var getArcFromMouse = function getArcFromMouse(event) {
        if (!canvasEl.current) return null;
        var _getRelativeCursor = (0, $2qXGl.getRelativeCursor)(canvasEl.current, event), _getRelativeCursor2 = $dbb779dc1a24301b$var$_slicedToArray(_getRelativeCursor, 2), x = _getRelativeCursor2[0], y = _getRelativeCursor2[1];
        var hoveredArc = (0, $9PQlg.findArcUnderCursor)(margin.left + centerX, margin.top + centerY, radius, innerRadius, arcs, x, y);
        if (!hoveredArc) return null;
        return dataWithArc.find(function(datum) {
            return datum.id === hoveredArc.id;
        });
    };
    var _useTooltip = (0, $lITvm.useTooltip)(), showTooltipFromEvent = _useTooltip.showTooltipFromEvent, hideTooltip = _useTooltip.hideTooltip;
    var handleMouseHover = function handleMouseHover(event) {
        var datum = getArcFromMouse(event);
        if (datum) {
            onMouseMove === null || onMouseMove === void 0 || onMouseMove(datum, event);
            setActiveId(datum.id);
            showTooltipFromEvent((0, $70fFQ.createElement)(tooltip, {
                datum: datum
            }), event);
        } else {
            setActiveId(null);
            hideTooltip();
        }
    };
    var handleMouseLeave = function handleMouseLeave() {
        hideTooltip();
    };
    var handleClick = function handleClick(event) {
        if (!onClick) return;
        var arc = getArcFromMouse(event);
        if (arc) onClick(arc, event);
    };
    return (0, $4x3bm.jsx)("canvas", {
        ref: canvasEl,
        width: outerWidth * pixelRatio,
        height: outerHeight * pixelRatio,
        style: {
            width: outerWidth,
            height: outerHeight,
            cursor: isInteractive ? "auto" : "normal"
        },
        onMouseEnter: isInteractive ? handleMouseHover : undefined,
        onMouseMove: isInteractive ? handleMouseHover : undefined,
        onMouseLeave: isInteractive ? handleMouseLeave : undefined,
        onClick: isInteractive ? handleClick : undefined
    });
};
var $dbb779dc1a24301b$export$62d6f587c9843e29 = function PieCanvas(_ref2) {
    var _ref2$isInteractive = _ref2.isInteractive, isInteractive = _ref2$isInteractive === void 0 ? $dbb779dc1a24301b$export$9c21a3269931e1e6.isInteractive : _ref2$isInteractive, theme = _ref2.theme, renderWrapper = _ref2.renderWrapper, otherProps = $dbb779dc1a24301b$var$_objectWithoutProperties(_ref2, [
        "isInteractive",
        "theme",
        "renderWrapper"
    ]);
    return (0, $4x3bm.jsx)((0, $2qXGl.Container), {
        isInteractive: isInteractive,
        renderWrapper: renderWrapper,
        theme: theme,
        children: (0, $4x3bm.jsx)($dbb779dc1a24301b$var$InnerPieCanvas, $dbb779dc1a24301b$var$_objectSpread2({
            isInteractive: isInteractive
        }, otherProps))
    });
};
var $dbb779dc1a24301b$export$b683bd2ce105ce17 = function ResponsivePieCanvas(props) {
    return (0, $4x3bm.jsx)((0, $2qXGl.ResponsiveWrapper), {
        children: function children(_ref) {
            var width = _ref.width, height = _ref.height;
            return (0, $4x3bm.jsx)($dbb779dc1a24301b$export$62d6f587c9843e29, $dbb779dc1a24301b$var$_objectSpread2({
                width: width,
                height: height
            }, props));
        }
    });
};

});
parcelRegister("2qXGl", function(module, exports) {

$parcel$export(module.exports, "motionPropTypes", function () { return $1c5c4e1a0d68bc50$export$99a092eaa44be1c8; });
$parcel$export(module.exports, "useMotionConfig", function () { return $1c5c4e1a0d68bc50$export$72acc3dc9629d75d; });
$parcel$export(module.exports, "useAnimatedPath", function () { return $1c5c4e1a0d68bc50$export$6b8391a1442f2172; });
$parcel$export(module.exports, "lineCurvePropType", function () { return $1c5c4e1a0d68bc50$export$b417d9aa8a99ac1a; });
$parcel$export(module.exports, "curveFromProp", function () { return $1c5c4e1a0d68bc50$export$99f526a753d63ebe; });
$parcel$export(module.exports, "defsPropTypes", function () { return $1c5c4e1a0d68bc50$export$395ebfe7dd3d9f57; });
$parcel$export(module.exports, "blendModePropType", function () { return $1c5c4e1a0d68bc50$export$6da2372f044c5e36; });
$parcel$export(module.exports, "useDimensions", function () { return $1c5c4e1a0d68bc50$export$d04af0e501fb729f; });
$parcel$export(module.exports, "useMeasure", function () { return $1c5c4e1a0d68bc50$export$e295b0c537d32d7d; });
$parcel$export(module.exports, "useValueFormatter", function () { return $1c5c4e1a0d68bc50$export$422f9765e6971fdf; });
$parcel$export(module.exports, "useTheme", function () { return $1c5c4e1a0d68bc50$export$93d4e7f90805808f; });
$parcel$export(module.exports, "Container", function () { return $1c5c4e1a0d68bc50$export$42a852a2b6b56249; });
$parcel$export(module.exports, "ResponsiveWrapper", function () { return $1c5c4e1a0d68bc50$export$fa6e408d6a7d6214; });
$parcel$export(module.exports, "degreesToRadians", function () { return $1c5c4e1a0d68bc50$export$c9fcf1a7df975d78; });
$parcel$export(module.exports, "radiansToDegrees", function () { return $1c5c4e1a0d68bc50$export$c41dd2a8460d3196; });
$parcel$export(module.exports, "midAngle", function () { return $1c5c4e1a0d68bc50$export$61f3799bad189d2e; });
$parcel$export(module.exports, "positionFromAngle", function () { return $1c5c4e1a0d68bc50$export$2e16b01652730550; });
$parcel$export(module.exports, "textPropsByEngine", function () { return $1c5c4e1a0d68bc50$export$1abb91cfca1e2069; });
$parcel$export(module.exports, "SvgWrapper", function () { return $1c5c4e1a0d68bc50$export$21d9f1931ef75b56; });
$parcel$export(module.exports, "DotsItem", function () { return $1c5c4e1a0d68bc50$export$ca30f0ad55489a87; });
$parcel$export(module.exports, "CartesianMarkers", function () { return $1c5c4e1a0d68bc50$export$81759e11f9e58ea4; });
$parcel$export(module.exports, "withContainer", function () { return $1c5c4e1a0d68bc50$export$4cbbe0314aa930ae; });
$parcel$export(module.exports, "getLabelGenerator", function () { return $1c5c4e1a0d68bc50$export$192dc59ac6f86c95; });
$parcel$export(module.exports, "usePropertyAccessor", function () { return $1c5c4e1a0d68bc50$export$2d590546cbb7e3ad; });
$parcel$export(module.exports, "getDistance", function () { return $1c5c4e1a0d68bc50$export$79376507b09a66f; });
$parcel$export(module.exports, "getAngle", function () { return $1c5c4e1a0d68bc50$export$b363da9ded343252; });
$parcel$export(module.exports, "isCursorInRect", function () { return $1c5c4e1a0d68bc50$export$be302859f014f482; });
$parcel$export(module.exports, "getRelativeCursor", function () { return $1c5c4e1a0d68bc50$export$2396fb9a7906fd81; });
$parcel$export(module.exports, "bindDefs", function () { return $1c5c4e1a0d68bc50$export$dc35cf769e3afe34; });

var $70fFQ = parcelRequire("70fFQ");

var $lITvm = parcelRequire("lITvm");

var $cd0Jr = parcelRequire("cd0Jr");

var $lldRo = parcelRequire("lldRo");

var $k561T = parcelRequire("k561T");

var $fD80G = parcelRequire("fD80G");

var $1BpPa = parcelRequire("1BpPa");

var $iPpol = parcelRequire("iPpol");
var $blk6s = parcelRequire("blk6s");

var $lBSSW = parcelRequire("lBSSW");

var $4x3bm = parcelRequire("4x3bm");

var $1NdVc = parcelRequire("1NdVc");

var $ioays = parcelRequire("ioays");

var $eZmYt = parcelRequire("eZmYt");
var $9MR7R = parcelRequire("9MR7R");
var $72ggJ = parcelRequire("72ggJ");

var $cpSH1 = parcelRequire("cpSH1");
var $fz4N9 = parcelRequire("fz4N9");
var $gt53g = parcelRequire("gt53g");
var $5Z16B = parcelRequire("5Z16B");
var $cwrJr = parcelRequire("cwrJr");
var $80FqD = parcelRequire("80FqD");
var $eN11p = parcelRequire("eN11p");
var $7hh3z = parcelRequire("7hh3z");
var $i74RE = parcelRequire("i74RE");
var $7oKHH = parcelRequire("7oKHH");
var $ll3aH = parcelRequire("ll3aH");
var $k90dT = parcelRequire("k90dT");
var $eqkbc = parcelRequire("eqkbc");
var $9kdQ2 = parcelRequire("9kdQ2");
var $75sQg = parcelRequire("75sQg");
var $j6d4T = parcelRequire("j6d4T");
var $3rkUU = parcelRequire("3rkUU");
var $2knla = parcelRequire("2knla");
var $b5AgS = parcelRequire("b5AgS");
var $deqjQ = parcelRequire("deqjQ");
var $n18IX = parcelRequire("n18IX");
var $2jgeQ = parcelRequire("2jgeQ");
var $6torH = parcelRequire("6torH");
var $7JT8F = parcelRequire("7JT8F");
var $grEAO = parcelRequire("grEAO");
var $5x0wB = parcelRequire("5x0wB");
var $7UdON = parcelRequire("7UdON");
var $gkCir = parcelRequire("gkCir");
var $bSpC5 = parcelRequire("bSpC5");
var $8ktkj = parcelRequire("8ktkj");
var $cMNJi = parcelRequire("cMNJi");
var $k8jNo = parcelRequire("k8jNo");
var $56l8W = parcelRequire("56l8W");
var $lXjI8 = parcelRequire("lXjI8");
var $1CkZa = parcelRequire("1CkZa");
var $7CLP4 = parcelRequire("7CLP4");
var $es2xN = parcelRequire("es2xN");
var $CgMhj = parcelRequire("CgMhj");
var $40aWI = parcelRequire("40aWI");
var $i3yYP = parcelRequire("i3yYP");

var $dC9tX = parcelRequire("dC9tX");

var $a8GNE = parcelRequire("a8GNE");

var $bnPpR = parcelRequire("bnPpR");
var $s34nM = parcelRequire("s34nM");
var $2bhQs = parcelRequire("2bhQs");
var $gy5kR = parcelRequire("gy5kR");
var $ez0Zd = parcelRequire("ez0Zd");
var $1qq3o = parcelRequire("1qq3o");
var $64Ae3 = parcelRequire("64Ae3");
var $aUWvE = parcelRequire("aUWvE");
var $6Ed0C = parcelRequire("6Ed0C");
var $hvYCW = parcelRequire("hvYCW");
var $ehI3a = parcelRequire("ehI3a");
var $8sVfw = parcelRequire("8sVfw");
var $9yRsK = parcelRequire("9yRsK");
var $k2x2n = parcelRequire("k2x2n");
var $4vuYI = parcelRequire("4vuYI");
var $dMc4H = parcelRequire("dMc4H");
var $8zZlU = parcelRequire("8zZlU");
var $cwhVc = parcelRequire("cwhVc");
var $gw7Hy = parcelRequire("gw7Hy");
var $66iM5 = parcelRequire("66iM5");
var $7hdUF = parcelRequire("7hdUF");
var $4Slcj = parcelRequire("4Slcj");
var $fGh8D = parcelRequire("fGh8D");
var $7aiBf = parcelRequire("7aiBf");
var $p47eF = parcelRequire("p47eF");

var $2yNl0 = parcelRequire("2yNl0");
var $7xMPq = parcelRequire("7xMPq");
var $SYRXa = parcelRequire("SYRXa");
var $cAlSl = parcelRequire("cAlSl");
var $2GHW9 = parcelRequire("2GHW9");
var $8eQwP = parcelRequire("8eQwP");

var $hjBRw = parcelRequire("hjBRw");

var $7pj3L = parcelRequire("7pj3L");

var $ejIWb = parcelRequire("ejIWb");

var $1sXdz = parcelRequire("1sXdz");

var $fnQSe = parcelRequire("fnQSe");

var $665Nt = parcelRequire("665Nt");
function $1c5c4e1a0d68bc50$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1c5c4e1a0d68bc50$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c5c4e1a0d68bc50$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1c5c4e1a0d68bc50$var$ownKeys(Object(source), true).forEach(function(key) {
            $1c5c4e1a0d68bc50$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1c5c4e1a0d68bc50$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $1c5c4e1a0d68bc50$var$textProps = {
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    fontFamily: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
};
var $1c5c4e1a0d68bc50$export$7c9b9140cfc20fb9 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    domain: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        line: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            stroke: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
            strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
            strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        }).isRequired
    }).isRequired,
    ticks: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        line: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            stroke: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
            strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
            strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        }).isRequired,
        text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps)).isRequired
    }).isRequired,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps)).isRequired
    }).isRequired
});
var $1c5c4e1a0d68bc50$export$f4dacb01e3bec6aa = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    line: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired
});
var $1c5c4e1a0d68bc50$export$5ce02678e5a3589b = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            fill: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
            opacity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
        }).isRequired,
        text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps), {}, {
            opacity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
        })).isRequired
    }).isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps)).isRequired
});
var $1c5c4e1a0d68bc50$export$6601ea7d14f6350c = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps)).isRequired
});
var $1c5c4e1a0d68bc50$export$eb57deacafb972d4 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps)).isRequired
});
var $1c5c4e1a0d68bc50$export$a02298887f2390f9 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps)).isRequired
});
var $1c5c4e1a0d68bc50$export$6c764636cab0210b = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    line: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    }).isRequired
});
var $1c5c4e1a0d68bc50$export$fd4544ad90251680 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$var$textProps), {}, {
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    })).isRequired,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }).isRequired,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }).isRequired,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        fill: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }).isRequired
});
var $1c5c4e1a0d68bc50$export$5d9ef733eb1e744b = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    background: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    fontFamily: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    axis: $1c5c4e1a0d68bc50$export$7c9b9140cfc20fb9.isRequired,
    grid: $1c5c4e1a0d68bc50$export$f4dacb01e3bec6aa.isRequired,
    legends: $1c5c4e1a0d68bc50$export$5ce02678e5a3589b.isRequired,
    labels: $1c5c4e1a0d68bc50$export$6601ea7d14f6350c.isRequired,
    dots: $1c5c4e1a0d68bc50$export$eb57deacafb972d4.isRequired,
    markers: $1c5c4e1a0d68bc50$export$a02298887f2390f9,
    crosshair: $1c5c4e1a0d68bc50$export$6c764636cab0210b.isRequired,
    annotations: $1c5c4e1a0d68bc50$export$fd4544ad90251680.isRequired
});
var $1c5c4e1a0d68bc50$export$164de7ab8df77ef0 = {
    background: "transparent",
    fontFamily: "sans-serif",
    fontSize: 11,
    textColor: "#333333",
    axis: {
        domain: {
            line: {
                stroke: "transparent",
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {}
        },
        legend: {
            text: {
                fontSize: 12
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        hidden: {
            symbol: {
                fill: "#333333",
                opacity: 0.6
            },
            text: {
                fill: "#333333",
                opacity: 0.6
            }
        },
        text: {}
    },
    labels: {
        text: {}
    },
    markers: {
        lineColor: "#000000",
        lineStrokeWidth: 1,
        text: {}
    },
    dots: {
        text: {}
    },
    tooltip: {
        container: {
            background: "white",
            color: "inherit",
            fontSize: "inherit",
            borderRadius: "2px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "5px 9px"
        },
        basic: {
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center"
        },
        chip: {
            marginRight: 7
        },
        table: {},
        tableCell: {
            padding: "3px 5px"
        },
        tableCellValue: {
            fontWeight: "bold"
        }
    },
    crosshair: {
        line: {
            stroke: "#000000",
            strokeWidth: 1,
            strokeOpacity: 0.75,
            strokeDasharray: "6 6"
        }
    },
    annotations: {
        text: {
            fontSize: 13,
            outlineWidth: 2,
            outlineColor: "#ffffff"
        },
        link: {
            stroke: "#000000",
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: "#ffffff"
        },
        outline: {
            fill: "none",
            stroke: "#000000",
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: "#ffffff"
        },
        symbol: {
            fill: "#000000",
            outlineWidth: 2,
            outlineColor: "#ffffff"
        }
    }
};
var $1c5c4e1a0d68bc50$var$fontProps = [
    "axis.ticks.text",
    "axis.legend.text",
    "legends.text",
    "labels.text",
    "dots.text",
    "markers.text",
    "annotations.text"
];
var $1c5c4e1a0d68bc50$export$582fa4e2a9b13dde = function extendDefaultTheme(defaultTheme, customTheme) {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($lldRo)))({}, defaultTheme, customTheme);
    $1c5c4e1a0d68bc50$var$fontProps.forEach(function(prop) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(theme, "".concat(prop, ".fontFamily")) === undefined) (0, (/*@__PURE__*/$parcel$interopDefault($fD80G)))(theme, "".concat(prop, ".fontFamily"), theme.fontFamily);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(theme, "".concat(prop, ".fontSize")) === undefined) (0, (/*@__PURE__*/$parcel$interopDefault($fD80G)))(theme, "".concat(prop, ".fontSize"), theme.fontSize);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(theme, "".concat(prop, ".fill")) === undefined) (0, (/*@__PURE__*/$parcel$interopDefault($fD80G)))(theme, "".concat(prop, ".fill"), theme.textColor);
    });
    return theme;
};
var $1c5c4e1a0d68bc50$export$1855e60b4fae8997 = (0, $70fFQ.createContext)();
var $1c5c4e1a0d68bc50$export$e9d875263f86dcb4 = function MotionConfigProvider(_ref) {
    var children = _ref.children, animate = _ref.animate, stiffness = _ref.stiffness, damping = _ref.damping, config$1 = _ref.config;
    var value = (0, $70fFQ.useMemo)(function() {
        var reactSpringConfig = (0, (/*@__PURE__*/$parcel$interopDefault($lBSSW)))(config$1) ? (0, $blk6s.config)[config$1] : config$1;
        return {
            animate: animate,
            springConfig: {
                stiffness: stiffness,
                damping: damping
            },
            config: reactSpringConfig
        };
    }, [
        animate,
        stiffness,
        damping,
        config$1
    ]);
    return (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$1855e60b4fae8997.Provider, {
        value: value,
        children: children
    });
};
var $1c5c4e1a0d68bc50$export$99a092eaa44be1c8 = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    motionStiffness: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    motionDamping: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf(Object.keys((0, $blk6s.config))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            mass: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            tension: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            friction: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            clamp: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
            precision: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            velocity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            duration: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            easing: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
        })
    ])
};
var $1c5c4e1a0d68bc50$export$465303079ec41f9d = {
    animate: true,
    stiffness: 90,
    damping: 15,
    config: "default"
};
$1c5c4e1a0d68bc50$export$e9d875263f86dcb4.defaultProps = $1c5c4e1a0d68bc50$export$465303079ec41f9d;
var $1c5c4e1a0d68bc50$export$72acc3dc9629d75d = function useMotionConfig() {
    return (0, $70fFQ.useContext)($1c5c4e1a0d68bc50$export$1855e60b4fae8997);
};
var $1c5c4e1a0d68bc50$var$usePrevious = function usePrevious(value) {
    var ref = (0, $70fFQ.useRef)();
    (0, $70fFQ.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
var $1c5c4e1a0d68bc50$export$6b8391a1442f2172 = function useAnimatedPath(path) {
    var _useMotionConfig = $1c5c4e1a0d68bc50$export$72acc3dc9629d75d(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var previousPath = $1c5c4e1a0d68bc50$var$usePrevious(path);
    var interpolator = (0, $70fFQ.useMemo)(function() {
        return (0, $1BpPa.default)(previousPath, path);
    }, [
        previousPath,
        path
    ]);
    var _useSpring = (0, $blk6s.useSpring)({
        from: {
            value: 0
        },
        to: {
            value: 1
        },
        reset: true,
        config: springConfig,
        immediate: !animate
    }), value = _useSpring.value;
    return (0, $blk6s.to)(value, interpolator);
};
var $1c5c4e1a0d68bc50$export$77ddf829b5125d20 = {
    nivo: [
        "#d76445",
        "#f47560",
        "#e8c1a0",
        "#97e3d5",
        "#61cdbb",
        "#00b0a7"
    ],
    BrBG: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $fz4N9.scheme)),
    PRGn: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $9kdQ2.scheme)),
    PiYG: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $eqkbc.scheme)),
    PuOr: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $3rkUU.scheme)),
    RdBu: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $deqjQ.scheme)),
    RdGy: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $n18IX.scheme)),
    RdYlBu: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $6torH.scheme)),
    RdYlGn: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $7JT8F.scheme)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $7UdON.scheme)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $cpSH1.scheme)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $7hh3z.scheme)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $i74RE.scheme)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $ll3aH.scheme)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $b5AgS.scheme)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $grEAO.scheme)),
    BuGn: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $gt53g.scheme)),
    BuPu: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $5Z16B.scheme)),
    GnBu: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $eN11p.scheme)),
    OrRd: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $k90dT.scheme)),
    PuBuGn: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $j6d4T.scheme)),
    PuBu: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $75sQg.scheme)),
    PuRd: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $2knla.scheme)),
    RdPu: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $2jgeQ.scheme)),
    YlGnBu: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $bSpC5.scheme)),
    YlGn: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $gkCir.scheme)),
    YlOrBr: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $8ktkj.scheme)),
    YlOrRd: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $cMNJi.scheme))
};
var $1c5c4e1a0d68bc50$export$6dc823b35197e3c3 = Object.keys($1c5c4e1a0d68bc50$export$77ddf829b5125d20);
var $1c5c4e1a0d68bc50$export$8d3d36a98ebb26b6 = function guessQuantizeColorScale(colors) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dC9tX)))(colors)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dC9tX)))(colors.domain)) throw new Error("Provided colors should be a valid quantize scale providing a 'domain()' function");
        return colors;
    }
    if ($1c5c4e1a0d68bc50$export$77ddf829b5125d20[colors]) return (0, $9MR7R.default)().range($1c5c4e1a0d68bc50$export$77ddf829b5125d20[colors]);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ioays)))(colors)) return (0, $9MR7R.default)().range(colors);
    throw new Error("Unable to guess quantize color scale from '".concat(colors, "',\nmust be a function or one of:\n'").concat($1c5c4e1a0d68bc50$export$6dc823b35197e3c3.join("', '"), "'"));
};
var $1c5c4e1a0d68bc50$var$colorSchemes = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $56l8W.default),
    accent: (0, $k8jNo.default),
    dark2: (0, $lXjI8.default),
    paired: (0, $1CkZa.default),
    pastel1: (0, $7CLP4.default),
    pastel2: (0, $es2xN.default),
    set1: (0, $CgMhj.default),
    set2: (0, $40aWI.default),
    set3: (0, $i3yYP.default),
    brown_blueGreen: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $fz4N9.scheme)),
    purpleRed_green: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $9kdQ2.scheme)),
    pink_yellowGreen: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $eqkbc.scheme)),
    purple_orange: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $3rkUU.scheme)),
    red_blue: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $deqjQ.scheme)),
    red_grey: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $n18IX.scheme)),
    red_yellow_blue: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $6torH.scheme)),
    red_yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $7JT8F.scheme)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $7UdON.scheme)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $cpSH1.scheme)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $7hh3z.scheme)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $i74RE.scheme)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $ll3aH.scheme)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $b5AgS.scheme)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $grEAO.scheme)),
    blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $gt53g.scheme)),
    blue_purple: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $5Z16B.scheme)),
    green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $eN11p.scheme)),
    orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $k90dT.scheme)),
    purple_blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $j6d4T.scheme)),
    purple_blue: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $75sQg.scheme)),
    purple_red: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $2knla.scheme)),
    red_purple: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $2jgeQ.scheme)),
    yellow_green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $bSpC5.scheme)),
    yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $gkCir.scheme)),
    yellow_orange_brown: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $8ktkj.scheme)),
    yellow_orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($1NdVc)))((0, $cMNJi.scheme))
};
var $1c5c4e1a0d68bc50$export$b48661626a811234 = [
    "nivo",
    "category10",
    "accent",
    "dark2",
    "paired",
    "pastel1",
    "pastel2",
    "set1",
    "set2",
    "set3",
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red"
];
var $1c5c4e1a0d68bc50$export$6638ab0298ebe095 = {
    brown_blueGreen: (0, $fz4N9.default),
    purpleRed_green: (0, $9kdQ2.default),
    pink_yellowGreen: (0, $eqkbc.default),
    purple_orange: (0, $3rkUU.default),
    red_blue: (0, $deqjQ.default),
    red_grey: (0, $n18IX.default),
    red_yellow_blue: (0, $6torH.default),
    red_yellow_green: (0, $7JT8F.default),
    spectral: (0, $7UdON.default),
    blues: (0, $cpSH1.default),
    greens: (0, $7hh3z.default),
    greys: (0, $i74RE.default),
    oranges: (0, $ll3aH.default),
    purples: (0, $b5AgS.default),
    reds: (0, $grEAO.default),
    viridis: (0, $7oKHH.default),
    inferno: (0, $7oKHH.inferno),
    magma: (0, $7oKHH.magma),
    plasma: (0, $7oKHH.plasma),
    warm: (0, $cwrJr.warm),
    cool: (0, $cwrJr.cool),
    cubehelixDefault: (0, $80FqD.default),
    blue_green: (0, $gt53g.default),
    blue_purple: (0, $5Z16B.default),
    green_blue: (0, $eN11p.default),
    orange_red: (0, $k90dT.default),
    purple_blue_green: (0, $j6d4T.default),
    purple_blue: (0, $75sQg.default),
    purple_red: (0, $2knla.default),
    red_purple: (0, $2jgeQ.default),
    yellow_green_blue: (0, $bSpC5.default),
    yellow_green: (0, $gkCir.default),
    yellow_orange_brown: (0, $8ktkj.default),
    yellow_orange_red: (0, $cMNJi.default),
    rainbow: (0, $cwrJr.default),
    sinebow: (0, $5x0wB.default)
};
var $1c5c4e1a0d68bc50$export$277274330ffd2780 = [
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "viridis",
    "inferno",
    "magma",
    "plasma",
    "warm",
    "cool",
    "cubehelixDefault",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red",
    "rainbow",
    "sinebow"
];
var $1c5c4e1a0d68bc50$export$cec134b1a1fa53dd = function nivoCategoricalColors() {
    return (0, $eZmYt.default)([
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ]);
};
var $1c5c4e1a0d68bc50$export$75f9af112506f7de = function getColorScale(colors, dataScale) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($lBSSW)))(colors)) {
        var scheme = $1c5c4e1a0d68bc50$var$colorSchemes[colors];
        if (scheme !== undefined) {
            var scale = (0, $eZmYt.default)(scheme);
            scale.type = "ordinal";
            return scale;
        }
        if (dataScale !== undefined && colors.indexOf("seq:") === 0) {
            var interpolator = $1c5c4e1a0d68bc50$export$6638ab0298ebe095[colors.slice(4)];
            if (interpolator !== undefined) {
                var _scale = (0, $72ggJ.default)(interpolator).domain(dataScale.domain());
                _scale.type = "sequential";
                return _scale;
            }
        }
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ioays)))(colors)) {
        var _scale2 = (0, $eZmYt.default)(colors);
        _scale2.type = "ordinal";
        return _scale2;
    }
    return function() {
        return colors;
    };
};
var $1c5c4e1a0d68bc50$export$51f2761e5fe5ca10 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($1c5c4e1a0d68bc50$export$6dc823b35197e3c3),
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string)
]);
var $1c5c4e1a0d68bc50$export$3794d272a0540747 = {
    basis: (0, $bnPpR.default),
    basisClosed: (0, $s34nM.default),
    basisOpen: (0, $2bhQs.default),
    bundle: (0, $gy5kR.default),
    cardinal: (0, $ez0Zd.default),
    cardinalClosed: (0, $1qq3o.default),
    cardinalOpen: (0, $64Ae3.default),
    catmullRom: (0, $aUWvE.default),
    catmullRomClosed: (0, $6Ed0C.default),
    catmullRomOpen: (0, $hvYCW.default),
    linear: (0, $ehI3a.default),
    linearClosed: (0, $8sVfw.default),
    monotoneX: (0, $9yRsK.monotoneX),
    monotoneY: (0, $9yRsK.monotoneY),
    natural: (0, $k2x2n.default),
    step: (0, $4vuYI.default),
    stepAfter: (0, $4vuYI.stepAfter),
    stepBefore: (0, $4vuYI.stepBefore)
};
var $1c5c4e1a0d68bc50$export$a2965cde22c100c0 = Object.keys($1c5c4e1a0d68bc50$export$3794d272a0540747);
var $1c5c4e1a0d68bc50$export$eef91b92fd6d82fc = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($1c5c4e1a0d68bc50$export$a2965cde22c100c0);
var $1c5c4e1a0d68bc50$export$2a904d581bf09f5e = $1c5c4e1a0d68bc50$export$a2965cde22c100c0.filter(function(c) {
    return c.endsWith("Closed");
});
var $1c5c4e1a0d68bc50$export$66e85fc6ea12b97e = (0, (/*@__PURE__*/$parcel$interopDefault($a8GNE)))($1c5c4e1a0d68bc50$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var $1c5c4e1a0d68bc50$export$6d32fc0bcd3f8555 = (0, (/*@__PURE__*/$parcel$interopDefault($a8GNE)))($1c5c4e1a0d68bc50$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var $1c5c4e1a0d68bc50$export$b417d9aa8a99ac1a = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($1c5c4e1a0d68bc50$export$6d32fc0bcd3f8555);
var $1c5c4e1a0d68bc50$export$99f526a753d63ebe = function curveFromProp(id) {
    var curveInterpolator = $1c5c4e1a0d68bc50$export$3794d272a0540747[id];
    if (!curveInterpolator) throw new TypeError("'".concat(id, "', is not a valid curve interpolator identifier."));
    return $1c5c4e1a0d68bc50$export$3794d272a0540747[id];
};
var $1c5c4e1a0d68bc50$export$395ebfe7dd3d9f57 = {
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    })).isRequired,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        match: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
                "*"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
        ]).isRequired
    })).isRequired
};
var $1c5c4e1a0d68bc50$export$9c0ef4eef492d11d = {
    ascending: (0, $7hdUF.default),
    descending: (0, $4Slcj.default),
    insideOut: (0, $fGh8D.default),
    none: (0, $7aiBf.default),
    reverse: (0, $p47eF.default)
};
var $1c5c4e1a0d68bc50$export$a8ec30103cd71280 = Object.keys($1c5c4e1a0d68bc50$export$9c0ef4eef492d11d);
var $1c5c4e1a0d68bc50$export$85e7401689f2f2cf = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($1c5c4e1a0d68bc50$export$a8ec30103cd71280);
var $1c5c4e1a0d68bc50$export$1d5443ca84f6d0f0 = function stackOrderFromProp(prop) {
    return $1c5c4e1a0d68bc50$export$9c0ef4eef492d11d[prop];
};
var $1c5c4e1a0d68bc50$export$ab3c04d5a3b28998 = {
    expand: (0, $8zZlU.default),
    diverging: (0, $dMc4H.default),
    none: (0, $cwhVc.default),
    silhouette: (0, $gw7Hy.default),
    wiggle: (0, $66iM5.default)
};
var $1c5c4e1a0d68bc50$export$31340e546ce1c184 = Object.keys($1c5c4e1a0d68bc50$export$ab3c04d5a3b28998);
var $1c5c4e1a0d68bc50$export$73f4209297f0de27 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($1c5c4e1a0d68bc50$export$31340e546ce1c184);
var $1c5c4e1a0d68bc50$export$5c9f4d1b003c0909 = function stackOffsetFromProp(prop) {
    return $1c5c4e1a0d68bc50$export$ab3c04d5a3b28998[prop];
};
var $1c5c4e1a0d68bc50$export$207a8bc280d901be = {
    binary: (0, $2yNl0.default),
    dice: (0, $7xMPq.default),
    slice: (0, $cAlSl.default),
    sliceDice: (0, $2GHW9.default),
    squarify: (0, $8eQwP.default),
    resquarify: (0, $SYRXa.default)
};
var $1c5c4e1a0d68bc50$export$721df90eadc4087f = Object.keys($1c5c4e1a0d68bc50$export$207a8bc280d901be);
var $1c5c4e1a0d68bc50$export$b051cc71b63328a3 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($1c5c4e1a0d68bc50$export$721df90eadc4087f);
var $1c5c4e1a0d68bc50$export$c87057bd1daeb071 = function treeMapTileFromProp(prop) {
    return $1c5c4e1a0d68bc50$export$207a8bc280d901be[prop];
};
var $1c5c4e1a0d68bc50$export$5d66dd569e74301b = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
    top: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
}).isRequired;
var $1c5c4e1a0d68bc50$export$34f44898ffea24c3 = [
    "normal",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
];
var $1c5c4e1a0d68bc50$export$6da2372f044c5e36 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($1c5c4e1a0d68bc50$export$34f44898ffea24c3);
var $1c5c4e1a0d68bc50$export$1db72d8ab19b94d9 = function useCurveInterpolation(interpolation) {
    return (0, $70fFQ.useMemo)(function() {
        return $1c5c4e1a0d68bc50$export$99f526a753d63ebe(interpolation);
    }, [
        interpolation
    ]);
};
var $1c5c4e1a0d68bc50$export$2785d5ef2943fe58 = true;
var $1c5c4e1a0d68bc50$export$bcf754ee2d5727f7 = 90;
var $1c5c4e1a0d68bc50$export$6bb389bedeee99d3 = 15;
var $1c5c4e1a0d68bc50$export$a4dcb37d1b87cf96 = $1c5c4e1a0d68bc50$export$cec134b1a1fa53dd;
var $1c5c4e1a0d68bc50$export$1570875fb8f3b023 = (0, $eZmYt.default)((0, $i3yYP.default));
var $1c5c4e1a0d68bc50$export$6728fea658cfb92e = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $1c5c4e1a0d68bc50$export$d04af0e501fb729f = function useDimensions(width, height) {
    var partialMargin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0, $70fFQ.useMemo)(function() {
        var margin = $1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$export$6728fea658cfb92e), partialMargin);
        return {
            margin: margin,
            innerWidth: width - margin.left - margin.right,
            innerHeight: height - margin.top - margin.bottom,
            outerWidth: width,
            outerHeight: height
        };
    }, [
        width,
        height,
        partialMargin.top,
        partialMargin.right,
        partialMargin.bottom,
        partialMargin.left
    ]);
};
function $1c5c4e1a0d68bc50$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1c5c4e1a0d68bc50$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1c5c4e1a0d68bc50$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1c5c4e1a0d68bc50$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1c5c4e1a0d68bc50$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1c5c4e1a0d68bc50$var$_arrayLikeToArray(o, minLen);
}
function $1c5c4e1a0d68bc50$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c5c4e1a0d68bc50$var$_slicedToArray(arr, i) {
    return $1c5c4e1a0d68bc50$var$_arrayWithHoles(arr) || $1c5c4e1a0d68bc50$var$_iterableToArrayLimit(arr, i) || $1c5c4e1a0d68bc50$var$_unsupportedIterableToArray(arr, i) || $1c5c4e1a0d68bc50$var$_nonIterableRest();
}
var $1c5c4e1a0d68bc50$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
var $1c5c4e1a0d68bc50$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var $1c5c4e1a0d68bc50$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    return Function("return this")();
}();
var $1c5c4e1a0d68bc50$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") return requestAnimationFrame.bind($1c5c4e1a0d68bc50$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
var $1c5c4e1a0d68bc50$var$trailingTimeout = 2;
function $1c5c4e1a0d68bc50$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    function timeoutCallback() {
        $1c5c4e1a0d68bc50$var$requestAnimationFrame$1(resolvePending);
    }
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            if (timeStamp - lastCallTime < $1c5c4e1a0d68bc50$var$trailingTimeout) return;
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
var $1c5c4e1a0d68bc50$var$REFRESH_DELAY = 20;
var $1c5c4e1a0d68bc50$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
var $1c5c4e1a0d68bc50$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
var $1c5c4e1a0d68bc50$var$ResizeObserverController = function() {
    function ResizeObserverController() {
        this.connected_ = false;
        this.mutationEventsAdded_ = false;
        this.mutationsObserver_ = null;
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $1c5c4e1a0d68bc50$var$throttle(this.refresh.bind(this), $1c5c4e1a0d68bc50$var$REFRESH_DELAY);
    }
    ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        if (!this.connected_) this.connect_();
    };
    ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        if (~index) observers.splice(index, 1);
        if (!observers.length && this.connected_) this.disconnect_();
    };
    ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        if (changesDetected) this.refresh();
    };
    ResizeObserverController.prototype.updateObservers_ = function() {
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    ResizeObserverController.prototype.connect_ = function() {
        if (!$1c5c4e1a0d68bc50$var$isBrowser || this.connected_) return;
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($1c5c4e1a0d68bc50$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    ResizeObserverController.prototype.disconnect_ = function() {
        if (!$1c5c4e1a0d68bc50$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        var isReflowProperty = $1c5c4e1a0d68bc50$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
var $1c5c4e1a0d68bc50$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
var $1c5c4e1a0d68bc50$var$getWindowOf = function(target) {
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    return ownerGlobal || $1c5c4e1a0d68bc50$var$global$1;
};
var $1c5c4e1a0d68bc50$var$emptyRect = $1c5c4e1a0d68bc50$var$createRectInit(0, 0, 0, 0);
function $1c5c4e1a0d68bc50$var$toFloat(value) {
    return parseFloat(value) || 0;
}
function $1c5c4e1a0d68bc50$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $1c5c4e1a0d68bc50$var$toFloat(value);
    }, 0);
}
function $1c5c4e1a0d68bc50$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $1c5c4e1a0d68bc50$var$toFloat(value);
    }
    return paddings;
}
function $1c5c4e1a0d68bc50$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $1c5c4e1a0d68bc50$var$createRectInit(0, 0, bbox.width, bbox.height);
}
function $1c5c4e1a0d68bc50$var$getHTMLElementContentRect(target) {
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    if (!clientWidth && !clientHeight) return $1c5c4e1a0d68bc50$var$emptyRect;
    var styles = $1c5c4e1a0d68bc50$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $1c5c4e1a0d68bc50$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    var width = $1c5c4e1a0d68bc50$var$toFloat(styles.width), height = $1c5c4e1a0d68bc50$var$toFloat(styles.height);
    if (styles.boxSizing === "border-box") {
        if (Math.round(width + horizPad) !== clientWidth) width -= $1c5c4e1a0d68bc50$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $1c5c4e1a0d68bc50$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    if (!$1c5c4e1a0d68bc50$var$isDocumentElement(target)) {
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $1c5c4e1a0d68bc50$var$createRectInit(paddings.left, paddings.top, width, height);
}
var $1c5c4e1a0d68bc50$var$isSVGGraphicsElement = function() {
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $1c5c4e1a0d68bc50$var$getWindowOf(target).SVGGraphicsElement;
    };
    return function(target) {
        return target instanceof $1c5c4e1a0d68bc50$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
function $1c5c4e1a0d68bc50$var$isDocumentElement(target) {
    return target === $1c5c4e1a0d68bc50$var$getWindowOf(target).document.documentElement;
}
function $1c5c4e1a0d68bc50$var$getContentRect(target) {
    if (!$1c5c4e1a0d68bc50$var$isBrowser) return $1c5c4e1a0d68bc50$var$emptyRect;
    if ($1c5c4e1a0d68bc50$var$isSVGGraphicsElement(target)) return $1c5c4e1a0d68bc50$var$getSVGContentRect(target);
    return $1c5c4e1a0d68bc50$var$getHTMLElementContentRect(target);
}
function $1c5c4e1a0d68bc50$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    $1c5c4e1a0d68bc50$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
function $1c5c4e1a0d68bc50$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
var $1c5c4e1a0d68bc50$var$ResizeObservation = function() {
    function ResizeObservation(target) {
        this.broadcastWidth = 0;
        this.broadcastHeight = 0;
        this.contentRect_ = $1c5c4e1a0d68bc50$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    ResizeObservation.prototype.isActive = function() {
        var rect = $1c5c4e1a0d68bc50$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $1c5c4e1a0d68bc50$var$ResizeObserverEntry = function() {
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = $1c5c4e1a0d68bc50$var$createReadOnlyRect(rectInit);
        $1c5c4e1a0d68bc50$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $1c5c4e1a0d68bc50$var$ResizeObserverSPI = function() {
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        this.activeObservations_ = [];
        this.observations_ = new $1c5c4e1a0d68bc50$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $1c5c4e1a0d68bc50$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        if (observations.has(target)) return;
        observations.set(target, new $1c5c4e1a0d68bc50$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        this.controller_.refresh();
    };
    ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $1c5c4e1a0d68bc50$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    ResizeObserverSPI.prototype.broadcastActive = function() {
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        var entries = this.activeObservations_.map(function(observation) {
            return new $1c5c4e1a0d68bc50$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
var $1c5c4e1a0d68bc50$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $1c5c4e1a0d68bc50$var$MapShim();
var $1c5c4e1a0d68bc50$var$ResizeObserver = function() {
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $1c5c4e1a0d68bc50$var$ResizeObserverController.getInstance();
        var observer = new $1c5c4e1a0d68bc50$var$ResizeObserverSPI(callback, controller, this);
        $1c5c4e1a0d68bc50$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $1c5c4e1a0d68bc50$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $1c5c4e1a0d68bc50$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $1c5c4e1a0d68bc50$var$index = function() {
    if (typeof $1c5c4e1a0d68bc50$var$global$1.ResizeObserver !== "undefined") return $1c5c4e1a0d68bc50$var$global$1.ResizeObserver;
    return $1c5c4e1a0d68bc50$var$ResizeObserver;
}();
var $1c5c4e1a0d68bc50$export$e295b0c537d32d7d = function useMeasure() {
    var measureRef = (0, $70fFQ.useRef)(null);
    var _useState = (0, $70fFQ.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0
    }), _useState2 = $1c5c4e1a0d68bc50$var$_slicedToArray(_useState, 2), bounds = _useState2[0], setBounds = _useState2[1];
    var _useState3 = (0, $70fFQ.useState)(function() {
        return new $1c5c4e1a0d68bc50$var$index(function(_ref) {
            var _ref2 = $1c5c4e1a0d68bc50$var$_slicedToArray(_ref, 1), entry = _ref2[0];
            return setBounds(entry.contentRect);
        });
    }), _useState4 = $1c5c4e1a0d68bc50$var$_slicedToArray(_useState3, 1), observer = _useState4[0];
    (0, $70fFQ.useEffect)(function() {
        if (measureRef.current) observer.observe(measureRef.current);
        return function() {
            return observer.disconnect();
        };
    }, []);
    return [
        measureRef,
        bounds
    ];
};
var $1c5c4e1a0d68bc50$export$7394831711fe34f = function usePartialTheme(partialTheme) {
    return (0, $70fFQ.useMemo)(function() {
        return $1c5c4e1a0d68bc50$export$582fa4e2a9b13dde($1c5c4e1a0d68bc50$export$164de7ab8df77ef0, partialTheme);
    }, [
        partialTheme
    ]);
};
var $1c5c4e1a0d68bc50$export$f037bf6aad5a4e75 = function getValueFormatter(format$1) {
    if (typeof format$1 === "function") return format$1;
    if (typeof format$1 === "string") {
        if (format$1.indexOf("time:") === 0) return (0, $7pj3L.timeFormat)(format$1.slice("5"));
        return (0, $hjBRw.format)(format$1);
    }
    return function(value) {
        return "".concat(value);
    };
};
var $1c5c4e1a0d68bc50$export$422f9765e6971fdf = function useValueFormatter(format) {
    return (0, $70fFQ.useMemo)(function() {
        return $1c5c4e1a0d68bc50$export$f037bf6aad5a4e75(format);
    }, [
        format
    ]);
};
var $1c5c4e1a0d68bc50$export$84c6f02482759c25 = (0, $70fFQ.createContext)();
var $1c5c4e1a0d68bc50$var$defaultPartialTheme = {};
var $1c5c4e1a0d68bc50$export$d8964aec282183a3 = function ThemeProvider(_ref) {
    var _ref$theme = _ref.theme, partialTheme = _ref$theme === void 0 ? $1c5c4e1a0d68bc50$var$defaultPartialTheme : _ref$theme, children = _ref.children;
    var theme = $1c5c4e1a0d68bc50$export$7394831711fe34f(partialTheme);
    return (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$84c6f02482759c25.Provider, {
        value: theme,
        children: children
    });
};
var $1c5c4e1a0d68bc50$export$93d4e7f90805808f = function useTheme() {
    return (0, $70fFQ.useContext)($1c5c4e1a0d68bc50$export$84c6f02482759c25);
};
var $1c5c4e1a0d68bc50$var$ConditionalWrapper = function ConditionalWrapper(_ref) {
    var children = _ref.children, condition = _ref.condition, wrapper = _ref.wrapper;
    if (!condition) return children;
    return (0, $70fFQ.cloneElement)(wrapper, {}, children);
};
var $1c5c4e1a0d68bc50$var$containerStyle = {
    position: "relative"
};
var $1c5c4e1a0d68bc50$export$42a852a2b6b56249 = function Container(_ref) {
    var children = _ref.children, theme = _ref.theme, _ref$renderWrapper = _ref.renderWrapper, renderWrapper = _ref$renderWrapper === void 0 ? true : _ref$renderWrapper, _ref$isInteractive = _ref.isInteractive, isInteractive = _ref$isInteractive === void 0 ? true : _ref$isInteractive, animate = _ref.animate, motionStiffness = _ref.motionStiffness, motionDamping = _ref.motionDamping, motionConfig = _ref.motionConfig;
    var container = (0, $70fFQ.useRef)(null);
    return (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$d8964aec282183a3, {
        theme: theme,
        children: (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$e9d875263f86dcb4, {
            animate: animate,
            stiffness: motionStiffness,
            damping: motionDamping,
            config: motionConfig,
            children: (0, $4x3bm.jsx)((0, $lITvm.TooltipProvider), {
                container: container,
                children: (0, $4x3bm.jsxs)($1c5c4e1a0d68bc50$var$ConditionalWrapper, {
                    condition: renderWrapper,
                    wrapper: (0, $4x3bm.jsx)("div", {
                        style: $1c5c4e1a0d68bc50$var$containerStyle,
                        ref: container
                    }),
                    children: [
                        children,
                        isInteractive && (0, $4x3bm.jsx)((0, $lITvm.Tooltip), {})
                    ]
                })
            })
        })
    });
};
var $1c5c4e1a0d68bc50$export$8793edee2d425525 = function() {};
var $1c5c4e1a0d68bc50$var$containerStyle$1 = {
    position: "relative"
};
var $1c5c4e1a0d68bc50$export$c2b4ab1564fcaab4 = function LegacyContainer(_ref) {
    var children = _ref.children, theme = _ref.theme, _ref$isInteractive = _ref.isInteractive, isInteractive = _ref$isInteractive === void 0 ? true : _ref$isInteractive, _ref$renderWrapper = _ref.renderWrapper, renderWrapper = _ref$renderWrapper === void 0 ? true : _ref$renderWrapper, animate = _ref.animate, motionStiffness = _ref.motionStiffness, motionDamping = _ref.motionDamping, motionConfig = _ref.motionConfig;
    var container = (0, $70fFQ.useRef)(null);
    var _useTooltipHandlers = (0, $lITvm.useTooltipHandlers)(container), tooltipActions = _useTooltipHandlers.actions, tooltipState = _useTooltipHandlers.state;
    var showTooltip = (0, $70fFQ.useCallback)(function(content, event) {
        return tooltipActions.showTooltipFromEvent(content, event);
    }, [
        tooltipActions.showTooltipFromEvent
    ]);
    var handlers = (0, $70fFQ.useMemo)(function() {
        return {
            showTooltip: isInteractive ? showTooltip : $1c5c4e1a0d68bc50$export$8793edee2d425525,
            hideTooltip: isInteractive ? tooltipActions.hideTooltip : $1c5c4e1a0d68bc50$export$8793edee2d425525
        };
    }, [
        tooltipActions.hideTooltip,
        isInteractive,
        showTooltip
    ]);
    return (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$d8964aec282183a3, {
        theme: theme,
        children: (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$e9d875263f86dcb4, {
            animate: animate,
            stiffness: motionStiffness,
            damping: motionDamping,
            config: motionConfig,
            children: (0, $4x3bm.jsx)((0, $lITvm.TooltipActionsContext).Provider, {
                value: tooltipActions,
                children: (0, $4x3bm.jsx)((0, $lITvm.TooltipStateContext).Provider, {
                    value: tooltipState,
                    children: (0, $4x3bm.jsxs)($1c5c4e1a0d68bc50$var$ConditionalWrapper, {
                        condition: renderWrapper,
                        wrapper: (0, $4x3bm.jsx)("div", {
                            style: $1c5c4e1a0d68bc50$var$containerStyle$1,
                            ref: container
                        }),
                        children: [
                            children(handlers),
                            isInteractive && (0, $4x3bm.jsx)((0, $lITvm.Tooltip), {})
                        ]
                    })
                })
            })
        })
    });
};
var $1c5c4e1a0d68bc50$export$fa6e408d6a7d6214 = function ResponsiveWrapper(_ref) {
    var children = _ref.children;
    var _useMeasure = $1c5c4e1a0d68bc50$export$e295b0c537d32d7d(), _useMeasure2 = $1c5c4e1a0d68bc50$var$_slicedToArray(_useMeasure, 2), measureRef = _useMeasure2[0], bounds = _useMeasure2[1];
    var shouldRender = bounds.width > 0 && bounds.height > 0;
    return (0, $4x3bm.jsx)("div", {
        ref: measureRef,
        style: {
            width: "100%",
            height: "100%"
        },
        children: shouldRender && children({
            width: bounds.width,
            height: bounds.height
        })
    });
};
function $1c5c4e1a0d68bc50$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1c5c4e1a0d68bc50$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1c5c4e1a0d68bc50$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $1c5c4e1a0d68bc50$export$39a41c7169757633 = function LinearGradient(_ref) {
    var id = _ref.id, colors = _ref.colors, rest = $1c5c4e1a0d68bc50$var$_objectWithoutProperties(_ref, [
        "id",
        "colors"
    ]);
    return (0, $4x3bm.jsx)("linearGradient", $1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({
        id: id,
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
    }, rest), {}, {
        children: colors.map(function(_ref2) {
            var offset = _ref2.offset, color = _ref2.color, opacity = _ref2.opacity;
            return (0, $4x3bm.jsx)("stop", {
                offset: "".concat(offset, "%"),
                stopColor: color,
                stopOpacity: opacity !== undefined ? opacity : 1
            }, offset);
        })
    }));
};
var $1c5c4e1a0d68bc50$export$78f14b2164360f92 = function linearGradientDef(id, colors) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return $1c5c4e1a0d68bc50$var$_objectSpread2({
        id: id,
        type: "linearGradient",
        colors: colors
    }, options);
};
var $1c5c4e1a0d68bc50$export$a3bca081a57901da = {
    linearGradient: $1c5c4e1a0d68bc50$export$39a41c7169757633
};
var $1c5c4e1a0d68bc50$export$5e799d98c1ab7521 = (0, $70fFQ.memo)(function(_ref) {
    var id = _ref.id, background = _ref.background, color = _ref.color, size = _ref.size, padding = _ref.padding, stagger = _ref.stagger;
    var fullSize = size + padding;
    var radius = size / 2;
    var halfPadding = padding / 2;
    if (stagger === true) fullSize = size * 2 + padding * 2;
    return (0, $4x3bm.jsxs)("pattern", {
        id: id,
        width: fullSize,
        height: fullSize,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $4x3bm.jsx)("rect", {
                width: fullSize,
                height: fullSize,
                fill: background
            }),
            (0, $4x3bm.jsx)("circle", {
                cx: halfPadding + radius,
                cy: halfPadding + radius,
                r: radius,
                fill: color
            }),
            stagger && (0, $4x3bm.jsx)("circle", {
                cx: padding * 1.5 + size + radius,
                cy: padding * 1.5 + size + radius,
                r: radius,
                fill: color
            })
        ]
    });
});
$1c5c4e1a0d68bc50$export$5e799d98c1ab7521.displayName = "PatternDots";
$1c5c4e1a0d68bc50$export$5e799d98c1ab7521.defaultProps = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: false
};
var $1c5c4e1a0d68bc50$export$27feaeda534cb3 = function patternDotsDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $1c5c4e1a0d68bc50$var$_objectSpread2({
        id: id,
        type: "patternDots"
    }, options);
};
var $1c5c4e1a0d68bc50$export$6eec49b1a6289c4e = Math.PI * 2;
var $1c5c4e1a0d68bc50$export$c9fcf1a7df975d78 = function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
};
var $1c5c4e1a0d68bc50$export$c41dd2a8460d3196 = function radiansToDegrees(radians) {
    return 180 * radians / Math.PI;
};
var $1c5c4e1a0d68bc50$export$61f3799bad189d2e = function midAngle(arc) {
    return arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
};
var $1c5c4e1a0d68bc50$export$2e16b01652730550 = function positionFromAngle(angle, distance) {
    return {
        x: Math.cos(angle) * distance,
        y: Math.sin(angle) * distance
    };
};
var $1c5c4e1a0d68bc50$export$c2f0a4925e526958 = function absoluteAngleDegrees(angle) {
    var absAngle = angle % 360;
    if (absAngle < 0) absAngle += 360;
    return absAngle;
};
var $1c5c4e1a0d68bc50$export$c2bacc09869b390f = function absoluteAngleRadians(angle) {
    return angle - $1c5c4e1a0d68bc50$export$6eec49b1a6289c4e * Math.floor((angle + Math.PI) / $1c5c4e1a0d68bc50$export$6eec49b1a6289c4e);
};
var $1c5c4e1a0d68bc50$export$e3df76cf4464bc81 = function normalizeAngle(rawAngle) {
    if (rawAngle < 0) return 360 - -rawAngle % 360;
    return rawAngle % 360;
};
var $1c5c4e1a0d68bc50$export$a9f93668da7e35c9 = function clampArc(startAngle, endAngle) {
    var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 360;
    var clampedEndAngle = endAngle;
    if (Math.abs(endAngle - startAngle) > length) clampedEndAngle = startAngle + (endAngle > startAngle ? length : -length);
    return [
        startAngle,
        clampedEndAngle
    ];
};
var $1c5c4e1a0d68bc50$export$1abb91cfca1e2069 = {
    svg: {
        align: {
            left: "start",
            center: "middle",
            right: "end",
            start: "start",
            middle: "middle",
            end: "end"
        },
        baseline: {
            top: "text-before-edge",
            center: "central",
            bottom: "alphabetic"
        }
    },
    canvas: {
        align: {
            left: "left",
            center: "center",
            right: "right",
            start: "left",
            middle: "center",
            end: "right"
        },
        baseline: {
            top: "top",
            center: "middle",
            bottom: "bottom"
        }
    }
};
var $1c5c4e1a0d68bc50$export$60f5dce4201c524 = function getPolarLabelProps(radius, angle, rotation) {
    var engine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "svg";
    var textProps = $1c5c4e1a0d68bc50$export$1abb91cfca1e2069[engine];
    var _positionFromAngle = $1c5c4e1a0d68bc50$export$2e16b01652730550(angle - Math.PI / 2, radius), x = _positionFromAngle.x, y = _positionFromAngle.y;
    var rotate = $1c5c4e1a0d68bc50$export$c41dd2a8460d3196(angle);
    var align = textProps.align.center;
    var baseline = textProps.baseline.bottom;
    if (rotation > 0) {
        align = textProps.align.right;
        baseline = textProps.baseline.center;
    } else if (rotation < 0) {
        align = textProps.align.left;
        baseline = textProps.baseline.center;
    }
    if (rotation !== 0 && rotate > 180) {
        rotate -= 180;
        align = align === textProps.align.right ? textProps.align.left : textProps.align.right;
    }
    rotate += rotation;
    return {
        x: x,
        y: y,
        rotate: rotate,
        align: align,
        baseline: baseline
    };
};
var $1c5c4e1a0d68bc50$export$ace8c9d56fb83ed1 = (0, $70fFQ.memo)(function(_ref) {
    var id = _ref.id, _spacing = _ref.spacing, _rotation = _ref.rotation, background = _ref.background, color = _ref.color, lineWidth = _ref.lineWidth;
    var rotation = Math.round(_rotation) % 360;
    var spacing = Math.abs(_spacing);
    if (rotation > 180) rotation = rotation - 360;
    else if (rotation > 90) rotation = rotation - 180;
    else if (rotation < -180) rotation = rotation + 360;
    else if (rotation < -90) rotation = rotation + 180;
    var width = spacing;
    var height = spacing;
    var path;
    if (rotation === 0) path = "\n                M 0 0 L ".concat(width, " 0\n                M 0 ").concat(height, " L ").concat(width, " ").concat(height, "\n            ");
    else if (rotation === 90) path = "\n                M 0 0 L 0 ".concat(height, "\n                M ").concat(width, " 0 L ").concat(width, " ").concat(height, "\n            ");
    else {
        width = Math.abs(spacing / Math.sin($1c5c4e1a0d68bc50$export$c9fcf1a7df975d78(rotation)));
        height = spacing / Math.sin($1c5c4e1a0d68bc50$export$c9fcf1a7df975d78(90 - rotation));
        if (rotation > 0) path = "\n                    M 0 ".concat(-height, " L ").concat(width * 2, " ").concat(height, "\n                    M ").concat(-width, " ").concat(-height, " L ").concat(width, " ").concat(height, "\n                    M ").concat(-width, " 0 L ").concat(width, " ").concat(height * 2, "\n                ");
        else path = "\n                    M ".concat(-width, " ").concat(height, " L ").concat(width, " ").concat(-height, "\n                    M ").concat(-width, " ").concat(height * 2, " L ").concat(width * 2, " ").concat(-height, "\n                    M 0 ").concat(height * 2, " L ").concat(width * 2, " 0\n                ");
    }
    return (0, $4x3bm.jsxs)("pattern", {
        id: id,
        width: width,
        height: height,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $4x3bm.jsx)("rect", {
                width: width,
                height: height,
                fill: background,
                stroke: "rgba(255, 0, 0, 0.1)",
                strokeWidth: 0
            }),
            (0, $4x3bm.jsx)("path", {
                d: path,
                strokeWidth: lineWidth,
                stroke: color,
                strokeLinecap: "square"
            })
        ]
    });
});
$1c5c4e1a0d68bc50$export$ace8c9d56fb83ed1.displayName = "PatternLines";
$1c5c4e1a0d68bc50$export$ace8c9d56fb83ed1.defaultProps = {
    spacing: 5,
    rotation: 0,
    color: "#000000",
    background: "#ffffff",
    lineWidth: 2
};
var $1c5c4e1a0d68bc50$export$5487da9d0b1282d9 = function patternLinesDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $1c5c4e1a0d68bc50$var$_objectSpread2({
        id: id,
        type: "patternLines"
    }, options);
};
var $1c5c4e1a0d68bc50$export$e9fa09500a728054 = (0, $70fFQ.memo)(function(_ref) {
    var id = _ref.id, background = _ref.background, color = _ref.color, size = _ref.size, padding = _ref.padding, stagger = _ref.stagger;
    var fullSize = size + padding;
    var halfPadding = padding / 2;
    if (stagger === true) fullSize = size * 2 + padding * 2;
    return (0, $4x3bm.jsxs)("pattern", {
        id: id,
        width: fullSize,
        height: fullSize,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $4x3bm.jsx)("rect", {
                width: fullSize,
                height: fullSize,
                fill: background
            }),
            (0, $4x3bm.jsx)("rect", {
                x: halfPadding,
                y: halfPadding,
                width: size,
                height: size,
                fill: color
            }),
            stagger && (0, $4x3bm.jsx)("rect", {
                x: padding * 1.5 + size,
                y: padding * 1.5 + size,
                width: size,
                height: size,
                fill: color
            })
        ]
    });
});
$1c5c4e1a0d68bc50$export$e9fa09500a728054.displayName = "PatternSquares";
$1c5c4e1a0d68bc50$export$e9fa09500a728054.defaultProps = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: false
};
var $1c5c4e1a0d68bc50$export$1b1d9cb2f82cf47f = function patternSquaresDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $1c5c4e1a0d68bc50$var$_objectSpread2({
        id: id,
        type: "patternSquares"
    }, options);
};
var $1c5c4e1a0d68bc50$export$691ec77bd278f3b0 = {
    patternDots: $1c5c4e1a0d68bc50$export$5e799d98c1ab7521,
    patternLines: $1c5c4e1a0d68bc50$export$ace8c9d56fb83ed1,
    patternSquares: $1c5c4e1a0d68bc50$export$e9fa09500a728054
};
var $1c5c4e1a0d68bc50$var$defsMapping = $1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, $1c5c4e1a0d68bc50$export$a3bca081a57901da), $1c5c4e1a0d68bc50$export$691ec77bd278f3b0);
var $1c5c4e1a0d68bc50$var$Defs = function Defs(_ref) {
    var definitions = _ref.defs;
    if (!definitions || definitions.length < 1) return null;
    return (0, $4x3bm.jsx)("defs", {
        "aria-hidden": true,
        children: definitions.map(function(_ref2) {
            var type = _ref2.type, def = $1c5c4e1a0d68bc50$var$_objectWithoutProperties(_ref2, [
                "type"
            ]);
            if ($1c5c4e1a0d68bc50$var$defsMapping[type]) return (0, $70fFQ.createElement)($1c5c4e1a0d68bc50$var$defsMapping[type], $1c5c4e1a0d68bc50$var$_objectSpread2({
                key: def.id
            }, def));
            return null;
        })
    });
};
var $1c5c4e1a0d68bc50$export$b2bdceae9588b42d = (0, $70fFQ.memo)($1c5c4e1a0d68bc50$var$Defs);
var $1c5c4e1a0d68bc50$export$21d9f1931ef75b56 = function SvgWrapper(_ref) {
    var width = _ref.width, height = _ref.height, margin = _ref.margin, defs = _ref.defs, children = _ref.children, role = _ref.role, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, ariaDescribedBy = _ref.ariaDescribedBy, isFocusable = _ref.isFocusable;
    var theme = $1c5c4e1a0d68bc50$export$93d4e7f90805808f();
    return (0, $4x3bm.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        role: role,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        focusable: isFocusable,
        tabIndex: isFocusable ? 0 : undefined,
        children: [
            (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$b2bdceae9588b42d, {
                defs: defs
            }),
            (0, $4x3bm.jsx)("rect", {
                width: width,
                height: height,
                fill: theme.background
            }),
            (0, $4x3bm.jsx)("g", {
                transform: "translate(".concat(margin.left, ",").concat(margin.top, ")"),
                children: children
            })
        ]
    });
};
var $1c5c4e1a0d68bc50$var$DotsItemSymbol = function DotsItemSymbol(_ref) {
    var size = _ref.size, color = _ref.color, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor;
    return (0, $4x3bm.jsx)("circle", {
        r: size / 2,
        fill: color,
        stroke: borderColor,
        strokeWidth: borderWidth,
        style: {
            pointerEvents: "none"
        }
    });
};
var $1c5c4e1a0d68bc50$var$DotsItemSymbol$1 = (0, $70fFQ.memo)($1c5c4e1a0d68bc50$var$DotsItemSymbol);
var $1c5c4e1a0d68bc50$var$DotsItem = function DotsItem(_ref) {
    var x = _ref.x, y = _ref.y, _ref$symbol = _ref.symbol, symbol = _ref$symbol === void 0 ? $1c5c4e1a0d68bc50$var$DotsItemSymbol$1 : _ref$symbol, size = _ref.size, datum = _ref.datum, color = _ref.color, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor, label = _ref.label, _ref$labelTextAnchor = _ref.labelTextAnchor, labelTextAnchor = _ref$labelTextAnchor === void 0 ? "middle" : _ref$labelTextAnchor, _ref$labelYOffset = _ref.labelYOffset, labelYOffset = _ref$labelYOffset === void 0 ? -12 : _ref$labelYOffset;
    var theme = $1c5c4e1a0d68bc50$export$93d4e7f90805808f();
    var _useMotionConfig = $1c5c4e1a0d68bc50$export$72acc3dc9629d75d(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var animatedProps = (0, $blk6s.useSpring)({
        transform: "translate(".concat(x, ", ").concat(y, ")"),
        config: springConfig,
        immediate: !animate
    });
    return (0, $4x3bm.jsxs)((0, $iPpol.animated).g, {
        transform: animatedProps.transform,
        style: {
            pointerEvents: "none"
        },
        children: [
            (0, $70fFQ.createElement)(symbol, {
                size: size,
                color: color,
                datum: datum,
                borderWidth: borderWidth,
                borderColor: borderColor
            }),
            label && (0, $4x3bm.jsx)("text", {
                textAnchor: labelTextAnchor,
                y: labelYOffset,
                style: theme.dots.text,
                children: label
            })
        ]
    });
};
var $1c5c4e1a0d68bc50$export$ca30f0ad55489a87 = (0, $70fFQ.memo)($1c5c4e1a0d68bc50$var$DotsItem);
var $1c5c4e1a0d68bc50$var$computeLabel = function computeLabel(_ref) {
    var axis = _ref.axis, width = _ref.width, height = _ref.height, position = _ref.position, offsetX = _ref.offsetX, offsetY = _ref.offsetY, orientation = _ref.orientation;
    var x = 0;
    var y = 0;
    var rotation = orientation === "vertical" ? -90 : 0;
    var textAnchor = "start";
    if (axis === "x") switch(position){
        case "top-left":
            x = -offsetX;
            y = offsetY;
            textAnchor = "end";
            break;
        case "top":
            y = -offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "start";
            break;
        case "top-right":
            x = offsetX;
            y = offsetY;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "end";
            break;
        case "right":
            x = offsetX;
            y = height / 2;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "middle";
            break;
        case "bottom-right":
            x = offsetX;
            y = height - offsetY;
            textAnchor = "start";
            break;
        case "bottom":
            y = height + offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "end";
            break;
        case "bottom-left":
            y = height - offsetY;
            x = -offsetX;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "start";
            break;
        case "left":
            x = -offsetX;
            y = height / 2;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "middle";
            break;
    }
    else switch(position){
        case "top-left":
            x = offsetX;
            y = -offsetY;
            textAnchor = "start";
            break;
        case "top":
            x = width / 2;
            y = -offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "start";
            break;
        case "top-right":
            x = width - offsetX;
            y = -offsetY;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "start";
            break;
        case "right":
            x = width + offsetX;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "middle";
            break;
        case "bottom-right":
            x = width - offsetX;
            y = offsetY;
            textAnchor = "end";
            break;
        case "bottom":
            x = width / 2;
            y = offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "end";
            break;
        case "bottom-left":
            x = offsetX;
            y = offsetY;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "end";
            break;
        case "left":
            x = -offsetX;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "middle";
            break;
    }
    return {
        x: x,
        y: y,
        rotation: rotation,
        textAnchor: textAnchor
    };
};
var $1c5c4e1a0d68bc50$var$CartesianMarkersItem = function CartesianMarkersItem(_ref2) {
    var width = _ref2.width, height = _ref2.height, axis = _ref2.axis, scale = _ref2.scale, value = _ref2.value, lineStyle = _ref2.lineStyle, textStyle = _ref2.textStyle, legend = _ref2.legend, legendPosition = _ref2.legendPosition, legendOffsetX = _ref2.legendOffsetX, legendOffsetY = _ref2.legendOffsetY, legendOrientation = _ref2.legendOrientation;
    var theme = $1c5c4e1a0d68bc50$export$93d4e7f90805808f();
    var x = 0;
    var x2 = 0;
    var y = 0;
    var y2 = 0;
    if (axis === "y") {
        y = scale(value);
        x2 = width;
    } else {
        x = scale(value);
        y2 = height;
    }
    var legendNode = null;
    if (legend) {
        var legendProps = $1c5c4e1a0d68bc50$var$computeLabel({
            axis: axis,
            width: width,
            height: height,
            position: legendPosition,
            offsetX: legendOffsetX,
            offsetY: legendOffsetY,
            orientation: legendOrientation
        });
        legendNode = (0, $4x3bm.jsx)("text", {
            transform: "translate(".concat(legendProps.x, ", ").concat(legendProps.y, ") rotate(").concat(legendProps.rotation, ")"),
            textAnchor: legendProps.textAnchor,
            dominantBaseline: "central",
            style: textStyle,
            children: legend
        });
    }
    return (0, $4x3bm.jsxs)("g", {
        transform: "translate(".concat(x, ", ").concat(y, ")"),
        children: [
            (0, $4x3bm.jsx)("line", {
                x1: 0,
                x2: x2,
                y1: 0,
                y2: y2,
                stroke: theme.markers.lineColor,
                strokeWidth: theme.markers.lineStrokeWidth,
                style: lineStyle
            }),
            legendNode
        ]
    });
};
$1c5c4e1a0d68bc50$var$CartesianMarkersItem.defaultProps = {
    legendPosition: "top-right",
    legendOffsetX: 14,
    legendOffsetY: 14,
    legendOrientation: "horizontal"
};
var $1c5c4e1a0d68bc50$export$2b29c35b9bad49e4 = (0, $70fFQ.memo)($1c5c4e1a0d68bc50$var$CartesianMarkersItem);
var $1c5c4e1a0d68bc50$var$CartesianMarkers = function CartesianMarkers(_ref) {
    var markers = _ref.markers, width = _ref.width, height = _ref.height, xScale = _ref.xScale, yScale = _ref.yScale;
    if (!markers || markers.length === 0) return null;
    return markers.map(function(marker, i) {
        return (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$2b29c35b9bad49e4, $1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, marker), {}, {
            width: width,
            height: height,
            scale: marker.axis === "y" ? yScale : xScale
        }), i);
    });
};
var $1c5c4e1a0d68bc50$export$81759e11f9e58ea4 = (0, $70fFQ.memo)($1c5c4e1a0d68bc50$var$CartesianMarkers);
var $1c5c4e1a0d68bc50$export$15d5069d1550e563 = function() {
    return (0, $ejIWb.compose)((0, $ejIWb.defaultProps)({
        margin: $1c5c4e1a0d68bc50$export$6728fea658cfb92e
    }), (0, $ejIWb.setPropTypes)({
        width: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
        margin: $1c5c4e1a0d68bc50$export$5d66dd569e74301b
    }), (0, $ejIWb.withPropsOnChange)(function(props, nextProps) {
        return props.width !== nextProps.width || props.height !== nextProps.height || !(0, (/*@__PURE__*/$parcel$interopDefault($1sXdz)))(props.margin, nextProps.margin);
    }, function(props) {
        var margin = Object.assign({}, $1c5c4e1a0d68bc50$export$6728fea658cfb92e, props.margin);
        return {
            margin: margin,
            width: props.width - margin.left - margin.right,
            height: props.height - margin.top - margin.bottom,
            outerWidth: props.width,
            outerHeight: props.height
        };
    }));
};
var $1c5c4e1a0d68bc50$export$ccaa479bac708af6 = function() {
    return (0, $ejIWb.compose)((0, $ejIWb.setPropTypes)($1c5c4e1a0d68bc50$export$99a092eaa44be1c8), (0, $ejIWb.defaultProps)({
        animate: $1c5c4e1a0d68bc50$export$2785d5ef2943fe58,
        motionDamping: $1c5c4e1a0d68bc50$export$6bb389bedeee99d3,
        motionStiffness: $1c5c4e1a0d68bc50$export$bcf754ee2d5727f7
    }));
};
var $1c5c4e1a0d68bc50$export$e8748c6a27b910dc = function() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$srcKey = _ref.srcKey, srcKey = _ref$srcKey === void 0 ? "theme" : _ref$srcKey, _ref$destKey = _ref.destKey, destKey = _ref$destKey === void 0 ? "theme" : _ref$destKey;
    return (0, $ejIWb.compose)((0, $ejIWb.setPropTypes)($1c5c4e1a0d68bc50$var$_defineProperty({}, srcKey, (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object)), (0, $ejIWb.withPropsOnChange)([
        srcKey
    ], function(props) {
        return $1c5c4e1a0d68bc50$var$_defineProperty({}, destKey, $1c5c4e1a0d68bc50$export$582fa4e2a9b13dde($1c5c4e1a0d68bc50$export$164de7ab8df77ef0, props[srcKey]));
    }));
};
function $1c5c4e1a0d68bc50$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c5c4e1a0d68bc50$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c5c4e1a0d68bc50$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c5c4e1a0d68bc50$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c5c4e1a0d68bc50$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1c5c4e1a0d68bc50$var$_setPrototypeOf(o, p) {
    $1c5c4e1a0d68bc50$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1c5c4e1a0d68bc50$var$_setPrototypeOf(o, p);
}
function $1c5c4e1a0d68bc50$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1c5c4e1a0d68bc50$var$_setPrototypeOf(subClass, superClass);
}
function $1c5c4e1a0d68bc50$var$_getPrototypeOf(o) {
    $1c5c4e1a0d68bc50$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1c5c4e1a0d68bc50$var$_getPrototypeOf(o);
}
function $1c5c4e1a0d68bc50$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1c5c4e1a0d68bc50$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1c5c4e1a0d68bc50$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1c5c4e1a0d68bc50$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1c5c4e1a0d68bc50$var$_typeof(obj);
}
function $1c5c4e1a0d68bc50$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $1c5c4e1a0d68bc50$var$_possibleConstructorReturn(self1, call) {
    if (call && ($1c5c4e1a0d68bc50$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1c5c4e1a0d68bc50$var$_assertThisInitialized(self1);
}
function $1c5c4e1a0d68bc50$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1c5c4e1a0d68bc50$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1c5c4e1a0d68bc50$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1c5c4e1a0d68bc50$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1c5c4e1a0d68bc50$var$_possibleConstructorReturn(this, result);
    };
}
var $1c5c4e1a0d68bc50$export$4cbbe0314aa930ae = function withContainer(WrappedComponent) {
    return function(_Component) {
        $1c5c4e1a0d68bc50$var$_inherits(_class, _Component);
        var _super = $1c5c4e1a0d68bc50$var$_createSuper(_class);
        function _class() {
            $1c5c4e1a0d68bc50$var$_classCallCheck(this, _class);
            return _super.apply(this, arguments);
        }
        $1c5c4e1a0d68bc50$var$_createClass(_class, [
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, theme = _this$props.theme, renderWrapper = _this$props.renderWrapper, animate = _this$props.animate, motionStiffness = _this$props.motionStiffness, motionDamping = _this$props.motionDamping, motionConfig = _this$props.motionConfig, childProps = $1c5c4e1a0d68bc50$var$_objectWithoutProperties(_this$props, [
                        "theme",
                        "renderWrapper",
                        "animate",
                        "motionStiffness",
                        "motionDamping",
                        "motionConfig"
                    ]);
                    return (0, $4x3bm.jsx)($1c5c4e1a0d68bc50$export$42a852a2b6b56249, {
                        theme: theme,
                        renderWrapper: renderWrapper,
                        isInteractive: childProps.isInteractive,
                        animate: animate,
                        motionStiffness: motionStiffness,
                        motionDamping: motionDamping,
                        motionConfig: motionConfig,
                        children: (0, $4x3bm.jsx)(WrappedComponent, $1c5c4e1a0d68bc50$var$_objectSpread2({}, childProps))
                    });
                }
            }
        ]);
        return _class;
    }((0, $70fFQ.Component));
};
var $1c5c4e1a0d68bc50$export$192dc59ac6f86c95 = function getLabelGenerator(_label, labelFormat) {
    var getRawLabel = (0, (/*@__PURE__*/$parcel$interopDefault($dC9tX)))(_label) ? _label : function(d) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(d, _label);
    };
    var formatter;
    if (labelFormat) formatter = (0, (/*@__PURE__*/$parcel$interopDefault($dC9tX)))(labelFormat) ? labelFormat : (0, $hjBRw.format)(labelFormat);
    if (formatter) return function(d) {
        return formatter(getRawLabel(d));
    };
    return getRawLabel;
};
var $1c5c4e1a0d68bc50$export$3cc9373c3cf93eff = function getPropertyAccessor(accessor) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dC9tX)))(accessor) ? accessor : function(d) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(d, accessor);
    };
};
var $1c5c4e1a0d68bc50$export$2d590546cbb7e3ad = function usePropertyAccessor(accessor) {
    return (0, $70fFQ.useMemo)(function() {
        return $1c5c4e1a0d68bc50$export$3cc9373c3cf93eff(accessor);
    }, [
        accessor
    ]);
};
var $1c5c4e1a0d68bc50$export$605481d5cadc9728 = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
];
var $1c5c4e1a0d68bc50$export$d3a11e7b798643fd = function alignBox(box, container, alignment) {
    var deltaX = container.width - box.width;
    var deltaY = container.height - box.height;
    var x = 0;
    var y = 0;
    if (alignment === "center") {
        x = deltaX / 2;
        y = deltaY / 2;
    }
    if (alignment === "top") x = deltaX / 2;
    if (alignment === "top-right") x = deltaX;
    if (alignment === "right") {
        x = deltaX;
        y = deltaY / 2;
    }
    if (alignment === "bottom-right") {
        x = deltaX;
        y = deltaY;
    }
    if (alignment === "bottom") {
        x = deltaX / 2;
        y = deltaY;
    }
    if (alignment === "bottom-left") y = deltaY;
    if (alignment === "left") y = deltaY / 2;
    return [
        x,
        y
    ];
};
var $1c5c4e1a0d68bc50$export$79376507b09a66f = function getDistance(x1, y1, x2, y2) {
    var deltaX = x2 - x1;
    var deltaY = y2 - y1;
    deltaX *= deltaX;
    deltaY *= deltaY;
    return Math.sqrt(deltaX + deltaY);
};
var $1c5c4e1a0d68bc50$export$b363da9ded343252 = function getAngle(x1, y1, x2, y2) {
    var angle = Math.atan2(y2 - y1, x2 - x1) - Math.PI / 2;
    return angle > 0 ? angle : Math.PI * 2 + angle;
};
var $1c5c4e1a0d68bc50$export$be302859f014f482 = function isCursorInRect(x, y, width, height, cursorX, cursorY) {
    return x <= cursorX && cursorX <= x + width && y <= cursorY && cursorY <= y + height;
};
var $1c5c4e1a0d68bc50$export$2396fb9a7906fd81 = function getRelativeCursor(el, event) {
    var clientX = event.clientX, clientY = event.clientY;
    var bounds = el.getBoundingClientRect();
    return [
        clientX - bounds.left,
        clientY - bounds.top
    ];
};
function $1c5c4e1a0d68bc50$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1c5c4e1a0d68bc50$var$_arrayLikeToArray(arr);
}
function $1c5c4e1a0d68bc50$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $1c5c4e1a0d68bc50$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c5c4e1a0d68bc50$var$_toConsumableArray(arr) {
    return $1c5c4e1a0d68bc50$var$_arrayWithoutHoles(arr) || $1c5c4e1a0d68bc50$var$_iterableToArray(arr) || $1c5c4e1a0d68bc50$var$_unsupportedIterableToArray(arr) || $1c5c4e1a0d68bc50$var$_nonIterableSpread();
}
var $1c5c4e1a0d68bc50$var$gradientKeys = Object.keys($1c5c4e1a0d68bc50$export$a3bca081a57901da);
var $1c5c4e1a0d68bc50$var$patternKeys = Object.keys($1c5c4e1a0d68bc50$export$691ec77bd278f3b0);
var $1c5c4e1a0d68bc50$export$468af463e7cc9c6f = function isMatchingDef(predicate, node, dataKey) {
    if (predicate === "*") return true;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($dC9tX)))(predicate)) return predicate(node);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($fnQSe)))(predicate)) {
        var data = dataKey ? (0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(node, dataKey) : node;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1sXdz)))((0, (/*@__PURE__*/$parcel$interopDefault($665Nt)))(data, Object.keys(predicate)), predicate);
    }
    return false;
};
var $1c5c4e1a0d68bc50$export$dc35cf769e3afe34 = function bindDefs(defs, nodes, rules) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {}, dataKey = _ref.dataKey, _ref$colorKey = _ref.colorKey, colorKey = _ref$colorKey === void 0 ? "color" : _ref$colorKey, _ref$targetKey = _ref.targetKey, targetKey = _ref$targetKey === void 0 ? "fill" : _ref$targetKey;
    var boundDefs = [];
    var generatedIds = {};
    if (defs.length && nodes.length) {
        boundDefs = $1c5c4e1a0d68bc50$var$_toConsumableArray(defs);
        nodes.forEach(function(node) {
            var _loop = function _loop(i) {
                var _rules$i = rules[i], id = _rules$i.id, match = _rules$i.match;
                if ($1c5c4e1a0d68bc50$export$468af463e7cc9c6f(match, node, dataKey)) {
                    var def = defs.find(function(_ref2) {
                        var defId = _ref2.id;
                        return defId === id;
                    });
                    if (def) {
                        if ($1c5c4e1a0d68bc50$var$patternKeys.includes(def.type)) {
                            if (def.background === "inherit" || def.color === "inherit") {
                                var nodeColor = (0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(node, colorKey);
                                var background = def.background;
                                var color = def.color;
                                var inheritedId = id;
                                if (def.background === "inherit") {
                                    inheritedId = "".concat(inheritedId, ".bg.").concat(nodeColor);
                                    background = nodeColor;
                                }
                                if (def.color === "inherit") {
                                    inheritedId = "".concat(inheritedId, ".fg.").concat(nodeColor);
                                    color = nodeColor;
                                }
                                (0, (/*@__PURE__*/$parcel$interopDefault($fD80G)))(node, targetKey, "url(#".concat(inheritedId, ")"));
                                if (!generatedIds[inheritedId]) {
                                    boundDefs.push($1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, def), {}, {
                                        id: inheritedId,
                                        background: background,
                                        color: color
                                    }));
                                    generatedIds[inheritedId] = 1;
                                }
                            } else (0, (/*@__PURE__*/$parcel$interopDefault($fD80G)))(node, targetKey, "url(#".concat(id, ")"));
                        } else if ($1c5c4e1a0d68bc50$var$gradientKeys.includes(def.type)) {
                            var allColors = def.colors.map(function(_ref3) {
                                var color = _ref3.color;
                                return color;
                            });
                            if (allColors.includes("inherit")) {
                                var _nodeColor = (0, (/*@__PURE__*/$parcel$interopDefault($k561T)))(node, colorKey);
                                var _inheritedId = id;
                                var inheritedDef = $1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, def), {}, {
                                    colors: def.colors.map(function(colorStop, i) {
                                        if (colorStop.color !== "inherit") return colorStop;
                                        _inheritedId = "".concat(_inheritedId, ".").concat(i, ".").concat(_nodeColor);
                                        return $1c5c4e1a0d68bc50$var$_objectSpread2($1c5c4e1a0d68bc50$var$_objectSpread2({}, colorStop), {}, {
                                            color: colorStop.color === "inherit" ? _nodeColor : colorStop.color
                                        });
                                    })
                                });
                                inheritedDef.id = _inheritedId;
                                (0, (/*@__PURE__*/$parcel$interopDefault($fD80G)))(node, targetKey, "url(#".concat(_inheritedId, ")"));
                                if (!generatedIds[_inheritedId]) {
                                    boundDefs.push(inheritedDef);
                                    generatedIds[_inheritedId] = 1;
                                }
                            } else (0, (/*@__PURE__*/$parcel$interopDefault($fD80G)))(node, targetKey, "url(#".concat(id, ")"));
                        }
                    }
                    return "break";
                }
            };
            for(var i = 0; i < rules.length; i++){
                var _ret = _loop(i);
                if (_ret === "break") break;
            }
        });
    }
    return boundDefs;
};

});
parcelRegister("lITvm", function(module, exports) {

$parcel$export(module.exports, "Chip", function () { return $fd08c31ff76472fa$export$5a7f9a6004988d01; });
$parcel$export(module.exports, "BasicTooltip", function () { return $fd08c31ff76472fa$export$d5f52d71198e271a; });
$parcel$export(module.exports, "TableTooltip", function () { return $fd08c31ff76472fa$export$4b779126465c60ce; });
$parcel$export(module.exports, "Crosshair", function () { return $fd08c31ff76472fa$export$2a195a185c8aa9e; });
$parcel$export(module.exports, "TooltipActionsContext", function () { return $fd08c31ff76472fa$export$d344f0e974db1e2e; });
$parcel$export(module.exports, "TooltipStateContext", function () { return $fd08c31ff76472fa$export$c7027a64d546bf1d; });
$parcel$export(module.exports, "useTooltipHandlers", function () { return $fd08c31ff76472fa$export$85cc26a2c4544aaa; });
$parcel$export(module.exports, "useTooltip", function () { return $fd08c31ff76472fa$export$1c4b08e0eca38426; });
$parcel$export(module.exports, "Tooltip", function () { return $fd08c31ff76472fa$export$28c660c63b792dea; });
$parcel$export(module.exports, "TooltipProvider", function () { return $fd08c31ff76472fa$export$f78649fb9ca566b8; });

var $70fFQ = parcelRequire("70fFQ");

var $eYtn3 = parcelRequire("eYtn3");
var $4ZiMn = parcelRequire("4ZiMn");

var $2qXGl = parcelRequire("2qXGl");

var $4x3bm = parcelRequire("4x3bm");
function $fd08c31ff76472fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fd08c31ff76472fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fd08c31ff76472fa$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fd08c31ff76472fa$var$ownKeys(Object(source), true).forEach(function(key) {
            $fd08c31ff76472fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fd08c31ff76472fa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fd08c31ff76472fa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fd08c31ff76472fa$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fd08c31ff76472fa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fd08c31ff76472fa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fd08c31ff76472fa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fd08c31ff76472fa$var$_arrayLikeToArray(o, minLen);
}
function $fd08c31ff76472fa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fd08c31ff76472fa$var$_slicedToArray(arr, i) {
    return $fd08c31ff76472fa$var$_arrayWithHoles(arr) || $fd08c31ff76472fa$var$_iterableToArrayLimit(arr, i) || $fd08c31ff76472fa$var$_unsupportedIterableToArray(arr, i) || $fd08c31ff76472fa$var$_nonIterableRest();
}
var $fd08c31ff76472fa$var$TOOLTIP_OFFSET = 14;
var $fd08c31ff76472fa$var$tooltipStyle = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
};
var $fd08c31ff76472fa$var$translate = function translate(x, y) {
    return "translate(".concat(x, "px, ").concat(y, "px)");
};
var $fd08c31ff76472fa$export$57a09c4864b20b90 = (0, $70fFQ.memo)(function(_ref) {
    var _animatedProps$transf;
    var position = _ref.position, anchor = _ref.anchor, children = _ref.children;
    var theme = (0, $2qXGl.useTheme)();
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var _useMeasure = (0, $2qXGl.useMeasure)(), _useMeasure2 = $fd08c31ff76472fa$var$_slicedToArray(_useMeasure, 2), measureRef = _useMeasure2[0], bounds = _useMeasure2[1];
    var previousPosition = (0, $70fFQ.useRef)(false);
    var to = undefined;
    var immediate = false;
    var hasDimension = bounds.width > 0 && bounds.height > 0;
    var x = Math.round(position[0]);
    var y = Math.round(position[1]);
    if (hasDimension) {
        if (anchor === "top") {
            x -= bounds.width / 2;
            y -= bounds.height + $fd08c31ff76472fa$var$TOOLTIP_OFFSET;
        } else if (anchor === "right") {
            x += $fd08c31ff76472fa$var$TOOLTIP_OFFSET;
            y -= bounds.height / 2;
        } else if (anchor === "bottom") {
            x -= bounds.width / 2;
            y += $fd08c31ff76472fa$var$TOOLTIP_OFFSET;
        } else if (anchor === "left") {
            x -= bounds.width + $fd08c31ff76472fa$var$TOOLTIP_OFFSET;
            y -= bounds.height / 2;
        } else if (anchor === "center") {
            x -= bounds.width / 2;
            y -= bounds.height / 2;
        }
        to = {
            transform: $fd08c31ff76472fa$var$translate(x, y)
        };
        if (!previousPosition.current) immediate = true;
        previousPosition.current = [
            x,
            y
        ];
    }
    var animatedProps = (0, $4ZiMn.useSpring)({
        to: to,
        config: springConfig,
        immediate: !animate || immediate
    });
    var style = $fd08c31ff76472fa$var$_objectSpread2($fd08c31ff76472fa$var$_objectSpread2($fd08c31ff76472fa$var$_objectSpread2({}, $fd08c31ff76472fa$var$tooltipStyle), theme.tooltip), {}, {
        transform: (_animatedProps$transf = animatedProps.transform) !== null && _animatedProps$transf !== void 0 ? _animatedProps$transf : $fd08c31ff76472fa$var$translate(x, y)
    });
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).div, {
        ref: measureRef,
        style: style,
        children: children
    });
});
$fd08c31ff76472fa$export$57a09c4864b20b90.displayName = "TooltipWrapper";
var $fd08c31ff76472fa$export$5a7f9a6004988d01 = (0, $70fFQ.memo)(function(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 12 : _ref$size, color = _ref.color, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    return (0, $4x3bm.jsx)("span", {
        style: $fd08c31ff76472fa$var$_objectSpread2({
            display: "block",
            width: size,
            height: size,
            background: color
        }, style)
    });
});
var $fd08c31ff76472fa$export$d5f52d71198e271a = (0, $70fFQ.memo)(function(_ref) {
    var id = _ref.id, _value = _ref.value, format = _ref.format, _ref$enableChip = _ref.enableChip, enableChip = _ref$enableChip === void 0 ? false : _ref$enableChip, color = _ref.color, renderContent = _ref.renderContent;
    var theme = (0, $2qXGl.useTheme)();
    var formatValue = (0, $2qXGl.useValueFormatter)(format);
    var content;
    if (typeof renderContent === "function") content = renderContent();
    else {
        var value = _value;
        if (formatValue !== undefined && value !== undefined) value = formatValue(value);
        content = (0, $4x3bm.jsxs)("div", {
            style: theme.tooltip.basic,
            children: [
                enableChip && (0, $4x3bm.jsx)($fd08c31ff76472fa$export$5a7f9a6004988d01, {
                    color: color,
                    style: theme.tooltip.chip
                }),
                value !== undefined ? (0, $4x3bm.jsxs)("span", {
                    children: [
                        id,
                        ": ",
                        (0, $4x3bm.jsx)("strong", {
                            children: "".concat(value)
                        })
                    ]
                }) : id
            ]
        });
    }
    return (0, $4x3bm.jsx)("div", {
        style: theme.tooltip.container,
        children: content
    });
});
var $fd08c31ff76472fa$var$tableStyle = {
    width: "100%",
    borderCollapse: "collapse"
};
var $fd08c31ff76472fa$export$4b779126465c60ce = (0, $70fFQ.memo)(function(_ref) {
    var title = _ref.title, _ref$rows = _ref.rows, rows = _ref$rows === void 0 ? [] : _ref$rows, renderContent = _ref.renderContent;
    var theme = (0, $2qXGl.useTheme)();
    if (!rows.length) return null;
    var content;
    if (typeof renderContent === "function") content = renderContent();
    else content = (0, $4x3bm.jsxs)("div", {
        children: [
            title && title,
            (0, $4x3bm.jsx)("table", {
                style: $fd08c31ff76472fa$var$_objectSpread2($fd08c31ff76472fa$var$_objectSpread2({}, $fd08c31ff76472fa$var$tableStyle), theme.tooltip.table),
                children: (0, $4x3bm.jsx)("tbody", {
                    children: rows.map(function(row, i) {
                        return (0, $4x3bm.jsx)("tr", {
                            children: row.map(function(column, j) {
                                return (0, $4x3bm.jsx)("td", {
                                    style: theme.tooltip.tableCell,
                                    children: column
                                }, j);
                            })
                        }, i);
                    })
                })
            })
        ]
    });
    return (0, $4x3bm.jsx)("div", {
        style: theme.tooltip.container,
        children: content
    });
});
$fd08c31ff76472fa$export$4b779126465c60ce.displayName = "TableTooltip";
var $fd08c31ff76472fa$var$CrosshairLine = (0, $70fFQ.memo)(function(_ref) {
    var x0 = _ref.x0, x1 = _ref.x1, y0 = _ref.y0, y1 = _ref.y1;
    var theme = (0, $2qXGl.useTheme)();
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var style = (0, $70fFQ.useMemo)(function() {
        return $fd08c31ff76472fa$var$_objectSpread2($fd08c31ff76472fa$var$_objectSpread2({}, theme.crosshair.line), {}, {
            pointerEvents: "none"
        });
    }, [
        theme.crosshair.line
    ]);
    var animatedProps = (0, $4ZiMn.useSpring)({
        x1: x0,
        x2: x1,
        y1: y0,
        y2: y1,
        config: springConfig,
        immediate: !animate
    });
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).line, $fd08c31ff76472fa$var$_objectSpread2($fd08c31ff76472fa$var$_objectSpread2({}, animatedProps), {}, {
        fill: "none",
        style: style
    }));
});
$fd08c31ff76472fa$var$CrosshairLine.displayName = "CrosshairLine";
var $fd08c31ff76472fa$export$2a195a185c8aa9e = (0, $70fFQ.memo)(function(_ref) {
    var width = _ref.width, height = _ref.height, type = _ref.type, x = _ref.x, y = _ref.y;
    var xLine;
    var yLine;
    if (type === "cross") {
        xLine = {
            x0: x,
            x1: x,
            y0: 0,
            y1: height
        };
        yLine = {
            x0: 0,
            x1: width,
            y0: y,
            y1: y
        };
    } else if (type === "top-left") {
        xLine = {
            x0: x,
            x1: x,
            y0: 0,
            y1: y
        };
        yLine = {
            x0: 0,
            x1: x,
            y0: y,
            y1: y
        };
    } else if (type === "top") xLine = {
        x0: x,
        x1: x,
        y0: 0,
        y1: y
    };
    else if (type === "top-right") {
        xLine = {
            x0: x,
            x1: x,
            y0: 0,
            y1: y
        };
        yLine = {
            x0: x,
            x1: width,
            y0: y,
            y1: y
        };
    } else if (type === "right") yLine = {
        x0: x,
        x1: width,
        y0: y,
        y1: y
    };
    else if (type === "bottom-right") {
        xLine = {
            x0: x,
            x1: x,
            y0: y,
            y1: height
        };
        yLine = {
            x0: x,
            x1: width,
            y0: y,
            y1: y
        };
    } else if (type === "bottom") xLine = {
        x0: x,
        x1: x,
        y0: y,
        y1: height
    };
    else if (type === "bottom-left") {
        xLine = {
            x0: x,
            x1: x,
            y0: y,
            y1: height
        };
        yLine = {
            x0: 0,
            x1: x,
            y0: y,
            y1: y
        };
    } else if (type === "left") yLine = {
        x0: 0,
        x1: x,
        y0: y,
        y1: y
    };
    else if (type === "x") xLine = {
        x0: x,
        x1: x,
        y0: 0,
        y1: height
    };
    else if (type === "y") yLine = {
        x0: 0,
        x1: width,
        y0: y,
        y1: y
    };
    return (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            xLine && (0, $4x3bm.jsx)($fd08c31ff76472fa$var$CrosshairLine, {
                x0: xLine.x0,
                x1: xLine.x1,
                y0: xLine.y0,
                y1: xLine.y1
            }),
            yLine && (0, $4x3bm.jsx)($fd08c31ff76472fa$var$CrosshairLine, {
                x0: yLine.x0,
                x1: yLine.x1,
                y0: yLine.y0,
                y1: yLine.y1
            })
        ]
    });
});
$fd08c31ff76472fa$export$2a195a185c8aa9e.displayName = "Crosshair";
var $fd08c31ff76472fa$var$defaultActions = {
    showTooltipAt: function showTooltipAt() {},
    showTooltipFromEvent: function showTooltipFromEvent() {},
    hideTooltip: function hideTooltip() {}
};
var $fd08c31ff76472fa$export$d344f0e974db1e2e = (0, $70fFQ.createContext)($fd08c31ff76472fa$var$defaultActions);
var $fd08c31ff76472fa$export$3a517200cf5bfc1b = {
    isVisible: false,
    position: [
        null,
        null
    ],
    content: null,
    anchor: null
};
var $fd08c31ff76472fa$export$c7027a64d546bf1d = (0, $70fFQ.createContext)($fd08c31ff76472fa$export$3a517200cf5bfc1b);
var $fd08c31ff76472fa$export$85cc26a2c4544aaa = function useTooltipHandlers(container) {
    var _useState = (0, $70fFQ.useState)($fd08c31ff76472fa$export$3a517200cf5bfc1b), _useState2 = $fd08c31ff76472fa$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var showTooltipAt = (0, $70fFQ.useCallback)(function(content, _ref) {
        var _ref2 = $fd08c31ff76472fa$var$_slicedToArray(_ref, 2), x = _ref2[0], y = _ref2[1];
        var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "top";
        setState({
            isVisible: true,
            position: [
                x,
                y
            ],
            anchor: anchor,
            content: content
        });
    }, [
        setState
    ]);
    var showTooltipFromEvent = (0, $70fFQ.useCallback)(function(content, event) {
        var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "top";
        var bounds = container.current.getBoundingClientRect();
        var x = event.clientX - bounds.left;
        var y = event.clientY - bounds.top;
        if (anchor === "left" || anchor === "right") {
            if (x < bounds.width / 2) anchor = "right";
            else anchor = "left";
        }
        setState({
            isVisible: true,
            position: [
                x,
                y
            ],
            anchor: anchor,
            content: content
        });
    }, [
        container,
        setState
    ]);
    var hideTooltip = (0, $70fFQ.useCallback)(function() {
        setState($fd08c31ff76472fa$export$3a517200cf5bfc1b);
    }, [
        setState
    ]);
    var actions = (0, $70fFQ.useMemo)(function() {
        return {
            showTooltipAt: showTooltipAt,
            showTooltipFromEvent: showTooltipFromEvent,
            hideTooltip: hideTooltip
        };
    }, [
        showTooltipAt,
        showTooltipFromEvent,
        hideTooltip
    ]);
    return {
        actions: actions,
        state: state
    };
};
var $fd08c31ff76472fa$export$1c4b08e0eca38426 = function useTooltip() {
    var context = (0, $70fFQ.useContext)($fd08c31ff76472fa$export$d344f0e974db1e2e);
    if (context === undefined) throw new Error("useTooltip must be used within a TooltipProvider");
    return context;
};
var $fd08c31ff76472fa$export$b6b30c61d706ffee = function useTooltipState() {
    var context = (0, $70fFQ.useContext)($fd08c31ff76472fa$export$c7027a64d546bf1d);
    if (context === undefined) throw new Error("useTooltipState must be used within a TooltipProvider");
    return context;
};
var $fd08c31ff76472fa$export$dd4f39ed288d94c9 = function isVisibleTooltipState(state) {
    return state.isVisible;
};
var $fd08c31ff76472fa$export$28c660c63b792dea = function Tooltip() {
    var state = $fd08c31ff76472fa$export$b6b30c61d706ffee();
    if (!$fd08c31ff76472fa$export$dd4f39ed288d94c9(state)) return null;
    return (0, $4x3bm.jsx)($fd08c31ff76472fa$export$57a09c4864b20b90, {
        position: state.position,
        anchor: state.anchor,
        children: state.content
    });
};
var $fd08c31ff76472fa$export$f78649fb9ca566b8 = function TooltipProvider(_ref) {
    var container = _ref.container, children = _ref.children;
    var _useTooltipHandlers = $fd08c31ff76472fa$export$85cc26a2c4544aaa(container), actions = _useTooltipHandlers.actions, state = _useTooltipHandlers.state;
    return (0, $4x3bm.jsx)($fd08c31ff76472fa$export$d344f0e974db1e2e.Provider, {
        value: actions,
        children: (0, $4x3bm.jsx)($fd08c31ff76472fa$export$c7027a64d546bf1d.Provider, {
            value: state,
            children: children
        })
    });
};

});
parcelRegister("eYtn3", function(module, exports) {
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("jZS6F")).Globals; });
$parcel$export(module.exports, "to", function () { return (parcelRequire("4ZiMn")).to; });
$parcel$export(module.exports, "useSpring", function () { return (parcelRequire("4ZiMn")).useSpring; });
$parcel$export(module.exports, "useTransition", function () { return (parcelRequire("4ZiMn")).useTransition; });

$parcel$export(module.exports, "animated", function () { return $ae6d73bc174a0887$export$407448d2b89b1813; });
parcelRequire("4ZiMn");
var $jZS6F = parcelRequire("jZS6F");

var $3glZ1 = parcelRequire("3glZ1");

var $jZS6F = parcelRequire("jZS6F");

var $2hAeX = parcelRequire("2hAeX");
function $ae6d73bc174a0887$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $ae6d73bc174a0887$var$_excluded$2 = [
    "style",
    "children",
    "scrollTop",
    "scrollLeft"
];
const $ae6d73bc174a0887$var$isCustomPropRE = /^--/;
function $ae6d73bc174a0887$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$ae6d73bc174a0887$var$isCustomPropRE.test(name) && !($ae6d73bc174a0887$var$isUnitlessNumber.hasOwnProperty(name) && $ae6d73bc174a0887$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
const $ae6d73bc174a0887$var$attributeCache = {};
function $ae6d73bc174a0887$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const _ref = props, { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft } = _ref, attributes = $ae6d73bc174a0887$var$_objectWithoutPropertiesLoose(_ref, $ae6d73bc174a0887$var$_excluded$2);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $ae6d73bc174a0887$var$attributeCache[name] || ($ae6d73bc174a0887$var$attributeCache[name] = name.replace(/([A-Z])/g, (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(let name in style)if (style.hasOwnProperty(name)) {
        const value = $ae6d73bc174a0887$var$dangerousStyleValue(name, style[name]);
        if ($ae6d73bc174a0887$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
}
let $ae6d73bc174a0887$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
const $ae6d73bc174a0887$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
const $ae6d73bc174a0887$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$ae6d73bc174a0887$var$isUnitlessNumber = Object.keys($ae6d73bc174a0887$var$isUnitlessNumber).reduce((acc, prop)=>{
    $ae6d73bc174a0887$var$prefixes.forEach((prefix)=>acc[$ae6d73bc174a0887$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $ae6d73bc174a0887$var$isUnitlessNumber);
const $ae6d73bc174a0887$var$_excluded$1 = [
    "x",
    "y",
    "z"
];
const $ae6d73bc174a0887$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const $ae6d73bc174a0887$var$pxTransforms = /^(translate)/;
const $ae6d73bc174a0887$var$degTransforms = /^(rotate|skew)/;
const $ae6d73bc174a0887$var$addUnit = (value, unit)=>(0, $jZS6F.is).num(value) && value !== 0 ? value + unit : value;
const $ae6d73bc174a0887$var$isValueIdentity = (value, id)=>(0, $jZS6F.is).arr(value) ? value.every((v)=>$ae6d73bc174a0887$var$isValueIdentity(v, id)) : (0, $jZS6F.is).num(value) ? value === id : parseFloat(value) === id;
class $ae6d73bc174a0887$var$AnimatedStyle extends (0, $2hAeX.AnimatedObject) {
    constructor(_ref){
        let { x: x, y: y, z: z } = _ref, style = $ae6d73bc174a0887$var$_objectWithoutPropertiesLoose(_ref, $ae6d73bc174a0887$var$_excluded$1);
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$ae6d73bc174a0887$var$addUnit(v, "px")).join(",")})`,
                    $ae6d73bc174a0887$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $jZS6F.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($ae6d73bc174a0887$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $jZS6F.is).und(value)) return;
                const unit = $ae6d73bc174a0887$var$pxTransforms.test(key) ? "px" : $ae6d73bc174a0887$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $jZS6F.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x, y, z, deg])=>[
                        `rotate3d(${x},${y},${z},${$ae6d73bc174a0887$var$addUnit(deg, unit)})`,
                        $ae6d73bc174a0887$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$ae6d73bc174a0887$var$addUnit(v, unit)).join(",")})`,
                        $ae6d73bc174a0887$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $ae6d73bc174a0887$var$FluidTransform(inputs, transforms);
        super(style);
    }
}
class $ae6d73bc174a0887$var$FluidTransform extends (0, $jZS6F.FluidValue) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $jZS6F.each)(this.inputs, (input, i)=>{
            const arg1 = (0, $jZS6F.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, $jZS6F.is).arr(arg1) ? arg1 : input.map((0, $jZS6F.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    observerAdded(count) {
        if (count == 1) (0, $jZS6F.each)(this.inputs, (input)=>(0, $jZS6F.each)(input, (value)=>(0, $jZS6F.hasFluidValue)(value) && (0, $jZS6F.addFluidObserver)(value, this)));
    }
    observerRemoved(count) {
        if (count == 0) (0, $jZS6F.each)(this.inputs, (input)=>(0, $jZS6F.each)(input, (value)=>(0, $jZS6F.hasFluidValue)(value) && (0, $jZS6F.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $jZS6F.callFluidObservers)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this._value = null;
        this.inputs = inputs;
        this.transforms = transforms;
    }
}
const $ae6d73bc174a0887$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
const $ae6d73bc174a0887$var$_excluded = [
    "scrollTop",
    "scrollLeft"
];
(0, $jZS6F.Globals).assign({
    batchedUpdates: (0, $3glZ1.unstable_batchedUpdates),
    createStringInterpolator: $jZS6F.createStringInterpolator,
    colors: $jZS6F.colors
});
const $ae6d73bc174a0887$var$host = (0, $2hAeX.createHost)($ae6d73bc174a0887$var$primitives, {
    applyAnimatedValues: $ae6d73bc174a0887$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $ae6d73bc174a0887$var$AnimatedStyle(style),
    getComponentProps: (_ref)=>{
        let props = $ae6d73bc174a0887$var$_objectWithoutPropertiesLoose(_ref, $ae6d73bc174a0887$var$_excluded);
        return props;
    }
});
const $ae6d73bc174a0887$export$407448d2b89b1813 = $ae6d73bc174a0887$var$host.animated;

});
parcelRegister("4ZiMn", function(module, exports) {

$parcel$export(module.exports, "useSpring", function () { return $3a1b6d1b1e4a1199$export$c4af9125706c4d30; });
$parcel$export(module.exports, "useTransition", function () { return $3a1b6d1b1e4a1199$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "to", function () { return $3a1b6d1b1e4a1199$export$2c618a4308a30424; });
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("jZS6F")).Globals; });

var $jZS6F = parcelRequire("jZS6F");
var $bUNLs = parcelRequire("bUNLs");

var $70fFQ = parcelRequire("70fFQ");

var $2hAeX = parcelRequire("2hAeX");

var $cJLRh = parcelRequire("cJLRh");

var $fTEGT = parcelRequire("fTEGT");
function $3a1b6d1b1e4a1199$var$_extends() {
    $3a1b6d1b1e4a1199$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a1b6d1b1e4a1199$var$_extends.apply(this, arguments);
}
function $3a1b6d1b1e4a1199$var$callProp(value, ...args) {
    return (0, $jZS6F.is).fun(value) ? value(...args) : value;
}
const $3a1b6d1b1e4a1199$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $jZS6F.is).fun(value) ? value(key) : (0, $jZS6F.toArray)(value).includes(key)));
const $3a1b6d1b1e4a1199$var$resolveProp = (prop, key)=>(0, $jZS6F.is).obj(prop) ? key && prop[key] : prop;
const $3a1b6d1b1e4a1199$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : undefined;
const $3a1b6d1b1e4a1199$var$noopTransform = (value)=>value;
const $3a1b6d1b1e4a1199$var$getDefaultProps = (props, transform = $3a1b6d1b1e4a1199$var$noopTransform)=>{
    let keys = $3a1b6d1b1e4a1199$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $jZS6F.is).und(value)) defaults[key] = value;
    }
    return defaults;
};
const $3a1b6d1b1e4a1199$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
const $3a1b6d1b1e4a1199$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
};
function $3a1b6d1b1e4a1199$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $jZS6F.eachProp)(props, (value, prop)=>{
        if (!$3a1b6d1b1e4a1199$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $3a1b6d1b1e4a1199$export$b971039a739bf227(props) {
    const to = $3a1b6d1b1e4a1199$var$getForwardProps(props);
    if (to) {
        const out = {
            to: to
        };
        (0, $jZS6F.eachProp)(props, (val, key)=>key in to || (out[key] = val));
        return out;
    }
    return $3a1b6d1b1e4a1199$var$_extends({}, props);
}
function $3a1b6d1b1e4a1199$var$computeGoal(value) {
    value = (0, $jZS6F.getFluidValue)(value);
    return (0, $jZS6F.is).arr(value) ? value.map($3a1b6d1b1e4a1199$var$computeGoal) : (0, $jZS6F.isAnimatedString)(value) ? (0, $jZS6F.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $3a1b6d1b1e4a1199$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $3a1b6d1b1e4a1199$var$isAsyncTo(to) {
    return (0, $jZS6F.is).fun(to) || (0, $jZS6F.is).arr(to) && (0, $jZS6F.is).obj(to[0]);
}
function $3a1b6d1b1e4a1199$var$detachRefs(ctrl, ref) {
    var _ctrl$ref;
    (_ctrl$ref = ctrl.ref) == null || _ctrl$ref.delete(ctrl);
    ref == null || ref.delete(ctrl);
}
function $3a1b6d1b1e4a1199$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl$ref2;
        (_ctrl$ref2 = ctrl.ref) == null || _ctrl$ref2.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
function $3a1b6d1b1e4a1199$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1000) {
    (0, $jZS6F.useLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $jZS6F.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $jZS6F.each)(controllers, (ctrl)=>{
                        (0, $jZS6F.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $3a1b6d1b1e4a1199$var$callProp(memoizedDelayProp || 0, key);
                        });
                        ctrl.start();
                    });
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $jZS6F.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $jZS6F.each)(controllers, (ctrl, i)=>(0, $jZS6F.each)(queues[i] || [], (update)=>ctrl.queue.push(update)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
const $3a1b6d1b1e4a1199$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
const $3a1b6d1b1e4a1199$var$linear = (t)=>t;
const $3a1b6d1b1e4a1199$var$defaults = $3a1b6d1b1e4a1199$var$_extends({}, $3a1b6d1b1e4a1199$export$e506a1d27d1eaa20.default, {
    mass: 1,
    damping: 1,
    easing: $3a1b6d1b1e4a1199$var$linear,
    clamp: false
});
class $3a1b6d1b1e4a1199$var$AnimationConfig {
    constructor(){
        this.tension = void 0;
        this.friction = void 0;
        this.frequency = void 0;
        this.damping = void 0;
        this.mass = void 0;
        this.velocity = 0;
        this.restVelocity = void 0;
        this.precision = void 0;
        this.progress = void 0;
        this.duration = void 0;
        this.easing = void 0;
        this.clamp = void 0;
        this.bounce = void 0;
        this.decay = void 0;
        this.round = void 0;
        Object.assign(this, $3a1b6d1b1e4a1199$var$defaults);
    }
}
function $3a1b6d1b1e4a1199$var$mergeConfig(config, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = $3a1b6d1b1e4a1199$var$_extends({}, defaultConfig);
        $3a1b6d1b1e4a1199$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = $3a1b6d1b1e4a1199$var$_extends({}, defaultConfig, newConfig);
    }
    $3a1b6d1b1e4a1199$var$sanitizeConfig(config, newConfig);
    Object.assign(config, newConfig);
    for(const key in $3a1b6d1b1e4a1199$var$defaults)if (config[key] == null) config[key] = $3a1b6d1b1e4a1199$var$defaults[key];
    let { mass: mass, frequency: frequency, damping: damping } = config;
    if (!(0, $jZS6F.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config;
}
function $3a1b6d1b1e4a1199$var$sanitizeConfig(config, props) {
    if (!(0, $jZS6F.is).und(props.decay)) config.duration = undefined;
    else {
        const isTensionConfig = !(0, $jZS6F.is).und(props.tension) || !(0, $jZS6F.is).und(props.friction);
        if (isTensionConfig || !(0, $jZS6F.is).und(props.frequency) || !(0, $jZS6F.is).und(props.damping) || !(0, $jZS6F.is).und(props.mass)) {
            config.duration = undefined;
            config.decay = undefined;
        }
        if (isTensionConfig) config.frequency = undefined;
    }
}
const $3a1b6d1b1e4a1199$var$emptyArray = [];
class $3a1b6d1b1e4a1199$var$Animation {
    constructor(){
        this.changed = false;
        this.values = $3a1b6d1b1e4a1199$var$emptyArray;
        this.toValues = null;
        this.fromValues = $3a1b6d1b1e4a1199$var$emptyArray;
        this.to = void 0;
        this.from = void 0;
        this.config = new $3a1b6d1b1e4a1199$var$AnimationConfig();
        this.immediate = false;
    }
}
function $3a1b6d1b1e4a1199$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        var _props$cancel;
        let delay;
        let timeout;
        let cancel = $3a1b6d1b1e4a1199$var$matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $jZS6F.is).und(props.pause)) state.paused = $3a1b6d1b1e4a1199$var$matchProp(props.pause, key);
            let pause = defaultProps == null ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $3a1b6d1b1e4a1199$var$matchProp(pause, key);
            delay = $3a1b6d1b1e4a1199$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $bUNLs.raf).now();
        }
        function onResume() {
            if (delay > 0) {
                timeout = (0, $bUNLs.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start($3a1b6d1b1e4a1199$var$_extends({}, props, {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
const $3a1b6d1b1e4a1199$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $3a1b6d1b1e4a1199$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $3a1b6d1b1e4a1199$var$getNoopResult(target.get()) : $3a1b6d1b1e4a1199$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
const $3a1b6d1b1e4a1199$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
const $3a1b6d1b1e4a1199$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
const $3a1b6d1b1e4a1199$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
function $3a1b6d1b1e4a1199$var$runAsync(to, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to;
        const defaultProps = $3a1b6d1b1e4a1199$var$getDefaultProps(props, (value, key)=>key === "onRest" ? undefined : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = callId <= (state.cancelId || 0) && $3a1b6d1b1e4a1199$var$getCancelledResult(target) || callId !== state.asyncId && $3a1b6d1b1e4a1199$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $3a1b6d1b1e4a1199$export$d362d093fa99dc7();
            const skipAnimationSignal = new $3a1b6d1b1e4a1199$var$SkipAniamtionSignal();
            return (async ()=>{
                if ((0, $jZS6F.Globals).skipAnimation) {
                    $3a1b6d1b1e4a1199$var$stopAsync(state);
                    skipAnimationSignal.result = $3a1b6d1b1e4a1199$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props = (0, $jZS6F.is).obj(arg1) ? $3a1b6d1b1e4a1199$var$_extends({}, arg1) : $3a1b6d1b1e4a1199$var$_extends({}, arg2, {
                    to: arg1
                });
                props.parentId = callId;
                (0, $jZS6F.eachProp)(defaultProps, (value, key)=>{
                    if ((0, $jZS6F.is).und(props[key])) props[key] = value;
                });
                const result = await target.start(props);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result;
            })();
        };
        let result;
        if ((0, $jZS6F.Globals).skipAnimation) {
            $3a1b6d1b1e4a1199$var$stopAsync(state);
            return $3a1b6d1b1e4a1199$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $jZS6F.is).arr(to)) animating = (async (queue)=>{
                for (const props of queue)await animate(props);
            })(to);
            else animating = Promise.resolve(to(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $3a1b6d1b1e4a1199$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $3a1b6d1b1e4a1199$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $3a1b6d1b1e4a1199$var$SkipAniamtionSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : undefined;
                state.promise = parentId ? prevPromise : undefined;
            }
        }
        if ((0, $jZS6F.is).fun(onRest)) (0, $bUNLs.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $3a1b6d1b1e4a1199$var$stopAsync(state, cancelId) {
    (0, $jZS6F.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = undefined;
    if (cancelId) state.cancelId = cancelId;
}
class $3a1b6d1b1e4a1199$export$d362d093fa99dc7 extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
        this.result = void 0;
    }
}
class $3a1b6d1b1e4a1199$var$SkipAniamtionSignal extends Error {
    constructor(){
        super("SkipAnimationSignal");
        this.result = void 0;
    }
}
const $3a1b6d1b1e4a1199$var$isFrameValue = (value)=>value instanceof $3a1b6d1b1e4a1199$export$8229896f80e2495e;
let $3a1b6d1b1e4a1199$var$nextId$1 = 1;
class $3a1b6d1b1e4a1199$export$8229896f80e2495e extends (0, $jZS6F.FluidValue) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    get() {
        const node = (0, $2hAeX.getAnimated)(this);
        return node && node.getValue();
    }
    to(...args) {
        return (0, $jZS6F.Globals).to(this, args);
    }
    interpolate(...args) {
        (0, $jZS6F.deprecateInterpolate)();
        return (0, $jZS6F.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    _attach() {}
    _detach() {}
    _onChange(value, idle = false) {
        (0, $jZS6F.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    _onPriorityChange(priority) {
        if (!this.idle) (0, $jZS6F.frameLoop).sort(this);
        (0, $jZS6F.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(...args){
        super(...args);
        this.id = $3a1b6d1b1e4a1199$var$nextId$1++;
        this.key = void 0;
        this._priority = 0;
    }
}
const $3a1b6d1b1e4a1199$var$$P = Symbol.for("SpringPhase");
const $3a1b6d1b1e4a1199$var$HAS_ANIMATED = 1;
const $3a1b6d1b1e4a1199$var$IS_ANIMATING = 2;
const $3a1b6d1b1e4a1199$var$IS_PAUSED = 4;
const $3a1b6d1b1e4a1199$var$hasAnimated = (target)=>(target[$3a1b6d1b1e4a1199$var$$P] & $3a1b6d1b1e4a1199$var$HAS_ANIMATED) > 0;
const $3a1b6d1b1e4a1199$var$isAnimating = (target)=>(target[$3a1b6d1b1e4a1199$var$$P] & $3a1b6d1b1e4a1199$var$IS_ANIMATING) > 0;
const $3a1b6d1b1e4a1199$var$isPaused = (target)=>(target[$3a1b6d1b1e4a1199$var$$P] & $3a1b6d1b1e4a1199$var$IS_PAUSED) > 0;
const $3a1b6d1b1e4a1199$var$setActiveBit = (target, active)=>active ? target[$3a1b6d1b1e4a1199$var$$P] |= $3a1b6d1b1e4a1199$var$IS_ANIMATING | $3a1b6d1b1e4a1199$var$HAS_ANIMATED : target[$3a1b6d1b1e4a1199$var$$P] &= ~$3a1b6d1b1e4a1199$var$IS_ANIMATING;
const $3a1b6d1b1e4a1199$var$setPausedBit = (target, paused)=>paused ? target[$3a1b6d1b1e4a1199$var$$P] |= $3a1b6d1b1e4a1199$var$IS_PAUSED : target[$3a1b6d1b1e4a1199$var$$P] &= ~$3a1b6d1b1e4a1199$var$IS_PAUSED;
class $3a1b6d1b1e4a1199$export$5854d13427d5a954 extends $3a1b6d1b1e4a1199$export$8229896f80e2495e {
    get idle() {
        return !($3a1b6d1b1e4a1199$var$isAnimating(this) || this._state.asyncTo) || $3a1b6d1b1e4a1199$var$isPaused(this);
    }
    get goal() {
        return (0, $jZS6F.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, $2hAeX.getAnimated)(this);
        return node instanceof (0, $2hAeX.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node)=>node.lastVelocity || 0);
    }
    get hasAnimated() {
        return $3a1b6d1b1e4a1199$var$hasAnimated(this);
    }
    get isAnimating() {
        return $3a1b6d1b1e4a1199$var$isAnimating(this);
    }
    get isPaused() {
        return $3a1b6d1b1e4a1199$var$isPaused(this);
    }
    advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { config: config, toValues: toValues } = anim;
        const payload = (0, $2hAeX.getPayload)(anim.to);
        if (!payload && (0, $jZS6F.hasFluidValue)(anim.to)) toValues = (0, $jZS6F.toArray)((0, $jZS6F.getFluidValue)(anim.to));
        anim.values.forEach((node, i)=>{
            if (node.done) return;
            const to = node.constructor == (0, $2hAeX.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to;
            if (!finished) {
                position = node.lastPosition;
                if (config.tension <= 0) {
                    node.done = true;
                    return;
                }
                let elapsed = node.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node.v0 != null ? node.v0 : node.v0 = (0, $jZS6F.is).arr(config.velocity) ? config.velocity[i] : config.velocity;
                let velocity;
                if (!(0, $jZS6F.is).und(config.duration)) {
                    let p = 1;
                    if (config.duration > 0) {
                        if (this._memoizedDuration !== config.duration) {
                            this._memoizedDuration = config.duration;
                            if (node.durationProgress > 0) {
                                node.elapsedTime = config.duration * node.durationProgress;
                                elapsed = node.elapsedTime += dt;
                            }
                        }
                        p = (config.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node.durationProgress = p;
                    }
                    position = from + config.easing(p) * (to - from);
                    velocity = (position - node.lastPosition) / dt;
                    finished = p == 1;
                } else if (config.decay) {
                    const decay = config.decay === true ? 0.998 : config.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node.lastPosition - position) < 0.1;
                    velocity = v0 * e;
                } else {
                    velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
                    const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
                    const restVelocity = config.restVelocity || precision / 10;
                    const bounceFactor = config.clamp ? 0 : config.bounce;
                    const canBounce = !(0, $jZS6F.is).und(bounceFactor);
                    const isGrowing = from == to ? node.v0 > 0 : from < to;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to || position > to == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to;
                            }
                        }
                        const springForce = -config.tension * 0.000001 * (position - to);
                        const dampingForce = -config.friction * 0.001 * velocity;
                        const acceleration = (springForce + dampingForce) / config.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node.done = true;
            else idle = false;
            if (node.setValue(position, config.round)) changed = true;
        });
        const node = (0, $2hAeX.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $jZS6F.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    set(value) {
        (0, $bUNLs.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    pause() {
        this._update({
            pause: true
        });
    }
    resume() {
        this._update({
            pause: false
        });
    }
    finish() {
        if ($3a1b6d1b1e4a1199$var$isAnimating(this)) {
            const { to: to, config: config } = this.animation;
            (0, $bUNLs.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config.decay) this._set(to, false);
                this._stop();
            });
        }
        return this;
    }
    update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to, arg2) {
        let queue;
        if (!(0, $jZS6F.is).und(to)) queue = [
            (0, $jZS6F.is).obj(to) ? to : $3a1b6d1b1e4a1199$var$_extends({}, arg2, {
                to: to
            })
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>this._update(props))).then((results)=>$3a1b6d1b1e4a1199$var$getCombinedResult(this, results));
    }
    stop(cancel) {
        const { to: to } = this.animation;
        this._focus(this.get());
        $3a1b6d1b1e4a1199$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $bUNLs.raf).batchedUpdates(()=>this._stop(to, cancel));
        return this;
    }
    reset() {
        this._update({
            reset: true
        });
    }
    eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    _prepareNode(props) {
        const key = this.key || "";
        let { to: to, from: from } = props;
        to = (0, $jZS6F.is).obj(to) ? to[key] : to;
        if (to == null || $3a1b6d1b1e4a1199$var$isAsyncTo(to)) to = undefined;
        from = (0, $jZS6F.is).obj(from) ? from[key] : from;
        if (from == null) from = undefined;
        const range = {
            to: to,
            from: from
        };
        if (!$3a1b6d1b1e4a1199$var$hasAnimated(this)) {
            if (props.reverse) [to, from] = [
                from,
                to
            ];
            from = (0, $jZS6F.getFluidValue)(from);
            if (!(0, $jZS6F.is).und(from)) this._set(from);
            else if (!(0, $2hAeX.getAnimated)(this)) this._set(to);
        }
        return range;
    }
    _update(_ref, isLoop) {
        let props = $3a1b6d1b1e4a1199$var$_extends({}, _ref);
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $3a1b6d1b1e4a1199$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $3a1b6d1b1e4a1199$var$resolveProp(value, key) : value));
        $3a1b6d1b1e4a1199$var$mergeActiveFn(this, props, "onProps");
        $3a1b6d1b1e4a1199$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $3a1b6d1b1e4a1199$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$3a1b6d1b1e4a1199$var$isPaused(this)) {
                        $3a1b6d1b1e4a1199$var$setPausedBit(this, true);
                        (0, $jZS6F.flushCalls)(state.pauseQueue);
                        $3a1b6d1b1e4a1199$var$sendEvent(this, "onPause", $3a1b6d1b1e4a1199$var$getFinishedResult(this, $3a1b6d1b1e4a1199$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($3a1b6d1b1e4a1199$var$isPaused(this)) {
                        $3a1b6d1b1e4a1199$var$setPausedBit(this, false);
                        if ($3a1b6d1b1e4a1199$var$isAnimating(this)) this._resume();
                        (0, $jZS6F.flushCalls)(state.resumeQueue);
                        $3a1b6d1b1e4a1199$var$sendEvent(this, "onResume", $3a1b6d1b1e4a1199$var$getFinishedResult(this, $3a1b6d1b1e4a1199$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $3a1b6d1b1e4a1199$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($3a1b6d1b1e4a1199$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $jZS6F.is).und(range.to);
        const hasFromProp = !(0, $jZS6F.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($3a1b6d1b1e4a1199$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $jZS6F.is).und(to))) to = from;
        if (props.reverse) [to, from] = [
            from,
            to
        ];
        const hasFromChanged = !(0, $jZS6F.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $jZS6F.getFluidValue)(from);
        const hasToChanged = !(0, $jZS6F.isEqual)(to, prevTo);
        if (hasToChanged) this._focus(to);
        const hasAsyncTo = $3a1b6d1b1e4a1199$var$isAsyncTo(props.to);
        const { config: config } = anim;
        const { decay: decay, velocity: velocity } = config;
        if (hasToProp || hasFromProp) config.velocity = 0;
        if (props.config && !hasAsyncTo) $3a1b6d1b1e4a1199$var$mergeConfig(config, $3a1b6d1b1e4a1199$var$callProp(props.config, key), props.config !== defaultProps.config ? $3a1b6d1b1e4a1199$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $2hAeX.getAnimated)(this);
        if (!node || (0, $jZS6F.is).und(to)) return resolve($3a1b6d1b1e4a1199$var$getFinishedResult(this, true));
        const reset = (0, $jZS6F.is).und(props.reset) ? hasFromProp && !props.default : !(0, $jZS6F.is).und(from) && $3a1b6d1b1e4a1199$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $3a1b6d1b1e4a1199$var$computeGoal(to);
        const isAnimatable = (0, $jZS6F.is).num(goal) || (0, $jZS6F.is).arr(goal) || (0, $jZS6F.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $3a1b6d1b1e4a1199$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $2hAeX.getAnimatedType)(to);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $jZS6F.hasFluidValue)(to);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$3a1b6d1b1e4a1199$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $jZS6F.isEqual)($3a1b6d1b1e4a1199$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $jZS6F.isEqual)(anim.immediate, immediate) && !immediate || !(0, $jZS6F.isEqual)(config.decay, decay) || !(0, $jZS6F.isEqual)(config.velocity, velocity)) started = true;
        }
        if (finished && $3a1b6d1b1e4a1199$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $jZS6F.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $jZS6F.hasFluidValue)(to) ? null : goalType == (0, $2hAeX.AnimatedString) ? [
                    1
                ] : (0, $jZS6F.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $jZS6F.each)($3a1b6d1b1e4a1199$var$ACTIVE_EVENTS, (type)=>$3a1b6d1b1e4a1199$var$mergeActiveFn(this, props, type));
                const result = $3a1b6d1b1e4a1199$var$getFinishedResult(this, $3a1b6d1b1e4a1199$var$checkFinished(this, prevTo));
                (0, $jZS6F.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $bUNLs.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest == null || onRest(result, this);
                    if (reset) $3a1b6d1b1e4a1199$var$callProp(defaultProps.onRest, result);
                    else anim.onStart == null || anim.onStart(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($3a1b6d1b1e4a1199$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($3a1b6d1b1e4a1199$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($3a1b6d1b1e4a1199$var$getNoopResult(value));
    }
    _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $jZS6F.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, $jZS6F.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to } = this.animation;
        if ((0, $jZS6F.hasFluidValue)(to)) {
            (0, $jZS6F.addFluidObserver)(to, this);
            if ($3a1b6d1b1e4a1199$var$isFrameValue(to)) priority = to.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to } = this.animation;
        if ((0, $jZS6F.hasFluidValue)(to)) (0, $jZS6F.removeFluidObserver)(to, this);
    }
    _set(arg, idle = true) {
        const value = (0, $jZS6F.getFluidValue)(arg);
        if (!(0, $jZS6F.is).und(value)) {
            const oldNode = (0, $2hAeX.getAnimated)(this);
            if (!oldNode || !(0, $jZS6F.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, $2hAeX.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $2hAeX.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $bUNLs.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $2hAeX.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $3a1b6d1b1e4a1199$var$sendEvent(this, "onStart", $3a1b6d1b1e4a1199$var$getFinishedResult(this, $3a1b6d1b1e4a1199$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $3a1b6d1b1e4a1199$var$callProp(this.animation.onChange, value, this);
        }
        $3a1b6d1b1e4a1199$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    _start() {
        const anim = this.animation;
        (0, $2hAeX.getAnimated)(this).reset((0, $jZS6F.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$3a1b6d1b1e4a1199$var$isAnimating(this)) {
            $3a1b6d1b1e4a1199$var$setActiveBit(this, true);
            if (!$3a1b6d1b1e4a1199$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $jZS6F.Globals).skipAnimation) this.finish();
        else (0, $jZS6F.frameLoop).start(this);
    }
    _stop(goal, cancel) {
        if ($3a1b6d1b1e4a1199$var$isAnimating(this)) {
            $3a1b6d1b1e4a1199$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $jZS6F.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = undefined;
            (0, $jZS6F.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $3a1b6d1b1e4a1199$var$getCancelledResult(this.get()) : $3a1b6d1b1e4a1199$var$getFinishedResult(this.get(), $3a1b6d1b1e4a1199$var$checkFinished(this, goal != null ? goal : anim.to));
            (0, $jZS6F.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $3a1b6d1b1e4a1199$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        this.key = void 0;
        this.animation = new $3a1b6d1b1e4a1199$var$Animation();
        this.queue = void 0;
        this.defaultProps = {};
        this._state = {
            paused: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._pendingCalls = new Set();
        this._lastCallId = 0;
        this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $jZS6F.is).und(arg1) || !(0, $jZS6F.is).und(arg2)) {
            const props = (0, $jZS6F.is).obj(arg1) ? $3a1b6d1b1e4a1199$var$_extends({}, arg1) : $3a1b6d1b1e4a1199$var$_extends({}, arg2, {
                from: arg1
            });
            if ((0, $jZS6F.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
}
function $3a1b6d1b1e4a1199$var$checkFinished(target, to) {
    const goal = $3a1b6d1b1e4a1199$var$computeGoal(to);
    const value = $3a1b6d1b1e4a1199$var$computeGoal(target.get());
    return (0, $jZS6F.isEqual)(value, goal);
}
function $3a1b6d1b1e4a1199$var$createLoopUpdate(props, loop = props.loop, to = props.to) {
    let loopRet = $3a1b6d1b1e4a1199$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $3a1b6d1b1e4a1199$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $3a1b6d1b1e4a1199$var$createUpdate($3a1b6d1b1e4a1199$var$_extends({}, props, {
            loop: loop,
            default: false,
            pause: undefined,
            to: !reverse || $3a1b6d1b1e4a1199$var$isAsyncTo(to) ? to : undefined,
            from: reset ? props.from : undefined,
            reset: reset
        }, overrides));
    }
}
function $3a1b6d1b1e4a1199$var$createUpdate(props) {
    const { to: to, from: from } = props = $3a1b6d1b1e4a1199$export$b971039a739bf227(props);
    const keys = new Set();
    if ((0, $jZS6F.is).obj(to)) $3a1b6d1b1e4a1199$var$findDefined(to, keys);
    if ((0, $jZS6F.is).obj(from)) $3a1b6d1b1e4a1199$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $3a1b6d1b1e4a1199$var$declareUpdate(props) {
    const update = $3a1b6d1b1e4a1199$var$createUpdate(props);
    if ((0, $jZS6F.is).und(update.default)) update.default = $3a1b6d1b1e4a1199$var$getDefaultProps(update);
    return update;
}
function $3a1b6d1b1e4a1199$var$findDefined(values, keys) {
    (0, $jZS6F.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
const $3a1b6d1b1e4a1199$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $3a1b6d1b1e4a1199$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $3a1b6d1b1e4a1199$var$getDefaultProp(props, type) ? $3a1b6d1b1e4a1199$var$resolveProp(props[type], target.key) : undefined;
}
function $3a1b6d1b1e4a1199$var$sendEvent(target, type, ...args) {
    var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
    (_target$animation$typ = (_target$animation = target.animation)[type]) == null || _target$animation$typ.call(_target$animation, ...args);
    (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null || _target$defaultProps$.call(_target$defaultProps, ...args);
}
const $3a1b6d1b1e4a1199$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
let $3a1b6d1b1e4a1199$var$nextId = 1;
class $3a1b6d1b1e4a1199$export$bd0bf19f25da8474 {
    get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>spring.idle);
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $jZS6F.is).und(value)) this.springs[key].set(value);
        }
    }
    update(props) {
        if (props) this.queue.push($3a1b6d1b1e4a1199$var$createUpdate(props));
        return this;
    }
    start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $jZS6F.toArray)(props).map($3a1b6d1b1e4a1199$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $3a1b6d1b1e4a1199$var$prepareKeys(this, queue);
        return $3a1b6d1b1e4a1199$var$flushUpdateQueue(this, queue);
    }
    stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $jZS6F.each)((0, $jZS6F.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $3a1b6d1b1e4a1199$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    pause(keys) {
        if ((0, $jZS6F.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $jZS6F.each)((0, $jZS6F.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    resume(keys) {
        if ((0, $jZS6F.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $jZS6F.each)((0, $jZS6F.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    each(iterator) {
        (0, $jZS6F.eachProp)(this.springs, iterator);
    }
    _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $jZS6F.flush)(onStart, ([onStart, result])=>{
                result.value = this.get();
                onStart(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $jZS6F.flush)(onChange, ([onChange, result])=>{
            result.value = values;
            onChange(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $jZS6F.flush)(onRest, ([onRest, result])=>{
                result.value = values;
                onRest(result, this, this._item);
            });
        }
    }
    eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $bUNLs.raf).onFrame(this._onFrame);
    }
    constructor(props, flush){
        this.id = $3a1b6d1b1e4a1199$var$nextId++;
        this.springs = {};
        this.queue = [];
        this.ref = void 0;
        this._flush = void 0;
        this._initialProps = void 0;
        this._lastAsyncId = 0;
        this._active = new Set();
        this._changed = new Set();
        this._started = false;
        this._item = void 0;
        this._state = {
            paused: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._events = {
            onStart: new Map(),
            onChange: new Map(),
            onRest: new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush) this._flush = flush;
        if (props) this.start($3a1b6d1b1e4a1199$var$_extends({
            default: true
        }, props));
    }
}
function $3a1b6d1b1e4a1199$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$3a1b6d1b1e4a1199$var$flushUpdate(ctrl, props))).then((results)=>$3a1b6d1b1e4a1199$var$getCombinedResult(ctrl, results));
}
async function $3a1b6d1b1e4a1199$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults = (0, $jZS6F.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $jZS6F.is).arr(to) || (0, $jZS6F.is).fun(to) ? to : undefined;
    if (asyncTo) {
        props.to = undefined;
        props.onRest = undefined;
        if (defaults) defaults.onRest = undefined;
    } else (0, $jZS6F.each)($3a1b6d1b1e4a1199$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $jZS6F.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result = queue.get(handler);
                if (result) {
                    if (!finished) result.finished = false;
                    if (cancelled) result.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults) defaults[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $jZS6F.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $3a1b6d1b1e4a1199$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($3a1b6d1b1e4a1199$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $jZS6F.noop),
            resume: (0, $jZS6F.noop),
            start (props, resolve) {
                if (cancel) {
                    $3a1b6d1b1e4a1199$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($3a1b6d1b1e4a1199$var$getCancelledResult(ctrl));
                } else {
                    props.onRest = onRest;
                    resolve($3a1b6d1b1e4a1199$var$runAsync(asyncTo, props, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $3a1b6d1b1e4a1199$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $3a1b6d1b1e4a1199$var$createLoopUpdate(props, loop, to);
        if (nextProps) {
            $3a1b6d1b1e4a1199$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $3a1b6d1b1e4a1199$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $bUNLs.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $3a1b6d1b1e4a1199$var$getSprings(ctrl, props) {
    const springs = $3a1b6d1b1e4a1199$var$_extends({}, ctrl.springs);
    if (props) (0, $jZS6F.each)((0, $jZS6F.toArray)(props), (props)=>{
        if ((0, $jZS6F.is).und(props.keys)) props = $3a1b6d1b1e4a1199$var$createUpdate(props);
        if (!(0, $jZS6F.is).obj(props.to)) props = $3a1b6d1b1e4a1199$var$_extends({}, props, {
            to: undefined
        });
        $3a1b6d1b1e4a1199$var$prepareSprings(springs, props, (key)=>{
            return $3a1b6d1b1e4a1199$var$createSpring(key);
        });
    });
    $3a1b6d1b1e4a1199$var$setSprings(ctrl, springs);
    return springs;
}
function $3a1b6d1b1e4a1199$var$setSprings(ctrl, springs) {
    (0, $jZS6F.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $jZS6F.addFluidObserver)(spring, ctrl);
        }
    });
}
function $3a1b6d1b1e4a1199$var$createSpring(key, observer) {
    const spring = new $3a1b6d1b1e4a1199$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $jZS6F.addFluidObserver)(spring, observer);
    return spring;
}
function $3a1b6d1b1e4a1199$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $jZS6F.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $3a1b6d1b1e4a1199$var$prepareKeys(ctrl, queue) {
    (0, $jZS6F.each)(queue, (props)=>{
        $3a1b6d1b1e4a1199$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $3a1b6d1b1e4a1199$var$createSpring(key, ctrl);
        });
    });
}
function $3a1b6d1b1e4a1199$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $3a1b6d1b1e4a1199$var$_excluded$3 = [
    "children"
];
const $3a1b6d1b1e4a1199$export$f12a216ec50d2cf1 = (_ref)=>{
    let { children: children } = _ref, props = $3a1b6d1b1e4a1199$var$_objectWithoutPropertiesLoose(_ref, $3a1b6d1b1e4a1199$var$_excluded$3);
    const inherited = (0, $70fFQ.useContext)($3a1b6d1b1e4a1199$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $jZS6F.useMemoOne)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $3a1b6d1b1e4a1199$var$ctx;
    return $70fFQ.createElement(Provider, {
        value: props
    }, children);
};
const $3a1b6d1b1e4a1199$var$ctx = $3a1b6d1b1e4a1199$var$makeContext($3a1b6d1b1e4a1199$export$f12a216ec50d2cf1, {});
$3a1b6d1b1e4a1199$export$f12a216ec50d2cf1.Provider = $3a1b6d1b1e4a1199$var$ctx.Provider;
$3a1b6d1b1e4a1199$export$f12a216ec50d2cf1.Consumer = $3a1b6d1b1e4a1199$var$ctx.Consumer;
function $3a1b6d1b1e4a1199$var$makeContext(target, init) {
    Object.assign(target, $70fFQ.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
const $3a1b6d1b1e4a1199$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef = function SpringRef(props) {
        (0, $jZS6F.deprecateDirectCall)();
        const results = [];
        (0, $jZS6F.each)(current, (ctrl, i)=>{
            if ((0, $jZS6F.is).und(props)) results.push(ctrl.start());
            else {
                const update = _getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.current = current;
    SpringRef.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef.pause = function() {
        (0, $jZS6F.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef.resume = function() {
        (0, $jZS6F.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef.set = function(values) {
        (0, $jZS6F.each)(current, (ctrl)=>ctrl.set(values));
    };
    SpringRef.start = function(props) {
        const results = [];
        (0, $jZS6F.each)(current, (ctrl, i)=>{
            if ((0, $jZS6F.is).und(props)) results.push(ctrl.start());
            else {
                const update = this._getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.stop = function() {
        (0, $jZS6F.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef.update = function(props) {
        (0, $jZS6F.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function _getProps(arg, ctrl, index) {
        return (0, $jZS6F.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef._getProps = _getProps;
    return SpringRef;
};
function $3a1b6d1b1e4a1199$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $jZS6F.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $70fFQ.useMemo)(()=>propsFn || arguments.length == 3 ? $3a1b6d1b1e4a1199$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $70fFQ.useRef)(0);
    const forceUpdate = (0, $jZS6F.useForceUpdate)();
    const state = (0, $70fFQ.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates) {
                const springs = $3a1b6d1b1e4a1199$var$getSprings(ctrl, updates);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $3a1b6d1b1e4a1199$var$flushUpdateQueue(ctrl, updates) : new Promise((resolve)=>{
                    $3a1b6d1b1e4a1199$var$setSprings(ctrl, springs);
                    state.queue.push(()=>{
                        resolve($3a1b6d1b1e4a1199$var$flushUpdateQueue(ctrl, updates));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $70fFQ.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $jZS6F.usePrev)(length) || 0;
    (0, $70fFQ.useMemo)(()=>{
        (0, $jZS6F.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $3a1b6d1b1e4a1199$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $70fFQ.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $3a1b6d1b1e4a1199$export$bd0bf19f25da8474(null, state.flush));
            const update = propsFn ? propsFn(i, ctrl) : props[i];
            if (update) updates[i] = $3a1b6d1b1e4a1199$var$declareUpdate(update);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$3a1b6d1b1e4a1199$var$getSprings(ctrl, updates[i]));
    const context = (0, $70fFQ.useContext)($3a1b6d1b1e4a1199$export$f12a216ec50d2cf1);
    const prevContext = (0, $jZS6F.usePrev)(context);
    const hasContext = context !== prevContext && $3a1b6d1b1e4a1199$var$hasProps(context);
    (0, $jZS6F.useLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $jZS6F.each)(queue, (cb)=>cb());
        }
        (0, $jZS6F.each)(ctrls.current, (ctrl, i)=>{
            ref == null || ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update = updates[i];
            if (update) {
                $3a1b6d1b1e4a1199$var$replaceRef(ctrl, update.ref);
                if (ctrl.ref) ctrl.queue.push(update);
                else ctrl.start(update);
            }
        });
    });
    (0, $jZS6F.useOnce)(()=>()=>{
            (0, $jZS6F.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>$3a1b6d1b1e4a1199$var$_extends({}, x));
    return ref ? [
        values,
        ref
    ] : values;
}
function $3a1b6d1b1e4a1199$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $jZS6F.is).fun(props);
    const [[values], ref] = $3a1b6d1b1e4a1199$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
const $3a1b6d1b1e4a1199$var$initSpringRef = ()=>$3a1b6d1b1e4a1199$export$2471ae76e2946684();
const $3a1b6d1b1e4a1199$export$564bff9c23cad2ca = ()=>(0, $70fFQ.useState)($3a1b6d1b1e4a1199$var$initSpringRef)[0];
function $3a1b6d1b1e4a1199$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $jZS6F.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    const result = $3a1b6d1b1e4a1199$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        reverse = reverse && props.reverse;
        return props;
    }, deps || [
        {}
    ]);
    const ref = result[1];
    (0, $jZS6F.useLayoutEffect)(()=>{
        (0, $jZS6F.each)(ref.current, (ctrl, i)=>{
            const parent = ref.current[i + (reverse ? 1 : -1)];
            if (parent) ctrl.start({
                to: parent.springs
            });
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        ref["_getProps"] = (propsArg, ctrl, i)=>{
            const props = (0, $jZS6F.is).fun(propsArg) ? propsArg(i, ctrl) : propsArg;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
let $3a1b6d1b1e4a1199$var$TransitionPhase;
(function(TransitionPhase) {
    TransitionPhase["MOUNT"] = "mount";
    TransitionPhase["ENTER"] = "enter";
    TransitionPhase["UPDATE"] = "update";
    TransitionPhase["LEAVE"] = "leave";
})($3a1b6d1b1e4a1199$var$TransitionPhase || ($3a1b6d1b1e4a1199$var$TransitionPhase = {}));
function $3a1b6d1b1e4a1199$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $jZS6F.is).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $70fFQ.useMemo)(()=>propsFn || arguments.length == 3 ? $3a1b6d1b1e4a1199$export$2471ae76e2946684() : void 0, []);
    const items = (0, $jZS6F.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, $70fFQ.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $jZS6F.useLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $jZS6F.useOnce)(()=>()=>(0, $jZS6F.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $3a1b6d1b1e4a1199$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            }));
    const keys = $3a1b6d1b1e4a1199$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $jZS6F.useLayoutEffect)(()=>(0, $jZS6F.each)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $3a1b6d1b1e4a1199$var$detachRefs(ctrl, ref);
            $3a1b6d1b1e4a1199$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $jZS6F.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $jZS6F.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: $3a1b6d1b1e4a1199$var$TransitionPhase.MOUNT,
                ctrl: new $3a1b6d1b1e4a1199$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $jZS6F.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = $3a1b6d1b1e4a1199$var$_extends({}, t, {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $jZS6F.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $jZS6F.useForceUpdate)();
    const defaultProps = $3a1b6d1b1e4a1199$var$getDefaultProps(props);
    const changes = new Map();
    (0, $jZS6F.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to;
        let phase;
        let propsDelay = $3a1b6d1b1e4a1199$var$callProp(p.delay || 0, key);
        if (prevPhase == $3a1b6d1b1e4a1199$var$TransitionPhase.MOUNT) {
            to = p.enter;
            phase = $3a1b6d1b1e4a1199$var$TransitionPhase.ENTER;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != $3a1b6d1b1e4a1199$var$TransitionPhase.LEAVE) {
                if (isLeave) {
                    to = p.leave;
                    phase = $3a1b6d1b1e4a1199$var$TransitionPhase.LEAVE;
                } else if (to = p.update) phase = $3a1b6d1b1e4a1199$var$TransitionPhase.UPDATE;
                else return;
            } else if (!isLeave) {
                to = p.enter;
                phase = $3a1b6d1b1e4a1199$var$TransitionPhase.ENTER;
            } else return;
        }
        to = $3a1b6d1b1e4a1199$var$callProp(to, t.item, i);
        to = (0, $jZS6F.is).obj(to) ? $3a1b6d1b1e4a1199$export$b971039a739bf227(to) : {
            to: to
        };
        if (!to.config) {
            const config = propsConfig || defaultProps.config;
            to.config = $3a1b6d1b1e4a1199$var$callProp(config, t.item, i, phase);
        }
        delay += trail;
        const payload = $3a1b6d1b1e4a1199$var$_extends({}, defaultProps, {
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            reset: false
        }, to);
        if (phase == $3a1b6d1b1e4a1199$var$TransitionPhase.ENTER && (0, $jZS6F.is).und(payload.from)) {
            const _p = propsFn ? propsFn() : props;
            const from = (0, $jZS6F.is).und(_p.initial) || prevTransitions ? _p.from : _p.initial;
            payload.from = $3a1b6d1b1e4a1199$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $3a1b6d1b1e4a1199$var$callProp(onResolve, result);
            const transitions = usedTransitions.current;
            const t = transitions.find((t)=>t.key === key);
            if (!t) return;
            if (result.cancelled && t.phase != $3a1b6d1b1e4a1199$var$TransitionPhase.UPDATE) return;
            if (t.ctrl.idle) {
                const idle = transitions.every((t)=>t.ctrl.idle);
                if (t.phase == $3a1b6d1b1e4a1199$var$TransitionPhase.LEAVE) {
                    const expiry = $3a1b6d1b1e4a1199$var$callProp(expires, t.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions.some((t)=>t.expired)) forceUpdate();
            }
        };
        const springs = $3a1b6d1b1e4a1199$var$getSprings(t.ctrl, payload);
        changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $70fFQ.useContext)($3a1b6d1b1e4a1199$export$f12a216ec50d2cf1);
    const prevContext = (0, $jZS6F.usePrev)(context);
    const hasContext = context !== prevContext && $3a1b6d1b1e4a1199$var$hasProps(context);
    (0, $jZS6F.useLayoutEffect)(()=>{
        if (hasContext) (0, $jZS6F.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $jZS6F.useLayoutEffect)(()=>{
        (0, $jZS6F.each)(changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref == null || ref.add(ctrl);
            if (hasContext && phase == $3a1b6d1b1e4a1199$var$TransitionPhase.ENTER) ctrl.start({
                default: context
            });
            if (payload) {
                $3a1b6d1b1e4a1199$var$replaceRef(ctrl, payload.ref);
                if (ctrl.ref) ctrl.update(payload);
                else ctrl.start(payload);
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>$70fFQ.createElement($70fFQ.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render($3a1b6d1b1e4a1199$var$_extends({}, springs), t.item, t, i);
            return elem && elem.type ? $70fFQ.createElement(elem.type, $3a1b6d1b1e4a1199$var$_extends({}, elem.props, {
                key: (0, $jZS6F.is).str(t.key) || (0, $jZS6F.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
let $3a1b6d1b1e4a1199$var$nextKey = 1;
function $3a1b6d1b1e4a1199$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t)=>t.item === item && t.phase !== $3a1b6d1b1e4a1199$var$TransitionPhase.LEAVE && !reused.has(t));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $3a1b6d1b1e4a1199$var$nextKey++;
        });
    }
    return (0, $jZS6F.is).und(keys) ? items : (0, $jZS6F.is).fun(keys) ? items.map(keys) : (0, $jZS6F.toArray)(keys);
}
const $3a1b6d1b1e4a1199$var$_excluded$2 = [
    "children"
];
function $3a1b6d1b1e4a1199$export$a500e5b516cedfc(_ref) {
    let { children: children } = _ref, props = $3a1b6d1b1e4a1199$var$_objectWithoutPropertiesLoose(_ref, $3a1b6d1b1e4a1199$var$_excluded$2);
    return children($3a1b6d1b1e4a1199$export$c4af9125706c4d30(props));
}
const $3a1b6d1b1e4a1199$var$_excluded$1 = [
    "items",
    "children"
];
function $3a1b6d1b1e4a1199$export$3b8b9d47fbf8fd2b(_ref) {
    let { items: items, children: children } = _ref, props = $3a1b6d1b1e4a1199$var$_objectWithoutPropertiesLoose(_ref, $3a1b6d1b1e4a1199$var$_excluded$1);
    const trails = $3a1b6d1b1e4a1199$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $jZS6F.is).fun(result) ? result(trails[index]) : result;
    });
}
const $3a1b6d1b1e4a1199$var$_excluded = [
    "items",
    "children"
];
function $3a1b6d1b1e4a1199$export$be58926105124dd4(_ref) {
    let { items: items, children: children } = _ref, props = $3a1b6d1b1e4a1199$var$_objectWithoutPropertiesLoose(_ref, $3a1b6d1b1e4a1199$var$_excluded);
    return $3a1b6d1b1e4a1199$export$7b286972b8d8ccbf(items, props)(children);
}
class $3a1b6d1b1e4a1199$export$b0cc4f9860136880 extends $3a1b6d1b1e4a1199$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $jZS6F.isEqual)(value, oldValue)) {
            (0, $2hAeX.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $3a1b6d1b1e4a1199$var$checkIdle(this._active)) $3a1b6d1b1e4a1199$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $jZS6F.is).arr(this.source) ? this.source.map((0, $jZS6F.getFluidValue)) : (0, $jZS6F.toArray)((0, $jZS6F.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$3a1b6d1b1e4a1199$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $jZS6F.each)((0, $2hAeX.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, $jZS6F.Globals).skipAnimation) {
                (0, $bUNLs.raf).batchedUpdates(()=>this.advance());
                $3a1b6d1b1e4a1199$var$becomeIdle(this);
            } else (0, $jZS6F.frameLoop).start(this);
        }
    }
    _attach() {
        let priority = 1;
        (0, $jZS6F.each)((0, $jZS6F.toArray)(this.source), (source)=>{
            if ((0, $jZS6F.hasFluidValue)(source)) (0, $jZS6F.addFluidObserver)(source, this);
            if ($3a1b6d1b1e4a1199$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    _detach() {
        (0, $jZS6F.each)((0, $jZS6F.toArray)(this.source), (source)=>{
            if ((0, $jZS6F.hasFluidValue)(source)) (0, $jZS6F.removeFluidObserver)(source, this);
        });
        this._active.clear();
        $3a1b6d1b1e4a1199$var$becomeIdle(this);
    }
    eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $jZS6F.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, ($3a1b6d1b1e4a1199$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.key = void 0;
        this.idle = true;
        this.calc = void 0;
        this._active = new Set();
        this.source = source;
        this.calc = (0, $jZS6F.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, $2hAeX.getAnimatedType)(value);
        (0, $2hAeX.setAnimated)(this, nodeType.create(value));
    }
}
function $3a1b6d1b1e4a1199$var$isIdle(source) {
    return source.idle !== false;
}
function $3a1b6d1b1e4a1199$var$checkIdle(active) {
    return !active.size || Array.from(active).every($3a1b6d1b1e4a1199$var$isIdle);
}
function $3a1b6d1b1e4a1199$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $jZS6F.each)((0, $2hAeX.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, $jZS6F.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
const $3a1b6d1b1e4a1199$export$2c618a4308a30424 = (source, ...args)=>new $3a1b6d1b1e4a1199$export$b0cc4f9860136880(source, args);
const $3a1b6d1b1e4a1199$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $jZS6F.deprecateInterpolate)(), new $3a1b6d1b1e4a1199$export$b0cc4f9860136880(source, args));
(0, $jZS6F.Globals).assign({
    createStringInterpolator: $jZS6F.createStringInterpolator,
    to: (source, args)=>new $3a1b6d1b1e4a1199$export$b0cc4f9860136880(source, args)
});
const $3a1b6d1b1e4a1199$export$722fbec263ad908a = (0, $jZS6F.frameLoop).advance;
$parcel$exportWildcard(module.exports, $cJLRh);
$parcel$exportWildcard(module.exports, $fTEGT);

});
parcelRegister("jZS6F", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $e8edaf4006ebf949$export$8793edee2d425525; });
$parcel$export(module.exports, "defineHidden", function () { return $e8edaf4006ebf949$export$5c74248ea0e35446; });
$parcel$export(module.exports, "is", function () { return $e8edaf4006ebf949$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "isEqual", function () { return $e8edaf4006ebf949$export$248d38f6296296c5; });
$parcel$export(module.exports, "each", function () { return $e8edaf4006ebf949$export$79b2f7037acddd43; });
$parcel$export(module.exports, "eachProp", function () { return $e8edaf4006ebf949$export$f4c6fe153f5a944e; });
$parcel$export(module.exports, "toArray", function () { return $e8edaf4006ebf949$export$45b10814cc054894; });
$parcel$export(module.exports, "flush", function () { return $e8edaf4006ebf949$export$4909b86c8034bf73; });
$parcel$export(module.exports, "flushCalls", function () { return $e8edaf4006ebf949$export$7ba486852759e806; });
$parcel$export(module.exports, "Globals", function () { return $e8edaf4006ebf949$export$cceeabf822b64fc0; });
$parcel$export(module.exports, "frameLoop", function () { return $e8edaf4006ebf949$export$a57f5080a3bcc90a; });
$parcel$export(module.exports, "colors", function () { return $e8edaf4006ebf949$export$8f45430ccf837300; });
$parcel$export(module.exports, "createInterpolator", function () { return $e8edaf4006ebf949$export$b12af43b97697ef5; });
$parcel$export(module.exports, "hasFluidValue", function () { return $e8edaf4006ebf949$export$57ea7e3a7f6280c7; });
$parcel$export(module.exports, "getFluidValue", function () { return $e8edaf4006ebf949$export$e37b7520edd66839; });
$parcel$export(module.exports, "getFluidObservers", function () { return $e8edaf4006ebf949$export$133f54e9f7cf1796; });
$parcel$export(module.exports, "callFluidObservers", function () { return $e8edaf4006ebf949$export$31752c40a5fab62a; });
$parcel$export(module.exports, "FluidValue", function () { return $e8edaf4006ebf949$export$aff8e1ac1a016a2; });
$parcel$export(module.exports, "addFluidObserver", function () { return $e8edaf4006ebf949$export$72d604e3f8d000a5; });
$parcel$export(module.exports, "removeFluidObserver", function () { return $e8edaf4006ebf949$export$7a0eb830d336339b; });
$parcel$export(module.exports, "createStringInterpolator", function () { return $e8edaf4006ebf949$export$4759a013d387347a; });
$parcel$export(module.exports, "deprecateInterpolate", function () { return $e8edaf4006ebf949$export$2abfcde8ae218ba8; });
$parcel$export(module.exports, "deprecateDirectCall", function () { return $e8edaf4006ebf949$export$d99d974913ad3b12; });
$parcel$export(module.exports, "isAnimatedString", function () { return $e8edaf4006ebf949$export$75bed621f62abfa9; });
$parcel$export(module.exports, "useOnce", function () { return $e8edaf4006ebf949$export$392544347a18b6ea; });
$parcel$export(module.exports, "useForceUpdate", function () { return $e8edaf4006ebf949$export$91db9bc4f8ac944a; });
$parcel$export(module.exports, "useMemoOne", function () { return $e8edaf4006ebf949$export$b6feb8998cd9b342; });
$parcel$export(module.exports, "usePrev", function () { return $e8edaf4006ebf949$export$ef7ad0c4e19d7fbf; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e8edaf4006ebf949$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "raf", function () { return (parcelRequire("bUNLs")).raf; });

var $bUNLs = parcelRequire("bUNLs");

var $70fFQ = parcelRequire("70fFQ");
function $e8edaf4006ebf949$export$8793edee2d425525() {}
const $e8edaf4006ebf949$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $e8edaf4006ebf949$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === undefined
};
function $e8edaf4006ebf949$export$248d38f6296296c5(a, b) {
    if ($e8edaf4006ebf949$export$226b3eccf92c9ed9.arr(a)) {
        if (!$e8edaf4006ebf949$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
const $e8edaf4006ebf949$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $e8edaf4006ebf949$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($e8edaf4006ebf949$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
const $e8edaf4006ebf949$export$45b10814cc054894 = (a)=>$e8edaf4006ebf949$export$226b3eccf92c9ed9.und(a) ? [] : $e8edaf4006ebf949$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $e8edaf4006ebf949$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $e8edaf4006ebf949$export$79b2f7037acddd43(items, iterator);
    }
}
const $e8edaf4006ebf949$export$7ba486852759e806 = (queue, ...args)=>$e8edaf4006ebf949$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
let $e8edaf4006ebf949$var$createStringInterpolator$1;
let $e8edaf4006ebf949$var$to;
let $e8edaf4006ebf949$var$colors$1 = null;
let $e8edaf4006ebf949$var$skipAnimation = false;
let $e8edaf4006ebf949$var$willAdvance = $e8edaf4006ebf949$export$8793edee2d425525;
const $e8edaf4006ebf949$var$assign = (globals)=>{
    if (globals.to) $e8edaf4006ebf949$var$to = globals.to;
    if (globals.now) (0, $bUNLs.raf).now = globals.now;
    if (globals.colors !== undefined) $e8edaf4006ebf949$var$colors$1 = globals.colors;
    if (globals.skipAnimation != null) $e8edaf4006ebf949$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $e8edaf4006ebf949$var$createStringInterpolator$1 = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $bUNLs.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $bUNLs.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $e8edaf4006ebf949$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $bUNLs.raf).frameLoop = globals.frameLoop;
};
var $e8edaf4006ebf949$export$cceeabf822b64fc0 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get createStringInterpolator () {
        return $e8edaf4006ebf949$var$createStringInterpolator$1;
    },
    get to () {
        return $e8edaf4006ebf949$var$to;
    },
    get colors () {
        return $e8edaf4006ebf949$var$colors$1;
    },
    get skipAnimation () {
        return $e8edaf4006ebf949$var$skipAnimation;
    },
    get willAdvance () {
        return $e8edaf4006ebf949$var$willAdvance;
    },
    assign: $e8edaf4006ebf949$var$assign
});
const $e8edaf4006ebf949$var$startQueue = new Set();
let $e8edaf4006ebf949$var$currentFrame = [];
let $e8edaf4006ebf949$var$prevFrame = [];
let $e8edaf4006ebf949$var$priority = 0;
const $e8edaf4006ebf949$export$a57f5080a3bcc90a = {
    get idle () {
        return !$e8edaf4006ebf949$var$startQueue.size && !$e8edaf4006ebf949$var$currentFrame.length;
    },
    start (animation) {
        if ($e8edaf4006ebf949$var$priority > animation.priority) {
            $e8edaf4006ebf949$var$startQueue.add(animation);
            (0, $bUNLs.raf).onStart($e8edaf4006ebf949$var$flushStartQueue);
        } else {
            $e8edaf4006ebf949$var$startSafely(animation);
            (0, $bUNLs.raf)($e8edaf4006ebf949$var$advance);
        }
    },
    advance: $e8edaf4006ebf949$var$advance,
    sort (animation) {
        if ($e8edaf4006ebf949$var$priority) (0, $bUNLs.raf).onFrame(()=>$e8edaf4006ebf949$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $e8edaf4006ebf949$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $e8edaf4006ebf949$var$currentFrame.splice(prevIndex, 1);
                $e8edaf4006ebf949$var$startUnsafely(animation);
            }
        }
    },
    clear () {
        $e8edaf4006ebf949$var$currentFrame = [];
        $e8edaf4006ebf949$var$startQueue.clear();
    }
};
function $e8edaf4006ebf949$var$flushStartQueue() {
    $e8edaf4006ebf949$var$startQueue.forEach($e8edaf4006ebf949$var$startSafely);
    $e8edaf4006ebf949$var$startQueue.clear();
    (0, $bUNLs.raf)($e8edaf4006ebf949$var$advance);
}
function $e8edaf4006ebf949$var$startSafely(animation) {
    if (!$e8edaf4006ebf949$var$currentFrame.includes(animation)) $e8edaf4006ebf949$var$startUnsafely(animation);
}
function $e8edaf4006ebf949$var$startUnsafely(animation) {
    $e8edaf4006ebf949$var$currentFrame.splice($e8edaf4006ebf949$var$findIndex($e8edaf4006ebf949$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $e8edaf4006ebf949$var$advance(dt) {
    const nextFrame = $e8edaf4006ebf949$var$prevFrame;
    for(let i = 0; i < $e8edaf4006ebf949$var$currentFrame.length; i++){
        const animation = $e8edaf4006ebf949$var$currentFrame[i];
        $e8edaf4006ebf949$var$priority = animation.priority;
        if (!animation.idle) {
            $e8edaf4006ebf949$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $e8edaf4006ebf949$var$priority = 0;
    $e8edaf4006ebf949$var$prevFrame = $e8edaf4006ebf949$var$currentFrame;
    $e8edaf4006ebf949$var$prevFrame.length = 0;
    $e8edaf4006ebf949$var$currentFrame = nextFrame;
    return $e8edaf4006ebf949$var$currentFrame.length > 0;
}
function $e8edaf4006ebf949$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
const $e8edaf4006ebf949$export$8f45430ccf837300 = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
};
const $e8edaf4006ebf949$var$NUMBER = "[-+]?\\d*\\.?\\d+";
const $e8edaf4006ebf949$var$PERCENTAGE = $e8edaf4006ebf949$var$NUMBER + "%";
function $e8edaf4006ebf949$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const $e8edaf4006ebf949$export$8972dc0e6ad9238f = new RegExp("rgb" + $e8edaf4006ebf949$var$call($e8edaf4006ebf949$var$NUMBER, $e8edaf4006ebf949$var$NUMBER, $e8edaf4006ebf949$var$NUMBER));
const $e8edaf4006ebf949$export$4e46ac54fc82cf3b = new RegExp("rgba" + $e8edaf4006ebf949$var$call($e8edaf4006ebf949$var$NUMBER, $e8edaf4006ebf949$var$NUMBER, $e8edaf4006ebf949$var$NUMBER, $e8edaf4006ebf949$var$NUMBER));
const $e8edaf4006ebf949$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $e8edaf4006ebf949$var$call($e8edaf4006ebf949$var$NUMBER, $e8edaf4006ebf949$var$PERCENTAGE, $e8edaf4006ebf949$var$PERCENTAGE));
const $e8edaf4006ebf949$export$810b04175080204c = new RegExp("hsla" + $e8edaf4006ebf949$var$call($e8edaf4006ebf949$var$NUMBER, $e8edaf4006ebf949$var$PERCENTAGE, $e8edaf4006ebf949$var$PERCENTAGE, $e8edaf4006ebf949$var$NUMBER));
const $e8edaf4006ebf949$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $e8edaf4006ebf949$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $e8edaf4006ebf949$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
const $e8edaf4006ebf949$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
function $e8edaf4006ebf949$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
    if (match = $e8edaf4006ebf949$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($e8edaf4006ebf949$var$colors$1 && $e8edaf4006ebf949$var$colors$1[color] !== undefined) return $e8edaf4006ebf949$var$colors$1[color];
    if (match = $e8edaf4006ebf949$export$8972dc0e6ad9238f.exec(color)) return ($e8edaf4006ebf949$var$parse255(match[1]) << 24 | $e8edaf4006ebf949$var$parse255(match[2]) << 16 | $e8edaf4006ebf949$var$parse255(match[3]) << 8 | 0x000000ff) >>> 0;
    if (match = $e8edaf4006ebf949$export$4e46ac54fc82cf3b.exec(color)) return ($e8edaf4006ebf949$var$parse255(match[1]) << 24 | $e8edaf4006ebf949$var$parse255(match[2]) << 16 | $e8edaf4006ebf949$var$parse255(match[3]) << 8 | $e8edaf4006ebf949$var$parse1(match[4])) >>> 0;
    if (match = $e8edaf4006ebf949$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    if (match = $e8edaf4006ebf949$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $e8edaf4006ebf949$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    if (match = $e8edaf4006ebf949$export$8f4a7c0bb78e6ea8.exec(color)) return ($e8edaf4006ebf949$var$hslToRgb($e8edaf4006ebf949$var$parse360(match[1]), $e8edaf4006ebf949$var$parsePercentage(match[2]), $e8edaf4006ebf949$var$parsePercentage(match[3])) | 0x000000ff) >>> 0;
    if (match = $e8edaf4006ebf949$export$810b04175080204c.exec(color)) return ($e8edaf4006ebf949$var$hslToRgb($e8edaf4006ebf949$var$parse360(match[1]), $e8edaf4006ebf949$var$parsePercentage(match[2]), $e8edaf4006ebf949$var$parsePercentage(match[3])) | $e8edaf4006ebf949$var$parse1(match[4])) >>> 0;
    return null;
}
function $e8edaf4006ebf949$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $e8edaf4006ebf949$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $e8edaf4006ebf949$var$hue2rgb(p, q, h + 1 / 3);
    const g = $e8edaf4006ebf949$var$hue2rgb(p, q, h);
    const b = $e8edaf4006ebf949$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $e8edaf4006ebf949$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $e8edaf4006ebf949$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $e8edaf4006ebf949$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $e8edaf4006ebf949$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
function $e8edaf4006ebf949$export$61db176b839af1f(input) {
    let int32Color = $e8edaf4006ebf949$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    let r = (int32Color & 0xff000000) >>> 24;
    let g = (int32Color & 0x00ff0000) >>> 16;
    let b = (int32Color & 0x0000ff00) >>> 8;
    let a = (int32Color & 0x000000ff) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
const $e8edaf4006ebf949$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($e8edaf4006ebf949$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($e8edaf4006ebf949$export$226b3eccf92c9ed9.arr(range)) return $e8edaf4006ebf949$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($e8edaf4006ebf949$export$226b3eccf92c9ed9.str(range.output[0])) return $e8edaf4006ebf949$var$createStringInterpolator$1(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range = $e8edaf4006ebf949$var$findRange(input, inputRange);
        return $e8edaf4006ebf949$var$interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $e8edaf4006ebf949$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $e8edaf4006ebf949$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
function $e8edaf4006ebf949$var$_extends() {
    $e8edaf4006ebf949$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8edaf4006ebf949$var$_extends.apply(this, arguments);
}
const $e8edaf4006ebf949$var$$get = Symbol.for("FluidValue.get");
const $e8edaf4006ebf949$var$$observers = Symbol.for("FluidValue.observers");
const $e8edaf4006ebf949$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$e8edaf4006ebf949$var$$get]);
const $e8edaf4006ebf949$export$e37b7520edd66839 = (arg)=>arg && arg[$e8edaf4006ebf949$var$$get] ? arg[$e8edaf4006ebf949$var$$get]() : arg;
const $e8edaf4006ebf949$export$133f54e9f7cf1796 = (target)=>target[$e8edaf4006ebf949$var$$observers] || null;
function $e8edaf4006ebf949$export$8cbca1207adce0c0(observer, event) {
    if (observer.eventObserved) observer.eventObserved(event);
    else observer(event);
}
function $e8edaf4006ebf949$export$31752c40a5fab62a(target, event) {
    let observers = target[$e8edaf4006ebf949$var$$observers];
    if (observers) observers.forEach((observer)=>{
        $e8edaf4006ebf949$export$8cbca1207adce0c0(observer, event);
    });
}
class $e8edaf4006ebf949$export$aff8e1ac1a016a2 {
    constructor(get){
        this[$e8edaf4006ebf949$var$$get] = void 0;
        this[$e8edaf4006ebf949$var$$observers] = void 0;
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $e8edaf4006ebf949$export$a3b4618659637aa3(this, get);
    }
}
const $e8edaf4006ebf949$export$a3b4618659637aa3 = (target, get)=>$e8edaf4006ebf949$var$setHidden(target, $e8edaf4006ebf949$var$$get, get);
function $e8edaf4006ebf949$export$72d604e3f8d000a5(target, observer) {
    if (target[$e8edaf4006ebf949$var$$get]) {
        let observers = target[$e8edaf4006ebf949$var$$observers];
        if (!observers) $e8edaf4006ebf949$var$setHidden(target, $e8edaf4006ebf949$var$$observers, observers = new Set());
        if (!observers.has(observer)) {
            observers.add(observer);
            if (target.observerAdded) target.observerAdded(observers.size, observer);
        }
    }
    return observer;
}
function $e8edaf4006ebf949$export$7a0eb830d336339b(target, observer) {
    let observers = target[$e8edaf4006ebf949$var$$observers];
    if (observers && observers.has(observer)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer);
        else target[$e8edaf4006ebf949$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer);
    }
}
const $e8edaf4006ebf949$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $e8edaf4006ebf949$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const $e8edaf4006ebf949$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
let $e8edaf4006ebf949$var$namedColorRegex;
const $e8edaf4006ebf949$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const $e8edaf4006ebf949$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
const $e8edaf4006ebf949$export$4759a013d387347a = (config)=>{
    if (!$e8edaf4006ebf949$var$namedColorRegex) $e8edaf4006ebf949$var$namedColorRegex = $e8edaf4006ebf949$var$colors$1 ? new RegExp(`(${Object.keys($e8edaf4006ebf949$var$colors$1).join("|")})(?!\\w)`, "g") : /^\b$/;
    const output = config.output.map((value)=>$e8edaf4006ebf949$export$e37b7520edd66839(value).replace($e8edaf4006ebf949$var$colorRegex, $e8edaf4006ebf949$export$61db176b839af1f).replace($e8edaf4006ebf949$var$namedColorRegex, $e8edaf4006ebf949$export$61db176b839af1f));
    const keyframes = output.map((value)=>value.match($e8edaf4006ebf949$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output)=>$e8edaf4006ebf949$export$b12af43b97697ef5($e8edaf4006ebf949$var$_extends({}, config, {
            output: output
        })));
    return (input)=>{
        let i = 0;
        return output[0].replace($e8edaf4006ebf949$var$numberRegex, ()=>String(interpolators[i++](input))).replace($e8edaf4006ebf949$var$rgbaRegex, $e8edaf4006ebf949$var$rgbaRound);
    };
};
const $e8edaf4006ebf949$var$prefix = "react-spring: ";
const $e8edaf4006ebf949$var$once = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$e8edaf4006ebf949$var$prefix}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
const $e8edaf4006ebf949$var$warnInterpolate = $e8edaf4006ebf949$var$once(console.warn);
function $e8edaf4006ebf949$export$2abfcde8ae218ba8() {
    $e8edaf4006ebf949$var$warnInterpolate(`${$e8edaf4006ebf949$var$prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const $e8edaf4006ebf949$var$warnDirectCall = $e8edaf4006ebf949$var$once(console.warn);
function $e8edaf4006ebf949$export$d99d974913ad3b12() {
    $e8edaf4006ebf949$var$warnDirectCall(`${$e8edaf4006ebf949$var$prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function $e8edaf4006ebf949$export$75bed621f62abfa9(value) {
    return $e8edaf4006ebf949$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || value in ($e8edaf4006ebf949$var$colors$1 || {}));
}
const $e8edaf4006ebf949$export$392544347a18b6ea = (effect)=>(0, $70fFQ.useEffect)(effect, $e8edaf4006ebf949$var$emptyDeps);
const $e8edaf4006ebf949$var$emptyDeps = [];
function $e8edaf4006ebf949$export$91db9bc4f8ac944a() {
    const update = (0, $70fFQ.useState)()[1];
    const mounted = (0, $70fFQ.useState)($e8edaf4006ebf949$var$makeMountedRef)[0];
    $e8edaf4006ebf949$export$392544347a18b6ea(mounted.unmount);
    return ()=>{
        if (mounted.current) update({});
    };
}
function $e8edaf4006ebf949$var$makeMountedRef() {
    const mounted = {
        current: true,
        unmount: ()=>()=>{
                mounted.current = false;
            }
    };
    return mounted;
}
function $e8edaf4006ebf949$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $70fFQ.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $70fFQ.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $e8edaf4006ebf949$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $70fFQ.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = undefined;
    }, [
        cache
    ]);
    return cache.result;
}
function $e8edaf4006ebf949$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
function $e8edaf4006ebf949$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $70fFQ.useRef)();
    (0, $70fFQ.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
const $e8edaf4006ebf949$export$e5c5a5f917a5871c = typeof window !== "undefined" && window.document && window.document.createElement ? $70fFQ.useLayoutEffect : $70fFQ.useEffect;

});
parcelRegister("bUNLs", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $8acb86d8366a6ec9$export$27f233d61a9e2fa4; });
let $8acb86d8366a6ec9$var$updateQueue = $8acb86d8366a6ec9$var$makeQueue();
const $8acb86d8366a6ec9$export$27f233d61a9e2fa4 = (fn)=>$8acb86d8366a6ec9$var$schedule(fn, $8acb86d8366a6ec9$var$updateQueue);
let $8acb86d8366a6ec9$var$writeQueue = $8acb86d8366a6ec9$var$makeQueue();
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.write = (fn)=>$8acb86d8366a6ec9$var$schedule(fn, $8acb86d8366a6ec9$var$writeQueue);
let $8acb86d8366a6ec9$var$onStartQueue = $8acb86d8366a6ec9$var$makeQueue();
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.onStart = (fn)=>$8acb86d8366a6ec9$var$schedule(fn, $8acb86d8366a6ec9$var$onStartQueue);
let $8acb86d8366a6ec9$var$onFrameQueue = $8acb86d8366a6ec9$var$makeQueue();
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.onFrame = (fn)=>$8acb86d8366a6ec9$var$schedule(fn, $8acb86d8366a6ec9$var$onFrameQueue);
let $8acb86d8366a6ec9$var$onFinishQueue = $8acb86d8366a6ec9$var$makeQueue();
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.onFinish = (fn)=>$8acb86d8366a6ec9$var$schedule(fn, $8acb86d8366a6ec9$var$onFinishQueue);
let $8acb86d8366a6ec9$var$timeouts = [];
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    let time = $8acb86d8366a6ec9$export$27f233d61a9e2fa4.now() + ms;
    let cancel = ()=>{
        let i = $8acb86d8366a6ec9$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $8acb86d8366a6ec9$var$timeouts.splice(i, 1);
        $8acb86d8366a6ec9$export$ef91a23fc803e177.count -= ~i ? 1 : 0;
    };
    let timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $8acb86d8366a6ec9$var$timeouts.splice($8acb86d8366a6ec9$var$findTimeout(time), 0, timeout);
    $8acb86d8366a6ec9$export$ef91a23fc803e177.count += 1;
    $8acb86d8366a6ec9$var$start();
    return timeout;
};
let $8acb86d8366a6ec9$var$findTimeout = (time)=>~(~$8acb86d8366a6ec9$var$timeouts.findIndex((t)=>t.time > time) || ~$8acb86d8366a6ec9$var$timeouts.length);
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $8acb86d8366a6ec9$var$updateQueue.delete(fn);
    $8acb86d8366a6ec9$var$writeQueue.delete(fn);
};
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.sync = (fn)=>{
    $8acb86d8366a6ec9$var$sync = true;
    $8acb86d8366a6ec9$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $8acb86d8366a6ec9$var$sync = false;
};
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $8acb86d8366a6ec9$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $8acb86d8366a6ec9$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
let $8acb86d8366a6ec9$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : ()=>{};
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.use = (impl)=>$8acb86d8366a6ec9$var$nativeRaf = impl;
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.catch = console.error;
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.frameLoop = "always";
$8acb86d8366a6ec9$export$27f233d61a9e2fa4.advance = ()=>{
    if ($8acb86d8366a6ec9$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $8acb86d8366a6ec9$var$update();
};
let $8acb86d8366a6ec9$var$ts = -1;
let $8acb86d8366a6ec9$var$sync = false;
function $8acb86d8366a6ec9$var$schedule(fn, queue) {
    if ($8acb86d8366a6ec9$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $8acb86d8366a6ec9$var$start();
    }
}
function $8acb86d8366a6ec9$var$start() {
    if ($8acb86d8366a6ec9$var$ts < 0) {
        $8acb86d8366a6ec9$var$ts = 0;
        if ($8acb86d8366a6ec9$export$27f233d61a9e2fa4.frameLoop !== "demand") $8acb86d8366a6ec9$var$nativeRaf($8acb86d8366a6ec9$var$loop);
    }
}
function $8acb86d8366a6ec9$var$loop() {
    if (~$8acb86d8366a6ec9$var$ts) {
        $8acb86d8366a6ec9$var$nativeRaf($8acb86d8366a6ec9$var$loop);
        $8acb86d8366a6ec9$export$27f233d61a9e2fa4.batchedUpdates($8acb86d8366a6ec9$var$update);
    }
}
function $8acb86d8366a6ec9$var$update() {
    let prevTs = $8acb86d8366a6ec9$var$ts;
    $8acb86d8366a6ec9$var$ts = $8acb86d8366a6ec9$export$27f233d61a9e2fa4.now();
    let count = $8acb86d8366a6ec9$var$findTimeout($8acb86d8366a6ec9$var$ts);
    if (count) {
        $8acb86d8366a6ec9$var$eachSafely($8acb86d8366a6ec9$var$timeouts.splice(0, count), (t)=>t.handler());
        $8acb86d8366a6ec9$export$ef91a23fc803e177.count -= count;
    }
    $8acb86d8366a6ec9$var$onStartQueue.flush();
    $8acb86d8366a6ec9$var$updateQueue.flush(prevTs ? Math.min(64, $8acb86d8366a6ec9$var$ts - prevTs) : 16.667);
    $8acb86d8366a6ec9$var$onFrameQueue.flush();
    $8acb86d8366a6ec9$var$writeQueue.flush();
    $8acb86d8366a6ec9$var$onFinishQueue.flush();
}
function $8acb86d8366a6ec9$var$makeQueue() {
    let next = new Set();
    let current = next;
    return {
        add (fn) {
            $8acb86d8366a6ec9$export$ef91a23fc803e177.count += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $8acb86d8366a6ec9$export$ef91a23fc803e177.count -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = new Set();
                $8acb86d8366a6ec9$export$ef91a23fc803e177.count -= current.size;
                $8acb86d8366a6ec9$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $8acb86d8366a6ec9$export$ef91a23fc803e177.count += next.size;
                current = next;
            }
        }
    };
}
function $8acb86d8366a6ec9$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $8acb86d8366a6ec9$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
const $8acb86d8366a6ec9$export$ef91a23fc803e177 = {
    count: 0,
    clear () {
        $8acb86d8366a6ec9$var$ts = -1;
        $8acb86d8366a6ec9$var$timeouts = [];
        $8acb86d8366a6ec9$var$onStartQueue = $8acb86d8366a6ec9$var$makeQueue();
        $8acb86d8366a6ec9$var$updateQueue = $8acb86d8366a6ec9$var$makeQueue();
        $8acb86d8366a6ec9$var$onFrameQueue = $8acb86d8366a6ec9$var$makeQueue();
        $8acb86d8366a6ec9$var$writeQueue = $8acb86d8366a6ec9$var$makeQueue();
        $8acb86d8366a6ec9$var$onFinishQueue = $8acb86d8366a6ec9$var$makeQueue();
        $8acb86d8366a6ec9$export$ef91a23fc803e177.count = 0;
    }
};

});


parcelRegister("2hAeX", function(module, exports) {

$parcel$export(module.exports, "getAnimated", function () { return $1a9947dadd7716d8$export$6b63995194a3a9e4; });
$parcel$export(module.exports, "setAnimated", function () { return $1a9947dadd7716d8$export$b553cb5b22b81b04; });
$parcel$export(module.exports, "getPayload", function () { return $1a9947dadd7716d8$export$ccab2b64c5d440; });
$parcel$export(module.exports, "AnimatedValue", function () { return $1a9947dadd7716d8$export$cb1e8f3c05d37ad5; });
$parcel$export(module.exports, "AnimatedString", function () { return $1a9947dadd7716d8$export$f6c6c4cbd7fa5b93; });
$parcel$export(module.exports, "AnimatedObject", function () { return $1a9947dadd7716d8$export$f1b0b9e366a6e2d4; });
$parcel$export(module.exports, "getAnimatedType", function () { return $1a9947dadd7716d8$export$e6b77ddbe47b132e; });
$parcel$export(module.exports, "createHost", function () { return $1a9947dadd7716d8$export$4ee5c78f6dcbcef; });

var $jZS6F = parcelRequire("jZS6F");
var $bUNLs = parcelRequire("bUNLs");

var $70fFQ = parcelRequire("70fFQ");
const $1a9947dadd7716d8$var$$node = Symbol.for("Animated:node");
const $1a9947dadd7716d8$export$3df5e165e801a70f = (value)=>!!value && value[$1a9947dadd7716d8$var$$node] === value;
const $1a9947dadd7716d8$export$6b63995194a3a9e4 = (owner)=>owner && owner[$1a9947dadd7716d8$var$$node];
const $1a9947dadd7716d8$export$b553cb5b22b81b04 = (owner, node)=>(0, $jZS6F.defineHidden)(owner, $1a9947dadd7716d8$var$$node, node);
const $1a9947dadd7716d8$export$ccab2b64c5d440 = (owner)=>owner && owner[$1a9947dadd7716d8$var$$node] && owner[$1a9947dadd7716d8$var$$node].getPayload();
class $1a9947dadd7716d8$export$31627395a3b18e54 {
    getPayload() {
        return this.payload || [];
    }
    constructor(){
        this.payload = void 0;
        $1a9947dadd7716d8$export$b553cb5b22b81b04(this, this);
    }
}
class $1a9947dadd7716d8$export$cb1e8f3c05d37ad5 extends $1a9947dadd7716d8$export$31627395a3b18e54 {
    static create(value) {
        return new $1a9947dadd7716d8$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $jZS6F.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $jZS6F.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this.done = true;
        this.elapsedTime = void 0;
        this.lastPosition = void 0;
        this.lastVelocity = void 0;
        this.v0 = void 0;
        this.durationProgress = 0;
        this._value = _value;
        if ((0, $jZS6F.is).num(this._value)) this.lastPosition = this._value;
    }
}
class $1a9947dadd7716d8$export$f6c6c4cbd7fa5b93 extends $1a9947dadd7716d8$export$cb1e8f3c05d37ad5 {
    static create(value) {
        return new $1a9947dadd7716d8$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        let value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $jZS6F.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $jZS6F.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = void 0;
        this._toString = (0, $jZS6F.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
}
const $1a9947dadd7716d8$var$TreeContext = {
    dependencies: null
};
class $1a9947dadd7716d8$export$f1b0b9e366a6e2d4 extends $1a9947dadd7716d8$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $jZS6F.eachProp)(this.source, (source, key)=>{
            if ($1a9947dadd7716d8$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $jZS6F.hasFluidValue)(source)) values[key] = (0, $jZS6F.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $jZS6F.each)(this.payload, (node)=>node.reset());
    }
    _makePayload(source) {
        if (source) {
            const payload = new Set();
            (0, $jZS6F.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    _addToPayload(source) {
        if ($1a9947dadd7716d8$var$TreeContext.dependencies && (0, $jZS6F.hasFluidValue)(source)) $1a9947dadd7716d8$var$TreeContext.dependencies.add(source);
        const payload = $1a9947dadd7716d8$export$ccab2b64c5d440(source);
        if (payload) (0, $jZS6F.each)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
}
class $1a9947dadd7716d8$export$ede394683406942d extends $1a9947dadd7716d8$export$f1b0b9e366a6e2d4 {
    static create(source) {
        return new $1a9947dadd7716d8$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($1a9947dadd7716d8$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
}
function $1a9947dadd7716d8$var$makeAnimated(value) {
    const nodeType = (0, $jZS6F.isAnimatedString)(value) ? $1a9947dadd7716d8$export$f6c6c4cbd7fa5b93 : $1a9947dadd7716d8$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $1a9947dadd7716d8$export$e6b77ddbe47b132e(value) {
    const parentNode = $1a9947dadd7716d8$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $jZS6F.is).arr(value) ? $1a9947dadd7716d8$export$ede394683406942d : (0, $jZS6F.isAnimatedString)(value) ? $1a9947dadd7716d8$export$f6c6c4cbd7fa5b93 : $1a9947dadd7716d8$export$cb1e8f3c05d37ad5;
}
function $1a9947dadd7716d8$var$_extends() {
    $1a9947dadd7716d8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a9947dadd7716d8$var$_extends.apply(this, arguments);
}
const $1a9947dadd7716d8$var$withAnimated = (Component, host)=>{
    const hasInstance = !(0, $jZS6F.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $70fFQ.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $70fFQ.useRef)(null);
        const ref = hasInstance && (0, $70fFQ.useCallback)((value)=>{
            instanceRef.current = $1a9947dadd7716d8$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $1a9947dadd7716d8$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $jZS6F.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $1a9947dadd7716d8$var$PropsObserver(callback, deps);
        const observerRef = (0, $70fFQ.useRef)();
        (0, $jZS6F.useLayoutEffect)(()=>{
            const lastObserver = observerRef.current;
            observerRef.current = observer;
            (0, $jZS6F.each)(deps, (dep)=>(0, $jZS6F.addFluidObserver)(dep, observer));
            if (lastObserver) {
                (0, $jZS6F.each)(lastObserver.deps, (dep)=>(0, $jZS6F.removeFluidObserver)(dep, lastObserver));
                (0, $bUNLs.raf).cancel(lastObserver.update);
            }
        });
        (0, $70fFQ.useEffect)(callback, []);
        (0, $jZS6F.useOnce)(()=>()=>{
                const observer = observerRef.current;
                (0, $jZS6F.each)(observer.deps, (dep)=>(0, $jZS6F.removeFluidObserver)(dep, observer));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return $70fFQ.createElement(Component, $1a9947dadd7716d8$var$_extends({}, usedProps, {
            ref: ref
        }));
    });
};
class $1a9947dadd7716d8$var$PropsObserver {
    eventObserved(event) {
        if (event.type == "change") (0, $bUNLs.raf).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
}
function $1a9947dadd7716d8$var$getAnimatedState(props, host) {
    const dependencies = new Set();
    $1a9947dadd7716d8$var$TreeContext.dependencies = dependencies;
    if (props.style) props = $1a9947dadd7716d8$var$_extends({}, props, {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $1a9947dadd7716d8$export$f1b0b9e366a6e2d4(props);
    $1a9947dadd7716d8$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $1a9947dadd7716d8$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $jZS6F.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
const $1a9947dadd7716d8$var$cacheKey = Symbol.for("AnimatedComponent");
const $1a9947dadd7716d8$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: _applyAnimatedValues = ()=>false, createAnimatedStyle: _createAnimatedStyle = (style)=>new $1a9947dadd7716d8$export$f1b0b9e366a6e2d4(style), getComponentProps: _getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: _applyAnimatedValues,
        createAnimatedStyle: _createAnimatedStyle,
        getComponentProps: _getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $1a9947dadd7716d8$var$getDisplayName(Component) || "Anonymous";
        if ((0, $jZS6F.is).str(Component)) Component = animated[Component] || (animated[Component] = $1a9947dadd7716d8$var$withAnimated(Component, hostConfig));
        else Component = Component[$1a9947dadd7716d8$var$cacheKey] || (Component[$1a9947dadd7716d8$var$cacheKey] = $1a9947dadd7716d8$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $jZS6F.eachProp)(components, (Component, key)=>{
        if ((0, $jZS6F.is).arr(components)) key = $1a9947dadd7716d8$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
const $1a9947dadd7716d8$var$getDisplayName = (arg)=>(0, $jZS6F.is).str(arg) ? arg : arg && (0, $jZS6F.is).str(arg.displayName) ? arg.displayName : (0, $jZS6F.is).fun(arg) && arg.name || null;

});

parcelRegister("cJLRh", function(module, exports) {

});

parcelRegister("fTEGT", function(module, exports) {

});




parcelRegister("lldRo", function(module, exports) {

var $6TI11 = parcelRequire("6TI11");

var $h4MLO = parcelRequire("h4MLO");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $f8964f77c2076cca$var$merge = $h4MLO(function(object, source, srcIndex) {
    $6TI11(object, source, srcIndex);
});
module.exports = $f8964f77c2076cca$var$merge;

});
parcelRegister("6TI11", function(module, exports) {

var $ghuvx = parcelRequire("ghuvx");

var $jmbe1 = parcelRequire("jmbe1");

var $fBeMr = parcelRequire("fBeMr");

var $7Trth = parcelRequire("7Trth");

var $jQzKY = parcelRequire("jQzKY");

var $5yKNI = parcelRequire("5yKNI");

var $goQhM = parcelRequire("goQhM");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $505a05ad6a6e38f5$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $fBeMr(source, function(srcValue, key) {
        stack || (stack = new $ghuvx);
        if ($jQzKY(srcValue)) $7Trth(object, source, key, srcIndex, $505a05ad6a6e38f5$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($goQhM(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $jmbe1(object, key, newValue);
        }
    }, $5yKNI);
}
module.exports = $505a05ad6a6e38f5$var$baseMerge;

});
parcelRegister("ghuvx", function(module, exports) {

var $lFHg3 = parcelRequire("lFHg3");

var $giUAJ = parcelRequire("giUAJ");

var $4ba3X = parcelRequire("4ba3X");

var $22pZI = parcelRequire("22pZI");

var $szlJm = parcelRequire("szlJm");

var $i19Fr = parcelRequire("i19Fr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bda5e6103b3dec62$var$Stack(entries) {
    var data = this.__data__ = new $lFHg3(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bda5e6103b3dec62$var$Stack.prototype.clear = $giUAJ;
$bda5e6103b3dec62$var$Stack.prototype["delete"] = $4ba3X;
$bda5e6103b3dec62$var$Stack.prototype.get = $22pZI;
$bda5e6103b3dec62$var$Stack.prototype.has = $szlJm;
$bda5e6103b3dec62$var$Stack.prototype.set = $i19Fr;
module.exports = $bda5e6103b3dec62$var$Stack;

});
parcelRegister("lFHg3", function(module, exports) {

var $lJxYF = parcelRequire("lJxYF");

var $fsbZO = parcelRequire("fsbZO");

var $aEhVX = parcelRequire("aEhVX");

var $ih2kp = parcelRequire("ih2kp");

var $c6PhA = parcelRequire("c6PhA");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fc6efb759cc45ecb$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$fc6efb759cc45ecb$var$ListCache.prototype.clear = $lJxYF;
$fc6efb759cc45ecb$var$ListCache.prototype["delete"] = $fsbZO;
$fc6efb759cc45ecb$var$ListCache.prototype.get = $aEhVX;
$fc6efb759cc45ecb$var$ListCache.prototype.has = $ih2kp;
$fc6efb759cc45ecb$var$ListCache.prototype.set = $c6PhA;
module.exports = $fc6efb759cc45ecb$var$ListCache;

});
parcelRegister("lJxYF", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $fd282829660d9ef3$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $fd282829660d9ef3$var$listCacheClear;

});

parcelRegister("fsbZO", function(module, exports) {

var $3sEFD = parcelRequire("3sEFD");
/** Used for built-in method references. */ var $02e74544ebedb282$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $02e74544ebedb282$var$splice = $02e74544ebedb282$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $02e74544ebedb282$var$listCacheDelete(key) {
    var data = this.__data__, index = $3sEFD(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $02e74544ebedb282$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $02e74544ebedb282$var$listCacheDelete;

});
parcelRegister("3sEFD", function(module, exports) {

var $aCDT6 = parcelRequire("aCDT6");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $285388ebbaf922db$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($aCDT6(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $285388ebbaf922db$var$assocIndexOf;

});
parcelRegister("aCDT6", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $7bbc64de9c98993e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $7bbc64de9c98993e$var$eq;

});



parcelRegister("aEhVX", function(module, exports) {

var $3sEFD = parcelRequire("3sEFD");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7c0b8d19159d643e$var$listCacheGet(key) {
    var data = this.__data__, index = $3sEFD(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $7c0b8d19159d643e$var$listCacheGet;

});

parcelRegister("ih2kp", function(module, exports) {

var $3sEFD = parcelRequire("3sEFD");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d4db9ed793a59fc2$var$listCacheHas(key) {
    return $3sEFD(this.__data__, key) > -1;
}
module.exports = $d4db9ed793a59fc2$var$listCacheHas;

});

parcelRegister("c6PhA", function(module, exports) {

var $3sEFD = parcelRequire("3sEFD");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8d0dd340987117c9$var$listCacheSet(key, value) {
    var data = this.__data__, index = $3sEFD(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $8d0dd340987117c9$var$listCacheSet;

});


parcelRegister("giUAJ", function(module, exports) {

var $lFHg3 = parcelRequire("lFHg3");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $bdea39a866f26277$var$stackClear() {
    this.__data__ = new $lFHg3;
    this.size = 0;
}
module.exports = $bdea39a866f26277$var$stackClear;

});

parcelRegister("4ba3X", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $30affec82f7758d2$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $30affec82f7758d2$var$stackDelete;

});

parcelRegister("22pZI", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $17bfeea64bd0f768$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $17bfeea64bd0f768$var$stackGet;

});

parcelRegister("szlJm", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $055e09502bab1d00$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $055e09502bab1d00$var$stackHas;

});

parcelRegister("i19Fr", function(module, exports) {

var $lFHg3 = parcelRequire("lFHg3");

var $ZFSZQ = parcelRequire("ZFSZQ");

var $8wBGT = parcelRequire("8wBGT");
/** Used as the size to enable large array optimizations. */ var $d1dfd1bf1cdf6ec9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d1dfd1bf1cdf6ec9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $lFHg3) {
        var pairs = data.__data__;
        if (!$ZFSZQ || pairs.length < $d1dfd1bf1cdf6ec9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $8wBGT(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $d1dfd1bf1cdf6ec9$var$stackSet;

});
parcelRegister("ZFSZQ", function(module, exports) {

var $klMbR = parcelRequire("klMbR");

var $hhiLy = parcelRequire("hhiLy");
/* Built-in method references that are verified to be native. */ var $0b9630508928fa54$var$Map = $klMbR($hhiLy, "Map");
module.exports = $0b9630508928fa54$var$Map;

});
parcelRegister("klMbR", function(module, exports) {

var $71zru = parcelRequire("71zru");

var $2CJKZ = parcelRequire("2CJKZ");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $ed0b2661e8858180$var$getNative(object, key) {
    var value = $2CJKZ(object, key);
    return $71zru(value) ? value : undefined;
}
module.exports = $ed0b2661e8858180$var$getNative;

});
parcelRegister("71zru", function(module, exports) {

var $dC9tX = parcelRequire("dC9tX");

var $iR8Sz = parcelRequire("iR8Sz");

var $jQzKY = parcelRequire("jQzKY");

var $luMAq = parcelRequire("luMAq");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $51d41e870781e743$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $51d41e870781e743$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $51d41e870781e743$var$funcProto = Function.prototype, $51d41e870781e743$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $51d41e870781e743$var$funcToString = $51d41e870781e743$var$funcProto.toString;
/** Used to check objects for own properties. */ var $51d41e870781e743$var$hasOwnProperty = $51d41e870781e743$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $51d41e870781e743$var$reIsNative = RegExp("^" + $51d41e870781e743$var$funcToString.call($51d41e870781e743$var$hasOwnProperty).replace($51d41e870781e743$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $51d41e870781e743$var$baseIsNative(value) {
    if (!$jQzKY(value) || $iR8Sz(value)) return false;
    var pattern = $dC9tX(value) ? $51d41e870781e743$var$reIsNative : $51d41e870781e743$var$reIsHostCtor;
    return pattern.test($luMAq(value));
}
module.exports = $51d41e870781e743$var$baseIsNative;

});
parcelRegister("dC9tX", function(module, exports) {

var $91x1j = parcelRequire("91x1j");

var $jQzKY = parcelRequire("jQzKY");
/** `Object#toString` result references. */ var $9e962df4eecf4ae6$var$asyncTag = "[object AsyncFunction]", $9e962df4eecf4ae6$var$funcTag = "[object Function]", $9e962df4eecf4ae6$var$genTag = "[object GeneratorFunction]", $9e962df4eecf4ae6$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $9e962df4eecf4ae6$var$isFunction(value) {
    if (!$jQzKY(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $91x1j(value);
    return tag == $9e962df4eecf4ae6$var$funcTag || tag == $9e962df4eecf4ae6$var$genTag || tag == $9e962df4eecf4ae6$var$asyncTag || tag == $9e962df4eecf4ae6$var$proxyTag;
}
module.exports = $9e962df4eecf4ae6$var$isFunction;

});
parcelRegister("91x1j", function(module, exports) {

var $kZpX4 = parcelRequire("kZpX4");

var $8gVPF = parcelRequire("8gVPF");

var $u5Wwn = parcelRequire("u5Wwn");
/** `Object#toString` result references. */ var $691dd22a329e7567$var$nullTag = "[object Null]", $691dd22a329e7567$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $691dd22a329e7567$var$symToStringTag = $kZpX4 ? $kZpX4.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $691dd22a329e7567$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $691dd22a329e7567$var$undefinedTag : $691dd22a329e7567$var$nullTag;
    return $691dd22a329e7567$var$symToStringTag && $691dd22a329e7567$var$symToStringTag in Object(value) ? $8gVPF(value) : $u5Wwn(value);
}
module.exports = $691dd22a329e7567$var$baseGetTag;

});
parcelRegister("kZpX4", function(module, exports) {

var $hhiLy = parcelRequire("hhiLy");
/** Built-in value references. */ var $f47da29d09af6803$var$Symbol = $hhiLy.Symbol;
module.exports = $f47da29d09af6803$var$Symbol;

});
parcelRegister("hhiLy", function(module, exports) {

var $3pALO = parcelRequire("3pALO");
/** Detect free variable `self`. */ var $c94294bd3aa33093$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c94294bd3aa33093$var$root = $3pALO || $c94294bd3aa33093$var$freeSelf || Function("return this")();
module.exports = $c94294bd3aa33093$var$root;

});
parcelRegister("3pALO", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $27c03aacbbecd112$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $27c03aacbbecd112$var$freeGlobal;

});



parcelRegister("8gVPF", function(module, exports) {

var $kZpX4 = parcelRequire("kZpX4");
/** Used for built-in method references. */ var $605cada62cf53380$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $605cada62cf53380$var$hasOwnProperty = $605cada62cf53380$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $605cada62cf53380$var$nativeObjectToString = $605cada62cf53380$var$objectProto.toString;
/** Built-in value references. */ var $605cada62cf53380$var$symToStringTag = $kZpX4 ? $kZpX4.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $605cada62cf53380$var$getRawTag(value) {
    var isOwn = $605cada62cf53380$var$hasOwnProperty.call(value, $605cada62cf53380$var$symToStringTag), tag = value[$605cada62cf53380$var$symToStringTag];
    try {
        value[$605cada62cf53380$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $605cada62cf53380$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$605cada62cf53380$var$symToStringTag] = tag;
        else delete value[$605cada62cf53380$var$symToStringTag];
    }
    return result;
}
module.exports = $605cada62cf53380$var$getRawTag;

});

parcelRegister("u5Wwn", function(module, exports) {
/** Used for built-in method references. */ var $05a769972d43637f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $05a769972d43637f$var$nativeObjectToString = $05a769972d43637f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $05a769972d43637f$var$objectToString(value) {
    return $05a769972d43637f$var$nativeObjectToString.call(value);
}
module.exports = $05a769972d43637f$var$objectToString;

});


parcelRegister("jQzKY", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e72e9c26ce0e9a85$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $e72e9c26ce0e9a85$var$isObject;

});


parcelRegister("iR8Sz", function(module, exports) {

var $dA5jt = parcelRequire("dA5jt");
/** Used to detect methods masquerading as native. */ var $dba4107209fdd4b6$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($dA5jt && $dA5jt.keys && $dA5jt.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $dba4107209fdd4b6$var$isMasked(func) {
    return !!$dba4107209fdd4b6$var$maskSrcKey && $dba4107209fdd4b6$var$maskSrcKey in func;
}
module.exports = $dba4107209fdd4b6$var$isMasked;

});
parcelRegister("dA5jt", function(module, exports) {

var $hhiLy = parcelRequire("hhiLy");
/** Used to detect overreaching core-js shims. */ var $9e32c23f8c17db9b$var$coreJsData = $hhiLy["__core-js_shared__"];
module.exports = $9e32c23f8c17db9b$var$coreJsData;

});


parcelRegister("luMAq", function(module, exports) {
/** Used for built-in method references. */ var $fa621699d89f6da9$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $fa621699d89f6da9$var$funcToString = $fa621699d89f6da9$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $fa621699d89f6da9$var$toSource(func) {
    if (func != null) {
        try {
            return $fa621699d89f6da9$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $fa621699d89f6da9$var$toSource;

});


parcelRegister("2CJKZ", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1e929fc0ed91de2b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $1e929fc0ed91de2b$var$getValue;

});



parcelRegister("8wBGT", function(module, exports) {

var $esCBE = parcelRequire("esCBE");

var $j1QlY = parcelRequire("j1QlY");

var $1ZF6W = parcelRequire("1ZF6W");

var $5eBdP = parcelRequire("5eBdP");

var $7gzxU = parcelRequire("7gzxU");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $634e8c83cc85a741$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$634e8c83cc85a741$var$MapCache.prototype.clear = $esCBE;
$634e8c83cc85a741$var$MapCache.prototype["delete"] = $j1QlY;
$634e8c83cc85a741$var$MapCache.prototype.get = $1ZF6W;
$634e8c83cc85a741$var$MapCache.prototype.has = $5eBdP;
$634e8c83cc85a741$var$MapCache.prototype.set = $7gzxU;
module.exports = $634e8c83cc85a741$var$MapCache;

});
parcelRegister("esCBE", function(module, exports) {

var $e915u = parcelRequire("e915u");

var $lFHg3 = parcelRequire("lFHg3");

var $ZFSZQ = parcelRequire("ZFSZQ");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $a871a0a391886a83$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $e915u,
        "map": new ($ZFSZQ || $lFHg3),
        "string": new $e915u
    };
}
module.exports = $a871a0a391886a83$var$mapCacheClear;

});
parcelRegister("e915u", function(module, exports) {

var $gsReE = parcelRequire("gsReE");

var $dgpjK = parcelRequire("dgpjK");

var $6dgb0 = parcelRequire("6dgb0");

var $hHhx6 = parcelRequire("hHhx6");

var $eKBxM = parcelRequire("eKBxM");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a4c2bfeeacaf051d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$a4c2bfeeacaf051d$var$Hash.prototype.clear = $gsReE;
$a4c2bfeeacaf051d$var$Hash.prototype["delete"] = $dgpjK;
$a4c2bfeeacaf051d$var$Hash.prototype.get = $6dgb0;
$a4c2bfeeacaf051d$var$Hash.prototype.has = $hHhx6;
$a4c2bfeeacaf051d$var$Hash.prototype.set = $eKBxM;
module.exports = $a4c2bfeeacaf051d$var$Hash;

});
parcelRegister("gsReE", function(module, exports) {

var $iDRJC = parcelRequire("iDRJC");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $bfc88e49833fb6d5$var$hashClear() {
    this.__data__ = $iDRJC ? $iDRJC(null) : {};
    this.size = 0;
}
module.exports = $bfc88e49833fb6d5$var$hashClear;

});
parcelRegister("iDRJC", function(module, exports) {

var $klMbR = parcelRequire("klMbR");
/* Built-in method references that are verified to be native. */ var $d9258d248406235b$var$nativeCreate = $klMbR(Object, "create");
module.exports = $d9258d248406235b$var$nativeCreate;

});


parcelRegister("dgpjK", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9a80688749bffcfd$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9a80688749bffcfd$var$hashDelete;

});

parcelRegister("6dgb0", function(module, exports) {

var $iDRJC = parcelRequire("iDRJC");
/** Used to stand-in for `undefined` hash values. */ var $48608146a121a196$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $48608146a121a196$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $48608146a121a196$var$hasOwnProperty = $48608146a121a196$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $48608146a121a196$var$hashGet(key) {
    var data = this.__data__;
    if ($iDRJC) {
        var result = data[key];
        return result === $48608146a121a196$var$HASH_UNDEFINED ? undefined : result;
    }
    return $48608146a121a196$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $48608146a121a196$var$hashGet;

});

parcelRegister("hHhx6", function(module, exports) {

var $iDRJC = parcelRequire("iDRJC");
/** Used for built-in method references. */ var $ce240d7e9c2e673f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ce240d7e9c2e673f$var$hasOwnProperty = $ce240d7e9c2e673f$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ce240d7e9c2e673f$var$hashHas(key) {
    var data = this.__data__;
    return $iDRJC ? data[key] !== undefined : $ce240d7e9c2e673f$var$hasOwnProperty.call(data, key);
}
module.exports = $ce240d7e9c2e673f$var$hashHas;

});

parcelRegister("eKBxM", function(module, exports) {

var $iDRJC = parcelRequire("iDRJC");
/** Used to stand-in for `undefined` hash values. */ var $abd27bfccbf8e5de$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $abd27bfccbf8e5de$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $iDRJC && value === undefined ? $abd27bfccbf8e5de$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $abd27bfccbf8e5de$var$hashSet;

});



parcelRegister("j1QlY", function(module, exports) {

var $kqDiW = parcelRequire("kqDiW");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dda6b89cbea82be5$var$mapCacheDelete(key) {
    var result = $kqDiW(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $dda6b89cbea82be5$var$mapCacheDelete;

});
parcelRegister("kqDiW", function(module, exports) {

var $7NUiD = parcelRequire("7NUiD");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $edf4b96bb96a22ae$var$getMapData(map, key) {
    var data = map.__data__;
    return $7NUiD(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $edf4b96bb96a22ae$var$getMapData;

});
parcelRegister("7NUiD", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $5ae8c7e7b3d0185b$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $5ae8c7e7b3d0185b$var$isKeyable;

});



parcelRegister("1ZF6W", function(module, exports) {

var $kqDiW = parcelRequire("kqDiW");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $173b60b66f2df848$var$mapCacheGet(key) {
    return $kqDiW(this, key).get(key);
}
module.exports = $173b60b66f2df848$var$mapCacheGet;

});

parcelRegister("5eBdP", function(module, exports) {

var $kqDiW = parcelRequire("kqDiW");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3cfb22152da4f7bc$var$mapCacheHas(key) {
    return $kqDiW(this, key).has(key);
}
module.exports = $3cfb22152da4f7bc$var$mapCacheHas;

});

parcelRegister("7gzxU", function(module, exports) {

var $kqDiW = parcelRequire("kqDiW");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $54a599b6a118771b$var$mapCacheSet(key, value) {
    var data = $kqDiW(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $54a599b6a118771b$var$mapCacheSet;

});




parcelRegister("jmbe1", function(module, exports) {

var $9Zv7x = parcelRequire("9Zv7x");

var $aCDT6 = parcelRequire("aCDT6");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e178c77f37d30a95$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$aCDT6(object[key], value) || value === undefined && !(key in object)) $9Zv7x(object, key, value);
}
module.exports = $e178c77f37d30a95$var$assignMergeValue;

});
parcelRegister("9Zv7x", function(module, exports) {

var $6Q3q9 = parcelRequire("6Q3q9");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7461f3760607dfcb$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $6Q3q9) $6Q3q9(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $7461f3760607dfcb$var$baseAssignValue;

});
parcelRegister("6Q3q9", function(module, exports) {

var $klMbR = parcelRequire("klMbR");
var $4faa40b93a80482f$var$defineProperty = function() {
    try {
        var func = $klMbR(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $4faa40b93a80482f$var$defineProperty;

});



parcelRegister("fBeMr", function(module, exports) {

var $5nALN = parcelRequire("5nALN");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $b5b5c6c39a76663d$var$baseFor = $5nALN();
module.exports = $b5b5c6c39a76663d$var$baseFor;

});
parcelRegister("5nALN", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3eab9f7af27c4a51$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $3eab9f7af27c4a51$var$createBaseFor;

});


parcelRegister("7Trth", function(module, exports) {

var $jmbe1 = parcelRequire("jmbe1");

var $gxSJF = parcelRequire("gxSJF");

var $9fxki = parcelRequire("9fxki");

var $iVAkd = parcelRequire("iVAkd");

var $lj4vk = parcelRequire("lj4vk");

var $EPvHK = parcelRequire("EPvHK");

var $ioays = parcelRequire("ioays");

var $5mBAP = parcelRequire("5mBAP");

var $3BSWT = parcelRequire("3BSWT");

var $dC9tX = parcelRequire("dC9tX");

var $jQzKY = parcelRequire("jQzKY");

var $fnQSe = parcelRequire("fnQSe");

var $kheMX = parcelRequire("kheMX");

var $goQhM = parcelRequire("goQhM");

var $d4Nyo = parcelRequire("d4Nyo");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $5bf2faab7076a58d$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $goQhM(object, key), srcValue = $goQhM(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $jmbe1(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $ioays(srcValue), isBuff = !isArr && $3BSWT(srcValue), isTyped = !isArr && !isBuff && $kheMX(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($ioays(objValue)) newValue = objValue;
            else if ($5mBAP(objValue)) newValue = $iVAkd(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $gxSJF(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $9fxki(srcValue, true);
            } else newValue = [];
        } else if ($fnQSe(srcValue) || $EPvHK(srcValue)) {
            newValue = objValue;
            if ($EPvHK(objValue)) newValue = $d4Nyo(objValue);
            else if (!$jQzKY(objValue) || $dC9tX(objValue)) newValue = $lj4vk(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $jmbe1(object, key, newValue);
}
module.exports = $5bf2faab7076a58d$var$baseMergeDeep;

});
parcelRegister("gxSJF", function(module, exports) {

var $hhiLy = parcelRequire("hhiLy");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $hhiLy.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("9fxki", function(module, exports) {

var $hU2zO = parcelRequire("hU2zO");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $6bbf5daba4647362$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $hU2zO(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $6bbf5daba4647362$var$cloneTypedArray;

});
parcelRegister("hU2zO", function(module, exports) {

var $gu1aG = parcelRequire("gu1aG");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $d089aa5145122195$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $gu1aG(result).set(new $gu1aG(arrayBuffer));
    return result;
}
module.exports = $d089aa5145122195$var$cloneArrayBuffer;

});
parcelRegister("gu1aG", function(module, exports) {

var $hhiLy = parcelRequire("hhiLy");
/** Built-in value references. */ var $c0005b46f7babfda$var$Uint8Array = $hhiLy.Uint8Array;
module.exports = $c0005b46f7babfda$var$Uint8Array;

});



parcelRegister("iVAkd", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $dc79ba440de64986$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $dc79ba440de64986$var$copyArray;

});

parcelRegister("lj4vk", function(module, exports) {

var $dTRib = parcelRequire("dTRib");

var $9fjxL = parcelRequire("9fjxL");

var $1c8Xi = parcelRequire("1c8Xi");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $f82eddc1f6cb34c5$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$1c8Xi(object) ? $dTRib($9fjxL(object)) : {};
}
module.exports = $f82eddc1f6cb34c5$var$initCloneObject;

});
parcelRegister("dTRib", function(module, exports) {

var $jQzKY = parcelRequire("jQzKY");
/** Built-in value references. */ var $a1e9c02d7f4369dc$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a1e9c02d7f4369dc$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$jQzKY(proto)) return {};
        if ($a1e9c02d7f4369dc$var$objectCreate) return $a1e9c02d7f4369dc$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $a1e9c02d7f4369dc$var$baseCreate;

});

parcelRegister("9fjxL", function(module, exports) {

var $u36QN = parcelRequire("u36QN");
/** Built-in value references. */ var $6bb4acbc05fdd59f$var$getPrototype = $u36QN(Object.getPrototypeOf, Object);
module.exports = $6bb4acbc05fdd59f$var$getPrototype;

});
parcelRegister("u36QN", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $05a536effa8712d9$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $05a536effa8712d9$var$overArg;

});


parcelRegister("1c8Xi", function(module, exports) {
/** Used for built-in method references. */ var $0deddbc3e832cb31$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0deddbc3e832cb31$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $0deddbc3e832cb31$var$objectProto;
    return value === proto;
}
module.exports = $0deddbc3e832cb31$var$isPrototype;

});


parcelRegister("EPvHK", function(module, exports) {

var $aVXZl = parcelRequire("aVXZl");

var $ftx1W = parcelRequire("ftx1W");
/** Used for built-in method references. */ var $07abb16d54467d30$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $07abb16d54467d30$var$hasOwnProperty = $07abb16d54467d30$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $07abb16d54467d30$var$propertyIsEnumerable = $07abb16d54467d30$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $07abb16d54467d30$var$isArguments = $aVXZl(function() {
    return arguments;
}()) ? $aVXZl : function(value) {
    return $ftx1W(value) && $07abb16d54467d30$var$hasOwnProperty.call(value, "callee") && !$07abb16d54467d30$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $07abb16d54467d30$var$isArguments;

});
parcelRegister("aVXZl", function(module, exports) {

var $91x1j = parcelRequire("91x1j");

var $ftx1W = parcelRequire("ftx1W");
/** `Object#toString` result references. */ var $7f5dc2baff624aa4$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $7f5dc2baff624aa4$var$baseIsArguments(value) {
    return $ftx1W(value) && $91x1j(value) == $7f5dc2baff624aa4$var$argsTag;
}
module.exports = $7f5dc2baff624aa4$var$baseIsArguments;

});
parcelRegister("ftx1W", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b4432f95ca97abd4$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $b4432f95ca97abd4$var$isObjectLike;

});



parcelRegister("ioays", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d632a7dacdae9c79$var$isArray = Array.isArray;
module.exports = $d632a7dacdae9c79$var$isArray;

});

parcelRegister("5mBAP", function(module, exports) {

var $79oK4 = parcelRequire("79oK4");

var $ftx1W = parcelRequire("ftx1W");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $3e7c2b080813cf12$var$isArrayLikeObject(value) {
    return $ftx1W(value) && $79oK4(value);
}
module.exports = $3e7c2b080813cf12$var$isArrayLikeObject;

});
parcelRegister("79oK4", function(module, exports) {

var $dC9tX = parcelRequire("dC9tX");

var $5VAtD = parcelRequire("5VAtD");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $534c90f17f4222c6$var$isArrayLike(value) {
    return value != null && $5VAtD(value.length) && !$dC9tX(value);
}
module.exports = $534c90f17f4222c6$var$isArrayLike;

});
parcelRegister("5VAtD", function(module, exports) {
/** Used as references for various `Number` constants. */ var $450e922c5b7b01ce$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $450e922c5b7b01ce$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $450e922c5b7b01ce$var$MAX_SAFE_INTEGER;
}
module.exports = $450e922c5b7b01ce$var$isLength;

});



parcelRegister("3BSWT", function(module, exports) {

var $hhiLy = parcelRequire("hhiLy");

var $1Axkr = parcelRequire("1Axkr");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $hhiLy.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1Axkr;
module.exports = isBuffer;

});
parcelRegister("1Axkr", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $1283019dbc3d88fb$var$stubFalse() {
    return false;
}
module.exports = $1283019dbc3d88fb$var$stubFalse;

});


parcelRegister("fnQSe", function(module, exports) {

var $91x1j = parcelRequire("91x1j");

var $9fjxL = parcelRequire("9fjxL");

var $ftx1W = parcelRequire("ftx1W");
/** `Object#toString` result references. */ var $b332049cd700b6a2$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $b332049cd700b6a2$var$funcProto = Function.prototype, $b332049cd700b6a2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b332049cd700b6a2$var$funcToString = $b332049cd700b6a2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b332049cd700b6a2$var$hasOwnProperty = $b332049cd700b6a2$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $b332049cd700b6a2$var$objectCtorString = $b332049cd700b6a2$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $b332049cd700b6a2$var$isPlainObject(value) {
    if (!$ftx1W(value) || $91x1j(value) != $b332049cd700b6a2$var$objectTag) return false;
    var proto = $9fjxL(value);
    if (proto === null) return true;
    var Ctor = $b332049cd700b6a2$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $b332049cd700b6a2$var$funcToString.call(Ctor) == $b332049cd700b6a2$var$objectCtorString;
}
module.exports = $b332049cd700b6a2$var$isPlainObject;

});

parcelRegister("kheMX", function(module, exports) {

var $kLxJ1 = parcelRequire("kLxJ1");

var $ecPyO = parcelRequire("ecPyO");

var $dCfkw = parcelRequire("dCfkw");
/* Node.js helper references. */ var $ec30dddf4baa34cf$var$nodeIsTypedArray = $dCfkw && $dCfkw.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $ec30dddf4baa34cf$var$isTypedArray = $ec30dddf4baa34cf$var$nodeIsTypedArray ? $ecPyO($ec30dddf4baa34cf$var$nodeIsTypedArray) : $kLxJ1;
module.exports = $ec30dddf4baa34cf$var$isTypedArray;

});
parcelRegister("kLxJ1", function(module, exports) {

var $91x1j = parcelRequire("91x1j");

var $5VAtD = parcelRequire("5VAtD");

var $ftx1W = parcelRequire("ftx1W");
/** `Object#toString` result references. */ var $f1e25b919cbc4210$var$argsTag = "[object Arguments]", $f1e25b919cbc4210$var$arrayTag = "[object Array]", $f1e25b919cbc4210$var$boolTag = "[object Boolean]", $f1e25b919cbc4210$var$dateTag = "[object Date]", $f1e25b919cbc4210$var$errorTag = "[object Error]", $f1e25b919cbc4210$var$funcTag = "[object Function]", $f1e25b919cbc4210$var$mapTag = "[object Map]", $f1e25b919cbc4210$var$numberTag = "[object Number]", $f1e25b919cbc4210$var$objectTag = "[object Object]", $f1e25b919cbc4210$var$regexpTag = "[object RegExp]", $f1e25b919cbc4210$var$setTag = "[object Set]", $f1e25b919cbc4210$var$stringTag = "[object String]", $f1e25b919cbc4210$var$weakMapTag = "[object WeakMap]";
var $f1e25b919cbc4210$var$arrayBufferTag = "[object ArrayBuffer]", $f1e25b919cbc4210$var$dataViewTag = "[object DataView]", $f1e25b919cbc4210$var$float32Tag = "[object Float32Array]", $f1e25b919cbc4210$var$float64Tag = "[object Float64Array]", $f1e25b919cbc4210$var$int8Tag = "[object Int8Array]", $f1e25b919cbc4210$var$int16Tag = "[object Int16Array]", $f1e25b919cbc4210$var$int32Tag = "[object Int32Array]", $f1e25b919cbc4210$var$uint8Tag = "[object Uint8Array]", $f1e25b919cbc4210$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f1e25b919cbc4210$var$uint16Tag = "[object Uint16Array]", $f1e25b919cbc4210$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $f1e25b919cbc4210$var$typedArrayTags = {};
$f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$float32Tag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$float64Tag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$int8Tag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$int16Tag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$int32Tag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$uint8Tag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$uint8ClampedTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$uint16Tag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$uint32Tag] = true;
$f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$argsTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$arrayTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$arrayBufferTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$boolTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$dataViewTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$dateTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$errorTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$funcTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$mapTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$numberTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$objectTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$regexpTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$setTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$stringTag] = $f1e25b919cbc4210$var$typedArrayTags[$f1e25b919cbc4210$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f1e25b919cbc4210$var$baseIsTypedArray(value) {
    return $ftx1W(value) && $5VAtD(value.length) && !!$f1e25b919cbc4210$var$typedArrayTags[$91x1j(value)];
}
module.exports = $f1e25b919cbc4210$var$baseIsTypedArray;

});

parcelRegister("ecPyO", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a57a2e8a7d46c888$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $a57a2e8a7d46c888$var$baseUnary;

});

parcelRegister("dCfkw", function(module, exports) {

var $3pALO = parcelRequire("3pALO");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $3pALO.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});


parcelRegister("goQhM", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $bf077219c71b01fe$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $bf077219c71b01fe$var$safeGet;

});

parcelRegister("d4Nyo", function(module, exports) {

var $7raZe = parcelRequire("7raZe");

var $5yKNI = parcelRequire("5yKNI");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $9852166f5a8b5be2$var$toPlainObject(value) {
    return $7raZe(value, $5yKNI(value));
}
module.exports = $9852166f5a8b5be2$var$toPlainObject;

});
parcelRegister("7raZe", function(module, exports) {

var $ki8pw = parcelRequire("ki8pw");

var $9Zv7x = parcelRequire("9Zv7x");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $56a393bfb7dd8f97$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $9Zv7x(object, key, newValue);
        else $ki8pw(object, key, newValue);
    }
    return object;
}
module.exports = $56a393bfb7dd8f97$var$copyObject;

});
parcelRegister("ki8pw", function(module, exports) {

var $9Zv7x = parcelRequire("9Zv7x");

var $aCDT6 = parcelRequire("aCDT6");
/** Used for built-in method references. */ var $ec5c034266b11207$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ec5c034266b11207$var$hasOwnProperty = $ec5c034266b11207$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ec5c034266b11207$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($ec5c034266b11207$var$hasOwnProperty.call(object, key) && $aCDT6(objValue, value)) || value === undefined && !(key in object)) $9Zv7x(object, key, value);
}
module.exports = $ec5c034266b11207$var$assignValue;

});


parcelRegister("5yKNI", function(module, exports) {

var $fPFzB = parcelRequire("fPFzB");

var $lAbKh = parcelRequire("lAbKh");

var $79oK4 = parcelRequire("79oK4");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $40c46e6d766f6298$var$keysIn(object) {
    return $79oK4(object) ? $fPFzB(object, true) : $lAbKh(object);
}
module.exports = $40c46e6d766f6298$var$keysIn;

});
parcelRegister("fPFzB", function(module, exports) {

var $5htP8 = parcelRequire("5htP8");

var $EPvHK = parcelRequire("EPvHK");

var $ioays = parcelRequire("ioays");

var $3BSWT = parcelRequire("3BSWT");

var $5Ntt4 = parcelRequire("5Ntt4");

var $kheMX = parcelRequire("kheMX");
/** Used for built-in method references. */ var $b86bde06e736e98d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b86bde06e736e98d$var$hasOwnProperty = $b86bde06e736e98d$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b86bde06e736e98d$var$arrayLikeKeys(value, inherited) {
    var isArr = $ioays(value), isArg = !isArr && $EPvHK(value), isBuff = !isArr && !isArg && $3BSWT(value), isType = !isArr && !isArg && !isBuff && $kheMX(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $5htP8(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b86bde06e736e98d$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $5Ntt4(key, length)))) result.push(key);
    return result;
}
module.exports = $b86bde06e736e98d$var$arrayLikeKeys;

});
parcelRegister("5htP8", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $3d85acab802e2729$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $3d85acab802e2729$var$baseTimes;

});

parcelRegister("5Ntt4", function(module, exports) {
/** Used as references for various `Number` constants. */ var $4388630c040ecb84$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $4388630c040ecb84$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $4388630c040ecb84$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $4388630c040ecb84$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $4388630c040ecb84$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $4388630c040ecb84$var$isIndex;

});


parcelRegister("lAbKh", function(module, exports) {

var $jQzKY = parcelRequire("jQzKY");

var $1c8Xi = parcelRequire("1c8Xi");

var $3bDMR = parcelRequire("3bDMR");
/** Used for built-in method references. */ var $fb66122c9f3dc396$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb66122c9f3dc396$var$hasOwnProperty = $fb66122c9f3dc396$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $fb66122c9f3dc396$var$baseKeysIn(object) {
    if (!$jQzKY(object)) return $3bDMR(object);
    var isProto = $1c8Xi(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$fb66122c9f3dc396$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $fb66122c9f3dc396$var$baseKeysIn;

});
parcelRegister("3bDMR", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2521431111d6be56$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $2521431111d6be56$var$nativeKeysIn;

});






parcelRegister("h4MLO", function(module, exports) {

var $kkQvj = parcelRequire("kkQvj");

var $DfXxY = parcelRequire("DfXxY");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $c6e8a423b318d06e$var$createAssigner(assigner) {
    return $kkQvj(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $DfXxY(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $c6e8a423b318d06e$var$createAssigner;

});
parcelRegister("kkQvj", function(module, exports) {

var $i9fzz = parcelRequire("i9fzz");

var $7weCi = parcelRequire("7weCi");

var $35D0R = parcelRequire("35D0R");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $ecde671697617007$var$baseRest(func, start) {
    return $35D0R($7weCi(func, start, $i9fzz), func + "");
}
module.exports = $ecde671697617007$var$baseRest;

});
parcelRegister("i9fzz", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d36525a75b036aa2$var$identity(value) {
    return value;
}
module.exports = $d36525a75b036aa2$var$identity;

});

parcelRegister("7weCi", function(module, exports) {

var $u6eYg = parcelRequire("u6eYg");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5796dc1ce3909879$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $5796dc1ce3909879$var$overRest(func, start, transform) {
    start = $5796dc1ce3909879$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $5796dc1ce3909879$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $u6eYg(func, this, otherArgs);
    };
}
module.exports = $5796dc1ce3909879$var$overRest;

});
parcelRegister("u6eYg", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $05a7a4af05e21fde$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $05a7a4af05e21fde$var$apply;

});


parcelRegister("35D0R", function(module, exports) {

var $jLWai = parcelRequire("jLWai");

var $fewvO = parcelRequire("fewvO");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $240019d90cf58f35$var$setToString = $fewvO($jLWai);
module.exports = $240019d90cf58f35$var$setToString;

});
parcelRegister("jLWai", function(module, exports) {

var $7QNam = parcelRequire("7QNam");

var $6Q3q9 = parcelRequire("6Q3q9");

var $i9fzz = parcelRequire("i9fzz");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e64f867916f8e112$var$baseSetToString = !$6Q3q9 ? $i9fzz : function(func, string) {
    return $6Q3q9(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $7QNam(string),
        "writable": true
    });
};
module.exports = $e64f867916f8e112$var$baseSetToString;

});
parcelRegister("7QNam", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $5b73871f79acfddd$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $5b73871f79acfddd$var$constant;

});


parcelRegister("fewvO", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $b171620669494b05$var$HOT_COUNT = 800, $b171620669494b05$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b171620669494b05$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $b171620669494b05$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $b171620669494b05$var$nativeNow(), remaining = $b171620669494b05$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $b171620669494b05$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $b171620669494b05$var$shortOut;

});



parcelRegister("DfXxY", function(module, exports) {

var $aCDT6 = parcelRequire("aCDT6");

var $79oK4 = parcelRequire("79oK4");

var $5Ntt4 = parcelRequire("5Ntt4");

var $jQzKY = parcelRequire("jQzKY");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $076005d83cddaff7$var$isIterateeCall(value, index, object) {
    if (!$jQzKY(object)) return false;
    var type = typeof index;
    if (type == "number" ? $79oK4(object) && $5Ntt4(index, object.length) : type == "string" && index in object) return $aCDT6(object[index], value);
    return false;
}
module.exports = $076005d83cddaff7$var$isIterateeCall;

});



parcelRegister("k561T", function(module, exports) {

var $c6ssy = parcelRequire("c6ssy");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $e9e8f3a2c1d374c0$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $c6ssy(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $e9e8f3a2c1d374c0$var$get;

});
parcelRegister("c6ssy", function(module, exports) {

var $9GSlD = parcelRequire("9GSlD");

var $dchoT = parcelRequire("dchoT");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $8cfc1f1081a61a01$var$baseGet(object, path) {
    path = $9GSlD(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$dchoT(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $8cfc1f1081a61a01$var$baseGet;

});
parcelRegister("9GSlD", function(module, exports) {

var $ioays = parcelRequire("ioays");

var $6eJXC = parcelRequire("6eJXC");

var $hrdQZ = parcelRequire("hrdQZ");

var $jsz0s = parcelRequire("jsz0s");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $70e231a5e60f225a$var$castPath(value, object) {
    if ($ioays(value)) return value;
    return $6eJXC(value, object) ? [
        value
    ] : $hrdQZ($jsz0s(value));
}
module.exports = $70e231a5e60f225a$var$castPath;

});
parcelRegister("6eJXC", function(module, exports) {

var $ioays = parcelRequire("ioays");

var $7gHvm = parcelRequire("7gHvm");
/** Used to match property names within property paths. */ var $48a7b3ae7fb0a68f$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $48a7b3ae7fb0a68f$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $48a7b3ae7fb0a68f$var$isKey(value, object) {
    if ($ioays(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $7gHvm(value)) return true;
    return $48a7b3ae7fb0a68f$var$reIsPlainProp.test(value) || !$48a7b3ae7fb0a68f$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $48a7b3ae7fb0a68f$var$isKey;

});
parcelRegister("7gHvm", function(module, exports) {

var $91x1j = parcelRequire("91x1j");

var $ftx1W = parcelRequire("ftx1W");
/** `Object#toString` result references. */ var $54abc62981b4bfea$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $54abc62981b4bfea$var$isSymbol(value) {
    return typeof value == "symbol" || $ftx1W(value) && $91x1j(value) == $54abc62981b4bfea$var$symbolTag;
}
module.exports = $54abc62981b4bfea$var$isSymbol;

});


parcelRegister("hrdQZ", function(module, exports) {

var $6ZIcz = parcelRequire("6ZIcz");
/** Used to match property names within property paths. */ var $cb1fb452e36811a7$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $cb1fb452e36811a7$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $cb1fb452e36811a7$var$stringToPath = $6ZIcz(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($cb1fb452e36811a7$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($cb1fb452e36811a7$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $cb1fb452e36811a7$var$stringToPath;

});
parcelRegister("6ZIcz", function(module, exports) {

var $aaRUG = parcelRequire("aaRUG");
/** Used as the maximum memoize cache size. */ var $517aba2402c0e0a3$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $517aba2402c0e0a3$var$memoizeCapped(func) {
    var result = $aaRUG(func, function(key) {
        if (cache.size === $517aba2402c0e0a3$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $517aba2402c0e0a3$var$memoizeCapped;

});
parcelRegister("aaRUG", function(module, exports) {

var $8wBGT = parcelRequire("8wBGT");
/** Error message constants. */ var $7684a89e2a46ee4b$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $7684a89e2a46ee4b$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($7684a89e2a46ee4b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($7684a89e2a46ee4b$var$memoize.Cache || $8wBGT);
    return memoized;
}
// Expose `MapCache`.
$7684a89e2a46ee4b$var$memoize.Cache = $8wBGT;
module.exports = $7684a89e2a46ee4b$var$memoize;

});



parcelRegister("jsz0s", function(module, exports) {

var $7xiDu = parcelRequire("7xiDu");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e2abc95c4a6ab174$var$toString(value) {
    return value == null ? "" : $7xiDu(value);
}
module.exports = $e2abc95c4a6ab174$var$toString;

});
parcelRegister("7xiDu", function(module, exports) {

var $kZpX4 = parcelRequire("kZpX4");

var $iRXKp = parcelRequire("iRXKp");

var $ioays = parcelRequire("ioays");

var $7gHvm = parcelRequire("7gHvm");
/** Used as references for various `Number` constants. */ var $57ca122b7760ab4b$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $57ca122b7760ab4b$var$symbolProto = $kZpX4 ? $kZpX4.prototype : undefined, $57ca122b7760ab4b$var$symbolToString = $57ca122b7760ab4b$var$symbolProto ? $57ca122b7760ab4b$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $57ca122b7760ab4b$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($ioays(value)) // Recursively convert values (susceptible to call stack limits).
    return $iRXKp(value, $57ca122b7760ab4b$var$baseToString) + "";
    if ($7gHvm(value)) return $57ca122b7760ab4b$var$symbolToString ? $57ca122b7760ab4b$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$57ca122b7760ab4b$var$INFINITY ? "-0" : result;
}
module.exports = $57ca122b7760ab4b$var$baseToString;

});
parcelRegister("iRXKp", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $dbcb85d8eb02d959$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $dbcb85d8eb02d959$var$arrayMap;

});




parcelRegister("dchoT", function(module, exports) {

var $7gHvm = parcelRequire("7gHvm");
/** Used as references for various `Number` constants. */ var $99b9e4bdc1ff43ee$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $99b9e4bdc1ff43ee$var$toKey(value) {
    if (typeof value == "string" || $7gHvm(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$99b9e4bdc1ff43ee$var$INFINITY ? "-0" : result;
}
module.exports = $99b9e4bdc1ff43ee$var$toKey;

});



parcelRegister("fD80G", function(module, exports) {

var $caGI3 = parcelRequire("caGI3");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $b610b62b33fb3b05$var$set(object, path, value) {
    return object == null ? object : $caGI3(object, path, value);
}
module.exports = $b610b62b33fb3b05$var$set;

});
parcelRegister("caGI3", function(module, exports) {

var $ki8pw = parcelRequire("ki8pw");

var $9GSlD = parcelRequire("9GSlD");

var $5Ntt4 = parcelRequire("5Ntt4");

var $jQzKY = parcelRequire("jQzKY");

var $dchoT = parcelRequire("dchoT");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $8dc78c73f77cfe2a$var$baseSet(object, path, value, customizer) {
    if (!$jQzKY(object)) return object;
    path = $9GSlD(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $dchoT(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $jQzKY(objValue) ? objValue : $5Ntt4(path[index + 1]) ? [] : {};
        }
        $ki8pw(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $8dc78c73f77cfe2a$var$baseSet;

});


parcelRegister("1BpPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12ad4751bf7f0721$export$2e2bcd8739ae039; });

var $e1GNZ = parcelRequire("e1GNZ");
var $12ad4751bf7f0721$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $12ad4751bf7f0721$var$reB = new RegExp($12ad4751bf7f0721$var$reA.source, "g");
function $12ad4751bf7f0721$var$zero(b) {
    return function() {
        return b;
    };
}
function $12ad4751bf7f0721$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $12ad4751bf7f0721$export$2e2bcd8739ae039(a, b) {
    var bi = $12ad4751bf7f0721$var$reA.lastIndex = $12ad4751bf7f0721$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $12ad4751bf7f0721$var$reA.exec(a)) && (bm = $12ad4751bf7f0721$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $e1GNZ.default)(am, bm)
            });
        }
        bi = $12ad4751bf7f0721$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $12ad4751bf7f0721$var$one(q[0].x) : $12ad4751bf7f0721$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});
parcelRegister("e1GNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3625ce6f7321509$export$2e2bcd8739ae039; });
function $a3625ce6f7321509$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});


parcelRegister("iPpol", function(module, exports) {
$parcel$export(module.exports, "config", function () { return (parcelRequire("blk6s")).config; });
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("a7arc")).Globals; });
$parcel$export(module.exports, "to", function () { return (parcelRequire("blk6s")).to; });
$parcel$export(module.exports, "useSpring", function () { return (parcelRequire("blk6s")).useSpring; });

$parcel$export(module.exports, "animated", function () { return $db50afa950f952db$export$407448d2b89b1813; });
parcelRequire("blk6s");
var $a7arc = parcelRequire("a7arc");

var $3glZ1 = parcelRequire("3glZ1");

var $a7arc = parcelRequire("a7arc");

var $4VQlI = parcelRequire("4VQlI");
function $db50afa950f952db$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $db50afa950f952db$var$_excluded$2 = [
    "style",
    "children",
    "scrollTop",
    "scrollLeft"
];
const $db50afa950f952db$var$isCustomPropRE = /^--/;
function $db50afa950f952db$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$db50afa950f952db$var$isCustomPropRE.test(name) && !($db50afa950f952db$var$isUnitlessNumber.hasOwnProperty(name) && $db50afa950f952db$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
const $db50afa950f952db$var$attributeCache = {};
function $db50afa950f952db$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const _ref = props, { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft } = _ref, attributes = $db50afa950f952db$var$_objectWithoutPropertiesLoose(_ref, $db50afa950f952db$var$_excluded$2);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $db50afa950f952db$var$attributeCache[name] || ($db50afa950f952db$var$attributeCache[name] = name.replace(/([A-Z])/g, (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(let name in style)if (style.hasOwnProperty(name)) {
        const value = $db50afa950f952db$var$dangerousStyleValue(name, style[name]);
        if ($db50afa950f952db$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
}
let $db50afa950f952db$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
const $db50afa950f952db$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
const $db50afa950f952db$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$db50afa950f952db$var$isUnitlessNumber = Object.keys($db50afa950f952db$var$isUnitlessNumber).reduce((acc, prop)=>{
    $db50afa950f952db$var$prefixes.forEach((prefix)=>acc[$db50afa950f952db$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $db50afa950f952db$var$isUnitlessNumber);
const $db50afa950f952db$var$_excluded$1 = [
    "x",
    "y",
    "z"
];
const $db50afa950f952db$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const $db50afa950f952db$var$pxTransforms = /^(translate)/;
const $db50afa950f952db$var$degTransforms = /^(rotate|skew)/;
const $db50afa950f952db$var$addUnit = (value, unit)=>(0, $a7arc.is).num(value) && value !== 0 ? value + unit : value;
const $db50afa950f952db$var$isValueIdentity = (value, id)=>(0, $a7arc.is).arr(value) ? value.every((v)=>$db50afa950f952db$var$isValueIdentity(v, id)) : (0, $a7arc.is).num(value) ? value === id : parseFloat(value) === id;
class $db50afa950f952db$var$AnimatedStyle extends (0, $4VQlI.AnimatedObject) {
    constructor(_ref){
        let { x: x, y: y, z: z } = _ref, style = $db50afa950f952db$var$_objectWithoutPropertiesLoose(_ref, $db50afa950f952db$var$_excluded$1);
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$db50afa950f952db$var$addUnit(v, "px")).join(",")})`,
                    $db50afa950f952db$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $a7arc.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($db50afa950f952db$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $a7arc.is).und(value)) return;
                const unit = $db50afa950f952db$var$pxTransforms.test(key) ? "px" : $db50afa950f952db$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $a7arc.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x, y, z, deg])=>[
                        `rotate3d(${x},${y},${z},${$db50afa950f952db$var$addUnit(deg, unit)})`,
                        $db50afa950f952db$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$db50afa950f952db$var$addUnit(v, unit)).join(",")})`,
                        $db50afa950f952db$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $db50afa950f952db$var$FluidTransform(inputs, transforms);
        super(style);
    }
}
class $db50afa950f952db$var$FluidTransform extends (0, $a7arc.FluidValue) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $a7arc.each)(this.inputs, (input, i)=>{
            const arg1 = (0, $a7arc.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, $a7arc.is).arr(arg1) ? arg1 : input.map((0, $a7arc.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    observerAdded(count) {
        if (count == 1) (0, $a7arc.each)(this.inputs, (input)=>(0, $a7arc.each)(input, (value)=>(0, $a7arc.hasFluidValue)(value) && (0, $a7arc.addFluidObserver)(value, this)));
    }
    observerRemoved(count) {
        if (count == 0) (0, $a7arc.each)(this.inputs, (input)=>(0, $a7arc.each)(input, (value)=>(0, $a7arc.hasFluidValue)(value) && (0, $a7arc.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $a7arc.callFluidObservers)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this._value = null;
        this.inputs = inputs;
        this.transforms = transforms;
    }
}
const $db50afa950f952db$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
const $db50afa950f952db$var$_excluded = [
    "scrollTop",
    "scrollLeft"
];
(0, $a7arc.Globals).assign({
    batchedUpdates: (0, $3glZ1.unstable_batchedUpdates),
    createStringInterpolator: $a7arc.createStringInterpolator,
    colors: $a7arc.colors
});
const $db50afa950f952db$var$host = (0, $4VQlI.createHost)($db50afa950f952db$var$primitives, {
    applyAnimatedValues: $db50afa950f952db$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $db50afa950f952db$var$AnimatedStyle(style),
    getComponentProps: (_ref)=>{
        let props = $db50afa950f952db$var$_objectWithoutPropertiesLoose(_ref, $db50afa950f952db$var$_excluded);
        return props;
    }
});
const $db50afa950f952db$export$407448d2b89b1813 = $db50afa950f952db$var$host.animated;

});
parcelRegister("blk6s", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $84213fec046916ac$export$e506a1d27d1eaa20; });
$parcel$export(module.exports, "useSpring", function () { return $84213fec046916ac$export$c4af9125706c4d30; });
$parcel$export(module.exports, "to", function () { return $84213fec046916ac$export$2c618a4308a30424; });
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("a7arc")).Globals; });

var $a7arc = parcelRequire("a7arc");
var $gVpVE = parcelRequire("gVpVE");

var $70fFQ = parcelRequire("70fFQ");

var $4VQlI = parcelRequire("4VQlI");

var $aLPvz = parcelRequire("aLPvz");

var $78Ali = parcelRequire("78Ali");
function $84213fec046916ac$var$_extends() {
    $84213fec046916ac$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84213fec046916ac$var$_extends.apply(this, arguments);
}
function $84213fec046916ac$var$callProp(value, ...args) {
    return (0, $a7arc.is).fun(value) ? value(...args) : value;
}
const $84213fec046916ac$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $a7arc.is).fun(value) ? value(key) : (0, $a7arc.toArray)(value).includes(key)));
const $84213fec046916ac$var$resolveProp = (prop, key)=>(0, $a7arc.is).obj(prop) ? key && prop[key] : prop;
const $84213fec046916ac$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : undefined;
const $84213fec046916ac$var$noopTransform = (value)=>value;
const $84213fec046916ac$var$getDefaultProps = (props, transform = $84213fec046916ac$var$noopTransform)=>{
    let keys = $84213fec046916ac$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $a7arc.is).und(value)) defaults[key] = value;
    }
    return defaults;
};
const $84213fec046916ac$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
const $84213fec046916ac$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
};
function $84213fec046916ac$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $a7arc.eachProp)(props, (value, prop)=>{
        if (!$84213fec046916ac$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $84213fec046916ac$export$b971039a739bf227(props) {
    const to = $84213fec046916ac$var$getForwardProps(props);
    if (to) {
        const out = {
            to: to
        };
        (0, $a7arc.eachProp)(props, (val, key)=>key in to || (out[key] = val));
        return out;
    }
    return $84213fec046916ac$var$_extends({}, props);
}
function $84213fec046916ac$var$computeGoal(value) {
    value = (0, $a7arc.getFluidValue)(value);
    return (0, $a7arc.is).arr(value) ? value.map($84213fec046916ac$var$computeGoal) : (0, $a7arc.isAnimatedString)(value) ? (0, $a7arc.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $84213fec046916ac$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $84213fec046916ac$var$isAsyncTo(to) {
    return (0, $a7arc.is).fun(to) || (0, $a7arc.is).arr(to) && (0, $a7arc.is).obj(to[0]);
}
function $84213fec046916ac$var$detachRefs(ctrl, ref) {
    var _ctrl$ref;
    (_ctrl$ref = ctrl.ref) == null || _ctrl$ref.delete(ctrl);
    ref == null || ref.delete(ctrl);
}
function $84213fec046916ac$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl$ref2;
        (_ctrl$ref2 = ctrl.ref) == null || _ctrl$ref2.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
function $84213fec046916ac$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1000) {
    (0, $a7arc.useLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $a7arc.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $a7arc.each)(controllers, (ctrl)=>{
                        (0, $a7arc.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $84213fec046916ac$var$callProp(memoizedDelayProp || 0, key);
                        });
                        ctrl.start();
                    });
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $a7arc.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $a7arc.each)(controllers, (ctrl, i)=>(0, $a7arc.each)(queues[i] || [], (update)=>ctrl.queue.push(update)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
const $84213fec046916ac$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
const $84213fec046916ac$var$linear = (t)=>t;
const $84213fec046916ac$var$defaults = $84213fec046916ac$var$_extends({}, $84213fec046916ac$export$e506a1d27d1eaa20.default, {
    mass: 1,
    damping: 1,
    easing: $84213fec046916ac$var$linear,
    clamp: false
});
class $84213fec046916ac$var$AnimationConfig {
    constructor(){
        this.tension = void 0;
        this.friction = void 0;
        this.frequency = void 0;
        this.damping = void 0;
        this.mass = void 0;
        this.velocity = 0;
        this.restVelocity = void 0;
        this.precision = void 0;
        this.progress = void 0;
        this.duration = void 0;
        this.easing = void 0;
        this.clamp = void 0;
        this.bounce = void 0;
        this.decay = void 0;
        this.round = void 0;
        Object.assign(this, $84213fec046916ac$var$defaults);
    }
}
function $84213fec046916ac$var$mergeConfig(config, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = $84213fec046916ac$var$_extends({}, defaultConfig);
        $84213fec046916ac$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = $84213fec046916ac$var$_extends({}, defaultConfig, newConfig);
    }
    $84213fec046916ac$var$sanitizeConfig(config, newConfig);
    Object.assign(config, newConfig);
    for(const key in $84213fec046916ac$var$defaults)if (config[key] == null) config[key] = $84213fec046916ac$var$defaults[key];
    let { mass: mass, frequency: frequency, damping: damping } = config;
    if (!(0, $a7arc.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config;
}
function $84213fec046916ac$var$sanitizeConfig(config, props) {
    if (!(0, $a7arc.is).und(props.decay)) config.duration = undefined;
    else {
        const isTensionConfig = !(0, $a7arc.is).und(props.tension) || !(0, $a7arc.is).und(props.friction);
        if (isTensionConfig || !(0, $a7arc.is).und(props.frequency) || !(0, $a7arc.is).und(props.damping) || !(0, $a7arc.is).und(props.mass)) {
            config.duration = undefined;
            config.decay = undefined;
        }
        if (isTensionConfig) config.frequency = undefined;
    }
}
const $84213fec046916ac$var$emptyArray = [];
class $84213fec046916ac$var$Animation {
    constructor(){
        this.changed = false;
        this.values = $84213fec046916ac$var$emptyArray;
        this.toValues = null;
        this.fromValues = $84213fec046916ac$var$emptyArray;
        this.to = void 0;
        this.from = void 0;
        this.config = new $84213fec046916ac$var$AnimationConfig();
        this.immediate = false;
    }
}
function $84213fec046916ac$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        var _props$cancel;
        let delay;
        let timeout;
        let cancel = $84213fec046916ac$var$matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $a7arc.is).und(props.pause)) state.paused = $84213fec046916ac$var$matchProp(props.pause, key);
            let pause = defaultProps == null ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $84213fec046916ac$var$matchProp(pause, key);
            delay = $84213fec046916ac$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $gVpVE.raf).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $a7arc.Globals).skipAnimation) {
                timeout = (0, $gVpVE.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start($84213fec046916ac$var$_extends({}, props, {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
const $84213fec046916ac$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $84213fec046916ac$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $84213fec046916ac$var$getNoopResult(target.get()) : $84213fec046916ac$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
const $84213fec046916ac$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
const $84213fec046916ac$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
const $84213fec046916ac$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
function $84213fec046916ac$var$runAsync(to, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to;
        const defaultProps = $84213fec046916ac$var$getDefaultProps(props, (value, key)=>key === "onRest" ? undefined : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = callId <= (state.cancelId || 0) && $84213fec046916ac$var$getCancelledResult(target) || callId !== state.asyncId && $84213fec046916ac$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $84213fec046916ac$export$d362d093fa99dc7();
            const skipAnimationSignal = new $84213fec046916ac$var$SkipAniamtionSignal();
            return (async ()=>{
                if ((0, $a7arc.Globals).skipAnimation) {
                    $84213fec046916ac$var$stopAsync(state);
                    skipAnimationSignal.result = $84213fec046916ac$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props = (0, $a7arc.is).obj(arg1) ? $84213fec046916ac$var$_extends({}, arg1) : $84213fec046916ac$var$_extends({}, arg2, {
                    to: arg1
                });
                props.parentId = callId;
                (0, $a7arc.eachProp)(defaultProps, (value, key)=>{
                    if ((0, $a7arc.is).und(props[key])) props[key] = value;
                });
                const result = await target.start(props);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result;
            })();
        };
        let result;
        if ((0, $a7arc.Globals).skipAnimation) {
            $84213fec046916ac$var$stopAsync(state);
            return $84213fec046916ac$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $a7arc.is).arr(to)) animating = (async (queue)=>{
                for (const props of queue)await animate(props);
            })(to);
            else animating = Promise.resolve(to(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $84213fec046916ac$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $84213fec046916ac$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $84213fec046916ac$var$SkipAniamtionSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : undefined;
                state.promise = parentId ? prevPromise : undefined;
            }
        }
        if ((0, $a7arc.is).fun(onRest)) (0, $gVpVE.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $84213fec046916ac$var$stopAsync(state, cancelId) {
    (0, $a7arc.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = undefined;
    if (cancelId) state.cancelId = cancelId;
}
class $84213fec046916ac$export$d362d093fa99dc7 extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
        this.result = void 0;
    }
}
class $84213fec046916ac$var$SkipAniamtionSignal extends Error {
    constructor(){
        super("SkipAnimationSignal");
        this.result = void 0;
    }
}
const $84213fec046916ac$var$isFrameValue = (value)=>value instanceof $84213fec046916ac$export$8229896f80e2495e;
let $84213fec046916ac$var$nextId$1 = 1;
class $84213fec046916ac$export$8229896f80e2495e extends (0, $a7arc.FluidValue) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    get() {
        const node = (0, $4VQlI.getAnimated)(this);
        return node && node.getValue();
    }
    to(...args) {
        return (0, $a7arc.Globals).to(this, args);
    }
    interpolate(...args) {
        (0, $a7arc.deprecateInterpolate)();
        return (0, $a7arc.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    _attach() {}
    _detach() {}
    _onChange(value, idle = false) {
        (0, $a7arc.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    _onPriorityChange(priority) {
        if (!this.idle) (0, $a7arc.frameLoop).sort(this);
        (0, $a7arc.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(...args){
        super(...args);
        this.id = $84213fec046916ac$var$nextId$1++;
        this.key = void 0;
        this._priority = 0;
    }
}
const $84213fec046916ac$var$$P = Symbol.for("SpringPhase");
const $84213fec046916ac$var$HAS_ANIMATED = 1;
const $84213fec046916ac$var$IS_ANIMATING = 2;
const $84213fec046916ac$var$IS_PAUSED = 4;
const $84213fec046916ac$var$hasAnimated = (target)=>(target[$84213fec046916ac$var$$P] & $84213fec046916ac$var$HAS_ANIMATED) > 0;
const $84213fec046916ac$var$isAnimating = (target)=>(target[$84213fec046916ac$var$$P] & $84213fec046916ac$var$IS_ANIMATING) > 0;
const $84213fec046916ac$var$isPaused = (target)=>(target[$84213fec046916ac$var$$P] & $84213fec046916ac$var$IS_PAUSED) > 0;
const $84213fec046916ac$var$setActiveBit = (target, active)=>active ? target[$84213fec046916ac$var$$P] |= $84213fec046916ac$var$IS_ANIMATING | $84213fec046916ac$var$HAS_ANIMATED : target[$84213fec046916ac$var$$P] &= ~$84213fec046916ac$var$IS_ANIMATING;
const $84213fec046916ac$var$setPausedBit = (target, paused)=>paused ? target[$84213fec046916ac$var$$P] |= $84213fec046916ac$var$IS_PAUSED : target[$84213fec046916ac$var$$P] &= ~$84213fec046916ac$var$IS_PAUSED;
class $84213fec046916ac$export$5854d13427d5a954 extends $84213fec046916ac$export$8229896f80e2495e {
    get idle() {
        return !($84213fec046916ac$var$isAnimating(this) || this._state.asyncTo) || $84213fec046916ac$var$isPaused(this);
    }
    get goal() {
        return (0, $a7arc.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, $4VQlI.getAnimated)(this);
        return node instanceof (0, $4VQlI.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node)=>node.lastVelocity || 0);
    }
    get hasAnimated() {
        return $84213fec046916ac$var$hasAnimated(this);
    }
    get isAnimating() {
        return $84213fec046916ac$var$isAnimating(this);
    }
    get isPaused() {
        return $84213fec046916ac$var$isPaused(this);
    }
    advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { config: config, toValues: toValues } = anim;
        const payload = (0, $4VQlI.getPayload)(anim.to);
        if (!payload && (0, $a7arc.hasFluidValue)(anim.to)) toValues = (0, $a7arc.toArray)((0, $a7arc.getFluidValue)(anim.to));
        anim.values.forEach((node, i)=>{
            if (node.done) return;
            const to = node.constructor == (0, $4VQlI.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to;
            if (!finished) {
                position = node.lastPosition;
                if (config.tension <= 0) {
                    node.done = true;
                    return;
                }
                let elapsed = node.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node.v0 != null ? node.v0 : node.v0 = (0, $a7arc.is).arr(config.velocity) ? config.velocity[i] : config.velocity;
                let velocity;
                if (!(0, $a7arc.is).und(config.duration)) {
                    let p = 1;
                    if (config.duration > 0) {
                        if (this._memoizedDuration !== config.duration) {
                            this._memoizedDuration = config.duration;
                            if (node.durationProgress > 0) {
                                node.elapsedTime = config.duration * node.durationProgress;
                                elapsed = node.elapsedTime += dt;
                            }
                        }
                        p = (config.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node.durationProgress = p;
                    }
                    position = from + config.easing(p) * (to - from);
                    velocity = (position - node.lastPosition) / dt;
                    finished = p == 1;
                } else if (config.decay) {
                    const decay = config.decay === true ? 0.998 : config.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node.lastPosition - position) < 0.1;
                    velocity = v0 * e;
                } else {
                    velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
                    const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
                    const restVelocity = config.restVelocity || precision / 10;
                    const bounceFactor = config.clamp ? 0 : config.bounce;
                    const canBounce = !(0, $a7arc.is).und(bounceFactor);
                    const isGrowing = from == to ? node.v0 > 0 : from < to;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to || position > to == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to;
                            }
                        }
                        const springForce = -config.tension * 0.000001 * (position - to);
                        const dampingForce = -config.friction * 0.001 * velocity;
                        const acceleration = (springForce + dampingForce) / config.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node.done = true;
            else idle = false;
            if (node.setValue(position, config.round)) changed = true;
        });
        const node = (0, $4VQlI.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $a7arc.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    set(value) {
        (0, $gVpVE.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    pause() {
        this._update({
            pause: true
        });
    }
    resume() {
        this._update({
            pause: false
        });
    }
    finish() {
        if ($84213fec046916ac$var$isAnimating(this)) {
            const { to: to, config: config } = this.animation;
            (0, $gVpVE.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config.decay) this._set(to, false);
                this._stop();
            });
        }
        return this;
    }
    update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to, arg2) {
        let queue;
        if (!(0, $a7arc.is).und(to)) queue = [
            (0, $a7arc.is).obj(to) ? to : $84213fec046916ac$var$_extends({}, arg2, {
                to: to
            })
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>this._update(props))).then((results)=>$84213fec046916ac$var$getCombinedResult(this, results));
    }
    stop(cancel) {
        const { to: to } = this.animation;
        this._focus(this.get());
        $84213fec046916ac$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $gVpVE.raf).batchedUpdates(()=>this._stop(to, cancel));
        return this;
    }
    reset() {
        this._update({
            reset: true
        });
    }
    eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    _prepareNode(props) {
        const key = this.key || "";
        let { to: to, from: from } = props;
        to = (0, $a7arc.is).obj(to) ? to[key] : to;
        if (to == null || $84213fec046916ac$var$isAsyncTo(to)) to = undefined;
        from = (0, $a7arc.is).obj(from) ? from[key] : from;
        if (from == null) from = undefined;
        const range = {
            to: to,
            from: from
        };
        if (!$84213fec046916ac$var$hasAnimated(this)) {
            if (props.reverse) [to, from] = [
                from,
                to
            ];
            from = (0, $a7arc.getFluidValue)(from);
            if (!(0, $a7arc.is).und(from)) this._set(from);
            else if (!(0, $4VQlI.getAnimated)(this)) this._set(to);
        }
        return range;
    }
    _update(_ref, isLoop) {
        let props = $84213fec046916ac$var$_extends({}, _ref);
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $84213fec046916ac$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $84213fec046916ac$var$resolveProp(value, key) : value));
        $84213fec046916ac$var$mergeActiveFn(this, props, "onProps");
        $84213fec046916ac$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $84213fec046916ac$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$84213fec046916ac$var$isPaused(this)) {
                        $84213fec046916ac$var$setPausedBit(this, true);
                        (0, $a7arc.flushCalls)(state.pauseQueue);
                        $84213fec046916ac$var$sendEvent(this, "onPause", $84213fec046916ac$var$getFinishedResult(this, $84213fec046916ac$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($84213fec046916ac$var$isPaused(this)) {
                        $84213fec046916ac$var$setPausedBit(this, false);
                        if ($84213fec046916ac$var$isAnimating(this)) this._resume();
                        (0, $a7arc.flushCalls)(state.resumeQueue);
                        $84213fec046916ac$var$sendEvent(this, "onResume", $84213fec046916ac$var$getFinishedResult(this, $84213fec046916ac$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $84213fec046916ac$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($84213fec046916ac$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $a7arc.is).und(range.to);
        const hasFromProp = !(0, $a7arc.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($84213fec046916ac$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $a7arc.is).und(to))) to = from;
        if (props.reverse) [to, from] = [
            from,
            to
        ];
        const hasFromChanged = !(0, $a7arc.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $a7arc.getFluidValue)(from);
        const hasToChanged = !(0, $a7arc.isEqual)(to, prevTo);
        if (hasToChanged) this._focus(to);
        const hasAsyncTo = $84213fec046916ac$var$isAsyncTo(props.to);
        const { config: config } = anim;
        const { decay: decay, velocity: velocity } = config;
        if (hasToProp || hasFromProp) config.velocity = 0;
        if (props.config && !hasAsyncTo) $84213fec046916ac$var$mergeConfig(config, $84213fec046916ac$var$callProp(props.config, key), props.config !== defaultProps.config ? $84213fec046916ac$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $4VQlI.getAnimated)(this);
        if (!node || (0, $a7arc.is).und(to)) return resolve($84213fec046916ac$var$getFinishedResult(this, true));
        const reset = (0, $a7arc.is).und(props.reset) ? hasFromProp && !props.default : !(0, $a7arc.is).und(from) && $84213fec046916ac$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $84213fec046916ac$var$computeGoal(to);
        const isAnimatable = (0, $a7arc.is).num(goal) || (0, $a7arc.is).arr(goal) || (0, $a7arc.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $84213fec046916ac$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $4VQlI.getAnimatedType)(to);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $a7arc.hasFluidValue)(to);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$84213fec046916ac$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $a7arc.isEqual)($84213fec046916ac$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $a7arc.isEqual)(anim.immediate, immediate) && !immediate || !(0, $a7arc.isEqual)(config.decay, decay) || !(0, $a7arc.isEqual)(config.velocity, velocity)) started = true;
        }
        if (finished && $84213fec046916ac$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $a7arc.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $a7arc.hasFluidValue)(to) ? null : goalType == (0, $4VQlI.AnimatedString) ? [
                    1
                ] : (0, $a7arc.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $a7arc.each)($84213fec046916ac$var$ACTIVE_EVENTS, (type)=>$84213fec046916ac$var$mergeActiveFn(this, props, type));
                const result = $84213fec046916ac$var$getFinishedResult(this, $84213fec046916ac$var$checkFinished(this, prevTo));
                (0, $a7arc.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $gVpVE.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest == null || onRest(result, this);
                    if (reset) $84213fec046916ac$var$callProp(defaultProps.onRest, result);
                    else anim.onStart == null || anim.onStart(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($84213fec046916ac$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($84213fec046916ac$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($84213fec046916ac$var$getNoopResult(value));
    }
    _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $a7arc.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, $a7arc.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to } = this.animation;
        if ((0, $a7arc.hasFluidValue)(to)) {
            (0, $a7arc.addFluidObserver)(to, this);
            if ($84213fec046916ac$var$isFrameValue(to)) priority = to.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to } = this.animation;
        if ((0, $a7arc.hasFluidValue)(to)) (0, $a7arc.removeFluidObserver)(to, this);
    }
    _set(arg, idle = true) {
        const value = (0, $a7arc.getFluidValue)(arg);
        if (!(0, $a7arc.is).und(value)) {
            const oldNode = (0, $4VQlI.getAnimated)(this);
            if (!oldNode || !(0, $a7arc.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, $4VQlI.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $4VQlI.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $gVpVE.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $4VQlI.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $84213fec046916ac$var$sendEvent(this, "onStart", $84213fec046916ac$var$getFinishedResult(this, $84213fec046916ac$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $84213fec046916ac$var$callProp(this.animation.onChange, value, this);
        }
        $84213fec046916ac$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    _start() {
        const anim = this.animation;
        (0, $4VQlI.getAnimated)(this).reset((0, $a7arc.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$84213fec046916ac$var$isAnimating(this)) {
            $84213fec046916ac$var$setActiveBit(this, true);
            if (!$84213fec046916ac$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $a7arc.Globals).skipAnimation) this.finish();
        else (0, $a7arc.frameLoop).start(this);
    }
    _stop(goal, cancel) {
        if ($84213fec046916ac$var$isAnimating(this)) {
            $84213fec046916ac$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $a7arc.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = undefined;
            (0, $a7arc.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $84213fec046916ac$var$getCancelledResult(this.get()) : $84213fec046916ac$var$getFinishedResult(this.get(), $84213fec046916ac$var$checkFinished(this, goal != null ? goal : anim.to));
            (0, $a7arc.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $84213fec046916ac$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        this.key = void 0;
        this.animation = new $84213fec046916ac$var$Animation();
        this.queue = void 0;
        this.defaultProps = {};
        this._state = {
            paused: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._pendingCalls = new Set();
        this._lastCallId = 0;
        this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $a7arc.is).und(arg1) || !(0, $a7arc.is).und(arg2)) {
            const props = (0, $a7arc.is).obj(arg1) ? $84213fec046916ac$var$_extends({}, arg1) : $84213fec046916ac$var$_extends({}, arg2, {
                from: arg1
            });
            if ((0, $a7arc.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
}
function $84213fec046916ac$var$checkFinished(target, to) {
    const goal = $84213fec046916ac$var$computeGoal(to);
    const value = $84213fec046916ac$var$computeGoal(target.get());
    return (0, $a7arc.isEqual)(value, goal);
}
function $84213fec046916ac$var$createLoopUpdate(props, loop = props.loop, to = props.to) {
    let loopRet = $84213fec046916ac$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $84213fec046916ac$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $84213fec046916ac$var$createUpdate($84213fec046916ac$var$_extends({}, props, {
            loop: loop,
            default: false,
            pause: undefined,
            to: !reverse || $84213fec046916ac$var$isAsyncTo(to) ? to : undefined,
            from: reset ? props.from : undefined,
            reset: reset
        }, overrides));
    }
}
function $84213fec046916ac$var$createUpdate(props) {
    const { to: to, from: from } = props = $84213fec046916ac$export$b971039a739bf227(props);
    const keys = new Set();
    if ((0, $a7arc.is).obj(to)) $84213fec046916ac$var$findDefined(to, keys);
    if ((0, $a7arc.is).obj(from)) $84213fec046916ac$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $84213fec046916ac$var$declareUpdate(props) {
    const update = $84213fec046916ac$var$createUpdate(props);
    if ((0, $a7arc.is).und(update.default)) update.default = $84213fec046916ac$var$getDefaultProps(update);
    return update;
}
function $84213fec046916ac$var$findDefined(values, keys) {
    (0, $a7arc.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
const $84213fec046916ac$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $84213fec046916ac$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $84213fec046916ac$var$getDefaultProp(props, type) ? $84213fec046916ac$var$resolveProp(props[type], target.key) : undefined;
}
function $84213fec046916ac$var$sendEvent(target, type, ...args) {
    var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
    (_target$animation$typ = (_target$animation = target.animation)[type]) == null || _target$animation$typ.call(_target$animation, ...args);
    (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null || _target$defaultProps$.call(_target$defaultProps, ...args);
}
const $84213fec046916ac$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
let $84213fec046916ac$var$nextId = 1;
class $84213fec046916ac$export$bd0bf19f25da8474 {
    get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>spring.idle);
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $a7arc.is).und(value)) this.springs[key].set(value);
        }
    }
    update(props) {
        if (props) this.queue.push($84213fec046916ac$var$createUpdate(props));
        return this;
    }
    start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $a7arc.toArray)(props).map($84213fec046916ac$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $84213fec046916ac$var$prepareKeys(this, queue);
        return $84213fec046916ac$var$flushUpdateQueue(this, queue);
    }
    stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $a7arc.each)((0, $a7arc.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $84213fec046916ac$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    pause(keys) {
        if ((0, $a7arc.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $a7arc.each)((0, $a7arc.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    resume(keys) {
        if ((0, $a7arc.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $a7arc.each)((0, $a7arc.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    each(iterator) {
        (0, $a7arc.eachProp)(this.springs, iterator);
    }
    _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $a7arc.flush)(onStart, ([onStart, result])=>{
                result.value = this.get();
                onStart(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $a7arc.flush)(onChange, ([onChange, result])=>{
            result.value = values;
            onChange(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $a7arc.flush)(onRest, ([onRest, result])=>{
                result.value = values;
                onRest(result, this, this._item);
            });
        }
    }
    eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $gVpVE.raf).onFrame(this._onFrame);
    }
    constructor(props, flush){
        this.id = $84213fec046916ac$var$nextId++;
        this.springs = {};
        this.queue = [];
        this.ref = void 0;
        this._flush = void 0;
        this._initialProps = void 0;
        this._lastAsyncId = 0;
        this._active = new Set();
        this._changed = new Set();
        this._started = false;
        this._item = void 0;
        this._state = {
            paused: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._events = {
            onStart: new Map(),
            onChange: new Map(),
            onRest: new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush) this._flush = flush;
        if (props) this.start($84213fec046916ac$var$_extends({
            default: true
        }, props));
    }
}
function $84213fec046916ac$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$84213fec046916ac$var$flushUpdate(ctrl, props))).then((results)=>$84213fec046916ac$var$getCombinedResult(ctrl, results));
}
async function $84213fec046916ac$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults = (0, $a7arc.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $a7arc.is).arr(to) || (0, $a7arc.is).fun(to) ? to : undefined;
    if (asyncTo) {
        props.to = undefined;
        props.onRest = undefined;
        if (defaults) defaults.onRest = undefined;
    } else (0, $a7arc.each)($84213fec046916ac$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $a7arc.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result = queue.get(handler);
                if (result) {
                    if (!finished) result.finished = false;
                    if (cancelled) result.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults) defaults[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $a7arc.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $84213fec046916ac$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($84213fec046916ac$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $a7arc.noop),
            resume: (0, $a7arc.noop),
            start (props, resolve) {
                if (cancel) {
                    $84213fec046916ac$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($84213fec046916ac$var$getCancelledResult(ctrl));
                } else {
                    props.onRest = onRest;
                    resolve($84213fec046916ac$var$runAsync(asyncTo, props, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $84213fec046916ac$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $84213fec046916ac$var$createLoopUpdate(props, loop, to);
        if (nextProps) {
            $84213fec046916ac$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $84213fec046916ac$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $gVpVE.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $84213fec046916ac$var$getSprings(ctrl, props) {
    const springs = $84213fec046916ac$var$_extends({}, ctrl.springs);
    if (props) (0, $a7arc.each)((0, $a7arc.toArray)(props), (props)=>{
        if ((0, $a7arc.is).und(props.keys)) props = $84213fec046916ac$var$createUpdate(props);
        if (!(0, $a7arc.is).obj(props.to)) props = $84213fec046916ac$var$_extends({}, props, {
            to: undefined
        });
        $84213fec046916ac$var$prepareSprings(springs, props, (key)=>{
            return $84213fec046916ac$var$createSpring(key);
        });
    });
    $84213fec046916ac$var$setSprings(ctrl, springs);
    return springs;
}
function $84213fec046916ac$var$setSprings(ctrl, springs) {
    (0, $a7arc.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $a7arc.addFluidObserver)(spring, ctrl);
        }
    });
}
function $84213fec046916ac$var$createSpring(key, observer) {
    const spring = new $84213fec046916ac$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $a7arc.addFluidObserver)(spring, observer);
    return spring;
}
function $84213fec046916ac$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $a7arc.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $84213fec046916ac$var$prepareKeys(ctrl, queue) {
    (0, $a7arc.each)(queue, (props)=>{
        $84213fec046916ac$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $84213fec046916ac$var$createSpring(key, ctrl);
        });
    });
}
function $84213fec046916ac$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $84213fec046916ac$var$_excluded$3 = [
    "children"
];
const $84213fec046916ac$export$f12a216ec50d2cf1 = (_ref)=>{
    let { children: children } = _ref, props = $84213fec046916ac$var$_objectWithoutPropertiesLoose(_ref, $84213fec046916ac$var$_excluded$3);
    const inherited = (0, $70fFQ.useContext)($84213fec046916ac$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $a7arc.useMemoOne)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $84213fec046916ac$var$ctx;
    return $70fFQ.createElement(Provider, {
        value: props
    }, children);
};
const $84213fec046916ac$var$ctx = $84213fec046916ac$var$makeContext($84213fec046916ac$export$f12a216ec50d2cf1, {});
$84213fec046916ac$export$f12a216ec50d2cf1.Provider = $84213fec046916ac$var$ctx.Provider;
$84213fec046916ac$export$f12a216ec50d2cf1.Consumer = $84213fec046916ac$var$ctx.Consumer;
function $84213fec046916ac$var$makeContext(target, init) {
    Object.assign(target, $70fFQ.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
const $84213fec046916ac$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef = function SpringRef(props) {
        (0, $a7arc.deprecateDirectCall)();
        const results = [];
        (0, $a7arc.each)(current, (ctrl, i)=>{
            if ((0, $a7arc.is).und(props)) results.push(ctrl.start());
            else {
                const update = _getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.current = current;
    SpringRef.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef.pause = function() {
        (0, $a7arc.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef.resume = function() {
        (0, $a7arc.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef.set = function(values) {
        (0, $a7arc.each)(current, (ctrl)=>ctrl.set(values));
    };
    SpringRef.start = function(props) {
        const results = [];
        (0, $a7arc.each)(current, (ctrl, i)=>{
            if ((0, $a7arc.is).und(props)) results.push(ctrl.start());
            else {
                const update = this._getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.stop = function() {
        (0, $a7arc.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef.update = function(props) {
        (0, $a7arc.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function _getProps(arg, ctrl, index) {
        return (0, $a7arc.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef._getProps = _getProps;
    return SpringRef;
};
function $84213fec046916ac$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $a7arc.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $70fFQ.useMemo)(()=>propsFn || arguments.length == 3 ? $84213fec046916ac$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $70fFQ.useRef)(0);
    const forceUpdate = (0, $a7arc.useForceUpdate)();
    const state = (0, $70fFQ.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates) {
                const springs = $84213fec046916ac$var$getSprings(ctrl, updates);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $84213fec046916ac$var$flushUpdateQueue(ctrl, updates) : new Promise((resolve)=>{
                    $84213fec046916ac$var$setSprings(ctrl, springs);
                    state.queue.push(()=>{
                        resolve($84213fec046916ac$var$flushUpdateQueue(ctrl, updates));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $70fFQ.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $a7arc.usePrev)(length) || 0;
    (0, $70fFQ.useMemo)(()=>{
        (0, $a7arc.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $84213fec046916ac$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $70fFQ.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $84213fec046916ac$export$bd0bf19f25da8474(null, state.flush));
            const update = propsFn ? propsFn(i, ctrl) : props[i];
            if (update) updates[i] = $84213fec046916ac$var$declareUpdate(update);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$84213fec046916ac$var$getSprings(ctrl, updates[i]));
    const context = (0, $70fFQ.useContext)($84213fec046916ac$export$f12a216ec50d2cf1);
    const prevContext = (0, $a7arc.usePrev)(context);
    const hasContext = context !== prevContext && $84213fec046916ac$var$hasProps(context);
    (0, $a7arc.useLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $a7arc.each)(queue, (cb)=>cb());
        }
        (0, $a7arc.each)(ctrls.current, (ctrl, i)=>{
            ref == null || ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update = updates[i];
            if (update) {
                $84213fec046916ac$var$replaceRef(ctrl, update.ref);
                if (ctrl.ref) ctrl.queue.push(update);
                else ctrl.start(update);
            }
        });
    });
    (0, $a7arc.useOnce)(()=>()=>{
            (0, $a7arc.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>$84213fec046916ac$var$_extends({}, x));
    return ref ? [
        values,
        ref
    ] : values;
}
function $84213fec046916ac$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $a7arc.is).fun(props);
    const [[values], ref] = $84213fec046916ac$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
const $84213fec046916ac$var$initSpringRef = ()=>$84213fec046916ac$export$2471ae76e2946684();
const $84213fec046916ac$export$564bff9c23cad2ca = ()=>(0, $70fFQ.useState)($84213fec046916ac$var$initSpringRef)[0];
function $84213fec046916ac$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $a7arc.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    const result = $84213fec046916ac$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        reverse = reverse && props.reverse;
        return props;
    }, deps || [
        {}
    ]);
    const ref = result[1];
    (0, $a7arc.useLayoutEffect)(()=>{
        (0, $a7arc.each)(ref.current, (ctrl, i)=>{
            const parent = ref.current[i + (reverse ? 1 : -1)];
            if (parent) ctrl.start({
                to: parent.springs
            });
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        ref["_getProps"] = (propsArg, ctrl, i)=>{
            const props = (0, $a7arc.is).fun(propsArg) ? propsArg(i, ctrl) : propsArg;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
let $84213fec046916ac$var$TransitionPhase;
(function(TransitionPhase) {
    TransitionPhase["MOUNT"] = "mount";
    TransitionPhase["ENTER"] = "enter";
    TransitionPhase["UPDATE"] = "update";
    TransitionPhase["LEAVE"] = "leave";
})($84213fec046916ac$var$TransitionPhase || ($84213fec046916ac$var$TransitionPhase = {}));
function $84213fec046916ac$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $a7arc.is).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $70fFQ.useMemo)(()=>propsFn || arguments.length == 3 ? $84213fec046916ac$export$2471ae76e2946684() : void 0, []);
    const items = (0, $a7arc.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, $70fFQ.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $a7arc.useLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $a7arc.useOnce)(()=>()=>(0, $a7arc.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $84213fec046916ac$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            }));
    const keys = $84213fec046916ac$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $a7arc.useLayoutEffect)(()=>(0, $a7arc.each)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $84213fec046916ac$var$detachRefs(ctrl, ref);
            $84213fec046916ac$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $a7arc.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $a7arc.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: $84213fec046916ac$var$TransitionPhase.MOUNT,
                ctrl: new $84213fec046916ac$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $a7arc.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = $84213fec046916ac$var$_extends({}, t, {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $a7arc.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $a7arc.useForceUpdate)();
    const defaultProps = $84213fec046916ac$var$getDefaultProps(props);
    const changes = new Map();
    (0, $a7arc.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to;
        let phase;
        let propsDelay = $84213fec046916ac$var$callProp(p.delay || 0, key);
        if (prevPhase == $84213fec046916ac$var$TransitionPhase.MOUNT) {
            to = p.enter;
            phase = $84213fec046916ac$var$TransitionPhase.ENTER;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != $84213fec046916ac$var$TransitionPhase.LEAVE) {
                if (isLeave) {
                    to = p.leave;
                    phase = $84213fec046916ac$var$TransitionPhase.LEAVE;
                } else if (to = p.update) phase = $84213fec046916ac$var$TransitionPhase.UPDATE;
                else return;
            } else if (!isLeave) {
                to = p.enter;
                phase = $84213fec046916ac$var$TransitionPhase.ENTER;
            } else return;
        }
        to = $84213fec046916ac$var$callProp(to, t.item, i);
        to = (0, $a7arc.is).obj(to) ? $84213fec046916ac$export$b971039a739bf227(to) : {
            to: to
        };
        if (!to.config) {
            const config = propsConfig || defaultProps.config;
            to.config = $84213fec046916ac$var$callProp(config, t.item, i, phase);
        }
        delay += trail;
        const payload = $84213fec046916ac$var$_extends({}, defaultProps, {
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            reset: false
        }, to);
        if (phase == $84213fec046916ac$var$TransitionPhase.ENTER && (0, $a7arc.is).und(payload.from)) {
            const _p = propsFn ? propsFn() : props;
            const from = (0, $a7arc.is).und(_p.initial) || prevTransitions ? _p.from : _p.initial;
            payload.from = $84213fec046916ac$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $84213fec046916ac$var$callProp(onResolve, result);
            const transitions = usedTransitions.current;
            const t = transitions.find((t)=>t.key === key);
            if (!t) return;
            if (result.cancelled && t.phase != $84213fec046916ac$var$TransitionPhase.UPDATE) return;
            if (t.ctrl.idle) {
                const idle = transitions.every((t)=>t.ctrl.idle);
                if (t.phase == $84213fec046916ac$var$TransitionPhase.LEAVE) {
                    const expiry = $84213fec046916ac$var$callProp(expires, t.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions.some((t)=>t.expired)) forceUpdate();
            }
        };
        const springs = $84213fec046916ac$var$getSprings(t.ctrl, payload);
        changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $70fFQ.useContext)($84213fec046916ac$export$f12a216ec50d2cf1);
    const prevContext = (0, $a7arc.usePrev)(context);
    const hasContext = context !== prevContext && $84213fec046916ac$var$hasProps(context);
    (0, $a7arc.useLayoutEffect)(()=>{
        if (hasContext) (0, $a7arc.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $a7arc.useLayoutEffect)(()=>{
        (0, $a7arc.each)(changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref == null || ref.add(ctrl);
            if (hasContext && phase == $84213fec046916ac$var$TransitionPhase.ENTER) ctrl.start({
                default: context
            });
            if (payload) {
                $84213fec046916ac$var$replaceRef(ctrl, payload.ref);
                if (ctrl.ref) ctrl.update(payload);
                else ctrl.start(payload);
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>$70fFQ.createElement($70fFQ.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render($84213fec046916ac$var$_extends({}, springs), t.item, t, i);
            return elem && elem.type ? $70fFQ.createElement(elem.type, $84213fec046916ac$var$_extends({}, elem.props, {
                key: (0, $a7arc.is).str(t.key) || (0, $a7arc.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
let $84213fec046916ac$var$nextKey = 1;
function $84213fec046916ac$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t)=>t.item === item && t.phase !== $84213fec046916ac$var$TransitionPhase.LEAVE && !reused.has(t));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $84213fec046916ac$var$nextKey++;
        });
    }
    return (0, $a7arc.is).und(keys) ? items : (0, $a7arc.is).fun(keys) ? items.map(keys) : (0, $a7arc.toArray)(keys);
}
const $84213fec046916ac$var$_excluded$2 = [
    "children"
];
function $84213fec046916ac$export$a500e5b516cedfc(_ref) {
    let { children: children } = _ref, props = $84213fec046916ac$var$_objectWithoutPropertiesLoose(_ref, $84213fec046916ac$var$_excluded$2);
    return children($84213fec046916ac$export$c4af9125706c4d30(props));
}
const $84213fec046916ac$var$_excluded$1 = [
    "items",
    "children"
];
function $84213fec046916ac$export$3b8b9d47fbf8fd2b(_ref) {
    let { items: items, children: children } = _ref, props = $84213fec046916ac$var$_objectWithoutPropertiesLoose(_ref, $84213fec046916ac$var$_excluded$1);
    const trails = $84213fec046916ac$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $a7arc.is).fun(result) ? result(trails[index]) : result;
    });
}
const $84213fec046916ac$var$_excluded = [
    "items",
    "children"
];
function $84213fec046916ac$export$be58926105124dd4(_ref) {
    let { items: items, children: children } = _ref, props = $84213fec046916ac$var$_objectWithoutPropertiesLoose(_ref, $84213fec046916ac$var$_excluded);
    return $84213fec046916ac$export$7b286972b8d8ccbf(items, props)(children);
}
class $84213fec046916ac$export$b0cc4f9860136880 extends $84213fec046916ac$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $a7arc.isEqual)(value, oldValue)) {
            (0, $4VQlI.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $84213fec046916ac$var$checkIdle(this._active)) $84213fec046916ac$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $a7arc.is).arr(this.source) ? this.source.map((0, $a7arc.getFluidValue)) : (0, $a7arc.toArray)((0, $a7arc.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$84213fec046916ac$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $a7arc.each)((0, $4VQlI.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, $a7arc.Globals).skipAnimation) {
                (0, $gVpVE.raf).batchedUpdates(()=>this.advance());
                $84213fec046916ac$var$becomeIdle(this);
            } else (0, $a7arc.frameLoop).start(this);
        }
    }
    _attach() {
        let priority = 1;
        (0, $a7arc.each)((0, $a7arc.toArray)(this.source), (source)=>{
            if ((0, $a7arc.hasFluidValue)(source)) (0, $a7arc.addFluidObserver)(source, this);
            if ($84213fec046916ac$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    _detach() {
        (0, $a7arc.each)((0, $a7arc.toArray)(this.source), (source)=>{
            if ((0, $a7arc.hasFluidValue)(source)) (0, $a7arc.removeFluidObserver)(source, this);
        });
        this._active.clear();
        $84213fec046916ac$var$becomeIdle(this);
    }
    eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $a7arc.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, ($84213fec046916ac$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.key = void 0;
        this.idle = true;
        this.calc = void 0;
        this._active = new Set();
        this.source = source;
        this.calc = (0, $a7arc.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, $4VQlI.getAnimatedType)(value);
        (0, $4VQlI.setAnimated)(this, nodeType.create(value));
    }
}
function $84213fec046916ac$var$isIdle(source) {
    return source.idle !== false;
}
function $84213fec046916ac$var$checkIdle(active) {
    return !active.size || Array.from(active).every($84213fec046916ac$var$isIdle);
}
function $84213fec046916ac$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $a7arc.each)((0, $4VQlI.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, $a7arc.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
const $84213fec046916ac$export$2c618a4308a30424 = (source, ...args)=>new $84213fec046916ac$export$b0cc4f9860136880(source, args);
const $84213fec046916ac$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $a7arc.deprecateInterpolate)(), new $84213fec046916ac$export$b0cc4f9860136880(source, args));
(0, $a7arc.Globals).assign({
    createStringInterpolator: $a7arc.createStringInterpolator,
    to: (source, args)=>new $84213fec046916ac$export$b0cc4f9860136880(source, args)
});
const $84213fec046916ac$export$722fbec263ad908a = (0, $a7arc.frameLoop).advance;
$parcel$exportWildcard(module.exports, $aLPvz);
$parcel$exportWildcard(module.exports, $78Ali);

});
parcelRegister("a7arc", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $75d2a78a5287a11b$export$8793edee2d425525; });
$parcel$export(module.exports, "defineHidden", function () { return $75d2a78a5287a11b$export$5c74248ea0e35446; });
$parcel$export(module.exports, "is", function () { return $75d2a78a5287a11b$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "isEqual", function () { return $75d2a78a5287a11b$export$248d38f6296296c5; });
$parcel$export(module.exports, "each", function () { return $75d2a78a5287a11b$export$79b2f7037acddd43; });
$parcel$export(module.exports, "eachProp", function () { return $75d2a78a5287a11b$export$f4c6fe153f5a944e; });
$parcel$export(module.exports, "toArray", function () { return $75d2a78a5287a11b$export$45b10814cc054894; });
$parcel$export(module.exports, "flush", function () { return $75d2a78a5287a11b$export$4909b86c8034bf73; });
$parcel$export(module.exports, "flushCalls", function () { return $75d2a78a5287a11b$export$7ba486852759e806; });
$parcel$export(module.exports, "Globals", function () { return $75d2a78a5287a11b$export$cceeabf822b64fc0; });
$parcel$export(module.exports, "frameLoop", function () { return $75d2a78a5287a11b$export$a57f5080a3bcc90a; });
$parcel$export(module.exports, "colors", function () { return $75d2a78a5287a11b$export$8f45430ccf837300; });
$parcel$export(module.exports, "createInterpolator", function () { return $75d2a78a5287a11b$export$b12af43b97697ef5; });
$parcel$export(module.exports, "hasFluidValue", function () { return $75d2a78a5287a11b$export$57ea7e3a7f6280c7; });
$parcel$export(module.exports, "getFluidValue", function () { return $75d2a78a5287a11b$export$e37b7520edd66839; });
$parcel$export(module.exports, "getFluidObservers", function () { return $75d2a78a5287a11b$export$133f54e9f7cf1796; });
$parcel$export(module.exports, "callFluidObservers", function () { return $75d2a78a5287a11b$export$31752c40a5fab62a; });
$parcel$export(module.exports, "FluidValue", function () { return $75d2a78a5287a11b$export$aff8e1ac1a016a2; });
$parcel$export(module.exports, "addFluidObserver", function () { return $75d2a78a5287a11b$export$72d604e3f8d000a5; });
$parcel$export(module.exports, "removeFluidObserver", function () { return $75d2a78a5287a11b$export$7a0eb830d336339b; });
$parcel$export(module.exports, "createStringInterpolator", function () { return $75d2a78a5287a11b$export$4759a013d387347a; });
$parcel$export(module.exports, "deprecateInterpolate", function () { return $75d2a78a5287a11b$export$2abfcde8ae218ba8; });
$parcel$export(module.exports, "deprecateDirectCall", function () { return $75d2a78a5287a11b$export$d99d974913ad3b12; });
$parcel$export(module.exports, "isAnimatedString", function () { return $75d2a78a5287a11b$export$75bed621f62abfa9; });
$parcel$export(module.exports, "useOnce", function () { return $75d2a78a5287a11b$export$392544347a18b6ea; });
$parcel$export(module.exports, "useForceUpdate", function () { return $75d2a78a5287a11b$export$91db9bc4f8ac944a; });
$parcel$export(module.exports, "useMemoOne", function () { return $75d2a78a5287a11b$export$b6feb8998cd9b342; });
$parcel$export(module.exports, "usePrev", function () { return $75d2a78a5287a11b$export$ef7ad0c4e19d7fbf; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $75d2a78a5287a11b$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "raf", function () { return (parcelRequire("gVpVE")).raf; });

var $gVpVE = parcelRequire("gVpVE");

var $70fFQ = parcelRequire("70fFQ");
function $75d2a78a5287a11b$export$8793edee2d425525() {}
const $75d2a78a5287a11b$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $75d2a78a5287a11b$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === undefined
};
function $75d2a78a5287a11b$export$248d38f6296296c5(a, b) {
    if ($75d2a78a5287a11b$export$226b3eccf92c9ed9.arr(a)) {
        if (!$75d2a78a5287a11b$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
const $75d2a78a5287a11b$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $75d2a78a5287a11b$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($75d2a78a5287a11b$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
const $75d2a78a5287a11b$export$45b10814cc054894 = (a)=>$75d2a78a5287a11b$export$226b3eccf92c9ed9.und(a) ? [] : $75d2a78a5287a11b$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $75d2a78a5287a11b$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $75d2a78a5287a11b$export$79b2f7037acddd43(items, iterator);
    }
}
const $75d2a78a5287a11b$export$7ba486852759e806 = (queue, ...args)=>$75d2a78a5287a11b$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
let $75d2a78a5287a11b$var$createStringInterpolator$1;
let $75d2a78a5287a11b$var$to;
let $75d2a78a5287a11b$var$colors$1 = null;
let $75d2a78a5287a11b$var$skipAnimation = false;
let $75d2a78a5287a11b$var$willAdvance = $75d2a78a5287a11b$export$8793edee2d425525;
const $75d2a78a5287a11b$var$assign = (globals)=>{
    if (globals.to) $75d2a78a5287a11b$var$to = globals.to;
    if (globals.now) (0, $gVpVE.raf).now = globals.now;
    if (globals.colors !== undefined) $75d2a78a5287a11b$var$colors$1 = globals.colors;
    if (globals.skipAnimation != null) $75d2a78a5287a11b$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $75d2a78a5287a11b$var$createStringInterpolator$1 = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $gVpVE.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $gVpVE.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $75d2a78a5287a11b$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $gVpVE.raf).frameLoop = globals.frameLoop;
};
var $75d2a78a5287a11b$export$cceeabf822b64fc0 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get createStringInterpolator () {
        return $75d2a78a5287a11b$var$createStringInterpolator$1;
    },
    get to () {
        return $75d2a78a5287a11b$var$to;
    },
    get colors () {
        return $75d2a78a5287a11b$var$colors$1;
    },
    get skipAnimation () {
        return $75d2a78a5287a11b$var$skipAnimation;
    },
    get willAdvance () {
        return $75d2a78a5287a11b$var$willAdvance;
    },
    assign: $75d2a78a5287a11b$var$assign
});
const $75d2a78a5287a11b$var$startQueue = new Set();
let $75d2a78a5287a11b$var$currentFrame = [];
let $75d2a78a5287a11b$var$prevFrame = [];
let $75d2a78a5287a11b$var$priority = 0;
const $75d2a78a5287a11b$export$a57f5080a3bcc90a = {
    get idle () {
        return !$75d2a78a5287a11b$var$startQueue.size && !$75d2a78a5287a11b$var$currentFrame.length;
    },
    start (animation) {
        if ($75d2a78a5287a11b$var$priority > animation.priority) {
            $75d2a78a5287a11b$var$startQueue.add(animation);
            (0, $gVpVE.raf).onStart($75d2a78a5287a11b$var$flushStartQueue);
        } else {
            $75d2a78a5287a11b$var$startSafely(animation);
            (0, $gVpVE.raf)($75d2a78a5287a11b$var$advance);
        }
    },
    advance: $75d2a78a5287a11b$var$advance,
    sort (animation) {
        if ($75d2a78a5287a11b$var$priority) (0, $gVpVE.raf).onFrame(()=>$75d2a78a5287a11b$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $75d2a78a5287a11b$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $75d2a78a5287a11b$var$currentFrame.splice(prevIndex, 1);
                $75d2a78a5287a11b$var$startUnsafely(animation);
            }
        }
    },
    clear () {
        $75d2a78a5287a11b$var$currentFrame = [];
        $75d2a78a5287a11b$var$startQueue.clear();
    }
};
function $75d2a78a5287a11b$var$flushStartQueue() {
    $75d2a78a5287a11b$var$startQueue.forEach($75d2a78a5287a11b$var$startSafely);
    $75d2a78a5287a11b$var$startQueue.clear();
    (0, $gVpVE.raf)($75d2a78a5287a11b$var$advance);
}
function $75d2a78a5287a11b$var$startSafely(animation) {
    if (!$75d2a78a5287a11b$var$currentFrame.includes(animation)) $75d2a78a5287a11b$var$startUnsafely(animation);
}
function $75d2a78a5287a11b$var$startUnsafely(animation) {
    $75d2a78a5287a11b$var$currentFrame.splice($75d2a78a5287a11b$var$findIndex($75d2a78a5287a11b$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $75d2a78a5287a11b$var$advance(dt) {
    const nextFrame = $75d2a78a5287a11b$var$prevFrame;
    for(let i = 0; i < $75d2a78a5287a11b$var$currentFrame.length; i++){
        const animation = $75d2a78a5287a11b$var$currentFrame[i];
        $75d2a78a5287a11b$var$priority = animation.priority;
        if (!animation.idle) {
            $75d2a78a5287a11b$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $75d2a78a5287a11b$var$priority = 0;
    $75d2a78a5287a11b$var$prevFrame = $75d2a78a5287a11b$var$currentFrame;
    $75d2a78a5287a11b$var$prevFrame.length = 0;
    $75d2a78a5287a11b$var$currentFrame = nextFrame;
    return $75d2a78a5287a11b$var$currentFrame.length > 0;
}
function $75d2a78a5287a11b$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
const $75d2a78a5287a11b$export$8f45430ccf837300 = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
};
const $75d2a78a5287a11b$var$NUMBER = "[-+]?\\d*\\.?\\d+";
const $75d2a78a5287a11b$var$PERCENTAGE = $75d2a78a5287a11b$var$NUMBER + "%";
function $75d2a78a5287a11b$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const $75d2a78a5287a11b$export$8972dc0e6ad9238f = new RegExp("rgb" + $75d2a78a5287a11b$var$call($75d2a78a5287a11b$var$NUMBER, $75d2a78a5287a11b$var$NUMBER, $75d2a78a5287a11b$var$NUMBER));
const $75d2a78a5287a11b$export$4e46ac54fc82cf3b = new RegExp("rgba" + $75d2a78a5287a11b$var$call($75d2a78a5287a11b$var$NUMBER, $75d2a78a5287a11b$var$NUMBER, $75d2a78a5287a11b$var$NUMBER, $75d2a78a5287a11b$var$NUMBER));
const $75d2a78a5287a11b$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $75d2a78a5287a11b$var$call($75d2a78a5287a11b$var$NUMBER, $75d2a78a5287a11b$var$PERCENTAGE, $75d2a78a5287a11b$var$PERCENTAGE));
const $75d2a78a5287a11b$export$810b04175080204c = new RegExp("hsla" + $75d2a78a5287a11b$var$call($75d2a78a5287a11b$var$NUMBER, $75d2a78a5287a11b$var$PERCENTAGE, $75d2a78a5287a11b$var$PERCENTAGE, $75d2a78a5287a11b$var$NUMBER));
const $75d2a78a5287a11b$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $75d2a78a5287a11b$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $75d2a78a5287a11b$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
const $75d2a78a5287a11b$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
function $75d2a78a5287a11b$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
    if (match = $75d2a78a5287a11b$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($75d2a78a5287a11b$var$colors$1 && $75d2a78a5287a11b$var$colors$1[color] !== undefined) return $75d2a78a5287a11b$var$colors$1[color];
    if (match = $75d2a78a5287a11b$export$8972dc0e6ad9238f.exec(color)) return ($75d2a78a5287a11b$var$parse255(match[1]) << 24 | $75d2a78a5287a11b$var$parse255(match[2]) << 16 | $75d2a78a5287a11b$var$parse255(match[3]) << 8 | 0x000000ff) >>> 0;
    if (match = $75d2a78a5287a11b$export$4e46ac54fc82cf3b.exec(color)) return ($75d2a78a5287a11b$var$parse255(match[1]) << 24 | $75d2a78a5287a11b$var$parse255(match[2]) << 16 | $75d2a78a5287a11b$var$parse255(match[3]) << 8 | $75d2a78a5287a11b$var$parse1(match[4])) >>> 0;
    if (match = $75d2a78a5287a11b$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    if (match = $75d2a78a5287a11b$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $75d2a78a5287a11b$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    if (match = $75d2a78a5287a11b$export$8f4a7c0bb78e6ea8.exec(color)) return ($75d2a78a5287a11b$var$hslToRgb($75d2a78a5287a11b$var$parse360(match[1]), $75d2a78a5287a11b$var$parsePercentage(match[2]), $75d2a78a5287a11b$var$parsePercentage(match[3])) | 0x000000ff) >>> 0;
    if (match = $75d2a78a5287a11b$export$810b04175080204c.exec(color)) return ($75d2a78a5287a11b$var$hslToRgb($75d2a78a5287a11b$var$parse360(match[1]), $75d2a78a5287a11b$var$parsePercentage(match[2]), $75d2a78a5287a11b$var$parsePercentage(match[3])) | $75d2a78a5287a11b$var$parse1(match[4])) >>> 0;
    return null;
}
function $75d2a78a5287a11b$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $75d2a78a5287a11b$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $75d2a78a5287a11b$var$hue2rgb(p, q, h + 1 / 3);
    const g = $75d2a78a5287a11b$var$hue2rgb(p, q, h);
    const b = $75d2a78a5287a11b$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $75d2a78a5287a11b$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $75d2a78a5287a11b$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $75d2a78a5287a11b$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $75d2a78a5287a11b$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
function $75d2a78a5287a11b$export$61db176b839af1f(input) {
    let int32Color = $75d2a78a5287a11b$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    let r = (int32Color & 0xff000000) >>> 24;
    let g = (int32Color & 0x00ff0000) >>> 16;
    let b = (int32Color & 0x0000ff00) >>> 8;
    let a = (int32Color & 0x000000ff) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
const $75d2a78a5287a11b$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($75d2a78a5287a11b$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($75d2a78a5287a11b$export$226b3eccf92c9ed9.arr(range)) return $75d2a78a5287a11b$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($75d2a78a5287a11b$export$226b3eccf92c9ed9.str(range.output[0])) return $75d2a78a5287a11b$var$createStringInterpolator$1(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range = $75d2a78a5287a11b$var$findRange(input, inputRange);
        return $75d2a78a5287a11b$var$interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $75d2a78a5287a11b$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $75d2a78a5287a11b$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
function $75d2a78a5287a11b$var$_extends() {
    $75d2a78a5287a11b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $75d2a78a5287a11b$var$_extends.apply(this, arguments);
}
const $75d2a78a5287a11b$var$$get = Symbol.for("FluidValue.get");
const $75d2a78a5287a11b$var$$observers = Symbol.for("FluidValue.observers");
const $75d2a78a5287a11b$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$75d2a78a5287a11b$var$$get]);
const $75d2a78a5287a11b$export$e37b7520edd66839 = (arg)=>arg && arg[$75d2a78a5287a11b$var$$get] ? arg[$75d2a78a5287a11b$var$$get]() : arg;
const $75d2a78a5287a11b$export$133f54e9f7cf1796 = (target)=>target[$75d2a78a5287a11b$var$$observers] || null;
function $75d2a78a5287a11b$export$8cbca1207adce0c0(observer, event) {
    if (observer.eventObserved) observer.eventObserved(event);
    else observer(event);
}
function $75d2a78a5287a11b$export$31752c40a5fab62a(target, event) {
    let observers = target[$75d2a78a5287a11b$var$$observers];
    if (observers) observers.forEach((observer)=>{
        $75d2a78a5287a11b$export$8cbca1207adce0c0(observer, event);
    });
}
class $75d2a78a5287a11b$export$aff8e1ac1a016a2 {
    constructor(get){
        this[$75d2a78a5287a11b$var$$get] = void 0;
        this[$75d2a78a5287a11b$var$$observers] = void 0;
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $75d2a78a5287a11b$export$a3b4618659637aa3(this, get);
    }
}
const $75d2a78a5287a11b$export$a3b4618659637aa3 = (target, get)=>$75d2a78a5287a11b$var$setHidden(target, $75d2a78a5287a11b$var$$get, get);
function $75d2a78a5287a11b$export$72d604e3f8d000a5(target, observer) {
    if (target[$75d2a78a5287a11b$var$$get]) {
        let observers = target[$75d2a78a5287a11b$var$$observers];
        if (!observers) $75d2a78a5287a11b$var$setHidden(target, $75d2a78a5287a11b$var$$observers, observers = new Set());
        if (!observers.has(observer)) {
            observers.add(observer);
            if (target.observerAdded) target.observerAdded(observers.size, observer);
        }
    }
    return observer;
}
function $75d2a78a5287a11b$export$7a0eb830d336339b(target, observer) {
    let observers = target[$75d2a78a5287a11b$var$$observers];
    if (observers && observers.has(observer)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer);
        else target[$75d2a78a5287a11b$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer);
    }
}
const $75d2a78a5287a11b$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $75d2a78a5287a11b$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const $75d2a78a5287a11b$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const $75d2a78a5287a11b$var$unitRegex = new RegExp(`(${$75d2a78a5287a11b$var$numberRegex.source})(%|[a-z]+)`, "i");
let $75d2a78a5287a11b$var$namedColorRegex;
const $75d2a78a5287a11b$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const $75d2a78a5287a11b$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
const $75d2a78a5287a11b$export$4759a013d387347a = (config)=>{
    if (!$75d2a78a5287a11b$var$namedColorRegex) $75d2a78a5287a11b$var$namedColorRegex = $75d2a78a5287a11b$var$colors$1 ? new RegExp(`(${Object.keys($75d2a78a5287a11b$var$colors$1).join("|")})(?!\\w)`, "g") : /^\b$/;
    const output = config.output.map((value)=>$75d2a78a5287a11b$export$e37b7520edd66839(value).replace($75d2a78a5287a11b$var$colorRegex, $75d2a78a5287a11b$export$61db176b839af1f).replace($75d2a78a5287a11b$var$namedColorRegex, $75d2a78a5287a11b$export$61db176b839af1f));
    const keyframes = output.map((value)=>value.match($75d2a78a5287a11b$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output)=>$75d2a78a5287a11b$export$b12af43b97697ef5($75d2a78a5287a11b$var$_extends({}, config, {
            output: output
        })));
    return (input)=>{
        var _output$find;
        const missingUnit = !$75d2a78a5287a11b$var$unitRegex.test(output[0]) && ((_output$find = output.find((value)=>$75d2a78a5287a11b$var$unitRegex.test(value))) == null ? void 0 : _output$find.replace($75d2a78a5287a11b$var$numberRegex, ""));
        let i = 0;
        return output[0].replace($75d2a78a5287a11b$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($75d2a78a5287a11b$var$rgbaRegex, $75d2a78a5287a11b$var$rgbaRound);
    };
};
const $75d2a78a5287a11b$var$prefix = "react-spring: ";
const $75d2a78a5287a11b$var$once = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$75d2a78a5287a11b$var$prefix}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
const $75d2a78a5287a11b$var$warnInterpolate = $75d2a78a5287a11b$var$once(console.warn);
function $75d2a78a5287a11b$export$2abfcde8ae218ba8() {
    $75d2a78a5287a11b$var$warnInterpolate(`${$75d2a78a5287a11b$var$prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const $75d2a78a5287a11b$var$warnDirectCall = $75d2a78a5287a11b$var$once(console.warn);
function $75d2a78a5287a11b$export$d99d974913ad3b12() {
    $75d2a78a5287a11b$var$warnDirectCall(`${$75d2a78a5287a11b$var$prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function $75d2a78a5287a11b$export$75bed621f62abfa9(value) {
    return $75d2a78a5287a11b$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || value in ($75d2a78a5287a11b$var$colors$1 || {}));
}
const $75d2a78a5287a11b$export$392544347a18b6ea = (effect)=>(0, $70fFQ.useEffect)(effect, $75d2a78a5287a11b$var$emptyDeps);
const $75d2a78a5287a11b$var$emptyDeps = [];
function $75d2a78a5287a11b$export$91db9bc4f8ac944a() {
    const update = (0, $70fFQ.useState)()[1];
    const mounted = (0, $70fFQ.useState)($75d2a78a5287a11b$var$makeMountedRef)[0];
    $75d2a78a5287a11b$export$392544347a18b6ea(mounted.unmount);
    return ()=>{
        if (mounted.current) update({});
    };
}
function $75d2a78a5287a11b$var$makeMountedRef() {
    const mounted = {
        current: true,
        unmount: ()=>()=>{
                mounted.current = false;
            }
    };
    return mounted;
}
function $75d2a78a5287a11b$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $70fFQ.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $70fFQ.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $75d2a78a5287a11b$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $70fFQ.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = undefined;
    }, [
        cache
    ]);
    return cache.result;
}
function $75d2a78a5287a11b$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
function $75d2a78a5287a11b$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $70fFQ.useRef)();
    (0, $70fFQ.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
const $75d2a78a5287a11b$export$e5c5a5f917a5871c = typeof window !== "undefined" && window.document && window.document.createElement ? $70fFQ.useLayoutEffect : $70fFQ.useEffect;

});
parcelRegister("gVpVE", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $c52615252adb5203$export$27f233d61a9e2fa4; });
let $c52615252adb5203$var$updateQueue = $c52615252adb5203$var$makeQueue();
const $c52615252adb5203$export$27f233d61a9e2fa4 = (fn)=>$c52615252adb5203$var$schedule(fn, $c52615252adb5203$var$updateQueue);
let $c52615252adb5203$var$writeQueue = $c52615252adb5203$var$makeQueue();
$c52615252adb5203$export$27f233d61a9e2fa4.write = (fn)=>$c52615252adb5203$var$schedule(fn, $c52615252adb5203$var$writeQueue);
let $c52615252adb5203$var$onStartQueue = $c52615252adb5203$var$makeQueue();
$c52615252adb5203$export$27f233d61a9e2fa4.onStart = (fn)=>$c52615252adb5203$var$schedule(fn, $c52615252adb5203$var$onStartQueue);
let $c52615252adb5203$var$onFrameQueue = $c52615252adb5203$var$makeQueue();
$c52615252adb5203$export$27f233d61a9e2fa4.onFrame = (fn)=>$c52615252adb5203$var$schedule(fn, $c52615252adb5203$var$onFrameQueue);
let $c52615252adb5203$var$onFinishQueue = $c52615252adb5203$var$makeQueue();
$c52615252adb5203$export$27f233d61a9e2fa4.onFinish = (fn)=>$c52615252adb5203$var$schedule(fn, $c52615252adb5203$var$onFinishQueue);
let $c52615252adb5203$var$timeouts = [];
$c52615252adb5203$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    let time = $c52615252adb5203$export$27f233d61a9e2fa4.now() + ms;
    let cancel = ()=>{
        let i = $c52615252adb5203$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $c52615252adb5203$var$timeouts.splice(i, 1);
        $c52615252adb5203$export$ef91a23fc803e177.count -= ~i ? 1 : 0;
    };
    let timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $c52615252adb5203$var$timeouts.splice($c52615252adb5203$var$findTimeout(time), 0, timeout);
    $c52615252adb5203$export$ef91a23fc803e177.count += 1;
    $c52615252adb5203$var$start();
    return timeout;
};
let $c52615252adb5203$var$findTimeout = (time)=>~(~$c52615252adb5203$var$timeouts.findIndex((t)=>t.time > time) || ~$c52615252adb5203$var$timeouts.length);
$c52615252adb5203$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $c52615252adb5203$var$updateQueue.delete(fn);
    $c52615252adb5203$var$writeQueue.delete(fn);
};
$c52615252adb5203$export$27f233d61a9e2fa4.sync = (fn)=>{
    $c52615252adb5203$var$sync = true;
    $c52615252adb5203$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $c52615252adb5203$var$sync = false;
};
$c52615252adb5203$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $c52615252adb5203$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $c52615252adb5203$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
let $c52615252adb5203$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : ()=>{};
$c52615252adb5203$export$27f233d61a9e2fa4.use = (impl)=>$c52615252adb5203$var$nativeRaf = impl;
$c52615252adb5203$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$c52615252adb5203$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$c52615252adb5203$export$27f233d61a9e2fa4.catch = console.error;
$c52615252adb5203$export$27f233d61a9e2fa4.frameLoop = "always";
$c52615252adb5203$export$27f233d61a9e2fa4.advance = ()=>{
    if ($c52615252adb5203$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $c52615252adb5203$var$update();
};
let $c52615252adb5203$var$ts = -1;
let $c52615252adb5203$var$sync = false;
function $c52615252adb5203$var$schedule(fn, queue) {
    if ($c52615252adb5203$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $c52615252adb5203$var$start();
    }
}
function $c52615252adb5203$var$start() {
    if ($c52615252adb5203$var$ts < 0) {
        $c52615252adb5203$var$ts = 0;
        if ($c52615252adb5203$export$27f233d61a9e2fa4.frameLoop !== "demand") $c52615252adb5203$var$nativeRaf($c52615252adb5203$var$loop);
    }
}
function $c52615252adb5203$var$loop() {
    if (~$c52615252adb5203$var$ts) {
        $c52615252adb5203$var$nativeRaf($c52615252adb5203$var$loop);
        $c52615252adb5203$export$27f233d61a9e2fa4.batchedUpdates($c52615252adb5203$var$update);
    }
}
function $c52615252adb5203$var$update() {
    let prevTs = $c52615252adb5203$var$ts;
    $c52615252adb5203$var$ts = $c52615252adb5203$export$27f233d61a9e2fa4.now();
    let count = $c52615252adb5203$var$findTimeout($c52615252adb5203$var$ts);
    if (count) {
        $c52615252adb5203$var$eachSafely($c52615252adb5203$var$timeouts.splice(0, count), (t)=>t.handler());
        $c52615252adb5203$export$ef91a23fc803e177.count -= count;
    }
    $c52615252adb5203$var$onStartQueue.flush();
    $c52615252adb5203$var$updateQueue.flush(prevTs ? Math.min(64, $c52615252adb5203$var$ts - prevTs) : 16.667);
    $c52615252adb5203$var$onFrameQueue.flush();
    $c52615252adb5203$var$writeQueue.flush();
    $c52615252adb5203$var$onFinishQueue.flush();
}
function $c52615252adb5203$var$makeQueue() {
    let next = new Set();
    let current = next;
    return {
        add (fn) {
            $c52615252adb5203$export$ef91a23fc803e177.count += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $c52615252adb5203$export$ef91a23fc803e177.count -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = new Set();
                $c52615252adb5203$export$ef91a23fc803e177.count -= current.size;
                $c52615252adb5203$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $c52615252adb5203$export$ef91a23fc803e177.count += next.size;
                current = next;
            }
        }
    };
}
function $c52615252adb5203$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $c52615252adb5203$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
const $c52615252adb5203$export$ef91a23fc803e177 = {
    count: 0,
    clear () {
        $c52615252adb5203$var$ts = -1;
        $c52615252adb5203$var$timeouts = [];
        $c52615252adb5203$var$onStartQueue = $c52615252adb5203$var$makeQueue();
        $c52615252adb5203$var$updateQueue = $c52615252adb5203$var$makeQueue();
        $c52615252adb5203$var$onFrameQueue = $c52615252adb5203$var$makeQueue();
        $c52615252adb5203$var$writeQueue = $c52615252adb5203$var$makeQueue();
        $c52615252adb5203$var$onFinishQueue = $c52615252adb5203$var$makeQueue();
        $c52615252adb5203$export$ef91a23fc803e177.count = 0;
    }
};

});


parcelRegister("4VQlI", function(module, exports) {

$parcel$export(module.exports, "getAnimated", function () { return $397517bfa305c116$export$6b63995194a3a9e4; });
$parcel$export(module.exports, "setAnimated", function () { return $397517bfa305c116$export$b553cb5b22b81b04; });
$parcel$export(module.exports, "getPayload", function () { return $397517bfa305c116$export$ccab2b64c5d440; });
$parcel$export(module.exports, "AnimatedValue", function () { return $397517bfa305c116$export$cb1e8f3c05d37ad5; });
$parcel$export(module.exports, "AnimatedString", function () { return $397517bfa305c116$export$f6c6c4cbd7fa5b93; });
$parcel$export(module.exports, "AnimatedObject", function () { return $397517bfa305c116$export$f1b0b9e366a6e2d4; });
$parcel$export(module.exports, "getAnimatedType", function () { return $397517bfa305c116$export$e6b77ddbe47b132e; });
$parcel$export(module.exports, "createHost", function () { return $397517bfa305c116$export$4ee5c78f6dcbcef; });

var $a7arc = parcelRequire("a7arc");
var $gVpVE = parcelRequire("gVpVE");

var $70fFQ = parcelRequire("70fFQ");
const $397517bfa305c116$var$$node = Symbol.for("Animated:node");
const $397517bfa305c116$export$3df5e165e801a70f = (value)=>!!value && value[$397517bfa305c116$var$$node] === value;
const $397517bfa305c116$export$6b63995194a3a9e4 = (owner)=>owner && owner[$397517bfa305c116$var$$node];
const $397517bfa305c116$export$b553cb5b22b81b04 = (owner, node)=>(0, $a7arc.defineHidden)(owner, $397517bfa305c116$var$$node, node);
const $397517bfa305c116$export$ccab2b64c5d440 = (owner)=>owner && owner[$397517bfa305c116$var$$node] && owner[$397517bfa305c116$var$$node].getPayload();
class $397517bfa305c116$export$31627395a3b18e54 {
    getPayload() {
        return this.payload || [];
    }
    constructor(){
        this.payload = void 0;
        $397517bfa305c116$export$b553cb5b22b81b04(this, this);
    }
}
class $397517bfa305c116$export$cb1e8f3c05d37ad5 extends $397517bfa305c116$export$31627395a3b18e54 {
    static create(value) {
        return new $397517bfa305c116$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $a7arc.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $a7arc.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this.done = true;
        this.elapsedTime = void 0;
        this.lastPosition = void 0;
        this.lastVelocity = void 0;
        this.v0 = void 0;
        this.durationProgress = 0;
        this._value = _value;
        if ((0, $a7arc.is).num(this._value)) this.lastPosition = this._value;
    }
}
class $397517bfa305c116$export$f6c6c4cbd7fa5b93 extends $397517bfa305c116$export$cb1e8f3c05d37ad5 {
    static create(value) {
        return new $397517bfa305c116$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        let value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $a7arc.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $a7arc.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = void 0;
        this._toString = (0, $a7arc.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
}
const $397517bfa305c116$var$TreeContext = {
    dependencies: null
};
class $397517bfa305c116$export$f1b0b9e366a6e2d4 extends $397517bfa305c116$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $a7arc.eachProp)(this.source, (source, key)=>{
            if ($397517bfa305c116$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $a7arc.hasFluidValue)(source)) values[key] = (0, $a7arc.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $a7arc.each)(this.payload, (node)=>node.reset());
    }
    _makePayload(source) {
        if (source) {
            const payload = new Set();
            (0, $a7arc.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    _addToPayload(source) {
        if ($397517bfa305c116$var$TreeContext.dependencies && (0, $a7arc.hasFluidValue)(source)) $397517bfa305c116$var$TreeContext.dependencies.add(source);
        const payload = $397517bfa305c116$export$ccab2b64c5d440(source);
        if (payload) (0, $a7arc.each)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
}
class $397517bfa305c116$export$ede394683406942d extends $397517bfa305c116$export$f1b0b9e366a6e2d4 {
    static create(source) {
        return new $397517bfa305c116$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($397517bfa305c116$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
}
function $397517bfa305c116$var$makeAnimated(value) {
    const nodeType = (0, $a7arc.isAnimatedString)(value) ? $397517bfa305c116$export$f6c6c4cbd7fa5b93 : $397517bfa305c116$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $397517bfa305c116$export$e6b77ddbe47b132e(value) {
    const parentNode = $397517bfa305c116$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $a7arc.is).arr(value) ? $397517bfa305c116$export$ede394683406942d : (0, $a7arc.isAnimatedString)(value) ? $397517bfa305c116$export$f6c6c4cbd7fa5b93 : $397517bfa305c116$export$cb1e8f3c05d37ad5;
}
function $397517bfa305c116$var$_extends() {
    $397517bfa305c116$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $397517bfa305c116$var$_extends.apply(this, arguments);
}
const $397517bfa305c116$var$withAnimated = (Component, host)=>{
    const hasInstance = !(0, $a7arc.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $70fFQ.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $70fFQ.useRef)(null);
        const ref = hasInstance && (0, $70fFQ.useCallback)((value)=>{
            instanceRef.current = $397517bfa305c116$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $397517bfa305c116$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $a7arc.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $397517bfa305c116$var$PropsObserver(callback, deps);
        const observerRef = (0, $70fFQ.useRef)();
        (0, $a7arc.useLayoutEffect)(()=>{
            const lastObserver = observerRef.current;
            observerRef.current = observer;
            (0, $a7arc.each)(deps, (dep)=>(0, $a7arc.addFluidObserver)(dep, observer));
            if (lastObserver) {
                (0, $a7arc.each)(lastObserver.deps, (dep)=>(0, $a7arc.removeFluidObserver)(dep, lastObserver));
                (0, $gVpVE.raf).cancel(lastObserver.update);
            }
        });
        (0, $70fFQ.useEffect)(callback, []);
        (0, $a7arc.useOnce)(()=>()=>{
                const observer = observerRef.current;
                (0, $a7arc.each)(observer.deps, (dep)=>(0, $a7arc.removeFluidObserver)(dep, observer));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return $70fFQ.createElement(Component, $397517bfa305c116$var$_extends({}, usedProps, {
            ref: ref
        }));
    });
};
class $397517bfa305c116$var$PropsObserver {
    eventObserved(event) {
        if (event.type == "change") (0, $gVpVE.raf).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
}
function $397517bfa305c116$var$getAnimatedState(props, host) {
    const dependencies = new Set();
    $397517bfa305c116$var$TreeContext.dependencies = dependencies;
    if (props.style) props = $397517bfa305c116$var$_extends({}, props, {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $397517bfa305c116$export$f1b0b9e366a6e2d4(props);
    $397517bfa305c116$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $397517bfa305c116$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $a7arc.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
const $397517bfa305c116$var$cacheKey = Symbol.for("AnimatedComponent");
const $397517bfa305c116$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: _applyAnimatedValues = ()=>false, createAnimatedStyle: _createAnimatedStyle = (style)=>new $397517bfa305c116$export$f1b0b9e366a6e2d4(style), getComponentProps: _getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: _applyAnimatedValues,
        createAnimatedStyle: _createAnimatedStyle,
        getComponentProps: _getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $397517bfa305c116$var$getDisplayName(Component) || "Anonymous";
        if ((0, $a7arc.is).str(Component)) Component = animated[Component] || (animated[Component] = $397517bfa305c116$var$withAnimated(Component, hostConfig));
        else Component = Component[$397517bfa305c116$var$cacheKey] || (Component[$397517bfa305c116$var$cacheKey] = $397517bfa305c116$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $a7arc.eachProp)(components, (Component, key)=>{
        if ((0, $a7arc.is).arr(components)) key = $397517bfa305c116$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
const $397517bfa305c116$var$getDisplayName = (arg)=>(0, $a7arc.is).str(arg) ? arg : arg && (0, $a7arc.is).str(arg.displayName) ? arg.displayName : (0, $a7arc.is).fun(arg) && arg.name || null;

});

parcelRegister("aLPvz", function(module, exports) {

});

parcelRegister("78Ali", function(module, exports) {

});



parcelRegister("lBSSW", function(module, exports) {

var $91x1j = parcelRequire("91x1j");

var $ioays = parcelRequire("ioays");

var $ftx1W = parcelRequire("ftx1W");
/** `Object#toString` result references. */ var $fbb7a0bbebfbec13$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $fbb7a0bbebfbec13$var$isString(value) {
    return typeof value == "string" || !$ioays(value) && $ftx1W(value) && $91x1j(value) == $fbb7a0bbebfbec13$var$stringTag;
}
module.exports = $fbb7a0bbebfbec13$var$isString;

});

parcelRegister("1NdVc", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $14e52a98e655ee86$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $14e52a98e655ee86$var$last;

});

parcelRegister("eZmYt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae98956793797982$export$2e2bcd8739ae039; });

var $f4AhM = parcelRequire("f4AhM");
const $ae98956793797982$export$e4f898ab14d9d460 = Symbol("implicit");
function $ae98956793797982$export$2e2bcd8739ae039() {
    var index = new Map(), domain = [], range = [], unknown = $ae98956793797982$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $ae98956793797982$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new Map();
        for (const value of _){
            const key = value + "";
            if (index.has(key)) continue;
            index.set(key, domain.push(value));
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $ae98956793797982$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $f4AhM.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("f4AhM", function(module, exports) {

$parcel$export(module.exports, "initRange", function () { return $af93605c775087b9$export$23c7bb9e6558da2a; });
$parcel$export(module.exports, "initInterpolator", function () { return $af93605c775087b9$export$7d6b419e59e83f3d; });
function $af93605c775087b9$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $af93605c775087b9$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});


parcelRegister("9MR7R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7201ce6f0c4077b0$export$2e2bcd8739ae039; });

var $kZFCO = parcelRequire("kZFCO");

var $a8yvN = parcelRequire("a8yvN");

var $f4AhM = parcelRequire("f4AhM");
function $7201ce6f0c4077b0$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $kZFCO.default)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $7201ce6f0c4077b0$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $f4AhM.initRange).apply((0, $a8yvN.linearish)(scale), arguments);
}

});
parcelRegister("kZFCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f489cb07b6cdd425$export$2e2bcd8739ae039; });

var $lI9GN = parcelRequire("lI9GN");

var $73fLL = parcelRequire("73fLL");

var $9AnDb = parcelRequire("9AnDb");
const $f489cb07b6cdd425$var$ascendingBisect = (0, $73fLL.default)((0, $lI9GN.default));
const $f489cb07b6cdd425$export$4d945ad3ad5751b0 = $f489cb07b6cdd425$var$ascendingBisect.right;
const $f489cb07b6cdd425$export$df7d25c84ebd12a5 = $f489cb07b6cdd425$var$ascendingBisect.left;
const $f489cb07b6cdd425$export$c1cb828b1117c77b = (0, $73fLL.default)((0, $9AnDb.default)).center;
var $f489cb07b6cdd425$export$2e2bcd8739ae039 = $f489cb07b6cdd425$export$4d945ad3ad5751b0;

});
parcelRegister("lI9GN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fce539220be5b36d$export$2e2bcd8739ae039; });
function $fce539220be5b36d$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("73fLL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52250bad79b707a4$export$2e2bcd8739ae039; });

var $lI9GN = parcelRequire("lI9GN");
function $52250bad79b707a4$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $52250bad79b707a4$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $52250bad79b707a4$var$ascendingComparator(f) {
    return (d, x)=>(0, $lI9GN.default)(f(d), x);
}

});

parcelRegister("9AnDb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fa9ce7a75ab5f28$export$2e2bcd8739ae039; });
function $6fa9ce7a75ab5f28$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $6fa9ce7a75ab5f28$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("a8yvN", function(module, exports) {

$parcel$export(module.exports, "linearish", function () { return $76156c12910f315d$export$16a5d4b4a61a274d; });
$parcel$export(module.exports, "default", function () { return $76156c12910f315d$export$2e2bcd8739ae039; });

var $lAhFG = parcelRequire("lAhFG");

var $62KKj = parcelRequire("62KKj");

var $f4AhM = parcelRequire("f4AhM");

var $eZQgc = parcelRequire("eZQgc");
function $76156c12910f315d$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $lAhFG.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $eZQgc.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $lAhFG.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $76156c12910f315d$export$2e2bcd8739ae039() {
    var scale = (0, $62KKj.default)();
    scale.copy = function() {
        return (0, $62KKj.copy)(scale, $76156c12910f315d$export$2e2bcd8739ae039());
    };
    (0, $f4AhM.initRange).apply(scale, arguments);
    return $76156c12910f315d$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("lAhFG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb6aaaea233dc524$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "tickIncrement", function () { return $fb6aaaea233dc524$export$bc64d00cc98e7e95; });
$parcel$export(module.exports, "tickStep", function () { return $fb6aaaea233dc524$export$81087d9b915d4ede; });
var $fb6aaaea233dc524$var$e10 = Math.sqrt(50), $fb6aaaea233dc524$var$e5 = Math.sqrt(10), $fb6aaaea233dc524$var$e2 = Math.sqrt(2);
function $fb6aaaea233dc524$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $fb6aaaea233dc524$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $fb6aaaea233dc524$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $fb6aaaea233dc524$var$e10 ? 10 : error >= $fb6aaaea233dc524$var$e5 ? 5 : error >= $fb6aaaea233dc524$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $fb6aaaea233dc524$var$e10 ? 10 : error >= $fb6aaaea233dc524$var$e5 ? 5 : error >= $fb6aaaea233dc524$var$e2 ? 2 : 1);
}
function $fb6aaaea233dc524$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $fb6aaaea233dc524$var$e10) step1 *= 10;
    else if (error >= $fb6aaaea233dc524$var$e5) step1 *= 5;
    else if (error >= $fb6aaaea233dc524$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("62KKj", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $466730bdbe6bc01e$export$f0954fd7d5368655; });
$parcel$export(module.exports, "copy", function () { return $466730bdbe6bc01e$export$784d13d8ee351f07; });
$parcel$export(module.exports, "transformer", function () { return $466730bdbe6bc01e$export$6b468dcfb64c653c; });
$parcel$export(module.exports, "default", function () { return $466730bdbe6bc01e$export$2e2bcd8739ae039; });

var $kZFCO = parcelRequire("kZFCO");

var $eH3R9 = parcelRequire("eH3R9");
var $3kqoA = parcelRequire("3kqoA");
var $a5PKU = parcelRequire("a5PKU");

var $7X2Ks = parcelRequire("7X2Ks");

var $cNp3N = parcelRequire("cNp3N");
var $466730bdbe6bc01e$var$unit = [
    0,
    1
];
function $466730bdbe6bc01e$export$f0954fd7d5368655(x) {
    return x;
}
function $466730bdbe6bc01e$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $7X2Ks.default)(isNaN(b) ? NaN : 0.5);
}
function $466730bdbe6bc01e$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $466730bdbe6bc01e$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $466730bdbe6bc01e$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $466730bdbe6bc01e$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $466730bdbe6bc01e$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $466730bdbe6bc01e$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $kZFCO.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $466730bdbe6bc01e$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $466730bdbe6bc01e$export$6b468dcfb64c653c() {
    var domain = $466730bdbe6bc01e$var$unit, range = $466730bdbe6bc01e$var$unit, interpolate = (0, $eH3R9.default), transform, untransform, unknown, clamp = $466730bdbe6bc01e$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $466730bdbe6bc01e$export$f0954fd7d5368655) clamp = $466730bdbe6bc01e$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $466730bdbe6bc01e$var$polymap : $466730bdbe6bc01e$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $3kqoA.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $cNp3N.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $a5PKU.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $466730bdbe6bc01e$export$f0954fd7d5368655, rescale()) : clamp !== $466730bdbe6bc01e$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $466730bdbe6bc01e$export$2e2bcd8739ae039() {
    return $466730bdbe6bc01e$export$6b468dcfb64c653c()($466730bdbe6bc01e$export$f0954fd7d5368655, $466730bdbe6bc01e$export$f0954fd7d5368655);
}

});
parcelRegister("eH3R9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab281297ea96f9b3$export$2e2bcd8739ae039; });

var $6rvtj = parcelRequire("6rvtj");

var $lm8DY = parcelRequire("lm8DY");

var $cOja9 = parcelRequire("cOja9");

var $enLGf = parcelRequire("enLGf");

var $3kqoA = parcelRequire("3kqoA");

var $7twxj = parcelRequire("7twxj");

var $c40jk = parcelRequire("c40jk");

var $ahmXq = parcelRequire("ahmXq");

var $5XV9b = parcelRequire("5XV9b");
function $ab281297ea96f9b3$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ahmXq.default)(b) : (t === "number" ? (0, $3kqoA.default) : t === "string" ? (c = (0, $6rvtj.default)(b)) ? (b = c, $lm8DY.default) : (0, $c40jk.default) : b instanceof (0, $6rvtj.default) ? (0, $lm8DY.default) : b instanceof Date ? (0, $enLGf.default) : (0, $5XV9b.isNumberArray)(b) ? (0, $5XV9b.default) : Array.isArray(b) ? (0, $cOja9.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $7twxj.default) : (0, $3kqoA.default))(a, b);
}

});
parcelRegister("6rvtj", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $aVB9q = parcelRequire("aVB9q");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $aVB9q.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $aVB9q.default)(Rgb, rgb, (0, $aVB9q.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $aVB9q.default)(Hsl, hsl, (0, $aVB9q.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("aVB9q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f4c0ba9f4c850f7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $7f4c0ba9f4c850f7$export$8b58be045bf06082; });
function $7f4c0ba9f4c850f7$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $7f4c0ba9f4c850f7$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("lm8DY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8c25b87d0bf7256$export$2e2bcd8739ae039; });

var $6rvtj = parcelRequire("6rvtj");

var $bC2ek = parcelRequire("bC2ek");

var $g04Cj = parcelRequire("g04Cj");

var $fVILD = parcelRequire("fVILD");
var $f8c25b87d0bf7256$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $fVILD.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $6rvtj.rgb)(start)).r, (end = (0, $6rvtj.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $fVILD.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $f8c25b87d0bf7256$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $6rvtj.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $f8c25b87d0bf7256$export$2c0e28f2e2852d3f = $f8c25b87d0bf7256$var$rgbSpline((0, $bC2ek.default));
var $f8c25b87d0bf7256$export$53d5214f625ccd4c = $f8c25b87d0bf7256$var$rgbSpline((0, $g04Cj.default));

});
parcelRegister("bC2ek", function(module, exports) {

$parcel$export(module.exports, "basis", function () { return $8744f925bcceb718$export$4e41033bfeec1a4c; });
$parcel$export(module.exports, "default", function () { return $8744f925bcceb718$export$2e2bcd8739ae039; });
function $8744f925bcceb718$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $8744f925bcceb718$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $8744f925bcceb718$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("g04Cj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba603a4363455c63$export$2e2bcd8739ae039; });

var $bC2ek = parcelRequire("bC2ek");
function $ba603a4363455c63$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $bC2ek.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("fVILD", function(module, exports) {

$parcel$export(module.exports, "gamma", function () { return $b98ee7c3abb124f4$export$a7ebe8cc6aaf8d37; });
$parcel$export(module.exports, "default", function () { return $b98ee7c3abb124f4$export$2e2bcd8739ae039; });

var $ahmXq = parcelRequire("ahmXq");
function $b98ee7c3abb124f4$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $b98ee7c3abb124f4$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $b98ee7c3abb124f4$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $b98ee7c3abb124f4$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $ahmXq.default)(isNaN(a) ? b : a);
}
function $b98ee7c3abb124f4$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $b98ee7c3abb124f4$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $b98ee7c3abb124f4$var$exponential(a, b, y) : (0, $ahmXq.default)(isNaN(a) ? b : a);
    };
}
function $b98ee7c3abb124f4$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $b98ee7c3abb124f4$var$linear(a, d) : (0, $ahmXq.default)(isNaN(a) ? b : a);
}

});
parcelRegister("ahmXq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77bd4ccd12b009b1$export$2e2bcd8739ae039; });
var $77bd4ccd12b009b1$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("cOja9", function(module, exports) {

$parcel$export(module.exports, "genericArray", function () { return $953904ddee966dee$export$15d09067c6a5ee49; });

var $eH3R9 = parcelRequire("eH3R9");

var $5XV9b = parcelRequire("5XV9b");
function $953904ddee966dee$export$2e2bcd8739ae039(a, b) {
    return ((0, $5XV9b.isNumberArray)(b) ? (0, $5XV9b.default) : $953904ddee966dee$export$15d09067c6a5ee49)(a, b);
}
function $953904ddee966dee$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $eH3R9.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("5XV9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $011ef2c09c288d49$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isNumberArray", function () { return $011ef2c09c288d49$export$5cd576d1827d40c8; });
function $011ef2c09c288d49$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $011ef2c09c288d49$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("enLGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a78832fc2cc6f2fd$export$2e2bcd8739ae039; });
function $a78832fc2cc6f2fd$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("3kqoA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26c7b6fc685127d0$export$2e2bcd8739ae039; });
function $26c7b6fc685127d0$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("7twxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57147ada25caa671$export$2e2bcd8739ae039; });

var $eH3R9 = parcelRequire("eH3R9");
function $57147ada25caa671$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $eH3R9.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("c40jk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c86197c44d5d9ad$export$2e2bcd8739ae039; });

var $3kqoA = parcelRequire("3kqoA");
var $8c86197c44d5d9ad$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $8c86197c44d5d9ad$var$reB = new RegExp($8c86197c44d5d9ad$var$reA.source, "g");
function $8c86197c44d5d9ad$var$zero(b) {
    return function() {
        return b;
    };
}
function $8c86197c44d5d9ad$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $8c86197c44d5d9ad$export$2e2bcd8739ae039(a, b) {
    var bi = $8c86197c44d5d9ad$var$reA.lastIndex = $8c86197c44d5d9ad$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $8c86197c44d5d9ad$var$reA.exec(a)) && (bm = $8c86197c44d5d9ad$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $3kqoA.default)(am, bm)
            });
        }
        bi = $8c86197c44d5d9ad$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $8c86197c44d5d9ad$var$one(q[0].x) : $8c86197c44d5d9ad$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("a5PKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7592849ae9e938f1$export$2e2bcd8739ae039; });
function $7592849ae9e938f1$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("7X2Ks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ca02cdcc6ced218$export$2e2bcd8739ae039; });
function $5ca02cdcc6ced218$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("cNp3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $950d8014a9fc320c$export$2e2bcd8739ae039; });
function $950d8014a9fc320c$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("eZQgc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeaf4cfa3b073f8a$export$2e2bcd8739ae039; });

var $lAhFG = parcelRequire("lAhFG");

var $5DdsI = parcelRequire("5DdsI");
var $7s9He = parcelRequire("7s9He");
var $bmV8E = parcelRequire("bmV8E");
var $e2SLo = parcelRequire("e2SLo");
var $6fw3b = parcelRequire("6fw3b");
function $aeaf4cfa3b073f8a$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $lAhFG.tickStep)(start, stop, count), precision;
    specifier = (0, $7s9He.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $e2SLo.default)(step, value))) specifier.precision = precision;
            return (0, $5DdsI.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $6fw3b.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $bmV8E.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $5DdsI.format)(specifier);
}

});
parcelRegister("5DdsI", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $419b098d4b1cd4b9$export$d9468344d3651243; });
$parcel$export(module.exports, "formatPrefix", function () { return $419b098d4b1cd4b9$export$8d85692a469dde6f; });

var $b5FU3 = parcelRequire("b5FU3");
var $419b098d4b1cd4b9$var$locale;
var $419b098d4b1cd4b9$export$d9468344d3651243;
var $419b098d4b1cd4b9$export$8d85692a469dde6f;
$419b098d4b1cd4b9$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $419b098d4b1cd4b9$export$2e2bcd8739ae039(definition) {
    $419b098d4b1cd4b9$var$locale = (0, $b5FU3.default)(definition);
    $419b098d4b1cd4b9$export$d9468344d3651243 = $419b098d4b1cd4b9$var$locale.format;
    $419b098d4b1cd4b9$export$8d85692a469dde6f = $419b098d4b1cd4b9$var$locale.formatPrefix;
    return $419b098d4b1cd4b9$var$locale;
}

});
parcelRegister("b5FU3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8130aa6ca6d8b38c$export$2e2bcd8739ae039; });

var $diM1L = parcelRequire("diM1L");

var $el9K5 = parcelRequire("el9K5");

var $kUT6P = parcelRequire("kUT6P");

var $7s9He = parcelRequire("7s9He");

var $c1Gxi = parcelRequire("c1Gxi");

var $bBPqD = parcelRequire("bBPqD");

var $5sPum = parcelRequire("5sPum");

var $9u9Ye = parcelRequire("9u9Ye");
var $8130aa6ca6d8b38c$var$map = Array.prototype.map, $8130aa6ca6d8b38c$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $8130aa6ca6d8b38c$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $9u9Ye.default) : (0, $el9K5.default)($8130aa6ca6d8b38c$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $9u9Ye.default) : (0, $kUT6P.default)($8130aa6ca6d8b38c$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $7s9He.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $bBPqD.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $bBPqD.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $c1Gxi.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $8130aa6ca6d8b38c$var$prefixes[8 + (0, $5sPum.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $7s9He.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $diM1L.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $8130aa6ca6d8b38c$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("diM1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9af2360d3601e165$export$2e2bcd8739ae039; });

var $7jczV = parcelRequire("7jczV");
function $9af2360d3601e165$export$2e2bcd8739ae039(x) {
    return x = (0, $7jczV.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("7jczV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5524108f847fe28d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "formatDecimalParts", function () { return $5524108f847fe28d$export$8f8e23dd27dc19f5; });
function $5524108f847fe28d$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $5524108f847fe28d$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("el9K5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a70a957e08e92815$export$2e2bcd8739ae039; });
function $a70a957e08e92815$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("kUT6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3a3c927c82efa92$export$2e2bcd8739ae039; });
function $f3a3c927c82efa92$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("7s9He", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56d2ab6e0f766a03$export$2e2bcd8739ae039; });
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $56d2ab6e0f766a03$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $56d2ab6e0f766a03$export$2e2bcd8739ae039(specifier) {
    if (!(match = $56d2ab6e0f766a03$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $56d2ab6e0f766a03$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$56d2ab6e0f766a03$export$2e2bcd8739ae039.prototype = $56d2ab6e0f766a03$export$963aac351db36ed4.prototype; // instanceof
function $56d2ab6e0f766a03$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$56d2ab6e0f766a03$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("c1Gxi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c1692cbf294482b$export$2e2bcd8739ae039; });
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $8c1692cbf294482b$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("bBPqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $873b0b08b2b0dd39$export$2e2bcd8739ae039; });

var $7jczV = parcelRequire("7jczV");

var $5sPum = parcelRequire("5sPum");

var $igvjy = parcelRequire("igvjy");
var $873b0b08b2b0dd39$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $7jczV.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $igvjy.default)(x * 100, p),
    "r": (0, $igvjy.default),
    "s": (0, $5sPum.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("5sPum", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", function () { return $3fa781d976610fe7$export$6863724d9a42263; });
$parcel$export(module.exports, "default", function () { return $3fa781d976610fe7$export$2e2bcd8739ae039; });

var $7jczV = parcelRequire("7jczV");
var $3fa781d976610fe7$export$6863724d9a42263;
function $3fa781d976610fe7$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7jczV.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($3fa781d976610fe7$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $7jczV.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("igvjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4c20305535fd357$export$2e2bcd8739ae039; });

var $7jczV = parcelRequire("7jczV");
function $d4c20305535fd357$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7jczV.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("9u9Ye", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e7ea65437de1c28$export$2e2bcd8739ae039; });
function $6e7ea65437de1c28$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("bmV8E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $846e124d52e06767$export$2e2bcd8739ae039; });

var $diM1L = parcelRequire("diM1L");
function $846e124d52e06767$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $diM1L.default)(Math.abs(step)));
}

});

parcelRegister("e2SLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a39bbb7abec9a1e0$export$2e2bcd8739ae039; });

var $diM1L = parcelRequire("diM1L");
function $a39bbb7abec9a1e0$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $diM1L.default)(value) / 3))) * 3 - (0, $diM1L.default)(Math.abs(step)));
}

});

parcelRegister("6fw3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48cd014e65f030d1$export$2e2bcd8739ae039; });

var $diM1L = parcelRequire("diM1L");
function $48cd014e65f030d1$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $diM1L.default)(max) - (0, $diM1L.default)(step)) + 1;
}

});




parcelRegister("72ggJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51f556f6800b5233$export$2e2bcd8739ae039; });

var $eH3R9 = parcelRequire("eH3R9");
var $a5PKU = parcelRequire("a5PKU");

var $62KKj = parcelRequire("62KKj");

var $f4AhM = parcelRequire("f4AhM");

var $a8yvN = parcelRequire("a8yvN");

var $i4W4N = parcelRequire("i4W4N");

var $g5Evh = parcelRequire("g5Evh");

var $5LW9x = parcelRequire("5LW9x");
function $51f556f6800b5233$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $62KKj.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $eH3R9.default));
    scale.rangeRound = range((0, $a5PKU.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $51f556f6800b5233$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $51f556f6800b5233$export$2e2bcd8739ae039() {
    var scale = (0, $a8yvN.linearish)($51f556f6800b5233$var$transformer()((0, $62KKj.identity)));
    scale.copy = function() {
        return $51f556f6800b5233$export$784d13d8ee351f07(scale, $51f556f6800b5233$export$2e2bcd8739ae039());
    };
    return (0, $f4AhM.initInterpolator).apply(scale, arguments);
}
function $51f556f6800b5233$export$6843e08bf2ff981f() {
    var scale = (0, $i4W4N.loggish)($51f556f6800b5233$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $51f556f6800b5233$export$784d13d8ee351f07(scale, $51f556f6800b5233$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $f4AhM.initInterpolator).apply(scale, arguments);
}
function $51f556f6800b5233$export$9d4af4de62c81941() {
    var scale = (0, $g5Evh.symlogish)($51f556f6800b5233$var$transformer());
    scale.copy = function() {
        return $51f556f6800b5233$export$784d13d8ee351f07(scale, $51f556f6800b5233$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $f4AhM.initInterpolator).apply(scale, arguments);
}
function $51f556f6800b5233$export$de9f78581b4f2405() {
    var scale = (0, $5LW9x.powish)($51f556f6800b5233$var$transformer());
    scale.copy = function() {
        return $51f556f6800b5233$export$784d13d8ee351f07(scale, $51f556f6800b5233$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $f4AhM.initInterpolator).apply(scale, arguments);
}
function $51f556f6800b5233$export$413d935127ed466e() {
    return $51f556f6800b5233$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("i4W4N", function(module, exports) {

$parcel$export(module.exports, "loggish", function () { return $d295a677aaeb6a07$export$860836db074028f0; });
$parcel$export(module.exports, "default", function () { return $d295a677aaeb6a07$export$2e2bcd8739ae039; });

var $lAhFG = parcelRequire("lAhFG");

var $5DdsI = parcelRequire("5DdsI");

var $79yV8 = parcelRequire("79yV8");

var $62KKj = parcelRequire("62KKj");

var $f4AhM = parcelRequire("f4AhM");
function $d295a677aaeb6a07$var$transformLog(x) {
    return Math.log(x);
}
function $d295a677aaeb6a07$var$transformExp(x) {
    return Math.exp(x);
}
function $d295a677aaeb6a07$var$transformLogn(x) {
    return -Math.log(-x);
}
function $d295a677aaeb6a07$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $d295a677aaeb6a07$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $d295a677aaeb6a07$var$powp(base) {
    return base === 10 ? $d295a677aaeb6a07$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $d295a677aaeb6a07$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $d295a677aaeb6a07$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $d295a677aaeb6a07$export$860836db074028f0(transform) {
    var scale = transform($d295a677aaeb6a07$var$transformLog, $d295a677aaeb6a07$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $d295a677aaeb6a07$var$logp(base), pows = $d295a677aaeb6a07$var$powp(base);
        if (domain()[0] < 0) {
            logs = $d295a677aaeb6a07$var$reflect(logs), pows = $d295a677aaeb6a07$var$reflect(pows);
            transform($d295a677aaeb6a07$var$transformLogn, $d295a677aaeb6a07$var$transformExpn);
        } else transform($d295a677aaeb6a07$var$transformLog, $d295a677aaeb6a07$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $lAhFG.default)(u, v, n);
        } else z = (0, $lAhFG.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $5DdsI.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $79yV8.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $d295a677aaeb6a07$export$2e2bcd8739ae039() {
    var scale = $d295a677aaeb6a07$export$860836db074028f0((0, $62KKj.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $62KKj.copy)(scale, $d295a677aaeb6a07$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $f4AhM.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("79yV8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53547621f2e830e0$export$2e2bcd8739ae039; });
function $53547621f2e830e0$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("g5Evh", function(module, exports) {

$parcel$export(module.exports, "symlogish", function () { return $bb6c8820c3d11629$export$4602684e614eba38; });
$parcel$export(module.exports, "default", function () { return $bb6c8820c3d11629$export$2e2bcd8739ae039; });

var $a8yvN = parcelRequire("a8yvN");

var $62KKj = parcelRequire("62KKj");

var $f4AhM = parcelRequire("f4AhM");
function $bb6c8820c3d11629$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $bb6c8820c3d11629$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $bb6c8820c3d11629$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($bb6c8820c3d11629$var$transformSymlog(c), $bb6c8820c3d11629$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($bb6c8820c3d11629$var$transformSymlog(c = +_), $bb6c8820c3d11629$var$transformSymexp(c)) : c;
    };
    return (0, $a8yvN.linearish)(scale);
}
function $bb6c8820c3d11629$export$2e2bcd8739ae039() {
    var scale = $bb6c8820c3d11629$export$4602684e614eba38((0, $62KKj.transformer)());
    scale.copy = function() {
        return (0, $62KKj.copy)(scale, $bb6c8820c3d11629$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $f4AhM.initRange).apply(scale, arguments);
}

});

parcelRegister("5LW9x", function(module, exports) {

$parcel$export(module.exports, "powish", function () { return $433e737e1220d75c$export$34695211ec403a46; });

var $a8yvN = parcelRequire("a8yvN");

var $62KKj = parcelRequire("62KKj");

var $f4AhM = parcelRequire("f4AhM");
function $433e737e1220d75c$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $433e737e1220d75c$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $433e737e1220d75c$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $433e737e1220d75c$export$34695211ec403a46(transform) {
    var scale = transform((0, $62KKj.identity), (0, $62KKj.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $62KKj.identity), (0, $62KKj.identity)) : exponent === 0.5 ? transform($433e737e1220d75c$var$transformSqrt, $433e737e1220d75c$var$transformSquare) : transform($433e737e1220d75c$var$transformPow(exponent), $433e737e1220d75c$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $a8yvN.linearish)(scale);
}
function $433e737e1220d75c$export$2e2bcd8739ae039() {
    var scale = $433e737e1220d75c$export$34695211ec403a46((0, $62KKj.transformer)());
    scale.copy = function() {
        return (0, $62KKj.copy)(scale, $433e737e1220d75c$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $f4AhM.initRange).apply(scale, arguments);
    return scale;
}
function $433e737e1220d75c$export$eba8049fb5020b81() {
    return $433e737e1220d75c$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});


parcelRegister("cpSH1", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $90a23eafa0b7021a$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $90a23eafa0b7021a$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $90a23eafa0b7021a$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $b84sM.default));
var $90a23eafa0b7021a$export$2e2bcd8739ae039 = (0, $3IBmH.default)($90a23eafa0b7021a$export$3005042704f95a69);

});
parcelRegister("b84sM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81a3e75cf4a49278$export$2e2bcd8739ae039; });
function $81a3e75cf4a49278$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}

});

parcelRegister("3IBmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b5277189d405cb0$export$2e2bcd8739ae039; });

var $iegtR = parcelRequire("iegtR");
var $2b5277189d405cb0$export$2e2bcd8739ae039 = (scheme)=>(0, $iegtR.rgbBasis)(scheme[scheme.length - 1]);

});
parcelRegister("iegtR", function(module, exports) {

$parcel$export(module.exports, "rgbBasis", function () { return $d456518486b57923$export$2c0e28f2e2852d3f; });

var $ju2Vl = parcelRequire("ju2Vl");

var $fvQaA = parcelRequire("fvQaA");

var $2M1ja = parcelRequire("2M1ja");

var $72FaA = parcelRequire("72FaA");
var $d456518486b57923$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $72FaA.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $ju2Vl.rgb)(start)).r, (end = (0, $ju2Vl.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $72FaA.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $d456518486b57923$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $ju2Vl.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $d456518486b57923$export$2c0e28f2e2852d3f = $d456518486b57923$var$rgbSpline((0, $fvQaA.default));
var $d456518486b57923$export$53d5214f625ccd4c = $d456518486b57923$var$rgbSpline((0, $2M1ja.default));

});
parcelRegister("ju2Vl", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });

var $cwdpQ = parcelRequire("cwdpQ");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $cwdpQ.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $cwdpQ.default)(Rgb, rgb, (0, $cwdpQ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $cwdpQ.default)(Hsl, hsl, (0, $cwdpQ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("cwdpQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91d2e149b598e388$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $91d2e149b598e388$export$8b58be045bf06082; });
function $91d2e149b598e388$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $91d2e149b598e388$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("fvQaA", function(module, exports) {

$parcel$export(module.exports, "basis", function () { return $b4b2381103ade7b2$export$4e41033bfeec1a4c; });
$parcel$export(module.exports, "default", function () { return $b4b2381103ade7b2$export$2e2bcd8739ae039; });
function $b4b2381103ade7b2$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $b4b2381103ade7b2$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $b4b2381103ade7b2$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("2M1ja", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2051143b92cb5f2b$export$2e2bcd8739ae039; });

var $fvQaA = parcelRequire("fvQaA");
function $2051143b92cb5f2b$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $fvQaA.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("72FaA", function(module, exports) {

$parcel$export(module.exports, "hue", function () { return $5208a7c14c235ac8$export$97d7b0c7ddb78dcf; });
$parcel$export(module.exports, "gamma", function () { return $5208a7c14c235ac8$export$a7ebe8cc6aaf8d37; });
$parcel$export(module.exports, "default", function () { return $5208a7c14c235ac8$export$2e2bcd8739ae039; });

var $cmRiY = parcelRequire("cmRiY");
function $5208a7c14c235ac8$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $5208a7c14c235ac8$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $5208a7c14c235ac8$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $5208a7c14c235ac8$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $cmRiY.default)(isNaN(a) ? b : a);
}
function $5208a7c14c235ac8$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $5208a7c14c235ac8$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $5208a7c14c235ac8$var$exponential(a, b, y) : (0, $cmRiY.default)(isNaN(a) ? b : a);
    };
}
function $5208a7c14c235ac8$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $5208a7c14c235ac8$var$linear(a, d) : (0, $cmRiY.default)(isNaN(a) ? b : a);
}

});
parcelRegister("cmRiY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9010e360efb61ddc$export$2e2bcd8739ae039; });
var $9010e360efb61ddc$export$2e2bcd8739ae039 = (x)=>()=>x;

});





parcelRegister("fz4N9", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $b54dd76cbe32b5e2$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $b54dd76cbe32b5e2$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $b54dd76cbe32b5e2$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $b84sM.default));
var $b54dd76cbe32b5e2$export$2e2bcd8739ae039 = (0, $3IBmH.default)($b54dd76cbe32b5e2$export$3005042704f95a69);

});

parcelRegister("gt53g", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $bfd345e91782b867$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $bfd345e91782b867$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $bfd345e91782b867$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $b84sM.default));
var $bfd345e91782b867$export$2e2bcd8739ae039 = (0, $3IBmH.default)($bfd345e91782b867$export$3005042704f95a69);

});

parcelRegister("5Z16B", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $45b381cb40e0224f$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $45b381cb40e0224f$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $45b381cb40e0224f$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $b84sM.default));
var $45b381cb40e0224f$export$2e2bcd8739ae039 = (0, $3IBmH.default)($45b381cb40e0224f$export$3005042704f95a69);

});

parcelRegister("cwrJr", function(module, exports) {

$parcel$export(module.exports, "warm", function () { return $91ddfc2fe20acfea$export$fc70efcec537be98; });
$parcel$export(module.exports, "cool", function () { return $91ddfc2fe20acfea$export$c5cedbc1ab3be2c3; });
$parcel$export(module.exports, "default", function () { return $91ddfc2fe20acfea$export$2e2bcd8739ae039; });

var $9HH3c = parcelRequire("9HH3c");

var $d5nQ3 = parcelRequire("d5nQ3");
var $91ddfc2fe20acfea$export$fc70efcec537be98 = (0, $d5nQ3.cubehelixLong)((0, $9HH3c.default)(-100, 0.75, 0.35), (0, $9HH3c.default)(80, 1.50, 0.8));
var $91ddfc2fe20acfea$export$c5cedbc1ab3be2c3 = (0, $d5nQ3.cubehelixLong)((0, $9HH3c.default)(260, 0.75, 0.35), (0, $9HH3c.default)(80, 1.50, 0.8));
var $91ddfc2fe20acfea$var$c = (0, $9HH3c.default)();
function $91ddfc2fe20acfea$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $91ddfc2fe20acfea$var$c.h = 360 * t - 100;
    $91ddfc2fe20acfea$var$c.s = 1.5 - 1.5 * ts;
    $91ddfc2fe20acfea$var$c.l = 0.8 - 0.9 * ts;
    return $91ddfc2fe20acfea$var$c + "";
}

});
parcelRegister("9HH3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7109862d4c770939$export$2e2bcd8739ae039; });

var $cwdpQ = parcelRequire("cwdpQ");

var $ju2Vl = parcelRequire("ju2Vl");

var $deEOO = parcelRequire("deEOO");
var $7109862d4c770939$var$A = -0.14861, $7109862d4c770939$var$B = 1.78277, $7109862d4c770939$var$C = -0.29227, $7109862d4c770939$var$D = -0.90649, $7109862d4c770939$var$E = 1.97294, $7109862d4c770939$var$ED = $7109862d4c770939$var$E * $7109862d4c770939$var$D, $7109862d4c770939$var$EB = $7109862d4c770939$var$E * $7109862d4c770939$var$B, $7109862d4c770939$var$BC_DA = $7109862d4c770939$var$B * $7109862d4c770939$var$C - $7109862d4c770939$var$D * $7109862d4c770939$var$A;
function $7109862d4c770939$var$cubehelixConvert(o) {
    if (o instanceof $7109862d4c770939$export$57ed4bde61a1e2f2) return new $7109862d4c770939$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $ju2Vl.Rgb))) o = (0, $ju2Vl.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($7109862d4c770939$var$BC_DA * b + $7109862d4c770939$var$ED * r - $7109862d4c770939$var$EB * g) / ($7109862d4c770939$var$BC_DA + $7109862d4c770939$var$ED - $7109862d4c770939$var$EB), bl = b - l, k = ($7109862d4c770939$var$E * (g - l) - $7109862d4c770939$var$C * bl) / $7109862d4c770939$var$D, s = Math.sqrt(k * k + bl * bl) / ($7109862d4c770939$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $deEOO.degrees) - 120 : NaN;
    return new $7109862d4c770939$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $7109862d4c770939$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $7109862d4c770939$var$cubehelixConvert(h) : new $7109862d4c770939$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $7109862d4c770939$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $cwdpQ.default)($7109862d4c770939$export$57ed4bde61a1e2f2, $7109862d4c770939$export$2e2bcd8739ae039, (0, $cwdpQ.extend)((0, $ju2Vl.Color), {
    brighter: function(k) {
        k = k == null ? (0, $ju2Vl.brighter) : Math.pow((0, $ju2Vl.brighter), k);
        return new $7109862d4c770939$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $ju2Vl.darker) : Math.pow((0, $ju2Vl.darker), k);
        return new $7109862d4c770939$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $deEOO.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $ju2Vl.Rgb)(255 * (l + a * ($7109862d4c770939$var$A * cosh + $7109862d4c770939$var$B * sinh)), 255 * (l + a * ($7109862d4c770939$var$C * cosh + $7109862d4c770939$var$D * sinh)), 255 * (l + a * ($7109862d4c770939$var$E * cosh)), this.opacity);
    }
}));

});
parcelRegister("deEOO", function(module, exports) {

$parcel$export(module.exports, "radians", function () { return $9a2c3ee4a0f63489$export$8449e153fbd325fc; });
$parcel$export(module.exports, "degrees", function () { return $9a2c3ee4a0f63489$export$41fc368e1a942b97; });
const $9a2c3ee4a0f63489$export$8449e153fbd325fc = Math.PI / 180;
const $9a2c3ee4a0f63489$export$41fc368e1a942b97 = 180 / Math.PI;

});


parcelRegister("d5nQ3", function(module, exports) {

$parcel$export(module.exports, "cubehelixLong", function () { return $986e3bd4692a150e$export$934fa09ad474a1b4; });

var $9HH3c = parcelRequire("9HH3c");

var $72FaA = parcelRequire("72FaA");
function $986e3bd4692a150e$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $9HH3c.default)(start)).h, (end = (0, $9HH3c.default)(end)).h), s = (0, $72FaA.default)(start.s, end.s), l = (0, $72FaA.default)(start.l, end.l), opacity = (0, $72FaA.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $986e3bd4692a150e$export$2e2bcd8739ae039 = $986e3bd4692a150e$var$cubehelix((0, $72FaA.hue));
var $986e3bd4692a150e$export$934fa09ad474a1b4 = $986e3bd4692a150e$var$cubehelix((0, $72FaA.default));

});


parcelRegister("80FqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d4e75a8b2af08a3$export$2e2bcd8739ae039; });

var $9HH3c = parcelRequire("9HH3c");

var $d5nQ3 = parcelRequire("d5nQ3");
var $5d4e75a8b2af08a3$export$2e2bcd8739ae039 = (0, $d5nQ3.cubehelixLong)((0, $9HH3c.default)(300, 0.5, 0.0), (0, $9HH3c.default)(-240, 0.5, 1.0));

});

parcelRegister("eN11p", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $ac466f2bd84b8c84$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $ac466f2bd84b8c84$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $ac466f2bd84b8c84$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $b84sM.default));
var $ac466f2bd84b8c84$export$2e2bcd8739ae039 = (0, $3IBmH.default)($ac466f2bd84b8c84$export$3005042704f95a69);

});

parcelRegister("7hh3z", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $54c759ff9c15b3f7$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $54c759ff9c15b3f7$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $54c759ff9c15b3f7$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $b84sM.default));
var $54c759ff9c15b3f7$export$2e2bcd8739ae039 = (0, $3IBmH.default)($54c759ff9c15b3f7$export$3005042704f95a69);

});

parcelRegister("i74RE", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $03672bfd99f400ba$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $03672bfd99f400ba$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $03672bfd99f400ba$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $b84sM.default));
var $03672bfd99f400ba$export$2e2bcd8739ae039 = (0, $3IBmH.default)($03672bfd99f400ba$export$3005042704f95a69);

});

parcelRegister("7oKHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $562f00b148ba2f15$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "magma", function () { return $562f00b148ba2f15$export$c41e69203f572e8d; });
$parcel$export(module.exports, "inferno", function () { return $562f00b148ba2f15$export$ad0c8285c8ea6dbd; });
$parcel$export(module.exports, "plasma", function () { return $562f00b148ba2f15$export$6664860a633d9daf; });

var $b84sM = parcelRequire("b84sM");
function $562f00b148ba2f15$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $562f00b148ba2f15$export$2e2bcd8739ae039 = $562f00b148ba2f15$var$ramp((0, $b84sM.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $562f00b148ba2f15$export$c41e69203f572e8d = $562f00b148ba2f15$var$ramp((0, $b84sM.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $562f00b148ba2f15$export$ad0c8285c8ea6dbd = $562f00b148ba2f15$var$ramp((0, $b84sM.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $562f00b148ba2f15$export$6664860a633d9daf = $562f00b148ba2f15$var$ramp((0, $b84sM.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

});

parcelRegister("ll3aH", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $f88e04ecad30490a$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $f88e04ecad30490a$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $f88e04ecad30490a$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $b84sM.default));
var $f88e04ecad30490a$export$2e2bcd8739ae039 = (0, $3IBmH.default)($f88e04ecad30490a$export$3005042704f95a69);

});

parcelRegister("k90dT", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $eaa4d23b0875baec$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $eaa4d23b0875baec$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $eaa4d23b0875baec$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $b84sM.default));
var $eaa4d23b0875baec$export$2e2bcd8739ae039 = (0, $3IBmH.default)($eaa4d23b0875baec$export$3005042704f95a69);

});

parcelRegister("eqkbc", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $a80325a9fd09103a$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $a80325a9fd09103a$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $a80325a9fd09103a$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $b84sM.default));
var $a80325a9fd09103a$export$2e2bcd8739ae039 = (0, $3IBmH.default)($a80325a9fd09103a$export$3005042704f95a69);

});

parcelRegister("9kdQ2", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $6ca0b750626a755e$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $6ca0b750626a755e$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $6ca0b750626a755e$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $b84sM.default));
var $6ca0b750626a755e$export$2e2bcd8739ae039 = (0, $3IBmH.default)($6ca0b750626a755e$export$3005042704f95a69);

});

parcelRegister("75sQg", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $528f5f73d60e255e$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $528f5f73d60e255e$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $528f5f73d60e255e$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $b84sM.default));
var $528f5f73d60e255e$export$2e2bcd8739ae039 = (0, $3IBmH.default)($528f5f73d60e255e$export$3005042704f95a69);

});

parcelRegister("j6d4T", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $de78b8d6550340b3$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $de78b8d6550340b3$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $de78b8d6550340b3$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $b84sM.default));
var $de78b8d6550340b3$export$2e2bcd8739ae039 = (0, $3IBmH.default)($de78b8d6550340b3$export$3005042704f95a69);

});

parcelRegister("3rkUU", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $28141e5e477e7f35$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $28141e5e477e7f35$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $28141e5e477e7f35$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $b84sM.default));
var $28141e5e477e7f35$export$2e2bcd8739ae039 = (0, $3IBmH.default)($28141e5e477e7f35$export$3005042704f95a69);

});

parcelRegister("2knla", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $1b1f8df2bf200a64$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $1b1f8df2bf200a64$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $1b1f8df2bf200a64$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $b84sM.default));
var $1b1f8df2bf200a64$export$2e2bcd8739ae039 = (0, $3IBmH.default)($1b1f8df2bf200a64$export$3005042704f95a69);

});

parcelRegister("b5AgS", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $812c4c10964924b3$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $812c4c10964924b3$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $812c4c10964924b3$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $b84sM.default));
var $812c4c10964924b3$export$2e2bcd8739ae039 = (0, $3IBmH.default)($812c4c10964924b3$export$3005042704f95a69);

});

parcelRegister("deqjQ", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $9a20ff9c638ea3c6$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $9a20ff9c638ea3c6$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $9a20ff9c638ea3c6$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $b84sM.default));
var $9a20ff9c638ea3c6$export$2e2bcd8739ae039 = (0, $3IBmH.default)($9a20ff9c638ea3c6$export$3005042704f95a69);

});

parcelRegister("n18IX", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $0453086b8b62cf90$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $0453086b8b62cf90$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $0453086b8b62cf90$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $b84sM.default));
var $0453086b8b62cf90$export$2e2bcd8739ae039 = (0, $3IBmH.default)($0453086b8b62cf90$export$3005042704f95a69);

});

parcelRegister("2jgeQ", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $1ae9f3b80bc415b2$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $1ae9f3b80bc415b2$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $1ae9f3b80bc415b2$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $b84sM.default));
var $1ae9f3b80bc415b2$export$2e2bcd8739ae039 = (0, $3IBmH.default)($1ae9f3b80bc415b2$export$3005042704f95a69);

});

parcelRegister("6torH", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $4b6869ee0c1eb38e$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $4b6869ee0c1eb38e$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $4b6869ee0c1eb38e$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $b84sM.default));
var $4b6869ee0c1eb38e$export$2e2bcd8739ae039 = (0, $3IBmH.default)($4b6869ee0c1eb38e$export$3005042704f95a69);

});

parcelRegister("7JT8F", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $5a2781cbde5cf1b4$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $5a2781cbde5cf1b4$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $5a2781cbde5cf1b4$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $b84sM.default));
var $5a2781cbde5cf1b4$export$2e2bcd8739ae039 = (0, $3IBmH.default)($5a2781cbde5cf1b4$export$3005042704f95a69);

});

parcelRegister("grEAO", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $bf8ea7d5f5db309a$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $bf8ea7d5f5db309a$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $bf8ea7d5f5db309a$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $b84sM.default));
var $bf8ea7d5f5db309a$export$2e2bcd8739ae039 = (0, $3IBmH.default)($bf8ea7d5f5db309a$export$3005042704f95a69);

});

parcelRegister("5x0wB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $407071044ea79932$export$2e2bcd8739ae039; });

var $ju2Vl = parcelRequire("ju2Vl");
var $407071044ea79932$var$c = (0, $ju2Vl.rgb)(), $407071044ea79932$var$pi_1_3 = Math.PI / 3, $407071044ea79932$var$pi_2_3 = Math.PI * 2 / 3;
function $407071044ea79932$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $407071044ea79932$var$c.r = 255 * (x = Math.sin(t)) * x;
    $407071044ea79932$var$c.g = 255 * (x = Math.sin(t + $407071044ea79932$var$pi_1_3)) * x;
    $407071044ea79932$var$c.b = 255 * (x = Math.sin(t + $407071044ea79932$var$pi_2_3)) * x;
    return $407071044ea79932$var$c + "";
}

});

parcelRegister("7UdON", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $5c187b6631a37701$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $5c187b6631a37701$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $5c187b6631a37701$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $b84sM.default));
var $5c187b6631a37701$export$2e2bcd8739ae039 = (0, $3IBmH.default)($5c187b6631a37701$export$3005042704f95a69);

});

parcelRegister("gkCir", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $be3c387428c58908$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $be3c387428c58908$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $be3c387428c58908$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $b84sM.default));
var $be3c387428c58908$export$2e2bcd8739ae039 = (0, $3IBmH.default)($be3c387428c58908$export$3005042704f95a69);

});

parcelRegister("bSpC5", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $8a589b1ed11dd734$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $8a589b1ed11dd734$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $8a589b1ed11dd734$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $b84sM.default));
var $8a589b1ed11dd734$export$2e2bcd8739ae039 = (0, $3IBmH.default)($8a589b1ed11dd734$export$3005042704f95a69);

});

parcelRegister("8ktkj", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $6106f09fb00037d5$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $6106f09fb00037d5$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $6106f09fb00037d5$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $b84sM.default));
var $6106f09fb00037d5$export$2e2bcd8739ae039 = (0, $3IBmH.default)($6106f09fb00037d5$export$3005042704f95a69);

});

parcelRegister("cMNJi", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $94f08afdc33ce481$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $94f08afdc33ce481$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");

var $3IBmH = parcelRequire("3IBmH");
var $94f08afdc33ce481$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $b84sM.default));
var $94f08afdc33ce481$export$2e2bcd8739ae039 = (0, $3IBmH.default)($94f08afdc33ce481$export$3005042704f95a69);

});

parcelRegister("k8jNo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea83e8fba09a2c4d$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $ea83e8fba09a2c4d$export$2e2bcd8739ae039 = (0, $b84sM.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

});

parcelRegister("56l8W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b6de9de6821d519$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $3b6de9de6821d519$export$2e2bcd8739ae039 = (0, $b84sM.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

});

parcelRegister("lXjI8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffbe65d05d04470b$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $ffbe65d05d04470b$export$2e2bcd8739ae039 = (0, $b84sM.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

});

parcelRegister("1CkZa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12d99e54c6269256$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $12d99e54c6269256$export$2e2bcd8739ae039 = (0, $b84sM.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

});

parcelRegister("7CLP4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58d12d9d82ca57fa$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $58d12d9d82ca57fa$export$2e2bcd8739ae039 = (0, $b84sM.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

});

parcelRegister("es2xN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a855a76c974b2364$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $a855a76c974b2364$export$2e2bcd8739ae039 = (0, $b84sM.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

});

parcelRegister("CgMhj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0730906c403e2572$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $0730906c403e2572$export$2e2bcd8739ae039 = (0, $b84sM.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

});

parcelRegister("40aWI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e9fa72aca924c24$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $2e9fa72aca924c24$export$2e2bcd8739ae039 = (0, $b84sM.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

});

parcelRegister("i3yYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d253a41c6d1284a3$export$2e2bcd8739ae039; });

var $b84sM = parcelRequire("b84sM");
var $d253a41c6d1284a3$export$2e2bcd8739ae039 = (0, $b84sM.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

});

parcelRegister("a8GNE", function(module, exports) {

var $ayZMu = parcelRequire("ayZMu");

var $kkQvj = parcelRequire("kkQvj");

var $5mBAP = parcelRequire("5mBAP");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $761bd9e133915527$var$without = $kkQvj(function(array, values) {
    return $5mBAP(array) ? $ayZMu(array, values) : [];
});
module.exports = $761bd9e133915527$var$without;

});
parcelRegister("ayZMu", function(module, exports) {

var $4XyaN = parcelRequire("4XyaN");

var $kND8l = parcelRequire("kND8l");

var $lIxxu = parcelRequire("lIxxu");

var $iRXKp = parcelRequire("iRXKp");

var $ecPyO = parcelRequire("ecPyO");

var $kDnhx = parcelRequire("kDnhx");
/** Used as the size to enable large array optimizations. */ var $7b0d00cbe3390acb$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $7b0d00cbe3390acb$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $kND8l, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $iRXKp(values, $ecPyO(iteratee));
    if (comparator) {
        includes = $lIxxu;
        isCommon = false;
    } else if (values.length >= $7b0d00cbe3390acb$var$LARGE_ARRAY_SIZE) {
        includes = $kDnhx;
        isCommon = false;
        values = new $4XyaN(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $7b0d00cbe3390acb$var$baseDifference;

});
parcelRegister("4XyaN", function(module, exports) {

var $8wBGT = parcelRequire("8wBGT");

var $emK6Q = parcelRequire("emK6Q");

var $erxuI = parcelRequire("erxuI");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $39c72e32cd42050d$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $8wBGT;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$39c72e32cd42050d$var$SetCache.prototype.add = $39c72e32cd42050d$var$SetCache.prototype.push = $emK6Q;
$39c72e32cd42050d$var$SetCache.prototype.has = $erxuI;
module.exports = $39c72e32cd42050d$var$SetCache;

});
parcelRegister("emK6Q", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $a756e323aa892570$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $a756e323aa892570$var$setCacheAdd(value) {
    this.__data__.set(value, $a756e323aa892570$var$HASH_UNDEFINED);
    return this;
}
module.exports = $a756e323aa892570$var$setCacheAdd;

});

parcelRegister("erxuI", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $a83d9197bcf096c9$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $a83d9197bcf096c9$var$setCacheHas;

});


parcelRegister("kND8l", function(module, exports) {

var $j4Af4 = parcelRequire("j4Af4");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f246bd5b5ac9a1e6$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $j4Af4(array, value, 0) > -1;
}
module.exports = $f246bd5b5ac9a1e6$var$arrayIncludes;

});
parcelRegister("j4Af4", function(module, exports) {

var $5zrJv = parcelRequire("5zrJv");

var $iNF4e = parcelRequire("iNF4e");

var $h13mN = parcelRequire("h13mN");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $de2a80f76bec3d3f$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $h13mN(array, value, fromIndex) : $5zrJv(array, $iNF4e, fromIndex);
}
module.exports = $de2a80f76bec3d3f$var$baseIndexOf;

});
parcelRegister("5zrJv", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $40e5bbd29f1d2426$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $40e5bbd29f1d2426$var$baseFindIndex;

});

parcelRegister("iNF4e", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $dafca8b1d5c559b2$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $dafca8b1d5c559b2$var$baseIsNaN;

});

parcelRegister("h13mN", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c635243451daa6e5$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $c635243451daa6e5$var$strictIndexOf;

});



parcelRegister("lIxxu", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $fcf7b93b45ddd390$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $fcf7b93b45ddd390$var$arrayIncludesWith;

});

parcelRegister("kDnhx", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f059827ab0ce04f7$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $f059827ab0ce04f7$var$cacheHas;

});



parcelRegister("bnPpR", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $8499b9db4cd652f6$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Basis", function () { return $8499b9db4cd652f6$export$957f7263e89bedd2; });
$parcel$export(module.exports, "default", function () { return $8499b9db4cd652f6$export$2e2bcd8739ae039; });
function $8499b9db4cd652f6$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $8499b9db4cd652f6$export$957f7263e89bedd2(context) {
    this._context = context;
}
$8499b9db4cd652f6$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $8499b9db4cd652f6$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $8499b9db4cd652f6$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $8499b9db4cd652f6$export$2e2bcd8739ae039(context) {
    return new $8499b9db4cd652f6$export$957f7263e89bedd2(context);
}

});

parcelRegister("s34nM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0544ff37219b55e3$export$2e2bcd8739ae039; });

var $32MHn = parcelRequire("32MHn");

var $bnPpR = parcelRequire("bnPpR");
function $0544ff37219b55e3$var$BasisClosed(context) {
    this._context = context;
}
$0544ff37219b55e3$var$BasisClosed.prototype = {
    areaStart: (0, $32MHn.default),
    areaEnd: (0, $32MHn.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $bnPpR.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $0544ff37219b55e3$export$2e2bcd8739ae039(context) {
    return new $0544ff37219b55e3$var$BasisClosed(context);
}

});
parcelRegister("32MHn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23775587a81b645b$export$2e2bcd8739ae039; });
function $23775587a81b645b$export$2e2bcd8739ae039() {}

});


parcelRegister("2bhQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $196a738441e91121$export$2e2bcd8739ae039; });

var $bnPpR = parcelRequire("bnPpR");
function $196a738441e91121$var$BasisOpen(context) {
    this._context = context;
}
$196a738441e91121$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $bnPpR.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $196a738441e91121$export$2e2bcd8739ae039(context) {
    return new $196a738441e91121$var$BasisOpen(context);
}

});

parcelRegister("gy5kR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c3f5ced4a205ca$export$2e2bcd8739ae039; });

var $bnPpR = parcelRequire("bnPpR");
function $c0c3f5ced4a205ca$var$Bundle(context, beta) {
    this._basis = new (0, $bnPpR.Basis)(context);
    this._beta = beta;
}
$c0c3f5ced4a205ca$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $c0c3f5ced4a205ca$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $bnPpR.Basis)(context) : new $c0c3f5ced4a205ca$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("ez0Zd", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $a9a51974895cb06a$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $a9a51974895cb06a$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $a9a51974895cb06a$export$2e2bcd8739ae039; });
function $a9a51974895cb06a$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $a9a51974895cb06a$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a9a51974895cb06a$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $a9a51974895cb06a$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $a9a51974895cb06a$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a9a51974895cb06a$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $a9a51974895cb06a$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("1qq3o", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", function () { return $109c6de346c92447$export$da3940d7e9162858; });
$parcel$export(module.exports, "default", function () { return $109c6de346c92447$export$2e2bcd8739ae039; });

var $32MHn = parcelRequire("32MHn");

var $ez0Zd = parcelRequire("ez0Zd");
function $109c6de346c92447$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$109c6de346c92447$export$da3940d7e9162858.prototype = {
    areaStart: (0, $32MHn.default),
    areaEnd: (0, $32MHn.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $ez0Zd.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $109c6de346c92447$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $109c6de346c92447$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("64Ae3", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", function () { return $46bf37715465eb4c$export$cd7d1a617282f2f1; });
$parcel$export(module.exports, "default", function () { return $46bf37715465eb4c$export$2e2bcd8739ae039; });

var $ez0Zd = parcelRequire("ez0Zd");
function $46bf37715465eb4c$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$46bf37715465eb4c$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $ez0Zd.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $46bf37715465eb4c$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $46bf37715465eb4c$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("aUWvE", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $7f2c852281d8dc0e$export$2e2bcd8739ae039; });

var $8FFuk = parcelRequire("8FFuk");

var $ez0Zd = parcelRequire("ez0Zd");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $8FFuk.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $8FFuk.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $7f2c852281d8dc0e$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $ez0Zd.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("8FFuk", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $650255c549a8fc98$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan2", function () { return $650255c549a8fc98$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $650255c549a8fc98$export$50d414a77b60d802; });
$parcel$export(module.exports, "max", function () { return $650255c549a8fc98$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $650255c549a8fc98$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "sin", function () { return $650255c549a8fc98$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sqrt", function () { return $650255c549a8fc98$export$eba8049fb5020b81; });
$parcel$export(module.exports, "epsilon", function () { return $650255c549a8fc98$export$6c421550c66a327d; });
$parcel$export(module.exports, "pi", function () { return $650255c549a8fc98$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $650255c549a8fc98$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $650255c549a8fc98$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "acos", function () { return $650255c549a8fc98$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $650255c549a8fc98$export$41726bdb1fc63f; });
var $650255c549a8fc98$export$2335f513bbd82c6d = Math.abs;
var $650255c549a8fc98$export$b8b770ee6a0d9760 = Math.atan2;
var $650255c549a8fc98$export$50d414a77b60d802 = Math.cos;
var $650255c549a8fc98$export$8960430cfd85939f = Math.max;
var $650255c549a8fc98$export$96ec731ed4dcb222 = Math.min;
var $650255c549a8fc98$export$5de3937cb4b592ed = Math.sin;
var $650255c549a8fc98$export$eba8049fb5020b81 = Math.sqrt;
var $650255c549a8fc98$export$6c421550c66a327d = 1e-12;
var $650255c549a8fc98$export$18c7bea995a110f = Math.PI;
var $650255c549a8fc98$export$e51408a300e8929a = $650255c549a8fc98$export$18c7bea995a110f / 2;
var $650255c549a8fc98$export$a4b4b4d4d776fe92 = 2 * $650255c549a8fc98$export$18c7bea995a110f;
function $650255c549a8fc98$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $650255c549a8fc98$export$18c7bea995a110f : Math.acos(x);
}
function $650255c549a8fc98$export$41726bdb1fc63f(x) {
    return x >= 1 ? $650255c549a8fc98$export$e51408a300e8929a : x <= -1 ? -$650255c549a8fc98$export$e51408a300e8929a : Math.asin(x);
}

});


parcelRegister("6Ed0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d7091d45975a5d2$export$2e2bcd8739ae039; });

var $1qq3o = parcelRequire("1qq3o");

var $32MHn = parcelRequire("32MHn");

var $aUWvE = parcelRequire("aUWvE");
function $4d7091d45975a5d2$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$4d7091d45975a5d2$var$CatmullRomClosed.prototype = {
    areaStart: (0, $32MHn.default),
    areaEnd: (0, $32MHn.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $aUWvE.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4d7091d45975a5d2$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $4d7091d45975a5d2$var$CatmullRomClosed(context, alpha) : new (0, $1qq3o.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("hvYCW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc045c346efa7753$export$2e2bcd8739ae039; });

var $64Ae3 = parcelRequire("64Ae3");

var $aUWvE = parcelRequire("aUWvE");
function $cc045c346efa7753$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$cc045c346efa7753$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $aUWvE.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $cc045c346efa7753$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $cc045c346efa7753$var$CatmullRomOpen(context, alpha) : new (0, $64Ae3.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("ehI3a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a664d2a9da09595c$export$2e2bcd8739ae039; });
function $a664d2a9da09595c$var$Linear(context) {
    this._context = context;
}
$a664d2a9da09595c$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $a664d2a9da09595c$export$2e2bcd8739ae039(context) {
    return new $a664d2a9da09595c$var$Linear(context);
}

});

parcelRegister("8sVfw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $629d58c88e68631a$export$2e2bcd8739ae039; });

var $32MHn = parcelRequire("32MHn");
function $629d58c88e68631a$var$LinearClosed(context) {
    this._context = context;
}
$629d58c88e68631a$var$LinearClosed.prototype = {
    areaStart: (0, $32MHn.default),
    areaEnd: (0, $32MHn.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $629d58c88e68631a$export$2e2bcd8739ae039(context) {
    return new $629d58c88e68631a$var$LinearClosed(context);
}

});

parcelRegister("9yRsK", function(module, exports) {

$parcel$export(module.exports, "monotoneX", function () { return $6f60c29cd1ca3fc5$export$99563b5420dbdc55; });
$parcel$export(module.exports, "monotoneY", function () { return $6f60c29cd1ca3fc5$export$8b5360456d6bdb88; });
function $6f60c29cd1ca3fc5$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $6f60c29cd1ca3fc5$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($6f60c29cd1ca3fc5$var$sign(s0) + $6f60c29cd1ca3fc5$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $6f60c29cd1ca3fc5$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $6f60c29cd1ca3fc5$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $6f60c29cd1ca3fc5$var$MonotoneX(context) {
    this._context = context;
}
$6f60c29cd1ca3fc5$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $6f60c29cd1ca3fc5$var$point(this, this._t0, $6f60c29cd1ca3fc5$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $6f60c29cd1ca3fc5$var$point(this, $6f60c29cd1ca3fc5$var$slope2(this, t1 = $6f60c29cd1ca3fc5$var$slope3(this, x, y)), t1);
                break;
            default:
                $6f60c29cd1ca3fc5$var$point(this, this._t0, t1 = $6f60c29cd1ca3fc5$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $6f60c29cd1ca3fc5$var$MonotoneY(context) {
    this._context = new $6f60c29cd1ca3fc5$var$ReflectContext(context);
}
($6f60c29cd1ca3fc5$var$MonotoneY.prototype = Object.create($6f60c29cd1ca3fc5$var$MonotoneX.prototype)).point = function(x, y) {
    $6f60c29cd1ca3fc5$var$MonotoneX.prototype.point.call(this, y, x);
};
function $6f60c29cd1ca3fc5$var$ReflectContext(context) {
    this._context = context;
}
$6f60c29cd1ca3fc5$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $6f60c29cd1ca3fc5$export$99563b5420dbdc55(context) {
    return new $6f60c29cd1ca3fc5$var$MonotoneX(context);
}
function $6f60c29cd1ca3fc5$export$8b5360456d6bdb88(context) {
    return new $6f60c29cd1ca3fc5$var$MonotoneY(context);
}

});

parcelRegister("k2x2n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e96d9f1799a0b6a4$export$2e2bcd8739ae039; });
function $e96d9f1799a0b6a4$var$Natural(context) {
    this._context = context;
}
$e96d9f1799a0b6a4$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $e96d9f1799a0b6a4$var$controlPoints(x), py = $e96d9f1799a0b6a4$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $e96d9f1799a0b6a4$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $e96d9f1799a0b6a4$export$2e2bcd8739ae039(context) {
    return new $e96d9f1799a0b6a4$var$Natural(context);
}

});

parcelRegister("4vuYI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3482164e701e6911$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "stepBefore", function () { return $3482164e701e6911$export$10eafa5b7478b343; });
$parcel$export(module.exports, "stepAfter", function () { return $3482164e701e6911$export$793b3db073781cbb; });
function $3482164e701e6911$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$3482164e701e6911$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $3482164e701e6911$export$2e2bcd8739ae039(context) {
    return new $3482164e701e6911$var$Step(context, 0.5);
}
function $3482164e701e6911$export$10eafa5b7478b343(context) {
    return new $3482164e701e6911$var$Step(context, 0);
}
function $3482164e701e6911$export$793b3db073781cbb(context) {
    return new $3482164e701e6911$var$Step(context, 1);
}

});

parcelRegister("dMc4H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0791fda52764197$export$2e2bcd8739ae039; });
function $a0791fda52764197$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("8zZlU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63f12ef12d516481$export$2e2bcd8739ae039; });

var $cwhVc = parcelRequire("cwhVc");
function $63f12ef12d516481$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $cwhVc.default)(series, order);
}

});
parcelRegister("cwhVc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91d660115c61c003$export$2e2bcd8739ae039; });
function $91d660115c61c003$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});


parcelRegister("gw7Hy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0659bd95fb4cd6b$export$2e2bcd8739ae039; });

var $cwhVc = parcelRequire("cwhVc");
function $c0659bd95fb4cd6b$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $cwhVc.default)(series, order);
}

});

parcelRegister("66iM5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4711dde025558c58$export$2e2bcd8739ae039; });

var $cwhVc = parcelRequire("cwhVc");
function $4711dde025558c58$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $cwhVc.default)(series, order);
}

});

parcelRegister("7hdUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54c4e9c6502f8c54$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sum", function () { return $54c4e9c6502f8c54$export$8a63f25cc62965f1; });

var $7aiBf = parcelRequire("7aiBf");
function $54c4e9c6502f8c54$export$2e2bcd8739ae039(series) {
    var sums = series.map($54c4e9c6502f8c54$export$8a63f25cc62965f1);
    return (0, $7aiBf.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $54c4e9c6502f8c54$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});
parcelRegister("7aiBf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5377e51e9b935695$export$2e2bcd8739ae039; });
function $5377e51e9b935695$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("4Slcj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38cca5f830079d43$export$2e2bcd8739ae039; });

var $7hdUF = parcelRequire("7hdUF");
function $38cca5f830079d43$export$2e2bcd8739ae039(series) {
    return (0, $7hdUF.default)(series).reverse();
}

});

parcelRegister("fGh8D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6a812963f34c3ff$export$2e2bcd8739ae039; });

var $b2Gf5 = parcelRequire("b2Gf5");

var $7hdUF = parcelRequire("7hdUF");
function $b6a812963f34c3ff$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $7hdUF.sum)), order = (0, $b2Gf5.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});
parcelRegister("b2Gf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80a0a60fcea9dccc$export$2e2bcd8739ae039; });

var $7aiBf = parcelRequire("7aiBf");
function $80a0a60fcea9dccc$export$2e2bcd8739ae039(series) {
    var peaks = series.map($80a0a60fcea9dccc$var$peak);
    return (0, $7aiBf.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $80a0a60fcea9dccc$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});


parcelRegister("p47eF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b5873510e8bfc1$export$2e2bcd8739ae039; });

var $7aiBf = parcelRequire("7aiBf");
function $04b5873510e8bfc1$export$2e2bcd8739ae039(series) {
    return (0, $7aiBf.default)(series).reverse();
}

});

parcelRegister("2yNl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dd50737f6c427dd$export$2e2bcd8739ae039; });
function $1dd50737f6c427dd$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = (x0 * valueRight + x1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = (y0 * valueRight + y1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}

});

parcelRegister("7xMPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57e17dc6e06f8292$export$2e2bcd8739ae039; });
function $57e17dc6e06f8292$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}

});

parcelRegister("SYRXa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a54429e50ce1ed9$export$2e2bcd8739ae039; });

var $7xMPq = parcelRequire("7xMPq");

var $cAlSl = parcelRequire("cAlSl");

var $8eQwP = parcelRequire("8eQwP");
var $0a54429e50ce1ed9$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $7xMPq.default)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
                else (0, $cAlSl.default)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $8eQwP.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $8eQwP.phi));

});
parcelRegister("cAlSl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9299d0def22e89f0$export$2e2bcd8739ae039; });
function $9299d0def22e89f0$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}

});

parcelRegister("8eQwP", function(module, exports) {

$parcel$export(module.exports, "phi", function () { return $5ff86097382dc7b5$export$324943737027944a; });
$parcel$export(module.exports, "squarifyRatio", function () { return $5ff86097382dc7b5$export$9ff1217655212093; });
$parcel$export(module.exports, "default", function () { return $5ff86097382dc7b5$export$2e2bcd8739ae039; });

var $7xMPq = parcelRequire("7xMPq");

var $cAlSl = parcelRequire("cAlSl");
var $5ff86097382dc7b5$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $5ff86097382dc7b5$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $7xMPq.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $cAlSl.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $5ff86097382dc7b5$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $5ff86097382dc7b5$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($5ff86097382dc7b5$export$324943737027944a);

});


parcelRegister("2GHW9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f5195f6dabba9bf$export$2e2bcd8739ae039; });

var $7xMPq = parcelRequire("7xMPq");

var $cAlSl = parcelRequire("cAlSl");
function $1f5195f6dabba9bf$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $cAlSl.default) : (0, $7xMPq.default))(parent, x0, y0, x1, y1);
}

});

parcelRegister("hjBRw", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $c9b194ab2e8c93ff$export$d9468344d3651243; });

var $btVTA = parcelRequire("btVTA");
var $c9b194ab2e8c93ff$var$locale;
var $c9b194ab2e8c93ff$export$d9468344d3651243;
var $c9b194ab2e8c93ff$export$8d85692a469dde6f;
$c9b194ab2e8c93ff$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $c9b194ab2e8c93ff$export$2e2bcd8739ae039(definition) {
    $c9b194ab2e8c93ff$var$locale = (0, $btVTA.default)(definition);
    $c9b194ab2e8c93ff$export$d9468344d3651243 = $c9b194ab2e8c93ff$var$locale.format;
    $c9b194ab2e8c93ff$export$8d85692a469dde6f = $c9b194ab2e8c93ff$var$locale.formatPrefix;
    return $c9b194ab2e8c93ff$var$locale;
}

});
parcelRegister("btVTA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85bf500423b954e4$export$2e2bcd8739ae039; });

var $i8tdm = parcelRequire("i8tdm");

var $fW6C0 = parcelRequire("fW6C0");

var $7yups = parcelRequire("7yups");

var $3VB08 = parcelRequire("3VB08");

var $7ao0C = parcelRequire("7ao0C");

var $341Jv = parcelRequire("341Jv");

var $3qUnI = parcelRequire("3qUnI");

var $hx9rk = parcelRequire("hx9rk");
var $85bf500423b954e4$var$map = Array.prototype.map, $85bf500423b954e4$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $85bf500423b954e4$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $hx9rk.default) : (0, $fW6C0.default)($85bf500423b954e4$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $hx9rk.default) : (0, $7yups.default)($85bf500423b954e4$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $3VB08.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $341Jv.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $341Jv.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $7ao0C.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $85bf500423b954e4$var$prefixes[8 + (0, $3qUnI.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $3VB08.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $i8tdm.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $85bf500423b954e4$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("i8tdm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d33fa2be4e3ce906$export$2e2bcd8739ae039; });

var $f5VWt = parcelRequire("f5VWt");
function $d33fa2be4e3ce906$export$2e2bcd8739ae039(x) {
    return x = (0, $f5VWt.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("f5VWt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afd444c1d9f6fd43$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "formatDecimalParts", function () { return $afd444c1d9f6fd43$export$8f8e23dd27dc19f5; });
function $afd444c1d9f6fd43$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $afd444c1d9f6fd43$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("fW6C0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a166c8a14ac8c8$export$2e2bcd8739ae039; });
function $b9a166c8a14ac8c8$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("7yups", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58034c13b8a5bc96$export$2e2bcd8739ae039; });
function $58034c13b8a5bc96$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("3VB08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dc3659c37ea1b51$export$2e2bcd8739ae039; });
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $2dc3659c37ea1b51$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $2dc3659c37ea1b51$export$2e2bcd8739ae039(specifier) {
    if (!(match = $2dc3659c37ea1b51$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $2dc3659c37ea1b51$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$2dc3659c37ea1b51$export$2e2bcd8739ae039.prototype = $2dc3659c37ea1b51$export$963aac351db36ed4.prototype; // instanceof
function $2dc3659c37ea1b51$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$2dc3659c37ea1b51$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("7ao0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $537c173cb010749c$export$2e2bcd8739ae039; });
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $537c173cb010749c$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("341Jv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23b316eecb55db8f$export$2e2bcd8739ae039; });

var $f5VWt = parcelRequire("f5VWt");

var $3qUnI = parcelRequire("3qUnI");

var $8ajkD = parcelRequire("8ajkD");
var $23b316eecb55db8f$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $f5VWt.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $8ajkD.default)(x * 100, p);
    },
    "r": (0, $8ajkD.default),
    "s": (0, $3qUnI.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

});
parcelRegister("3qUnI", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", function () { return $27ff88ffdb2dd371$export$6863724d9a42263; });
$parcel$export(module.exports, "default", function () { return $27ff88ffdb2dd371$export$2e2bcd8739ae039; });

var $f5VWt = parcelRequire("f5VWt");
var $27ff88ffdb2dd371$export$6863724d9a42263;
function $27ff88ffdb2dd371$export$2e2bcd8739ae039(x, p) {
    var d = (0, $f5VWt.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($27ff88ffdb2dd371$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $f5VWt.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("8ajkD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f1e40d23ccc0b80$export$2e2bcd8739ae039; });

var $f5VWt = parcelRequire("f5VWt");
function $5f1e40d23ccc0b80$export$2e2bcd8739ae039(x, p) {
    var d = (0, $f5VWt.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("hx9rk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc3cd74785c4982b$export$2e2bcd8739ae039; });
function $cc3cd74785c4982b$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("7pj3L", function(module, exports) {

$parcel$export(module.exports, "timeFormat", function () { return $5649a711413a5733$export$94f4d87fad5dcf9a; });
$parcel$export(module.exports, "timeParse", function () { return $5649a711413a5733$export$32b9cd16e1b8c8d2; });
$parcel$export(module.exports, "utcFormat", function () { return $5649a711413a5733$export$1a08fe38f63ebbbb; });
$parcel$export(module.exports, "utcParse", function () { return $5649a711413a5733$export$3edae9cf8e233729; });

var $kJ6Bq = parcelRequire("kJ6Bq");
var $5649a711413a5733$var$locale;
var $5649a711413a5733$export$94f4d87fad5dcf9a;
var $5649a711413a5733$export$32b9cd16e1b8c8d2;
var $5649a711413a5733$export$1a08fe38f63ebbbb;
var $5649a711413a5733$export$3edae9cf8e233729;
$5649a711413a5733$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $5649a711413a5733$export$2e2bcd8739ae039(definition) {
    $5649a711413a5733$var$locale = (0, $kJ6Bq.default)(definition);
    $5649a711413a5733$export$94f4d87fad5dcf9a = $5649a711413a5733$var$locale.format;
    $5649a711413a5733$export$32b9cd16e1b8c8d2 = $5649a711413a5733$var$locale.parse;
    $5649a711413a5733$export$1a08fe38f63ebbbb = $5649a711413a5733$var$locale.utcFormat;
    $5649a711413a5733$export$3edae9cf8e233729 = $5649a711413a5733$var$locale.utcParse;
    return $5649a711413a5733$var$locale;
}

});
parcelRegister("kJ6Bq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f16d21c7015a1939$export$2e2bcd8739ae039; });

var $edjFq = parcelRequire("edjFq");
var $bb8fS = parcelRequire("bb8fS");
var $ifZP5 = parcelRequire("ifZP5");
var $dIjmu = parcelRequire("dIjmu");
var $fqF62 = parcelRequire("fqF62");
var $lvYzT = parcelRequire("lvYzT");
function $f16d21c7015a1939$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $f16d21c7015a1939$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $f16d21c7015a1939$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $f16d21c7015a1939$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $f16d21c7015a1939$var$formatRe(locale_periods), periodLookup = $f16d21c7015a1939$var$formatLookup(locale_periods), weekdayRe = $f16d21c7015a1939$var$formatRe(locale_weekdays), weekdayLookup = $f16d21c7015a1939$var$formatLookup(locale_weekdays), shortWeekdayRe = $f16d21c7015a1939$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $f16d21c7015a1939$var$formatLookup(locale_shortWeekdays), monthRe = $f16d21c7015a1939$var$formatRe(locale_months), monthLookup = $f16d21c7015a1939$var$formatLookup(locale_months), shortMonthRe = $f16d21c7015a1939$var$formatRe(locale_shortMonths), shortMonthLookup = $f16d21c7015a1939$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $f16d21c7015a1939$var$formatDayOfMonth,
        "e": $f16d21c7015a1939$var$formatDayOfMonth,
        "f": $f16d21c7015a1939$var$formatMicroseconds,
        "g": $f16d21c7015a1939$var$formatYearISO,
        "G": $f16d21c7015a1939$var$formatFullYearISO,
        "H": $f16d21c7015a1939$var$formatHour24,
        "I": $f16d21c7015a1939$var$formatHour12,
        "j": $f16d21c7015a1939$var$formatDayOfYear,
        "L": $f16d21c7015a1939$var$formatMilliseconds,
        "m": $f16d21c7015a1939$var$formatMonthNumber,
        "M": $f16d21c7015a1939$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $f16d21c7015a1939$var$formatUnixTimestamp,
        "s": $f16d21c7015a1939$var$formatUnixTimestampSeconds,
        "S": $f16d21c7015a1939$var$formatSeconds,
        "u": $f16d21c7015a1939$var$formatWeekdayNumberMonday,
        "U": $f16d21c7015a1939$var$formatWeekNumberSunday,
        "V": $f16d21c7015a1939$var$formatWeekNumberISO,
        "w": $f16d21c7015a1939$var$formatWeekdayNumberSunday,
        "W": $f16d21c7015a1939$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $f16d21c7015a1939$var$formatYear,
        "Y": $f16d21c7015a1939$var$formatFullYear,
        "Z": $f16d21c7015a1939$var$formatZone,
        "%": $f16d21c7015a1939$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $f16d21c7015a1939$var$formatUTCDayOfMonth,
        "e": $f16d21c7015a1939$var$formatUTCDayOfMonth,
        "f": $f16d21c7015a1939$var$formatUTCMicroseconds,
        "g": $f16d21c7015a1939$var$formatUTCYearISO,
        "G": $f16d21c7015a1939$var$formatUTCFullYearISO,
        "H": $f16d21c7015a1939$var$formatUTCHour24,
        "I": $f16d21c7015a1939$var$formatUTCHour12,
        "j": $f16d21c7015a1939$var$formatUTCDayOfYear,
        "L": $f16d21c7015a1939$var$formatUTCMilliseconds,
        "m": $f16d21c7015a1939$var$formatUTCMonthNumber,
        "M": $f16d21c7015a1939$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $f16d21c7015a1939$var$formatUnixTimestamp,
        "s": $f16d21c7015a1939$var$formatUnixTimestampSeconds,
        "S": $f16d21c7015a1939$var$formatUTCSeconds,
        "u": $f16d21c7015a1939$var$formatUTCWeekdayNumberMonday,
        "U": $f16d21c7015a1939$var$formatUTCWeekNumberSunday,
        "V": $f16d21c7015a1939$var$formatUTCWeekNumberISO,
        "w": $f16d21c7015a1939$var$formatUTCWeekdayNumberSunday,
        "W": $f16d21c7015a1939$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $f16d21c7015a1939$var$formatUTCYear,
        "Y": $f16d21c7015a1939$var$formatUTCFullYear,
        "Z": $f16d21c7015a1939$var$formatUTCZone,
        "%": $f16d21c7015a1939$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $f16d21c7015a1939$var$parseDayOfMonth,
        "e": $f16d21c7015a1939$var$parseDayOfMonth,
        "f": $f16d21c7015a1939$var$parseMicroseconds,
        "g": $f16d21c7015a1939$var$parseYear,
        "G": $f16d21c7015a1939$var$parseFullYear,
        "H": $f16d21c7015a1939$var$parseHour24,
        "I": $f16d21c7015a1939$var$parseHour24,
        "j": $f16d21c7015a1939$var$parseDayOfYear,
        "L": $f16d21c7015a1939$var$parseMilliseconds,
        "m": $f16d21c7015a1939$var$parseMonthNumber,
        "M": $f16d21c7015a1939$var$parseMinutes,
        "p": parsePeriod,
        "q": $f16d21c7015a1939$var$parseQuarter,
        "Q": $f16d21c7015a1939$var$parseUnixTimestamp,
        "s": $f16d21c7015a1939$var$parseUnixTimestampSeconds,
        "S": $f16d21c7015a1939$var$parseSeconds,
        "u": $f16d21c7015a1939$var$parseWeekdayNumberMonday,
        "U": $f16d21c7015a1939$var$parseWeekNumberSunday,
        "V": $f16d21c7015a1939$var$parseWeekNumberISO,
        "w": $f16d21c7015a1939$var$parseWeekdayNumberSunday,
        "W": $f16d21c7015a1939$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $f16d21c7015a1939$var$parseYear,
        "Y": $f16d21c7015a1939$var$parseFullYear,
        "Z": $f16d21c7015a1939$var$parseZone,
        "%": $f16d21c7015a1939$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $f16d21c7015a1939$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $f16d21c7015a1939$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $f16d21c7015a1939$var$utcDate($f16d21c7015a1939$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $fqF62.utcMonday).ceil(week) : (0, $fqF62.utcMonday)(week);
                    week = (0, $dIjmu.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $f16d21c7015a1939$var$localDate($f16d21c7015a1939$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $bb8fS.monday).ceil(week) : (0, $bb8fS.monday)(week);
                    week = (0, $edjFq.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $f16d21c7015a1939$var$utcDate($f16d21c7015a1939$var$newDate(d.y, 0, 1)).getUTCDay() : $f16d21c7015a1939$var$localDate($f16d21c7015a1939$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $f16d21c7015a1939$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $f16d21c7015a1939$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $f16d21c7015a1939$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $f16d21c7015a1939$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $f16d21c7015a1939$var$numberRe = /^\s*\d+/, $f16d21c7015a1939$var$percentRe = /^%/, $f16d21c7015a1939$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $f16d21c7015a1939$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $f16d21c7015a1939$var$requote(s) {
    return s.replace($f16d21c7015a1939$var$requoteRe, "\\$&");
}
function $f16d21c7015a1939$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($f16d21c7015a1939$var$requote).join("|") + ")", "i");
}
function $f16d21c7015a1939$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $f16d21c7015a1939$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseWeekNumberSunday(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseWeekNumberISO(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseWeekNumberMonday(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseFullYear(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseYear(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseQuarter(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseMonthNumber(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseDayOfMonth(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseDayOfYear(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseHour24(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseMinutes(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseSeconds(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseMilliseconds(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseMicroseconds(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseLiteralPercent(d, string, i) {
    var n = $f16d21c7015a1939$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $f16d21c7015a1939$var$parseUnixTimestamp(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $f16d21c7015a1939$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $f16d21c7015a1939$var$formatDayOfMonth(d, p) {
    return $f16d21c7015a1939$var$pad(d.getDate(), p, 2);
}
function $f16d21c7015a1939$var$formatHour24(d, p) {
    return $f16d21c7015a1939$var$pad(d.getHours(), p, 2);
}
function $f16d21c7015a1939$var$formatHour12(d, p) {
    return $f16d21c7015a1939$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $f16d21c7015a1939$var$formatDayOfYear(d, p) {
    return $f16d21c7015a1939$var$pad(1 + (0, $edjFq.default).count((0, $ifZP5.default)(d), d), p, 3);
}
function $f16d21c7015a1939$var$formatMilliseconds(d, p) {
    return $f16d21c7015a1939$var$pad(d.getMilliseconds(), p, 3);
}
function $f16d21c7015a1939$var$formatMicroseconds(d, p) {
    return $f16d21c7015a1939$var$formatMilliseconds(d, p) + "000";
}
function $f16d21c7015a1939$var$formatMonthNumber(d, p) {
    return $f16d21c7015a1939$var$pad(d.getMonth() + 1, p, 2);
}
function $f16d21c7015a1939$var$formatMinutes(d, p) {
    return $f16d21c7015a1939$var$pad(d.getMinutes(), p, 2);
}
function $f16d21c7015a1939$var$formatSeconds(d, p) {
    return $f16d21c7015a1939$var$pad(d.getSeconds(), p, 2);
}
function $f16d21c7015a1939$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $f16d21c7015a1939$var$formatWeekNumberSunday(d, p) {
    return $f16d21c7015a1939$var$pad((0, $bb8fS.sunday).count((0, $ifZP5.default)(d) - 1, d), p, 2);
}
function $f16d21c7015a1939$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $bb8fS.thursday)(d) : (0, $bb8fS.thursday).ceil(d);
}
function $f16d21c7015a1939$var$formatWeekNumberISO(d, p) {
    d = $f16d21c7015a1939$var$dISO(d);
    return $f16d21c7015a1939$var$pad((0, $bb8fS.thursday).count((0, $ifZP5.default)(d), d) + ((0, $ifZP5.default)(d).getDay() === 4), p, 2);
}
function $f16d21c7015a1939$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $f16d21c7015a1939$var$formatWeekNumberMonday(d, p) {
    return $f16d21c7015a1939$var$pad((0, $bb8fS.monday).count((0, $ifZP5.default)(d) - 1, d), p, 2);
}
function $f16d21c7015a1939$var$formatYear(d, p) {
    return $f16d21c7015a1939$var$pad(d.getFullYear() % 100, p, 2);
}
function $f16d21c7015a1939$var$formatYearISO(d, p) {
    d = $f16d21c7015a1939$var$dISO(d);
    return $f16d21c7015a1939$var$pad(d.getFullYear() % 100, p, 2);
}
function $f16d21c7015a1939$var$formatFullYear(d, p) {
    return $f16d21c7015a1939$var$pad(d.getFullYear() % 10000, p, 4);
}
function $f16d21c7015a1939$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $bb8fS.thursday)(d) : (0, $bb8fS.thursday).ceil(d);
    return $f16d21c7015a1939$var$pad(d.getFullYear() % 10000, p, 4);
}
function $f16d21c7015a1939$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $f16d21c7015a1939$var$pad(z / 60 | 0, "0", 2) + $f16d21c7015a1939$var$pad(z % 60, "0", 2);
}
function $f16d21c7015a1939$var$formatUTCDayOfMonth(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCDate(), p, 2);
}
function $f16d21c7015a1939$var$formatUTCHour24(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCHours(), p, 2);
}
function $f16d21c7015a1939$var$formatUTCHour12(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $f16d21c7015a1939$var$formatUTCDayOfYear(d, p) {
    return $f16d21c7015a1939$var$pad(1 + (0, $dIjmu.default).count((0, $lvYzT.default)(d), d), p, 3);
}
function $f16d21c7015a1939$var$formatUTCMilliseconds(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $f16d21c7015a1939$var$formatUTCMicroseconds(d, p) {
    return $f16d21c7015a1939$var$formatUTCMilliseconds(d, p) + "000";
}
function $f16d21c7015a1939$var$formatUTCMonthNumber(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $f16d21c7015a1939$var$formatUTCMinutes(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCMinutes(), p, 2);
}
function $f16d21c7015a1939$var$formatUTCSeconds(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCSeconds(), p, 2);
}
function $f16d21c7015a1939$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $f16d21c7015a1939$var$formatUTCWeekNumberSunday(d, p) {
    return $f16d21c7015a1939$var$pad((0, $fqF62.utcSunday).count((0, $lvYzT.default)(d) - 1, d), p, 2);
}
function $f16d21c7015a1939$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $fqF62.utcThursday)(d) : (0, $fqF62.utcThursday).ceil(d);
}
function $f16d21c7015a1939$var$formatUTCWeekNumberISO(d, p) {
    d = $f16d21c7015a1939$var$UTCdISO(d);
    return $f16d21c7015a1939$var$pad((0, $fqF62.utcThursday).count((0, $lvYzT.default)(d), d) + ((0, $lvYzT.default)(d).getUTCDay() === 4), p, 2);
}
function $f16d21c7015a1939$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $f16d21c7015a1939$var$formatUTCWeekNumberMonday(d, p) {
    return $f16d21c7015a1939$var$pad((0, $fqF62.utcMonday).count((0, $lvYzT.default)(d) - 1, d), p, 2);
}
function $f16d21c7015a1939$var$formatUTCYear(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $f16d21c7015a1939$var$formatUTCYearISO(d, p) {
    d = $f16d21c7015a1939$var$UTCdISO(d);
    return $f16d21c7015a1939$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $f16d21c7015a1939$var$formatUTCFullYear(d, p) {
    return $f16d21c7015a1939$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $f16d21c7015a1939$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $fqF62.utcThursday)(d) : (0, $fqF62.utcThursday).ceil(d);
    return $f16d21c7015a1939$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $f16d21c7015a1939$var$formatUTCZone() {
    return "+0000";
}
function $f16d21c7015a1939$var$formatLiteralPercent() {
    return "%";
}
function $f16d21c7015a1939$var$formatUnixTimestamp(d) {
    return +d;
}
function $f16d21c7015a1939$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});
parcelRegister("edjFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a591890c12a452af$export$2e2bcd8739ae039; });

var $5LF6I = parcelRequire("5LF6I");

var $f3HgA = parcelRequire("f3HgA");
var $a591890c12a452af$var$day = (0, $5LF6I.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $f3HgA.durationMinute)) / (0, $f3HgA.durationDay), (date)=>date.getDate() - 1);
var $a591890c12a452af$export$2e2bcd8739ae039 = $a591890c12a452af$var$day;
var $a591890c12a452af$export$3cf5dda4201cc0f2 = $a591890c12a452af$var$day.range;

});
parcelRegister("5LF6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43313a9b9e00d326$export$2e2bcd8739ae039; });
var $43313a9b9e00d326$var$t0 = new Date, $43313a9b9e00d326$var$t1 = new Date;
function $43313a9b9e00d326$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $43313a9b9e00d326$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $43313a9b9e00d326$var$t0.setTime(+start), $43313a9b9e00d326$var$t1.setTime(+end);
            floori($43313a9b9e00d326$var$t0), floori($43313a9b9e00d326$var$t1);
            return Math.floor(count($43313a9b9e00d326$var$t0, $43313a9b9e00d326$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("f3HgA", function(module, exports) {

$parcel$export(module.exports, "durationMinute", function () { return $af68b2a6f99622bd$export$683905d551c33fa9; });
$parcel$export(module.exports, "durationDay", function () { return $af68b2a6f99622bd$export$353686095f4fbf45; });
$parcel$export(module.exports, "durationWeek", function () { return $af68b2a6f99622bd$export$c241eb88520d5016; });
const $af68b2a6f99622bd$export$79ef0e34099623dc = 1000;
const $af68b2a6f99622bd$export$683905d551c33fa9 = $af68b2a6f99622bd$export$79ef0e34099623dc * 60;
const $af68b2a6f99622bd$export$4157bf0c8e241659 = $af68b2a6f99622bd$export$683905d551c33fa9 * 60;
const $af68b2a6f99622bd$export$353686095f4fbf45 = $af68b2a6f99622bd$export$4157bf0c8e241659 * 24;
const $af68b2a6f99622bd$export$c241eb88520d5016 = $af68b2a6f99622bd$export$353686095f4fbf45 * 7;
const $af68b2a6f99622bd$export$ab95684df7020b26 = $af68b2a6f99622bd$export$353686095f4fbf45 * 30;
const $af68b2a6f99622bd$export$61f8ee2d834c6959 = $af68b2a6f99622bd$export$353686095f4fbf45 * 365;

});


parcelRegister("bb8fS", function(module, exports) {

$parcel$export(module.exports, "sunday", function () { return $82372018cf0a5a7c$export$fb3ee18ed410cc21; });
$parcel$export(module.exports, "monday", function () { return $82372018cf0a5a7c$export$6416afaab03bc9b8; });
$parcel$export(module.exports, "thursday", function () { return $82372018cf0a5a7c$export$2f2b56683a3e5629; });

var $5LF6I = parcelRequire("5LF6I");

var $f3HgA = parcelRequire("f3HgA");
function $82372018cf0a5a7c$var$weekday(i) {
    return (0, $5LF6I.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $f3HgA.durationMinute)) / (0, $f3HgA.durationWeek);
    });
}
var $82372018cf0a5a7c$export$fb3ee18ed410cc21 = $82372018cf0a5a7c$var$weekday(0);
var $82372018cf0a5a7c$export$6416afaab03bc9b8 = $82372018cf0a5a7c$var$weekday(1);
var $82372018cf0a5a7c$export$cb8f040f5d17ac7b = $82372018cf0a5a7c$var$weekday(2);
var $82372018cf0a5a7c$export$347581849975dfc8 = $82372018cf0a5a7c$var$weekday(3);
var $82372018cf0a5a7c$export$2f2b56683a3e5629 = $82372018cf0a5a7c$var$weekday(4);
var $82372018cf0a5a7c$export$59b8c2ccd931d806 = $82372018cf0a5a7c$var$weekday(5);
var $82372018cf0a5a7c$export$478ceadebff4d377 = $82372018cf0a5a7c$var$weekday(6);
var $82372018cf0a5a7c$export$e8daabaa40641211 = $82372018cf0a5a7c$export$fb3ee18ed410cc21.range;
var $82372018cf0a5a7c$export$74e5b559c235c00e = $82372018cf0a5a7c$export$6416afaab03bc9b8.range;
var $82372018cf0a5a7c$export$e7d6aa4fb107bc56 = $82372018cf0a5a7c$export$cb8f040f5d17ac7b.range;
var $82372018cf0a5a7c$export$fcd5880b20bb06a8 = $82372018cf0a5a7c$export$347581849975dfc8.range;
var $82372018cf0a5a7c$export$682716b7bbe33641 = $82372018cf0a5a7c$export$2f2b56683a3e5629.range;
var $82372018cf0a5a7c$export$482924968ca86084 = $82372018cf0a5a7c$export$59b8c2ccd931d806.range;
var $82372018cf0a5a7c$export$7d755172c9cda9d2 = $82372018cf0a5a7c$export$478ceadebff4d377.range;

});

parcelRegister("ifZP5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a9957d204e6a2f$export$2e2bcd8739ae039; });

var $5LF6I = parcelRequire("5LF6I");
var $d4a9957d204e6a2f$var$year = (0, $5LF6I.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$d4a9957d204e6a2f$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $5LF6I.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $d4a9957d204e6a2f$export$2e2bcd8739ae039 = $d4a9957d204e6a2f$var$year;
var $d4a9957d204e6a2f$export$6fda41c7fb23acf9 = $d4a9957d204e6a2f$var$year.range;

});

parcelRegister("dIjmu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fbe674137658393$export$2e2bcd8739ae039; });

var $5LF6I = parcelRequire("5LF6I");

var $f3HgA = parcelRequire("f3HgA");
var $9fbe674137658393$var$utcDay = (0, $5LF6I.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $f3HgA.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $9fbe674137658393$export$2e2bcd8739ae039 = $9fbe674137658393$var$utcDay;
var $9fbe674137658393$export$d277e198508549a1 = $9fbe674137658393$var$utcDay.range;

});

parcelRegister("fqF62", function(module, exports) {

$parcel$export(module.exports, "utcSunday", function () { return $b3b929a0a47c916b$export$4898b06303a92011; });
$parcel$export(module.exports, "utcMonday", function () { return $b3b929a0a47c916b$export$9cfc53b9cfafd080; });
$parcel$export(module.exports, "utcThursday", function () { return $b3b929a0a47c916b$export$1db08111baec2f53; });

var $5LF6I = parcelRequire("5LF6I");

var $f3HgA = parcelRequire("f3HgA");
function $b3b929a0a47c916b$var$utcWeekday(i) {
    return (0, $5LF6I.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $f3HgA.durationWeek);
    });
}
var $b3b929a0a47c916b$export$4898b06303a92011 = $b3b929a0a47c916b$var$utcWeekday(0);
var $b3b929a0a47c916b$export$9cfc53b9cfafd080 = $b3b929a0a47c916b$var$utcWeekday(1);
var $b3b929a0a47c916b$export$2a6d545f77eceb15 = $b3b929a0a47c916b$var$utcWeekday(2);
var $b3b929a0a47c916b$export$a5c25d8ed64433c4 = $b3b929a0a47c916b$var$utcWeekday(3);
var $b3b929a0a47c916b$export$1db08111baec2f53 = $b3b929a0a47c916b$var$utcWeekday(4);
var $b3b929a0a47c916b$export$29265e34dd5921f7 = $b3b929a0a47c916b$var$utcWeekday(5);
var $b3b929a0a47c916b$export$85b74dad05049604 = $b3b929a0a47c916b$var$utcWeekday(6);
var $b3b929a0a47c916b$export$6f3e1c2b0f7d7880 = $b3b929a0a47c916b$export$4898b06303a92011.range;
var $b3b929a0a47c916b$export$1d2d8b858bb366f9 = $b3b929a0a47c916b$export$9cfc53b9cfafd080.range;
var $b3b929a0a47c916b$export$1d5f6785fc7f30f8 = $b3b929a0a47c916b$export$2a6d545f77eceb15.range;
var $b3b929a0a47c916b$export$7a75faf0e37ef4af = $b3b929a0a47c916b$export$a5c25d8ed64433c4.range;
var $b3b929a0a47c916b$export$417eb959611b2f2f = $b3b929a0a47c916b$export$1db08111baec2f53.range;
var $b3b929a0a47c916b$export$59d308db7af08c64 = $b3b929a0a47c916b$export$29265e34dd5921f7.range;
var $b3b929a0a47c916b$export$a124108a0a7f34c8 = $b3b929a0a47c916b$export$85b74dad05049604.range;

});

parcelRegister("lvYzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa9b7bbd9eab3cae$export$2e2bcd8739ae039; });

var $5LF6I = parcelRequire("5LF6I");
var $fa9b7bbd9eab3cae$var$utcYear = (0, $5LF6I.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$fa9b7bbd9eab3cae$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $5LF6I.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $fa9b7bbd9eab3cae$export$2e2bcd8739ae039 = $fa9b7bbd9eab3cae$var$utcYear;
var $fa9b7bbd9eab3cae$export$3e24d311e17f5802 = $fa9b7bbd9eab3cae$var$utcYear.range;

});



parcelRegister("ejIWb", function(module, exports) {

$parcel$export(module.exports, "compose", function () { return $a6c5b2b018aec4d3$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "withPropsOnChange", function () { return $a6c5b2b018aec4d3$export$6bb05b1ab09a4158; });
$parcel$export(module.exports, "defaultProps", function () { return $a6c5b2b018aec4d3$export$9c21a3269931e1e6; });
$parcel$export(module.exports, "setPropTypes", function () { return $a6c5b2b018aec4d3$export$3f05a82d2bb032cc; });

var $70fFQ = parcelRequire("70fFQ");

var $h6JIp = parcelRequire("h6JIp");
var $a6c5b2b018aec4d3$export$be63e0664592e141 = function getDisplayName(component) {
    if (typeof component === "string") return component;
    if (!component) return undefined;
    return component.displayName || component.name || "Component";
};
var $a6c5b2b018aec4d3$export$b7c688f26e0b9b7c = function setStatic(key, value) {
    return function(BaseComponent) {
        BaseComponent[key] = value;
        return BaseComponent;
    };
};
var $a6c5b2b018aec4d3$export$ce7d0f83c324f6cf = function setDisplayName(displayName) {
    return $a6c5b2b018aec4d3$export$b7c688f26e0b9b7c("displayName", displayName);
};
var $a6c5b2b018aec4d3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $a6c5b2b018aec4d3$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    return x !== x && y !== y;
}
function $a6c5b2b018aec4d3$export$d36bdfa510afb180(objA, objB) {
    if ($a6c5b2b018aec4d3$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$a6c5b2b018aec4d3$var$hasOwnProperty.call(objB, keysA[i]) || !$a6c5b2b018aec4d3$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $a6c5b2b018aec4d3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a6c5b2b018aec4d3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a6c5b2b018aec4d3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a6c5b2b018aec4d3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a6c5b2b018aec4d3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a6c5b2b018aec4d3$var$_setPrototypeOf(o, p) {
    $a6c5b2b018aec4d3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a6c5b2b018aec4d3$var$_setPrototypeOf(o, p);
}
function $a6c5b2b018aec4d3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a6c5b2b018aec4d3$var$_setPrototypeOf(subClass, superClass);
}
function $a6c5b2b018aec4d3$var$_getPrototypeOf(o) {
    $a6c5b2b018aec4d3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a6c5b2b018aec4d3$var$_getPrototypeOf(o);
}
function $a6c5b2b018aec4d3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a6c5b2b018aec4d3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a6c5b2b018aec4d3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a6c5b2b018aec4d3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a6c5b2b018aec4d3$var$_typeof(obj);
}
function $a6c5b2b018aec4d3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a6c5b2b018aec4d3$var$_possibleConstructorReturn(self, call) {
    if (call && ($a6c5b2b018aec4d3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a6c5b2b018aec4d3$var$_assertThisInitialized(self);
}
function $a6c5b2b018aec4d3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a6c5b2b018aec4d3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a6c5b2b018aec4d3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a6c5b2b018aec4d3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a6c5b2b018aec4d3$var$_possibleConstructorReturn(this, result);
    };
}
var $a6c5b2b018aec4d3$export$234d6aee19c01743 = function wrapDisplayName(BaseComponent, hocName) {
    return "".concat(hocName, "(").concat($a6c5b2b018aec4d3$export$be63e0664592e141(BaseComponent), ")");
};
var $a6c5b2b018aec4d3$export$ea8391e230935df = function shouldUpdate(test) {
    return function(BaseComponent) {
        var factory = (0, $70fFQ.createFactory)(BaseComponent);
        var ShouldUpdate = function(_Component) {
            $a6c5b2b018aec4d3$var$_inherits(ShouldUpdate, _Component);
            var _super = $a6c5b2b018aec4d3$var$_createSuper(ShouldUpdate);
            function ShouldUpdate() {
                $a6c5b2b018aec4d3$var$_classCallCheck(this, ShouldUpdate);
                return _super.apply(this, arguments);
            }
            $a6c5b2b018aec4d3$var$_createClass(ShouldUpdate, [
                {
                    key: "shouldComponentUpdate",
                    value: function shouldComponentUpdate(nextProps) {
                        return test(this.props, nextProps);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        return factory(this.props);
                    }
                }
            ]);
            return ShouldUpdate;
        }((0, $70fFQ.Component));
        return ShouldUpdate;
    };
};
var $a6c5b2b018aec4d3$export$48ec4a2b1cfc6557 = function pure(component) {
    var hoc = $a6c5b2b018aec4d3$export$ea8391e230935df(function(props, nextProps) {
        return !$a6c5b2b018aec4d3$export$d36bdfa510afb180(props, nextProps);
    });
    return hoc(component);
};
var $a6c5b2b018aec4d3$export$f672e0b6f7222cd7 = function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    }, function(arg) {
        return arg;
    });
};
function $a6c5b2b018aec4d3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a6c5b2b018aec4d3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a6c5b2b018aec4d3$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a6c5b2b018aec4d3$var$ownKeys(Object(source), true).forEach(function(key) {
            $a6c5b2b018aec4d3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a6c5b2b018aec4d3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a6c5b2b018aec4d3$var$pick = function pick(obj, keys) {
    var result = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (obj.hasOwnProperty(key)) result[key] = obj[key];
    }
    return result;
};
var $a6c5b2b018aec4d3$export$6bb05b1ab09a4158 = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
    return function(BaseComponent) {
        var factory = (0, $70fFQ.createFactory)(BaseComponent);
        var shouldMap = typeof shouldMapOrKeys === "function" ? shouldMapOrKeys : function(props, nextProps) {
            return !$a6c5b2b018aec4d3$export$d36bdfa510afb180($a6c5b2b018aec4d3$var$pick(props, shouldMapOrKeys), $a6c5b2b018aec4d3$var$pick(nextProps, shouldMapOrKeys));
        };
        var WithPropsOnChange = function(_Component) {
            $a6c5b2b018aec4d3$var$_inherits(WithPropsOnChange, _Component);
            var _super = $a6c5b2b018aec4d3$var$_createSuper(WithPropsOnChange);
            function WithPropsOnChange() {
                var _this;
                $a6c5b2b018aec4d3$var$_classCallCheck(this, WithPropsOnChange);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _super.call.apply(_super, [
                    this
                ].concat(args));
                _this.state = {
                    computedProps: propsMapper(_this.props),
                    prevProps: _this.props
                };
                return _this;
            }
            $a6c5b2b018aec4d3$var$_createClass(WithPropsOnChange, [
                {
                    key: "render",
                    value: function render() {
                        return factory($a6c5b2b018aec4d3$var$_objectSpread2($a6c5b2b018aec4d3$var$_objectSpread2({}, this.props), this.state.computedProps));
                    }
                }
            ], [
                {
                    key: "getDerivedStateFromProps",
                    value: function getDerivedStateFromProps(nextProps, prevState) {
                        if (shouldMap(prevState.prevProps, nextProps)) return {
                            computedProps: propsMapper(nextProps),
                            prevProps: nextProps
                        };
                        return {
                            prevProps: nextProps
                        };
                    }
                }
            ]);
            return WithPropsOnChange;
        }((0, $70fFQ.Component));
        (0, $h6JIp.polyfill)(WithPropsOnChange);
        return WithPropsOnChange;
    };
};
var $a6c5b2b018aec4d3$export$9c21a3269931e1e6 = function defaultProps(props) {
    return function(BaseComponent) {
        var factory = (0, $70fFQ.createFactory)(BaseComponent);
        var DefaultProps = function DefaultProps(ownerProps) {
            return factory(ownerProps);
        };
        DefaultProps.defaultProps = props;
        return DefaultProps;
    };
};
var $a6c5b2b018aec4d3$var$mapProps = function mapProps(propsMapper) {
    return function(BaseComponent) {
        var factory = (0, $70fFQ.createFactory)(BaseComponent);
        var MapProps = function MapProps(props) {
            return factory(propsMapper(props));
        };
        return MapProps;
    };
};
var $a6c5b2b018aec4d3$export$19c55c6cefb3b57 = function withProps(createProps) {
    var hoc = $a6c5b2b018aec4d3$var$mapProps(function(props) {
        return $a6c5b2b018aec4d3$var$_objectSpread2($a6c5b2b018aec4d3$var$_objectSpread2({}, props), typeof createProps === "function" ? createProps(props) : createProps);
    });
    return hoc;
};
var $a6c5b2b018aec4d3$export$3f05a82d2bb032cc = function setPropTypes(propTypes) {
    return $a6c5b2b018aec4d3$export$b7c688f26e0b9b7c("propTypes", propTypes);
};
var $a6c5b2b018aec4d3$export$29d22fcef0a54f1b = function withState(stateName, stateUpdaterName, initialState) {
    return function(BaseComponent) {
        var factory = (0, $70fFQ.createFactory)(BaseComponent);
        var WithState = function(_Component) {
            $a6c5b2b018aec4d3$var$_inherits(WithState, _Component);
            var _super = $a6c5b2b018aec4d3$var$_createSuper(WithState);
            function WithState() {
                var _this;
                $a6c5b2b018aec4d3$var$_classCallCheck(this, WithState);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _super.call.apply(_super, [
                    this
                ].concat(args));
                _this.state = {
                    stateValue: typeof initialState === "function" ? initialState(_this.props) : initialState
                };
                _this.updateStateValue = function(updateFn, callback) {
                    return _this.setState(function(_ref) {
                        var stateValue = _ref.stateValue;
                        return {
                            stateValue: typeof updateFn === "function" ? updateFn(stateValue) : updateFn
                        };
                    }, callback);
                };
                return _this;
            }
            $a6c5b2b018aec4d3$var$_createClass(WithState, [
                {
                    key: "render",
                    value: function render() {
                        var _objectSpread2$1;
                        return factory($a6c5b2b018aec4d3$var$_objectSpread2($a6c5b2b018aec4d3$var$_objectSpread2({}, this.props), {}, (_objectSpread2$1 = {}, $a6c5b2b018aec4d3$var$_defineProperty(_objectSpread2$1, stateName, this.state.stateValue), $a6c5b2b018aec4d3$var$_defineProperty(_objectSpread2$1, stateUpdaterName, this.updateStateValue), _objectSpread2$1)));
                    }
                }
            ]);
            return WithState;
        }((0, $70fFQ.Component));
        return WithState;
    };
};

});
parcelRegister("h6JIp", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $c7467548cdf961da$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c7467548cdf961da$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c7467548cdf961da$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c7467548cdf961da$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c7467548cdf961da$var$componentWillMount.__suppressDeprecationWarning = true;
$c7467548cdf961da$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c7467548cdf961da$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c7467548cdf961da$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c7467548cdf961da$var$componentWillMount;
        prototype.componentWillReceiveProps = $c7467548cdf961da$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c7467548cdf961da$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});


parcelRegister("1sXdz", function(module, exports) {

var $1WB09 = parcelRequire("1WB09");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $111657697df9c236$var$isEqual(value, other) {
    return $1WB09(value, other);
}
module.exports = $111657697df9c236$var$isEqual;

});
parcelRegister("1WB09", function(module, exports) {

var $gCf9v = parcelRequire("gCf9v");

var $ftx1W = parcelRequire("ftx1W");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $16a7e8ecdf0d141c$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$ftx1W(value) && !$ftx1W(other)) return value !== value && other !== other;
    return $gCf9v(value, other, bitmask, customizer, $16a7e8ecdf0d141c$var$baseIsEqual, stack);
}
module.exports = $16a7e8ecdf0d141c$var$baseIsEqual;

});
parcelRegister("gCf9v", function(module, exports) {

var $ghuvx = parcelRequire("ghuvx");

var $3gOoB = parcelRequire("3gOoB");

var $fxpd1 = parcelRequire("fxpd1");

var $g0GZi = parcelRequire("g0GZi");

var $jUKMk = parcelRequire("jUKMk");

var $ioays = parcelRequire("ioays");

var $3BSWT = parcelRequire("3BSWT");

var $kheMX = parcelRequire("kheMX");
/** Used to compose bitmasks for value comparisons. */ var $c18bf2e37bd99660$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c18bf2e37bd99660$var$argsTag = "[object Arguments]", $c18bf2e37bd99660$var$arrayTag = "[object Array]", $c18bf2e37bd99660$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c18bf2e37bd99660$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c18bf2e37bd99660$var$hasOwnProperty = $c18bf2e37bd99660$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c18bf2e37bd99660$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $ioays(object), othIsArr = $ioays(other), objTag = objIsArr ? $c18bf2e37bd99660$var$arrayTag : $jUKMk(object), othTag = othIsArr ? $c18bf2e37bd99660$var$arrayTag : $jUKMk(other);
    objTag = objTag == $c18bf2e37bd99660$var$argsTag ? $c18bf2e37bd99660$var$objectTag : objTag;
    othTag = othTag == $c18bf2e37bd99660$var$argsTag ? $c18bf2e37bd99660$var$objectTag : othTag;
    var objIsObj = objTag == $c18bf2e37bd99660$var$objectTag, othIsObj = othTag == $c18bf2e37bd99660$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $3BSWT(object)) {
        if (!$3BSWT(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $ghuvx);
        return objIsArr || $kheMX(object) ? $3gOoB(object, other, bitmask, customizer, equalFunc, stack) : $fxpd1(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c18bf2e37bd99660$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c18bf2e37bd99660$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $c18bf2e37bd99660$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $ghuvx);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $ghuvx);
    return $g0GZi(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $c18bf2e37bd99660$var$baseIsEqualDeep;

});
parcelRegister("3gOoB", function(module, exports) {

var $4XyaN = parcelRequire("4XyaN");

var $hotRf = parcelRequire("hotRf");

var $kDnhx = parcelRequire("kDnhx");
/** Used to compose bitmasks for value comparisons. */ var $2619f547e37ebc38$var$COMPARE_PARTIAL_FLAG = 1, $2619f547e37ebc38$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $2619f547e37ebc38$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2619f547e37ebc38$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $2619f547e37ebc38$var$COMPARE_UNORDERED_FLAG ? new $4XyaN : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$hotRf(other, function(othValue, othIndex) {
                if (!$kDnhx(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $2619f547e37ebc38$var$equalArrays;

});
parcelRegister("hotRf", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $ca9bd6b87186eb52$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $ca9bd6b87186eb52$var$arraySome;

});


parcelRegister("fxpd1", function(module, exports) {

var $kZpX4 = parcelRequire("kZpX4");

var $gu1aG = parcelRequire("gu1aG");

var $aCDT6 = parcelRequire("aCDT6");

var $3gOoB = parcelRequire("3gOoB");

var $1WPJB = parcelRequire("1WPJB");

var $fK3G0 = parcelRequire("fK3G0");
/** Used to compose bitmasks for value comparisons. */ var $b4fd7e160a5fe088$var$COMPARE_PARTIAL_FLAG = 1, $b4fd7e160a5fe088$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $b4fd7e160a5fe088$var$boolTag = "[object Boolean]", $b4fd7e160a5fe088$var$dateTag = "[object Date]", $b4fd7e160a5fe088$var$errorTag = "[object Error]", $b4fd7e160a5fe088$var$mapTag = "[object Map]", $b4fd7e160a5fe088$var$numberTag = "[object Number]", $b4fd7e160a5fe088$var$regexpTag = "[object RegExp]", $b4fd7e160a5fe088$var$setTag = "[object Set]", $b4fd7e160a5fe088$var$stringTag = "[object String]", $b4fd7e160a5fe088$var$symbolTag = "[object Symbol]";
var $b4fd7e160a5fe088$var$arrayBufferTag = "[object ArrayBuffer]", $b4fd7e160a5fe088$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $b4fd7e160a5fe088$var$symbolProto = $kZpX4 ? $kZpX4.prototype : undefined, $b4fd7e160a5fe088$var$symbolValueOf = $b4fd7e160a5fe088$var$symbolProto ? $b4fd7e160a5fe088$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b4fd7e160a5fe088$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $b4fd7e160a5fe088$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $b4fd7e160a5fe088$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $gu1aG(object), new $gu1aG(other))) return false;
            return true;
        case $b4fd7e160a5fe088$var$boolTag:
        case $b4fd7e160a5fe088$var$dateTag:
        case $b4fd7e160a5fe088$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $aCDT6(+object, +other);
        case $b4fd7e160a5fe088$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $b4fd7e160a5fe088$var$regexpTag:
        case $b4fd7e160a5fe088$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $b4fd7e160a5fe088$var$mapTag:
            var convert = $1WPJB;
        case $b4fd7e160a5fe088$var$setTag:
            var isPartial = bitmask & $b4fd7e160a5fe088$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $fK3G0);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $b4fd7e160a5fe088$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $3gOoB(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $b4fd7e160a5fe088$var$symbolTag:
            if ($b4fd7e160a5fe088$var$symbolValueOf) return $b4fd7e160a5fe088$var$symbolValueOf.call(object) == $b4fd7e160a5fe088$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $b4fd7e160a5fe088$var$equalByTag;

});
parcelRegister("1WPJB", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $16b356a1ab33c668$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $16b356a1ab33c668$var$mapToArray;

});

parcelRegister("fK3G0", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b75e00fb3e1ccbc5$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $b75e00fb3e1ccbc5$var$setToArray;

});


parcelRegister("g0GZi", function(module, exports) {

var $516p4 = parcelRequire("516p4");
/** Used to compose bitmasks for value comparisons. */ var $ba7dfde62566621c$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ba7dfde62566621c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ba7dfde62566621c$var$hasOwnProperty = $ba7dfde62566621c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ba7dfde62566621c$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ba7dfde62566621c$var$COMPARE_PARTIAL_FLAG, objProps = $516p4(object), objLength = objProps.length, othProps = $516p4(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ba7dfde62566621c$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $ba7dfde62566621c$var$equalObjects;

});
parcelRegister("516p4", function(module, exports) {

var $4rp0Y = parcelRequire("4rp0Y");

var $izSm5 = parcelRequire("izSm5");

var $6R8Bb = parcelRequire("6R8Bb");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3a72034ee8b2b45e$var$getAllKeys(object) {
    return $4rp0Y(object, $6R8Bb, $izSm5);
}
module.exports = $3a72034ee8b2b45e$var$getAllKeys;

});
parcelRegister("4rp0Y", function(module, exports) {

var $b9oe2 = parcelRequire("b9oe2");

var $ioays = parcelRequire("ioays");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $33bd166d08050dc2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $ioays(object) ? result : $b9oe2(result, symbolsFunc(object));
}
module.exports = $33bd166d08050dc2$var$baseGetAllKeys;

});
parcelRegister("b9oe2", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $81e353a80308284e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $81e353a80308284e$var$arrayPush;

});


parcelRegister("izSm5", function(module, exports) {

var $8s3O9 = parcelRequire("8s3O9");

var $hcLFi = parcelRequire("hcLFi");
/** Used for built-in method references. */ var $d865a8b79e71b46c$var$objectProto = Object.prototype;
/** Built-in value references. */ var $d865a8b79e71b46c$var$propertyIsEnumerable = $d865a8b79e71b46c$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d865a8b79e71b46c$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d865a8b79e71b46c$var$getSymbols = !$d865a8b79e71b46c$var$nativeGetSymbols ? $hcLFi : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8s3O9($d865a8b79e71b46c$var$nativeGetSymbols(object), function(symbol) {
        return $d865a8b79e71b46c$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $d865a8b79e71b46c$var$getSymbols;

});
parcelRegister("8s3O9", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6273e468f3150820$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6273e468f3150820$var$arrayFilter;

});

parcelRegister("hcLFi", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $c86887ef6f23aebf$var$stubArray() {
    return [];
}
module.exports = $c86887ef6f23aebf$var$stubArray;

});


parcelRegister("6R8Bb", function(module, exports) {

var $fPFzB = parcelRequire("fPFzB");

var $hh79K = parcelRequire("hh79K");

var $79oK4 = parcelRequire("79oK4");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $4fde5cd5c5e231b9$var$keys(object) {
    return $79oK4(object) ? $fPFzB(object) : $hh79K(object);
}
module.exports = $4fde5cd5c5e231b9$var$keys;

});
parcelRegister("hh79K", function(module, exports) {

var $1c8Xi = parcelRequire("1c8Xi");

var $hBFnZ = parcelRequire("hBFnZ");
/** Used for built-in method references. */ var $c93993473704a3a6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c93993473704a3a6$var$hasOwnProperty = $c93993473704a3a6$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c93993473704a3a6$var$baseKeys(object) {
    if (!$1c8Xi(object)) return $hBFnZ(object);
    var result = [];
    for(var key in Object(object))if ($c93993473704a3a6$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $c93993473704a3a6$var$baseKeys;

});
parcelRegister("hBFnZ", function(module, exports) {

var $u36QN = parcelRequire("u36QN");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd15fec3f41a34b8$var$nativeKeys = $u36QN(Object.keys, Object);
module.exports = $cd15fec3f41a34b8$var$nativeKeys;

});





parcelRegister("jUKMk", function(module, exports) {

var $6iBTm = parcelRequire("6iBTm");

var $ZFSZQ = parcelRequire("ZFSZQ");

var $5Gigt = parcelRequire("5Gigt");

var $aW9k2 = parcelRequire("aW9k2");

var $fc7XT = parcelRequire("fc7XT");

var $91x1j = parcelRequire("91x1j");

var $luMAq = parcelRequire("luMAq");
/** `Object#toString` result references. */ var $e7f78889b50c90aa$var$mapTag = "[object Map]", $e7f78889b50c90aa$var$objectTag = "[object Object]", $e7f78889b50c90aa$var$promiseTag = "[object Promise]", $e7f78889b50c90aa$var$setTag = "[object Set]", $e7f78889b50c90aa$var$weakMapTag = "[object WeakMap]";
var $e7f78889b50c90aa$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $e7f78889b50c90aa$var$dataViewCtorString = $luMAq($6iBTm), $e7f78889b50c90aa$var$mapCtorString = $luMAq($ZFSZQ), $e7f78889b50c90aa$var$promiseCtorString = $luMAq($5Gigt), $e7f78889b50c90aa$var$setCtorString = $luMAq($aW9k2), $e7f78889b50c90aa$var$weakMapCtorString = $luMAq($fc7XT);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $e7f78889b50c90aa$var$getTag = $91x1j;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($6iBTm && $e7f78889b50c90aa$var$getTag(new $6iBTm(new ArrayBuffer(1))) != $e7f78889b50c90aa$var$dataViewTag || $ZFSZQ && $e7f78889b50c90aa$var$getTag(new $ZFSZQ) != $e7f78889b50c90aa$var$mapTag || $5Gigt && $e7f78889b50c90aa$var$getTag($5Gigt.resolve()) != $e7f78889b50c90aa$var$promiseTag || $aW9k2 && $e7f78889b50c90aa$var$getTag(new $aW9k2) != $e7f78889b50c90aa$var$setTag || $fc7XT && $e7f78889b50c90aa$var$getTag(new $fc7XT) != $e7f78889b50c90aa$var$weakMapTag) $e7f78889b50c90aa$var$getTag = function(value) {
    var result = $91x1j(value), Ctor = result == $e7f78889b50c90aa$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $luMAq(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $e7f78889b50c90aa$var$dataViewCtorString:
            return $e7f78889b50c90aa$var$dataViewTag;
        case $e7f78889b50c90aa$var$mapCtorString:
            return $e7f78889b50c90aa$var$mapTag;
        case $e7f78889b50c90aa$var$promiseCtorString:
            return $e7f78889b50c90aa$var$promiseTag;
        case $e7f78889b50c90aa$var$setCtorString:
            return $e7f78889b50c90aa$var$setTag;
        case $e7f78889b50c90aa$var$weakMapCtorString:
            return $e7f78889b50c90aa$var$weakMapTag;
    }
    return result;
};
module.exports = $e7f78889b50c90aa$var$getTag;

});
parcelRegister("6iBTm", function(module, exports) {

var $klMbR = parcelRequire("klMbR");

var $hhiLy = parcelRequire("hhiLy");
/* Built-in method references that are verified to be native. */ var $4961d10abebb3596$var$DataView = $klMbR($hhiLy, "DataView");
module.exports = $4961d10abebb3596$var$DataView;

});

parcelRegister("5Gigt", function(module, exports) {

var $klMbR = parcelRequire("klMbR");

var $hhiLy = parcelRequire("hhiLy");
/* Built-in method references that are verified to be native. */ var $422f0af84972c3a1$var$Promise = $klMbR($hhiLy, "Promise");
module.exports = $422f0af84972c3a1$var$Promise;

});

parcelRegister("aW9k2", function(module, exports) {

var $klMbR = parcelRequire("klMbR");

var $hhiLy = parcelRequire("hhiLy");
/* Built-in method references that are verified to be native. */ var $7f668d55d55769b5$var$Set = $klMbR($hhiLy, "Set");
module.exports = $7f668d55d55769b5$var$Set;

});

parcelRegister("fc7XT", function(module, exports) {

var $klMbR = parcelRequire("klMbR");

var $hhiLy = parcelRequire("hhiLy");
/* Built-in method references that are verified to be native. */ var $b0fe27ab5a4d1c91$var$WeakMap = $klMbR($hhiLy, "WeakMap");
module.exports = $b0fe27ab5a4d1c91$var$WeakMap;

});





parcelRegister("665Nt", function(module, exports) {

var $jz5MV = parcelRequire("jz5MV");

var $ergFi = parcelRequire("ergFi");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $4707ccca95f72cca$var$pick = $ergFi(function(object, paths) {
    return object == null ? {} : $jz5MV(object, paths);
});
module.exports = $4707ccca95f72cca$var$pick;

});
parcelRegister("jz5MV", function(module, exports) {

var $j1G2N = parcelRequire("j1G2N");

var $2S2On = parcelRequire("2S2On");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $e3e5c69f01037876$var$basePick(object, paths) {
    return $j1G2N(object, paths, function(value, path) {
        return $2S2On(object, path);
    });
}
module.exports = $e3e5c69f01037876$var$basePick;

});
parcelRegister("j1G2N", function(module, exports) {

var $c6ssy = parcelRequire("c6ssy");

var $caGI3 = parcelRequire("caGI3");

var $9GSlD = parcelRequire("9GSlD");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $dd9eb962a8d75439$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $c6ssy(object, path);
        if (predicate(value, path)) $caGI3(result, $9GSlD(path, object), value);
    }
    return result;
}
module.exports = $dd9eb962a8d75439$var$basePickBy;

});

parcelRegister("2S2On", function(module, exports) {

var $136k5 = parcelRequire("136k5");

var $lW38I = parcelRequire("lW38I");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $2172ce40d6146397$var$hasIn(object, path) {
    return object != null && $lW38I(object, path, $136k5);
}
module.exports = $2172ce40d6146397$var$hasIn;

});
parcelRegister("136k5", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $0c3af9e32eb67cd6$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $0c3af9e32eb67cd6$var$baseHasIn;

});

parcelRegister("lW38I", function(module, exports) {

var $9GSlD = parcelRequire("9GSlD");

var $EPvHK = parcelRequire("EPvHK");

var $ioays = parcelRequire("ioays");

var $5Ntt4 = parcelRequire("5Ntt4");

var $5VAtD = parcelRequire("5VAtD");

var $dchoT = parcelRequire("dchoT");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $ff81732fb5ff0590$var$hasPath(object, path, hasFunc) {
    path = $9GSlD(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $dchoT(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5VAtD(length) && $5Ntt4(key, length) && ($ioays(object) || $EPvHK(object));
}
module.exports = $ff81732fb5ff0590$var$hasPath;

});



parcelRegister("ergFi", function(module, exports) {

var $aBxy4 = parcelRequire("aBxy4");

var $7weCi = parcelRequire("7weCi");

var $35D0R = parcelRequire("35D0R");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $a83083a4faefccb5$var$flatRest(func) {
    return $35D0R($7weCi(func, undefined, $aBxy4), func + "");
}
module.exports = $a83083a4faefccb5$var$flatRest;

});
parcelRegister("aBxy4", function(module, exports) {

var $6675C = parcelRequire("6675C");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $7b8762223e0e0c84$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $6675C(array, 1) : [];
}
module.exports = $7b8762223e0e0c84$var$flatten;

});
parcelRegister("6675C", function(module, exports) {

var $b9oe2 = parcelRequire("b9oe2");

var $gjYBy = parcelRequire("gjYBy");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $4708cd76c161909e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $gjYBy);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $4708cd76c161909e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $b9oe2(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $4708cd76c161909e$var$baseFlatten;

});
parcelRegister("gjYBy", function(module, exports) {

var $kZpX4 = parcelRequire("kZpX4");

var $EPvHK = parcelRequire("EPvHK");

var $ioays = parcelRequire("ioays");
/** Built-in value references. */ var $be1d6e87f3ac7cc2$var$spreadableSymbol = $kZpX4 ? $kZpX4.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $be1d6e87f3ac7cc2$var$isFlattenable(value) {
    return $ioays(value) || $EPvHK(value) || !!($be1d6e87f3ac7cc2$var$spreadableSymbol && value && value[$be1d6e87f3ac7cc2$var$spreadableSymbol]);
}
module.exports = $be1d6e87f3ac7cc2$var$isFlattenable;

});






parcelRegister("9PQlg", function(module, exports) {

$parcel$export(module.exports, "ArcLabelsLayer", function () { return $72917a7ee8b1980d$export$6aed5a877c5fc8a1; });
$parcel$export(module.exports, "drawCanvasArcLabels", function () { return $72917a7ee8b1980d$export$3162ce2b4ca97f8a; });
$parcel$export(module.exports, "useArcLabels", function () { return $72917a7ee8b1980d$export$13804dbea81a51a5; });
$parcel$export(module.exports, "ArcLinkLabelsLayer", function () { return $72917a7ee8b1980d$export$ea70f6ffe59d94b1; });
$parcel$export(module.exports, "drawCanvasArcLinkLabels", function () { return $72917a7ee8b1980d$export$3aacf153e19c708d; });
$parcel$export(module.exports, "useArcLinkLabels", function () { return $72917a7ee8b1980d$export$a2fecac67fe4140c; });
$parcel$export(module.exports, "ArcsLayer", function () { return $72917a7ee8b1980d$export$aa2d92ba89b625ed; });
$parcel$export(module.exports, "computeArcBoundingBox", function () { return $72917a7ee8b1980d$export$ac350cdccf8fe5e4; });
$parcel$export(module.exports, "findArcUnderCursor", function () { return $72917a7ee8b1980d$export$f797b637b9988726; });
$parcel$export(module.exports, "useArcGenerator", function () { return $72917a7ee8b1980d$export$9dba50da1768ab65; });

var $70fFQ = parcelRequire("70fFQ");

var $2qXGl = parcelRequire("2qXGl");

var $boipe = parcelRequire("boipe");

var $eYtn3 = parcelRequire("eYtn3");
var $4ZiMn = parcelRequire("4ZiMn");

var $4x3bm = parcelRequire("4x3bm");

var $4q1F4 = parcelRequire("4q1F4");
var $7Gyiu = parcelRequire("7Gyiu");
function $72917a7ee8b1980d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $72917a7ee8b1980d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $72917a7ee8b1980d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $72917a7ee8b1980d$var$ownKeys(Object(source), true).forEach(function(key) {
            $72917a7ee8b1980d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $72917a7ee8b1980d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $72917a7ee8b1980d$var$getNormalizedAngle = function getNormalizedAngle(angle) {
    var normalizedAngle = angle % (Math.PI * 2);
    if (normalizedAngle < 0) normalizedAngle += Math.PI * 2;
    return normalizedAngle;
};
var $72917a7ee8b1980d$var$filterDataBySkipAngle = function filterDataBySkipAngle(data, skipAngle) {
    return data.filter(function(datum) {
        return Math.abs((0, $2qXGl.radiansToDegrees)(datum.arc.endAngle - datum.arc.startAngle)) >= skipAngle;
    });
};
var $72917a7ee8b1980d$var$useFilteredDataBySkipAngle = function useFilteredDataBySkipAngle(data, skipAngle) {
    return (0, $70fFQ.useMemo)(function() {
        return $72917a7ee8b1980d$var$filterDataBySkipAngle(data, skipAngle);
    }, [
        data,
        skipAngle
    ]);
};
var $72917a7ee8b1980d$var$svgEllipticalArcCommand = function svgEllipticalArcCommand(radius, largeArcFlag, sweepFlag, x, y) {
    return [
        "A",
        radius,
        radius,
        0,
        largeArcFlag,
        sweepFlag,
        x,
        y
    ].join(" ");
};
var $72917a7ee8b1980d$var$generateSvgArc = function generateSvgArc(radius, originalStartAngle, originalEndAngle) {
    var startAngle = Math.min(originalStartAngle, originalEndAngle);
    var endAngle = Math.max(originalStartAngle, originalEndAngle);
    var start = (0, $2qXGl.positionFromAngle)((0, $2qXGl.degreesToRadians)(endAngle), radius);
    var end = (0, $2qXGl.positionFromAngle)((0, $2qXGl.degreesToRadians)(startAngle), radius);
    if (endAngle - startAngle >= 360) {
        var mid = (0, $2qXGl.positionFromAngle)((0, $2qXGl.degreesToRadians)(startAngle + 180), radius);
        return [
            "M ".concat(start.x, " ").concat(start.y),
            $72917a7ee8b1980d$var$svgEllipticalArcCommand(radius, 1, 1, mid.x, mid.y),
            "M ".concat(start.x, " ").concat(start.y),
            $72917a7ee8b1980d$var$svgEllipticalArcCommand(radius, 1, 0, mid.x, mid.y)
        ].join(" ");
    }
    var largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;
    return [
        "M ".concat(start.x, " ").concat(start.y),
        $72917a7ee8b1980d$var$svgEllipticalArcCommand(radius, largeArcFlag, 0, end.x, end.y)
    ].join(" ");
};
var $72917a7ee8b1980d$export$d2a093ad2bac157 = [
    "startAngle",
    "middleAngle",
    "endAngle",
    "innerRadius",
    "centerRadius",
    "outerRadius",
    "pushIn",
    "pushOut"
];
var $72917a7ee8b1980d$export$81e64a3650c150c1 = {
    startAngle: {
        enter: function enter(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                endAngle: arc.startAngle
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                startAngle: arc.endAngle
            });
        }
    },
    middleAngle: {
        enter: function enter(arc) {
            var middleAngle = arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                startAngle: middleAngle,
                endAngle: middleAngle
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            var middleAngle = arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                startAngle: middleAngle,
                endAngle: middleAngle
            });
        }
    },
    endAngle: {
        enter: function enter(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                startAngle: arc.endAngle
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                endAngle: arc.startAngle
            });
        }
    },
    innerRadius: {
        enter: function enter(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                outerRadius: arc.innerRadius
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: arc.outerRadius
            });
        }
    },
    centerRadius: {
        enter: function enter(arc) {
            var centerRadius = arc.innerRadius + (arc.outerRadius - arc.innerRadius) / 2;
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: centerRadius,
                outerRadius: centerRadius
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            var centerRadius = arc.innerRadius + (arc.outerRadius - arc.innerRadius) / 2;
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: centerRadius,
                outerRadius: centerRadius
            });
        }
    },
    outerRadius: {
        enter: function enter(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: arc.outerRadius
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                outerRadius: arc.innerRadius
            });
        }
    },
    pushIn: {
        enter: function enter(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: arc.innerRadius - arc.outerRadius + arc.innerRadius,
                outerRadius: arc.innerRadius
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: arc.outerRadius,
                outerRadius: arc.outerRadius + arc.outerRadius - arc.innerRadius
            });
        }
    },
    pushOut: {
        enter: function enter(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: arc.outerRadius,
                outerRadius: arc.outerRadius + arc.outerRadius - arc.innerRadius
            });
        },
        update: function update(arc) {
            return arc;
        },
        leave: function leave(arc) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, arc), {}, {
                innerRadius: arc.innerRadius - arc.outerRadius + arc.innerRadius,
                outerRadius: arc.innerRadius
            });
        }
    }
};
var $72917a7ee8b1980d$export$a313c3952fef8fc3 = function useArcTransitionMode(mode, extraTransition) {
    return (0, $70fFQ.useMemo)(function() {
        var transitionMode = $72917a7ee8b1980d$export$81e64a3650c150c1[mode];
        return {
            enter: function enter(datum) {
                return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({
                    progress: 0
                }, transitionMode.enter(datum.arc)), extraTransition ? extraTransition.enter(datum) : {});
            },
            update: function update(datum) {
                return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({
                    progress: 1
                }, transitionMode.update(datum.arc)), extraTransition ? extraTransition.update(datum) : {});
            },
            leave: function leave(datum) {
                return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({
                    progress: 0
                }, transitionMode.leave(datum.arc)), extraTransition ? extraTransition.leave(datum) : {});
            }
        };
    }, [
        mode,
        extraTransition
    ]);
};
var $72917a7ee8b1980d$export$f7b13546106819e8 = function computeArcCenter(arc, offset) {
    var angle = (0, $2qXGl.midAngle)(arc) - Math.PI / 2;
    var radius = arc.innerRadius + (arc.outerRadius - arc.innerRadius) * offset;
    return (0, $2qXGl.positionFromAngle)(angle, radius);
};
var $72917a7ee8b1980d$export$aee1f2bb11698da9 = function interpolateArcCenter(offset) {
    return function(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue) {
        return (0, $4ZiMn.to)([
            startAngleValue,
            endAngleValue,
            innerRadiusValue,
            outerRadiusValue
        ], function(startAngle, endAngle, innerRadius, outerRadius) {
            var centroid = $72917a7ee8b1980d$export$f7b13546106819e8({
                startAngle: startAngle,
                endAngle: endAngle,
                innerRadius: innerRadius,
                outerRadius: outerRadius
            }, offset);
            return "translate(".concat(centroid.x, ",").concat(centroid.y, ")");
        });
    };
};
var $72917a7ee8b1980d$export$e64eb3d94f48a98e = function useArcCentersTransition(data) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
    var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "innerRadius";
    var extra = arguments.length > 3 ? arguments[3] : undefined;
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var phases = $72917a7ee8b1980d$export$a313c3952fef8fc3(mode, extra);
    var transition = (0, $4ZiMn.useTransition)(data, {
        keys: function keys(datum) {
            return datum.id;
        },
        initial: phases.update,
        from: phases.enter,
        enter: phases.update,
        update: phases.update,
        leave: phases.leave,
        config: springConfig,
        immediate: !animate
    });
    return {
        transition: transition,
        interpolate: $72917a7ee8b1980d$export$aee1f2bb11698da9(offset)
    };
};
var $72917a7ee8b1980d$export$92aaf3f031db9626 = function useArcCenters(_ref) {
    var data = _ref.data, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0.5 : _ref$offset, _ref$skipAngle = _ref.skipAngle, skipAngle = _ref$skipAngle === void 0 ? 0 : _ref$skipAngle, _ref$computeExtraProp = _ref.computeExtraProps, computeExtraProps = _ref$computeExtraProp === void 0 ? function() {
        return {};
    } : _ref$computeExtraProp;
    return (0, $70fFQ.useMemo)(function() {
        return $72917a7ee8b1980d$var$filterDataBySkipAngle(data, skipAngle).map(function(datum) {
            var position = $72917a7ee8b1980d$export$f7b13546106819e8(datum.arc, offset);
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, computeExtraProps(datum)), {}, {
                x: position.x,
                y: position.y,
                data: datum
            });
        });
    }, [
        data,
        offset,
        skipAngle,
        computeExtraProps
    ]);
};
var $72917a7ee8b1980d$var$staticStyle = {
    pointerEvents: "none"
};
var $72917a7ee8b1980d$var$ArcLabel = function ArcLabel(_ref) {
    var label = _ref.label, style = _ref.style;
    var theme = (0, $2qXGl.useTheme)();
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).g, {
        transform: style.transform,
        opacity: style.progress,
        style: $72917a7ee8b1980d$var$staticStyle,
        children: (0, $4x3bm.jsx)((0, $eYtn3.animated).text, {
            textAnchor: "middle",
            dominantBaseline: "central",
            style: $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, theme.labels.text), {}, {
                fill: style.textColor
            }),
            children: label
        })
    });
};
var $72917a7ee8b1980d$export$6aed5a877c5fc8a1 = function ArcLabelsLayer(_ref) {
    var center = _ref.center, data = _ref.data, transitionMode = _ref.transitionMode, labelAccessor = _ref.label, radiusOffset = _ref.radiusOffset, skipAngle = _ref.skipAngle, textColor = _ref.textColor, _ref$component = _ref.component, component = _ref$component === void 0 ? $72917a7ee8b1980d$var$ArcLabel : _ref$component;
    var getLabel = (0, $2qXGl.usePropertyAccessor)(labelAccessor);
    var theme = (0, $2qXGl.useTheme)();
    var getTextColor = (0, $boipe.useInheritedColor)(textColor, theme);
    var filteredData = (0, $70fFQ.useMemo)(function() {
        return data.filter(function(datum) {
            return Math.abs((0, $2qXGl.radiansToDegrees)(datum.arc.endAngle - datum.arc.startAngle)) >= skipAngle;
        });
    }, [
        data,
        skipAngle
    ]);
    var _useArcCentersTransit = $72917a7ee8b1980d$export$e64eb3d94f48a98e(filteredData, radiusOffset, transitionMode), transition = _useArcCentersTransit.transition, interpolate = _useArcCentersTransit.interpolate;
    var Label = component;
    return (0, $4x3bm.jsx)("g", {
        transform: "translate(".concat(center[0], ",").concat(center[1], ")"),
        children: transition(function(transitionProps, datum) {
            return (0, $70fFQ.createElement)(Label, {
                key: datum.id,
                datum: datum,
                label: getLabel(datum),
                style: $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, transitionProps), {}, {
                    transform: interpolate(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius),
                    textColor: getTextColor(datum)
                })
            });
        })
    });
};
var $72917a7ee8b1980d$export$3162ce2b4ca97f8a = function drawCanvasArcLabels(ctx, labels, theme) {
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "".concat(theme.labels.text.fontSize, "px ").concat(theme.labels.text.fontFamily);
    labels.forEach(function(label) {
        ctx.fillStyle = label.textColor;
        ctx.fillText("".concat(label.label), label.x, label.y);
    });
};
var $72917a7ee8b1980d$export$13804dbea81a51a5 = function useArcLabels(_ref) {
    var data = _ref.data, offset = _ref.offset, skipAngle = _ref.skipAngle, label = _ref.label, textColor = _ref.textColor;
    var getLabel = (0, $2qXGl.usePropertyAccessor)(label);
    var theme = (0, $2qXGl.useTheme)();
    var getTextColor = (0, $boipe.useInheritedColor)(textColor, theme);
    var computeExtraProps = (0, $70fFQ.useCallback)(function(datum) {
        return {
            label: getLabel(datum),
            textColor: getTextColor(datum)
        };
    }, [
        getLabel,
        getTextColor
    ]);
    return $72917a7ee8b1980d$export$92aaf3f031db9626({
        data: data,
        offset: offset,
        skipAngle: skipAngle,
        computeExtraProps: computeExtraProps
    });
};
var $72917a7ee8b1980d$export$248385da08f607e = function computeArcLinkTextAnchor(arc) {
    var centerAngle = $72917a7ee8b1980d$var$getNormalizedAngle(arc.startAngle + (arc.endAngle - arc.startAngle) / 2 - Math.PI / 2);
    if (centerAngle < Math.PI / 2 || centerAngle > Math.PI * 1.5) return "start";
    return "end";
};
var $72917a7ee8b1980d$export$67742f271c0ba17f = function computeArcLink(arc, offset, diagonalLength, straightLength) {
    var centerAngle = $72917a7ee8b1980d$var$getNormalizedAngle(arc.startAngle + (arc.endAngle - arc.startAngle) / 2 - Math.PI / 2);
    var point0 = (0, $2qXGl.positionFromAngle)(centerAngle, arc.outerRadius + offset);
    var point1 = (0, $2qXGl.positionFromAngle)(centerAngle, arc.outerRadius + offset + diagonalLength);
    var side;
    var point2;
    if (centerAngle < Math.PI / 2 || centerAngle > Math.PI * 1.5) {
        side = "after";
        point2 = {
            x: point1.x + straightLength,
            y: point1.y
        };
    } else {
        side = "before";
        point2 = {
            x: point1.x - straightLength,
            y: point1.y
        };
    }
    return {
        side: side,
        points: [
            point0,
            point1,
            point2
        ]
    };
};
var $72917a7ee8b1980d$var$lineGenerator = (0, $7Gyiu.default)().x(function(d) {
    return d.x;
}).y(function(d) {
    return d.y;
});
var $72917a7ee8b1980d$var$useTransitionPhases = function useTransitionPhases(_ref) {
    var offset = _ref.offset, diagonalLength = _ref.diagonalLength, straightLength = _ref.straightLength, textOffset = _ref.textOffset, getLinkColor = _ref.getLinkColor, getTextColor = _ref.getTextColor;
    return (0, $70fFQ.useMemo)(function() {
        return {
            enter: function enter(datum) {
                return {
                    startAngle: datum.arc.startAngle,
                    endAngle: datum.arc.endAngle,
                    innerRadius: datum.arc.innerRadius,
                    outerRadius: datum.arc.outerRadius,
                    offset: offset,
                    diagonalLength: 0,
                    straightLength: 0,
                    textOffset: textOffset,
                    linkColor: getLinkColor(datum),
                    textColor: getTextColor(datum),
                    opacity: 0
                };
            },
            update: function update(d) {
                return {
                    startAngle: d.arc.startAngle,
                    endAngle: d.arc.endAngle,
                    innerRadius: d.arc.innerRadius,
                    outerRadius: d.arc.outerRadius,
                    offset: offset,
                    diagonalLength: diagonalLength,
                    straightLength: straightLength,
                    textOffset: textOffset,
                    linkColor: getLinkColor(d),
                    textColor: getTextColor(d),
                    opacity: 1
                };
            },
            leave: function leave(d) {
                return {
                    startAngle: d.arc.startAngle,
                    endAngle: d.arc.endAngle,
                    innerRadius: d.arc.innerRadius,
                    outerRadius: d.arc.outerRadius,
                    offset: offset,
                    diagonalLength: 0,
                    straightLength: 0,
                    textOffset: textOffset,
                    linkColor: getLinkColor(d),
                    textColor: getTextColor(d),
                    opacity: 0
                };
            }
        };
    }, [
        diagonalLength,
        straightLength,
        textOffset,
        getLinkColor,
        getTextColor
    ]);
};
var $72917a7ee8b1980d$var$interpolateLink = function interpolateLink(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, offsetValue, diagonalLengthValue, straightLengthValue) {
    return (0, $4ZiMn.to)([
        startAngleValue,
        endAngleValue,
        innerRadiusValue,
        outerRadiusValue,
        offsetValue,
        diagonalLengthValue,
        straightLengthValue
    ], function(startAngle, endAngle, innerRadius, outerRadius, offset, diagonalLengthAnimated, straightLengthAnimated) {
        var _computeArcLink = $72917a7ee8b1980d$export$67742f271c0ba17f({
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
        }, offset, diagonalLengthAnimated, straightLengthAnimated), points = _computeArcLink.points;
        return $72917a7ee8b1980d$var$lineGenerator(points);
    });
};
var $72917a7ee8b1980d$var$interpolateTextAnchor = function interpolateTextAnchor(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue) {
    return (0, $4ZiMn.to)([
        startAngleValue,
        endAngleValue,
        innerRadiusValue,
        outerRadiusValue
    ], function(startAngle, endAngle, innerRadius, outerRadius) {
        return $72917a7ee8b1980d$export$248385da08f607e({
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
        });
    });
};
var $72917a7ee8b1980d$var$interpolateTextPosition = function interpolateTextPosition(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, offsetValue, diagonalLengthValue, straightLengthValue, textOffsetValue) {
    return (0, $4ZiMn.to)([
        startAngleValue,
        endAngleValue,
        innerRadiusValue,
        outerRadiusValue,
        offsetValue,
        diagonalLengthValue,
        straightLengthValue,
        textOffsetValue
    ], function(startAngle, endAngle, innerRadius, outerRadius, offset, diagonalLengthAnimated, straightLengthAnimated, textOffset) {
        var _computeArcLink2 = $72917a7ee8b1980d$export$67742f271c0ba17f({
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
        }, offset, diagonalLengthAnimated, straightLengthAnimated), points = _computeArcLink2.points, side = _computeArcLink2.side;
        var position = points[2];
        if (side === "before") position.x -= textOffset;
        else position.x += textOffset;
        return "translate(".concat(position.x, ",").concat(position.y, ")");
    });
};
var $72917a7ee8b1980d$export$5a16238ff9674f1b = function useArcLinkLabelsTransition(_ref2) {
    var data = _ref2.data, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? 0 : _ref2$offset, diagonalLength = _ref2.diagonalLength, straightLength = _ref2.straightLength, _ref2$skipAngle = _ref2.skipAngle, skipAngle = _ref2$skipAngle === void 0 ? 0 : _ref2$skipAngle, textOffset = _ref2.textOffset, linkColor = _ref2.linkColor, textColor = _ref2.textColor;
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var theme = (0, $2qXGl.useTheme)();
    var getLinkColor = (0, $boipe.useInheritedColor)(linkColor, theme);
    var getTextColor = (0, $boipe.useInheritedColor)(textColor, theme);
    var filteredData = $72917a7ee8b1980d$var$useFilteredDataBySkipAngle(data, skipAngle);
    var transitionPhases = $72917a7ee8b1980d$var$useTransitionPhases({
        offset: offset,
        diagonalLength: diagonalLength,
        straightLength: straightLength,
        textOffset: textOffset,
        getLinkColor: getLinkColor,
        getTextColor: getTextColor
    });
    var transition = (0, $4ZiMn.useTransition)(filteredData, {
        keys: function keys(datum) {
            return datum.id;
        },
        initial: transitionPhases.update,
        from: transitionPhases.enter,
        enter: transitionPhases.update,
        update: transitionPhases.update,
        leave: transitionPhases.leave,
        config: springConfig,
        immediate: !animate
    });
    return {
        transition: transition,
        interpolateLink: $72917a7ee8b1980d$var$interpolateLink,
        interpolateTextAnchor: $72917a7ee8b1980d$var$interpolateTextAnchor,
        interpolateTextPosition: $72917a7ee8b1980d$var$interpolateTextPosition
    };
};
var $72917a7ee8b1980d$var$ArcLinkLabel = function ArcLinkLabel(_ref) {
    var label = _ref.label, style = _ref.style;
    var theme = (0, $2qXGl.useTheme)();
    return (0, $4x3bm.jsxs)((0, $eYtn3.animated).g, {
        opacity: style.opacity,
        children: [
            (0, $4x3bm.jsx)((0, $eYtn3.animated).path, {
                fill: "none",
                stroke: style.linkColor,
                strokeWidth: style.thickness,
                d: style.path
            }),
            (0, $4x3bm.jsx)((0, $eYtn3.animated).text, {
                transform: style.textPosition,
                textAnchor: style.textAnchor,
                dominantBaseline: "central",
                style: $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, theme.labels.text), {}, {
                    fill: style.textColor
                }),
                children: label
            })
        ]
    });
};
var $72917a7ee8b1980d$export$ea70f6ffe59d94b1 = function ArcLinkLabelsLayer(_ref) {
    var center = _ref.center, data = _ref.data, labelAccessor = _ref.label, skipAngle = _ref.skipAngle, offset = _ref.offset, diagonalLength = _ref.diagonalLength, straightLength = _ref.straightLength, strokeWidth = _ref.strokeWidth, textOffset = _ref.textOffset, textColor = _ref.textColor, linkColor = _ref.linkColor, _ref$component = _ref.component, component = _ref$component === void 0 ? $72917a7ee8b1980d$var$ArcLinkLabel : _ref$component;
    var getLabel = (0, $2qXGl.usePropertyAccessor)(labelAccessor);
    var _useArcLinkLabelsTran = $72917a7ee8b1980d$export$5a16238ff9674f1b({
        data: data,
        skipAngle: skipAngle,
        offset: offset,
        diagonalLength: diagonalLength,
        straightLength: straightLength,
        textOffset: textOffset,
        linkColor: linkColor,
        textColor: textColor
    }), transition = _useArcLinkLabelsTran.transition, interpolateLink = _useArcLinkLabelsTran.interpolateLink, interpolateTextAnchor = _useArcLinkLabelsTran.interpolateTextAnchor, interpolateTextPosition = _useArcLinkLabelsTran.interpolateTextPosition;
    var Label = component;
    return (0, $4x3bm.jsx)("g", {
        transform: "translate(".concat(center[0], ",").concat(center[1], ")"),
        children: transition(function(transitionProps, datum) {
            return (0, $70fFQ.createElement)(Label, {
                key: datum.id,
                datum: datum,
                label: getLabel(datum),
                style: $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, transitionProps), {}, {
                    thickness: strokeWidth,
                    path: interpolateLink(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius, transitionProps.offset, transitionProps.diagonalLength, transitionProps.straightLength),
                    textAnchor: interpolateTextAnchor(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius),
                    textPosition: interpolateTextPosition(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius, transitionProps.offset, transitionProps.diagonalLength, transitionProps.straightLength, transitionProps.textOffset)
                })
            });
        })
    });
};
var $72917a7ee8b1980d$export$3aacf153e19c708d = function drawCanvasArcLinkLabels(ctx, labels, theme, strokeWidth) {
    ctx.textBaseline = "middle";
    ctx.font = "".concat(theme.labels.text.fontSize, "px ").concat(theme.labels.text.fontFamily);
    labels.forEach(function(label) {
        ctx.fillStyle = label.textColor;
        ctx.textAlign = (0, $2qXGl.textPropsByEngine).canvas.align[label.textAnchor];
        ctx.fillText("".concat(label.label), label.x, label.y);
        ctx.beginPath();
        ctx.strokeStyle = label.linkColor;
        ctx.lineWidth = strokeWidth;
        label.points.forEach(function(point, index) {
            if (index === 0) ctx.moveTo(point.x, point.y);
            else ctx.lineTo(point.x, point.y);
        });
        ctx.stroke();
    });
};
var $72917a7ee8b1980d$export$1b7846c545dc3357 = function useArcLinks(_ref) {
    var data = _ref.data, _ref$skipAngle = _ref.skipAngle, skipAngle = _ref$skipAngle === void 0 ? 0 : _ref$skipAngle, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0.5 : _ref$offset, diagonalLength = _ref.diagonalLength, straightLength = _ref.straightLength, _ref$computeExtraProp = _ref.computeExtraProps, computeExtraProps = _ref$computeExtraProp === void 0 ? function() {
        return {};
    } : _ref$computeExtraProp;
    var links = (0, $70fFQ.useMemo)(function() {
        return data.filter(function(datum) {
            return Math.abs((0, $2qXGl.radiansToDegrees)(datum.arc.endAngle - datum.arc.startAngle)) >= skipAngle;
        }).map(function(datum) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, $72917a7ee8b1980d$export$67742f271c0ba17f(datum.arc, offset, diagonalLength, straightLength)), {}, {
                data: datum
            });
        });
    }, [
        data,
        skipAngle,
        offset,
        diagonalLength,
        straightLength
    ]);
    return (0, $70fFQ.useMemo)(function() {
        return links.map(function(link) {
            return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, computeExtraProps(link)), link);
        });
    }, [
        links,
        computeExtraProps
    ]);
};
var $72917a7ee8b1980d$export$a2fecac67fe4140c = function useArcLinkLabels(_ref) {
    var data = _ref.data, skipAngle = _ref.skipAngle, offset = _ref.offset, diagonalLength = _ref.diagonalLength, straightLength = _ref.straightLength, _ref$textOffset = _ref.textOffset, textOffset = _ref$textOffset === void 0 ? 0 : _ref$textOffset, label = _ref.label, linkColor = _ref.linkColor, textColor = _ref.textColor;
    var getLabel = (0, $2qXGl.usePropertyAccessor)(label);
    var theme = (0, $2qXGl.useTheme)();
    var getLinkColor = (0, $boipe.useInheritedColor)(linkColor, theme);
    var getTextColor = (0, $boipe.useInheritedColor)(textColor, theme);
    var computeExtraProps = (0, $70fFQ.useCallback)(function(link) {
        var position = {
            x: link.points[2].x,
            y: link.points[2].y
        };
        var textAnchor;
        if (link.side === "before") {
            position.x -= textOffset;
            textAnchor = "end";
        } else {
            position.x += textOffset;
            textAnchor = "start";
        }
        return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, position), {}, {
            label: getLabel(link.data),
            linkColor: getLinkColor(link.data),
            textAnchor: textAnchor,
            textColor: getTextColor(link.data)
        });
    }, [
        getLabel,
        getLinkColor,
        getTextColor,
        textOffset
    ]);
    return $72917a7ee8b1980d$export$1b7846c545dc3357({
        data: data,
        skipAngle: skipAngle,
        offset: offset,
        diagonalLength: diagonalLength,
        straightLength: straightLength,
        computeExtraProps: computeExtraProps
    });
};
function $72917a7ee8b1980d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $72917a7ee8b1980d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $72917a7ee8b1980d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $72917a7ee8b1980d$export$7f622f5e9941ffc5 = function ArcLine(_ref) {
    var animatedProps = _ref.animated, rest = $72917a7ee8b1980d$var$_objectWithoutProperties(_ref, [
        "animated"
    ]);
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).path, $72917a7ee8b1980d$var$_objectSpread2({
        d: (0, $4ZiMn.to)([
            animatedProps.radius,
            animatedProps.startAngle,
            animatedProps.endAngle
        ], function(radius, start, end) {
            return $72917a7ee8b1980d$var$generateSvgArc(radius, start, end);
        })
    }, rest));
};
var $72917a7ee8b1980d$export$a259dbdc51948277 = function ArcShape(_ref) {
    var datum = _ref.datum, style = _ref.style, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseMove = _ref.onMouseMove, onMouseLeave = _ref.onMouseLeave;
    var handleClick = (0, $70fFQ.useCallback)(function(event) {
        return onClick === null || onClick === void 0 ? void 0 : onClick(datum, event);
    }, [
        onClick,
        datum
    ]);
    var handleMouseEnter = (0, $70fFQ.useCallback)(function(event) {
        return onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(datum, event);
    }, [
        onMouseEnter,
        datum
    ]);
    var handleMouseMove = (0, $70fFQ.useCallback)(function(event) {
        return onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(datum, event);
    }, [
        onMouseMove,
        datum
    ]);
    var handleMouseLeave = (0, $70fFQ.useCallback)(function(event) {
        return onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(datum, event);
    }, [
        onMouseLeave,
        datum
    ]);
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).path, {
        d: style.path,
        opacity: style.opacity,
        fill: datum.fill || style.color,
        stroke: style.borderColor,
        strokeWidth: style.borderWidth,
        onClick: onClick ? handleClick : undefined,
        onMouseEnter: onMouseEnter ? handleMouseEnter : undefined,
        onMouseMove: onMouseMove ? handleMouseMove : undefined,
        onMouseLeave: onMouseLeave ? handleMouseLeave : undefined
    });
};
var $72917a7ee8b1980d$export$c01f32ffac6cf6f5 = function interpolateArc(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, arcGenerator) {
    return (0, $4ZiMn.to)([
        startAngleValue,
        endAngleValue,
        innerRadiusValue,
        outerRadiusValue
    ], function(startAngle, endAngle, innerRadius, outerRadius) {
        return arcGenerator({
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: Math.max(0, innerRadius),
            outerRadius: Math.max(0, outerRadius)
        });
    });
};
var $72917a7ee8b1980d$export$36567afd66e798ad = function useArcsTransition(data) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "innerRadius";
    var extra = arguments.length > 2 ? arguments[2] : undefined;
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var phases = $72917a7ee8b1980d$export$a313c3952fef8fc3(mode, extra);
    var transition = (0, $4ZiMn.useTransition)(data, {
        keys: function keys(datum) {
            return datum.id;
        },
        initial: phases.update,
        from: phases.enter,
        enter: phases.update,
        update: phases.update,
        leave: phases.leave,
        config: springConfig,
        immediate: !animate
    });
    return {
        transition: transition,
        interpolate: $72917a7ee8b1980d$export$c01f32ffac6cf6f5
    };
};
var $72917a7ee8b1980d$export$aa2d92ba89b625ed = function ArcsLayer(_ref) {
    var center = _ref.center, data = _ref.data, arcGenerator = _ref.arcGenerator, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseMove = _ref.onMouseMove, onMouseLeave = _ref.onMouseLeave, transitionMode = _ref.transitionMode, _ref$component = _ref.component, component = _ref$component === void 0 ? $72917a7ee8b1980d$export$a259dbdc51948277 : _ref$component;
    var theme = (0, $2qXGl.useTheme)();
    var getBorderColor = (0, $boipe.useInheritedColor)(borderColor, theme);
    var _useArcsTransition = $72917a7ee8b1980d$export$36567afd66e798ad(data, transitionMode, {
        enter: function enter(datum) {
            return {
                opacity: 0,
                color: datum.color,
                borderColor: getBorderColor(datum)
            };
        },
        update: function update(datum) {
            return {
                opacity: 1,
                color: datum.color,
                borderColor: getBorderColor(datum)
            };
        },
        leave: function leave(datum) {
            return {
                opacity: 0,
                color: datum.color,
                borderColor: getBorderColor(datum)
            };
        }
    }), transition = _useArcsTransition.transition, interpolate = _useArcsTransition.interpolate;
    var Arc = component;
    return (0, $4x3bm.jsx)("g", {
        transform: "translate(".concat(center[0], ",").concat(center[1], ")"),
        children: transition(function(transitionProps, datum) {
            return (0, $70fFQ.createElement)(Arc, {
                key: datum.id,
                datum: datum,
                style: $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, transitionProps), {}, {
                    borderWidth: borderWidth,
                    path: interpolate(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius, arcGenerator)
                }),
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                onMouseMove: onMouseMove,
                onMouseLeave: onMouseLeave
            });
        })
    });
};
function $72917a7ee8b1980d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $72917a7ee8b1980d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $72917a7ee8b1980d$var$_arrayLikeToArray(arr);
}
function $72917a7ee8b1980d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $72917a7ee8b1980d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $72917a7ee8b1980d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $72917a7ee8b1980d$var$_arrayLikeToArray(o, minLen);
}
function $72917a7ee8b1980d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $72917a7ee8b1980d$var$_toConsumableArray(arr) {
    return $72917a7ee8b1980d$var$_arrayWithoutHoles(arr) || $72917a7ee8b1980d$var$_iterableToArray(arr) || $72917a7ee8b1980d$var$_unsupportedIterableToArray(arr) || $72917a7ee8b1980d$var$_nonIterableSpread();
}
function $72917a7ee8b1980d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $72917a7ee8b1980d$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $72917a7ee8b1980d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $72917a7ee8b1980d$var$_slicedToArray(arr, i) {
    return $72917a7ee8b1980d$var$_arrayWithHoles(arr) || $72917a7ee8b1980d$var$_iterableToArrayLimit(arr, i) || $72917a7ee8b1980d$var$_unsupportedIterableToArray(arr, i) || $72917a7ee8b1980d$var$_nonIterableRest();
}
var $72917a7ee8b1980d$export$ac350cdccf8fe5e4 = function computeArcBoundingBox(centerX, centerY, radius, startAngle, endAngle) {
    var includeCenter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var points = [];
    var p0 = (0, $2qXGl.positionFromAngle)((0, $2qXGl.degreesToRadians)(startAngle), radius);
    points.push([
        p0.x,
        p0.y
    ]);
    var p1 = (0, $2qXGl.positionFromAngle)((0, $2qXGl.degreesToRadians)(endAngle), radius);
    points.push([
        p1.x,
        p1.y
    ]);
    for(var angle = Math.round(Math.min(startAngle, endAngle)); angle <= Math.round(Math.max(startAngle, endAngle)); angle++)if (angle % 90 === 0) {
        var p = (0, $2qXGl.positionFromAngle)((0, $2qXGl.degreesToRadians)(angle), radius);
        points.push([
            p.x,
            p.y
        ]);
    }
    points = points.map(function(_ref) {
        var _ref2 = $72917a7ee8b1980d$var$_slicedToArray(_ref, 2), x = _ref2[0], y = _ref2[1];
        return [
            centerX + x,
            centerY + y
        ];
    });
    if (includeCenter) points.push([
        centerX,
        centerY
    ]);
    var xs = points.map(function(_ref3) {
        var _ref4 = $72917a7ee8b1980d$var$_slicedToArray(_ref3, 1), x = _ref4[0];
        return x;
    });
    var ys = points.map(function(_ref5) {
        var _ref6 = $72917a7ee8b1980d$var$_slicedToArray(_ref5, 2), y = _ref6[1];
        return y;
    });
    var x0 = Math.min.apply(Math, $72917a7ee8b1980d$var$_toConsumableArray(xs));
    var x1 = Math.max.apply(Math, $72917a7ee8b1980d$var$_toConsumableArray(xs));
    var y0 = Math.min.apply(Math, $72917a7ee8b1980d$var$_toConsumableArray(ys));
    var y1 = Math.max.apply(Math, $72917a7ee8b1980d$var$_toConsumableArray(ys));
    return {
        points: points,
        x: x0,
        y: y0,
        width: x1 - x0,
        height: y1 - y0
    };
};
var $72917a7ee8b1980d$export$c1d34fa0d5d8e0e2 = function isCursorInRing(centerX, centerY, radius, innerRadius, cursorX, cursorY) {
    var distance = (0, $2qXGl.getDistance)(cursorX, cursorY, centerX, centerY);
    return distance < radius && distance > innerRadius;
};
var $72917a7ee8b1980d$export$f797b637b9988726 = function findArcUnderCursor(centerX, centerY, radius, innerRadius, arcs, cursorX, cursorY) {
    if (!$72917a7ee8b1980d$export$c1d34fa0d5d8e0e2(centerX, centerY, radius, innerRadius, cursorX, cursorY)) return undefined;
    var cursorAngle = (0, $2qXGl.getAngle)(cursorX, cursorY, centerX, centerY);
    return arcs.find(function(_ref) {
        var startAngle = _ref.startAngle, endAngle = _ref.endAngle;
        return cursorAngle >= startAngle && cursorAngle < endAngle;
    });
};
var $72917a7ee8b1980d$export$7b66ccfb3ae3d569 = function useAnimatedArc(datumWithArc, arcGenerator) {
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var animatedValues = (0, $4ZiMn.useSpring)({
        startAngle: datumWithArc.arc.startAngle,
        endAngle: datumWithArc.arc.endAngle,
        innerRadius: datumWithArc.arc.innerRadius,
        outerRadius: datumWithArc.arc.outerRadius,
        config: springConfig,
        immediate: !animate
    });
    return $72917a7ee8b1980d$var$_objectSpread2($72917a7ee8b1980d$var$_objectSpread2({}, animatedValues), {}, {
        path: $72917a7ee8b1980d$export$c01f32ffac6cf6f5(animatedValues.startAngle, animatedValues.endAngle, animatedValues.innerRadius, animatedValues.outerRadius, arcGenerator)
    });
};
var $72917a7ee8b1980d$export$9dba50da1768ab65 = function useArcGenerator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$cornerRadius = _ref.cornerRadius, cornerRadius = _ref$cornerRadius === void 0 ? 0 : _ref$cornerRadius, _ref$padAngle = _ref.padAngle, padAngle = _ref$padAngle === void 0 ? 0 : _ref$padAngle;
    return (0, $70fFQ.useMemo)(function() {
        return (0, $4q1F4.default)().innerRadius(function(arc) {
            return arc.innerRadius;
        }).outerRadius(function(arc) {
            return arc.outerRadius;
        }).cornerRadius(cornerRadius).padAngle(padAngle);
    }, [
        cornerRadius,
        padAngle
    ]);
};

});
parcelRegister("boipe", function(module, exports) {

$parcel$export(module.exports, "useInheritedColor", function () { return $0223dfd9752fbcb9$export$2a9e363116151414; });
$parcel$export(module.exports, "useOrdinalColorScale", function () { return $0223dfd9752fbcb9$export$47939777be1516f5; });
$parcel$export(module.exports, "ordinalColorsPropType", function () { return $0223dfd9752fbcb9$export$9ef95eaec260ee21; });

var $cpSH1 = parcelRequire("cpSH1");
var $fz4N9 = parcelRequire("fz4N9");
var $gt53g = parcelRequire("gt53g");
var $5Z16B = parcelRequire("5Z16B");
var $8V7EI = parcelRequire("8V7EI");
var $cwrJr = parcelRequire("cwrJr");
var $80FqD = parcelRequire("80FqD");
var $eN11p = parcelRequire("eN11p");
var $7hh3z = parcelRequire("7hh3z");
var $i74RE = parcelRequire("i74RE");
var $7oKHH = parcelRequire("7oKHH");
var $ll3aH = parcelRequire("ll3aH");
var $k90dT = parcelRequire("k90dT");
var $eqkbc = parcelRequire("eqkbc");
var $9kdQ2 = parcelRequire("9kdQ2");
var $75sQg = parcelRequire("75sQg");
var $j6d4T = parcelRequire("j6d4T");
var $3rkUU = parcelRequire("3rkUU");
var $2knla = parcelRequire("2knla");
var $b5AgS = parcelRequire("b5AgS");
var $deqjQ = parcelRequire("deqjQ");
var $n18IX = parcelRequire("n18IX");
var $2jgeQ = parcelRequire("2jgeQ");
var $6torH = parcelRequire("6torH");
var $7JT8F = parcelRequire("7JT8F");
var $grEAO = parcelRequire("grEAO");
var $5x0wB = parcelRequire("5x0wB");
var $7UdON = parcelRequire("7UdON");
var $5Hs8O = parcelRequire("5Hs8O");
var $gkCir = parcelRequire("gkCir");
var $bSpC5 = parcelRequire("bSpC5");
var $8ktkj = parcelRequire("8ktkj");
var $cMNJi = parcelRequire("cMNJi");
var $k8jNo = parcelRequire("k8jNo");
var $56l8W = parcelRequire("56l8W");
var $lXjI8 = parcelRequire("lXjI8");
var $1CkZa = parcelRequire("1CkZa");
var $7CLP4 = parcelRequire("7CLP4");
var $es2xN = parcelRequire("es2xN");
var $CgMhj = parcelRequire("CgMhj");
var $40aWI = parcelRequire("40aWI");
var $i3yYP = parcelRequire("i3yYP");

var $cBppa = parcelRequire("cBppa");

var $eycjp = parcelRequire("eycjp");

var $70fFQ = parcelRequire("70fFQ");

var $6z37v = parcelRequire("6z37v");

var $als2V = parcelRequire("als2V");

var $eZmYt = parcelRequire("eZmYt");

var $cd0Jr = parcelRequire("cd0Jr");
function $0223dfd9752fbcb9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0223dfd9752fbcb9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0223dfd9752fbcb9$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0223dfd9752fbcb9$var$ownKeys(Object(source), true).forEach(function(key) {
            $0223dfd9752fbcb9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0223dfd9752fbcb9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0223dfd9752fbcb9$export$8382cb219651957d = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $56l8W.default),
    accent: (0, $k8jNo.default),
    dark2: (0, $lXjI8.default),
    paired: (0, $1CkZa.default),
    pastel1: (0, $7CLP4.default),
    pastel2: (0, $es2xN.default),
    set1: (0, $CgMhj.default),
    set2: (0, $40aWI.default),
    set3: (0, $i3yYP.default)
};
var $0223dfd9752fbcb9$export$480d437bf98751ba = Object.keys($0223dfd9752fbcb9$export$8382cb219651957d);
var $0223dfd9752fbcb9$export$b42e9133a3bfc0c2 = {
    brown_blueGreen: (0, $fz4N9.scheme),
    purpleRed_green: (0, $9kdQ2.scheme),
    pink_yellowGreen: (0, $eqkbc.scheme),
    purple_orange: (0, $3rkUU.scheme),
    red_blue: (0, $deqjQ.scheme),
    red_grey: (0, $n18IX.scheme),
    red_yellow_blue: (0, $6torH.scheme),
    red_yellow_green: (0, $7JT8F.scheme),
    spectral: (0, $7UdON.scheme)
};
var $0223dfd9752fbcb9$export$63357c6d2f7b8781 = Object.keys($0223dfd9752fbcb9$export$b42e9133a3bfc0c2);
var $0223dfd9752fbcb9$export$d9c06f2af83aa27b = {
    brown_blueGreen: (0, $fz4N9.default),
    purpleRed_green: (0, $9kdQ2.default),
    pink_yellowGreen: (0, $eqkbc.default),
    purple_orange: (0, $3rkUU.default),
    red_blue: (0, $deqjQ.default),
    red_grey: (0, $n18IX.default),
    red_yellow_blue: (0, $6torH.default),
    red_yellow_green: (0, $7JT8F.default),
    spectral: (0, $7UdON.default)
};
var $0223dfd9752fbcb9$export$db45d8c654873588 = {
    blues: (0, $cpSH1.scheme),
    greens: (0, $7hh3z.scheme),
    greys: (0, $i74RE.scheme),
    oranges: (0, $ll3aH.scheme),
    purples: (0, $b5AgS.scheme),
    reds: (0, $grEAO.scheme),
    blue_green: (0, $gt53g.scheme),
    blue_purple: (0, $5Z16B.scheme),
    green_blue: (0, $eN11p.scheme),
    orange_red: (0, $k90dT.scheme),
    purple_blue_green: (0, $j6d4T.scheme),
    purple_blue: (0, $75sQg.scheme),
    purple_red: (0, $2knla.scheme),
    red_purple: (0, $2jgeQ.scheme),
    yellow_green_blue: (0, $bSpC5.scheme),
    yellow_green: (0, $gkCir.scheme),
    yellow_orange_brown: (0, $8ktkj.scheme),
    yellow_orange_red: (0, $cMNJi.scheme)
};
var $0223dfd9752fbcb9$export$6c6944263c7cbb3b = Object.keys($0223dfd9752fbcb9$export$db45d8c654873588);
var $0223dfd9752fbcb9$export$21dd087678fc5202 = {
    blues: (0, $cpSH1.default),
    greens: (0, $7hh3z.default),
    greys: (0, $i74RE.default),
    oranges: (0, $ll3aH.default),
    purples: (0, $b5AgS.default),
    reds: (0, $grEAO.default),
    turbo: (0, $5Hs8O.default),
    viridis: (0, $7oKHH.default),
    inferno: (0, $7oKHH.inferno),
    magma: (0, $7oKHH.magma),
    plasma: (0, $7oKHH.plasma),
    cividis: (0, $8V7EI.default),
    warm: (0, $cwrJr.warm),
    cool: (0, $cwrJr.cool),
    cubehelixDefault: (0, $80FqD.default),
    blue_green: (0, $gt53g.default),
    blue_purple: (0, $5Z16B.default),
    green_blue: (0, $eN11p.default),
    orange_red: (0, $k90dT.default),
    purple_blue_green: (0, $j6d4T.default),
    purple_blue: (0, $75sQg.default),
    purple_red: (0, $2knla.default),
    red_purple: (0, $2jgeQ.default),
    yellow_green_blue: (0, $bSpC5.default),
    yellow_green: (0, $gkCir.default),
    yellow_orange_brown: (0, $8ktkj.default),
    yellow_orange_red: (0, $cMNJi.default)
};
var $0223dfd9752fbcb9$export$2ad73d393c16f81c = $0223dfd9752fbcb9$var$_objectSpread2($0223dfd9752fbcb9$var$_objectSpread2($0223dfd9752fbcb9$var$_objectSpread2({}, $0223dfd9752fbcb9$export$8382cb219651957d), $0223dfd9752fbcb9$export$b42e9133a3bfc0c2), $0223dfd9752fbcb9$export$db45d8c654873588);
var $0223dfd9752fbcb9$export$b48661626a811234 = Object.keys($0223dfd9752fbcb9$export$2ad73d393c16f81c);
var $0223dfd9752fbcb9$export$9f49cca6c7d1dda4 = function isCategoricalColorScheme(scheme) {
    return $0223dfd9752fbcb9$export$480d437bf98751ba.includes(scheme);
};
var $0223dfd9752fbcb9$export$4d028a51ab424d0b = function isDivergingColorScheme(scheme) {
    return $0223dfd9752fbcb9$export$63357c6d2f7b8781.includes(scheme);
};
var $0223dfd9752fbcb9$export$166c33132082d11d = function isSequentialColorScheme(scheme) {
    return $0223dfd9752fbcb9$export$6c6944263c7cbb3b.includes(scheme);
};
var $0223dfd9752fbcb9$export$66bec3b8446aaf18 = {
    rainbow: (0, $cwrJr.default),
    sinebow: (0, $5x0wB.default)
};
var $0223dfd9752fbcb9$export$6638ab0298ebe095 = $0223dfd9752fbcb9$var$_objectSpread2($0223dfd9752fbcb9$var$_objectSpread2($0223dfd9752fbcb9$var$_objectSpread2({}, $0223dfd9752fbcb9$export$d9c06f2af83aa27b), $0223dfd9752fbcb9$export$21dd087678fc5202), $0223dfd9752fbcb9$export$66bec3b8446aaf18);
var $0223dfd9752fbcb9$export$277274330ffd2780 = Object.keys($0223dfd9752fbcb9$export$6638ab0298ebe095);
function $0223dfd9752fbcb9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0223dfd9752fbcb9$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0223dfd9752fbcb9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0223dfd9752fbcb9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0223dfd9752fbcb9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0223dfd9752fbcb9$var$_arrayLikeToArray(o, minLen);
}
function $0223dfd9752fbcb9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0223dfd9752fbcb9$var$_slicedToArray(arr, i) {
    return $0223dfd9752fbcb9$var$_arrayWithHoles(arr) || $0223dfd9752fbcb9$var$_iterableToArrayLimit(arr, i) || $0223dfd9752fbcb9$var$_unsupportedIterableToArray(arr, i) || $0223dfd9752fbcb9$var$_nonIterableRest();
}
function $0223dfd9752fbcb9$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $0223dfd9752fbcb9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $0223dfd9752fbcb9$var$isInheritedColorConfigFromTheme = function isInheritedColorConfigFromTheme(config) {
    return config.theme !== undefined;
};
var $0223dfd9752fbcb9$var$isInheritedColorConfigFromContext = function isInheritedColorConfigFromContext(config) {
    return config.from !== undefined;
};
var $0223dfd9752fbcb9$export$acb96d3092c0904 = function getInheritedColorGenerator(config, theme) {
    if (typeof config === "function") return config;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cBppa)))(config)) {
        if ($0223dfd9752fbcb9$var$isInheritedColorConfigFromTheme(config)) {
            if (theme === undefined) throw new Error("Unable to use color from theme as no theme was provided");
            var themeColor = (0, (/*@__PURE__*/$parcel$interopDefault($eycjp)))(theme, config.theme);
            if (themeColor === undefined) throw new Error("Color from theme is undefined at path: '".concat(config.theme, "'"));
            return function() {
                return themeColor;
            };
        }
        if ($0223dfd9752fbcb9$var$isInheritedColorConfigFromContext(config)) {
            var getColor = function getColor(d) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($eycjp)))(d, config.from);
            };
            if (Array.isArray(config.modifiers)) {
                var modifiers = [];
                var _iterator = $0223dfd9752fbcb9$var$_createForOfIteratorHelper(config.modifiers), _step;
                try {
                    var _loop = function _loop() {
                        var modifier = _step.value;
                        var _modifier = $0223dfd9752fbcb9$var$_slicedToArray(modifier, 2), modifierType = _modifier[0], amount = _modifier[1];
                        if (modifierType === "brighter") modifiers.push(function(color) {
                            return color.brighter(amount);
                        });
                        else if (modifierType === "darker") modifiers.push(function(color) {
                            return color.darker(amount);
                        });
                        else if (modifierType === "opacity") modifiers.push(function(color) {
                            color.opacity = amount;
                            return color;
                        });
                        else throw new Error("Invalid color modifier: '".concat(modifierType, "', must be one of: 'brighter', 'darker', 'opacity'"));
                    };
                    for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (modifiers.length === 0) return getColor;
                return function(datum) {
                    return modifiers.reduce(function(color, modify) {
                        return modify(color);
                    }, (0, $6z37v.rgb)(getColor(datum))).toString();
                };
            }
            return getColor;
        }
        throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function() {
        return config;
    };
};
var $0223dfd9752fbcb9$export$2a9e363116151414 = function useInheritedColor(config, theme) {
    return (0, $70fFQ.useMemo)(function() {
        return $0223dfd9752fbcb9$export$acb96d3092c0904(config, theme);
    }, [
        config,
        theme
    ]);
};
var $0223dfd9752fbcb9$export$5931e35698b46017 = function interpolateColor(color, springConfig) {
    var colorComponents = (0, $6z37v.rgb)(color);
    if (!springConfig) return {
        colorR: colorComponents.r,
        colorG: colorComponents.g,
        colorB: colorComponents.b
    };
    var configWithPrecision = $0223dfd9752fbcb9$var$_objectSpread2($0223dfd9752fbcb9$var$_objectSpread2({}, springConfig), {}, {
        precision: 1
    });
    return {
        colorR: (0, $als2V.spring)(colorComponents.r, configWithPrecision),
        colorG: (0, $als2V.spring)(colorComponents.g, configWithPrecision),
        colorB: (0, $als2V.spring)(colorComponents.b, configWithPrecision)
    };
};
var $0223dfd9752fbcb9$export$15b5ff079982ba95 = function getInterpolatedColor(_ref) {
    var colorR = _ref.colorR, colorG = _ref.colorG, colorB = _ref.colorB;
    return "rgb(".concat(Math.round(Math.max(colorR, 0)), ",").concat(Math.round(Math.max(colorG, 0)), ",").concat(Math.round(Math.max(colorB, 0)), ")");
};
var $0223dfd9752fbcb9$var$isOrdinalColorScaleConfigScheme = function isOrdinalColorScaleConfigScheme(config) {
    return config.scheme !== undefined;
};
var $0223dfd9752fbcb9$var$isOrdinalColorScaleConfigDatumProperty = function isOrdinalColorScaleConfigDatumProperty(config) {
    return config.datum !== undefined;
};
var $0223dfd9752fbcb9$export$c3ea10dbbf6bbab3 = function getOrdinalColorScale(config, identity) {
    if (typeof config === "function") return config;
    var getIdentity = typeof identity === "function" ? identity : function(datum) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eycjp)))(datum, identity);
    };
    if (Array.isArray(config)) {
        var scale = (0, $eZmYt.default)(config);
        var generator = function generator(datum) {
            return scale(getIdentity(datum));
        };
        generator.scale = scale;
        return generator;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cBppa)))(config)) {
        if ($0223dfd9752fbcb9$var$isOrdinalColorScaleConfigDatumProperty(config)) return function(datum) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($eycjp)))(datum, config.datum);
        };
        if ($0223dfd9752fbcb9$var$isOrdinalColorScaleConfigScheme(config)) {
            if ($0223dfd9752fbcb9$export$9f49cca6c7d1dda4(config.scheme)) {
                var _scale = (0, $eZmYt.default)($0223dfd9752fbcb9$export$2ad73d393c16f81c[config.scheme]);
                var _generator = function _generator(datum) {
                    return _scale(getIdentity(datum));
                };
                _generator.scale = _scale;
                return _generator;
            }
            if ($0223dfd9752fbcb9$export$4d028a51ab424d0b(config.scheme)) {
                if (config.size !== undefined && (config.size < 3 || config.size > 11)) throw new Error("Invalid size '".concat(config.size, "' for diverging color scheme '").concat(config.scheme, "', must be between 3~11"));
                var _scale2 = (0, $eZmYt.default)($0223dfd9752fbcb9$export$2ad73d393c16f81c[config.scheme][config.size || 11]);
                var _generator2 = function _generator2(d) {
                    return _scale2(getIdentity(d));
                };
                _generator2.scale = _scale2;
                return _generator2;
            }
            if ($0223dfd9752fbcb9$export$166c33132082d11d(config.scheme)) {
                if (config.size !== undefined && (config.size < 3 || config.size > 9)) throw new Error("Invalid size '".concat(config.size, "' for sequential color scheme '").concat(config.scheme, "', must be between 3~9"));
                var _scale3 = (0, $eZmYt.default)($0223dfd9752fbcb9$export$2ad73d393c16f81c[config.scheme][config.size || 9]);
                var _generator3 = function _generator3(d) {
                    return _scale3(getIdentity(d));
                };
                _generator3.scale = _scale3;
                return _generator3;
            }
        }
        throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function() {
        return config;
    };
};
var $0223dfd9752fbcb9$export$47939777be1516f5 = function useOrdinalColorScale(config, identity) {
    return (0, $70fFQ.useMemo)(function() {
        return $0223dfd9752fbcb9$export$c3ea10dbbf6bbab3(config, identity);
    }, [
        config,
        identity
    ]);
};
var $0223dfd9752fbcb9$export$9ef95eaec260ee21 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string),
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        scheme: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf($0223dfd9752fbcb9$export$b48661626a811234).isRequired,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        datum: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
]);
var $0223dfd9752fbcb9$export$7f7877bf575af39c = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
]);
var $0223dfd9752fbcb9$export$5f5a386483e6fff5 = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        from: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).array)
    })
]);

});
parcelRegister("8V7EI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67e995e09a1247b3$export$2e2bcd8739ae039; });
function $67e995e09a1247b3$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

});

parcelRegister("5Hs8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4266cc20517c286c$export$2e2bcd8739ae039; });
function $4266cc20517c286c$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}

});

parcelRegister("cBppa", function(module, exports) {

var $9NCzx = parcelRequire("9NCzx");

var $7NbA5 = parcelRequire("7NbA5");

var $3j9VG = parcelRequire("3j9VG");
/** `Object#toString` result references. */ var $92cca5a6bffc2f01$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $92cca5a6bffc2f01$var$funcProto = Function.prototype, $92cca5a6bffc2f01$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $92cca5a6bffc2f01$var$funcToString = $92cca5a6bffc2f01$var$funcProto.toString;
/** Used to check objects for own properties. */ var $92cca5a6bffc2f01$var$hasOwnProperty = $92cca5a6bffc2f01$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $92cca5a6bffc2f01$var$objectCtorString = $92cca5a6bffc2f01$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $92cca5a6bffc2f01$var$isPlainObject(value) {
    if (!$3j9VG(value) || $9NCzx(value) != $92cca5a6bffc2f01$var$objectTag) return false;
    var proto = $7NbA5(value);
    if (proto === null) return true;
    var Ctor = $92cca5a6bffc2f01$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $92cca5a6bffc2f01$var$funcToString.call(Ctor) == $92cca5a6bffc2f01$var$objectCtorString;
}
module.exports = $92cca5a6bffc2f01$var$isPlainObject;

});
parcelRegister("9NCzx", function(module, exports) {

var $34Ypa = parcelRequire("34Ypa");

var $6KF9D = parcelRequire("6KF9D");

var $lfmHZ = parcelRequire("lfmHZ");
/** `Object#toString` result references. */ var $72269c48e0032927$var$nullTag = "[object Null]", $72269c48e0032927$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $72269c48e0032927$var$symToStringTag = $34Ypa ? $34Ypa.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $72269c48e0032927$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $72269c48e0032927$var$undefinedTag : $72269c48e0032927$var$nullTag;
    return $72269c48e0032927$var$symToStringTag && $72269c48e0032927$var$symToStringTag in Object(value) ? $6KF9D(value) : $lfmHZ(value);
}
module.exports = $72269c48e0032927$var$baseGetTag;

});
parcelRegister("34Ypa", function(module, exports) {

var $ktzXC = parcelRequire("ktzXC");
/** Built-in value references. */ var $23e099f755542f7a$var$Symbol = $ktzXC.Symbol;
module.exports = $23e099f755542f7a$var$Symbol;

});
parcelRegister("ktzXC", function(module, exports) {

var $rJYFk = parcelRequire("rJYFk");
/** Detect free variable `self`. */ var $ee82691a27b6d3e7$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ee82691a27b6d3e7$var$root = $rJYFk || $ee82691a27b6d3e7$var$freeSelf || Function("return this")();
module.exports = $ee82691a27b6d3e7$var$root;

});
parcelRegister("rJYFk", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $05362fe67d597359$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $05362fe67d597359$var$freeGlobal;

});



parcelRegister("6KF9D", function(module, exports) {

var $34Ypa = parcelRequire("34Ypa");
/** Used for built-in method references. */ var $4ea6f660555c85a2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4ea6f660555c85a2$var$hasOwnProperty = $4ea6f660555c85a2$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4ea6f660555c85a2$var$nativeObjectToString = $4ea6f660555c85a2$var$objectProto.toString;
/** Built-in value references. */ var $4ea6f660555c85a2$var$symToStringTag = $34Ypa ? $34Ypa.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4ea6f660555c85a2$var$getRawTag(value) {
    var isOwn = $4ea6f660555c85a2$var$hasOwnProperty.call(value, $4ea6f660555c85a2$var$symToStringTag), tag = value[$4ea6f660555c85a2$var$symToStringTag];
    try {
        value[$4ea6f660555c85a2$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4ea6f660555c85a2$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4ea6f660555c85a2$var$symToStringTag] = tag;
        else delete value[$4ea6f660555c85a2$var$symToStringTag];
    }
    return result;
}
module.exports = $4ea6f660555c85a2$var$getRawTag;

});

parcelRegister("lfmHZ", function(module, exports) {
/** Used for built-in method references. */ var $f77c9d254e6ac0f5$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f77c9d254e6ac0f5$var$nativeObjectToString = $f77c9d254e6ac0f5$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f77c9d254e6ac0f5$var$objectToString(value) {
    return $f77c9d254e6ac0f5$var$nativeObjectToString.call(value);
}
module.exports = $f77c9d254e6ac0f5$var$objectToString;

});


parcelRegister("7NbA5", function(module, exports) {

var $lWzvH = parcelRequire("lWzvH");
/** Built-in value references. */ var $5ac617c4209f3301$var$getPrototype = $lWzvH(Object.getPrototypeOf, Object);
module.exports = $5ac617c4209f3301$var$getPrototype;

});
parcelRegister("lWzvH", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff9a8f5d88c2449f$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff9a8f5d88c2449f$var$overArg;

});


parcelRegister("3j9VG", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $268ad93a5bbdfdd6$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $268ad93a5bbdfdd6$var$isObjectLike;

});


parcelRegister("eycjp", function(module, exports) {

var $79aqo = parcelRequire("79aqo");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $a97dca9117315eb9$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $79aqo(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $a97dca9117315eb9$var$get;

});
parcelRegister("79aqo", function(module, exports) {

var $9oLOw = parcelRequire("9oLOw");

var $lno6z = parcelRequire("lno6z");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $534175c56a37bed2$var$baseGet(object, path) {
    path = $9oLOw(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$lno6z(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $534175c56a37bed2$var$baseGet;

});
parcelRegister("9oLOw", function(module, exports) {

var $coEBZ = parcelRequire("coEBZ");

var $8J2Es = parcelRequire("8J2Es");

var $dZDzE = parcelRequire("dZDzE");

var $ebKZI = parcelRequire("ebKZI");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $6d7b71cd82247a5e$var$castPath(value, object) {
    if ($coEBZ(value)) return value;
    return $8J2Es(value, object) ? [
        value
    ] : $dZDzE($ebKZI(value));
}
module.exports = $6d7b71cd82247a5e$var$castPath;

});
parcelRegister("coEBZ", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $90673a964e62efc3$var$isArray = Array.isArray;
module.exports = $90673a964e62efc3$var$isArray;

});

parcelRegister("8J2Es", function(module, exports) {

var $coEBZ = parcelRequire("coEBZ");

var $5p8CO = parcelRequire("5p8CO");
/** Used to match property names within property paths. */ var $65a4953d6934145b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $65a4953d6934145b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $65a4953d6934145b$var$isKey(value, object) {
    if ($coEBZ(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $5p8CO(value)) return true;
    return $65a4953d6934145b$var$reIsPlainProp.test(value) || !$65a4953d6934145b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $65a4953d6934145b$var$isKey;

});
parcelRegister("5p8CO", function(module, exports) {

var $9NCzx = parcelRequire("9NCzx");

var $3j9VG = parcelRequire("3j9VG");
/** `Object#toString` result references. */ var $3ef5fa4d00675c2e$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $3ef5fa4d00675c2e$var$isSymbol(value) {
    return typeof value == "symbol" || $3j9VG(value) && $9NCzx(value) == $3ef5fa4d00675c2e$var$symbolTag;
}
module.exports = $3ef5fa4d00675c2e$var$isSymbol;

});


parcelRegister("dZDzE", function(module, exports) {

var $68e51 = parcelRequire("68e51");
/** Used to match property names within property paths. */ var $a2ffab6c0e066b7e$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a2ffab6c0e066b7e$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a2ffab6c0e066b7e$var$stringToPath = $68e51(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($a2ffab6c0e066b7e$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a2ffab6c0e066b7e$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $a2ffab6c0e066b7e$var$stringToPath;

});
parcelRegister("68e51", function(module, exports) {

var $h0i63 = parcelRequire("h0i63");
/** Used as the maximum memoize cache size. */ var $476e69689c1ba531$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $476e69689c1ba531$var$memoizeCapped(func) {
    var result = $h0i63(func, function(key) {
        if (cache.size === $476e69689c1ba531$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $476e69689c1ba531$var$memoizeCapped;

});
parcelRegister("h0i63", function(module, exports) {

var $bi3fb = parcelRequire("bi3fb");
/** Error message constants. */ var $c6107961c4c2c643$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c6107961c4c2c643$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($c6107961c4c2c643$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c6107961c4c2c643$var$memoize.Cache || $bi3fb);
    return memoized;
}
// Expose `MapCache`.
$c6107961c4c2c643$var$memoize.Cache = $bi3fb;
module.exports = $c6107961c4c2c643$var$memoize;

});
parcelRegister("bi3fb", function(module, exports) {

var $9HKhn = parcelRequire("9HKhn");

var $dlSGe = parcelRequire("dlSGe");

var $d4PEB = parcelRequire("d4PEB");

var $4yiPG = parcelRequire("4yiPG");

var $4nwNF = parcelRequire("4nwNF");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8383e4529804a240$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$8383e4529804a240$var$MapCache.prototype.clear = $9HKhn;
$8383e4529804a240$var$MapCache.prototype["delete"] = $dlSGe;
$8383e4529804a240$var$MapCache.prototype.get = $d4PEB;
$8383e4529804a240$var$MapCache.prototype.has = $4yiPG;
$8383e4529804a240$var$MapCache.prototype.set = $4nwNF;
module.exports = $8383e4529804a240$var$MapCache;

});
parcelRegister("9HKhn", function(module, exports) {

var $jTfKb = parcelRequire("jTfKb");

var $3gsSp = parcelRequire("3gsSp");

var $4x5Z8 = parcelRequire("4x5Z8");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $710c074f1d4764a2$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $jTfKb,
        "map": new ($4x5Z8 || $3gsSp),
        "string": new $jTfKb
    };
}
module.exports = $710c074f1d4764a2$var$mapCacheClear;

});
parcelRegister("jTfKb", function(module, exports) {

var $8PiVa = parcelRequire("8PiVa");

var $lXwqn = parcelRequire("lXwqn");

var $4S6MH = parcelRequire("4S6MH");

var $hf6Rr = parcelRequire("hf6Rr");

var $iL7LV = parcelRequire("iL7LV");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e7af5dc5383e9cb3$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e7af5dc5383e9cb3$var$Hash.prototype.clear = $8PiVa;
$e7af5dc5383e9cb3$var$Hash.prototype["delete"] = $lXwqn;
$e7af5dc5383e9cb3$var$Hash.prototype.get = $4S6MH;
$e7af5dc5383e9cb3$var$Hash.prototype.has = $hf6Rr;
$e7af5dc5383e9cb3$var$Hash.prototype.set = $iL7LV;
module.exports = $e7af5dc5383e9cb3$var$Hash;

});
parcelRegister("8PiVa", function(module, exports) {

var $1WWjF = parcelRequire("1WWjF");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $66d1c37851f8dd76$var$hashClear() {
    this.__data__ = $1WWjF ? $1WWjF(null) : {};
    this.size = 0;
}
module.exports = $66d1c37851f8dd76$var$hashClear;

});
parcelRegister("1WWjF", function(module, exports) {

var $a4Ugo = parcelRequire("a4Ugo");
/* Built-in method references that are verified to be native. */ var $16b8719e1fae524c$var$nativeCreate = $a4Ugo(Object, "create");
module.exports = $16b8719e1fae524c$var$nativeCreate;

});
parcelRegister("a4Ugo", function(module, exports) {

var $cn9LK = parcelRequire("cn9LK");

var $b6aZB = parcelRequire("b6aZB");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7565ebd9b3fb470a$var$getNative(object, key) {
    var value = $b6aZB(object, key);
    return $cn9LK(value) ? value : undefined;
}
module.exports = $7565ebd9b3fb470a$var$getNative;

});
parcelRegister("cn9LK", function(module, exports) {

var $k2GhO = parcelRequire("k2GhO");

var $48YAm = parcelRequire("48YAm");

var $b2hmt = parcelRequire("b2hmt");

var $69BGk = parcelRequire("69BGk");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $901f35f8bfa4067c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $901f35f8bfa4067c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $901f35f8bfa4067c$var$funcProto = Function.prototype, $901f35f8bfa4067c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $901f35f8bfa4067c$var$funcToString = $901f35f8bfa4067c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $901f35f8bfa4067c$var$hasOwnProperty = $901f35f8bfa4067c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $901f35f8bfa4067c$var$reIsNative = RegExp("^" + $901f35f8bfa4067c$var$funcToString.call($901f35f8bfa4067c$var$hasOwnProperty).replace($901f35f8bfa4067c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $901f35f8bfa4067c$var$baseIsNative(value) {
    if (!$b2hmt(value) || $48YAm(value)) return false;
    var pattern = $k2GhO(value) ? $901f35f8bfa4067c$var$reIsNative : $901f35f8bfa4067c$var$reIsHostCtor;
    return pattern.test($69BGk(value));
}
module.exports = $901f35f8bfa4067c$var$baseIsNative;

});
parcelRegister("k2GhO", function(module, exports) {

var $9NCzx = parcelRequire("9NCzx");

var $b2hmt = parcelRequire("b2hmt");
/** `Object#toString` result references. */ var $e974cbbfbc9952d5$var$asyncTag = "[object AsyncFunction]", $e974cbbfbc9952d5$var$funcTag = "[object Function]", $e974cbbfbc9952d5$var$genTag = "[object GeneratorFunction]", $e974cbbfbc9952d5$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e974cbbfbc9952d5$var$isFunction(value) {
    if (!$b2hmt(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $9NCzx(value);
    return tag == $e974cbbfbc9952d5$var$funcTag || tag == $e974cbbfbc9952d5$var$genTag || tag == $e974cbbfbc9952d5$var$asyncTag || tag == $e974cbbfbc9952d5$var$proxyTag;
}
module.exports = $e974cbbfbc9952d5$var$isFunction;

});
parcelRegister("b2hmt", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $808d593f1c0c5f59$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $808d593f1c0c5f59$var$isObject;

});


parcelRegister("48YAm", function(module, exports) {

var $b9SAW = parcelRequire("b9SAW");
/** Used to detect methods masquerading as native. */ var $3046e7cf1c845df8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b9SAW && $b9SAW.keys && $b9SAW.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $3046e7cf1c845df8$var$isMasked(func) {
    return !!$3046e7cf1c845df8$var$maskSrcKey && $3046e7cf1c845df8$var$maskSrcKey in func;
}
module.exports = $3046e7cf1c845df8$var$isMasked;

});
parcelRegister("b9SAW", function(module, exports) {

var $ktzXC = parcelRequire("ktzXC");
/** Used to detect overreaching core-js shims. */ var $81fae2596bb36260$var$coreJsData = $ktzXC["__core-js_shared__"];
module.exports = $81fae2596bb36260$var$coreJsData;

});


parcelRegister("69BGk", function(module, exports) {
/** Used for built-in method references. */ var $47b0d02a83139f7f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $47b0d02a83139f7f$var$funcToString = $47b0d02a83139f7f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $47b0d02a83139f7f$var$toSource(func) {
    if (func != null) {
        try {
            return $47b0d02a83139f7f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $47b0d02a83139f7f$var$toSource;

});


parcelRegister("b6aZB", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8148c82a2943c27b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $8148c82a2943c27b$var$getValue;

});




parcelRegister("lXwqn", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ffc842745c0c2da4$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $ffc842745c0c2da4$var$hashDelete;

});

parcelRegister("4S6MH", function(module, exports) {

var $1WWjF = parcelRequire("1WWjF");
/** Used to stand-in for `undefined` hash values. */ var $38c177d5fdbc828b$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $38c177d5fdbc828b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $38c177d5fdbc828b$var$hasOwnProperty = $38c177d5fdbc828b$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $38c177d5fdbc828b$var$hashGet(key) {
    var data = this.__data__;
    if ($1WWjF) {
        var result = data[key];
        return result === $38c177d5fdbc828b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $38c177d5fdbc828b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $38c177d5fdbc828b$var$hashGet;

});

parcelRegister("hf6Rr", function(module, exports) {

var $1WWjF = parcelRequire("1WWjF");
/** Used for built-in method references. */ var $c8d928d9dee2220f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c8d928d9dee2220f$var$hasOwnProperty = $c8d928d9dee2220f$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c8d928d9dee2220f$var$hashHas(key) {
    var data = this.__data__;
    return $1WWjF ? data[key] !== undefined : $c8d928d9dee2220f$var$hasOwnProperty.call(data, key);
}
module.exports = $c8d928d9dee2220f$var$hashHas;

});

parcelRegister("iL7LV", function(module, exports) {

var $1WWjF = parcelRequire("1WWjF");
/** Used to stand-in for `undefined` hash values. */ var $da82a52530437aca$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $da82a52530437aca$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $1WWjF && value === undefined ? $da82a52530437aca$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $da82a52530437aca$var$hashSet;

});


parcelRegister("3gsSp", function(module, exports) {

var $lLOQo = parcelRequire("lLOQo");

var $2U1AR = parcelRequire("2U1AR");

var $jj5xm = parcelRequire("jj5xm");

var $04epZ = parcelRequire("04epZ");

var $gi5eD = parcelRequire("gi5eD");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2609440650efd633$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$2609440650efd633$var$ListCache.prototype.clear = $lLOQo;
$2609440650efd633$var$ListCache.prototype["delete"] = $2U1AR;
$2609440650efd633$var$ListCache.prototype.get = $jj5xm;
$2609440650efd633$var$ListCache.prototype.has = $04epZ;
$2609440650efd633$var$ListCache.prototype.set = $gi5eD;
module.exports = $2609440650efd633$var$ListCache;

});
parcelRegister("lLOQo", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $fd956d53deec7aaa$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $fd956d53deec7aaa$var$listCacheClear;

});

parcelRegister("2U1AR", function(module, exports) {

var $kBoFF = parcelRequire("kBoFF");
/** Used for built-in method references. */ var $21d20c2e5d855676$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $21d20c2e5d855676$var$splice = $21d20c2e5d855676$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $21d20c2e5d855676$var$listCacheDelete(key) {
    var data = this.__data__, index = $kBoFF(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $21d20c2e5d855676$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $21d20c2e5d855676$var$listCacheDelete;

});
parcelRegister("kBoFF", function(module, exports) {

var $219Nz = parcelRequire("219Nz");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $effa668251be0019$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($219Nz(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $effa668251be0019$var$assocIndexOf;

});
parcelRegister("219Nz", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $1783468df525fc1d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $1783468df525fc1d$var$eq;

});



parcelRegister("jj5xm", function(module, exports) {

var $kBoFF = parcelRequire("kBoFF");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e0e41632d6bfe08a$var$listCacheGet(key) {
    var data = this.__data__, index = $kBoFF(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $e0e41632d6bfe08a$var$listCacheGet;

});

parcelRegister("04epZ", function(module, exports) {

var $kBoFF = parcelRequire("kBoFF");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $00cb8ef96d0ac9c4$var$listCacheHas(key) {
    return $kBoFF(this.__data__, key) > -1;
}
module.exports = $00cb8ef96d0ac9c4$var$listCacheHas;

});

parcelRegister("gi5eD", function(module, exports) {

var $kBoFF = parcelRequire("kBoFF");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $bdc2635a324ac6cf$var$listCacheSet(key, value) {
    var data = this.__data__, index = $kBoFF(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $bdc2635a324ac6cf$var$listCacheSet;

});


parcelRegister("4x5Z8", function(module, exports) {

var $a4Ugo = parcelRequire("a4Ugo");

var $ktzXC = parcelRequire("ktzXC");
/* Built-in method references that are verified to be native. */ var $34cee2fdf6e93708$var$Map = $a4Ugo($ktzXC, "Map");
module.exports = $34cee2fdf6e93708$var$Map;

});


parcelRegister("dlSGe", function(module, exports) {

var $g2iep = parcelRequire("g2iep");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9b87a6dc44292310$var$mapCacheDelete(key) {
    var result = $g2iep(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9b87a6dc44292310$var$mapCacheDelete;

});
parcelRegister("g2iep", function(module, exports) {

var $kDj4O = parcelRequire("kDj4O");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $bacaf9a3bf55629c$var$getMapData(map, key) {
    var data = map.__data__;
    return $kDj4O(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $bacaf9a3bf55629c$var$getMapData;

});
parcelRegister("kDj4O", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $f0563f62715e1dd0$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $f0563f62715e1dd0$var$isKeyable;

});



parcelRegister("d4PEB", function(module, exports) {

var $g2iep = parcelRequire("g2iep");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9853b7745d132101$var$mapCacheGet(key) {
    return $g2iep(this, key).get(key);
}
module.exports = $9853b7745d132101$var$mapCacheGet;

});

parcelRegister("4yiPG", function(module, exports) {

var $g2iep = parcelRequire("g2iep");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3508f227c36a638d$var$mapCacheHas(key) {
    return $g2iep(this, key).has(key);
}
module.exports = $3508f227c36a638d$var$mapCacheHas;

});

parcelRegister("4nwNF", function(module, exports) {

var $g2iep = parcelRequire("g2iep");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3302c0d0e9ca6938$var$mapCacheSet(key, value) {
    var data = $g2iep(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $3302c0d0e9ca6938$var$mapCacheSet;

});





parcelRegister("ebKZI", function(module, exports) {

var $2AzGh = parcelRequire("2AzGh");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a5468be606df4498$var$toString(value) {
    return value == null ? "" : $2AzGh(value);
}
module.exports = $a5468be606df4498$var$toString;

});
parcelRegister("2AzGh", function(module, exports) {

var $34Ypa = parcelRequire("34Ypa");

var $ecQRY = parcelRequire("ecQRY");

var $coEBZ = parcelRequire("coEBZ");

var $5p8CO = parcelRequire("5p8CO");
/** Used as references for various `Number` constants. */ var $1e2a9f10f9638c48$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $1e2a9f10f9638c48$var$symbolProto = $34Ypa ? $34Ypa.prototype : undefined, $1e2a9f10f9638c48$var$symbolToString = $1e2a9f10f9638c48$var$symbolProto ? $1e2a9f10f9638c48$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $1e2a9f10f9638c48$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($coEBZ(value)) // Recursively convert values (susceptible to call stack limits).
    return $ecQRY(value, $1e2a9f10f9638c48$var$baseToString) + "";
    if ($5p8CO(value)) return $1e2a9f10f9638c48$var$symbolToString ? $1e2a9f10f9638c48$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$1e2a9f10f9638c48$var$INFINITY ? "-0" : result;
}
module.exports = $1e2a9f10f9638c48$var$baseToString;

});
parcelRegister("ecQRY", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a57b327c87b65996$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $a57b327c87b65996$var$arrayMap;

});




parcelRegister("lno6z", function(module, exports) {

var $5p8CO = parcelRequire("5p8CO");
/** Used as references for various `Number` constants. */ var $04041a9bc1e8c1bd$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $04041a9bc1e8c1bd$var$toKey(value) {
    if (typeof value == "string" || $5p8CO(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$04041a9bc1e8c1bd$var$INFINITY ? "-0" : result;
}
module.exports = $04041a9bc1e8c1bd$var$toKey;

});



parcelRegister("6z37v", function(module, exports) {

$parcel$export(module.exports, "rgb", function () { return rgb; });

var $fepYF = parcelRequire("fepYF");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $fepYF.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $fepYF.default)(Rgb, rgb, (0, $fepYF.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $fepYF.default)(Hsl, hsl, (0, $fepYF.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("fepYF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b16c5063619c8553$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $b16c5063619c8553$export$8b58be045bf06082; });
function $b16c5063619c8553$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $b16c5063619c8553$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("als2V", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $78819ef3bb6ea48a$export$b36281d89752ae66; }, function (v) { return $78819ef3bb6ea48a$export$b36281d89752ae66 = v; });
var $78819ef3bb6ea48a$export$1e511d4a378977f5;
var $78819ef3bb6ea48a$export$ab7b018719e111db;
var $78819ef3bb6ea48a$export$8e2db863497d88e8;
var $78819ef3bb6ea48a$export$f55099f28d39dce4;
var $78819ef3bb6ea48a$export$b36281d89752ae66;
var $78819ef3bb6ea48a$export$7afd9c1079ecedf7;
var $78819ef3bb6ea48a$export$5d0a73a0957eccf0;
var $78819ef3bb6ea48a$export$e4c0b4e3a05535fb;
"use strict";
$78819ef3bb6ea48a$export$1e511d4a378977f5 = true;
function $78819ef3bb6ea48a$var$_interopRequire(obj) {
    return obj && obj.__esModule ? obj["default"] : obj;
}

var $aMkIx = parcelRequire("aMkIx");
$78819ef3bb6ea48a$export$ab7b018719e111db = $78819ef3bb6ea48a$var$_interopRequire($aMkIx);

var $4sqVD = parcelRequire("4sqVD");
$78819ef3bb6ea48a$export$8e2db863497d88e8 = $78819ef3bb6ea48a$var$_interopRequire($4sqVD);

var $idpeu = parcelRequire("idpeu");
$78819ef3bb6ea48a$export$f55099f28d39dce4 = $78819ef3bb6ea48a$var$_interopRequire($idpeu);

var $lgk0B = parcelRequire("lgk0B");
$78819ef3bb6ea48a$export$b36281d89752ae66 = $78819ef3bb6ea48a$var$_interopRequire($lgk0B);

var $cQmRK = parcelRequire("cQmRK");
$78819ef3bb6ea48a$export$7afd9c1079ecedf7 = $78819ef3bb6ea48a$var$_interopRequire($cQmRK);

var $iJ7V0 = parcelRequire("iJ7V0");
$78819ef3bb6ea48a$export$5d0a73a0957eccf0 = $78819ef3bb6ea48a$var$_interopRequire($iJ7V0);

var $5Dn8J = parcelRequire("5Dn8J");
$78819ef3bb6ea48a$export$e4c0b4e3a05535fb = $78819ef3bb6ea48a$var$_interopRequire($5Dn8J);

});
parcelRegister("aMkIx", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $7d8e751bf9aaaab1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7d8e751bf9aaaab1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $7d8e751bf9aaaab1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7d8e751bf9aaaab1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d8e751bf9aaaab1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $f5Ps9 = parcelRequire("f5Ps9");
var $7d8e751bf9aaaab1$var$_mapToZero2 = $7d8e751bf9aaaab1$var$_interopRequireDefault($f5Ps9);

var $iJ7V0 = parcelRequire("iJ7V0");
var $7d8e751bf9aaaab1$var$_stripStyle2 = $7d8e751bf9aaaab1$var$_interopRequireDefault($iJ7V0);

var $PUFWh = parcelRequire("PUFWh");
var $7d8e751bf9aaaab1$var$_stepper4 = $7d8e751bf9aaaab1$var$_interopRequireDefault($PUFWh);

var $fjm4g = parcelRequire("fjm4g");
var $7d8e751bf9aaaab1$var$_performanceNow2 = $7d8e751bf9aaaab1$var$_interopRequireDefault($fjm4g);

var $hiF87 = parcelRequire("hiF87");
var $7d8e751bf9aaaab1$var$_raf2 = $7d8e751bf9aaaab1$var$_interopRequireDefault($hiF87);

var $1R3ID = parcelRequire("1R3ID");
var $7d8e751bf9aaaab1$var$_shouldStopAnimation2 = $7d8e751bf9aaaab1$var$_interopRequireDefault($1R3ID);

var $70fFQ = parcelRequire("70fFQ");
var $7d8e751bf9aaaab1$var$_react2 = $7d8e751bf9aaaab1$var$_interopRequireDefault($70fFQ);

var $aCgUY = parcelRequire("aCgUY");
var $7d8e751bf9aaaab1$var$_propTypes2 = $7d8e751bf9aaaab1$var$_interopRequireDefault($aCgUY);
var $7d8e751bf9aaaab1$var$msPerFrame = 1000 / 60;
var $7d8e751bf9aaaab1$var$Motion = function(_React$Component) {
    $7d8e751bf9aaaab1$var$_inherits(Motion, _React$Component);
    $7d8e751bf9aaaab1$var$_createClass(Motion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyle: $7d8e751bf9aaaab1$var$_propTypes2["default"].objectOf($7d8e751bf9aaaab1$var$_propTypes2["default"].number),
                style: $7d8e751bf9aaaab1$var$_propTypes2["default"].objectOf($7d8e751bf9aaaab1$var$_propTypes2["default"].oneOfType([
                    $7d8e751bf9aaaab1$var$_propTypes2["default"].number,
                    $7d8e751bf9aaaab1$var$_propTypes2["default"].object
                ])).isRequired,
                children: $7d8e751bf9aaaab1$var$_propTypes2["default"].func.isRequired,
                onRest: $7d8e751bf9aaaab1$var$_propTypes2["default"].func
            },
            enumerable: true
        }
    ]);
    function Motion(props) {
        var _this = this;
        $7d8e751bf9aaaab1$var$_classCallCheck(this, Motion);
        _React$Component.call(this, props);
        this.wasAnimating = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyle = null;
        this.clearUnreadPropStyle = function(destStyle) {
            var dirty = false;
            var _state = _this.state;
            var currentStyle = _state.currentStyle;
            var currentVelocity = _state.currentVelocity;
            var lastIdealStyle = _state.lastIdealStyle;
            var lastIdealVelocity = _state.lastIdealVelocity;
            for(var key in destStyle){
                if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                var styleValue = destStyle[key];
                if (typeof styleValue === "number") {
                    if (!dirty) {
                        dirty = true;
                        currentStyle = $7d8e751bf9aaaab1$var$_extends({}, currentStyle);
                        currentVelocity = $7d8e751bf9aaaab1$var$_extends({}, currentVelocity);
                        lastIdealStyle = $7d8e751bf9aaaab1$var$_extends({}, lastIdealStyle);
                        lastIdealVelocity = $7d8e751bf9aaaab1$var$_extends({}, lastIdealVelocity);
                    }
                    currentStyle[key] = styleValue;
                    currentVelocity[key] = 0;
                    lastIdealStyle[key] = styleValue;
                    lastIdealVelocity[key] = 0;
                }
            }
            if (dirty) _this.setState({
                currentStyle: currentStyle,
                currentVelocity: currentVelocity,
                lastIdealStyle: lastIdealStyle,
                lastIdealVelocity: lastIdealVelocity
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $7d8e751bf9aaaab1$var$_raf2["default"](function(timestamp) {
                // check if we need to animate in the first place
                var propsStyle = _this.props.style;
                if ($7d8e751bf9aaaab1$var$_shouldStopAnimation2["default"](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
                    if (_this.wasAnimating && _this.props.onRest) _this.props.onRest();
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.wasAnimating = false;
                    _this.accumulatedTime = 0;
                    return;
                }
                _this.wasAnimating = true;
                var currentTime = timestamp || $7d8e751bf9aaaab1$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $7d8e751bf9aaaab1$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $7d8e751bf9aaaab1$var$msPerFrame) * $7d8e751bf9aaaab1$var$msPerFrame) / $7d8e751bf9aaaab1$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $7d8e751bf9aaaab1$var$msPerFrame);
                var newLastIdealStyle = {};
                var newLastIdealVelocity = {};
                var newCurrentStyle = {};
                var newCurrentVelocity = {};
                for(var key in propsStyle){
                    if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) continue;
                    var styleValue = propsStyle[key];
                    if (typeof styleValue === "number") {
                        newCurrentStyle[key] = styleValue;
                        newCurrentVelocity[key] = 0;
                        newLastIdealStyle[key] = styleValue;
                        newLastIdealVelocity[key] = 0;
                    } else {
                        var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
                        var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
                        for(var i = 0; i < framesToCatchUp; i++){
                            var _stepper = $7d8e751bf9aaaab1$var$_stepper4["default"]($7d8e751bf9aaaab1$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            newLastIdealStyleValue = _stepper[0];
                            newLastIdealVelocityValue = _stepper[1];
                        }
                        var _stepper2 = $7d8e751bf9aaaab1$var$_stepper4["default"]($7d8e751bf9aaaab1$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                        var nextIdealX = _stepper2[0];
                        var nextIdealV = _stepper2[1];
                        newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                        newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                        newLastIdealStyle[key] = newLastIdealStyleValue;
                        newLastIdealVelocity[key] = newLastIdealVelocityValue;
                    }
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $7d8e751bf9aaaab1$var$msPerFrame;
                _this.setState({
                    currentStyle: newCurrentStyle,
                    currentVelocity: newCurrentVelocity,
                    lastIdealStyle: newLastIdealStyle,
                    lastIdealVelocity: newLastIdealVelocity
                });
                _this.unreadPropStyle = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    Motion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyle = _props.defaultStyle;
        var style = _props.style;
        var currentStyle = defaultStyle || $7d8e751bf9aaaab1$var$_stripStyle2["default"](style);
        var currentVelocity = $7d8e751bf9aaaab1$var$_mapToZero2["default"](currentStyle);
        return {
            currentStyle: currentStyle,
            currentVelocity: currentVelocity,
            lastIdealStyle: currentStyle,
            lastIdealVelocity: currentVelocity
        };
    };
    // it's possible that currentStyle's value is stale: if props is immediately
    // changed from 0 to 400 to spring(0) again, the async currentStyle is still
    // at 0 (didn't have time to tick and interpolate even once). If we naively
    // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
    // In reality currentStyle should be 400
    Motion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $7d8e751bf9aaaab1$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyle != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyle);
        this.unreadPropStyle = props.style;
        if (this.animationID == null) {
            this.prevTime = $7d8e751bf9aaaab1$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    Motion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $7d8e751bf9aaaab1$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    Motion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyle);
        return renderedChildren && $7d8e751bf9aaaab1$var$_react2["default"].Children.only(renderedChildren);
    };
    return Motion;
}($7d8e751bf9aaaab1$var$_react2["default"].Component);
module.exports["default"] = $7d8e751bf9aaaab1$var$Motion;
module.exports = module.exports["default"]; // after checking for unreadPropStyle != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

});
parcelRegister("f5Ps9", function(module, exports) {
// currently used to initiate the velocity style object to 0
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $afcf3c2b531e7e02$var$mapToZero;
function $afcf3c2b531e7e02$var$mapToZero(obj) {
    var ret = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) ret[key] = 0;
    return ret;
}
module.exports = module.exports["default"];

});

parcelRegister("iJ7V0", function(module, exports) {
// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $da22926b0f2a1a11$var$stripStyle;
function $da22926b0f2a1a11$var$stripStyle(style) {
    var ret = {};
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        ret[key] = typeof style[key] === "number" ? style[key] : style[key].val;
    }
    return ret;
}
module.exports = module.exports["default"];

});

parcelRegister("PUFWh", function(module, exports) {
// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $09c0ba187378e522$var$stepper;
var $09c0ba187378e522$var$reusedTuple = [
    0,
    0
];
function $09c0ba187378e522$var$stepper(secondPerFrame, x, v, destX, k, b, precision) {
    // Spring stiffness, in kg / s^2
    // for animations, destX is really spring length (spring at rest). initial
    // position is considered as the stretched/compressed position of a spring
    var Fspring = -k * (x - destX);
    // Damping, in kg / s
    var Fdamper = -b * v;
    // usually we put mass here, but for animation purposes, specifying mass is a
    // bit redundant. you could simply adjust k and b accordingly
    // let a = (Fspring + Fdamper) / mass;
    var a = Fspring + Fdamper;
    var newV = v + a * secondPerFrame;
    var newX = x + newV * secondPerFrame;
    if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
        $09c0ba187378e522$var$reusedTuple[0] = destX;
        $09c0ba187378e522$var$reusedTuple[1] = 0;
        return $09c0ba187378e522$var$reusedTuple;
    }
    $09c0ba187378e522$var$reusedTuple[0] = newX;
    $09c0ba187378e522$var$reusedTuple[1] = newV;
    return $09c0ba187378e522$var$reusedTuple;
}
module.exports = module.exports["default"]; // array reference around.

});

parcelRegister("fjm4g", function(module, exports) {

var $95Bnk = parcelRequire("95Bnk");
// Generated by CoffeeScript 1.7.1
(function() {
    var getNanoSeconds, hrtime, loadTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $95Bnk !== "undefined" && $95Bnk !== null && $95Bnk.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - loadTime) / 1e6;
        };
        hrtime = $95Bnk.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        loadTime = getNanoSeconds();
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});

parcelRegister("hiF87", function(module, exports) {

var $eRpio = parcelRequire("eRpio");
var $c98405ac47945111$var$root = typeof window === "undefined" ? $parcel$global : window, $c98405ac47945111$var$vendors = [
    "moz",
    "webkit"
], $c98405ac47945111$var$suffix = "AnimationFrame", $c98405ac47945111$var$raf = $c98405ac47945111$var$root["request" + $c98405ac47945111$var$suffix], $c98405ac47945111$var$caf = $c98405ac47945111$var$root["cancel" + $c98405ac47945111$var$suffix] || $c98405ac47945111$var$root["cancelRequest" + $c98405ac47945111$var$suffix];
for(var $c98405ac47945111$var$i = 0; !$c98405ac47945111$var$raf && $c98405ac47945111$var$i < $c98405ac47945111$var$vendors.length; $c98405ac47945111$var$i++){
    $c98405ac47945111$var$raf = $c98405ac47945111$var$root[$c98405ac47945111$var$vendors[$c98405ac47945111$var$i] + "Request" + $c98405ac47945111$var$suffix];
    $c98405ac47945111$var$caf = $c98405ac47945111$var$root[$c98405ac47945111$var$vendors[$c98405ac47945111$var$i] + "Cancel" + $c98405ac47945111$var$suffix] || $c98405ac47945111$var$root[$c98405ac47945111$var$vendors[$c98405ac47945111$var$i] + "CancelRequest" + $c98405ac47945111$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$c98405ac47945111$var$raf || !$c98405ac47945111$var$caf) {
    var $c98405ac47945111$var$last = 0, $c98405ac47945111$var$id = 0, $c98405ac47945111$var$queue = [], $c98405ac47945111$var$frameDuration = 1000 / 60;
    $c98405ac47945111$var$raf = function(callback) {
        if ($c98405ac47945111$var$queue.length === 0) {
            var _now = $eRpio(), next = Math.max(0, $c98405ac47945111$var$frameDuration - (_now - $c98405ac47945111$var$last));
            $c98405ac47945111$var$last = next + _now;
            setTimeout(function() {
                var cp = $c98405ac47945111$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $c98405ac47945111$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($c98405ac47945111$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $c98405ac47945111$var$queue.push({
            handle: ++$c98405ac47945111$var$id,
            callback: callback,
            cancelled: false
        });
        return $c98405ac47945111$var$id;
    };
    $c98405ac47945111$var$caf = function(handle) {
        for(var i = 0; i < $c98405ac47945111$var$queue.length; i++)if ($c98405ac47945111$var$queue[i].handle === handle) $c98405ac47945111$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $c98405ac47945111$var$raf.call($c98405ac47945111$var$root, fn);
};
module.exports.cancel = function() {
    $c98405ac47945111$var$caf.apply($c98405ac47945111$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $c98405ac47945111$var$root;
    object.requestAnimationFrame = $c98405ac47945111$var$raf;
    object.cancelAnimationFrame = $c98405ac47945111$var$caf;
};

});
parcelRegister("eRpio", function(module, exports) {

var $95Bnk = parcelRequire("95Bnk");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $95Bnk !== "undefined" && $95Bnk !== null && $95Bnk.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $95Bnk.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $95Bnk.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("1R3ID", function(module, exports) {
// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $159da033e30db1dc$var$shouldStopAnimation;
function $159da033e30db1dc$var$shouldStopAnimation(currentStyle, style, currentVelocity) {
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        if (currentVelocity[key] !== 0) return false;
        var styleValue = typeof style[key] === "number" ? style[key] : style[key].val;
        // stepper will have already taken care of rounding precision errors, so
        // won't have such thing as 0.9999 !=== 1
        if (currentStyle[key] !== styleValue) return false;
    }
    return true;
}
module.exports = module.exports["default"];

});

parcelRegister("aCgUY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7baa9388f4b7c2c1$var$ReactIs, $7baa9388f4b7c2c1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("h1tzU"))();

});
parcelRegister("h1tzU", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $jJPvY = parcelRequire("jJPvY");
function $c6497945c3df6e04$var$emptyFunction() {}
function $c6497945c3df6e04$var$emptyFunctionWithReset() {}
$c6497945c3df6e04$var$emptyFunctionWithReset.resetWarningCache = $c6497945c3df6e04$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $jJPvY) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $c6497945c3df6e04$var$emptyFunctionWithReset,
        resetWarningCache: $c6497945c3df6e04$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("jJPvY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $e5ea2e0e95f37a10$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $e5ea2e0e95f37a10$var$ReactPropTypesSecret;

});




parcelRegister("4sqVD", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $33eeaa62fc2ffdc4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $33eeaa62fc2ffdc4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $33eeaa62fc2ffdc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $33eeaa62fc2ffdc4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $33eeaa62fc2ffdc4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $f5Ps9 = parcelRequire("f5Ps9");
var $33eeaa62fc2ffdc4$var$_mapToZero2 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($f5Ps9);

var $iJ7V0 = parcelRequire("iJ7V0");
var $33eeaa62fc2ffdc4$var$_stripStyle2 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($iJ7V0);

var $PUFWh = parcelRequire("PUFWh");
var $33eeaa62fc2ffdc4$var$_stepper4 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($PUFWh);

var $fjm4g = parcelRequire("fjm4g");
var $33eeaa62fc2ffdc4$var$_performanceNow2 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($fjm4g);

var $hiF87 = parcelRequire("hiF87");
var $33eeaa62fc2ffdc4$var$_raf2 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($hiF87);

var $1R3ID = parcelRequire("1R3ID");
var $33eeaa62fc2ffdc4$var$_shouldStopAnimation2 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($1R3ID);

var $70fFQ = parcelRequire("70fFQ");
var $33eeaa62fc2ffdc4$var$_react2 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($70fFQ);

var $aCgUY = parcelRequire("aCgUY");
var $33eeaa62fc2ffdc4$var$_propTypes2 = $33eeaa62fc2ffdc4$var$_interopRequireDefault($aCgUY);
var $33eeaa62fc2ffdc4$var$msPerFrame = 1000 / 60;
function $33eeaa62fc2ffdc4$var$shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
    for(var i = 0; i < currentStyles.length; i++){
        if (!$33eeaa62fc2ffdc4$var$_shouldStopAnimation2["default"](currentStyles[i], styles[i], currentVelocities[i])) return false;
    }
    return true;
}
var $33eeaa62fc2ffdc4$var$StaggeredMotion = function(_React$Component) {
    $33eeaa62fc2ffdc4$var$_inherits(StaggeredMotion, _React$Component);
    $33eeaa62fc2ffdc4$var$_createClass(StaggeredMotion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyles: $33eeaa62fc2ffdc4$var$_propTypes2["default"].arrayOf($33eeaa62fc2ffdc4$var$_propTypes2["default"].objectOf($33eeaa62fc2ffdc4$var$_propTypes2["default"].number)),
                styles: $33eeaa62fc2ffdc4$var$_propTypes2["default"].func.isRequired,
                children: $33eeaa62fc2ffdc4$var$_propTypes2["default"].func.isRequired
            },
            enumerable: true
        }
    ]);
    function StaggeredMotion(props) {
        var _this = this;
        $33eeaa62fc2ffdc4$var$_classCallCheck(this, StaggeredMotion);
        _React$Component.call(this, props);
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _state = _this.state;
            var currentStyles = _state.currentStyles;
            var currentVelocities = _state.currentVelocities;
            var lastIdealStyles = _state.lastIdealStyles;
            var lastIdealVelocities = _state.lastIdealVelocities;
            var someDirty = false;
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i];
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            someDirty = true;
                            currentStyles[i] = $33eeaa62fc2ffdc4$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $33eeaa62fc2ffdc4$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $33eeaa62fc2ffdc4$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $33eeaa62fc2ffdc4$var$_extends({}, lastIdealVelocities[i]);
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                    }
                }
            }
            if (someDirty) _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $33eeaa62fc2ffdc4$var$_raf2["default"](function(timestamp) {
                var destStyles = _this.props.styles(_this.state.lastIdealStyles);
                // check if we need to animate in the first place
                if ($33eeaa62fc2ffdc4$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $33eeaa62fc2ffdc4$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $33eeaa62fc2ffdc4$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $33eeaa62fc2ffdc4$var$msPerFrame) * $33eeaa62fc2ffdc4$var$msPerFrame) / $33eeaa62fc2ffdc4$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $33eeaa62fc2ffdc4$var$msPerFrame);
                var newLastIdealStyles = [];
                var newLastIdealVelocities = [];
                var newCurrentStyles = [];
                var newCurrentVelocities = [];
                for(var i = 0; i < destStyles.length; i++){
                    var destStyle = destStyles[i];
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in destStyle){
                        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                        var styleValue = destStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
                            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $33eeaa62fc2ffdc4$var$_stepper4["default"]($33eeaa62fc2ffdc4$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $33eeaa62fc2ffdc4$var$_stepper4["default"]($33eeaa62fc2ffdc4$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $33eeaa62fc2ffdc4$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    StaggeredMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var currentStyles = defaultStyles || styles().map($33eeaa62fc2ffdc4$var$_stripStyle2["default"]);
        var currentVelocities = currentStyles.map(function(currentStyle) {
            return $33eeaa62fc2ffdc4$var$_mapToZero2["default"](currentStyle);
        });
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: currentStyles,
            lastIdealVelocities: currentVelocities
        };
    };
    StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $33eeaa62fc2ffdc4$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
        if (this.animationID == null) {
            this.prevTime = $33eeaa62fc2ffdc4$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $33eeaa62fc2ffdc4$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    StaggeredMotion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyles);
        return renderedChildren && $33eeaa62fc2ffdc4$var$_react2["default"].Children.only(renderedChildren);
    };
    return StaggeredMotion;
}($33eeaa62fc2ffdc4$var$_react2["default"].Component);
module.exports["default"] = $33eeaa62fc2ffdc4$var$StaggeredMotion;
module.exports = module.exports["default"]; // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400
 // after checking for unreadPropStyles != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

});

parcelRegister("idpeu", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $d42d039b943ed7fb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d42d039b943ed7fb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $d42d039b943ed7fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d42d039b943ed7fb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d42d039b943ed7fb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $f5Ps9 = parcelRequire("f5Ps9");
var $d42d039b943ed7fb$var$_mapToZero2 = $d42d039b943ed7fb$var$_interopRequireDefault($f5Ps9);

var $iJ7V0 = parcelRequire("iJ7V0");
var $d42d039b943ed7fb$var$_stripStyle2 = $d42d039b943ed7fb$var$_interopRequireDefault($iJ7V0);

var $PUFWh = parcelRequire("PUFWh");
var $d42d039b943ed7fb$var$_stepper4 = $d42d039b943ed7fb$var$_interopRequireDefault($PUFWh);

var $k6epI = parcelRequire("k6epI");
var $d42d039b943ed7fb$var$_mergeDiff2 = $d42d039b943ed7fb$var$_interopRequireDefault($k6epI);

var $fjm4g = parcelRequire("fjm4g");
var $d42d039b943ed7fb$var$_performanceNow2 = $d42d039b943ed7fb$var$_interopRequireDefault($fjm4g);

var $hiF87 = parcelRequire("hiF87");
var $d42d039b943ed7fb$var$_raf2 = $d42d039b943ed7fb$var$_interopRequireDefault($hiF87);

var $1R3ID = parcelRequire("1R3ID");
var $d42d039b943ed7fb$var$_shouldStopAnimation2 = $d42d039b943ed7fb$var$_interopRequireDefault($1R3ID);

var $70fFQ = parcelRequire("70fFQ");
var $d42d039b943ed7fb$var$_react2 = $d42d039b943ed7fb$var$_interopRequireDefault($70fFQ);

var $aCgUY = parcelRequire("aCgUY");
var $d42d039b943ed7fb$var$_propTypes2 = $d42d039b943ed7fb$var$_interopRequireDefault($aCgUY);
var $d42d039b943ed7fb$var$msPerFrame = 1000 / 60;
// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function $d42d039b943ed7fb$var$rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
    // Copy the value to a `const` so that Flow understands that the const won't
    // change and will be non-nullable in the callback below.
    var cUnreadPropStyles = unreadPropStyles;
    if (cUnreadPropStyles == null) return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
    return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        for(var j = 0; j < cUnreadPropStyles.length; j++){
            if (cUnreadPropStyles[j].key === mergedPropsStyle.key) return {
                key: cUnreadPropStyles[j].key,
                data: cUnreadPropStyles[j].data,
                style: plainStyles[i]
            };
        }
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
}
function $d42d039b943ed7fb$var$shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
    if (mergedPropsStyles.length !== destStyles.length) return false;
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (mergedPropsStyles[i].key !== destStyles[i].key) return false;
    }
    // we have the invariant that mergedPropsStyles and
    // currentStyles/currentVelocities/last* are synced in terms of cells, see
    // mergeAndSync comment for more info
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (!$d42d039b943ed7fb$var$_shouldStopAnimation2["default"](currentStyles[i], destStyles[i].style, currentVelocities[i])) return false;
    }
    return true;
}
// core key merging logic
// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key
// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function $d42d039b943ed7fb$var$mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
    var newMergedPropsStyles = $d42d039b943ed7fb$var$_mergeDiff2["default"](oldMergedPropsStyles, destStyles, function(oldIndex, oldMergedPropsStyle) {
        var leavingStyle = willLeave(oldMergedPropsStyle);
        if (leavingStyle == null) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        if ($d42d039b943ed7fb$var$_shouldStopAnimation2["default"](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        return {
            key: oldMergedPropsStyle.key,
            data: oldMergedPropsStyle.data,
            style: leavingStyle
        };
    });
    var newCurrentStyles = [];
    var newCurrentVelocities = [];
    var newLastIdealStyles = [];
    var newLastIdealVelocities = [];
    for(var i = 0; i < newMergedPropsStyles.length; i++){
        var newMergedPropsStyleCell = newMergedPropsStyles[i];
        var foundOldIndex = null;
        for(var j = 0; j < oldMergedPropsStyles.length; j++)if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
            foundOldIndex = j;
            break;
        }
        // TODO: key search code
        if (foundOldIndex == null) {
            var plainStyle = willEnter(newMergedPropsStyleCell);
            newCurrentStyles[i] = plainStyle;
            newLastIdealStyles[i] = plainStyle;
            var velocity = $d42d039b943ed7fb$var$_mapToZero2["default"](newMergedPropsStyleCell.style);
            newCurrentVelocities[i] = velocity;
            newLastIdealVelocities[i] = velocity;
        } else {
            newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
            newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
            newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
            newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
        }
    }
    return [
        newMergedPropsStyles,
        newCurrentStyles,
        newCurrentVelocities,
        newLastIdealStyles,
        newLastIdealVelocities
    ];
}
var $d42d039b943ed7fb$var$TransitionMotion = function(_React$Component) {
    $d42d039b943ed7fb$var$_inherits(TransitionMotion, _React$Component);
    $d42d039b943ed7fb$var$_createClass(TransitionMotion, null, [
        {
            key: "propTypes",
            value: {
                defaultStyles: $d42d039b943ed7fb$var$_propTypes2["default"].arrayOf($d42d039b943ed7fb$var$_propTypes2["default"].shape({
                    key: $d42d039b943ed7fb$var$_propTypes2["default"].string.isRequired,
                    data: $d42d039b943ed7fb$var$_propTypes2["default"].any,
                    style: $d42d039b943ed7fb$var$_propTypes2["default"].objectOf($d42d039b943ed7fb$var$_propTypes2["default"].number).isRequired
                })),
                styles: $d42d039b943ed7fb$var$_propTypes2["default"].oneOfType([
                    $d42d039b943ed7fb$var$_propTypes2["default"].func,
                    $d42d039b943ed7fb$var$_propTypes2["default"].arrayOf($d42d039b943ed7fb$var$_propTypes2["default"].shape({
                        key: $d42d039b943ed7fb$var$_propTypes2["default"].string.isRequired,
                        data: $d42d039b943ed7fb$var$_propTypes2["default"].any,
                        style: $d42d039b943ed7fb$var$_propTypes2["default"].objectOf($d42d039b943ed7fb$var$_propTypes2["default"].oneOfType([
                            $d42d039b943ed7fb$var$_propTypes2["default"].number,
                            $d42d039b943ed7fb$var$_propTypes2["default"].object
                        ])).isRequired
                    }))
                ]).isRequired,
                children: $d42d039b943ed7fb$var$_propTypes2["default"].func.isRequired,
                willEnter: $d42d039b943ed7fb$var$_propTypes2["default"].func,
                willLeave: $d42d039b943ed7fb$var$_propTypes2["default"].func,
                didLeave: $d42d039b943ed7fb$var$_propTypes2["default"].func
            },
            enumerable: true
        },
        {
            key: "defaultProps",
            value: {
                willEnter: function willEnter(styleThatEntered) {
                    return $d42d039b943ed7fb$var$_stripStyle2["default"](styleThatEntered.style);
                },
                // recall: returning null makes the current unmounting TransitionStyle
                // disappear immediately
                willLeave: function willLeave() {
                    return null;
                },
                didLeave: function didLeave() {}
            },
            enumerable: true
        }
    ]);
    function TransitionMotion(props) {
        var _this = this;
        $d42d039b943ed7fb$var$_classCallCheck(this, TransitionMotion);
        _React$Component.call(this, props);
        this.unmounting = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _mergeAndSync = $d42d039b943ed7fb$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
            var mergedPropsStyles = _mergeAndSync[0];
            var currentStyles = _mergeAndSync[1];
            var currentVelocities = _mergeAndSync[2];
            var lastIdealStyles = _mergeAndSync[3];
            var lastIdealVelocities = _mergeAndSync[4];
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i].style;
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            currentStyles[i] = $d42d039b943ed7fb$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $d42d039b943ed7fb$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $d42d039b943ed7fb$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $d42d039b943ed7fb$var$_extends({}, lastIdealVelocities[i]);
                            mergedPropsStyles[i] = {
                                key: mergedPropsStyles[i].key,
                                data: mergedPropsStyles[i].data,
                                style: $d42d039b943ed7fb$var$_extends({}, mergedPropsStyles[i].style)
                            };
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                        mergedPropsStyles[i].style[key] = styleValue;
                    }
                }
            }
            // unlike the other 2 components, we can't detect staleness and optionally
            // opt out of setState here. each style object's data might contain new
            // stuff we're not/cannot compare
            _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                mergedPropsStyles: mergedPropsStyles,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            if (_this.unmounting) return;
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $d42d039b943ed7fb$var$_raf2["default"](function(timestamp) {
                // https://github.com/chenglou/react-motion/pull/420
                // > if execution passes the conditional if (this.unmounting), then
                // executes async defaultRaf and after that component unmounts and after
                // that the callback of defaultRaf is called, then setState will be called
                // on unmounted component.
                if (_this.unmounting) return;
                var propStyles = _this.props.styles;
                var destStyles = typeof propStyles === "function" ? propStyles($d42d039b943ed7fb$var$rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
                // check if we need to animate in the first place
                if ($d42d039b943ed7fb$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $d42d039b943ed7fb$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $d42d039b943ed7fb$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $d42d039b943ed7fb$var$msPerFrame) * $d42d039b943ed7fb$var$msPerFrame) / $d42d039b943ed7fb$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $d42d039b943ed7fb$var$msPerFrame);
                var _mergeAndSync2 = $d42d039b943ed7fb$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
                var newMergedPropsStyles = _mergeAndSync2[0];
                var newCurrentStyles = _mergeAndSync2[1];
                var newCurrentVelocities = _mergeAndSync2[2];
                var newLastIdealStyles = _mergeAndSync2[3];
                var newLastIdealVelocities = _mergeAndSync2[4];
                for(var i = 0; i < newMergedPropsStyles.length; i++){
                    var newMergedPropsStyle = newMergedPropsStyles[i].style;
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in newMergedPropsStyle){
                        if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) continue;
                        var styleValue = newMergedPropsStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = newLastIdealStyles[i][key];
                            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $d42d039b943ed7fb$var$_stepper4["default"]($d42d039b943ed7fb$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $d42d039b943ed7fb$var$_stepper4["default"]($d42d039b943ed7fb$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $d42d039b943ed7fb$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities,
                    mergedPropsStyles: newMergedPropsStyles
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    TransitionMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var willEnter = _props.willEnter;
        var willLeave = _props.willLeave;
        var didLeave = _props.didLeave;
        var destStyles = typeof styles === "function" ? styles(defaultStyles) : styles;
        // this is special. for the first time around, we don't have a comparison
        // between last (no last) and current merged props. we'll compute last so:
        // say default is {a, b} and styles (dest style) is {b, c}, we'll
        // fabricate last as {a, b}
        var oldMergedPropsStyles = undefined;
        if (defaultStyles == null) oldMergedPropsStyles = destStyles;
        else oldMergedPropsStyles = defaultStyles.map(function(defaultStyleCell) {
            // TODO: key search code
            for(var i = 0; i < destStyles.length; i++){
                if (destStyles[i].key === defaultStyleCell.key) return destStyles[i];
            }
            return defaultStyleCell;
        });
        var oldCurrentStyles = defaultStyles == null ? destStyles.map(function(s) {
            return $d42d039b943ed7fb$var$_stripStyle2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return $d42d039b943ed7fb$var$_stripStyle2["default"](s.style);
        });
        var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function(s) {
            return $d42d039b943ed7fb$var$_mapToZero2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return $d42d039b943ed7fb$var$_mapToZero2["default"](s.style);
        });
        var _mergeAndSync3 = $d42d039b943ed7fb$var$mergeAndSync(// Because this is an old-style createReactClass component, Flow doesn't
        // understand that the willEnter and willLeave props have default values
        // and will always be present.
        willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, oldCurrentVelocities);
        var mergedPropsStyles = _mergeAndSync3[0];
        var currentStyles = _mergeAndSync3[1];
        var currentVelocities = _mergeAndSync3[2];
        var lastIdealStyles = _mergeAndSync3[3];
        var lastIdealVelocities = _mergeAndSync3[4];
        // oldLastIdealVelocities really
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: lastIdealStyles,
            lastIdealVelocities: lastIdealVelocities,
            mergedPropsStyles: mergedPropsStyles
        };
    };
    // after checking for unreadPropStyles != null, we manually go set the
    // non-interpolating values (those that are a number, without a spring
    // config)
    TransitionMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $d42d039b943ed7fb$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        var styles = props.styles;
        if (typeof styles === "function") this.unreadPropStyles = styles($d42d039b943ed7fb$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
        else this.unreadPropStyles = styles;
        if (this.animationID == null) {
            this.prevTime = $d42d039b943ed7fb$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounting = true;
        if (this.animationID != null) {
            $d42d039b943ed7fb$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    TransitionMotion.prototype.render = function render() {
        var hydratedStyles = $d42d039b943ed7fb$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
        var renderedChildren = this.props.children(hydratedStyles);
        return renderedChildren && $d42d039b943ed7fb$var$_react2["default"].Children.only(renderedChildren);
    };
    return TransitionMotion;
}($d42d039b943ed7fb$var$_react2["default"].Component);
module.exports["default"] = $d42d039b943ed7fb$var$TransitionMotion;
module.exports = module.exports["default"]; // list of styles, each containing interpolating values. Part of what's passed
 // to children function. Notice that this is
 // Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
 // data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
 // contains the key & data info (so that we only have a single source of truth
 // for these, and to save space). Check the comment for `rehydrateStyles` to
 // see how we regenerate the entirety of what's passed to children function
 // the array that keeps track of currently rendered stuff! Including stuff
 // that you've unmounted but that's still animating. This is where it lives
 // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400

});
parcelRegister("k6epI", function(module, exports) {
// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?
// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous
// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a
// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $ea1f8c7947dfc9c2$var$mergeDiff;
function $ea1f8c7947dfc9c2$var$mergeDiff(prev, next, onRemove) {
    // bookkeeping for easier access of a key's index below. This is 2 allocations +
    // potentially triggering chrome hash map mode for objs (so it might be faster
    var prevKeyIndex = {};
    for(var i = 0; i < prev.length; i++)prevKeyIndex[prev[i].key] = i;
    var nextKeyIndex = {};
    for(var i = 0; i < next.length; i++)nextKeyIndex[next[i].key] = i;
    // first, an overly elaborate way of merging prev and next, eliminating
    // duplicates (in terms of keys). If there's dupe, keep the item in next).
    // This way of writing it saves allocations
    var ret = [];
    for(var i = 0; i < next.length; i++)ret[i] = next[i];
    for(var i = 0; i < prev.length; i++)if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
        // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
        // merge in keys that the user desires to kill
        var fill = onRemove(i, prev[i]);
        if (fill != null) ret.push(fill);
    }
    // now all the items all present. Core sorting logic to have the right order
    return ret.sort(function(a, b) {
        var nextOrderA = nextKeyIndex[a.key];
        var nextOrderB = nextKeyIndex[b.key];
        var prevOrderA = prevKeyIndex[a.key];
        var prevOrderB = prevKeyIndex[b.key];
        if (nextOrderA != null && nextOrderB != null) // both keys in next
        return nextKeyIndex[a.key] - nextKeyIndex[b.key];
        else if (prevOrderA != null && prevOrderB != null) // both keys in prev
        return prevKeyIndex[a.key] - prevKeyIndex[b.key];
        else if (nextOrderA != null) {
            // key a in next, key b in prev
            // how to determine the order between a and b? We find a "pivot" (term
            // abuse), a key present in both prev and next, that is sandwiched between
            // a and b. In the context of our above example, if we're comparing a and
            // d, b's (the only) pivot
            for(var i = 0; i < next.length; i++){
                var pivot = next[i].key;
                if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
                if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) return -1;
                else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) return 1;
            }
            // pluggable. default to: next bigger than prev
            return 1;
        }
        // prevOrderA, nextOrderB
        for(var i = 0; i < next.length; i++){
            var pivot = next[i].key;
            if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
            if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) return 1;
            else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) return -1;
        }
        // pluggable. default to: next bigger than prev
        return -1;
    });
}
module.exports = module.exports["default"]; // to loop through and find a key's index each time), but I no longer care

});


parcelRegister("lgk0B", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $f7aa9ce4c097de01$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports["default"] = $f7aa9ce4c097de01$var$spring;
function $f7aa9ce4c097de01$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $cQmRK = parcelRequire("cQmRK");
var $f7aa9ce4c097de01$var$_presets2 = $f7aa9ce4c097de01$var$_interopRequireDefault($cQmRK);
var $f7aa9ce4c097de01$var$defaultConfig = $f7aa9ce4c097de01$var$_extends({}, $f7aa9ce4c097de01$var$_presets2["default"].noWobble, {
    precision: 0.01
});
function $f7aa9ce4c097de01$var$spring(val, config) {
    return $f7aa9ce4c097de01$var$_extends({}, $f7aa9ce4c097de01$var$defaultConfig, config, {
        val: val
    });
}
module.exports = module.exports["default"];

});
parcelRegister("cQmRK", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = {
    noWobble: {
        stiffness: 170,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 210,
        damping: 20
    }
};
module.exports = module.exports["default"];

});


parcelRegister("5Dn8J", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $41a28b55189eb297$var$reorderKeys;
var $41a28b55189eb297$var$hasWarned = false;
function $41a28b55189eb297$var$reorderKeys() {}
module.exports = module.exports["default"];

});



parcelRegister("4q1F4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $337ae108590d6236$export$2e2bcd8739ae039; });

var $jhh4j = parcelRequire("jhh4j");

var $iFaTn = parcelRequire("iFaTn");

var $8FFuk = parcelRequire("8FFuk");
function $337ae108590d6236$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $337ae108590d6236$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $337ae108590d6236$var$arcStartAngle(d) {
    return d.startAngle;
}
function $337ae108590d6236$var$arcEndAngle(d) {
    return d.endAngle;
}
function $337ae108590d6236$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $337ae108590d6236$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $8FFuk.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $337ae108590d6236$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $8FFuk.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $8FFuk.sqrt)((0, $8FFuk.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $337ae108590d6236$export$2e2bcd8739ae039() {
    var innerRadius = $337ae108590d6236$var$arcInnerRadius, outerRadius = $337ae108590d6236$var$arcOuterRadius, cornerRadius = (0, $iFaTn.default)(0), padRadius = null, startAngle = $337ae108590d6236$var$arcStartAngle, endAngle = $337ae108590d6236$var$arcEndAngle, padAngle = $337ae108590d6236$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $8FFuk.halfPi), a1 = endAngle.apply(this, arguments) - (0, $8FFuk.halfPi), da = (0, $8FFuk.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $jhh4j.default)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $8FFuk.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $8FFuk.tau) - (0, $8FFuk.epsilon)) {
            context.moveTo(r1 * (0, $8FFuk.cos)(a0), r1 * (0, $8FFuk.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $8FFuk.epsilon)) {
                context.moveTo(r0 * (0, $8FFuk.cos)(a1), r0 * (0, $8FFuk.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $8FFuk.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $8FFuk.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $8FFuk.min)((0, $8FFuk.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $8FFuk.epsilon)) {
                var p0 = (0, $8FFuk.asin)(rp / r0 * (0, $8FFuk.sin)(ap)), p1 = (0, $8FFuk.asin)(rp / r1 * (0, $8FFuk.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $8FFuk.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $8FFuk.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $8FFuk.cos)(a01), y01 = r1 * (0, $8FFuk.sin)(a01), x10 = r0 * (0, $8FFuk.cos)(a10), y10 = r0 * (0, $8FFuk.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $8FFuk.epsilon)) {
                var x11 = r1 * (0, $8FFuk.cos)(a11), y11 = r1 * (0, $8FFuk.sin)(a11), x00 = r0 * (0, $8FFuk.cos)(a00), y00 = r0 * (0, $8FFuk.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $8FFuk.pi) && (oc = $337ae108590d6236$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $8FFuk.sin)((0, $8FFuk.acos)((ax * bx + ay * by) / ((0, $8FFuk.sqrt)(ax * ax + ay * ay) * (0, $8FFuk.sqrt)(bx * bx + by * by))) / 2), lc = (0, $8FFuk.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $8FFuk.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $8FFuk.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $8FFuk.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $8FFuk.epsilon)) {
                t0 = $337ae108590d6236$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $337ae108590d6236$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $8FFuk.atan2)(t0.y01, t0.x01), (0, $8FFuk.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $8FFuk.atan2)(t0.y01, t0.x01), (0, $8FFuk.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $8FFuk.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8FFuk.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $8FFuk.atan2)(t1.y11, t1.x11), (0, $8FFuk.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $8FFuk.epsilon)) || !(da0 > (0, $8FFuk.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $8FFuk.epsilon)) {
                t0 = $337ae108590d6236$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $337ae108590d6236$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $8FFuk.atan2)(t0.y01, t0.x01), (0, $8FFuk.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $8FFuk.atan2)(t0.y01, t0.x01), (0, $8FFuk.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $8FFuk.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8FFuk.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $8FFuk.atan2)(t1.y11, t1.x11), (0, $8FFuk.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $8FFuk.pi) / 2;
        return [
            (0, $8FFuk.cos)(a) * r,
            (0, $8FFuk.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("jhh4j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e08cd8531b64f548$export$2e2bcd8739ae039; });
var $e08cd8531b64f548$var$pi = Math.PI, $e08cd8531b64f548$var$tau = 2 * $e08cd8531b64f548$var$pi, $e08cd8531b64f548$var$epsilon = 1e-6, $e08cd8531b64f548$var$tauEpsilon = $e08cd8531b64f548$var$tau - $e08cd8531b64f548$var$epsilon;
function $e08cd8531b64f548$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $e08cd8531b64f548$var$path() {
    return new $e08cd8531b64f548$var$Path;
}
$e08cd8531b64f548$var$Path.prototype = $e08cd8531b64f548$var$path.prototype = {
    constructor: $e08cd8531b64f548$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $e08cd8531b64f548$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $e08cd8531b64f548$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($e08cd8531b64f548$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $e08cd8531b64f548$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $e08cd8531b64f548$var$epsilon || Math.abs(this._y1 - y0) > $e08cd8531b64f548$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $e08cd8531b64f548$var$tau + $e08cd8531b64f548$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $e08cd8531b64f548$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $e08cd8531b64f548$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $e08cd8531b64f548$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $e08cd8531b64f548$export$2e2bcd8739ae039 = $e08cd8531b64f548$var$path;

});

parcelRegister("iFaTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d96481497d0cebd8$export$2e2bcd8739ae039; });
function $d96481497d0cebd8$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});


parcelRegister("7Gyiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59870f57320a9d95$export$2e2bcd8739ae039; });

var $jhh4j = parcelRequire("jhh4j");

var $iFaTn = parcelRequire("iFaTn");

var $ehI3a = parcelRequire("ehI3a");

var $5Jig7 = parcelRequire("5Jig7");
function $59870f57320a9d95$export$2e2bcd8739ae039() {
    var x = (0, $5Jig7.x), y = (0, $5Jig7.y), defined = (0, $iFaTn.default)(true), context = null, curve = (0, $ehI3a.default), output = null;
    function line(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $jhh4j.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $iFaTn.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("5Jig7", function(module, exports) {

$parcel$export(module.exports, "x", function () { return $42bf518fb7afdbaf$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $42bf518fb7afdbaf$export$4a5767248b18ef41; });
function $42bf518fb7afdbaf$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $42bf518fb7afdbaf$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("fpOVP", function(module, exports) {

$parcel$export(module.exports, "BoxLegendSvg", function () { return $b390b2ce44bb316b$export$238a2f791d4948f7; });
$parcel$export(module.exports, "renderLegendToCanvas", function () { return $b390b2ce44bb316b$export$28c0156604402604; });
$parcel$export(module.exports, "LegendPropShape", function () { return $b390b2ce44bb316b$export$b3fa7ef443b640af; });

var $70fFQ = parcelRequire("70fFQ");

var $2qXGl = parcelRequire("2qXGl");

var $4x3bm = parcelRequire("4x3bm");

var $cd0Jr = parcelRequire("cd0Jr");
function $b390b2ce44bb316b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b390b2ce44bb316b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b390b2ce44bb316b$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b390b2ce44bb316b$var$ownKeys(Object(source), true).forEach(function(key) {
            $b390b2ce44bb316b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b390b2ce44bb316b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b390b2ce44bb316b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b390b2ce44bb316b$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b390b2ce44bb316b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b390b2ce44bb316b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b390b2ce44bb316b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b390b2ce44bb316b$var$_arrayLikeToArray(o, minLen);
}
function $b390b2ce44bb316b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b390b2ce44bb316b$var$_slicedToArray(arr, i) {
    return $b390b2ce44bb316b$var$_arrayWithHoles(arr) || $b390b2ce44bb316b$var$_iterableToArrayLimit(arr, i) || $b390b2ce44bb316b$var$_unsupportedIterableToArray(arr, i) || $b390b2ce44bb316b$var$_nonIterableRest();
}
var $b390b2ce44bb316b$var$isObject = function isObject(item) {
    return typeof item === "object" && !Array.isArray(item) && item !== null;
};
var $b390b2ce44bb316b$var$zeroPadding = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $b390b2ce44bb316b$var$computeDimensions = function computeDimensions(_ref) {
    var direction = _ref.direction, itemsSpacing = _ref.itemsSpacing, _padding = _ref.padding, itemCount = _ref.itemCount, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight;
    if (typeof _padding !== "number" && !$b390b2ce44bb316b$var$isObject(_padding)) throw new Error("Invalid property padding, must be one of: number, object");
    var padding = typeof _padding === "number" ? {
        top: _padding,
        right: _padding,
        bottom: _padding,
        left: _padding
    } : $b390b2ce44bb316b$var$_objectSpread2($b390b2ce44bb316b$var$_objectSpread2({}, $b390b2ce44bb316b$var$zeroPadding), _padding);
    var horizontalPadding = padding.left + padding.right;
    var verticalPadding = padding.top + padding.bottom;
    var width = itemWidth + horizontalPadding;
    var height = itemHeight + verticalPadding;
    var spacing = (itemCount - 1) * itemsSpacing;
    if (direction === "row") width = itemWidth * itemCount + spacing + horizontalPadding;
    else if (direction === "column") height = itemHeight * itemCount + spacing + verticalPadding;
    return {
        width: width,
        height: height,
        padding: padding
    };
};
var $b390b2ce44bb316b$var$computePositionFromAnchor = function computePositionFromAnchor(_ref2) {
    var anchor = _ref2.anchor, translateX = _ref2.translateX, translateY = _ref2.translateY, containerWidth = _ref2.containerWidth, containerHeight = _ref2.containerHeight, width = _ref2.width, height = _ref2.height;
    var x = translateX;
    var y = translateY;
    switch(anchor){
        case "top":
            x += (containerWidth - width) / 2;
            break;
        case "top-right":
            x += containerWidth - width;
            break;
        case "right":
            x += containerWidth - width;
            y += (containerHeight - height) / 2;
            break;
        case "bottom-right":
            x += containerWidth - width;
            y += containerHeight - height;
            break;
        case "bottom":
            x += (containerWidth - width) / 2;
            y += containerHeight - height;
            break;
        case "bottom-left":
            y += containerHeight - height;
            break;
        case "left":
            y += (containerHeight - height) / 2;
            break;
        case "center":
            x += (containerWidth - width) / 2;
            y += (containerHeight - height) / 2;
            break;
    }
    return {
        x: x,
        y: y
    };
};
var $b390b2ce44bb316b$var$computeItemLayout = function computeItemLayout(_ref3) {
    var direction = _ref3.direction, justify = _ref3.justify, symbolSize = _ref3.symbolSize, symbolSpacing = _ref3.symbolSpacing, width = _ref3.width, height = _ref3.height;
    var symbolX;
    var symbolY;
    var labelX;
    var labelY;
    var labelAnchor;
    var labelAlignment;
    switch(direction){
        case "left-to-right":
            symbolX = 0;
            symbolY = (height - symbolSize) / 2;
            labelY = height / 2;
            labelAlignment = "central";
            if (justify === true) {
                labelX = width;
                labelAnchor = "end";
            } else {
                labelX = symbolSize + symbolSpacing;
                labelAnchor = "start";
            }
            break;
        case "right-to-left":
            symbolX = width - symbolSize;
            symbolY = (height - symbolSize) / 2;
            labelY = height / 2;
            labelAlignment = "central";
            if (justify === true) {
                labelX = 0;
                labelAnchor = "start";
            } else {
                labelX = width - symbolSize - symbolSpacing;
                labelAnchor = "end";
            }
            break;
        case "top-to-bottom":
            symbolX = (width - symbolSize) / 2;
            symbolY = 0;
            labelX = width / 2;
            labelAnchor = "middle";
            if (justify === true) {
                labelY = height;
                labelAlignment = "alphabetic";
            } else {
                labelY = symbolSize + symbolSpacing;
                labelAlignment = "text-before-edge";
            }
            break;
        case "bottom-to-top":
            symbolX = (width - symbolSize) / 2;
            symbolY = height - symbolSize;
            labelX = width / 2;
            labelAnchor = "middle";
            if (justify === true) {
                labelY = 0;
                labelAlignment = "text-before-edge";
            } else {
                labelY = height - symbolSize - symbolSpacing;
                labelAlignment = "alphabetic";
            }
            break;
    }
    return {
        symbolX: symbolX,
        symbolY: symbolY,
        labelX: labelX,
        labelY: labelY,
        labelAnchor: labelAnchor,
        labelAlignment: labelAlignment
    };
};
var $b390b2ce44bb316b$var$SymbolCircle = function SymbolCircle(_ref) {
    var x = _ref.x, y = _ref.y, size = _ref.size, fill = _ref.fill, _ref$opacity = _ref.opacity, opacity = _ref$opacity === void 0 ? 1 : _ref$opacity, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "transparent" : _ref$borderColor;
    return (0, $4x3bm.jsx)("circle", {
        r: size / 2,
        cx: x + size / 2,
        cy: y + size / 2,
        fill: fill,
        opacity: opacity,
        strokeWidth: borderWidth,
        stroke: borderColor,
        style: {
            pointerEvents: "none"
        }
    });
};
var $b390b2ce44bb316b$var$SymbolDiamond = function SymbolDiamond(_ref) {
    var x = _ref.x, y = _ref.y, size = _ref.size, fill = _ref.fill, _ref$opacity = _ref.opacity, opacity = _ref$opacity === void 0 ? 1 : _ref$opacity, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "transparent" : _ref$borderColor;
    return (0, $4x3bm.jsx)("g", {
        transform: "translate(".concat(x, ",").concat(y, ")"),
        children: (0, $4x3bm.jsx)("path", {
            d: "\n                    M".concat(size / 2, " 0\n                    L").concat(size * 0.8, " ").concat(size / 2, "\n                    L").concat(size / 2, " ").concat(size, "\n                    L").concat(size * 0.2, " ").concat(size / 2, "\n                    L").concat(size / 2, " 0\n                "),
            fill: fill,
            opacity: opacity,
            strokeWidth: borderWidth,
            stroke: borderColor,
            style: {
                pointerEvents: "none"
            }
        })
    });
};
var $b390b2ce44bb316b$var$SymbolSquare = function SymbolSquare(_ref) {
    var x = _ref.x, y = _ref.y, size = _ref.size, fill = _ref.fill, _ref$opacity = _ref.opacity, opacity = _ref$opacity === void 0 ? 1 : _ref$opacity, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "transparent" : _ref$borderColor;
    return (0, $4x3bm.jsx)("rect", {
        x: x,
        y: y,
        fill: fill,
        opacity: opacity,
        strokeWidth: borderWidth,
        stroke: borderColor,
        width: size,
        height: size,
        style: {
            pointerEvents: "none"
        }
    });
};
var $b390b2ce44bb316b$var$SymbolTriangle = function SymbolTriangle(_ref) {
    var x = _ref.x, y = _ref.y, size = _ref.size, fill = _ref.fill, _ref$opacity = _ref.opacity, opacity = _ref$opacity === void 0 ? 1 : _ref$opacity, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "transparent" : _ref$borderColor;
    return (0, $4x3bm.jsx)("g", {
        transform: "translate(".concat(x, ",").concat(y, ")"),
        children: (0, $4x3bm.jsx)("path", {
            d: "\n                M".concat(size / 2, " 0\n                L").concat(size, " ").concat(size, "\n                L0 ").concat(size, "\n                L").concat(size / 2, " 0\n            "),
            fill: fill,
            opacity: opacity,
            strokeWidth: borderWidth,
            stroke: borderColor,
            style: {
                pointerEvents: "none"
            }
        })
    });
};
var $b390b2ce44bb316b$var$symbolByShape = {
    circle: $b390b2ce44bb316b$var$SymbolCircle,
    diamond: $b390b2ce44bb316b$var$SymbolDiamond,
    square: $b390b2ce44bb316b$var$SymbolSquare,
    triangle: $b390b2ce44bb316b$var$SymbolTriangle
};
var $b390b2ce44bb316b$export$cfc3a318dc419256 = function LegendSvgItem(_ref) {
    var _style$symbolSize, _style$itemOpacity, _style$itemBackground, _style$symbolSize2, _ref4, _data$fill, _style$symbolBorderWi, _style$symbolBorderCo, _ref5, _ref6, _style$itemTextColor;
    var x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height, data = _ref.data, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? "left-to-right" : _ref$direction, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? false : _ref$justify, textColor = _ref.textColor, _ref$background = _ref.background, background = _ref$background === void 0 ? "transparent" : _ref$background, _ref$opacity = _ref.opacity, opacity = _ref$opacity === void 0 ? 1 : _ref$opacity, _ref$symbolShape = _ref.symbolShape, symbolShape = _ref$symbolShape === void 0 ? "square" : _ref$symbolShape, _ref$symbolSize = _ref.symbolSize, symbolSize = _ref$symbolSize === void 0 ? 16 : _ref$symbolSize, _ref$symbolSpacing = _ref.symbolSpacing, symbolSpacing = _ref$symbolSpacing === void 0 ? 8 : _ref$symbolSpacing, _ref$symbolBorderWidt = _ref.symbolBorderWidth, symbolBorderWidth = _ref$symbolBorderWidt === void 0 ? 0 : _ref$symbolBorderWidt, _ref$symbolBorderColo = _ref.symbolBorderColor, symbolBorderColor = _ref$symbolBorderColo === void 0 ? "transparent" : _ref$symbolBorderColo, _onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, toggleSerie = _ref.toggleSerie, effects = _ref.effects;
    var _useState = (0, $70fFQ.useState)({}), _useState2 = $b390b2ce44bb316b$var$_slicedToArray(_useState, 2), style = _useState2[0], setStyle = _useState2[1];
    var theme = (0, $2qXGl.useTheme)();
    var handleMouseEnter = (0, $70fFQ.useCallback)(function(event) {
        if (effects) {
            var applyEffects = effects.filter(function(_ref2) {
                var on = _ref2.on;
                return on === "hover";
            });
            var _style = applyEffects.reduce(function(acc, effect) {
                return $b390b2ce44bb316b$var$_objectSpread2($b390b2ce44bb316b$var$_objectSpread2({}, acc), effect.style);
            }, {});
            setStyle(_style);
        }
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter(data, event);
    }, [
        onMouseEnter,
        data,
        effects
    ]);
    var handleMouseLeave = (0, $70fFQ.useCallback)(function(event) {
        if (effects) {
            var applyEffects = effects.filter(function(_ref3) {
                var on = _ref3.on;
                return on !== "hover";
            });
            var _style2 = applyEffects.reduce(function(acc, effect) {
                return $b390b2ce44bb316b$var$_objectSpread2($b390b2ce44bb316b$var$_objectSpread2({}, acc), effect.style);
            }, {});
            setStyle(_style2);
        }
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave(data, event);
    }, [
        onMouseLeave,
        data,
        effects
    ]);
    var _computeItemLayout = $b390b2ce44bb316b$var$computeItemLayout({
        direction: direction,
        justify: justify,
        symbolSize: (_style$symbolSize = style.symbolSize) !== null && _style$symbolSize !== void 0 ? _style$symbolSize : symbolSize,
        symbolSpacing: symbolSpacing,
        width: width,
        height: height
    }), symbolX = _computeItemLayout.symbolX, symbolY = _computeItemLayout.symbolY, labelX = _computeItemLayout.labelX, labelY = _computeItemLayout.labelY, labelAnchor = _computeItemLayout.labelAnchor, labelAlignment = _computeItemLayout.labelAlignment;
    var isInteractive = [
        _onClick,
        onMouseEnter,
        onMouseLeave,
        toggleSerie
    ].some(function(handler) {
        return handler !== undefined;
    });
    var SymbolShape = typeof symbolShape === "function" ? symbolShape : $b390b2ce44bb316b$var$symbolByShape[symbolShape];
    return (0, $4x3bm.jsxs)("g", {
        transform: "translate(".concat(x, ",").concat(y, ")"),
        style: {
            opacity: (_style$itemOpacity = style.itemOpacity) !== null && _style$itemOpacity !== void 0 ? _style$itemOpacity : opacity
        },
        children: [
            (0, $4x3bm.jsx)("rect", {
                width: width,
                height: height,
                fill: (_style$itemBackground = style.itemBackground) !== null && _style$itemBackground !== void 0 ? _style$itemBackground : background,
                style: {
                    cursor: isInteractive ? "pointer" : "auto"
                },
                onClick: function onClick(event) {
                    _onClick === null || _onClick === void 0 || _onClick(data, event);
                    toggleSerie === null || toggleSerie === void 0 || toggleSerie(data.id);
                },
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave
            }),
            (0, $70fFQ.createElement)(SymbolShape, $b390b2ce44bb316b$var$_objectSpread2({
                id: data.id,
                x: symbolX,
                y: symbolY,
                size: (_style$symbolSize2 = style.symbolSize) !== null && _style$symbolSize2 !== void 0 ? _style$symbolSize2 : symbolSize,
                fill: (_ref4 = (_data$fill = data.fill) !== null && _data$fill !== void 0 ? _data$fill : data.color) !== null && _ref4 !== void 0 ? _ref4 : "black",
                borderWidth: (_style$symbolBorderWi = style.symbolBorderWidth) !== null && _style$symbolBorderWi !== void 0 ? _style$symbolBorderWi : symbolBorderWidth,
                borderColor: (_style$symbolBorderCo = style.symbolBorderColor) !== null && _style$symbolBorderCo !== void 0 ? _style$symbolBorderCo : symbolBorderColor
            }, data.hidden ? theme.legends.hidden.symbol : undefined)),
            (0, $4x3bm.jsx)("text", {
                textAnchor: labelAnchor,
                style: $b390b2ce44bb316b$var$_objectSpread2($b390b2ce44bb316b$var$_objectSpread2({}, theme.legends.text), {}, {
                    fill: (_ref5 = (_ref6 = (_style$itemTextColor = style.itemTextColor) !== null && _style$itemTextColor !== void 0 ? _style$itemTextColor : textColor) !== null && _ref6 !== void 0 ? _ref6 : theme.legends.text.fill) !== null && _ref5 !== void 0 ? _ref5 : "black",
                    dominantBaseline: labelAlignment,
                    pointerEvents: "none",
                    userSelect: "none"
                }, data.hidden ? theme.legends.hidden.text : undefined),
                x: labelX,
                y: labelY,
                children: data.label
            })
        ]
    });
};
var $b390b2ce44bb316b$export$31ce35324c7aa71 = function LegendSvg(_ref) {
    var data = _ref.data, x = _ref.x, y = _ref.y, direction = _ref.direction, _ref$padding = _ref.padding, _padding = _ref$padding === void 0 ? 0 : _ref$padding, justify = _ref.justify, effects = _ref.effects, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight, _ref$itemDirection = _ref.itemDirection, itemDirection = _ref$itemDirection === void 0 ? "left-to-right" : _ref$itemDirection, _ref$itemsSpacing = _ref.itemsSpacing, itemsSpacing = _ref$itemsSpacing === void 0 ? 0 : _ref$itemsSpacing, itemTextColor = _ref.itemTextColor, _ref$itemBackground = _ref.itemBackground, itemBackground = _ref$itemBackground === void 0 ? "transparent" : _ref$itemBackground, _ref$itemOpacity = _ref.itemOpacity, itemOpacity = _ref$itemOpacity === void 0 ? 1 : _ref$itemOpacity, symbolShape = _ref.symbolShape, symbolSize = _ref.symbolSize, symbolSpacing = _ref.symbolSpacing, symbolBorderWidth = _ref.symbolBorderWidth, symbolBorderColor = _ref.symbolBorderColor, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, toggleSerie = _ref.toggleSerie;
    var _computeDimensions = $b390b2ce44bb316b$var$computeDimensions({
        itemCount: data.length,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemsSpacing: itemsSpacing,
        direction: direction,
        padding: _padding
    }), padding = _computeDimensions.padding;
    var xStep = direction === "row" ? itemWidth + itemsSpacing : 0;
    var yStep = direction === "column" ? itemHeight + itemsSpacing : 0;
    return (0, $4x3bm.jsx)("g", {
        transform: "translate(".concat(x, ",").concat(y, ")"),
        children: data.map(function(data, i) {
            return (0, $4x3bm.jsx)($b390b2ce44bb316b$export$cfc3a318dc419256, {
                data: data,
                x: i * xStep + padding.left,
                y: i * yStep + padding.top,
                width: itemWidth,
                height: itemHeight,
                direction: itemDirection,
                justify: justify,
                effects: effects,
                textColor: itemTextColor,
                background: itemBackground,
                opacity: itemOpacity,
                symbolShape: symbolShape,
                symbolSize: symbolSize,
                symbolSpacing: symbolSpacing,
                symbolBorderWidth: symbolBorderWidth,
                symbolBorderColor: symbolBorderColor,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                toggleSerie: toggleSerie
            }, i);
        })
    });
};
var $b390b2ce44bb316b$export$238a2f791d4948f7 = function BoxLegendSvg(_ref) {
    var data = _ref.data, containerWidth = _ref.containerWidth, containerHeight = _ref.containerHeight, _ref$translateX = _ref.translateX, translateX = _ref$translateX === void 0 ? 0 : _ref$translateX, _ref$translateY = _ref.translateY, translateY = _ref$translateY === void 0 ? 0 : _ref$translateY, anchor = _ref.anchor, direction = _ref.direction, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 0 : _ref$padding, justify = _ref.justify, _ref$itemsSpacing = _ref.itemsSpacing, itemsSpacing = _ref$itemsSpacing === void 0 ? 0 : _ref$itemsSpacing, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight, itemDirection = _ref.itemDirection, itemTextColor = _ref.itemTextColor, itemBackground = _ref.itemBackground, itemOpacity = _ref.itemOpacity, symbolShape = _ref.symbolShape, symbolSize = _ref.symbolSize, symbolSpacing = _ref.symbolSpacing, symbolBorderWidth = _ref.symbolBorderWidth, symbolBorderColor = _ref.symbolBorderColor, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, toggleSerie = _ref.toggleSerie, effects = _ref.effects;
    var _computeDimensions = $b390b2ce44bb316b$var$computeDimensions({
        itemCount: data.length,
        itemsSpacing: itemsSpacing,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        direction: direction,
        padding: padding
    }), width = _computeDimensions.width, height = _computeDimensions.height;
    var _computePositionFromA = $b390b2ce44bb316b$var$computePositionFromAnchor({
        anchor: anchor,
        translateX: translateX,
        translateY: translateY,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        width: width,
        height: height
    }), x = _computePositionFromA.x, y = _computePositionFromA.y;
    return (0, $4x3bm.jsx)($b390b2ce44bb316b$export$31ce35324c7aa71, {
        data: data,
        x: x,
        y: y,
        direction: direction,
        padding: padding,
        justify: justify,
        effects: effects,
        itemsSpacing: itemsSpacing,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemDirection: itemDirection,
        itemTextColor: itemTextColor,
        itemBackground: itemBackground,
        itemOpacity: itemOpacity,
        symbolShape: symbolShape,
        symbolSize: symbolSize,
        symbolSpacing: symbolSpacing,
        symbolBorderWidth: symbolBorderWidth,
        symbolBorderColor: symbolBorderColor,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        toggleSerie: typeof toggleSerie === "boolean" ? undefined : toggleSerie
    });
};
var $b390b2ce44bb316b$var$textAlignMapping = {
    start: "left",
    middle: "center",
    end: "right"
};
var $b390b2ce44bb316b$export$28c0156604402604 = function renderLegendToCanvas(ctx, _ref) {
    var data = _ref.data, containerWidth = _ref.containerWidth, containerHeight = _ref.containerHeight, _ref$translateX = _ref.translateX, translateX = _ref$translateX === void 0 ? 0 : _ref$translateX, _ref$translateY = _ref.translateY, translateY = _ref$translateY === void 0 ? 0 : _ref$translateY, anchor = _ref.anchor, direction = _ref.direction, _ref$padding = _ref.padding, _padding = _ref$padding === void 0 ? 0 : _ref$padding, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? false : _ref$justify, _ref$itemsSpacing = _ref.itemsSpacing, itemsSpacing = _ref$itemsSpacing === void 0 ? 0 : _ref$itemsSpacing, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight, _ref$itemDirection = _ref.itemDirection, itemDirection = _ref$itemDirection === void 0 ? "left-to-right" : _ref$itemDirection, itemTextColor = _ref.itemTextColor, _ref$symbolSize = _ref.symbolSize, symbolSize = _ref$symbolSize === void 0 ? 16 : _ref$symbolSize, _ref$symbolSpacing = _ref.symbolSpacing, symbolSpacing = _ref$symbolSpacing === void 0 ? 8 : _ref$symbolSpacing, theme = _ref.theme;
    var _computeDimensions = $b390b2ce44bb316b$var$computeDimensions({
        itemCount: data.length,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemsSpacing: itemsSpacing,
        direction: direction,
        padding: _padding
    }), width = _computeDimensions.width, height = _computeDimensions.height, padding = _computeDimensions.padding;
    var _computePositionFromA = $b390b2ce44bb316b$var$computePositionFromAnchor({
        anchor: anchor,
        translateX: translateX,
        translateY: translateY,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        width: width,
        height: height
    }), x = _computePositionFromA.x, y = _computePositionFromA.y;
    var xStep = direction === "row" ? itemWidth + itemsSpacing : 0;
    var yStep = direction === "column" ? itemHeight + itemsSpacing : 0;
    ctx.save();
    ctx.translate(x, y);
    ctx.font = "".concat(theme.legends.text.fontSize, "px ").concat(theme.legends.text.fontFamily || "sans-serif");
    data.forEach(function(d, i) {
        var _d$color, _ref2;
        var itemX = i * xStep + padding.left;
        var itemY = i * yStep + padding.top;
        var _computeItemLayout = $b390b2ce44bb316b$var$computeItemLayout({
            direction: itemDirection,
            justify: justify,
            symbolSize: symbolSize,
            symbolSpacing: symbolSpacing,
            width: itemWidth,
            height: itemHeight
        }), symbolX = _computeItemLayout.symbolX, symbolY = _computeItemLayout.symbolY, labelX = _computeItemLayout.labelX, labelY = _computeItemLayout.labelY, labelAnchor = _computeItemLayout.labelAnchor, labelAlignment = _computeItemLayout.labelAlignment;
        ctx.fillStyle = (_d$color = d.color) !== null && _d$color !== void 0 ? _d$color : "black";
        ctx.fillRect(itemX + symbolX, itemY + symbolY, symbolSize, symbolSize);
        ctx.textAlign = $b390b2ce44bb316b$var$textAlignMapping[labelAnchor];
        if (labelAlignment === "central") ctx.textBaseline = "middle";
        ctx.fillStyle = (_ref2 = itemTextColor !== null && itemTextColor !== void 0 ? itemTextColor : theme.legends.text.fill) !== null && _ref2 !== void 0 ? _ref2 : "black";
        ctx.fillText(String(d.label), itemX + labelX, itemY + labelY);
    });
    ctx.restore();
};
var $b390b2ce44bb316b$export$419bf2ab46804c4 = function useQuantizeColorScaleLegendData(_ref) {
    var scale = _ref.scale, overriddenDomain = _ref.domain, _ref$reverse = _ref.reverse, reverse = _ref$reverse === void 0 ? false : _ref$reverse, _ref$valueFormat = _ref.valueFormat, valueFormat = _ref$valueFormat === void 0 ? function(v) {
        return v;
    } : _ref$valueFormat, _ref$separator = _ref.separator, separator = _ref$separator === void 0 ? " - " : _ref$separator;
    return (0, $70fFQ.useMemo)(function() {
        var domain = overriddenDomain !== null && overriddenDomain !== void 0 ? overriddenDomain : scale.range();
        var items = domain.map(function(domainValue, index) {
            var _scale$invertExtent = scale.invertExtent(domainValue), _scale$invertExtent2 = $b390b2ce44bb316b$var$_slicedToArray(_scale$invertExtent, 2), start = _scale$invertExtent2[0], end = _scale$invertExtent2[1];
            return {
                id: domainValue,
                index: index,
                extent: [
                    start,
                    end
                ],
                label: "".concat(valueFormat(start)).concat(separator).concat(valueFormat(end)),
                value: scale(start),
                color: domainValue
            };
        });
        if (reverse === true) items.reverse();
        return items;
    }, [
        overriddenDomain,
        scale,
        reverse
    ]);
};
var $b390b2ce44bb316b$export$b3fa7ef443b640af = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object),
    anchor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left",
        "top-left",
        "center"
    ]).isRequired,
    translateX: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    translateY: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        "row",
        "column"
    ]).isRequired,
    itemsSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    itemWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    itemHeight: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    itemDirection: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        "left-to-right",
        "right-to-left",
        "top-to-bottom",
        "bottom-to-top"
    ]),
    itemTextColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    itemBackground: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    itemOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    symbolShape: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
            "circle",
            "diamond",
            "square",
            "triangle"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    ]),
    symbolSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    symbolSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    symbolBorderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    symbolBorderColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    effects: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        on: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
                "hover"
            ])
        ]).isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            itemTextColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            itemBackground: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            itemOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            symbolSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            symbolBorderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            symbolBorderColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
        }).isRequired
    }))
};

});

parcelRegister("b4aj1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80e80ff41425f8d1$export$2e2bcd8739ae039; });

var $iFaTn = parcelRequire("iFaTn");

var $cP2ti = parcelRequire("cP2ti");

var $HbBV6 = parcelRequire("HbBV6");

var $8FFuk = parcelRequire("8FFuk");
function $80e80ff41425f8d1$export$2e2bcd8739ae039() {
    var value = (0, $HbBV6.default), sortValues = (0, $cP2ti.default), sort = null, startAngle = (0, $iFaTn.default)(0), endAngle = (0, $iFaTn.default)((0, $8FFuk.tau)), padAngle = (0, $iFaTn.default)(0);
    function pie(data) {
        var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $8FFuk.tau), Math.max(-(0, $8FFuk.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("cP2ti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $955c2a426b430189$export$2e2bcd8739ae039; });
function $955c2a426b430189$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("HbBV6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $081d05e4964317bb$export$2e2bcd8739ae039; });
function $081d05e4964317bb$export$2e2bcd8739ae039(d) {
    return d;
}

});





parcelRegister("7VCZk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c5c19845599264a$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $8VJ2N = parcelRequire("8VJ2N");

var $cU2FJ = parcelRequire("cU2FJ");

var $8AxZQ = parcelRequire("8AxZQ");
parcelRequire("kaUpJ");
var $duEqu = parcelRequire("duEqu");
const $5c5c19845599264a$var$BuildingRecommendation = ({ children: children, description: description, iconProps: iconProps, label: label, value: value })=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
        className: "recommendations-item",
        item: true,
        xs: 6,
        sm: 3,
        lg: 6,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $duEqu.default), (0, $2QP2i._)({}, iconProps)),
            /*#__PURE__*/ (0, $4x3bm.jsx)("label", {
                title: description,
                children: label
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("p", {
                children: value
            }),
            children
        ]
    });
function $5c5c19845599264a$export$2e2bcd8739ae039({ chp: chp, descriptions: descriptions, estimates: estimates, fuel_cell: fuel_cell, icons: icons, pv: pv, reductions: reductions, solar_thermal: solar_thermal, storage: storage, therm_production: therm_production }) {
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
        className: "recommendations",
        container: true,
        spacing: 0,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                item: true,
                xs: 12,
                lg: true,
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
                    container: true,
                    spacing: 2,
                    wrap: "nowrap",
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsxs)($5c5c19845599264a$var$BuildingRecommendation, {
                            description: descriptions.storage_estimate,
                            iconProps: {
                                name: "battery",
                                title: descriptions.storage_recommendation,
                                value: storage
                            },
                            label: "Storage Estimate",
                            value: estimates.storage,
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: reductions.storage.low,
                                    high: reductions.storage.high,
                                    label: "Average Monthly Peak kW Reduction",
                                    unit: "kW"
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: reductions.storage.low,
                                    high: reductions.storage.high,
                                    label: "Average Monthly Peak kWh Reduction",
                                    unit: "kWh"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsxs)($5c5c19845599264a$var$BuildingRecommendation, {
                            description: descriptions.fuel_cell_estimate,
                            iconProps: {
                                name: "hydrogen",
                                title: descriptions.fuel_cell_recommendation,
                                value: fuel_cell
                            },
                            label: "Fuel Cell Estimate",
                            value: estimates.fuel_cell,
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: reductions.solar.low,
                                    high: reductions.solar.high,
                                    unit: "kWh"
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: reductions.fuel_cell.low,
                                    high: reductions.fuel_cell.high,
                                    unit: "kW"
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: reductions.fuel_cell.low,
                                    high: reductions.fuel_cell.high,
                                    unit: "kWh"
                                })
                            ]
                        }),
                        !!solar_thermal && /*#__PURE__*/ (0, $4x3bm.jsx)($5c5c19845599264a$var$BuildingRecommendation, {
                            description: descriptions.solar_estimate,
                            iconProps: {
                                name: "solar_thermal",
                                value: solar_thermal
                            },
                            label: "Solar Thermal Estimate",
                            value: estimates.solar_thermal
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsxs)($5c5c19845599264a$var$BuildingRecommendation, {
                            description: descriptions.chp_estimate,
                            iconProps: {
                                name: "bulb",
                                title: descriptions.chp_recommendation,
                                value: chp
                            },
                            label: "CHP Estimate",
                            value: estimates.chp,
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: reductions.chp.low,
                                    high: reductions.chp.high,
                                    unit: "kW"
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: reductions.chp.low,
                                    high: reductions.chp.high,
                                    unit: "kWh"
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                    low: therm_production.low,
                                    high: therm_production.high,
                                    unit: " therms",
                                    label: "Therm Production"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)($5c5c19845599264a$var$BuildingRecommendation, {
                            description: descriptions.solar_estimate,
                            iconProps: {
                                name: "sun",
                                title: descriptions.solar_recommendation,
                                value: pv
                            },
                            label: "Solar Estimate",
                            value: estimates.solar,
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cU2FJ.default), {
                                low: reductions.solar.low,
                                high: reductions.solar.high,
                                unit: "kWh"
                            })
                        })
                    ]
                })
            }),
            (icons.energystar || icons.eui) && icons.energystar !== "n/a" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8AxZQ.default), {
                icons: icons
            })
        ]
    });
}

});
parcelRegister("cU2FJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $964cc99d4fa10693$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");
const $964cc99d4fa10693$var$Reduction = ({ unit: unit, label: label = `${unit} Reduction`, low: low, high: high })=>{
    if (!high) return false;
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("label", {
                children: label
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)("p", {
                children: [
                    low.toLocaleString("en-US"),
                    unit,
                    " - ",
                    high.toLocaleString("en-US"),
                    unit
                ]
            })
        ]
    });
};
var $964cc99d4fa10693$export$2e2bcd8739ae039 = $964cc99d4fa10693$var$Reduction;

});

parcelRegister("8AxZQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $640c0e87c049982c$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $8VJ2N = parcelRequire("8VJ2N");
function $640c0e87c049982c$export$2e2bcd8739ae039({ icons: icons, nowrap: nowrap }) {
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
        style: {
            display: "none"
        },
        item: true,
        xs: 12,
        lg: 2,
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
            ontainer: true,
            wrap: nowrap ? "nowrap" : "wrap",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                    className: "building--energy",
                    item: true,
                    xs: 6,
                    lg: 12,
                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                        title: "Energy Star Score",
                        className: "icon",
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                className: "energy-star-icon"
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsxs)("p", {
                                className: icons.energystar === "n/a" ? "none" : "",
                                children: [
                                    icons.energystar,
                                    /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                        children: "of 100"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                    className: "building--energy",
                    item: true,
                    xs: 6,
                    lg: 12,
                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                        title: "EUI",
                        className: "icon",
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                className: "der-icon"
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsxs)("p", {
                                className: icons.eui === "n/a" ? "none" : "",
                                children: [
                                    icons.eui,
                                    /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                        children: "kBtu / ft2"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

});


parcelRegister("fJ9i4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b73243e3cd547a9e$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $fTMNl = parcelRequire("fTMNl");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $bfhCA = parcelRequire("bfhCA");
var $fDlBJ = parcelRequire("fDlBJ");
var $27ZKj = parcelRequire("27ZKj");

var $lxEiN = parcelRequire("lxEiN");

var $lUBOG = parcelRequire("lUBOG");

var $iWaGk = parcelRequire("iWaGk");

var $hj3wO = parcelRequire("hj3wO");

var $lCGM8 = parcelRequire("lCGM8");
function $b73243e3cd547a9e$var$changeTimeZone(date, timeZone) {
    if (typeof date === "string") return new Date(new Date(date).toLocaleString("en-US", {
        timeZone: timeZone
    }));
    return new Date(date.toLocaleString("en-US", {
        timeZone: timeZone
    }));
}
function $b73243e3cd547a9e$var$Chart({ showMenu: showMenu, chartType: chartType, latitude: latitude, longitude: longitude, buildingId: buildingId, projectId: projectId }) {
    const canUploadData = showMenu && projectId && chartType === "load_curve";
    const { buildingDetailStore: buildingDetailStore } = (0, $iWaGk.default)();
    const [chartData, setChartData] = (0, $70fFQ.useState)([]);
    const [acceptedFiles, setAcceptedFiles] = (0, $70fFQ.useState)([]);
    const [draggedOver, setDraggedOver] = (0, $70fFQ.useState)(false);
    const [uploadError, setUploadError] = (0, $70fFQ.useState)(false);
    const [uploadProgress, setUploadProgress] = (0, $70fFQ.useState)(null);
    const onDragOver = ()=>setDraggedOver(true);
    const onDragLeave = ()=>setDraggedOver(false);
    const onDrop = async (acceptedFiles)=>{
        setAcceptedFiles(acceptedFiles);
    };
    (0, $70fFQ.useEffect)(()=>{
        if (!acceptedFiles.length) return;
        setUploadProgress(0);
        (async ()=>{
            const { data: data } = await (0, $lxEiN.default).Project.uploadBuildingLoadProfile(projectId, buildingId, acceptedFiles, (progress)=>{
                setUploadProgress(progress);
            });
            if (data.err) {
                setUploadError(data.err.msg);
                setUploadProgress(null);
                setTimeout(()=>{
                    setUploadError(null);
                }, 2000);
                return;
            }
            await buildingDetailStore.getPredictions(buildingId);
            setChartData(buildingDetailStore.predictions);
            setUploadProgress(null);
            setDraggedOver(false);
        })();
    }, [
        acceptedFiles
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, open: open } = (0, $fTMNl.useDropzone)({
        onDrop: onDrop,
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        disabled: !canUploadData,
        noClick: true,
        accept: [
            ".csv"
        ]
    });
    let tickValues = "every 1 days";
    const fetchLoadCurve = async ()=>{
        console.log("fetching load curve", projectId, buildingId);
        if (projectId && !buildingId) {
            const { data: data } = await (0, $lxEiN.default).Project.getProjectPredictions(projectId);
            setChartData(data.data);
        } else await buildingDetailStore.getPredictions(buildingId);
    };
    const reset = async ()=>{
        await (0, $lxEiN.default).Project.deleteBuildingLoadProfile(projectId, buildingId);
        await fetchLoadCurve();
    };
    (0, $70fFQ.useEffect)(()=>{
        console.log("Predictions changed");
        if (buildingId && buildingDetailStore.predictions.length) setChartData(buildingDetailStore.predictions);
    }, [
        buildingDetailStore.predictions
    ]);
    (0, $70fFQ.useEffect)(()=>{
        (async ()=>{
            if (chartType === "temperature" || chartType === "windspeed") await buildingDetailStore.getWeather(longitude, latitude);
            if (chartType === "load_curve") await fetchLoadCurve();
            if (chartType === "temperature") {
                if (buildingDetailStore.weatherData.length) {
                    const temperatureChart = buildingDetailStore.weatherData.find((chart)=>chart.id === "temperature");
                    setChartData([
                        temperatureChart
                    ]);
                }
            }
            if (chartType === "wind_speed") {
                if (buildingDetailStore.weatherData.length) {
                    const windspeedChart = buildingDetailStore.weatherData.find((chart)=>chart.id === "windspeed");
                    setChartData([
                        windspeedChart
                    ]);
                }
            }
            if (chartType === "load_curve") {
                tickValues = "every 1 days";
                if (buildingId && buildingDetailStore.predictions.length) setChartData(buildingDetailStore.predictions);
            }
        })();
    }, [
        buildingId,
        chartType
    ]);
    const units = {
        temperature: "\xb0F",
        wind_speed: " ft/s",
        load_curve: " kW"
    };
    const unit = units[chartType];
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", (0, $edHbI._)((0, $2QP2i._)({}, getRootProps()), {
        style: {
            height: 270,
            position: "relative"
        },
        children: [
            projectId && showMenu && chartType === "load_curve" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hj3wO.default), {
                isFab: true,
                size: "small",
                style: {
                    position: "absolute",
                    right: 0,
                    zIndex: 1,
                    top: 16
                },
                options: [
                    {
                        label: "Upload Interval Data",
                        onClick: open
                    },
                    {
                        label: "Download Interval Data",
                        href: `${(0, $lUBOG.default).E2E_API_URL}project/${projectId}/building/${buildingId}/load_profile?format=csv`
                    },
                    {
                        label: "Reset Interval Data",
                        onClick: reset
                    }
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("input", (0, $2QP2i._)({}, getInputProps())),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bfhCA.default), {
                className: "filemanager-backdrop",
                open: draggedOver
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bfhCA.default), {
                invisible: true,
                style: {
                    position: "absolute",
                    zIndex: 1
                },
                open: uploadProgress !== null || uploadError,
                children: [
                    uploadProgress !== null && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fDlBJ.default), {
                        color: "primary"
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                        children: uploadError
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $lCGM8.default), {
                onTooltip: (slice)=>{
                    buildingDetailStore.setTimeOfDay($b73243e3cd547a9e$var$changeTimeZone(slice.points[0].data.x));
                },
                animate: true,
                axisBottom: {
                    type: "time",
                    format: `%-d. %b`,
                    tickValues: tickValues,
                    legend: "",
                    legendOffset: -12
                },
                unit: unit,
                units: {
                    temperature: "\xb0F",
                    windspeed: " ft/s"
                },
                data: chartData
            })
        ]
    }));
}
var $b73243e3cd547a9e$export$2e2bcd8739ae039 = (0, $87gt0.observer)($b73243e3cd547a9e$var$Chart);

});
parcelRegister("fTMNl", function(module, exports) {

$parcel$export(module.exports, "useDropzone", function () { return $b931d7b8e759c997$export$cd49c0ecc5be9f36; });
$parcel$export(module.exports, "default", function () { return $b931d7b8e759c997$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $cd0Jr = parcelRequire("cd0Jr");
parcelRequire("1tHxk");
var $2YDS4 = parcelRequire("2YDS4");

var $zwFqq = parcelRequire("zwFqq");
function $b931d7b8e759c997$var$_toConsumableArray(arr) {
    return $b931d7b8e759c997$var$_arrayWithoutHoles(arr) || $b931d7b8e759c997$var$_iterableToArray(arr) || $b931d7b8e759c997$var$_nonIterableSpread();
}
function $b931d7b8e759c997$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $b931d7b8e759c997$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $b931d7b8e759c997$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $b931d7b8e759c997$var$_slicedToArray(arr, i) {
    return $b931d7b8e759c997$var$_arrayWithHoles(arr) || $b931d7b8e759c997$var$_iterableToArrayLimit(arr, i) || $b931d7b8e759c997$var$_nonIterableRest();
}
function $b931d7b8e759c997$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $b931d7b8e759c997$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b931d7b8e759c997$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b931d7b8e759c997$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b931d7b8e759c997$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b931d7b8e759c997$var$ownKeys(source, true).forEach(function(key) {
            $b931d7b8e759c997$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b931d7b8e759c997$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b931d7b8e759c997$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b931d7b8e759c997$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b931d7b8e759c997$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b931d7b8e759c997$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $b931d7b8e759c997$var$Dropzone = (0, $70fFQ.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $b931d7b8e759c997$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    var _useDropzone = $b931d7b8e759c997$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $b931d7b8e759c997$var$_objectWithoutProperties(_useDropzone, [
        "open"
    ]);
    (0, $70fFQ.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $70fFQ.Fragment), null, children($b931d7b8e759c997$var$_objectSpread({}, props, {
        open: open
    })));
});
$b931d7b8e759c997$var$Dropzone.displayName = "Dropzone";
$b931d7b8e759c997$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
};
var $b931d7b8e759c997$export$2e2bcd8739ae039 = $b931d7b8e759c997$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */ var $b931d7b8e759c997$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    rejectedFiles: []
};
function $b931d7b8e759c997$export$cd49c0ecc5be9f36() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, accept = _ref2.accept, _ref2$disabled = _ref2.disabled, disabled = _ref2$disabled === void 0 ? false : _ref2$disabled, _ref2$getFilesFromEve = _ref2.getFilesFromEvent, getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? (0, $2YDS4.fromEvent) : _ref2$getFilesFromEve, _ref2$maxSize = _ref2.maxSize, maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize, _ref2$minSize = _ref2.minSize, minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize, _ref2$multiple = _ref2.multiple, multiple = _ref2$multiple === void 0 ? true : _ref2$multiple, onDragEnter = _ref2.onDragEnter, onDragLeave = _ref2.onDragLeave, onDragOver = _ref2.onDragOver, onDrop = _ref2.onDrop, onDropAccepted = _ref2.onDropAccepted, onDropRejected = _ref2.onDropRejected, onFileDialogCancel = _ref2.onFileDialogCancel, _ref2$preventDropOnDo = _ref2.preventDropOnDocument, preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo, _ref2$noClick = _ref2.noClick, noClick = _ref2$noClick === void 0 ? false : _ref2$noClick, _ref2$noKeyboard = _ref2.noKeyboard, noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard, _ref2$noDrag = _ref2.noDrag, noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag, _ref2$noDragEventsBub = _ref2.noDragEventsBubbling, noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;
    var rootRef = (0, $70fFQ.useRef)(null);
    var inputRef = (0, $70fFQ.useRef)(null);
    var _useReducer = (0, $70fFQ.useReducer)($b931d7b8e759c997$var$reducer, $b931d7b8e759c997$var$initialState), _useReducer2 = $b931d7b8e759c997$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $70fFQ.useCallback)(function() {
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch
    ]); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    if (typeof onFileDialogCancel === "function") onFileDialogCancel();
                }
            }
        }, 300);
    };
    (0, $70fFQ.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancel
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $70fFQ.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        inputRef
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $70fFQ.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $70fFQ.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $70fFQ.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $zwFqq.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        inputRef,
        noClick
    ]);
    var dragTargetsRef = (0, $70fFQ.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $70fFQ.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $zwFqq.onDocumentDragOver), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $zwFqq.onDocumentDragOver));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $70fFQ.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event); // Count the dropzone and any children that are entered.
        if (dragTargetsRef.current.indexOf(event.target) === -1) dragTargetsRef.current = [].concat($b931d7b8e759c997$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $zwFqq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $zwFqq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $70fFQ.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        if (event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if ((0, $zwFqq.isEvtWithFiles)(event) && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $70fFQ.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return target !== event.target && rootRef.current && rootRef.current.contains(target);
        });
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: "setDraggedFiles",
            draggedFiles: []
        });
        if ((0, $zwFqq.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var onDropCb = (0, $70fFQ.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        dispatch({
            type: "reset"
        });
        if ((0, $zwFqq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $zwFqq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var acceptedFiles = [];
            var rejectedFiles = [];
            files.forEach(function(file) {
                if ((0, $zwFqq.fileAccepted)(file, accept) && (0, $zwFqq.fileMatchSize)(file, minSize, maxSize)) acceptedFiles.push(file);
                else rejectedFiles.push(file);
            });
            if (!multiple && acceptedFiles.length > 1) rejectedFiles.push.apply(rejectedFiles, $b931d7b8e759c997$var$_toConsumableArray(acceptedFiles.splice(0))); // Reject everything and empty accepted files
            dispatch({
                acceptedFiles: acceptedFiles,
                rejectedFiles: rejectedFiles,
                type: "setFiles"
            });
            if (onDrop) onDrop(acceptedFiles, rejectedFiles, event);
            if (rejectedFiles.length > 0 && onDropRejected) onDropRejected(rejectedFiles, event);
            if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
        });
    }, [
        multiple,
        accept,
        minSize,
        maxSize,
        getFilesFromEvent,
        onDrop,
        onDropAccepted,
        onDropRejected,
        noDragEventsBubbling
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $70fFQ.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onKeyDown = _ref3.onKeyDown, onFocus = _ref3.onFocus, onBlur = _ref3.onBlur, onClick = _ref3.onClick, onDragEnter = _ref3.onDragEnter, onDragOver = _ref3.onDragOver, onDragLeave = _ref3.onDragLeave, onDrop = _ref3.onDrop, rest = $b931d7b8e759c997$var$_objectWithoutProperties(_ref3, [
                "refKey",
                "onKeyDown",
                "onFocus",
                "onBlur",
                "onClick",
                "onDragEnter",
                "onDragOver",
                "onDragLeave",
                "onDrop"
            ]);
            return $b931d7b8e759c997$var$_objectSpread($b931d7b8e759c997$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $zwFqq.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $zwFqq.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $zwFqq.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $zwFqq.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $zwFqq.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $zwFqq.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $zwFqq.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $zwFqq.composeEventHandlers)(onDrop, onDropCb))
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}, {}, rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $70fFQ.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $70fFQ.useMemo)(function() {
        return function() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey, onChange = _ref4.onChange, onClick = _ref4.onClick, rest = $b931d7b8e759c997$var$_objectWithoutProperties(_ref4, [
                "refKey",
                "onChange",
                "onClick"
            ]);
            var inputProps = $b931d7b8e759c997$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $zwFqq.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, $zwFqq.composeEventHandlers)(onClick, onInputElementClick)),
                autoComplete: "off",
                tabIndex: -1
            }, refKey, inputRef);
            return $b931d7b8e759c997$var$_objectSpread({}, inputProps, {}, rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isMultipleAllowed = multiple || fileCount <= 1;
    var isDragAccept = fileCount > 0 && (0, $zwFqq.allFilesAccepted)(draggedFiles, accept, minSize, maxSize);
    var isDragReject = fileCount > 0 && (!isDragAccept || !isMultipleAllowed);
    return $b931d7b8e759c997$var$_objectSpread({}, state, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $b931d7b8e759c997$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $b931d7b8e759c997$var$_objectSpread({}, state, {
                isFocused: true
            });
        case "blur":
            return $b931d7b8e759c997$var$_objectSpread({}, state, {
                isFocused: false
            });
        case "openDialog":
            return $b931d7b8e759c997$var$_objectSpread({}, state, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $b931d7b8e759c997$var$_objectSpread({}, state, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $b931d7b8e759c997$var$_objectSpread({}, state, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case "setFiles":
            return $b931d7b8e759c997$var$_objectSpread({}, state, {
                acceptedFiles: action.acceptedFiles,
                rejectedFiles: action.rejectedFiles
            });
        case "reset":
            return $b931d7b8e759c997$var$_objectSpread({}, state, {
                isFileDialogActive: false,
                isDragActive: false,
                draggedFiles: []
            });
        default:
            return state;
    }
}

});
parcelRegister("1tHxk", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return (parcelRequire("2YDS4")).fromEvent; });

var $2YDS4 = parcelRequire("2YDS4");

});
parcelRegister("2YDS4", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return $22b01cf0a4a38161$export$a36e16046ae8f1bb; });

var $aXGlE = parcelRequire("aXGlE");

var $1BRV9 = parcelRequire("1BRV9");
var $22b01cf0a4a38161$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $22b01cf0a4a38161$export$a36e16046ae8f1bb(evt) {
    return $aXGlE.__awaiter(this, void 0, void 0, function() {
        return $aXGlE.__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                $22b01cf0a4a38161$var$isDragEvt(evt) && evt.dataTransfer ? $22b01cf0a4a38161$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $22b01cf0a4a38161$var$getInputFiles(evt)
            ];
        });
    });
}
function $22b01cf0a4a38161$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $22b01cf0a4a38161$var$getInputFiles(evt) {
    var files = $22b01cf0a4a38161$var$isInput(evt.target) ? evt.target.files ? $22b01cf0a4a38161$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $1BRV9.toFileWithPath)(file);
    });
}
function $22b01cf0a4a38161$var$isInput(value) {
    return value !== null;
}
function $22b01cf0a4a38161$var$getDataTransferFiles(dt, type) {
    return $aXGlE.__awaiter(this, void 0, void 0, function() {
        var items, files;
        return $aXGlE.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $22b01cf0a4a38161$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($22b01cf0a4a38161$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $22b01cf0a4a38161$var$noIgnoredFiles($22b01cf0a4a38161$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $22b01cf0a4a38161$var$noIgnoredFiles($22b01cf0a4a38161$var$fromList(dt.files).map(function(file) {
                            return (0, $1BRV9.toFileWithPath)(file);
                        }))
                    ];
            }
        });
    });
}
function $22b01cf0a4a38161$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $22b01cf0a4a38161$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $22b01cf0a4a38161$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $22b01cf0a4a38161$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $22b01cf0a4a38161$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $22b01cf0a4a38161$var$fromDirEntry(entry);
    return $22b01cf0a4a38161$var$fromDataTransferItem(item);
}
function $22b01cf0a4a38161$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return $aXGlE.__spread(acc, Array.isArray(files) ? $22b01cf0a4a38161$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $22b01cf0a4a38161$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $1BRV9.toFileWithPath)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $22b01cf0a4a38161$var$fromEntry(entry) {
    return $aXGlE.__awaiter(this, void 0, void 0, function() {
        return $aXGlE.__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $22b01cf0a4a38161$var$fromDirEntry(entry) : $22b01cf0a4a38161$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $22b01cf0a4a38161$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return $aXGlE.__awaiter(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return $aXGlE.__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($22b01cf0a4a38161$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $22b01cf0a4a38161$var$fromFileEntry(entry) {
    return $aXGlE.__awaiter(this, void 0, void 0, function() {
        return $aXGlE.__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $1BRV9.toFileWithPath)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}

});
parcelRegister("aXGlE", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $7fb043861368495f$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $7fb043861368495f$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spread", function () { return $7fb043861368495f$export$afc72e2116322959; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $7fb043861368495f$var$extendStatics = function(d, b) {
    $7fb043861368495f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7fb043861368495f$var$extendStatics(d, b);
};
function $7fb043861368495f$export$a8ba968b8961cb8a(d, b) {
    $7fb043861368495f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7fb043861368495f$export$18ce0697a983be9b = function() {
    $7fb043861368495f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fb043861368495f$export$18ce0697a983be9b.apply(this, arguments);
};
function $7fb043861368495f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7fb043861368495f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7fb043861368495f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7fb043861368495f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7fb043861368495f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7fb043861368495f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $7fb043861368495f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $7fb043861368495f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7fb043861368495f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7fb043861368495f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7fb043861368495f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7fb043861368495f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7fb043861368495f$export$10c90e4f7922046c(v) {
    return this instanceof $7fb043861368495f$export$10c90e4f7922046c ? (this.v = v, this) : new $7fb043861368495f$export$10c90e4f7922046c(v);
}
function $7fb043861368495f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7fb043861368495f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7fb043861368495f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7fb043861368495f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7fb043861368495f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7fb043861368495f$export$19a8beecd37a4c45 === "function" ? $7fb043861368495f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7fb043861368495f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $7fb043861368495f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $7fb043861368495f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7fb043861368495f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $7fb043861368495f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("1BRV9", function(module, exports) {

$parcel$export(module.exports, "toFileWithPath", function () { return $12c312b61e1536ba$export$8cc09085015f0dc7; });
var $12c312b61e1536ba$export$db0345794bfc14ed = new Map([
    [
        "avi",
        "video/avi"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "ico",
        "image/x-icon"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ]
]);
function $12c312b61e1536ba$export$8cc09085015f0dc7(file, path) {
    var f = $12c312b61e1536ba$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $12c312b61e1536ba$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $12c312b61e1536ba$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}

});



parcelRegister("zwFqq", function(module, exports) {

$parcel$export(module.exports, "fileAccepted", function () { return $06ac9c03ba30f6f9$export$b511db3632effe58; });
$parcel$export(module.exports, "fileMatchSize", function () { return $06ac9c03ba30f6f9$export$860631d45ba43fd9; });
$parcel$export(module.exports, "allFilesAccepted", function () { return $06ac9c03ba30f6f9$export$6a0bb4322c81a197; });
$parcel$export(module.exports, "isPropagationStopped", function () { return $06ac9c03ba30f6f9$export$8d6d6472146de265; });
$parcel$export(module.exports, "isEvtWithFiles", function () { return $06ac9c03ba30f6f9$export$52f1fc875a1e5986; });
$parcel$export(module.exports, "onDocumentDragOver", function () { return $06ac9c03ba30f6f9$export$2ead263d6635cecc; });
$parcel$export(module.exports, "isIeOrEdge", function () { return $06ac9c03ba30f6f9$export$d3498e653911f962; });
$parcel$export(module.exports, "composeEventHandlers", function () { return $06ac9c03ba30f6f9$export$b9ecd428b558ff10; });

var $kBADZ = parcelRequire("kBADZ");
function $06ac9c03ba30f6f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $06ac9c03ba30f6f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $06ac9c03ba30f6f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $06ac9c03ba30f6f9$var$_typeof(obj);
}
function $06ac9c03ba30f6f9$export$b511db3632effe58(file, accept) {
    return file.type === "application/x-moz-file" || (0, (/*@__PURE__*/$parcel$interopDefault($kBADZ)))(file, accept);
}
function $06ac9c03ba30f6f9$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($06ac9c03ba30f6f9$var$isDefined(file.size)) {
        if ($06ac9c03ba30f6f9$var$isDefined(minSize) && $06ac9c03ba30f6f9$var$isDefined(maxSize)) return file.size >= minSize && file.size <= maxSize;
        else if ($06ac9c03ba30f6f9$var$isDefined(minSize)) return file.size >= minSize;
        else if ($06ac9c03ba30f6f9$var$isDefined(maxSize)) return file.size <= maxSize;
    }
    return true;
}
function $06ac9c03ba30f6f9$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $06ac9c03ba30f6f9$export$6a0bb4322c81a197(files, accept, minSize, maxSize) {
    return files.every(function(file) {
        return $06ac9c03ba30f6f9$export$b511db3632effe58(file, accept) && $06ac9c03ba30f6f9$export$860631d45ba43fd9(file, minSize, maxSize);
    });
} // React's synthetic events has event.isPropagationStopped,
function $06ac9c03ba30f6f9$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $06ac9c03ba30f6f9$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $06ac9c03ba30f6f9$export$f9006bf02b243736(item) {
    return $06ac9c03ba30f6f9$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $06ac9c03ba30f6f9$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $06ac9c03ba30f6f9$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $06ac9c03ba30f6f9$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $06ac9c03ba30f6f9$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $06ac9c03ba30f6f9$var$isIe(userAgent) || $06ac9c03ba30f6f9$var$isEdge(userAgent);
}
function $06ac9c03ba30f6f9$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$06ac9c03ba30f6f9$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $06ac9c03ba30f6f9$export$8d6d6472146de265(event);
        });
    };
}

});
parcelRegister("kBADZ", function(module, exports) {
module.exports = function(e) {
    function r(n) {
        if (t[n]) return t[n].exports;
        var o = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    var t = {};
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: n
        });
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
    }, r.p = "", r(r.s = 0);
}([
    function(e, r, t) {
        "use strict";
        r.__esModule = !0, r.default = function(e, r) {
            if (e && r) {
                var t = Array.isArray(r) ? r : r.split(","), n = e.name || "", o = e.type || "", u = o.replace(/\/.*$/, "");
                return t.some(function(e) {
                    var r = e.trim();
                    return "." === r.charAt(0) ? n.toLowerCase().endsWith(r.toLowerCase()) : r.endsWith("/*") ? u === r.replace(/\/.*$/, "") : o === r;
                });
            }
            return !0;
        };
    }
]);

});



parcelRegister("fDlBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b61b4259f69e2161$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $l1z3A = parcelRequire("l1z3A");

var $aAAPW = parcelRequire("aAAPW");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $4yvNV = parcelRequire("4yvNV");

var $4x3bm = parcelRequire("4x3bm");
let $b61b4259f69e2161$var$_ = (t)=>t, $b61b4259f69e2161$var$t, $b61b4259f69e2161$var$t1, $b61b4259f69e2161$var$t2, $b61b4259f69e2161$var$t3;
const $b61b4259f69e2161$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $b61b4259f69e2161$var$_1 = (t)=>t, $b61b4259f69e2161$var$_t, $b61b4259f69e2161$var$_t2, $b61b4259f69e2161$var$_t3, $b61b4259f69e2161$var$_t4;
const $b61b4259f69e2161$var$SIZE = 44;
const $b61b4259f69e2161$var$circularRotateKeyframe = (0, $l1z3A.keyframes)($b61b4259f69e2161$var$_t || ($b61b4259f69e2161$var$_t = $b61b4259f69e2161$var$_1($b61b4259f69e2161$var$t || ($b61b4259f69e2161$var$t = $b61b4259f69e2161$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const $b61b4259f69e2161$var$circularDashKeyframe = (0, $l1z3A.keyframes)($b61b4259f69e2161$var$_t2 || ($b61b4259f69e2161$var$_t2 = $b61b4259f69e2161$var$_1($b61b4259f69e2161$var$t1 || ($b61b4259f69e2161$var$t1 = $b61b4259f69e2161$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const $b61b4259f69e2161$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $aAAPW.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $aAAPW.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $4yvNV.getCircularProgressUtilityClass), classes);
};
const $b61b4259f69e2161$var$CircularProgressRoot = (0, $71Pr4.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $aAAPW.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: theme.palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $l1z3A.css)($b61b4259f69e2161$var$_t3 || ($b61b4259f69e2161$var$_t3 = $b61b4259f69e2161$var$_1($b61b4259f69e2161$var$t2 || ($b61b4259f69e2161$var$t2 = $b61b4259f69e2161$var$_`
      animation: ${0} 1.4s linear infinite;
    `), 0)), $b61b4259f69e2161$var$circularRotateKeyframe));
const $b61b4259f69e2161$var$CircularProgressSVG = (0, $71Pr4.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $b61b4259f69e2161$var$CircularProgressCircle = (0, $71Pr4.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $aAAPW.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $l1z3A.css)($b61b4259f69e2161$var$_t4 || ($b61b4259f69e2161$var$_t4 = $b61b4259f69e2161$var$_1($b61b4259f69e2161$var$t3 || ($b61b4259f69e2161$var$t3 = $b61b4259f69e2161$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), $b61b4259f69e2161$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $b61b4259f69e2161$var$CircularProgress = /*#__PURE__*/ $70fFQ.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $79yYo.default)(props, $b61b4259f69e2161$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $b61b4259f69e2161$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($b61b4259f69e2161$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $4x3bm.jsx)($b61b4259f69e2161$var$CircularProgressRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        style: (0, $20MOv.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($b61b4259f69e2161$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$b61b4259f69e2161$var$SIZE / 2} ${$b61b4259f69e2161$var$SIZE / 2} ${$b61b4259f69e2161$var$SIZE} ${$b61b4259f69e2161$var$SIZE}`,
            children: /*#__PURE__*/ (0, $4x3bm.jsx)($b61b4259f69e2161$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $b61b4259f69e2161$var$SIZE,
                cy: $b61b4259f69e2161$var$SIZE,
                r: ($b61b4259f69e2161$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $b61b4259f69e2161$export$2e2bcd8739ae039 = $b61b4259f69e2161$var$CircularProgress;

});
parcelRegister("4yvNV", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $351302098f4ca9da$export$29cad1383b3f235d; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $351302098f4ca9da$export$29cad1383b3f235d(slot) {
    return (0, $dtsUs.default)("MuiCircularProgress", slot);
}
const $351302098f4ca9da$var$circularProgressClasses = (0, $jLqVN.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $351302098f4ca9da$export$2e2bcd8739ae039 = $351302098f4ca9da$var$circularProgressClasses;

});


parcelRegister("hj3wO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c996f2a3eb8ef982$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $2OCa7 = parcelRequire("2OCa7");
var $cGU07 = parcelRequire("cGU07");
var $ajp8Q = parcelRequire("ajp8Q");
var $6yY4r = parcelRequire("6yY4r");

var $5GjdS = parcelRequire("5GjdS");
const $c996f2a3eb8ef982$var$ITEM_HEIGHT = 48;
function $c996f2a3eb8ef982$export$2e2bcd8739ae039({ isFab: isFab, options: options, style: style, size: size = "small" }) {
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            isFab && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2OCa7.default), {
                style: style,
                size: size,
                onClick: handleClick,
                "aria-label": "add",
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5GjdS.default), {
                    fontSize: size
                })
            }),
            !isFab && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                style: style,
                size: size,
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5GjdS.default), {
                    fontSize: size
                })
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ajp8Q.default), {
                anchorEl: anchorEl,
                keepMounted: true,
                open: open,
                onClose: handleClose,
                PaperProps: {
                    style: {
                        maxHeight: $c996f2a3eb8ef982$var$ITEM_HEIGHT * 4.5,
                        width: 200
                    }
                },
                children: options.map((option)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $6yY4r.default), {
                        linkButton: Boolean(option.href),
                        href: option.href,
                        component: option.href ? "a" : "button",
                        onClick: ()=>{
                            if (option.onClick) option.onClick();
                            setAnchorEl(null);
                        },
                        children: option.label
                    }, option.label))
            })
        ]
    });
}

});
parcelRegister("2OCa7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20cdda81b67f46b9$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $eGmvM = parcelRequire("eGmvM");

var $aAAPW = parcelRequire("aAAPW");

var $cNmNk = parcelRequire("cNmNk");

var $6CbK3 = parcelRequire("6CbK3");

var $71Pr4 = parcelRequire("71Pr4");

var $4x3bm = parcelRequire("4x3bm");
const $20cdda81b67f46b9$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $20cdda81b67f46b9$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `size${(0, $aAAPW.default)(size)}`,
            color === "inherit" ? "colorInherit" : color
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $6CbK3.getFabUtilityClass), classes);
};
const $20cdda81b67f46b9$var$FabRoot = (0, $71Pr4.default)((0, $eGmvM.default), {
    name: "MuiFab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $aAAPW.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            styles[(0, $aAAPW.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: "50%",
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: theme.zIndex.fab,
        boxShadow: theme.shadows[6],
        "&:active": {
            boxShadow: theme.shadows[12]
        },
        color: theme.palette.getContrastText(theme.palette.grey[300]),
        backgroundColor: theme.palette.grey[300],
        "&:hover": {
            backgroundColor: theme.palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.palette.grey[300]
            },
            textDecoration: "none"
        },
        [`&.${(0, $6CbK3.default).focusVisible}`]: {
            boxShadow: theme.shadows[6]
        },
        [`&.${(0, $6CbK3.default).disabled}`]: {
            color: theme.palette.action.disabled,
            boxShadow: theme.shadows[0],
            backgroundColor: theme.palette.action.disabledBackground
        }
    }, ownerState.size === "small" && {
        width: 40,
        height: 40
    }, ownerState.size === "medium" && {
        width: 48,
        height: 48
    }, ownerState.variant === "extended" && {
        borderRadius: 24,
        padding: "0 16px",
        width: "auto",
        minHeight: "auto",
        minWidth: 48,
        height: 48
    }, ownerState.variant === "extended" && ownerState.size === "small" && {
        width: "auto",
        padding: "0 8px",
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === "extended" && ownerState.size === "medium" && {
        width: "auto",
        padding: "0 16px",
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }), ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.color !== "inherit" && ownerState.color !== "default" && theme.palette[ownerState.color] != null && {
        color: theme.palette[ownerState.color].contrastText,
        backgroundColor: theme.palette[ownerState.color].main,
        "&:hover": {
            backgroundColor: theme.palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.palette[ownerState.color].main
            }
        }
    }));
const $20cdda81b67f46b9$var$Fab = /*#__PURE__*/ $70fFQ.forwardRef(function Fab(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiFab"
    });
    const { children: children, className: className, color: color = "default", component: component = "button", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = "large", variant: variant = "circular" } = props, other = (0, $79yYo.default)(props, $20cdda81b67f46b9$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $20cdda81b67f46b9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($20cdda81b67f46b9$var$FabRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $gjktY.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: children
    }));
});
var $20cdda81b67f46b9$export$2e2bcd8739ae039 = $20cdda81b67f46b9$var$Fab;

});
parcelRegister("6CbK3", function(module, exports) {

$parcel$export(module.exports, "getFabUtilityClass", function () { return $4d0f6657e82691f4$export$e2cfa0ca4bce1fc2; });
$parcel$export(module.exports, "default", function () { return $4d0f6657e82691f4$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $4d0f6657e82691f4$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $dtsUs.default)("MuiFab", slot);
}
const $4d0f6657e82691f4$var$fabClasses = (0, $jLqVN.default)("MuiFab", [
    "root",
    "primary",
    "secondary",
    "extended",
    "circular",
    "focusVisible",
    "disabled",
    "colorInherit",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "info",
    "error",
    "warning",
    "success"
]);
var $4d0f6657e82691f4$export$2e2bcd8739ae039 = $4d0f6657e82691f4$var$fabClasses;

});


parcelRegister("5GjdS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $422fc93f588721c4$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $422fc93f588721c4$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert");

});


parcelRegister("lCGM8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbde53db07562111$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $1Dcce = parcelRequire("1Dcce");

var $bDcYY = parcelRequire("bDcYY");
var $1mImZ = parcelRequire("1mImZ");
var $27ZKj = parcelRequire("27ZKj");

var $fuiMG = parcelRequire("fuiMG");
function $fbde53db07562111$export$2e2bcd8739ae039({ onTooltip: onTooltip = ()=>{}, animate: animate, data: data, axisBottom: axisBottom, unit: unit }) {
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1Dcce.ResponsiveLine), {
        theme: {
            grid: {
                line: {
                    stroke: "rgba(0,0,0,0.05)",
                    strokeWidth: 1
                }
            },
            crosshair: {
                line: {
                    stroke: "#000000",
                    strokeWidth: 1,
                    strokeOpacity: 0.5,
                    strokeDasharray: "2 4"
                }
            }
        },
        data: data,
        margin: {
            top: 16,
            right: 0,
            bottom: 32,
            left: 48
        },
        xScale: {
            type: "time",
            format: "%Y-%m-%d %H:%M:%S",
            precision: "second"
        },
        yScale: {
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: false,
            reverse: false
        },
        defs: [
            {
                id: "gradientC",
                type: "linearGradient",
                colors: [
                    {
                        offset: 0,
                        color: "#faf047"
                    },
                    {
                        offset: 100,
                        color: "#e4b400"
                    }
                ]
            }
        ],
        fill: [
            {
                match: "*",
                id: "gradientA"
            }
        ],
        // enableSlices={false}
        enableCrosshair: true,
        crosshairType: "x",
        lineWidth: 2,
        animate: animate,
        axisTop: null,
        axisRight: null,
        enableSlices: "x",
        sliceTooltip: ({ slice: slice })=>{
            const labels = {
                pvwatts: "Solar (pvwatts)",
                load_curve: "Consumption",
                fuel_cell: "Fuel Cell",
                solar: "Solar",
                chp: "CHP",
                net_load: "Net Load"
            };
            onTooltip(slice);
            const units = {
                pvwatts: "kW",
                load_curve: "kW",
                temperature: "\xb0F",
                windspeed: " ft/s",
                fuel_cell: "kW",
                solar: "kW",
                chp: "kW",
                net_load: "kW"
            };
            function sortArrayByOrder(arr, order) {
                return arr.sort((a, b)=>{
                    return order.indexOf(a.serieId) - order.indexOf(b.serieId);
                });
            }
            const orderedPoints = sortArrayByOrder(slice.points, [
                "pvwatts",
                "load_curve",
                "fuel_cell",
                "chp",
                "solar"
            ]);
            return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1mImZ.default), {
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                    p: 1,
                    children: [
                        orderedPoints.map((point)=>/*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                    noWrap: true,
                                    children: [
                                        labels[point.serieId] || point.serieId,
                                        ": ",
                                        point.data.y,
                                        " ",
                                        units[point.serieId]
                                    ]
                                })
                            }, point.serieId)),
                        /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                            children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                noWrap: true,
                                children: [
                                    "Time: ",
                                    (0, $fuiMG.humanDateTime)(slice.points[0].data.x)
                                ]
                            })
                        })
                    ]
                })
            });
        },
        enableGridY: true,
        tooltip: ({ point: point })=>{
            return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                children: [
                    point.serieId,
                    ": ",
                    (0, $fuiMG.abbreviateNumber)(point.data.y),
                    unit
                ]
            });
        },
        axisBottom: axisBottom,
        axisLeft: {
            orient: "left",
            tickSize: 0,
            tickPadding: 16,
            tickRotation: 0,
            legend: null,
            legendOffset: -40,
            legendPosition: "middle",
            format: (v)=>Math.sign(v) === -1 ? `-${(0, $fuiMG.abbreviateNumber)(Math.abs(v))}` : `${(0, $fuiMG.abbreviateNumber)(Math.abs(v))}`
        },
        enableGridX: false,
        colors: (v)=>{
            return v.color;
        },
        pointSize: 0,
        pointColor: {
            theme: "background"
        },
        pointBorderWidth: 2,
        // pointBorderColor={{ from: "serieColor" }}
        pointLabel: "y",
        pointLabelYOffset: -12,
        enableArea: false,
        useMesh: true
    });
}

});
parcelRegister("1Dcce", function(module, exports) {

$parcel$export(module.exports, "ResponsiveLine", function () { return $1302e4e1bb487594$export$a4a9f4982e5c2626; });

var $70fFQ = parcelRequire("70fFQ");

var $2qXGl = parcelRequire("2qXGl");

var $boipe = parcelRequire("boipe");

var $jtZ7X = parcelRequire("jtZ7X");

var $fpOVP = parcelRequire("fpOVP");

var $lITvm = parcelRequire("lITvm");

var $e9xmC = parcelRequire("e9xmC");
var $7Gyiu = parcelRequire("7Gyiu");

var $lT7k3 = parcelRequire("lT7k3");

var $cd0Jr = parcelRequire("cd0Jr");

var $4x3bm = parcelRequire("4x3bm");

var $eYtn3 = parcelRequire("eYtn3");
var $4ZiMn = parcelRequire("4ZiMn");

var $eI4IL = parcelRequire("eI4IL");
function $1302e4e1bb487594$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1302e4e1bb487594$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1302e4e1bb487594$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1302e4e1bb487594$var$ownKeys(Object(source), true).forEach(function(key) {
            $1302e4e1bb487594$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1302e4e1bb487594$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1302e4e1bb487594$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1302e4e1bb487594$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1302e4e1bb487594$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1302e4e1bb487594$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1302e4e1bb487594$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1302e4e1bb487594$var$_arrayLikeToArray(o, minLen);
}
function $1302e4e1bb487594$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1302e4e1bb487594$var$_slicedToArray(arr, i) {
    return $1302e4e1bb487594$var$_arrayWithHoles(arr) || $1302e4e1bb487594$var$_iterableToArrayLimit(arr, i) || $1302e4e1bb487594$var$_unsupportedIterableToArray(arr, i) || $1302e4e1bb487594$var$_nonIterableRest();
}
function $1302e4e1bb487594$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1302e4e1bb487594$var$_arrayLikeToArray(arr);
}
function $1302e4e1bb487594$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $1302e4e1bb487594$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1302e4e1bb487594$var$_toConsumableArray(arr) {
    return $1302e4e1bb487594$var$_arrayWithoutHoles(arr) || $1302e4e1bb487594$var$_iterableToArray(arr) || $1302e4e1bb487594$var$_unsupportedIterableToArray(arr) || $1302e4e1bb487594$var$_nonIterableSpread();
}
var $1302e4e1bb487594$var$LinePointTooltip = function LinePointTooltip(_ref) {
    var point = _ref.point;
    return (0, $4x3bm.jsx)((0, $lITvm.BasicTooltip), {
        id: (0, $4x3bm.jsxs)("span", {
            children: [
                "x: ",
                (0, $4x3bm.jsx)("strong", {
                    children: point.data.xFormatted
                }),
                ", y:",
                " ",
                (0, $4x3bm.jsx)("strong", {
                    children: point.data.yFormatted
                })
            ]
        }),
        enableChip: true,
        color: point.serieColor
    });
};
var $1302e4e1bb487594$var$PointTooltip = (0, $70fFQ.memo)($1302e4e1bb487594$var$LinePointTooltip);
var $1302e4e1bb487594$var$SliceTooltip = function SliceTooltip(_ref) {
    var slice = _ref.slice, axis = _ref.axis;
    var theme = (0, $2qXGl.useTheme)();
    var otherAxis = axis === "x" ? "y" : "x";
    return (0, $4x3bm.jsx)((0, $lITvm.TableTooltip), {
        rows: slice.points.map(function(point) {
            return [
                (0, $4x3bm.jsx)((0, $lITvm.Chip), {
                    color: point.serieColor,
                    style: theme.tooltip.chip
                }, "chip"),
                point.serieId,
                (0, $4x3bm.jsx)("span", {
                    style: theme.tooltip.tableCellValue,
                    children: point.data["".concat(otherAxis, "Formatted")]
                }, "value")
            ];
        })
    });
};
var $1302e4e1bb487594$var$SliceTooltip$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$SliceTooltip);
var $1302e4e1bb487594$var$commonPropTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number
        ]).isRequired,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf(Date)
            ]),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf(Date)
            ])
        })).isRequired
    })).isRequired,
    xScale: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object.isRequired,
    xFormat: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    yScale: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object.isRequired,
    yFormat: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    layers: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
            "grid",
            "markers",
            "axes",
            "areas",
            "crosshair",
            "lines",
            "slices",
            "points",
            "mesh",
            "legends"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    ])).isRequired,
    curve: (0, $2qXGl.lineCurvePropType).isRequired,
    axisTop: (0, $jtZ7X.axisPropType),
    axisRight: (0, $jtZ7X.axisPropType),
    axisBottom: (0, $jtZ7X.axisPropType),
    axisLeft: (0, $jtZ7X.axisPropType),
    enableGridX: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    enableGridY: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    gridXValues: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf(Date)
        ]))
    ]),
    gridYValues: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf(Date)
        ]))
    ]),
    enablePoints: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    pointSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    pointSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    pointColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).any.isRequired,
    pointBorderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    pointBorderColor: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).any.isRequired,
    enablePointLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    pointLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func
    ]).isRequired,
    markers: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape({
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
            "x",
            "y"
        ]).isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf(Date)
        ]).isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object
    })),
    colors: (0, $boipe.ordinalColorsPropType).isRequired,
    enableArea: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    areaOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    areaBlendMode: (0, $2qXGl.blendModePropType).isRequired,
    areaBaselineValue: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf(Date)
    ]).isRequired,
    lineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired,
    legends: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape((0, $fpOVP.LegendPropShape))).isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    debugMesh: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object
    ]).isRequired,
    enableSlices: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        "x",
        "y",
        false
    ]).isRequired,
    debugSlices: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    sliceTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).object
    ]).isRequired,
    enableCrosshair: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    crosshairType: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired
};
var $1302e4e1bb487594$export$208f32d331641072 = $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, $1302e4e1bb487594$var$commonPropTypes), {}, {
    enablePointLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string.isRequired,
    useMesh: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool.isRequired
}, (0, $2qXGl.motionPropTypes)), (0, $2qXGl.defsPropTypes));
var $1302e4e1bb487594$export$233d529d87f42067 = $1302e4e1bb487594$var$_objectSpread2({
    pixelRatio: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number.isRequired
}, $1302e4e1bb487594$var$commonPropTypes);
var $1302e4e1bb487594$var$commonDefaultProps = {
    curve: "linear",
    xScale: {
        type: "point"
    },
    yScale: {
        type: "linear",
        min: 0,
        max: "auto"
    },
    layers: [
        "grid",
        "markers",
        "axes",
        "areas",
        "crosshair",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends"
    ],
    axisBottom: {},
    axisLeft: {},
    enableGridX: true,
    enableGridY: true,
    enablePoints: true,
    pointSize: 6,
    pointColor: {
        from: "color"
    },
    pointBorderWidth: 0,
    pointBorderColor: {
        theme: "background"
    },
    enablePointLabel: false,
    pointLabel: "yFormatted",
    colors: {
        scheme: "nivo"
    },
    enableArea: false,
    areaBaselineValue: 0,
    areaOpacity: 0.2,
    areaBlendMode: "normal",
    lineWidth: 2,
    legends: [],
    isInteractive: true,
    tooltip: $1302e4e1bb487594$var$PointTooltip,
    enableSlices: false,
    debugSlices: false,
    sliceTooltip: $1302e4e1bb487594$var$SliceTooltip$1,
    debugMesh: false,
    enableCrosshair: true,
    crosshairType: "bottom-left"
};
var $1302e4e1bb487594$export$a29ddeccc3bcb4ee = $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, $1302e4e1bb487594$var$commonDefaultProps), {}, {
    enablePointLabel: false,
    useMesh: false,
    animate: true,
    motionConfig: "gentle",
    defs: [],
    fill: [],
    role: "img"
});
var $1302e4e1bb487594$export$933fd60b0b46acbc = $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, $1302e4e1bb487594$var$commonDefaultProps), {}, {
    pixelRatio: typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1
});
var $1302e4e1bb487594$export$f96f914698309372 = function useLineGenerator(_ref) {
    var curve = _ref.curve;
    return (0, $70fFQ.useMemo)(function() {
        return (0, $7Gyiu.default)().defined(function(d) {
            return d.x !== null && d.y !== null;
        }).x(function(d) {
            return d.x;
        }).y(function(d) {
            return d.y;
        }).curve((0, $2qXGl.curveFromProp)(curve));
    }, [
        curve
    ]);
};
var $1302e4e1bb487594$export$639abc9ba99bfd30 = function useAreaGenerator(_ref2) {
    var curve = _ref2.curve, yScale = _ref2.yScale, areaBaselineValue = _ref2.areaBaselineValue;
    return (0, $70fFQ.useMemo)(function() {
        return (0, $e9xmC.default)().defined(function(d) {
            return d.x !== null && d.y !== null;
        }).x(function(d) {
            return d.x;
        }).y1(function(d) {
            return d.y;
        }).curve((0, $2qXGl.curveFromProp)(curve)).y0(yScale(areaBaselineValue));
    }, [
        curve,
        yScale,
        areaBaselineValue
    ]);
};
var $1302e4e1bb487594$var$usePoints = function usePoints(_ref3) {
    var series = _ref3.series, getPointColor = _ref3.getPointColor, getPointBorderColor = _ref3.getPointBorderColor, formatX = _ref3.formatX, formatY = _ref3.formatY;
    return (0, $70fFQ.useMemo)(function() {
        return series.reduce(function(acc, serie) {
            return [].concat($1302e4e1bb487594$var$_toConsumableArray(acc), $1302e4e1bb487594$var$_toConsumableArray(serie.data.filter(function(datum) {
                return datum.position.x !== null && datum.position.y !== null;
            }).map(function(datum, i) {
                var point = {
                    id: "".concat(serie.id, ".").concat(i),
                    index: acc.length + i,
                    serieId: serie.id,
                    serieColor: serie.color,
                    x: datum.position.x,
                    y: datum.position.y
                };
                point.color = getPointColor(serie);
                point.borderColor = getPointBorderColor(point);
                point.data = $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, datum.data), {}, {
                    xFormatted: formatX(datum.data.x),
                    yFormatted: formatY(datum.data.y)
                });
                return point;
            })));
        }, []);
    }, [
        series,
        getPointColor,
        getPointBorderColor,
        formatX,
        formatY
    ]);
};
var $1302e4e1bb487594$export$f3ade18b642c97b8 = function useSlices(_ref4) {
    var enableSlices = _ref4.enableSlices, points = _ref4.points, width = _ref4.width, height = _ref4.height;
    return (0, $70fFQ.useMemo)(function() {
        if (enableSlices === false) return [];
        if (enableSlices === "x") {
            var map = new Map();
            points.forEach(function(point) {
                if (point.data.x === null || point.data.y === null) return;
                if (!map.has(point.x)) map.set(point.x, [
                    point
                ]);
                else map.get(point.x).push(point);
            });
            return Array.from(map.entries()).sort(function(a, b) {
                return a[0] - b[0];
            }).map(function(_ref5, i, slices) {
                var _ref6 = $1302e4e1bb487594$var$_slicedToArray(_ref5, 2), x = _ref6[0], slicePoints = _ref6[1];
                var prevSlice = slices[i - 1];
                var nextSlice = slices[i + 1];
                var x0;
                if (!prevSlice) x0 = x;
                else x0 = x - (x - prevSlice[0]) / 2;
                var sliceWidth;
                if (!nextSlice) sliceWidth = width - x0;
                else sliceWidth = x - x0 + (nextSlice[0] - x) / 2;
                return {
                    id: x,
                    x0: x0,
                    x: x,
                    y0: 0,
                    y: 0,
                    width: sliceWidth,
                    height: height,
                    points: slicePoints.reverse()
                };
            });
        } else if (enableSlices === "y") {
            var _map = new Map();
            points.forEach(function(point) {
                if (point.data.x === null || point.data.y === null) return;
                if (!_map.has(point.y)) _map.set(point.y, [
                    point
                ]);
                else _map.get(point.y).push(point);
            });
            return Array.from(_map.entries()).sort(function(a, b) {
                return a[0] - b[0];
            }).map(function(_ref7, i, slices) {
                var _ref8 = $1302e4e1bb487594$var$_slicedToArray(_ref7, 2), y = _ref8[0], slicePoints = _ref8[1];
                var prevSlice = slices[i - 1];
                var nextSlice = slices[i + 1];
                var y0;
                if (!prevSlice) y0 = y;
                else y0 = y - (y - prevSlice[0]) / 2;
                var sliceHeight;
                if (!nextSlice) sliceHeight = height - y0;
                else sliceHeight = y - y0 + (nextSlice[0] - y) / 2;
                return {
                    id: y,
                    x0: 0,
                    x: 0,
                    y0: y0,
                    y: y,
                    width: width,
                    height: sliceHeight,
                    points: slicePoints.reverse()
                };
            });
        }
    }, [
        enableSlices,
        points
    ]);
};
var $1302e4e1bb487594$export$223993f5dbe98de0 = function useLine(_ref9) {
    var data = _ref9.data, _ref9$xScale = _ref9.xScale, xScaleSpec = _ref9$xScale === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.xScale : _ref9$xScale, xFormat = _ref9.xFormat, _ref9$yScale = _ref9.yScale, yScaleSpec = _ref9$yScale === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.yScale : _ref9$yScale, yFormat = _ref9.yFormat, width = _ref9.width, height = _ref9.height, _ref9$colors = _ref9.colors, colors = _ref9$colors === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.colors : _ref9$colors, _ref9$curve = _ref9.curve, curve = _ref9$curve === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.curve : _ref9$curve, _ref9$areaBaselineVal = _ref9.areaBaselineValue, areaBaselineValue = _ref9$areaBaselineVal === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.areaBaselineValue : _ref9$areaBaselineVal, _ref9$pointColor = _ref9.pointColor, pointColor = _ref9$pointColor === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.pointColor : _ref9$pointColor, _ref9$pointBorderColo = _ref9.pointBorderColor, pointBorderColor = _ref9$pointBorderColo === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.pointBorderColor : _ref9$pointBorderColo, _ref9$enableSlices = _ref9.enableSlices, enableSlices = _ref9$enableSlices === void 0 ? $1302e4e1bb487594$export$a29ddeccc3bcb4ee.enableSlicesTooltip : _ref9$enableSlices;
    var formatX = (0, $2qXGl.useValueFormatter)(xFormat);
    var formatY = (0, $2qXGl.useValueFormatter)(yFormat);
    var getColor = (0, $boipe.useOrdinalColorScale)(colors, "id");
    var theme = (0, $2qXGl.useTheme)();
    var getPointColor = (0, $boipe.useInheritedColor)(pointColor, theme);
    var getPointBorderColor = (0, $boipe.useInheritedColor)(pointBorderColor, theme);
    var _useState = (0, $70fFQ.useState)([]), _useState2 = $1302e4e1bb487594$var$_slicedToArray(_useState, 2), hiddenIds = _useState2[0], setHiddenIds = _useState2[1];
    var _useMemo = (0, $70fFQ.useMemo)(function() {
        return (0, $lT7k3.computeXYScalesForSeries)(data.filter(function(item) {
            return hiddenIds.indexOf(item.id) === -1;
        }), xScaleSpec, yScaleSpec, width, height);
    }, [
        data,
        hiddenIds,
        xScaleSpec,
        yScaleSpec,
        width,
        height
    ]), xScale = _useMemo.xScale, yScale = _useMemo.yScale, rawSeries = _useMemo.series;
    var _useMemo2 = (0, $70fFQ.useMemo)(function() {
        var dataWithColor = data.map(function(line) {
            return {
                id: line.id,
                label: line.id,
                color: getColor(line)
            };
        });
        var series = dataWithColor.map(function(datum) {
            return $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, rawSeries.find(function(serie) {
                return serie.id === datum.id;
            })), {}, {
                color: datum.color
            });
        }).filter(function(item) {
            return Boolean(item.id);
        });
        var legendData = dataWithColor.map(function(item) {
            return $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, item), {}, {
                hidden: !series.find(function(serie) {
                    return serie.id === item.id;
                })
            });
        }).reverse();
        return {
            legendData: legendData,
            series: series
        };
    }, [
        data,
        rawSeries,
        getColor
    ]), legendData = _useMemo2.legendData, series = _useMemo2.series;
    var toggleSerie = (0, $70fFQ.useCallback)(function(id) {
        setHiddenIds(function(state) {
            return state.indexOf(id) > -1 ? state.filter(function(item) {
                return item !== id;
            }) : [].concat($1302e4e1bb487594$var$_toConsumableArray(state), [
                id
            ]);
        });
    }, []);
    var points = $1302e4e1bb487594$var$usePoints({
        series: series,
        getPointColor: getPointColor,
        getPointBorderColor: getPointBorderColor,
        formatX: formatX,
        formatY: formatY
    });
    var slices = $1302e4e1bb487594$export$f3ade18b642c97b8({
        enableSlices: enableSlices,
        points: points,
        width: width,
        height: height
    });
    var lineGenerator = $1302e4e1bb487594$export$f96f914698309372({
        curve: curve
    });
    var areaGenerator = $1302e4e1bb487594$export$639abc9ba99bfd30({
        curve: curve,
        yScale: yScale,
        areaBaselineValue: areaBaselineValue
    });
    return {
        legendData: legendData,
        toggleSerie: toggleSerie,
        lineGenerator: lineGenerator,
        areaGenerator: areaGenerator,
        getColor: getColor,
        series: series,
        xScale: xScale,
        yScale: yScale,
        slices: slices,
        points: points
    };
};
var $1302e4e1bb487594$var$AreaPath = function AreaPath(_ref) {
    var areaBlendMode = _ref.areaBlendMode, areaOpacity = _ref.areaOpacity, color = _ref.color, fill = _ref.fill, path = _ref.path;
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var animatedPath = (0, $2qXGl.useAnimatedPath)(path);
    var animatedProps = (0, $4ZiMn.useSpring)({
        color: color,
        config: springConfig,
        immediate: !animate
    });
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).path, {
        d: animatedPath,
        fill: fill ? fill : animatedProps.color,
        fillOpacity: areaOpacity,
        strokeWidth: 0,
        style: {
            mixBlendMode: areaBlendMode
        }
    });
};
var $1302e4e1bb487594$var$Areas = function Areas(_ref2) {
    var areaGenerator = _ref2.areaGenerator, areaOpacity = _ref2.areaOpacity, areaBlendMode = _ref2.areaBlendMode, lines = _ref2.lines;
    var computedLines = lines.slice(0).reverse();
    return (0, $4x3bm.jsx)("g", {
        children: computedLines.map(function(line) {
            return (0, $4x3bm.jsx)($1302e4e1bb487594$var$AreaPath, $1302e4e1bb487594$var$_objectSpread2({
                path: areaGenerator(line.data.map(function(d) {
                    return d.position;
                }))
            }, $1302e4e1bb487594$var$_objectSpread2({
                areaOpacity: areaOpacity,
                areaBlendMode: areaBlendMode
            }, line)), line.id);
        })
    });
};
var $1302e4e1bb487594$var$Areas$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$Areas);
var $1302e4e1bb487594$var$LinesItem = function LinesItem(_ref) {
    var lineGenerator = _ref.lineGenerator, points = _ref.points, color = _ref.color, thickness = _ref.thickness;
    var path = (0, $70fFQ.useMemo)(function() {
        return lineGenerator(points);
    }, [
        lineGenerator,
        points
    ]);
    var animatedPath = (0, $2qXGl.useAnimatedPath)(path);
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).path, {
        d: animatedPath,
        fill: "none",
        strokeWidth: thickness,
        stroke: color
    });
};
var $1302e4e1bb487594$var$LinesItem$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$LinesItem);
var $1302e4e1bb487594$var$Lines = function Lines(_ref) {
    var lines = _ref.lines, lineGenerator = _ref.lineGenerator, lineWidth = _ref.lineWidth;
    return lines.slice(0).reverse().map(function(_ref2) {
        var id = _ref2.id, data = _ref2.data, color = _ref2.color;
        return (0, $4x3bm.jsx)($1302e4e1bb487594$var$LinesItem$1, {
            id: id,
            points: data.map(function(d) {
                return d.position;
            }),
            lineGenerator: lineGenerator,
            color: color,
            thickness: lineWidth
        }, id);
    });
};
var $1302e4e1bb487594$var$Lines$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$Lines);
var $1302e4e1bb487594$var$SlicesItem = function SlicesItem(_ref) {
    var slice = _ref.slice, axis = _ref.axis, debug = _ref.debug, tooltip = _ref.tooltip, isCurrent = _ref.isCurrent, setCurrent = _ref.setCurrent;
    var _useTooltip = (0, $lITvm.useTooltip)(), showTooltipFromEvent = _useTooltip.showTooltipFromEvent, hideTooltip = _useTooltip.hideTooltip;
    var handleMouseEnter = (0, $70fFQ.useCallback)(function(event) {
        showTooltipFromEvent((0, $70fFQ.createElement)(tooltip, {
            slice: slice,
            axis: axis
        }), event, "right");
        setCurrent(slice);
    }, [
        showTooltipFromEvent,
        tooltip,
        slice
    ]);
    var handleMouseMove = (0, $70fFQ.useCallback)(function(event) {
        showTooltipFromEvent((0, $70fFQ.createElement)(tooltip, {
            slice: slice,
            axis: axis
        }), event, "right");
    }, [
        showTooltipFromEvent,
        tooltip,
        slice
    ]);
    var handleMouseLeave = (0, $70fFQ.useCallback)(function() {
        hideTooltip();
        setCurrent(null);
    }, [
        hideTooltip
    ]);
    return (0, $4x3bm.jsx)("rect", {
        x: slice.x0,
        y: slice.y0,
        width: slice.width,
        height: slice.height,
        stroke: "red",
        strokeWidth: debug ? 1 : 0,
        strokeOpacity: 0.75,
        fill: "red",
        fillOpacity: isCurrent && debug ? 0.35 : 0,
        onMouseEnter: handleMouseEnter,
        onMouseMove: handleMouseMove,
        onMouseLeave: handleMouseLeave
    });
};
var $1302e4e1bb487594$var$SlicesItem$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$SlicesItem);
var $1302e4e1bb487594$var$Slices = function Slices(_ref) {
    var slices = _ref.slices, axis = _ref.axis, debug = _ref.debug, height = _ref.height, tooltip = _ref.tooltip, current = _ref.current, setCurrent = _ref.setCurrent;
    return slices.map(function(slice) {
        return (0, $4x3bm.jsx)($1302e4e1bb487594$var$SlicesItem$1, {
            slice: slice,
            axis: axis,
            debug: debug,
            height: height,
            tooltip: tooltip,
            setCurrent: setCurrent,
            isCurrent: current !== null && current.id === slice.id
        }, slice.id);
    });
};
var $1302e4e1bb487594$var$Slices$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$Slices);
var $1302e4e1bb487594$var$Points = function Points(_ref) {
    var points = _ref.points, symbol = _ref.symbol, size = _ref.size, borderWidth = _ref.borderWidth, enableLabel = _ref.enableLabel, label = _ref.label, labelYOffset = _ref.labelYOffset;
    var theme = (0, $2qXGl.useTheme)();
    var getLabel = (0, $2qXGl.getLabelGenerator)(label);
    var mappedPoints = points.reverse().map(function(point) {
        var mappedPoint = {
            id: point.id,
            x: point.x,
            y: point.y,
            datum: point.data,
            fill: point.color,
            stroke: point.borderColor,
            label: enableLabel ? getLabel(point.data) : null
        };
        return mappedPoint;
    });
    return (0, $4x3bm.jsx)("g", {
        children: mappedPoints.map(function(point) {
            return (0, $4x3bm.jsx)((0, $2qXGl.DotsItem), {
                x: point.x,
                y: point.y,
                datum: point.datum,
                symbol: symbol,
                size: size,
                color: point.fill,
                borderWidth: borderWidth,
                borderColor: point.stroke,
                label: point.label,
                labelYOffset: labelYOffset,
                theme: theme
            }, point.id);
        })
    });
};
var $1302e4e1bb487594$var$Points$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$Points);
var $1302e4e1bb487594$var$Mesh = function Mesh(_ref) {
    var points = _ref.points, width = _ref.width, height = _ref.height, margin = _ref.margin, setCurrent = _ref.setCurrent, onMouseEnter = _ref.onMouseEnter, onMouseMove = _ref.onMouseMove, onMouseLeave = _ref.onMouseLeave, onClick = _ref.onClick, tooltip = _ref.tooltip, debug = _ref.debug;
    var _useTooltip = (0, $lITvm.useTooltip)(), showTooltipAt = _useTooltip.showTooltipAt, hideTooltip = _useTooltip.hideTooltip;
    var handleMouseEnter = (0, $70fFQ.useCallback)(function(point, event) {
        showTooltipAt((0, $70fFQ.createElement)(tooltip, {
            point: point
        }), [
            point.x + margin.left,
            point.y + margin.top
        ], "top");
        setCurrent(point);
        onMouseEnter && onMouseEnter(point, event);
    }, [
        setCurrent,
        showTooltipAt,
        tooltip,
        onMouseEnter,
        margin
    ]);
    var handleMouseMove = (0, $70fFQ.useCallback)(function(point, event) {
        showTooltipAt((0, $70fFQ.createElement)(tooltip, {
            point: point
        }), [
            point.x + margin.left,
            point.y + margin.top
        ], "top");
        setCurrent(point);
        onMouseMove && onMouseMove(point, event);
    }, [
        setCurrent,
        showTooltipAt,
        tooltip,
        onMouseMove
    ]);
    var handleMouseLeave = (0, $70fFQ.useCallback)(function(point, event) {
        hideTooltip();
        setCurrent(null);
        onMouseLeave && onMouseLeave(point, event);
    }, [
        hideTooltip,
        setCurrent,
        onMouseLeave
    ]);
    var handleClick = (0, $70fFQ.useCallback)(function(point, event) {
        onClick && onClick(point, event);
    }, [
        onClick
    ]);
    return (0, $4x3bm.jsx)((0, $eI4IL.Mesh), {
        nodes: points,
        width: width,
        height: height,
        onMouseEnter: handleMouseEnter,
        onMouseMove: handleMouseMove,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick,
        debug: debug
    });
};
var $1302e4e1bb487594$var$Mesh$1 = (0, $70fFQ.memo)($1302e4e1bb487594$var$Mesh);
var $1302e4e1bb487594$var$Line = function Line(props) {
    var data = props.data, xScaleSpec = props.xScale, xFormat = props.xFormat, yScaleSpec = props.yScale, yFormat = props.yFormat, layers = props.layers, curve = props.curve, areaBaselineValue = props.areaBaselineValue, colors = props.colors, partialMargin = props.margin, width = props.width, height = props.height, axisTop = props.axisTop, axisRight = props.axisRight, axisBottom = props.axisBottom, axisLeft = props.axisLeft, enableGridX = props.enableGridX, enableGridY = props.enableGridY, gridXValues = props.gridXValues, gridYValues = props.gridYValues, lineWidth = props.lineWidth, enableArea = props.enableArea, areaOpacity = props.areaOpacity, areaBlendMode = props.areaBlendMode, enablePoints = props.enablePoints, pointSymbol = props.pointSymbol, pointSize = props.pointSize, pointColor = props.pointColor, pointBorderWidth = props.pointBorderWidth, pointBorderColor = props.pointBorderColor, enablePointLabel = props.enablePointLabel, pointLabel = props.pointLabel, pointLabelYOffset = props.pointLabelYOffset, defs = props.defs, fill = props.fill, markers = props.markers, legends = props.legends, isInteractive = props.isInteractive, useMesh = props.useMesh, debugMesh = props.debugMesh, onMouseEnter = props.onMouseEnter, onMouseMove = props.onMouseMove, onMouseLeave = props.onMouseLeave, onClick = props.onClick, tooltip = props.tooltip, enableSlices = props.enableSlices, debugSlices = props.debugSlices, sliceTooltip = props.sliceTooltip, enableCrosshair = props.enableCrosshair, crosshairType = props.crosshairType, role = props.role;
    var _useDimensions = (0, $2qXGl.useDimensions)(width, height, partialMargin), margin = _useDimensions.margin, innerWidth = _useDimensions.innerWidth, innerHeight = _useDimensions.innerHeight, outerWidth = _useDimensions.outerWidth, outerHeight = _useDimensions.outerHeight;
    var _useLine = $1302e4e1bb487594$export$223993f5dbe98de0({
        data: data,
        xScale: xScaleSpec,
        xFormat: xFormat,
        yScale: yScaleSpec,
        yFormat: yFormat,
        width: innerWidth,
        height: innerHeight,
        colors: colors,
        curve: curve,
        areaBaselineValue: areaBaselineValue,
        pointColor: pointColor,
        pointBorderColor: pointBorderColor,
        enableSlices: enableSlices
    }), legendData = _useLine.legendData, toggleSerie = _useLine.toggleSerie, lineGenerator = _useLine.lineGenerator, areaGenerator = _useLine.areaGenerator, series = _useLine.series, xScale = _useLine.xScale, yScale = _useLine.yScale, slices = _useLine.slices, points = _useLine.points;
    var theme = (0, $2qXGl.useTheme)();
    var getPointColor = (0, $boipe.useInheritedColor)(pointColor, theme);
    var getPointBorderColor = (0, $boipe.useInheritedColor)(pointBorderColor, theme);
    var _useState = (0, $70fFQ.useState)(null), _useState2 = $1302e4e1bb487594$var$_slicedToArray(_useState, 2), currentPoint = _useState2[0], setCurrentPoint = _useState2[1];
    var _useState3 = (0, $70fFQ.useState)(null), _useState4 = $1302e4e1bb487594$var$_slicedToArray(_useState3, 2), currentSlice = _useState4[0], setCurrentSlice = _useState4[1];
    var layerById = {
        grid: (0, $4x3bm.jsx)((0, $jtZ7X.Grid), {
            theme: theme,
            width: innerWidth,
            height: innerHeight,
            xScale: enableGridX ? xScale : null,
            yScale: enableGridY ? yScale : null,
            xValues: gridXValues,
            yValues: gridYValues
        }, "grid"),
        markers: (0, $4x3bm.jsx)((0, $2qXGl.CartesianMarkers), {
            markers: markers,
            width: innerWidth,
            height: innerHeight,
            xScale: xScale,
            yScale: yScale,
            theme: theme
        }, "markers"),
        axes: (0, $4x3bm.jsx)((0, $jtZ7X.Axes), {
            xScale: xScale,
            yScale: yScale,
            width: innerWidth,
            height: innerHeight,
            theme: theme,
            top: axisTop,
            right: axisRight,
            bottom: axisBottom,
            left: axisLeft
        }, "axes"),
        areas: null,
        lines: (0, $4x3bm.jsx)($1302e4e1bb487594$var$Lines$1, {
            lines: series,
            lineGenerator: lineGenerator,
            lineWidth: lineWidth
        }, "lines"),
        slices: null,
        points: null,
        crosshair: null,
        mesh: null,
        legends: legends.map(function(legend, i) {
            return (0, $4x3bm.jsx)((0, $fpOVP.BoxLegendSvg), $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, legend), {}, {
                containerWidth: innerWidth,
                containerHeight: innerHeight,
                data: legend.data || legendData,
                theme: theme,
                toggleSerie: legend.toggleSerie ? toggleSerie : undefined
            }), "legend.".concat(i));
        })
    };
    var boundDefs = (0, $2qXGl.bindDefs)(defs, series, fill);
    if (enableArea) layerById.areas = (0, $4x3bm.jsx)($1302e4e1bb487594$var$Areas$1, {
        areaGenerator: areaGenerator,
        areaOpacity: areaOpacity,
        areaBlendMode: areaBlendMode,
        lines: series
    }, "areas");
    if (isInteractive && enableSlices !== false) layerById.slices = (0, $4x3bm.jsx)($1302e4e1bb487594$var$Slices$1, {
        slices: slices,
        axis: enableSlices,
        debug: debugSlices,
        height: innerHeight,
        tooltip: sliceTooltip,
        current: currentSlice,
        setCurrent: setCurrentSlice
    }, "slices");
    if (enablePoints) layerById.points = (0, $4x3bm.jsx)($1302e4e1bb487594$var$Points$1, {
        points: points,
        symbol: pointSymbol,
        size: pointSize,
        color: getPointColor,
        borderWidth: pointBorderWidth,
        borderColor: getPointBorderColor,
        enableLabel: enablePointLabel,
        label: pointLabel,
        labelYOffset: pointLabelYOffset
    }, "points");
    if (isInteractive && enableCrosshair) {
        if (currentPoint !== null) layerById.crosshair = (0, $4x3bm.jsx)((0, $lITvm.Crosshair), {
            width: innerWidth,
            height: innerHeight,
            x: currentPoint.x,
            y: currentPoint.y,
            type: crosshairType
        }, "crosshair");
        if (currentSlice !== null) layerById.crosshair = (0, $4x3bm.jsx)((0, $lITvm.Crosshair), {
            width: innerWidth,
            height: innerHeight,
            x: currentSlice.x,
            y: currentSlice.y,
            type: enableSlices
        }, "crosshair");
    }
    if (isInteractive && useMesh && enableSlices === false) layerById.mesh = (0, $4x3bm.jsx)($1302e4e1bb487594$var$Mesh$1, {
        points: points,
        width: innerWidth,
        height: innerHeight,
        margin: margin,
        current: currentPoint,
        setCurrent: setCurrentPoint,
        onMouseEnter: onMouseEnter,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        tooltip: tooltip,
        debug: debugMesh
    }, "mesh");
    return (0, $4x3bm.jsx)((0, $2qXGl.SvgWrapper), {
        defs: boundDefs,
        width: outerWidth,
        height: outerHeight,
        margin: margin,
        role: role,
        children: layers.map(function(layer, i) {
            if (typeof layer === "function") return (0, $4x3bm.jsx)((0, $70fFQ.Fragment), {
                children: layer($1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, props), {}, {
                    innerWidth: innerWidth,
                    innerHeight: innerHeight,
                    series: series,
                    slices: slices,
                    points: points,
                    xScale: xScale,
                    yScale: yScale,
                    lineGenerator: lineGenerator,
                    areaGenerator: areaGenerator,
                    currentPoint: currentPoint,
                    setCurrentPoint: setCurrentPoint,
                    currentSlice: currentSlice,
                    setCurrentSlice: setCurrentSlice
                }))
            }, i);
            return layerById[layer];
        })
    });
};
$1302e4e1bb487594$var$Line.defaultProps = $1302e4e1bb487594$export$a29ddeccc3bcb4ee;
var $1302e4e1bb487594$export$17d680238e50603e = (0, $2qXGl.withContainer)($1302e4e1bb487594$var$Line);
var $1302e4e1bb487594$export$a4a9f4982e5c2626 = function ResponsiveLine(props) {
    return (0, $4x3bm.jsx)((0, $2qXGl.ResponsiveWrapper), {
        children: function children(_ref) {
            var width = _ref.width, height = _ref.height;
            return (0, $4x3bm.jsx)($1302e4e1bb487594$export$17d680238e50603e, $1302e4e1bb487594$var$_objectSpread2({
                width: width,
                height: height
            }, props));
        }
    });
};
var $1302e4e1bb487594$var$LineCanvas = function LineCanvas(_ref) {
    var width = _ref.width, height = _ref.height, partialMargin = _ref.margin, pixelRatio = _ref.pixelRatio, data = _ref.data, xScaleSpec = _ref.xScale, xFormat = _ref.xFormat, yScaleSpec = _ref.yScale, yFormat = _ref.yFormat, curve = _ref.curve, layers = _ref.layers, colors = _ref.colors, lineWidth = _ref.lineWidth, enableArea = _ref.enableArea, areaBaselineValue = _ref.areaBaselineValue, areaOpacity = _ref.areaOpacity, enablePoints = _ref.enablePoints, pointSize = _ref.pointSize, pointColor = _ref.pointColor, pointBorderWidth = _ref.pointBorderWidth, pointBorderColor = _ref.pointBorderColor, enableGridX = _ref.enableGridX, gridXValues = _ref.gridXValues, enableGridY = _ref.enableGridY, gridYValues = _ref.gridYValues, axisTop = _ref.axisTop, axisRight = _ref.axisRight, axisBottom = _ref.axisBottom, axisLeft = _ref.axisLeft, legends = _ref.legends, isInteractive = _ref.isInteractive, debugMesh = _ref.debugMesh, onMouseLeave = _ref.onMouseLeave, onClick = _ref.onClick, tooltip = _ref.tooltip, canvasRef = _ref.canvasRef;
    var canvasEl = (0, $70fFQ.useRef)(null);
    var _useDimensions = (0, $2qXGl.useDimensions)(width, height, partialMargin), margin = _useDimensions.margin, innerWidth = _useDimensions.innerWidth, innerHeight = _useDimensions.innerHeight, outerWidth = _useDimensions.outerWidth, outerHeight = _useDimensions.outerHeight;
    var theme = (0, $2qXGl.useTheme)();
    var _useState = (0, $70fFQ.useState)(null), _useState2 = $1302e4e1bb487594$var$_slicedToArray(_useState, 2), currentPoint = _useState2[0], setCurrentPoint = _useState2[1];
    var _useLine = $1302e4e1bb487594$export$223993f5dbe98de0({
        data: data,
        xScale: xScaleSpec,
        xFormat: xFormat,
        yScale: yScaleSpec,
        yFormat: yFormat,
        width: innerWidth,
        height: innerHeight,
        colors: colors,
        curve: curve,
        areaBaselineValue: areaBaselineValue,
        pointColor: pointColor,
        pointBorderColor: pointBorderColor
    }), lineGenerator = _useLine.lineGenerator, areaGenerator = _useLine.areaGenerator, series = _useLine.series, xScale = _useLine.xScale, yScale = _useLine.yScale, points = _useLine.points;
    var _useVoronoiMesh = (0, $eI4IL.useVoronoiMesh)({
        points: points,
        width: innerWidth,
        height: innerHeight,
        debug: debugMesh
    }), delaunay = _useVoronoiMesh.delaunay, voronoi = _useVoronoiMesh.voronoi;
    (0, $70fFQ.useEffect)(function() {
        if (canvasRef) canvasRef.current = canvasEl.current;
        canvasEl.current.width = outerWidth * pixelRatio;
        canvasEl.current.height = outerHeight * pixelRatio;
        var ctx = canvasEl.current.getContext("2d");
        ctx.scale(pixelRatio, pixelRatio);
        ctx.fillStyle = theme.background;
        ctx.fillRect(0, 0, outerWidth, outerHeight);
        ctx.translate(margin.left, margin.top);
        layers.forEach(function(layer) {
            if (typeof layer === "function") layer({
                ctx: ctx,
                innerWidth: innerWidth,
                innerHeight: innerHeight,
                series: series,
                points: points,
                xScale: xScale,
                yScale: yScale,
                lineWidth: lineWidth,
                lineGenerator: lineGenerator,
                areaGenerator: areaGenerator,
                currentPoint: currentPoint,
                setCurrentPoint: setCurrentPoint
            });
            if (layer === "grid" && theme.grid.line.strokeWidth > 0) {
                ctx.lineWidth = theme.grid.line.strokeWidth;
                ctx.strokeStyle = theme.grid.line.stroke;
                enableGridX && (0, $jtZ7X.renderGridLinesToCanvas)(ctx, {
                    width: innerWidth,
                    height: innerHeight,
                    scale: xScale,
                    axis: "x",
                    values: gridXValues
                });
                enableGridY && (0, $jtZ7X.renderGridLinesToCanvas)(ctx, {
                    width: innerWidth,
                    height: innerHeight,
                    scale: yScale,
                    axis: "y",
                    values: gridYValues
                });
            }
            if (layer === "axes") (0, $jtZ7X.renderAxesToCanvas)(ctx, {
                xScale: xScale,
                yScale: yScale,
                width: innerWidth,
                height: innerHeight,
                top: axisTop,
                right: axisRight,
                bottom: axisBottom,
                left: axisLeft,
                theme: theme
            });
            if (layer === "areas" && enableArea === true) {
                ctx.save();
                ctx.globalAlpha = areaOpacity;
                areaGenerator.context(ctx);
                series.forEach(function(serie) {
                    ctx.fillStyle = serie.color;
                    ctx.beginPath();
                    areaGenerator(serie.data.map(function(d) {
                        return d.position;
                    }));
                    ctx.fill();
                });
                ctx.restore();
            }
            if (layer === "lines") {
                lineGenerator.context(ctx);
                series.forEach(function(serie) {
                    ctx.strokeStyle = serie.color;
                    ctx.lineWidth = lineWidth;
                    ctx.beginPath();
                    lineGenerator(serie.data.map(function(d) {
                        return d.position;
                    }));
                    ctx.stroke();
                });
            }
            if (layer === "points" && enablePoints === true && pointSize > 0) points.forEach(function(point) {
                ctx.fillStyle = point.color;
                ctx.beginPath();
                ctx.arc(point.x, point.y, pointSize / 2, 0, 2 * Math.PI);
                ctx.fill();
                if (pointBorderWidth > 0) {
                    ctx.strokeStyle = point.borderColor;
                    ctx.lineWidth = pointBorderWidth;
                    ctx.stroke();
                }
            });
            if (layer === "mesh" && debugMesh === true) {
                (0, $eI4IL.renderVoronoiToCanvas)(ctx, voronoi);
                if (currentPoint) (0, $eI4IL.renderVoronoiCellToCanvas)(ctx, voronoi, currentPoint.index);
            }
            if (layer === "legends") {
                var legendData = series.map(function(serie) {
                    return {
                        id: serie.id,
                        label: serie.id,
                        color: serie.color
                    };
                }).reverse();
                legends.forEach(function(legend) {
                    (0, $fpOVP.renderLegendToCanvas)(ctx, $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, legend), {}, {
                        data: legend.data || legendData,
                        containerWidth: innerWidth,
                        containerHeight: innerHeight,
                        theme: theme
                    }));
                });
            }
        });
    }, [
        canvasEl,
        outerWidth,
        outerHeight,
        layers,
        theme,
        lineGenerator,
        series,
        xScale,
        yScale,
        enableGridX,
        gridXValues,
        enableGridY,
        gridYValues,
        axisTop,
        axisRight,
        axisBottom,
        axisLeft,
        legends,
        points,
        enablePoints,
        pointSize,
        currentPoint
    ]);
    var getPointFromMouseEvent = (0, $70fFQ.useCallback)(function(event) {
        var _getRelativeCursor = (0, $2qXGl.getRelativeCursor)(canvasEl.current, event), _getRelativeCursor2 = $1302e4e1bb487594$var$_slicedToArray(_getRelativeCursor, 2), x = _getRelativeCursor2[0], y = _getRelativeCursor2[1];
        if (!(0, $2qXGl.isCursorInRect)(margin.left, margin.top, innerWidth, innerHeight, x, y)) return null;
        var pointIndex = delaunay.find(x - margin.left, y - margin.top);
        return points[pointIndex];
    }, [
        canvasEl,
        margin,
        innerWidth,
        innerHeight,
        delaunay
    ]);
    var _useTooltip = (0, $lITvm.useTooltip)(), showTooltipFromEvent = _useTooltip.showTooltipFromEvent, hideTooltip = _useTooltip.hideTooltip;
    var handleMouseHover = (0, $70fFQ.useCallback)(function(event) {
        var point = getPointFromMouseEvent(event);
        setCurrentPoint(point);
        if (point) showTooltipFromEvent((0, $70fFQ.createElement)(tooltip, {
            point: point
        }), event);
        else hideTooltip();
    }, [
        getPointFromMouseEvent,
        setCurrentPoint,
        showTooltipFromEvent,
        hideTooltip,
        tooltip
    ]);
    var handleMouseLeave = (0, $70fFQ.useCallback)(function(event) {
        hideTooltip();
        setCurrentPoint(null);
        currentPoint && onMouseLeave && onMouseLeave(currentPoint, event);
    }, [
        hideTooltip,
        setCurrentPoint,
        onMouseLeave
    ]);
    var handleClick = (0, $70fFQ.useCallback)(function(event) {
        if (onClick) {
            var point = getPointFromMouseEvent(event);
            point && onClick(point, event);
        }
    }, [
        getPointFromMouseEvent,
        onClick
    ]);
    return (0, $4x3bm.jsx)("canvas", {
        ref: canvasEl,
        width: outerWidth * pixelRatio,
        height: outerHeight * pixelRatio,
        style: {
            width: outerWidth,
            height: outerHeight,
            cursor: isInteractive ? "auto" : "normal"
        },
        onMouseEnter: isInteractive ? handleMouseHover : undefined,
        onMouseMove: isInteractive ? handleMouseHover : undefined,
        onMouseLeave: isInteractive ? handleMouseLeave : undefined,
        onClick: isInteractive ? handleClick : undefined
    });
};
$1302e4e1bb487594$var$LineCanvas.defaultProps = $1302e4e1bb487594$export$933fd60b0b46acbc;
var $1302e4e1bb487594$var$LineCanvasWithContainer = (0, $2qXGl.withContainer)($1302e4e1bb487594$var$LineCanvas);
var $1302e4e1bb487594$export$b180b12178bebb77 = (0, $70fFQ.forwardRef)(function(props, ref) {
    return (0, $4x3bm.jsx)($1302e4e1bb487594$var$LineCanvasWithContainer, $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({}, props), {}, {
        canvasRef: ref
    }));
});
var $1302e4e1bb487594$var$ResponsiveLineCanvas = function ResponsiveLineCanvas(props, ref) {
    return (0, $4x3bm.jsx)((0, $2qXGl.ResponsiveWrapper), {
        children: function children(_ref) {
            var width = _ref.width, height = _ref.height;
            return (0, $4x3bm.jsx)($1302e4e1bb487594$export$b180b12178bebb77, $1302e4e1bb487594$var$_objectSpread2($1302e4e1bb487594$var$_objectSpread2({
                width: width,
                height: height
            }, props), {}, {
                ref: ref
            }));
        }
    });
};
var $1302e4e1bb487594$export$ef8f1d6c5afa72f3 = (0, $70fFQ.forwardRef)($1302e4e1bb487594$var$ResponsiveLineCanvas);

});
parcelRegister("jtZ7X", function(module, exports) {

$parcel$export(module.exports, "axisPropType", function () { return $e2f0245f714c3922$export$8502d8c4b99a277e; });
$parcel$export(module.exports, "Axes", function () { return $e2f0245f714c3922$export$387a78ab20784494; });
$parcel$export(module.exports, "Grid", function () { return $e2f0245f714c3922$export$ef2184bd89960b14; });
$parcel$export(module.exports, "renderAxesToCanvas", function () { return $e2f0245f714c3922$export$6f12c0e853c1bfff; });
$parcel$export(module.exports, "renderGridLinesToCanvas", function () { return $e2f0245f714c3922$export$5eea7e798580e5d1; });

var $70fFQ = parcelRequire("70fFQ");

var $eYtn3 = parcelRequire("eYtn3");
var $4ZiMn = parcelRequire("4ZiMn");

var $2qXGl = parcelRequire("2qXGl");

var $7pj3L = parcelRequire("7pj3L");

var $go5S7 = parcelRequire("go5S7");

var $lT7k3 = parcelRequire("lT7k3");

var $4x3bm = parcelRequire("4x3bm");

var $cd0Jr = parcelRequire("cd0Jr");
function $e2f0245f714c3922$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e2f0245f714c3922$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e2f0245f714c3922$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e2f0245f714c3922$var$ownKeys(Object(source), true).forEach(function(key) {
            $e2f0245f714c3922$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e2f0245f714c3922$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e2f0245f714c3922$var$isArray = function isArray(value) {
    return Array.isArray(value);
};
var $e2f0245f714c3922$var$computeCartesianTicks = function computeCartesianTicks(_ref) {
    var axis = _ref.axis, scale = _ref.scale, ticksPosition = _ref.ticksPosition, tickValues = _ref.tickValues, tickSize = _ref.tickSize, tickPadding = _ref.tickPadding, tickRotation = _ref.tickRotation, _ref$engine = _ref.engine, engine = _ref$engine === void 0 ? "svg" : _ref$engine;
    var values = (0, $lT7k3.getScaleTicks)(scale, tickValues);
    var textProps = (0, $2qXGl.textPropsByEngine)[engine];
    var position = "bandwidth" in scale ? (0, $lT7k3.centerScale)(scale) : scale;
    var line = {
        lineX: 0,
        lineY: 0
    };
    var text = {
        textX: 0,
        textY: 0
    };
    var isRTL = typeof document === "object" ? document.dir === "rtl" : false;
    var translate;
    var textAlign = textProps.align.center;
    var textBaseline = textProps.baseline.center;
    if (axis === "x") {
        translate = function translate(d) {
            var _position;
            return {
                x: (_position = position(d)) !== null && _position !== void 0 ? _position : 0,
                y: 0
            };
        };
        line.lineY = tickSize * (ticksPosition === "after" ? 1 : -1);
        text.textY = (tickSize + tickPadding) * (ticksPosition === "after" ? 1 : -1);
        if (ticksPosition === "after") textBaseline = textProps.baseline.top;
        else textBaseline = textProps.baseline.bottom;
        if (tickRotation === 0) textAlign = textProps.align.center;
        else if (ticksPosition === "after" && tickRotation < 0 || ticksPosition === "before" && tickRotation > 0) {
            textAlign = textProps.align[isRTL ? "left" : "right"];
            textBaseline = textProps.baseline.center;
        } else if (ticksPosition === "after" && tickRotation > 0 || ticksPosition === "before" && tickRotation < 0) {
            textAlign = textProps.align[isRTL ? "right" : "left"];
            textBaseline = textProps.baseline.center;
        }
    } else {
        translate = function translate(d) {
            var _position2;
            return {
                x: 0,
                y: (_position2 = position(d)) !== null && _position2 !== void 0 ? _position2 : 0
            };
        };
        line.lineX = tickSize * (ticksPosition === "after" ? 1 : -1);
        text.textX = (tickSize + tickPadding) * (ticksPosition === "after" ? 1 : -1);
        if (ticksPosition === "after") textAlign = textProps.align.left;
        else textAlign = textProps.align.right;
    }
    var ticks = values.map(function(value) {
        return $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({
            key: typeof value === "number" || typeof value === "string" ? value : "".concat(value),
            value: value
        }, translate(value)), line), text);
    });
    return {
        ticks: ticks,
        textAlign: textAlign,
        textBaseline: textBaseline
    };
};
var $e2f0245f714c3922$var$getFormatter = function getFormatter(format$1, scale) {
    if (typeof format$1 === "undefined" || typeof format$1 === "function") return format$1;
    if (scale.type === "time") {
        var formatter = (0, $7pj3L.timeFormat)(format$1);
        return function(d) {
            return formatter(d instanceof Date ? d : new Date(d));
        };
    }
    return (0, $go5S7.format)(format$1);
};
var $e2f0245f714c3922$var$computeGridLines = function computeGridLines(_ref2) {
    var width = _ref2.width, height = _ref2.height, scale = _ref2.scale, axis = _ref2.axis, _values = _ref2.values;
    var lineValues = $e2f0245f714c3922$var$isArray(_values) ? _values : undefined;
    var values = lineValues || (0, $lT7k3.getScaleTicks)(scale, _values);
    var position = "bandwidth" in scale ? (0, $lT7k3.centerScale)(scale) : scale;
    var lines = axis === "x" ? values.map(function(value) {
        var _position3, _position4;
        return {
            key: "".concat(value),
            x1: (_position3 = position(value)) !== null && _position3 !== void 0 ? _position3 : 0,
            x2: (_position4 = position(value)) !== null && _position4 !== void 0 ? _position4 : 0,
            y1: 0,
            y2: height
        };
    }) : values.map(function(value) {
        var _position5, _position6;
        return {
            key: "".concat(value),
            x1: 0,
            x2: width,
            y1: (_position5 = position(value)) !== null && _position5 !== void 0 ? _position5 : 0,
            y2: (_position6 = position(value)) !== null && _position6 !== void 0 ? _position6 : 0
        };
    });
    return lines;
};
var $e2f0245f714c3922$var$AxisTick = function AxisTick(_ref) {
    var _format;
    var _value = _ref.value, format = _ref.format, lineX = _ref.lineX, lineY = _ref.lineY, _onClick = _ref.onClick, textBaseline = _ref.textBaseline, textAnchor = _ref.textAnchor, animatedProps = _ref.animatedProps;
    var theme = (0, $2qXGl.useTheme)();
    var value = (_format = format === null || format === void 0 ? void 0 : format(_value)) !== null && _format !== void 0 ? _format : _value;
    var props = (0, $70fFQ.useMemo)(function() {
        var style = {
            opacity: animatedProps.opacity
        };
        if (!_onClick) return {
            style: style
        };
        return {
            style: $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({}, style), {}, {
                cursor: "pointer"
            }),
            onClick: function onClick(event) {
                return _onClick(event, value);
            }
        };
    }, [
        animatedProps.opacity,
        _onClick,
        value
    ]);
    return (0, $4x3bm.jsxs)((0, $eYtn3.animated).g, $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({
        transform: animatedProps.transform
    }, props), {}, {
        children: [
            (0, $4x3bm.jsx)("line", {
                x1: 0,
                x2: lineX,
                y1: 0,
                y2: lineY,
                style: theme.axis.ticks.line
            }),
            (0, $4x3bm.jsx)((0, $eYtn3.animated).text, {
                dominantBaseline: textBaseline,
                textAnchor: textAnchor,
                transform: animatedProps.textTransform,
                style: theme.axis.ticks.text,
                children: value
            })
        ]
    }));
};
var $e2f0245f714c3922$export$3704f81c1ca961a8 = (0, $70fFQ.memo)($e2f0245f714c3922$var$AxisTick);
var $e2f0245f714c3922$var$Axis = function Axis(_ref) {
    var axis = _ref.axis, scale = _ref.scale, _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, length = _ref.length, ticksPosition = _ref.ticksPosition, tickValues = _ref.tickValues, _ref$tickSize = _ref.tickSize, tickSize = _ref$tickSize === void 0 ? 5 : _ref$tickSize, _ref$tickPadding = _ref.tickPadding, tickPadding = _ref$tickPadding === void 0 ? 5 : _ref$tickPadding, _ref$tickRotation = _ref.tickRotation, tickRotation = _ref$tickRotation === void 0 ? 0 : _ref$tickRotation, format = _ref.format, _ref$renderTick = _ref.renderTick, renderTick = _ref$renderTick === void 0 ? $e2f0245f714c3922$export$3704f81c1ca961a8 : _ref$renderTick, legend = _ref.legend, _ref$legendPosition = _ref.legendPosition, legendPosition = _ref$legendPosition === void 0 ? "end" : _ref$legendPosition, _ref$legendOffset = _ref.legendOffset, legendOffset = _ref$legendOffset === void 0 ? 0 : _ref$legendOffset, onClick = _ref.onClick, ariaHidden = _ref.ariaHidden;
    var theme = (0, $2qXGl.useTheme)();
    var formatValue = (0, $70fFQ.useMemo)(function() {
        return $e2f0245f714c3922$var$getFormatter(format, scale);
    }, [
        format,
        scale
    ]);
    var _computeCartesianTick = $e2f0245f714c3922$var$computeCartesianTicks({
        axis: axis,
        scale: scale,
        ticksPosition: ticksPosition,
        tickValues: tickValues,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotation: tickRotation
    }), ticks = _computeCartesianTick.ticks, textAlign = _computeCartesianTick.textAlign, textBaseline = _computeCartesianTick.textBaseline;
    var legendNode = null;
    if (legend !== undefined) {
        var legendX = 0;
        var legendY = 0;
        var legendRotation = 0;
        var textAnchor;
        if (axis === "y") {
            legendRotation = -90;
            legendX = legendOffset;
            if (legendPosition === "start") {
                textAnchor = "start";
                legendY = length;
            } else if (legendPosition === "middle") {
                textAnchor = "middle";
                legendY = length / 2;
            } else if (legendPosition === "end") textAnchor = "end";
        } else {
            legendY = legendOffset;
            if (legendPosition === "start") textAnchor = "start";
            else if (legendPosition === "middle") {
                textAnchor = "middle";
                legendX = length / 2;
            } else if (legendPosition === "end") {
                textAnchor = "end";
                legendX = length;
            }
        }
        legendNode = (0, $4x3bm.jsx)("text", {
            transform: "translate(".concat(legendX, ", ").concat(legendY, ") rotate(").concat(legendRotation, ")"),
            textAnchor: textAnchor,
            style: $e2f0245f714c3922$var$_objectSpread2({
                dominantBaseline: "central"
            }, theme.axis.legend.text),
            children: legend
        });
    }
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var animatedProps = (0, $4ZiMn.useSpring)({
        transform: "translate(".concat(x, ",").concat(y, ")"),
        lineX2: axis === "x" ? length : 0,
        lineY2: axis === "x" ? 0 : length,
        config: springConfig,
        immediate: !animate
    });
    var transition = (0, $4ZiMn.useTransition)(ticks, {
        keys: function keys(tick) {
            return tick.key;
        },
        initial: function initial(tick) {
            return {
                opacity: 1,
                transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
                textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
            };
        },
        from: function from(tick) {
            return {
                opacity: 0,
                transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
                textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
            };
        },
        enter: function enter(tick) {
            return {
                opacity: 1,
                transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
                textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
            };
        },
        update: function update(tick) {
            return {
                opacity: 1,
                transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
                textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
            };
        },
        leave: {
            opacity: 0
        },
        config: springConfig,
        immediate: !animate
    });
    return (0, $4x3bm.jsxs)((0, $eYtn3.animated).g, {
        transform: animatedProps.transform,
        "aria-hidden": ariaHidden,
        children: [
            transition(function(transitionProps, tick, _state, tickIndex) {
                return (0, $70fFQ.createElement)(renderTick, $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({
                    tickIndex: tickIndex,
                    format: formatValue,
                    rotate: tickRotation,
                    textBaseline: textBaseline,
                    textAnchor: textAlign,
                    animatedProps: transitionProps
                }, tick), onClick ? {
                    onClick: onClick
                } : {}));
            }),
            (0, $4x3bm.jsx)((0, $eYtn3.animated).line, {
                style: theme.axis.domain.line,
                x1: 0,
                x2: animatedProps.lineX2,
                y1: 0,
                y2: animatedProps.lineY2
            }),
            legendNode
        ]
    });
};
var $e2f0245f714c3922$export$d06866a9fb0606da = (0, $70fFQ.memo)($e2f0245f714c3922$var$Axis);
var $e2f0245f714c3922$export$e5dd2f622170d212 = {
    ticksPosition: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        "before",
        "after"
    ]),
    tickValues: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).instanceOf(Date)
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    tickSize: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    tickPadding: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    tickRotation: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    format: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).string
    ]),
    renderTick: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).func,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).node,
    legendPosition: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    legendOffset: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).number,
    ariaHidden: (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).bool
};
var $e2f0245f714c3922$export$8502d8c4b99a277e = (0, (/*@__PURE__*/$parcel$interopDefault($cd0Jr))).shape($e2f0245f714c3922$export$e5dd2f622170d212);
var $e2f0245f714c3922$export$878041e1e4cd4218 = [
    "top",
    "right",
    "bottom",
    "left"
];
var $e2f0245f714c3922$export$387a78ab20784494 = (0, $70fFQ.memo)(function(_ref) {
    var xScale = _ref.xScale, yScale = _ref.yScale, width = _ref.width, height = _ref.height, top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var axes = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    return (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
        children: $e2f0245f714c3922$export$878041e1e4cd4218.map(function(position) {
            var axis = axes[position];
            if (!axis) return null;
            var isXAxis = position === "top" || position === "bottom";
            var ticksPosition = position === "top" || position === "left" ? "before" : "after";
            return (0, $4x3bm.jsx)($e2f0245f714c3922$export$d06866a9fb0606da, $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({}, axis), {}, {
                axis: isXAxis ? "x" : "y",
                x: position === "right" ? width : 0,
                y: position === "bottom" ? height : 0,
                scale: isXAxis ? xScale : yScale,
                length: isXAxis ? width : height,
                ticksPosition: ticksPosition
            }), position);
        })
    });
});
var $e2f0245f714c3922$export$cb089865d3c60926 = (0, $70fFQ.memo)(function(_ref) {
    var animatedProps = _ref.animatedProps;
    var theme = (0, $2qXGl.useTheme)();
    return (0, $4x3bm.jsx)((0, $eYtn3.animated).line, $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({}, animatedProps), theme.grid.line));
});
var $e2f0245f714c3922$export$36506d95c1656a54 = (0, $70fFQ.memo)(function(_ref) {
    var lines = _ref.lines;
    var _useMotionConfig = (0, $2qXGl.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.config;
    var transition = (0, $4ZiMn.useTransition)(lines, {
        keys: function keys(line) {
            return line.key;
        },
        initial: function initial(line) {
            return {
                opacity: 1,
                x1: line.x1,
                x2: line.x2,
                y1: line.y1,
                y2: line.y2
            };
        },
        from: function from(line) {
            return {
                opacity: 0,
                x1: line.x1,
                x2: line.x2,
                y1: line.y1,
                y2: line.y2
            };
        },
        enter: function enter(line) {
            return {
                opacity: 1,
                x1: line.x1,
                x2: line.x2,
                y1: line.y1,
                y2: line.y2
            };
        },
        update: function update(line) {
            return {
                opacity: 1,
                x1: line.x1,
                x2: line.x2,
                y1: line.y1,
                y2: line.y2
            };
        },
        leave: {
            opacity: 0
        },
        config: springConfig,
        immediate: !animate
    });
    return (0, $4x3bm.jsx)("g", {
        children: transition(function(animatedProps, line) {
            return (0, $70fFQ.createElement)($e2f0245f714c3922$export$cb089865d3c60926, $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({}, line), {}, {
                key: line.key,
                animatedProps: animatedProps
            }));
        })
    });
});
var $e2f0245f714c3922$export$ef2184bd89960b14 = (0, $70fFQ.memo)(function(_ref) {
    var width = _ref.width, height = _ref.height, xScale = _ref.xScale, yScale = _ref.yScale, xValues = _ref.xValues, yValues = _ref.yValues;
    var xLines = (0, $70fFQ.useMemo)(function() {
        if (!xScale) return false;
        return $e2f0245f714c3922$var$computeGridLines({
            width: width,
            height: height,
            scale: xScale,
            axis: "x",
            values: xValues
        });
    }, [
        xScale,
        xValues,
        width,
        height
    ]);
    var yLines = (0, $70fFQ.useMemo)(function() {
        if (!yScale) return false;
        return $e2f0245f714c3922$var$computeGridLines({
            width: width,
            height: height,
            scale: yScale,
            axis: "y",
            values: yValues
        });
    }, [
        height,
        width,
        yScale,
        yValues
    ]);
    return (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            xLines && (0, $4x3bm.jsx)($e2f0245f714c3922$export$36506d95c1656a54, {
                lines: xLines
            }),
            yLines && (0, $4x3bm.jsx)($e2f0245f714c3922$export$36506d95c1656a54, {
                lines: yLines
            })
        ]
    });
});
var $e2f0245f714c3922$export$b3252c0e7f5dbc3f = function renderAxisToCanvas(ctx, _ref) {
    var _theme$axis$domain$li;
    var axis = _ref.axis, scale = _ref.scale, _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, length = _ref.length, ticksPosition = _ref.ticksPosition, tickValues = _ref.tickValues, _ref$tickSize = _ref.tickSize, tickSize = _ref$tickSize === void 0 ? 5 : _ref$tickSize, _ref$tickPadding = _ref.tickPadding, tickPadding = _ref$tickPadding === void 0 ? 5 : _ref$tickPadding, _ref$tickRotation = _ref.tickRotation, tickRotation = _ref$tickRotation === void 0 ? 0 : _ref$tickRotation, _format = _ref.format, legend = _ref.legend, _ref$legendPosition = _ref.legendPosition, legendPosition = _ref$legendPosition === void 0 ? "end" : _ref$legendPosition, _ref$legendOffset = _ref.legendOffset, legendOffset = _ref$legendOffset === void 0 ? 0 : _ref$legendOffset, theme = _ref.theme;
    var _computeCartesianTick = $e2f0245f714c3922$var$computeCartesianTicks({
        axis: axis,
        scale: scale,
        ticksPosition: ticksPosition,
        tickValues: tickValues,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotation: tickRotation,
        engine: "canvas"
    }), ticks = _computeCartesianTick.ticks, textAlign = _computeCartesianTick.textAlign, textBaseline = _computeCartesianTick.textBaseline;
    ctx.save();
    ctx.translate(x, y);
    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.font = "".concat(theme.axis.ticks.text.fontWeight ? "".concat(theme.axis.ticks.text.fontWeight, " ") : "").concat(theme.axis.ticks.text.fontSize, "px ").concat(theme.axis.ticks.text.fontFamily);
    if (((_theme$axis$domain$li = theme.axis.domain.line.strokeWidth) !== null && _theme$axis$domain$li !== void 0 ? _theme$axis$domain$li : 0) > 0) {
        ctx.lineWidth = Number(theme.axis.domain.line.strokeWidth);
        ctx.lineCap = "square";
        if (theme.axis.domain.line.stroke) ctx.strokeStyle = theme.axis.domain.line.stroke;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(axis === "x" ? length : 0, axis === "x" ? 0 : length);
        ctx.stroke();
    }
    var format = typeof _format === "function" ? _format : function(value) {
        return "".concat(value);
    };
    ticks.forEach(function(tick) {
        var _theme$axis$ticks$lin;
        if (((_theme$axis$ticks$lin = theme.axis.ticks.line.strokeWidth) !== null && _theme$axis$ticks$lin !== void 0 ? _theme$axis$ticks$lin : 0) > 0) {
            ctx.lineWidth = Number(theme.axis.ticks.line.strokeWidth);
            ctx.lineCap = "square";
            if (theme.axis.ticks.line.stroke) ctx.strokeStyle = theme.axis.ticks.line.stroke;
            ctx.beginPath();
            ctx.moveTo(tick.x, tick.y);
            ctx.lineTo(tick.x + tick.lineX, tick.y + tick.lineY);
            ctx.stroke();
        }
        var value = format(tick.value);
        ctx.save();
        ctx.translate(tick.x + tick.textX, tick.y + tick.textY);
        ctx.rotate((0, $2qXGl.degreesToRadians)(tickRotation));
        if (theme.axis.ticks.text.fill) ctx.fillStyle = theme.axis.ticks.text.fill;
        ctx.fillText(String(value), 0, 0);
        ctx.restore();
    });
    if (legend !== undefined) {
        var legendX = 0;
        var legendY = 0;
        var legendRotation = 0;
        var _textAlign = "center";
        if (axis === "y") {
            legendRotation = -90;
            legendX = legendOffset;
            if (legendPosition === "start") {
                _textAlign = "start";
                legendY = length;
            } else if (legendPosition === "middle") {
                _textAlign = "center";
                legendY = length / 2;
            } else if (legendPosition === "end") _textAlign = "end";
        } else {
            legendY = legendOffset;
            if (legendPosition === "start") _textAlign = "start";
            else if (legendPosition === "middle") {
                _textAlign = "center";
                legendX = length / 2;
            } else if (legendPosition === "end") {
                _textAlign = "end";
                legendX = length;
            }
        }
        ctx.translate(legendX, legendY);
        ctx.rotate((0, $2qXGl.degreesToRadians)(legendRotation));
        ctx.font = "".concat(theme.axis.legend.text.fontWeight ? "".concat(theme.axis.legend.text.fontWeight, " ") : "").concat(theme.axis.legend.text.fontSize, "px ").concat(theme.axis.legend.text.fontFamily);
        if (theme.axis.legend.text.fill) ctx.fillStyle = theme.axis.legend.text.fill;
        ctx.textAlign = _textAlign;
        ctx.textBaseline = "middle";
        ctx.fillText(legend, 0, 0);
    }
    ctx.restore();
};
var $e2f0245f714c3922$export$6f12c0e853c1bfff = function renderAxesToCanvas(ctx, _ref2) {
    var xScale = _ref2.xScale, yScale = _ref2.yScale, width = _ref2.width, height = _ref2.height, top = _ref2.top, right = _ref2.right, bottom = _ref2.bottom, left = _ref2.left, theme = _ref2.theme;
    var axes = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    $e2f0245f714c3922$export$878041e1e4cd4218.forEach(function(position) {
        var axis = axes[position];
        if (!axis) return null;
        var isXAxis = position === "top" || position === "bottom";
        var ticksPosition = position === "top" || position === "left" ? "before" : "after";
        var scale = isXAxis ? xScale : yScale;
        var format = $e2f0245f714c3922$var$getFormatter(axis.format, scale);
        $e2f0245f714c3922$export$b3252c0e7f5dbc3f(ctx, $e2f0245f714c3922$var$_objectSpread2($e2f0245f714c3922$var$_objectSpread2({}, axis), {}, {
            axis: isXAxis ? "x" : "y",
            x: position === "right" ? width : 0,
            y: position === "bottom" ? height : 0,
            scale: scale,
            format: format,
            length: isXAxis ? width : height,
            ticksPosition: ticksPosition,
            theme: theme
        }));
    });
};
var $e2f0245f714c3922$export$5eea7e798580e5d1 = function renderGridLinesToCanvas(ctx, _ref3) {
    var width = _ref3.width, height = _ref3.height, scale = _ref3.scale, axis = _ref3.axis, values = _ref3.values;
    var lines = $e2f0245f714c3922$var$computeGridLines({
        width: width,
        height: height,
        scale: scale,
        axis: axis,
        values: values
    });
    lines.forEach(function(line) {
        ctx.beginPath();
        ctx.moveTo(line.x1, line.y1);
        ctx.lineTo(line.x2, line.y2);
        ctx.stroke();
    });
};

});
parcelRegister("go5S7", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $bee37144f604f299$export$d9468344d3651243; });

var $48US5 = parcelRequire("48US5");
var $bee37144f604f299$var$locale;
var $bee37144f604f299$export$d9468344d3651243;
var $bee37144f604f299$export$8d85692a469dde6f;
$bee37144f604f299$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $bee37144f604f299$export$2e2bcd8739ae039(definition) {
    $bee37144f604f299$var$locale = (0, $48US5.default)(definition);
    $bee37144f604f299$export$d9468344d3651243 = $bee37144f604f299$var$locale.format;
    $bee37144f604f299$export$8d85692a469dde6f = $bee37144f604f299$var$locale.formatPrefix;
    return $bee37144f604f299$var$locale;
}

});
parcelRegister("48US5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30440639128fd21e$export$2e2bcd8739ae039; });

var $blHDz = parcelRequire("blHDz");

var $6fliW = parcelRequire("6fliW");

var $g7JKL = parcelRequire("g7JKL");

var $fQToc = parcelRequire("fQToc");

var $8DHXn = parcelRequire("8DHXn");

var $Ld5Zm = parcelRequire("Ld5Zm");

var $gtqss = parcelRequire("gtqss");

var $01ipG = parcelRequire("01ipG");
var $30440639128fd21e$var$map = Array.prototype.map, $30440639128fd21e$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $30440639128fd21e$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $01ipG.default) : (0, $6fliW.default)($30440639128fd21e$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $01ipG.default) : (0, $g7JKL.default)($30440639128fd21e$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $fQToc.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $Ld5Zm.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $Ld5Zm.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $8DHXn.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $30440639128fd21e$var$prefixes[8 + (0, $gtqss.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $fQToc.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $blHDz.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $30440639128fd21e$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("blHDz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8433815108959446$export$2e2bcd8739ae039; });

var $aRcPx = parcelRequire("aRcPx");
function $8433815108959446$export$2e2bcd8739ae039(x) {
    return x = (0, $aRcPx.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("aRcPx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e78ce7682f77be9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "formatDecimalParts", function () { return $7e78ce7682f77be9$export$8f8e23dd27dc19f5; });
function $7e78ce7682f77be9$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $7e78ce7682f77be9$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("6fliW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48c4ab6d3436aa72$export$2e2bcd8739ae039; });
function $48c4ab6d3436aa72$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("g7JKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbd0ca74a0588188$export$2e2bcd8739ae039; });
function $bbd0ca74a0588188$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("fQToc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8a6ad8311188579$export$2e2bcd8739ae039; });
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $b8a6ad8311188579$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $b8a6ad8311188579$export$2e2bcd8739ae039(specifier) {
    if (!(match = $b8a6ad8311188579$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $b8a6ad8311188579$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$b8a6ad8311188579$export$2e2bcd8739ae039.prototype = $b8a6ad8311188579$export$963aac351db36ed4.prototype; // instanceof
function $b8a6ad8311188579$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$b8a6ad8311188579$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("8DHXn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a41026c4f7067c$export$2e2bcd8739ae039; });
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $64a41026c4f7067c$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("Ld5Zm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08de8c699f22bc4b$export$2e2bcd8739ae039; });

var $aRcPx = parcelRequire("aRcPx");

var $gtqss = parcelRequire("gtqss");

var $1r5Wi = parcelRequire("1r5Wi");
var $08de8c699f22bc4b$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $aRcPx.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $1r5Wi.default)(x * 100, p);
    },
    "r": (0, $1r5Wi.default),
    "s": (0, $gtqss.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

});
parcelRegister("gtqss", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", function () { return $bfe3e0c4ea11472d$export$6863724d9a42263; });
$parcel$export(module.exports, "default", function () { return $bfe3e0c4ea11472d$export$2e2bcd8739ae039; });

var $aRcPx = parcelRequire("aRcPx");
var $bfe3e0c4ea11472d$export$6863724d9a42263;
function $bfe3e0c4ea11472d$export$2e2bcd8739ae039(x, p) {
    var d = (0, $aRcPx.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($bfe3e0c4ea11472d$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $aRcPx.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("1r5Wi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10bceb7984ce204c$export$2e2bcd8739ae039; });

var $aRcPx = parcelRequire("aRcPx");
function $10bceb7984ce204c$export$2e2bcd8739ae039(x, p) {
    var d = (0, $aRcPx.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("01ipG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $003e6098c02798c5$export$2e2bcd8739ae039; });
function $003e6098c02798c5$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("lT7k3", function(module, exports) {

$parcel$export(module.exports, "computeXYScalesForSeries", function () { return $fef46a17913c173a$export$4d0b292d246e5304; });
$parcel$export(module.exports, "centerScale", function () { return $fef46a17913c173a$export$6eebe39d34e5b9b7; });
$parcel$export(module.exports, "getScaleTicks", function () { return $fef46a17913c173a$export$6524ae923f6f50f3; });

var $9y8hW = parcelRequire("9y8hW");

var $2SWin = parcelRequire("2SWin");

var $1Bt2m = parcelRequire("1Bt2m");

var $e5pHQ = parcelRequire("e5pHQ");

var $kHQkn = parcelRequire("kHQkn");

var $7pj3L = parcelRequire("7pj3L");

var $aZXhI = parcelRequire("aZXhI");
var $a8yvN = parcelRequire("a8yvN");
var $i4W4N = parcelRequire("i4W4N");
var $g5Evh = parcelRequire("g5Evh");
var $jPEDU = parcelRequire("jPEDU");
var $8dUNx = parcelRequire("8dUNx");

var $5qhcs = parcelRequire("5qhcs");
var $80dMk = parcelRequire("80dMk");
var $ibzeX = parcelRequire("ibzeX");
var $2hFmH = parcelRequire("2hFmH");
var $aehqB = parcelRequire("aehqB");
var $4iSPB = parcelRequire("4iSPB");
var $ccJuc = parcelRequire("ccJuc");
var $d7Oww = parcelRequire("d7Oww");
var $3SrNU = parcelRequire("3SrNU");
var $l26u6 = parcelRequire("l26u6");
var $b7ApD = parcelRequire("b7ApD");
var $ftYuF = parcelRequire("ftYuF");
var $ggOD1 = parcelRequire("ggOD1");
function $fef46a17913c173a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fef46a17913c173a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $fef46a17913c173a$var$_arrayLikeToArray(arr);
}
function $fef46a17913c173a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $fef46a17913c173a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fef46a17913c173a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fef46a17913c173a$var$_arrayLikeToArray(o, minLen);
}
function $fef46a17913c173a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fef46a17913c173a$var$_toConsumableArray(arr) {
    return $fef46a17913c173a$var$_arrayWithoutHoles(arr) || $fef46a17913c173a$var$_iterableToArray(arr) || $fef46a17913c173a$var$_unsupportedIterableToArray(arr) || $fef46a17913c173a$var$_nonIterableSpread();
}
function $fef46a17913c173a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fef46a17913c173a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fef46a17913c173a$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fef46a17913c173a$var$ownKeys(Object(source), true).forEach(function(key) {
            $fef46a17913c173a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fef46a17913c173a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $fef46a17913c173a$export$6dcdc1137d8ab211 = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year"
];
var $fef46a17913c173a$export$1dc82d6660f2ea1c = [
    function(date) {
        return date.setMilliseconds(0);
    },
    function(date) {
        return date.setSeconds(0);
    },
    function(date) {
        return date.setMinutes(0);
    },
    function(date) {
        return date.setHours(0);
    },
    function(date) {
        return date.setDate(1);
    },
    function(date) {
        return date.setMonth(0);
    }
];
var $fef46a17913c173a$export$43fb64d4d70cf1d2 = {
    millisecond: [],
    second: $fef46a17913c173a$export$1dc82d6660f2ea1c.slice(0, 1),
    minute: $fef46a17913c173a$export$1dc82d6660f2ea1c.slice(0, 2),
    hour: $fef46a17913c173a$export$1dc82d6660f2ea1c.slice(0, 3),
    day: $fef46a17913c173a$export$1dc82d6660f2ea1c.slice(0, 4),
    month: $fef46a17913c173a$export$1dc82d6660f2ea1c.slice(0, 5),
    year: $fef46a17913c173a$export$1dc82d6660f2ea1c.slice(0, 6)
};
var $fef46a17913c173a$export$317f4d4c07f3c42a = function createPrecisionMethod(precision) {
    return function(date) {
        $fef46a17913c173a$export$43fb64d4d70cf1d2[precision].forEach(function(cutOff) {
            cutOff(date);
        });
        return date;
    };
};
var $fef46a17913c173a$export$daf307d3fe6dfa68 = function createDateNormalizer(_ref) {
    var _ref$format = _ref.format, format = _ref$format === void 0 ? "native" : _ref$format, _ref$precision = _ref.precision, precision = _ref$precision === void 0 ? "millisecond" : _ref$precision, _ref$useUTC = _ref.useUTC, useUTC = _ref$useUTC === void 0 ? true : _ref$useUTC;
    var precisionFn = $fef46a17913c173a$export$317f4d4c07f3c42a(precision);
    return function(value) {
        if (value === undefined) return value;
        if (format === "native" || value instanceof Date) return precisionFn(value);
        var parseTime = useUTC ? (0, $7pj3L.utcParse)(format) : (0, $7pj3L.timeParse)(format);
        return precisionFn(parseTime(value));
    };
};
var $fef46a17913c173a$export$4e095c21b86a0457 = function createLinearScale(_ref, data, size, axis) {
    var _ref$min = _ref.min, min = _ref$min === void 0 ? 0 : _ref$min, _ref$max = _ref.max, max = _ref$max === void 0 ? "auto" : _ref$max, _ref$stacked = _ref.stacked, stacked = _ref$stacked === void 0 ? false : _ref$stacked, _ref$reverse = _ref.reverse, reverse = _ref$reverse === void 0 ? false : _ref$reverse, _ref$clamp = _ref.clamp, clamp = _ref$clamp === void 0 ? false : _ref$clamp, _ref$nice = _ref.nice, nice = _ref$nice === void 0 ? false : _ref$nice;
    var minValue;
    if (min === "auto") {
        var _data$minStacked;
        minValue = stacked === true ? (_data$minStacked = data.minStacked) !== null && _data$minStacked !== void 0 ? _data$minStacked : 0 : data.min;
    } else minValue = min;
    var maxValue;
    if (max === "auto") {
        var _data$maxStacked;
        maxValue = stacked === true ? (_data$maxStacked = data.maxStacked) !== null && _data$maxStacked !== void 0 ? _data$maxStacked : 0 : data.max;
    } else maxValue = max;
    var scale = (0, $a8yvN.default)().rangeRound(axis === "x" ? [
        0,
        size
    ] : [
        size,
        0
    ]).domain(reverse ? [
        maxValue,
        minValue
    ] : [
        minValue,
        maxValue
    ]).clamp(clamp);
    if (nice === true) scale.nice();
    else if (typeof nice === "number") scale.nice(nice);
    return $fef46a17913c173a$export$4fd02d345bf145e3(scale, stacked);
};
var $fef46a17913c173a$export$4fd02d345bf145e3 = function castLinearScale(scale) {
    var stacked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var typedScale = scale;
    typedScale.type = "linear";
    typedScale.stacked = stacked;
    return typedScale;
};
var $fef46a17913c173a$export$9abcadf788874abe = function createPointScale(_spec, data, size) {
    var scale = (0, $aZXhI.point)().range([
        0,
        size
    ]).domain(data.all);
    var typedScale = scale;
    typedScale.type = "point";
    return typedScale;
};
var $fef46a17913c173a$export$e9706c87cd649069 = function createBandScale(_ref, data, size, axis) {
    var _ref$round = _ref.round, round = _ref$round === void 0 ? true : _ref$round;
    var scale = (0, $aZXhI.default)().range(axis === "x" ? [
        0,
        size
    ] : [
        size,
        0
    ]).domain(data.all).round(round);
    return $fef46a17913c173a$export$c88e9eb2fbaf2089(scale);
};
var $fef46a17913c173a$export$c88e9eb2fbaf2089 = function castBandScale(scale) {
    var typedScale = scale;
    typedScale.type = "band";
    return typedScale;
};
var $fef46a17913c173a$export$27d74465d4d4bf01 = function createTimeScale(_ref, data, size) {
    var _ref$format = _ref.format, format = _ref$format === void 0 ? "native" : _ref$format, _ref$precision = _ref.precision, precision = _ref$precision === void 0 ? "millisecond" : _ref$precision, _ref$min = _ref.min, min = _ref$min === void 0 ? "auto" : _ref$min, _ref$max = _ref.max, max = _ref$max === void 0 ? "auto" : _ref$max, _ref$useUTC = _ref.useUTC, useUTC = _ref$useUTC === void 0 ? true : _ref$useUTC, _ref$nice = _ref.nice, nice = _ref$nice === void 0 ? false : _ref$nice;
    var normalize = $fef46a17913c173a$export$daf307d3fe6dfa68({
        format: format,
        precision: precision,
        useUTC: useUTC
    });
    var minValue;
    if (min === "auto") minValue = normalize(data.min);
    else if (format !== "native") minValue = normalize(min);
    else minValue = min;
    var maxValue;
    if (max === "auto") maxValue = normalize(data.max);
    else if (format !== "native") maxValue = normalize(max);
    else maxValue = max;
    var scale = useUTC ? (0, $8dUNx.default)() : (0, $jPEDU.default)();
    scale.range([
        0,
        size
    ]);
    if (minValue && maxValue) scale.domain([
        minValue,
        maxValue
    ]);
    if (nice === true) scale.nice();
    else if (typeof nice === "object" || typeof nice === "number") scale.nice(nice);
    var typedScale = scale;
    typedScale.type = "time";
    typedScale.useUTC = useUTC;
    return typedScale;
};
var $fef46a17913c173a$export$554cc426a2d37672 = function createLogScale(_ref, data, size, axis) {
    var _ref$base = _ref.base, base = _ref$base === void 0 ? 10 : _ref$base, _ref$min = _ref.min, min = _ref$min === void 0 ? "auto" : _ref$min, _ref$max = _ref.max, max = _ref$max === void 0 ? "auto" : _ref$max;
    var hasZero = data.all.some(function(v) {
        return v === 0;
    });
    if (hasZero) throw new Error("a log scale domain must not include or cross zero");
    var sign;
    var hasMixedSign = false;
    data.all.filter(function(v) {
        return v != null;
    }).forEach(function(v) {
        if (hasMixedSign) return;
        if (sign === undefined) sign = Math.sign(v);
        else if (Math.sign(v) !== sign) hasMixedSign = true;
    });
    if (hasMixedSign) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
    var minValue;
    if (min === "auto") minValue = data.min;
    else minValue = min;
    var maxValue;
    if (max === "auto") maxValue = data.max;
    else maxValue = max;
    var scale = (0, $i4W4N.default)().domain([
        minValue,
        maxValue
    ]).rangeRound(axis === "x" ? [
        0,
        size
    ] : [
        size,
        0
    ]).base(base).nice();
    var typedScale = scale;
    typedScale.type = "log";
    return scale;
};
var $fef46a17913c173a$export$8e14d6e8a8fc902c = function createSymlogScale(_ref, data, size, axis) {
    var _ref$constant = _ref.constant, constant = _ref$constant === void 0 ? 1 : _ref$constant, _ref$min = _ref.min, min = _ref$min === void 0 ? "auto" : _ref$min, _ref$max = _ref.max, max = _ref$max === void 0 ? "auto" : _ref$max, _ref$reverse = _ref.reverse, reverse = _ref$reverse === void 0 ? false : _ref$reverse;
    var minValue;
    if (min === "auto") minValue = data.min;
    else minValue = min;
    var maxValue;
    if (max === "auto") maxValue = data.max;
    else maxValue = max;
    var scale = (0, $g5Evh.default)().constant(constant).rangeRound(axis === "x" ? [
        0,
        size
    ] : [
        size,
        0
    ]).nice();
    if (reverse === true) scale.domain([
        maxValue,
        minValue
    ]);
    else scale.domain([
        minValue,
        maxValue
    ]);
    var typedScale = scale;
    typedScale.type = "symlog";
    return typedScale;
};
var $fef46a17913c173a$export$9aa6d07acb85188c = function getOtherAxis(axis) {
    return axis === "x" ? "y" : "x";
};
var $fef46a17913c173a$export$6ab1df3197f7c641 = function compareValues(a, b) {
    return a === b;
};
var $fef46a17913c173a$export$562cdc7d09e1fa5a = function compareDateValues(a, b) {
    return a.getTime() === b.getTime();
};
function $fef46a17913c173a$export$5268a4c29077d335(spec, data, size, axis) {
    switch(spec.type){
        case "linear":
            return $fef46a17913c173a$export$4e095c21b86a0457(spec, data, size, axis);
        case "point":
            return $fef46a17913c173a$export$9abcadf788874abe(spec, data, size);
        case "band":
            return $fef46a17913c173a$export$e9706c87cd649069(spec, data, size, axis);
        case "time":
            return $fef46a17913c173a$export$27d74465d4d4bf01(spec, data, size);
        case "log":
            return $fef46a17913c173a$export$554cc426a2d37672(spec, data, size, axis);
        case "symlog":
            return $fef46a17913c173a$export$8e14d6e8a8fc902c(spec, data, size, axis);
        default:
            throw new Error("invalid scale spec");
    }
}
var $fef46a17913c173a$var$nestSerieData = function nestSerieData(serie) {
    return $fef46a17913c173a$var$_objectSpread2($fef46a17913c173a$var$_objectSpread2({}, serie), {}, {
        data: serie.data.map(function(d) {
            return {
                data: $fef46a17913c173a$var$_objectSpread2({}, d)
            };
        })
    });
};
var $fef46a17913c173a$var$getDatumAxisPosition = function getDatumAxisPosition(datum, axis, scale) {
    var _scale;
    if ("stacked" in scale && scale.stacked) {
        var stackedValue = datum.data[axis === "x" ? "xStacked" : "yStacked"];
        if (stackedValue === null || stackedValue === undefined) return null;
        return scale(stackedValue);
    }
    return (_scale = scale(datum.data[axis])) !== null && _scale !== void 0 ? _scale : null;
};
var $fef46a17913c173a$export$4d0b292d246e5304 = function computeXYScalesForSeries(series, xScaleSpec, yScaleSpec, width, height) {
    var nestedSeries = series.map(function(serie) {
        return $fef46a17913c173a$var$nestSerieData(serie);
    });
    var xy = $fef46a17913c173a$export$ebc19db715008482(nestedSeries, xScaleSpec, yScaleSpec);
    if ("stacked" in xScaleSpec && xScaleSpec.stacked === true) $fef46a17913c173a$var$stackX(xy, nestedSeries);
    if ("stacked" in yScaleSpec && yScaleSpec.stacked === true) $fef46a17913c173a$var$stackY(xy, nestedSeries);
    var xScale = $fef46a17913c173a$export$5268a4c29077d335(xScaleSpec, xy.x, width, "x");
    var yScale = $fef46a17913c173a$export$5268a4c29077d335(yScaleSpec, xy.y, height, "y");
    var computedSeries = nestedSeries.map(function(serie) {
        return $fef46a17913c173a$var$_objectSpread2($fef46a17913c173a$var$_objectSpread2({}, serie), {}, {
            data: serie.data.map(function(datum) {
                return $fef46a17913c173a$var$_objectSpread2($fef46a17913c173a$var$_objectSpread2({}, datum), {}, {
                    position: {
                        x: $fef46a17913c173a$var$getDatumAxisPosition(datum, "x", xScale),
                        y: $fef46a17913c173a$var$getDatumAxisPosition(datum, "y", yScale)
                    }
                });
            })
        });
    });
    return $fef46a17913c173a$var$_objectSpread2($fef46a17913c173a$var$_objectSpread2({}, xy), {}, {
        series: computedSeries,
        xScale: xScale,
        yScale: yScale
    });
};
var $fef46a17913c173a$export$ebc19db715008482 = function generateSeriesXY(series, xScaleSpec, yScaleSpec) {
    return {
        x: $fef46a17913c173a$export$b510e85f598a24fb(series, "x", xScaleSpec),
        y: $fef46a17913c173a$export$b510e85f598a24fb(series, "y", yScaleSpec)
    };
};
var $fef46a17913c173a$export$b510e85f598a24fb = function generateSeriesAxis(series, axis, scaleSpec) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {}, _ref$getValue = _ref.getValue, getValue = _ref$getValue === void 0 ? function(d) {
        return d.data[axis];
    } : _ref$getValue, _ref$setValue = _ref.setValue, setValue = _ref$setValue === void 0 ? function(d, v) {
        d.data[axis] = v;
    } : _ref$setValue;
    if (scaleSpec.type === "linear") series.forEach(function(serie) {
        serie.data.forEach(function(d) {
            var value = getValue(d);
            if (value) setValue(d, parseFloat(String(value)));
        });
    });
    else if (scaleSpec.type === "time" && scaleSpec.format !== "native") {
        var parseTime = $fef46a17913c173a$export$daf307d3fe6dfa68(scaleSpec);
        series.forEach(function(serie) {
            serie.data.forEach(function(d) {
                var value = getValue(d);
                if (value) setValue(d, parseTime(value));
            });
        });
    }
    var values = [];
    series.forEach(function(serie) {
        serie.data.forEach(function(d) {
            values.push(getValue(d));
        });
    });
    switch(scaleSpec.type){
        case "linear":
            var all = (0, (/*@__PURE__*/$parcel$interopDefault($1Bt2m)))((0, (/*@__PURE__*/$parcel$interopDefault($9y8hW)))(values).filter(function(v) {
                return v !== null;
            }), function(v) {
                return v;
            });
            return {
                all: all,
                min: Math.min.apply(Math, $fef46a17913c173a$var$_toConsumableArray(all)),
                max: Math.max.apply(Math, $fef46a17913c173a$var$_toConsumableArray(all))
            };
        case "time":
            var _all = (0, (/*@__PURE__*/$parcel$interopDefault($2SWin)))(values, function(v) {
                return v.getTime();
            }).slice(0).sort(function(a, b) {
                return b.getTime() - a.getTime();
            }).reverse();
            return {
                all: _all,
                min: _all[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($e5pHQ)))(_all)
            };
        default:
            var _all2 = (0, (/*@__PURE__*/$parcel$interopDefault($9y8hW)))(values);
            return {
                all: _all2,
                min: _all2[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($e5pHQ)))(_all2)
            };
    }
};
var $fef46a17913c173a$export$c6f16b50cdeeb77c = function stackAxis(axis, xy, series) {
    var otherAxis = $fef46a17913c173a$export$9aa6d07acb85188c(axis);
    var all = [];
    xy[otherAxis].all.forEach(function(v) {
        var compare = (0, (/*@__PURE__*/$parcel$interopDefault($kHQkn)))(v) ? $fef46a17913c173a$export$562cdc7d09e1fa5a : $fef46a17913c173a$export$6ab1df3197f7c641;
        var stack = [];
        series.forEach(function(serie) {
            var datum = serie.data.find(function(d) {
                return compare(d.data[otherAxis], v);
            });
            var value = null;
            var stackValue = null;
            if (datum !== undefined) {
                value = datum.data[axis];
                if (value !== null) {
                    var head = (0, (/*@__PURE__*/$parcel$interopDefault($e5pHQ)))(stack);
                    if (head === undefined) stackValue = value;
                    else if (head !== null) stackValue = head + value;
                }
                datum.data[axis === "x" ? "xStacked" : "yStacked"] = stackValue;
            }
            stack.push(stackValue);
            if (stackValue !== null) all.push(stackValue);
        });
    });
    xy[axis].minStacked = Math.min.apply(Math, all);
    xy[axis].maxStacked = Math.max.apply(Math, all);
};
var $fef46a17913c173a$var$stackX = function stackX(xy, series) {
    return $fef46a17913c173a$export$c6f16b50cdeeb77c("x", xy, series);
};
var $fef46a17913c173a$var$stackY = function stackY(xy, series) {
    return $fef46a17913c173a$export$c6f16b50cdeeb77c("y", xy, series);
};
function $fef46a17913c173a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fef46a17913c173a$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fef46a17913c173a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fef46a17913c173a$var$_slicedToArray(arr, i) {
    return $fef46a17913c173a$var$_arrayWithHoles(arr) || $fef46a17913c173a$var$_iterableToArrayLimit(arr, i) || $fef46a17913c173a$var$_unsupportedIterableToArray(arr, i) || $fef46a17913c173a$var$_nonIterableRest();
}
var $fef46a17913c173a$export$6eebe39d34e5b9b7 = function centerScale(scale) {
    var bandwidth = scale.bandwidth();
    if (bandwidth === 0) return scale;
    var offset = bandwidth / 2;
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        var _scale;
        return ((_scale = scale(d)) !== null && _scale !== void 0 ? _scale : 0) + offset;
    };
};
var $fef46a17913c173a$var$timeDay = (0, $5qhcs.default)(function(date) {
    return date.setHours(0, 0, 0, 0);
}, function(date, step) {
    return date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end.getTime() - start.getTime()) / 864e5;
}, function(date) {
    return Math.floor(date.getTime() / 864e5);
});
var $fef46a17913c173a$var$utcDay = (0, $5qhcs.default)(function(date) {
    return date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    return date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end.getTime() - start.getTime()) / 864e5;
}, function(date) {
    return Math.floor(date.getTime() / 864e5);
});
var $fef46a17913c173a$var$timeByType = {
    millisecond: [
        (0, $80dMk.default),
        (0, $80dMk.default)
    ],
    second: [
        (0, $ibzeX.default),
        (0, $ibzeX.default)
    ],
    minute: [
        (0, $2hFmH.default),
        (0, $aehqB.default)
    ],
    hour: [
        (0, $4iSPB.default),
        (0, $ccJuc.default)
    ],
    day: [
        $fef46a17913c173a$var$timeDay,
        $fef46a17913c173a$var$utcDay
    ],
    week: [
        (0, $d7Oww.sunday),
        (0, $3SrNU.utcSunday)
    ],
    sunday: [
        (0, $d7Oww.sunday),
        (0, $3SrNU.utcSunday)
    ],
    monday: [
        (0, $d7Oww.monday),
        (0, $3SrNU.utcMonday)
    ],
    tuesday: [
        (0, $d7Oww.tuesday),
        (0, $3SrNU.utcTuesday)
    ],
    wednesday: [
        (0, $d7Oww.wednesday),
        (0, $3SrNU.utcWednesday)
    ],
    thursday: [
        (0, $d7Oww.thursday),
        (0, $3SrNU.utcThursday)
    ],
    friday: [
        (0, $d7Oww.friday),
        (0, $3SrNU.utcFriday)
    ],
    saturday: [
        (0, $d7Oww.saturday),
        (0, $3SrNU.utcSaturday)
    ],
    month: [
        (0, $l26u6.default),
        (0, $b7ApD.default)
    ],
    year: [
        (0, $ftYuF.default),
        (0, $ggOD1.default)
    ]
};
var $fef46a17913c173a$var$timeTypes = Object.keys($fef46a17913c173a$var$timeByType);
var $fef46a17913c173a$var$timeIntervalRegexp = new RegExp("^every\\s*(\\d+)?\\s*(".concat($fef46a17913c173a$var$timeTypes.join("|"), ")s?$"), "i");
var $fef46a17913c173a$var$isInteger = function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
var $fef46a17913c173a$export$6524ae923f6f50f3 = function getScaleTicks(scale, spec) {
    if (Array.isArray(spec)) return spec;
    if (typeof spec === "string" && "useUTC" in scale) {
        var matches = spec.match($fef46a17913c173a$var$timeIntervalRegexp);
        if (matches) {
            var _matches = $fef46a17913c173a$var$_slicedToArray(matches, 3), amount = _matches[1], type = _matches[2];
            var timeType = $fef46a17913c173a$var$timeByType[type][scale.useUTC ? 1 : 0];
            if (type === "day") {
                var _timeType$every$range, _timeType$every;
                var _scale$domain = scale.domain(), _scale$domain2 = $fef46a17913c173a$var$_slicedToArray(_scale$domain, 2), start = _scale$domain2[0], originalStop = _scale$domain2[1];
                var stop = new Date(originalStop);
                stop.setDate(stop.getDate() + 1);
                return (_timeType$every$range = (_timeType$every = timeType.every(Number(amount !== null && amount !== void 0 ? amount : 1))) === null || _timeType$every === void 0 ? void 0 : _timeType$every.range(start, stop)) !== null && _timeType$every$range !== void 0 ? _timeType$every$range : [];
            }
            if (amount === undefined) return scale.ticks(timeType);
            var interval = timeType.every(Number(amount));
            if (interval) return scale.ticks(interval);
        }
        throw new Error("Invalid tickValues: ".concat(spec));
    }
    if ("ticks" in scale) {
        if (spec === undefined) return scale.ticks();
        if ($fef46a17913c173a$var$isInteger(spec)) return scale.ticks(spec);
    }
    return scale.domain();
};

});
parcelRegister("9y8hW", function(module, exports) {

var $kZqru = parcelRequire("kZqru");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $6f3db7efafd4ca48$var$uniq(array) {
    return array && array.length ? $kZqru(array) : [];
}
module.exports = $6f3db7efafd4ca48$var$uniq;

});
parcelRegister("kZqru", function(module, exports) {

var $4T70o = parcelRequire("4T70o");

var $5ANxz = parcelRequire("5ANxz");

var $h5Byl = parcelRequire("h5Byl");

var $divFr = parcelRequire("divFr");

var $3TE2F = parcelRequire("3TE2F");

var $efQTl = parcelRequire("efQTl");
/** Used as the size to enable large array optimizations. */ var $f47e0408ce4cc42c$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $f47e0408ce4cc42c$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $5ANxz, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $h5Byl;
    } else if (length >= $f47e0408ce4cc42c$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $3TE2F(array);
        if (set) return $efQTl(set);
        isCommon = false;
        includes = $divFr;
        seen = new $4T70o;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f47e0408ce4cc42c$var$baseUniq;

});
parcelRegister("4T70o", function(module, exports) {

var $fs2Xm = parcelRequire("fs2Xm");

var $6Y8AX = parcelRequire("6Y8AX");

var $b5rUI = parcelRequire("b5rUI");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $38f1bb9a81616fa8$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $fs2Xm;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$38f1bb9a81616fa8$var$SetCache.prototype.add = $38f1bb9a81616fa8$var$SetCache.prototype.push = $6Y8AX;
$38f1bb9a81616fa8$var$SetCache.prototype.has = $b5rUI;
module.exports = $38f1bb9a81616fa8$var$SetCache;

});
parcelRegister("fs2Xm", function(module, exports) {

var $9mqts = parcelRequire("9mqts");

var $fuc4N = parcelRequire("fuc4N");

var $1Ooxm = parcelRequire("1Ooxm");

var $1TzHN = parcelRequire("1TzHN");

var $5gYdy = parcelRequire("5gYdy");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b3fbc3a4dbc44a55$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$b3fbc3a4dbc44a55$var$MapCache.prototype.clear = $9mqts;
$b3fbc3a4dbc44a55$var$MapCache.prototype["delete"] = $fuc4N;
$b3fbc3a4dbc44a55$var$MapCache.prototype.get = $1Ooxm;
$b3fbc3a4dbc44a55$var$MapCache.prototype.has = $1TzHN;
$b3fbc3a4dbc44a55$var$MapCache.prototype.set = $5gYdy;
module.exports = $b3fbc3a4dbc44a55$var$MapCache;

});
parcelRegister("9mqts", function(module, exports) {

var $gS8Kw = parcelRequire("gS8Kw");

var $ci9tK = parcelRequire("ci9tK");

var $3DAeb = parcelRequire("3DAeb");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $6d0ab45be53870e1$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $gS8Kw,
        "map": new ($3DAeb || $ci9tK),
        "string": new $gS8Kw
    };
}
module.exports = $6d0ab45be53870e1$var$mapCacheClear;

});
parcelRegister("gS8Kw", function(module, exports) {

var $3YPtV = parcelRequire("3YPtV");

var $g1Dt3 = parcelRequire("g1Dt3");

var $4nrYP = parcelRequire("4nrYP");

var $lHaSp = parcelRequire("lHaSp");

var $bwPKm = parcelRequire("bwPKm");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c48879ed7043943e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$c48879ed7043943e$var$Hash.prototype.clear = $3YPtV;
$c48879ed7043943e$var$Hash.prototype["delete"] = $g1Dt3;
$c48879ed7043943e$var$Hash.prototype.get = $4nrYP;
$c48879ed7043943e$var$Hash.prototype.has = $lHaSp;
$c48879ed7043943e$var$Hash.prototype.set = $bwPKm;
module.exports = $c48879ed7043943e$var$Hash;

});
parcelRegister("3YPtV", function(module, exports) {

var $dLHDi = parcelRequire("dLHDi");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $2e5ee8e4526eaf96$var$hashClear() {
    this.__data__ = $dLHDi ? $dLHDi(null) : {};
    this.size = 0;
}
module.exports = $2e5ee8e4526eaf96$var$hashClear;

});
parcelRegister("dLHDi", function(module, exports) {

var $21Jw3 = parcelRequire("21Jw3");
/* Built-in method references that are verified to be native. */ var $a06182bbbfb16dae$var$nativeCreate = $21Jw3(Object, "create");
module.exports = $a06182bbbfb16dae$var$nativeCreate;

});
parcelRegister("21Jw3", function(module, exports) {

var $ikawB = parcelRequire("ikawB");

var $aeCRo = parcelRequire("aeCRo");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $179efb461975f816$var$getNative(object, key) {
    var value = $aeCRo(object, key);
    return $ikawB(value) ? value : undefined;
}
module.exports = $179efb461975f816$var$getNative;

});
parcelRegister("ikawB", function(module, exports) {

var $lNtat = parcelRequire("lNtat");

var $kWjpx = parcelRequire("kWjpx");

var $7LfXT = parcelRequire("7LfXT");

var $htk17 = parcelRequire("htk17");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d5724246534f1cae$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $d5724246534f1cae$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $d5724246534f1cae$var$funcProto = Function.prototype, $d5724246534f1cae$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d5724246534f1cae$var$funcToString = $d5724246534f1cae$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d5724246534f1cae$var$hasOwnProperty = $d5724246534f1cae$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $d5724246534f1cae$var$reIsNative = RegExp("^" + $d5724246534f1cae$var$funcToString.call($d5724246534f1cae$var$hasOwnProperty).replace($d5724246534f1cae$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d5724246534f1cae$var$baseIsNative(value) {
    if (!$7LfXT(value) || $kWjpx(value)) return false;
    var pattern = $lNtat(value) ? $d5724246534f1cae$var$reIsNative : $d5724246534f1cae$var$reIsHostCtor;
    return pattern.test($htk17(value));
}
module.exports = $d5724246534f1cae$var$baseIsNative;

});
parcelRegister("lNtat", function(module, exports) {

var $eW5ml = parcelRequire("eW5ml");

var $7LfXT = parcelRequire("7LfXT");
/** `Object#toString` result references. */ var $041855e1d62c0b26$var$asyncTag = "[object AsyncFunction]", $041855e1d62c0b26$var$funcTag = "[object Function]", $041855e1d62c0b26$var$genTag = "[object GeneratorFunction]", $041855e1d62c0b26$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $041855e1d62c0b26$var$isFunction(value) {
    if (!$7LfXT(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eW5ml(value);
    return tag == $041855e1d62c0b26$var$funcTag || tag == $041855e1d62c0b26$var$genTag || tag == $041855e1d62c0b26$var$asyncTag || tag == $041855e1d62c0b26$var$proxyTag;
}
module.exports = $041855e1d62c0b26$var$isFunction;

});
parcelRegister("eW5ml", function(module, exports) {

var $2SIh4 = parcelRequire("2SIh4");

var $5xmGy = parcelRequire("5xmGy");

var $bv36B = parcelRequire("bv36B");
/** `Object#toString` result references. */ var $adfaa3c2341615db$var$nullTag = "[object Null]", $adfaa3c2341615db$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $adfaa3c2341615db$var$symToStringTag = $2SIh4 ? $2SIh4.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $adfaa3c2341615db$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $adfaa3c2341615db$var$undefinedTag : $adfaa3c2341615db$var$nullTag;
    return $adfaa3c2341615db$var$symToStringTag && $adfaa3c2341615db$var$symToStringTag in Object(value) ? $5xmGy(value) : $bv36B(value);
}
module.exports = $adfaa3c2341615db$var$baseGetTag;

});
parcelRegister("2SIh4", function(module, exports) {

var $las3k = parcelRequire("las3k");
/** Built-in value references. */ var $2192f7e4159d9ee2$var$Symbol = $las3k.Symbol;
module.exports = $2192f7e4159d9ee2$var$Symbol;

});
parcelRegister("las3k", function(module, exports) {

var $U9otS = parcelRequire("U9otS");
/** Detect free variable `self`. */ var $f6904ad05d8bc742$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f6904ad05d8bc742$var$root = $U9otS || $f6904ad05d8bc742$var$freeSelf || Function("return this")();
module.exports = $f6904ad05d8bc742$var$root;

});
parcelRegister("U9otS", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $0a8c848039776f9a$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $0a8c848039776f9a$var$freeGlobal;

});



parcelRegister("5xmGy", function(module, exports) {

var $2SIh4 = parcelRequire("2SIh4");
/** Used for built-in method references. */ var $4081a1aacaab647d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4081a1aacaab647d$var$hasOwnProperty = $4081a1aacaab647d$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4081a1aacaab647d$var$nativeObjectToString = $4081a1aacaab647d$var$objectProto.toString;
/** Built-in value references. */ var $4081a1aacaab647d$var$symToStringTag = $2SIh4 ? $2SIh4.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4081a1aacaab647d$var$getRawTag(value) {
    var isOwn = $4081a1aacaab647d$var$hasOwnProperty.call(value, $4081a1aacaab647d$var$symToStringTag), tag = value[$4081a1aacaab647d$var$symToStringTag];
    try {
        value[$4081a1aacaab647d$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4081a1aacaab647d$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4081a1aacaab647d$var$symToStringTag] = tag;
        else delete value[$4081a1aacaab647d$var$symToStringTag];
    }
    return result;
}
module.exports = $4081a1aacaab647d$var$getRawTag;

});

parcelRegister("bv36B", function(module, exports) {
/** Used for built-in method references. */ var $85f4ffa1acdd1a15$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $85f4ffa1acdd1a15$var$nativeObjectToString = $85f4ffa1acdd1a15$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $85f4ffa1acdd1a15$var$objectToString(value) {
    return $85f4ffa1acdd1a15$var$nativeObjectToString.call(value);
}
module.exports = $85f4ffa1acdd1a15$var$objectToString;

});


parcelRegister("7LfXT", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $5a694e8868be28bb$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $5a694e8868be28bb$var$isObject;

});


parcelRegister("kWjpx", function(module, exports) {

var $2XGWt = parcelRequire("2XGWt");
/** Used to detect methods masquerading as native. */ var $f3e84809c39ca0ab$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($2XGWt && $2XGWt.keys && $2XGWt.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f3e84809c39ca0ab$var$isMasked(func) {
    return !!$f3e84809c39ca0ab$var$maskSrcKey && $f3e84809c39ca0ab$var$maskSrcKey in func;
}
module.exports = $f3e84809c39ca0ab$var$isMasked;

});
parcelRegister("2XGWt", function(module, exports) {

var $las3k = parcelRequire("las3k");
/** Used to detect overreaching core-js shims. */ var $228266dd5be79a41$var$coreJsData = $las3k["__core-js_shared__"];
module.exports = $228266dd5be79a41$var$coreJsData;

});


parcelRegister("htk17", function(module, exports) {
/** Used for built-in method references. */ var $cb84ac11b34f1be9$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $cb84ac11b34f1be9$var$funcToString = $cb84ac11b34f1be9$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $cb84ac11b34f1be9$var$toSource(func) {
    if (func != null) {
        try {
            return $cb84ac11b34f1be9$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $cb84ac11b34f1be9$var$toSource;

});


parcelRegister("aeCRo", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $77395aff3e3d6a3c$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $77395aff3e3d6a3c$var$getValue;

});




parcelRegister("g1Dt3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $baab5ac330d9a477$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $baab5ac330d9a477$var$hashDelete;

});

parcelRegister("4nrYP", function(module, exports) {

var $dLHDi = parcelRequire("dLHDi");
/** Used to stand-in for `undefined` hash values. */ var $32ff03b27498d2fb$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $32ff03b27498d2fb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $32ff03b27498d2fb$var$hasOwnProperty = $32ff03b27498d2fb$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $32ff03b27498d2fb$var$hashGet(key) {
    var data = this.__data__;
    if ($dLHDi) {
        var result = data[key];
        return result === $32ff03b27498d2fb$var$HASH_UNDEFINED ? undefined : result;
    }
    return $32ff03b27498d2fb$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $32ff03b27498d2fb$var$hashGet;

});

parcelRegister("lHaSp", function(module, exports) {

var $dLHDi = parcelRequire("dLHDi");
/** Used for built-in method references. */ var $fcb60d0049a17241$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fcb60d0049a17241$var$hasOwnProperty = $fcb60d0049a17241$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fcb60d0049a17241$var$hashHas(key) {
    var data = this.__data__;
    return $dLHDi ? data[key] !== undefined : $fcb60d0049a17241$var$hasOwnProperty.call(data, key);
}
module.exports = $fcb60d0049a17241$var$hashHas;

});

parcelRegister("bwPKm", function(module, exports) {

var $dLHDi = parcelRequire("dLHDi");
/** Used to stand-in for `undefined` hash values. */ var $864ad2b2728f91a6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $864ad2b2728f91a6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $dLHDi && value === undefined ? $864ad2b2728f91a6$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $864ad2b2728f91a6$var$hashSet;

});


parcelRegister("ci9tK", function(module, exports) {

var $if9Aj = parcelRequire("if9Aj");

var $cgnCP = parcelRequire("cgnCP");

var $frKtD = parcelRequire("frKtD");

var $6c0sQ = parcelRequire("6c0sQ");

var $6afWa = parcelRequire("6afWa");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8f2e84c8d3eb1f6f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$8f2e84c8d3eb1f6f$var$ListCache.prototype.clear = $if9Aj;
$8f2e84c8d3eb1f6f$var$ListCache.prototype["delete"] = $cgnCP;
$8f2e84c8d3eb1f6f$var$ListCache.prototype.get = $frKtD;
$8f2e84c8d3eb1f6f$var$ListCache.prototype.has = $6c0sQ;
$8f2e84c8d3eb1f6f$var$ListCache.prototype.set = $6afWa;
module.exports = $8f2e84c8d3eb1f6f$var$ListCache;

});
parcelRegister("if9Aj", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d481100a588cc91d$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $d481100a588cc91d$var$listCacheClear;

});

parcelRegister("cgnCP", function(module, exports) {

var $6R6zw = parcelRequire("6R6zw");
/** Used for built-in method references. */ var $8ed94e2324ab9796$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8ed94e2324ab9796$var$splice = $8ed94e2324ab9796$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8ed94e2324ab9796$var$listCacheDelete(key) {
    var data = this.__data__, index = $6R6zw(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8ed94e2324ab9796$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $8ed94e2324ab9796$var$listCacheDelete;

});
parcelRegister("6R6zw", function(module, exports) {

var $3uvDw = parcelRequire("3uvDw");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4fdcca5726e3d069$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($3uvDw(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $4fdcca5726e3d069$var$assocIndexOf;

});
parcelRegister("3uvDw", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $28acb6c39dee5693$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $28acb6c39dee5693$var$eq;

});



parcelRegister("frKtD", function(module, exports) {

var $6R6zw = parcelRequire("6R6zw");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b3ed6df7698d5ad3$var$listCacheGet(key) {
    var data = this.__data__, index = $6R6zw(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b3ed6df7698d5ad3$var$listCacheGet;

});

parcelRegister("6c0sQ", function(module, exports) {

var $6R6zw = parcelRequire("6R6zw");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4824394387b63f1b$var$listCacheHas(key) {
    return $6R6zw(this.__data__, key) > -1;
}
module.exports = $4824394387b63f1b$var$listCacheHas;

});

parcelRegister("6afWa", function(module, exports) {

var $6R6zw = parcelRequire("6R6zw");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $47d00a108974a6ba$var$listCacheSet(key, value) {
    var data = this.__data__, index = $6R6zw(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $47d00a108974a6ba$var$listCacheSet;

});


parcelRegister("3DAeb", function(module, exports) {

var $21Jw3 = parcelRequire("21Jw3");

var $las3k = parcelRequire("las3k");
/* Built-in method references that are verified to be native. */ var $2a611db0b3777057$var$Map = $21Jw3($las3k, "Map");
module.exports = $2a611db0b3777057$var$Map;

});


parcelRegister("fuc4N", function(module, exports) {

var $dkGJ7 = parcelRequire("dkGJ7");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b463067e5eac7d1f$var$mapCacheDelete(key) {
    var result = $dkGJ7(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b463067e5eac7d1f$var$mapCacheDelete;

});
parcelRegister("dkGJ7", function(module, exports) {

var $lpY5g = parcelRequire("lpY5g");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $9b4e49474d73ce0a$var$getMapData(map, key) {
    var data = map.__data__;
    return $lpY5g(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $9b4e49474d73ce0a$var$getMapData;

});
parcelRegister("lpY5g", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $f97a8a2e24bd0679$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $f97a8a2e24bd0679$var$isKeyable;

});



parcelRegister("1Ooxm", function(module, exports) {

var $dkGJ7 = parcelRequire("dkGJ7");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $151d7e7d364555ad$var$mapCacheGet(key) {
    return $dkGJ7(this, key).get(key);
}
module.exports = $151d7e7d364555ad$var$mapCacheGet;

});

parcelRegister("1TzHN", function(module, exports) {

var $dkGJ7 = parcelRequire("dkGJ7");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $16169fd61b96b07c$var$mapCacheHas(key) {
    return $dkGJ7(this, key).has(key);
}
module.exports = $16169fd61b96b07c$var$mapCacheHas;

});

parcelRegister("5gYdy", function(module, exports) {

var $dkGJ7 = parcelRequire("dkGJ7");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3d6d285963f07e1c$var$mapCacheSet(key, value) {
    var data = $dkGJ7(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $3d6d285963f07e1c$var$mapCacheSet;

});


parcelRegister("6Y8AX", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $512f0379968e7292$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $512f0379968e7292$var$setCacheAdd(value) {
    this.__data__.set(value, $512f0379968e7292$var$HASH_UNDEFINED);
    return this;
}
module.exports = $512f0379968e7292$var$setCacheAdd;

});

parcelRegister("b5rUI", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $8125d06d5fa5078b$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $8125d06d5fa5078b$var$setCacheHas;

});


parcelRegister("5ANxz", function(module, exports) {

var $gIWkQ = parcelRequire("gIWkQ");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $4126be3e31f3f14e$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gIWkQ(array, value, 0) > -1;
}
module.exports = $4126be3e31f3f14e$var$arrayIncludes;

});
parcelRegister("gIWkQ", function(module, exports) {

var $187Zp = parcelRequire("187Zp");

var $5mN4u = parcelRequire("5mN4u");

var $eIdOl = parcelRequire("eIdOl");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c2ce01897989dff5$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $eIdOl(array, value, fromIndex) : $187Zp(array, $5mN4u, fromIndex);
}
module.exports = $c2ce01897989dff5$var$baseIndexOf;

});
parcelRegister("187Zp", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0d2cbc5597a9d7cc$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $0d2cbc5597a9d7cc$var$baseFindIndex;

});

parcelRegister("5mN4u", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3e851268b4fdd616$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3e851268b4fdd616$var$baseIsNaN;

});

parcelRegister("eIdOl", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ab5fe3525b4e55d4$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $ab5fe3525b4e55d4$var$strictIndexOf;

});



parcelRegister("h5Byl", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $c71008839be11e9f$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $c71008839be11e9f$var$arrayIncludesWith;

});

parcelRegister("divFr", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9ae585460c4004f7$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $9ae585460c4004f7$var$cacheHas;

});

parcelRegister("3TE2F", function(module, exports) {

var $9dt9e = parcelRequire("9dt9e");

var $9ucj1 = parcelRequire("9ucj1");

var $efQTl = parcelRequire("efQTl");
/** Used as references for various `Number` constants. */ var $2d6591aaca77f97a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $2d6591aaca77f97a$var$createSet = !($9dt9e && 1 / $efQTl(new $9dt9e([
    ,
    -0
]))[1] == $2d6591aaca77f97a$var$INFINITY) ? $9ucj1 : function(values) {
    return new $9dt9e(values);
};
module.exports = $2d6591aaca77f97a$var$createSet;

});
parcelRegister("9dt9e", function(module, exports) {

var $21Jw3 = parcelRequire("21Jw3");

var $las3k = parcelRequire("las3k");
/* Built-in method references that are verified to be native. */ var $6b5bf01a64962417$var$Set = $21Jw3($las3k, "Set");
module.exports = $6b5bf01a64962417$var$Set;

});

parcelRegister("9ucj1", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6e80760d4b49b51a$var$noop() {
// No operation performed.
}
module.exports = $6e80760d4b49b51a$var$noop;

});

parcelRegister("efQTl", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $a60b7e97911f2118$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $a60b7e97911f2118$var$setToArray;

});




parcelRegister("2SWin", function(module, exports) {

var $jXSNg = parcelRequire("jXSNg");

var $kZqru = parcelRequire("kZqru");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $219dd8272b6a1d36$var$uniqBy(array, iteratee) {
    return array && array.length ? $kZqru(array, $jXSNg(iteratee, 2)) : [];
}
module.exports = $219dd8272b6a1d36$var$uniqBy;

});
parcelRegister("jXSNg", function(module, exports) {

var $eZxoc = parcelRequire("eZxoc");

var $9OGvV = parcelRequire("9OGvV");

var $7OX5j = parcelRequire("7OX5j");

var $2RB6q = parcelRequire("2RB6q");

var $lWIWa = parcelRequire("lWIWa");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $e88e07dbb9c088e7$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $7OX5j;
    if (typeof value == "object") return $2RB6q(value) ? $9OGvV(value[0], value[1]) : $eZxoc(value);
    return $lWIWa(value);
}
module.exports = $e88e07dbb9c088e7$var$baseIteratee;

});
parcelRegister("eZxoc", function(module, exports) {

var $94ZSb = parcelRequire("94ZSb");

var $7wWnS = parcelRequire("7wWnS");

var $2o1QS = parcelRequire("2o1QS");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $aea0a9a0fc0982d8$var$baseMatches(source) {
    var matchData = $7wWnS(source);
    if (matchData.length == 1 && matchData[0][2]) return $2o1QS(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $94ZSb(object, source, matchData);
    };
}
module.exports = $aea0a9a0fc0982d8$var$baseMatches;

});
parcelRegister("94ZSb", function(module, exports) {

var $elB8P = parcelRequire("elB8P");

var $3p1z6 = parcelRequire("3p1z6");
/** Used to compose bitmasks for value comparisons. */ var $69c47b72261df3b2$var$COMPARE_PARTIAL_FLAG = 1, $69c47b72261df3b2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $69c47b72261df3b2$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $elB8P;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $3p1z6(srcValue, objValue, $69c47b72261df3b2$var$COMPARE_PARTIAL_FLAG | $69c47b72261df3b2$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $69c47b72261df3b2$var$baseIsMatch;

});
parcelRegister("elB8P", function(module, exports) {

var $ci9tK = parcelRequire("ci9tK");

var $jwslK = parcelRequire("jwslK");

var $dT6RI = parcelRequire("dT6RI");

var $k7Xg1 = parcelRequire("k7Xg1");

var $cDGVa = parcelRequire("cDGVa");

var $4bFTa = parcelRequire("4bFTa");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a71fd65aacb298fd$var$Stack(entries) {
    var data = this.__data__ = new $ci9tK(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$a71fd65aacb298fd$var$Stack.prototype.clear = $jwslK;
$a71fd65aacb298fd$var$Stack.prototype["delete"] = $dT6RI;
$a71fd65aacb298fd$var$Stack.prototype.get = $k7Xg1;
$a71fd65aacb298fd$var$Stack.prototype.has = $cDGVa;
$a71fd65aacb298fd$var$Stack.prototype.set = $4bFTa;
module.exports = $a71fd65aacb298fd$var$Stack;

});
parcelRegister("jwslK", function(module, exports) {

var $ci9tK = parcelRequire("ci9tK");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e366ff284d72e0c4$var$stackClear() {
    this.__data__ = new $ci9tK;
    this.size = 0;
}
module.exports = $e366ff284d72e0c4$var$stackClear;

});

parcelRegister("dT6RI", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a1c5bcbf24ac159a$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $a1c5bcbf24ac159a$var$stackDelete;

});

parcelRegister("k7Xg1", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ea726d6149dd67a7$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $ea726d6149dd67a7$var$stackGet;

});

parcelRegister("cDGVa", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $933a6bc946fb55d8$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $933a6bc946fb55d8$var$stackHas;

});

parcelRegister("4bFTa", function(module, exports) {

var $ci9tK = parcelRequire("ci9tK");

var $3DAeb = parcelRequire("3DAeb");

var $fs2Xm = parcelRequire("fs2Xm");
/** Used as the size to enable large array optimizations. */ var $30c8aec418fc5b61$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $30c8aec418fc5b61$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $ci9tK) {
        var pairs = data.__data__;
        if (!$3DAeb || pairs.length < $30c8aec418fc5b61$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $fs2Xm(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $30c8aec418fc5b61$var$stackSet;

});


parcelRegister("3p1z6", function(module, exports) {

var $5ztk3 = parcelRequire("5ztk3");

var $6dia8 = parcelRequire("6dia8");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $27a4ebb95fe61d55$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$6dia8(value) && !$6dia8(other)) return value !== value && other !== other;
    return $5ztk3(value, other, bitmask, customizer, $27a4ebb95fe61d55$var$baseIsEqual, stack);
}
module.exports = $27a4ebb95fe61d55$var$baseIsEqual;

});
parcelRegister("5ztk3", function(module, exports) {

var $elB8P = parcelRequire("elB8P");

var $16nT1 = parcelRequire("16nT1");

var $8RNSo = parcelRequire("8RNSo");

var $53AO3 = parcelRequire("53AO3");

var $li3xL = parcelRequire("li3xL");

var $2RB6q = parcelRequire("2RB6q");

var $gi0oQ = parcelRequire("gi0oQ");

var $d1ZIi = parcelRequire("d1ZIi");
/** Used to compose bitmasks for value comparisons. */ var $40e6f774130ee343$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $40e6f774130ee343$var$argsTag = "[object Arguments]", $40e6f774130ee343$var$arrayTag = "[object Array]", $40e6f774130ee343$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $40e6f774130ee343$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $40e6f774130ee343$var$hasOwnProperty = $40e6f774130ee343$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $40e6f774130ee343$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $2RB6q(object), othIsArr = $2RB6q(other), objTag = objIsArr ? $40e6f774130ee343$var$arrayTag : $li3xL(object), othTag = othIsArr ? $40e6f774130ee343$var$arrayTag : $li3xL(other);
    objTag = objTag == $40e6f774130ee343$var$argsTag ? $40e6f774130ee343$var$objectTag : objTag;
    othTag = othTag == $40e6f774130ee343$var$argsTag ? $40e6f774130ee343$var$objectTag : othTag;
    var objIsObj = objTag == $40e6f774130ee343$var$objectTag, othIsObj = othTag == $40e6f774130ee343$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $gi0oQ(object)) {
        if (!$gi0oQ(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $elB8P);
        return objIsArr || $d1ZIi(object) ? $16nT1(object, other, bitmask, customizer, equalFunc, stack) : $8RNSo(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $40e6f774130ee343$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $40e6f774130ee343$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $40e6f774130ee343$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $elB8P);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $elB8P);
    return $53AO3(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $40e6f774130ee343$var$baseIsEqualDeep;

});
parcelRegister("16nT1", function(module, exports) {

var $4T70o = parcelRequire("4T70o");

var $dLy0Z = parcelRequire("dLy0Z");

var $divFr = parcelRequire("divFr");
/** Used to compose bitmasks for value comparisons. */ var $0cd8e15a7fe3c1a3$var$COMPARE_PARTIAL_FLAG = 1, $0cd8e15a7fe3c1a3$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0cd8e15a7fe3c1a3$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0cd8e15a7fe3c1a3$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0cd8e15a7fe3c1a3$var$COMPARE_UNORDERED_FLAG ? new $4T70o : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$dLy0Z(other, function(othValue, othIndex) {
                if (!$divFr(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $0cd8e15a7fe3c1a3$var$equalArrays;

});
parcelRegister("dLy0Z", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $a05a0cc93e0cef9a$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $a05a0cc93e0cef9a$var$arraySome;

});


parcelRegister("8RNSo", function(module, exports) {

var $2SIh4 = parcelRequire("2SIh4");

var $5GYCE = parcelRequire("5GYCE");

var $3uvDw = parcelRequire("3uvDw");

var $16nT1 = parcelRequire("16nT1");

var $b72qX = parcelRequire("b72qX");

var $efQTl = parcelRequire("efQTl");
/** Used to compose bitmasks for value comparisons. */ var $6749f65bac6ab953$var$COMPARE_PARTIAL_FLAG = 1, $6749f65bac6ab953$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $6749f65bac6ab953$var$boolTag = "[object Boolean]", $6749f65bac6ab953$var$dateTag = "[object Date]", $6749f65bac6ab953$var$errorTag = "[object Error]", $6749f65bac6ab953$var$mapTag = "[object Map]", $6749f65bac6ab953$var$numberTag = "[object Number]", $6749f65bac6ab953$var$regexpTag = "[object RegExp]", $6749f65bac6ab953$var$setTag = "[object Set]", $6749f65bac6ab953$var$stringTag = "[object String]", $6749f65bac6ab953$var$symbolTag = "[object Symbol]";
var $6749f65bac6ab953$var$arrayBufferTag = "[object ArrayBuffer]", $6749f65bac6ab953$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $6749f65bac6ab953$var$symbolProto = $2SIh4 ? $2SIh4.prototype : undefined, $6749f65bac6ab953$var$symbolValueOf = $6749f65bac6ab953$var$symbolProto ? $6749f65bac6ab953$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6749f65bac6ab953$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $6749f65bac6ab953$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $6749f65bac6ab953$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $5GYCE(object), new $5GYCE(other))) return false;
            return true;
        case $6749f65bac6ab953$var$boolTag:
        case $6749f65bac6ab953$var$dateTag:
        case $6749f65bac6ab953$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $3uvDw(+object, +other);
        case $6749f65bac6ab953$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $6749f65bac6ab953$var$regexpTag:
        case $6749f65bac6ab953$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $6749f65bac6ab953$var$mapTag:
            var convert = $b72qX;
        case $6749f65bac6ab953$var$setTag:
            var isPartial = bitmask & $6749f65bac6ab953$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $efQTl);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $6749f65bac6ab953$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $16nT1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $6749f65bac6ab953$var$symbolTag:
            if ($6749f65bac6ab953$var$symbolValueOf) return $6749f65bac6ab953$var$symbolValueOf.call(object) == $6749f65bac6ab953$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $6749f65bac6ab953$var$equalByTag;

});
parcelRegister("5GYCE", function(module, exports) {

var $las3k = parcelRequire("las3k");
/** Built-in value references. */ var $424fe656853eaa87$var$Uint8Array = $las3k.Uint8Array;
module.exports = $424fe656853eaa87$var$Uint8Array;

});

parcelRegister("b72qX", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $81723c729cff599f$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $81723c729cff599f$var$mapToArray;

});


parcelRegister("53AO3", function(module, exports) {

var $7pkCs = parcelRequire("7pkCs");
/** Used to compose bitmasks for value comparisons. */ var $3ae9c88389d8a483$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3ae9c88389d8a483$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3ae9c88389d8a483$var$hasOwnProperty = $3ae9c88389d8a483$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3ae9c88389d8a483$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3ae9c88389d8a483$var$COMPARE_PARTIAL_FLAG, objProps = $7pkCs(object), objLength = objProps.length, othProps = $7pkCs(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3ae9c88389d8a483$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $3ae9c88389d8a483$var$equalObjects;

});
parcelRegister("7pkCs", function(module, exports) {

var $jByAh = parcelRequire("jByAh");

var $cw6WA = parcelRequire("cw6WA");

var $jQ4EC = parcelRequire("jQ4EC");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $564adcbd3085f1cc$var$getAllKeys(object) {
    return $jByAh(object, $jQ4EC, $cw6WA);
}
module.exports = $564adcbd3085f1cc$var$getAllKeys;

});
parcelRegister("jByAh", function(module, exports) {

var $1X0Mw = parcelRequire("1X0Mw");

var $2RB6q = parcelRequire("2RB6q");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e45c4cbd57acca1f$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $2RB6q(object) ? result : $1X0Mw(result, symbolsFunc(object));
}
module.exports = $e45c4cbd57acca1f$var$baseGetAllKeys;

});
parcelRegister("1X0Mw", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $16bbe85b0b6319e4$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $16bbe85b0b6319e4$var$arrayPush;

});

parcelRegister("2RB6q", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $215d4fcfdacdd808$var$isArray = Array.isArray;
module.exports = $215d4fcfdacdd808$var$isArray;

});


parcelRegister("cw6WA", function(module, exports) {

var $cXLyH = parcelRequire("cXLyH");

var $8kkxm = parcelRequire("8kkxm");
/** Used for built-in method references. */ var $91cddc19cbdd3f1d$var$objectProto = Object.prototype;
/** Built-in value references. */ var $91cddc19cbdd3f1d$var$propertyIsEnumerable = $91cddc19cbdd3f1d$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $91cddc19cbdd3f1d$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $91cddc19cbdd3f1d$var$getSymbols = !$91cddc19cbdd3f1d$var$nativeGetSymbols ? $8kkxm : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $cXLyH($91cddc19cbdd3f1d$var$nativeGetSymbols(object), function(symbol) {
        return $91cddc19cbdd3f1d$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $91cddc19cbdd3f1d$var$getSymbols;

});
parcelRegister("cXLyH", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $96ffe2e287d6cc65$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $96ffe2e287d6cc65$var$arrayFilter;

});

parcelRegister("8kkxm", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $61001f3f44bf9506$var$stubArray() {
    return [];
}
module.exports = $61001f3f44bf9506$var$stubArray;

});


parcelRegister("jQ4EC", function(module, exports) {

var $adY2t = parcelRequire("adY2t");

var $9Wkb8 = parcelRequire("9Wkb8");

var $g7K1J = parcelRequire("g7K1J");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $e7167bd8917b32a3$var$keys(object) {
    return $g7K1J(object) ? $adY2t(object) : $9Wkb8(object);
}
module.exports = $e7167bd8917b32a3$var$keys;

});
parcelRegister("adY2t", function(module, exports) {

var $5Pvf8 = parcelRequire("5Pvf8");

var $jaqPN = parcelRequire("jaqPN");

var $2RB6q = parcelRequire("2RB6q");

var $gi0oQ = parcelRequire("gi0oQ");

var $4BmOQ = parcelRequire("4BmOQ");

var $d1ZIi = parcelRequire("d1ZIi");
/** Used for built-in method references. */ var $7719b0c25b32d8e0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7719b0c25b32d8e0$var$hasOwnProperty = $7719b0c25b32d8e0$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $7719b0c25b32d8e0$var$arrayLikeKeys(value, inherited) {
    var isArr = $2RB6q(value), isArg = !isArr && $jaqPN(value), isBuff = !isArr && !isArg && $gi0oQ(value), isType = !isArr && !isArg && !isBuff && $d1ZIi(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $5Pvf8(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $7719b0c25b32d8e0$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $4BmOQ(key, length)))) result.push(key);
    return result;
}
module.exports = $7719b0c25b32d8e0$var$arrayLikeKeys;

});
parcelRegister("5Pvf8", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $43e9f362c4fe809c$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $43e9f362c4fe809c$var$baseTimes;

});

parcelRegister("jaqPN", function(module, exports) {

var $fCstS = parcelRequire("fCstS");

var $6dia8 = parcelRequire("6dia8");
/** Used for built-in method references. */ var $df43c43a37dcf527$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $df43c43a37dcf527$var$hasOwnProperty = $df43c43a37dcf527$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $df43c43a37dcf527$var$propertyIsEnumerable = $df43c43a37dcf527$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $df43c43a37dcf527$var$isArguments = $fCstS(function() {
    return arguments;
}()) ? $fCstS : function(value) {
    return $6dia8(value) && $df43c43a37dcf527$var$hasOwnProperty.call(value, "callee") && !$df43c43a37dcf527$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $df43c43a37dcf527$var$isArguments;

});
parcelRegister("fCstS", function(module, exports) {

var $eW5ml = parcelRequire("eW5ml");

var $6dia8 = parcelRequire("6dia8");
/** `Object#toString` result references. */ var $b5f07f58d75ed9ea$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $b5f07f58d75ed9ea$var$baseIsArguments(value) {
    return $6dia8(value) && $eW5ml(value) == $b5f07f58d75ed9ea$var$argsTag;
}
module.exports = $b5f07f58d75ed9ea$var$baseIsArguments;

});
parcelRegister("6dia8", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $48620ba2ea6c03aa$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $48620ba2ea6c03aa$var$isObjectLike;

});



parcelRegister("gi0oQ", function(module, exports) {

var $las3k = parcelRequire("las3k");

var $8WX7M = parcelRequire("8WX7M");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $las3k.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8WX7M;
module.exports = isBuffer;

});
parcelRegister("8WX7M", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $68419a6d189ded09$var$stubFalse() {
    return false;
}
module.exports = $68419a6d189ded09$var$stubFalse;

});


parcelRegister("4BmOQ", function(module, exports) {
/** Used as references for various `Number` constants. */ var $359c518106e3f78c$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $359c518106e3f78c$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $359c518106e3f78c$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $359c518106e3f78c$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $359c518106e3f78c$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $359c518106e3f78c$var$isIndex;

});

parcelRegister("d1ZIi", function(module, exports) {

var $8doqK = parcelRequire("8doqK");

var $1eGn4 = parcelRequire("1eGn4");

var $9bVEp = parcelRequire("9bVEp");
/* Node.js helper references. */ var $97cb3d6270351c9c$var$nodeIsTypedArray = $9bVEp && $9bVEp.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $97cb3d6270351c9c$var$isTypedArray = $97cb3d6270351c9c$var$nodeIsTypedArray ? $1eGn4($97cb3d6270351c9c$var$nodeIsTypedArray) : $8doqK;
module.exports = $97cb3d6270351c9c$var$isTypedArray;

});
parcelRegister("8doqK", function(module, exports) {

var $eW5ml = parcelRequire("eW5ml");

var $cx1ts = parcelRequire("cx1ts");

var $6dia8 = parcelRequire("6dia8");
/** `Object#toString` result references. */ var $5fb27d04081c8bd2$var$argsTag = "[object Arguments]", $5fb27d04081c8bd2$var$arrayTag = "[object Array]", $5fb27d04081c8bd2$var$boolTag = "[object Boolean]", $5fb27d04081c8bd2$var$dateTag = "[object Date]", $5fb27d04081c8bd2$var$errorTag = "[object Error]", $5fb27d04081c8bd2$var$funcTag = "[object Function]", $5fb27d04081c8bd2$var$mapTag = "[object Map]", $5fb27d04081c8bd2$var$numberTag = "[object Number]", $5fb27d04081c8bd2$var$objectTag = "[object Object]", $5fb27d04081c8bd2$var$regexpTag = "[object RegExp]", $5fb27d04081c8bd2$var$setTag = "[object Set]", $5fb27d04081c8bd2$var$stringTag = "[object String]", $5fb27d04081c8bd2$var$weakMapTag = "[object WeakMap]";
var $5fb27d04081c8bd2$var$arrayBufferTag = "[object ArrayBuffer]", $5fb27d04081c8bd2$var$dataViewTag = "[object DataView]", $5fb27d04081c8bd2$var$float32Tag = "[object Float32Array]", $5fb27d04081c8bd2$var$float64Tag = "[object Float64Array]", $5fb27d04081c8bd2$var$int8Tag = "[object Int8Array]", $5fb27d04081c8bd2$var$int16Tag = "[object Int16Array]", $5fb27d04081c8bd2$var$int32Tag = "[object Int32Array]", $5fb27d04081c8bd2$var$uint8Tag = "[object Uint8Array]", $5fb27d04081c8bd2$var$uint8ClampedTag = "[object Uint8ClampedArray]", $5fb27d04081c8bd2$var$uint16Tag = "[object Uint16Array]", $5fb27d04081c8bd2$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $5fb27d04081c8bd2$var$typedArrayTags = {};
$5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$float32Tag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$float64Tag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$int8Tag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$int16Tag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$int32Tag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$uint8Tag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$uint8ClampedTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$uint16Tag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$uint32Tag] = true;
$5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$argsTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$arrayTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$arrayBufferTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$boolTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$dataViewTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$dateTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$errorTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$funcTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$mapTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$numberTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$objectTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$regexpTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$setTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$stringTag] = $5fb27d04081c8bd2$var$typedArrayTags[$5fb27d04081c8bd2$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $5fb27d04081c8bd2$var$baseIsTypedArray(value) {
    return $6dia8(value) && $cx1ts(value.length) && !!$5fb27d04081c8bd2$var$typedArrayTags[$eW5ml(value)];
}
module.exports = $5fb27d04081c8bd2$var$baseIsTypedArray;

});
parcelRegister("cx1ts", function(module, exports) {
/** Used as references for various `Number` constants. */ var $91f9b5d425aa2564$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $91f9b5d425aa2564$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $91f9b5d425aa2564$var$MAX_SAFE_INTEGER;
}
module.exports = $91f9b5d425aa2564$var$isLength;

});


parcelRegister("1eGn4", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $0e67f745a04d3633$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $0e67f745a04d3633$var$baseUnary;

});

parcelRegister("9bVEp", function(module, exports) {

var $U9otS = parcelRequire("U9otS");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $U9otS.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("9Wkb8", function(module, exports) {

var $l6y2a = parcelRequire("l6y2a");

var $4Ug0x = parcelRequire("4Ug0x");
/** Used for built-in method references. */ var $73c92ee84ddd14dd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $73c92ee84ddd14dd$var$hasOwnProperty = $73c92ee84ddd14dd$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $73c92ee84ddd14dd$var$baseKeys(object) {
    if (!$l6y2a(object)) return $4Ug0x(object);
    var result = [];
    for(var key in Object(object))if ($73c92ee84ddd14dd$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $73c92ee84ddd14dd$var$baseKeys;

});
parcelRegister("l6y2a", function(module, exports) {
/** Used for built-in method references. */ var $f5d48ef7ac4fea94$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $f5d48ef7ac4fea94$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $f5d48ef7ac4fea94$var$objectProto;
    return value === proto;
}
module.exports = $f5d48ef7ac4fea94$var$isPrototype;

});

parcelRegister("4Ug0x", function(module, exports) {

var $jGpPo = parcelRequire("jGpPo");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3928cf2ec1e78a6f$var$nativeKeys = $jGpPo(Object.keys, Object);
module.exports = $3928cf2ec1e78a6f$var$nativeKeys;

});
parcelRegister("jGpPo", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e545f9798a05d9d4$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $e545f9798a05d9d4$var$overArg;

});



parcelRegister("g7K1J", function(module, exports) {

var $lNtat = parcelRequire("lNtat");

var $cx1ts = parcelRequire("cx1ts");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $bbd100c74133754b$var$isArrayLike(value) {
    return value != null && $cx1ts(value.length) && !$lNtat(value);
}
module.exports = $bbd100c74133754b$var$isArrayLike;

});




parcelRegister("li3xL", function(module, exports) {

var $1oRTU = parcelRequire("1oRTU");

var $3DAeb = parcelRequire("3DAeb");

var $jCbNQ = parcelRequire("jCbNQ");

var $9dt9e = parcelRequire("9dt9e");

var $6UEG5 = parcelRequire("6UEG5");

var $eW5ml = parcelRequire("eW5ml");

var $htk17 = parcelRequire("htk17");
/** `Object#toString` result references. */ var $f7fe071b28d80b60$var$mapTag = "[object Map]", $f7fe071b28d80b60$var$objectTag = "[object Object]", $f7fe071b28d80b60$var$promiseTag = "[object Promise]", $f7fe071b28d80b60$var$setTag = "[object Set]", $f7fe071b28d80b60$var$weakMapTag = "[object WeakMap]";
var $f7fe071b28d80b60$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $f7fe071b28d80b60$var$dataViewCtorString = $htk17($1oRTU), $f7fe071b28d80b60$var$mapCtorString = $htk17($3DAeb), $f7fe071b28d80b60$var$promiseCtorString = $htk17($jCbNQ), $f7fe071b28d80b60$var$setCtorString = $htk17($9dt9e), $f7fe071b28d80b60$var$weakMapCtorString = $htk17($6UEG5);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $f7fe071b28d80b60$var$getTag = $eW5ml;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($1oRTU && $f7fe071b28d80b60$var$getTag(new $1oRTU(new ArrayBuffer(1))) != $f7fe071b28d80b60$var$dataViewTag || $3DAeb && $f7fe071b28d80b60$var$getTag(new $3DAeb) != $f7fe071b28d80b60$var$mapTag || $jCbNQ && $f7fe071b28d80b60$var$getTag($jCbNQ.resolve()) != $f7fe071b28d80b60$var$promiseTag || $9dt9e && $f7fe071b28d80b60$var$getTag(new $9dt9e) != $f7fe071b28d80b60$var$setTag || $6UEG5 && $f7fe071b28d80b60$var$getTag(new $6UEG5) != $f7fe071b28d80b60$var$weakMapTag) $f7fe071b28d80b60$var$getTag = function(value) {
    var result = $eW5ml(value), Ctor = result == $f7fe071b28d80b60$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $htk17(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $f7fe071b28d80b60$var$dataViewCtorString:
            return $f7fe071b28d80b60$var$dataViewTag;
        case $f7fe071b28d80b60$var$mapCtorString:
            return $f7fe071b28d80b60$var$mapTag;
        case $f7fe071b28d80b60$var$promiseCtorString:
            return $f7fe071b28d80b60$var$promiseTag;
        case $f7fe071b28d80b60$var$setCtorString:
            return $f7fe071b28d80b60$var$setTag;
        case $f7fe071b28d80b60$var$weakMapCtorString:
            return $f7fe071b28d80b60$var$weakMapTag;
    }
    return result;
};
module.exports = $f7fe071b28d80b60$var$getTag;

});
parcelRegister("1oRTU", function(module, exports) {

var $21Jw3 = parcelRequire("21Jw3");

var $las3k = parcelRequire("las3k");
/* Built-in method references that are verified to be native. */ var $1051d7ecb9a2f216$var$DataView = $21Jw3($las3k, "DataView");
module.exports = $1051d7ecb9a2f216$var$DataView;

});

parcelRegister("jCbNQ", function(module, exports) {

var $21Jw3 = parcelRequire("21Jw3");

var $las3k = parcelRequire("las3k");
/* Built-in method references that are verified to be native. */ var $e47ab8c0af4e8b2d$var$Promise = $21Jw3($las3k, "Promise");
module.exports = $e47ab8c0af4e8b2d$var$Promise;

});

parcelRegister("6UEG5", function(module, exports) {

var $21Jw3 = parcelRequire("21Jw3");

var $las3k = parcelRequire("las3k");
/* Built-in method references that are verified to be native. */ var $508786d3ebb04bfc$var$WeakMap = $21Jw3($las3k, "WeakMap");
module.exports = $508786d3ebb04bfc$var$WeakMap;

});





parcelRegister("7wWnS", function(module, exports) {

var $2UvHM = parcelRequire("2UvHM");

var $jQ4EC = parcelRequire("jQ4EC");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $57b8cf6c2fae90c8$var$getMatchData(object) {
    var result = $jQ4EC(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $2UvHM(value)
        ];
    }
    return result;
}
module.exports = $57b8cf6c2fae90c8$var$getMatchData;

});
parcelRegister("2UvHM", function(module, exports) {

var $7LfXT = parcelRequire("7LfXT");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $21e967ba6903ffcc$var$isStrictComparable(value) {
    return value === value && !$7LfXT(value);
}
module.exports = $21e967ba6903ffcc$var$isStrictComparable;

});


parcelRegister("2o1QS", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1bcf426ae0000f28$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1bcf426ae0000f28$var$matchesStrictComparable;

});


parcelRegister("9OGvV", function(module, exports) {

var $3p1z6 = parcelRequire("3p1z6");

var $dCugQ = parcelRequire("dCugQ");

var $5rPGK = parcelRequire("5rPGK");

var $eSSwv = parcelRequire("eSSwv");

var $2UvHM = parcelRequire("2UvHM");

var $2o1QS = parcelRequire("2o1QS");

var $hzB1B = parcelRequire("hzB1B");
/** Used to compose bitmasks for value comparisons. */ var $7259c2f647b96532$var$COMPARE_PARTIAL_FLAG = 1, $7259c2f647b96532$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7259c2f647b96532$var$baseMatchesProperty(path, srcValue) {
    if ($eSSwv(path) && $2UvHM(srcValue)) return $2o1QS($hzB1B(path), srcValue);
    return function(object) {
        var objValue = $dCugQ(object, path);
        return objValue === undefined && objValue === srcValue ? $5rPGK(object, path) : $3p1z6(srcValue, objValue, $7259c2f647b96532$var$COMPARE_PARTIAL_FLAG | $7259c2f647b96532$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $7259c2f647b96532$var$baseMatchesProperty;

});
parcelRegister("dCugQ", function(module, exports) {

var $76od4 = parcelRequire("76od4");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $9ea64e13561c90e8$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $76od4(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $9ea64e13561c90e8$var$get;

});
parcelRegister("76od4", function(module, exports) {

var $M5AyG = parcelRequire("M5AyG");

var $hzB1B = parcelRequire("hzB1B");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $52bbdf7f900a53da$var$baseGet(object, path) {
    path = $M5AyG(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$hzB1B(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $52bbdf7f900a53da$var$baseGet;

});
parcelRegister("M5AyG", function(module, exports) {

var $2RB6q = parcelRequire("2RB6q");

var $eSSwv = parcelRequire("eSSwv");

var $4uQlN = parcelRequire("4uQlN");

var $lU871 = parcelRequire("lU871");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $0908d1996f67ffad$var$castPath(value, object) {
    if ($2RB6q(value)) return value;
    return $eSSwv(value, object) ? [
        value
    ] : $4uQlN($lU871(value));
}
module.exports = $0908d1996f67ffad$var$castPath;

});
parcelRegister("eSSwv", function(module, exports) {

var $2RB6q = parcelRequire("2RB6q");

var $4Cmnw = parcelRequire("4Cmnw");
/** Used to match property names within property paths. */ var $ad60670484425406$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $ad60670484425406$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $ad60670484425406$var$isKey(value, object) {
    if ($2RB6q(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $4Cmnw(value)) return true;
    return $ad60670484425406$var$reIsPlainProp.test(value) || !$ad60670484425406$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $ad60670484425406$var$isKey;

});
parcelRegister("4Cmnw", function(module, exports) {

var $eW5ml = parcelRequire("eW5ml");

var $6dia8 = parcelRequire("6dia8");
/** `Object#toString` result references. */ var $35cc11efa4a66f56$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $35cc11efa4a66f56$var$isSymbol(value) {
    return typeof value == "symbol" || $6dia8(value) && $eW5ml(value) == $35cc11efa4a66f56$var$symbolTag;
}
module.exports = $35cc11efa4a66f56$var$isSymbol;

});


parcelRegister("4uQlN", function(module, exports) {

var $j4Njg = parcelRequire("j4Njg");
/** Used to match property names within property paths. */ var $3462927ab4ad4b1b$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $3462927ab4ad4b1b$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $3462927ab4ad4b1b$var$stringToPath = $j4Njg(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($3462927ab4ad4b1b$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($3462927ab4ad4b1b$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $3462927ab4ad4b1b$var$stringToPath;

});
parcelRegister("j4Njg", function(module, exports) {

var $76quZ = parcelRequire("76quZ");
/** Used as the maximum memoize cache size. */ var $de34a3f1bec6c87f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $de34a3f1bec6c87f$var$memoizeCapped(func) {
    var result = $76quZ(func, function(key) {
        if (cache.size === $de34a3f1bec6c87f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $de34a3f1bec6c87f$var$memoizeCapped;

});
parcelRegister("76quZ", function(module, exports) {

var $fs2Xm = parcelRequire("fs2Xm");
/** Error message constants. */ var $52bda60a117f8b4d$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $52bda60a117f8b4d$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($52bda60a117f8b4d$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($52bda60a117f8b4d$var$memoize.Cache || $fs2Xm);
    return memoized;
}
// Expose `MapCache`.
$52bda60a117f8b4d$var$memoize.Cache = $fs2Xm;
module.exports = $52bda60a117f8b4d$var$memoize;

});



parcelRegister("lU871", function(module, exports) {

var $d7A7d = parcelRequire("d7A7d");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $ff251ed872d791a6$var$toString(value) {
    return value == null ? "" : $d7A7d(value);
}
module.exports = $ff251ed872d791a6$var$toString;

});
parcelRegister("d7A7d", function(module, exports) {

var $2SIh4 = parcelRequire("2SIh4");

var $8K7fk = parcelRequire("8K7fk");

var $2RB6q = parcelRequire("2RB6q");

var $4Cmnw = parcelRequire("4Cmnw");
/** Used as references for various `Number` constants. */ var $98d7f194cd253b21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $98d7f194cd253b21$var$symbolProto = $2SIh4 ? $2SIh4.prototype : undefined, $98d7f194cd253b21$var$symbolToString = $98d7f194cd253b21$var$symbolProto ? $98d7f194cd253b21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $98d7f194cd253b21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($2RB6q(value)) // Recursively convert values (susceptible to call stack limits).
    return $8K7fk(value, $98d7f194cd253b21$var$baseToString) + "";
    if ($4Cmnw(value)) return $98d7f194cd253b21$var$symbolToString ? $98d7f194cd253b21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$98d7f194cd253b21$var$INFINITY ? "-0" : result;
}
module.exports = $98d7f194cd253b21$var$baseToString;

});
parcelRegister("8K7fk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $65d83d8b8fb6fa99$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $65d83d8b8fb6fa99$var$arrayMap;

});




parcelRegister("hzB1B", function(module, exports) {

var $4Cmnw = parcelRequire("4Cmnw");
/** Used as references for various `Number` constants. */ var $ccb26ce9bc82e3c4$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $ccb26ce9bc82e3c4$var$toKey(value) {
    if (typeof value == "string" || $4Cmnw(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$ccb26ce9bc82e3c4$var$INFINITY ? "-0" : result;
}
module.exports = $ccb26ce9bc82e3c4$var$toKey;

});



parcelRegister("5rPGK", function(module, exports) {

var $dyqQj = parcelRequire("dyqQj");

var $9keZn = parcelRequire("9keZn");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $3f779199a5d00e50$var$hasIn(object, path) {
    return object != null && $9keZn(object, path, $dyqQj);
}
module.exports = $3f779199a5d00e50$var$hasIn;

});
parcelRegister("dyqQj", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $9de345c119a3c020$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $9de345c119a3c020$var$baseHasIn;

});

parcelRegister("9keZn", function(module, exports) {

var $M5AyG = parcelRequire("M5AyG");

var $jaqPN = parcelRequire("jaqPN");

var $2RB6q = parcelRequire("2RB6q");

var $4BmOQ = parcelRequire("4BmOQ");

var $cx1ts = parcelRequire("cx1ts");

var $hzB1B = parcelRequire("hzB1B");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $6ca19bd12e8eadee$var$hasPath(object, path, hasFunc) {
    path = $M5AyG(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $hzB1B(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cx1ts(length) && $4BmOQ(key, length) && ($2RB6q(object) || $jaqPN(object));
}
module.exports = $6ca19bd12e8eadee$var$hasPath;

});



parcelRegister("7OX5j", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $5b1b08e59fc602c4$var$identity(value) {
    return value;
}
module.exports = $5b1b08e59fc602c4$var$identity;

});

parcelRegister("lWIWa", function(module, exports) {

var $kuWDt = parcelRequire("kuWDt");

var $jZo1o = parcelRequire("jZo1o");

var $eSSwv = parcelRequire("eSSwv");

var $hzB1B = parcelRequire("hzB1B");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $ffa1df535b8df777$var$property(path) {
    return $eSSwv(path) ? $kuWDt($hzB1B(path)) : $jZo1o(path);
}
module.exports = $ffa1df535b8df777$var$property;

});
parcelRegister("kuWDt", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $eec417d2477d3818$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $eec417d2477d3818$var$baseProperty;

});

parcelRegister("jZo1o", function(module, exports) {

var $76od4 = parcelRequire("76od4");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e8d658fb77d07dc8$var$basePropertyDeep(path) {
    return function(object) {
        return $76od4(object, path);
    };
}
module.exports = $e8d658fb77d07dc8$var$basePropertyDeep;

});




parcelRegister("1Bt2m", function(module, exports) {

var $bT5qu = parcelRequire("bT5qu");

var $lItag = parcelRequire("lItag");

var $cyiI7 = parcelRequire("cyiI7");

var $varmQ = parcelRequire("varmQ");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $12afc549114ec3fd$var$sortBy = $cyiI7(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $varmQ(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $varmQ(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $lItag(collection, $bT5qu(iteratees, 1), []);
});
module.exports = $12afc549114ec3fd$var$sortBy;

});
parcelRegister("bT5qu", function(module, exports) {

var $1X0Mw = parcelRequire("1X0Mw");

var $gy5Us = parcelRequire("gy5Us");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $8a790a4e6bcdc063$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $gy5Us);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $8a790a4e6bcdc063$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $1X0Mw(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $8a790a4e6bcdc063$var$baseFlatten;

});
parcelRegister("gy5Us", function(module, exports) {

var $2SIh4 = parcelRequire("2SIh4");

var $jaqPN = parcelRequire("jaqPN");

var $2RB6q = parcelRequire("2RB6q");
/** Built-in value references. */ var $c0c467dd79335edb$var$spreadableSymbol = $2SIh4 ? $2SIh4.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $c0c467dd79335edb$var$isFlattenable(value) {
    return $2RB6q(value) || $jaqPN(value) || !!($c0c467dd79335edb$var$spreadableSymbol && value && value[$c0c467dd79335edb$var$spreadableSymbol]);
}
module.exports = $c0c467dd79335edb$var$isFlattenable;

});


parcelRegister("lItag", function(module, exports) {

var $8K7fk = parcelRequire("8K7fk");

var $76od4 = parcelRequire("76od4");

var $jXSNg = parcelRequire("jXSNg");

var $b1OdP = parcelRequire("b1OdP");

var $qjCo8 = parcelRequire("qjCo8");

var $1eGn4 = parcelRequire("1eGn4");

var $eFd87 = parcelRequire("eFd87");

var $7OX5j = parcelRequire("7OX5j");

var $2RB6q = parcelRequire("2RB6q");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $fcf4548353089058$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $8K7fk(iteratees, function(iteratee) {
        if ($2RB6q(iteratee)) return function(value) {
            return $76od4(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $7OX5j
    ];
    var index = -1;
    iteratees = $8K7fk(iteratees, $1eGn4($jXSNg));
    var result = $b1OdP(collection, function(value, key, collection) {
        var criteria = $8K7fk(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $qjCo8(result, function(object, other) {
        return $eFd87(object, other, orders);
    });
}
module.exports = $fcf4548353089058$var$baseOrderBy;

});
parcelRegister("b1OdP", function(module, exports) {

var $aXgdH = parcelRequire("aXgdH");

var $g7K1J = parcelRequire("g7K1J");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $8076bec172a8b706$var$baseMap(collection, iteratee) {
    var index = -1, result = $g7K1J(collection) ? Array(collection.length) : [];
    $aXgdH(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $8076bec172a8b706$var$baseMap;

});
parcelRegister("aXgdH", function(module, exports) {

var $4PcUC = parcelRequire("4PcUC");

var $46LSv = parcelRequire("46LSv");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $7f9bff02859bd6b7$var$baseEach = $46LSv($4PcUC);
module.exports = $7f9bff02859bd6b7$var$baseEach;

});
parcelRegister("4PcUC", function(module, exports) {

var $lKEcZ = parcelRequire("lKEcZ");

var $jQ4EC = parcelRequire("jQ4EC");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $3835f0f1a6c48f8b$var$baseForOwn(object, iteratee) {
    return object && $lKEcZ(object, iteratee, $jQ4EC);
}
module.exports = $3835f0f1a6c48f8b$var$baseForOwn;

});
parcelRegister("lKEcZ", function(module, exports) {

var $eKiot = parcelRequire("eKiot");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $fd5d156fedef1dfd$var$baseFor = $eKiot();
module.exports = $fd5d156fedef1dfd$var$baseFor;

});
parcelRegister("eKiot", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $abc3a13018b1a8e6$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $abc3a13018b1a8e6$var$createBaseFor;

});



parcelRegister("46LSv", function(module, exports) {

var $g7K1J = parcelRequire("g7K1J");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $2fdcdc94b8d42e0a$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$g7K1J(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $2fdcdc94b8d42e0a$var$createBaseEach;

});



parcelRegister("qjCo8", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $04f1a595029b1908$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $04f1a595029b1908$var$baseSortBy;

});

parcelRegister("eFd87", function(module, exports) {

var $hdHhU = parcelRequire("hdHhU");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $aacf145569870ca4$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $hdHhU(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $aacf145569870ca4$var$compareMultiple;

});
parcelRegister("hdHhU", function(module, exports) {

var $4Cmnw = parcelRequire("4Cmnw");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $c8953aa5b05390b6$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $4Cmnw(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $4Cmnw(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $c8953aa5b05390b6$var$compareAscending;

});



parcelRegister("cyiI7", function(module, exports) {

var $7OX5j = parcelRequire("7OX5j");

var $cjM5W = parcelRequire("cjM5W");

var $ezeu6 = parcelRequire("ezeu6");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $92372c866f42743b$var$baseRest(func, start) {
    return $ezeu6($cjM5W(func, start, $7OX5j), func + "");
}
module.exports = $92372c866f42743b$var$baseRest;

});
parcelRegister("cjM5W", function(module, exports) {

var $5YZIg = parcelRequire("5YZIg");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8f7c90ff61ae630b$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $8f7c90ff61ae630b$var$overRest(func, start, transform) {
    start = $8f7c90ff61ae630b$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $8f7c90ff61ae630b$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $5YZIg(func, this, otherArgs);
    };
}
module.exports = $8f7c90ff61ae630b$var$overRest;

});
parcelRegister("5YZIg", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $45b26d3a7b156060$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $45b26d3a7b156060$var$apply;

});


parcelRegister("ezeu6", function(module, exports) {

var $9XSjM = parcelRequire("9XSjM");

var $j4VrS = parcelRequire("j4VrS");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a9af91ea0369d4fe$var$setToString = $j4VrS($9XSjM);
module.exports = $a9af91ea0369d4fe$var$setToString;

});
parcelRegister("9XSjM", function(module, exports) {

var $ebyv4 = parcelRequire("ebyv4");

var $acXg8 = parcelRequire("acXg8");

var $7OX5j = parcelRequire("7OX5j");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $7413c22ffe6778f8$var$baseSetToString = !$acXg8 ? $7OX5j : function(func, string) {
    return $acXg8(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $ebyv4(string),
        "writable": true
    });
};
module.exports = $7413c22ffe6778f8$var$baseSetToString;

});
parcelRegister("ebyv4", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $a53cdacd07c1864c$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $a53cdacd07c1864c$var$constant;

});

parcelRegister("acXg8", function(module, exports) {

var $21Jw3 = parcelRequire("21Jw3");
var $76e8fe0242da05a7$var$defineProperty = function() {
    try {
        var func = $21Jw3(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $76e8fe0242da05a7$var$defineProperty;

});


parcelRegister("j4VrS", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $de3af422de4a65e3$var$HOT_COUNT = 800, $de3af422de4a65e3$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $de3af422de4a65e3$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $de3af422de4a65e3$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $de3af422de4a65e3$var$nativeNow(), remaining = $de3af422de4a65e3$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $de3af422de4a65e3$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $de3af422de4a65e3$var$shortOut;

});



parcelRegister("varmQ", function(module, exports) {

var $3uvDw = parcelRequire("3uvDw");

var $g7K1J = parcelRequire("g7K1J");

var $4BmOQ = parcelRequire("4BmOQ");

var $7LfXT = parcelRequire("7LfXT");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $05dafe9cf9f91e08$var$isIterateeCall(value, index, object) {
    if (!$7LfXT(object)) return false;
    var type = typeof index;
    if (type == "number" ? $g7K1J(object) && $4BmOQ(index, object.length) : type == "string" && index in object) return $3uvDw(object[index], value);
    return false;
}
module.exports = $05dafe9cf9f91e08$var$isIterateeCall;

});


parcelRegister("e5pHQ", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $a415790c59dd5845$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $a415790c59dd5845$var$last;

});

parcelRegister("kHQkn", function(module, exports) {

var $bFOw4 = parcelRequire("bFOw4");

var $1eGn4 = parcelRequire("1eGn4");

var $9bVEp = parcelRequire("9bVEp");
/* Node.js helper references. */ var $f13069f676a58207$var$nodeIsDate = $9bVEp && $9bVEp.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */ var $f13069f676a58207$var$isDate = $f13069f676a58207$var$nodeIsDate ? $1eGn4($f13069f676a58207$var$nodeIsDate) : $bFOw4;
module.exports = $f13069f676a58207$var$isDate;

});
parcelRegister("bFOw4", function(module, exports) {

var $eW5ml = parcelRequire("eW5ml");

var $6dia8 = parcelRequire("6dia8");
/** `Object#toString` result references. */ var $87fab589d3a99925$var$dateTag = "[object Date]";
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */ function $87fab589d3a99925$var$baseIsDate(value) {
    return $6dia8(value) && $eW5ml(value) == $87fab589d3a99925$var$dateTag;
}
module.exports = $87fab589d3a99925$var$baseIsDate;

});


parcelRegister("aZXhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $801d9693da013742$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "point", function () { return $801d9693da013742$export$105684a3041cb6f3; });

var $167Nn = parcelRequire("167Nn");

var $f4AhM = parcelRequire("f4AhM");

var $eZmYt = parcelRequire("eZmYt");
function $801d9693da013742$export$2e2bcd8739ae039() {
    var scale = (0, $eZmYt.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $167Nn.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $801d9693da013742$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $f4AhM.initRange).apply(rescale(), arguments);
}
function $801d9693da013742$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $801d9693da013742$var$pointish(copy());
    };
    return scale;
}
function $801d9693da013742$export$105684a3041cb6f3() {
    return $801d9693da013742$var$pointish($801d9693da013742$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("167Nn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ccc65fd15c9761a$export$2e2bcd8739ae039; });
function $0ccc65fd15c9761a$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});


parcelRegister("jPEDU", function(module, exports) {

$parcel$export(module.exports, "calendar", function () { return $e7024e87ff67ada0$export$56bbcdb8aca31149; });
$parcel$export(module.exports, "default", function () { return $e7024e87ff67ada0$export$2e2bcd8739ae039; });

var $eb41W = parcelRequire("eb41W");
var $l17YE = parcelRequire("l17YE");
var $8st3n = parcelRequire("8st3n");
var $ljfAd = parcelRequire("ljfAd");
var $hmWDf = parcelRequire("hmWDf");
var $7Bq7c = parcelRequire("7Bq7c");
var $13xJY = parcelRequire("13xJY");
var $fubQZ = parcelRequire("fubQZ");

var $7pj3L = parcelRequire("7pj3L");

var $62KKj = parcelRequire("62KKj");

var $f4AhM = parcelRequire("f4AhM");

var $79yV8 = parcelRequire("79yV8");
function $e7024e87ff67ada0$var$date(t) {
    return new Date(t);
}
function $e7024e87ff67ada0$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $e7024e87ff67ada0$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $62KKj.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $e7024e87ff67ada0$var$number)) : domain().map($e7024e87ff67ada0$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $79yV8.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $62KKj.copy)(scale, $e7024e87ff67ada0$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $e7024e87ff67ada0$export$2e2bcd8739ae039() {
    return (0, $f4AhM.initRange).apply($e7024e87ff67ada0$export$56bbcdb8aca31149((0, $7Bq7c.timeTicks), (0, $7Bq7c.timeTickInterval), (0, $fubQZ.default), (0, $ljfAd.default), (0, $13xJY.sunday), (0, $eb41W.default), (0, $l17YE.default), (0, $8st3n.default), (0, $hmWDf.default), (0, $7pj3L.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("eb41W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a525381ee8103fb8$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
var $a525381ee8103fb8$var$day = (0, $d66o7.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $h80YT.durationMinute)) / (0, $h80YT.durationDay), (date)=>date.getDate() - 1);
var $a525381ee8103fb8$export$2e2bcd8739ae039 = $a525381ee8103fb8$var$day;
var $a525381ee8103fb8$export$3cf5dda4201cc0f2 = $a525381ee8103fb8$var$day.range;

});
parcelRegister("d66o7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9890ca70e6fbbe61$export$2e2bcd8739ae039; });
var $9890ca70e6fbbe61$var$t0 = new Date, $9890ca70e6fbbe61$var$t1 = new Date;
function $9890ca70e6fbbe61$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $9890ca70e6fbbe61$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $9890ca70e6fbbe61$var$t0.setTime(+start), $9890ca70e6fbbe61$var$t1.setTime(+end);
            floori($9890ca70e6fbbe61$var$t0), floori($9890ca70e6fbbe61$var$t1);
            return Math.floor(count($9890ca70e6fbbe61$var$t0, $9890ca70e6fbbe61$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("h80YT", function(module, exports) {

$parcel$export(module.exports, "durationSecond", function () { return $c783f1d77904c747$export$79ef0e34099623dc; });
$parcel$export(module.exports, "durationMinute", function () { return $c783f1d77904c747$export$683905d551c33fa9; });
$parcel$export(module.exports, "durationHour", function () { return $c783f1d77904c747$export$4157bf0c8e241659; });
$parcel$export(module.exports, "durationDay", function () { return $c783f1d77904c747$export$353686095f4fbf45; });
$parcel$export(module.exports, "durationWeek", function () { return $c783f1d77904c747$export$c241eb88520d5016; });
$parcel$export(module.exports, "durationMonth", function () { return $c783f1d77904c747$export$ab95684df7020b26; });
$parcel$export(module.exports, "durationYear", function () { return $c783f1d77904c747$export$61f8ee2d834c6959; });
const $c783f1d77904c747$export$79ef0e34099623dc = 1000;
const $c783f1d77904c747$export$683905d551c33fa9 = $c783f1d77904c747$export$79ef0e34099623dc * 60;
const $c783f1d77904c747$export$4157bf0c8e241659 = $c783f1d77904c747$export$683905d551c33fa9 * 60;
const $c783f1d77904c747$export$353686095f4fbf45 = $c783f1d77904c747$export$4157bf0c8e241659 * 24;
const $c783f1d77904c747$export$c241eb88520d5016 = $c783f1d77904c747$export$353686095f4fbf45 * 7;
const $c783f1d77904c747$export$ab95684df7020b26 = $c783f1d77904c747$export$353686095f4fbf45 * 30;
const $c783f1d77904c747$export$61f8ee2d834c6959 = $c783f1d77904c747$export$353686095f4fbf45 * 365;

});


parcelRegister("l17YE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4cfe11bafdf1de3$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
var $f4cfe11bafdf1de3$var$hour = (0, $d66o7.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $h80YT.durationSecond) - date.getMinutes() * (0, $h80YT.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $h80YT.durationHour));
}, function(start, end) {
    return (end - start) / (0, $h80YT.durationHour);
}, function(date) {
    return date.getHours();
});
var $f4cfe11bafdf1de3$export$2e2bcd8739ae039 = $f4cfe11bafdf1de3$var$hour;
var $f4cfe11bafdf1de3$export$8d468796d69cdad1 = $f4cfe11bafdf1de3$var$hour.range;

});

parcelRegister("8st3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $628779ac5e0b8d8e$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
var $628779ac5e0b8d8e$var$minute = (0, $d66o7.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $h80YT.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $h80YT.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $h80YT.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $628779ac5e0b8d8e$export$2e2bcd8739ae039 = $628779ac5e0b8d8e$var$minute;
var $628779ac5e0b8d8e$export$666252b437cce0c7 = $628779ac5e0b8d8e$var$minute.range;

});

parcelRegister("ljfAd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f83775d43c1e4495$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");
var $f83775d43c1e4495$var$month = (0, $d66o7.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $f83775d43c1e4495$export$2e2bcd8739ae039 = $f83775d43c1e4495$var$month;
var $f83775d43c1e4495$export$16352d1b10c5eb38 = $f83775d43c1e4495$var$month.range;

});

parcelRegister("hmWDf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca51f8dc2f35fafd$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
var $ca51f8dc2f35fafd$var$second = (0, $d66o7.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $h80YT.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $h80YT.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $ca51f8dc2f35fafd$export$2e2bcd8739ae039 = $ca51f8dc2f35fafd$var$second;
var $ca51f8dc2f35fafd$export$4792e48abc550fa1 = $ca51f8dc2f35fafd$var$second.range;

});

parcelRegister("7Bq7c", function(module, exports) {

$parcel$export(module.exports, "utcTicks", function () { return $58903f00239e6469$export$826ba5ae907e9767; });
$parcel$export(module.exports, "utcTickInterval", function () { return $58903f00239e6469$export$6262d8d056ea44c4; });
$parcel$export(module.exports, "timeTicks", function () { return $58903f00239e6469$export$60c76498552d28a6; });
$parcel$export(module.exports, "timeTickInterval", function () { return $58903f00239e6469$export$69511150134dd174; });

var $73fLL = parcelRequire("73fLL");
var $lAhFG = parcelRequire("lAhFG");

var $h80YT = parcelRequire("h80YT");

var $dAKmE = parcelRequire("dAKmE");

var $hmWDf = parcelRequire("hmWDf");

var $8st3n = parcelRequire("8st3n");

var $l17YE = parcelRequire("l17YE");

var $eb41W = parcelRequire("eb41W");

var $13xJY = parcelRequire("13xJY");

var $ljfAd = parcelRequire("ljfAd");

var $fubQZ = parcelRequire("fubQZ");

var $g5pwx = parcelRequire("g5pwx");

var $9bne0 = parcelRequire("9bne0");

var $d2Xvg = parcelRequire("d2Xvg");

var $38lsh = parcelRequire("38lsh");

var $4MwdQ = parcelRequire("4MwdQ");

var $6idk8 = parcelRequire("6idk8");
function $58903f00239e6469$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $hmWDf.default),
            1,
            (0, $h80YT.durationSecond)
        ],
        [
            (0, $hmWDf.default),
            5,
            5 * (0, $h80YT.durationSecond)
        ],
        [
            (0, $hmWDf.default),
            15,
            15 * (0, $h80YT.durationSecond)
        ],
        [
            (0, $hmWDf.default),
            30,
            30 * (0, $h80YT.durationSecond)
        ],
        [
            minute,
            1,
            (0, $h80YT.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $h80YT.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $h80YT.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $h80YT.durationMinute)
        ],
        [
            hour,
            1,
            (0, $h80YT.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $h80YT.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $h80YT.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $h80YT.durationHour)
        ],
        [
            day,
            1,
            (0, $h80YT.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $h80YT.durationDay)
        ],
        [
            week,
            1,
            (0, $h80YT.durationWeek)
        ],
        [
            month,
            1,
            (0, $h80YT.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $h80YT.durationMonth)
        ],
        [
            year,
            1,
            (0, $h80YT.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $73fLL.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $lAhFG.tickStep)(start / (0, $h80YT.durationYear), stop / (0, $h80YT.durationYear), count));
        if (i === 0) return (0, $dAKmE.default).every(Math.max((0, $lAhFG.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$58903f00239e6469$export$826ba5ae907e9767, $58903f00239e6469$export$6262d8d056ea44c4] = $58903f00239e6469$var$ticker((0, $6idk8.default), (0, $4MwdQ.default), (0, $38lsh.utcSunday), (0, $d2Xvg.default), (0, $9bne0.default), (0, $g5pwx.default));
const [$58903f00239e6469$export$60c76498552d28a6, $58903f00239e6469$export$69511150134dd174] = $58903f00239e6469$var$ticker((0, $fubQZ.default), (0, $ljfAd.default), (0, $13xJY.sunday), (0, $eb41W.default), (0, $l17YE.default), (0, $8st3n.default));

});
parcelRegister("dAKmE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e529a20f84546ab$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");
var $9e529a20f84546ab$var$millisecond = (0, $d66o7.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$9e529a20f84546ab$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $9e529a20f84546ab$var$millisecond;
    return (0, $d66o7.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $9e529a20f84546ab$export$2e2bcd8739ae039 = $9e529a20f84546ab$var$millisecond;
var $9e529a20f84546ab$export$9a27fac83d67afd3 = $9e529a20f84546ab$var$millisecond.range;

});

parcelRegister("13xJY", function(module, exports) {

$parcel$export(module.exports, "sunday", function () { return $0c503e71bb2f5d64$export$fb3ee18ed410cc21; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
function $0c503e71bb2f5d64$var$weekday(i) {
    return (0, $d66o7.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $h80YT.durationMinute)) / (0, $h80YT.durationWeek);
    });
}
var $0c503e71bb2f5d64$export$fb3ee18ed410cc21 = $0c503e71bb2f5d64$var$weekday(0);
var $0c503e71bb2f5d64$export$6416afaab03bc9b8 = $0c503e71bb2f5d64$var$weekday(1);
var $0c503e71bb2f5d64$export$cb8f040f5d17ac7b = $0c503e71bb2f5d64$var$weekday(2);
var $0c503e71bb2f5d64$export$347581849975dfc8 = $0c503e71bb2f5d64$var$weekday(3);
var $0c503e71bb2f5d64$export$2f2b56683a3e5629 = $0c503e71bb2f5d64$var$weekday(4);
var $0c503e71bb2f5d64$export$59b8c2ccd931d806 = $0c503e71bb2f5d64$var$weekday(5);
var $0c503e71bb2f5d64$export$478ceadebff4d377 = $0c503e71bb2f5d64$var$weekday(6);
var $0c503e71bb2f5d64$export$e8daabaa40641211 = $0c503e71bb2f5d64$export$fb3ee18ed410cc21.range;
var $0c503e71bb2f5d64$export$74e5b559c235c00e = $0c503e71bb2f5d64$export$6416afaab03bc9b8.range;
var $0c503e71bb2f5d64$export$e7d6aa4fb107bc56 = $0c503e71bb2f5d64$export$cb8f040f5d17ac7b.range;
var $0c503e71bb2f5d64$export$fcd5880b20bb06a8 = $0c503e71bb2f5d64$export$347581849975dfc8.range;
var $0c503e71bb2f5d64$export$682716b7bbe33641 = $0c503e71bb2f5d64$export$2f2b56683a3e5629.range;
var $0c503e71bb2f5d64$export$482924968ca86084 = $0c503e71bb2f5d64$export$59b8c2ccd931d806.range;
var $0c503e71bb2f5d64$export$7d755172c9cda9d2 = $0c503e71bb2f5d64$export$478ceadebff4d377.range;

});

parcelRegister("fubQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b462da3c0b36d644$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");
var $b462da3c0b36d644$var$year = (0, $d66o7.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$b462da3c0b36d644$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $d66o7.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $b462da3c0b36d644$export$2e2bcd8739ae039 = $b462da3c0b36d644$var$year;
var $b462da3c0b36d644$export$6fda41c7fb23acf9 = $b462da3c0b36d644$var$year.range;

});

parcelRegister("g5pwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb60e97b0c3e29ec$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
var $bb60e97b0c3e29ec$var$utcMinute = (0, $d66o7.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $h80YT.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $h80YT.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $bb60e97b0c3e29ec$export$2e2bcd8739ae039 = $bb60e97b0c3e29ec$var$utcMinute;
var $bb60e97b0c3e29ec$export$cedd563624e8ee50 = $bb60e97b0c3e29ec$var$utcMinute.range;

});

parcelRegister("9bne0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6af728225d5412c8$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
var $6af728225d5412c8$var$utcHour = (0, $d66o7.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $h80YT.durationHour));
}, function(start, end) {
    return (end - start) / (0, $h80YT.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $6af728225d5412c8$export$2e2bcd8739ae039 = $6af728225d5412c8$var$utcHour;
var $6af728225d5412c8$export$6e7a76cd5f50b719 = $6af728225d5412c8$var$utcHour.range;

});

parcelRegister("d2Xvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97f99e5c6fba18a0$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
var $97f99e5c6fba18a0$var$utcDay = (0, $d66o7.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $h80YT.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $97f99e5c6fba18a0$export$2e2bcd8739ae039 = $97f99e5c6fba18a0$var$utcDay;
var $97f99e5c6fba18a0$export$d277e198508549a1 = $97f99e5c6fba18a0$var$utcDay.range;

});

parcelRegister("38lsh", function(module, exports) {

$parcel$export(module.exports, "utcSunday", function () { return $2482c3021022b3e2$export$4898b06303a92011; });

var $d66o7 = parcelRequire("d66o7");

var $h80YT = parcelRequire("h80YT");
function $2482c3021022b3e2$var$utcWeekday(i) {
    return (0, $d66o7.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $h80YT.durationWeek);
    });
}
var $2482c3021022b3e2$export$4898b06303a92011 = $2482c3021022b3e2$var$utcWeekday(0);
var $2482c3021022b3e2$export$9cfc53b9cfafd080 = $2482c3021022b3e2$var$utcWeekday(1);
var $2482c3021022b3e2$export$2a6d545f77eceb15 = $2482c3021022b3e2$var$utcWeekday(2);
var $2482c3021022b3e2$export$a5c25d8ed64433c4 = $2482c3021022b3e2$var$utcWeekday(3);
var $2482c3021022b3e2$export$1db08111baec2f53 = $2482c3021022b3e2$var$utcWeekday(4);
var $2482c3021022b3e2$export$29265e34dd5921f7 = $2482c3021022b3e2$var$utcWeekday(5);
var $2482c3021022b3e2$export$85b74dad05049604 = $2482c3021022b3e2$var$utcWeekday(6);
var $2482c3021022b3e2$export$6f3e1c2b0f7d7880 = $2482c3021022b3e2$export$4898b06303a92011.range;
var $2482c3021022b3e2$export$1d2d8b858bb366f9 = $2482c3021022b3e2$export$9cfc53b9cfafd080.range;
var $2482c3021022b3e2$export$1d5f6785fc7f30f8 = $2482c3021022b3e2$export$2a6d545f77eceb15.range;
var $2482c3021022b3e2$export$7a75faf0e37ef4af = $2482c3021022b3e2$export$a5c25d8ed64433c4.range;
var $2482c3021022b3e2$export$417eb959611b2f2f = $2482c3021022b3e2$export$1db08111baec2f53.range;
var $2482c3021022b3e2$export$59d308db7af08c64 = $2482c3021022b3e2$export$29265e34dd5921f7.range;
var $2482c3021022b3e2$export$a124108a0a7f34c8 = $2482c3021022b3e2$export$85b74dad05049604.range;

});

parcelRegister("4MwdQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37b4a3c597d22b64$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");
var $37b4a3c597d22b64$var$utcMonth = (0, $d66o7.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $37b4a3c597d22b64$export$2e2bcd8739ae039 = $37b4a3c597d22b64$var$utcMonth;
var $37b4a3c597d22b64$export$49159f585997498 = $37b4a3c597d22b64$var$utcMonth.range;

});

parcelRegister("6idk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $494ec256e1d0c07e$export$2e2bcd8739ae039; });

var $d66o7 = parcelRequire("d66o7");
var $494ec256e1d0c07e$var$utcYear = (0, $d66o7.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$494ec256e1d0c07e$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $d66o7.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $494ec256e1d0c07e$export$2e2bcd8739ae039 = $494ec256e1d0c07e$var$utcYear;
var $494ec256e1d0c07e$export$3e24d311e17f5802 = $494ec256e1d0c07e$var$utcYear.range;

});



parcelRegister("8dUNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fcb98811d94ac32$export$2e2bcd8739ae039; });

var $d2Xvg = parcelRequire("d2Xvg");
var $9bne0 = parcelRequire("9bne0");
var $g5pwx = parcelRequire("g5pwx");
var $4MwdQ = parcelRequire("4MwdQ");
var $hmWDf = parcelRequire("hmWDf");
var $7Bq7c = parcelRequire("7Bq7c");
var $38lsh = parcelRequire("38lsh");
var $6idk8 = parcelRequire("6idk8");

var $7pj3L = parcelRequire("7pj3L");

var $jPEDU = parcelRequire("jPEDU");

var $f4AhM = parcelRequire("f4AhM");
function $5fcb98811d94ac32$export$2e2bcd8739ae039() {
    return (0, $f4AhM.initRange).apply((0, $jPEDU.calendar)((0, $7Bq7c.utcTicks), (0, $7Bq7c.utcTickInterval), (0, $6idk8.default), (0, $4MwdQ.default), (0, $38lsh.utcSunday), (0, $d2Xvg.default), (0, $9bne0.default), (0, $g5pwx.default), (0, $hmWDf.default), (0, $7pj3L.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("5qhcs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f2cb902d7886d2f$export$2e2bcd8739ae039; });
var $3f2cb902d7886d2f$var$t0 = new Date, $3f2cb902d7886d2f$var$t1 = new Date;
function $3f2cb902d7886d2f$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $3f2cb902d7886d2f$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $3f2cb902d7886d2f$var$t0.setTime(+start), $3f2cb902d7886d2f$var$t1.setTime(+end);
            floori($3f2cb902d7886d2f$var$t0), floori($3f2cb902d7886d2f$var$t1);
            return Math.floor(count($3f2cb902d7886d2f$var$t0, $3f2cb902d7886d2f$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("80dMk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d3902ec0c498067$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");
var $5d3902ec0c498067$var$millisecond = (0, $5qhcs.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$5d3902ec0c498067$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $5d3902ec0c498067$var$millisecond;
    return (0, $5qhcs.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $5d3902ec0c498067$export$2e2bcd8739ae039 = $5d3902ec0c498067$var$millisecond;
var $5d3902ec0c498067$export$9a27fac83d67afd3 = $5d3902ec0c498067$var$millisecond.range;

});

parcelRegister("ibzeX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3d497110c3f0f89$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");

var $7EpEx = parcelRequire("7EpEx");
var $d3d497110c3f0f89$var$second = (0, $5qhcs.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $7EpEx.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $7EpEx.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $d3d497110c3f0f89$export$2e2bcd8739ae039 = $d3d497110c3f0f89$var$second;
var $d3d497110c3f0f89$export$4792e48abc550fa1 = $d3d497110c3f0f89$var$second.range;

});
parcelRegister("7EpEx", function(module, exports) {

$parcel$export(module.exports, "durationSecond", function () { return $017000b16556e903$export$79ef0e34099623dc; });
$parcel$export(module.exports, "durationMinute", function () { return $017000b16556e903$export$683905d551c33fa9; });
$parcel$export(module.exports, "durationHour", function () { return $017000b16556e903$export$4157bf0c8e241659; });
$parcel$export(module.exports, "durationWeek", function () { return $017000b16556e903$export$c241eb88520d5016; });
var $017000b16556e903$export$79ef0e34099623dc = 1e3;
var $017000b16556e903$export$683905d551c33fa9 = 6e4;
var $017000b16556e903$export$4157bf0c8e241659 = 36e5;
var $017000b16556e903$export$353686095f4fbf45 = 864e5;
var $017000b16556e903$export$c241eb88520d5016 = 6048e5;

});


parcelRegister("2hFmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9d418b93b86c09$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");

var $7EpEx = parcelRequire("7EpEx");
var $1a9d418b93b86c09$var$minute = (0, $5qhcs.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $7EpEx.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $7EpEx.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $7EpEx.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $1a9d418b93b86c09$export$2e2bcd8739ae039 = $1a9d418b93b86c09$var$minute;
var $1a9d418b93b86c09$export$666252b437cce0c7 = $1a9d418b93b86c09$var$minute.range;

});

parcelRegister("4iSPB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32236035ecb96522$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");

var $7EpEx = parcelRequire("7EpEx");
var $32236035ecb96522$var$hour = (0, $5qhcs.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $7EpEx.durationSecond) - date.getMinutes() * (0, $7EpEx.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $7EpEx.durationHour));
}, function(start, end) {
    return (end - start) / (0, $7EpEx.durationHour);
}, function(date) {
    return date.getHours();
});
var $32236035ecb96522$export$2e2bcd8739ae039 = $32236035ecb96522$var$hour;
var $32236035ecb96522$export$8d468796d69cdad1 = $32236035ecb96522$var$hour.range;

});

parcelRegister("d7Oww", function(module, exports) {

$parcel$export(module.exports, "sunday", function () { return $98e31eb85b1d0391$export$fb3ee18ed410cc21; });
$parcel$export(module.exports, "monday", function () { return $98e31eb85b1d0391$export$6416afaab03bc9b8; });
$parcel$export(module.exports, "tuesday", function () { return $98e31eb85b1d0391$export$cb8f040f5d17ac7b; });
$parcel$export(module.exports, "wednesday", function () { return $98e31eb85b1d0391$export$347581849975dfc8; });
$parcel$export(module.exports, "thursday", function () { return $98e31eb85b1d0391$export$2f2b56683a3e5629; });
$parcel$export(module.exports, "friday", function () { return $98e31eb85b1d0391$export$59b8c2ccd931d806; });
$parcel$export(module.exports, "saturday", function () { return $98e31eb85b1d0391$export$478ceadebff4d377; });

var $5qhcs = parcelRequire("5qhcs");

var $7EpEx = parcelRequire("7EpEx");
function $98e31eb85b1d0391$var$weekday(i) {
    return (0, $5qhcs.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $7EpEx.durationMinute)) / (0, $7EpEx.durationWeek);
    });
}
var $98e31eb85b1d0391$export$fb3ee18ed410cc21 = $98e31eb85b1d0391$var$weekday(0);
var $98e31eb85b1d0391$export$6416afaab03bc9b8 = $98e31eb85b1d0391$var$weekday(1);
var $98e31eb85b1d0391$export$cb8f040f5d17ac7b = $98e31eb85b1d0391$var$weekday(2);
var $98e31eb85b1d0391$export$347581849975dfc8 = $98e31eb85b1d0391$var$weekday(3);
var $98e31eb85b1d0391$export$2f2b56683a3e5629 = $98e31eb85b1d0391$var$weekday(4);
var $98e31eb85b1d0391$export$59b8c2ccd931d806 = $98e31eb85b1d0391$var$weekday(5);
var $98e31eb85b1d0391$export$478ceadebff4d377 = $98e31eb85b1d0391$var$weekday(6);
var $98e31eb85b1d0391$export$e8daabaa40641211 = $98e31eb85b1d0391$export$fb3ee18ed410cc21.range;
var $98e31eb85b1d0391$export$74e5b559c235c00e = $98e31eb85b1d0391$export$6416afaab03bc9b8.range;
var $98e31eb85b1d0391$export$e7d6aa4fb107bc56 = $98e31eb85b1d0391$export$cb8f040f5d17ac7b.range;
var $98e31eb85b1d0391$export$fcd5880b20bb06a8 = $98e31eb85b1d0391$export$347581849975dfc8.range;
var $98e31eb85b1d0391$export$682716b7bbe33641 = $98e31eb85b1d0391$export$2f2b56683a3e5629.range;
var $98e31eb85b1d0391$export$482924968ca86084 = $98e31eb85b1d0391$export$59b8c2ccd931d806.range;
var $98e31eb85b1d0391$export$7d755172c9cda9d2 = $98e31eb85b1d0391$export$478ceadebff4d377.range;

});

parcelRegister("l26u6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4fed0982e0fd415$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");
var $f4fed0982e0fd415$var$month = (0, $5qhcs.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $f4fed0982e0fd415$export$2e2bcd8739ae039 = $f4fed0982e0fd415$var$month;
var $f4fed0982e0fd415$export$16352d1b10c5eb38 = $f4fed0982e0fd415$var$month.range;

});

parcelRegister("ftYuF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4587d3c007e02a0$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");
var $b4587d3c007e02a0$var$year = (0, $5qhcs.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$b4587d3c007e02a0$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $5qhcs.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $b4587d3c007e02a0$export$2e2bcd8739ae039 = $b4587d3c007e02a0$var$year;
var $b4587d3c007e02a0$export$6fda41c7fb23acf9 = $b4587d3c007e02a0$var$year.range;

});

parcelRegister("aehqB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7728bb060ddffeaf$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");

var $7EpEx = parcelRequire("7EpEx");
var $7728bb060ddffeaf$var$utcMinute = (0, $5qhcs.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $7EpEx.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $7EpEx.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $7728bb060ddffeaf$export$2e2bcd8739ae039 = $7728bb060ddffeaf$var$utcMinute;
var $7728bb060ddffeaf$export$cedd563624e8ee50 = $7728bb060ddffeaf$var$utcMinute.range;

});

parcelRegister("ccJuc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e29e39a7f8b53bc$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");

var $7EpEx = parcelRequire("7EpEx");
var $8e29e39a7f8b53bc$var$utcHour = (0, $5qhcs.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $7EpEx.durationHour));
}, function(start, end) {
    return (end - start) / (0, $7EpEx.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $8e29e39a7f8b53bc$export$2e2bcd8739ae039 = $8e29e39a7f8b53bc$var$utcHour;
var $8e29e39a7f8b53bc$export$6e7a76cd5f50b719 = $8e29e39a7f8b53bc$var$utcHour.range;

});

parcelRegister("3SrNU", function(module, exports) {

$parcel$export(module.exports, "utcSunday", function () { return $2d2bfb8430cae1bc$export$4898b06303a92011; });
$parcel$export(module.exports, "utcMonday", function () { return $2d2bfb8430cae1bc$export$9cfc53b9cfafd080; });
$parcel$export(module.exports, "utcTuesday", function () { return $2d2bfb8430cae1bc$export$2a6d545f77eceb15; });
$parcel$export(module.exports, "utcWednesday", function () { return $2d2bfb8430cae1bc$export$a5c25d8ed64433c4; });
$parcel$export(module.exports, "utcThursday", function () { return $2d2bfb8430cae1bc$export$1db08111baec2f53; });
$parcel$export(module.exports, "utcFriday", function () { return $2d2bfb8430cae1bc$export$29265e34dd5921f7; });
$parcel$export(module.exports, "utcSaturday", function () { return $2d2bfb8430cae1bc$export$85b74dad05049604; });

var $5qhcs = parcelRequire("5qhcs");

var $7EpEx = parcelRequire("7EpEx");
function $2d2bfb8430cae1bc$var$utcWeekday(i) {
    return (0, $5qhcs.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $7EpEx.durationWeek);
    });
}
var $2d2bfb8430cae1bc$export$4898b06303a92011 = $2d2bfb8430cae1bc$var$utcWeekday(0);
var $2d2bfb8430cae1bc$export$9cfc53b9cfafd080 = $2d2bfb8430cae1bc$var$utcWeekday(1);
var $2d2bfb8430cae1bc$export$2a6d545f77eceb15 = $2d2bfb8430cae1bc$var$utcWeekday(2);
var $2d2bfb8430cae1bc$export$a5c25d8ed64433c4 = $2d2bfb8430cae1bc$var$utcWeekday(3);
var $2d2bfb8430cae1bc$export$1db08111baec2f53 = $2d2bfb8430cae1bc$var$utcWeekday(4);
var $2d2bfb8430cae1bc$export$29265e34dd5921f7 = $2d2bfb8430cae1bc$var$utcWeekday(5);
var $2d2bfb8430cae1bc$export$85b74dad05049604 = $2d2bfb8430cae1bc$var$utcWeekday(6);
var $2d2bfb8430cae1bc$export$6f3e1c2b0f7d7880 = $2d2bfb8430cae1bc$export$4898b06303a92011.range;
var $2d2bfb8430cae1bc$export$1d2d8b858bb366f9 = $2d2bfb8430cae1bc$export$9cfc53b9cfafd080.range;
var $2d2bfb8430cae1bc$export$1d5f6785fc7f30f8 = $2d2bfb8430cae1bc$export$2a6d545f77eceb15.range;
var $2d2bfb8430cae1bc$export$7a75faf0e37ef4af = $2d2bfb8430cae1bc$export$a5c25d8ed64433c4.range;
var $2d2bfb8430cae1bc$export$417eb959611b2f2f = $2d2bfb8430cae1bc$export$1db08111baec2f53.range;
var $2d2bfb8430cae1bc$export$59d308db7af08c64 = $2d2bfb8430cae1bc$export$29265e34dd5921f7.range;
var $2d2bfb8430cae1bc$export$a124108a0a7f34c8 = $2d2bfb8430cae1bc$export$85b74dad05049604.range;

});

parcelRegister("b7ApD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $818c97e453bfeec2$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");
var $818c97e453bfeec2$var$utcMonth = (0, $5qhcs.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $818c97e453bfeec2$export$2e2bcd8739ae039 = $818c97e453bfeec2$var$utcMonth;
var $818c97e453bfeec2$export$49159f585997498 = $818c97e453bfeec2$var$utcMonth.range;

});

parcelRegister("ggOD1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd8569b0c1d98640$export$2e2bcd8739ae039; });

var $5qhcs = parcelRequire("5qhcs");
var $bd8569b0c1d98640$var$utcYear = (0, $5qhcs.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$bd8569b0c1d98640$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $5qhcs.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $bd8569b0c1d98640$export$2e2bcd8739ae039 = $bd8569b0c1d98640$var$utcYear;
var $bd8569b0c1d98640$export$3e24d311e17f5802 = $bd8569b0c1d98640$var$utcYear.range;

});




parcelRegister("e9xmC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4dbc95104690930$export$2e2bcd8739ae039; });

var $jhh4j = parcelRequire("jhh4j");

var $iFaTn = parcelRequire("iFaTn");

var $ehI3a = parcelRequire("ehI3a");

var $7Gyiu = parcelRequire("7Gyiu");

var $5Jig7 = parcelRequire("5Jig7");
function $a4dbc95104690930$export$2e2bcd8739ae039() {
    var x0 = (0, $5Jig7.x), x1 = null, y0 = (0, $iFaTn.default)(0), y1 = (0, $5Jig7.y), defined = (0, $iFaTn.default)(true), context = null, curve = (0, $ehI3a.default), output = null;
    function area(data) {
        var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $jhh4j.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $7Gyiu.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $iFaTn.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $iFaTn.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});

parcelRegister("eI4IL", function(module, exports) {

$parcel$export(module.exports, "useVoronoiMesh", function () { return $ab58d6417e98cb70$export$a75177f2ff2023d0; });
$parcel$export(module.exports, "Mesh", function () { return $ab58d6417e98cb70$export$e176487c05830cc5; });
$parcel$export(module.exports, "renderVoronoiToCanvas", function () { return $ab58d6417e98cb70$export$bbd1eaf81b7812e8; });
$parcel$export(module.exports, "renderVoronoiCellToCanvas", function () { return $ab58d6417e98cb70$export$1392694608497cc; });

var $70fFQ = parcelRequire("70fFQ");

var $2qXGl = parcelRequire("2qXGl");

var $a8yvN = parcelRequire("a8yvN");

var $dIF9D = parcelRequire("dIF9D");

var $4x3bm = parcelRequire("4x3bm");
function $ab58d6417e98cb70$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab58d6417e98cb70$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ab58d6417e98cb70$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ab58d6417e98cb70$var$ownKeys(Object(source), true).forEach(function(key) {
            $ab58d6417e98cb70$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ab58d6417e98cb70$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ab58d6417e98cb70$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ab58d6417e98cb70$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ab58d6417e98cb70$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $ab58d6417e98cb70$export$10439206f18620b6 = {
    xDomain: [
        0,
        1
    ],
    yDomain: [
        0,
        1
    ],
    layers: [
        "links",
        "cells",
        "points",
        "bounds"
    ],
    enableLinks: false,
    linkLineWidth: 1,
    linkLineColor: "#bbbbbb",
    enableCells: true,
    cellLineWidth: 2,
    cellLineColor: "#000000",
    enablePoints: true,
    pointSize: 4,
    pointColor: "#666666",
    role: "img"
};
var $ab58d6417e98cb70$var$getAccessor = function getAccessor(directive) {
    return typeof directive === "function" ? directive : function(datum) {
        return datum[directive];
    };
};
var $ab58d6417e98cb70$export$b1152448cb844ea5 = function computeMeshPoints(_ref) {
    var points = _ref.points, _ref$x = _ref.x, x = _ref$x === void 0 ? "x" : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? "y" : _ref$y;
    var getX = $ab58d6417e98cb70$var$getAccessor(x);
    var getY = $ab58d6417e98cb70$var$getAccessor(y);
    return points.map(function(point) {
        return [
            getX(point),
            getY(point)
        ];
    });
};
var $ab58d6417e98cb70$export$886e4dd0d89461d3 = function computeMesh(_ref2) {
    var points = _ref2.points, width = _ref2.width, height = _ref2.height, debug = _ref2.debug;
    var delaunay = (0, $dIF9D.default).from(points);
    var voronoi = debug ? delaunay.voronoi([
        0,
        0,
        width,
        height
    ]) : undefined;
    return {
        delaunay: delaunay,
        voronoi: voronoi
    };
};
var $ab58d6417e98cb70$export$a75177f2ff2023d0 = function useVoronoiMesh(_ref) {
    var points = _ref.points, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height, debug = _ref.debug;
    var points2d = (0, $70fFQ.useMemo)(function() {
        return $ab58d6417e98cb70$export$b1152448cb844ea5({
            points: points,
            x: x,
            y: y
        });
    }, [
        points,
        x,
        y
    ]);
    return (0, $70fFQ.useMemo)(function() {
        return $ab58d6417e98cb70$export$886e4dd0d89461d3({
            points: points2d,
            width: width,
            height: height,
            debug: debug
        });
    }, [
        points2d,
        width,
        height,
        debug
    ]);
};
var $ab58d6417e98cb70$export$5c7fece0e156854e = function useVoronoi(_ref2) {
    var data = _ref2.data, width = _ref2.width, height = _ref2.height, xDomain = _ref2.xDomain, yDomain = _ref2.yDomain;
    var xScale = (0, $70fFQ.useMemo)(function() {
        return (0, $a8yvN.default)().domain(xDomain).range([
            0,
            width
        ]);
    }, [
        xDomain,
        width
    ]);
    var yScale = (0, $70fFQ.useMemo)(function() {
        return (0, $a8yvN.default)().domain(yDomain).range([
            0,
            height
        ]);
    }, [
        yDomain,
        height
    ]);
    var points = (0, $70fFQ.useMemo)(function() {
        return data.map(function(d) {
            return {
                x: xScale(d.x),
                y: yScale(d.y),
                data: d
            };
        });
    }, [
        data,
        xScale,
        yScale
    ]);
    return (0, $70fFQ.useMemo)(function() {
        var delaunay = (0, $dIF9D.default).from(points.map(function(p) {
            return [
                p.x,
                p.y
            ];
        }));
        var voronoi = delaunay.voronoi([
            0,
            0,
            width,
            height
        ]);
        return {
            points: points,
            delaunay: delaunay,
            voronoi: voronoi
        };
    }, [
        points,
        width,
        height
    ]);
};
var $ab58d6417e98cb70$export$365e60801398c8ef = function useVoronoiLayerContext(_ref3) {
    var points = _ref3.points, delaunay = _ref3.delaunay, voronoi = _ref3.voronoi;
    return (0, $70fFQ.useMemo)(function() {
        return {
            points: points,
            delaunay: delaunay,
            voronoi: voronoi
        };
    }, [
        points,
        delaunay,
        voronoi
    ]);
};
var $ab58d6417e98cb70$var$InnerVoronoi = function InnerVoronoi(_ref) {
    var data = _ref.data, width = _ref.width, height = _ref.height, partialMargin = _ref.margin, _ref$layers = _ref.layers, layers = _ref$layers === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.layers : _ref$layers, _ref$xDomain = _ref.xDomain, xDomain = _ref$xDomain === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.xDomain : _ref$xDomain, _ref$yDomain = _ref.yDomain, yDomain = _ref$yDomain === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.yDomain : _ref$yDomain, _ref$enableLinks = _ref.enableLinks, enableLinks = _ref$enableLinks === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.enableLinks : _ref$enableLinks, _ref$linkLineWidth = _ref.linkLineWidth, linkLineWidth = _ref$linkLineWidth === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.linkLineWidth : _ref$linkLineWidth, _ref$linkLineColor = _ref.linkLineColor, linkLineColor = _ref$linkLineColor === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.linkLineColor : _ref$linkLineColor, _ref$enableCells = _ref.enableCells, enableCells = _ref$enableCells === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.enableCells : _ref$enableCells, _ref$cellLineWidth = _ref.cellLineWidth, cellLineWidth = _ref$cellLineWidth === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.cellLineWidth : _ref$cellLineWidth, _ref$cellLineColor = _ref.cellLineColor, cellLineColor = _ref$cellLineColor === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.cellLineColor : _ref$cellLineColor, _ref$enablePoints = _ref.enablePoints, enablePoints = _ref$enablePoints === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.enableCells : _ref$enablePoints, _ref$pointSize = _ref.pointSize, pointSize = _ref$pointSize === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.pointSize : _ref$pointSize, _ref$pointColor = _ref.pointColor, pointColor = _ref$pointColor === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.pointColor : _ref$pointColor, _ref$role = _ref.role, role = _ref$role === void 0 ? $ab58d6417e98cb70$export$10439206f18620b6.role : _ref$role;
    var _useDimensions = (0, $2qXGl.useDimensions)(width, height, partialMargin), outerWidth = _useDimensions.outerWidth, outerHeight = _useDimensions.outerHeight, margin = _useDimensions.margin, innerWidth = _useDimensions.innerWidth, innerHeight = _useDimensions.innerHeight;
    var _useVoronoi = $ab58d6417e98cb70$export$5c7fece0e156854e({
        data: data,
        width: innerWidth,
        height: innerHeight,
        xDomain: xDomain,
        yDomain: yDomain
    }), points = _useVoronoi.points, delaunay = _useVoronoi.delaunay, voronoi = _useVoronoi.voronoi;
    var layerById = {
        links: null,
        cells: null,
        points: null,
        bounds: null
    };
    if (enableLinks && layers.includes("links")) layerById.links = (0, $4x3bm.jsx)("path", {
        stroke: linkLineColor,
        strokeWidth: linkLineWidth,
        fill: "none",
        d: delaunay.render()
    }, "links");
    if (enableCells && layers.includes("cells")) layerById.cells = (0, $4x3bm.jsx)("path", {
        d: voronoi.render(),
        fill: "none",
        stroke: cellLineColor,
        strokeWidth: cellLineWidth
    }, "cells");
    if (enablePoints && layers.includes("points")) layerById.points = (0, $4x3bm.jsx)("path", {
        stroke: "none",
        fill: pointColor,
        d: delaunay.renderPoints(undefined, pointSize / 2)
    }, "points");
    if (layers.includes("bounds")) layerById.bounds = (0, $4x3bm.jsx)("path", {
        fill: "none",
        stroke: cellLineColor,
        strokeWidth: cellLineWidth,
        d: voronoi.renderBounds()
    }, "bounds");
    var layerContext = $ab58d6417e98cb70$export$365e60801398c8ef({
        points: points,
        delaunay: delaunay,
        voronoi: voronoi
    });
    return (0, $4x3bm.jsx)((0, $2qXGl.SvgWrapper), {
        width: outerWidth,
        height: outerHeight,
        margin: margin,
        role: role,
        children: layers.map(function(layer, i) {
            if (layerById[layer] !== undefined) return layerById[layer];
            if (typeof layer === "function") return (0, $4x3bm.jsx)((0, $70fFQ.Fragment), {
                children: (0, $70fFQ.createElement)(layer, layerContext)
            }, i);
            return null;
        })
    });
};
var $ab58d6417e98cb70$export$20f0351992a349 = function Voronoi(_ref2) {
    var theme = _ref2.theme, otherProps = $ab58d6417e98cb70$var$_objectWithoutProperties(_ref2, [
        "theme"
    ]);
    return (0, $4x3bm.jsx)((0, $2qXGl.Container), {
        isInteractive: false,
        animate: false,
        theme: theme,
        children: (0, $4x3bm.jsx)($ab58d6417e98cb70$var$InnerVoronoi, $ab58d6417e98cb70$var$_objectSpread2({}, otherProps))
    });
};
var $ab58d6417e98cb70$export$5298a84d23fda932 = function ResponsiveVoronoi(props) {
    return (0, $4x3bm.jsx)((0, $2qXGl.ResponsiveWrapper), {
        children: function children(_ref) {
            var width = _ref.width, height = _ref.height;
            return (0, $4x3bm.jsx)($ab58d6417e98cb70$export$20f0351992a349, $ab58d6417e98cb70$var$_objectSpread2({
                width: width,
                height: height
            }, props));
        }
    });
};
function $ab58d6417e98cb70$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ab58d6417e98cb70$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ab58d6417e98cb70$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ab58d6417e98cb70$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ab58d6417e98cb70$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ab58d6417e98cb70$var$_arrayLikeToArray(o, minLen);
}
function $ab58d6417e98cb70$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ab58d6417e98cb70$var$_slicedToArray(arr, i) {
    return $ab58d6417e98cb70$var$_arrayWithHoles(arr) || $ab58d6417e98cb70$var$_iterableToArrayLimit(arr, i) || $ab58d6417e98cb70$var$_unsupportedIterableToArray(arr, i) || $ab58d6417e98cb70$var$_nonIterableRest();
}
var $ab58d6417e98cb70$export$e176487c05830cc5 = function Mesh(_ref) {
    var nodes = _ref.nodes, width = _ref.width, height = _ref.height, x = _ref.x, y = _ref.y, onMouseEnter = _ref.onMouseEnter, onMouseMove = _ref.onMouseMove, onMouseLeave = _ref.onMouseLeave, onClick = _ref.onClick, debug = _ref.debug;
    var elementRef = (0, $70fFQ.useRef)(null);
    var _useState = (0, $70fFQ.useState)(null), _useState2 = $ab58d6417e98cb70$var$_slicedToArray(_useState, 2), currentIndex = _useState2[0], setCurrentIndex = _useState2[1];
    var _useVoronoiMesh = $ab58d6417e98cb70$export$a75177f2ff2023d0({
        points: nodes,
        x: x,
        y: y,
        width: width,
        height: height,
        debug: debug
    }), delaunay = _useVoronoiMesh.delaunay, voronoi = _useVoronoiMesh.voronoi;
    var voronoiPath = (0, $70fFQ.useMemo)(function() {
        if (debug && voronoi) return voronoi.render();
        return undefined;
    }, [
        debug,
        voronoi
    ]);
    var getIndexAndNodeFromEvent = (0, $70fFQ.useCallback)(function(event) {
        if (!elementRef.current) return [
            null,
            null
        ];
        var _getRelativeCursor = (0, $2qXGl.getRelativeCursor)(elementRef.current, event), _getRelativeCursor2 = $ab58d6417e98cb70$var$_slicedToArray(_getRelativeCursor, 2), x = _getRelativeCursor2[0], y = _getRelativeCursor2[1];
        var index = delaunay.find(x, y);
        return [
            index,
            index !== undefined ? nodes[index] : null
        ];
    }, [
        elementRef,
        delaunay
    ]);
    var handleMouseEnter = (0, $70fFQ.useCallback)(function(event) {
        var _getIndexAndNodeFromE = getIndexAndNodeFromEvent(event), _getIndexAndNodeFromE2 = $ab58d6417e98cb70$var$_slicedToArray(_getIndexAndNodeFromE, 2), index = _getIndexAndNodeFromE2[0], node = _getIndexAndNodeFromE2[1];
        setCurrentIndex(index);
        if (node) onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter(node, event);
    }, [
        getIndexAndNodeFromEvent,
        setCurrentIndex,
        onMouseEnter
    ]);
    var handleMouseMove = (0, $70fFQ.useCallback)(function(event) {
        var _getIndexAndNodeFromE3 = getIndexAndNodeFromEvent(event), _getIndexAndNodeFromE4 = $ab58d6417e98cb70$var$_slicedToArray(_getIndexAndNodeFromE3, 2), index = _getIndexAndNodeFromE4[0], node = _getIndexAndNodeFromE4[1];
        setCurrentIndex(index);
        if (node) onMouseMove === null || onMouseMove === void 0 || onMouseMove(node, event);
    }, [
        getIndexAndNodeFromEvent,
        setCurrentIndex,
        onMouseMove
    ]);
    var handleMouseLeave = (0, $70fFQ.useCallback)(function(event) {
        setCurrentIndex(null);
        if (onMouseLeave) {
            var previousNode = undefined;
            if (currentIndex !== null) previousNode = nodes[currentIndex];
            previousNode && onMouseLeave(previousNode, event);
        }
    }, [
        setCurrentIndex,
        currentIndex,
        onMouseLeave,
        nodes
    ]);
    var handleClick = (0, $70fFQ.useCallback)(function(event) {
        var _getIndexAndNodeFromE5 = getIndexAndNodeFromEvent(event), _getIndexAndNodeFromE6 = $ab58d6417e98cb70$var$_slicedToArray(_getIndexAndNodeFromE5, 2), index = _getIndexAndNodeFromE6[0], node = _getIndexAndNodeFromE6[1];
        setCurrentIndex(index);
        if (node) onClick === null || onClick === void 0 || onClick(node, event);
    }, [
        getIndexAndNodeFromEvent,
        setCurrentIndex,
        onClick
    ]);
    return (0, $4x3bm.jsxs)("g", {
        ref: elementRef,
        children: [
            debug && voronoi && (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                children: [
                    (0, $4x3bm.jsx)("path", {
                        d: voronoiPath,
                        stroke: "red",
                        strokeWidth: 1,
                        opacity: 0.75
                    }),
                    currentIndex !== null && (0, $4x3bm.jsx)("path", {
                        fill: "pink",
                        opacity: 0.35,
                        d: voronoi.renderCell(currentIndex)
                    })
                ]
            }),
            (0, $4x3bm.jsx)("rect", {
                width: width,
                height: height,
                fill: "red",
                opacity: 0,
                style: {
                    cursor: "auto"
                },
                onMouseEnter: handleMouseEnter,
                onMouseMove: handleMouseMove,
                onMouseLeave: handleMouseLeave,
                onClick: handleClick
            })
        ]
    });
};
var $ab58d6417e98cb70$export$bbd1eaf81b7812e8 = function renderVoronoiToCanvas(ctx, voronoi) {
    ctx.save();
    ctx.globalAlpha = 0.75;
    ctx.beginPath();
    voronoi.render(ctx);
    ctx.strokeStyle = "red";
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.restore();
};
var $ab58d6417e98cb70$export$1392694608497cc = function renderVoronoiCellToCanvas(ctx, voronoi, index) {
    ctx.save();
    ctx.globalAlpha = 0.35;
    ctx.beginPath();
    voronoi.renderCell(index, ctx);
    ctx.fillStyle = "red";
    ctx.fill();
    ctx.restore();
};

});
parcelRegister("dIF9D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fcf4ecff97c5b93$export$2e2bcd8739ae039; });

var $cQV83 = parcelRequire("cQV83");

var $3QQuq = parcelRequire("3QQuq");

var $7EbP7 = parcelRequire("7EbP7");

var $hbW0a = parcelRequire("hbW0a");
const $9fcf4ecff97c5b93$var$tau = 2 * Math.PI, $9fcf4ecff97c5b93$var$pow = Math.pow;
function $9fcf4ecff97c5b93$var$pointX(p) {
    return p[0];
}
function $9fcf4ecff97c5b93$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $9fcf4ecff97c5b93$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $9fcf4ecff97c5b93$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $9fcf4ecff97c5b93$export$2e2bcd8739ae039 {
    static from(points, fx = $9fcf4ecff97c5b93$var$pointX, fy = $9fcf4ecff97c5b93$var$pointY, that) {
        return new $9fcf4ecff97c5b93$export$2e2bcd8739ae039("length" in points ? $9fcf4ecff97c5b93$var$flatArray(points, fx, fy, that) : Float64Array.from($9fcf4ecff97c5b93$var$flatIterable(points, fx, fy, that)));
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $9fcf4ecff97c5b93$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $9fcf4ecff97c5b93$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $cQV83.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            this.triangles[1] = hull[1];
            this.triangles[2] = hull[1];
            inedges[hull[0]] = 1;
            if (hull.length === 2) inedges[hull[1]] = 0;
        }
    }
    voronoi(bounds) {
        return new (0, $hbW0a.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $9fcf4ecff97c5b93$var$pow(x - points[i * 2], 2) + $9fcf4ecff97c5b93$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $9fcf4ecff97c5b93$var$pow(x - points[t * 2], 2) + $9fcf4ecff97c5b93$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($9fcf4ecff97c5b93$var$pow(x - points[e * 2], 2) + $9fcf4ecff97c5b93$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $3QQuq.default) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r = 2) {
        const buffer = context == null ? context = new (0, $3QQuq.default) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $9fcf4ecff97c5b93$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $3QQuq.default) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $7EbP7.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $3QQuq.default) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $7EbP7.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
    constructor(points){
        this._delaunator = new (0, $cQV83.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
}
function $9fcf4ecff97c5b93$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $9fcf4ecff97c5b93$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

});
parcelRegister("cQV83", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95b6a7fb9153c5d0$export$2e2bcd8739ae039; });
const $95b6a7fb9153c5d0$var$EPSILON = Math.pow(2, -52);
const $95b6a7fb9153c5d0$var$EDGE_STACK = new Uint32Array(512);
class $95b6a7fb9153c5d0$export$2e2bcd8739ae039 {
    static from(points, getX = $95b6a7fb9153c5d0$var$defaultGetX, getY = $95b6a7fb9153c5d0$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $95b6a7fb9153c5d0$export$2e2bcd8739ae039(coords);
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let minDist = Infinity;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0; i < n; i++){
            const d = $95b6a7fb9153c5d0$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        minDist = Infinity;
        // find the point closest to the seed
        for(let i = 0; i < n; i++){
            if (i === i0) continue;
            const d = $95b6a7fb9153c5d0$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $95b6a7fb9153c5d0$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $95b6a7fb9153c5d0$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ($95b6a7fb9153c5d0$var$orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $95b6a7fb9153c5d0$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $95b6a7fb9153c5d0$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $95b6a7fb9153c5d0$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $95b6a7fb9153c5d0$var$EPSILON && Math.abs(y - yp) <= $95b6a7fb9153c5d0$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], !$95b6a7fb9153c5d0$var$orient(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], $95b6a7fb9153c5d0$var$orient(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1])){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], $95b6a7fb9153c5d0$var$orient(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($95b6a7fb9153c5d0$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $95b6a7fb9153c5d0$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $95b6a7fb9153c5d0$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $95b6a7fb9153c5d0$var$EDGE_STACK.length) $95b6a7fb9153c5d0$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $95b6a7fb9153c5d0$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $95b6a7fb9153c5d0$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $95b6a7fb9153c5d0$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
// return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
function $95b6a7fb9153c5d0$var$orientIfSure(px, py, rx, ry, qx, qy) {
    const l = (ry - py) * (qx - px);
    const r = (rx - px) * (qy - py);
    return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
}
// a more robust orientation test that's stable in a given triangle (to fix robustness issues)
function $95b6a7fb9153c5d0$var$orient(rx, ry, qx, qy, px, py) {
    const sign = $95b6a7fb9153c5d0$var$orientIfSure(px, py, rx, ry, qx, qy) || $95b6a7fb9153c5d0$var$orientIfSure(rx, ry, qx, qy, px, py) || $95b6a7fb9153c5d0$var$orientIfSure(qx, qy, px, py, rx, ry);
    return sign < 0;
}
function $95b6a7fb9153c5d0$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $95b6a7fb9153c5d0$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $95b6a7fb9153c5d0$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $95b6a7fb9153c5d0$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $95b6a7fb9153c5d0$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $95b6a7fb9153c5d0$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $95b6a7fb9153c5d0$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $95b6a7fb9153c5d0$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $95b6a7fb9153c5d0$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $95b6a7fb9153c5d0$var$quicksort(ids, dists, i, right);
            $95b6a7fb9153c5d0$var$quicksort(ids, dists, left, j - 1);
        } else {
            $95b6a7fb9153c5d0$var$quicksort(ids, dists, left, j - 1);
            $95b6a7fb9153c5d0$var$quicksort(ids, dists, i, right);
        }
    }
}
function $95b6a7fb9153c5d0$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $95b6a7fb9153c5d0$var$defaultGetX(p) {
    return p[0];
}
function $95b6a7fb9153c5d0$var$defaultGetY(p) {
    return p[1];
}

});

parcelRegister("3QQuq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cdef1c5aaa449c3$export$2e2bcd8739ae039; });
const $2cdef1c5aaa449c3$var$epsilon = 1e-6;
class $2cdef1c5aaa449c3$export$2e2bcd8739ae039 {
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $2cdef1c5aaa449c3$var$epsilon || Math.abs(this._y1 - y0) > $2cdef1c5aaa449c3$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
}

});

parcelRegister("7EbP7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $591570be2476df19$export$2e2bcd8739ae039; });
class $591570be2476df19$export$2e2bcd8739ae039 {
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
    constructor(){
        this._ = [];
    }
}

});

parcelRegister("hbW0a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c84074a97949e52e$export$2e2bcd8739ae039; });

var $3QQuq = parcelRequire("3QQuq");

var $7EbP7 = parcelRequire("7EbP7");
class $c84074a97949e52e$export$2e2bcd8739ae039 {
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            const ab = (dx * ey - dy * ex) * 2;
            if (!ab) {
                // degenerate case (collinear diagram)
                x = (x1 + x3) / 2 - 1e8 * ey;
                y = (y1 + y3) / 2 + 1e8 * ex;
            } else if (Math.abs(ab) < 1e-8) {
                // almost equal points (degenerate triangle)
                x = (x1 + x3) / 2;
                y = (y1 + y3) / 2;
            } else {
                const d = 1 / ab;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $3QQuq.default) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $3QQuq.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $3QQuq.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $7EbP7.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        while(true){
            if (c0 === 0 && c1 === 0) return [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        if (P.length > 4) for(let i = 0; i < P.length; i += 2){
            const j = (i + 2) % P.length, k = (i + 4) % P.length;
            if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
}

});






parcelRegister("5H7Tw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4257179317f21c20$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $7xvOw = parcelRequire("7xvOw");
var $9chvy = parcelRequire("9chvy");
var $8OSnc = parcelRequire("8OSnc");
var $eEaJD = parcelRequire("eEaJD");
var $iuPCn = parcelRequire("iuPCn");
var $W7alG = parcelRequire("W7alG");
var $eS4JX = parcelRequire("eS4JX");
var $iHyg3 = parcelRequire("iHyg3");
var $27ZKj = parcelRequire("27ZKj");
function $4257179317f21c20$export$2e2bcd8739ae039({ address: address, name: name, relationship_to_owner: relationship_to_owner, company: company, phones: phones, emails: emails }) {
    const addressLink = `https://maps.google.com/?q=${address}`;
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $9chvy.default), {
        sx: {
            boxShadow: "none",
            borderRadius: 0,
            border: "1px solid #F0F0F0"
        },
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuPCn.default), {
                sx: {
                    title: {
                        fontSize: "1rem",
                        fontWeight: 700
                    },
                    subheader: {
                        fontSize: "0.875rem"
                    }
                },
                title: name,
                subheader: relationship_to_owner
            }),
            (company || address) && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eEaJD.default), {
                sx: {
                    paddingTop: 0
                },
                children: [
                    company && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                        variant: "body2",
                        dangerouslySetInnerHTML: {
                            __html: company
                        }
                    }),
                    address && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                        variant: "body2",
                        dangerouslySetInnerHTML: {
                            __html: address
                        }
                    })
                ]
            }),
            phones && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $W7alG.default), {
                disablePadding: true,
                dense: true,
                children: phones.map((phone)=>{
                    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $eS4JX.default), {
                        dense: true,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                            sx: {
                                margin: 0
                            },
                            primary: phone.phone,
                            secondary: phone.year ? /*#__PURE__*/ (0, $4x3bm.jsx)("time", {
                                dateTime: phone.year,
                                children: phone.year
                            }) : ""
                        })
                    }, phone.phone);
                })
            }),
            emails && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $W7alG.default), {
                disablePadding: true,
                dense: true,
                children: emails.map((email)=>{
                    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $eS4JX.default), {
                        dense: true,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                            sx: {
                                margin: 0
                            },
                            primary: email.email,
                            secondary: email.year ? /*#__PURE__*/ (0, $4x3bm.jsx)("time", {
                                dateTime: email.year,
                                children: email.year
                            }) : ""
                        })
                    }, email.email);
                })
            }),
            address && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8OSnc.default), {
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                    component: "a",
                    href: addressLink,
                    target: "_blank",
                    size: "small",
                    color: "primary",
                    children: "View on Google maps"
                })
            })
        ]
    });
}

});
parcelRegister("9chvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b22d0c3f6fb64e3$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $1mImZ = parcelRequire("1mImZ");

var $2rQqH = parcelRequire("2rQqH");

var $4x3bm = parcelRequire("4x3bm");
const $6b22d0c3f6fb64e3$var$_excluded = [
    "className",
    "raised"
];
const $6b22d0c3f6fb64e3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $2rQqH.getCardUtilityClass), classes);
};
const $6b22d0c3f6fb64e3$var$CardRoot = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $6b22d0c3f6fb64e3$var$Card = /*#__PURE__*/ $70fFQ.forwardRef(function Card(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $79yYo.default)(props, $6b22d0c3f6fb64e3$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        raised: raised
    });
    const classes = $6b22d0c3f6fb64e3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($6b22d0c3f6fb64e3$var$CardRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $6b22d0c3f6fb64e3$export$2e2bcd8739ae039 = $6b22d0c3f6fb64e3$var$Card;

});
parcelRegister("2rQqH", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", function () { return $1c86c5cf62d65c4b$export$f3b76d2cce458caa; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $1c86c5cf62d65c4b$export$f3b76d2cce458caa(slot) {
    return (0, $dtsUs.default)("MuiCard", slot);
}
const $1c86c5cf62d65c4b$var$cardClasses = (0, $jLqVN.default)("MuiCard", [
    "root"
]);
var $1c86c5cf62d65c4b$export$2e2bcd8739ae039 = $1c86c5cf62d65c4b$var$cardClasses;

});


parcelRegister("8OSnc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66bd2b9dda4284a0$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $9CU86 = parcelRequire("9CU86");

var $4x3bm = parcelRequire("4x3bm");
const $66bd2b9dda4284a0$var$_excluded = [
    "disableSpacing",
    "className"
];
const $66bd2b9dda4284a0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $9CU86.getCardActionsUtilityClass), classes);
};
const $66bd2b9dda4284a0$var$CardActionsRoot = (0, $71Pr4.default)("div", {
    name: "MuiCardActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        alignItems: "center",
        padding: 8
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $66bd2b9dda4284a0$var$CardActions = /*#__PURE__*/ $70fFQ.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCardActions"
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $79yYo.default)(props, $66bd2b9dda4284a0$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $66bd2b9dda4284a0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($66bd2b9dda4284a0$var$CardActionsRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $66bd2b9dda4284a0$export$2e2bcd8739ae039 = $66bd2b9dda4284a0$var$CardActions;

});
parcelRegister("9CU86", function(module, exports) {

$parcel$export(module.exports, "getCardActionsUtilityClass", function () { return $702333daf0f08e74$export$2a5c27c211442e3c; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $702333daf0f08e74$export$2a5c27c211442e3c(slot) {
    return (0, $dtsUs.default)("MuiCardActions", slot);
}
const $702333daf0f08e74$var$cardActionsClasses = (0, $jLqVN.default)("MuiCardActions", [
    "root",
    "spacing"
]);
var $702333daf0f08e74$export$2e2bcd8739ae039 = $702333daf0f08e74$var$cardActionsClasses;

});


parcelRegister("eEaJD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa9d20ddef3dc465$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $aiH7U = parcelRequire("aiH7U");

var $4x3bm = parcelRequire("4x3bm");
const $aa9d20ddef3dc465$var$_excluded = [
    "className",
    "component"
];
const $aa9d20ddef3dc465$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $aiH7U.getCardContentUtilityClass), classes);
};
const $aa9d20ddef3dc465$var$CardContentRoot = (0, $71Pr4.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $aa9d20ddef3dc465$var$CardContent = /*#__PURE__*/ $70fFQ.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $79yYo.default)(props, $aa9d20ddef3dc465$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component
    });
    const classes = $aa9d20ddef3dc465$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($aa9d20ddef3dc465$var$CardContentRoot, (0, $20MOv.default)({
        as: component,
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $aa9d20ddef3dc465$export$2e2bcd8739ae039 = $aa9d20ddef3dc465$var$CardContent;

});
parcelRegister("aiH7U", function(module, exports) {

$parcel$export(module.exports, "getCardContentUtilityClass", function () { return $77fd09de0cb4a468$export$964336739a8c7119; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $77fd09de0cb4a468$export$964336739a8c7119(slot) {
    return (0, $dtsUs.default)("MuiCardContent", slot);
}
const $77fd09de0cb4a468$var$cardContentClasses = (0, $jLqVN.default)("MuiCardContent", [
    "root"
]);
var $77fd09de0cb4a468$export$2e2bcd8739ae039 = $77fd09de0cb4a468$var$cardContentClasses;

});


parcelRegister("iuPCn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7731193748c006f$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $27ZKj = parcelRequire("27ZKj");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $k9Z0P = parcelRequire("k9Z0P");

var $4x3bm = parcelRequire("4x3bm");
const $d7731193748c006f$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $d7731193748c006f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ],
        action: [
            "action"
        ],
        content: [
            "content"
        ],
        title: [
            "title"
        ],
        subheader: [
            "subheader"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $k9Z0P.getCardHeaderUtilityClass), classes);
};
const $d7731193748c006f$var$CardHeaderRoot = (0, $71Pr4.default)("div", {
    name: "MuiCardHeader",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, $20MOv.default)({
            [`& .${(0, $k9Z0P.default).title}`]: styles.title,
            [`& .${(0, $k9Z0P.default).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: "flex",
    alignItems: "center",
    padding: 16
});
const $d7731193748c006f$var$CardHeaderAvatar = (0, $71Pr4.default)("div", {
    name: "MuiCardHeader",
    slot: "Avatar",
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: "flex",
    flex: "0 0 auto",
    marginRight: 16
});
const $d7731193748c006f$var$CardHeaderAction = (0, $71Pr4.default)("div", {
    name: "MuiCardHeader",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $d7731193748c006f$var$CardHeaderContent = (0, $71Pr4.default)("div", {
    name: "MuiCardHeader",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    flex: "1 1 auto"
});
const $d7731193748c006f$var$CardHeader = /*#__PURE__*/ $70fFQ.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCardHeader"
    });
    const { action: action, avatar: avatar, className: className, component: component = "div", disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $79yYo.default)(props, $d7731193748c006f$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $d7731193748c006f$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $27ZKj.default) && !disableTypography) title = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), (0, $20MOv.default)({
        variant: avatar ? "body2" : "h5",
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $27ZKj.default) && !disableTypography) subheader = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), (0, $20MOv.default)({
        variant: avatar ? "body2" : "body1",
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($d7731193748c006f$var$CardHeaderRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $4x3bm.jsx)($d7731193748c006f$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)($d7731193748c006f$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $4x3bm.jsx)($d7731193748c006f$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $d7731193748c006f$export$2e2bcd8739ae039 = $d7731193748c006f$var$CardHeader;

});
parcelRegister("k9Z0P", function(module, exports) {

$parcel$export(module.exports, "getCardHeaderUtilityClass", function () { return $ead3f9acaba78c7a$export$f54c8b0d04b67946; });
$parcel$export(module.exports, "default", function () { return $ead3f9acaba78c7a$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $ead3f9acaba78c7a$export$f54c8b0d04b67946(slot) {
    return (0, $dtsUs.default)("MuiCardHeader", slot);
}
const $ead3f9acaba78c7a$var$cardHeaderClasses = (0, $jLqVN.default)("MuiCardHeader", [
    "root",
    "avatar",
    "action",
    "content",
    "title",
    "subheader"
]);
var $ead3f9acaba78c7a$export$2e2bcd8739ae039 = $ead3f9acaba78c7a$var$cardHeaderClasses;

});


parcelRegister("eS4JX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad39c9205b0134a2$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $gZaTl = parcelRequire("gZaTl");
var $8dWxZ = parcelRequire("8dWxZ");


var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $eGmvM = parcelRequire("eGmvM");

var $6ATFq = parcelRequire("6ATFq");

var $7kxc8 = parcelRequire("7kxc8");

var $5Up1l = parcelRequire("5Up1l");

var $jgeht = parcelRequire("jgeht");

var $4br0Q = parcelRequire("4br0Q");

var $c9pu5 = parcelRequire("c9pu5");

var $2Z3Gv = parcelRequire("2Z3Gv");

var $4x3bm = parcelRequire("4x3bm");
const $ad39c9205b0134a2$var$_excluded = [
    "className"
], $ad39c9205b0134a2$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected"
];
const $ad39c9205b0134a2$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $ad39c9205b0134a2$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $4br0Q.getListItemUtilityClass), classes);
};
const $ad39c9205b0134a2$export$aed538f7519abe89 = (0, $71Pr4.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $ad39c9205b0134a2$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $20MOv.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $c9pu5.default).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $4br0Q.default).focusVisible}`]: {
            backgroundColor: theme.palette.action.focus
        },
        [`&.${(0, $4br0Q.default).selected}`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $4br0Q.default).focusVisible}`]: {
                backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $4br0Q.default).disabled}`]: {
            opacity: theme.palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: theme.palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $4br0Q.default).selected}:hover`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $ad39c9205b0134a2$var$ListItemContainer = (0, $71Pr4.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $ad39c9205b0134a2$var$ListItem = /*#__PURE__*/ $70fFQ.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false } = props, ContainerProps = (0, $79yYo.default)(props.ContainerProps, $ad39c9205b0134a2$var$_excluded), other = (0, $79yYo.default)(props, $ad39c9205b0134a2$var$_excluded2);
    const context = $70fFQ.useContext((0, $jgeht.default));
    const childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems,
        disableGutters: disableGutters
    };
    const listItemRef = $70fFQ.useRef(null);
    (0, $7kxc8.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $70fFQ.Children.toArray(childrenProp); // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $6ATFq.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $20MOv.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $ad39c9205b0134a2$var$useUtilityClasses(ownerState);
    const handleRef = (0, $5Up1l.default)(listItemRef, ref);
    const Root = components.Root || $ad39c9205b0134a2$export$aed538f7519abe89;
    const rootProps = componentsProps.root || {};
    const componentProps = (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $gjktY.default)((0, $4br0Q.default).focusVisible, focusVisibleClassName);
        Component = (0, $eGmvM.default);
    } // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jgeht.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $4x3bm.jsxs)($ad39c9205b0134a2$var$ListItemContainer, (0, $20MOv.default)({
                as: ContainerComponent,
                className: (0, $gjktY.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)(Root, (0, $20MOv.default)({}, rootProps, !(0, $gZaTl.default)(Root) && {
                        as: Component,
                        ownerState: (0, $20MOv.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jgeht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)(Root, (0, $20MOv.default)({}, rootProps, {
            as: Component,
            ref: handleRef,
            ownerState: ownerState
        }, !(0, $gZaTl.default)(Root) && {
            ownerState: (0, $20MOv.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Z3Gv.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $ad39c9205b0134a2$export$2e2bcd8739ae039 = $ad39c9205b0134a2$var$ListItem;

});
parcelRegister("4br0Q", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", function () { return $30bd24a91e7e7f2f$export$5682c366c0c669d9; });
$parcel$export(module.exports, "default", function () { return $30bd24a91e7e7f2f$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $30bd24a91e7e7f2f$export$5682c366c0c669d9(slot) {
    return (0, $dtsUs.default)("MuiListItem", slot);
}
const $30bd24a91e7e7f2f$var$listItemClasses = (0, $jLqVN.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $30bd24a91e7e7f2f$export$2e2bcd8739ae039 = $30bd24a91e7e7f2f$var$listItemClasses;

});

parcelRegister("c9pu5", function(module, exports) {

$parcel$export(module.exports, "getListItemButtonUtilityClass", function () { return $8d8a17f61f4960d8$export$c09531d8563c67a5; });
$parcel$export(module.exports, "default", function () { return $8d8a17f61f4960d8$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $8d8a17f61f4960d8$export$c09531d8563c67a5(slot) {
    return (0, $dtsUs.default)("MuiListItemButton", slot);
}
const $8d8a17f61f4960d8$var$listItemButtonClasses = (0, $jLqVN.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $8d8a17f61f4960d8$export$2e2bcd8739ae039 = $8d8a17f61f4960d8$var$listItemButtonClasses;

});

parcelRegister("2Z3Gv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22c422f80c0449ff$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $jgeht = parcelRequire("jgeht");

var $8nwqL = parcelRequire("8nwqL");

var $4x3bm = parcelRequire("4x3bm");
const $22c422f80c0449ff$var$_excluded = [
    "className"
];
const $22c422f80c0449ff$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $8nwqL.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $22c422f80c0449ff$var$ListItemSecondaryActionRoot = (0, $71Pr4.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $22c422f80c0449ff$var$ListItemSecondaryAction = /*#__PURE__*/ $70fFQ.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $79yYo.default)(props, $22c422f80c0449ff$var$_excluded);
    const context = $70fFQ.useContext((0, $jgeht.default));
    const ownerState = (0, $20MOv.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $22c422f80c0449ff$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($22c422f80c0449ff$var$ListItemSecondaryActionRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$22c422f80c0449ff$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $22c422f80c0449ff$export$2e2bcd8739ae039 = $22c422f80c0449ff$var$ListItemSecondaryAction;

});
parcelRegister("8nwqL", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", function () { return $6199a0cab5e330e8$export$ccdb26aeba48a86e; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $6199a0cab5e330e8$export$ccdb26aeba48a86e(slot) {
    return (0, $dtsUs.default)("MuiListItemSecondaryAction", slot);
}
const $6199a0cab5e330e8$var$listItemSecondaryActionClasses = (0, $jLqVN.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $6199a0cab5e330e8$export$2e2bcd8739ae039 = $6199a0cab5e330e8$var$listItemSecondaryActionClasses;

});



parcelRegister("iHyg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9d6d11251c6ecb1$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $27ZKj = parcelRequire("27ZKj");

var $jgeht = parcelRequire("jgeht");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $c7ir8 = parcelRequire("c7ir8");

var $4x3bm = parcelRequire("4x3bm");
const $d9d6d11251c6ecb1$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $d9d6d11251c6ecb1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $c7ir8.getListItemTextUtilityClass), classes);
};
const $d9d6d11251c6ecb1$var$ListItemTextRoot = (0, $71Pr4.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c7ir8.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $c7ir8.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $d9d6d11251c6ecb1$var$ListItemText = /*#__PURE__*/ $70fFQ.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $79yYo.default)(props, $d9d6d11251c6ecb1$var$_excluded);
    const { dense: dense } = $70fFQ.useContext((0, $jgeht.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $20MOv.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $d9d6d11251c6ecb1$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $27ZKj.default) && !disableTypography) primary = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), (0, $20MOv.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $27ZKj.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), (0, $20MOv.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($d9d6d11251c6ecb1$var$ListItemTextRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $d9d6d11251c6ecb1$export$2e2bcd8739ae039 = $d9d6d11251c6ecb1$var$ListItemText;

});


parcelRegister("jQZSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e742e044b926f7f3$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $7xvOw = parcelRequire("7xvOw");
var $9chvy = parcelRequire("9chvy");
var $8OSnc = parcelRequire("8OSnc");
var $eEaJD = parcelRequire("eEaJD");
var $iuPCn = parcelRequire("iuPCn");
var $W7alG = parcelRequire("W7alG");
var $eS4JX = parcelRequire("eS4JX");
var $iHyg3 = parcelRequire("iHyg3");
var $27ZKj = parcelRequire("27ZKj");
function $e742e044b926f7f3$export$2e2bcd8739ae039({ name: name, website: website, phone: phone, opening_hours: opening_hours }) {
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $9chvy.default), {
        sx: {
            boxShadow: "none",
            borderRadius: 0,
            border: "1px solid #F0F0F0"
        },
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuPCn.default), {
                sx: {
                    title: {
                        fontSize: "1rem",
                        fontWeight: 700
                    }
                },
                title: name
            }),
            (website || phone) && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eEaJD.default), {
                xs: {
                    paddingTop: 0
                },
                children: [
                    website && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                        variant: "body2",
                        children: `Website: ${website}`
                    }),
                    phone && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                        variant: "body2",
                        children: `Phone: ${phone}`
                    })
                ]
            }),
            opening_hours && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $W7alG.default), {
                disablePadding: true,
                dense: true,
                children: opening_hours.map((hour)=>{
                    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $eS4JX.default), {
                        dense: true,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                            sx: {
                                margin: 0
                            },
                            primary: hour
                        })
                    }, hour);
                })
            }),
            (website || phone) && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8OSnc.default), {
                children: [
                    website && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        component: "a",
                        href: website,
                        target: "_blank",
                        size: "small",
                        color: "primary",
                        children: "Visit website"
                    }),
                    phone && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        component: "a",
                        href: `tel:${phone}`,
                        size: "small",
                        color: "primary",
                        children: `Call ${phone}`
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("93Bu5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $698178731305dddb$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $dih0O = parcelRequire("dih0O");

var $7yu4D = parcelRequire("7yu4D");
function $698178731305dddb$export$2e2bcd8739ae039({ address: address, buildingId: buildingId, centroid: centroid, power_line: power_line }) {
    const history = (0, $dih0O.useHistory)();
    const map = (0, $70fFQ.useRef)(null);
    (0, $70fFQ.useEffect)(()=>{
        if (power_line) {
            const powerlineMap = new google.maps.Map(map.current, {
                center: {
                    lat: centroid.lat,
                    lng: centroid.lon
                },
                disableDefaultUI: true,
                fullscreenControl: true,
                gestureHandling: "cooperative",
                styles: (0, $7yu4D.powerlineMapStyles),
                zoom: 18,
                zoomControl: true
            });
            const fitBounds = ()=>{
                const bounds = new google.maps.LatLngBounds().extend({
                    lat: centroid.lat,
                    lng: centroid.lon
                });
                if (power_line.power_line_closest_point) bounds.extend({
                    lat: power_line.power_line_closest_point[1],
                    lng: power_line.power_line_closest_point[0]
                });
                powerlineMap.fitBounds(bounds);
            };
            fitBounds();
            powerlineMap.data.addGeoJson({
                type: "Feature",
                geometry: power_line.power_line_geometry,
                properties: {
                    id: power_line.power_line_id,
                    type: "powerline"
                }
            });
            if (power_line.power_plant_geometry) powerlineMap.data.addGeoJson({
                type: "Feature",
                geometry: power_line.power_plant_geometry,
                properties: {
                    type: "powerplant"
                }
            });
            const icon = {
                path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
                fillColor: "#55b045",
                fillOpacity: 0.9,
                anchor: new google.maps.Point(0, 0),
                labelOrigin: new google.maps.Point(0, 50),
                strokeWeight: 0,
                scale: 0.3
            };
            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(centroid.lat, centroid.lon),
                map: powerlineMap,
                icon: icon,
                zIndex: 50,
                optimized: false,
                id: buildingId,
                label: {
                    color: "#333",
                    fontWeight: "bold",
                    fontSize: "9px",
                    text: address
                },
                labelOrigin: new google.maps.Point(29, 9)
            });
            marker.isClicked = false;
            marker.addListener("click", ()=>{
                if (marker.isClicked) fitBounds();
                else {
                    powerlineMap.setCenter({
                        lat: centroid.lat,
                        lng: centroid.lon
                    });
                    powerlineMap.setZoom(19);
                }
                marker.isClicked = !marker.isClicked;
            });
            powerlineMap.data.addListener("click", (event)=>{
                const { feature: feature } = event;
                const id = feature.getProperty("id");
                history.push(`/details/${id}`);
            });
            powerlineMap.data.addListener("mouseover", (event)=>{
                const { feature: feature } = event;
                const type = feature.getProperty("type");
                if (type === "building") powerlineMap.data.overrideStyle(feature, {
                    fillOpacity: 0.8
                });
            });
            powerlineMap.data.addListener("mouseout", ()=>{
                powerlineMap.data.revertStyle();
            });
            if (power_line.power_line_closest_point) {
                const powerlineMarker = new google.maps.Marker({
                    position: {
                        lat: power_line.power_line_closest_point[1],
                        lng: power_line.power_line_closest_point[0]
                    },
                    map: powerlineMap,
                    icon: icon,
                    zIndex: 50,
                    optimized: false,
                    id: buildingId,
                    label: {
                        color: "#333",
                        fontWeight: "bold",
                        fontSize: "9px",
                        text: "Nearest Powerline"
                    },
                    labelOrigin: new google.maps.Point(29, 9)
                });
                powerlineMarker.isClicked = false;
                powerlineMarker.addListener("click", ()=>{
                    if (marker.isClicked) fitBounds();
                    else {
                        powerlineMap.setCenter({
                            lat: power_line.power_line_closest_point[1],
                            lng: power_line.power_line_closest_point[0]
                        });
                        powerlineMap.setZoom(19);
                    }
                    marker.isClicked = !marker.isClicked;
                });
            }
            powerlineMap.data.setStyle((feature)=>{
                const id = feature.getProperty("id");
                const type = feature.getProperty("type");
                const subType = feature.getProperty("sub_type");
                const style = {
                    fillColor: "#DDD",
                    strokeWeight: 0,
                    fillOpacity: 0.3,
                    strokeOpacity: 0.3,
                    clickable: true
                };
                if (id === buildingId) {
                    style.fillColor = "#00A3FF";
                    style.fillOpacity = 0.6;
                }
                if (type === "powerplant") {
                    style.fillColor = "#0070FF";
                    style.fillOpacity = 1;
                }
                if (type === "powerline") {
                    style.strokeColor = "#04D747";
                    style.fillOpacity = 1;
                    style.strokeWeight = 1;
                    style.fillColor = "#04D747";
                    style.strokeColor = "#04D747";
                    style.isClickable = false;
                    style.cursor = "initial";
                    style.fillOpacity = 0;
                    style.strokeOpacity = 0.6;
                    style.strokeWeight = 2;
                    if (id === power_line.power_line_id) style.strokeOpacity = 1;
                    if (subType === "minor_line") style.strokeWeight = 1;
                }
                return style;
            });
        }
    }, [
        address,
        buildingId,
        centroid,
        power_line
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        className: "details-map-container",
        children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
            ref: map,
            style: {
                height: "250px",
                width: "100%"
            }
        })
    });
}

});
parcelRegister("7yu4D", function(module, exports) {

$parcel$export(module.exports, "powerlineMapStyles", function () { return $58030960cf0c8aa4$export$142e8ce0184e518a; });
const $58030960cf0c8aa4$export$a43af521ac8c3202 = [
    {
        elementType: "labels.text",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "landscape.natural",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#f5f5f2"
            },
            {
                visibility: "on"
            }
        ]
    },
    {
        featureType: "administrative",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "transit",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi.business",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                visibility: "on"
            }
        ]
    },
    {
        featureType: "poi.business",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi.medical",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi.place_of_worship",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi.school",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi.sports_complex",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                visibility: "simplified"
            }
        ]
    },
    {
        featureType: "road.arterial",
        stylers: [
            {
                visibility: "simplified"
            },
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "labels.icon",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road.arterial",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "road.local",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "water",
        stylers: [
            {
                color: "#71c8d4"
            }
        ]
    },
    {
        featureType: "landscape",
        stylers: [
            {
                color: "#e5e8e7"
            }
        ]
    },
    {
        featureType: "poi.park",
        stylers: [
            {
                color: "#8ba129"
            }
        ]
    },
    {
        featureType: "road",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "poi.sports_complex",
        elementType: "geometry",
        stylers: [
            {
                color: "#c7c7c7"
            },
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "water",
        stylers: [
            {
                color: "#a0d3d3"
            }
        ]
    },
    {
        featureType: "poi.park",
        stylers: [
            {
                color: "#91b65d"
            }
        ]
    },
    {
        featureType: "poi.park",
        stylers: [
            {
                gamma: 1.51
            }
        ]
    },
    {
        featureType: "road.local",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                visibility: "on"
            }
        ]
    },
    {
        featureType: "poi.government",
        elementType: "geometry",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "landscape",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            {
                visibility: "simplified"
            }
        ]
    },
    {
        featureType: "road.local",
        stylers: [
            {
                visibility: "simplified"
            }
        ]
    },
    {
        featureType: "road"
    },
    {
        featureType: "road"
    },
    {},
    {
        featureType: "road.highway"
    }
];
const $58030960cf0c8aa4$export$55ce6f3a06c59543 = [
    {
        featureType: "all",
        stylers: [
            {
                color: "#505050"
            }
        ]
    },
    {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
            {
                saturation: 36
            },
            {
                color: "#000000"
            },
            {
                lightness: 40
            }
        ]
    },
    {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "on"
            },
            {
                color: "#000000"
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 17
            },
            {
                weight: 1.2
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.country",
        elementType: "all",
        stylers: [
            {
                visibility: "simplified"
            }
        ]
    },
    {
        featureType: "administrative.country",
        elementType: "geometry",
        stylers: [
            {
                visibility: "simplified"
            }
        ]
    },
    {
        featureType: "administrative.country",
        elementType: "labels.text",
        stylers: [
            {
                visibility: "simplified"
            }
        ]
    },
    {
        featureType: "administrative.province",
        elementType: "all",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.locality",
        elementType: "all",
        stylers: [
            {
                visibility: "simplified"
            },
            {
                saturation: "-100"
            },
            {
                lightness: "30"
            }
        ]
    },
    {
        featureType: "administrative.neighborhood",
        elementType: "all",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.land_parcel",
        elementType: "all",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "landscape",
        elementType: "all",
        stylers: [
            {
                visibility: "simplified"
            },
            {
                gamma: "0.00"
            },
            {
                lightness: "74"
            }
        ]
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: "landscape.man_made",
        elementType: "all",
        stylers: [
            {
                lightness: "3"
            }
        ]
    },
    {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "all",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 21
            }
        ]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [
            {
                visibility: "simplified"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 17
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 29
            },
            {
                weight: 0.2
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 18
            }
        ]
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 19
            }
        ]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 17
            }
        ]
    }
];
const $58030960cf0c8aa4$export$35dd8ce50f1c31e0 = [
    {
        elementType: "geometry",
        stylers: [
            {
                color: "#1d2c4d"
            }
        ]
    },
    {
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#8ec3b9"
            }
        ]
    },
    {
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#1a3646"
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.country",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#4b6878"
            }
        ]
    },
    {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#64779e"
            }
        ]
    },
    {
        featureType: "administrative.province",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#4b6878"
            }
        ]
    },
    {
        featureType: "landscape.man_made",
        elementType: "geometry.stroke",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "landscape.natural",
        elementType: "geometry",
        stylers: [
            {
                color: "#023e58"
            }
        ]
    },
    {
        featureType: "poi",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#283d6a"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#6f9ba5"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#1d2c4d"
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#023e58"
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#3C7680"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [
            {
                color: "#304a7d"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#98a5be"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#1d2c4d"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
            {
                color: "#2c6675"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#255763"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#b0d5ce"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#023e58"
            }
        ]
    },
    {
        featureType: "transit",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "transit",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#98a5be"
            }
        ]
    },
    {
        featureType: "transit",
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#1d2c4d"
            }
        ]
    },
    {
        featureType: "transit.line",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#283d6a"
            }
        ]
    },
    {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [
            {
                color: "#3a4762"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#0e1626"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#4e6d70"
            }
        ]
    },
    {
        featureType: "landscape.man_made",
        elementType: "labels.text",
        stylers: [
            {
                visibility: "off"
            }
        ]
    }
];
const $58030960cf0c8aa4$export$142e8ce0184e518a = [
    {
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.land_parcel",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.neighborhood",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "landscape.man_made",
        elementType: "geometry",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        stylers: [
            {
                visibility: "on"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels",
        stylers: [
            {
                visibility: "on"
            }
        ]
    },
    {
        featureType: "transit",
        stylers: [
            {
                visibility: "off"
            },
            {
                color: "#FFF"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                color: "#F6F6F6"
            }
        ]
    }
];
const $58030960cf0c8aa4$export$10c083462c34aef3 = [
    {
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.land_parcel",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "administrative.neighborhood",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "landscape.man_made",
        elementType: "geometry",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "poi",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "transit",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                color: "#F6F6F6"
            }
        ]
    }
];
const $58030960cf0c8aa4$export$2cf0ade8bd62135d = [
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#e9e9e9"
            },
            {
                lightness: 17
            }
        ]
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                color: "#f5f5f5"
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 17
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 29
            },
            {
                weight: 0.2
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 18
            }
        ]
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#f5f5f5"
            },
            {
                lightness: 21
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
            {
                color: "#dedede"
            },
            {
                lightness: 21
            }
        ]
    },
    {
        elementType: "labels.text.stroke",
        stylers: [
            {
                visibility: "on"
            },
            {
                color: "#ffffff"
            },
            {
                lightness: 16
            }
        ]
    },
    {
        elementType: "labels.text.fill",
        stylers: [
            {
                saturation: 36
            },
            {
                color: "#333333"
            },
            {
                lightness: 40
            }
        ]
    },
    {
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
            {
                color: "#f2f2f2"
            },
            {
                lightness: 19
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#fefefe"
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#fefefe"
            },
            {
                lightness: 17
            },
            {
                weight: 1.2
            }
        ]
    }
];

});


parcelRegister("jxLxf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a5f8e9f3ad41d7$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $bDcYY = parcelRequire("bDcYY");
var $7xvOw = parcelRequire("7xvOw");
var $8VJ2N = parcelRequire("8VJ2N");

var $i11qA = parcelRequire("i11qA");
var $6TeSR = parcelRequire("6TeSR");
var $lC6sU = parcelRequire("lC6sU");
var $eIrE0 = parcelRequire("eIrE0");
var $hzgLN = parcelRequire("hzgLN");

var $dih0O = parcelRequire("dih0O");

var $ht0W2 = parcelRequire("ht0W2");

var $iWaGk = parcelRequire("iWaGk");

var $fJ9i4 = parcelRequire("fJ9i4");

var $ezukV = parcelRequire("ezukV");

var $5tCXN = parcelRequire("5tCXN");

var $etOpj = parcelRequire("etOpj");

var $k8aZE = parcelRequire("k8aZE");

var $hsiY7 = parcelRequire("hsiY7");

var $bNddL = parcelRequire("bNddL");

var $b7VhJ = parcelRequire("b7VhJ");

var $dKmHy = parcelRequire("dKmHy");


var $baN65 = parcelRequire("baN65");
const $e3a5f8e9f3ad41d7$var$Financials = ({ disablePadding: disablePadding = false, buildingId: buildingId, projectId: projectId, isVendor: isVendor = false, isAdmin: isAdmin = false })=>{
    var _buildingStore_financials, _buildingStore_financials1;
    const history = (0, $dih0O.useHistory)();
    const { buildingStore: buildingStore, projectDetailStore: projectDetailStore, buildingDetailStore: buildingDetailStore, userStore: userStore } = (0, $iWaGk.default)();
    const store = buildingId ? buildingDetailStore : projectDetailStore;
    const [, setFormattedRates] = (0, $70fFQ.useState)(null);
    const [PPAMode] = (0, $70fFQ.useState)("customer");
    const [quickMenuAnchor, setQuickMenuAnchor] = (0, $70fFQ.useState)(null);
    const building = buildingStore.buildings.get(buildingId);
    const isProjectHome = projectId && !buildingId;
    let financialData = isProjectHome ? (_buildingStore_financials = buildingStore.financials) === null || _buildingStore_financials === void 0 ? void 0 : _buildingStore_financials.financials : store.formattedFinancials;
    const { financialMode: financialMode } = buildingDetailStore;
    if (buildingId && financialMode === "ppa") financialData = buildingDetailStore.formattedFinancialsPPA;
    const formattedFinancialsPPA = buildingId ? buildingDetailStore.formattedFinancialsPPA : null;
    const ppaData = formattedFinancialsPPA ? [
        {
            field: "ppa_kwh_rate",
            category: "customer"
        },
        {
            field: "total_1st_year_net_revenue",
            category: "customer"
        },
        /*
    {
      label: 'Lifetime Savings',
      field: 'ppa_20_year_savings_to_customer',
      category: 'customer'
    },
    {
      label: 'Rate Discount',
      field: '',
      category: 'customer'
    },
    */ {
            field: "total_gross_project_cost",
            category: "owner"
        },
        {
            field: "payback_period",
            category: "owner"
        },
        {
            field: "IRR",
            category: "owner"
        },
        {
            field: "total_1st_year_net_revenue",
            category: "owner"
        },
        {
            field: "total_30_year_net_revenue",
            category: "owner"
        }
    ].map((item)=>{
        const data = formattedFinancialsPPA.find((e)=>e.id === item.field);
        if (data) return (0, $edHbI._)((0, $2QP2i._)({}, data), {
            category: item.category
        });
        return null;
    }).filter((e)=>e) : null;
    const energyGenerationData = buildingDetailStore.formattedFinancials.filter((item)=>[
            "solar_potential_gen_y1",
            "fuel_cell_potential_gen_y1",
            "chp_potential_gen_y1",
            "year_1_generation"
        ].includes(item.id));
    const financialsLoading = isProjectHome && ((_buildingStore_financials1 = buildingStore.financials) === null || _buildingStore_financials1 === void 0 ? void 0 : _buildingStore_financials1.financials_loading);
    const emissionsData = isProjectHome ? buildingStore === null || buildingStore === void 0 ? void 0 : buildingStore.emissions : store.emissionsData;
    let { cashFlow: cashFlowData } = store;
    if (buildingId && financialMode === "ppa") cashFlowData = buildingDetailStore.cashFlowPPA;
    const { location: { hash: hash } } = history;
    const activeHash = hash && hash.replace("#", "");
    const { quickMenuLinks: quickMenuLinks } = buildingDetailStore;
    (0, $70fFQ.useEffect)(()=>{
        if (building === null || building === void 0 ? void 0 : building.rates) setFormattedRates((0, $ht0W2.formatBuildingRates)(building === null || building === void 0 ? void 0 : building.rates));
    }, [
        building
    ]);
    if (!financialData) return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        className: "financials",
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {})
    });
    const scatterPlotData = projectDetailStore.buildings.filter((building)=>building.financials).map((building)=>{
        const { total_gross_project_cost: total_gross_project_cost, payback_period: payback_period } = building.financials;
        return {
            x: total_gross_project_cost,
            y: payback_period,
            id: building.id,
            address: building.address
        };
    });
    /*
  const emissionIcons = {
    smartphones_charged: PhoneIphoneIcon,
    passenger_vehicles_driven_for_one_year: DriveEtaIcon,
    gallons_of_gasoline_consumed: LocalGasStationIcon,
    tree_seedlings_grown_for_10_years: NatureIcon,
    annual_co2_kg_reduced: CloudQueueIcon
  };
  */ return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
        className: "financials",
        style: {
            padding: disablePadding ? "0" : "16px 32px 48px"
        },
        children: [
            financialData && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                id: "financials",
                isActive: activeHash === "financials",
                setQuickMenuAnchor: setQuickMenuAnchor,
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hsiY7.default), {
                    financialMode: financialMode,
                    buildingId: buildingId,
                    data: financialData,
                    loading: financialsLoading,
                    isAdmin: isAdmin,
                    isVendor: isVendor
                })
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: 12,
                        lg: 6,
                        children: emissionsData && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            id: "environmental",
                            isActive: activeHash === "environmental",
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Annual environmental savings",
                            children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), {
                                        Icon: (0, $6TeSR.default),
                                        label: "Vehicles driven",
                                        md: 12,
                                        value: emissionsData.passenger_vehicles_driven_for_one_year,
                                        valueProps: {
                                            variant: "h5"
                                        },
                                        isLoading: financialsLoading
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), {
                                        Icon: (0, $lC6sU.default),
                                        label: "Gallons of gasoline consumed",
                                        md: 12,
                                        value: emissionsData.gallons_of_gasoline_consumed,
                                        valueProps: {
                                            variant: "h5"
                                        },
                                        isLoading: financialsLoading
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), {
                                        Icon: (0, $eIrE0.default),
                                        label: "Trees grown for 10 years",
                                        md: 12,
                                        value: emissionsData.tree_seedlings_grown_for_10_years,
                                        valueProps: {
                                            variant: "h5"
                                        },
                                        isLoading: financialsLoading
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), {
                                        Icon: (0, $i11qA.default),
                                        label: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                            children: [
                                                "kg CO",
                                                /*#__PURE__*/ (0, $4x3bm.jsx)("sub", {
                                                    children: "2"
                                                }),
                                                " Reduced Annually"
                                            ]
                                        }),
                                        md: 12,
                                        value: emissionsData.annual_co2_kg_reduced,
                                        valueProps: {
                                            variant: "h5"
                                        },
                                        isLoading: financialsLoading
                                    })
                                ]
                            })
                        })
                    }),
                    (cashFlowData === null || cashFlowData === void 0 ? void 0 : cashFlowData.length) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bNddL.default), {
                            id: "cashflow",
                            isActive: activeHash === "cashflow",
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Cumulative project cash flow",
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $b7VhJ.default), {
                                    style: {
                                        marginLeft: -16
                                    },
                                    data: cashFlowData
                                }),
                                store.analyticsUrl && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                    color: "primary",
                                    endIcon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hzgLN.default), {}),
                                    href: `https://calculator.gridmarket.com/projects/${store.analyticsUrl}`,
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: "Detailed calculation"
                                })
                            ]
                        })
                    }),
                    projectId && !buildingId && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            style: {
                                height: "100%"
                            },
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Insights",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dKmHy.default), {
                                xLabel: "Payback Period",
                                yLabel: "Total Gross Project Cost",
                                data: scatterPlotData,
                                onBrush: (range, selection, points)=>{
                                    if (range === null || points.size === 0) {
                                        buildingStore.setFilter("financial_total_gross_project_cost", null);
                                        buildingStore.setFilter("financial_payback_period", null);
                                        return;
                                    }
                                    buildingStore.setFilter("financial_total_gross_project_cost", {
                                        start: range.x[0],
                                        end: range.x[1]
                                    });
                                    buildingStore.setFilter("financial_payback_period", {
                                        start: range.y[1],
                                        end: range.y[0]
                                    });
                                }
                            })
                        })
                    }),
                    false,
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: 12,
                        sx: {
                            mt: 6
                        },
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Load Profile",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fJ9i4.default), {
                                chartType: "load_curve",
                                projectId: projectId,
                                buildingId: buildingId,
                                showMenu: userStore.isAdmin
                            })
                        })
                    }),
                    !isProjectHome && energyGenerationData.length > 0 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: 12,
                        sx: {
                            mt: 6
                        },
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Year 1 Energy Generation",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ezukV.default), {
                                data: energyGenerationData
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: 12,
                        sx: {
                            mt: 6
                        },
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                            setQuickMenuAnchor: setQuickMenuAnchor,
                            title: "Energy Consumption",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                align: "center",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $baN65.default), {
                                    width: 1000,
                                    height: 370,
                                    buildingId: buildingId,
                                    projectId: projectId
                                })
                            })
                        })
                    })
                ]
            }),
            (building === null || building === void 0 ? void 0 : building.rates) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bNddL.default), {
                id: "rates",
                isActive: activeHash === "rates",
                setQuickMenuAnchor: setQuickMenuAnchor,
                title: "Rates",
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ezukV.default), {
                    data: (0, $ht0W2.formatBuildingRates)(building === null || building === void 0 ? void 0 : building.rates).map((rate)=>({
                            label: rate.label,
                            value: rate.value,
                            suffix: rate.unit,
                            format: rate.format
                        }))
                })
            }),
            financialData === null && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {}),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $k8aZE.default), {
                anchorEl: quickMenuAnchor,
                links: quickMenuLinks,
                onClose: ()=>setQuickMenuAnchor(null)
            })
        ]
    });
};
var $e3a5f8e9f3ad41d7$export$2e2bcd8739ae039 = (0, $87gt0.observer)($e3a5f8e9f3ad41d7$var$Financials);

});
parcelRegister("i11qA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d96d8abb53d703$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $d1d96d8abb53d703$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
}), "CloudQueue");

});

parcelRegister("6TeSR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50436cc199ae8486$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $50436cc199ae8486$export$2e2bcd8739ae039 = (0, $fKdUq.default)([
    /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
        d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
    }, "0"),
    /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
        cx: "7.5",
        cy: "13.5",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
        cx: "16.5",
        cy: "13.5",
        r: "1.5"
    }, "2")
], "DriveEtaOutlined");

});

parcelRegister("lC6sU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbc2297387762400$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $fbc2297387762400$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "m19.77 7.23.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 13.5V19H6v-7h6v1.5zm0-3.5H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
}), "LocalGasStationOutlined");

});

parcelRegister("eIrE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab6a9e4d6f70ca45$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $ab6a9e4d6f70ca45$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M13 16.12h-.03c3.49-.4 6.2-3.36 6.2-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88zM7.17 9.17c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5z"
}), "NatureOutlined");

});

parcelRegister("hzgLN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca2b6b19eb3a147$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $cca2b6b19eb3a147$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), "OpenInNew");

});

parcelRegister("hsiY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb53c3f46c296899$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $8VJ2N = parcelRequire("8VJ2N");

var $5tCXN = parcelRequire("5tCXN");
const $cb53c3f46c296899$var$capexFields = [
    "total_gross_project_cost",
    "payback_period",
    "IRR",
    "total_1st_year_net_revenue",
    "total_30_year_net_revenue",
    "net_present_value"
];
const $cb53c3f46c296899$var$customerPPAFields = [
    "customer_ppa_cost",
    "customer_payback_period",
    "1_year_savings",
    "25_year_savings",
    // 'total_1st_year_net_revenue',
    // 'total_30_year_net_revenue',
    "ppa_rate_kwh"
];
const $cb53c3f46c296899$var$vendorPPAFields = [
    "capex_y0",
    "IRR",
    "1_year_net_revenue",
    "25_year_net_revenue",
    "payback_period",
    "net_present_value"
];
const $cb53c3f46c296899$var$adminPPAFields = [
    ...$cb53c3f46c296899$var$customerPPAFields,
    ...$cb53c3f46c296899$var$vendorPPAFields
];
const $cb53c3f46c296899$var$updateLabelsForAdmin = (data, isAdmin = false)=>{
    return isAdmin ? data.map((item)=>{
        if ($cb53c3f46c296899$var$customerPPAFields.includes(item.id)) return (0, $edHbI._)((0, $2QP2i._)({}, item), {
            label: `Customer ${item.label}`
        });
        if ($cb53c3f46c296899$var$vendorPPAFields.includes(item.id)) return (0, $edHbI._)((0, $2QP2i._)({}, item), {
            label: `PPA Owner ${item.label}`
        });
        return item;
    }) : data;
};
const $cb53c3f46c296899$var$FinancialsSummary = ({ buildingId: buildingId, data: data, loading: loading, financialMode: financialMode, isAdmin: isAdmin = false, isVendor: isVendor = false })=>{
    let includedFields = $cb53c3f46c296899$var$capexFields;
    if (buildingId && financialMode === "ppa") {
        if (isVendor) includedFields = $cb53c3f46c296899$var$vendorPPAFields;
        if (isAdmin) includedFields = $cb53c3f46c296899$var$adminPPAFields;
        if (!isAdmin && !isVendor) includedFields = $cb53c3f46c296899$var$customerPPAFields;
    }
    const fields = $cb53c3f46c296899$var$updateLabelsForAdmin(data.filter((item)=>includedFields.includes(item.id)), isAdmin && financialMode === "ppa");
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
        container: true,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
            item: true,
            xs: 12,
            lg: 12,
            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                container: true,
                spacing: 2,
                children: fields.map((d)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), (0, $2QP2i._)({
                        isLoading: loading,
                        lg: 6,
                        md: 6,
                        sm: 6,
                        digits: d.id === "ppa_rate_kwh" ? 4 : undefined
                    }, d), d.label))
            })
        })
    });
};
var $cb53c3f46c296899$export$2e2bcd8739ae039 = $cb53c3f46c296899$var$FinancialsSummary;

});

parcelRegister("b7VhJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $819cc8c4e8cf8451$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $1Dcce = parcelRequire("1Dcce");

var $fuiMG = parcelRequire("fuiMG");
const $819cc8c4e8cf8451$var$LineChart = ({ data: data })=>{
    const a = data.map((d, i)=>{
        return {
            x: new Date().getFullYear() + i,
            y: Math.round(d)
        };
    }).slice(0, 20);
    const xAxisLabels = data.map((d, i)=>i % 2 === 0 ? new Date().getFullYear() + i : undefined).slice(0, 20);
    const formattedData = [
        {
            id: "line",
            data: a
        }
    ];
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1Dcce.ResponsiveLine), {
        data: formattedData,
        margin: {
            top: 0,
            right: 0,
            bottom: 32,
            left: 64
        },
        // xScale={{ type: "point" }}
        defs: [
            {
                id: "gradientC",
                type: "linearGradient",
                colors: [
                    {
                        offset: 0,
                        color: "#05d748"
                    },
                    {
                        offset: 100,
                        color: "#05d748",
                        opacity: 0
                    }
                ]
            }
        ],
        fill: [
            {
                match: "*",
                id: "gradientC"
            }
        ],
        yScale: {
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: true,
            reverse: false
        },
        endableArea: true,
        enableCrosshair: true,
        areaOpacity: 0.2,
        lineWidth: 1,
        animate: true,
        axisTop: null,
        axisRight: null,
        tooltip: ({ point: point })=>{
            return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                children: [
                    point.data.x,
                    ": $",
                    (0, $fuiMG.formatNumber)(point.data.y)
                ]
            });
        },
        axisBottom: {
            orient: "bottom",
            tickSize: 0,
            tickPadding: 16,
            tickRotation: 0,
            legend: null,
            legendOffset: 36,
            tickValues: xAxisLabels,
            legendPosition: "middle"
        },
        axisLeft: {
            orient: "left",
            tickSize: 0,
            tickPadding: 16,
            tickRotation: 0,
            legend: null,
            legendOffset: -40,
            legendPosition: "middle",
            format: (v)=>Math.sign(v) === -1 ? `-$${(0, $fuiMG.abbreviateNumber)(Math.abs(v))}` : `$${(0, $fuiMG.abbreviateNumber)(Math.abs(v))}`
        },
        enableGridX: false,
        enableGridY: false,
        colors: [
            "rgb(5, 215, 72)"
        ],
        pointSize: 0,
        pointColor: {
            theme: "background"
        },
        pointBorderWidth: 2,
        pointLabel: "y",
        pointLabelYOffset: -12,
        enableArea: true,
        useMesh: true
    });
};
function $819cc8c4e8cf8451$export$2e2bcd8739ae039({ data: data, style: style = {} }) {
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        style: (0, $2QP2i._)({
            height: 300
        }, style),
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($819cc8c4e8cf8451$var$LineChart, {
            data: data
        })
    });
}

});

parcelRegister("dKmHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0212e475e9f178e$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $5WBiR = parcelRequire("5WBiR");

var $fuiMG = parcelRequire("fuiMG");
/* Parcel scope hoising is dumb (view with d3 errors) and this hack solves it */ const { axisBottom: $a0212e475e9f178e$var$axisBottom, axisLeft: $a0212e475e9f178e$var$axisLeft, select: $a0212e475e9f178e$var$select, format: $a0212e475e9f178e$var$format, min: $a0212e475e9f178e$var$min, max: $a0212e475e9f178e$var$max, scaleLinear: $a0212e475e9f178e$var$scaleLinear, brush: $a0212e475e9f178e$var$brush } = $5WBiR;
const $a0212e475e9f178e$var$Datapoint = ({ x: x, y: y, data: data, fill: fill, r: r, isBrushed: isBrushed, onMouseOver: onMouseOver, onMouseOut: onMouseOut })=>{
    const [circleRadius, setCircleRadius] = (0, $70fFQ.useState)(r);
    // eslint-disable-next-line no-underscore-dangle
    const _onMouseOver = ()=>{
        setCircleRadius(r * 1.5);
        onMouseOver(x, y, data);
    };
    // eslint-disable-next-line no-underscore-dangle
    const _onMouseOut = ()=>{
        setCircleRadius(r);
        onMouseOut();
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)("g", {
        onMouseOver: _onMouseOver,
        onMouseOut: _onMouseOut,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
            style: {
                cursor: "pointer",
                pointerEvents: "all"
            },
            cx: x,
            cy: y,
            r: circleRadius,
            fill: isBrushed ? "#05d748" : fill,
            className: "datapoint"
        })
    });
};
const $a0212e475e9f178e$var$Axis = ({ type: type, x: x, y: y, label: label, scale: scale })=>{
    const axis = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const positions = {
        top: {
            x: scale.range()[1] + 20,
            y: 0
        },
        right: {
            x: 20,
            y: 0
        },
        bottom: {
            x: scale.range()[1] / 2.5,
            y: 30
        },
        left: {
            x: scale.range()[0] / 2.5,
            y: 40
        }
    };
    const labelPosition = positions[type];
    const d3Axis = type === "left" ? $a0212e475e9f178e$var$axisLeft : $a0212e475e9f178e$var$axisBottom;
    (0, $70fFQ.useEffect)(()=>{
        $a0212e475e9f178e$var$select(axis.current).call(d3Axis(scale).tickFormat($a0212e475e9f178e$var$format("~s"))).attr("class", `axis axis-${type}`);
    }, [
        d3Axis,
        scale,
        type,
        axis,
        x,
        y,
        label
    ]);
    const rotate = type === "left" ? 90 : 0;
    return /*#__PURE__*/ (0, $4x3bm.jsx)("g", {
        ref: axis,
        transform: `translate(${x}, ${y})`,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)("text", (0, $edHbI._)((0, $2QP2i._)({
            textAnchor: "start",
            transform: `rotate(${rotate})`
        }, labelPosition), {
            children: label
        }))
    });
};
const $a0212e475e9f178e$var$ScatterPlot = ({ data: data, xLabel: xLabel = "", yLabel: yLabel = "", onBrush: onBrush = ()=>{} })=>{
    const margin = {
        top: 10,
        right: 30,
        bottom: 30,
        left: 50
    };
    const [tooltip, setTooltip] = (0, $70fFQ.useState)(null);
    const [dimensions, setDimensions] = (0, $70fFQ.useState)({
        width: 460,
        height: 400
    });
    const svgWidth = dimensions.width - margin.left - margin.right;
    const svgHeight = dimensions.height - margin.top - margin.bottom;
    const svg = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const brushRef = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useRef(null);
    const [brushedPoints, setBrushedPoints] = (0, $70fFQ.useState)(new Set());
    (0, $70fFQ.useEffect)(()=>{
        const resizeObserver = new ResizeObserver((entries)=>{
            var _containerRef_current, _containerRef_current1;
            if (entries[0].contentRect.width) setDimensions({
                width: (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.offsetWidth,
                height: ((_containerRef_current1 = containerRef.current) === null || _containerRef_current1 === void 0 ? void 0 : _containerRef_current1.offsetHeight) - 32
            });
        });
        resizeObserver.observe(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current);
    }, []);
    function isBrushed(brush_coords, cx, cy) {
        const x0 = brush_coords[0][0];
        const x1 = brush_coords[1][0];
        const y0 = brush_coords[0][1];
        const y1 = brush_coords[1][1];
        return x0 <= cx && cx <= x1 && y0 <= cy && cy <= y1; // This return TRUE or FALSE depending on if the points is in the selected area
    }
    const minX = $a0212e475e9f178e$var$min(data, (d)=>d.x);
    const maxX = $a0212e475e9f178e$var$max(data, (d)=>d.x);
    const minY = $a0212e475e9f178e$var$min(data, (d)=>d.y);
    const maxY = $a0212e475e9f178e$var$max(data, (d)=>d.y);
    const xScale = $a0212e475e9f178e$var$scaleLinear().range([
        0,
        svgWidth
    ]).domain([
        minX,
        maxX
    ]);
    const yScale = $a0212e475e9f178e$var$scaleLinear().range([
        svgHeight,
        0
    ]).domain([
        minY,
        maxY
    ]);
    const points = data.map((d)=>{
        return {
            x: xScale(d.x),
            y: yScale(d.y),
            index: d.id,
            data: d
        };
    });
    (0, $70fFQ.useEffect)(()=>{
        if (brushRef.current) {
            const svgNode = $a0212e475e9f178e$var$select(brushRef.current);
            svgNode.selectAll(".d3brush").remove();
            svgNode.append("g").attr("class", "d3brush").call($a0212e475e9f178e$var$brush() // Add the brush feature using the d3.brush function
            .extent([
                [
                    0,
                    0
                ],
                [
                    svgWidth,
                    svgHeight
                ]
            ]).on("start brush end", (e)=>{
                const { selection: selection } = e;
                if (selection === null) {
                    setBrushedPoints(new Set());
                    onBrush(null, null, []);
                    return;
                }
                const brushedPoints = new Set(points.filter(({ x: x, y: y })=>isBrushed(selection, x, y)).map(({ index: index })=>index));
                const xRange = [
                    xScale.invert(selection[0][0]),
                    xScale.invert(selection[1][0])
                ];
                const yRange = [
                    yScale.invert(selection[0][1]),
                    yScale.invert(selection[1][1])
                ];
                setBrushedPoints(brushedPoints);
                const range = {
                    x: xRange,
                    y: yRange
                };
                onBrush(range, selection, brushedPoints);
            }) // Each time the brush selection changes, trigger the 'updateChart' function
            );
        }
    }, [
        dimensions
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (!containerRef.current) return;
        const container = $a0212e475e9f178e$var$select(containerRef.current);
        const tooltipNode = container.selectAll(".scatterplot-tooltip");
        if (!tooltip) {
            tooltipNode.style("opacity", 0);
            return;
        }
        const html = `
      Address: ${tooltip.data.address} <br />
      Project cost: $${(0, $fuiMG.formatNumber)(tooltip.data.x)}
      <br />
      Payback period: ${(0, $fuiMG.formatNumber)(tooltip.data.y)} years
    `;
        tooltipNode.transition().duration(150).style("opacity", 0.9);
        tooltipNode.html(html).style("transform", `translate(${tooltip.x - 100}px,${tooltip.y - 30}px)`);
        console.log("tooltipNode", tooltipNode);
    }, [
        tooltip,
        containerRef
    ]);
    const translate = `translate(${margin.left},${margin.top})`;
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
        className: "container",
        style: {
            height: "100%",
            width: "100%",
            position: "relative"
        },
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                className: "scatterplot-tooltip",
                style: {
                    position: "absolute",
                    pointerEvents: "none",
                    padding: "10px",
                    backgroundColor: "white",
                    boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                    borderRadius: "5px",
                    zIndex: 1000
                }
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("svg", {
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0
                },
                className: "d3svg",
                ref: svg,
                width: svgWidth + margin.left + margin.right,
                height: svgHeight + margin.top + margin.bottom,
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)("g", {
                    transform: translate,
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)("g", {
                            ref: brushRef,
                            className: "brush"
                        }),
                        points.map(({ x: x, y: y, index: index, data: data })=>/*#__PURE__*/ (0, $4x3bm.jsx)($a0212e475e9f178e$var$Datapoint, {
                                xScale: xScale,
                                yScale: yScale,
                                isBrushed: brushedPoints.has(index),
                                onMouseOver: (x, y, data)=>{
                                    setTooltip({
                                        x: x,
                                        y: y,
                                        data: data
                                    });
                                },
                                onMouseOut: ()=>{
                                    setTooltip(null);
                                },
                                containerRef: containerRef,
                                data: data,
                                x: x,
                                y: y,
                                fill: "#0070FF",
                                r: 5
                            }, `${x}-${y}-${index}`)),
                        /*#__PURE__*/ (0, $4x3bm.jsx)($a0212e475e9f178e$var$Axis, {
                            label: xLabel,
                            x: 0,
                            y: 0,
                            scale: yScale,
                            type: "left"
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)($a0212e475e9f178e$var$Axis, {
                            label: yLabel,
                            x: 0,
                            y: svgHeight,
                            scale: xScale,
                            type: "bottom"
                        })
                    ]
                })
            })
        ]
    });
};
var $a0212e475e9f178e$export$2e2bcd8739ae039 = $a0212e475e9f178e$var$ScatterPlot;

});
parcelRegister("5WBiR", function(module, exports) {

var $eCQNF = parcelRequire("eCQNF");

var $kMcPQ = parcelRequire("kMcPQ");

var $ktMqu = parcelRequire("ktMqu");

var $cJ6dS = parcelRequire("cJ6dS");

var $inJCY = parcelRequire("inJCY");

var $6la9m = parcelRequire("6la9m");

var $f3ekm = parcelRequire("f3ekm");

var $UMLAc = parcelRequire("UMLAc");

var $1PktO = parcelRequire("1PktO");

var $50AvS = parcelRequire("50AvS");

var $2Wj9t = parcelRequire("2Wj9t");

var $81W8M = parcelRequire("81W8M");

var $gY9gz = parcelRequire("gY9gz");

var $erWrv = parcelRequire("erWrv");

var $7LmmM = parcelRequire("7LmmM");

var $i51pS = parcelRequire("i51pS");

var $aGRBr = parcelRequire("aGRBr");

var $3D8Wm = parcelRequire("3D8Wm");

var $3Xg7Q = parcelRequire("3Xg7Q");

var $a1OtG = parcelRequire("a1OtG");

var $dI56V = parcelRequire("dI56V");

var $jroKu = parcelRequire("jroKu");

var $8dIxz = parcelRequire("8dIxz");

var $94AoT = parcelRequire("94AoT");

var $4VAJt = parcelRequire("4VAJt");

var $esTGQ = parcelRequire("esTGQ");

var $3ELuc = parcelRequire("3ELuc");

var $9qanl = parcelRequire("9qanl");

var $buDM2 = parcelRequire("buDM2");

var $hAqXZ = parcelRequire("hAqXZ");
$parcel$exportWildcard(module.exports, $eCQNF);
$parcel$exportWildcard(module.exports, $kMcPQ);
$parcel$exportWildcard(module.exports, $ktMqu);
$parcel$exportWildcard(module.exports, $cJ6dS);
$parcel$exportWildcard(module.exports, $inJCY);
$parcel$exportWildcard(module.exports, $6la9m);
$parcel$exportWildcard(module.exports, $f3ekm);
$parcel$exportWildcard(module.exports, $UMLAc);
$parcel$exportWildcard(module.exports, $1PktO);
$parcel$exportWildcard(module.exports, $50AvS);
$parcel$exportWildcard(module.exports, $2Wj9t);
$parcel$exportWildcard(module.exports, $81W8M);
$parcel$exportWildcard(module.exports, $gY9gz);
$parcel$exportWildcard(module.exports, $erWrv);
$parcel$exportWildcard(module.exports, $7LmmM);
$parcel$exportWildcard(module.exports, $i51pS);
$parcel$exportWildcard(module.exports, $aGRBr);
$parcel$exportWildcard(module.exports, $3D8Wm);
$parcel$exportWildcard(module.exports, $3Xg7Q);
$parcel$exportWildcard(module.exports, $a1OtG);
$parcel$exportWildcard(module.exports, $dI56V);
$parcel$exportWildcard(module.exports, $jroKu);
$parcel$exportWildcard(module.exports, $8dIxz);
$parcel$exportWildcard(module.exports, $94AoT);
$parcel$exportWildcard(module.exports, $4VAJt);
$parcel$exportWildcard(module.exports, $esTGQ);
$parcel$exportWildcard(module.exports, $3ELuc);
$parcel$exportWildcard(module.exports, $9qanl);
$parcel$exportWildcard(module.exports, $buDM2);
$parcel$exportWildcard(module.exports, $hAqXZ);

});
parcelRegister("eCQNF", function(module, exports) {

$parcel$export(module.exports, "bisect", function () { return (parcelRequire("eZf2H")).default; });
$parcel$export(module.exports, "bisectRight", function () { return (parcelRequire("eZf2H")).bisectRight; });
$parcel$export(module.exports, "bisectLeft", function () { return (parcelRequire("eZf2H")).bisectLeft; });
$parcel$export(module.exports, "bisectCenter", function () { return (parcelRequire("eZf2H")).bisectCenter; });
$parcel$export(module.exports, "ascending", function () { return (parcelRequire("mbn54")).default; });
$parcel$export(module.exports, "bisector", function () { return (parcelRequire("f8fRa")).default; });
$parcel$export(module.exports, "blur", function () { return (parcelRequire("cIT6x")).blur; });
$parcel$export(module.exports, "blur2", function () { return (parcelRequire("cIT6x")).blur2; });
$parcel$export(module.exports, "blurImage", function () { return (parcelRequire("cIT6x")).blurImage; });
$parcel$export(module.exports, "count", function () { return (parcelRequire("iVCja")).default; });
$parcel$export(module.exports, "cross", function () { return (parcelRequire("7edNN")).default; });
$parcel$export(module.exports, "cumsum", function () { return (parcelRequire("dWWLu")).default; });
$parcel$export(module.exports, "descending", function () { return (parcelRequire("5OdPt")).default; });
$parcel$export(module.exports, "deviation", function () { return (parcelRequire("3vzLS")).default; });
$parcel$export(module.exports, "extent", function () { return (parcelRequire("eI3Wa")).default; });
$parcel$export(module.exports, "Adder", function () { return (parcelRequire("fT5Bl")).Adder; });
$parcel$export(module.exports, "fsum", function () { return (parcelRequire("fT5Bl")).fsum; });
$parcel$export(module.exports, "fcumsum", function () { return (parcelRequire("fT5Bl")).fcumsum; });
$parcel$export(module.exports, "group", function () { return (parcelRequire("bYJCw")).default; });
$parcel$export(module.exports, "flatGroup", function () { return (parcelRequire("bYJCw")).flatGroup; });
$parcel$export(module.exports, "flatRollup", function () { return (parcelRequire("bYJCw")).flatRollup; });
$parcel$export(module.exports, "groups", function () { return (parcelRequire("bYJCw")).groups; });
$parcel$export(module.exports, "index", function () { return (parcelRequire("bYJCw")).index; });
$parcel$export(module.exports, "indexes", function () { return (parcelRequire("bYJCw")).indexes; });
$parcel$export(module.exports, "rollup", function () { return (parcelRequire("bYJCw")).rollup; });
$parcel$export(module.exports, "rollups", function () { return (parcelRequire("bYJCw")).rollups; });
$parcel$export(module.exports, "groupSort", function () { return (parcelRequire("8DJtf")).default; });
$parcel$export(module.exports, "bin", function () { return (parcelRequire("7zhHc")).default; });
$parcel$export(module.exports, "histogram", function () { return (parcelRequire("7zhHc")).default; });
$parcel$export(module.exports, "thresholdFreedmanDiaconis", function () { return (parcelRequire("1SUeo")).default; });
$parcel$export(module.exports, "thresholdScott", function () { return (parcelRequire("gvXVQ")).default; });
$parcel$export(module.exports, "thresholdSturges", function () { return (parcelRequire("ihuha")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("NBzfP")).default; });
$parcel$export(module.exports, "maxIndex", function () { return (parcelRequire("6Y8eX")).default; });
$parcel$export(module.exports, "mean", function () { return (parcelRequire("cHRaL")).default; });
$parcel$export(module.exports, "median", function () { return (parcelRequire("boQL9")).default; });
$parcel$export(module.exports, "medianIndex", function () { return (parcelRequire("boQL9")).medianIndex; });
$parcel$export(module.exports, "merge", function () { return (parcelRequire("4AHKb")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("xN89R")).default; });
$parcel$export(module.exports, "minIndex", function () { return (parcelRequire("jElCj")).default; });
$parcel$export(module.exports, "mode", function () { return (parcelRequire("4Pd24")).default; });
$parcel$export(module.exports, "nice", function () { return (parcelRequire("dAZOc")).default; });
$parcel$export(module.exports, "pairs", function () { return (parcelRequire("lAYzF")).default; });
$parcel$export(module.exports, "permute", function () { return (parcelRequire("fCvvC")).default; });
$parcel$export(module.exports, "quantile", function () { return (parcelRequire("hr3aa")).default; });
$parcel$export(module.exports, "quantileIndex", function () { return (parcelRequire("hr3aa")).quantileIndex; });
$parcel$export(module.exports, "quantileSorted", function () { return (parcelRequire("hr3aa")).quantileSorted; });
$parcel$export(module.exports, "quickselect", function () { return (parcelRequire("9CpqA")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("6jvVk")).default; });
$parcel$export(module.exports, "rank", function () { return (parcelRequire("iXkno")).default; });
$parcel$export(module.exports, "least", function () { return (parcelRequire("hGKSX")).default; });
$parcel$export(module.exports, "leastIndex", function () { return (parcelRequire("d8qfW")).default; });
$parcel$export(module.exports, "greatest", function () { return (parcelRequire("bP9Pg")).default; });
$parcel$export(module.exports, "greatestIndex", function () { return (parcelRequire("ipkua")).default; });
$parcel$export(module.exports, "scan", function () { return (parcelRequire("gkxAz")).default; });
$parcel$export(module.exports, "shuffle", function () { return (parcelRequire("6EWLf")).default; });
$parcel$export(module.exports, "shuffler", function () { return (parcelRequire("6EWLf")).shuffler; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("a8nTT")).default; });
$parcel$export(module.exports, "ticks", function () { return (parcelRequire("amLJv")).default; });
$parcel$export(module.exports, "tickIncrement", function () { return (parcelRequire("amLJv")).tickIncrement; });
$parcel$export(module.exports, "tickStep", function () { return (parcelRequire("amLJv")).tickStep; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("gNswG")).default; });
$parcel$export(module.exports, "variance", function () { return (parcelRequire("8vJaY")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("f9sL7")).default; });
$parcel$export(module.exports, "every", function () { return (parcelRequire("5MF5l")).default; });
$parcel$export(module.exports, "some", function () { return (parcelRequire("iJUUy")).default; });
$parcel$export(module.exports, "filter", function () { return (parcelRequire("9gpbC")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("3jLKL")).default; });
$parcel$export(module.exports, "reduce", function () { return (parcelRequire("ekQxE")).default; });
$parcel$export(module.exports, "reverse", function () { return (parcelRequire("9jDib")).default; });
$parcel$export(module.exports, "sort", function () { return (parcelRequire("2Bdnp")).default; });
$parcel$export(module.exports, "difference", function () { return (parcelRequire("8G4dS")).default; });
$parcel$export(module.exports, "disjoint", function () { return (parcelRequire("6gpBJ")).default; });
$parcel$export(module.exports, "intersection", function () { return (parcelRequire("jC0Xp")).default; });
$parcel$export(module.exports, "subset", function () { return (parcelRequire("2VOGt")).default; });
$parcel$export(module.exports, "superset", function () { return (parcelRequire("8LDeD")).default; });
$parcel$export(module.exports, "union", function () { return (parcelRequire("i1Ei2")).default; });
$parcel$export(module.exports, "InternMap", function () { return (parcelRequire("9Y6md")).InternMap; });
$parcel$export(module.exports, "InternSet", function () { return (parcelRequire("9Y6md")).InternSet; });

var $eZf2H = parcelRequire("eZf2H");

var $mbn54 = parcelRequire("mbn54");

var $f8fRa = parcelRequire("f8fRa");

var $cIT6x = parcelRequire("cIT6x");

var $iVCja = parcelRequire("iVCja");

var $7edNN = parcelRequire("7edNN");

var $dWWLu = parcelRequire("dWWLu");

var $5OdPt = parcelRequire("5OdPt");

var $3vzLS = parcelRequire("3vzLS");

var $eI3Wa = parcelRequire("eI3Wa");

var $fT5Bl = parcelRequire("fT5Bl");

var $bYJCw = parcelRequire("bYJCw");

var $8DJtf = parcelRequire("8DJtf");

var $7zhHc = parcelRequire("7zhHc");

var $1SUeo = parcelRequire("1SUeo");

var $gvXVQ = parcelRequire("gvXVQ");

var $ihuha = parcelRequire("ihuha");

var $NBzfP = parcelRequire("NBzfP");

var $6Y8eX = parcelRequire("6Y8eX");

var $cHRaL = parcelRequire("cHRaL");

var $boQL9 = parcelRequire("boQL9");

var $4AHKb = parcelRequire("4AHKb");

var $xN89R = parcelRequire("xN89R");

var $jElCj = parcelRequire("jElCj");

var $4Pd24 = parcelRequire("4Pd24");

var $dAZOc = parcelRequire("dAZOc");

var $lAYzF = parcelRequire("lAYzF");

var $fCvvC = parcelRequire("fCvvC");

var $hr3aa = parcelRequire("hr3aa");

var $9CpqA = parcelRequire("9CpqA");

var $6jvVk = parcelRequire("6jvVk");

var $iXkno = parcelRequire("iXkno");

var $hGKSX = parcelRequire("hGKSX");

var $d8qfW = parcelRequire("d8qfW");

var $bP9Pg = parcelRequire("bP9Pg");

var $ipkua = parcelRequire("ipkua");

var $gkxAz = parcelRequire("gkxAz");

var $6EWLf = parcelRequire("6EWLf");

var $a8nTT = parcelRequire("a8nTT");

var $amLJv = parcelRequire("amLJv");

var $gNswG = parcelRequire("gNswG");

var $8vJaY = parcelRequire("8vJaY");

var $f9sL7 = parcelRequire("f9sL7");

var $5MF5l = parcelRequire("5MF5l");

var $iJUUy = parcelRequire("iJUUy");

var $9gpbC = parcelRequire("9gpbC");

var $3jLKL = parcelRequire("3jLKL");

var $ekQxE = parcelRequire("ekQxE");

var $9jDib = parcelRequire("9jDib");

var $2Bdnp = parcelRequire("2Bdnp");

var $8G4dS = parcelRequire("8G4dS");

var $6gpBJ = parcelRequire("6gpBJ");

var $jC0Xp = parcelRequire("jC0Xp");

var $2VOGt = parcelRequire("2VOGt");

var $8LDeD = parcelRequire("8LDeD");

var $i1Ei2 = parcelRequire("i1Ei2");

var $9Y6md = parcelRequire("9Y6md");

});
parcelRegister("eZf2H", function(module, exports) {

$parcel$export(module.exports, "bisectRight", function () { return $ae926e5243dc4c83$export$4d945ad3ad5751b0; });
$parcel$export(module.exports, "bisectLeft", function () { return $ae926e5243dc4c83$export$df7d25c84ebd12a5; });
$parcel$export(module.exports, "bisectCenter", function () { return $ae926e5243dc4c83$export$c1cb828b1117c77b; });
$parcel$export(module.exports, "default", function () { return $ae926e5243dc4c83$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");

var $f8fRa = parcelRequire("f8fRa");

var $deGR4 = parcelRequire("deGR4");
const $ae926e5243dc4c83$var$ascendingBisect = (0, $f8fRa.default)((0, $mbn54.default));
const $ae926e5243dc4c83$export$4d945ad3ad5751b0 = $ae926e5243dc4c83$var$ascendingBisect.right;
const $ae926e5243dc4c83$export$df7d25c84ebd12a5 = $ae926e5243dc4c83$var$ascendingBisect.left;
const $ae926e5243dc4c83$export$c1cb828b1117c77b = (0, $f8fRa.default)((0, $deGR4.default)).center;
var $ae926e5243dc4c83$export$2e2bcd8739ae039 = $ae926e5243dc4c83$export$4d945ad3ad5751b0;

});
parcelRegister("mbn54", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $042ae049363a13e7$export$2e2bcd8739ae039; });
function $042ae049363a13e7$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("f8fRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b043e722ed6263fe$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");

var $5OdPt = parcelRequire("5OdPt");
function $b043e722ed6263fe$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $mbn54.default);
        compare2 = (d, x)=>(0, $mbn54.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $mbn54.default) || f === (0, $5OdPt.default) ? f : $b043e722ed6263fe$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $b043e722ed6263fe$var$zero() {
    return 0;
}

});
parcelRegister("5OdPt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43ac5972b8023517$export$2e2bcd8739ae039; });
function $43ac5972b8023517$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("deGR4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a2dd345af230559$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "numbers", function () { return $9a2dd345af230559$export$1f6c9cc012ebacae; });
function $9a2dd345af230559$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $9a2dd345af230559$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("cIT6x", function(module, exports) {

$parcel$export(module.exports, "blur", function () { return $943456ac2ae9f2fe$export$2cc7ff91bcacba5e; });
$parcel$export(module.exports, "blur2", function () { return $943456ac2ae9f2fe$export$7671911241d9460b; });
$parcel$export(module.exports, "blurImage", function () { return $943456ac2ae9f2fe$export$44bf2d4c3a4dda00; });
function $943456ac2ae9f2fe$export$2cc7ff91bcacba5e(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = $943456ac2ae9f2fe$var$blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const $943456ac2ae9f2fe$export$7671911241d9460b = $943456ac2ae9f2fe$var$Blur2($943456ac2ae9f2fe$var$blurf);
const $943456ac2ae9f2fe$export$44bf2d4c3a4dda00 = $943456ac2ae9f2fe$var$Blur2($943456ac2ae9f2fe$var$blurfImage);
function $943456ac2ae9f2fe$var$Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width: width, height: height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            $943456ac2ae9f2fe$var$blurh(blurx, temp, values, width, height);
            $943456ac2ae9f2fe$var$blurh(blurx, values, temp, width, height);
            $943456ac2ae9f2fe$var$blurh(blurx, temp, values, width, height);
            $943456ac2ae9f2fe$var$blurv(blury, values, temp, width, height);
            $943456ac2ae9f2fe$var$blurv(blury, temp, values, width, height);
            $943456ac2ae9f2fe$var$blurv(blury, values, temp, width, height);
        } else if (blurx) {
            $943456ac2ae9f2fe$var$blurh(blurx, values, temp, width, height);
            $943456ac2ae9f2fe$var$blurh(blurx, temp, values, width, height);
            $943456ac2ae9f2fe$var$blurh(blurx, values, temp, width, height);
        } else if (blury) {
            $943456ac2ae9f2fe$var$blurv(blury, values, temp, width, height);
            $943456ac2ae9f2fe$var$blurv(blury, temp, values, width, height);
            $943456ac2ae9f2fe$var$blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function $943456ac2ae9f2fe$var$blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function $943456ac2ae9f2fe$var$blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function $943456ac2ae9f2fe$var$blurfImage(radius) {
    const blur = $943456ac2ae9f2fe$var$blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function $943456ac2ae9f2fe$var$blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return $943456ac2ae9f2fe$var$bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function $943456ac2ae9f2fe$var$bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

});

parcelRegister("iVCja", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7b440aebb61904$export$2e2bcd8739ae039; });
function $dc7b440aebb61904$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("7edNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54348c0905ab2477$export$2e2bcd8739ae039; });
function $54348c0905ab2477$var$length(array) {
    return array.length | 0;
}
function $54348c0905ab2477$var$empty(length) {
    return !(length > 0);
}
function $54348c0905ab2477$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $54348c0905ab2477$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $54348c0905ab2477$export$2e2bcd8739ae039(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $54348c0905ab2477$var$reducer(values.pop());
    values = values.map($54348c0905ab2477$var$arrayify);
    const lengths = values.map($54348c0905ab2477$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($54348c0905ab2477$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("dWWLu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a27e46a158ea2c13$export$2e2bcd8739ae039; });
function $a27e46a158ea2c13$export$2e2bcd8739ae039(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("3vzLS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28e003c9ac203bf6$export$2e2bcd8739ae039; });

var $8vJaY = parcelRequire("8vJaY");
function $28e003c9ac203bf6$export$2e2bcd8739ae039(values, valueof) {
    const v = (0, $8vJaY.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("8vJaY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $632442ffa25e3900$export$2e2bcd8739ae039; });
function $632442ffa25e3900$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("eI3Wa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab583a93f165f8d9$export$2e2bcd8739ae039; });
function $ab583a93f165f8d9$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("fT5Bl", function(module, exports) {

$parcel$export(module.exports, "Adder", function () { return $b910565f52c0571e$export$bda7ba77fb86c375; });
$parcel$export(module.exports, "fsum", function () { return $b910565f52c0571e$export$61cb83f1a93e9fae; });
$parcel$export(module.exports, "fcumsum", function () { return $b910565f52c0571e$export$5a6391da70c130da; });
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $b910565f52c0571e$export$bda7ba77fb86c375 {
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
}
function $b910565f52c0571e$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $b910565f52c0571e$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $b910565f52c0571e$export$5a6391da70c130da(values, valueof) {
    const adder = new $b910565f52c0571e$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("bYJCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b88af8c1697d86c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "groups", function () { return $8b88af8c1697d86c$export$d4abd167df80d226; });
$parcel$export(module.exports, "flatGroup", function () { return $8b88af8c1697d86c$export$4ed6fc79ae2c51b5; });
$parcel$export(module.exports, "flatRollup", function () { return $8b88af8c1697d86c$export$788c7294dbcd8e36; });
$parcel$export(module.exports, "rollups", function () { return $8b88af8c1697d86c$export$24814875ed03194b; });
$parcel$export(module.exports, "rollup", function () { return $8b88af8c1697d86c$export$97e11c0b0230f130; });
$parcel$export(module.exports, "index", function () { return $8b88af8c1697d86c$export$b610b8812bbcded9; });
$parcel$export(module.exports, "indexes", function () { return $8b88af8c1697d86c$export$8b04ba635e5803cd; });

var $9Y6md = parcelRequire("9Y6md");

var $knVCG = parcelRequire("knVCG");
function $8b88af8c1697d86c$export$2e2bcd8739ae039(values, ...keys) {
    return $8b88af8c1697d86c$var$nest(values, (0, $knVCG.default), (0, $knVCG.default), keys);
}
function $8b88af8c1697d86c$export$d4abd167df80d226(values, ...keys) {
    return $8b88af8c1697d86c$var$nest(values, Array.from, (0, $knVCG.default), keys);
}
function $8b88af8c1697d86c$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $8b88af8c1697d86c$export$4ed6fc79ae2c51b5(values, ...keys) {
    return $8b88af8c1697d86c$var$flatten($8b88af8c1697d86c$export$d4abd167df80d226(values, ...keys), keys);
}
function $8b88af8c1697d86c$export$788c7294dbcd8e36(values, reduce, ...keys) {
    return $8b88af8c1697d86c$var$flatten($8b88af8c1697d86c$export$24814875ed03194b(values, reduce, ...keys), keys);
}
function $8b88af8c1697d86c$export$97e11c0b0230f130(values, reduce, ...keys) {
    return $8b88af8c1697d86c$var$nest(values, (0, $knVCG.default), reduce, keys);
}
function $8b88af8c1697d86c$export$24814875ed03194b(values, reduce, ...keys) {
    return $8b88af8c1697d86c$var$nest(values, Array.from, reduce, keys);
}
function $8b88af8c1697d86c$export$b610b8812bbcded9(values, ...keys) {
    return $8b88af8c1697d86c$var$nest(values, (0, $knVCG.default), $8b88af8c1697d86c$var$unique, keys);
}
function $8b88af8c1697d86c$export$8b04ba635e5803cd(values, ...keys) {
    return $8b88af8c1697d86c$var$nest(values, Array.from, $8b88af8c1697d86c$var$unique, keys);
}
function $8b88af8c1697d86c$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $8b88af8c1697d86c$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, $9Y6md.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("9Y6md", function(module, exports) {

$parcel$export(module.exports, "InternMap", function () { return $741ea61887a25000$export$dcc6fb7d82b5bc7b; });
$parcel$export(module.exports, "InternSet", function () { return $741ea61887a25000$export$55278c3294239828; });
class $741ea61887a25000$export$dcc6fb7d82b5bc7b extends Map {
    get(key) {
        return super.get($741ea61887a25000$var$intern_get(this, key));
    }
    has(key) {
        return super.has($741ea61887a25000$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($741ea61887a25000$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($741ea61887a25000$var$intern_delete(this, key));
    }
    constructor(entries, key = $741ea61887a25000$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
}
class $741ea61887a25000$export$55278c3294239828 extends Set {
    has(value) {
        return super.has($741ea61887a25000$var$intern_get(this, value));
    }
    add(value) {
        return super.add($741ea61887a25000$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($741ea61887a25000$var$intern_delete(this, value));
    }
    constructor(values, key = $741ea61887a25000$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
}
function $741ea61887a25000$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $741ea61887a25000$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $741ea61887a25000$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $741ea61887a25000$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("knVCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed72a7588f458fe8$export$2e2bcd8739ae039; });
function $ed72a7588f458fe8$export$2e2bcd8739ae039(x) {
    return x;
}

});


parcelRegister("8DJtf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a53ccef2fe7e43$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");

var $bYJCw = parcelRequire("bYJCw");

var $2Bdnp = parcelRequire("2Bdnp");
function $64a53ccef2fe7e43$export$2e2bcd8739ae039(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $2Bdnp.default)((0, $bYJCw.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $mbn54.default)(av, bv) || (0, $mbn54.default)(ak, bk)) : (0, $2Bdnp.default)((0, $bYJCw.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $mbn54.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("2Bdnp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e4969cac10d97e7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ascendingDefined", function () { return $1e4969cac10d97e7$export$686e14b8469efec4; });
$parcel$export(module.exports, "compareDefined", function () { return $1e4969cac10d97e7$export$5708b2c031939e56; });

var $mbn54 = parcelRequire("mbn54");

var $fCvvC = parcelRequire("fCvvC");
function $1e4969cac10d97e7$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $1e4969cac10d97e7$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$1e4969cac10d97e7$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $fCvvC.default)(values, index);
    }
    return values.sort($1e4969cac10d97e7$export$5708b2c031939e56(f));
}
function $1e4969cac10d97e7$export$5708b2c031939e56(compare = (0, $mbn54.default)) {
    if (compare === (0, $mbn54.default)) return $1e4969cac10d97e7$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $1e4969cac10d97e7$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("fCvvC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02ef458f07e5494a$export$2e2bcd8739ae039; });
function $02ef458f07e5494a$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("7zhHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $582987511de42a1d$export$2e2bcd8739ae039; });

var $2KuNW = parcelRequire("2KuNW");

var $eZf2H = parcelRequire("eZf2H");

var $1QK9D = parcelRequire("1QK9D");

var $eI3Wa = parcelRequire("eI3Wa");

var $knVCG = parcelRequire("knVCG");

var $dAZOc = parcelRequire("dAZOc");

var $amLJv = parcelRequire("amLJv");

var $ihuha = parcelRequire("ihuha");
function $582987511de42a1d$export$2e2bcd8739ae039() {
    var value = (0, $knVCG.default), domain = (0, $eI3Wa.default), threshold = (0, $ihuha.default);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, $eI3Wa.default)) [x0, x1] = (0, $dAZOc.default)(x0, x1, tn);
            tz = (0, $amLJv.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $amLJv.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, $eI3Wa.default)) {
                    const step = (0, $amLJv.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $eZf2H.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $1QK9D.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $1QK9D.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, $1QK9D.default)(Array.isArray(_) ? (0, $2KuNW.slice).call(_) : _), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("2KuNW", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $2007c5c2e738318d$export$58adb3bec8346d0f; });
var $2007c5c2e738318d$var$array = Array.prototype;
var $2007c5c2e738318d$export$58adb3bec8346d0f = $2007c5c2e738318d$var$array.slice;
var $2007c5c2e738318d$export$871de8747c9eaa88 = $2007c5c2e738318d$var$array.map;

});

parcelRegister("1QK9D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $158e731257ce8494$export$2e2bcd8739ae039; });
function $158e731257ce8494$export$2e2bcd8739ae039(x) {
    return ()=>x;
}

});

parcelRegister("dAZOc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e5e951138e8652a$export$2e2bcd8739ae039; });

var $amLJv = parcelRequire("amLJv");
function $9e5e951138e8652a$export$2e2bcd8739ae039(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $amLJv.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("amLJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c0fc3f3932ac84$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "tickIncrement", function () { return $78c0fc3f3932ac84$export$bc64d00cc98e7e95; });
$parcel$export(module.exports, "tickStep", function () { return $78c0fc3f3932ac84$export$81087d9b915d4ede; });
const $78c0fc3f3932ac84$var$e10 = Math.sqrt(50), $78c0fc3f3932ac84$var$e5 = Math.sqrt(10), $78c0fc3f3932ac84$var$e2 = Math.sqrt(2);
function $78c0fc3f3932ac84$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $78c0fc3f3932ac84$var$e10 ? 10 : error >= $78c0fc3f3932ac84$var$e5 ? 5 : error >= $78c0fc3f3932ac84$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $78c0fc3f3932ac84$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $78c0fc3f3932ac84$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $78c0fc3f3932ac84$var$tickSpec(stop, start, count) : $78c0fc3f3932ac84$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $78c0fc3f3932ac84$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $78c0fc3f3932ac84$var$tickSpec(start, stop, count)[2];
}
function $78c0fc3f3932ac84$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $78c0fc3f3932ac84$export$bc64d00cc98e7e95(stop, start, count) : $78c0fc3f3932ac84$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

});


parcelRegister("ihuha", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4f14cb3ae02c199$export$2e2bcd8739ae039; });

var $iVCja = parcelRequire("iVCja");
function $d4f14cb3ae02c199$export$2e2bcd8739ae039(values) {
    return Math.max(1, Math.ceil(Math.log((0, $iVCja.default)(values)) / Math.LN2) + 1);
}

});


parcelRegister("1SUeo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15f673e6c2557e02$export$2e2bcd8739ae039; });

var $iVCja = parcelRequire("iVCja");

var $hr3aa = parcelRequire("hr3aa");
function $15f673e6c2557e02$export$2e2bcd8739ae039(values, min, max) {
    const c = (0, $iVCja.default)(values), d = (0, $hr3aa.default)(values, 0.75) - (0, $hr3aa.default)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}

});
parcelRegister("hr3aa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb17695d3d1ddc06$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "quantileSorted", function () { return $cb17695d3d1ddc06$export$f924a6cad778dddb; });
$parcel$export(module.exports, "quantileIndex", function () { return $cb17695d3d1ddc06$export$f1fcc854ecc6ce55; });

var $NBzfP = parcelRequire("NBzfP");

var $6Y8eX = parcelRequire("6Y8eX");

var $xN89R = parcelRequire("xN89R");

var $jElCj = parcelRequire("jElCj");

var $9CpqA = parcelRequire("9CpqA");

var $deGR4 = parcelRequire("deGR4");

var $2Bdnp = parcelRequire("2Bdnp");

var $bP9Pg = parcelRequire("bP9Pg");
function $cb17695d3d1ddc06$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $deGR4.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $xN89R.default)(values);
    if (p >= 1) return (0, $NBzfP.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $NBzfP.default)((0, $9CpqA.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $xN89R.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $cb17695d3d1ddc06$export$f924a6cad778dddb(values, p, valueof = (0, $deGR4.default)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $cb17695d3d1ddc06$export$f1fcc854ecc6ce55(values, p, valueof) {
    values = Float64Array.from((0, $deGR4.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $jElCj.default)(values);
    if (p >= 1) return (0, $6Y8eX.default)(values);
    var n, i = Math.floor((n - 1) * p), order = (i, j)=>(0, $2Bdnp.ascendingDefined)(values[i], values[j]), index = (0, $9CpqA.default)(Uint32Array.from(values, (_, i)=>i), i, 0, n - 1, order);
    return (0, $bP9Pg.default)(index.subarray(0, i + 1), (i)=>values[i]);
}

});
parcelRegister("NBzfP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0951b7dd4c8575df$export$2e2bcd8739ae039; });
function $0951b7dd4c8575df$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("6Y8eX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $512ebd092b25576a$export$2e2bcd8739ae039; });
function $512ebd092b25576a$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("xN89R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0659317e0a2bbdb3$export$2e2bcd8739ae039; });
function $0659317e0a2bbdb3$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("jElCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4e28568a5a4ee56$export$2e2bcd8739ae039; });
function $e4e28568a5a4ee56$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("9CpqA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $700b6318869c154a$export$2e2bcd8739ae039; });

var $2Bdnp = parcelRequire("2Bdnp");
function $700b6318869c154a$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $2Bdnp.ascendingDefined) : (0, $2Bdnp.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $700b6318869c154a$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $700b6318869c154a$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $700b6318869c154a$var$swap(array, left, right);
        while(i < j){
            $700b6318869c154a$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $700b6318869c154a$var$swap(array, left, j);
        else ++j, $700b6318869c154a$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $700b6318869c154a$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});

parcelRegister("bP9Pg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89bc14585ed10ed0$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");
function $89bc14585ed10ed0$export$2e2bcd8739ae039(values, compare = (0, $mbn54.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $mbn54.default)(value, maxValue) > 0 : (0, $mbn54.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});



parcelRegister("gvXVQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c05e07d87f3b4f84$export$2e2bcd8739ae039; });

var $iVCja = parcelRequire("iVCja");

var $3vzLS = parcelRequire("3vzLS");
function $c05e07d87f3b4f84$export$2e2bcd8739ae039(values, min, max) {
    const c = (0, $iVCja.default)(values), d = (0, $3vzLS.default)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}

});

parcelRegister("cHRaL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9402bf2cb890cc63$export$2e2bcd8739ae039; });
function $9402bf2cb890cc63$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("boQL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84cadc85f238abae$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "medianIndex", function () { return $84cadc85f238abae$export$57546ab4fd3c7a5e; });

var $hr3aa = parcelRequire("hr3aa");
function $84cadc85f238abae$export$2e2bcd8739ae039(values, valueof) {
    return (0, $hr3aa.default)(values, 0.5, valueof);
}
function $84cadc85f238abae$export$57546ab4fd3c7a5e(values, valueof) {
    return (0, $hr3aa.quantileIndex)(values, 0.5, valueof);
}

});

parcelRegister("4AHKb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $357c74d29197523c$export$2e2bcd8739ae039; });
function* $357c74d29197523c$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $357c74d29197523c$export$2e2bcd8739ae039(arrays) {
    return Array.from($357c74d29197523c$var$flatten(arrays));
}

});

parcelRegister("4Pd24", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $383608d007b93561$export$2e2bcd8739ae039; });

var $9Y6md = parcelRequire("9Y6md");
function $383608d007b93561$export$2e2bcd8739ae039(values, valueof) {
    const counts = new (0, $9Y6md.InternMap)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("lAYzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb8bf28ab0c836c2$export$2e2bcd8739ae039; });
function $fb8bf28ab0c836c2$export$2e2bcd8739ae039(values, pairof = $fb8bf28ab0c836c2$export$a04cb3fe8b81dd) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $fb8bf28ab0c836c2$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("6jvVk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $498d47c8e719f6c2$export$2e2bcd8739ae039; });
function $498d47c8e719f6c2$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("iXkno", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dccd8afa67736b61$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");

var $2Bdnp = parcelRequire("2Bdnp");
function $dccd8afa67736b61$export$2e2bcd8739ae039(values, valueof = (0, $mbn54.default)) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = (0, $mbn54.default);
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === (0, $mbn54.default) ? (i, j)=>(0, $2Bdnp.ascendingDefined)(V[i], V[j]) : (0, $2Bdnp.compareDefined)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("hGKSX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce0aba66b62aa8b4$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");
function $ce0aba66b62aa8b4$export$2e2bcd8739ae039(values, compare = (0, $mbn54.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $mbn54.default)(value, minValue) < 0 : (0, $mbn54.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("d8qfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $990063a906682846$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");

var $jElCj = parcelRequire("jElCj");
function $990063a906682846$export$2e2bcd8739ae039(values, compare = (0, $mbn54.default)) {
    if (compare.length === 1) return (0, $jElCj.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("ipkua", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d66a73d00c1caf62$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");

var $6Y8eX = parcelRequire("6Y8eX");
function $d66a73d00c1caf62$export$2e2bcd8739ae039(values, compare = (0, $mbn54.default)) {
    if (compare.length === 1) return (0, $6Y8eX.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("gkxAz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be3891a9cd1f91c0$export$2e2bcd8739ae039; });

var $d8qfW = parcelRequire("d8qfW");
function $be3891a9cd1f91c0$export$2e2bcd8739ae039(values, compare) {
    const index = (0, $d8qfW.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("6EWLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d940f3fdd31cc44$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "shuffler", function () { return $4d940f3fdd31cc44$export$a430ea578c95d356; });
var $4d940f3fdd31cc44$export$2e2bcd8739ae039 = $4d940f3fdd31cc44$export$a430ea578c95d356(Math.random);
function $4d940f3fdd31cc44$export$a430ea578c95d356(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("a8nTT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $760d30ddb30bcd7e$export$2e2bcd8739ae039; });
function $760d30ddb30bcd7e$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("gNswG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3a759a73e45fb54$export$2e2bcd8739ae039; });

var $xN89R = parcelRequire("xN89R");
function $c3a759a73e45fb54$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $xN89R.default)(matrix, $c3a759a73e45fb54$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $c3a759a73e45fb54$var$length(d) {
    return d.length;
}

});

parcelRegister("f9sL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b07e013c3c70c61e$export$2e2bcd8739ae039; });

var $gNswG = parcelRequire("gNswG");
function $b07e013c3c70c61e$export$2e2bcd8739ae039() {
    return (0, $gNswG.default)(arguments);
}

});

parcelRegister("5MF5l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43614e20a1c32d70$export$2e2bcd8739ae039; });
function $43614e20a1c32d70$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("iJUUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da48935231f9a892$export$2e2bcd8739ae039; });
function $da48935231f9a892$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("9gpbC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6be92527c5f21a47$export$2e2bcd8739ae039; });
function $6be92527c5f21a47$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("3jLKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a8303f70873fa4$export$2e2bcd8739ae039; });
function $26a8303f70873fa4$export$2e2bcd8739ae039(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("ekQxE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fbb0ab6543725f$export$2e2bcd8739ae039; });
function $a6fbb0ab6543725f$export$2e2bcd8739ae039(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("9jDib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c845e092d389ed2$export$2e2bcd8739ae039; });
function $6c845e092d389ed2$export$2e2bcd8739ae039(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("8G4dS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65158587165166cf$export$2e2bcd8739ae039; });

var $9Y6md = parcelRequire("9Y6md");
function $65158587165166cf$export$2e2bcd8739ae039(values, ...others) {
    values = new (0, $9Y6md.InternSet)(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("6gpBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48f819d5f90dcab1$export$2e2bcd8739ae039; });

var $9Y6md = parcelRequire("9Y6md");
function $48f819d5f90dcab1$export$2e2bcd8739ae039(values, other) {
    const iterator = other[Symbol.iterator](), set = new (0, $9Y6md.InternSet)();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("jC0Xp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4724f087bc3b62f$export$2e2bcd8739ae039; });

var $9Y6md = parcelRequire("9Y6md");
function $e4724f087bc3b62f$export$2e2bcd8739ae039(values, ...others) {
    values = new (0, $9Y6md.InternSet)(values);
    others = others.map($e4724f087bc3b62f$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $e4724f087bc3b62f$var$set(values) {
    return values instanceof (0, $9Y6md.InternSet) ? values : new (0, $9Y6md.InternSet)(values);
}

});

parcelRegister("2VOGt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2228386acda625fd$export$2e2bcd8739ae039; });

var $8LDeD = parcelRequire("8LDeD");
function $2228386acda625fd$export$2e2bcd8739ae039(values, other) {
    return (0, $8LDeD.default)(other, values);
}

});
parcelRegister("8LDeD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $662125c278c4305d$export$2e2bcd8739ae039; });
function $662125c278c4305d$export$2e2bcd8739ae039(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $662125c278c4305d$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $662125c278c4305d$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $662125c278c4305d$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("i1Ei2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f792c22cda77e5$export$2e2bcd8739ae039; });

var $9Y6md = parcelRequire("9Y6md");
function $d1f792c22cda77e5$export$2e2bcd8739ae039(...others) {
    const set = new (0, $9Y6md.InternSet)();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("kMcPQ", function(module, exports) {

$parcel$export(module.exports, "axisTop", function () { return (parcelRequire("9nwsJ")).axisTop; });
$parcel$export(module.exports, "axisRight", function () { return (parcelRequire("9nwsJ")).axisRight; });
$parcel$export(module.exports, "axisBottom", function () { return (parcelRequire("9nwsJ")).axisBottom; });
$parcel$export(module.exports, "axisLeft", function () { return (parcelRequire("9nwsJ")).axisLeft; });

var $9nwsJ = parcelRequire("9nwsJ");

});
parcelRegister("9nwsJ", function(module, exports) {

$parcel$export(module.exports, "axisTop", function () { return $6d3f716a993cbaf8$export$59b8cfab074bdeb1; });
$parcel$export(module.exports, "axisRight", function () { return $6d3f716a993cbaf8$export$b0d2e24dc4f898f0; });
$parcel$export(module.exports, "axisBottom", function () { return $6d3f716a993cbaf8$export$e5cb22533a15e72e; });
$parcel$export(module.exports, "axisLeft", function () { return $6d3f716a993cbaf8$export$2749afb169a520d2; });

var $79cpB = parcelRequire("79cpB");
var $6d3f716a993cbaf8$var$top = 1, $6d3f716a993cbaf8$var$right = 2, $6d3f716a993cbaf8$var$bottom = 3, $6d3f716a993cbaf8$var$left = 4, $6d3f716a993cbaf8$var$epsilon = 1e-6;
function $6d3f716a993cbaf8$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $6d3f716a993cbaf8$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $6d3f716a993cbaf8$var$number(scale) {
    return (d)=>+scale(d);
}
function $6d3f716a993cbaf8$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $6d3f716a993cbaf8$var$entering() {
    return !this.__axis;
}
function $6d3f716a993cbaf8$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $6d3f716a993cbaf8$var$top || orient === $6d3f716a993cbaf8$var$left ? -1 : 1, x = orient === $6d3f716a993cbaf8$var$left || orient === $6d3f716a993cbaf8$var$right ? "x" : "y", transform = orient === $6d3f716a993cbaf8$var$top || orient === $6d3f716a993cbaf8$var$bottom ? $6d3f716a993cbaf8$var$translateX : $6d3f716a993cbaf8$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $79cpB.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $6d3f716a993cbaf8$var$center : $6d3f716a993cbaf8$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $6d3f716a993cbaf8$var$top ? "0em" : orient === $6d3f716a993cbaf8$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $6d3f716a993cbaf8$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $6d3f716a993cbaf8$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $6d3f716a993cbaf8$var$left || orient === $6d3f716a993cbaf8$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($6d3f716a993cbaf8$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $6d3f716a993cbaf8$var$right ? "start" : orient === $6d3f716a993cbaf8$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $6d3f716a993cbaf8$export$59b8cfab074bdeb1(scale) {
    return $6d3f716a993cbaf8$var$axis($6d3f716a993cbaf8$var$top, scale);
}
function $6d3f716a993cbaf8$export$b0d2e24dc4f898f0(scale) {
    return $6d3f716a993cbaf8$var$axis($6d3f716a993cbaf8$var$right, scale);
}
function $6d3f716a993cbaf8$export$e5cb22533a15e72e(scale) {
    return $6d3f716a993cbaf8$var$axis($6d3f716a993cbaf8$var$bottom, scale);
}
function $6d3f716a993cbaf8$export$2749afb169a520d2(scale) {
    return $6d3f716a993cbaf8$var$axis($6d3f716a993cbaf8$var$left, scale);
}

});
parcelRegister("79cpB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534300656a115810$export$2e2bcd8739ae039; });
function $534300656a115810$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("ktMqu", function(module, exports) {

$parcel$export(module.exports, "brush", function () { return (parcelRequire("lSVqV")).default; });
$parcel$export(module.exports, "brushX", function () { return (parcelRequire("lSVqV")).brushX; });
$parcel$export(module.exports, "brushY", function () { return (parcelRequire("lSVqV")).brushY; });
$parcel$export(module.exports, "brushSelection", function () { return (parcelRequire("lSVqV")).brushSelection; });

var $lSVqV = parcelRequire("lSVqV");

});
parcelRegister("lSVqV", function(module, exports) {

$parcel$export(module.exports, "brushSelection", function () { return $feeb3127ba1dde11$export$69760394fc76f689; });
$parcel$export(module.exports, "brushX", function () { return $feeb3127ba1dde11$export$979ace6c88860aa8; });
$parcel$export(module.exports, "brushY", function () { return $feeb3127ba1dde11$export$468748b530991c54; });
$parcel$export(module.exports, "default", function () { return $feeb3127ba1dde11$export$2e2bcd8739ae039; });

var $5Rufx = parcelRequire("5Rufx");

var $bQ9aN = parcelRequire("bQ9aN");

var $hAt8X = parcelRequire("hAt8X");

var $pd5FT = parcelRequire("pd5FT");
var $3xlsS = parcelRequire("3xlsS");
parcelRequire("buDM2");
var $1WXFO = parcelRequire("1WXFO");

var $d4WCG = parcelRequire("d4WCG");

var $lFPki = parcelRequire("lFPki");

var $lgmjO = parcelRequire("lgmjO");
var $feeb3127ba1dde11$var$MODE_DRAG = {
    name: "drag"
}, $feeb3127ba1dde11$var$MODE_SPACE = {
    name: "space"
}, $feeb3127ba1dde11$var$MODE_HANDLE = {
    name: "handle"
}, $feeb3127ba1dde11$var$MODE_CENTER = {
    name: "center"
};
const { abs: $feeb3127ba1dde11$var$abs, max: $feeb3127ba1dde11$var$max, min: $feeb3127ba1dde11$var$min } = Math;
function $feeb3127ba1dde11$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $feeb3127ba1dde11$var$number2(e) {
    return [
        $feeb3127ba1dde11$var$number1(e[0]),
        $feeb3127ba1dde11$var$number1(e[1])
    ];
}
var $feeb3127ba1dde11$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($feeb3127ba1dde11$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $feeb3127ba1dde11$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($feeb3127ba1dde11$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $feeb3127ba1dde11$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($feeb3127ba1dde11$var$type),
    input: function(xy) {
        return xy == null ? null : $feeb3127ba1dde11$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $feeb3127ba1dde11$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $feeb3127ba1dde11$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $feeb3127ba1dde11$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $feeb3127ba1dde11$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $feeb3127ba1dde11$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $feeb3127ba1dde11$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $feeb3127ba1dde11$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $feeb3127ba1dde11$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $feeb3127ba1dde11$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $feeb3127ba1dde11$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $feeb3127ba1dde11$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $feeb3127ba1dde11$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $feeb3127ba1dde11$export$979ace6c88860aa8() {
    return $feeb3127ba1dde11$var$brush($feeb3127ba1dde11$var$X);
}
function $feeb3127ba1dde11$export$468748b530991c54() {
    return $feeb3127ba1dde11$var$brush($feeb3127ba1dde11$var$Y);
}
function $feeb3127ba1dde11$export$2e2bcd8739ae039() {
    return $feeb3127ba1dde11$var$brush($feeb3127ba1dde11$var$XY);
}
function $feeb3127ba1dde11$var$brush(dim) {
    var extent = $feeb3127ba1dde11$var$defaultExtent, filter = $feeb3127ba1dde11$var$defaultFilter, touchable = $feeb3127ba1dde11$var$defaultTouchable, keys = true, listeners = (0, $5Rufx.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $feeb3127ba1dde11$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $feeb3127ba1dde11$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $feeb3127ba1dde11$var$local(this).extent;
            (0, $3xlsS.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $feeb3127ba1dde11$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $feeb3127ba1dde11$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $feeb3127ba1dde11$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $hAt8X.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $1WXFO.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $3xlsS.default)(this), selection = $feeb3127ba1dde11$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $3xlsS.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $lFPki.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $feeb3127ba1dde11$var$MODE_DRAG : keys && event.altKey ? $feeb3127ba1dde11$var$MODE_CENTER : $feeb3127ba1dde11$var$MODE_HANDLE, signX = dim === $feeb3127ba1dde11$var$Y ? null : $feeb3127ba1dde11$var$signsX[type], signY = dim === $feeb3127ba1dde11$var$X ? null : $feeb3127ba1dde11$var$signsY[type], state = $feeb3127ba1dde11$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $pd5FT.default)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $1WXFO.default)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $feeb3127ba1dde11$var$Y ? W : $feeb3127ba1dde11$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $feeb3127ba1dde11$var$X ? N : $feeb3127ba1dde11$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $feeb3127ba1dde11$var$Y ? E : $feeb3127ba1dde11$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $feeb3127ba1dde11$var$X ? S : $feeb3127ba1dde11$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $3xlsS.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $feeb3127ba1dde11$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $3xlsS.default)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $bQ9aN.default)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $pd5FT.default)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($feeb3127ba1dde11$var$abs(point.cur[0] - point[0]) > $feeb3127ba1dde11$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $lgmjO.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $feeb3127ba1dde11$var$MODE_SPACE:
                case $feeb3127ba1dde11$var$MODE_DRAG:
                    if (signX) dx = $feeb3127ba1dde11$var$max(W - w0, $feeb3127ba1dde11$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $feeb3127ba1dde11$var$max(N - n0, $feeb3127ba1dde11$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $feeb3127ba1dde11$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $feeb3127ba1dde11$var$max(W, $feeb3127ba1dde11$var$min(E, points[0][0])), e1 = $feeb3127ba1dde11$var$max(W, $feeb3127ba1dde11$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $feeb3127ba1dde11$var$max(N, $feeb3127ba1dde11$var$min(S, points[0][1])), s1 = $feeb3127ba1dde11$var$max(N, $feeb3127ba1dde11$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $feeb3127ba1dde11$var$max(W - w0, $feeb3127ba1dde11$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $feeb3127ba1dde11$var$max(W - e0, $feeb3127ba1dde11$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $feeb3127ba1dde11$var$max(N - n0, $feeb3127ba1dde11$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $feeb3127ba1dde11$var$max(N - s0, $feeb3127ba1dde11$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $feeb3127ba1dde11$var$MODE_CENTER:
                    if (signX) w1 = $feeb3127ba1dde11$var$max(W, $feeb3127ba1dde11$var$min(E, w0 - dx * signX)), e1 = $feeb3127ba1dde11$var$max(W, $feeb3127ba1dde11$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $feeb3127ba1dde11$var$max(N, $feeb3127ba1dde11$var$min(S, n0 - dy * signY)), s1 = $feeb3127ba1dde11$var$max(N, $feeb3127ba1dde11$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $feeb3127ba1dde11$var$flipX) overlay.attr("cursor", $feeb3127ba1dde11$var$cursors[type = $feeb3127ba1dde11$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $feeb3127ba1dde11$var$flipY) overlay.attr("cursor", $feeb3127ba1dde11$var$cursors[type = $feeb3127ba1dde11$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $lgmjO.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $bQ9aN.yesdrag)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $feeb3127ba1dde11$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($feeb3127ba1dde11$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $feeb3127ba1dde11$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $feeb3127ba1dde11$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $feeb3127ba1dde11$var$MODE_HANDLE || mode === $feeb3127ba1dde11$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $feeb3127ba1dde11$var$MODE_SPACE;
                        overlay.attr("cursor", $feeb3127ba1dde11$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $lgmjO.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $feeb3127ba1dde11$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $feeb3127ba1dde11$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $feeb3127ba1dde11$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $feeb3127ba1dde11$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $feeb3127ba1dde11$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $feeb3127ba1dde11$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $lgmjO.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $feeb3127ba1dde11$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $d4WCG.default)($feeb3127ba1dde11$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $d4WCG.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $d4WCG.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("5Rufx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44495def34fc3bfb$export$2e2bcd8739ae039; });
var $44495def34fc3bfb$var$noop = {
    value: ()=>{}
};
function $44495def34fc3bfb$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $44495def34fc3bfb$var$Dispatch(_);
}
function $44495def34fc3bfb$var$Dispatch(_) {
    this._ = _;
}
function $44495def34fc3bfb$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$44495def34fc3bfb$var$Dispatch.prototype = $44495def34fc3bfb$var$dispatch.prototype = {
    constructor: $44495def34fc3bfb$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $44495def34fc3bfb$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $44495def34fc3bfb$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $44495def34fc3bfb$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $44495def34fc3bfb$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $44495def34fc3bfb$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $44495def34fc3bfb$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $44495def34fc3bfb$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $44495def34fc3bfb$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $44495def34fc3bfb$export$2e2bcd8739ae039 = $44495def34fc3bfb$var$dispatch;

});

parcelRegister("bQ9aN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89ebaaa0d3474282$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "yesdrag", function () { return $89ebaaa0d3474282$export$833237748009e1e1; });

var $3xlsS = parcelRequire("3xlsS");

var $fz6ZW = parcelRequire("fz6ZW");
function $89ebaaa0d3474282$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $3xlsS.default)(view).on("dragstart.drag", (0, $fz6ZW.default), (0, $fz6ZW.nonpassivecapture));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $fz6ZW.default), (0, $fz6ZW.nonpassivecapture));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $89ebaaa0d3474282$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $3xlsS.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $fz6ZW.default), (0, $fz6ZW.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("3xlsS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29351aa1394de652$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");
function $29351aa1394de652$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $lkjtJ.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $lkjtJ.Selection)([
        [
            selector
        ]
    ], (0, $lkjtJ.root));
}

});
parcelRegister("lkjtJ", function(module, exports) {

$parcel$export(module.exports, "root", function () { return $f86a9344da678f18$export$e8e78c978b129247; });
$parcel$export(module.exports, "Selection", function () { return $f86a9344da678f18$export$52baac22726c72bf; });
$parcel$export(module.exports, "default", function () { return $f86a9344da678f18$export$2e2bcd8739ae039; });

var $i6fZJ = parcelRequire("i6fZJ");

var $acWad = parcelRequire("acWad");

var $g9Fju = parcelRequire("g9Fju");

var $ig0c2 = parcelRequire("ig0c2");

var $8Ez7P = parcelRequire("8Ez7P");

var $8sr2V = parcelRequire("8sr2V");

var $8sdRF = parcelRequire("8sdRF");

var $2CT62 = parcelRequire("2CT62");

var $6MkIX = parcelRequire("6MkIX");

var $gadTF = parcelRequire("gadTF");

var $3zqGg = parcelRequire("3zqGg");

var $3jlxq = parcelRequire("3jlxq");

var $hJdyd = parcelRequire("hJdyd");

var $6dbi2 = parcelRequire("6dbi2");

var $jeAIg = parcelRequire("jeAIg");

var $lw4vp = parcelRequire("lw4vp");

var $6qOMB = parcelRequire("6qOMB");

var $j18W8 = parcelRequire("j18W8");

var $84Th5 = parcelRequire("84Th5");

var $hxyOW = parcelRequire("hxyOW");

var $7ajhL = parcelRequire("7ajhL");

var $dS3z4 = parcelRequire("dS3z4");

var $bXETX = parcelRequire("bXETX");

var $3XVdH = parcelRequire("3XVdH");

var $5TyV2 = parcelRequire("5TyV2");

var $bGOs7 = parcelRequire("bGOs7");

var $PQqvi = parcelRequire("PQqvi");

var $jGJRL = parcelRequire("jGJRL");

var $8hsq3 = parcelRequire("8hsq3");

var $a17Mu = parcelRequire("a17Mu");

var $7zOJF = parcelRequire("7zOJF");

var $aXoYl = parcelRequire("aXoYl");

var $5jhFo = parcelRequire("5jhFo");

var $6GcfU = parcelRequire("6GcfU");
var $f86a9344da678f18$export$e8e78c978b129247 = [
    null
];
function $f86a9344da678f18$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $f86a9344da678f18$var$selection() {
    return new $f86a9344da678f18$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $f86a9344da678f18$export$e8e78c978b129247);
}
function $f86a9344da678f18$var$selection_selection() {
    return this;
}
$f86a9344da678f18$export$52baac22726c72bf.prototype = $f86a9344da678f18$var$selection.prototype = {
    constructor: $f86a9344da678f18$export$52baac22726c72bf,
    select: (0, $i6fZJ.default),
    selectAll: (0, $acWad.default),
    selectChild: (0, $g9Fju.default),
    selectChildren: (0, $ig0c2.default),
    filter: (0, $8Ez7P.default),
    data: (0, $8sr2V.default),
    enter: (0, $8sdRF.default),
    exit: (0, $2CT62.default),
    join: (0, $6MkIX.default),
    merge: (0, $gadTF.default),
    selection: $f86a9344da678f18$var$selection_selection,
    order: (0, $3zqGg.default),
    sort: (0, $3jlxq.default),
    call: (0, $hJdyd.default),
    nodes: (0, $6dbi2.default),
    node: (0, $jeAIg.default),
    size: (0, $lw4vp.default),
    empty: (0, $6qOMB.default),
    each: (0, $j18W8.default),
    attr: (0, $84Th5.default),
    style: (0, $hxyOW.default),
    property: (0, $7ajhL.default),
    classed: (0, $dS3z4.default),
    text: (0, $bXETX.default),
    html: (0, $3XVdH.default),
    raise: (0, $5TyV2.default),
    lower: (0, $bGOs7.default),
    append: (0, $PQqvi.default),
    insert: (0, $jGJRL.default),
    remove: (0, $8hsq3.default),
    clone: (0, $a17Mu.default),
    datum: (0, $7zOJF.default),
    on: (0, $aXoYl.default),
    dispatch: (0, $5jhFo.default),
    [Symbol.iterator]: (0, $6GcfU.default)
};
var $f86a9344da678f18$export$2e2bcd8739ae039 = $f86a9344da678f18$var$selection;

});
parcelRegister("i6fZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2d531bd0be8763d$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");

var $dTsqF = parcelRequire("dTsqF");
function $d2d531bd0be8763d$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $dTsqF.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $lkjtJ.Selection)(subgroups, this._parents);
}

});
parcelRegister("dTsqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1d676dc2514e7c2$export$2e2bcd8739ae039; });
function $a1d676dc2514e7c2$var$none() {}
function $a1d676dc2514e7c2$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a1d676dc2514e7c2$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("acWad", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76e8247d0ab918dd$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");

var $4EN9f = parcelRequire("4EN9f");

var $cuaq4 = parcelRequire("cuaq4");
function $76e8247d0ab918dd$var$arrayAll(select) {
    return function() {
        return (0, $4EN9f.default)(select.apply(this, arguments));
    };
}
function $76e8247d0ab918dd$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $76e8247d0ab918dd$var$arrayAll(select);
    else select = (0, $cuaq4.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $lkjtJ.Selection)(subgroups, parents);
}

});
parcelRegister("4EN9f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $364105aae16f555e$export$2e2bcd8739ae039; });
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $364105aae16f555e$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

});

parcelRegister("cuaq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91705e74ef079673$export$2e2bcd8739ae039; });
function $91705e74ef079673$var$empty() {
    return [];
}
function $91705e74ef079673$export$2e2bcd8739ae039(selector) {
    return selector == null ? $91705e74ef079673$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("g9Fju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc2d888e27635a51$export$2e2bcd8739ae039; });

var $fso1b = parcelRequire("fso1b");
var $bc2d888e27635a51$var$find = Array.prototype.find;
function $bc2d888e27635a51$var$childFind(match) {
    return function() {
        return $bc2d888e27635a51$var$find.call(this.children, match);
    };
}
function $bc2d888e27635a51$var$childFirst() {
    return this.firstElementChild;
}
function $bc2d888e27635a51$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $bc2d888e27635a51$var$childFirst : $bc2d888e27635a51$var$childFind(typeof match === "function" ? match : (0, $fso1b.childMatcher)(match)));
}

});
parcelRegister("fso1b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b40c1a0204fd35ad$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "childMatcher", function () { return $b40c1a0204fd35ad$export$90c2759c036528; });
function $b40c1a0204fd35ad$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $b40c1a0204fd35ad$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

});


parcelRegister("ig0c2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a9defdd4bc611d$export$2e2bcd8739ae039; });

var $fso1b = parcelRequire("fso1b");
var $d4a9defdd4bc611d$var$filter = Array.prototype.filter;
function $d4a9defdd4bc611d$var$children() {
    return Array.from(this.children);
}
function $d4a9defdd4bc611d$var$childrenFilter(match) {
    return function() {
        return $d4a9defdd4bc611d$var$filter.call(this.children, match);
    };
}
function $d4a9defdd4bc611d$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $d4a9defdd4bc611d$var$children : $d4a9defdd4bc611d$var$childrenFilter(typeof match === "function" ? match : (0, $fso1b.childMatcher)(match)));
}

});

parcelRegister("8Ez7P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64cd4e4a61a1bb24$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");

var $fso1b = parcelRequire("fso1b");
function $64cd4e4a61a1bb24$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $fso1b.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $lkjtJ.Selection)(subgroups, this._parents);
}

});

parcelRegister("8sr2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6285eb1265ff28ca$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");

var $8sdRF = parcelRequire("8sdRF");

var $6Ed4g = parcelRequire("6Ed4g");
function $6285eb1265ff28ca$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $8sdRF.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $6285eb1265ff28ca$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $8sdRF.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $6285eb1265ff28ca$var$datum(node) {
    return node.__data__;
}
function $6285eb1265ff28ca$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $6285eb1265ff28ca$var$datum);
    var bind = key ? $6285eb1265ff28ca$var$bindKey : $6285eb1265ff28ca$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $6Ed4g.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $6285eb1265ff28ca$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $lkjtJ.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $6285eb1265ff28ca$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

});
parcelRegister("8sdRF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $627bb17a7ccfae31$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "EnterNode", function () { return $627bb17a7ccfae31$export$67b01759a14cf6a4; });

var $4V9Dx = parcelRequire("4V9Dx");

var $lkjtJ = parcelRequire("lkjtJ");
function $627bb17a7ccfae31$export$2e2bcd8739ae039() {
    return new (0, $lkjtJ.Selection)(this._enter || this._groups.map((0, $4V9Dx.default)), this._parents);
}
function $627bb17a7ccfae31$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$627bb17a7ccfae31$export$67b01759a14cf6a4.prototype = {
    constructor: $627bb17a7ccfae31$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("4V9Dx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3953f5f24f2c7956$export$2e2bcd8739ae039; });
function $3953f5f24f2c7956$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("6Ed4g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d709d7ef1dfebb5$export$2e2bcd8739ae039; });
function $4d709d7ef1dfebb5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("2CT62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e99de5acc80bffa$export$2e2bcd8739ae039; });

var $4V9Dx = parcelRequire("4V9Dx");

var $lkjtJ = parcelRequire("lkjtJ");
function $1e99de5acc80bffa$export$2e2bcd8739ae039() {
    return new (0, $lkjtJ.Selection)(this._exit || this._groups.map((0, $4V9Dx.default)), this._parents);
}

});

parcelRegister("6MkIX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ef74d2b98a8f112$export$2e2bcd8739ae039; });
function $4ef74d2b98a8f112$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("gadTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc485c295c37a11e$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");
function $bc485c295c37a11e$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $lkjtJ.Selection)(merges, this._parents);
}

});

parcelRegister("3zqGg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29995634681ba0cf$export$2e2bcd8739ae039; });
function $29995634681ba0cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("3jlxq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2693da7d76959320$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");
function $2693da7d76959320$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $2693da7d76959320$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $lkjtJ.Selection)(sortgroups, this._parents).order();
}
function $2693da7d76959320$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("hJdyd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce812689b08948ce$export$2e2bcd8739ae039; });
function $ce812689b08948ce$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("6dbi2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $485cb6ecaff9913a$export$2e2bcd8739ae039; });
function $485cb6ecaff9913a$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("jeAIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e00bcd90001c0a61$export$2e2bcd8739ae039; });
function $e00bcd90001c0a61$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("lw4vp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faa014d42d863c05$export$2e2bcd8739ae039; });
function $faa014d42d863c05$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}

});

parcelRegister("6qOMB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4aec9036ca9cd922$export$2e2bcd8739ae039; });
function $4aec9036ca9cd922$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("j18W8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd850af168091206$export$2e2bcd8739ae039; });
function $dd850af168091206$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("84Th5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e1992d8a2a0b08e$export$2e2bcd8739ae039; });

var $kAMSn = parcelRequire("kAMSn");
function $5e1992d8a2a0b08e$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $5e1992d8a2a0b08e$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $5e1992d8a2a0b08e$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $5e1992d8a2a0b08e$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $5e1992d8a2a0b08e$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $5e1992d8a2a0b08e$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $5e1992d8a2a0b08e$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $kAMSn.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $5e1992d8a2a0b08e$var$attrRemoveNS : $5e1992d8a2a0b08e$var$attrRemove : typeof value === "function" ? fullname.local ? $5e1992d8a2a0b08e$var$attrFunctionNS : $5e1992d8a2a0b08e$var$attrFunction : fullname.local ? $5e1992d8a2a0b08e$var$attrConstantNS : $5e1992d8a2a0b08e$var$attrConstant)(fullname, value));
}

});
parcelRegister("kAMSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efdd1534ede7be16$export$2e2bcd8739ae039; });

var $2nesS = parcelRequire("2nesS");
function $efdd1534ede7be16$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $2nesS.default).hasOwnProperty(prefix) ? {
        space: (0, $2nesS.default)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}

});
parcelRegister("2nesS", function(module, exports) {

$parcel$export(module.exports, "xhtml", function () { return $1ba8f3240975edb2$export$201a3f7520ccc326; });
$parcel$export(module.exports, "default", function () { return $1ba8f3240975edb2$export$2e2bcd8739ae039; });
var $1ba8f3240975edb2$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $1ba8f3240975edb2$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $1ba8f3240975edb2$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("hxyOW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc508768cef3ac26$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "styleValue", function () { return $cc508768cef3ac26$export$5e3cec964f0b5efd; });

var $9Wm3c = parcelRequire("9Wm3c");
function $cc508768cef3ac26$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $cc508768cef3ac26$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $cc508768cef3ac26$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $cc508768cef3ac26$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $cc508768cef3ac26$var$styleRemove : typeof value === "function" ? $cc508768cef3ac26$var$styleFunction : $cc508768cef3ac26$var$styleConstant)(name, value, priority == null ? "" : priority)) : $cc508768cef3ac26$export$5e3cec964f0b5efd(this.node(), name);
}
function $cc508768cef3ac26$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $9Wm3c.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("9Wm3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73caa29b60bfdd0f$export$2e2bcd8739ae039; });
function $73caa29b60bfdd0f$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("7ajhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53786d4790e643a4$export$2e2bcd8739ae039; });
function $53786d4790e643a4$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $53786d4790e643a4$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $53786d4790e643a4$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $53786d4790e643a4$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $53786d4790e643a4$var$propertyRemove : typeof value === "function" ? $53786d4790e643a4$var$propertyFunction : $53786d4790e643a4$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("dS3z4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1931561b2d32df5$export$2e2bcd8739ae039; });
function $a1931561b2d32df5$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $a1931561b2d32df5$var$classList(node) {
    return node.classList || new $a1931561b2d32df5$var$ClassList(node);
}
function $a1931561b2d32df5$var$ClassList(node) {
    this._node = node;
    this._names = $a1931561b2d32df5$var$classArray(node.getAttribute("class") || "");
}
$a1931561b2d32df5$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $a1931561b2d32df5$var$classedAdd(node, names) {
    var list = $a1931561b2d32df5$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $a1931561b2d32df5$var$classedRemove(node, names) {
    var list = $a1931561b2d32df5$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $a1931561b2d32df5$var$classedTrue(names) {
    return function() {
        $a1931561b2d32df5$var$classedAdd(this, names);
    };
}
function $a1931561b2d32df5$var$classedFalse(names) {
    return function() {
        $a1931561b2d32df5$var$classedRemove(this, names);
    };
}
function $a1931561b2d32df5$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $a1931561b2d32df5$var$classedAdd : $a1931561b2d32df5$var$classedRemove)(this, names);
    };
}
function $a1931561b2d32df5$export$2e2bcd8739ae039(name, value) {
    var names = $a1931561b2d32df5$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $a1931561b2d32df5$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $a1931561b2d32df5$var$classedFunction : value ? $a1931561b2d32df5$var$classedTrue : $a1931561b2d32df5$var$classedFalse)(names, value));
}

});

parcelRegister("bXETX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b54ee92e3794364$export$2e2bcd8739ae039; });
function $8b54ee92e3794364$var$textRemove() {
    this.textContent = "";
}
function $8b54ee92e3794364$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $8b54ee92e3794364$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $8b54ee92e3794364$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $8b54ee92e3794364$var$textRemove : (typeof value === "function" ? $8b54ee92e3794364$var$textFunction : $8b54ee92e3794364$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("3XVdH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e33447c4d959e74$export$2e2bcd8739ae039; });
function $2e33447c4d959e74$var$htmlRemove() {
    this.innerHTML = "";
}
function $2e33447c4d959e74$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $2e33447c4d959e74$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $2e33447c4d959e74$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $2e33447c4d959e74$var$htmlRemove : (typeof value === "function" ? $2e33447c4d959e74$var$htmlFunction : $2e33447c4d959e74$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("5TyV2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44ad2d01045bc8db$export$2e2bcd8739ae039; });
function $44ad2d01045bc8db$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $44ad2d01045bc8db$export$2e2bcd8739ae039() {
    return this.each($44ad2d01045bc8db$var$raise);
}

});

parcelRegister("bGOs7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $882ac0c1d24e4ab1$export$2e2bcd8739ae039; });
function $882ac0c1d24e4ab1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $882ac0c1d24e4ab1$export$2e2bcd8739ae039() {
    return this.each($882ac0c1d24e4ab1$var$lower);
}

});

parcelRegister("PQqvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09bd6e579bd730df$export$2e2bcd8739ae039; });

var $4AWtu = parcelRequire("4AWtu");
function $09bd6e579bd730df$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $4AWtu.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("4AWtu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587e20cc64e54fe$export$2e2bcd8739ae039; });

var $kAMSn = parcelRequire("kAMSn");

var $2nesS = parcelRequire("2nesS");
function $3587e20cc64e54fe$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $2nesS.xhtml) && document.documentElement.namespaceURI === (0, $2nesS.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $3587e20cc64e54fe$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $3587e20cc64e54fe$export$2e2bcd8739ae039(name) {
    var fullname = (0, $kAMSn.default)(name);
    return (fullname.local ? $3587e20cc64e54fe$var$creatorFixed : $3587e20cc64e54fe$var$creatorInherit)(fullname);
}

});


parcelRegister("jGJRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e55584a40c10a576$export$2e2bcd8739ae039; });

var $4AWtu = parcelRequire("4AWtu");

var $dTsqF = parcelRequire("dTsqF");
function $e55584a40c10a576$var$constantNull() {
    return null;
}
function $e55584a40c10a576$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $4AWtu.default)(name), select = before == null ? $e55584a40c10a576$var$constantNull : typeof before === "function" ? before : (0, $dTsqF.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("8hsq3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6075f4be51a1b53c$export$2e2bcd8739ae039; });
function $6075f4be51a1b53c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $6075f4be51a1b53c$export$2e2bcd8739ae039() {
    return this.each($6075f4be51a1b53c$var$remove);
}

});

parcelRegister("a17Mu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74b0088a183f7c62$export$2e2bcd8739ae039; });
function $74b0088a183f7c62$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $74b0088a183f7c62$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $74b0088a183f7c62$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $74b0088a183f7c62$var$selection_cloneDeep : $74b0088a183f7c62$var$selection_cloneShallow);
}

});

parcelRegister("7zOJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5843284c5de66b0c$export$2e2bcd8739ae039; });
function $5843284c5de66b0c$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("aXoYl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fa2c90cc82f616e$export$2e2bcd8739ae039; });
function $7fa2c90cc82f616e$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $7fa2c90cc82f616e$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $7fa2c90cc82f616e$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $7fa2c90cc82f616e$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $7fa2c90cc82f616e$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $7fa2c90cc82f616e$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $7fa2c90cc82f616e$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $7fa2c90cc82f616e$var$onAdd : $7fa2c90cc82f616e$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}

});

parcelRegister("5jhFo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ddc6e53524500f8$export$2e2bcd8739ae039; });

var $9Wm3c = parcelRequire("9Wm3c");
function $3ddc6e53524500f8$var$dispatchEvent(node, type, params) {
    var window = (0, $9Wm3c.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $3ddc6e53524500f8$var$dispatchConstant(type, params) {
    return function() {
        return $3ddc6e53524500f8$var$dispatchEvent(this, type, params);
    };
}
function $3ddc6e53524500f8$var$dispatchFunction(type, params) {
    return function() {
        return $3ddc6e53524500f8$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $3ddc6e53524500f8$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $3ddc6e53524500f8$var$dispatchFunction : $3ddc6e53524500f8$var$dispatchConstant)(type, params));
}

});

parcelRegister("6GcfU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dd02c09f845dc11$export$2e2bcd8739ae039; });
function* $4dd02c09f845dc11$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}

});



parcelRegister("fz6ZW", function(module, exports) {

$parcel$export(module.exports, "nonpassive", function () { return $b54f8d943f5708c0$export$524615cd03e458cc; });
$parcel$export(module.exports, "nonpassivecapture", function () { return $b54f8d943f5708c0$export$35431a0e47022de1; });
$parcel$export(module.exports, "nopropagation", function () { return $b54f8d943f5708c0$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $b54f8d943f5708c0$export$2e2bcd8739ae039; });
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $b54f8d943f5708c0$export$524615cd03e458cc = {
    passive: false
};
const $b54f8d943f5708c0$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $b54f8d943f5708c0$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $b54f8d943f5708c0$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});


parcelRegister("hAt8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccdc67c481586eb9$export$2e2bcd8739ae039; });

var $5xbVo = parcelRequire("5xbVo");

var $1LBfd = parcelRequire("1LBfd");

var $kxgmJ = parcelRequire("kxgmJ");

var $2FeGB = parcelRequire("2FeGB");

var $fc8VK = parcelRequire("fc8VK");

var $4iFiu = parcelRequire("4iFiu");

var $lwIcH = parcelRequire("lwIcH");

var $I8xeE = parcelRequire("I8xeE");

var $JMJxs = parcelRequire("JMJxs");
function $ccdc67c481586eb9$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $I8xeE.default)(b) : (t === "number" ? (0, $fc8VK.default) : t === "string" ? (c = (0, $5xbVo.default)(b)) ? (b = c, $1LBfd.default) : (0, $lwIcH.default) : b instanceof (0, $5xbVo.default) ? (0, $1LBfd.default) : b instanceof Date ? (0, $2FeGB.default) : (0, $JMJxs.isNumberArray)(b) ? (0, $JMJxs.default) : Array.isArray(b) ? (0, $kxgmJ.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $4iFiu.default) : (0, $fc8VK.default))(a, b);
}

});
parcelRegister("5xbVo", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $jecNh = parcelRequire("jecNh");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $jecNh.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jecNh.default)(Rgb, rgb, (0, $jecNh.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jecNh.default)(Hsl, hsl, (0, $jecNh.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("jecNh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dff93fba100e883a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $dff93fba100e883a$export$8b58be045bf06082; });
function $dff93fba100e883a$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $dff93fba100e883a$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("1LBfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14971234043e0943$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rgbBasis", function () { return $14971234043e0943$export$2c0e28f2e2852d3f; });
$parcel$export(module.exports, "rgbBasisClosed", function () { return $14971234043e0943$export$53d5214f625ccd4c; });

var $5xbVo = parcelRequire("5xbVo");

var $1I9Xl = parcelRequire("1I9Xl");

var $u9AWy = parcelRequire("u9AWy");

var $7auAs = parcelRequire("7auAs");
var $14971234043e0943$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $7auAs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $5xbVo.rgb)(start)).r, (end = (0, $5xbVo.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $7auAs.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $14971234043e0943$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $5xbVo.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $14971234043e0943$export$2c0e28f2e2852d3f = $14971234043e0943$var$rgbSpline((0, $1I9Xl.default));
var $14971234043e0943$export$53d5214f625ccd4c = $14971234043e0943$var$rgbSpline((0, $u9AWy.default));

});
parcelRegister("1I9Xl", function(module, exports) {

$parcel$export(module.exports, "basis", function () { return $13f19f9c50bbe2ca$export$4e41033bfeec1a4c; });
$parcel$export(module.exports, "default", function () { return $13f19f9c50bbe2ca$export$2e2bcd8739ae039; });
function $13f19f9c50bbe2ca$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $13f19f9c50bbe2ca$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $13f19f9c50bbe2ca$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("u9AWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05aa3ecbc5647055$export$2e2bcd8739ae039; });

var $1I9Xl = parcelRequire("1I9Xl");
function $05aa3ecbc5647055$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $1I9Xl.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("7auAs", function(module, exports) {

$parcel$export(module.exports, "hue", function () { return $538131835a3b7df9$export$97d7b0c7ddb78dcf; });
$parcel$export(module.exports, "gamma", function () { return $538131835a3b7df9$export$a7ebe8cc6aaf8d37; });
$parcel$export(module.exports, "default", function () { return $538131835a3b7df9$export$2e2bcd8739ae039; });

var $I8xeE = parcelRequire("I8xeE");
function $538131835a3b7df9$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $538131835a3b7df9$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $538131835a3b7df9$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $538131835a3b7df9$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $I8xeE.default)(isNaN(a) ? b : a);
}
function $538131835a3b7df9$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $538131835a3b7df9$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $538131835a3b7df9$var$exponential(a, b, y) : (0, $I8xeE.default)(isNaN(a) ? b : a);
    };
}
function $538131835a3b7df9$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $538131835a3b7df9$var$linear(a, d) : (0, $I8xeE.default)(isNaN(a) ? b : a);
}

});
parcelRegister("I8xeE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $084abb0f257432c2$export$2e2bcd8739ae039; });
var $084abb0f257432c2$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("kxgmJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef339593e9305b25$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "genericArray", function () { return $ef339593e9305b25$export$15d09067c6a5ee49; });

var $hAt8X = parcelRequire("hAt8X");

var $JMJxs = parcelRequire("JMJxs");
function $ef339593e9305b25$export$2e2bcd8739ae039(a, b) {
    return ((0, $JMJxs.isNumberArray)(b) ? (0, $JMJxs.default) : $ef339593e9305b25$export$15d09067c6a5ee49)(a, b);
}
function $ef339593e9305b25$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $hAt8X.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("JMJxs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $089a018a60b24040$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isNumberArray", function () { return $089a018a60b24040$export$5cd576d1827d40c8; });
function $089a018a60b24040$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $089a018a60b24040$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("2FeGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f0acd7187f3db70$export$2e2bcd8739ae039; });
function $1f0acd7187f3db70$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("fc8VK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0fee760397abf06$export$2e2bcd8739ae039; });
function $b0fee760397abf06$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("4iFiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3218e0a5ca92a636$export$2e2bcd8739ae039; });

var $hAt8X = parcelRequire("hAt8X");
function $3218e0a5ca92a636$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $hAt8X.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("lwIcH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fabee0116e203ce8$export$2e2bcd8739ae039; });

var $fc8VK = parcelRequire("fc8VK");
var $fabee0116e203ce8$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $fabee0116e203ce8$var$reB = new RegExp($fabee0116e203ce8$var$reA.source, "g");
function $fabee0116e203ce8$var$zero(b) {
    return function() {
        return b;
    };
}
function $fabee0116e203ce8$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $fabee0116e203ce8$export$2e2bcd8739ae039(a, b) {
    var bi = $fabee0116e203ce8$var$reA.lastIndex = $fabee0116e203ce8$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $fabee0116e203ce8$var$reA.exec(a)) && (bm = $fabee0116e203ce8$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $fc8VK.default)(am, bm)
            });
        }
        bi = $fabee0116e203ce8$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $fabee0116e203ce8$var$one(q[0].x) : $fabee0116e203ce8$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("pd5FT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04bc7d6b84dfbe95$export$2e2bcd8739ae039; });

var $aleUh = parcelRequire("aleUh");
function $04bc7d6b84dfbe95$export$2e2bcd8739ae039(event, node) {
    event = (0, $aleUh.default)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}

});
parcelRegister("aleUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78776dbc4d090422$export$2e2bcd8739ae039; });
function $78776dbc4d090422$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}

});


parcelRegister("buDM2", function(module, exports) {

$parcel$export(module.exports, "transition", function () { return (parcelRequire("2YstX")).default; });
$parcel$export(module.exports, "active", function () { return (parcelRequire("kjHtc")).default; });
$parcel$export(module.exports, "interrupt", function () { return (parcelRequire("1WXFO")).default; });
parcelRequire("7FlXk");

var $2YstX = parcelRequire("2YstX");

var $kjHtc = parcelRequire("kjHtc");

var $1WXFO = parcelRequire("1WXFO");

});
parcelRegister("7FlXk", function(module, exports) {

var $lkjtJ = parcelRequire("lkjtJ");

var $c8wp2 = parcelRequire("c8wp2");

var $diC2A = parcelRequire("diC2A");
(0, $lkjtJ.default).prototype.interrupt = (0, $c8wp2.default);
(0, $lkjtJ.default).prototype.transition = (0, $diC2A.default);

});
parcelRegister("c8wp2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d5f5dec651ae66c$export$2e2bcd8739ae039; });

var $1WXFO = parcelRequire("1WXFO");
function $8d5f5dec651ae66c$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $1WXFO.default)(this, name);
    });
}

});
parcelRegister("1WXFO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16b97f201dbcf64c$export$2e2bcd8739ae039; });

var $4fB2s = parcelRequire("4fB2s");
function $16b97f201dbcf64c$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $4fB2s.STARTING) && schedule.state < (0, $4fB2s.ENDING);
        schedule.state = (0, $4fB2s.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("4fB2s", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", function () { return $31854b37fd7c9227$export$584530fe98d14a84; });
$parcel$export(module.exports, "STARTING", function () { return $31854b37fd7c9227$export$a5d151aee16efd42; });
$parcel$export(module.exports, "ENDING", function () { return $31854b37fd7c9227$export$a2e792214ded83b2; });
$parcel$export(module.exports, "ENDED", function () { return $31854b37fd7c9227$export$9d38167254403955; });
$parcel$export(module.exports, "default", function () { return $31854b37fd7c9227$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "init", function () { return $31854b37fd7c9227$export$2cd8252107eb640b; });
$parcel$export(module.exports, "get", function () { return $31854b37fd7c9227$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $31854b37fd7c9227$export$adaa4cf7ef1b65be; });

var $5Rufx = parcelRequire("5Rufx");

var $iEvah = parcelRequire("iEvah");
var $2lwYT = parcelRequire("2lwYT");
var $31854b37fd7c9227$var$emptyOn = (0, $5Rufx.default)("start", "end", "cancel", "interrupt");
var $31854b37fd7c9227$var$emptyTween = [];
var $31854b37fd7c9227$export$ff39ebd4bb12b718 = 0;
var $31854b37fd7c9227$export$584530fe98d14a84 = 1;
var $31854b37fd7c9227$export$a5d151aee16efd42 = 2;
var $31854b37fd7c9227$export$fb935ab5849a0db9 = 3;
var $31854b37fd7c9227$export$1573e22b087389af = 4;
var $31854b37fd7c9227$export$a2e792214ded83b2 = 5;
var $31854b37fd7c9227$export$9d38167254403955 = 6;
function $31854b37fd7c9227$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $31854b37fd7c9227$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $31854b37fd7c9227$var$emptyOn,
        tween: $31854b37fd7c9227$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $31854b37fd7c9227$export$ff39ebd4bb12b718
    });
}
function $31854b37fd7c9227$export$2cd8252107eb640b(node, id) {
    var schedule = $31854b37fd7c9227$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $31854b37fd7c9227$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $31854b37fd7c9227$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $31854b37fd7c9227$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $31854b37fd7c9227$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $31854b37fd7c9227$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $31854b37fd7c9227$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $2lwYT.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $31854b37fd7c9227$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $31854b37fd7c9227$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $31854b37fd7c9227$export$fb935ab5849a0db9) return (0, $iEvah.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $31854b37fd7c9227$export$1573e22b087389af) {
                o.state = $31854b37fd7c9227$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $31854b37fd7c9227$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $iEvah.default)(function() {
            if (self.state === $31854b37fd7c9227$export$fb935ab5849a0db9) {
                self.state = $31854b37fd7c9227$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $31854b37fd7c9227$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $31854b37fd7c9227$export$a5d151aee16efd42) return; // interrupted
        self.state = $31854b37fd7c9227$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $31854b37fd7c9227$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $31854b37fd7c9227$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $31854b37fd7c9227$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("iEvah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d944231f489759c1$export$2e2bcd8739ae039; });

var $2lwYT = parcelRequire("2lwYT");
function $d944231f489759c1$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $2lwYT.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("2lwYT", function(module, exports) {

$parcel$export(module.exports, "now", function () { return $1b572052a9f19f73$export$461939dd4422153; });
$parcel$export(module.exports, "Timer", function () { return $1b572052a9f19f73$export$c57e9b2d8b9e4de; });
$parcel$export(module.exports, "timer", function () { return $1b572052a9f19f73$export$9dc4ecf953986f04; });
$parcel$export(module.exports, "timerFlush", function () { return $1b572052a9f19f73$export$d60154c1d7f3990e; });
var $1b572052a9f19f73$var$frame = 0, $1b572052a9f19f73$var$timeout = 0, $1b572052a9f19f73$var$interval = 0, $1b572052a9f19f73$var$pokeDelay = 1000, $1b572052a9f19f73$var$taskHead, $1b572052a9f19f73$var$taskTail, $1b572052a9f19f73$var$clockLast = 0, $1b572052a9f19f73$var$clockNow = 0, $1b572052a9f19f73$var$clockSkew = 0, $1b572052a9f19f73$var$clock = typeof performance === "object" && performance.now ? performance : Date, $1b572052a9f19f73$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $1b572052a9f19f73$export$461939dd4422153() {
    return $1b572052a9f19f73$var$clockNow || ($1b572052a9f19f73$var$setFrame($1b572052a9f19f73$var$clearNow), $1b572052a9f19f73$var$clockNow = $1b572052a9f19f73$var$clock.now() + $1b572052a9f19f73$var$clockSkew);
}
function $1b572052a9f19f73$var$clearNow() {
    $1b572052a9f19f73$var$clockNow = 0;
}
function $1b572052a9f19f73$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$1b572052a9f19f73$export$c57e9b2d8b9e4de.prototype = $1b572052a9f19f73$export$9dc4ecf953986f04.prototype = {
    constructor: $1b572052a9f19f73$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $1b572052a9f19f73$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $1b572052a9f19f73$var$taskTail !== this) {
            if ($1b572052a9f19f73$var$taskTail) $1b572052a9f19f73$var$taskTail._next = this;
            else $1b572052a9f19f73$var$taskHead = this;
            $1b572052a9f19f73$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $1b572052a9f19f73$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $1b572052a9f19f73$var$sleep();
        }
    }
};
function $1b572052a9f19f73$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $1b572052a9f19f73$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $1b572052a9f19f73$export$d60154c1d7f3990e() {
    $1b572052a9f19f73$export$461939dd4422153(); // Get the current time, if not already set.
    ++$1b572052a9f19f73$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $1b572052a9f19f73$var$taskHead, e;
    while(t){
        if ((e = $1b572052a9f19f73$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$1b572052a9f19f73$var$frame;
}
function $1b572052a9f19f73$var$wake() {
    $1b572052a9f19f73$var$clockNow = ($1b572052a9f19f73$var$clockLast = $1b572052a9f19f73$var$clock.now()) + $1b572052a9f19f73$var$clockSkew;
    $1b572052a9f19f73$var$frame = $1b572052a9f19f73$var$timeout = 0;
    try {
        $1b572052a9f19f73$export$d60154c1d7f3990e();
    } finally{
        $1b572052a9f19f73$var$frame = 0;
        $1b572052a9f19f73$var$nap();
        $1b572052a9f19f73$var$clockNow = 0;
    }
}
function $1b572052a9f19f73$var$poke() {
    var now = $1b572052a9f19f73$var$clock.now(), delay = now - $1b572052a9f19f73$var$clockLast;
    if (delay > $1b572052a9f19f73$var$pokeDelay) $1b572052a9f19f73$var$clockSkew -= delay, $1b572052a9f19f73$var$clockLast = now;
}
function $1b572052a9f19f73$var$nap() {
    var t0, t1 = $1b572052a9f19f73$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $1b572052a9f19f73$var$taskHead = t2;
    }
    $1b572052a9f19f73$var$taskTail = t0;
    $1b572052a9f19f73$var$sleep(time);
}
function $1b572052a9f19f73$var$sleep(time) {
    if ($1b572052a9f19f73$var$frame) return; // Soonest alarm already set, or will be.
    if ($1b572052a9f19f73$var$timeout) $1b572052a9f19f73$var$timeout = clearTimeout($1b572052a9f19f73$var$timeout);
    var delay = time - $1b572052a9f19f73$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $1b572052a9f19f73$var$timeout = setTimeout($1b572052a9f19f73$var$wake, time - $1b572052a9f19f73$var$clock.now() - $1b572052a9f19f73$var$clockSkew);
        if ($1b572052a9f19f73$var$interval) $1b572052a9f19f73$var$interval = clearInterval($1b572052a9f19f73$var$interval);
    } else {
        if (!$1b572052a9f19f73$var$interval) $1b572052a9f19f73$var$clockLast = $1b572052a9f19f73$var$clock.now(), $1b572052a9f19f73$var$interval = setInterval($1b572052a9f19f73$var$poke, $1b572052a9f19f73$var$pokeDelay);
        $1b572052a9f19f73$var$frame = 1, $1b572052a9f19f73$var$setFrame($1b572052a9f19f73$var$wake);
    }
}

});





parcelRegister("diC2A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aea76ead9dd5d8b$export$2e2bcd8739ae039; });

var $2YstX = parcelRequire("2YstX");

var $4fB2s = parcelRequire("4fB2s");

var $btfUt = parcelRequire("btfUt");

var $2lwYT = parcelRequire("2lwYT");
var $9aea76ead9dd5d8b$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $btfUt.cubicInOut)
};
function $9aea76ead9dd5d8b$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $9aea76ead9dd5d8b$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $2YstX.Transition)) id = name._id, name = name._name;
    else id = (0, $2YstX.newId)(), (timing = $9aea76ead9dd5d8b$var$defaultTiming).time = (0, $2lwYT.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $4fB2s.default)(node, name, id, i, group, timing || $9aea76ead9dd5d8b$var$inherit(node, id));
    }
    return new (0, $2YstX.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("2YstX", function(module, exports) {

$parcel$export(module.exports, "Transition", function () { return $22a74758567a9a38$export$be58926105124dd4; });
$parcel$export(module.exports, "default", function () { return $22a74758567a9a38$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "newId", function () { return $22a74758567a9a38$export$9ffd10a3fbdc175b; });

var $lkjtJ = parcelRequire("lkjtJ");

var $eD1wZ = parcelRequire("eD1wZ");

var $3bINA = parcelRequire("3bINA");

var $iSjTy = parcelRequire("iSjTy");

var $1G7QX = parcelRequire("1G7QX");

var $jsMXY = parcelRequire("jsMXY");

var $9OrbU = parcelRequire("9OrbU");

var $hRUms = parcelRequire("hRUms");

var $k5FYr = parcelRequire("k5FYr");

var $l6QBt = parcelRequire("l6QBt");

var $lxacd = parcelRequire("lxacd");

var $2iz2d = parcelRequire("2iz2d");

var $fYgs7 = parcelRequire("fYgs7");

var $5aRet = parcelRequire("5aRet");

var $dCIuK = parcelRequire("dCIuK");

var $08aSv = parcelRequire("08aSv");

var $f0SGZ = parcelRequire("f0SGZ");

var $fN06N = parcelRequire("fN06N");

var $fGljA = parcelRequire("fGljA");

var $fvPF3 = parcelRequire("fvPF3");

var $iyvAB = parcelRequire("iyvAB");
var $22a74758567a9a38$var$id = 0;
function $22a74758567a9a38$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $22a74758567a9a38$export$2e2bcd8739ae039(name) {
    return (0, $lkjtJ.default)().transition(name);
}
function $22a74758567a9a38$export$9ffd10a3fbdc175b() {
    return ++$22a74758567a9a38$var$id;
}
var $22a74758567a9a38$var$selection_prototype = (0, $lkjtJ.default).prototype;
$22a74758567a9a38$export$be58926105124dd4.prototype = $22a74758567a9a38$export$2e2bcd8739ae039.prototype = {
    constructor: $22a74758567a9a38$export$be58926105124dd4,
    select: (0, $2iz2d.default),
    selectAll: (0, $fYgs7.default),
    selectChild: $22a74758567a9a38$var$selection_prototype.selectChild,
    selectChildren: $22a74758567a9a38$var$selection_prototype.selectChildren,
    filter: (0, $hRUms.default),
    merge: (0, $k5FYr.default),
    selection: (0, $5aRet.default),
    transition: (0, $fGljA.default),
    call: $22a74758567a9a38$var$selection_prototype.call,
    nodes: $22a74758567a9a38$var$selection_prototype.nodes,
    node: $22a74758567a9a38$var$selection_prototype.node,
    size: $22a74758567a9a38$var$selection_prototype.size,
    empty: $22a74758567a9a38$var$selection_prototype.empty,
    each: $22a74758567a9a38$var$selection_prototype.each,
    on: (0, $l6QBt.default),
    attr: (0, $eD1wZ.default),
    attrTween: (0, $3bINA.default),
    style: (0, $dCIuK.default),
    styleTween: (0, $08aSv.default),
    text: (0, $f0SGZ.default),
    textTween: (0, $fN06N.default),
    remove: (0, $lxacd.default),
    tween: (0, $fvPF3.default),
    delay: (0, $iSjTy.default),
    duration: (0, $1G7QX.default),
    ease: (0, $jsMXY.default),
    easeVarying: (0, $9OrbU.default),
    end: (0, $iyvAB.default),
    [Symbol.iterator]: $22a74758567a9a38$var$selection_prototype[Symbol.iterator]
};

});
parcelRegister("eD1wZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa65e54620f0d32d$export$2e2bcd8739ae039; });

var $2Ej7V = parcelRequire("2Ej7V");

var $kAMSn = parcelRequire("kAMSn");

var $fvPF3 = parcelRequire("fvPF3");

var $eQNCP = parcelRequire("eQNCP");
function $aa65e54620f0d32d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $aa65e54620f0d32d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $aa65e54620f0d32d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $aa65e54620f0d32d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $aa65e54620f0d32d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $aa65e54620f0d32d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $aa65e54620f0d32d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $kAMSn.default)(name), i = fullname === "transform" ? (0, $2Ej7V.interpolateTransformSvg) : (0, $eQNCP.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $aa65e54620f0d32d$var$attrFunctionNS : $aa65e54620f0d32d$var$attrFunction)(fullname, i, (0, $fvPF3.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $aa65e54620f0d32d$var$attrRemoveNS : $aa65e54620f0d32d$var$attrRemove)(fullname) : (fullname.local ? $aa65e54620f0d32d$var$attrConstantNS : $aa65e54620f0d32d$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("2Ej7V", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", function () { return $1ede275cb2527ec1$export$56bec7123bb3589a; });
$parcel$export(module.exports, "interpolateTransformSvg", function () { return $1ede275cb2527ec1$export$da8cba906d64c082; });

var $fc8VK = parcelRequire("fc8VK");

var $8lcIb = parcelRequire("8lcIb");
function $1ede275cb2527ec1$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $fc8VK.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $fc8VK.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $fc8VK.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $fc8VK.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $fc8VK.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $fc8VK.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $1ede275cb2527ec1$export$56bec7123bb3589a = $1ede275cb2527ec1$var$interpolateTransform((0, $8lcIb.parseCss), "px, ", "px)", "deg)");
var $1ede275cb2527ec1$export$da8cba906d64c082 = $1ede275cb2527ec1$var$interpolateTransform((0, $8lcIb.parseSvg), ", ", ")", ")");

});
parcelRegister("8lcIb", function(module, exports) {

$parcel$export(module.exports, "parseCss", function () { return $612a2527c9ed66d5$export$59ad369bf4938177; });
$parcel$export(module.exports, "parseSvg", function () { return $612a2527c9ed66d5$export$f9ef43f9a1d89a18; });

var $fK0PN = parcelRequire("fK0PN");
var $612a2527c9ed66d5$var$svgNode;
function $612a2527c9ed66d5$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $fK0PN.identity) : (0, $fK0PN.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $612a2527c9ed66d5$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $fK0PN.identity;
    if (!$612a2527c9ed66d5$var$svgNode) $612a2527c9ed66d5$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $612a2527c9ed66d5$var$svgNode.setAttribute("transform", value);
    if (!(value = $612a2527c9ed66d5$var$svgNode.transform.baseVal.consolidate())) return 0, $fK0PN.identity;
    value = value.matrix;
    return (0, $fK0PN.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("fK0PN", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $b75bcc95f7be1a65$export$f0954fd7d5368655; });
$parcel$export(module.exports, "default", function () { return $b75bcc95f7be1a65$export$2e2bcd8739ae039; });
var $b75bcc95f7be1a65$var$degrees = 180 / Math.PI;
var $b75bcc95f7be1a65$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $b75bcc95f7be1a65$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $b75bcc95f7be1a65$var$degrees,
        skewX: Math.atan(skewX) * $b75bcc95f7be1a65$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("fvPF3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4b1d3168ede9316$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "tweenValue", function () { return $b4b1d3168ede9316$export$f78ce6ab10405d82; });

var $4fB2s = parcelRequire("4fB2s");
function $b4b1d3168ede9316$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $4fB2s.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $b4b1d3168ede9316$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $4fB2s.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $b4b1d3168ede9316$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $4fB2s.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $b4b1d3168ede9316$var$tweenRemove : $b4b1d3168ede9316$var$tweenFunction)(id, name, value));
}
function $b4b1d3168ede9316$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $4fB2s.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $4fB2s.get)(node, id).value[name];
    };
}

});

parcelRegister("eQNCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acfc6a8be72daad3$export$2e2bcd8739ae039; });

var $5xbVo = parcelRequire("5xbVo");

var $fc8VK = parcelRequire("fc8VK");
var $1LBfd = parcelRequire("1LBfd");
var $lwIcH = parcelRequire("lwIcH");
function $acfc6a8be72daad3$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $fc8VK.default) : b instanceof (0, $5xbVo.default) ? (0, $1LBfd.default) : (c = (0, $5xbVo.default)(b)) ? (b = c, $1LBfd.default) : (0, $lwIcH.default))(a, b);
}

});


parcelRegister("3bINA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2525264204eb8e40$export$2e2bcd8739ae039; });

var $kAMSn = parcelRequire("kAMSn");
function $2525264204eb8e40$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $2525264204eb8e40$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $2525264204eb8e40$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $2525264204eb8e40$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $2525264204eb8e40$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $2525264204eb8e40$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $2525264204eb8e40$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $kAMSn.default)(name);
    return this.tween(key, (fullname.local ? $2525264204eb8e40$var$attrTweenNS : $2525264204eb8e40$var$attrTween)(fullname, value));
}

});

parcelRegister("iSjTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbdcb3dd5ec42851$export$2e2bcd8739ae039; });

var $4fB2s = parcelRequire("4fB2s");
function $dbdcb3dd5ec42851$var$delayFunction(id, value) {
    return function() {
        (0, $4fB2s.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $dbdcb3dd5ec42851$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $4fB2s.init)(this, id).delay = value;
    };
}
function $dbdcb3dd5ec42851$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $dbdcb3dd5ec42851$var$delayFunction : $dbdcb3dd5ec42851$var$delayConstant)(id, value)) : (0, $4fB2s.get)(this.node(), id).delay;
}

});

parcelRegister("1G7QX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $138fce238bba885c$export$2e2bcd8739ae039; });

var $4fB2s = parcelRequire("4fB2s");
function $138fce238bba885c$var$durationFunction(id, value) {
    return function() {
        (0, $4fB2s.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $138fce238bba885c$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $4fB2s.set)(this, id).duration = value;
    };
}
function $138fce238bba885c$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $138fce238bba885c$var$durationFunction : $138fce238bba885c$var$durationConstant)(id, value)) : (0, $4fB2s.get)(this.node(), id).duration;
}

});

parcelRegister("jsMXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2b69d8df3d2e5ef$export$2e2bcd8739ae039; });

var $4fB2s = parcelRequire("4fB2s");
function $e2b69d8df3d2e5ef$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $4fB2s.set)(this, id).ease = value;
    };
}
function $e2b69d8df3d2e5ef$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($e2b69d8df3d2e5ef$var$easeConstant(id, value)) : (0, $4fB2s.get)(this.node(), id).ease;
}

});

parcelRegister("9OrbU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $724de028583d8db9$export$2e2bcd8739ae039; });

var $4fB2s = parcelRequire("4fB2s");
function $724de028583d8db9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $4fB2s.set)(this, id).ease = v;
    };
}
function $724de028583d8db9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($724de028583d8db9$var$easeVarying(this._id, value));
}

});

parcelRegister("hRUms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0231b1523211c03$export$2e2bcd8739ae039; });

var $fso1b = parcelRequire("fso1b");

var $2YstX = parcelRequire("2YstX");
function $d0231b1523211c03$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $fso1b.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $2YstX.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("k5FYr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea04d56c4727b1ca$export$2e2bcd8739ae039; });

var $2YstX = parcelRequire("2YstX");
function $ea04d56c4727b1ca$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $2YstX.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("l6QBt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5e2f67841ef8a7d$export$2e2bcd8739ae039; });

var $4fB2s = parcelRequire("4fB2s");
function $f5e2f67841ef8a7d$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $f5e2f67841ef8a7d$var$onFunction(id, name, listener) {
    var on0, on1, sit = $f5e2f67841ef8a7d$var$start(name) ? (0, $4fB2s.init) : (0, $4fB2s.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $f5e2f67841ef8a7d$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $4fB2s.get)(this.node(), id).on.on(name) : this.each($f5e2f67841ef8a7d$var$onFunction(id, name, listener));
}

});

parcelRegister("lxacd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fad496bd93df4f3d$export$2e2bcd8739ae039; });
function $fad496bd93df4f3d$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $fad496bd93df4f3d$export$2e2bcd8739ae039() {
    return this.on("end.remove", $fad496bd93df4f3d$var$removeFunction(this._id));
}

});

parcelRegister("2iz2d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ac8706360b13509$export$2e2bcd8739ae039; });

var $dTsqF = parcelRequire("dTsqF");

var $2YstX = parcelRequire("2YstX");

var $4fB2s = parcelRequire("4fB2s");
function $1ac8706360b13509$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $dTsqF.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $4fB2s.default)(subgroup[i], name, id, i, subgroup, (0, $4fB2s.get)(node, id));
        }
    }
    return new (0, $2YstX.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("fYgs7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0938c0f173d819$export$2e2bcd8739ae039; });

var $cuaq4 = parcelRequire("cuaq4");

var $2YstX = parcelRequire("2YstX");

var $4fB2s = parcelRequire("4fB2s");
function $ba0938c0f173d819$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $cuaq4.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $4fB2s.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $4fB2s.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $2YstX.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("5aRet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c472dc690e32f7e$export$2e2bcd8739ae039; });

var $lkjtJ = parcelRequire("lkjtJ");
var $3c472dc690e32f7e$var$Selection = (0, $lkjtJ.default).prototype.constructor;
function $3c472dc690e32f7e$export$2e2bcd8739ae039() {
    return new $3c472dc690e32f7e$var$Selection(this._groups, this._parents);
}

});

parcelRegister("dCIuK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eb156b930119694$export$2e2bcd8739ae039; });

var $2Ej7V = parcelRequire("2Ej7V");

var $hxyOW = parcelRequire("hxyOW");

var $4fB2s = parcelRequire("4fB2s");

var $fvPF3 = parcelRequire("fvPF3");

var $eQNCP = parcelRequire("eQNCP");
function $9eb156b930119694$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $hxyOW.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $hxyOW.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $9eb156b930119694$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $9eb156b930119694$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $hxyOW.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $9eb156b930119694$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $hxyOW.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $hxyOW.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $9eb156b930119694$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $4fB2s.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $9eb156b930119694$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $9eb156b930119694$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $2Ej7V.interpolateTransformCss) : (0, $eQNCP.default);
    return value == null ? this.styleTween(name, $9eb156b930119694$var$styleNull(name, i)).on("end.style." + name, $9eb156b930119694$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $9eb156b930119694$var$styleFunction(name, i, (0, $fvPF3.tweenValue)(this, "style." + name, value))).each($9eb156b930119694$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $9eb156b930119694$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("08aSv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0006577a78443e05$export$2e2bcd8739ae039; });
function $0006577a78443e05$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $0006577a78443e05$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $0006577a78443e05$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $0006577a78443e05$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $0006577a78443e05$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("f0SGZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aee147e1d0698e2c$export$2e2bcd8739ae039; });

var $fvPF3 = parcelRequire("fvPF3");
function $aee147e1d0698e2c$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $aee147e1d0698e2c$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $aee147e1d0698e2c$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $aee147e1d0698e2c$var$textFunction((0, $fvPF3.tweenValue)(this, "text", value)) : $aee147e1d0698e2c$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("fN06N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7eb842d8408b7ef$export$2e2bcd8739ae039; });
function $b7eb842d8408b7ef$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $b7eb842d8408b7ef$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $b7eb842d8408b7ef$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $b7eb842d8408b7ef$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $b7eb842d8408b7ef$var$textTween(value));
}

});

parcelRegister("fGljA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6ab4fee6fa3f084$export$2e2bcd8739ae039; });

var $2YstX = parcelRequire("2YstX");

var $4fB2s = parcelRequire("4fB2s");
function $b6ab4fee6fa3f084$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $2YstX.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $4fB2s.get)(node, id0);
            (0, $4fB2s.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $2YstX.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("iyvAB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d823e7f068f1a0f0$export$2e2bcd8739ae039; });

var $4fB2s = parcelRequire("4fB2s");
function $d823e7f068f1a0f0$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $4fB2s.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}

});


parcelRegister("btfUt", function(module, exports) {

$parcel$export(module.exports, "cubicIn", function () { return $859ebe7d134617fa$export$b1a09cb1b71f86aa; });
$parcel$export(module.exports, "cubicOut", function () { return $859ebe7d134617fa$export$68d528839c701b6; });
$parcel$export(module.exports, "cubicInOut", function () { return $859ebe7d134617fa$export$89238d3bc79d3ada; });
function $859ebe7d134617fa$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $859ebe7d134617fa$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $859ebe7d134617fa$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("kjHtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca74d3338bee78f$export$2e2bcd8739ae039; });

var $2YstX = parcelRequire("2YstX");

var $4fB2s = parcelRequire("4fB2s");
var $eca74d3338bee78f$var$root = [
    null
];
function $eca74d3338bee78f$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $4fB2s.SCHEDULED) && schedule.name === name) return new (0, $2YstX.Transition)([
                [
                    node
                ]
            ], $eca74d3338bee78f$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("d4WCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98591f5f949cd9de$export$2e2bcd8739ae039; });
var $98591f5f949cd9de$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("lFPki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc753da2d6488361$export$2e2bcd8739ae039; });
function $fc753da2d6488361$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("lgmjO", function(module, exports) {

$parcel$export(module.exports, "nopropagation", function () { return $f7ac679483cdd72e$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $f7ac679483cdd72e$export$2e2bcd8739ae039; });
function $f7ac679483cdd72e$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $f7ac679483cdd72e$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});



parcelRegister("cJ6dS", function(module, exports) {

$parcel$export(module.exports, "chord", function () { return (parcelRequire("hnV02")).default; });
$parcel$export(module.exports, "chordTranspose", function () { return (parcelRequire("hnV02")).chordTranspose; });
$parcel$export(module.exports, "chordDirected", function () { return (parcelRequire("hnV02")).chordDirected; });
$parcel$export(module.exports, "ribbon", function () { return (parcelRequire("12qzx")).default; });
$parcel$export(module.exports, "ribbonArrow", function () { return (parcelRequire("12qzx")).ribbonArrow; });

var $hnV02 = parcelRequire("hnV02");

var $12qzx = parcelRequire("12qzx");

});
parcelRegister("hnV02", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca80cc989d6d71c8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "chordTranspose", function () { return $ca80cc989d6d71c8$export$ccf0fb804feeadb0; });
$parcel$export(module.exports, "chordDirected", function () { return $ca80cc989d6d71c8$export$66e653ba9a7a4d8c; });

var $jcDKt = parcelRequire("jcDKt");
function $ca80cc989d6d71c8$var$range(i, j) {
    return Array.from({
        length: j - i
    }, (_, k)=>i + k);
}
function $ca80cc989d6d71c8$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $ca80cc989d6d71c8$export$2e2bcd8739ae039() {
    return $ca80cc989d6d71c8$var$chord(false, false);
}
function $ca80cc989d6d71c8$export$ccf0fb804feeadb0() {
    return $ca80cc989d6d71c8$var$chord(false, true);
}
function $ca80cc989d6d71c8$export$66e653ba9a7a4d8c() {
    return $ca80cc989d6d71c8$var$chord(true, false);
}
function $ca80cc989d6d71c8$var$chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = $ca80cc989d6d71c8$var$range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({
            length: n * n
        }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
        // Compute the scaling factor from value to angle in [0, 2pi].
        for(let i = 0; i < n; ++i){
            let x = 0;
            for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = (0, $jcDKt.max)(0, (0, $jcDKt.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, $jcDKt.tau) / n;
        // Compute the angles for each group and constituent chord.
        {
            let x = 0;
            if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
            for (const i of groupIndex){
                const x0 = x;
                if (directed) {
                    const subgroupIndex = $ca80cc989d6d71c8$var$range(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                    for (const j of subgroupIndex)if (j < 0) {
                        const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                            source: null,
                            target: null
                        });
                        chord.target = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[~j * n + i] * k,
                            value: matrix[~j * n + i]
                        };
                    } else {
                        const chord = chords[i * n + j] || (chords[i * n + j] = {
                            source: null,
                            target: null
                        });
                        chord.source = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[i * n + j] * k,
                            value: matrix[i * n + j]
                        };
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                } else {
                    const subgroupIndex = $ca80cc989d6d71c8$var$range(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                    for (const j of subgroupIndex){
                        let chord;
                        if (i < j) {
                            chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        } else {
                            chord = chords[j * n + i] || (chords[j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                            if (i === j) chord.source = chord.target;
                        }
                        if (chord.source && chord.target && chord.source.value < chord.target.value) {
                            const source = chord.source;
                            chord.source = chord.target;
                            chord.target = source;
                        }
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                }
                x += dx;
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $jcDKt.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $ca80cc989d6d71c8$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

});
parcelRegister("jcDKt", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $dfadf8914a533c5b$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "cos", function () { return $dfadf8914a533c5b$export$50d414a77b60d802; });
$parcel$export(module.exports, "sin", function () { return $dfadf8914a533c5b$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "halfPi", function () { return $dfadf8914a533c5b$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $dfadf8914a533c5b$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "max", function () { return $dfadf8914a533c5b$export$8960430cfd85939f; });
$parcel$export(module.exports, "epsilon", function () { return $dfadf8914a533c5b$export$6c421550c66a327d; });
var $dfadf8914a533c5b$export$2335f513bbd82c6d = Math.abs;
var $dfadf8914a533c5b$export$50d414a77b60d802 = Math.cos;
var $dfadf8914a533c5b$export$5de3937cb4b592ed = Math.sin;
var $dfadf8914a533c5b$export$18c7bea995a110f = Math.PI;
var $dfadf8914a533c5b$export$e51408a300e8929a = $dfadf8914a533c5b$export$18c7bea995a110f / 2;
var $dfadf8914a533c5b$export$a4b4b4d4d776fe92 = $dfadf8914a533c5b$export$18c7bea995a110f * 2;
var $dfadf8914a533c5b$export$8960430cfd85939f = Math.max;
var $dfadf8914a533c5b$export$6c421550c66a327d = 1e-12;

});


parcelRegister("12qzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c1a97093211f949$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ribbonArrow", function () { return $0c1a97093211f949$export$63f6c8bb9e816a34; });

var $ayz97 = parcelRequire("ayz97");

var $5pScE = parcelRequire("5pScE");

var $4fUUH = parcelRequire("4fUUH");

var $jcDKt = parcelRequire("jcDKt");
function $0c1a97093211f949$var$defaultSource(d) {
    return d.source;
}
function $0c1a97093211f949$var$defaultTarget(d) {
    return d.target;
}
function $0c1a97093211f949$var$defaultRadius(d) {
    return d.radius;
}
function $0c1a97093211f949$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $0c1a97093211f949$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $0c1a97093211f949$var$defaultPadAngle() {
    return 0;
}
function $0c1a97093211f949$var$defaultArrowheadRadius() {
    return 10;
}
function $0c1a97093211f949$var$ribbon(headRadius) {
    var source = $0c1a97093211f949$var$defaultSource, target = $0c1a97093211f949$var$defaultTarget, sourceRadius = $0c1a97093211f949$var$defaultRadius, targetRadius = $0c1a97093211f949$var$defaultRadius, startAngle = $0c1a97093211f949$var$defaultStartAngle, endAngle = $0c1a97093211f949$var$defaultEndAngle, padAngle = $0c1a97093211f949$var$defaultPadAngle, context = null;
    function ribbon() {
        var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = (0, $5pScE.slice).call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $jcDKt.halfPi), sa1 = endAngle.apply(this, argv) - (0, $jcDKt.halfPi), tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $jcDKt.halfPi), ta1 = endAngle.apply(this, argv) - (0, $jcDKt.halfPi);
        if (!context) context = buffer = (0, $ayz97.path)();
        if (ap > (0, $jcDKt.epsilon)) {
            if ((0, $jcDKt.abs)(sa1 - sa0) > ap * 2 + (0, $jcDKt.epsilon)) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
            else sa0 = sa1 = (sa0 + sa1) / 2;
            if ((0, $jcDKt.abs)(ta1 - ta0) > ap * 2 + (0, $jcDKt.epsilon)) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
            else ta0 = ta1 = (ta0 + ta1) / 2;
        }
        context.moveTo(sr * (0, $jcDKt.cos)(sa0), sr * (0, $jcDKt.sin)(sa0));
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            if (headRadius) {
                var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                context.quadraticCurveTo(0, 0, tr2 * (0, $jcDKt.cos)(ta0), tr2 * (0, $jcDKt.sin)(ta0));
                context.lineTo(tr * (0, $jcDKt.cos)(ta2), tr * (0, $jcDKt.sin)(ta2));
                context.lineTo(tr2 * (0, $jcDKt.cos)(ta1), tr2 * (0, $jcDKt.sin)(ta1));
            } else {
                context.quadraticCurveTo(0, 0, tr * (0, $jcDKt.cos)(ta0), tr * (0, $jcDKt.sin)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
        }
        context.quadraticCurveTo(0, 0, sr * (0, $jcDKt.cos)(sa0), sr * (0, $jcDKt.sin)(sa0));
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    if (headRadius) ribbon.headRadius = function(_) {
        return arguments.length ? (headRadius = typeof _ === "function" ? _ : (0, $4fUUH.default)(+_), ribbon) : headRadius;
    };
    ribbon.radius = function(_) {
        return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : (0, $4fUUH.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.sourceRadius = function(_) {
        return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : (0, $4fUUH.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.targetRadius = function(_) {
        return arguments.length ? (targetRadius = typeof _ === "function" ? _ : (0, $4fUUH.default)(+_), ribbon) : targetRadius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $4fUUH.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $4fUUH.default)(+_), ribbon) : endAngle;
    };
    ribbon.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $4fUUH.default)(+_), ribbon) : padAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}
function $0c1a97093211f949$export$2e2bcd8739ae039() {
    return $0c1a97093211f949$var$ribbon();
}
function $0c1a97093211f949$export$63f6c8bb9e816a34() {
    return $0c1a97093211f949$var$ribbon($0c1a97093211f949$var$defaultArrowheadRadius);
}

});
parcelRegister("ayz97", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return $7af857a0912e0579$export$4b2950bdac9b6ee9; });
$parcel$export(module.exports, "path", function () { return $7af857a0912e0579$export$bb654e07daaf8c3a; });
$parcel$export(module.exports, "pathRound", function () { return $7af857a0912e0579$export$e181c6ece8d9cc5f; });
let $7af857a0912e0579$var$_ = (t)=>t, $7af857a0912e0579$var$t, $7af857a0912e0579$var$t1, $7af857a0912e0579$var$t2, $7af857a0912e0579$var$t3, $7af857a0912e0579$var$t4, $7af857a0912e0579$var$t5, $7af857a0912e0579$var$t6, $7af857a0912e0579$var$t7, $7af857a0912e0579$var$t8, $7af857a0912e0579$var$t9, $7af857a0912e0579$var$t10, $7af857a0912e0579$var$t11, $7af857a0912e0579$var$t12, $7af857a0912e0579$var$t13;
const $7af857a0912e0579$var$pi = Math.PI, $7af857a0912e0579$var$tau = 2 * $7af857a0912e0579$var$pi, $7af857a0912e0579$var$epsilon = 1e-6, $7af857a0912e0579$var$tauEpsilon = $7af857a0912e0579$var$tau - $7af857a0912e0579$var$epsilon;
function $7af857a0912e0579$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $7af857a0912e0579$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $7af857a0912e0579$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $7af857a0912e0579$export$4b2950bdac9b6ee9 {
    moveTo(x, y) {
        this._append($7af857a0912e0579$var$t || ($7af857a0912e0579$var$t = $7af857a0912e0579$var$_`M${0},${0}`), this._x0 = this._x1 = +x, this._y0 = this._y1 = +y);
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append($7af857a0912e0579$var$t1 || ($7af857a0912e0579$var$t1 = $7af857a0912e0579$var$_`Z`));
        }
    }
    lineTo(x, y) {
        this._append($7af857a0912e0579$var$t2 || ($7af857a0912e0579$var$t2 = $7af857a0912e0579$var$_`L${0},${0}`), this._x1 = +x, this._y1 = +y);
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append($7af857a0912e0579$var$t3 || ($7af857a0912e0579$var$t3 = $7af857a0912e0579$var$_`Q${0},${0},${0},${0}`), +x1, +y1, this._x1 = +x, this._y1 = +y);
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append($7af857a0912e0579$var$t4 || ($7af857a0912e0579$var$t4 = $7af857a0912e0579$var$_`C${0},${0},${0},${0},${0},${0}`), +x1, +y1, +x2, +y2, this._x1 = +x, this._y1 = +y);
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append($7af857a0912e0579$var$t5 || ($7af857a0912e0579$var$t5 = $7af857a0912e0579$var$_`M${0},${0}`), this._x1 = x1, this._y1 = y1);
        else if (!(l01_2 > $7af857a0912e0579$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $7af857a0912e0579$var$epsilon) || !r) this._append($7af857a0912e0579$var$t6 || ($7af857a0912e0579$var$t6 = $7af857a0912e0579$var$_`L${0},${0}`), this._x1 = x1, this._y1 = y1);
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($7af857a0912e0579$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $7af857a0912e0579$var$epsilon) this._append($7af857a0912e0579$var$t7 || ($7af857a0912e0579$var$t7 = $7af857a0912e0579$var$_`L${0},${0}`), x1 + t01 * x01, y1 + t01 * y01);
            this._append($7af857a0912e0579$var$t8 || ($7af857a0912e0579$var$t8 = $7af857a0912e0579$var$_`A${0},${0},0,0,${0},${0},${0}`), r, r, +(y01 * x20 > x01 * y20), this._x1 = x1 + t21 * x21, this._y1 = y1 + t21 * y21);
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append($7af857a0912e0579$var$t9 || ($7af857a0912e0579$var$t9 = $7af857a0912e0579$var$_`M${0},${0}`), x0, y0);
        else if (Math.abs(this._x1 - x0) > $7af857a0912e0579$var$epsilon || Math.abs(this._y1 - y0) > $7af857a0912e0579$var$epsilon) this._append($7af857a0912e0579$var$t10 || ($7af857a0912e0579$var$t10 = $7af857a0912e0579$var$_`L${0},${0}`), x0, y0);
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $7af857a0912e0579$var$tau + $7af857a0912e0579$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $7af857a0912e0579$var$tauEpsilon) this._append($7af857a0912e0579$var$t11 || ($7af857a0912e0579$var$t11 = $7af857a0912e0579$var$_`A${0},${0},0,1,${0},${0},${0}A${0},${0},0,1,${0},${0},${0}`), r, r, cw, x - dx, y - dy, r, r, cw, this._x1 = x0, this._y1 = y0);
        else if (da > $7af857a0912e0579$var$epsilon) this._append($7af857a0912e0579$var$t12 || ($7af857a0912e0579$var$t12 = $7af857a0912e0579$var$_`A${0},${0},0,${0},${0},${0},${0}`), r, r, +(da >= $7af857a0912e0579$var$pi), cw, this._x1 = x + r * Math.cos(a1), this._y1 = y + r * Math.sin(a1));
    }
    rect(x, y, w, h) {
        this._append($7af857a0912e0579$var$t13 || ($7af857a0912e0579$var$t13 = $7af857a0912e0579$var$_`M${0},${0}h${0}v${0}h${0}Z`), this._x0 = this._x1 = +x, this._y0 = this._y1 = +y, w = +w, +h, -w);
    }
    toString() {
        return this._;
    }
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $7af857a0912e0579$var$append : $7af857a0912e0579$var$appendRound(digits);
    }
}
function $7af857a0912e0579$export$bb654e07daaf8c3a() {
    return new $7af857a0912e0579$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$7af857a0912e0579$export$bb654e07daaf8c3a.prototype = $7af857a0912e0579$export$4b2950bdac9b6ee9.prototype;
function $7af857a0912e0579$export$e181c6ece8d9cc5f(digits = 3) {
    return new $7af857a0912e0579$export$4b2950bdac9b6ee9(+digits);
}

});

parcelRegister("5pScE", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $3f195523e0795adf$export$58adb3bec8346d0f; });
var $3f195523e0795adf$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("4fUUH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3194b5f4f67a9cdb$export$2e2bcd8739ae039; });
function $3194b5f4f67a9cdb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("inJCY", function(module, exports) {

$parcel$export(module.exports, "color", function () { return (parcelRequire("5xbVo")).default; });
$parcel$export(module.exports, "rgb", function () { return (parcelRequire("5xbVo")).rgb; });
$parcel$export(module.exports, "hsl", function () { return (parcelRequire("5xbVo")).hsl; });
$parcel$export(module.exports, "lab", function () { return (parcelRequire("iLylX")).default; });
$parcel$export(module.exports, "hcl", function () { return (parcelRequire("iLylX")).hcl; });
$parcel$export(module.exports, "lch", function () { return (parcelRequire("iLylX")).lch; });
$parcel$export(module.exports, "gray", function () { return (parcelRequire("iLylX")).gray; });
$parcel$export(module.exports, "cubehelix", function () { return (parcelRequire("10y0i")).default; });

var $5xbVo = parcelRequire("5xbVo");

var $iLylX = parcelRequire("iLylX");

var $10y0i = parcelRequire("10y0i");

});
parcelRegister("iLylX", function(module, exports) {

$parcel$export(module.exports, "gray", function () { return $da974397f921abb7$export$3e2c219d3ab79d01; });
$parcel$export(module.exports, "default", function () { return $da974397f921abb7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "lch", function () { return $da974397f921abb7$export$5a21418738164530; });
$parcel$export(module.exports, "hcl", function () { return $da974397f921abb7$export$d0e870ba50062ff1; });

var $jecNh = parcelRequire("jecNh");

var $5xbVo = parcelRequire("5xbVo");

var $80Ljv = parcelRequire("80Ljv");
// https://observablehq.com/@mbostock/lab-and-rgb
const $da974397f921abb7$var$K = 18, $da974397f921abb7$var$Xn = 0.96422, $da974397f921abb7$var$Yn = 1, $da974397f921abb7$var$Zn = 0.82521, $da974397f921abb7$var$t0 = 4 / 29, $da974397f921abb7$var$t1 = 6 / 29, $da974397f921abb7$var$t2 = 3 * $da974397f921abb7$var$t1 * $da974397f921abb7$var$t1, $da974397f921abb7$var$t3 = $da974397f921abb7$var$t1 * $da974397f921abb7$var$t1 * $da974397f921abb7$var$t1;
function $da974397f921abb7$var$labConvert(o) {
    if (o instanceof $da974397f921abb7$export$f2722c70a60257f7) return new $da974397f921abb7$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $da974397f921abb7$export$d9397e094a5fbb9a) return $da974397f921abb7$var$hcl2lab(o);
    if (!(o instanceof (0, $5xbVo.Rgb))) o = (0, $5xbVo.rgbConvert)(o);
    var r = $da974397f921abb7$var$rgb2lrgb(o.r), g = $da974397f921abb7$var$rgb2lrgb(o.g), b = $da974397f921abb7$var$rgb2lrgb(o.b), y = $da974397f921abb7$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $da974397f921abb7$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $da974397f921abb7$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $da974397f921abb7$var$Xn);
        z = $da974397f921abb7$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $da974397f921abb7$var$Zn);
    }
    return new $da974397f921abb7$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $da974397f921abb7$export$3e2c219d3ab79d01(l, opacity) {
    return new $da974397f921abb7$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $da974397f921abb7$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $da974397f921abb7$var$labConvert(l) : new $da974397f921abb7$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $da974397f921abb7$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jecNh.default)($da974397f921abb7$export$f2722c70a60257f7, $da974397f921abb7$export$2e2bcd8739ae039, (0, $jecNh.extend)((0, $5xbVo.Color), {
    brighter (k) {
        return new $da974397f921abb7$export$f2722c70a60257f7(this.l + $da974397f921abb7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $da974397f921abb7$export$f2722c70a60257f7(this.l - $da974397f921abb7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $da974397f921abb7$var$Xn * $da974397f921abb7$var$lab2xyz(x);
        y = $da974397f921abb7$var$Yn * $da974397f921abb7$var$lab2xyz(y);
        z = $da974397f921abb7$var$Zn * $da974397f921abb7$var$lab2xyz(z);
        return new (0, $5xbVo.Rgb)($da974397f921abb7$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $da974397f921abb7$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $da974397f921abb7$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $da974397f921abb7$var$xyz2lab(t) {
    return t > $da974397f921abb7$var$t3 ? Math.pow(t, 1 / 3) : t / $da974397f921abb7$var$t2 + $da974397f921abb7$var$t0;
}
function $da974397f921abb7$var$lab2xyz(t) {
    return t > $da974397f921abb7$var$t1 ? t * t * t : $da974397f921abb7$var$t2 * (t - $da974397f921abb7$var$t0);
}
function $da974397f921abb7$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $da974397f921abb7$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $da974397f921abb7$var$hclConvert(o) {
    if (o instanceof $da974397f921abb7$export$d9397e094a5fbb9a) return new $da974397f921abb7$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $da974397f921abb7$export$f2722c70a60257f7)) o = $da974397f921abb7$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $da974397f921abb7$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $80Ljv.degrees);
    return new $da974397f921abb7$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $da974397f921abb7$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $da974397f921abb7$var$hclConvert(l) : new $da974397f921abb7$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $da974397f921abb7$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $da974397f921abb7$var$hclConvert(h) : new $da974397f921abb7$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $da974397f921abb7$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $da974397f921abb7$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $da974397f921abb7$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $80Ljv.radians);
    return new $da974397f921abb7$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $jecNh.default)($da974397f921abb7$export$d9397e094a5fbb9a, $da974397f921abb7$export$d0e870ba50062ff1, (0, $jecNh.extend)((0, $5xbVo.Color), {
    brighter (k) {
        return new $da974397f921abb7$export$d9397e094a5fbb9a(this.h, this.c, this.l + $da974397f921abb7$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $da974397f921abb7$export$d9397e094a5fbb9a(this.h, this.c, this.l - $da974397f921abb7$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $da974397f921abb7$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("80Ljv", function(module, exports) {

$parcel$export(module.exports, "radians", function () { return $5d53064e2f3d78af$export$8449e153fbd325fc; });
$parcel$export(module.exports, "degrees", function () { return $5d53064e2f3d78af$export$41fc368e1a942b97; });
const $5d53064e2f3d78af$export$8449e153fbd325fc = Math.PI / 180;
const $5d53064e2f3d78af$export$41fc368e1a942b97 = 180 / Math.PI;

});


parcelRegister("10y0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc02af5db84ecb1$export$2e2bcd8739ae039; });

var $jecNh = parcelRequire("jecNh");

var $5xbVo = parcelRequire("5xbVo");

var $80Ljv = parcelRequire("80Ljv");
var $0bc02af5db84ecb1$var$A = -0.14861, $0bc02af5db84ecb1$var$B = 1.78277, $0bc02af5db84ecb1$var$C = -0.29227, $0bc02af5db84ecb1$var$D = -0.90649, $0bc02af5db84ecb1$var$E = 1.97294, $0bc02af5db84ecb1$var$ED = $0bc02af5db84ecb1$var$E * $0bc02af5db84ecb1$var$D, $0bc02af5db84ecb1$var$EB = $0bc02af5db84ecb1$var$E * $0bc02af5db84ecb1$var$B, $0bc02af5db84ecb1$var$BC_DA = $0bc02af5db84ecb1$var$B * $0bc02af5db84ecb1$var$C - $0bc02af5db84ecb1$var$D * $0bc02af5db84ecb1$var$A;
function $0bc02af5db84ecb1$var$cubehelixConvert(o) {
    if (o instanceof $0bc02af5db84ecb1$export$57ed4bde61a1e2f2) return new $0bc02af5db84ecb1$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $5xbVo.Rgb))) o = (0, $5xbVo.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($0bc02af5db84ecb1$var$BC_DA * b + $0bc02af5db84ecb1$var$ED * r - $0bc02af5db84ecb1$var$EB * g) / ($0bc02af5db84ecb1$var$BC_DA + $0bc02af5db84ecb1$var$ED - $0bc02af5db84ecb1$var$EB), bl = b - l, k = ($0bc02af5db84ecb1$var$E * (g - l) - $0bc02af5db84ecb1$var$C * bl) / $0bc02af5db84ecb1$var$D, s = Math.sqrt(k * k + bl * bl) / ($0bc02af5db84ecb1$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $80Ljv.degrees) - 120 : NaN;
    return new $0bc02af5db84ecb1$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $0bc02af5db84ecb1$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $0bc02af5db84ecb1$var$cubehelixConvert(h) : new $0bc02af5db84ecb1$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $0bc02af5db84ecb1$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jecNh.default)($0bc02af5db84ecb1$export$57ed4bde61a1e2f2, $0bc02af5db84ecb1$export$2e2bcd8739ae039, (0, $jecNh.extend)((0, $5xbVo.Color), {
    brighter (k) {
        k = k == null ? (0, $5xbVo.brighter) : Math.pow((0, $5xbVo.brighter), k);
        return new $0bc02af5db84ecb1$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $5xbVo.darker) : Math.pow((0, $5xbVo.darker), k);
        return new $0bc02af5db84ecb1$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $80Ljv.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $5xbVo.Rgb)(255 * (l + a * ($0bc02af5db84ecb1$var$A * cosh + $0bc02af5db84ecb1$var$B * sinh)), 255 * (l + a * ($0bc02af5db84ecb1$var$C * cosh + $0bc02af5db84ecb1$var$D * sinh)), 255 * (l + a * ($0bc02af5db84ecb1$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("6la9m", function(module, exports) {

$parcel$export(module.exports, "contours", function () { return (parcelRequire("cVw1V")).default; });
$parcel$export(module.exports, "contourDensity", function () { return (parcelRequire("10SJb")).default; });

var $cVw1V = parcelRequire("cVw1V");

var $10SJb = parcelRequire("10SJb");

});
parcelRegister("cVw1V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9693a76e00001c16$export$2e2bcd8739ae039; });

var $eI3Wa = parcelRequire("eI3Wa");
var $dAZOc = parcelRequire("dAZOc");
var $ihuha = parcelRequire("ihuha");
var $amLJv = parcelRequire("amLJv");

var $egZgA = parcelRequire("egZgA");

var $hE8SQ = parcelRequire("hE8SQ");

var $iVqUW = parcelRequire("iVqUW");

var $7Siek = parcelRequire("7Siek");

var $6uXYi = parcelRequire("6uXYi");

var $lheyf = parcelRequire("lheyf");
var $9693a76e00001c16$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $9693a76e00001c16$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $ihuha.default), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            const e = (0, $eI3Wa.default)(values, $9693a76e00001c16$var$finite);
            tz = (0, $amLJv.default)(...(0, $dAZOc.default)(e[0], e[1], tz), tz);
            while(tz[tz.length - 1] >= e[1])tz.pop();
            while(tz[1] < e[0])tz.shift();
        } else tz = tz.slice().sort((0, $hE8SQ.default));
        return tz.map((value)=>contour(values, value));
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        const v = value == null ? NaN : +value;
        if (isNaN(v)) throw new Error(`invalid value: ${value}`);
        var polygons = [], holes = [];
        isorings(values, v, function(ring) {
            smooth(ring, values, v);
            if ((0, $iVqUW.default)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $6uXYi.default)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = $9693a76e00001c16$var$above(values[0], value);
        $9693a76e00001c16$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = $9693a76e00001c16$var$above(values[x + 1], value);
            $9693a76e00001c16$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $9693a76e00001c16$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = $9693a76e00001c16$var$above(values[y * dx + dx], value);
            t2 = $9693a76e00001c16$var$above(values[y * dx], value);
            $9693a76e00001c16$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = $9693a76e00001c16$var$above(values[y * dx + dx + x + 1], value);
                t3 = t2, t2 = $9693a76e00001c16$var$above(values[y * dx + x + 1], value);
                $9693a76e00001c16$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $9693a76e00001c16$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $9693a76e00001c16$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = $9693a76e00001c16$var$above(values[y * dx + x + 1], value);
            $9693a76e00001c16$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $9693a76e00001c16$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v1 = $9693a76e00001c16$var$valid(values[yt * dx + xt]);
            if (x > 0 && x < dx && xt === x) point[0] = $9693a76e00001c16$var$smooth1(x, $9693a76e00001c16$var$valid(values[yt * dx + xt - 1]), v1, value);
            if (y > 0 && y < dy && yt === y) point[1] = $9693a76e00001c16$var$smooth1(y, $9693a76e00001c16$var$valid(values[(yt - 1) * dx + xt]), v1, value);
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $7Siek.default)((0, $egZgA.slice).call(_)) : (0, $7Siek.default)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $lheyf.default), contours) : smooth === smoothLinear;
    };
    return contours;
}
// When computing the extent, ignore infinite values (as well as invalid ones).
function $9693a76e00001c16$var$finite(x) {
    return isFinite(x) ? x : NaN;
}
// Is the (possibly invalid) x greater than or equal to the (known valid) value?
// Treat any invalid value as below negative infinity.
function $9693a76e00001c16$var$above(x, value) {
    return x == null ? false : +x >= value;
}
// During smoothing, treat any invalid value as negative infinity.
function $9693a76e00001c16$var$valid(v) {
    return v == null || isNaN(v = +v) ? -Infinity : v;
}
function $9693a76e00001c16$var$smooth1(x, v0, v1, value) {
    const a = value - v0;
    const b = v1 - v0;
    const d = isFinite(a) || isFinite(b) ? a / b : Math.sign(a) / Math.sign(b);
    return isNaN(d) ? x : x + d - 0.5;
}

});
parcelRegister("egZgA", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $a64215972e3a9afb$export$58adb3bec8346d0f; });
var $a64215972e3a9afb$var$array = Array.prototype;
var $a64215972e3a9afb$export$58adb3bec8346d0f = $a64215972e3a9afb$var$array.slice;

});

parcelRegister("hE8SQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd8d1034645bd246$export$2e2bcd8739ae039; });
function $cd8d1034645bd246$export$2e2bcd8739ae039(a, b) {
    return a - b;
}

});

parcelRegister("iVqUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc726e16814de5cd$export$2e2bcd8739ae039; });
function $dc726e16814de5cd$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}

});

parcelRegister("7Siek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bbbb7a6e4cbd902$export$2e2bcd8739ae039; });
var $5bbbb7a6e4cbd902$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("6uXYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bb4107ceeadee35$export$2e2bcd8739ae039; });
function $4bb4107ceeadee35$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $4bb4107ceeadee35$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $4bb4107ceeadee35$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($4bb4107ceeadee35$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $4bb4107ceeadee35$var$segmentContains(a, b, c) {
    var i;
    return $4bb4107ceeadee35$var$collinear(a, b, c) && $4bb4107ceeadee35$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $4bb4107ceeadee35$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $4bb4107ceeadee35$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

});

parcelRegister("lheyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7d679186b163314$export$2e2bcd8739ae039; });
function $f7d679186b163314$export$2e2bcd8739ae039() {}

});


parcelRegister("10SJb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bd03e51c1b047d3$export$2e2bcd8739ae039; });

var $cIT6x = parcelRequire("cIT6x");
var $NBzfP = parcelRequire("NBzfP");
var $amLJv = parcelRequire("amLJv");

var $egZgA = parcelRequire("egZgA");

var $7Siek = parcelRequire("7Siek");

var $cVw1V = parcelRequire("cVw1V");
function $0bd03e51c1b047d3$var$defaultX(d) {
    return d[0];
}
function $0bd03e51c1b047d3$var$defaultY(d) {
    return d[1];
}
function $0bd03e51c1b047d3$var$defaultWeight() {
    return 1;
}
function $0bd03e51c1b047d3$export$2e2bcd8739ae039() {
    var x = $0bd03e51c1b047d3$var$defaultX, y = $0bd03e51c1b047d3$var$defaultY, weight = $0bd03e51c1b047d3$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $7Siek.default)(20);
    function grid(data) {
        var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
        for (const d of data){
            var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
            if (wi && xi >= 0 && xi < n && yi >= 0 && yi < m) {
                var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
            }
        }
        (0, $cIT6x.blur2)({
            data: values,
            width: n,
            height: m
        }, r * pow2k);
        return values;
    }
    function density(data) {
        var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) tz = (0, $amLJv.default)(Number.MIN_VALUE, (0, $NBzfP.default)(values) / pow4k, tz);
        return (0, $cVw1V.default)().size([
            n,
            m
        ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
    }
    density.contours = function(data) {
        var values = grid(data), contours = (0, $cVw1V.default)().size([
            n,
            m
        ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
            value = +value;
            var c = transform(contours.contour(values, value * pow4k));
            c.value = value; // preserve exact threshold value
            return c;
        };
        Object.defineProperty(contour, "max", {
            get: ()=>(0, $NBzfP.default)(values) / pow4k
        });
        return contour;
    };
    function transform(geometry) {
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7Siek.default)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7Siek.default)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $7Siek.default)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = +_[0], _1 = +_[1];
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $7Siek.default)((0, $egZgA.slice).call(_)) : (0, $7Siek.default)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
    };
    return density;
}

});


parcelRegister("f3ekm", function(module, exports) {

$parcel$export(module.exports, "Delaunay", function () { return (parcelRequire("2JAiz")).default; });
$parcel$export(module.exports, "Voronoi", function () { return (parcelRequire("kRv3x")).default; });

var $2JAiz = parcelRequire("2JAiz");

var $kRv3x = parcelRequire("kRv3x");

});
parcelRegister("2JAiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fdbf0e1e42d9519$export$2e2bcd8739ae039; });

var $lMQEj = parcelRequire("lMQEj");

var $dbxyJ = parcelRequire("dbxyJ");

var $iW4zH = parcelRequire("iW4zH");

var $kRv3x = parcelRequire("kRv3x");
const $1fdbf0e1e42d9519$var$tau = 2 * Math.PI, $1fdbf0e1e42d9519$var$pow = Math.pow;
function $1fdbf0e1e42d9519$var$pointX(p) {
    return p[0];
}
function $1fdbf0e1e42d9519$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $1fdbf0e1e42d9519$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $1fdbf0e1e42d9519$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $1fdbf0e1e42d9519$export$2e2bcd8739ae039 {
    static from(points, fx = $1fdbf0e1e42d9519$var$pointX, fy = $1fdbf0e1e42d9519$var$pointY, that) {
        return new $1fdbf0e1e42d9519$export$2e2bcd8739ae039("length" in points ? $1fdbf0e1e42d9519$var$flatArray(points, fx, fy, that) : Float64Array.from($1fdbf0e1e42d9519$var$flatIterable(points, fx, fy, that)));
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $1fdbf0e1e42d9519$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $1fdbf0e1e42d9519$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $lMQEj.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, $kRv3x.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $1fdbf0e1e42d9519$var$pow(x - points[i * 2], 2) + $1fdbf0e1e42d9519$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $1fdbf0e1e42d9519$var$pow(x - points[t * 2], 2) + $1fdbf0e1e42d9519$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($1fdbf0e1e42d9519$var$pow(x - points[e * 2], 2) + $1fdbf0e1e42d9519$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $dbxyJ.default) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, $dbxyJ.default) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $1fdbf0e1e42d9519$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $dbxyJ.default) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $iW4zH.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $dbxyJ.default) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $iW4zH.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
    constructor(points){
        this._delaunator = new (0, $lMQEj.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
}
function $1fdbf0e1e42d9519$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $1fdbf0e1e42d9519$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

});
parcelRegister("lMQEj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc6ebb22fde94d3$export$2e2bcd8739ae039; });
parcelRequire("6Ehx1");
var $4DLuo = parcelRequire("4DLuo");
const $fdc6ebb22fde94d3$var$EPSILON = Math.pow(2, -52);
const $fdc6ebb22fde94d3$var$EDGE_STACK = new Uint32Array(512);
class $fdc6ebb22fde94d3$export$2e2bcd8739ae039 {
    static from(points, getX = $fdc6ebb22fde94d3$var$defaultGetX, getY = $fdc6ebb22fde94d3$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $fdc6ebb22fde94d3$export$2e2bcd8739ae039(coords);
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let minDist = Infinity;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0; i < n; i++){
            const d = $fdc6ebb22fde94d3$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        minDist = Infinity;
        // find the point closest to the seed
        for(let i = 0; i < n; i++){
            if (i === i0) continue;
            const d = $fdc6ebb22fde94d3$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $fdc6ebb22fde94d3$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $fdc6ebb22fde94d3$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, $4DLuo.orient2d)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $fdc6ebb22fde94d3$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $fdc6ebb22fde94d3$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $fdc6ebb22fde94d3$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $fdc6ebb22fde94d3$var$EPSILON && Math.abs(y - yp) <= $fdc6ebb22fde94d3$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, $4DLuo.orient2d)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, $4DLuo.orient2d)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, $4DLuo.orient2d)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($fdc6ebb22fde94d3$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $fdc6ebb22fde94d3$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $fdc6ebb22fde94d3$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $fdc6ebb22fde94d3$var$EDGE_STACK.length) $fdc6ebb22fde94d3$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $fdc6ebb22fde94d3$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $fdc6ebb22fde94d3$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $fdc6ebb22fde94d3$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function $fdc6ebb22fde94d3$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $fdc6ebb22fde94d3$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $fdc6ebb22fde94d3$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $fdc6ebb22fde94d3$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $fdc6ebb22fde94d3$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $fdc6ebb22fde94d3$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $fdc6ebb22fde94d3$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $fdc6ebb22fde94d3$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $fdc6ebb22fde94d3$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $fdc6ebb22fde94d3$var$quicksort(ids, dists, i, right);
            $fdc6ebb22fde94d3$var$quicksort(ids, dists, left, j - 1);
        } else {
            $fdc6ebb22fde94d3$var$quicksort(ids, dists, left, j - 1);
            $fdc6ebb22fde94d3$var$quicksort(ids, dists, i, right);
        }
    }
}
function $fdc6ebb22fde94d3$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $fdc6ebb22fde94d3$var$defaultGetX(p) {
    return p[0];
}
function $fdc6ebb22fde94d3$var$defaultGetY(p) {
    return p[1];
}

});
parcelRegister("6Ehx1", function(module, exports) {

$parcel$export(module.exports, "orient2d", function () { return (parcelRequire("4DLuo")).orient2d; });

var $4DLuo = parcelRequire("4DLuo");

var $arimA = parcelRequire("arimA");

var $dmJE4 = parcelRequire("dmJE4");

var $lALxz = parcelRequire("lALxz");

});
parcelRegister("4DLuo", function(module, exports) {

$parcel$export(module.exports, "orient2d", function () { return $360fa44aeb5e87a5$export$bbb923599a46a7d8; });

var $jsXsn = parcelRequire("jsXsn");
const $360fa44aeb5e87a5$var$ccwerrboundA = (3 + 16 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $360fa44aeb5e87a5$var$ccwerrboundB = (2 + 12 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $360fa44aeb5e87a5$var$ccwerrboundC = (9 + 64 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon) * (0, $jsXsn.epsilon);
const $360fa44aeb5e87a5$var$B = (0, $jsXsn.vec)(4);
const $360fa44aeb5e87a5$var$C1 = (0, $jsXsn.vec)(8);
const $360fa44aeb5e87a5$var$C2 = (0, $jsXsn.vec)(12);
const $360fa44aeb5e87a5$var$D = (0, $jsXsn.vec)(16);
const $360fa44aeb5e87a5$var$u = (0, $jsXsn.vec)(4);
function $360fa44aeb5e87a5$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $jsXsn.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $jsXsn.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $jsXsn.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $jsXsn.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $360fa44aeb5e87a5$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $360fa44aeb5e87a5$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $360fa44aeb5e87a5$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $360fa44aeb5e87a5$var$B[3] = u3;
    let det = (0, $jsXsn.estimate)(4, $360fa44aeb5e87a5$var$B);
    let errbound = $360fa44aeb5e87a5$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $360fa44aeb5e87a5$var$ccwerrboundC * detsum + (0, $jsXsn.resulterrbound) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $jsXsn.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $jsXsn.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $jsXsn.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $jsXsn.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $360fa44aeb5e87a5$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $360fa44aeb5e87a5$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $360fa44aeb5e87a5$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $360fa44aeb5e87a5$var$u[3] = u3;
    const C1len = (0, $jsXsn.sum)(4, $360fa44aeb5e87a5$var$B, 4, $360fa44aeb5e87a5$var$u, $360fa44aeb5e87a5$var$C1);
    s1 = acx * bcytail;
    c = (0, $jsXsn.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $jsXsn.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $jsXsn.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $jsXsn.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $360fa44aeb5e87a5$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $360fa44aeb5e87a5$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $360fa44aeb5e87a5$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $360fa44aeb5e87a5$var$u[3] = u3;
    const C2len = (0, $jsXsn.sum)(C1len, $360fa44aeb5e87a5$var$C1, 4, $360fa44aeb5e87a5$var$u, $360fa44aeb5e87a5$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $jsXsn.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $jsXsn.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $jsXsn.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $jsXsn.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $360fa44aeb5e87a5$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $360fa44aeb5e87a5$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $360fa44aeb5e87a5$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $360fa44aeb5e87a5$var$u[3] = u3;
    const Dlen = (0, $jsXsn.sum)(C2len, $360fa44aeb5e87a5$var$C2, 4, $360fa44aeb5e87a5$var$u, $360fa44aeb5e87a5$var$D);
    return $360fa44aeb5e87a5$var$D[Dlen - 1];
}
function $360fa44aeb5e87a5$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    if (detleft === 0 || detright === 0 || detleft > 0 !== detright > 0) return det;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $360fa44aeb5e87a5$var$ccwerrboundA * detsum) return det;
    return -$360fa44aeb5e87a5$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $360fa44aeb5e87a5$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

});
parcelRegister("jsXsn", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return $e2bec0b4a1ca8577$export$6c421550c66a327d; });
$parcel$export(module.exports, "splitter", function () { return $e2bec0b4a1ca8577$export$8cfde575cbd41e40; });
$parcel$export(module.exports, "resulterrbound", function () { return $e2bec0b4a1ca8577$export$a4103c3ab16b06d7; });
$parcel$export(module.exports, "sum", function () { return $e2bec0b4a1ca8577$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "sum_three", function () { return $e2bec0b4a1ca8577$export$195a93e4bd4d876f; });
$parcel$export(module.exports, "scale", function () { return $e2bec0b4a1ca8577$export$dcdf75081b88279d; });
$parcel$export(module.exports, "negate", function () { return $e2bec0b4a1ca8577$export$aef51622e549b8b0; });
$parcel$export(module.exports, "estimate", function () { return $e2bec0b4a1ca8577$export$9f3a0795ca2cc944; });
$parcel$export(module.exports, "vec", function () { return $e2bec0b4a1ca8577$export$202e0172ed3c7be0; });
const $e2bec0b4a1ca8577$export$6c421550c66a327d = 1.1102230246251565e-16;
const $e2bec0b4a1ca8577$export$8cfde575cbd41e40 = 134217729;
const $e2bec0b4a1ca8577$export$a4103c3ab16b06d7 = (3 + 8 * $e2bec0b4a1ca8577$export$6c421550c66a327d) * $e2bec0b4a1ca8577$export$6c421550c66a327d;
function $e2bec0b4a1ca8577$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $e2bec0b4a1ca8577$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $e2bec0b4a1ca8577$export$8a63f25cc62965f1($e2bec0b4a1ca8577$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $e2bec0b4a1ca8577$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $e2bec0b4a1ca8577$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $e2bec0b4a1ca8577$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $e2bec0b4a1ca8577$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $e2bec0b4a1ca8577$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $e2bec0b4a1ca8577$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $e2bec0b4a1ca8577$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}

});


parcelRegister("arimA", function(module, exports) {

var $jsXsn = parcelRequire("jsXsn");
const $799aab961f9509c5$var$o3derrboundA = (7 + 56 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $799aab961f9509c5$var$o3derrboundB = (3 + 28 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $799aab961f9509c5$var$o3derrboundC = (26 + 288 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon) * (0, $jsXsn.epsilon);
const $799aab961f9509c5$var$bc = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$ca = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$ab = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$at_b = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$at_c = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$bt_c = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$bt_a = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$ct_a = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$ct_b = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$bct = (0, $jsXsn.vec)(8);
const $799aab961f9509c5$var$cat = (0, $jsXsn.vec)(8);
const $799aab961f9509c5$var$abt = (0, $jsXsn.vec)(8);
const $799aab961f9509c5$var$u = (0, $jsXsn.vec)(4);
const $799aab961f9509c5$var$_8 = (0, $jsXsn.vec)(8);
const $799aab961f9509c5$var$_8b = (0, $jsXsn.vec)(8);
const $799aab961f9509c5$var$_16 = (0, $jsXsn.vec)(8);
const $799aab961f9509c5$var$_12 = (0, $jsXsn.vec)(12);
let $799aab961f9509c5$var$fin = (0, $jsXsn.vec)(192);
let $799aab961f9509c5$var$fin2 = (0, $jsXsn.vec)(192);
function $799aab961f9509c5$var$finadd(finlen, alen, a) {
    finlen = (0, $jsXsn.sum)(finlen, $799aab961f9509c5$var$fin, alen, a, $799aab961f9509c5$var$fin2);
    const tmp = $799aab961f9509c5$var$fin;
    $799aab961f9509c5$var$fin = $799aab961f9509c5$var$fin2;
    $799aab961f9509c5$var$fin2 = tmp;
    return finlen;
}
function $799aab961f9509c5$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $jsXsn.splitter) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $jsXsn.splitter) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $jsXsn.splitter) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $jsXsn.splitter) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $jsXsn.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $jsXsn.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $jsXsn.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $jsXsn.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $jsXsn.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $jsXsn.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $jsXsn.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $jsXsn.splitter) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $jsXsn.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $jsXsn.splitter) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $jsXsn.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $jsXsn.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $799aab961f9509c5$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $jsXsn.splitter) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $jsXsn.splitter) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $jsXsn.splitter) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $jsXsn.splitter) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $799aab961f9509c5$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $jsXsn.splitter) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $799aab961f9509c5$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $799aab961f9509c5$var$u[2] = _k - (u3 - _j);
    $799aab961f9509c5$var$u[3] = u3;
    finlen = $799aab961f9509c5$var$finadd(finlen, 4, $799aab961f9509c5$var$u);
    if (z !== 0) {
        c = (0, $jsXsn.splitter) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $jsXsn.splitter) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $799aab961f9509c5$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $jsXsn.splitter) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $799aab961f9509c5$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $799aab961f9509c5$var$u[2] = _k - (u3 - _j);
        $799aab961f9509c5$var$u[3] = u3;
        finlen = $799aab961f9509c5$var$finadd(finlen, 4, $799aab961f9509c5$var$u);
    }
    return finlen;
}
function $799aab961f9509c5$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $jsXsn.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $jsXsn.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $jsXsn.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $jsXsn.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $799aab961f9509c5$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $799aab961f9509c5$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $799aab961f9509c5$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $799aab961f9509c5$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $jsXsn.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $jsXsn.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $jsXsn.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $jsXsn.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $799aab961f9509c5$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $799aab961f9509c5$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $799aab961f9509c5$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $799aab961f9509c5$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $jsXsn.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $jsXsn.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $jsXsn.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $jsXsn.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $799aab961f9509c5$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $799aab961f9509c5$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $799aab961f9509c5$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $799aab961f9509c5$var$ab[3] = u3;
    finlen = (0, $jsXsn.sum)((0, $jsXsn.sum)((0, $jsXsn.scale)(4, $799aab961f9509c5$var$bc, adz, $799aab961f9509c5$var$_8), $799aab961f9509c5$var$_8, (0, $jsXsn.scale)(4, $799aab961f9509c5$var$ca, bdz, $799aab961f9509c5$var$_8b), $799aab961f9509c5$var$_8b, $799aab961f9509c5$var$_16), $799aab961f9509c5$var$_16, (0, $jsXsn.scale)(4, $799aab961f9509c5$var$ab, cdz, $799aab961f9509c5$var$_8), $799aab961f9509c5$var$_8, $799aab961f9509c5$var$fin);
    let det = (0, $jsXsn.estimate)(finlen, $799aab961f9509c5$var$fin);
    let errbound = $799aab961f9509c5$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $799aab961f9509c5$var$o3derrboundC * permanent + (0, $jsXsn.resulterrbound) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $799aab961f9509c5$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $799aab961f9509c5$var$at_b, $799aab961f9509c5$var$at_c);
    const bt_len = $799aab961f9509c5$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $799aab961f9509c5$var$bt_c, $799aab961f9509c5$var$bt_a);
    const ct_len = $799aab961f9509c5$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $799aab961f9509c5$var$ct_a, $799aab961f9509c5$var$ct_b);
    const bctlen = (0, $jsXsn.sum)(bt_len, $799aab961f9509c5$var$bt_c, ct_len, $799aab961f9509c5$var$ct_b, $799aab961f9509c5$var$bct);
    finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(bctlen, $799aab961f9509c5$var$bct, adz, $799aab961f9509c5$var$_16), $799aab961f9509c5$var$_16);
    const catlen = (0, $jsXsn.sum)(ct_len, $799aab961f9509c5$var$ct_a, at_len, $799aab961f9509c5$var$at_c, $799aab961f9509c5$var$cat);
    finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(catlen, $799aab961f9509c5$var$cat, bdz, $799aab961f9509c5$var$_16), $799aab961f9509c5$var$_16);
    const abtlen = (0, $jsXsn.sum)(at_len, $799aab961f9509c5$var$at_b, bt_len, $799aab961f9509c5$var$bt_a, $799aab961f9509c5$var$abt);
    finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(abtlen, $799aab961f9509c5$var$abt, cdz, $799aab961f9509c5$var$_16), $799aab961f9509c5$var$_16);
    if (adztail !== 0) {
        finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(4, $799aab961f9509c5$var$bc, adztail, $799aab961f9509c5$var$_12), $799aab961f9509c5$var$_12);
        finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(bctlen, $799aab961f9509c5$var$bct, adztail, $799aab961f9509c5$var$_16), $799aab961f9509c5$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(4, $799aab961f9509c5$var$ca, bdztail, $799aab961f9509c5$var$_12), $799aab961f9509c5$var$_12);
        finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(catlen, $799aab961f9509c5$var$cat, bdztail, $799aab961f9509c5$var$_16), $799aab961f9509c5$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(4, $799aab961f9509c5$var$ab, cdztail, $799aab961f9509c5$var$_12), $799aab961f9509c5$var$_12);
        finlen = $799aab961f9509c5$var$finadd(finlen, (0, $jsXsn.scale)(abtlen, $799aab961f9509c5$var$abt, cdztail, $799aab961f9509c5$var$_16), $799aab961f9509c5$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $799aab961f9509c5$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $799aab961f9509c5$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $799aab961f9509c5$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $799aab961f9509c5$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $799aab961f9509c5$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $799aab961f9509c5$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $799aab961f9509c5$var$fin[finlen - 1];
}
function $799aab961f9509c5$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $799aab961f9509c5$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $799aab961f9509c5$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $799aab961f9509c5$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}

});

parcelRegister("dmJE4", function(module, exports) {

var $jsXsn = parcelRequire("jsXsn");
const $9bb0bca8035eb1f8$var$iccerrboundA = (10 + 96 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $9bb0bca8035eb1f8$var$iccerrboundB = (4 + 48 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $9bb0bca8035eb1f8$var$iccerrboundC = (44 + 576 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon) * (0, $jsXsn.epsilon);
const $9bb0bca8035eb1f8$var$bc = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$ca = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$ab = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$aa = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$bb = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$cc = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$u = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$v = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$axtbc = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$aytbc = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$bxtca = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$bytca = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$cxtab = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$cytab = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$abt = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$bct = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$cat = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$abtt = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$bctt = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$catt = (0, $jsXsn.vec)(4);
const $9bb0bca8035eb1f8$var$_8 = (0, $jsXsn.vec)(8);
const $9bb0bca8035eb1f8$var$_16 = (0, $jsXsn.vec)(16);
const $9bb0bca8035eb1f8$var$_16b = (0, $jsXsn.vec)(16);
const $9bb0bca8035eb1f8$var$_16c = (0, $jsXsn.vec)(16);
const $9bb0bca8035eb1f8$var$_32 = (0, $jsXsn.vec)(32);
const $9bb0bca8035eb1f8$var$_32b = (0, $jsXsn.vec)(32);
const $9bb0bca8035eb1f8$var$_48 = (0, $jsXsn.vec)(48);
const $9bb0bca8035eb1f8$var$_64 = (0, $jsXsn.vec)(64);
let $9bb0bca8035eb1f8$var$fin = (0, $jsXsn.vec)(1152);
let $9bb0bca8035eb1f8$var$fin2 = (0, $jsXsn.vec)(1152);
function $9bb0bca8035eb1f8$var$finadd(finlen, a, alen) {
    finlen = (0, $jsXsn.sum)(finlen, $9bb0bca8035eb1f8$var$fin, a, alen, $9bb0bca8035eb1f8$var$fin2);
    const tmp = $9bb0bca8035eb1f8$var$fin;
    $9bb0bca8035eb1f8$var$fin = $9bb0bca8035eb1f8$var$fin2;
    $9bb0bca8035eb1f8$var$fin2 = tmp;
    return finlen;
}
function $9bb0bca8035eb1f8$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $jsXsn.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $jsXsn.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $jsXsn.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $jsXsn.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $9bb0bca8035eb1f8$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $9bb0bca8035eb1f8$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $9bb0bca8035eb1f8$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $9bb0bca8035eb1f8$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $jsXsn.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $jsXsn.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $jsXsn.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $jsXsn.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $9bb0bca8035eb1f8$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $9bb0bca8035eb1f8$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $9bb0bca8035eb1f8$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $9bb0bca8035eb1f8$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $jsXsn.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $jsXsn.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $jsXsn.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $jsXsn.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $9bb0bca8035eb1f8$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $9bb0bca8035eb1f8$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $9bb0bca8035eb1f8$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $9bb0bca8035eb1f8$var$ab[3] = u3;
    finlen = (0, $jsXsn.sum)((0, $jsXsn.sum)((0, $jsXsn.sum)((0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bc, adx, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, adx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bc, ady, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, ady, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, (0, $jsXsn.sum)((0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ca, bdx, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, bdx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ca, bdy, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, bdy, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, $9bb0bca8035eb1f8$var$_32b), $9bb0bca8035eb1f8$var$_32b, $9bb0bca8035eb1f8$var$_64), $9bb0bca8035eb1f8$var$_64, (0, $jsXsn.sum)((0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ab, cdx, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, cdx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ab, cdy, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, cdy, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$fin);
    let det = (0, $jsXsn.estimate)(finlen, $9bb0bca8035eb1f8$var$fin);
    let errbound = $9bb0bca8035eb1f8$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $9bb0bca8035eb1f8$var$iccerrboundC * permanent + (0, $jsXsn.resulterrbound) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $jsXsn.splitter) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $jsXsn.splitter) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $9bb0bca8035eb1f8$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $9bb0bca8035eb1f8$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $9bb0bca8035eb1f8$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $9bb0bca8035eb1f8$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $jsXsn.splitter) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $jsXsn.splitter) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $9bb0bca8035eb1f8$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $9bb0bca8035eb1f8$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $9bb0bca8035eb1f8$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $9bb0bca8035eb1f8$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $jsXsn.splitter) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $jsXsn.splitter) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $9bb0bca8035eb1f8$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $9bb0bca8035eb1f8$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $9bb0bca8035eb1f8$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $9bb0bca8035eb1f8$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bc, adxtail, $9bb0bca8035eb1f8$var$axtbc);
        finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(axtbclen, $9bb0bca8035eb1f8$var$axtbc, 2 * adx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$cc, adxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, bdy, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bb, adxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, -cdy, $9bb0bca8035eb1f8$var$_16c), $9bb0bca8035eb1f8$var$_16c, $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bc, adytail, $9bb0bca8035eb1f8$var$aytbc);
        finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(aytbclen, $9bb0bca8035eb1f8$var$aytbc, 2 * ady, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bb, adytail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, cdx, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$cc, adytail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, -bdx, $9bb0bca8035eb1f8$var$_16c), $9bb0bca8035eb1f8$var$_16c, $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ca, bdxtail, $9bb0bca8035eb1f8$var$bxtca);
        finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(bxtcalen, $9bb0bca8035eb1f8$var$bxtca, 2 * bdx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$aa, bdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, cdy, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$cc, bdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, -ady, $9bb0bca8035eb1f8$var$_16c), $9bb0bca8035eb1f8$var$_16c, $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ca, bdytail, $9bb0bca8035eb1f8$var$bytca);
        finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(bytcalen, $9bb0bca8035eb1f8$var$bytca, 2 * bdy, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$cc, bdytail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, adx, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$aa, bdytail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, -cdx, $9bb0bca8035eb1f8$var$_16c), $9bb0bca8035eb1f8$var$_16c, $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ab, cdxtail, $9bb0bca8035eb1f8$var$cxtab);
        finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(cxtablen, $9bb0bca8035eb1f8$var$cxtab, 2 * cdx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bb, cdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, ady, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$aa, cdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, -bdy, $9bb0bca8035eb1f8$var$_16c), $9bb0bca8035eb1f8$var$_16c, $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$ab, cdytail, $9bb0bca8035eb1f8$var$cytab);
        finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(cytablen, $9bb0bca8035eb1f8$var$cytab, 2 * cdy, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$aa, cdytail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, bdx, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bb, cdytail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, -adx, $9bb0bca8035eb1f8$var$_16c), $9bb0bca8035eb1f8$var$_16c, $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $jsXsn.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $jsXsn.splitter) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $jsXsn.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $jsXsn.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $9bb0bca8035eb1f8$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $9bb0bca8035eb1f8$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $jsXsn.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $jsXsn.splitter) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $jsXsn.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $jsXsn.splitter) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $9bb0bca8035eb1f8$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $9bb0bca8035eb1f8$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$v[3] = u3;
            bctlen = (0, $jsXsn.sum)(4, $9bb0bca8035eb1f8$var$u, 4, $9bb0bca8035eb1f8$var$v, $9bb0bca8035eb1f8$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $jsXsn.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $jsXsn.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $jsXsn.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $jsXsn.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $9bb0bca8035eb1f8$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $9bb0bca8035eb1f8$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $9bb0bca8035eb1f8$var$bct[0] = 0;
            bctlen = 1;
            $9bb0bca8035eb1f8$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $jsXsn.scale)(bctlen, $9bb0bca8035eb1f8$var$bct, adxtail, $9bb0bca8035eb1f8$var$_16c);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum)((0, $jsXsn.scale)(axtbclen, $9bb0bca8035eb1f8$var$axtbc, adxtail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, 2 * adx, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
            const len2 = (0, $jsXsn.scale)(bcttlen, $9bb0bca8035eb1f8$var$bctt, adxtail, $9bb0bca8035eb1f8$var$_8);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, 2 * adx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, adxtail, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, adxtail, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_32b, $9bb0bca8035eb1f8$var$_64), $9bb0bca8035eb1f8$var$_64);
            if (bdytail !== 0) finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$cc, adxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, bdytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16);
            if (cdytail !== 0) finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bb, -adxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, cdytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $jsXsn.scale)(bctlen, $9bb0bca8035eb1f8$var$bct, adytail, $9bb0bca8035eb1f8$var$_16c);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum)((0, $jsXsn.scale)(aytbclen, $9bb0bca8035eb1f8$var$aytbc, adytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, 2 * ady, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
            const len2 = (0, $jsXsn.scale)(bcttlen, $9bb0bca8035eb1f8$var$bctt, adytail, $9bb0bca8035eb1f8$var$_8);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, 2 * ady, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, adytail, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, adytail, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_32b, $9bb0bca8035eb1f8$var$_64), $9bb0bca8035eb1f8$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $jsXsn.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $jsXsn.splitter) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $jsXsn.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $jsXsn.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $9bb0bca8035eb1f8$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $9bb0bca8035eb1f8$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $jsXsn.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $jsXsn.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $jsXsn.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $jsXsn.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $9bb0bca8035eb1f8$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $9bb0bca8035eb1f8$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$v[3] = u3;
            catlen = (0, $jsXsn.sum)(4, $9bb0bca8035eb1f8$var$u, 4, $9bb0bca8035eb1f8$var$v, $9bb0bca8035eb1f8$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $jsXsn.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $jsXsn.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $jsXsn.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $jsXsn.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $9bb0bca8035eb1f8$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $9bb0bca8035eb1f8$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $9bb0bca8035eb1f8$var$cat[0] = 0;
            catlen = 1;
            $9bb0bca8035eb1f8$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $jsXsn.scale)(catlen, $9bb0bca8035eb1f8$var$cat, bdxtail, $9bb0bca8035eb1f8$var$_16c);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum)((0, $jsXsn.scale)(bxtcalen, $9bb0bca8035eb1f8$var$bxtca, bdxtail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, 2 * bdx, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
            const len2 = (0, $jsXsn.scale)(cattlen, $9bb0bca8035eb1f8$var$catt, bdxtail, $9bb0bca8035eb1f8$var$_8);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, 2 * bdx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, bdxtail, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, bdxtail, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_32b, $9bb0bca8035eb1f8$var$_64), $9bb0bca8035eb1f8$var$_64);
            if (cdytail !== 0) finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$aa, bdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, cdytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16);
            if (adytail !== 0) finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$cc, -bdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, adytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $jsXsn.scale)(catlen, $9bb0bca8035eb1f8$var$cat, bdytail, $9bb0bca8035eb1f8$var$_16c);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum)((0, $jsXsn.scale)(bytcalen, $9bb0bca8035eb1f8$var$bytca, bdytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, 2 * bdy, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
            const len2 = (0, $jsXsn.scale)(cattlen, $9bb0bca8035eb1f8$var$catt, bdytail, $9bb0bca8035eb1f8$var$_8);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, 2 * bdy, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, bdytail, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, bdytail, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_32b, $9bb0bca8035eb1f8$var$_64), $9bb0bca8035eb1f8$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $jsXsn.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $jsXsn.splitter) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $jsXsn.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $jsXsn.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $9bb0bca8035eb1f8$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $9bb0bca8035eb1f8$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $jsXsn.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $jsXsn.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $jsXsn.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $jsXsn.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $9bb0bca8035eb1f8$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $9bb0bca8035eb1f8$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$v[3] = u3;
            abtlen = (0, $jsXsn.sum)(4, $9bb0bca8035eb1f8$var$u, 4, $9bb0bca8035eb1f8$var$v, $9bb0bca8035eb1f8$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $jsXsn.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $jsXsn.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $jsXsn.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $jsXsn.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $9bb0bca8035eb1f8$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $9bb0bca8035eb1f8$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $9bb0bca8035eb1f8$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $9bb0bca8035eb1f8$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $9bb0bca8035eb1f8$var$abt[0] = 0;
            abtlen = 1;
            $9bb0bca8035eb1f8$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $jsXsn.scale)(abtlen, $9bb0bca8035eb1f8$var$abt, cdxtail, $9bb0bca8035eb1f8$var$_16c);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum)((0, $jsXsn.scale)(cxtablen, $9bb0bca8035eb1f8$var$cxtab, cdxtail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, 2 * cdx, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
            const len2 = (0, $jsXsn.scale)(abttlen, $9bb0bca8035eb1f8$var$abtt, cdxtail, $9bb0bca8035eb1f8$var$_8);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, 2 * cdx, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, cdxtail, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, cdxtail, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_32b, $9bb0bca8035eb1f8$var$_64), $9bb0bca8035eb1f8$var$_64);
            if (adytail !== 0) finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$bb, cdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, adytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16);
            if (bdytail !== 0) finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.scale)((0, $jsXsn.scale)(4, $9bb0bca8035eb1f8$var$aa, -cdxtail, $9bb0bca8035eb1f8$var$_8), $9bb0bca8035eb1f8$var$_8, bdytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $jsXsn.scale)(abtlen, $9bb0bca8035eb1f8$var$abt, cdytail, $9bb0bca8035eb1f8$var$_16c);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum)((0, $jsXsn.scale)(cytablen, $9bb0bca8035eb1f8$var$cytab, cdytail, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, 2 * cdy, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_48), $9bb0bca8035eb1f8$var$_48);
            const len2 = (0, $jsXsn.scale)(abttlen, $9bb0bca8035eb1f8$var$abtt, cdytail, $9bb0bca8035eb1f8$var$_8);
            finlen = $9bb0bca8035eb1f8$var$finadd(finlen, (0, $jsXsn.sum_three)((0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, 2 * cdy, $9bb0bca8035eb1f8$var$_16), $9bb0bca8035eb1f8$var$_16, (0, $jsXsn.scale)(len2, $9bb0bca8035eb1f8$var$_8, cdytail, $9bb0bca8035eb1f8$var$_16b), $9bb0bca8035eb1f8$var$_16b, (0, $jsXsn.scale)(len, $9bb0bca8035eb1f8$var$_16c, cdytail, $9bb0bca8035eb1f8$var$_32), $9bb0bca8035eb1f8$var$_32, $9bb0bca8035eb1f8$var$_32b, $9bb0bca8035eb1f8$var$_64), $9bb0bca8035eb1f8$var$_64);
        }
    }
    return $9bb0bca8035eb1f8$var$fin[finlen - 1];
}
function $9bb0bca8035eb1f8$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $9bb0bca8035eb1f8$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $9bb0bca8035eb1f8$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $9bb0bca8035eb1f8$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}

});

parcelRegister("lALxz", function(module, exports) {

var $jsXsn = parcelRequire("jsXsn");
const $fb81d64eb1da6605$var$isperrboundA = (16 + 224 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $fb81d64eb1da6605$var$isperrboundB = (5 + 72 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon);
const $fb81d64eb1da6605$var$isperrboundC = (71 + 1408 * (0, $jsXsn.epsilon)) * (0, $jsXsn.epsilon) * (0, $jsXsn.epsilon);
const $fb81d64eb1da6605$var$ab = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$bc = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$cd = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$de = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$ea = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$ac = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$bd = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$ce = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$da = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$eb = (0, $jsXsn.vec)(4);
const $fb81d64eb1da6605$var$abc = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$bcd = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$cde = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$dea = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$eab = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$abd = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$bce = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$cda = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$deb = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$eac = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$adet = (0, $jsXsn.vec)(1152);
const $fb81d64eb1da6605$var$bdet = (0, $jsXsn.vec)(1152);
const $fb81d64eb1da6605$var$cdet = (0, $jsXsn.vec)(1152);
const $fb81d64eb1da6605$var$ddet = (0, $jsXsn.vec)(1152);
const $fb81d64eb1da6605$var$edet = (0, $jsXsn.vec)(1152);
const $fb81d64eb1da6605$var$abdet = (0, $jsXsn.vec)(2304);
const $fb81d64eb1da6605$var$cddet = (0, $jsXsn.vec)(2304);
const $fb81d64eb1da6605$var$cdedet = (0, $jsXsn.vec)(3456);
const $fb81d64eb1da6605$var$deter = (0, $jsXsn.vec)(5760);
const $fb81d64eb1da6605$var$_8 = (0, $jsXsn.vec)(8);
const $fb81d64eb1da6605$var$_8b = (0, $jsXsn.vec)(8);
const $fb81d64eb1da6605$var$_8c = (0, $jsXsn.vec)(8);
const $fb81d64eb1da6605$var$_16 = (0, $jsXsn.vec)(16);
const $fb81d64eb1da6605$var$_24 = (0, $jsXsn.vec)(24);
const $fb81d64eb1da6605$var$_48 = (0, $jsXsn.vec)(48);
const $fb81d64eb1da6605$var$_48b = (0, $jsXsn.vec)(48);
const $fb81d64eb1da6605$var$_96 = (0, $jsXsn.vec)(96);
const $fb81d64eb1da6605$var$_192 = (0, $jsXsn.vec)(192);
const $fb81d64eb1da6605$var$_384x = (0, $jsXsn.vec)(384);
const $fb81d64eb1da6605$var$_384y = (0, $jsXsn.vec)(384);
const $fb81d64eb1da6605$var$_384z = (0, $jsXsn.vec)(384);
const $fb81d64eb1da6605$var$_768 = (0, $jsXsn.vec)(768);
function $fb81d64eb1da6605$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $jsXsn.sum_three)((0, $jsXsn.scale)(4, a, az, $fb81d64eb1da6605$var$_8), $fb81d64eb1da6605$var$_8, (0, $jsXsn.scale)(4, b, bz, $fb81d64eb1da6605$var$_8b), $fb81d64eb1da6605$var$_8b, (0, $jsXsn.scale)(4, c, cz, $fb81d64eb1da6605$var$_8c), $fb81d64eb1da6605$var$_8c, $fb81d64eb1da6605$var$_16, out);
}
function $fb81d64eb1da6605$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $jsXsn.sum)((0, $jsXsn.sum)(alen, a, blen, b, $fb81d64eb1da6605$var$_48), $fb81d64eb1da6605$var$_48, (0, $jsXsn.negate)((0, $jsXsn.sum)(clen, c, dlen, d, $fb81d64eb1da6605$var$_48b), $fb81d64eb1da6605$var$_48b), $fb81d64eb1da6605$var$_48b, $fb81d64eb1da6605$var$_96);
    return (0, $jsXsn.sum_three)((0, $jsXsn.scale)((0, $jsXsn.scale)(len, $fb81d64eb1da6605$var$_96, x, $fb81d64eb1da6605$var$_192), $fb81d64eb1da6605$var$_192, x, $fb81d64eb1da6605$var$_384x), $fb81d64eb1da6605$var$_384x, (0, $jsXsn.scale)((0, $jsXsn.scale)(len, $fb81d64eb1da6605$var$_96, y, $fb81d64eb1da6605$var$_192), $fb81d64eb1da6605$var$_192, y, $fb81d64eb1da6605$var$_384y), $fb81d64eb1da6605$var$_384y, (0, $jsXsn.scale)((0, $jsXsn.scale)(len, $fb81d64eb1da6605$var$_96, z, $fb81d64eb1da6605$var$_192), $fb81d64eb1da6605$var$_192, z, $fb81d64eb1da6605$var$_384z), $fb81d64eb1da6605$var$_384z, $fb81d64eb1da6605$var$_768, out);
}
function $fb81d64eb1da6605$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $jsXsn.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $jsXsn.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $jsXsn.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $jsXsn.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $jsXsn.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $jsXsn.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $jsXsn.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $jsXsn.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $jsXsn.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $jsXsn.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $jsXsn.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $jsXsn.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $jsXsn.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $jsXsn.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $jsXsn.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $jsXsn.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $jsXsn.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $jsXsn.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $jsXsn.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $jsXsn.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $jsXsn.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $jsXsn.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $jsXsn.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $jsXsn.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $jsXsn.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $jsXsn.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $jsXsn.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $jsXsn.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $jsXsn.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $jsXsn.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $jsXsn.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $jsXsn.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $jsXsn.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $jsXsn.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $jsXsn.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $jsXsn.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $jsXsn.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $jsXsn.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $jsXsn.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $jsXsn.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $fb81d64eb1da6605$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$eb[3] = u3;
    const abclen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$ab, $fb81d64eb1da6605$var$bc, $fb81d64eb1da6605$var$ac, cz, az, -bz, $fb81d64eb1da6605$var$abc);
    const bcdlen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$bc, $fb81d64eb1da6605$var$cd, $fb81d64eb1da6605$var$bd, dz, bz, -cz, $fb81d64eb1da6605$var$bcd);
    const cdelen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$cd, $fb81d64eb1da6605$var$de, $fb81d64eb1da6605$var$ce, ez, cz, -dz, $fb81d64eb1da6605$var$cde);
    const dealen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$de, $fb81d64eb1da6605$var$ea, $fb81d64eb1da6605$var$da, az, dz, -ez, $fb81d64eb1da6605$var$dea);
    const eablen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$ea, $fb81d64eb1da6605$var$ab, $fb81d64eb1da6605$var$eb, bz, ez, -az, $fb81d64eb1da6605$var$eab);
    const abdlen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$ab, $fb81d64eb1da6605$var$bd, $fb81d64eb1da6605$var$da, dz, az, bz, $fb81d64eb1da6605$var$abd);
    const bcelen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$bc, $fb81d64eb1da6605$var$ce, $fb81d64eb1da6605$var$eb, ez, bz, cz, $fb81d64eb1da6605$var$bce);
    const cdalen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$cd, $fb81d64eb1da6605$var$da, $fb81d64eb1da6605$var$ac, az, cz, dz, $fb81d64eb1da6605$var$cda);
    const deblen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$de, $fb81d64eb1da6605$var$eb, $fb81d64eb1da6605$var$bd, bz, dz, ez, $fb81d64eb1da6605$var$deb);
    const eaclen = $fb81d64eb1da6605$var$sum_three_scale($fb81d64eb1da6605$var$ea, $fb81d64eb1da6605$var$ac, $fb81d64eb1da6605$var$ce, cz, ez, az, $fb81d64eb1da6605$var$eac);
    const deterlen = (0, $jsXsn.sum_three)($fb81d64eb1da6605$var$liftexact(cdelen, $fb81d64eb1da6605$var$cde, bcelen, $fb81d64eb1da6605$var$bce, deblen, $fb81d64eb1da6605$var$deb, bcdlen, $fb81d64eb1da6605$var$bcd, ax, ay, az, $fb81d64eb1da6605$var$adet), $fb81d64eb1da6605$var$adet, $fb81d64eb1da6605$var$liftexact(dealen, $fb81d64eb1da6605$var$dea, cdalen, $fb81d64eb1da6605$var$cda, eaclen, $fb81d64eb1da6605$var$eac, cdelen, $fb81d64eb1da6605$var$cde, bx, by, bz, $fb81d64eb1da6605$var$bdet), $fb81d64eb1da6605$var$bdet, (0, $jsXsn.sum_three)($fb81d64eb1da6605$var$liftexact(eablen, $fb81d64eb1da6605$var$eab, deblen, $fb81d64eb1da6605$var$deb, abdlen, $fb81d64eb1da6605$var$abd, dealen, $fb81d64eb1da6605$var$dea, cx, cy, cz, $fb81d64eb1da6605$var$cdet), $fb81d64eb1da6605$var$cdet, $fb81d64eb1da6605$var$liftexact(abclen, $fb81d64eb1da6605$var$abc, eaclen, $fb81d64eb1da6605$var$eac, bcelen, $fb81d64eb1da6605$var$bce, eablen, $fb81d64eb1da6605$var$eab, dx, dy, dz, $fb81d64eb1da6605$var$ddet), $fb81d64eb1da6605$var$ddet, $fb81d64eb1da6605$var$liftexact(bcdlen, $fb81d64eb1da6605$var$bcd, abdlen, $fb81d64eb1da6605$var$abd, cdalen, $fb81d64eb1da6605$var$cda, abclen, $fb81d64eb1da6605$var$abc, ex, ey, ez, $fb81d64eb1da6605$var$edet), $fb81d64eb1da6605$var$edet, $fb81d64eb1da6605$var$cddet, $fb81d64eb1da6605$var$cdedet), $fb81d64eb1da6605$var$cdedet, $fb81d64eb1da6605$var$abdet, $fb81d64eb1da6605$var$deter);
    return $fb81d64eb1da6605$var$deter[deterlen - 1];
}
const $fb81d64eb1da6605$var$xdet = (0, $jsXsn.vec)(96);
const $fb81d64eb1da6605$var$ydet = (0, $jsXsn.vec)(96);
const $fb81d64eb1da6605$var$zdet = (0, $jsXsn.vec)(96);
const $fb81d64eb1da6605$var$fin = (0, $jsXsn.vec)(1152);
function $fb81d64eb1da6605$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $fb81d64eb1da6605$var$sum_three_scale(a, b, c, az, bz, cz, $fb81d64eb1da6605$var$_24);
    return (0, $jsXsn.sum_three)((0, $jsXsn.scale)((0, $jsXsn.scale)(len, $fb81d64eb1da6605$var$_24, x, $fb81d64eb1da6605$var$_48), $fb81d64eb1da6605$var$_48, x, $fb81d64eb1da6605$var$xdet), $fb81d64eb1da6605$var$xdet, (0, $jsXsn.scale)((0, $jsXsn.scale)(len, $fb81d64eb1da6605$var$_24, y, $fb81d64eb1da6605$var$_48), $fb81d64eb1da6605$var$_48, y, $fb81d64eb1da6605$var$ydet), $fb81d64eb1da6605$var$ydet, (0, $jsXsn.scale)((0, $jsXsn.scale)(len, $fb81d64eb1da6605$var$_24, z, $fb81d64eb1da6605$var$_48), $fb81d64eb1da6605$var$_48, z, $fb81d64eb1da6605$var$zdet), $fb81d64eb1da6605$var$zdet, $fb81d64eb1da6605$var$_192, out);
}
function $fb81d64eb1da6605$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $jsXsn.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $jsXsn.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $jsXsn.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $jsXsn.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $fb81d64eb1da6605$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $jsXsn.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $jsXsn.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $jsXsn.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $jsXsn.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $fb81d64eb1da6605$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $jsXsn.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $jsXsn.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $jsXsn.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $jsXsn.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $fb81d64eb1da6605$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $jsXsn.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $jsXsn.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $jsXsn.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $jsXsn.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $fb81d64eb1da6605$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $jsXsn.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $jsXsn.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $jsXsn.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $jsXsn.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $fb81d64eb1da6605$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $jsXsn.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $jsXsn.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $jsXsn.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $jsXsn.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $fb81d64eb1da6605$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $fb81d64eb1da6605$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $fb81d64eb1da6605$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $fb81d64eb1da6605$var$bd[3] = bd3;
    const finlen = (0, $jsXsn.sum)((0, $jsXsn.sum)((0, $jsXsn.negate)($fb81d64eb1da6605$var$liftadapt($fb81d64eb1da6605$var$bc, $fb81d64eb1da6605$var$cd, $fb81d64eb1da6605$var$bd, dez, bez, -cez, aex, aey, aez, $fb81d64eb1da6605$var$adet), $fb81d64eb1da6605$var$adet), $fb81d64eb1da6605$var$adet, $fb81d64eb1da6605$var$liftadapt($fb81d64eb1da6605$var$cd, $fb81d64eb1da6605$var$da, $fb81d64eb1da6605$var$ac, aez, cez, dez, bex, bey, bez, $fb81d64eb1da6605$var$bdet), $fb81d64eb1da6605$var$bdet, $fb81d64eb1da6605$var$abdet), $fb81d64eb1da6605$var$abdet, (0, $jsXsn.sum)((0, $jsXsn.negate)($fb81d64eb1da6605$var$liftadapt($fb81d64eb1da6605$var$da, $fb81d64eb1da6605$var$ab, $fb81d64eb1da6605$var$bd, bez, dez, aez, cex, cey, cez, $fb81d64eb1da6605$var$cdet), $fb81d64eb1da6605$var$cdet), $fb81d64eb1da6605$var$cdet, $fb81d64eb1da6605$var$liftadapt($fb81d64eb1da6605$var$ab, $fb81d64eb1da6605$var$bc, $fb81d64eb1da6605$var$ac, cez, aez, -bez, dex, dey, dez, $fb81d64eb1da6605$var$ddet), $fb81d64eb1da6605$var$ddet, $fb81d64eb1da6605$var$cddet), $fb81d64eb1da6605$var$cddet, $fb81d64eb1da6605$var$fin);
    let det = (0, $jsXsn.estimate)(finlen, $fb81d64eb1da6605$var$fin);
    let errbound = $fb81d64eb1da6605$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $fb81d64eb1da6605$var$isperrboundC * permanent + (0, $jsXsn.resulterrbound) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $fb81d64eb1da6605$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $fb81d64eb1da6605$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * dab - dlift * abc + (alift * bcd - blift * cda);
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey);
    const bexaeyplus = Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey);
    const cexbeyplus = Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey);
    const dexceyplus = Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey);
    const aexdeyplus = Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey);
    const cexaeyplus = Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey);
    const dexbeyplus = Math.abs(dexbey);
    const permanent = ((cexdeyplus + dexceyplus) * bezplus + (dexbeyplus + bexdeyplus) * cezplus + (bexceyplus + cexbeyplus) * dezplus) * alift + ((dexaeyplus + aexdeyplus) * cezplus + (aexceyplus + cexaeyplus) * dezplus + (cexdeyplus + dexceyplus) * aezplus) * blift + ((aexbeyplus + bexaeyplus) * dezplus + (bexdeyplus + dexbeyplus) * aezplus + (dexaeyplus + aexdeyplus) * bezplus) * clift + ((bexceyplus + cexbeyplus) * aezplus + (cexaeyplus + aexceyplus) * bezplus + (aexbeyplus + bexaeyplus) * cezplus) * dlift;
    const errbound = $fb81d64eb1da6605$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$fb81d64eb1da6605$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $fb81d64eb1da6605$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}

});



parcelRegister("dbxyJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99965595b8838d6f$export$2e2bcd8739ae039; });
const $99965595b8838d6f$var$epsilon = 1e-6;
class $99965595b8838d6f$export$2e2bcd8739ae039 {
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $99965595b8838d6f$var$epsilon || Math.abs(this._y1 - y0) > $99965595b8838d6f$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
}

});

parcelRegister("iW4zH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc9131360bcff472$export$2e2bcd8739ae039; });
class $dc9131360bcff472$export$2e2bcd8739ae039 {
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
    constructor(){
        this._ = [];
    }
}

});

parcelRegister("kRv3x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f300d8fc2d9596b4$export$2e2bcd8739ae039; });

var $dbxyJ = parcelRequire("dbxyJ");

var $iW4zH = parcelRequire("iW4zH");
class $f300d8fc2d9596b4$export$2e2bcd8739ae039 {
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $dbxyJ.default) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $dbxyJ.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $dbxyJ.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $iW4zH.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
}

});



parcelRegister("UMLAc", function(module, exports) {

$parcel$export(module.exports, "dispatch", function () { return (parcelRequire("5Rufx")).default; });

var $5Rufx = parcelRequire("5Rufx");

});

parcelRegister("1PktO", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return (parcelRequire("cJwpP")).default; });
$parcel$export(module.exports, "dragDisable", function () { return (parcelRequire("bQ9aN")).default; });
$parcel$export(module.exports, "dragEnable", function () { return (parcelRequire("bQ9aN")).yesdrag; });

var $cJwpP = parcelRequire("cJwpP");

var $bQ9aN = parcelRequire("bQ9aN");

});
parcelRegister("cJwpP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9452d514a2817a38$export$2e2bcd8739ae039; });

var $5Rufx = parcelRequire("5Rufx");

var $pd5FT = parcelRequire("pd5FT");
var $3xlsS = parcelRequire("3xlsS");

var $bQ9aN = parcelRequire("bQ9aN");

var $fz6ZW = parcelRequire("fz6ZW");

var $aP6dA = parcelRequire("aP6dA");

var $lq8qa = parcelRequire("lq8qa");
// Ignore right-click, since that should open the context menu.
function $9452d514a2817a38$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $9452d514a2817a38$var$defaultContainer() {
    return this.parentNode;
}
function $9452d514a2817a38$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $9452d514a2817a38$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $9452d514a2817a38$export$2e2bcd8739ae039() {
    var filter = $9452d514a2817a38$var$defaultFilter, container = $9452d514a2817a38$var$defaultContainer, subject = $9452d514a2817a38$var$defaultSubject, touchable = $9452d514a2817a38$var$defaultTouchable, gestures = {}, listeners = (0, $5Rufx.default)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, $fz6ZW.nonpassive)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $3xlsS.default)(event.view).on("mousemove.drag", mousemoved, (0, $fz6ZW.nonpassivecapture)).on("mouseup.drag", mouseupped, (0, $fz6ZW.nonpassivecapture));
        (0, $bQ9aN.default)(event.view);
        (0, $fz6ZW.nopropagation)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $fz6ZW.default)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $3xlsS.default)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $bQ9aN.yesdrag)(event.view, mousemoving);
        (0, $fz6ZW.default)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $fz6ZW.nopropagation)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $fz6ZW.default)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $fz6ZW.nopropagation)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $pd5FT.default)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $lq8qa.default)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // falls through
                case "drag":
                    p = (0, $pd5FT.default)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $lq8qa.default)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $aP6dA.default)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $aP6dA.default)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $aP6dA.default)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $aP6dA.default)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}

});
parcelRegister("aP6dA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e137d9494afec2f$export$2e2bcd8739ae039; });
var $7e137d9494afec2f$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("lq8qa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04063c1cab716f4f$export$2e2bcd8739ae039; });
function $04063c1cab716f4f$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$04063c1cab716f4f$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

});



parcelRegister("50AvS", function(module, exports) {

$parcel$export(module.exports, "dsvFormat", function () { return (parcelRequire("jiL5B")).default; });
$parcel$export(module.exports, "csvParse", function () { return (parcelRequire("fd99W")).csvParse; });
$parcel$export(module.exports, "csvParseRows", function () { return (parcelRequire("fd99W")).csvParseRows; });
$parcel$export(module.exports, "csvFormat", function () { return (parcelRequire("fd99W")).csvFormat; });
$parcel$export(module.exports, "csvFormatBody", function () { return (parcelRequire("fd99W")).csvFormatBody; });
$parcel$export(module.exports, "csvFormatRows", function () { return (parcelRequire("fd99W")).csvFormatRows; });
$parcel$export(module.exports, "csvFormatRow", function () { return (parcelRequire("fd99W")).csvFormatRow; });
$parcel$export(module.exports, "csvFormatValue", function () { return (parcelRequire("fd99W")).csvFormatValue; });
$parcel$export(module.exports, "tsvParse", function () { return (parcelRequire("6A0af")).tsvParse; });
$parcel$export(module.exports, "tsvParseRows", function () { return (parcelRequire("6A0af")).tsvParseRows; });
$parcel$export(module.exports, "tsvFormat", function () { return (parcelRequire("6A0af")).tsvFormat; });
$parcel$export(module.exports, "tsvFormatBody", function () { return (parcelRequire("6A0af")).tsvFormatBody; });
$parcel$export(module.exports, "tsvFormatRows", function () { return (parcelRequire("6A0af")).tsvFormatRows; });
$parcel$export(module.exports, "tsvFormatRow", function () { return (parcelRequire("6A0af")).tsvFormatRow; });
$parcel$export(module.exports, "tsvFormatValue", function () { return (parcelRequire("6A0af")).tsvFormatValue; });
$parcel$export(module.exports, "autoType", function () { return (parcelRequire("cgElf")).default; });

var $jiL5B = parcelRequire("jiL5B");

var $fd99W = parcelRequire("fd99W");

var $6A0af = parcelRequire("6A0af");

var $cgElf = parcelRequire("cgElf");

});
parcelRegister("jiL5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0d439bc07f99a55$export$2e2bcd8739ae039; });
var $e0d439bc07f99a55$var$EOL = {}, $e0d439bc07f99a55$var$EOF = {}, $e0d439bc07f99a55$var$QUOTE = 34, $e0d439bc07f99a55$var$NEWLINE = 10, $e0d439bc07f99a55$var$RETURN = 13;
function $e0d439bc07f99a55$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + '] || ""';
    }).join(",") + "}");
}
function $e0d439bc07f99a55$var$customConverter(columns, f) {
    var object = $e0d439bc07f99a55$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $e0d439bc07f99a55$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $e0d439bc07f99a55$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $e0d439bc07f99a55$var$formatYear(year) {
    return year < 0 ? "-" + $e0d439bc07f99a55$var$pad(-year, 6) : year > 9999 ? "+" + $e0d439bc07f99a55$var$pad(year, 6) : $e0d439bc07f99a55$var$pad(year, 4);
}
function $e0d439bc07f99a55$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $e0d439bc07f99a55$var$formatYear(date.getUTCFullYear(), 4) + "-" + $e0d439bc07f99a55$var$pad(date.getUTCMonth() + 1, 2) + "-" + $e0d439bc07f99a55$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $e0d439bc07f99a55$var$pad(hours, 2) + ":" + $e0d439bc07f99a55$var$pad(minutes, 2) + ":" + $e0d439bc07f99a55$var$pad(seconds, 2) + "." + $e0d439bc07f99a55$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $e0d439bc07f99a55$var$pad(hours, 2) + ":" + $e0d439bc07f99a55$var$pad(minutes, 2) + ":" + $e0d439bc07f99a55$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $e0d439bc07f99a55$var$pad(hours, 2) + ":" + $e0d439bc07f99a55$var$pad(minutes, 2) + "Z" : "");
}
function $e0d439bc07f99a55$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $e0d439bc07f99a55$var$customConverter(row, f) : $e0d439bc07f99a55$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $e0d439bc07f99a55$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $e0d439bc07f99a55$var$RETURN) --N;
        function token() {
            if (eof) return $e0d439bc07f99a55$var$EOF;
            if (eol) return eol = false, $e0d439bc07f99a55$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $e0d439bc07f99a55$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $e0d439bc07f99a55$var$QUOTE || text.charCodeAt(++I) === $e0d439bc07f99a55$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $e0d439bc07f99a55$var$NEWLINE) eol = true;
                else if (c === $e0d439bc07f99a55$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $e0d439bc07f99a55$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, '"');
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $e0d439bc07f99a55$var$NEWLINE) eol = true;
                else if (c === $e0d439bc07f99a55$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $e0d439bc07f99a55$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $e0d439bc07f99a55$var$EOF){
            var row = [];
            while(t !== $e0d439bc07f99a55$var$EOL && t !== $e0d439bc07f99a55$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $e0d439bc07f99a55$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $e0d439bc07f99a55$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $e0d439bc07f99a55$var$formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}

});

parcelRegister("fd99W", function(module, exports) {

$parcel$export(module.exports, "csvParse", function () { return $b12f2cbe7ce3316c$export$289d25497b0f4c16; });
$parcel$export(module.exports, "csvParseRows", function () { return $b12f2cbe7ce3316c$export$c82550ca942d869; });
$parcel$export(module.exports, "csvFormat", function () { return $b12f2cbe7ce3316c$export$afe767551074aa08; });
$parcel$export(module.exports, "csvFormatBody", function () { return $b12f2cbe7ce3316c$export$b46fa59a5e3bc8a2; });
$parcel$export(module.exports, "csvFormatRows", function () { return $b12f2cbe7ce3316c$export$3f42a65843fbd1d9; });
$parcel$export(module.exports, "csvFormatRow", function () { return $b12f2cbe7ce3316c$export$c30212b87b2d080f; });
$parcel$export(module.exports, "csvFormatValue", function () { return $b12f2cbe7ce3316c$export$2771de09a60fc648; });

var $jiL5B = parcelRequire("jiL5B");
var $b12f2cbe7ce3316c$var$csv = (0, $jiL5B.default)(",");
var $b12f2cbe7ce3316c$export$289d25497b0f4c16 = $b12f2cbe7ce3316c$var$csv.parse;
var $b12f2cbe7ce3316c$export$c82550ca942d869 = $b12f2cbe7ce3316c$var$csv.parseRows;
var $b12f2cbe7ce3316c$export$afe767551074aa08 = $b12f2cbe7ce3316c$var$csv.format;
var $b12f2cbe7ce3316c$export$b46fa59a5e3bc8a2 = $b12f2cbe7ce3316c$var$csv.formatBody;
var $b12f2cbe7ce3316c$export$3f42a65843fbd1d9 = $b12f2cbe7ce3316c$var$csv.formatRows;
var $b12f2cbe7ce3316c$export$c30212b87b2d080f = $b12f2cbe7ce3316c$var$csv.formatRow;
var $b12f2cbe7ce3316c$export$2771de09a60fc648 = $b12f2cbe7ce3316c$var$csv.formatValue;

});

parcelRegister("6A0af", function(module, exports) {

$parcel$export(module.exports, "tsvParse", function () { return $4ca63b7ab0c4ccca$export$f913251db2f734ee; });
$parcel$export(module.exports, "tsvParseRows", function () { return $4ca63b7ab0c4ccca$export$8de3b5abc40a067f; });
$parcel$export(module.exports, "tsvFormat", function () { return $4ca63b7ab0c4ccca$export$77e754c4f8504293; });
$parcel$export(module.exports, "tsvFormatBody", function () { return $4ca63b7ab0c4ccca$export$9d44987d460c9cb3; });
$parcel$export(module.exports, "tsvFormatRows", function () { return $4ca63b7ab0c4ccca$export$ae461973f6adc981; });
$parcel$export(module.exports, "tsvFormatRow", function () { return $4ca63b7ab0c4ccca$export$5d61cf35a4a738d2; });
$parcel$export(module.exports, "tsvFormatValue", function () { return $4ca63b7ab0c4ccca$export$4280e6a416cd92a3; });

var $jiL5B = parcelRequire("jiL5B");
var $4ca63b7ab0c4ccca$var$tsv = (0, $jiL5B.default)("	");
var $4ca63b7ab0c4ccca$export$f913251db2f734ee = $4ca63b7ab0c4ccca$var$tsv.parse;
var $4ca63b7ab0c4ccca$export$8de3b5abc40a067f = $4ca63b7ab0c4ccca$var$tsv.parseRows;
var $4ca63b7ab0c4ccca$export$77e754c4f8504293 = $4ca63b7ab0c4ccca$var$tsv.format;
var $4ca63b7ab0c4ccca$export$9d44987d460c9cb3 = $4ca63b7ab0c4ccca$var$tsv.formatBody;
var $4ca63b7ab0c4ccca$export$ae461973f6adc981 = $4ca63b7ab0c4ccca$var$tsv.formatRows;
var $4ca63b7ab0c4ccca$export$5d61cf35a4a738d2 = $4ca63b7ab0c4ccca$var$tsv.formatRow;
var $4ca63b7ab0c4ccca$export$4280e6a416cd92a3 = $4ca63b7ab0c4ccca$var$tsv.formatValue;

});

parcelRegister("cgElf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee645b43a2266ba$export$2e2bcd8739ae039; });
function $8ee645b43a2266ba$export$2e2bcd8739ae039(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if ($8ee645b43a2266ba$var$fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
const $8ee645b43a2266ba$var$fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

});


parcelRegister("2Wj9t", function(module, exports) {

$parcel$export(module.exports, "easeLinear", function () { return (parcelRequire("fl2a9")).linear; });
$parcel$export(module.exports, "easeQuad", function () { return (parcelRequire("avve3")).quadInOut; });
$parcel$export(module.exports, "easeQuadIn", function () { return (parcelRequire("avve3")).quadIn; });
$parcel$export(module.exports, "easeQuadOut", function () { return (parcelRequire("avve3")).quadOut; });
$parcel$export(module.exports, "easeQuadInOut", function () { return (parcelRequire("avve3")).quadInOut; });
$parcel$export(module.exports, "easeCubic", function () { return (parcelRequire("btfUt")).cubicInOut; });
$parcel$export(module.exports, "easeCubicIn", function () { return (parcelRequire("btfUt")).cubicIn; });
$parcel$export(module.exports, "easeCubicOut", function () { return (parcelRequire("btfUt")).cubicOut; });
$parcel$export(module.exports, "easeCubicInOut", function () { return (parcelRequire("btfUt")).cubicInOut; });
$parcel$export(module.exports, "easePoly", function () { return (parcelRequire("41k2j")).polyInOut; });
$parcel$export(module.exports, "easePolyIn", function () { return (parcelRequire("41k2j")).polyIn; });
$parcel$export(module.exports, "easePolyOut", function () { return (parcelRequire("41k2j")).polyOut; });
$parcel$export(module.exports, "easePolyInOut", function () { return (parcelRequire("41k2j")).polyInOut; });
$parcel$export(module.exports, "easeSin", function () { return (parcelRequire("69dfT")).sinInOut; });
$parcel$export(module.exports, "easeSinIn", function () { return (parcelRequire("69dfT")).sinIn; });
$parcel$export(module.exports, "easeSinOut", function () { return (parcelRequire("69dfT")).sinOut; });
$parcel$export(module.exports, "easeSinInOut", function () { return (parcelRequire("69dfT")).sinInOut; });
$parcel$export(module.exports, "easeExp", function () { return (parcelRequire("2ocdj")).expInOut; });
$parcel$export(module.exports, "easeExpIn", function () { return (parcelRequire("2ocdj")).expIn; });
$parcel$export(module.exports, "easeExpOut", function () { return (parcelRequire("2ocdj")).expOut; });
$parcel$export(module.exports, "easeExpInOut", function () { return (parcelRequire("2ocdj")).expInOut; });
$parcel$export(module.exports, "easeCircle", function () { return (parcelRequire("gVv2Z")).circleInOut; });
$parcel$export(module.exports, "easeCircleIn", function () { return (parcelRequire("gVv2Z")).circleIn; });
$parcel$export(module.exports, "easeCircleOut", function () { return (parcelRequire("gVv2Z")).circleOut; });
$parcel$export(module.exports, "easeCircleInOut", function () { return (parcelRequire("gVv2Z")).circleInOut; });
$parcel$export(module.exports, "easeBounce", function () { return (parcelRequire("3xd38")).bounceOut; });
$parcel$export(module.exports, "easeBounceIn", function () { return (parcelRequire("3xd38")).bounceIn; });
$parcel$export(module.exports, "easeBounceOut", function () { return (parcelRequire("3xd38")).bounceOut; });
$parcel$export(module.exports, "easeBounceInOut", function () { return (parcelRequire("3xd38")).bounceInOut; });
$parcel$export(module.exports, "easeBack", function () { return (parcelRequire("17TG3")).backInOut; });
$parcel$export(module.exports, "easeBackIn", function () { return (parcelRequire("17TG3")).backIn; });
$parcel$export(module.exports, "easeBackOut", function () { return (parcelRequire("17TG3")).backOut; });
$parcel$export(module.exports, "easeBackInOut", function () { return (parcelRequire("17TG3")).backInOut; });
$parcel$export(module.exports, "easeElastic", function () { return (parcelRequire("bngKk")).elasticOut; });
$parcel$export(module.exports, "easeElasticIn", function () { return (parcelRequire("bngKk")).elasticIn; });
$parcel$export(module.exports, "easeElasticOut", function () { return (parcelRequire("bngKk")).elasticOut; });
$parcel$export(module.exports, "easeElasticInOut", function () { return (parcelRequire("bngKk")).elasticInOut; });

var $fl2a9 = parcelRequire("fl2a9");

var $avve3 = parcelRequire("avve3");

var $btfUt = parcelRequire("btfUt");

var $41k2j = parcelRequire("41k2j");

var $69dfT = parcelRequire("69dfT");

var $2ocdj = parcelRequire("2ocdj");

var $gVv2Z = parcelRequire("gVv2Z");

var $3xd38 = parcelRequire("3xd38");

var $17TG3 = parcelRequire("17TG3");

var $bngKk = parcelRequire("bngKk");

});
parcelRegister("fl2a9", function(module, exports) {

$parcel$export(module.exports, "linear", function () { return $b2aa7ea61cc40dff$export$45db2fc2f15997e7; });
const $b2aa7ea61cc40dff$export$45db2fc2f15997e7 = (t)=>+t;

});

parcelRegister("avve3", function(module, exports) {

$parcel$export(module.exports, "quadIn", function () { return $7a650561a32027cd$export$5118fc7a1e64441b; });
$parcel$export(module.exports, "quadOut", function () { return $7a650561a32027cd$export$5be5f5e804d0b60c; });
$parcel$export(module.exports, "quadInOut", function () { return $7a650561a32027cd$export$d6ded66933892ed3; });
function $7a650561a32027cd$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $7a650561a32027cd$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $7a650561a32027cd$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

});

parcelRegister("41k2j", function(module, exports) {

$parcel$export(module.exports, "polyIn", function () { return $2ed6cc38619db381$export$aa0b5c3ce2df9d7d; });
$parcel$export(module.exports, "polyOut", function () { return $2ed6cc38619db381$export$e3d987a417dc6640; });
$parcel$export(module.exports, "polyInOut", function () { return $2ed6cc38619db381$export$ae94c6a40058b429; });
var $2ed6cc38619db381$var$exponent = 3;
var $2ed6cc38619db381$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($2ed6cc38619db381$var$exponent);
var $2ed6cc38619db381$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($2ed6cc38619db381$var$exponent);
var $2ed6cc38619db381$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($2ed6cc38619db381$var$exponent);

});

parcelRegister("69dfT", function(module, exports) {

$parcel$export(module.exports, "sinIn", function () { return $0127b51f3ae16c12$export$a83a280f8d31ba8d; });
$parcel$export(module.exports, "sinOut", function () { return $0127b51f3ae16c12$export$62ec6410ca53f2a7; });
$parcel$export(module.exports, "sinInOut", function () { return $0127b51f3ae16c12$export$ff58b604d3ba15ba; });
var $0127b51f3ae16c12$var$pi = Math.PI, $0127b51f3ae16c12$var$halfPi = $0127b51f3ae16c12$var$pi / 2;
function $0127b51f3ae16c12$export$a83a280f8d31ba8d(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * $0127b51f3ae16c12$var$halfPi);
}
function $0127b51f3ae16c12$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $0127b51f3ae16c12$var$halfPi);
}
function $0127b51f3ae16c12$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($0127b51f3ae16c12$var$pi * t)) / 2;
}

});

parcelRegister("2ocdj", function(module, exports) {

$parcel$export(module.exports, "expIn", function () { return $1bd74c0f8b143415$export$fc3e95f15e1ef38e; });
$parcel$export(module.exports, "expOut", function () { return $1bd74c0f8b143415$export$f3c9b2f85fbcf0ab; });
$parcel$export(module.exports, "expInOut", function () { return $1bd74c0f8b143415$export$ae4d4e77fab188ff; });

var $9oeJX = parcelRequire("9oeJX");
function $1bd74c0f8b143415$export$fc3e95f15e1ef38e(t) {
    return (0, $9oeJX.tpmt)(1 - +t);
}
function $1bd74c0f8b143415$export$f3c9b2f85fbcf0ab(t) {
    return 1 - (0, $9oeJX.tpmt)(t);
}
function $1bd74c0f8b143415$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? (0, $9oeJX.tpmt)(1 - t) : 2 - (0, $9oeJX.tpmt)(t - 1)) / 2;
}

});
parcelRegister("9oeJX", function(module, exports) {

$parcel$export(module.exports, "tpmt", function () { return $6d61ca0b1809fa53$export$be3f0f7224794b88; });
// tpmt is two power minus ten times t scaled to [0,1]
function $6d61ca0b1809fa53$export$be3f0f7224794b88(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

});


parcelRegister("gVv2Z", function(module, exports) {

$parcel$export(module.exports, "circleIn", function () { return $c52a0d8f383ef116$export$9f82a71b0377c018; });
$parcel$export(module.exports, "circleOut", function () { return $c52a0d8f383ef116$export$27989e665abef2c8; });
$parcel$export(module.exports, "circleInOut", function () { return $c52a0d8f383ef116$export$2d757ff9ad09038f; });
function $c52a0d8f383ef116$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $c52a0d8f383ef116$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $c52a0d8f383ef116$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

});

parcelRegister("3xd38", function(module, exports) {

$parcel$export(module.exports, "bounceIn", function () { return $292e9388e2c18c89$export$fccebd7948554554; });
$parcel$export(module.exports, "bounceOut", function () { return $292e9388e2c18c89$export$cccc9e04465dce11; });
$parcel$export(module.exports, "bounceInOut", function () { return $292e9388e2c18c89$export$41ad9e9849a703ce; });
var $292e9388e2c18c89$var$b1 = 4 / 11, $292e9388e2c18c89$var$b2 = 6 / 11, $292e9388e2c18c89$var$b3 = 8 / 11, $292e9388e2c18c89$var$b4 = 3 / 4, $292e9388e2c18c89$var$b5 = 9 / 11, $292e9388e2c18c89$var$b6 = 10 / 11, $292e9388e2c18c89$var$b7 = 15 / 16, $292e9388e2c18c89$var$b8 = 21 / 22, $292e9388e2c18c89$var$b9 = 63 / 64, $292e9388e2c18c89$var$b0 = 1 / $292e9388e2c18c89$var$b1 / $292e9388e2c18c89$var$b1;
function $292e9388e2c18c89$export$fccebd7948554554(t) {
    return 1 - $292e9388e2c18c89$export$cccc9e04465dce11(1 - t);
}
function $292e9388e2c18c89$export$cccc9e04465dce11(t) {
    return (t = +t) < $292e9388e2c18c89$var$b1 ? $292e9388e2c18c89$var$b0 * t * t : t < $292e9388e2c18c89$var$b3 ? $292e9388e2c18c89$var$b0 * (t -= $292e9388e2c18c89$var$b2) * t + $292e9388e2c18c89$var$b4 : t < $292e9388e2c18c89$var$b6 ? $292e9388e2c18c89$var$b0 * (t -= $292e9388e2c18c89$var$b5) * t + $292e9388e2c18c89$var$b7 : $292e9388e2c18c89$var$b0 * (t -= $292e9388e2c18c89$var$b8) * t + $292e9388e2c18c89$var$b9;
}
function $292e9388e2c18c89$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $292e9388e2c18c89$export$cccc9e04465dce11(1 - t) : $292e9388e2c18c89$export$cccc9e04465dce11(t - 1) + 1) / 2;
}

});

parcelRegister("17TG3", function(module, exports) {

$parcel$export(module.exports, "backIn", function () { return $0d21a23fe4c15b18$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backOut", function () { return $0d21a23fe4c15b18$export$77edfce482316a60; });
$parcel$export(module.exports, "backInOut", function () { return $0d21a23fe4c15b18$export$ddc5fd596f6c71b2; });
var $0d21a23fe4c15b18$var$overshoot = 1.70158;
var $0d21a23fe4c15b18$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}($0d21a23fe4c15b18$var$overshoot);
var $0d21a23fe4c15b18$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($0d21a23fe4c15b18$var$overshoot);
var $0d21a23fe4c15b18$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($0d21a23fe4c15b18$var$overshoot);

});

parcelRegister("bngKk", function(module, exports) {

$parcel$export(module.exports, "elasticIn", function () { return $847ed52a6d0ac907$export$41f42134872a5fa0; });
$parcel$export(module.exports, "elasticOut", function () { return $847ed52a6d0ac907$export$ed1782b99e69bbc8; });
$parcel$export(module.exports, "elasticInOut", function () { return $847ed52a6d0ac907$export$309de4f35f218bfd; });

var $9oeJX = parcelRequire("9oeJX");
var $847ed52a6d0ac907$var$tau = 2 * Math.PI, $847ed52a6d0ac907$var$amplitude = 1, $847ed52a6d0ac907$var$period = 0.3;
var $847ed52a6d0ac907$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $847ed52a6d0ac907$var$tau);
    function elasticIn(t) {
        return a * (0, $9oeJX.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $847ed52a6d0ac907$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($847ed52a6d0ac907$var$amplitude, $847ed52a6d0ac907$var$period);
var $847ed52a6d0ac907$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $847ed52a6d0ac907$var$tau);
    function elasticOut(t) {
        return 1 - a * (0, $9oeJX.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $847ed52a6d0ac907$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($847ed52a6d0ac907$var$amplitude, $847ed52a6d0ac907$var$period);
var $847ed52a6d0ac907$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $847ed52a6d0ac907$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, $9oeJX.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, $9oeJX.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $847ed52a6d0ac907$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($847ed52a6d0ac907$var$amplitude, $847ed52a6d0ac907$var$period);

});


parcelRegister("81W8M", function(module, exports) {

$parcel$export(module.exports, "blob", function () { return (parcelRequire("eRben")).default; });
$parcel$export(module.exports, "buffer", function () { return (parcelRequire("a81xd")).default; });
$parcel$export(module.exports, "dsv", function () { return (parcelRequire("j4NTy")).default; });
$parcel$export(module.exports, "csv", function () { return (parcelRequire("j4NTy")).csv; });
$parcel$export(module.exports, "tsv", function () { return (parcelRequire("j4NTy")).tsv; });
$parcel$export(module.exports, "image", function () { return (parcelRequire("1a1Ek")).default; });
$parcel$export(module.exports, "json", function () { return (parcelRequire("h3MBJ")).default; });
$parcel$export(module.exports, "text", function () { return (parcelRequire("7Q7Y8")).default; });
$parcel$export(module.exports, "xml", function () { return (parcelRequire("iPUNz")).default; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("iPUNz")).html; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("iPUNz")).svg; });

var $eRben = parcelRequire("eRben");

var $a81xd = parcelRequire("a81xd");

var $j4NTy = parcelRequire("j4NTy");

var $1a1Ek = parcelRequire("1a1Ek");

var $h3MBJ = parcelRequire("h3MBJ");

var $7Q7Y8 = parcelRequire("7Q7Y8");

var $iPUNz = parcelRequire("iPUNz");

});
parcelRegister("eRben", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad0eba28abd0fca2$export$2e2bcd8739ae039; });
function $ad0eba28abd0fca2$var$responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}
function $ad0eba28abd0fca2$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($ad0eba28abd0fca2$var$responseBlob);
}

});

parcelRegister("a81xd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75fbd77bc97a52f6$export$2e2bcd8739ae039; });
function $75fbd77bc97a52f6$var$responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}
function $75fbd77bc97a52f6$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($75fbd77bc97a52f6$var$responseArrayBuffer);
}

});

parcelRegister("j4NTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de35182eaee16237$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "csv", function () { return $de35182eaee16237$export$901ba78aa04f49da; });
$parcel$export(module.exports, "tsv", function () { return $de35182eaee16237$export$580b2de76423ff18; });

var $dsk8i = parcelRequire("dsk8i");
var $gW1qs = parcelRequire("gW1qs");
var $fVUSD = parcelRequire("fVUSD");

var $7Q7Y8 = parcelRequire("7Q7Y8");
function $de35182eaee16237$var$dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, $7Q7Y8.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function $de35182eaee16237$export$2e2bcd8739ae039(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, $gW1qs.default)(delimiter);
    return (0, $7Q7Y8.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var $de35182eaee16237$export$901ba78aa04f49da = $de35182eaee16237$var$dsvParse((0, $dsk8i.csvParse));
var $de35182eaee16237$export$580b2de76423ff18 = $de35182eaee16237$var$dsvParse((0, $fVUSD.tsvParse));

});
parcelRegister("dsk8i", function(module, exports) {

$parcel$export(module.exports, "csvParse", function () { return $9cbd81d59c1e21d2$export$289d25497b0f4c16; });

var $gW1qs = parcelRequire("gW1qs");
var $9cbd81d59c1e21d2$var$csv = (0, $gW1qs.default)(",");
var $9cbd81d59c1e21d2$export$289d25497b0f4c16 = $9cbd81d59c1e21d2$var$csv.parse;
var $9cbd81d59c1e21d2$export$c82550ca942d869 = $9cbd81d59c1e21d2$var$csv.parseRows;
var $9cbd81d59c1e21d2$export$afe767551074aa08 = $9cbd81d59c1e21d2$var$csv.format;
var $9cbd81d59c1e21d2$export$b46fa59a5e3bc8a2 = $9cbd81d59c1e21d2$var$csv.formatBody;
var $9cbd81d59c1e21d2$export$3f42a65843fbd1d9 = $9cbd81d59c1e21d2$var$csv.formatRows;
var $9cbd81d59c1e21d2$export$c30212b87b2d080f = $9cbd81d59c1e21d2$var$csv.formatRow;
var $9cbd81d59c1e21d2$export$2771de09a60fc648 = $9cbd81d59c1e21d2$var$csv.formatValue;

});
parcelRegister("gW1qs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5432b3fb7d77cc0$export$2e2bcd8739ae039; });
var $c5432b3fb7d77cc0$var$EOL = {}, $c5432b3fb7d77cc0$var$EOF = {}, $c5432b3fb7d77cc0$var$QUOTE = 34, $c5432b3fb7d77cc0$var$NEWLINE = 10, $c5432b3fb7d77cc0$var$RETURN = 13;
function $c5432b3fb7d77cc0$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + '] || ""';
    }).join(",") + "}");
}
function $c5432b3fb7d77cc0$var$customConverter(columns, f) {
    var object = $c5432b3fb7d77cc0$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $c5432b3fb7d77cc0$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $c5432b3fb7d77cc0$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $c5432b3fb7d77cc0$var$formatYear(year) {
    return year < 0 ? "-" + $c5432b3fb7d77cc0$var$pad(-year, 6) : year > 9999 ? "+" + $c5432b3fb7d77cc0$var$pad(year, 6) : $c5432b3fb7d77cc0$var$pad(year, 4);
}
function $c5432b3fb7d77cc0$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $c5432b3fb7d77cc0$var$formatYear(date.getUTCFullYear(), 4) + "-" + $c5432b3fb7d77cc0$var$pad(date.getUTCMonth() + 1, 2) + "-" + $c5432b3fb7d77cc0$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $c5432b3fb7d77cc0$var$pad(hours, 2) + ":" + $c5432b3fb7d77cc0$var$pad(minutes, 2) + ":" + $c5432b3fb7d77cc0$var$pad(seconds, 2) + "." + $c5432b3fb7d77cc0$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $c5432b3fb7d77cc0$var$pad(hours, 2) + ":" + $c5432b3fb7d77cc0$var$pad(minutes, 2) + ":" + $c5432b3fb7d77cc0$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $c5432b3fb7d77cc0$var$pad(hours, 2) + ":" + $c5432b3fb7d77cc0$var$pad(minutes, 2) + "Z" : "");
}
function $c5432b3fb7d77cc0$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $c5432b3fb7d77cc0$var$customConverter(row, f) : $c5432b3fb7d77cc0$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $c5432b3fb7d77cc0$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $c5432b3fb7d77cc0$var$RETURN) --N;
        function token() {
            if (eof) return $c5432b3fb7d77cc0$var$EOF;
            if (eol) return eol = false, $c5432b3fb7d77cc0$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $c5432b3fb7d77cc0$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $c5432b3fb7d77cc0$var$QUOTE || text.charCodeAt(++I) === $c5432b3fb7d77cc0$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $c5432b3fb7d77cc0$var$NEWLINE) eol = true;
                else if (c === $c5432b3fb7d77cc0$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $c5432b3fb7d77cc0$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, '"');
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $c5432b3fb7d77cc0$var$NEWLINE) eol = true;
                else if (c === $c5432b3fb7d77cc0$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $c5432b3fb7d77cc0$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $c5432b3fb7d77cc0$var$EOF){
            var row = [];
            while(t !== $c5432b3fb7d77cc0$var$EOL && t !== $c5432b3fb7d77cc0$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $c5432b3fb7d77cc0$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $c5432b3fb7d77cc0$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $c5432b3fb7d77cc0$var$formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}

});


parcelRegister("fVUSD", function(module, exports) {

$parcel$export(module.exports, "tsvParse", function () { return $b9984d215fcbfad8$export$f913251db2f734ee; });

var $gW1qs = parcelRequire("gW1qs");
var $b9984d215fcbfad8$var$tsv = (0, $gW1qs.default)("	");
var $b9984d215fcbfad8$export$f913251db2f734ee = $b9984d215fcbfad8$var$tsv.parse;
var $b9984d215fcbfad8$export$8de3b5abc40a067f = $b9984d215fcbfad8$var$tsv.parseRows;
var $b9984d215fcbfad8$export$77e754c4f8504293 = $b9984d215fcbfad8$var$tsv.format;
var $b9984d215fcbfad8$export$9d44987d460c9cb3 = $b9984d215fcbfad8$var$tsv.formatBody;
var $b9984d215fcbfad8$export$ae461973f6adc981 = $b9984d215fcbfad8$var$tsv.formatRows;
var $b9984d215fcbfad8$export$5d61cf35a4a738d2 = $b9984d215fcbfad8$var$tsv.formatRow;
var $b9984d215fcbfad8$export$4280e6a416cd92a3 = $b9984d215fcbfad8$var$tsv.formatValue;

});

parcelRegister("7Q7Y8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b539233aa790c5a$export$2e2bcd8739ae039; });
function $5b539233aa790c5a$var$responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}
function $5b539233aa790c5a$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($5b539233aa790c5a$var$responseText);
}

});


parcelRegister("1a1Ek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d88012d5a9bca8b$export$2e2bcd8739ae039; });
function $0d88012d5a9bca8b$export$2e2bcd8739ae039(input, init) {
    return new Promise(function(resolve, reject) {
        var image = new Image;
        for(var key in init)image[key] = init[key];
        image.onerror = reject;
        image.onload = function() {
            resolve(image);
        };
        image.src = input;
    });
}

});

parcelRegister("h3MBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6b86be8351df49c$export$2e2bcd8739ae039; });
function $c6b86be8351df49c$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $c6b86be8351df49c$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($c6b86be8351df49c$var$responseJson);
}

});

parcelRegister("iPUNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db690c6dc4447efd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "html", function () { return $db690c6dc4447efd$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $db690c6dc4447efd$export$7ed1367e7fa1ad68; });

var $7Q7Y8 = parcelRequire("7Q7Y8");
function $db690c6dc4447efd$var$parser(type) {
    return (input, init)=>(0, $7Q7Y8.default)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
var $db690c6dc4447efd$export$2e2bcd8739ae039 = $db690c6dc4447efd$var$parser("application/xml");
var $db690c6dc4447efd$export$c0bb0b647f701bb5 = $db690c6dc4447efd$var$parser("text/html");
var $db690c6dc4447efd$export$7ed1367e7fa1ad68 = $db690c6dc4447efd$var$parser("image/svg+xml");

});


parcelRegister("gY9gz", function(module, exports) {

$parcel$export(module.exports, "forceCenter", function () { return (parcelRequire("6luKm")).default; });
$parcel$export(module.exports, "forceCollide", function () { return (parcelRequire("glgbc")).default; });
$parcel$export(module.exports, "forceLink", function () { return (parcelRequire("lXbHc")).default; });
$parcel$export(module.exports, "forceManyBody", function () { return (parcelRequire("1wOPu")).default; });
$parcel$export(module.exports, "forceRadial", function () { return (parcelRequire("eZmby")).default; });
$parcel$export(module.exports, "forceSimulation", function () { return (parcelRequire("1Vq1e")).default; });
$parcel$export(module.exports, "forceX", function () { return (parcelRequire("heQ2P")).default; });
$parcel$export(module.exports, "forceY", function () { return (parcelRequire("8UN2D")).default; });

var $6luKm = parcelRequire("6luKm");

var $glgbc = parcelRequire("glgbc");

var $lXbHc = parcelRequire("lXbHc");

var $1wOPu = parcelRequire("1wOPu");

var $eZmby = parcelRequire("eZmby");

var $1Vq1e = parcelRequire("1Vq1e");

var $heQ2P = parcelRequire("heQ2P");

var $8UN2D = parcelRequire("8UN2D");

});
parcelRegister("6luKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49ec8de6bcd1b74e$export$2e2bcd8739ae039; });
function $49ec8de6bcd1b74e$export$2e2bcd8739ae039(x, y) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}

});

parcelRegister("glgbc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be5b28741c902de4$export$2e2bcd8739ae039; });

var $22HY7 = parcelRequire("22HY7");

var $aZHJY = parcelRequire("aZHJY");

var $l3FOm = parcelRequire("l3FOm");
function $be5b28741c902de4$var$x(d) {
    return d.x + d.vx;
}
function $be5b28741c902de4$var$y(d) {
    return d.y + d.vy;
}
function $be5b28741c902de4$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $aZHJY.default)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $22HY7.default)(nodes, $be5b28741c902de4$var$x, $be5b28741c902de4$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $l3FOm.default)(random), l += x * x;
                        if (y === 0) y = (0, $l3FOm.default)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : radius;
    };
    return force;
}

});
parcelRegister("22HY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17cddff5837d0987$export$2e2bcd8739ae039; });

var $c7LSH = parcelRequire("c7LSH");

var $94GOB = parcelRequire("94GOB");

var $ii0W2 = parcelRequire("ii0W2");

var $b79MO = parcelRequire("b79MO");

var $fYSZD = parcelRequire("fYSZD");

var $g5PAE = parcelRequire("g5PAE");

var $lnxMg = parcelRequire("lnxMg");

var $2WBOh = parcelRequire("2WBOh");

var $dI2Yb = parcelRequire("dI2Yb");

var $9Cv3b = parcelRequire("9Cv3b");

var $dQjRY = parcelRequire("dQjRY");

var $e50Bf = parcelRequire("e50Bf");
function $17cddff5837d0987$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $17cddff5837d0987$var$Quadtree(x == null ? (0, $dQjRY.defaultX) : x, y == null ? (0, $e50Bf.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $17cddff5837d0987$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $17cddff5837d0987$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $17cddff5837d0987$var$treeProto = $17cddff5837d0987$export$2e2bcd8739ae039.prototype = $17cddff5837d0987$var$Quadtree.prototype;
$17cddff5837d0987$var$treeProto.copy = function() {
    var copy = new $17cddff5837d0987$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $17cddff5837d0987$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $17cddff5837d0987$var$leaf_copy(child);
        }
    }
    return copy;
};
$17cddff5837d0987$var$treeProto.add = (0, $c7LSH.default);
$17cddff5837d0987$var$treeProto.addAll = (0, $c7LSH.addAll);
$17cddff5837d0987$var$treeProto.cover = (0, $94GOB.default);
$17cddff5837d0987$var$treeProto.data = (0, $ii0W2.default);
$17cddff5837d0987$var$treeProto.extent = (0, $b79MO.default);
$17cddff5837d0987$var$treeProto.find = (0, $fYSZD.default);
$17cddff5837d0987$var$treeProto.remove = (0, $g5PAE.default);
$17cddff5837d0987$var$treeProto.removeAll = (0, $g5PAE.removeAll);
$17cddff5837d0987$var$treeProto.root = (0, $lnxMg.default);
$17cddff5837d0987$var$treeProto.size = (0, $2WBOh.default);
$17cddff5837d0987$var$treeProto.visit = (0, $dI2Yb.default);
$17cddff5837d0987$var$treeProto.visitAfter = (0, $9Cv3b.default);
$17cddff5837d0987$var$treeProto.x = (0, $dQjRY.default);
$17cddff5837d0987$var$treeProto.y = (0, $e50Bf.default);

});
parcelRegister("c7LSH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d3b47b77c964c55$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "addAll", function () { return $8d3b47b77c964c55$export$32ed0561867ec8a1; });
function $8d3b47b77c964c55$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $8d3b47b77c964c55$var$add(this.cover(x, y), x, y, d);
}
function $8d3b47b77c964c55$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $8d3b47b77c964c55$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$8d3b47b77c964c55$var$add(this, xz[i], yz[i], data[i]);
    return this;
}

});

parcelRegister("94GOB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69b5b2f705276c58$export$2e2bcd8739ae039; });
function $69b5b2f705276c58$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}

});

parcelRegister("ii0W2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d50aa22044f75fe1$export$2e2bcd8739ae039; });
function $d50aa22044f75fe1$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("b79MO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8177f07fc1d1cd4f$export$2e2bcd8739ae039; });
function $8177f07fc1d1cd4f$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}

});

parcelRegister("fYSZD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba271e1ea1762391$export$2e2bcd8739ae039; });

var $irUiL = parcelRequire("irUiL");
function $ba271e1ea1762391$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $irUiL.default)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $irUiL.default)(node[3], xm, ym, x2, y2), new (0, $irUiL.default)(node[2], x1, ym, xm, y2), new (0, $irUiL.default)(node[1], xm, y1, x2, ym), new (0, $irUiL.default)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("irUiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6e66bf43293be8b$export$2e2bcd8739ae039; });
function $d6e66bf43293be8b$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}

});


parcelRegister("g5PAE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb7521b40ee2c409$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "removeAll", function () { return $bb7521b40ee2c409$export$1cfc7aad5cb1833b; });
function $bb7521b40ee2c409$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $bb7521b40ee2c409$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("lnxMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f905f273fff33e10$export$2e2bcd8739ae039; });
function $f905f273fff33e10$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("2WBOh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $224e53d5847151d5$export$2e2bcd8739ae039; });
function $224e53d5847151d5$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("dI2Yb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fb1b02a714b2e11$export$2e2bcd8739ae039; });

var $irUiL = parcelRequire("irUiL");
function $9fb1b02a714b2e11$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $irUiL.default)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $irUiL.default)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $irUiL.default)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $irUiL.default)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $irUiL.default)(child, x0, y0, xm, ym));
    }
    return this;
}

});

parcelRegister("9Cv3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $700fbf9f8b44e63e$export$2e2bcd8739ae039; });

var $irUiL = parcelRequire("irUiL");
function $700fbf9f8b44e63e$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $irUiL.default)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $irUiL.default)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $irUiL.default)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $irUiL.default)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $irUiL.default)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}

});

parcelRegister("dQjRY", function(module, exports) {

$parcel$export(module.exports, "defaultX", function () { return $a13f8b60f6278086$export$e6fafc98131d2a44; });
$parcel$export(module.exports, "default", function () { return $a13f8b60f6278086$export$2e2bcd8739ae039; });
function $a13f8b60f6278086$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $a13f8b60f6278086$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("e50Bf", function(module, exports) {

$parcel$export(module.exports, "defaultY", function () { return $a401ff6cdb819d4f$export$6f0a21aeb844a64c; });
$parcel$export(module.exports, "default", function () { return $a401ff6cdb819d4f$export$2e2bcd8739ae039; });
function $a401ff6cdb819d4f$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $a401ff6cdb819d4f$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});


parcelRegister("aZHJY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $801187dcda15c398$export$2e2bcd8739ae039; });
function $801187dcda15c398$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("l3FOm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f54a4fa4376f5371$export$2e2bcd8739ae039; });
function $f54a4fa4376f5371$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}

});


parcelRegister("lXbHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffb82e32dc42c191$export$2e2bcd8739ae039; });

var $aZHJY = parcelRequire("aZHJY");

var $l3FOm = parcelRequire("l3FOm");
function $ffb82e32dc42c191$var$index(d) {
    return d.index;
}
function $ffb82e32dc42c191$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $ffb82e32dc42c191$export$2e2bcd8739ae039(links) {
    var id = $ffb82e32dc42c191$var$index, strength = defaultStrength, strengths, distance = (0, $aZHJY.default)(30), distances, nodes, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $l3FOm.default)(random);
            y = target.y + target.vy - source.y - source.vy || (0, $l3FOm.default)(random);
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $ffb82e32dc42c191$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $ffb82e32dc42c191$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

});

parcelRegister("1wOPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11d0354d723f4f77$export$2e2bcd8739ae039; });

var $22HY7 = parcelRequire("22HY7");

var $aZHJY = parcelRequire("aZHJY");

var $l3FOm = parcelRequire("l3FOm");

var $1Vq1e = parcelRequire("1Vq1e");
function $11d0354d723f4f77$export$2e2bcd8739ae039() {
    var nodes, node, random, alpha, strength = (0, $aZHJY.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $22HY7.default)(nodes, (0, $1Vq1e.x), (0, $1Vq1e.y)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $l3FOm.default)(random), l += x * x;
                if (y === 0) y = (0, $l3FOm.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $l3FOm.default)(random), l += x * x;
            if (y === 0) y = (0, $l3FOm.default)(random), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}

});
parcelRegister("1Vq1e", function(module, exports) {

$parcel$export(module.exports, "x", function () { return $166f4c239ad2f486$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $166f4c239ad2f486$export$4a5767248b18ef41; });
$parcel$export(module.exports, "default", function () { return $166f4c239ad2f486$export$2e2bcd8739ae039; });

var $5Rufx = parcelRequire("5Rufx");

var $2lwYT = parcelRequire("2lwYT");

var $5h2Mb = parcelRequire("5h2Mb");
function $166f4c239ad2f486$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $166f4c239ad2f486$export$4a5767248b18ef41(d) {
    return d.y;
}
var $166f4c239ad2f486$var$initialRadius = 10, $166f4c239ad2f486$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $166f4c239ad2f486$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $2lwYT.timer)(step), event = (0, $5Rufx.default)("tick", "end"), random = (0, $5h2Mb.default)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $166f4c239ad2f486$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $166f4c239ad2f486$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}

});
parcelRegister("5h2Mb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d70b18fd763c56e$export$2e2bcd8739ae039; });
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $3d70b18fd763c56e$var$a = 1664525;
const $3d70b18fd763c56e$var$c = 1013904223;
const $3d70b18fd763c56e$var$m = 4294967296; // 2^32
function $3d70b18fd763c56e$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($3d70b18fd763c56e$var$a * s + $3d70b18fd763c56e$var$c) % $3d70b18fd763c56e$var$m) / $3d70b18fd763c56e$var$m;
}

});



parcelRegister("eZmby", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae97f8b9a7aa22c8$export$2e2bcd8739ae039; });

var $aZHJY = parcelRequire("aZHJY");
function $ae97f8b9a7aa22c8$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $aZHJY.default)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $aZHJY.default)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("heQ2P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8cc1d770ace87ae$export$2e2bcd8739ae039; });

var $aZHJY = parcelRequire("aZHJY");
function $c8cc1d770ace87ae$export$2e2bcd8739ae039(x) {
    var strength = (0, $aZHJY.default)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $aZHJY.default)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : x;
    };
    return force;
}

});

parcelRegister("8UN2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67d99849df0a5412$export$2e2bcd8739ae039; });

var $aZHJY = parcelRequire("aZHJY");
function $67d99849df0a5412$export$2e2bcd8739ae039(y) {
    var strength = (0, $aZHJY.default)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $aZHJY.default)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $aZHJY.default)(+_), initialize(), force) : y;
    };
    return force;
}

});


parcelRegister("erWrv", function(module, exports) {

$parcel$export(module.exports, "formatDefaultLocale", function () { return (parcelRequire("bBrYe")).default; });
$parcel$export(module.exports, "format", function () { return (parcelRequire("bBrYe")).format; });
$parcel$export(module.exports, "formatPrefix", function () { return (parcelRequire("bBrYe")).formatPrefix; });
$parcel$export(module.exports, "formatLocale", function () { return (parcelRequire("id5VI")).default; });
$parcel$export(module.exports, "formatSpecifier", function () { return (parcelRequire("1AA4l")).default; });
$parcel$export(module.exports, "FormatSpecifier", function () { return (parcelRequire("1AA4l")).FormatSpecifier; });
$parcel$export(module.exports, "precisionFixed", function () { return (parcelRequire("6Ziqw")).default; });
$parcel$export(module.exports, "precisionPrefix", function () { return (parcelRequire("eiLdi")).default; });
$parcel$export(module.exports, "precisionRound", function () { return (parcelRequire("c3pED")).default; });

var $bBrYe = parcelRequire("bBrYe");

var $id5VI = parcelRequire("id5VI");

var $1AA4l = parcelRequire("1AA4l");

var $6Ziqw = parcelRequire("6Ziqw");

var $eiLdi = parcelRequire("eiLdi");

var $c3pED = parcelRequire("c3pED");

});
parcelRegister("bBrYe", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $8728d8c452494e52$export$d9468344d3651243; });
$parcel$export(module.exports, "formatPrefix", function () { return $8728d8c452494e52$export$8d85692a469dde6f; });
$parcel$export(module.exports, "default", function () { return $8728d8c452494e52$export$2e2bcd8739ae039; });

var $id5VI = parcelRequire("id5VI");
var $8728d8c452494e52$var$locale;
var $8728d8c452494e52$export$d9468344d3651243;
var $8728d8c452494e52$export$8d85692a469dde6f;
$8728d8c452494e52$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $8728d8c452494e52$export$2e2bcd8739ae039(definition) {
    $8728d8c452494e52$var$locale = (0, $id5VI.default)(definition);
    $8728d8c452494e52$export$d9468344d3651243 = $8728d8c452494e52$var$locale.format;
    $8728d8c452494e52$export$8d85692a469dde6f = $8728d8c452494e52$var$locale.formatPrefix;
    return $8728d8c452494e52$var$locale;
}

});
parcelRegister("id5VI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d41e0a6d78b4ee52$export$2e2bcd8739ae039; });

var $36T2j = parcelRequire("36T2j");

var $bLaLd = parcelRequire("bLaLd");

var $2uEuJ = parcelRequire("2uEuJ");

var $1AA4l = parcelRequire("1AA4l");

var $bpohl = parcelRequire("bpohl");

var $h0jE1 = parcelRequire("h0jE1");

var $4yEmU = parcelRequire("4yEmU");

var $P6RN1 = parcelRequire("P6RN1");
var $d41e0a6d78b4ee52$var$map = Array.prototype.map, $d41e0a6d78b4ee52$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $d41e0a6d78b4ee52$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $P6RN1.default) : (0, $bLaLd.default)($d41e0a6d78b4ee52$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $P6RN1.default) : (0, $2uEuJ.default)($d41e0a6d78b4ee52$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $1AA4l.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $h0jE1.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $h0jE1.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $bpohl.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $d41e0a6d78b4ee52$var$prefixes[8 + (0, $4yEmU.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $1AA4l.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $36T2j.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $d41e0a6d78b4ee52$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("36T2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $243c9fb1d6fdce54$export$2e2bcd8739ae039; });

var $2zKfQ = parcelRequire("2zKfQ");
function $243c9fb1d6fdce54$export$2e2bcd8739ae039(x) {
    return x = (0, $2zKfQ.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("2zKfQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e02bade167e67bd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "formatDecimalParts", function () { return $1e02bade167e67bd$export$8f8e23dd27dc19f5; });
function $1e02bade167e67bd$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $1e02bade167e67bd$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("bLaLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88fc6e4c0b8f4617$export$2e2bcd8739ae039; });
function $88fc6e4c0b8f4617$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2uEuJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d0dcb8261679bec$export$2e2bcd8739ae039; });
function $1d0dcb8261679bec$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("1AA4l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $128521c9644d4d0b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "FormatSpecifier", function () { return $128521c9644d4d0b$export$963aac351db36ed4; });
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $128521c9644d4d0b$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $128521c9644d4d0b$export$2e2bcd8739ae039(specifier) {
    if (!(match = $128521c9644d4d0b$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $128521c9644d4d0b$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$128521c9644d4d0b$export$2e2bcd8739ae039.prototype = $128521c9644d4d0b$export$963aac351db36ed4.prototype; // instanceof
function $128521c9644d4d0b$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$128521c9644d4d0b$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("bpohl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84e4dcc43551dacc$export$2e2bcd8739ae039; });
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $84e4dcc43551dacc$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("h0jE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c611acbe5379f5e8$export$2e2bcd8739ae039; });

var $2zKfQ = parcelRequire("2zKfQ");

var $4yEmU = parcelRequire("4yEmU");

var $8iezw = parcelRequire("8iezw");
var $c611acbe5379f5e8$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $2zKfQ.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $8iezw.default)(x * 100, p),
    "r": (0, $8iezw.default),
    "s": (0, $4yEmU.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("4yEmU", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", function () { return $3519a6b9f429aa6f$export$6863724d9a42263; });
$parcel$export(module.exports, "default", function () { return $3519a6b9f429aa6f$export$2e2bcd8739ae039; });

var $2zKfQ = parcelRequire("2zKfQ");
var $3519a6b9f429aa6f$export$6863724d9a42263;
function $3519a6b9f429aa6f$export$2e2bcd8739ae039(x, p) {
    var d = (0, $2zKfQ.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($3519a6b9f429aa6f$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $2zKfQ.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("8iezw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $609b4ed9d6c3cff0$export$2e2bcd8739ae039; });

var $2zKfQ = parcelRequire("2zKfQ");
function $609b4ed9d6c3cff0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $2zKfQ.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("P6RN1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $099a1717f1c8eb86$export$2e2bcd8739ae039; });
function $099a1717f1c8eb86$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("6Ziqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5166bbc4ea9607f6$export$2e2bcd8739ae039; });

var $36T2j = parcelRequire("36T2j");
function $5166bbc4ea9607f6$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $36T2j.default)(Math.abs(step)));
}

});

parcelRegister("eiLdi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6975ebcb8ce1783$export$2e2bcd8739ae039; });

var $36T2j = parcelRequire("36T2j");
function $a6975ebcb8ce1783$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $36T2j.default)(value) / 3))) * 3 - (0, $36T2j.default)(Math.abs(step)));
}

});

parcelRegister("c3pED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c69aa49b6ce2264$export$2e2bcd8739ae039; });

var $36T2j = parcelRequire("36T2j");
function $8c69aa49b6ce2264$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $36T2j.default)(max) - (0, $36T2j.default)(step)) + 1;
}

});


parcelRegister("7LmmM", function(module, exports) {

$parcel$export(module.exports, "geoArea", function () { return (parcelRequire("aefnR")).default; });
$parcel$export(module.exports, "geoBounds", function () { return (parcelRequire("bi2RP")).default; });
$parcel$export(module.exports, "geoCentroid", function () { return (parcelRequire("33dG4")).default; });
$parcel$export(module.exports, "geoCircle", function () { return (parcelRequire("5iIVH")).default; });
$parcel$export(module.exports, "geoClipAntimeridian", function () { return (parcelRequire("i18v5")).default; });
$parcel$export(module.exports, "geoClipCircle", function () { return (parcelRequire("hVPK1")).default; });
$parcel$export(module.exports, "geoClipExtent", function () { return (parcelRequire("kuFIt")).default; });
$parcel$export(module.exports, "geoClipRectangle", function () { return (parcelRequire("7aYGE")).default; });
$parcel$export(module.exports, "geoContains", function () { return (parcelRequire("eJGs0")).default; });
$parcel$export(module.exports, "geoDistance", function () { return (parcelRequire("3dQ40")).default; });
$parcel$export(module.exports, "geoGraticule", function () { return (parcelRequire("3KaUJ")).default; });
$parcel$export(module.exports, "geoGraticule10", function () { return (parcelRequire("3KaUJ")).graticule10; });
$parcel$export(module.exports, "geoInterpolate", function () { return (parcelRequire("79oDe")).default; });
$parcel$export(module.exports, "geoLength", function () { return (parcelRequire("arJ4z")).default; });
$parcel$export(module.exports, "geoPath", function () { return (parcelRequire("9QR7V")).default; });
$parcel$export(module.exports, "geoAlbers", function () { return (parcelRequire("4CjlI")).default; });
$parcel$export(module.exports, "geoAlbersUsa", function () { return (parcelRequire("gCd89")).default; });
$parcel$export(module.exports, "geoAzimuthalEqualArea", function () { return (parcelRequire("gSDfH")).default; });
$parcel$export(module.exports, "geoAzimuthalEqualAreaRaw", function () { return (parcelRequire("gSDfH")).azimuthalEqualAreaRaw; });
$parcel$export(module.exports, "geoAzimuthalEquidistant", function () { return (parcelRequire("8ZTVf")).default; });
$parcel$export(module.exports, "geoAzimuthalEquidistantRaw", function () { return (parcelRequire("8ZTVf")).azimuthalEquidistantRaw; });
$parcel$export(module.exports, "geoConicConformal", function () { return (parcelRequire("5i5iU")).default; });
$parcel$export(module.exports, "geoConicConformalRaw", function () { return (parcelRequire("5i5iU")).conicConformalRaw; });
$parcel$export(module.exports, "geoConicEqualArea", function () { return (parcelRequire("e5xCI")).default; });
$parcel$export(module.exports, "geoConicEqualAreaRaw", function () { return (parcelRequire("e5xCI")).conicEqualAreaRaw; });
$parcel$export(module.exports, "geoConicEquidistant", function () { return (parcelRequire("d8Z5n")).default; });
$parcel$export(module.exports, "geoConicEquidistantRaw", function () { return (parcelRequire("d8Z5n")).conicEquidistantRaw; });
$parcel$export(module.exports, "geoEqualEarth", function () { return (parcelRequire("lQCZE")).default; });
$parcel$export(module.exports, "geoEqualEarthRaw", function () { return (parcelRequire("lQCZE")).equalEarthRaw; });
$parcel$export(module.exports, "geoEquirectangular", function () { return (parcelRequire("4gub3")).default; });
$parcel$export(module.exports, "geoEquirectangularRaw", function () { return (parcelRequire("4gub3")).equirectangularRaw; });
$parcel$export(module.exports, "geoGnomonic", function () { return (parcelRequire("fPTRS")).default; });
$parcel$export(module.exports, "geoGnomonicRaw", function () { return (parcelRequire("fPTRS")).gnomonicRaw; });
$parcel$export(module.exports, "geoIdentity", function () { return (parcelRequire("40c69")).default; });
$parcel$export(module.exports, "geoProjection", function () { return (parcelRequire("2TXoI")).default; });
$parcel$export(module.exports, "geoProjectionMutator", function () { return (parcelRequire("2TXoI")).projectionMutator; });
$parcel$export(module.exports, "geoMercator", function () { return (parcelRequire("1xcoz")).default; });
$parcel$export(module.exports, "geoMercatorRaw", function () { return (parcelRequire("1xcoz")).mercatorRaw; });
$parcel$export(module.exports, "geoNaturalEarth1", function () { return (parcelRequire("kVh2Y")).default; });
$parcel$export(module.exports, "geoNaturalEarth1Raw", function () { return (parcelRequire("kVh2Y")).naturalEarth1Raw; });
$parcel$export(module.exports, "geoOrthographic", function () { return (parcelRequire("jMtWt")).default; });
$parcel$export(module.exports, "geoOrthographicRaw", function () { return (parcelRequire("jMtWt")).orthographicRaw; });
$parcel$export(module.exports, "geoStereographic", function () { return (parcelRequire("2T1fm")).default; });
$parcel$export(module.exports, "geoStereographicRaw", function () { return (parcelRequire("2T1fm")).stereographicRaw; });
$parcel$export(module.exports, "geoTransverseMercator", function () { return (parcelRequire("d60zl")).default; });
$parcel$export(module.exports, "geoTransverseMercatorRaw", function () { return (parcelRequire("d60zl")).transverseMercatorRaw; });
$parcel$export(module.exports, "geoRotation", function () { return (parcelRequire("6sZgy")).default; });
$parcel$export(module.exports, "geoStream", function () { return (parcelRequire("bJwlW")).default; });
$parcel$export(module.exports, "geoTransform", function () { return (parcelRequire("LrrUN")).default; });

var $aefnR = parcelRequire("aefnR");

var $bi2RP = parcelRequire("bi2RP");

var $33dG4 = parcelRequire("33dG4");

var $5iIVH = parcelRequire("5iIVH");

var $i18v5 = parcelRequire("i18v5");

var $hVPK1 = parcelRequire("hVPK1");

var $kuFIt = parcelRequire("kuFIt");

var $7aYGE = parcelRequire("7aYGE");

var $eJGs0 = parcelRequire("eJGs0");

var $3dQ40 = parcelRequire("3dQ40");

var $3KaUJ = parcelRequire("3KaUJ");

var $79oDe = parcelRequire("79oDe");

var $arJ4z = parcelRequire("arJ4z");

var $9QR7V = parcelRequire("9QR7V");

var $4CjlI = parcelRequire("4CjlI");

var $gCd89 = parcelRequire("gCd89");

var $gSDfH = parcelRequire("gSDfH");

var $8ZTVf = parcelRequire("8ZTVf");

var $5i5iU = parcelRequire("5i5iU");

var $e5xCI = parcelRequire("e5xCI");

var $d8Z5n = parcelRequire("d8Z5n");

var $lQCZE = parcelRequire("lQCZE");

var $4gub3 = parcelRequire("4gub3");

var $fPTRS = parcelRequire("fPTRS");

var $40c69 = parcelRequire("40c69");

var $2TXoI = parcelRequire("2TXoI");

var $1xcoz = parcelRequire("1xcoz");

var $kVh2Y = parcelRequire("kVh2Y");

var $jMtWt = parcelRequire("jMtWt");

var $2T1fm = parcelRequire("2T1fm");

var $d60zl = parcelRequire("d60zl");

var $6sZgy = parcelRequire("6sZgy");

var $bJwlW = parcelRequire("bJwlW");

var $LrrUN = parcelRequire("LrrUN");

});
parcelRegister("aefnR", function(module, exports) {

$parcel$export(module.exports, "areaRingSum", function () { return $77272515e8b9d1a6$export$bf8f994332070c7f; });
$parcel$export(module.exports, "areaStream", function () { return $77272515e8b9d1a6$export$cb67cfa750ae69dc; });
$parcel$export(module.exports, "default", function () { return $77272515e8b9d1a6$export$2e2bcd8739ae039; });

var $fT5Bl = parcelRequire("fT5Bl");

var $gPo1b = parcelRequire("gPo1b");

var $jqvlO = parcelRequire("jqvlO");

var $bJwlW = parcelRequire("bJwlW");
var $77272515e8b9d1a6$export$bf8f994332070c7f = new (0, $fT5Bl.Adder)();
// hello?
var $77272515e8b9d1a6$var$areaSum = new (0, $fT5Bl.Adder)(), $77272515e8b9d1a6$var$lambda00, $77272515e8b9d1a6$var$phi00, $77272515e8b9d1a6$var$lambda0, $77272515e8b9d1a6$var$cosPhi0, $77272515e8b9d1a6$var$sinPhi0;
var $77272515e8b9d1a6$export$cb67cfa750ae69dc = {
    point: (0, $jqvlO.default),
    lineStart: (0, $jqvlO.default),
    lineEnd: (0, $jqvlO.default),
    polygonStart: function() {
        $77272515e8b9d1a6$export$bf8f994332070c7f = new (0, $fT5Bl.Adder)();
        $77272515e8b9d1a6$export$cb67cfa750ae69dc.lineStart = $77272515e8b9d1a6$var$areaRingStart;
        $77272515e8b9d1a6$export$cb67cfa750ae69dc.lineEnd = $77272515e8b9d1a6$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$77272515e8b9d1a6$export$bf8f994332070c7f;
        $77272515e8b9d1a6$var$areaSum.add(areaRing < 0 ? (0, $gPo1b.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $jqvlO.default);
    },
    sphere: function() {
        $77272515e8b9d1a6$var$areaSum.add((0, $gPo1b.tau));
    }
};
function $77272515e8b9d1a6$var$areaRingStart() {
    $77272515e8b9d1a6$export$cb67cfa750ae69dc.point = $77272515e8b9d1a6$var$areaPointFirst;
}
function $77272515e8b9d1a6$var$areaRingEnd() {
    $77272515e8b9d1a6$var$areaPoint($77272515e8b9d1a6$var$lambda00, $77272515e8b9d1a6$var$phi00);
}
function $77272515e8b9d1a6$var$areaPointFirst(lambda, phi) {
    $77272515e8b9d1a6$export$cb67cfa750ae69dc.point = $77272515e8b9d1a6$var$areaPoint;
    $77272515e8b9d1a6$var$lambda00 = lambda, $77272515e8b9d1a6$var$phi00 = phi;
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    $77272515e8b9d1a6$var$lambda0 = lambda, $77272515e8b9d1a6$var$cosPhi0 = (0, $gPo1b.cos)(phi = phi / 2 + (0, $gPo1b.quarterPi)), $77272515e8b9d1a6$var$sinPhi0 = (0, $gPo1b.sin)(phi);
}
function $77272515e8b9d1a6$var$areaPoint(lambda, phi) {
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    phi = phi / 2 + (0, $gPo1b.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $77272515e8b9d1a6$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $gPo1b.cos)(phi), sinPhi = (0, $gPo1b.sin)(phi), k = $77272515e8b9d1a6$var$sinPhi0 * sinPhi, u = $77272515e8b9d1a6$var$cosPhi0 * cosPhi + k * (0, $gPo1b.cos)(adLambda), v = k * sdLambda * (0, $gPo1b.sin)(adLambda);
    $77272515e8b9d1a6$export$bf8f994332070c7f.add((0, $gPo1b.atan2)(v, u));
    // Advance the previous points.
    $77272515e8b9d1a6$var$lambda0 = lambda, $77272515e8b9d1a6$var$cosPhi0 = cosPhi, $77272515e8b9d1a6$var$sinPhi0 = sinPhi;
}
function $77272515e8b9d1a6$export$2e2bcd8739ae039(object) {
    $77272515e8b9d1a6$var$areaSum = new (0, $fT5Bl.Adder)();
    (0, $bJwlW.default)(object, $77272515e8b9d1a6$export$cb67cfa750ae69dc);
    return $77272515e8b9d1a6$var$areaSum * 2;
}

});
parcelRegister("gPo1b", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return $c4040a461d28a641$export$6c421550c66a327d; });
$parcel$export(module.exports, "epsilon2", function () { return $c4040a461d28a641$export$92c06fba281fe81b; });
$parcel$export(module.exports, "pi", function () { return $c4040a461d28a641$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $c4040a461d28a641$export$e51408a300e8929a; });
$parcel$export(module.exports, "quarterPi", function () { return $c4040a461d28a641$export$c39a5cba78ea0fc2; });
$parcel$export(module.exports, "tau", function () { return $c4040a461d28a641$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "degrees", function () { return $c4040a461d28a641$export$41fc368e1a942b97; });
$parcel$export(module.exports, "radians", function () { return $c4040a461d28a641$export$8449e153fbd325fc; });
$parcel$export(module.exports, "abs", function () { return $c4040a461d28a641$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan", function () { return $c4040a461d28a641$export$628dc4eed22b0fbd; });
$parcel$export(module.exports, "atan2", function () { return $c4040a461d28a641$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $c4040a461d28a641$export$50d414a77b60d802; });
$parcel$export(module.exports, "ceil", function () { return $c4040a461d28a641$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "exp", function () { return $c4040a461d28a641$export$b310ec824aaee37f; });
$parcel$export(module.exports, "hypot", function () { return $c4040a461d28a641$export$f95c7888b62f8e9a; });
$parcel$export(module.exports, "log", function () { return $c4040a461d28a641$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "pow", function () { return $c4040a461d28a641$export$9c297f60e22e3389; });
$parcel$export(module.exports, "sin", function () { return $c4040a461d28a641$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sign", function () { return $c4040a461d28a641$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "sqrt", function () { return $c4040a461d28a641$export$eba8049fb5020b81; });
$parcel$export(module.exports, "tan", function () { return $c4040a461d28a641$export$fcdd3b0b3246a325; });
$parcel$export(module.exports, "acos", function () { return $c4040a461d28a641$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $c4040a461d28a641$export$41726bdb1fc63f; });
$parcel$export(module.exports, "haversin", function () { return $c4040a461d28a641$export$e808712c2966e662; });
var $c4040a461d28a641$export$6c421550c66a327d = 1e-6;
var $c4040a461d28a641$export$92c06fba281fe81b = 1e-12;
var $c4040a461d28a641$export$18c7bea995a110f = Math.PI;
var $c4040a461d28a641$export$e51408a300e8929a = $c4040a461d28a641$export$18c7bea995a110f / 2;
var $c4040a461d28a641$export$c39a5cba78ea0fc2 = $c4040a461d28a641$export$18c7bea995a110f / 4;
var $c4040a461d28a641$export$a4b4b4d4d776fe92 = $c4040a461d28a641$export$18c7bea995a110f * 2;
var $c4040a461d28a641$export$41fc368e1a942b97 = 180 / $c4040a461d28a641$export$18c7bea995a110f;
var $c4040a461d28a641$export$8449e153fbd325fc = $c4040a461d28a641$export$18c7bea995a110f / 180;
var $c4040a461d28a641$export$2335f513bbd82c6d = Math.abs;
var $c4040a461d28a641$export$628dc4eed22b0fbd = Math.atan;
var $c4040a461d28a641$export$b8b770ee6a0d9760 = Math.atan2;
var $c4040a461d28a641$export$50d414a77b60d802 = Math.cos;
var $c4040a461d28a641$export$803ce6b71a0a94b2 = Math.ceil;
var $c4040a461d28a641$export$b310ec824aaee37f = Math.exp;
var $c4040a461d28a641$export$a3fe094919f356fd = Math.floor;
var $c4040a461d28a641$export$f95c7888b62f8e9a = Math.hypot;
var $c4040a461d28a641$export$bef1f36f5486a6a3 = Math.log;
var $c4040a461d28a641$export$9c297f60e22e3389 = Math.pow;
var $c4040a461d28a641$export$5de3937cb4b592ed = Math.sin;
var $c4040a461d28a641$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $c4040a461d28a641$export$eba8049fb5020b81 = Math.sqrt;
var $c4040a461d28a641$export$fcdd3b0b3246a325 = Math.tan;
function $c4040a461d28a641$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $c4040a461d28a641$export$18c7bea995a110f : Math.acos(x);
}
function $c4040a461d28a641$export$41726bdb1fc63f(x) {
    return x > 1 ? $c4040a461d28a641$export$e51408a300e8929a : x < -1 ? -$c4040a461d28a641$export$e51408a300e8929a : Math.asin(x);
}
function $c4040a461d28a641$export$e808712c2966e662(x) {
    return (x = $c4040a461d28a641$export$5de3937cb4b592ed(x / 2)) * x;
}

});

parcelRegister("jqvlO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e248c3a386931e50$export$2e2bcd8739ae039; });
function $e248c3a386931e50$export$2e2bcd8739ae039() {}

});

parcelRegister("bJwlW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88acfe46a9a10973$export$2e2bcd8739ae039; });
function $88acfe46a9a10973$var$streamGeometry(geometry, stream) {
    if (geometry && $88acfe46a9a10973$var$streamGeometryType.hasOwnProperty(geometry.type)) $88acfe46a9a10973$var$streamGeometryType[geometry.type](geometry, stream);
}
var $88acfe46a9a10973$var$streamObjectType = {
    Feature: function(object, stream) {
        $88acfe46a9a10973$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$88acfe46a9a10973$var$streamGeometry(features[i].geometry, stream);
    }
};
var $88acfe46a9a10973$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $88acfe46a9a10973$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$88acfe46a9a10973$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $88acfe46a9a10973$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$88acfe46a9a10973$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$88acfe46a9a10973$var$streamGeometry(geometries[i], stream);
    }
};
function $88acfe46a9a10973$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $88acfe46a9a10973$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$88acfe46a9a10973$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $88acfe46a9a10973$export$2e2bcd8739ae039(object, stream) {
    if (object && $88acfe46a9a10973$var$streamObjectType.hasOwnProperty(object.type)) $88acfe46a9a10973$var$streamObjectType[object.type](object, stream);
    else $88acfe46a9a10973$var$streamGeometry(object, stream);
}

});


parcelRegister("bi2RP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83839983b98615c5$export$2e2bcd8739ae039; });

var $fT5Bl = parcelRequire("fT5Bl");

var $aefnR = parcelRequire("aefnR");

var $duXPh = parcelRequire("duXPh");

var $gPo1b = parcelRequire("gPo1b");

var $bJwlW = parcelRequire("bJwlW");
var $83839983b98615c5$var$lambda0, $83839983b98615c5$var$phi0, $83839983b98615c5$var$lambda1, $83839983b98615c5$var$phi1, $83839983b98615c5$var$lambda2, $83839983b98615c5$var$lambda00, $83839983b98615c5$var$phi00, $83839983b98615c5$var$p0, $83839983b98615c5$var$deltaSum, $83839983b98615c5$var$ranges, $83839983b98615c5$var$range;
var $83839983b98615c5$var$boundsStream = {
    point: $83839983b98615c5$var$boundsPoint,
    lineStart: $83839983b98615c5$var$boundsLineStart,
    lineEnd: $83839983b98615c5$var$boundsLineEnd,
    polygonStart: function() {
        $83839983b98615c5$var$boundsStream.point = $83839983b98615c5$var$boundsRingPoint;
        $83839983b98615c5$var$boundsStream.lineStart = $83839983b98615c5$var$boundsRingStart;
        $83839983b98615c5$var$boundsStream.lineEnd = $83839983b98615c5$var$boundsRingEnd;
        $83839983b98615c5$var$deltaSum = new (0, $fT5Bl.Adder)();
        (0, $aefnR.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, $aefnR.areaStream).polygonEnd();
        $83839983b98615c5$var$boundsStream.point = $83839983b98615c5$var$boundsPoint;
        $83839983b98615c5$var$boundsStream.lineStart = $83839983b98615c5$var$boundsLineStart;
        $83839983b98615c5$var$boundsStream.lineEnd = $83839983b98615c5$var$boundsLineEnd;
        if ((0, $aefnR.areaRingSum) < 0) $83839983b98615c5$var$lambda0 = -($83839983b98615c5$var$lambda1 = 180), $83839983b98615c5$var$phi0 = -($83839983b98615c5$var$phi1 = 90);
        else if ($83839983b98615c5$var$deltaSum > (0, $gPo1b.epsilon)) $83839983b98615c5$var$phi1 = 90;
        else if ($83839983b98615c5$var$deltaSum < -(0, $gPo1b.epsilon)) $83839983b98615c5$var$phi0 = -90;
        $83839983b98615c5$var$range[0] = $83839983b98615c5$var$lambda0, $83839983b98615c5$var$range[1] = $83839983b98615c5$var$lambda1;
    },
    sphere: function() {
        $83839983b98615c5$var$lambda0 = -($83839983b98615c5$var$lambda1 = 180), $83839983b98615c5$var$phi0 = -($83839983b98615c5$var$phi1 = 90);
    }
};
function $83839983b98615c5$var$boundsPoint(lambda, phi) {
    $83839983b98615c5$var$ranges.push($83839983b98615c5$var$range = [
        $83839983b98615c5$var$lambda0 = lambda,
        $83839983b98615c5$var$lambda1 = lambda
    ]);
    if (phi < $83839983b98615c5$var$phi0) $83839983b98615c5$var$phi0 = phi;
    if (phi > $83839983b98615c5$var$phi1) $83839983b98615c5$var$phi1 = phi;
}
function $83839983b98615c5$var$linePoint(lambda, phi) {
    var p = (0, $duXPh.cartesian)([
        lambda * (0, $gPo1b.radians),
        phi * (0, $gPo1b.radians)
    ]);
    if ($83839983b98615c5$var$p0) {
        var normal = (0, $duXPh.cartesianCross)($83839983b98615c5$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $duXPh.cartesianCross)(equatorial, normal);
        (0, $duXPh.cartesianNormalizeInPlace)(inflection);
        inflection = (0, $duXPh.spherical)(inflection);
        var delta = lambda - $83839983b98615c5$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $gPo1b.degrees) * sign, phii, antimeridian = (0, $gPo1b.abs)(delta) > 180;
        if (antimeridian ^ (sign * $83839983b98615c5$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $gPo1b.degrees);
            if (phii > $83839983b98615c5$var$phi1) $83839983b98615c5$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $83839983b98615c5$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $gPo1b.degrees);
            if (phii < $83839983b98615c5$var$phi0) $83839983b98615c5$var$phi0 = phii;
        } else {
            if (phi < $83839983b98615c5$var$phi0) $83839983b98615c5$var$phi0 = phi;
            if (phi > $83839983b98615c5$var$phi1) $83839983b98615c5$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $83839983b98615c5$var$lambda2) {
                if ($83839983b98615c5$var$angle($83839983b98615c5$var$lambda0, lambda) > $83839983b98615c5$var$angle($83839983b98615c5$var$lambda0, $83839983b98615c5$var$lambda1)) $83839983b98615c5$var$lambda1 = lambda;
            } else if ($83839983b98615c5$var$angle(lambda, $83839983b98615c5$var$lambda1) > $83839983b98615c5$var$angle($83839983b98615c5$var$lambda0, $83839983b98615c5$var$lambda1)) $83839983b98615c5$var$lambda0 = lambda;
        } else if ($83839983b98615c5$var$lambda1 >= $83839983b98615c5$var$lambda0) {
            if (lambda < $83839983b98615c5$var$lambda0) $83839983b98615c5$var$lambda0 = lambda;
            if (lambda > $83839983b98615c5$var$lambda1) $83839983b98615c5$var$lambda1 = lambda;
        } else {
            if (lambda > $83839983b98615c5$var$lambda2) {
                if ($83839983b98615c5$var$angle($83839983b98615c5$var$lambda0, lambda) > $83839983b98615c5$var$angle($83839983b98615c5$var$lambda0, $83839983b98615c5$var$lambda1)) $83839983b98615c5$var$lambda1 = lambda;
            } else if ($83839983b98615c5$var$angle(lambda, $83839983b98615c5$var$lambda1) > $83839983b98615c5$var$angle($83839983b98615c5$var$lambda0, $83839983b98615c5$var$lambda1)) $83839983b98615c5$var$lambda0 = lambda;
        }
    } else $83839983b98615c5$var$ranges.push($83839983b98615c5$var$range = [
        $83839983b98615c5$var$lambda0 = lambda,
        $83839983b98615c5$var$lambda1 = lambda
    ]);
    if (phi < $83839983b98615c5$var$phi0) $83839983b98615c5$var$phi0 = phi;
    if (phi > $83839983b98615c5$var$phi1) $83839983b98615c5$var$phi1 = phi;
    $83839983b98615c5$var$p0 = p, $83839983b98615c5$var$lambda2 = lambda;
}
function $83839983b98615c5$var$boundsLineStart() {
    $83839983b98615c5$var$boundsStream.point = $83839983b98615c5$var$linePoint;
}
function $83839983b98615c5$var$boundsLineEnd() {
    $83839983b98615c5$var$range[0] = $83839983b98615c5$var$lambda0, $83839983b98615c5$var$range[1] = $83839983b98615c5$var$lambda1;
    $83839983b98615c5$var$boundsStream.point = $83839983b98615c5$var$boundsPoint;
    $83839983b98615c5$var$p0 = null;
}
function $83839983b98615c5$var$boundsRingPoint(lambda, phi) {
    if ($83839983b98615c5$var$p0) {
        var delta = lambda - $83839983b98615c5$var$lambda2;
        $83839983b98615c5$var$deltaSum.add((0, $gPo1b.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $83839983b98615c5$var$lambda00 = lambda, $83839983b98615c5$var$phi00 = phi;
    (0, $aefnR.areaStream).point(lambda, phi);
    $83839983b98615c5$var$linePoint(lambda, phi);
}
function $83839983b98615c5$var$boundsRingStart() {
    (0, $aefnR.areaStream).lineStart();
}
function $83839983b98615c5$var$boundsRingEnd() {
    $83839983b98615c5$var$boundsRingPoint($83839983b98615c5$var$lambda00, $83839983b98615c5$var$phi00);
    (0, $aefnR.areaStream).lineEnd();
    if ((0, $gPo1b.abs)($83839983b98615c5$var$deltaSum) > (0, $gPo1b.epsilon)) $83839983b98615c5$var$lambda0 = -($83839983b98615c5$var$lambda1 = 180);
    $83839983b98615c5$var$range[0] = $83839983b98615c5$var$lambda0, $83839983b98615c5$var$range[1] = $83839983b98615c5$var$lambda1;
    $83839983b98615c5$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $83839983b98615c5$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $83839983b98615c5$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $83839983b98615c5$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $83839983b98615c5$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $83839983b98615c5$var$phi1 = $83839983b98615c5$var$lambda1 = -($83839983b98615c5$var$lambda0 = $83839983b98615c5$var$phi0 = Infinity);
    $83839983b98615c5$var$ranges = [];
    (0, $bJwlW.default)(feature, $83839983b98615c5$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $83839983b98615c5$var$ranges.length) {
        $83839983b98615c5$var$ranges.sort($83839983b98615c5$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $83839983b98615c5$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $83839983b98615c5$var$ranges[i];
            if ($83839983b98615c5$var$rangeContains(a, b[0]) || $83839983b98615c5$var$rangeContains(a, b[1])) {
                if ($83839983b98615c5$var$angle(a[0], b[1]) > $83839983b98615c5$var$angle(a[0], a[1])) a[1] = b[1];
                if ($83839983b98615c5$var$angle(b[0], a[1]) > $83839983b98615c5$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $83839983b98615c5$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $83839983b98615c5$var$lambda0 = b[0], $83839983b98615c5$var$lambda1 = a[1];
        }
    }
    $83839983b98615c5$var$ranges = $83839983b98615c5$var$range = null;
    return $83839983b98615c5$var$lambda0 === Infinity || $83839983b98615c5$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $83839983b98615c5$var$lambda0,
            $83839983b98615c5$var$phi0
        ],
        [
            $83839983b98615c5$var$lambda1,
            $83839983b98615c5$var$phi1
        ]
    ];
}

});
parcelRegister("duXPh", function(module, exports) {

$parcel$export(module.exports, "spherical", function () { return $9d3c7be8668fc917$export$12f9ad44fe773943; });
$parcel$export(module.exports, "cartesian", function () { return $9d3c7be8668fc917$export$6e6697ef026a96; });
$parcel$export(module.exports, "cartesianDot", function () { return $9d3c7be8668fc917$export$2ef80f51436a9de9; });
$parcel$export(module.exports, "cartesianCross", function () { return $9d3c7be8668fc917$export$4763f5351b14293f; });
$parcel$export(module.exports, "cartesianAddInPlace", function () { return $9d3c7be8668fc917$export$e62eba72fc898eae; });
$parcel$export(module.exports, "cartesianScale", function () { return $9d3c7be8668fc917$export$52d0ee3fc868d452; });
$parcel$export(module.exports, "cartesianNormalizeInPlace", function () { return $9d3c7be8668fc917$export$6789498aec2cb34b; });

var $gPo1b = parcelRequire("gPo1b");
function $9d3c7be8668fc917$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $gPo1b.atan2)(cartesian[1], cartesian[0]),
        (0, $gPo1b.asin)(cartesian[2])
    ];
}
function $9d3c7be8668fc917$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $gPo1b.cos)(phi);
    return [
        cosPhi * (0, $gPo1b.cos)(lambda),
        cosPhi * (0, $gPo1b.sin)(lambda),
        (0, $gPo1b.sin)(phi)
    ];
}
function $9d3c7be8668fc917$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $9d3c7be8668fc917$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $9d3c7be8668fc917$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $9d3c7be8668fc917$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $9d3c7be8668fc917$export$6789498aec2cb34b(d) {
    var l = (0, $gPo1b.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

});


parcelRegister("33dG4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $238c42faf9d00fe9$export$2e2bcd8739ae039; });

var $fT5Bl = parcelRequire("fT5Bl");

var $gPo1b = parcelRequire("gPo1b");

var $jqvlO = parcelRequire("jqvlO");

var $bJwlW = parcelRequire("bJwlW");
var $238c42faf9d00fe9$var$W0, $238c42faf9d00fe9$var$W1, $238c42faf9d00fe9$var$X0, $238c42faf9d00fe9$var$Y0, $238c42faf9d00fe9$var$Z0, $238c42faf9d00fe9$var$X1, $238c42faf9d00fe9$var$Y1, $238c42faf9d00fe9$var$Z1, $238c42faf9d00fe9$var$X2, $238c42faf9d00fe9$var$Y2, $238c42faf9d00fe9$var$Z2, $238c42faf9d00fe9$var$lambda00, $238c42faf9d00fe9$var$phi00, $238c42faf9d00fe9$var$x0, $238c42faf9d00fe9$var$y0, $238c42faf9d00fe9$var$z0; // previous point
var $238c42faf9d00fe9$var$centroidStream = {
    sphere: (0, $jqvlO.default),
    point: $238c42faf9d00fe9$var$centroidPoint,
    lineStart: $238c42faf9d00fe9$var$centroidLineStart,
    lineEnd: $238c42faf9d00fe9$var$centroidLineEnd,
    polygonStart: function() {
        $238c42faf9d00fe9$var$centroidStream.lineStart = $238c42faf9d00fe9$var$centroidRingStart;
        $238c42faf9d00fe9$var$centroidStream.lineEnd = $238c42faf9d00fe9$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $238c42faf9d00fe9$var$centroidStream.lineStart = $238c42faf9d00fe9$var$centroidLineStart;
        $238c42faf9d00fe9$var$centroidStream.lineEnd = $238c42faf9d00fe9$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $238c42faf9d00fe9$var$centroidPoint(lambda, phi) {
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    var cosPhi = (0, $gPo1b.cos)(phi);
    $238c42faf9d00fe9$var$centroidPointCartesian(cosPhi * (0, $gPo1b.cos)(lambda), cosPhi * (0, $gPo1b.sin)(lambda), (0, $gPo1b.sin)(phi));
}
function $238c42faf9d00fe9$var$centroidPointCartesian(x, y, z) {
    ++$238c42faf9d00fe9$var$W0;
    $238c42faf9d00fe9$var$X0 += (x - $238c42faf9d00fe9$var$X0) / $238c42faf9d00fe9$var$W0;
    $238c42faf9d00fe9$var$Y0 += (y - $238c42faf9d00fe9$var$Y0) / $238c42faf9d00fe9$var$W0;
    $238c42faf9d00fe9$var$Z0 += (z - $238c42faf9d00fe9$var$Z0) / $238c42faf9d00fe9$var$W0;
}
function $238c42faf9d00fe9$var$centroidLineStart() {
    $238c42faf9d00fe9$var$centroidStream.point = $238c42faf9d00fe9$var$centroidLinePointFirst;
}
function $238c42faf9d00fe9$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    var cosPhi = (0, $gPo1b.cos)(phi);
    $238c42faf9d00fe9$var$x0 = cosPhi * (0, $gPo1b.cos)(lambda);
    $238c42faf9d00fe9$var$y0 = cosPhi * (0, $gPo1b.sin)(lambda);
    $238c42faf9d00fe9$var$z0 = (0, $gPo1b.sin)(phi);
    $238c42faf9d00fe9$var$centroidStream.point = $238c42faf9d00fe9$var$centroidLinePoint;
    $238c42faf9d00fe9$var$centroidPointCartesian($238c42faf9d00fe9$var$x0, $238c42faf9d00fe9$var$y0, $238c42faf9d00fe9$var$z0);
}
function $238c42faf9d00fe9$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    var cosPhi = (0, $gPo1b.cos)(phi), x = cosPhi * (0, $gPo1b.cos)(lambda), y = cosPhi * (0, $gPo1b.sin)(lambda), z = (0, $gPo1b.sin)(phi), w = (0, $gPo1b.atan2)((0, $gPo1b.sqrt)((w = $238c42faf9d00fe9$var$y0 * z - $238c42faf9d00fe9$var$z0 * y) * w + (w = $238c42faf9d00fe9$var$z0 * x - $238c42faf9d00fe9$var$x0 * z) * w + (w = $238c42faf9d00fe9$var$x0 * y - $238c42faf9d00fe9$var$y0 * x) * w), $238c42faf9d00fe9$var$x0 * x + $238c42faf9d00fe9$var$y0 * y + $238c42faf9d00fe9$var$z0 * z);
    $238c42faf9d00fe9$var$W1 += w;
    $238c42faf9d00fe9$var$X1 += w * ($238c42faf9d00fe9$var$x0 + ($238c42faf9d00fe9$var$x0 = x));
    $238c42faf9d00fe9$var$Y1 += w * ($238c42faf9d00fe9$var$y0 + ($238c42faf9d00fe9$var$y0 = y));
    $238c42faf9d00fe9$var$Z1 += w * ($238c42faf9d00fe9$var$z0 + ($238c42faf9d00fe9$var$z0 = z));
    $238c42faf9d00fe9$var$centroidPointCartesian($238c42faf9d00fe9$var$x0, $238c42faf9d00fe9$var$y0, $238c42faf9d00fe9$var$z0);
}
function $238c42faf9d00fe9$var$centroidLineEnd() {
    $238c42faf9d00fe9$var$centroidStream.point = $238c42faf9d00fe9$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $238c42faf9d00fe9$var$centroidRingStart() {
    $238c42faf9d00fe9$var$centroidStream.point = $238c42faf9d00fe9$var$centroidRingPointFirst;
}
function $238c42faf9d00fe9$var$centroidRingEnd() {
    $238c42faf9d00fe9$var$centroidRingPoint($238c42faf9d00fe9$var$lambda00, $238c42faf9d00fe9$var$phi00);
    $238c42faf9d00fe9$var$centroidStream.point = $238c42faf9d00fe9$var$centroidPoint;
}
function $238c42faf9d00fe9$var$centroidRingPointFirst(lambda, phi) {
    $238c42faf9d00fe9$var$lambda00 = lambda, $238c42faf9d00fe9$var$phi00 = phi;
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    $238c42faf9d00fe9$var$centroidStream.point = $238c42faf9d00fe9$var$centroidRingPoint;
    var cosPhi = (0, $gPo1b.cos)(phi);
    $238c42faf9d00fe9$var$x0 = cosPhi * (0, $gPo1b.cos)(lambda);
    $238c42faf9d00fe9$var$y0 = cosPhi * (0, $gPo1b.sin)(lambda);
    $238c42faf9d00fe9$var$z0 = (0, $gPo1b.sin)(phi);
    $238c42faf9d00fe9$var$centroidPointCartesian($238c42faf9d00fe9$var$x0, $238c42faf9d00fe9$var$y0, $238c42faf9d00fe9$var$z0);
}
function $238c42faf9d00fe9$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    var cosPhi = (0, $gPo1b.cos)(phi), x = cosPhi * (0, $gPo1b.cos)(lambda), y = cosPhi * (0, $gPo1b.sin)(lambda), z = (0, $gPo1b.sin)(phi), cx = $238c42faf9d00fe9$var$y0 * z - $238c42faf9d00fe9$var$z0 * y, cy = $238c42faf9d00fe9$var$z0 * x - $238c42faf9d00fe9$var$x0 * z, cz = $238c42faf9d00fe9$var$x0 * y - $238c42faf9d00fe9$var$y0 * x, m = (0, $gPo1b.hypot)(cx, cy, cz), w = (0, $gPo1b.asin)(m), v = m && -w / m; // area weight multiplier
    $238c42faf9d00fe9$var$X2.add(v * cx);
    $238c42faf9d00fe9$var$Y2.add(v * cy);
    $238c42faf9d00fe9$var$Z2.add(v * cz);
    $238c42faf9d00fe9$var$W1 += w;
    $238c42faf9d00fe9$var$X1 += w * ($238c42faf9d00fe9$var$x0 + ($238c42faf9d00fe9$var$x0 = x));
    $238c42faf9d00fe9$var$Y1 += w * ($238c42faf9d00fe9$var$y0 + ($238c42faf9d00fe9$var$y0 = y));
    $238c42faf9d00fe9$var$Z1 += w * ($238c42faf9d00fe9$var$z0 + ($238c42faf9d00fe9$var$z0 = z));
    $238c42faf9d00fe9$var$centroidPointCartesian($238c42faf9d00fe9$var$x0, $238c42faf9d00fe9$var$y0, $238c42faf9d00fe9$var$z0);
}
function $238c42faf9d00fe9$export$2e2bcd8739ae039(object) {
    $238c42faf9d00fe9$var$W0 = $238c42faf9d00fe9$var$W1 = $238c42faf9d00fe9$var$X0 = $238c42faf9d00fe9$var$Y0 = $238c42faf9d00fe9$var$Z0 = $238c42faf9d00fe9$var$X1 = $238c42faf9d00fe9$var$Y1 = $238c42faf9d00fe9$var$Z1 = 0;
    $238c42faf9d00fe9$var$X2 = new (0, $fT5Bl.Adder)();
    $238c42faf9d00fe9$var$Y2 = new (0, $fT5Bl.Adder)();
    $238c42faf9d00fe9$var$Z2 = new (0, $fT5Bl.Adder)();
    (0, $bJwlW.default)(object, $238c42faf9d00fe9$var$centroidStream);
    var x = +$238c42faf9d00fe9$var$X2, y = +$238c42faf9d00fe9$var$Y2, z = +$238c42faf9d00fe9$var$Z2, m = (0, $gPo1b.hypot)(x, y, z);
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $gPo1b.epsilon2)) {
        x = $238c42faf9d00fe9$var$X1, y = $238c42faf9d00fe9$var$Y1, z = $238c42faf9d00fe9$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($238c42faf9d00fe9$var$W1 < (0, $gPo1b.epsilon)) x = $238c42faf9d00fe9$var$X0, y = $238c42faf9d00fe9$var$Y0, z = $238c42faf9d00fe9$var$Z0;
        m = (0, $gPo1b.hypot)(x, y, z);
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $gPo1b.epsilon2)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $gPo1b.atan2)(y, x) * (0, $gPo1b.degrees),
        (0, $gPo1b.asin)(z / m) * (0, $gPo1b.degrees)
    ];
}

});

parcelRegister("5iIVH", function(module, exports) {

$parcel$export(module.exports, "circleStream", function () { return $3dc17c424aa1e4de$export$b5441eb324cd8d4e; });
$parcel$export(module.exports, "default", function () { return $3dc17c424aa1e4de$export$2e2bcd8739ae039; });

var $duXPh = parcelRequire("duXPh");

var $lIpgy = parcelRequire("lIpgy");

var $gPo1b = parcelRequire("gPo1b");

var $6sZgy = parcelRequire("6sZgy");
function $3dc17c424aa1e4de$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $gPo1b.cos)(radius), sinRadius = (0, $gPo1b.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $gPo1b.tau);
        t1 = radius - step / 2;
    } else {
        t0 = $3dc17c424aa1e4de$var$circleRadius(cosRadius, t0);
        t1 = $3dc17c424aa1e4de$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $gPo1b.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $duXPh.spherical)([
            cosRadius,
            -sinRadius * (0, $gPo1b.cos)(t),
            -sinRadius * (0, $gPo1b.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $3dc17c424aa1e4de$var$circleRadius(cosRadius, point) {
    point = (0, $duXPh.cartesian)(point), point[0] -= cosRadius;
    (0, $duXPh.cartesianNormalizeInPlace)(point);
    var radius = (0, $gPo1b.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $gPo1b.tau) - (0, $gPo1b.epsilon)) % (0, $gPo1b.tau);
}
function $3dc17c424aa1e4de$export$2e2bcd8739ae039() {
    var center = (0, $lIpgy.default)([
        0,
        0
    ]), radius = (0, $lIpgy.default)(90), precision = (0, $lIpgy.default)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $gPo1b.degrees), x[1] *= (0, $gPo1b.degrees);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $gPo1b.radians), p = precision.apply(this, arguments) * (0, $gPo1b.radians);
        ring = [];
        rotate = (0, $6sZgy.rotateRadians)(-c[0] * (0, $gPo1b.radians), -c[1] * (0, $gPo1b.radians), 0).invert;
        $3dc17c424aa1e4de$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $lIpgy.default)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $lIpgy.default)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $lIpgy.default)(+_), circle) : precision;
    };
    return circle;
}

});
parcelRegister("lIpgy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0414687d5009cd9a$export$2e2bcd8739ae039; });
function $0414687d5009cd9a$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("6sZgy", function(module, exports) {

$parcel$export(module.exports, "rotateRadians", function () { return $4b54e1bb7e5ab852$export$a2ba89726971a90f; });
$parcel$export(module.exports, "default", function () { return $4b54e1bb7e5ab852$export$2e2bcd8739ae039; });

var $80D59 = parcelRequire("80D59");

var $gPo1b = parcelRequire("gPo1b");
function $4b54e1bb7e5ab852$var$rotationIdentity(lambda, phi) {
    if ((0, $gPo1b.abs)(lambda) > (0, $gPo1b.pi)) lambda -= Math.round(lambda / (0, $gPo1b.tau)) * (0, $gPo1b.tau);
    return [
        lambda,
        phi
    ];
}
$4b54e1bb7e5ab852$var$rotationIdentity.invert = $4b54e1bb7e5ab852$var$rotationIdentity;
function $4b54e1bb7e5ab852$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $gPo1b.tau)) ? deltaPhi || deltaGamma ? (0, $80D59.default)($4b54e1bb7e5ab852$var$rotationLambda(deltaLambda), $4b54e1bb7e5ab852$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $4b54e1bb7e5ab852$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $4b54e1bb7e5ab852$var$rotationPhiGamma(deltaPhi, deltaGamma) : $4b54e1bb7e5ab852$var$rotationIdentity;
}
function $4b54e1bb7e5ab852$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, $gPo1b.abs)(lambda) > (0, $gPo1b.pi)) lambda -= Math.round(lambda / (0, $gPo1b.tau)) * (0, $gPo1b.tau);
        return [
            lambda,
            phi
        ];
    };
}
function $4b54e1bb7e5ab852$var$rotationLambda(deltaLambda) {
    var rotation = $4b54e1bb7e5ab852$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $4b54e1bb7e5ab852$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $4b54e1bb7e5ab852$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $gPo1b.cos)(deltaPhi), sinDeltaPhi = (0, $gPo1b.sin)(deltaPhi), cosDeltaGamma = (0, $gPo1b.cos)(deltaGamma), sinDeltaGamma = (0, $gPo1b.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $gPo1b.cos)(phi), x = (0, $gPo1b.cos)(lambda) * cosPhi, y = (0, $gPo1b.sin)(lambda) * cosPhi, z = (0, $gPo1b.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $gPo1b.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $gPo1b.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $gPo1b.cos)(phi), x = (0, $gPo1b.cos)(lambda) * cosPhi, y = (0, $gPo1b.sin)(lambda) * cosPhi, z = (0, $gPo1b.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $gPo1b.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $gPo1b.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $4b54e1bb7e5ab852$export$2e2bcd8739ae039(rotate) {
    rotate = $4b54e1bb7e5ab852$export$a2ba89726971a90f(rotate[0] * (0, $gPo1b.radians), rotate[1] * (0, $gPo1b.radians), rotate.length > 2 ? rotate[2] * (0, $gPo1b.radians) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $gPo1b.radians), coordinates[1] * (0, $gPo1b.radians));
        return coordinates[0] *= (0, $gPo1b.degrees), coordinates[1] *= (0, $gPo1b.degrees), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $gPo1b.radians), coordinates[1] * (0, $gPo1b.radians));
        return coordinates[0] *= (0, $gPo1b.degrees), coordinates[1] *= (0, $gPo1b.degrees), coordinates;
    };
    return forward;
}

});
parcelRegister("80D59", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d4ca3b9263f1795$export$2e2bcd8739ae039; });
function $5d4ca3b9263f1795$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}

});



parcelRegister("i18v5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1dee9fb787f155d$export$2e2bcd8739ae039; });

var $5vOPP = parcelRequire("5vOPP");

var $gPo1b = parcelRequire("gPo1b");
var $d1dee9fb787f155d$export$2e2bcd8739ae039 = (0, $5vOPP.default)(function() {
    return true;
}, $d1dee9fb787f155d$var$clipAntimeridianLine, $d1dee9fb787f155d$var$clipAntimeridianInterpolate, [
    -(0, $gPo1b.pi),
    -(0, $gPo1b.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $d1dee9fb787f155d$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $gPo1b.pi) : -(0, $gPo1b.pi), delta = (0, $gPo1b.abs)(lambda1 - lambda0);
            if ((0, $gPo1b.abs)(delta - (0, $gPo1b.pi)) < (0, $gPo1b.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $gPo1b.halfPi) : -(0, $gPo1b.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $gPo1b.pi)) {
                if ((0, $gPo1b.abs)(lambda0 - sign0) < (0, $gPo1b.epsilon)) lambda0 -= sign0 * (0, $gPo1b.epsilon); // handle degeneracies
                if ((0, $gPo1b.abs)(lambda1 - sign1) < (0, $gPo1b.epsilon)) lambda1 -= sign1 * (0, $gPo1b.epsilon);
                phi0 = $d1dee9fb787f155d$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $d1dee9fb787f155d$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $gPo1b.sin)(lambda0 - lambda1);
    return (0, $gPo1b.abs)(sinLambda0Lambda1) > (0, $gPo1b.epsilon) ? (0, $gPo1b.atan)(((0, $gPo1b.sin)(phi0) * (cosPhi1 = (0, $gPo1b.cos)(phi1)) * (0, $gPo1b.sin)(lambda1) - (0, $gPo1b.sin)(phi1) * (cosPhi0 = (0, $gPo1b.cos)(phi0)) * (0, $gPo1b.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $d1dee9fb787f155d$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $gPo1b.halfPi);
        stream.point(-(0, $gPo1b.pi), phi);
        stream.point(0, phi);
        stream.point((0, $gPo1b.pi), phi);
        stream.point((0, $gPo1b.pi), 0);
        stream.point((0, $gPo1b.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $gPo1b.pi), -phi);
        stream.point(-(0, $gPo1b.pi), 0);
        stream.point(-(0, $gPo1b.pi), phi);
    } else if ((0, $gPo1b.abs)(from[0] - to[0]) > (0, $gPo1b.epsilon)) {
        var lambda = from[0] < to[0] ? (0, $gPo1b.pi) : -(0, $gPo1b.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

});
parcelRegister("5vOPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $403747c779cafa0a$export$2e2bcd8739ae039; });

var $g6tnI = parcelRequire("g6tnI");

var $aRgZc = parcelRequire("aRgZc");

var $gPo1b = parcelRequire("gPo1b");

var $a5K8H = parcelRequire("a5K8H");

var $4AHKb = parcelRequire("4AHKb");
function $403747c779cafa0a$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $g6tnI.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $4AHKb.default)(segments);
                var startInside = (0, $a5K8H.default)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $aRgZc.default)(segments, $403747c779cafa0a$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($403747c779cafa0a$var$validSegment));
        }
        return clip;
    };
}
function $403747c779cafa0a$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $403747c779cafa0a$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $gPo1b.halfPi) - (0, $gPo1b.epsilon) : (0, $gPo1b.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $gPo1b.halfPi) - (0, $gPo1b.epsilon) : (0, $gPo1b.halfPi) - b[1]);
}

});
parcelRegister("g6tnI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb93ff70a57a5791$export$2e2bcd8739ae039; });

var $jqvlO = parcelRequire("jqvlO");
function $bb93ff70a57a5791$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $jqvlO.default),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}

});

parcelRegister("aRgZc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e7c07b1eb995aae$export$2e2bcd8739ae039; });

var $6Luej = parcelRequire("6Luej");

var $gPo1b = parcelRequire("gPo1b");
function $7e7c07b1eb995aae$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $7e7c07b1eb995aae$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $6Luej.default)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $gPo1b.epsilon);
        }
        subject.push(x = new $7e7c07b1eb995aae$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $7e7c07b1eb995aae$var$Intersection(p0, null, x, false));
        subject.push(x = new $7e7c07b1eb995aae$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $7e7c07b1eb995aae$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $7e7c07b1eb995aae$var$link(subject);
    $7e7c07b1eb995aae$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $7e7c07b1eb995aae$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

});
parcelRegister("6Luej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ece94e0f7592bf2$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");
function $4ece94e0f7592bf2$export$2e2bcd8739ae039(a, b) {
    return (0, $gPo1b.abs)(a[0] - b[0]) < (0, $gPo1b.epsilon) && (0, $gPo1b.abs)(a[1] - b[1]) < (0, $gPo1b.epsilon);
}

});


parcelRegister("a5K8H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $758e295383e3a824$export$2e2bcd8739ae039; });

var $fT5Bl = parcelRequire("fT5Bl");

var $duXPh = parcelRequire("duXPh");

var $gPo1b = parcelRequire("gPo1b");
function $758e295383e3a824$var$longitude(point) {
    return (0, $gPo1b.abs)(point[0]) <= (0, $gPo1b.pi) ? point[0] : (0, $gPo1b.sign)(point[0]) * (((0, $gPo1b.abs)(point[0]) + (0, $gPo1b.pi)) % (0, $gPo1b.tau) - (0, $gPo1b.pi));
}
function $758e295383e3a824$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $758e295383e3a824$var$longitude(point), phi = point[1], sinPhi = (0, $gPo1b.sin)(phi), normal = [
        (0, $gPo1b.sin)(lambda),
        -(0, $gPo1b.cos)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $fT5Bl.Adder)();
    if (sinPhi === 1) phi = (0, $gPo1b.halfPi) + (0, $gPo1b.epsilon);
    else if (sinPhi === -1) phi = -(0, $gPo1b.halfPi) - (0, $gPo1b.epsilon);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $758e295383e3a824$var$longitude(point0), phi0 = point0[1] / 2 + (0, $gPo1b.quarterPi), sinPhi0 = (0, $gPo1b.sin)(phi0), cosPhi0 = (0, $gPo1b.cos)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $758e295383e3a824$var$longitude(point1), phi1 = point1[1] / 2 + (0, $gPo1b.quarterPi), sinPhi1 = (0, $gPo1b.sin)(phi1), cosPhi1 = (0, $gPo1b.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $gPo1b.pi), k = sinPhi0 * sinPhi1;
            sum.add((0, $gPo1b.atan2)(k * sign * (0, $gPo1b.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, $gPo1b.cos)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $gPo1b.tau) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $duXPh.cartesianCross)((0, $duXPh.cartesian)(point0), (0, $duXPh.cartesian)(point1));
                (0, $duXPh.cartesianNormalizeInPlace)(arc);
                var intersection = (0, $duXPh.cartesianCross)(normal, arc);
                (0, $duXPh.cartesianNormalizeInPlace)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $gPo1b.asin)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $gPo1b.epsilon) || angle < (0, $gPo1b.epsilon) && sum < -(0, $gPo1b.epsilon2)) ^ winding & 1;
}

});



parcelRegister("hVPK1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0dfe545d03f8d25$export$2e2bcd8739ae039; });

var $duXPh = parcelRequire("duXPh");

var $5iIVH = parcelRequire("5iIVH");

var $gPo1b = parcelRequire("gPo1b");

var $6Luej = parcelRequire("6Luej");

var $5vOPP = parcelRequire("5vOPP");
function $d0dfe545d03f8d25$export$2e2bcd8739ae039(radius) {
    var cr = (0, $gPo1b.cos)(radius), delta = 6 * (0, $gPo1b.radians), smallRadius = cr > 0, notHemisphere = (0, $gPo1b.abs)(cr) > (0, $gPo1b.epsilon); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $5iIVH.circleStream)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $gPo1b.cos)(lambda) * (0, $gPo1b.cos)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $gPo1b.pi) : -(0, $gPo1b.pi)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $6Luej.default)(point0, point2) || (0, $6Luej.default)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $6Luej.default)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $duXPh.cartesian)(a), pb = (0, $duXPh.cartesian)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $duXPh.cartesianCross)(pa, pb), n2n2 = (0, $duXPh.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $duXPh.cartesianCross)(n1, n2), A = (0, $duXPh.cartesianScale)(n1, c1), B = (0, $duXPh.cartesianScale)(n2, c2);
        (0, $duXPh.cartesianAddInPlace)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $duXPh.cartesianDot)(A, u), uu = (0, $duXPh.cartesianDot)(u, u), t2 = w * w - uu * ((0, $duXPh.cartesianDot)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $gPo1b.sqrt)(t2), q = (0, $duXPh.cartesianScale)(u, (-w - t) / uu);
        (0, $duXPh.cartesianAddInPlace)(q, A);
        q = (0, $duXPh.spherical)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $gPo1b.abs)(delta - (0, $gPo1b.pi)) < (0, $gPo1b.epsilon), meridian = polar || delta < (0, $gPo1b.epsilon);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $gPo1b.abs)(q[0] - lambda0) < (0, $gPo1b.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $gPo1b.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $duXPh.cartesianScale)(u, (-w + t) / uu);
            (0, $duXPh.cartesianAddInPlace)(q1, A);
            return [
                q,
                (0, $duXPh.spherical)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $gPo1b.pi) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $5vOPP.default)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $gPo1b.pi),
        radius - (0, $gPo1b.pi)
    ]);
}

});

parcelRegister("kuFIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeb6f7fc19fae448$export$2e2bcd8739ae039; });

var $7aYGE = parcelRequire("7aYGE");
function $eeb6f7fc19fae448$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $7aYGE.default)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}

});
parcelRegister("7aYGE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53988abdcd3b1f2a$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $g6tnI = parcelRequire("g6tnI");

var $5VXhK = parcelRequire("5VXhK");

var $aRgZc = parcelRequire("aRgZc");

var $4AHKb = parcelRequire("4AHKb");
var $53988abdcd3b1f2a$var$clipMax = 1e9, $53988abdcd3b1f2a$var$clipMin = -$53988abdcd3b1f2a$var$clipMax;
function $53988abdcd3b1f2a$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $gPo1b.abs)(p[0] - x0) < (0, $gPo1b.epsilon) ? direction > 0 ? 0 : 3 : (0, $gPo1b.abs)(p[0] - x1) < (0, $gPo1b.epsilon) ? direction > 0 ? 2 : 1 : (0, $gPo1b.abs)(p[1] - y0) < (0, $gPo1b.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $g6tnI.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $4AHKb.default)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $aRgZc.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($53988abdcd3b1f2a$var$clipMin, Math.min($53988abdcd3b1f2a$var$clipMax, x_)),
                    y_ = Math.max($53988abdcd3b1f2a$var$clipMin, Math.min($53988abdcd3b1f2a$var$clipMax, y_))
                ], b = [
                    x = Math.max($53988abdcd3b1f2a$var$clipMin, Math.min($53988abdcd3b1f2a$var$clipMax, x)),
                    y = Math.max($53988abdcd3b1f2a$var$clipMin, Math.min($53988abdcd3b1f2a$var$clipMax, y))
                ];
                if ((0, $5VXhK.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

});
parcelRegister("5VXhK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45204374734a4bf7$export$2e2bcd8739ae039; });
function $45204374734a4bf7$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}

});



parcelRegister("eJGs0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aba6327bfe393218$export$2e2bcd8739ae039; });

var $a5K8H = parcelRequire("a5K8H");

var $3dQ40 = parcelRequire("3dQ40");

var $gPo1b = parcelRequire("gPo1b");
var $aba6327bfe393218$var$containsObjectType = {
    Feature: function(object, point) {
        return $aba6327bfe393218$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($aba6327bfe393218$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $aba6327bfe393218$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $aba6327bfe393218$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($aba6327bfe393218$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $aba6327bfe393218$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($aba6327bfe393218$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $aba6327bfe393218$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($aba6327bfe393218$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($aba6327bfe393218$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $aba6327bfe393218$var$containsGeometry(geometry, point) {
    return geometry && $aba6327bfe393218$var$containsGeometryType.hasOwnProperty(geometry.type) ? $aba6327bfe393218$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $aba6327bfe393218$var$containsPoint(coordinates, point) {
    return (0, $3dQ40.default)(coordinates, point) === 0;
}
function $aba6327bfe393218$var$containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, $3dQ40.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, $3dQ40.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, $gPo1b.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function $aba6327bfe393218$var$containsPolygon(coordinates, point) {
    return !!(0, $a5K8H.default)(coordinates.map($aba6327bfe393218$var$ringRadians), $aba6327bfe393218$var$pointRadians(point));
}
function $aba6327bfe393218$var$ringRadians(ring) {
    return ring = ring.map($aba6327bfe393218$var$pointRadians), ring.pop(), ring;
}
function $aba6327bfe393218$var$pointRadians(point) {
    return [
        point[0] * (0, $gPo1b.radians),
        point[1] * (0, $gPo1b.radians)
    ];
}
function $aba6327bfe393218$export$2e2bcd8739ae039(object, point) {
    return (object && $aba6327bfe393218$var$containsObjectType.hasOwnProperty(object.type) ? $aba6327bfe393218$var$containsObjectType[object.type] : $aba6327bfe393218$var$containsGeometry)(object, point);
}

});
parcelRegister("3dQ40", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $258af8b858ef5716$export$2e2bcd8739ae039; });

var $arJ4z = parcelRequire("arJ4z");
var $258af8b858ef5716$var$coordinates = [
    null,
    null
], $258af8b858ef5716$var$object = {
    type: "LineString",
    coordinates: $258af8b858ef5716$var$coordinates
};
function $258af8b858ef5716$export$2e2bcd8739ae039(a, b) {
    $258af8b858ef5716$var$coordinates[0] = a;
    $258af8b858ef5716$var$coordinates[1] = b;
    return (0, $arJ4z.default)($258af8b858ef5716$var$object);
}

});
parcelRegister("arJ4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79af638022774818$export$2e2bcd8739ae039; });

var $fT5Bl = parcelRequire("fT5Bl");

var $gPo1b = parcelRequire("gPo1b");

var $jqvlO = parcelRequire("jqvlO");

var $bJwlW = parcelRequire("bJwlW");
var $79af638022774818$var$lengthSum, $79af638022774818$var$lambda0, $79af638022774818$var$sinPhi0, $79af638022774818$var$cosPhi0;
var $79af638022774818$var$lengthStream = {
    sphere: (0, $jqvlO.default),
    point: (0, $jqvlO.default),
    lineStart: $79af638022774818$var$lengthLineStart,
    lineEnd: (0, $jqvlO.default),
    polygonStart: (0, $jqvlO.default),
    polygonEnd: (0, $jqvlO.default)
};
function $79af638022774818$var$lengthLineStart() {
    $79af638022774818$var$lengthStream.point = $79af638022774818$var$lengthPointFirst;
    $79af638022774818$var$lengthStream.lineEnd = $79af638022774818$var$lengthLineEnd;
}
function $79af638022774818$var$lengthLineEnd() {
    $79af638022774818$var$lengthStream.point = $79af638022774818$var$lengthStream.lineEnd = (0, $jqvlO.default);
}
function $79af638022774818$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    $79af638022774818$var$lambda0 = lambda, $79af638022774818$var$sinPhi0 = (0, $gPo1b.sin)(phi), $79af638022774818$var$cosPhi0 = (0, $gPo1b.cos)(phi);
    $79af638022774818$var$lengthStream.point = $79af638022774818$var$lengthPoint;
}
function $79af638022774818$var$lengthPoint(lambda, phi) {
    lambda *= (0, $gPo1b.radians), phi *= (0, $gPo1b.radians);
    var sinPhi = (0, $gPo1b.sin)(phi), cosPhi = (0, $gPo1b.cos)(phi), delta = (0, $gPo1b.abs)(lambda - $79af638022774818$var$lambda0), cosDelta = (0, $gPo1b.cos)(delta), sinDelta = (0, $gPo1b.sin)(delta), x = cosPhi * sinDelta, y = $79af638022774818$var$cosPhi0 * sinPhi - $79af638022774818$var$sinPhi0 * cosPhi * cosDelta, z = $79af638022774818$var$sinPhi0 * sinPhi + $79af638022774818$var$cosPhi0 * cosPhi * cosDelta;
    $79af638022774818$var$lengthSum.add((0, $gPo1b.atan2)((0, $gPo1b.sqrt)(x * x + y * y), z));
    $79af638022774818$var$lambda0 = lambda, $79af638022774818$var$sinPhi0 = sinPhi, $79af638022774818$var$cosPhi0 = cosPhi;
}
function $79af638022774818$export$2e2bcd8739ae039(object) {
    $79af638022774818$var$lengthSum = new (0, $fT5Bl.Adder)();
    (0, $bJwlW.default)(object, $79af638022774818$var$lengthStream);
    return +$79af638022774818$var$lengthSum;
}

});



parcelRegister("3KaUJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9e2249030e075c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "graticule10", function () { return $2b9e2249030e075c$export$b8db4e9403a5b6f1; });

var $6jvVk = parcelRequire("6jvVk");

var $gPo1b = parcelRequire("gPo1b");
function $2b9e2249030e075c$var$graticuleX(y0, y1, dy) {
    var y = (0, $6jvVk.default)(y0, y1 - (0, $gPo1b.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $2b9e2249030e075c$var$graticuleY(x0, x1, dx) {
    var x = (0, $6jvVk.default)(x0, x1 - (0, $gPo1b.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $2b9e2249030e075c$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $6jvVk.default)((0, $gPo1b.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, $6jvVk.default)((0, $gPo1b.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $6jvVk.default)((0, $gPo1b.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $gPo1b.abs)(x % DX) > (0, $gPo1b.epsilon);
        }).map(x)).concat((0, $6jvVk.default)((0, $gPo1b.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $gPo1b.abs)(y % DY) > (0, $gPo1b.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $2b9e2249030e075c$var$graticuleX(y0, y1, 90);
        y = $2b9e2249030e075c$var$graticuleY(x0, x1, precision);
        X = $2b9e2249030e075c$var$graticuleX(Y0, Y1, 90);
        Y = $2b9e2249030e075c$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $gPo1b.epsilon)
        ],
        [
            180,
            90 - (0, $gPo1b.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $gPo1b.epsilon)
        ],
        [
            180,
            80 + (0, $gPo1b.epsilon)
        ]
    ]);
}
function $2b9e2249030e075c$export$b8db4e9403a5b6f1() {
    return $2b9e2249030e075c$export$2e2bcd8739ae039()();
}

});

parcelRegister("79oDe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534c7b08086d3d5f$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");
function $534c7b08086d3d5f$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $gPo1b.radians), y0 = a[1] * (0, $gPo1b.radians), x1 = b[0] * (0, $gPo1b.radians), y1 = b[1] * (0, $gPo1b.radians), cy0 = (0, $gPo1b.cos)(y0), sy0 = (0, $gPo1b.sin)(y0), cy1 = (0, $gPo1b.cos)(y1), sy1 = (0, $gPo1b.sin)(y1), kx0 = cy0 * (0, $gPo1b.cos)(x0), ky0 = cy0 * (0, $gPo1b.sin)(x0), kx1 = cy1 * (0, $gPo1b.cos)(x1), ky1 = cy1 * (0, $gPo1b.sin)(x1), d = 2 * (0, $gPo1b.asin)((0, $gPo1b.sqrt)((0, $gPo1b.haversin)(y1 - y0) + cy0 * cy1 * (0, $gPo1b.haversin)(x1 - x0))), k = (0, $gPo1b.sin)(d);
    var interpolate = d ? function(t) {
        var B = (0, $gPo1b.sin)(t *= d) / k, A = (0, $gPo1b.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $gPo1b.atan2)(y, x) * (0, $gPo1b.degrees),
            (0, $gPo1b.atan2)(z, (0, $gPo1b.sqrt)(x * x + y * y)) * (0, $gPo1b.degrees)
        ];
    } : function() {
        return [
            x0 * (0, $gPo1b.degrees),
            y0 * (0, $gPo1b.degrees)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}

});

parcelRegister("9QR7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72c22e41d92f74b3$export$2e2bcd8739ae039; });

var $gwqqd = parcelRequire("gwqqd");

var $bJwlW = parcelRequire("bJwlW");

var $c3rbG = parcelRequire("c3rbG");

var $kEnSA = parcelRequire("kEnSA");

var $7I5PY = parcelRequire("7I5PY");

var $7A40Q = parcelRequire("7A40Q");

var $23Nxw = parcelRequire("23Nxw");

var $friPy = parcelRequire("friPy");
function $72c22e41d92f74b3$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $bJwlW.default)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $bJwlW.default)(object, projectionStream((0, $c3rbG.default)));
        return (0, $c3rbG.default).result();
    };
    path.measure = function(object) {
        (0, $bJwlW.default)(object, projectionStream((0, $23Nxw.default)));
        return (0, $23Nxw.default).result();
    };
    path.bounds = function(object) {
        (0, $bJwlW.default)(object, projectionStream((0, $kEnSA.default)));
        return (0, $kEnSA.default).result();
    };
    path.centroid = function(object) {
        (0, $bJwlW.default)(object, projectionStream((0, $7I5PY.default)));
        return (0, $7I5PY.default).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $gwqqd.default) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $friPy.default)(digits)) : new (0, $7A40Q.default)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $friPy.default)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}

});
parcelRegister("gwqqd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c074214e0fb6aad1$export$2e2bcd8739ae039; });
var $c074214e0fb6aad1$export$2e2bcd8739ae039 = (x)=>x;

});

parcelRegister("c3rbG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c6adab84f87ac5f$export$2e2bcd8739ae039; });

var $fT5Bl = parcelRequire("fT5Bl");

var $gPo1b = parcelRequire("gPo1b");

var $jqvlO = parcelRequire("jqvlO");
var $8c6adab84f87ac5f$var$areaSum = new (0, $fT5Bl.Adder)(), $8c6adab84f87ac5f$var$areaRingSum = new (0, $fT5Bl.Adder)(), $8c6adab84f87ac5f$var$x00, $8c6adab84f87ac5f$var$y00, $8c6adab84f87ac5f$var$x0, $8c6adab84f87ac5f$var$y0;
var $8c6adab84f87ac5f$var$areaStream = {
    point: (0, $jqvlO.default),
    lineStart: (0, $jqvlO.default),
    lineEnd: (0, $jqvlO.default),
    polygonStart: function() {
        $8c6adab84f87ac5f$var$areaStream.lineStart = $8c6adab84f87ac5f$var$areaRingStart;
        $8c6adab84f87ac5f$var$areaStream.lineEnd = $8c6adab84f87ac5f$var$areaRingEnd;
    },
    polygonEnd: function() {
        $8c6adab84f87ac5f$var$areaStream.lineStart = $8c6adab84f87ac5f$var$areaStream.lineEnd = $8c6adab84f87ac5f$var$areaStream.point = (0, $jqvlO.default);
        $8c6adab84f87ac5f$var$areaSum.add((0, $gPo1b.abs)($8c6adab84f87ac5f$var$areaRingSum));
        $8c6adab84f87ac5f$var$areaRingSum = new (0, $fT5Bl.Adder)();
    },
    result: function() {
        var area = $8c6adab84f87ac5f$var$areaSum / 2;
        $8c6adab84f87ac5f$var$areaSum = new (0, $fT5Bl.Adder)();
        return area;
    }
};
function $8c6adab84f87ac5f$var$areaRingStart() {
    $8c6adab84f87ac5f$var$areaStream.point = $8c6adab84f87ac5f$var$areaPointFirst;
}
function $8c6adab84f87ac5f$var$areaPointFirst(x, y) {
    $8c6adab84f87ac5f$var$areaStream.point = $8c6adab84f87ac5f$var$areaPoint;
    $8c6adab84f87ac5f$var$x00 = $8c6adab84f87ac5f$var$x0 = x, $8c6adab84f87ac5f$var$y00 = $8c6adab84f87ac5f$var$y0 = y;
}
function $8c6adab84f87ac5f$var$areaPoint(x, y) {
    $8c6adab84f87ac5f$var$areaRingSum.add($8c6adab84f87ac5f$var$y0 * x - $8c6adab84f87ac5f$var$x0 * y);
    $8c6adab84f87ac5f$var$x0 = x, $8c6adab84f87ac5f$var$y0 = y;
}
function $8c6adab84f87ac5f$var$areaRingEnd() {
    $8c6adab84f87ac5f$var$areaPoint($8c6adab84f87ac5f$var$x00, $8c6adab84f87ac5f$var$y00);
}
var $8c6adab84f87ac5f$export$2e2bcd8739ae039 = $8c6adab84f87ac5f$var$areaStream;

});

parcelRegister("kEnSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f08a11043b42db2f$export$2e2bcd8739ae039; });

var $jqvlO = parcelRequire("jqvlO");
var $f08a11043b42db2f$var$x0 = Infinity, $f08a11043b42db2f$var$y0 = $f08a11043b42db2f$var$x0, $f08a11043b42db2f$var$x1 = -$f08a11043b42db2f$var$x0, $f08a11043b42db2f$var$y1 = $f08a11043b42db2f$var$x1;
var $f08a11043b42db2f$var$boundsStream = {
    point: $f08a11043b42db2f$var$boundsPoint,
    lineStart: (0, $jqvlO.default),
    lineEnd: (0, $jqvlO.default),
    polygonStart: (0, $jqvlO.default),
    polygonEnd: (0, $jqvlO.default),
    result: function() {
        var bounds = [
            [
                $f08a11043b42db2f$var$x0,
                $f08a11043b42db2f$var$y0
            ],
            [
                $f08a11043b42db2f$var$x1,
                $f08a11043b42db2f$var$y1
            ]
        ];
        $f08a11043b42db2f$var$x1 = $f08a11043b42db2f$var$y1 = -($f08a11043b42db2f$var$y0 = $f08a11043b42db2f$var$x0 = Infinity);
        return bounds;
    }
};
function $f08a11043b42db2f$var$boundsPoint(x, y) {
    if (x < $f08a11043b42db2f$var$x0) $f08a11043b42db2f$var$x0 = x;
    if (x > $f08a11043b42db2f$var$x1) $f08a11043b42db2f$var$x1 = x;
    if (y < $f08a11043b42db2f$var$y0) $f08a11043b42db2f$var$y0 = y;
    if (y > $f08a11043b42db2f$var$y1) $f08a11043b42db2f$var$y1 = y;
}
var $f08a11043b42db2f$export$2e2bcd8739ae039 = $f08a11043b42db2f$var$boundsStream;

});

parcelRegister("7I5PY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59d12ba4e39c0499$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");
// TODO Enforce positive area for exterior, negative area for interior?
var $59d12ba4e39c0499$var$X0 = 0, $59d12ba4e39c0499$var$Y0 = 0, $59d12ba4e39c0499$var$Z0 = 0, $59d12ba4e39c0499$var$X1 = 0, $59d12ba4e39c0499$var$Y1 = 0, $59d12ba4e39c0499$var$Z1 = 0, $59d12ba4e39c0499$var$X2 = 0, $59d12ba4e39c0499$var$Y2 = 0, $59d12ba4e39c0499$var$Z2 = 0, $59d12ba4e39c0499$var$x00, $59d12ba4e39c0499$var$y00, $59d12ba4e39c0499$var$x0, $59d12ba4e39c0499$var$y0;
var $59d12ba4e39c0499$var$centroidStream = {
    point: $59d12ba4e39c0499$var$centroidPoint,
    lineStart: $59d12ba4e39c0499$var$centroidLineStart,
    lineEnd: $59d12ba4e39c0499$var$centroidLineEnd,
    polygonStart: function() {
        $59d12ba4e39c0499$var$centroidStream.lineStart = $59d12ba4e39c0499$var$centroidRingStart;
        $59d12ba4e39c0499$var$centroidStream.lineEnd = $59d12ba4e39c0499$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $59d12ba4e39c0499$var$centroidStream.point = $59d12ba4e39c0499$var$centroidPoint;
        $59d12ba4e39c0499$var$centroidStream.lineStart = $59d12ba4e39c0499$var$centroidLineStart;
        $59d12ba4e39c0499$var$centroidStream.lineEnd = $59d12ba4e39c0499$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $59d12ba4e39c0499$var$Z2 ? [
            $59d12ba4e39c0499$var$X2 / $59d12ba4e39c0499$var$Z2,
            $59d12ba4e39c0499$var$Y2 / $59d12ba4e39c0499$var$Z2
        ] : $59d12ba4e39c0499$var$Z1 ? [
            $59d12ba4e39c0499$var$X1 / $59d12ba4e39c0499$var$Z1,
            $59d12ba4e39c0499$var$Y1 / $59d12ba4e39c0499$var$Z1
        ] : $59d12ba4e39c0499$var$Z0 ? [
            $59d12ba4e39c0499$var$X0 / $59d12ba4e39c0499$var$Z0,
            $59d12ba4e39c0499$var$Y0 / $59d12ba4e39c0499$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $59d12ba4e39c0499$var$X0 = $59d12ba4e39c0499$var$Y0 = $59d12ba4e39c0499$var$Z0 = $59d12ba4e39c0499$var$X1 = $59d12ba4e39c0499$var$Y1 = $59d12ba4e39c0499$var$Z1 = $59d12ba4e39c0499$var$X2 = $59d12ba4e39c0499$var$Y2 = $59d12ba4e39c0499$var$Z2 = 0;
        return centroid;
    }
};
function $59d12ba4e39c0499$var$centroidPoint(x, y) {
    $59d12ba4e39c0499$var$X0 += x;
    $59d12ba4e39c0499$var$Y0 += y;
    ++$59d12ba4e39c0499$var$Z0;
}
function $59d12ba4e39c0499$var$centroidLineStart() {
    $59d12ba4e39c0499$var$centroidStream.point = $59d12ba4e39c0499$var$centroidPointFirstLine;
}
function $59d12ba4e39c0499$var$centroidPointFirstLine(x, y) {
    $59d12ba4e39c0499$var$centroidStream.point = $59d12ba4e39c0499$var$centroidPointLine;
    $59d12ba4e39c0499$var$centroidPoint($59d12ba4e39c0499$var$x0 = x, $59d12ba4e39c0499$var$y0 = y);
}
function $59d12ba4e39c0499$var$centroidPointLine(x, y) {
    var dx = x - $59d12ba4e39c0499$var$x0, dy = y - $59d12ba4e39c0499$var$y0, z = (0, $gPo1b.sqrt)(dx * dx + dy * dy);
    $59d12ba4e39c0499$var$X1 += z * ($59d12ba4e39c0499$var$x0 + x) / 2;
    $59d12ba4e39c0499$var$Y1 += z * ($59d12ba4e39c0499$var$y0 + y) / 2;
    $59d12ba4e39c0499$var$Z1 += z;
    $59d12ba4e39c0499$var$centroidPoint($59d12ba4e39c0499$var$x0 = x, $59d12ba4e39c0499$var$y0 = y);
}
function $59d12ba4e39c0499$var$centroidLineEnd() {
    $59d12ba4e39c0499$var$centroidStream.point = $59d12ba4e39c0499$var$centroidPoint;
}
function $59d12ba4e39c0499$var$centroidRingStart() {
    $59d12ba4e39c0499$var$centroidStream.point = $59d12ba4e39c0499$var$centroidPointFirstRing;
}
function $59d12ba4e39c0499$var$centroidRingEnd() {
    $59d12ba4e39c0499$var$centroidPointRing($59d12ba4e39c0499$var$x00, $59d12ba4e39c0499$var$y00);
}
function $59d12ba4e39c0499$var$centroidPointFirstRing(x, y) {
    $59d12ba4e39c0499$var$centroidStream.point = $59d12ba4e39c0499$var$centroidPointRing;
    $59d12ba4e39c0499$var$centroidPoint($59d12ba4e39c0499$var$x00 = $59d12ba4e39c0499$var$x0 = x, $59d12ba4e39c0499$var$y00 = $59d12ba4e39c0499$var$y0 = y);
}
function $59d12ba4e39c0499$var$centroidPointRing(x, y) {
    var dx = x - $59d12ba4e39c0499$var$x0, dy = y - $59d12ba4e39c0499$var$y0, z = (0, $gPo1b.sqrt)(dx * dx + dy * dy);
    $59d12ba4e39c0499$var$X1 += z * ($59d12ba4e39c0499$var$x0 + x) / 2;
    $59d12ba4e39c0499$var$Y1 += z * ($59d12ba4e39c0499$var$y0 + y) / 2;
    $59d12ba4e39c0499$var$Z1 += z;
    z = $59d12ba4e39c0499$var$y0 * x - $59d12ba4e39c0499$var$x0 * y;
    $59d12ba4e39c0499$var$X2 += z * ($59d12ba4e39c0499$var$x0 + x);
    $59d12ba4e39c0499$var$Y2 += z * ($59d12ba4e39c0499$var$y0 + y);
    $59d12ba4e39c0499$var$Z2 += z * 3;
    $59d12ba4e39c0499$var$centroidPoint($59d12ba4e39c0499$var$x0 = x, $59d12ba4e39c0499$var$y0 = y);
}
var $59d12ba4e39c0499$export$2e2bcd8739ae039 = $59d12ba4e39c0499$var$centroidStream;

});

parcelRegister("7A40Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $584f02078a02f724$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $jqvlO = parcelRequire("jqvlO");
function $584f02078a02f724$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$584f02078a02f724$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $gPo1b.tau));
                break;
        }
    },
    result: (0, $jqvlO.default)
};

});

parcelRegister("23Nxw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18024a221d3b61ec$export$2e2bcd8739ae039; });

var $fT5Bl = parcelRequire("fT5Bl");

var $gPo1b = parcelRequire("gPo1b");

var $jqvlO = parcelRequire("jqvlO");
var $18024a221d3b61ec$var$lengthSum = new (0, $fT5Bl.Adder)(), $18024a221d3b61ec$var$lengthRing, $18024a221d3b61ec$var$x00, $18024a221d3b61ec$var$y00, $18024a221d3b61ec$var$x0, $18024a221d3b61ec$var$y0;
var $18024a221d3b61ec$var$lengthStream = {
    point: (0, $jqvlO.default),
    lineStart: function() {
        $18024a221d3b61ec$var$lengthStream.point = $18024a221d3b61ec$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($18024a221d3b61ec$var$lengthRing) $18024a221d3b61ec$var$lengthPoint($18024a221d3b61ec$var$x00, $18024a221d3b61ec$var$y00);
        $18024a221d3b61ec$var$lengthStream.point = (0, $jqvlO.default);
    },
    polygonStart: function() {
        $18024a221d3b61ec$var$lengthRing = true;
    },
    polygonEnd: function() {
        $18024a221d3b61ec$var$lengthRing = null;
    },
    result: function() {
        var length = +$18024a221d3b61ec$var$lengthSum;
        $18024a221d3b61ec$var$lengthSum = new (0, $fT5Bl.Adder)();
        return length;
    }
};
function $18024a221d3b61ec$var$lengthPointFirst(x, y) {
    $18024a221d3b61ec$var$lengthStream.point = $18024a221d3b61ec$var$lengthPoint;
    $18024a221d3b61ec$var$x00 = $18024a221d3b61ec$var$x0 = x, $18024a221d3b61ec$var$y00 = $18024a221d3b61ec$var$y0 = y;
}
function $18024a221d3b61ec$var$lengthPoint(x, y) {
    $18024a221d3b61ec$var$x0 -= x, $18024a221d3b61ec$var$y0 -= y;
    $18024a221d3b61ec$var$lengthSum.add((0, $gPo1b.sqrt)($18024a221d3b61ec$var$x0 * $18024a221d3b61ec$var$x0 + $18024a221d3b61ec$var$y0 * $18024a221d3b61ec$var$y0));
    $18024a221d3b61ec$var$x0 = x, $18024a221d3b61ec$var$y0 = y;
}
var $18024a221d3b61ec$export$2e2bcd8739ae039 = $18024a221d3b61ec$var$lengthStream;

});

parcelRegister("friPy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d7fc0045c02dc3$export$2e2bcd8739ae039; });
// Simple caching for constant-radius points.
let $b3d7fc0045c02dc3$var$_ = (t)=>t, $b3d7fc0045c02dc3$var$t, $b3d7fc0045c02dc3$var$t1, $b3d7fc0045c02dc3$var$t2, $b3d7fc0045c02dc3$var$t3;
let $b3d7fc0045c02dc3$var$cacheDigits, $b3d7fc0045c02dc3$var$cacheAppend, $b3d7fc0045c02dc3$var$cacheRadius, $b3d7fc0045c02dc3$var$cacheCircle;
class $b3d7fc0045c02dc3$export$2e2bcd8739ae039 {
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append($b3d7fc0045c02dc3$var$t || ($b3d7fc0045c02dc3$var$t = $b3d7fc0045c02dc3$var$_`M${0},${0}`), x, y);
                this._point = 1;
                break;
            case 1:
                this._append($b3d7fc0045c02dc3$var$t1 || ($b3d7fc0045c02dc3$var$t1 = $b3d7fc0045c02dc3$var$_`L${0},${0}`), x, y);
                break;
            default:
                this._append($b3d7fc0045c02dc3$var$t2 || ($b3d7fc0045c02dc3$var$t2 = $b3d7fc0045c02dc3$var$_`M${0},${0}`), x, y);
                if (this._radius !== $b3d7fc0045c02dc3$var$cacheRadius || this._append !== $b3d7fc0045c02dc3$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append($b3d7fc0045c02dc3$var$t3 || ($b3d7fc0045c02dc3$var$t3 = $b3d7fc0045c02dc3$var$_`m0,${0}a${0},${0} 0 1,1 0,${0}a${0},${0} 0 1,1 0,${0}z`), r, r, r, -2 * r, r, r, 2 * r);
                    $b3d7fc0045c02dc3$var$cacheRadius = r;
                    $b3d7fc0045c02dc3$var$cacheAppend = this._append;
                    $b3d7fc0045c02dc3$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $b3d7fc0045c02dc3$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
    constructor(digits){
        this._append = digits == null ? $b3d7fc0045c02dc3$var$append : $b3d7fc0045c02dc3$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
}
function $b3d7fc0045c02dc3$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $b3d7fc0045c02dc3$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $b3d7fc0045c02dc3$var$append;
    if (d !== $b3d7fc0045c02dc3$var$cacheDigits) {
        const k = 10 ** d;
        $b3d7fc0045c02dc3$var$cacheDigits = d;
        $b3d7fc0045c02dc3$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $b3d7fc0045c02dc3$var$cacheAppend;
}

});


parcelRegister("4CjlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35c9b86b04b760e2$export$2e2bcd8739ae039; });

var $e5xCI = parcelRequire("e5xCI");
function $35c9b86b04b760e2$export$2e2bcd8739ae039() {
    return (0, $e5xCI.default)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}

});
parcelRegister("e5xCI", function(module, exports) {

$parcel$export(module.exports, "conicEqualAreaRaw", function () { return $a41b9d3aa8ed03c9$export$75409dad1c406288; });
$parcel$export(module.exports, "default", function () { return $a41b9d3aa8ed03c9$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $5D9es = parcelRequire("5D9es");

var $hhzxP = parcelRequire("hhzxP");
function $a41b9d3aa8ed03c9$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $gPo1b.sin)(y0), n = (sy0 + (0, $gPo1b.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $gPo1b.abs)(n) < (0, $gPo1b.epsilon)) return (0, $hhzxP.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $gPo1b.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, $gPo1b.sqrt)(c - 2 * n * (0, $gPo1b.sin)(y)) / n;
        return [
            r * (0, $gPo1b.sin)(x *= n),
            r0 - r * (0, $gPo1b.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $gPo1b.atan2)(x, (0, $gPo1b.abs)(r0y)) * (0, $gPo1b.sign)(r0y);
        if (r0y * n < 0) l -= (0, $gPo1b.pi) * (0, $gPo1b.sign)(x) * (0, $gPo1b.sign)(r0y);
        return [
            l / n,
            (0, $gPo1b.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $a41b9d3aa8ed03c9$export$2e2bcd8739ae039() {
    return (0, $5D9es.conicProjection)($a41b9d3aa8ed03c9$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}

});
parcelRegister("5D9es", function(module, exports) {

$parcel$export(module.exports, "conicProjection", function () { return $4197c19b5bb367c0$export$228272587c4d24d8; });

var $gPo1b = parcelRequire("gPo1b");

var $2TXoI = parcelRequire("2TXoI");
function $4197c19b5bb367c0$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $gPo1b.pi) / 3, m = (0, $2TXoI.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $gPo1b.radians), phi1 = _[1] * (0, $gPo1b.radians)) : [
            phi0 * (0, $gPo1b.degrees),
            phi1 * (0, $gPo1b.degrees)
        ];
    };
    return p;
}

});
parcelRegister("2TXoI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21cecaf9a25e12e8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "projectionMutator", function () { return $21cecaf9a25e12e8$export$155d5a6fa6fddeba; });

var $i18v5 = parcelRequire("i18v5");

var $hVPK1 = parcelRequire("hVPK1");

var $7aYGE = parcelRequire("7aYGE");

var $80D59 = parcelRequire("80D59");

var $gwqqd = parcelRequire("gwqqd");

var $gPo1b = parcelRequire("gPo1b");

var $6sZgy = parcelRequire("6sZgy");

var $LrrUN = parcelRequire("LrrUN");

var $5k2a7 = parcelRequire("5k2a7");

var $k6P5l = parcelRequire("k6P5l");
var $21cecaf9a25e12e8$var$transformRadians = (0, $LrrUN.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, $gPo1b.radians), y * (0, $gPo1b.radians));
    }
});
function $21cecaf9a25e12e8$var$transformRotate(rotate) {
    return (0, $LrrUN.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $21cecaf9a25e12e8$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $21cecaf9a25e12e8$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $21cecaf9a25e12e8$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $gPo1b.cos)(alpha), sinAlpha = (0, $gPo1b.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $21cecaf9a25e12e8$export$2e2bcd8739ae039(project) {
    return $21cecaf9a25e12e8$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $21cecaf9a25e12e8$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $i18v5.default), x0 = null, y0, x1, y1, postclip = (0, $gwqqd.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $gPo1b.radians), point[1] * (0, $gPo1b.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $gPo1b.degrees),
            point[1] * (0, $gPo1b.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $21cecaf9a25e12e8$var$transformRadians($21cecaf9a25e12e8$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $hVPK1.default)(theta = _ * (0, $gPo1b.radians)) : (theta = null, $i18v5.default), reset()) : theta * (0, $gPo1b.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $gwqqd.default) : (0, $7aYGE.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $gPo1b.radians), phi = _[1] % 360 * (0, $gPo1b.radians), recenter()) : [
            lambda * (0, $gPo1b.degrees),
            phi * (0, $gPo1b.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $gPo1b.radians), deltaPhi = _[1] % 360 * (0, $gPo1b.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $gPo1b.radians) : 0, recenter()) : [
            deltaLambda * (0, $gPo1b.degrees),
            deltaPhi * (0, $gPo1b.degrees),
            deltaGamma * (0, $gPo1b.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $gPo1b.radians), recenter()) : alpha * (0, $gPo1b.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $k6P5l.default)(projectTransform, delta2 = _ * _), reset()) : (0, $gPo1b.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $5k2a7.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $5k2a7.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $5k2a7.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $5k2a7.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = $21cecaf9a25e12e8$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $21cecaf9a25e12e8$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $6sZgy.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $80D59.default)(project, transform);
        projectRotateTransform = (0, $80D59.default)(rotate, projectTransform);
        projectResample = (0, $k6P5l.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

});
parcelRegister("LrrUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08e9aebfa7683fa0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "transformer", function () { return $08e9aebfa7683fa0$export$6b468dcfb64c653c; });
function $08e9aebfa7683fa0$export$2e2bcd8739ae039(methods) {
    return {
        stream: $08e9aebfa7683fa0$export$6b468dcfb64c653c(methods)
    };
}
function $08e9aebfa7683fa0$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $08e9aebfa7683fa0$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $08e9aebfa7683fa0$var$TransformStream() {}
$08e9aebfa7683fa0$var$TransformStream.prototype = {
    constructor: $08e9aebfa7683fa0$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

});

parcelRegister("5k2a7", function(module, exports) {

$parcel$export(module.exports, "fitExtent", function () { return $3e007f613e04a20d$export$e450184041869e7f; });
$parcel$export(module.exports, "fitSize", function () { return $3e007f613e04a20d$export$33a367fa1728c3ba; });
$parcel$export(module.exports, "fitWidth", function () { return $3e007f613e04a20d$export$7d8f2192ef31c5a7; });
$parcel$export(module.exports, "fitHeight", function () { return $3e007f613e04a20d$export$7069bab0d2ced675; });

var $bJwlW = parcelRequire("bJwlW");

var $kEnSA = parcelRequire("kEnSA");
function $3e007f613e04a20d$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $bJwlW.default)(object, projection.stream((0, $kEnSA.default)));
    fitBounds((0, $kEnSA.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $3e007f613e04a20d$export$e450184041869e7f(projection, extent, object) {
    return $3e007f613e04a20d$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $3e007f613e04a20d$export$33a367fa1728c3ba(projection, size, object) {
    return $3e007f613e04a20d$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $3e007f613e04a20d$export$7d8f2192ef31c5a7(projection, width, object) {
    return $3e007f613e04a20d$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $3e007f613e04a20d$export$7069bab0d2ced675(projection, height, object) {
    return $3e007f613e04a20d$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

});

parcelRegister("k6P5l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3bfea1d1532733$export$2e2bcd8739ae039; });

var $duXPh = parcelRequire("duXPh");

var $gPo1b = parcelRequire("gPo1b");

var $LrrUN = parcelRequire("LrrUN");
var $ea3bfea1d1532733$var$maxDepth = 16, $ea3bfea1d1532733$var$cosMinDistance = (0, $gPo1b.cos)(30 * (0, $gPo1b.radians)); // cos(minimum angular distance)
function $ea3bfea1d1532733$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $ea3bfea1d1532733$var$resample(project, delta2) : $ea3bfea1d1532733$var$resampleNone(project);
}
function $ea3bfea1d1532733$var$resampleNone(project) {
    return (0, $LrrUN.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $ea3bfea1d1532733$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $gPo1b.sqrt)(a * a + b * b + c * c), phi2 = (0, $gPo1b.asin)(c /= m), lambda2 = (0, $gPo1b.abs)((0, $gPo1b.abs)(c) - 1) < (0, $gPo1b.epsilon) || (0, $gPo1b.abs)(lambda0 - lambda1) < (0, $gPo1b.epsilon) ? (lambda0 + lambda1) / 2 : (0, $gPo1b.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $gPo1b.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $ea3bfea1d1532733$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $duXPh.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $ea3bfea1d1532733$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $ea3bfea1d1532733$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

});



parcelRegister("hhzxP", function(module, exports) {

$parcel$export(module.exports, "cylindricalEqualAreaRaw", function () { return $c94f989ab6c55c73$export$ae68c6db8b65046a; });

var $gPo1b = parcelRequire("gPo1b");
function $c94f989ab6c55c73$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $gPo1b.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $gPo1b.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $gPo1b.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

});



parcelRegister("gCd89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c18a6166ba5e796b$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $4CjlI = parcelRequire("4CjlI");

var $e5xCI = parcelRequire("e5xCI");

var $5k2a7 = parcelRequire("5k2a7");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $c18a6166ba5e796b$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $c18a6166ba5e796b$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $4CjlI.default)(), lower48Point, alaska = (0, $e5xCI.default)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $e5xCI.default)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $c18a6166ba5e796b$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $gPo1b.epsilon),
                y + 0.120 * k + (0, $gPo1b.epsilon)
            ],
            [
                x - 0.214 * k - (0, $gPo1b.epsilon),
                y + 0.234 * k - (0, $gPo1b.epsilon)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $gPo1b.epsilon),
                y + 0.166 * k + (0, $gPo1b.epsilon)
            ],
            [
                x - 0.115 * k - (0, $gPo1b.epsilon),
                y + 0.234 * k - (0, $gPo1b.epsilon)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $5k2a7.fitExtent)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $5k2a7.fitSize)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $5k2a7.fitWidth)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $5k2a7.fitHeight)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}

});

parcelRegister("gSDfH", function(module, exports) {

$parcel$export(module.exports, "azimuthalEqualAreaRaw", function () { return $c4a0232435dab344$export$5e11f94fc4a8d2c6; });
$parcel$export(module.exports, "default", function () { return $c4a0232435dab344$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $6Vmte = parcelRequire("6Vmte");

var $2TXoI = parcelRequire("2TXoI");
var $c4a0232435dab344$export$5e11f94fc4a8d2c6 = (0, $6Vmte.azimuthalRaw)(function(cxcy) {
    return (0, $gPo1b.sqrt)(2 / (1 + cxcy));
});
$c4a0232435dab344$export$5e11f94fc4a8d2c6.invert = (0, $6Vmte.azimuthalInvert)(function(z) {
    return 2 * (0, $gPo1b.asin)(z / 2);
});
function $c4a0232435dab344$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($c4a0232435dab344$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}

});
parcelRegister("6Vmte", function(module, exports) {

$parcel$export(module.exports, "azimuthalRaw", function () { return $50a97f1b736cc76f$export$f1211ac1bdb0796; });
$parcel$export(module.exports, "azimuthalInvert", function () { return $50a97f1b736cc76f$export$3cee429f13e44eac; });

var $gPo1b = parcelRequire("gPo1b");
function $50a97f1b736cc76f$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $gPo1b.cos)(x), cy = (0, $gPo1b.cos)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $gPo1b.sin)(x),
            k * (0, $gPo1b.sin)(y)
        ];
    };
}
function $50a97f1b736cc76f$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $gPo1b.sqrt)(x * x + y * y), c = angle(z), sc = (0, $gPo1b.sin)(c), cc = (0, $gPo1b.cos)(c);
        return [
            (0, $gPo1b.atan2)(x * sc, z * cc),
            (0, $gPo1b.asin)(z && y * sc / z)
        ];
    };
}

});


parcelRegister("8ZTVf", function(module, exports) {

$parcel$export(module.exports, "azimuthalEquidistantRaw", function () { return $68cf664651e0fb79$export$b94a4d6aa3dd25c; });
$parcel$export(module.exports, "default", function () { return $68cf664651e0fb79$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $6Vmte = parcelRequire("6Vmte");

var $2TXoI = parcelRequire("2TXoI");
var $68cf664651e0fb79$export$b94a4d6aa3dd25c = (0, $6Vmte.azimuthalRaw)(function(c) {
    return (c = (0, $gPo1b.acos)(c)) && c / (0, $gPo1b.sin)(c);
});
$68cf664651e0fb79$export$b94a4d6aa3dd25c.invert = (0, $6Vmte.azimuthalInvert)(function(z) {
    return z;
});
function $68cf664651e0fb79$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($68cf664651e0fb79$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}

});

parcelRegister("5i5iU", function(module, exports) {

$parcel$export(module.exports, "conicConformalRaw", function () { return $3da2bf76a519a176$export$2b1bc913962ed170; });
$parcel$export(module.exports, "default", function () { return $3da2bf76a519a176$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $5D9es = parcelRequire("5D9es");

var $1xcoz = parcelRequire("1xcoz");
function $3da2bf76a519a176$var$tany(y) {
    return (0, $gPo1b.tan)(((0, $gPo1b.halfPi) + y) / 2);
}
function $3da2bf76a519a176$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $gPo1b.cos)(y0), n = y0 === y1 ? (0, $gPo1b.sin)(y0) : (0, $gPo1b.log)(cy0 / (0, $gPo1b.cos)(y1)) / (0, $gPo1b.log)($3da2bf76a519a176$var$tany(y1) / $3da2bf76a519a176$var$tany(y0)), f = cy0 * (0, $gPo1b.pow)($3da2bf76a519a176$var$tany(y0), n) / n;
    if (!n) return 0, $1xcoz.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $gPo1b.halfPi) + (0, $gPo1b.epsilon)) y = -(0, $gPo1b.halfPi) + (0, $gPo1b.epsilon);
        } else if (y > (0, $gPo1b.halfPi) - (0, $gPo1b.epsilon)) y = (0, $gPo1b.halfPi) - (0, $gPo1b.epsilon);
        var r = f / (0, $gPo1b.pow)($3da2bf76a519a176$var$tany(y), n);
        return [
            r * (0, $gPo1b.sin)(n * x),
            f - r * (0, $gPo1b.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $gPo1b.sign)(n) * (0, $gPo1b.sqrt)(x * x + fy * fy), l = (0, $gPo1b.atan2)(x, (0, $gPo1b.abs)(fy)) * (0, $gPo1b.sign)(fy);
        if (fy * n < 0) l -= (0, $gPo1b.pi) * (0, $gPo1b.sign)(x) * (0, $gPo1b.sign)(fy);
        return [
            l / n,
            2 * (0, $gPo1b.atan)((0, $gPo1b.pow)(f / r, 1 / n)) - (0, $gPo1b.halfPi)
        ];
    };
    return project;
}
function $3da2bf76a519a176$export$2e2bcd8739ae039() {
    return (0, $5D9es.conicProjection)($3da2bf76a519a176$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}

});
parcelRegister("1xcoz", function(module, exports) {

$parcel$export(module.exports, "mercatorRaw", function () { return $11e27cf34fcc29ef$export$94ff8a57e9b91cc3; });
$parcel$export(module.exports, "default", function () { return $11e27cf34fcc29ef$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "mercatorProjection", function () { return $11e27cf34fcc29ef$export$44b9b66a01f2127b; });

var $gPo1b = parcelRequire("gPo1b");

var $6sZgy = parcelRequire("6sZgy");

var $2TXoI = parcelRequire("2TXoI");
function $11e27cf34fcc29ef$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $gPo1b.log)((0, $gPo1b.tan)(((0, $gPo1b.halfPi) + phi) / 2))
    ];
}
$11e27cf34fcc29ef$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $gPo1b.atan)((0, $gPo1b.exp)(y)) - (0, $gPo1b.halfPi)
    ];
};
function $11e27cf34fcc29ef$export$2e2bcd8739ae039() {
    return $11e27cf34fcc29ef$export$44b9b66a01f2127b($11e27cf34fcc29ef$export$94ff8a57e9b91cc3).scale(961 / (0, $gPo1b.tau));
}
function $11e27cf34fcc29ef$export$44b9b66a01f2127b(project) {
    var m = (0, $2TXoI.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $gPo1b.pi) * scale(), t = m((0, $6sZgy.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $11e27cf34fcc29ef$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

});


parcelRegister("d8Z5n", function(module, exports) {

$parcel$export(module.exports, "conicEquidistantRaw", function () { return $991b680e5ab81d4a$export$24f604fe80e5f192; });
$parcel$export(module.exports, "default", function () { return $991b680e5ab81d4a$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $5D9es = parcelRequire("5D9es");

var $4gub3 = parcelRequire("4gub3");
function $991b680e5ab81d4a$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $gPo1b.cos)(y0), n = y0 === y1 ? (0, $gPo1b.sin)(y0) : (cy0 - (0, $gPo1b.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $gPo1b.abs)(n) < (0, $gPo1b.epsilon)) return 0, $4gub3.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $gPo1b.sin)(nx),
            g - gy * (0, $gPo1b.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $gPo1b.atan2)(x, (0, $gPo1b.abs)(gy)) * (0, $gPo1b.sign)(gy);
        if (gy * n < 0) l -= (0, $gPo1b.pi) * (0, $gPo1b.sign)(x) * (0, $gPo1b.sign)(gy);
        return [
            l / n,
            g - (0, $gPo1b.sign)(n) * (0, $gPo1b.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}
function $991b680e5ab81d4a$export$2e2bcd8739ae039() {
    return (0, $5D9es.conicProjection)($991b680e5ab81d4a$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}

});
parcelRegister("4gub3", function(module, exports) {

$parcel$export(module.exports, "equirectangularRaw", function () { return $31b010a14f77c3be$export$f5fee52180f2f058; });
$parcel$export(module.exports, "default", function () { return $31b010a14f77c3be$export$2e2bcd8739ae039; });

var $2TXoI = parcelRequire("2TXoI");
function $31b010a14f77c3be$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$31b010a14f77c3be$export$f5fee52180f2f058.invert = $31b010a14f77c3be$export$f5fee52180f2f058;
function $31b010a14f77c3be$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($31b010a14f77c3be$export$f5fee52180f2f058).scale(152.63);
}

});


parcelRegister("lQCZE", function(module, exports) {

$parcel$export(module.exports, "equalEarthRaw", function () { return $fe7cb391a241a1eb$export$a320734067e7a731; });
$parcel$export(module.exports, "default", function () { return $fe7cb391a241a1eb$export$2e2bcd8739ae039; });

var $2TXoI = parcelRequire("2TXoI");

var $gPo1b = parcelRequire("gPo1b");
var $fe7cb391a241a1eb$var$A1 = 1.340264, $fe7cb391a241a1eb$var$A2 = -0.081106, $fe7cb391a241a1eb$var$A3 = 0.000893, $fe7cb391a241a1eb$var$A4 = 0.003796, $fe7cb391a241a1eb$var$M = (0, $gPo1b.sqrt)(3) / 2, $fe7cb391a241a1eb$var$iterations = 12;
function $fe7cb391a241a1eb$export$a320734067e7a731(lambda, phi) {
    var l = (0, $gPo1b.asin)($fe7cb391a241a1eb$var$M * (0, $gPo1b.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $gPo1b.cos)(l) / ($fe7cb391a241a1eb$var$M * ($fe7cb391a241a1eb$var$A1 + 3 * $fe7cb391a241a1eb$var$A2 * l2 + l6 * (7 * $fe7cb391a241a1eb$var$A3 + 9 * $fe7cb391a241a1eb$var$A4 * l2))),
        l * ($fe7cb391a241a1eb$var$A1 + $fe7cb391a241a1eb$var$A2 * l2 + l6 * ($fe7cb391a241a1eb$var$A3 + $fe7cb391a241a1eb$var$A4 * l2))
    ];
}
$fe7cb391a241a1eb$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $fe7cb391a241a1eb$var$iterations; ++i){
        fy = l * ($fe7cb391a241a1eb$var$A1 + $fe7cb391a241a1eb$var$A2 * l2 + l6 * ($fe7cb391a241a1eb$var$A3 + $fe7cb391a241a1eb$var$A4 * l2)) - y;
        fpy = $fe7cb391a241a1eb$var$A1 + 3 * $fe7cb391a241a1eb$var$A2 * l2 + l6 * (7 * $fe7cb391a241a1eb$var$A3 + 9 * $fe7cb391a241a1eb$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $gPo1b.abs)(delta) < (0, $gPo1b.epsilon2)) break;
    }
    return [
        $fe7cb391a241a1eb$var$M * x * ($fe7cb391a241a1eb$var$A1 + 3 * $fe7cb391a241a1eb$var$A2 * l2 + l6 * (7 * $fe7cb391a241a1eb$var$A3 + 9 * $fe7cb391a241a1eb$var$A4 * l2)) / (0, $gPo1b.cos)(l),
        (0, $gPo1b.asin)((0, $gPo1b.sin)(l) / $fe7cb391a241a1eb$var$M)
    ];
};
function $fe7cb391a241a1eb$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($fe7cb391a241a1eb$export$a320734067e7a731).scale(177.158);
}

});

parcelRegister("fPTRS", function(module, exports) {

$parcel$export(module.exports, "gnomonicRaw", function () { return $b876f4a27623c076$export$dc8c6ddfc8b22c85; });
$parcel$export(module.exports, "default", function () { return $b876f4a27623c076$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $6Vmte = parcelRequire("6Vmte");

var $2TXoI = parcelRequire("2TXoI");
function $b876f4a27623c076$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $gPo1b.cos)(y), k = (0, $gPo1b.cos)(x) * cy;
    return [
        cy * (0, $gPo1b.sin)(x) / k,
        (0, $gPo1b.sin)(y) / k
    ];
}
$b876f4a27623c076$export$dc8c6ddfc8b22c85.invert = (0, $6Vmte.azimuthalInvert)((0, $gPo1b.atan));
function $b876f4a27623c076$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($b876f4a27623c076$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}

});

parcelRegister("40c69", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ea08bf8b9ef4973$export$2e2bcd8739ae039; });

var $7aYGE = parcelRequire("7aYGE");

var $gwqqd = parcelRequire("gwqqd");

var $LrrUN = parcelRequire("LrrUN");

var $5k2a7 = parcelRequire("5k2a7");

var $gPo1b = parcelRequire("gPo1b");
function $2ea08bf8b9ef4973$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, $LrrUN.transformer)({
        point: function(x, y) {
            var p = projection([
                x,
                y
            ]);
            this.stream.point(p[0], p[1]);
        }
    }), postclip = (0, $gwqqd.default), cache, cacheStream;
    function reset() {
        kx = k * sx;
        ky = k * sy;
        cache = cacheStream = null;
        return projection;
    }
    function projection(p) {
        var x = p[0] * kx, y = p[1] * ky;
        if (alpha) {
            var t = y * ca - x * sa;
            x = x * ca + y * sa;
            y = t;
        }
        return [
            x + tx,
            y + ty
        ];
    }
    projection.invert = function(p) {
        var x = p[0] - tx, y = p[1] - ty;
        if (alpha) {
            var t = y * ca + x * sa;
            x = x * ca - y * sa;
            y = t;
        }
        return [
            x / kx,
            y / ky
        ];
    };
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $gwqqd.default) : (0, $7aYGE.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, reset()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
            tx,
            ty
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $gPo1b.radians), sa = (0, $gPo1b.sin)(alpha), ca = (0, $gPo1b.cos)(alpha), reset()) : alpha * (0, $gPo1b.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
    };
    projection.fitExtent = function(extent, object) {
        return (0, $5k2a7.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $5k2a7.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $5k2a7.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $5k2a7.fitHeight)(projection, height, object);
    };
    return projection;
}

});

parcelRegister("kVh2Y", function(module, exports) {

$parcel$export(module.exports, "naturalEarth1Raw", function () { return $f3b65aaae45602cb$export$acb6def22fe878e6; });
$parcel$export(module.exports, "default", function () { return $f3b65aaae45602cb$export$2e2bcd8739ae039; });

var $2TXoI = parcelRequire("2TXoI");

var $gPo1b = parcelRequire("gPo1b");
function $f3b65aaae45602cb$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$f3b65aaae45602cb$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $gPo1b.abs)(delta) > (0, $gPo1b.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $f3b65aaae45602cb$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($f3b65aaae45602cb$export$acb6def22fe878e6).scale(175.295);
}

});

parcelRegister("jMtWt", function(module, exports) {

$parcel$export(module.exports, "orthographicRaw", function () { return $e669b9e89ab27bbc$export$1cd9c2eb846182a; });
$parcel$export(module.exports, "default", function () { return $e669b9e89ab27bbc$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $6Vmte = parcelRequire("6Vmte");

var $2TXoI = parcelRequire("2TXoI");
function $e669b9e89ab27bbc$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $gPo1b.cos)(y) * (0, $gPo1b.sin)(x),
        (0, $gPo1b.sin)(y)
    ];
}
$e669b9e89ab27bbc$export$1cd9c2eb846182a.invert = (0, $6Vmte.azimuthalInvert)((0, $gPo1b.asin));
function $e669b9e89ab27bbc$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($e669b9e89ab27bbc$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $gPo1b.epsilon));
}

});

parcelRegister("2T1fm", function(module, exports) {

$parcel$export(module.exports, "stereographicRaw", function () { return $21a1af6b7072c633$export$f9ccbb0dcb3dcd2b; });
$parcel$export(module.exports, "default", function () { return $21a1af6b7072c633$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $6Vmte = parcelRequire("6Vmte");

var $2TXoI = parcelRequire("2TXoI");
function $21a1af6b7072c633$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $gPo1b.cos)(y), k = 1 + (0, $gPo1b.cos)(x) * cy;
    return [
        cy * (0, $gPo1b.sin)(x) / k,
        (0, $gPo1b.sin)(y) / k
    ];
}
$21a1af6b7072c633$export$f9ccbb0dcb3dcd2b.invert = (0, $6Vmte.azimuthalInvert)(function(z) {
    return 2 * (0, $gPo1b.atan)(z);
});
function $21a1af6b7072c633$export$2e2bcd8739ae039() {
    return (0, $2TXoI.default)($21a1af6b7072c633$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}

});

parcelRegister("d60zl", function(module, exports) {

$parcel$export(module.exports, "transverseMercatorRaw", function () { return $988c46e759e78fdc$export$e84942adec6de533; });
$parcel$export(module.exports, "default", function () { return $988c46e759e78fdc$export$2e2bcd8739ae039; });

var $gPo1b = parcelRequire("gPo1b");

var $1xcoz = parcelRequire("1xcoz");
function $988c46e759e78fdc$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $gPo1b.log)((0, $gPo1b.tan)(((0, $gPo1b.halfPi) + phi) / 2)),
        -lambda
    ];
}
$988c46e759e78fdc$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $gPo1b.atan)((0, $gPo1b.exp)(x)) - (0, $gPo1b.halfPi)
    ];
};
function $988c46e759e78fdc$export$2e2bcd8739ae039() {
    var m = (0, $1xcoz.mercatorProjection)($988c46e759e78fdc$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}

});


parcelRegister("i51pS", function(module, exports) {

$parcel$export(module.exports, "cluster", function () { return (parcelRequire("2ESsk")).default; });
$parcel$export(module.exports, "hierarchy", function () { return (parcelRequire("iTN6P")).default; });
$parcel$export(module.exports, "Node", function () { return (parcelRequire("iTN6P")).Node; });
$parcel$export(module.exports, "pack", function () { return (parcelRequire("h5h8x")).default; });
$parcel$export(module.exports, "packSiblings", function () { return (parcelRequire("6b6H1")).default; });
$parcel$export(module.exports, "packEnclose", function () { return (parcelRequire("82ZKJ")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("dG4X8")).default; });
$parcel$export(module.exports, "stratify", function () { return (parcelRequire("jfVK6")).default; });
$parcel$export(module.exports, "tree", function () { return (parcelRequire("eqXyG")).default; });
$parcel$export(module.exports, "treemap", function () { return (parcelRequire("dJyCW")).default; });
$parcel$export(module.exports, "treemapBinary", function () { return (parcelRequire("l4PGJ")).default; });
$parcel$export(module.exports, "treemapDice", function () { return (parcelRequire("84EDU")).default; });
$parcel$export(module.exports, "treemapSlice", function () { return (parcelRequire("ksFPK")).default; });
$parcel$export(module.exports, "treemapSliceDice", function () { return (parcelRequire("gFLXR")).default; });
$parcel$export(module.exports, "treemapSquarify", function () { return (parcelRequire("5qEZJ")).default; });
$parcel$export(module.exports, "treemapResquarify", function () { return (parcelRequire("jm8VP")).default; });

var $2ESsk = parcelRequire("2ESsk");

var $iTN6P = parcelRequire("iTN6P");

var $h5h8x = parcelRequire("h5h8x");

var $6b6H1 = parcelRequire("6b6H1");

var $82ZKJ = parcelRequire("82ZKJ");

var $dG4X8 = parcelRequire("dG4X8");

var $jfVK6 = parcelRequire("jfVK6");

var $eqXyG = parcelRequire("eqXyG");

var $dJyCW = parcelRequire("dJyCW");

var $l4PGJ = parcelRequire("l4PGJ");

var $84EDU = parcelRequire("84EDU");

var $ksFPK = parcelRequire("ksFPK");

var $gFLXR = parcelRequire("gFLXR");

var $5qEZJ = parcelRequire("5qEZJ");

var $jm8VP = parcelRequire("jm8VP");

});
parcelRegister("2ESsk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef98f0467635c67$export$2e2bcd8739ae039; });
function $1ef98f0467635c67$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $1ef98f0467635c67$var$meanX(children) {
    return children.reduce($1ef98f0467635c67$var$meanXReduce, 0) / children.length;
}
function $1ef98f0467635c67$var$meanXReduce(x, c) {
    return x + c.x;
}
function $1ef98f0467635c67$var$maxY(children) {
    return 1 + children.reduce($1ef98f0467635c67$var$maxYReduce, 0);
}
function $1ef98f0467635c67$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $1ef98f0467635c67$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $1ef98f0467635c67$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $1ef98f0467635c67$export$2e2bcd8739ae039() {
    var separation = $1ef98f0467635c67$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $1ef98f0467635c67$var$meanX(children);
                node.y = $1ef98f0467635c67$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $1ef98f0467635c67$var$leafLeft(root), right = $1ef98f0467635c67$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}

});

parcelRegister("iTN6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc23751f2afd8eef$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Node", function () { return $dc23751f2afd8eef$export$85c928794f8d04d4; });
$parcel$export(module.exports, "computeHeight", function () { return $dc23751f2afd8eef$export$5af32d52ab5dfd57; });

var $iuvzb = parcelRequire("iuvzb");

var $SA4UX = parcelRequire("SA4UX");

var $9E5jS = parcelRequire("9E5jS");

var $8wNK3 = parcelRequire("8wNK3");

var $2cJw5 = parcelRequire("2cJw5");

var $a2xSi = parcelRequire("a2xSi");

var $5JH0M = parcelRequire("5JH0M");

var $29kuI = parcelRequire("29kuI");

var $2piUV = parcelRequire("2piUV");

var $ejhMR = parcelRequire("ejhMR");

var $3dFhb = parcelRequire("3dFhb");

var $kbXXm = parcelRequire("kbXXm");

var $j3lvl = parcelRequire("j3lvl");
function $dc23751f2afd8eef$export$2e2bcd8739ae039(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = $dc23751f2afd8eef$var$mapChildren;
    } else if (children === undefined) children = $dc23751f2afd8eef$var$objectChildren;
    var root = new $dc23751f2afd8eef$export$85c928794f8d04d4(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new $dc23751f2afd8eef$export$85c928794f8d04d4(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore($dc23751f2afd8eef$export$5af32d52ab5dfd57);
}
function $dc23751f2afd8eef$var$node_copy() {
    return $dc23751f2afd8eef$export$2e2bcd8739ae039(this).eachBefore($dc23751f2afd8eef$var$copyData);
}
function $dc23751f2afd8eef$var$objectChildren(d) {
    return d.children;
}
function $dc23751f2afd8eef$var$mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function $dc23751f2afd8eef$var$copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function $dc23751f2afd8eef$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $dc23751f2afd8eef$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$dc23751f2afd8eef$export$85c928794f8d04d4.prototype = $dc23751f2afd8eef$export$2e2bcd8739ae039.prototype = {
    constructor: $dc23751f2afd8eef$export$85c928794f8d04d4,
    count: (0, $iuvzb.default),
    each: (0, $SA4UX.default),
    eachAfter: (0, $8wNK3.default),
    eachBefore: (0, $9E5jS.default),
    find: (0, $2cJw5.default),
    sum: (0, $a2xSi.default),
    sort: (0, $5JH0M.default),
    path: (0, $29kuI.default),
    ancestors: (0, $2piUV.default),
    descendants: (0, $ejhMR.default),
    leaves: (0, $3dFhb.default),
    links: (0, $kbXXm.default),
    copy: $dc23751f2afd8eef$var$node_copy,
    [Symbol.iterator]: (0, $j3lvl.default)
};

});
parcelRegister("iuvzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d76383cb2188a9fb$export$2e2bcd8739ae039; });
function $d76383cb2188a9fb$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $d76383cb2188a9fb$export$2e2bcd8739ae039() {
    return this.eachAfter($d76383cb2188a9fb$var$count);
}

});

parcelRegister("SA4UX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a4107a9be7411ae$export$2e2bcd8739ae039; });
function $0a4107a9be7411ae$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this)callback.call(that, node, ++index, this);
    return this;
}

});

parcelRegister("9E5jS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $705bf9d6b872ac7d$export$2e2bcd8739ae039; });
function $705bf9d6b872ac7d$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], children, i, index = -1;
    while(node = nodes.pop()){
        callback.call(that, node, ++index, this);
        if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}

});

parcelRegister("8wNK3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6357e599cb1c2d4e$export$2e2bcd8739ae039; });
function $6357e599cb1c2d4e$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n, index = -1;
    while(node = nodes.pop()){
        next.push(node);
        if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback.call(that, node, ++index, this);
    return this;
}

});

parcelRegister("2cJw5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19b0025f84d520fd$export$2e2bcd8739ae039; });
function $19b0025f84d520fd$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this){
        if (callback.call(that, node, ++index, this)) return node;
    }
}

});

parcelRegister("a2xSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f45e1fe2613111$export$2e2bcd8739ae039; });
function $74f45e1fe2613111$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}

});

parcelRegister("5JH0M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42d284f01cf517c1$export$2e2bcd8739ae039; });
function $42d284f01cf517c1$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}

});

parcelRegister("29kuI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $190c51c902e17184$export$2e2bcd8739ae039; });
function $190c51c902e17184$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $190c51c902e17184$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $190c51c902e17184$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

});

parcelRegister("2piUV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c0c972511b455f7$export$2e2bcd8739ae039; });
function $1c0c972511b455f7$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}

});

parcelRegister("ejhMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6b0a3345e342e87$export$2e2bcd8739ae039; });
function $a6b0a3345e342e87$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("3dFhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25829a96518a8eec$export$2e2bcd8739ae039; });
function $25829a96518a8eec$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}

});

parcelRegister("kbXXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb3357d7a55262f1$export$2e2bcd8739ae039; });
function $eb3357d7a55262f1$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}

});

parcelRegister("j3lvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddeefa8437360224$export$2e2bcd8739ae039; });
function* $ddeefa8437360224$export$2e2bcd8739ae039() {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            yield node;
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
}

});


parcelRegister("h5h8x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c700324f6d6ca83f$export$2e2bcd8739ae039; });

var $f1bJE = parcelRequire("f1bJE");

var $2tcQB = parcelRequire("2tcQB");

var $7rwre = parcelRequire("7rwre");

var $6b6H1 = parcelRequire("6b6H1");
function $c700324f6d6ca83f$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $c700324f6d6ca83f$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $2tcQB.constantZero);
    function pack(root) {
        const random = (0, $7rwre.default)();
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($c700324f6d6ca83f$var$radiusLeaf(radius)).eachAfter($c700324f6d6ca83f$var$packChildrenRandom(padding, 0.5, random)).eachBefore($c700324f6d6ca83f$var$translateChild(1));
        else root.eachBefore($c700324f6d6ca83f$var$radiusLeaf($c700324f6d6ca83f$var$defaultRadius)).eachAfter($c700324f6d6ca83f$var$packChildrenRandom((0, $2tcQB.constantZero), 1, random)).eachAfter($c700324f6d6ca83f$var$packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore($c700324f6d6ca83f$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $f1bJE.optional)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $2tcQB.default)(+x), pack) : padding;
    };
    return pack;
}
function $c700324f6d6ca83f$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $c700324f6d6ca83f$var$packChildrenRandom(padding, k, random) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $6b6H1.packSiblingsRandom)(children, random);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $c700324f6d6ca83f$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

});
parcelRegister("f1bJE", function(module, exports) {

$parcel$export(module.exports, "optional", function () { return $aef00d644fb99ac9$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "required", function () { return $aef00d644fb99ac9$export$a7a0278c004aac3f; });
function $aef00d644fb99ac9$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $aef00d644fb99ac9$export$a7a0278c004aac3f(f);
}
function $aef00d644fb99ac9$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

});

parcelRegister("2tcQB", function(module, exports) {

$parcel$export(module.exports, "constantZero", function () { return $1cc8416dc6d63a87$export$99e2e371aa6a9db; });
$parcel$export(module.exports, "default", function () { return $1cc8416dc6d63a87$export$2e2bcd8739ae039; });
function $1cc8416dc6d63a87$export$99e2e371aa6a9db() {
    return 0;
}
function $1cc8416dc6d63a87$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("7rwre", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56b4378d846525bc$export$2e2bcd8739ae039; });
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $56b4378d846525bc$var$a = 1664525;
const $56b4378d846525bc$var$c = 1013904223;
const $56b4378d846525bc$var$m = 4294967296; // 2^32
function $56b4378d846525bc$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($56b4378d846525bc$var$a * s + $56b4378d846525bc$var$c) % $56b4378d846525bc$var$m) / $56b4378d846525bc$var$m;
}

});

parcelRegister("6b6H1", function(module, exports) {

$parcel$export(module.exports, "packSiblingsRandom", function () { return $47f8f63770dde46e$export$5390336473d877c8; });
$parcel$export(module.exports, "default", function () { return $47f8f63770dde46e$export$2e2bcd8739ae039; });

var $8HtAc = parcelRequire("8HtAc");

var $7rwre = parcelRequire("7rwre");

var $82ZKJ = parcelRequire("82ZKJ");
function $47f8f63770dde46e$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $47f8f63770dde46e$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $47f8f63770dde46e$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $47f8f63770dde46e$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $47f8f63770dde46e$export$5390336473d877c8(circles, random) {
    if (!(n = (circles = (0, $8HtAc.default)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $47f8f63770dde46e$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $47f8f63770dde46e$var$Node(a), b = new $47f8f63770dde46e$var$Node(b), c = new $47f8f63770dde46e$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $47f8f63770dde46e$var$place(a._, b._, c = circles[i]), c = new $47f8f63770dde46e$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($47f8f63770dde46e$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($47f8f63770dde46e$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $47f8f63770dde46e$var$score(a);
        while((c = c.next) !== b)if ((ca = $47f8f63770dde46e$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $82ZKJ.packEncloseRandom)(a, random);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $47f8f63770dde46e$export$2e2bcd8739ae039(circles) {
    $47f8f63770dde46e$export$5390336473d877c8(circles, (0, $7rwre.default)());
    return circles;
}

});
parcelRegister("8HtAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6559496be7d41886$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "shuffle", function () { return $6559496be7d41886$export$448332262467e042; });
function $6559496be7d41886$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}
function $6559496be7d41886$export$448332262467e042(array, random) {
    let m = array.length, t, i;
    while(m){
        i = random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

});

parcelRegister("82ZKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dbe697119990248$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "packEncloseRandom", function () { return $5dbe697119990248$export$55712536b4d8ce73; });

var $8HtAc = parcelRequire("8HtAc");

var $7rwre = parcelRequire("7rwre");
function $5dbe697119990248$export$2e2bcd8739ae039(circles) {
    return $5dbe697119990248$export$55712536b4d8ce73(circles, (0, $7rwre.default)());
}
function $5dbe697119990248$export$55712536b4d8ce73(circles, random) {
    var i = 0, n = (circles = (0, $8HtAc.shuffle)(Array.from(circles), random)).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $5dbe697119990248$var$enclosesWeak(e, p)) ++i;
        else e = $5dbe697119990248$var$encloseBasis(B = $5dbe697119990248$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $5dbe697119990248$var$extendBasis(B, p) {
    var i, j;
    if ($5dbe697119990248$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($5dbe697119990248$var$enclosesNot(p, B[i]) && $5dbe697119990248$var$enclosesWeakAll($5dbe697119990248$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($5dbe697119990248$var$enclosesNot($5dbe697119990248$var$encloseBasis2(B[i], B[j]), p) && $5dbe697119990248$var$enclosesNot($5dbe697119990248$var$encloseBasis2(B[i], p), B[j]) && $5dbe697119990248$var$enclosesNot($5dbe697119990248$var$encloseBasis2(B[j], p), B[i]) && $5dbe697119990248$var$enclosesWeakAll($5dbe697119990248$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $5dbe697119990248$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $5dbe697119990248$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $5dbe697119990248$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$5dbe697119990248$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $5dbe697119990248$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $5dbe697119990248$var$encloseBasis1(B[0]);
        case 2:
            return $5dbe697119990248$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $5dbe697119990248$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $5dbe697119990248$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $5dbe697119990248$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $5dbe697119990248$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

});



parcelRegister("dG4X8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f530a1bc8683d18$export$2e2bcd8739ae039; });

var $hN8cc = parcelRequire("hN8cc");

var $84EDU = parcelRequire("84EDU");
function $9f530a1bc8683d18$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $hN8cc.default));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $84EDU.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}

});
parcelRegister("hN8cc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf3d5ecaa524c6ca$export$2e2bcd8739ae039; });
function $cf3d5ecaa524c6ca$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}

});

parcelRegister("84EDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e0e393bd0c93d7f$export$2e2bcd8739ae039; });
function $5e0e393bd0c93d7f$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}

});


parcelRegister("jfVK6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e04c357fa5e8e60e$export$2e2bcd8739ae039; });

var $f1bJE = parcelRequire("f1bJE");

var $iTN6P = parcelRequire("iTN6P");
var $e04c357fa5e8e60e$var$preroot = {
    depth: -1
}, $e04c357fa5e8e60e$var$ambiguous = {}, $e04c357fa5e8e60e$var$imputed = {};
function $e04c357fa5e8e60e$var$defaultId(d) {
    return d.id;
}
function $e04c357fa5e8e60e$var$defaultParentId(d) {
    return d.parentId;
}
function $e04c357fa5e8e60e$export$2e2bcd8739ae039() {
    var id = $e04c357fa5e8e60e$var$defaultId, parentId = $e04c357fa5e8e60e$var$defaultParentId, path;
    function stratify(data) {
        var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
        if (path != null) {
            const I = nodes.map((d, i)=>$e04c357fa5e8e60e$var$normalize(path(d, i, data)));
            const P = I.map($e04c357fa5e8e60e$var$parentof);
            const S = new Set(I).add("");
            for (const i of P)if (!S.has(i)) {
                S.add(i);
                I.push(i);
                P.push($e04c357fa5e8e60e$var$parentof(i));
                nodes.push($e04c357fa5e8e60e$var$imputed);
            }
            currentId = (_, i)=>I[i];
            currentParentId = (_, i)=>P[i];
        }
        for(i = 0, n = nodes.length; i < n; ++i){
            d = nodes[i], node = nodes[i] = new (0, $iTN6P.Node)(d);
            if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                nodeKey = node.id = nodeId;
                nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? $e04c357fa5e8e60e$var$ambiguous : node);
            }
            if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
        }
        for(i = 0; i < n; ++i){
            node = nodes[i];
            if (nodeId = node.parent) {
                parent = nodeByKey.get(nodeId);
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $e04c357fa5e8e60e$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            } else {
                if (root) throw new Error("multiple roots");
                root = node;
            }
        }
        if (!root) throw new Error("no root");
        // When imputing internal nodes, only introduce roots if needed.
        // Then replace the imputed marker data with null.
        if (path != null) {
            while(root.data === $e04c357fa5e8e60e$var$imputed && root.children.length === 1)root = root.children[0], --n;
            for(let i = nodes.length - 1; i >= 0; --i){
                node = nodes[i];
                if (node.data !== $e04c357fa5e8e60e$var$imputed) break;
                node.data = null;
            }
        }
        root.parent = $e04c357fa5e8e60e$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $iTN6P.computeHeight));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $f1bJE.optional)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $f1bJE.optional)(x), stratify) : parentId;
    };
    stratify.path = function(x) {
        return arguments.length ? (path = (0, $f1bJE.optional)(x), stratify) : path;
    };
    return stratify;
}
// To normalize a path, we coerce to a string, strip the trailing slash if any
// (as long as the trailing slash is not immediately preceded by another slash),
// and add leading slash if missing.
function $e04c357fa5e8e60e$var$normalize(path) {
    path = `${path}`;
    let i = path.length;
    if ($e04c357fa5e8e60e$var$slash(path, i - 1) && !$e04c357fa5e8e60e$var$slash(path, i - 2)) path = path.slice(0, -1);
    return path[0] === "/" ? path : `/${path}`;
}
// Walk backwards to find the first slash that is not the leading slash, e.g.:
// "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
// because the id of the root must be a truthy value.)
function $e04c357fa5e8e60e$var$parentof(path) {
    let i = path.length;
    if (i < 2) return "";
    while(--i > 1)if ($e04c357fa5e8e60e$var$slash(path, i)) break;
    return path.slice(0, i);
}
// Slashes can be escaped; to determine whether a slash is a path delimiter, we
// count the number of preceding backslashes escaping the forward slash: an odd
// number indicates an escaped forward slash.
function $e04c357fa5e8e60e$var$slash(path, i) {
    if (path[i] === "/") {
        let k = 0;
        while(i > 0 && path[--i] === "\\")++k;
        if ((k & 1) === 0) return true;
    }
    return false;
}

});

parcelRegister("eqXyG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a821b16f7ff364c4$export$2e2bcd8739ae039; });

var $iTN6P = parcelRequire("iTN6P");
function $a821b16f7ff364c4$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $a821b16f7ff364c4$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $a821b16f7ff364c4$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $a821b16f7ff364c4$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $a821b16f7ff364c4$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $a821b16f7ff364c4$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $a821b16f7ff364c4$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$a821b16f7ff364c4$var$TreeNode.prototype = Object.create((0, $iTN6P.Node).prototype);
function $a821b16f7ff364c4$var$treeRoot(root) {
    var tree = new $a821b16f7ff364c4$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $a821b16f7ff364c4$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $a821b16f7ff364c4$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $a821b16f7ff364c4$export$2e2bcd8739ae039() {
    var separation = $a821b16f7ff364c4$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $a821b16f7ff364c4$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $a821b16f7ff364c4$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $a821b16f7ff364c4$var$nextRight(vim), vip = $a821b16f7ff364c4$var$nextLeft(vip), vim && vip){
                vom = $a821b16f7ff364c4$var$nextLeft(vom);
                vop = $a821b16f7ff364c4$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $a821b16f7ff364c4$var$moveSubtree($a821b16f7ff364c4$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$a821b16f7ff364c4$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$a821b16f7ff364c4$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}

});

parcelRegister("dJyCW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ffa568cfaabd2df$export$2e2bcd8739ae039; });

var $hN8cc = parcelRequire("hN8cc");

var $5qEZJ = parcelRequire("5qEZJ");

var $f1bJE = parcelRequire("f1bJE");

var $2tcQB = parcelRequire("2tcQB");
function $9ffa568cfaabd2df$export$2e2bcd8739ae039() {
    var tile = (0, $5qEZJ.default), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $2tcQB.constantZero), paddingTop = (0, $2tcQB.constantZero), paddingRight = (0, $2tcQB.constantZero), paddingBottom = (0, $2tcQB.constantZero), paddingLeft = (0, $2tcQB.constantZero);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $hN8cc.default));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $f1bJE.required)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $2tcQB.default)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $2tcQB.default)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $2tcQB.default)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $2tcQB.default)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $2tcQB.default)(+x), treemap) : paddingLeft;
    };
    return treemap;
}

});
parcelRegister("5qEZJ", function(module, exports) {

$parcel$export(module.exports, "phi", function () { return $3f3f2e22fa49d7dc$export$324943737027944a; });
$parcel$export(module.exports, "squarifyRatio", function () { return $3f3f2e22fa49d7dc$export$9ff1217655212093; });
$parcel$export(module.exports, "default", function () { return $3f3f2e22fa49d7dc$export$2e2bcd8739ae039; });

var $84EDU = parcelRequire("84EDU");

var $ksFPK = parcelRequire("ksFPK");
var $3f3f2e22fa49d7dc$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $3f3f2e22fa49d7dc$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $84EDU.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $ksFPK.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $3f3f2e22fa49d7dc$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $3f3f2e22fa49d7dc$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($3f3f2e22fa49d7dc$export$324943737027944a);

});
parcelRegister("ksFPK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee56df79c79d9d4a$export$2e2bcd8739ae039; });
function $ee56df79c79d9d4a$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}

});



parcelRegister("l4PGJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f58210eae3c86924$export$2e2bcd8739ae039; });
function $f58210eae3c86924$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}

});

parcelRegister("gFLXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c235ae71a0bd0a4d$export$2e2bcd8739ae039; });

var $84EDU = parcelRequire("84EDU");

var $ksFPK = parcelRequire("ksFPK");
function $c235ae71a0bd0a4d$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $ksFPK.default) : (0, $84EDU.default))(parent, x0, y0, x1, y1);
}

});

parcelRegister("jm8VP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e177000c2fcdb72f$export$2e2bcd8739ae039; });

var $84EDU = parcelRequire("84EDU");

var $ksFPK = parcelRequire("ksFPK");

var $5qEZJ = parcelRequire("5qEZJ");
var $e177000c2fcdb72f$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $84EDU.default)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, $ksFPK.default)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $5qEZJ.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $5qEZJ.phi));

});


parcelRegister("aGRBr", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return (parcelRequire("hAt8X")).default; });
$parcel$export(module.exports, "interpolateArray", function () { return (parcelRequire("kxgmJ")).default; });
$parcel$export(module.exports, "interpolateBasis", function () { return (parcelRequire("1I9Xl")).default; });
$parcel$export(module.exports, "interpolateBasisClosed", function () { return (parcelRequire("u9AWy")).default; });
$parcel$export(module.exports, "interpolateDate", function () { return (parcelRequire("2FeGB")).default; });
$parcel$export(module.exports, "interpolateDiscrete", function () { return (parcelRequire("3dIeY")).default; });
$parcel$export(module.exports, "interpolateHue", function () { return (parcelRequire("hkF3D")).default; });
$parcel$export(module.exports, "interpolateNumber", function () { return (parcelRequire("fc8VK")).default; });
$parcel$export(module.exports, "interpolateNumberArray", function () { return (parcelRequire("JMJxs")).default; });
$parcel$export(module.exports, "interpolateObject", function () { return (parcelRequire("4iFiu")).default; });
$parcel$export(module.exports, "interpolateRound", function () { return (parcelRequire("EDADb")).default; });
$parcel$export(module.exports, "interpolateString", function () { return (parcelRequire("lwIcH")).default; });
$parcel$export(module.exports, "interpolateTransformCss", function () { return (parcelRequire("2Ej7V")).interpolateTransformCss; });
$parcel$export(module.exports, "interpolateTransformSvg", function () { return (parcelRequire("2Ej7V")).interpolateTransformSvg; });
$parcel$export(module.exports, "interpolateZoom", function () { return (parcelRequire("ijeSI")).default; });
$parcel$export(module.exports, "interpolateRgb", function () { return (parcelRequire("1LBfd")).default; });
$parcel$export(module.exports, "interpolateRgbBasis", function () { return (parcelRequire("1LBfd")).rgbBasis; });
$parcel$export(module.exports, "interpolateRgbBasisClosed", function () { return (parcelRequire("1LBfd")).rgbBasisClosed; });
$parcel$export(module.exports, "interpolateHsl", function () { return (parcelRequire("8Bb70")).default; });
$parcel$export(module.exports, "interpolateHslLong", function () { return (parcelRequire("8Bb70")).hslLong; });
$parcel$export(module.exports, "interpolateLab", function () { return (parcelRequire("4zcab")).default; });
$parcel$export(module.exports, "interpolateHcl", function () { return (parcelRequire("ad2e4")).default; });
$parcel$export(module.exports, "interpolateHclLong", function () { return (parcelRequire("ad2e4")).hclLong; });
$parcel$export(module.exports, "interpolateCubehelix", function () { return (parcelRequire("kbZDP")).default; });
$parcel$export(module.exports, "interpolateCubehelixLong", function () { return (parcelRequire("kbZDP")).cubehelixLong; });
$parcel$export(module.exports, "piecewise", function () { return (parcelRequire("8FaV9")).default; });
$parcel$export(module.exports, "quantize", function () { return (parcelRequire("fvYlp")).default; });

var $hAt8X = parcelRequire("hAt8X");

var $kxgmJ = parcelRequire("kxgmJ");

var $1I9Xl = parcelRequire("1I9Xl");

var $u9AWy = parcelRequire("u9AWy");

var $2FeGB = parcelRequire("2FeGB");

var $3dIeY = parcelRequire("3dIeY");

var $hkF3D = parcelRequire("hkF3D");

var $fc8VK = parcelRequire("fc8VK");

var $JMJxs = parcelRequire("JMJxs");

var $4iFiu = parcelRequire("4iFiu");

var $EDADb = parcelRequire("EDADb");

var $lwIcH = parcelRequire("lwIcH");

var $2Ej7V = parcelRequire("2Ej7V");

var $ijeSI = parcelRequire("ijeSI");

var $1LBfd = parcelRequire("1LBfd");

var $8Bb70 = parcelRequire("8Bb70");

var $4zcab = parcelRequire("4zcab");

var $ad2e4 = parcelRequire("ad2e4");

var $kbZDP = parcelRequire("kbZDP");

var $8FaV9 = parcelRequire("8FaV9");

var $fvYlp = parcelRequire("fvYlp");

});
parcelRegister("3dIeY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2584e7421e33afb3$export$2e2bcd8739ae039; });
function $2584e7421e33afb3$export$2e2bcd8739ae039(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("hkF3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9e4271e4ed0ae0b$export$2e2bcd8739ae039; });

var $7auAs = parcelRequire("7auAs");
function $c9e4271e4ed0ae0b$export$2e2bcd8739ae039(a, b) {
    var i = (0, $7auAs.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("EDADb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a2724176645b6f$export$2e2bcd8739ae039; });
function $07a2724176645b6f$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("ijeSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5458b7b1b8fe40f$export$2e2bcd8739ae039; });
var $d5458b7b1b8fe40f$var$epsilon2 = 1e-12;
function $d5458b7b1b8fe40f$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $d5458b7b1b8fe40f$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $d5458b7b1b8fe40f$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $d5458b7b1b8fe40f$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $d5458b7b1b8fe40f$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $d5458b7b1b8fe40f$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $d5458b7b1b8fe40f$var$tanh(rho * s + r0) - $d5458b7b1b8fe40f$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $d5458b7b1b8fe40f$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("8Bb70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $642a6608bb623ff7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "hslLong", function () { return $642a6608bb623ff7$export$a2c535e270a59256; });

var $5xbVo = parcelRequire("5xbVo");

var $7auAs = parcelRequire("7auAs");
function $642a6608bb623ff7$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $5xbVo.hsl)(start)).h, (end = (0, $5xbVo.hsl)(end)).h), s = (0, $7auAs.default)(start.s, end.s), l = (0, $7auAs.default)(start.l, end.l), opacity = (0, $7auAs.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $642a6608bb623ff7$export$2e2bcd8739ae039 = $642a6608bb623ff7$var$hsl((0, $7auAs.hue));
var $642a6608bb623ff7$export$a2c535e270a59256 = $642a6608bb623ff7$var$hsl((0, $7auAs.default));

});

parcelRegister("4zcab", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3533dda9e91f8f16$export$2e2bcd8739ae039; });

var $iLylX = parcelRequire("iLylX");

var $7auAs = parcelRequire("7auAs");
function $3533dda9e91f8f16$export$2e2bcd8739ae039(start, end) {
    var l = (0, $7auAs.default)((start = (0, $iLylX.default)(start)).l, (end = (0, $iLylX.default)(end)).l), a = (0, $7auAs.default)(start.a, end.a), b = (0, $7auAs.default)(start.b, end.b), opacity = (0, $7auAs.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("ad2e4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76ecd85030ec6d4e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "hclLong", function () { return $76ecd85030ec6d4e$export$5aaa50f7615f9b70; });

var $iLylX = parcelRequire("iLylX");

var $7auAs = parcelRequire("7auAs");
function $76ecd85030ec6d4e$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $iLylX.hcl)(start)).h, (end = (0, $iLylX.hcl)(end)).h), c = (0, $7auAs.default)(start.c, end.c), l = (0, $7auAs.default)(start.l, end.l), opacity = (0, $7auAs.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $76ecd85030ec6d4e$export$2e2bcd8739ae039 = $76ecd85030ec6d4e$var$hcl((0, $7auAs.hue));
var $76ecd85030ec6d4e$export$5aaa50f7615f9b70 = $76ecd85030ec6d4e$var$hcl((0, $7auAs.default));

});

parcelRegister("kbZDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb34a668a56a0820$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "cubehelixLong", function () { return $eb34a668a56a0820$export$934fa09ad474a1b4; });

var $10y0i = parcelRequire("10y0i");

var $7auAs = parcelRequire("7auAs");
function $eb34a668a56a0820$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $10y0i.default)(start)).h, (end = (0, $10y0i.default)(end)).h), s = (0, $7auAs.default)(start.s, end.s), l = (0, $7auAs.default)(start.l, end.l), opacity = (0, $7auAs.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $eb34a668a56a0820$export$2e2bcd8739ae039 = $eb34a668a56a0820$var$cubehelix((0, $7auAs.hue));
var $eb34a668a56a0820$export$934fa09ad474a1b4 = $eb34a668a56a0820$var$cubehelix((0, $7auAs.default));

});

parcelRegister("8FaV9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64ea9fb631895bcf$export$2e2bcd8739ae039; });

var $hAt8X = parcelRequire("hAt8X");
function $64ea9fb631895bcf$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $hAt8X.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("fvYlp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4b88f5ee0eb390b$export$2e2bcd8739ae039; });
function $b4b88f5ee0eb390b$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("3D8Wm", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return (parcelRequire("ayz97")).Path; });
$parcel$export(module.exports, "path", function () { return (parcelRequire("ayz97")).path; });
$parcel$export(module.exports, "pathRound", function () { return (parcelRequire("ayz97")).pathRound; });

var $ayz97 = parcelRequire("ayz97");

});

parcelRegister("3Xg7Q", function(module, exports) {

$parcel$export(module.exports, "polygonArea", function () { return (parcelRequire("54xO8")).default; });
$parcel$export(module.exports, "polygonCentroid", function () { return (parcelRequire("aIQ6F")).default; });
$parcel$export(module.exports, "polygonHull", function () { return (parcelRequire("kavJH")).default; });
$parcel$export(module.exports, "polygonContains", function () { return (parcelRequire("4Sv8j")).default; });
$parcel$export(module.exports, "polygonLength", function () { return (parcelRequire("4bxvm")).default; });

var $54xO8 = parcelRequire("54xO8");

var $aIQ6F = parcelRequire("aIQ6F");

var $kavJH = parcelRequire("kavJH");

var $4Sv8j = parcelRequire("4Sv8j");

var $4bxvm = parcelRequire("4bxvm");

});
parcelRegister("54xO8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b178cfa459b3cda$export$2e2bcd8739ae039; });
function $3b178cfa459b3cda$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}

});

parcelRegister("aIQ6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ce66ebd26ab0ffc$export$2e2bcd8739ae039; });
function $7ce66ebd26ab0ffc$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}

});

parcelRegister("kavJH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaed5bf1f9a88a96$export$2e2bcd8739ae039; });

var $fHS6R = parcelRequire("fHS6R");
function $eaed5bf1f9a88a96$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $eaed5bf1f9a88a96$var$computeUpperHullIndexes(points) {
    const n = points.length, indexes = [
        0,
        1
    ];
    let size = 2, i;
    for(i = 2; i < n; ++i){
        while(size > 1 && (0, $fHS6R.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $eaed5bf1f9a88a96$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($eaed5bf1f9a88a96$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $eaed5bf1f9a88a96$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $eaed5bf1f9a88a96$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}

});
parcelRegister("fHS6R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6f4d83ae2040470$export$2e2bcd8739ae039; });
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $b6f4d83ae2040470$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}

});


parcelRegister("4Sv8j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38d45af7427b96ac$export$2e2bcd8739ae039; });
function $38d45af7427b96ac$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}

});

parcelRegister("4bxvm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30c22ddf6ea8c788$export$2e2bcd8739ae039; });
function $30c22ddf6ea8c788$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.hypot(xa, ya);
    }
    return perimeter;
}

});


parcelRegister("a1OtG", function(module, exports) {

$parcel$export(module.exports, "quadtree", function () { return (parcelRequire("22HY7")).default; });

var $22HY7 = parcelRequire("22HY7");

});

parcelRegister("dI56V", function(module, exports) {

$parcel$export(module.exports, "randomUniform", function () { return (parcelRequire("fdPuE")).default; });
$parcel$export(module.exports, "randomInt", function () { return (parcelRequire("8N49t")).default; });
$parcel$export(module.exports, "randomNormal", function () { return (parcelRequire("i9pjJ")).default; });
$parcel$export(module.exports, "randomLogNormal", function () { return (parcelRequire("giAjY")).default; });
$parcel$export(module.exports, "randomBates", function () { return (parcelRequire("kZbhX")).default; });
$parcel$export(module.exports, "randomIrwinHall", function () { return (parcelRequire("iSAdK")).default; });
$parcel$export(module.exports, "randomExponential", function () { return (parcelRequire("4jUKp")).default; });
$parcel$export(module.exports, "randomPareto", function () { return (parcelRequire("aw3ZF")).default; });
$parcel$export(module.exports, "randomBernoulli", function () { return (parcelRequire("4YT6L")).default; });
$parcel$export(module.exports, "randomGeometric", function () { return (parcelRequire("dIbxW")).default; });
$parcel$export(module.exports, "randomBinomial", function () { return (parcelRequire("eMcqV")).default; });
$parcel$export(module.exports, "randomGamma", function () { return (parcelRequire("6fH0z")).default; });
$parcel$export(module.exports, "randomBeta", function () { return (parcelRequire("9BKyo")).default; });
$parcel$export(module.exports, "randomWeibull", function () { return (parcelRequire("ajWS6")).default; });
$parcel$export(module.exports, "randomCauchy", function () { return (parcelRequire("k5KaT")).default; });
$parcel$export(module.exports, "randomLogistic", function () { return (parcelRequire("3l0IJ")).default; });
$parcel$export(module.exports, "randomPoisson", function () { return (parcelRequire("58S7e")).default; });
$parcel$export(module.exports, "randomLcg", function () { return (parcelRequire("gUF3C")).default; });

var $fdPuE = parcelRequire("fdPuE");

var $8N49t = parcelRequire("8N49t");

var $i9pjJ = parcelRequire("i9pjJ");

var $giAjY = parcelRequire("giAjY");

var $kZbhX = parcelRequire("kZbhX");

var $iSAdK = parcelRequire("iSAdK");

var $4jUKp = parcelRequire("4jUKp");

var $aw3ZF = parcelRequire("aw3ZF");

var $4YT6L = parcelRequire("4YT6L");

var $dIbxW = parcelRequire("dIbxW");

var $eMcqV = parcelRequire("eMcqV");

var $6fH0z = parcelRequire("6fH0z");

var $9BKyo = parcelRequire("9BKyo");

var $ajWS6 = parcelRequire("ajWS6");

var $k5KaT = parcelRequire("k5KaT");

var $3l0IJ = parcelRequire("3l0IJ");

var $58S7e = parcelRequire("58S7e");

var $gUF3C = parcelRequire("gUF3C");

});
parcelRegister("fdPuE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b150036818bcde71$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $b150036818bcde71$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $85Kuh.default));

});
parcelRegister("85Kuh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e42d9c94d52ea1a$export$2e2bcd8739ae039; });
var $5e42d9c94d52ea1a$export$2e2bcd8739ae039 = Math.random;

});


parcelRegister("8N49t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66661ed1abe98a5d$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $66661ed1abe98a5d$export$2e2bcd8739ae039 = function sourceRandomInt(source) {
    function randomInt(min, max) {
        if (arguments.length < 2) max = min, min = 0;
        min = Math.floor(min);
        max = Math.floor(max) - min;
        return function() {
            return Math.floor(source() * max + min);
        };
    }
    randomInt.source = sourceRandomInt;
    return randomInt;
}((0, $85Kuh.default));

});

parcelRegister("i9pjJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d36cb4bbe684dbc1$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $d36cb4bbe684dbc1$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $85Kuh.default));

});

parcelRegister("giAjY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdda8068788a3093$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");

var $i9pjJ = parcelRequire("i9pjJ");
var $bdda8068788a3093$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    var N = (0, $i9pjJ.default).source(source);
    function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $85Kuh.default));

});

parcelRegister("kZbhX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47242d6c901dd17$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");

var $iSAdK = parcelRequire("iSAdK");
var $f47242d6c901dd17$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    var I = (0, $iSAdK.default).source(source);
    function randomBates(n) {
        // use limiting distribution at n === 0
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $85Kuh.default));

});
parcelRegister("iSAdK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbe95dd28b3fc33c$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $dbe95dd28b3fc33c$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        if ((n = +n) <= 0) return ()=>0;
        return function() {
            for(var sum = 0, i = n; i > 1; --i)sum += source();
            return sum + i * source();
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $85Kuh.default));

});


parcelRegister("4jUKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3254f4a5c0c42471$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $3254f4a5c0c42471$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $85Kuh.default));

});

parcelRegister("aw3ZF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a7ffd91b2e94602$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $7a7ffd91b2e94602$export$2e2bcd8739ae039 = function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
}((0, $85Kuh.default));

});

parcelRegister("4YT6L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a0783540a19bdfb$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $3a0783540a19bdfb$export$2e2bcd8739ae039 = function sourceRandomBernoulli(source) {
    function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
            return Math.floor(source() + p);
        };
    }
    randomBernoulli.source = sourceRandomBernoulli;
    return randomBernoulli;
}((0, $85Kuh.default));

});

parcelRegister("dIbxW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fb8575072fb7e00$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $9fb8575072fb7e00$export$2e2bcd8739ae039 = function sourceRandomGeometric(source) {
    function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return ()=>Infinity;
        if (p === 1) return ()=>1;
        p = Math.log1p(-p);
        return function() {
            return 1 + Math.floor(Math.log1p(-source()) / p);
        };
    }
    randomGeometric.source = sourceRandomGeometric;
    return randomGeometric;
}((0, $85Kuh.default));

});

parcelRegister("eMcqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1f31611d478495$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");

var $9BKyo = parcelRequire("9BKyo");

var $dIbxW = parcelRequire("dIbxW");
var $ac1f31611d478495$export$2e2bcd8739ae039 = function sourceRandomBinomial(source) {
    var G = (0, $dIbxW.default).source(source), B = (0, $9BKyo.default).source(source);
    function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return ()=>n;
        if (p <= 0) return ()=>0;
        return function() {
            var acc = 0, nn = n, pp = p;
            while(nn * pp > 16 && nn * (1 - pp) > 16){
                var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                if (y <= pp) {
                    acc += i;
                    nn -= i;
                    pp = (pp - y) / (1 - y);
                } else {
                    nn = i - 1;
                    pp /= y;
                }
            }
            var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
            for(var s = g(), k = 0; s <= nn; ++k)s += g();
            return acc + (sign ? k : nn - k);
        };
    }
    randomBinomial.source = sourceRandomBinomial;
    return randomBinomial;
}((0, $85Kuh.default));

});
parcelRegister("9BKyo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6febae57904b02ee$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");

var $6fH0z = parcelRequire("6fH0z");
var $6febae57904b02ee$export$2e2bcd8739ae039 = function sourceRandomBeta(source) {
    var G = (0, $6fH0z.default).source(source);
    function randomBeta(alpha, beta) {
        var X = G(alpha), Y = G(beta);
        return function() {
            var x = X();
            return x === 0 ? 0 : x / (x + Y());
        };
    }
    randomBeta.source = sourceRandomBeta;
    return randomBeta;
}((0, $85Kuh.default));

});
parcelRegister("6fH0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48d58153660e31c0$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");

var $i9pjJ = parcelRequire("i9pjJ");
var $48d58153660e31c0$export$2e2bcd8739ae039 = function sourceRandomGamma(source) {
    var randomNormal = (0, $i9pjJ.default).source(source)();
    function randomGamma(k, theta) {
        if ((k = +k) < 0) throw new RangeError("invalid k");
        // degenerate distribution if k === 0
        if (k === 0) return ()=>0;
        theta = theta == null ? 1 : +theta;
        // exponential distribution if k === 1
        if (k === 1) return ()=>-Math.log1p(-source()) * theta;
        var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
        return function() {
            do {
                do var x = randomNormal(), v = 1 + c * x;
                while (v <= 0);
                v *= v * v;
                var u = 1 - source();
            }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
            return d * v * multiplier() * theta;
        };
    }
    randomGamma.source = sourceRandomGamma;
    return randomGamma;
}((0, $85Kuh.default));

});



parcelRegister("ajWS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78395866a7484172$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $78395866a7484172$export$2e2bcd8739ae039 = function sourceRandomWeibull(source) {
    function randomWeibull(k, a, b) {
        var outerFunc;
        if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
        else {
            k = 1 / k;
            outerFunc = (x)=>Math.pow(x, k);
        }
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * outerFunc(-Math.log1p(-source()));
        };
    }
    randomWeibull.source = sourceRandomWeibull;
    return randomWeibull;
}((0, $85Kuh.default));

});

parcelRegister("k5KaT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea0817a282292451$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $ea0817a282292451$export$2e2bcd8739ae039 = function sourceRandomCauchy(source) {
    function randomCauchy(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * Math.tan(Math.PI * source());
        };
    }
    randomCauchy.source = sourceRandomCauchy;
    return randomCauchy;
}((0, $85Kuh.default));

});

parcelRegister("3l0IJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26e3e45570b2f685$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");
var $26e3e45570b2f685$export$2e2bcd8739ae039 = function sourceRandomLogistic(source) {
    function randomLogistic(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            var u = source();
            return a + b * Math.log(u / (1 - u));
        };
    }
    randomLogistic.source = sourceRandomLogistic;
    return randomLogistic;
}((0, $85Kuh.default));

});

parcelRegister("58S7e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3be7ad560d30cec5$export$2e2bcd8739ae039; });

var $85Kuh = parcelRequire("85Kuh");

var $eMcqV = parcelRequire("eMcqV");

var $6fH0z = parcelRequire("6fH0z");
var $3be7ad560d30cec5$export$2e2bcd8739ae039 = function sourceRandomPoisson(source) {
    var G = (0, $6fH0z.default).source(source), B = (0, $eMcqV.default).source(source);
    function randomPoisson(lambda) {
        return function() {
            var acc = 0, l = lambda;
            while(l > 16){
                var n = Math.floor(0.875 * l), t = G(n)();
                if (t > l) return acc + B(n - 1, l / t)();
                acc += n;
                l -= t;
            }
            for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
            return acc + k;
        };
    }
    randomPoisson.source = sourceRandomPoisson;
    return randomPoisson;
}((0, $85Kuh.default));

});

parcelRegister("gUF3C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c501b972458f3e59$export$2e2bcd8739ae039; });
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $c501b972458f3e59$var$mul = 0x19660D;
const $c501b972458f3e59$var$inc = 0x3C6EF35F;
const $c501b972458f3e59$var$eps = 1 / 0x100000000;
function $c501b972458f3e59$export$2e2bcd8739ae039(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / $c501b972458f3e59$var$eps : Math.abs(seed)) | 0;
    return ()=>(state = $c501b972458f3e59$var$mul * state + $c501b972458f3e59$var$inc | 0, $c501b972458f3e59$var$eps * (state >>> 0));
}

});


parcelRegister("jroKu", function(module, exports) {

$parcel$export(module.exports, "scaleBand", function () { return (parcelRequire("dQDxu")).default; });
$parcel$export(module.exports, "scalePoint", function () { return (parcelRequire("dQDxu")).point; });
$parcel$export(module.exports, "scaleIdentity", function () { return (parcelRequire("d61Jt")).default; });
$parcel$export(module.exports, "scaleLinear", function () { return (parcelRequire("4G7qM")).default; });
$parcel$export(module.exports, "scaleLog", function () { return (parcelRequire("gLv5r")).default; });
$parcel$export(module.exports, "scaleSymlog", function () { return (parcelRequire("hdWxy")).default; });
$parcel$export(module.exports, "scaleOrdinal", function () { return (parcelRequire("irGLJ")).default; });
$parcel$export(module.exports, "scaleImplicit", function () { return (parcelRequire("irGLJ")).implicit; });
$parcel$export(module.exports, "scalePow", function () { return (parcelRequire("8Odyk")).default; });
$parcel$export(module.exports, "scaleSqrt", function () { return (parcelRequire("8Odyk")).sqrt; });
$parcel$export(module.exports, "scaleRadial", function () { return (parcelRequire("iHEP0")).default; });
$parcel$export(module.exports, "scaleQuantile", function () { return (parcelRequire("e5Yzy")).default; });
$parcel$export(module.exports, "scaleQuantize", function () { return (parcelRequire("9Z9E0")).default; });
$parcel$export(module.exports, "scaleThreshold", function () { return (parcelRequire("f1KNs")).default; });
$parcel$export(module.exports, "scaleTime", function () { return (parcelRequire("aLd8A")).default; });
$parcel$export(module.exports, "scaleUtc", function () { return (parcelRequire("1Y70c")).default; });
$parcel$export(module.exports, "scaleSequential", function () { return (parcelRequire("21aYu")).default; });
$parcel$export(module.exports, "scaleSequentialLog", function () { return (parcelRequire("21aYu")).sequentialLog; });
$parcel$export(module.exports, "scaleSequentialPow", function () { return (parcelRequire("21aYu")).sequentialPow; });
$parcel$export(module.exports, "scaleSequentialSqrt", function () { return (parcelRequire("21aYu")).sequentialSqrt; });
$parcel$export(module.exports, "scaleSequentialSymlog", function () { return (parcelRequire("21aYu")).sequentialSymlog; });
$parcel$export(module.exports, "scaleSequentialQuantile", function () { return (parcelRequire("QXau9")).default; });
$parcel$export(module.exports, "scaleDiverging", function () { return (parcelRequire("d3a3c")).default; });
$parcel$export(module.exports, "scaleDivergingLog", function () { return (parcelRequire("d3a3c")).divergingLog; });
$parcel$export(module.exports, "scaleDivergingPow", function () { return (parcelRequire("d3a3c")).divergingPow; });
$parcel$export(module.exports, "scaleDivergingSqrt", function () { return (parcelRequire("d3a3c")).divergingSqrt; });
$parcel$export(module.exports, "scaleDivergingSymlog", function () { return (parcelRequire("d3a3c")).divergingSymlog; });
$parcel$export(module.exports, "tickFormat", function () { return (parcelRequire("3D4sX")).default; });

var $dQDxu = parcelRequire("dQDxu");

var $d61Jt = parcelRequire("d61Jt");

var $4G7qM = parcelRequire("4G7qM");

var $gLv5r = parcelRequire("gLv5r");

var $hdWxy = parcelRequire("hdWxy");

var $irGLJ = parcelRequire("irGLJ");

var $8Odyk = parcelRequire("8Odyk");

var $iHEP0 = parcelRequire("iHEP0");

var $e5Yzy = parcelRequire("e5Yzy");

var $9Z9E0 = parcelRequire("9Z9E0");

var $f1KNs = parcelRequire("f1KNs");

var $aLd8A = parcelRequire("aLd8A");

var $1Y70c = parcelRequire("1Y70c");

var $21aYu = parcelRequire("21aYu");

var $QXau9 = parcelRequire("QXau9");

var $d3a3c = parcelRequire("d3a3c");

var $3D4sX = parcelRequire("3D4sX");

});
parcelRegister("dQDxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a14ecd551cca87b8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "point", function () { return $a14ecd551cca87b8$export$105684a3041cb6f3; });

var $6jvVk = parcelRequire("6jvVk");

var $33fAq = parcelRequire("33fAq");

var $irGLJ = parcelRequire("irGLJ");
function $a14ecd551cca87b8$export$2e2bcd8739ae039() {
    var scale = (0, $irGLJ.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $6jvVk.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $a14ecd551cca87b8$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $33fAq.initRange).apply(rescale(), arguments);
}
function $a14ecd551cca87b8$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $a14ecd551cca87b8$var$pointish(copy());
    };
    return scale;
}
function $a14ecd551cca87b8$export$105684a3041cb6f3() {
    return $a14ecd551cca87b8$var$pointish($a14ecd551cca87b8$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("33fAq", function(module, exports) {

$parcel$export(module.exports, "initRange", function () { return $238dbe0e4d3fd0fa$export$23c7bb9e6558da2a; });
$parcel$export(module.exports, "initInterpolator", function () { return $238dbe0e4d3fd0fa$export$7d6b419e59e83f3d; });
function $238dbe0e4d3fd0fa$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $238dbe0e4d3fd0fa$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("irGLJ", function(module, exports) {

$parcel$export(module.exports, "implicit", function () { return $d6dbec97f8877273$export$e4f898ab14d9d460; });
$parcel$export(module.exports, "default", function () { return $d6dbec97f8877273$export$2e2bcd8739ae039; });

var $9Y6md = parcelRequire("9Y6md");

var $33fAq = parcelRequire("33fAq");
const $d6dbec97f8877273$export$e4f898ab14d9d460 = Symbol("implicit");
function $d6dbec97f8877273$export$2e2bcd8739ae039() {
    var index = new (0, $9Y6md.InternMap)(), domain = [], range = [], unknown = $d6dbec97f8877273$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $d6dbec97f8877273$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $9Y6md.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $d6dbec97f8877273$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $33fAq.initRange).apply(scale, arguments);
    return scale;
}

});


parcelRegister("d61Jt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988d2de70ef95404$export$2e2bcd8739ae039; });

var $4G7qM = parcelRequire("4G7qM");

var $88Sm0 = parcelRequire("88Sm0");
function $988d2de70ef95404$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $88Sm0.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $988d2de70ef95404$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $88Sm0.default)) : [
        0,
        1
    ];
    return (0, $4G7qM.linearish)(scale);
}

});
parcelRegister("4G7qM", function(module, exports) {

$parcel$export(module.exports, "linearish", function () { return $3680d946ddaea58f$export$16a5d4b4a61a274d; });
$parcel$export(module.exports, "default", function () { return $3680d946ddaea58f$export$2e2bcd8739ae039; });

var $amLJv = parcelRequire("amLJv");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");

var $3D4sX = parcelRequire("3D4sX");
function $3680d946ddaea58f$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $amLJv.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $3D4sX.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $amLJv.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $3680d946ddaea58f$export$2e2bcd8739ae039() {
    var scale = (0, $knO4f.default)();
    scale.copy = function() {
        return (0, $knO4f.copy)(scale, $3680d946ddaea58f$export$2e2bcd8739ae039());
    };
    (0, $33fAq.initRange).apply(scale, arguments);
    return $3680d946ddaea58f$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("knO4f", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $ed6ccb038e7a979a$export$f0954fd7d5368655; });
$parcel$export(module.exports, "copy", function () { return $ed6ccb038e7a979a$export$784d13d8ee351f07; });
$parcel$export(module.exports, "transformer", function () { return $ed6ccb038e7a979a$export$6b468dcfb64c653c; });
$parcel$export(module.exports, "default", function () { return $ed6ccb038e7a979a$export$2e2bcd8739ae039; });

var $eZf2H = parcelRequire("eZf2H");

var $hAt8X = parcelRequire("hAt8X");
var $fc8VK = parcelRequire("fc8VK");
var $EDADb = parcelRequire("EDADb");

var $cXNzy = parcelRequire("cXNzy");

var $88Sm0 = parcelRequire("88Sm0");
var $ed6ccb038e7a979a$var$unit = [
    0,
    1
];
function $ed6ccb038e7a979a$export$f0954fd7d5368655(x) {
    return x;
}
function $ed6ccb038e7a979a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $cXNzy.default)(isNaN(b) ? NaN : 0.5);
}
function $ed6ccb038e7a979a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $ed6ccb038e7a979a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $ed6ccb038e7a979a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $ed6ccb038e7a979a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $ed6ccb038e7a979a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $ed6ccb038e7a979a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $eZf2H.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $ed6ccb038e7a979a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $ed6ccb038e7a979a$export$6b468dcfb64c653c() {
    var domain = $ed6ccb038e7a979a$var$unit, range = $ed6ccb038e7a979a$var$unit, interpolate = (0, $hAt8X.default), transform, untransform, unknown, clamp = $ed6ccb038e7a979a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $ed6ccb038e7a979a$export$f0954fd7d5368655) clamp = $ed6ccb038e7a979a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $ed6ccb038e7a979a$var$polymap : $ed6ccb038e7a979a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $fc8VK.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $88Sm0.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $EDADb.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $ed6ccb038e7a979a$export$f0954fd7d5368655, rescale()) : clamp !== $ed6ccb038e7a979a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $ed6ccb038e7a979a$export$2e2bcd8739ae039() {
    return $ed6ccb038e7a979a$export$6b468dcfb64c653c()($ed6ccb038e7a979a$export$f0954fd7d5368655, $ed6ccb038e7a979a$export$f0954fd7d5368655);
}

});
parcelRegister("cXNzy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $970172cdfa4202be$export$2e2bcd8739ae039; });
function $970172cdfa4202be$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("88Sm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ed93ba03cfe8a73$export$2e2bcd8739ae039; });
function $5ed93ba03cfe8a73$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("3D4sX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a487a7daa89a56a$export$2e2bcd8739ae039; });

var $amLJv = parcelRequire("amLJv");

var $bBrYe = parcelRequire("bBrYe");
var $1AA4l = parcelRequire("1AA4l");
var $6Ziqw = parcelRequire("6Ziqw");
var $eiLdi = parcelRequire("eiLdi");
var $c3pED = parcelRequire("c3pED");
function $2a487a7daa89a56a$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $amLJv.tickStep)(start, stop, count), precision;
    specifier = (0, $1AA4l.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $eiLdi.default)(step, value))) specifier.precision = precision;
            return (0, $bBrYe.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $c3pED.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $6Ziqw.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $bBrYe.format)(specifier);
}

});



parcelRegister("gLv5r", function(module, exports) {

$parcel$export(module.exports, "loggish", function () { return $c349265455f8e143$export$860836db074028f0; });
$parcel$export(module.exports, "default", function () { return $c349265455f8e143$export$2e2bcd8739ae039; });

var $amLJv = parcelRequire("amLJv");

var $bBrYe = parcelRequire("bBrYe");
var $1AA4l = parcelRequire("1AA4l");

var $5W0K8 = parcelRequire("5W0K8");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");
function $c349265455f8e143$var$transformLog(x) {
    return Math.log(x);
}
function $c349265455f8e143$var$transformExp(x) {
    return Math.exp(x);
}
function $c349265455f8e143$var$transformLogn(x) {
    return -Math.log(-x);
}
function $c349265455f8e143$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $c349265455f8e143$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $c349265455f8e143$var$powp(base) {
    return base === 10 ? $c349265455f8e143$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $c349265455f8e143$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $c349265455f8e143$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $c349265455f8e143$export$860836db074028f0(transform) {
    const scale = transform($c349265455f8e143$var$transformLog, $c349265455f8e143$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $c349265455f8e143$var$logp(base), pows = $c349265455f8e143$var$powp(base);
        if (domain()[0] < 0) {
            logs = $c349265455f8e143$var$reflect(logs), pows = $c349265455f8e143$var$reflect(pows);
            transform($c349265455f8e143$var$transformLogn, $c349265455f8e143$var$transformExpn);
        } else transform($c349265455f8e143$var$transformLog, $c349265455f8e143$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $amLJv.default)(u, v, n);
        } else z = (0, $amLJv.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $1AA4l.default)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $bBrYe.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $5W0K8.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $c349265455f8e143$export$2e2bcd8739ae039() {
    const scale = $c349265455f8e143$export$860836db074028f0((0, $knO4f.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $knO4f.copy)(scale, $c349265455f8e143$export$2e2bcd8739ae039()).base(scale.base());
    (0, $33fAq.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("5W0K8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4522f21c02962c49$export$2e2bcd8739ae039; });
function $4522f21c02962c49$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("hdWxy", function(module, exports) {

$parcel$export(module.exports, "symlogish", function () { return $c8a10f702ed6234e$export$4602684e614eba38; });
$parcel$export(module.exports, "default", function () { return $c8a10f702ed6234e$export$2e2bcd8739ae039; });

var $4G7qM = parcelRequire("4G7qM");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");
function $c8a10f702ed6234e$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $c8a10f702ed6234e$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $c8a10f702ed6234e$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($c8a10f702ed6234e$var$transformSymlog(c), $c8a10f702ed6234e$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($c8a10f702ed6234e$var$transformSymlog(c = +_), $c8a10f702ed6234e$var$transformSymexp(c)) : c;
    };
    return (0, $4G7qM.linearish)(scale);
}
function $c8a10f702ed6234e$export$2e2bcd8739ae039() {
    var scale = $c8a10f702ed6234e$export$4602684e614eba38((0, $knO4f.transformer)());
    scale.copy = function() {
        return (0, $knO4f.copy)(scale, $c8a10f702ed6234e$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $33fAq.initRange).apply(scale, arguments);
}

});

parcelRegister("8Odyk", function(module, exports) {

$parcel$export(module.exports, "powish", function () { return $669d8184e84dbc68$export$34695211ec403a46; });
$parcel$export(module.exports, "default", function () { return $669d8184e84dbc68$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sqrt", function () { return $669d8184e84dbc68$export$eba8049fb5020b81; });

var $4G7qM = parcelRequire("4G7qM");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");
function $669d8184e84dbc68$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $669d8184e84dbc68$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $669d8184e84dbc68$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $669d8184e84dbc68$export$34695211ec403a46(transform) {
    var scale = transform((0, $knO4f.identity), (0, $knO4f.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $knO4f.identity), (0, $knO4f.identity)) : exponent === 0.5 ? transform($669d8184e84dbc68$var$transformSqrt, $669d8184e84dbc68$var$transformSquare) : transform($669d8184e84dbc68$var$transformPow(exponent), $669d8184e84dbc68$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $4G7qM.linearish)(scale);
}
function $669d8184e84dbc68$export$2e2bcd8739ae039() {
    var scale = $669d8184e84dbc68$export$34695211ec403a46((0, $knO4f.transformer)());
    scale.copy = function() {
        return (0, $knO4f.copy)(scale, $669d8184e84dbc68$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $33fAq.initRange).apply(scale, arguments);
    return scale;
}
function $669d8184e84dbc68$export$eba8049fb5020b81() {
    return $669d8184e84dbc68$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("iHEP0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9dbe87e4cf2984c$export$2e2bcd8739ae039; });

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");

var $4G7qM = parcelRequire("4G7qM");

var $88Sm0 = parcelRequire("88Sm0");
function $d9dbe87e4cf2984c$var$square(x) {
    return Math.sign(x) * x * x;
}
function $d9dbe87e4cf2984c$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $d9dbe87e4cf2984c$export$2e2bcd8739ae039() {
    var squared = (0, $knO4f.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $d9dbe87e4cf2984c$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($d9dbe87e4cf2984c$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $88Sm0.default))).map($d9dbe87e4cf2984c$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $d9dbe87e4cf2984c$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $33fAq.initRange).apply(scale, arguments);
    return (0, $4G7qM.linearish)(scale);
}

});

parcelRegister("e5Yzy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a43084bb78e86af1$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");
var $eZf2H = parcelRequire("eZf2H");
var $hr3aa = parcelRequire("hr3aa");

var $33fAq = parcelRequire("33fAq");
function $a43084bb78e86af1$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $hr3aa.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $eZf2H.default)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $mbn54.default));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $a43084bb78e86af1$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $33fAq.initRange).apply(scale, arguments);
}

});

parcelRegister("9Z9E0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74514ab3babb2055$export$2e2bcd8739ae039; });

var $eZf2H = parcelRequire("eZf2H");

var $4G7qM = parcelRequire("4G7qM");

var $33fAq = parcelRequire("33fAq");
function $74514ab3babb2055$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $eZf2H.default)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $74514ab3babb2055$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $33fAq.initRange).apply((0, $4G7qM.linearish)(scale), arguments);
}

});

parcelRegister("f1KNs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af0b3fdaefb7ad76$export$2e2bcd8739ae039; });

var $eZf2H = parcelRequire("eZf2H");

var $33fAq = parcelRequire("33fAq");
function $af0b3fdaefb7ad76$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $eZf2H.default)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $af0b3fdaefb7ad76$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $33fAq.initRange).apply(scale, arguments);
}

});

parcelRegister("aLd8A", function(module, exports) {

$parcel$export(module.exports, "calendar", function () { return $7d587bfe8ad16f3d$export$56bbcdb8aca31149; });
$parcel$export(module.exports, "default", function () { return $7d587bfe8ad16f3d$export$2e2bcd8739ae039; });

var $6fz8m = parcelRequire("6fz8m");
var $3hgbf = parcelRequire("3hgbf");
var $7P7u1 = parcelRequire("7P7u1");
var $ceUnP = parcelRequire("ceUnP");
var $leuDw = parcelRequire("leuDw");
var $5qbnm = parcelRequire("5qbnm");
var $4gg5r = parcelRequire("4gg5r");
var $kHofm = parcelRequire("kHofm");

var $eo1Zn = parcelRequire("eo1Zn");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");

var $5W0K8 = parcelRequire("5W0K8");
function $7d587bfe8ad16f3d$var$date(t) {
    return new Date(t);
}
function $7d587bfe8ad16f3d$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $7d587bfe8ad16f3d$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $knO4f.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $7d587bfe8ad16f3d$var$number)) : domain().map($7d587bfe8ad16f3d$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $5W0K8.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $knO4f.copy)(scale, $7d587bfe8ad16f3d$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $7d587bfe8ad16f3d$export$2e2bcd8739ae039() {
    return (0, $33fAq.initRange).apply($7d587bfe8ad16f3d$export$56bbcdb8aca31149((0, $5qbnm.timeTicks), (0, $5qbnm.timeTickInterval), (0, $kHofm.timeYear), (0, $ceUnP.timeMonth), (0, $4gg5r.timeSunday), (0, $6fz8m.timeDay), (0, $3hgbf.timeHour), (0, $7P7u1.timeMinute), (0, $leuDw.second), (0, $eo1Zn.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("6fz8m", function(module, exports) {

$parcel$export(module.exports, "timeDay", function () { return $48cf65a65f3c9b44$export$8888529b966033e5; });
$parcel$export(module.exports, "timeDays", function () { return $48cf65a65f3c9b44$export$6657a54f3034cf45; });
$parcel$export(module.exports, "utcDay", function () { return $48cf65a65f3c9b44$export$c8cbc42cefd47140; });
$parcel$export(module.exports, "utcDays", function () { return $48cf65a65f3c9b44$export$d277e198508549a1; });
$parcel$export(module.exports, "unixDay", function () { return $48cf65a65f3c9b44$export$fb065be2d7ea4a71; });
$parcel$export(module.exports, "unixDays", function () { return $48cf65a65f3c9b44$export$a491caaf5e9481aa; });

var $4kQAV = parcelRequire("4kQAV");

var $8wG98 = parcelRequire("8wG98");
const $48cf65a65f3c9b44$export$8888529b966033e5 = (0, $4kQAV.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $8wG98.durationMinute)) / (0, $8wG98.durationDay), (date)=>date.getDate() - 1);
const $48cf65a65f3c9b44$export$6657a54f3034cf45 = $48cf65a65f3c9b44$export$8888529b966033e5.range;
const $48cf65a65f3c9b44$export$c8cbc42cefd47140 = (0, $4kQAV.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $8wG98.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $48cf65a65f3c9b44$export$d277e198508549a1 = $48cf65a65f3c9b44$export$c8cbc42cefd47140.range;
const $48cf65a65f3c9b44$export$fb065be2d7ea4a71 = (0, $4kQAV.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $8wG98.durationDay);
}, (date)=>{
    return Math.floor(date / (0, $8wG98.durationDay));
});
const $48cf65a65f3c9b44$export$a491caaf5e9481aa = $48cf65a65f3c9b44$export$fb065be2d7ea4a71.range;

});
parcelRegister("4kQAV", function(module, exports) {

$parcel$export(module.exports, "timeInterval", function () { return $3281d3e3aa6840ac$export$1a539c8b2950ab40; });
const $3281d3e3aa6840ac$var$t0 = new Date, $3281d3e3aa6840ac$var$t1 = new Date;
function $3281d3e3aa6840ac$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $3281d3e3aa6840ac$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $3281d3e3aa6840ac$var$t0.setTime(+start), $3281d3e3aa6840ac$var$t1.setTime(+end);
            floori($3281d3e3aa6840ac$var$t0), floori($3281d3e3aa6840ac$var$t1);
            return Math.floor(count($3281d3e3aa6840ac$var$t0, $3281d3e3aa6840ac$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

});

parcelRegister("8wG98", function(module, exports) {

$parcel$export(module.exports, "durationSecond", function () { return $635201452e78d100$export$79ef0e34099623dc; });
$parcel$export(module.exports, "durationMinute", function () { return $635201452e78d100$export$683905d551c33fa9; });
$parcel$export(module.exports, "durationHour", function () { return $635201452e78d100$export$4157bf0c8e241659; });
$parcel$export(module.exports, "durationDay", function () { return $635201452e78d100$export$353686095f4fbf45; });
$parcel$export(module.exports, "durationWeek", function () { return $635201452e78d100$export$c241eb88520d5016; });
$parcel$export(module.exports, "durationMonth", function () { return $635201452e78d100$export$ab95684df7020b26; });
$parcel$export(module.exports, "durationYear", function () { return $635201452e78d100$export$61f8ee2d834c6959; });
const $635201452e78d100$export$79ef0e34099623dc = 1000;
const $635201452e78d100$export$683905d551c33fa9 = $635201452e78d100$export$79ef0e34099623dc * 60;
const $635201452e78d100$export$4157bf0c8e241659 = $635201452e78d100$export$683905d551c33fa9 * 60;
const $635201452e78d100$export$353686095f4fbf45 = $635201452e78d100$export$4157bf0c8e241659 * 24;
const $635201452e78d100$export$c241eb88520d5016 = $635201452e78d100$export$353686095f4fbf45 * 7;
const $635201452e78d100$export$ab95684df7020b26 = $635201452e78d100$export$353686095f4fbf45 * 30;
const $635201452e78d100$export$61f8ee2d834c6959 = $635201452e78d100$export$353686095f4fbf45 * 365;

});


parcelRegister("3hgbf", function(module, exports) {

$parcel$export(module.exports, "timeHour", function () { return $262f82bbb76dc32e$export$46c68a5833bc315b; });
$parcel$export(module.exports, "timeHours", function () { return $262f82bbb76dc32e$export$fb843f9087cd5235; });
$parcel$export(module.exports, "utcHour", function () { return $262f82bbb76dc32e$export$31f6f2b3c63ac75e; });
$parcel$export(module.exports, "utcHours", function () { return $262f82bbb76dc32e$export$6e7a76cd5f50b719; });

var $4kQAV = parcelRequire("4kQAV");

var $8wG98 = parcelRequire("8wG98");
const $262f82bbb76dc32e$export$46c68a5833bc315b = (0, $4kQAV.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $8wG98.durationSecond) - date.getMinutes() * (0, $8wG98.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, $8wG98.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $8wG98.durationHour);
}, (date)=>{
    return date.getHours();
});
const $262f82bbb76dc32e$export$fb843f9087cd5235 = $262f82bbb76dc32e$export$46c68a5833bc315b.range;
const $262f82bbb76dc32e$export$31f6f2b3c63ac75e = (0, $4kQAV.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $8wG98.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $8wG98.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const $262f82bbb76dc32e$export$6e7a76cd5f50b719 = $262f82bbb76dc32e$export$31f6f2b3c63ac75e.range;

});

parcelRegister("7P7u1", function(module, exports) {

$parcel$export(module.exports, "timeMinute", function () { return $5b2319d3ca4c0a06$export$a7e4c34a52f0576; });
$parcel$export(module.exports, "timeMinutes", function () { return $5b2319d3ca4c0a06$export$186d65358374c0a2; });
$parcel$export(module.exports, "utcMinute", function () { return $5b2319d3ca4c0a06$export$efe6712d6003761b; });
$parcel$export(module.exports, "utcMinutes", function () { return $5b2319d3ca4c0a06$export$cedd563624e8ee50; });

var $4kQAV = parcelRequire("4kQAV");

var $8wG98 = parcelRequire("8wG98");
const $5b2319d3ca4c0a06$export$a7e4c34a52f0576 = (0, $4kQAV.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $8wG98.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, $8wG98.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $8wG98.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const $5b2319d3ca4c0a06$export$186d65358374c0a2 = $5b2319d3ca4c0a06$export$a7e4c34a52f0576.range;
const $5b2319d3ca4c0a06$export$efe6712d6003761b = (0, $4kQAV.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $8wG98.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $8wG98.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const $5b2319d3ca4c0a06$export$cedd563624e8ee50 = $5b2319d3ca4c0a06$export$efe6712d6003761b.range;

});

parcelRegister("ceUnP", function(module, exports) {

$parcel$export(module.exports, "timeMonth", function () { return $8e9287622f2dfa46$export$7e1084fb688591c1; });
$parcel$export(module.exports, "timeMonths", function () { return $8e9287622f2dfa46$export$3e24aa839cd0f1c4; });
$parcel$export(module.exports, "utcMonth", function () { return $8e9287622f2dfa46$export$cd49b3d2bcfe50d5; });
$parcel$export(module.exports, "utcMonths", function () { return $8e9287622f2dfa46$export$49159f585997498; });

var $4kQAV = parcelRequire("4kQAV");
const $8e9287622f2dfa46$export$7e1084fb688591c1 = (0, $4kQAV.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $8e9287622f2dfa46$export$3e24aa839cd0f1c4 = $8e9287622f2dfa46$export$7e1084fb688591c1.range;
const $8e9287622f2dfa46$export$cd49b3d2bcfe50d5 = (0, $4kQAV.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $8e9287622f2dfa46$export$49159f585997498 = $8e9287622f2dfa46$export$cd49b3d2bcfe50d5.range;

});

parcelRegister("leuDw", function(module, exports) {

$parcel$export(module.exports, "second", function () { return $f752ab8fc15dd565$export$3d3c77ce7df7d30d; });
$parcel$export(module.exports, "seconds", function () { return $f752ab8fc15dd565$export$4792e48abc550fa1; });

var $4kQAV = parcelRequire("4kQAV");

var $8wG98 = parcelRequire("8wG98");
const $f752ab8fc15dd565$export$3d3c77ce7df7d30d = (0, $4kQAV.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $8wG98.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, $8wG98.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const $f752ab8fc15dd565$export$4792e48abc550fa1 = $f752ab8fc15dd565$export$3d3c77ce7df7d30d.range;

});

parcelRegister("5qbnm", function(module, exports) {

$parcel$export(module.exports, "utcTicks", function () { return $3f283473ff8ed74f$export$826ba5ae907e9767; });
$parcel$export(module.exports, "utcTickInterval", function () { return $3f283473ff8ed74f$export$6262d8d056ea44c4; });
$parcel$export(module.exports, "timeTicks", function () { return $3f283473ff8ed74f$export$60c76498552d28a6; });
$parcel$export(module.exports, "timeTickInterval", function () { return $3f283473ff8ed74f$export$69511150134dd174; });

var $f8fRa = parcelRequire("f8fRa");
var $amLJv = parcelRequire("amLJv");

var $8wG98 = parcelRequire("8wG98");

var $6FfPx = parcelRequire("6FfPx");

var $leuDw = parcelRequire("leuDw");

var $7P7u1 = parcelRequire("7P7u1");

var $3hgbf = parcelRequire("3hgbf");

var $6fz8m = parcelRequire("6fz8m");

var $4gg5r = parcelRequire("4gg5r");

var $ceUnP = parcelRequire("ceUnP");

var $kHofm = parcelRequire("kHofm");
function $3f283473ff8ed74f$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $leuDw.second),
            1,
            (0, $8wG98.durationSecond)
        ],
        [
            (0, $leuDw.second),
            5,
            5 * (0, $8wG98.durationSecond)
        ],
        [
            (0, $leuDw.second),
            15,
            15 * (0, $8wG98.durationSecond)
        ],
        [
            (0, $leuDw.second),
            30,
            30 * (0, $8wG98.durationSecond)
        ],
        [
            minute,
            1,
            (0, $8wG98.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $8wG98.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $8wG98.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $8wG98.durationMinute)
        ],
        [
            hour,
            1,
            (0, $8wG98.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $8wG98.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $8wG98.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $8wG98.durationHour)
        ],
        [
            day,
            1,
            (0, $8wG98.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $8wG98.durationDay)
        ],
        [
            week,
            1,
            (0, $8wG98.durationWeek)
        ],
        [
            month,
            1,
            (0, $8wG98.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $8wG98.durationMonth)
        ],
        [
            year,
            1,
            (0, $8wG98.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $f8fRa.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $amLJv.tickStep)(start / (0, $8wG98.durationYear), stop / (0, $8wG98.durationYear), count));
        if (i === 0) return (0, $6FfPx.millisecond).every(Math.max((0, $amLJv.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$3f283473ff8ed74f$export$826ba5ae907e9767, $3f283473ff8ed74f$export$6262d8d056ea44c4] = $3f283473ff8ed74f$var$ticker((0, $kHofm.utcYear), (0, $ceUnP.utcMonth), (0, $4gg5r.utcSunday), (0, $6fz8m.unixDay), (0, $3hgbf.utcHour), (0, $7P7u1.utcMinute));
const [$3f283473ff8ed74f$export$60c76498552d28a6, $3f283473ff8ed74f$export$69511150134dd174] = $3f283473ff8ed74f$var$ticker((0, $kHofm.timeYear), (0, $ceUnP.timeMonth), (0, $4gg5r.timeSunday), (0, $6fz8m.timeDay), (0, $3hgbf.timeHour), (0, $7P7u1.timeMinute));

});
parcelRegister("6FfPx", function(module, exports) {

$parcel$export(module.exports, "millisecond", function () { return $4da2d9f52813f3a7$export$edc5e5cb87280477; });
$parcel$export(module.exports, "milliseconds", function () { return $4da2d9f52813f3a7$export$9a27fac83d67afd3; });

var $4kQAV = parcelRequire("4kQAV");
const $4da2d9f52813f3a7$export$edc5e5cb87280477 = (0, $4kQAV.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$4da2d9f52813f3a7$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $4da2d9f52813f3a7$export$edc5e5cb87280477;
    return (0, $4kQAV.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $4da2d9f52813f3a7$export$9a27fac83d67afd3 = $4da2d9f52813f3a7$export$edc5e5cb87280477.range;

});

parcelRegister("4gg5r", function(module, exports) {

$parcel$export(module.exports, "timeSunday", function () { return $31a522912b1cd811$export$22ee6205b762968c; });
$parcel$export(module.exports, "timeMonday", function () { return $31a522912b1cd811$export$e79bbe0177cf1b01; });
$parcel$export(module.exports, "timeTuesday", function () { return $31a522912b1cd811$export$57c0658c29f77708; });
$parcel$export(module.exports, "timeWednesday", function () { return $31a522912b1cd811$export$3fbeef226c256e43; });
$parcel$export(module.exports, "timeThursday", function () { return $31a522912b1cd811$export$608689422d5cf9f4; });
$parcel$export(module.exports, "timeFriday", function () { return $31a522912b1cd811$export$548e5227aa183dca; });
$parcel$export(module.exports, "timeSaturday", function () { return $31a522912b1cd811$export$c56a3ad248908e19; });
$parcel$export(module.exports, "timeSundays", function () { return $31a522912b1cd811$export$eac514c8a8674eba; });
$parcel$export(module.exports, "timeMondays", function () { return $31a522912b1cd811$export$f7219b1481948356; });
$parcel$export(module.exports, "timeTuesdays", function () { return $31a522912b1cd811$export$77e22b12c5bed05b; });
$parcel$export(module.exports, "timeWednesdays", function () { return $31a522912b1cd811$export$b85d407a471809e8; });
$parcel$export(module.exports, "timeThursdays", function () { return $31a522912b1cd811$export$c1bc1c49254c8855; });
$parcel$export(module.exports, "timeFridays", function () { return $31a522912b1cd811$export$3691a1557fff46f1; });
$parcel$export(module.exports, "timeSaturdays", function () { return $31a522912b1cd811$export$b755452d02cba8d2; });
$parcel$export(module.exports, "utcSunday", function () { return $31a522912b1cd811$export$4898b06303a92011; });
$parcel$export(module.exports, "utcMonday", function () { return $31a522912b1cd811$export$9cfc53b9cfafd080; });
$parcel$export(module.exports, "utcTuesday", function () { return $31a522912b1cd811$export$2a6d545f77eceb15; });
$parcel$export(module.exports, "utcWednesday", function () { return $31a522912b1cd811$export$a5c25d8ed64433c4; });
$parcel$export(module.exports, "utcThursday", function () { return $31a522912b1cd811$export$1db08111baec2f53; });
$parcel$export(module.exports, "utcFriday", function () { return $31a522912b1cd811$export$29265e34dd5921f7; });
$parcel$export(module.exports, "utcSaturday", function () { return $31a522912b1cd811$export$85b74dad05049604; });
$parcel$export(module.exports, "utcSundays", function () { return $31a522912b1cd811$export$6f3e1c2b0f7d7880; });
$parcel$export(module.exports, "utcMondays", function () { return $31a522912b1cd811$export$1d2d8b858bb366f9; });
$parcel$export(module.exports, "utcTuesdays", function () { return $31a522912b1cd811$export$1d5f6785fc7f30f8; });
$parcel$export(module.exports, "utcWednesdays", function () { return $31a522912b1cd811$export$7a75faf0e37ef4af; });
$parcel$export(module.exports, "utcThursdays", function () { return $31a522912b1cd811$export$417eb959611b2f2f; });
$parcel$export(module.exports, "utcFridays", function () { return $31a522912b1cd811$export$59d308db7af08c64; });
$parcel$export(module.exports, "utcSaturdays", function () { return $31a522912b1cd811$export$a124108a0a7f34c8; });

var $4kQAV = parcelRequire("4kQAV");

var $8wG98 = parcelRequire("8wG98");
function $31a522912b1cd811$var$timeWeekday(i) {
    return (0, $4kQAV.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $8wG98.durationMinute)) / (0, $8wG98.durationWeek);
    });
}
const $31a522912b1cd811$export$22ee6205b762968c = $31a522912b1cd811$var$timeWeekday(0);
const $31a522912b1cd811$export$e79bbe0177cf1b01 = $31a522912b1cd811$var$timeWeekday(1);
const $31a522912b1cd811$export$57c0658c29f77708 = $31a522912b1cd811$var$timeWeekday(2);
const $31a522912b1cd811$export$3fbeef226c256e43 = $31a522912b1cd811$var$timeWeekday(3);
const $31a522912b1cd811$export$608689422d5cf9f4 = $31a522912b1cd811$var$timeWeekday(4);
const $31a522912b1cd811$export$548e5227aa183dca = $31a522912b1cd811$var$timeWeekday(5);
const $31a522912b1cd811$export$c56a3ad248908e19 = $31a522912b1cd811$var$timeWeekday(6);
const $31a522912b1cd811$export$eac514c8a8674eba = $31a522912b1cd811$export$22ee6205b762968c.range;
const $31a522912b1cd811$export$f7219b1481948356 = $31a522912b1cd811$export$e79bbe0177cf1b01.range;
const $31a522912b1cd811$export$77e22b12c5bed05b = $31a522912b1cd811$export$57c0658c29f77708.range;
const $31a522912b1cd811$export$b85d407a471809e8 = $31a522912b1cd811$export$3fbeef226c256e43.range;
const $31a522912b1cd811$export$c1bc1c49254c8855 = $31a522912b1cd811$export$608689422d5cf9f4.range;
const $31a522912b1cd811$export$3691a1557fff46f1 = $31a522912b1cd811$export$548e5227aa183dca.range;
const $31a522912b1cd811$export$b755452d02cba8d2 = $31a522912b1cd811$export$c56a3ad248908e19.range;
function $31a522912b1cd811$var$utcWeekday(i) {
    return (0, $4kQAV.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $8wG98.durationWeek);
    });
}
const $31a522912b1cd811$export$4898b06303a92011 = $31a522912b1cd811$var$utcWeekday(0);
const $31a522912b1cd811$export$9cfc53b9cfafd080 = $31a522912b1cd811$var$utcWeekday(1);
const $31a522912b1cd811$export$2a6d545f77eceb15 = $31a522912b1cd811$var$utcWeekday(2);
const $31a522912b1cd811$export$a5c25d8ed64433c4 = $31a522912b1cd811$var$utcWeekday(3);
const $31a522912b1cd811$export$1db08111baec2f53 = $31a522912b1cd811$var$utcWeekday(4);
const $31a522912b1cd811$export$29265e34dd5921f7 = $31a522912b1cd811$var$utcWeekday(5);
const $31a522912b1cd811$export$85b74dad05049604 = $31a522912b1cd811$var$utcWeekday(6);
const $31a522912b1cd811$export$6f3e1c2b0f7d7880 = $31a522912b1cd811$export$4898b06303a92011.range;
const $31a522912b1cd811$export$1d2d8b858bb366f9 = $31a522912b1cd811$export$9cfc53b9cfafd080.range;
const $31a522912b1cd811$export$1d5f6785fc7f30f8 = $31a522912b1cd811$export$2a6d545f77eceb15.range;
const $31a522912b1cd811$export$7a75faf0e37ef4af = $31a522912b1cd811$export$a5c25d8ed64433c4.range;
const $31a522912b1cd811$export$417eb959611b2f2f = $31a522912b1cd811$export$1db08111baec2f53.range;
const $31a522912b1cd811$export$59d308db7af08c64 = $31a522912b1cd811$export$29265e34dd5921f7.range;
const $31a522912b1cd811$export$a124108a0a7f34c8 = $31a522912b1cd811$export$85b74dad05049604.range;

});

parcelRegister("kHofm", function(module, exports) {

$parcel$export(module.exports, "timeYear", function () { return $f11aa1b43eaad108$export$cd17cfe45df0c046; });
$parcel$export(module.exports, "timeYears", function () { return $f11aa1b43eaad108$export$69a4e90dd2cc3bd1; });
$parcel$export(module.exports, "utcYear", function () { return $f11aa1b43eaad108$export$d5c3802e389714c4; });
$parcel$export(module.exports, "utcYears", function () { return $f11aa1b43eaad108$export$3e24d311e17f5802; });

var $4kQAV = parcelRequire("4kQAV");
const $f11aa1b43eaad108$export$cd17cfe45df0c046 = (0, $4kQAV.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$f11aa1b43eaad108$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $4kQAV.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $f11aa1b43eaad108$export$69a4e90dd2cc3bd1 = $f11aa1b43eaad108$export$cd17cfe45df0c046.range;
const $f11aa1b43eaad108$export$d5c3802e389714c4 = (0, $4kQAV.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$f11aa1b43eaad108$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $4kQAV.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $f11aa1b43eaad108$export$3e24d311e17f5802 = $f11aa1b43eaad108$export$d5c3802e389714c4.range;

});


parcelRegister("eo1Zn", function(module, exports) {

$parcel$export(module.exports, "timeFormat", function () { return $a794d99055ad1ce9$export$94f4d87fad5dcf9a; });
$parcel$export(module.exports, "timeParse", function () { return $a794d99055ad1ce9$export$32b9cd16e1b8c8d2; });
$parcel$export(module.exports, "utcFormat", function () { return $a794d99055ad1ce9$export$1a08fe38f63ebbbb; });
$parcel$export(module.exports, "utcParse", function () { return $a794d99055ad1ce9$export$3edae9cf8e233729; });
$parcel$export(module.exports, "default", function () { return $a794d99055ad1ce9$export$2e2bcd8739ae039; });

var $fhkRg = parcelRequire("fhkRg");
var $a794d99055ad1ce9$var$locale;
var $a794d99055ad1ce9$export$94f4d87fad5dcf9a;
var $a794d99055ad1ce9$export$32b9cd16e1b8c8d2;
var $a794d99055ad1ce9$export$1a08fe38f63ebbbb;
var $a794d99055ad1ce9$export$3edae9cf8e233729;
$a794d99055ad1ce9$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $a794d99055ad1ce9$export$2e2bcd8739ae039(definition) {
    $a794d99055ad1ce9$var$locale = (0, $fhkRg.default)(definition);
    $a794d99055ad1ce9$export$94f4d87fad5dcf9a = $a794d99055ad1ce9$var$locale.format;
    $a794d99055ad1ce9$export$32b9cd16e1b8c8d2 = $a794d99055ad1ce9$var$locale.parse;
    $a794d99055ad1ce9$export$1a08fe38f63ebbbb = $a794d99055ad1ce9$var$locale.utcFormat;
    $a794d99055ad1ce9$export$3edae9cf8e233729 = $a794d99055ad1ce9$var$locale.utcParse;
    return $a794d99055ad1ce9$var$locale;
}

});
parcelRegister("fhkRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1f89f83bf71b2ec$export$2e2bcd8739ae039; });

var $6fz8m = parcelRequire("6fz8m");
var $4gg5r = parcelRequire("4gg5r");
var $kHofm = parcelRequire("kHofm");
function $b1f89f83bf71b2ec$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $b1f89f83bf71b2ec$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $b1f89f83bf71b2ec$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $b1f89f83bf71b2ec$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $b1f89f83bf71b2ec$var$formatRe(locale_periods), periodLookup = $b1f89f83bf71b2ec$var$formatLookup(locale_periods), weekdayRe = $b1f89f83bf71b2ec$var$formatRe(locale_weekdays), weekdayLookup = $b1f89f83bf71b2ec$var$formatLookup(locale_weekdays), shortWeekdayRe = $b1f89f83bf71b2ec$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $b1f89f83bf71b2ec$var$formatLookup(locale_shortWeekdays), monthRe = $b1f89f83bf71b2ec$var$formatRe(locale_months), monthLookup = $b1f89f83bf71b2ec$var$formatLookup(locale_months), shortMonthRe = $b1f89f83bf71b2ec$var$formatRe(locale_shortMonths), shortMonthLookup = $b1f89f83bf71b2ec$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $b1f89f83bf71b2ec$var$formatDayOfMonth,
        "e": $b1f89f83bf71b2ec$var$formatDayOfMonth,
        "f": $b1f89f83bf71b2ec$var$formatMicroseconds,
        "g": $b1f89f83bf71b2ec$var$formatYearISO,
        "G": $b1f89f83bf71b2ec$var$formatFullYearISO,
        "H": $b1f89f83bf71b2ec$var$formatHour24,
        "I": $b1f89f83bf71b2ec$var$formatHour12,
        "j": $b1f89f83bf71b2ec$var$formatDayOfYear,
        "L": $b1f89f83bf71b2ec$var$formatMilliseconds,
        "m": $b1f89f83bf71b2ec$var$formatMonthNumber,
        "M": $b1f89f83bf71b2ec$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $b1f89f83bf71b2ec$var$formatUnixTimestamp,
        "s": $b1f89f83bf71b2ec$var$formatUnixTimestampSeconds,
        "S": $b1f89f83bf71b2ec$var$formatSeconds,
        "u": $b1f89f83bf71b2ec$var$formatWeekdayNumberMonday,
        "U": $b1f89f83bf71b2ec$var$formatWeekNumberSunday,
        "V": $b1f89f83bf71b2ec$var$formatWeekNumberISO,
        "w": $b1f89f83bf71b2ec$var$formatWeekdayNumberSunday,
        "W": $b1f89f83bf71b2ec$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b1f89f83bf71b2ec$var$formatYear,
        "Y": $b1f89f83bf71b2ec$var$formatFullYear,
        "Z": $b1f89f83bf71b2ec$var$formatZone,
        "%": $b1f89f83bf71b2ec$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $b1f89f83bf71b2ec$var$formatUTCDayOfMonth,
        "e": $b1f89f83bf71b2ec$var$formatUTCDayOfMonth,
        "f": $b1f89f83bf71b2ec$var$formatUTCMicroseconds,
        "g": $b1f89f83bf71b2ec$var$formatUTCYearISO,
        "G": $b1f89f83bf71b2ec$var$formatUTCFullYearISO,
        "H": $b1f89f83bf71b2ec$var$formatUTCHour24,
        "I": $b1f89f83bf71b2ec$var$formatUTCHour12,
        "j": $b1f89f83bf71b2ec$var$formatUTCDayOfYear,
        "L": $b1f89f83bf71b2ec$var$formatUTCMilliseconds,
        "m": $b1f89f83bf71b2ec$var$formatUTCMonthNumber,
        "M": $b1f89f83bf71b2ec$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $b1f89f83bf71b2ec$var$formatUnixTimestamp,
        "s": $b1f89f83bf71b2ec$var$formatUnixTimestampSeconds,
        "S": $b1f89f83bf71b2ec$var$formatUTCSeconds,
        "u": $b1f89f83bf71b2ec$var$formatUTCWeekdayNumberMonday,
        "U": $b1f89f83bf71b2ec$var$formatUTCWeekNumberSunday,
        "V": $b1f89f83bf71b2ec$var$formatUTCWeekNumberISO,
        "w": $b1f89f83bf71b2ec$var$formatUTCWeekdayNumberSunday,
        "W": $b1f89f83bf71b2ec$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b1f89f83bf71b2ec$var$formatUTCYear,
        "Y": $b1f89f83bf71b2ec$var$formatUTCFullYear,
        "Z": $b1f89f83bf71b2ec$var$formatUTCZone,
        "%": $b1f89f83bf71b2ec$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $b1f89f83bf71b2ec$var$parseDayOfMonth,
        "e": $b1f89f83bf71b2ec$var$parseDayOfMonth,
        "f": $b1f89f83bf71b2ec$var$parseMicroseconds,
        "g": $b1f89f83bf71b2ec$var$parseYear,
        "G": $b1f89f83bf71b2ec$var$parseFullYear,
        "H": $b1f89f83bf71b2ec$var$parseHour24,
        "I": $b1f89f83bf71b2ec$var$parseHour24,
        "j": $b1f89f83bf71b2ec$var$parseDayOfYear,
        "L": $b1f89f83bf71b2ec$var$parseMilliseconds,
        "m": $b1f89f83bf71b2ec$var$parseMonthNumber,
        "M": $b1f89f83bf71b2ec$var$parseMinutes,
        "p": parsePeriod,
        "q": $b1f89f83bf71b2ec$var$parseQuarter,
        "Q": $b1f89f83bf71b2ec$var$parseUnixTimestamp,
        "s": $b1f89f83bf71b2ec$var$parseUnixTimestampSeconds,
        "S": $b1f89f83bf71b2ec$var$parseSeconds,
        "u": $b1f89f83bf71b2ec$var$parseWeekdayNumberMonday,
        "U": $b1f89f83bf71b2ec$var$parseWeekNumberSunday,
        "V": $b1f89f83bf71b2ec$var$parseWeekNumberISO,
        "w": $b1f89f83bf71b2ec$var$parseWeekdayNumberSunday,
        "W": $b1f89f83bf71b2ec$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $b1f89f83bf71b2ec$var$parseYear,
        "Y": $b1f89f83bf71b2ec$var$parseFullYear,
        "Z": $b1f89f83bf71b2ec$var$parseZone,
        "%": $b1f89f83bf71b2ec$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $b1f89f83bf71b2ec$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $b1f89f83bf71b2ec$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $b1f89f83bf71b2ec$var$utcDate($b1f89f83bf71b2ec$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $4gg5r.utcMonday).ceil(week) : (0, $4gg5r.utcMonday)(week);
                    week = (0, $6fz8m.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $b1f89f83bf71b2ec$var$localDate($b1f89f83bf71b2ec$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $4gg5r.timeMonday).ceil(week) : (0, $4gg5r.timeMonday)(week);
                    week = (0, $6fz8m.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $b1f89f83bf71b2ec$var$utcDate($b1f89f83bf71b2ec$var$newDate(d.y, 0, 1)).getUTCDay() : $b1f89f83bf71b2ec$var$localDate($b1f89f83bf71b2ec$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $b1f89f83bf71b2ec$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $b1f89f83bf71b2ec$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $b1f89f83bf71b2ec$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $b1f89f83bf71b2ec$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $b1f89f83bf71b2ec$var$numberRe = /^\s*\d+/, $b1f89f83bf71b2ec$var$percentRe = /^%/, $b1f89f83bf71b2ec$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $b1f89f83bf71b2ec$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $b1f89f83bf71b2ec$var$requote(s) {
    return s.replace($b1f89f83bf71b2ec$var$requoteRe, "\\$&");
}
function $b1f89f83bf71b2ec$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($b1f89f83bf71b2ec$var$requote).join("|") + ")", "i");
}
function $b1f89f83bf71b2ec$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $b1f89f83bf71b2ec$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseWeekNumberSunday(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseWeekNumberISO(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseWeekNumberMonday(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseFullYear(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseYear(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseQuarter(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseMonthNumber(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseDayOfMonth(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseDayOfYear(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseHour24(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseMinutes(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseSeconds(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseMilliseconds(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseMicroseconds(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseLiteralPercent(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $b1f89f83bf71b2ec$var$parseUnixTimestamp(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $b1f89f83bf71b2ec$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $b1f89f83bf71b2ec$var$formatDayOfMonth(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getDate(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatHour24(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getHours(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatHour12(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $b1f89f83bf71b2ec$var$formatDayOfYear(d, p) {
    return $b1f89f83bf71b2ec$var$pad(1 + (0, $6fz8m.timeDay).count((0, $kHofm.timeYear)(d), d), p, 3);
}
function $b1f89f83bf71b2ec$var$formatMilliseconds(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getMilliseconds(), p, 3);
}
function $b1f89f83bf71b2ec$var$formatMicroseconds(d, p) {
    return $b1f89f83bf71b2ec$var$formatMilliseconds(d, p) + "000";
}
function $b1f89f83bf71b2ec$var$formatMonthNumber(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getMonth() + 1, p, 2);
}
function $b1f89f83bf71b2ec$var$formatMinutes(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getMinutes(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatSeconds(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getSeconds(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $b1f89f83bf71b2ec$var$formatWeekNumberSunday(d, p) {
    return $b1f89f83bf71b2ec$var$pad((0, $4gg5r.timeSunday).count((0, $kHofm.timeYear)(d) - 1, d), p, 2);
}
function $b1f89f83bf71b2ec$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $4gg5r.timeThursday)(d) : (0, $4gg5r.timeThursday).ceil(d);
}
function $b1f89f83bf71b2ec$var$formatWeekNumberISO(d, p) {
    d = $b1f89f83bf71b2ec$var$dISO(d);
    return $b1f89f83bf71b2ec$var$pad((0, $4gg5r.timeThursday).count((0, $kHofm.timeYear)(d), d) + ((0, $kHofm.timeYear)(d).getDay() === 4), p, 2);
}
function $b1f89f83bf71b2ec$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $b1f89f83bf71b2ec$var$formatWeekNumberMonday(d, p) {
    return $b1f89f83bf71b2ec$var$pad((0, $4gg5r.timeMonday).count((0, $kHofm.timeYear)(d) - 1, d), p, 2);
}
function $b1f89f83bf71b2ec$var$formatYear(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getFullYear() % 100, p, 2);
}
function $b1f89f83bf71b2ec$var$formatYearISO(d, p) {
    d = $b1f89f83bf71b2ec$var$dISO(d);
    return $b1f89f83bf71b2ec$var$pad(d.getFullYear() % 100, p, 2);
}
function $b1f89f83bf71b2ec$var$formatFullYear(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b1f89f83bf71b2ec$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $4gg5r.timeThursday)(d) : (0, $4gg5r.timeThursday).ceil(d);
    return $b1f89f83bf71b2ec$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b1f89f83bf71b2ec$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $b1f89f83bf71b2ec$var$pad(z / 60 | 0, "0", 2) + $b1f89f83bf71b2ec$var$pad(z % 60, "0", 2);
}
function $b1f89f83bf71b2ec$var$formatUTCDayOfMonth(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCDate(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCHour24(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCHours(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCHour12(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCDayOfYear(d, p) {
    return $b1f89f83bf71b2ec$var$pad(1 + (0, $6fz8m.utcDay).count((0, $kHofm.utcYear)(d), d), p, 3);
}
function $b1f89f83bf71b2ec$var$formatUTCMilliseconds(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $b1f89f83bf71b2ec$var$formatUTCMicroseconds(d, p) {
    return $b1f89f83bf71b2ec$var$formatUTCMilliseconds(d, p) + "000";
}
function $b1f89f83bf71b2ec$var$formatUTCMonthNumber(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCMinutes(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCMinutes(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCSeconds(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCSeconds(), p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $b1f89f83bf71b2ec$var$formatUTCWeekNumberSunday(d, p) {
    return $b1f89f83bf71b2ec$var$pad((0, $4gg5r.utcSunday).count((0, $kHofm.utcYear)(d) - 1, d), p, 2);
}
function $b1f89f83bf71b2ec$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $4gg5r.utcThursday)(d) : (0, $4gg5r.utcThursday).ceil(d);
}
function $b1f89f83bf71b2ec$var$formatUTCWeekNumberISO(d, p) {
    d = $b1f89f83bf71b2ec$var$UTCdISO(d);
    return $b1f89f83bf71b2ec$var$pad((0, $4gg5r.utcThursday).count((0, $kHofm.utcYear)(d), d) + ((0, $kHofm.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $b1f89f83bf71b2ec$var$formatUTCWeekNumberMonday(d, p) {
    return $b1f89f83bf71b2ec$var$pad((0, $4gg5r.utcMonday).count((0, $kHofm.utcYear)(d) - 1, d), p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCYear(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCYearISO(d, p) {
    d = $b1f89f83bf71b2ec$var$UTCdISO(d);
    return $b1f89f83bf71b2ec$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b1f89f83bf71b2ec$var$formatUTCFullYear(d, p) {
    return $b1f89f83bf71b2ec$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b1f89f83bf71b2ec$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $4gg5r.utcThursday)(d) : (0, $4gg5r.utcThursday).ceil(d);
    return $b1f89f83bf71b2ec$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b1f89f83bf71b2ec$var$formatUTCZone() {
    return "+0000";
}
function $b1f89f83bf71b2ec$var$formatLiteralPercent() {
    return "%";
}
function $b1f89f83bf71b2ec$var$formatUnixTimestamp(d) {
    return +d;
}
function $b1f89f83bf71b2ec$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});



parcelRegister("1Y70c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16f0d38a6fa93735$export$2e2bcd8739ae039; });

var $6fz8m = parcelRequire("6fz8m");
var $3hgbf = parcelRequire("3hgbf");
var $7P7u1 = parcelRequire("7P7u1");
var $ceUnP = parcelRequire("ceUnP");
var $leuDw = parcelRequire("leuDw");
var $5qbnm = parcelRequire("5qbnm");
var $4gg5r = parcelRequire("4gg5r");
var $kHofm = parcelRequire("kHofm");

var $eo1Zn = parcelRequire("eo1Zn");

var $aLd8A = parcelRequire("aLd8A");

var $33fAq = parcelRequire("33fAq");
function $16f0d38a6fa93735$export$2e2bcd8739ae039() {
    return (0, $33fAq.initRange).apply((0, $aLd8A.calendar)((0, $5qbnm.utcTicks), (0, $5qbnm.utcTickInterval), (0, $kHofm.utcYear), (0, $ceUnP.utcMonth), (0, $4gg5r.utcSunday), (0, $6fz8m.utcDay), (0, $3hgbf.utcHour), (0, $7P7u1.utcMinute), (0, $leuDw.second), (0, $eo1Zn.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("21aYu", function(module, exports) {

$parcel$export(module.exports, "copy", function () { return $1784301fa2c1e0b7$export$784d13d8ee351f07; });
$parcel$export(module.exports, "default", function () { return $1784301fa2c1e0b7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sequentialLog", function () { return $1784301fa2c1e0b7$export$6843e08bf2ff981f; });
$parcel$export(module.exports, "sequentialSymlog", function () { return $1784301fa2c1e0b7$export$9d4af4de62c81941; });
$parcel$export(module.exports, "sequentialPow", function () { return $1784301fa2c1e0b7$export$de9f78581b4f2405; });
$parcel$export(module.exports, "sequentialSqrt", function () { return $1784301fa2c1e0b7$export$413d935127ed466e; });

var $hAt8X = parcelRequire("hAt8X");
var $EDADb = parcelRequire("EDADb");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");

var $4G7qM = parcelRequire("4G7qM");

var $gLv5r = parcelRequire("gLv5r");

var $hdWxy = parcelRequire("hdWxy");

var $8Odyk = parcelRequire("8Odyk");
function $1784301fa2c1e0b7$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $knO4f.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $hAt8X.default));
    scale.rangeRound = range((0, $EDADb.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $1784301fa2c1e0b7$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $1784301fa2c1e0b7$export$2e2bcd8739ae039() {
    var scale = (0, $4G7qM.linearish)($1784301fa2c1e0b7$var$transformer()((0, $knO4f.identity)));
    scale.copy = function() {
        return $1784301fa2c1e0b7$export$784d13d8ee351f07(scale, $1784301fa2c1e0b7$export$2e2bcd8739ae039());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $1784301fa2c1e0b7$export$6843e08bf2ff981f() {
    var scale = (0, $gLv5r.loggish)($1784301fa2c1e0b7$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $1784301fa2c1e0b7$export$784d13d8ee351f07(scale, $1784301fa2c1e0b7$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $1784301fa2c1e0b7$export$9d4af4de62c81941() {
    var scale = (0, $hdWxy.symlogish)($1784301fa2c1e0b7$var$transformer());
    scale.copy = function() {
        return $1784301fa2c1e0b7$export$784d13d8ee351f07(scale, $1784301fa2c1e0b7$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $1784301fa2c1e0b7$export$de9f78581b4f2405() {
    var scale = (0, $8Odyk.powish)($1784301fa2c1e0b7$var$transformer());
    scale.copy = function() {
        return $1784301fa2c1e0b7$export$784d13d8ee351f07(scale, $1784301fa2c1e0b7$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $1784301fa2c1e0b7$export$413d935127ed466e() {
    return $1784301fa2c1e0b7$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("QXau9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09f2c0ffc61da299$export$2e2bcd8739ae039; });

var $mbn54 = parcelRequire("mbn54");
var $eZf2H = parcelRequire("eZf2H");
var $hr3aa = parcelRequire("hr3aa");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");
function $09f2c0ffc61da299$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $knO4f.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $eZf2H.default)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $mbn54.default));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $hr3aa.default)(domain, i / n));
    };
    scale.copy = function() {
        return $09f2c0ffc61da299$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}

});

parcelRegister("d3a3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98035a076382f82e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "divergingLog", function () { return $98035a076382f82e$export$5f0266a9159c47fb; });
$parcel$export(module.exports, "divergingSymlog", function () { return $98035a076382f82e$export$50b3da713cf557c6; });
$parcel$export(module.exports, "divergingPow", function () { return $98035a076382f82e$export$d6cedcc63bf26e7e; });
$parcel$export(module.exports, "divergingSqrt", function () { return $98035a076382f82e$export$33ddefb5c4ab9e9c; });

var $hAt8X = parcelRequire("hAt8X");
var $EDADb = parcelRequire("EDADb");
var $8FaV9 = parcelRequire("8FaV9");

var $knO4f = parcelRequire("knO4f");

var $33fAq = parcelRequire("33fAq");

var $4G7qM = parcelRequire("4G7qM");

var $gLv5r = parcelRequire("gLv5r");

var $21aYu = parcelRequire("21aYu");

var $hdWxy = parcelRequire("hdWxy");

var $8Odyk = parcelRequire("8Odyk");
function $98035a076382f82e$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $knO4f.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $8FaV9.default)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $hAt8X.default));
    scale.rangeRound = range((0, $EDADb.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $98035a076382f82e$export$2e2bcd8739ae039() {
    var scale = (0, $4G7qM.linearish)($98035a076382f82e$var$transformer()((0, $knO4f.identity)));
    scale.copy = function() {
        return (0, $21aYu.copy)(scale, $98035a076382f82e$export$2e2bcd8739ae039());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $98035a076382f82e$export$5f0266a9159c47fb() {
    var scale = (0, $gLv5r.loggish)($98035a076382f82e$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $21aYu.copy)(scale, $98035a076382f82e$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $98035a076382f82e$export$50b3da713cf557c6() {
    var scale = (0, $hdWxy.symlogish)($98035a076382f82e$var$transformer());
    scale.copy = function() {
        return (0, $21aYu.copy)(scale, $98035a076382f82e$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $98035a076382f82e$export$d6cedcc63bf26e7e() {
    var scale = (0, $8Odyk.powish)($98035a076382f82e$var$transformer());
    scale.copy = function() {
        return (0, $21aYu.copy)(scale, $98035a076382f82e$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $33fAq.initInterpolator).apply(scale, arguments);
}
function $98035a076382f82e$export$33ddefb5c4ab9e9c() {
    return $98035a076382f82e$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});


parcelRegister("8dIxz", function(module, exports) {

$parcel$export(module.exports, "schemeCategory10", function () { return (parcelRequire("7R7o4")).default; });
$parcel$export(module.exports, "schemeAccent", function () { return (parcelRequire("cBrCb")).default; });
$parcel$export(module.exports, "schemeDark2", function () { return (parcelRequire("f90DJ")).default; });
$parcel$export(module.exports, "schemePaired", function () { return (parcelRequire("idOsC")).default; });
$parcel$export(module.exports, "schemePastel1", function () { return (parcelRequire("bgnKw")).default; });
$parcel$export(module.exports, "schemePastel2", function () { return (parcelRequire("k4SYi")).default; });
$parcel$export(module.exports, "schemeSet1", function () { return (parcelRequire("3AX7V")).default; });
$parcel$export(module.exports, "schemeSet2", function () { return (parcelRequire("bGyi0")).default; });
$parcel$export(module.exports, "schemeSet3", function () { return (parcelRequire("jsFJa")).default; });
$parcel$export(module.exports, "schemeTableau10", function () { return (parcelRequire("duOFB")).default; });
$parcel$export(module.exports, "interpolateBrBG", function () { return (parcelRequire("2Mjzk")).default; });
$parcel$export(module.exports, "schemeBrBG", function () { return (parcelRequire("2Mjzk")).scheme; });
$parcel$export(module.exports, "interpolatePRGn", function () { return (parcelRequire("2Ejwj")).default; });
$parcel$export(module.exports, "schemePRGn", function () { return (parcelRequire("2Ejwj")).scheme; });
$parcel$export(module.exports, "interpolatePiYG", function () { return (parcelRequire("8o9U2")).default; });
$parcel$export(module.exports, "schemePiYG", function () { return (parcelRequire("8o9U2")).scheme; });
$parcel$export(module.exports, "interpolatePuOr", function () { return (parcelRequire("lEklU")).default; });
$parcel$export(module.exports, "schemePuOr", function () { return (parcelRequire("lEklU")).scheme; });
$parcel$export(module.exports, "interpolateRdBu", function () { return (parcelRequire("a0Zr8")).default; });
$parcel$export(module.exports, "schemeRdBu", function () { return (parcelRequire("a0Zr8")).scheme; });
$parcel$export(module.exports, "interpolateRdGy", function () { return (parcelRequire("fj1dZ")).default; });
$parcel$export(module.exports, "schemeRdGy", function () { return (parcelRequire("fj1dZ")).scheme; });
$parcel$export(module.exports, "interpolateRdYlBu", function () { return (parcelRequire("6GbLa")).default; });
$parcel$export(module.exports, "schemeRdYlBu", function () { return (parcelRequire("6GbLa")).scheme; });
$parcel$export(module.exports, "interpolateRdYlGn", function () { return (parcelRequire("62sdZ")).default; });
$parcel$export(module.exports, "schemeRdYlGn", function () { return (parcelRequire("62sdZ")).scheme; });
$parcel$export(module.exports, "interpolateSpectral", function () { return (parcelRequire("imXw9")).default; });
$parcel$export(module.exports, "schemeSpectral", function () { return (parcelRequire("imXw9")).scheme; });
$parcel$export(module.exports, "interpolateBuGn", function () { return (parcelRequire("kDWJT")).default; });
$parcel$export(module.exports, "schemeBuGn", function () { return (parcelRequire("kDWJT")).scheme; });
$parcel$export(module.exports, "interpolateBuPu", function () { return (parcelRequire("irMZU")).default; });
$parcel$export(module.exports, "schemeBuPu", function () { return (parcelRequire("irMZU")).scheme; });
$parcel$export(module.exports, "interpolateGnBu", function () { return (parcelRequire("cEBGH")).default; });
$parcel$export(module.exports, "schemeGnBu", function () { return (parcelRequire("cEBGH")).scheme; });
$parcel$export(module.exports, "interpolateOrRd", function () { return (parcelRequire("e8uid")).default; });
$parcel$export(module.exports, "schemeOrRd", function () { return (parcelRequire("e8uid")).scheme; });
$parcel$export(module.exports, "interpolatePuBuGn", function () { return (parcelRequire("7RlYM")).default; });
$parcel$export(module.exports, "schemePuBuGn", function () { return (parcelRequire("7RlYM")).scheme; });
$parcel$export(module.exports, "interpolatePuBu", function () { return (parcelRequire("dtcu1")).default; });
$parcel$export(module.exports, "schemePuBu", function () { return (parcelRequire("dtcu1")).scheme; });
$parcel$export(module.exports, "interpolatePuRd", function () { return (parcelRequire("lXGCH")).default; });
$parcel$export(module.exports, "schemePuRd", function () { return (parcelRequire("lXGCH")).scheme; });
$parcel$export(module.exports, "interpolateRdPu", function () { return (parcelRequire("eO2tQ")).default; });
$parcel$export(module.exports, "schemeRdPu", function () { return (parcelRequire("eO2tQ")).scheme; });
$parcel$export(module.exports, "interpolateYlGnBu", function () { return (parcelRequire("1QokA")).default; });
$parcel$export(module.exports, "schemeYlGnBu", function () { return (parcelRequire("1QokA")).scheme; });
$parcel$export(module.exports, "interpolateYlGn", function () { return (parcelRequire("9R4G8")).default; });
$parcel$export(module.exports, "schemeYlGn", function () { return (parcelRequire("9R4G8")).scheme; });
$parcel$export(module.exports, "interpolateYlOrBr", function () { return (parcelRequire("9ZxZK")).default; });
$parcel$export(module.exports, "schemeYlOrBr", function () { return (parcelRequire("9ZxZK")).scheme; });
$parcel$export(module.exports, "interpolateYlOrRd", function () { return (parcelRequire("ji02Y")).default; });
$parcel$export(module.exports, "schemeYlOrRd", function () { return (parcelRequire("ji02Y")).scheme; });
$parcel$export(module.exports, "interpolateBlues", function () { return (parcelRequire("9AiTM")).default; });
$parcel$export(module.exports, "schemeBlues", function () { return (parcelRequire("9AiTM")).scheme; });
$parcel$export(module.exports, "interpolateGreens", function () { return (parcelRequire("gd22Q")).default; });
$parcel$export(module.exports, "schemeGreens", function () { return (parcelRequire("gd22Q")).scheme; });
$parcel$export(module.exports, "interpolateGreys", function () { return (parcelRequire("hfL9u")).default; });
$parcel$export(module.exports, "schemeGreys", function () { return (parcelRequire("hfL9u")).scheme; });
$parcel$export(module.exports, "interpolatePurples", function () { return (parcelRequire("2LkwV")).default; });
$parcel$export(module.exports, "schemePurples", function () { return (parcelRequire("2LkwV")).scheme; });
$parcel$export(module.exports, "interpolateReds", function () { return (parcelRequire("kAcPv")).default; });
$parcel$export(module.exports, "schemeReds", function () { return (parcelRequire("kAcPv")).scheme; });
$parcel$export(module.exports, "interpolateOranges", function () { return (parcelRequire("3IwSR")).default; });
$parcel$export(module.exports, "schemeOranges", function () { return (parcelRequire("3IwSR")).scheme; });
$parcel$export(module.exports, "interpolateCividis", function () { return (parcelRequire("a5b2h")).default; });
$parcel$export(module.exports, "interpolateCubehelixDefault", function () { return (parcelRequire("2Q0GF")).default; });
$parcel$export(module.exports, "interpolateRainbow", function () { return (parcelRequire("lbeF7")).default; });
$parcel$export(module.exports, "interpolateWarm", function () { return (parcelRequire("lbeF7")).warm; });
$parcel$export(module.exports, "interpolateCool", function () { return (parcelRequire("lbeF7")).cool; });
$parcel$export(module.exports, "interpolateSinebow", function () { return (parcelRequire("4Z7n6")).default; });
$parcel$export(module.exports, "interpolateTurbo", function () { return (parcelRequire("7EoQb")).default; });
$parcel$export(module.exports, "interpolateViridis", function () { return (parcelRequire("a5cpq")).default; });
$parcel$export(module.exports, "interpolateMagma", function () { return (parcelRequire("a5cpq")).magma; });
$parcel$export(module.exports, "interpolateInferno", function () { return (parcelRequire("a5cpq")).inferno; });
$parcel$export(module.exports, "interpolatePlasma", function () { return (parcelRequire("a5cpq")).plasma; });

var $7R7o4 = parcelRequire("7R7o4");

var $cBrCb = parcelRequire("cBrCb");

var $f90DJ = parcelRequire("f90DJ");

var $idOsC = parcelRequire("idOsC");

var $bgnKw = parcelRequire("bgnKw");

var $k4SYi = parcelRequire("k4SYi");

var $3AX7V = parcelRequire("3AX7V");

var $bGyi0 = parcelRequire("bGyi0");

var $jsFJa = parcelRequire("jsFJa");

var $duOFB = parcelRequire("duOFB");

var $2Mjzk = parcelRequire("2Mjzk");

var $2Ejwj = parcelRequire("2Ejwj");

var $8o9U2 = parcelRequire("8o9U2");

var $lEklU = parcelRequire("lEklU");

var $a0Zr8 = parcelRequire("a0Zr8");

var $fj1dZ = parcelRequire("fj1dZ");

var $6GbLa = parcelRequire("6GbLa");

var $62sdZ = parcelRequire("62sdZ");

var $imXw9 = parcelRequire("imXw9");

var $kDWJT = parcelRequire("kDWJT");

var $irMZU = parcelRequire("irMZU");

var $cEBGH = parcelRequire("cEBGH");

var $e8uid = parcelRequire("e8uid");

var $7RlYM = parcelRequire("7RlYM");

var $dtcu1 = parcelRequire("dtcu1");

var $lXGCH = parcelRequire("lXGCH");

var $eO2tQ = parcelRequire("eO2tQ");

var $1QokA = parcelRequire("1QokA");

var $9R4G8 = parcelRequire("9R4G8");

var $9ZxZK = parcelRequire("9ZxZK");

var $ji02Y = parcelRequire("ji02Y");

var $9AiTM = parcelRequire("9AiTM");

var $gd22Q = parcelRequire("gd22Q");

var $hfL9u = parcelRequire("hfL9u");

var $2LkwV = parcelRequire("2LkwV");

var $kAcPv = parcelRequire("kAcPv");

var $3IwSR = parcelRequire("3IwSR");

var $a5b2h = parcelRequire("a5b2h");

var $2Q0GF = parcelRequire("2Q0GF");

var $lbeF7 = parcelRequire("lbeF7");

var $4Z7n6 = parcelRequire("4Z7n6");

var $7EoQb = parcelRequire("7EoQb");

var $a5cpq = parcelRequire("a5cpq");

});
parcelRegister("7R7o4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b83369810123ffd$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $5b83369810123ffd$export$2e2bcd8739ae039 = (0, $3RvgX.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

});
parcelRegister("3RvgX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cfe946b5f7b254e$export$2e2bcd8739ae039; });
function $2cfe946b5f7b254e$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}

});


parcelRegister("cBrCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92ce5c79de544214$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $92ce5c79de544214$export$2e2bcd8739ae039 = (0, $3RvgX.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

});

parcelRegister("f90DJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b06831540d433762$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $b06831540d433762$export$2e2bcd8739ae039 = (0, $3RvgX.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

});

parcelRegister("idOsC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d440954b9b964af2$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $d440954b9b964af2$export$2e2bcd8739ae039 = (0, $3RvgX.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

});

parcelRegister("bgnKw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83339c6fe824188c$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $83339c6fe824188c$export$2e2bcd8739ae039 = (0, $3RvgX.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

});

parcelRegister("k4SYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9ded29208585c21$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $e9ded29208585c21$export$2e2bcd8739ae039 = (0, $3RvgX.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

});

parcelRegister("3AX7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29e2993b8baaa8b0$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $29e2993b8baaa8b0$export$2e2bcd8739ae039 = (0, $3RvgX.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

});

parcelRegister("bGyi0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $881e3722658db419$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $881e3722658db419$export$2e2bcd8739ae039 = (0, $3RvgX.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

});

parcelRegister("jsFJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2b10010beb84918$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $e2b10010beb84918$export$2e2bcd8739ae039 = (0, $3RvgX.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

});

parcelRegister("duOFB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d3561b8c65d4a34$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");
var $9d3561b8c65d4a34$export$2e2bcd8739ae039 = (0, $3RvgX.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

});

parcelRegister("2Mjzk", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $205f3e6ae56d3385$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $205f3e6ae56d3385$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $205f3e6ae56d3385$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $3RvgX.default));
var $205f3e6ae56d3385$export$2e2bcd8739ae039 = (0, $wbeO3.default)($205f3e6ae56d3385$export$3005042704f95a69);

});
parcelRegister("wbeO3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $060bb4de7a1932b5$export$2e2bcd8739ae039; });

var $1LBfd = parcelRequire("1LBfd");
var $060bb4de7a1932b5$export$2e2bcd8739ae039 = (scheme)=>(0, $1LBfd.rgbBasis)(scheme[scheme.length - 1]);

});


parcelRegister("2Ejwj", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $1ede758496f99cc1$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $1ede758496f99cc1$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $1ede758496f99cc1$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $3RvgX.default));
var $1ede758496f99cc1$export$2e2bcd8739ae039 = (0, $wbeO3.default)($1ede758496f99cc1$export$3005042704f95a69);

});

parcelRegister("8o9U2", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $61b83f19a8235834$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $61b83f19a8235834$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $61b83f19a8235834$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $3RvgX.default));
var $61b83f19a8235834$export$2e2bcd8739ae039 = (0, $wbeO3.default)($61b83f19a8235834$export$3005042704f95a69);

});

parcelRegister("lEklU", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $fc2d1ef9c679a523$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $fc2d1ef9c679a523$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $fc2d1ef9c679a523$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $3RvgX.default));
var $fc2d1ef9c679a523$export$2e2bcd8739ae039 = (0, $wbeO3.default)($fc2d1ef9c679a523$export$3005042704f95a69);

});

parcelRegister("a0Zr8", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $74a98f7e7a6b4bb2$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $74a98f7e7a6b4bb2$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $74a98f7e7a6b4bb2$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $3RvgX.default));
var $74a98f7e7a6b4bb2$export$2e2bcd8739ae039 = (0, $wbeO3.default)($74a98f7e7a6b4bb2$export$3005042704f95a69);

});

parcelRegister("fj1dZ", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $b249948ad144adc0$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $b249948ad144adc0$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $b249948ad144adc0$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $3RvgX.default));
var $b249948ad144adc0$export$2e2bcd8739ae039 = (0, $wbeO3.default)($b249948ad144adc0$export$3005042704f95a69);

});

parcelRegister("6GbLa", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $4dcfc994029b6b85$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $4dcfc994029b6b85$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $4dcfc994029b6b85$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $3RvgX.default));
var $4dcfc994029b6b85$export$2e2bcd8739ae039 = (0, $wbeO3.default)($4dcfc994029b6b85$export$3005042704f95a69);

});

parcelRegister("62sdZ", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $4658d2caca4109bc$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $4658d2caca4109bc$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $4658d2caca4109bc$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $3RvgX.default));
var $4658d2caca4109bc$export$2e2bcd8739ae039 = (0, $wbeO3.default)($4658d2caca4109bc$export$3005042704f95a69);

});

parcelRegister("imXw9", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $d5f87302d6f1c281$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $d5f87302d6f1c281$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $d5f87302d6f1c281$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $3RvgX.default));
var $d5f87302d6f1c281$export$2e2bcd8739ae039 = (0, $wbeO3.default)($d5f87302d6f1c281$export$3005042704f95a69);

});

parcelRegister("kDWJT", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $f075038c39b13eb5$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $f075038c39b13eb5$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $f075038c39b13eb5$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $3RvgX.default));
var $f075038c39b13eb5$export$2e2bcd8739ae039 = (0, $wbeO3.default)($f075038c39b13eb5$export$3005042704f95a69);

});

parcelRegister("irMZU", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $d6e0c1851b2f824a$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $d6e0c1851b2f824a$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $d6e0c1851b2f824a$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $3RvgX.default));
var $d6e0c1851b2f824a$export$2e2bcd8739ae039 = (0, $wbeO3.default)($d6e0c1851b2f824a$export$3005042704f95a69);

});

parcelRegister("cEBGH", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $936674794902d5f9$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $936674794902d5f9$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $936674794902d5f9$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $3RvgX.default));
var $936674794902d5f9$export$2e2bcd8739ae039 = (0, $wbeO3.default)($936674794902d5f9$export$3005042704f95a69);

});

parcelRegister("e8uid", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $a4a94f9098a6c0d7$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $a4a94f9098a6c0d7$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $a4a94f9098a6c0d7$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $3RvgX.default));
var $a4a94f9098a6c0d7$export$2e2bcd8739ae039 = (0, $wbeO3.default)($a4a94f9098a6c0d7$export$3005042704f95a69);

});

parcelRegister("7RlYM", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $5b8e8844d848a50e$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $5b8e8844d848a50e$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $5b8e8844d848a50e$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $3RvgX.default));
var $5b8e8844d848a50e$export$2e2bcd8739ae039 = (0, $wbeO3.default)($5b8e8844d848a50e$export$3005042704f95a69);

});

parcelRegister("dtcu1", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $9ce7aab90bf8a134$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $9ce7aab90bf8a134$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $9ce7aab90bf8a134$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $3RvgX.default));
var $9ce7aab90bf8a134$export$2e2bcd8739ae039 = (0, $wbeO3.default)($9ce7aab90bf8a134$export$3005042704f95a69);

});

parcelRegister("lXGCH", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $ffd02bbd644ff85d$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $ffd02bbd644ff85d$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $ffd02bbd644ff85d$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $3RvgX.default));
var $ffd02bbd644ff85d$export$2e2bcd8739ae039 = (0, $wbeO3.default)($ffd02bbd644ff85d$export$3005042704f95a69);

});

parcelRegister("eO2tQ", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $ac77a8bf04f9498c$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $ac77a8bf04f9498c$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $ac77a8bf04f9498c$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $3RvgX.default));
var $ac77a8bf04f9498c$export$2e2bcd8739ae039 = (0, $wbeO3.default)($ac77a8bf04f9498c$export$3005042704f95a69);

});

parcelRegister("1QokA", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $157d8567dc72121f$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $157d8567dc72121f$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $157d8567dc72121f$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $3RvgX.default));
var $157d8567dc72121f$export$2e2bcd8739ae039 = (0, $wbeO3.default)($157d8567dc72121f$export$3005042704f95a69);

});

parcelRegister("9R4G8", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $72ccb1583d437506$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $72ccb1583d437506$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $72ccb1583d437506$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $3RvgX.default));
var $72ccb1583d437506$export$2e2bcd8739ae039 = (0, $wbeO3.default)($72ccb1583d437506$export$3005042704f95a69);

});

parcelRegister("9ZxZK", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $74642e3c521c1239$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $74642e3c521c1239$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $74642e3c521c1239$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $3RvgX.default));
var $74642e3c521c1239$export$2e2bcd8739ae039 = (0, $wbeO3.default)($74642e3c521c1239$export$3005042704f95a69);

});

parcelRegister("ji02Y", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $e0afbc13448e11fe$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $e0afbc13448e11fe$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $e0afbc13448e11fe$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $3RvgX.default));
var $e0afbc13448e11fe$export$2e2bcd8739ae039 = (0, $wbeO3.default)($e0afbc13448e11fe$export$3005042704f95a69);

});

parcelRegister("9AiTM", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $6fa622b92089f271$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $6fa622b92089f271$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $6fa622b92089f271$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $3RvgX.default));
var $6fa622b92089f271$export$2e2bcd8739ae039 = (0, $wbeO3.default)($6fa622b92089f271$export$3005042704f95a69);

});

parcelRegister("gd22Q", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $bccf724e42d8b86d$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $bccf724e42d8b86d$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $bccf724e42d8b86d$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $3RvgX.default));
var $bccf724e42d8b86d$export$2e2bcd8739ae039 = (0, $wbeO3.default)($bccf724e42d8b86d$export$3005042704f95a69);

});

parcelRegister("hfL9u", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $c8f869cf9f2a0eae$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $c8f869cf9f2a0eae$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $c8f869cf9f2a0eae$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $3RvgX.default));
var $c8f869cf9f2a0eae$export$2e2bcd8739ae039 = (0, $wbeO3.default)($c8f869cf9f2a0eae$export$3005042704f95a69);

});

parcelRegister("2LkwV", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $202fe55f810bce33$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $202fe55f810bce33$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $202fe55f810bce33$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $3RvgX.default));
var $202fe55f810bce33$export$2e2bcd8739ae039 = (0, $wbeO3.default)($202fe55f810bce33$export$3005042704f95a69);

});

parcelRegister("kAcPv", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $efc11f238de38450$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $efc11f238de38450$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $efc11f238de38450$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $3RvgX.default));
var $efc11f238de38450$export$2e2bcd8739ae039 = (0, $wbeO3.default)($efc11f238de38450$export$3005042704f95a69);

});

parcelRegister("3IwSR", function(module, exports) {

$parcel$export(module.exports, "scheme", function () { return $2b4efd35fa87fc8b$export$3005042704f95a69; });
$parcel$export(module.exports, "default", function () { return $2b4efd35fa87fc8b$export$2e2bcd8739ae039; });

var $3RvgX = parcelRequire("3RvgX");

var $wbeO3 = parcelRequire("wbeO3");
var $2b4efd35fa87fc8b$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $3RvgX.default));
var $2b4efd35fa87fc8b$export$2e2bcd8739ae039 = (0, $wbeO3.default)($2b4efd35fa87fc8b$export$3005042704f95a69);

});

parcelRegister("a5b2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7572ee7ceb15997c$export$2e2bcd8739ae039; });
function $7572ee7ceb15997c$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

});

parcelRegister("2Q0GF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2110f8918068e54d$export$2e2bcd8739ae039; });

var $10y0i = parcelRequire("10y0i");

var $kbZDP = parcelRequire("kbZDP");
var $2110f8918068e54d$export$2e2bcd8739ae039 = (0, $kbZDP.cubehelixLong)((0, $10y0i.default)(300, 0.5, 0.0), (0, $10y0i.default)(-240, 0.5, 1.0));

});

parcelRegister("lbeF7", function(module, exports) {

$parcel$export(module.exports, "warm", function () { return $f6b5ffa5d589d9af$export$fc70efcec537be98; });
$parcel$export(module.exports, "cool", function () { return $f6b5ffa5d589d9af$export$c5cedbc1ab3be2c3; });
$parcel$export(module.exports, "default", function () { return $f6b5ffa5d589d9af$export$2e2bcd8739ae039; });

var $10y0i = parcelRequire("10y0i");

var $kbZDP = parcelRequire("kbZDP");
var $f6b5ffa5d589d9af$export$fc70efcec537be98 = (0, $kbZDP.cubehelixLong)((0, $10y0i.default)(-100, 0.75, 0.35), (0, $10y0i.default)(80, 1.50, 0.8));
var $f6b5ffa5d589d9af$export$c5cedbc1ab3be2c3 = (0, $kbZDP.cubehelixLong)((0, $10y0i.default)(260, 0.75, 0.35), (0, $10y0i.default)(80, 1.50, 0.8));
var $f6b5ffa5d589d9af$var$c = (0, $10y0i.default)();
function $f6b5ffa5d589d9af$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $f6b5ffa5d589d9af$var$c.h = 360 * t - 100;
    $f6b5ffa5d589d9af$var$c.s = 1.5 - 1.5 * ts;
    $f6b5ffa5d589d9af$var$c.l = 0.8 - 0.9 * ts;
    return $f6b5ffa5d589d9af$var$c + "";
}

});

parcelRegister("4Z7n6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a1293cb72230870$export$2e2bcd8739ae039; });

var $5xbVo = parcelRequire("5xbVo");
var $3a1293cb72230870$var$c = (0, $5xbVo.rgb)(), $3a1293cb72230870$var$pi_1_3 = Math.PI / 3, $3a1293cb72230870$var$pi_2_3 = Math.PI * 2 / 3;
function $3a1293cb72230870$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $3a1293cb72230870$var$c.r = 255 * (x = Math.sin(t)) * x;
    $3a1293cb72230870$var$c.g = 255 * (x = Math.sin(t + $3a1293cb72230870$var$pi_1_3)) * x;
    $3a1293cb72230870$var$c.b = 255 * (x = Math.sin(t + $3a1293cb72230870$var$pi_2_3)) * x;
    return $3a1293cb72230870$var$c + "";
}

});

parcelRegister("7EoQb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $591f89b1c1698369$export$2e2bcd8739ae039; });
function $591f89b1c1698369$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}

});

parcelRegister("a5cpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7573ff316683d874$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "magma", function () { return $7573ff316683d874$export$c41e69203f572e8d; });
$parcel$export(module.exports, "inferno", function () { return $7573ff316683d874$export$ad0c8285c8ea6dbd; });
$parcel$export(module.exports, "plasma", function () { return $7573ff316683d874$export$6664860a633d9daf; });

var $3RvgX = parcelRequire("3RvgX");
function $7573ff316683d874$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $7573ff316683d874$export$2e2bcd8739ae039 = $7573ff316683d874$var$ramp((0, $3RvgX.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $7573ff316683d874$export$c41e69203f572e8d = $7573ff316683d874$var$ramp((0, $3RvgX.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $7573ff316683d874$export$ad0c8285c8ea6dbd = $7573ff316683d874$var$ramp((0, $3RvgX.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $7573ff316683d874$export$6664860a633d9daf = $7573ff316683d874$var$ramp((0, $3RvgX.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

});


parcelRegister("94AoT", function(module, exports) {

$parcel$export(module.exports, "create", function () { return (parcelRequire("bNI8u")).default; });
$parcel$export(module.exports, "creator", function () { return (parcelRequire("4AWtu")).default; });
$parcel$export(module.exports, "local", function () { return (parcelRequire("Zwzti")).default; });
$parcel$export(module.exports, "matcher", function () { return (parcelRequire("fso1b")).default; });
$parcel$export(module.exports, "namespace", function () { return (parcelRequire("kAMSn")).default; });
$parcel$export(module.exports, "namespaces", function () { return (parcelRequire("2nesS")).default; });
$parcel$export(module.exports, "pointer", function () { return (parcelRequire("pd5FT")).default; });
$parcel$export(module.exports, "pointers", function () { return (parcelRequire("3yuwP")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("3xlsS")).default; });
$parcel$export(module.exports, "selectAll", function () { return (parcelRequire("82iRQ")).default; });
$parcel$export(module.exports, "selection", function () { return (parcelRequire("lkjtJ")).default; });
$parcel$export(module.exports, "selector", function () { return (parcelRequire("dTsqF")).default; });
$parcel$export(module.exports, "selectorAll", function () { return (parcelRequire("cuaq4")).default; });
$parcel$export(module.exports, "style", function () { return (parcelRequire("hxyOW")).styleValue; });
$parcel$export(module.exports, "window", function () { return (parcelRequire("9Wm3c")).default; });

var $bNI8u = parcelRequire("bNI8u");

var $4AWtu = parcelRequire("4AWtu");

var $Zwzti = parcelRequire("Zwzti");

var $fso1b = parcelRequire("fso1b");

var $kAMSn = parcelRequire("kAMSn");

var $2nesS = parcelRequire("2nesS");

var $pd5FT = parcelRequire("pd5FT");

var $3yuwP = parcelRequire("3yuwP");

var $3xlsS = parcelRequire("3xlsS");

var $82iRQ = parcelRequire("82iRQ");

var $lkjtJ = parcelRequire("lkjtJ");

var $dTsqF = parcelRequire("dTsqF");

var $cuaq4 = parcelRequire("cuaq4");

var $hxyOW = parcelRequire("hxyOW");

var $9Wm3c = parcelRequire("9Wm3c");

});
parcelRegister("bNI8u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $897681cb58617d9c$export$2e2bcd8739ae039; });

var $4AWtu = parcelRequire("4AWtu");

var $3xlsS = parcelRequire("3xlsS");
function $897681cb58617d9c$export$2e2bcd8739ae039(name) {
    return (0, $3xlsS.default)((0, $4AWtu.default)(name).call(document.documentElement));
}

});

parcelRegister("Zwzti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b8ef690ff6a4f56$export$2e2bcd8739ae039; });
var $0b8ef690ff6a4f56$var$nextId = 0;
function $0b8ef690ff6a4f56$export$2e2bcd8739ae039() {
    return new $0b8ef690ff6a4f56$var$Local;
}
function $0b8ef690ff6a4f56$var$Local() {
    this._ = "@" + (++$0b8ef690ff6a4f56$var$nextId).toString(36);
}
$0b8ef690ff6a4f56$var$Local.prototype = $0b8ef690ff6a4f56$export$2e2bcd8739ae039.prototype = {
    constructor: $0b8ef690ff6a4f56$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

});

parcelRegister("3yuwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $296c3a6aab933701$export$2e2bcd8739ae039; });

var $pd5FT = parcelRequire("pd5FT");

var $aleUh = parcelRequire("aleUh");
function $296c3a6aab933701$export$2e2bcd8739ae039(events, node) {
    if (events.target) {
        events = (0, $aleUh.default)(events);
        if (node === undefined) node = events.currentTarget;
        events = events.touches || [
            events
        ];
    }
    return Array.from(events, (event)=>(0, $pd5FT.default)(event, node));
}

});

parcelRegister("82iRQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d9d255541b7af73$export$2e2bcd8739ae039; });

var $4EN9f = parcelRequire("4EN9f");

var $lkjtJ = parcelRequire("lkjtJ");
function $5d9d255541b7af73$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $lkjtJ.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $lkjtJ.Selection)([
        (0, $4EN9f.default)(selector)
    ], (0, $lkjtJ.root));
}

});


parcelRegister("4VAJt", function(module, exports) {

$parcel$export(module.exports, "arc", function () { return (parcelRequire("hZdL7")).default; });
$parcel$export(module.exports, "area", function () { return (parcelRequire("2ibeX")).default; });
$parcel$export(module.exports, "line", function () { return (parcelRequire("lS1PO")).default; });
$parcel$export(module.exports, "pie", function () { return (parcelRequire("hEvPA")).default; });
$parcel$export(module.exports, "areaRadial", function () { return (parcelRequire("cAG0v")).default; });
$parcel$export(module.exports, "radialArea", function () { return (parcelRequire("cAG0v")).default; });
$parcel$export(module.exports, "lineRadial", function () { return (parcelRequire("9qOcR")).default; });
$parcel$export(module.exports, "radialLine", function () { return (parcelRequire("9qOcR")).default; });
$parcel$export(module.exports, "pointRadial", function () { return (parcelRequire("3AB1L")).default; });
$parcel$export(module.exports, "link", function () { return (parcelRequire("kkRqd")).link; });
$parcel$export(module.exports, "linkHorizontal", function () { return (parcelRequire("kkRqd")).linkHorizontal; });
$parcel$export(module.exports, "linkVertical", function () { return (parcelRequire("kkRqd")).linkVertical; });
$parcel$export(module.exports, "linkRadial", function () { return (parcelRequire("kkRqd")).linkRadial; });
$parcel$export(module.exports, "symbol", function () { return (parcelRequire("gOqiu")).default; });
$parcel$export(module.exports, "symbolsStroke", function () { return (parcelRequire("gOqiu")).symbolsStroke; });
$parcel$export(module.exports, "symbolsFill", function () { return (parcelRequire("gOqiu")).symbolsFill; });
$parcel$export(module.exports, "symbols", function () { return (parcelRequire("gOqiu")).symbolsFill; });
$parcel$export(module.exports, "symbolAsterisk", function () { return (parcelRequire("fXABo")).default; });
$parcel$export(module.exports, "symbolCircle", function () { return (parcelRequire("6uW3b")).default; });
$parcel$export(module.exports, "symbolCross", function () { return (parcelRequire("6bLCL")).default; });
$parcel$export(module.exports, "symbolDiamond", function () { return (parcelRequire("21Qfn")).default; });
$parcel$export(module.exports, "symbolDiamond2", function () { return (parcelRequire("64qIK")).default; });
$parcel$export(module.exports, "symbolPlus", function () { return (parcelRequire("dNu4Z")).default; });
$parcel$export(module.exports, "symbolSquare", function () { return (parcelRequire("2ZaqT")).default; });
$parcel$export(module.exports, "symbolSquare2", function () { return (parcelRequire("6IxCj")).default; });
$parcel$export(module.exports, "symbolStar", function () { return (parcelRequire("8HCXR")).default; });
$parcel$export(module.exports, "symbolTriangle", function () { return (parcelRequire("cp7H4")).default; });
$parcel$export(module.exports, "symbolTriangle2", function () { return (parcelRequire("loKoN")).default; });
$parcel$export(module.exports, "symbolWye", function () { return (parcelRequire("9DbId")).default; });
$parcel$export(module.exports, "symbolTimes", function () { return (parcelRequire("9g7TB")).default; });
$parcel$export(module.exports, "symbolX", function () { return (parcelRequire("9g7TB")).default; });
$parcel$export(module.exports, "curveBasisClosed", function () { return (parcelRequire("lLSbn")).default; });
$parcel$export(module.exports, "curveBasisOpen", function () { return (parcelRequire("3q1fy")).default; });
$parcel$export(module.exports, "curveBasis", function () { return (parcelRequire("3r6V7")).default; });
$parcel$export(module.exports, "curveBumpX", function () { return (parcelRequire("2BueF")).bumpX; });
$parcel$export(module.exports, "curveBumpY", function () { return (parcelRequire("2BueF")).bumpY; });
$parcel$export(module.exports, "curveBundle", function () { return (parcelRequire("3DXFu")).default; });
$parcel$export(module.exports, "curveCardinalClosed", function () { return (parcelRequire("bAmTZ")).default; });
$parcel$export(module.exports, "curveCardinalOpen", function () { return (parcelRequire("6YdNX")).default; });
$parcel$export(module.exports, "curveCardinal", function () { return (parcelRequire("52CP9")).default; });
$parcel$export(module.exports, "curveCatmullRomClosed", function () { return (parcelRequire("brCNE")).default; });
$parcel$export(module.exports, "curveCatmullRomOpen", function () { return (parcelRequire("lQj60")).default; });
$parcel$export(module.exports, "curveCatmullRom", function () { return (parcelRequire("84EER")).default; });
$parcel$export(module.exports, "curveLinearClosed", function () { return (parcelRequire("bWNLs")).default; });
$parcel$export(module.exports, "curveLinear", function () { return (parcelRequire("eRZ2p")).default; });
$parcel$export(module.exports, "curveMonotoneX", function () { return (parcelRequire("ivmHr")).monotoneX; });
$parcel$export(module.exports, "curveMonotoneY", function () { return (parcelRequire("ivmHr")).monotoneY; });
$parcel$export(module.exports, "curveNatural", function () { return (parcelRequire("1Mn1f")).default; });
$parcel$export(module.exports, "curveStep", function () { return (parcelRequire("38sKq")).default; });
$parcel$export(module.exports, "curveStepAfter", function () { return (parcelRequire("38sKq")).stepAfter; });
$parcel$export(module.exports, "curveStepBefore", function () { return (parcelRequire("38sKq")).stepBefore; });
$parcel$export(module.exports, "stack", function () { return (parcelRequire("by9WN")).default; });
$parcel$export(module.exports, "stackOffsetExpand", function () { return (parcelRequire("flkSt")).default; });
$parcel$export(module.exports, "stackOffsetDiverging", function () { return (parcelRequire("63Syu")).default; });
$parcel$export(module.exports, "stackOffsetNone", function () { return (parcelRequire("kM39A")).default; });
$parcel$export(module.exports, "stackOffsetSilhouette", function () { return (parcelRequire("8paFe")).default; });
$parcel$export(module.exports, "stackOffsetWiggle", function () { return (parcelRequire("XwP10")).default; });
$parcel$export(module.exports, "stackOrderAppearance", function () { return (parcelRequire("dks2s")).default; });
$parcel$export(module.exports, "stackOrderAscending", function () { return (parcelRequire("d3Ppk")).default; });
$parcel$export(module.exports, "stackOrderDescending", function () { return (parcelRequire("jMPoC")).default; });
$parcel$export(module.exports, "stackOrderInsideOut", function () { return (parcelRequire("7gOhO")).default; });
$parcel$export(module.exports, "stackOrderNone", function () { return (parcelRequire("1QhlB")).default; });
$parcel$export(module.exports, "stackOrderReverse", function () { return (parcelRequire("gYdLj")).default; });

var $hZdL7 = parcelRequire("hZdL7");

var $2ibeX = parcelRequire("2ibeX");

var $lS1PO = parcelRequire("lS1PO");

var $hEvPA = parcelRequire("hEvPA");

var $cAG0v = parcelRequire("cAG0v");

var $9qOcR = parcelRequire("9qOcR");

var $3AB1L = parcelRequire("3AB1L");

var $kkRqd = parcelRequire("kkRqd");

var $gOqiu = parcelRequire("gOqiu");

var $fXABo = parcelRequire("fXABo");

var $6uW3b = parcelRequire("6uW3b");

var $6bLCL = parcelRequire("6bLCL");

var $21Qfn = parcelRequire("21Qfn");

var $64qIK = parcelRequire("64qIK");

var $dNu4Z = parcelRequire("dNu4Z");

var $2ZaqT = parcelRequire("2ZaqT");

var $6IxCj = parcelRequire("6IxCj");

var $8HCXR = parcelRequire("8HCXR");

var $cp7H4 = parcelRequire("cp7H4");

var $loKoN = parcelRequire("loKoN");

var $9DbId = parcelRequire("9DbId");

var $9g7TB = parcelRequire("9g7TB");

var $lLSbn = parcelRequire("lLSbn");

var $3q1fy = parcelRequire("3q1fy");

var $3r6V7 = parcelRequire("3r6V7");

var $2BueF = parcelRequire("2BueF");

var $3DXFu = parcelRequire("3DXFu");

var $bAmTZ = parcelRequire("bAmTZ");

var $6YdNX = parcelRequire("6YdNX");

var $52CP9 = parcelRequire("52CP9");

var $brCNE = parcelRequire("brCNE");

var $lQj60 = parcelRequire("lQj60");

var $84EER = parcelRequire("84EER");

var $bWNLs = parcelRequire("bWNLs");

var $eRZ2p = parcelRequire("eRZ2p");

var $ivmHr = parcelRequire("ivmHr");

var $1Mn1f = parcelRequire("1Mn1f");

var $38sKq = parcelRequire("38sKq");

var $by9WN = parcelRequire("by9WN");

var $flkSt = parcelRequire("flkSt");

var $63Syu = parcelRequire("63Syu");

var $kM39A = parcelRequire("kM39A");

var $8paFe = parcelRequire("8paFe");

var $XwP10 = parcelRequire("XwP10");

var $dks2s = parcelRequire("dks2s");

var $d3Ppk = parcelRequire("d3Ppk");

var $jMPoC = parcelRequire("jMPoC");

var $7gOhO = parcelRequire("7gOhO");

var $1QhlB = parcelRequire("1QhlB");

var $gYdLj = parcelRequire("gYdLj");

});
parcelRegister("hZdL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d182ce6d5f5b47ae$export$2e2bcd8739ae039; });

var $5UbpF = parcelRequire("5UbpF");

var $3JHvG = parcelRequire("3JHvG");

var $bDdX4 = parcelRequire("bDdX4");
function $d182ce6d5f5b47ae$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $d182ce6d5f5b47ae$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $d182ce6d5f5b47ae$var$arcStartAngle(d) {
    return d.startAngle;
}
function $d182ce6d5f5b47ae$var$arcEndAngle(d) {
    return d.endAngle;
}
function $d182ce6d5f5b47ae$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $d182ce6d5f5b47ae$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $3JHvG.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $d182ce6d5f5b47ae$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $3JHvG.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $3JHvG.sqrt)((0, $3JHvG.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $d182ce6d5f5b47ae$export$2e2bcd8739ae039() {
    var innerRadius = $d182ce6d5f5b47ae$var$arcInnerRadius, outerRadius = $d182ce6d5f5b47ae$var$arcOuterRadius, cornerRadius = (0, $5UbpF.default)(0), padRadius = null, startAngle = $d182ce6d5f5b47ae$var$arcStartAngle, endAngle = $d182ce6d5f5b47ae$var$arcEndAngle, padAngle = $d182ce6d5f5b47ae$var$arcPadAngle, context = null, path = (0, $bDdX4.withPath)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $3JHvG.halfPi), a1 = endAngle.apply(this, arguments) - (0, $3JHvG.halfPi), da = (0, $3JHvG.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $3JHvG.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $3JHvG.tau) - (0, $3JHvG.epsilon)) {
            context.moveTo(r1 * (0, $3JHvG.cos)(a0), r1 * (0, $3JHvG.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $3JHvG.epsilon)) {
                context.moveTo(r0 * (0, $3JHvG.cos)(a1), r0 * (0, $3JHvG.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $3JHvG.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $3JHvG.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $3JHvG.min)((0, $3JHvG.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $3JHvG.epsilon)) {
                var p0 = (0, $3JHvG.asin)(rp / r0 * (0, $3JHvG.sin)(ap)), p1 = (0, $3JHvG.asin)(rp / r1 * (0, $3JHvG.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $3JHvG.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $3JHvG.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $3JHvG.cos)(a01), y01 = r1 * (0, $3JHvG.sin)(a01), x10 = r0 * (0, $3JHvG.cos)(a10), y10 = r0 * (0, $3JHvG.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $3JHvG.epsilon)) {
                var x11 = r1 * (0, $3JHvG.cos)(a11), y11 = r1 * (0, $3JHvG.sin)(a11), x00 = r0 * (0, $3JHvG.cos)(a00), y00 = r0 * (0, $3JHvG.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $3JHvG.pi)) {
                    if (oc = $d182ce6d5f5b47ae$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $3JHvG.sin)((0, $3JHvG.acos)((ax * bx + ay * by) / ((0, $3JHvG.sqrt)(ax * ax + ay * ay) * (0, $3JHvG.sqrt)(bx * bx + by * by))) / 2), lc = (0, $3JHvG.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $3JHvG.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $3JHvG.min)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $3JHvG.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $3JHvG.epsilon)) {
                t0 = $d182ce6d5f5b47ae$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $d182ce6d5f5b47ae$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $3JHvG.atan2)(t0.y01, t0.x01), (0, $3JHvG.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $3JHvG.atan2)(t0.y01, t0.x01), (0, $3JHvG.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $3JHvG.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $3JHvG.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $3JHvG.atan2)(t1.y11, t1.x11), (0, $3JHvG.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $3JHvG.epsilon)) || !(da0 > (0, $3JHvG.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $3JHvG.epsilon)) {
                t0 = $d182ce6d5f5b47ae$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $d182ce6d5f5b47ae$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $3JHvG.atan2)(t0.y01, t0.x01), (0, $3JHvG.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $3JHvG.atan2)(t0.y01, t0.x01), (0, $3JHvG.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $3JHvG.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $3JHvG.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $3JHvG.atan2)(t1.y11, t1.x11), (0, $3JHvG.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $3JHvG.pi) / 2;
        return [
            (0, $3JHvG.cos)(a) * r,
            (0, $3JHvG.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("5UbpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44cb091e23d0a200$export$2e2bcd8739ae039; });
function $44cb091e23d0a200$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("3JHvG", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $2b8753446f93a988$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan2", function () { return $2b8753446f93a988$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $2b8753446f93a988$export$50d414a77b60d802; });
$parcel$export(module.exports, "max", function () { return $2b8753446f93a988$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $2b8753446f93a988$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "sin", function () { return $2b8753446f93a988$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sqrt", function () { return $2b8753446f93a988$export$eba8049fb5020b81; });
$parcel$export(module.exports, "epsilon", function () { return $2b8753446f93a988$export$6c421550c66a327d; });
$parcel$export(module.exports, "pi", function () { return $2b8753446f93a988$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $2b8753446f93a988$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $2b8753446f93a988$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "acos", function () { return $2b8753446f93a988$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $2b8753446f93a988$export$41726bdb1fc63f; });
const $2b8753446f93a988$export$2335f513bbd82c6d = Math.abs;
const $2b8753446f93a988$export$b8b770ee6a0d9760 = Math.atan2;
const $2b8753446f93a988$export$50d414a77b60d802 = Math.cos;
const $2b8753446f93a988$export$8960430cfd85939f = Math.max;
const $2b8753446f93a988$export$96ec731ed4dcb222 = Math.min;
const $2b8753446f93a988$export$5de3937cb4b592ed = Math.sin;
const $2b8753446f93a988$export$eba8049fb5020b81 = Math.sqrt;
const $2b8753446f93a988$export$6c421550c66a327d = 1e-12;
const $2b8753446f93a988$export$18c7bea995a110f = Math.PI;
const $2b8753446f93a988$export$e51408a300e8929a = $2b8753446f93a988$export$18c7bea995a110f / 2;
const $2b8753446f93a988$export$a4b4b4d4d776fe92 = 2 * $2b8753446f93a988$export$18c7bea995a110f;
function $2b8753446f93a988$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $2b8753446f93a988$export$18c7bea995a110f : Math.acos(x);
}
function $2b8753446f93a988$export$41726bdb1fc63f(x) {
    return x >= 1 ? $2b8753446f93a988$export$e51408a300e8929a : x <= -1 ? -$2b8753446f93a988$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("bDdX4", function(module, exports) {

$parcel$export(module.exports, "withPath", function () { return $877e28bc9cda8b43$export$fb6e83118a5dcd45; });

var $ayz97 = parcelRequire("ayz97");
function $877e28bc9cda8b43$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $ayz97.Path)(digits);
}

});


parcelRegister("2ibeX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ab5fb4fb368ca45$export$2e2bcd8739ae039; });

var $1NVw6 = parcelRequire("1NVw6");

var $5UbpF = parcelRequire("5UbpF");

var $eRZ2p = parcelRequire("eRZ2p");

var $lS1PO = parcelRequire("lS1PO");

var $bDdX4 = parcelRequire("bDdX4");

var $H4Pjh = parcelRequire("H4Pjh");
function $1ab5fb4fb368ca45$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $5UbpF.default)(true), context = null, curve = (0, $eRZ2p.default), output = null, path = (0, $bDdX4.withPath)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $H4Pjh.x) : (0, $5UbpF.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $5UbpF.default)(0) : (0, $5UbpF.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $H4Pjh.y) : (0, $5UbpF.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $1NVw6.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $lS1PO.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $5UbpF.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("1NVw6", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $1506fbb001825fa7$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "default", function () { return $1506fbb001825fa7$export$2e2bcd8739ae039; });
var $1506fbb001825fa7$export$58adb3bec8346d0f = Array.prototype.slice;
function $1506fbb001825fa7$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("eRZ2p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad355cbfc103560b$export$2e2bcd8739ae039; });
function $ad355cbfc103560b$var$Linear(context) {
    this._context = context;
}
$ad355cbfc103560b$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $ad355cbfc103560b$export$2e2bcd8739ae039(context) {
    return new $ad355cbfc103560b$var$Linear(context);
}

});

parcelRegister("lS1PO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fec01077f7c21b06$export$2e2bcd8739ae039; });

var $1NVw6 = parcelRequire("1NVw6");

var $5UbpF = parcelRequire("5UbpF");

var $eRZ2p = parcelRequire("eRZ2p");

var $bDdX4 = parcelRequire("bDdX4");

var $H4Pjh = parcelRequire("H4Pjh");
function $fec01077f7c21b06$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $5UbpF.default)(true), context = null, curve = (0, $eRZ2p.default), output = null, path = (0, $bDdX4.withPath)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $H4Pjh.x) : (0, $5UbpF.default)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $H4Pjh.y) : (0, $5UbpF.default)(y);
    function line(data) {
        var i, n = (data = (0, $1NVw6.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $5UbpF.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("H4Pjh", function(module, exports) {

$parcel$export(module.exports, "x", function () { return $0817c2b9b85f29b7$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $0817c2b9b85f29b7$export$4a5767248b18ef41; });
function $0817c2b9b85f29b7$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $0817c2b9b85f29b7$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("hEvPA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd9edd10c79dfd71$export$2e2bcd8739ae039; });

var $1NVw6 = parcelRequire("1NVw6");

var $5UbpF = parcelRequire("5UbpF");

var $7VYs6 = parcelRequire("7VYs6");

var $2v6mw = parcelRequire("2v6mw");

var $3JHvG = parcelRequire("3JHvG");
function $cd9edd10c79dfd71$export$2e2bcd8739ae039() {
    var value = (0, $2v6mw.default), sortValues = (0, $7VYs6.default), sort = null, startAngle = (0, $5UbpF.default)(0), endAngle = (0, $5UbpF.default)((0, $3JHvG.tau)), padAngle = (0, $5UbpF.default)(0);
    function pie(data) {
        var i, n = (data = (0, $1NVw6.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $3JHvG.tau), Math.max(-(0, $3JHvG.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("7VYs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c6cbfd2ada29470$export$2e2bcd8739ae039; });
function $5c6cbfd2ada29470$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("2v6mw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d23697370754055$export$2e2bcd8739ae039; });
function $1d23697370754055$export$2e2bcd8739ae039(d) {
    return d;
}

});


parcelRegister("cAG0v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a96e99e879d557$export$2e2bcd8739ae039; });

var $a6rI0 = parcelRequire("a6rI0");

var $2ibeX = parcelRequire("2ibeX");

var $9qOcR = parcelRequire("9qOcR");
function $92a96e99e879d557$export$2e2bcd8739ae039() {
    var a = (0, $2ibeX.default)().curve((0, $a6rI0.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $9qOcR.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $9qOcR.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $9qOcR.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $9qOcR.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $a6rI0.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("a6rI0", function(module, exports) {

$parcel$export(module.exports, "curveRadialLinear", function () { return $75aff54eaa09359f$export$22d25ffb9fb15b6f; });
$parcel$export(module.exports, "default", function () { return $75aff54eaa09359f$export$2e2bcd8739ae039; });

var $eRZ2p = parcelRequire("eRZ2p");
var $75aff54eaa09359f$export$22d25ffb9fb15b6f = $75aff54eaa09359f$export$2e2bcd8739ae039((0, $eRZ2p.default));
function $75aff54eaa09359f$var$Radial(curve) {
    this._curve = curve;
}
$75aff54eaa09359f$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $75aff54eaa09359f$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $75aff54eaa09359f$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("9qOcR", function(module, exports) {

$parcel$export(module.exports, "lineRadial", function () { return $6ddd7cb9eb0bb981$export$4d8815a75dc8cd4d; });
$parcel$export(module.exports, "default", function () { return $6ddd7cb9eb0bb981$export$2e2bcd8739ae039; });

var $a6rI0 = parcelRequire("a6rI0");

var $lS1PO = parcelRequire("lS1PO");
function $6ddd7cb9eb0bb981$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $a6rI0.default)(_)) : c()._curve;
    };
    return l;
}
function $6ddd7cb9eb0bb981$export$2e2bcd8739ae039() {
    return $6ddd7cb9eb0bb981$export$4d8815a75dc8cd4d((0, $lS1PO.default)().curve((0, $a6rI0.curveRadialLinear)));
}

});


parcelRegister("3AB1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29d174c371da1dc1$export$2e2bcd8739ae039; });
function $29d174c371da1dc1$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("kkRqd", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $ecdf1d63e5bc54c9$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "linkHorizontal", function () { return $ecdf1d63e5bc54c9$export$e7c381889b2cd14d; });
$parcel$export(module.exports, "linkVertical", function () { return $ecdf1d63e5bc54c9$export$75de4c8c66884e04; });
$parcel$export(module.exports, "linkRadial", function () { return $ecdf1d63e5bc54c9$export$7739cfe68d4e0799; });

var $1NVw6 = parcelRequire("1NVw6");

var $5UbpF = parcelRequire("5UbpF");

var $2BueF = parcelRequire("2BueF");

var $bDdX4 = parcelRequire("bDdX4");

var $H4Pjh = parcelRequire("H4Pjh");
function $ecdf1d63e5bc54c9$var$linkSource(d) {
    return d.source;
}
function $ecdf1d63e5bc54c9$var$linkTarget(d) {
    return d.target;
}
function $ecdf1d63e5bc54c9$export$9c30223ca0a664fb(curve) {
    let source = $ecdf1d63e5bc54c9$var$linkSource, target = $ecdf1d63e5bc54c9$var$linkTarget, x = (0, $H4Pjh.x), y = (0, $H4Pjh.y), context = null, output = null, path = (0, $bDdX4.withPath)(link);
    function link() {
        let buffer;
        const argv = (0, $1NVw6.slice).call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = path());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $ecdf1d63e5bc54c9$export$e7c381889b2cd14d() {
    return $ecdf1d63e5bc54c9$export$9c30223ca0a664fb((0, $2BueF.bumpX));
}
function $ecdf1d63e5bc54c9$export$75de4c8c66884e04() {
    return $ecdf1d63e5bc54c9$export$9c30223ca0a664fb((0, $2BueF.bumpY));
}
function $ecdf1d63e5bc54c9$export$7739cfe68d4e0799() {
    const l = $ecdf1d63e5bc54c9$export$9c30223ca0a664fb((0, $2BueF.bumpRadial));
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("2BueF", function(module, exports) {

$parcel$export(module.exports, "bumpX", function () { return $1e567da51fb87c16$export$2c099b5096f70ce6; });
$parcel$export(module.exports, "bumpY", function () { return $1e567da51fb87c16$export$908da9dfa54cbed6; });
$parcel$export(module.exports, "bumpRadial", function () { return $1e567da51fb87c16$export$8c82a77a5061b331; });

var $3AB1L = parcelRequire("3AB1L");
class $1e567da51fb87c16$var$Bump {
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
}
class $1e567da51fb87c16$var$BumpRadial {
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $3AB1L.default)(this._x0, this._y0);
            const p1 = (0, $3AB1L.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $3AB1L.default)(x, this._y0);
            const p3 = (0, $3AB1L.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
    constructor(context){
        this._context = context;
    }
}
function $1e567da51fb87c16$export$2c099b5096f70ce6(context) {
    return new $1e567da51fb87c16$var$Bump(context, true);
}
function $1e567da51fb87c16$export$908da9dfa54cbed6(context) {
    return new $1e567da51fb87c16$var$Bump(context, false);
}
function $1e567da51fb87c16$export$8c82a77a5061b331(context) {
    return new $1e567da51fb87c16$var$BumpRadial(context);
}

});


parcelRegister("gOqiu", function(module, exports) {

$parcel$export(module.exports, "symbolsFill", function () { return $c3d5b6f139bd8562$export$19158c96a6700c15; });
$parcel$export(module.exports, "symbolsStroke", function () { return $c3d5b6f139bd8562$export$915e06de6acf8fe; });
$parcel$export(module.exports, "default", function () { return $c3d5b6f139bd8562$export$2e2bcd8739ae039; });

var $5UbpF = parcelRequire("5UbpF");

var $bDdX4 = parcelRequire("bDdX4");

var $fXABo = parcelRequire("fXABo");

var $6uW3b = parcelRequire("6uW3b");

var $6bLCL = parcelRequire("6bLCL");

var $21Qfn = parcelRequire("21Qfn");

var $64qIK = parcelRequire("64qIK");

var $dNu4Z = parcelRequire("dNu4Z");

var $2ZaqT = parcelRequire("2ZaqT");

var $6IxCj = parcelRequire("6IxCj");

var $8HCXR = parcelRequire("8HCXR");

var $cp7H4 = parcelRequire("cp7H4");

var $loKoN = parcelRequire("loKoN");

var $9DbId = parcelRequire("9DbId");

var $9g7TB = parcelRequire("9g7TB");
const $c3d5b6f139bd8562$export$19158c96a6700c15 = [
    (0, $6uW3b.default),
    (0, $6bLCL.default),
    (0, $21Qfn.default),
    (0, $2ZaqT.default),
    (0, $8HCXR.default),
    (0, $cp7H4.default),
    (0, $9DbId.default)
];
const $c3d5b6f139bd8562$export$915e06de6acf8fe = [
    (0, $6uW3b.default),
    (0, $dNu4Z.default),
    (0, $9g7TB.default),
    (0, $loKoN.default),
    (0, $fXABo.default),
    (0, $6IxCj.default),
    (0, $64qIK.default)
];
function $c3d5b6f139bd8562$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $bDdX4.withPath)(symbol);
    type = typeof type === "function" ? type : (0, $5UbpF.default)(type || (0, $6uW3b.default));
    size = typeof size === "function" ? size : (0, $5UbpF.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $5UbpF.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("fXABo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e8c21c1e80e7c7$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
const $b9e8c21c1e80e7c7$var$sqrt3 = (0, $3JHvG.sqrt)(3);
var $b9e8c21c1e80e7c7$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size + (0, $3JHvG.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $b9e8c21c1e80e7c7$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

});

parcelRegister("6uW3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bb293072ed3a82e$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
var $4bb293072ed3a82e$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size / (0, $3JHvG.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $3JHvG.tau));
    }
};

});

parcelRegister("6bLCL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4818b658f5658a4b$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
var $4818b658f5658a4b$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("21Qfn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a433f2538ac9ff$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
const $17a433f2538ac9ff$var$tan30 = (0, $3JHvG.sqrt)(1 / 3);
const $17a433f2538ac9ff$var$tan30_2 = $17a433f2538ac9ff$var$tan30 * 2;
var $17a433f2538ac9ff$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $3JHvG.sqrt)(size / $17a433f2538ac9ff$var$tan30_2);
        const x = y * $17a433f2538ac9ff$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("64qIK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b7d7f8938e37d5$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
var $46b7d7f8938e37d5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

});

parcelRegister("dNu4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b72f1b31372407$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
var $a0b72f1b31372407$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size - (0, $3JHvG.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

});

parcelRegister("2ZaqT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22c95f035fdad5ab$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
var $22c95f035fdad5ab$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $3JHvG.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("6IxCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e40edc0bf9c8f65$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
var $4e40edc0bf9c8f65$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

});

parcelRegister("8HCXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6560907042ebe6ab$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
const $6560907042ebe6ab$var$ka = 0.89081309152928522810;
const $6560907042ebe6ab$var$kr = (0, $3JHvG.sin)((0, $3JHvG.pi) / 10) / (0, $3JHvG.sin)(7 * (0, $3JHvG.pi) / 10);
const $6560907042ebe6ab$var$kx = (0, $3JHvG.sin)((0, $3JHvG.tau) / 10) * $6560907042ebe6ab$var$kr;
const $6560907042ebe6ab$var$ky = -(0, $3JHvG.cos)((0, $3JHvG.tau) / 10) * $6560907042ebe6ab$var$kr;
var $6560907042ebe6ab$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size * $6560907042ebe6ab$var$ka);
        const x = $6560907042ebe6ab$var$kx * r;
        const y = $6560907042ebe6ab$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $3JHvG.tau) * i / 5;
            const c = (0, $3JHvG.cos)(a);
            const s = (0, $3JHvG.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("cp7H4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $907dc9a1ba7c2ac9$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
const $907dc9a1ba7c2ac9$var$sqrt3 = (0, $3JHvG.sqrt)(3);
var $907dc9a1ba7c2ac9$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $3JHvG.sqrt)(size / ($907dc9a1ba7c2ac9$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$907dc9a1ba7c2ac9$var$sqrt3 * y, -y);
        context.lineTo($907dc9a1ba7c2ac9$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("loKoN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f93fd4c0df1f5c2d$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
const $f93fd4c0df1f5c2d$var$sqrt3 = (0, $3JHvG.sqrt)(3);
var $f93fd4c0df1f5c2d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $3JHvG.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $f93fd4c0df1f5c2d$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

});

parcelRegister("9DbId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7030d762f7982fcb$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
const $7030d762f7982fcb$var$c = -0.5;
const $7030d762f7982fcb$var$s = (0, $3JHvG.sqrt)(3) / 2;
const $7030d762f7982fcb$var$k = 1 / (0, $3JHvG.sqrt)(12);
const $7030d762f7982fcb$var$a = ($7030d762f7982fcb$var$k / 2 + 1) * 3;
var $7030d762f7982fcb$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size / $7030d762f7982fcb$var$a);
        const x0 = r / 2, y0 = r * $7030d762f7982fcb$var$k;
        const x1 = x0, y1 = r * $7030d762f7982fcb$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($7030d762f7982fcb$var$c * x0 - $7030d762f7982fcb$var$s * y0, $7030d762f7982fcb$var$s * x0 + $7030d762f7982fcb$var$c * y0);
        context.lineTo($7030d762f7982fcb$var$c * x1 - $7030d762f7982fcb$var$s * y1, $7030d762f7982fcb$var$s * x1 + $7030d762f7982fcb$var$c * y1);
        context.lineTo($7030d762f7982fcb$var$c * x2 - $7030d762f7982fcb$var$s * y2, $7030d762f7982fcb$var$s * x2 + $7030d762f7982fcb$var$c * y2);
        context.lineTo($7030d762f7982fcb$var$c * x0 + $7030d762f7982fcb$var$s * y0, $7030d762f7982fcb$var$c * y0 - $7030d762f7982fcb$var$s * x0);
        context.lineTo($7030d762f7982fcb$var$c * x1 + $7030d762f7982fcb$var$s * y1, $7030d762f7982fcb$var$c * y1 - $7030d762f7982fcb$var$s * x1);
        context.lineTo($7030d762f7982fcb$var$c * x2 + $7030d762f7982fcb$var$s * y2, $7030d762f7982fcb$var$c * y2 - $7030d762f7982fcb$var$s * x2);
        context.closePath();
    }
};

});

parcelRegister("9g7TB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bdbbb9e9f69d9af$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");
var $6bdbbb9e9f69d9af$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $3JHvG.sqrt)(size - (0, $3JHvG.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

});


parcelRegister("lLSbn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd980448a30b1bcc$export$2e2bcd8739ae039; });

var $2QVeP = parcelRequire("2QVeP");

var $3r6V7 = parcelRequire("3r6V7");
function $fd980448a30b1bcc$var$BasisClosed(context) {
    this._context = context;
}
$fd980448a30b1bcc$var$BasisClosed.prototype = {
    areaStart: (0, $2QVeP.default),
    areaEnd: (0, $2QVeP.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $3r6V7.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $fd980448a30b1bcc$export$2e2bcd8739ae039(context) {
    return new $fd980448a30b1bcc$var$BasisClosed(context);
}

});
parcelRegister("2QVeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $213cd66b55b441a8$export$2e2bcd8739ae039; });
function $213cd66b55b441a8$export$2e2bcd8739ae039() {}

});

parcelRegister("3r6V7", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $280942ea0c85cc4c$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Basis", function () { return $280942ea0c85cc4c$export$957f7263e89bedd2; });
$parcel$export(module.exports, "default", function () { return $280942ea0c85cc4c$export$2e2bcd8739ae039; });
function $280942ea0c85cc4c$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $280942ea0c85cc4c$export$957f7263e89bedd2(context) {
    this._context = context;
}
$280942ea0c85cc4c$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $280942ea0c85cc4c$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $280942ea0c85cc4c$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $280942ea0c85cc4c$export$2e2bcd8739ae039(context) {
    return new $280942ea0c85cc4c$export$957f7263e89bedd2(context);
}

});


parcelRegister("3q1fy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d4c4fd30415dcb$export$2e2bcd8739ae039; });

var $3r6V7 = parcelRequire("3r6V7");
function $27d4c4fd30415dcb$var$BasisOpen(context) {
    this._context = context;
}
$27d4c4fd30415dcb$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $3r6V7.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $27d4c4fd30415dcb$export$2e2bcd8739ae039(context) {
    return new $27d4c4fd30415dcb$var$BasisOpen(context);
}

});

parcelRegister("3DXFu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a734c757ae554ca$export$2e2bcd8739ae039; });

var $3r6V7 = parcelRequire("3r6V7");
function $2a734c757ae554ca$var$Bundle(context, beta) {
    this._basis = new (0, $3r6V7.Basis)(context);
    this._beta = beta;
}
$2a734c757ae554ca$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $2a734c757ae554ca$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $3r6V7.Basis)(context) : new $2a734c757ae554ca$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("bAmTZ", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", function () { return $86f4d261c031f05c$export$da3940d7e9162858; });
$parcel$export(module.exports, "default", function () { return $86f4d261c031f05c$export$2e2bcd8739ae039; });

var $2QVeP = parcelRequire("2QVeP");

var $52CP9 = parcelRequire("52CP9");
function $86f4d261c031f05c$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$86f4d261c031f05c$export$da3940d7e9162858.prototype = {
    areaStart: (0, $2QVeP.default),
    areaEnd: (0, $2QVeP.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $52CP9.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $86f4d261c031f05c$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $86f4d261c031f05c$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("52CP9", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $3abb414a0c13e147$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $3abb414a0c13e147$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $3abb414a0c13e147$export$2e2bcd8739ae039; });
function $3abb414a0c13e147$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $3abb414a0c13e147$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$3abb414a0c13e147$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $3abb414a0c13e147$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $3abb414a0c13e147$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $3abb414a0c13e147$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $3abb414a0c13e147$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("6YdNX", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", function () { return $51330e022e0fe057$export$cd7d1a617282f2f1; });
$parcel$export(module.exports, "default", function () { return $51330e022e0fe057$export$2e2bcd8739ae039; });

var $52CP9 = parcelRequire("52CP9");
function $51330e022e0fe057$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$51330e022e0fe057$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $52CP9.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $51330e022e0fe057$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $51330e022e0fe057$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("brCNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85505024b21cdf3f$export$2e2bcd8739ae039; });

var $bAmTZ = parcelRequire("bAmTZ");

var $2QVeP = parcelRequire("2QVeP");

var $84EER = parcelRequire("84EER");
function $85505024b21cdf3f$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$85505024b21cdf3f$var$CatmullRomClosed.prototype = {
    areaStart: (0, $2QVeP.default),
    areaEnd: (0, $2QVeP.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $84EER.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $85505024b21cdf3f$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $85505024b21cdf3f$var$CatmullRomClosed(context, alpha) : new (0, $bAmTZ.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("84EER", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $5e0e3c443338365e$export$2e2bcd8739ae039; });

var $3JHvG = parcelRequire("3JHvG");

var $52CP9 = parcelRequire("52CP9");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $3JHvG.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $3JHvG.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5e0e3c443338365e$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $52CP9.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("lQj60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe6d445943309ee2$export$2e2bcd8739ae039; });

var $6YdNX = parcelRequire("6YdNX");

var $84EER = parcelRequire("84EER");
function $fe6d445943309ee2$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$fe6d445943309ee2$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $84EER.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $fe6d445943309ee2$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $fe6d445943309ee2$var$CatmullRomOpen(context, alpha) : new (0, $6YdNX.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("bWNLs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b2bb6a93ca081be$export$2e2bcd8739ae039; });

var $2QVeP = parcelRequire("2QVeP");
function $8b2bb6a93ca081be$var$LinearClosed(context) {
    this._context = context;
}
$8b2bb6a93ca081be$var$LinearClosed.prototype = {
    areaStart: (0, $2QVeP.default),
    areaEnd: (0, $2QVeP.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $8b2bb6a93ca081be$export$2e2bcd8739ae039(context) {
    return new $8b2bb6a93ca081be$var$LinearClosed(context);
}

});

parcelRegister("ivmHr", function(module, exports) {

$parcel$export(module.exports, "monotoneX", function () { return $d78cbaf1ba300577$export$99563b5420dbdc55; });
$parcel$export(module.exports, "monotoneY", function () { return $d78cbaf1ba300577$export$8b5360456d6bdb88; });
function $d78cbaf1ba300577$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $d78cbaf1ba300577$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($d78cbaf1ba300577$var$sign(s0) + $d78cbaf1ba300577$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $d78cbaf1ba300577$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $d78cbaf1ba300577$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $d78cbaf1ba300577$var$MonotoneX(context) {
    this._context = context;
}
$d78cbaf1ba300577$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $d78cbaf1ba300577$var$point(this, this._t0, $d78cbaf1ba300577$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $d78cbaf1ba300577$var$point(this, $d78cbaf1ba300577$var$slope2(this, t1 = $d78cbaf1ba300577$var$slope3(this, x, y)), t1);
                break;
            default:
                $d78cbaf1ba300577$var$point(this, this._t0, t1 = $d78cbaf1ba300577$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $d78cbaf1ba300577$var$MonotoneY(context) {
    this._context = new $d78cbaf1ba300577$var$ReflectContext(context);
}
($d78cbaf1ba300577$var$MonotoneY.prototype = Object.create($d78cbaf1ba300577$var$MonotoneX.prototype)).point = function(x, y) {
    $d78cbaf1ba300577$var$MonotoneX.prototype.point.call(this, y, x);
};
function $d78cbaf1ba300577$var$ReflectContext(context) {
    this._context = context;
}
$d78cbaf1ba300577$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $d78cbaf1ba300577$export$99563b5420dbdc55(context) {
    return new $d78cbaf1ba300577$var$MonotoneX(context);
}
function $d78cbaf1ba300577$export$8b5360456d6bdb88(context) {
    return new $d78cbaf1ba300577$var$MonotoneY(context);
}

});

parcelRegister("1Mn1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14bc21429763cf8d$export$2e2bcd8739ae039; });
function $14bc21429763cf8d$var$Natural(context) {
    this._context = context;
}
$14bc21429763cf8d$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $14bc21429763cf8d$var$controlPoints(x), py = $14bc21429763cf8d$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $14bc21429763cf8d$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $14bc21429763cf8d$export$2e2bcd8739ae039(context) {
    return new $14bc21429763cf8d$var$Natural(context);
}

});

parcelRegister("38sKq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24886b26ebd87303$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "stepBefore", function () { return $24886b26ebd87303$export$10eafa5b7478b343; });
$parcel$export(module.exports, "stepAfter", function () { return $24886b26ebd87303$export$793b3db073781cbb; });
function $24886b26ebd87303$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$24886b26ebd87303$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $24886b26ebd87303$export$2e2bcd8739ae039(context) {
    return new $24886b26ebd87303$var$Step(context, 0.5);
}
function $24886b26ebd87303$export$10eafa5b7478b343(context) {
    return new $24886b26ebd87303$var$Step(context, 0);
}
function $24886b26ebd87303$export$793b3db073781cbb(context) {
    return new $24886b26ebd87303$var$Step(context, 1);
}

});

parcelRegister("by9WN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $868a9607d3f7599e$export$2e2bcd8739ae039; });

var $1NVw6 = parcelRequire("1NVw6");

var $5UbpF = parcelRequire("5UbpF");

var $kM39A = parcelRequire("kM39A");

var $1QhlB = parcelRequire("1QhlB");
function $868a9607d3f7599e$var$stackValue(d, key) {
    return d[key];
}
function $868a9607d3f7599e$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $868a9607d3f7599e$export$2e2bcd8739ae039() {
    var keys = (0, $5UbpF.default)([]), order = (0, $1QhlB.default), offset = (0, $kM39A.default), value = $868a9607d3f7599e$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $868a9607d3f7599e$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $1NVw6.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $5UbpF.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $5UbpF.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $1QhlB.default) : typeof _ === "function" ? _ : (0, $5UbpF.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $kM39A.default) : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("kM39A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1fabc911d01aeed$export$2e2bcd8739ae039; });
function $f1fabc911d01aeed$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("1QhlB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15781a9dd22812c8$export$2e2bcd8739ae039; });
function $15781a9dd22812c8$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("flkSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b9030ed0140423$export$2e2bcd8739ae039; });

var $kM39A = parcelRequire("kM39A");
function $b2b9030ed0140423$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $kM39A.default)(series, order);
}

});

parcelRegister("63Syu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $469d5772aa47141b$export$2e2bcd8739ae039; });
function $469d5772aa47141b$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("8paFe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e8ee2fa8ffe27e$export$2e2bcd8739ae039; });

var $kM39A = parcelRequire("kM39A");
function $61e8ee2fa8ffe27e$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $kM39A.default)(series, order);
}

});

parcelRegister("XwP10", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b2ef888ba06ae96$export$2e2bcd8739ae039; });

var $kM39A = parcelRequire("kM39A");
function $0b2ef888ba06ae96$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $kM39A.default)(series, order);
}

});

parcelRegister("dks2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b42e47ff3180318$export$2e2bcd8739ae039; });

var $1QhlB = parcelRequire("1QhlB");
function $9b42e47ff3180318$export$2e2bcd8739ae039(series) {
    var peaks = series.map($9b42e47ff3180318$var$peak);
    return (0, $1QhlB.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $9b42e47ff3180318$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("d3Ppk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98236ea027448246$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "sum", function () { return $98236ea027448246$export$8a63f25cc62965f1; });

var $1QhlB = parcelRequire("1QhlB");
function $98236ea027448246$export$2e2bcd8739ae039(series) {
    var sums = series.map($98236ea027448246$export$8a63f25cc62965f1);
    return (0, $1QhlB.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $98236ea027448246$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("jMPoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e67a5e2e7858745f$export$2e2bcd8739ae039; });

var $d3Ppk = parcelRequire("d3Ppk");
function $e67a5e2e7858745f$export$2e2bcd8739ae039(series) {
    return (0, $d3Ppk.default)(series).reverse();
}

});

parcelRegister("7gOhO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54b108d433e35585$export$2e2bcd8739ae039; });

var $dks2s = parcelRequire("dks2s");

var $d3Ppk = parcelRequire("d3Ppk");
function $54b108d433e35585$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $d3Ppk.sum)), order = (0, $dks2s.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("gYdLj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5acecd488fe05b9$export$2e2bcd8739ae039; });

var $1QhlB = parcelRequire("1QhlB");
function $c5acecd488fe05b9$export$2e2bcd8739ae039(series) {
    return (0, $1QhlB.default)(series).reverse();
}

});


parcelRegister("esTGQ", function(module, exports) {

$parcel$export(module.exports, "timeInterval", function () { return (parcelRequire("4kQAV")).timeInterval; });
$parcel$export(module.exports, "utcMillisecond", function () { return (parcelRequire("6FfPx")).millisecond; });
$parcel$export(module.exports, "utcMilliseconds", function () { return (parcelRequire("6FfPx")).milliseconds; });
$parcel$export(module.exports, "timeMillisecond", function () { return (parcelRequire("6FfPx")).millisecond; });
$parcel$export(module.exports, "timeMilliseconds", function () { return (parcelRequire("6FfPx")).milliseconds; });
$parcel$export(module.exports, "utcSecond", function () { return (parcelRequire("leuDw")).second; });
$parcel$export(module.exports, "utcSeconds", function () { return (parcelRequire("leuDw")).seconds; });
$parcel$export(module.exports, "timeSecond", function () { return (parcelRequire("leuDw")).second; });
$parcel$export(module.exports, "timeSeconds", function () { return (parcelRequire("leuDw")).seconds; });
$parcel$export(module.exports, "timeMinute", function () { return (parcelRequire("7P7u1")).timeMinute; });
$parcel$export(module.exports, "timeMinutes", function () { return (parcelRequire("7P7u1")).timeMinutes; });
$parcel$export(module.exports, "utcMinute", function () { return (parcelRequire("7P7u1")).utcMinute; });
$parcel$export(module.exports, "utcMinutes", function () { return (parcelRequire("7P7u1")).utcMinutes; });
$parcel$export(module.exports, "timeHour", function () { return (parcelRequire("3hgbf")).timeHour; });
$parcel$export(module.exports, "timeHours", function () { return (parcelRequire("3hgbf")).timeHours; });
$parcel$export(module.exports, "utcHour", function () { return (parcelRequire("3hgbf")).utcHour; });
$parcel$export(module.exports, "utcHours", function () { return (parcelRequire("3hgbf")).utcHours; });
$parcel$export(module.exports, "timeDay", function () { return (parcelRequire("6fz8m")).timeDay; });
$parcel$export(module.exports, "timeDays", function () { return (parcelRequire("6fz8m")).timeDays; });
$parcel$export(module.exports, "utcDay", function () { return (parcelRequire("6fz8m")).utcDay; });
$parcel$export(module.exports, "utcDays", function () { return (parcelRequire("6fz8m")).utcDays; });
$parcel$export(module.exports, "unixDay", function () { return (parcelRequire("6fz8m")).unixDay; });
$parcel$export(module.exports, "unixDays", function () { return (parcelRequire("6fz8m")).unixDays; });
$parcel$export(module.exports, "timeWeek", function () { return (parcelRequire("4gg5r")).timeSunday; });
$parcel$export(module.exports, "timeWeeks", function () { return (parcelRequire("4gg5r")).timeSundays; });
$parcel$export(module.exports, "timeSunday", function () { return (parcelRequire("4gg5r")).timeSunday; });
$parcel$export(module.exports, "timeSundays", function () { return (parcelRequire("4gg5r")).timeSundays; });
$parcel$export(module.exports, "timeMonday", function () { return (parcelRequire("4gg5r")).timeMonday; });
$parcel$export(module.exports, "timeMondays", function () { return (parcelRequire("4gg5r")).timeMondays; });
$parcel$export(module.exports, "timeTuesday", function () { return (parcelRequire("4gg5r")).timeTuesday; });
$parcel$export(module.exports, "timeTuesdays", function () { return (parcelRequire("4gg5r")).timeTuesdays; });
$parcel$export(module.exports, "timeWednesday", function () { return (parcelRequire("4gg5r")).timeWednesday; });
$parcel$export(module.exports, "timeWednesdays", function () { return (parcelRequire("4gg5r")).timeWednesdays; });
$parcel$export(module.exports, "timeThursday", function () { return (parcelRequire("4gg5r")).timeThursday; });
$parcel$export(module.exports, "timeThursdays", function () { return (parcelRequire("4gg5r")).timeThursdays; });
$parcel$export(module.exports, "timeFriday", function () { return (parcelRequire("4gg5r")).timeFriday; });
$parcel$export(module.exports, "timeFridays", function () { return (parcelRequire("4gg5r")).timeFridays; });
$parcel$export(module.exports, "timeSaturday", function () { return (parcelRequire("4gg5r")).timeSaturday; });
$parcel$export(module.exports, "timeSaturdays", function () { return (parcelRequire("4gg5r")).timeSaturdays; });
$parcel$export(module.exports, "utcWeek", function () { return (parcelRequire("4gg5r")).utcSunday; });
$parcel$export(module.exports, "utcWeeks", function () { return (parcelRequire("4gg5r")).utcSundays; });
$parcel$export(module.exports, "utcSunday", function () { return (parcelRequire("4gg5r")).utcSunday; });
$parcel$export(module.exports, "utcSundays", function () { return (parcelRequire("4gg5r")).utcSundays; });
$parcel$export(module.exports, "utcMonday", function () { return (parcelRequire("4gg5r")).utcMonday; });
$parcel$export(module.exports, "utcMondays", function () { return (parcelRequire("4gg5r")).utcMondays; });
$parcel$export(module.exports, "utcTuesday", function () { return (parcelRequire("4gg5r")).utcTuesday; });
$parcel$export(module.exports, "utcTuesdays", function () { return (parcelRequire("4gg5r")).utcTuesdays; });
$parcel$export(module.exports, "utcWednesday", function () { return (parcelRequire("4gg5r")).utcWednesday; });
$parcel$export(module.exports, "utcWednesdays", function () { return (parcelRequire("4gg5r")).utcWednesdays; });
$parcel$export(module.exports, "utcThursday", function () { return (parcelRequire("4gg5r")).utcThursday; });
$parcel$export(module.exports, "utcThursdays", function () { return (parcelRequire("4gg5r")).utcThursdays; });
$parcel$export(module.exports, "utcFriday", function () { return (parcelRequire("4gg5r")).utcFriday; });
$parcel$export(module.exports, "utcFridays", function () { return (parcelRequire("4gg5r")).utcFridays; });
$parcel$export(module.exports, "utcSaturday", function () { return (parcelRequire("4gg5r")).utcSaturday; });
$parcel$export(module.exports, "utcSaturdays", function () { return (parcelRequire("4gg5r")).utcSaturdays; });
$parcel$export(module.exports, "timeMonth", function () { return (parcelRequire("ceUnP")).timeMonth; });
$parcel$export(module.exports, "timeMonths", function () { return (parcelRequire("ceUnP")).timeMonths; });
$parcel$export(module.exports, "utcMonth", function () { return (parcelRequire("ceUnP")).utcMonth; });
$parcel$export(module.exports, "utcMonths", function () { return (parcelRequire("ceUnP")).utcMonths; });
$parcel$export(module.exports, "timeYear", function () { return (parcelRequire("kHofm")).timeYear; });
$parcel$export(module.exports, "timeYears", function () { return (parcelRequire("kHofm")).timeYears; });
$parcel$export(module.exports, "utcYear", function () { return (parcelRequire("kHofm")).utcYear; });
$parcel$export(module.exports, "utcYears", function () { return (parcelRequire("kHofm")).utcYears; });
$parcel$export(module.exports, "utcTicks", function () { return (parcelRequire("5qbnm")).utcTicks; });
$parcel$export(module.exports, "utcTickInterval", function () { return (parcelRequire("5qbnm")).utcTickInterval; });
$parcel$export(module.exports, "timeTicks", function () { return (parcelRequire("5qbnm")).timeTicks; });
$parcel$export(module.exports, "timeTickInterval", function () { return (parcelRequire("5qbnm")).timeTickInterval; });

var $4kQAV = parcelRequire("4kQAV");

var $6FfPx = parcelRequire("6FfPx");

var $leuDw = parcelRequire("leuDw");

var $7P7u1 = parcelRequire("7P7u1");

var $3hgbf = parcelRequire("3hgbf");

var $6fz8m = parcelRequire("6fz8m");

var $4gg5r = parcelRequire("4gg5r");

var $ceUnP = parcelRequire("ceUnP");

var $kHofm = parcelRequire("kHofm");

var $5qbnm = parcelRequire("5qbnm");

});

parcelRegister("3ELuc", function(module, exports) {

$parcel$export(module.exports, "timeFormatDefaultLocale", function () { return (parcelRequire("eo1Zn")).default; });
$parcel$export(module.exports, "timeFormat", function () { return (parcelRequire("eo1Zn")).timeFormat; });
$parcel$export(module.exports, "timeParse", function () { return (parcelRequire("eo1Zn")).timeParse; });
$parcel$export(module.exports, "utcFormat", function () { return (parcelRequire("eo1Zn")).utcFormat; });
$parcel$export(module.exports, "utcParse", function () { return (parcelRequire("eo1Zn")).utcParse; });
$parcel$export(module.exports, "timeFormatLocale", function () { return (parcelRequire("fhkRg")).default; });
$parcel$export(module.exports, "isoFormat", function () { return (parcelRequire("9cPzm")).default; });
$parcel$export(module.exports, "isoParse", function () { return (parcelRequire("b0cFQ")).default; });

var $eo1Zn = parcelRequire("eo1Zn");

var $fhkRg = parcelRequire("fhkRg");

var $9cPzm = parcelRequire("9cPzm");

var $b0cFQ = parcelRequire("b0cFQ");

});
parcelRegister("9cPzm", function(module, exports) {

$parcel$export(module.exports, "isoSpecifier", function () { return $6b3d3ca9a53f9dd8$export$491f7bf2e88d83ce; });
$parcel$export(module.exports, "default", function () { return $6b3d3ca9a53f9dd8$export$2e2bcd8739ae039; });

var $eo1Zn = parcelRequire("eo1Zn");
var $6b3d3ca9a53f9dd8$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $6b3d3ca9a53f9dd8$var$formatIsoNative(date) {
    return date.toISOString();
}
var $6b3d3ca9a53f9dd8$var$formatIso = Date.prototype.toISOString ? $6b3d3ca9a53f9dd8$var$formatIsoNative : (0, $eo1Zn.utcFormat)($6b3d3ca9a53f9dd8$export$491f7bf2e88d83ce);
var $6b3d3ca9a53f9dd8$export$2e2bcd8739ae039 = $6b3d3ca9a53f9dd8$var$formatIso;

});

parcelRegister("b0cFQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8029868cb53f1de0$export$2e2bcd8739ae039; });

var $9cPzm = parcelRequire("9cPzm");

var $eo1Zn = parcelRequire("eo1Zn");
function $8029868cb53f1de0$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $8029868cb53f1de0$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $8029868cb53f1de0$var$parseIsoNative : (0, $eo1Zn.utcParse)((0, $9cPzm.isoSpecifier));
var $8029868cb53f1de0$export$2e2bcd8739ae039 = $8029868cb53f1de0$var$parseIso;

});


parcelRegister("9qanl", function(module, exports) {

$parcel$export(module.exports, "now", function () { return (parcelRequire("2lwYT")).now; });
$parcel$export(module.exports, "timer", function () { return (parcelRequire("2lwYT")).timer; });
$parcel$export(module.exports, "timerFlush", function () { return (parcelRequire("2lwYT")).timerFlush; });
$parcel$export(module.exports, "timeout", function () { return (parcelRequire("iEvah")).default; });
$parcel$export(module.exports, "interval", function () { return (parcelRequire("cNDzF")).default; });

var $2lwYT = parcelRequire("2lwYT");

var $iEvah = parcelRequire("iEvah");

var $cNDzF = parcelRequire("cNDzF");

});
parcelRegister("cNDzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9518c24280592466$export$2e2bcd8739ae039; });

var $2lwYT = parcelRequire("2lwYT");
function $9518c24280592466$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $2lwYT.Timer), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    t._restart = t.restart;
    t.restart = function(callback, delay, time) {
        delay = +delay, time = time == null ? (0, $2lwYT.now)() : +time;
        t._restart(function tick(elapsed) {
            elapsed += total;
            t._restart(tick, total += delay, time);
            callback(elapsed);
        }, delay, time);
    };
    t.restart(callback, delay, time);
    return t;
}

});


parcelRegister("hAqXZ", function(module, exports) {

$parcel$export(module.exports, "zoom", function () { return (parcelRequire("6sJdA")).default; });
$parcel$export(module.exports, "zoomTransform", function () { return (parcelRequire("aPiHx")).default; });
$parcel$export(module.exports, "zoomIdentity", function () { return (parcelRequire("aPiHx")).identity; });
$parcel$export(module.exports, "ZoomTransform", function () { return (parcelRequire("aPiHx")).Transform; });

var $6sJdA = parcelRequire("6sJdA");

var $aPiHx = parcelRequire("aPiHx");

});
parcelRegister("6sJdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b486efc2195b64d$export$2e2bcd8739ae039; });

var $5Rufx = parcelRequire("5Rufx");

var $bQ9aN = parcelRequire("bQ9aN");

var $ijeSI = parcelRequire("ijeSI");

var $pd5FT = parcelRequire("pd5FT");
var $3xlsS = parcelRequire("3xlsS");
parcelRequire("buDM2");
var $1WXFO = parcelRequire("1WXFO");

var $heG7M = parcelRequire("heG7M");

var $3UyO4 = parcelRequire("3UyO4");

var $aPiHx = parcelRequire("aPiHx");

var $7x5Oi = parcelRequire("7x5Oi");
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $4b486efc2195b64d$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function $4b486efc2195b64d$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $4b486efc2195b64d$var$defaultTransform() {
    return this.__zoom || (0, $aPiHx.identity);
}
function $4b486efc2195b64d$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $4b486efc2195b64d$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $4b486efc2195b64d$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $4b486efc2195b64d$export$2e2bcd8739ae039() {
    var filter = $4b486efc2195b64d$var$defaultFilter, extent = $4b486efc2195b64d$var$defaultExtent, constrain = $4b486efc2195b64d$var$defaultConstrain, wheelDelta = $4b486efc2195b64d$var$defaultWheelDelta, touchable = $4b486efc2195b64d$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $ijeSI.default), listeners = (0, $5Rufx.default)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $4b486efc2195b64d$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $4b486efc2195b64d$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $aPiHx.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $aPiHx.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $aPiHx.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $aPiHx.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $3xlsS.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $3UyO4.default)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $pd5FT.default)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $1WXFO.default)(this);
            g.start();
        }
        (0, $7x5Oi.default)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $3xlsS.default)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $pd5FT.default)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $bQ9aN.default)(event.view);
        (0, $7x5Oi.nopropagation)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $1WXFO.default)(this);
        g.start();
        function mousemoved(event) {
            (0, $7x5Oi.default)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $pd5FT.default)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $bQ9aN.yesdrag)(event.view, g.moved);
            (0, $7x5Oi.default)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $pd5FT.default)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $7x5Oi.default)(event);
        if (duration > 0) (0, $3xlsS.default)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $3xlsS.default)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $7x5Oi.nopropagation)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $pd5FT.default)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $1WXFO.default)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $7x5Oi.default)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $pd5FT.default)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $7x5Oi.nopropagation)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $pd5FT.default)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $3xlsS.default)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $heG7M.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $heG7M.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $heG7M.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $heG7M.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}

});
parcelRegister("heG7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8c46b8801822023$export$2e2bcd8739ae039; });
var $c8c46b8801822023$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("3UyO4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d9199f13602a530$export$2e2bcd8739ae039; });
function $2d9199f13602a530$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("aPiHx", function(module, exports) {

$parcel$export(module.exports, "Transform", function () { return $7e1d2c797c450045$export$563a914cafbdc389; });
$parcel$export(module.exports, "identity", function () { return $7e1d2c797c450045$export$f0954fd7d5368655; });
$parcel$export(module.exports, "default", function () { return $7e1d2c797c450045$export$2e2bcd8739ae039; });
function $7e1d2c797c450045$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$7e1d2c797c450045$export$563a914cafbdc389.prototype = {
    constructor: $7e1d2c797c450045$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $7e1d2c797c450045$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $7e1d2c797c450045$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $7e1d2c797c450045$export$f0954fd7d5368655 = new $7e1d2c797c450045$export$563a914cafbdc389(1, 0, 0);
$7e1d2c797c450045$export$2e2bcd8739ae039.prototype = $7e1d2c797c450045$export$563a914cafbdc389.prototype;
function $7e1d2c797c450045$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $7e1d2c797c450045$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("7x5Oi", function(module, exports) {

$parcel$export(module.exports, "nopropagation", function () { return $57c01f455775c72f$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $57c01f455775c72f$export$2e2bcd8739ae039; });
function $57c01f455775c72f$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $57c01f455775c72f$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});





parcelRegister("baN65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8226b693f4d04f28$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("5WBiR");
var $NBzfP = parcelRequire("NBzfP");
var $xN89R = parcelRequire("xN89R");
var $dQDxu = parcelRequire("dQDxu");

var $eFsDQ = parcelRequire("eFsDQ");

var $27ZKj = parcelRequire("27ZKj");

var $iWaGk = parcelRequire("iWaGk");

var $lxEiN = parcelRequire("lxEiN");

var $etOpj = parcelRequire("etOpj");
const $8226b693f4d04f28$var$margin = {
    top: 10,
    right: 50,
    bottom: 30,
    left: 50
};
const $8226b693f4d04f28$var$Rectangle = ({ x: x, y: y, width: width, height: height, d: d, setTooltip: setTooltip, colorScale: colorScale, calculateTooltipPosition: calculateTooltipPosition })=>{
    const [mouseOver, setMouseOver] = (0, $70fFQ.useState)(false);
    return /*#__PURE__*/ (0, $4x3bm.jsx)("rect", {
        r: 0,
        x: x,
        y: y,
        width: width - 2,
        height: height - 2,
        calculateTooltipPosition: true,
        opacity: 1,
        fill: colorScale(d.value),
        rx: 0,
        strokeWidth: mouseOver ? 5 : 8,
        stroke: mouseOver ? "#2196f3" : "none",
        onMouseEnter: ()=>{
            const { xPos: xPos, yPos: yPos } = calculateTooltipPosition(x, y);
            setMouseOver(true);
            setTooltip({
                xLabel: d.x,
                yLabel: d.y,
                xPos: xPos,
                yPos: yPos,
                // xPos: x + xScale.bandwidth() + margin.left - 200,
                // yPos: y + xScale.bandwidth() / 2 + margin.top,
                value: Math.round(d.value * 100) / 100,
                consumption: Math.round(d.consumption * 100) / 100,
                production: d.production
            });
        },
        onMouseOut: ()=>{
            setMouseOver(false);
            setTooltip(null);
        },
        // containerRef={containerRef}
        cursor: "pointer"
    }, x + y);
};
const $8226b693f4d04f28$var$Heatmap = (props)=>{
    const { buildingDetailStore: buildingDetailStore } = (0, $iWaGk.default)();
    const { height: height, buildingId: buildingId, projectId: projectId } = props;
    const [tooltip, setTooltip] = (0, $70fFQ.useState)(null);
    const [res, setRes] = (0, $70fFQ.useState)();
    const [data, setData] = (0, $70fFQ.useState)([]);
    const [loading, setLoading] = (0, $70fFQ.useState)(true);
    const [width, setWidth] = (0, $70fFQ.useState)((window.innerWidth - 550) / 1.07);
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    (0, $70fFQ.useEffect)(()=>{
        const handleResize = ()=>{
            setWidth((window.innerWidth - 500) / 1.07);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0, $70fFQ.useEffect)(()=>{
        const fetchData = async (buildingId, projectId)=>{
            if (buildingId) {
                await buildingDetailStore.getPredictions(buildingId);
                // setInitialResBuilding(buildingDetailStore.predictions);
                const tempVar = buildingDetailStore.predictions;
                setRes(tempVar);
                setLoading(false);
            } else if (projectId) {
                const tempVar = await (0, $lxEiN.default).Project.getProjectPredictions(projectId);
                setRes(tempVar.data.data);
                setLoading(false);
            }
        };
        fetchData(buildingId, projectId);
    }, [
        buildingId,
        projectId
    ]);
    (0, $70fFQ.useEffect)(()=>{
        const formatData = ()=>{
            const result = [];
            if (res) {
                const data = res;
                const netLoad = data.find((item)=>item.id === "net_load");
                const loadCurve = data.find((item)=>item.id === "load_curve");
                const chp = data.find((item)=>item.id === "chp");
                const solar = data.find((item)=>item.id === "solar");
                const fuelCell = data.find((item)=>item.id === "fuel_cell");
                const pvWatts = data.find((item)=>item.id === "pvwatts");
                for(let i = 0; i < netLoad.data.length; i += 1){
                    const timestamp = netLoad.data[i].x;
                    const date = new Date(timestamp);
                    const day = (0, $eFsDQ.default)(date, "d. MMM");
                    const consumption = loadCurve.data[i].y;
                    /*
            Old projects don't have the technology breakdown (solar, chp, fuel cell)
            but instead have a pvWatts data which is the solar production. So we use that instead.
          */ const production = pvWatts ? pvWatts.data[i].y : chp.data[i].y + solar.data[i].y + fuelCell.data[i].y;
                    const net = netLoad.data[i].y;
                    result.push({
                        x: (0, $eFsDQ.default)(date, "h a"),
                        y: day,
                        value: net,
                        consumption: consumption,
                        production: production
                    });
                }
            }
            setData(result);
        };
        formatData();
    }, [
        res
    ]);
    const boundsWidth = width - $8226b693f4d04f28$var$margin.right - $8226b693f4d04f28$var$margin.left;
    const boundsHeight = height - $8226b693f4d04f28$var$margin.top - $8226b693f4d04f28$var$margin.bottom;
    const allYGroups = (0, $70fFQ.useMemo)(()=>[
            ...new Set(data.map((d)=>d.y))
        ], [
        data
    ]);
    const allXGroups = (0, $70fFQ.useMemo)(()=>[
            ...new Set(data.map((d)=>d.x))
        ], [
        data
    ]);
    const maxValue = (0, $70fFQ.useMemo)(()=>$NBzfP.default(data.map((d)=>parseFloat(d.value))), [
        data
    ]);
    const minValue = (0, $70fFQ.useMemo)(()=>$xN89R.default(data.map((d)=>parseFloat(d.value))), [
        data
    ]);
    const xScale = (0, $70fFQ.useMemo)(()=>{
        return $dQDxu.default().range([
            0,
            boundsWidth
        ]).domain(allXGroups).padding(0.01);
    }, [
        data,
        width
    ]);
    const yScale = (0, $70fFQ.useMemo)(()=>{
        return $dQDxu.default().range([
            boundsHeight,
            0
        ]).domain(allYGroups).padding(0.01);
    }, [
        data,
        height
    ]);
    // const colorScale = d3
    //   .scaleSequential()
    //   .interpolator(d3.interpolateInferno)
    //   .domain([min, max]);
    function colorScale(value) {
        const min = minValue - 1;
        const max = maxValue + 1;
        if (value <= min) return 0;
        if (value >= max) return 1;
        const v = (value - min) / (max - min);
        const color = `rgba(59, 130, 246, ${v})`;
        return color;
    }
    const calculateTooltipPosition = (x, y)=>{
        const tooltipWidth = 800;
        const tooltipHeight = 100;
        const adjustedXPos = x + xScale.bandwidth() + $8226b693f4d04f28$var$margin.left;
        const adjustedYPos = y + xScale.bandwidth() / 2 + $8226b693f4d04f28$var$margin.top;
        const xPos = adjustedXPos + tooltipWidth > screenWidth ? screenWidth - tooltipWidth : adjustedXPos;
        const yPos = adjustedYPos + tooltipHeight > screenHeight ? screenHeight - tooltipHeight : adjustedYPos < 0 ? 0 : adjustedYPos;
        return {
            xPos: xPos,
            yPos: yPos
        };
    };
    // Build the rectangles
    const allShapes = data.map((d)=>{
        const x = xScale(d.x);
        const y = yScale(d.y);
        if (d.value === null || !x || !y) return;
        const width = xScale.bandwidth();
        const height = yScale.bandwidth();
        return /*#__PURE__*/ (0, $4x3bm.jsx)($8226b693f4d04f28$var$Rectangle, {
            colorScale: colorScale,
            setTooltip: setTooltip,
            calculateTooltipPosition: calculateTooltipPosition,
            width: width,
            height: height,
            x: x,
            y: y,
            d: d
        }, `${x}${y}`);
    });
    const xLabels = allXGroups.map((name)=>{
        const x = xScale(name);
        if (!x) return null;
        return /*#__PURE__*/ (0, $4x3bm.jsx)("text", {
            x: x + xScale.bandwidth() / 2,
            y: boundsHeight + 10,
            textAnchor: "middle",
            dominantBaseline: "middle",
            fontSize: 10,
            children: name
        }, `${x}text`);
    });
    const yLabels = allYGroups.map((name)=>{
        const y = yScale(name);
        if (!y) return null;
        return /*#__PURE__*/ (0, $4x3bm.jsx)("text", {
            x: -5,
            y: y + yScale.bandwidth() / 2,
            textAnchor: "end",
            dominantBaseline: "middle",
            fontSize: 10,
            children: name
        }, `${y}text`);
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
        children: loading ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {}) : /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
            // className="container"
            style: {
                height: "100%",
                width: "100%",
                position: "relative"
            },
            children: [
                tooltip && /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                    className: "tooltip",
                    style: {
                        backgroundColor: "white",
                        position: "absolute",
                        left: tooltip.xPos,
                        top: tooltip.yPos,
                        pointerEvents: "none",
                        padding: "10px",
                        boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                        borderRadius: "5px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                            variant: "body2",
                            center: true,
                            children: [
                                "Consumption: ",
                                tooltip.consumption,
                                " kWh"
                            ]
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                            variant: "body2",
                            center: true,
                            children: [
                                "Production: ",
                                tooltip.production,
                                " kWh"
                            ]
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                            variant: "body2",
                            center: true,
                            children: [
                                "Net: ",
                                tooltip.value,
                                " kWh"
                            ]
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                            variant: "body2",
                            center: true,
                            children: [
                                "Day: ",
                                tooltip.yLabel
                            ]
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                            variant: "body2",
                            center: true,
                            children: [
                                "Hour: ",
                                tooltip.xLabel
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)("svg", {
                    width: width,
                    height: height,
                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)("g", {
                        width: boundsWidth,
                        height: boundsHeight,
                        transform: `translate(${[
                            $8226b693f4d04f28$var$margin.left,
                            $8226b693f4d04f28$var$margin.top
                        ].join(",")})`,
                        children: [
                            allShapes,
                            xLabels,
                            yLabels
                        ]
                    })
                })
            ]
        })
    });
};
var $8226b693f4d04f28$export$2e2bcd8739ae039 = $8226b693f4d04f28$var$Heatmap;

});


parcelRegister("e5JnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a5c0f9f8b8a3a2$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $kIEUX = parcelRequire("kIEUX");

var $4vahZ = parcelRequire("4vahZ");

var $27ZKj = parcelRequire("27ZKj");

var $2mnfJ = parcelRequire("2mnfJ");
function $02a5c0f9f8b8a3a2$export$2e2bcd8739ae039({ options: options = [
    {
        id: "customer",
        label: "Customer"
    },
    {
        id: "owner",
        label: "PPA Owner"
    }
], onChange: onChange = (event, value)=>{
    console.log(event, value);
} }) {
    const [checked, setChecked] = (0, $70fFQ.useState)(false);
    const theme = (0, $2mnfJ.default)();
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4vahZ.default), {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                sx: {
                    textTransform: "initial",
                    color: checked ? theme.palette.text.disabled : theme.palette.text.primary,
                    transition: theme.transitions.create([
                        "color"
                    ])
                },
                variant: "body1",
                children: options[0].label
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $kIEUX.default), {
                size: "small",
                onChange: (event, checked)=>{
                    setChecked(checked);
                    onChange(event, checked ? options[1] : options[0]);
                },
                checked: checked,
                color: "default"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                sx: {
                    textTransform: "initial",
                    color: checked ? theme.palette.text.secondary : theme.palette.text.disabled,
                    transition: theme.transitions.create([
                        "color"
                    ])
                },
                variant: "body1",
                children: options[1].label
            })
        ]
    });
}

});
parcelRegister("kIEUX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f157a816c33ff2a3$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $aAAPW = parcelRequire("aAAPW");

var $bKj54 = parcelRequire("bKj54");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $9A6AZ = parcelRequire("9A6AZ");

var $4x3bm = parcelRequire("4x3bm");
const $f157a816c33ff2a3$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $f157a816c33ff2a3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $aAAPW.default)(edge)}`,
            `size${(0, $aAAPW.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $aAAPW.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $9A6AZ.getSwitchUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $f157a816c33ff2a3$var$SwitchRoot = (0, $71Pr4.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $aAAPW.default)(ownerState.edge)}`],
            styles[`size${(0, $aAAPW.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $9A6AZ.default).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $9A6AZ.default).switchBase}`]: {
            padding: 4,
            [`&.${(0, $9A6AZ.default).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $f157a816c33ff2a3$var$SwitchSwitchBase = (0, $71Pr4.default)((0, $bKj54.default), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $9A6AZ.default).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $aAAPW.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300],
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $9A6AZ.default).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $9A6AZ.default).disabled}`]: {
            color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]
        },
        [`&.${(0, $9A6AZ.default).checked} + .${(0, $9A6AZ.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $9A6AZ.default).disabled} + .${(0, $9A6AZ.default).track}`]: {
            opacity: theme.palette.mode === "light" ? 0.12 : 0.2
        },
        [`& .${(0, $9A6AZ.default).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        "&:hover": {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $9A6AZ.default).checked}`]: {
            color: theme.palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (0, $bFVgt.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $9A6AZ.default).disabled}`]: {
                color: theme.palette.mode === "light" ? (0, $bFVgt.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $bFVgt.darken)(theme.palette[ownerState.color].main, 0.55)
            }
        },
        [`&.${(0, $9A6AZ.default).checked} + .${(0, $9A6AZ.default).track}`]: {
            backgroundColor: theme.palette[ownerState.color].main
        }
    }));
const $f157a816c33ff2a3$var$SwitchTrack = (0, $71Pr4.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white,
        opacity: theme.palette.mode === "light" ? 0.38 : 0.3
    }));
const $f157a816c33ff2a3$var$SwitchThumb = (0, $71Pr4.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: theme.shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $f157a816c33ff2a3$var$Switch = /*#__PURE__*/ $70fFQ.forwardRef(function Switch(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $79yYo.default)(props, $f157a816c33ff2a3$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $f157a816c33ff2a3$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $4x3bm.jsx)($f157a816c33ff2a3$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($f157a816c33ff2a3$var$SwitchRoot, {
        className: (0, $gjktY.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($f157a816c33ff2a3$var$SwitchSwitchBase, (0, $20MOv.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $20MOv.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $4x3bm.jsx)($f157a816c33ff2a3$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $f157a816c33ff2a3$export$2e2bcd8739ae039 = $f157a816c33ff2a3$var$Switch;

});
parcelRegister("9A6AZ", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", function () { return $6f9c97949d00d44b$export$39f6debbec19b3ba; });
$parcel$export(module.exports, "default", function () { return $6f9c97949d00d44b$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $6f9c97949d00d44b$export$39f6debbec19b3ba(slot) {
    return (0, $dtsUs.default)("MuiSwitch", slot);
}
const $6f9c97949d00d44b$var$switchClasses = (0, $jLqVN.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $6f9c97949d00d44b$export$2e2bcd8739ae039 = $6f9c97949d00d44b$var$switchClasses;

});


parcelRegister("4vahZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $347209dd29401af5$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $eHQ84 = parcelRequire("eHQ84");
var $bXmqm = parcelRequire("bXmqm");
var $859H5 = parcelRequire("859H5");

var $jWrHX = parcelRequire("jWrHX");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $4x3bm = parcelRequire("4x3bm");
const $347209dd29401af5$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children"
];
function $347209dd29401af5$var$joinChildren(children, separator) {
    const childrenArray = $70fFQ.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $70fFQ.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $347209dd29401af5$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $347209dd29401af5$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $20MOv.default)({
        display: "flex"
    }, (0, $bXmqm.handleBreakpoints)({
        theme: theme
    }, (0, $bXmqm.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $eHQ84.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (ownerState.spacing[breakpoint] != null || ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $bXmqm.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $bXmqm.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            return {
                "& > :not(style) + :not(style)": {
                    margin: 0,
                    [`margin${$347209dd29401af5$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $eHQ84.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $jWrHX.default)(styles, (0, $bXmqm.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    return styles;
};
const $347209dd29401af5$var$StackRoot = (0, $71Pr4.default)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            styles.root
        ];
    }
})($347209dd29401af5$export$1d567c320f4763bc);
const $347209dd29401af5$var$Stack = /*#__PURE__*/ $70fFQ.forwardRef(function Stack(inProps, ref) {
    const themeProps = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiStack"
    });
    const props = (0, $859H5.default)(themeProps);
    const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children } = props, other = (0, $79yYo.default)(props, $347209dd29401af5$var$_excluded);
    const ownerState = {
        direction: direction,
        spacing: spacing
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)($347209dd29401af5$var$StackRoot, (0, $20MOv.default)({
        as: component,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: divider ? $347209dd29401af5$var$joinChildren(children, divider) : children
    }));
});
var $347209dd29401af5$export$2e2bcd8739ae039 = $347209dd29401af5$var$Stack;

});



parcelRegister("3cTYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $255dea4da3fa923c$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $bDcYY = parcelRequire("bDcYY");
var $7xvOw = parcelRequire("7xvOw");
var $27ZKj = parcelRequire("27ZKj");

var $0qEbJ = parcelRequire("0qEbJ");

function $255dea4da3fa923c$export$2e2bcd8739ae039({ children: children, description: description, title: title, onClick: onClick = ()=>{} }) {
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
        style: {
            pointerEvents: "all"
        },
        className: "page-error",
        bgcolor: "background.paper",
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $0qEbJ.default), {
                className: "page-error-icon",
                color: "disabled"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                gutterBottom: true,
                variant: "h6",
                children: title
            }),
            description && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    gutterBottom: true,
                    variant: "body2",
                    children: description
                })
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                sx: {
                    mt: 2
                },
                variant: "contained",
                color: "primary",
                onClick: onClick,
                className: "page-error-button",
                children: "Ok"
            }),
            children
        ]
    });
}

});

parcelRegister("bPwEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89cdc83e5dc64fdf$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $eGmvM = parcelRequire("eGmvM");
var $27ZKj = parcelRequire("27ZKj");

var $gwLQV = parcelRequire("gwLQV");

var $jkYel = parcelRequire("jkYel");

const $89cdc83e5dc64fdf$var$PanoramaToggleButton = ({ views: views, mapboxMapRef: mapboxMapRef, onChange: onChange, viewState: viewState, dataEditor: dataEditor })=>{
    const [currentView, setCurrentView] = (0, $70fFQ.useState)("map");
    const [satelliteImageSrc, setSatelliteImageSrc] = (0, $70fFQ.useState)(null);
    const [location, setLocation] = (0, $70fFQ.useState)(null);
    const [image, setImage] = (0, $70fFQ.useState)(null);
    const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZ3JpZG1hcmtldCIsImEiOiJjbDkydWs3MzEweXEzM250Z3dzcmQ5ajRtIn0.HJU00OC2YDjxV2KAUJiVyg";
    const debounced = (0, $jkYel.useDebouncedCallback)(()=>{
        if (!mapboxMapRef || !viewState) return;
        const { latitude: latitude, longitude: longitude, zoom: zoom } = viewState;
        const location = `${latitude},${longitude}`;
        const url = `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/${longitude},${latitude},${zoom > 18 ? 18 : zoom},0/300x200?access_token=${MAPBOX_ACCESS_TOKEN}`;
        setSatelliteImageSrc(url);
        setLocation(location);
        if (dataEditor) setCurrentView("satellite");
        if (typeof mapboxMapRef.getCanvas !== "undefined") {
            const dataUrl = mapboxMapRef.getCanvas().toDataURL();
            setImage(dataUrl);
        } else {
            if (!(mapboxMapRef === null || mapboxMapRef === void 0 ? void 0 : mapboxMapRef.current)) return;
            const viewport = new (0, $gwLQV.default)(viewState);
            const nw = viewport.unproject([
                0,
                0
            ]);
            const se = viewport.unproject([
                viewport.width,
                viewport.height
            ]);
            const bbox = `${nw[0]},${se[1]},${se[0]},${nw[1]}`;
            const dataUrl = `https://api.mapbox.com/styles/v1/mapbox/light-v10/static/[${bbox}]/200x130?access_token=pk.eyJ1Ijoia3JpejkiLCJhIjoiY2lna3hzcjc3MDA4ZHZpa3RicmFocTY3diJ9.QpU33nYdvz01BECV2bCrvA&attribution=false&logo=false`;
            setImage(dataUrl);
        }
    }, 1200);
    (0, $70fFQ.useEffect)(()=>{
        debounced();
    }, [
        mapboxMapRef,
        viewState
    ]);
    const setNextView = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const currentIndex = views.indexOf(currentView);
        const nextIndex = (currentIndex + 1) % views.length;
        const nextView = views[nextIndex];
        setCurrentView(nextView);
        onChange(nextView);
    };
    const className = `header-map-toggle header-map-toggle-${currentView}`;
    if (!location) return null;
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eGmvM.default), {
            onClick: setNextView,
            children: [
                currentView === "satellite" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    variant: "body1",
                    children: "Switch to map view"
                }),
                currentView === "map" && views.length === 3 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    variant: "body1",
                    children: "Switch to street view"
                }),
                currentView === "map" && views.length === 2 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    variant: "body1",
                    children: "Switch to satellite view"
                }),
                currentView === "panorama" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    variant: "body1",
                    children: "Switch to satellite view"
                }),
                /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                    className: "street-view-toggle-image",
                    children: [
                        currentView === "map" && /*#__PURE__*/ (0, $4x3bm.jsx)("img", {
                            className: "street-view-toggle-image-panorama",
                            zIndex: "-1",
                            width: "200",
                            height: "130",
                            src: `https://maps.googleapis.com/maps/api/streetview?size=300x300&location=${encodeURI(location)}&key=AIzaSyAqNSqJg9tICtIVa01g1fBj-yI-naGifyA&fov=90&radius=50&source=outdoor&pitch=20`,
                            alt: ""
                        }),
                        currentView === "satellite" && /*#__PURE__*/ (0, $4x3bm.jsx)("img", {
                            className: "street-view-toggle-image-satellite",
                            width: "200",
                            height: "130",
                            src: image,
                            alt: ""
                        }),
                        (currentView === "panorama" || currentView === "map" && views.length === 2) && /*#__PURE__*/ (0, $4x3bm.jsx)("img", {
                            className: "street-view-toggle-image-satellite",
                            width: "200",
                            height: "130",
                            src: satelliteImageSrc,
                            alt: ""
                        })
                    ]
                })
            ]
        })
    });
};
var $89cdc83e5dc64fdf$export$2e2bcd8739ae039 = $89cdc83e5dc64fdf$var$PanoramaToggleButton;

});
parcelRegister("jkYel", function(module, exports) {

$parcel$export(module.exports, "useDebouncedCallback", function () { return $e13e9b1739a59c50$export$e70e6da722faba05; });

var $70fFQ = parcelRequire("70fFQ");
function $e13e9b1739a59c50$export$e70e6da722faba05(u, e, c) {
    var i = this, a = (0, $70fFQ.useRef)(null), o = (0, $70fFQ.useRef)(0), f = (0, $70fFQ.useRef)(null), l = (0, $70fFQ.useRef)([]), m = (0, $70fFQ.useRef)(), v = (0, $70fFQ.useRef)(), d = (0, $70fFQ.useRef)(u), p = (0, $70fFQ.useRef)(!0);
    (0, $70fFQ.useEffect)(function() {
        d.current = u;
    }, [
        u
    ]);
    var g = !e && 0 !== e && "undefined" != typeof window;
    if ("function" != typeof u) throw new TypeError("Expected a function");
    e = +e || 0;
    var w = !!(c = c || {}).leading, s = !("trailing" in c) || !!c.trailing, x = "maxWait" in c, y = x ? Math.max(+c.maxWait || 0, e) : null;
    (0, $70fFQ.useEffect)(function() {
        return p.current = !0, function() {
            p.current = !1;
        };
    }, []);
    var h = (0, $70fFQ.useMemo)(function() {
        var r = function(r) {
            var n = l.current, t = m.current;
            return l.current = m.current = null, o.current = r, v.current = d.current.apply(t, n);
        }, n = function(r, n) {
            g && cancelAnimationFrame(f.current), f.current = g ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!p.current) return !1;
            var n = r - a.current;
            return !a.current || n >= e || n < 0 || x && r - o.current >= y;
        }, u = function(n) {
            return f.current = null, s && l.current ? r(n) : (l.current = m.current = null, v.current);
        }, c = function r() {
            var c = Date.now();
            if (t(c)) return u(c);
            if (p.current) {
                var i = e - (c - a.current), f = x ? Math.min(i, y - (c - o.current)) : i;
                n(r, f);
            }
        }, h = function() {
            var u = Date.now(), d = t(u);
            if (l.current = [].slice.call(arguments), m.current = i, a.current = u, d) {
                if (!f.current && p.current) return o.current = a.current, n(c, e), w ? r(a.current) : v.current;
                if (x) return n(c, e), r(a.current);
            }
            return f.current || n(c, e), v.current;
        };
        return h.cancel = function() {
            f.current && (g ? cancelAnimationFrame(f.current) : clearTimeout(f.current)), o.current = 0, l.current = a.current = m.current = f.current = null;
        }, h.isPending = function() {
            return !!f.current;
        }, h.flush = function() {
            return f.current ? u(Date.now()) : v.current;
        }, h;
    }, [
        w,
        x,
        e,
        y,
        s,
        g
    ]);
    return h;
}
function $e13e9b1739a59c50$var$i(r, n) {
    return r === n;
}
function $e13e9b1739a59c50$var$a(r) {
    return "function" == typeof r ? function() {
        return r;
    } : r;
}
function $e13e9b1739a59c50$export$21805fee57372823(n, t, o) {
    var f, l, m = o && o.equalityFn || $e13e9b1739a59c50$var$i, v = (f = (0, $70fFQ.useState)($e13e9b1739a59c50$var$a(n)), l = f[1], [
        f[0],
        (0, $70fFQ.useCallback)(function(r) {
            return l($e13e9b1739a59c50$var$a(r));
        }, [])
    ]), d = v[0], p = v[1], g = $e13e9b1739a59c50$export$e70e6da722faba05((0, $70fFQ.useCallback)(function(r) {
        return p(r);
    }, [
        p
    ]), t, o), w = (0, $70fFQ.useRef)(n);
    return m(w.current, n) || (g(n), w.current = n), [
        d,
        g
    ];
}
function $e13e9b1739a59c50$export$7158785e55df0693(r, n, t) {
    var u = void 0 === t ? {} : t, e = u.leading, i = u.trailing;
    return $e13e9b1739a59c50$export$e70e6da722faba05(r, n, {
        maxWait: n,
        leading: void 0 === e || e,
        trailing: void 0 === i || i
    });
}

});


parcelRegister("1qCAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10a626cc39e212b8$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");
const $10a626cc39e212b8$var$ProjectHeaderPanorama = ({ onMouseOver: onMouseOver = ()=>{}, onMouseOut: onMouseOut = ()=>{}, viewState: viewState })=>{
    const panoramaContainer = (0, $70fFQ.useRef)(null);
    (0, $70fFQ.useEffect)(()=>{
        if (!viewState) return;
        const { latitude: latitude, longitude: longitude } = viewState;
        const address = `${latitude},${longitude}`;
        const panorama = new google.maps.StreetViewPanorama(panoramaContainer.current, {
            address: // position: { lat: 37.86926, lng: -122.254811 },
            address,
            pov: {
                heading: 165,
                pitch: 20
            },
            zoom: 1,
            disableDefaultUI: true
        });
        let myLatLng;
        const sv = new google.maps.StreetViewService();
        const geocoder = new google.maps.Geocoder();
        const directionsService = new google.maps.DirectionsService();
        const processSVData = (data, status)=>{
            if (status === google.maps.StreetViewStatus.OK) {
                panorama.setPano(data.location.pano);
                const heading = google.maps.geometry.spherical.computeHeading(data.location.latLng, myLatLng);
                panorama.setPov({
                    heading: heading,
                    pitch: 0,
                    zoom: 1
                });
                panorama.setVisible(true);
            } else document.getElementById("pano").style.display = "none";
        };
        geocoder.geocode({
            address: address
        }, (results, status)=>{
            if (status === google.maps.GeocoderStatus.OK) {
                myLatLng = results[0].geometry.location;
                // find a Streetview location on the road
                const request = {
                    origin: address,
                    destination: address,
                    travelMode: google.maps.DirectionsTravelMode.DRIVING
                };
                directionsService.route(request, (response, status)=>{
                    if (status === google.maps.DirectionsStatus.OK) {
                        const latlng = response.routes[0].legs[0].start_location;
                        const radius = 1000;
                        sv.getPanorama({
                            location: latlng,
                            radius: radius,
                            source: google.maps.StreetViewSource.OUTDOOR
                        }, processSVData);
                    }
                });
            }
        });
        return ()=>{
            panorama.setVisible(false);
        };
    }, [
        viewState
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onFocus: onMouseOver,
        onBlur: onMouseOut,
        className: "street-view-panorama",
        style: {
            pointerEvents: "all",
            zIndex: 500
        },
        children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
            ref: panoramaContainer
        })
    });
};
var $10a626cc39e212b8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).memo($10a626cc39e212b8$var$ProjectHeaderPanorama);

});


parcelRegister("jRWBX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7706e85f6f3fb0e$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $k8awT = parcelRequire("k8awT");

var $1Kscq = parcelRequire("1Kscq");

var $bCnFC = parcelRequire("bCnFC");

var $8LlRP = parcelRequire("8LlRP");
const $e7706e85f6f3fb0e$var$SearchResults = ({ itemCount: itemCount, itemSize: itemSize = 68, style: style, renderNoResults: renderNoResults, renderRow: renderRow, store: store, getItemsSize: getItemsSize })=>{
    const { resultMap: resultMap } = store;
    const ids = [
        ...resultMap.keys()
    ];
    const loadMoreItems = (startIndex, stopIndex)=>{
        const iterator = Array.from(new Array(stopIndex - startIndex), (x, i)=>startIndex + i);
        const idsToLoad = iterator.reduce((acc, i)=>{
            const id = ids[i];
            const res = resultMap.get(id);
            if (res === 0 && res !== 1) acc.push(id);
            return acc;
        }, []);
        return store.loadResult(idsToLoad);
    };
    const isRowLoaded = (index)=>{
        const id = ids[index];
        const result = resultMap.get(id);
        return !!result;
    };
    const Row = ({ index: index, style: style })=>{
        const id = ids[index];
        const result = resultMap.get(id);
        if (result === 1 || result === 0) return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
            className: "building-card building-card-loading",
            style: style,
            children: [
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1Kscq.default), {
                    width: "40%",
                    variant: "text"
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1Kscq.default), {
                    width: "90%",
                    variant: "text"
                })
            ]
        }, id);
        const isPicked = store.pickedResults.has(id);
        return renderRow({
            index: index,
            style: style,
            data: result,
            isPicked: isPicked
        });
    };
    if (resultMap.size === 0 && renderNoResults) return renderNoResults();
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        style: style,
        className: "results",
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bCnFC.default), {
            children: ({ height: height, width: width })=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $8LlRP.default), {
                    isItemLoaded: isRowLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: itemCount || ids.length,
                    threshold: 10,
                    minimumBatchSize: 10,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $k8awT.VariableSizeList), {
                            height: height,
                            itemCount: ids.length,
                            itemSize: (index)=>{
                                if (getItemsSize) return getItemsSize(index);
                                return itemSize;
                            },
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: width,
                            children: Row
                        })
                })
        })
    });
};
var $e7706e85f6f3fb0e$export$2e2bcd8739ae039 = (0, $87gt0.observer)($e7706e85f6f3fb0e$var$SearchResults);

});
parcelRegister("k8awT", function(module, exports) {

$parcel$export(module.exports, "VariableSizeList", function () { return $ea7cb8f7913dc99b$export$d8ac3b6b20be856e; });

var $hSVl4 = parcelRequire("hSVl4");

var $b9BiW = parcelRequire("b9BiW");

var $7jrgG = parcelRequire("7jrgG");

var $9W8FL = parcelRequire("9W8FL");

var $70fFQ = parcelRequire("70fFQ");

var $8EuCQ = parcelRequire("8EuCQ");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $ea7cb8f7913dc99b$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $ea7cb8f7913dc99b$var$now = $ea7cb8f7913dc99b$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $ea7cb8f7913dc99b$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $ea7cb8f7913dc99b$var$requestTimeout(callback, delay) {
    var start = $ea7cb8f7913dc99b$var$now();
    function tick() {
        if ($ea7cb8f7913dc99b$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $ea7cb8f7913dc99b$var$size = -1; // This utility copied from "dom-helpers" package.
function $ea7cb8f7913dc99b$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($ea7cb8f7913dc99b$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $ea7cb8f7913dc99b$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $ea7cb8f7913dc99b$var$size;
}
var $ea7cb8f7913dc99b$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $ea7cb8f7913dc99b$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($ea7cb8f7913dc99b$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $ea7cb8f7913dc99b$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $ea7cb8f7913dc99b$var$cachedRTLResult = "negative";
            else $ea7cb8f7913dc99b$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $ea7cb8f7913dc99b$var$cachedRTLResult;
    }
    return $ea7cb8f7913dc99b$var$cachedRTLResult;
}
var $ea7cb8f7913dc99b$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $ea7cb8f7913dc99b$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $ea7cb8f7913dc99b$var$devWarningsOverscanCount = null;
var $ea7cb8f7913dc99b$var$devWarningsOverscanRowsColumnsCount = null;
var $ea7cb8f7913dc99b$var$devWarningsTagName = null;
function $ea7cb8f7913dc99b$var$createGridComponent(_ref2) {
    var _class, _temp;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _temp = _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $b9BiW.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $7jrgG.default)((0, $7jrgG.default)(_this)));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $7jrgG.default)((0, $7jrgG.default)(_this)),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $9W8FL.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $9W8FL.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $9W8FL.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($ea7cb8f7913dc99b$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $ea7cb8f7913dc99b$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $ea7cb8f7913dc99b$var$requestTimeout(_this._resetIsScrolling, $ea7cb8f7913dc99b$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $ea7cb8f7913dc99b$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $ea7cb8f7913dc99b$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($ea7cb8f7913dc99b$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $ea7cb8f7913dc99b$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $ea7cb8f7913dc99b$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $70fFQ.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $70fFQ.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $hSVl4.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $70fFQ.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        }; // Lazily create and cache item styles while scrolling,
        // So that pure component sCU will prevent re-renders.
        // We maintain this cache, and pass a style prop rather than index,
        // So that List can clear cached styles and force item re-render if necessary.
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $70fFQ.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _temp;
}
var $ea7cb8f7913dc99b$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $ea7cb8f7913dc99b$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $ea7cb8f7913dc99b$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $ea7cb8f7913dc99b$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $ea7cb8f7913dc99b$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $ea7cb8f7913dc99b$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $ea7cb8f7913dc99b$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $ea7cb8f7913dc99b$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $ea7cb8f7913dc99b$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $ea7cb8f7913dc99b$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $ea7cb8f7913dc99b$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $ea7cb8f7913dc99b$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $ea7cb8f7913dc99b$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $ea7cb8f7913dc99b$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $ea7cb8f7913dc99b$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $ea7cb8f7913dc99b$var$getEstimatedTotalWidth(props, instanceProps) : $ea7cb8f7913dc99b$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $ea7cb8f7913dc99b$export$32c206c84102e73c = /*#__PURE__*/ $ea7cb8f7913dc99b$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $ea7cb8f7913dc99b$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $ea7cb8f7913dc99b$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $ea7cb8f7913dc99b$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $ea7cb8f7913dc99b$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $ea7cb8f7913dc99b$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $ea7cb8f7913dc99b$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $ea7cb8f7913dc99b$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $ea7cb8f7913dc99b$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $ea7cb8f7913dc99b$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $ea7cb8f7913dc99b$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $ea7cb8f7913dc99b$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $ea7cb8f7913dc99b$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $ea7cb8f7913dc99b$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $ea7cb8f7913dc99b$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $ea7cb8f7913dc99b$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $ea7cb8f7913dc99b$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $ea7cb8f7913dc99b$var$devWarningsDirection = null;
var $ea7cb8f7913dc99b$var$devWarningsTagName$1 = null;
function $ea7cb8f7913dc99b$var$createListComponent(_ref) {
    var _class, _temp;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _temp = _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $b9BiW.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $7jrgG.default)((0, $7jrgG.default)(_this)));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $7jrgG.default)((0, $7jrgG.default)(_this)),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $9W8FL.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $9W8FL.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $9W8FL.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($ea7cb8f7913dc99b$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollLeft ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $ea7cb8f7913dc99b$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $ea7cb8f7913dc99b$var$requestTimeout(_this._resetIsScrolling, $ea7cb8f7913dc99b$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $ea7cb8f7913dc99b$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var itemCount = this.props.itemCount;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1));
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props2 = this.props, direction = _this$props2.direction, initialScrollOffset = _this$props2.initialScrollOffset, layout = _this$props2.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props3 = this.props, direction = _this$props3.direction, layout = _this$props3.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($ea7cb8f7913dc99b$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $ea7cb8f7913dc99b$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemCount = _this$props4.itemCount, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $ea7cb8f7913dc99b$var$defaultItemKey$1 : _this$props4$itemKey, layout = _this$props4.layout, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $70fFQ.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $70fFQ.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $hSVl4.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $70fFQ.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        }; // Lazily create and cache item styles while scrolling,
        // So that pure component sCU will prevent re-renders.
        // We maintain this cache, and pass a style prop rather than index,
        // So that List can clear cached styles and force item re-render if necessary.
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props5 = this.props, itemCount = _this$props5.itemCount, overscanCount = _this$props5.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $70fFQ.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _temp;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $ea7cb8f7913dc99b$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $ea7cb8f7913dc99b$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $ea7cb8f7913dc99b$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $ea7cb8f7913dc99b$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $ea7cb8f7913dc99b$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $ea7cb8f7913dc99b$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $ea7cb8f7913dc99b$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $ea7cb8f7913dc99b$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $ea7cb8f7913dc99b$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $ea7cb8f7913dc99b$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $ea7cb8f7913dc99b$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $ea7cb8f7913dc99b$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $ea7cb8f7913dc99b$export$d8ac3b6b20be856e = /*#__PURE__*/ $ea7cb8f7913dc99b$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $ea7cb8f7913dc99b$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $ea7cb8f7913dc99b$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $ea7cb8f7913dc99b$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $ea7cb8f7913dc99b$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $ea7cb8f7913dc99b$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $ea7cb8f7913dc99b$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $ea7cb8f7913dc99b$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $ea7cb8f7913dc99b$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $ea7cb8f7913dc99b$export$f331158cccad7361 = /*#__PURE__*/ $ea7cb8f7913dc99b$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $ea7cb8f7913dc99b$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $ea7cb8f7913dc99b$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $ea7cb8f7913dc99b$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $ea7cb8f7913dc99b$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $8EuCQ.default)(prevProps, [
        "style"
    ]);
    var nextStyle = nextProps.style, nextRest = (0, $8EuCQ.default)(nextProps, [
        "style"
    ]);
    return !$ea7cb8f7913dc99b$var$shallowDiffers(prevStyle, nextStyle) && !$ea7cb8f7913dc99b$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $ea7cb8f7913dc99b$export$aa365c903ed149ff(nextProps, nextState) {
    return !$ea7cb8f7913dc99b$export$b141efd0b0fb9174(this.props, nextProps) || $ea7cb8f7913dc99b$var$shallowDiffers(this.state, nextState);
}

});
parcelRegister("hSVl4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d053f51cfcd6684d$export$2e2bcd8739ae039; });
function $d053f51cfcd6684d$export$2e2bcd8739ae039() {
    $d053f51cfcd6684d$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d053f51cfcd6684d$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("b9BiW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81ed78d976e3cd75$export$2e2bcd8739ae039; });
function $81ed78d976e3cd75$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

});

parcelRegister("7jrgG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $552f759ae97c89c8$export$2e2bcd8739ae039; });
function $552f759ae97c89c8$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("9W8FL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73c04205c5167ef6$export$2e2bcd8739ae039; });
function $73c04205c5167ef6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $73c04205c5167ef6$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $73c04205c5167ef6$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $73c04205c5167ef6$export$2e2bcd8739ae039 = $73c04205c5167ef6$var$memoizeOne;

});

parcelRegister("8EuCQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64c9d0c4716c3208$export$2e2bcd8739ae039; });
function $64c9d0c4716c3208$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("bCnFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87559ac37e16716e$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/ function $87559ac37e16716e$var$createDetectElementResize(nonce) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof window !== "undefined") _window = window;
    else if (typeof self !== "undefined") _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof document !== "undefined" && document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + "px";
            expandChild.style.height = expand.offsetHeight + 1 + "px";
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = "", animationstartevent = "animationstart", domPrefixes = "Webkit Moz O ms".split(" "), startEvents = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), pfx = "";
        var elm = document.createElement("fakeelement");
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = "-" + pfx.toLowerCase() + "-";
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = "resizeanim";
        var animationKeyframes = "@" + keyframeprefix + "keyframes " + animationName + " { from { opacity: 0; } to { opacity: 0; } } ";
        var animationStyle = keyframeprefix + "animation: 1ms " + animationName + "; ";
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById("detectElementResize")) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : "") + ".resize-triggers { " + (animationStyle ? animationStyle : "") + "visibility: hidden; opacity: 0; } " + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName("head")[0], style = doc.createElement("style");
            style.id = "detectElementResize";
            style.type = "text/css";
            if (nonce != null) style.setAttribute("nonce", nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent("onresize", fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == "static") element.style.position = "relative";
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement("div")).className = "resize-triggers";
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener("scroll", scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent("onresize", fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener("scroll", scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}
var $87559ac37e16716e$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $87559ac37e16716e$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $87559ac37e16716e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $87559ac37e16716e$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $87559ac37e16716e$var$possibleConstructorReturn = function(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
};
var $87559ac37e16716e$var$AutoSizer = function(_React$PureComponent) {
    $87559ac37e16716e$var$inherits(AutoSizer, _React$PureComponent);
    function AutoSizer() {
        var _ref;
        var _temp, _this, _ret;
        $87559ac37e16716e$var$classCallCheck(this, AutoSizer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $87559ac37e16716e$var$possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        }, _this._onResize = function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var _height = _this._parentNode.offsetHeight || 0;
                var _width = _this._parentNode.offsetWidth || 0;
                var _style = window.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(_style.paddingRight, 10) || 0;
                var paddingTop = parseInt(_style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
                var newHeight = _height - paddingTop - paddingBottom;
                var newWidth = _width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: _height - paddingTop - paddingBottom,
                        width: _width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: _height,
                        width: _width
                    });
                }
            }
        }, _this._setRef = function(autoSizer) {
            _this._autoSizer = autoSizer;
        }, _temp), $87559ac37e16716e$var$possibleConstructorReturn(_this, _ret);
    }
    $87559ac37e16716e$var$createClass(AutoSizer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = $87559ac37e16716e$var$createDetectElementResize(nonce);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, className = _props.className, disableHeight = _props.disableHeight, disableWidth = _props.disableWidth, style = _props.style;
                var _state = this.state, height = _state.height, width = _state.width;
                // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle = {
                    overflow: "visible"
                };
                var childParams = {};
                // Avoid rendering children before the initial measurements have been collected.
                // At best this would just be wasting cycles.
                var bailoutOnChildren = false;
                if (!disableHeight) {
                    if (height === 0) bailoutOnChildren = true;
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    if (width === 0) bailoutOnChildren = true;
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                return (0, $70fFQ.createElement)("div", {
                    className: className,
                    ref: this._setRef,
                    style: $87559ac37e16716e$var$_extends({}, outerStyle, style)
                }, !bailoutOnChildren && children(childParams));
            }
        }
    ]);
    return AutoSizer;
}((0, $70fFQ.PureComponent));
$87559ac37e16716e$var$AutoSizer.defaultProps = {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
};
var $87559ac37e16716e$export$2e2bcd8739ae039 = $87559ac37e16716e$var$AutoSizer;

});

parcelRegister("8LlRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6613ace02ec85b68$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
function $6613ace02ec85b68$var$isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $6613ace02ec85b68$var$isRangeVisible(_ref) {
    var lastRenderedStartIndex = _ref.lastRenderedStartIndex, lastRenderedStopIndex = _ref.lastRenderedStopIndex, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function $6613ace02ec85b68$var$scanForUnloadedRanges(_ref) {
    var isItemLoaded = _ref.isItemLoaded, itemCount = _ref.itemCount, minimumBatchSize = _ref.minimumBatchSize, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    var unloadedRanges = [];
    var rangeStartIndex = null;
    var rangeStopIndex = null;
    for(var _index = startIndex; _index <= stopIndex; _index++){
        var loaded = isItemLoaded(_index);
        if (!loaded) {
            rangeStopIndex = _index;
            if (rangeStartIndex === null) rangeStartIndex = _index;
        } else if (rangeStopIndex !== null) {
            unloadedRanges.push([
                rangeStartIndex,
                rangeStopIndex
            ]);
            rangeStartIndex = rangeStopIndex = null;
        }
    }
    // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
    // Scan forward to try filling our :minimumBatchSize.
    if (rangeStopIndex !== null) {
        var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), itemCount - 1);
        for(var _index2 = rangeStopIndex + 1; _index2 <= potentialStopIndex; _index2++){
            if (!isItemLoaded(_index2)) rangeStopIndex = _index2;
            else break;
        }
        unloadedRanges.push([
            rangeStartIndex,
            rangeStopIndex
        ]);
    }
    // Check to see if our first range ended prematurely.
    // In this case we should scan backwards to try filling our :minimumBatchSize.
    if (unloadedRanges.length) {
        var firstRange = unloadedRanges[0];
        while(firstRange[1] - firstRange[0] + 1 < minimumBatchSize && firstRange[0] > 0){
            var _index3 = firstRange[0] - 1;
            if (!isItemLoaded(_index3)) firstRange[0] = _index3;
            else break;
        }
    }
    return unloadedRanges;
}
var $6613ace02ec85b68$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $6613ace02ec85b68$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $6613ace02ec85b68$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $6613ace02ec85b68$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $6613ace02ec85b68$var$slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $6613ace02ec85b68$var$InfiniteLoader = function(_PureComponent) {
    $6613ace02ec85b68$var$inherits(InfiniteLoader, _PureComponent);
    function InfiniteLoader() {
        var _ref;
        var _temp, _this, _ret;
        $6613ace02ec85b68$var$classCallCheck(this, InfiniteLoader);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $6613ace02ec85b68$var$possibleConstructorReturn(this, (_ref = InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._lastRenderedStartIndex = -1, _this._lastRenderedStopIndex = -1, _this._memoizedUnloadedRanges = [], _this._onItemsRendered = function(_ref2) {
            var visibleStartIndex = _ref2.visibleStartIndex, visibleStopIndex = _ref2.visibleStopIndex;
            _this._lastRenderedStartIndex = visibleStartIndex;
            _this._lastRenderedStopIndex = visibleStopIndex;
            _this._ensureRowsLoaded(visibleStartIndex, visibleStopIndex);
        }, _this._setRef = function(listRef) {
            _this._listRef = listRef;
        }, _temp), $6613ace02ec85b68$var$possibleConstructorReturn(_this, _ret);
    }
    $6613ace02ec85b68$var$createClass(InfiniteLoader, [
        {
            key: "resetloadMoreItemsCache",
            value: function resetloadMoreItemsCache() {
                var autoReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this._memoizedUnloadedRanges = [];
                if (autoReload) this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {}
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    onItemsRendered: this._onItemsRendered,
                    ref: this._setRef
                });
            }
        },
        {
            key: "_ensureRowsLoaded",
            value: function _ensureRowsLoaded(startIndex, stopIndex) {
                var _props = this.props, isItemLoaded = _props.isItemLoaded, itemCount = _props.itemCount, _props$minimumBatchSi = _props.minimumBatchSize, minimumBatchSize = _props$minimumBatchSi === undefined ? 10 : _props$minimumBatchSi, _props$threshold = _props.threshold, threshold = _props$threshold === undefined ? 15 : _props$threshold;
                var unloadedRanges = $6613ace02ec85b68$var$scanForUnloadedRanges({
                    isItemLoaded: isItemLoaded,
                    itemCount: itemCount,
                    minimumBatchSize: minimumBatchSize,
                    startIndex: Math.max(0, startIndex - threshold),
                    stopIndex: Math.min(itemCount - 1, stopIndex + threshold)
                });
                // Avoid calling load-rows unless range has changed.
                // This shouldn't be strictly necsesary, but is maybe nice to do.
                if (this._memoizedUnloadedRanges.length !== unloadedRanges.length || this._memoizedUnloadedRanges.some(function(_ref3, index) {
                    var _ref4 = $6613ace02ec85b68$var$slicedToArray(_ref3, 2), startIndex = _ref4[0], stopIndex = _ref4[1];
                    return unloadedRanges[index][0] !== startIndex || unloadedRanges[index][1] !== stopIndex;
                })) {
                    this._memoizedUnloadedRanges = unloadedRanges;
                    this._loadUnloadedRanges(unloadedRanges);
                }
            }
        },
        {
            key: "_loadUnloadedRanges",
            value: function _loadUnloadedRanges(unloadedRanges) {
                var _this2 = this;
                // loadMoreRows was renamed to loadMoreItems in v1.0.3; will be removed in v2.0
                var loadMoreItems = this.props.loadMoreItems || this.props.loadMoreRows;
                unloadedRanges.forEach(function(_ref5) {
                    var _ref6 = $6613ace02ec85b68$var$slicedToArray(_ref5, 2), startIndex = _ref6[0], stopIndex = _ref6[1];
                    var promise = loadMoreItems(startIndex, stopIndex);
                    if (promise != null) promise.then(function() {
                        // Refresh the visible rows if any of them have just been loaded.
                        // Otherwise they will remain in their unloaded visual state.
                        if ($6613ace02ec85b68$var$isRangeVisible({
                            lastRenderedStartIndex: _this2._lastRenderedStartIndex,
                            lastRenderedStopIndex: _this2._lastRenderedStopIndex,
                            startIndex: startIndex,
                            stopIndex: stopIndex
                        })) {
                            // Handle an unmount while promises are still in flight.
                            if (_this2._listRef == null) return;
                            // Resize cached row sizes for VariableSizeList,
                            // otherwise just re-render the list.
                            if (typeof _this2._listRef.resetAfterIndex === "function") _this2._listRef.resetAfterIndex(startIndex, true);
                            else {
                                // HACK reset temporarily cached item styles to force PureComponent to re-render.
                                // This is pretty gross, but I'm okay with it for now.
                                // Don't judge me.
                                if (typeof _this2._listRef._getItemStyleCache === "function") _this2._listRef._getItemStyleCache(-1);
                                _this2._listRef.forceUpdate();
                            }
                        }
                    });
                });
            }
        }
    ]);
    return InfiniteLoader;
}((0, $70fFQ.PureComponent));
var $6613ace02ec85b68$export$2e2bcd8739ae039 = $6613ace02ec85b68$var$InfiniteLoader;

});


parcelRegister("7ZYVJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d2d7e5df41361ca$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $3fLZ2 = parcelRequire("3fLZ2");
var $hsXqC = parcelRequire("hsXqC");
var $9Vd8j = parcelRequire("9Vd8j");
var $fuVrF = parcelRequire("fuVrF");
var $8VJ2N = parcelRequire("8VJ2N");
var $eS4JX = parcelRequire("eS4JX");
var $dcOT1 = parcelRequire("dcOT1");
var $9Xosf = parcelRequire("9Xosf");
var $2Z3Gv = parcelRequire("2Z3Gv");
var $iHyg3 = parcelRequire("iHyg3");
var $27ZKj = parcelRequire("27ZKj");

var $2Qzvd = parcelRequire("2Qzvd");

var $dih0O = parcelRequire("dih0O");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $fuiMG = parcelRequire("fuiMG");

var $iWaGk = parcelRequire("iWaGk");

var $5tCXN = parcelRequire("5tCXN");

var $fZAmD = parcelRequire("fZAmD");

// variant = ['teaser, 'compact']
const $5d2d7e5df41361ca$var$BuildingCard = (_param)=>{
    var { to: to = null, disableGrade: disableGrade = false, projectId: projectId, building: building, variant: variant, onClick: onClick = ()=>{} } = _param, rest = (0, $bmkEq._)(_param, [
        "to",
        "disableGrade",
        "projectId",
        "building",
        "variant",
        "onClick"
    ]);
    const history = (0, $dih0O.useHistory)();
    const { name: name, address: address, financials: financials, id: id, property_type: property_type, recommendations: recommendations, der_score: der_score, der_accuracy: der_accuracy, distance: distance, building_name: building_name } = building;
    const distanceInMiles = (0, $fuiMG.metersToMiles)(distance * 1000);
    const title = distance ? /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            building_name || name || address,
            " ",
            /*#__PURE__*/ (0, $4x3bm.jsxs)("span", {
                style: {
                    opacity: 0.8
                },
                children: [
                    distanceInMiles,
                    "mi."
                ]
            })
        ]
    }) : building_name || name || address;
    const { buildingStore: buildingStore, uiStore: uiStore, mapStore: mapStore, userStore: userStore, projectDetailStore: projectDetailStore } = (0, $iWaGk.default)();
    const { controlPanelState: controlPanelState } = uiStore;
    const showGrade = !disableGrade && der_score && userStore.isAdmin && variant === undefined && controlPanelState !== "picker";
    const gradeColor = "rgb(76, 175, 80)";
    const isPicked = buildingStore.pickedResults.has(id);
    const financialData = building.financials && variant === "teaser" ? financials.slice(0, 4) : [
        ...new Array(4)
    ].map(()=>{
        return {
            value: 1,
            isLoading: true
        };
    });
    const className = history.location.pathname.includes(`/${id}`) ? `building-card building-card-active` : `building-card`;
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eS4JX.default), (0, $edHbI._)((0, $2QP2i._)({
                className: className,
                button: true,
                // component={NavLink}
                ContainerComponent: "div",
                onClick: ()=>{
                    // TODO Should move this to UiStore
                    projectDetailStore.setVariant("large");
                    mapStore.setPopup(null);
                    history.push(to || `/search/${building.id}`);
                    onClick(event);
                },
                onMouseEnter: ()=>{
                    const url = window.location.href;
                    const end = url.substring(url.length - 6);
                    if (!variant && end === "search" || end === "earch/") mapStore.setPopup(building);
                },
                onMouseLeave: ()=>{
                    mapStore.setPopup(null);
                }
            }, rest), {
                children: [
                    showGrade && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dcOT1.default), {
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hsXqC.default), {
                            classes: {
                                badge: "building-card-avatar-badge"
                            },
                            overlap: "circular",
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            badgeContent: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                className: "building-card-avatar-badge-text",
                                variant: "caption",
                                children: [
                                    der_accuracy,
                                    "%"
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3fLZ2.default), {
                                style: {
                                    border: `1px solid ${gradeColor}`,
                                    transition: "all 0.1s ease-out",
                                    transitionProperty: "background, color, border-color",
                                    color: gradeColor,
                                    backgroundColor: "transparent"
                                },
                                className: "search-card-avatar",
                                children: der_score
                            })
                        })
                    }),
                    !variant && controlPanelState === "picker" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Xosf.default), {
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Vd8j.default), {
                            edge: "start",
                            checked: isPicked,
                            tabIndex: -1,
                            disableRipple: true,
                            onClick: (event1)=>{
                                if (controlPanelState === "picker") {
                                    event1.preventDefault();
                                    event1.stopPropagation();
                                    if (!isPicked) buildingStore.pickResult(id);
                                    else buildingStore.unPickResult(id);
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                        className: "building-card-content",
                        disableTypography: true,
                        inset: variant === "compact",
                        primary: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
                            container: true,
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                    item: true,
                                    xs: 12,
                                    lg: true,
                                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                        className: "building-card-primary",
                                        children: [
                                            (recommendations || property_type) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fZAmD.default), {
                                                recommendations: recommendations,
                                                propertyType: property_type
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                color: variant === "compact" ? "textSecondary" : "textPrimary",
                                                variant: variant === "compact" ? "body2" : "body1",
                                                noWrap: variant !== "teaser",
                                                children: building_name || title
                                            })
                                        ]
                                    })
                                }),
                                variant === "teaser" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                    item: true,
                                    xs: 12,
                                    lg: 5,
                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                        container: true,
                                        spacing: 0,
                                        className: "data-grid compact",
                                        children: financialData.map((item)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $5tCXN.default), (0, $edHbI._)((0, $2QP2i._)({}, item), {
                                                xs: 6,
                                                sm: 3,
                                                md: 6
                                            }), item.label))
                                    })
                                })
                            ]
                        })
                    }),
                    variant === "teaser" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Z3Gv.default), {
                        className: "building-card-icon",
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Qzvd.default), {
                            size: "large"
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fuVrF.default), {
                light: true,
                variant: "inset"
            })
        ]
    });
};
var $5d2d7e5df41361ca$export$2e2bcd8739ae039 = (0, $87gt0.observer)($5d2d7e5df41361ca$var$BuildingCard);

});
parcelRegister("dcOT1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99d3de5a25b7c335$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $jgeht = parcelRequire("jgeht");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $aggE6 = parcelRequire("aggE6");

var $4x3bm = parcelRequire("4x3bm");
const $99d3de5a25b7c335$var$_excluded = [
    "className"
];
const $99d3de5a25b7c335$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $aggE6.getListItemAvatarUtilityClass), classes);
};
const $99d3de5a25b7c335$var$ListItemAvatarRoot = (0, $71Pr4.default)("div", {
    name: "MuiListItemAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        minWidth: 56,
        flexShrink: 0
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $99d3de5a25b7c335$var$ListItemAvatar = /*#__PURE__*/ $70fFQ.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiListItemAvatar"
    });
    const { className: className } = props, other = (0, $79yYo.default)(props, $99d3de5a25b7c335$var$_excluded);
    const context = $70fFQ.useContext((0, $jgeht.default));
    const ownerState = (0, $20MOv.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $99d3de5a25b7c335$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($99d3de5a25b7c335$var$ListItemAvatarRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $99d3de5a25b7c335$export$2e2bcd8739ae039 = $99d3de5a25b7c335$var$ListItemAvatar;

});
parcelRegister("aggE6", function(module, exports) {

$parcel$export(module.exports, "getListItemAvatarUtilityClass", function () { return $77884f84747495b3$export$e4f04f80f2ce3fc0; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $77884f84747495b3$export$e4f04f80f2ce3fc0(slot) {
    return (0, $dtsUs.default)("MuiListItemAvatar", slot);
}
const $77884f84747495b3$var$listItemAvatarClasses = (0, $jLqVN.default)("MuiListItemAvatar", [
    "root",
    "alignItemsFlexStart"
]);
var $77884f84747495b3$export$2e2bcd8739ae039 = $77884f84747495b3$var$listItemAvatarClasses;

});


parcelRegister("9Xosf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73fc97f166b5433b$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $1uWNS = parcelRequire("1uWNS");

var $jgeht = parcelRequire("jgeht");

var $4x3bm = parcelRequire("4x3bm");
const $73fc97f166b5433b$var$_excluded = [
    "className"
];
const $73fc97f166b5433b$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $1uWNS.getListItemIconUtilityClass), classes);
};
const $73fc97f166b5433b$var$ListItemIconRoot = (0, $71Pr4.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        minWidth: 56,
        color: theme.palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $73fc97f166b5433b$var$ListItemIcon = /*#__PURE__*/ $70fFQ.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $79yYo.default)(props, $73fc97f166b5433b$var$_excluded);
    const context = $70fFQ.useContext((0, $jgeht.default));
    const ownerState = (0, $20MOv.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $73fc97f166b5433b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($73fc97f166b5433b$var$ListItemIconRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $73fc97f166b5433b$export$2e2bcd8739ae039 = $73fc97f166b5433b$var$ListItemIcon;

});

parcelRegister("2Qzvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $212bfa29d3b6ce5d$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $212bfa29d3b6ce5d$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");

});

parcelRegister("fZAmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba48c2ab08f17160$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $27ZKj = parcelRequire("27ZKj");

var $8me0n = parcelRequire("8me0n");
function $ba48c2ab08f17160$export$2e2bcd8739ae039({ recommendations: recommendations, propertyType: propertyType }) {
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
        className: "building-card-meta",
        children: [
            recommendations && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8me0n.default), (0, $2QP2i._)({}, recommendations)),
            propertyType && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                sx: {
                    lineHeight: "initial"
                },
                color: "textSecondary",
                variant: "overline",
                children: propertyType
            })
        ]
    });
}

});


parcelRegister("icIXl", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("31nVF"))((parcelRequire("c1lIA")).resolve("dzhn7")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("haWsD")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("5vw2V"))
]).then(()=>parcelRequire("5Ot3e"));

});
parcelRegister("31nVF", function(module, exports) {
"use strict";

var $3CWN4 = parcelRequire("3CWN4");
module.exports = $3CWN4(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("3CWN4", function(module, exports) {
"use strict";
var $2a4286460d86daf1$var$cachedBundles = {};
var $2a4286460d86daf1$var$cachedPreloads = {};
var $2a4286460d86daf1$var$cachedPrefetches = {};
function $2a4286460d86daf1$var$getCache(type) {
    switch(type){
        case "preload":
            return $2a4286460d86daf1$var$cachedPreloads;
        case "prefetch":
            return $2a4286460d86daf1$var$cachedPrefetches;
        default:
            return $2a4286460d86daf1$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $2a4286460d86daf1$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hPc3f", function(module, exports) {
"use strict";

var $3CWN4 = parcelRequire("3CWN4");
module.exports = $3CWN4(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});


parcelRegister("iuSYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d775ac85fb64421c$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $hBUX7 = parcelRequire("hBUX7");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $3cESc = parcelRequire("3cESc");

var $dWKKV = parcelRequire("dWKKV");

var $13NkT = parcelRequire("13NkT");

var $1IOh3 = parcelRequire("1IOh3");

var $697xl = parcelRequire("697xl");

var $7adKh = parcelRequire("7adKh");

var $69ubn = parcelRequire("69ubn");

var $9OExZ = parcelRequire("9OExZ");

var $4x3bm = parcelRequire("4x3bm");
const $d775ac85fb64421c$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d775ac85fb64421c$var$variantComponent = {
    standard: (0, $3cESc.default),
    filled: (0, $dWKKV.default),
    outlined: (0, $13NkT.default)
};
const $d775ac85fb64421c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $9OExZ.getTextFieldUtilityClass), classes);
};
const $d775ac85fb64421c$var$TextFieldRoot = (0, $71Pr4.default)((0, $697xl.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d775ac85fb64421c$var$TextField = /*#__PURE__*/ $70fFQ.forwardRef(function TextField(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $79yYo.default)(props, $d775ac85fb64421c$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d775ac85fb64421c$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $hBUX7.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d775ac85fb64421c$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $4x3bm.jsx)(InputComponent, (0, $20MOv.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($d775ac85fb64421c$var$TextFieldRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), (0, $20MOv.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $69ubn.default), (0, $20MOv.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7adKh.default), (0, $20MOv.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d775ac85fb64421c$export$2e2bcd8739ae039 = $d775ac85fb64421c$var$TextField;

});
parcelRegister("hBUX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd2211fb07bc1658$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
let $cd2211fb07bc1658$var$globalId = 0;
function $cd2211fb07bc1658$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $70fFQ.useState(idOverride);
    const id = idOverride || defaultId;
    $70fFQ.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $cd2211fb07bc1658$var$globalId += 1;
            setDefaultId(`mui-${$cd2211fb07bc1658$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $cd2211fb07bc1658$var$maybeReactUseId = $70fFQ.useId;
function $cd2211fb07bc1658$export$2e2bcd8739ae039(idOverride) {
    if ($cd2211fb07bc1658$var$maybeReactUseId !== undefined) {
        const reactId = $cd2211fb07bc1658$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    } // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $cd2211fb07bc1658$var$useGlobalId(idOverride);
}

});

parcelRegister("9OExZ", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $01d822018db59f23$export$c1bdcbaf0596aeda; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $01d822018db59f23$export$c1bdcbaf0596aeda(slot) {
    return (0, $dtsUs.default)("MuiTextField", slot);
}
const $01d822018db59f23$var$textFieldClasses = (0, $jLqVN.default)("MuiTextField", [
    "root"
]);
var $01d822018db59f23$export$2e2bcd8739ae039 = $01d822018db59f23$var$textFieldClasses;

});


parcelRegister("cvbk1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91a1299c920ecea4$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $hBUX7 = parcelRequire("hBUX7");

var $aAAPW = parcelRequire("aAAPW");

var $7aifL = parcelRequire("7aifL");

var $kcSl7 = parcelRequire("kcSl7");

var $1mImZ = parcelRequire("1mImZ");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $cE12W = parcelRequire("cE12W");

var $4gGwm = parcelRequire("4gGwm");

var $bfhCA = parcelRequire("bfhCA");

var $2mnfJ = parcelRequire("2mnfJ");

var $4x3bm = parcelRequire("4x3bm");
const $91a1299c920ecea4$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $91a1299c920ecea4$var$DialogBackdrop = (0, $71Pr4.default)((0, $bfhCA.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $91a1299c920ecea4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $aAAPW.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $aAAPW.default)(scroll)}`,
            `paperWidth${(0, $aAAPW.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $cE12W.getDialogUtilityClass), classes);
};
const $91a1299c920ecea4$var$DialogRoot = (0, $71Pr4.default)((0, $7aifL.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $91a1299c920ecea4$var$DialogContainer = (0, $71Pr4.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $aAAPW.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $91a1299c920ecea4$var$DialogPaper = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $aAAPW.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $aAAPW.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
        [`&.${(0, $cE12W.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $cE12W.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $cE12W.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $91a1299c920ecea4$var$Dialog = /*#__PURE__*/ $70fFQ.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $2mnfJ.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $1mImZ.default), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $kcSl7.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $79yYo.default)(props, $91a1299c920ecea4$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $91a1299c920ecea4$var$useUtilityClasses(ownerState);
    const backdropClick = $70fFQ.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $hBUX7.default)(ariaLabelledbyProp);
    const dialogContextValue = $70fFQ.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($91a1299c920ecea4$var$DialogRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        BackdropProps: (0, $20MOv.default)({
            transitionDuration: transitionDuration,
            as: BackdropComponent
        }, BackdropProps),
        closeAfterTransition: true,
        BackdropComponent: $91a1299c920ecea4$var$DialogBackdrop,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $4x3bm.jsx)($91a1299c920ecea4$var$DialogContainer, {
                className: (0, $gjktY.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $4x3bm.jsx)($91a1299c920ecea4$var$DialogPaper, (0, $20MOv.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $gjktY.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4gGwm.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $91a1299c920ecea4$export$2e2bcd8739ae039 = $91a1299c920ecea4$var$Dialog;

});
parcelRegister("cE12W", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", function () { return $934a08483e0c8921$export$2177af0aa15c34c2; });
$parcel$export(module.exports, "default", function () { return $934a08483e0c8921$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $934a08483e0c8921$export$2177af0aa15c34c2(slot) {
    return (0, $dtsUs.default)("MuiDialog", slot);
}
const $934a08483e0c8921$var$dialogClasses = (0, $jLqVN.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $934a08483e0c8921$export$2e2bcd8739ae039 = $934a08483e0c8921$var$dialogClasses;

});

parcelRegister("4gGwm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31b9a3d18ff632e8$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
const $31b9a3d18ff632e8$var$DialogContext = /*#__PURE__*/ (0, $70fFQ.createContext)({});
var $31b9a3d18ff632e8$export$2e2bcd8739ae039 = $31b9a3d18ff632e8$var$DialogContext;

});


parcelRegister("daCoF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9969fe56a9f627b2$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $a5jRd = parcelRequire("a5jRd");

var $4x3bm = parcelRequire("4x3bm");
const $9969fe56a9f627b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $9969fe56a9f627b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $a5jRd.getDialogActionsUtilityClass), classes);
};
const $9969fe56a9f627b2$var$DialogActionsRoot = (0, $71Pr4.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $9969fe56a9f627b2$var$DialogActions = /*#__PURE__*/ $70fFQ.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $79yYo.default)(props, $9969fe56a9f627b2$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $9969fe56a9f627b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($9969fe56a9f627b2$var$DialogActionsRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $9969fe56a9f627b2$export$2e2bcd8739ae039 = $9969fe56a9f627b2$var$DialogActions;

});
parcelRegister("a5jRd", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", function () { return $7579c6416ff9c27b$export$5e57a444791c63be; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $7579c6416ff9c27b$export$5e57a444791c63be(slot) {
    return (0, $dtsUs.default)("MuiDialogActions", slot);
}
const $7579c6416ff9c27b$var$dialogActionsClasses = (0, $jLqVN.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $7579c6416ff9c27b$export$2e2bcd8739ae039 = $7579c6416ff9c27b$var$dialogActionsClasses;

});


parcelRegister("3c7f6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25381c4a336468c8$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $giM2P = parcelRequire("giM2P");

var $bFyaS = parcelRequire("bFyaS");

var $4x3bm = parcelRequire("4x3bm");
const $25381c4a336468c8$var$_excluded = [
    "className",
    "dividers"
];
const $25381c4a336468c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $giM2P.getDialogContentUtilityClass), classes);
};
const $25381c4a336468c8$var$DialogContentRoot = (0, $71Pr4.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`
    } : {
        [`.${(0, $bFyaS.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const $25381c4a336468c8$var$DialogContent = /*#__PURE__*/ $70fFQ.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $79yYo.default)(props, $25381c4a336468c8$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        dividers: dividers
    });
    const classes = $25381c4a336468c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($25381c4a336468c8$var$DialogContentRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $25381c4a336468c8$export$2e2bcd8739ae039 = $25381c4a336468c8$var$DialogContent;

});
parcelRegister("giM2P", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", function () { return $bde39870654139e4$export$61b0ee1f05fb344e; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $bde39870654139e4$export$61b0ee1f05fb344e(slot) {
    return (0, $dtsUs.default)("MuiDialogContent", slot);
}
const $bde39870654139e4$var$dialogContentClasses = (0, $jLqVN.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $bde39870654139e4$export$2e2bcd8739ae039 = $bde39870654139e4$var$dialogContentClasses;

});

parcelRegister("bFyaS", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", function () { return $87ee08640fcfd4ac$export$f5d2ec7e4c47e088; });
$parcel$export(module.exports, "default", function () { return $87ee08640fcfd4ac$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $87ee08640fcfd4ac$export$f5d2ec7e4c47e088(slot) {
    return (0, $dtsUs.default)("MuiDialogTitle", slot);
}
const $87ee08640fcfd4ac$var$dialogTitleClasses = (0, $jLqVN.default)("MuiDialogTitle", [
    "root"
]);
var $87ee08640fcfd4ac$export$2e2bcd8739ae039 = $87ee08640fcfd4ac$var$dialogTitleClasses;

});


parcelRegister("2zy57", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1df9498a05cdfc3a$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $27ZKj = parcelRequire("27ZKj");

var $g1xRY = parcelRequire("g1xRY");

var $4x3bm = parcelRequire("4x3bm");
const $1df9498a05cdfc3a$var$_excluded = [
    "children"
];
const $1df9498a05cdfc3a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $8dWxZ.default)(slots, (0, $g1xRY.getDialogContentTextUtilityClass), classes);
    return (0, $20MOv.default)({}, classes, composedClasses);
};
const $1df9498a05cdfc3a$var$DialogContentTextRoot = (0, $71Pr4.default)((0, $27ZKj.default), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $1df9498a05cdfc3a$var$DialogContentText = /*#__PURE__*/ $70fFQ.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const ownerState = (0, $79yYo.default)(props, $1df9498a05cdfc3a$var$_excluded);
    const classes = $1df9498a05cdfc3a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($1df9498a05cdfc3a$var$DialogContentTextRoot, (0, $20MOv.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState
    }, props, {
        classes: classes
    }));
});
var $1df9498a05cdfc3a$export$2e2bcd8739ae039 = $1df9498a05cdfc3a$var$DialogContentText;

});
parcelRegister("g1xRY", function(module, exports) {

$parcel$export(module.exports, "getDialogContentTextUtilityClass", function () { return $baa7031b89ccd5ae$export$d9c6dc45f75b0e4f; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $baa7031b89ccd5ae$export$d9c6dc45f75b0e4f(slot) {
    return (0, $dtsUs.default)("MuiDialogContentText", slot);
}
const $baa7031b89ccd5ae$var$dialogContentTextClasses = (0, $jLqVN.default)("MuiDialogContentText", [
    "root"
]);
var $baa7031b89ccd5ae$export$2e2bcd8739ae039 = $baa7031b89ccd5ae$var$dialogContentTextClasses;

});


parcelRegister("e4z6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3ecace334123b17$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $27ZKj = parcelRequire("27ZKj");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $bFyaS = parcelRequire("bFyaS");

var $4gGwm = parcelRequire("4gGwm");

var $4x3bm = parcelRequire("4x3bm");
const $a3ecace334123b17$var$_excluded = [
    "className",
    "id"
];
const $a3ecace334123b17$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $bFyaS.getDialogTitleUtilityClass), classes);
};
const $a3ecace334123b17$var$DialogTitleRoot = (0, $71Pr4.default)((0, $27ZKj.default), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $a3ecace334123b17$var$DialogTitle = /*#__PURE__*/ $70fFQ.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $79yYo.default)(props, $a3ecace334123b17$var$_excluded);
    const ownerState = props;
    const classes = $a3ecace334123b17$var$useUtilityClasses(ownerState);
    const { titleId: id = idProp } = $70fFQ.useContext((0, $4gGwm.default));
    return /*#__PURE__*/ (0, $4x3bm.jsx)($a3ecace334123b17$var$DialogTitleRoot, (0, $20MOv.default)({
        component: "h2",
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: id
    }, other));
});
var $a3ecace334123b17$export$2e2bcd8739ae039 = $a3ecace334123b17$var$DialogTitle;

});

parcelRegister("o6Ww0", function(module, exports) {
"use strict";

var $kUwzY = parcelRequire("kUwzY");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDomTreeShapes = $0487a0b3156b866d$var$getDomTreeShapes;
module.exports.findNativeHandler = $0487a0b3156b866d$var$findNativeHandler;
module.exports.default = void 0;

var $0487a0b3156b866d$var$_extends2 = $kUwzY((parcelRequire("BvuYv")));

var $0487a0b3156b866d$var$_objectWithoutProperties2 = $kUwzY((parcelRequire("8masA")));

var $0487a0b3156b866d$var$_classCallCheck2 = $kUwzY((parcelRequire("6L4M1")));

var $0487a0b3156b866d$var$_createClass2 = $kUwzY((parcelRequire("hnSKw")));

var $0487a0b3156b866d$var$_possibleConstructorReturn2 = $kUwzY((parcelRequire("1cT1p")));

var $0487a0b3156b866d$var$_getPrototypeOf2 = $kUwzY((parcelRequire("44JRR")));

var $0487a0b3156b866d$var$_inherits2 = $kUwzY((parcelRequire("guNYK")));

var $0487a0b3156b866d$var$_react = $kUwzY((parcelRequire("70fFQ")));

var $0487a0b3156b866d$var$_propTypes = $kUwzY((parcelRequire("2Quny")));

var $0487a0b3156b866d$var$_warning = $kUwzY((parcelRequire("3a4dW")));

var $0487a0b3156b866d$var$_properties = $kUwzY((parcelRequire("5OrjC")));

var $0487a0b3156b866d$var$_on = $kUwzY((parcelRequire("l7fKm")));

var $0487a0b3156b866d$var$_off = $kUwzY((parcelRequire("5e0ma")));

var $i3GqJ = parcelRequire("i3GqJ");
function $0487a0b3156b866d$var$addEventListenerEnhanced(node, event, handler, options) {
    (0, $0487a0b3156b866d$var$_on.default)(node, event, handler, options);
    return {
        remove: function remove() {
            (0, $0487a0b3156b866d$var$_off.default)(node, event, handler, options);
        }
    };
}
var $0487a0b3156b866d$var$styles = {
    container: {
        direction: "ltr",
        display: "flex",
        willChange: "transform"
    },
    slide: {
        width: "100%",
        WebkitFlexShrink: 0,
        flexShrink: 0,
        overflow: "auto"
    }
};
var $0487a0b3156b866d$var$axisProperties = {
    root: {
        x: {
            overflowX: "hidden"
        },
        "x-reverse": {
            overflowX: "hidden"
        },
        y: {
            overflowY: "hidden"
        },
        "y-reverse": {
            overflowY: "hidden"
        }
    },
    flexDirection: {
        x: "row",
        "x-reverse": "row-reverse",
        y: "column",
        "y-reverse": "column-reverse"
    },
    transform: {
        x: function x(translate) {
            return "translate(".concat(-translate, "%, 0)");
        },
        "x-reverse": function xReverse(translate) {
            return "translate(".concat(translate, "%, 0)");
        },
        y: function y(translate) {
            return "translate(0, ".concat(-translate, "%)");
        },
        "y-reverse": function yReverse(translate) {
            return "translate(0, ".concat(translate, "%)");
        }
    },
    length: {
        x: "width",
        "x-reverse": "width",
        y: "height",
        "y-reverse": "height"
    },
    rotationMatrix: {
        x: {
            x: [
                1,
                0
            ],
            y: [
                0,
                1
            ]
        },
        "x-reverse": {
            x: [
                -1,
                0
            ],
            y: [
                0,
                1
            ]
        },
        y: {
            x: [
                0,
                1
            ],
            y: [
                1,
                0
            ]
        },
        "y-reverse": {
            x: [
                0,
                -1
            ],
            y: [
                1,
                0
            ]
        }
    },
    scrollPosition: {
        x: "scrollLeft",
        "x-reverse": "scrollLeft",
        y: "scrollTop",
        "y-reverse": "scrollTop"
    },
    scrollLength: {
        x: "scrollWidth",
        "x-reverse": "scrollWidth",
        y: "scrollHeight",
        "y-reverse": "scrollHeight"
    },
    clientLength: {
        x: "clientWidth",
        "x-reverse": "clientWidth",
        y: "clientHeight",
        "y-reverse": "clientHeight"
    }
};
function $0487a0b3156b866d$var$createTransition(property, options) {
    var duration = options.duration, easeFunction = options.easeFunction, delay = options.delay;
    return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
} // We are using a 2x2 rotation matrix.
function $0487a0b3156b866d$var$applyRotationMatrix(touch, axis) {
    var rotationMatrix = $0487a0b3156b866d$var$axisProperties.rotationMatrix[axis];
    return {
        pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
        pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
    };
}
function $0487a0b3156b866d$var$adaptMouse(event) {
    event.touches = [
        {
            pageX: event.pageX,
            pageY: event.pageY
        }
    ];
    return event;
}
function $0487a0b3156b866d$var$getDomTreeShapes(element, rootNode) {
    var domTreeShapes = [];
    while(element && element !== rootNode){
        // We reach a Swipeable View, no need to look higher in the dom tree.
        if (element.hasAttribute("data-swipeable")) break;
        var style = window.getComputedStyle(element);
        if (style.getPropertyValue("position") === "absolute" || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue("overflow-x") === "hidden") domTreeShapes = [];
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push({
            element: element,
            scrollWidth: element.scrollWidth,
            scrollHeight: element.scrollHeight,
            clientWidth: element.clientWidth,
            clientHeight: element.clientHeight,
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        });
        element = element.parentNode;
    }
    return domTreeShapes;
} // We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
var $0487a0b3156b866d$var$nodeWhoClaimedTheScroll = null;
function $0487a0b3156b866d$var$findNativeHandler(params) {
    var domTreeShapes = params.domTreeShapes, pageX = params.pageX, startX = params.startX, axis = params.axis;
    return domTreeShapes.some(function(shape) {
        // Determine if we are going backward or forward.
        var goingForward = pageX >= startX;
        if (axis === "x" || axis === "y") goingForward = !goingForward;
        var scrollPosition = shape[$0487a0b3156b866d$var$axisProperties.scrollPosition[axis]];
        var areNotAtStart = scrollPosition > 0;
        var areNotAtEnd = scrollPosition + shape[$0487a0b3156b866d$var$axisProperties.clientLength[axis]] < shape[$0487a0b3156b866d$var$axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
            $0487a0b3156b866d$var$nodeWhoClaimedTheScroll = shape.element;
            return true;
        }
        return false;
    });
}
var $0487a0b3156b866d$var$SwipeableViews = /*#__PURE__*/ function(_React$Component) {
    (0, $0487a0b3156b866d$var$_inherits2.default)(SwipeableViews, _React$Component);
    function SwipeableViews(props) {
        var _this;
        (0, $0487a0b3156b866d$var$_classCallCheck2.default)(this, SwipeableViews);
        _this = (0, $0487a0b3156b866d$var$_possibleConstructorReturn2.default)(this, (0, $0487a0b3156b866d$var$_getPrototypeOf2.default)(SwipeableViews).call(this, props));
        _this.rootNode = null;
        _this.containerNode = null;
        _this.ignoreNextScrollEvents = false;
        _this.viewLength = 0;
        _this.startX = 0;
        _this.lastX = 0;
        _this.vx = 0;
        _this.startY = 0;
        _this.isSwiping = undefined;
        _this.started = false;
        _this.startIndex = 0;
        _this.transitionListener = null;
        _this.touchMoveListener = null;
        _this.activeSlide = null;
        _this.indexCurrent = null;
        _this.firstRenderTimeout = null;
        _this.setRootNode = function(node) {
            _this.rootNode = node;
        };
        _this.setContainerNode = function(node) {
            _this.containerNode = node;
        };
        _this.setActiveSlide = function(node) {
            _this.activeSlide = node;
            _this.updateHeight();
        };
        _this.handleSwipeStart = function(event) {
            var axis = _this.props.axis;
            var touch = $0487a0b3156b866d$var$applyRotationMatrix(event.touches[0], axis);
            _this.viewLength = _this.rootNode.getBoundingClientRect()[$0487a0b3156b866d$var$axisProperties.length[axis]];
            _this.startX = touch.pageX;
            _this.lastX = touch.pageX;
            _this.vx = 0;
            _this.startY = touch.pageY;
            _this.isSwiping = undefined;
            _this.started = true;
            var computedStyle = window.getComputedStyle(_this.containerNode);
            var transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
            if (transform && transform !== "none") {
                var transformValues = transform.split("(")[1].split(")")[0].split(",");
                var rootStyle = window.getComputedStyle(_this.rootNode);
                var tranformNormalized = $0487a0b3156b866d$var$applyRotationMatrix({
                    pageX: parseInt(transformValues[4], 10),
                    pageY: parseInt(transformValues[5], 10)
                }, axis);
                _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
            }
        };
        _this.handleSwipeMove = function(event) {
            // The touch start event can be cancel.
            // Makes sure we set a starting point.
            if (!_this.started) {
                _this.handleTouchStart(event);
                return;
            } // We are not supposed to hanlde this touch move.
            if ($0487a0b3156b866d$var$nodeWhoClaimedTheScroll !== null && $0487a0b3156b866d$var$nodeWhoClaimedTheScroll !== _this.rootNode) return;
            var _this$props = _this.props, axis = _this$props.axis, children = _this$props.children, ignoreNativeScroll = _this$props.ignoreNativeScroll, onSwitching = _this$props.onSwitching, resistance = _this$props.resistance;
            var touch = $0487a0b3156b866d$var$applyRotationMatrix(event.touches[0], axis); // We don't know yet.
            if (_this.isSwiping === undefined) {
                var dx = Math.abs(touch.pageX - _this.startX);
                var dy = Math.abs(touch.pageY - _this.startY);
                var isSwiping = dx > dy && dx > $i3GqJ.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.
                if (!resistance && (axis === "y" || axis === "y-reverse") && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === $0487a0b3156b866d$var$_react.default.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
                    _this.isSwiping = false;
                    return;
                } // We are likely to be swiping, let's prevent the scroll event.
                if (dx > dy) event.preventDefault();
                if (isSwiping === true || dy > $i3GqJ.constant.UNCERTAINTY_THRESHOLD) {
                    _this.isSwiping = isSwiping;
                    _this.startX = touch.pageX; // Shift the starting point.
                    return; // Let's wait the next touch event to move something.
                }
            }
            if (_this.isSwiping !== true) return;
             // We are swiping, let's prevent the scroll event.
            event.preventDefault(); // Low Pass filter.
            _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
            _this.lastX = touch.pageX;
            var _computeIndex = (0, $i3GqJ.computeIndex)({
                children: children,
                resistance: resistance,
                pageX: touch.pageX,
                startIndex: _this.startIndex,
                startX: _this.startX,
                viewLength: _this.viewLength
            }), index = _computeIndex.index, startX = _computeIndex.startX; // Add support for native scroll elements.
            if ($0487a0b3156b866d$var$nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
                var domTreeShapes = $0487a0b3156b866d$var$getDomTreeShapes(event.target, _this.rootNode);
                var hasFoundNativeHandler = $0487a0b3156b866d$var$findNativeHandler({
                    domTreeShapes: domTreeShapes,
                    startX: _this.startX,
                    pageX: touch.pageX,
                    axis: axis
                }); // We abort the touch move handler.
                if (hasFoundNativeHandler) return;
            } // We are moving toward the edges.
            if (startX) _this.startX = startX;
            else if ($0487a0b3156b866d$var$nodeWhoClaimedTheScroll === null) $0487a0b3156b866d$var$nodeWhoClaimedTheScroll = _this.rootNode;
            _this.setIndexCurrent(index);
            var callback = function callback() {
                if (onSwitching) onSwitching(index, "move");
            };
            if (_this.state.displaySameSlide || !_this.state.isDragging) _this.setState({
                displaySameSlide: false,
                isDragging: true
            }, callback);
            callback();
        };
        _this.handleSwipeEnd = function() {
            $0487a0b3156b866d$var$nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
            // Makes sure that a starting point is set.
            if (!_this.started) return;
            _this.started = false;
            if (_this.isSwiping !== true) return;
            var indexLatest = _this.state.indexLatest;
            var indexCurrent = _this.indexCurrent;
            var delta = indexLatest - indexCurrent;
            var indexNew; // Quick movement
            if (Math.abs(_this.vx) > _this.props.threshold) {
                if (_this.vx > 0) indexNew = Math.floor(indexCurrent);
                else indexNew = Math.ceil(indexCurrent);
            } else if (Math.abs(delta) > _this.props.hysteresis) // Some hysteresis with indexLatest.
            indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
            else indexNew = indexLatest;
            var indexMax = $0487a0b3156b866d$var$_react.default.Children.count(_this.props.children) - 1;
            if (indexNew < 0) indexNew = 0;
            else if (indexNew > indexMax) indexNew = indexMax;
            _this.setIndexCurrent(indexNew);
            _this.setState({
                indexLatest: indexNew,
                isDragging: false
            }, function() {
                if (_this.props.onSwitching) _this.props.onSwitching(indexNew, "end");
                if (_this.props.onChangeIndex && indexNew !== indexLatest) _this.props.onChangeIndex(indexNew, indexLatest, {
                    reason: "swipe"
                });
                 // Manually calling handleTransitionEnd in that case as isn't otherwise.
                if (indexCurrent === indexLatest) _this.handleTransitionEnd();
            });
        };
        _this.handleTouchStart = function(event) {
            if (_this.props.onTouchStart) _this.props.onTouchStart(event);
            _this.handleSwipeStart(event);
        };
        _this.handleTouchEnd = function(event) {
            if (_this.props.onTouchEnd) _this.props.onTouchEnd(event);
            _this.handleSwipeEnd(event);
        };
        _this.handleMouseDown = function(event) {
            if (_this.props.onMouseDown) _this.props.onMouseDown(event);
            event.persist();
            _this.handleSwipeStart($0487a0b3156b866d$var$adaptMouse(event));
        };
        _this.handleMouseUp = function(event) {
            if (_this.props.onMouseUp) _this.props.onMouseUp(event);
            _this.handleSwipeEnd($0487a0b3156b866d$var$adaptMouse(event));
        };
        _this.handleMouseLeave = function(event) {
            if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
             // Filter out events
            if (_this.started) _this.handleSwipeEnd($0487a0b3156b866d$var$adaptMouse(event));
        };
        _this.handleMouseMove = function(event) {
            if (_this.props.onMouseMove) _this.props.onMouseMove(event);
             // Filter out events
            if (_this.started) _this.handleSwipeMove($0487a0b3156b866d$var$adaptMouse(event));
        };
        _this.handleScroll = function(event) {
            if (_this.props.onScroll) _this.props.onScroll(event);
             // Ignore events bubbling up.
            if (event.target !== _this.rootNode) return;
            if (_this.ignoreNextScrollEvents) {
                _this.ignoreNextScrollEvents = false;
                return;
            }
            var indexLatest = _this.state.indexLatest;
            var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
            _this.ignoreNextScrollEvents = true; // Reset the scroll position.
            event.target.scrollLeft = 0;
            if (_this.props.onChangeIndex && indexNew !== indexLatest) _this.props.onChangeIndex(indexNew, indexLatest, {
                reason: "focus"
            });
        };
        _this.updateHeight = function() {
            if (_this.activeSlide !== null) {
                var child = _this.activeSlide.children[0];
                if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) _this.setState({
                    heightLatest: child.offsetHeight
                });
            }
        };
        _this.state = {
            indexLatest: props.index,
            // Set to true as soon as the component is swiping.
            // It's the state counter part of this.isSwiping.
            isDragging: false,
            // Help with SSR logic and lazy loading logic.
            renderOnlyActive: !props.disableLazyLoading,
            heightLatest: 0,
            // Let the render method that we are going to display the same slide than previously.
            displaySameSlide: true
        };
        _this.setIndexCurrent(props.index);
        return _this;
    }
    (0, $0487a0b3156b866d$var$_createClass2.default)(SwipeableViews, [
        {
            key: "getChildContext",
            value: function getChildContext() {
                var _this2 = this;
                return {
                    swipeableViews: {
                        slideUpdateHeight: function slideUpdateHeight() {
                            _this2.updateHeight();
                        }
                    }
                };
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this3 = this;
                // Subscribe to transition end events.
                this.transitionListener = $0487a0b3156b866d$var$addEventListenerEnhanced(this.containerNode, $0487a0b3156b866d$var$_properties.default.end, function(event) {
                    if (event.target !== _this3.containerNode) return;
                    _this3.handleTransitionEnd();
                }); // Block the thread to handle that event.
                this.touchMoveListener = $0487a0b3156b866d$var$addEventListenerEnhanced(this.rootNode, "touchmove", function(event) {
                    // Handling touch events is disabled.
                    if (_this3.props.disabled) return;
                    _this3.handleSwipeMove(event);
                }, {
                    passive: false
                });
                if (!this.props.disableLazyLoading) this.firstRenderTimeout = setTimeout(function() {
                    _this3.setState({
                        renderOnlyActive: false
                    });
                }, 0);
                 // Send all functions in an object if action param is set.
                if (this.props.action) this.props.action({
                    updateHeight: this.updateHeight
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var index = nextProps.index;
                if (typeof index === "number" && index !== this.props.index) {
                    this.setIndexCurrent(index);
                    this.setState({
                        // If true, we are going to change the children. We shoudn't animate it.
                        displaySameSlide: (0, $i3GqJ.getDisplaySameSlide)(this.props, nextProps),
                        indexLatest: index
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.transitionListener.remove();
                this.touchMoveListener.remove();
                clearTimeout(this.firstRenderTimeout);
            }
        },
        {
            key: "setIndexCurrent",
            value: function setIndexCurrent(indexCurrent) {
                if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) this.handleTransitionEnd();
                this.indexCurrent = indexCurrent;
                if (this.containerNode) {
                    var axis = this.props.axis;
                    var transform = $0487a0b3156b866d$var$axisProperties.transform[axis](indexCurrent * 100);
                    this.containerNode.style.WebkitTransform = transform;
                    this.containerNode.style.transform = transform;
                }
            }
        },
        {
            key: "handleTransitionEnd",
            value: function handleTransitionEnd() {
                if (!this.props.onTransitionEnd) return;
                 // Filters out when changing the children
                if (this.state.displaySameSlide) return;
                 // The rest callback is triggered when swiping. It's just noise.
                // We filter it out.
                if (!this.state.isDragging) this.props.onTransitionEnd();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$props2 = this.props, action = _this$props2.action, animateHeight = _this$props2.animateHeight, animateTransitions = _this$props2.animateTransitions, axis = _this$props2.axis, children = _this$props2.children, containerStyleProp = _this$props2.containerStyle, disabled = _this$props2.disabled, disableLazyLoading = _this$props2.disableLazyLoading, enableMouseEvents = _this$props2.enableMouseEvents, hysteresis = _this$props2.hysteresis, ignoreNativeScroll = _this$props2.ignoreNativeScroll, index = _this$props2.index, onChangeIndex = _this$props2.onChangeIndex, onSwitching = _this$props2.onSwitching, onTransitionEnd = _this$props2.onTransitionEnd, resistance = _this$props2.resistance, slideStyleProp = _this$props2.slideStyle, slideClassName = _this$props2.slideClassName, springConfig = _this$props2.springConfig, style = _this$props2.style, threshold = _this$props2.threshold, other = (0, $0487a0b3156b866d$var$_objectWithoutProperties2.default)(_this$props2, [
                    "action",
                    "animateHeight",
                    "animateTransitions",
                    "axis",
                    "children",
                    "containerStyle",
                    "disabled",
                    "disableLazyLoading",
                    "enableMouseEvents",
                    "hysteresis",
                    "ignoreNativeScroll",
                    "index",
                    "onChangeIndex",
                    "onSwitching",
                    "onTransitionEnd",
                    "resistance",
                    "slideStyle",
                    "slideClassName",
                    "springConfig",
                    "style",
                    "threshold"
                ]);
                var _this$state = this.state, displaySameSlide = _this$state.displaySameSlide, heightLatest = _this$state.heightLatest, indexLatest = _this$state.indexLatest, isDragging = _this$state.isDragging, renderOnlyActive = _this$state.renderOnlyActive;
                var touchEvents = !disabled ? {
                    onTouchStart: this.handleTouchStart,
                    onTouchEnd: this.handleTouchEnd
                } : {};
                var mouseEvents = !disabled && enableMouseEvents ? {
                    onMouseDown: this.handleMouseDown,
                    onMouseUp: this.handleMouseUp,
                    onMouseLeave: this.handleMouseLeave,
                    onMouseMove: this.handleMouseMove
                } : {}; // There is no point to animate if we are already providing a height.
                var slideStyle = (0, $0487a0b3156b866d$var$_extends2.default)({}, $0487a0b3156b866d$var$styles.slide, slideStyleProp);
                var transition;
                var WebkitTransition;
                if (isDragging || !animateTransitions || displaySameSlide) {
                    transition = "all 0s ease 0s";
                    WebkitTransition = "all 0s ease 0s";
                } else {
                    transition = $0487a0b3156b866d$var$createTransition("transform", springConfig);
                    WebkitTransition = $0487a0b3156b866d$var$createTransition("-webkit-transform", springConfig);
                    if (heightLatest !== 0) {
                        var additionalTranstion = ", ".concat($0487a0b3156b866d$var$createTransition("height", springConfig));
                        transition += additionalTranstion;
                        WebkitTransition += additionalTranstion;
                    }
                }
                var containerStyle = {
                    height: null,
                    WebkitFlexDirection: $0487a0b3156b866d$var$axisProperties.flexDirection[axis],
                    flexDirection: $0487a0b3156b866d$var$axisProperties.flexDirection[axis],
                    WebkitTransition: WebkitTransition,
                    transition: transition
                }; // Apply the styles for SSR considerations
                if (!renderOnlyActive) {
                    var transform = $0487a0b3156b866d$var$axisProperties.transform[axis](this.indexCurrent * 100);
                    containerStyle.WebkitTransform = transform;
                    containerStyle.transform = transform;
                }
                if (animateHeight) containerStyle.height = heightLatest;
                return $0487a0b3156b866d$var$_react.default.createElement("div", (0, $0487a0b3156b866d$var$_extends2.default)({
                    ref: this.setRootNode,
                    style: (0, $0487a0b3156b866d$var$_extends2.default)({}, $0487a0b3156b866d$var$axisProperties.root[axis], style)
                }, other, touchEvents, mouseEvents, {
                    onScroll: this.handleScroll
                }), $0487a0b3156b866d$var$_react.default.createElement("div", {
                    ref: this.setContainerNode,
                    style: (0, $0487a0b3156b866d$var$_extends2.default)({}, containerStyle, $0487a0b3156b866d$var$styles.container, containerStyleProp),
                    className: "react-swipeable-view-container"
                }, $0487a0b3156b866d$var$_react.default.Children.map(children, function(child, indexChild) {
                    if (renderOnlyActive && indexChild !== indexLatest) return null;
                    var ref;
                    var hidden = true;
                    if (indexChild === indexLatest) {
                        hidden = false;
                        if (animateHeight) {
                            ref = _this4.setActiveSlide;
                            slideStyle.overflowY = "hidden";
                        }
                    }
                    return $0487a0b3156b866d$var$_react.default.createElement("div", {
                        ref: ref,
                        style: slideStyle,
                        className: slideClassName,
                        "aria-hidden": hidden,
                        "data-swipeable": "true"
                    }, child);
                })));
            }
        }
    ]);
    return SwipeableViews;
}($0487a0b3156b866d$var$_react.default.Component); // Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.
$0487a0b3156b866d$var$SwipeableViews.displayName = "ReactSwipableView";
$0487a0b3156b866d$var$SwipeableViews.propTypes = {};
$0487a0b3156b866d$var$SwipeableViews.defaultProps = {
    animateHeight: false,
    animateTransitions: true,
    axis: "x",
    disabled: false,
    disableLazyLoading: false,
    enableMouseEvents: false,
    hysteresis: 0.6,
    ignoreNativeScroll: false,
    index: 0,
    threshold: 5,
    springConfig: {
        duration: "0.35s",
        easeFunction: "cubic-bezier(0.15, 0.3, 0.25, 1)",
        delay: "0s"
    },
    resistance: false
};
$0487a0b3156b866d$var$SwipeableViews.childContextTypes = {
    swipeableViews: $0487a0b3156b866d$var$_propTypes.default.shape({
        slideUpdateHeight: $0487a0b3156b866d$var$_propTypes.default.func
    })
};
var $0487a0b3156b866d$var$_default = $0487a0b3156b866d$var$SwipeableViews;
module.exports.default = $0487a0b3156b866d$var$_default;

});
parcelRegister("kUwzY", function(module, exports) {
function $f3924f250626b1b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = $f3924f250626b1b2$var$_interopRequireDefault;

});

parcelRegister("BvuYv", function(module, exports) {
function $070be3c7dc12f01e$var$_extends() {
    module.exports = $070be3c7dc12f01e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $070be3c7dc12f01e$var$_extends.apply(this, arguments);
}
module.exports = $070be3c7dc12f01e$var$_extends;

});

parcelRegister("8masA", function(module, exports) {

var $4QpXc = parcelRequire("4QpXc");
function $61587dfaf5666d1f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4QpXc(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $61587dfaf5666d1f$var$_objectWithoutProperties;

});
parcelRegister("4QpXc", function(module, exports) {
function $387026a20196f451$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $387026a20196f451$var$_objectWithoutPropertiesLoose;

});


parcelRegister("6L4M1", function(module, exports) {
function $4ebad5c65b8ae524$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $4ebad5c65b8ae524$var$_classCallCheck;

});

parcelRegister("hnSKw", function(module, exports) {
function $ca7f0db6e334310c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ca7f0db6e334310c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ca7f0db6e334310c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ca7f0db6e334310c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = $ca7f0db6e334310c$var$_createClass;

});

parcelRegister("1cT1p", function(module, exports) {

var $1b104 = parcelRequire("1b104");

var $lY3Di = parcelRequire("lY3Di");
function $0e119795892938f8$var$_possibleConstructorReturn(self, call) {
    if (call && ($1b104(call) === "object" || typeof call === "function")) return call;
    return $lY3Di(self);
}
module.exports = $0e119795892938f8$var$_possibleConstructorReturn;

});
parcelRegister("1b104", function(module, exports) {
function $0db7981d85f73340$var$_typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0db7981d85f73340$var$_typeof2 = function _typeof2(obj) {
        return typeof obj;
    };
    else $0db7981d85f73340$var$_typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0db7981d85f73340$var$_typeof2(obj);
}
function $0db7981d85f73340$var$_typeof(obj) {
    if (typeof Symbol === "function" && $0db7981d85f73340$var$_typeof2(Symbol.iterator) === "symbol") module.exports = $0db7981d85f73340$var$_typeof = function _typeof(obj) {
        return $0db7981d85f73340$var$_typeof2(obj);
    };
    else module.exports = $0db7981d85f73340$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : $0db7981d85f73340$var$_typeof2(obj);
    };
    return $0db7981d85f73340$var$_typeof(obj);
}
module.exports = $0db7981d85f73340$var$_typeof;

});

parcelRegister("lY3Di", function(module, exports) {
function $ffe204f5108d4af5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $ffe204f5108d4af5$var$_assertThisInitialized;

});


parcelRegister("44JRR", function(module, exports) {
function $2f7b1d825e6c9370$var$_getPrototypeOf(o) {
    module.exports = $2f7b1d825e6c9370$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2f7b1d825e6c9370$var$_getPrototypeOf(o);
}
module.exports = $2f7b1d825e6c9370$var$_getPrototypeOf;

});

parcelRegister("guNYK", function(module, exports) {

var $97mFq = parcelRequire("97mFq");
function $c02637716e87ce5c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $97mFq(subClass, superClass);
}
module.exports = $c02637716e87ce5c$var$_inherits;

});
parcelRegister("97mFq", function(module, exports) {
function $6a3659c00fb5344a$var$_setPrototypeOf(o, p) {
    module.exports = $6a3659c00fb5344a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6a3659c00fb5344a$var$_setPrototypeOf(o, p);
}
module.exports = $6a3659c00fb5344a$var$_setPrototypeOf;

});


parcelRegister("2Quny", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $212800be356fddd2$var$ReactIs, $212800be356fddd2$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("54H64"))();

});
parcelRegister("54H64", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $3xu5S = parcelRequire("3xu5S");
function $3b1ec19f515bce3b$var$emptyFunction() {}
function $3b1ec19f515bce3b$var$emptyFunctionWithReset() {}
$3b1ec19f515bce3b$var$emptyFunctionWithReset.resetWarningCache = $3b1ec19f515bce3b$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $3xu5S) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $3b1ec19f515bce3b$var$emptyFunctionWithReset,
        resetWarningCache: $3b1ec19f515bce3b$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("3xu5S", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $293bcc2ed8f1683c$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $293bcc2ed8f1683c$var$ReactPropTypesSecret;

});



parcelRegister("3a4dW", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $24d5950e74790b9d$var$__DEV__ = false;
var $24d5950e74790b9d$var$warning = function() {};
if ($24d5950e74790b9d$var$__DEV__) {
    var $24d5950e74790b9d$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $24d5950e74790b9d$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $24d5950e74790b9d$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $24d5950e74790b9d$var$warning;

});

parcelRegister("5OrjC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $43b6cf899a758c0c$export$1e511d4a378977f5; }, function (v) { return $43b6cf899a758c0c$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $43b6cf899a758c0c$export$2e2bcd8739ae039; }, function (v) { return $43b6cf899a758c0c$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "animationEnd", function () { return $43b6cf899a758c0c$export$70f051812b89bf32; }, function (v) { return $43b6cf899a758c0c$export$70f051812b89bf32 = v; });
$parcel$export(module.exports, "animationDelay", function () { return $43b6cf899a758c0c$export$749d4cba267d0cfb; }, function (v) { return $43b6cf899a758c0c$export$749d4cba267d0cfb = v; });
$parcel$export(module.exports, "animationTiming", function () { return $43b6cf899a758c0c$export$ffa43e98d6c6fda0; }, function (v) { return $43b6cf899a758c0c$export$ffa43e98d6c6fda0 = v; });
$parcel$export(module.exports, "animationDuration", function () { return $43b6cf899a758c0c$export$82f5c257a11c5515; }, function (v) { return $43b6cf899a758c0c$export$82f5c257a11c5515 = v; });
$parcel$export(module.exports, "animationName", function () { return $43b6cf899a758c0c$export$3661f43c23499d48; }, function (v) { return $43b6cf899a758c0c$export$3661f43c23499d48 = v; });
$parcel$export(module.exports, "transitionEnd", function () { return $43b6cf899a758c0c$export$358dc01d65cad417; }, function (v) { return $43b6cf899a758c0c$export$358dc01d65cad417 = v; });
$parcel$export(module.exports, "transitionDuration", function () { return $43b6cf899a758c0c$export$3105270315df0e7; }, function (v) { return $43b6cf899a758c0c$export$3105270315df0e7 = v; });
$parcel$export(module.exports, "transitionDelay", function () { return $43b6cf899a758c0c$export$48c3efaeac751014; }, function (v) { return $43b6cf899a758c0c$export$48c3efaeac751014 = v; });
$parcel$export(module.exports, "transitionTiming", function () { return $43b6cf899a758c0c$export$17443db69dc7b37a; }, function (v) { return $43b6cf899a758c0c$export$17443db69dc7b37a = v; });
$parcel$export(module.exports, "transitionProperty", function () { return $43b6cf899a758c0c$export$88a474443352206c; }, function (v) { return $43b6cf899a758c0c$export$88a474443352206c = v; });
$parcel$export(module.exports, "transform", function () { return $43b6cf899a758c0c$export$51186ad6e864892a; }, function (v) { return $43b6cf899a758c0c$export$51186ad6e864892a = v; });
var $43b6cf899a758c0c$export$1e511d4a378977f5;
var $43b6cf899a758c0c$export$2e2bcd8739ae039;
var $43b6cf899a758c0c$export$70f051812b89bf32;
var $43b6cf899a758c0c$export$749d4cba267d0cfb;
var $43b6cf899a758c0c$export$ffa43e98d6c6fda0;
var $43b6cf899a758c0c$export$82f5c257a11c5515;
var $43b6cf899a758c0c$export$3661f43c23499d48;
var $43b6cf899a758c0c$export$358dc01d65cad417;
var $43b6cf899a758c0c$export$3105270315df0e7;
var $43b6cf899a758c0c$export$48c3efaeac751014;
var $43b6cf899a758c0c$export$17443db69dc7b37a;
var $43b6cf899a758c0c$export$88a474443352206c;
var $43b6cf899a758c0c$export$51186ad6e864892a;
"use strict";

var $lvhY9 = parcelRequire("lvhY9");
$43b6cf899a758c0c$export$1e511d4a378977f5 = true;
$43b6cf899a758c0c$export$2e2bcd8739ae039 = $43b6cf899a758c0c$export$70f051812b89bf32 = $43b6cf899a758c0c$export$749d4cba267d0cfb = $43b6cf899a758c0c$export$ffa43e98d6c6fda0 = $43b6cf899a758c0c$export$82f5c257a11c5515 = $43b6cf899a758c0c$export$3661f43c23499d48 = $43b6cf899a758c0c$export$358dc01d65cad417 = $43b6cf899a758c0c$export$3105270315df0e7 = $43b6cf899a758c0c$export$48c3efaeac751014 = $43b6cf899a758c0c$export$17443db69dc7b37a = $43b6cf899a758c0c$export$88a474443352206c = $43b6cf899a758c0c$export$51186ad6e864892a = void 0;

var $43b6cf899a758c0c$var$_inDOM = $lvhY9((parcelRequire("9N9Gj")));
var $43b6cf899a758c0c$var$transform = "transform";
$43b6cf899a758c0c$export$51186ad6e864892a = $43b6cf899a758c0c$var$transform;
var $43b6cf899a758c0c$var$prefix, $43b6cf899a758c0c$var$transitionEnd, $43b6cf899a758c0c$var$animationEnd;
$43b6cf899a758c0c$export$70f051812b89bf32 = $43b6cf899a758c0c$var$animationEnd;
$43b6cf899a758c0c$export$358dc01d65cad417 = $43b6cf899a758c0c$var$transitionEnd;
var $43b6cf899a758c0c$var$transitionProperty, $43b6cf899a758c0c$var$transitionDuration, $43b6cf899a758c0c$var$transitionTiming, $43b6cf899a758c0c$var$transitionDelay;
$43b6cf899a758c0c$export$48c3efaeac751014 = $43b6cf899a758c0c$var$transitionDelay;
$43b6cf899a758c0c$export$17443db69dc7b37a = $43b6cf899a758c0c$var$transitionTiming;
$43b6cf899a758c0c$export$3105270315df0e7 = $43b6cf899a758c0c$var$transitionDuration;
$43b6cf899a758c0c$export$88a474443352206c = $43b6cf899a758c0c$var$transitionProperty;
var $43b6cf899a758c0c$var$animationName, $43b6cf899a758c0c$var$animationDuration, $43b6cf899a758c0c$var$animationTiming, $43b6cf899a758c0c$var$animationDelay;
$43b6cf899a758c0c$export$749d4cba267d0cfb = $43b6cf899a758c0c$var$animationDelay;
$43b6cf899a758c0c$export$ffa43e98d6c6fda0 = $43b6cf899a758c0c$var$animationTiming;
$43b6cf899a758c0c$export$82f5c257a11c5515 = $43b6cf899a758c0c$var$animationDuration;
$43b6cf899a758c0c$export$3661f43c23499d48 = $43b6cf899a758c0c$var$animationName;
if ($43b6cf899a758c0c$var$_inDOM.default) {
    var $43b6cf899a758c0c$var$_getTransitionPropert = $43b6cf899a758c0c$var$getTransitionProperties();
    $43b6cf899a758c0c$var$prefix = $43b6cf899a758c0c$var$_getTransitionPropert.prefix;
    $43b6cf899a758c0c$export$358dc01d65cad417 = $43b6cf899a758c0c$var$transitionEnd = $43b6cf899a758c0c$var$_getTransitionPropert.transitionEnd;
    $43b6cf899a758c0c$export$70f051812b89bf32 = $43b6cf899a758c0c$var$animationEnd = $43b6cf899a758c0c$var$_getTransitionPropert.animationEnd;
    $43b6cf899a758c0c$export$51186ad6e864892a = $43b6cf899a758c0c$var$transform = $43b6cf899a758c0c$var$prefix + "-" + $43b6cf899a758c0c$var$transform;
    $43b6cf899a758c0c$export$88a474443352206c = $43b6cf899a758c0c$var$transitionProperty = $43b6cf899a758c0c$var$prefix + "-transition-property";
    $43b6cf899a758c0c$export$3105270315df0e7 = $43b6cf899a758c0c$var$transitionDuration = $43b6cf899a758c0c$var$prefix + "-transition-duration";
    $43b6cf899a758c0c$export$48c3efaeac751014 = $43b6cf899a758c0c$var$transitionDelay = $43b6cf899a758c0c$var$prefix + "-transition-delay";
    $43b6cf899a758c0c$export$17443db69dc7b37a = $43b6cf899a758c0c$var$transitionTiming = $43b6cf899a758c0c$var$prefix + "-transition-timing-function";
    $43b6cf899a758c0c$export$3661f43c23499d48 = $43b6cf899a758c0c$var$animationName = $43b6cf899a758c0c$var$prefix + "-animation-name";
    $43b6cf899a758c0c$export$82f5c257a11c5515 = $43b6cf899a758c0c$var$animationDuration = $43b6cf899a758c0c$var$prefix + "-animation-duration";
    $43b6cf899a758c0c$export$ffa43e98d6c6fda0 = $43b6cf899a758c0c$var$animationTiming = $43b6cf899a758c0c$var$prefix + "-animation-delay";
    $43b6cf899a758c0c$export$749d4cba267d0cfb = $43b6cf899a758c0c$var$animationDelay = $43b6cf899a758c0c$var$prefix + "-animation-timing-function";
}
var $43b6cf899a758c0c$var$_default = {
    transform: $43b6cf899a758c0c$var$transform,
    end: $43b6cf899a758c0c$var$transitionEnd,
    property: $43b6cf899a758c0c$var$transitionProperty,
    timing: $43b6cf899a758c0c$var$transitionTiming,
    delay: $43b6cf899a758c0c$var$transitionDelay,
    duration: $43b6cf899a758c0c$var$transitionDuration
};
$43b6cf899a758c0c$export$2e2bcd8739ae039 = $43b6cf899a758c0c$var$_default;
function $43b6cf899a758c0c$var$getTransitionProperties() {
    var style = document.createElement("div").style;
    var vendorMap = {
        O: function O(e) {
            return "o" + e.toLowerCase();
        },
        Moz: function Moz(e) {
            return e.toLowerCase();
        },
        Webkit: function Webkit(e) {
            return "webkit" + e;
        },
        ms: function ms(e) {
            return "MS" + e;
        }
    };
    var vendors = Object.keys(vendorMap);
    var transitionEnd, animationEnd;
    var prefix = "";
    for(var i = 0; i < vendors.length; i++){
        var vendor = vendors[i];
        if (vendor + "TransitionProperty" in style) {
            prefix = "-" + vendor.toLowerCase();
            transitionEnd = vendorMap[vendor]("TransitionEnd");
            animationEnd = vendorMap[vendor]("AnimationEnd");
            break;
        }
    }
    if (!transitionEnd && "transitionProperty" in style) transitionEnd = "transitionend";
    if (!animationEnd && "animationName" in style) animationEnd = "animationend";
    style = null;
    return {
        animationEnd: animationEnd,
        transitionEnd: transitionEnd,
        prefix: prefix
    };
}

});
parcelRegister("lvhY9", function(module, exports) {
function $fa7a6e885fc2dc64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $fa7a6e885fc2dc64$var$_interopRequireDefault;

});

parcelRegister("9N9Gj", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;
var $7210332c47c74910$var$_default = !!(typeof window !== "undefined" && window.document && window.document.createElement);
module.exports.default = $7210332c47c74910$var$_default;
module.exports = module.exports["default"];

});


parcelRegister("l7fKm", function(module, exports) {
"use strict";

var $lvhY9 = parcelRequire("lvhY9");
module.exports.__esModule = true;
module.exports.default = void 0;

var $f5f677660f9cbff3$var$_inDOM = $lvhY9((parcelRequire("9N9Gj")));
var $f5f677660f9cbff3$var$on = function on() {};
if ($f5f677660f9cbff3$var$_inDOM.default) $f5f677660f9cbff3$var$on = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.addEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.attachEvent("on" + eventName, function(e) {
            e = e || window.event;
            e.target = e.target || e.srcElement;
            e.currentTarget = node;
            handler.call(node, e);
        });
    };
}();
var $f5f677660f9cbff3$var$_default = $f5f677660f9cbff3$var$on;
module.exports.default = $f5f677660f9cbff3$var$_default;
module.exports = module.exports["default"];

});

parcelRegister("5e0ma", function(module, exports) {
"use strict";

var $lvhY9 = parcelRequire("lvhY9");
module.exports.__esModule = true;
module.exports.default = void 0;

var $3cde895d02abf370$var$_inDOM = $lvhY9((parcelRequire("9N9Gj")));
var $3cde895d02abf370$var$off = function off() {};
if ($3cde895d02abf370$var$_inDOM.default) $3cde895d02abf370$var$off = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.removeEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.detachEvent("on" + eventName, handler);
    };
}();
var $3cde895d02abf370$var$_default = $3cde895d02abf370$var$off;
module.exports.default = $3cde895d02abf370$var$_default;
module.exports = module.exports["default"];

});

parcelRegister("i3GqJ", function(module, exports) {
"use strict";

var $0XjZu = parcelRequire("0XjZu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "checkIndexBounds", {
    enumerable: true,
    get: function get() {
        return $d2596b8fc1350c5f$var$_checkIndexBounds.default;
    }
});
Object.defineProperty(module.exports, "computeIndex", {
    enumerable: true,
    get: function get() {
        return $d2596b8fc1350c5f$var$_computeIndex.default;
    }
});
Object.defineProperty(module.exports, "constant", {
    enumerable: true,
    get: function get() {
        return $d2596b8fc1350c5f$var$_constant.default;
    }
});
Object.defineProperty(module.exports, "getDisplaySameSlide", {
    enumerable: true,
    get: function get() {
        return $d2596b8fc1350c5f$var$_getDisplaySameSlide.default;
    }
});
Object.defineProperty(module.exports, "mod", {
    enumerable: true,
    get: function get() {
        return $d2596b8fc1350c5f$var$_mod.default;
    }
});

var $d2596b8fc1350c5f$var$_checkIndexBounds = $0XjZu((parcelRequire("6QkrY")));

var $d2596b8fc1350c5f$var$_computeIndex = $0XjZu((parcelRequire("3SrnI")));

var $d2596b8fc1350c5f$var$_constant = $0XjZu((parcelRequire("2Yni5")));

var $d2596b8fc1350c5f$var$_getDisplaySameSlide = $0XjZu((parcelRequire("2edKJ")));

var $d2596b8fc1350c5f$var$_mod = $0XjZu((parcelRequire("b2v1n")));

});
parcelRegister("0XjZu", function(module, exports) {
function $002e0433c13f45ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = $002e0433c13f45ed$var$_interopRequireDefault;

});

parcelRegister("6QkrY", function(module, exports) {
"use strict";

var $0XjZu = parcelRequire("0XjZu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fb7765ed46aded2$var$_react = $0XjZu((parcelRequire("70fFQ")));

var $4fb7765ed46aded2$var$_warning = $0XjZu((parcelRequire("3a4dW")));
var $4fb7765ed46aded2$var$checkIndexBounds = function checkIndexBounds(props) {
    var index = props.index, children = props.children;
    var childrenCount = $4fb7765ed46aded2$var$_react.default.Children.count(children);
};
var $4fb7765ed46aded2$var$_default = $4fb7765ed46aded2$var$checkIndexBounds;
module.exports.default = $4fb7765ed46aded2$var$_default;

});

parcelRegister("3SrnI", function(module, exports) {
"use strict";

var $0XjZu = parcelRequire("0XjZu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2d2ba7a5b75c2e6a$var$computeIndex;

var $2d2ba7a5b75c2e6a$var$_react = $0XjZu((parcelRequire("70fFQ")));

var $2d2ba7a5b75c2e6a$var$_constant = $0XjZu((parcelRequire("2Yni5")));
function $2d2ba7a5b75c2e6a$var$computeIndex(params) {
    var children = params.children, startIndex = params.startIndex, startX = params.startX, pageX = params.pageX, viewLength = params.viewLength, resistance = params.resistance;
    var indexMax = $2d2ba7a5b75c2e6a$var$_react.default.Children.count(children) - 1;
    var index = startIndex + (startX - pageX) / viewLength;
    var newStartX;
    if (!resistance) {
        // Reset the starting point
        if (index < 0) {
            index = 0;
            newStartX = (index - startIndex) * viewLength + pageX;
        } else if (index > indexMax) {
            index = indexMax;
            newStartX = (index - startIndex) * viewLength + pageX;
        }
    } else if (index < 0) index = Math.exp(index * $2d2ba7a5b75c2e6a$var$_constant.default.RESISTANCE_COEF) - 1;
    else if (index > indexMax) index = indexMax + 1 - Math.exp((indexMax - index) * $2d2ba7a5b75c2e6a$var$_constant.default.RESISTANCE_COEF);
    return {
        index: index,
        startX: newStartX
    };
}

});
parcelRegister("2Yni5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $22a3406b77c6c078$var$_default = {
    RESISTANCE_COEF: 0.6,
    // This value is closed to what browsers are using internally to
    // trigger a native scroll.
    UNCERTAINTY_THRESHOLD: 3 // px
};
module.exports.default = $22a3406b77c6c078$var$_default;

});


parcelRegister("2edKJ", function(module, exports) {
"use strict";

var $0XjZu = parcelRequire("0XjZu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19f78e9871dc1286$var$_react = $0XjZu((parcelRequire("70fFQ")));
var $19f78e9871dc1286$var$getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
    var displaySameSlide = false;
    var getChildrenKey = function getChildrenKey(child) {
        return child ? child.key : "empty";
    };
    if (props.children.length && nextProps.children.length) {
        var oldKeys = $19f78e9871dc1286$var$_react.default.Children.map(props.children, getChildrenKey);
        var oldKey = oldKeys[props.index];
        if (oldKey !== null && oldKey !== undefined) {
            var newKeys = $19f78e9871dc1286$var$_react.default.Children.map(nextProps.children, getChildrenKey);
            var newKey = newKeys[nextProps.index];
            if (oldKey === newKey) displaySameSlide = true;
        }
    }
    return displaySameSlide;
};
var $19f78e9871dc1286$var$_default = $19f78e9871dc1286$var$getDisplaySameSlide;
module.exports.default = $19f78e9871dc1286$var$_default;

});

parcelRegister("b2v1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// Extended version of % with negative integer support.
function $8097f1c1d743bc00$var$mod(n, m) {
    var q = n % m;
    return q < 0 ? q + m : q;
}
var $8097f1c1d743bc00$var$_default = $8097f1c1d743bc00$var$mod;
module.exports.default = $8097f1c1d743bc00$var$_default;

});



parcelRegister("lBx17", function(module, exports) {
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fba6aa2d134ab5fc$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $fba6aa2d134ab5fc$var$_default = (0, $fba6aa2d134ab5fc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBack");
module.exports.default = $fba6aa2d134ab5fc$var$_default;

});

parcelRegister("c4gat", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c92665cf49baced$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $8c92665cf49baced$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});

parcelRegister("cg448", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eca2201007dbb2e$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $8eca2201007dbb2e$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");

});

parcelRegister("kQo3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2cb53bacf130abf$export$2e2bcd8739ae039; });

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $bmkEq = parcelRequire("bmkEq");

var $4x3bm = parcelRequire("4x3bm");

var $kcSl7 = parcelRequire("kcSl7");
var $k353r = parcelRequire("k353r");
var $jTjNP = parcelRequire("jTjNP");
var $27ZKj = parcelRequire("27ZKj");

var $5GjdS = parcelRequire("5GjdS");

var $70fFQ = parcelRequire("70fFQ");
function $f2cb53bacf130abf$export$2e2bcd8739ae039(_param) {
    var { icon: icon, open: open = false, actions: actions = [], FabProps: FabProps = {}, defaultAction: defaultAction, onOpen: onOpen = ()=>{}, children: children } = _param, rest = (0, $bmkEq._)(_param, [
        "icon",
        "open",
        "actions",
        "FabProps",
        "defaultAction",
        "onOpen",
        "children"
    ]);
    // const open = true;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState(open);
    (0, $70fFQ.useEffect)(()=>{
        setIsOpen(open);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
        id: "speed-dial",
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $k353r.default), (0, $edHbI._)((0, $2QP2i._)({
                ariaLabel: "Building actions",
                className: "speed-dial",
                direction: "up",
                icon: icon || (defaultAction === null || defaultAction === void 0 ? void 0 : defaultAction.icon) || /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5GjdS.default), {}),
                open: isOpen,
                FabProps: FabProps,
                classes: {
                    fab: "speed-dial-fab"
                },
                onOpen: (event, reason)=>{
                    if (reason !== "focus") onOpen();
                    setIsOpen(true);
                },
                onClose: ()=>{
                    setIsOpen(false);
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    setIsOpen(false);
                    if (defaultAction === null || defaultAction === void 0 ? void 0 : defaultAction.onClick) defaultAction.onClick(event);
                }
            }, rest), {
                children: actions.filter((action)=>!action.isHidden).map((action)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $jTjNP.default), {
                        tooltipTitle: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                            style: {
                                whiteSpace: "nowrap"
                            },
                            variant: "body1",
                            children: action.tooltipTitle
                        }),
                        classes: {
                            staticTooltip: "speed-dial-tooltip-label"
                        },
                        icon: action.icon,
                        tooltipOpen: true,
                        onClick: (event)=>{
                            event.stopPropagation();
                            action.onClick(event);
                        }
                    }, action.tooltipTitle))
            })),
            defaultAction && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $kcSl7.default), {
                in: isOpen,
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    className: "speed-dial-tooltip-label  default-action",
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                        children: defaultAction.label
                    })
                })
            }),
            children
        ]
    });
}

});
parcelRegister("k353r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e988022f25fc05a7$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8q2ES");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $2mnfJ = parcelRequire("2mnfJ");

var $3bgTm = parcelRequire("3bgTm");

var $2OCa7 = parcelRequire("2OCa7");

var $aAAPW = parcelRequire("aAAPW");

var $6ATFq = parcelRequire("6ATFq");

var $5Up1l = parcelRequire("5Up1l");

var $6Apvh = parcelRequire("6Apvh");

var $jNZi4 = parcelRequire("jNZi4");

var $4x3bm = parcelRequire("4x3bm");
const $e988022f25fc05a7$var$_excluded = [
    "ref"
], $e988022f25fc05a7$var$_excluded2 = [
    "ariaLabel",
    "FabProps",
    "children",
    "className",
    "direction",
    "hidden",
    "icon",
    "onBlur",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMouseEnter",
    "onMouseLeave",
    "onOpen",
    "open",
    "openIcon",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
], $e988022f25fc05a7$var$_excluded3 = [
    "ref"
];
const $e988022f25fc05a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, direction: direction } = ownerState;
    const slots = {
        root: [
            "root",
            `direction${(0, $aAAPW.default)(direction)}`
        ],
        fab: [
            "fab"
        ],
        actions: [
            "actions",
            !open && "actionsClosed"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $jNZi4.getSpeedDialUtilityClass), classes);
};
function $e988022f25fc05a7$var$getOrientation(direction) {
    if (direction === "up" || direction === "down") return "vertical";
    if (direction === "right" || direction === "left") return "horizontal";
    return undefined;
}
function $e988022f25fc05a7$var$clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
}
const $e988022f25fc05a7$var$dialRadius = 32;
const $e988022f25fc05a7$var$spacingActions = 16;
const $e988022f25fc05a7$var$SpeedDialRoot = (0, $71Pr4.default)("div", {
    name: "MuiSpeedDial",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`direction${(0, $aAAPW.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        zIndex: theme.zIndex.speedDial,
        display: "flex",
        alignItems: "center",
        pointerEvents: "none"
    }, ownerState.direction === "up" && {
        flexDirection: "column-reverse",
        [`& .${(0, $jNZi4.default).actions}`]: {
            flexDirection: "column-reverse",
            marginBottom: -$e988022f25fc05a7$var$dialRadius,
            paddingBottom: $e988022f25fc05a7$var$spacingActions + $e988022f25fc05a7$var$dialRadius
        }
    }, ownerState.direction === "down" && {
        flexDirection: "column",
        [`& .${(0, $jNZi4.default).actions}`]: {
            flexDirection: "column",
            marginTop: -$e988022f25fc05a7$var$dialRadius,
            paddingTop: $e988022f25fc05a7$var$spacingActions + $e988022f25fc05a7$var$dialRadius
        }
    }, ownerState.direction === "left" && {
        flexDirection: "row-reverse",
        [`& .${(0, $jNZi4.default).actions}`]: {
            flexDirection: "row-reverse",
            marginRight: -$e988022f25fc05a7$var$dialRadius,
            paddingRight: $e988022f25fc05a7$var$spacingActions + $e988022f25fc05a7$var$dialRadius
        }
    }, ownerState.direction === "right" && {
        flexDirection: "row",
        [`& .${(0, $jNZi4.default).actions}`]: {
            flexDirection: "row",
            marginLeft: -$e988022f25fc05a7$var$dialRadius,
            paddingLeft: $e988022f25fc05a7$var$spacingActions + $e988022f25fc05a7$var$dialRadius
        }
    }));
const $e988022f25fc05a7$var$SpeedDialFab = (0, $71Pr4.default)((0, $2OCa7.default), {
    name: "MuiSpeedDial",
    slot: "Fab",
    overridesResolver: (props, styles)=>styles.fab
})(()=>({
        pointerEvents: "auto"
    }));
const $e988022f25fc05a7$var$SpeedDialActions = (0, $71Pr4.default)("div", {
    name: "MuiSpeedDial",
    slot: "Actions",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actions,
            !ownerState.open && styles.actionsClosed
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        pointerEvents: "auto"
    }, !ownerState.open && {
        transition: "top 0s linear 0.2s",
        pointerEvents: "none"
    }));
const $e988022f25fc05a7$var$SpeedDial = /*#__PURE__*/ $70fFQ.forwardRef(function SpeedDial(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiSpeedDial"
    });
    const theme = (0, $2mnfJ.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { ariaLabel: ariaLabel, FabProps: { ref: origDialButtonRef } = {}, children: childrenProp, className: className, direction: direction = "up", hidden: hidden = false, icon: icon, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onOpen: onOpen, open: openProp, TransitionComponent: TransitionComponent = (0, $3bgTm.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, FabProps = (0, $79yYo.default)(props.FabProps, $e988022f25fc05a7$var$_excluded), other = (0, $79yYo.default)(props, $e988022f25fc05a7$var$_excluded2);
    const [open, setOpenState] = (0, $6Apvh.default)({
        controlled: openProp,
        default: false,
        name: "SpeedDial",
        state: "open"
    });
    const ownerState = (0, $20MOv.default)({}, props, {
        open: open,
        direction: direction
    });
    const classes = $e988022f25fc05a7$var$useUtilityClasses(ownerState);
    const eventTimer = $70fFQ.useRef();
    $70fFQ.useEffect(()=>{
        return ()=>{
            clearTimeout(eventTimer.current);
        };
    }, []);
    /**
   * an index in actions.current
   */ const focusedAction = $70fFQ.useRef(0);
    /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */ const nextItemArrowKey = $70fFQ.useRef();
    /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */ const actions = $70fFQ.useRef([]);
    actions.current = [
        actions.current[0]
    ];
    const handleOwnFabRef = $70fFQ.useCallback((fabFef)=>{
        actions.current[0] = fabFef;
    }, []);
    const handleFabRef = (0, $5Up1l.default)(origDialButtonRef, handleOwnFabRef);
    /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   */ const createHandleSpeedDialActionButtonRef = (dialActionIndex, origButtonRef)=>{
        return (buttonRef)=>{
            actions.current[dialActionIndex + 1] = buttonRef;
            if (origButtonRef) origButtonRef(buttonRef);
        };
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        const key = event.key.replace("Arrow", "").toLowerCase();
        const { current: nextItemArrowKeyCurrent = key } = nextItemArrowKey;
        if (event.key === "Escape") {
            setOpenState(false);
            actions.current[0].focus();
            if (onClose) onClose(event, "escapeKeyDown");
            return;
        }
        if ($e988022f25fc05a7$var$getOrientation(key) === $e988022f25fc05a7$var$getOrientation(nextItemArrowKeyCurrent) && $e988022f25fc05a7$var$getOrientation(key) !== undefined) {
            event.preventDefault();
            const actionStep = key === nextItemArrowKeyCurrent ? 1 : -1; // stay within array indices
            const nextAction = $e988022f25fc05a7$var$clamp(focusedAction.current + actionStep, 0, actions.current.length - 1);
            actions.current[nextAction].focus();
            focusedAction.current = nextAction;
            nextItemArrowKey.current = nextItemArrowKeyCurrent;
        }
    };
    $70fFQ.useEffect(()=>{
        // actions were closed while navigation state was not reset
        if (!open) {
            focusedAction.current = 0;
            nextItemArrowKey.current = undefined;
        }
    }, [
        open
    ]);
    const handleClose = (event)=>{
        if (event.type === "mouseleave" && onMouseLeave) onMouseLeave(event);
        if (event.type === "blur" && onBlur) onBlur(event);
        clearTimeout(eventTimer.current);
        if (event.type === "blur") eventTimer.current = setTimeout(()=>{
            setOpenState(false);
            if (onClose) onClose(event, "blur");
        });
        else {
            setOpenState(false);
            if (onClose) onClose(event, "mouseLeave");
        }
    };
    const handleClick = (event)=>{
        if (FabProps.onClick) FabProps.onClick(event);
        clearTimeout(eventTimer.current);
        if (open) {
            setOpenState(false);
            if (onClose) onClose(event, "toggle");
        } else {
            setOpenState(true);
            if (onOpen) onOpen(event, "toggle");
        }
    };
    const handleOpen = (event)=>{
        if (event.type === "mouseenter" && onMouseEnter) onMouseEnter(event);
        if (event.type === "focus" && onFocus) onFocus(event);
         // When moving the focus between two items,
        // a chain if blur and focus event is triggered.
        // We only handle the last event.
        clearTimeout(eventTimer.current);
        if (!open) // Wait for a future focus or click event
        eventTimer.current = setTimeout(()=>{
            setOpenState(true);
            if (onOpen) {
                const eventMap = {
                    focus: "focus",
                    mouseenter: "mouseEnter"
                };
                onOpen(event, eventMap[event.type]);
            }
        });
    }; // Filter the label for valid id characters.
    const id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, "");
    const allItems = $70fFQ.Children.toArray(childrenProp).filter((child)=>{
        return /*#__PURE__*/ $70fFQ.isValidElement(child);
    });
    const children = allItems.map((child, index)=>{
        const _child$props = child.props, { FabProps: { ref: origButtonRef } = {}, tooltipPlacement: tooltipPlacementProp } = _child$props, ChildFabProps = (0, $79yYo.default)(_child$props.FabProps, $e988022f25fc05a7$var$_excluded3);
        const tooltipPlacement = tooltipPlacementProp || ($e988022f25fc05a7$var$getOrientation(direction) === "vertical" ? "left" : "top");
        return /*#__PURE__*/ $70fFQ.cloneElement(child, {
            FabProps: (0, $20MOv.default)({}, ChildFabProps, {
                ref: createHandleSpeedDialActionButtonRef(index, origButtonRef)
            }),
            delay: 30 * (open ? index : allItems.length - index),
            open: open,
            tooltipPlacement: tooltipPlacement,
            id: `${id}-action-${index}`
        });
    });
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($e988022f25fc05a7$var$SpeedDialRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref,
        role: "presentation",
        onKeyDown: handleKeyDown,
        onBlur: handleClose,
        onFocus: handleOpen,
        onMouseEnter: handleOpen,
        onMouseLeave: handleClose,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
                in: !hidden,
                timeout: transitionDuration,
                unmountOnExit: true
            }, TransitionProps, {
                children: /*#__PURE__*/ (0, $4x3bm.jsx)($e988022f25fc05a7$var$SpeedDialFab, (0, $20MOv.default)({
                    color: "primary",
                    "aria-label": ariaLabel,
                    "aria-haspopup": "true",
                    "aria-expanded": open,
                    "aria-controls": `${id}-actions`
                }, FabProps, {
                    onClick: handleClick,
                    className: (0, $gjktY.default)(classes.fab, FabProps.className),
                    ref: handleFabRef,
                    ownerState: ownerState,
                    children: /*#__PURE__*/ $70fFQ.isValidElement(icon) && (0, $6ATFq.default)(icon, [
                        "SpeedDialIcon"
                    ]) ? /*#__PURE__*/ $70fFQ.cloneElement(icon, {
                        open: open
                    }) : icon
                }))
            })),
            /*#__PURE__*/ (0, $4x3bm.jsx)($e988022f25fc05a7$var$SpeedDialActions, {
                id: `${id}-actions`,
                role: "menu",
                "aria-orientation": $e988022f25fc05a7$var$getOrientation(direction),
                className: (0, $gjktY.default)(classes.actions, !open && classes.actionsClosed),
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});
var $e988022f25fc05a7$export$2e2bcd8739ae039 = $e988022f25fc05a7$var$SpeedDial;

});
parcelRegister("3bgTm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $250f8092c3dbdde5$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $dxolJ = parcelRequire("dxolJ");


var $2mnfJ = parcelRequire("2mnfJ");

var $ceSe6 = parcelRequire("ceSe6");

var $5Up1l = parcelRequire("5Up1l");

var $4x3bm = parcelRequire("4x3bm");
const $250f8092c3dbdde5$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $250f8092c3dbdde5$var$styles = {
    entering: {
        transform: "none"
    },
    entered: {
        transform: "none"
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/components/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $250f8092c3dbdde5$var$Zoom = /*#__PURE__*/ $70fFQ.forwardRef(function Zoom(props, ref) {
    const theme = (0, $2mnfJ.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $dxolJ.default) } = props, other = (0, $79yYo.default)(props, $250f8092c3dbdde5$var$_excluded);
    const nodeRef = $70fFQ.useRef(null);
    const foreignRef = (0, $5Up1l.default)(children.ref, ref);
    const handleRef = (0, $5Up1l.default)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $ceSe6.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $ceSe6.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $70fFQ.cloneElement(children, (0, $20MOv.default)({
                style: (0, $20MOv.default)({
                    transform: "scale(0)",
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $250f8092c3dbdde5$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $250f8092c3dbdde5$export$2e2bcd8739ae039 = $250f8092c3dbdde5$var$Zoom;

});

parcelRegister("jNZi4", function(module, exports) {

$parcel$export(module.exports, "getSpeedDialUtilityClass", function () { return $e6b222f15861dd96$export$b96222ae71926780; });
$parcel$export(module.exports, "default", function () { return $e6b222f15861dd96$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $e6b222f15861dd96$export$b96222ae71926780(slot) {
    return (0, $dtsUs.default)("MuiSpeedDial", slot);
}
const $e6b222f15861dd96$var$speedDialClasses = (0, $jLqVN.default)("MuiSpeedDial", [
    "root",
    "fab",
    "directionUp",
    "directionDown",
    "directionLeft",
    "directionRight",
    "actions",
    "actionsClosed"
]);
var $e6b222f15861dd96$export$2e2bcd8739ae039 = $e6b222f15861dd96$var$speedDialClasses;

});


parcelRegister("jTjNP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7b283c36b1f6c4a$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $2OCa7 = parcelRequire("2OCa7");

var $PjeUW = parcelRequire("PjeUW");

var $aAAPW = parcelRequire("aAAPW");

var $1wlCp = parcelRequire("1wlCp");

var $4x3bm = parcelRequire("4x3bm");
const $e7b283c36b1f6c4a$var$_excluded = [
    "className",
    "delay",
    "FabProps",
    "icon",
    "id",
    "open",
    "TooltipClasses",
    "tooltipOpen",
    "tooltipPlacement",
    "tooltipTitle"
];
const $e7b283c36b1f6c4a$var$useUtilityClasses = (ownerState)=>{
    const { open: open, tooltipPlacement: tooltipPlacement, classes: classes } = ownerState;
    const slots = {
        fab: [
            "fab",
            !open && "fabClosed"
        ],
        staticTooltip: [
            "staticTooltip",
            `tooltipPlacement${(0, $aAAPW.default)(tooltipPlacement)}`,
            !open && "staticTooltipClosed"
        ],
        staticTooltipLabel: [
            "staticTooltipLabel"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $1wlCp.getSpeedDialActionUtilityClass), classes);
};
const $e7b283c36b1f6c4a$var$SpeedDialActionFab = (0, $71Pr4.default)((0, $2OCa7.default), {
    name: "MuiSpeedDialAction",
    slot: "Fab",
    skipVariantsResolver: false,
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.fab,
            !ownerState.open && styles.fabClosed
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        margin: 8,
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
            backgroundColor: (0, $bFVgt.emphasize)(theme.palette.background.paper, 0.15)
        },
        transition: `${theme.transitions.create("transform", {
            duration: theme.transitions.duration.shorter
        })}, opacity 0.8s`,
        opacity: 1
    }, !ownerState.open && {
        opacity: 0,
        transform: "scale(0)"
    }));
const $e7b283c36b1f6c4a$var$SpeedDialActionStaticTooltip = (0, $71Pr4.default)("span", {
    name: "MuiSpeedDialAction",
    slot: "StaticTooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.staticTooltip,
            !ownerState.open && styles.staticTooltipClosed,
            styles[`tooltipPlacement${(0, $aAAPW.default)(ownerState.tooltipPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        [`& .${(0, $1wlCp.default).staticTooltipLabel}`]: (0, $20MOv.default)({
            transition: theme.transitions.create([
                "transform",
                "opacity"
            ], {
                duration: theme.transitions.duration.shorter
            }),
            opacity: 1
        }, !ownerState.open && {
            opacity: 0,
            transform: "scale(0.5)"
        }, ownerState.tooltipPlacement === "left" && {
            transformOrigin: "100% 50%",
            right: "100%",
            marginRight: 8
        }, ownerState.tooltipPlacement === "right" && {
            transformOrigin: "0% 50%",
            left: "100%",
            marginLeft: 8
        })
    }));
const $e7b283c36b1f6c4a$var$SpeedDialActionStaticTooltipLabel = (0, $71Pr4.default)("span", {
    name: "MuiSpeedDialAction",
    slot: "StaticTooltipLabel",
    overridesResolver: (props, styles)=>styles.staticTooltipLabel
})(({ theme: theme })=>(0, $20MOv.default)({
        position: "absolute"
    }, theme.typography.body1, {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
        color: theme.palette.text.secondary,
        padding: "4px 16px",
        wordBreak: "keep-all"
    }));
const $e7b283c36b1f6c4a$var$SpeedDialAction = /*#__PURE__*/ $70fFQ.forwardRef(function SpeedDialAction(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiSpeedDialAction"
    });
    const { className: className, delay: delay = 0, FabProps: FabProps = {}, icon: icon, id: id, open: open, TooltipClasses: TooltipClasses, tooltipOpen: tooltipOpenProp = false, tooltipPlacement: tooltipPlacement = "left", tooltipTitle: tooltipTitle } = props, other = (0, $79yYo.default)(props, $e7b283c36b1f6c4a$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        tooltipPlacement: tooltipPlacement
    });
    const classes = $e7b283c36b1f6c4a$var$useUtilityClasses(ownerState);
    const [tooltipOpen, setTooltipOpen] = $70fFQ.useState(tooltipOpenProp);
    const handleTooltipClose = ()=>{
        setTooltipOpen(false);
    };
    const handleTooltipOpen = ()=>{
        setTooltipOpen(true);
    };
    const transitionStyle = {
        transitionDelay: `${delay}ms`
    };
    const fab = /*#__PURE__*/ (0, $4x3bm.jsx)($e7b283c36b1f6c4a$var$SpeedDialActionFab, (0, $20MOv.default)({
        size: "small",
        className: (0, $gjktY.default)(classes.fab, className),
        tabIndex: -1,
        role: "menuitem",
        ownerState: ownerState
    }, FabProps, {
        style: (0, $20MOv.default)({}, transitionStyle, FabProps.style),
        children: icon
    }));
    if (tooltipOpenProp) return /*#__PURE__*/ (0, $4x3bm.jsxs)($e7b283c36b1f6c4a$var$SpeedDialActionStaticTooltip, (0, $20MOv.default)({
        id: id,
        ref: ref,
        className: classes.staticTooltip,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($e7b283c36b1f6c4a$var$SpeedDialActionStaticTooltipLabel, {
                style: transitionStyle,
                id: `${id}-label`,
                className: classes.staticTooltipLabel,
                ownerState: ownerState,
                children: tooltipTitle
            }),
            /*#__PURE__*/ $70fFQ.cloneElement(fab, {
                "aria-labelledby": `${id}-label`
            })
        ]
    }));
    if (!open && tooltipOpen) setTooltipOpen(false);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $PjeUW.default), (0, $20MOv.default)({
        id: id,
        ref: ref,
        title: tooltipTitle,
        placement: tooltipPlacement,
        onClose: handleTooltipClose,
        onOpen: handleTooltipOpen,
        open: open && tooltipOpen,
        classes: TooltipClasses
    }, other, {
        children: fab
    }));
});
var $e7b283c36b1f6c4a$export$2e2bcd8739ae039 = $e7b283c36b1f6c4a$var$SpeedDialAction;

});
parcelRegister("PjeUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09a3b01e94f5d261$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $3GrfC = parcelRequire("3GrfC");
var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $71Pr4 = parcelRequire("71Pr4");

var $2mnfJ = parcelRequire("2mnfJ");

var $cNmNk = parcelRequire("cNmNk");

var $aAAPW = parcelRequire("aAAPW");

var $54wpe = parcelRequire("54wpe");

var $4gFK1 = parcelRequire("4gFK1");

var $duaP9 = parcelRequire("duaP9");

var $5Up1l = parcelRequire("5Up1l");

var $57DGY = parcelRequire("57DGY");

var $kdx2B = parcelRequire("kdx2B");

var $6Apvh = parcelRequire("6Apvh");

var $5d11d = parcelRequire("5d11d");

var $4x3bm = parcelRequire("4x3bm");
const $09a3b01e94f5d261$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $09a3b01e94f5d261$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $09a3b01e94f5d261$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $aAAPW.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $5d11d.getTooltipUtilityClass), classes);
};
const $09a3b01e94f5d261$var$TooltipPopper = (0, $71Pr4.default)((0, $4gFK1.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $20MOv.default)({
        zIndex: theme.zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $5d11d.default).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $5d11d.default).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $5d11d.default).arrow}`]: (0, $20MOv.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $5d11d.default).arrow}`]: (0, $20MOv.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $09a3b01e94f5d261$var$TooltipTooltip = (0, $71Pr4.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $aAAPW.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        backgroundColor: (0, $bFVgt.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$09a3b01e94f5d261$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $5d11d.default).popper}[data-popper-placement*="left"] &`]: (0, $20MOv.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $20MOv.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $20MOv.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $5d11d.default).popper}[data-popper-placement*="right"] &`]: (0, $20MOv.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $20MOv.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $20MOv.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $5d11d.default).popper}[data-popper-placement*="top"] &`]: (0, $20MOv.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $5d11d.default).popper}[data-popper-placement*="bottom"] &`]: (0, $20MOv.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $09a3b01e94f5d261$var$TooltipArrow = (0, $71Pr4.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em",
        boxSizing: "border-box",
        color: (0, $bFVgt.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $09a3b01e94f5d261$var$hystersisOpen = false;
let $09a3b01e94f5d261$var$hystersisTimer = null;
function $09a3b01e94f5d261$export$b9ee5a7ace0541f8() {
    $09a3b01e94f5d261$var$hystersisOpen = false;
    clearTimeout($09a3b01e94f5d261$var$hystersisTimer);
}
function $09a3b01e94f5d261$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
} // TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $09a3b01e94f5d261$var$Tooltip = /*#__PURE__*/ $70fFQ.forwardRef(function Tooltip(inProps, ref) {
    var _components$Popper, _ref, _components$Transitio, _components$Tooltip, _components$Arrow, _componentsProps$popp;
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: children, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $54wpe.default), TransitionProps: TransitionProps } = props, other = (0, $79yYo.default)(props, $09a3b01e94f5d261$var$_excluded);
    const theme = (0, $2mnfJ.default)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $70fFQ.useState();
    const [arrowRef, setArrowRef] = $70fFQ.useState(null);
    const ignoreNonTouchEvents = $70fFQ.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $70fFQ.useRef();
    const enterTimer = $70fFQ.useRef();
    const leaveTimer = $70fFQ.useRef();
    const touchTimer = $70fFQ.useRef();
    const [openState, setOpenState] = (0, $6Apvh.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $57DGY.default)(idProp);
    const prevUserSelect = $70fFQ.useRef();
    const stopTouchInteraction = $70fFQ.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $70fFQ.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($09a3b01e94f5d261$var$hystersisTimer);
        $09a3b01e94f5d261$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $duaP9.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($09a3b01e94f5d261$var$hystersisTimer);
        $09a3b01e94f5d261$var$hystersisTimer = setTimeout(()=>{
            $09a3b01e94f5d261$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
         // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $09a3b01e94f5d261$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $09a3b01e94f5d261$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $kdx2B.default)(); // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $70fFQ.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect; // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $70fFQ.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleUseRef = (0, $5Up1l.default)(setChildNode, ref);
    const handleFocusRef = (0, $5Up1l.default)(focusVisibleRef, handleUseRef);
    const handleRef = (0, $5Up1l.default)(children.ref, handleFocusRef); // There is no point in displaying an empty tooltip.
    if (title === "") open = false;
    const positionRef = $70fFQ.useRef({
        x: 0,
        y: 0
    });
    const popperRef = $70fFQ.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        positionRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $20MOv.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $gjktY.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $09a3b01e94f5d261$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $09a3b01e94f5d261$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $09a3b01e94f5d261$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $09a3b01e94f5d261$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $70fFQ.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $20MOv.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $20MOv.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $09a3b01e94f5d261$var$useUtilityClasses(ownerState);
    const PopperComponent = (_components$Popper = components.Popper) != null ? _components$Popper : $09a3b01e94f5d261$var$TooltipPopper;
    const TransitionComponent = (_ref = (_components$Transitio = components.Transition) != null ? _components$Transitio : TransitionComponentProp) != null ? _ref : (0, $54wpe.default);
    const TooltipComponent = (_components$Tooltip = components.Tooltip) != null ? _components$Tooltip : $09a3b01e94f5d261$var$TooltipTooltip;
    const ArrowComponent = (_components$Arrow = components.Arrow) != null ? _components$Arrow : $09a3b01e94f5d261$var$TooltipArrow;
    const popperProps = (0, $3GrfC.default)(PopperComponent, (0, $20MOv.default)({}, PopperProps, componentsProps.popper), ownerState);
    const transitionProps = (0, $3GrfC.default)(TransitionComponent, (0, $20MOv.default)({}, TransitionProps, componentsProps.transition), ownerState);
    const tooltipProps = (0, $3GrfC.default)(TooltipComponent, (0, $20MOv.default)({}, componentsProps.tooltip), ownerState);
    const tooltipArrowProps = (0, $3GrfC.default)(ArrowComponent, (0, $20MOv.default)({}, componentsProps.arrow), ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            /*#__PURE__*/ $70fFQ.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $4x3bm.jsx)(PopperComponent, (0, $20MOv.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $4gFK1.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: positionRef.current.y,
                            left: positionRef.current.x,
                            right: positionRef.current.x,
                            bottom: positionRef.current.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                className: (0, $gjktY.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_componentsProps$popp = componentsProps.popper) == null ? void 0 : _componentsProps$popp.className),
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>{
                    var _componentsProps$tool, _componentsProps$arro;
                    return /*#__PURE__*/ (0, $4x3bm.jsx)(TransitionComponent, (0, $20MOv.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $4x3bm.jsxs)(TooltipComponent, (0, $20MOv.default)({}, tooltipProps, {
                            className: (0, $gjktY.default)(classes.tooltip, (_componentsProps$tool = componentsProps.tooltip) == null ? void 0 : _componentsProps$tool.className),
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $4x3bm.jsx)(ArrowComponent, (0, $20MOv.default)({}, tooltipArrowProps, {
                                    className: (0, $gjktY.default)(classes.arrow, (_componentsProps$arro = componentsProps.arrow) == null ? void 0 : _componentsProps$arro.className),
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }));
                }
            }))
        ]
    });
});
var $09a3b01e94f5d261$export$2e2bcd8739ae039 = $09a3b01e94f5d261$var$Tooltip;

});
parcelRegister("4gFK1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31b908fad70cd570$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $5YW3o = parcelRequire("5YW3o");

var $g7YYH = parcelRequire("g7YYH");



var $70fFQ = parcelRequire("70fFQ");

var $71Pr4 = parcelRequire("71Pr4");
var $cNmNk = parcelRequire("cNmNk");

var $4x3bm = parcelRequire("4x3bm");
const $31b908fad70cd570$var$PopperRoot = (0, $71Pr4.default)((0, $5YW3o.default), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/components/autocomplete/)
 * - [Menus](https://mui.com/components/menus/)
 * - [Popper](https://mui.com/components/popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/api/popper/)
 */ const $31b908fad70cd570$var$Popper = /*#__PURE__*/ $70fFQ.forwardRef(function Popper(inProps, ref) {
    const theme = (0, $g7YYH.default)();
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiPopper"
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)($31b908fad70cd570$var$PopperRoot, (0, $20MOv.default)({
        direction: theme == null ? void 0 : theme.direction
    }, props, {
        ref: ref
    }));
});
var $31b908fad70cd570$export$2e2bcd8739ae039 = $31b908fad70cd570$var$Popper;

});
parcelRegister("5YW3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45af96a0efa91609$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $iMBVa = parcelRequire("iMBVa");
var $qEgbK = parcelRequire("qEgbK");
var $4Rshd = parcelRequire("4Rshd");

var $2jtLr = parcelRequire("2jtLr");


var $70fFQ = parcelRequire("70fFQ");

var $7niyo = parcelRequire("7niyo");

var $4x3bm = parcelRequire("4x3bm");
const $45af96a0efa91609$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "ownerState",
    "placement",
    "popperOptions",
    "popperRef",
    "TransitionProps"
], $45af96a0efa91609$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition"
];
function $45af96a0efa91609$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $45af96a0efa91609$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $45af96a0efa91609$var$defaultPopperOptions = {};
/* eslint-disable react/prop-types */ const $45af96a0efa91609$var$PopperTooltip = /*#__PURE__*/ $70fFQ.forwardRef(function PopperTooltip(props, ref) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, TransitionProps: TransitionProps } = props, other = (0, $79yYo.default)(props, $45af96a0efa91609$var$_excluded);
    const tooltipRef = $70fFQ.useRef(null);
    const ownRef = (0, $4Rshd.default)(tooltipRef, ref);
    const popperRef = $70fFQ.useRef(null);
    const handlePopperRef = (0, $4Rshd.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $70fFQ.useRef(handlePopperRef);
    (0, $qEgbK.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $70fFQ.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $45af96a0efa91609$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $70fFQ.useState(rtlPlacement);
    $70fFQ.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    (0, $qEgbK.default)(()=>{
        if (!anchorEl || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        const resolvedAnchorEl = $45af96a0efa91609$var$resolveAnchorEl(anchorEl);
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $2jtLr.createPopper)($45af96a0efa91609$var$resolveAnchorEl(anchorEl), tooltipRef.current, (0, $20MOv.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", (0, $20MOv.default)({
        ref: ownRef,
        role: "tooltip"
    }, other, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/* eslint-enable react/prop-types */ /**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 */ const $45af96a0efa91609$var$PopperUnstyled = /*#__PURE__*/ $70fFQ.forwardRef(function PopperUnstyled(props, ref) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $45af96a0efa91609$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false } = props, other = (0, $79yYo.default)(props, $45af96a0efa91609$var$_excluded2);
    const [exited, setExited] = $70fFQ.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $iMBVa.default)($45af96a0efa91609$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7niyo.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($45af96a0efa91609$var$PopperTooltip, (0, $20MOv.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: ref,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef
        }, other, {
            style: (0, $20MOv.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: !open && keepMounted && (!transition || exited) ? "none" : null
            }, style),
            TransitionProps: transition ? {
                in: open,
                onEnter: handleEnter,
                onExited: handleExited
            } : null,
            children: children
        }))
    });
});
var $45af96a0efa91609$export$2e2bcd8739ae039 = $45af96a0efa91609$var$PopperUnstyled;

});
parcelRegister("2jtLr", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $1af471aecf9ace0a$export$8f7491d57c8f97a9; });

var $kRZeO = parcelRequire("kRZeO");

var $fywMH = parcelRequire("fywMH");

var $hgQTv = parcelRequire("hgQTv");

var $eca9B = parcelRequire("eca9B");

var $imyhn = parcelRequire("imyhn");

var $1xRdy = parcelRequire("1xRdy");

var $laP4i = parcelRequire("laP4i");

var $x5HiO = parcelRequire("x5HiO");

var $b31EC = parcelRequire("b31EC");

var $2sHk8 = parcelRequire("2sHk8");


var $1af471aecf9ace0a$export$d34966752335dd47 = [
    (0, $fywMH.default),
    (0, $hgQTv.default),
    (0, $eca9B.default),
    (0, $imyhn.default),
    (0, $1xRdy.default),
    (0, $laP4i.default),
    (0, $x5HiO.default),
    (0, $b31EC.default),
    (0, $2sHk8.default)
];
var $1af471aecf9ace0a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $kRZeO.popperGenerator)({
    defaultModifiers: $1af471aecf9ace0a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("kRZeO", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $f318427903714b14$export$ed5e13716264f202; });

var $ga7P4 = parcelRequire("ga7P4");

var $h10ij = parcelRequire("h10ij");

var $2U2JL = parcelRequire("2U2JL");

var $fYtF7 = parcelRequire("fYtF7");


var $8fTgU = parcelRequire("8fTgU");

var $ds7lB = parcelRequire("ds7lB");




var $ixkoV = parcelRequire("ixkoV");


var $eZK2V = parcelRequire("eZK2V");

var $f318427903714b14$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $f318427903714b14$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $f318427903714b14$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $f318427903714b14$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $f318427903714b14$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $f318427903714b14$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $f318427903714b14$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $eZK2V.isElement)(reference) ? (0, $2U2JL.default)(reference) : reference.contextElement ? (0, $2U2JL.default)(reference.contextElement) : [],
                    popper: (0, $2U2JL.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8fTgU.default)((0, $ixkoV.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$f318427903714b14$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ga7P4.default)(reference, (0, $fYtF7.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $h10ij.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $ds7lB.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$f318427903714b14$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $f318427903714b14$export$8f7491d57c8f97a9 = /*#__PURE__*/ $f318427903714b14$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("ga7P4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc43a5f6d7ff87f3$export$2e2bcd8739ae039; });

var $59k2D = parcelRequire("59k2D");

var $2OT45 = parcelRequire("2OT45");

var $9whjR = parcelRequire("9whjR");

var $eZK2V = parcelRequire("eZK2V");

var $4IHcu = parcelRequire("4IHcu");

var $9kVLf = parcelRequire("9kVLf");

var $hORg4 = parcelRequire("hORg4");

var $lHtx5 = parcelRequire("lHtx5");
function $bc43a5f6d7ff87f3$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $lHtx5.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $lHtx5.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bc43a5f6d7ff87f3$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $eZK2V.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $eZK2V.isHTMLElement)(offsetParent) && $bc43a5f6d7ff87f3$var$isElementScaled(offsetParent);
    var documentElement = (0, $9kVLf.default)(offsetParent);
    var rect = (0, $59k2D.default)(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9whjR.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $hORg4.default)(documentElement)) scroll = (0, $2OT45.default)(offsetParent);
        if ((0, $eZK2V.isHTMLElement)(offsetParent)) {
            offsets = (0, $59k2D.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $4IHcu.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("59k2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bfd56d2e5bd175a$export$2e2bcd8739ae039; });

var $eZK2V = parcelRequire("eZK2V");

var $lHtx5 = parcelRequire("lHtx5");
function $3bfd56d2e5bd175a$export$2e2bcd8739ae039(element, includeScale) {
    if (includeScale === void 0) includeScale = false;
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if ((0, $eZK2V.isHTMLElement)(element) && includeScale) {
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        // Fallback to 1 in case both values are `0`
        if (offsetWidth > 0) scaleX = (0, $lHtx5.round)(rect.width) / offsetWidth || 1;
        if (offsetHeight > 0) scaleY = (0, $lHtx5.round)(rect.height) / offsetHeight || 1;
    }
    return {
        width: rect.width / scaleX,
        height: rect.height / scaleY,
        top: rect.top / scaleY,
        right: rect.right / scaleX,
        bottom: rect.bottom / scaleY,
        left: rect.left / scaleX,
        x: rect.left / scaleX,
        y: rect.top / scaleY
    };
}

});
parcelRegister("eZK2V", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $aeaa7afe5d866276$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $aeaa7afe5d866276$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $aeaa7afe5d866276$export$af51f0f06c0f328a; });

var $jlYCn = parcelRequire("jlYCn");
function $aeaa7afe5d866276$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jlYCn.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $aeaa7afe5d866276$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jlYCn.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $aeaa7afe5d866276$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $jlYCn.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jlYCn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e16efff5c22d20d7$export$2e2bcd8739ae039; });
function $e16efff5c22d20d7$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("lHtx5", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $fcc485b496584521$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $fcc485b496584521$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $fcc485b496584521$export$2077e0241d6afd3c; });
var $fcc485b496584521$export$8960430cfd85939f = Math.max;
var $fcc485b496584521$export$96ec731ed4dcb222 = Math.min;
var $fcc485b496584521$export$2077e0241d6afd3c = Math.round;

});


parcelRegister("2OT45", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20daf7092198b12d$export$2e2bcd8739ae039; });

var $kpt5l = parcelRequire("kpt5l");

var $jlYCn = parcelRequire("jlYCn");

var $eZK2V = parcelRequire("eZK2V");

var $arJtW = parcelRequire("arJtW");
function $20daf7092198b12d$export$2e2bcd8739ae039(node) {
    if (node === (0, $jlYCn.default)(node) || !(0, $eZK2V.isHTMLElement)(node)) return (0, $kpt5l.default)(node);
    else return (0, $arJtW.default)(node);
}

});
parcelRegister("kpt5l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edbcb42870cc6fff$export$2e2bcd8739ae039; });

var $jlYCn = parcelRequire("jlYCn");
function $edbcb42870cc6fff$export$2e2bcd8739ae039(node) {
    var win = (0, $jlYCn.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("arJtW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79afb4c50bbbcc76$export$2e2bcd8739ae039; });
function $79afb4c50bbbcc76$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("9whjR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ee4897ba80cb3ab$export$2e2bcd8739ae039; });
function $6ee4897ba80cb3ab$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("4IHcu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36fcc83342ccb4d6$export$2e2bcd8739ae039; });

var $59k2D = parcelRequire("59k2D");

var $9kVLf = parcelRequire("9kVLf");

var $kpt5l = parcelRequire("kpt5l");
function $36fcc83342ccb4d6$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $59k2D.default)((0, $9kVLf.default)(element)).left + (0, $kpt5l.default)(element).scrollLeft;
}

});
parcelRegister("9kVLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cc2c971223d248d$export$2e2bcd8739ae039; });

var $eZK2V = parcelRequire("eZK2V");
function $6cc2c971223d248d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $eZK2V.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("hORg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf906b2099589713$export$2e2bcd8739ae039; });

var $56wbW = parcelRequire("56wbW");
function $cf906b2099589713$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $56wbW.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("56wbW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b767be23543f4c2$export$2e2bcd8739ae039; });

var $jlYCn = parcelRequire("jlYCn");
function $3b767be23543f4c2$export$2e2bcd8739ae039(element) {
    return (0, $jlYCn.default)(element).getComputedStyle(element);
}

});



parcelRegister("h10ij", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c632c221e93fe404$export$2e2bcd8739ae039; });

var $59k2D = parcelRequire("59k2D");
function $c632c221e93fe404$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $59k2D.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2U2JL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21d2ef41b96029fb$export$2e2bcd8739ae039; });

var $cnbZ7 = parcelRequire("cnbZ7");

var $b9wiu = parcelRequire("b9wiu");

var $jlYCn = parcelRequire("jlYCn");

var $hORg4 = parcelRequire("hORg4");
function $21d2ef41b96029fb$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $cnbZ7.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jlYCn.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $hORg4.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($21d2ef41b96029fb$export$2e2bcd8739ae039((0, $b9wiu.default)(target)));
}

});
parcelRegister("cnbZ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9020edf82f5d52a3$export$2e2bcd8739ae039; });

var $b9wiu = parcelRequire("b9wiu");

var $hORg4 = parcelRequire("hORg4");

var $9whjR = parcelRequire("9whjR");

var $eZK2V = parcelRequire("eZK2V");
function $9020edf82f5d52a3$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $9whjR.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $eZK2V.isHTMLElement)(node) && (0, $hORg4.default)(node)) return node;
    return $9020edf82f5d52a3$export$2e2bcd8739ae039((0, $b9wiu.default)(node));
}

});
parcelRegister("b9wiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81e9968408ca9073$export$2e2bcd8739ae039; });

var $9whjR = parcelRequire("9whjR");

var $9kVLf = parcelRequire("9kVLf");

var $eZK2V = parcelRequire("eZK2V");
function $81e9968408ca9073$export$2e2bcd8739ae039(element) {
    if ((0, $9whjR.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $eZK2V.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9kVLf.default)(element) // fallback
    );
}

});



parcelRegister("fYtF7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba1377e60b0da9e7$export$2e2bcd8739ae039; });

var $jlYCn = parcelRequire("jlYCn");

var $9whjR = parcelRequire("9whjR");

var $56wbW = parcelRequire("56wbW");

var $eZK2V = parcelRequire("eZK2V");

var $VCAX3 = parcelRequire("VCAX3");

var $b9wiu = parcelRequire("b9wiu");
function $ba1377e60b0da9e7$var$getTrueOffsetParent(element) {
    if (!(0, $eZK2V.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $56wbW.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $ba1377e60b0da9e7$var$getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
    var isIE = navigator.userAgent.indexOf("Trident") !== -1;
    if (isIE && (0, $eZK2V.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $56wbW.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $b9wiu.default)(element);
    if ((0, $eZK2V.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $eZK2V.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $9whjR.default)(currentNode)) < 0){
        var css = (0, $56wbW.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $ba1377e60b0da9e7$export$2e2bcd8739ae039(element) {
    var window = (0, $jlYCn.default)(element);
    var offsetParent = $ba1377e60b0da9e7$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $VCAX3.default)(offsetParent) && (0, $56wbW.default)(offsetParent).position === "static")offsetParent = $ba1377e60b0da9e7$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $9whjR.default)(offsetParent) === "html" || (0, $9whjR.default)(offsetParent) === "body" && (0, $56wbW.default)(offsetParent).position === "static")) return window;
    return offsetParent || $ba1377e60b0da9e7$var$getContainingBlock(element) || window;
}

});
parcelRegister("VCAX3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ad34325a265e731$export$2e2bcd8739ae039; });

var $9whjR = parcelRequire("9whjR");
function $0ad34325a265e731$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $9whjR.default)(element)) >= 0;
}

});


parcelRegister("8fTgU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $602a9947aed2adea$export$2e2bcd8739ae039; });

var $4iOh5 = parcelRequire("4iOh5");
function $602a9947aed2adea$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $602a9947aed2adea$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $602a9947aed2adea$var$order(modifiers); // order based on phase
    return (0, $4iOh5.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("4iOh5", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $321fd75f967c2757$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $321fd75f967c2757$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $321fd75f967c2757$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $321fd75f967c2757$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $321fd75f967c2757$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $321fd75f967c2757$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $321fd75f967c2757$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $321fd75f967c2757$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $321fd75f967c2757$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $321fd75f967c2757$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $321fd75f967c2757$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $321fd75f967c2757$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $321fd75f967c2757$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $321fd75f967c2757$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $321fd75f967c2757$export$d087d3878fdf71d5; });
var $321fd75f967c2757$export$1e95b668f3b82d = "top";
var $321fd75f967c2757$export$40e543e69a8b3fbb = "bottom";
var $321fd75f967c2757$export$79ffe56a765070d2 = "right";
var $321fd75f967c2757$export$eabcd2c8791e7bf4 = "left";
var $321fd75f967c2757$export$dfb5619354ba860 = "auto";
var $321fd75f967c2757$export$aec2ce47c367b8c3 = [
    $321fd75f967c2757$export$1e95b668f3b82d,
    $321fd75f967c2757$export$40e543e69a8b3fbb,
    $321fd75f967c2757$export$79ffe56a765070d2,
    $321fd75f967c2757$export$eabcd2c8791e7bf4
];
var $321fd75f967c2757$export$b3571188c770cc5a = "start";
var $321fd75f967c2757$export$bd5df0f255a350f8 = "end";
var $321fd75f967c2757$export$390fd549c5303b4d = "clippingParents";
var $321fd75f967c2757$export$d7b7311ec04a3e8f = "viewport";
var $321fd75f967c2757$export$ae5ab1c730825774 = "popper";
var $321fd75f967c2757$export$ca50aac9f3ba507f = "reference";
var $321fd75f967c2757$export$368f9a87e87fa4e1 = /*#__PURE__*/ $321fd75f967c2757$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $321fd75f967c2757$export$b3571188c770cc5a,
        placement + "-" + $321fd75f967c2757$export$bd5df0f255a350f8
    ]);
}, []);
var $321fd75f967c2757$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($321fd75f967c2757$export$aec2ce47c367b8c3, [
    $321fd75f967c2757$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $321fd75f967c2757$export$b3571188c770cc5a,
        placement + "-" + $321fd75f967c2757$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $321fd75f967c2757$export$421679a7c3d56e = "beforeRead";
var $321fd75f967c2757$export$aafa59e2e03f2942 = "read";
var $321fd75f967c2757$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $321fd75f967c2757$export$c65e99957a05207c = "beforeMain";
var $321fd75f967c2757$export$f22da7240b7add18 = "main";
var $321fd75f967c2757$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $321fd75f967c2757$export$8d4d2d70e7d46032 = "beforeWrite";
var $321fd75f967c2757$export$68d8715fc104d294 = "write";
var $321fd75f967c2757$export$70a6e5159acce2e6 = "afterWrite";
var $321fd75f967c2757$export$d087d3878fdf71d5 = [
    $321fd75f967c2757$export$421679a7c3d56e,
    $321fd75f967c2757$export$aafa59e2e03f2942,
    $321fd75f967c2757$export$6964f6c886723980,
    $321fd75f967c2757$export$c65e99957a05207c,
    $321fd75f967c2757$export$f22da7240b7add18,
    $321fd75f967c2757$export$bab79516f2d662fe,
    $321fd75f967c2757$export$8d4d2d70e7d46032,
    $321fd75f967c2757$export$68d8715fc104d294,
    $321fd75f967c2757$export$70a6e5159acce2e6
];

});


parcelRegister("ds7lB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb396f39b6a3155$export$2e2bcd8739ae039; });
function $9cb396f39b6a3155$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("ixkoV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7eb224dd36703b9$export$2e2bcd8739ae039; });
function $d7eb224dd36703b9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("fywMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b53376531176bc40$export$2e2bcd8739ae039; });

var $jlYCn = parcelRequire("jlYCn");
var $b53376531176bc40$var$passive = {
    passive: true
};
function $b53376531176bc40$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jlYCn.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $b53376531176bc40$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $b53376531176bc40$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $b53376531176bc40$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $b53376531176bc40$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $b53376531176bc40$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $b53376531176bc40$var$effect,
    data: {}
};

});

parcelRegister("hgQTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c92cf602852353f3$export$2e2bcd8739ae039; });

var $8iSmh = parcelRequire("8iSmh");
function $c92cf602852353f3$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $8iSmh.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c92cf602852353f3$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $c92cf602852353f3$var$popperOffsets,
    data: {}
};

});
parcelRegister("8iSmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60ba2b9df33c9502$export$2e2bcd8739ae039; });

var $41Xgj = parcelRequire("41Xgj");

var $aydOM = parcelRequire("aydOM");

var $dCdW9 = parcelRequire("dCdW9");

var $4iOh5 = parcelRequire("4iOh5");
function $60ba2b9df33c9502$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $41Xgj.default)(placement) : null;
    var variation = placement ? (0, $aydOM.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $4iOh5.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $4iOh5.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $4iOh5.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $4iOh5.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $dCdW9.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $4iOh5.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $4iOh5.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("41Xgj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ef539a048fd05d7$export$2e2bcd8739ae039; });

function $2ef539a048fd05d7$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("aydOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ae7cc4f5dc5f447$export$2e2bcd8739ae039; });
function $7ae7cc4f5dc5f447$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("dCdW9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e99a292b40dd2cc$export$2e2bcd8739ae039; });
function $9e99a292b40dd2cc$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("eca9B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a55a1005654bffca$export$2e2bcd8739ae039; });

var $4iOh5 = parcelRequire("4iOh5");

var $fYtF7 = parcelRequire("fYtF7");

var $jlYCn = parcelRequire("jlYCn");

var $9kVLf = parcelRequire("9kVLf");

var $56wbW = parcelRequire("56wbW");

var $41Xgj = parcelRequire("41Xgj");

var $aydOM = parcelRequire("aydOM");

var $lHtx5 = parcelRequire("lHtx5");
var $a55a1005654bffca$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $a55a1005654bffca$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $lHtx5.round)(x * dpr) / dpr || 0,
        y: (0, $lHtx5.round)(y * dpr) / dpr || 0
    };
}
function $a55a1005654bffca$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $4iOh5.left);
    var sideY = (0, $4iOh5.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $fYtF7.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $jlYCn.default)(popper)) {
            offsetParent = (0, $9kVLf.default)(popper);
            if ((0, $56wbW.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $4iOh5.top) || (placement === (0, $4iOh5.left) || placement === (0, $4iOh5.right)) && variation === (0, $4iOh5.end)) {
            sideY = (0, $4iOh5.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $4iOh5.left) || (placement === (0, $4iOh5.top) || placement === (0, $4iOh5.bottom)) && variation === (0, $4iOh5.end)) {
            sideX = (0, $4iOh5.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $a55a1005654bffca$var$unsetSides);
    var _ref4 = roundOffsets === true ? $a55a1005654bffca$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $a55a1005654bffca$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $41Xgj.default)(state.placement),
        variation: (0, $aydOM.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $a55a1005654bffca$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $a55a1005654bffca$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a55a1005654bffca$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $a55a1005654bffca$var$computeStyles,
    data: {}
};

});

parcelRegister("imyhn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5e4df37c0f3a41e$export$2e2bcd8739ae039; });

var $9whjR = parcelRequire("9whjR");

var $eZK2V = parcelRequire("eZK2V");
// and applies them to the HTMLElements such as popper and arrow
function $d5e4df37c0f3a41e$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $eZK2V.isHTMLElement)(element) || !(0, $9whjR.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $d5e4df37c0f3a41e$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $eZK2V.isHTMLElement)(element) || !(0, $9whjR.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $d5e4df37c0f3a41e$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $d5e4df37c0f3a41e$var$applyStyles,
    effect: $d5e4df37c0f3a41e$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("1xRdy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1202276990f6209e$export$2e2bcd8739ae039; });

var $41Xgj = parcelRequire("41Xgj");

var $4iOh5 = parcelRequire("4iOh5");
function $1202276990f6209e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $41Xgj.default)(placement);
    var invertDistance = [
        (0, $4iOh5.left),
        (0, $4iOh5.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $4iOh5.left),
        (0, $4iOh5.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $1202276990f6209e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $4iOh5.placements).reduce(function(acc, placement) {
        acc[placement] = $1202276990f6209e$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1202276990f6209e$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $1202276990f6209e$var$offset
};

});

parcelRegister("laP4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6a225419a74ecd3$export$2e2bcd8739ae039; });

var $h4PGz = parcelRequire("h4PGz");

var $41Xgj = parcelRequire("41Xgj");

var $8TqDC = parcelRequire("8TqDC");

var $iO6Nm = parcelRequire("iO6Nm");

var $cKgAp = parcelRequire("cKgAp");

var $4iOh5 = parcelRequire("4iOh5");

var $aydOM = parcelRequire("aydOM");
function $f6a225419a74ecd3$var$getExpandedFallbackPlacements(placement) {
    if ((0, $41Xgj.default)(placement) === (0, $4iOh5.auto)) return [];
    var oppositePlacement = (0, $h4PGz.default)(placement);
    return [
        (0, $8TqDC.default)(placement),
        oppositePlacement,
        (0, $8TqDC.default)(oppositePlacement)
    ];
}
function $f6a225419a74ecd3$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $41Xgj.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $h4PGz.default)(preferredPlacement)
    ] : $f6a225419a74ecd3$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $41Xgj.default)(placement) === (0, $4iOh5.auto) ? (0, $cKgAp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $41Xgj.default)(placement);
        var isStartVariation = (0, $aydOM.default)(placement) === (0, $4iOh5.start);
        var isVertical = [
            (0, $4iOh5.top),
            (0, $4iOh5.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $iO6Nm.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $4iOh5.right) : (0, $4iOh5.left) : isStartVariation ? (0, $4iOh5.bottom) : (0, $4iOh5.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $h4PGz.default)(mainVariationSide);
        var altVariationSide = (0, $h4PGz.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f6a225419a74ecd3$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $f6a225419a74ecd3$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("h4PGz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6eae7182365d75c$export$2e2bcd8739ae039; });
var $c6eae7182365d75c$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $c6eae7182365d75c$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $c6eae7182365d75c$var$hash[matched];
    });
}

});

parcelRegister("8TqDC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67981f883da26597$export$2e2bcd8739ae039; });
var $67981f883da26597$var$hash = {
    start: "end",
    end: "start"
};
function $67981f883da26597$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $67981f883da26597$var$hash[matched];
    });
}

});

parcelRegister("iO6Nm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db122ae0880cd3f8$export$2e2bcd8739ae039; });

var $jkhJb = parcelRequire("jkhJb");

var $9kVLf = parcelRequire("9kVLf");

var $59k2D = parcelRequire("59k2D");

var $8iSmh = parcelRequire("8iSmh");

var $756Tr = parcelRequire("756Tr");

var $4iOh5 = parcelRequire("4iOh5");

var $eZK2V = parcelRequire("eZK2V");

var $bZxeP = parcelRequire("bZxeP");

var $4oVPd = parcelRequire("4oVPd");
function $db122ae0880cd3f8$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $4iOh5.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $4iOh5.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $4iOh5.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $bZxeP.default)(typeof padding !== "number" ? padding : (0, $4oVPd.default)(padding, (0, $4iOh5.basePlacements)));
    var altContext = elementContext === (0, $4iOh5.popper) ? (0, $4iOh5.reference) : (0, $4iOh5.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $jkhJb.default)((0, $eZK2V.isElement)(element) ? element : element.contextElement || (0, $9kVLf.default)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $59k2D.default)(state.elements.reference);
    var popperOffsets = (0, $8iSmh.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $756Tr.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $4iOh5.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $4iOh5.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $4iOh5.right),
                (0, $4iOh5.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $4iOh5.top),
                (0, $4iOh5.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("jkhJb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e11da2efe086e5dd$export$2e2bcd8739ae039; });

var $4iOh5 = parcelRequire("4iOh5");

var $jPJuz = parcelRequire("jPJuz");

var $fYlkx = parcelRequire("fYlkx");

var $2U2JL = parcelRequire("2U2JL");

var $fYtF7 = parcelRequire("fYtF7");

var $9kVLf = parcelRequire("9kVLf");

var $56wbW = parcelRequire("56wbW");

var $eZK2V = parcelRequire("eZK2V");

var $59k2D = parcelRequire("59k2D");

var $b9wiu = parcelRequire("b9wiu");

var $jafkk = parcelRequire("jafkk");

var $9whjR = parcelRequire("9whjR");

var $756Tr = parcelRequire("756Tr");

var $lHtx5 = parcelRequire("lHtx5");
function $e11da2efe086e5dd$var$getInnerBoundingClientRect(element) {
    var rect = (0, $59k2D.default)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $e11da2efe086e5dd$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $4iOh5.viewport) ? (0, $756Tr.default)((0, $jPJuz.default)(element)) : (0, $eZK2V.isElement)(clippingParent) ? $e11da2efe086e5dd$var$getInnerBoundingClientRect(clippingParent) : (0, $756Tr.default)((0, $fYlkx.default)((0, $9kVLf.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $e11da2efe086e5dd$var$getClippingParents(element) {
    var clippingParents = (0, $2U2JL.default)((0, $b9wiu.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $56wbW.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $eZK2V.isHTMLElement)(element) ? (0, $fYtF7.default)(element) : element;
    if (!(0, $eZK2V.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $eZK2V.isElement)(clippingParent) && (0, $jafkk.default)(clippingParent, clipperElement) && (0, $9whjR.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $e11da2efe086e5dd$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === "clippingParents" ? $e11da2efe086e5dd$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $e11da2efe086e5dd$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = (0, $lHtx5.max)(rect.top, accRect.top);
        accRect.right = (0, $lHtx5.min)(rect.right, accRect.right);
        accRect.bottom = (0, $lHtx5.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $lHtx5.max)(rect.left, accRect.left);
        return accRect;
    }, $e11da2efe086e5dd$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("jPJuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7061185da00c4de$export$2e2bcd8739ae039; });

var $jlYCn = parcelRequire("jlYCn");

var $9kVLf = parcelRequire("9kVLf");

var $4IHcu = parcelRequire("4IHcu");
function $e7061185da00c4de$export$2e2bcd8739ae039(element) {
    var win = (0, $jlYCn.default)(element);
    var html = (0, $9kVLf.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $4IHcu.default)(element),
        y: y
    };
}

});

parcelRegister("fYlkx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0d01600f364033$export$2e2bcd8739ae039; });

var $9kVLf = parcelRequire("9kVLf");

var $56wbW = parcelRequire("56wbW");

var $4IHcu = parcelRequire("4IHcu");

var $kpt5l = parcelRequire("kpt5l");

var $lHtx5 = parcelRequire("lHtx5");
function $ba0d01600f364033$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9kVLf.default)(element);
    var winScroll = (0, $kpt5l.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $lHtx5.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $lHtx5.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $4IHcu.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $56wbW.default)(body || html).direction === "rtl") x += (0, $lHtx5.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("jafkk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df3ad713b18ab7a6$export$2e2bcd8739ae039; });

var $eZK2V = parcelRequire("eZK2V");
function $df3ad713b18ab7a6$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $eZK2V.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("756Tr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $527e58e4caa35fad$export$2e2bcd8739ae039; });
function $527e58e4caa35fad$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("bZxeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8baf2ca582af9e72$export$2e2bcd8739ae039; });

var $7FOfq = parcelRequire("7FOfq");
function $8baf2ca582af9e72$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $7FOfq.default)(), paddingObject);
}

});
parcelRegister("7FOfq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $596356eb98a09eec$export$2e2bcd8739ae039; });
function $596356eb98a09eec$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4oVPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3346422f3e3bc175$export$2e2bcd8739ae039; });
function $3346422f3e3bc175$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cKgAp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9476a59982347d28$export$2e2bcd8739ae039; });

var $aydOM = parcelRequire("aydOM");

var $4iOh5 = parcelRequire("4iOh5");

var $iO6Nm = parcelRequire("iO6Nm");

var $41Xgj = parcelRequire("41Xgj");
function $9476a59982347d28$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $4iOh5.placements) : _options$allowedAutoP;
    var variation = (0, $aydOM.default)(placement);
    var placements = variation ? flipVariations ? (0, $4iOh5.variationPlacements) : (0, $4iOh5.variationPlacements).filter(function(placement) {
        return (0, $aydOM.default)(placement) === variation;
    }) : (0, $4iOh5.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $iO6Nm.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $41Xgj.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("x5HiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0637809265926183$export$2e2bcd8739ae039; });

var $4iOh5 = parcelRequire("4iOh5");

var $41Xgj = parcelRequire("41Xgj");

var $dCdW9 = parcelRequire("dCdW9");

var $hkHoJ = parcelRequire("hkHoJ");

var $9cg45 = parcelRequire("9cg45");

var $h10ij = parcelRequire("h10ij");

var $fYtF7 = parcelRequire("fYtF7");

var $iO6Nm = parcelRequire("iO6Nm");

var $aydOM = parcelRequire("aydOM");

var $7FOfq = parcelRequire("7FOfq");

var $lHtx5 = parcelRequire("lHtx5");
function $0637809265926183$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $iO6Nm.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $41Xgj.default)(state.placement);
    var variation = (0, $aydOM.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $dCdW9.default)(basePlacement);
    var altAxis = (0, $hkHoJ.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $4iOh5.top) : (0, $4iOh5.left);
        var altSide = mainAxis === "y" ? (0, $4iOh5.bottom) : (0, $4iOh5.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $4iOh5.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $4iOh5.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $h10ij.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $7FOfq.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $9cg45.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $fYtF7.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $9cg45.within)(tether ? (0, $lHtx5.min)(min, tetherMin) : min, offset, tether ? (0, $lHtx5.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $4iOh5.top) : (0, $4iOh5.left);
        var _altSide = mainAxis === "x" ? (0, $4iOh5.bottom) : (0, $4iOh5.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $4iOh5.top),
            (0, $4iOh5.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $9cg45.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $9cg45.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0637809265926183$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $0637809265926183$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("hkHoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9e5f7d3fc93c462$export$2e2bcd8739ae039; });
function $c9e5f7d3fc93c462$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("9cg45", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $6b21b22dfdf2c4e2$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $6b21b22dfdf2c4e2$export$86c8af6d3ef0b4a; });

var $lHtx5 = parcelRequire("lHtx5");
function $6b21b22dfdf2c4e2$export$f28d906d67a997f3(min, value, max) {
    return (0, $lHtx5.max)(min, (0, $lHtx5.min)(value, max));
}
function $6b21b22dfdf2c4e2$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $6b21b22dfdf2c4e2$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("b31EC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80b141fb78ce6527$export$2e2bcd8739ae039; });

var $41Xgj = parcelRequire("41Xgj");

var $h10ij = parcelRequire("h10ij");

var $jafkk = parcelRequire("jafkk");

var $fYtF7 = parcelRequire("fYtF7");

var $dCdW9 = parcelRequire("dCdW9");

var $9cg45 = parcelRequire("9cg45");

var $bZxeP = parcelRequire("bZxeP");

var $4oVPd = parcelRequire("4oVPd");

var $4iOh5 = parcelRequire("4iOh5");

var $80b141fb78ce6527$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $bZxeP.default)(typeof padding !== "number" ? padding : (0, $4oVPd.default)(padding, (0, $4iOh5.basePlacements)));
};
function $80b141fb78ce6527$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $41Xgj.default)(state.placement);
    var axis = (0, $dCdW9.default)(basePlacement);
    var isVertical = [
        (0, $4iOh5.left),
        (0, $4iOh5.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $80b141fb78ce6527$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $h10ij.default)(arrowElement);
    var minProp = axis === "y" ? (0, $4iOh5.top) : (0, $4iOh5.left);
    var maxProp = axis === "y" ? (0, $4iOh5.bottom) : (0, $4iOh5.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $fYtF7.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $9cg45.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $80b141fb78ce6527$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $jafkk.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $80b141fb78ce6527$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $80b141fb78ce6527$var$arrow,
    effect: $80b141fb78ce6527$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("2sHk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cafcd7ed261b672$export$2e2bcd8739ae039; });

var $4iOh5 = parcelRequire("4iOh5");

var $iO6Nm = parcelRequire("iO6Nm");
function $1cafcd7ed261b672$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $1cafcd7ed261b672$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $4iOh5.top),
        (0, $4iOh5.right),
        (0, $4iOh5.bottom),
        (0, $4iOh5.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $1cafcd7ed261b672$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $iO6Nm.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $iO6Nm.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $1cafcd7ed261b672$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $1cafcd7ed261b672$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $1cafcd7ed261b672$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $1cafcd7ed261b672$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $1cafcd7ed261b672$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $1cafcd7ed261b672$var$hide
};

});




parcelRegister("57DGY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bac6535a1455837$export$2e2bcd8739ae039; });

var $hBUX7 = parcelRequire("hBUX7");
var $3bac6535a1455837$export$2e2bcd8739ae039 = (0, $hBUX7.default);

});

parcelRegister("5d11d", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", function () { return $3caef4e85314a2d1$export$837848f5f6cee923; });
$parcel$export(module.exports, "default", function () { return $3caef4e85314a2d1$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $3caef4e85314a2d1$export$837848f5f6cee923(slot) {
    return (0, $dtsUs.default)("MuiTooltip", slot);
}
const $3caef4e85314a2d1$var$tooltipClasses = (0, $jLqVN.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $3caef4e85314a2d1$export$2e2bcd8739ae039 = $3caef4e85314a2d1$var$tooltipClasses;

});


parcelRegister("1wlCp", function(module, exports) {

$parcel$export(module.exports, "getSpeedDialActionUtilityClass", function () { return $11b98c9aa22a45d5$export$245f94b54fb85595; });
$parcel$export(module.exports, "default", function () { return $11b98c9aa22a45d5$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $11b98c9aa22a45d5$export$245f94b54fb85595(slot) {
    return (0, $dtsUs.default)("MuiSpeedDialAction", slot);
}
const $11b98c9aa22a45d5$var$speedDialActionClasses = (0, $jLqVN.default)("MuiSpeedDialAction", [
    "fab",
    "fabClosed",
    "staticTooltip",
    "staticTooltipClosed",
    "staticTooltipLabel",
    "tooltipPlacementLeft",
    "tooltipPlacementRight"
]);
var $11b98c9aa22a45d5$export$2e2bcd8739ae039 = $11b98c9aa22a45d5$var$speedDialActionClasses;

});



parcelRegister("irnsW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6ccf3722eb73002$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $apyzp = parcelRequire("apyzp");

var $7kxx2 = parcelRequire("7kxx2");

var $et0sX = parcelRequire("et0sX");

var $4x3bm = parcelRequire("4x3bm");
const $d6ccf3722eb73002$var$_excluded = [
    "className",
    "row"
];
const $d6ccf3722eb73002$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $apyzp.getFormGroupUtilityClass), classes);
};
const $d6ccf3722eb73002$var$FormGroupRoot = (0, $71Pr4.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $d6ccf3722eb73002$var$FormGroup = /*#__PURE__*/ $70fFQ.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $79yYo.default)(props, $d6ccf3722eb73002$var$_excluded);
    const muiFormControl = (0, $7kxx2.default)();
    const fcs = (0, $et0sX.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $20MOv.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $d6ccf3722eb73002$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($d6ccf3722eb73002$var$FormGroupRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $d6ccf3722eb73002$export$2e2bcd8739ae039 = $d6ccf3722eb73002$var$FormGroup;

});
parcelRegister("apyzp", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", function () { return $79470e1539ac44e7$export$d72d4cbdc30b331f; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $79470e1539ac44e7$export$d72d4cbdc30b331f(slot) {
    return (0, $dtsUs.default)("MuiFormGroup", slot);
}
const $79470e1539ac44e7$var$formGroupClasses = (0, $jLqVN.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $79470e1539ac44e7$export$2e2bcd8739ae039 = $79470e1539ac44e7$var$formGroupClasses;

});


parcelRegister("j6Rju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de97eec88fe23825$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");
var $1sJkf = parcelRequire("1sJkf");

var $aAAPW = parcelRequire("aAAPW");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $kdx2B = parcelRequire("kdx2B");

var $5Up1l = parcelRequire("5Up1l");

var $27ZKj = parcelRequire("27ZKj");

var $cweZM = parcelRequire("cweZM");

var $4x3bm = parcelRequire("4x3bm");
const $de97eec88fe23825$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant"
];
const $de97eec88fe23825$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $de97eec88fe23825$var$transformDeprecatedColors = (color)=>{
    return $de97eec88fe23825$var$colorTransformations[color] || color;
};
const $de97eec88fe23825$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $aAAPW.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $cweZM.getLinkUtilityClass), classes);
};
const $de97eec88fe23825$var$LinkRoot = (0, $71Pr4.default)((0, $27ZKj.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $aAAPW.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const color = (0, $1sJkf.getPath)(theme, `palette.${$de97eec88fe23825$var$transformDeprecatedColors(ownerState.color)}`) || ownerState.color;
    return (0, $20MOv.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && {
        textDecoration: "underline",
        textDecorationColor: color !== "inherit" ? (0, $bFVgt.alpha)(color, 0.4) : undefined,
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }, ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $cweZM.default).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $de97eec88fe23825$var$Link = /*#__PURE__*/ $70fFQ.forwardRef(function Link(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit" } = props, other = (0, $79yYo.default)(props, $de97eec88fe23825$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $kdx2B.default)();
    const [focusVisible, setFocusVisible] = $70fFQ.useState(false);
    const handlerRef = (0, $5Up1l.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $de97eec88fe23825$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($de97eec88fe23825$var$LinkRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant
    }, other));
});
var $de97eec88fe23825$export$2e2bcd8739ae039 = $de97eec88fe23825$var$Link;

});
parcelRegister("cweZM", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $91d41af95adb5dfa$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $91d41af95adb5dfa$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $91d41af95adb5dfa$export$d6efab9620b78fec(slot) {
    return (0, $dtsUs.default)("MuiLink", slot);
}
const $91d41af95adb5dfa$var$linkClasses = (0, $jLqVN.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $91d41af95adb5dfa$export$2e2bcd8739ae039 = $91d41af95adb5dfa$var$linkClasses;

});


parcelRegister("9BDqo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fe626af82328233$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $6fe626af82328233$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
}), "Business");

});

parcelRegister("7aNPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53901fb4f0839ac7$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $53901fb4f0839ac7$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
}), "Group");

});

parcelRegister("5KAQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42fdd4fcb279f006$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $42fdd4fcb279f006$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
}), "Layers");

});

parcelRegister("5rR0J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $010612f8b1fd5cb3$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $010612f8b1fd5cb3$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBack");

});

parcelRegister("bey3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82db6c280370a791$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $aAAPW = parcelRequire("aAAPW");

var $27oSn = parcelRequire("27oSn");

var $4x3bm = parcelRequire("4x3bm");
const $82db6c280370a791$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $82db6c280370a791$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $aAAPW.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $27oSn.getListSubheaderUtilityClass), classes);
};
const $82db6c280370a791$var$ListSubheaderRoot = (0, $71Pr4.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $aAAPW.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: theme.palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: theme.palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: theme.palette.background.paper
    }));
const $82db6c280370a791$var$ListSubheader = /*#__PURE__*/ $70fFQ.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $79yYo.default)(props, $82db6c280370a791$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $82db6c280370a791$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($82db6c280370a791$var$ListSubheaderRoot, (0, $20MOv.default)({
        as: component,
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $82db6c280370a791$export$2e2bcd8739ae039 = $82db6c280370a791$var$ListSubheader;

});
parcelRegister("27oSn", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", function () { return $18af881882f10717$export$6816d4fc0981ec7; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $18af881882f10717$export$6816d4fc0981ec7(slot) {
    return (0, $dtsUs.default)("MuiListSubheader", slot);
}
const $18af881882f10717$var$listSubheaderClasses = (0, $jLqVN.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $18af881882f10717$export$2e2bcd8739ae039 = $18af881882f10717$var$listSubheaderClasses;

});


parcelRegister("kbqXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb19bede9f5b13ee$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $eb19bede9f5b13ee$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRegister("e9iFh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d062691a1ed843$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $a4d062691a1ed843$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");

});

parcelRegister("50Bvw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a5a0c089a7dd5ca$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $9fL0u = parcelRequire("9fL0u");
var $9alAF = parcelRequire("9alAF");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $iWaGk = parcelRequire("iWaGk");

function $3a5a0c089a7dd5ca$var$LayoutContent({ children: children = null, panel: panel, style: style = {} }) {
    const { uiStore: uiStore } = (0, $iWaGk.default)();
    (0, $70fFQ.useEffect)(()=>{
        uiStore.setIsContentVisible(!!children);
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            panel,
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9alAF.default), {
                component: null,
                children: children && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9fL0u.default), {
                    classNames: "slide",
                    in: !children,
                    timeout: {
                        enter: 300,
                        exit: 500
                    },
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                        style: style,
                        className: "layout--content",
                        children: children
                    })
                }, location.key)
            })
        ]
    });
}
var $3a5a0c089a7dd5ca$export$2e2bcd8739ae039 = (0, $87gt0.observer)($3a5a0c089a7dd5ca$var$LayoutContent);

});
parcelRegister("9fL0u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bc9fa60c26b2976$export$2e2bcd8739ae039; });

var $7ZhC4 = parcelRequire("7ZhC4");

var $2D2PK = parcelRequire("2D2PK");

var $7PKwc = parcelRequire("7PKwc");


var $j16lN = parcelRequire("j16lN");

var $4R4FF = parcelRequire("4R4FF");

var $70fFQ = parcelRequire("70fFQ");

var $k9fXo = parcelRequire("k9fXo");

var $6bc9fa60c26b2976$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($j16lN)))(node, c);
    });
};
var $6bc9fa60c26b2976$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4R4FF)))(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $6bc9fa60c26b2976$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $7PKwc.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(node, appearing) {
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        if (type === "appear" && phase === "done") className += " " + this.getClassNames("enter").doneClassName;
         // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") /* eslint-disable no-unused-expressions */ node && node.scrollTop;
        this.appliedClasses[type][phase] = className;
        $6bc9fa60c26b2976$var$_addClass(node, className);
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $6bc9fa60c26b2976$var$removeClass(node, baseClassName);
        if (activeClassName) $6bc9fa60c26b2976$var$removeClass(node, activeClassName);
        if (doneClassName) $6bc9fa60c26b2976$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $2D2PK.default)(_this$props, [
            "classNames"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $k9fXo.default), (0, $7ZhC4.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
$6bc9fa60c26b2976$var$CSSTransition.defaultProps = {
    classNames: ""
};
$6bc9fa60c26b2976$var$CSSTransition.propTypes = {};
var $6bc9fa60c26b2976$export$2e2bcd8739ae039 = $6bc9fa60c26b2976$var$CSSTransition;

});
parcelRegister("7ZhC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0be481cc0ae9e2$export$2e2bcd8739ae039; });
function $5d0be481cc0ae9e2$export$2e2bcd8739ae039() {
    $5d0be481cc0ae9e2$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d0be481cc0ae9e2$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("2D2PK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ea16c00aabc307f$export$2e2bcd8739ae039; });
function $1ea16c00aabc307f$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("7PKwc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b41616057824375$export$2e2bcd8739ae039; });
function $5b41616057824375$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

});

parcelRegister("j16lN", function(module, exports) {
"use strict";

var $lvhY9 = parcelRequire("lvhY9");
module.exports.__esModule = true;
module.exports.default = $dd8309651a57028f$var$addClass;

var $dd8309651a57028f$var$_hasClass = $lvhY9((parcelRequire("hhZ5h")));
function $dd8309651a57028f$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $dd8309651a57028f$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("hhZ5h", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $c96368430d400a21$var$hasClass;
function $c96368430d400a21$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("4R4FF", function(module, exports) {
"use strict";
function $388fbc425d3929cb$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $388fbc425d3929cb$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $388fbc425d3929cb$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRegister("k9fXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eab1069f2d35a284$export$2e2bcd8739ae039; });

var $2D2PK = parcelRequire("2D2PK");

var $7PKwc = parcelRequire("7PKwc");


var $70fFQ = parcelRequire("70fFQ");

var $3glZ1 = parcelRequire("3glZ1");

var $h8FmF = parcelRequire("h8FmF");


var $4qVLt = parcelRequire("4qVLt");
var $eab1069f2d35a284$export$bb38bb9a1161268 = "unmounted";
var $eab1069f2d35a284$export$84cbff306f539230 = "exited";
var $eab1069f2d35a284$export$df38205c966be359 = "entering";
var $eab1069f2d35a284$export$78e9e6e3e014d60a = "entered";
var $eab1069f2d35a284$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $eab1069f2d35a284$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $7PKwc.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $eab1069f2d35a284$export$84cbff306f539230;
                _this.appearStatus = $eab1069f2d35a284$export$df38205c966be359;
            } else initialStatus = $eab1069f2d35a284$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $eab1069f2d35a284$export$bb38bb9a1161268;
        else initialStatus = $eab1069f2d35a284$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $eab1069f2d35a284$export$bb38bb9a1161268) return {
            status: $eab1069f2d35a284$export$84cbff306f539230
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $eab1069f2d35a284$export$df38205c966be359 && status !== $eab1069f2d35a284$export$78e9e6e3e014d60a) nextStatus = $eab1069f2d35a284$export$df38205c966be359;
            } else if (status === $eab1069f2d35a284$export$df38205c966be359 || status === $eab1069f2d35a284$export$78e9e6e3e014d60a) nextStatus = $eab1069f2d35a284$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = (0, (/*@__PURE__*/$parcel$interopDefault($3glZ1))).findDOMNode(this);
            if (nextStatus === $eab1069f2d35a284$export$df38205c966be359) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $eab1069f2d35a284$export$84cbff306f539230) this.setState({
            status: $eab1069f2d35a284$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $h8FmF.default).disabled) {
            this.safeSetState({
                status: $eab1069f2d35a284$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $eab1069f2d35a284$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $eab1069f2d35a284$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit || (0, $h8FmF.default).disabled) {
            this.safeSetState({
                status: $eab1069f2d35a284$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $eab1069f2d35a284$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $eab1069f2d35a284$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $eab1069f2d35a284$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, childProps = (0, $2D2PK.default)(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") // allows for nested Transitions
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $4qVLt.default).Provider, {
            value: null
        }, children(status, childProps));
        var child = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Children.only(children);
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $4qVLt.default).Provider, {
            value: null
        }, (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).cloneElement(child, childProps));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
$eab1069f2d35a284$var$Transition.contextType = (0, $4qVLt.default);
$eab1069f2d35a284$var$Transition.propTypes = {};
function $eab1069f2d35a284$var$noop() {}
$eab1069f2d35a284$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $eab1069f2d35a284$var$noop,
    onEntering: $eab1069f2d35a284$var$noop,
    onEntered: $eab1069f2d35a284$var$noop,
    onExit: $eab1069f2d35a284$var$noop,
    onExiting: $eab1069f2d35a284$var$noop,
    onExited: $eab1069f2d35a284$var$noop
};
$eab1069f2d35a284$var$Transition.UNMOUNTED = 0;
$eab1069f2d35a284$var$Transition.EXITED = 1;
$eab1069f2d35a284$var$Transition.ENTERING = 2;
$eab1069f2d35a284$var$Transition.ENTERED = 3;
$eab1069f2d35a284$var$Transition.EXITING = 4;
var $eab1069f2d35a284$export$2e2bcd8739ae039 = $eab1069f2d35a284$var$Transition;

});
parcelRegister("h8FmF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a34531073c5216$export$2e2bcd8739ae039; });
var $c7a34531073c5216$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("4qVLt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33a66605070563c4$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
var $33a66605070563c4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createContext(null);

});



parcelRegister("9alAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ac5cba62b059f30$export$2e2bcd8739ae039; });

var $2D2PK = parcelRequire("2D2PK");

var $7ZhC4 = parcelRequire("7ZhC4");

var $7PKwc = parcelRequire("7PKwc");

var $4DTSS = parcelRequire("4DTSS");


var $70fFQ = parcelRequire("70fFQ");

var $4qVLt = parcelRequire("4qVLt");

var $27NWn = parcelRequire("27NWn");
var $6ac5cba62b059f30$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $6ac5cba62b059f30$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $6ac5cba62b059f30$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $7PKwc.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $4DTSS.default)((0, $4DTSS.default)(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $27NWn.getInitialChildMapping)(nextProps, handleExited) : (0, $27NWn.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $27NWn.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $7ZhC4.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $2D2PK.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $6ac5cba62b059f30$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $4qVLt.default).Provider, {
            value: contextValue
        }, children);
        return (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement((0, $4qVLt.default).Provider, {
            value: contextValue
        }, (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).Component);
$6ac5cba62b059f30$var$TransitionGroup.propTypes = {};
$6ac5cba62b059f30$var$TransitionGroup.defaultProps = $6ac5cba62b059f30$var$defaultProps;
var $6ac5cba62b059f30$export$2e2bcd8739ae039 = $6ac5cba62b059f30$var$TransitionGroup;

});
parcelRegister("4DTSS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $361627601b79af25$export$2e2bcd8739ae039; });
function $361627601b79af25$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("27NWn", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $18c2f95c83e72740$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $18c2f95c83e72740$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $18c2f95c83e72740$export$36fd1af28d383ec0; });

var $70fFQ = parcelRequire("70fFQ");
function $18c2f95c83e72740$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $70fFQ.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $70fFQ.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $18c2f95c83e72740$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $18c2f95c83e72740$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $18c2f95c83e72740$export$fa71e2345c31d7a2(props, onExited) {
    return $18c2f95c83e72740$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $18c2f95c83e72740$var$getProp(child, "appear", props),
            enter: $18c2f95c83e72740$var$getProp(child, "enter", props),
            exit: $18c2f95c83e72740$var$getProp(child, "exit", props)
        });
    });
}
function $18c2f95c83e72740$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $18c2f95c83e72740$export$bbc8a025727ea824(nextProps.children);
    var children = $18c2f95c83e72740$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $70fFQ.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $70fFQ.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $18c2f95c83e72740$var$getProp(child, "exit", nextProps),
            enter: $18c2f95c83e72740$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $70fFQ.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $70fFQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $18c2f95c83e72740$var$getProp(child, "exit", nextProps),
            enter: $18c2f95c83e72740$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



parcelRegister("7pHcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $565c61c0888a77b3$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $8VJ2N = parcelRequire("8VJ2N");
var $1mImZ = parcelRequire("1mImZ");

var $awtVx = parcelRequire("awtVx");
function $565c61c0888a77b3$export$2e2bcd8739ae039({ children: children, header: header }) {
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $1mImZ.default), {
        sx: {
            overflow: "auto"
        },
        className: "layout--panel",
        elevation: 0,
        square: true,
        children: [
            header && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8VJ2N.default), {
                alignItems: "center",
                className: "header",
                container: true,
                spacing: 0,
                wrap: "nowrap",
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: "auto",
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $awtVx.default), {})
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                        item: true,
                        xs: true,
                        children: header
                    })
                ]
            }),
            children
        ]
    });
}

});
parcelRegister("awtVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a941b6b0237c0a9$export$2e2bcd8739ae039; });

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $cGU07 = parcelRequire("cGU07");

var $8r5DD = parcelRequire("8r5DD");

var $iWaGk = parcelRequire("iWaGk");
const $7a941b6b0237c0a9$var$SidebarToggle = ()=>{
    const { uiStore: uiStore } = (0, $iWaGk.default)();
    const handleExpand = ()=>{
        uiStore.setSidebarExpanded(!uiStore.sidebarExpanded);
    };
    const handleBlur = (event)=>{
        var _event_relatedTarget;
        const id = event === null || event === void 0 ? void 0 : (_event_relatedTarget = event.relatedTarget) === null || _event_relatedTarget === void 0 ? void 0 : _event_relatedTarget.id;
        if ([
            "group-name",
            "switch-group"
        ].includes(id)) return;
        uiStore.setSidebarExpanded(false);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
        id: "nav-sidebar-toggle",
        className: "sidebar--toggle",
        "aria-label": "Menu",
        onBlur: handleBlur,
        onClick: handleExpand,
        size: "large",
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8r5DD.default), {})
    });
};
var $7a941b6b0237c0a9$export$2e2bcd8739ae039 = $7a941b6b0237c0a9$var$SidebarToggle;

});
parcelRegister("8r5DD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $624537fc8511f176$export$2e2bcd8739ae039; });

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $624537fc8511f176$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");

});



parcelRegister("4Ghcg", function(module, exports) {

$parcel$export(module.exports, "useSelectedBuilding", function () { return $36886c956e39f87b$export$84b4e7aacf64381a; });
$parcel$export(module.exports, "SelectedBuildingProvider", function () { return $36886c956e39f87b$export$2283a83df7c01d8e; });

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");
const $36886c956e39f87b$var$SelectedBuildingContext = /*#__PURE__*/ (0, $70fFQ.createContext)();
const $36886c956e39f87b$export$84b4e7aacf64381a = ()=>(0, $70fFQ.useContext)($36886c956e39f87b$var$SelectedBuildingContext);
const $36886c956e39f87b$export$2283a83df7c01d8e = ({ children: children })=>{
    const [selectedBuilding, setSelectedBuilding] = (0, $70fFQ.useState)(null);
    return /*#__PURE__*/ (0, $4x3bm.jsx)($36886c956e39f87b$var$SelectedBuildingContext.Provider, {
        value: {
            selectedBuilding: selectedBuilding,
            setSelectedBuilding: setSelectedBuilding
        },
        children: children
    });
};

});

parcelRegister("jOtOD", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("31nVF"))((parcelRequire("c1lIA")).resolve("kiiv1")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("6UvQe")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("2i8bu"))
]).then(()=>parcelRequire("5Wt4I"));

});

parcelRegister("6jag2", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("31nVF"))((parcelRequire("c1lIA")).resolve("cvSyY")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("cYqwX")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("616JI")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("3XmT6"))
]).then(()=>parcelRequire("4cmvu"));

});

parcelRegister("991y0", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("31nVF"))((parcelRequire("c1lIA")).resolve("fOAr7")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("eEl6C")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("cYqwX")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("ablVK"))
]).then(()=>parcelRequire("6aTpT"));

});

parcelRegister("cLQwS", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("31nVF"))((parcelRequire("c1lIA")).resolve("iovf3")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("eEl6C")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("cYqwX")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("616JI")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("6UvQe")),
    (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("6eC7B"))
]).then(()=>parcelRequire("f1DqQ"));

});

parcelRegister("cFp2b", function(module, exports) {


module.exports = (parcelRequire("hPc3f"))((parcelRequire("c1lIA")).resolve("1iwPP")).then(()=>parcelRequire("34apt"));

});

parcelRegister("ld7Nh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03fc2492d2b6f52e$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");

var $1mImZ = parcelRequire("1mImZ");

var $aAAPW = parcelRequire("aAAPW");

var $bVfKY = parcelRequire("bVfKY");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $d0h6u = parcelRequire("d0h6u");

var $4x3bm = parcelRequire("4x3bm");
const $03fc2492d2b6f52e$var$_excluded = [
    "activeStep",
    "backButton",
    "className",
    "LinearProgressProps",
    "nextButton",
    "position",
    "steps",
    "variant"
];
const $03fc2492d2b6f52e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            "root",
            `position${(0, $aAAPW.default)(position)}`
        ],
        dots: [
            "dots"
        ],
        dot: [
            "dot"
        ],
        dotActive: [
            "dotActive"
        ],
        progress: [
            "progress"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $d0h6u.getMobileStepperUtilityClass), classes);
};
const $03fc2492d2b6f52e$var$MobileStepperRoot = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiMobileStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $aAAPW.default)(ownerState.position)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        background: theme.palette.background.default,
        padding: 8
    }, ownerState.position === "bottom" && {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.mobileStepper
    }, ownerState.position === "top" && {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.mobileStepper
    }));
const $03fc2492d2b6f52e$var$MobileStepperDots = (0, $71Pr4.default)("div", {
    name: "MuiMobileStepper",
    slot: "Dots",
    overridesResolver: (props, styles)=>styles.dots
})(({ ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.variant === "dots" && {
        display: "flex",
        flexDirection: "row"
    }));
const $03fc2492d2b6f52e$var$MobileStepperDot = (0, $71Pr4.default)("div", {
    name: "MuiMobileStepper",
    slot: "Dot",
    shouldForwardProp: (prop)=>(0, $71Pr4.slotShouldForwardProp)(prop) && prop !== "dotActive",
    overridesResolver: (props, styles)=>{
        const { dotActive: dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})(({ theme: theme, ownerState: ownerState, dotActive: dotActive })=>(0, $20MOv.default)({}, ownerState.variant === "dots" && (0, $20MOv.default)({
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.palette.action.disabled,
        borderRadius: "50%",
        width: 8,
        height: 8,
        margin: "0 2px"
    }, dotActive && {
        backgroundColor: theme.palette.primary.main
    })));
const $03fc2492d2b6f52e$var$MobileStepperProgress = (0, $71Pr4.default)((0, $bVfKY.default), {
    name: "MuiMobileStepper",
    slot: "Progress",
    overridesResolver: (props, styles)=>styles.progress
})(({ ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.variant === "progress" && {
        width: "50%"
    }));
const $03fc2492d2b6f52e$var$MobileStepper = /*#__PURE__*/ $70fFQ.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiMobileStepper"
    });
    const { activeStep: activeStep = 0, backButton: backButton, className: className, LinearProgressProps: LinearProgressProps, nextButton: nextButton, position: position = "bottom", steps: steps, variant: variant = "dots" } = props, other = (0, $79yYo.default)(props, $03fc2492d2b6f52e$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        activeStep: activeStep,
        position: position,
        variant: variant
    });
    const classes = $03fc2492d2b6f52e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($03fc2492d2b6f52e$var$MobileStepperRoot, (0, $20MOv.default)({
        square: true,
        elevation: 0,
        className: (0, $gjktY.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            backButton,
            variant === "text" && /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === "dots" && /*#__PURE__*/ (0, $4x3bm.jsx)($03fc2492d2b6f52e$var$MobileStepperDots, {
                ownerState: ownerState,
                className: classes.dots,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, $4x3bm.jsx)($03fc2492d2b6f52e$var$MobileStepperDot, {
                        className: (0, $gjktY.default)(classes.dot, index === activeStep && classes.dotActive),
                        ownerState: ownerState,
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === "progress" && /*#__PURE__*/ (0, $4x3bm.jsx)($03fc2492d2b6f52e$var$MobileStepperProgress, (0, $20MOv.default)({
                ownerState: ownerState,
                className: classes.progress,
                variant: "determinate",
                value: Math.ceil(activeStep / (steps - 1) * 100)
            }, LinearProgressProps)),
            nextButton
        ]
    }));
});
var $03fc2492d2b6f52e$export$2e2bcd8739ae039 = $03fc2492d2b6f52e$var$MobileStepper;

});
parcelRegister("bVfKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ae13d87deba5729$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $l1z3A = parcelRequire("l1z3A");
var $bFVgt = parcelRequire("bFVgt");

var $aAAPW = parcelRequire("aAAPW");

var $2mnfJ = parcelRequire("2mnfJ");

var $71Pr4 = parcelRequire("71Pr4");

var $cNmNk = parcelRequire("cNmNk");

var $boaoq = parcelRequire("boaoq");

var $4x3bm = parcelRequire("4x3bm");
let $8ae13d87deba5729$var$_ = (t)=>t, $8ae13d87deba5729$var$t, $8ae13d87deba5729$var$t1, $8ae13d87deba5729$var$t2, $8ae13d87deba5729$var$t3, $8ae13d87deba5729$var$t4, $8ae13d87deba5729$var$t5;
const $8ae13d87deba5729$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $8ae13d87deba5729$var$_1 = (t)=>t, $8ae13d87deba5729$var$_t, $8ae13d87deba5729$var$_t2, $8ae13d87deba5729$var$_t3, $8ae13d87deba5729$var$_t4, $8ae13d87deba5729$var$_t5, $8ae13d87deba5729$var$_t6;
const $8ae13d87deba5729$var$TRANSITION_DURATION = 4; // seconds
const $8ae13d87deba5729$var$indeterminate1Keyframe = (0, $l1z3A.keyframes)($8ae13d87deba5729$var$_t || ($8ae13d87deba5729$var$_t = $8ae13d87deba5729$var$_1($8ae13d87deba5729$var$t || ($8ae13d87deba5729$var$t = $8ae13d87deba5729$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`))));
const $8ae13d87deba5729$var$indeterminate2Keyframe = (0, $l1z3A.keyframes)($8ae13d87deba5729$var$_t2 || ($8ae13d87deba5729$var$_t2 = $8ae13d87deba5729$var$_1($8ae13d87deba5729$var$t1 || ($8ae13d87deba5729$var$t1 = $8ae13d87deba5729$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`))));
const $8ae13d87deba5729$var$bufferKeyframe = (0, $l1z3A.keyframes)($8ae13d87deba5729$var$_t3 || ($8ae13d87deba5729$var$_t3 = $8ae13d87deba5729$var$_1($8ae13d87deba5729$var$t2 || ($8ae13d87deba5729$var$t2 = $8ae13d87deba5729$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`))));
const $8ae13d87deba5729$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $aAAPW.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $aAAPW.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $aAAPW.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $aAAPW.default)(color)}`,
            variant === "buffer" && `color${(0, $aAAPW.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $boaoq.getLinearProgressUtilityClass), classes);
};
const $8ae13d87deba5729$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    return theme.palette.mode === "light" ? (0, $bFVgt.lighten)(theme.palette[color].main, 0.62) : (0, $bFVgt.darken)(theme.palette[color].main, 0.5);
};
const $8ae13d87deba5729$var$LinearProgressRoot = (0, $71Pr4.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $aAAPW.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $8ae13d87deba5729$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $8ae13d87deba5729$var$LinearProgressDashed = (0, $71Pr4.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $aAAPW.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $8ae13d87deba5729$var$getColorShade(theme, ownerState.color);
    return (0, $20MOv.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $l1z3A.css)($8ae13d87deba5729$var$_t4 || ($8ae13d87deba5729$var$_t4 = $8ae13d87deba5729$var$_1($8ae13d87deba5729$var$t3 || ($8ae13d87deba5729$var$t3 = $8ae13d87deba5729$var$_`
    animation: ${0} 3s infinite linear;
  `), 0)), $8ae13d87deba5729$var$bufferKeyframe));
const $8ae13d87deba5729$var$LinearProgressBar1 = (0, $71Pr4.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $aAAPW.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : theme.palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$8ae13d87deba5729$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$8ae13d87deba5729$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $l1z3A.css)($8ae13d87deba5729$var$_t5 || ($8ae13d87deba5729$var$_t5 = $8ae13d87deba5729$var$_1($8ae13d87deba5729$var$t4 || ($8ae13d87deba5729$var$t4 = $8ae13d87deba5729$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), 0)), $8ae13d87deba5729$var$indeterminate1Keyframe));
const $8ae13d87deba5729$var$LinearProgressBar2 = (0, $71Pr4.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $aAAPW.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $20MOv.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : theme.palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $8ae13d87deba5729$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$8ae13d87deba5729$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $l1z3A.css)($8ae13d87deba5729$var$_t6 || ($8ae13d87deba5729$var$_t6 = $8ae13d87deba5729$var$_1($8ae13d87deba5729$var$t5 || ($8ae13d87deba5729$var$t5 = $8ae13d87deba5729$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), 0)), $8ae13d87deba5729$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $8ae13d87deba5729$var$LinearProgress = /*#__PURE__*/ $70fFQ.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate" } = props, other = (0, $79yYo.default)(props, $8ae13d87deba5729$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $8ae13d87deba5729$var$useUtilityClasses(ownerState);
    const theme = (0, $2mnfJ.default)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($8ae13d87deba5729$var$LinearProgressRoot, (0, $20MOv.default)({
        className: (0, $gjktY.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $4x3bm.jsx)($8ae13d87deba5729$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $4x3bm.jsx)($8ae13d87deba5729$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $4x3bm.jsx)($8ae13d87deba5729$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $8ae13d87deba5729$export$2e2bcd8739ae039 = $8ae13d87deba5729$var$LinearProgress;

});
parcelRegister("boaoq", function(module, exports) {

$parcel$export(module.exports, "getLinearProgressUtilityClass", function () { return $84a9ff6a30a25c37$export$bc8a6ea1eb17d7c6; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $84a9ff6a30a25c37$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $dtsUs.default)("MuiLinearProgress", slot);
}
const $84a9ff6a30a25c37$var$linearProgressClasses = (0, $jLqVN.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $84a9ff6a30a25c37$export$2e2bcd8739ae039 = $84a9ff6a30a25c37$var$linearProgressClasses;

});


parcelRegister("d0h6u", function(module, exports) {

$parcel$export(module.exports, "getMobileStepperUtilityClass", function () { return $97788ae4d4d39ffb$export$af7da6d60955385e; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $97788ae4d4d39ffb$export$af7da6d60955385e(slot) {
    return (0, $dtsUs.default)("MuiMobileStepper", slot);
}
const $97788ae4d4d39ffb$var$mobileStepperClasses = (0, $jLqVN.default)("MuiMobileStepper", [
    "root",
    "positionBottom",
    "positionTop",
    "positionStatic",
    "dots",
    "dot",
    "dotActive",
    "progress"
]);
var $97788ae4d4d39ffb$export$2e2bcd8739ae039 = $97788ae4d4d39ffb$var$mobileStepperClasses;

});


parcelRegister("ghdbC", function(module, exports) {
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd9876664c58f15a$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $bd9876664c58f15a$var$_default = (0, $bd9876664c58f15a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
}), "CheckOutlined");
module.exports.default = $bd9876664c58f15a$var$_default;

});

parcelRegister("gD8dY", function(module, exports) {
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1b6ab0874df8edd$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $c1b6ab0874df8edd$var$_default = (0, $c1b6ab0874df8edd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
module.exports.default = $c1b6ab0874df8edd$var$_default;

});

parcelRegister("ggYS0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd8d5b7e9b78d098$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");


var $8dWxZ = parcelRequire("8dWxZ");
var $b5YPE = parcelRequire("b5YPE");

var $bFVgt = parcelRequire("bFVgt");

var $4gFK1 = parcelRequire("4gFK1");

var $bey3N = parcelRequire("bey3N");

var $1mImZ = parcelRequire("1mImZ");

var $cGU07 = parcelRequire("cGU07");

var $jRqkM = parcelRequire("jRqkM");

var $1k5uZ = parcelRequire("1k5uZ");

var $b29Hy = parcelRequire("b29Hy");

var $4XGo8 = parcelRequire("4XGo8");

var $d8LGX = parcelRequire("d8LGX");

var $7AUf9 = parcelRequire("7AUf9");

var $1MKx1 = parcelRequire("1MKx1");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $fAmaY = parcelRequire("fAmaY");

var $aAAPW = parcelRequire("aAAPW");

var $4x3bm = parcelRequire("4x3bm");
var $bd8d5b7e9b78d098$var$_ClearIcon, $bd8d5b7e9b78d098$var$_ArrowDropDownIcon;
const $bd8d5b7e9b78d098$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "value"
];
const $bd8d5b7e9b78d098$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $aAAPW.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $fAmaY.getAutocompleteUtilityClass), classes);
};
const $bd8d5b7e9b78d098$var$AutocompleteRoot = (0, $71Pr4.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $fAmaY.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $fAmaY.default).tag}`]: styles[`tagSize${(0, $aAAPW.default)(size)}`]
            },
            {
                [`& .${(0, $fAmaY.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $fAmaY.default).input}`]: styles.input
            },
            {
                [`& .${(0, $fAmaY.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        [`&.${(0, $fAmaY.default).focused} .${(0, $fAmaY.default).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $fAmaY.default).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $fAmaY.default).tag}`]: (0, $20MOv.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $fAmaY.default).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $fAmaY.default).hasPopupIcon}&, .${(0, $fAmaY.default).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $fAmaY.default).hasPopupIcon}.${(0, $fAmaY.default).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $fAmaY.default).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $1k5uZ.default).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $1k5uZ.default).root}.${(0, $b29Hy.default).sizeSmall}`]: {
            [`& .${(0, $1k5uZ.default).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $4XGo8.default).root}`]: {
            padding: 9,
            [`.${(0, $fAmaY.default).hasPopupIcon}&, .${(0, $fAmaY.default).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $fAmaY.default).hasPopupIcon}.${(0, $fAmaY.default).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $fAmaY.default).input}`]: {
                padding: "7.5px 4px 7.5px 6px"
            },
            [`& .${(0, $fAmaY.default).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $4XGo8.default).root}.${(0, $b29Hy.default).sizeSmall}`]: {
            padding: 6,
            [`& .${(0, $fAmaY.default).input}`]: {
                padding: "2.5px 4px 2.5px 6px"
            }
        },
        [`& .${(0, $d8LGX.default).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $fAmaY.default).hasPopupIcon}&, .${(0, $fAmaY.default).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $fAmaY.default).hasPopupIcon}.${(0, $fAmaY.default).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $d8LGX.default).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $fAmaY.default).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $d8LGX.default).root}.${(0, $b29Hy.default).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $d8LGX.default).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $b29Hy.default).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $fAmaY.default).input}`]: (0, $20MOv.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $bd8d5b7e9b78d098$var$AutocompleteEndAdornment = (0, $71Pr4.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const $bd8d5b7e9b78d098$var$AutocompleteClearIndicator = (0, $71Pr4.default)((0, $cGU07.default), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $bd8d5b7e9b78d098$var$AutocompletePopupIndicator = (0, $71Pr4.default)((0, $cGU07.default), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $20MOv.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $bd8d5b7e9b78d098$var$AutocompletePopper = (0, $71Pr4.default)((0, $4gFK1.default), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $fAmaY.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        zIndex: theme.zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $bd8d5b7e9b78d098$var$AutocompletePaper = (0, $71Pr4.default)((0, $1mImZ.default), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $20MOv.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $bd8d5b7e9b78d098$var$AutocompleteLoading = (0, $71Pr4.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: theme.palette.text.secondary,
        padding: "14px 16px"
    }));
const $bd8d5b7e9b78d098$var$AutocompleteNoOptions = (0, $71Pr4.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: theme.palette.text.secondary,
        padding: "14px 16px"
    }));
const $bd8d5b7e9b78d098$var$AutocompleteListbox = (0, $71Pr4.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        [`& .${(0, $fAmaY.default).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $fAmaY.default).focused}`]: {
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: theme.palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $fAmaY.default).focusVisible}`]: {
                backgroundColor: theme.palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $fAmaY.default).focused}`]: {
                    backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: theme.palette.action.selected
                    }
                },
                [`&.${(0, $fAmaY.default).focusVisible}`]: {
                    backgroundColor: (0, $bFVgt.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $bd8d5b7e9b78d098$var$AutocompleteGroupLabel = (0, $71Pr4.default)((0, $bey3N.default), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: theme.palette.background.paper,
        top: -8
    }));
const $bd8d5b7e9b78d098$var$AutocompleteGroupUl = (0, $71Pr4.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $fAmaY.default).option}`]: {
        paddingLeft: 24
    }
});
const $bd8d5b7e9b78d098$var$Autocomplete = /*#__PURE__*/ $70fFQ.forwardRef(function Autocomplete(inProps, ref) {
    var _componentsProps$clea, _componentsProps$pape;
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $bd8d5b7e9b78d098$var$_ClearIcon || ($bd8d5b7e9b78d098$var$_ClearIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7AUf9.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $1mImZ.default), PopperComponent: PopperComponent = (0, $4gFK1.default), popupIcon: popupIcon = $bd8d5b7e9b78d098$var$_ArrowDropDownIcon || ($bd8d5b7e9b78d098$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1MKx1.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium" } = props, other = (0, $79yYo.default)(props, $bd8d5b7e9b78d098$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $b5YPE.default)((0, $20MOv.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const ownerState = (0, $20MOv.default)({}, props, {
        disablePortal: disablePortal,
        focused: focused,
        fullWidth: fullWidth,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $bd8d5b7e9b78d098$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $20MOv.default)({
                className: (0, $gjktY.default)(classes.tag),
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $jRqkM.default), (0, $20MOv.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $4x3bm.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>/*#__PURE__*/ (0, $4x3bm.jsx)("li", (0, $20MOv.default)({}, props2, {
            children: getOptionLabel(option)
        }));
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $20MOv.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            inputValue: inputValue
        });
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompleteRoot, (0, $20MOv.default)({
                ref: ref,
                className: (0, $gjktY.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        endAdornment: /*#__PURE__*/ (0, $4x3bm.jsxs)($bd8d5b7e9b78d098$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompleteClearIndicator, (0, $20MOv.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, componentsProps.clearIndicator, {
                                    className: (0, $gjktY.default)(classes.clearIndicator, (_componentsProps$clea = componentsProps.clearIndicator) == null ? void 0 : _componentsProps$clea.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompletePopupIndicator, (0, $20MOv.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    className: (0, $gjktY.default)(classes.popupIndicator),
                                    ownerState: ownerState,
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    },
                    inputProps: (0, $20MOv.default)({
                        className: (0, $gjktY.default)(classes.input),
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            popupOpen && anchorEl ? /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompletePopper, {
                as: PopperComponent,
                className: (0, $gjktY.default)(classes.popper),
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: true,
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)($bd8d5b7e9b78d098$var$AutocompletePaper, (0, $20MOv.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, componentsProps.paper, {
                    className: (0, $gjktY.default)(classes.paper, (_componentsProps$pape = componentsProps.paper) == null ? void 0 : _componentsProps$pape.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $4x3bm.jsx)($bd8d5b7e9b78d098$var$AutocompleteListbox, (0, $20MOv.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, getListboxProps(), ListboxProps, {
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            }) : null
        ]
    });
});
var $bd8d5b7e9b78d098$export$2e2bcd8739ae039 = $bd8d5b7e9b78d098$var$Autocomplete;

});
parcelRegister("b5YPE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $813f594ce9b4173e$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");

var $eSJYK = parcelRequire("eSJYK");
var $dyLoc = parcelRequire("dyLoc");
var $3Fato = parcelRequire("3Fato");
var $hBUX7 = parcelRequire("hBUX7");
// Give up on IE11 support for this feature
function $813f594ce9b4173e$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $813f594ce9b4173e$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $813f594ce9b4173e$var$stripDiacritics(input);
        const filteredOptions = options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $813f594ce9b4173e$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
} // To replace with .findIndex() once we stop IE11 support.
function $813f594ce9b4173e$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $813f594ce9b4173e$var$defaultFilterOptions = $813f594ce9b4173e$export$f76f94b238d946d8(); // Number of options to jump in list box when pageup and pagedown keys are used.
const $813f594ce9b4173e$var$pageSize = 5;
function $813f594ce9b4173e$export$2e2bcd8739ae039(props) {
    const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, disabled: disabledProp, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $813f594ce9b4173e$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $hBUX7.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $70fFQ.useRef(false);
    const firstFocus = $70fFQ.useRef(true);
    const inputRef = $70fFQ.useRef(null);
    const listboxRef = $70fFQ.useRef(null);
    const [anchorEl, setAnchorEl] = $70fFQ.useState(null);
    const [focusedTag, setFocusedTag] = $70fFQ.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $70fFQ.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $dyLoc.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $dyLoc.default)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $70fFQ.useState(false);
    const resetInputValue = $70fFQ.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const prevValue = $70fFQ.useRef();
    $70fFQ.useEffect(()=>{
        const valueChange = value !== prevValue.current;
        prevValue.current = value;
        if (focused && !valueChange) return;
         // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        prevValue,
        freeSolo
    ]);
    const [open, setOpenState] = (0, $dyLoc.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $70fFQ.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $3Fato.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    }); // Ensure the focusedTag is never inconsistent
    $70fFQ.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === filteredOptions.length || direction === "previous" && nextFocus === -1) return -1;
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`); // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && !option.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const setHighlightedIndex = (0, $3Fato.default)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index; // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector('[role="option"].Mui-focused');
        if (prev) {
            prev.classList.remove("Mui-focused");
            prev.classList.remove("Mui-focusVisible");
        }
        const listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add("Mui-focused");
        if (reason === "keyboard") option.classList.add("Mui-focusVisible");
         // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
        //
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $3Fato.default)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        }); // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const syncHighlightedIndex = $70fFQ.useCallback(()=>{
        if (!popupOpen) return;
        const valueItem = multiple ? value[0] : value; // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
         // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
            if (multiple && currentOption && $813f594ce9b4173e$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $813f594ce9b4173e$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        } // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        } // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        }); // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filteredOptions.length,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $3Fato.default)((node)=>{
        (0, $eSJYK.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $70fFQ.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (Array.isArray(value)) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $70fFQ.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $813f594ce9b4173e$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && !event.ctrlKey && !event.metaKey) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`); // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            } // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$813f594ce9b4173e$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $813f594ce9b4173e$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false; // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption"); // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (listboxRef.current !== null && listboxRef.current.parentElement.contains(document.activeElement)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseOver = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = ()=>{
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    }; // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    }; // Focus the input when interacting with the combobox
    const handleClick = ()=>{
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (inputValue === "" || !open) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $20MOv.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperativeley so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox"
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $20MOv.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseOver: handleOptionMouseOver,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}

});

parcelRegister("jRqkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e75764f7192a0740$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $9n9u9 = parcelRequire("9n9u9");

var $5Up1l = parcelRequire("5Up1l");


var $aAAPW = parcelRequire("aAAPW");

var $eGmvM = parcelRequire("eGmvM");

var $cNmNk = parcelRequire("cNmNk");

var $71Pr4 = parcelRequire("71Pr4");

var $5uoBg = parcelRequire("5uoBg");

var $4x3bm = parcelRequire("4x3bm");
const $e75764f7192a0740$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant"
];
const $e75764f7192a0740$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $aAAPW.default)(size)}`,
            `color${(0, $aAAPW.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $aAAPW.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $aAAPW.default)(color)}`,
            `${variant}${(0, $aAAPW.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $aAAPW.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $aAAPW.default)(size)}`,
            `avatarColor${(0, $aAAPW.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $aAAPW.default)(size)}`,
            `iconColor${(0, $aAAPW.default)(color)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $aAAPW.default)(size)}`,
            `deleteIconColor${(0, $aAAPW.default)(color)}`,
            `deleteIconOutlinedColor${(0, $aAAPW.default)(color)}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $5uoBg.getChipUtilityClass), classes);
};
const $e75764f7192a0740$var$ChipRoot = (0, $71Pr4.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $5uoBg.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $5uoBg.default).avatar}`]: styles[`avatar${(0, $aAAPW.default)(size)}`]
            },
            {
                [`& .${(0, $5uoBg.default).avatar}`]: styles[`avatarColor${(0, $aAAPW.default)(color)}`]
            },
            {
                [`& .${(0, $5uoBg.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $5uoBg.default).icon}`]: styles[`icon${(0, $aAAPW.default)(size)}`]
            },
            {
                [`& .${(0, $5uoBg.default).icon}`]: styles[`iconColor${(0, $aAAPW.default)(color)}`]
            },
            {
                [`& .${(0, $5uoBg.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $5uoBg.default).deleteIcon}`]: styles[`deleteIcon${(0, $aAAPW.default)(size)}`]
            },
            {
                [`& .${(0, $5uoBg.default).deleteIcon}`]: styles[`deleteIconColor${(0, $aAAPW.default)(color)}`]
            },
            {
                [`& .${(0, $5uoBg.default).deleteIcon}`]: styles[`deleteIconOutlinedColor${(0, $aAAPW.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $aAAPW.default)(size)}`],
            styles[`color${(0, $aAAPW.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $aAAPW.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $aAAPW.default)(color)}`],
            styles[variant],
            variant === "outlined" && styles[`outlined${(0, $aAAPW.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const deleteIconColor = (0, $bFVgt.alpha)(theme.palette.text.primary, 0.26);
    return (0, $20MOv.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // label will inherit this from root, then `clickable` class overrides this for both
        cursor: "default",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $5uoBg.default).disabled}`]: {
            opacity: theme.palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $5uoBg.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $5uoBg.default).avatarColorPrimary}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.dark
        },
        [`& .${(0, $5uoBg.default).avatarColorSecondary}`]: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.dark
        },
        [`& .${(0, $5uoBg.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $5uoBg.default).icon}`]: (0, $20MOv.default)({
            color: theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.color !== "default" && {
            color: "inherit"
        }),
        [`& .${(0, $5uoBg.default).deleteIcon}`]: (0, $20MOv.default)({
            WebkitTapHighlightColor: "transparent",
            color: deleteIconColor,
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: (0, $bFVgt.alpha)(deleteIconColor, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: (0, $bFVgt.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: theme.palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $5uoBg.default).focusVisible}`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $5uoBg.default).focusVisible}`]: {
            backgroundColor: theme.palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $5uoBg.default).focusVisible}`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: theme.shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $5uoBg.default).focusVisible}`]: {
            backgroundColor: theme.palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $5uoBg.default).clickable}:hover`]: {
            backgroundColor: theme.palette.action.hover
        },
        [`&.${(0, $5uoBg.default).focusVisible}`]: {
            backgroundColor: theme.palette.action.focus
        },
        [`& .${(0, $5uoBg.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $5uoBg.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $5uoBg.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $5uoBg.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $5uoBg.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $5uoBg.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: theme.palette[ownerState.color].main,
        border: `1px solid ${(0, $bFVgt.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $5uoBg.default).clickable}:hover`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $5uoBg.default).focusVisible}`]: {
            backgroundColor: (0, $bFVgt.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $5uoBg.default).deleteIcon}`]: {
            color: (0, $bFVgt.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: theme.palette[ownerState.color].main
            }
        }
    }));
const $e75764f7192a0740$var$ChipLabel = (0, $71Pr4.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $aAAPW.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $20MOv.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }));
function $e75764f7192a0740$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $e75764f7192a0740$var$Chip = /*#__PURE__*/ $70fFQ.forwardRef(function Chip(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled" } = props, other = (0, $79yYo.default)(props, $e75764f7192a0740$var$_excluded);
    const chipRef = $70fFQ.useRef(null);
    const handleRef = (0, $5Up1l.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $e75764f7192a0740$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $e75764f7192a0740$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const small = size === "small";
    const component = clickable || onDelete ? (0, $eGmvM.default) : ComponentProp || "div";
    const ownerState = (0, $20MOv.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $e75764f7192a0740$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $eGmvM.default) ? (0, $20MOv.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) {
        const customClasses = (0, $gjktY.default)(color !== "default" && (variant === "outlined" ? classes[`deleteIconOutlinedColor${(0, $aAAPW.default)(color)}`] : classes[`deleteIconColor${(0, $aAAPW.default)(color)}`]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $70fFQ.isValidElement(deleteIconProp) ? /*#__PURE__*/ $70fFQ.cloneElement(deleteIconProp, {
            className: (0, $gjktY.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9n9u9.default), {
            className: (0, $gjktY.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $70fFQ.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $70fFQ.cloneElement(avatarProp, {
        className: (0, $gjktY.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $70fFQ.isValidElement(iconProp)) icon = /*#__PURE__*/ $70fFQ.cloneElement(iconProp, {
        className: (0, $gjktY.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($e75764f7192a0740$var$ChipRoot, (0, $20MOv.default)({
        as: component,
        className: (0, $gjktY.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $4x3bm.jsx)($e75764f7192a0740$var$ChipLabel, {
                className: (0, $gjktY.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $e75764f7192a0740$export$2e2bcd8739ae039 = $e75764f7192a0740$var$Chip;

});
parcelRegister("9n9u9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d2d9e9b1fd201c0$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $6d2d9e9b1fd201c0$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

});

parcelRegister("5uoBg", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", function () { return $3ff2d6205552d26a$export$31444911e4ee6fdd; });
$parcel$export(module.exports, "default", function () { return $3ff2d6205552d26a$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $3ff2d6205552d26a$export$31444911e4ee6fdd(slot) {
    return (0, $dtsUs.default)("MuiChip", slot);
}
const $3ff2d6205552d26a$var$chipClasses = (0, $jLqVN.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorPrimary",
    "colorSecondary",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "focusVisible"
]);
var $3ff2d6205552d26a$export$2e2bcd8739ae039 = $3ff2d6205552d26a$var$chipClasses;

});


parcelRegister("7AUf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587785f3fdc954fd$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $587785f3fdc954fd$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});

parcelRegister("fAmaY", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", function () { return $b58b6b82cc5a8c72$export$8ee01529667e66d9; });
$parcel$export(module.exports, "default", function () { return $b58b6b82cc5a8c72$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $b58b6b82cc5a8c72$export$8ee01529667e66d9(slot) {
    return (0, $dtsUs.default)("MuiAutocomplete", slot);
}
const $b58b6b82cc5a8c72$var$autocompleteClasses = (0, $jLqVN.default)("MuiAutocomplete", [
    "root",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $b58b6b82cc5a8c72$export$2e2bcd8739ae039 = $b58b6b82cc5a8c72$var$autocompleteClasses;

});


parcelRegister("4aoN6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308b5390273a79c5$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $gjktY = parcelRequire("gjktY");

var $8dWxZ = parcelRequire("8dWxZ");

var $aAAPW = parcelRequire("aAAPW");

var $27ZKj = parcelRequire("27ZKj");

var $eNpqa = parcelRequire("eNpqa");

var $7kxx2 = parcelRequire("7kxx2");

var $71Pr4 = parcelRequire("71Pr4");

var $dxrOb = parcelRequire("dxrOb");

var $cNmNk = parcelRequire("cNmNk");

var $4x3bm = parcelRequire("4x3bm");
var $308b5390273a79c5$var$_span;
const $308b5390273a79c5$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $308b5390273a79c5$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $aAAPW.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $308b5390273a79c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $aAAPW.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $aAAPW.default)(size)}`
        ]
    };
    return (0, $8dWxZ.default)(slots, (0, $dxrOb.getInputAdornmentUtilityClass), classes);
};
const $308b5390273a79c5$var$InputAdornmentRoot = (0, $71Pr4.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $308b5390273a79c5$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: theme.palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $dxrOb.default).positionStart}&:not(.${(0, $dxrOb.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $308b5390273a79c5$var$InputAdornment = /*#__PURE__*/ $70fFQ.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $79yYo.default)(props, $308b5390273a79c5$var$_excluded);
    const muiFormControl = (0, $7kxx2.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $20MOv.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $308b5390273a79c5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $eNpqa.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)($308b5390273a79c5$var$InputAdornmentRoot, (0, $20MOv.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $gjktY.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $308b5390273a79c5$var$_span || ($308b5390273a79c5$var$_span = /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $308b5390273a79c5$export$2e2bcd8739ae039 = $308b5390273a79c5$var$InputAdornment;

});
parcelRegister("dxrOb", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", function () { return $9db3ed9d654e70b4$export$4b135a4b3a6c4550; });
$parcel$export(module.exports, "default", function () { return $9db3ed9d654e70b4$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $9db3ed9d654e70b4$export$4b135a4b3a6c4550(slot) {
    return (0, $dtsUs.default)("MuiInputAdornment", slot);
}
const $9db3ed9d654e70b4$var$inputAdornmentClasses = (0, $jLqVN.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $9db3ed9d654e70b4$export$2e2bcd8739ae039 = $9db3ed9d654e70b4$var$inputAdornmentClasses;

});


parcelRegister("6QAZD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fc44b7c7ca8aeea$export$2e2bcd8739ae039; });

var $79yYo = parcelRequire("79yYo");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");



var $8dWxZ = parcelRequire("8dWxZ");

var $bFVgt = parcelRequire("bFVgt");

var $bKj54 = parcelRequire("bKj54");

var $cNmNk = parcelRequire("cNmNk");

var $jZ9og = parcelRequire("jZ9og");

var $aAAPW = parcelRequire("aAAPW");

var $3YAuu = parcelRequire("3YAuu");

var $3AnZy = parcelRequire("3AnZy");

var $7QIvB = parcelRequire("7QIvB");

var $71Pr4 = parcelRequire("71Pr4");

var $4x3bm = parcelRequire("4x3bm");
const $4fc44b7c7ca8aeea$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size"
];
const $4fc44b7c7ca8aeea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $aAAPW.default)(color)}`
        ]
    };
    return (0, $20MOv.default)({}, classes, (0, $8dWxZ.default)(slots, (0, $7QIvB.getRadioUtilityClass), classes));
};
const $4fc44b7c7ca8aeea$var$RadioRoot = (0, $71Pr4.default)((0, $bKj54.default), {
    shouldForwardProp: (prop)=>(0, $71Pr4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $aAAPW.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        color: theme.palette.text.secondary,
        "&:hover": {
            backgroundColor: (0, $bFVgt.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $7QIvB.default).checked}`]: {
            color: theme.palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $7QIvB.default).disabled}`]: {
            color: theme.palette.action.disabled
        }
    }));
function $4fc44b7c7ca8aeea$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
     // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $4fc44b7c7ca8aeea$var$defaultCheckedIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jZ9og.default), {
    checked: true
});
const $4fc44b7c7ca8aeea$var$defaultIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jZ9og.default), {});
const $4fc44b7c7ca8aeea$var$Radio = /*#__PURE__*/ $70fFQ.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $4fc44b7c7ca8aeea$var$defaultCheckedIcon, color: color = "primary", icon: icon = $4fc44b7c7ca8aeea$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium" } = props, other = (0, $79yYo.default)(props, $4fc44b7c7ca8aeea$var$_excluded);
    const ownerState = (0, $20MOv.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $4fc44b7c7ca8aeea$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $3AnZy.default)();
    let checked = checkedProp;
    const onChange = (0, $3YAuu.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $4fc44b7c7ca8aeea$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $4x3bm.jsx)($4fc44b7c7ca8aeea$var$RadioRoot, (0, $20MOv.default)({
        type: "radio",
        icon: /*#__PURE__*/ $70fFQ.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $4fc44b7c7ca8aeea$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $70fFQ.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $4fc44b7c7ca8aeea$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref
    }, other));
});
var $4fc44b7c7ca8aeea$export$2e2bcd8739ae039 = $4fc44b7c7ca8aeea$var$Radio;

});
parcelRegister("jZ9og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8caff9433e5d0b2$export$2e2bcd8739ae039; });

var $20MOv = parcelRequire("20MOv");
parcelRequire("70fFQ");


var $dnDVi = parcelRequire("dnDVi");

var $cjMMv = parcelRequire("cjMMv");

var $71Pr4 = parcelRequire("71Pr4");

var $4x3bm = parcelRequire("4x3bm");
const $e8caff9433e5d0b2$var$RadioButtonIconRoot = (0, $71Pr4.default)("span")({
    position: "relative",
    display: "flex"
});
const $e8caff9433e5d0b2$var$RadioButtonIconBackground = (0, $71Pr4.default)((0, $dnDVi.default))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $e8caff9433e5d0b2$var$RadioButtonIconDot = (0, $71Pr4.default)((0, $cjMMv.default))(({ theme: theme, ownerState: ownerState })=>(0, $20MOv.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $e8caff9433e5d0b2$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $20MOv.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($e8caff9433e5d0b2$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)($e8caff9433e5d0b2$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)($e8caff9433e5d0b2$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $e8caff9433e5d0b2$export$2e2bcd8739ae039 = $e8caff9433e5d0b2$var$RadioButtonIcon;

});
parcelRegister("dnDVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bdc64396e0c15f7$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $9bdc64396e0c15f7$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");

});

parcelRegister("cjMMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f7d1958a660145f$export$2e2bcd8739ae039; });
parcelRequire("70fFQ");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $8f7d1958a660145f$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");

});


parcelRegister("3YAuu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e534803aabd1c94$export$2e2bcd8739ae039; });

var $6tMUR = parcelRequire("6tMUR");
var $2e534803aabd1c94$export$2e2bcd8739ae039 = (0, $6tMUR.default);

});

parcelRegister("3AnZy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c7582930b706b9$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");

var $7b960 = parcelRequire("7b960");
function $29c7582930b706b9$export$2e2bcd8739ae039() {
    return $70fFQ.useContext((0, $7b960.default));
}

});
parcelRegister("7b960", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53a09dbe07fbaf1c$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
/**
 * @ignore - internal component.
 */ const $53a09dbe07fbaf1c$var$RadioGroupContext = /*#__PURE__*/ $70fFQ.createContext(undefined);
var $53a09dbe07fbaf1c$export$2e2bcd8739ae039 = $53a09dbe07fbaf1c$var$RadioGroupContext;

});


parcelRegister("7QIvB", function(module, exports) {

$parcel$export(module.exports, "getRadioUtilityClass", function () { return $5b6fea3698d1392d$export$192f7b2363c77155; });
$parcel$export(module.exports, "default", function () { return $5b6fea3698d1392d$export$2e2bcd8739ae039; });

var $dtsUs = parcelRequire("dtsUs");
var $jLqVN = parcelRequire("jLqVN");
function $5b6fea3698d1392d$export$192f7b2363c77155(slot) {
    return (0, $dtsUs.default)("MuiRadio", slot);
}
const $5b6fea3698d1392d$var$radioClasses = (0, $jLqVN.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary"
]);
var $5b6fea3698d1392d$export$2e2bcd8739ae039 = $5b6fea3698d1392d$var$radioClasses;

});


parcelRegister("bg50F", function(module, exports) {
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83251325b328da74$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $83251325b328da74$var$_default = (0, $83251325b328da74$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "CheckCircleOutline");
module.exports.default = $83251325b328da74$var$_default;

});

parcelRegister("6lvOy", function(module, exports) {
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49ed61eb46db3908$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $49ed61eb46db3908$var$_default = (0, $49ed61eb46db3908$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "KeyboardArrowLeft");
module.exports.default = $49ed61eb46db3908$var$_default;

});

parcelRegister("lbjAq", function(module, exports) {
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6b9d187fcf42006$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $f6b9d187fcf42006$var$_default = (0, $f6b9d187fcf42006$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight");
module.exports.default = $f6b9d187fcf42006$var$_default;

});

parcelRegister("6jgOg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49818e7cd5c563e8$export$2e2bcd8739ae039; });

var $70fFQ = parcelRequire("70fFQ");
function $49818e7cd5c563e8$export$2e2bcd8739ae039(callback, delay) {
    const savedCallback = (0, $70fFQ.useRef)();
    // Remember the latest callback.
    (0, $70fFQ.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $70fFQ.useEffect)(()=>{
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
}

});


var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");
var $94a1820d6644dae9$exports = {};

$parcel$export($94a1820d6644dae9$exports, "createRoot", function () { return $94a1820d6644dae9$export$882461b6382ed46c; }, function (v) { return $94a1820d6644dae9$export$882461b6382ed46c = v; });
$parcel$export($94a1820d6644dae9$exports, "hydrateRoot", function () { return $94a1820d6644dae9$export$757ceba2d55c277e; }, function (v) { return $94a1820d6644dae9$export$757ceba2d55c277e = v; });
var $94a1820d6644dae9$export$882461b6382ed46c;
var $94a1820d6644dae9$export$757ceba2d55c277e;
"use strict";

var $3glZ1 = parcelRequire("3glZ1");
var $94a1820d6644dae9$var$i;
$94a1820d6644dae9$export$882461b6382ed46c = $3glZ1.createRoot;
$94a1820d6644dae9$export$757ceba2d55c277e = $3glZ1.hydrateRoot;



var $dsvUQ = parcelRequire("dsvUQ");

var $20MOv = parcelRequire("20MOv");

var $70fFQ = parcelRequire("70fFQ");


var $cNmNk = parcelRequire("cNmNk");

var $kfZqu = parcelRequire("kfZqu");

var $4x3bm = parcelRequire("4x3bm");
const $111504f542e6f1a6$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $20MOv.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && {
        colorScheme: theme.palette.mode
    });
const $111504f542e6f1a6$export$32180ef41b15b513 = (theme)=>(0, $20MOv.default)({
        color: theme.palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: theme.palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: theme.palette.common.white
        }
    });
const $111504f542e6f1a6$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components, _theme$components$Mui;
    let defaultStyles = {
        html: $111504f542e6f1a6$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $20MOv.default)({
            margin: 0
        }, $111504f542e6f1a6$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: theme.palette.background.default
            }
        })
    };
    const themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $111504f542e6f1a6$var$CssBaseline(inProps) {
    const props = (0, $cNmNk.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $4x3bm.jsxs)($70fFQ.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $kfZqu.default), {
                styles: (theme)=>$111504f542e6f1a6$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $111504f542e6f1a6$export$2e2bcd8739ae039 = $111504f542e6f1a6$var$CssBaseline;



var $lM6lR = parcelRequire("lM6lR");
var $5vXJC = parcelRequire("5vXJC");

var $gOgWf = parcelRequire("gOgWf");

var $bMr3l = parcelRequire("bMr3l");
var $f1e1a6fa5ed79428$exports = {};

$f1e1a6fa5ed79428$exports = (parcelRequire("6UIir")).getBundleURL("ak0ox") + "Inter-roman.var.c7ef754c.woff2";


var $413aab18001e136a$exports = {};

$413aab18001e136a$exports = (parcelRequire("6UIir")).getBundleURL("ak0ox") + "Inter-italic.var.6edd0203.woff2";


const $798fe7a4458df1c3$var$interRoman = {
    fontFamily: "Inter var",
    fontWeight: "100 900",
    fontDisplay: "swap",
    fontStyle: "normal",
    fontNamedInstance: "Regular",
    src: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($f1e1a6fa5ed79428$exports)))}) format("woff2")`
};
const $798fe7a4458df1c3$var$interItalic = {
    fontFamily: "Inter var",
    fontWeight: "100 900",
    fontDisplay: "swap",
    fontStyle: "italic",
    fontNamedInstance: "Italic",
    src: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($413aab18001e136a$exports)))}) format("woff2")`
};
var $798fe7a4458df1c3$export$2e2bcd8739ae039 = (0, $bMr3l.default)({
    typography: {
        fontFamily: [
            "Inter",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(","),
        h4: {
            fontWeight: 500,
            letterSpacing: "-1px"
        }
    },
    palette: {
        background: {
            default: "#f5f5f5"
        },
        primary: {
            main: "#0070FF"
        },
        secondary: {
            main: "#f50057"
        },
        success: {
            main: "#c5e1a5",
            light: "#dcedc8",
            dark: "#aed581",
            contrastText: "#8bc34a"
        },
        text: {
            primary: "#404040",
            secondary: "rgba(0, 0, 0, 0.6)",
            disabled: "#D7D7D7"
        },
        warning: {
            main: "#ffe082",
            light: "#ffecb3",
            dark: "#ffd54f",
            contrastText: "#ffb300"
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "@global": {
                    "@font-face": [
                        $798fe7a4458df1c3$var$interRoman,
                        $798fe7a4458df1c3$var$interItalic
                    ]
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                inset: {
                    marginLeft: 16
                }
            }
        },
        MuiListItem: {
            button: {
                styleOverrides: {
                    "&:hover": {
                        backgroundColor: "rgba(0,0,0,0)"
                    }
                }
            }
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    backgroundColor: "#fff"
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                overline: {
                    fontSize: "0.65rem"
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                sizeSmall: {
                    fontSize: "0.625rem"
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeExtraLarge: {
                    padding: 12,
                    width: 64,
                    height: 64,
                    fontSize: 48,
                    "& svg": {
                        height: 48,
                        width: 48,
                        fontSize: 48
                    }
                },
                sizeSmall: {
                    padding: 5,
                    "& svg": {
                        maxHeight: 20,
                        maxWidth: 20
                    }
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    color: "#01a3ff",
                    height: 1
                },
                rail: {
                    height: 1
                },
                track: {
                    height: 1
                },
                thumb: {
                    width: 12,
                    height: 12,
                    background: "#01a3ff"
                }
            }
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    display: "block"
                }
            }
        },
        MuiListSubheader: {
            styleOverrides: {
                root: {
                    fontWeight: 400,
                    fontSize: "0.8rem",
                    borderBottom: "1px solid #DFDFDF"
                },
                sticky: {
                    backgroundColor: "#fff"
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "0.875rem"
                }
            }
        }
    }
});



var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $dih0O = parcelRequire("dih0O");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $iWaGk = parcelRequire("iWaGk");
const $49502641be0ebafe$var$KeyboardShortcuts = ({ children: children })=>{
    const { buildingStore: buildingStore, uiStore: uiStore } = (0, $iWaGk.default)();
    const history = (0, $dih0O.useHistory)();
    const handleOnKeyDown = (e)=>{
        const { pickedResults: pickedResults, resultMap: resultMap } = buildingStore;
        if (e.ctrlKey && e.keyCode === "P".charCodeAt(0)) {
            e.preventDefault();
            if (uiStore.version === "v2") uiStore.setUIVersion("v1");
            else uiStore.setUIVersion("v2");
        }
        if (history.location.pathname === "/search") {
            if (e.ctrlKey && e.keyCode === "A".charCodeAt(0)) {
                e.preventDefault();
                uiStore.setSearchPanelState("picker");
                if (resultMap.size === pickedResults.size) buildingStore.clearPicked();
                else buildingStore.pickAllResults();
            }
        }
    };
    (0, $70fFQ.useEffect)(()=>{
        window.addEventListener("keydown", handleOnKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleOnKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        style: {
            height: "inherit"
        },
        tabIndex: "-1",
        role: "complementary",
        // onKeyDown={handleOnKeyDown}
        onPaste: ()=>{
        /*

        return;
        if (!projectDetailStore.id) return;
        const paste = (event.clipboardData || window.clipboardData).getData(
          'text'
        );

        const data = paste
          .split(`\n`)
          .map(line => {
            return line
              .split(`\t`)
              .map(item => `"${item}"`)
              .join('\t');
          })
          .join(`\n`);
        console.log(data);

        const blob = new Blob([data], { type: 'text/plain' });
        projectDetailStore.setAcceptedFiles([blob]);
        event.preventDefault();
        */ },
        children: children
    });
};
var $49502641be0ebafe$export$2e2bcd8739ae039 = (0, $87gt0.observer)($49502641be0ebafe$var$KeyboardShortcuts);



var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $7zM2h = parcelRequire("7zM2h");

var $gOgWf = parcelRequire("gOgWf");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $iWaGk = parcelRequire("iWaGk");
const $07bac6c924ea40e1$var$NotificationBar = ()=>{
    const [open, setOpen] = (0, $70fFQ.useState)(false);
    const [notification, setNotification] = (0, $70fFQ.useState)(null);
    const { userStore: userStore } = (0, $iWaGk.default)();
    (0, $70fFQ.useEffect)(()=>(0, $gOgWf.autorun)(()=>{
            const [notification] = userStore.notifications.slice(-1);
            if (notification) {
                setNotification(notification);
                setOpen(true);
                setTimeout(()=>{
                    setOpen(false);
                }, 5000);
            }
        }), []);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7zM2h.default), {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        open: open,
        message: notification === null || notification === void 0 ? void 0 : notification.title
    });
};
var $07bac6c924ea40e1$export$2e2bcd8739ae039 = (0, $87gt0.observer)($07bac6c924ea40e1$var$NotificationBar);



var $2QP2i = parcelRequire("2QP2i");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $dih0O = parcelRequire("dih0O");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $27ZKj = parcelRequire("27ZKj");

var $4x3bm = parcelRequire("4x3bm");

var $hqhdr = parcelRequire("hqhdr");

var $dih0O = parcelRequire("dih0O");

var $70fFQ = parcelRequire("70fFQ");
const $4aa0f072730a5215$var$PrivateRoute = ({ userStore: userStore, component: Component, location: location })=>{
    const history = (0, $dih0O.useHistory)();
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($hqhdr))).parse(window.location.search.substring(1));
    (0, $70fFQ.useEffect)(()=>{
        if (!userStore.isLoggedIn && query.code) (async ()=>{
            await userStore.loginWithCode(query.code);
            history.push(window.location.pathname);
        })();
    }, []);
    if (!userStore.isLoggedIn && query.code) return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {});
    if (!userStore.loggedIn) return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Redirect), {
        to: {
            pathname: "/login",
            state: {
                referrer: location.pathname
            }
        }
    });
    if (location.pathname.startsWith("/search") && !userStore.hasAccess("prospecting")) return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {});
    return /*#__PURE__*/ (0, $4x3bm.jsx)(Component, {});
};
var $4aa0f072730a5215$export$2e2bcd8739ae039 = $4aa0f072730a5215$var$PrivateRoute;


/* eslint-disable prefer-destructuring */ /* eslint-disable no-await-in-loop */ /* eslint-disable no-restricted-syntax */ 
var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $bdM1R = parcelRequire("bdM1R");
var $fRNcc = parcelRequire("fRNcc");
var $3PGZI = parcelRequire("3PGZI");
var $hsXqC = parcelRequire("hsXqC");
var $bDcYY = parcelRequire("bDcYY");
var $27ZKj = parcelRequire("27ZKj");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $e3e0ce42694788c1$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "CheckCircleOutline");


var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $d5e315da602eee3d$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


var $4KbVS = parcelRequire("4KbVS");

var $96kno = parcelRequire("96kno");

var $fuiMG = parcelRequire("fuiMG");

var $lUBOG = parcelRequire("lUBOG");
function $a17ae84f2c373946$export$2e2bcd8739ae039() {
    const [expanded, setExpanded] = (0, $70fFQ.useState)(false);
    const [browserExpanded, setBrowserExpanded] = (0, $70fFQ.useState)(false);
    const [specExpanded, setSpecExpanded] = (0, $70fFQ.useState)(false);
    const [finalTests, setFinalTests] = (0, $70fFQ.useState)([]);
    const url = `${(0, $lUBOG.default).E2E_API_URL}test_results`;
    const setExpanedPanel = (panel)=>(event, isExpanded)=>{
            setExpanded(isExpanded ? panel : false);
        };
    const handleBrowserExpand = (panel)=>(event, isBrowserExpanded)=>{
            setBrowserExpanded(isBrowserExpanded ? panel : false);
        };
    const handleSpecExpand = (panel)=>(event, isSpecExpanded)=>{
            setSpecExpanded(isSpecExpanded ? panel : false);
        };
    const sortNameAndNumber = (title)=>{
        let number = "";
        let name = "";
        const numbers = "0123456789";
        for(let i = 0; i < title.length; i += 1){
            const curChar = title[i];
            if (numbers.includes(curChar)) number += curChar;
            else if (curChar !== "-") name += curChar;
        }
        return [
            number,
            name
        ];
    };
    const fetchResults = async (curTest)=>{
        try {
            const { name: name } = curTest;
            const { data: data } = await (0, (/*@__PURE__*/$parcel$interopDefault($96kno))).get(`${url}/${name}/results.json`);
            const results = [];
            if (data.suites[0]) data.suites[0].suites.forEach((x)=>{
                if (x.suites) results.push(x.suites[0]);
                results.push(x);
            });
            return results;
        } catch (err) {
            console.log(err);
            return [];
        }
    };
    const browserSort = (set)=>{
        const chromium = {
            browser: "chromium",
            specs: [],
            errorCount: 0
        };
        const firefox = {
            browser: "firefox",
            specs: [],
            errorCount: 0
        };
        const webkit = {
            browser: "webkit",
            specs: [],
            errorCount: 0
        };
        set.forEach((x)=>{
            const curBrowser = x.browser;
            const { status: status } = x.tests[0].results[0];
            if (curBrowser === "chromium") {
                if (status !== "passed") chromium.errorCount += 1;
                chromium.specs.push(x);
            }
            if (curBrowser === "webkit") {
                if (status !== "passed") webkit.errorCount += 1;
                webkit.specs.push(x);
            }
            if (curBrowser === "firefox") {
                if (status !== "passed") firefox.errorCount += 1;
                firefox.specs.push(x);
            }
        });
        return [
            chromium,
            firefox,
            webkit
        ];
    };
    const parseResults = (newTests)=>{
        newTests.sort((a, b)=>{
            return b.name.localeCompare(a.name);
        });
        const normalizedData = [];
        for(let i = 0; i < newTests.length; i += 1){
            const thisTest = newTests[i];
            const { mtime: mtime, results: results, name: name } = thisTest;
            const specsArray = [];
            normalizedData[i] = {};
            normalizedData[i].mtime = mtime;
            normalizedData[i].name = name;
            normalizedData[i].errorTotal = 0;
            normalizedData[i].allSpecs = [];
            normalizedData[i].timeSinceText = (0, $fuiMG.timeSince)(new Date(mtime));
            if (results) for(let j = 0; j < results.length; j += 1){
                const curSet = results[j];
                specsArray.push(curSet.specs);
            }
            normalizedData[i].allSpecs = specsArray.flat();
            for(let z = 0; z < normalizedData[i].allSpecs.length; z += 1){
                const nameAndNumber = sortNameAndNumber(normalizedData[i].allSpecs[z].title);
                normalizedData[i].allSpecs[z].order = nameAndNumber[0];
                normalizedData[i].allSpecs[z].title = nameAndNumber[1];
                normalizedData[i].allSpecs[z].browser = normalizedData[i].allSpecs[z].tests[0].projectName;
                normalizedData[i].allSpecs[z].duration = normalizedData[i].allSpecs[z].tests[0].results[0].duration / 1000;
                normalizedData[i].allSpecs.sort((a, b)=>{
                    return a.order - b.order;
                });
            }
            normalizedData[i].allSpecs = browserSort(normalizedData[i].allSpecs);
            normalizedData[i].allSpecs.forEach((x)=>{
                const { errorCount: errorCount } = x;
                normalizedData[i].errorTotal += errorCount;
            });
        }
        return normalizedData;
    };
    const fetchAndParseResults = async ()=>{
        const { data: data } = await (0, (/*@__PURE__*/$parcel$interopDefault($96kno))).get(url);
        const resultsToFetch = data.slice(-30);
        const tests = [];
        for (const curTest of resultsToFetch){
            const results = await fetchResults(curTest);
            if (results.length > 0) tests.push((0, $edHbI._)((0, $2QP2i._)({}, curTest), {
                results: results
            }));
        }
        const parsedResults = parseResults(tests);
        setFinalTests(parsedResults);
    };
    (0, $70fFQ.useEffect)(()=>{
        fetchAndParseResults();
    }, []);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
        sx: {
            width: "100%",
            height: "100%",
            overflow: "auto",
            paddingTop: 4
        },
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
            sx: {
                width: "40%",
                maxWidth: 920,
                minWidth: 460,
                margin: "auto"
            },
            children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                children: finalTests.map(({ allSpecs: allSpecs, timeSinceText: timeSinceText, errorTotal: errorTotal, name: name })=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bdM1R.default), {
                        expanded: expanded === name,
                        onChange: setExpanedPanel(name),
                        TransitionProps: {
                            unmountOnExit: true
                        },
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $3PGZI.default), {
                                expandIcon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4KbVS.default), {}),
                                "aria-controls": "panel1bh-content",
                                id: "panel1bh-header",
                                style: {
                                    justifyContent: "center"
                                },
                                sx: {
                                    alignItems: "center",
                                    overflow: "wrap"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hsXqC.default), {
                                        color: "error",
                                        children: errorTotal > 0 ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $d5e315da602eee3d$export$2e2bcd8739ae039), {
                                            sx: {
                                                marginRight: 8
                                            },
                                            color: "error"
                                        }) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e3e0ce42694788c1$export$2e2bcd8739ae039), {
                                            sx: {
                                                marginRight: 8
                                            },
                                            color: "primary"
                                        })
                                    }),
                                    name,
                                    " - ",
                                    timeSinceText,
                                    " ago"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fRNcc.default), {
                                children: allSpecs.filter((x)=>x.specs.length > 0).map((x, i)=>{
                                    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bdM1R.default), {
                                        expanded: browserExpanded === x.browser + i,
                                        onChange: handleBrowserExpand(x.browser + i),
                                        TransitionProps: {
                                            unmountOnExit: true
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $3PGZI.default), {
                                                expandIcon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4KbVS.default), {}),
                                                "aria-controls": "panel1bh-content",
                                                id: "panel1bh-header",
                                                style: {
                                                    alignText: "center"
                                                },
                                                children: [
                                                    x.browser,
                                                    x.errorCount ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hsXqC.default), {
                                                        color: "error",
                                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $d5e315da602eee3d$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                marginRight: 8
                                                            },
                                                            color: "error",
                                                            fontSize: "small"
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fRNcc.default), {
                                                children: x.specs.map((y, i)=>{
                                                    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bdM1R.default), {
                                                        expanded: specExpanded === i + y.title,
                                                        onChange: handleSpecExpand(i + y.title),
                                                        TransitionProps: {
                                                            unmountOnExit: true
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $3PGZI.default), {
                                                                expandIcon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4KbVS.default), {}),
                                                                "aria-controls": "panel1bh-content",
                                                                id: "panel1bh-header",
                                                                style: {
                                                                    alignItems: "center"
                                                                },
                                                                sx: {
                                                                    alignItems: "center",
                                                                    overflow: "wrap"
                                                                },
                                                                children: [
                                                                    y.tests[0].results[0].status === "passed" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e3e0ce42694788c1$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            marginRight: 8
                                                                        },
                                                                        fontSize: "medium",
                                                                        color: "primary"
                                                                    }),
                                                                    y.tests[0].results[0].status !== "passed" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $d5e315da602eee3d$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            marginRight: 8
                                                                        },
                                                                        color: "error",
                                                                        fontSize: "medium"
                                                                    }),
                                                                    y.title
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $fRNcc.default), {
                                                                children: [
                                                                    y.tests[0].results[0].attachments && y.tests[0].results[0].attachments.map((attachment)=>{
                                                                        return attachment.name.includes("video") ? /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                                                    variant: "subtitle2",
                                                                                    children: "Video:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $4x3bm.jsx)("video", {
                                                                                    width: "100%",
                                                                                    autoPlay: true,
                                                                                    muted: true,
                                                                                    loop: true,
                                                                                    controls: true,
                                                                                    src: `${url}/${attachment.path}`
                                                                                })
                                                                            ]
                                                                        }, `${attachment.name}`) : /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                                                    variant: "subtitle2",
                                                                                    children: "Screenshot:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                                                                    component: "img",
                                                                                    src: `${url}${attachment.path.slice(26)}`,
                                                                                    width: "100%"
                                                                                })
                                                                            ]
                                                                        }, `${attachment.name}`);
                                                                    }),
                                                                    y.tests[0].results[0].error && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                                                        variant: "subtitle2",
                                                                        children: [
                                                                            "Error:",
                                                                            " ",
                                                                            y.tests[0].results[0].error.message
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, `${name}${y.title}`);
                                                })
                                            })
                                        ]
                                    }, `${name}${x.browser}}`);
                                })
                            })
                        ]
                    }, name))
            })
        })
    });
}



var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");


var $lUBOG = parcelRequire("lUBOG");
const $4a01c454afb76c25$var$Auth = ({ match: match })=>{
    const { method: method } = match.params;
    console.log((0, $lUBOG.default));
    if (method === "arcgis") window.location.href = `${(0, $lUBOG.default).E2E_API_URL}auth/arcgis`;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {});
};
var $4a01c454afb76c25$export$2e2bcd8739ae039 = $4a01c454afb76c25$var$Auth;


/* eslint react/no-danger: 0 */ 
var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $dsvUQ = parcelRequire("dsvUQ");
var $dih0O = parcelRequire("dih0O");

var $7xvOw = parcelRequire("7xvOw");
var $9Vd8j = parcelRequire("9Vd8j");
var $697xl = parcelRequire("697xl");
var $b2gZS = parcelRequire("b2gZS");
var $7adKh = parcelRequire("7adKh");
var $8VJ2N = parcelRequire("8VJ2N");
var $3cESc = parcelRequire("3cESc");
var $1IOh3 = parcelRequire("1IOh3");
var $27ZKj = parcelRequire("27ZKj");
var $00703a9646241803$exports = {};

$00703a9646241803$exports = (parcelRequire("6UIir")).getBundleURL("ak0ox") + "signin.49105d33.jpg";



var $lxEiN = parcelRequire("lxEiN");

var $3U8SM = parcelRequire("3U8SM");

var $iWaGk = parcelRequire("iWaGk");

var $etOpj = parcelRequire("etOpj");

function $803f9f4f70fb5181$var$SignIn({ history: history, location: location, match: match }) {
    const { userStore: userStore } = (0, $iWaGk.default)();
    const [isTokenValid, setIsTokenValid] = (0, $70fFQ.useState)(null);
    const [error, setError] = (0, $70fFQ.useState)({});
    const { resetPasswordToken: resetPasswordToken, userActivationToken: userActivationToken } = match.params;
    const emailInput = (0, $70fFQ.useRef)(null);
    const passwordInput = (0, $70fFQ.useRef)(null);
    const passwordRepeatInput = (0, $70fFQ.useRef)(null);
    const honeyPotInput = (0, $70fFQ.useRef)(null);
    const [passwordResetEmailSent, setPasswordResetEmailSent] = (0, $70fFQ.useState)(false);
    const [userIsActivated, setUserIsActivated] = (0, $70fFQ.useState)(null);
    (0, $70fFQ.useEffect)(()=>{
        if (!resetPasswordToken) return;
        (async ()=>{
            const response = await (0, $lxEiN.default).User.validateResetToken(resetPasswordToken);
            setIsTokenValid(response.data.is_valid);
        })();
    }, [
        resetPasswordToken
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (!userActivationToken) return;
        (async ()=>{
            const response = await (0, $lxEiN.default).User.validateUserActivationToken(userActivationToken);
            await userStore.fetchCredentials();
            const { redirect: redirect } = response.data;
            if (redirect) history.push(redirect);
            setUserIsActivated(response.data.ok === 1);
        })();
    }, [
        userActivationToken
    ]);
    const handleSubmit = async (e)=>{
        var _location_state;
        e.preventDefault();
        // if (honeyPotInput?.current?.value) return;
        if (resetPasswordToken) {
            const newPassword = passwordInput.current.value;
            const newPasswordRepeat = passwordRepeatInput.current.value;
            if (newPassword !== newPasswordRepeat) {
                setError({
                    "password-repeat": "The password confirmation does not match"
                });
                return;
            }
            setError({});
            const { data: data } = await (0, $3U8SM.default).post(`/reset/${resetPasswordToken}`, {
                password: newPassword,
                resetPasswordToken: resetPasswordToken
            });
            if (data.ok) return history.push("/");
        }
        const email = emailInput.current.value;
        const password = passwordInput.current.value;
        const success = await userStore.login(email, password);
        if (!success) {
            setError({
                "password-error": "Wrong username/password combination"
            });
            passwordInput.current.value = "";
        } else history.push(((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.referrer) || "/");
    };
    const handlePasswordResetSubmit = (event)=>{
        event.preventDefault();
        const email = emailInput.current.value;
        (0, $lxEiN.default).User.sendPasswordResetEmail(email);
        setPasswordResetEmailSent(true);
    };
    const tosText = {
        __html: `I agree with the <a target="_blank" href="https://gridmarket.com/terms-of-use/">Terms Of Use</a> and <a target="_blank" href="https://gridmarket.com/privacy-policy/">Privacy Policy</a>`
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
        className: "sign-in",
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("main", {
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $dih0O.Switch), {
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                            path: "/forgot-password",
                            render: ()=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)("form", {
                                        onSubmit: handlePasswordResetSubmit,
                                        children: [
                                            passwordResetEmailSent && /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                        align: "center",
                                                        variant: "h6",
                                                        children: "Password reset e-mail has been sent"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                        gutterBottom: true,
                                                        align: "center",
                                                        variant: "body2",
                                                        children: "Password reset e-mail has been sent to you, check your e-mail"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                        align: "center",
                                                        variant: "body2",
                                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsvUQ.Link), {
                                                            to: "/",
                                                            children: "Back to login"
                                                        })
                                                    })
                                                ]
                                            }),
                                            !passwordResetEmailSent && /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                        align: "center",
                                                        variant: "h6",
                                                        children: "Reset your password"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                        align: "center",
                                                        variant: "body2",
                                                        children: "Type in your e-mail and we'll send you the link to reset your password"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                                        margin: "normal",
                                                        required: true,
                                                        fullWidth: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                                htmlFor: "email",
                                                                children: "Email Address"
                                                            }),
                                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                                inputRef: emailInput,
                                                                id: "email",
                                                                name: "email",
                                                                autoComplete: "email",
                                                                type: "email",
                                                                autoFocus: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                                        className: "sign-in-buttons",
                                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                            type: "submit",
                                                            variant: "outlined",
                                                            color: "primary",
                                                            size: "large",
                                                            children: "Sendd"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                            path: "/login/activate/:userActivationToken",
                            exact: true,
                            render: ()=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                    children: [
                                        userIsActivated === true && /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Redirect), {
                                                to: {
                                                    pathname: "/",
                                                    search: ""
                                                }
                                            })
                                        }),
                                        userIsActivated === false && /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                    align: "center",
                                                    variant: "h6",
                                                    children: "Your account activation link is invalid"
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                    gutterBottom: true,
                                                    align: "center",
                                                    variant: "body2",
                                                    children: "Please check your e-mail for the correct link"
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                    align: "center",
                                                    variant: "body2",
                                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsvUQ.Link), {
                                                        to: "/",
                                                        children: "Back to login"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                            path: "/login",
                            exact: true,
                            render: ()=>/*#__PURE__*/ (0, $4x3bm.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                            align: "center",
                                            variant: "h6",
                                            children: "Sign in"
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                            margin: "normal",
                                            required: true,
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                    htmlFor: "email",
                                                    children: "Email Address"
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                    inputRef: emailInput,
                                                    id: "email",
                                                    name: "email",
                                                    autoComplete: "email",
                                                    autoFocus: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                            margin: "normal",
                                            required: true,
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                    htmlFor: "password",
                                                    children: "Password"
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                    inputRef: passwordInput,
                                                    name: "password",
                                                    type: "password",
                                                    id: "password",
                                                    autoComplete: "current-password"
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7adKh.default), {
                                                    error: true,
                                                    children: error["password-error"]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $697xl.default), {
                                            style: {
                                                transform: "translateX(-10000px)",
                                                height: 1,
                                                margin: 0,
                                                overflow: "hidden",
                                                position: "fixed"
                                            },
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                style: {
                                                    transform: "translateX(-10000px)",
                                                    height: 1,
                                                    display: "none"
                                                },
                                                inputRef: honeyPotInput,
                                                name: "password",
                                                type: "password",
                                                id: "password",
                                                autoComplete: "new-password"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                            justifyContent: "flex-end",
                                            alignItems: "right",
                                            container: true,
                                            spacing: 3,
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsvUQ.Link), {
                                                    to: "/forgot-password",
                                                    children: "Forgot your password?"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                            justifyContent: "flex-end",
                                            alignItems: "right",
                                            container: true,
                                            spacing: 3,
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                                style: {
                                                    display: "none"
                                                },
                                                item: true,
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsvUQ.Link), {
                                                    color: "primary",
                                                    to: "/auth/arcgis",
                                                    children: "Sign in with ArcGIS"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                            className: "sign-in-buttons",
                                            children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $7xvOw.default), {
                                                type: "submit",
                                                variant: "outlined",
                                                color: "primary",
                                                size: "large",
                                                children: [
                                                    resetPasswordToken && /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                                        children: "Submit"
                                                    }),
                                                    !resetPasswordToken && /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                                        children: "Sign in"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                            exact: true,
                            path: "/login/:token",
                            children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                children: [
                                    isTokenValid === null && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {}),
                                    isTokenValid === false && /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                align: "center",
                                                variant: "h6",
                                                children: "Your link has expired"
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                                align: "center",
                                                variant: "body1",
                                                children: [
                                                    "Your account activation link has expired. If you have already activated your account then",
                                                    " ",
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsvUQ.Link), {
                                                        to: "/",
                                                        children: "sign in"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    isTokenValid === true && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                        children: /*#__PURE__*/ (0, $4x3bm.jsxs)("form", {
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                    align: "center",
                                                    variant: "h6",
                                                    children: "Create your new password"
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                                    margin: "normal",
                                                    required: true,
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                            htmlFor: "password",
                                                            children: "Password"
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                            inputProps: {
                                                                minlength: 6
                                                            },
                                                            autoComplete: "current-password",
                                                            id: "password",
                                                            inputRef: passwordInput,
                                                            name: "password",
                                                            type: "password"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                                    margin: "normal",
                                                    required: true,
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                            htmlFor: "password",
                                                            children: "Repeat Password"
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                            autoComplete: "current-password",
                                                            id: "password-repeat",
                                                            error: error["password-repeat"],
                                                            inputRef: passwordRepeatInput,
                                                            name: "password-repeat",
                                                            type: "password"
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7adKh.default), {
                                                            id: "my-helper-text",
                                                            children: error["password-repeat"]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $b2gZS.default), {
                                                    control: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Vd8j.default), {
                                                        required: true,
                                                        value: "tos",
                                                        color: "primary"
                                                    }),
                                                    label: /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                                        dangerouslySetInnerHTML: tosText
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                                    className: "sign-in-buttons",
                                                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $7xvOw.default), {
                                                        type: "submit",
                                                        variant: "outlined",
                                                        color: "primary",
                                                        size: "large",
                                                        children: [
                                                            resetPasswordToken && /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                                                children: "Submit"
                                                            }),
                                                            !resetPasswordToken && /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                                                children: "Sign in"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                className: "sign-in-background",
                style: {
                    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($00703a9646241803$exports)))})`
                }
            })
        ]
    });
}
var $803f9f4f70fb5181$export$2e2bcd8739ae039 = (0, $87gt0.observer)($803f9f4f70fb5181$var$SignIn);



var $iWaGk = parcelRequire("iWaGk");

var $2QP2i = parcelRequire("2QP2i");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $dih0O = parcelRequire("dih0O");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $fuVrF = parcelRequire("fuVrF");
var $cGU07 = parcelRequire("cGU07");
var $5DHXT = parcelRequire("5DHXT");
var $27ZKj = parcelRequire("27ZKj");

var $dsTz1 = parcelRequire("dsTz1");
var $6mDA2 = parcelRequire("6mDA2");

var $dih0O = parcelRequire("dih0O");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $0qEbJ = parcelRequire("0qEbJ");

var $gfxK7 = parcelRequire("gfxK7");

var $jRWBX = parcelRequire("jRWBX");

var $7ZYVJ = parcelRequire("7ZYVJ");

var $iWaGk = parcelRequire("iWaGk");

const $61da6a620ff15715$var$MapContainer = /*#__PURE__*/ (0, $70fFQ.lazy)(()=>(parcelRequire("icIXl")));
const $61da6a620ff15715$var$Demo = ({ props: props })=>{
    const history = (0, $dih0O.useHistory)();
    const { buildingStore: buildingStore, buildingDetailStore: buildingDetailStore } = (0, $iWaGk.default)();
    const match = props === null || props === void 0 ? void 0 : props.match;
    const { buildingId: buildingId } = match.params;
    const [present, setPresent] = (0, $70fFQ.useState)(false);
    const [showSearch, setShowSearch] = (0, $70fFQ.useState)(true);
    let state = {
        y: 16,
        opacity: 1
    };
    if (showSearch) state = {
        y: 16,
        opacity: 1
    };
    if (!showSearch) state = {
        y: "90vh",
        opacity: 1
    };
    if (!showSearch && buildingId) state = {
        y: "90vh",
        opacity: 1
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
        className: "demo",
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                style: {
                    width: "100%",
                    top: 0,
                    height: "100%",
                    position: "fixed"
                },
                children: /*#__PURE__*/ (0, $4x3bm.jsx)($61da6a620ff15715$var$MapContainer, (0, $2QP2i._)({}, props))
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                role: "presentation",
                className: "demo-container",
                style: {
                    height: "100vh",
                    width: "100%",
                    overflow: "scroll",
                    position: "absolute",
                    cursor: present ? "pointer" : "default"
                },
                onClick: (event)=>{
                    if (event.target === event.currentTarget) {
                        if (!showSearch) {
                            document.querySelector(".demo-container").scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                            setShowSearch(true);
                            setPresent(false);
                        }
                    }
                /*
          setStyles({
            ...styles,
            container: {
              transform: `translateY(calc(100vh - 90px))`
            }
          });
          */ },
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                    style: {
                        // height: '100vh',
                        width: "960px",
                        margin: "auto",
                        position: "relative",
                        // paddingTop: 380,
                        zIndex: 1000
                    },
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6mDA2.motion).div, {
                            initial: {
                                opacity: 0,
                                y: 0
                            },
                            animate: (0, $2QP2i._)({
                                opacity: 1
                            }, state),
                            transition: {
                                ease: "easeOut",
                                duration: 0.3
                            },
                            exit: {
                                opacity: 0,
                                y: 0
                            },
                            children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                className: "search-container",
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                        className: "search-controls",
                                        elevation: 1,
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), {
                                            // value={value}
                                            onClick: (event)=>{
                                                setShowSearch(true);
                                                event.stopPropagation();
                                            /*
                  setStyles({
                    ...styles,
                    container: {
                      transform: `translateY(16px)`
                    }
                  });
                  */ },
                                            onChange: (event)=>{
                                                buildingStore.setFilter("addresses", event.target.value);
                                            },
                                            sx: {
                                                fontSize: 48,
                                                padding: 0,
                                                width: "100%"
                                            },
                                            className: "search-controls-input",
                                            placeholder: "Search...",
                                            startAdornment: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                                disabled: true,
                                                color: "default",
                                                style: {
                                                    width: 48,
                                                    marginRight: 16,
                                                    height: 48,
                                                    fontSize: 48
                                                },
                                                sx: {
                                                    largeIcon: {
                                                        fontSize: 48
                                                    }
                                                },
                                                onClick: ()=>{},
                                                size: "extraLarge",
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $0qEbJ.default), {})
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fuVrF.default), {}),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $jRWBX.default), {
                                        style: {
                                            position: "static",
                                            width: "100%",
                                            height: "100%",
                                            flexGrow: 1,
                                            flex: 1
                                        },
                                        getItemsSize: ()=>{
                                            return 90;
                                        },
                                        renderNoResults: ()=>{
                                            var _buildingStore_filters_addresses, _buildingStore_filters, _buildingStore_filters_addresses1, _buildingStore_filters1;
                                            return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                                    className: "search-result results results-none",
                                                    children: [
                                                        ((_buildingStore_filters = buildingStore.filters) === null || _buildingStore_filters === void 0 ? void 0 : (_buildingStore_filters_addresses = _buildingStore_filters.addresses) === null || _buildingStore_filters_addresses === void 0 ? void 0 : _buildingStore_filters_addresses.length) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                            variant: "h5",
                                                            children: "No results"
                                                        }),
                                                        !((_buildingStore_filters1 = buildingStore.filters) === null || _buildingStore_filters1 === void 0 ? void 0 : (_buildingStore_filters_addresses1 = _buildingStore_filters1.addresses) === null || _buildingStore_filters_addresses1 === void 0 ? void 0 : _buildingStore_filters_addresses1.length) && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                                            variant: "h5",
                                                            children: [
                                                                "Type an address into the search bar to begin.",
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            });
                                        },
                                        renderRow: ({ index: index, style: style, data: data })=>/*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                                className: "search-result",
                                                style: style,
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7ZYVJ.default), {
                                                    disableGrade: true,
                                                    onClick: (event)=>{
                                                        (async ()=>{
                                                            await buildingDetailStore.loadBuilding(data.id);
                                                            setPresent(true);
                                                            setShowSearch(false);
                                                        })();
                                                        event.stopPropagation();
                                                        history.push(`/demo/${data.id}`);
                                                    },
                                                    // to={`/demo/${data.id}`}
                                                    building: data
                                                })
                                            }, index),
                                        store: buildingStore
                                    })
                                ]
                            })
                        }, "search"),
                        /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                            role: "presentation",
                            onClick: (event)=>{
                                if (event.target === event.currentTarget) {
                                    setShowSearch(true);
                                    setPresent(false);
                                }
                            },
                            className: "building-container",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsTz1.AnimatePresence), {
                                children: present && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6mDA2.motion).div, {
                                    transition: {
                                        ease: "easeOut",
                                        duration: 0.3
                                    },
                                    initial: {
                                        opacity: 1,
                                        y: "100vh"
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 350
                                    },
                                    exit: {
                                        opacity: 1,
                                        y: "100vh"
                                    },
                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $gfxK7.default), {
                                        noHeader: true,
                                        isDemo: true,
                                        noHeaderMap: true,
                                        style: {
                                            cursor: "default",
                                            position: "static",
                                            margin: "auto",
                                            // height: 90000,
                                            // overflow: 'hidden',
                                            borderTopLeftRadius: 8,
                                            // transform: 'translateY(400px)',
                                            borderTopRightRadius: 8,
                                            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
                                        },
                                        history: history,
                                        match: (0, $edHbI._)((0, $2QP2i._)({}, match), {
                                            params: {
                                                buildingId: buildingId || "W167890836"
                                            }
                                        })
                                    })
                                }, "building")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $61da6a620ff15715$export$2e2bcd8739ae039 = (0, $87gt0.observer)($61da6a620ff15715$var$Demo);


/* eslint-disable jsx-a11y/media-has-caption */ 
var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $fTMNl = parcelRequire("fTMNl");

var $7xvOw = parcelRequire("7xvOw");

var $iuSYB = parcelRequire("iuSYB");

var $cvbk1 = parcelRequire("cvbk1");

var $daCoF = parcelRequire("daCoF");

var $3c7f6 = parcelRequire("3c7f6");

var $2zy57 = parcelRequire("2zy57");

var $e4z6Z = parcelRequire("e4z6Z");

var $27ZKj = parcelRequire("27ZKj");

var $bDcYY = parcelRequire("bDcYY");
var $7059dfb24aac4c1c$exports = {};
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty($7059dfb24aac4c1c$exports, "__esModule", {
    value: true
});
$7059dfb24aac4c1c$exports.default = void 0;

var $7059dfb24aac4c1c$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $7059dfb24aac4c1c$var$_default = (0, $7059dfb24aac4c1c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
}), "AttachFile");
$7059dfb24aac4c1c$exports.default = $7059dfb24aac4c1c$var$_default;


var $e780071ddc4ea0fa$exports = {};
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty($e780071ddc4ea0fa$exports, "__esModule", {
    value: true
});
$e780071ddc4ea0fa$exports.default = void 0;

var $e780071ddc4ea0fa$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $e780071ddc4ea0fa$var$_default = (0, $e780071ddc4ea0fa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65C8.03 15.48 8 15.23 8 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18c.31-.08.63-.12.94-.12.32 0 .63.04.95.12l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z"
}), "BugReportOutlined");
$e780071ddc4ea0fa$exports.default = $e780071ddc4ea0fa$var$_default;



var $cGU07 = parcelRequire("cGU07");
var $19a76c2c6739c4a8$exports = {};
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty($19a76c2c6739c4a8$exports, "__esModule", {
    value: true
});
$19a76c2c6739c4a8$exports.default = void 0;

var $19a76c2c6739c4a8$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $19a76c2c6739c4a8$var$_default = (0, $19a76c2c6739c4a8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), "FiberManualRecord");
$19a76c2c6739c4a8$exports.default = $19a76c2c6739c4a8$var$_default;



var $hsXqC = parcelRequire("hsXqC");

var $lxEiN = parcelRequire("lxEiN");
function $d757e86f9af94941$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const videoRef = (0, $70fFQ.useRef)();
    const textFieldRef = (0, $70fFQ.useRef)(null);
    const [hidden, setHidden] = (0, $70fFQ.useState)(null);
    const [stream, setStream] = (0, $70fFQ.useState)(null);
    const [files, setFiles] = (0, $70fFQ.useState)([]);
    const [videoBlobs, setVideoBlobs] = (0, $70fFQ.useState)([]);
    const onDrop = (acceptedFiles)=>{
        setFiles(acceptedFiles);
    };
    const { getRootProps: getRootProps, getInputProps: getInputProps, open: openFileDialog } = (0, $fTMNl.useDropzone)({
        onDrop: onDrop,
        noClick: true
    });
    const [submitted, setSubmitted] = (0, $70fFQ.useState)(false);
    const title = submitted ? "" : "Feedback";
    const stopRecording = async ()=>{
        setHidden(false);
        // recorder.stop();
        // stream.getVideoTracks()[0].stop();
        setStream(null);
    };
    const startRecording = async ()=>{
        const stream = await navigator.mediaDevices.getDisplayMedia({
            video: {
                mediaSource: "screen"
            }
        });
        setStream(stream);
        setHidden(true);
        const recorder = new MediaRecorder(stream);
        stream.getVideoTracks()[0].onended = ()=>{
            stopRecording();
        };
        const chunks = [];
        recorder.ondataavailable = (e)=>chunks.push(e.data);
        recorder.onstop = ()=>{
            const completeBlob = new Blob(chunks, {
                type: chunks[0].type
            });
            setVideoBlobs([
                completeBlob,
                ...videoBlobs
            ]);
        };
        recorder.start();
    };
    (0, $70fFQ.useEffect)(()=>{
        if (videoBlobs.length) {
            const blob = URL.createObjectURL(videoBlobs[0]);
            videoRef.current.src = blob;
        }
    }, [
        videoBlobs,
        videoBlobs
    ]);
    const handleSubmit = async ()=>{
        const formData = new FormData();
        files.forEach((file)=>formData.append("file[]", file));
        videoBlobs.forEach((blob, i)=>formData.append("file[]", blob, `blob${i}.mp4`));
        const { userAgent: userAgent } = navigator;
        const { href: href } = window.location;
        formData.append("user_agent", userAgent);
        formData.append("href", href);
        const { value: value } = textFieldRef.current;
        formData.append("feedback", value);
        await (0, $lxEiN.default).User.sendFeedback(formData);
        setSubmitted(true);
        setTimeout(()=>{
            onClose();
        }, 3000);
    };
    const style = hidden ? {
        display: "none",
        pointerEvents: "none"
    } : {};
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $cvbk1.default), (0, $edHbI._)((0, $2QP2i._)({
        style: style,
        open: open,
        onClose: onClose
    }, getRootProps()), {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)("input", (0, $2QP2i._)({
                webkitdirectory: true,
                directory: true,
                multiple: true
            }, getInputProps({
                disabled: false
            }))),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e4z6Z.default), {
                id: "form-dialog-title",
                children: title
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $3c7f6.default), {
                children: [
                    !submitted && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2zy57.default), {
                                children: "Please use this form for suggesting improvements and for submitting issues"
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                                inputRef: textFieldRef,
                                multiline: true,
                                rows: 4,
                                autoFocus: true,
                                margin: "dense",
                                id: "feedbcack",
                                label: "Feedback",
                                variant: "outlined",
                                type: "text",
                                fullWidth: true
                            }),
                            videoBlobs.length > 0 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)("video", {
                                    controls: true,
                                    width: "100%",
                                    ref: videoRef,
                                    autoPlay: true
                                })
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                display: "flex",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                variant: "contained",
                                                style: {
                                                    border: "none",
                                                    boxShadow: "none",
                                                    textTransform: "initial",
                                                    background: "none"
                                                },
                                                onClick: ()=>{
                                                    if (!stream) startRecording();
                                                    if (stream) stopRecording();
                                                },
                                                startIcon: stream ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($19a76c2c6739c4a8$exports))), {}) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($19a76c2c6739c4a8$exports))), {
                                                    color: "secondary"
                                                }),
                                                children: !videoBlobs.length ? `Press to record a video` : `Press to record another video`
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                                color: "primary",
                                                "aria-label": "upload picture",
                                                component: "span",
                                                style: {
                                                    color: "red"
                                                },
                                                size: "large"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                        "aria-label": "Close",
                                        onClick: openFileDialog,
                                        size: "medium",
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hsXqC.default), {
                                            badgeContent: files.length,
                                            color: "secondary",
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7059dfb24aac4c1c$exports))), {})
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    submitted && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                            p: 4,
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e780071ddc4ea0fa$exports))), {
                                    fontSize: "large",
                                    className: "feedback-bug",
                                    color: "secondary"
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                    gutterBottom: true,
                                    variant: "h5",
                                    children: "Thank you for your time !"
                                }),
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                    variant: "body1",
                                    children: "We will let you know when this issue has been solved"
                                })
                            ]
                        })
                    })
                ]
            }),
            !submitted && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $daCoF.default), {
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        onClick: onClose,
                        color: "secondary",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        onClick: ()=>{
                            handleSubmit();
                        },
                        color: "primary",
                        children: "Send"
                    })
                ]
            })
        ]
    }));
}



var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $cvbk1 = parcelRequire("cvbk1");

var $dih0O = parcelRequire("dih0O");
const $23953f26a187e6b6$var$DocumentSignModal = ({ match: match })=>{
    const history = (0, $dih0O.useHistory)();
    const { documentId: documentId } = match.params;
    const [open, setOpen] = (0, $70fFQ.useState)(true);
    const handleClose = ()=>{
        setOpen(false);
        history.push(`/`);
    };
    (0, $70fFQ.useEffect)(()=>{
        window.pandadoc_embed_config = {
            embed_uuid: documentId,
            width: 900,
            height: 700,
            element_id: "eOTEwMTcx"
        };
        (()=>{
            const pds = document.createElement("script");
            pds.type = "text/javascript";
            pds.async = true;
            pds.src = "https://dr79nymq4x8i9.cloudfront.net/embed/embed.js";
            (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(pds);
        })();
    }, [
        documentId
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cvbk1.default), {
        maxWidth: false,
        open: open,
        onClose: handleClose,
        "aria-labelledby": "simple-dialog-title",
        children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
            children: /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                id: "eOTEwMTcx"
            })
        })
    });
};
var $23953f26a187e6b6$export$2e2bcd8739ae039 = $23953f26a187e6b6$var$DocumentSignModal;



var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");
var $223d9dcabe73955f$exports = {};
"use strict";

var $kUwzY = parcelRequire("kUwzY");
Object.defineProperty($223d9dcabe73955f$exports, "__esModule", {
    value: true
});
$223d9dcabe73955f$exports.default = void 0;

var $223d9dcabe73955f$var$_SwipeableViews = $kUwzY((parcelRequire("o6Ww0")));
var $223d9dcabe73955f$var$_default = $223d9dcabe73955f$var$_SwipeableViews.default;
$223d9dcabe73955f$exports.default = $223d9dcabe73955f$var$_default;



var $bDcYY = parcelRequire("bDcYY");
var $7xvOw = parcelRequire("7xvOw");
var $9Vd8j = parcelRequire("9Vd8j");
var $fDlBJ = parcelRequire("fDlBJ");
var $cvbk1 = parcelRequire("cvbk1");
var $daCoF = parcelRequire("daCoF");
var $fuVrF = parcelRequire("fuVrF");
var $cGU07 = parcelRequire("cGU07");
var $5DHXT = parcelRequire("5DHXT");
var $W7alG = parcelRequire("W7alG");
var $eS4JX = parcelRequire("eS4JX");
var $9Xosf = parcelRequire("9Xosf");
var $2Z3Gv = parcelRequire("2Z3Gv");
var $iHyg3 = parcelRequire("iHyg3");
var $1mImZ = parcelRequire("1mImZ");
var $iuSYB = parcelRequire("iuSYB");
var $27ZKj = parcelRequire("27ZKj");

var $dih0O = parcelRequire("dih0O");

var $2mnfJ = parcelRequire("2mnfJ");

var $lBx17 = parcelRequire("lBx17");

var $c4gat = parcelRequire("c4gat");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $lxEiN = parcelRequire("lxEiN");

var $iWaGk = parcelRequire("iWaGk");
function $09243fa8c5e39d82$var$ProjectPicker() {
    const formEl = (0, $70fFQ.useRef)(null);
    const projectNameEl = (0, $70fFQ.useRef)(null);
    const projectDescriptionEl = (0, $70fFQ.useRef)(null);
    const { projectStore: projectStore, editorStore: editorStore, userStore: userStore, buildingStore: buildingStore, uiStore: uiStore } = (0, $iWaGk.default)();
    const location = (0, $dih0O.useLocation)();
    const history = (0, $dih0O.useHistory)();
    const theme = (0, $2mnfJ.default)();
    const { buildings: buildings, context: context } = location.state;
    console.log("picked buildings", buildings);
    const [activeStep, setActiveStep] = (0, $70fFQ.useState)(context === "new-project" ? 1 : 0);
    uiStore.setIsSpeedDialOpen(false);
    const projects = [
        ...projectStore.resultMap.values()
    ];
    const [results, setResults] = (0, $70fFQ.useState)(projects);
    const [checked, setChecked] = (0, $70fFQ.useState)([]);
    const [inProgress, setInProgress] = (0, $70fFQ.useState)([]);
    const [open, setOpen] = (0, $70fFQ.useState)(buildings);
    const handleStepChange = (step)=>{
        setActiveStep(step);
    };
    const handleKeyUp = (event)=>{
        const { value: value } = event.target;
        const results = projects.filter((project)=>{
            return new RegExp(value, "ig").test(project.name);
        });
        setResults(results);
    };
    const toggleChecked = async (value)=>{
        let newChecked = [
            ...checked
        ];
        if (checked.includes(value.id)) {
            newChecked = newChecked.filter((val)=>val !== value.id);
            setInProgress([
                ...inProgress,
                value.id
            ]);
            await (0, $lxEiN.default).Project.removeBuilding(value.id, buildings);
            userStore.addNotification({
                title: `Removed from ${value.name}`,
                type: "building"
            });
            setInProgress([
                ...inProgress
            ].filter((val)=>val !== value.id));
        } else {
            userStore.addNotification({
                title: `Added to ${value.name}`,
                type: "building"
            });
            newChecked.push(value.id);
            console.log(value.id, buildings, "adding building");
            (0, $lxEiN.default).Project.addBuilding(value.id, buildings);
        }
        setChecked(newChecked);
    };
    const onCreateNewProject = ()=>{
        setActiveStep(1);
    };
    const handleClose = ()=>{
        setActiveStep(0);
        history.push(location.pathname, {
            state: {
                modal: false,
                buildingId: null
            }
        });
        setOpen(false);
    };
    const onSubmit = async ()=>{
        const params = {
            buildings: buildings,
            name: projectNameEl.current.value,
            description: projectDescriptionEl.current.value
        };
        handleClose();
        const project = await projectStore.createProject(params);
        if (!project.error) {
            buildingStore.clearPicked();
            editorStore.reset();
            uiStore.setSearchPanelState("search");
            projectStore.fetchAll();
            userStore.addNotification({
                title: `New project: ${project.name}`,
                type: "project"
            });
        }
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $cvbk1.default), {
        onClose: handleClose,
        "aria-labelledby": "simple-dialog-title",
        open: open,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                sx: {
                    maxWidth: 400,
                    minWidth: 320,
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $1mImZ.default), {
                        square: true,
                        elevation: 0,
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            height: 50,
                            paddingLeft: 16,
                            backgroundColor: theme.palette.background.default
                        },
                        children: [
                            activeStep === 0 && /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        children: "Select Project"
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                        "aria-label": "Close",
                                        className: "",
                                        onClick: handleClose,
                                        size: "large",
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c4gat.default), {})
                                    })
                                ]
                            }),
                            activeStep === 1 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                children: [
                                    context !== "new-project" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                        style: {
                                            marginLeft: -14
                                        },
                                        onClick: ()=>{
                                            setActiveStep(0);
                                        },
                                        color: "primary",
                                        component: "span",
                                        size: "large",
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lBx17))), {})
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        children: "Project Details"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($223d9dcabe73955f$exports))), {
                        disabled: true,
                        index: activeStep,
                        onChangeIndex: handleStepChange,
                        enableMouseEvents: true,
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), {
                                        onKeyUp: handleKeyUp,
                                        style: {
                                            padding: "16px 16px"
                                        },
                                        placeholder: "Search projects...",
                                        inputProps: {
                                            "aria-label": "Search projects"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fuVrF.default), {
                                        orientation: "horizontal"
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                        p: 2,
                                        pb: 0,
                                        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                            variant: "body2",
                                            children: [
                                                "Adding ",
                                                buildingStore.pickedResults.size,
                                                " selected",
                                                " ",
                                                buildingStore.pickedResults.size === 1 ? "building" : "buildings",
                                                " ",
                                                "to project:"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                        style: {
                                            height: 300,
                                            overflowY: "scroll"
                                        },
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $W7alG.default), {
                                            dense: true,
                                            children: results.map((result)=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eS4JX.default), {
                                                    onClick: ()=>toggleChecked(result),
                                                    button: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Xosf.default), {
                                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Vd8j.default), {
                                                                value: result.id,
                                                                checked: checked.includes(result.id),
                                                                disabled: inProgress.includes(result.id),
                                                                edge: "start",
                                                                tabIndex: -1,
                                                                disableRipple: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                                                            primary: result.name
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Z3Gv.default), {
                                                            children: inProgress.includes(result.id) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fDlBJ.default), {})
                                                        })
                                                    ]
                                                }, result.id))
                                        })
                                    })
                                ]
                            }, "list"),
                            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $1mImZ.default), {
                                    ref: formEl,
                                    component: "form",
                                    square: true,
                                    elevation: 0,
                                    onSubmit: onSubmit,
                                    style: {
                                        padding: "2rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                                            required: true,
                                            fullWidth: true,
                                            inputRef: projectNameEl,
                                            label: "Project name",
                                            defaultValue: "Untitled Project",
                                            margin: "normal"
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                                            multiline: true,
                                            inputRef: projectDescriptionEl,
                                            rows: 4,
                                            fullWidth: true,
                                            label: "Project Description",
                                            margin: "normal"
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                            variant: "body2",
                                            children: [
                                                "Creating project with ",
                                                buildingStore.pickedResults.size,
                                                " ",
                                                "selected buildings"
                                            ]
                                        })
                                    ]
                                })
                            }, "settings")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $daCoF.default), {
                children: [
                    activeStep === 0 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        color: "primary",
                        style: {
                            marginRight: "auto"
                        },
                        onClick: onCreateNewProject,
                        children: "Create project"
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        onClick: ()=>{
                            buildingStore.clearPicked();
                            editorStore.reset();
                            uiStore.setSearchPanelState("search");
                            handleClose();
                        },
                        color: "primary",
                        children: "Cancel"
                    }),
                    activeStep === 0 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        onClick: ()=>{
                            buildingStore.clearPicked();
                            editorStore.reset();
                            uiStore.setSearchPanelState("search");
                            handleClose();
                        },
                        color: "secondary",
                        children: "Done"
                    }),
                    activeStep === 1 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        onClick: ()=>{
                            const isValid = formEl.current.reportValidity();
                            if (isValid) onSubmit();
                        },
                        color: "secondary",
                        children: "Create"
                    })
                ]
            })
        ]
    });
}
var $09243fa8c5e39d82$export$2e2bcd8739ae039 = (0, $87gt0.observer)($09243fa8c5e39d82$var$ProjectPicker);



var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $hsXqC = parcelRequire("hsXqC");

var $27ZKj = parcelRequire("27ZKj");

var $cg448 = parcelRequire("cg448");
var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $2329d5afa4af1f48$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");


var $c4gat = parcelRequire("c4gat");
var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $e96107fdc34eaaea$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z"
}), "PlaylistAdd");


parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");


var $kcSl7 = parcelRequire("kcSl7");

var $iWaGk = parcelRequire("iWaGk");

var $kQo3L = parcelRequire("kQo3L");
const $4f9c7eb8d5082e41$var$ProjectSpeedDial = ({ history: history, match: match })=>{
    const { buildingId: buildingId } = match.params;
    const { buildingStore: buildingStore, uiStore: uiStore, editorStore: editorStore, mapStore: mapStore } = (0, $iWaGk.default)();
    const { isSpeedDialOpen: isSpeedDialOpen } = uiStore;
    const [mode, setMode] = (0, $70fFQ.useState)("default");
    (0, $70fFQ.useEffect)(()=>{
        setMode(buildingId ? "building" : "default");
    }, [
        buildingId
    ]);
    const actions = [
        {
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e96107fdc34eaaea$export$2e2bcd8739ae039), {}),
            tooltipTitle: "Add search results to project",
            onClick: ()=>{
                uiStore.setSearchPanelState("picker");
                setMode("picker");
                uiStore.setIsSpeedDialOpen(false);
            },
            isHidden: ![
                "default",
                "building"
            ].includes(mode)
        },
        /*
    {
      icon: <AddIcon />,
      tooltipTitle: 'Create a project',
      onClick: () => {
        setIsDialogOpen(true);
      },
      mode: ['picker']
    },
    */ {
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c4gat.default), {}),
            tooltipTitle: "Cancel",
            onClick: ()=>{
                editorStore.reset();
                mapStore.setBounds(null);
                uiStore.setActiveLayer("satellite", false);
                buildingStore.clearPicked();
                uiStore.setSearchPanelState("search");
                mapStore.setMode("view");
                setMode(buildingId ? "building" : "default");
            },
            isHidden: editorStore.features.length === 0 && ![
                "picker",
                "draw"
            ].includes(mode)
        },
        {
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cg448.default), {}),
            tooltipTitle: "Add property to existing project",
            onClick: ()=>{
                history.push({
                    pathname: location.pathname,
                    state: {
                        modal: true,
                        buildings: [
                            {
                                id: buildingId
                            }
                        ]
                    }
                });
            },
            isHidden: ![
                "building"
            ].includes(mode)
        }
    ];
    const propertyCount = buildingStore.pickedResults.size;
    let speedDialIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cg448.default), {});
    if (propertyCount) speedDialIcon = /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2329d5afa4af1f48$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $kQo3L.default), {
            actions: actions.filter((action)=>!action.isHidden).filter((action)=>typeof action.isVisible === "undefined" || action.isVisible === true),
            ariaLabel: "Building actions",
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hsXqC.default), {
                classes: {
                    badge: "speed-dial-fab-badge"
                },
                badgeContent: propertyCount,
                color: "primary",
                invisible: propertyCount === 0,
                children: speedDialIcon
            }),
            onClose: ()=>{
                if ([
                    "default",
                    "building",
                    "draw"
                ].includes(mode)) uiStore.setIsSpeedDialOpen(false);
            },
            onOpen: (event, reason)=>{
                if (reason !== "focus") uiStore.setIsSpeedDialOpen(true);
            },
            open: isSpeedDialOpen,
            onClick: ()=>{
                uiStore.setIsSpeedDialOpen(false);
                const buildings = [
                    ...buildingStore.pickedResults
                ].map((buldingId)=>({
                        id: buldingId
                    }));
                const allBuildingData = JSON.parse(JSON.stringify([
                    ...buildings
                ]));
                if (allBuildingData.length === 0 && buildingId) history.push({
                    pathname: location.pathname,
                    state: {
                        modal: true,
                        context: "new-project",
                        buildings: [
                            {
                                id: buildingId
                            }
                        ]
                    }
                });
                else history.push({
                    pathname: location.pathname,
                    state: {
                        modal: true,
                        context: "add-to-project",
                        buildings: allBuildingData
                    }
                });
            },
            children: mode === "building" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $kcSl7.default), {
                in: isSpeedDialOpen,
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                    className: "speed-dial-tooltip-label default-action",
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                        children: "Create a new project"
                    })
                })
            })
        })
    });
};
var $4f9c7eb8d5082e41$export$2e2bcd8739ae039 = (0, $87gt0.observer)($4f9c7eb8d5082e41$var$ProjectSpeedDial);



var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $cGU07 = parcelRequire("cGU07");
var $5DHXT = parcelRequire("5DHXT");

var $4KbVS = parcelRequire("4KbVS");

var $lxEiN = parcelRequire("lxEiN");

var $iWaGk = parcelRequire("iWaGk");

var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $7xvOw = parcelRequire("7xvOw");
var $9Vd8j = parcelRequire("9Vd8j");
var $cvbk1 = parcelRequire("cvbk1");
var $daCoF = parcelRequire("daCoF");
var $3c7f6 = parcelRequire("3c7f6");
var $e4z6Z = parcelRequire("e4z6Z");
var $b2gZS = parcelRequire("b2gZS");
var $irnsW = parcelRequire("irnsW");
var $iuSYB = parcelRequire("iuSYB");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $3U8SM = parcelRequire("3U8SM");

var $iWaGk = parcelRequire("iWaGk");
const $1397f98f660ce9c3$var$AddAccount = ()=>{
    const { modalStore: modalStore, userStore: userStore } = (0, $iWaGk.default)();
    const [userExists, setUserExists] = (0, $70fFQ.useState)(null);
    const [user, setUser] = (0, $70fFQ.useState)(null);
    const [email, setEmail] = (0, $70fFQ.useState)(null);
    const [message, setMessage] = (0, $70fFQ.useState)(null);
    const [name, setName] = (0, $70fFQ.useState)(null);
    const handleClose = ()=>{
        modalStore.setModal(null);
    };
    const search = (email)=>{
        (0, $3U8SM.default).get("/user/exists", {
            params: {
                email: email
            }
        }).then((response)=>{
            if (response.data.data !== null) {
                setUser(response.data.data);
                setUserExists(true);
            } else {
                setUser(null);
                setUserExists(false);
            }
        });
    };
    const handleChange = async (event)=>{
        const { name: name } = event.target;
        if (name === "e-mail") {
            setEmail(event.target.value);
            search(event.target.value);
        }
        if (name === "message") setMessage(event.target.value);
        if (name === "name") setName(event.target.value);
    };
    const handleAdd = async ()=>{
        const groupId = userStore.user.group.id;
        if (userExists) {
            const { data: data } = await (0, $3U8SM.default).post(`/group/${groupId}/relationships/users`, {
                data: [
                    (0, $edHbI._)((0, $2QP2i._)({}, user), {
                        message: message
                    })
                ]
            });
            handleClose();
            const groupMembers = [
                ...userStore.groupMembers
            ];
            groupMembers.push(...data.data);
            userStore.groupMembers = groupMembers;
        }
        if (!userExists) {
            const { data: data } = await (0, $3U8SM.default).post(`/group/${groupId}/relationships/users`, {
                data: [
                    {
                        email: email,
                        message: message,
                        name: name
                    }
                ]
            });
            handleClose();
            const groupMembers = [
                ...userStore.groupMembers
            ];
            groupMembers.push(...data.data);
            userStore.groupMembers = groupMembers;
        }
        // UserStore.fetchGroupMembers();
        modalStore.setModal("team-manager");
    };
    const isOpen = modalStore.open === "add-account";
    let helperText = "";
    if (userExists === true) helperText = "User Exists, invite  to join the group will be sent";
    if (userExists === false) helperText = "User does not exist and will be created";
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $cvbk1.default), {
        onClose: handleClose,
        "aria-labelledby": "simple-dialog-title",
        open: isOpen,
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e4z6Z.default), {
                id: "simple-dialog-title",
                children: "Add Account"
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3c7f6.default), {
                style: {
                    minWidth: 400,
                    padding: "1rem 2rem"
                },
                children: /*#__PURE__*/ (0, $4x3bm.jsxs)("form", {
                    onChange: handleChange,
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                            fullWidth: true,
                            id: "e-mail",
                            name: "e-mail",
                            label: "E-mail",
                            value: email,
                            helperText: helperText,
                            margin: "normal"
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                            fullWidth: true,
                            id: "name",
                            name: "name",
                            label: "Name (optional)",
                            margin: "normal",
                            value: name,
                            multiline: true
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                            fullWidth: true,
                            id: "standard-name",
                            name: "message",
                            label: "Message (optional)",
                            margin: "normal",
                            value: message,
                            multiline: true
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $irnsW.default), {
                            style: {
                                display: "none"
                            },
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $b2gZS.default), {
                                control: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Vd8j.default), {
                                    value: "notify"
                                }),
                                label: "Send notification"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $daCoF.default), {
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        onClick: handleClose,
                        color: "primary",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                        onClick: handleAdd,
                        color: "primary",
                        autoFocus: true,
                        children: "Add"
                    })
                ]
            })
        ]
    });
};
var $1397f98f660ce9c3$export$2e2bcd8739ae039 = (0, $87gt0.observer)($1397f98f660ce9c3$var$AddAccount);



var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $3fLZ2 = parcelRequire("3fLZ2");
var $hsXqC = parcelRequire("hsXqC");
var $bDcYY = parcelRequire("bDcYY");
var $7xvOw = parcelRequire("7xvOw");
var $j6Rju = parcelRequire("j6Rju");
var $W7alG = parcelRequire("W7alG");
var $eS4JX = parcelRequire("eS4JX");
var $9Xosf = parcelRequire("9Xosf");
var $2Z3Gv = parcelRequire("2Z3Gv");
var $iHyg3 = parcelRequire("iHyg3");

var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $566c9032ce1b26fa$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
}), "BarChart");


var $9BDqo = parcelRequire("9BDqo");
var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $d5baa62dfe4f89e4$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
}), "FeedbackOutlined");


var $7aNPO = parcelRequire("7aNPO");
var $5KAQF = parcelRequire("5KAQF");
var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $36b75330f27c6651$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
}), "Notes");


var $fKdUq = parcelRequire("fKdUq");

var $4x3bm = parcelRequire("4x3bm");
var $0eb281d5ae95e3e1$export$2e2bcd8739ae039 = (0, $fKdUq.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    fillRule: "evenodd",
    d: "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
}), "WorkOutline");



var $dsvUQ = parcelRequire("dsvUQ");
var $dih0O = parcelRequire("dih0O");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $iWaGk = parcelRequire("iWaGk");
const $b8863318d110334b$var$MenuList = ()=>{
    const { userStore: userStore, uiStore: uiStore } = (0, $iWaGk.default)();
    const { user: user } = userStore;
    const history = (0, $dih0O.useHistory)();
    // TODO remove compatability hack
    const menuItems = user && user.group.menu_items ? user.group.menu_items : null;
    const goToSettings = (e)=>{
        e.stopPropagation();
        history.push(`/team/${user.id}`);
        uiStore.setSidebarExpanded(false);
    };
    const items = [
        {
            id: "nav-prospecting",
            to: "/search",
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9BDqo.default), {}),
            label: "Prospecting",
            isVisible: menuItems.includes("prospecting")
        },
        {
            id: "nav-projects",
            to: "/project",
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $0eb281d5ae95e3e1$export$2e2bcd8739ae039), {}),
            label: "Projects",
            isVisible: true,
            notificationCount: userStore.notifications.filter((n)=>n.type === "project").length
        },
        {
            id: "nav-team",
            to: "/team",
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7aNPO.default), {}),
            label: "Team",
            isVisible: menuItems.includes("team_manager")
        },
        {
            id: "nav-documents",
            to: {
                pathname: `/documents/OTEwMTcxOTc2NTA1OTY1NjQyODQxMzA1MTg3ODAwNjk3NTg5MzUwMDExNDYwMzk0MjgzOTQyNDA5NzU3NDk0MDI4NzE0MjMxOTAzODE5NDYwOTY3ODg4NDU4Njc5NzQy`,
                state: {
                    modal: true
                }
            },
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $36b75330f27c6651$export$2e2bcd8739ae039), {}),
            label: "Documents",
            isVisible: menuItems.includes("documents")
        },
        {
            id: "nav-editor",
            to: "/dataeditor",
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5KAQF.default), {}),
            label: "Editor",
            isVisible: menuItems.includes("editor")
        },
        {
            id: "nav-analytics",
            to: "/analytics",
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $566c9032ce1b26fa$export$2e2bcd8739ae039), {}),
            label: "Events",
            isVisible: menuItems.includes("analytics")
        },
        {
            id: "nav-feedback",
            to: "#",
            onClick: ()=>uiStore.setFeedbackModalOpen(true),
            icon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $d5baa62dfe4f89e4$export$2e2bcd8739ae039), {}),
            label: "Feedback",
            isVisible: menuItems.includes("feedback")
        }
    ].filter((menuItem)=>menuItem.isVisible);
    return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
        className: "sidebar--menu",
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $W7alG.default), {
            component: "nav",
            children: [
                items.map((item)=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eS4JX.default), {
                        id: item.id,
                        button: true,
                        component: typeof item.onClick !== "undefined" ? (0, $j6Rju.default) : (0, $dsvUQ.NavLink),
                        onClick: item.onClick,
                        to: item.to,
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Xosf.default), {
                                className: "list-item-icon",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $hsXqC.default), {
                                    badgeContent: item.notificationCount,
                                    color: "primary",
                                    children: item.icon
                                })
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                                className: "list-item-text",
                                primary: item.label,
                                primaryTypographyProps: {
                                    noWrap: true
                                }
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Z3Gv.default), {})
                        ]
                    }, item.id)),
                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eS4JX.default), {
                    id: "nav-user-profile",
                    onClick: ()=>uiStore.setSidebarExpanded(true),
                    onBlur: ()=>uiStore.setSidebarExpanded(false),
                    button: true,
                    className: "list-item-profile",
                    style: {
                        paddingLeft: 8,
                        paddingBottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Xosf.default), {
                            className: "list-item-icon",
                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3fLZ2.default), {
                                style: {
                                    background: "#2c2c2c",
                                    opacity: 1
                                },
                                // src={avatarUrl}
                                src: userStore.avatar,
                                children: user.email && user.email.substring(0, 2)
                            })
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                            className: "list-item-text",
                            primary: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                onClick: goToSettings,
                                children: user.firstname || user.email
                            }),
                            secondary: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                sx: {
                                    color: "#fff",
                                    fontWeight: 500,
                                    textTransform: "none",
                                    padding: 0
                                },
                                onClick: goToSettings,
                                children: "Manage Account"
                            }),
                            primaryTypographyProps: {
                                noWrap: true
                            }
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Z3Gv.default), {})
                    ]
                })
            ]
        })
    });
};
var $b8863318d110334b$export$2e2bcd8739ae039 = (0, $87gt0.observer)($b8863318d110334b$var$MenuList);



var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $cvbk1 = parcelRequire("cvbk1");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $dih0O = parcelRequire("dih0O");

var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $bDcYY = parcelRequire("bDcYY");
var $fuVrF = parcelRequire("fuVrF");
var $cGU07 = parcelRequire("cGU07");
var $5DHXT = parcelRequire("5DHXT");
var $1mImZ = parcelRequire("1mImZ");
var $27ZKj = parcelRequire("27ZKj");

var $cg448 = parcelRequire("cg448");
var $5rR0J = parcelRequire("5rR0J");

parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $3U8SM = parcelRequire("3U8SM");

var $iWaGk = parcelRequire("iWaGk");

var $4x3bm = parcelRequire("4x3bm");
parcelRequire("70fFQ");

var $3fLZ2 = parcelRequire("3fLZ2");
var $cGU07 = parcelRequire("cGU07");
var $W7alG = parcelRequire("W7alG");
var $eS4JX = parcelRequire("eS4JX");
var $dcOT1 = parcelRequire("dcOT1");
var $2Z3Gv = parcelRequire("2Z3Gv");
var $iHyg3 = parcelRequire("iHyg3");
var $bey3N = parcelRequire("bey3N");

var $7aNPO = parcelRequire("7aNPO");
var $5GjdS = parcelRequire("5GjdS");
var $kbqXp = parcelRequire("kbqXp");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $iWaGk = parcelRequire("iWaGk");
function $a2e9b720bcde850a$var$AccountList({ onClickSettings: onClickSettings, accounts: accounts, onSelectAccount: onSelectAccount }) {
    const { userStore: userStore } = (0, $iWaGk.default)();
    const userGroups = accounts.filter((group)=>group.has_group);
    const adminGroups = accounts.filter((group)=>!group.has_group);
    const groups = [
        {
            title: "My Groups",
            groups: userGroups
        }
    ];
    if (adminGroups.length) groups.push({
        title: "Other Groups",
        groups: adminGroups
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $W7alG.default), {
        subheader: /*#__PURE__*/ (0, $4x3bm.jsx)("li", {}),
        sx: {
            scrollbarWidth: "thin",
            width: "100%",
            maxHeight: 360
        },
        dense: true,
        children: groups.map((group)=>/*#__PURE__*/ (0, $4x3bm.jsxs)("ul", {
                style: {
                    paddingLeft: 0
                },
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bey3N.default), {
                        style: {
                            background: "#fff",
                            fontWeight: 400,
                            fontSize: "0.8rem",
                            borderBottom: "1px solid #DFDFDF"
                        },
                        children: group.title
                    }),
                    group.groups.map((acc)=>{
                        return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                            children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eS4JX.default), {
                                id: `group-${acc.id}`,
                                onClick: ()=>{
                                    onSelectAccount(acc);
                                },
                                button: true,
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dcOT1.default), {
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3fLZ2.default), {
                                            variant: "rounded",
                                            children: acc.is_user_workspace ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $kbqXp.default), {}) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7aNPO.default), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                                        primaryTypographyProps: {
                                            noWrap: true,
                                            textOverflow: "ellipsis",
                                            overflow: "hidden"
                                        },
                                        secondaryTypographyProps: {
                                            noWrap: true,
                                            textOverflow: "ellipsis",
                                            overflow: "hidden"
                                        },
                                        primary: acc.is_user_workspace ? "My Workspace" : acc.name,
                                        secondary: acc.is_user_workspace ? "Your personal workspace" : acc.description
                                    }),
                                    userStore.isAdmin && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Z3Gv.default), {
                                        style: {
                                            right: 8
                                        },
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                            onClick: ()=>{
                                                onClickSettings(acc);
                                            },
                                            component: "span",
                                            size: "large",
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5GjdS.default), {})
                                        })
                                    })
                                ]
                            }, acc.id)
                        });
                    })
                ]
            }, group.title))
    });
}
var $a2e9b720bcde850a$export$2e2bcd8739ae039 = (0, $87gt0.observer)($a2e9b720bcde850a$var$AccountList);



var $4x3bm = parcelRequire("4x3bm");

var $70fFQ = parcelRequire("70fFQ");

var $3fLZ2 = parcelRequire("3fLZ2");
var $7xvOw = parcelRequire("7xvOw");
var $9Vd8j = parcelRequire("9Vd8j");
var $5DHXT = parcelRequire("5DHXT");
var $W7alG = parcelRequire("W7alG");
var $eS4JX = parcelRequire("eS4JX");
var $2Z3Gv = parcelRequire("2Z3Gv");
var $iHyg3 = parcelRequire("iHyg3");
var $27ZKj = parcelRequire("27ZKj");

var $e9iFh = parcelRequire("e9iFh");
parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $lxEiN = parcelRequire("lxEiN");

var $iWaGk = parcelRequire("iWaGk");
function $26178ba1a6c6b107$var$AccountSettings({ account: account, onDelete: onDelete }) {
    const { userStore: userStore } = (0, $iWaGk.default)();
    const [settings, setSettings] = (0, $70fFQ.useState)([
        {
            label: "Prospecting",
            enabled: false,
            value: "prospecting"
        },
        {
            label: "Documents",
            enabled: false,
            value: "documents"
        },
        {
            label: "Team Manager",
            enabled: false,
            value: "team_manager"
        },
        {
            label: "Analytics",
            enabled: false,
            value: "analytics"
        }
    ]);
    (0, $70fFQ.useEffect)(()=>{
        (async ()=>{
            const { data: data } = await (0, $lxEiN.default).Group.getSettings(account.id);
            setSettings(data.data.menu_items);
        })();
    }, [
        account
    ]);
    const handleDelete = async (groupId)=>{
        if (!confirm(`Delete group ?`)) return;
        const currentGroupId = userStore.user.group.id;
        if (currentGroupId === groupId) {
            alert("Error: Switch active group first");
            return;
        }
        userStore.deleteGroup(groupId);
        if (onDelete) onDelete(groupId);
    };
    const handleToggle = (value)=>()=>{
            const newSettings = [
                ...settings
            ];
            const setting = newSettings.find((s)=>s.value === value);
            setting.enabled = !setting.enabled;
            setSettings(newSettings);
            const menuItems = settings.reduce((acc, val)=>{
                if (val.enabled) acc.push(val.value);
                return acc;
            }, []);
            (0, $lxEiN.default).Group.setSettings(account.id, {
                menu_items: menuItems
            });
        };
    const handleOnBlur = (event)=>{
        const { value: value } = event.target;
        (0, $lxEiN.default).Group.update(account.id, {
            description: value
        });
        const idx = userStore.user.groups.findIndex((group)=>group.id === account.id);
        userStore.user.groups[idx].description = value;
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                style: {
                    padding: 16,
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3fLZ2.default), {
                        style: {
                            marginRight: 16
                        }
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                        className: "account-info-block-details",
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                variant: "h6",
                                children: account === null || account === void 0 ? void 0 : account.name
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                variant: "body2",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), {
                                    defaultValue: account === null || account === void 0 ? void 0 : account.description,
                                    onBlur: handleOnBlur,
                                    placeholder: "Write decription here"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $W7alG.default), {
                dense: true,
                children: settings.map((setting)=>{
                    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $eS4JX.default), {
                        button: true,
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iHyg3.default), {
                                primary: setting.label
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2Z3Gv.default), {
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $9Vd8j.default), {
                                    edge: "end",
                                    checked: settings.find((s)=>s.value === setting.value).enabled,
                                    onChange: handleToggle(setting.value)
                                })
                            })
                        ]
                    }, setting.value);
                })
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                style: {
                    padding: 16,
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: ()=>{
                        handleDelete(account.id);
                    },
                    startIcon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $e9iFh.default), {}),
                    children: "Delete"
                })
            })
        ]
    });
}
var $26178ba1a6c6b107$export$2e2bcd8739ae039 = (0, $87gt0.observer)($26178ba1a6c6b107$var$AccountSettings);


function $2e51ed903795cc84$var$AccountManager({ accounts: accounts, onSelectAccount: onSelectAccount }) {
    const [activeStep, setActiveStep] = (0, $70fFQ.useState)(0);
    const [account, setAccount] = (0, $70fFQ.useState)(null);
    const [filterBy, setFilterBy] = (0, $70fFQ.useState)("");
    const { userStore: userStore, modalStore: modalStore, projectStore: projectStore } = (0, $iWaGk.default)();
    const handleStepChange = (step)=>{
        setActiveStep(step);
    };
    const filterAccounts = (accounts, filterBy)=>{
        return accounts.filter((account)=>account.name.toLowerCase().includes(filterBy.toLowerCase()));
    };
    const handleChange = (e)=>{
        setFilterBy(e.target.value);
    };
    const handleGroupAdd = async ()=>{
        const { data: data } = await (0, $3U8SM.default).post("/group", {
            name: "New Group"
        });
        const groupId = data.data.id;
        await userStore.switchGroup(groupId);
        projectStore.fetchAll();
        modalStore.setModal(null);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
        sx: {
            maxWidth: 400,
            flexGrow: 1
        },
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $1mImZ.default), {
                square: true,
                elevation: 0,
                sx: {
                    alignItems: "center",
                    paddingLeft: 2,
                    display: "flex"
                },
                children: [
                    activeStep === 0 && /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            width: "96%"
                        },
                        children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                    children: "Select Account"
                                }),
                                userStore.user.is_admin && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                    id: "nav-group-add",
                                    onClick: ()=>{
                                        handleGroupAdd();
                                    },
                                    component: "span",
                                    size: "large",
                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cg448.default), {})
                                })
                            ]
                        })
                    }),
                    activeStep === 1 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                                style: {
                                    marginLeft: -14
                                },
                                onClick: ()=>{
                                    setActiveStep(0);
                                    setAccount(null);
                                },
                                color: "primary",
                                component: "span",
                                size: "large",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5rR0J.default), {})
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                children: "Account settings"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($223d9dcabe73955f$exports))), {
                disabled: true,
                index: activeStep,
                onChangeIndex: handleStepChange,
                enableMouseEvents: true,
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                        style: {
                            maxHeight: 360,
                            scrollbarWidth: "thin"
                        },
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fuVrF.default), {
                                className: "search-controls-divider"
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                                style: {
                                    marginTop: 10,
                                    paddingLeft: 16,
                                    alignItems: "center",
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), {
                                    onChange: handleChange,
                                    placeholder: "Search..."
                                })
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $a2e9b720bcde850a$export$2e2bcd8739ae039), {
                                accounts: filterBy ? filterAccounts(accounts, filterBy) : accounts,
                                onSelectAccount: onSelectAccount,
                                onClickSettings: (account)=>{
                                    setAccount(account);
                                    setActiveStep(1);
                                }
                            })
                        ]
                    }, "list"),
                    /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1mImZ.default), {
                            style: {
                                minWidth: 400,
                                minHeight: 370
                            },
                            square: true,
                            elevation: 0,
                            children: account && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $26178ba1a6c6b107$export$2e2bcd8739ae039), {
                                onDelete: ()=>{
                                    setActiveStep(0);
                                    setAccount(null);
                                },
                                account: account
                            })
                        })
                    }, "settings")
                ]
            })
        ]
    });
}
var $2e51ed903795cc84$export$2e2bcd8739ae039 = (0, $87gt0.observer)($2e51ed903795cc84$var$AccountManager);



var $lxEiN = parcelRequire("lxEiN");

var $iWaGk = parcelRequire("iWaGk");
const $5fb907816ebe0645$var$ProfilePicker = ()=>{
    const history = (0, $dih0O.useHistory)();
    const { modalStore: modalStore, userStore: userStore, projectStore: projectStore } = (0, $iWaGk.default)();
    const [userGroups, setUserGroups] = (0, $70fFQ.useState)([]);
    (0, $70fFQ.useEffect)(()=>{
        (async ()=>{
            const response = await (0, $lxEiN.default).User.getGroups();
            setUserGroups(response.data.data);
        })();
    }, []);
    const handleClose = ()=>{
        modalStore.setModal(null);
    };
    const handleGroupClick = async (group)=>{
        await userStore.switchGroup(group.id);
        history.push(`/`);
        projectStore.fetchAll();
        handleClose();
    };
    if (!userGroups.length) return null;
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cvbk1.default), {
        onClose: handleClose,
        open: true,
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $2e51ed903795cc84$export$2e2bcd8739ae039), {
            onSelectAccount: handleGroupClick,
            accounts: userGroups
        })
    });
};
var $5fb907816ebe0645$export$2e2bcd8739ae039 = (0, $87gt0.observer)($5fb907816ebe0645$var$ProfilePicker);



var $awtVx = parcelRequire("awtVx");

const $bcaf067aaacc7e97$var$SideBar = ()=>{
    var _user_group, _userStore_user_groups, _userStore_user;
    const { modalStore: modalStore, uiStore: uiStore, userStore: userStore } = (0, $iWaGk.default)();
    const { user: user } = userStore;
    const longName = user && user.group ? user.group.name : "";
    const handleChange = (event)=>{
        const val = event.target.value;
        const isValid = /^$|^[a-z0-9 -]+$/i.test(val);
        if (!isValid) return;
        user.group.name = val;
        const { group: group } = user;
        const idx = user.groups.findIndex((g)=>g.id === group.id);
        user.groups[idx].name = val;
    };
    const handleBlur = (event)=>{
        const val = event.target.value;
        const groupId = user.group.id;
        (0, $lxEiN.default).Group.update(groupId, {
            name: val
        });
        uiStore.setSidebarExpanded(false);
    };
    return /*#__PURE__*/ (0, $4x3bm.jsxs)("aside", {
        className: "layout--sidebar",
        children: [
            modalStore.open === "profile-select" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5fb907816ebe0645$export$2e2bcd8739ae039), {}),
            modalStore.open === "add-account" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1397f98f660ce9c3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $awtVx.default), {
                uiStore: uiStore
            }),
            /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
                className: "sidebar--user",
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $5DHXT.default), {
                        id: "group-name",
                        type: "text",
                        disabled: user === null || user === void 0 ? void 0 : (_user_group = user.group) === null || _user_group === void 0 ? void 0 : _user_group.is_user_workspace,
                        value: longName,
                        onChange: handleChange,
                        // onFocus={handleFocus}
                        onBlur: handleBlur
                    }),
                    ((_userStore_user = userStore.user) === null || _userStore_user === void 0 ? void 0 : (_userStore_user_groups = _userStore_user.groups) === null || _userStore_user_groups === void 0 ? void 0 : _userStore_user_groups.length) > 1 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $cGU07.default), {
                        id: "switch-group",
                        "aria-label": "Switch Group",
                        className: "search-controls-icon-button",
                        onClick: ()=>{
                            modalStore.setModal("profile-select");
                            uiStore.setSidebarExpanded(false);
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4KbVS.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $b8863318d110334b$export$2e2bcd8739ae039), {})
        ]
    });
};
var $bcaf067aaacc7e97$export$2e2bcd8739ae039 = (0, $87gt0.observer)($bcaf067aaacc7e97$var$SideBar);


parcelRequire("kaUpJ");
var $etOpj = parcelRequire("etOpj");

var $iWaGk = parcelRequire("iWaGk");

var $50Bvw = parcelRequire("50Bvw");

var $7pHcK = parcelRequire("7pHcK");

var $4Ghcg = parcelRequire("4Ghcg");

const $aacc396004ae5cb8$var$Analytics = /*#__PURE__*/ (0, $70fFQ.lazy)(()=>(parcelRequire("jOtOD")));

const $aacc396004ae5cb8$var$Buildings = /*#__PURE__*/ (0, $70fFQ.lazy)(()=>(parcelRequire("6jag2")));

const $aacc396004ae5cb8$var$DataEditor = /*#__PURE__*/ (0, $70fFQ.lazy)(()=>(parcelRequire("991y0")));

const $aacc396004ae5cb8$var$MapContainer = /*#__PURE__*/ (0, $70fFQ.lazy)(()=>(parcelRequire("icIXl")));

const $aacc396004ae5cb8$var$Projects = /*#__PURE__*/ (0, $70fFQ.lazy)(()=>(parcelRequire("cLQwS")));

const $aacc396004ae5cb8$var$Team = /*#__PURE__*/ (0, $70fFQ.lazy)(()=>(parcelRequire("cFp2b")));
const $aacc396004ae5cb8$var$PrivateRoutes = ()=>{
    var _userStore_user_group, _userStore_user, _location_state;
    const location = (0, $dih0O.useLocation)();
    const history = (0, $dih0O.useHistory)();
    const { action: action } = history;
    const { uiStore: uiStore, userStore: userStore } = (0, $iWaGk.default)();
    let { layoutClass: layoutClass } = uiStore;
    if (location.pathname === "/onboarding") layoutClass += " onboarding";
    (_userStore_user = userStore.user) === null || _userStore_user === void 0 ? void 0 : (_userStore_user_group = _userStore_user.group) === null || _userStore_user_group === void 0 ? void 0 : _userStore_user_group.menu_items.length;
    const [previousLocation, setPreviousLocation] = (0, $70fFQ.useState)(location);
    (0, $70fFQ.useEffect)(()=>{
        // set previousLocation if location is not modal
        if (action !== "POP" && (!location.state || !location.state.modal)) setPreviousLocation(location);
    }, [
        location.pathname
    ]);
    const isModal = !!(((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.modal) && previousLocation !== location); // not initial render
    const { version: version } = uiStore;
    const className = `ui-${version} layout ${layoutClass}`;
    if (location.pathname.startsWith("/demo")) return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
        exact: true,
        path: [
            "/demo",
            "/demo/:buildingId"
        ],
        render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $61da6a620ff15715$export$2e2bcd8739ae039), {
                props: props
            })
    });
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4Ghcg.SelectedBuildingProvider), {
        value: null,
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bcaf067aaacc7e97$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Switch), {
                    location: location,
                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $70fFQ.Suspense), {
                        fallback: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $50Bvw.default), {
                            panel: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7pHcK.default), {
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {})
                            })
                        }),
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                                exact: true,
                                path: [
                                    "/analytics",
                                    "/analytics/:analyticsId"
                                ],
                                render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)($aacc396004ae5cb8$var$Analytics, (0, $2QP2i._)({}, props))
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                                exact: true,
                                path: [
                                    "/",
                                    "/project",
                                    "/project/upload",
                                    "/project/:projectId/tos",
                                    "/project/:projectId",
                                    "/project/:projectId/terms/:termsId",
                                    "/project/:projectId/preview/:fileId",
                                    "/project/:projectId/building/:buildingId/preview/:fileId",
                                    "/project/:projectId/building/:buildingId",
                                    "/project/:projectId/building/:buildingId/:viewId",
                                    "/project/:projectId/feature/:featureId",
                                    "/project/:projectId/building/:buildingId/:viewId/:itemId/:itemOption?",
                                    "/project/:projectId/:viewId",
                                    "/project/:projectId/:viewId/:itemId/:itemOption?"
                                ],
                                render: ({ match: match })=>/*#__PURE__*/ (0, $4x3bm.jsx)($aacc396004ae5cb8$var$Projects, {
                                        match: match
                                    })
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                                path: [
                                    "/search",
                                    "/search/:buildingId"
                                ],
                                exact: true,
                                render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)($aacc396004ae5cb8$var$Buildings, (0, $2QP2i._)({}, props))
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                                path: [
                                    "/dataeditor",
                                    "/dataeditor/search",
                                    "/dataeditor/:datasetId",
                                    "/dataeditor/:datasetId/:layerId",
                                    "/dataeditor/:datasetId/:layerId/:featureId",
                                    "/dataeditor/:datasetId/:layerId/:featureId/settings"
                                ],
                                exact: true,
                                render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)($aacc396004ae5cb8$var$DataEditor, (0, $2QP2i._)({}, props))
                            }),
                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                                path: [
                                    "/team",
                                    "/team/:userId"
                                ],
                                exact: true,
                                render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)($aacc396004ae5cb8$var$Team, (0, $2QP2i._)({}, props))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)("div", {
                    className: "layout--map",
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $70fFQ.Suspense), {
                        fallback: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $etOpj.default), {}),
                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                            path: [
                                "/project/:projectId/building/:buildingId",
                                "/project/:projectId/feature/:featureId",
                                "/project/:projectId",
                                "/project",
                                "/search/:buildingId",
                                "/search",
                                "/dataeditor/:datasetId",
                                "/dataeditor/:datasetId/:layerId",
                                "/dataeditor/:datasetId/:layerId/:featureId",
                                "/dataeditor",
                                "/"
                            ],
                            render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)($aacc396004ae5cb8$var$MapContainer, (0, $2QP2i._)({}, props))
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $dih0O.Switch), {
                    location: location,
                    children: [
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                            path: "/group/:groupId",
                            render: ({ match: match })=>{
                                userStore.switchGroup(match.params.groupId).then(()=>{
                                    history.push("/");
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                            path: "/documents/:documentId?",
                            render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $23953f26a187e6b6$export$2e2bcd8739ae039), (0, $2QP2i._)({}, props))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    path: [
                        "/search",
                        "/search/:buildingId"
                    ],
                    exact: true,
                    render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $4f9c7eb8d5082e41$export$2e2bcd8739ae039), (0, $2QP2i._)({}, props))
                }),
                isModal ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    path: "/",
                    component: (0, $09243fa8c5e39d82$export$2e2bcd8739ae039)
                }) : null,
                uiStore.feedbackModalOpen && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $d757e86f9af94941$export$2e2bcd8739ae039), {
                    onClose: ()=>uiStore.setFeedbackModalOpen(false),
                    open: uiStore.feedbackModalOpen
                })
            ]
        })
    });
};
var $aacc396004ae5cb8$export$2e2bcd8739ae039 = (0, $87gt0.observer)($aacc396004ae5cb8$var$PrivateRoutes);



var $2QP2i = parcelRequire("2QP2i");

var $edHbI = parcelRequire("edHbI");

var $4x3bm = parcelRequire("4x3bm");

parcelRequire("8hvMW");
var $87gt0 = parcelRequire("87gt0");

var $2mnfJ = parcelRequire("2mnfJ");

var $70fFQ = parcelRequire("70fFQ");

var $ld7Nh = parcelRequire("ld7Nh");

var $ghdbC = parcelRequire("ghdbC");

var $gD8dY = parcelRequire("gD8dY");

var $ggYS0 = parcelRequire("ggYS0");
var $bDcYY = parcelRequire("bDcYY");
var $7xvOw = parcelRequire("7xvOw");
var $fDlBJ = parcelRequire("fDlBJ");
var $fuVrF = parcelRequire("fuVrF");
var $697xl = parcelRequire("697xl");
var $b2gZS = parcelRequire("b2gZS");
var $irnsW = parcelRequire("irnsW");
var $7adKh = parcelRequire("7adKh");
var $8VJ2N = parcelRequire("8VJ2N");
var $3cESc = parcelRequire("3cESc");
var $4aoN6 = parcelRequire("4aoN6");
var $1IOh3 = parcelRequire("1IOh3");
var $6yY4r = parcelRequire("6yY4r");
var $6QAZD = parcelRequire("6QAZD");
var $20MOv = parcelRequire("20MOv");

var $79yYo = parcelRequire("79yYo");

var $70fFQ = parcelRequire("70fFQ");


var $irnsW = parcelRequire("irnsW");

var $5Up1l = parcelRequire("5Up1l");

var $6Apvh = parcelRequire("6Apvh");

var $7b960 = parcelRequire("7b960");

var $57DGY = parcelRequire("57DGY");

var $4x3bm = parcelRequire("4x3bm");
const $0d6a8f18ce31daaa$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $0d6a8f18ce31daaa$var$RadioGroup = /*#__PURE__*/ $70fFQ.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $79yYo.default)(props, $0d6a8f18ce31daaa$var$_excluded);
    const rootRef = $70fFQ.useRef(null);
    const [value, setValueState] = (0, $6Apvh.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $70fFQ.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $5Up1l.default)(ref, rootRef);
    const handleChange = (event)=>{
        setValueState(event.target.value);
        if (onChange) onChange(event, event.target.value);
    };
    const name = (0, $57DGY.default)(nameProp);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7b960.default).Provider, {
        value: {
            name: name,
            onChange: handleChange,
            value: value
        },
        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $irnsW.default), (0, $20MOv.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $0d6a8f18ce31daaa$export$2e2bcd8739ae039 = $0d6a8f18ce31daaa$var$RadioGroup;


var $69ubn = parcelRequire("69ubn");
var $iWVbX = parcelRequire("iWVbX");
var $3DLOK = parcelRequire("3DLOK");
var $c9kiU = parcelRequire("c9kiU");
var $iTwQr = parcelRequire("iTwQr");
var $8Hhl0 = parcelRequire("8Hhl0");
var $iuSYB = parcelRequire("iuSYB");
var $PjeUW = parcelRequire("PjeUW");
var $27ZKj = parcelRequire("27ZKj");

var $dsvUQ = parcelRequire("dsvUQ");

var $bg50F = parcelRequire("bg50F");
var $1d14e9fb1f91190a$exports = {};
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty($1d14e9fb1f91190a$exports, "__esModule", {
    value: true
});
$1d14e9fb1f91190a$exports.default = void 0;

var $1d14e9fb1f91190a$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $1d14e9fb1f91190a$var$_default = (0, $1d14e9fb1f91190a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4x3bm.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
}), "MailOutline");
$1d14e9fb1f91190a$exports.default = $1d14e9fb1f91190a$var$_default;



var $6lvOy = parcelRequire("6lvOy");

var $lbjAq = parcelRequire("lbjAq");
var $d3eaa2147c29393a$exports = {};
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty($d3eaa2147c29393a$exports, "__esModule", {
    value: true
});
$d3eaa2147c29393a$exports.default = void 0;

var $d3eaa2147c29393a$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $d3eaa2147c29393a$var$_default = (0, $d3eaa2147c29393a$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
        d: "M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
    }, "0"),
    /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
        d: "m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
    }, "1")
], "KeyboardDoubleArrowRight");
$d3eaa2147c29393a$exports.default = $d3eaa2147c29393a$var$_default;


var $bdf228aab2ca545c$exports = {};
"use strict";

var $hTVTj = parcelRequire("hTVTj");
Object.defineProperty($bdf228aab2ca545c$exports, "__esModule", {
    value: true
});
$bdf228aab2ca545c$exports.default = void 0;

var $bdf228aab2ca545c$var$_createSvgIcon = $hTVTj((parcelRequire("7Jp6i")));

var $4x3bm = parcelRequire("4x3bm");
var $bdf228aab2ca545c$var$_default = (0, $bdf228aab2ca545c$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
        d: "M17.59 18 19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"
    }, "0"),
    /*#__PURE__*/ (0, $4x3bm.jsx)("path", {
        d: "m11 18 1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"
    }, "1")
], "KeyboardDoubleArrowLeft");
$bdf228aab2ca545c$exports.default = $bdf228aab2ca545c$var$_default;



var $lxEiN = parcelRequire("lxEiN");

var $50Bvw = parcelRequire("50Bvw");

var $7pHcK = parcelRequire("7pHcK");
var $0fc2f63448566455$exports = {};

$0fc2f63448566455$exports = (parcelRequire("6UIir")).getBundleURL("ak0ox") + "arcgis-logo.72697dab.png";


var $b1c28dc114acb307$exports = {};

$b1c28dc114acb307$exports = (parcelRequire("6UIir")).getBundleURL("ak0ox") + "gridmarket-logo.206016d1.svg";



var $iWaGk = parcelRequire("iWaGk");

var $6jgOg = parcelRequire("6jgOg");
const $c3821d9fe2dbd085$var$Onboarding = ({ onboardingAnswers: onboardingAnswers = {}, history: history, match: match, onboardingStep: onboardingStep = 1 })=>{
    const theme = (0, $2mnfJ.default)();
    const [step, setStep] = (0, $70fFQ.useState)(onboardingStep);
    const [activeStep, setActiveStep] = (0, $70fFQ.useState)(0);
    const [registrationForm, setRegistrationForm] = (0, $70fFQ.useState)({
        email: "",
        password: "",
        name: "",
        phone: ""
    });
    const [options, setOptions] = (0, $70fFQ.useState)([]);
    const [selectedGoals, setSelectedGoals] = (0, $70fFQ.useState)([]);
    const [autoInputValue, setAutoInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($70fFQ))).useState("");
    const { userStore: userStore } = (0, $iWaGk.default)();
    const [pickedAddress, setPickedAddress] = (0, $70fFQ.useState)(null);
    const [userId, setUserId] = (0, $70fFQ.useState)(null);
    const [error, setError] = (0, $70fFQ.useState)({});
    const [addressError, setAddressError] = (0, $70fFQ.useState)(false);
    const { token: token } = match.params;
    const emailInput = (0, $70fFQ.useRef)(null);
    const passwordInput = (0, $70fFQ.useRef)(null);
    const passwordRepeatInput = (0, $70fFQ.useRef)(null);
    const honeyPotInput = (0, $70fFQ.useRef)(null);
    const [value, setValue] = (0, $70fFQ.useState)(null);
    const [inputValue, setInputValue] = (0, $70fFQ.useState)("");
    const [selectedAddresses, setSelectedAddresses] = (0, $70fFQ.useState)([]);
    const [loading, setLoading] = (0, $70fFQ.useState)(false);
    const { uiStore: uiStore } = (0, $iWaGk.default)();
    const { REGISTRATION_VERSION: REGISTRATION_VERSION } = uiStore;
    const handleBack = ()=>{
        setAddressError(false);
        if (step === 3) {
            setStep(6);
            return;
        }
        setActiveStep((prevActiveStep)=>prevActiveStep - 1);
        setStep(step - 1);
    };
    const handleSkip = ()=>{
        (0, $lxEiN.default).User.submitOnboardingAnswer("skipped", "true", userId);
        (0, $lxEiN.default).User.onboardingComplete();
        handleBack();
    };
    const [formState, setFormState] = (0, $70fFQ.useState)((0, $2QP2i._)({
        userType: "",
        quantity: "",
        orgType: "",
        explanation: "",
        orgName: "",
        title: "",
        goals: [],
        budget: "",
        annualEnergyCost: "",
        annualEnergyUse: "",
        utility: "",
        lotSize: "",
        roofSize: "",
        ownOrLease: ""
    }, onboardingAnswers));
    const [uploadedData, setUploadedData] = (0, $70fFQ.useState)([]);
    const [otherOrg, setOtherOrg] = (0, $70fFQ.useState)(false);
    const [isEmployee, setIsEmployee] = (0, $70fFQ.useState)(false);
    const [forgotPassword, setForgotPassword] = (0, $70fFQ.useState)(0);
    const [isFormValid, setIsFormValid] = (0, $70fFQ.useState)(false);
    const questions = [
        {
            question: "How many properties that you manage are interested in distributed energy projects?",
            name: "quantity",
            options: [
                "1-5",
                "6-10",
                "11-50",
                "50+"
            ]
        },
        {
            question: "For whom do you manage the properties?",
            name: "orgType",
            options: [
                "Myself/My Family",
                "The organization I work for",
                "For a client or a friend",
                "Other"
            ],
            other: [
                "Please Explain",
                "explanation"
            ],
            employee: [
                "What organization do you work for?",
                "orgName",
                "What is your title in that organization",
                "title"
            ]
        },
        {
            question: "What are your goals with your energy project(s)?",
            name: "goals",
            options: [
                "Energy Cost Reduction",
                "Regulatory Compliance",
                "Fleet Electrification",
                "Electricity Resilience",
                "Environmental, Social, Governance (ESG)",
                "Other",
                "Don't Know"
            ]
        }
    ];
    (0, $70fFQ.useEffect)(()=>{
        if (formState.orgType === "The organization I work for") setIsEmployee(true);
        else setIsEmployee(false);
        if (formState.orgType === "Other") setOtherOrg(true);
        else setOtherOrg(false);
    }, [
        formState.orgType
    ]);
    (0, $70fFQ.useEffect)(()=>{
        if (step === 3) setActiveStep(1);
        if (step === 4) setActiveStep(1);
        if (step === 5) setActiveStep(2);
        if (step === 6) setActiveStep(3);
    }, [
        step
    ]);
    (0, $6jgOg.default)(()=>{
        if (!userStore.isActivated && step === 5) userStore.fetchCredentials();
        if (!userStore.isOnboardingCompleted && step === 5) (async ()=>{
            await (0, $lxEiN.default).User.onboardingComplete();
        })();
    }, 5000);
    const handleGoalsBlur = ()=>{
        (0, $lxEiN.default).User.submitOnboardingAnswer("goals", formState.goals, userId);
    };
    const goalsOptions = [
        "Energy Cost Reduction",
        "Regulatory Compliance",
        "Fleet Electrification",
        "Electricity Resilience",
        "Environmental, Social, Governance (ESG)",
        "Other",
        "Don't Know"
    ];
    const handleRegisterChange = (e)=>{
        setRegistrationForm((registrationForm)=>{
            return (0, $edHbI._)((0, $2QP2i._)({}, registrationForm), {
                [e.target.name]: e.target.value
            });
        });
        e.preventDefault();
        if (registrationForm.email && // registrationForm.name &&
        registrationForm.password) setIsFormValid(true);
    };
    const nextStep = ()=>{
        setStep(step + 1);
    };
    const handleRegistrationQuizSubmission = (e)=>{
        (0, $lxEiN.default).User.submitOnboardingAnswer(e.target.name, e.target.value, userId);
    };
    const handleRegistration = async ()=>{
        const buildingsArray = [];
        for(let i = 0; i < selectedAddresses.length; i += 1)buildingsArray.push(selectedAddresses[i].id);
        const postBody = {
            name: "My first project",
            buildings: buildingsArray
        };
        if (formState.orgName) postBody.group = {
            name: formState.orgName
        };
        try {
            await (0, $lxEiN.default).User.createSignupProject((0, $edHbI._)((0, $2QP2i._)({}, postBody), {
                user_id: userId
            }));
        } catch (err) {
            setTimeout(()=>{
                console.error(err);
            }, 4000);
            setAddressError(true);
            return;
        }
        nextStep();
    };
    const handleNext = async ()=>{
        if (step === 7 && userStore.isActivated) history.push("/");
        if (step === 5 && REGISTRATION_VERSION === "v2") setTimeout(handleRegistration(), 2000);
        if (step !== 7) {
            setActiveStep(activeStep + 1);
            nextStep();
        }
    };
    const handleRegister = async (e)=>{
        e.preventDefault();
        const response = await (0, $lxEiN.default).User.signup(registrationForm);
        if (response.data.ok) {
            setUserId(response.data.id);
            setStep(3);
        }
        if (!response.data.ok) {
            if (response.data.err.user) setError({
                email: "A user already exists with this email"
            });
            if (response.data.err.email) setError({
                email: "Please check the formatting of your email address"
            });
            if (response.data.err.password) setError({
                password: "Your password must have a minimum of 6 characters"
            });
        }
    };
    const handleChange = (e)=>{
        e.preventDefault();
        setFormState((0, $edHbI._)((0, $2QP2i._)({}, formState), {
            [e.target.name]: e.target.value
        }));
        if (formState.orgType === "The organization I work for") setIsEmployee(true);
        else setIsEmployee(false);
        if (formState.orgType === "Other") setOtherOrg(true);
        else setOtherOrg(false);
    };
    const handlePasswordResetSubmit = (event)=>{
        event.preventDefault();
        const email = emailInput.current.value;
        (0, $lxEiN.default).User.sendPasswordResetEmail(email);
        // setPasswordResetEmailSent(true);
        setForgotPassword(2);
    };
    const addressAddTimer = (result)=>{
        const selected = result;
        setTimeout(()=>{
            setLoading(false);
            setTimeout(()=>{
                setValue("");
                setLoading(true);
                setPickedAddress("");
                if (selected) setUploadedData((uploadedData)=>[
                        ...uploadedData,
                        selected
                    ]);
            }, 600);
        }, 1100);
        setLoading(true);
    };
    const deleteAddress = (e)=>{
        const deletedFile = e.target.getAttribute("row");
        setUploadedData(uploadedData.filter((address)=>address !== deletedFile));
        setSelectedAddresses(selectedAddresses.filter((address)=>address.address !== deletedFile));
    };
    const handleLoginSubmit = async (e)=>{
        var _location_state;
        e.preventDefault();
        // if (honeyPotInput?.current?.value) return;
        if (token) {
            const newPassword = passwordInput.current.value;
            const newPasswordRepeat = passwordRepeatInput.current.value;
            if (newPassword !== newPasswordRepeat) {
                setError({
                    "password-repeat": "The password confirmation does not match"
                });
                return;
            }
            setError({});
        /*
      const { data } = await axios.post(`/reset/${token}`, {
        password: newPassword,
        token
      });
      */ // if (data.ok) {
        //   return history.push('/');
        // }
        }
        const email = emailInput.current.value;
        const password = passwordInput.current.value;
        const success = await userStore.login(email, password);
        if (!success) {
            setError({
                "password-error": "Wrong username/password combination"
            });
            passwordInput.current.value = "";
        } else history.push(((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.referrer) || "/");
    };
    (0, $70fFQ.useEffect)(()=>{
        if (inputValue.length < 3) return;
        (async ()=>{
            const response = await (0, $lxEiN.default).Address.autocomplete(inputValue);
            // console.log(response, 'response from autocomplete');
            setOptions(response.data.data);
        })();
    }, [
        inputValue
    ]);
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $50Bvw.default), {
        panel: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7pHcK.default), {
            children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                className: "onboarding-container",
                children: [
                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                        className: "content-container  scrollBarsHidden",
                        children: [
                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                className: "logoBox",
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                        component: "img",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b1c28dc114acb307$exports))),
                                        className: "gridmarket-logo"
                                    }),
                                    step > 2 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                variant: "h6",
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                children: "Registration"
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                                variant: "body",
                                                children: [
                                                    "Step ",
                                                    activeStep + 1,
                                                    " of 4"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 0 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                className: "login-selection content",
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        variant: "h6",
                                        sx: {
                                            mb: 5
                                        },
                                        children: "Log In Or Sign Up"
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                variant: "outlined",
                                                org: "ArcGIS",
                                                fullWidth: "true",
                                                component: (0, $dsvUQ.NavLink),
                                                to: "/auth/arcgis",
                                                sx: {
                                                    p: 1,
                                                    mt: 1,
                                                    textTransform: "none"
                                                },
                                                startIcon: /*#__PURE__*/ (0, $4x3bm.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0fc2f63448566455$exports))),
                                                    className: "arc-logo",
                                                    alt: "ArcGis"
                                                }),
                                                children: "Continue with ArcGIS"
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                variant: "outlined",
                                                fullWidth: "true",
                                                onClick: nextStep,
                                                org: "ArcGIS",
                                                sx: {
                                                    p: 1,
                                                    mt: 1,
                                                    textTransform: "none"
                                                },
                                                startIcon: /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d14e9fb1f91190a$exports))), {
                                                    className: "email-icon"
                                                }),
                                                children: "Continue with Email"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 1 && forgotPassword === 0 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                className: "content login",
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsxs)("form", {
                                        onSubmit: handleLoginSubmit,
                                        className: "content",
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                variant: "h6",
                                                children: "Sign in"
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                                margin: "normal",
                                                required: true,
                                                fullWidth: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                        htmlFor: "email",
                                                        children: "Email Address"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                        inputRef: emailInput,
                                                        id: "email",
                                                        name: "email",
                                                        autoComplete: "email",
                                                        autoFocus: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                                margin: "normal",
                                                required: true,
                                                fullWidth: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                        htmlFor: "password",
                                                        children: "Password"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                        inputRef: passwordInput,
                                                        name: "password",
                                                        type: "password",
                                                        id: "password",
                                                        autoComplete: "current-password"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7adKh.default), {
                                                        error: true,
                                                        children: error["password-error"]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $697xl.default), {
                                                style: {
                                                    transform: "translateX(-10000px)",
                                                    height: 1,
                                                    margin: 0,
                                                    overflow: "hidden",
                                                    position: "fixed"
                                                },
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                    style: {
                                                        transform: "translateX(-10000px)",
                                                        height: 1,
                                                        display: "none"
                                                    },
                                                    inputRef: honeyPotInput,
                                                    name: "password",
                                                    type: "password",
                                                    id: "password",
                                                    autoComplete: "new-password"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                                justifyContent: "flex-end",
                                                alignItems: "right",
                                                container: true,
                                                spacing: 3,
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $8VJ2N.default), {
                                                    item: true,
                                                    sx: {
                                                        mb: 3
                                                    },
                                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                        sx: {
                                                            textTransform: "none"
                                                        },
                                                        onClick: ()=>setForgotPassword(1),
                                                        children: "Forgot your password?"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                                className: "content",
                                                children: [
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                        type: "submit",
                                                        className: "round-button",
                                                        sx: {
                                                            m: 2
                                                        },
                                                        children: "Sign In"
                                                    }),
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                        sx: {
                                                            display: "none"
                                                        },
                                                        m: 3,
                                                        color: "gray",
                                                        children: "- or -"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                                sx: {
                                                    display: "none"
                                                },
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                    variant: "outlined",
                                                    org: "ArcGIS",
                                                    fullWidth: "true",
                                                    component: (0, $dsvUQ.NavLink),
                                                    to: "/auth/arcgis",
                                                    sx: {
                                                        textTransform: "none"
                                                    },
                                                    startIcon: /*#__PURE__*/ (0, $4x3bm.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0fc2f63448566455$exports))),
                                                        width: 27,
                                                        height: 27,
                                                        alt: "ArcGIS"
                                                    }),
                                                    children: "Continue with ArcGIS"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                        sx: {
                                            width: "100%",
                                            textAlign: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fuVrF.default), {
                                                variant: "middle",
                                                sx: {
                                                    mt: 4,
                                                    mb: 2
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $27ZKj.default), {
                                                variant: "body",
                                                sx: {
                                                    textAlign: "center",
                                                    width: "100%",
                                                    letterSpacing: "0.04rem",
                                                    display: "flex",
                                                    alignContent: "center",
                                                    alignItems: "baseline",
                                                    justifyContent: "center"
                                                },
                                                children: [
                                                    "Don't have an account?",
                                                    " ",
                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                        variant: "text",
                                                        disableRipple: true,
                                                        sx: {
                                                            font: "inherit",
                                                            fontWeight: 600,
                                                            textTransform: "none",
                                                            "&:hover": {
                                                                backgroundColor: "transparent"
                                                            }
                                                        },
                                                        onClick: nextStep,
                                                        children: "Sign up."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 1 && forgotPassword === 1 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                className: "content login",
                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $7xvOw.default), {
                                            size: "large",
                                            sx: {
                                                alignSelf: "start",
                                                textTransform: "none"
                                            },
                                            onClick: ()=>{
                                                setForgotPassword(0);
                                            },
                                            children: [
                                                theme.direction === "rtl" ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbjAq))), {}) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6lvOy))), {}),
                                                "Back"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                            align: "center",
                                            variant: "h6",
                                            children: "Reset your password"
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                            gutterBottom: true,
                                            align: "center",
                                            variant: "body2",
                                            children: "Type in your e-mail and we'll send you the link to reset your password"
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                            margin: "normal",
                                            required: true,
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                    htmlFor: "email",
                                                    children: "Email Address"
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                    inputRef: emailInput,
                                                    id: "email",
                                                    name: "email",
                                                    autoComplete: "email",
                                                    type: "email",
                                                    sx: {
                                                        mb: 4
                                                    },
                                                    autoFocus: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                            type: "submit",
                                            onClick: handlePasswordResetSubmit,
                                            className: "round-button",
                                            children: "Send"
                                        })
                                    ]
                                })
                            }),
                            step === 1 && forgotPassword === 2 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                className: "content login",
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        align: "center",
                                        variant: "h6",
                                        gutterBottom: true,
                                        children: "Password reset e-mail has been sent"
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        gutterBottom: true,
                                        align: "center",
                                        variant: "body2",
                                        sx: {
                                            mb: 2,
                                            mt: 2
                                        },
                                        children: "Password reset e-mail has been sent to you, check your e-mail"
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        align: "center",
                                        variant: "body2",
                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                            onClick: ()=>setForgotPassword(0),
                                            children: "Back to login"
                                        })
                                    })
                                ]
                            }),
                            step === 2 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                className: "content login",
                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)("form", {
                                    onChange: handleRegisterChange,
                                    onSubmit: handleRegister,
                                    children: [
                                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $7xvOw.default), {
                                            size: "large",
                                            sx: {
                                                alignSelf: "start",
                                                textTransform: "none"
                                            },
                                            onClick: handleBack,
                                            children: [
                                                theme.direction === "rtl" ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbjAq))), {}) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6lvOy))), {}),
                                                "Back"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $irnsW.default), {
                                            sx: {
                                                mb: 3
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                                    margin: "normal",
                                                    required: true,
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                            htmlFor: "email",
                                                            children: "Email Address"
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                            id: "email",
                                                            name: "email",
                                                            type: "email",
                                                            autoComplete: "email"
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7adKh.default), {
                                                            error: true,
                                                            children: error.email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $697xl.default), {
                                                    margin: "normal",
                                                    required: true,
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                            htmlFor: "password",
                                                            children: "Password"
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                            id: "password",
                                                            type: "password",
                                                            name: "password",
                                                            autoComplete: "new-password"
                                                        }),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7adKh.default), {
                                                            error: true,
                                                            children: error.password
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $PjeUW.default), {
                                                    title: !isFormValid ? "Please complete all required fields" : "",
                                                    className: "content",
                                                    arrow: true,
                                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7xvOw.default), {
                                                            type: "submit",
                                                            disabled: !isFormValid,
                                                            className: "round-button",
                                                            color: "primary",
                                                            children: "Register"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            step === 3 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                    className: "form-container",
                                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                        className: "content",
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                variant: "h6",
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                children: "What do you want to do?"
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $697xl.default), {
                                                component: "fieldset",
                                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $0d6a8f18ce31daaa$export$2e2bcd8739ae039), {
                                                    "aria-labelledby": "What do you want to do?",
                                                    name: "userType",
                                                    sx: {
                                                        display: "flex",
                                                        flexDirection: "row"
                                                    },
                                                    onBlur: handleRegistrationQuizSubmission,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $b2gZS.default), {
                                                            value: "property manager",
                                                            sx: {
                                                                m: 2
                                                            },
                                                            control: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6QAZD.default), {}),
                                                            label: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                                variant: "body1",
                                                                children: "I want to get distributed energy solutions for properties."
                                                            }),
                                                            onChange: handleChange
                                                        }, "property manager"),
                                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $b2gZS.default), {
                                                            value: "vendor",
                                                            control: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6QAZD.default), {}),
                                                            sx: {
                                                                m: 2
                                                            },
                                                            label: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                                variant: "body1",
                                                                children: "I want to sell distributed energy solutions to property owners."
                                                            }),
                                                            onChange: handleChange
                                                        }, "vendor")
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            step === 4 && formState.userType === "vendor" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                    className: "content scrollBarsHidden",
                                    children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                        className: "content",
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                variant: "h6",
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                children: "Tell us a bit about yourself."
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                                                label: "Your Name",
                                                name: "name",
                                                sx: {
                                                    mt: 2,
                                                    width: "100%"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                                                label: "Your Organization",
                                                name: "orgName",
                                                sx: {
                                                    mt: 2,
                                                    width: "100%"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                                                label: "Your Title",
                                                name: "title",
                                                sx: {
                                                    mt: 2,
                                                    width: "100%"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), {
                                                label: "Your Phone Number",
                                                name: "phone",
                                                sx: {
                                                    mt: 2,
                                                    width: "100%"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            step === 4 && formState.userType === "property manager" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
                                children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                    className: "content scrollBarsHidden",
                                    children: [
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                            className: "content",
                                            children: REGISTRATION_VERSION === "v1" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                variant: "body",
                                                align: "center",
                                                gutterBottom: true,
                                                sx: {
                                                    textAlign: "justify",
                                                    fontWeight: "500",
                                                    mt: 5
                                                },
                                                children: "The next few questions will assist in setting up your custom profile."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                            className: "form-container",
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)("form", {
                                                onSubmit: handleRegistrationQuizSubmission,
                                                children: questions.map((question)=>question.question === "What are your goals with your energy project(s)?" ? /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                                sx: {
                                                                    mt: 4,
                                                                    mb: 1,
                                                                    whiteSpace: "unset",
                                                                    width: "100%",
                                                                    color: "black"
                                                                },
                                                                children: question.question
                                                            }, "labelForAutocomplete"),
                                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ggYS0.default), {
                                                                multiple: true,
                                                                limitTags: 2,
                                                                question: question.question,
                                                                options: goalsOptions,
                                                                getOptionLabel: (option)=>option,
                                                                onBlur: handleGoalsBlur,
                                                                name: question.name,
                                                                value: selectedGoals,
                                                                disableCloseOnSelect: true,
                                                                onChange: (e, newValue)=>{
                                                                    setSelectedGoals(newValue);
                                                                    setFormState((0, $edHbI._)((0, $2QP2i._)({}, formState), {
                                                                        goals: newValue
                                                                    }));
                                                                },
                                                                // onChange={newValue => {
                                                                //   setSelectedGoals(selectedGoals => [
                                                                //     ...selectedGoals,
                                                                //     newValue
                                                                //   ]);
                                                                //   setFormState({
                                                                //     ...formState,
                                                                //     goals: options
                                                                //   });
                                                                // }}
                                                                inputValue: autoInputValue,
                                                                onInputChange: (event, newInputValue)=>{
                                                                    setAutoInputValue(newInputValue);
                                                                },
                                                                renderInput: (params)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), (0, $edHbI._)((0, $2QP2i._)({}, params), {
                                                                        variant: "standard",
                                                                        placeholder: "Please select..."
                                                                    }))
                                                            }, question.question)
                                                        ]
                                                    }) : REGISTRATION_VERSION === "v1" ? /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                                sx: {
                                                                    mt: 4,
                                                                    mb: 1,
                                                                    whiteSpace: "unset",
                                                                    width: "100%",
                                                                    color: "black"
                                                                },
                                                                children: question.question
                                                            }),
                                                            /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $69ubn.default), {
                                                                question: question.question,
                                                                variant: "standard",
                                                                name: question.name,
                                                                onChange: (e)=>handleChange(e),
                                                                displayEmpty: true,
                                                                onBlur: handleRegistrationQuizSubmission,
                                                                value: formState[question.name],
                                                                sx: {
                                                                    color: "gray",
                                                                    mb: 2
                                                                },
                                                                fullWidth: true,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6yY4r.default), {
                                                                        value: "",
                                                                        children: "Please Select..."
                                                                    }),
                                                                    question.options && question.options.map((option)=>{
                                                                        return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $6yY4r.default), {
                                                                            value: option,
                                                                            children: option
                                                                        }, option);
                                                                    })
                                                                ]
                                                            }),
                                                            question.other && otherOrg && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                                        sx: {
                                                                            mt: 4,
                                                                            mb: 1,
                                                                            width: "100%",
                                                                            whiteSpace: "unset",
                                                                            color: "black"
                                                                        },
                                                                        children: question.other[0]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                                        id: question.other[1],
                                                                        autoComplete: "new-password",
                                                                        question: question.other,
                                                                        name: question.other[1],
                                                                        onBlur: handleRegistrationQuizSubmission,
                                                                        sx: {
                                                                            color: "gray",
                                                                            mb: 2
                                                                        },
                                                                        onChange: (e)=>handleChange(e),
                                                                        fullWidth: true
                                                                    })
                                                                ]
                                                            }),
                                                            question.employee && isEmployee && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                                        sx: {
                                                                            mt: 4,
                                                                            mb: 1,
                                                                            whiteSpace: "unset",
                                                                            width: "100%",
                                                                            color: "black"
                                                                        },
                                                                        children: question.employee[0]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                                        id: question.other[1],
                                                                        autoComplete: "new-password",
                                                                        question: question.employee[1],
                                                                        name: question.employee[1],
                                                                        sx: {
                                                                            mb: 2
                                                                        },
                                                                        onBlur: handleRegistrationQuizSubmission,
                                                                        onChange: (e)=>handleChange(e),
                                                                        fullWidth: true
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $1IOh3.default), {
                                                                        sx: {
                                                                            mt: 3,
                                                                            mb: 1,
                                                                            whiteSpace: "unset",
                                                                            width: "100%",
                                                                            color: "black"
                                                                        },
                                                                        children: question.employee[2]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3cESc.default), {
                                                                        id: question.employee[3],
                                                                        autoComplete: "new-password",
                                                                        question: question.employee[3],
                                                                        onBlur: handleRegistrationQuizSubmission,
                                                                        name: question.employee[3],
                                                                        onChange: (e)=>handleChange(e),
                                                                        sx: {
                                                                            mb: 2
                                                                        },
                                                                        fullWidth: true
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {}))
                                            })
                                        })
                                    ]
                                })
                            }),
                            step === 5 && /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                className: "content",
                                children: [
                                    /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $bDcYY.default), {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            height: 105,
                                            mt: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                                variant: "body",
                                                align: "justify",
                                                gutterBottom: true,
                                                children: "Add one or more properties to your first project."
                                            }),
                                            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ggYS0.default), {
                                                autoHighlight: true,
                                                options: options,
                                                noOptionsText: "Please type to search for an address",
                                                value: value,
                                                onChange: async (event, newValue, reason)=>{
                                                    setOptions(newValue ? [
                                                        newValue,
                                                        ...options
                                                    ] : options);
                                                    setValue(newValue);
                                                    if (reason === "clear") {
                                                        setPickedAddress(null);
                                                        setInputValue("");
                                                        setValue("");
                                                    }
                                                    if (reason === "selectOption") {
                                                        var _response_data_data, _response_data;
                                                        // console.log('address sent to geocode ->', newValue);
                                                        const response = await (0, $lxEiN.default).Address.geocode(newValue);
                                                        // console.log('response from geocode ->', response);
                                                        const result = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_data = _response_data.data) === null || _response_data_data === void 0 ? void 0 : _response_data_data[0];
                                                        if (result) {
                                                            setPickedAddress(result);
                                                            setSelectedAddresses((addresses)=>[
                                                                    ...addresses,
                                                                    result
                                                                ]);
                                                            addressAddTimer(result.address);
                                                        }
                                                    }
                                                },
                                                onInputChange: (event, newInputValue)=>{
                                                    if (newInputValue.length >= 3) setInputValue(newInputValue);
                                                },
                                                renderInput: (params)=>{
                                                    var _pickedAddress_address;
                                                    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iuSYB.default), (0, $edHbI._)((0, $2QP2i._)({}, params), {
                                                        fullWidth: true,
                                                        placeholder: "Type to search ...",
                                                        InputProps: (0, $edHbI._)((0, $2QP2i._)({}, params.InputProps), {
                                                            startAdornment: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $4x3bm.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4aoN6.default), {
                                                                        position: "start",
                                                                        children: (pickedAddress === null || pickedAddress === void 0 ? void 0 : (_pickedAddress_address = pickedAddress.address) === null || _pickedAddress_address === void 0 ? void 0 : _pickedAddress_address.length) > 6 ? loading ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $fDlBJ.default), {}) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bg50F))), {
                                                                            sx: {
                                                                                color: "green"
                                                                            }
                                                                        }) : null
                                                                    }),
                                                                    params.InputProps.startAdornment
                                                                ]
                                                            })
                                                        })
                                                    }));
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iTwQr.default), {
                                        className: "scrollBarsHidden",
                                        sx: {
                                            height: "50vh",
                                            overFlowX: "scroll",
                                            marginBottom: 4,
                                            width: "100%"
                                        },
                                        children: !!(uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.length) && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                            pt: 4,
                                            children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $iWVbX.default), {
                                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $3DLOK.default), {
                                                    children: uploadedData.map((address)=>/*#__PURE__*/ (0, $4x3bm.jsxs)((0, $8Hhl0.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                                    align: "left",
                                                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghdbC))), {
                                                                        sx: {
                                                                            color: "#8fc408",
                                                                            fontSize: 20
                                                                        }
                                                                    })
                                                                }),
                                                                uploadedData && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                                    align: "center",
                                                                    style: {
                                                                        textOverflow: "ellipsis",
                                                                        overflow: "hidden",
                                                                        whiteSpace: "nowrap",
                                                                        maxWidth: 200
                                                                    },
                                                                    children: address
                                                                }),
                                                                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $c9kiU.default), {
                                                                    align: "right",
                                                                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gD8dY))), {
                                                                        sx: {
                                                                            color: "#1f1f1f",
                                                                            fontSize: 20
                                                                        },
                                                                        onClick: (e)=>deleteAddress(e),
                                                                        row: address
                                                                    })
                                                                })
                                                            ]
                                                        }))
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            step === 6 && REGISTRATION_VERSION === "v1" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                className: "content",
                                children: pickedAddress ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                    sx: {
                                        mt: 6
                                    },
                                    children: uploadedData.length === 1 ? `Successfully added ${pickedAddress.address} to your
                      project.` : `Successfully added ${uploadedData.length} sites to your project`
                                }) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                    sx: {
                                        textAlign: "justify",
                                        mt: 6
                                    },
                                    children: "Are you sure you don't want to add any properties now?"
                                })
                            }),
                            step === 6 && REGISTRATION_VERSION === "v2" && (addressError ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                className: "content",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                    sx: {
                                        textAlign: "justify",
                                        mt: 6
                                    },
                                    children: "There was a problem with one or more of your addresses. Please try again."
                                })
                            }) : /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                className: "content",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                    children: userStore.isActivated ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        children: "Thanks for confirming your email, welcome to Gridmarket."
                                    }) : // <Spinner />
                                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
                                        children: "We've sent you a confirmation email. Please click the link in that email to activate your account and see your property assessment."
                                    })
                                })
                            })),
                            step >= 3 && step <= 6 && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                                className: "react-stepper",
                                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $ld7Nh.default), {
                                    variant: "dots",
                                    steps: 4,
                                    position: "static",
                                    sx: {
                                        background: "transparent"
                                    },
                                    activeStep: activeStep,
                                    nextButton: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $7xvOw.default), {
                                        size: "large",
                                        onClick: handleNext,
                                        disabled: step === 6,
                                        children: [
                                            step < 7 ? "Next" : null,
                                            theme.direction === "rtl" && activeStep < 4 ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6lvOy))), {}) : activeStep < 4 ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbjAq))), {}) : null
                                        ]
                                    }),
                                    backButton: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $7xvOw.default), {
                                        size: "large",
                                        onClick: activeStep === 0 ? handleSkip : handleBack,
                                        disabled: activeStep === 2 && userStore.isActivated,
                                        children: [
                                            theme.direction === "rtl" ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbjAq))), {}) : activeStep > 0 ? /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6lvOy))), {}) : null,
                                            activeStep === 0 ? "Skip" : "Back",
                                            activeStep === 0 && theme.direction === "ltr" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3eaa2147c29393a$exports))), {}),
                                            activeStep === 0 && theme.direction === "rtl" && /*#__PURE__*/ (0, $4x3bm.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bdf228aab2ca545c$exports))), {})
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4x3bm.jsx)((0, $bDcYY.default), {
                        className: "bg"
                    })
                ]
            })
        })
    });
};
var $c3821d9fe2dbd085$export$2e2bcd8739ae039 = (0, $87gt0.observer)($c3821d9fe2dbd085$var$Onboarding);


const $7ddcdf8e9d17d380$var$App = ()=>{
    const { userStore: userStore } = (0, $iWaGk.default)();
    if (userStore.status === "loading") return /*#__PURE__*/ (0, $4x3bm.jsx)("div", {});
    if (userStore.status === "UNDER_MAINTENANCE") return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $27ZKj.default), {
        style: {
            padding: "4rem",
            marginTop: 100
        },
        variant: "h5",
        children: "Platform is undergoing some maintenance. We'll be back soon..."
    });
    let onboardingStep = null;
    if (userStore.user && userStore.user.is_onboarding_completed === false) {
        if (userStore.user.onboarding_step === "onboarding-questions") onboardingStep = 3;
        else if (userStore.user.onboarding_step === "create-project") onboardingStep = 4;
        else if (userStore.user.onboarding_step === "validate-email") onboardingStep = 6;
    }
    return /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4x3bm.Fragment), {
        children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $dih0O.Switch), {
            children: [
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    exact: true,
                    path: [
                        "/auth/:method"
                    ],
                    render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $4a01c454afb76c25$export$2e2bcd8739ae039), (0, $2QP2i._)({}, props))
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    path: "/status",
                    exact: true,
                    render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $a17ae84f2c373946$export$2e2bcd8739ae039), (0, $2QP2i._)({}, props))
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    path: [
                        "/login/:resetPasswordToken",
                        "/login/activate/:userActivationToken",
                        "/forgot-password"
                    ],
                    exact: true,
                    render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $803f9f4f70fb5181$export$2e2bcd8739ae039), (0, $2QP2i._)({}, props))
                }),
                onboardingStep && /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    exact: true,
                    render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $c3821d9fe2dbd085$export$2e2bcd8739ae039), (0, $2QP2i._)({
                            onboardingAnswers: userStore.user.onboarding_answers,
                            onboardingStep: onboardingStep
                        }, props))
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    exact: true,
                    path: [
                        "/login",
                        "/onboarding"
                    ],
                    render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $c3821d9fe2dbd085$export$2e2bcd8739ae039), (0, $2QP2i._)({}, props))
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dih0O.Route), {
                    exact: true,
                    path: "/register",
                    render: (props)=>/*#__PURE__*/ (0, $4x3bm.jsx)((0, $c3821d9fe2dbd085$export$2e2bcd8739ae039), (0, $2QP2i._)({
                            onboardingStep: 2
                        }, props))
                }),
                /*#__PURE__*/ (0, $4x3bm.jsx)((0, $4aa0f072730a5215$export$2e2bcd8739ae039), {
                    userStore: userStore,
                    path: "/",
                    component: (0, $aacc396004ae5cb8$export$2e2bcd8739ae039)
                })
            ]
        })
    });
};
var $7ddcdf8e9d17d380$export$2e2bcd8739ae039 = (0, $87gt0.observer)($7ddcdf8e9d17d380$var$App);


/* eslint-disable */ if (window.location.hostname !== "platform.gridmarket.com") window["ga-disable-G-00W30VGFDY"] = true;
if (window.location.hostname === "platform.gridmarket.com") {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-00W30VGFDY");
    (function(h, o, t, j, a, r) {
        h.hj = h.hj || function() {
            (h.hj.q = h.hj.q || []).push(arguments);
        };
        h._hjSettings = {
            hjid: 1545832,
            hjsv: 6
        };
        a = o.getElementsByTagName("head")[0];
        r = o.createElement("script");
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
    let _rollbarConfig = {
        accessToken: "3a42d853ae8d47209abc693dbf9a0813",
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
            environment: "production"
        }
    };
    // Rollbar Snippet
    !function(r) {
        function e(n) {
            if (o[n]) return o[n].exports;
            const t = o[n] = {
                exports: {},
                id: n,
                loaded: !1
            };
            return r[n].call(t.exports, t, t.exports, e), t.loaded = !0, t.exports;
        }
        var o = {};
        return e.m = r, e.c = o, e.p = "", e(0);
    }([
        function(r, e, o) {
            const n = o(1);
            const t = o(4);
            _rollbarConfig = _rollbarConfig || {}, _rollbarConfig.rollbarJsUrl = _rollbarConfig.rollbarJsUrl || "https://cdnjs.cloudflare.com/ajax/libs/rollbar.js/2.4.6/rollbar.min.js", _rollbarConfig.async = void 0 === _rollbarConfig.async || _rollbarConfig.async;
            const a = n.setupShim(window, _rollbarConfig);
            const l = t(_rollbarConfig);
            window.rollbar = n.Rollbar, a.loadFull(window, document, !_rollbarConfig.async, _rollbarConfig, l);
        },
        function(r, e, o) {
            function n(r) {
                return function() {
                    try {
                        return r.apply(this, arguments);
                    } catch (r) {
                        try {
                            console.error("[Rollbar]: Internal error", r);
                        } catch (r) {}
                    }
                };
            }
            function t(r, e) {
                this.options = r, this._rollbarOldOnError = null;
                const o = s++;
                this.shimId = function() {
                    return o;
                }, typeof window !== "undefined" && window._rollbarShims && (window._rollbarShims[o] = {
                    handler: e,
                    messages: []
                });
            }
            function a(r, e) {
                if (r) {
                    const o = e.globalAlias || "Rollbar";
                    if (typeof r[o] === "object") return r[o];
                    r._rollbarShims = {}, r._rollbarWrappedError = null;
                    const t = new p(e);
                    return n(function() {
                        e.captureUncaught && (t._rollbarOldOnError = r.onerror, i.captureUncaughtExceptions(r, t, !0), i.wrapGlobals(r, t, !0)), e.captureUnhandledRejections && i.captureUnhandledRejections(r, t, !0);
                        const n = e.autoInstrument;
                        return e.enabled !== !1 && (void 0 === n || n === !0 || typeof n === "object" && n.network) && r.addEventListener && (r.addEventListener("load", t.captureLoad.bind(t)), r.addEventListener("DOMContentLoaded", t.captureDomContentLoaded.bind(t))), r[o] = t, t;
                    })();
                }
            }
            function l(r) {
                return n(function() {
                    const e = this;
                    const o = Array.prototype.slice.call(arguments, 0);
                    const n = {
                        shim: e,
                        method: r,
                        args: o,
                        ts: new Date()
                    };
                    window._rollbarShims[this.shimId()].messages.push(n);
                });
            }
            var i = o(2);
            var s = 0;
            const d = o(3);
            const c = function(r, e) {
                return new t(r, e);
            };
            var p = d.bind(null, c);
            t.prototype.loadFull = function(r, e, o, t, a) {
                const l = function() {
                    let e;
                    if (void 0 === r._rollbarDidLoad) {
                        e = new Error("rollbar.js did not load");
                        for(var o, n, t, l, i = 0; o = r._rollbarShims[i++];)for(o = o.messages || []; n = o.shift();)for(t = n.args || [], i = 0; i < t.length; ++i)if (l = t[i], typeof l === "function") {
                            l(e);
                            break;
                        }
                    }
                    typeof a === "function" && a(e);
                };
                let i = !1;
                const s = e.createElement("script");
                const d = e.getElementsByTagName("script")[0];
                const c = d.parentNode;
                s.crossOrigin = "", s.src = t.rollbarJsUrl, o || (s.async = !0), s.onload = s.onreadystatechange = n(function() {
                    if (!(i || this.readyState && this.readyState !== "loaded" && this.readyState !== "complete")) {
                        s.onload = s.onreadystatechange = null;
                        try {
                            c.removeChild(s);
                        } catch (r) {}
                        i = !0, l();
                    }
                }), c.insertBefore(s, d);
            }, t.prototype.wrap = function(r, e, o) {
                try {
                    let n;
                    if (n = typeof e === "function" ? e : function() {
                        return e || {};
                    }, typeof r !== "function") return r;
                    if (r._isWrap) return r;
                    if (!r._rollbar_wrapped && (r._rollbar_wrapped = function() {
                        o && typeof o === "function" && o.apply(this, arguments);
                        try {
                            return r.apply(this, arguments);
                        } catch (o) {
                            let e = o;
                            throw e && (typeof e === "string" && (e = new String(e)), e._rollbarContext = n() || {}, e._rollbarContext._wrappedSource = r.toString(), window._rollbarWrappedError = e), e;
                        }
                    }, r._rollbar_wrapped._isWrap = !0, r.hasOwnProperty)) for(const t in r)r.hasOwnProperty(t) && (r._rollbar_wrapped[t] = r[t]);
                    return r._rollbar_wrapped;
                } catch (e) {
                    return r;
                }
            };
            for(let u = "log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,captureEvent,captureDomContentLoaded,captureLoad".split(","), f = 0; f < u.length; ++f)t.prototype[u[f]] = l(u[f]);
            r.exports = {
                setupShim: a,
                Rollbar: p
            };
        },
        function(r) {
            function o(r, e, o) {
                if (r) {
                    let t;
                    typeof e._rollbarOldOnError === "function" ? t = e._rollbarOldOnError : r.onerror && !r.onerror.belongsToShim && (t = r.onerror, e._rollbarOldOnError = t);
                    const a = function() {
                        const o = Array.prototype.slice.call(arguments, 0);
                        n(r, e, t, o);
                    };
                    a.belongsToShim = o, r.onerror = a;
                }
            }
            function n(r, e, o, n) {
                r._rollbarWrappedError && (n[4] || (n[4] = r._rollbarWrappedError), n[5] || (n[5] = r._rollbarWrappedError._rollbarContext), r._rollbarWrappedError = null), e.handleUncaughtException.apply(e, n), o && o.apply(r, n);
            }
            function t(r, e, o) {
                if (r) {
                    typeof r._rollbarURH === "function" && r._rollbarURH.belongsToShim && r.removeEventListener("unhandledrejection", r._rollbarURH);
                    const n = function(r) {
                        let o;
                        let n;
                        let t;
                        try {
                            o = r.reason;
                        } catch (r) {
                            o = void 0;
                        }
                        try {
                            n = r.promise;
                        } catch (r) {
                            n = "[unhandledrejection] error getting `promise` from event";
                        }
                        try {
                            t = r.detail, !o && t && (o = t.reason, n = t.promise);
                        } catch (r) {
                            t = "[unhandledrejection] error getting `detail` from event";
                        }
                        o || (o = "[unhandledrejection] error getting `reason` from event"), e && e.handleUnhandledRejection && e.handleUnhandledRejection(o, n);
                    };
                    n.belongsToShim = o, r._rollbarURH = n, r.addEventListener("unhandledrejection", n);
                }
            }
            function a(r, e, o) {
                if (r) {
                    let n;
                    let t;
                    const a = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                    for(n = 0; n < a.length; ++n)t = a[n], r[t] && r[t].prototype && l(e, r[t].prototype, o);
                }
            }
            function l(r, e, o) {
                if (e.hasOwnProperty && e.hasOwnProperty("addEventListener")) {
                    for(var n = e.addEventListener; n._rollbarOldAdd && n.belongsToShim;)n = n._rollbarOldAdd;
                    const t = function(e, o, t) {
                        n.call(this, e, r.wrap(o), t);
                    };
                    t._rollbarOldAdd = n, t.belongsToShim = o, e.addEventListener = t;
                    for(var a = e.removeEventListener; a._rollbarOldRemove && a.belongsToShim;)a = a._rollbarOldRemove;
                    const l = function(r, e, o) {
                        a.call(this, r, e && e._rollbar_wrapped || e, o);
                    };
                    l._rollbarOldRemove = a, l.belongsToShim = o, e.removeEventListener = l;
                }
            }
            r.exports = {
                captureUncaughtExceptions: o,
                captureUnhandledRejections: t,
                wrapGlobals: a
            };
        },
        function(r) {
            function o(r, e) {
                this.impl = r(e, this), this.options = e, n(o.prototype);
            }
            function n(r) {
                for(let e = function(r) {
                    return function() {
                        const e = Array.prototype.slice.call(arguments, 0);
                        if (this.impl[r]) return this.impl[r].apply(this.impl, e);
                    };
                }, o = "log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,_createItem,wrap,loadFull,shimId,captureEvent,captureDomContentLoaded,captureLoad".split(","), n = 0; n < o.length; n++)r[o[n]] = e(o[n]);
            }
            o.prototype._swapAndProcessMessages = function(r, e) {
                this.impl = r(this.options);
                for(var o, n, t; o = e.shift();)n = o.method, t = o.args, this[n] && typeof this[n] === "function" && (n === "captureDomContentLoaded" || n === "captureLoad" ? this[n].apply(this, [
                    t[0],
                    o.ts
                ]) : this[n].apply(this, t));
                return this;
            }, r.exports = o;
        },
        function(r) {
            r.exports = function(r) {
                return function(e) {
                    if (!e && !window._rollbarInitialized) {
                        r = r || {};
                        for(var o, n, t = r.globalAlias || "Rollbar", a = window.rollbar, l = function(r) {
                            return new a(r);
                        }, i = 0; o = window._rollbarShims[i++];)n || (n = o.handler), o.handler._swapAndProcessMessages(l, o.messages);
                        window[t] = n, window._rollbarInitialized = !0;
                    }
                };
            };
        }
    ]);
// End Rollbar Snippet
}


/*
import e2eInstance from './lib/axios';
e2eInstance.interceptors.response.use(
  response => {
    const now = Date.now();
    console.log(response);

    return response;
  },
  error => Promise.reject(error)
);
*/ (0, $gOgWf.configure)({
    enforceActions: false
}); // strict mode
/* DISABLE GOOGLE MAPS LOADING FONTS AND REFRESHING PAGE */ const $0f95a7894f653d4a$var$head = document.getElementsByTagName("head")[0];
const { insertBefore: $0f95a7894f653d4a$var$insertBefore } = document.head;
document.head.insertBefore = (newElement, referenceElement)=>{
    if (newElement.href && newElement.href.indexOf("//fonts.googleapis.com/css?family=Roboto") > -1) return;
    $0f95a7894f653d4a$var$insertBefore.call($0f95a7894f653d4a$var$head, newElement, referenceElement);
};
/* END OF DISABLE GOOGLE MAPS LOADING FONTS AND REFRESHING PAGE */ const $0f95a7894f653d4a$var$rootNode = document.getElementById("root");
const $0f95a7894f653d4a$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($94a1820d6644dae9$exports))).createRoot($0f95a7894f653d4a$var$rootNode);
$0f95a7894f653d4a$var$root.render(/*#__PURE__*/ (0, $4x3bm.jsx)((0, $lM6lR.default), {
    injectFirst: true,
    children: /*#__PURE__*/ (0, $4x3bm.jsxs)((0, $5vXJC.default), {
        theme: (0, $798fe7a4458df1c3$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $07bac6c924ea40e1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $111504f542e6f1a6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4x3bm.jsx)((0, $dsvUQ.BrowserRouter), {
                children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $49502641be0ebafe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $4x3bm.jsx)((0, $7ddcdf8e9d17d380$export$2e2bcd8739ae039), {})
                })
            })
        ]
    })
}));


//# sourceMappingURL=index.c58f6d81.js.map
